/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"edbb74b9"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 663);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(210);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1014);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var SvgIcon = React.createClass({
  displayName: 'SvgIcon',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    color: React.PropTypes.string,
    hoverColor: React.PropTypes.string,
    onMouseEnter: React.PropTypes.func,
    onMouseLeave: React.PropTypes.func,
    viewBox: React.PropTypes.string
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      hovered: false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onMouseEnter: function onMouseEnter() {},
      onMouseLeave: function onMouseLeave() {},
      viewBox: '0 0 24 24'
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _props = this.props;
    var children = _props.children;
    var color = _props.color;
    var hoverColor = _props.hoverColor;
    var onMouseEnter = _props.onMouseEnter;
    var onMouseLeave = _props.onMouseLeave;
    var style = _props.style;
    var viewBox = _props.viewBox;

    var other = _objectWithoutProperties(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);

    var offColor = color ? color : style && style.fill ? style.fill : this.state.muiTheme.rawTheme.palette.textColor;
    var onColor = hoverColor ? hoverColor : offColor;

    var mergedStyles = this.prepareStyles({
      display: 'inline-block',
      height: 24,
      width: 24,
      userSelect: 'none',
      transition: Transitions.easeOut()
    }, style, {
      // Make sure our fill color overrides fill provided in props.style
      fill: this.state.hovered ? onColor : offColor
    });

    var events = hoverColor ? {
      onMouseEnter: this._handleMouseEnter,
      onMouseLeave: this._handleMouseLeave
    } : {};

    return React.createElement(
      'svg',
      _extends({}, other, events, {
        style: mergedStyles,
        viewBox: viewBox }),
      children
    );
  },

  _handleMouseLeave: function _handleMouseLeave(e) {
    this.setState({ hovered: false });
    this.props.onMouseLeave(e);
  },

  _handleMouseEnter: function _handleMouseEnter(e) {
    this.setState({ hovered: true });
    this.props.onMouseEnter(e);
  }
});

module.exports = SvgIcon;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  AppBar: __webpack_require__(1012),
  AppCanvas: __webpack_require__(1020),
  Avatar: __webpack_require__(521),
  BeforeAfterWrapper: __webpack_require__(522),
  Card: __webpack_require__(1021),
  CardActions: __webpack_require__(1022),
  CardExpandable: __webpack_require__(523),
  CardHeader: __webpack_require__(1023),
  CardMedia: __webpack_require__(1026),
  CardText: __webpack_require__(1027),
  CardTitle: __webpack_require__(1028),
  Checkbox: __webpack_require__(355),
  CircularProgress: __webpack_require__(1029),
  ClearFix: __webpack_require__(191),
  DatePicker: __webpack_require__(1030),
  DatePickerDialog: __webpack_require__(528),
  Dialog: __webpack_require__(361),
  DropDownIcon: __webpack_require__(1041),
  DropDownMenu: __webpack_require__(534),
  EnhancedButton: __webpack_require__(102),
  FlatButton: __webpack_require__(193),
  FloatingActionButton: __webpack_require__(1044),
  FontIcon: __webpack_require__(189),
  GridList: __webpack_require__(1045),
  GridTile: __webpack_require__(1046),
  IconButton: __webpack_require__(186),
  IconMenu: __webpack_require__(1047),
  LeftNav: __webpack_require__(1049),
  LinearProgress: __webpack_require__(1050),
  List: __webpack_require__(364),
  ListDivider: __webpack_require__(536),
  ListItem: __webpack_require__(1051),
  Menu: __webpack_require__(247),
  MenuItem: __webpack_require__(532),
  Mixins: __webpack_require__(1053),
  Overlay: __webpack_require__(362),
  Paper: __webpack_require__(54),
  RadioButton: __webpack_require__(538),
  RadioButtonGroup: __webpack_require__(1055),
  RaisedButton: __webpack_require__(1056),
  RefreshIndicator: __webpack_require__(1057),
  Ripples: __webpack_require__(1058),
  SelectField: __webpack_require__(1059),
  Slider: __webpack_require__(1060),
  SvgIcon: __webpack_require__(2),
  Icons: {
    NavigationMenu: __webpack_require__(354),
    NavigationChevronLeft: __webpack_require__(358),
    NavigationChevronRight: __webpack_require__(359)
  },
  Styles: __webpack_require__(190),
  Snackbar: __webpack_require__(1061),
  Tab: __webpack_require__(1062),
  Tabs: __webpack_require__(1063),
  Table: __webpack_require__(1066),
  TableBody: __webpack_require__(1067),
  TableFooter: __webpack_require__(1068),
  TableHeader: __webpack_require__(1069),
  TableHeaderColumn: __webpack_require__(541),
  TableRow: __webpack_require__(1070),
  TableRowColumn: __webpack_require__(365),
  Toggle: __webpack_require__(533),
  ThemeWrapper: __webpack_require__(1071),
  TimePicker: __webpack_require__(1072),
  TextField: __webpack_require__(246),
  Toolbar: __webpack_require__(529),
  ToolbarGroup: __webpack_require__(530),
  ToolbarSeparator: __webpack_require__(1080),
  ToolbarTitle: __webpack_require__(1081),
  Tooltip: __webpack_require__(353),
  Utils: __webpack_require__(1082)
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(24);
var core = __webpack_require__(86);
var hide = __webpack_require__(59);
var redefine = __webpack_require__(60);
var ctx = __webpack_require__(76);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaLibraryOverview__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Group__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MediaLibrary__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Payment__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Student__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Auth__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dashboard__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Invitation__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Message__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Settings__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Transaction__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Bundle__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Discount__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Invite__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__InviteWizard__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Notification__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Store__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Task__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__User__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PageModule__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Export__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Clipboard__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__StudentOverview__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__PageLayout__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__StoreOverview__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Klarna__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Stripe__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Category__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Quiz__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__QuizDetail__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Webinar__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Page__ = __webpack_require__(995);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__App__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__MediaLibraryOverview__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__Course__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__Group__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_4__MediaLibrary__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_5__Payment__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_6__Student__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Auth__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__Dashboard__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__Invitation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_10__Message__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_11__Settings__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_12__Transaction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_13__Bundle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_14__Discount__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_15__Invite__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_16__InviteWizard__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_17__Notification__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_18__Store__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_19__Task__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_20__User__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_21__PageModule__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_22__Export__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_23__Clipboard__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_24__StudentOverview__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_25__PageLayout__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_26__StoreOverview__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_27__Klarna__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_28__Stripe__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_29__Category__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_30__Quiz__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_31__QuizDetail__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_32__Webinar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_33__Page__["a"]; });
/* unused harmony default export */ var _unused_webpack_default_export = ({AppActions:__WEBPACK_IMPORTED_MODULE_0__App__["a" /* default */],MediaLibraryOverviewActions:__WEBPACK_IMPORTED_MODULE_1__MediaLibraryOverview__["a" /* default */],CourseActions:__WEBPACK_IMPORTED_MODULE_2__Course__["a" /* default */],GroupActions:__WEBPACK_IMPORTED_MODULE_3__Group__["a" /* default */],MediaLibraryActions:__WEBPACK_IMPORTED_MODULE_4__MediaLibrary__["a" /* default */],PaymentActions:__WEBPACK_IMPORTED_MODULE_5__Payment__["a" /* default */],StudentActions:__WEBPACK_IMPORTED_MODULE_6__Student__["a" /* default */],AuthActions:__WEBPACK_IMPORTED_MODULE_7__Auth__["a" /* default */],DashboardActions:__WEBPACK_IMPORTED_MODULE_8__Dashboard__["a" /* default */],InvitationActions:__WEBPACK_IMPORTED_MODULE_9__Invitation__["a" /* default */],MessageActions:__WEBPACK_IMPORTED_MODULE_10__Message__["a" /* default */],SettingsActions:__WEBPACK_IMPORTED_MODULE_11__Settings__["a" /* default */],TransactionActions:__WEBPACK_IMPORTED_MODULE_12__Transaction__["a" /* default */],BundleActions:__WEBPACK_IMPORTED_MODULE_13__Bundle__["a" /* default */],DiscountActions:__WEBPACK_IMPORTED_MODULE_14__Discount__["a" /* default */],InviteActions:__WEBPACK_IMPORTED_MODULE_15__Invite__["a" /* default */],InviteWizardActions:__WEBPACK_IMPORTED_MODULE_16__InviteWizard__["a" /* default */],NotificationActions:__WEBPACK_IMPORTED_MODULE_17__Notification__["a" /* default */],StoreActions:__WEBPACK_IMPORTED_MODULE_18__Store__["a" /* default */],TaskActions:__WEBPACK_IMPORTED_MODULE_19__Task__["a" /* default */],UserActions:__WEBPACK_IMPORTED_MODULE_20__User__["a" /* default */],PageModuleActions:__WEBPACK_IMPORTED_MODULE_21__PageModule__["a" /* default */],ExportActions:__WEBPACK_IMPORTED_MODULE_22__Export__["a" /* default */],ClipboardActions:__WEBPACK_IMPORTED_MODULE_23__Clipboard__["a" /* default */],StudentOverviewActions:__WEBPACK_IMPORTED_MODULE_24__StudentOverview__["a" /* default */],PageLayoutActions:__WEBPACK_IMPORTED_MODULE_25__PageLayout__["a" /* default */],StoreOverviewActions:__WEBPACK_IMPORTED_MODULE_26__StoreOverview__["a" /* default */],KlarnaActions:__WEBPACK_IMPORTED_MODULE_27__Klarna__["a" /* default */],StripeActions:__WEBPACK_IMPORTED_MODULE_28__Stripe__["a" /* default */],CategoryActions:__WEBPACK_IMPORTED_MODULE_29__Category__["a" /* default */],QuizActions:__WEBPACK_IMPORTED_MODULE_30__Quiz__["a" /* default */],QuizDetailActions:__WEBPACK_IMPORTED_MODULE_31__QuizDetail__["a" /* default */],WebinarActions:__WEBPACK_IMPORTED_MODULE_32__Webinar__["a" /* default */],PageActions:__WEBPACK_IMPORTED_MODULE_33__Page__["a" /* default */]});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textColors", function() { return textColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "themeColors", function() { return themeColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Shadow", function() { return Shadow; });
/* harmony export (immutable) */ __webpack_exports__["hexToRgba"] = hexToRgba;
/* harmony export (immutable) */ __webpack_exports__["brighten"] = brighten;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Colors", function() { return Colors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Units", function() { return Units; });
var textColors={Light:{divider:'rgba(255, 255, 255, 0.12)',disabled:'rgba(255, 255, 255, 0.30)',secondary:'rgba(255, 255, 255, 0.70)',default:'rgba(255, 255, 255, 1)'},Dark:{divider:'rgba(0, 0, 0, 0.12)',disabled:'rgba(0, 0, 0, 0.26)',secondary:'rgba(0, 0, 0, 0.54)',default:'rgba(0, 0, 0, 0.87)'}};var MuiColors={red:{'50':{hex:'#FFEBEE',text:textColors.Dark},'100':{hex:'#FFCDD2',text:textColors.Dark},'200':{hex:'#EF9A9A',text:textColors.Dark},'300':{hex:'#E57373',text:textColors.Dark},'400':{hex:'#EF5350',text:textColors.Light},'500':{hex:'#F44336',text:textColors.Light},'600':{hex:'#E53935',text:textColors.Light},'700':{hex:'#D32F2F',text:textColors.Light},'800':{hex:'#C62828',text:textColors.Light},'900':{hex:'#B71C1C',text:textColors.Light},A100:{hex:'#FF8A80',text:textColors.Dark},A200:{hex:'#FF5252',text:textColors.Light},A400:{hex:'#FF1744',text:textColors.Light},A700:{hex:'#D50000',text:textColors.Light}},pink:{'50':{hex:'#FCE4EC',text:textColors.Dark},'100':{hex:'#F8BBD0',text:textColors.Dark},'200':{hex:'#F48FB1',text:textColors.Dark},'300':{hex:'#F06292',text:textColors.Light},'400':{hex:'#EC407A',text:textColors.Light},'500':{hex:'#E91E63',text:textColors.Light},'600':{hex:'#D81B60',text:textColors.Light},'700':{hex:'#C2185B',text:textColors.Light},'800':{hex:'#AD1457',text:textColors.Light},'900':{hex:'#880E4F',text:textColors.Light},A100:{hex:'#FF80AB',text:textColors.Dark},A200:{hex:'#FF4081',text:textColors.Light},A400:{hex:'#F50057',text:textColors.Light},A700:{hex:'#C51162',text:textColors.Light}},purple:{'50':{hex:'#F3E5F5',text:textColors.Dark},'100':{hex:'#E1BEE7',text:textColors.Dark},'200':{hex:'#CE93D8',text:textColors.Dark},'300':{hex:'#BA68C8',text:textColors.Light},'400':{hex:'#AB47BC',text:textColors.Light},'500':{hex:'#9C27B0',text:textColors.Light},'600':{hex:'#8E24AA',text:textColors.Light},'700':{hex:'#7B1FA2',text:textColors.Light},'800':{hex:'#6A1B9A',text:textColors.Light},'900':{hex:'#4A148C',text:textColors.Light},A100:{hex:'#EA80FC',text:textColors.Dark},A200:{hex:'#E040FB',text:textColors.Light},A400:{hex:'#D500F9',text:textColors.Light},A700:{hex:'#AA00FF',text:textColors.Light}},deepPurple:{'50':{hex:'#EDE7F6',text:textColors.Dark},'100':{hex:'#D1C4E9',text:textColors.Dark},'200':{hex:'#B39DDB',text:textColors.Dark},'300':{hex:'#9575CD',text:textColors.Light},'400':{hex:'#7E57C2',text:textColors.Light},'500':{hex:'#673AB7',text:textColors.Light},'600':{hex:'#5E35B1',text:textColors.Light},'700':{hex:'#512DA8',text:textColors.Light},'800':{hex:'#4527A0',text:textColors.Light},'900':{hex:'#311B92',text:textColors.Light},A100:{hex:'#B388FF',text:textColors.Dark},A200:{hex:'#7C4DFF',text:textColors.Light},A400:{hex:'#651FFF',text:textColors.Light},A700:{hex:'#6200EA',text:textColors.Light}},indigo:{'50':{hex:'#E8EAF6',text:textColors.Dark},'100':{hex:'#C5CAE9',text:textColors.Dark},'200':{hex:'#9FA8DA',text:textColors.Dark},'300':{hex:'#7986CB',text:textColors.Light},'400':{hex:'#5C6BC0',text:textColors.Light},'500':{hex:'#3F51B5',text:textColors.Light},'600':{hex:'#3949AB',text:textColors.Light},'700':{hex:'#303F9F',text:textColors.Light},'800':{hex:'#283593',text:textColors.Light},'900':{hex:'#1A237E',text:textColors.Light},A100:{hex:'#8C9EFF',text:textColors.Dark},A200:{hex:'#536DFE',text:textColors.Light},A400:{hex:'#3D5AFE',text:textColors.Light},A700:{hex:'#304FFE',text:textColors.Light}},blue:{'50':{hex:'#E3F2FD',text:textColors.Dark},'100':{hex:'#BBDEFB',text:textColors.Dark},'200':{hex:'#90CAF9',text:textColors.Dark},'300':{hex:'#64B5F6',text:textColors.Dark},'400':{hex:'#42A5F5',text:textColors.Dark},'500':{hex:'#2196F3',text:textColors.Light},'600':{hex:'#1E88E5',text:textColors.Light},'700':{hex:'#1976D2',text:textColors.Light},'800':{hex:'#1565C0',text:textColors.Light},'900':{hex:'#0D47A1',text:textColors.Light},A100:{hex:'#82B1FF',text:textColors.Dark},A200:{hex:'#448AFF',text:textColors.Light},A400:{hex:'#2979FF',text:textColors.Light},A700:{hex:'#2962FF',text:textColors.Light}},lightBlue:{'50':{hex:'#E1F5FE',text:textColors.Dark},'100':{hex:'#B3E5FC',text:textColors.Dark},'200':{hex:'#81D4FA',text:textColors.Dark},'300':{hex:'#4FC3F7',text:textColors.Dark},'400':{hex:'#29B6F6',text:textColors.Dark},'500':{hex:'#03A9F4',text:textColors.Dark},'600':{hex:'#039BE5',text:textColors.Light},'700':{hex:'#0288D1',text:textColors.Light},'800':{hex:'#0277BD',text:textColors.Light},'900':{hex:'#01579B',text:textColors.Light},A100:{hex:'#80D8FF',text:textColors.Dark},A200:{hex:'#40C4FF',text:textColors.Dark},A400:{hex:'#00B0FF',text:textColors.Dark},A700:{hex:'#0091EA',text:textColors.Light}},cyan:{'50':{hex:'#E0F7FA',text:textColors.Dark},'100':{hex:'#B2EBF2',text:textColors.Dark},'200':{hex:'#80DEEA',text:textColors.Dark},'300':{hex:'#4DD0E1',text:textColors.Dark},'400':{hex:'#26C6DA',text:textColors.Dark},'500':{hex:'#00BCD4',text:textColors.Dark},'600':{hex:'#00ACC1',text:textColors.Dark},'700':{hex:'#0097A7',text:textColors.Light},'800':{hex:'#00838F',text:textColors.Light},'900':{hex:'#006064',text:textColors.Light},A100:{hex:'#84FFFF',text:textColors.Dark},A200:{hex:'#18FFFF',text:textColors.Dark},A400:{hex:'#00E5FF',text:textColors.Dark},A700:{hex:'#00B8D4',text:textColors.Dark}},coursio:{'50':{hex:'#70FDFF',text:textColors.Dark},'100':{hex:'#5CFCFF',text:textColors.Dark},'200':{hex:'#47FCFF',text:textColors.Dark},'300':{hex:'#1FFBFF',text:textColors.Dark},'400':{hex:'#00F1F5',text:textColors.Dark},'500':{hex:'#00c9cc',text:textColors.Light},'600':{hex:'#00A0A3',text:textColors.Light},'700':{hex:'#008C8F',text:textColors.Light},'800':{hex:'#006466',text:textColors.Light},'900':{hex:'#003C3D',text:textColors.Light},A100:{hex:'#5CFCFF',text:textColors.Dark},A200:{hex:'#47FCFF',text:textColors.Dark},A400:{hex:'#00F1F5',text:textColors.Dark},A700:{hex:'#008C8F',text:textColors.Dark}},teal:{'50':{hex:'#E0F2F1',text:textColors.Dark},'100':{hex:'#B2DFDB',text:textColors.Dark},'200':{hex:'#80CBC4',text:textColors.Dark},'300':{hex:'#4DB6AC',text:textColors.Dark},'400':{hex:'#26A69A',text:textColors.Dark},'500':{hex:'#009688',text:textColors.Light},'600':{hex:'#00897B',text:textColors.Light},'700':{hex:'#00796B',text:textColors.Light},'800':{hex:'#00695C',text:textColors.Light},'900':{hex:'#004D40',text:textColors.Light},A100:{hex:'#A7FFEB',text:textColors.Dark},A200:{hex:'#64FFDA',text:textColors.Dark},A400:{hex:'#1DE9B6',text:textColors.Dark},A700:{hex:'#00BFA5',text:textColors.Dark}},green:{'50':{hex:'#E8F5E9',text:textColors.Dark},'100':{hex:'#C8E6C9',text:textColors.Dark},'200':{hex:'#A5D6A7',text:textColors.Dark},'300':{hex:'#81C784',text:textColors.Dark},'400':{hex:'#66BB6A',text:textColors.Dark},'500':{hex:'#4CAF50',text:textColors.Dark},'600':{hex:'#43A047',text:textColors.Light},'700':{hex:'#388E3C',text:textColors.Light},'800':{hex:'#2E7D32',text:textColors.Light},'900':{hex:'#1B5E20',text:textColors.Light},A100:{hex:'#B9F6CA',text:textColors.Dark},A200:{hex:'#69F0AE',text:textColors.Dark},A400:{hex:'#00E676',text:textColors.Dark},A700:{hex:'#00C853',text:textColors.Dark}},lightGreen:{'50':{hex:'#F1F8E9',text:textColors.Dark},'100':{hex:'#DCEDC8',text:textColors.Dark},'200':{hex:'#C5E1A5',text:textColors.Dark},'300':{hex:'#AED581',text:textColors.Dark},'400':{hex:'#9CCC65',text:textColors.Dark},'500':{hex:'#8BC34A',text:textColors.Dark},'600':{hex:'#7CB342',text:textColors.Dark},'700':{hex:'#689F38',text:textColors.Light},'800':{hex:'#558B2F',text:textColors.Light},'900':{hex:'#33691E',text:textColors.Light},A100:{hex:'#CCFF90',text:textColors.Dark},A200:{hex:'#B2FF59',text:textColors.Dark},A400:{hex:'#76FF03',text:textColors.Dark},A700:{hex:'#64DD17',text:textColors.Dark}},lime:{'50':{hex:'#F9FBE7',text:textColors.Dark},'100':{hex:'#F0F4C3',text:textColors.Dark},'200':{hex:'#E6EE9C',text:textColors.Dark},'300':{hex:'#DCE775',text:textColors.Dark},'400':{hex:'#D4E157',text:textColors.Dark},'500':{hex:'#CDDC39',text:textColors.Dark},'600':{hex:'#C0CA33',text:textColors.Dark},'700':{hex:'#AFB42B',text:textColors.Dark},'800':{hex:'#9E9D24',text:textColors.Dark},'900':{hex:'#827717',text:textColors.Light},A100:{hex:'#F4FF81',text:textColors.Dark},A200:{hex:'#EEFF41',text:textColors.Dark},A400:{hex:'#C6FF00',text:textColors.Dark},A700:{hex:'#AEEA00',text:textColors.Dark}},yellow:{'50':{hex:'#FFFDE7',text:textColors.Dark},'100':{hex:'#FFF9C4',text:textColors.Dark},'200':{hex:'#FFF59D',text:textColors.Dark},'300':{hex:'#FFF176',text:textColors.Dark},'400':{hex:'#FFEE58',text:textColors.Dark},'500':{hex:'#FFEB3B',text:textColors.Dark},'600':{hex:'#FDD835',text:textColors.Dark},'700':{hex:'#FBC02D',text:textColors.Dark},'800':{hex:'#F9A825',text:textColors.Dark},'900':{hex:'#F57F17',text:textColors.Dark},A100:{hex:'#FFFF8D',text:textColors.Dark},A200:{hex:'#FFFF00',text:textColors.Dark},A400:{hex:'#FFEA00',text:textColors.Dark},A700:{hex:'#FFD600',text:textColors.Dark}},amber:{'50':{hex:'#FFF8E1',text:textColors.Dark},'100':{hex:'#FFECB3',text:textColors.Dark},'200':{hex:'#FFE082',text:textColors.Dark},'300':{hex:'#FFD54F',text:textColors.Dark},'400':{hex:'#FFCA28',text:textColors.Dark},'500':{hex:'#FFC107',text:textColors.Dark},'600':{hex:'#FFB300',text:textColors.Dark},'700':{hex:'#FFA000',text:textColors.Dark},'800':{hex:'#FF8F00',text:textColors.Dark},'900':{hex:'#FF6F00',text:textColors.Dark},A100:{hex:'#FFE57F',text:textColors.Dark},A200:{hex:'#FFD740',text:textColors.Dark},A400:{hex:'#FFC400',text:textColors.Dark},A700:{hex:'#FFAB00',text:textColors.Dark}},orange:{'50':{hex:'#FFF3E0',text:textColors.Dark},'100':{hex:'#FFE0B2',text:textColors.Dark},'200':{hex:'#FFCC80',text:textColors.Dark},'300':{hex:'#FFB74D',text:textColors.Dark},'400':{hex:'#FFA726',text:textColors.Dark},'500':{hex:'#FF9800',text:textColors.Dark},'600':{hex:'#FB8C00',text:textColors.Dark},'700':{hex:'#F57C00',text:textColors.Dark},'800':{hex:'#EF6C00',text:textColors.Light},'900':{hex:'#E65100',text:textColors.Light},A100:{hex:'#FFD180',text:textColors.Dark},A200:{hex:'#FFAB40',text:textColors.Dark},A400:{hex:'#FF9100',text:textColors.Dark},A700:{hex:'#FF6D00',text:textColors.Dark}},deepOrange:{'50':{hex:'#FBE9E7',text:textColors.Dark},'100':{hex:'#FFCCBC',text:textColors.Dark},'200':{hex:'#FFAB91',text:textColors.Dark},'300':{hex:'#FF8A65',text:textColors.Dark},'400':{hex:'#FF7043',text:textColors.Dark},'500':{hex:'#FF5722',text:textColors.Light},'600':{hex:'#F4511E',text:textColors.Light},'700':{hex:'#E64A19',text:textColors.Light},'800':{hex:'#D84315',text:textColors.Light},'900':{hex:'#BF360C',text:textColors.Light},A100:{hex:'#FF9E80',text:textColors.Dark},A200:{hex:'#FF6E40',text:textColors.Dark},A400:{hex:'#FF3D00',text:textColors.Light},A700:{hex:'#DD2C00',text:textColors.Light}},brown:{'50':{hex:'#EFEBE9',text:textColors.Dark},'100':{hex:'#D7CCC8',text:textColors.Dark},'200':{hex:'#BCAAA4',text:textColors.Dark},'300':{hex:'#A1887F',text:textColors.Light},'400':{hex:'#8D6E63',text:textColors.Light},'500':{hex:'#795548',text:textColors.Light},'600':{hex:'#6D4C41',text:textColors.Light},'700':{hex:'#5D4037',text:textColors.Light},'800':{hex:'#4E342E',text:textColors.Light},'900':{hex:'#3E2723',text:textColors.Light}},grey:{'50':{hex:'#FAFAFA',text:textColors.Dark},'100':{hex:'#F5F5F5',text:textColors.Dark},'200':{hex:'#EEEEEE',text:textColors.Dark},'300':{hex:'#E0E0E0',text:textColors.Dark},'400':{hex:'#BDBDBD',text:textColors.Dark},'500':{hex:'#9E9E9E',text:textColors.Dark},'600':{hex:'#757575',text:textColors.Light},'700':{hex:'#616161',text:textColors.Light},'800':{hex:'#424242',text:textColors.Light},'900':{hex:'#212121',text:textColors.Light}},blueGrey:{'50':{hex:'#ECEFF1',text:textColors.Dark},'100':{hex:'#CFD8DC',text:textColors.Dark},'200':{hex:'#B0BEC5',text:textColors.Dark},'300':{hex:'#90A4AE',text:textColors.Dark},'400':{hex:'#78909C',text:textColors.Light},'500':{hex:'#607D8B',text:textColors.Light},'600':{hex:'#546E7A',text:textColors.Light},'700':{hex:'#455A64',text:textColors.Light},'800':{hex:'#37474F',text:textColors.Light},'900':{hex:'#263238',text:textColors.Light}}};var themeColors={Light:{statusBar:'#777777',appBar:'#E5E5E5',background:'#F2F2F2',card:'#FFFFFF'},Dark:{statusBar:'#000000',appBar:'#212121',background:'#303030',card:'#424242'}};var Shadow=[null,'0 1px 3px 0 rgba(0, 0, 0, 0.11)','0 2px 6px 0 rgba(0, 0, 0, 0.06)','0 5px 14px 0 rgba(0, 0, 0, 0.08)','0 2px 24px 0 rgba(0,0,0,.07)'];function hexToRgba(input,opacity){var hex=input.replace('#','');var r=parseInt(hex.substring(0,2),16);var g=parseInt(hex.substring(2,4),16);var b=parseInt(hex.substring(4,6),16);return'rgba('+r+','+g+','+b+','+opacity/100+')';}function brighten(input,percentage){var hex=input.replace('#','');var r=Math.ceil(parseInt(hex.substring(0,2),16)*(1+percentage));var g=Math.ceil(parseInt(hex.substring(2,4),16)*(1+percentage));var b=Math.ceil(parseInt(hex.substring(4,6),16)*(1+percentage));return'rgba('+r+','+g+','+b+', 1)';}var theme={hexToRgba:hexToRgba,brighten:brighten,Shadow:Shadow,Units:{base:8,keyline:64},Typography:{paragraph:{fontSize:14,letterSpacing:'0.1px',fontFamily:'MaisonNeue-Book',lineHeight:1.5},small:{fontSize:12,letterSpacing:'0.1px',fontFamily:'MaisonNeue-Demi',lineHeight:1.5},normal:{fontSize:14,letterSpacing:'0.1px',fontFamily:'MaisonNeue-Book',lineHeight:1.5},subheading:{fontSize:20,letterSpacing:'0.5px',fontFamily:'MaisonNeue-Demi',lineHeight:1.5},heading:{fontSize:32,letterSpacing:'0.5px',fontFamily:'MaisonNeue-Demi',lineHeight:1.5}},Colors:{material:MuiColors,theme:themeColors,text:textColors,black:'#000000',white:'#ffffff',creen:'#3bcfd1',brightOrange:'#ff5500',transparent:'rgba(0, 0, 0, 0)',fullBlack:'rgba(0, 0, 0, 1)',darkBlack:'rgba(0, 0, 0, 0.87)',lightBlack:'rgba(0, 0, 0, 0.54)',minBlack:'rgba(0, 0, 0, 0.26)',faintBlack:'rgba(0, 0, 0, 0.12)',fullWhite:'rgba(255, 255, 255, 1)',darkWhite:'rgba(255, 255, 255, 0.87)',lightWhite:'rgba(255, 255, 255, 0.54)',bondiBlue:'#00C9CC',darkBondiBlue:'#004F51',bondiBluehover:'#09E4E9'}};var Colors=theme.Colors;var Units=theme.Units;/* harmony default export */ __webpack_exports__["default"] = (theme);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_lib_svg_icons_maps_directions_railway__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui_lib_svg_icons_maps_directions_railway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui_lib_svg_icons_maps_directions_railway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_lib_svg_icons_maps_directions_subway__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_lib_svg_icons_maps_directions_subway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_lib_svg_icons_maps_directions_subway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_lib_svg_icons_maps_satellite__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_lib_svg_icons_maps_satellite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_lib_svg_icons_maps_satellite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_lib_svg_icons_maps_directions_car__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_lib_svg_icons_maps_directions_car___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_lib_svg_icons_maps_directions_car__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_lib_svg_icons_maps_directions_walk__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_lib_svg_icons_maps_directions_walk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_lib_svg_icons_maps_directions_walk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_lib_svg_icons_maps_layers_clear__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_lib_svg_icons_maps_layers_clear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_lib_svg_icons_maps_layers_clear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_lib_svg_icons_maps_local_pharmacy__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_lib_svg_icons_maps_local_pharmacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_lib_svg_icons_maps_local_pharmacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_lib_svg_icons_maps_place__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_lib_svg_icons_maps_place___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_lib_svg_icons_maps_place__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_lib_svg_icons_maps_hotel__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_lib_svg_icons_maps_hotel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_lib_svg_icons_maps_hotel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_lib_svg_icons_maps_directions_bike__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_lib_svg_icons_maps_directions_bike___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_lib_svg_icons_maps_directions_bike__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_lib_svg_icons_maps_local_mall__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_lib_svg_icons_maps_local_mall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_lib_svg_icons_maps_local_mall__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_lib_svg_icons_maps_my_location__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_lib_svg_icons_maps_my_location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_lib_svg_icons_maps_my_location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_lib_svg_icons_maps_local_offer__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_lib_svg_icons_maps_local_offer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_lib_svg_icons_maps_local_offer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_lib_svg_icons_maps_local_see__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_lib_svg_icons_maps_local_see___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_lib_svg_icons_maps_local_see__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_lib_svg_icons_maps_local_car_wash__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_lib_svg_icons_maps_local_car_wash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_lib_svg_icons_maps_local_car_wash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_lib_svg_icons_maps_local_post_office__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_lib_svg_icons_maps_local_post_office___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_material_ui_lib_svg_icons_maps_local_post_office__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_lib_svg_icons_maps_directions__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_lib_svg_icons_maps_directions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_material_ui_lib_svg_icons_maps_directions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_lib_svg_icons_maps_local_movies__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_lib_svg_icons_maps_local_movies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_material_ui_lib_svg_icons_maps_local_movies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_material_ui_lib_svg_icons_maps_restaurant_menu__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_material_ui_lib_svg_icons_maps_restaurant_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_material_ui_lib_svg_icons_maps_restaurant_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_material_ui_lib_svg_icons_maps_directions_boat__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_material_ui_lib_svg_icons_maps_directions_boat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_material_ui_lib_svg_icons_maps_directions_boat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_material_ui_lib_svg_icons_maps_local_cafe__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_material_ui_lib_svg_icons_maps_local_cafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_material_ui_lib_svg_icons_maps_local_cafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_material_ui_lib_svg_icons_maps_terrain__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_material_ui_lib_svg_icons_maps_terrain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_material_ui_lib_svg_icons_maps_terrain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_material_ui_lib_svg_icons_maps_local_phone__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_material_ui_lib_svg_icons_maps_local_phone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_material_ui_lib_svg_icons_maps_local_phone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_material_ui_lib_svg_icons_maps_local_hotel__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_material_ui_lib_svg_icons_maps_local_hotel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_material_ui_lib_svg_icons_maps_local_hotel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_material_ui_lib_svg_icons_maps_local_play__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_material_ui_lib_svg_icons_maps_local_play___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_material_ui_lib_svg_icons_maps_local_play__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_material_ui_lib_svg_icons_maps_local_pizza__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_material_ui_lib_svg_icons_maps_local_pizza___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_material_ui_lib_svg_icons_maps_local_pizza__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_material_ui_lib_svg_icons_maps_local_airport__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_material_ui_lib_svg_icons_maps_local_airport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_material_ui_lib_svg_icons_maps_local_airport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_material_ui_lib_svg_icons_maps_local_shipping__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_material_ui_lib_svg_icons_maps_local_shipping___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_material_ui_lib_svg_icons_maps_local_shipping__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_material_ui_lib_svg_icons_maps_local_parking__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_material_ui_lib_svg_icons_maps_local_parking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_material_ui_lib_svg_icons_maps_local_parking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_material_ui_lib_svg_icons_maps_navigation__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_material_ui_lib_svg_icons_maps_navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_material_ui_lib_svg_icons_maps_navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_material_ui_lib_svg_icons_maps_map__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_material_ui_lib_svg_icons_maps_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_material_ui_lib_svg_icons_maps_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_material_ui_lib_svg_icons_maps_pin_drop__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_material_ui_lib_svg_icons_maps_pin_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_material_ui_lib_svg_icons_maps_pin_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_material_ui_lib_svg_icons_maps_local_hospital__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_material_ui_lib_svg_icons_maps_local_hospital___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_material_ui_lib_svg_icons_maps_local_hospital__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_material_ui_lib_svg_icons_maps_directions_run__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_material_ui_lib_svg_icons_maps_directions_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_material_ui_lib_svg_icons_maps_directions_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_material_ui_lib_svg_icons_maps_traffic__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_material_ui_lib_svg_icons_maps_traffic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_material_ui_lib_svg_icons_maps_traffic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_material_ui_lib_svg_icons_maps_layers__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_material_ui_lib_svg_icons_maps_layers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_material_ui_lib_svg_icons_maps_layers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_material_ui_lib_svg_icons_maps_local_drink__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_material_ui_lib_svg_icons_maps_local_drink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_material_ui_lib_svg_icons_maps_local_drink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_material_ui_lib_svg_icons_maps_local_grocery_store__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_material_ui_lib_svg_icons_maps_local_grocery_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_material_ui_lib_svg_icons_maps_local_grocery_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_material_ui_lib_svg_icons_maps_local_dining__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_material_ui_lib_svg_icons_maps_local_dining___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_material_ui_lib_svg_icons_maps_local_dining__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_material_ui_lib_svg_icons_maps_local_taxi__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_material_ui_lib_svg_icons_maps_local_taxi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_material_ui_lib_svg_icons_maps_local_taxi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_material_ui_lib_svg_icons_maps_person_pin__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_material_ui_lib_svg_icons_maps_person_pin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_material_ui_lib_svg_icons_maps_person_pin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_material_ui_lib_svg_icons_maps_local_gas_station__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_material_ui_lib_svg_icons_maps_local_gas_station___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_material_ui_lib_svg_icons_maps_local_gas_station__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_material_ui_lib_svg_icons_maps_flight__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_material_ui_lib_svg_icons_maps_flight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_material_ui_lib_svg_icons_maps_flight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_material_ui_lib_svg_icons_maps_local_activity__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_material_ui_lib_svg_icons_maps_local_activity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_material_ui_lib_svg_icons_maps_local_activity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_material_ui_lib_svg_icons_maps_local_florist__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_material_ui_lib_svg_icons_maps_local_florist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_material_ui_lib_svg_icons_maps_local_florist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_material_ui_lib_svg_icons_maps_local_bar__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_material_ui_lib_svg_icons_maps_local_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_material_ui_lib_svg_icons_maps_local_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_material_ui_lib_svg_icons_maps_directions_transit__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_material_ui_lib_svg_icons_maps_directions_transit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_material_ui_lib_svg_icons_maps_directions_transit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_material_ui_lib_svg_icons_maps_local_printshop__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_material_ui_lib_svg_icons_maps_local_printshop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_material_ui_lib_svg_icons_maps_local_printshop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_material_ui_lib_svg_icons_maps_local_atm__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_material_ui_lib_svg_icons_maps_local_atm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_material_ui_lib_svg_icons_maps_local_atm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_material_ui_lib_svg_icons_maps_store_mall_directory__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_material_ui_lib_svg_icons_maps_store_mall_directory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_material_ui_lib_svg_icons_maps_store_mall_directory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_material_ui_lib_svg_icons_maps_local_convenience_store__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_material_ui_lib_svg_icons_maps_local_convenience_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_material_ui_lib_svg_icons_maps_local_convenience_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_material_ui_lib_svg_icons_maps_rate_review__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_material_ui_lib_svg_icons_maps_rate_review___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_material_ui_lib_svg_icons_maps_rate_review__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_material_ui_lib_svg_icons_maps_local_library__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_material_ui_lib_svg_icons_maps_local_library___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_material_ui_lib_svg_icons_maps_local_library__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_material_ui_lib_svg_icons_maps_local_laundry_service__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_material_ui_lib_svg_icons_maps_local_laundry_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_material_ui_lib_svg_icons_maps_local_laundry_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_material_ui_lib_svg_icons_maps_beenhere__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_material_ui_lib_svg_icons_maps_beenhere___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_material_ui_lib_svg_icons_maps_beenhere__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_material_ui_lib_svg_icons_maps_directions_bus__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_material_ui_lib_svg_icons_maps_directions_bus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_material_ui_lib_svg_icons_maps_directions_bus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_material_ui_lib_svg_icons_navigation_more_horiz__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_material_ui_lib_svg_icons_navigation_more_horiz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_material_ui_lib_svg_icons_navigation_more_horiz__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_material_ui_lib_svg_icons_navigation_fullscreen__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_material_ui_lib_svg_icons_navigation_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_material_ui_lib_svg_icons_navigation_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_material_ui_lib_svg_icons_navigation_check__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_material_ui_lib_svg_icons_navigation_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_material_ui_lib_svg_icons_navigation_check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_material_ui_lib_svg_icons_navigation_refresh__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_material_ui_lib_svg_icons_navigation_refresh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_material_ui_lib_svg_icons_navigation_refresh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_material_ui_lib_svg_icons_navigation_arrow_drop_down_circle__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_material_ui_lib_svg_icons_navigation_arrow_drop_down_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_material_ui_lib_svg_icons_navigation_arrow_drop_down_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_material_ui_lib_svg_icons_navigation_menu__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_material_ui_lib_svg_icons_navigation_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_material_ui_lib_svg_icons_navigation_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_material_ui_lib_svg_icons_navigation_expand_more__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_material_ui_lib_svg_icons_navigation_expand_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_material_ui_lib_svg_icons_navigation_expand_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_material_ui_lib_svg_icons_navigation_unfold_less__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_material_ui_lib_svg_icons_navigation_unfold_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_material_ui_lib_svg_icons_navigation_unfold_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_material_ui_lib_svg_icons_navigation_arrow_forward__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_material_ui_lib_svg_icons_navigation_arrow_forward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_material_ui_lib_svg_icons_navigation_arrow_forward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_material_ui_lib_svg_icons_navigation_fullscreen_exit__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_material_ui_lib_svg_icons_navigation_fullscreen_exit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_material_ui_lib_svg_icons_navigation_fullscreen_exit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_material_ui_lib_svg_icons_navigation_apps__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_material_ui_lib_svg_icons_navigation_apps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_material_ui_lib_svg_icons_navigation_apps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_material_ui_lib_svg_icons_navigation_arrow_back__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_material_ui_lib_svg_icons_navigation_arrow_back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_material_ui_lib_svg_icons_navigation_arrow_back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_material_ui_lib_svg_icons_navigation_arrow_drop_up__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_material_ui_lib_svg_icons_navigation_arrow_drop_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_material_ui_lib_svg_icons_navigation_arrow_drop_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_material_ui_lib_svg_icons_navigation_close__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_material_ui_lib_svg_icons_navigation_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_material_ui_lib_svg_icons_navigation_close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_material_ui_lib_svg_icons_navigation_chevron_right__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_material_ui_lib_svg_icons_navigation_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_material_ui_lib_svg_icons_navigation_chevron_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_material_ui_lib_svg_icons_navigation_expand_less__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_material_ui_lib_svg_icons_navigation_expand_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_material_ui_lib_svg_icons_navigation_expand_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_material_ui_lib_svg_icons_navigation_more_vert__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_material_ui_lib_svg_icons_navigation_more_vert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_material_ui_lib_svg_icons_navigation_more_vert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_material_ui_lib_svg_icons_navigation_arrow_drop_down__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_material_ui_lib_svg_icons_navigation_arrow_drop_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_material_ui_lib_svg_icons_navigation_arrow_drop_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_material_ui_lib_svg_icons_navigation_chevron_left__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_material_ui_lib_svg_icons_navigation_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_material_ui_lib_svg_icons_navigation_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_material_ui_lib_svg_icons_navigation_unfold_more__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_material_ui_lib_svg_icons_navigation_unfold_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_material_ui_lib_svg_icons_navigation_unfold_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_material_ui_lib_svg_icons_navigation_cancel__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_material_ui_lib_svg_icons_navigation_cancel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_material_ui_lib_svg_icons_navigation_cancel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_material_ui_lib_svg_icons_editor_vertical_align_bottom__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_material_ui_lib_svg_icons_editor_vertical_align_bottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_material_ui_lib_svg_icons_editor_vertical_align_bottom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_material_ui_lib_svg_icons_editor_format_paint__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_material_ui_lib_svg_icons_editor_format_paint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_material_ui_lib_svg_icons_editor_format_paint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_material_ui_lib_svg_icons_editor_border_horizontal__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_material_ui_lib_svg_icons_editor_border_horizontal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_material_ui_lib_svg_icons_editor_border_horizontal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_material_ui_lib_svg_icons_editor_format_align_right__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_material_ui_lib_svg_icons_editor_format_align_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_material_ui_lib_svg_icons_editor_format_align_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_material_ui_lib_svg_icons_editor_border_style__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_material_ui_lib_svg_icons_editor_border_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_material_ui_lib_svg_icons_editor_border_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_material_ui_lib_svg_icons_editor_border_inner__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_material_ui_lib_svg_icons_editor_border_inner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_material_ui_lib_svg_icons_editor_border_inner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_material_ui_lib_svg_icons_editor_format_textdirection_l_to_r__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_material_ui_lib_svg_icons_editor_format_textdirection_l_to_r___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_material_ui_lib_svg_icons_editor_format_textdirection_l_to_r__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_material_ui_lib_svg_icons_editor_border_color__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_material_ui_lib_svg_icons_editor_border_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_material_ui_lib_svg_icons_editor_border_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_material_ui_lib_svg_icons_editor_format_align_center__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_material_ui_lib_svg_icons_editor_format_align_center___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_material_ui_lib_svg_icons_editor_format_align_center__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_material_ui_lib_svg_icons_editor_format_strikethrough__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_material_ui_lib_svg_icons_editor_format_strikethrough___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_material_ui_lib_svg_icons_editor_format_strikethrough__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_material_ui_lib_svg_icons_editor_format_list_bulleted__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_material_ui_lib_svg_icons_editor_format_list_bulleted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_material_ui_lib_svg_icons_editor_format_list_bulleted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_material_ui_lib_svg_icons_editor_functions__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_material_ui_lib_svg_icons_editor_functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88_material_ui_lib_svg_icons_editor_functions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_material_ui_lib_svg_icons_editor_format_color_text__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_material_ui_lib_svg_icons_editor_format_color_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_material_ui_lib_svg_icons_editor_format_color_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_material_ui_lib_svg_icons_editor_format_color_fill__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_material_ui_lib_svg_icons_editor_format_color_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90_material_ui_lib_svg_icons_editor_format_color_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_material_ui_lib_svg_icons_editor_mode_edit__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_material_ui_lib_svg_icons_editor_mode_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91_material_ui_lib_svg_icons_editor_mode_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_material_ui_lib_svg_icons_editor_wrap_text__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_material_ui_lib_svg_icons_editor_wrap_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92_material_ui_lib_svg_icons_editor_wrap_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_material_ui_lib_svg_icons_editor_merge_type__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_material_ui_lib_svg_icons_editor_merge_type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93_material_ui_lib_svg_icons_editor_merge_type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_material_ui_lib_svg_icons_editor_border_vertical__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_material_ui_lib_svg_icons_editor_border_vertical___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94_material_ui_lib_svg_icons_editor_border_vertical__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_material_ui_lib_svg_icons_editor_vertical_align_center__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_material_ui_lib_svg_icons_editor_vertical_align_center___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95_material_ui_lib_svg_icons_editor_vertical_align_center__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_material_ui_lib_svg_icons_editor_border_left__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_material_ui_lib_svg_icons_editor_border_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96_material_ui_lib_svg_icons_editor_border_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_material_ui_lib_svg_icons_editor_format_list_numbered__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_material_ui_lib_svg_icons_editor_format_list_numbered___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97_material_ui_lib_svg_icons_editor_format_list_numbered__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_material_ui_lib_svg_icons_editor_border_right__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_material_ui_lib_svg_icons_editor_border_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98_material_ui_lib_svg_icons_editor_border_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_material_ui_lib_svg_icons_editor_format_line_spacing__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_material_ui_lib_svg_icons_editor_format_line_spacing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99_material_ui_lib_svg_icons_editor_format_line_spacing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_material_ui_lib_svg_icons_editor_format_indent_decrease__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100_material_ui_lib_svg_icons_editor_format_indent_decrease___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100_material_ui_lib_svg_icons_editor_format_indent_decrease__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_material_ui_lib_svg_icons_editor_border_top__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101_material_ui_lib_svg_icons_editor_border_top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101_material_ui_lib_svg_icons_editor_border_top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_material_ui_lib_svg_icons_editor_mode_comment__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102_material_ui_lib_svg_icons_editor_mode_comment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102_material_ui_lib_svg_icons_editor_mode_comment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_material_ui_lib_svg_icons_editor_format_color_reset__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103_material_ui_lib_svg_icons_editor_format_color_reset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103_material_ui_lib_svg_icons_editor_format_color_reset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104_material_ui_lib_svg_icons_editor_money_off__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104_material_ui_lib_svg_icons_editor_money_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104_material_ui_lib_svg_icons_editor_money_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_material_ui_lib_svg_icons_editor_space_bar__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_material_ui_lib_svg_icons_editor_space_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105_material_ui_lib_svg_icons_editor_space_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_material_ui_lib_svg_icons_editor_insert_emoticon__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_material_ui_lib_svg_icons_editor_insert_emoticon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106_material_ui_lib_svg_icons_editor_insert_emoticon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107_material_ui_lib_svg_icons_editor_format_quote__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107_material_ui_lib_svg_icons_editor_format_quote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107_material_ui_lib_svg_icons_editor_format_quote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_material_ui_lib_svg_icons_editor_vertical_align_top__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108_material_ui_lib_svg_icons_editor_vertical_align_top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108_material_ui_lib_svg_icons_editor_vertical_align_top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109_material_ui_lib_svg_icons_editor_format_align_left__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109_material_ui_lib_svg_icons_editor_format_align_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109_material_ui_lib_svg_icons_editor_format_align_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110_material_ui_lib_svg_icons_editor_attach_money__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110_material_ui_lib_svg_icons_editor_attach_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110_material_ui_lib_svg_icons_editor_attach_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111_material_ui_lib_svg_icons_editor_border_bottom__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111_material_ui_lib_svg_icons_editor_border_bottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111_material_ui_lib_svg_icons_editor_border_bottom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112_material_ui_lib_svg_icons_editor_format_textdirection_r_to_l__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112_material_ui_lib_svg_icons_editor_format_textdirection_r_to_l___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112_material_ui_lib_svg_icons_editor_format_textdirection_r_to_l__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113_material_ui_lib_svg_icons_editor_format_clear__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113_material_ui_lib_svg_icons_editor_format_clear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113_material_ui_lib_svg_icons_editor_format_clear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114_material_ui_lib_svg_icons_editor_insert_drive_file__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114_material_ui_lib_svg_icons_editor_insert_drive_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114_material_ui_lib_svg_icons_editor_insert_drive_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115_material_ui_lib_svg_icons_editor_format_indent_increase__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115_material_ui_lib_svg_icons_editor_format_indent_increase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115_material_ui_lib_svg_icons_editor_format_indent_increase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116_material_ui_lib_svg_icons_editor_insert_chart__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116_material_ui_lib_svg_icons_editor_insert_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116_material_ui_lib_svg_icons_editor_insert_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117_material_ui_lib_svg_icons_editor_insert_comment__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117_material_ui_lib_svg_icons_editor_insert_comment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117_material_ui_lib_svg_icons_editor_insert_comment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118_material_ui_lib_svg_icons_editor_format_bold__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118_material_ui_lib_svg_icons_editor_format_bold___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118_material_ui_lib_svg_icons_editor_format_bold__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119_material_ui_lib_svg_icons_editor_format_size__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119_material_ui_lib_svg_icons_editor_format_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119_material_ui_lib_svg_icons_editor_format_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120_material_ui_lib_svg_icons_editor_border_clear__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120_material_ui_lib_svg_icons_editor_border_clear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120_material_ui_lib_svg_icons_editor_border_clear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121_material_ui_lib_svg_icons_editor_publish__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121_material_ui_lib_svg_icons_editor_publish___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121_material_ui_lib_svg_icons_editor_publish__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122_material_ui_lib_svg_icons_editor_attach_file__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122_material_ui_lib_svg_icons_editor_attach_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122_material_ui_lib_svg_icons_editor_attach_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123_material_ui_lib_svg_icons_editor_border_all__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123_material_ui_lib_svg_icons_editor_border_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123_material_ui_lib_svg_icons_editor_border_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124_material_ui_lib_svg_icons_editor_strikethrough_s__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124_material_ui_lib_svg_icons_editor_strikethrough_s___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124_material_ui_lib_svg_icons_editor_strikethrough_s__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125_material_ui_lib_svg_icons_editor_format_underlined__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125_material_ui_lib_svg_icons_editor_format_underlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125_material_ui_lib_svg_icons_editor_format_underlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126_material_ui_lib_svg_icons_editor_insert_invitation__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126_material_ui_lib_svg_icons_editor_insert_invitation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126_material_ui_lib_svg_icons_editor_insert_invitation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127_material_ui_lib_svg_icons_editor_insert_link__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127_material_ui_lib_svg_icons_editor_insert_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127_material_ui_lib_svg_icons_editor_insert_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128_material_ui_lib_svg_icons_editor_border_outer__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128_material_ui_lib_svg_icons_editor_border_outer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128_material_ui_lib_svg_icons_editor_border_outer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129_material_ui_lib_svg_icons_editor_format_align_justify__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129_material_ui_lib_svg_icons_editor_format_align_justify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129_material_ui_lib_svg_icons_editor_format_align_justify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130_material_ui_lib_svg_icons_editor_insert_photo__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130_material_ui_lib_svg_icons_editor_insert_photo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130_material_ui_lib_svg_icons_editor_insert_photo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131_material_ui_lib_svg_icons_editor_format_italic__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131_material_ui_lib_svg_icons_editor_format_italic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131_material_ui_lib_svg_icons_editor_format_italic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132_material_ui_lib_svg_icons_navigation_arrow_drop_right__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132_material_ui_lib_svg_icons_navigation_arrow_drop_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132_material_ui_lib_svg_icons_navigation_arrow_drop_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133_material_ui_lib_svg_icons_toggle_check_box__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133_material_ui_lib_svg_icons_toggle_check_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133_material_ui_lib_svg_icons_toggle_check_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134_material_ui_lib_svg_icons_toggle_star__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134_material_ui_lib_svg_icons_toggle_star___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134_material_ui_lib_svg_icons_toggle_star__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135_material_ui_lib_svg_icons_toggle_check_box_outline_blank__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135_material_ui_lib_svg_icons_toggle_check_box_outline_blank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135_material_ui_lib_svg_icons_toggle_check_box_outline_blank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136_material_ui_lib_svg_icons_toggle_star_half__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136_material_ui_lib_svg_icons_toggle_star_half___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136_material_ui_lib_svg_icons_toggle_star_half__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137_material_ui_lib_svg_icons_toggle_star_border__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137_material_ui_lib_svg_icons_toggle_star_border___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137_material_ui_lib_svg_icons_toggle_star_border__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138_material_ui_lib_svg_icons_toggle_indeterminate_check_box__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138_material_ui_lib_svg_icons_toggle_indeterminate_check_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138_material_ui_lib_svg_icons_toggle_indeterminate_check_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139_material_ui_lib_svg_icons_toggle_radio_button_unchecked__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139_material_ui_lib_svg_icons_toggle_radio_button_unchecked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139_material_ui_lib_svg_icons_toggle_radio_button_unchecked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140_material_ui_lib_svg_icons_toggle_radio_button_checked__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140_material_ui_lib_svg_icons_toggle_radio_button_checked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140_material_ui_lib_svg_icons_toggle_radio_button_checked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141_material_ui_lib_svg_icons_file_cloud_off__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141_material_ui_lib_svg_icons_file_cloud_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141_material_ui_lib_svg_icons_file_cloud_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142_material_ui_lib_svg_icons_file_cloud__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142_material_ui_lib_svg_icons_file_cloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142_material_ui_lib_svg_icons_file_cloud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143_material_ui_lib_svg_icons_file_cloud_download__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143_material_ui_lib_svg_icons_file_cloud_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143_material_ui_lib_svg_icons_file_cloud_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144_material_ui_lib_svg_icons_file_folder_open__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144_material_ui_lib_svg_icons_file_folder_open___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144_material_ui_lib_svg_icons_file_folder_open__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145_material_ui_lib_svg_icons_file_file_upload__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145_material_ui_lib_svg_icons_file_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145_material_ui_lib_svg_icons_file_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146_material_ui_lib_svg_icons_file_cloud_upload__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146_material_ui_lib_svg_icons_file_cloud_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146_material_ui_lib_svg_icons_file_cloud_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147_material_ui_lib_svg_icons_file_file_download__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147_material_ui_lib_svg_icons_file_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_147_material_ui_lib_svg_icons_file_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148_material_ui_lib_svg_icons_file_cloud_done__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148_material_ui_lib_svg_icons_file_cloud_done___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_148_material_ui_lib_svg_icons_file_cloud_done__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149_material_ui_lib_svg_icons_file_attachment__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149_material_ui_lib_svg_icons_file_attachment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_149_material_ui_lib_svg_icons_file_attachment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150_material_ui_lib_svg_icons_file_folder_shared__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150_material_ui_lib_svg_icons_file_folder_shared___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_150_material_ui_lib_svg_icons_file_folder_shared__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151_material_ui_lib_svg_icons_file_cloud_queue__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151_material_ui_lib_svg_icons_file_cloud_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_151_material_ui_lib_svg_icons_file_cloud_queue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152_material_ui_lib_svg_icons_file_cloud_circle__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152_material_ui_lib_svg_icons_file_cloud_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_152_material_ui_lib_svg_icons_file_cloud_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153_material_ui_lib_svg_icons_file_folder__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153_material_ui_lib_svg_icons_file_folder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_153_material_ui_lib_svg_icons_file_folder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154_material_ui_lib_svg_icons_communication_message__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154_material_ui_lib_svg_icons_communication_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_154_material_ui_lib_svg_icons_communication_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155_material_ui_lib_svg_icons_communication_speaker_phone__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155_material_ui_lib_svg_icons_communication_speaker_phone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_155_material_ui_lib_svg_icons_communication_speaker_phone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156_material_ui_lib_svg_icons_communication_forum__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156_material_ui_lib_svg_icons_communication_forum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_156_material_ui_lib_svg_icons_communication_forum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157_material_ui_lib_svg_icons_communication_location_on__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157_material_ui_lib_svg_icons_communication_location_on___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_157_material_ui_lib_svg_icons_communication_location_on__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158_material_ui_lib_svg_icons_communication_dialpad__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158_material_ui_lib_svg_icons_communication_dialpad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_158_material_ui_lib_svg_icons_communication_dialpad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159_material_ui_lib_svg_icons_communication_contacts__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159_material_ui_lib_svg_icons_communication_contacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_159_material_ui_lib_svg_icons_communication_contacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160_material_ui_lib_svg_icons_communication_location_off__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160_material_ui_lib_svg_icons_communication_location_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_160_material_ui_lib_svg_icons_communication_location_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161_material_ui_lib_svg_icons_communication_chat_bubble_outline__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161_material_ui_lib_svg_icons_communication_chat_bubble_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_161_material_ui_lib_svg_icons_communication_chat_bubble_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162_material_ui_lib_svg_icons_communication_stay_current_portrait__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162_material_ui_lib_svg_icons_communication_stay_current_portrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_162_material_ui_lib_svg_icons_communication_stay_current_portrait__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163_material_ui_lib_svg_icons_communication_call_split__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163_material_ui_lib_svg_icons_communication_call_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_163_material_ui_lib_svg_icons_communication_call_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164_material_ui_lib_svg_icons_communication_call_missed__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164_material_ui_lib_svg_icons_communication_call_missed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_164_material_ui_lib_svg_icons_communication_call_missed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165_material_ui_lib_svg_icons_communication_chat_bubble__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165_material_ui_lib_svg_icons_communication_chat_bubble___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_165_material_ui_lib_svg_icons_communication_chat_bubble__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166_material_ui_lib_svg_icons_communication_present_to_all__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166_material_ui_lib_svg_icons_communication_present_to_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_166_material_ui_lib_svg_icons_communication_present_to_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167_material_ui_lib_svg_icons_communication_stay_primary_portrait__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167_material_ui_lib_svg_icons_communication_stay_primary_portrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_167_material_ui_lib_svg_icons_communication_stay_primary_portrait__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168_material_ui_lib_svg_icons_communication_call_received__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168_material_ui_lib_svg_icons_communication_call_received___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_168_material_ui_lib_svg_icons_communication_call_received__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169_material_ui_lib_svg_icons_communication_stay_primary_landscape__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169_material_ui_lib_svg_icons_communication_stay_primary_landscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_169_material_ui_lib_svg_icons_communication_stay_primary_landscape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170_material_ui_lib_svg_icons_communication_phonelink_erase__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170_material_ui_lib_svg_icons_communication_phonelink_erase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_170_material_ui_lib_svg_icons_communication_phonelink_erase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171_material_ui_lib_svg_icons_communication_invert_colors_off__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171_material_ui_lib_svg_icons_communication_invert_colors_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_171_material_ui_lib_svg_icons_communication_invert_colors_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172_material_ui_lib_svg_icons_communication_call_merge__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172_material_ui_lib_svg_icons_communication_call_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_172_material_ui_lib_svg_icons_communication_call_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173_material_ui_lib_svg_icons_communication_phonelink_lock__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173_material_ui_lib_svg_icons_communication_phonelink_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_173_material_ui_lib_svg_icons_communication_phonelink_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174_material_ui_lib_svg_icons_communication_live_help__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174_material_ui_lib_svg_icons_communication_live_help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_174_material_ui_lib_svg_icons_communication_live_help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175_material_ui_lib_svg_icons_communication_swap_calls__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175_material_ui_lib_svg_icons_communication_swap_calls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_175_material_ui_lib_svg_icons_communication_swap_calls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176_material_ui_lib_svg_icons_communication_tact_mail__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176_material_ui_lib_svg_icons_communication_tact_mail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_176_material_ui_lib_svg_icons_communication_tact_mail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177_material_ui_lib_svg_icons_communication_contact_phone__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177_material_ui_lib_svg_icons_communication_contact_phone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_177_material_ui_lib_svg_icons_communication_contact_phone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178_material_ui_lib_svg_icons_communication_portable_wifi_off__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178_material_ui_lib_svg_icons_communication_portable_wifi_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_178_material_ui_lib_svg_icons_communication_portable_wifi_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179_material_ui_lib_svg_icons_communication_dialer_sip__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179_material_ui_lib_svg_icons_communication_dialer_sip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_179_material_ui_lib_svg_icons_communication_dialer_sip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180_material_ui_lib_svg_icons_communication_no_sim__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180_material_ui_lib_svg_icons_communication_no_sim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_180_material_ui_lib_svg_icons_communication_no_sim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181_material_ui_lib_svg_icons_communication_stay_current_landscape__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181_material_ui_lib_svg_icons_communication_stay_current_landscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_181_material_ui_lib_svg_icons_communication_stay_current_landscape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182_material_ui_lib_svg_icons_communication_call__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182_material_ui_lib_svg_icons_communication_call___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_182_material_ui_lib_svg_icons_communication_call__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183_material_ui_lib_svg_icons_communication_vpn_key__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183_material_ui_lib_svg_icons_communication_vpn_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_183_material_ui_lib_svg_icons_communication_vpn_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184_material_ui_lib_svg_icons_communication_voicemail__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184_material_ui_lib_svg_icons_communication_voicemail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_184_material_ui_lib_svg_icons_communication_voicemail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185_material_ui_lib_svg_icons_communication_phonelink_ring__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185_material_ui_lib_svg_icons_communication_phonelink_ring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_185_material_ui_lib_svg_icons_communication_phonelink_ring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186_material_ui_lib_svg_icons_communication_business__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186_material_ui_lib_svg_icons_communication_business___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_186_material_ui_lib_svg_icons_communication_business__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187_material_ui_lib_svg_icons_communication_import_export__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187_material_ui_lib_svg_icons_communication_import_export___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_187_material_ui_lib_svg_icons_communication_import_export__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188_material_ui_lib_svg_icons_communication_clear_all__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188_material_ui_lib_svg_icons_communication_clear_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_188_material_ui_lib_svg_icons_communication_clear_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189_material_ui_lib_svg_icons_communication_email__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189_material_ui_lib_svg_icons_communication_email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_189_material_ui_lib_svg_icons_communication_email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190_material_ui_lib_svg_icons_communication_comment__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190_material_ui_lib_svg_icons_communication_comment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_190_material_ui_lib_svg_icons_communication_comment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191_material_ui_lib_svg_icons_communication_textsms__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191_material_ui_lib_svg_icons_communication_textsms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_191_material_ui_lib_svg_icons_communication_textsms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192_material_ui_lib_svg_icons_communication_phonelink_setup__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192_material_ui_lib_svg_icons_communication_phonelink_setup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_192_material_ui_lib_svg_icons_communication_phonelink_setup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193_material_ui_lib_svg_icons_communication_call_end__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193_material_ui_lib_svg_icons_communication_call_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_193_material_ui_lib_svg_icons_communication_call_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194_material_ui_lib_svg_icons_communication_call_made__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194_material_ui_lib_svg_icons_communication_call_made___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_194_material_ui_lib_svg_icons_communication_call_made__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195_material_ui_lib_svg_icons_communication_chat__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195_material_ui_lib_svg_icons_communication_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_195_material_ui_lib_svg_icons_communication_chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196_material_ui_lib_svg_icons_communication_phone__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196_material_ui_lib_svg_icons_communication_phone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_196_material_ui_lib_svg_icons_communication_phone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197_material_ui_lib_svg_icons_communication_ring_volume__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197_material_ui_lib_svg_icons_communication_ring_volume___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_197_material_ui_lib_svg_icons_communication_ring_volume__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198_material_ui_lib_svg_icons_action_settings_ethernet__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198_material_ui_lib_svg_icons_action_settings_ethernet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_198_material_ui_lib_svg_icons_action_settings_ethernet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199_material_ui_lib_svg_icons_action_assignment_returned__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199_material_ui_lib_svg_icons_action_assignment_returned___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_199_material_ui_lib_svg_icons_action_assignment_returned__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200_material_ui_lib_svg_icons_action_lock_open__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200_material_ui_lib_svg_icons_action_lock_open___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_200_material_ui_lib_svg_icons_action_lock_open__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201_material_ui_lib_svg_icons_action_report_problem__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201_material_ui_lib_svg_icons_action_report_problem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_201_material_ui_lib_svg_icons_action_report_problem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202_material_ui_lib_svg_icons_action_list__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202_material_ui_lib_svg_icons_action_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_202_material_ui_lib_svg_icons_action_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203_material_ui_lib_svg_icons_action_swap_vert__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203_material_ui_lib_svg_icons_action_swap_vert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_203_material_ui_lib_svg_icons_action_swap_vert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204_material_ui_lib_svg_icons_action_tab__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204_material_ui_lib_svg_icons_action_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_204_material_ui_lib_svg_icons_action_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205_material_ui_lib_svg_icons_action_info_outline__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205_material_ui_lib_svg_icons_action_info_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_205_material_ui_lib_svg_icons_action_info_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206_material_ui_lib_svg_icons_action_tab_unselected__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206_material_ui_lib_svg_icons_action_tab_unselected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_206_material_ui_lib_svg_icons_action_tab_unselected__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207_material_ui_lib_svg_icons_action_gif__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207_material_ui_lib_svg_icons_action_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_207_material_ui_lib_svg_icons_action_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208_material_ui_lib_svg_icons_action_polymer__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208_material_ui_lib_svg_icons_action_polymer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_208_material_ui_lib_svg_icons_action_polymer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209_material_ui_lib_svg_icons_action_explore__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209_material_ui_lib_svg_icons_action_explore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_209_material_ui_lib_svg_icons_action_explore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210_material_ui_lib_svg_icons_action_thumb_down__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210_material_ui_lib_svg_icons_action_thumb_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_210_material_ui_lib_svg_icons_action_thumb_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211_material_ui_lib_svg_icons_action_view_headline__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211_material_ui_lib_svg_icons_action_view_headline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_211_material_ui_lib_svg_icons_action_view_headline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212_material_ui_lib_svg_icons_action_pageview__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212_material_ui_lib_svg_icons_action_pageview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_212_material_ui_lib_svg_icons_action_pageview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213_material_ui_lib_svg_icons_action_favorite_border__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213_material_ui_lib_svg_icons_action_favorite_border___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_213_material_ui_lib_svg_icons_action_favorite_border__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214_material_ui_lib_svg_icons_action_perm_phone_msg__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214_material_ui_lib_svg_icons_action_perm_phone_msg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_214_material_ui_lib_svg_icons_action_perm_phone_msg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215_material_ui_lib_svg_icons_action_settings_input_antenna__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215_material_ui_lib_svg_icons_action_settings_input_antenna___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_215_material_ui_lib_svg_icons_action_settings_input_antenna__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216_material_ui_lib_svg_icons_action_assignment__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216_material_ui_lib_svg_icons_action_assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_216_material_ui_lib_svg_icons_action_assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217_material_ui_lib_svg_icons_action_get_app__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217_material_ui_lib_svg_icons_action_get_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_217_material_ui_lib_svg_icons_action_get_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218_material_ui_lib_svg_icons_action_perm_media__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218_material_ui_lib_svg_icons_action_perm_media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_218_material_ui_lib_svg_icons_action_perm_media__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219_material_ui_lib_svg_icons_action_find_in_page__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219_material_ui_lib_svg_icons_action_find_in_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_219_material_ui_lib_svg_icons_action_find_in_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220_material_ui_lib_svg_icons_action_settings_bluetooth__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220_material_ui_lib_svg_icons_action_settings_bluetooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_220_material_ui_lib_svg_icons_action_settings_bluetooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221_material_ui_lib_svg_icons_action_credit_card__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221_material_ui_lib_svg_icons_action_credit_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_221_material_ui_lib_svg_icons_action_credit_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222_material_ui_lib_svg_icons_action_view_week__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222_material_ui_lib_svg_icons_action_view_week___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_222_material_ui_lib_svg_icons_action_view_week__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223_material_ui_lib_svg_icons_action_track_changes__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223_material_ui_lib_svg_icons_action_track_changes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_223_material_ui_lib_svg_icons_action_track_changes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224_material_ui_lib_svg_icons_action_card_giftcard__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224_material_ui_lib_svg_icons_action_card_giftcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_224_material_ui_lib_svg_icons_action_card_giftcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225_material_ui_lib_svg_icons_action_settings_backup_restore__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225_material_ui_lib_svg_icons_action_settings_backup_restore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_225_material_ui_lib_svg_icons_action_settings_backup_restore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226_material_ui_lib_svg_icons_action_bug_report__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226_material_ui_lib_svg_icons_action_bug_report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_226_material_ui_lib_svg_icons_action_bug_report__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227_material_ui_lib_svg_icons_action_highlight_off__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227_material_ui_lib_svg_icons_action_highlight_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_227_material_ui_lib_svg_icons_action_highlight_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228_material_ui_lib_svg_icons_action_change_history__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228_material_ui_lib_svg_icons_action_change_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_228_material_ui_lib_svg_icons_action_change_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229_material_ui_lib_svg_icons_action_view_agenda__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229_material_ui_lib_svg_icons_action_view_agenda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_229_material_ui_lib_svg_icons_action_view_agenda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230_material_ui_lib_svg_icons_action_done__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230_material_ui_lib_svg_icons_action_done___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_230_material_ui_lib_svg_icons_action_done__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231_material_ui_lib_svg_icons_action_lock_outline__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231_material_ui_lib_svg_icons_action_lock_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_231_material_ui_lib_svg_icons_action_lock_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232_material_ui_lib_svg_icons_action_hourglass_full__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232_material_ui_lib_svg_icons_action_hourglass_full___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_232_material_ui_lib_svg_icons_action_hourglass_full__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233_material_ui_lib_svg_icons_action_label__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233_material_ui_lib_svg_icons_action_label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_233_material_ui_lib_svg_icons_action_label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234_material_ui_lib_svg_icons_action_bookmark__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234_material_ui_lib_svg_icons_action_bookmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_234_material_ui_lib_svg_icons_action_bookmark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235_material_ui_lib_svg_icons_action_swap_vertical_circle__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235_material_ui_lib_svg_icons_action_swap_vertical_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_235_material_ui_lib_svg_icons_action_swap_vertical_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236_material_ui_lib_svg_icons_action_eject__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236_material_ui_lib_svg_icons_action_eject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_236_material_ui_lib_svg_icons_action_eject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237_material_ui_lib_svg_icons_action_trending_flat__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237_material_ui_lib_svg_icons_action_trending_flat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_237_material_ui_lib_svg_icons_action_trending_flat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238_material_ui_lib_svg_icons_action_group_work__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238_material_ui_lib_svg_icons_action_group_work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_238_material_ui_lib_svg_icons_action_group_work__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239_material_ui_lib_svg_icons_action_settings_input_svideo__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239_material_ui_lib_svg_icons_action_settings_input_svideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_239_material_ui_lib_svg_icons_action_settings_input_svideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240_material_ui_lib_svg_icons_action_perm_contact_calendar__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240_material_ui_lib_svg_icons_action_perm_contact_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_240_material_ui_lib_svg_icons_action_perm_contact_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241_material_ui_lib_svg_icons_action_face__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241_material_ui_lib_svg_icons_action_face___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_241_material_ui_lib_svg_icons_action_face__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242_material_ui_lib_svg_icons_action_verified_user__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242_material_ui_lib_svg_icons_action_verified_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_242_material_ui_lib_svg_icons_action_verified_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243_material_ui_lib_svg_icons_action_theaters__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243_material_ui_lib_svg_icons_action_theaters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_243_material_ui_lib_svg_icons_action_theaters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244_material_ui_lib_svg_icons_action_build__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244_material_ui_lib_svg_icons_action_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_244_material_ui_lib_svg_icons_action_build__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245_material_ui_lib_svg_icons_action_perm_data_setting__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245_material_ui_lib_svg_icons_action_perm_data_setting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_245_material_ui_lib_svg_icons_action_perm_data_setting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246_material_ui_lib_svg_icons_action_question_answer__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246_material_ui_lib_svg_icons_action_question_answer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_246_material_ui_lib_svg_icons_action_question_answer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247_material_ui_lib_svg_icons_action_flip_to_back__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247_material_ui_lib_svg_icons_action_flip_to_back___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_247_material_ui_lib_svg_icons_action_flip_to_back__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248_material_ui_lib_svg_icons_action_extension__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248_material_ui_lib_svg_icons_action_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_248_material_ui_lib_svg_icons_action_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249_material_ui_lib_svg_icons_action_accessibility__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249_material_ui_lib_svg_icons_action_accessibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_249_material_ui_lib_svg_icons_action_accessibility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250_material_ui_lib_svg_icons_action_alarm_on__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250_material_ui_lib_svg_icons_action_alarm_on___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_250_material_ui_lib_svg_icons_action_alarm_on__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251_material_ui_lib_svg_icons_action_query_builder__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251_material_ui_lib_svg_icons_action_query_builder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_251_material_ui_lib_svg_icons_action_query_builder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252_material_ui_lib_svg_icons_action_add_shopping_cart__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252_material_ui_lib_svg_icons_action_add_shopping_cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_252_material_ui_lib_svg_icons_action_add_shopping_cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253_material_ui_lib_svg_icons_action_payment__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253_material_ui_lib_svg_icons_action_payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_253_material_ui_lib_svg_icons_action_payment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254_material_ui_lib_svg_icons_action_event_seat__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254_material_ui_lib_svg_icons_action_event_seat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_254_material_ui_lib_svg_icons_action_event_seat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255_material_ui_lib_svg_icons_action_input__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255_material_ui_lib_svg_icons_action_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_255_material_ui_lib_svg_icons_action_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256_material_ui_lib_svg_icons_action_markunread_mailbox__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256_material_ui_lib_svg_icons_action_markunread_mailbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_256_material_ui_lib_svg_icons_action_markunread_mailbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257_material_ui_lib_svg_icons_action_loyalty__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257_material_ui_lib_svg_icons_action_loyalty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_257_material_ui_lib_svg_icons_action_loyalty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258_material_ui_lib_svg_icons_action_print__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258_material_ui_lib_svg_icons_action_print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_258_material_ui_lib_svg_icons_action_print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259_material_ui_lib_svg_icons_action_autorenew__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259_material_ui_lib_svg_icons_action_autorenew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_259_material_ui_lib_svg_icons_action_autorenew__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260_material_ui_lib_svg_icons_action_delete__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260_material_ui_lib_svg_icons_action_delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_260_material_ui_lib_svg_icons_action_delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261_material_ui_lib_svg_icons_action_alarm_add__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261_material_ui_lib_svg_icons_action_alarm_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_261_material_ui_lib_svg_icons_action_alarm_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262_material_ui_lib_svg_icons_action_account_balance__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262_material_ui_lib_svg_icons_action_account_balance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_262_material_ui_lib_svg_icons_action_account_balance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263_material_ui_lib_svg_icons_action_android__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263_material_ui_lib_svg_icons_action_android___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_263_material_ui_lib_svg_icons_action_android__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264_material_ui_lib_svg_icons_action_bookmark_border__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264_material_ui_lib_svg_icons_action_bookmark_border___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_264_material_ui_lib_svg_icons_action_bookmark_border__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265_material_ui_lib_svg_icons_action_launch__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265_material_ui_lib_svg_icons_action_launch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_265_material_ui_lib_svg_icons_action_launch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266_material_ui_lib_svg_icons_action_search__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266_material_ui_lib_svg_icons_action_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_266_material_ui_lib_svg_icons_action_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267_material_ui_lib_svg_icons_action_zoom_out__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267_material_ui_lib_svg_icons_action_zoom_out___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_267_material_ui_lib_svg_icons_action_zoom_out__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268_material_ui_lib_svg_icons_action_visibility_off__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268_material_ui_lib_svg_icons_action_visibility_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_268_material_ui_lib_svg_icons_action_visibility_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269_material_ui_lib_svg_icons_action_lock__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269_material_ui_lib_svg_icons_action_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_269_material_ui_lib_svg_icons_action_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270_material_ui_lib_svg_icons_action_account_circle__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270_material_ui_lib_svg_icons_action_account_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_270_material_ui_lib_svg_icons_action_account_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271_material_ui_lib_svg_icons_action_assignment_late__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271_material_ui_lib_svg_icons_action_assignment_late___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_271_material_ui_lib_svg_icons_action_assignment_late__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272_material_ui_lib_svg_icons_action_shop__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272_material_ui_lib_svg_icons_action_shop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_272_material_ui_lib_svg_icons_action_shop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273_material_ui_lib_svg_icons_action_toc__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273_material_ui_lib_svg_icons_action_toc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_273_material_ui_lib_svg_icons_action_toc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274_material_ui_lib_svg_icons_action_shopping_cart__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274_material_ui_lib_svg_icons_action_shopping_cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_274_material_ui_lib_svg_icons_action_shopping_cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275_material_ui_lib_svg_icons_action_card_membership__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275_material_ui_lib_svg_icons_action_card_membership___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_275_material_ui_lib_svg_icons_action_card_membership__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276_material_ui_lib_svg_icons_action_label_outline__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276_material_ui_lib_svg_icons_action_label_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_276_material_ui_lib_svg_icons_action_label_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277_material_ui_lib_svg_icons_action_settings__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277_material_ui_lib_svg_icons_action_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_277_material_ui_lib_svg_icons_action_settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278_material_ui_lib_svg_icons_action_settings_cell__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278_material_ui_lib_svg_icons_action_settings_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_278_material_ui_lib_svg_icons_action_settings_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279_material_ui_lib_svg_icons_action_offline_pin__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279_material_ui_lib_svg_icons_action_offline_pin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_279_material_ui_lib_svg_icons_action_offline_pin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280_material_ui_lib_svg_icons_action_view_day__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280_material_ui_lib_svg_icons_action_view_day___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_280_material_ui_lib_svg_icons_action_view_day__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281_material_ui_lib_svg_icons_action_dashboard__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281_material_ui_lib_svg_icons_action_dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_281_material_ui_lib_svg_icons_action_dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282_material_ui_lib_svg_icons_action_view_module__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282_material_ui_lib_svg_icons_action_view_module___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_282_material_ui_lib_svg_icons_action_view_module__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283_material_ui_lib_svg_icons_action_settings_applications__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283_material_ui_lib_svg_icons_action_settings_applications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_283_material_ui_lib_svg_icons_action_settings_applications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284_material_ui_lib_svg_icons_action_view_stream__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284_material_ui_lib_svg_icons_action_view_stream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_284_material_ui_lib_svg_icons_action_view_stream__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285_material_ui_lib_svg_icons_action_view_column__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285_material_ui_lib_svg_icons_action_view_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_285_material_ui_lib_svg_icons_action_view_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286_material_ui_lib_svg_icons_action_settings_input_composite__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286_material_ui_lib_svg_icons_action_settings_input_composite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_286_material_ui_lib_svg_icons_action_settings_input_composite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287_material_ui_lib_svg_icons_action_account_balance_wallet__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287_material_ui_lib_svg_icons_action_account_balance_wallet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_287_material_ui_lib_svg_icons_action_account_balance_wallet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288_material_ui_lib_svg_icons_action_info__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288_material_ui_lib_svg_icons_action_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_288_material_ui_lib_svg_icons_action_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289_material_ui_lib_svg_icons_action_assignment_turned_in__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289_material_ui_lib_svg_icons_action_assignment_turned_in___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_289_material_ui_lib_svg_icons_action_assignment_turned_in__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290_material_ui_lib_svg_icons_action_schedule__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290_material_ui_lib_svg_icons_action_schedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_290_material_ui_lib_svg_icons_action_schedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291_material_ui_lib_svg_icons_action_perm_device_information__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291_material_ui_lib_svg_icons_action_perm_device_information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_291_material_ui_lib_svg_icons_action_perm_device_information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292_material_ui_lib_svg_icons_action_view_list__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292_material_ui_lib_svg_icons_action_view_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_292_material_ui_lib_svg_icons_action_view_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293_material_ui_lib_svg_icons_action_open_in_browser__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293_material_ui_lib_svg_icons_action_open_in_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_293_material_ui_lib_svg_icons_action_open_in_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294_material_ui_lib_svg_icons_action_settings_phone__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294_material_ui_lib_svg_icons_action_settings_phone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_294_material_ui_lib_svg_icons_action_settings_phone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295_material_ui_lib_svg_icons_action_feedback__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295_material_ui_lib_svg_icons_action_feedback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_295_material_ui_lib_svg_icons_action_feedback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296_material_ui_lib_svg_icons_action_https__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296_material_ui_lib_svg_icons_action_https___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_296_material_ui_lib_svg_icons_action_https__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297_material_ui_lib_svg_icons_action_alarm_off__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297_material_ui_lib_svg_icons_action_alarm_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_297_material_ui_lib_svg_icons_action_alarm_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298_material_ui_lib_svg_icons_action_cached__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298_material_ui_lib_svg_icons_action_cached___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_298_material_ui_lib_svg_icons_action_cached__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299_material_ui_lib_svg_icons_action_trending_up__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299_material_ui_lib_svg_icons_action_trending_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_299_material_ui_lib_svg_icons_action_trending_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300_material_ui_lib_svg_icons_action_work__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300_material_ui_lib_svg_icons_action_work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_300_material_ui_lib_svg_icons_action_work__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301_material_ui_lib_svg_icons_action_perm_camera_mic__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301_material_ui_lib_svg_icons_action_perm_camera_mic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_301_material_ui_lib_svg_icons_action_perm_camera_mic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302_material_ui_lib_svg_icons_action_open_in_new__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302_material_ui_lib_svg_icons_action_open_in_new___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_302_material_ui_lib_svg_icons_action_open_in_new__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303_material_ui_lib_svg_icons_action_turned_in_not__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303_material_ui_lib_svg_icons_action_turned_in_not___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_303_material_ui_lib_svg_icons_action_turned_in_not__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304_material_ui_lib_svg_icons_action_thumb_up__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304_material_ui_lib_svg_icons_action_thumb_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_304_material_ui_lib_svg_icons_action_thumb_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305_material_ui_lib_svg_icons_action_exit_to_app__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305_material_ui_lib_svg_icons_action_exit_to_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_305_material_ui_lib_svg_icons_action_exit_to_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306_material_ui_lib_svg_icons_action_view_array__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306_material_ui_lib_svg_icons_action_view_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_306_material_ui_lib_svg_icons_action_view_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307_material_ui_lib_svg_icons_action_receipt__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307_material_ui_lib_svg_icons_action_receipt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_307_material_ui_lib_svg_icons_action_receipt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308_material_ui_lib_svg_icons_action_aspect_ratio__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308_material_ui_lib_svg_icons_action_aspect_ratio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_308_material_ui_lib_svg_icons_action_aspect_ratio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309_material_ui_lib_svg_icons_action_play_for_work__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309_material_ui_lib_svg_icons_action_play_for_work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_309_material_ui_lib_svg_icons_action_play_for_work__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310_material_ui_lib_svg_icons_action_redeem__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310_material_ui_lib_svg_icons_action_redeem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_310_material_ui_lib_svg_icons_action_redeem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311_material_ui_lib_svg_icons_action_check_circle__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311_material_ui_lib_svg_icons_action_check_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_311_material_ui_lib_svg_icons_action_check_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312_material_ui_lib_svg_icons_action_http__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312_material_ui_lib_svg_icons_action_http___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_312_material_ui_lib_svg_icons_action_http__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313_material_ui_lib_svg_icons_action_event__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313_material_ui_lib_svg_icons_action_event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_313_material_ui_lib_svg_icons_action_event__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314_material_ui_lib_svg_icons_action_stars__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314_material_ui_lib_svg_icons_action_stars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_314_material_ui_lib_svg_icons_action_stars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315_material_ui_lib_svg_icons_action_invert_colors__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315_material_ui_lib_svg_icons_action_invert_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_315_material_ui_lib_svg_icons_action_invert_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316_material_ui_lib_svg_icons_action_speaker_notes__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316_material_ui_lib_svg_icons_action_speaker_notes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_316_material_ui_lib_svg_icons_action_speaker_notes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_317_material_ui_lib_svg_icons_action_open_with__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_317_material_ui_lib_svg_icons_action_open_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_317_material_ui_lib_svg_icons_action_open_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_318_material_ui_lib_svg_icons_action_help__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_318_material_ui_lib_svg_icons_action_help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_318_material_ui_lib_svg_icons_action_help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_319_material_ui_lib_svg_icons_action_hourglass_empty__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_319_material_ui_lib_svg_icons_action_hourglass_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_319_material_ui_lib_svg_icons_action_hourglass_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_320_material_ui_lib_svg_icons_action_assignment_ind__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_320_material_ui_lib_svg_icons_action_assignment_ind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_320_material_ui_lib_svg_icons_action_assignment_ind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_321_material_ui_lib_svg_icons_action_assessment__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_321_material_ui_lib_svg_icons_action_assessment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_321_material_ui_lib_svg_icons_action_assessment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_322_material_ui_lib_svg_icons_action_code__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_322_material_ui_lib_svg_icons_action_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_322_material_ui_lib_svg_icons_action_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_323_material_ui_lib_svg_icons_action_alarm__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_323_material_ui_lib_svg_icons_action_alarm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_323_material_ui_lib_svg_icons_action_alarm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_324_material_ui_lib_svg_icons_action_power_settings_new__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_324_material_ui_lib_svg_icons_action_power_settings_new___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_324_material_ui_lib_svg_icons_action_power_settings_new__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_325_material_ui_lib_svg_icons_action_system_update_alt__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_325_material_ui_lib_svg_icons_action_system_update_alt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_325_material_ui_lib_svg_icons_action_system_update_alt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_326_material_ui_lib_svg_icons_action_toll__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_326_material_ui_lib_svg_icons_action_toll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_326_material_ui_lib_svg_icons_action_toll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_327_material_ui_lib_svg_icons_action_note_add__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_327_material_ui_lib_svg_icons_action_note_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_327_material_ui_lib_svg_icons_action_note_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_328_material_ui_lib_svg_icons_action_card_travel__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_328_material_ui_lib_svg_icons_action_card_travel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_328_material_ui_lib_svg_icons_action_card_travel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_329_material_ui_lib_svg_icons_action_settings_remote__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_329_material_ui_lib_svg_icons_action_settings_remote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_329_material_ui_lib_svg_icons_action_settings_remote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_330_material_ui_lib_svg_icons_action_book__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_330_material_ui_lib_svg_icons_action_book___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_330_material_ui_lib_svg_icons_action_book__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_331_material_ui_lib_svg_icons_action_store__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_331_material_ui_lib_svg_icons_action_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_331_material_ui_lib_svg_icons_action_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_332_material_ui_lib_svg_icons_action_subject__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_332_material_ui_lib_svg_icons_action_subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_332_material_ui_lib_svg_icons_action_subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_333_material_ui_lib_svg_icons_action_view_carousel__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_333_material_ui_lib_svg_icons_action_view_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_333_material_ui_lib_svg_icons_action_view_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_334_material_ui_lib_svg_icons_action_reorder__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_334_material_ui_lib_svg_icons_action_reorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_334_material_ui_lib_svg_icons_action_reorder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_335_material_ui_lib_svg_icons_action_visibility__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_335_material_ui_lib_svg_icons_action_visibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_335_material_ui_lib_svg_icons_action_visibility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_336_material_ui_lib_svg_icons_action_account_box__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_336_material_ui_lib_svg_icons_action_account_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_336_material_ui_lib_svg_icons_action_account_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_337_material_ui_lib_svg_icons_action_favorite__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_337_material_ui_lib_svg_icons_action_favorite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_337_material_ui_lib_svg_icons_action_favorite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_338_material_ui_lib_svg_icons_action_settings_input_hdmi__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_338_material_ui_lib_svg_icons_action_settings_input_hdmi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_338_material_ui_lib_svg_icons_action_settings_input_hdmi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_339_material_ui_lib_svg_icons_action_turned_in__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_339_material_ui_lib_svg_icons_action_turned_in___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_339_material_ui_lib_svg_icons_action_turned_in__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_340_material_ui_lib_svg_icons_action_description__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_340_material_ui_lib_svg_icons_action_description___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_340_material_ui_lib_svg_icons_action_description__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_341_material_ui_lib_svg_icons_action_help_outline__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_341_material_ui_lib_svg_icons_action_help_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_341_material_ui_lib_svg_icons_action_help_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_342_material_ui_lib_svg_icons_action_trending_down__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_342_material_ui_lib_svg_icons_action_trending_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_342_material_ui_lib_svg_icons_action_trending_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_343_material_ui_lib_svg_icons_action_flight_land__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_343_material_ui_lib_svg_icons_action_flight_land___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_343_material_ui_lib_svg_icons_action_flight_land__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_344_material_ui_lib_svg_icons_action_flip_to_front__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_344_material_ui_lib_svg_icons_action_flip_to_front___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_344_material_ui_lib_svg_icons_action_flip_to_front__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_345_material_ui_lib_svg_icons_action_today__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_345_material_ui_lib_svg_icons_action_today___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_345_material_ui_lib_svg_icons_action_today__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_346_material_ui_lib_svg_icons_action_shopping_basket__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_346_material_ui_lib_svg_icons_action_shopping_basket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_346_material_ui_lib_svg_icons_action_shopping_basket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_347_material_ui_lib_svg_icons_action_settings_brightness__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_347_material_ui_lib_svg_icons_action_settings_brightness___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_347_material_ui_lib_svg_icons_action_settings_brightness__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_348_material_ui_lib_svg_icons_action_picture_in_picture__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_348_material_ui_lib_svg_icons_action_picture_in_picture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_348_material_ui_lib_svg_icons_action_picture_in_picture__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_349_material_ui_lib_svg_icons_action_zoom_in__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_349_material_ui_lib_svg_icons_action_zoom_in___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_349_material_ui_lib_svg_icons_action_zoom_in__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_350_material_ui_lib_svg_icons_action_shop_two__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_350_material_ui_lib_svg_icons_action_shop_two___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_350_material_ui_lib_svg_icons_action_shop_two__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_351_material_ui_lib_svg_icons_action_class__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_351_material_ui_lib_svg_icons_action_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_351_material_ui_lib_svg_icons_action_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_352_material_ui_lib_svg_icons_action_swap_horiz__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_352_material_ui_lib_svg_icons_action_swap_horiz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_352_material_ui_lib_svg_icons_action_swap_horiz__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_353_material_ui_lib_svg_icons_action_perm_scan_wifi__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_353_material_ui_lib_svg_icons_action_perm_scan_wifi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_353_material_ui_lib_svg_icons_action_perm_scan_wifi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_354_material_ui_lib_svg_icons_action_flight_takeoff__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_354_material_ui_lib_svg_icons_action_flight_takeoff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_354_material_ui_lib_svg_icons_action_flight_takeoff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_355_material_ui_lib_svg_icons_action_grade__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_355_material_ui_lib_svg_icons_action_grade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_355_material_ui_lib_svg_icons_action_grade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_356_material_ui_lib_svg_icons_action_home__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_356_material_ui_lib_svg_icons_action_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_356_material_ui_lib_svg_icons_action_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_357_material_ui_lib_svg_icons_action_backup__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_357_material_ui_lib_svg_icons_action_backup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_357_material_ui_lib_svg_icons_action_backup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_358_material_ui_lib_svg_icons_action_settings_input_component__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_358_material_ui_lib_svg_icons_action_settings_input_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_358_material_ui_lib_svg_icons_action_settings_input_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_359_material_ui_lib_svg_icons_action_translate__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_359_material_ui_lib_svg_icons_action_translate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_359_material_ui_lib_svg_icons_action_translate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_360_material_ui_lib_svg_icons_action_settings_voice__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_360_material_ui_lib_svg_icons_action_settings_voice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_360_material_ui_lib_svg_icons_action_settings_voice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_361_material_ui_lib_svg_icons_action_thumbs_up_down__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_361_material_ui_lib_svg_icons_action_thumbs_up_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_361_material_ui_lib_svg_icons_action_thumbs_up_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_362_material_ui_lib_svg_icons_action_view_quilt__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_362_material_ui_lib_svg_icons_action_view_quilt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_362_material_ui_lib_svg_icons_action_view_quilt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_363_material_ui_lib_svg_icons_action_dns__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_363_material_ui_lib_svg_icons_action_dns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_363_material_ui_lib_svg_icons_action_dns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_364_material_ui_lib_svg_icons_action_restore__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_364_material_ui_lib_svg_icons_action_restore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_364_material_ui_lib_svg_icons_action_restore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_365_material_ui_lib_svg_icons_action_settings_overscan__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_365_material_ui_lib_svg_icons_action_settings_overscan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_365_material_ui_lib_svg_icons_action_settings_overscan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_366_material_ui_lib_svg_icons_action_done_all__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_366_material_ui_lib_svg_icons_action_done_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_366_material_ui_lib_svg_icons_action_done_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_367_material_ui_lib_svg_icons_action_supervisor_account__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_367_material_ui_lib_svg_icons_action_supervisor_account___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_367_material_ui_lib_svg_icons_action_supervisor_account__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_368_material_ui_lib_svg_icons_action_language__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_368_material_ui_lib_svg_icons_action_language___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_368_material_ui_lib_svg_icons_action_language__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_369_material_ui_lib_svg_icons_action_perm_identity__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_369_material_ui_lib_svg_icons_action_perm_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_369_material_ui_lib_svg_icons_action_perm_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_370_material_ui_lib_svg_icons_action_youtube_searched_for__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_370_material_ui_lib_svg_icons_action_youtube_searched_for___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_370_material_ui_lib_svg_icons_action_youtube_searched_for__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_371_material_ui_lib_svg_icons_action_assignment_return__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_371_material_ui_lib_svg_icons_action_assignment_return___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_371_material_ui_lib_svg_icons_action_assignment_return__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_372_material_ui_lib_svg_icons_action_announcement__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_372_material_ui_lib_svg_icons_action_announcement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_372_material_ui_lib_svg_icons_action_announcement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_373_material_ui_lib_svg_icons_action_settings_power__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_373_material_ui_lib_svg_icons_action_settings_power___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_373_material_ui_lib_svg_icons_action_settings_power__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_374_material_ui_lib_svg_icons_action_room__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_374_material_ui_lib_svg_icons_action_room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_374_material_ui_lib_svg_icons_action_room__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_375_material_ui_lib_svg_icons_action_find_replace__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_375_material_ui_lib_svg_icons_action_find_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_375_material_ui_lib_svg_icons_action_find_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_376_material_ui_lib_svg_icons_action_three_d_rotation__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_376_material_ui_lib_svg_icons_action_three_d_rotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_376_material_ui_lib_svg_icons_action_three_d_rotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_377_material_ui_lib_svg_icons_action_chrome_reader_mode__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_377_material_ui_lib_svg_icons_action_chrome_reader_mode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_377_material_ui_lib_svg_icons_action_chrome_reader_mode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_378_material_ui_lib_svg_icons_action_camera_enhance__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_378_material_ui_lib_svg_icons_action_camera_enhance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_378_material_ui_lib_svg_icons_action_camera_enhance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_379_material_ui_lib_svg_icons_action_history__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_379_material_ui_lib_svg_icons_action_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_379_material_ui_lib_svg_icons_action_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_380_material_ui_lib_svg_icons_action_spellcheck__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_380_material_ui_lib_svg_icons_action_spellcheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_380_material_ui_lib_svg_icons_action_spellcheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_381_material_ui_lib_svg_icons_social_notifications_off__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_381_material_ui_lib_svg_icons_social_notifications_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_381_material_ui_lib_svg_icons_social_notifications_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_382_material_ui_lib_svg_icons_social_person_add__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_382_material_ui_lib_svg_icons_social_person_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_382_material_ui_lib_svg_icons_social_person_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_383_material_ui_lib_svg_icons_social_share__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_383_material_ui_lib_svg_icons_social_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_383_material_ui_lib_svg_icons_social_share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_384_material_ui_lib_svg_icons_social_group_add__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_384_material_ui_lib_svg_icons_social_group_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_384_material_ui_lib_svg_icons_social_group_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_385_material_ui_lib_svg_icons_social_group__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_385_material_ui_lib_svg_icons_social_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_385_material_ui_lib_svg_icons_social_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_386_material_ui_lib_svg_icons_social_notifications_none__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_386_material_ui_lib_svg_icons_social_notifications_none___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_386_material_ui_lib_svg_icons_social_notifications_none__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_387_material_ui_lib_svg_icons_social_mood_bad__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_387_material_ui_lib_svg_icons_social_mood_bad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_387_material_ui_lib_svg_icons_social_mood_bad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_388_material_ui_lib_svg_icons_social_plus_one__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_388_material_ui_lib_svg_icons_social_plus_one___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_388_material_ui_lib_svg_icons_social_plus_one__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_389_material_ui_lib_svg_icons_social_mood__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_389_material_ui_lib_svg_icons_social_mood___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_389_material_ui_lib_svg_icons_social_mood__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_390_material_ui_lib_svg_icons_social_person_outline__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_390_material_ui_lib_svg_icons_social_person_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_390_material_ui_lib_svg_icons_social_person_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_391_material_ui_lib_svg_icons_social_poll__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_391_material_ui_lib_svg_icons_social_poll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_391_material_ui_lib_svg_icons_social_poll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_392_material_ui_lib_svg_icons_social_location_city__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_392_material_ui_lib_svg_icons_social_location_city___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_392_material_ui_lib_svg_icons_social_location_city__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_393_material_ui_lib_svg_icons_social_person__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_393_material_ui_lib_svg_icons_social_person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_393_material_ui_lib_svg_icons_social_person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_394_material_ui_lib_svg_icons_social_people_outline__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_394_material_ui_lib_svg_icons_social_people_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_394_material_ui_lib_svg_icons_social_people_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_395_material_ui_lib_svg_icons_social_cake__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_395_material_ui_lib_svg_icons_social_cake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_395_material_ui_lib_svg_icons_social_cake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_396_material_ui_lib_svg_icons_social_whatshot__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_396_material_ui_lib_svg_icons_social_whatshot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_396_material_ui_lib_svg_icons_social_whatshot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_397_material_ui_lib_svg_icons_social_notifications_paused__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_397_material_ui_lib_svg_icons_social_notifications_paused___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_397_material_ui_lib_svg_icons_social_notifications_paused__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_398_material_ui_lib_svg_icons_social_public__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_398_material_ui_lib_svg_icons_social_public___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_398_material_ui_lib_svg_icons_social_public__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_399_material_ui_lib_svg_icons_social_pages__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_399_material_ui_lib_svg_icons_social_pages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_399_material_ui_lib_svg_icons_social_pages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_400_material_ui_lib_svg_icons_social_people__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_400_material_ui_lib_svg_icons_social_people___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_400_material_ui_lib_svg_icons_social_people__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_401_material_ui_lib_svg_icons_social_notifications__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_401_material_ui_lib_svg_icons_social_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_401_material_ui_lib_svg_icons_social_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_402_material_ui_lib_svg_icons_social_notifications_active__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_402_material_ui_lib_svg_icons_social_notifications_active___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_402_material_ui_lib_svg_icons_social_notifications_active__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_403_material_ui_lib_svg_icons_social_school__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_403_material_ui_lib_svg_icons_social_school___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_403_material_ui_lib_svg_icons_social_school__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_404_material_ui_lib_svg_icons_social_domain__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_404_material_ui_lib_svg_icons_social_domain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_404_material_ui_lib_svg_icons_social_domain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_405_material_ui_lib_svg_icons_social_party_mode__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_405_material_ui_lib_svg_icons_social_party_mode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_405_material_ui_lib_svg_icons_social_party_mode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_406_material_ui_lib_svg_icons_av_not_interested__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_406_material_ui_lib_svg_icons_av_not_interested___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_406_material_ui_lib_svg_icons_av_not_interested__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_407_material_ui_lib_svg_icons_av_pause_circle_outline__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_407_material_ui_lib_svg_icons_av_pause_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_407_material_ui_lib_svg_icons_av_pause_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_408_material_ui_lib_svg_icons_av_new_releases__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_408_material_ui_lib_svg_icons_av_new_releases___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_408_material_ui_lib_svg_icons_av_new_releases__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_409_material_ui_lib_svg_icons_av_mic__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_409_material_ui_lib_svg_icons_av_mic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_409_material_ui_lib_svg_icons_av_mic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_410_material_ui_lib_svg_icons_av_skip_previous__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_410_material_ui_lib_svg_icons_av_skip_previous___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_410_material_ui_lib_svg_icons_av_skip_previous__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_411_material_ui_lib_svg_icons_av_replay_5__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_411_material_ui_lib_svg_icons_av_replay_5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_411_material_ui_lib_svg_icons_av_replay_5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_412_material_ui_lib_svg_icons_av_movie__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_412_material_ui_lib_svg_icons_av_movie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_412_material_ui_lib_svg_icons_av_movie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_413_material_ui_lib_svg_icons_av_forward_10__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_413_material_ui_lib_svg_icons_av_forward_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_413_material_ui_lib_svg_icons_av_forward_10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_414_material_ui_lib_svg_icons_av_games__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_414_material_ui_lib_svg_icons_av_games___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_414_material_ui_lib_svg_icons_av_games__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_415_material_ui_lib_svg_icons_av_high_quality__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_415_material_ui_lib_svg_icons_av_high_quality___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_415_material_ui_lib_svg_icons_av_high_quality__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_416_material_ui_lib_svg_icons_av_explicit__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_416_material_ui_lib_svg_icons_av_explicit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_416_material_ui_lib_svg_icons_av_explicit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_417_material_ui_lib_svg_icons_av_hd__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_417_material_ui_lib_svg_icons_av_hd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_417_material_ui_lib_svg_icons_av_hd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_418_material_ui_lib_svg_icons_av_album__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_418_material_ui_lib_svg_icons_av_album___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_418_material_ui_lib_svg_icons_av_album__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_419_material_ui_lib_svg_icons_av_repeat_one__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_419_material_ui_lib_svg_icons_av_repeat_one___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_419_material_ui_lib_svg_icons_av_repeat_one__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_420_material_ui_lib_svg_icons_av_skip_next__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_420_material_ui_lib_svg_icons_av_skip_next___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_420_material_ui_lib_svg_icons_av_skip_next__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_421_material_ui_lib_svg_icons_av_library_books__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_421_material_ui_lib_svg_icons_av_library_books___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_421_material_ui_lib_svg_icons_av_library_books__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_422_material_ui_lib_svg_icons_av_volume_mute__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_422_material_ui_lib_svg_icons_av_volume_mute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_422_material_ui_lib_svg_icons_av_volume_mute__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_423_material_ui_lib_svg_icons_av_library_music__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_423_material_ui_lib_svg_icons_av_library_music___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_423_material_ui_lib_svg_icons_av_library_music__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_424_material_ui_lib_svg_icons_av_play_arrow__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_424_material_ui_lib_svg_icons_av_play_arrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_424_material_ui_lib_svg_icons_av_play_arrow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_425_material_ui_lib_svg_icons_av_radio__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_425_material_ui_lib_svg_icons_av_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_425_material_ui_lib_svg_icons_av_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_426_material_ui_lib_svg_icons_av_fast_rewind__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_426_material_ui_lib_svg_icons_av_fast_rewind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_426_material_ui_lib_svg_icons_av_fast_rewind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_427_material_ui_lib_svg_icons_av_replay__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_427_material_ui_lib_svg_icons_av_replay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_427_material_ui_lib_svg_icons_av_replay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_428_material_ui_lib_svg_icons_av_hearing__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_428_material_ui_lib_svg_icons_av_hearing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_428_material_ui_lib_svg_icons_av_hearing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_429_material_ui_lib_svg_icons_av_pause__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_429_material_ui_lib_svg_icons_av_pause___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_429_material_ui_lib_svg_icons_av_pause__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_430_material_ui_lib_svg_icons_av_equalizer__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_430_material_ui_lib_svg_icons_av_equalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_430_material_ui_lib_svg_icons_av_equalizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_431_material_ui_lib_svg_icons_av_volume_up__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_431_material_ui_lib_svg_icons_av_volume_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_431_material_ui_lib_svg_icons_av_volume_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_432_material_ui_lib_svg_icons_av_fast_forward__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_432_material_ui_lib_svg_icons_av_fast_forward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_432_material_ui_lib_svg_icons_av_fast_forward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_433_material_ui_lib_svg_icons_av_surround_sound__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_433_material_ui_lib_svg_icons_av_surround_sound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_433_material_ui_lib_svg_icons_av_surround_sound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_434_material_ui_lib_svg_icons_av_forward_30__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_434_material_ui_lib_svg_icons_av_forward_30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_434_material_ui_lib_svg_icons_av_forward_30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_435_material_ui_lib_svg_icons_av_queue_music__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_435_material_ui_lib_svg_icons_av_queue_music___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_435_material_ui_lib_svg_icons_av_queue_music__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_436_material_ui_lib_svg_icons_av_replay_30__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_436_material_ui_lib_svg_icons_av_replay_30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_436_material_ui_lib_svg_icons_av_replay_30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_437_material_ui_lib_svg_icons_av_sort_by_alpha__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_437_material_ui_lib_svg_icons_av_sort_by_alpha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_437_material_ui_lib_svg_icons_av_sort_by_alpha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_438_material_ui_lib_svg_icons_av_subtitles__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_438_material_ui_lib_svg_icons_av_subtitles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_438_material_ui_lib_svg_icons_av_subtitles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_439_material_ui_lib_svg_icons_av_closed_caption__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_439_material_ui_lib_svg_icons_av_closed_caption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_439_material_ui_lib_svg_icons_av_closed_caption__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_440_material_ui_lib_svg_icons_av_video_library__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_440_material_ui_lib_svg_icons_av_video_library___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_440_material_ui_lib_svg_icons_av_video_library__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_441_material_ui_lib_svg_icons_av_web__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_441_material_ui_lib_svg_icons_av_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_441_material_ui_lib_svg_icons_av_web__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_442_material_ui_lib_svg_icons_av_mic_none__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_442_material_ui_lib_svg_icons_av_mic_none___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_442_material_ui_lib_svg_icons_av_mic_none__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_443_material_ui_lib_svg_icons_av_shuffle__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_443_material_ui_lib_svg_icons_av_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_443_material_ui_lib_svg_icons_av_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_444_material_ui_lib_svg_icons_av_stop__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_444_material_ui_lib_svg_icons_av_stop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_444_material_ui_lib_svg_icons_av_stop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_445_material_ui_lib_svg_icons_av_play_circle_outline__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_445_material_ui_lib_svg_icons_av_play_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_445_material_ui_lib_svg_icons_av_play_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_446_material_ui_lib_svg_icons_av_videocam_off__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_446_material_ui_lib_svg_icons_av_videocam_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_446_material_ui_lib_svg_icons_av_videocam_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_447_material_ui_lib_svg_icons_av_queue__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_447_material_ui_lib_svg_icons_av_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_447_material_ui_lib_svg_icons_av_queue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_448_material_ui_lib_svg_icons_av_volume_down__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_448_material_ui_lib_svg_icons_av_volume_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_448_material_ui_lib_svg_icons_av_volume_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_449_material_ui_lib_svg_icons_av_videocam__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_449_material_ui_lib_svg_icons_av_videocam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_449_material_ui_lib_svg_icons_av_videocam__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_450_material_ui_lib_svg_icons_av_repeat__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_450_material_ui_lib_svg_icons_av_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_450_material_ui_lib_svg_icons_av_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_451_material_ui_lib_svg_icons_av_recent_actors__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_451_material_ui_lib_svg_icons_av_recent_actors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_451_material_ui_lib_svg_icons_av_recent_actors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_452_material_ui_lib_svg_icons_av_forward_5__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_452_material_ui_lib_svg_icons_av_forward_5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_452_material_ui_lib_svg_icons_av_forward_5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_453_material_ui_lib_svg_icons_av_loop__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_453_material_ui_lib_svg_icons_av_loop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_453_material_ui_lib_svg_icons_av_loop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_454_material_ui_lib_svg_icons_av_library_add__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_454_material_ui_lib_svg_icons_av_library_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_454_material_ui_lib_svg_icons_av_library_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_455_material_ui_lib_svg_icons_av_play_circle_filled__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_455_material_ui_lib_svg_icons_av_play_circle_filled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_455_material_ui_lib_svg_icons_av_play_circle_filled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_456_material_ui_lib_svg_icons_av_playlist_add__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_456_material_ui_lib_svg_icons_av_playlist_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_456_material_ui_lib_svg_icons_av_playlist_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_457_material_ui_lib_svg_icons_av_mic_off__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_457_material_ui_lib_svg_icons_av_mic_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_457_material_ui_lib_svg_icons_av_mic_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_458_material_ui_lib_svg_icons_av_replay_10__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_458_material_ui_lib_svg_icons_av_replay_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_458_material_ui_lib_svg_icons_av_replay_10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_459_material_ui_lib_svg_icons_av_av_timer__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_459_material_ui_lib_svg_icons_av_av_timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_459_material_ui_lib_svg_icons_av_av_timer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_460_material_ui_lib_svg_icons_av_volume_off__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_460_material_ui_lib_svg_icons_av_volume_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_460_material_ui_lib_svg_icons_av_volume_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_461_material_ui_lib_svg_icons_av_pause_circle_filled__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_461_material_ui_lib_svg_icons_av_pause_circle_filled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_461_material_ui_lib_svg_icons_av_pause_circle_filled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_462_material_ui_lib_svg_icons_av_airplay__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_462_material_ui_lib_svg_icons_av_airplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_462_material_ui_lib_svg_icons_av_airplay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_463_material_ui_lib_svg_icons_av_snooze__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_463_material_ui_lib_svg_icons_av_snooze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_463_material_ui_lib_svg_icons_av_snooze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_464_material_ui_lib_svg_icons_image_brush__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_464_material_ui_lib_svg_icons_image_brush___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_464_material_ui_lib_svg_icons_image_brush__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_465_material_ui_lib_svg_icons_image_looks_one__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_465_material_ui_lib_svg_icons_image_looks_one___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_465_material_ui_lib_svg_icons_image_looks_one__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_466_material_ui_lib_svg_icons_image_details__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_466_material_ui_lib_svg_icons_image_details___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_466_material_ui_lib_svg_icons_image_details__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_467_material_ui_lib_svg_icons_image_timer_3__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_467_material_ui_lib_svg_icons_image_timer_3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_467_material_ui_lib_svg_icons_image_timer_3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_468_material_ui_lib_svg_icons_image_filter_none__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_468_material_ui_lib_svg_icons_image_filter_none___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_468_material_ui_lib_svg_icons_image_filter_none__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_469_material_ui_lib_svg_icons_image_looks_3__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_469_material_ui_lib_svg_icons_image_looks_3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_469_material_ui_lib_svg_icons_image_looks_3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_470_material_ui_lib_svg_icons_image_filter_9__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_470_material_ui_lib_svg_icons_image_filter_9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_470_material_ui_lib_svg_icons_image_filter_9__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_471_material_ui_lib_svg_icons_image_filter__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_471_material_ui_lib_svg_icons_image_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_471_material_ui_lib_svg_icons_image_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_472_material_ui_lib_svg_icons_image_assistant_photo__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_472_material_ui_lib_svg_icons_image_assistant_photo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_472_material_ui_lib_svg_icons_image_assistant_photo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_473_material_ui_lib_svg_icons_image_wb_cloudy__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_473_material_ui_lib_svg_icons_image_wb_cloudy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_473_material_ui_lib_svg_icons_image_wb_cloudy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_474_material_ui_lib_svg_icons_image_brightness_1__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_474_material_ui_lib_svg_icons_image_brightness_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_474_material_ui_lib_svg_icons_image_brightness_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_475_material_ui_lib_svg_icons_image_panorama_wide_angle__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_475_material_ui_lib_svg_icons_image_panorama_wide_angle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_475_material_ui_lib_svg_icons_image_panorama_wide_angle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_476_material_ui_lib_svg_icons_image_panorama_fish_eye__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_476_material_ui_lib_svg_icons_image_panorama_fish_eye___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_476_material_ui_lib_svg_icons_image_panorama_fish_eye__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_477_material_ui_lib_svg_icons_image_portrait__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_477_material_ui_lib_svg_icons_image_portrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_477_material_ui_lib_svg_icons_image_portrait__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_478_material_ui_lib_svg_icons_image_brightness_5__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_478_material_ui_lib_svg_icons_image_brightness_5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_478_material_ui_lib_svg_icons_image_brightness_5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_479_material_ui_lib_svg_icons_image_exposure_zero__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_479_material_ui_lib_svg_icons_image_exposure_zero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_479_material_ui_lib_svg_icons_image_exposure_zero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_480_material_ui_lib_svg_icons_image_exposure_neg_2__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_480_material_ui_lib_svg_icons_image_exposure_neg_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_480_material_ui_lib_svg_icons_image_exposure_neg_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_481_material_ui_lib_svg_icons_image_wb_auto__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_481_material_ui_lib_svg_icons_image_wb_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_481_material_ui_lib_svg_icons_image_wb_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_482_material_ui_lib_svg_icons_image_hdr_off__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_482_material_ui_lib_svg_icons_image_hdr_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_482_material_ui_lib_svg_icons_image_hdr_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_483_material_ui_lib_svg_icons_image_nature_people__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_483_material_ui_lib_svg_icons_image_nature_people___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_483_material_ui_lib_svg_icons_image_nature_people__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_484_material_ui_lib_svg_icons_image_audiotrack__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_484_material_ui_lib_svg_icons_image_audiotrack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_484_material_ui_lib_svg_icons_image_audiotrack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_485_material_ui_lib_svg_icons_image_crop_portrait__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_485_material_ui_lib_svg_icons_image_crop_portrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_485_material_ui_lib_svg_icons_image_crop_portrait__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_486_material_ui_lib_svg_icons_image_colorize__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_486_material_ui_lib_svg_icons_image_colorize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_486_material_ui_lib_svg_icons_image_colorize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_487_material_ui_lib_svg_icons_image_compare__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_487_material_ui_lib_svg_icons_image_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_487_material_ui_lib_svg_icons_image_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_488_material_ui_lib_svg_icons_image_filter_2__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_488_material_ui_lib_svg_icons_image_filter_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_488_material_ui_lib_svg_icons_image_filter_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_489_material_ui_lib_svg_icons_image_tag_faces__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_489_material_ui_lib_svg_icons_image_tag_faces___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_489_material_ui_lib_svg_icons_image_tag_faces__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_490_material_ui_lib_svg_icons_image_blur_circular__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_490_material_ui_lib_svg_icons_image_blur_circular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_490_material_ui_lib_svg_icons_image_blur_circular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_491_material_ui_lib_svg_icons_image_lens__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_491_material_ui_lib_svg_icons_image_lens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_491_material_ui_lib_svg_icons_image_lens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_492_material_ui_lib_svg_icons_image_tune__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_492_material_ui_lib_svg_icons_image_tune___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_492_material_ui_lib_svg_icons_image_tune__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_493_material_ui_lib_svg_icons_image_view_comfy__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_493_material_ui_lib_svg_icons_image_view_comfy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_493_material_ui_lib_svg_icons_image_view_comfy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_494_material_ui_lib_svg_icons_image_camera_roll__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_494_material_ui_lib_svg_icons_image_camera_roll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_494_material_ui_lib_svg_icons_image_camera_roll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_495_material_ui_lib_svg_icons_image_center_focus_strong__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_495_material_ui_lib_svg_icons_image_center_focus_strong___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_495_material_ui_lib_svg_icons_image_center_focus_strong__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_496_material_ui_lib_svg_icons_image_flash_off__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_496_material_ui_lib_svg_icons_image_flash_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_496_material_ui_lib_svg_icons_image_flash_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_497_material_ui_lib_svg_icons_image_collections_bookmark__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_497_material_ui_lib_svg_icons_image_collections_bookmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_497_material_ui_lib_svg_icons_image_collections_bookmark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_498_material_ui_lib_svg_icons_image_photo_size_select_actual__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_498_material_ui_lib_svg_icons_image_photo_size_select_actual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_498_material_ui_lib_svg_icons_image_photo_size_select_actual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_499_material_ui_lib_svg_icons_image_image_aspect_ratio__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_499_material_ui_lib_svg_icons_image_image_aspect_ratio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_499_material_ui_lib_svg_icons_image_image_aspect_ratio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_500_material_ui_lib_svg_icons_image_filter_hdr__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_500_material_ui_lib_svg_icons_image_filter_hdr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_500_material_ui_lib_svg_icons_image_filter_hdr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_501_material_ui_lib_svg_icons_image_rotate_right__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_501_material_ui_lib_svg_icons_image_rotate_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_501_material_ui_lib_svg_icons_image_rotate_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_502_material_ui_lib_svg_icons_image_filter_tilt_shift__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_502_material_ui_lib_svg_icons_image_filter_tilt_shift___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_502_material_ui_lib_svg_icons_image_filter_tilt_shift__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_503_material_ui_lib_svg_icons_image_crop_free__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_503_material_ui_lib_svg_icons_image_crop_free___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_503_material_ui_lib_svg_icons_image_crop_free__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_504_material_ui_lib_svg_icons_image_style__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_504_material_ui_lib_svg_icons_image_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_504_material_ui_lib_svg_icons_image_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_505_material_ui_lib_svg_icons_image_nature__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_505_material_ui_lib_svg_icons_image_nature___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_505_material_ui_lib_svg_icons_image_nature__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_506_material_ui_lib_svg_icons_image_photo_size_select_large__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_506_material_ui_lib_svg_icons_image_photo_size_select_large___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_506_material_ui_lib_svg_icons_image_photo_size_select_large__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_507_material_ui_lib_svg_icons_image_adjust__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_507_material_ui_lib_svg_icons_image_adjust___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_507_material_ui_lib_svg_icons_image_adjust__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_508_material_ui_lib_svg_icons_image_flare__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_508_material_ui_lib_svg_icons_image_flare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_508_material_ui_lib_svg_icons_image_flare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_509_material_ui_lib_svg_icons_image_wb_iridescent__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_509_material_ui_lib_svg_icons_image_wb_iridescent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_509_material_ui_lib_svg_icons_image_wb_iridescent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_510_material_ui_lib_svg_icons_image_filter_drama__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_510_material_ui_lib_svg_icons_image_filter_drama___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_510_material_ui_lib_svg_icons_image_filter_drama__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_511_material_ui_lib_svg_icons_image_brightness_7__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_511_material_ui_lib_svg_icons_image_brightness_7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_511_material_ui_lib_svg_icons_image_brightness_7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_512_material_ui_lib_svg_icons_image_blur_on__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_512_material_ui_lib_svg_icons_image_blur_on___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_512_material_ui_lib_svg_icons_image_blur_on__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_513_material_ui_lib_svg_icons_image_timer_10__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_513_material_ui_lib_svg_icons_image_timer_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_513_material_ui_lib_svg_icons_image_timer_10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_514_material_ui_lib_svg_icons_image_flash_on__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_514_material_ui_lib_svg_icons_image_flash_on___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_514_material_ui_lib_svg_icons_image_flash_on__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_515_material_ui_lib_svg_icons_image_photo_library__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_515_material_ui_lib_svg_icons_image_photo_library___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_515_material_ui_lib_svg_icons_image_photo_library__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_516_material_ui_lib_svg_icons_image_blur_linear__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_516_material_ui_lib_svg_icons_image_blur_linear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_516_material_ui_lib_svg_icons_image_blur_linear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_517_material_ui_lib_svg_icons_image_camera__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_517_material_ui_lib_svg_icons_image_camera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_517_material_ui_lib_svg_icons_image_camera__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_518_material_ui_lib_svg_icons_image_timelapse__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_518_material_ui_lib_svg_icons_image_timelapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_518_material_ui_lib_svg_icons_image_timelapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_519_material_ui_lib_svg_icons_image_loupe__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_519_material_ui_lib_svg_icons_image_loupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_519_material_ui_lib_svg_icons_image_loupe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_520_material_ui_lib_svg_icons_image_exposure_plus_1__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_520_material_ui_lib_svg_icons_image_exposure_plus_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_520_material_ui_lib_svg_icons_image_exposure_plus_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_521_material_ui_lib_svg_icons_image_exposure_plus_2__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_521_material_ui_lib_svg_icons_image_exposure_plus_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_521_material_ui_lib_svg_icons_image_exposure_plus_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_522_material_ui_lib_svg_icons_image_flash_auto__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_522_material_ui_lib_svg_icons_image_flash_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_522_material_ui_lib_svg_icons_image_flash_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_523_material_ui_lib_svg_icons_image_palette__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_523_material_ui_lib_svg_icons_image_palette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_523_material_ui_lib_svg_icons_image_palette__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_524_material_ui_lib_svg_icons_image_crop_din__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_524_material_ui_lib_svg_icons_image_crop_din___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_524_material_ui_lib_svg_icons_image_crop_din__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_525_material_ui_lib_svg_icons_image_crop_16_9__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_525_material_ui_lib_svg_icons_image_crop_16_9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_525_material_ui_lib_svg_icons_image_crop_16_9__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_526_material_ui_lib_svg_icons_image_slideshow__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_526_material_ui_lib_svg_icons_image_slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_526_material_ui_lib_svg_icons_image_slideshow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_527_material_ui_lib_svg_icons_image_filter_1__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_527_material_ui_lib_svg_icons_image_filter_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_527_material_ui_lib_svg_icons_image_filter_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_528_material_ui_lib_svg_icons_image_crop_7_5__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_528_material_ui_lib_svg_icons_image_crop_7_5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_528_material_ui_lib_svg_icons_image_crop_7_5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_529_material_ui_lib_svg_icons_image_music_note__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_529_material_ui_lib_svg_icons_image_music_note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_529_material_ui_lib_svg_icons_image_music_note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_530_material_ui_lib_svg_icons_image_crop_landscape__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_530_material_ui_lib_svg_icons_image_crop_landscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_530_material_ui_lib_svg_icons_image_crop_landscape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_531_material_ui_lib_svg_icons_image_crop_3_2__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_531_material_ui_lib_svg_icons_image_crop_3_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_531_material_ui_lib_svg_icons_image_crop_3_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_532_material_ui_lib_svg_icons_image_timer__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_532_material_ui_lib_svg_icons_image_timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_532_material_ui_lib_svg_icons_image_timer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_533_material_ui_lib_svg_icons_image_wb_incandescent__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_533_material_ui_lib_svg_icons_image_wb_incandescent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_533_material_ui_lib_svg_icons_image_wb_incandescent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_534_material_ui_lib_svg_icons_image_looks_5__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_534_material_ui_lib_svg_icons_image_looks_5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_534_material_ui_lib_svg_icons_image_looks_5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_535_material_ui_lib_svg_icons_image_gradient__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_535_material_ui_lib_svg_icons_image_gradient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_535_material_ui_lib_svg_icons_image_gradient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_536_material_ui_lib_svg_icons_image_view_compact__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_536_material_ui_lib_svg_icons_image_view_compact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_536_material_ui_lib_svg_icons_image_view_compact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_537_material_ui_lib_svg_icons_image_center_focus_weak__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_537_material_ui_lib_svg_icons_image_center_focus_weak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_537_material_ui_lib_svg_icons_image_center_focus_weak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_538_material_ui_lib_svg_icons_image_looks__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_538_material_ui_lib_svg_icons_image_looks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_538_material_ui_lib_svg_icons_image_looks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_539_material_ui_lib_svg_icons_image_collections__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_539_material_ui_lib_svg_icons_image_collections___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_539_material_ui_lib_svg_icons_image_collections__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_540_material_ui_lib_svg_icons_image_monochrome_photos__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_540_material_ui_lib_svg_icons_image_monochrome_photos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_540_material_ui_lib_svg_icons_image_monochrome_photos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_541_material_ui_lib_svg_icons_image_blur_off__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_541_material_ui_lib_svg_icons_image_blur_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_541_material_ui_lib_svg_icons_image_blur_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_542_material_ui_lib_svg_icons_image_photo_size_select_small__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_542_material_ui_lib_svg_icons_image_photo_size_select_small___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_542_material_ui_lib_svg_icons_image_photo_size_select_small__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_543_material_ui_lib_svg_icons_image_filter_6__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_543_material_ui_lib_svg_icons_image_filter_6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_543_material_ui_lib_svg_icons_image_filter_6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_544_material_ui_lib_svg_icons_image_camera_rear__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_544_material_ui_lib_svg_icons_image_camera_rear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_544_material_ui_lib_svg_icons_image_camera_rear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_545_material_ui_lib_svg_icons_image_rotate_left__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_545_material_ui_lib_svg_icons_image_rotate_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_545_material_ui_lib_svg_icons_image_rotate_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_546_material_ui_lib_svg_icons_image_filter_7__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_546_material_ui_lib_svg_icons_image_filter_7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_546_material_ui_lib_svg_icons_image_filter_7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_547_material_ui_lib_svg_icons_image_edit__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_547_material_ui_lib_svg_icons_image_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_547_material_ui_lib_svg_icons_image_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_548_material_ui_lib_svg_icons_image_filter_9_plus__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_548_material_ui_lib_svg_icons_image_filter_9_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_548_material_ui_lib_svg_icons_image_filter_9_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_549_material_ui_lib_svg_icons_image_leak_remove__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_549_material_ui_lib_svg_icons_image_leak_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_549_material_ui_lib_svg_icons_image_leak_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_550_material_ui_lib_svg_icons_image_texture__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_550_material_ui_lib_svg_icons_image_texture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_550_material_ui_lib_svg_icons_image_texture__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_551_material_ui_lib_svg_icons_image_brightness_6__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_551_material_ui_lib_svg_icons_image_brightness_6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_551_material_ui_lib_svg_icons_image_brightness_6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_552_material_ui_lib_svg_icons_image_crop_original__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_552_material_ui_lib_svg_icons_image_crop_original___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_552_material_ui_lib_svg_icons_image_crop_original__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_553_material_ui_lib_svg_icons_image_navigate_next__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_553_material_ui_lib_svg_icons_image_navigate_next___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_553_material_ui_lib_svg_icons_image_navigate_next__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_554_material_ui_lib_svg_icons_image_filter_center_focus__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_554_material_ui_lib_svg_icons_image_filter_center_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_554_material_ui_lib_svg_icons_image_filter_center_focus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_555_material_ui_lib_svg_icons_image_assistant__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_555_material_ui_lib_svg_icons_image_assistant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_555_material_ui_lib_svg_icons_image_assistant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_556_material_ui_lib_svg_icons_image_flip__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_556_material_ui_lib_svg_icons_image_flip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_556_material_ui_lib_svg_icons_image_flip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_557_material_ui_lib_svg_icons_image_crop_square__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_557_material_ui_lib_svg_icons_image_crop_square___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_557_material_ui_lib_svg_icons_image_crop_square__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_558_material_ui_lib_svg_icons_image_vignette__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_558_material_ui_lib_svg_icons_image_vignette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_558_material_ui_lib_svg_icons_image_vignette__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_559_material_ui_lib_svg_icons_image_exposure__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_559_material_ui_lib_svg_icons_image_exposure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_559_material_ui_lib_svg_icons_image_exposure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_560_material_ui_lib_svg_icons_image_panorama_horizontal__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_560_material_ui_lib_svg_icons_image_panorama_horizontal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_560_material_ui_lib_svg_icons_image_panorama_horizontal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_561_material_ui_lib_svg_icons_image_panorama__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_561_material_ui_lib_svg_icons_image_panorama___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_561_material_ui_lib_svg_icons_image_panorama__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_562_material_ui_lib_svg_icons_image_crop__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_562_material_ui_lib_svg_icons_image_crop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_562_material_ui_lib_svg_icons_image_crop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_563_material_ui_lib_svg_icons_image_control_point__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_563_material_ui_lib_svg_icons_image_control_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_563_material_ui_lib_svg_icons_image_control_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_564_material_ui_lib_svg_icons_image_rotate_90_degrees_ccw__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_564_material_ui_lib_svg_icons_image_rotate_90_degrees_ccw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_564_material_ui_lib_svg_icons_image_rotate_90_degrees_ccw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_565_material_ui_lib_svg_icons_image_filter_b_and_w__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_565_material_ui_lib_svg_icons_image_filter_b_and_w___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_565_material_ui_lib_svg_icons_image_filter_b_and_w__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_566_material_ui_lib_svg_icons_image_grid_off__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_566_material_ui_lib_svg_icons_image_grid_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_566_material_ui_lib_svg_icons_image_grid_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_567_material_ui_lib_svg_icons_image_brightness_3__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_567_material_ui_lib_svg_icons_image_brightness_3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_567_material_ui_lib_svg_icons_image_brightness_3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_568_material_ui_lib_svg_icons_image_filter_8__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_568_material_ui_lib_svg_icons_image_filter_8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_568_material_ui_lib_svg_icons_image_filter_8__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_569_material_ui_lib_svg_icons_image_leak_add__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_569_material_ui_lib_svg_icons_image_leak_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_569_material_ui_lib_svg_icons_image_leak_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_570_material_ui_lib_svg_icons_image_remove_red_eye__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_570_material_ui_lib_svg_icons_image_remove_red_eye___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_570_material_ui_lib_svg_icons_image_remove_red_eye__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_571_material_ui_lib_svg_icons_image_photo_camera__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_571_material_ui_lib_svg_icons_image_photo_camera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_571_material_ui_lib_svg_icons_image_photo_camera__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_572_material_ui_lib_svg_icons_image_straighten__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_572_material_ui_lib_svg_icons_image_straighten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_572_material_ui_lib_svg_icons_image_straighten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_573_material_ui_lib_svg_icons_image_filter_4__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_573_material_ui_lib_svg_icons_image_filter_4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_573_material_ui_lib_svg_icons_image_filter_4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_574_material_ui_lib_svg_icons_image_grid_on__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_574_material_ui_lib_svg_icons_image_grid_on___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_574_material_ui_lib_svg_icons_image_grid_on__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_575_material_ui_lib_svg_icons_image_filter_3__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_575_material_ui_lib_svg_icons_image_filter_3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_575_material_ui_lib_svg_icons_image_filter_3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_576_material_ui_lib_svg_icons_image_landscape__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_576_material_ui_lib_svg_icons_image_landscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_576_material_ui_lib_svg_icons_image_landscape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_577_material_ui_lib_svg_icons_image_filter_frames__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_577_material_ui_lib_svg_icons_image_filter_frames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_577_material_ui_lib_svg_icons_image_filter_frames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_578_material_ui_lib_svg_icons_image_iso__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_578_material_ui_lib_svg_icons_image_iso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_578_material_ui_lib_svg_icons_image_iso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_579_material_ui_lib_svg_icons_image_tonality__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_579_material_ui_lib_svg_icons_image_tonality___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_579_material_ui_lib_svg_icons_image_tonality__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_580_material_ui_lib_svg_icons_image_dehaze__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_580_material_ui_lib_svg_icons_image_dehaze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_580_material_ui_lib_svg_icons_image_dehaze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_581_material_ui_lib_svg_icons_image_hdr_strong__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_581_material_ui_lib_svg_icons_image_hdr_strong___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_581_material_ui_lib_svg_icons_image_hdr_strong__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_582_material_ui_lib_svg_icons_image_healing__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_582_material_ui_lib_svg_icons_image_healing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_582_material_ui_lib_svg_icons_image_healing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_583_material_ui_lib_svg_icons_image_hdr_weak__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_583_material_ui_lib_svg_icons_image_hdr_weak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_583_material_ui_lib_svg_icons_image_hdr_weak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_584_material_ui_lib_svg_icons_image_filter_vintage__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_584_material_ui_lib_svg_icons_image_filter_vintage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_584_material_ui_lib_svg_icons_image_filter_vintage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_585_material_ui_lib_svg_icons_image_filter_5__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_585_material_ui_lib_svg_icons_image_filter_5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_585_material_ui_lib_svg_icons_image_filter_5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_586_material_ui_lib_svg_icons_image_image__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_586_material_ui_lib_svg_icons_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_586_material_ui_lib_svg_icons_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_587_material_ui_lib_svg_icons_image_color_lens__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_587_material_ui_lib_svg_icons_image_color_lens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_587_material_ui_lib_svg_icons_image_color_lens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_588_material_ui_lib_svg_icons_image_looks_4__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_588_material_ui_lib_svg_icons_image_looks_4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_588_material_ui_lib_svg_icons_image_looks_4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_589_material_ui_lib_svg_icons_image_panorama_vertical__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_589_material_ui_lib_svg_icons_image_panorama_vertical___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_589_material_ui_lib_svg_icons_image_panorama_vertical__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_590_material_ui_lib_svg_icons_image_brightness_4__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_590_material_ui_lib_svg_icons_image_brightness_4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_590_material_ui_lib_svg_icons_image_brightness_4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_591_material_ui_lib_svg_icons_image_looks_6__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_591_material_ui_lib_svg_icons_image_looks_6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_591_material_ui_lib_svg_icons_image_looks_6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_592_material_ui_lib_svg_icons_image_control_point_duplicate__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_592_material_ui_lib_svg_icons_image_control_point_duplicate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_592_material_ui_lib_svg_icons_image_control_point_duplicate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_593_material_ui_lib_svg_icons_image_crop_5_4__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_593_material_ui_lib_svg_icons_image_crop_5_4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_593_material_ui_lib_svg_icons_image_crop_5_4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_594_material_ui_lib_svg_icons_image_hdr_on__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_594_material_ui_lib_svg_icons_image_hdr_on___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_594_material_ui_lib_svg_icons_image_hdr_on__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_595_material_ui_lib_svg_icons_image_photo_album__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_595_material_ui_lib_svg_icons_image_photo_album___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_595_material_ui_lib_svg_icons_image_photo_album__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_596_material_ui_lib_svg_icons_image_navigate_before__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_596_material_ui_lib_svg_icons_image_navigate_before___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_596_material_ui_lib_svg_icons_image_navigate_before__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_597_material_ui_lib_svg_icons_image_switch_video__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_597_material_ui_lib_svg_icons_image_switch_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_597_material_ui_lib_svg_icons_image_switch_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_598_material_ui_lib_svg_icons_image_wb_sunny__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_598_material_ui_lib_svg_icons_image_wb_sunny___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_598_material_ui_lib_svg_icons_image_wb_sunny__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_599_material_ui_lib_svg_icons_image_add_to_photos__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_599_material_ui_lib_svg_icons_image_add_to_photos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_599_material_ui_lib_svg_icons_image_add_to_photos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_600_material_ui_lib_svg_icons_image_photo__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_600_material_ui_lib_svg_icons_image_photo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_600_material_ui_lib_svg_icons_image_photo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_601_material_ui_lib_svg_icons_image_broken_image__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_601_material_ui_lib_svg_icons_image_broken_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_601_material_ui_lib_svg_icons_image_broken_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_602_material_ui_lib_svg_icons_image_picture_as_pdf__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_602_material_ui_lib_svg_icons_image_picture_as_pdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_602_material_ui_lib_svg_icons_image_picture_as_pdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_603_material_ui_lib_svg_icons_image_transform__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_603_material_ui_lib_svg_icons_image_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_603_material_ui_lib_svg_icons_image_transform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_604_material_ui_lib_svg_icons_image_camera_alt__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_604_material_ui_lib_svg_icons_image_camera_alt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_604_material_ui_lib_svg_icons_image_camera_alt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_605_material_ui_lib_svg_icons_image_brightness_2__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_605_material_ui_lib_svg_icons_image_brightness_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_605_material_ui_lib_svg_icons_image_brightness_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_606_material_ui_lib_svg_icons_image_movie_creation__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_606_material_ui_lib_svg_icons_image_movie_creation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_606_material_ui_lib_svg_icons_image_movie_creation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_607_material_ui_lib_svg_icons_image_grain__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_607_material_ui_lib_svg_icons_image_grain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_607_material_ui_lib_svg_icons_image_grain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_608_material_ui_lib_svg_icons_image_looks_two__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_608_material_ui_lib_svg_icons_image_looks_two___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_608_material_ui_lib_svg_icons_image_looks_two__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_609_material_ui_lib_svg_icons_image_timer_off__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_609_material_ui_lib_svg_icons_image_timer_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_609_material_ui_lib_svg_icons_image_timer_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_610_material_ui_lib_svg_icons_image_exposure_neg_1__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_610_material_ui_lib_svg_icons_image_exposure_neg_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_610_material_ui_lib_svg_icons_image_exposure_neg_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_611_material_ui_lib_svg_icons_image_camera_front__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_611_material_ui_lib_svg_icons_image_camera_front___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_611_material_ui_lib_svg_icons_image_camera_front__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_612_material_ui_lib_svg_icons_image_switch_camera__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_612_material_ui_lib_svg_icons_image_switch_camera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_612_material_ui_lib_svg_icons_image_switch_camera__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_613_material_ui_lib_svg_icons_content_forward__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_613_material_ui_lib_svg_icons_content_forward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_613_material_ui_lib_svg_icons_content_forward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_614_material_ui_lib_svg_icons_content_select_all__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_614_material_ui_lib_svg_icons_content_select_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_614_material_ui_lib_svg_icons_content_select_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_615_material_ui_lib_svg_icons_content_drafts__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_615_material_ui_lib_svg_icons_content_drafts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_615_material_ui_lib_svg_icons_content_drafts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_616_material_ui_lib_svg_icons_content_content_copy__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_616_material_ui_lib_svg_icons_content_content_copy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_616_material_ui_lib_svg_icons_content_content_copy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_617_material_ui_lib_svg_icons_content_flag__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_617_material_ui_lib_svg_icons_content_flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_617_material_ui_lib_svg_icons_content_flag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_618_material_ui_lib_svg_icons_content_text_format__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_618_material_ui_lib_svg_icons_content_text_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_618_material_ui_lib_svg_icons_content_text_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_619_material_ui_lib_svg_icons_content_reply_all__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_619_material_ui_lib_svg_icons_content_reply_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_619_material_ui_lib_svg_icons_content_reply_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_620_material_ui_lib_svg_icons_content_reply__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_620_material_ui_lib_svg_icons_content_reply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_620_material_ui_lib_svg_icons_content_reply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_621_material_ui_lib_svg_icons_content_remove_circle__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_621_material_ui_lib_svg_icons_content_remove_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_621_material_ui_lib_svg_icons_content_remove_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_622_material_ui_lib_svg_icons_content_add_circle__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_622_material_ui_lib_svg_icons_content_add_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_622_material_ui_lib_svg_icons_content_add_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_623_material_ui_lib_svg_icons_content_link__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_623_material_ui_lib_svg_icons_content_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_623_material_ui_lib_svg_icons_content_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_624_material_ui_lib_svg_icons_content_mail__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_624_material_ui_lib_svg_icons_content_mail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_624_material_ui_lib_svg_icons_content_mail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_625_material_ui_lib_svg_icons_content_archive__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_625_material_ui_lib_svg_icons_content_archive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_625_material_ui_lib_svg_icons_content_archive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_626_material_ui_lib_svg_icons_content_save__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_626_material_ui_lib_svg_icons_content_save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_626_material_ui_lib_svg_icons_content_save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_627_material_ui_lib_svg_icons_content_remove__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_627_material_ui_lib_svg_icons_content_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_627_material_ui_lib_svg_icons_content_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_628_material_ui_lib_svg_icons_content_font_download__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_628_material_ui_lib_svg_icons_content_font_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_628_material_ui_lib_svg_icons_content_font_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_629_material_ui_lib_svg_icons_content_remove_circle_outline__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_629_material_ui_lib_svg_icons_content_remove_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_629_material_ui_lib_svg_icons_content_remove_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_630_material_ui_lib_svg_icons_content_create__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_630_material_ui_lib_svg_icons_content_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_630_material_ui_lib_svg_icons_content_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_631_material_ui_lib_svg_icons_content_clear__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_631_material_ui_lib_svg_icons_content_clear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_631_material_ui_lib_svg_icons_content_clear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_632_material_ui_lib_svg_icons_content_content_cut__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_632_material_ui_lib_svg_icons_content_content_cut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_632_material_ui_lib_svg_icons_content_content_cut__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_633_material_ui_lib_svg_icons_content_redo__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_633_material_ui_lib_svg_icons_content_redo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_633_material_ui_lib_svg_icons_content_redo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_634_material_ui_lib_svg_icons_content_markunread__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_634_material_ui_lib_svg_icons_content_markunread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_634_material_ui_lib_svg_icons_content_markunread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_635_material_ui_lib_svg_icons_content_content_paste__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_635_material_ui_lib_svg_icons_content_content_paste___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_635_material_ui_lib_svg_icons_content_content_paste__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_636_material_ui_lib_svg_icons_content_backspace__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_636_material_ui_lib_svg_icons_content_backspace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_636_material_ui_lib_svg_icons_content_backspace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_637_material_ui_lib_svg_icons_content_report__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_637_material_ui_lib_svg_icons_content_report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_637_material_ui_lib_svg_icons_content_report__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_638_material_ui_lib_svg_icons_content_sort__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_638_material_ui_lib_svg_icons_content_sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_638_material_ui_lib_svg_icons_content_sort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_639_material_ui_lib_svg_icons_content_inbox__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_639_material_ui_lib_svg_icons_content_inbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_639_material_ui_lib_svg_icons_content_inbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_640_material_ui_lib_svg_icons_content_gesture__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_640_material_ui_lib_svg_icons_content_gesture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_640_material_ui_lib_svg_icons_content_gesture__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_641_material_ui_lib_svg_icons_content_block__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_641_material_ui_lib_svg_icons_content_block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_641_material_ui_lib_svg_icons_content_block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_642_material_ui_lib_svg_icons_content_add__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_642_material_ui_lib_svg_icons_content_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_642_material_ui_lib_svg_icons_content_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_643_material_ui_lib_svg_icons_content_undo__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_643_material_ui_lib_svg_icons_content_undo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_643_material_ui_lib_svg_icons_content_undo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_644_material_ui_lib_svg_icons_content_add_box__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_644_material_ui_lib_svg_icons_content_add_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_644_material_ui_lib_svg_icons_content_add_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_645_material_ui_lib_svg_icons_content_add_circle_outline__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_645_material_ui_lib_svg_icons_content_add_circle_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_645_material_ui_lib_svg_icons_content_add_circle_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_646_material_ui_lib_svg_icons_content_filter_list__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_646_material_ui_lib_svg_icons_content_filter_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_646_material_ui_lib_svg_icons_content_filter_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_647_material_ui_lib_svg_icons_content_send__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_647_material_ui_lib_svg_icons_content_send___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_647_material_ui_lib_svg_icons_content_send__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_648_material_ui_lib_svg_icons_notification_sync_problem__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_648_material_ui_lib_svg_icons_notification_sync_problem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_648_material_ui_lib_svg_icons_notification_sync_problem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_649_material_ui_lib_svg_icons_notification_airline_seat_individual_suite__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_649_material_ui_lib_svg_icons_notification_airline_seat_individual_suite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_649_material_ui_lib_svg_icons_notification_airline_seat_individual_suite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_650_material_ui_lib_svg_icons_notification_vpn_lock__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_650_material_ui_lib_svg_icons_notification_vpn_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_650_material_ui_lib_svg_icons_notification_vpn_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_651_material_ui_lib_svg_icons_notification_airline_seat_legroom_extra__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_651_material_ui_lib_svg_icons_notification_airline_seat_legroom_extra___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_651_material_ui_lib_svg_icons_notification_airline_seat_legroom_extra__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_652_material_ui_lib_svg_icons_notification_wifi__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_652_material_ui_lib_svg_icons_notification_wifi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_652_material_ui_lib_svg_icons_notification_wifi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_653_material_ui_lib_svg_icons_notification_tap_and_play__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_653_material_ui_lib_svg_icons_notification_tap_and_play___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_653_material_ui_lib_svg_icons_notification_tap_and_play__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_654_material_ui_lib_svg_icons_notification_airline_seat_flat_angled__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_654_material_ui_lib_svg_icons_notification_airline_seat_flat_angled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_654_material_ui_lib_svg_icons_notification_airline_seat_flat_angled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_655_material_ui_lib_svg_icons_notification_wc__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_655_material_ui_lib_svg_icons_notification_wc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_655_material_ui_lib_svg_icons_notification_wc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_656_material_ui_lib_svg_icons_notification_sms__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_656_material_ui_lib_svg_icons_notification_sms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_656_material_ui_lib_svg_icons_notification_sms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_657_material_ui_lib_svg_icons_notification_bluetooth_audio__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_657_material_ui_lib_svg_icons_notification_bluetooth_audio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_657_material_ui_lib_svg_icons_notification_bluetooth_audio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_658_material_ui_lib_svg_icons_notification_folder_special__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_658_material_ui_lib_svg_icons_notification_folder_special___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_658_material_ui_lib_svg_icons_notification_folder_special__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_659_material_ui_lib_svg_icons_notification_sim_card_alert__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_659_material_ui_lib_svg_icons_notification_sim_card_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_659_material_ui_lib_svg_icons_notification_sim_card_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_660_material_ui_lib_svg_icons_notification_event_note__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_660_material_ui_lib_svg_icons_notification_event_note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_660_material_ui_lib_svg_icons_notification_event_note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_661_material_ui_lib_svg_icons_notification_personal_video__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_661_material_ui_lib_svg_icons_notification_personal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_661_material_ui_lib_svg_icons_notification_personal_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_662_material_ui_lib_svg_icons_notification_live_tv__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_662_material_ui_lib_svg_icons_notification_live_tv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_662_material_ui_lib_svg_icons_notification_live_tv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_663_material_ui_lib_svg_icons_notification_time_to_leave__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_663_material_ui_lib_svg_icons_notification_time_to_leave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_663_material_ui_lib_svg_icons_notification_time_to_leave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_664_material_ui_lib_svg_icons_notification_adb__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_664_material_ui_lib_svg_icons_notification_adb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_664_material_ui_lib_svg_icons_notification_adb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_665_material_ui_lib_svg_icons_notification_confirmation_number__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_665_material_ui_lib_svg_icons_notification_confirmation_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_665_material_ui_lib_svg_icons_notification_confirmation_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_666_material_ui_lib_svg_icons_notification_airline_seat_flat__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_666_material_ui_lib_svg_icons_notification_airline_seat_flat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_666_material_ui_lib_svg_icons_notification_airline_seat_flat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_667_material_ui_lib_svg_icons_notification_sync__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_667_material_ui_lib_svg_icons_notification_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_667_material_ui_lib_svg_icons_notification_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_668_material_ui_lib_svg_icons_notification_voice_chat__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_668_material_ui_lib_svg_icons_notification_voice_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_668_material_ui_lib_svg_icons_notification_voice_chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_669_material_ui_lib_svg_icons_notification_phone_locked__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_669_material_ui_lib_svg_icons_notification_phone_locked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_669_material_ui_lib_svg_icons_notification_phone_locked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_670_material_ui_lib_svg_icons_notification_phone_forwarded__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_670_material_ui_lib_svg_icons_notification_phone_forwarded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_670_material_ui_lib_svg_icons_notification_phone_forwarded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_671_material_ui_lib_svg_icons_notification_system_update__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_671_material_ui_lib_svg_icons_notification_system_update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_671_material_ui_lib_svg_icons_notification_system_update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_672_material_ui_lib_svg_icons_notification_more__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_672_material_ui_lib_svg_icons_notification_more___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_672_material_ui_lib_svg_icons_notification_more__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_673_material_ui_lib_svg_icons_notification_mms__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_673_material_ui_lib_svg_icons_notification_mms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_673_material_ui_lib_svg_icons_notification_mms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_674_material_ui_lib_svg_icons_notification_phone_in_talk__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_674_material_ui_lib_svg_icons_notification_phone_in_talk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_674_material_ui_lib_svg_icons_notification_phone_in_talk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_675_material_ui_lib_svg_icons_notification_airline_seat_recline_extra__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_675_material_ui_lib_svg_icons_notification_airline_seat_recline_extra___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_675_material_ui_lib_svg_icons_notification_airline_seat_recline_extra__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_676_material_ui_lib_svg_icons_notification_phone_bluetooth_speaker__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_676_material_ui_lib_svg_icons_notification_phone_bluetooth_speaker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_676_material_ui_lib_svg_icons_notification_phone_bluetooth_speaker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_677_material_ui_lib_svg_icons_notification_airline_seat_legroom_normal__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_677_material_ui_lib_svg_icons_notification_airline_seat_legroom_normal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_677_material_ui_lib_svg_icons_notification_airline_seat_legroom_normal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_678_material_ui_lib_svg_icons_notification_do_not_disturb_alt__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_678_material_ui_lib_svg_icons_notification_do_not_disturb_alt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_678_material_ui_lib_svg_icons_notification_do_not_disturb_alt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_679_material_ui_lib_svg_icons_notification_ondemand_video__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_679_material_ui_lib_svg_icons_notification_ondemand_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_679_material_ui_lib_svg_icons_notification_ondemand_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_680_material_ui_lib_svg_icons_notification_event_busy__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_680_material_ui_lib_svg_icons_notification_event_busy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_680_material_ui_lib_svg_icons_notification_event_busy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_681_material_ui_lib_svg_icons_notification_do_not_disturb__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_681_material_ui_lib_svg_icons_notification_do_not_disturb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_681_material_ui_lib_svg_icons_notification_do_not_disturb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_682_material_ui_lib_svg_icons_notification_drive_eta__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_682_material_ui_lib_svg_icons_notification_drive_eta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_682_material_ui_lib_svg_icons_notification_drive_eta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_683_material_ui_lib_svg_icons_notification_airline_seat_legroom_reduced__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_683_material_ui_lib_svg_icons_notification_airline_seat_legroom_reduced___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_683_material_ui_lib_svg_icons_notification_airline_seat_legroom_reduced__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_684_material_ui_lib_svg_icons_notification_sync_disabled__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_684_material_ui_lib_svg_icons_notification_sync_disabled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_684_material_ui_lib_svg_icons_notification_sync_disabled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_685_material_ui_lib_svg_icons_notification_phone_missed__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_685_material_ui_lib_svg_icons_notification_phone_missed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_685_material_ui_lib_svg_icons_notification_phone_missed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_686_material_ui_lib_svg_icons_notification_event_available__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_686_material_ui_lib_svg_icons_notification_event_available___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_686_material_ui_lib_svg_icons_notification_event_available__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_687_material_ui_lib_svg_icons_notification_airline_seat_recline_normal__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_687_material_ui_lib_svg_icons_notification_airline_seat_recline_normal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_687_material_ui_lib_svg_icons_notification_airline_seat_recline_normal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_688_material_ui_lib_svg_icons_notification_vibration__ = __webpack_require__(1762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_688_material_ui_lib_svg_icons_notification_vibration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_688_material_ui_lib_svg_icons_notification_vibration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_689_material_ui_lib_svg_icons_notification_power__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_689_material_ui_lib_svg_icons_notification_power___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_689_material_ui_lib_svg_icons_notification_power__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_690_material_ui_lib_svg_icons_notification_sd_card__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_690_material_ui_lib_svg_icons_notification_sd_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_690_material_ui_lib_svg_icons_notification_sd_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_691_material_ui_lib_svg_icons_notification_phone_paused__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_691_material_ui_lib_svg_icons_notification_phone_paused___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_691_material_ui_lib_svg_icons_notification_phone_paused__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_692_material_ui_lib_svg_icons_notification_disc_full__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_692_material_ui_lib_svg_icons_notification_disc_full___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_692_material_ui_lib_svg_icons_notification_disc_full__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_693_material_ui_lib_svg_icons_notification_sms_failed__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_693_material_ui_lib_svg_icons_notification_sms_failed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_693_material_ui_lib_svg_icons_notification_sms_failed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_694_material_ui_lib_svg_icons_notification_network_locked__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_694_material_ui_lib_svg_icons_notification_network_locked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_694_material_ui_lib_svg_icons_notification_network_locked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_695_material_ui_lib_svg_icons_hardware_power_input__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_695_material_ui_lib_svg_icons_hardware_power_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_695_material_ui_lib_svg_icons_hardware_power_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_696_material_ui_lib_svg_icons_hardware_watch__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_696_material_ui_lib_svg_icons_hardware_watch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_696_material_ui_lib_svg_icons_hardware_watch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_697_material_ui_lib_svg_icons_hardware_gamepad__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_697_material_ui_lib_svg_icons_hardware_gamepad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_697_material_ui_lib_svg_icons_hardware_gamepad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_698_material_ui_lib_svg_icons_hardware_laptop__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_698_material_ui_lib_svg_icons_hardware_laptop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_698_material_ui_lib_svg_icons_hardware_laptop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_699_material_ui_lib_svg_icons_hardware_keyboard_backspace__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_699_material_ui_lib_svg_icons_hardware_keyboard_backspace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_699_material_ui_lib_svg_icons_hardware_keyboard_backspace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_700_material_ui_lib_svg_icons_hardware_smartphone__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_700_material_ui_lib_svg_icons_hardware_smartphone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_700_material_ui_lib_svg_icons_hardware_smartphone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_701_material_ui_lib_svg_icons_hardware_phonelink_off__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_701_material_ui_lib_svg_icons_hardware_phonelink_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_701_material_ui_lib_svg_icons_hardware_phonelink_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_702_material_ui_lib_svg_icons_hardware_phone_android__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_702_material_ui_lib_svg_icons_hardware_phone_android___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_702_material_ui_lib_svg_icons_hardware_phone_android__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_703_material_ui_lib_svg_icons_hardware_mouse__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_703_material_ui_lib_svg_icons_hardware_mouse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_703_material_ui_lib_svg_icons_hardware_mouse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_704_material_ui_lib_svg_icons_hardware_laptop_chromebook__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_704_material_ui_lib_svg_icons_hardware_laptop_chromebook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_704_material_ui_lib_svg_icons_hardware_laptop_chromebook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_705_material_ui_lib_svg_icons_hardware_security__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_705_material_ui_lib_svg_icons_hardware_security___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_705_material_ui_lib_svg_icons_hardware_security__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_706_material_ui_lib_svg_icons_hardware_tv__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_706_material_ui_lib_svg_icons_hardware_tv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_706_material_ui_lib_svg_icons_hardware_tv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_707_material_ui_lib_svg_icons_hardware_speaker_group__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_707_material_ui_lib_svg_icons_hardware_speaker_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_707_material_ui_lib_svg_icons_hardware_speaker_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_708_material_ui_lib_svg_icons_hardware_keyboard_arrow_up__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_708_material_ui_lib_svg_icons_hardware_keyboard_arrow_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_708_material_ui_lib_svg_icons_hardware_keyboard_arrow_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_709_material_ui_lib_svg_icons_hardware_sim_card__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_709_material_ui_lib_svg_icons_hardware_sim_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_709_material_ui_lib_svg_icons_hardware_sim_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_710_material_ui_lib_svg_icons_hardware_cast_connected__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_710_material_ui_lib_svg_icons_hardware_cast_connected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_710_material_ui_lib_svg_icons_hardware_cast_connected__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_711_material_ui_lib_svg_icons_hardware_memory__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_711_material_ui_lib_svg_icons_hardware_memory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_711_material_ui_lib_svg_icons_hardware_memory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_712_material_ui_lib_svg_icons_hardware_desktop_mac__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_712_material_ui_lib_svg_icons_hardware_desktop_mac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_712_material_ui_lib_svg_icons_hardware_desktop_mac__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_713_material_ui_lib_svg_icons_hardware_desktop_windows__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_713_material_ui_lib_svg_icons_hardware_desktop_windows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_713_material_ui_lib_svg_icons_hardware_desktop_windows__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_714_material_ui_lib_svg_icons_hardware_speaker__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_714_material_ui_lib_svg_icons_hardware_speaker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_714_material_ui_lib_svg_icons_hardware_speaker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_715_material_ui_lib_svg_icons_hardware_toys__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_715_material_ui_lib_svg_icons_hardware_toys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_715_material_ui_lib_svg_icons_hardware_toys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_716_material_ui_lib_svg_icons_hardware_keyboard_hide__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_716_material_ui_lib_svg_icons_hardware_keyboard_hide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_716_material_ui_lib_svg_icons_hardware_keyboard_hide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_717_material_ui_lib_svg_icons_hardware_router__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_717_material_ui_lib_svg_icons_hardware_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_717_material_ui_lib_svg_icons_hardware_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_718_material_ui_lib_svg_icons_hardware_tablet_android__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_718_material_ui_lib_svg_icons_hardware_tablet_android___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_718_material_ui_lib_svg_icons_hardware_tablet_android__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_719_material_ui_lib_svg_icons_hardware_headset__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_719_material_ui_lib_svg_icons_hardware_headset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_719_material_ui_lib_svg_icons_hardware_headset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_720_material_ui_lib_svg_icons_hardware_laptop_windows__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_720_material_ui_lib_svg_icons_hardware_laptop_windows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_720_material_ui_lib_svg_icons_hardware_laptop_windows__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_721_material_ui_lib_svg_icons_hardware_keyboard_arrow_left__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_721_material_ui_lib_svg_icons_hardware_keyboard_arrow_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_721_material_ui_lib_svg_icons_hardware_keyboard_arrow_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_722_material_ui_lib_svg_icons_hardware_laptop_mac__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_722_material_ui_lib_svg_icons_hardware_laptop_mac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_722_material_ui_lib_svg_icons_hardware_laptop_mac__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_723_material_ui_lib_svg_icons_hardware_tablet_mac__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_723_material_ui_lib_svg_icons_hardware_tablet_mac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_723_material_ui_lib_svg_icons_hardware_tablet_mac__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_724_material_ui_lib_svg_icons_hardware_keyboard_arrow_right__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_724_material_ui_lib_svg_icons_hardware_keyboard_arrow_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_724_material_ui_lib_svg_icons_hardware_keyboard_arrow_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_725_material_ui_lib_svg_icons_hardware_keyboard__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_725_material_ui_lib_svg_icons_hardware_keyboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_725_material_ui_lib_svg_icons_hardware_keyboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_726_material_ui_lib_svg_icons_hardware_phone_iphone__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_726_material_ui_lib_svg_icons_hardware_phone_iphone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_726_material_ui_lib_svg_icons_hardware_phone_iphone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_727_material_ui_lib_svg_icons_hardware_developer_board__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_727_material_ui_lib_svg_icons_hardware_developer_board___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_727_material_ui_lib_svg_icons_hardware_developer_board__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_728_material_ui_lib_svg_icons_hardware_device_hub__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_728_material_ui_lib_svg_icons_hardware_device_hub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_728_material_ui_lib_svg_icons_hardware_device_hub__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_729_material_ui_lib_svg_icons_hardware_keyboard_return__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_729_material_ui_lib_svg_icons_hardware_keyboard_return___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_729_material_ui_lib_svg_icons_hardware_keyboard_return__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_730_material_ui_lib_svg_icons_hardware_headset_mic__ = __webpack_require__(1803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_730_material_ui_lib_svg_icons_hardware_headset_mic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_730_material_ui_lib_svg_icons_hardware_headset_mic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_731_material_ui_lib_svg_icons_hardware_tablet__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_731_material_ui_lib_svg_icons_hardware_tablet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_731_material_ui_lib_svg_icons_hardware_tablet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_732_material_ui_lib_svg_icons_hardware_phonelink__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_732_material_ui_lib_svg_icons_hardware_phonelink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_732_material_ui_lib_svg_icons_hardware_phonelink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_733_material_ui_lib_svg_icons_hardware_keyboard_tab__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_733_material_ui_lib_svg_icons_hardware_keyboard_tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_733_material_ui_lib_svg_icons_hardware_keyboard_tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_734_material_ui_lib_svg_icons_hardware_computer__ = __webpack_require__(1807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_734_material_ui_lib_svg_icons_hardware_computer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_734_material_ui_lib_svg_icons_hardware_computer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_735_material_ui_lib_svg_icons_hardware_cast__ = __webpack_require__(1808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_735_material_ui_lib_svg_icons_hardware_cast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_735_material_ui_lib_svg_icons_hardware_cast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_736_material_ui_lib_svg_icons_hardware_keyboard_arrow_down__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_736_material_ui_lib_svg_icons_hardware_keyboard_arrow_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_736_material_ui_lib_svg_icons_hardware_keyboard_arrow_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_737_material_ui_lib_svg_icons_hardware_dock__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_737_material_ui_lib_svg_icons_hardware_dock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_737_material_ui_lib_svg_icons_hardware_dock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_738_material_ui_lib_svg_icons_hardware_keyboard_voice__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_738_material_ui_lib_svg_icons_hardware_keyboard_voice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_738_material_ui_lib_svg_icons_hardware_keyboard_voice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_739_material_ui_lib_svg_icons_hardware_scanner__ = __webpack_require__(1811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_739_material_ui_lib_svg_icons_hardware_scanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_739_material_ui_lib_svg_icons_hardware_scanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_740_material_ui_lib_svg_icons_hardware_keyboard_capslock__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_740_material_ui_lib_svg_icons_hardware_keyboard_capslock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_740_material_ui_lib_svg_icons_hardware_keyboard_capslock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_741_material_ui_lib_svg_icons_alert_warning__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_741_material_ui_lib_svg_icons_alert_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_741_material_ui_lib_svg_icons_alert_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_742_material_ui_lib_svg_icons_alert_error_outline__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_742_material_ui_lib_svg_icons_alert_error_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_742_material_ui_lib_svg_icons_alert_error_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_743_material_ui_lib_svg_icons_alert_add_alert__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_743_material_ui_lib_svg_icons_alert_add_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_743_material_ui_lib_svg_icons_alert_add_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_744_material_ui_lib_svg_icons_alert_error__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_744_material_ui_lib_svg_icons_alert_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_744_material_ui_lib_svg_icons_alert_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_745_material_ui_lib_svg_icons_device_network_wifi__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_745_material_ui_lib_svg_icons_device_network_wifi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_745_material_ui_lib_svg_icons_device_network_wifi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_746_material_ui_lib_svg_icons_device_signal_wifi_0_bar__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_746_material_ui_lib_svg_icons_device_signal_wifi_0_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_746_material_ui_lib_svg_icons_device_signal_wifi_0_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_747_material_ui_lib_svg_icons_device_signal_cellular_4_bar__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_747_material_ui_lib_svg_icons_device_signal_cellular_4_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_747_material_ui_lib_svg_icons_device_signal_cellular_4_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_748_material_ui_lib_svg_icons_device_access_alarm__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_748_material_ui_lib_svg_icons_device_access_alarm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_748_material_ui_lib_svg_icons_device_access_alarm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_749_material_ui_lib_svg_icons_device_wallpaper__ = __webpack_require__(1821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_749_material_ui_lib_svg_icons_device_wallpaper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_749_material_ui_lib_svg_icons_device_wallpaper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_750_material_ui_lib_svg_icons_device_data_usage__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_750_material_ui_lib_svg_icons_device_data_usage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_750_material_ui_lib_svg_icons_device_data_usage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_751_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_1_bar__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_751_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_1_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_751_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_1_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_752_material_ui_lib_svg_icons_device_battery_charging_80__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_752_material_ui_lib_svg_icons_device_battery_charging_80___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_752_material_ui_lib_svg_icons_device_battery_charging_80__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_753_material_ui_lib_svg_icons_device_location_searching__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_753_material_ui_lib_svg_icons_device_location_searching___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_753_material_ui_lib_svg_icons_device_location_searching__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_754_material_ui_lib_svg_icons_device_signal_cellular_0_bar__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_754_material_ui_lib_svg_icons_device_signal_cellular_0_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_754_material_ui_lib_svg_icons_device_signal_cellular_0_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_755_material_ui_lib_svg_icons_device_settings_system_daydream__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_755_material_ui_lib_svg_icons_device_settings_system_daydream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_755_material_ui_lib_svg_icons_device_settings_system_daydream__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_756_material_ui_lib_svg_icons_device_battery_charging_full__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_756_material_ui_lib_svg_icons_device_battery_charging_full___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_756_material_ui_lib_svg_icons_device_battery_charging_full__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_757_material_ui_lib_svg_icons_device_screen_lock_landscape__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_757_material_ui_lib_svg_icons_device_screen_lock_landscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_757_material_ui_lib_svg_icons_device_screen_lock_landscape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_758_material_ui_lib_svg_icons_device_bluetooth_connected__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_758_material_ui_lib_svg_icons_device_bluetooth_connected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_758_material_ui_lib_svg_icons_device_bluetooth_connected__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_759_material_ui_lib_svg_icons_device_sd_storage__ = __webpack_require__(1831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_759_material_ui_lib_svg_icons_device_sd_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_759_material_ui_lib_svg_icons_device_sd_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_760_material_ui_lib_svg_icons_device_widgets__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_760_material_ui_lib_svg_icons_device_widgets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_760_material_ui_lib_svg_icons_device_widgets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_761_material_ui_lib_svg_icons_device_brightness_high__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_761_material_ui_lib_svg_icons_device_brightness_high___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_761_material_ui_lib_svg_icons_device_brightness_high__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_762_material_ui_lib_svg_icons_device_wifi_lock__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_762_material_ui_lib_svg_icons_device_wifi_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_762_material_ui_lib_svg_icons_device_wifi_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_763_material_ui_lib_svg_icons_device_battery_charging_60__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_763_material_ui_lib_svg_icons_device_battery_charging_60___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_763_material_ui_lib_svg_icons_device_battery_charging_60__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_764_material_ui_lib_svg_icons_device_brightness_auto__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_764_material_ui_lib_svg_icons_device_brightness_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_764_material_ui_lib_svg_icons_device_brightness_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_765_material_ui_lib_svg_icons_device_battery_60__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_765_material_ui_lib_svg_icons_device_battery_60___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_765_material_ui_lib_svg_icons_device_battery_60__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_766_material_ui_lib_svg_icons_device_battery_charging_20__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_766_material_ui_lib_svg_icons_device_battery_charging_20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_766_material_ui_lib_svg_icons_device_battery_charging_20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_767_material_ui_lib_svg_icons_device_signal_cellular_3_bar__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_767_material_ui_lib_svg_icons_device_signal_cellular_3_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_767_material_ui_lib_svg_icons_device_signal_cellular_3_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_768_material_ui_lib_svg_icons_device_signal_cellular_2_bar__ = __webpack_require__(1840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_768_material_ui_lib_svg_icons_device_signal_cellular_2_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_768_material_ui_lib_svg_icons_device_signal_cellular_2_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_769_material_ui_lib_svg_icons_device_battery_charging_50__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_769_material_ui_lib_svg_icons_device_battery_charging_50___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_769_material_ui_lib_svg_icons_device_battery_charging_50__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_770_material_ui_lib_svg_icons_device_battery_50__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_770_material_ui_lib_svg_icons_device_battery_50___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_770_material_ui_lib_svg_icons_device_battery_50__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_771_material_ui_lib_svg_icons_device_wifi_tethering__ = __webpack_require__(1843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_771_material_ui_lib_svg_icons_device_wifi_tethering___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_771_material_ui_lib_svg_icons_device_wifi_tethering__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_772_material_ui_lib_svg_icons_device_battery_20__ = __webpack_require__(1844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_772_material_ui_lib_svg_icons_device_battery_20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_772_material_ui_lib_svg_icons_device_battery_20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_773_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_2_bar__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_773_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_2_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_773_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_2_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_774_material_ui_lib_svg_icons_device_access_alarms__ = __webpack_require__(1846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_774_material_ui_lib_svg_icons_device_access_alarms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_774_material_ui_lib_svg_icons_device_access_alarms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_775_material_ui_lib_svg_icons_device_signal_wifi_1_bar__ = __webpack_require__(1847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_775_material_ui_lib_svg_icons_device_signal_wifi_1_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_775_material_ui_lib_svg_icons_device_signal_wifi_1_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_776_material_ui_lib_svg_icons_device_screen_lock_portrait__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_776_material_ui_lib_svg_icons_device_screen_lock_portrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_776_material_ui_lib_svg_icons_device_screen_lock_portrait__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_777_material_ui_lib_svg_icons_device_access_time__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_777_material_ui_lib_svg_icons_device_access_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_777_material_ui_lib_svg_icons_device_access_time__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_778_material_ui_lib_svg_icons_device_battery_80__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_778_material_ui_lib_svg_icons_device_battery_80___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_778_material_ui_lib_svg_icons_device_battery_80__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_779_material_ui_lib_svg_icons_device_gps_off__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_779_material_ui_lib_svg_icons_device_gps_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_779_material_ui_lib_svg_icons_device_gps_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_780_material_ui_lib_svg_icons_device_screen_lock_rotation__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_780_material_ui_lib_svg_icons_device_screen_lock_rotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_780_material_ui_lib_svg_icons_device_screen_lock_rotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_781_material_ui_lib_svg_icons_device_battery_unknown__ = __webpack_require__(1853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_781_material_ui_lib_svg_icons_device_battery_unknown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_781_material_ui_lib_svg_icons_device_battery_unknown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_782_material_ui_lib_svg_icons_device_gps_not_fixed__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_782_material_ui_lib_svg_icons_device_gps_not_fixed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_782_material_ui_lib_svg_icons_device_gps_not_fixed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_783_material_ui_lib_svg_icons_device_signal_wifi_3_bar_lock__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_783_material_ui_lib_svg_icons_device_signal_wifi_3_bar_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_783_material_ui_lib_svg_icons_device_signal_wifi_3_bar_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_784_material_ui_lib_svg_icons_device_nfc__ = __webpack_require__(1856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_784_material_ui_lib_svg_icons_device_nfc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_784_material_ui_lib_svg_icons_device_nfc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_785_material_ui_lib_svg_icons_device_dvr__ = __webpack_require__(1857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_785_material_ui_lib_svg_icons_device_dvr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_785_material_ui_lib_svg_icons_device_dvr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_786_material_ui_lib_svg_icons_device_signal_cellular_1_bar__ = __webpack_require__(1858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_786_material_ui_lib_svg_icons_device_signal_cellular_1_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_786_material_ui_lib_svg_icons_device_signal_cellular_1_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_787_material_ui_lib_svg_icons_device_airplanemode_active__ = __webpack_require__(1859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_787_material_ui_lib_svg_icons_device_airplanemode_active___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_787_material_ui_lib_svg_icons_device_airplanemode_active__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_788_material_ui_lib_svg_icons_device_battery_90__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_788_material_ui_lib_svg_icons_device_battery_90___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_788_material_ui_lib_svg_icons_device_battery_90__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_789_material_ui_lib_svg_icons_device_bluetooth_searching__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_789_material_ui_lib_svg_icons_device_bluetooth_searching___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_789_material_ui_lib_svg_icons_device_bluetooth_searching__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_790_material_ui_lib_svg_icons_device_storage__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_790_material_ui_lib_svg_icons_device_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_790_material_ui_lib_svg_icons_device_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_791_material_ui_lib_svg_icons_device_signal_cellular_no_sim__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_791_material_ui_lib_svg_icons_device_signal_cellular_no_sim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_791_material_ui_lib_svg_icons_device_signal_cellular_no_sim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_792_material_ui_lib_svg_icons_device_brightness_medium__ = __webpack_require__(1864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_792_material_ui_lib_svg_icons_device_brightness_medium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_792_material_ui_lib_svg_icons_device_brightness_medium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_793_material_ui_lib_svg_icons_device_location_disabled__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_793_material_ui_lib_svg_icons_device_location_disabled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_793_material_ui_lib_svg_icons_device_location_disabled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_794_material_ui_lib_svg_icons_device_signal_wifi_2_bar_lock__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_794_material_ui_lib_svg_icons_device_signal_wifi_2_bar_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_794_material_ui_lib_svg_icons_device_signal_wifi_2_bar_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_795_material_ui_lib_svg_icons_device_signal_wifi_off__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_795_material_ui_lib_svg_icons_device_signal_wifi_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_795_material_ui_lib_svg_icons_device_signal_wifi_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_796_material_ui_lib_svg_icons_device_battery_full__ = __webpack_require__(1868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_796_material_ui_lib_svg_icons_device_battery_full___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_796_material_ui_lib_svg_icons_device_battery_full__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_797_material_ui_lib_svg_icons_device_bluetooth__ = __webpack_require__(1869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_797_material_ui_lib_svg_icons_device_bluetooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_797_material_ui_lib_svg_icons_device_bluetooth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_798_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_3_bar__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_798_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_3_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_798_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_3_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_799_material_ui_lib_svg_icons_device_signal_wifi_1_bar_lock__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_799_material_ui_lib_svg_icons_device_signal_wifi_1_bar_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_799_material_ui_lib_svg_icons_device_signal_wifi_1_bar_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_800_material_ui_lib_svg_icons_device_signal_cellular_null__ = __webpack_require__(1872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_800_material_ui_lib_svg_icons_device_signal_cellular_null___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_800_material_ui_lib_svg_icons_device_signal_cellular_null__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_801_material_ui_lib_svg_icons_device_brightness_low__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_801_material_ui_lib_svg_icons_device_brightness_low___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_801_material_ui_lib_svg_icons_device_brightness_low__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_802_material_ui_lib_svg_icons_device_battery_charging_90__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_802_material_ui_lib_svg_icons_device_battery_charging_90___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_802_material_ui_lib_svg_icons_device_battery_charging_90__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_803_material_ui_lib_svg_icons_device_signal_wifi_3_bar__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_803_material_ui_lib_svg_icons_device_signal_wifi_3_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_803_material_ui_lib_svg_icons_device_signal_wifi_3_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_804_material_ui_lib_svg_icons_device_signal_cellular_off__ = __webpack_require__(1876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_804_material_ui_lib_svg_icons_device_signal_cellular_off___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_804_material_ui_lib_svg_icons_device_signal_cellular_off__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_805_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_0_bar__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_805_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_0_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_805_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_0_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_806_material_ui_lib_svg_icons_device_bluetooth_disabled__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_806_material_ui_lib_svg_icons_device_bluetooth_disabled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_806_material_ui_lib_svg_icons_device_bluetooth_disabled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_807_material_ui_lib_svg_icons_device_devices__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_807_material_ui_lib_svg_icons_device_devices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_807_material_ui_lib_svg_icons_device_devices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_808_material_ui_lib_svg_icons_device_add_alarm__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_808_material_ui_lib_svg_icons_device_add_alarm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_808_material_ui_lib_svg_icons_device_add_alarm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_809_material_ui_lib_svg_icons_device_graphic_eq__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_809_material_ui_lib_svg_icons_device_graphic_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_809_material_ui_lib_svg_icons_device_graphic_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_810_material_ui_lib_svg_icons_device_battery_alert__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_810_material_ui_lib_svg_icons_device_battery_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_810_material_ui_lib_svg_icons_device_battery_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_811_material_ui_lib_svg_icons_device_signal_wifi_4_bar_lock__ = __webpack_require__(1883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_811_material_ui_lib_svg_icons_device_signal_wifi_4_bar_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_811_material_ui_lib_svg_icons_device_signal_wifi_4_bar_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_812_material_ui_lib_svg_icons_device_signal_wifi_4_bar__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_812_material_ui_lib_svg_icons_device_signal_wifi_4_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_812_material_ui_lib_svg_icons_device_signal_wifi_4_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_813_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_4_bar__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_813_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_4_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_813_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_4_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_814_material_ui_lib_svg_icons_device_developer_mode__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_814_material_ui_lib_svg_icons_device_developer_mode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_814_material_ui_lib_svg_icons_device_developer_mode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_815_material_ui_lib_svg_icons_device_gps_fixed__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_815_material_ui_lib_svg_icons_device_gps_fixed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_815_material_ui_lib_svg_icons_device_gps_fixed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_816_material_ui_lib_svg_icons_device_battery_std__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_816_material_ui_lib_svg_icons_device_battery_std___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_816_material_ui_lib_svg_icons_device_battery_std__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_817_material_ui_lib_svg_icons_device_battery_30__ = __webpack_require__(1889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_817_material_ui_lib_svg_icons_device_battery_30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_817_material_ui_lib_svg_icons_device_battery_30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_818_material_ui_lib_svg_icons_device_airplanemode_inactive__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_818_material_ui_lib_svg_icons_device_airplanemode_inactive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_818_material_ui_lib_svg_icons_device_airplanemode_inactive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_819_material_ui_lib_svg_icons_device_signal_wifi_2_bar__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_819_material_ui_lib_svg_icons_device_signal_wifi_2_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_819_material_ui_lib_svg_icons_device_signal_wifi_2_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_820_material_ui_lib_svg_icons_device_network_cell__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_820_material_ui_lib_svg_icons_device_network_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_820_material_ui_lib_svg_icons_device_network_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_821_material_ui_lib_svg_icons_device_usb__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_821_material_ui_lib_svg_icons_device_usb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_821_material_ui_lib_svg_icons_device_usb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_822_material_ui_lib_svg_icons_device_battery_charging_30__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_822_material_ui_lib_svg_icons_device_battery_charging_30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_822_material_ui_lib_svg_icons_device_battery_charging_30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_823_material_ui_lib_svg_icons_device_screen_rotation__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_823_material_ui_lib_svg_icons_device_screen_rotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_823_material_ui_lib_svg_icons_device_screen_rotation__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsDirectionsRailway", function() { return __WEBPACK_IMPORTED_MODULE_0_material_ui_lib_svg_icons_maps_directions_railway___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsDirectionsSubway", function() { return __WEBPACK_IMPORTED_MODULE_1_material_ui_lib_svg_icons_maps_directions_subway___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsSatellite", function() { return __WEBPACK_IMPORTED_MODULE_2_material_ui_lib_svg_icons_maps_satellite___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsDirectionsCar", function() { return __WEBPACK_IMPORTED_MODULE_3_material_ui_lib_svg_icons_maps_directions_car___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsDirectionsWalk", function() { return __WEBPACK_IMPORTED_MODULE_4_material_ui_lib_svg_icons_maps_directions_walk___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLayersClear", function() { return __WEBPACK_IMPORTED_MODULE_5_material_ui_lib_svg_icons_maps_layers_clear___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalPharmacy", function() { return __WEBPACK_IMPORTED_MODULE_6_material_ui_lib_svg_icons_maps_local_pharmacy___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsPlace", function() { return __WEBPACK_IMPORTED_MODULE_7_material_ui_lib_svg_icons_maps_place___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsHotel", function() { return __WEBPACK_IMPORTED_MODULE_8_material_ui_lib_svg_icons_maps_hotel___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsDirectionsBike", function() { return __WEBPACK_IMPORTED_MODULE_9_material_ui_lib_svg_icons_maps_directions_bike___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalMall", function() { return __WEBPACK_IMPORTED_MODULE_10_material_ui_lib_svg_icons_maps_local_mall___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsMyLocation", function() { return __WEBPACK_IMPORTED_MODULE_11_material_ui_lib_svg_icons_maps_my_location___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalOffer", function() { return __WEBPACK_IMPORTED_MODULE_12_material_ui_lib_svg_icons_maps_local_offer___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalSee", function() { return __WEBPACK_IMPORTED_MODULE_13_material_ui_lib_svg_icons_maps_local_see___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalCarWash", function() { return __WEBPACK_IMPORTED_MODULE_14_material_ui_lib_svg_icons_maps_local_car_wash___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalPostOffice", function() { return __WEBPACK_IMPORTED_MODULE_15_material_ui_lib_svg_icons_maps_local_post_office___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsDirections", function() { return __WEBPACK_IMPORTED_MODULE_16_material_ui_lib_svg_icons_maps_directions___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalMovies", function() { return __WEBPACK_IMPORTED_MODULE_17_material_ui_lib_svg_icons_maps_local_movies___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsRestaurantMenu", function() { return __WEBPACK_IMPORTED_MODULE_18_material_ui_lib_svg_icons_maps_restaurant_menu___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsDirectionsBoat", function() { return __WEBPACK_IMPORTED_MODULE_19_material_ui_lib_svg_icons_maps_directions_boat___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalCafe", function() { return __WEBPACK_IMPORTED_MODULE_20_material_ui_lib_svg_icons_maps_local_cafe___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsTerrain", function() { return __WEBPACK_IMPORTED_MODULE_21_material_ui_lib_svg_icons_maps_terrain___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalPhone", function() { return __WEBPACK_IMPORTED_MODULE_22_material_ui_lib_svg_icons_maps_local_phone___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalHotel", function() { return __WEBPACK_IMPORTED_MODULE_23_material_ui_lib_svg_icons_maps_local_hotel___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalPlay", function() { return __WEBPACK_IMPORTED_MODULE_24_material_ui_lib_svg_icons_maps_local_play___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalPizza", function() { return __WEBPACK_IMPORTED_MODULE_25_material_ui_lib_svg_icons_maps_local_pizza___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalAirport", function() { return __WEBPACK_IMPORTED_MODULE_26_material_ui_lib_svg_icons_maps_local_airport___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalShipping", function() { return __WEBPACK_IMPORTED_MODULE_27_material_ui_lib_svg_icons_maps_local_shipping___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalParking", function() { return __WEBPACK_IMPORTED_MODULE_28_material_ui_lib_svg_icons_maps_local_parking___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsNavigation", function() { return __WEBPACK_IMPORTED_MODULE_29_material_ui_lib_svg_icons_maps_navigation___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsMap", function() { return __WEBPACK_IMPORTED_MODULE_30_material_ui_lib_svg_icons_maps_map___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsPinDrop", function() { return __WEBPACK_IMPORTED_MODULE_31_material_ui_lib_svg_icons_maps_pin_drop___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalHospital", function() { return __WEBPACK_IMPORTED_MODULE_32_material_ui_lib_svg_icons_maps_local_hospital___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsDirectionsRun", function() { return __WEBPACK_IMPORTED_MODULE_33_material_ui_lib_svg_icons_maps_directions_run___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsTraffic", function() { return __WEBPACK_IMPORTED_MODULE_34_material_ui_lib_svg_icons_maps_traffic___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLayers", function() { return __WEBPACK_IMPORTED_MODULE_35_material_ui_lib_svg_icons_maps_layers___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalDrink", function() { return __WEBPACK_IMPORTED_MODULE_36_material_ui_lib_svg_icons_maps_local_drink___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalGroceryStore", function() { return __WEBPACK_IMPORTED_MODULE_37_material_ui_lib_svg_icons_maps_local_grocery_store___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalDining", function() { return __WEBPACK_IMPORTED_MODULE_38_material_ui_lib_svg_icons_maps_local_dining___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalTaxi", function() { return __WEBPACK_IMPORTED_MODULE_39_material_ui_lib_svg_icons_maps_local_taxi___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsPersonPin", function() { return __WEBPACK_IMPORTED_MODULE_40_material_ui_lib_svg_icons_maps_person_pin___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalGasStation", function() { return __WEBPACK_IMPORTED_MODULE_41_material_ui_lib_svg_icons_maps_local_gas_station___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsFlight", function() { return __WEBPACK_IMPORTED_MODULE_42_material_ui_lib_svg_icons_maps_flight___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalActivity", function() { return __WEBPACK_IMPORTED_MODULE_43_material_ui_lib_svg_icons_maps_local_activity___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalFlorist", function() { return __WEBPACK_IMPORTED_MODULE_44_material_ui_lib_svg_icons_maps_local_florist___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalBar", function() { return __WEBPACK_IMPORTED_MODULE_45_material_ui_lib_svg_icons_maps_local_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsDirectionsTransit", function() { return __WEBPACK_IMPORTED_MODULE_46_material_ui_lib_svg_icons_maps_directions_transit___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalPrintshop", function() { return __WEBPACK_IMPORTED_MODULE_47_material_ui_lib_svg_icons_maps_local_printshop___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalAtm", function() { return __WEBPACK_IMPORTED_MODULE_48_material_ui_lib_svg_icons_maps_local_atm___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsStoreMallDirectory", function() { return __WEBPACK_IMPORTED_MODULE_49_material_ui_lib_svg_icons_maps_store_mall_directory___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalConvenienceStore", function() { return __WEBPACK_IMPORTED_MODULE_50_material_ui_lib_svg_icons_maps_local_convenience_store___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsRateReview", function() { return __WEBPACK_IMPORTED_MODULE_51_material_ui_lib_svg_icons_maps_rate_review___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalLibrary", function() { return __WEBPACK_IMPORTED_MODULE_52_material_ui_lib_svg_icons_maps_local_library___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsLocalLaundryService", function() { return __WEBPACK_IMPORTED_MODULE_53_material_ui_lib_svg_icons_maps_local_laundry_service___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsBeenhere", function() { return __WEBPACK_IMPORTED_MODULE_54_material_ui_lib_svg_icons_maps_beenhere___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MapsDirectionsBus", function() { return __WEBPACK_IMPORTED_MODULE_55_material_ui_lib_svg_icons_maps_directions_bus___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationMoreHoriz", function() { return __WEBPACK_IMPORTED_MODULE_56_material_ui_lib_svg_icons_navigation_more_horiz___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationFullscreen", function() { return __WEBPACK_IMPORTED_MODULE_57_material_ui_lib_svg_icons_navigation_fullscreen___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationCheck", function() { return __WEBPACK_IMPORTED_MODULE_58_material_ui_lib_svg_icons_navigation_check___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationRefresh", function() { return __WEBPACK_IMPORTED_MODULE_59_material_ui_lib_svg_icons_navigation_refresh___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationArrowDropDownCircle", function() { return __WEBPACK_IMPORTED_MODULE_60_material_ui_lib_svg_icons_navigation_arrow_drop_down_circle___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationMenu", function() { return __WEBPACK_IMPORTED_MODULE_61_material_ui_lib_svg_icons_navigation_menu___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationExpandMore", function() { return __WEBPACK_IMPORTED_MODULE_62_material_ui_lib_svg_icons_navigation_expand_more___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationUnfoldLess", function() { return __WEBPACK_IMPORTED_MODULE_63_material_ui_lib_svg_icons_navigation_unfold_less___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationArrowForward", function() { return __WEBPACK_IMPORTED_MODULE_64_material_ui_lib_svg_icons_navigation_arrow_forward___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationFullscreenExit", function() { return __WEBPACK_IMPORTED_MODULE_65_material_ui_lib_svg_icons_navigation_fullscreen_exit___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationApps", function() { return __WEBPACK_IMPORTED_MODULE_66_material_ui_lib_svg_icons_navigation_apps___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationArrowBack", function() { return __WEBPACK_IMPORTED_MODULE_67_material_ui_lib_svg_icons_navigation_arrow_back___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationArrowDropUp", function() { return __WEBPACK_IMPORTED_MODULE_68_material_ui_lib_svg_icons_navigation_arrow_drop_up___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationClose", function() { return __WEBPACK_IMPORTED_MODULE_69_material_ui_lib_svg_icons_navigation_close___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationChevronRight", function() { return __WEBPACK_IMPORTED_MODULE_70_material_ui_lib_svg_icons_navigation_chevron_right___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationExpandLess", function() { return __WEBPACK_IMPORTED_MODULE_71_material_ui_lib_svg_icons_navigation_expand_less___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationMoreVert", function() { return __WEBPACK_IMPORTED_MODULE_72_material_ui_lib_svg_icons_navigation_more_vert___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationArrowDropDown", function() { return __WEBPACK_IMPORTED_MODULE_73_material_ui_lib_svg_icons_navigation_arrow_drop_down___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationChevronLeft", function() { return __WEBPACK_IMPORTED_MODULE_74_material_ui_lib_svg_icons_navigation_chevron_left___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationUnfoldMore", function() { return __WEBPACK_IMPORTED_MODULE_75_material_ui_lib_svg_icons_navigation_unfold_more___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationCancel", function() { return __WEBPACK_IMPORTED_MODULE_76_material_ui_lib_svg_icons_navigation_cancel___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorVerticalAlignBottom", function() { return __WEBPACK_IMPORTED_MODULE_77_material_ui_lib_svg_icons_editor_vertical_align_bottom___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatPaint", function() { return __WEBPACK_IMPORTED_MODULE_78_material_ui_lib_svg_icons_editor_format_paint___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorBorderHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_79_material_ui_lib_svg_icons_editor_border_horizontal___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatAlignRight", function() { return __WEBPACK_IMPORTED_MODULE_80_material_ui_lib_svg_icons_editor_format_align_right___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorBorderStyle", function() { return __WEBPACK_IMPORTED_MODULE_81_material_ui_lib_svg_icons_editor_border_style___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorBorderInner", function() { return __WEBPACK_IMPORTED_MODULE_82_material_ui_lib_svg_icons_editor_border_inner___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatTextdirectionLToR", function() { return __WEBPACK_IMPORTED_MODULE_83_material_ui_lib_svg_icons_editor_format_textdirection_l_to_r___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorBorderColor", function() { return __WEBPACK_IMPORTED_MODULE_84_material_ui_lib_svg_icons_editor_border_color___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatAlignCenter", function() { return __WEBPACK_IMPORTED_MODULE_85_material_ui_lib_svg_icons_editor_format_align_center___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatStrikethrough", function() { return __WEBPACK_IMPORTED_MODULE_86_material_ui_lib_svg_icons_editor_format_strikethrough___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatListBulleted", function() { return __WEBPACK_IMPORTED_MODULE_87_material_ui_lib_svg_icons_editor_format_list_bulleted___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFunctions", function() { return __WEBPACK_IMPORTED_MODULE_88_material_ui_lib_svg_icons_editor_functions___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatColorText", function() { return __WEBPACK_IMPORTED_MODULE_89_material_ui_lib_svg_icons_editor_format_color_text___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatColorFill", function() { return __WEBPACK_IMPORTED_MODULE_90_material_ui_lib_svg_icons_editor_format_color_fill___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorModeEdit", function() { return __WEBPACK_IMPORTED_MODULE_91_material_ui_lib_svg_icons_editor_mode_edit___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorWrapText", function() { return __WEBPACK_IMPORTED_MODULE_92_material_ui_lib_svg_icons_editor_wrap_text___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorMergeType", function() { return __WEBPACK_IMPORTED_MODULE_93_material_ui_lib_svg_icons_editor_merge_type___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorBorderVertical", function() { return __WEBPACK_IMPORTED_MODULE_94_material_ui_lib_svg_icons_editor_border_vertical___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorVerticalAlignCenter", function() { return __WEBPACK_IMPORTED_MODULE_95_material_ui_lib_svg_icons_editor_vertical_align_center___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorBorderLeft", function() { return __WEBPACK_IMPORTED_MODULE_96_material_ui_lib_svg_icons_editor_border_left___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatListNumbered", function() { return __WEBPACK_IMPORTED_MODULE_97_material_ui_lib_svg_icons_editor_format_list_numbered___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorBorderRight", function() { return __WEBPACK_IMPORTED_MODULE_98_material_ui_lib_svg_icons_editor_border_right___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatLineSpacing", function() { return __WEBPACK_IMPORTED_MODULE_99_material_ui_lib_svg_icons_editor_format_line_spacing___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatIndentDecrease", function() { return __WEBPACK_IMPORTED_MODULE_100_material_ui_lib_svg_icons_editor_format_indent_decrease___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorBorderTop", function() { return __WEBPACK_IMPORTED_MODULE_101_material_ui_lib_svg_icons_editor_border_top___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorModeComment", function() { return __WEBPACK_IMPORTED_MODULE_102_material_ui_lib_svg_icons_editor_mode_comment___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatColorReset", function() { return __WEBPACK_IMPORTED_MODULE_103_material_ui_lib_svg_icons_editor_format_color_reset___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorMoneyOff", function() { return __WEBPACK_IMPORTED_MODULE_104_material_ui_lib_svg_icons_editor_money_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorSpaceBar", function() { return __WEBPACK_IMPORTED_MODULE_105_material_ui_lib_svg_icons_editor_space_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorInsertEmoticon", function() { return __WEBPACK_IMPORTED_MODULE_106_material_ui_lib_svg_icons_editor_insert_emoticon___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatQuote", function() { return __WEBPACK_IMPORTED_MODULE_107_material_ui_lib_svg_icons_editor_format_quote___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorVerticalAlignTop", function() { return __WEBPACK_IMPORTED_MODULE_108_material_ui_lib_svg_icons_editor_vertical_align_top___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatAlignLeft", function() { return __WEBPACK_IMPORTED_MODULE_109_material_ui_lib_svg_icons_editor_format_align_left___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorAttachMoney", function() { return __WEBPACK_IMPORTED_MODULE_110_material_ui_lib_svg_icons_editor_attach_money___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorBorderBottom", function() { return __WEBPACK_IMPORTED_MODULE_111_material_ui_lib_svg_icons_editor_border_bottom___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatTextdirectionRToL", function() { return __WEBPACK_IMPORTED_MODULE_112_material_ui_lib_svg_icons_editor_format_textdirection_r_to_l___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatClear", function() { return __WEBPACK_IMPORTED_MODULE_113_material_ui_lib_svg_icons_editor_format_clear___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorInsertDriveFile", function() { return __WEBPACK_IMPORTED_MODULE_114_material_ui_lib_svg_icons_editor_insert_drive_file___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatIndentIncrease", function() { return __WEBPACK_IMPORTED_MODULE_115_material_ui_lib_svg_icons_editor_format_indent_increase___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorInsertChart", function() { return __WEBPACK_IMPORTED_MODULE_116_material_ui_lib_svg_icons_editor_insert_chart___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorInsertComment", function() { return __WEBPACK_IMPORTED_MODULE_117_material_ui_lib_svg_icons_editor_insert_comment___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatBold", function() { return __WEBPACK_IMPORTED_MODULE_118_material_ui_lib_svg_icons_editor_format_bold___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatSize", function() { return __WEBPACK_IMPORTED_MODULE_119_material_ui_lib_svg_icons_editor_format_size___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorBorderClear", function() { return __WEBPACK_IMPORTED_MODULE_120_material_ui_lib_svg_icons_editor_border_clear___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorPublish", function() { return __WEBPACK_IMPORTED_MODULE_121_material_ui_lib_svg_icons_editor_publish___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorAttachFile", function() { return __WEBPACK_IMPORTED_MODULE_122_material_ui_lib_svg_icons_editor_attach_file___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorBorderAll", function() { return __WEBPACK_IMPORTED_MODULE_123_material_ui_lib_svg_icons_editor_border_all___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorStrikethroughS", function() { return __WEBPACK_IMPORTED_MODULE_124_material_ui_lib_svg_icons_editor_strikethrough_s___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatUnderlined", function() { return __WEBPACK_IMPORTED_MODULE_125_material_ui_lib_svg_icons_editor_format_underlined___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorInsertInvitation", function() { return __WEBPACK_IMPORTED_MODULE_126_material_ui_lib_svg_icons_editor_insert_invitation___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorInsertLink", function() { return __WEBPACK_IMPORTED_MODULE_127_material_ui_lib_svg_icons_editor_insert_link___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorBorderOuter", function() { return __WEBPACK_IMPORTED_MODULE_128_material_ui_lib_svg_icons_editor_border_outer___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatAlignJustify", function() { return __WEBPACK_IMPORTED_MODULE_129_material_ui_lib_svg_icons_editor_format_align_justify___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorInsertPhoto", function() { return __WEBPACK_IMPORTED_MODULE_130_material_ui_lib_svg_icons_editor_insert_photo___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "EditorFormatItalic", function() { return __WEBPACK_IMPORTED_MODULE_131_material_ui_lib_svg_icons_editor_format_italic___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NavigationArrowDropRight", function() { return __WEBPACK_IMPORTED_MODULE_132_material_ui_lib_svg_icons_navigation_arrow_drop_right___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleCheckBox", function() { return __WEBPACK_IMPORTED_MODULE_133_material_ui_lib_svg_icons_toggle_check_box___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleStar", function() { return __WEBPACK_IMPORTED_MODULE_134_material_ui_lib_svg_icons_toggle_star___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleCheckBoxOutlineBlank", function() { return __WEBPACK_IMPORTED_MODULE_135_material_ui_lib_svg_icons_toggle_check_box_outline_blank___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleStarHalf", function() { return __WEBPACK_IMPORTED_MODULE_136_material_ui_lib_svg_icons_toggle_star_half___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleStarBorder", function() { return __WEBPACK_IMPORTED_MODULE_137_material_ui_lib_svg_icons_toggle_star_border___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleIndeterminateCheckBox", function() { return __WEBPACK_IMPORTED_MODULE_138_material_ui_lib_svg_icons_toggle_indeterminate_check_box___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleRadioButtonUnchecked", function() { return __WEBPACK_IMPORTED_MODULE_139_material_ui_lib_svg_icons_toggle_radio_button_unchecked___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleRadioButtonChecked", function() { return __WEBPACK_IMPORTED_MODULE_140_material_ui_lib_svg_icons_toggle_radio_button_checked___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileCloudOff", function() { return __WEBPACK_IMPORTED_MODULE_141_material_ui_lib_svg_icons_file_cloud_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileCloud", function() { return __WEBPACK_IMPORTED_MODULE_142_material_ui_lib_svg_icons_file_cloud___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileCloudDownload", function() { return __WEBPACK_IMPORTED_MODULE_143_material_ui_lib_svg_icons_file_cloud_download___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileFolderOpen", function() { return __WEBPACK_IMPORTED_MODULE_144_material_ui_lib_svg_icons_file_folder_open___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileFileUpload", function() { return __WEBPACK_IMPORTED_MODULE_145_material_ui_lib_svg_icons_file_file_upload___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileCloudUpload", function() { return __WEBPACK_IMPORTED_MODULE_146_material_ui_lib_svg_icons_file_cloud_upload___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileFileDownload", function() { return __WEBPACK_IMPORTED_MODULE_147_material_ui_lib_svg_icons_file_file_download___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileCloudDone", function() { return __WEBPACK_IMPORTED_MODULE_148_material_ui_lib_svg_icons_file_cloud_done___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileAttachment", function() { return __WEBPACK_IMPORTED_MODULE_149_material_ui_lib_svg_icons_file_attachment___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileFolderShared", function() { return __WEBPACK_IMPORTED_MODULE_150_material_ui_lib_svg_icons_file_folder_shared___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileCloudQueue", function() { return __WEBPACK_IMPORTED_MODULE_151_material_ui_lib_svg_icons_file_cloud_queue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileCloudCircle", function() { return __WEBPACK_IMPORTED_MODULE_152_material_ui_lib_svg_icons_file_cloud_circle___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FileFolder", function() { return __WEBPACK_IMPORTED_MODULE_153_material_ui_lib_svg_icons_file_folder___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationMessage", function() { return __WEBPACK_IMPORTED_MODULE_154_material_ui_lib_svg_icons_communication_message___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationSpeakerPhone", function() { return __WEBPACK_IMPORTED_MODULE_155_material_ui_lib_svg_icons_communication_speaker_phone___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationForum", function() { return __WEBPACK_IMPORTED_MODULE_156_material_ui_lib_svg_icons_communication_forum___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationLocationOn", function() { return __WEBPACK_IMPORTED_MODULE_157_material_ui_lib_svg_icons_communication_location_on___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationDialpad", function() { return __WEBPACK_IMPORTED_MODULE_158_material_ui_lib_svg_icons_communication_dialpad___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationContacts", function() { return __WEBPACK_IMPORTED_MODULE_159_material_ui_lib_svg_icons_communication_contacts___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationLocationOff", function() { return __WEBPACK_IMPORTED_MODULE_160_material_ui_lib_svg_icons_communication_location_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationChatBubbleOutline", function() { return __WEBPACK_IMPORTED_MODULE_161_material_ui_lib_svg_icons_communication_chat_bubble_outline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationStayCurrentPortrait", function() { return __WEBPACK_IMPORTED_MODULE_162_material_ui_lib_svg_icons_communication_stay_current_portrait___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationCallSplit", function() { return __WEBPACK_IMPORTED_MODULE_163_material_ui_lib_svg_icons_communication_call_split___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationCallMissed", function() { return __WEBPACK_IMPORTED_MODULE_164_material_ui_lib_svg_icons_communication_call_missed___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationChatBubble", function() { return __WEBPACK_IMPORTED_MODULE_165_material_ui_lib_svg_icons_communication_chat_bubble___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationPresentToAll", function() { return __WEBPACK_IMPORTED_MODULE_166_material_ui_lib_svg_icons_communication_present_to_all___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationStayPrimaryPortrait", function() { return __WEBPACK_IMPORTED_MODULE_167_material_ui_lib_svg_icons_communication_stay_primary_portrait___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationCallReceived", function() { return __WEBPACK_IMPORTED_MODULE_168_material_ui_lib_svg_icons_communication_call_received___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationStayPrimaryLandscape", function() { return __WEBPACK_IMPORTED_MODULE_169_material_ui_lib_svg_icons_communication_stay_primary_landscape___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationPhonelinkErase", function() { return __WEBPACK_IMPORTED_MODULE_170_material_ui_lib_svg_icons_communication_phonelink_erase___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationInvertColorsOff", function() { return __WEBPACK_IMPORTED_MODULE_171_material_ui_lib_svg_icons_communication_invert_colors_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationCallMerge", function() { return __WEBPACK_IMPORTED_MODULE_172_material_ui_lib_svg_icons_communication_call_merge___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationPhonelinkLock", function() { return __WEBPACK_IMPORTED_MODULE_173_material_ui_lib_svg_icons_communication_phonelink_lock___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationLiveHelp", function() { return __WEBPACK_IMPORTED_MODULE_174_material_ui_lib_svg_icons_communication_live_help___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationSwapCalls", function() { return __WEBPACK_IMPORTED_MODULE_175_material_ui_lib_svg_icons_communication_swap_calls___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationTactMail", function() { return __WEBPACK_IMPORTED_MODULE_176_material_ui_lib_svg_icons_communication_tact_mail___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationContactPhone", function() { return __WEBPACK_IMPORTED_MODULE_177_material_ui_lib_svg_icons_communication_contact_phone___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationPortableWifiOff", function() { return __WEBPACK_IMPORTED_MODULE_178_material_ui_lib_svg_icons_communication_portable_wifi_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationDialerSip", function() { return __WEBPACK_IMPORTED_MODULE_179_material_ui_lib_svg_icons_communication_dialer_sip___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationNoSim", function() { return __WEBPACK_IMPORTED_MODULE_180_material_ui_lib_svg_icons_communication_no_sim___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationStayCurrentLandscape", function() { return __WEBPACK_IMPORTED_MODULE_181_material_ui_lib_svg_icons_communication_stay_current_landscape___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationCall", function() { return __WEBPACK_IMPORTED_MODULE_182_material_ui_lib_svg_icons_communication_call___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationVpnKey", function() { return __WEBPACK_IMPORTED_MODULE_183_material_ui_lib_svg_icons_communication_vpn_key___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationVoicemail", function() { return __WEBPACK_IMPORTED_MODULE_184_material_ui_lib_svg_icons_communication_voicemail___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationPhonelinkRing", function() { return __WEBPACK_IMPORTED_MODULE_185_material_ui_lib_svg_icons_communication_phonelink_ring___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationBusiness", function() { return __WEBPACK_IMPORTED_MODULE_186_material_ui_lib_svg_icons_communication_business___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationImportExport", function() { return __WEBPACK_IMPORTED_MODULE_187_material_ui_lib_svg_icons_communication_import_export___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationClearAll", function() { return __WEBPACK_IMPORTED_MODULE_188_material_ui_lib_svg_icons_communication_clear_all___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationEmail", function() { return __WEBPACK_IMPORTED_MODULE_189_material_ui_lib_svg_icons_communication_email___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationComment", function() { return __WEBPACK_IMPORTED_MODULE_190_material_ui_lib_svg_icons_communication_comment___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationTextsms", function() { return __WEBPACK_IMPORTED_MODULE_191_material_ui_lib_svg_icons_communication_textsms___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationPhonelinkSetup", function() { return __WEBPACK_IMPORTED_MODULE_192_material_ui_lib_svg_icons_communication_phonelink_setup___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationCallEnd", function() { return __WEBPACK_IMPORTED_MODULE_193_material_ui_lib_svg_icons_communication_call_end___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationCallMade", function() { return __WEBPACK_IMPORTED_MODULE_194_material_ui_lib_svg_icons_communication_call_made___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationChat", function() { return __WEBPACK_IMPORTED_MODULE_195_material_ui_lib_svg_icons_communication_chat___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationPhone", function() { return __WEBPACK_IMPORTED_MODULE_196_material_ui_lib_svg_icons_communication_phone___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CommunicationRingVolume", function() { return __WEBPACK_IMPORTED_MODULE_197_material_ui_lib_svg_icons_communication_ring_volume___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsEthernet", function() { return __WEBPACK_IMPORTED_MODULE_198_material_ui_lib_svg_icons_action_settings_ethernet___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAssignmentReturned", function() { return __WEBPACK_IMPORTED_MODULE_199_material_ui_lib_svg_icons_action_assignment_returned___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionLockOpen", function() { return __WEBPACK_IMPORTED_MODULE_200_material_ui_lib_svg_icons_action_lock_open___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionReportProblem", function() { return __WEBPACK_IMPORTED_MODULE_201_material_ui_lib_svg_icons_action_report_problem___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionList", function() { return __WEBPACK_IMPORTED_MODULE_202_material_ui_lib_svg_icons_action_list___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSwapVert", function() { return __WEBPACK_IMPORTED_MODULE_203_material_ui_lib_svg_icons_action_swap_vert___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionTab", function() { return __WEBPACK_IMPORTED_MODULE_204_material_ui_lib_svg_icons_action_tab___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionInfoOutline", function() { return __WEBPACK_IMPORTED_MODULE_205_material_ui_lib_svg_icons_action_info_outline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionTabUnselected", function() { return __WEBPACK_IMPORTED_MODULE_206_material_ui_lib_svg_icons_action_tab_unselected___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionGif", function() { return __WEBPACK_IMPORTED_MODULE_207_material_ui_lib_svg_icons_action_gif___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPolymer", function() { return __WEBPACK_IMPORTED_MODULE_208_material_ui_lib_svg_icons_action_polymer___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionExplore", function() { return __WEBPACK_IMPORTED_MODULE_209_material_ui_lib_svg_icons_action_explore___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionThumbDown", function() { return __WEBPACK_IMPORTED_MODULE_210_material_ui_lib_svg_icons_action_thumb_down___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionViewHeadline", function() { return __WEBPACK_IMPORTED_MODULE_211_material_ui_lib_svg_icons_action_view_headline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPageview", function() { return __WEBPACK_IMPORTED_MODULE_212_material_ui_lib_svg_icons_action_pageview___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionFavoriteBorder", function() { return __WEBPACK_IMPORTED_MODULE_213_material_ui_lib_svg_icons_action_favorite_border___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPermPhoneMsg", function() { return __WEBPACK_IMPORTED_MODULE_214_material_ui_lib_svg_icons_action_perm_phone_msg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsInputAntenna", function() { return __WEBPACK_IMPORTED_MODULE_215_material_ui_lib_svg_icons_action_settings_input_antenna___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAssignment", function() { return __WEBPACK_IMPORTED_MODULE_216_material_ui_lib_svg_icons_action_assignment___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionGetApp", function() { return __WEBPACK_IMPORTED_MODULE_217_material_ui_lib_svg_icons_action_get_app___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPermMedia", function() { return __WEBPACK_IMPORTED_MODULE_218_material_ui_lib_svg_icons_action_perm_media___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionFindInPage", function() { return __WEBPACK_IMPORTED_MODULE_219_material_ui_lib_svg_icons_action_find_in_page___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsBluetooth", function() { return __WEBPACK_IMPORTED_MODULE_220_material_ui_lib_svg_icons_action_settings_bluetooth___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionCreditCard", function() { return __WEBPACK_IMPORTED_MODULE_221_material_ui_lib_svg_icons_action_credit_card___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionViewWeek", function() { return __WEBPACK_IMPORTED_MODULE_222_material_ui_lib_svg_icons_action_view_week___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionTrackChanges", function() { return __WEBPACK_IMPORTED_MODULE_223_material_ui_lib_svg_icons_action_track_changes___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionCardGiftcard", function() { return __WEBPACK_IMPORTED_MODULE_224_material_ui_lib_svg_icons_action_card_giftcard___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsBackupRestore", function() { return __WEBPACK_IMPORTED_MODULE_225_material_ui_lib_svg_icons_action_settings_backup_restore___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionBugReport", function() { return __WEBPACK_IMPORTED_MODULE_226_material_ui_lib_svg_icons_action_bug_report___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionHighlightOff", function() { return __WEBPACK_IMPORTED_MODULE_227_material_ui_lib_svg_icons_action_highlight_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionChangeHistory", function() { return __WEBPACK_IMPORTED_MODULE_228_material_ui_lib_svg_icons_action_change_history___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionViewAgenda", function() { return __WEBPACK_IMPORTED_MODULE_229_material_ui_lib_svg_icons_action_view_agenda___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionDone", function() { return __WEBPACK_IMPORTED_MODULE_230_material_ui_lib_svg_icons_action_done___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionLockOutline", function() { return __WEBPACK_IMPORTED_MODULE_231_material_ui_lib_svg_icons_action_lock_outline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionHourglassFull", function() { return __WEBPACK_IMPORTED_MODULE_232_material_ui_lib_svg_icons_action_hourglass_full___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionLabel", function() { return __WEBPACK_IMPORTED_MODULE_233_material_ui_lib_svg_icons_action_label___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionBookmark", function() { return __WEBPACK_IMPORTED_MODULE_234_material_ui_lib_svg_icons_action_bookmark___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSwapVerticalCircle", function() { return __WEBPACK_IMPORTED_MODULE_235_material_ui_lib_svg_icons_action_swap_vertical_circle___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionEject", function() { return __WEBPACK_IMPORTED_MODULE_236_material_ui_lib_svg_icons_action_eject___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionTrendingFlat", function() { return __WEBPACK_IMPORTED_MODULE_237_material_ui_lib_svg_icons_action_trending_flat___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionGroupWork", function() { return __WEBPACK_IMPORTED_MODULE_238_material_ui_lib_svg_icons_action_group_work___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsInputSvideo", function() { return __WEBPACK_IMPORTED_MODULE_239_material_ui_lib_svg_icons_action_settings_input_svideo___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPermContactCalendar", function() { return __WEBPACK_IMPORTED_MODULE_240_material_ui_lib_svg_icons_action_perm_contact_calendar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionFace", function() { return __WEBPACK_IMPORTED_MODULE_241_material_ui_lib_svg_icons_action_face___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionVerifiedUser", function() { return __WEBPACK_IMPORTED_MODULE_242_material_ui_lib_svg_icons_action_verified_user___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionTheaters", function() { return __WEBPACK_IMPORTED_MODULE_243_material_ui_lib_svg_icons_action_theaters___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionBuild", function() { return __WEBPACK_IMPORTED_MODULE_244_material_ui_lib_svg_icons_action_build___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPermDataSetting", function() { return __WEBPACK_IMPORTED_MODULE_245_material_ui_lib_svg_icons_action_perm_data_setting___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionQuestionAnswer", function() { return __WEBPACK_IMPORTED_MODULE_246_material_ui_lib_svg_icons_action_question_answer___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionFlipToBack", function() { return __WEBPACK_IMPORTED_MODULE_247_material_ui_lib_svg_icons_action_flip_to_back___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionExtension", function() { return __WEBPACK_IMPORTED_MODULE_248_material_ui_lib_svg_icons_action_extension___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAccessibility", function() { return __WEBPACK_IMPORTED_MODULE_249_material_ui_lib_svg_icons_action_accessibility___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAlarmOn", function() { return __WEBPACK_IMPORTED_MODULE_250_material_ui_lib_svg_icons_action_alarm_on___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionQueryBuilder", function() { return __WEBPACK_IMPORTED_MODULE_251_material_ui_lib_svg_icons_action_query_builder___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAddShoppingCart", function() { return __WEBPACK_IMPORTED_MODULE_252_material_ui_lib_svg_icons_action_add_shopping_cart___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPayment", function() { return __WEBPACK_IMPORTED_MODULE_253_material_ui_lib_svg_icons_action_payment___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionEventSeat", function() { return __WEBPACK_IMPORTED_MODULE_254_material_ui_lib_svg_icons_action_event_seat___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionInput", function() { return __WEBPACK_IMPORTED_MODULE_255_material_ui_lib_svg_icons_action_input___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionMarkunreadMailbox", function() { return __WEBPACK_IMPORTED_MODULE_256_material_ui_lib_svg_icons_action_markunread_mailbox___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionLoyalty", function() { return __WEBPACK_IMPORTED_MODULE_257_material_ui_lib_svg_icons_action_loyalty___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPrint", function() { return __WEBPACK_IMPORTED_MODULE_258_material_ui_lib_svg_icons_action_print___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAutorenew", function() { return __WEBPACK_IMPORTED_MODULE_259_material_ui_lib_svg_icons_action_autorenew___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionDelete", function() { return __WEBPACK_IMPORTED_MODULE_260_material_ui_lib_svg_icons_action_delete___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAlarmAdd", function() { return __WEBPACK_IMPORTED_MODULE_261_material_ui_lib_svg_icons_action_alarm_add___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAccountBalance", function() { return __WEBPACK_IMPORTED_MODULE_262_material_ui_lib_svg_icons_action_account_balance___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAndroid", function() { return __WEBPACK_IMPORTED_MODULE_263_material_ui_lib_svg_icons_action_android___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionBookmarkBorder", function() { return __WEBPACK_IMPORTED_MODULE_264_material_ui_lib_svg_icons_action_bookmark_border___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionLaunch", function() { return __WEBPACK_IMPORTED_MODULE_265_material_ui_lib_svg_icons_action_launch___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSearch", function() { return __WEBPACK_IMPORTED_MODULE_266_material_ui_lib_svg_icons_action_search___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionZoomOut", function() { return __WEBPACK_IMPORTED_MODULE_267_material_ui_lib_svg_icons_action_zoom_out___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionVisibilityOff", function() { return __WEBPACK_IMPORTED_MODULE_268_material_ui_lib_svg_icons_action_visibility_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionLock", function() { return __WEBPACK_IMPORTED_MODULE_269_material_ui_lib_svg_icons_action_lock___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAccountCircle", function() { return __WEBPACK_IMPORTED_MODULE_270_material_ui_lib_svg_icons_action_account_circle___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAssignmentLate", function() { return __WEBPACK_IMPORTED_MODULE_271_material_ui_lib_svg_icons_action_assignment_late___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionShop", function() { return __WEBPACK_IMPORTED_MODULE_272_material_ui_lib_svg_icons_action_shop___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionToc", function() { return __WEBPACK_IMPORTED_MODULE_273_material_ui_lib_svg_icons_action_toc___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionShoppingCart", function() { return __WEBPACK_IMPORTED_MODULE_274_material_ui_lib_svg_icons_action_shopping_cart___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionCardMembership", function() { return __WEBPACK_IMPORTED_MODULE_275_material_ui_lib_svg_icons_action_card_membership___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionLabelOutline", function() { return __WEBPACK_IMPORTED_MODULE_276_material_ui_lib_svg_icons_action_label_outline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettings", function() { return __WEBPACK_IMPORTED_MODULE_277_material_ui_lib_svg_icons_action_settings___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsCell", function() { return __WEBPACK_IMPORTED_MODULE_278_material_ui_lib_svg_icons_action_settings_cell___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionOfflinePin", function() { return __WEBPACK_IMPORTED_MODULE_279_material_ui_lib_svg_icons_action_offline_pin___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionViewDay", function() { return __WEBPACK_IMPORTED_MODULE_280_material_ui_lib_svg_icons_action_view_day___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionDashboard", function() { return __WEBPACK_IMPORTED_MODULE_281_material_ui_lib_svg_icons_action_dashboard___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionViewModule", function() { return __WEBPACK_IMPORTED_MODULE_282_material_ui_lib_svg_icons_action_view_module___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsApplications", function() { return __WEBPACK_IMPORTED_MODULE_283_material_ui_lib_svg_icons_action_settings_applications___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionViewStream", function() { return __WEBPACK_IMPORTED_MODULE_284_material_ui_lib_svg_icons_action_view_stream___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionViewColumn", function() { return __WEBPACK_IMPORTED_MODULE_285_material_ui_lib_svg_icons_action_view_column___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsInputComposite", function() { return __WEBPACK_IMPORTED_MODULE_286_material_ui_lib_svg_icons_action_settings_input_composite___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAccountBalanceWallet", function() { return __WEBPACK_IMPORTED_MODULE_287_material_ui_lib_svg_icons_action_account_balance_wallet___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionInfo", function() { return __WEBPACK_IMPORTED_MODULE_288_material_ui_lib_svg_icons_action_info___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAssignmentTurnedIn", function() { return __WEBPACK_IMPORTED_MODULE_289_material_ui_lib_svg_icons_action_assignment_turned_in___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSchedule", function() { return __WEBPACK_IMPORTED_MODULE_290_material_ui_lib_svg_icons_action_schedule___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPermDeviceInformation", function() { return __WEBPACK_IMPORTED_MODULE_291_material_ui_lib_svg_icons_action_perm_device_information___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionViewList", function() { return __WEBPACK_IMPORTED_MODULE_292_material_ui_lib_svg_icons_action_view_list___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionOpenInBrowser", function() { return __WEBPACK_IMPORTED_MODULE_293_material_ui_lib_svg_icons_action_open_in_browser___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsPhone", function() { return __WEBPACK_IMPORTED_MODULE_294_material_ui_lib_svg_icons_action_settings_phone___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionFeedback", function() { return __WEBPACK_IMPORTED_MODULE_295_material_ui_lib_svg_icons_action_feedback___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionHttps", function() { return __WEBPACK_IMPORTED_MODULE_296_material_ui_lib_svg_icons_action_https___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAlarmOff", function() { return __WEBPACK_IMPORTED_MODULE_297_material_ui_lib_svg_icons_action_alarm_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionCached", function() { return __WEBPACK_IMPORTED_MODULE_298_material_ui_lib_svg_icons_action_cached___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionTrendingUp", function() { return __WEBPACK_IMPORTED_MODULE_299_material_ui_lib_svg_icons_action_trending_up___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionWork", function() { return __WEBPACK_IMPORTED_MODULE_300_material_ui_lib_svg_icons_action_work___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPermCameraMic", function() { return __WEBPACK_IMPORTED_MODULE_301_material_ui_lib_svg_icons_action_perm_camera_mic___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionOpenInNew", function() { return __WEBPACK_IMPORTED_MODULE_302_material_ui_lib_svg_icons_action_open_in_new___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionTurnedInNot", function() { return __WEBPACK_IMPORTED_MODULE_303_material_ui_lib_svg_icons_action_turned_in_not___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionThumbUp", function() { return __WEBPACK_IMPORTED_MODULE_304_material_ui_lib_svg_icons_action_thumb_up___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionExitToApp", function() { return __WEBPACK_IMPORTED_MODULE_305_material_ui_lib_svg_icons_action_exit_to_app___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionViewArray", function() { return __WEBPACK_IMPORTED_MODULE_306_material_ui_lib_svg_icons_action_view_array___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionReceipt", function() { return __WEBPACK_IMPORTED_MODULE_307_material_ui_lib_svg_icons_action_receipt___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAspectRatio", function() { return __WEBPACK_IMPORTED_MODULE_308_material_ui_lib_svg_icons_action_aspect_ratio___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPlayForWork", function() { return __WEBPACK_IMPORTED_MODULE_309_material_ui_lib_svg_icons_action_play_for_work___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionRedeem", function() { return __WEBPACK_IMPORTED_MODULE_310_material_ui_lib_svg_icons_action_redeem___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionCheckCircle", function() { return __WEBPACK_IMPORTED_MODULE_311_material_ui_lib_svg_icons_action_check_circle___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionHttp", function() { return __WEBPACK_IMPORTED_MODULE_312_material_ui_lib_svg_icons_action_http___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionEvent", function() { return __WEBPACK_IMPORTED_MODULE_313_material_ui_lib_svg_icons_action_event___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionStars", function() { return __WEBPACK_IMPORTED_MODULE_314_material_ui_lib_svg_icons_action_stars___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionInvertColors", function() { return __WEBPACK_IMPORTED_MODULE_315_material_ui_lib_svg_icons_action_invert_colors___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSpeakerNotes", function() { return __WEBPACK_IMPORTED_MODULE_316_material_ui_lib_svg_icons_action_speaker_notes___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionOpenWith", function() { return __WEBPACK_IMPORTED_MODULE_317_material_ui_lib_svg_icons_action_open_with___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionHelp", function() { return __WEBPACK_IMPORTED_MODULE_318_material_ui_lib_svg_icons_action_help___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionHourglassEmpty", function() { return __WEBPACK_IMPORTED_MODULE_319_material_ui_lib_svg_icons_action_hourglass_empty___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAssignmentInd", function() { return __WEBPACK_IMPORTED_MODULE_320_material_ui_lib_svg_icons_action_assignment_ind___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAssessment", function() { return __WEBPACK_IMPORTED_MODULE_321_material_ui_lib_svg_icons_action_assessment___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionCode", function() { return __WEBPACK_IMPORTED_MODULE_322_material_ui_lib_svg_icons_action_code___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAlarm", function() { return __WEBPACK_IMPORTED_MODULE_323_material_ui_lib_svg_icons_action_alarm___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPowerSettingsNew", function() { return __WEBPACK_IMPORTED_MODULE_324_material_ui_lib_svg_icons_action_power_settings_new___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSystemUpdateAlt", function() { return __WEBPACK_IMPORTED_MODULE_325_material_ui_lib_svg_icons_action_system_update_alt___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionToll", function() { return __WEBPACK_IMPORTED_MODULE_326_material_ui_lib_svg_icons_action_toll___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionNoteAdd", function() { return __WEBPACK_IMPORTED_MODULE_327_material_ui_lib_svg_icons_action_note_add___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionCardTravel", function() { return __WEBPACK_IMPORTED_MODULE_328_material_ui_lib_svg_icons_action_card_travel___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsRemote", function() { return __WEBPACK_IMPORTED_MODULE_329_material_ui_lib_svg_icons_action_settings_remote___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionBook", function() { return __WEBPACK_IMPORTED_MODULE_330_material_ui_lib_svg_icons_action_book___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionStore", function() { return __WEBPACK_IMPORTED_MODULE_331_material_ui_lib_svg_icons_action_store___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSubject", function() { return __WEBPACK_IMPORTED_MODULE_332_material_ui_lib_svg_icons_action_subject___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionViewCarousel", function() { return __WEBPACK_IMPORTED_MODULE_333_material_ui_lib_svg_icons_action_view_carousel___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionReorder", function() { return __WEBPACK_IMPORTED_MODULE_334_material_ui_lib_svg_icons_action_reorder___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionVisibility", function() { return __WEBPACK_IMPORTED_MODULE_335_material_ui_lib_svg_icons_action_visibility___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAccountBox", function() { return __WEBPACK_IMPORTED_MODULE_336_material_ui_lib_svg_icons_action_account_box___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionFavorite", function() { return __WEBPACK_IMPORTED_MODULE_337_material_ui_lib_svg_icons_action_favorite___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsInputHdmi", function() { return __WEBPACK_IMPORTED_MODULE_338_material_ui_lib_svg_icons_action_settings_input_hdmi___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionTurnedIn", function() { return __WEBPACK_IMPORTED_MODULE_339_material_ui_lib_svg_icons_action_turned_in___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionDescription", function() { return __WEBPACK_IMPORTED_MODULE_340_material_ui_lib_svg_icons_action_description___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionHelpOutline", function() { return __WEBPACK_IMPORTED_MODULE_341_material_ui_lib_svg_icons_action_help_outline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionTrendingDown", function() { return __WEBPACK_IMPORTED_MODULE_342_material_ui_lib_svg_icons_action_trending_down___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionFlightLand", function() { return __WEBPACK_IMPORTED_MODULE_343_material_ui_lib_svg_icons_action_flight_land___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionFlipToFront", function() { return __WEBPACK_IMPORTED_MODULE_344_material_ui_lib_svg_icons_action_flip_to_front___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionToday", function() { return __WEBPACK_IMPORTED_MODULE_345_material_ui_lib_svg_icons_action_today___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionShoppingBasket", function() { return __WEBPACK_IMPORTED_MODULE_346_material_ui_lib_svg_icons_action_shopping_basket___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsBrightness", function() { return __WEBPACK_IMPORTED_MODULE_347_material_ui_lib_svg_icons_action_settings_brightness___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPictureInPicture", function() { return __WEBPACK_IMPORTED_MODULE_348_material_ui_lib_svg_icons_action_picture_in_picture___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionZoomIn", function() { return __WEBPACK_IMPORTED_MODULE_349_material_ui_lib_svg_icons_action_zoom_in___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionShopTwo", function() { return __WEBPACK_IMPORTED_MODULE_350_material_ui_lib_svg_icons_action_shop_two___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionClass", function() { return __WEBPACK_IMPORTED_MODULE_351_material_ui_lib_svg_icons_action_class___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSwapHoriz", function() { return __WEBPACK_IMPORTED_MODULE_352_material_ui_lib_svg_icons_action_swap_horiz___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPermScanWifi", function() { return __WEBPACK_IMPORTED_MODULE_353_material_ui_lib_svg_icons_action_perm_scan_wifi___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionFlightTakeoff", function() { return __WEBPACK_IMPORTED_MODULE_354_material_ui_lib_svg_icons_action_flight_takeoff___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionGrade", function() { return __WEBPACK_IMPORTED_MODULE_355_material_ui_lib_svg_icons_action_grade___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionHome", function() { return __WEBPACK_IMPORTED_MODULE_356_material_ui_lib_svg_icons_action_home___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionBackup", function() { return __WEBPACK_IMPORTED_MODULE_357_material_ui_lib_svg_icons_action_backup___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsInputComponent", function() { return __WEBPACK_IMPORTED_MODULE_358_material_ui_lib_svg_icons_action_settings_input_component___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionTranslate", function() { return __WEBPACK_IMPORTED_MODULE_359_material_ui_lib_svg_icons_action_translate___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsVoice", function() { return __WEBPACK_IMPORTED_MODULE_360_material_ui_lib_svg_icons_action_settings_voice___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionThumbsUpDown", function() { return __WEBPACK_IMPORTED_MODULE_361_material_ui_lib_svg_icons_action_thumbs_up_down___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionViewQuilt", function() { return __WEBPACK_IMPORTED_MODULE_362_material_ui_lib_svg_icons_action_view_quilt___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionDns", function() { return __WEBPACK_IMPORTED_MODULE_363_material_ui_lib_svg_icons_action_dns___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionRestore", function() { return __WEBPACK_IMPORTED_MODULE_364_material_ui_lib_svg_icons_action_restore___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsOverscan", function() { return __WEBPACK_IMPORTED_MODULE_365_material_ui_lib_svg_icons_action_settings_overscan___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionDoneAll", function() { return __WEBPACK_IMPORTED_MODULE_366_material_ui_lib_svg_icons_action_done_all___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSupervisorAccount", function() { return __WEBPACK_IMPORTED_MODULE_367_material_ui_lib_svg_icons_action_supervisor_account___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionLanguage", function() { return __WEBPACK_IMPORTED_MODULE_368_material_ui_lib_svg_icons_action_language___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionPermIdentity", function() { return __WEBPACK_IMPORTED_MODULE_369_material_ui_lib_svg_icons_action_perm_identity___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionYoutubeSearchedFor", function() { return __WEBPACK_IMPORTED_MODULE_370_material_ui_lib_svg_icons_action_youtube_searched_for___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAssignmentReturn", function() { return __WEBPACK_IMPORTED_MODULE_371_material_ui_lib_svg_icons_action_assignment_return___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionAnnouncement", function() { return __WEBPACK_IMPORTED_MODULE_372_material_ui_lib_svg_icons_action_announcement___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSettingsPower", function() { return __WEBPACK_IMPORTED_MODULE_373_material_ui_lib_svg_icons_action_settings_power___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionRoom", function() { return __WEBPACK_IMPORTED_MODULE_374_material_ui_lib_svg_icons_action_room___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionFindReplace", function() { return __WEBPACK_IMPORTED_MODULE_375_material_ui_lib_svg_icons_action_find_replace___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionThreeDRotation", function() { return __WEBPACK_IMPORTED_MODULE_376_material_ui_lib_svg_icons_action_three_d_rotation___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionChromeReaderMode", function() { return __WEBPACK_IMPORTED_MODULE_377_material_ui_lib_svg_icons_action_chrome_reader_mode___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionCameraEnhance", function() { return __WEBPACK_IMPORTED_MODULE_378_material_ui_lib_svg_icons_action_camera_enhance___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionHistory", function() { return __WEBPACK_IMPORTED_MODULE_379_material_ui_lib_svg_icons_action_history___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ActionSpellcheck", function() { return __WEBPACK_IMPORTED_MODULE_380_material_ui_lib_svg_icons_action_spellcheck___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialNotificationsOff", function() { return __WEBPACK_IMPORTED_MODULE_381_material_ui_lib_svg_icons_social_notifications_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialPersonAdd", function() { return __WEBPACK_IMPORTED_MODULE_382_material_ui_lib_svg_icons_social_person_add___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialShare", function() { return __WEBPACK_IMPORTED_MODULE_383_material_ui_lib_svg_icons_social_share___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialGroupAdd", function() { return __WEBPACK_IMPORTED_MODULE_384_material_ui_lib_svg_icons_social_group_add___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialGroup", function() { return __WEBPACK_IMPORTED_MODULE_385_material_ui_lib_svg_icons_social_group___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialNotificationsNone", function() { return __WEBPACK_IMPORTED_MODULE_386_material_ui_lib_svg_icons_social_notifications_none___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialMoodBad", function() { return __WEBPACK_IMPORTED_MODULE_387_material_ui_lib_svg_icons_social_mood_bad___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialPlusOne", function() { return __WEBPACK_IMPORTED_MODULE_388_material_ui_lib_svg_icons_social_plus_one___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialMood", function() { return __WEBPACK_IMPORTED_MODULE_389_material_ui_lib_svg_icons_social_mood___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialPersonOutline", function() { return __WEBPACK_IMPORTED_MODULE_390_material_ui_lib_svg_icons_social_person_outline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialPoll", function() { return __WEBPACK_IMPORTED_MODULE_391_material_ui_lib_svg_icons_social_poll___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialLocationCity", function() { return __WEBPACK_IMPORTED_MODULE_392_material_ui_lib_svg_icons_social_location_city___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialPerson", function() { return __WEBPACK_IMPORTED_MODULE_393_material_ui_lib_svg_icons_social_person___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialPeopleOutline", function() { return __WEBPACK_IMPORTED_MODULE_394_material_ui_lib_svg_icons_social_people_outline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialCake", function() { return __WEBPACK_IMPORTED_MODULE_395_material_ui_lib_svg_icons_social_cake___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialWhatshot", function() { return __WEBPACK_IMPORTED_MODULE_396_material_ui_lib_svg_icons_social_whatshot___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialNotificationsPaused", function() { return __WEBPACK_IMPORTED_MODULE_397_material_ui_lib_svg_icons_social_notifications_paused___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialPublic", function() { return __WEBPACK_IMPORTED_MODULE_398_material_ui_lib_svg_icons_social_public___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialPages", function() { return __WEBPACK_IMPORTED_MODULE_399_material_ui_lib_svg_icons_social_pages___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialPeople", function() { return __WEBPACK_IMPORTED_MODULE_400_material_ui_lib_svg_icons_social_people___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialNotifications", function() { return __WEBPACK_IMPORTED_MODULE_401_material_ui_lib_svg_icons_social_notifications___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialNotificationsActive", function() { return __WEBPACK_IMPORTED_MODULE_402_material_ui_lib_svg_icons_social_notifications_active___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialSchool", function() { return __WEBPACK_IMPORTED_MODULE_403_material_ui_lib_svg_icons_social_school___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialDomain", function() { return __WEBPACK_IMPORTED_MODULE_404_material_ui_lib_svg_icons_social_domain___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SocialPartyMode", function() { return __WEBPACK_IMPORTED_MODULE_405_material_ui_lib_svg_icons_social_party_mode___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvNotInterested", function() { return __WEBPACK_IMPORTED_MODULE_406_material_ui_lib_svg_icons_av_not_interested___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvPauseCircleOutline", function() { return __WEBPACK_IMPORTED_MODULE_407_material_ui_lib_svg_icons_av_pause_circle_outline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvNewReleases", function() { return __WEBPACK_IMPORTED_MODULE_408_material_ui_lib_svg_icons_av_new_releases___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvMic", function() { return __WEBPACK_IMPORTED_MODULE_409_material_ui_lib_svg_icons_av_mic___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvSkipPrevious", function() { return __WEBPACK_IMPORTED_MODULE_410_material_ui_lib_svg_icons_av_skip_previous___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvReplay5", function() { return __WEBPACK_IMPORTED_MODULE_411_material_ui_lib_svg_icons_av_replay_5___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvMovie", function() { return __WEBPACK_IMPORTED_MODULE_412_material_ui_lib_svg_icons_av_movie___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvForward10", function() { return __WEBPACK_IMPORTED_MODULE_413_material_ui_lib_svg_icons_av_forward_10___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvGames", function() { return __WEBPACK_IMPORTED_MODULE_414_material_ui_lib_svg_icons_av_games___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvHighQuality", function() { return __WEBPACK_IMPORTED_MODULE_415_material_ui_lib_svg_icons_av_high_quality___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvExplicit", function() { return __WEBPACK_IMPORTED_MODULE_416_material_ui_lib_svg_icons_av_explicit___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvHd", function() { return __WEBPACK_IMPORTED_MODULE_417_material_ui_lib_svg_icons_av_hd___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvAlbum", function() { return __WEBPACK_IMPORTED_MODULE_418_material_ui_lib_svg_icons_av_album___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvRepeatOne", function() { return __WEBPACK_IMPORTED_MODULE_419_material_ui_lib_svg_icons_av_repeat_one___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvSkipNext", function() { return __WEBPACK_IMPORTED_MODULE_420_material_ui_lib_svg_icons_av_skip_next___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvLibraryBooks", function() { return __WEBPACK_IMPORTED_MODULE_421_material_ui_lib_svg_icons_av_library_books___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvVolumeMute", function() { return __WEBPACK_IMPORTED_MODULE_422_material_ui_lib_svg_icons_av_volume_mute___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvLibraryMusic", function() { return __WEBPACK_IMPORTED_MODULE_423_material_ui_lib_svg_icons_av_library_music___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvPlayArrow", function() { return __WEBPACK_IMPORTED_MODULE_424_material_ui_lib_svg_icons_av_play_arrow___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvRadio", function() { return __WEBPACK_IMPORTED_MODULE_425_material_ui_lib_svg_icons_av_radio___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvFastRewind", function() { return __WEBPACK_IMPORTED_MODULE_426_material_ui_lib_svg_icons_av_fast_rewind___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvReplay", function() { return __WEBPACK_IMPORTED_MODULE_427_material_ui_lib_svg_icons_av_replay___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvHearing", function() { return __WEBPACK_IMPORTED_MODULE_428_material_ui_lib_svg_icons_av_hearing___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvPause", function() { return __WEBPACK_IMPORTED_MODULE_429_material_ui_lib_svg_icons_av_pause___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvEqualizer", function() { return __WEBPACK_IMPORTED_MODULE_430_material_ui_lib_svg_icons_av_equalizer___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvVolumeUp", function() { return __WEBPACK_IMPORTED_MODULE_431_material_ui_lib_svg_icons_av_volume_up___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvFastForward", function() { return __WEBPACK_IMPORTED_MODULE_432_material_ui_lib_svg_icons_av_fast_forward___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvSurroundSound", function() { return __WEBPACK_IMPORTED_MODULE_433_material_ui_lib_svg_icons_av_surround_sound___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvForward30", function() { return __WEBPACK_IMPORTED_MODULE_434_material_ui_lib_svg_icons_av_forward_30___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvQueueMusic", function() { return __WEBPACK_IMPORTED_MODULE_435_material_ui_lib_svg_icons_av_queue_music___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvReplay30", function() { return __WEBPACK_IMPORTED_MODULE_436_material_ui_lib_svg_icons_av_replay_30___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvSortByAlpha", function() { return __WEBPACK_IMPORTED_MODULE_437_material_ui_lib_svg_icons_av_sort_by_alpha___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvSubtitles", function() { return __WEBPACK_IMPORTED_MODULE_438_material_ui_lib_svg_icons_av_subtitles___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvClosedCaption", function() { return __WEBPACK_IMPORTED_MODULE_439_material_ui_lib_svg_icons_av_closed_caption___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvVideoLibrary", function() { return __WEBPACK_IMPORTED_MODULE_440_material_ui_lib_svg_icons_av_video_library___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvWeb", function() { return __WEBPACK_IMPORTED_MODULE_441_material_ui_lib_svg_icons_av_web___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvMicNone", function() { return __WEBPACK_IMPORTED_MODULE_442_material_ui_lib_svg_icons_av_mic_none___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvShuffle", function() { return __WEBPACK_IMPORTED_MODULE_443_material_ui_lib_svg_icons_av_shuffle___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvStop", function() { return __WEBPACK_IMPORTED_MODULE_444_material_ui_lib_svg_icons_av_stop___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvPlayCircleOutline", function() { return __WEBPACK_IMPORTED_MODULE_445_material_ui_lib_svg_icons_av_play_circle_outline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvVideocamOff", function() { return __WEBPACK_IMPORTED_MODULE_446_material_ui_lib_svg_icons_av_videocam_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvQueue", function() { return __WEBPACK_IMPORTED_MODULE_447_material_ui_lib_svg_icons_av_queue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvVolumeDown", function() { return __WEBPACK_IMPORTED_MODULE_448_material_ui_lib_svg_icons_av_volume_down___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvVideocam", function() { return __WEBPACK_IMPORTED_MODULE_449_material_ui_lib_svg_icons_av_videocam___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvRepeat", function() { return __WEBPACK_IMPORTED_MODULE_450_material_ui_lib_svg_icons_av_repeat___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvRecentActors", function() { return __WEBPACK_IMPORTED_MODULE_451_material_ui_lib_svg_icons_av_recent_actors___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvForward5", function() { return __WEBPACK_IMPORTED_MODULE_452_material_ui_lib_svg_icons_av_forward_5___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvLoop", function() { return __WEBPACK_IMPORTED_MODULE_453_material_ui_lib_svg_icons_av_loop___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvLibraryAdd", function() { return __WEBPACK_IMPORTED_MODULE_454_material_ui_lib_svg_icons_av_library_add___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvPlayCircleFilled", function() { return __WEBPACK_IMPORTED_MODULE_455_material_ui_lib_svg_icons_av_play_circle_filled___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvPlaylistAdd", function() { return __WEBPACK_IMPORTED_MODULE_456_material_ui_lib_svg_icons_av_playlist_add___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvMicOff", function() { return __WEBPACK_IMPORTED_MODULE_457_material_ui_lib_svg_icons_av_mic_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvReplay10", function() { return __WEBPACK_IMPORTED_MODULE_458_material_ui_lib_svg_icons_av_replay_10___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvAvTimer", function() { return __WEBPACK_IMPORTED_MODULE_459_material_ui_lib_svg_icons_av_av_timer___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvVolumeOff", function() { return __WEBPACK_IMPORTED_MODULE_460_material_ui_lib_svg_icons_av_volume_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvPauseCircleFilled", function() { return __WEBPACK_IMPORTED_MODULE_461_material_ui_lib_svg_icons_av_pause_circle_filled___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvAirplay", function() { return __WEBPACK_IMPORTED_MODULE_462_material_ui_lib_svg_icons_av_airplay___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AvSnooze", function() { return __WEBPACK_IMPORTED_MODULE_463_material_ui_lib_svg_icons_av_snooze___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBrush", function() { return __WEBPACK_IMPORTED_MODULE_464_material_ui_lib_svg_icons_image_brush___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageLooksOne", function() { return __WEBPACK_IMPORTED_MODULE_465_material_ui_lib_svg_icons_image_looks_one___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageDetails", function() { return __WEBPACK_IMPORTED_MODULE_466_material_ui_lib_svg_icons_image_details___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageTimer3", function() { return __WEBPACK_IMPORTED_MODULE_467_material_ui_lib_svg_icons_image_timer_3___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilterNone", function() { return __WEBPACK_IMPORTED_MODULE_468_material_ui_lib_svg_icons_image_filter_none___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageLooks3", function() { return __WEBPACK_IMPORTED_MODULE_469_material_ui_lib_svg_icons_image_looks_3___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilter9", function() { return __WEBPACK_IMPORTED_MODULE_470_material_ui_lib_svg_icons_image_filter_9___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilter", function() { return __WEBPACK_IMPORTED_MODULE_471_material_ui_lib_svg_icons_image_filter___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageAssistantPhoto", function() { return __WEBPACK_IMPORTED_MODULE_472_material_ui_lib_svg_icons_image_assistant_photo___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageWbCloudy", function() { return __WEBPACK_IMPORTED_MODULE_473_material_ui_lib_svg_icons_image_wb_cloudy___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBrightness1", function() { return __WEBPACK_IMPORTED_MODULE_474_material_ui_lib_svg_icons_image_brightness_1___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePanoramaWideAngle", function() { return __WEBPACK_IMPORTED_MODULE_475_material_ui_lib_svg_icons_image_panorama_wide_angle___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePanoramaFishEye", function() { return __WEBPACK_IMPORTED_MODULE_476_material_ui_lib_svg_icons_image_panorama_fish_eye___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePortrait", function() { return __WEBPACK_IMPORTED_MODULE_477_material_ui_lib_svg_icons_image_portrait___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBrightness5", function() { return __WEBPACK_IMPORTED_MODULE_478_material_ui_lib_svg_icons_image_brightness_5___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageExposureZero", function() { return __WEBPACK_IMPORTED_MODULE_479_material_ui_lib_svg_icons_image_exposure_zero___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageExposureNeg2", function() { return __WEBPACK_IMPORTED_MODULE_480_material_ui_lib_svg_icons_image_exposure_neg_2___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageWbAuto", function() { return __WEBPACK_IMPORTED_MODULE_481_material_ui_lib_svg_icons_image_wb_auto___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageHdrOff", function() { return __WEBPACK_IMPORTED_MODULE_482_material_ui_lib_svg_icons_image_hdr_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageNaturePeople", function() { return __WEBPACK_IMPORTED_MODULE_483_material_ui_lib_svg_icons_image_nature_people___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageAudiotrack", function() { return __WEBPACK_IMPORTED_MODULE_484_material_ui_lib_svg_icons_image_audiotrack___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCropPortrait", function() { return __WEBPACK_IMPORTED_MODULE_485_material_ui_lib_svg_icons_image_crop_portrait___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageColorize", function() { return __WEBPACK_IMPORTED_MODULE_486_material_ui_lib_svg_icons_image_colorize___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCompare", function() { return __WEBPACK_IMPORTED_MODULE_487_material_ui_lib_svg_icons_image_compare___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilter2", function() { return __WEBPACK_IMPORTED_MODULE_488_material_ui_lib_svg_icons_image_filter_2___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageTagFaces", function() { return __WEBPACK_IMPORTED_MODULE_489_material_ui_lib_svg_icons_image_tag_faces___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBlurCircular", function() { return __WEBPACK_IMPORTED_MODULE_490_material_ui_lib_svg_icons_image_blur_circular___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageLens", function() { return __WEBPACK_IMPORTED_MODULE_491_material_ui_lib_svg_icons_image_lens___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageTune", function() { return __WEBPACK_IMPORTED_MODULE_492_material_ui_lib_svg_icons_image_tune___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageViewComfy", function() { return __WEBPACK_IMPORTED_MODULE_493_material_ui_lib_svg_icons_image_view_comfy___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCameraRoll", function() { return __WEBPACK_IMPORTED_MODULE_494_material_ui_lib_svg_icons_image_camera_roll___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCenterFocusStrong", function() { return __WEBPACK_IMPORTED_MODULE_495_material_ui_lib_svg_icons_image_center_focus_strong___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFlashOff", function() { return __WEBPACK_IMPORTED_MODULE_496_material_ui_lib_svg_icons_image_flash_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCollectionsBookmark", function() { return __WEBPACK_IMPORTED_MODULE_497_material_ui_lib_svg_icons_image_collections_bookmark___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePhotoSizeSelectActual", function() { return __WEBPACK_IMPORTED_MODULE_498_material_ui_lib_svg_icons_image_photo_size_select_actual___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageImageAspectRatio", function() { return __WEBPACK_IMPORTED_MODULE_499_material_ui_lib_svg_icons_image_image_aspect_ratio___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilterHdr", function() { return __WEBPACK_IMPORTED_MODULE_500_material_ui_lib_svg_icons_image_filter_hdr___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageRotateRight", function() { return __WEBPACK_IMPORTED_MODULE_501_material_ui_lib_svg_icons_image_rotate_right___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilterTiltShift", function() { return __WEBPACK_IMPORTED_MODULE_502_material_ui_lib_svg_icons_image_filter_tilt_shift___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCropFree", function() { return __WEBPACK_IMPORTED_MODULE_503_material_ui_lib_svg_icons_image_crop_free___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageStyle", function() { return __WEBPACK_IMPORTED_MODULE_504_material_ui_lib_svg_icons_image_style___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageNature", function() { return __WEBPACK_IMPORTED_MODULE_505_material_ui_lib_svg_icons_image_nature___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePhotoSizeSelectLarge", function() { return __WEBPACK_IMPORTED_MODULE_506_material_ui_lib_svg_icons_image_photo_size_select_large___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageAdjust", function() { return __WEBPACK_IMPORTED_MODULE_507_material_ui_lib_svg_icons_image_adjust___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFlare", function() { return __WEBPACK_IMPORTED_MODULE_508_material_ui_lib_svg_icons_image_flare___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageWbIridescent", function() { return __WEBPACK_IMPORTED_MODULE_509_material_ui_lib_svg_icons_image_wb_iridescent___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilterDrama", function() { return __WEBPACK_IMPORTED_MODULE_510_material_ui_lib_svg_icons_image_filter_drama___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBrightness7", function() { return __WEBPACK_IMPORTED_MODULE_511_material_ui_lib_svg_icons_image_brightness_7___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBlurOn", function() { return __WEBPACK_IMPORTED_MODULE_512_material_ui_lib_svg_icons_image_blur_on___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageTimer10", function() { return __WEBPACK_IMPORTED_MODULE_513_material_ui_lib_svg_icons_image_timer_10___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFlashOn", function() { return __WEBPACK_IMPORTED_MODULE_514_material_ui_lib_svg_icons_image_flash_on___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePhotoLibrary", function() { return __WEBPACK_IMPORTED_MODULE_515_material_ui_lib_svg_icons_image_photo_library___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBlurLinear", function() { return __WEBPACK_IMPORTED_MODULE_516_material_ui_lib_svg_icons_image_blur_linear___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCamera", function() { return __WEBPACK_IMPORTED_MODULE_517_material_ui_lib_svg_icons_image_camera___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageTimelapse", function() { return __WEBPACK_IMPORTED_MODULE_518_material_ui_lib_svg_icons_image_timelapse___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageLoupe", function() { return __WEBPACK_IMPORTED_MODULE_519_material_ui_lib_svg_icons_image_loupe___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageExposurePlus1", function() { return __WEBPACK_IMPORTED_MODULE_520_material_ui_lib_svg_icons_image_exposure_plus_1___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageExposurePlus2", function() { return __WEBPACK_IMPORTED_MODULE_521_material_ui_lib_svg_icons_image_exposure_plus_2___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFlashAuto", function() { return __WEBPACK_IMPORTED_MODULE_522_material_ui_lib_svg_icons_image_flash_auto___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePalette", function() { return __WEBPACK_IMPORTED_MODULE_523_material_ui_lib_svg_icons_image_palette___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCropDin", function() { return __WEBPACK_IMPORTED_MODULE_524_material_ui_lib_svg_icons_image_crop_din___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCrop169", function() { return __WEBPACK_IMPORTED_MODULE_525_material_ui_lib_svg_icons_image_crop_16_9___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageSlideshow", function() { return __WEBPACK_IMPORTED_MODULE_526_material_ui_lib_svg_icons_image_slideshow___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilter1", function() { return __WEBPACK_IMPORTED_MODULE_527_material_ui_lib_svg_icons_image_filter_1___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCrop75", function() { return __WEBPACK_IMPORTED_MODULE_528_material_ui_lib_svg_icons_image_crop_7_5___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageMusicNote", function() { return __WEBPACK_IMPORTED_MODULE_529_material_ui_lib_svg_icons_image_music_note___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCropLandscape", function() { return __WEBPACK_IMPORTED_MODULE_530_material_ui_lib_svg_icons_image_crop_landscape___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCrop32", function() { return __WEBPACK_IMPORTED_MODULE_531_material_ui_lib_svg_icons_image_crop_3_2___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageTimer", function() { return __WEBPACK_IMPORTED_MODULE_532_material_ui_lib_svg_icons_image_timer___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageWbIncandescent", function() { return __WEBPACK_IMPORTED_MODULE_533_material_ui_lib_svg_icons_image_wb_incandescent___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageLooks5", function() { return __WEBPACK_IMPORTED_MODULE_534_material_ui_lib_svg_icons_image_looks_5___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageGradient", function() { return __WEBPACK_IMPORTED_MODULE_535_material_ui_lib_svg_icons_image_gradient___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageViewCompact", function() { return __WEBPACK_IMPORTED_MODULE_536_material_ui_lib_svg_icons_image_view_compact___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCenterFocusWeak", function() { return __WEBPACK_IMPORTED_MODULE_537_material_ui_lib_svg_icons_image_center_focus_weak___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageLooks", function() { return __WEBPACK_IMPORTED_MODULE_538_material_ui_lib_svg_icons_image_looks___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCollections", function() { return __WEBPACK_IMPORTED_MODULE_539_material_ui_lib_svg_icons_image_collections___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageMonochromePhotos", function() { return __WEBPACK_IMPORTED_MODULE_540_material_ui_lib_svg_icons_image_monochrome_photos___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBlurOff", function() { return __WEBPACK_IMPORTED_MODULE_541_material_ui_lib_svg_icons_image_blur_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePhotoSizeSelectSmall", function() { return __WEBPACK_IMPORTED_MODULE_542_material_ui_lib_svg_icons_image_photo_size_select_small___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilter6", function() { return __WEBPACK_IMPORTED_MODULE_543_material_ui_lib_svg_icons_image_filter_6___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCameraRear", function() { return __WEBPACK_IMPORTED_MODULE_544_material_ui_lib_svg_icons_image_camera_rear___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageRotateLeft", function() { return __WEBPACK_IMPORTED_MODULE_545_material_ui_lib_svg_icons_image_rotate_left___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilter7", function() { return __WEBPACK_IMPORTED_MODULE_546_material_ui_lib_svg_icons_image_filter_7___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageEdit", function() { return __WEBPACK_IMPORTED_MODULE_547_material_ui_lib_svg_icons_image_edit___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilter9Plus", function() { return __WEBPACK_IMPORTED_MODULE_548_material_ui_lib_svg_icons_image_filter_9_plus___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageLeakRemove", function() { return __WEBPACK_IMPORTED_MODULE_549_material_ui_lib_svg_icons_image_leak_remove___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageTexture", function() { return __WEBPACK_IMPORTED_MODULE_550_material_ui_lib_svg_icons_image_texture___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBrightness6", function() { return __WEBPACK_IMPORTED_MODULE_551_material_ui_lib_svg_icons_image_brightness_6___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCropOriginal", function() { return __WEBPACK_IMPORTED_MODULE_552_material_ui_lib_svg_icons_image_crop_original___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageNavigateNext", function() { return __WEBPACK_IMPORTED_MODULE_553_material_ui_lib_svg_icons_image_navigate_next___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilterCenterFocus", function() { return __WEBPACK_IMPORTED_MODULE_554_material_ui_lib_svg_icons_image_filter_center_focus___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageAssistant", function() { return __WEBPACK_IMPORTED_MODULE_555_material_ui_lib_svg_icons_image_assistant___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFlip", function() { return __WEBPACK_IMPORTED_MODULE_556_material_ui_lib_svg_icons_image_flip___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCropSquare", function() { return __WEBPACK_IMPORTED_MODULE_557_material_ui_lib_svg_icons_image_crop_square___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageVignette", function() { return __WEBPACK_IMPORTED_MODULE_558_material_ui_lib_svg_icons_image_vignette___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageExposure", function() { return __WEBPACK_IMPORTED_MODULE_559_material_ui_lib_svg_icons_image_exposure___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePanoramaHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_560_material_ui_lib_svg_icons_image_panorama_horizontal___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePanorama", function() { return __WEBPACK_IMPORTED_MODULE_561_material_ui_lib_svg_icons_image_panorama___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCrop", function() { return __WEBPACK_IMPORTED_MODULE_562_material_ui_lib_svg_icons_image_crop___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageControlPoint", function() { return __WEBPACK_IMPORTED_MODULE_563_material_ui_lib_svg_icons_image_control_point___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageRotate90DegreesCcw", function() { return __WEBPACK_IMPORTED_MODULE_564_material_ui_lib_svg_icons_image_rotate_90_degrees_ccw___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilterBAndW", function() { return __WEBPACK_IMPORTED_MODULE_565_material_ui_lib_svg_icons_image_filter_b_and_w___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageGridOff", function() { return __WEBPACK_IMPORTED_MODULE_566_material_ui_lib_svg_icons_image_grid_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBrightness3", function() { return __WEBPACK_IMPORTED_MODULE_567_material_ui_lib_svg_icons_image_brightness_3___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilter8", function() { return __WEBPACK_IMPORTED_MODULE_568_material_ui_lib_svg_icons_image_filter_8___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageLeakAdd", function() { return __WEBPACK_IMPORTED_MODULE_569_material_ui_lib_svg_icons_image_leak_add___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageRemoveRedEye", function() { return __WEBPACK_IMPORTED_MODULE_570_material_ui_lib_svg_icons_image_remove_red_eye___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePhotoCamera", function() { return __WEBPACK_IMPORTED_MODULE_571_material_ui_lib_svg_icons_image_photo_camera___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageStraighten", function() { return __WEBPACK_IMPORTED_MODULE_572_material_ui_lib_svg_icons_image_straighten___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilter4", function() { return __WEBPACK_IMPORTED_MODULE_573_material_ui_lib_svg_icons_image_filter_4___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageGridOn", function() { return __WEBPACK_IMPORTED_MODULE_574_material_ui_lib_svg_icons_image_grid_on___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilter3", function() { return __WEBPACK_IMPORTED_MODULE_575_material_ui_lib_svg_icons_image_filter_3___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageLandscape", function() { return __WEBPACK_IMPORTED_MODULE_576_material_ui_lib_svg_icons_image_landscape___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilterFrames", function() { return __WEBPACK_IMPORTED_MODULE_577_material_ui_lib_svg_icons_image_filter_frames___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageIso", function() { return __WEBPACK_IMPORTED_MODULE_578_material_ui_lib_svg_icons_image_iso___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageTonality", function() { return __WEBPACK_IMPORTED_MODULE_579_material_ui_lib_svg_icons_image_tonality___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageDehaze", function() { return __WEBPACK_IMPORTED_MODULE_580_material_ui_lib_svg_icons_image_dehaze___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageHdrStrong", function() { return __WEBPACK_IMPORTED_MODULE_581_material_ui_lib_svg_icons_image_hdr_strong___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageHealing", function() { return __WEBPACK_IMPORTED_MODULE_582_material_ui_lib_svg_icons_image_healing___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageHdrWeak", function() { return __WEBPACK_IMPORTED_MODULE_583_material_ui_lib_svg_icons_image_hdr_weak___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilterVintage", function() { return __WEBPACK_IMPORTED_MODULE_584_material_ui_lib_svg_icons_image_filter_vintage___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageFilter5", function() { return __WEBPACK_IMPORTED_MODULE_585_material_ui_lib_svg_icons_image_filter_5___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageImage", function() { return __WEBPACK_IMPORTED_MODULE_586_material_ui_lib_svg_icons_image_image___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageColorLens", function() { return __WEBPACK_IMPORTED_MODULE_587_material_ui_lib_svg_icons_image_color_lens___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageLooks4", function() { return __WEBPACK_IMPORTED_MODULE_588_material_ui_lib_svg_icons_image_looks_4___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePanoramaVertical", function() { return __WEBPACK_IMPORTED_MODULE_589_material_ui_lib_svg_icons_image_panorama_vertical___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBrightness4", function() { return __WEBPACK_IMPORTED_MODULE_590_material_ui_lib_svg_icons_image_brightness_4___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageLooks6", function() { return __WEBPACK_IMPORTED_MODULE_591_material_ui_lib_svg_icons_image_looks_6___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageControlPointDuplicate", function() { return __WEBPACK_IMPORTED_MODULE_592_material_ui_lib_svg_icons_image_control_point_duplicate___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCrop54", function() { return __WEBPACK_IMPORTED_MODULE_593_material_ui_lib_svg_icons_image_crop_5_4___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageHdrOn", function() { return __WEBPACK_IMPORTED_MODULE_594_material_ui_lib_svg_icons_image_hdr_on___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePhotoAlbum", function() { return __WEBPACK_IMPORTED_MODULE_595_material_ui_lib_svg_icons_image_photo_album___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageNavigateBefore", function() { return __WEBPACK_IMPORTED_MODULE_596_material_ui_lib_svg_icons_image_navigate_before___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageSwitchVideo", function() { return __WEBPACK_IMPORTED_MODULE_597_material_ui_lib_svg_icons_image_switch_video___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageWbSunny", function() { return __WEBPACK_IMPORTED_MODULE_598_material_ui_lib_svg_icons_image_wb_sunny___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageAddToPhotos", function() { return __WEBPACK_IMPORTED_MODULE_599_material_ui_lib_svg_icons_image_add_to_photos___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePhoto", function() { return __WEBPACK_IMPORTED_MODULE_600_material_ui_lib_svg_icons_image_photo___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBrokenImage", function() { return __WEBPACK_IMPORTED_MODULE_601_material_ui_lib_svg_icons_image_broken_image___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImagePictureAsPdf", function() { return __WEBPACK_IMPORTED_MODULE_602_material_ui_lib_svg_icons_image_picture_as_pdf___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageTransform", function() { return __WEBPACK_IMPORTED_MODULE_603_material_ui_lib_svg_icons_image_transform___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCameraAlt", function() { return __WEBPACK_IMPORTED_MODULE_604_material_ui_lib_svg_icons_image_camera_alt___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageBrightness2", function() { return __WEBPACK_IMPORTED_MODULE_605_material_ui_lib_svg_icons_image_brightness_2___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageMovieCreation", function() { return __WEBPACK_IMPORTED_MODULE_606_material_ui_lib_svg_icons_image_movie_creation___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageGrain", function() { return __WEBPACK_IMPORTED_MODULE_607_material_ui_lib_svg_icons_image_grain___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageLooksTwo", function() { return __WEBPACK_IMPORTED_MODULE_608_material_ui_lib_svg_icons_image_looks_two___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageTimerOff", function() { return __WEBPACK_IMPORTED_MODULE_609_material_ui_lib_svg_icons_image_timer_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageExposureNeg1", function() { return __WEBPACK_IMPORTED_MODULE_610_material_ui_lib_svg_icons_image_exposure_neg_1___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageCameraFront", function() { return __WEBPACK_IMPORTED_MODULE_611_material_ui_lib_svg_icons_image_camera_front___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ImageSwitchCamera", function() { return __WEBPACK_IMPORTED_MODULE_612_material_ui_lib_svg_icons_image_switch_camera___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentForward", function() { return __WEBPACK_IMPORTED_MODULE_613_material_ui_lib_svg_icons_content_forward___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentSelectAll", function() { return __WEBPACK_IMPORTED_MODULE_614_material_ui_lib_svg_icons_content_select_all___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentDrafts", function() { return __WEBPACK_IMPORTED_MODULE_615_material_ui_lib_svg_icons_content_drafts___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentContentCopy", function() { return __WEBPACK_IMPORTED_MODULE_616_material_ui_lib_svg_icons_content_content_copy___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentFlag", function() { return __WEBPACK_IMPORTED_MODULE_617_material_ui_lib_svg_icons_content_flag___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentTextFormat", function() { return __WEBPACK_IMPORTED_MODULE_618_material_ui_lib_svg_icons_content_text_format___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentReplyAll", function() { return __WEBPACK_IMPORTED_MODULE_619_material_ui_lib_svg_icons_content_reply_all___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentReply", function() { return __WEBPACK_IMPORTED_MODULE_620_material_ui_lib_svg_icons_content_reply___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentRemoveCircle", function() { return __WEBPACK_IMPORTED_MODULE_621_material_ui_lib_svg_icons_content_remove_circle___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentAddCircle", function() { return __WEBPACK_IMPORTED_MODULE_622_material_ui_lib_svg_icons_content_add_circle___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentLink", function() { return __WEBPACK_IMPORTED_MODULE_623_material_ui_lib_svg_icons_content_link___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentMail", function() { return __WEBPACK_IMPORTED_MODULE_624_material_ui_lib_svg_icons_content_mail___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentArchive", function() { return __WEBPACK_IMPORTED_MODULE_625_material_ui_lib_svg_icons_content_archive___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentSave", function() { return __WEBPACK_IMPORTED_MODULE_626_material_ui_lib_svg_icons_content_save___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentRemove", function() { return __WEBPACK_IMPORTED_MODULE_627_material_ui_lib_svg_icons_content_remove___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentFontDownload", function() { return __WEBPACK_IMPORTED_MODULE_628_material_ui_lib_svg_icons_content_font_download___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentRemoveCircleOutline", function() { return __WEBPACK_IMPORTED_MODULE_629_material_ui_lib_svg_icons_content_remove_circle_outline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentCreate", function() { return __WEBPACK_IMPORTED_MODULE_630_material_ui_lib_svg_icons_content_create___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentClear", function() { return __WEBPACK_IMPORTED_MODULE_631_material_ui_lib_svg_icons_content_clear___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentContentCut", function() { return __WEBPACK_IMPORTED_MODULE_632_material_ui_lib_svg_icons_content_content_cut___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentRedo", function() { return __WEBPACK_IMPORTED_MODULE_633_material_ui_lib_svg_icons_content_redo___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentMarkunread", function() { return __WEBPACK_IMPORTED_MODULE_634_material_ui_lib_svg_icons_content_markunread___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentContentPaste", function() { return __WEBPACK_IMPORTED_MODULE_635_material_ui_lib_svg_icons_content_content_paste___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentBackspace", function() { return __WEBPACK_IMPORTED_MODULE_636_material_ui_lib_svg_icons_content_backspace___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentReport", function() { return __WEBPACK_IMPORTED_MODULE_637_material_ui_lib_svg_icons_content_report___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentSort", function() { return __WEBPACK_IMPORTED_MODULE_638_material_ui_lib_svg_icons_content_sort___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentInbox", function() { return __WEBPACK_IMPORTED_MODULE_639_material_ui_lib_svg_icons_content_inbox___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentGesture", function() { return __WEBPACK_IMPORTED_MODULE_640_material_ui_lib_svg_icons_content_gesture___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentBlock", function() { return __WEBPACK_IMPORTED_MODULE_641_material_ui_lib_svg_icons_content_block___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentAdd", function() { return __WEBPACK_IMPORTED_MODULE_642_material_ui_lib_svg_icons_content_add___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentUndo", function() { return __WEBPACK_IMPORTED_MODULE_643_material_ui_lib_svg_icons_content_undo___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentAddBox", function() { return __WEBPACK_IMPORTED_MODULE_644_material_ui_lib_svg_icons_content_add_box___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentAddCircleOutline", function() { return __WEBPACK_IMPORTED_MODULE_645_material_ui_lib_svg_icons_content_add_circle_outline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentFilterList", function() { return __WEBPACK_IMPORTED_MODULE_646_material_ui_lib_svg_icons_content_filter_list___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ContentSend", function() { return __WEBPACK_IMPORTED_MODULE_647_material_ui_lib_svg_icons_content_send___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationSyncProblem", function() { return __WEBPACK_IMPORTED_MODULE_648_material_ui_lib_svg_icons_notification_sync_problem___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationAirlineSeatIndividualSuite", function() { return __WEBPACK_IMPORTED_MODULE_649_material_ui_lib_svg_icons_notification_airline_seat_individual_suite___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationVpnLock", function() { return __WEBPACK_IMPORTED_MODULE_650_material_ui_lib_svg_icons_notification_vpn_lock___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationAirlineSeatLegroomExtra", function() { return __WEBPACK_IMPORTED_MODULE_651_material_ui_lib_svg_icons_notification_airline_seat_legroom_extra___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationWifi", function() { return __WEBPACK_IMPORTED_MODULE_652_material_ui_lib_svg_icons_notification_wifi___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationTapAndPlay", function() { return __WEBPACK_IMPORTED_MODULE_653_material_ui_lib_svg_icons_notification_tap_and_play___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationAirlineSeatFlatAngled", function() { return __WEBPACK_IMPORTED_MODULE_654_material_ui_lib_svg_icons_notification_airline_seat_flat_angled___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationWc", function() { return __WEBPACK_IMPORTED_MODULE_655_material_ui_lib_svg_icons_notification_wc___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationSms", function() { return __WEBPACK_IMPORTED_MODULE_656_material_ui_lib_svg_icons_notification_sms___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationBluetoothAudio", function() { return __WEBPACK_IMPORTED_MODULE_657_material_ui_lib_svg_icons_notification_bluetooth_audio___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationFolderSpecial", function() { return __WEBPACK_IMPORTED_MODULE_658_material_ui_lib_svg_icons_notification_folder_special___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationSimCardAlert", function() { return __WEBPACK_IMPORTED_MODULE_659_material_ui_lib_svg_icons_notification_sim_card_alert___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationEventNote", function() { return __WEBPACK_IMPORTED_MODULE_660_material_ui_lib_svg_icons_notification_event_note___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationPersonalVideo", function() { return __WEBPACK_IMPORTED_MODULE_661_material_ui_lib_svg_icons_notification_personal_video___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationLiveTv", function() { return __WEBPACK_IMPORTED_MODULE_662_material_ui_lib_svg_icons_notification_live_tv___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationTimeToLeave", function() { return __WEBPACK_IMPORTED_MODULE_663_material_ui_lib_svg_icons_notification_time_to_leave___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationAdb", function() { return __WEBPACK_IMPORTED_MODULE_664_material_ui_lib_svg_icons_notification_adb___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationConfirmationNumber", function() { return __WEBPACK_IMPORTED_MODULE_665_material_ui_lib_svg_icons_notification_confirmation_number___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationAirlineSeatFlat", function() { return __WEBPACK_IMPORTED_MODULE_666_material_ui_lib_svg_icons_notification_airline_seat_flat___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationSync", function() { return __WEBPACK_IMPORTED_MODULE_667_material_ui_lib_svg_icons_notification_sync___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationVoiceChat", function() { return __WEBPACK_IMPORTED_MODULE_668_material_ui_lib_svg_icons_notification_voice_chat___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationPhoneLocked", function() { return __WEBPACK_IMPORTED_MODULE_669_material_ui_lib_svg_icons_notification_phone_locked___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationPhoneForwarded", function() { return __WEBPACK_IMPORTED_MODULE_670_material_ui_lib_svg_icons_notification_phone_forwarded___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationSystemUpdate", function() { return __WEBPACK_IMPORTED_MODULE_671_material_ui_lib_svg_icons_notification_system_update___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationMore", function() { return __WEBPACK_IMPORTED_MODULE_672_material_ui_lib_svg_icons_notification_more___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationMms", function() { return __WEBPACK_IMPORTED_MODULE_673_material_ui_lib_svg_icons_notification_mms___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationPhoneInTalk", function() { return __WEBPACK_IMPORTED_MODULE_674_material_ui_lib_svg_icons_notification_phone_in_talk___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationAirlineSeatReclineExtra", function() { return __WEBPACK_IMPORTED_MODULE_675_material_ui_lib_svg_icons_notification_airline_seat_recline_extra___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationPhoneBluetoothSpeaker", function() { return __WEBPACK_IMPORTED_MODULE_676_material_ui_lib_svg_icons_notification_phone_bluetooth_speaker___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationAirlineSeatLegroomNormal", function() { return __WEBPACK_IMPORTED_MODULE_677_material_ui_lib_svg_icons_notification_airline_seat_legroom_normal___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationDoNotDisturbAlt", function() { return __WEBPACK_IMPORTED_MODULE_678_material_ui_lib_svg_icons_notification_do_not_disturb_alt___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationOndemandVideo", function() { return __WEBPACK_IMPORTED_MODULE_679_material_ui_lib_svg_icons_notification_ondemand_video___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationEventBusy", function() { return __WEBPACK_IMPORTED_MODULE_680_material_ui_lib_svg_icons_notification_event_busy___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationDoNotDisturb", function() { return __WEBPACK_IMPORTED_MODULE_681_material_ui_lib_svg_icons_notification_do_not_disturb___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationDriveEta", function() { return __WEBPACK_IMPORTED_MODULE_682_material_ui_lib_svg_icons_notification_drive_eta___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationAirlineSeatLegroomReduced", function() { return __WEBPACK_IMPORTED_MODULE_683_material_ui_lib_svg_icons_notification_airline_seat_legroom_reduced___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationSyncDisabled", function() { return __WEBPACK_IMPORTED_MODULE_684_material_ui_lib_svg_icons_notification_sync_disabled___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationPhoneMissed", function() { return __WEBPACK_IMPORTED_MODULE_685_material_ui_lib_svg_icons_notification_phone_missed___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationEventAvailable", function() { return __WEBPACK_IMPORTED_MODULE_686_material_ui_lib_svg_icons_notification_event_available___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationAirlineSeatReclineNormal", function() { return __WEBPACK_IMPORTED_MODULE_687_material_ui_lib_svg_icons_notification_airline_seat_recline_normal___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationVibration", function() { return __WEBPACK_IMPORTED_MODULE_688_material_ui_lib_svg_icons_notification_vibration___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationPower", function() { return __WEBPACK_IMPORTED_MODULE_689_material_ui_lib_svg_icons_notification_power___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationSdCard", function() { return __WEBPACK_IMPORTED_MODULE_690_material_ui_lib_svg_icons_notification_sd_card___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationPhonePaused", function() { return __WEBPACK_IMPORTED_MODULE_691_material_ui_lib_svg_icons_notification_phone_paused___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationDiscFull", function() { return __WEBPACK_IMPORTED_MODULE_692_material_ui_lib_svg_icons_notification_disc_full___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationSmsFailed", function() { return __WEBPACK_IMPORTED_MODULE_693_material_ui_lib_svg_icons_notification_sms_failed___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NotificationNetworkLocked", function() { return __WEBPACK_IMPORTED_MODULE_694_material_ui_lib_svg_icons_notification_network_locked___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwarePowerInput", function() { return __WEBPACK_IMPORTED_MODULE_695_material_ui_lib_svg_icons_hardware_power_input___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareWatch", function() { return __WEBPACK_IMPORTED_MODULE_696_material_ui_lib_svg_icons_hardware_watch___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareGamepad", function() { return __WEBPACK_IMPORTED_MODULE_697_material_ui_lib_svg_icons_hardware_gamepad___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareLaptop", function() { return __WEBPACK_IMPORTED_MODULE_698_material_ui_lib_svg_icons_hardware_laptop___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareKeyboardBackspace", function() { return __WEBPACK_IMPORTED_MODULE_699_material_ui_lib_svg_icons_hardware_keyboard_backspace___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareSmartphone", function() { return __WEBPACK_IMPORTED_MODULE_700_material_ui_lib_svg_icons_hardware_smartphone___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwarePhonelinkOff", function() { return __WEBPACK_IMPORTED_MODULE_701_material_ui_lib_svg_icons_hardware_phonelink_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwarePhoneAndroid", function() { return __WEBPACK_IMPORTED_MODULE_702_material_ui_lib_svg_icons_hardware_phone_android___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareMouse", function() { return __WEBPACK_IMPORTED_MODULE_703_material_ui_lib_svg_icons_hardware_mouse___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareLaptopChromebook", function() { return __WEBPACK_IMPORTED_MODULE_704_material_ui_lib_svg_icons_hardware_laptop_chromebook___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareSecurity", function() { return __WEBPACK_IMPORTED_MODULE_705_material_ui_lib_svg_icons_hardware_security___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareTv", function() { return __WEBPACK_IMPORTED_MODULE_706_material_ui_lib_svg_icons_hardware_tv___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareSpeakerGroup", function() { return __WEBPACK_IMPORTED_MODULE_707_material_ui_lib_svg_icons_hardware_speaker_group___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareKeyboardArrowUp", function() { return __WEBPACK_IMPORTED_MODULE_708_material_ui_lib_svg_icons_hardware_keyboard_arrow_up___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareSimCard", function() { return __WEBPACK_IMPORTED_MODULE_709_material_ui_lib_svg_icons_hardware_sim_card___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareCastConnected", function() { return __WEBPACK_IMPORTED_MODULE_710_material_ui_lib_svg_icons_hardware_cast_connected___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareMemory", function() { return __WEBPACK_IMPORTED_MODULE_711_material_ui_lib_svg_icons_hardware_memory___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareDesktopMac", function() { return __WEBPACK_IMPORTED_MODULE_712_material_ui_lib_svg_icons_hardware_desktop_mac___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareDesktopWindows", function() { return __WEBPACK_IMPORTED_MODULE_713_material_ui_lib_svg_icons_hardware_desktop_windows___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareSpeaker", function() { return __WEBPACK_IMPORTED_MODULE_714_material_ui_lib_svg_icons_hardware_speaker___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareToys", function() { return __WEBPACK_IMPORTED_MODULE_715_material_ui_lib_svg_icons_hardware_toys___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareKeyboardHide", function() { return __WEBPACK_IMPORTED_MODULE_716_material_ui_lib_svg_icons_hardware_keyboard_hide___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareRouter", function() { return __WEBPACK_IMPORTED_MODULE_717_material_ui_lib_svg_icons_hardware_router___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareTabletAndroid", function() { return __WEBPACK_IMPORTED_MODULE_718_material_ui_lib_svg_icons_hardware_tablet_android___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareHeadset", function() { return __WEBPACK_IMPORTED_MODULE_719_material_ui_lib_svg_icons_hardware_headset___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareLaptopWindows", function() { return __WEBPACK_IMPORTED_MODULE_720_material_ui_lib_svg_icons_hardware_laptop_windows___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareKeyboardArrowLeft", function() { return __WEBPACK_IMPORTED_MODULE_721_material_ui_lib_svg_icons_hardware_keyboard_arrow_left___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareLaptopMac", function() { return __WEBPACK_IMPORTED_MODULE_722_material_ui_lib_svg_icons_hardware_laptop_mac___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareTabletMac", function() { return __WEBPACK_IMPORTED_MODULE_723_material_ui_lib_svg_icons_hardware_tablet_mac___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareKeyboardArrowRight", function() { return __WEBPACK_IMPORTED_MODULE_724_material_ui_lib_svg_icons_hardware_keyboard_arrow_right___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareKeyboard", function() { return __WEBPACK_IMPORTED_MODULE_725_material_ui_lib_svg_icons_hardware_keyboard___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwarePhoneIphone", function() { return __WEBPACK_IMPORTED_MODULE_726_material_ui_lib_svg_icons_hardware_phone_iphone___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareDeveloperBoard", function() { return __WEBPACK_IMPORTED_MODULE_727_material_ui_lib_svg_icons_hardware_developer_board___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareDeviceHub", function() { return __WEBPACK_IMPORTED_MODULE_728_material_ui_lib_svg_icons_hardware_device_hub___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareKeyboardReturn", function() { return __WEBPACK_IMPORTED_MODULE_729_material_ui_lib_svg_icons_hardware_keyboard_return___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareHeadsetMic", function() { return __WEBPACK_IMPORTED_MODULE_730_material_ui_lib_svg_icons_hardware_headset_mic___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareTablet", function() { return __WEBPACK_IMPORTED_MODULE_731_material_ui_lib_svg_icons_hardware_tablet___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwarePhonelink", function() { return __WEBPACK_IMPORTED_MODULE_732_material_ui_lib_svg_icons_hardware_phonelink___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareKeyboardTab", function() { return __WEBPACK_IMPORTED_MODULE_733_material_ui_lib_svg_icons_hardware_keyboard_tab___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareComputer", function() { return __WEBPACK_IMPORTED_MODULE_734_material_ui_lib_svg_icons_hardware_computer___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareCast", function() { return __WEBPACK_IMPORTED_MODULE_735_material_ui_lib_svg_icons_hardware_cast___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareKeyboardArrowDown", function() { return __WEBPACK_IMPORTED_MODULE_736_material_ui_lib_svg_icons_hardware_keyboard_arrow_down___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareDock", function() { return __WEBPACK_IMPORTED_MODULE_737_material_ui_lib_svg_icons_hardware_dock___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareKeyboardVoice", function() { return __WEBPACK_IMPORTED_MODULE_738_material_ui_lib_svg_icons_hardware_keyboard_voice___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareScanner", function() { return __WEBPACK_IMPORTED_MODULE_739_material_ui_lib_svg_icons_hardware_scanner___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "HardwareKeyboardCapslock", function() { return __WEBPACK_IMPORTED_MODULE_740_material_ui_lib_svg_icons_hardware_keyboard_capslock___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AlertWarning", function() { return __WEBPACK_IMPORTED_MODULE_741_material_ui_lib_svg_icons_alert_warning___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AlertErrorOutline", function() { return __WEBPACK_IMPORTED_MODULE_742_material_ui_lib_svg_icons_alert_error_outline___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AlertAddAlert", function() { return __WEBPACK_IMPORTED_MODULE_743_material_ui_lib_svg_icons_alert_add_alert___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AlertError", function() { return __WEBPACK_IMPORTED_MODULE_744_material_ui_lib_svg_icons_alert_error___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceNetworkWifi", function() { return __WEBPACK_IMPORTED_MODULE_745_material_ui_lib_svg_icons_device_network_wifi___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalWifi0Bar", function() { return __WEBPACK_IMPORTED_MODULE_746_material_ui_lib_svg_icons_device_signal_wifi_0_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellular4Bar", function() { return __WEBPACK_IMPORTED_MODULE_747_material_ui_lib_svg_icons_device_signal_cellular_4_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceAccessAlarm", function() { return __WEBPACK_IMPORTED_MODULE_748_material_ui_lib_svg_icons_device_access_alarm___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceWallpaper", function() { return __WEBPACK_IMPORTED_MODULE_749_material_ui_lib_svg_icons_device_wallpaper___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceDataUsage", function() { return __WEBPACK_IMPORTED_MODULE_750_material_ui_lib_svg_icons_device_data_usage___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellularConnectedNoInternet1Bar", function() { return __WEBPACK_IMPORTED_MODULE_751_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_1_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBatteryCharging80", function() { return __WEBPACK_IMPORTED_MODULE_752_material_ui_lib_svg_icons_device_battery_charging_80___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceLocationSearching", function() { return __WEBPACK_IMPORTED_MODULE_753_material_ui_lib_svg_icons_device_location_searching___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellular0Bar", function() { return __WEBPACK_IMPORTED_MODULE_754_material_ui_lib_svg_icons_device_signal_cellular_0_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSettingsSystemDaydream", function() { return __WEBPACK_IMPORTED_MODULE_755_material_ui_lib_svg_icons_device_settings_system_daydream___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBatteryChargingFull", function() { return __WEBPACK_IMPORTED_MODULE_756_material_ui_lib_svg_icons_device_battery_charging_full___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceScreenLockLandscape", function() { return __WEBPACK_IMPORTED_MODULE_757_material_ui_lib_svg_icons_device_screen_lock_landscape___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBluetoothConnected", function() { return __WEBPACK_IMPORTED_MODULE_758_material_ui_lib_svg_icons_device_bluetooth_connected___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSdStorage", function() { return __WEBPACK_IMPORTED_MODULE_759_material_ui_lib_svg_icons_device_sd_storage___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceWidgets", function() { return __WEBPACK_IMPORTED_MODULE_760_material_ui_lib_svg_icons_device_widgets___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBrightnessHigh", function() { return __WEBPACK_IMPORTED_MODULE_761_material_ui_lib_svg_icons_device_brightness_high___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceWifiLock", function() { return __WEBPACK_IMPORTED_MODULE_762_material_ui_lib_svg_icons_device_wifi_lock___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBatteryCharging60", function() { return __WEBPACK_IMPORTED_MODULE_763_material_ui_lib_svg_icons_device_battery_charging_60___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBrightnessAuto", function() { return __WEBPACK_IMPORTED_MODULE_764_material_ui_lib_svg_icons_device_brightness_auto___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBattery60", function() { return __WEBPACK_IMPORTED_MODULE_765_material_ui_lib_svg_icons_device_battery_60___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBatteryCharging20", function() { return __WEBPACK_IMPORTED_MODULE_766_material_ui_lib_svg_icons_device_battery_charging_20___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellular3Bar", function() { return __WEBPACK_IMPORTED_MODULE_767_material_ui_lib_svg_icons_device_signal_cellular_3_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellular2Bar", function() { return __WEBPACK_IMPORTED_MODULE_768_material_ui_lib_svg_icons_device_signal_cellular_2_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBatteryCharging50", function() { return __WEBPACK_IMPORTED_MODULE_769_material_ui_lib_svg_icons_device_battery_charging_50___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBattery50", function() { return __WEBPACK_IMPORTED_MODULE_770_material_ui_lib_svg_icons_device_battery_50___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceWifiTethering", function() { return __WEBPACK_IMPORTED_MODULE_771_material_ui_lib_svg_icons_device_wifi_tethering___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBattery20", function() { return __WEBPACK_IMPORTED_MODULE_772_material_ui_lib_svg_icons_device_battery_20___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellularConnectedNoInternet2Bar", function() { return __WEBPACK_IMPORTED_MODULE_773_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_2_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceAccessAlarms", function() { return __WEBPACK_IMPORTED_MODULE_774_material_ui_lib_svg_icons_device_access_alarms___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalWifi1Bar", function() { return __WEBPACK_IMPORTED_MODULE_775_material_ui_lib_svg_icons_device_signal_wifi_1_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceScreenLockPortrait", function() { return __WEBPACK_IMPORTED_MODULE_776_material_ui_lib_svg_icons_device_screen_lock_portrait___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceAccessTime", function() { return __WEBPACK_IMPORTED_MODULE_777_material_ui_lib_svg_icons_device_access_time___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBattery80", function() { return __WEBPACK_IMPORTED_MODULE_778_material_ui_lib_svg_icons_device_battery_80___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceGpsOff", function() { return __WEBPACK_IMPORTED_MODULE_779_material_ui_lib_svg_icons_device_gps_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceScreenLockRotation", function() { return __WEBPACK_IMPORTED_MODULE_780_material_ui_lib_svg_icons_device_screen_lock_rotation___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBatteryUnknown", function() { return __WEBPACK_IMPORTED_MODULE_781_material_ui_lib_svg_icons_device_battery_unknown___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceGpsNotFixed", function() { return __WEBPACK_IMPORTED_MODULE_782_material_ui_lib_svg_icons_device_gps_not_fixed___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalWifi3BarLock", function() { return __WEBPACK_IMPORTED_MODULE_783_material_ui_lib_svg_icons_device_signal_wifi_3_bar_lock___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceNfc", function() { return __WEBPACK_IMPORTED_MODULE_784_material_ui_lib_svg_icons_device_nfc___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceDvr", function() { return __WEBPACK_IMPORTED_MODULE_785_material_ui_lib_svg_icons_device_dvr___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellular1Bar", function() { return __WEBPACK_IMPORTED_MODULE_786_material_ui_lib_svg_icons_device_signal_cellular_1_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceAirplanemodeActive", function() { return __WEBPACK_IMPORTED_MODULE_787_material_ui_lib_svg_icons_device_airplanemode_active___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBattery90", function() { return __WEBPACK_IMPORTED_MODULE_788_material_ui_lib_svg_icons_device_battery_90___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBluetoothSearching", function() { return __WEBPACK_IMPORTED_MODULE_789_material_ui_lib_svg_icons_device_bluetooth_searching___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceStorage", function() { return __WEBPACK_IMPORTED_MODULE_790_material_ui_lib_svg_icons_device_storage___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellularNoSim", function() { return __WEBPACK_IMPORTED_MODULE_791_material_ui_lib_svg_icons_device_signal_cellular_no_sim___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBrightnessMedium", function() { return __WEBPACK_IMPORTED_MODULE_792_material_ui_lib_svg_icons_device_brightness_medium___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceLocationDisabled", function() { return __WEBPACK_IMPORTED_MODULE_793_material_ui_lib_svg_icons_device_location_disabled___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalWifi2BarLock", function() { return __WEBPACK_IMPORTED_MODULE_794_material_ui_lib_svg_icons_device_signal_wifi_2_bar_lock___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalWifiOff", function() { return __WEBPACK_IMPORTED_MODULE_795_material_ui_lib_svg_icons_device_signal_wifi_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBatteryFull", function() { return __WEBPACK_IMPORTED_MODULE_796_material_ui_lib_svg_icons_device_battery_full___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBluetooth", function() { return __WEBPACK_IMPORTED_MODULE_797_material_ui_lib_svg_icons_device_bluetooth___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellularConnectedNoInternet3Bar", function() { return __WEBPACK_IMPORTED_MODULE_798_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_3_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalWifi1BarLock", function() { return __WEBPACK_IMPORTED_MODULE_799_material_ui_lib_svg_icons_device_signal_wifi_1_bar_lock___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellularNull", function() { return __WEBPACK_IMPORTED_MODULE_800_material_ui_lib_svg_icons_device_signal_cellular_null___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBrightnessLow", function() { return __WEBPACK_IMPORTED_MODULE_801_material_ui_lib_svg_icons_device_brightness_low___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBatteryCharging90", function() { return __WEBPACK_IMPORTED_MODULE_802_material_ui_lib_svg_icons_device_battery_charging_90___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalWifi3Bar", function() { return __WEBPACK_IMPORTED_MODULE_803_material_ui_lib_svg_icons_device_signal_wifi_3_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellularOff", function() { return __WEBPACK_IMPORTED_MODULE_804_material_ui_lib_svg_icons_device_signal_cellular_off___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellularConnectedNoInternet0Bar", function() { return __WEBPACK_IMPORTED_MODULE_805_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_0_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBluetoothDisabled", function() { return __WEBPACK_IMPORTED_MODULE_806_material_ui_lib_svg_icons_device_bluetooth_disabled___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceDevices", function() { return __WEBPACK_IMPORTED_MODULE_807_material_ui_lib_svg_icons_device_devices___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceAddAlarm", function() { return __WEBPACK_IMPORTED_MODULE_808_material_ui_lib_svg_icons_device_add_alarm___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceGraphicEq", function() { return __WEBPACK_IMPORTED_MODULE_809_material_ui_lib_svg_icons_device_graphic_eq___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBatteryAlert", function() { return __WEBPACK_IMPORTED_MODULE_810_material_ui_lib_svg_icons_device_battery_alert___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalWifi4BarLock", function() { return __WEBPACK_IMPORTED_MODULE_811_material_ui_lib_svg_icons_device_signal_wifi_4_bar_lock___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalWifi4Bar", function() { return __WEBPACK_IMPORTED_MODULE_812_material_ui_lib_svg_icons_device_signal_wifi_4_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalCellularConnectedNoInternet4Bar", function() { return __WEBPACK_IMPORTED_MODULE_813_material_ui_lib_svg_icons_device_signal_cellular_connected_no_internet_4_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceDeveloperMode", function() { return __WEBPACK_IMPORTED_MODULE_814_material_ui_lib_svg_icons_device_developer_mode___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceGpsFixed", function() { return __WEBPACK_IMPORTED_MODULE_815_material_ui_lib_svg_icons_device_gps_fixed___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBatteryStd", function() { return __WEBPACK_IMPORTED_MODULE_816_material_ui_lib_svg_icons_device_battery_std___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBattery30", function() { return __WEBPACK_IMPORTED_MODULE_817_material_ui_lib_svg_icons_device_battery_30___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceAirplanemodeInactive", function() { return __WEBPACK_IMPORTED_MODULE_818_material_ui_lib_svg_icons_device_airplanemode_inactive___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceSignalWifi2Bar", function() { return __WEBPACK_IMPORTED_MODULE_819_material_ui_lib_svg_icons_device_signal_wifi_2_bar___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceNetworkCell", function() { return __WEBPACK_IMPORTED_MODULE_820_material_ui_lib_svg_icons_device_network_cell___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceUsb", function() { return __WEBPACK_IMPORTED_MODULE_821_material_ui_lib_svg_icons_device_usb___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceBatteryCharging30", function() { return __WEBPACK_IMPORTED_MODULE_822_material_ui_lib_svg_icons_device_battery_charging_30___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DeviceScreenRotation", function() { return __WEBPACK_IMPORTED_MODULE_823_material_ui_lib_svg_icons_device_screen_rotation___default.a; });
/* global require */

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

function classNames() {
	var classes = '';
	var arg;

	for (var i = 0; i < arguments.length; i++) {
		arg = arguments[i];
		if (!arg) {
			continue;
		}

		if ('string' === typeof arg || 'number' === typeof arg) {
			classes += ' ' + arg;
		} else if (Object.prototype.toString.call(arg) === '[object Array]') {
			classes += ' ' + classNames.apply(null, arg);
		} else if ('object' === typeof arg) {
			for (var key in arg) {
				if (!arg.hasOwnProperty(key) || !arg[key]) {
					continue;
				}
				classes += ' ' + key;
			}
		}
	}
	return classes.substr(1);
}

// safely export classNames for node / browserify
if (typeof module !== 'undefined' && module.exports) {
	module.exports = classNames;
}

// safely export classNames for RequireJS
if (true) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return classNames;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin__ = __webpack_require__(2042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RefluxMixin__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Authorizer__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Media__ = __webpack_require__(374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__mixin__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__RefluxMixin__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Authorizer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Media__["a"]; });


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ImmutabilityHelper = __webpack_require__(162);
var Styles = __webpack_require__(348);

// This mixin isn't necessary and will be removed in v0.11

/**
 *	@params:
 *	styles = Current styles.
 *  props = New style properties that will override the current style.
 */
module.exports = {

  propTypes: {
    style: React.PropTypes.object
  },

  //Moved this function to ImmutabilityHelper.merge
  mergeStyles: function mergeStyles() {
    return ImmutabilityHelper.merge.apply(this, arguments);
  },

  //Moved this function to /utils/styles.js
  mergeAndPrefix: function mergeAndPrefix() {
    return Styles.mergeAndPrefix.apply(this, arguments);
  },

  // prepareStyles is used to merge multiple styles, make sure they are flipped to rtl
  // if needed, and then autoprefix them. It should probably always be used instead of
  // mergeAndPrefix.
  //
  // Never call this on the same style object twice. As a rule of thumb,
  //   only call it when passing style attribute to html elements.
  // If you call it twice you'll get a warning anyway.
  prepareStyles: function prepareStyles() {
    return Styles.prepareStyles.apply(Styles, [this.state && this.state.muiTheme || this.context.muiTheme].concat([].slice.apply(arguments)));
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Colors = __webpack_require__(53);
var ColorManipulator = __webpack_require__(95);
var Spacing = __webpack_require__(349);

/*
 *  Light Theme is the default theme used in material-ui. It is guaranteed to
 *  have all theme variables needed for every component. Variables not defined
 *  in a custom theme will default to these values.
 */

module.exports = {
  spacing: Spacing,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: Colors.cyan500,
    primary2Color: Colors.cyan700,
    primary3Color: Colors.lightBlack,
    accent1Color: Colors.pinkA200,
    accent2Color: Colors.grey100,
    accent3Color: Colors.grey500,
    textColor: Colors.darkBlack,
    alternateTextColor: Colors.white,
    canvasColor: Colors.white,
    borderColor: Colors.grey300,
    disabledColor: ColorManipulator.fade(Colors.darkBlack, 0.3)
  }
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Colors = __webpack_require__(53);
var ColorManipulator = __webpack_require__(95);
var Extend = __webpack_require__(350);
var update = __webpack_require__(243);

module.exports = {

  //get the MUI theme corresponding to a raw theme
  getMuiTheme: function getMuiTheme(rawTheme) {
    var returnObj = {
      appBar: {
        color: rawTheme.palette.primary1Color,
        textColor: rawTheme.palette.alternateTextColor,
        height: rawTheme.spacing.desktopKeylineIncrement
      },
      avatar: {
        borderColor: 'rgba(0, 0, 0, 0.08)'
      },
      button: {
        height: 36,
        minWidth: 88,
        iconButtonSize: rawTheme.spacing.iconSize * 2
      },
      checkbox: {
        boxColor: rawTheme.palette.textColor,
        checkedColor: rawTheme.palette.primary1Color,
        requiredColor: rawTheme.palette.primary1Color,
        disabledColor: rawTheme.palette.disabledColor,
        labelColor: rawTheme.palette.textColor,
        labelDisabledColor: rawTheme.palette.disabledColor
      },
      datePicker: {
        color: rawTheme.palette.primary1Color,
        textColor: rawTheme.palette.alternateTextColor,
        calendarTextColor: rawTheme.palette.textColor,
        selectColor: rawTheme.palette.primary2Color,
        selectTextColor: rawTheme.palette.alternateTextColor
      },
      dropDownMenu: {
        accentColor: rawTheme.palette.borderColor
      },
      flatButton: {
        color: rawTheme.palette.alternateTextColor,
        textColor: rawTheme.palette.textColor,
        primaryTextColor: rawTheme.palette.accent1Color,
        secondaryTextColor: rawTheme.palette.primary1Color
      },
      floatingActionButton: {
        buttonSize: 56,
        miniSize: 40,
        color: rawTheme.palette.accent1Color,
        iconColor: rawTheme.palette.alternateTextColor,
        secondaryColor: rawTheme.palette.primary1Color,
        secondaryIconColor: rawTheme.palette.alternateTextColor,
        disabledTextColor: rawTheme.palette.disabledColor
      },
      gridTile: {
        textColor: Colors.white
      },
      inkBar: {
        backgroundColor: rawTheme.palette.accent1Color
      },
      leftNav: {
        width: rawTheme.spacing.desktopKeylineIncrement * 4,
        color: rawTheme.palette.canvasColor
      },
      listItem: {
        nestedLevelDepth: 18
      },
      menu: {
        backgroundColor: rawTheme.palette.canvasColor,
        containerBackgroundColor: rawTheme.palette.canvasColor
      },
      menuItem: {
        dataHeight: 32,
        height: 48,
        hoverColor: 'rgba(0, 0, 0, .035)',
        padding: rawTheme.spacing.desktopGutter,
        selectedTextColor: rawTheme.palette.accent1Color
      },
      menuSubheader: {
        padding: rawTheme.spacing.desktopGutter,
        borderColor: rawTheme.palette.borderColor,
        textColor: rawTheme.palette.primary1Color
      },
      paper: {
        backgroundColor: rawTheme.palette.canvasColor
      },
      radioButton: {
        borderColor: rawTheme.palette.textColor,
        backgroundColor: rawTheme.palette.alternateTextColor,
        checkedColor: rawTheme.palette.primary1Color,
        requiredColor: rawTheme.palette.primary1Color,
        disabledColor: rawTheme.palette.disabledColor,
        size: 24,
        labelColor: rawTheme.palette.textColor,
        labelDisabledColor: rawTheme.palette.disabledColor
      },
      raisedButton: {
        color: rawTheme.palette.alternateTextColor,
        textColor: rawTheme.palette.textColor,
        primaryColor: rawTheme.palette.accent1Color,
        primaryTextColor: rawTheme.palette.alternateTextColor,
        secondaryColor: rawTheme.palette.primary1Color,
        secondaryTextColor: rawTheme.palette.alternateTextColor
      },
      refreshIndicator: {
        strokeColor: rawTheme.palette.borderColor,
        loadingStrokeColor: rawTheme.palette.primary1Color
      },
      slider: {
        trackSize: 2,
        trackColor: rawTheme.palette.primary3Color,
        trackColorSelected: rawTheme.palette.accent3Color,
        handleSize: 12,
        handleSizeDisabled: 8,
        handleSizeActive: 18,
        handleColorZero: rawTheme.palette.borderColor,
        handleFillColor: rawTheme.palette.alternateTextColor,
        selectionColor: rawTheme.palette.primary1Color,
        rippleColor: rawTheme.palette.primary1Color
      },
      snackbar: {
        textColor: rawTheme.palette.alternateTextColor,
        backgroundColor: rawTheme.palette.textColor,
        actionColor: rawTheme.palette.accent1Color
      },
      table: {
        backgroundColor: rawTheme.palette.canvasColor
      },
      tableHeader: {
        borderColor: rawTheme.palette.borderColor
      },
      tableHeaderColumn: {
        textColor: rawTheme.palette.primary3Color,
        height: 56,
        spacing: 24
      },
      tableFooter: {
        borderColor: rawTheme.palette.borderColor,
        textColor: rawTheme.palette.primary3Color
      },
      tableRow: {
        hoverColor: rawTheme.palette.accent2Color,
        stripeColor: ColorManipulator.lighten(rawTheme.palette.primary1Color, 0.55),
        selectedColor: rawTheme.palette.borderColor,
        textColor: rawTheme.palette.textColor,
        borderColor: rawTheme.palette.borderColor
      },
      tableRowColumn: {
        height: 48,
        spacing: 24
      },
      timePicker: {
        color: rawTheme.palette.alternateTextColor,
        textColor: rawTheme.palette.accent3Color,
        accentColor: rawTheme.palette.primary1Color,
        clockColor: rawTheme.palette.primary3Color,
        selectColor: rawTheme.palette.primary2Color,
        selectTextColor: rawTheme.palette.alternateTextColor
      },
      toggle: {
        thumbOnColor: rawTheme.palette.primary1Color,
        thumbOffColor: rawTheme.palette.accent2Color,
        thumbDisabledColor: rawTheme.palette.borderColor,
        thumbRequiredColor: rawTheme.palette.primary1Color,
        trackOnColor: ColorManipulator.fade(rawTheme.palette.primary1Color, 0.5),
        trackOffColor: rawTheme.palette.primary3Color,
        trackDisabledColor: rawTheme.palette.primary3Color,
        labelColor: rawTheme.palette.textColor,
        labelDisabledColor: rawTheme.palette.disabledColor
      },
      toolbar: {
        backgroundColor: ColorManipulator.darken(rawTheme.palette.accent2Color, 0.05),
        height: 56,
        titleFontSize: 20,
        iconColor: 'rgba(0, 0, 0, .40)',
        separatorColor: 'rgba(0, 0, 0, .175)',
        menuHoverColor: 'rgba(0, 0, 0, .10)'
      },
      tabs: {
        backgroundColor: rawTheme.palette.primary1Color
      },
      textField: {
        textColor: rawTheme.palette.textColor,
        hintColor: rawTheme.palette.disabledColor,
        floatingLabelColor: rawTheme.palette.textColor,
        disabledTextColor: rawTheme.palette.disabledColor,
        errorColor: Colors.red500,
        focusColor: rawTheme.palette.primary1Color,
        backgroundColor: 'transparent',
        borderColor: rawTheme.palette.borderColor
      },
      isRtl: false
    };

    //add properties to objects inside 'returnObj' that depend on existing properties
    returnObj.flatButton.disabledTextColor = ColorManipulator.fade(returnObj.flatButton.textColor, 0.3);
    returnObj.raisedButton.disabledColor = ColorManipulator.darken(returnObj.raisedButton.color, 0.1);
    returnObj.raisedButton.disabledTextColor = ColorManipulator.fade(returnObj.raisedButton.textColor, 0.3);
    returnObj.toggle.trackRequiredColor = ColorManipulator.fade(returnObj.toggle.thumbRequiredColor, 0.5);

    //append the raw theme object to 'returnObj'
    returnObj.rawTheme = rawTheme;

    //set 'static' key as true (by default) on return object. This is to support the ContextPure mixin.
    returnObj['static'] = true;

    return returnObj;
  },

  //functions to modify properties of raw theme, namely spacing, palette
  //and font family. These functions use the React update immutability helper
  //to create a new object for the raw theme, and return a new MUI theme object

  //function to modify the spacing of the raw theme. This function recomputes
  //the MUI theme and returns it based on the new theme.
  modifyRawThemeSpacing: function modifyRawThemeSpacing(muiTheme, newSpacing) {
    var newRawTheme = update(muiTheme.rawTheme, { spacing: { $set: newSpacing } });
    return this.getMuiTheme(newRawTheme);
  },

  //function to modify the palette of the raw theme. This function recomputes
  //the MUI theme and returns it based on the new raw theme.
  //keys inside 'newPalette' override values for existing keys in palette
  modifyRawThemePalette: function modifyRawThemePalette(muiTheme, newPaletteKeys) {
    var newPalette = Extend(muiTheme.rawTheme.palette, newPaletteKeys);
    var newRawTheme = update(muiTheme.rawTheme, { palette: { $set: newPalette } });
    return this.getMuiTheme(newRawTheme);
  },

  //function to modify the font family of the raw theme. This function recomputes
  //the MUI theme and returns it based on the new raw theme.
  modifyRawThemeFontFamily: function modifyRawThemeFontFamily(muiTheme, newFontFamily) {
    var newRawTheme = update(muiTheme.rawTheme, { fontFamily: { $set: newFontFamily } });
    return this.getMuiTheme(newRawTheme);
  }

};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Reflux = __webpack_require__(972);

Reflux.connect = __webpack_require__(977);

Reflux.connectFilter = __webpack_require__(978);

Reflux.ListenerMixin = __webpack_require__(336);

Reflux.listenTo = __webpack_require__(979);

Reflux.listenToMany = __webpack_require__(980);

module.exports = Reflux;


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Auth__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Bundle__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Course__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dashboard__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Discount__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Group__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Invitation__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Invite__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__InviteWizard__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MediaLibrary__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MediaLibraryOverview__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Message__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Notification__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Settings__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Store__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Student__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Transaction__ = __webpack_require__(1970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Theme__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Task__ = __webpack_require__(1971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__User__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Export__ = __webpack_require__(1972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Clipboard__ = __webpack_require__(1973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Klarna__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__StudentOverview__ = __webpack_require__(1975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__PageLayout__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__StoreOverview__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Payment__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Category__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Stripe__ = __webpack_require__(2037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Quiz__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__QuizDetail__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Webinar__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Page__ = __webpack_require__(2041);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__App__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Auth__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Bundle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__Course__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__Dashboard__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__Discount__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__Group__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__Invitation__["a"]; });
/* unused harmony reexport InviteStore */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__InviteWizard__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_10__MediaLibrary__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_11__MediaLibraryOverview__["a"]; });
/* unused harmony reexport MessageStore */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_13__Notification__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_14__Settings__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_15__Store__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_16__Student__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_17__Transaction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_18__Theme__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_19__Task__["a"]; });
/* unused harmony reexport UserStore */
/* unused harmony reexport ExportStore */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_22__Clipboard__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_23__Klarna__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_24__StudentOverview__["a"]; });
/* unused harmony reexport PageLayoutStore */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_26__StoreOverview__["a"]; });
/* unused harmony reexport PaymentStore */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_28__Category__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_29__Stripe__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_30__Quiz__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_31__QuizDetail__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_32__Webinar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_33__Page__["a"]; });
/* unused harmony default export */ var _unused_webpack_default_export = ({AppStore:__WEBPACK_IMPORTED_MODULE_0__App__["a" /* default */],AuthStore:__WEBPACK_IMPORTED_MODULE_1__Auth__["a" /* default */],BundleStore:__WEBPACK_IMPORTED_MODULE_2__Bundle__["a" /* default */],CourseStore:__WEBPACK_IMPORTED_MODULE_3__Course__["a" /* default */],DashboardStore:__WEBPACK_IMPORTED_MODULE_4__Dashboard__["a" /* default */],DiscountStore:__WEBPACK_IMPORTED_MODULE_5__Discount__["a" /* default */],GroupStore:__WEBPACK_IMPORTED_MODULE_6__Group__["a" /* default */],InvitationStore:__WEBPACK_IMPORTED_MODULE_7__Invitation__["a" /* default */],InviteStore:__WEBPACK_IMPORTED_MODULE_8__Invite__["a" /* default */],InviteWizardStore:__WEBPACK_IMPORTED_MODULE_9__InviteWizard__["a" /* default */],MediaLibraryStore:__WEBPACK_IMPORTED_MODULE_10__MediaLibrary__["a" /* default */],MediaLibraryOverviewStore:__WEBPACK_IMPORTED_MODULE_11__MediaLibraryOverview__["a" /* default */],MessageStore:__WEBPACK_IMPORTED_MODULE_12__Message__["a" /* default */],NotificationStore:__WEBPACK_IMPORTED_MODULE_13__Notification__["a" /* default */],SettingsStore:__WEBPACK_IMPORTED_MODULE_14__Settings__["a" /* default */],StoreStore:__WEBPACK_IMPORTED_MODULE_15__Store__["a" /* default */],StudentStore:__WEBPACK_IMPORTED_MODULE_16__Student__["a" /* default */],TransactionStore:__WEBPACK_IMPORTED_MODULE_17__Transaction__["a" /* default */],ThemeStore:__WEBPACK_IMPORTED_MODULE_18__Theme__["a" /* default */],TaskStore:__WEBPACK_IMPORTED_MODULE_19__Task__["a" /* default */],UserStore:__WEBPACK_IMPORTED_MODULE_20__User__["a" /* default */],ExportStore:__WEBPACK_IMPORTED_MODULE_21__Export__["a" /* default */],ClipboardStore:__WEBPACK_IMPORTED_MODULE_22__Clipboard__["a" /* default */],KlarnaStore:__WEBPACK_IMPORTED_MODULE_23__Klarna__["a" /* default */],StudentOverviewStore:__WEBPACK_IMPORTED_MODULE_24__StudentOverview__["a" /* default */],PageLayoutStore:__WEBPACK_IMPORTED_MODULE_25__PageLayout__["a" /* default */],StoreOverviewStore:__WEBPACK_IMPORTED_MODULE_26__StoreOverview__["a" /* default */],PaymentStore:__WEBPACK_IMPORTED_MODULE_27__Payment__["a" /* default */],CategoryStore:__WEBPACK_IMPORTED_MODULE_28__Category__["a" /* default */],StripeStore:__WEBPACK_IMPORTED_MODULE_29__Stripe__["a" /* default */],QuizStore:__WEBPACK_IMPORTED_MODULE_30__Quiz__["a" /* default */],QuizDetailStore:__WEBPACK_IMPORTED_MODULE_31__QuizDetail__["a" /* default */],WebinarStore:__WEBPACK_IMPORTED_MODULE_32__Webinar__["a" /* default */],PageStore:__WEBPACK_IMPORTED_MODULE_33__Page__["a" /* default */]});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(279);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Icon=function(_Component){_inherits(Icon,_Component);function Icon(){_classCallCheck(this,Icon);return _possibleConstructorReturn(this,(Icon.__proto__||Object.getPrototypeOf(Icon)).apply(this,arguments));}_createClass(Icon,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize});}}]);return Icon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Icon.propTypes={color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,viewPortSize:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number};Icon.defaultProps={color:'#FFFFFF',size:24,viewPortSize:16};/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Colors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Theme; });
var materialColors={red:{'50':{material:'#FFEBEE',text:'Dark'},'100':{material:'#FFCDD2',text:'Dark'},'200':{material:'#EF9A9A',text:'Dark'},'300':{material:'#E57373',text:'Dark'},'400':{material:'#EF5350',text:'Light'},'500':{material:'#F44336',text:'Light'},'600':{material:'#E53935',text:'Light'},'700':{material:'#D32F2F',text:'Light'},'800':{material:'#C62828',text:'Light'},'900':{material:'#B71C1C',text:'Light'},A100:{material:'#FF8A80',text:'Dark'},A200:{material:'#FF5252',text:'Light'},A400:{material:'#FF1744',text:'Light'},A700:{material:'#D50000',text:'Light'}},pink:{'50':{material:'#FCE4EC',text:'Dark'},'100':{material:'#F8BBD0',text:'Dark'},'200':{material:'#F48FB1',text:'Dark'},'300':{material:'#F06292',text:'Light'},'400':{material:'#EC407A',text:'Light'},'500':{material:'#E91E63',text:'Light'},'600':{material:'#D81B60',text:'Light'},'700':{material:'#C2185B',text:'Light'},'800':{material:'#AD1457',text:'Light'},'900':{material:'#880E4F',text:'Light'},A100:{material:'#FF80AB',text:'Dark'},A200:{material:'#FF4081',text:'Light'},A400:{material:'#F50057',text:'Light'},A700:{material:'#C51162',text:'Light'}},purple:{'50':{material:'#F3E5F5',text:'Dark'},'100':{material:'#E1BEE7',text:'Dark'},'200':{material:'#CE93D8',text:'Dark'},'300':{material:'#BA68C8',text:'Light'},'400':{material:'#AB47BC',text:'Light'},'500':{material:'#9C27B0',text:'Light'},'600':{material:'#8E24AA',text:'Light'},'700':{material:'#7B1FA2',text:'Light'},'800':{material:'#6A1B9A',text:'Light'},'900':{material:'#4A148C',text:'Light'},A100:{material:'#EA80FC',text:'Dark'},A200:{material:'#E040FB',text:'Light'},A400:{material:'#D500F9',text:'Light'},A700:{material:'#AA00FF',text:'Light'}},deepPurple:{'50':{material:'#EDE7F6',text:'Dark'},'100':{material:'#D1C4E9',text:'Dark'},'200':{material:'#B39DDB',text:'Dark'},'300':{material:'#9575CD',text:'Light'},'400':{material:'#7E57C2',text:'Light'},'500':{material:'#673AB7',text:'Light'},'600':{material:'#5E35B1',text:'Light'},'700':{material:'#512DA8',text:'Light'},'800':{material:'#4527A0',text:'Light'},'900':{material:'#311B92',text:'Light'},A100:{material:'#B388FF',text:'Dark'},A200:{material:'#7C4DFF',text:'Light'},A400:{material:'#651FFF',text:'Light'},A700:{material:'#6200EA',text:'Light'}},indigo:{'50':{material:'#E8EAF6',text:'Dark'},'100':{material:'#C5CAE9',text:'Dark'},'200':{material:'#9FA8DA',text:'Dark'},'300':{material:'#7986CB',text:'Light'},'400':{material:'#5C6BC0',text:'Light'},'500':{material:'#3F51B5',text:'Light'},'600':{material:'#3949AB',text:'Light'},'700':{material:'#303F9F',text:'Light'},'800':{material:'#283593',text:'Light'},'900':{material:'#1A237E',text:'Light'},A100:{material:'#8C9EFF',text:'Dark'},A200:{material:'#536DFE',text:'Light'},A400:{material:'#3D5AFE',text:'Light'},A700:{material:'#304FFE',text:'Light'}},blue:{'50':{material:'#E3F2FD',text:'Dark'},'100':{material:'#BBDEFB',text:'Dark'},'200':{material:'#90CAF9',text:'Dark'},'300':{material:'#64B5F6',text:'Dark'},'400':{material:'#42A5F5',text:'Dark'},'500':{material:'#2196F3',text:'Light'},'600':{material:'#1E88E5',text:'Light'},'700':{material:'#1976D2',text:'Light'},'800':{material:'#1565C0',text:'Light'},'900':{material:'#0D47A1',text:'Light'},A100:{material:'#82B1FF',text:'Dark'},A200:{material:'#448AFF',text:'Light'},A400:{material:'#2979FF',text:'Light'},A700:{material:'#2962FF',text:'Light'}},lightBlue:{'50':{material:'#E1F5FE',text:'Dark'},'100':{material:'#B3E5FC',text:'Dark'},'200':{material:'#81D4FA',text:'Dark'},'300':{material:'#4FC3F7',text:'Dark'},'400':{material:'#29B6F6',text:'Dark'},'500':{material:'#03A9F4',text:'Dark'},'600':{material:'#039BE5',text:'Light'},'700':{material:'#0288D1',text:'Light'},'800':{material:'#0277BD',text:'Light'},'900':{material:'#01579B',text:'Light'},A100:{material:'#80D8FF',text:'Dark'},A200:{material:'#40C4FF',text:'Dark'},A400:{material:'#00B0FF',text:'Dark'},A700:{material:'#0091EA',text:'Light'}},cyan:{'50':{material:'#E0F7FA',text:'Dark'},'100':{material:'#B2EBF2',text:'Dark'},'200':{material:'#80DEEA',text:'Dark'},'300':{material:'#4DD0E1',text:'Dark'},'400':{material:'#26C6DA',text:'Dark'},'500':{material:'#00BCD4',text:'Dark'},'600':{material:'#00ACC1',text:'Dark'},'700':{material:'#0097A7',text:'Light'},'800':{material:'#00838F',text:'Light'},'900':{material:'#006064',text:'Light'},A100:{material:'#84FFFF',text:'Dark'},A200:{material:'#18FFFF',text:'Dark'},A400:{material:'#00E5FF',text:'Dark'},A700:{material:'#00B8D4',text:'Dark'}},coursio:{'50':{material:'#70FDFF',text:'Dark'},'100':{material:'#5CFCFF',text:'Dark'},'200':{material:'#47FCFF',text:'Dark'},'300':{material:'#1FFBFF',text:'Dark'},'400':{material:'#00F1F5',text:'Dark'},'500':{material:'#00c9cc',text:'Light'},'600':{material:'#00A0A3',text:'Light'},'700':{material:'#008C8F',text:'Light'},'800':{material:'#006466',text:'Light'},'900':{material:'#003C3D',text:'Light'},A100:{material:'#5CFCFF',text:'Dark'},A200:{material:'#47FCFF',text:'Dark'},A400:{material:'#00F1F5',text:'Dark'},A700:{material:'#008C8F',text:'Dark'}},teal:{'50':{material:'#E0F2F1',text:'Dark'},'100':{material:'#B2DFDB',text:'Dark'},'200':{material:'#80CBC4',text:'Dark'},'300':{material:'#4DB6AC',text:'Dark'},'400':{material:'#26A69A',text:'Dark'},'500':{material:'#009688',text:'Light'},'600':{material:'#00897B',text:'Light'},'700':{material:'#00796B',text:'Light'},'800':{material:'#00695C',text:'Light'},'900':{material:'#004D40',text:'Light'},A100:{material:'#A7FFEB',text:'Dark'},A200:{material:'#64FFDA',text:'Dark'},A400:{material:'#1DE9B6',text:'Dark'},A700:{material:'#00BFA5',text:'Dark'}},green:{'50':{material:'#E8F5E9',text:'Dark'},'100':{material:'#C8E6C9',text:'Dark'},'200':{material:'#A5D6A7',text:'Dark'},'300':{material:'#81C784',text:'Dark'},'400':{material:'#66BB6A',text:'Dark'},'500':{material:'#4CAF50',text:'Dark'},'600':{material:'#43A047',text:'Light'},'700':{material:'#388E3C',text:'Light'},'800':{material:'#2E7D32',text:'Light'},'900':{material:'#1B5E20',text:'Light'},A100:{material:'#B9F6CA',text:'Dark'},A200:{material:'#69F0AE',text:'Dark'},A400:{material:'#00E676',text:'Dark'},A700:{material:'#00C853',text:'Dark'}},lightGreen:{'50':{material:'#F1F8E9',text:'Dark'},'100':{material:'#DCEDC8',text:'Dark'},'200':{material:'#C5E1A5',text:'Dark'},'300':{material:'#AED581',text:'Dark'},'400':{material:'#9CCC65',text:'Dark'},'500':{material:'#8BC34A',text:'Dark'},'600':{material:'#7CB342',text:'Dark'},'700':{material:'#689F38',text:'Light'},'800':{material:'#558B2F',text:'Light'},'900':{material:'#33691E',text:'Light'},A100:{material:'#CCFF90',text:'Dark'},A200:{material:'#B2FF59',text:'Dark'},A400:{material:'#76FF03',text:'Dark'},A700:{material:'#64DD17',text:'Dark'}},lime:{'50':{material:'#F9FBE7',text:'Dark'},'100':{material:'#F0F4C3',text:'Dark'},'200':{material:'#E6EE9C',text:'Dark'},'300':{material:'#DCE775',text:'Dark'},'400':{material:'#D4E157',text:'Dark'},'500':{material:'#CDDC39',text:'Dark'},'600':{material:'#C0CA33',text:'Dark'},'700':{material:'#AFB42B',text:'Dark'},'800':{material:'#9E9D24',text:'Dark'},'900':{material:'#827717',text:'Light'},A100:{material:'#F4FF81',text:'Dark'},A200:{material:'#EEFF41',text:'Dark'},A400:{material:'#C6FF00',text:'Dark'},A700:{material:'#AEEA00',text:'Dark'}},yellow:{'50':{material:'#FFFDE7',text:'Dark'},'100':{material:'#FFF9C4',text:'Dark'},'200':{material:'#FFF59D',text:'Dark'},'300':{material:'#FFF176',text:'Dark'},'400':{material:'#FFEE58',text:'Dark'},'500':{material:'#FFEB3B',text:'Dark'},'600':{material:'#FDD835',text:'Dark'},'700':{material:'#FBC02D',text:'Dark'},'800':{material:'#F9A825',text:'Dark'},'900':{material:'#F57F17',text:'Dark'},A100:{material:'#FFFF8D',text:'Dark'},A200:{material:'#FFFF00',text:'Dark'},A400:{material:'#FFEA00',text:'Dark'},A700:{material:'#FFD600',text:'Dark'}},amber:{'50':{material:'#FFF8E1',text:'Dark'},'100':{material:'#FFECB3',text:'Dark'},'200':{material:'#FFE082',text:'Dark'},'300':{material:'#FFD54F',text:'Dark'},'400':{material:'#FFCA28',text:'Dark'},'500':{material:'#FFC107',text:'Dark'},'600':{material:'#FFB300',text:'Dark'},'700':{material:'#FFA000',text:'Dark'},'800':{material:'#FF8F00',text:'Dark'},'900':{material:'#FF6F00',text:'Dark'},A100:{material:'#FFE57F',text:'Dark'},A200:{material:'#FFD740',text:'Dark'},A400:{material:'#FFC400',text:'Dark'},A700:{material:'#FFAB00',text:'Dark'}},orange:{'50':{material:'#FFF3E0',text:'Dark'},'100':{material:'#FFE0B2',text:'Dark'},'200':{material:'#FFCC80',text:'Dark'},'300':{material:'#FFB74D',text:'Dark'},'400':{material:'#FFA726',text:'Dark'},'500':{material:'#FF9800',text:'Dark'},'600':{material:'#FB8C00',text:'Dark'},'700':{material:'#F57C00',text:'Dark'},'800':{material:'#EF6C00',text:'Light'},'900':{material:'#E65100',text:'Light'},A100:{material:'#FFD180',text:'Dark'},A200:{material:'#FFAB40',text:'Dark'},A400:{material:'#FF9100',text:'Dark'},A700:{material:'#FF6D00',text:'Dark'}},deepOrange:{'50':{material:'#FBE9E7',text:'Dark'},'100':{material:'#FFCCBC',text:'Dark'},'200':{material:'#FFAB91',text:'Dark'},'300':{material:'#FF8A65',text:'Dark'},'400':{material:'#FF7043',text:'Dark'},'500':{material:'#FF5722',text:'Light'},'600':{material:'#F4511E',text:'Light'},'700':{material:'#E64A19',text:'Light'},'800':{material:'#D84315',text:'Light'},'900':{material:'#BF360C',text:'Light'},A100:{material:'#FF9E80',text:'Dark'},A200:{material:'#FF6E40',text:'Dark'},A400:{material:'#FF3D00',text:'Light'},A700:{material:'#DD2C00',text:'Light'}},brown:{'50':{material:'#EFEBE9',text:'Dark'},'100':{material:'#D7CCC8',text:'Dark'},'200':{material:'#BCAAA4',text:'Dark'},'300':{material:'#A1887F',text:'Light'},'400':{material:'#8D6E63',text:'Light'},'500':{material:'#795548',text:'Light'},'600':{material:'#6D4C41',text:'Light'},'700':{material:'#5D4037',text:'Light'},'800':{material:'#4E342E',text:'Light'},'900':{material:'#3E2723',text:'Light'}},grey:{'50':{material:'#FAFAFA',text:'Dark'},'100':{material:'#F5F5F5',text:'Dark'},'200':{material:'#EEEEEE',text:'Dark'},'300':{material:'#E0E0E0',text:'Dark'},'400':{material:'#BDBDBD',text:'Dark'},'500':{material:'#9E9E9E',text:'Dark'},'600':{material:'#757575',text:'Light'},'700':{material:'#616161',text:'Light'},'800':{material:'#424242',text:'Light'},'900':{material:'#212121',text:'Light'}},blueGrey:{'50':{material:'#ECEFF1',text:'Dark'},'100':{material:'#CFD8DC',text:'Dark'},'200':{material:'#B0BEC5',text:'Dark'},'300':{material:'#90A4AE',text:'Dark'},'400':{material:'#78909C',text:'Light'},'500':{material:'#607D8B',text:'Light'},'600':{material:'#546E7A',text:'Light'},'700':{material:'#455A64',text:'Light'},'800':{material:'#37474F',text:'Light'},'900':{material:'#263238',text:'Light'}},black:'#000000',white:'#ffffff',transparent:'rgba(0, 0, 0, 0)',fullBlack:'rgba(0, 0, 0, 1)',darkBlack:'rgba(0, 0, 0, 0.87)',lightBlack:'rgba(0, 0, 0, 0.54)',minBlack:'rgba(0, 0, 0, 0.26)',faintBlack:'rgba(0, 0, 0, 0.12)',fullWhite:'rgba(255, 255, 255, 1)',darkWhite:'rgba(255, 255, 255, 0.87)',lightWhite:'rgba(255, 255, 255, 0.54)',bondiBlue:'#00C9CC',darkBondiBlue:'#004F51',bondiBluehover:'#09E4E9'};var textColors={Light:{divider:'rgba(255, 255, 255, 0.12)',disabled:'rgba(255, 255, 255, 0.30)',secondary:'rgba(255, 255, 255, 0.70)',text:'rgba(255, 255, 255, 1)'},Dark:{divider:'rgba(0, 0, 0, 0.12)',disabled:'rgba(0, 0, 0, 0.26)',secondary:'rgba(0, 0, 0, 0.54)',text:'rgba(0, 0, 0, 0.87)'}};var themeColors={Light:{statusBar:'#777777',appBar:'#E5E5E5',background:'#FAFAFA',card:'#FFFFFF'},Dark:{statusBar:'#000000',appBar:'#212121',background:'#303030',card:'#424242'}};var Colors=materialColors;var Text=textColors;var Theme=themeColors;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var HTTP_UNAUTHORIZED=401;var HTTP_OK=200;var INTERNAL_ERROR=500;var SteelCompass=function(){function SteelCompass(){_classCallCheck(this,SteelCompass);this.token=localStorage&&localStorage.getItem("token");}_createClass(SteelCompass,[{key:"setAuthToken",value:function setAuthToken(token){this.token=token;localStorage.setItem("token",token);}},{key:"call",value:function call(object,method,data,callback){__WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0_Config__["a" /* default */].steelCompassRoot+object).set("Accept","application/json").set("Content-Type","application/json").set("Token",this.token).send(JSON.stringify({method:method,data:data})).end(function(err,response){if(err&&err.status&&response.status===HTTP_UNAUTHORIZED){__WEBPACK_IMPORTED_MODULE_2_helpers__["a" /* history */].push("/logout");}if(response.status>=INTERNAL_ERROR){__WEBPACK_IMPORTED_MODULE_2_helpers__["a" /* history */].push("/coursio-error");}if(!response.body){response.body=__WEBPACK_IMPORTED_MODULE_1_superagent___default.a.parse["application/json"](response.text);}if(response.body.isError&&response.status===HTTP_UNAUTHORIZED){__WEBPACK_IMPORTED_MODULE_2_helpers__["a" /* history */].push("/logout");}if(response.status!==HTTP_OK){response.body.isError=true;}callback(response.body);});}},{key:"request",value:function request(object,method,requestData,pageStart,pageLength){var _this=this;var data=requestData||{};return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0_Config__["a" /* default */].steelCompassRoot+object).set("Accept","application/json").set("Content-Type","application/json").set("Token",_this.token).send(JSON.stringify({method:method,data:data,pageStart:pageStart,pageLength:pageLength})).end(function(err,response){if(err&&err.status){if(response.status===HTTP_UNAUTHORIZED){var user=JSON.parse(localStorage.getItem("user"));if(user&&user.loggedIn){__WEBPACK_IMPORTED_MODULE_2_helpers__["a" /* history */].push("/logout");}}if(response.status>=INTERNAL_ERROR){if(response.body.errMsg!=='xroom.app is not configured (go to settings)'){__WEBPACK_IMPORTED_MODULE_2_helpers__["a" /* history */].push("/coursio-error");}}reject(response.body&&response.body.errMsg||"Ohh noes!");}else{try{if(!response.body){response.body=__WEBPACK_IMPORTED_MODULE_1_superagent___default.a.parse["application/json"](response.text);}}catch(e){reject("Ohh snap!");}if(response&&response.body.isError&&response.status===HTTP_UNAUTHORIZED){var _user=JSON.parse(localStorage.getItem("user"));if(_user&&_user.loggedIn){__WEBPACK_IMPORTED_MODULE_2_helpers__["a" /* history */].push("/logout");}reject(response.body.errMsg);}else if(response.status>=INTERNAL_ERROR){__WEBPACK_IMPORTED_MODULE_2_helpers__["a" /* history */].push("/coursio-error");}else if(response&&response.body.isError){reject(response.body.errMsg);}else if(!response){reject("Ohh snap!");}else{resolve(response.body.data);}}});});}},{key:"savePageModule",value:function savePageModule(id,params){this.call("page-module","update",{id:id,params:params},function(response){});}},{key:"deletePageModule",value:function deletePageModule(id,callback){this.call("page-module","delete",{id:id},function(response){if(callback){callback();}});}},{key:"upload",value:function upload(files,options){var request=void 0,method=options.encoded&&"encoded"||"plain";options=options||{};request=__WEBPACK_IMPORTED_MODULE_1_superagent___default.a.post(__WEBPACK_IMPORTED_MODULE_0_Config__["a" /* default */].steelCompassRoot+"upload/"+method).set("Token",this.token);var fd=new FormData();for(var i=0,file;file=files[i];i++){fd.append("file[]",file,file.name);}request.send(fd).on("progress",function(event){if(options.progress){options.progress(event);}}).end(function(err,response){if(err){options.error(response.body);}else if(options.success){options.success(response.body);}});}},{key:"login",value:function login(identity,credential){var _this2=this;return new Promise(function(resolve,reject){_this2.request("auth","login",{identity:identity,credential:credential}).then(function(data){if(data){resolve(data);}else{reject("Unknown error");}},function(error){reject(error);});});}},{key:"loginCdk",value:function loginCdk(key){var _this3=this;return new Promise(function(resolve,reject){_this3.request("auth","loginCdk",{hash:key}).then(function(data){if(data){resolve(data);}else{reject("Unknown error");}},function(error){reject(error);});});}},{key:"logout",value:function logout(){return this.request("auth","logout");}},{key:"issueCdk",value:function issueCdk(id){var _this4=this;return new Promise(function(resolve,reject){_this4.request("user","issueCdk",{userIds:id}).then(function(data){if(data){resolve(data);}else{reject("Unknown error");}},function(error){reject(error);});});}}]);return SteelCompass;}();var sc=new SteelCompass();window.SteelCompass=sc;/* harmony default export */ __webpack_exports__["a"] = (sc);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions__ = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_actions__["q" /* MessageActions */]);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AutoPrefix = __webpack_require__(62);

module.exports = {

  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',

  easeOut: function easeOut(duration, property, delay, easeFunction) {

    easeFunction = easeFunction || this.easeOutFunction;

    if (property && Object.prototype.toString.call(property) === '[object Array]') {

      var transitions = '';
      for (var i = 0; i < property.length; i++) {
        if (transitions) transitions += ',';
        transitions += this.create(duration, property[i], delay, easeFunction);
      }
      return transitions;
    } else {
      return this.create(duration, property, delay, easeFunction);
    }
  },

  create: function create(duration, property, delay, easeFunction) {
    duration = duration || '450ms';
    property = property || 'all';
    delay = delay || '0ms';
    easeFunction = easeFunction || "linear";

    return AutoPrefix.singleHyphened(property) + ' ' + duration + ' ' + easeFunction + ' ' + delay;
  }
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(30);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocale = exports._l = exports.translate = exports.currency = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.addMessages = addMessages;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var typeInfoRegex = /^:([a-z])(\((.+)\))?/;
var messages = {};

var I18N = function () {
  function I18N(locale, defaultCurrency) {
    _classCallCheck(this, I18N);

    _initialiseProps.call(this);

    this.setLocale(locale, defaultCurrency);
  }

  _createClass(I18N, [{
    key: 'setLocalizers',
    value: function setLocalizers() {
      var _this = this;

      var locale = this.locale,
          defaultCurrency = this.defaultCurrency;

      this._localizers = {
        s /*string*/: function s(v) {
          return (v || '').toLocaleString(locale);
        },
        c /*currency*/: function c(v, currency) {
          return v.toLocaleString(locale, {
            style: 'currency',
            currency: currency && currency.replace('_', '-') || defaultCurrency
          });
        },
        n /*number*/: function n(v, fractionalDigits) {
          return v.toLocaleString(locale, {
            minimumFractionDigits: fractionalDigits,
            maximumFractionDigits: fractionalDigits
          });
        },
        dt: function dt(v) {
          return _this.dateTimeFormat.format(v);
        },
        d: function d(v) {
          return _this.dateFormat.format(v);
        }
      };
    }
  }, {
    key: '_extractTypeInfo',
    value: function _extractTypeInfo(literal) {
      var match = typeInfoRegex.exec(literal);
      if (match) {
        return { type: match[1], options: match[3] };
      } else {
        return { type: 's', options: '' };
      }
    }
  }, {
    key: '_localize',
    value: function _localize(value, _ref) {
      var type = _ref.type,
          options = _ref.options;

      return this._localizers[type](value, options);
    }

    // e.g. I18n._buildKey(['', ' has ', ':c in the']) == '{0} has {1} in the bank'

  }, {
    key: '_buildKey',
    value: function _buildKey(literals) {
      var stripType = function stripType(s) {
        return s.replace(typeInfoRegex, '');
      };
      var lastPartialKey = stripType(literals[literals.length - 1]);
      var prependPartialKey = function prependPartialKey(memo, curr, i) {
        return stripType(curr) + '{' + i + '}' + memo;
      };

      return literals.slice(0, -1).reduceRight(prependPartialKey, lastPartialKey);
    }

    // e.g. I18n._formatStrings('{0} {1}!', 'hello', 'world') == 'hello world!'

  }, {
    key: '_buildMessage',
    value: function _buildMessage(str) {
      for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        values[_key - 1] = arguments[_key];
      }

      return str.replace(/{(\d)}/g, function (_, index) {
        return values[Number(index)];
      });
    }
  }, {
    key: '_buildReact',
    value: function _buildReact(str) {
      for (var _len2 = arguments.length, values = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        values[_key2 - 1] = arguments[_key2];
      }

      var tokens = str.split(/({\d+})/).map(function (token) {
        var match = token.match(/{(\d+)}/);
        if (match) {
          return values[Number(match[1])];
        }
        return token;
      });
      return _react2.default.createElement.apply(_react2.default, ['span', {}].concat(_toConsumableArray(tokens)));
    }
  }]);

  return I18N;
}();

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.fallback = false;

  this.translate = function (literals) {
    for (var _len3 = arguments.length, values = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      values[_key3 - 1] = arguments[_key3];
    }

    var messageBundle = messages[_this2.locale];
    var translationKey = _this2._buildKey(literals);
    var translationString = messageBundle[translationKey];

    if (_this2.fallback && !translationString) {
      translationString = messages['en-US'][translationKey];
    }
    if (translationString) {
      var hasReact = false;
      var typeInfoForValues = literals.slice(1).map(_this2._extractTypeInfo);
      var localizedValues = values.map(function (v, i) {
        if (typeInfoForValues[i].type === 's' && (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object') {
          hasReact = true;
          return v;
        } else if (typeof v === 'number' && typeInfoForValues[i].type == 's') {
          if (typeof v == 'number') {
            return _this2._localize(v, { type: 'n', options: '' });
          }
        }
        return _this2._localize(v, typeInfoForValues[i]);
      });
      if (hasReact) {
        return _this2._buildReact.apply(_this2, [translationString].concat(_toConsumableArray(localizedValues)));
      }
      return _this2._buildMessage.apply(_this2, [translationString].concat(_toConsumableArray(localizedValues)));
    }
    return translationKey + '[' + _this2.locale + ']';
  };

  this.currency = function (v, currency) {
    var locale = _this2.locale,
        defaultCurrency = _this2.defaultCurrency;

    return v.toLocaleString(locale, {
      style: 'currency',
      currency: currency && currency.replace('_', '-') || defaultCurrency
    });
  };

  this.setLocale = function (locale, defaultCurrency) {
    _this2.locale = locale;
    messages[locale] = messages[locale] || {};
    _this2.defaultCurrency = defaultCurrency;
    _this2.dateTimeFormat = new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    _this2.dateFormat = new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    _this2.setLocalizers();
    if (_this2.onChange) {
      _this2.onChange(locale, defaultCurrency);
    }
  };
};

function addMessages(messageBundles) {
  Object.keys(messageBundles).forEach(function (locale) {
    messages[locale] = messages[locale] || {};
    messages[locale] = Object.assign({}, messages[locale], messageBundles[locale]);
  });
}

var i18n = new I18N('en-US', 'EUR');
var _l = i18n.translate;
var translate = i18n.translate,
    setLocale = i18n.setLocale,
    currency = i18n.currency;
exports.currency = currency;
exports.translate = translate;
exports._l = _l;
exports.setLocale = setLocale;
exports.default = i18n;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={container:{textAlign:'center',paddingTop:Spacing.desktopGutterMini}};var Loader=function(_Component){_inherits(Loader,_Component);function Loader(){_classCallCheck(this,Loader);return _possibleConstructorReturn(this,(Loader.__proto__||Object.getPrototypeOf(Loader)).apply(this,arguments));}_createClass(Loader,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["CircularProgress"],{mode:'indeterminate'}));}}]);return Loader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Loader.displayName='Loader';/* harmony default export */ __webpack_exports__["b"] = (Loader);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* jshint node:true */


// Expose `React` as a global, because the ReactIntlMixin assumes it's global.
var oldReact = global.React;
global.React = __webpack_require__(0);

// Require the lib and add all locale data to `ReactIntl`. This module will be
// ignored when bundling for the browser with Browserify/Webpack.
var ReactIntl = __webpack_require__(2074);
__webpack_require__(2099);

// Export the Mixin as the default export for back-compat with v1.0.0. This will
// be changed to simply re-exporting `ReactIntl` as the default export in v2.0.
exports = module.exports = ReactIntl.IntlMixin;

// Define non-enumerable expandos for each named export on the default export --
// which is the Mixin for back-compat with v1.0.0.
Object.keys(ReactIntl).forEach(function (namedExport) {
    Object.defineProperty(exports, namedExport, {
        enumerable: true,
        value     : ReactIntl[namedExport]
    });
});

// Put back `global.React` to how it was.
if (oldReact) {
    global.React = oldReact;
} else {
    // IE < 9 will throw when trying to delete something off the global object,
    // `window`, so this does the next best thing as sets it to `undefined`.
    try {
        delete global.React;
    } catch (e) {
        global.React = undefined;
    }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_AppContent__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_J',noHeader:'_K'};var AppPage=function(_Component){_inherits(AppPage,_Component);function AppPage(){_classCallCheck(this,AppPage);return _possibleConstructorReturn(this,(AppPage.__proto__||Object.getPrototypeOf(AppPage)).apply(this,arguments));}_createClass(AppPage,[{key:'render',value:function render(){var _props=this.props,noHeader=_props.noHeader,className=_props.className,children=_props.children,other=_objectWithoutProperties(_props,['noHeader','className','children']);var classes=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.root,className,_defineProperty({},css.noHeader,noHeader));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:classes},other),this.props.header,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_AppContent__["a" /* default */],null,children),this.props.footer);}}]);return AppPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AppPage.propTypes={noHeader:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,dark:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,header:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object]),footer:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object])};AppPage.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};AppPage.defaultProps={dark:false,header:null,footer:null};/* harmony default export */ __webpack_exports__["a"] = (AppPage);

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Object.assign
 */

// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign



function assign(target, sources) {
  if (target == null) {
    throw new TypeError('Object.assign target cannot be null or undefined');
  }

  var to = Object(target);
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
    var nextSource = arguments[nextIndex];
    if (nextSource == null) {
      continue;
    }

    var from = Object(nextSource);

    // We don't currently support accessors nor proxies. Therefore this
    // copy cannot throw. If we ever supported this then we must handle
    // exceptions and side-effects. We don't support symbols so they won't
    // be transferred.

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
  }

  return to;
}

module.exports = assign;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__history__ = __webpack_require__(1000);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__history__["a"]; });


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pageModules", function() { return pageModules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NO_TIME", function() { return NO_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_COVER", function() { return DEFAULT_COVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_CURRENCY", function() { return DEFAULT_CURRENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ItemTypes", function() { return ItemTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fileTypeIcons", function() { return fileTypeIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentProviders", function() { return paymentProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskTypes", function() { return taskTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOTIFICATIONS", function() { return NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "features", function() { return features; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentSettings", function() { return paymentSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxFileSize", function() { return maxFileSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notificationPageLength", function() { return notificationPageLength; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_plugins_PageModules__ = __webpack_require__(515);
var pageModules={text:{id:1,icon:'ModuleText'},video:{id:2,icon:'ModuleVideo'},image:{id:3,icon:'ModuleImage'},audio:{id:4,icon:'ModuleAudio'},embed:{id:5,icon:'ModuleEmbed'},task:{id:6,icon:'ModuleInteraction'},download:{id:7,icon:'ModuleDownload'},discussion:{id:8,icon:'ModuleDiscussion'},slideshow:{id:9,icon:'ModuleTask'},quiz:{id:10,icon:'ModuleInteraction'},webinar:{id:11,icon:'ModuleWebinar'},quiziframe:{id:12,icon:'ModuleQuiziframe'}};Object.keys(__WEBPACK_IMPORTED_MODULE_0_plugins_PageModules__).forEach(function(moduleName){var module=__WEBPACK_IMPORTED_MODULE_0_plugins_PageModules__[moduleName];pageModules[moduleName]={active:module.active,public:module.public,id:module.type,plugin:true};});var NO_TIME='0000-00-00 00:00:00';var DEFAULT_COVER='/images/cover_default.png';var DEFAULT_CURRENCY='SEK';// pageModules: {
//   helloWorld: {id: 1000, plugin: true},
//   webinar: {id: 1001, plugin: true},
//   oscilloscope: {id: 1002, plugin: true},
//   instagramFeed: {id: 1003, plugin: true},
// },
var ItemTypes={MODULE:'module',ROW:'row',TOC_SECTION:'toc-section',TOC_PAGE:'toc-page',LIST_ITEM:'listitem'};var fileTypeIcons={audio:'audio'};var paymentProviders={STRIPE:6,KLARNA:5,PAYPAL:2,KLARNACHECKOUT:9};var taskTypes={SINGLE_CHOICE:1,MULTI_CHOICE:2,TEXT:4};var NOTIFICATIONS={NOTIFICATION_ADDED_TO_CIRCLE:1,NOTIFICATION_TASK_FEEDBACK:2,NOTIFICATION_POST_ADDED:3,NOTIFICATION_TASK_ASSESSED:4,NOTIFICATION_YOU_MENTIONED:5,NOTIFICATION_FEEDBACK_REQUIRED:6,NOTIFICATION_UNREVIEWED_TASKS:7,NOTIFICATION_THREAD_NEW_POSTS:8,NOTIFICATION_COURSE_NEW_POSTS:9,NOTIFICATION_COURSE_SOLD:10,NOTIFICATION_COURSE_PACKAGE_SOLD:11,NOTIFICATION_ADDED_TO_COURSE:12,NOTIFICATION_DRIP_CONTENT:14,NOTIFICATION_DATA_EXPORT:15,NOTIFICATION_COURSE_INVITE:16,NOTIFICATION_BROADCAST:17};var features={diplomas:'Diplomas',dripContent:'Drip content',enterpriseStore:'Enterprise store',klarnaCheckout:'Klarna checkout',quiz:'Quiz',showTaskResultOnAnswer:'Show taskresult on answer'};var paymentSettings={nonProfit:'NonProfit'};var maxFileSize=512*1024*1024;var notificationPageLength=100;/* harmony default export */ __webpack_exports__["default"] = ({pageModules:pageModules,features:features,paymentSettings:paymentSettings,NOTIFICATIONS:NOTIFICATIONS,NO_TIME:NO_TIME,DEFAULT_CURRENCY:DEFAULT_CURRENCY,DEFAULT_COVER:DEFAULT_COVER,ItemTypes:ItemTypes,fileTypeIcons:fileTypeIcons,paymentProviders:paymentProviders,taskTypes:taskTypes,notificationPageLength:notificationPageLength});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(57);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(220)('wks');
var uid = __webpack_require__(124);
var Symbol = __webpack_require__(24).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_EventManager__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_App__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ReactGestures from 'react-gestures';
var css={root:'_L',count:'_M',header:'_N'};var RulerBar=function(_mixin){_inherits(RulerBar,_mixin);function RulerBar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RulerBar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RulerBar.__proto__||Object.getPrototypeOf(RulerBar)).call.apply(_ref,[this].concat(args))),_this),_this.toggleAppBar=function(event){__WEBPACK_IMPORTED_MODULE_4_actions_App__["a" /* default */].toggleAppBar();event.preventDefault();},_this.onSearchTextChange=function(){if(_this._timer){clearTimeout(_this._timer);}_this._timer=setTimeout(function(){var searchText=null;var fieldValue=_this.refs.searchField.getValue();if(fieldValue!==''){searchText=fieldValue.toUpperCase();}__WEBPACK_IMPORTED_MODULE_4_actions_App__["a" /* default */].search(searchText);},500);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RulerBar,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_5_stores__["b" /* AuthStore */]);this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_5_stores__["b" /* AuthStore */],function(state){return{loggedIn:state.loggedIn};});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_5_stores__["o" /* NotificationStore */],function(state){return{unreadNotifications:state.unreadNotifications};});}},{key:'render',value:function render(){var _props=this.props,children=_props.children,other=_objectWithoutProperties(_props,['children']);var _state=this.state,loggedIn=_state.loggedIn,unreadNotifications=_state.unreadNotifications;var hasCount=!!unreadNotifications;if(loggedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["AppBar"],Object.assign({className:css.root,onLeftIconButtonTouchTap:this.toggleAppBar,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},this.props.title),zDepth:0,style:{zIndex:6}},other),hasCount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.count,onTouchTap:this.toggleAppBar},unreadNotifications<100?unreadNotifications:'10+'),children);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["AppBar"],Object.assign({showMenuIconButton:false,className:css.root,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},this.props.title),zDepth:0},other),children);}}]);return RulerBar;}(Object(__WEBPACK_IMPORTED_MODULE_6_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_6_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));RulerBar.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};RulerBar.propTypes={title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,label:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (RulerBar);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async__ = __webpack_require__(741);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(301);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is__ = __webpack_require__(156);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(302);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_3__logger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__memo__ = __webpack_require__(454);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc__ = __webpack_require__(179);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["n"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__object__ = __webpack_require__(455);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__path__ = __webpack_require__(743);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__promisebuffer__ = __webpack_require__(744);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__promisebuffer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__string__ = __webpack_require__(456);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__supports__ = __webpack_require__(458);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__syncpromise__ = __webpack_require__(457);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__syncpromise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__instrument__ = __webpack_require__(745);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__instrument__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dsn__ = __webpack_require__(746);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_13__dsn__["a"]; });














//# sourceMappingURL=index.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2135)();
}


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(28)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(22);
var IE8_DOM_DEFINE = __webpack_require__(467);
var toPrimitive = __webpack_require__(87);
var dP = Object.defineProperty;

exports.f = __webpack_require__(39) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(89);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* harmony export (immutable) */ __webpack_exports__["e"] = __values;
/* harmony export (immutable) */ __webpack_exports__["c"] = __read;
/* harmony export (immutable) */ __webpack_exports__["d"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var css={card:'_O'};var ScrollableContainer=function(_Component){_inherits(ScrollableContainer,_Component);function ScrollableContainer(){_classCallCheck(this,ScrollableContainer);return _possibleConstructorReturn(this,(ScrollableContainer.__proto__||Object.getPrototypeOf(ScrollableContainer)).apply(this,arguments));}_createClass(ScrollableContainer,[{key:'componentDidMount',value:function componentDidMount(){if(_get(ScrollableContainer.prototype.__proto__||Object.getPrototypeOf(ScrollableContainer.prototype),'componentDidMount',this)){_get(ScrollableContainer.prototype.__proto__||Object.getPrototypeOf(ScrollableContainer.prototype),'componentDidMount',this).call(this);}var onMount=this.props.onMount;this._pageScrollListener=this.onPageScroll.bind(this);this.refs.scrollContainer.addEventListener('scroll',this._pageScrollListener,false);onMount&&onMount();}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(_get(ScrollableContainer.prototype.__proto__||Object.getPrototypeOf(ScrollableContainer.prototype),'componentWillUnmount',this)){_get(ScrollableContainer.prototype.__proto__||Object.getPrototypeOf(ScrollableContainer.prototype),'componentWillUnmount',this).call(this);}this.refs.scrollContainer.removeEventListener('scroll',this._pageScrollListener,false);}},{key:'onPageScroll',value:function onPageScroll(event){var node=Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this.refs.scrollContainer);var containerNode=Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this);if(node.scrollTop+10>=node.scrollHeight-node.clientHeight){if(this.props.onScrollToBottom){this.props.onScrollToBottom();}}}},{key:'getStyle',value:function getStyle(){return Object.assign({},{height:this.props.height,position:'relative',boxSizing:'border-box'},this.props.style);}},{key:'getContainerStyle',value:function getContainerStyle(hasHeader){return{transition:'all 0.5s ease',overflow:'auto',overflowY:'auto',WebkitOverflowScrolling:'touch',position:'absolute',left:0,right:0,bottom:0,top:hasHeader?this.props.headerHeight:0};}},{key:'getToolbarStyle',value:function getToolbarStyle(){return Object.assign({},{position:'absolute',left:0,width:'100%',top:0,zIndex:1});}},{key:'scrollTo',value:function scrollTo(position){var node=Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this.refs.scrollContainer);node.scrollTop=position;}},{key:'scrollToEnd',value:function scrollToEnd(){var node=this.refs.scrollContainer;// const boundingRect = node.getBoundingClientRect();
node.scrollTop=node.scrollHeight;}},{key:'render',value:function render(){var _props=this.props,card=_props.card,header=_props.header,style=_props.style,children=_props.children,containerStyle=_props.containerStyle,other=_objectWithoutProperties(_props,['card','header','style','children','containerStyle']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({style:this.getStyle(!!header)},other,{className:card?css.card:null}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:Object.assign({},this.getContainerStyle(!!header),containerStyle),ref:'scrollContainer'},this.props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getToolbarStyle()},header));}}]);return ScrollableContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ScrollableContainer.propTypes={header:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,height:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string]),headerHeight:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,onMount:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,containerStyle:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,card:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};ScrollableContainer.defaultProps={height:'100%',headerHeight:60,style:{},containerStyle:{}};/* harmony default export */ __webpack_exports__["a"] = (ScrollableContainer);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(88);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var textColors = {
  Light: {
    divider: 'rgba(255, 255, 255, 0.12)',
    disabled: 'rgba(255, 255, 255, 0.30)',
    secondary: 'rgba(255, 255, 255, 0.70)',
    default: 'rgba(255, 255, 255, 1)',
    border: 'rgba(66, 66, 66, 0.3)'
  },
  Dark: {
    divider: 'rgba(0, 0, 0, 0.12)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    secondary: 'rgba(0, 0, 0, 0.54)',
    default: 'rgba(0, 0, 0, 0.87)',
    border: 'rgba(66, 66, 66, 0.3)'
  }
};

var Colors = {
  red: {
    '50': { hex: '#FFEBEE', text: textColors.Dark },
    '100': { hex: '#FFCDD2', text: textColors.Dark },
    '200': { hex: '#EF9A9A', text: textColors.Dark },
    '300': { hex: '#E57373', text: textColors.Dark },
    '400': { hex: '#EF5350', text: textColors.Light },
    '500': { hex: '#F44336', text: textColors.Light },
    '600': { hex: '#E53935', text: textColors.Light },
    '700': { hex: '#D32F2F', text: textColors.Light },
    '800': { hex: '#C62828', text: textColors.Light },
    '900': { hex: '#B71C1C', text: textColors.Light },
    'A100': { hex: '#FF8A80', text: textColors.Dark },
    'A200': { hex: '#FF5252', text: textColors.Light },
    'A400': { hex: '#FF1744', text: textColors.Light },
    'A700': { hex: '#D50000', text: textColors.Light }
  },
  pink: {
    '50': { hex: '#FCE4EC', text: textColors.Dark },
    '100': { hex: '#F8BBD0', text: textColors.Dark },
    '200': { hex: '#F48FB1', text: textColors.Dark },
    '300': { hex: '#F06292', text: textColors.Light },
    '400': { hex: '#EC407A', text: textColors.Light },
    '500': { hex: '#E91E63', text: textColors.Light },
    '600': { hex: '#D81B60', text: textColors.Light },
    '700': { hex: '#C2185B', text: textColors.Light },
    '800': { hex: '#AD1457', text: textColors.Light },
    '900': { hex: '#880E4F', text: textColors.Light },
    'A100': { hex: '#FF80AB', text: textColors.Dark },
    'A200': { hex: '#FF4081', text: textColors.Light },
    'A400': { hex: '#F50057', text: textColors.Light },
    'A700': { hex: '#C51162', text: textColors.Light }
  },
  purple: {
    '50': { hex: '#F3E5F5', text: textColors.Dark },
    '100': { hex: '#E1BEE7', text: textColors.Dark },
    '200': { hex: '#CE93D8', text: textColors.Dark },
    '300': { hex: '#BA68C8', text: textColors.Light },
    '400': { hex: '#AB47BC', text: textColors.Light },
    '500': { hex: '#9C27B0', text: textColors.Light },
    '600': { hex: '#8E24AA', text: textColors.Light },
    '700': { hex: '#7B1FA2', text: textColors.Light },
    '800': { hex: '#6A1B9A', text: textColors.Light },
    '900': { hex: '#4A148C', text: textColors.Light },
    'A100': { hex: '#EA80FC', text: textColors.Dark },
    'A200': { hex: '#E040FB', text: textColors.Light },
    'A400': { hex: '#D500F9', text: textColors.Light },
    'A700': { hex: '#AA00FF', text: textColors.Light }
  },
  deepPurple: {
    '50': { hex: '#EDE7F6', text: textColors.Dark },
    '100': { hex: '#D1C4E9', text: textColors.Dark },
    '200': { hex: '#B39DDB', text: textColors.Dark },
    '300': { hex: '#9575CD', text: textColors.Light },
    '400': { hex: '#7E57C2', text: textColors.Light },
    '500': { hex: '#673AB7', text: textColors.Light },
    '600': { hex: '#5E35B1', text: textColors.Light },
    '700': { hex: '#512DA8', text: textColors.Light },
    '800': { hex: '#4527A0', text: textColors.Light },
    '900': { hex: '#311B92', text: textColors.Light },
    'A100': { hex: '#B388FF', text: textColors.Dark },
    'A200': { hex: '#7C4DFF', text: textColors.Light },
    'A400': { hex: '#651FFF', text: textColors.Light },
    'A700': { hex: '#6200EA', text: textColors.Light }
  },
  indigo: {
    '50': { hex: '#E8EAF6', text: textColors.Dark },
    '100': { hex: '#C5CAE9', text: textColors.Dark },
    '200': { hex: '#9FA8DA', text: textColors.Dark },
    '300': { hex: '#7986CB', text: textColors.Light },
    '400': { hex: '#5C6BC0', text: textColors.Light },
    '500': { hex: '#3F51B5', text: textColors.Light },
    '600': { hex: '#3949AB', text: textColors.Light },
    '700': { hex: '#303F9F', text: textColors.Light },
    '800': { hex: '#283593', text: textColors.Light },
    '900': { hex: '#1A237E', text: textColors.Light },
    'A100': { hex: '#8C9EFF', text: textColors.Dark },
    'A200': { hex: '#536DFE', text: textColors.Light },
    'A400': { hex: '#3D5AFE', text: textColors.Light },
    'A700': { hex: '#304FFE', text: textColors.Light }
  },
  blue: {
    '50': { hex: '#E3F2FD', text: textColors.Dark },
    '100': { hex: '#BBDEFB', text: textColors.Dark },
    '200': { hex: '#90CAF9', text: textColors.Dark },
    '300': { hex: '#64B5F6', text: textColors.Dark },
    '400': { hex: '#42A5F5', text: textColors.Dark },
    '500': { hex: '#2196F3', text: textColors.Light },
    '600': { hex: '#1E88E5', text: textColors.Light },
    '700': { hex: '#1976D2', text: textColors.Light },
    '800': { hex: '#1565C0', text: textColors.Light },
    '900': { hex: '#0D47A1', text: textColors.Light },
    'A100': { hex: '#82B1FF', text: textColors.Dark },
    'A200': { hex: '#448AFF', text: textColors.Light },
    'A400': { hex: '#2979FF', text: textColors.Light },
    'A700': { hex: '#2962FF', text: textColors.Light }
  },
  lightBlue: {
    '50': { hex: '#E1F5FE', text: textColors.Dark },
    '100': { hex: '#B3E5FC', text: textColors.Dark },
    '200': { hex: '#81D4FA', text: textColors.Dark },
    '300': { hex: '#4FC3F7', text: textColors.Dark },
    '400': { hex: '#29B6F6', text: textColors.Dark },
    '500': { hex: '#03A9F4', text: textColors.Dark },
    '600': { hex: '#039BE5', text: textColors.Light },
    '700': { hex: '#0288D1', text: textColors.Light },
    '800': { hex: '#0277BD', text: textColors.Light },
    '900': { hex: '#01579B', text: textColors.Light },
    'A100': { hex: '#80D8FF', text: textColors.Dark },
    'A200': { hex: '#40C4FF', text: textColors.Dark },
    'A400': { hex: '#00B0FF', text: textColors.Dark },
    'A700': { hex: '#0091EA', text: textColors.Light }
  },
  cyan: {
    '50': { hex: '#E0F7FA', text: textColors.Dark },
    '100': { hex: '#B2EBF2', text: textColors.Dark },
    '200': { hex: '#80DEEA', text: textColors.Dark },
    '300': { hex: '#4DD0E1', text: textColors.Dark },
    '400': { hex: '#26C6DA', text: textColors.Dark },
    '500': { hex: '#00BCD4', text: textColors.Dark },
    '600': { hex: '#00ACC1', text: textColors.Dark },
    '700': { hex: '#0097A7', text: textColors.Light },
    '800': { hex: '#00838F', text: textColors.Light },
    '900': { hex: '#006064', text: textColors.Light },
    'A100': { hex: '#84FFFF', text: textColors.Dark },
    'A200': { hex: '#18FFFF', text: textColors.Dark },
    'A400': { hex: '#00E5FF', text: textColors.Dark },
    'A700': { hex: '#00B8D4', text: textColors.Dark }
  },
  coursio: {
    '50': { hex: '#70FDFF', text: textColors.Dark },
    '100': { hex: '#5CFCFF', text: textColors.Dark },
    '200': { hex: '#47FCFF', text: textColors.Dark },
    '300': { hex: '#1FFBFF', text: textColors.Dark },
    '400': { hex: '#00F1F5', text: textColors.Dark },
    '500': { hex: '#00c9cc', text: textColors.Light },
    '600': { hex: '#00A0A3', text: textColors.Light },
    '700': { hex: '#008C8F', text: textColors.Light },
    '800': { hex: '#006466', text: textColors.Light },
    '900': { hex: '#003C3D', text: textColors.Light },
    'A100': { hex: '#5CFCFF', text: textColors.Dark },
    'A200': { hex: '#47FCFF', text: textColors.Dark },
    'A400': { hex: '#00F1F5', text: textColors.Dark },
    'A700': { hex: '#008C8F', text: textColors.Dark }
  },
  teal: {
    '50': { hex: '#E0F2F1', text: textColors.Dark },
    '100': { hex: '#B2DFDB', text: textColors.Dark },
    '200': { hex: '#80CBC4', text: textColors.Dark },
    '300': { hex: '#4DB6AC', text: textColors.Dark },
    '400': { hex: '#26A69A', text: textColors.Dark },
    '500': { hex: '#009688', text: textColors.Light },
    '600': { hex: '#00897B', text: textColors.Light },
    '700': { hex: '#00796B', text: textColors.Light },
    '800': { hex: '#00695C', text: textColors.Light },
    '900': { hex: '#004D40', text: textColors.Light },
    'A100': { hex: '#A7FFEB', text: textColors.Dark },
    'A200': { hex: '#64FFDA', text: textColors.Dark },
    'A400': { hex: '#1DE9B6', text: textColors.Dark },
    'A700': { hex: '#00BFA5', text: textColors.Dark }
  },
  green: {
    '50': { hex: '#E8F5E9', text: textColors.Dark },
    '100': { hex: '#C8E6C9', text: textColors.Dark },
    '200': { hex: '#A5D6A7', text: textColors.Dark },
    '300': { hex: '#81C784', text: textColors.Dark },
    '400': { hex: '#66BB6A', text: textColors.Dark },
    '500': { hex: '#4CAF50', text: textColors.Dark },
    '600': { hex: '#43A047', text: textColors.Light },
    '700': { hex: '#388E3C', text: textColors.Light },
    '800': { hex: '#2E7D32', text: textColors.Light },
    '900': { hex: '#1B5E20', text: textColors.Light },
    'A100': { hex: '#B9F6CA', text: textColors.Dark },
    'A200': { hex: '#69F0AE', text: textColors.Dark },
    'A400': { hex: '#00E676', text: textColors.Dark },
    'A700': { hex: '#00C853', text: textColors.Dark }
  },
  lightGreen: {
    '50': { hex: '#F1F8E9', text: textColors.Dark },
    '100': { hex: '#DCEDC8', text: textColors.Dark },
    '200': { hex: '#C5E1A5', text: textColors.Dark },
    '300': { hex: '#AED581', text: textColors.Dark },
    '400': { hex: '#9CCC65', text: textColors.Dark },
    '500': { hex: '#8BC34A', text: textColors.Dark },
    '600': { hex: '#7CB342', text: textColors.Dark },
    '700': { hex: '#689F38', text: textColors.Light },
    '800': { hex: '#558B2F', text: textColors.Light },
    '900': { hex: '#33691E', text: textColors.Light },
    'A100': { hex: '#CCFF90', text: textColors.Dark },
    'A200': { hex: '#B2FF59', text: textColors.Dark },
    'A400': { hex: '#76FF03', text: textColors.Dark },
    'A700': { hex: '#64DD17', text: textColors.Dark }
  },
  lime: {
    '50': { hex: '#F9FBE7', text: textColors.Dark },
    '100': { hex: '#F0F4C3', text: textColors.Dark },
    '200': { hex: '#E6EE9C', text: textColors.Dark },
    '300': { hex: '#DCE775', text: textColors.Dark },
    '400': { hex: '#D4E157', text: textColors.Dark },
    '500': { hex: '#CDDC39', text: textColors.Dark },
    '600': { hex: '#C0CA33', text: textColors.Dark },
    '700': { hex: '#AFB42B', text: textColors.Dark },
    '800': { hex: '#9E9D24', text: textColors.Dark },
    '900': { hex: '#827717', text: textColors.Light },
    'A100': { hex: '#F4FF81', text: textColors.Dark },
    'A200': { hex: '#EEFF41', text: textColors.Dark },
    'A400': { hex: '#C6FF00', text: textColors.Dark },
    'A700': { hex: '#AEEA00', text: textColors.Dark }

  },
  yellow: {
    '50': { hex: '#FFFDE7', text: textColors.Dark },
    '100': { hex: '#FFF9C4', text: textColors.Dark },
    '200': { hex: '#FFF59D', text: textColors.Dark },
    '300': { hex: '#FFF176', text: textColors.Dark },
    '400': { hex: '#FFEE58', text: textColors.Dark },
    '500': { hex: '#FFEB3B', text: textColors.Dark },
    '600': { hex: '#FDD835', text: textColors.Dark },
    '700': { hex: '#FBC02D', text: textColors.Dark },
    '800': { hex: '#F9A825', text: textColors.Dark },
    '900': { hex: '#F57F17', text: textColors.Dark },
    'A100': { hex: '#FFFF8D', text: textColors.Dark },
    'A200': { hex: '#FFFF00', text: textColors.Dark },
    'A400': { hex: '#FFEA00', text: textColors.Dark },
    'A700': { hex: '#FFD600', text: textColors.Dark }

  },
  amber: {
    '50': { hex: '#FFF8E1', text: textColors.Dark },
    '100': { hex: '#FFECB3', text: textColors.Dark },
    '200': { hex: '#FFE082', text: textColors.Dark },
    '300': { hex: '#FFD54F', text: textColors.Dark },
    '400': { hex: '#FFCA28', text: textColors.Dark },
    '500': { hex: '#FFC107', text: textColors.Dark },
    '600': { hex: '#FFB300', text: textColors.Dark },
    '700': { hex: '#FFA000', text: textColors.Dark },
    '800': { hex: '#FF8F00', text: textColors.Dark },
    '900': { hex: '#FF6F00', text: textColors.Dark },
    'A100': { hex: '#FFE57F', text: textColors.Dark },
    'A200': { hex: '#FFD740', text: textColors.Dark },
    'A400': { hex: '#FFC400', text: textColors.Dark },
    'A700': { hex: '#FFAB00', text: textColors.Dark }

  },
  orange: {
    '50': { hex: '#FFF3E0', text: textColors.Dark },
    '100': { hex: '#FFE0B2', text: textColors.Dark },
    '200': { hex: '#FFCC80', text: textColors.Dark },
    '300': { hex: '#FFB74D', text: textColors.Dark },
    '400': { hex: '#FFA726', text: textColors.Dark },
    '500': { hex: '#FF9800', text: textColors.Dark },
    '600': { hex: '#FB8C00', text: textColors.Dark },
    '700': { hex: '#F57C00', text: textColors.Dark },
    '800': { hex: '#EF6C00', text: textColors.Light },
    '900': { hex: '#E65100', text: textColors.Light },
    'A100': { hex: '#FFD180', text: textColors.Dark },
    'A200': { hex: '#FFAB40', text: textColors.Dark },
    'A400': { hex: '#FF9100', text: textColors.Dark },
    'A700': { hex: '#FF6D00', text: textColors.Dark }

  },
  deepOrange: {
    '50': { hex: '#FBE9E7', text: textColors.Dark },
    '100': { hex: '#FFCCBC', text: textColors.Dark },
    '200': { hex: '#FFAB91', text: textColors.Dark },
    '300': { hex: '#FF8A65', text: textColors.Dark },
    '400': { hex: '#FF7043', text: textColors.Dark },
    '500': { hex: '#FF5722', text: textColors.Light },
    '600': { hex: '#F4511E', text: textColors.Light },
    '700': { hex: '#E64A19', text: textColors.Light },
    '800': { hex: '#D84315', text: textColors.Light },
    '900': { hex: '#BF360C', text: textColors.Light },
    'A100': { hex: '#FF9E80', text: textColors.Dark },
    'A200': { hex: '#FF6E40', text: textColors.Dark },
    'A400': { hex: '#FF3D00', text: textColors.Light },
    'A700': { hex: '#DD2C00', text: textColors.Light }

  },
  brown: {
    '50': { hex: '#EFEBE9', text: textColors.Dark },
    '100': { hex: '#D7CCC8', text: textColors.Dark },
    '200': { hex: '#BCAAA4', text: textColors.Dark },
    '300': { hex: '#A1887F', text: textColors.Light },
    '400': { hex: '#8D6E63', text: textColors.Light },
    '500': { hex: '#795548', text: textColors.Light },
    '600': { hex: '#6D4C41', text: textColors.Light },
    '700': { hex: '#5D4037', text: textColors.Light },
    '800': { hex: '#4E342E', text: textColors.Light },
    '900': { hex: '#3E2723', text: textColors.Light }
  },
  grey: {
    '50': { hex: '#FAFAFA', text: textColors.Dark },
    '100': { hex: '#F5F5F5', text: textColors.Dark },
    '200': { hex: '#EEEEEE', text: textColors.Dark },
    '300': { hex: '#E0E0E0', text: textColors.Dark },
    '400': { hex: '#BDBDBD', text: textColors.Dark },
    '500': { hex: '#9E9E9E', text: textColors.Dark },
    '600': { hex: '#757575', text: textColors.Light },
    '700': { hex: '#616161', text: textColors.Light },
    '800': { hex: '#424242', text: textColors.Light },
    '900': { hex: '#212121', text: textColors.Light }
  },
  blueGrey: {
    '50': { hex: '#ECEFF1', text: textColors.Dark },
    '100': { hex: '#CFD8DC', text: textColors.Dark },
    '200': { hex: '#B0BEC5', text: textColors.Dark },
    '300': { hex: '#90A4AE', text: textColors.Dark },
    '400': { hex: '#78909C', text: textColors.Light },
    '500': { hex: '#607D8B', text: textColors.Light },
    '600': { hex: '#546E7A', text: textColors.Light },
    '700': { hex: '#455A64', text: textColors.Light },
    '800': { hex: '#37474F', text: textColors.Light },
    '900': { hex: '#263238', text: textColors.Light }
  }
};

var themeColors = {
  Light: {
    statusBar: '#777777',
    appBar: '#E5E5E5',
    background: '#F2F2F2',
    card: '#FFFFFF'
  },
  Dark: {
    statusBar: '#000000',
    appBar: '#212121',
    background: '#303030',
    card: '#424242'
  }
};

var Shadow = [null, '0 1px 3px 0 rgba(0, 0, 0, 0.11)', '0 2px 6px 0 rgba(0, 0, 0, 0.06)', '0 5px 14px 0 rgba(0, 0, 0, 0.08)', '0 2px 24px 0 rgba(0,0,0,.07)'];

function hexToRgba(input, opacity) {
  var hex = input.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);

  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
}

function brighten(input, percentage) {
  var hex = input.replace('#', '');
  var r = Math.ceil(parseInt(hex.substring(0, 2), 16) * (1 + percentage));
  var g = Math.ceil(parseInt(hex.substring(2, 4), 16) * (1 + percentage));
  var b = Math.ceil(parseInt(hex.substring(4, 6), 16) * (1 + percentage));

  return 'rgba(' + r + ',' + g + ',' + b + ', 1)';
}

module.exports = {
  hexToRgba: hexToRgba,
  brighten: brighten,
  Shadow: Shadow,
  Typography: {
    paragraph: {
      fontSize: 14,
      letterSpacing: '0.1px',
      fontFamily: 'MaisonNeue-Book',
      lineHeight: 1.5
    },
    small: {
      fontSize: 12,
      letterSpacing: '0.1px',
      fontFamily: 'MaisonNeue-Demi',
      lineHeight: 1.5
    },
    normal: {
      fontSize: 14,
      letterSpacing: '0.1px',
      fontFamily: 'MaisonNeue-Book',
      lineHeight: 1.5
    },
    subheading: {
      fontSize: 20,
      letterSpacing: '0.5px',
      fontFamily: 'MaisonNeue-Demi',
      lineHeight: 1.5
    },
    heading: {
      fontSize: 32,
      letterSpacing: '0.5px',
      fontFamily: 'MaisonNeue-Demi',
      lineHeight: 1.5
    }
  },
  Cio: {
    Menu: {
      padding: 8,
      margin: 16,
      item: {
        padding: 16,
        margin: 16,
        height: 48,
        dense: {
          height: 32
        }
      }
    },
    Text: {
      disabled: '#AEAEAE',
      default: '#343434',
      light: '#424242',
      secondary: '#7e7e7e'
    },
    Colors: {
      creen: '#3bcfd1',
      Light: {
        divider: '#E8E8E8',
        border: '#CDCDCD',
        card: '#FFFFFF',
        background: '#F2F2F2'
      }
    }
  },
  Units: {
    base: 8,
    keyline: 64
  },
  Colors: {
    material: Colors,
    theme: themeColors,
    text: textColors,
    black: '#000000',
    white: '#ffffff',
    creen: '#3bcfd1',
    brightOrange: '#ff5500',
    transparent: 'rgba(0, 0, 0, 0)',
    fullBlack: 'rgba(0, 0, 0, 1)',
    darkBlack: 'rgba(0, 0, 0, 0.87)',
    lightBlack: 'rgba(0, 0, 0, 0.54)',
    minBlack: 'rgba(0, 0, 0, 0.26)',
    faintBlack: 'rgba(0, 0, 0, 0.12)',
    fullWhite: 'rgba(255, 255, 255, 1)',
    darkWhite: 'rgba(255, 255, 255, 0.87)',
    lightWhite: 'rgba(255, 255, 255, 0.54)',
    bondiBlue: '#00C9CC',
    darkBondiBlue: '#004F51',
    bondiBluehover: '#09E4E9'
  }
};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var CourseActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['setCategory','addTag','addTagComplete','removeTag','removeTagComplete','increaseModuleSize','increaseModuleSizeComplete','sanitizePage','filter','setFilter','search','resetFilter','setSort','resetSort','updatePageModule','updatePageModuleComplete','findBySlug','findBySlugComplete','getPageById','getPageByIdComplete','getPageBySlug','getPageBySlugComplete','saveSettings','updateDiploma','removeDiploma','retrieveDiploma','findById','findByIdComplete','findBuildable','findBuildableComplete','findByUserId','findByUserIdComplete','findByGroupId','moveModule','moveModuleToRow','moveModuleToNewRow','moveModuleToNewRowComplete','cancelNewRow','deletePageRow','createSectionComplete','deletePageRowComplete','moveModuleAfterRow','addToTop','deleteModule','deleteModuleComplete','getFile','update','updateComplete','createComplete','genericError','addSection','addQuizSectionComplete','addQuizPageComplete','addSectionComplete','updateQuizSettings','createPageComplete','updatePageRow','updatePageRowComplete','updatePage','updatePageComplete','updateSection','updateSectionComplete','deleteSection','deleteSectionComplete','deletePage','deletePageComplete','genericError','removeFromSelection','duplicatePage','duplicatePageComplete','duplicateSection','duplicateSectionComplete','updateTask','updateTaskComplete','setPageModuleFile','updateTaskCaption',{'answerTask':{asyncResult:true}},'answerTaskComplete','note','noteComplete','toggleNotes','findNotes','resetSelection','openToc','closeToc','toggleToc','openLayoutDesign','closeLayoutDesign','toggleLayoutDesign','markPageViewed','markPageViewedComplete','addPageModule','addPageModuleComplete','moveSection','movePage','movePageComplete','addPage','addPageComplete','reorderSections','reorderSectionsComplete','reorderPages','reorderPagesComplete','setPageModuleMode','pastePage','pasteSection','getToc','getTocComplete','getGuestToc','getGuestTocComplete','refetchToc','updateDripContent']);/* harmony default export */ __webpack_exports__["a"] = (CourseActions);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_PageModule_Controls__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_DialogPortal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__ = __webpack_require__(96);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageModule=function(_Component){_inherits(PageModule,_Component);function PageModule(props){_classCallCheck(this,PageModule);var _this=_possibleConstructorReturn(this,(PageModule.__proto__||Object.getPrototypeOf(PageModule)).call(this,props));_this.handleModeChange=function(){_this.save();};_this.state={mouseOver:false};return _this;}_createClass(PageModule,[{key:'componentDidMount',value:function componentDidMount(){if(this.onInit){this.onInit();}}},{key:'getModuleData',value:function getModuleData(content,data){return Object.assign({},data);}},{key:'getContent',value:function getContent(content,data){return content;}},{key:'getUserData',value:function getUserData(userdata){return Object.assign({},userdata);}},{key:'getStyle',value:function getStyle(){var mouseOver=this.state.mouseOver;var _props=this.props,style=_props.style,mode=_props.mode;return Object.assign({},__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].root,style,mode==='edit'?__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].edit:null,mouseOver&&mode==='edit'?__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].hover:null);}},{key:'listenToActions',value:function listenToActions(){this.listenToAction(__WEBPACK_IMPORTED_MODULE_1_actions__["b" /* AuthActions */].readerMode,this.handleModeChange);}},{key:'createControls',value:function createControls(){var _props2=this.props,mode=_props2.mode,params=_props2.params,moduleName=_props2.moduleName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["a" /* FlexBox */],{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].toolbar,row:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["a" /* FlexBox */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["a" /* FlexBox */],{grow:0,shrink:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_PageModule_Controls__["a" /* default */],{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].toolbarGroup,onSave:this.save.bind(this),onDelete:this.askForDelete.bind(this),onEditMode:this.changeToEditMode.bind(this),mode:mode,raw:params.hasOwnProperty('raw')?params.raw:false,moduleName:moduleName})));}},{key:'handleMouseEnter',value:function handleMouseEnter(){this.setState({mouseOver:true});}},{key:'handleMouseLeave',value:function handleMouseLeave(){this.setState({mouseOver:false});}},{key:'askForDelete',value:function askForDelete(){this.refs.confirmDialog.show();}},{key:'cancelDelete',value:function cancelDelete(){this.refs.confirmDialog.dismiss();}},{key:'clearUserData',value:function clearUserData(){__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].savePageModuleUserData(this.props.moduleId,{});}},{key:'deleteModule',value:function deleteModule(){__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].deletePageModule(this.props.moduleId);}},{key:'changeToEditMode',value:function changeToEditMode(){this.onEdit();if(this.props.onEdit){this.props.onEdit();}__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].changePageModuleMode(this.props.moduleId,'edit');}},{key:'onEdit',value:function onEdit(){}},{key:'changeToDetailMode',value:function changeToDetailMode(){this.onDetail();if(this.props.onDetail){this.props.onDetail();}__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].changePageModuleMode(this.props.moduleId,'detail');}},{key:'onDetail',value:function onDetail(){}},{key:'saveUserData',value:function saveUserData(){var userdata=this.props.userdata;var dataToSave=this.getUserData(userdata);__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].savePageModuleUserData(this.props.moduleId,dataToSave);}},{key:'save',value:function save(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},_ref$isCancelResize=_ref.isCancelResize,isCancelResize=_ref$isCancelResize===undefined?false:_ref$isCancelResize,_ref$switchBack=_ref.switchBack,switchBack=_ref$switchBack===undefined?true:_ref$switchBack;var _props3=this.props,content=_props3.content,params=_props3.params;var dataToSave=this.getModuleData(content,params);var contentToSave=this.getContent(content,params);dataToSave.raw=isCancelResize;__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].savePageModule(this.props.moduleId,contentToSave,dataToSave);if(switchBack){this.changeToDetailMode();}}},{key:'autoSave',value:function autoSave(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].markModuleSaving(this.props.moduleId);if(this._saveTimer){clearTimeout(this._saveTimer);}this._saveTimer=setTimeout(function(){_this2.save({switchBack:false});},1000);}},{key:'renderEditMode',value:function renderEditMode(content,data,userdata){console.log(content,data,userdata);}},{key:'renderDetailMode',value:function renderDetailMode(content,data,userdata){console.log(content,data,userdata);}},{key:'render',value:function render(){var _props4=this.props,mode=_props4.mode,saving=_props4.saving,editor=_props4.editor,content=_props4.content,params=_props4.params,userdata=_props4.userdata,children=_props4.children;var dialog=void 0;var pageModule=void 0;var controls=void 0;if(editor){controls=this.createControls();var standardActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["FlatButton"],{key:'cancel',label:this.context.getIntlMessage('No'),primary:true,onTouchTap:this.cancelDelete.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('Yes'),secondary:true,onTouchTap:this.deleteModule.bind(this)})];dialog=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Dialog"],{ref:'confirmDialog',title:this.context.getIntlMessage('Remove'),actions:standardActions,dismissOnClickAway:true},this.context.getIntlMessage('module.confirmDelete')));}var savingIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].saving},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["CircularProgress"],{size:0.5,mode:'indeterminate'}));if(mode==='edit'&&editor){pageModule=this.renderEditMode(content,params||{},userdata);}else{pageModule=this.renderDetailMode(content,params||{},userdata);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getStyle(),onMouseEnter:this.handleMouseEnter.bind(this),onMouseLeave:this.handleMouseLeave.bind(this)},controls,pageModule,children,saving&&savingIcon,dialog);}}]);return PageModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PageModule.propTypes={user:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,mode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOf(['detail','edit']),style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,editor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,reader:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,params:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array]),children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,content:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string]),userdata:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array]),moduleId:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number};PageModule.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (PageModule);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMount
 */



var DOMProperty = __webpack_require__(150);
var ReactBrowserEventEmitter = __webpack_require__(214);
var ReactCurrentOwner = __webpack_require__(99);
var ReactDOMFeatureFlags = __webpack_require__(428);
var ReactElement = __webpack_require__(51);
var ReactEmptyComponentRegistry = __webpack_require__(429);
var ReactInstanceHandles = __webpack_require__(152);
var ReactInstanceMap = __webpack_require__(177);
var ReactMarkupChecksum = __webpack_require__(431);
var ReactPerf = __webpack_require__(72);
var ReactReconciler = __webpack_require__(120);
var ReactUpdateQueue = __webpack_require__(286);
var ReactUpdates = __webpack_require__(73);

var assign = __webpack_require__(29);
var emptyObject = __webpack_require__(153);
var containsNode = __webpack_require__(432);
var instantiateReactComponent = __webpack_require__(288);
var invariant = __webpack_require__(20);
var setInnerHTML = __webpack_require__(212);
var shouldUpdateReactComponent = __webpack_require__(290);
var validateDOMNesting = __webpack_require__(291);
var warning = __webpack_require__(33);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var nodeCache = {};

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);

/** Mapping from reactRootID to React component instance. */
var instancesByReactRootID = {};

/** Mapping from reactRootID to `container` nodes. */
var containersByReactRootID = {};

if (false) {
  /** __DEV__-only mapping from reactRootID to root elements. */
  var rootElementsByReactRootID = {};
}

// Used to store breadth-first search state in findComponentRoot.
var findComponentRootReusableArray = [];

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

/**
 * @param {DOMElement} container DOM element that may contain a React component.
 * @return {?string} A "reactRoot" ID, if a React component is rendered.
 */
function getReactRootID(container) {
  var rootElement = getReactRootElementInContainer(container);
  return rootElement && ReactMount.getID(rootElement);
}

/**
 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
 * element can return its control whose name or ID equals ATTR_NAME. All
 * DOM nodes support `getAttributeNode` but this can also get called on
 * other objects so just return '' if we're given something other than a
 * DOM node (such as window).
 *
 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
 * @return {string} ID of the supplied `domNode`.
 */
function getID(node) {
  var id = internalGetID(node);
  if (id) {
    if (nodeCache.hasOwnProperty(id)) {
      var cached = nodeCache[id];
      if (cached !== node) {
        !!isValid(cached, id) ?  false ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;

        nodeCache[id] = node;
      }
    } else {
      nodeCache[id] = node;
    }
  }

  return id;
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Sets the React-specific ID of the given node.
 *
 * @param {DOMElement} node The DOM node whose ID will be set.
 * @param {string} id The value of the ID attribute.
 */
function setID(node, id) {
  var oldID = internalGetID(node);
  if (oldID !== id) {
    delete nodeCache[oldID];
  }
  node.setAttribute(ATTR_NAME, id);
  nodeCache[id] = node;
}

/**
 * Finds the node with the supplied React-generated DOM ID.
 *
 * @param {string} id A React-generated DOM ID.
 * @return {DOMElement} DOM node with the suppled `id`.
 * @internal
 */
function getNode(id) {
  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
    nodeCache[id] = ReactMount.findReactNodeByID(id);
  }
  return nodeCache[id];
}

/**
 * Finds the node with the supplied public React instance.
 *
 * @param {*} instance A public React instance.
 * @return {?DOMElement} DOM node with the suppled `id`.
 * @internal
 */
function getNodeFromInstance(instance) {
  var id = ReactInstanceMap.get(instance)._rootNodeID;
  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
    return null;
  }
  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
    nodeCache[id] = ReactMount.findReactNodeByID(id);
  }
  return nodeCache[id];
}

/**
 * A node is "valid" if it is contained by a currently mounted container.
 *
 * This means that the node does not have to be contained by a document in
 * order to be considered valid.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @param {string} id The expected ID of the node.
 * @return {boolean} Whether the node is contained by a mounted container.
 */
function isValid(node, id) {
  if (node) {
    !(internalGetID(node) === id) ?  false ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;

    var container = ReactMount.findReactContainerForID(id);
    if (container && containsNode(container, node)) {
      return true;
    }
  }

  return false;
}

/**
 * Causes the cache to forget about one React-specific ID.
 *
 * @param {string} id The ID to forget.
 */
function purgeID(id) {
  delete nodeCache[id];
}

var deepestNodeSoFar = null;
function findDeepestCachedAncestorImpl(ancestorID) {
  var ancestor = nodeCache[ancestorID];
  if (ancestor && isValid(ancestor, ancestorID)) {
    deepestNodeSoFar = ancestor;
  } else {
    // This node isn't populated in the cache, so presumably none of its
    // descendants are. Break out of the loop.
    return false;
  }
}

/**
 * Return the deepest cached node whose ID is a prefix of `targetID`.
 */
function findDeepestCachedAncestor(targetID) {
  deepestNodeSoFar = null;
  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);

  var foundNode = deepestNodeSoFar;
  deepestNodeSoFar = null;
  return foundNode;
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {string} rootID DOM ID of the root node.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
  if (ReactDOMFeatureFlags.useCreateElement) {
    context = assign({}, context);
    if (container.nodeType === DOC_NODE_TYPE) {
      context[ownerDocumentContextKey] = container;
    } else {
      context[ownerDocumentContextKey] = container.ownerDocument;
    }
  }
  if (false) {
    if (context === emptyObject) {
      context = {};
    }
    var tag = container.nodeName.toLowerCase();
    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
  }
  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {string} rootID DOM ID of the root node.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* forceHTML */shouldReuseMarkup);
  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container) {
  ReactReconciler.unmountComponent(instance);

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(node) {
  var reactRootID = getReactRootID(node);
  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
}

/**
 * Returns the first (deepest) ancestor of a node which is rendered by this copy
 * of React.
 */
function findFirstReactDOMImpl(node) {
  // This node might be from another React instance, so we make sure not to
  // examine the node cache here
  for (; node && node.parentNode !== node; node = node.parentNode) {
    if (node.nodeType !== 1) {
      // Not a DOMElement, therefore not a React component
      continue;
    }
    var nodeID = internalGetID(node);
    if (!nodeID) {
      continue;
    }
    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);

    // If containersByReactRootID contains the container we find by crawling up
    // the tree, we know that this instance of React rendered the node.
    // nb. isValid's strategy (with containsNode) does not work because render
    // trees may be nested and we don't want a false positive in that case.
    var current = node;
    var lastID;
    do {
      lastID = internalGetID(current);
      current = current.parentNode;
      if (current == null) {
        // The passed-in node has been detached from the container it was
        // originally rendered into.
        return null;
      }
    } while (lastID !== reactRootID);

    if (current === containersByReactRootID[reactRootID]) {
      return node;
    }
  }
  return null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var TopLevelWrapper = function () {};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  // this.props is actually a ReactElement
  return this.props;
};

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {

  TopLevelWrapper: TopLevelWrapper,

  /** Exposed for debugging purposes **/
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    if (false) {
      // Record the root element in case it later gets transplanted.
      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
    }

    return prevComponent;
  },

  /**
   * Register a component into the instance map and starts scroll value
   * monitoring
   * @param {ReactComponent} nextComponent component instance to render
   * @param {DOMElement} container container to render into
   * @return {string} reactRoot ID prefix
   */
  _registerComponent: function (nextComponent, container) {
    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();

    var reactRootID = ReactMount.registerContainer(container);
    instancesByReactRootID[reactRootID] = nextComponent;
    return reactRootID;
  },

  /**
   * Render a new component into the DOM.
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;

    var componentInstance = instantiateReactComponent(nextElement, null);
    var reactRootID = ReactMount._registerComponent(componentInstance, container);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);

    if (false) {
      // Record the root element in case it later gets transplanted.
      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
    }

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
    // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;

    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);

    var prevComponent = instancesByReactRootID[getReactRootID(container)];

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        return ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, callback)._renderedComponent.getPublicInstance();
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Registers a container node into which React components will be rendered.
   * This also creates the "reactRoot" ID that will be assigned to the element
   * rendered within.
   *
   * @param {DOMElement} container DOM element to register as a container.
   * @return {string} The "reactRoot" ID of elements rendered within.
   */
  registerContainer: function (container) {
    var reactRootID = getReactRootID(container);
    if (reactRootID) {
      // If one exists, make sure it is a valid "reactRoot" ID.
      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
    }
    if (!reactRootID) {
      // No valid "reactRoot" ID found, create one.
      reactRootID = ReactInstanceHandles.createReactRootID();
    }
    containersByReactRootID[reactRootID] = container;
    return reactRootID;
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;

    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;

    var reactRootID = getReactRootID(container);
    var component = instancesByReactRootID[reactRootID];
    if (!component) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var containerID = internalGetID(container);
      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
      }

      return false;
    }
    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
    delete instancesByReactRootID[reactRootID];
    delete containersByReactRootID[reactRootID];
    if (false) {
      delete rootElementsByReactRootID[reactRootID];
    }
    return true;
  },

  /**
   * Finds the container DOM element that contains React component to which the
   * supplied DOM `id` belongs.
   *
   * @param {string} id The ID of an element rendered by a React component.
   * @return {?DOMElement} DOM element that contains the `id`.
   */
  findReactContainerForID: function (id) {
    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
    var container = containersByReactRootID[reactRootID];

    if (false) {
      var rootElement = rootElementsByReactRootID[reactRootID];
      if (rootElement && rootElement.parentNode !== container) {
        process.env.NODE_ENV !== 'production' ? warning(
        // Call internalGetID here because getID calls isValid which calls
        // findReactContainerForID (this function).
        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
        var containerChild = container.firstChild;
        if (containerChild && reactRootID === internalGetID(containerChild)) {
          // If the container has a new child with the same ID as the old
          // root element, then rootElementsByReactRootID[reactRootID] is
          // just stale and needs to be updated. The case that deserves a
          // warning is when the container is empty.
          rootElementsByReactRootID[reactRootID] = containerChild;
        } else {
          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
        }
      }
    }

    return container;
  },

  /**
   * Finds an element rendered by React with the supplied ID.
   *
   * @param {string} id ID of a DOM node in the React component.
   * @return {DOMElement} Root DOM node of the React component.
   */
  findReactNodeByID: function (id) {
    var reactRoot = ReactMount.findReactContainerForID(id);
    return ReactMount.findComponentRoot(reactRoot, id);
  },

  /**
   * Traverses up the ancestors of the supplied node to find a node that is a
   * DOM representation of a React component rendered by this copy of React.
   *
   * @param {*} node
   * @return {?DOMEventTarget}
   * @internal
   */
  getFirstReactDOM: function (node) {
    return findFirstReactDOMImpl(node);
  },

  /**
   * Finds a node with the supplied `targetID` inside of the supplied
   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
   * quickly.
   *
   * @param {DOMEventTarget} ancestorNode Search from this root.
   * @pararm {string} targetID ID of the DOM representation of the component.
   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
   * @internal
   */
  findComponentRoot: function (ancestorNode, targetID) {
    var firstChildren = findComponentRootReusableArray;
    var childIndex = 0;

    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;

    if (false) {
      // This will throw on the next line; give an early warning
      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
    }

    firstChildren[0] = deepestAncestor.firstChild;
    firstChildren.length = 1;

    while (childIndex < firstChildren.length) {
      var child = firstChildren[childIndex++];
      var targetChild;

      while (child) {
        var childID = ReactMount.getID(child);
        if (childID) {
          // Even if we find the node we're looking for, we finish looping
          // through its siblings to ensure they're cached so that we don't have
          // to revisit this node again. Otherwise, we make n^2 calls to getID
          // when visiting the many children of a single node in order.

          if (targetID === childID) {
            targetChild = child;
          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
            // If we find a child whose ID is an ancestor of the given ID,
            // then we can be sure that we only want to search the subtree
            // rooted at this child, so we can throw out the rest of the
            // search state.
            firstChildren.length = childIndex = 0;
            firstChildren.push(child.firstChild);
          }
        } else {
          // If this child had no ID, then there's a chance that it was
          // injected automatically by the browser, as when a `<table>`
          // element sprouts an extra `<tbody>` child as a side effect of
          // `.innerHTML` parsing. Optimistically continue down this
          // branch, but not before examining the other siblings.
          firstChildren.push(child.firstChild);
        }

        child = child.nextSibling;
      }

      if (targetChild) {
        // Emptying firstChildren/findComponentRootReusableArray is
        // not necessary for correctness, but it helps the GC reclaim
        // any nodes that were left at the end of the search.
        firstChildren.length = 0;

        return targetChild;
      }
    }

    firstChildren.length = 0;

     true ?  false ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
  },

  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      container.appendChild(markup);
    } else {
      setInnerHTML(container, markup);
    }
  },

  ownerDocumentContextKey: ownerDocumentContextKey,

  /**
   * React ID utilities.
   */

  getReactRootID: getReactRootID,

  getID: getID,

  setID: setID,

  getNode: getNode,

  getNodeFromInstance: getNodeFromInstance,

  isValid: isValid,

  purgeID: purgeID
};

ReactPerf.measureMethods(ReactMount, 'ReactMount', {
  _renderNewRootComponent: '_renderNewRootComponent',
  _mountImageIntoNode: '_mountImageIntoNode'
});

module.exports = ReactMount;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactElement
 */



var ReactCurrentOwner = __webpack_require__(99);

var assign = __webpack_require__(29);

// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var canDefineProperty = false;
if (false) {
  try {
    Object.defineProperty({}, 'x', {});
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

/**
 * Base constructor for all React elements. This is only used to make this
 * work with a dynamic instanceof check. Nothing should live on this prototype.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    Object.freeze(element.props);
    Object.freeze(element);
  }

  return element;
};

ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    ref = config.ref === undefined ? null : config.ref;
    key = config.key === undefined ? null : '' + config.key;
    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (typeof props[propName] === 'undefined') {
        props[propName] = defaultProps[propName];
      }
    }
  }

  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);

  if (false) {
    // If the key on the original is valid, then the clone is valid
    newElement._store.validated = oldElement._store.validated;
  }

  return newElement;
};

ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (config.ref !== undefined) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (config.key !== undefined) {
      key = '' + config.key;
    }
    // Remaining properties override existing props
    for (propName in config) {
      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*global __TARGET__*/var Config=void 0;if(true){Config={thisHost:'//d-app.s.coursio.com',discountHost:'//d-app.s.coursio.com',coursioWebsite:'//coursio.com',steelCompassRoot:'https://t-api.s.coursio.com/api/',// Changed for quiztaker QA testing.
zenCoderRoot:'https://app.zencoder.com/api/v2/',soundCloudRoot:'http://soundcloud.com/',facebookPixelId:'456322654879473',googleAnalyticsId:'UA-806038-20',googleClientId:'315357729136-oofnelcssgsgoohbnh8227esjhidfgvo.apps.googleusercontent.com',taxamoPublicKey:'public_test_9LuwgbbG3kF3C6SYVXAeBAz7x0JJ8CKAiBYyJ13cUxc',intercomAppId:null,hotjarId:553600};}else if(__TARGET__==='t'){Config={thisHost:'//t-app.s.coursio.com',discountHost:'//t-app.s.coursio.com',steelCompassRoot:'https://t-api.s.coursio.com/api/',soundCloudRoot:'http://soundcloud.com/',zenCoderRoot:'https://app.zencoder.com/api/v2/',coursioWebsite:'//coursio.com',facebookPixelId:'456322654879473',googleAnalyticsId:'UA-806038-20',googleClientId:'315357729136-oofnelcssgsgoohbnh8227esjhidfgvo.apps.googleusercontent.com',taxamoPublicKey:'public_test_9LuwgbbG3kF3C6SYVXAeBAz7x0JJ8CKAiBYyJ13cUxc',intercomAppId:'t73jspsv',hotjarId:560124};}else if(__TARGET__==='a'){Config={thisHost:'//a-app.s.coursio.com',discountHost:'//a-app.s.coursio.com',steelCompassRoot:'https://a-api.s.coursio.com/api/',soundCloudRoot:'http://soundcloud.com/',zenCoderRoot:'https://app.zencoder.com/api/v2/',coursioWebsite:'//coursio.com',facebookPixelId:'456322654879473',googleAnalyticsId:'UA-806038-20',googleClientId:'315357729136-oofnelcssgsgoohbnh8227esjhidfgvo.apps.googleusercontent.com',taxamoPublicKey:'public_OdI2FdbEYcL8v4TxGuoeIpQI3Z2qAzO5EwquVkaHrOk',intercomAppId:'chwsmww4',hotjarId:560125};}else if(__TARGET__==='p'){var _Config;Config=(_Config={thisHost:'//app.coursio.com',discountHost:'//app.coursio.com',steelCompassRoot:'https://api-3.coursio.com/api/',soundCloudRoot:'http://soundcloud.com/',zenCoderRoot:'https://app.zencoder.com/api/v2/',coursioWebsite:'//coursio.com',facebookPixelId:'456322654879473',googleAnalyticsId:'UA-806038-20',googleClientId:'315357729136-oofnelcssgsgoohbnh8227esjhidfgvo.apps.googleusercontent.com'},_defineProperty(_Config,'facebookPixelId','456322654879473'),_defineProperty(_Config,'taxamoPublicKey','public_OdI2FdbEYcL8v4TxGuoeIpQI3Z2qAzO5EwquVkaHrOk'),_defineProperty(_Config,'intercomAppId','chwsmww4'),_defineProperty(_Config,'hotjarId',553600),_defineProperty(_Config,'stripeKey','pk_live_cJIzjNJJArhwBq1nS1KURscP'),_Config);}else{Config={thisHost:'//localhost:3000',discountHost:'//localhost:3000',coursioWebsite:'//coursio.com',steelCompassRoot:'https://t-api.s.coursio.com/api/',zenCoderRoot:'https://app.zencoder.com/api/v2/',soundCloudRoot:'http://soundcloud.com/',facebookPixelId:'456322654879473',googleAnalyticsId:'UA-806038-20',googleClientId:'315357729136-oofnelcssgsgoohbnh8227esjhidfgvo.apps.googleusercontent.com',taxamoPublicKey:'public_test_9LuwgbbG3kF3C6SYVXAeBAz7x0JJ8CKAiBYyJ13cUxc',intercomAppId:null,hotjarId:560124,stripeKey:'pk_test_OApJrN5kCO4e2bx43zGNLDIG'};}/* harmony default export */ __webpack_exports__["a"] = (Config);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// To include this file in your project:
// let mui = require('mui');
// let Colors = mui.Styles.Colors;



module.exports = {

  red50: '#ffebee',
  red100: '#ffcdd2',
  red200: '#ef9a9a',
  red300: '#e57373',
  red400: '#ef5350',
  red500: '#f44336',
  red600: '#e53935',
  red700: '#d32f2f',
  red800: '#c62828',
  red900: '#b71c1c',
  redA100: '#ff8a80',
  redA200: '#ff5252',
  redA400: '#ff1744',
  redA700: '#d50000',

  pink50: '#fce4ec',
  pink100: '#f8bbd0',
  pink200: '#f48fb1',
  pink300: '#f06292',
  pink400: '#ec407a',
  pink500: '#e91e63',
  pink600: '#d81b60',
  pink700: '#c2185b',
  pink800: '#ad1457',
  pink900: '#880e4f',
  pinkA100: '#ff80ab',
  pinkA200: '#ff4081',
  pinkA400: '#f50057',
  pinkA700: '#c51162',

  purple50: '#f3e5f5',
  purple100: '#e1bee7',
  purple200: '#ce93d8',
  purple300: '#ba68c8',
  purple400: '#ab47bc',
  purple500: '#9c27b0',
  purple600: '#8e24aa',
  purple700: '#7b1fa2',
  purple800: '#6a1b9a',
  purple900: '#4a148c',
  purpleA100: '#ea80fc',
  purpleA200: '#e040fb',
  purpleA400: '#d500f9',
  purpleA700: '#aa00ff',

  deepPurple50: '#ede7f6',
  deepPurple100: '#d1c4e9',
  deepPurple200: '#b39ddb',
  deepPurple300: '#9575cd',
  deepPurple400: '#7e57c2',
  deepPurple500: '#673ab7',
  deepPurple600: '#5e35b1',
  deepPurple700: '#512da8',
  deepPurple800: '#4527a0',
  deepPurple900: '#311b92',
  deepPurpleA100: '#b388ff',
  deepPurpleA200: '#7c4dff',
  deepPurpleA400: '#651fff',
  deepPurpleA700: '#6200ea',

  indigo50: '#e8eaf6',
  indigo100: '#c5cae9',
  indigo200: '#9fa8da',
  indigo300: '#7986cb',
  indigo400: '#5c6bc0',
  indigo500: '#3f51b5',
  indigo600: '#3949ab',
  indigo700: '#303f9f',
  indigo800: '#283593',
  indigo900: '#1a237e',
  indigoA100: '#8c9eff',
  indigoA200: '#536dfe',
  indigoA400: '#3d5afe',
  indigoA700: '#304ffe',

  blue50: '#e3f2fd',
  blue100: '#bbdefb',
  blue200: '#90caf9',
  blue300: '#64b5f6',
  blue400: '#42a5f5',
  blue500: '#2196f3',
  blue600: '#1e88e5',
  blue700: '#1976d2',
  blue800: '#1565c0',
  blue900: '#0d47a1',
  blueA100: '#82b1ff',
  blueA200: '#448aff',
  blueA400: '#2979ff',
  blueA700: '#2962ff',

  lightBlue50: '#e1f5fe',
  lightBlue100: '#b3e5fc',
  lightBlue200: '#81d4fa',
  lightBlue300: '#4fc3f7',
  lightBlue400: '#29b6f6',
  lightBlue500: '#03a9f4',
  lightBlue600: '#039be5',
  lightBlue700: '#0288d1',
  lightBlue800: '#0277bd',
  lightBlue900: '#01579b',
  lightBlueA100: '#80d8ff',
  lightBlueA200: '#40c4ff',
  lightBlueA400: '#00b0ff',
  lightBlueA700: '#0091ea',

  cyan50: '#e0f7fa',
  cyan100: '#b2ebf2',
  cyan200: '#80deea',
  cyan300: '#4dd0e1',
  cyan400: '#26c6da',
  cyan500: '#00bcd4',
  cyan600: '#00acc1',
  cyan700: '#0097a7',
  cyan800: '#00838f',
  cyan900: '#006064',
  cyanA100: '#84ffff',
  cyanA200: '#18ffff',
  cyanA400: '#00e5ff',
  cyanA700: '#00b8d4',

  teal50: '#e0f2f1',
  teal100: '#b2dfdb',
  teal200: '#80cbc4',
  teal300: '#4db6ac',
  teal400: '#26a69a',
  teal500: '#009688',
  teal600: '#00897b',
  teal700: '#00796b',
  teal800: '#00695c',
  teal900: '#004d40',
  tealA100: '#a7ffeb',
  tealA200: '#64ffda',
  tealA400: '#1de9b6',
  tealA700: '#00bfa5',

  green50: '#e8f5e9',
  green100: '#c8e6c9',
  green200: '#a5d6a7',
  green300: '#81c784',
  green400: '#66bb6a',
  green500: '#4caf50',
  green600: '#43a047',
  green700: '#388e3c',
  green800: '#2e7d32',
  green900: '#1b5e20',
  greenA100: '#b9f6ca',
  greenA200: '#69f0ae',
  greenA400: '#00e676',
  greenA700: '#00c853',

  lightGreen50: '#f1f8e9',
  lightGreen100: '#dcedc8',
  lightGreen200: '#c5e1a5',
  lightGreen300: '#aed581',
  lightGreen400: '#9ccc65',
  lightGreen500: '#8bc34a',
  lightGreen600: '#7cb342',
  lightGreen700: '#689f38',
  lightGreen800: '#558b2f',
  lightGreen900: '#33691e',
  lightGreenA100: '#ccff90',
  lightGreenA200: '#b2ff59',
  lightGreenA400: '#76ff03',
  lightGreenA700: '#64dd17',

  lime50: '#f9fbe7',
  lime100: '#f0f4c3',
  lime200: '#e6ee9c',
  lime300: '#dce775',
  lime400: '#d4e157',
  lime500: '#cddc39',
  lime600: '#c0ca33',
  lime700: '#afb42b',
  lime800: '#9e9d24',
  lime900: '#827717',
  limeA100: '#f4ff81',
  limeA200: '#eeff41',
  limeA400: '#c6ff00',
  limeA700: '#aeea00',

  yellow50: '#fffde7',
  yellow100: '#fff9c4',
  yellow200: '#fff59d',
  yellow300: '#fff176',
  yellow400: '#ffee58',
  yellow500: '#ffeb3b',
  yellow600: '#fdd835',
  yellow700: '#fbc02d',
  yellow800: '#f9a825',
  yellow900: '#f57f17',
  yellowA100: '#ffff8d',
  yellowA200: '#ffff00',
  yellowA400: '#ffea00',
  yellowA700: '#ffd600',

  amber50: '#fff8e1',
  amber100: '#ffecb3',
  amber200: '#ffe082',
  amber300: '#ffd54f',
  amber400: '#ffca28',
  amber500: '#ffc107',
  amber600: '#ffb300',
  amber700: '#ffa000',
  amber800: '#ff8f00',
  amber900: '#ff6f00',
  amberA100: '#ffe57f',
  amberA200: '#ffd740',
  amberA400: '#ffc400',
  amberA700: '#ffab00',

  orange50: '#fff3e0',
  orange100: '#ffe0b2',
  orange200: '#ffcc80',
  orange300: '#ffb74d',
  orange400: '#ffa726',
  orange500: '#ff9800',
  orange600: '#fb8c00',
  orange700: '#f57c00',
  orange800: '#ef6c00',
  orange900: '#e65100',
  orangeA100: '#ffd180',
  orangeA200: '#ffab40',
  orangeA400: '#ff9100',
  orangeA700: '#ff6d00',

  deepOrange50: '#fbe9e7',
  deepOrange100: '#ffccbc',
  deepOrange200: '#ffab91',
  deepOrange300: '#ff8a65',
  deepOrange400: '#ff7043',
  deepOrange500: '#ff5722',
  deepOrange600: '#f4511e',
  deepOrange700: '#e64a19',
  deepOrange800: '#d84315',
  deepOrange900: '#bf360c',
  deepOrangeA100: '#ff9e80',
  deepOrangeA200: '#ff6e40',
  deepOrangeA400: '#ff3d00',
  deepOrangeA700: '#dd2c00',

  brown50: '#efebe9',
  brown100: '#d7ccc8',
  brown200: '#bcaaa4',
  brown300: '#a1887f',
  brown400: '#8d6e63',
  brown500: '#795548',
  brown600: '#6d4c41',
  brown700: '#5d4037',
  brown800: '#4e342e',
  brown900: '#3e2723',

  blueGrey50: '#eceff1',
  blueGrey100: '#cfd8dc',
  blueGrey200: '#b0bec5',
  blueGrey300: '#90a4ae',
  blueGrey400: '#78909c',
  blueGrey500: '#607d8b',
  blueGrey600: '#546e7a',
  blueGrey700: '#455a64',
  blueGrey800: '#37474f',
  blueGrey900: '#263238',

  grey50: '#fafafa',
  grey100: '#f5f5f5',
  grey200: '#eeeeee',
  grey300: '#e0e0e0',
  grey400: '#bdbdbd',
  grey500: '#9e9e9e',
  grey600: '#757575',
  grey700: '#616161',
  grey800: '#424242',
  grey900: '#212121',

  black: '#000000',
  white: '#ffffff',

  transparent: 'rgba(0, 0, 0, 0)',
  fullBlack: 'rgba(0, 0, 0, 1)',
  darkBlack: 'rgba(0, 0, 0, 0.87)',
  lightBlack: 'rgba(0, 0, 0, 0.54)',
  minBlack: 'rgba(0, 0, 0, 0.26)',
  faintBlack: 'rgba(0, 0, 0, 0.12)',
  fullWhite: 'rgba(255, 255, 255, 1)',
  darkWhite: 'rgba(255, 255, 255, 0.87)',
  lightWhite: 'rgba(255, 255, 255, 0.54)'

};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var StylePropable = __webpack_require__(10);
var PropTypes = __webpack_require__(187);
var Transitions = __webpack_require__(21);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Paper = React.createClass({
  displayName: 'Paper',

  mixins: [PureRenderMixin, StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  propTypes: {
    circle: React.PropTypes.bool,
    rounded: React.PropTypes.bool,
    transitionEnabled: React.PropTypes.bool,
    zDepth: PropTypes.zDepth
  },

  getDefaultProps: function getDefaultProps() {
    return {
      circle: false,
      rounded: true,
      transitionEnabled: true,
      zDepth: 1
    };
  },

  render: function render() {
    var _props = this.props;
    var children = _props.children;
    var circle = _props.circle;
    var rounded = _props.rounded;
    var style = _props.style;
    var transitionEnabled = _props.transitionEnabled;
    var zDepth = _props.zDepth;

    var other = _objectWithoutProperties(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);

    var styles = {
      backgroundColor: this.state.muiTheme.paper.backgroundColor,
      transition: transitionEnabled && Transitions.easeOut(),
      boxSizing: 'border-box',
      fontFamily: this.state.muiTheme.rawTheme.fontFamily,
      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
      boxShadow: this._getZDepthShadows(zDepth),
      borderRadius: circle ? '50%' : rounded ? '2px' : '0px'
    };

    return React.createElement(
      'div',
      _extends({}, other, { style: this.prepareStyles(styles, style) }),
      children
    );
  },

  _getZDepthShadows: function _getZDepthShadows(zDepth) {
    var shadows = [null, '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)', '0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23)', '0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23)', '0 14px 45px rgba(0, 0, 0, 0.25), 0 10px 18px rgba(0, 0, 0, 0.22)', '0 19px 60px rgba(0, 0, 0, 0.30), 0 15px 20px rgba(0, 0, 0, 0.22)'];

    return shadows[zDepth];
  }

});

module.exports = Paper;

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Portal__ = __webpack_require__(113);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DialogPortal=function(_Component){_inherits(DialogPortal,_Component);function DialogPortal(){_classCallCheck(this,DialogPortal);return _possibleConstructorReturn(this,(DialogPortal.__proto__||Object.getPrototypeOf(DialogPortal)).apply(this,arguments));}_createClass(DialogPortal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Portal__["a" /* default */],{style:{zIndex:100,position:'relative'}},this.props.children);}}]);return DialogPortal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DialogPortal.displayName='DialogPortal';/* harmony default export */ __webpack_exports__["a"] = (DialogPortal);

/***/ }),
/* 56 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(40);
var createDesc = __webpack_require__(123);
module.exports = __webpack_require__(39) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(24);
var hide = __webpack_require__(59);
var has = __webpack_require__(58);
var SRC = __webpack_require__(124)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(86).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var fails = __webpack_require__(28);
var defined = __webpack_require__(88);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isBrowser = __webpack_require__(516);

var Modernizr = isBrowser ? __webpack_require__(517) : undefined;

//Keep track of already prefixed keys so we can skip Modernizr prefixing
var prefixedKeys = {};

module.exports = {

  all: function all(styles) {
    var prefixedStyle = {};
    for (var key in styles) {
      prefixedStyle[this.single(key)] = styles[key];
    }
    return prefixedStyle;
  },

  set: function set(style, key, value) {
    style[this.single(key)] = value;
  },

  single: function single(key) {

    //If a browser doesn't exist, we can't prefix with Modernizr so
    //just return the key
    if (!isBrowser) return key;

    //Check if we've prefixed this key before, just return it
    if (prefixedKeys.hasOwnProperty(key)) return prefixedKeys[key];

    //Key hasn't been prefixed yet, prefix with Modernizr
    var prefKey = Modernizr.prefixed(key);

    // Windows 7 Firefox has an issue with the implementation of Modernizr.prefixed
    // and is capturing 'false' as the CSS property name instead of the non-prefixed version.
    if (prefKey === false) return key;

    //Save the key off for the future and return the prefixed key
    prefixedKeys[key] = prefKey;
    return prefKey;
  },

  singleHyphened: function singleHyphened(key) {
    var str = this.single(key);

    return !str ? key : str.replace(/([A-Z])/g, function (str, m1) {
      return '-' + m1.toLowerCase();
    }).replace(/^ms-/, '-ms-');
  }

};

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cio_lib_Assets_Embed__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cio_lib_Assets_Embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cio_lib_Assets_Embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AudioHigher__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioLower__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AudioMid__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AudioMute__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Cancel__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CheckCheckBox__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Check__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Close__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Communication__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Delete__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Download__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Duplicate__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Edit__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Export__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Filter__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Fullsize__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Help__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Home__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Layout__ = __webpack_require__(1914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Library__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ListView__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Lock__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Menu__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ModuleAudio__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ModuleDiscussion__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ModuleDownload__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ModuleImage__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ModuleInteraction__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ModuleSlideshow__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ModuleTask__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ModuleText__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ModuleVideo__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ModuleWebinar__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ModuleQuiziframe__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__MoveVertical__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Note__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Pause__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Play__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Plus__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Preview__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Settings__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Sort__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Stats__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Students__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__TextB__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__TextH1__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__TextH2__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__TextH3__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__TextI__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__TextP__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Tool__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ChapterDone__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__SizeSelect__ = __webpack_require__(1948);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ModuleEmbed", function() { return __WEBPACK_IMPORTED_MODULE_0_cio_lib_Assets_Embed___default.a; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AudioHigher", function() { return __WEBPACK_IMPORTED_MODULE_1__AudioHigher__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AudioLower", function() { return __WEBPACK_IMPORTED_MODULE_2__AudioLower__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AudioMid", function() { return __WEBPACK_IMPORTED_MODULE_3__AudioMid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AudioMute", function() { return __WEBPACK_IMPORTED_MODULE_4__AudioMute__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Cancel", function() { return __WEBPACK_IMPORTED_MODULE_5__Cancel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CheckCheckBox", function() { return __WEBPACK_IMPORTED_MODULE_6__CheckCheckBox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Check", function() { return __WEBPACK_IMPORTED_MODULE_7__Check__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Close", function() { return __WEBPACK_IMPORTED_MODULE_8__Close__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Communication", function() { return __WEBPACK_IMPORTED_MODULE_9__Communication__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Delete", function() { return __WEBPACK_IMPORTED_MODULE_10__Delete__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Download", function() { return __WEBPACK_IMPORTED_MODULE_11__Download__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Duplicate", function() { return __WEBPACK_IMPORTED_MODULE_12__Duplicate__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Edit", function() { return __WEBPACK_IMPORTED_MODULE_13__Edit__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Export", function() { return __WEBPACK_IMPORTED_MODULE_14__Export__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Filter", function() { return __WEBPACK_IMPORTED_MODULE_15__Filter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Fullsize", function() { return __WEBPACK_IMPORTED_MODULE_16__Fullsize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Help", function() { return __WEBPACK_IMPORTED_MODULE_17__Help__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Home", function() { return __WEBPACK_IMPORTED_MODULE_18__Home__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Layout", function() { return __WEBPACK_IMPORTED_MODULE_19__Layout__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Library", function() { return __WEBPACK_IMPORTED_MODULE_20__Library__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListView", function() { return __WEBPACK_IMPORTED_MODULE_21__ListView__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Lock", function() { return __WEBPACK_IMPORTED_MODULE_22__Lock__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return __WEBPACK_IMPORTED_MODULE_23__Menu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleAudio", function() { return __WEBPACK_IMPORTED_MODULE_24__ModuleAudio__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleDiscussion", function() { return __WEBPACK_IMPORTED_MODULE_25__ModuleDiscussion__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleDownload", function() { return __WEBPACK_IMPORTED_MODULE_26__ModuleDownload__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleImage", function() { return __WEBPACK_IMPORTED_MODULE_27__ModuleImage__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleInteraction", function() { return __WEBPACK_IMPORTED_MODULE_28__ModuleInteraction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleSlideshow", function() { return __WEBPACK_IMPORTED_MODULE_29__ModuleSlideshow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleTask", function() { return __WEBPACK_IMPORTED_MODULE_30__ModuleTask__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleText", function() { return __WEBPACK_IMPORTED_MODULE_31__ModuleText__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleVideo", function() { return __WEBPACK_IMPORTED_MODULE_32__ModuleVideo__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleWebinar", function() { return __WEBPACK_IMPORTED_MODULE_33__ModuleWebinar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleQuiziframe", function() { return __WEBPACK_IMPORTED_MODULE_34__ModuleQuiziframe__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MoveVertical", function() { return __WEBPACK_IMPORTED_MODULE_35__MoveVertical__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Note", function() { return __WEBPACK_IMPORTED_MODULE_36__Note__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pause", function() { return __WEBPACK_IMPORTED_MODULE_37__Pause__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Play", function() { return __WEBPACK_IMPORTED_MODULE_38__Play__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Plus", function() { return __WEBPACK_IMPORTED_MODULE_39__Plus__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Preview", function() { return __WEBPACK_IMPORTED_MODULE_40__Preview__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Settings", function() { return __WEBPACK_IMPORTED_MODULE_41__Settings__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sort", function() { return __WEBPACK_IMPORTED_MODULE_42__Sort__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Stats", function() { return __WEBPACK_IMPORTED_MODULE_43__Stats__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Students", function() { return __WEBPACK_IMPORTED_MODULE_44__Students__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextB", function() { return __WEBPACK_IMPORTED_MODULE_45__TextB__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextH1", function() { return __WEBPACK_IMPORTED_MODULE_46__TextH1__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextH2", function() { return __WEBPACK_IMPORTED_MODULE_47__TextH2__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextH3", function() { return __WEBPACK_IMPORTED_MODULE_48__TextH3__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextI", function() { return __WEBPACK_IMPORTED_MODULE_49__TextI__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextP", function() { return __WEBPACK_IMPORTED_MODULE_50__TextP__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tool", function() { return __WEBPACK_IMPORTED_MODULE_51__Tool__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ChapterDone", function() { return __WEBPACK_IMPORTED_MODULE_52__ChapterDone__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SizeSelect", function() { return __WEBPACK_IMPORTED_MODULE_53__SizeSelect__["a"]; });


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func) {
  var wait = arguments.length <= 1 || arguments[1] === undefined ? 100 : arguments[1];
  var immediate = arguments[2];

  var timeout = void 0;

  function debounced() {
    var context = this;
    var args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };

  debounced.clear = function () {
    if (timeout) {
      clearTimeout(timeout);
    }
  };

  return debounced;
};
module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ToolbarIconButton=function(_Component){_inherits(ToolbarIconButton,_Component);function ToolbarIconButton(){_classCallCheck(this,ToolbarIconButton);return _possibleConstructorReturn(this,(ToolbarIconButton.__proto__||Object.getPrototypeOf(ToolbarIconButton)).apply(this,arguments));}_createClass(ToolbarIconButton,[{key:'render',value:function render(){var _props=this.props,svgIcon=_props.svgIcon,other=_objectWithoutProperties(_props,['svgIcon']),theme=this.context.muiTheme.toolbar,icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(svgIcon,{color:this.context.muiTheme.rawTheme.palette.alternateTextColor,hoverColor:theme.menuHoverColor}),height=theme.height,width=32,paddingVer=(height-24)/2,paddingHor=(width-24)/2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],Object.assign({style:{padding:paddingVer+'px '+paddingHor+'px ',width:width,height:height}},other),icon,this.props.children);}}]);return ToolbarIconButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ToolbarIconButton.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (ToolbarIconButton);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Portal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lib_CSSPropertyOperations__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lib_CSSPropertyOperations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_lib_CSSPropertyOperations__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Units=__WEBPACK_IMPORTED_MODULE_4_Css__["default"].Units;var css={root:'_bR',overlay:'_bS',hasToolbar:'_bT',container:'_bU',padded:'_bV',dialogWrapper:'_bW',toolbar:'_bX',title:'_bY',closeButton:'_bZ',dialog:'_b0',maxi:'_b1',mini:'_b2'};var ESC=27;var isDescendant=function isDescendant(parent,child){var node=child.parentNode;while(node!==null){if(node===parent){return true;}node=node.parentNode;}return false;};var FullScreenDialog=function(_Component){_inherits(FullScreenDialog,_Component);function FullScreenDialog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FullScreenDialog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FullScreenDialog.__proto__||Object.getPrototypeOf(FullScreenDialog)).call.apply(_ref,[this].concat(args))),_this),_this.close=function(){var onDismiss=_this.props.onDismiss;__WEBPACK_IMPORTED_MODULE_6_react_lib_CSSPropertyOperations___default.a.setValueForStyles(document.body,{overflow:_this._overflow});onDismiss&&onDismiss();},_this.open=function(){_this._overflow=document.body.style.overflow;__WEBPACK_IMPORTED_MODULE_6_react_lib_CSSPropertyOperations___default.a.setValueForStyles(document.body,{overflow:'hidden'});},_this.handleKey=function(event){var keyCode=event.keyCode;if(keyCode===ESC){_this.requestClose();}},_this.handleTouchStart=function(event){var touchObj=event.changedTouches[0];_this._pageX=touchObj.pageX;},_this.handleTouchEnd=function(event){var touchObj=event.changedTouches[0];if(_this._pageX===touchObj.pageX){_this.handleClick(event);}},_this.handleClick=function(event){if(!isDescendant(_this.dialog,event.target)){_this.requestClose();}},_this.requestClose=function(event){var onRequestClose=_this.props.onRequestClose;event&&event.preventDefault();event&&event.stopPropagation();onRequestClose&&onRequestClose();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FullScreenDialog,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,overlay=_props.overlay,open=_props.open;overlay&&document.addEventListener('keyup',this.handleKey);document.addEventListener('mousedown',this.handleClick);document.addEventListener('touchstart',this.handleTouchStart);// Needs to defer touchend event listener, so we do not catch the end of the event that triggered the dialog appearance
// Otherwise, it would close the dialog as soon as it opens
setTimeout(function(){document.addEventListener('touchend',this.handleTouchEnd);},0);if(open){this.open();}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.open&&!nextProps.open){this.close();}else if(!this.props.open&&nextProps.open){this.open();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var overlay=this.props.overlay;overlay&&document.removeEventListener('keyup',this.handleKey);document.removeEventListener('mousedown',this.handleClick);document.removeEventListener('touchstart',this.handleTouchStart);document.removeEventListener('touchend',this.handleTouchEnd);this.close();// Solves #1302 (removes 'overflow: hidden' properly)
}},{key:'render',value:function render(){var _classNames2,_this2=this;var _props2=this.props,mini=_props2.mini,maxi=_props2.maxi,onRequestClose=_props2.onRequestClose,padded=_props2.padded,overlay=_props2.overlay,children=_props2.children,title=_props2.title,open=_props2.open,toolbar=_props2.toolbar;if(!open){return null;}var classes=__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.root,_defineProperty({},css.overlay,overlay));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Portal__["a" /* default */],{dialog:true,className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.dialog,(_classNames2={},_defineProperty(_classNames2,css.mini,mini),_defineProperty(_classNames2,css.maxi,maxi),_classNames2))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.dialogWrapper,ref:function ref(dialog){return _this2.dialog=dialog;}},toolbar&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.title},title),onRequestClose&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.closeButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{onTouchTap:this.requestClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationClose"],null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.container,padded&&css.padded)},children))));}}]);return FullScreenDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FullScreenDialog.propTypes={onRequestClose:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,open:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,overlay:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onDismiss:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,toolbar:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,mini:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,maxi:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,padded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};FullScreenDialog.contextTypes={media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};FullScreenDialog.defaultProps={toolbar:true,closeButton:true,overlay:true};/* harmony default export */ __webpack_exports__["a"] = (FullScreenDialog);

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(180);
var defined = __webpack_require__(88);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(181);
var createDesc = __webpack_require__(123);
var toIObject = __webpack_require__(67);
var toPrimitive = __webpack_require__(87);
var has = __webpack_require__(58);
var IE8_DOM_DEFINE = __webpack_require__(467);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(39) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(58);
var toObject = __webpack_require__(44);
var IE_PROTO = __webpack_require__(308)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var colors=['#F44336','#E91E63','#9C27B0','#673AB7','#3F51B5','#2196F3','#03A9F4','#00BCD4','#009688','#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#FF9800','#FF5722','#795548','#9E9E9E','#607D8B'];var order=[1,2,3,4];var CoursioLogo=function(_Component){_inherits(CoursioLogo,_Component);function CoursioLogo(){_classCallCheck(this,CoursioLogo);var _this=_possibleConstructorReturn(this,(CoursioLogo.__proto__||Object.getPrototypeOf(CoursioLogo)).apply(this,arguments));_this.state={fill:_this.props.initialFill,sizeDelta:0};_this.currentOrder=[];return _this;}_createClass(CoursioLogo,[{key:'add',value:function add(move){var _this2=this;this.currentOrder.push(move);if(this.currentOrder.length>4){this.currentOrder.shift();}var correct=true;if(this.currentOrder.length===4){this.currentOrder.forEach(function(move,index){if(order[index]!==move){correct=false;}});}else{correct=false;}if(correct&&!this._interval){this._interval=setInterval(function(){var fill=colors[Math.floor(Math.random()*colors.length)];var sizeDelta=1-_this2.state.sizeDelta;_this2.setState({fill:fill,sizeDelta:sizeDelta});},1000);}}},{key:'render',value:function render(){var _props=this.props,size=_props.size,circleRadius=_props.circleRadius,initialFill=_props.initialFill,width=_props.width,className=_props.className,props=_objectWithoutProperties(_props,['size','circleRadius','initialFill','width','className']),logoSize=size-circleRadius*2,_state=this.state,fill=_state.fill,sizeDelta=_state.sizeDelta,x1=0,y1=0,x2=logoSize/2,y2=logoSize/4,x3=logoSize,y3=logoSize/2,x4=logoSize/2,y4=logoSize*0.75,x5=0,y5=logoSize;width=width||logoSize;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({className:className,viewBox:'0 0 '+size+' '+size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',width:width,height:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{style:{transition:'fill 1s ease'},fill:fill},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{rect:true,x:x1,y:y1,width:circleRadius*2,height:logoSize/2+circleRadius*2,rx:circleRadius,ry:circleRadius,onMouseLeave:this.add.bind(this,0)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{style:{transition:'all 1s ease'},r:circleRadius-sizeDelta*5,cx:circleRadius+x2,cy:circleRadius+y2,onMouseLeave:this.add.bind(this,1)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{style:{transition:'all 1s ease'},r:circleRadius-sizeDelta*5,cx:circleRadius+x3,cy:circleRadius+y3,onMouseLeave:this.add.bind(this,2)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{style:{transition:'all 1s ease'},r:circleRadius-sizeDelta*5,cx:circleRadius+x4,cy:circleRadius+y4,onMouseLeave:this.add.bind(this,3)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{style:{transition:'all 1s ease'},r:circleRadius-sizeDelta*5,cx:circleRadius+x5,cy:circleRadius+y5,onMouseLeave:this.add.bind(this,4)})));}}]);return CoursioLogo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CoursioLogo.propTypes={size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,circleRadius:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,initialFill:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};CoursioLogo.defaultProps={initialFill:'#FFFFFF',size:100,circleRadius:10};/* harmony default export */ __webpack_exports__["a"] = (CoursioLogo);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(2134);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPerf
 * @typechecks static-only
 */



/**
 * ReactPerf is a general AOP system designed to measure performance. This
 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
 */
var ReactPerf = {
  /**
   * Boolean to enable/disable measurement. Set to false by default to prevent
   * accidental logging and perf loss.
   */
  enableMeasure: false,

  /**
   * Holds onto the measure function in use. By default, don't measure
   * anything, but we'll override this if we inject a measure function.
   */
  storedMeasure: _noMeasure,

  /**
   * @param {object} object
   * @param {string} objectName
   * @param {object<string>} methodNames
   */
  measureMethods: function (object, objectName, methodNames) {
    if (false) {
      for (var key in methodNames) {
        if (!methodNames.hasOwnProperty(key)) {
          continue;
        }
        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
      }
    }
  },

  /**
   * Use this to wrap methods you want to measure. Zero overhead in production.
   *
   * @param {string} objName
   * @param {string} fnName
   * @param {function} func
   * @return {function}
   */
  measure: function (objName, fnName, func) {
    if (false) {
      var measuredFunc = null;
      var wrapper = function () {
        if (ReactPerf.enableMeasure) {
          if (!measuredFunc) {
            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
          }
          return measuredFunc.apply(this, arguments);
        }
        return func.apply(this, arguments);
      };
      wrapper.displayName = objName + '_' + fnName;
      return wrapper;
    }
    return func;
  },

  injection: {
    /**
     * @param {function} measure
     */
    injectMeasure: function (measure) {
      ReactPerf.storedMeasure = measure;
    }
  }
};

/**
 * Simply passes through the measured function, without measuring it.
 *
 * @param {string} objName
 * @param {string} fnName
 * @param {function} func
 * @return {function}
 */
function _noMeasure(objName, fnName, func) {
  return func;
}

module.exports = ReactPerf;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactUpdates
 */



var CallbackQueue = __webpack_require__(287);
var PooledClass = __webpack_require__(107);
var ReactPerf = __webpack_require__(72);
var ReactReconciler = __webpack_require__(120);
var Transaction = __webpack_require__(215);

var assign = __webpack_require__(29);
var invariant = __webpack_require__(20);

var dirtyComponents = [];
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
}

assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};
flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setProps, setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSPropertyOperations
 * @typechecks static-only
 */



var CSSProperty = __webpack_require__(440);
var ExecutionEnvironment = __webpack_require__(45);
var ReactPerf = __webpack_require__(72);

var camelizeStyleName = __webpack_require__(697);
var dangerousStyleValue = __webpack_require__(699);
var hyphenateStyleName = __webpack_require__(700);
var memoizeStringOnly = __webpack_require__(702);
var warning = __webpack_require__(33);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};

  var warnHyphenatedStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
  };

  var warnBadVendoredStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
  };

  var warnStyleValueWithSemicolon = function (name, value) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
  };

  /**
   * @param {string} name
   * @param {*} value
   */
  var warnValidStyle = function (name, value) {
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {

  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @return {?string}
   */
  createMarkupForStyles: function (styles) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = styles[styleName];
      if (false) {
        warnValidStyle(styleName, styleValue);
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   */
  setValueForStyles: function (node, styles) {
    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      if (false) {
        warnValidStyle(styleName, styles[styleName]);
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
      if (styleName === 'float') {
        styleName = styleFloatAccessor;
      }
      if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }

};

ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
  setValueForStyles: 'setValueForStyles'
});

module.exports = CSSPropertyOperations;

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__ = __webpack_require__(740);
/* unused harmony reexport addBreadcrumb */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["a"]; });
/* unused harmony reexport captureEvent */
/* unused harmony reexport captureMessage */
/* unused harmony reexport configureScope */
/* unused harmony reexport setContext */
/* unused harmony reexport setExtra */
/* unused harmony reexport setExtras */
/* unused harmony reexport setTag */
/* unused harmony reexport setTags */
/* unused harmony reexport setUser */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b"]; });
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport Hub */
/* unused harmony reexport Scope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(748);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__api__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseclient__ = __webpack_require__(749);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__baseclient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__basebackend__ = __webpack_require__(751);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__basebackend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sdk__ = __webpack_require__(752);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__transports_noop__ = __webpack_require__(460);
/* unused harmony reexport NoopTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__integrations__ = __webpack_require__(753);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__integrations__; });









//# sourceMappingURL=index.js.map

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(47);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(28);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  DOWN: 40,
  ESC: 27,
  ENTER: 13,
  LEFT: 37,
  RIGHT: 39,
  SPACE: 32,
  TAB: 9,
  UP: 38
};

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toolbar__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToolbarGroup__ = __webpack_require__(1950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToolbarButton__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TabButton__ = __webpack_require__(1956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolbarTitle__ = __webpack_require__(1957);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Toolbar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__ToolbarGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__ToolbarButton__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__TabButton__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__ToolbarTitle__["a"]; });


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fetchKeys = __webpack_require__(1952);

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if (ret !== void 0) {
        return !!ret;
    }

    if (objA === objB) {
        return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }

    var keysA = fetchKeys(objA);
    var keysB = fetchKeys(objB);

    var len = keysA.length;
    if (len !== keysB.length) {
        return false;
    }

    compareContext = compareContext || null;

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < len; i++) {
        var key = keysA[i];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];

        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (_ret === false || _ret === void 0 && valueA !== valueB) {
            return false;
        }
    }

    return true;
};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getVisibleStoreItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getStoreItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilteredStoreItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSearchedStoreItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isGift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSelectedModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSelectedSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var getItems=function getItems(state){return state.items;};var getList=function getList(state){if(state.followOrder){return state.list;}return state.list.sort(function(a,b){var first=state.items[a.type][a.id];var second=state.items[b.type][b.id];if(first.public===second.public){return first.name<second.name?-1:first.name>second.name?1:0;}if(first.public&&!second.public){return-1;}if(!first.public&&second.public){return 1;}return 0;});};var getFilter=function getFilter(state){return state.filter;};var makeGetVisibleStoreItems=function makeGetVisibleStoreItems(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getItems,getList,getFilter,function(items,list,filter){var filtered=void 0;filtered=list.filter(function(storeItem){var item=items[storeItem.type][storeItem.id];return!filter.categoryId||item.categories&&item.categories[filter.categoryId];});if(filter.tags){filtered=filtered.filter(function(storeItem){var item=items[storeItem.type][storeItem.id];return Object.keys(filter.tags).every(function(tag){return!filter.tags[tag]||item.tagsMap[tag];});});}// if (filter.searchText) {
//   const regexp = new RegExp(filter.searchText, 'i');
//   filtered = filtered.filter(storeItem => {
//     const item = items[storeItem.type][storeItem.id];
//     return (item.name + item.description).search(regexp) > -1;
//   });
// }
return filtered.map(function(_ref){var type=_ref.type,id=_ref.id;return items[type][id];});});};var getVisibleStoreItems=makeGetVisibleStoreItems();var makeGetStoreItems=function makeGetStoreItems(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getItems,getList,function(items,list){return list.map(function(_ref2){var type=_ref2.type,id=_ref2.id;return items[type][id];});});};var getStoreItems=makeGetStoreItems();var makeGetFilteredStoreItems=function makeGetFilteredStoreItems(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(list){return list;},function(list,filter){return filter;},function(list,filter){var filtered=void 0;filtered=list.filter(function(item){return!filter.categoryId||item.categories&&item.categories[filter.categoryId];});if(filter.tags){filtered=filtered.filter(function(item){return Object.keys(filter.tags).every(function(tag){return!filter.tags[tag]||item.tagsMap[tag];});});}// if (filter.searchText) {
//   const regexp = new RegExp(filter.searchText, 'i');
//   filtered = filtered.filter(item => {
//     return (item.name + item.description).search(regexp) > -1;
//   });
// }
return filtered;});};var getFilteredStoreItems=makeGetFilteredStoreItems();var makeGetSearchedStoreItems=function makeGetSearchedStoreItems(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(list){return list;},function(list,filter){return filter;},function(list,filter){var filtered=void 0;filtered=list.filter(function(item){return!filter.categoryId||item.categories&&item.categories[filter.categoryId];});if(filter.tags){filtered=filtered.filter(function(item){return Object.keys(filter.tags).every(function(tag){return!filter.tags[tag]||item.tagsMap[tag];});});}if(filter.searchText){var regexp=new RegExp(filter.searchText,'i');filtered=filtered.filter(function(item){return(item.name+item.description).search(regexp)>-1;});}return filtered;});};var getSearchedStoreItems=makeGetSearchedStoreItems();var makeGetSelectedItem=function makeGetSelectedItem(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.selected;},getItems,function(_ref3,items){var type=_ref3.type,id=_ref3.id;return id&&items[type][id]||null;});};var getSelectedItem=makeGetSelectedItem();var makeGetCart=function makeGetCart(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getItems,function(state){return state.cart;},function(items,cart){return cart.map(function(_ref4){var type=_ref4.type,id=_ref4.id;if(items[type]&&items[type][id]){return items[type][id];}return null;}).filter(function(item){return item!==null;});});};var getCart=makeGetCart();var isGift=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.cart;},function(cart){return cart.some(function(_ref5){var gift=_ref5.gift;return gift;});});var getSection=function getSection(sections,modules,sectionId,marked){var section=sections[sectionId];return Object.assign({},section,{marked:marked,modules:section.modules.filter(function(moduleId){return modules[moduleId];}).map(function(moduleId){return modules[moduleId];})});};var makeGetLayout=function makeGetLayout(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){var mode=state.mode;var layout=mode==='editor'?state.layoutDraft:state.layout;var entities=layout.entities,other=_objectWithoutProperties(layout,['entities']);return Object.assign({},other);},function(state){var mode=state.mode;var layout=mode==='editor'?state.layoutDraft:state.layout;return layout.entities.sections;},function(state){var mode=state.mode;var layout=mode==='editor'?state.layoutDraft:state.layout;return layout.entities.modules;},function(state){var mode=state.mode;var layout=mode==='editor'?state.layoutDraft:state.layout;return layout.overSection;},function(layout,sections,modules,overSection){return Object.assign({},layout,{sections:layout.sections.map(function(sectionId){return getSection(sections,modules,sectionId,overSection&&overSection.id===sectionId?overSection.position:null);})});});};var getLayout=makeGetLayout();var makeGetSelectedModule=function makeGetSelectedModule(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.mode;},function(state){return state.layoutDraft&&state.layoutDraft.entities||{};},function(state){return state.layoutDraft&&state.layoutDraft.selectedModuleId;},function(mode,entities,selectedModuleId){return mode==='list'||!entities||!entities.sections?undefined:entities.modules[selectedModuleId];});};var getSelectedModule=makeGetSelectedModule();var makeGetSelectedSection=function makeGetSelectedSection(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.mode;},function(state){return state.layoutDraft&&state.layoutDraft.entities;},function(state){return state.layoutDraft&&state.layoutDraft.selectedSectionId;},function(mode,entities,selectedSectionId){return mode==='list'||!entities||!entities.sections?undefined:entities.sections[selectedSectionId];});};var getSelectedSection=makeGetSelectedSection();

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var AuthActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['login','loginSuccess','loginRestored','loginFailed','loginError','logout','incarnate','wakeUp','genericError','readerMode','builderMode','register','registerComplete','setFacebookLoginUrl','tryHashLogin','requestNewPassword','requestNewPasswordComplete','restorePassword','restorePasswordComplete','setLocale']);/* harmony default export */ __webpack_exports__["a"] = (AuthActions);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventConstants
 */



var keyMirror = __webpack_require__(211);

var PropagationPhases = keyMirror({ bubbled: null, captured: null });

/**
 * Types of raw signals from the browser caught at the top level.
 */
var topLevelTypes = keyMirror({
  topAbort: null,
  topBlur: null,
  topCanPlay: null,
  topCanPlayThrough: null,
  topChange: null,
  topClick: null,
  topCompositionEnd: null,
  topCompositionStart: null,
  topCompositionUpdate: null,
  topContextMenu: null,
  topCopy: null,
  topCut: null,
  topDoubleClick: null,
  topDrag: null,
  topDragEnd: null,
  topDragEnter: null,
  topDragExit: null,
  topDragLeave: null,
  topDragOver: null,
  topDragStart: null,
  topDrop: null,
  topDurationChange: null,
  topEmptied: null,
  topEncrypted: null,
  topEnded: null,
  topError: null,
  topFocus: null,
  topInput: null,
  topKeyDown: null,
  topKeyPress: null,
  topKeyUp: null,
  topLoad: null,
  topLoadedData: null,
  topLoadedMetadata: null,
  topLoadStart: null,
  topMouseDown: null,
  topMouseMove: null,
  topMouseOut: null,
  topMouseOver: null,
  topMouseUp: null,
  topPaste: null,
  topPause: null,
  topPlay: null,
  topPlaying: null,
  topProgress: null,
  topRateChange: null,
  topReset: null,
  topScroll: null,
  topSeeked: null,
  topSeeking: null,
  topSelectionChange: null,
  topStalled: null,
  topSubmit: null,
  topSuspend: null,
  topTextInput: null,
  topTimeUpdate: null,
  topTouchCancel: null,
  topTouchEnd: null,
  topTouchMove: null,
  topTouchStart: null,
  topVolumeChange: null,
  topWaiting: null,
  topWheel: null
});

var EventConstants = {
  topLevelTypes: topLevelTypes,
  PropagationPhases: PropagationPhases
};

module.exports = EventConstants;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Allows extraction of a minified key. Let's the build system minify keys
 * without losing the ability to dynamically use key strings as values
 * themselves. Pass in an object with a single key/val pair and it will return
 * you the string key of that single record. Suppose you want to grab the
 * value for a key 'className' inside of an object. Key/val minification may
 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
 * reuse those resolutions.
 */
var keyOf = function keyOf(oneKeyObj) {
  var key;
  for (key in oneKeyObj) {
    if (!oneKeyObj.hasOwnProperty(key)) {
      continue;
    }
    return key;
  }
  return null;
};

module.exports = keyOf;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(30);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(4);
var core = __webpack_require__(86);
var fails = __webpack_require__(28);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(76);
var IObject = __webpack_require__(180);
var toObject = __webpack_require__(44);
var toLength = __webpack_require__(41);
var asc = __webpack_require__(325);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.capitalize = capitalize;
exports.callbackName = callbackName;
exports.isObject = isObject;
exports.extend = extend;
exports.isFunction = isFunction;
exports.object = object;
exports.isArguments = isArguments;
exports.throwIf = throwIf;

function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function callbackName(string, prefix) {
    prefix = prefix || "on";
    return prefix + exports.capitalize(string);
}

/*
 * isObject, extend, isFunction, isArguments are taken from undescore/lodash in
 * order to remove the dependency
 */

function isObject(obj) {
    var type = typeof obj;
    return type === "function" || type === "object" && !!obj;
}

function extend(obj) {
    if (!isObject(obj)) {
        return obj;
    }
    var source, prop;
    for (var i = 1, length = arguments.length; i < length; i++) {
        source = arguments[i];
        for (prop in source) {
            if (Object.getOwnPropertyDescriptor && Object.defineProperty) {
                var propertyDescriptor = Object.getOwnPropertyDescriptor(source, prop);
                Object.defineProperty(obj, prop, propertyDescriptor);
            } else {
                obj[prop] = source[prop];
            }
        }
    }
    return obj;
}

function isFunction(value) {
    return typeof value === "function";
}

exports.EventEmitter = __webpack_require__(973);

exports.nextTick = function (callback) {
    setTimeout(callback, 0);
};

function object(keys, vals) {
    var o = {},
        i = 0;
    for (; i < keys.length; i++) {
        o[keys[i]] = vals[i];
    }
    return o;
}

function isArguments(value) {
    return typeof value === "object" && "callee" in value && typeof value.length === "number";
}

function throwIf(val, msg) {
    if (val) {
        throw Error(msg || val);
    }
}

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Config__ = __webpack_require__(52);
var AuthStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */],__WEBPACK_IMPORTED_MODULE_2_actions__["z" /* StoreActions */],__WEBPACK_IMPORTED_MODULE_2_actions__["y" /* SettingsActions */]],data:{loading:false,loggedIn:false,incarnated:true,locale:'en_US',role:{},roleMap:{},message:null},getInitialState:function getInitialState(){return this.data;},readComplete:function readComplete(store){if(!this.data.loggedIn){this.data=Object.assign({},this.data,{locale:store&&store.owner&&store.owner.locale||'en_US'});this.trigger(this.data);}},setLocale:function setLocale(locale){if(!this.data.loggedIn){this.data=Object.assign({},this.data,{locale:locale});this.trigger(this.data);}},init:function init(){if(localStorage){var _user=localStorage.getItem('user');if(_user){this.data=JSON.parse(_user);if(!this.data.roleMap){this.data.roleMap=Object.assign({},this.data.role);}this.data.locale=this.data.locale||'en_US';this.trigger(this.data);}}else{this.data={loggedIn:false,locale:'en_US'};this.trigger(this.data);}},updateComplete:function updateComplete(settings){var locale=settings.language;if(this.data.locale!==locale){this.data.locale=locale;this.trigger(this.data);}this.serialize();},loginRestored:function loginRestored(data){var user=data.user||{};user.loggedIn=true;this.data=user;this.data.incarnated=data.incarnated||false;this.data.features=user.features||{};this.data.roles=data.roles;this.data.role=data.roles.reduce(function(roleMap,item){roleMap[item]=true;return roleMap;},{});this.data.roleMap=Object.assign({},this.data.role);this.serialize();this.trigger(this.data);this.data.loading=false;__WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].setAuthToken(data.sessionId);this.trigger(this.data);},loginSuccess:function loginSuccess(data){__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].translatableMessage('login.success');this.loginRestored(data);},loginFailed:function loginFailed(){__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].translatableMessage('login.failed');this.data=Object.assign({},this.data,{loggedIn:false,loading:false,role:{},locale:'en_US',user:null});// history.push('/login');
this.trigger(this.data);},isReader:function isReader(){return this.data.roleMap.reader;},isTester:function isTester(){return this.data.roleMap.tester;},isTeacher:function isTeacher(){return this.data.roleMap.teacher;},isEditor:function isEditor(){return this.data.roleMap.editor;},isAccountant:function isAccountant(){return this.data.roleMap.account;},isAssistant:function isAssistant(){return this.data.roleMap.assistant;},isOwner:function isOwner(){return this.data.roleMap.owner;},isDarkAdmin:function isDarkAdmin(){return this.data.roleMap['dark-admin'];},getRole:function getRole(){return this.data.role;},onReaderMode:function onReaderMode(){this.data.role={reader:true};this.trigger(this.data);},onBuilderMode:function onBuilderMode(){this.data.role=this.data.roles.reduce(function(roleMap,item){roleMap[item]=true;return roleMap;},{});this.trigger(this.data);},onLoginError:function onLoginError(error){this.data={loggedIn:false,loading:false};__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].genericError(error);this.trigger(this.data);},onLogin:function onLogin(username,password){var _this=this;this.data.loading=true;this.trigger(this.data);if(username&&password){__WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].login(username,password).then(function(response){if(response.user){__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */].loginSuccess(response);}else{__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */].loginFailed();}},function(error){_this.data.loading=false;_this.trigger(_this.data);__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].genericError(error);});}else{__WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].request('auth','status').then(function(response){if(response.user){__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */].loginRestored(response);}else{__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */].loginFailed();}});}},// TODO: Remove after coursio 2.0 is shutdown
tryHashLogin:function tryHashLogin(){if(location.search.split('welcome%3D')[1]){var c2hash=location.search.split('welcome%3D')[1];__WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].loginCdk(c2hash).then(function(response){if(response.user){__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */].loginSuccess(response);}else{__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */].loginFailed();}},function(error){__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].genericError(error);});}},register:function register(email,password,firstName,lastName,locale){return __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].request('auth','register',{email:email,password:password,firstName:firstName,lastName:lastName,locale:locale}).then(function(response){__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */].loginSuccess(response);},function(error){console.log('Error',error);__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].genericError(error);});},logout:function logout(){this.data=Object.assign({},this.data,{loggedIn:false,user:null});this.trigger(this.data);this.serialize();__WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].logout().then(function(){__WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].setAuthToken(null);__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].translatableMessage('login.loggedOut');});},onIncarnate:function onIncarnate(userId,callback){var _this2=this;__WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].call('auth','incarnate',{userId:userId},function(response){_this2.loginSuccess(Object.assign({},response.data,{incarnated:true}));if(callback){callback();}});},onWakeUp:function onWakeUp(callback){var _this3=this;__WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].call('auth','wakeUp',{},function(response){_this3.loginSuccess(Object.assign({},response.data,{incarnated:false}));if(callback){callback();}});},serialize:function serialize(){try{localStorage.setItem('user',JSON.stringify(this.data));if(this.data.displayName){localStorage.setItem('displayName',this.data.displayName);}else{localStorage.setItem('displayName','No Display Name Exists on User');}}catch(e){console.error(e);}},requestNewPassword:function requestNewPassword(email){return __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].request('auth','requestNewPassword',{email:email,callbackUrl:location.protocol+__WEBPACK_IMPORTED_MODULE_4_Config__["a" /* default */].thisHost+'/restore-password/'}).then(function(response){__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */].requestNewPasswordComplete(response);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].genericError(error);});},requestNewPasswordComplete:function requestNewPasswordComplete(response){__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].translatableMessage('password.restoreLinkMailed');},restorePassword:function restorePassword(key,password,passwordVerify){return __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].request('auth','restorePassword',{key:key,password:password,passwordVerify:passwordVerify}).then(function(response){__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */].restorePasswordComplete();},function(error){__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].genericError(error);});},restorePasswordComplete:function restorePasswordComplete(){__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].translatableMessage('password.changed');__WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* history */].push('/login');},getUser:function getUser(){return this.data;},isAuthenticated:function isAuthenticated(){return this.data.loggedIn;},isIncarnated:function isIncarnated(){return this.data.incarnated;},getLocale:function getLocale(){return this.data.locale;},setFacebookLoginUrl:function setFacebookLoginUrl(url){this.data=Object.assign({},this.data,{facebookLoginUrl:url});this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (AuthStore);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Page__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_universalAnalytics__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__);
var _templateObject=_taggedTemplateLiteral(['Diploma will be generated and mailed to your email addresss.'],['Diploma will be generated and mailed to your email addresss.']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var checkCourse=function checkCourse(course){var settings=course.settings||{};var dripContent=settings.dripContent||{};if(dripContent.gatedAccess){var prevPage=void 0;return Object.assign({},course,{toc:course.toc.map(function(section){return Object.assign({},section,{pages:section.pages.map(function(page){if(prevPage&&!prevPage.isViewed){var newPage=Object.assign({},page,{isLocked:prevPage.isLocked||prevPage.progress===0});prevPage=newPage;return newPage;}prevPage=page;return Object.assign({},page,{isLocked:false});})});})});}return course;};var CourseStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */],__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */],__WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */]],data:{search:[],tocEnabled:JSON.parse(localStorage.getItem('tocEnabled'))||true,layoutDesignEnabled:false,notesEnabled:false,notes:[],list:[],buildable:[],courses:[],toc:{loading:true,list:[]},course:{},detail:{},page:{},slugMap:{},sort:{},filter:{},selected:null,selection:[]},getInitialState:function getInitialState(){return this.data;},init:function init(){if(localStorage){var courses=JSON.parse(localStorage.getItem('courses'))||{};if(courses.filter){this.data.filter=courses.filter;}if(courses.sort){this.data.sort=courses.sort;}this.trigger(this.data);}},getFilter:function getFilter(){return this.data.filter;},hasFilter:function hasFilter(){return!!this.data.filter.groupId||!!this.data.filter.userId;},search:function search(text){var _this=this;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('search','content',{courseId:this.data.course.id,token:'%'+text+'%'}).then(function(result){_this.data=Object.assign({},_this.data,{search:result});_this.trigger(_this.data);});},setCategory:function setCategory(courseId,categories){var _this2=this;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','update',{id:courseId,categories:categories}).then(function(response){if(_this2.data.course.id===courseId){_this2.data=Object.assign({},_this2.data,{course:Object.assign({},_this2.data.course,{categories:categories})});}if(_this2.data.selected.id===courseId){_this2.data=Object.assign({},_this2.data,{selected:Object.assign({},_this2.data.selected,{categories:categories})});}_this2.trigger(_this2.data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},onResetFilter:function onResetFilter(){this.data.filter={};this.trigger(this.data);this.serialize();},getToc:function getToc(courseId){this.data.toc=Object.assign({},this.data.toc,{loading:true});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','getToc',{courseId:courseId}).then(function(toc){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].getTocComplete(toc);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},getTocComplete:function getTocComplete(list){this.data.toc=Object.assign({},this.data.toc,{list:list,loading:false});this.trigger(this.data);},getGuestToc:function getGuestToc(courseId){this.data.toc=Object.assign({},this.data.toc,{loading:true});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('guest','getCourseToc',{courseId:courseId}).then(function(toc){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].getGuestTocComplete(toc);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},getGuestTocComplete:function getGuestTocComplete(list){this.data.toc=Object.assign({},this.data.toc,{list:list,loading:false});this.trigger(this.data);},openToc:function openToc(){if(!this.data.tocEnabled){this.data.tocEnabled=true;this.trigger(this.data);localStorage.setItem('tocEnabled',JSON.stringify(true));}},closeToc:function closeToc(){if(this.data.tocEnabled){this.data.tocEnabled=false;this.trigger(this.data);localStorage.setItem('tocEnabled',JSON.stringify(false));}},toggleNotes:function toggleNotes(){this.data.notesEnabled=!this.data.notesEnabled;this.trigger(this.data);},findNotes:function findNotes(){var _this3=this;var courseId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('note','findAll',{courseId:courseId}).then(function(response){_this3.data=Object.assign({},_this3.data,{notes:response});_this3.trigger(_this3.data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},toggleToc:function toggleToc(){if(this.data.tocEnabled){this.closeToc();}else{this.openToc();}},openLayoutDesign:function openLayoutDesign(){if(!this.data.layoutDesignEnabled){this.data.layoutDesignEnabled=true;this.trigger(this.data);}},closeLayoutDesign:function closeLayoutDesign(){if(this.data.layoutDesignEnabled){this.data.layoutDesignEnabled=false;this.trigger(this.data);}},toggleLayoutDesign:function toggleLayoutDesign(){if(this.data.layoutDesignEnabled){this.closeLayoutDesign();}else{this.openLayoutDesign();}},onSetFilter:function onSetFilter(filter){Object.assign(this.data.filter,filter);this.trigger(this.data);this.serialize();},onResetSort:function onResetSort(){this.data.sort={};this.trigger(this.data);this.serialize();},onSetSort:function onSetSort(sort){Object.assign(this.data.sort,sort);this.trigger(this.data);this.serialize();},serialize:function serialize(){localStorage.setItem('courses',JSON.stringify({filter:this.data.filter,sort:this.data.sort}));},onFetchAll:function onFetchAll(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('dashboard','read',{},function(response){_this4.data.courses=response.data;_this4.trigger(_this4.data);});},onFindBuildable:function onFindBuildable(){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','findBuildable',{}).then(function(buildable){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].findBuildableComplete(buildable);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},onFindBuildableComplete:function onFindBuildableComplete(buildable){this.data.buildable=buildable;this.trigger(this.data);},onFilter:function onFilter(dontUseFilter){var _this5=this;var options={sortBy:this.data.sort.property||'name',sortMode:this.data.sort.direction||'asc'};if(!dontUseFilter){options.circleId=this.data.filter.groupId;options.userId=this.data.filter.userId;}return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('search','filterCourses',options,function(response){_this5.data.list=response.data;_this5.trigger(_this5.data);});},onFindBySlug:function onFindBySlug(ownerSlug,courseSlug){var statistics=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;if(ownerSlug!==this.data.course.ownerSlug&&courseSlug!==this.data.course.slug){this.data=Object.assign({},this.data,{page:{}});this.trigger(this.data);}return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','findByUsernameAndSlug',{slug:courseSlug,username:ownerSlug}).then(function(course){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].findBySlugComplete(course);if(statistics){__WEBPACK_IMPORTED_MODULE_5_helpers_universalAnalytics__["a" /* default */].initialize(course.ownerExtra&&course.ownerExtra.ga&&course.ownerExtra.ga.id||undefined);__WEBPACK_IMPORTED_MODULE_5_helpers_universalAnalytics__["a" /* default */].pageview();}},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},onFindBySlugComplete:function onFindBySlugComplete(course){this.data.course=checkCourse(course);this.trigger(this.data);},refetchToc:function refetchToc(){var id=this.data.course.id;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','findById',{id:id}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].findByIdComplete(data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].genericError(error);});},onFindById:function onFindById(id){if(id!==this.data.course.id){this.data=Object.assign({},this.data,{page:{}});this.trigger(this.data);}this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','findById',{id:id}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].findByIdComplete(data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].genericError(error);});},onFindByIdComplete:function onFindByIdComplete(course){var checkedCourse=checkCourse(course);this.data.selected=checkedCourse;this.data.course=checkedCourse;this.trigger(this.data);},onUpdateComplete:function onUpdateComplete(data){this.data.course=data;this.trigger(this.data);},retrieveDiploma:function retrieveDiploma(courseId){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','fetchDiploma',{courseId:courseId}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].notify(Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject));},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},saveSettings:function saveSettings(){var _ref=this.data.selected?this.data.selected:this.data.course?this.data.course:{},id=_ref.id,settings=_ref.settings;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','update',{id:id,settings:settings}).then(function(data){},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].genericError(error);});},updateDiploma:function updateDiploma(data){var diploma=this.data.selected.settings&&this.data.selected.settings.diploma?this.data.selected.settings.diploma:{};var settings=Object.assign({},this.data.selected.settings,{diploma:Object.assign({},diploma,data)});this.data=Object.assign({},this.data,{selected:Object.assign({},this.data.selected,{settings:settings})});this.trigger(this.data);},removeDiploma:function removeDiploma(id){var _this6=this;var settings=Object.assign({},this.data.selected.settings,{diploma:{fileId:null}});return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','update',{id:id,settings:settings}).then(function(data){_this6.data=Object.assign({},_this6.data,{selected:Object.assign({},_this6.data.selected,{settings:data.settings})});_this6.trigger(_this6.data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].genericError(error);});},updateQuizSettings:function updateQuizSettings(data){var course_settings=this.data.selected&&this.data.selected.settings&&this.data.selected.settings?this.data.selected.settings:this.data.course.settings&&this.data.course.settings?this.data.course.settings:{};var settings=Object.assign({},course_settings,{quiz:Object.assign({},course_settings.quiz,data)});this.data=Object.assign({},this.data,{selected:Object.assign({},this.data.selected,{settings:settings}),course:Object.assign({},this.data.course,{settings:settings})});this.trigger(this.data);},updateDripContent:function updateDripContent(data){var dripContent=this.data.selected.settings&&this.data.selected.settings.dripContent?this.data.selected.settings.dripContent:{};var settings=Object.assign({},this.data.selected.settings,{dripContent:Object.assign({},dripContent,data)});this.data=Object.assign({},this.data,{selected:Object.assign({},this.data.selected,{settings:settings})});this.trigger(this.data);},getNextForPageId:function getNextForPageId(pageId){var filtered=this.data.course.toc?this.data.course.toc.filter(function(s){return s.type!=='quiz';}):[];var quizSettings=this.data.course.settings&&this.data.course.settings.quiz;var toc=quizSettings&&quizSettings.enabled?this.data.course.toc?this.data.course.toc:[]:filtered;var foundPageIndex=void 0;var foundSectionIndex=toc.findIndex(function(section){foundPageIndex=section.pages.findIndex(function(page){return page.id===pageId;});return foundPageIndex>-1;});var foundSection=toc[foundSectionIndex];var foundPage=void 0;if(foundSection&&foundPageIndex===foundSection.pages.length-1&&foundSectionIndex<toc.length-1){foundSection=toc[foundSectionIndex+1];foundPage=foundSection.pages[0];return{chapter:foundSection,page:foundPage};}else if(foundSection&&foundPageIndex<foundSection.pages.length-1){return{chapter:foundSection,page:foundSection.pages[foundPageIndex+1]};}return null;},getPreviousForPageId:function getPreviousForPageId(pageId){var filtered=this.data.course.toc?this.data.course.toc.filter(function(s){return s.type!=='quiz';}):[];var quizSettings=this.data.course.settings&&this.data.course.settings.quiz;var toc=quizSettings&&quizSettings.enabled?this.data.course.toc?this.data.course.toc:[]:filtered;var foundPageIndex=void 0;var foundSectionIndex=toc.findIndex(function(section){foundPageIndex=section.pages.findIndex(function(page){return page.id===pageId;});return foundPageIndex>-1;});var foundSection=toc[foundSectionIndex];var foundPage=void 0;if(foundPageIndex===0&&foundSectionIndex>0){foundSection=toc[foundSectionIndex-1];foundPage=foundSection.pages[foundSection.pages.length-1];return{chapter:foundSection,page:foundPage};}else if(foundPageIndex>0){return{chapter:foundSection,page:foundSection.pages[foundPageIndex-1]};}return null;},onGetPageBySlug:function onGetPageBySlug(username,courseSlug,sectionSlug,pageSlug,callback){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page','findBySlug',{username:username,courseSlug:courseSlug,sectionSlug:sectionSlug,pageSlug:pageSlug}).then(function(page){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].getPageByIdComplete(page);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},getPageById:function getPageById(pageId,editor){var _this7=this;// this.data.page = null;
// this.trigger(this.data);
return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page','findById',{id:pageId}).then(function(page){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].getPageByIdComplete(page,editor);},function(error){if(_this7.data.page.id===pageId){_this7.data.page={};_this7.trigger(_this7.data);}__WEBPACK_IMPORTED_MODULE_4_helpers__["a" /* history */].push('/dashboard');__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},getPageByIdComplete:function getPageByIdComplete(page,editor){this.data.page=Object.assign({},page,{pageRows:page.pageRows.filter(function(row){if(row.pageModules.length>0){return true;}if(editor){__WEBPACK_IMPORTED_MODULE_3_services_Page__["a" /* default */].deletePageRow(row.id);}return false;})});this.trigger(this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].markPageViewed(this.data.course.id,page.id);},markPageViewed:function markPageViewed(courseId,pageId){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page','markViewed',{courseId:courseId,pageId:pageId}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].markPageViewedComplete(courseId,pageId);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},markPageViewedComplete:function markPageViewedComplete(courseId,pageId){var course=this.data.course;if(course.id===courseId){course.lastViewedPageId=pageId;course.toc=course.toc.map(function(section){section.pages=section.pages.map(function(page){if(page.id===pageId){return Object.assign({},page,{isViewed:1});}return page;});return section;});this.data.course=checkCourse(course);this.trigger(this.data);}},resetSelection:function resetSelection(){this.data.selection=[];this.trigger(this.data);},onFindByUserId:function onFindByUserId(userId){this.data.selectionLoading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('search','filterCourses',{userId:userId,sortBy:'name',sortMode:'asc',showOld:true}).then(function(selection){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].findByUserIdComplete(selection);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},onFindByUserIdComplete:function onFindByUserIdComplete(selection){this.data.selection=selection;this.data.selectionLoading=false;this.trigger(this.data);},onRemoveFromSelection:function onRemoveFromSelection(courseId){var dirty=false;var selection=this.data.selection;for(var i=selection.length;i--;){if(selection[i].id===courseId){selection.splice(i,1);dirty=true;}}if(dirty){this.trigger(this.data);}},onDuplicatePage:function onDuplicatePage(courseId,id){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page','duplicate',{id:id}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].duplicatePageComplete(courseId);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].genericError(error);});},onDuplicatePageComplete:function onDuplicatePageComplete(courseId){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].findById(courseId);},onDuplicateSection:function onDuplicateSection(courseId,id){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('section','duplicate',{id:id}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].duplicateSectionComplete(courseId);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].genericError(error);});},onDuplicateSectionComplete:function onDuplicateSectionComplete(courseId){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].findById(courseId);},onFindByGroupId:function onFindByGroupId(groupId,callback){var _this8=this;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('search','filterCourses',{circleId:groupId,sortBy:'name',sortMode:'asc'},function(response){_this8.data.list=response.data||[];_this8.trigger(_this8.data);if(callback){callback();}});},// moveModule(fromRow, fromPosition, toRow, toPosition) {
//   if (this.moduleToMove) {
//     if (toRow === this.moduleToMove.toRow && toPosition === this.moduleToMove.toPosition) {
//       return;
//     }
//     if (this._moveModuleTimer) {
//       clearTimeout(this._moveModuleTimer);
//       this._moveModuleTimer = null;
//     }
//   }
//   if (this._moveModuleTimer) {
//     return;
//   }
//   this.moduleToMove = {
//     toRow,
//     toPosition
//   };
//   console.log(this.moduleToMove);
//   this._moveModuleTimer = setTimeout(() => {
//     this.moveModuleFinalize(fromRow, fromPosition, toRow, toPosition);
//     clearTimeout(this._moveModuleTimer);
//     this._moveModuleTimer = null;
//   }, 1000);
// },
moveModule:function moveModule(id,fromRow,fromPosition,toRow,toPosition){var pageRows=this.data.page.pageRows.slice();if(!pageRows[fromRow]||!pageRows[toRow]){return;}if(!pageRows[fromRow].pageModules[fromPosition]||pageRows[fromRow].pageModules[fromPosition].id!==id){return;}if(fromRow===toRow){var pageModules=pageRows[fromRow].pageModules.slice();pageModules[toPosition]=pageModules.splice(fromPosition,1,pageModules[toPosition])[0];if(!pageModules[toPosition]){return;}pageRows[fromRow]=Object.assign({},pageRows[fromRow],{pageModules:pageModules});pageModules.forEach(function(module,index){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updatePageModule(module.id,{sortOrder:index+1});});}else if(fromRow!==toRow){var fromModules=pageRows[fromRow].pageModules.slice();// TODO
var toModules=pageRows[toRow].pageModules.slice();var pageModule=fromModules.splice(fromPosition,1)[0];if(!pageModule){return;}toModules.splice(toPosition,0,pageModule);if(pageRows[fromRow].pageModules.length<1){// CourseActions.deletePageRow(pageRows[fromRow].id);
}pageRows[fromRow]=Object.assign({},pageRows[fromRow],{pageModules:fromModules});pageRows[toRow]=Object.assign({},pageRows[toRow],{pageModules:toModules});toModules.forEach(function(module,index){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updatePageModule(module.id,{pageRowId:pageRows[toRow].id,sortOrder:index+1});});}this.data.page=Object.assign({},this.data.page,{pageRows:pageRows});this.trigger(this.data);},deletePageRow:function deletePageRow(id){__WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page-row','delete',{id:id}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].deletePageRowComplete(id);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},deletePageRowComplete:function deletePageRowComplete(id){},sanitizePage:function sanitizePage(){var pageRows=this.data.page.pageRows.slice().filter(function(row){if(row.pageModules&&row.pageModules.length>0){return true;}__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].deletePageRow(row.id);return false;});this.data.page=Object.assign({},this.data.page,{pageRows:pageRows});this.trigger(this.data);},moveModuleToNewRow:function moveModuleToNewRow(rowIndex,index,toRowIndex){var pageRows=this.data.page.pageRows.slice();if(!pageRows[rowIndex]){return;}var pageModules=pageRows[rowIndex].pageModules.slice();var pageModule=pageModules.splice(index,1)[0];if(!pageModule){return;}if(pageRows[rowIndex].pageModules.length<1){// CourseActions.deletePageRow(pageRows[rowIndex].id);
}pageRows[rowIndex]=Object.assign({},pageRows[rowIndex],{pageModules:pageModules});pageRows.splice(toRowIndex,0,{id:Math.random(),pageModules:[pageModule]});this.data.page=Object.assign({},this.data.page,{pageRows:pageRows});__WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page-module','moveToNewPageRow',{id:pageModule.id,pageRowPosition:toRowIndex+1}).then(function(pageRow){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].moveModuleToNewRowComplete(toRowIndex,pageRow);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});this.trigger(this.data);},moveModuleToNewRowComplete:function moveModuleToNewRowComplete(rowIndex,pageRow){var pageRows=this.data.page.pageRows.slice();pageRows[rowIndex]=pageRow;this.data.page=Object.assign({},this.data.page,{pageRows:pageRows});this.trigger(this.data);//pageRows.splice(rowIndex, 1, pageRow);
},cancelNewRow:function cancelNewRow(){if(this._newRowTimer){clearTimeout(this._newRowTimer);this._newRowTimer=null;}},moveModuleToRow:function moveModuleToRow(moduleId,rowId,position){// Remove first
var page=this.data.page,toPageRow=null,fromPageRow=null,foundIndex=null,foundModule=null,fromRowIndex=null;page.pageRows.some(function(row,rowIndex){if(row.id===rowId){toPageRow=row;}row.pageModules.some(function(module,index){if(module.id===moduleId){foundIndex=index;fromPageRow=row;fromRowIndex=rowIndex;foundModule=module;return true;}});return foundModule!==null&&toPageRow!==null;});fromPageRow.pageModules.splice(foundIndex,1);toPageRow.pageModules.splice(position,0,foundModule);if(fromPageRow.pageModules.length<1){page.pageRows.splice(fromRowIndex,1);}this.trigger(this.data);},onMoveModuleAfterRow:function onMoveModuleAfterRow(moduleId,rowId){var page=this.data.page,fromPageRow=null,foundIndex=null,foundModule=null,foundRowIndex=null,fromRowIndex=null;page.pageRows.some(function(row,rowIndex){if(row.id===rowId){foundRowIndex=rowIndex;}row.pageModules.some(function(module,index){if(module.id===moduleId){foundIndex=index;fromPageRow=row;fromRowIndex=rowIndex;foundModule=module;return true;}});return foundRowIndex!==null&&foundIndex!==null;});fromPageRow.pageModules.splice(foundIndex,1);page.pageRows.splice(foundRowIndex+1,0,{id:getNextId(),pageModules:[foundModule]});if(fromPageRow.pageModules.length<1){page.pageRows.splice(fromRowIndex,1);}this.trigger(this.data);},onAddToTop:function onAddToTop(moduleId){var page=this.data.page,fromPageRow=null,foundIndex=null,foundModule=null,fromRowIndex=null;page.pageRows.some(function(row,rowIndex){row.pageModules.some(function(module,index){if(module.id===moduleId){foundIndex=index;fromPageRow=row;fromRowIndex=rowIndex;foundModule=module;return true;}});return foundIndex!==null;});fromPageRow.pageModules.splice(foundIndex,1);page.pageRows.splice(0,0,{id:getNextId(),pageModules:[foundModule]});if(fromPageRow.pageModules.length<1){page.pageRows.splice(fromRowIndex,1);}this.trigger(this.data);},deletePageModule:function deletePageModule(id){return this.deleteModule(id);},deleteModule:function deleteModule(id){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page-module','delete',{id:id}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].deleteModuleComplete(id);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},markModuleSaving:function markModuleSaving(id){var page=this.data.page;var dirty=false;var newPage=Object.assign({},page,{pageRows:page.pageRows.map(function(row){return Object.assign({},row,{pageModules:row.pageModules.map(function(module){if(module.id===id&&!module.saving){dirty=true;return Object.assign({},module,{saving:true});}return module;})});}).filter(function(row){return row.pageModules.length>0;})});if(dirty){this.data.page=newPage;this.trigger(this.data);}},changePageModule:function changePageModule(moduleData,callback){var newModule=void 0;var page=this.data.page;var newPage=Object.assign({},page,{pageRows:page.pageRows.map(function(row){return Object.assign({},row,{pageModules:row.pageModules.map(function(module){if(module.id===moduleData.id&&!module.saving){newModule=Object.assign({},module,moduleData);return newModule;}return module;})});}).filter(function(row){return row.pageModules.length>0;})});this.data.page=newPage;this.trigger(this.data);callback&&callback(newModule);},savePageModule:function savePageModule(id,content,data){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page-module','update',{id:id,content:content,params:data}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].savePageModuleComplete(id,content,data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},savePageModuleComplete:function savePageModuleComplete(id,content,data){var page=this.data.page;this.data.page=Object.assign({},page,{pageRows:page.pageRows.map(function(row){return Object.assign({},row,{pageModules:row.pageModules.map(function(module){if(module.id===id){return Object.assign({},module,{content:content,data:Object.assign({},module.data,{params:data}),saving:false});}return module;})});}).filter(function(row){return row.pageModules.length>0;})});this.trigger(this.data);},savePageModuleUserData:function savePageModuleUserData(id,data){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page-module','saveUserData',{id:id,data:data}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].savePageModuleUserDataComplete(id,data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},savePageModuleUserDataComplete:function savePageModuleUserDataComplete(id,userdata){var page=this.data.page;this.data.page=Object.assign({},page,{pageRows:page.pageRows.map(function(row){return Object.assign({},row,{pageModules:row.pageModules.map(function(module){if(module.id===id){return Object.assign({},module,{data:{content:module.content,params:module.params,userdata:userdata}});}return module;})});}).filter(function(row){return row.pageModules.length>0;})});this.trigger(this.data);},changePageModuleMode:function changePageModuleMode(id,mode){var page=this.data.page;this.data.page=Object.assign({},page,{pageRows:page.pageRows.map(function(row){return Object.assign({},row,{pageModules:row.pageModules.map(function(module){if(module.id===id){return Object.assign({},module,{mode:mode});}return module;})});}).filter(function(row){return row.pageModules.length>0;})});this.trigger(this.data);},deleteModuleComplete:function deleteModuleComplete(moduleId){var page=this.data.page;this.data.page=Object.assign({},page,{pageRows:page.pageRows.map(function(row){return Object.assign({},row,{pageModules:row.pageModules.filter(function(module){return module.id!==moduleId;})});}).filter(function(row){return row.pageModules.length>0;})});this.trigger(this.data);},moveSection:function moveSection(courseId,dragIndex,hoverIndex){var _this9=this;var toc=this.data.course.toc.slice();toc[hoverIndex]=toc.splice(dragIndex,1,toc[hoverIndex])[0];var course=Object.assign({},this.data.course,{toc:toc});this.data.course=course;this.trigger(this.data);if(this._reorderTimeout){clearTimeout(this._reorderTimeout);}this._reorderTimeout=setTimeout(function(){_this9.reorderSections(courseId,_this9.data.course.toc.map(function(section){return section.id;}));},1000);},reorderSections:function reorderSections(id,sectionIds){__WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','reorderSections',{id:id,sectionIds:sectionIds}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].reorderSectionsComplete(sectionIds);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},reorderSectionsComplete:function reorderSectionsComplete(){},reorderPages:function reorderPages(id,pageIds){__WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('section','reorderPages',{id:id,pageIds:pageIds}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].reorderPagesComplete(pageIds);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},reorderPagesComplete:function reorderPagesComplete(){},movePage:function movePage(courseId,sectionIndex,pageIndex,toSectionIndex,toPageIndex){var _this10=this;var toc=this.data.course.toc.slice();var pageId=toc[sectionIndex].pages[pageIndex].id;var sectionId=toc[toSectionIndex].id;var position=toPageIndex+1;var course=void 0;if(sectionIndex===toSectionIndex){var pages=toc[sectionIndex].pages.slice();pages[toPageIndex]=pages.splice(pageIndex,1,pages[toPageIndex])[0];toc[sectionIndex]=Object.assign({},toc[sectionIndex],{pages:pages});// console.log(pages);
course=Object.assign({},this.data.course,{toc:toc});this.data.course=course;this.trigger(this.data);if(this._pageReorderTimeout){clearTimeout(this._pageReorderTimeout);}this._pageReorderTimeout=setTimeout(function(){_this10.reorderPages(sectionId,pages.map(function(page){return page.id;}));},1000);}else if(sectionIndex!==toSectionIndex){var fromPages=toc[sectionIndex].pages.slice();var toPages=toc[toSectionIndex].pages.slice();var page=fromPages.splice(pageIndex,1)[0];toPages.splice(toPageIndex,0,page);toc[sectionIndex]=Object.assign({},toc[sectionIndex],{pages:fromPages});toc[toSectionIndex]=Object.assign({},toc[toSectionIndex],{pages:toPages});course=Object.assign({},this.data.course,{toc:toc});this.data.course=course;this.trigger(this.data);if(this._pageMoveTimeout){clearTimeout(this._pageMoveTimeout);}this._pageMoveTimeout=setTimeout(function(){_this10.movePageToSection(pageId,sectionId,position);},1000);}},movePageToSection:function movePageToSection(pageId,sectionId,position){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page','moveToSection',{pageId:pageId,sectionId:sectionId,position:position}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].movePageComplete();},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},movePageComplete:function movePageComplete(){},updatePageModule:function updatePageModule(pageModuleId,pageModuleData){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page-module','update',Object.assign({},pageModuleData,{id:pageModuleId})).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updatePageModuleComplete();},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},updatePageModuleComplete:function updatePageModuleComplete(){},setPageModuleMode:function setPageModuleMode(pageModuleId,mode){var page=this.data.page;this.data.page=Object.assign({},page,{pageRows:page.pageRows.map(function(row){return Object.assign({},row,{pageModules:row.pageModules.map(function(module){if(module.id===pageModuleId){return Object.assign({},module,{mode:mode});}return module;})});})});this.trigger(this.data);},addPageModule:function addPageModule(type,pageId){var update=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page-module','create',{type:type,newRow:true,pageId:pageId}).then(function(response){if(update){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].addPageModuleComplete(response.pageRows);}},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},addPageModuleComplete:function addPageModuleComplete(pageRows){if(pageRows&&pageRows.length>0){var page=this.data.page;this.data.page=Object.assign({},page,{pageRows:page.pageRows.concat(pageRows.map(function(row){row.pageModules=row.pageModules.map(function(module){return Object.assign({},module,{mode:'edit'});});return row;}))});this.trigger(this.data);}},onGetFile:function onGetFile(fileId,callback){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('file','getFileInfo',{id:fileId},function(response){//this.trigger(this.data);
if(callback){callback();}});},updateTask:function updateTask(pageModuleId,task){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updateTaskComplete(pageModuleId,task);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('task','update',task).then(function(response){},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},updateTaskCaption:function updateTaskCaption(task){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('task','update',task).then(function(response){},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},updateTaskComplete:function updateTaskComplete(pageModuleId,task){var page=this.data.page;this.data.page=Object.assign({},page,{pageRows:page.pageRows.map(function(row){return Object.assign({},row,{pageModules:row.pageModules.map(function(module){if(module.id===pageModuleId){return Object.assign({},module,{data:Object.assign({},module.data,{params:Object.assign({},module.data.params,{task:Object.assign({},module.data.params.task,task)})}),saving:false});}return module;})});}).filter(function(row){return row.pageModules.length>0;})});this.trigger(this.data);},note:function note(pageModuleId,text,color){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page-module','note',{id:pageModuleId,note:{text:text,color:color}}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].noteComplete(pageModuleId,text,color);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},noteComplete:function noteComplete(pageModuleId,text,color){var _this11=this;var page=this.data.page;if(page.pageRows){page.pageRows.some(function(row){return row.pageModules.some(function(module){if(module.id===pageModuleId){module.note={text:text,color:color};_this11.trigger(_this11.data);return true;}});});}},answerTask:function answerTask(taskId,pageModuleId,body){var bodyFiles=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('task','answer',{taskId:taskId,pmid:pageModuleId,body:body}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].answerTaskComplete(taskId,pageModuleId,response.taskResult,bodyFiles);}).catch(__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError);},answerTaskComplete:function answerTaskComplete(taskId,pageModuleId,taskResult,bodyFiles){var page=this.data.page;this.data.page=Object.assign({},page,{pageRows:page.pageRows.map(function(row){return Object.assign({},row,{pageModules:row.pageModules.map(function(module){if(module.id===pageModuleId){return Object.assign({},module,{data:Object.assign({},module.data,{params:Object.assign({},module.data.params,{taskResults:[].concat(_toConsumableArray(module.data.params.taskResults||[]),[{id:taskResult.id,feedback:taskResult.feedback||{},visible:taskResult.visible,bodyFiles:bodyFiles,body:{value:taskResult.body.value}}])})})});}return module;})});}).filter(function(row){return row.pageModules.length>0;})});this.trigger(this.data);},addPage:function addPage(sectionId,afterPageId,pageName){var course=this.data.course;var foundSection=void 0;course.toc.every(function(section){if(section.id===sectionId){foundSection=section;return false;}});var name=foundSection?pageName+' '+(foundSection.pages.length+1):pageName;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page','create',{sectionId:sectionId,afterPageId:afterPageId,name:name}).then(function(page){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].addPageComplete(sectionId,afterPageId,page);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},addPageComplete:function addPageComplete(sectionId,afterPageId,page){var course=this.data.course;var toc=course.toc.map(function(section){if(section.id===sectionId){var pages=section.pages.slice();var pageIndex=afterPageId&&pages.findIndex(function(sectionPage){return sectionPage.id===afterPageId;})||0;pages.splice(pageIndex+1,0,Object.assign({},page,{mode:'edit'}));return Object.assign({},section,{pages:pages});}return Object.assign({},section);});this.data.course=Object.assign({},course,{toc:toc});this.trigger(this.data);if(!this.data.page||!this.data.page.id){__WEBPACK_IMPORTED_MODULE_4_helpers__["a" /* history */].push('/course/'+course.ownerSlug+'/'+course.slug+'/'+page.id);}},addQuizPageComplete:function addQuizPageComplete(sectionId,afterPageId,page){var course=this.data.course;var toc=course.toc.map(function(section){if(section.id===sectionId){var pages=section.pages.slice();var pageIndex=afterPageId&&pages.findIndex(function(sectionPage){return sectionPage.id===afterPageId;})||0;pages.splice(pageIndex+1,0,Object.assign({},page,{mode:'edit'}));return Object.assign({},section,{pages:pages});}return Object.assign({},section);});this.data.course=Object.assign({},course,{toc:toc});this.trigger(this.data);},updateSection:function updateSection(sectionData){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('section','update',sectionData).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updateSectionComplete(sectionData);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},updateSectionComplete:function updateSectionComplete(sectionData){var course=this.data.course;var toc=course.toc.map(function(section){if(section.id===sectionData.id){return Object.assign({},section,sectionData);}return Object.assign({},section);});this.data.course=Object.assign({},course,{toc:toc});this.trigger(this.data);},updatePage:function updatePage(page){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page','update',page).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updatePageComplete(page);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},updatePageComplete:function updatePageComplete(page){if(this.data.page.id===page.id){this.data.page=Object.assign({},this.data.page,page);this.trigger(this.data);}},deleteSection:function deleteSection(id){if(this.data.course.toc&&this.data.course.toc.length!==1){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('section','delete',{id:id}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].deleteSectionComplete(id);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});}},deleteSectionComplete:function deleteSectionComplete(sectionId){var course=this.data.course;var toc=course.toc.slice();var index=toc.findIndex(function(section){return section.id===sectionId;});toc.splice(index,1);this.data.course=Object.assign({},course,{toc:toc});this.trigger(this.data);},deletePage:function deletePage(id){var course=this.data.course;var toc=course.toc.map(function(section){var pageIndex=section.pages.findIndex(function(page){return page.id===id;});if(pageIndex>=0){return section.pages;}return null;});var pages=[].concat.apply([],toc).filter(function(x){return!!x;});if(pages.length!==1){var quizPages=this.data.course.settings&&this.data.course.settings.quiz&&this.data.course.settings.quiz.pages?this.data.course.settings.quiz.pages:null;if(quizPages&&quizPages[id]){delete quizPages[id];__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updateQuizSettings({pages:quizPages});__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].saveSettings();}return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page','delete',{id:id}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].deletePageComplete(id);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});}},deletePageComplete:function deletePageComplete(pageId){var course=this.data.course;var toc=course.toc.map(function(section){var pageIndex=section.pages.findIndex(function(page){return page.id===pageId;});if(pageIndex>-1){var pages=section.pages.slice();pages.splice(pageIndex,1);return Object.assign({},section,{pages:pages});}return Object.assign({},section);});this.data.course=Object.assign({},course,{toc:toc});this.trigger(this.data);},addSection:function addSection(courseId,afterSectionId,sectionName,pageName,type){var name=sectionName+' '+(this.data.course.toc.length+1);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('section','create',{courseId:courseId,afterSectionId:afterSectionId,name:name,type:type}).then(function(section){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].addSectionComplete(section,afterSectionId,pageName+' 1');},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},addSectionComplete:function addSectionComplete(section,afterSectionId,pageName){var course=this.data.course;var toc=course.toc.slice();var sectionIndex=toc.findIndex(function(courseSection){return courseSection.id===afterSectionId;});toc.splice(sectionIndex+1,0,Object.assign({},section,{mode:'edit',pages:section.pages||[]}));this.data.course=Object.assign({},course,{toc:toc});this.trigger(this.data);this.addPage(section.id,null,pageName);},addQuizSectionComplete:function addQuizSectionComplete(section,afterSectionId){var course=this.data.course;var toc=course.toc.slice();var sectionIndex=toc.findIndex(function(courseSection){return courseSection.id===afterSectionId;});toc.splice(sectionIndex+1,0,Object.assign({},section,{mode:'edit',pages:section.pages||[]}));this.data.course=Object.assign({},course,{toc:toc});this.trigger(this.data);},increaseModuleSize:function increaseModuleSize(pageModuleId){var page=this.data.page;var pageRows=page.pageRows.slice().map(function(row){var pageModuleIndex=row.pageModules.findIndex(function(module){return module.id===pageModuleId;});if(pageModuleIndex>-1){if(row.placement&&row.placement.length<1){row.placement=[6,6];}var placement=(row.placement||[6,6]).map(function(weight){return weight-1;});placement[pageModuleIndex]=placement[pageModuleIndex]+2;__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updatePageRow(row.id,{placement:placement});}return row;});this.data.page=Object.assign({},page,{pageRows:pageRows});this.trigger(this.data);},updatePageRow:function updatePageRow(id,pageRowData){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page-row','update',Object.assign({},pageRowData,{id:id})).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updatePageRowComplete(Object.assign({},pageRowData,{id:id}));},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},updatePageRowComplete:function updatePageRowComplete(row){var page=this.data.page;var pageRows=page.pageRows.slice().map(function(pageRow){if(pageRow.id===row.id){return Object.assign({},pageRow,row);}return pageRow;});this.data.page=Object.assign({},page,{pageRows:pageRows});this.trigger(this.data);},pastePage:function pastePage(sectionId,page){// SteelCompass.request('content', 'createFromReference', { parentId: sectionId, ref: { type: 'page', id: page.id } }).then(response => {
//   console.log(response);
// }, error => {
//   console.log(error);
// })
var course=this.data.course;var toc=course.toc.map(function(section){if(section.id===sectionId){var pages=section.pages.slice();pages.push(Object.assign({},page,{id:--index}));return Object.assign({},section,{pages:pages});}return section;});this.data.course=Object.assign({},course,{toc:toc});this.trigger(this.data);},pasteSection:function pasteSection(section){var course=this.data.course;var toc=course.toc.slice();toc.push(Object.assign({},section,{id:--index}));this.data.course=Object.assign({},course,{toc:toc});this.trigger(this.data);},update:function update(id,data){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','update',Object.assign({id:id},data)).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updateComplete(id,data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},addTag:function addTag(courseId,name){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('tag','addLink',{objectId:courseId,objectType:2,name:name}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].addTagComplete(courseId,name);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},removeTag:function removeTag(courseId,name){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('tag','removeLink',{objectId:courseId,objectType:2,name:name}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].removeTagComplete(courseId,name);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},updateComplete:function updateComplete(id,data){this.data=Object.assign({},this.data,{list:this.data.list.map(function(course){if(course.id===id){return Object.assign({},course,data);}return course;})});if(this.data.selected.id===id){this.data=Object.assign({},this.data,{selected:Object.assign({},this.data.selected,data)});}this.trigger(this.data);},addTagComplete:function addTagComplete(courseId,name){this.data=Object.assign({},this.data,{list:this.data.list.map(function(course){if(course.id===courseId){var tagsMap=course.tagsMap||{};return Object.assign({},course,{tagsMap:Object.assign({},tagsMap,_defineProperty({},name,true))});}return course;})});if(this.data.selected.id===courseId){var tagsMap=this.data.selected.tagsMap||{};this.data=Object.assign({},this.data,{selected:Object.assign({},this.data.selected,{tagsMap:Object.assign({},tagsMap,_defineProperty({},name,true))})});}this.trigger(this.data);},removeTagComplete:function removeTagComplete(courseId,name){this.data=Object.assign({},this.data,{list:this.data.list.map(function(course){if(course.id===courseId){var tagsMap=course.tagsMap||{};return Object.assign({},course,{tagsMap:Object.assign({},tagsMap,_defineProperty({},name,false))});}return course;})});if(this.data.selected.id===courseId){var tagsMap=this.data.selected.tagsMap||{};this.data=Object.assign({},this.data,{selected:Object.assign({},this.data.selected,{tagsMap:Object.assign({},tagsMap,_defineProperty({},name,false))})});}this.trigger(this.data);}});var index=-1;/* harmony default export */ __webpack_exports__["a"] = (CourseStore);

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  /**
   * The relative brightness of any point in a colorspace, normalized to 0 for
   * darkest black and 1 for lightest white. RGB colors only. Does not take
   * into account alpha values.
   *
   * TODO:
   * - Take into account alpha values.
   * - Identify why there are minor discrepancies for some use cases
   *   (i.e. #F0F & #FFF). Note that these cases rarely occur.
   *
   * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  _luminance: function _luminance(color) {
    color = this._decomposeColor(color);

    if (color.type.indexOf('rgb') > -1) {
      var rgb = color.values.map(function (val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
      });

      return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
    } else {
      var message = 'Calculating the relative luminance is not available for ' + 'HSL and HSLA.';
      console.error(message);
      return -1;
    }
  },

  /**
   * @params:
   * additionalValue = An extra value that has been calculated but not included
   *                   with the original color object, such as an alpha value.
   */
  _convertColorToString: function _convertColorToString(color, additonalValue) {
    var str = color.type + '(' + parseInt(color.values[0]) + ',' + parseInt(color.values[1]) + ',' + parseInt(color.values[2]);

    if (additonalValue !== undefined) {
      str += ',' + additonalValue + ')';
    } else if (color.values.length === 4) {
      str += ',' + color.values[3] + ')';
    } else {
      str += ')';
    }

    return str;
  },

  // Converts a color from hex format to rgb format.
  _convertHexToRGB: function _convertHexToRGB(color) {
    if (color.length === 4) {
      var extendedColor = '#';
      for (var i = 1; i < color.length; i++) {
        extendedColor += color.charAt(i) + color.charAt(i);
      }
      color = extendedColor;
    }

    var values = {
      r: parseInt(color.substr(1, 2), 16),
      g: parseInt(color.substr(3, 2), 16),
      b: parseInt(color.substr(5, 2), 16)
    };

    return 'rgb(' + values.r + ',' + values.g + ',' + values.b + ')';
  },

  // Returns the type and values of a color of any given type.
  _decomposeColor: function _decomposeColor(color) {
    if (color.charAt(0) === '#') {
      return this._decomposeColor(this._convertHexToRGB(color));
    }

    var marker = color.indexOf('(');
    var type = color.substring(0, marker);
    var values = color.substring(marker + 1, color.length - 1).split(',');

    return { type: type, values: values };
  },

  // Set the absolute transparency of a color.
  // Any existing alpha values are overwritten.
  fade: function fade(color, amount) {
    color = this._decomposeColor(color);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    return this._convertColorToString(color, amount);
  },

  // Desaturates rgb and sets opacity to 0.15
  lighten: function lighten(color, amount) {
    color = this._decomposeColor(color);

    if (color.type.indexOf('hsl') > -1) {
      color.values[2] += amount;
      return this._decomposeColor(this._convertColorToString(color));
    } else if (color.type.indexOf('rgb') > -1) {
      for (var i = 0; i < 3; i++) {
        color.values[i] *= 1 + amount;
        if (color.values[i] > 255) color.values[i] = 255;
      }
    }

    if (color.type.indexOf('a') <= -1) color.type += 'a';

    return this._convertColorToString(color, '0.15');
  },

  darken: function darken(color, amount) {
    color = this._decomposeColor(color);

    if (color.type.indexOf('hsl') > -1) {
      color.values[2] += amount;
      return this._decomposeColor(this._convertColorToString(color));
    } else if (color.type.indexOf('rgb') > -1) {
      for (var i = 0; i < 3; i++) {
        color.values[i] *= 1 - amount;
        if (color.values[i] < 0) color.values[i] = 0;
      }
    }

    return this._convertColorToString(color);
  },

  // Calculates the contrast ratio between two colors.
  //
  // Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
  contrastRatio: function contrastRatio(background, foreground) {
    var lumA = this._luminance(background);
    var lumB = this._luminance(foreground);

    if (lumA >= lumB) {
      return ((lumA + 0.05) / (lumB + 0.05)).toFixed(2);
    } else {
      return ((lumB + 0.05) / (lumA + 0.05)).toFixed(2);
    }
  },

  /**
   * Determines how readable a color combination is based on its level.
   * Levels are defined from @LeaVerou:
   * https://github.com/LeaVerou/contrast-ratio/blob/gh-pages/contrast-ratio.js
   */
  contrastRatioLevel: function contrastRatioLevel(background, foreground) {
    var levels = {
      'fail': {
        range: [0, 3],
        color: 'hsl(0, 100%, 40%)'
      },
      'aa-large': {
        range: [3, 4.5],
        color: 'hsl(40, 100%, 45%)'
      },
      'aa': {
        range: [4.5, 7],
        color: 'hsl(80, 60%, 45%)'
      },
      'aaa': {
        range: [7, 22],
        color: 'hsl(95, 60%, 41%)'
      }
    };

    var ratio = this.contrastRatio(background, foreground);

    for (var level in levels) {
      var range = levels[level].range;
      if (ratio >= range[0] && ratio <= range[1]) return level;
    }
  }
};

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__ = __webpack_require__(17);
var Spacing=__WEBPACK_IMPORTED_MODULE_0_material_ui__["Styles"].Spacing;var styles={root:{transition:'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',position:'relative',// minHeight: Spacing.desktopKeylineIncrement * 2,
borderRadius:2,border:'transparent solid 1px'// marginBottom: Spacing.desktopGutter,
},edit:{borderRadius:2,border:'solid 1px '+__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].grey[300].material,backgroundColor:__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].grey[100].material},hover:{backgroundColor:__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].grey[100].material},dropZone:{// backgroundColor: Colors.Colors.grey[100].material,
// borderColor: Colors.Colors.grey[300].material,
// borderStyle: 'solid',
// borderWidth: '1px',
borderStyle:'none',textAlign:'center',padding:Spacing.desktopGutter,width:'auto',height:'auto',cursor:'pointer'},icon:{verticalAlign:'middle',margin:Spacing.desktopGutterMini,width:Spacing.desktopKeylineIncrement+'px',height:Spacing.desktopKeylineIncrement+'px'},iconContainer:{padding:Spacing.desktopGutter},header:{fontSize:'28px',fontWeight:300},moduleContainer:{padding:Spacing.desktopGutterMini,textAlign:'center'},toolbar:{// borderStyle: 'none none solid none',
// borderWidth: 1,
// borderColor: Colors.Colors.grey[300].material,
backgroundColor:__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].grey[200].material},seperator:{borderStyle:'none solid none none',borderWidth:'1px',borderColor:__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].grey[300].material},toolbarGroup:{margin:2,borderRadius:2,borderStyle:'solid',borderWidth:'1px',borderColor:__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].grey[300].material},import:{root:{display:'inline-block',backgroundColor:__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,width:'100%'},input:{width:'100%',background:'transparent',border:'none',outline:'none',padding:'0 '+Spacing.desktopGutterMini/2+'px'}},saving:{position:'absolute',right:Spacing.desktopGutterMini/2,bottom:Spacing.desktopGutterMini/2,height:50,width:50}};/* harmony default export */ __webpack_exports__["a"] = (styles);

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.1';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(372)(module)))

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TagSelector__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TagList__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tag__ = __webpack_require__(387);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__TagSelector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__TagList__["a"]; });
/* unused harmony reexport Tag */


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactCurrentOwner
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {

  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null

};

module.exports = ReactCurrentOwner;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(39)) {
  var LIBRARY = __webpack_require__(125);
  var global = __webpack_require__(24);
  var fails = __webpack_require__(28);
  var $export = __webpack_require__(4);
  var $typed = __webpack_require__(230);
  var $buffer = __webpack_require__(331);
  var ctx = __webpack_require__(76);
  var anInstance = __webpack_require__(131);
  var propertyDesc = __webpack_require__(123);
  var hide = __webpack_require__(59);
  var redefineAll = __webpack_require__(133);
  var toInteger = __webpack_require__(89);
  var toLength = __webpack_require__(41);
  var toIndex = __webpack_require__(493);
  var toAbsoluteIndex = __webpack_require__(127);
  var toPrimitive = __webpack_require__(87);
  var has = __webpack_require__(58);
  var classof = __webpack_require__(182);
  var isObject = __webpack_require__(30);
  var toObject = __webpack_require__(44);
  var isArrayIter = __webpack_require__(322);
  var create = __webpack_require__(128);
  var getPrototypeOf = __webpack_require__(69);
  var gOPN = __webpack_require__(129).f;
  var getIterFn = __webpack_require__(324);
  var uid = __webpack_require__(124);
  var wks = __webpack_require__(35);
  var createArrayMethod = __webpack_require__(91);
  var createArrayIncludes = __webpack_require__(221);
  var speciesConstructor = __webpack_require__(228);
  var ArrayIterators = __webpack_require__(327);
  var Iterators = __webpack_require__(159);
  var $iterDetect = __webpack_require__(225);
  var setSpecies = __webpack_require__(130);
  var arrayFill = __webpack_require__(326);
  var arrayCopyWithin = __webpack_require__(483);
  var $DP = __webpack_require__(40);
  var $GOPD = __webpack_require__(68);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(488);
var $export = __webpack_require__(4);
var shared = __webpack_require__(220)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(491))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var StylePropable = __webpack_require__(10);
var Colors = __webpack_require__(53);
var Children = __webpack_require__(244);
var Events = __webpack_require__(137);
var KeyCode = __webpack_require__(79);
var FocusRipple = __webpack_require__(245);
var TouchRipple = __webpack_require__(351);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var styleInjected = false;
var listening = false;
var tabPressed = false;

function injectStyle() {
  if (!styleInjected) {
    // Remove inner padding and border in Firefox 4+.
    var style = document.createElement("style");
    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';

    document.body.appendChild(style);
    styleInjected = true;
  }
}

function listenForTabPresses() {
  if (!listening) {
    Events.on(window, 'keydown', function (e) {
      tabPressed = e.keyCode === KeyCode.TAB;
    });
    listening = true;
  }
}

var EnhancedButton = React.createClass({
  displayName: 'EnhancedButton',

  mixins: [PureRenderMixin, StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    centerRipple: React.PropTypes.bool,
    containerElement: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
    disabled: React.PropTypes.bool,
    disableFocusRipple: React.PropTypes.bool,
    disableKeyboardFocus: React.PropTypes.bool,
    disableTouchRipple: React.PropTypes.bool,
    keyboardFocused: React.PropTypes.bool,
    linkButton: React.PropTypes.bool,
    focusRippleColor: React.PropTypes.string,
    touchRippleColor: React.PropTypes.string,
    focusRippleOpacity: React.PropTypes.number,
    touchRippleOpacity: React.PropTypes.number,
    onBlur: React.PropTypes.func,
    onFocus: React.PropTypes.func,
    onKeyboardFocus: React.PropTypes.func,
    onKeyDown: React.PropTypes.func,
    onKeyUp: React.PropTypes.func,
    onTouchTap: React.PropTypes.func,
    tabIndex: React.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      containerElement: 'button',
      onBlur: function onBlur() {},
      onFocus: function onFocus() {},
      onKeyboardFocus: function onKeyboardFocus() {},
      onKeyDown: function onKeyDown() {},
      onKeyUp: function onKeyUp() {},
      onTouchTap: function onTouchTap() {},
      tabIndex: 0,
      type: 'button'
    };
  },

  getInitialState: function getInitialState() {
    return {
      isKeyboardFocused: !this.props.disabled && this.props.keyboardFocused && !this.props.disableKeyboardFocus,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });

    if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
      this.setState({ isKeyboardFocused: false });
      if (nextProps.onKeyboardFocus) {
        nextProps.onKeyboardFocus(null, false);
      }
    }
  },

  componentDidMount: function componentDidMount() {
    injectStyle();
    listenForTabPresses();
  },

  render: function render() {
    var _props = this.props;
    var centerRipple = _props.centerRipple;
    var children = _props.children;
    var containerElement = _props.containerElement;
    var disabled = _props.disabled;
    var disableFocusRipple = _props.disableFocusRipple;
    var disableKeyboardFocus = _props.disableKeyboardFocus;
    var disableTouchRipple = _props.disableTouchRipple;
    var focusRippleColor = _props.focusRippleColor;
    var focusRippleOpacity = _props.focusRippleOpacity;
    var linkButton = _props.linkButton;
    var touchRippleColor = _props.touchRippleColor;
    var touchRippleOpacity = _props.touchRippleOpacity;
    var onBlur = _props.onBlur;
    var onFocus = _props.onFocus;
    var onKeyUp = _props.onKeyUp;
    var onKeyDown = _props.onKeyDown;
    var onTouchTap = _props.onTouchTap;
    var style = _props.style;
    var tabIndex = _props.tabIndex;
    var type = _props.type;

    var other = _objectWithoutProperties(_props, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'linkButton', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onFocus', 'onKeyUp', 'onKeyDown', 'onTouchTap', 'style', 'tabIndex', 'type']);

    var mergedStyles = this.prepareStyles({
      border: 10,
      background: 'none',
      boxSizing: 'border-box',
      display: 'inline-block',
      font: 'inherit',
      fontFamily: this.state.muiTheme.rawTheme.fontFamily,
      tapHighlightColor: Colors.transparent,
      appearance: linkButton ? null : 'button',
      cursor: disabled ? 'default' : 'pointer',
      textDecoration: 'none',
      outline: 'none'
    }, style);

    if (disabled && linkButton) {
      return React.createElement(
        'span',
        _extends({}, other, {
          style: mergedStyles }),
        children
      );
    }

    var buttonProps = _extends({}, other, {
      style: mergedStyles,
      disabled: disabled,
      onBlur: this._handleBlur,
      onFocus: this._handleFocus,
      onTouchTap: this._handleTouchTap,
      onKeyUp: this._handleKeyUp,
      onKeyDown: this._handleKeyDown,
      tabIndex: tabIndex,
      type: type
    });
    var buttonChildren = this._createButtonChildren();

    return React.isValidElement(containerElement) ? React.cloneElement(containerElement, buttonProps, buttonChildren) : React.createElement(linkButton ? 'a' : containerElement, buttonProps, buttonChildren);
  },

  isKeyboardFocused: function isKeyboardFocused() {
    return this.state.isKeyboardFocused;
  },

  removeKeyboardFocus: function removeKeyboardFocus(e) {
    if (this.state.isKeyboardFocused) {
      this.setState({ isKeyboardFocused: false });
      this.props.onKeyboardFocus(e, false);
    }
  },

  setKeyboardFocus: function setKeyboardFocus(e) {
    if (!this.state.isKeyboardFocused) {
      this.setState({ isKeyboardFocused: true });
      this.props.onKeyboardFocus(e, true);
    }
  },

  _cancelFocusTimeout: function _cancelFocusTimeout() {
    if (this._focusTimeout) {
      clearTimeout(this._focusTimeout);
      this._focusTimeout = null;
    }
  },

  _createButtonChildren: function _createButtonChildren() {
    var _props2 = this.props;
    var centerRipple = _props2.centerRipple;
    var children = _props2.children;
    var disabled = _props2.disabled;
    var disableFocusRipple = _props2.disableFocusRipple;
    var disableKeyboardFocus = _props2.disableKeyboardFocus;
    var disableTouchRipple = _props2.disableTouchRipple;
    var focusRippleColor = _props2.focusRippleColor;
    var focusRippleOpacity = _props2.focusRippleOpacity;
    var touchRippleColor = _props2.touchRippleColor;
    var touchRippleOpacity = _props2.touchRippleOpacity;
    var isKeyboardFocused = this.state.isKeyboardFocused;

    //Focus Ripple
    var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? React.createElement(FocusRipple, {
      color: focusRippleColor,
      opacity: focusRippleOpacity,
      show: isKeyboardFocused
    }) : undefined;

    //Touch Ripple
    var touchRipple = !disabled && !disableTouchRipple ? React.createElement(
      TouchRipple,
      {
        centerRipple: centerRipple,
        color: touchRippleColor,
        opacity: touchRippleOpacity },
      children
    ) : undefined;

    return Children.create({
      focusRipple: focusRipple,
      touchRipple: touchRipple,
      children: touchRipple ? undefined : children
    });
  },

  _handleKeyDown: function _handleKeyDown(e) {
    if (!this.props.disabled && !this.props.disableKeyboardFocus) {
      if (e.keyCode === KeyCode.ENTER && this.state.isKeyboardFocused) {
        this._handleTouchTap(e);
      }
    }
    this.props.onKeyDown(e);
  },

  _handleKeyUp: function _handleKeyUp(e) {
    if (!this.props.disabled && e.keyCode === KeyCode.SPACE && this.state.isKeyboardFocused) {
      this._handleTouchTap(e);
    }
    this.props.onKeyUp(e);
  },

  _handleBlur: function _handleBlur(e) {
    this._cancelFocusTimeout();
    this.removeKeyboardFocus(e);
    this.props.onBlur(e);
  },

  _handleFocus: function _handleFocus(e) {
    var _this = this;

    if (!this.props.disabled && !this.props.disableKeyboardFocus) {
      //setTimeout is needed because the focus event fires first
      //Wait so that we can capture if this was a keyboard focus
      //or touch focus
      this._focusTimeout = setTimeout(function () {
        if (tabPressed) {
          _this.setKeyboardFocus(e);
        }
      }, 150);

      this.props.onFocus(e);
    }
  },

  _handleTouchTap: function _handleTouchTap(e) {
    this._cancelFocusTimeout();
    if (!this.props.disabled) {
      tabPressed = false;
      this.removeKeyboardFocus(e);
      this.props.onTouchTap(e);
    }
  }

});

module.exports = EnhancedButton;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Events = __webpack_require__(137);

module.exports = {

  componentDidMount: function componentDidMount() {
    var listeners = this.windowListeners;

    for (var eventName in listeners) {
      var callbackName = listeners[eventName];
      Events.on(window, eventName, this[callbackName]);
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    var listeners = this.windowListeners;

    for (var eventName in listeners) {
      var callbackName = listeners[eventName];
      Events.off(window, eventName, this[callbackName]);
    }
  }

};

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FlexBox__ = __webpack_require__(1958);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FlexBox__["a"]; });


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(553);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule PooledClass
 */



var invariant = __webpack_require__(20);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4, a5);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4, a5);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances (optional).
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler,
  fiveArgumentPooler: fiveArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(124)('meta');
var isObject = __webpack_require__(30);
var has = __webpack_require__(58);
var setDesc = __webpack_require__(40).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(28)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(35)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(59)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var AppActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['expandAppBar','collapseAppBar','toggleAppBar','hideAppBar','showSearchBar','hideSearchBar','setTitle','search','switchToAppMenu','switchToStudentMenu','genericError','translatableMessage','notify','toggleToc','showReportBugDialog','hideReportBugDialog','reportBug']);/* harmony default export */ __webpack_exports__["a"] = (AppActions);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(111);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path);

  var pathname = _parsePath.pathname;
  var search = _parsePath.search;
  var hash = _parsePath.hash;


  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path);

  var pathname = _parsePath2.pathname;
  var search = _parsePath2.search;
  var hash = _parsePath2.hash;


  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path);

  var search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename;
  var pathname = location.pathname;
  var search = location.search;
  var hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lib_CSSPropertyOperations__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lib_CSSPropertyOperations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_lib_CSSPropertyOperations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isDescendant=function isDescendant(parent,child){var node=child.parentNode;while(node!==null){if(node===parent){return true;}node=node.parentNode;}return false;};var css={dialog:'_bG',tooltip:'_bH',menu:'_bI'};var Portal=function(_Component){_inherits(Portal,_Component);function Portal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Portal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Portal.__proto__||Object.getPrototypeOf(Portal)).call.apply(_ref,[this].concat(args))),_this),_this.node=null,_this.handleClickAway=function(event){var onClickAway=_this.props.onClickAway;if(!isDescendant(_this.node,event.target)){onClickAway();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Portal,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,onMount=_props.onMount,onClickAway=_props.onClickAway;this.node=document.createElement('div');__WEBPACK_IMPORTED_MODULE_1_react_lib_CSSPropertyOperations___default.a.setValueForStyles(this.node,this.props.style);document.body.appendChild(this.node);this.renderPortal(this.props);onMount&&onMount(this.node);if(onClickAway){document.body.addEventListener('mousedown',this.handleClickAway);document.body.addEventListener('touchstart',this.handleClickAway);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.renderPortal(nextProps);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!__WEBPACK_IMPORTED_MODULE_2_shallowequal___default()(this.props,nextProps);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var onClickAway=this.props.onClickAway;this.closePortal();if(onClickAway){document.body.removeEventListener('mousedown',this.handleClickAway);document.body.removeEventListener('touchstart',this.handleClickAway);}}},{key:'closePortal',value:function closePortal(){if(this.node){Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["unmountComponentAtNode"])(this.node);document.body.removeChild(this.node);}this.node=null;}},{key:'renderPortal',value:function renderPortal(props){var _classNames;var children=props.children,style=props.style,className=props.className,dialog=props.dialog,tooltip=props.tooltip,menu=props.menu,other=_objectWithoutProperties(props,['children','style','className','dialog','tooltip','menu']);__WEBPACK_IMPORTED_MODULE_1_react_lib_CSSPropertyOperations___default.a.setValueForStyles(this.node,style);this.node.className=__WEBPACK_IMPORTED_MODULE_4_classnames___default()(className,(_classNames={},_defineProperty(_classNames,css.dialog,dialog),_defineProperty(_classNames,css.tooltip,tooltip),_defineProperty(_classNames,css.menu,menu),_classNames));if(children&&children.length>0){__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.unstable_renderSubtreeIntoContainer(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',other,children),this.node);}else if(children){__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.unstable_renderSubtreeIntoContainer(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children),this.node);}}},{key:'render',value:function render(){return null;}}]);return Portal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Portal.displayName='Portal';Portal.propTypes={style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,onClickAway:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onMount:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,dialog:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,tooltip:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,menu:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 114 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={root:{display:'inline-block',verticalAlign:' middle'}};var CircularProgress=function(_Component){_inherits(CircularProgress,_Component);function CircularProgress(){_classCallCheck(this,CircularProgress);return _possibleConstructorReturn(this,(CircularProgress.__proto__||Object.getPrototypeOf(CircularProgress)).apply(this,arguments));}_createClass(CircularProgress,[{key:'getPoint',value:function getPoint(r,degree){var size=this.props.size*Spacing.desktopKeylineIncrement-24;var d=degree/180*Math.PI;return{x:r*Math.sin(d)+size/2,y:this.props.trackWidth/2+r*(1-Math.cos(d))};}},{key:'render',value:function render(){var size=this.props.size*Spacing.desktopKeylineIncrement-24;var progress=this.props.progress;var r=size/2-this.props.trackWidth/2;var startDegree=this.props.startDegree;var endDegree=startDegree+progress*360/100;var s=this.getPoint(r,this.props.startDegree);var e=this.getPoint(r,endDegree);if(progress>100){progress=0;}else if(progress<0){progress=0;}var progressPath=null;if(progress<50){progressPath='M '+s.x+' '+s.y+' A '+r+' '+r+', 0, 0, 1, '+e.x+','+e.y;}else{var m=this.getPoint(r,startDegree+180);progressPath='M '+s.x+' '+s.y+' A '+r+' '+r+', 0, 0, 1, '+m.x+','+m.y+'\n        M '+m.x+' '+m.y+' A '+r+' '+r+', 0, 0, 1, '+e.x+','+e.y;}var progressStyle={strokeWidth:this.props.progressWidth,stroke:this.props.progressColor,fill:'none'};var trackStyle={fill:this.props.fillColor,stroke:this.props.trackColor,strokeWidth:this.props.trackWidth};var text=void 0;if(this.props.progress>0){text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:size/2,y:size/2,fontSize:size/3,fill:this.props.progressColor,textAnchor:'middle',style:{alignmentBaseline:'middle'}},Math.round(progress));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({style:styles.root},this.props,{width:size,height:size,viewBox:'0 0 '+size+' '+size}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:size/2,cy:size/2,r:r,style:trackStyle}),progress>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:progressPath,style:progressStyle}):null,progress>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:s.x,cy:s.y,r:this.props.cornersWidth,fill:this.props.progressColor}):null,progress>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:e.x,cy:e.y,r:this.props.cornersWidth,fill:this.props.progressColor}):null,text,this.props.children);}}]);return CircularProgress;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CircularProgress.displayName='ProgressLabel';CircularProgress.propTypes={size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,startDegree:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,endDegree:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,progressWidth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,trackWidth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,cornersWidth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,progress:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,fillColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,trackColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,progressColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};CircularProgress.defaultProps={fillColor:'transparent',trackColor:'rgba(255, 255, 255, 0.125)',progressColor:__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,startDegree:0,progress:0,progressWidth:4,trackWidth:3.9,cornersWidth:2,size:1};/* harmony default export */ __webpack_exports__["a"] = (CircularProgress);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={root:{padding:Spacing.desktopGutterMini,borderWidth:'1px',transition:'all 1.5s ease'},progress:{margin:Spacing.desktopGutterMini+'px 0'},incomplete:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__["a" /* Colors */].grey[200].material},correct:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__["a" /* Colors */].green[100].material},upload:{button:{marginLeft:Spacing.desktopGutterMini},input:{position:'absolute',left:0,right:0,bottom:0,top:0,opacity:0}},buttonContainer:{marginTop:Spacing.desktopGutterMini,marginBottom:Spacing.desktopGutterMini},incorrect:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__["a" /* Colors */].red[100].material},task:{margin:Spacing.desktopGutterLess},choices:{margin:'0 '+Spacing.desktopGutterLess+'px '+Spacing.desktopGutter+'px '+Spacing.desktopGutterLess+'px'},container:{},uncorrected:{display:'inline-block',background:'white',marginRight:5,marginBottom:0,padding:'0px 3px',borderRadius:5},question:{padding:Spacing.desktopGutterMini,boxSizing:'border-box',fontWeight:500,fontSize:'18px',minHeight:Spacing.desktopSubheaderHeight},answer:{controls:{padding:Spacing.desktopGutterMini},button:{marginRight:Spacing.desktopGutterMini},correct:{margin:Spacing.desktopGutterMini/2},feedback:{margin:Spacing.desktopGutterMini/2},incorrect:{margin:Spacing.desktopGutterMini/2},root:{whiteSpace:'pre-line',// lineHeight: '32px',
boxSizing:'border-box',borderStyle:'none none solid none',borderColor:__WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__["b" /* Text */].Dark.divider,borderWidth:1,position:'relative',padding:Spacing.desktopGutterMini+'px '+(Spacing.iconSize+2*Spacing.desktopGutterMini)+'px',minHeight:Spacing.desktopSubheaderHeight},leftIcon:{position:'absolute',left:Spacing.desktopGutterMini,top:'50%',marginTop:-16},rightIcon:{position:'absolute',right:Spacing.desktopGutterMini,top:'50%',marginTop:-16}},radio:{verticalAlign:'middle',position:'absolute',left:Spacing.desktopGutterMini,top:0,padding:Spacing.desktopGutterMini/2,width:Spacing.iconSize+Spacing.desktopGutterMini,height:Spacing.iconSize+Spacing.desktopGutterMini},label:{lineHeight:'32px',fontWeight:300,position:'relative',padding:'0 '+Spacing.desktopGutterMini+'px 0 '+(Spacing.iconSize+Spacing.desktopGutterMini*3)+'px'},results:{padding:'0 '+Spacing.desktopGutterLess+'px '+Spacing.desktopGutter+'px '+Spacing.desktopGutterLess+'px'},noResults:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__["a" /* Colors */].red[100].material,padding:Spacing.desktopGutter,fontSize:'18px',textAlign:'center'},makeSelection:{backgroundColor:__WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__["a" /* Colors */].grey[100].material,padding:Spacing.desktopGutter,fontSize:'18px',textAlign:'center'}};/* harmony default export */ __webpack_exports__["a"] = (styles);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_MediaQuery__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SearchBarToolbar__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_Notification__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_Message__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var css={listWrapper:'_eH'};var styles={markRead:{margin:'10px',marginBottom:0,display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}};var ListDetail=function(_Component){_inherits(ListDetail,_Component);function ListDetail(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ListDetail);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ListDetail.__proto__||Object.getPrototypeOf(ListDetail)).call.apply(_ref,[this].concat(args))),_this),_this.state={// maxItems: this.props.initialItemCount,
searchEnabled:false,media:__WEBPACK_IMPORTED_MODULE_3_services_MediaQuery__["a" /* default */].detect(),deleted:{},selected:{}},_this.onSearchTextChange=function(searchText){if(searchText!==_this.state.searchText){_this.setState({searchText:searchText});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ListDetail,[{key:'getStyle',/**
   * Returns the fitting style for the whole object
   *
   * @param  {boolean} hasDetail Is the detail panel enabled?
   *
   * @return {object}            Style object
   */value:function getStyle(){var style={position:'relative',height:'100%'};// backgroundColor: this.context.muiTheme.rawTheme.palette.primary1Color
return style;}/**
   * Returns the fitting style for the detail object
   *
   * @param  {boolean} hasDetail Is the detail panel enabled?
   *
   * @return {object}            Style object
   */},{key:'getDetailStyle',value:function getDetailStyle(hasDetail,hasFloatingActionButton){var left=8;var right=8;if(this.context.media==='desktop'){left=Spacing.desktopKeylineIncrement*7;right=hasFloatingActionButton&&Spacing.desktopKeylineIncrement*2||Spacing.desktopGutter;}else if(this.context.media==='tablet'){left=Spacing.desktopKeylineIncrement*6;right=hasFloatingActionButton&&Spacing.desktopKeylineIncrement*2||Spacing.desktopGutter;}var backgroundColor=this.props.detailBackground||this.context.muiTheme.cardColor;return{position:'absolute',left:left,right:right,top:0,bottom:0,backgroundColor:backgroundColor,overflow:'auto',transition:'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'};// transform: 'translate3d(0,0,0)'
}/**
   * Returns the fitting style for the toolbar object
   *
   * @param  {boolean} hasDetail Is the detail panel enabled?
   *
   * @return {object}            Style object
   */},{key:'getToolbarStyle',value:function getToolbarStyle(hasDetail){var style={backgroundColor:this.context.muiTheme.primary1Color,borderStyle:'none none solid none',borderWidth:'1px',borderColor:'#DDD'};if(hasDetail){if(this.context.media==='desktop'){style.width=Spacing.desktopKeylineIncrement*7;}else if(this.context.media==='tablet'){style.width=Spacing.desktopKeylineIncrement*6;}}return style;}/**
   * Returns the fitting style for the list object
   *
   * @param  {boolean} hasDetail Is the detail panel enabled?
   *
   * @return {object}            Style object
   */},{key:'getListStyle',value:function getListStyle(){var hasDetail=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var style={boxSizing:'border-box',position:'relative',height:'100%'};if(hasDetail){if(this.context.media==='desktop'){style.width=Spacing.desktopKeylineIncrement*7;}else if(this.context.media==='tablet'){style.width=Spacing.desktopKeylineIncrement*6;}}return style;}},{key:'getSearchHeaderStyle',value:function getSearchHeaderStyle(){var style={backgroundColor:this.context.muiTheme.rawTheme.palette.primary1Color};return style;}},{key:'getSearchBarStyle',value:function getSearchBarStyle(){var hasDetail=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var hasFloatingActionButton=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var style={boxSizing:'border-box'};if(hasDetail){if(this.context.media==='desktop'){style.width=Spacing.desktopKeylineIncrement*7;}else if(this.context.media==='tablet'){style.width=Spacing.desktopKeylineIncrement*6;}}else if(hasFloatingActionButton&&this.context.media!=='phone'){style.marginRight=Spacing.desktopKeylineIncrement*1.5;style.marginLeft=Spacing.desktopKeylineIncrement*1.5;}return style;}/**
   * Callback function used when no custom filter is supplied for this ListDetail.
   * Will resort to just checking for the searchText
   *
   * @param {object}  item             Object to check
   * @param {string}  searchText       Piece of text that needs to be contained in the label to pass the filter
   * @param {string}  labelProperty    What property of the item is used as it's label
   *
   * @return {boolean}                 True if the label of the object contains searchText, false otherwise
   */// filter(item, searchText, labelProperty, emailProperty) {
//   if (searchText && searchText !== '') {
//     return (
//       item[labelProperty].search(searchText) > -1 ||
//       item[emailProperty].search(searchText) > -1
//     );
//   } else {
//     return true;
//   }
// }
},{key:'filter',value:function filter(item,searchText,labelProperty){if(searchText&&searchText!==''){return item[labelProperty].search(searchText)>-1;}else{return true;}}/**
   * Gets called whenever the user taps or clicks a list item
   *
   * @param  {object} item Item that was represented in the 'touched' list item
   * @param  {[type]} e    Javascript event
   */},{key:'onTouchTapItem',value:function onTouchTapItem(item,e){if(this.props.onTouchTapItem){this.props.onTouchTapItem(item,e);}this.setState({selected:item});}/**
   * Gets called by the scroll container whenever the list was scrolled all the way to the bottom.
   * This is used to dynamically popuplate the list with more items upon reaching the bottom
   */// onScrollToBottom() {
//   this.setState({
//     maxItems: this.state.maxItems + 10
//   });
// }
/**
   * [dropDownChange description]
   * @param  {[type]} e             [description]
   * @param  {[type]} selectedIndex [description]
   * @param  {[type]} menuItem      [description]
   * @return {[type]}               [description]
   */},{key:'dropDownChange',value:function dropDownChange(e,selectedIndex,menuItem){if(this.props.onFilterChange){this.props.onFilterChange(menuItem);}}/**
   * Gets called upon user enabling the search bar
   */},{key:'enableSearch',value:function enableSearch(){this.setState({searchEnabled:true});}/**
   * Gets called upon user disab ling the search bar
   */},{key:'disableSearch',value:function disableSearch(){this.setState({searchEnabled:false});}},{key:'getFloatingActionButtonStyle',value:function getFloatingActionButtonStyle(){var style=void 0,componentTheme=this.context.muiTheme;if(this.context.media==='phone'){style={position:'fixed',right:Spacing.desktopGutter,bottom:Spacing.desktopGutter,zIndex:3};}else{style={position:'fixed',right:Spacing.desktopKeylineIncrement/2,top:componentTheme.toolbar.height*2-componentTheme.floatingActionButton.buttonSize/2,zIndex:3};if(this.state.searchEnabled){style.top=style.top+componentTheme.floatingActionButton.buttonSize;}}return style;}},{key:'getItemStyle',value:function getItemStyle(){var style={};return style;}},{key:'markAllRead',value:function markAllRead(){var items=this.props.items;items.forEach(function(item){__WEBPACK_IMPORTED_MODULE_7_actions_Notification__["a" /* default */].markRead([item.id],1);});__WEBPACK_IMPORTED_MODULE_8_services_Message__["a" /* default */].info(this.context.getIntlMessage('notification.removed'));}},{key:'render',value:function render(){var _props=this.props,loading=_props.loading,filterBar=_props.filterBar,containerStyle=_props.containerStyle,pagination=_props.pagination;var children=[],list=void 0,detail=void 0,currentLetter=void 0,lastLetter=void 0,filterDropDown=void 0,markReadAllButton=void 0,floatingActionButton=void 0,hasDivider=this.props.hasDivider,searchText=this.state.searchText,regexp='',items=this.props.items||[];var filter=this.props.filter||this.filter,labelProperty=this.props.labelProperty,idProperty=this.props.idProperty,emailProperty=this.props.emailProperty;if(searchText&&searchText!==''){try{regexp=new RegExp(searchText,'i');}catch(e){regexp=new RegExp();}}items=items.filter(function(item){return filter(item,regexp,labelProperty,emailProperty);});// .splice(0, this.state.maxItems);
for(var i=0;i<items.length;i++){var item=items[i],_currentLetter=void 0,label=void 0,id=item[idProperty],leftAvatar=void 0;if(this.state.deleted[id]){continue;}if(hasDivider){_currentLetter=item[labelProperty]&&item[labelProperty][0].toUpperCase()||'';if(lastLetter!==_currentLetter){leftAvatar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Avatar"],null,_currentLetter);lastLetter=_currentLetter;}}if(this.props.formatLabel){label=this.props.formatLabel(item);}else{label=item[labelProperty];}if(this.props.listItemGenerator){children.push(this.props.listItemGenerator(item,leftAvatar,hasDivider));}else if(this.props.dangerouslySetInnerHTML){var primaryText=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:label}});children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListItem"],{leftAvatar:leftAvatar,insetChildren:hasDivider,key:'i-'+id,onTouchTap:this.onTouchTapItem.bind(this,item),primaryText:primaryText}));}else{var style=this.getItemStyle();if(this.state.selected&&item[idProperty]===this.state.selected[idProperty]){style.backgroundColor=__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].grey[300].material;//style.color = this.context.muiTheme.rawTheme.palette.primary3TextColor;
}children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListItem"],{style:style,leftAvatar:leftAvatar,insetChildren:hasDivider,key:'i-'+id,onTouchTap:this.onTouchTapItem.bind(this,item),primaryText:label}));}if(this.props.divider){children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListDivider"],{inset:hasDivider,key:'d-'+id}));}}var hasDetail=this.props.children;floatingActionButton=this.props.floatingActionButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.floatingActionButton,{style:this.getFloatingActionButtonStyle(hasDetail)});if(hasDetail){detail=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Paper"],{style:this.getDetailStyle(hasDetail,floatingActionButton),zDepth:1},this.props.children);}if(this.props.filterOptions){filterDropDown=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["DropDownMenu"],{onChange:this.dropDownChange.bind(this),menuItems:this.props.filterOptions});}if(this.props.types&&this.props.types[-1]&&this.props.filtering.payload=='all'&&this.props.items.length!=0){markReadAllButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('notification.readAll'),onTouchTap:this.markAllRead.bind(this)});}else{markReadAllButton=null;}list=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.listWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["List"],null,this.props.listHeader,loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_Loader__["b" /* default */],null),children));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getStyle(hasDetail)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getSearchHeaderStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getSearchBarStyle(hasDetail,!!floatingActionButton)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_SearchBarToolbar__["a" /* default */],{fullWidth:true,onChange:this.onSearchTextChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.markRead},filterDropDown,pagination,markReadAllButton),!loading&&filterBar,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getListStyle(hasDetail)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ScrollableContainer__["a" /* default */],{containerStyle:Object.assign({},containerStyle,{backgroundColor:this.context.muiTheme.canvasColor})// onScrollToBottom={this.onScrollToBottom.bind(this)}
},list)),floatingActionButton,detail);}}]);return ListDetail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ListDetail.propTypes={hasDivider:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,labelProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,idProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,emailProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,onTouchTapItem:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,searchText:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,initialItemCount:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,filterChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,listItemGenerator:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,loading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,divider:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};ListDetail.defaultProps={divider:true,searchText:null,labelProperty:'name',idProperty:'id',emailProperty:'email',initialItemCount:25,hasDivider:true,items:[],swipeEnabled:true,dangerouslySetInnerHTML:false};ListDetail.contextTypes={router:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (ListDetail);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_j9',leftAlign:'_j_'};var FormFieldContainer=function(_Component){_inherits(FormFieldContainer,_Component);function FormFieldContainer(){_classCallCheck(this,FormFieldContainer);return _possibleConstructorReturn(this,(FormFieldContainer.__proto__||Object.getPrototypeOf(FormFieldContainer)).apply(this,arguments));}_createClass(FormFieldContainer,[{key:'render',value:function render(){var _props=this.props,children=_props.children,title=_props.title,leftAlign=_props.leftAlign;var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.root,_defineProperty({},css.leftAlign,leftAlign));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,title),children);}}]);return FormFieldContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FormFieldContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,leftAlign:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (FormFieldContainer);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactReconciler
 */



var ReactRef = __webpack_require__(680);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {string} rootID DOM ID of the root node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, rootID, transaction, context) {
    var markup = internalInstance.mountComponent(rootID, transaction, context);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    return markup;
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance) {
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent();
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction) {
    internalInstance.performUpdateIfNecessary(transaction);
  }

};

module.exports = ReactReconciler;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticEvent
 * @typechecks static-only
 */



var PooledClass = __webpack_require__(107);

var assign = __webpack_require__(29);
var emptyFunction = __webpack_require__(57);
var warning = __webpack_require__(33);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 */
function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  this.dispatchConfig = dispatchConfig;
  this.dispatchMarker = dispatchMarker;
  this.nativeEvent = nativeEvent;
  this.target = nativeEventTarget;
  this.currentTarget = nativeEventTarget;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      this[propName] = nativeEvent[propName];
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
}

assign(SyntheticEvent.prototype, {

  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
    }
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
    }
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else {
      event.cancelBubble = true;
    }
    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      this[propName] = null;
    }
    this.dispatchConfig = null;
    this.dispatchMarker = null;
    this.nativeEvent = null;
  }

});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var prototype = Object.create(Super.prototype);
  assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loglevel__ = __webpack_require__(736);
/* unused harmony reexport LogLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__severity__ = __webpack_require__(737);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__severity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__span__ = __webpack_require__(738);
/* unused harmony reexport SpanStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__status__ = __webpack_require__(739);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__status__["a"]; });




//# sourceMappingURL=index.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 124 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(469);
var enumBugKeys = __webpack_require__(309);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(89);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(22);
var dPs = __webpack_require__(470);
var enumBugKeys = __webpack_require__(309);
var IE_PROTO = __webpack_require__(308)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(306)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(310).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(469);
var hiddenKeys = __webpack_require__(309).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(24);
var dP = __webpack_require__(40);
var DESCRIPTORS = __webpack_require__(39);
var SPECIES = __webpack_require__(35)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(76);
var call = __webpack_require__(481);
var isArrayIter = __webpack_require__(322);
var anObject = __webpack_require__(22);
var toLength = __webpack_require__(41);
var getIterFn = __webpack_require__(324);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(60);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(92),
    maker = __webpack_require__(503).instanceJoinCreator;

/**
 * Extract child listenables from a parent from their
 * children property and return them in a keyed Object
 *
 * @param {Object} listenable The parent listenable
 */
var mapChildListenables = function mapChildListenables(listenable) {
    var i = 0,
        children = {},
        childName;
    for (; i < (listenable.children || []).length; ++i) {
        childName = listenable.children[i];
        if (listenable[childName]) {
            children[childName] = listenable[childName];
        }
    }
    return children;
};

/**
 * Make a flat dictionary of all listenables including their
 * possible children (recursively), concatenating names in camelCase.
 *
 * @param {Object} listenables The top-level listenables
 */
var flattenListenables = function flattenListenables(listenables) {
    var flattened = {};
    for (var key in listenables) {
        var listenable = listenables[key];
        var childMap = mapChildListenables(listenable);

        // recursively flatten children
        var children = flattenListenables(childMap);

        // add the primary listenable and chilren
        flattened[key] = listenable;
        for (var childKey in children) {
            var childListenable = children[childKey];
            flattened[key + _.capitalize(childKey)] = childListenable;
        }
    }

    return flattened;
};

/**
 * A module of methods related to listening.
 */
module.exports = {

    /**
     * An internal utility function used by `validateListening`
     *
     * @param {Action|Store} listenable The listenable we want to search for
     * @returns {Boolean} The result of a recursive search among `this.subscriptions`
     */
    hasListener: function hasListener(listenable) {
        var i = 0,
            j,
            listener,
            listenables;
        for (; i < (this.subscriptions || []).length; ++i) {
            listenables = [].concat(this.subscriptions[i].listenable);
            for (j = 0; j < listenables.length; j++) {
                listener = listenables[j];
                if (listener === listenable || listener.hasListener && listener.hasListener(listenable)) {
                    return true;
                }
            }
        }
        return false;
    },

    /**
     * A convenience method that listens to all listenables in the given object.
     *
     * @param {Object} listenables An object of listenables. Keys will be used as callback method names.
     */
    listenToMany: function listenToMany(listenables) {
        var allListenables = flattenListenables(listenables);
        for (var key in allListenables) {
            var cbname = _.callbackName(key),
                localname = this[cbname] ? cbname : this[key] ? key : undefined;
            if (localname) {
                this.listenTo(allListenables[key], localname, this[cbname + "Default"] || this[localname + "Default"] || localname);
            }
        }
    },

    /**
     * Checks if the current context can listen to the supplied listenable
     *
     * @param {Action|Store} listenable An Action or Store that should be
     *  listened to.
     * @returns {String|Undefined} An error message, or undefined if there was no problem.
     */
    validateListening: function validateListening(listenable) {
        if (listenable === this) {
            return "Listener is not able to listen to itself";
        }
        if (!_.isFunction(listenable.listen)) {
            return listenable + " is missing a listen method";
        }
        if (listenable.hasListener && listenable.hasListener(this)) {
            return "Listener cannot listen to this listenable because of circular loop";
        }
    },

    /**
     * Sets up a subscription to the given listenable for the context object
     *
     * @param {Action|Store} listenable An Action or Store that should be
     *  listened to.
     * @param {Function|String} callback The callback to register as event handler
     * @param {Function|String} defaultCallback The callback to register as default handler
     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is the object being listened to
     */
    listenTo: function listenTo(listenable, callback, defaultCallback) {
        var desub,
            unsubscriber,
            subscriptionobj,
            subs = this.subscriptions = this.subscriptions || [];
        _.throwIf(this.validateListening(listenable));
        this.fetchInitialState(listenable, defaultCallback);
        desub = listenable.listen(this[callback] || callback, this);
        unsubscriber = function () {
            var index = subs.indexOf(subscriptionobj);
            _.throwIf(index === -1, "Tried to remove listen already gone from subscriptions list!");
            subs.splice(index, 1);
            desub();
        };
        subscriptionobj = {
            stop: unsubscriber,
            listenable: listenable
        };
        subs.push(subscriptionobj);
        return subscriptionobj;
    },

    /**
     * Stops listening to a single listenable
     *
     * @param {Action|Store} listenable The action or store we no longer want to listen to
     * @returns {Boolean} True if a subscription was found and removed, otherwise false.
     */
    stopListeningTo: function stopListeningTo(listenable) {
        var sub,
            i = 0,
            subs = this.subscriptions || [];
        for (; i < subs.length; i++) {
            sub = subs[i];
            if (sub.listenable === listenable) {
                sub.stop();
                _.throwIf(subs.indexOf(sub) !== -1, "Failed to remove listen from subscriptions list!");
                return true;
            }
        }
        return false;
    },

    /**
     * Stops all subscriptions and empties subscriptions array
     */
    stopListeningToAll: function stopListeningToAll() {
        var remaining,
            subs = this.subscriptions || [];
        while (remaining = subs.length) {
            subs[0].stop();
            _.throwIf(subs.length !== remaining - 1, "Failed to remove listen from subscriptions list!");
        }
    },

    /**
     * Used in `listenTo`. Fetches initial data from a publisher if it has a `getInitialState` method.
     * @param {Action|Store} listenable The publisher we want to get initial state from
     * @param {Function|String} defaultCallback The method to receive the data
     */
    fetchInitialState: function fetchInitialState(listenable, defaultCallback) {
        defaultCallback = defaultCallback && this[defaultCallback] || defaultCallback;
        var me = this;
        if (_.isFunction(defaultCallback) && _.isFunction(listenable.getInitialState)) {
            var data = listenable.getInitialState();
            if (data && _.isFunction(data.then)) {
                data.then(function () {
                    defaultCallback.apply(me, arguments);
                });
            } else {
                defaultCallback.call(this, data);
            }
        }
    },

    /**
     * The callback will be called once all listenables have triggered at least once.
     * It will be invoked with the last emission from each listenable.
     * @param {...Publishers} publishers Publishers that should be tracked.
     * @param {Function|String} callback The method to call when all publishers have emitted
     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
     */
    joinTrailing: maker("last"),

    /**
     * The callback will be called once all listenables have triggered at least once.
     * It will be invoked with the first emission from each listenable.
     * @param {...Publishers} publishers Publishers that should be tracked.
     * @param {Function|String} callback The method to call when all publishers have emitted
     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
     */
    joinLeading: maker("first"),

    /**
     * The callback will be called once all listenables have triggered at least once.
     * It will be invoked with all emission from each listenable.
     * @param {...Publishers} publishers Publishers that should be tracked.
     * @param {Function|String} callback The method to call when all publishers have emitted
     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
     */
    joinConcat: maker("all"),

    /**
     * The callback will be called once all listenables have triggered.
     * If a callback triggers twice before that happens, an error is thrown.
     * @param {...Publishers} publishers Publishers that should be tracked.
     * @param {Function|String} callback The method to call when all publishers have emitted
     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
     */
    joinStrict: maker("strict")
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var Colors = __webpack_require__(53);

var Typography = function Typography() {
  _classCallCheck(this, Typography);

  // text colors
  this.textFullBlack = Colors.fullBlack;
  this.textDarkBlack = Colors.darkBlack;
  this.textLightBlack = Colors.lightBlack;
  this.textMinBlack = Colors.minBlack;
  this.textFullWhite = Colors.fullWhite;
  this.textDarkWhite = Colors.darkWhite;
  this.textLightWhite = Colors.lightWhite;

  // font weight
  this.fontWeightLight = 300;
  this.fontWeightNormal = 400;
  this.fontWeightMedium = 500;

  this.fontStyleButtonFontSize = 14;
};

module.exports = new Typography();

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var shallowEqual = __webpack_require__(1013);

function relevantContextKeysEqual(classObject, currentContext, nextContext) {

  //Get those keys from current object's context that we care
  //about and check whether those keys have changed or not
  if (classObject.getRelevantContextKeys) {
    var currentContextKeys = classObject.getRelevantContextKeys(currentContext);
    var nextContextKeys = classObject.getRelevantContextKeys(nextContext);

    if (!shallowEqual(currentContextKeys, nextContextKeys)) {
      return false;
    }
  }

  //Check if children context keys changed
  if (classObject.getChildrenClasses) {
    var childrenArray = classObject.getChildrenClasses();
    for (var i = 0; i < childrenArray.length; i++) {
      if (!relevantContextKeysEqual(childrenArray[i], currentContext, nextContext)) {
        return false;
      }
    }
  }

  //context keys are equal
  return true;
}

module.exports = {

  //Don't update if state, prop, and context are equal
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState, nextContext) {

    //If either the props or state have changed, component should update
    if (!shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState)) {
      return true;
    }

    //If current theme and next theme are both undefined, do not update
    if (!this.context.muiTheme && !nextContext.muiTheme) {
      return false;
    }

    //If both themes exist, compare keys only if current theme is not static
    if (this.context.muiTheme && nextContext.muiTheme) {
      return !this.context.muiTheme['static'] && !relevantContextKeysEqual(this.constructor, this.context.muiTheme, nextContext.muiTheme);
    }

    //At this point it is guaranteed that exactly one theme is undefined so simply update
    return true;
  }

};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  once: function once(el, type, callback) {
    var typeArray = type ? type.split(' ') : [];
    var recursiveFunction = function recursiveFunction(e) {
      e.target.removeEventListener(e.type, recursiveFunction);
      return callback(e);
    };

    for (var i = typeArray.length - 1; i >= 0; i--) {
      this.on(el, typeArray[i], recursiveFunction);
    }
  },

  on: function on(el, type, callback) {
    if (el.addEventListener) {
      el.addEventListener(type, callback);
    } else {
      // IE8+ Support
      el.attachEvent('on' + type, function () {
        callback.call(el);
      });
    }
  },

  off: function off(el, type, callback) {
    if (el.removeEventListener) {
      el.removeEventListener(type, callback);
    } else {
      // IE8+ Support
      el.detachEvent('on' + type, callback);
    }
  },

  isKeyboard: function isKeyboard(e) {
    return ['keydown', 'keypress', 'keyup'].indexOf(e.type) !== -1;
  }
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  addDays: function addDays(d, days) {
    var newDate = this.clone(d);
    newDate.setDate(d.getDate() + days);
    return newDate;
  },

  addMonths: function addMonths(d, months) {
    var newDate = this.clone(d);
    newDate.setMonth(d.getMonth() + months);
    return newDate;
  },

  addYears: function addYears(d, years) {
    var newDate = this.clone(d);
    newDate.setFullYear(d.getFullYear() + years);
    return newDate;
  },

  clone: function clone(d) {
    return new Date(d.getTime());
  },

  cloneAsDate: function cloneAsDate(d) {
    var clonedDate = this.clone(d);
    clonedDate.setHours(0, 0, 0, 0);
    return clonedDate;
  },

  getDaysInMonth: function getDaysInMonth(d) {
    var resultDate = this.getFirstDayOfMonth(d);

    resultDate.setMonth(resultDate.getMonth() + 1);
    resultDate.setDate(resultDate.getDate() - 1);

    return resultDate.getDate();
  },

  getFirstDayOfMonth: function getFirstDayOfMonth(d) {
    return new Date(d.getFullYear(), d.getMonth(), 1);
  },

  getFullMonth: function getFullMonth(d) {
    var month = d.getMonth();
    switch (month) {
      case 0:
        return 'January';
      case 1:
        return 'February';
      case 2:
        return 'March';
      case 3:
        return 'April';
      case 4:
        return 'May';
      case 5:
        return 'June';
      case 6:
        return 'July';
      case 7:
        return 'August';
      case 8:
        return 'September';
      case 9:
        return 'October';
      case 10:
        return 'November';
      case 11:
        return 'December';
    }
  },

  getShortMonth: function getShortMonth(d) {
    var month = d.getMonth();
    switch (month) {
      case 0:
        return 'Jan';
      case 1:
        return 'Feb';
      case 2:
        return 'Mar';
      case 3:
        return 'Apr';
      case 4:
        return 'May';
      case 5:
        return 'Jun';
      case 6:
        return 'Jul';
      case 7:
        return 'Aug';
      case 8:
        return 'Sep';
      case 9:
        return 'Oct';
      case 10:
        return 'Nov';
      case 11:
        return 'Dec';
    }
  },

  getDayOfWeek: function getDayOfWeek(d) {
    var dow = d.getDay();
    switch (dow) {
      case 0:
        return 'Sun';
      case 1:
        return 'Mon';
      case 2:
        return 'Tue';
      case 3:
        return 'Wed';
      case 4:
        return 'Thu';
      case 5:
        return 'Fri';
      case 6:
        return 'Sat';
    }
  },

  getWeekArray: function getWeekArray(d) {
    var dayArray = [];
    var daysInMonth = this.getDaysInMonth(d);
    var daysInWeek = undefined;
    var emptyDays = undefined;
    var firstDayOfWeek = undefined;
    var week = undefined;
    var weekArray = [];

    for (var i = 1; i <= daysInMonth; i++) {
      dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
    }

    while (dayArray.length) {
      firstDayOfWeek = dayArray[0].getDay();
      daysInWeek = 7 - firstDayOfWeek;
      emptyDays = 7 - daysInWeek;
      week = dayArray.splice(0, daysInWeek);

      for (var i = 0; i < emptyDays; i++) {
        week.unshift(null);
      }

      weekArray.push(week);
    }

    return weekArray;
  },

  format: function format(date) {
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var y = date.getFullYear();
    return m + '/' + d + '/' + y;
  },

  isEqualDate: function isEqualDate(d1, d2) {
    return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
  },

  isBeforeDate: function isBeforeDate(d1, d2) {
    var date1 = this.cloneAsDate(d1);
    var date2 = this.cloneAsDate(d2);

    return date1.getTime() < date2.getTime();
  },

  isAfterDate: function isAfterDate(d1, d2) {
    var date1 = this.cloneAsDate(d1);
    var date2 = this.cloneAsDate(d2);

    return date1.getTime() > date2.getTime();
  },

  isBetweenDates: function isBetweenDates(dateToCheck, startDate, endDate) {
    return !this.isBeforeDate(dateToCheck, startDate) && !this.isAfterDate(dateToCheck, endDate);
  },

  isDateObject: function isDateObject(d) {
    return d instanceof Date;
  },

  monthDiff: function monthDiff(d1, d2) {
    var m = undefined;
    m = (d1.getFullYear() - d2.getFullYear()) * 12;
    m += d1.getMonth();
    m -= d2.getMonth();
    return m;
  },

  yearDiff: function yearDiff(d1, d2) {
    return ~ ~(this.monthDiff(d1, d2) / 12);
  }

};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1992),
    getValue = __webpack_require__(1997);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ResponsiveImage__ = __webpack_require__(198);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_3_material_ui__["Styles"].Spacing;var iconSize=Spacing.desktopKeylineIncrement*1.5;var styles={iconContainer:{position:'absolute',left:0,right:0,top:0,bottom:0,textAlign:'center'}};var Cover=function(_Component){_inherits(Cover,_Component);function Cover(){_classCallCheck(this,Cover);return _possibleConstructorReturn(this,(Cover.__proto__||Object.getPrototypeOf(Cover)).apply(this,arguments));}_createClass(Cover,[{key:'getIconStyle',value:function getIconStyle(imageHeight){return Object.assign({},styles.iconContainer,{padding:(imageHeight-iconSize)/2});}},{key:'render',value:function render(){var _props=this.props,backgroundColor=_props.backgroundColor,height=_props.height,image=_props.image,children=_props.children,defaultIcon=_props.defaultIcon,noImage=_props.noImage,imageOpacity=_props.imageOpacity,style=_props.style,other=_objectWithoutProperties(_props,['backgroundColor','height','image','children','defaultIcon','noImage','imageOpacity','style']);var coverStyle=void 0;var icon=void 0;if(image){coverStyle=Object.assign({position:'relative',display:'block',height:height,opacity:this.props.opacity},style);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ResponsiveImage__["a" /* default */],Object.assign({key:image,style:coverStyle,src:image,opacity:imageOpacity},other),icon,children);}coverStyle=Object.assign({position:'relative',boxSizing:'border-box',height:height},style);if(backgroundColor){coverStyle.backgroundColor=backgroundColor;}var Icon=__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__[defaultIcon];if(!noImage&&!image){icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getIconStyle(height)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{color:__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].grey[700].material,style:{width:iconSize,height:iconSize}}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({style:coverStyle},other),icon,children);}}]);return Cover;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Cover.propTypes={opacity:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,imageOpacity:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,height:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,defaultIcon:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,backgroundColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};Cover.defaultProps={defaultIcon:'ImageImage',backgroundColor:__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material,height:246,opacity:1,imageOpacity:1,noImage:false};/* harmony default export */ __webpack_exports__["a"] = (Cover);

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint esnext:true */

// TODO: Use `import React from "react";` when external modules are supported.

var src$react$$ = __webpack_require__(142), intl$messageformat$$ = __webpack_require__(262), intl$relativeformat$$ = __webpack_require__(379), intl$format$cache$$ = __webpack_require__(576);

// -----------------------------------------------------------------------------

var typesSpec = {
    locales: src$react$$["default"].PropTypes.oneOfType([
        src$react$$["default"].PropTypes.string,
        src$react$$["default"].PropTypes.array
    ]),

    formats : src$react$$["default"].PropTypes.object,
    messages: src$react$$["default"].PropTypes.object
};

function assertIsDate(date, errMsg) {
    // Determine if the `date` is valid by checking if it is finite, which is
    // the same way that `Intl.DateTimeFormat#format()` checks.
    if (!isFinite(date)) {
        throw new TypeError(errMsg);
    }
}

exports["default"] = {
    statics: {
        filterFormatOptions: function (obj, defaults) {
            if (!defaults) { defaults = {}; }

            return (this.formatOptions || []).reduce(function (opts, name) {
                if (obj.hasOwnProperty(name)) {
                    opts[name] = obj[name];
                } else if (defaults.hasOwnProperty(name)) {
                    opts[name] = defaults[name];
                }

                return opts;
            }, {});
        }
    },

    propTypes        : typesSpec,
    contextTypes     : typesSpec,
    childContextTypes: typesSpec,

    getNumberFormat  : intl$format$cache$$["default"](Intl.NumberFormat),
    getDateTimeFormat: intl$format$cache$$["default"](Intl.DateTimeFormat),
    getMessageFormat : intl$format$cache$$["default"](intl$messageformat$$["default"]),
    getRelativeFormat: intl$format$cache$$["default"](intl$relativeformat$$["default"]),

    getChildContext: function () {
        var context = this.context;
        var props   = this.props;

        return {
            locales:  props.locales  || context.locales,
            formats:  props.formats  || context.formats,
            messages: props.messages || context.messages
        };
    },

    formatDate: function (date, options) {
        date = new Date(date);
        assertIsDate(date, 'A date or timestamp must be provided to formatDate()');
        return this._format('date', date, options);
    },

    formatTime: function (date, options) {
        date = new Date(date);
        assertIsDate(date, 'A date or timestamp must be provided to formatTime()');
        return this._format('time', date, options);
    },

    formatRelative: function (date, options, formatOptions) {
        date = new Date(date);
        assertIsDate(date, 'A date or timestamp must be provided to formatRelative()');
        return this._format('relative', date, options, formatOptions);
    },

    formatNumber: function (num, options) {
        return this._format('number', num, options);
    },

    formatMessage: function (message, values) {
        var locales = this.props.locales || this.context.locales;
        var formats = this.props.formats || this.context.formats;

        // When `message` is a function, assume it's an IntlMessageFormat
        // instance's `format()` method passed by reference, and call it. This
        // is possible because its `this` will be pre-bound to the instance.
        if (typeof message === 'function') {
            return message(values);
        }

        if (typeof message === 'string') {
            message = this.getMessageFormat(message, locales, formats);
        }

        return message.format(values);
    },

    getIntlMessage: function (path) {
        var messages  = this.props.messages || this.context.messages;
        var pathParts = path.split('.');

        var message;

        try {
            message = pathParts.reduce(function (obj, pathPart) {
                return obj[pathPart];
            }, messages);
        } finally {
            if (message === undefined) {
                throw new ReferenceError('Could not find Intl message: ' + path);
            }
        }

        return message;
    },

    getNamedFormat: function (type, name) {
        var formats = this.props.formats || this.context.formats;
        var format  = null;

        try {
            format = formats[type][name];
        } finally {
            if (!format) {
                throw new ReferenceError(
                    'No ' + type + ' format named: ' + name
                );
            }
        }

        return format;
    },

    _format: function (type, value, options, formatOptions) {
        var locales = this.props.locales || this.context.locales;

        if (options && typeof options === 'string') {
            options = this.getNamedFormat(type, options);
        }

        switch(type) {
            case 'date':
            case 'time':
                return this.getDateTimeFormat(locales, options).format(value);
            case 'number':
                return this.getNumberFormat(locales, options).format(value);
            case 'relative':
                return this.getRelativeFormat(locales, options).format(value, formatOptions);
            default:
                throw new Error('Unrecognized format type: ' + type);
        }
    }
};

//# sourceMappingURL=mixin.js.map

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global React */
/* jshint esnext:true */

// TODO: Remove the global `React` binding lookup once the ES6 Module Transpiler
// supports external modules. This is a hack for now that provides the local
// modules a referece to React.

exports["default"] = React;

//# sourceMappingURL=react.js.map

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_attr_accept__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_attr_accept__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_App__ = __webpack_require__(110);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Dropzone=function(_Component){_inherits(Dropzone,_Component);function Dropzone(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Dropzone);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Dropzone.__proto__||Object.getPrototypeOf(Dropzone)).call.apply(_ref,[this].concat(args))),_this),_this.state={isDragActive:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dropzone,[{key:'componentDidMount',value:function componentDidMount(){this.enterCounter=0;}},{key:'onDragLeave',value:function onDragLeave(e){e.preventDefault();// Only deactivate once the dropzone and all children was left.
if(--this.enterCounter>0){return;}this.setState({isDragActive:false,isDragReject:false});if(this.props.onDragLeave){this.props.onDragLeave.call(this,e);}}},{key:'allFilesAccepted',value:function allFilesAccepted(files){var _this2=this;return files.every(function(file){return __WEBPACK_IMPORTED_MODULE_2_attr_accept___default()(file,_this2.props.accept);});}},{key:'onDragOver',value:function onDragOver(e){e.preventDefault();e.stopPropagation();return false;}},{key:'onDragEnter',value:function onDragEnter(e){e.preventDefault();e.dataTransfer.dropEffect='copy';++this.enterCounter;// This is tricky. During the drag even the dataTransfer.files is null
// But Chrome implements some drag store, which is accesible via dataTransfer.items
var dataTransferItems=e.dataTransfer&&e.dataTransfer.items?e.dataTransfer.items:[];// Now we need to convert the DataTransferList to Array
var allFilesAccepted=this.allFilesAccepted(Array.prototype.slice.call(dataTransferItems));this.setState({isDragActive:allFilesAccepted,isDragReject:!allFilesAccepted});if(this.props.onDragEnter){this.props.onDragEnter.call(this,e);}}},{key:'handleFile',value:function handleFile(files){var _this3=this;if(files.length<1){return;}var current=files.pop();if(current){var fileType=current.type;var encoded=fileType.indexOf('audio')===0||fileType.indexOf('video')===0;SteelCompass.upload([current],{encoded:encoded,progress:function progress(event){if(_this3.props.onProgress&&event){_this3.props.onProgress(Object.assign({},event,{remaining:files.length}));}},error:function error(res){if(res&&res.errMsg){__WEBPACK_IMPORTED_MODULE_5_actions_App__["a" /* default */].notify(res.errMsg);}if(files.length>0){_this3.handleFile(files);}},success:function success(response){if(response&&response.data&&_this3.props.onSuccess){_this3.props.onSuccess(response.data);}if(files.length>0){_this3.handleFile(files);}}});}}},{key:'onChange',value:function onChange(e){this.processFiles(e.target.files);}},{key:'processFiles',value:function processFiles(files){var fileList=Object.keys(files).map(function(key){return files[key];});var willBeUploaded=fileList.filter(function(file){return file.size<__WEBPACK_IMPORTED_MODULE_4_Constants__["maxFileSize"];});var willBeDropped=fileList.filter(function(file){return file.size>=__WEBPACK_IMPORTED_MODULE_4_Constants__["maxFileSize"];});if(willBeDropped.length>0){if(willBeDropped.length>1){__WEBPACK_IMPORTED_MODULE_5_actions_App__["a" /* default */].notify(willBeDropped.length+' files are too big.');}else{__WEBPACK_IMPORTED_MODULE_5_actions_App__["a" /* default */].notify(willBeDropped.length+' file is too big.');}}if(willBeUploaded.length>0){this.handleFile(willBeUploaded);}}},{key:'onDrop',value:function onDrop(e){e.preventDefault();if(!!this.state.isDragReject){return;}this.setState({isDragActive:false});var files=void 0;if(e.dataTransfer){files=e.dataTransfer.files;}else if(e.target){files=e.target.files;}var maxFiles=this.props.multiple?files.length:1;for(var i=0;i<maxFiles;i++){files[i].preview=URL.createObjectURL(files[i]);}files=Array.prototype.slice.call(files,0,maxFiles);this.processFiles(files);}},{key:'onClick',value:function onClick(){if(this.props.supportClick===true){this.open();}}},{key:'open',value:function open(){var fileInput=Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.refs.fileInput);fileInput.value=null;fileInput.click();}},{key:'render',value:function render(){var className=this.props.className||'dropzone';// if (this.state.isDragActive) {
//   className += ' active';
// }
var style=Object.assign({},{cursor:'pointer',width:this.props.width||100,height:this.props.height||100,lineHeight:this.props.lineHeight&&this.props.lineHeight+'px'||'24px',backgroundColor:this.state.isDragActive?__WEBPACK_IMPORTED_MODULE_3_components_Material_Styles_Colors__["a" /* Colors */].yellow[50].material:null},this.props.style);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className,style:style,onDragLeave:this.onDragLeave.bind(this),onDragOver:this.onDragOver.bind(this),onDragEnter:this.onDragEnter.bind(this),onDrop:this.onDrop.bind(this)},this.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{display:'none'},type:'file',multiple:this.props.multiple,ref:'fileInput',onChange:this.onChange.bind(this),accept:this.props.accept}));}}]);return Dropzone;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Dropzone.defaultProps={supportClick:true,multiple:true};Dropzone.propTypes={onProgress:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onSuccess:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,width:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string]),height:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,lineHeight:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,supportClick:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,accept:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,multiple:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var css={audio:'_dy'};var IframeEmbedder=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({displayName:'IframeEmbedder',propTypes:{url:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string.isRequired,id:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.oneOfType([__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.number]),urlSuffix:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,type:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.oneOf(['audio','video'])},getDefaultProps:function getDefaultProps(){return{type:'video',urlSuffix:''};},render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'iframe-'+this.props.type+'-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{className:this.props.className,src:this.props.url+this.props.id+this.props.urlSuffix,allowTransparency:true,frameBorder:0,scrolling:'no',webkitAllowFullScreen:true,mozAllowFullScreen:true,allowFullScreen:true,oAllowFullScreen:true,msAllowFullScreen:true}));}});var YouTube=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({displayName:'YouTube',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IframeEmbedder,{url:__WEBPACK_IMPORTED_MODULE_1_Util__["b" /* Media */].baseUrls[1],id:this.props.id});}});var Vimeo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({displayName:'Vimeo',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IframeEmbedder,{url:__WEBPACK_IMPORTED_MODULE_1_Util__["b" /* Media */].baseUrls[2],id:this.props.id});}});var Wistia=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({displayName:'Wistia',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IframeEmbedder,{url:__WEBPACK_IMPORTED_MODULE_1_Util__["b" /* Media */].baseUrls[5],id:this.props.id});}});var SoundCloud=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({displayName:'SoundCloud',render:function render(){if(this.props.type&&this.props.type=='track'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IframeEmbedder,{type:'audio',className:css.audio,url:__WEBPACK_IMPORTED_MODULE_1_Util__["b" /* Media */].baseUrls[3],id:this.props.id});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:this.props.id}});}}});var Spotify=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({displayName:'Spotify',// test id = 193781466
render:function render(){var _props=this.props,id=_props.id,user=_props.user,type=_props.type;var url=user?'user:'+user+':'+type+':'+id:id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IframeEmbedder,{url:__WEBPACK_IMPORTED_MODULE_1_Util__["b" /* Media */].baseUrls[4],id:url});}});var Youku=function(_React$Component){_inherits(Youku,_React$Component);function Youku(){_classCallCheck(this,Youku);return _possibleConstructorReturn(this,(Youku.__proto__||Object.getPrototypeOf(Youku)).apply(this,arguments));}_createClass(Youku,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IframeEmbedder,{url:__WEBPACK_IMPORTED_MODULE_1_Util__["b" /* Media */].baseUrls[6],id:this.props.id,allowFullScreen:true});}}]);return Youku;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var providers={1:YouTube,2:Vimeo,3:SoundCloud,4:Spotify,5:Wistia,6:Youku};var Embed=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({displayName:'Embed',shouldComponentUpdate:function shouldComponentUpdate(nextProps){return JSON.stringify(nextProps)!==JSON.stringify(this.props);},render:function render(){var Provider=providers[this.props.params?this.props.params.provider:this.props.provider];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Provider&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Provider,this.props.params?this.props.params:this.props)));}});/* harmony default export */ __webpack_exports__["a"] = (Embed);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_bJ',header:'_bK',footer:'_bL',container:'_bM',padded:'_bN'};var ScrollableContainer=function(_Component){_inherits(ScrollableContainer,_Component);function ScrollableContainer(){_classCallCheck(this,ScrollableContainer);return _possibleConstructorReturn(this,(ScrollableContainer.__proto__||Object.getPrototypeOf(ScrollableContainer)).apply(this,arguments));}_createClass(ScrollableContainer,[{key:'render',value:function render(){var _props=this.props,padded=_props.padded,header=_props.header,footer=_props.footer,className=_props.className,children=_props.children,color=_props.color,backgroundColor=_props.backgroundColor,other=_objectWithoutProperties(_props,['padded','header','footer','className','children','color','backgroundColor']);var style=backgroundColor||color?{backgroundColor:backgroundColor,color:color}:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(className,css.root),style:style},other),header&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.container,_defineProperty({},css.padded,padded))},children),footer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.footer},footer));}}]);return ScrollableContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ScrollableContainer.propTypes={header:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,footer:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,padded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,backgroundColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (ScrollableContainer);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function defaultEqualityCheck(a, b) {
  return a === b;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];

  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
      return equalityCheck(value, lastArgs[index]);
    })) {
      lastResult = func.apply(undefined, args);
    }
    lastArgs = args;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    memoizeOptions[_key2 - 1] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      funcs[_key3] = arguments[_key3];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      return resultFunc.apply(undefined, arguments);
    }].concat(memoizeOptions));

    var selector = function selector(state, props) {
      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      var params = dependencies.map(function (dependency) {
        return dependency.apply(undefined, [state, props].concat(args));
      });
      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
    };

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      values[_key5] = arguments[_key5];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CountdownTimer=function(_Component){_inherits(CountdownTimer,_Component);function CountdownTimer(){_classCallCheck(this,CountdownTimer);var _this=_possibleConstructorReturn(this,(CountdownTimer.__proto__||Object.getPrototypeOf(CountdownTimer)).apply(this,arguments));_this.seconds=0;_this.radius=null;_this.fraction=0;_this.content=0;_this.canvas=0;return _this;}_createClass(CountdownTimer,[{key:'componentDidMount',value:function componentDidMount(){this.seconds=this.props.seconds;this.setupTimer();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.seconds=nextProps.seconds;this.setupTimer();}},{key:'setupTimer',value:function setupTimer(){this.setScale();this.setupCanvas();this.drawTimer();this.startTimer();}},{key:'setScale',value:function setScale(){this.radius=this.props.size/2;this.fraction=2/this.seconds;this.tickPeriod=this.seconds*1.8;}},{key:'setupCanvas',value:function setupCanvas(){this.canvas=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);this.ctx=this.canvas.getContext('2d');this.ctx.textAlign='center';this.ctx.textBaseline='middle';this.ctx.font='bold '+this.radius/2+'px Arial';}},{key:'updateCanvas',value:function updateCanvas(){this.clearTimer();this.drawTimer();}},{key:'startTimer',value:function startTimer(){var _this2=this;setTimeout(function(){_this2.tick();},200);}},{key:'tick',value:function tick(){var _this3=this;var start=Date.now();setTimeout(function(){var duration=(Date.now()-start)/1000;_this3.seconds-=duration;if(_this3.seconds<=0){_this3.seconds=0;_this3.handleComplete();_this3.clearTimer();}else{_this3.updateCanvas();_this3.tick();}},this.tickPeriod);}},{key:'handleComplete',value:function handleComplete(){if(this.props.onComplete){this.props.onComplete();}}},{key:'clearTimer',value:function clearTimer(){this.ctx.clearRect(0,0,this.canvas.width,this.canvas.height);this.drawBackground();}},{key:'drawBackground',value:function drawBackground(){this.ctx.beginPath();this.ctx.globalAlpha=this.props.alpha/3;this.ctx.arc(this.radius,this.radius,this.radius,0,Math.PI*2,false);this.ctx.arc(this.radius,this.radius,this.radius/1.1,Math.PI*2,0,true);this.ctx.fill();}},{key:'drawTimer',value:function drawTimer(){var percent=this.fraction*this.seconds+1.5;this.ctx.globalAlpha=this.props.alpha;this.ctx.fillStyle=this.props.color;this.ctx.fillText(this.seconds.toFixed(2),this.radius,this.radius);this.ctx.beginPath();this.ctx.arc(this.radius,this.radius,this.radius,Math.PI*1.5,Math.PI*percent,false);this.ctx.arc(this.radius,this.radius,this.radius/1.1,Math.PI*percent,Math.PI*1.5,true);this.ctx.fill();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{ref:'canvas',className:'react-countdown-clock',width:this.props.size,height:this.props.size});}}]);return CountdownTimer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CountdownTimer.displayName='CountdownTimer';CountdownTimer.propTypes={seconds:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,alpha:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,onComplete:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};CountdownTimer.defaultProps={size:300,color:'#000',alpha:1};/* harmony default export */ __webpack_exports__["a"] = (CountdownTimer);

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    getPrototype = __webpack_require__(2233),
    isObjectLike = __webpack_require__(166);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spinner=function(_Component){_inherits(Spinner,_Component);function Spinner(){_classCallCheck(this,Spinner);return _possibleConstructorReturn(this,(Spinner.__proto__||Object.getPrototypeOf(Spinner)).apply(this,arguments));}_createClass(Spinner,[{key:'render',value:function render(){var size=this.props.size,strokeWidth=this.props.strokeWidth,strokeMiterlimit=this.props.strokeMiterlimit,radius=size-strokeWidth,classes=void 0;classes=__WEBPACK_IMPORTED_MODULE_1_classnames___default()('spinner',{inline:this.props.inline});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'circular',style:{width:size*2,height:size*2}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'path',cx:size,cy:size,r:radius,fill:'none',strokeWidth:strokeWidth,strokeMiterlimit:strokeMiterlimit})));}}]);return Spinner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Spinner.propTypes={size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,strokeWidth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,strokeMiterlimit:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,inline:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};Spinner.defaultProps={size:24,strokeWidth:2,strokeMiterlimit:10,inline:false};/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMProperty
 * @typechecks static-only
 */



var invariant = __webpack_require__(20);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_ATTRIBUTE: 0x1,
  MUST_USE_PROPERTY: 0x2,
  HAS_SIDE_EFFECTS: 0x4,
  HAS_BOOLEAN_VALUE: 0x8,
  HAS_NUMERIC_VALUE: 0x10,
  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };

      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ?  false ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};
var defaultValueCache = {};

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {

  ID_ATTRIBUTE_NAME: 'data-reactid',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseAttribute:
   *   Whether the property must be accessed and mutated using `*Attribute()`.
   *   (This includes anything that fails `<propName> in <element>`.)
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasSideEffects:
   *   Whether or not setting a value causes side effects such as triggering
   *   resources to be loaded or text selection changes. If true, we read from
   *   the DOM before updating to ensure that the value is only set if it has
   *   changed.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   * @type {Object}
   */
  getPossibleStandardName:  false ? {} : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  /**
   * Returns the default property value for a DOM property (i.e., not an
   * attribute). Most default values are '' or false, but not all. Worse yet,
   * some (in particular, `type`) vary depending on the type of element.
   *
   * TODO: Is it better to grab all the possible properties when creating an
   * element to avoid having to create the same element twice?
   */
  getDefaultValueForProperty: function (nodeName, prop) {
    var nodeDefaults = defaultValueCache[nodeName];
    var testElement;
    if (!nodeDefaults) {
      defaultValueCache[nodeName] = nodeDefaults = {};
    }
    if (!(prop in nodeDefaults)) {
      testElement = document.createElement(nodeName);
      nodeDefaults[prop] = testElement[prop];
    }
    return nodeDefaults[prop];
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginHub
 */



var EventPluginRegistry = __webpack_require__(423);
var EventPluginUtils = __webpack_require__(424);
var ReactErrorUtils = __webpack_require__(425);

var accumulateInto = __webpack_require__(426);
var forEachAccumulated = __webpack_require__(427);
var invariant = __webpack_require__(20);
var warning = __webpack_require__(33);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

/**
 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
 *   hierarchy given ids of the logical DOM elements involved.
 */
var InstanceHandle = null;

function validateInstanceHandle() {
  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
   false ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {

  /**
   * Methods for injecting dependencies.
   */
  injection: {

    /**
     * @param {object} InjectedMount
     * @public
     */
    injectMount: EventPluginUtils.injection.injectMount,

    /**
     * @param {object} InjectedInstanceHandle
     * @public
     */
    injectInstanceHandle: function (InjectedInstanceHandle) {
      InstanceHandle = InjectedInstanceHandle;
      if (false) {
        validateInstanceHandle();
      }
    },

    getInstanceHandle: function () {
      if (false) {
        validateInstanceHandle();
      }
      return InstanceHandle;
    },

    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

  },

  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,

  registrationNameModules: EventPluginRegistry.registrationNameModules,

  /**
   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
   *
   * @param {string} id ID of the DOM element.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {?function} listener The callback to store.
   */
  putListener: function (id, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;

    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[id] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(id, registrationName, listener);
    }
  },

  /**
   * @param {string} id ID of the DOM element.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (id, registrationName) {
    var bankForRegistrationName = listenerBank[registrationName];
    return bankForRegistrationName && bankForRegistrationName[id];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {string} id ID of the DOM element.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (id, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(id, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      delete bankForRegistrationName[id];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {string} id ID of the DOM element.
   */
  deleteAllListeners: function (id) {
    for (var registrationName in listenerBank) {
      if (!listenerBank[registrationName][id]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(id, registrationName);
      }

      delete listenerBank[registrationName][id];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }

};

module.exports = EventPluginHub;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInstanceHandles
 * @typechecks static-only
 */



var ReactRootIndex = __webpack_require__(430);

var invariant = __webpack_require__(20);

var SEPARATOR = '.';
var SEPARATOR_LENGTH = SEPARATOR.length;

/**
 * Maximum depth of traversals before we consider the possibility of a bad ID.
 */
var MAX_TREE_DEPTH = 10000;

/**
 * Creates a DOM ID prefix to use when mounting React components.
 *
 * @param {number} index A unique integer
 * @return {string} React root ID.
 * @internal
 */
function getReactRootIDString(index) {
  return SEPARATOR + index.toString(36);
}

/**
 * Checks if a character in the supplied ID is a separator or the end.
 *
 * @param {string} id A React DOM ID.
 * @param {number} index Index of the character to check.
 * @return {boolean} True if the character is a separator or end of the ID.
 * @private
 */
function isBoundary(id, index) {
  return id.charAt(index) === SEPARATOR || index === id.length;
}

/**
 * Checks if the supplied string is a valid React DOM ID.
 *
 * @param {string} id A React DOM ID, maybe.
 * @return {boolean} True if the string is a valid React DOM ID.
 * @private
 */
function isValidID(id) {
  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
}

/**
 * Checks if the first ID is an ancestor of or equal to the second ID.
 *
 * @param {string} ancestorID
 * @param {string} descendantID
 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
 * @internal
 */
function isAncestorIDOf(ancestorID, descendantID) {
  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
}

/**
 * Gets the parent ID of the supplied React DOM ID, `id`.
 *
 * @param {string} id ID of a component.
 * @return {string} ID of the parent, or an empty string.
 * @private
 */
function getParentID(id) {
  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
}

/**
 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
 * supplied `destinationID`. If they are equal, the ID is returned.
 *
 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
 * @param {string} destinationID ID of the destination node.
 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
 * @private
 */
function getNextDescendantID(ancestorID, destinationID) {
  !(isValidID(ancestorID) && isValidID(destinationID)) ?  false ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
  !isAncestorIDOf(ancestorID, destinationID) ?  false ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
  if (ancestorID === destinationID) {
    return ancestorID;
  }
  // Skip over the ancestor and the immediate separator. Traverse until we hit
  // another separator or we reach the end of `destinationID`.
  var start = ancestorID.length + SEPARATOR_LENGTH;
  var i;
  for (i = start; i < destinationID.length; i++) {
    if (isBoundary(destinationID, i)) {
      break;
    }
  }
  return destinationID.substr(0, i);
}

/**
 * Gets the nearest common ancestor ID of two IDs.
 *
 * Using this ID scheme, the nearest common ancestor ID is the longest common
 * prefix of the two IDs that immediately preceded a "marker" in both strings.
 *
 * @param {string} oneID
 * @param {string} twoID
 * @return {string} Nearest common ancestor ID, or the empty string if none.
 * @private
 */
function getFirstCommonAncestorID(oneID, twoID) {
  var minLength = Math.min(oneID.length, twoID.length);
  if (minLength === 0) {
    return '';
  }
  var lastCommonMarkerIndex = 0;
  // Use `<=` to traverse until the "EOL" of the shorter string.
  for (var i = 0; i <= minLength; i++) {
    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
      lastCommonMarkerIndex = i;
    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
      break;
    }
  }
  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
  !isValidID(longestCommonID) ?  false ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
  return longestCommonID;
}

/**
 * Traverses the parent path between two IDs (either up or down). The IDs must
 * not be the same, and there must exist a parent path between them. If the
 * callback returns `false`, traversal is stopped.
 *
 * @param {?string} start ID at which to start traversal.
 * @param {?string} stop ID at which to end traversal.
 * @param {function} cb Callback to invoke each ID with.
 * @param {*} arg Argument to invoke the callback with.
 * @param {?boolean} skipFirst Whether or not to skip the first node.
 * @param {?boolean} skipLast Whether or not to skip the last node.
 * @private
 */
function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
  start = start || '';
  stop = stop || '';
  !(start !== stop) ?  false ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
  var traverseUp = isAncestorIDOf(stop, start);
  !(traverseUp || isAncestorIDOf(start, stop)) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
  // Traverse from `start` to `stop` one depth at a time.
  var depth = 0;
  var traverse = traverseUp ? getParentID : getNextDescendantID;
  for (var id = start;; /* until break */id = traverse(id, stop)) {
    var ret;
    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
      ret = cb(id, traverseUp, arg);
    }
    if (ret === false || id === stop) {
      // Only break //after// visiting `stop`.
      break;
    }
    !(depth++ < MAX_TREE_DEPTH) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
  }
}

/**
 * Manages the IDs assigned to DOM representations of React components. This
 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
 * order to simulate events).
 *
 * @internal
 */
var ReactInstanceHandles = {

  /**
   * Constructs a React root ID
   * @return {string} A React root ID.
   */
  createReactRootID: function () {
    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
  },

  /**
   * Constructs a React ID by joining a root ID with a name.
   *
   * @param {string} rootID Root ID of a parent component.
   * @param {string} name A component's name (as flattened children).
   * @return {string} A React ID.
   * @internal
   */
  createReactID: function (rootID, name) {
    return rootID + name;
  },

  /**
   * Gets the DOM ID of the React component that is the root of the tree that
   * contains the React component with the supplied DOM ID.
   *
   * @param {string} id DOM ID of a React component.
   * @return {?string} DOM ID of the React component that is the root.
   * @internal
   */
  getReactRootIDFromNodeID: function (id) {
    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
      var index = id.indexOf(SEPARATOR, 1);
      return index > -1 ? id.substr(0, index) : id;
    }
    return null;
  },

  /**
   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
   * should would receive a `mouseEnter` or `mouseLeave` event.
   *
   * NOTE: Does not invoke the callback on the nearest common ancestor because
   * nothing "entered" or "left" that element.
   *
   * @param {string} leaveID ID being left.
   * @param {string} enterID ID being entered.
   * @param {function} cb Callback to invoke on each entered/left ID.
   * @param {*} upArg Argument to invoke the callback with on left IDs.
   * @param {*} downArg Argument to invoke the callback with on entered IDs.
   * @internal
   */
  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
    if (ancestorID !== leaveID) {
      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
    }
    if (ancestorID !== enterID) {
      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
    }
  },

  /**
   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
   *
   * NOTE: This traversal happens on IDs without touching the DOM.
   *
   * @param {string} targetID ID of the target node.
   * @param {function} cb Callback to invoke.
   * @param {*} arg Argument to invoke the callback with.
   * @internal
   */
  traverseTwoPhase: function (targetID, cb, arg) {
    if (targetID) {
      traverseParentPath('', targetID, cb, arg, true, false);
      traverseParentPath(targetID, '', cb, arg, false, true);
    }
  },

  /**
   * Same as `traverseTwoPhase` but skips the `targetID`.
   */
  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
    if (targetID) {
      traverseParentPath('', targetID, cb, arg, true, true);
      traverseParentPath(targetID, '', cb, arg, true, true);
    }
  },

  /**
   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
   * example, passing `.0.$row-0.1` would result in `cb` getting called
   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
   *
   * NOTE: This traversal happens on IDs without touching the DOM.
   *
   * @param {string} targetID ID of the target node.
   * @param {function} cb Callback to invoke.
   * @param {*} arg Argument to invoke the callback with.
   * @internal
   */
  traverseAncestors: function (targetID, cb, arg) {
    traverseParentPath('', targetID, cb, arg, true, false);
  },

  getFirstCommonAncestorID: getFirstCommonAncestorID,

  /**
   * Exposed for unit testing.
   * @private
   */
  _getNextDescendantID: getNextDescendantID,

  isAncestorIDOf: isAncestorIDOf,

  SEPARATOR: SEPARATOR

};

module.exports = ReactInstanceHandles;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPropagators
 */



var EventConstants = __webpack_require__(84);
var EventPluginHub = __webpack_require__(151);

var warning = __webpack_require__(33);

var accumulateInto = __webpack_require__(426);
var forEachAccumulated = __webpack_require__(427);

var PropagationPhases = EventConstants.PropagationPhases;
var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(id, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(id, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(domID, upwards, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
  }
  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
  var listener = listenerAtPhase(domID, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(id, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(id, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event.dispatchMarker, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticUIEvent
 * @typechecks static-only
 */



var SyntheticEvent = __webpack_require__(121);

var getEventTarget = __webpack_require__(292);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target != null && target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = isError;
/* harmony export (immutable) */ __webpack_exports__["e"] = isErrorEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDOMError;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDOMException;
/* harmony export (immutable) */ __webpack_exports__["k"] = isString;
/* harmony export (immutable) */ __webpack_exports__["i"] = isPrimitive;
/* harmony export (immutable) */ __webpack_exports__["h"] = isPlainObject;
/* harmony export (immutable) */ __webpack_exports__["f"] = isEvent;
/* harmony export (immutable) */ __webpack_exports__["c"] = isElement;
/* harmony export (immutable) */ __webpack_exports__["j"] = isRegExp;
/* harmony export (immutable) */ __webpack_exports__["m"] = isThenable;
/* harmony export (immutable) */ __webpack_exports__["l"] = isSyntheticEvent;
/* harmony export (immutable) */ __webpack_exports__["g"] = isInstanceOf;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    // tslint:disable-next-line:strict-type-predicates
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    // tslint:disable-next-line:strict-type-predicates
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // tslint:disable:no-unsafe-any
    return Boolean(wat && wat.then && typeof wat.then === 'function');
    // tslint:enable:no-unsafe-any
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    // tslint:disable-next-line:no-unsafe-any
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        // tslint:disable-next-line:no-unsafe-any
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(40).f;
var has = __webpack_require__(58);
var TAG = __webpack_require__(35)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var defined = __webpack_require__(88);
var fails = __webpack_require__(28);
var spaces = __webpack_require__(312);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(30);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(111);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(112);

var _Actions = __webpack_require__(239);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var update = __webpack_require__(243);

function mergeSingle(objA, objB) {
  if (!objA) return objB;
  if (!objB) return objA;
  return update(objA, { $merge: objB });
}

module.exports = {

  merge: function merge() {
    var args = Array.prototype.slice.call(arguments, 0);
    var base = args[0];

    for (var i = 1; i < args.length; i++) {
      if (args[i]) {
        base = mergeSingle(base, args[i]);
      }
    }
    return base;
  },

  mergeItem: function mergeItem(obj, key, newValueObject) {
    var command = {};
    command[key] = { $merge: newValueObject };
    return update(obj, command);
  },

  push: function push(array, obj) {
    var newObj = Array.isArray(obj) ? obj : [obj];
    return update(array, { $push: newObj });
  },

  shift: function shift(array) {
    return update(array, { $splice: [[0, 1]] });
  }

};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var Events = __webpack_require__(137);
var Dom = __webpack_require__(352);

module.exports = {

  //When the component mounts, listen to click events and check if we need to
  //Call the componentClickAway function.
  componentDidMount: function componentDidMount() {
    if (!this.manuallyBindClickAway) this._bindClickAway();
  },

  componentWillUnmount: function componentWillUnmount() {
    this._unbindClickAway();
  },

  _checkClickAway: function _checkClickAway(event) {
    var el = ReactDOM.findDOMNode(this);

    // Check if the target is inside the current component
    if (event.target !== el && !Dom.isDescendant(el, event.target) && document.documentElement.contains(event.target)) {
      if (this.componentClickAway) this.componentClickAway();
    }
  },

  _bindClickAway: function _bindClickAway() {
    // On touch-enabled devices, both events fire, and the handler is called twice,
    // but it's fine since all operations for which the mixin is used
    // are idempotent.
    Events.on(document, 'mouseup', this._checkClickAway);
    Events.on(document, 'touchend', this._checkClickAway);
  },

  _unbindClickAway: function _unbindClickAway() {
    Events.off(document, 'mouseup', this._checkClickAway);
    Events.off(document, 'touchend', this._checkClickAway);
  }

};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Css = __webpack_require__(46);

var _Css2 = _interopRequireDefault(_Css);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  root: 'cio_fz'
};

var SvgIcon = function (_Component) {
  _inherits(SvgIcon, _Component);

  function SvgIcon() {
    _classCallCheck(this, SvgIcon);

    return _possibleConstructorReturn(this, (SvgIcon.__proto__ || Object.getPrototypeOf(SvgIcon)).apply(this, arguments));
  }

  _createClass(SvgIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          color = _props.color,
          size = _props.size,
          width = _props.width,
          height = _props.height,
          style = _props.style,
          viewPortSize = _props.viewPortSize,
          className = _props.className,
          x = _props.x,
          y = _props.y,
          props = _objectWithoutProperties(_props, ['children', 'color', 'size', 'width', 'height', 'style', 'viewPortSize', 'className', 'x', 'y']);

      return _react2.default.createElement(
        'svg',
        _extends({}, props, {
          className: (0, _classnames2.default)(css.root, className),
          width: width || size,
          style: style,
          height: height || size,
          version: '1.1',
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: viewPortSize ? '0 0 ' + viewPortSize + ' ' + viewPortSize : null
        }),
        children
      );
    }
  }]);

  return SvgIcon;
}(_react.Component);

SvgIcon.propTypes = {
  color: _react.PropTypes.string,
  size: _react.PropTypes.number,
  children: _react.PropTypes.node,
  viewPortSize: _react.PropTypes.number
};
SvgIcon.defaultProps = {
  color: _Css.Cio.Text.secondary,
  size: 24,
  x: 0,
  y: 0
};
exports.default = SvgIcon;
module.exports = exports['default'];

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridContainer__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GridRow__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GridCell__ = __webpack_require__(548);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__GridContainer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__GridRow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__GridCell__["a"]; });


/***/ }),
/* 166 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ozitor__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LinkList__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailPane__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GooglePlus__ = __webpack_require__(2069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FacebookLogo__ = __webpack_require__(2070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TextField__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VideoPlayer__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VideoPreview__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(2072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FileList__ = __webpack_require__(2073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RadialSVGProgressBar__ = __webpack_require__(577);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Ozitor__["a"]; });
/* unused harmony reexport LinkList */
/* unused harmony reexport DetailPane */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__GooglePlus__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__FacebookLogo__["a"]; });
/* unused harmony reexport TextField */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__VideoPlayer__["a"]; });
/* unused harmony reexport Dropdown */
/* unused harmony reexport FileList */
/* unused harmony reexport VideoPreview */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__RadialSVGProgressBar__["a"]; });


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Widgets_FileSelectorContainer__ = __webpack_require__(2123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Overlay__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_3_material_ui__["Styles"].Spacing;var styles={root:{position:'fixed',left:Spacing.desktopGutter*2,right:Spacing.desktopGutter*2,top:Spacing.desktopGutter*2,bottom:Spacing.desktopGutter*2}};var FileSelectorDialog=function(_Component){_inherits(FileSelectorDialog,_Component);function FileSelectorDialog(){_classCallCheck(this,FileSelectorDialog);return _possibleConstructorReturn(this,(FileSelectorDialog.__proto__||Object.getPrototypeOf(FileSelectorDialog)).apply(this,arguments));}_createClass(FileSelectorDialog,[{key:'render',value:function render(){var _props=this.props,onOpen=_props.onOpen,onClose=_props.onClose,open=_props.open,other=_objectWithoutProperties(_props,['onOpen','onClose','open']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Overlay__["a" /* default */],{ref:'overlay',onOpen:onOpen,onClose:onClose,open:open},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Paper"],{rounded:true,style:styles.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Widgets_FileSelectorContainer__["a" /* default */],other)));}}]);return FileSelectorDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FileSelectorDialog.displayName='FileSelectorDialog';/* harmony default export */ __webpack_exports__["a"] = (FileSelectorDialog);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(2133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(595);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(2143);
/* unused harmony reexport IndexLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(2144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(2145);
/* unused harmony reexport IndexRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(2146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(596);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(2147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(118);
/* unused harmony reexport createRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(389);
/* unused harmony reexport RouterContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(391);
/* unused harmony reexport locationShape */
/* unused harmony reexport routerShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(2148);
/* unused harmony reexport match */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(600);
/* unused harmony reexport useRouterHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(171);
/* unused harmony reexport formatPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(2152);
/* unused harmony reexport applyRouterMiddleware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(2153);
/* unused harmony reexport browserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(2154);
/* unused harmony reexport hashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(597);
/* unused harmony reexport createMemoryHistory */
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Material_Spinner__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['totalNumberOfTasks'],['totalNumberOfTasks']),_templateObject2=_taggedTemplateLiteral(['correctAnswers'],['correctAnswers']),_templateObject3=_taggedTemplateLiteral(['pagesViewed'],['pagesViewed']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_3_material_ui__["Styles"].Spacing;var ContentClear=__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ContentClear"],ContentSend=__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ContentSend"],MapsBeenhere=__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["MapsBeenhere"];var SimpleOverview=function(_Component){_inherits(SimpleOverview,_Component);function SimpleOverview(){_classCallCheck(this,SimpleOverview);var _this=_possibleConstructorReturn(this,(SimpleOverview.__proto__||Object.getPrototypeOf(SimpleOverview)).apply(this,arguments));_this.toggleExpand=function(){_this.setState({expanded:!_this.state.expanded});};_this.state={collapsed:false,ifToggled:_this.props.items&&_this.props.items.map(function(item){item.role=='admin';}),expanded:false,clicked:false};return _this;}_createClass(SimpleOverview,[{key:'select',value:function select(item){if(this.props.onSelect){this.props.onSelect(item);}}},{key:'toggle',value:function toggle(){this.setState({collapsed:!this.state.collapsed});}},{key:'onTouchTapRightIcon',value:function onTouchTapRightIcon(item){if(this.props.onTouchTapRightIcon){this.props.onTouchTapRightIcon(item);}}},{key:'onTouchTapLeftIcon',value:function onTouchTapLeftIcon(item){if(this.props.onTouchTapLeftIcon){this.props.onTouchTapLeftIcon(item);}}},{key:'onCheck',value:function onCheck(item){if(this.props.onCheck){this.props.onCheck(item);}}},{key:'onToggleItem',value:function onToggleItem(item){if(this.props.onTouchTapRightToggle){this.props.onTouchTapRightToggle(item);}}},{key:'render',value:function render(){var _this2=this;var children=[];var _props=this.props,expires=_props.expires,keyProperty=_props.keyProperty,readable=_props.readable,loading=_props.loading,limitToMax=_props.limitToMax,removable=_props.removable,role=_props.role,progress=_props.progress;var expanded=this.state.expanded;var getIntlMessage=this.context.getIntlMessage;var items=void 0;if(limitToMax>0&&!expanded){items=this.props.items.slice(0,limitToMax);}else{items=this.props.items;}if(loading){children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["CircularProgress"],{mode:'indeterminate',key:'spinner'}));}else{children=this.props.items&&this.props.items.map(function(item){var expires=item.ucpInfo&&item.ucpInfo.expires;var expiration=void 0,resendButton=void 0,checkBoxItem=void 0,removeButton=void 0;if(expires){expiration=' ('+_this2.context.getIntlMessage('course.access')+expires.slice(0,10)+')';resendButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{onTouchTap:_this2.onTouchTapLeftIcon.bind(_this2,item),tooltip:'Resend Invitation',tooltipPosition:'top-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentSend,null));}else{expiration='';resendButton=null;}var isActivePropExists=Object.keys(item).includes('active');//check if user is in the user list, ensure to not delete himself, unless the user is the main admin
if(removable){removeButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{onTouchTap:_this2.onTouchTapRightIcon.bind(_this2,item),tooltip:_this2.context.getIntlMessage('invitation.remove'),tooltipPosition:'top-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentClear,null)));}else if(parseInt(item&&item.id,10)==parseInt(_this2.props.user&&_this2.props.user.id,10)&&_this2.props.user&&!_this2.props.user.role.editor){removeButton=null;}else if(item&&item.file_id&&_this2.props.user&&!_this2.props.user.role.editor){//check if item is a course and if the user is not the main admin to avoid the user to delete the course from the group
removeButton=null;}else if(!item.active&&isActivePropExists){removeButton=null;}else{removeButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{onTouchTap:_this2.onTouchTapRightIcon.bind(_this2,item),tooltip:_this2.context.getIntlMessage('invitation.remove'),tooltipPosition:'top-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentClear,null)));}var progressItem=progress&&progress.filter(function(obj){return obj.id===item.id;})[0];var prog=progressItem&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:5,paddingLeft:5,fontSize:'14px'}},'Progress:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Math.round(progressItem.progress*100),'% '),Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject),':',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,progressItem.taskTotal,' '),Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject2),':',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,' ',progressItem.tasksCorrect,' '),Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject3),':',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,progressItem.pageViewed,' / ',progressItem.pageTotal));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["ListItem"],{key:item[keyProperty],leftCheckbox:checkBoxItem,onTouchTap:_this2.select.bind(_this2,item),primaryText:item[readable]+' '+expiration,secondaryText:prog,leftIcon:resendButton,rightToggle:item[role]&&parseInt(item&&item.id,10)!=parseInt(_this2.props.user&&_this2.props.user.id,10)&&_this2.props.user&&_this2.props.user.role.owner?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Toggle"],{label:_this2.context.getIntlMessage('invitation.admin'),toggled:item[role]=='admin',style:{right:'50px',width:'120px',fontSize:'x-small'},onToggle:_this2.onToggleItem.bind(_this2,item)}):null,rightIconButton:removeButton});});}var itemsLength=this.props.items&&this.props.items.length;var loadMore=!expanded&&itemsLength>items.length;var hide=expanded&&limitToMax>0&&this.props.items.length>limitToMax;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["List"],{subheader:this.props.title+'('+itemsLength+')',style:{paddingTop:Spacing.desktopGutter,backgroundColor:'#FFFFFF'},subheaderStyle:{fontSize:24,borderStyle:'none none solid none',borderWidth:'1px',borderColor:'rgba(0, 0, 0, 0.12)'}},this.props.children,children,loadMore&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["RaisedButton"],{secondary:true,fullWidth:true,onTouchTap:this.toggleExpand,label:getIntlMessage('ozitor.more')}),hide&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["RaisedButton"],{secondary:true,fullWidth:true,onTouchTap:this.toggleExpand,label:getIntlMessage('ozitor.less')}));}}]);return SimpleOverview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SimpleOverview.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};SimpleOverview.propTypes={limitToMax:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,readable:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,keyProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,expires:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,role:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onSelect:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onTouchTapRightIcon:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onTouchTapLeftIcon:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onCheck:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onTouchTapRightToggle:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onTouchTapLeftToggle:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array.isRequired,loading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,user:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};SimpleOverview.defaultProps={limitToMax:0,readable:'name',keyProperty:'id',expires:'expires',role:'role',loading:false,items:[]};SimpleOverview.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (SimpleOverview);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createRefluxStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapActions=function mapActions(actions){var boundActions={};Object.keys(actions).forEach(function(actionName){var action=actions[actionName];boundActions[actionName]=function(){return action.apply(undefined,arguments);};});return boundActions;};var shallowEquals=function shallowEquals(subState,state){return Object.keys(subState).every(function(key){return subState[key]===state[key];});};var connect=function connect(){var mapStateToProps=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var mapActionToProps=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _storeListeners=[];return function(WrappedComponent){var EnhancedComponent=function(_React$Component){_inherits(EnhancedComponent,_React$Component);function EnhancedComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EnhancedComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EnhancedComponent.__proto__||Object.getPrototypeOf(EnhancedComponent)).call.apply(_ref,[this].concat(args))),_this),_this.state=mapActions(mapActionToProps),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EnhancedComponent,[{key:'_listenToStoreWithMapper',value:function _listenToStoreWithMapper(_ref2){var _this2=this;var _ref3=_slicedToArray(_ref2,2),store=_ref3[0],mapper=_ref3[1];_storeListeners.push(store.listen(function(state){var newState=mapper(state,_this2.props);if(!shallowEquals(newState,_this2.state)){_this2.setState(newState);}}));this.setState(mapper(store.getInitialState(),this.props));}},{key:'componentWillMount',value:function componentWillMount(){var _this3=this;mapStateToProps.forEach(function(storeMapper){_this3._listenToStoreWithMapper(storeMapper);});}},{key:'componentWillUnmount',value:function componentWillUnmount(){_storeListeners.forEach(function(unsub){return unsub();});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,Object.assign({},this.props,this.state));}}]);return EnhancedComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(EnhancedComponent,WrappedComponent);};};var createRefluxStore=function createRefluxStore(StoreClass){var store={};var actions=[];Object.getOwnPropertyNames(StoreClass.prototype).forEach(function(name){var method=StoreClass.prototype[name];if(method instanceof Function){store[name]=method;actions.push(name);}});store.state=Object.assign({},StoreClass.state)||{};store.getInitialState=function(){return this.state;};store.set=function(state){this.state=Object.assign({},this.state,state);this.trigger(this.state);};var storeActions=__WEBPACK_IMPORTED_MODULE_1_reflux___default.a.createActions(actions);store.listenables=[storeActions];var refluxStore=__WEBPACK_IMPORTED_MODULE_1_reflux___default.a.createStore(store);return{actions:storeActions,store:refluxStore};};

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_DiscountField__ = __webpack_require__(2211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Units=__WEBPACK_IMPORTED_MODULE_5_Css__["default"].Units,Colors=__WEBPACK_IMPORTED_MODULE_5_Css__["default"].Colors;var css={root:'_ds',item:'_dt',header:'_du',title:'_dv',price:'_dw',discountFieldContainer:'_dx'};var ItemDetails=function(_Component){_inherits(ItemDetails,_Component);function ItemDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ItemDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ItemDetails.__proto__||Object.getPrototypeOf(ItemDetails)).call.apply(_ref,[this].concat(args))),_this),_this.refresh=function(){var _this$props=_this.props,type=_this$props.type,slug=_this$props.slug;__WEBPACK_IMPORTED_MODULE_3_actions__["A" /* StoreOverviewActions */].findBySlug(type,slug);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ItemDetails,[{key:'render',value:function render(){var _props=this.props,name=_props.name,currency=_props.currency,price=_props.price,activeDiscountCount=_props.activeDiscountCount;var getIntlMessage=this.context.getIntlMessage;var hasDiscount=true||!!(activeDiscountCount&&activeDiscountCount>0);if(!name){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_Loader__["b" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:css.title},getIntlMessage('store.joinCourse')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:css.header},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.price},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["FormattedNumber"],{style:'currency',currency:currency,value:Math.round(price.discounted)}))),hasDiscount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.discountFieldContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_DiscountField__["a" /* default */],{fullWidth:true,onChange:this.refresh})));}}]);return ItemDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ItemDetails.propTypes={name:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,currency:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,slug:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,price:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,store:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,activeDiscountCount:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number};ItemDetails.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (ItemDetails);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_DialogPortal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Toolbar__ = __webpack_require__(80);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var actions=[{link:{icon:'EditorInsertLink'}},{undo:{icon:'ContentUndo'},redo:{icon:'ContentRedo',mode:'advanced'}},{bold:{text:'<b>B</b>'},italic:{text:'<i>I</i>'},underline:{text:'<u>U</u>',mode:'advanced'},strikeThrough:{text:'<s>S</s>',mode:'advanced'}},{justifyLeft:{icon:'EditorFormatAlignLeft',mode:'advanced'},justifyCenter:{icon:'EditorFormatAlignCenter',mode:'advanced'},justifyRight:{icon:'EditorFormatAlignRight',mode:'advanced'},justifyFull:{icon:'EditorFormatAlignJustify',mode:'advanced'}},{indent:{icon:'EditorFormatIndentIncrease',mode:'advanced'},outdent:{icon:'EditorFormatIndentDecrease',mode:'advanced'}},{insertUnorderedList:{icon:'EditorFormatListBulleted'},insertOrderedList:{icon:'EditorFormatListNumbered'}},{h1:{action:'formatBlock',text:'h<sub>1</sub>'},h2:{action:'formatBlock',text:'h<sub>2</sub>'},h3:{action:'formatBlock',text:'h<sub>3</sub>',mode:'advanced'},h4:{action:'formatBlock',text:'h<sub>4</sub>',mode:'advanced'},h5:{action:'formatBlock',text:'h<sub>5</sub>',mode:'advanced'},h6:{action:'formatBlock',text:'h<sub>6</sub>',mode:'advanced'},p:{action:'formatBlock',text:'p'},clearFormatting:{action:'clearFormatting',icon:'EditorFormatClear'}},{quote:{action:'quote',text:'"',mode:'advanced'},subscript:{text:'x<sub>2</sub>',mode:'advanced'},superscript:{text:'x<sup>2</sup>',mode:'advanced'}// html:          {text: 'html'},
}];var styles={button:{lineHeight:36+'px',width:36,height:36,minWidth:36,// margin: Spacing.desktopGutterMini / 2,
verticalAlign:'middle'},iconButton:{lineHeight:36+'px',backgroundColor:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,margin:0,padding:6,borderRadius:2,width:36,height:36,verticalAlign:'middle'},icon:{margin:6},toolbar:{backgroundColor:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].grey[200].material,borderStyle:'none none solid none',borderWidth:1,borderColor:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].grey[300].material},root:{minHeight:Spacing.desktopKeylineIncrement*2},editable:{minHeight:Spacing.desktopKeylineIncrement*4// border: `solid 1px ${Colors.Colors.grey[300].material}`
},contentEditable:{outline:'none',padding:Spacing.desktopGutterMini,overflow:'auto',minHeight:Spacing.desktopKeylineIncrement*4,maxHeight:Spacing.desktopKeylineIncrement*6},content:{},toolbarGroup:__WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__["a" /* default */].toolbarGroup};var attributeWhitelist={href:true,src:true,target:true};var tagWhitelist={// font: true,
br:true};var Ozitor=function(_Component){_inherits(Ozitor,_Component);function Ozitor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Ozitor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Ozitor.__proto__||Object.getPrototypeOf(Ozitor)).call.apply(_ref,[this].concat(args))),_this),_this.state={html:_this.props.content||_this.props.defaultContent,defaultContent:_this.props.defaultContent||_this.props.content,mode:'simple'},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Ozitor,[{key:'stripAttributes',value:function stripAttributes(element){for(var i=element.attributes.length-1;i>=0;i--){var attribute=element.attributes[i];if(!attributeWhitelist[attribute.name]){element.removeAttribute(attribute.name);}}}},{key:'removeStyle',value:function removeStyle(all){var i=all.length;while(i--){var element=all[i];if(!tagWhitelist[element.tagName.toLowerCase()]){var isHidden=element.style.display==='none';this.stripAttributes(element);if(isHidden){element.style.display='none';}if(!element.hasChildNodes()&&element.parentNode){element.parentNode.removeChild(element);}if(!element.hasChildNodes()&&element.parentNode&&element.innerText.trim()===''){element.parentNode.removeChild(element);}}}}},{key:'selectNode',value:function selectNode(){var selection=window.getSelection();var node=selection.anchorNode;var containers={p:true,div:true,ul:true,ol:true,h1:true,h2:true,h3:true,h4:true,h5:true,blockquote:true};while(node&&containers[node.nodeName]){node=node.parentNode;}if(node){this.saveSelection();var range=document.createRange();range.selectNodeContents(node);selection.addRange(range);this.restoreSelection();}}},{key:'quote',value:function quote(){document.execCommand('insertHTML',false,"<div class='quote'>"+document.getSelection()+'</div>');}},{key:'clearFormatting',value:function clearFormatting(){if(this.hasSelection()){document.execCommand('removeformat',false,null);document.execCommand('formatBlock',false,'p');}else{this.saveSelection();this.selectNode();// this.replaceWithOwnChildren(node)
this.removeSelectedElements(['h1','h2','h3','h4','h5','i','s','em','strong','li','ul','ol','blockquote']);this.restoreSelection();}this.onChange();}},{key:'nextNode',value:function nextNode(originalNode){var node=originalNode;if(node.hasChildNodes()){return node.firstChild;}while(node&&!node.nextSibling){node=node.parentNode;}if(!node){return null;}return node.nextSibling;}},{key:'getRangeSelectedNodes',value:function getRangeSelectedNodes(range,includePartiallySelectedContainers){var node=range.startContainer;var endNode=range.endContainer;var rangeNodes=[];// Special case for a range that is contained within a single node
if(node===endNode){rangeNodes=[node];}else{// Iterate nodes until we hit the end container
while(node&&node!==endNode){rangeNodes.push(node===this.nextNode(node));}// Add partially selected nodes at the start of the range
node=range.startContainer;while(node&&node!==range.commonAncestorContainer){rangeNodes.unshift(node);node=node.parentNode;}}// Add ancestors of the range container, if required
if(includePartiallySelectedContainers){node=range.commonAncestorContainer;while(node){rangeNodes.push(node);node=node.parentNode;}}return rangeNodes;}},{key:'getSelectedNodes',value:function getSelectedNodes(){var nodes=[];if(window.getSelection){var sel=window.getSelection();for(var i=0,len=sel.rangeCount;i<len;++i){nodes.push.apply(nodes,this.getRangeSelectedNodes(sel.getRangeAt(i),true));}}return nodes;}},{key:'replaceWithOwnChildren',value:function replaceWithOwnChildren(el){var parent=el.parentNode;while(el.hasChildNodes()){parent.insertBefore(el.firstChild,el);}parent.removeChild(el);}},{key:'removeSelectedElements',value:function removeSelectedElements(tagNames){var _this2=this;this.getSelectedNodes().forEach(function(node){if(node.nodeType===1&&tagNames.indexOf(node.tagName.toLowerCase())>-1){// Remove the node and replace it with its children
_this2.replaceWithOwnChildren(node);}});}},{key:'format',value:function format(action,alternativeAction){if(this[action]){this[action].apply(this,[]);}else if(alternativeAction){document.execCommand(alternativeAction,false,action);}else{document.execCommand(action,false,null);}this.onChange();Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this.refs.editor).focus();}},{key:'onChange',value:function onChange(){var html=Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this.refs.editor).innerHTML;if(html!==this.state.html){this.setState({html:html});if(this.props.onChange){this.props.onChange(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this.refs.editor).innerHTML);}}}},{key:'hasSelection',value:function hasSelection(){var selection=window.getSelection();if(selection.getRangeAt&&selection.rangeCount){var length=0;for(var i=0,len=selection.rangeCount;i<len;++i){var range=selection.getRangeAt(i);length+=Math.abs(range.endOffset-range.startOffset);}return length>0;}return false;}},{key:'onPaste',value:function onPaste(){var _this3=this;setTimeout(function(){if(_this3.props.removeStyle){_this3.removeStyle(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this3.refs.editor).getElementsByTagName('*'));}_this3.setState({html:Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this3.refs.editor).innerHTML});if(_this3.props.onChange){_this3.props.onChange(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this3.refs.editor).innerHTML);}},50);}},{key:'getValue',value:function getValue(){return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this.refs.editor).innerHTML;}},{key:'getContentStyle',value:function getContentStyle(){var style=this.props.style;return Object.assign({},styles.root,this.props.editable?styles.contentEditable:{},style&&style.content);}},{key:'getRootStyle',value:function getRootStyle(){var style=this.props.style;return Object.assign({},styles.root,this.props.editable?styles.editable:{},style&&style.root);}},{key:'saveSelection',value:function saveSelection(){if(window.getSelection){var sel=window.getSelection();if(sel.getRangeAt&&sel.rangeCount){var ranges=[];for(var i=0,len=sel.rangeCount;i<len;++i){ranges.push(sel.getRangeAt(i));}this.savedSelection=ranges;}}else if(document.selection&&document.selection.createRange){this.savedSelection=document.selection.createRange();}}},{key:'restoreSelection',value:function restoreSelection(){var savedSel=this.savedSelection;if(savedSel){if(window.getSelection){var sel=window.getSelection();sel.removeAllRanges();for(var i=0,len=savedSel.length;i<len;++i){sel.addRange(savedSel[i]);}}else if(document.selection&&savedSel.select){savedSel.select();}this.savedSelection=null;}}},{key:'link',value:function link(){this.refs.linkDialog.show();}},{key:'extendSelectionToWord',value:function extendSelectionToWord(){var sel=void 0;if(window.getSelection&&(sel=window.getSelection()).modify){// let selectedRange = sel.getRangeAt(0);
sel.collapseToStart();sel.modify('move','backward','word');sel.modify('extend','forward','word');}else if((sel=document.selection)&&sel.type!=='Control'){var range=sel.createRange();range.collapse(true);range.expand('word');}}},{key:'confirmLink',value:function confirmLink(){var url=this.refs.linkUrl.getValue(),openInNewTab=this.refs.linkTarget.isToggled();this.refs.linkDialog.dismiss();Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this.refs.editor).focus();this.restoreSelection();this.refs.linkUrl.setValue('http://');if(openInNewTab){document.execCommand('insertHTML',false,'<a href=\''+url+'\' target=\'_blank\'>'+this.linkText+'</a>');}else{document.execCommand('insertHTML',false,'<a href=\''+url+'\' >'+this.linkText+'</a>');}if(this.props.onChange){this.props.onChange(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this.refs.editor).innerHTML);}}},{key:'restore',value:function restore(){this.restoreSelection();}},{key:'fillLinkDefaults',value:function fillLinkDefaults(){var selection=void 0,selectedText=void 0;if(window.getSelection){selection=window.getSelection();selectedText=selection.toString();}else if(document.selection&&document.selection.type!=='Control'){selection=document.selection;selectedText=selection.toString();}if(!selectedText){this.extendSelectionToWord();selectedText=selection.toString();}var parentNode=selection.anchorNode&&selection.anchorNode.parentNode;if(parentNode&&parentNode.tagName.toLowerCase()==='a'){selectedText=this.selectElementContents(parentNode);this.refs.linkUrl.setValue(parentNode.href);this.refs.linkTarget.setToggled(parentNode.target==='_blank');}this.saveSelection();this.linkText=selectedText;}},{key:'selectElementContents',value:function selectElementContents(el){var range=document.createRange();range.selectNodeContents(el);var sel=window.getSelection();sel.removeAllRanges();sel.addRange(range);return sel.toString();}},{key:'toggleMode',value:function toggleMode(){if(this.state.mode==='simple'){this.setState({mode:'advanced'});}else{this.setState({mode:'simple'});}}},{key:'render',value:function render(){var _this4=this;var controls=void 0;var buttons=[];var standardActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('OK'),secondary:true,onTouchTap:this.confirmLink.bind(this)})];var extraControls=this.props.extraControls;var props={// className: 'ozitor-content',
onBlur:this.onChange.bind(this),onKeyUp:this.onChange.bind(this),onCopy:this.onChange.bind(this),onPaste:this.onPaste.bind(this),onCut:this.onChange.bind(this),onMouseup:this.onChange.bind(this),dangerouslySetInnerHTML:{__html:this.state.defaultContent}};if(this.props.editable){props.contentEditable=true;if(this.props.controls){buttons=actions.map(function(actionGroup,groupIndex){var groupControls=Object.keys(actionGroup).map(function(actionName){var action=actionGroup[actionName];if(action.mode&&action.mode!==_this4.state.mode){return null;}if(action.icon){var Icon=__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__[action.icon];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Toolbar__["c" /* ToolbarButton */],{onTouchTap:_this4.format.bind(_this4,actionName,action.action),key:actionName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Toolbar__["c" /* ToolbarButton */],{onTouchTap:_this4.format.bind(_this4,actionName,action.action),key:actionName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:action.text}}));}).filter(function(control){return!!control;});if(groupControls.length&&groupControls.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Toolbar__["d" /* ToolbarGroup */],{key:groupIndex},groupControls);}});var switchIcon=void 0;var tooltip=void 0;if(this.state.mode==='simple'){tooltip=this.context.getIntlMessage('ozitor.more');switchIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["NavigationMoreVert"],null);}else{tooltip=this.context.getIntlMessage('ozitor.less');switchIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["NavigationMoreHoriz"],null);}controls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Toolbar__["b" /* Toolbar */],null,buttons,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Toolbar__["d" /* ToolbarGroup */],{right:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Toolbar__["c" /* ToolbarButton */],{tooltip:tooltip,onTouchTap:this.toggleMode.bind(this)},switchIcon)),extraControls);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('ozitor'),style:this.getRootStyle(styles.root)},controls,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({ref:'editor'},props,{style:this.getContentStyle()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Dialog"],{onShow:this.fillLinkDefaults.bind(this),onDismiss:this.restore.bind(this),ref:'linkDialog',title:this.context.getIntlMessage('ozitor.createLink'),actions:standardActions,dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{fullWidth:true,ref:'linkUrl',defaultValue:'http://',floatingLabelText:this.context.getIntlMessage('ozitor.url')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Toggle"],{label:this.context.getIntlMessage('ozitor.openInNewTab'),ref:'linkTarget'}))));}}]);return Ozitor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Ozitor.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};Ozitor.propTypes={content:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,defaultContent:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,controls:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,removeStyle:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,editable:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,dark:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};Ozitor.defaultProps={dark:true,controls:true,editable:true,removeStyle:true};/* harmony default export */ __webpack_exports__["a"] = (Ozitor);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridContainer__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GridRow__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GridCell__ = __webpack_require__(548);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__GridContainer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__GridRow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__GridCell__["a"]; });


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInstanceMap
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
var ReactInstanceMap = {

  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }

};

module.exports = ReactInstanceMap;

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scope__ = __webpack_require__(452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["b"]; });
/* unused harmony reexport Scope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hub__ = __webpack_require__(747);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__hub__["a"]; });
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport getMainCarrier */
/* unused harmony reexport Hub */
/* unused harmony reexport makeMain */
/* unused harmony reexport setHubOnCarrier */


//# sourceMappingURL=index.js.map

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {/* harmony export (immutable) */ __webpack_exports__["d"] = dynamicRequire;
/* harmony export (immutable) */ __webpack_exports__["j"] = isNodeEnv;
/* harmony export (immutable) */ __webpack_exports__["g"] = getGlobalObject;
/* harmony export (immutable) */ __webpack_exports__["n"] = uuid4;
/* harmony export (immutable) */ __webpack_exports__["l"] = parseUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = getEventDescription;
/* harmony export (immutable) */ __webpack_exports__["c"] = consoleSandbox;
/* harmony export (immutable) */ __webpack_exports__["b"] = addExceptionTypeValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = addExceptionMechanism;
/* harmony export (immutable) */ __webpack_exports__["h"] = getLocationHref;
/* harmony export (immutable) */ __webpack_exports__["i"] = htmlTreeAsString;
/* harmony export (immutable) */ __webpack_exports__["m"] = timestampWithMs;
/* unused harmony export parseSemver */
/* harmony export (immutable) */ __webpack_exports__["k"] = parseRetryAfterHeader;
/* harmony export (immutable) */ __webpack_exports__["f"] = getFunctionName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(156);

/**
 * Requires a module which is protected _against bundler minification.
 *
 * @param request The module path to resolve
 */
function dynamicRequire(mod, request) {
    // tslint:disable-next-line: no-unsafe-any
    return mod.require(request);
}
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // tslint:disable:strict-type-predicates
    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (isNodeEnv()
        ? global
        : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // tslint:disable-next-line:no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // tslint:disable-next-line:no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        var r = (Math.random() * 16) | 0;
        // tslint:disable-next-line:no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    if (event.message) {
        return event.message;
    }
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) {
            return exception.type + ": " + exception.value;
        }
        return exception.type || exception.value || event.event_id || '<unknown>';
    }
    return event.event_id || '<unknown>';
}
/** JSDoc */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        if (level in global.console && originalConsole[level].__sentry__) {
            wrappedLevels[level] = originalConsole[level].__sentry_wrapped__;
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || '';
    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
}
/**
 * Adds exception mechanism to a given event.
 * @param event The event to modify.
 * @param mechanism Mechanism of the mechanism.
 * @hidden
 */
function addExceptionMechanism(event, mechanism) {
    if (mechanism === void 0) { mechanism = {}; }
    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
    try {
        // @ts-ignore
        // tslint:disable:no-non-null-assertion
        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
        Object.keys(mechanism).forEach(function (key) {
            // @ts-ignore
            event.exception.values[0].mechanism[key] = mechanism[key];
        });
    }
    catch (_oO) {
        // no-empty
    }
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    try {
        return document.location.href;
    }
    catch (oO) {
        return '';
    }
}
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push("#" + elem.id);
    }
    className = elem.className;
    if (className && Object(__WEBPACK_IMPORTED_MODULE_0__is__["k" /* isString */])(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push("." + classes[i]);
        }
    }
    var attrWhitelist = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < attrWhitelist.length; i++) {
        key = attrWhitelist[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
/**
 * Returns a timestamp in seconds with milliseconds precision.
 */
function timestampWithMs() {
    return new Date().getTime() / 1000;
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
var defaultRetryAfter = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param now current unix timestamp
 * @param header string representation of 'Retry-After' header
 */
function parseRetryAfterHeader(now, header) {
    if (!header) {
        return defaultRetryAfter;
    }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return defaultRetryAfter;
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
//# sourceMappingURL=misc.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(453), __webpack_require__(56)))

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(77);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 181 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(77);
var TAG = __webpack_require__(35)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var GroupActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['findBuildable','findBuildableComplete','fetchAll','filter','setFilter','resetFilter','setSort','resetSort','create','createComplete','update','updateComplete','findByUserId','findByUserIdComplete','findByCourseId','findByCourseIdComplete','findById','findByIdComplete','genericError','countParticipants','delete','removeFromCourse','removeFromCourseComplete','removeFromSelection','addToCourse','addToCourseComplete']);/* harmony default export */ __webpack_exports__["a"] = (GroupActions);

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Emitter = __webpack_require__(996);
var reduce = __webpack_require__(997);
var requestBase = __webpack_require__(998);
var isObject = __webpack_require__(511);

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  root = this;
}

/**
 * Noop.
 */

function noop(){};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * TODO: future proof, move to compoent land
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isHost(obj) {
  var str = {}.toString.call(obj);

  switch (str) {
    case '[object File]':
    case '[object Blob]':
    case '[object FormData]':
      return true;
    default:
      return false;
  }
}

/**
 * Expose `request`.
 */

var request = module.exports = __webpack_require__(999).bind(null, Request);

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  return false;
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    if (null != obj[key]) {
      pushEncodedKeyValuePair(pairs, key, obj[key]);
        }
      }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (Array.isArray(val)) {
    return val.forEach(function(v) {
      pushEncodedKeyValuePair(pairs, key, v);
    });
  }
  pairs.push(encodeURIComponent(key)
    + '=' + encodeURIComponent(val));
}

/**
 * Expose serialization method.
 */

 request.serializeObject = serialize;

 /**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var parts;
  var pair;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    parts = pair.split('=');
    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'application/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

 request.serialize = {
   'application/x-www-form-urlencoded': serialize,
   'application/json': JSON.stringify
 };

 /**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  lines.pop(); // trailing CRLF

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  return /[\/+]json\b/.test(mime);
}

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function type(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function params(str){
  return reduce(str.split(/ *; */), function(obj, str){
    var parts = str.split(/ *= */)
      , key = parts.shift()
      , val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req, options) {
  options = options || {};
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  this.setStatusProperties(this.xhr.status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this.setHeaderProperties(this.header);
  this.body = this.req.method != 'HEAD'
    ? this.parseBody(this.text ? this.text : this.xhr.response)
    : null;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

Response.prototype.get = function(field){
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

Response.prototype.setHeaderProperties = function(header){
  // content-type
  var ct = this.header['content-type'] || '';
  this.type = type(ct);

  // params
  var obj = params(ct);
  for (var key in obj) this[key] = obj[key];
};

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype.parseBody = function(str){
  var parse = request.parse[this.type];
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

Response.prototype.setStatusProperties = function(status){
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }

  var type = status / 100 | 0;

  // status / class
  this.status = this.statusCode = status;
  this.statusType = type;

  // basics
  this.info = 1 == type;
  this.ok = 2 == type;
  this.clientError = 4 == type;
  this.serverError = 5 == type;
  this.error = (4 == type || 5 == type)
    ? this.toError()
    : false;

  // sugar
  this.accepted = 202 == status;
  this.noContent = 204 == status;
  this.badRequest = 400 == status;
  this.unauthorized = 401 == status;
  this.notAcceptable = 406 == status;
  this.notFound = 404 == status;
  this.forbidden = 403 == status;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
      // issue #876: return the http status code if the response parsing fails
      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
      return self.callback(err);
    }

    self.emit('response', res);

    if (err) {
      return self.callback(err, res);
    }

    if (res.status >= 200 && res.status < 300) {
      return self.callback(err, res);
    }

    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
    new_err.original = err;
    new_err.response = res;
    new_err.status = res.status;

    self.callback(new_err, res);
  });
}

/**
 * Mixin `Emitter` and `requestBase`.
 */

Emitter(Request.prototype);
for (var key in requestBase) {
  Request.prototype[key] = requestBase[key];
}

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */

Request.prototype.abort = function(){
  if (this.aborted) return;
  this.aborted = true;
  this.xhr && this.xhr.abort();
  this.clearTimeout();
  this.emit('abort');
  return this;
};

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set responseType to `val`. Presently valid responseTypes are 'blob' and 
 * 'arraybuffer'.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} pass
 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (!options) {
    options = {
      type: 'basic'
    }
  }

  switch (options.type) {
    case 'basic':
      var str = btoa(user + ':' + pass);
      this.set('Authorization', 'Basic ' + str);
    break;

    case 'auto':
      this.username = user;
      this.password = pass;
    break;
  }
  return this;
};

/**
* Add query-string `val`.
*
* Examples:
*
*   request.get('/shoes')
*     .query('size=10')
*     .query({ color: 'blue' })
*
* @param {Object|String} val
* @return {Request} for chaining
* @api public
*/

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `filename`.
 *
 * ``` js
 * request.post('/upload')
 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String} filename
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, filename){
  this._getFormData().append(field, file, filename || file.name);
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
  *      request.post('/user')
  *        .send('name=tobi')
  *        .send('species=ferret')
  *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.send = function(data){
  var obj = isObject(data);
  var type = this._header['content-type'];

  // merge
  if (obj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!obj || isHost(data)) return this;
  if (!type) this.type('json');
  return this;
};

/**
 * @deprecated
 */
Response.prototype.parse = function serialize(fn){
  if (root.console) {
    console.warn("Client-side parse() method has been renamed to serialize(). This method is not compatible with superagent v2.0");
  }
  this.serialize(fn);
  return this;
};

Response.prototype.serialize = function serialize(fn){
  this._parser = fn;
  return this;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  var fn = this._callback;
  this.clearTimeout();
  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

Request.prototype.timeoutError = function(){
  var timeout = this._timeout;
  var err = new Error('timeout of ' + timeout + 'ms exceeded');
  err.timeout = timeout;
  this.callback(err);
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

Request.prototype.withCredentials = function(){
  this._withCredentials = true;
  return this;
};

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var query = this._query.join('&');
  var timeout = this._timeout;
  var data = this._formData || this._data;

  // store callback
  this._callback = fn || noop;

  // state change
  xhr.onreadystatechange = function(){
    if (4 != xhr.readyState) return;

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (0 == status) {
      if (self.timedout) return self.timeoutError();
      if (self.aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(e){
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = 'download';
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    xhr.onprogress = handleProgress;
  }
  try {
    if (xhr.upload && this.hasListeners('progress')) {
      xhr.upload.onprogress = handleProgress;
    }
  } catch(e) {
    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
    // Reported here:
    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
  }

  // timeout
  if (timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self.timedout = true;
      self.abort();
    }, timeout);
  }

  // querystring
  if (query) {
    query = request.serializeObject(query);
    this.url += ~this.url.indexOf('?')
      ? '&' + query
      : '?' + query;
  }

  // initiate request
  if (this.username && this.password) {
    xhr.open(this.method, this.url, true, this.username, this.password);
  } else {
    xhr.open(this.method, this.url, true);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._parser || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;
    xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};


/**
 * Expose `Request`.
 */

request.Request = Request;

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} data or fn
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn){
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} data or fn
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn){
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

function del(url, fn){
  var req = request('DELETE', url);
  if (fn) req.end(fn);
  return req;
};

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} data
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn){
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} data
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn){
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} data or fn
 * @param {Function} fn
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn){
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var gaTrackers={};var Analytics=function(){function Analytics(){_classCallCheck(this,Analytics);this.ids="production"==='production'&&['UA-806038-4']||[];}_createClass(Analytics,[{key:'initialize',value:function initialize(){var analyticsCode=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var googleAnalyticsId=analyticsCode.split(/[\s,]+/).filter(function(y){return!!y;});this.ids=[].concat(_toConsumableArray(this.ids),_toConsumableArray(googleAnalyticsId));for(var i=0;i<this.ids.length;i++){if(!gaTrackers[this.ids[i]]){gaTrackers[this.ids[i]]=true;gtag('config',this.ids[i]);}}}},{key:'pageview',value:function pageview(){gtag('event','page_view');}},{key:'viewitem',value:function viewitem(data){gtag('event','view_item',{items:[data]});}},{key:'checkout',value:function checkout(data){gtag('event','begin_checkout',{items:[data]});}},{key:'ecAddItem',value:function ecAddItem(data){gtag('event','add_to_cart',{items:[data]});}},{key:'ecAddTransaction',value:function ecAddTransaction(data){gtag('event','purchase',data);}},{key:'event',value:function event(){for(var _len=arguments.length,data=Array(_len),_key=0;_key<_len;_key++){data[_key]=arguments[_key];}var id=data[0],category=data[1],label=data[2];gtag('event',id,{'event_category':category,'event_label':label});}}]);return Analytics;}();/* harmony default export */ __webpack_exports__["a"] = (new Analytics());

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var ContextPure = __webpack_require__(136);
var Transitions = __webpack_require__(21);
var PropTypes = __webpack_require__(187);
var EnhancedButton = __webpack_require__(102);
var FontIcon = __webpack_require__(189);
var Tooltip = __webpack_require__(353);
var Children = __webpack_require__(244);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var IconButton = React.createClass({
  displayName: 'IconButton',

  mixins: [StylePropable, ContextPure],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  statics: {
    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
      var spacing = muiTheme.rawTheme.spacing;
      var palette = muiTheme.rawTheme.palette;

      return {
        iconSize: spacing.iconSize,
        textColor: palette.textColor,
        disabledColor: palette.disabledColor
      };
    },

    getChildrenClasses: function getChildrenClasses() {
      return [EnhancedButton, FontIcon, Tooltip];
    }
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    className: React.PropTypes.string,
    disabled: React.PropTypes.bool,
    iconClassName: React.PropTypes.string,
    iconStyle: React.PropTypes.object,
    onBlur: React.PropTypes.func,
    onFocus: React.PropTypes.func,
    onKeyboardFocus: React.PropTypes.func,
    tooltip: React.PropTypes.node,
    tooltipStyles: React.PropTypes.object,
    tooltipPosition: PropTypes.cornersAndCenter,
    touch: React.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    return {
      tooltipShown: false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getDefaultProps: function getDefaultProps() {
    return {
      iconStyle: {},
      tooltipPosition: 'bottom-center'
    };
  },

  getStyles: function getStyles() {
    var _constructor$getRelevantContextKeys = this.constructor.getRelevantContextKeys(this.state.muiTheme);

    var iconSize = _constructor$getRelevantContextKeys.iconSize;
    var textColor = _constructor$getRelevantContextKeys.textColor;
    var disabledColor = _constructor$getRelevantContextKeys.disabledColor;

    var styles = {
      root: {
        position: 'relative',
        boxSizing: 'border-box',
        transition: Transitions.easeOut(),
        padding: iconSize / 2,
        width: iconSize * 2,
        height: iconSize * 2,
        fontSize: 0
      },
      tooltip: {
        boxSizing: 'border-box'
      },
      icon: {
        color: textColor,
        fill: textColor
      },
      overlay: {
        position: 'relative',
        top: 0,
        width: '100%',
        height: '100%',
        background: disabledColor
      },
      disabled: {
        color: disabledColor,
        fill: disabledColor
      }
    };

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var disabled = _props.disabled;
    var iconClassName = _props.iconClassName;
    var tooltip = _props.tooltip;
    var touch = _props.touch;
    var iconStyle = _props.iconStyle;

    var other = _objectWithoutProperties(_props, ['disabled', 'iconClassName', 'tooltip', 'touch', 'iconStyle']);

    var fonticon = undefined;

    var styles = this.getStyles();
    var tooltipPosition = this.props.tooltipPosition.split('-');

    var tooltipElement = tooltip ? React.createElement(Tooltip, {
      ref: 'tooltip',
      label: tooltip,
      show: this.state.tooltipShown,
      touch: touch,
      style: this.mergeStyles(styles.tooltip, this.props.tooltipStyles),
      verticalPosition: tooltipPosition[0],
      horizontalPosition: tooltipPosition[1] }) : null;

    if (iconClassName) {
      var iconHoverColor = iconStyle.iconHoverColor;

      var iconStyleFontIcon = _objectWithoutProperties(iconStyle, ['iconHoverColor']);

      fonticon = React.createElement(
        FontIcon,
        {
          className: iconClassName,
          hoverColor: disabled ? null : iconHoverColor,
          style: this.mergeStyles(styles.icon, disabled ? styles.disabled : {}, iconStyleFontIcon) },
        this.props.children
      );
    }

    var childrenStyle = disabled ? this.mergeStyles(iconStyle, styles.disabled) : iconStyle;

    return React.createElement(
      EnhancedButton,
      _extends({}, other, {
        ref: 'button',
        centerRipple: true,
        disabled: disabled,
        style: this.mergeStyles(styles.root, this.props.style),
        onBlur: this._handleBlur,
        onFocus: this._handleFocus,
        onMouseLeave: this._handleMouseLeave,
        onMouseEnter: this._handleMouseEnter,
        onKeyboardFocus: this._handleKeyboardFocus }),
      tooltipElement,
      fonticon,
      Children.extend(this.props.children, {
        style: childrenStyle
      })
    );
  },

  setKeyboardFocus: function setKeyboardFocus() {
    this.refs.button.setKeyboardFocus();
  },

  _showTooltip: function _showTooltip() {
    if (!this.props.disabled && this.props.tooltip) {
      this.setState({ tooltipShown: true });
    }
  },

  _hideTooltip: function _hideTooltip() {
    if (this.props.tooltip) this.setState({ tooltipShown: false });
  },

  _handleBlur: function _handleBlur(e) {
    this._hideTooltip();
    if (this.props.onBlur) this.props.onBlur(e);
  },

  _handleFocus: function _handleFocus(e) {
    this._showTooltip();
    if (this.props.onFocus) this.props.onFocus(e);
  },

  _handleMouseLeave: function _handleMouseLeave(e) {
    if (!this.refs.button.isKeyboardFocused()) this._hideTooltip();
    if (this.props.onMouseLeave) this.props.onMouseLeave(e);
  },

  _handleMouseEnter: function _handleMouseEnter(e) {
    this._showTooltip();
    if (this.props.onMouseEnter) this.props.onMouseEnter(e);
  },

  _handleKeyboardFocus: function _handleKeyboardFocus(e, keyboardFocused) {
    if (keyboardFocused && !this.props.disabled) {
      this._showTooltip();
      if (this.props.onFocus) this.props.onFocus(e);
    } else if (!this.state.hovered) {
      this._hideTooltip();
      if (this.props.onBlur) this.props.onBlur(e);
    }

    if (this.props.onKeyboardFocus) this.props.onKeyboardFocus(e, keyboardFocused);
  }

});

module.exports = IconButton;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

module.exports = {

  corners: React.PropTypes.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),

  cornersAndCenter: React.PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),

  stringOrNumber: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),

  zDepth: React.PropTypes.oneOf([0, 1, 2, 3, 4, 5])

};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(519);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var FontIcon = React.createClass({
  displayName: 'FontIcon',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    color: React.PropTypes.string,
    hoverColor: React.PropTypes.string,
    onMouseLeave: React.PropTypes.func,
    onMouseEnter: React.PropTypes.func
  },

  getInitialState: function getInitialState() {
    return {
      hovered: false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _props = this.props;
    var color = _props.color;
    var hoverColor = _props.hoverColor;
    var onMouseLeave = _props.onMouseLeave;
    var onMouseEnter = _props.onMouseEnter;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['color', 'hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);

    var spacing = this.state.muiTheme.rawTheme.spacing;
    var offColor = color ? color : style && style.color ? style.color : this.state.muiTheme.rawTheme.palette.textColor;
    var onColor = hoverColor ? hoverColor : offColor;

    var mergedStyles = this.prepareStyles({
      position: 'relative',
      fontSize: spacing.iconSize,
      display: 'inline-block',
      userSelect: 'none',
      transition: Transitions.easeOut()
    }, style, {
      color: this.state.hovered ? onColor : offColor
    });

    return React.createElement('span', _extends({}, other, {
      onMouseLeave: this._handleMouseLeave,
      onMouseEnter: this._handleMouseEnter,
      style: mergedStyles }));
  },

  _handleMouseLeave: function _handleMouseLeave(e) {
    // hover is needed only when a hoverColor is defined
    if (this.props.hoverColor !== undefined) this.setState({ hovered: false });
    if (this.props.onMouseLeave) {
      this.props.onMouseLeave(e);
    }
  },

  _handleMouseEnter: function _handleMouseEnter(e) {
    // hover is needed only when a hoverColor is defined
    if (this.props.hoverColor !== undefined) this.setState({ hovered: true });
    if (this.props.onMouseEnter) {
      this.props.onMouseEnter(e);
    }
  }
});

module.exports = FontIcon;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  AutoPrefix: __webpack_require__(62),
  Colors: __webpack_require__(53),
  Spacing: __webpack_require__(349),
  ThemeManager: __webpack_require__(12),
  Transitions: __webpack_require__(21),
  Typography: __webpack_require__(135),
  LightRawTheme: __webpack_require__(11),
  DarkRawTheme: __webpack_require__(1024),
  ThemeDecorator: __webpack_require__(1025)
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var BeforeAfterWrapper = __webpack_require__(522);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var ClearFix = React.createClass({
  displayName: 'ClearFix',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _props = this.props;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['style']);

    var before = function before() {
      return {
        content: "' '",
        display: 'table'
      };
    };

    var after = before();
    after.clear = 'both';

    return React.createElement(
      BeforeAfterWrapper,
      _extends({}, other, {
        beforeStyle: before(),
        afterStyle: after,
        style: style }),
      this.props.children
    );
  }
});

module.exports = ClearFix;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Events = __webpack_require__(137);

module.exports = {

  _testSupportedProps: function _testSupportedProps(props) {
    var i = undefined,
        el = document.createElement('div');

    for (i in props) {
      if (props.hasOwnProperty(i) && el.style[i] !== undefined) {
        return props[i];
      }
    }
  },

  //Returns the correct event name to use
  transitionEndEventName: function transitionEndEventName() {
    return this._testSupportedProps({
      'transition': 'transitionend',
      'OTransition': 'otransitionend',
      'MozTransition': 'transitionend',
      'WebkitTransition': 'webkitTransitionEnd'
    });
  },

  animationEndEventName: function animationEndEventName() {
    return this._testSupportedProps({
      'animation': 'animationend',
      '-o-animation': 'oAnimationEnd',
      '-moz-animation': 'animationend',
      '-webkit-animation': 'webkitAnimationEnd'
    });
  },

  onTransitionEnd: function onTransitionEnd(el, callback) {
    var transitionEnd = this.transitionEndEventName();

    Events.once(el, transitionEnd, function () {
      return callback();
    });
  },

  onAnimationEnd: function onAnimationEnd(el, callback) {
    var animationEnd = this.animationEndEventName();

    Events.once(el, animationEnd, function () {
      return callback();
    });
  }
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ContextPure = __webpack_require__(136);
var Transitions = __webpack_require__(21);
var Children = __webpack_require__(244);
var ColorManipulator = __webpack_require__(95);
var ImmutabilityHelper = __webpack_require__(162);
var Typography = __webpack_require__(135);
var EnhancedButton = __webpack_require__(102);
var FlatButtonLabel = __webpack_require__(1039);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

function validateLabel(props, propName, componentName) {
  if (!props.children && !props.label) {
    return new Error('Required prop label or children was not ' + 'specified in ' + componentName + '.');
  }
}

var FlatButton = React.createClass({
  displayName: 'FlatButton',

  mixins: [ContextPure],

  statics: {
    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
      var buttonTheme = muiTheme.button;
      var flatButtonTheme = muiTheme.flatButton;

      return {
        buttonColor: flatButtonTheme.color,
        buttonHeight: buttonTheme.height,
        buttonMinWidth: buttonTheme.minWidth,
        disabledTextColor: flatButtonTheme.disabledTextColor,
        primaryTextColor: flatButtonTheme.primaryTextColor,
        secondaryTextColor: flatButtonTheme.secondaryTextColor,
        textColor: flatButtonTheme.textColor,
        textTransform: flatButtonTheme.textTransform ? flatButtonTheme.textTransform : buttonTheme.textTransform ? buttonTheme.textTransform : 'uppercase'
      };
    },
    getChildrenClasses: function getChildrenClasses() {
      return [EnhancedButton, FlatButtonLabel];
    }
  },

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    disabled: React.PropTypes.bool,
    hoverColor: React.PropTypes.string,
    label: validateLabel,
    labelPosition: React.PropTypes.oneOf(['before', 'after']),
    labelStyle: React.PropTypes.object,
    onKeyboardFocus: React.PropTypes.func,
    onMouseEnter: React.PropTypes.func,
    onMouseLeave: React.PropTypes.func,
    onTouchStart: React.PropTypes.func,
    primary: React.PropTypes.bool,
    rippleColor: React.PropTypes.string,
    secondary: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      labelStyle: {},
      labelPosition: 'before',
      onKeyboardFocus: function onKeyboardFocus() {},
      onMouseEnter: function onMouseEnter() {},
      onMouseLeave: function onMouseLeave() {},
      onTouchStart: function onTouchStart() {}
    };
  },

  getInitialState: function getInitialState() {
    return {
      hovered: false,
      isKeyboardFocused: false,
      touch: false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _props = this.props;
    var children = _props.children;
    var disabled = _props.disabled;
    var hoverColor = _props.hoverColor;
    var backgroundColor = _props.backgroundColor;
    var label = _props.label;
    var labelStyle = _props.labelStyle;
    var labelPosition = _props.labelPosition;
    var onKeyboardFocus = _props.onKeyboardFocus;
    var onMouseLeave = _props.onMouseLeave;
    var onMouseEnter = _props.onMouseEnter;
    var onTouchStart = _props.onTouchStart;
    var primary = _props.primary;
    var rippleColor = _props.rippleColor;
    var secondary = _props.secondary;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['children', 'disabled', 'hoverColor', 'backgroundColor', 'label', 'labelStyle', 'labelPosition', 'onKeyboardFocus', 'onMouseLeave', 'onMouseEnter', 'onTouchStart', 'primary', 'rippleColor', 'secondary', 'style']);

    var _constructor$getRelevantContextKeys = this.constructor.getRelevantContextKeys(this.state.muiTheme);

    var buttonColor = _constructor$getRelevantContextKeys.buttonColor;
    var buttonHeight = _constructor$getRelevantContextKeys.buttonHeight;
    var buttonMinWidth = _constructor$getRelevantContextKeys.buttonMinWidth;
    var disabledTextColor = _constructor$getRelevantContextKeys.disabledTextColor;
    var primaryTextColor = _constructor$getRelevantContextKeys.primaryTextColor;
    var secondaryTextColor = _constructor$getRelevantContextKeys.secondaryTextColor;
    var textColor = _constructor$getRelevantContextKeys.textColor;
    var textTransform = _constructor$getRelevantContextKeys.textTransform;

    var defaultColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;

    var defaultHoverColor = ColorManipulator.fade(ColorManipulator.lighten(defaultColor, 0.4), 0.15);
    var defaultRippleColor = ColorManipulator.fade(defaultColor, 0.8);
    var buttonHoverColor = hoverColor || defaultHoverColor;
    var buttonRippleColor = rippleColor || defaultRippleColor;
    var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
    var buttonBackgroundColor = backgroundColor || buttonColor;

    var mergedRootStyles = ImmutabilityHelper.merge({
      color: defaultColor,
      transition: Transitions.easeOut(),
      fontSize: Typography.fontStyleButtonFontSize,
      letterSpacing: 0,
      textTransform: textTransform,
      fontWeight: Typography.fontWeightMedium,
      borderRadius: 2,
      userSelect: 'none',
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
      lineHeight: buttonHeight + 'px',
      minWidth: buttonMinWidth,
      padding: 0,
      margin: 0,
      //This is need so that ripples do not bleed past border radius.
      //See: http://stackoverflow.com/questions/17298739
      transform: 'translate3d(0, 0, 0)'
    }, style);

    var labelElement = label ? React.createElement(FlatButtonLabel, { label: label, style: labelStyle }) : undefined;
    // Place label before or after children.
    var childrenFragment = labelPosition === 'before' ? { labelElement: labelElement, children: children } : { children: children, labelElement: labelElement };
    var enhancedButtonChildren = Children.create(childrenFragment);

    return React.createElement(
      EnhancedButton,
      _extends({}, other, {
        disabled: disabled,
        focusRippleColor: buttonRippleColor,
        onKeyboardFocus: this._handleKeyboardFocus,
        onMouseLeave: this._handleMouseLeave,
        onMouseEnter: this._handleMouseEnter,
        onTouchStart: this._handleTouchStart,
        style: mergedRootStyles,
        touchRippleColor: buttonRippleColor }),
      enhancedButtonChildren
    );
  },

  _handleKeyboardFocus: function _handleKeyboardFocus(e, isKeyboardFocused) {
    this.setState({ isKeyboardFocused: isKeyboardFocused });
    this.props.onKeyboardFocus(e, isKeyboardFocused);
  },

  _handleMouseEnter: function _handleMouseEnter(e) {
    //Cancel hover styles for touch devices
    if (!this.state.touch) this.setState({ hovered: true });
    this.props.onMouseEnter(e);
  },

  _handleMouseLeave: function _handleMouseLeave(e) {
    this.setState({ hovered: false });
    this.props.onMouseLeave(e);
  },

  _handleTouchStart: function _handleTouchStart(e) {
    this.setState({ touch: true });
    this.props.onTouchStart(e);
  }

});

module.exports = FlatButton;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var css = {
  inheritFill: 'cio_hE',
  inheritStroke: 'cio_hF'
};

exports.default = css;
module.exports = exports['default'];

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(253),
    getRawTag = __webpack_require__(1993),
    objectToString = __webpack_require__(1994);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_matchMedia_polyfill__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_matchMedia_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_matchMedia_polyfill__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var MediaQuery=function(){function MediaQuery(){_classCallCheck(this,MediaQuery);var tabletWidth=768;var desktopWidth=1024;this.tabletQuery='(min-width : '+tabletWidth+'px) and (max-width: '+desktopWidth+'px)';this.tabletDesktopQuery='(min-width : '+tabletWidth+'px)';this.desktopQuery='(min-width : '+desktopWidth+'px)';this.phoneQuery='(max-width : '+(tabletWidth-1)+'px)';this.portraitPhoneQuery='(max-width : '+(tabletWidth-1)+'px) and (orientation: portrait)';}_createClass(MediaQuery,[{key:'detect',value:function detect(){if(this.phone()){return'phone';}else if(this.tablet()){return'tablet';}else if(this.desktop()){return'desktop';}else if(this.tabletOrDesktop()){return'tablet-or-desktop';}}},{key:'tablet',value:function tablet(){return window.matchMedia(this.tabletQuery).matches;}},{key:'tabletOrDesktop',value:function tabletOrDesktop(){return window.matchMedia(this.tabletDesktopQuery).matches;}},{key:'desktop',value:function desktop(){return window.matchMedia(this.desktopQuery).matches;}},{key:'phone',value:function phone(){return window.matchMedia(this.phoneQuery).matches;}},{key:'portraitPhone',value:function portraitPhone(){return window.matchMedia(this.portraitPhoneQuery).matches;}}]);return MediaQuery;}();/* harmony default export */ __webpack_exports__["a"] = (new MediaQuery());

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultAvatar='/images/profile_default.png';var css={root:'_c6'};var ProfileImage=function(_Component){_inherits(ProfileImage,_Component);function ProfileImage(){_classCallCheck(this,ProfileImage);return _possibleConstructorReturn(this,(ProfileImage.__proto__||Object.getPrototypeOf(ProfileImage)).apply(this,arguments));}_createClass(ProfileImage,[{key:'getStyle',value:function getStyle(){var avatarImage=this.props.author.avatar||this.props.author.avatarUrl||defaultAvatar;var _props=this.props,size=_props.size,style=_props.style;return Object.assign({},style,{backgroundImage:'url("'+avatarImage+'")',width:size,height:size});}},{key:'render',value:function render(){var className=this.props.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.root,className),style:this.getStyle()});}}]);return ProfileImage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProfileImage.propTypes={author:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};ProfileImage.defaultProps={author:'',size:48,defaultAvatar:__webpack_require__(2049)};/* harmony default export */ __webpack_exports__["a"] = (ProfileImage);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={root:{verticalAlign:'top',position:'relative',backgroundPosition:'center',backgroundRepeat:'no-repeat',display:'inline-block'},image:{display:'none'}};var ResponsiveImage=function(_Component){_inherits(ResponsiveImage,_Component);function ResponsiveImage(){_classCallCheck(this,ResponsiveImage);var _this=_possibleConstructorReturn(this,(ResponsiveImage.__proto__||Object.getPrototypeOf(ResponsiveImage)).apply(this,arguments));_this.getRootStyle=function(){var _this$props=_this.props,contain=_this$props.contain,style=_this$props.style,opacity=_this$props.opacity;return Object.assign({},styles.root,{width:'100%',opacity:opacity,objectFit:contain?'contain':'cover'},style);};_this.handleError=function(altrSrc){if(_this.state.errored){return;}var tokens=_this.state.src?_this.state.src.split('/'):altrSrc.split('/');tokens[2]=_this.props.fallback;var src=tokens.join('/');if(src.includes('/cache/files/')){src=src.replace('/files','');}_this.setState({errored:true,src:src});};_this.resize=function(url,nextRaw){if(nextRaw!==undefined?!nextRaw:!_this.props.raw){var size=_this.props.size;var tokens=url.split('.');var extension=tokens.pop();if(extension.length>4){tokens.push(extension);return tokens.join('.')+'-'+size;}return tokens.join('.')+'-'+size+'.'+extension;}};_this.state={errored:false,src:_this.props.src.endsWith('gif')?_this.props.src:_this.resize(_this.props.src)};return _this;}_createClass(ResponsiveImage,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(next,current){if(next.src!==this.props.src){this.setState({src:this.resize(next.src)});}if(next.raw!==this.props.raw){this.setState({src:this.resize(next.src,next.raw)});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,src=_props.src,children=_props.children,other=_objectWithoutProperties(_props,['src','children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',Object.assign({},other,{style:this.getRootStyle(),onError:function onError(){return _this2.handleError(src);},src:this.state.src||src})),children);}}]);return ResponsiveImage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ResponsiveImage.displayName='ResponsiveImage';ResponsiveImage.propTypes={src:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,fallback:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,contain:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,opacity:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,raw:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};ResponsiveImage.defaultProps={contain:false,opacity:1,size:512,fallback:'r.s.coursio.com/cache',raw:false};/* harmony default export */ __webpack_exports__["a"] = (ResponsiveImage);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={dropdown:{verticalAlign:'top',fontSize:'16px'},label:{lineHeight:'56px',display:'inline-block',verticalAlign:'top',fontWeight:700},menuItem:{fontSize:'16px'}};var DropDown=function(_Component){_inherits(DropDown,_Component);function DropDown(){_classCallCheck(this,DropDown);return _possibleConstructorReturn(this,(DropDown.__proto__||Object.getPrototypeOf(DropDown)).apply(this,arguments));}_createClass(DropDown,[{key:'getStyle',value:function getStyle(){return{display:this.props.fullWidth?'block':'inline-block'};}},{key:'render',value:function render(){var _props=this.props,label=_props.label,other=_objectWithoutProperties(_props,['label']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.label},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["DropDownMenu"],Object.assign({labelStyle:styles.dropdown,menuItemStyle:styles.menuItem,style:styles.dropdown},other)));}}]);return DropDown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DropDown);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ListSelector__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_Course__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_Course__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CourseSelector=function(_mixin){_inherits(CourseSelector,_mixin);function CourseSelector(){_classCallCheck(this,CourseSelector);return _possibleConstructorReturn(this,(CourseSelector.__proto__||Object.getPrototypeOf(CourseSelector)).apply(this,arguments));}_createClass(CourseSelector,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores_Course__["a" /* default */]);}},{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_4_actions_Course__["a" /* default */].findBuildable();}},{key:'getSelected',value:function getSelected(){return this.refs.list.getSelected();}},{key:'getBuildableCourses',value:function getBuildableCourses(){var _this2=this;var buildable=this.state.buildable;if(this.props.ignoreExistingCourses){return buildable.filter(function(course){return _this2.props.ignoreExistingCourses.every(function(id){return id!==course.id;});});}return buildable;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ListSelector__["a" /* default */],Object.assign({ref:'list',searchHint:this.context.getIntlMessage('course.choose')},this.props,{items:this.getBuildableCourses()}));}}]);return CourseSelector;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));CourseSelector.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};CourseSelector.propTypes={ignoreExistingCourses:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};/* harmony default export */ __webpack_exports__["a"] = (CourseSelector);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(2223);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(2224);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(2225);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(2227);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(625);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(271);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(2228);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropContext = __webpack_require__(632);

Object.defineProperty(exports, 'DragDropContext', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropContext).default;
  }
});

var _DragDropContextProvider = __webpack_require__(2281);

Object.defineProperty(exports, 'DragDropContextProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropContextProvider).default;
  }
});

var _DragLayer = __webpack_require__(412);

Object.defineProperty(exports, 'DragLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragLayer).default;
  }
});

var _DragSource = __webpack_require__(405);

Object.defineProperty(exports, 'DragSource', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragSource).default;
  }
});

var _DropTarget = __webpack_require__(408);

Object.defineProperty(exports, 'DropTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropTarget).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(637),
    overRest = __webpack_require__(2258),
    setToString = __webpack_require__(2260);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={textField:{fontSize:20// color: Colors.Colors.fullWhite,
},controls:{height:38,margin:0,padding:0,borderRadius:2,position:'absolute',transition:'all 0.3s ease',whiteSpace:'nowrap'},addPageButtonContainer:{cursor:'pointer',fontSize:'24px',lineHeight:'32px',height:38,fontWeight:300,paddingLeft:Spacing.desktopGutter,paddingRight:Spacing.desktopGutterMini,position:'relative'},addPageButton:{boxShadow:'none'},addSectionButton:{boxShadow:'none'},addPageLabel:{textAlign:'left'},addSectionButtonContainer:{cursor:'pointer',fontSize:'24px',minHeight:'32px',height:32,fontWeight:300,paddingLeft:Spacing.desktopGutterMini,paddingRight:Spacing.desktopGutterMini,position:'relative',marginTop:Spacing.desktopGutterMini},section:{position:'relative',paddingTop:16,paddingBottom:16},page:{cursor:'pointer',paddingLeft:22,paddingRight:18,borderStyle:'none none none solid',borderWidth:Spacing.desktopGutterMini/2,borderColor:'transparent',position:'relative',letterSpacing:'0.1px',lineHeight:'25.89px',paddingTop:5,paddingBottom:5},activePageHeader:{color:'#393939'},inactivePageHeader:{color:'#757575'},sectionHeader:{borderStyle:'none none none solid',borderWidth:Spacing.desktopGutterMini/2,borderColor:'transparent',position:'relative',fontSize:'20px',letterSpacing:'0.5px',lineHeight:'25.89px',paddingLeft:22,paddingRight:25,paddingTop:5,paddingBottom:5},activeSectionHeader:{color:'#393939'},inactiveSectionHeader:{color:'#757575'},taskCount:{lineHeight:'18px',minHeight:'18px',fontSize:'12px',paddingLeft:Spacing.desktopGutterMini,color:__WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__["a" /* Colors */].grey[400].material,position:'absolute',bottom:'0'},input:{color:__WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__["a" /* Colors */].fullWhite},coverCaption:{position:'absolute',left:0,right:0,bottom:0,top:0,height:246},coverCourseName:{position:'absolute',left:26,right:26,top:36,color:__WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,fontSize:'25.89px',letterSpacing:'0.1px',lineHeight:'41.89px'},coverCourseBy:{textTransform:'uppercase',color:__WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,position:'absolute',left:26,right:26,bottom:20,fontSize:14},logoContainer:{height:56,backgroundColor:__WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__["a" /* Colors */].fullBlack,opacity:0.4,padding:Spacing.desktopGutterMini/2,boxSizing:'border-box'},logo:{margin:'auto',display:'block',boxSizing:'border-box',height:48,maxWidth:'100%',maxHeight:48},answeredTask:{width:Spacing.desktopGutterMini*2,height:Spacing.desktopGutterMini,borderRadius:Spacing.desktopGutterMini/2,backgroundColor:__WEBPACK_IMPORTED_MODULE_0_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,display:'inline-block',marginRight:Spacing.desktopGutterMini/2},unansweredTask:{width:Spacing.desktopGutterMini*2,height:Spacing.desktopGutterMini,borderRadius:Spacing.desktopGutterMini/2,backgroundColor:'rgba(255, 255, 255, 0.4)',display:'inline-block',marginRight:Spacing.desktopGutterMini/2},coursioLogoContainer:{textAlign:'center',marginTop:Spacing.desktopGutterMore*2}};/* harmony default export */ __webpack_exports__["a"] = (styles);

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Css = __webpack_require__(6);

var _Portal = __webpack_require__(415);

var _Portal2 = _interopRequireDefault(_Portal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  bubble: 'cio_hs',
  padded: 'cio_ht',
  active: 'cio_hu',
  hasArrow: 'cio_hv'
};

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      top: null,
      left: null
    }, _this.handleMount = function (portal) {
      var anchorTo = _this.props.anchorTo;

      _this._anchor = anchorTo();
      _this._portal = portal;
      _this.position();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.position();
    }
  }, {
    key: 'getTooltipStyle',
    value: function getTooltipStyle() {
      var _state = this.state,
          top = _state.top,
          left = _state.left;
      var width = this.props.width;

      return {
        width: width,
        transform: 'translate3d( ' + (left || 0) + 'px, ' + (top || 0) + 'px, 0px)'
      };
    }
  }, {
    key: 'getPosition',
    value: function getPosition() {
      var getPosition = this.props.getPosition;

      var rect = this._anchor.getBoundingClientRect();
      var ownRect = this._portal.getBoundingClientRect();
      if (getPosition) {
        return getPosition(rect, ownRect);
      }
      return this.defaultPosition(rect, ownRect);
    }
  }, {
    key: 'defaultPosition',
    value: function defaultPosition(rect, ownRect) {
      return {
        left: rect.left - ownRect.width / 2 + rect.width / 2,
        top: rect.top + rect.height + _Css.Units.base * 2
      };
    }
  }, {
    key: 'position',
    value: function position() {
      var _getPosition = this.getPosition(),
          left = _getPosition.left,
          top = _getPosition.top;

      if (this.state.left !== left || this.state.top !== top) {
        this.setState({
          left: left,
          top: top
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          style = _props.style,
          padded = _props.padded,
          hasArrow = _props.hasArrow,
          other = _objectWithoutProperties(_props, ['children', 'style', 'padded', 'hasArrow']);

      var top = this.state.top;

      return _react2.default.createElement(
        _Portal2.default,
        _extends({
          onMount: this.handleMount,
          className: (0, _classnames2.default)(css.bubble, (_classNames = {}, _defineProperty(_classNames, css.hasArrow, hasArrow), _defineProperty(_classNames, css.padded, padded), _defineProperty(_classNames, css.active, top !== null), _classNames)),
          style: this.getTooltipStyle()
        }, other),
        children
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.propTypes = {
  children: _react.PropTypes.node,
  style: _react.PropTypes.object,
  anchorTo: _react.PropTypes.func,
  padded: _react.PropTypes.bool,
  getPosition: _react.PropTypes.func,
  hasArrow: _react.PropTypes.bool
};
Tooltip.defaultProps = {
  padded: true,
  hasArrow: true,
  width: 192
};
exports.default = Tooltip;
module.exports = exports['default'];

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Css__ = __webpack_require__(6);
var css={root:'_g4',edit:'_g5',container:'_g6',panel:'_g7',leftToolbarGroup:'_g8',toolbarHeader:'_g9',progress:'_g_',buttonContainer:'_g-',pad:'_ha'};/* harmony default export */ __webpack_exports__["a"] = (css);

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule React
 */



var ReactDOM = __webpack_require__(279);
var ReactDOMServer = __webpack_require__(727);
var ReactIsomorphic = __webpack_require__(731);

var assign = __webpack_require__(29);
var deprecated = __webpack_require__(734);

// `version` will be added here by ReactIsomorphic.
var React = {};

assign(React, ReactIsomorphic);

assign(React, {
  // ReactDOM
  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),

  // ReactDOMServer
  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
});

React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;

module.exports = React;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks static-only
 */



var invariant = __webpack_require__(20);

/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */
var keyMirror = function keyMirror(obj) {
  var ret = {};
  var key;
  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    ret[key] = key;
  }
  return ret;
};

module.exports = keyMirror;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setInnerHTML
 */

/* globals MSApp */



var ExecutionEnvironment = __webpack_require__(45);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = function (node, html) {
  node.innerHTML = html;
};

// Win8 apps: Allow all html to be inserted
if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
  setInnerHTML = function (node, html) {
    MSApp.execUnsafeLocalFunction(function () {
      node.innerHTML = html;
    });
  };
}

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xFEFF) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
}

module.exports = setInnerHTML;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule escapeTextContentForBrowser
 */



var ESCAPE_LOOKUP = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  '\'': '&#x27;'
};

var ESCAPE_REGEX = /[&><"']/g;

function escaper(match) {
  return ESCAPE_LOOKUP[match];
}

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  return ('' + text).replace(ESCAPE_REGEX, escaper);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactBrowserEventEmitter
 * @typechecks static-only
 */



var EventConstants = __webpack_require__(84);
var EventPluginHub = __webpack_require__(151);
var EventPluginRegistry = __webpack_require__(423);
var ReactEventEmitterMixin = __webpack_require__(678);
var ReactPerf = __webpack_require__(72);
var ViewportMetrics = __webpack_require__(284);

var assign = __webpack_require__(29);
var isEventSupported = __webpack_require__(285);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {

  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    var topLevelTypes = EventConstants.topLevelTypes;
    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === topLevelTypes.topWheel) {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === topLevelTypes.topScroll) {

          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {

          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening[topLevelTypes.topBlur] = true;
          isListening[topLevelTypes.topFocus] = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (!isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  },

  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,

  registrationNameModules: EventPluginHub.registrationNameModules,

  putListener: EventPluginHub.putListener,

  getListener: EventPluginHub.getListener,

  deleteListener: EventPluginHub.deleteListener,

  deleteAllListeners: EventPluginHub.deleteAllListeners

});

ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
  putListener: 'putListener',
  deleteListener: 'deleteListener'
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Transaction
 */



var invariant = __webpack_require__(20);

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var Mixin = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

var Transaction = {

  Mixin: Mixin,

  /**
   * Token to look for to determine if an error occurred.
   */
  OBSERVED_ERROR: {}

};

module.exports = Transaction;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypeLocations
 */



var keyMirror = __webpack_require__(211);

var ReactPropTypeLocations = keyMirror({
  prop: null,
  context: null,
  childContext: null
});

module.exports = ReactPropTypeLocations;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypeLocationNames
 */



var ReactPropTypeLocationNames = {};

if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticMouseEvent
 * @typechecks static-only
 */



var SyntheticUIEvent = __webpack_require__(155);
var ViewportMetrics = __webpack_require__(284);

var getEventModifierState = __webpack_require__(293);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(24);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(67);
var toLength = __webpack_require__(41);
var toAbsoluteIndex = __webpack_require__(127);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 222 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(77);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(30);
var cof = __webpack_require__(77);
var MATCH = __webpack_require__(35)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(35)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(22);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(59);
var redefine = __webpack_require__(60);
var fails = __webpack_require__(28);
var defined = __webpack_require__(88);
var wks = __webpack_require__(35);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(22);
var aFunction = __webpack_require__(47);
var SPECIES = __webpack_require__(35)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(24);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(60);
var redefineAll = __webpack_require__(133);
var meta = __webpack_require__(108);
var forOf = __webpack_require__(132);
var anInstance = __webpack_require__(131);
var isObject = __webpack_require__(30);
var fails = __webpack_require__(28);
var $iterDetect = __webpack_require__(225);
var setToStringTag = __webpack_require__(157);
var inheritIfRequired = __webpack_require__(313);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(24);
var hide = __webpack_require__(59);
var uid = __webpack_require__(124);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(125) || !__webpack_require__(28)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(24)[K];
});


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(4);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(4);
var aFunction = __webpack_require__(47);
var ctx = __webpack_require__(76);
var forOf = __webpack_require__(132);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var MediaLibraryActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['moveFiles','listDirectory','createDirectory','find','refresh','findById','findComplete','genericError','filter','setFilter','resetFilter','setSort','resetSort','delete','deleteComplete','toggleStyle','clearSelected','getFileInfo','getFileInfoComplete','toggleMode']);/* harmony default export */ __webpack_exports__["a"] = (MediaLibraryActions);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var StudentActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['findReaders','findReadersComplete','fetchAll','filter','filterComplete','genericError','setFilter','resetFilter','setSort','resetSort','findByGroupId','findByGroupIdComplete','findByCourseId','findByCourseIdComplete','findById','findByIdComplete','delete','removeFromCourse','removeFromGroup','removeFromCourseComplete','removeFromGroupComplete','removeTag','removeTagComplete','addTag','addTagComplete','export','exportComplete','update','updateComplete','countByCourseId','expel','expelComplete','exportStatistic','exportStatisticComplete']);/* harmony default export */ __webpack_exports__["a"] = (StudentActions);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var BundleActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['addTag','addTagComplete','removeTag','removeTagComplete','read','readComplete','create','createComplete','update','updateComplete','findById','findByIdError','findByIdComplete','remove','removeComplete','removeError','genericError']);/* harmony default export */ __webpack_exports__["a"] = (BundleActions);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var DiscountActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['read','readComplete','create','createComplete','update','updateComplete','findById','findByIdError','findByIdComplete','remove','removeComplete','removeError','genericError']);/* harmony default export */ __webpack_exports__["a"] = (DiscountActions);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var PageModuleActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['markModuleSaving','savePageModule',//
'savePageModuleComplete',//
'savePageModuleUserData','savePageModuleUserDataComplete','deletePageModule',//
'changePageModuleMode',//
'changePageModule']);/* harmony default export */ __webpack_exports__["a"] = (PageModuleActions);

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_Group__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_App__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__ = __webpack_require__(18);
var GroupStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */]],data:{list:[],buildable:[],detail:{},sort:{},participantCount:null,filter:{},selection:[],selected:null,selectionLoading:false},getInitialState:function getInitialState(){return this.data;},init:function init(){if(localStorage){var groups=JSON.parse(localStorage.getItem('groups'))||{};if(groups.filter){this.data.filter=groups.filter;}if(groups.sort){this.data.sort=groups.sort;}this.trigger(this.data);}},serialize:function serialize(){localStorage.setItem('groups',JSON.stringify({filter:this.data.filter,sort:this.data.sort}));},getFilter:function getFilter(){return this.data.filter;},onResetFilter:function onResetFilter(){this.data.filter={};this.trigger(this.data);this.serialize();},onSetFilter:function onSetFilter(filter){Object.assign(this.data.filter,filter);this.trigger(this.data);this.serialize();},onResetSort:function onResetSort(){this.data.sort={};this.trigger(this.data);this.serialize();},onSetSort:function onSetSort(sort){Object.assign(this.data.sort,sort);this.trigger(this.data);this.serialize();},hasFilter:function hasFilter(){return!!this.data.filter.courseId||!!this.data.filter.userId;},onFetchAll:function onFetchAll(){var _this=this;return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].call('search','filterCircles',{},function(response){_this.data.list=response.data;_this.trigger(_this.data);});},onFilter:function onFilter(dontUseFilter){var _this2=this;var options={sortBy:this.data.sort.property||'name',sortMode:this.data.sort.direction||'asc'};if(!dontUseFilter){options.courseId=this.data.filter.courseId;options.userId=this.data.filter.userId;}return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].call('search','filterCircles',options,function(response){_this2.data.list=response.data;_this2.trigger(_this2.data);});},onFindBuildable:function onFindBuildable(){return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('circle','findBuildable',{}).then(function(buildable){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].findBuildableComplete(buildable);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},onFindBuildableComplete:function onFindBuildableComplete(buildable){this.data.buildable=buildable;this.trigger(this.data);},onCreate:function onCreate(groupName){var _this3=this;return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('circle','create',{name:groupName}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].createComplete(data);_this3.data.selected=data;_this3.trigger(_this3.data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].genericError(error);});},onUpdate:function onUpdate(circleId,name){return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('circle','update',{id:circleId,name:name}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].updateComplete(circleId);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},updateComplete:function updateComplete(circleId){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].findById(circleId);},onFindByUserId:function onFindByUserId(userId,callback){this.data.selectionLoading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('search','filterCircles',{userId:userId,sortBy:'name',sortMode:'asc'}).then(function(selection){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].findByUserIdComplete(selection);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},onFindByUserIdComplete:function onFindByUserIdComplete(selection){this.data.selection=selection;this.data.selectionLoading=false;this.trigger(this.data);},onFindByCourseId:function onFindByCourseId(courseId){return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('search','filterCircles',{courseId:courseId,sortBy:'name',sortMode:'asc'}).then(function(groups){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].findByCourseIdComplete(groups);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},onFindByCourseIdComplete:function onFindByCourseIdComplete(groups){this.data.selection=groups;this.trigger(this.data);},removeFromCourse:function removeFromCourse(circleId,courseId){return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('circle','removeFromCourse',{circleId:circleId,courseId:courseId}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].removeFromCourseComplete(circleId);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},removeFromCourseComplete:function removeFromCourseComplete(circleId){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].translatableMessage('group.courseRemoved');__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].findById(circleId);},onRemoveFromSelection:function onRemoveFromSelection(groupId){var dirty=false;var selection=this.data.selection;for(var i=selection.length;i--;){if(selection[i].id===groupId){selection.splice(i,1);dirty=true;}}if(dirty){this.trigger(this.data);}},onFindById:function onFindById(groupId){return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('circle','findById',{id:groupId}).then(function(group){__WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('course','findByCircleId',{circleId:groupId,sortBy:'name',sortMode:'asc'}).then(function(courses){group.courses=courses;__WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('invitation','findByCircleId',{circleId:groupId,sortBy:'name',sortMode:'asc'}).then(function(invitations){group.invitations=invitations;__WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('user','findByCircleId',{circleId:groupId,sortBy:'name',sortMode:'asc'}).then(function(students){group.students=students;__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].findByIdComplete(group);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].genericError(error);});},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].genericError(error);});},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].genericError(error);});},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].genericError(error);});},onFindByIdComplete:function onFindByIdComplete(group){this.data.detail=group;this.trigger(this.data);},onDelete:function onDelete(groupId,revokeAccess,callback){return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].call('circle','delete',{id:groupId,revokeAccess:revokeAccess},function(response){if(callback&&!response.isError){callback();}});},onCountParticipants:function onCountParticipants(groupIds,callback){var _this4=this;return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].call('circle','countParticipants',{circleIds:groupIds},function(response){_this4.data.participantCount=response.data.simple;_this4.trigger(_this4.data);if(callback){callback();}});},addToCourse:function addToCourse(circleId,courseIds,endDate){var now=new Date();var ucpPeriod=(endDate-now)/1000;var notify=true;if(circleId&&circleId>0){return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('circle','addToCourse',{circleId:circleId,courseIds:courseIds,ucpPeriod:ucpPeriod,notify:notify}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].addToCourseComplete(circleId);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});}},addToCourseComplete:function addToCourseComplete(circleId){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].translatableMessage('group.coursesAdded');__WEBPACK_IMPORTED_MODULE_1_actions_Group__["a" /* default */].findById(circleId);}});/* harmony default export */ __webpack_exports__["a"] = (GroupStore);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var MediaLibraryStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_2_actions__["o" /* MediaLibraryActions */]],data:{grid:false,list:[],detail:{},breadcrumbs:[],saving:false,loading:true,selected:null,filter:{},sort:{}},serialize:function serialize(){localStorage.setItem('mediaLibrary',JSON.stringify({filter:this.data.filter,sort:this.data.sort,grid:this.data.grid}));},onDelete:function onDelete(ids){return __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].call('file','update',{id:ids,hide:true},function(){__WEBPACK_IMPORTED_MODULE_2_actions__["o" /* MediaLibraryActions */].deleteComplete(ids);});},onDeleteComplete:function onDeleteComplete(ids){this.data.list.forEach(function(file){if((typeof ids==='undefined'?'undefined':_typeof(ids))==='object'){if(ids.indexOf[file.id]>-1){file.deleted=true;}}else{if(file.id===ids){file.deleted=true;}}});this.trigger(this.data);},onGetFileInfoComplete:function onGetFileInfoComplete(data){this.data.selected=data;this.data.loading=false;this.trigger(this.data);},onGetFileInfo:function onGetFileInfo(id){this.data.loading=true;return __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].request('file','getFileInfo',{id:id}).then(function(data){if(data){__WEBPACK_IMPORTED_MODULE_2_actions__["o" /* MediaLibraryActions */].getFileInfoComplete(data[0]&&data[0]||null);}else{__WEBPACK_IMPORTED_MODULE_2_actions__["o" /* MediaLibraryActions */].genericError();}},function(error){__WEBPACK_IMPORTED_MODULE_2_actions__["o" /* MediaLibraryActions */].genericError(error);});},clearSelected:function clearSelected(){this.data.selected=null;this.trigger(this.data);},getFilter:function getFilter(){return this.data.filter;},onResetFilter:function onResetFilter(){this.data.filter={};this.trigger(this.data);this.serialize();},onSetFilter:function onSetFilter(filter){Object.assign(this.data.filter,filter);this.trigger(this.data);this.serialize();},onResetSort:function onResetSort(){this.data.sort={};this.trigger(this.data);this.serialize();},onSetSort:function onSetSort(sort){Object.assign(this.data.sort,sort);this.trigger(this.data);this.serialize();},moveFiles:function moveFiles(files){var _this=this;var breadcrumbs=this.data.breadcrumbs;var currentDir=breadcrumbs&&breadcrumbs.length>0&&breadcrumbs[0].id||0;var promises=files.map(function(file){return __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].request('file','move',{id:file.file.id,directoryId:currentDir});});Promise.all(promises).then(function(values){__WEBPACK_IMPORTED_MODULE_2_actions__["o" /* MediaLibraryActions */].listDirectory(currentDir);},function(error){_this.data=Object.assign({},_this.data,{loading:false});_this.trigger(_this.data);__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].genericError(error);});},getInitialState:function getInitialState(){this.data=Object.assign({},this.data,JSON.parse(localStorage.getItem('mediaLibrary')));return this.data;},find:function find(){return this.listDirectory();},createDirectory:function createDirectory(parentDirectoryId,name){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].request('file','createDirectory',{directoryId:parentDirectoryId,name:name}).then(function(){__WEBPACK_IMPORTED_MODULE_2_actions__["o" /* MediaLibraryActions */].listDirectory(parentDirectoryId);},function(error){_this2.data=Object.assign({},_this2.data,{loading:false});_this2.trigger(_this2.data);__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].genericError(error);});},listDirectory:function listDirectory(){var _this3=this;var dirId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var directoryId=parseInt(dirId,10);this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].request('file','listDirectory',{directoryId:directoryId}).then(function(response){__WEBPACK_IMPORTED_MODULE_2_actions__["o" /* MediaLibraryActions */].findComplete(response);},function(error){_this3.data=Object.assign({},_this3.data,{loading:false});_this3.trigger(_this3.data);__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].genericError(error);});},toggleMode:function toggleMode(){this.data=Object.assign({},this.data,{grid:!this.data.grid});this.trigger(this.data);this.serialize();},refresh:function refresh(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].request('file','find',{}).then(function(response){__WEBPACK_IMPORTED_MODULE_2_actions__["o" /* MediaLibraryActions */].findComplete(response);},function(error){_this4.data=Object.assign({},_this4.data,{loading:false});_this4.trigger(_this4.data);__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].genericError(error);});},findComplete:function findComplete(response){var files=response.files,breadcrumbs=response.breadcrumbs;this.data=Object.assign({},this.data,{list:files,breadcrumbs:breadcrumbs,loading:false});this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (MediaLibraryStore);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(347);

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var createFragment = __webpack_require__(1015);

module.exports = {

  create: function create(fragments) {
    var newFragments = {};
    var validChildrenCount = 0;
    var firstKey = undefined;

    //Only create non-empty key fragments
    for (var key in fragments) {
      var currentChild = fragments[key];

      if (currentChild) {
        if (validChildrenCount === 0) firstKey = key;
        newFragments[key] = currentChild;
        validChildrenCount++;
      }
    }

    if (validChildrenCount === 0) return undefined;
    if (validChildrenCount === 1) return newFragments[firstKey];
    return createFragment(newFragments);
  },

  extend: function extend(children, extendedProps, extendedChildren) {

    return React.isValidElement(children) ? React.Children.map(children, function (child) {

      var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;

      var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;

      return React.cloneElement(child, newProps, newChildren);
    }) : children;
  }

};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var PureRenderMixin = __webpack_require__(1);
var StylePropable = __webpack_require__(10);
var AutoPrefix = __webpack_require__(62);
var Colors = __webpack_require__(53);
var Transitions = __webpack_require__(21);
var ScaleInTransitionGroup = __webpack_require__(1017);

var pulsateDuration = 750;

var FocusRipple = React.createClass({
  displayName: 'FocusRipple',

  mixins: [PureRenderMixin, StylePropable],

  propTypes: {
    color: React.PropTypes.string,
    innerStyle: React.PropTypes.object,
    opacity: React.PropTypes.number,
    show: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      color: Colors.darkBlack
    };
  },

  componentDidMount: function componentDidMount() {
    if (this.props.show) {
      this._setRippleSize();
      this._pulsate();
    }
  },

  componentDidUpdate: function componentDidUpdate() {
    if (this.props.show) {
      this._setRippleSize();
      this._pulsate();
    } else {
      if (this._timeout) clearTimeout(this._timeout);
    }
  },

  render: function render() {
    var _props = this.props;
    var show = _props.show;
    var style = _props.style;

    var mergedRootStyles = this.mergeStyles({
      height: '100%',
      width: '100%',
      position: 'absolute',
      top: 0,
      left: 0
    }, style);

    var ripple = show ? this._getRippleElement(this.props) : null;

    return React.createElement(
      ScaleInTransitionGroup,
      {
        maxScale: 0.85,
        style: mergedRootStyles },
      ripple
    );
  },

  _getRippleElement: function _getRippleElement(props) {
    var color = props.color;
    var innerStyle = props.innerStyle;
    var opacity = props.opacity;

    var innerStyles = this.mergeAndPrefix({
      position: 'absolute',
      height: '100%',
      width: '100%',
      borderRadius: '50%',
      opacity: opacity ? opacity : 0.16,
      backgroundColor: color,
      transition: Transitions.easeOut(pulsateDuration + 'ms', 'transform', null, Transitions.easeInOutFunction)
    }, innerStyle);

    return React.createElement('div', { ref: 'innerCircle', style: innerStyles });
  },

  _pulsate: function _pulsate() {
    if (!this.isMounted()) return;

    var innerCircle = ReactDOM.findDOMNode(this.refs.innerCircle);
    if (!innerCircle) return;

    var startScale = 'scale(1)';
    var endScale = 'scale(0.85)';
    var currentScale = innerCircle.style[AutoPrefix.single('transform')];
    var nextScale = undefined;

    currentScale = currentScale || startScale;
    nextScale = currentScale === startScale ? endScale : startScale;

    innerCircle.style[AutoPrefix.single('transform')] = nextScale;
    this._timeout = setTimeout(this._pulsate, pulsateDuration);
  },

  _setRippleSize: function _setRippleSize() {
    var el = ReactDOM.findDOMNode(this.refs.innerCircle);
    var height = el.offsetHeight;
    var width = el.offsetWidth;
    var size = Math.max(height, width);

    var oldTop = 0;
    // For browsers that don't support endsWith()
    if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
      oldTop = parseInt(el.style.top);
    }
    el.style.height = size + 'px';
    el.style.top = height / 2 - size / 2 + oldTop + 'px';
  }

});

module.exports = FocusRipple;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var ColorManipulator = __webpack_require__(95);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var UniqueId = __webpack_require__(357);
var EnhancedTextarea = __webpack_require__(1040);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);
var ContextPure = __webpack_require__(136);

/**
 * Check if a value is valid to be displayed inside an input.
 *
 * @param The value to check.
 * @returns True if the string provided is valid, false otherwise.
 */
function isValid(value) {
  return value || value === 0;
}

var TextField = React.createClass({
  displayName: 'TextField',

  mixins: [ContextPure, StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    errorStyle: React.PropTypes.object,
    errorText: React.PropTypes.string,
    floatingLabelStyle: React.PropTypes.object,
    floatingLabelText: React.PropTypes.string,
    fullWidth: React.PropTypes.bool,
    hintText: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
    hintStyle: React.PropTypes.object,
    id: React.PropTypes.string,
    inputStyle: React.PropTypes.object,
    multiLine: React.PropTypes.bool,
    onBlur: React.PropTypes.func,
    onChange: React.PropTypes.func,
    onEnterKeyDown: React.PropTypes.func,
    onFocus: React.PropTypes.func,
    onKeyDown: React.PropTypes.func,
    rows: React.PropTypes.number,
    rowsMax: React.PropTypes.number,
    type: React.PropTypes.string,
    underlineStyle: React.PropTypes.object,
    underlineFocusStyle: React.PropTypes.object,
    underlineDisabledStyle: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      fullWidth: false,
      type: 'text',
      rows: 1
    };
  },

  statics: {
    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
      var textFieldTheme = muiTheme.textField;

      return {
        floatingLabelColor: textFieldTheme.floatingLabelColor,
        focusColor: textFieldTheme.focusColor,
        borderColor: textFieldTheme.borderColor,
        textColor: textFieldTheme.textColor,
        disabledTextColor: textFieldTheme.disabledTextColor,
        backgroundColor: textFieldTheme.backgroundColor,
        hintColor: textFieldTheme.hintColor,
        errorColor: textFieldTheme.errorColor
      };
    },
    getChildrenClasses: function getChildrenClasses() {
      return [EnhancedTextarea];
    }
  },

  getInitialState: function getInitialState() {
    var props = this.props.children ? this.props.children.props : this.props;

    return {
      errorText: this.props.errorText,
      hasValue: isValid(props.value) || isValid(props.defaultValue) || props.valueLink && isValid(props.valueLink.value),
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  componentDidMount: function componentDidMount() {
    this._uniqueId = UniqueId.generate();
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newState = {};
    newState.muiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;

    newState.errorText = nextProps.errorText;
    if (nextProps.children && nextProps.children.props) {
      nextProps = nextProps.children.props;
    }

    var hasValueLinkProp = nextProps.hasOwnProperty('valueLink');
    var hasValueProp = nextProps.hasOwnProperty('value');
    var hasNewDefaultValue = nextProps.defaultValue !== this.props.defaultValue;

    if (hasValueLinkProp) {
      newState.hasValue = isValid(nextProps.valueLink.value);
    } else if (hasValueProp) {
      newState.hasValue = isValid(nextProps.value);
    } else if (hasNewDefaultValue) {
      newState.hasValue = isValid(nextProps.defaultValue);
    }

    if (newState) this.setState(newState);
  },

  getStyles: function getStyles() {
    var props = this.props;

    var _constructor$getRelevantContextKeys = this.constructor.getRelevantContextKeys(this.state.muiTheme);

    var floatingLabelColor = _constructor$getRelevantContextKeys.floatingLabelColor;
    var focusColor = _constructor$getRelevantContextKeys.focusColor;
    var borderColor = _constructor$getRelevantContextKeys.borderColor;
    var textColor = _constructor$getRelevantContextKeys.textColor;
    var disabledTextColor = _constructor$getRelevantContextKeys.disabledTextColor;
    var backgroundColor = _constructor$getRelevantContextKeys.backgroundColor;
    var hintColor = _constructor$getRelevantContextKeys.hintColor;
    var errorColor = _constructor$getRelevantContextKeys.errorColor;

    var styles = {
      root: {
        fontSize: 16,
        lineHeight: '24px',
        width: props.fullWidth ? '100%' : 256,
        height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
        display: 'inline-block',
        position: 'relative',
        fontFamily: this.state.muiTheme.rawTheme.fontFamily,
        transition: Transitions.easeOut('200ms', 'height')
      },
      error: {
        position: 'relative',
        bottom: 5,
        fontSize: 12,
        lineHeight: '12px',
        color: errorColor,
        transition: Transitions.easeOut()
      },
      hint: {
        position: 'absolute',
        lineHeight: '22px',
        opacity: 1,
        color: hintColor,
        transition: Transitions.easeOut(),
        bottom: 12
      },
      input: {
        tapHighlightColor: 'rgba(0,0,0,0)',
        padding: 0,
        position: 'relative',
        width: '100%',
        height: '100%',
        border: 'none',
        outline: 'none',
        backgroundColor: backgroundColor,
        color: props.disabled ? disabledTextColor : textColor,
        font: 'inherit'
      },
      underline: {
        border: 'none',
        borderBottom: 'solid 1px ' + borderColor,
        position: 'absolute',
        width: '100%',
        bottom: 8,
        margin: 0,
        MozBoxSizing: 'content-box',
        boxSizing: 'content-box',
        height: 0
      },
      underlineAfter: {
        position: 'absolute',
        width: '100%',
        overflow: 'hidden',
        userSelect: 'none',
        cursor: 'default',
        bottom: 8,
        borderBottom: 'dotted 2px ' + disabledTextColor
      },
      underlineFocus: {
        borderBottom: 'solid 2px',
        borderColor: focusColor,
        transform: 'scaleX(0)',
        transition: Transitions.easeOut()
      }
    };

    styles.error = this.mergeAndPrefix(styles.error, props.errorStyle);
    styles.underline = this.mergeAndPrefix(styles.underline, props.underlineStyle);
    styles.underlineAfter = this.mergeAndPrefix(styles.underlineAfter, props.underlineDisabledStyle);

    styles.floatingLabel = this.mergeStyles(styles.hint, {
      lineHeight: '22px',
      top: 38,
      bottom: 'none',
      opacity: 1,
      transform: 'scale(1) translate3d(0, 0, 0)',
      transformOrigin: 'left top'
    });

    styles.textarea = this.mergeStyles(styles.input, {
      marginTop: props.floatingLabelText ? 36 : 12,
      marginBottom: props.floatingLabelText ? -36 : -12,
      boxSizing: 'border-box',
      font: 'inherit'
    });

    styles.focusUnderline = this.mergeStyles(styles.underline, styles.underlineFocus, props.underlineFocusStyle);

    if (this.state.isFocused) {
      styles.floatingLabel.color = focusColor;
      styles.floatingLabel.transform = 'perspective(1px) scale(0.75) translate3d(2px, -28px, 0)';
      styles.focusUnderline.transform = 'scaleX(1)';
    }

    if (this.state.hasValue) {
      styles.floatingLabel.color = ColorManipulator.fade(props.disabled ? disabledTextColor : floatingLabelColor, 0.5);
      styles.floatingLabel.transform = 'perspective(1px) scale(0.75) translate3d(2px, -28px, 0)';
      styles.hint.opacity = 0;
    }

    if (props.floatingLabelText) {
      styles.hint.opacity = 0;
      styles.input.boxSizing = 'border-box';
      if (this.state.isFocused && !this.state.hasValue) styles.hint.opacity = 1;
    }

    if (props.style && props.style.height) {
      styles.hint.lineHeight = props.style.height;
    }

    if (this.state.errorText && this.state.isFocused) styles.floatingLabel.color = styles.error.color;
    if (props.floatingLabelText && !props.multiLine) styles.input.marginTop = 14;

    if (this.state.errorText) {
      styles.focusUnderline.borderColor = styles.error.color;
      styles.focusUnderline.transform = 'scaleX(1)';
    }

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var className = _props.className;
    var errorStyle = _props.errorStyle;
    var errorText = _props.errorText;
    var floatingLabelText = _props.floatingLabelText;
    var fullWidth = _props.fullWidth;
    var hintText = _props.hintText;
    var hintStyle = _props.hintStyle;
    var id = _props.id;
    var multiLine = _props.multiLine;
    var onBlur = _props.onBlur;
    var onChange = _props.onChange;
    var onFocus = _props.onFocus;
    var type = _props.type;
    var rows = _props.rows;
    var rowsMax = _props.rowsMax;

    var other = _objectWithoutProperties(_props, ['className', 'errorStyle', 'errorText', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'type', 'rows', 'rowsMax']);

    var styles = this.getStyles();

    var inputId = id || this._uniqueId;

    var errorTextElement = this.state.errorText ? React.createElement(
      'div',
      { style: this.prepareStyles(styles.error) },
      this.state.errorText
    ) : null;

    var hintTextElement = hintText ? React.createElement(
      'div',
      { style: this.prepareStyles(styles.hint, hintStyle) },
      hintText
    ) : null;

    var floatingLabelTextElement = floatingLabelText ? React.createElement(
      'label',
      {
        style: this.prepareStyles(styles.floatingLabel, this.props.floatingLabelStyle),
        htmlFor: inputId },
      floatingLabelText
    ) : null;

    var inputProps = undefined;
    var inputElement = undefined;

    inputProps = {
      id: inputId,
      ref: this._getRef(),
      onBlur: this._handleInputBlur,
      onFocus: this._handleInputFocus,
      disabled: this.props.disabled,
      onKeyDown: this._handleInputKeyDown
    };
    var inputStyle = this.mergeStyles(styles.input, this.props.inputStyle);

    if (!this.props.hasOwnProperty('valueLink')) {
      inputProps.onChange = this._handleInputChange;
    }
    if (this.props.children) {
      inputElement = React.cloneElement(this.props.children, _extends({}, inputProps, this.props.children.props));
    } else {
      inputElement = multiLine ? React.createElement(EnhancedTextarea, _extends({}, other, inputProps, {
        style: inputStyle,
        rows: rows,
        rowsMax: rowsMax,
        onHeightChange: this._handleTextAreaHeightChange,
        textareaStyle: this.mergeAndPrefix(styles.textarea) })) : React.createElement('input', _extends({}, other, inputProps, {
        style: this.prepareStyles(inputStyle),
        type: type }));
    }

    var underlineElement = this.props.disabled ? React.createElement('div', { style: this.prepareStyles(styles.underlineAfter) }) : React.createElement('hr', { style: this.prepareStyles(styles.underline) });
    var focusUnderlineElement = React.createElement('hr', { style: this.prepareStyles(styles.focusUnderline) });

    return React.createElement(
      'div',
      { className: className, style: this.prepareStyles(styles.root, this.props.style) },
      floatingLabelTextElement,
      hintTextElement,
      inputElement,
      underlineElement,
      focusUnderlineElement,
      errorTextElement
    );
  },

  blur: function blur() {
    if (this.isMounted()) this._getInputNode().blur();
  },

  clearValue: function clearValue() {
    this.setValue('');
  },

  focus: function focus() {
    if (this.isMounted()) this._getInputNode().focus();
  },

  getValue: function getValue() {
    return this.isMounted() ? this._getInputNode().value : undefined;
  },

  setErrorText: function setErrorText(newErrorText) {
    if (false) {
      console.error('Cannot call TextField.setErrorText when errorText is defined as a property.');
    } else if (this.isMounted()) {
      this.setState({ errorText: newErrorText });
    }
  },

  setValue: function setValue(newValue) {
    if (false) {
      console.error('Cannot call TextField.setValue when value or valueLink is defined as a property.');
    } else if (this.isMounted()) {
      if (this.props.multiLine) {
        this.refs[this._getRef()].setValue(newValue);
      } else {
        this._getInputNode().value = newValue;
      }

      this.setState({ hasValue: isValid(newValue) });
    }
  },

  _getRef: function _getRef() {
    return this.props.ref ? this.props.ref : 'input';
  },

  _getInputNode: function _getInputNode() {
    return this.props.children || this.props.multiLine ? this.refs[this._getRef()].getInputNode() : ReactDOM.findDOMNode(this.refs[this._getRef()]);
  },

  _handleInputBlur: function _handleInputBlur(e) {
    this.setState({ isFocused: false });
    if (this.props.onBlur) this.props.onBlur(e);
  },

  _handleInputChange: function _handleInputChange(e) {
    this.setState({ hasValue: isValid(e.target.value) });
    if (this.props.onChange) this.props.onChange(e);
  },

  _handleInputFocus: function _handleInputFocus(e) {
    if (this.props.disabled) return;
    this.setState({ isFocused: true });
    if (this.props.onFocus) this.props.onFocus(e);
  },

  _handleInputKeyDown: function _handleInputKeyDown(e) {
    if (e.keyCode === 13 && this.props.onEnterKeyDown) this.props.onEnterKeyDown(e);
    if (this.props.onKeyDown) this.props.onKeyDown(e);
  },

  _handleTextAreaHeightChange: function _handleTextAreaHeightChange(e, height) {
    var newHeight = height + 24;
    if (this.props.floatingLabelText) newHeight += 24;
    ReactDOM.findDOMNode(this).style.height = newHeight + 'px';
  },

  _isControlled: function _isControlled() {
    return this.props.hasOwnProperty('value') || this.props.hasOwnProperty('valueLink');
  }

});

module.exports = TextField;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var CssEvent = __webpack_require__(192);
var KeyLine = __webpack_require__(531);
var KeyCode = __webpack_require__(79);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var ClickAwayable = __webpack_require__(163);
var Paper = __webpack_require__(54);
var MenuItem = __webpack_require__(532);
var LinkMenuItem = __webpack_require__(1042);
var SubheaderMenuItem = __webpack_require__(1043);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

/***********************
* Nested Menu Component
***********************/
var NestedMenuItem = React.createClass({
  displayName: 'NestedMenuItem',

  mixins: [ClickAwayable, StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    index: React.PropTypes.number.isRequired,
    text: React.PropTypes.string,
    menuItems: React.PropTypes.array.isRequired,
    zDepth: React.PropTypes.number,
    disabled: React.PropTypes.bool,
    active: React.PropTypes.bool,
    onItemTap: React.PropTypes.func,
    menuItemStyle: React.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false
    };
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme),
      open: false,
      activeIndex: 0
    };
  },

  componentClickAway: function componentClickAway() {
    this._closeNestedMenu();
  },

  componentDidMount: function componentDidMount() {
    this._positionNestedMenu();
    ReactDOM.findDOMNode(this).focus();
  },

  componentDidUpdate: function componentDidUpdate() {
    this._positionNestedMenu();
  },

  getSpacing: function getSpacing() {
    return this.state.muiTheme.rawTheme.spacing;
  },

  getStyles: function getStyles() {
    var styles = {
      root: {
        userSelect: 'none',
        cursor: 'pointer',
        lineHeight: this.getTheme().height + 'px',
        color: this.state.muiTheme.rawTheme.palette.textColor
      },
      icon: {
        float: 'left',
        lineHeight: this.getTheme().height + 'px',
        marginRight: this.getSpacing().desktopGutter
      },
      toggle: {
        marginTop: (this.getTheme().height - this.state.muiTheme.radioButton.size) / 2,
        float: 'right',
        width: 42
      },
      rootWhenHovered: {
        backgroundColor: this.getTheme().hoverColor
      },
      rootWhenSelected: {
        color: this.getTheme().selectedTextColor
      },
      rootWhenDisabled: {
        cursor: 'default',
        color: this.state.muiTheme.rawTheme.palette.disabledColor
      }
    };

    return styles;
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.menuItem;
  },

  render: function render() {
    var styles = this.getStyles();
    styles = this.prepareStyles(styles.root, this.props.active && !this.props.disabled && styles.rootWhenHovered, {
      position: 'relative'
    }, this.props.style);

    var iconCustomArrowDropRight = {
      marginRight: this.getSpacing().desktopGutterMini * -1,
      color: this.state.muiTheme.dropDownMenu.accentColor
    };

    var _props = this.props;
    var index = _props.index;
    var menuItemStyle = _props.menuItemStyle;

    var other = _objectWithoutProperties(_props, ['index', 'menuItemStyle']);

    return React.createElement(
      'div',
      {
        ref: 'root',
        style: styles,
        onMouseEnter: this._openNestedMenu,
        onMouseLeave: this._closeNestedMenu,
        onMouseOver: this._handleMouseOver,
        onMouseOut: this._handleMouseOut },
      React.createElement(
        MenuItem,
        {
          index: index,
          style: menuItemStyle,
          disabled: this.props.disabled,
          iconRightStyle: iconCustomArrowDropRight,
          iconRightClassName: 'muidocs-icon-custom-arrow-drop-right',
          onTouchTap: this._onParentItemTap },
        this.props.text
      ),
      React.createElement(Menu, _extends({}, other, {
        ref: 'nestedMenu',
        menuItems: this.props.menuItems,
        menuItemStyle: menuItemStyle,
        onItemTap: this._onMenuItemTap,
        hideable: true,
        visible: this.state.open,
        onRequestClose: this._closeNestedMenu,
        zDepth: this.props.zDepth + 1 }))
    );
  },

  toggleNestedMenu: function toggleNestedMenu() {
    if (!this.props.disabled) this.setState({ open: !this.state.open });
  },

  isOpen: function isOpen() {
    return this.state.open;
  },

  _positionNestedMenu: function _positionNestedMenu() {
    var el = ReactDOM.findDOMNode(this);
    var nestedMenu = ReactDOM.findDOMNode(this.refs.nestedMenu);
    nestedMenu.style.left = el.offsetWidth + 'px';
  },

  _openNestedMenu: function _openNestedMenu() {
    if (!this.props.disabled) this.setState({ open: true });
  },

  _closeNestedMenu: function _closeNestedMenu() {
    this.setState({ open: false });
    ReactDOM.findDOMNode(this).focus();
  },

  _onParentItemTap: function _onParentItemTap() {
    this.toggleNestedMenu();
  },

  _onMenuItemTap: function _onMenuItemTap(e, index, menuItem) {
    if (this.props.onItemTap) this.props.onItemTap(e, index, menuItem);
    this._closeNestedMenu();
  },
  _handleMouseOver: function _handleMouseOver(e) {
    if (!this.props.disabled && this.props.onMouseOver) this.props.onMouseOver(e, this.props.index);
  },

  _handleMouseOut: function _handleMouseOut(e) {
    if (!this.props.disabled && this.props.onMouseOut) this.props.onMouseOut(e, this.props.index);
  }

});

/****************
* Menu Component
****************/
var Menu = React.createClass({
  displayName: 'Menu',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    autoWidth: React.PropTypes.bool,
    onItemTap: React.PropTypes.func,
    onToggle: React.PropTypes.func,
    onRequestClose: React.PropTypes.func,
    menuItems: React.PropTypes.array.isRequired,
    selectedIndex: React.PropTypes.number,
    hideable: React.PropTypes.bool,
    visible: React.PropTypes.bool,
    zDepth: React.PropTypes.number,
    menuItemStyle: React.PropTypes.object,
    menuItemStyleSubheader: React.PropTypes.object,
    menuItemStyleLink: React.PropTypes.object,
    menuItemClassName: React.PropTypes.string,
    menuItemClassNameSubheader: React.PropTypes.string,
    menuItemClassNameLink: React.PropTypes.string
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme),
      nestedMenuShown: false,
      activeIndex: 0
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autoWidth: true,
      hideable: false,
      visible: true,
      zDepth: 1,
      onRequestClose: function onRequestClose() {}
    };
  },

  componentDidMount: function componentDidMount() {
    var el = ReactDOM.findDOMNode(this);

    //Set the menu width
    this._setKeyWidth(el);

    //Show or Hide the menu according to visibility
    this._renderVisibility();
  },

  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible || this.props.menuItems.length !== prevProps.menuItems.length) {
      this._renderVisibility();
    }
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });

    //Set the menu width
    this._setKeyWidth(ReactDOM.findDOMNode(this));
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.menu;
  },

  getSpacing: function getSpacing() {
    return this.state.muiTheme.rawTheme.spacing;
  },

  getStyles: function getStyles() {
    var styles = {
      root: {
        backgroundColor: this.getTheme().containerBackgroundColor,
        paddingTop: this.getSpacing().desktopGutterMini,
        paddingBottom: this.getSpacing().desktopGutterMini,
        transition: Transitions.easeOut(null, 'height'),
        outline: 'none !important'
      },
      subheader: {
        paddingLeft: this.state.muiTheme.menuSubheader.padding,
        paddingRight: this.state.muiTheme.menuSubheader.padding
      },
      hideable: {
        overflow: 'hidden',
        position: 'absolute',
        top: 0,
        zIndex: 1
      },
      item: {
        height: 34
      }
    };

    return styles;
  },

  render: function render() {
    var styles = this.getStyles();
    return React.createElement(
      Paper,
      {
        ref: 'paperContainer',
        tabIndex: '0',
        onKeyDown: this._onKeyDown,
        zDepth: this.props.zDepth,
        style: this.mergeStyles(styles.root, this.props.hideable && styles.hideable, this.props.style) },
      this._getChildren()
    );
  },

  _getChildren: function _getChildren() {
    var menuItem = undefined,
        itemComponent = undefined,
        isDisabled = undefined;

    var styles = this.getStyles();

    this._children = [];
    //This array is used to keep track of all nested menu refs
    this._nestedChildren = [];

    for (var i = 0; i < this.props.menuItems.length; i++) {
      menuItem = this.props.menuItems[i];
      isDisabled = menuItem.disabled === undefined ? false : menuItem.disabled;

      var _menuItem = menuItem;
      var icon = _menuItem.icon;
      var data = _menuItem.data;
      var attribute = _menuItem.attribute;
      var number = _menuItem.number;
      var toggle = _menuItem.toggle;
      var onTouchTap = _menuItem.onTouchTap;

      var other = _objectWithoutProperties(_menuItem, ['icon', 'data', 'attribute', 'number', 'toggle', 'onTouchTap']);

      switch (menuItem.type) {

        case MenuItem.Types.LINK:
          itemComponent = React.createElement(LinkMenuItem, {
            key: i,
            index: i,
            active: this.state.activeIndex === i,
            text: menuItem.text,
            disabled: isDisabled,
            className: this.props.menuItemClassNameLink,
            style: this.props.menuItemStyleLink,
            payload: menuItem.payload,
            target: menuItem.target });
          break;

        case MenuItem.Types.SUBHEADER:
          itemComponent = React.createElement(SubheaderMenuItem, {
            key: i,
            index: i,
            className: this.props.menuItemClassNameSubheader,
            style: this.mergeStyles(styles.subheader, this.props.menuItemStyleSubheader),
            firstChild: i === 0,
            text: menuItem.text });
          break;

        case MenuItem.Types.NESTED:
          var _props2 = this.props,
              ref = _props2.ref,
              key = _props2.key,
              index = _props2.index,
              zDepth = _props2.zDepth,
              other = _objectWithoutProperties(_props2, ['ref', 'key', 'index', 'zDepth']);

          itemComponent = React.createElement(NestedMenuItem, _extends({}, other, {
            ref: i,
            key: i,
            index: i,
            nested: true,
            active: this.state.activeIndex === i,
            text: menuItem.text,
            disabled: isDisabled,
            menuItems: menuItem.items,
            menuItemStyle: this.props.menuItemStyle,
            zDepth: this.props.zDepth,
            onMouseEnter: this._onItemActivated,
            onMouseLeave: this._onItemDeactivated,
            onItemTap: this._onNestedItemTap }));
          this._nestedChildren.push(i);
          break;

        default:
          itemComponent = React.createElement(
            MenuItem,
            _extends({}, other, {
              selected: this.props.selectedIndex === i,
              key: i,
              index: i,
              active: this.state.activeIndex === i,
              icon: menuItem.icon,
              data: menuItem.data,
              className: this.props.menuItemClassName,
              style: this.props.menuItemStyle,
              attribute: menuItem.attribute,
              number: menuItem.number,
              toggle: menuItem.toggle,
              onToggle: this.props.onToggle,
              disabled: isDisabled,
              onTouchTap: this._onItemTap,
              onMouseEnter: this._onItemActivated,
              onMouseLeave: this._onItemDeactivated
            }),
            menuItem.text
          );
      }
      this._children.push(itemComponent);
    }

    return this._children;
  },

  _setKeyWidth: function _setKeyWidth(el) {
    //Update the menu width
    var menuWidth = '100%';

    if (this.props.autoWidth) {
      el.style.width = 'auto';
      menuWidth = KeyLine.getIncrementalDim(el.offsetWidth) + 'px';
    }

    el.style.width = menuWidth;
  },

  _renderVisibility: function _renderVisibility() {
    if (this.props.hideable) {
      if (this.props.visible) this._expandHideableMenu();else this._collapseHideableMenu();
    }
  },

  _expandHideableMenu: function _expandHideableMenu() {
    var _this = this;

    var el = ReactDOM.findDOMNode(this);
    var container = ReactDOM.findDOMNode(this.refs.paperContainer);
    var padding = this.getSpacing().desktopGutterMini;
    var height = this._getHiddenMenuHeight(el, padding);

    //Add transition
    if (!el.style.transition) {
      el.style.transition = Transitions.easeOut();
    }

    this._nextAnimationFrame(function () {
      container.style.overflow = 'hidden';

      // Yeild to the DOM, then apply height and padding. This makes the transition smoother.
      el.style.paddingTop = padding + 'px';
      el.style.paddingBottom = padding + 'px';
      el.style.height = height + 'px';
      el.style.opacity = 1;

      //Set the overflow to visible after the animation is done so
      //that other nested menus can be shown
      CssEvent.onTransitionEnd(el, function () {
        //Make sure the menu is open before setting the overflow.
        //This is to accout for fast clicks
        if (_this.props.visible) container.style.overflow = 'visible';
        el.style.transition = null;
        el.focus();
      });
    });
  },

  _getHiddenMenuHeight: function _getHiddenMenuHeight(el, padding) {
    //Add padding to the offset height, because it is not yet set in the style.
    var height = padding * 2;

    //Hide the element and allow the browser to automatically resize it.
    el.style.visibility = 'hidden';
    el.style.height = 'auto';

    //Determine the height of the menu.
    height += el.offsetHeight;

    //Unhide the menu with the height set back to zero.
    el.style.height = '0px';
    el.style.visibility = 'visible';

    return height;
  },

  _collapseHideableMenu: function _collapseHideableMenu() {
    var el = ReactDOM.findDOMNode(this);
    var container = ReactDOM.findDOMNode(this.refs.paperContainer);
    var originalOpacity = el.style.opacity;

    //Add transition
    if (!el.style.transition && originalOpacity !== '') {
      el.style.transition = Transitions.easeOut();
    }

    this._nextAnimationFrame(function () {
      //Set the overflow to hidden so that animation works properly
      container.style.overflow = 'hidden';

      //Close the menu
      el.style.opacity = 0;
      el.style.height = '0px';
      el.style.paddingTop = '0px';
      el.style.paddingBottom = '0px';

      var end = function end() {
        el.style.transition = null;
      };

      if (originalOpacity === '') end();else CssEvent.onTransitionEnd(el, end);
    });
  },

  _nextAnimationFrame: function _nextAnimationFrame(func) {
    if (window.requestAnimationFrame) {
      return window.requestAnimationFrame(func);
    }
    return setTimeout(func, 16);
  },

  _onNestedItemTap: function _onNestedItemTap(e, index, menuItem) {
    if (this.props.onItemTap) this.props.onItemTap(e, index, menuItem);
  },

  _onItemTap: function _onItemTap(e, index) {
    if (this.props.onItemTap) this.props.onItemTap(e, index, this.props.menuItems[index]);
  },

  _onItemToggle: function _onItemToggle(e, index, toggled) {
    if (this.props.onItemToggle) this.props.onItemToggle(e, index, this.props.menuItems[index], toggled);
  },
  _onItemActivated: function _onItemActivated(e, index) {
    this.setState({ activeIndex: index });
  },
  _onItemDeactivated: function _onItemDeactivated(e, index) {
    if (this.state.activeKey === index) this.setState({ activeIndex: 0 });
  },

  _onKeyDown: function _onKeyDown(e) {
    if (!(this.state.open || this.props.visible)) return;

    var nested = this._children[this.state.activeIndex];
    if (nested && nested.props.nested && this.refs[this.state.activeIndex].isOpen()) return;

    switch (e.which) {
      case KeyCode.UP:
        this._activatePreviousItem();
        break;
      case KeyCode.DOWN:
        this._activateNextItem();
        break;
      case KeyCode.RIGHT:
        this._tryToggleNested(this.state.activeIndex);
        break;
      case KeyCode.LEFT:
        this._close();
        break;
      case KeyCode.ESC:
        this._close();
        break;
      case KeyCode.TAB:
        this._close();
        return; // so the tab key can propagate
      case KeyCode.ENTER:
      case KeyCode.SPACE:
        e.stopPropagation(); // needs called before the close
        this._triggerSelection(e);
        break;
      default:
        return; //important
    }
    e.preventDefault();
    e.stopPropagation();
  },

  _activatePreviousItem: function _activatePreviousItem() {
    var active = this.state.activeIndex || 0;
    active = Math.max(active - 1, 0);
    this.setState({ activeIndex: active });
  },

  _activateNextItem: function _activateNextItem() {
    var active = this.state.activeIndex || 0;
    active = Math.min(active + 1, this._children.length - 1);
    this.setState({ activeIndex: active });
  },

  _triggerSelection: function _triggerSelection(e) {
    var index = this.state.activeIndex || 0;
    this._onItemTap(e, index);
  },

  _close: function _close() {
    this.props.onRequestClose();
  },

  _tryToggleNested: function _tryToggleNested(index) {
    var item = this.refs[index];
    if (item && item.toggleNestedMenu) item.toggleNestedMenu();
  }

});

module.exports = Menu;

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalizr__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_normalizr__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var module=new __WEBPACK_IMPORTED_MODULE_3_normalizr__["Schema"]('pageModules');var row=new __WEBPACK_IMPORTED_MODULE_3_normalizr__["Schema"]('pageRows');var page=new __WEBPACK_IMPORTED_MODULE_3_normalizr__["Schema"]('page');row.define({pageModules:Object(__WEBPACK_IMPORTED_MODULE_3_normalizr__["arrayOf"])(module)});page.define({pageRows:Object(__WEBPACK_IMPORTED_MODULE_3_normalizr__["arrayOf"])(row)});var moveElement=function moveElement(array,from,to){var defCopy=[].concat(_toConsumableArray(array));var dest=to;if(from<to){dest=dest-1;}if(to>=defCopy.length){var k=to-defCopy.length;while(k--+1){defCopy.push(undefined);}}defCopy.splice(dest,0,defCopy.splice(from,1)[0]);return defCopy.filter(function(item){return typeof item!=='undefined';});};var PageLayoutStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["t" /* PageLayoutActions */]],data:{enabled:false,moduleMenuEnabled:false,overRow:{},selectedPageModuleId:null,entities:{page:{},pageRows:{},pageModules:{},result:null}},init:function init(){this.listenTo(__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].getPageByIdComplete,this.readTocComplete);this.listenTo(__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].addPageModuleComplete,this.addPageModuleComplete);this.listenTo(__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].deleteModuleComplete,this.deletePageModuleComplete);this.listenTo(__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].changePageModuleMode,this.changePageModuleMode);this.listenTo(__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].savePageModuleComplete,this.savePageModuleComplete);this.listenTo(__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].changePageModule,this.changePageModule);this.listenTo(__WEBPACK_IMPORTED_MODULE_1_actions__["u" /* PageModuleActions */].savePageModuleUserDataComplete,this.savePageModuleUserDataComplete);this.listenTo(__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].answerTaskComplete,this.answerTaskComplete);this.listenTo(__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updateTaskComplete,this.updateTaskComplete);},getInitialState:function getInitialState(){return this.data;},readTocComplete:function readTocComplete(toc){var data=Object(__WEBPACK_IMPORTED_MODULE_3_normalizr__["normalize"])(toc,page);this.data=Object.assign({},this.data,data);this.trigger(this.data);},addPageModule:function addPageModule(type){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page-module','create',{type:type,newRow:true,pageId:this.data.result}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].addPageModuleComplete(response.pageRows);},function(error){console.log(error);// quiziframe => "Undefined module type."
__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},savePageModule:function savePageModule(id){var module=this.data.entities.pageModules[id];var _module$data=module.data,content=_module$data.content,params=_module$data.params,sources=_module$data.sources,caption=_module$data.caption;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page-module','update',{id:id,caption:caption,content:content,params:params,sources:sources}).then(function(response){},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},changePageModuleMode:function changePageModuleMode(pageModuleId,mode){var entities=this.data.entities;this.data=Object.assign({},this.data,{entities:Object.assign({},entities,{pageModules:Object.assign({},entities.pageModules,_defineProperty({},pageModuleId,Object.assign({},entities.pageModules[pageModuleId],{mode:mode})))})});this.trigger(this.data);},changePageModule:function changePageModule(moduleData,callback){var entities=this.data.entities;var pageModuleId=moduleData.id;this.data=Object.assign({},this.data,{entities:Object.assign({},entities,{pageModules:Object.assign({},entities.pageModules,_defineProperty({},pageModuleId,Object.assign({},entities.pageModules[pageModuleId],moduleData)))})});callback&&callback(Object.assign({},entities.pageModules[pageModuleId],moduleData));this.trigger(this.data);},selectPageModule:function selectPageModule(selectedPageModuleId){this.data=Object.assign({},this.data,{selectedPageModuleId:selectedPageModuleId});this.trigger(this.data);},changePageModuleData:function changePageModuleData(moduleData){var entities=this.data.entities;var pageModuleId=moduleData.id,data=moduleData.data,rest=_objectWithoutProperties(moduleData,['id','data']);var module=entities.pageModules[pageModuleId];this.data=Object.assign({},this.data,{entities:Object.assign({},entities,{pageModules:Object.assign({},entities.pageModules,_defineProperty({},pageModuleId,Object.assign({},module,rest,{data:Object.assign({},module.data,data)})))})});this.trigger(this.data);},savePageModuleUserDataComplete:function savePageModuleUserDataComplete(pageModuleId,userdata){var entities=this.data.entities;this.data=Object.assign({},this.data,{entities:Object.assign({},entities,{pageModules:Object.assign({},entities.pageModules,_defineProperty({},pageModuleId,Object.assign({},entities.pageModules[pageModuleId],{data:Object.assign({},entities.pageModules[pageModuleId].data,{userdata:userdata})})))})});this.trigger(this.data);},savePageModuleComplete:function savePageModuleComplete(pageModuleId,content,params){var entities=this.data.entities;this.data=Object.assign({},this.data,{entities:Object.assign({},entities,{pageModules:Object.assign({},entities.pageModules,_defineProperty({},pageModuleId,Object.assign({},entities.pageModules[pageModuleId],{content:content,data:Object.assign({},entities.pageModules[pageModuleId].data,{params:params})})))})});this.trigger(this.data);},addPageModuleComplete:function addPageModuleComplete(pageRows){var toc={id:this.data.result,pageRows:pageRows};var data=Object(__WEBPACK_IMPORTED_MODULE_3_normalizr__["normalize"])(toc,page);var entities=this.data.entities;this.data=Object.assign({},this.data,{entities:Object.assign({},entities,{pageRows:Object.assign({},entities.pageRows,data.entities.pageRows),pageModules:Object.assign({},entities.pageModules,data.entities.pageModules),page:Object.assign({},entities.page,_defineProperty({},data.result,Object.assign({},entities.page[data.result],{pageRows:entities.page[data.result].pageRows.concat(data.entities.page[data.result].pageRows)})))})});this.trigger(this.data);},setPageModuleFile:function setPageModuleFile(pageRowId,moduleId,file){var _this=this;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','update',Object.assign({id:id},data)).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updateComplete(id,data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('content','saveDataForObject',{objectId:moduleId,objectType:'pageModule',data:file}).then(function(page){_this.setUserdata(pageRowId,moduleId,file);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},setUserdata:function setUserdata(pageRowId,moduleId,file){var entities=this.data.entities;var pageModule=entities.pageModules[moduleId];this.data=Object.assign({},this.data,{entities:Object.assign({},entities,{pageModules:Object.assign({},entities.pageModules,_defineProperty({},moduleId,Object.assign({},pageModule,{data:Object.assign({},pageModule.data,{userdata:file})})))})});},uploadComplete:function uploadComplete(pageModuleId,file){var entities=this.data.entities;var pageModule=entities.pageModules[pageModuleId];this.data=Object.assign({},this.data,{entities:Object.assign({},entities,{pageModules:Object.assign({},entities.pageModules,_defineProperty({},pageModuleId,Object.assign({},pageModule,{data:Object.assign({},pageModule.data,{params:Object.assign({},pageModule.data.params,{task:Object.assign({},pageModule.data.params.task,{captionFiles:[file]})})})})))})});this.trigger(this.data);},answerTaskComplete:function answerTaskComplete(taskId,pageModuleId,taskResult,bodyFiles){var entities=this.data.entities;taskResult.feedback=taskResult.feedback||{};// taskResult.body = {
//   ...taskResult.body,
// };
taskResult.bodyFiles=bodyFiles;var pageModule=entities.pageModules[pageModuleId];this.data=Object.assign({},this.data,{entities:Object.assign({},entities,{pageModules:Object.assign({},entities.pageModules,_defineProperty({},pageModuleId,Object.assign({},pageModule,{data:Object.assign({},pageModule.data,{params:Object.assign({},pageModule.data.params,{taskResults:[].concat(_toConsumableArray(pageModule.data.params.taskResults||[]),[taskResult])})})})))})});this.trigger(this.data);},updateTaskComplete:function updateTaskComplete(pageModuleId,task){var entities=this.data.entities;var pageModule=entities.pageModules[pageModuleId];this.data=Object.assign({},this.data,{entities:Object.assign({},entities,{pageModules:Object.assign({},entities.pageModules,_defineProperty({},pageModuleId,Object.assign({},pageModule,{data:Object.assign({},pageModule.data,{params:Object.assign({},pageModule.data.params,{task:Object.assign({},pageModule.data.params.task,task)})})})))})});this.trigger(this.data);},deletePageModuleComplete:function deletePageModuleComplete(pageModuleId){var pageModules=Object.assign({},this.data.entities.pageModules);delete pageModules[pageModuleId];var pageRows=Object.assign({},this.data.entities.pageRows);Object.keys(pageRows).some(function(pageRowId){var pageRow=pageRows[pageRowId];var pageModuleIndex=pageRow.pageModules.findIndex(function(pageModule){return pageModule.id===pageModuleId;});if(pageModuleIndex>-1){pageRows[pageRowId]=Object.assign({},pageRows[pageRowId],{pageModules:pageRows.pageModules.filter(function(_id){return _id!==pageModuleId;})});return true;}});this.data=Object.assign({},this.data,{entities:Object.assign({},this.data.entities,{pageRows:pageRows,pageModules:pageModules})});this.trigger(this.data);},enable:function enable(){this.data=Object.assign({},this.data,{enabled:true});this.trigger(this.data);},disable:function disable(){this.data=Object.assign({},this.data,{enabled:false});this.trigger(this.data);},toggle:function toggle(){if(this.data.enabled){this.disable();}else{this.enable();}},openModuleMenu:function openModuleMenu(){this.data=Object.assign({},this.data,{moduleMenuEnabled:true});this.trigger(this.data);},closeModuleMenu:function closeModuleMenu(){this.data=Object.assign({},this.data,{moduleMenuEnabled:false});this.trigger(this.data);},toggleModuleMenu:function toggleModuleMenu(){if(this.data.moduleMenuEnabled){this.closeModuleMenu();}else{this.openModuleMenu();}},overRow:function overRow(position,id){var overRow=this.data.overRow;if(overRow.id!==id||overRow.position!==position){var entities=this.data.entities;var pageRows=Object.assign({},entities.pageRows);var drag=entities.pageModules.drag;if(drag){pageRows=Object.assign({},pageRows,_defineProperty({},drag.pageRowId,Object.assign({},pageRows[drag.pageRowId],{pageModules:pageRows[drag.pageRowId].pageModules.filter(function(pageModuleId){return pageModuleId!=='drag';})})));}this.data=Object.assign({},this.data,{entities:Object.assign({},entities,{pageRows:pageRows,pageModules:Object.assign({},entities.pageModules,{drag:null})}),overRow:{position:position,id:id}});this.trigger(this.data);}},resetDragging:function resetDragging(){var entities=this.data.entities;this.data=Object.assign({},this.data,{overRow:{},entities:Object.assign({},entities,{pageModules:Object.assign({},entities.pageModules,{drag:null})})});this.trigger(this.data);},setDraggingPos:function setDraggingPos(pageRowId,dropPosition,pageModuleId){var entities=this.data.entities;var pageRows=entities.pageRows,pageModules=entities.pageModules;var _pageModules=pageModules,drag=_pageModules.drag;if(drag&&drag.pageModuleId===pageModuleId&&drag.pageRowId===pageRowId&&drag.dropPosition===dropPosition){return;}if(drag&&drag.pageRowId===pageRowId){var dragIndex=pageRows[drag.pageRowId].pageModules.findIndex(function(_pageModuleId){return _pageModuleId==='drag';});if(dragIndex===dropPosition){return;}}// Remove it from the old section
if(drag){Object.keys(pageRows).forEach(function(id){var section=pageRows[id];if(section.pageModules.findIndex(function(_mid){return _mid==='drag';})>-1){pageRows[id]=Object.assign({},pageRows[id],{pageModules:section.pageModules.filter(function(_mid){return _mid!=='drag';})});}});}drag={id:'drag',pageRowId:pageRowId,dropPosition:dropPosition,pageModuleId:pageModuleId,subType:pageModules[pageModuleId].type,type:'Drag'};// create a new drag handle
pageModules=Object.assign({},pageModules,{drag:drag});// Add it to the new section
var newModules=pageRows[pageRowId].pageModules.filter(function(_pageModuleId){return _pageModuleId!=='drag';});newModules.splice(dropPosition,0,'drag');pageRows=Object.assign({},pageRows,_defineProperty({},pageRowId,Object.assign({},pageRows[pageRowId],{pageModules:newModules})));this.data=Object.assign({},this.data,{entities:Object.assign({},this.data.entities,{pageRows:pageRows,pageModules:pageModules}),overRow:{}});this.trigger(this.data);},endDragging:function endDragging(pageRowId,item){var _data=this.data,entities=_data.entities,overRow=_data.overRow;var drag=entities.pageModules.drag;if(!drag&&overRow&&overRow.id){return this.moveToNewRow(overRow.id,pageRowId,item.pageModuleId);}var pageRows=entities.pageRows,pageModules=entities.pageModules;if(drag){var toPageRowId=drag.pageRowId,pageModuleId=drag.pageModuleId;pageModules=Object.assign({},pageModules,{drag:null});this.data=Object.assign({},this.data,{overRow:{},entities:Object.assign({},entities,{pageModules:pageModules})});// this.saveSnapshot();
if(pageRowId===toPageRowId){var section=Object.assign({},pageRows[pageRowId],{pageModules:pageRows[pageRowId].pageModules.filter(function(_mId){return _mId!==pageModuleId;}).map(function(id){if(id==='drag'){return pageModuleId;}return id;})});pageRows=Object.assign({},pageRows,_defineProperty({},pageRowId,section));pageRows[pageRowId].pageModules.forEach(function(id,index){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updatePageModule(id,{sortOrder:index+1});});}else{var _Object$assign14;var _section=Object.assign({},pageRows[pageRowId],{pageModules:pageRows[pageRowId].pageModules.filter(function(_mId){return _mId!==pageModuleId;})});var toSection=Object.assign({},pageRows[toPageRowId],{pageModules:pageRows[toPageRowId].pageModules.map(function(id){if(id==='drag'){return pageModuleId;}return id;})});pageRows=Object.assign({},pageRows,(_Object$assign14={},_defineProperty(_Object$assign14,pageRowId,_section),_defineProperty(_Object$assign14,toPageRowId,toSection),_Object$assign14));pageRows[toPageRowId].pageModules.forEach(function(id,index){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updatePageModule(id,{pageRowId:toPageRowId,sortOrder:index+1});});}this.data=Object.assign({},this.data,{entities:Object.assign({},entities,{pageRows:pageRows})});if(pageRows[pageRowId].pageModules.length<1){this.data.entities.page[this.data.result].pageRows=this.data.entities.page[this.data.result].pageRows.filter(function(id){return id!==pageRowId;});delete pageRows[pageRowId];}this.trigger(this.data);}},moveToNewRow:function moveToNewRow(toPageRowId,fromPageRowId,pageModuleId){var _this2=this;var _data2=this.data,entities=_data2.entities,overRow=_data2.overRow;var pageRows=[].concat(_toConsumableArray(entities.page[this.data.result].pageRows));var offset=overRow.position==='after'?1:0;var dropRowIndex=pageRows.findIndex(function(_pageRowId){return overRow.id===_pageRowId;});__WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page-module','moveToNewPageRow',{id:pageModuleId,pageRowPosition:Math.max(1,dropRowIndex+1+offset)}).then(function(insertedPageRow){var _Object$assign15;var pageRow={id:insertedPageRow.id,pageModules:insertedPageRow.pageModules.map(function(pageModule){return pageModule.id;})};if(entities.pageRows[fromPageRowId].pageModules.length===1){_this2.moveRow(fromPageRowId,toPageRowId,offset);return;}pageRows.splice(dropRowIndex+offset,0,pageRow.id);_this2.data=Object.assign({},_this2.data,{overRow:{}});// this.saveSnapshot();
_this2.data=Object.assign({},_this2.data,{entities:Object.assign({},entities,{pageRows:Object.assign({},entities.pageRows,(_Object$assign15={},_defineProperty(_Object$assign15,fromPageRowId,Object.assign({},entities.pageRows[fromPageRowId],{pageModules:entities.pageRows[fromPageRowId].pageModules.filter(function(id){return id!==pageModuleId;})})),_defineProperty(_Object$assign15,pageRow.id,pageRow),_Object$assign15)),page:Object.assign({},entities.page,_defineProperty({},_this2.data.result,Object.assign({},entities.page[_this2.data.result],{pageRows:pageRows})))}),overRow:{}});if(_this2.data.entities.pageRows[fromPageRowId].pageModules.length<1){delete _this2.data.entities.pageRows[fromPageRowId];_this2.data.entities.page[_this2.data.result].pageRows=_this2.data.entities.page[_this2.data.result].pageRows.filter(function(id){return id!==fromPageRowId;});}_this2.trigger(_this2.data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},moveRow:function moveRow(fromPageRowId,toPageRowId,offset){this.data=Object.assign({},this.data,{overRow:{}});// this.saveSnapshot();
var currentPage=this.data.entities.page[this.data.result];var pageRows=currentPage.pageRows;var index=pageRows.findIndex(function(id){return fromPageRowId===id;});var destIndex=pageRows.findIndex(function(id){return toPageRowId===id;});if(index>-1){this.data=Object.assign({},this.data,{entities:Object.assign({},this.data.entities,{page:Object.assign({},this.data.entities.page,_defineProperty({},this.data.result,Object.assign({},currentPage,{pageRows:moveElement(pageRows,index,Math.max(destIndex+offset,0))})))})});this.trigger(this.data);}}});/* harmony default export */ __webpack_exports__["a"] = (PageLayoutStore);

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Schema = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.arrayOf = arrayOf;
exports.valuesOf = valuesOf;
exports.unionOf = unionOf;
exports.normalize = normalize;

var _EntitySchema = __webpack_require__(1976);

var _EntitySchema2 = _interopRequireDefault(_EntitySchema);

var _IterableSchema = __webpack_require__(1977);

var _IterableSchema2 = _interopRequireDefault(_IterableSchema);

var _UnionSchema = __webpack_require__(551);

var _UnionSchema2 = _interopRequireDefault(_UnionSchema);

var _isEqual = __webpack_require__(1978);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _isObject = __webpack_require__(114);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultAssignEntity(normalized, key, entity) {
  normalized[key] = entity;
}

function visitObject(obj, schema, bag, options, collectionKey) {
  var _options$assignEntity = options.assignEntity,
      assignEntity = _options$assignEntity === undefined ? defaultAssignEntity : _options$assignEntity;


  var defaults = schema && schema.getDefaults && schema.getDefaults();
  var schemaAssignEntity = schema && schema.getAssignEntity && schema.getAssignEntity();
  var normalized = (0, _isObject2.default)(defaults) ? _extends({}, defaults) : {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var resolvedSchema = typeof schema[key] === 'function' ? schema[key].call(null, obj) : schema[key];
      var entity = visit(obj[key], resolvedSchema, bag, options, collectionKey);
      assignEntity.call(null, normalized, key, entity, obj, schema);
      if (schemaAssignEntity) {
        schemaAssignEntity.call(null, normalized, key, entity, obj, schema);
      }
    }
  }
  return normalized;
}

function defaultMapper(iterableSchema, itemSchema, bag, options) {
  return function (obj, key) {
    return visit(obj, itemSchema, bag, options, key);
  };
}

function polymorphicMapper(iterableSchema, itemSchema, bag, options) {
  return function (obj, key) {
    var schemaKey = iterableSchema.getSchemaKey(obj);
    var result = visit(obj, itemSchema[schemaKey], bag, options, key);
    return { id: result, schema: schemaKey };
  };
}

function visitIterable(obj, iterableSchema, bag, options) {
  var itemSchema = iterableSchema.getItemSchema();
  var curriedItemMapper = defaultMapper(iterableSchema, itemSchema, bag, options);

  if (Array.isArray(obj)) {
    return obj.map(curriedItemMapper);
  } else {
    return Object.keys(obj).reduce(function (objMap, key) {
      objMap[key] = curriedItemMapper(obj[key], key);
      return objMap;
    }, {});
  }
}

function visitUnion(obj, unionSchema, bag, options) {
  var itemSchema = unionSchema.getItemSchema();
  return polymorphicMapper(unionSchema, itemSchema, bag, options)(obj);
}

function defaultMergeIntoEntity(entityA, entityB, entityKey) {
  for (var key in entityB) {
    if (!entityB.hasOwnProperty(key)) {
      continue;
    }

    if (!entityA.hasOwnProperty(key) || (0, _isEqual2.default)(entityA[key], entityB[key])) {
      entityA[key] = entityB[key];
      continue;
    }

    console.warn('When merging two ' + entityKey + ', found unequal data in their "' + key + '" values. Using the earlier value.', entityA[key], entityB[key]);
  }
}

function visitEntity(entity, entitySchema, bag, options, collectionKey) {
  var _options$mergeIntoEnt = options.mergeIntoEntity,
      mergeIntoEntity = _options$mergeIntoEnt === undefined ? defaultMergeIntoEntity : _options$mergeIntoEnt;


  var entityKey = entitySchema.getKey();
  var id = entitySchema.getId(entity, collectionKey);

  if (!bag.hasOwnProperty(entityKey)) {
    bag[entityKey] = {};
  }

  if (!bag[entityKey].hasOwnProperty(id)) {
    bag[entityKey][id] = {};
  }

  var stored = bag[entityKey][id];
  var normalized = visitObject(entity, entitySchema, bag, options, collectionKey);
  mergeIntoEntity(stored, normalized, entityKey);

  return id;
}

function visit(obj, schema, bag, options, collectionKey) {
  if (!(0, _isObject2.default)(obj) || !(0, _isObject2.default)(schema)) {
    return obj;
  }

  if (schema instanceof _EntitySchema2.default) {
    return visitEntity(obj, schema, bag, options, collectionKey);
  } else if (schema instanceof _IterableSchema2.default) {
    return visitIterable(obj, schema, bag, options);
  } else if (schema instanceof _UnionSchema2.default) {
    return visitUnion(obj, schema, bag, options);
  } else {
    return visitObject(obj, schema, bag, options, collectionKey);
  }
}

function normalizeResult(result) {
  if ((0, _isObject2.default)(result) && (0, _isEqual2.default)(Object.keys(result), Object.keys(result).map(function (key) {
    return result[key];
  }))) {
    return Object.keys(result);
  }
  return result;
}

function arrayOf(schema, options) {
  return new _IterableSchema2.default(schema, options);
}

function valuesOf(schema, options) {
  return new _IterableSchema2.default(schema, options);
}

function unionOf(schema, options) {
  return new _UnionSchema2.default(schema, options);
}

exports.Schema = _EntitySchema2.default;
function normalize(obj, schema) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!(0, _isObject2.default)(obj)) {
    throw new Error('Normalize accepts an object or an array as its input.');
  }

  if (!(0, _isObject2.default)(schema) || Array.isArray(schema)) {
    throw new Error('Normalize accepts an object for schema.');
  }

  var bag = {};
  var result = visit(obj, schema, bag, options);

  return {
    entities: bag,
    result: normalizeResult(result)
  };
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1982),
    listCacheDelete = __webpack_require__(1983),
    listCacheGet = __webpack_require__(1984),
    listCacheHas = __webpack_require__(1985),
    listCacheSet = __webpack_require__(1986);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(252);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(105);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(139);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(2006);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(370),
    setCacheAdd = __webpack_require__(2010),
    setCacheHas = __webpack_require__(2011);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(552),
    isLength = __webpack_require__(563);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2064);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_universalAnalytics__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plyr__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_plyr__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VideoPlayer=function(_Component){_inherits(VideoPlayer,_Component);function VideoPlayer(){_classCallCheck(this,VideoPlayer);return _possibleConstructorReturn(this,(VideoPlayer.__proto__||Object.getPrototypeOf(VideoPlayer)).apply(this,arguments));}_createClass(VideoPlayer,[{key:'_playPause',value:function _playPause(){var video=this.refs.video.getDOMNode();if(video.paused===true){video.play();}else{video.pause();}}},{key:'_mute',value:function _mute(){var video=this.refs.video.getDOMNode();if(video.muted===false){video.muted=true;}else{video.muted=false;}}},{key:'_seek',value:function _seek(e){var video=this.refs.video.getDOMNode();var time=video.duration*(e.target.value/100);video.currentTime=time;}// _componentDidMount() {
//   var video = this.refs.video.getDOMNode();
//   video.addEventListener('timeupdate', e => {
//     var value = 100 / video.duration * video.currentTime;
//     this.refs.seekBar.getDOMNode().value = value;
//   });
// }
},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;var videoModuleInvert=JSON.parse(localStorage.getItem('videoModuleInvert'));this.player=new __WEBPACK_IMPORTED_MODULE_2_plyr___default.a(this.refs.video,{controls:['play-large','play','progress','current-time','mute','volume','captions','settings','pip','airplay','fullscreen'],settings:['captions','quality','speed','loop'],invertTime:videoModuleInvert===null?true:videoModuleInvert});this.refs.video.addEventListener('play',function(event){var pageId=Number(document.location.href.split("/").pop());__WEBPACK_IMPORTED_MODULE_1_helpers_universalAnalytics__["a" /* default */].event('video_player','video_interaction',{eventLabel:pageId});});this.player.increaseVolume(0);this.player.on('click',function(e){if(e.target.ariaLabel==='Current time'){localStorage.setItem('videoModuleInvert',JSON.stringify(!_this2.player.config.toggleInvert));}});}},{key:'formatForAndroid',value:function formatForAndroid(sources){return sources.sort(function(first){if(first.type==='mp4'){return-1;}else{return 1;}});}},{key:'render',value:function render(){var thesources=[];var sources=/Android/i.test(navigator.userAgent)?this.formatForAndroid(this.props.sources):this.props.sources;thesources=sources.map(function(source){if(source.url&&source.url.toString().indexOf(source.type)!==-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:source.url,type:'video/'+source.type,key:source.type});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:source.url+'.'+source.type,type:'video/'+source.type,key:source.type});}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'media-player'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{ref:'video',controls:true},thesources),this.props.children);}}]);return VideoPlayer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VideoPlayer.propTypes={controls:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};VideoPlayer.defaultProps={controls:false};/* harmony default export */ __webpack_exports__["a"] = (VideoPlayer);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VideoPreview=function(_Component){_inherits(VideoPreview,_Component);function VideoPreview(){_classCallCheck(this,VideoPreview);return _possibleConstructorReturn(this,(VideoPreview.__proto__||Object.getPrototypeOf(VideoPreview)).apply(this,arguments));}_createClass(VideoPreview,[{key:'render',value:function render(){var sources=[];sources=this.props.sources.map(function(source){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:source.url,type:'video/'+source.type,key:source.type});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{style:{width:'100%'}},sources));}}]);return VideoPreview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (VideoPreview);

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(2075)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(2082);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_SearchBar__ = __webpack_require__(579);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={root:{height:Spacing.desktopToolbarHeight,padding:(Spacing.desktopToolbarHeight-36)/2,textAlign:'center',boxSizing:'border-box'}};var SearchBarToolbar=function(_Component){_inherits(SearchBarToolbar,_Component);function SearchBarToolbar(){_classCallCheck(this,SearchBarToolbar);return _possibleConstructorReturn(this,(SearchBarToolbar.__proto__||Object.getPrototypeOf(SearchBarToolbar)).apply(this,arguments));}_createClass(SearchBarToolbar,[{key:'getStyle',value:function getStyle(){var style=Object.assign({},styles.root);style.backgroundColor=this.props.backgroundColor;if(this.props.fullWidth){style.padding=(Spacing.desktopToolbarHeight-36)/2+'px '+Spacing.desktopGutter+'px';}return style;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_SearchBar__["a" /* default */],this.props));}}]);return SearchBarToolbar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SearchBarToolbar.displayName='SearchBarToolbar';SearchBarToolbar.defaultProps={backgroundColor:'transparent'};/* harmony default export */ __webpack_exports__["a"] = (SearchBarToolbar);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Constants__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FileUpload=function(_Component){_inherits(FileUpload,_Component);function FileUpload(){_classCallCheck(this,FileUpload);return _possibleConstructorReturn(this,(FileUpload.__proto__||Object.getPrototypeOf(FileUpload)).apply(this,arguments));}_createClass(FileUpload,[{key:'handleFile',value:function handleFile(files){var _this2=this;if(files.length<1){return;}var current=files.pop();if(current){var fileType=current.type;var encoded=fileType.indexOf('audio')===0||fileType.indexOf('video')===0;__WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].upload([current],{encoded:encoded,progress:function progress(event){if(_this2.props.onProgress&&event){_this2.props.onProgress(Object.assign({},event,{remaining:files.length}));}},error:function error(){if(files.length>0){_this2.handleFile(files);}},success:function success(response){if(response&&response.data&&_this2.props.onSuccess){_this2.props.onSuccess(response.data);}if(files.length>0){_this2.handleFile(files);}}});}}},{key:'onChange',value:function onChange(e){this.processFiles(e.target.files);}},{key:'processFiles',value:function processFiles(files){var fileList=Object.keys(files).map(function(key){return files[key];});var willBeUploaded=fileList.filter(function(file){return file.size<__WEBPACK_IMPORTED_MODULE_5_Constants__["maxFileSize"];});var willBeDropped=fileList.filter(function(file){return file.size>=__WEBPACK_IMPORTED_MODULE_5_Constants__["maxFileSize"];});if(willBeDropped.length>0){if(willBeDropped.length>1){__WEBPACK_IMPORTED_MODULE_4_services_Message__["a" /* default */].info(willBeDropped.length+' files are too big.');}else{__WEBPACK_IMPORTED_MODULE_4_services_Message__["a" /* default */].info(willBeDropped.length+' file is too big.');}}if(willBeUploaded.length>0){this.handleFile(willBeUploaded);}}},{key:'handleClick',value:function handleClick(){this.refs.fileInput.value=null;this.refs.fileInput.click();}},{key:'handleInputClick',value:function handleInputClick(e){e.stopPropagation();}},{key:'getStyle',value:function getStyle(){var style=this.props.style;return Object.assign({position:'relative'},style);}},{key:'render',value:function render(){var classes=void 0,_props=this.props,className=_props.className,label=_props.label,Element=_props.Element,other=_objectWithoutProperties(_props,['className','label','Element']);var inputStyle={position:'absolute',top:0,bottom:0,right:0,left:0,cursor:'pointer',opacity:0};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Element,Object.assign({className:classes},other,{style:this.getStyle(),label:label,onTouchTap:this.handleClick.bind(this)}),this.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onTouchTap:this.handleInputClick.bind(this),style:inputStyle,ref:'fileInput',type:'file',onChange:this.onChange.bind(this),multiple:this.props.multiple,accept:this.props.accept}));}}]);return FileUpload;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FileUpload.propTypes={onSuccess:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,Element:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,multiple:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,accept:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};FileUpload.defaultProps={multiple:false,accept:'*/*',Element:__WEBPACK_IMPORTED_MODULE_3_material_ui__["RaisedButton"]};/* harmony default export */ __webpack_exports__["a"] = (FileUpload);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TaskResultList=function(_Component){_inherits(TaskResultList,_Component);function TaskResultList(){_classCallCheck(this,TaskResultList);return _possibleConstructorReturn(this,(TaskResultList.__proto__||Object.getPrototypeOf(TaskResultList)).apply(this,arguments));}_createClass(TaskResultList,[{key:'render',value:function render(){var _this2=this;var _props=this.props,results=_props.results,ListElement=_props.ListElement,choices=_props.choices,taskId=_props.taskId,correctResponse=_props.correctResponse,canGrade=_props.canGrade,removeAnimation=_props.removeAnimation;var tasks=[];if(results&&!!results.length){var _loop=function _loop(i){var result=results[i];if(result){var user=result.user;tasks.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{key:result.id},canGrade&&user&&user.name,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ListElement,Object.assign({feedback:_this2.props.feedback,taskId:taskId},result,{choices:choices,id:result.id,correctResponse:correctResponse,canGrade:canGrade})),canGrade&&!!result.bodyFiles.length&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{style:{margin:'0px 8px',width:'calc(100% - 16px)',marginBottom:16,minWidth:'auto'},onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_0_actions__["E" /* TaskActions */].removeUploaded(result.id);},fullWidth:true,label:'Remove attached files'})));}};for(var i=0;i<results.length;i++){_loop(i);}}if(removeAnimation){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,tasks);}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_addons_css_transition_group___default.a,{transitionEnterTimeout:500,transitionLeaveTimeout:500,transitionName:'task-result'},tasks);}}]);return TaskResultList;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);TaskResultList.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].func};TaskResultList.propTypes={results:__WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].array,ListElement:__WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].func,choices:__WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].array,taskId:__WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].number,correctResponse:__WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].object,canGrade:__WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].bool,removeAnimation:__WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].bool,feedback:__WEBPACK_IMPORTED_MODULE_2_react__["PropTypes"].array};/* harmony default export */ __webpack_exports__["a"] = (TaskResultList);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styles__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_File__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_formatDate__ = __webpack_require__(584);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['no_feedback_text'],['no_feedback_text']),_templateObject2=_taggedTemplateLiteral(['no_feedback'],['no_feedback']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={fileContainer:'_gO',file:'_gP'};var TaskFeedback=function(_Component){_inherits(TaskFeedback,_Component);function TaskFeedback(){_classCallCheck(this,TaskFeedback);return _possibleConstructorReturn(this,(TaskFeedback.__proto__||Object.getPrototypeOf(TaskFeedback)).apply(this,arguments));}_createClass(TaskFeedback,[{key:'render',value:function render(){var _props=this.props,files=_props.files,answers=_props.answers,leftIcon=_props.leftIcon,rightIcon=_props.rightIcon,created=_props.created,other=_objectWithoutProperties(_props,['files','answers','leftIcon','rightIcon','created']);if(created){created=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_formatDate__["a" /* formatDate */])(created);}if(leftIcon){leftIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(leftIcon,{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].answer.leftIcon});}if(rightIcon){rightIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(rightIcon,{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].answer.rightIcon});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].answer.root},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,answers.map(function(answer,index){var _answer=_slicedToArray(answer,3),feedback=_answer[0],color=_answer[1],icon=_answer[2];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,style:{color:color}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{color:color,margin:0}},feedback.text||feedback.grade&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject))||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject2)),' ',icon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(icon):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{color:color,margin:0}},feedback.hasOwnProperty('grade')?'Grade: '+(feedback.grade>0?'Correct':'Incorrect'):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,feedback.created&&feedback.created));}),leftIcon,rightIcon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.fileContainer},files.map(function(file,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:css.file},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_File__["a" /* default */],{url:file.url,caption:file.name})));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,created));}}]);return TaskFeedback;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TaskFeedback.displayName='TaskFeedback';TaskFeedback.defaultProps={files:[]};/* harmony default export */ __webpack_exports__["a"] = (TaskFeedback);

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2121);


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_Loader__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var listStyle={marginTop:Spacing.desktopGutter,boxSizing:'border-box'};var ListSelector=function(_Component){_inherits(ListSelector,_Component);function ListSelector(){_classCallCheck(this,ListSelector);var _this=_possibleConstructorReturn(this,(ListSelector.__proto__||Object.getPrototypeOf(ListSelector)).apply(this,arguments));var selected={};var _this$props=_this.props,idProperty=_this$props.idProperty,initialItemCount=_this$props.initialItemCount;if(_this.props.selected){_this.props.selected.forEach(function(item){selected[item[idProperty]]=item;});}_this.state={maxItems:initialItemCount,searchText:null,selected:selected};return _this;}_createClass(ListSelector,[{key:'getSelected',value:function getSelected(){return this.state.selected;}},{key:'_onSelect',value:function _onSelect(selected){if(this.props.onSelect){this.props.onSelect(selected);}}},{key:'onScrollToBottom',value:function onScrollToBottom(){var _this2=this;if(this._scrollTimeout){clearTimeout(this._scrollTimeout);}this._scrollTimeout=setTimeout(function(){if(_this2.state.maxItems<=_this2.props.items.length){_this2.setState({maxItems:_this2.state.maxItems+10});}},100);}},{key:'selectAll',value:function selectAll(){var _this3=this;var _props=this.props,items=_props.items,idProperty=_props.idProperty,labelProperty=_props.labelProperty,selected={},searchText=this.state.searchText,regexp=void 0;if(searchText&&searchText!==''){regexp=new RegExp(searchText,'i');}items.filter(function(item){return item[idProperty]&&_this3.filter(item,regexp,labelProperty);}).forEach(function(item){if(item[idProperty]){selected[item[idProperty]]=item;}});this.setState({selected:selected});this._onSelect(selected);}},{key:'clearSelection',value:function clearSelection(){this.setState({selected:{}});this._onSelect({});}},{key:'reset',value:function reset(){this.setState({selected:{}});}},{key:'selectItem',value:function selectItem(item){var selected=this.state.selected,idProperty=this.props.idProperty;if(selected[item[idProperty]]){delete selected[item[idProperty]];}else{selected[item[idProperty]]=item;}this.setState({selected:selected});this._onSelect(selected);}},{key:'filter',value:function filter(item,regexp,labelProperty){if(regexp&&regexp!==''){return item[labelProperty].search(regexp)>-1;}else{return true;}}},{key:'changeSearchText',value:function changeSearchText(){var _this4=this;if(this._changeSearchTimeout){clearTimeout(this._changeSearchTimeout);}this._changeSearchTimeout=setTimeout(function(){_this4.setState({searchText:_this4.refs.searchField.getValue()});},100);}},{key:'render',value:function render(){var _this5=this;var _props2=this.props,items=_props2.items,idProperty=_props2.idProperty,labelProperty=_props2.labelProperty,loading=_props2.loading,children=[],theme=this.context.muiTheme,searchText=this.state.searchText,regexp=void 0;var selectedCount=Object.keys(this.state.selected).length;var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini,borderStyle:'none none solid none',borderColor:this.context.muiTheme.rawTheme.palette.borderColor,borderWidth:1,backgroundColor:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{fullWidth:true,floatingLabelText:this.props.searchHint,ref:'searchField',onChange:this.changeSearchText.bind(this)}));var list=void 0;if(loading){list=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_Loader__["b" /* default */],null);}else{if(searchText&&searchText!==''){regexp=new RegExp(searchText,'i');}items=items.filter(function(item){return item[idProperty]&&_this5.filter(item,regexp,labelProperty);}).splice(0,this.state.maxItems);children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListDivider"],{key:'d-0'}));items.forEach(function(item){var label=item[labelProperty],id=item[idProperty],style={},selected=_this5.state.selected&&_this5.state.selected[id];if(id){if(selected){style.backgroundColor=_this5.context.muiTheme.rawTheme.palette.primary3Color;style.color=_this5.context.muiTheme.rawTheme.palette.primary3TextColor;}children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListItem"],{onTouchTap:_this5.selectItem.bind(_this5,item),style:style,key:'i-'+id,primaryText:label}));children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListDivider"],{key:'d-'+id}));}});list=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:listStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["List"],null,children));}var buttonStyle={border:'none',padding:4,width:32,height:32};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Paper"],{zDepth:0,style:{borderStyle:'solid',borderWidth:1,borderColor:theme.rawTheme.palette.borderColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ScrollableContainer__["a" /* default */],{header:toolbar,headerHeight:90,style:{height:this.props.height},onScrollToBottom:this.onScrollToBottom.bind(this)},list),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{backgroundColor:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].faintBlack,color:theme.rawTheme.palette.primary3TextColor,lineHeight:'32px',paddingRight:Spacing.desktopGutterMini,paddingLeft:Spacing.desktopGutterMini,borderStyle:'none none solid none',borderColor:this.context.muiTheme.rawTheme.palette.borderColor,borderWidth:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('selectedCount'),num:selectedCount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{style:buttonStyle,onTouchTap:this.selectAll.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ToggleCheckBox"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{style:buttonStyle,onTouchTap:this.clearSelection.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ToggleCheckBoxOutlineBlank"],null)))));}}]);return ListSelector;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ListSelector.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};ListSelector.propTypes={labelProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,idProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,initialItemCount:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,loading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,searchHint:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,height:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number])};ListSelector.defaultProps={labelProperty:'name',idProperty:'id',initialItemCount:25,items:[],searchHint:'Search',height:400};/* harmony default export */ __webpack_exports__["a"] = (ListSelector);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleOverview=function(_Component){_inherits(SimpleOverview,_Component);function SimpleOverview(){_classCallCheck(this,SimpleOverview);return _possibleConstructorReturn(this,(SimpleOverview.__proto__||Object.getPrototypeOf(SimpleOverview)).apply(this,arguments));}_createClass(SimpleOverview,[{key:'getHeaderStyle',value:function getHeaderStyle(){return{color:'rgba(0, 0, 0, 0.54)',fontSize:24,fontWeight:'500',lineHeight:'48px',paddingLeft:16,borderStyle:'none none solid none',borderWidth:1,borderColor:'rgba(0, 0, 0, 0.12)'};}},{key:'render',value:function render(){var _props=this.props,header=_props.header,children=_props.children,other=_objectWithoutProperties(_props,['header','children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',other,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getHeaderStyle()},header),children);}}]);return SimpleOverview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SimpleOverview.propTypes={header:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object])};/* harmony default export */ __webpack_exports__["a"] = (SimpleOverview);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_Spinner__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_LoginForm__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isValidEmail=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;var Units=__WEBPACK_IMPORTED_MODULE_7_Css__["default"].Units,Colors=__WEBPACK_IMPORTED_MODULE_7_Css__["default"].Colors;var css={root:'_c-',logoWrapper:'_da',logoContainer:'_db',headerWrapper:'_dc',header:'_dd'};var RegisterForm=function(_mixin){_inherits(RegisterForm,_mixin);function RegisterForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RegisterForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterForm.__proto__||Object.getPrototypeOf(RegisterForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={login:false,password:null,firstname:null,lastname:null,email:_this.props.userEmail,emailError:null,nameError:null,passwordError:null},_this._handleEmailChange=function(event){var email=event.target.value;if(!_this.validEmail(email)){_this.setState({email:email,emailError:_this.context.getIntlMessage('validation.invalidEmail')});}else{_this.setState({email:email,emailError:null});}},_this._handlePasswordChange=function(event){var password=event.target.value;if(password===''||password===null){_this.setState({password:password,passwordError:_this.context.getIntlMessage('validation.required')});}else if(password.length<6){_this.setState({password:password,passwordError:_this.context.getIntlMessage('validation.passwordTooShort')});}else{_this.setState({password:password,passwordError:null,empty:false});}},_this._handleNameChange=function(e){if(e.target.value===''||e.target.value===null){var _this$setState;_this.setState((_this$setState={},_defineProperty(_this$setState,e.target.name,e.target.value),_defineProperty(_this$setState,'nameError',_this.context.getIntlMessage('validation.required')),_this$setState));}else{var _this$setState2;_this.setState((_this$setState2={},_defineProperty(_this$setState2,e.target.name,e.target.value),_defineProperty(_this$setState2,'nameError',null),_this$setState2));}},_this.onTac=function(){var onTac=_this.props.onTac;onTac&&onTac();},_this.register=function(){var _this$state=_this.state,firstname=_this$state.firstname,lastname=_this$state.lastname,email=_this$state.email,password=_this$state.password;var userLocale=_this.props.userLocale;__WEBPACK_IMPORTED_MODULE_6_actions__["b" /* AuthActions */].register(email,password,firstname,lastname,userLocale);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RegisterForm,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_9_stores__["t" /* StoreOverviewStore */],function(state){return{store:state.name};});}},{key:'reset',value:function reset(){this.setState({login:false});}},{key:'login',value:function login(){if(this.props.onLogin){this.props.onLogin();}}},{key:'loginForm',value:function loginForm(){this.setState({login:true});}},{key:'validEmail',value:function validEmail(email){return isValidEmail.test(email.toLowerCase());}},{key:'render',value:function render(){var _this2=this;var _state=this.state,emailError=_state.emailError,passwordError=_state.passwordError,nameError=_state.nameError,login=_state.login,firstname=_state.firstname,lastname=_state.lastname,email=_state.email,password=_state.password,store=_state.store;var _props=this.props,userEmail=_props.userEmail,hash=_props.hash,userName=_props.userName,userLocale=_props.userLocale,router=_props.router;var getIntlMessage=this.context.getIntlMessage;if(login){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_LoginForm__["a" /* default */],{router:router,onLogin:this.login.bind(this)});}var canRegister=password&&!passwordError&&email&&!emailError&&firstname&&lastname&&!nameError;var button=void 0,tocContents=void 0;if(this.state.loading){button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{fullWidth:true,secondary:true,disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_Spinner__["a" /* default */],null));}else{button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{disabled:!canRegister,fullWidth:true,label:this.context.getIntlMessage('Register'),secondary:true,onTouchTap:this.register});}tocContents=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',onTouchTap:function onTouchTap(){return _this2.onTac();}},this.context.getIntlMessage('toc.toc'));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:css.header},this.props.title||this.context.getIntlMessage('account.need')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{fullWidth:true,onChange:this._handleNameChange,autoFocus:true,hintText:this.context.getIntlMessage('firstname'),errorText:nameError,type:'text',value:firstname,name:'firstname'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{fullWidth:true,onChange:this._handleNameChange,autoFocus:true,hintText:this.context.getIntlMessage('lastname'),errorText:nameError,type:'text',value:lastname,name:'lastname'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{onChange:this._handleEmailChange,hintText:this.context.getIntlMessage('Email'),errorText:emailError,fullWidth:true,value:email,disabled:!!userEmail,type:'text'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{fullWidth:true,errorText:passwordError,onChange:this._handlePasswordChange,hintText:this.context.getIntlMessage('Password'),value:password,type:'password'})),button,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('toc.accept'),toc:tocContents})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.headerWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:css.header},this.context.getIntlMessage('account.have'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{fullWidth:true,secondary:true,label:this.context.getIntlMessage('Login'),onTouchTap:this.loginForm.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.logoWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.logoContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"],{message:getIntlMessage('poweredBy'),engine:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__["a" /* default */],{width:16,initialFill:'#7e7e7e'}),'coursio')}))));}}]);return RegisterForm;}(Object(__WEBPACK_IMPORTED_MODULE_8_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_8_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));RegisterForm.propTypes={onLogin:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,store:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,userEmail:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};RegisterForm.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (RegisterForm);

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(453)))

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = checkDecoratorArguments;
function checkDecoratorArguments(functionName, signature) {
	if (false) {
		for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i += 1) {
			var arg = arguments.length <= i + 2 ? undefined : arguments[i + 2];
			if (arg && arg.prototype && arg.prototype.render) {
				// eslint-disable-next-line no-console
				console.error('You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
				return;
			}
		}
	}
}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.beginDrag = beginDrag;
exports.publishDragSource = publishDragSource;
exports.hover = hover;
exports.drop = drop;
exports.endDrag = endDrag;

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(106);

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = __webpack_require__(114);

var _isObject2 = _interopRequireDefault(_isObject);

var _matchesType = __webpack_require__(634);

var _matchesType2 = _interopRequireDefault(_matchesType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var HOVER = exports.HOVER = 'dnd-core/HOVER';
var DROP = exports.DROP = 'dnd-core/DROP';
var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';

function beginDrag(sourceIds) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { publishSource: true, clientOffset: null };
	var publishSource = options.publishSource,
	    clientOffset = options.clientOffset,
	    getSourceClientOffset = options.getSourceClientOffset;

	(0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');

	for (var i = 0; i < sourceIds.length; i++) {
		(0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
	}

	var sourceId = null;
	for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
		if (monitor.canDragSource(sourceIds[_i])) {
			sourceId = sourceIds[_i];
			break;
		}
	}
	if (sourceId === null) {
		return;
	}

	var sourceClientOffset = null;
	if (clientOffset) {
		(0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
		sourceClientOffset = getSourceClientOffset(sourceId);
	}

	var source = registry.getSource(sourceId);
	var item = source.beginDrag(monitor, sourceId);
	(0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');

	registry.pinSource(sourceId);

	var itemType = registry.getSourceType(sourceId);
	return {
		type: BEGIN_DRAG,
		itemType: itemType,
		item: item,
		sourceId: sourceId,
		clientOffset: clientOffset,
		sourceClientOffset: sourceClientOffset,
		isSourcePublic: publishSource
	};
}

function publishDragSource() {
	var monitor = this.getMonitor();
	if (!monitor.isDragging()) {
		return;
	}

	return { type: PUBLISH_DRAG_SOURCE };
}

function hover(targetIdsArg) {
	var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	    _ref$clientOffset = _ref.clientOffset,
	    clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;

	(0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
	var targetIds = targetIdsArg.slice(0);

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
	(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');

	// First check invariants.
	for (var i = 0; i < targetIds.length; i++) {
		var targetId = targetIds[i];
		(0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');

		var target = registry.getTarget(targetId);
		(0, _invariant2.default)(target, 'Expected targetIds to be registered.');
	}

	var draggedItemType = monitor.getItemType();

	// Remove those targetIds that don't match the targetType.  This
	// fixes shallow isOver which would only be non-shallow because of
	// non-matching targets.
	for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
		var _targetId = targetIds[_i2];
		var targetType = registry.getTargetType(_targetId);
		if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
			targetIds.splice(_i2, 1);
		}
	}

	// Finally call hover on all matching targets.
	for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
		var _targetId2 = targetIds[_i3];
		var _target = registry.getTarget(_targetId2);
		_target.hover(monitor, _targetId2);
	}

	return {
		type: HOVER,
		targetIds: targetIds,
		clientOffset: clientOffset
	};
}

function drop() {
	var _this = this;

	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
	(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');

	var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);

	targetIds.reverse();
	targetIds.forEach(function (targetId, index) {
		var target = registry.getTarget(targetId);

		var dropResult = target.drop(monitor, targetId);
		(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
		if (typeof dropResult === 'undefined') {
			dropResult = index === 0 ? {} : monitor.getDropResult();
		}

		_this.store.dispatch({
			type: DROP,
			dropResult: _extends({}, options, dropResult)
		});
	});
}

function endDrag() {
	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');

	var sourceId = monitor.getSourceId();
	var source = registry.getSource(sourceId, true);
	source.endDrag(monitor, sourceId);

	registry.unpinSource();

	return { type: END_DRAG };
}

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(258),
    isObjectLike = __webpack_require__(166);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.addSource = addSource;
exports.addTarget = addTarget;
exports.removeSource = removeSource;
exports.removeTarget = removeTarget;
var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';

function addSource(sourceId) {
	return {
		type: ADD_SOURCE,
		sourceId: sourceId
	};
}

function addTarget(targetId) {
	return {
		type: ADD_TARGET,
		targetId: targetId
	};
}

function removeSource(sourceId) {
	return {
		type: REMOVE_SOURCE,
		sourceId: sourceId
	};
}

function removeTarget(targetId) {
	return {
		type: REMOVE_TARGET,
		targetId: targetId
	};
}

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cio__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_cio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_PageModule__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cio_lib_Assets_Delete__ = __webpack_require__(2389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cio_lib_Assets_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_cio_lib_Assets_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_cio_lib_Assets_Eye__ = __webpack_require__(2390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_cio_lib_Assets_Eye___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_cio_lib_Assets_Eye__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_cio_lib_Assets_Edit__ = __webpack_require__(2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_cio_lib_Assets_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_cio_lib_Assets_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['Delete'],['Delete']),_templateObject2=_taggedTemplateLiteral(['Are you sure you want to remove this module?'],['Are you sure you want to remove this module?']),_templateObject3=_taggedTemplateLiteral(['No'],['No']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*global addTranslations*/var PageModule=function(_Component){_inherits(PageModule,_Component);function PageModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PageModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PageModule.__proto__||Object.getPrototypeOf(PageModule)).call.apply(_ref,[this].concat(args))),_this),_this.state={deleteDialog:false},_this.editMode=function(){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_3_actions_PageModule__["a" /* default */].changePageModuleMode(id,'edit');},_this.deleteModule=function(){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_3_actions_PageModule__["a" /* default */].deletePageModule(id);},_this.detailMode=function(){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_3_actions_PageModule__["a" /* default */].changePageModuleMode(id,'detail');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PageModule,[{key:'render',value:function render(){var _this2=this;var _props=this.props,mode=_props.mode,icon=_props.icon,editor=_props.editor,children=_props.children;var deleteDialog=this.state.deleteDialog;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].root,_defineProperty({},__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].edit,mode==='edit'))},mode==='edit'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["Toolbar"],{zDepth:1,transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["ToolbarGroup"],{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].leftToolbarGroup,transparent:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["ToolbarGroup"],{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].toolbarHeader,transparent:true,fullWidth:true,center:true},icon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["ToolbarGroup"],{transparent:true,className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].leftToolbarGroup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["ToolbarButton"],{dense:true,onTouchTap:this.detailMode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_cio_lib_Assets_Eye___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["ToolbarButton"],{dense:true,onTouchTap:function onTouchTap(){return _this2.setState({deleteDialog:true});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_cio_lib_Assets_Delete___default.a,null)))),editor&&mode!=='edit'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["Toolbar"],{dense:true,transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["ToolbarGroup"],{fullWidth:true,center:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["ToolbarGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["ToolbarButton"],{onTouchTap:this.editMode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_cio_lib_Assets_Edit___default.a,null)))),children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["Dialog"],{open:deleteDialog,onRequestClose:function onRequestClose(){return _this2.setState({deleteDialog:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["ToolbarTitle"],null,Object(__WEBPACK_IMPORTED_MODULE_8_oxygen_i18n__["translate"])(_templateObject)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].panel},Object(__WEBPACK_IMPORTED_MODULE_8_oxygen_i18n__["translate"])(_templateObject2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["ButtonGroup"],{fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].buttonContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["Button"],{label:Object(__WEBPACK_IMPORTED_MODULE_8_oxygen_i18n__["translate"])(_templateObject3),primary:true,onTouchTap:function onTouchTap(){return _this2.setState({deleteDialog:false});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].buttonContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_cio__["Button"],{label:Object(__WEBPACK_IMPORTED_MODULE_8_oxygen_i18n__["translate"])(_templateObject),secondary:true,onTouchTap:this.deleteModule})))));}}]);return PageModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PageModule.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,icon:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,mode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (PageModule);

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = exports.ButtonGroup = exports.Button = exports.RollDownButton = exports.ActionButton = exports.MenuButton = exports.HoverIconButton = exports.IconButton = exports.Text = exports.ProgressBar = exports.DropZone = exports.ToolbarTitle = exports.TabButton = exports.ToolbarButton = exports.ToolbarGroup = exports.Toolbar = exports.TextArea = exports.TextField = undefined;

var _TextField2 = __webpack_require__(2371);

var _TextField3 = _interopRequireDefault(_TextField2);

var _TextArea2 = __webpack_require__(2372);

var _TextArea3 = _interopRequireDefault(_TextArea2);

var _Toolbar2 = __webpack_require__(2373);

var _Toolbar3 = _interopRequireDefault(_Toolbar2);

var _ToolbarGroup2 = __webpack_require__(652);

var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);

var _ToolbarButton2 = __webpack_require__(653);

var _ToolbarButton3 = _interopRequireDefault(_ToolbarButton2);

var _TabButton2 = __webpack_require__(2374);

var _TabButton3 = _interopRequireDefault(_TabButton2);

var _ToolbarTitle2 = __webpack_require__(2375);

var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);

var _DropZone2 = __webpack_require__(2376);

var _DropZone3 = _interopRequireDefault(_DropZone2);

var _ProgressBar2 = __webpack_require__(2377);

var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);

var _Text2 = __webpack_require__(2378);

var _Text3 = _interopRequireDefault(_Text2);

var _IconButton2 = __webpack_require__(654);

var _IconButton3 = _interopRequireDefault(_IconButton2);

var _HoverIconButton2 = __webpack_require__(2379);

var _HoverIconButton3 = _interopRequireDefault(_HoverIconButton2);

var _MenuButton2 = __webpack_require__(2380);

var _MenuButton3 = _interopRequireDefault(_MenuButton2);

var _ActionButton2 = __webpack_require__(655);

var _ActionButton3 = _interopRequireDefault(_ActionButton2);

var _RollDownButton2 = __webpack_require__(2384);

var _RollDownButton3 = _interopRequireDefault(_RollDownButton2);

var _Button2 = __webpack_require__(2386);

var _Button3 = _interopRequireDefault(_Button2);

var _ButtonGroup2 = __webpack_require__(2387);

var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);

var _Dialog2 = __webpack_require__(2388);

var _Dialog3 = _interopRequireDefault(_Dialog2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TextField = _TextField3.default;
exports.TextArea = _TextArea3.default;
exports.Toolbar = _Toolbar3.default;
exports.ToolbarGroup = _ToolbarGroup3.default;
exports.ToolbarButton = _ToolbarButton3.default;
exports.TabButton = _TabButton3.default;
exports.ToolbarTitle = _ToolbarTitle3.default;
exports.DropZone = _DropZone3.default;
exports.ProgressBar = _ProgressBar3.default;
exports.Text = _Text3.default;
exports.IconButton = _IconButton3.default;
exports.HoverIconButton = _HoverIconButton3.default;
exports.MenuButton = _MenuButton3.default;
exports.ActionButton = _ActionButton3.default;
exports.RollDownButton = _RollDownButton3.default;
exports.Button = _Button3.default;
exports.ButtonGroup = _ButtonGroup3.default;
exports.Dialog = _Dialog3.default;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOM
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactCurrentOwner = __webpack_require__(99);
var ReactDOMTextComponent = __webpack_require__(419);
var ReactDefaultInjection = __webpack_require__(435);
var ReactInstanceHandles = __webpack_require__(152);
var ReactMount = __webpack_require__(50);
var ReactPerf = __webpack_require__(72);
var ReactReconciler = __webpack_require__(120);
var ReactUpdates = __webpack_require__(73);
var ReactVersion = __webpack_require__(300);

var findDOMNode = __webpack_require__(294);
var renderSubtreeIntoContainer = __webpack_require__(726);
var warning = __webpack_require__(33);

ReactDefaultInjection.inject();

var render = ReactPerf.measure('React', 'render', ReactMount.render);

var React = {
  findDOMNode: findDOMNode,
  render: render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
/* eslint-enable camelcase */
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    CurrentOwner: ReactCurrentOwner,
    InstanceHandles: ReactInstanceHandles,
    Mount: ReactMount,
    Reconciler: ReactReconciler,
    TextComponent: ReactDOMTextComponent
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {

    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,

    // shams
    Object.create, Object.freeze];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
        break;
      }
    }
  }
}

module.exports = React;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setTextContent
 */



var ExecutionEnvironment = __webpack_require__(45);
var escapeTextContentForBrowser = __webpack_require__(213);
var setInnerHTML = __webpack_require__(212);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMPropertyOperations
 * @typechecks static-only
 */



var DOMProperty = __webpack_require__(150);
var ReactPerf = __webpack_require__(72);

var quoteAttributeValueForBrowser = __webpack_require__(677);
var warning = __webpack_require__(33);

// Simplified subset
var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

if (false) {
  var reactProps = {
    children: true,
    dangerouslySetInnerHTML: true,
    key: true,
    ref: true
  };
  var warnedProperties = {};

  var warnUnknownProperty = function (name) {
    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
      return;
    }

    warnedProperties[name] = true;
    var lowerCasedName = name.toLowerCase();

    // data-* attributes should be lowercase; suggest the lowercase version
    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;

    // For now, only warn when we have a suggested correction. This prevents
    // logging too much when using transferPropsTo.
    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
  };
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {

  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    } else if (false) {
      warnUnknownProperty(name);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
      } else if (propertyInfo.mustUseAttribute) {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      } else {
        var propName = propertyInfo.propertyName;
        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
        // property type before comparing; only `value` does and is string.
        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
          // Contrary to `setAttribute`, object properties are properly
          // `toString`ed by IE8/9.
          node[propName] = value;
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
    } else if (false) {
      warnUnknownProperty(name);
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseAttribute) {
        node.removeAttribute(propertyInfo.attributeName);
      } else {
        var propName = propertyInfo.propertyName;
        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
          node[propName] = defaultValue;
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    } else if (false) {
      warnUnknownProperty(name);
    }
  }

};

ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
  setValueForProperty: 'setValueForProperty',
  setValueForAttribute: 'setValueForAttribute',
  deleteValueForProperty: 'deleteValueForProperty'
});

module.exports = DOMPropertyOperations;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentBrowserEnvironment
 */



var ReactDOMIDOperations = __webpack_require__(283);
var ReactMount = __webpack_require__(50);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {

  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,

  /**
   * If a particular environment requires that some resources be cleaned up,
   * specify this in the injected Mixin. In the DOM, we would likely want to
   * purge any cached node ID lookups.
   *
   * @private
   */
  unmountIDFromEnvironment: function (rootNodeID) {
    ReactMount.purgeID(rootNodeID);
  }

};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMIDOperations
 * @typechecks static-only
 */



var DOMChildrenOperations = __webpack_require__(420);
var DOMPropertyOperations = __webpack_require__(281);
var ReactMount = __webpack_require__(50);
var ReactPerf = __webpack_require__(72);

var invariant = __webpack_require__(20);

/**
 * Errors for properties that should not be updated with `updatePropertyByID()`.
 *
 * @type {object}
 * @private
 */
var INVALID_PROPERTY_ERRORS = {
  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
  style: '`style` must be set using `updateStylesByID()`.'
};

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {

  /**
   * Updates a DOM node with new property values. This should only be used to
   * update DOM properties in `DOMProperty`.
   *
   * @param {string} id ID of the node to update.
   * @param {string} name A valid property name, see `DOMProperty`.
   * @param {*} value New value of the property.
   * @internal
   */
  updatePropertyByID: function (id, name, value) {
    var node = ReactMount.getNode(id);
    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ?  false ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;

    // If we're updating to null or undefined, we should remove the property
    // from the DOM node instead of inadvertantly setting to a string. This
    // brings us in line with the same behavior we have on initial render.
    if (value != null) {
      DOMPropertyOperations.setValueForProperty(node, name, value);
    } else {
      DOMPropertyOperations.deleteValueForProperty(node, name);
    }
  },

  /**
   * Replaces a DOM node that exists in the document with markup.
   *
   * @param {string} id ID of child to be replaced.
   * @param {string} markup Dangerous markup to inject in place of child.
   * @internal
   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
   */
  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
    var node = ReactMount.getNode(id);
    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
  },

  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @param {array<string>} markup List of markup strings.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (updates, markup) {
    for (var i = 0; i < updates.length; i++) {
      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
    }
    DOMChildrenOperations.processUpdates(updates, markup);
  }
};

ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
});

module.exports = ReactDOMIDOperations;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ViewportMetrics
 */



var ViewportMetrics = {

  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }

};

module.exports = ViewportMetrics;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */



var ExecutionEnvironment = __webpack_require__(45);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = (eventName in document);

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactUpdateQueue
 */



var ReactCurrentOwner = __webpack_require__(99);
var ReactElement = __webpack_require__(51);
var ReactInstanceMap = __webpack_require__(177);
var ReactUpdates = __webpack_require__(73);

var assign = __webpack_require__(29);
var invariant = __webpack_require__(20);
var warning = __webpack_require__(33);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {
    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the props.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialProps Subset of the next props.
   * @internal
   */
  enqueueSetProps: function (publicInstance, partialProps) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
    if (!internalInstance) {
      return;
    }
    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
  },

  enqueueSetPropsInternal: function (internalInstance, partialProps) {
    var topLevelWrapper = internalInstance._topLevelWrapper;
    !topLevelWrapper ?  false ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;

    // Merge with the pending element if it exists, otherwise with existing
    // element props.
    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
    var element = wrapElement.props;
    var props = assign({}, element.props, partialProps);
    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));

    enqueueUpdate(topLevelWrapper);
  },

  /**
   * Replaces all of the props.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} props New props.
   * @internal
   */
  enqueueReplaceProps: function (publicInstance, props) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
    if (!internalInstance) {
      return;
    }
    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
  },

  enqueueReplacePropsInternal: function (internalInstance, props) {
    var topLevelWrapper = internalInstance._topLevelWrapper;
    !topLevelWrapper ?  false ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;

    // Merge with the pending element if it exists, otherwise with existing
    // element props.
    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
    var element = wrapElement.props;
    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));

    enqueueUpdate(topLevelWrapper);
  },

  enqueueElementInternal: function (internalInstance, newElement) {
    internalInstance._pendingElement = newElement;
    enqueueUpdate(internalInstance);
  }

};

module.exports = ReactUpdateQueue;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CallbackQueue
 */



var PooledClass = __webpack_require__(107);

var assign = __webpack_require__(29);
var invariant = __webpack_require__(20);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */
function CallbackQueue() {
  this._callbacks = null;
  this._contexts = null;
}

assign(CallbackQueue.prototype, {

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */
  enqueue: function (callback, context) {
    this._callbacks = this._callbacks || [];
    this._contexts = this._contexts || [];
    this._callbacks.push(callback);
    this._contexts.push(context);
  },

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */
  notifyAll: function () {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    if (callbacks) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i]);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  },

  /**
   * Resets the internal queue.
   *
   * @internal
   */
  reset: function () {
    this._callbacks = null;
    this._contexts = null;
  },

  /**
   * `PooledClass` looks for this.
   */
  destructor: function () {
    this.reset();
  }

});

PooledClass.addPoolingTo(CallbackQueue);

module.exports = CallbackQueue;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule instantiateReactComponent
 * @typechecks static-only
 */



var ReactCompositeComponent = __webpack_require__(684);
var ReactEmptyComponent = __webpack_require__(433);
var ReactNativeComponent = __webpack_require__(434);

var assign = __webpack_require__(29);
var invariant = __webpack_require__(20);
var warning = __webpack_require__(33);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function () {};
assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
  _instantiateReactComponent: instantiateReactComponent
});

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node) {
  var instance;

  if (node === null || node === false) {
    instance = new ReactEmptyComponent(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactNativeComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);
    } else {
      instance = new ReactCompositeComponentWrapper();
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactNativeComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
  }

  // Sets up the instance. This can probably just move into the constructor now.
  instance.construct(node);

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._isOwnerNecessary = false;
    instance._warnedAboutRefsInRender = false;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

module.exports = instantiateReactComponent;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentEnvironment
 */



var invariant = __webpack_require__(20);

var injected = false;

var ReactComponentEnvironment = {

  /**
   * Optionally injectable environment dependent cleanup hook. (server vs.
   * browser etc). Example: A browser system caches DOM nodes based on component
   * ID and must remove that cache entry when this instance is unmounted.
   */
  unmountIDFromEnvironment: null,

  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkupByID: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }

};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule shouldUpdateReactComponent
 * @typechecks static-only
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */
function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
  return false;
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule validateDOMNesting
 */



var assign = __webpack_require__(29);
var emptyFunction = __webpack_require__(57);
var warning = __webpack_require__(33);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    parentTag: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.parentTag = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':

      case 'pre':
      case 'listing':

      case 'table':

      case 'hr':

      case 'xmp':

      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    /*eslint-disable space-after-keywords */
    do {
      /*eslint-enable space-after-keywords */
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.parentTag;
    var parentTag = parentInfo && parentInfo.tag;

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
      }
    }
  };

  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.parentTag;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventTarget
 * @typechecks static-only
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */
function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;
  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventModifierState
 * @typechecks static-only
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  'Alt': 'altKey',
  'Control': 'ctrlKey',
  'Meta': 'metaKey',
  'Shift': 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findDOMNode
 * @typechecks static-only
 */



var ReactCurrentOwner = __webpack_require__(99);
var ReactInstanceMap = __webpack_require__(177);
var ReactMount = __webpack_require__(50);

var invariant = __webpack_require__(20);
var warning = __webpack_require__(33);

/**
 * Returns the DOM node rendered by this element.
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }
  if (ReactInstanceMap.has(componentOrElement)) {
    return ReactMount.getNodeFromInstance(componentOrElement);
  }
  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
   true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
}

module.exports = findDOMNode;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule LinkedValueUtils
 * @typechecks static-only
 */



var ReactPropTypes = __webpack_require__(441);
var ReactPropTypeLocations = __webpack_require__(216);

var invariant = __webpack_require__(20);
var warning = __webpack_require__(33);

var hasReadOnlyValue = {
  'button': true,
  'checkbox': true,
  'image': true,
  'hidden': true,
  'radio': true,
  'reset': true,
  'submit': true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: ReactPropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getIteratorFn
 * @typechecks static-only
 */



/* global Symbol */
var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactChildren
 */



var PooledClass = __webpack_require__(107);
var ReactElement = __webpack_require__(51);

var emptyFunction = __webpack_require__(57);
var traverseAllChildren = __webpack_require__(298);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result;
  var keyPrefix = bookKeeping.keyPrefix;
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule traverseAllChildren
 */



var ReactCurrentOwner = __webpack_require__(99);
var ReactElement = __webpack_require__(51);
var ReactInstanceHandles = __webpack_require__(152);

var getIteratorFn = __webpack_require__(296);
var invariant = __webpack_require__(20);
var warning = __webpack_require__(33);

var SEPARATOR = ReactInstanceHandles.SEPARATOR;
var SUBSEPARATOR = ':';

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var userProvidedKeyEscaperLookup = {
  '=': '=0',
  '.': '=1',
  ':': '=2'
};

var userProvidedKeyEscapeRegex = /[=.:]/g;

var didWarnAboutMaps = false;

function userProvidedKeyEscaper(match) {
  return userProvidedKeyEscaperLookup[match];
}

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  if (component && component.key != null) {
    // Explicit key
    return wrapUserProvidedKey(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * Escape a component key so that it is safe to use in a reactid.
 *
 * @param {*} text Component key to be escaped.
 * @return {string} An escaped string.
 */
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
}

/**
 * Wrap a `key` value explicitly provided by the user to distinguish it from
 * implicitly-generated keys generated by a component's index in its parent.
 *
 * @param {string} key Value of a user-provided `key` attribute
 * @return {string}
 */
function wrapUserProvidedKey(key) {
  return '$' + escapeUserProvidedKey(key);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventCharCode
 * @typechecks static-only
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */
function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactVersion
 */



module.exports = '0.14.0';

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentryError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfill__ = __webpack_require__(742);


/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        // tslint:disable:no-unsafe-any
        _this.name = _newTarget.prototype.constructor.name;
        Object(__WEBPACK_IMPORTED_MODULE_1__polyfill__["a" /* setPrototypeOf */])(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc__ = __webpack_require__(179);

// TODO: Implement different loggers for different environments
var global = Object(__WEBPACK_IMPORTED_MODULE_0__misc__["g" /* getGlobalObject */])();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.log(PREFIX + "[Log]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.warn(PREFIX + "[Warn]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.error(PREFIX + "[Error]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());

//# sourceMappingURL=logger.js.map

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeStackTrace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
// tslint:disable:object-literal-sort-keys

// global reference to slice
var UNKNOWN_FUNCTION = '?';
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[-a-z]+:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
/** JSDoc */
function computeStackTrace(ex) {
    // tslint:disable:no-unsafe-any
    var stack = null;
    var popSize = ex && ex.framesToPop;
    try {
        // This must be tried first because Opera 10 *destroys*
        // its stacktrace property if you try to access the stack
        // property first!!
        stack = computeStackTraceFromStacktraceProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    try {
        stack = computeStackTraceFromStackProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    return {
        message: extractMessage(ex),
        name: ex && ex.name,
        stack: [],
        failed: true,
    };
}
/** JSDoc */
// tslint:disable-next-line:cyclomatic-complexity
function computeStackTraceFromStackProp(ex) {
    // tslint:disable:no-conditional-assignment
    if (!ex || !ex.stack) {
        return null;
    }
    var stack = [];
    var lines = ex.stack.split('\n');
    var isEval;
    var submatch;
    var parts;
    var element;
    for (var i = 0; i < lines.length; ++i) {
        if ((parts = chrome.exec(lines[i]))) {
            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = submatch[1]; // url
                parts[3] = submatch[2]; // line
                parts[4] = submatch[3]; // column
            }
            element = {
                url: parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: isNative ? [parts[2]] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = winjs.exec(lines[i]))) {
            element = {
                url: parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: [],
                line: +parts[3],
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = gecko.exec(lines[i]))) {
            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = ''; // no column when eval
            }
            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
                // FireFox uses this awesome columnNumber property for its top frame
                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                // so adding 1
                // NOTE: this hack doesn't work if top-most frame is eval
                stack[0].column = ex.columnNumber + 1;
            }
            element = {
                url: parts[3],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: parts[2] ? parts[2].split(',') : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null,
            };
        }
        else {
            continue;
        }
        if (!element.func && element.line) {
            element.func = UNKNOWN_FUNCTION;
        }
        stack.push(element);
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** JSDoc */
function computeStackTraceFromStacktraceProp(ex) {
    if (!ex || !ex.stacktrace) {
        return null;
    }
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace;
    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i;
    var lines = stacktrace.split('\n');
    var stack = [];
    var parts;
    for (var line = 0; line < lines.length; line += 2) {
        // tslint:disable:no-conditional-assignment
        var element = null;
        if ((parts = opera10Regex.exec(lines[line]))) {
            element = {
                url: parts[2],
                func: parts[3],
                args: [],
                line: +parts[1],
                column: null,
            };
        }
        else if ((parts = opera11Regex.exec(lines[line]))) {
            element = {
                url: parts[6],
                func: parts[3] || parts[4],
                args: parts[5] ? parts[5].split(',') : [],
                line: +parts[1],
                column: +parts[2],
            };
        }
        if (element) {
            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }
            stack.push(element);
        }
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** Remove N number of frames from the stack */
function popFrames(stacktrace, popSize) {
    try {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, stacktrace, { stack: stacktrace.stack.slice(popSize) });
    }
    catch (e) {
        return stacktrace;
    }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(37);


/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* PromiseBuffer */](30);
        this.url = new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["a" /* API */](this.options.dsn).getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (_) {
        throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SentryError */]('Transport Class has to implement `sendEvent` method');
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shouldIgnoreOnError;
/* unused harmony export ignoreNextOnError */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(37);



var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    if (options === void 0) { options = {}; }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) {
            return fn;
        }
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) {
            return fn.__sentry_wrapped__;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        // tslint:disable:no-unsafe-any
        try {
            // tslint:disable-next-line:strict-type-predicates
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            if (fn.handleEvent) {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means the sentry.javascript SDK caught an error invoking your application code. This
                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
                return fn.handleEvent.apply(this, wrappedArguments);
            }
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
            // tslint:enable:no-unsafe-any
        }
        catch (ex) {
            ignoreNextOnError();
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* withScope */])(function (scope) {
                scope.addEventProcessor(function (event) {
                    var processedEvent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event);
                    if (options.mechanism) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["f" /* addExceptionTypeValue */])(processedEvent, undefined, undefined);
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["e" /* addExceptionMechanism */])(processedEvent, options.mechanism);
                    }
                    processedEvent.extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, processedEvent.extra, { arguments: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* normalize */])(args, 3) });
                    return processedEvent;
                });
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["f" /* captureException */])(ex);
            });
            throw ex;
        }
    };
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // tslint:disable-line:no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, '__sentry_wrapped__', {
        enumerable: false,
        value: sentryWrapped,
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true,
        },
        __sentry_original__: {
            enumerable: false,
            value: fn,
        },
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
    }
    catch (_oO) {
        /*no-empty*/
    }
    return sentryWrapped;
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(30);
var document = __webpack_require__(24).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(24);
var core = __webpack_require__(86);
var LIBRARY = __webpack_require__(125);
var wksExt = __webpack_require__(468);
var defineProperty = __webpack_require__(40).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(220)('keys');
var uid = __webpack_require__(124);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 309 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(24).document;
module.exports = document && document.documentElement;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(30);
var anObject = __webpack_require__(22);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(76)(Function.call, __webpack_require__(68).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(30);
var setPrototypeOf = __webpack_require__(311).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(89);
var defined = __webpack_require__(88);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 315 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 316 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(89);
var defined = __webpack_require__(88);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(125);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(60);
var hide = __webpack_require__(59);
var has = __webpack_require__(58);
var Iterators = __webpack_require__(159);
var $iterCreate = __webpack_require__(319);
var setToStringTag = __webpack_require__(157);
var getPrototypeOf = __webpack_require__(69);
var ITERATOR = __webpack_require__(35)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(128);
var descriptor = __webpack_require__(123);
var setToStringTag = __webpack_require__(157);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(59)(IteratorPrototype, __webpack_require__(35)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(224);
var defined = __webpack_require__(88);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(35)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(159);
var ITERATOR = __webpack_require__(35)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(40);
var createDesc = __webpack_require__(123);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(182);
var ITERATOR = __webpack_require__(35)('iterator');
var Iterators = __webpack_require__(159);
module.exports = __webpack_require__(86).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(861);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(44);
var toAbsoluteIndex = __webpack_require__(127);
var toLength = __webpack_require__(41);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(109);
var step = __webpack_require__(484);
var Iterators = __webpack_require__(159);
var toIObject = __webpack_require__(67);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(318)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(76);
var invoke = __webpack_require__(474);
var html = __webpack_require__(310);
var cel = __webpack_require__(306);
var global = __webpack_require__(24);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(77)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(24);
var macrotask = __webpack_require__(328).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(77)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(47);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(24);
var DESCRIPTORS = __webpack_require__(39);
var LIBRARY = __webpack_require__(125);
var $typed = __webpack_require__(230);
var hide = __webpack_require__(59);
var redefineAll = __webpack_require__(133);
var fails = __webpack_require__(28);
var anInstance = __webpack_require__(131);
var toInteger = __webpack_require__(89);
var toLength = __webpack_require__(41);
var toIndex = __webpack_require__(493);
var gOPN = __webpack_require__(129).f;
var dP = __webpack_require__(40).f;
var arrayFill = __webpack_require__(326);
var setToStringTag = __webpack_require__(157);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(24);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
var AppStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */],__WEBPACK_IMPORTED_MODULE_1_actions__["q" /* MessageActions */]],data:{message:null,reportBug:false},getInitialState:function getInitialState(){return this.data;},init:function init(){if(localStorage){var data=JSON.parse(localStorage.getItem('app'));if(data){this.data=data;this.trigger(this.data);}}},serialize:function serialize(){localStorage.setItem('app',JSON.stringify(this.data));},sync:function sync(){this.serialize();this.trigger(this.data);},onSetTitle:function onSetTitle(title){this.data.title=title;this.sync();},getTitle:function getTitle(){return this.data.title;},genericError:function genericError(message){this.data.message={message:message,type:'error',translate:false};this.trigger(this.data);},translatableMessage:function translatableMessage(message){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'info';this.data.message={message:message,type:type,translate:true};this.trigger(this.data);},notify:function notify(message){this.message(message,'notification');},error:function error(message){this.message(message,'error');},info:function info(message){this.message(message,'info');},message:function message(_message){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'info';this.data.message={message:_message,type:type,translate:false};this.trigger(this.data);},clearMessage:function clearMessage(){this.data=Object.assign({},this.data,{message:null});this.trigger(this.data);},onSearch:function onSearch(searchText){if(this.data.searchText!==searchText){this.data.searchText=searchText;this.sync();}},showReportBugDialog:function showReportBugDialog(){this.data=Object.assign({},this.data,{reportBug:true});this.trigger(this.data);},hideReportBugDialog:function hideReportBugDialog(){this.data=Object.assign({},this.data,{reportBug:false});this.trigger(this.data);},reportBug:function reportBug(userComment,technicalData){var _this=this;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('guest','reportBug',{userComment:userComment,technicalData:technicalData}).then(function(response){_this.translatableMessage('bug.reported');},function(){_this.translatableMessage('bug.reportFailed');});}});/* harmony default export */ __webpack_exports__["a"] = (AppStore);

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.createdStores = [];

exports.createdActions = [];

exports.reset = function () {
    while (exports.createdStores.length) {
        exports.createdStores.pop();
    }
    while (exports.createdActions.length) {
        exports.createdActions.pop();
    }
};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(92);

/**
 * A module of methods for object that you want to be able to listen to.
 * This module is consumed by `createStore` and `createAction`
 */
module.exports = {

    /**
     * Hook used by the publisher that is invoked before emitting
     * and before `shouldEmit`. The arguments are the ones that the action
     * is invoked with. If this function returns something other than
     * undefined, that will be passed on as arguments for shouldEmit and
     * emission.
     */
    preEmit: function preEmit() {},

    /**
     * Hook used by the publisher after `preEmit` to determine if the
     * event should be emitted with given arguments. This may be overridden
     * in your application, default implementation always returns true.
     *
     * @returns {Boolean} true if event should be emitted
     */
    shouldEmit: function shouldEmit() {
        return true;
    },

    /**
     * Subscribes the given callback for action triggered
     *
     * @param {Function} callback The callback to register as event handler
     * @param {Mixed} [optional] bindContext The context to bind the callback with
     * @returns {Function} Callback that unsubscribes the registered event handler
     */
    listen: function listen(callback, bindContext) {
        bindContext = bindContext || this;
        var eventHandler = function eventHandler(args) {
            if (aborted) {
                return;
            }
            callback.apply(bindContext, args);
        },
            me = this,
            aborted = false;
        this.emitter.addListener(this.eventLabel, eventHandler);
        return function () {
            aborted = true;
            me.emitter.removeListener(me.eventLabel, eventHandler);
        };
    },

    /**
     * Publishes an event using `this.emitter` (if `shouldEmit` agrees)
     */
    trigger: function trigger() {
        var args = arguments,
            pre = this.preEmit.apply(this, args);
        args = pre === undefined ? args : _.isArguments(pre) ? pre : [].concat(pre);
        if (this.shouldEmit.apply(this, args)) {
            this.emitter.emit(this.eventLabel, args);
        }
    },

    /**
     * Tries to publish the event on the next tick
     */
    triggerAsync: function triggerAsync() {
        var args = arguments,
            me = this;
        _.nextTick(function () {
            me.trigger.apply(me, args);
        });
    },

    /**
     * Wraps the trigger mechanism with a deferral function.
     *
     * @param {Function} callback the deferral function,
     *        first argument is the resolving function and the
     *        rest are the arguments provided from the previous
     *        trigger invocation
     */
    deferWith: function deferWith(callback) {
        var oldTrigger = this.trigger,
            ctx = this,
            resolver = function resolver() {
            oldTrigger.apply(ctx, arguments);
        };
        this.trigger = function () {
            callback.apply(ctx, [resolver].concat([].splice.call(arguments, 0)));
        };
    }

};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(92),
    ListenerMethods = __webpack_require__(134);

/**
 * A module meant to be consumed as a mixin by a React component. Supplies the methods from
 * `ListenerMethods` mixin and takes care of teardown of subscriptions.
 * Note that if you're using the `connect` mixin you don't need this mixin, as connect will
 * import everything this mixin contains!
 */
module.exports = _.extend({

    /**
     * Cleans up all listener previously registered.
     */
    componentWillUnmount: ListenerMethods.stopListeningToAll

}, ListenerMethods);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var TransactionActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['read','readComplete','findById','findByIdError','findByIdComplete','genericError','refund','refundError','refundComplete','resend','resendComplete','export','exportComplete']);/* harmony default export */ __webpack_exports__["a"] = (TransactionActions);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var InviteActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['setCourses','setStudents','setCourseAccess','setGroups','setStudentInviteMode','reset','disableSteps','nextStep','inviteByCircleIds','inviteByUserIds','inviteByEmails','inviteToCircle']);/* harmony default export */ __webpack_exports__["a"] = (InviteActions);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var NotificationActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['read','readComplete','markRead','countUnreadNotifications','countUnreadNotificationsComplete']);/* harmony default export */ __webpack_exports__["a"] = (NotificationActions);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var PageLayoutActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['enable','disable','toggle','closeModuleMenu','openModuleMenu','toggleModuleMenu','overRow','resetDragging','setDraggingPos','endDragging','addPageModule','changePageModuleData','savePageModule','selectPageModule','uploadComplete','setPageModuleFile','savePageModuleCaption']);/* harmony default export */ __webpack_exports__["a"] = (PageLayoutActions);

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(161);

var _DOMUtils = __webpack_require__(240);

var _DOMStateStorage = __webpack_require__(513);

var _PathUtils = __webpack_require__(112);

var _ExecutionEnvironment = __webpack_require__(341);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if (event.state !== undefined) // Ignore extraneous popstate events in WebKit
      listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state;
  var key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(1002);

var _PathUtils = __webpack_require__(112);

var _runTransitionHook = __webpack_require__(344);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(239);

var _LocationUtils = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var getCurrentLocation = options.getCurrentLocation;
  var getUserConfirmation = options.getUserConfirmation;
  var pushLocation = options.pushLocation;
  var replaceLocation = options.replaceLocation;
  var go = options.go;
  var keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(111);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(31);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var BundleStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["c" /* BundleActions */]],data:{list:[],loading:false,saving:false,selected:null},getInitialState:function getInitialState(){return this.data;},onRead:function onRead(includeRead,callback){this.data.loading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('course-package','read',{},function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["c" /* BundleActions */].readComplete(response.data);if(callback){callback();}});},onReadComplete:function onReadComplete(data){this.data={list:data,loading:false,saving:false,selected:null};this.trigger(this.data);},findById:function findById(id){this.data.loading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('course-package','findById',{id:id},function(response){if(response.isError){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(response.errMsg);}else{__WEBPACK_IMPORTED_MODULE_1_actions__["c" /* BundleActions */].findByIdComplete(response.data);}});},findByIdComplete:function findByIdComplete(bundle){this.data.loading=false;this.data.selected=bundle;this.trigger(this.data);},onFindByIdError:function onFindByIdError(errorMessage){this.data.loading=false;this.data.errorMessage=errorMessage;this.trigger(this.data);},onUpdate:function onUpdate(bundleId,bundle){this.data=Object.assign({},this.data,{saving:true});this.trigger(this.data);bundle.id=bundleId;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('course-package','update',bundle,function(response){if(response.isError){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(response.errMsg);}else{__WEBPACK_IMPORTED_MODULE_1_actions__["c" /* BundleActions */].updateComplete(response.data);}});},onUpdateComplete:function onUpdateComplete(bundle){this.data=Object.assign({},this.data,{selected:Object.assign({},this.data.selected,bundle)});this.trigger(this.data);},onCreate:function onCreate(bundle){this.data.saving=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('course-package','create',bundle,function(response){if(response.isError){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(response.errMsg);}else{__WEBPACK_IMPORTED_MODULE_1_actions__["c" /* BundleActions */].createComplete(response.data);__WEBPACK_IMPORTED_MODULE_1_actions__["c" /* BundleActions */].read();}});},createComplete:function createComplete(bundle){__WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* history */].push('/bundle/'+bundle.id);},onRemoveComplete:function onRemoveComplete(bundle){var found=-1,bundles=this.data.list;for(var i=0;i<=bundles.length;i++){if(bundles[i].id===bundle.id){found=i;break;}}if(found>=0){bundles.splice(found,1);this.data.list=bundles;this.trigger(this.data);}__WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* history */].push('/bundles');},onRemove:function onRemove(bundle){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('course-package','delete',{id:bundle.id},function(response){if(response.isError){__WEBPACK_IMPORTED_MODULE_1_actions__["c" /* BundleActions */].removeError(response.errMsg);}else{__WEBPACK_IMPORTED_MODULE_1_actions__["c" /* BundleActions */].removeComplete(bundle);}});},addTag:function addTag(bundleId,name){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('tag','addLink',{objectId:bundleId,objectType:3,name:name}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["c" /* BundleActions */].addTagComplete(bundleId,name);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},removeTag:function removeTag(bundleId,name){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('tag','removeLink',{objectId:bundleId,objectType:3,name:name}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["c" /* BundleActions */].removeTagComplete(bundleId,name);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},addTagComplete:function addTagComplete(bundleId,name){this.data=Object.assign({},this.data,{list:this.data.list.map(function(bundle){if(bundle.id===bundleId){var tagsMap=bundle.tagsMap||{};return Object.assign({},bundle,{tagsMap:Object.assign({},tagsMap,_defineProperty({},name,true))});}return bundle;})});if(this.data.selected.id===bundleId){var tagsMap=this.data.selected.tagsMap||{};this.data=Object.assign({},this.data,{selected:Object.assign({},this.data.selected,{tagsMap:Object.assign({},tagsMap,_defineProperty({},name,true))})});}this.trigger(this.data);},removeTagComplete:function removeTagComplete(bundleId,name){this.data=Object.assign({},this.data,{list:this.data.list.map(function(bundle){if(bundle.id===bundleId){var tagsMap=bundle.tagsMap||{};return Object.assign({},bundle,{tagsMap:Object.assign({},tagsMap,_defineProperty({},name,false))});}return bundle;})});if(this.data.selected.id===bundleId){var tagsMap=this.data.selected.tagsMap||{};this.data=Object.assign({},this.data,{selected:Object.assign({},this.data.selected,{tagsMap:Object.assign({},tagsMap,_defineProperty({},name,false))})});}this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (BundleStore);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(31);
var localizeDate=function localizeDate(dateStr){var firstChars=dateStr.substr(0,dateStr.indexOf(' '));var properFormat=firstChars.length===10&&firstChars!=='0000-00-00';// We want YYYY-MM-DD format, but not '0000-00-00'
var utcCharsHasNotBeenAddedYet=dateStr.substr(dateStr.length-3)!=='UTC';var updatedDateStr=properFormat&&utcCharsHasNotBeenAddedYet?dateStr+' UTC':dateStr;return updatedDateStr;};var DiscountStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["h" /* DiscountActions */]],data:{list:[],loading:true},getInitialState:function getInitialState(){return this.data;},onRead:function onRead(includeRead,callback){this.data.loading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('discount','read',{},function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["h" /* DiscountActions */].readComplete(response.data);if(callback){callback();}});},onReadComplete:function onReadComplete(data){this.data=Object.assign({},this.data,{list:data});this.trigger(this.data);},onFindById:function onFindById(id){this.data.loading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('discount','findById',{id:id}).then(function(discount){__WEBPACK_IMPORTED_MODULE_1_actions__["h" /* DiscountActions */].findByIdComplete(discount);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},findByIdComplete:function findByIdComplete(discount){if(discount.startDate){var newStartDate=localizeDate(discount.startDate);discount.startDate=newStartDate;}if(discount.endDate){var newEndDate=localizeDate(discount.endDate);discount.endDate=newEndDate;}this.data.loading=false;this.data.discount=discount;this.trigger(this.data);},onFindByIdError:function onFindByIdError(errorMessage){this.data.loading=false;this.data.errorMessage=errorMessage;this.trigger(this.data);},update:function update(discountId,discount){discount.id=discountId;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('discount','update',discount).then(function(discount){if(discount.startDate){var newStartDate=localizeDate(discount.startDate);discount.startDate=newStartDate;}if(discount.endDate){var newEndDate=localizeDate(discount.endDate);discount.endDate=newEndDate;}__WEBPACK_IMPORTED_MODULE_1_actions__["h" /* DiscountActions */].updateComplete(discount);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},updateComplete:function updateComplete(discount){this.data=Object.assign({},this.data,{discount:Object.assign({},discount)});this.trigger(this.data);},onCreate:function onCreate(discount){var _this=this;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('discount','create',discount,function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["h" /* DiscountActions */].createComplete(response.data);_this.data.saving=true;_this.trigger(_this.data);});},createComplete:function createComplete(discount){__WEBPACK_IMPORTED_MODULE_1_actions__["h" /* DiscountActions */].read();__WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* history */].push('/discount/'+discount.id);},onRemoveComplete:function onRemoveComplete(discount){var found=-1,discounts=this.data.list;for(var i=0;i<=discounts.length;i++){if(discounts[i].id===discount.id){found=i;break;}}if(found>=0){discounts.splice(found,1);this.data.list=discounts;this.trigger(this.data);}},onRemove:function onRemove(discount){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('discount','delete',{id:discount.id},function(response){if(response.isError){__WEBPACK_IMPORTED_MODULE_1_actions__["h" /* DiscountActions */].removeError(response.errMsg);}else{__WEBPACK_IMPORTED_MODULE_1_actions__["h" /* DiscountActions */].removeComplete(discount);}});}});/* harmony default export */ __webpack_exports__["a"] = (DiscountStore);

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule update
 */

/* global hasOwnProperty:true */



var assign = __webpack_require__(29);
var keyOf = __webpack_require__(85);
var invariant = __webpack_require__(20);
var hasOwnProperty = ({}).hasOwnProperty;

function shallowCopy(x) {
  if (Array.isArray(x)) {
    return x.concat();
  } else if (x && typeof x === 'object') {
    return assign(new x.constructor(), x);
  } else {
    return x;
  }
}

var COMMAND_PUSH = keyOf({ $push: null });
var COMMAND_UNSHIFT = keyOf({ $unshift: null });
var COMMAND_SPLICE = keyOf({ $splice: null });
var COMMAND_SET = keyOf({ $set: null });
var COMMAND_MERGE = keyOf({ $merge: null });
var COMMAND_APPLY = keyOf({ $apply: null });

var ALL_COMMANDS_LIST = [COMMAND_PUSH, COMMAND_UNSHIFT, COMMAND_SPLICE, COMMAND_SET, COMMAND_MERGE, COMMAND_APPLY];

var ALL_COMMANDS_SET = {};

ALL_COMMANDS_LIST.forEach(function (command) {
  ALL_COMMANDS_SET[command] = true;
});

function invariantArrayCase(value, spec, command) {
  !Array.isArray(value) ?  false ? invariant(false, 'update(): expected target of %s to be an array; got %s.', command, value) : invariant(false) : undefined;
  var specValue = spec[command];
  !Array.isArray(specValue) ?  false ? invariant(false, 'update(): expected spec of %s to be an array; got %s. ' + 'Did you forget to wrap your parameter in an array?', command, specValue) : invariant(false) : undefined;
}

function update(value, spec) {
  !(typeof spec === 'object') ?  false ? invariant(false, 'update(): You provided a key path to update() that did not contain one ' + 'of %s. Did you forget to include {%s: ...}?', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : invariant(false) : undefined;

  if (hasOwnProperty.call(spec, COMMAND_SET)) {
    !(Object.keys(spec).length === 1) ?  false ? invariant(false, 'Cannot have more than one key in an object with %s', COMMAND_SET) : invariant(false) : undefined;

    return spec[COMMAND_SET];
  }

  var nextValue = shallowCopy(value);

  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
    var mergeObj = spec[COMMAND_MERGE];
    !(mergeObj && typeof mergeObj === 'object') ?  false ? invariant(false, 'update(): %s expects a spec of type \'object\'; got %s', COMMAND_MERGE, mergeObj) : invariant(false) : undefined;
    !(nextValue && typeof nextValue === 'object') ?  false ? invariant(false, 'update(): %s expects a target of type \'object\'; got %s', COMMAND_MERGE, nextValue) : invariant(false) : undefined;
    assign(nextValue, spec[COMMAND_MERGE]);
  }

  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
    invariantArrayCase(value, spec, COMMAND_PUSH);
    spec[COMMAND_PUSH].forEach(function (item) {
      nextValue.push(item);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
    spec[COMMAND_UNSHIFT].forEach(function (item) {
      nextValue.unshift(item);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
    !Array.isArray(value) ?  false ? invariant(false, 'Expected %s target to be an array; got %s', COMMAND_SPLICE, value) : invariant(false) : undefined;
    !Array.isArray(spec[COMMAND_SPLICE]) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. ' + 'Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : invariant(false) : undefined;
    spec[COMMAND_SPLICE].forEach(function (args) {
      !Array.isArray(args) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. ' + 'Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : invariant(false) : undefined;
      nextValue.splice.apply(nextValue, args);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
    !(typeof spec[COMMAND_APPLY] === 'function') ?  false ? invariant(false, 'update(): expected spec of %s to be a function; got %s.', COMMAND_APPLY, spec[COMMAND_APPLY]) : invariant(false) : undefined;
    nextValue = spec[COMMAND_APPLY](nextValue);
  }

  for (var k in spec) {
    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
      nextValue[k] = update(value[k], spec[k]);
    }
  }

  return nextValue;
}

module.exports = update;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AutoPrefix = __webpack_require__(62);
var ImmutabilityHelper = __webpack_require__(162);

var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;

var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;

module.exports = {

  mergeAndPrefix: function mergeAndPrefix() {
    var mergedStyles = ImmutabilityHelper.merge.apply(this, arguments);
    return AutoPrefix.all(mergedStyles);
  },

  // This function ensures that `style` supports both ltr and rtl directions by checking
  //   `styleConstants` in `muiTheme` and replacing attribute keys if necessary.
  ensureDirection: function ensureDirection(muiTheme, style) {
    if (false) {
      if (style.didFlip) {
        console.warn(new Error('You\'re calling `ensureDirection` on the same style object twice.'));
      }
      style = ImmutabilityHelper.merge({
        didFlip: 'true'
      }, style);
    }

    // Left to right is the default. No need to flip anything.
    if (!muiTheme.isRtl) return style;

    var flippedAttributes = {
      // Keys and their replacements.
      right: 'left',
      left: 'right',
      marginRight: 'marginLeft',
      marginLeft: 'marginRight',
      paddingRight: 'paddingLeft',
      paddingLeft: 'paddingRight',
      borderRight: 'borderLeft',
      borderLeft: 'borderRight'
    };

    var newStyle = {};

    Object.keys(style).forEach(function (attribute) {
      var value = style[attribute];
      var key = attribute;

      if (flippedAttributes.hasOwnProperty(attribute)) {
        key = flippedAttributes[attribute];
      }

      switch (attribute) {
        case 'float':
        case 'textAlign':
          if (value === 'right') {
            value = 'left';
          } else if (value === 'left') {
            value = 'right';
          }
          break;
        case 'direction':
          if (value === 'ltr') {
            value = 'rtl';
          } else if (value === 'rtl') {
            value = 'ltr';
          }
          break;
        case 'transform':
          var matches = undefined;
          if (matches = value.match(reTranslate)) {
            value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
          }
          if (matches = value.match(reSkew)) {
            value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ',' + -parseFloat(matches[7]) + matches[8] : '');
          }
          break;
        case 'transformOrigin':
          if (value.indexOf('right') > -1) {
            value = value.replace('right', 'left');
          } else if (value.indexOf('left') > -1) {
            value = value.replace('left', 'right');
          }
          break;
      }

      newStyle[key] = value;
    });

    return newStyle;
  },

  prepareStyles: function prepareStyles(muiTheme) {
    for (var _len = arguments.length, styles = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      styles[_key - 1] = arguments[_key];
    }

    styles = styles.length > 1 ? ImmutabilityHelper.merge.apply(this, styles) : styles[0] || {};
    var flipped = this.ensureDirection(muiTheme, styles);
    return AutoPrefix.all(flipped);
  }
};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  iconSize: 24,

  desktopGutter: 24,
  desktopGutterMore: 32,
  desktopGutterLess: 16,
  desktopGutterMini: 8,
  desktopKeylineIncrement: 64,
  desktopDropDownMenuItemHeight: 32,
  desktopDropDownMenuFontSize: 15,
  desktopLeftNavMenuItemHeight: 48,
  desktopSubheaderHeight: 48,
  desktopToolbarHeight: 56
};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isObject(obj) {
  return typeof obj === 'object' && obj !== null;
}

/**
*  A recursive merge between two objects.
*
*  @param base     - the object whose properties are to be overwritten. It
*                    should be either the root level or some nested level.
*  @param override - an object containing properties to be overwritten. It
*                    should have the same structure as the object object.
*/
var extend = function extend(base, override) {

  var mergedObject = {};

  //Loop through each key in the base object
  Object.keys(base).forEach(function (key) {

    var baseProp = base[key];
    var overrideProp = undefined;

    if (isObject(override)) overrideProp = override[key];

    //Recursive call extend if the prop is another object, else just copy it over
    mergedObject[key] = isObject(baseProp) && !Array.isArray(baseProp) ? extend(baseProp, overrideProp) : baseProp;
  });

  //Loop through each override key and override the props in the
  //base object
  if (isObject(override)) {

    Object.keys(override).forEach(function (overrideKey) {

      var overrideProp = override[overrideKey];

      //Only copy over props that are not objects
      if (!isObject(overrideProp) || Array.isArray(overrideProp)) {
        mergedObject[overrideKey] = overrideProp;
      }
    });
  }

  return mergedObject;
};

module.exports = extend;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var PureRenderMixin = __webpack_require__(1);
var ReactTransitionGroup = __webpack_require__(188);
var StylePropable = __webpack_require__(10);
var Dom = __webpack_require__(352);
var ImmutabilityHelper = __webpack_require__(162);
var CircleRipple = __webpack_require__(520);

var TouchRipple = React.createClass({
  displayName: 'TouchRipple',

  mixins: [PureRenderMixin, StylePropable],

  propTypes: {
    centerRipple: React.PropTypes.bool,
    color: React.PropTypes.string,
    opacity: React.PropTypes.number
  },

  getInitialState: function getInitialState() {
    return {
      //This prop allows us to only render the ReactTransitionGroup
      //on the first click of the component, making the inital
      //render faster
      hasRipples: false,
      nextKey: 0,
      ripples: []
    };
  },

  render: function render() {
    var _props = this.props;
    var children = _props.children;
    var style = _props.style;
    var _state = this.state;
    var hasRipples = _state.hasRipples;
    var ripples = _state.ripples;

    var rippleGroup = undefined;
    if (hasRipples) {
      var mergedStyles = this.mergeAndPrefix({
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        overflow: 'hidden'
      }, style);

      rippleGroup = React.createElement(
        ReactTransitionGroup,
        { style: mergedStyles },
        ripples
      );
    }

    return React.createElement(
      'div',
      {
        onMouseUp: this._handleMouseUp,
        onMouseDown: this._handleMouseDown,
        onMouseLeave: this._handleMouseLeave,
        onTouchStart: this._handleTouchStart,
        onTouchEnd: this._handleTouchEnd },
      rippleGroup,
      children
    );
  },

  start: function start(e, isRippleTouchGenerated) {
    var ripples = this.state.ripples;

    //Do nothing if we're starting a click-event-generated ripple
    //while having touch-generated ripples
    if (!isRippleTouchGenerated) {
      for (var i = 0; i < ripples.length; i++) {
        if (ripples[i].props.touchGenerated) return;
      }
    }

    //Add a ripple to the ripples array
    ripples = ImmutabilityHelper.push(ripples, React.createElement(CircleRipple, {
      key: this.state.nextKey,
      style: !this.props.centerRipple ? this._getRippleStyle(e) : {},
      color: this.props.color,
      opacity: this.props.opacity,
      touchGenerated: isRippleTouchGenerated }));

    this.setState({
      hasRipples: true,
      nextKey: this.state.nextKey + 1,
      ripples: ripples
    });
  },

  end: function end() {
    var currentRipples = this.state.ripples;
    this.setState({
      ripples: ImmutabilityHelper.shift(currentRipples)
    });
  },

  _handleMouseDown: function _handleMouseDown(e) {
    //only listen to left clicks
    if (e.button === 0) this.start(e, false);
  },

  _handleMouseUp: function _handleMouseUp() {
    this.end();
  },

  _handleMouseLeave: function _handleMouseLeave() {
    this.end();
  },

  _handleTouchStart: function _handleTouchStart(e) {
    this.start(e, true);
  },

  _handleTouchEnd: function _handleTouchEnd() {
    this.end();
  },

  _getRippleStyle: function _getRippleStyle(e) {
    var style = {};
    var el = ReactDOM.findDOMNode(this);
    var elHeight = el.offsetHeight;
    var elWidth = el.offsetWidth;
    var offset = Dom.offset(el);
    var isTouchEvent = e.touches && e.touches.length;
    var pageX = isTouchEvent ? e.touches[0].pageX : e.pageX;
    var pageY = isTouchEvent ? e.touches[0].pageY : e.pageY;
    var pointerX = pageX - offset.left;
    var pointerY = pageY - offset.top;
    var topLeftDiag = this._calcDiag(pointerX, pointerY);
    var topRightDiag = this._calcDiag(elWidth - pointerX, pointerY);
    var botRightDiag = this._calcDiag(elWidth - pointerX, elHeight - pointerY);
    var botLeftDiag = this._calcDiag(pointerX, elHeight - pointerY);
    var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
    var rippleSize = rippleRadius * 2;
    var left = pointerX - rippleRadius;
    var top = pointerY - rippleRadius;

    style.height = rippleSize + 'px';
    style.width = rippleSize + 'px';
    style.top = top + 'px';
    style.left = left + 'px';

    return style;
  },

  _calcDiag: function _calcDiag(a, b) {
    return Math.sqrt(a * a + b * b);
  }

});

module.exports = TouchRipple;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  isDescendant: function isDescendant(parent, child) {
    var node = child.parentNode;

    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }

    return false;
  },

  offset: function offset(el) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top + document.body.scrollTop,
      left: rect.left + document.body.scrollLeft
    };
  },

  getStyleAttributeAsNumber: function getStyleAttributeAsNumber(el, attr) {
    var attrStyle = el.style[attr];
    var attrNum = 0;
    if (attrStyle && attrStyle.length) {
      attrNum = parseInt(attrStyle);
    }

    return attrNum;
  },

  addClass: function addClass(el, className) {
    if (el.classList) el.classList.add(className);else el.className += ' ' + className;
  },

  removeClass: function removeClass(el, className) {
    if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
  },

  hasClass: function hasClass(el, className) {
    if (el.classList) return el.classList.contains(className);else return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
  },

  toggleClass: function toggleClass(el, className) {
    if (this.hasClass(el, className)) this.removeClass(el, className);else this.addClass(el, className);
  },

  forceRedraw: function forceRedraw(el) {
    var originalDisplay = el.style.display;

    el.style.display = 'none';
    el.style.display = originalDisplay;
  },

  withoutTransition: function withoutTransition(el, callback) {
    var originalTransition = el.style.transition;

    //turn off transition
    el.style.transition = null;

    callback();

    //force a redraw
    this.forceRedraw(el);

    //put the transition back
    el.style.transition = originalTransition;
  }

};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var Colors = __webpack_require__(53);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Tooltip = React.createClass({
  displayName: 'Tooltip',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    className: React.PropTypes.string,
    label: React.PropTypes.node.isRequired,
    show: React.PropTypes.bool,
    touch: React.PropTypes.bool,
    verticalPosition: React.PropTypes.oneOf(['top', 'bottom']),
    horizontalPosition: React.PropTypes.oneOf(['left', 'right', 'center'])
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  componentDidMount: function componentDidMount() {
    this._setRippleSize();
    this._setTooltipPosition();
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    this._setTooltipPosition();

    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  componentDidUpdate: function componentDidUpdate() {
    this._setRippleSize();
  },

  getInitialState: function getInitialState() {
    return {
      offsetWidth: null,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  getStyles: function getStyles() {
    var verticalPosition = this.props.verticalPosition;
    var horizontalPosition = this.props.horizontalPosition;
    var touchMarginOffset = this.props.touch ? 10 : 0;
    var touchOffsetTop = this.props.touch ? -20 : -10;
    var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;

    var styles = {
      root: {
        position: 'absolute',
        fontFamily: this.state.muiTheme.rawTheme.fontFamily,
        fontSize: '10px',
        lineHeight: '22px',
        padding: '0 8px',
        color: Colors.white,
        overflow: 'hidden',
        top: -10000,
        borderRadius: 2,
        userSelect: 'none',
        opacity: 0,
        right: horizontalPosition === 'left' ? 12 : null,
        left: horizontalPosition === 'center' ? (this.state.offsetWidth - 48) / 2 * -1 : null,
        transition: Transitions.easeOut('0ms', 'top', '450ms') + ',' + Transitions.easeOut('450ms', 'transform', '0ms') + ',' + Transitions.easeOut('450ms', 'opacity', '0ms')
      },
      label: {
        position: 'relative',
        whiteSpace: 'nowrap'
      },
      ripple: {
        position: 'absolute',
        left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
        top: verticalPosition === 'bottom' ? 0 : '100%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '50%',
        backgroundColor: 'transparent',
        transition: Transitions.easeOut('0ms', 'width', '450ms') + ',' + Transitions.easeOut('0ms', 'height', '450ms') + ',' + Transitions.easeOut('450ms', 'backgroundColor', '0ms')
      },
      rootWhenShown: {
        top: verticalPosition === 'top' ? touchOffsetTop : 36,
        opacity: 0.9,
        transform: 'translate3d(0px, ' + offset + 'px, 0px)',
        transition: Transitions.easeOut('0ms', 'top', '0ms') + ',' + Transitions.easeOut('450ms', 'transform', '0ms') + ',' + Transitions.easeOut('450ms', 'opacity', '0ms')
      },
      rootWhenTouched: {
        fontSize: '14px',
        lineHeight: '32px',
        padding: '0 16px'
      },
      rippleWhenShown: {
        backgroundColor: Colors.grey700,
        transition: Transitions.easeOut('450ms', 'width', '0ms') + ',' + Transitions.easeOut('450ms', 'height', '0ms') + ',' + Transitions.easeOut('450ms', 'backgroundColor', '0ms')
      }
    };

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var label = _props.label;

    var other = _objectWithoutProperties(_props, ['label']);

    var styles = this.getStyles();
    return React.createElement(
      'div',
      _extends({}, other, {
        style: this.prepareStyles(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style) }),
      React.createElement('div', {
        ref: 'ripple',
        style: this.prepareStyles(styles.ripple, this.props.show && styles.rippleWhenShown) }),
      React.createElement(
        'span',
        { style: this.prepareStyles(styles.label) },
        this.props.label
      )
    );
  },

  _setRippleSize: function _setRippleSize() {
    var ripple = ReactDOM.findDOMNode(this.refs.ripple);
    var tooltip = window.getComputedStyle(ReactDOM.findDOMNode(this));
    var tooltipWidth = parseInt(tooltip.getPropertyValue("width"), 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
    var tooltipHeight = parseInt(tooltip.getPropertyValue("height"), 10);

    var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
    if (this.props.show) {
      ripple.style.height = rippleDiameter + 'px';
      ripple.style.width = rippleDiameter + 'px';
    } else {
      ripple.style.width = '0px';
      ripple.style.height = '0px';
    }
  },

  _setTooltipPosition: function _setTooltipPosition() {
    var tooltip = ReactDOM.findDOMNode(this);
    this.setState({ offsetWidth: tooltip.offsetWidth });
  }

});

module.exports = Tooltip;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationMenu = React.createClass({
  displayName: 'NavigationMenu',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
    );
  }

});

module.exports = NavigationMenu;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var EnhancedSwitch = __webpack_require__(356);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var CheckboxOutline = __webpack_require__(526);
var CheckboxChecked = __webpack_require__(527);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Checkbox = React.createClass({
  displayName: 'Checkbox',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    checked: React.PropTypes.bool,
    checkedIcon: React.PropTypes.element,
    defaultChecked: React.PropTypes.bool,
    iconStyle: React.PropTypes.object,
    labelStyle: React.PropTypes.object,
    onCheck: React.PropTypes.func,
    unCheckedIcon: React.PropTypes.element
  },

  getInitialState: function getInitialState() {
    return {
      switched: this.props.checked || this.props.defaultChecked || this.props.valueLink && this.props.valueLink.value || false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.checkbox;
  },

  getStyles: function getStyles() {
    var checkboxSize = 24;
    var styles = {
      icon: {
        height: checkboxSize,
        width: checkboxSize
      },
      check: {
        position: 'absolute',
        opacity: 0,
        transform: 'scale(0)',
        transitionOrigin: '50% 50%',
        transition: Transitions.easeOut('450ms', 'opacity', '0ms') + ', ' + Transitions.easeOut('0ms', 'transform', '450ms'),
        fill: this.getTheme().checkedColor
      },
      box: {
        position: 'absolute',
        opacity: 1,
        fill: this.getTheme().boxColor,
        transition: Transitions.easeOut('2s', null, '200ms')
      },
      checkWhenSwitched: {
        opacity: 1,
        transform: 'scale(1)',
        transition: Transitions.easeOut('0ms', 'opacity', '0ms') + ', ' + Transitions.easeOut('800ms', 'transform', '0ms')
      },
      boxWhenSwitched: {
        transition: Transitions.easeOut('100ms', null, '0ms'),
        fill: this.getTheme().checkedColor
      },
      checkWhenDisabled: {
        fill: this.getTheme().disabledColor
      },
      boxWhenDisabled: {
        fill: this.getTheme().disabledColor
      },
      label: {
        color: this.props.disabled ? this.getTheme().labelDisabledColor : this.getTheme().labelColor
      }
    };

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var iconStyle = _props.iconStyle;
    var onCheck = _props.onCheck;
    var checkedIcon = _props.checkedIcon;
    var unCheckedIcon = _props.unCheckedIcon;

    var other = _objectWithoutProperties(_props, ['iconStyle', 'onCheck', 'checkedIcon', 'unCheckedIcon']);

    var styles = this.getStyles();
    var boxStyles = this.mergeStyles(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
    var checkStyles = this.mergeStyles(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);

    var checkedElement = checkedIcon ? React.cloneElement(checkedIcon, {
      style: this.mergeStyles(checkStyles, checkedIcon.props.style)
    }) : React.createElement(CheckboxChecked, {
      style: checkStyles
    });

    var unCheckedElement = unCheckedIcon ? React.cloneElement(unCheckedIcon, {
      style: this.mergeStyles(boxStyles, unCheckedIcon.props.style)
    }) : React.createElement(CheckboxOutline, {
      style: boxStyles
    });

    var checkboxElement = React.createElement(
      'div',
      null,
      unCheckedElement,
      checkedElement
    );

    var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
    var mergedIconStyle = this.mergeStyles(styles.icon, iconStyle);

    var labelStyle = this.mergeStyles(styles.label, this.props.labelStyle);

    var enhancedSwitchProps = {
      ref: "enhancedSwitch",
      inputType: "checkbox",
      switched: this.state.switched,
      switchElement: checkboxElement,
      rippleColor: rippleColor,
      iconStyle: mergedIconStyle,
      onSwitch: this._handleCheck,
      labelStyle: labelStyle,
      onParentShouldUpdate: this._handleStateChange,
      defaultSwitched: this.props.defaultChecked,
      labelPosition: this.props.labelPosition ? this.props.labelPosition : "right"
    };

    return React.createElement(EnhancedSwitch, _extends({}, other, enhancedSwitchProps));
  },

  isChecked: function isChecked() {
    return this.refs.enhancedSwitch.isSwitched();
  },

  setChecked: function setChecked(newCheckedValue) {
    this.refs.enhancedSwitch.setSwitched(newCheckedValue);
  },

  _handleCheck: function _handleCheck(e, isInputChecked) {
    if (this.props.onCheck) this.props.onCheck(e, isInputChecked);
  },

  _handleStateChange: function _handleStateChange(newSwitched) {
    this.setState({ switched: newSwitched });
  }

});

module.exports = Checkbox;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var KeyCode = __webpack_require__(79);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var UniqueId = __webpack_require__(357);
var WindowListenable = __webpack_require__(103);
var ClearFix = __webpack_require__(191);
var FocusRipple = __webpack_require__(245);
var TouchRipple = __webpack_require__(351);
var Paper = __webpack_require__(54);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var EnhancedSwitch = React.createClass({
  displayName: 'EnhancedSwitch',

  mixins: [WindowListenable, StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    id: React.PropTypes.string,
    inputType: React.PropTypes.string.isRequired,
    switchElement: React.PropTypes.element.isRequired,
    onParentShouldUpdate: React.PropTypes.func.isRequired,
    switched: React.PropTypes.bool.isRequired,
    rippleStyle: React.PropTypes.object,
    rippleColor: React.PropTypes.string,
    iconStyle: React.PropTypes.object,
    thumbStyle: React.PropTypes.object,
    trackStyle: React.PropTypes.object,
    labelStyle: React.PropTypes.object,
    name: React.PropTypes.string,
    value: React.PropTypes.string,
    label: React.PropTypes.string,
    onSwitch: React.PropTypes.func,
    required: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
    defaultSwitched: React.PropTypes.bool,
    labelPosition: React.PropTypes.oneOf(['left', 'right']),
    disableFocusRipple: React.PropTypes.bool,
    disableTouchRipple: React.PropTypes.bool
  },

  windowListeners: {
    keydown: '_handleWindowKeydown',
    keyup: '_handleWindowKeyup'
  },

  getInitialState: function getInitialState() {
    return {
      isKeyboardFocused: false,
      parentWidth: 100,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  getEvenWidth: function getEvenWidth() {
    return parseInt(window.getComputedStyle(ReactDOM.findDOMNode(this.refs.root)).getPropertyValue('width'), 10);
  },

  componentDidMount: function componentDidMount() {
    var inputNode = ReactDOM.findDOMNode(this.refs.checkbox);
    if (!this.props.switched || inputNode.checked !== this.props.switched) {
      this.props.onParentShouldUpdate(inputNode.checked);
    }

    window.addEventListener("resize", this._handleResize);

    this._handleResize();
  },

  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener("resize", this._handleResize);
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var hasCheckedLinkProp = nextProps.hasOwnProperty('checkedLink');
    var hasCheckedProp = nextProps.hasOwnProperty('checked');
    var hasToggledProp = nextProps.hasOwnProperty('toggled');
    var hasNewDefaultProp = nextProps.hasOwnProperty('defaultSwitched') && nextProps.defaultSwitched !== this.props.defaultSwitched;
    var newState = {};
    newState.muiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;

    if (hasCheckedProp) {
      newState.switched = nextProps.checked;
    } else if (hasToggledProp) {
      newState.switched = nextProps.toggled;
    } else if (hasCheckedLinkProp) {
      newState.switched = nextProps.checkedLink.value;
    } else if (hasNewDefaultProp) {
      newState.switched = nextProps.defaultSwitched;
    }

    if (newState.switched !== undefined && newState.switched !== this.props.switched) {
      this.props.onParentShouldUpdate(newState.switched);
    }

    this.setState(newState);
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.rawTheme.palette;
  },

  getStyles: function getStyles() {
    var spacing = this.state.muiTheme.rawTheme.spacing;
    var switchWidth = 60 - spacing.desktopGutterLess;
    var labelWidth = 'calc(100% - 60px)';
    var styles = {
      root: {
        position: 'relative',
        cursor: this.props.disabled ? 'default' : 'pointer',
        overflow: 'visible',
        display: 'table',
        height: 'auto',
        width: '100%'
      },
      input: {
        position: 'absolute',
        cursor: this.props.disabled ? 'default' : 'pointer',
        pointerEvents: 'all',
        opacity: 0,
        width: '100%',
        height: '100%',
        zIndex: 2,
        left: 0,
        boxSizing: 'border-box',
        padding: 0,
        margin: 0
      },
      controls: {
        width: '100%',
        height: '100%'
      },
      label: {
        float: 'left',
        position: 'relative',
        display: 'block',
        width: labelWidth,
        lineHeight: '24px',
        color: this.getTheme().textColor
      },
      wrap: {
        transition: Transitions.easeOut(),
        float: 'left',
        position: 'relative',
        display: 'block',
        width: switchWidth,
        marginRight: this.props.labelPosition === 'right' ? spacing.desktopGutterLess : 0,
        marginLeft: this.props.labelPosition === 'left' ? spacing.desktopGutterLess : 0
      },
      ripple: {
        height: '200%',
        width: '200%',
        top: -12,
        left: -12
      }
    };

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var type = _props.type;
    var name = _props.name;
    var value = _props.value;
    var label = _props.label;
    var onSwitch = _props.onSwitch;
    var defaultSwitched = _props.defaultSwitched;
    var onBlur = _props.onBlur;
    var onFocus = _props.onFocus;
    var onMouseUp = _props.onMouseUp;
    var onMouseDown = _props.onMouseDown;
    var onMouseLeave = _props.onMouseLeave;
    var onTouchStart = _props.onTouchStart;
    var onTouchEnd = _props.onTouchEnd;
    var disableTouchRipple = _props.disableTouchRipple;
    var disableFocusRipple = _props.disableFocusRipple;
    var className = _props.className;

    var other = _objectWithoutProperties(_props, ['type', 'name', 'value', 'label', 'onSwitch', 'defaultSwitched', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'disableTouchRipple', 'disableFocusRipple', 'className']);

    var styles = this.getStyles();
    var wrapStyles = this.prepareStyles(styles.wrap, this.props.iconStyle);
    var rippleStyle = this.prepareStyles(styles.ripple, this.props.rippleStyle);
    var rippleColor = this.props.hasOwnProperty('rippleColor') ? this.props.rippleColor : this.getTheme().primary1Color;

    if (this.props.thumbStyle) {
      wrapStyles.marginLeft /= 2;
      wrapStyles.marginRight /= 2;
    }

    var inputId = this.props.id || UniqueId.generate();

    var labelStyle = this.prepareStyles(styles.label, this.props.labelStyle);
    var labelElement = this.props.label ? React.createElement(
      'label',
      { style: labelStyle, htmlFor: inputId },
      this.props.label
    ) : null;

    var inputProps = {
      ref: "checkbox",
      type: this.props.inputType,
      style: this.prepareStyles(styles.input),
      name: this.props.name,
      value: this.props.value,
      defaultChecked: this.props.defaultSwitched,
      onBlur: this._handleBlur,
      onFocus: this._handleFocus
    };

    var hideTouchRipple = this.props.disabled || disableTouchRipple;

    if (!hideTouchRipple) {
      inputProps.onMouseUp = this._handleMouseUp;
      inputProps.onMouseDown = this._handleMouseDown;
      inputProps.onMouseLeave = this._handleMouseLeave;
      inputProps.onTouchStart = this._handleTouchStart;
      inputProps.onTouchEnd = this._handleTouchEnd;
    }

    if (!this.props.hasOwnProperty('checkedLink')) {
      inputProps.onChange = this._handleChange;
    }

    var inputElement = React.createElement('input', _extends({}, other, inputProps));

    var touchRipple = React.createElement(TouchRipple, {
      ref: 'touchRipple',
      key: 'touchRipple',
      style: rippleStyle,
      color: rippleColor,
      centerRipple: true });

    var focusRipple = React.createElement(FocusRipple, {
      key: 'focusRipple',
      innerStyle: rippleStyle,
      color: rippleColor,
      show: this.state.isKeyboardFocused });

    var ripples = [hideTouchRipple ? null : touchRipple, this.props.disabled || disableFocusRipple ? null : focusRipple];

    // If toggle component (indicated by whether the style includes thumb) manually lay out
    // elements in order to nest ripple elements
    var switchElement = !this.props.thumbStyle ? React.createElement(
      'div',
      { style: wrapStyles },
      this.props.switchElement,
      ripples
    ) : React.createElement(
      'div',
      { style: wrapStyles },
      React.createElement('div', { style: this.prepareStyles(this.props.trackStyle) }),
      React.createElement(
        Paper,
        { style: this.props.thumbStyle, zDepth: 1, circle: true },
        ' ',
        ripples,
        ' '
      )
    );

    var labelPositionExist = this.props.labelPosition;

    // Position is left if not defined or invalid.
    var elementsInOrder = labelPositionExist && this.props.labelPosition.toUpperCase() === "RIGHT" ? React.createElement(
      ClearFix,
      { style: styles.controls },
      switchElement,
      labelElement
    ) : React.createElement(
      ClearFix,
      { style: styles.controls },
      labelElement,
      switchElement
    );

    return React.createElement(
      'div',
      { ref: 'root', className: className, style: this.prepareStyles(styles.root, this.props.style) },
      inputElement,
      elementsInOrder
    );
  },

  isSwitched: function isSwitched() {
    return ReactDOM.findDOMNode(this.refs.checkbox).checked;
  },

  // no callback here because there is no event
  setSwitched: function setSwitched(newSwitchedValue) {
    if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
      this.props.onParentShouldUpdate(newSwitchedValue);
      ReactDOM.findDOMNode(this.refs.checkbox).checked = newSwitchedValue;
    } else if (false) {
      var message = 'Cannot call set method while checked is defined as a property.';
      console.error(message);
    }
  },

  getValue: function getValue() {
    return ReactDOM.findDOMNode(this.refs.checkbox).value;
  },

  isKeyboardFocused: function isKeyboardFocused() {
    return this.state.isKeyboardFocused;
  },

  _handleChange: function _handleChange(e) {
    this._tabPressed = false;
    this.setState({
      isKeyboardFocused: false
    });

    var isInputChecked = ReactDOM.findDOMNode(this.refs.checkbox).checked;

    if (!this.props.hasOwnProperty('checked')) {
      this.props.onParentShouldUpdate(isInputChecked);
    }
    if (this.props.onSwitch) {
      this.props.onSwitch(e, isInputChecked);
    }
  },

  // Checkbox inputs only use SPACE to change their state. Using ENTER will
  // update the ui but not the input.
  _handleWindowKeydown: function _handleWindowKeydown(e) {
    if (e.keyCode === KeyCode.TAB) {
      this._tabPressed = true;
    }
    if (e.keyCode === KeyCode.SPACE && this.state.isKeyboardFocused) {
      this._handleChange(e);
    }
  },

  _handleWindowKeyup: function _handleWindowKeyup(e) {
    if (e.keyCode === KeyCode.SPACE && this.state.isKeyboardFocused) {
      this._handleChange(e);
    }
  },

  /**
   * Because both the ripples and the checkbox input cannot share pointer
   * events, the checkbox input takes control of pointer events and calls
   * ripple animations manually.
   */
  _handleMouseDown: function _handleMouseDown(e) {
    //only listen to left clicks
    if (e.button === 0) {
      this.refs.touchRipple.start(e);
    }
  },

  _handleMouseUp: function _handleMouseUp() {
    this.refs.touchRipple.end();
  },

  _handleMouseLeave: function _handleMouseLeave() {
    this.refs.touchRipple.end();
  },

  _handleTouchStart: function _handleTouchStart(e) {
    this.refs.touchRipple.start(e);
  },

  _handleTouchEnd: function _handleTouchEnd() {
    this.refs.touchRipple.end();
  },

  _handleBlur: function _handleBlur(e) {
    this.setState({
      isKeyboardFocused: false
    });

    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
  },

  _handleFocus: function _handleFocus(e) {
    var _this = this;

    //setTimeout is needed becuase the focus event fires first
    //Wait so that we can capture if this was a keyboard focus
    //or touch focus
    setTimeout(function () {
      if (_this._tabPressed) {
        _this.setState({
          isKeyboardFocused: true
        });
      }
    }, 150);

    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
  },

  _handleResize: function _handleResize() {
    this.setState({ parentWidth: this.getEvenWidth() });
  }

});

module.exports = EnhancedSwitch;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var index = 0;

module.exports = {
  generate: function generate() {
    return "mui-id-" + index++;
  }
};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationChevronLeft = React.createClass({
  displayName: 'NavigationChevronLeft',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
    );
  }

});

module.exports = NavigationChevronLeft;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationChevronRight = React.createClass({
  displayName: 'NavigationChevronRight',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
    );
  }

});

module.exports = NavigationChevronRight;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactTransitionGroup = __webpack_require__(188);
var StylePropable = __webpack_require__(10);
var SlideInChild = __webpack_require__(1037);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var SlideIn = React.createClass({
  displayName: 'SlideIn',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  propTypes: {
    enterDelay: React.PropTypes.number,
    childStyle: React.PropTypes.object,
    direction: React.PropTypes.oneOf(['left', 'right', 'up', 'down'])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      enterDelay: 0,
      direction: 'left'
    };
  },

  render: function render() {
    var _this = this;

    var _props = this.props;
    var enterDelay = _props.enterDelay;
    var children = _props.children;
    var childStyle = _props.childStyle;
    var direction = _props.direction;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);

    var mergedRootStyles = this.prepareStyles({
      position: 'relative',
      overflow: 'hidden',
      height: '100%'
    }, style);

    var newChildren = React.Children.map(children, function (child) {
      return React.createElement(
        SlideInChild,
        {
          key: child.key,
          direction: direction,
          enterDelay: enterDelay,
          getLeaveDirection: _this._getLeaveDirection,
          style: childStyle },
        child
      );
    }, this);

    return React.createElement(
      ReactTransitionGroup,
      _extends({}, other, {
        style: mergedRootStyles,
        component: 'div' }),
      newChildren
    );
  },

  _getLeaveDirection: function _getLeaveDirection() {
    return this.props.direction;
  }

});

module.exports = SlideIn;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var WindowListenable = __webpack_require__(103);
var CssEvent = __webpack_require__(192);
var KeyCode = __webpack_require__(79);
var Transitions = __webpack_require__(21);
var StylePropable = __webpack_require__(10);
var FlatButton = __webpack_require__(193);
var Overlay = __webpack_require__(362);
var Paper = __webpack_require__(54);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var ReactTransitionGroup = __webpack_require__(188);

var TransitionItem = React.createClass({
  displayName: 'TransitionItem',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      style: {},
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  componentWillEnter: function componentWillEnter(callback) {
    var spacing = this.state.muiTheme.rawTheme.spacing;

    this.setState({
      style: {
        opacity: 1,
        transform: 'translate3d(0, ' + spacing.desktopKeylineIncrement + 'px, 0)'
      }
    });

    setTimeout(callback, 450); // matches transition duration
  },

  componentWillLeave: function componentWillLeave(callback) {
    var _this = this;

    this.setState({
      style: {
        opacity: 0,
        transform: 'translate3d(0, 0, 0)'
      }
    });

    setTimeout(function () {
      if (_this.isMounted()) callback();
    }, 450); // matches transition duration
  },

  render: function render() {
    var _props = this.props;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['style']);

    return React.createElement(
      'div',
      _extends({}, other, { style: this.prepareStyles(this.state.style, style) }),
      this.props.children
    );
  }
});

var Dialog = React.createClass({
  displayName: 'Dialog',

  mixins: [WindowListenable, StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    actions: React.PropTypes.array,
    autoDetectWindowHeight: React.PropTypes.bool,
    autoScrollBodyContent: React.PropTypes.bool,
    bodyStyle: React.PropTypes.object,
    contentClassName: React.PropTypes.string,
    contentStyle: React.PropTypes.object,
    modal: React.PropTypes.bool,
    openImmediately: React.PropTypes.bool,
    onClickAway: React.PropTypes.func,
    onDismiss: React.PropTypes.func,
    onShow: React.PropTypes.func,
    repositionOnUpdate: React.PropTypes.bool,
    title: React.PropTypes.node
  },

  windowListeners: {
    keyup: '_handleWindowKeyUp',
    resize: '_positionDialog'
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autoDetectWindowHeight: false,
      autoScrollBodyContent: false,
      actions: [],
      modal: false,
      repositionOnUpdate: true
    };
  },

  getInitialState: function getInitialState() {
    return {
      open: this.props.openImmediately || false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  componentDidMount: function componentDidMount() {
    this._positionDialog();
    if (this.props.openImmediately) {
      this.refs.dialogOverlay.preventScrolling();
      this._onShow();
    }
  },

  componentDidUpdate: function componentDidUpdate() {
    this._positionDialog();
  },

  getStyles: function getStyles() {
    var spacing = this.state.muiTheme.rawTheme.spacing;

    var main = {
      position: 'fixed',
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
      zIndex: 10,
      top: 0,
      left: -10000,
      width: '100%',
      height: '100%',
      transition: Transitions.easeOut('0ms', 'left', '450ms')
    };

    var content = {
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
      transition: Transitions.easeOut(),
      position: 'relative',
      width: '75%',
      maxWidth: spacing.desktopKeylineIncrement * 12,
      margin: '0 auto',
      zIndex: 10
    };

    var body = {
      padding: spacing.desktopGutter,
      overflowY: this.props.autoScrollBodyContent ? 'auto' : 'hidden',
      overflowX: 'hidden'
    };

    var gutter = spacing.desktopGutter + 'px ';
    var title = {
      margin: 0,
      padding: gutter + gutter + '0 ' + gutter,
      color: this.state.muiTheme.rawTheme.palette.textColor,
      fontSize: 24,
      lineHeight: '32px',
      fontWeight: '400'
    };

    if (this.state.open) {
      main = this.mergeStyles(main, {
        left: 0,
        transition: Transitions.easeOut('0ms', 'left', '0ms')
      });
    }

    return {
      main: this.mergeStyles(main, this.props.style),
      content: this.mergeStyles(content, this.props.contentStyle),
      paper: {
        background: this.state.muiTheme.rawTheme.palette.canvasColor
      },
      body: this.mergeStyles(body, this.props.bodyStyle),
      title: this.mergeStyles(title, this.props.titleStyle)
    };
  },

  render: function render() {
    var styles = this.getStyles();
    var actions = this._getActionsContainer(this.props.actions);
    var title = undefined;
    if (this.props.title) {
      // If the title is a string, wrap in an h3 tag.
      // If not, just use it as a node.
      title = Object.prototype.toString.call(this.props.title) === '[object String]' ? React.createElement(
        'h3',
        { style: this.prepareStyles(styles.title) },
        this.props.title
      ) : this.props.title;
    }

    return React.createElement(
      'div',
      { ref: 'container', style: this.prepareStyles(styles.main) },
      React.createElement(
        ReactTransitionGroup,
        { component: 'div', ref: 'dialogWindow' },
        this.state.open && React.createElement(
          TransitionItem,
          {
            className: this.props.contentClassName,
            style: styles.content },
          React.createElement(
            Paper,
            {
              style: styles.paper,
              zDepth: 4 },
            title,
            React.createElement(
              'div',
              { ref: 'dialogContent', style: this.prepareStyles(styles.body) },
              this.props.children
            ),
            actions
          )
        )
      ),
      React.createElement(Overlay, {
        ref: 'dialogOverlay',
        show: this.state.open,
        autoLockScrolling: false,
        onTouchTap: this._handleOverlayTouchTap })
    );
  },

  isOpen: function isOpen() {
    return this.state.open;
  },

  dismiss: function dismiss() {
    var _this2 = this;

    CssEvent.onTransitionEnd(ReactDOM.findDOMNode(this), function () {
      _this2.refs.dialogOverlay.allowScrolling();
    });

    this.setState({ open: false });
    this._onDismiss();
  },

  show: function show() {
    this.refs.dialogOverlay.preventScrolling();
    this.setState({ open: true }, this._onShow);
  },

  _getAction: function _getAction(actionJSON, key) {
    var _this3 = this;

    var styles = { marginRight: 8 };
    var props = {
      key: key,
      secondary: true,
      onClick: actionJSON.onClick,
      onTouchTap: function onTouchTap() {
        if (actionJSON.onTouchTap) {
          actionJSON.onTouchTap.call(undefined);
        }
        if (!(actionJSON.onClick || actionJSON.onTouchTap)) {
          _this3.dismiss();
        }
      },
      label: actionJSON.text,
      style: styles
    };
    if (actionJSON.ref) {
      props.ref = actionJSON.ref;
      props.keyboardFocused = actionJSON.ref === this.props.actionFocus;
    }
    if (actionJSON.id) {
      props.id = actionJSON.id;
    }

    return React.createElement(FlatButton, props);
  },

  _getActionsContainer: function _getActionsContainer(actions) {
    var actionContainer = undefined;
    var actionObjects = [];
    var actionStyle = {
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
      padding: 8,
      marginBottom: 8,
      width: '100%',
      textAlign: 'right'
    };

    if (actions.length) {
      for (var i = 0; i < actions.length; i++) {
        var currentAction = actions[i];

        //if the current action isn't a react object, create one
        if (!React.isValidElement(currentAction)) {
          currentAction = this._getAction(currentAction, i);
        }

        actionObjects.push(currentAction);
      }

      actionContainer = React.createElement(
        'div',
        { style: this.prepareStyles(actionStyle) },
        actionObjects
      );
    }

    return actionContainer;
  },

  _positionDialog: function _positionDialog() {
    if (this.state.open) {
      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      var container = ReactDOM.findDOMNode(this);
      var dialogWindow = ReactDOM.findDOMNode(this.refs.dialogWindow);
      var dialogContent = ReactDOM.findDOMNode(this.refs.dialogContent);
      var minPaddingTop = 16;

      //Reset the height in case the window was resized.
      dialogWindow.style.height = '';
      dialogContent.style.height = '';

      var dialogWindowHeight = dialogWindow.offsetHeight;
      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;

      //Vertically center the dialog window, but make sure it doesn't
      //transition to that position.
      if (this.props.repositionOnUpdate || !container.style.paddingTop) {
        container.style.paddingTop = paddingTop + 'px';
      }

      // Force a height if the dialog is taller than clientHeight
      if (this.props.autoDetectWindowHeight || this.props.autoScrollBodyContent) {
        var styles = this.getStyles();
        var maxDialogContentHeight = clientHeight - 2 * (styles.body.padding + 64);

        if (this.props.title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
        if (this.props.actions.length) maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;

        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
      }
    }
  },

  _onShow: function _onShow() {
    if (this.props.onShow) this.props.onShow();
  },

  _onDismiss: function _onDismiss() {
    if (this.props.onDismiss) this.props.onDismiss();
  },

  _handleOverlayTouchTap: function _handleOverlayTouchTap(e) {
    if (this.props.modal) {
      e.stopPropagation();
    } else {
      this.dismiss();
      if (this.props.onClickAway) this.props.onClickAway();
    }
  },

  _handleWindowKeyUp: function _handleWindowKeyUp(e) {
    if (e.keyCode === KeyCode.ESC && !this.props.modal) {
      this.dismiss();
    }
  }

});

module.exports = Dialog;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var Colors = __webpack_require__(53);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Overlay = React.createClass({
  displayName: 'Overlay',

  _originalBodyOverflow: '',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  propTypes: {
    autoLockScrolling: React.PropTypes.bool,
    show: React.PropTypes.bool,
    transitionEnabled: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autoLockScrolling: true,
      transitionEnabled: true
    };
  },

  componentDidMount: function componentDidMount() {
    this._originalBodyOverflow = document.getElementsByTagName('body')[0].style.oveflow;
  },

  componentDidUpdate: function componentDidUpdate() {
    if (this.props.autoLockScrolling) {
      if (this.props.show) {
        this._preventScrolling();
      } else {
        this._allowScrolling();
      }
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    this._allowScrolling();
  },

  setOpacity: function setOpacity(opacity) {
    var overlay = ReactDOM.findDOMNode(this);
    overlay.style.opacity = opacity;
  },

  getStyles: function getStyles() {
    var styles = {
      root: {
        position: 'fixed',
        height: '100%',
        width: '100%',
        zIndex: 9,
        top: 0,
        left: '-100%',
        opacity: 0,
        backgroundColor: Colors.lightBlack,
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',

        // Two ways to promote overlay to its own render layer
        willChange: 'opacity',
        transform: 'translateZ(0)',

        transition: this.props.transitionEnabled && Transitions.easeOut('0ms', 'left', '400ms') + ',' + Transitions.easeOut('400ms', 'opacity')
      },
      rootWhenShown: {
        left: '0',
        opacity: 1,
        transition: this.props.transitionEnabled && Transitions.easeOut('0ms', 'left') + ',' + Transitions.easeOut('400ms', 'opacity')
      }
    };
    return styles;
  },

  render: function render() {
    var _props = this.props;
    var show = _props.show;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['show', 'style']);

    var styles = this.prepareStyles(this.getStyles().root, this.props.style, this.props.show && this.getStyles().rootWhenShown);

    return React.createElement('div', _extends({}, other, { style: styles }));
  },

  preventScrolling: function preventScrolling() {
    if (!this.props.autoLockScrolling) this._preventScrolling();
  },

  allowScrolling: function allowScrolling() {
    if (!this.props.autoLockScrolling) this._allowScrolling();
  },

  _preventScrolling: function _preventScrolling() {
    var body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'hidden';
  },

  _allowScrolling: function _allowScrolling() {
    var body = document.getElementsByTagName('body')[0];
    body.style.overflow = this._originalBodyOverflow || '';
  }

});

module.exports = Overlay;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationArrowDropDown = React.createClass({
  displayName: 'NavigationArrowDropDown',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 10l5 5 5-5z' })
    );
  }

});

module.exports = NavigationArrowDropDown;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var PropTypes = __webpack_require__(187);
var StylePropable = __webpack_require__(10);
var Typography = __webpack_require__(135);
var Paper = __webpack_require__(54);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var List = React.createClass({
  displayName: 'List',

  mixins: [PureRenderMixin, StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    insetSubheader: React.PropTypes.bool,
    subheader: React.PropTypes.string,
    subheaderStyle: React.PropTypes.object,
    zDepth: PropTypes.zDepth
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      zDepth: 0
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _props = this.props;
    var children = _props.children;
    var insetSubheader = _props.insetSubheader;
    var style = _props.style;
    var subheader = _props.subheader;
    var subheaderStyle = _props.subheaderStyle;
    var zDepth = _props.zDepth;

    var other = _objectWithoutProperties(_props, ['children', 'insetSubheader', 'style', 'subheader', 'subheaderStyle', 'zDepth']);

    var styles = {
      root: {
        padding: 0,
        paddingBottom: 8,
        paddingTop: subheader ? 0 : 8
      },

      subheader: {
        color: Typography.textLightBlack,
        fontSize: 14,
        fontWeight: Typography.fontWeightMedium,
        lineHeight: '48px',
        paddingLeft: insetSubheader ? 72 : 16
      }
    };

    var subheaderElement = undefined;
    if (subheader) {
      var mergedSubheaderStyles = this.prepareStyles(styles.subheader, subheaderStyle);
      subheaderElement = React.createElement(
        'div',
        { style: mergedSubheaderStyles },
        subheader
      );
    }

    return React.createElement(
      Paper,
      _extends({}, other, {
        style: this.mergeStyles(styles.root, style),
        zDepth: zDepth }),
      subheaderElement,
      children
    );
  }
});

module.exports = List;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var TableRowColumn = React.createClass({
  displayName: 'TableRowColumn',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    columnNumber: React.PropTypes.number,
    hoverable: React.PropTypes.bool,
    onClick: React.PropTypes.func,
    onHover: React.PropTypes.func,
    onHoverExit: React.PropTypes.func,
    style: React.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      hoverable: false
    };
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme),
      hovered: false
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.tableRowColumn;
  },

  getStyles: function getStyles() {
    var theme = this.getTheme();
    var styles = {
      root: {
        paddingLeft: theme.spacing,
        paddingRight: theme.spacing,
        height: theme.height,
        textAlign: 'left',
        fontSize: 13,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
      }
    };

    if (React.Children.count(this.props.children) === 1 && !isNaN(this.props.children)) {
      styles.textAlign = 'right';
    }

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var className = _props.className;
    var columnNumber = _props.columnNumber;
    var hoverable = _props.hoverable;
    var onClick = _props.onClick;
    var onHover = _props.onHover;
    var onHoverExit = _props.onHoverExit;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);

    var styles = this.getStyles();
    var handlers = {
      onClick: this._onClick,
      onMouseEnter: this._onMouseEnter,
      onMouseLeave: this._onMouseLeave
    };
    var classes = 'mui-table-row-column';
    if (className) classes += ' ' + className;

    return React.createElement(
      'td',
      _extends({
        key: this.props.key,
        className: classes,
        style: this.prepareStyles(styles.root, style)
      }, handlers, other),
      this.props.children
    );
  },

  _onClick: function _onClick(e) {
    if (this.props.onClick) this.props.onClick(e, this.props.columnNumber);
  },

  _onMouseEnter: function _onMouseEnter(e) {
    if (this.props.hoverable) {
      this.setState({ hovered: true });
      if (this.props.onHover) this.props.onHover(e, this.props.columnNumber);
    }
  },

  _onMouseLeave: function _onMouseLeave(e) {
    if (this.props.hoverable) {
      this.setState({ hovered: false });
      if (this.props.onHoverExit) this.props.onHoverExit(e, this.props.columnNumber);
    }
  }

});

module.exports = TableRowColumn;

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Portal__ = __webpack_require__(113);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={bubble:'_cp',padded:'_cq',active:'_cr',hasArrow:'_cs'};var Tooltip=function(_Component){_inherits(Tooltip,_Component);function Tooltip(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Tooltip);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Tooltip.__proto__||Object.getPrototypeOf(Tooltip)).call.apply(_ref,[this].concat(args))),_this),_this.state={top:null,left:null,width:null},_this.handleMount=function(portal){var anchorTo=_this.props.anchorTo;_this._anchor=anchorTo();_this._portal=portal;_this.position();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Tooltip,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.position();}},{key:'getTooltipStyle',value:function getTooltipStyle(){var _state=this.state,width=_state.width,top=_state.top,left=_state.left;return{transform:'translate3d( '+(left||0)+'px, '+(top||0)+'px, 0px)',width:width};}},{key:'getPosition',value:function getPosition(){var getPosition=this.props.getPosition;var rect=this._anchor.getBoundingClientRect();var ownRect=this._portal.getBoundingClientRect();if(getPosition){return getPosition(rect,ownRect);}return this.defaultPosition(rect,ownRect);}},{key:'defaultPosition',value:function defaultPosition(rect,ownRect){return{left:rect.left-ownRect.width/2+rect.width/2,top:rect.top+rect.height+__WEBPACK_IMPORTED_MODULE_2_Css__["Units"].base*2};}},{key:'position',value:function position(){var _getPosition=this.getPosition(),left=_getPosition.left,top=_getPosition.top,width=_getPosition.width;if(this.state.left!==left||this.state.top!==top){this.setState({left:left,top:top,width:width});}}},{key:'render',value:function render(){var _classNames;var _props=this.props,children=_props.children,style=_props.style,padded=_props.padded,hasArrow=_props.hasArrow,other=_objectWithoutProperties(_props,['children','style','padded','hasArrow']);var top=this.state.top;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Portal__["a" /* default */],Object.assign({onMount:this.handleMount,className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.bubble,(_classNames={},_defineProperty(_classNames,css.hasArrow,hasArrow),_defineProperty(_classNames,css.padded,padded),_defineProperty(_classNames,css.active,top!==null),_classNames)),style:this.getTooltipStyle()},other),children);}}]);return Tooltip;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Tooltip.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,anchorTo:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,padded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,getPosition:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,hasArrow:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};Tooltip.defaultProps={padded:true,hasArrow:true};/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialized=false;var debug=true;var verifyInit=function verifyInit(){if(!initialized){console.warn('Pixel not initialized before using call ReactPixel.init with required params');}return initialized;};var log=function log(){var _console;for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}(_console=console).info.apply(_console,_toConsumableArray(['[react-facebook-pixel]'].concat(args)));};var defaultOptions={autoConfig:true,debug:false};/* harmony default export */ __webpack_exports__["a"] = ({init:function init(pixelId){var advancedMatching=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:defaultOptions;/* eslint-disable */!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments);};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s);}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');/* eslint-enable */if(!pixelId){console.warn('Please insert pixel id for initializing');}else{if(options.autoConfig===false){fbq('set','autoConfig',false,pixelId);// eslint-disable-line no-undef
}fbq('init',pixelId,advancedMatching);// eslint-disable-line no-undef
initialized=true;debug=options.debug;}},pageView:function pageView(){if(!verifyInit()){return;}fbq('track','PageView');// eslint-disable-line no-undef
if(debug){log("called fbq('track', 'PageView');");}},track:function track(title,data){if(!verifyInit()){return;}fbq('track',title,data);// eslint-disable-line no-undef
if(debug){log('called fbq(\'track\', \''+title+'\');');if(data){log('with data',data);}}},trackCustom:function trackCustom(event,data){if(!verifyInit()){return;}fbq('trackCustom',event,data);// eslint-disable-line no-undef
if(debug){log('called fbq(\'trackCustom\', \''+event+'\');');if(data){log('with data',data);}}},fbq:function(_fbq){function fbq(){return _fbq.apply(this,arguments);}fbq.toString=function(){return _fbq.toString();};return fbq;}(function(){if(!verifyInit()){return;}for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}fbq.apply(undefined,_toConsumableArray(args));// eslint-disable-line no-undef
if(debug){log('called fbq(\''+args.slice(0,2).join("', '")+'\')');if(args[2]){log('with data',args[2]);}}})});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_Student__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_App__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_Group__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__ = __webpack_require__(18);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var StudentStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */]],data:{list:[],readers:[],selection:[],sort:{},detail:{},filter:{},total:0,readersLoading:true,saving:false},getInitialState:function getInitialState(){return this.data;},init:function init(){if(localStorage){var student=JSON.parse(localStorage.getItem('students'))||{};if(student.filter){this.data.filter=student.filter;}if(student.sort){this.data.sort=student.sort;}this.trigger(this.data);}},serialize:function serialize(){localStorage.setItem('students',JSON.stringify({filter:this.data.filter,sort:this.data.sort}));},getFilter:function getFilter(){return this.data.filter;},onResetFilter:function onResetFilter(){this.data.filter={};this.trigger(this.data);this.serialize();},onSetFilter:function onSetFilter(filter){Object.assign(this.data.filter,filter);this.trigger(this.data);this.serialize();},onResetSort:function onResetSort(){this.data.sort={};this.trigger(this.data);this.serialize();},onSetSort:function onSetSort(sort){Object.assign(this.data.sort,sort);this.trigger(this.data);this.serialize();},hasFilter:function hasFilter(){return!!this.data.filter.courseId||!!this.data.filter.groupId||!!this.data.filter.access||!!this.data.filter.status;},onFetchAll:function onFetchAll(){var _this=this;return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].call('search','filterUsers',{isRealUser:true},function(response){_this.data.list=response.data;_this.trigger(_this.data);});},countByCourseId:function countByCourseId(courseId){var _this2=this;return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].call('user','countByCourseId',{courseId:courseId},function(response){_this2.data.total=response.data;_this2.trigger(_this2.data);});},findReaders:function findReaders(){var _this3=this;this.data=Object.assign({},this.data,{readersLoading:true});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].request('user','findReaders',{}).then(function(readers){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].findReadersComplete(readers);},function(error){_this3.data=Object.assign({},_this3.data,{readers:[],readersLoading:false});_this3.trigger(_this3.data);__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},findReadersComplete:function findReadersComplete(readers){this.data=Object.assign({},this.data,{readers:readers,readersLoading:false});this.trigger(this.data);},onFilter:function onFilter(dontUseFilter){var options={sortBy:this.data.sort.property||'name',sortMode:this.data.sort.direction||'asc',isRealUser:this.data.filter.status?this.data.filter.status=='invited':null};if(!dontUseFilter){options.courseId=this.data.filter.courseId;options.circleId=this.data.filter.circleId;}this.data.loading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].call('search','filterUsers',options,function(response){if(response.isError){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].genericError(response.errMsg);}else{__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].filterComplete(response.data);}});},onFilterComplete:function onFilterComplete(data){this.data.list=data;this.data.loading=false;this.trigger(this.data);},onFindByGroupId:function onFindByGroupId(groupId,callback){var _this4=this;return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].call('user','findByCircleId',{circleId:groupId,sortBy:'name',sortMode:'asc'},function(response){_this4.data.list=response.data||[];_this4.trigger(_this4.data);if(callback){callback();}});},onFindByCourseId:function onFindByCourseId(courseId,pageStart,pageLength){return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].request('user','findByCourseId',{courseId:courseId,sortBy:'name',sortMode:'asc'},pageStart,pageLength).then(function(students){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].findByCourseIdComplete(students);});// return SteelCompass.request('search', 'filterUsers', { courseId, isRealUser: true, sortBy : name, sortMode : 'asc' }).then(students => {
//   StudentActions.findByCourseIdComplete(students);
// });
},onFindByCourseIdComplete:function onFindByCourseIdComplete(students){this.data.selection=students;this.trigger(this.data);},onFindById:function onFindById(id){this.data.loading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].request('user','findById',{id:id}).then(function(response){if(response.isError){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].genericError(response.errMsg);}else{__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].findByIdComplete(Object.assign({},response));}},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].genericError(error);});},onFindByIdComplete:function onFindByIdComplete(student){this.data.loading=false;this.data.student=student;this.trigger(this.data);},onDelete:function onDelete(groupId,revokeAccess,callback){return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].call('user','delete',{id:groupId,revokeAccess:revokeAccess},function(response){if(callback&&!response.isError){callback();}});},onRemoveFromCourse:function onRemoveFromCourse(courseId,userId){return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].request('user','removeFromCourse',{courseId:courseId,userId:userId}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].removeFromCourseComplete(userId,courseId);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},onRemoveFromCourseComplete:function onRemoveFromCourseComplete(userId,courseId){var selection=this.data.selection;for(var i=selection.length;i--;){if(selection[i].id===userId){selection.splice(i,1);}}__WEBPACK_IMPORTED_MODULE_4_actions_Course__["a" /* default */].removeFromSelection(courseId);this.trigger(this.data);},onRemoveFromGroup:function onRemoveFromGroup(groupId,userId){return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].request('user','removeFromCircle',{circleId:groupId,userId:userId}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].removeFromGroupComplete(userId,groupId);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},onRemoveFromGroupComplete:function onRemoveFromGroupComplete(userId,groupId){var selection=this.data.selection;for(var i=selection.length;i--;){if(selection[i].id===userId){selection.splice(i,1);}}__WEBPACK_IMPORTED_MODULE_3_actions_Group__["a" /* default */].removeFromSelection(groupId);this.trigger(this.data);},onRemoveTag:function onRemoveTag(userId,name){return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].request('tag','removeLink',{objectType:1,objectId:userId,name:name}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].removeTagComplete(userId,name);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},onRemoveTagComplete:function onRemoveTagComplete(userId,name){this.data=Object.assign({},this.data,{list:this.data.list.map(function(user){if(user.id===userId){var tagsMap=user.tagsMap||{};return Object.assign({},user,{tagsMap:Object.assign({},tagsMap,_defineProperty({},name,false))});}return user;})});if(this.data.selection.id===userId){var tagsMap=this.data.selection.tagsMap||{};this.data=Object.assign({},this.data,{selection:Object.assign({},this.data.selection,{tagsMap:Object.assign({},tagsMap,_defineProperty({},name,false))})});}if(this.data.student.id===userId){var _tagsMap=this.data.student.tagsMap||{};this.data=Object.assign({},this.data,{student:Object.assign({},this.data.student,{tagsMap:Object.assign({},_tagsMap,_defineProperty({},name,false))})});}this.trigger(this.data);},export:function _export(options){return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].request('user','export',options).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].exportComplete(response);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},exportComplete:function exportComplete(){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].translatableMessage('student.exportDone');},exportStatistic:function exportStatistic(options){return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].request('course','getTasksReport',options).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].exportStatisticComplete(response);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},exportStatisticComplete:function exportStatisticComplete(){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].translatableMessage('student.exportStatisticDone');},onAddTag:function onAddTag(userId,name){return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].request('tag','addLink',{objectType:1,objectId:userId,name:name}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].addTagComplete(userId,name);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},onAddTagComplete:function onAddTagComplete(userId,name){this.data=Object.assign({},this.data,{list:this.data.list.map(function(user){if(user.id===userId){var tagsMap=user.tagsMap||{};return Object.assign({},user,{tagsMap:Object.assign({},tagsMap,_defineProperty({},name,true))});}return user;})});if(this.data.selection.id===userId){var tagsMap=this.data.selection.tagsMap||{};this.data=Object.assign({},this.data,{selection:Object.assign({},this.data.selection,{tagsMap:Object.assign({},tagsMap,_defineProperty({},name,true))})});}if(this.data.student.id===userId){var _tagsMap2=this.data.student.tagsMap||{};this.data=Object.assign({},this.data,{student:Object.assign({},this.data.student,{tagsMap:Object.assign({},_tagsMap2,_defineProperty({},name,true))})});}this.trigger(this.data);},update:function update(userId,roleValues){this.data=Object.assign({},this.data,{saving:true});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].request('user','update',{id:userId,roles:roleValues}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].updateComplete(userId,roleValues);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},updateComplete:function updateComplete(userId,roleValues){if(this.data.student.id===userId){this.data.student.roles[roleValues]=true;}this.data=Object.assign({},this.data,{saving:false});this.trigger(this.data);__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].translatableMessage('user.updated');},expel:function expel(id){return __WEBPACK_IMPORTED_MODULE_5_services_SteelCompass__["a" /* default */].request('user','expel',{id:id}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions_Student__["a" /* default */].expelComplete(id);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},expelComplete:function expelComplete(){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].translatableMessage('student.expelDone');}});/* harmony default export */ __webpack_exports__["a"] = (StudentStore);

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(139),
    root = __webpack_require__(105);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1998),
    mapCacheDelete = __webpack_require__(2005),
    mapCacheGet = __webpack_require__(2007),
    mapCacheHas = __webpack_require__(2008),
    mapCacheSet = __webpack_require__(2009);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 373 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var baseUrls={1:'//www.youtube.com/embed/',2:'//player.vimeo.com/video/',3:'//w.soundcloud.com/player/?url=http%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F',4:'//embed.spotify.com/?uri=spotify%3Atrack%3A',5:'//fast.wistia.net/embed/iframe/',6:'//player.youku.com/embed/'};var isValidURL=function isValidURL(str){var pattern=new RegExp('^(https?:\\/\\/)?'+// protocol
'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+// domain name
'((\\d{1,3}\\.){3}\\d{1,3}))'+// OR ip (v4) address
'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+// port and path
'(\\?[;&a-z\\d%_.~+=-]*)?'+// query string
'(\\#[-a-z\\d_]*)?$','i');// fragment locator
return pattern.test(str);};var Media=function(){function Media(){_classCallCheck(this,Media);this.baseUrls=baseUrls;}_createClass(Media,[{key:'parseYouTubeUrl',value:function parseYouTubeUrl(url){var regExp=/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;var match=url.match(regExp);if(match&&match[7].length==11){return match[7];}else{return null;}}},{key:'parseVimeoUrl',value:function parseVimeoUrl(url){var regExp=/^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;var match=url.match(regExp);if(match){return match[5];}else{return null;}}},{key:'parseWistiaUrl',value:function parseWistiaUrl(url){var regExp=/^.*(wistia.com|home.wistia.com|wistia.net)\/(medias\/)?([A-z0-9]+)/;var match=url.match(regExp);if(match){return match[3];}else{return null;}}},{key:'parseSpotifyUrl',value:function parseSpotifyUrl(url){var regExp=/^.*(((spotify:)(track:)?)|(open.spotify.com)\/(track\/)?)([A-z0-9]+)/;var match=url.match(regExp);if(match){return match[7];}else{return null;}}},{key:'parseSoundCloudUrl',value:function parseSoundCloudUrl(url){var regExp=/^.*(((spotify:)(track:)?)|(open.spotify.com)\/(track\/)?)([A-z0-9]+)/;var match=url.match(regExp);if(match){return match[7];}else{return null;}}},{key:'parseYoukuUrl',value:function parseYoukuUrl(url){var regExp=/^.*(v.youku.com)\/(v_show\/id_)?([A-z0-9]+)==.html(.*)/;var match=url.match(regExp);if(match){return match[3];}else{return null;}}},{key:'isYouTubeUrl',value:function isYouTubeUrl(url){return /(youtube|youtu\.be)/.test(url);}},{key:'isYoukuUrl',value:function isYoukuUrl(url){return /(youku)/.test(url);}},{key:'isVimeoUrl',value:function isVimeoUrl(url){return /(vimeo)/.test(url);}},{key:'isWistiaUrl',value:function isWistiaUrl(url){return /(wistia)/.test(url);}},{key:'isSpotifyUrl',value:function isSpotifyUrl(url){return /(spotify\:|open\.spotify\.com)/.test(url);}},{key:'isSoundCloudUrl',value:function isSoundCloudUrl(url){return /(soundcloud)/.test(url);}},{key:'getUrlFromProvider',value:function getUrlFromProvider(provider){if(!provider||typeof provider==='string'){return provider;}if(provider.provider){if(provider.provider===8){return null;}else if(provider.provider===7){return provider.id;}else{return window.document.location.protocol+baseUrls[provider.provider]+provider.id;}}else{return null;}}},{key:'getEmbedUrl',value:function getEmbedUrl(url){var provider=this.getProviderFromUrl(url);if(provider){return this.getUrlFromProvider(provider);}}},{key:'getProviderFromUrl',value:function getProviderFromUrl(url){if(isValidURL(url)){if(this.isYouTubeUrl(url)){return{provider:1,id:this.parseYouTubeUrl(url)};}else if(this.isYoukuUrl(url)){return{provider:6,id:this.parseYoukuUrl(url)};}else if(this.isVimeoUrl(url)){return{provider:2,id:this.parseVimeoUrl(url)};}else if(this.isWistiaUrl(url)){return{provider:5,id:this.parseWistiaUrl(url)};}else if(this.isSpotifyUrl(url)){return{provider:4,id:this.parseSpotifyUrl(url)};}else if(this.isSoundCloudUrl(url)){return{provider:3};}else{return{provider:7,id:url};}}else{return{provider:8,id:url};}}}]);return Media;}();/* harmony default export */ __webpack_exports__["a"] = (new Media());

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Portal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var styles={root:{position:'absolute',// transform: 'translate3d(0,0,0)',
zIndex:2},overlay:{position:'fixed',left:'-100%',top:0,width:'100%',height:'100%',opacity:1,willChange:'opacity',// transform: 'translate3d(0,0,0)',
transition:'left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',backgroundColor:'rgba(0, 0, 0, 0.541176)'},overlayOpen:{left:0},panel:{position:'fixed',// transform: 'translate3d(0,0,0)',
top:0,bottom:0,transition:'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',boxShadow:'rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px'},panelOpen:{left:0}};var SlidingPanel=function(_Component){_inherits(SlidingPanel,_Component);function SlidingPanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SlidingPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SlidingPanel.__proto__||Object.getPrototypeOf(SlidingPanel)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:_this.props.initialOpen},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SlidingPanel,[{key:'open',value:function open(){var force=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(!this.state.open){this.setState({open:true});if(this.props.onOpen){this.props.onOpen();}}else if(force){if(this.props.onOpen){this.props.onOpen();}}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.initialOpen&&!this.state.open){this.open();}else if(!nextProps.initialOpen&&this.state.open){this.close();}}},{key:'getStyle',value:function getStyle(){var style=Object.assign({},styles.root,this.props.style);if(this.props.zIndex){style.zIndex=this.props.zIndex;}return style;}},{key:'close',value:function close(){if(this.state.open){this.setState({open:false});if(this.props.onClose){this.props.onClose();}}}},{key:'toggle',value:function toggle(){if(this.state.open){this.close();}else{this.open();}}},{key:'handleOutsideMouseClick',value:function handleOutsideMouseClick(e){if(isNodeInRoot(e.target,Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.refs.panel))){return;}this.close();}},{key:'closeOverlay',value:function closeOverlay(e){var _props=this.props,closeOnRequestClose=_props.closeOnRequestClose,onRequestClose=_props.onRequestClose;onRequestClose&&onRequestClose();e.stopPropagation();e.preventDefault();if(closeOnRequestClose){this.close();}}},{key:'handleKeydown',value:function handleKeydown(e){if(e.keyCode===27){this.close();}}},{key:'createPanel',value:function createPanel(open){var children=void 0;if(open){children=this.props.children;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'panel',style:this.getPanelStyle(open)},children);}},{key:'createOverlay',value:function createOverlay(open){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:this.closeOverlay.bind(this),style:this.getOverlayStyle(open)});}},{key:'getPanelStyle',value:function getPanelStyle(open){return Object.assign({backgroundColor:this.props.backgroundColor||__WEBPACK_IMPORTED_MODULE_3_components_Material_Styles_Colors__["a" /* Colors */].bondiBlue,left:-Spacing.desktopKeylineIncrement*this.props.width-10,width:Spacing.desktopKeylineIncrement*this.props.width},styles.panel,open?styles.panelOpen:{});}},{key:'getOverlayStyle',value:function getOverlayStyle(open){return Object.assign({},styles.overlay,open?styles.overlayOpen:{});}},{key:'render',value:function render(){var overlay=void 0,panel=void 0;var open=this.state.open;if(this.props.overlay){overlay=this.createOverlay(open);}panel=this.createPanel(open);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Portal__["a" /* default */],{style:this.getStyle()},overlay,panel);}}]);return SlidingPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SlidingPanel.propTypes={overlay:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,width:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number};SlidingPanel.defaultProps={overlay:true,width:4};/* harmony default export */ __webpack_exports__["a"] = (SlidingPanel);function isNodeInRoot(node,root){while(node){if(node===root){return true;}node=node.parentNode;}return false;}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSideEffect = __webpack_require__(2055);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(2056);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _objectAssign = __webpack_require__(209);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(2059);

var _PlainComponent = __webpack_require__(2060);

var _PlainComponent2 = _interopRequireDefault(_PlainComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HELMET_ATTRIBUTE = "data-react-helmet";

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props[property]) {
            return props[property];
        }
    }
    return null;
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, "title");
    var innermostTemplate = getInnermostProperty(propsList, "titleTemplate");

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, "defaultTitle");

    return innermostTitle || innermostDefaultTitle || "";
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, "onChangeClientState") || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    var tagList = propsList.filter(function (props) {
        return typeof props[tagName] !== "undefined";
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();

    return tagList;
};

var updateTitle = function updateTitle(title, attributes) {
    document.title = title || document.title;
    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var htmlTag = document.getElementsByTagName(tagName)[0];
    var helmetAttributeString = htmlTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        htmlTag.setAttribute(attribute, value);

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        htmlTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        htmlTag.removeAttribute(HELMET_ATTRIBUTE);
    } else {
        htmlTag.setAttribute(HELMET_ATTRIBUTE, helmetAttributes.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector("head");
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === "innerHTML") {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === "cssText") {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateHtmlAttributesAsString = function generateHtmlAttributesAsString(attributes) {
    var keys = Object.keys(attributes);
    var attributeString = "";

    for (var i = 0; i < keys.length; i++) {
        var attribute = keys[i];
        var attr = typeof attributes[attribute] !== "undefined" ? attribute + "=\"" + attributes[attribute] + "\"" : "" + attribute;
        attributeString += attr + " ";
    }

    return attributeString.trim();
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes) {
    var attributeString = "";
    var attributeKeys = Object.keys(attributes);
    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var attr = typeof attributes[attribute] !== "undefined" ? attribute + "=\"" + attributes[attribute] + "\"" : "" + attribute;
        attributeString += attr + " ";
    }

    var stringifiedMarkup = attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString.trim() + ">" + encodeSpecialCharacters(title) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title) + "</" + type + ">";

    return stringifiedMarkup;
};

var generateTagsAsString = function generateTagsAsString(type, tags) {
    var stringifiedMarkup = tags.map(function (tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === "innerHTML" || attribute === "cssText");
        }).map(function (attribute) {
            if (typeof tag[attribute] === "undefined") {
                return attribute;
            }

            var encodedValue = encodeSpecialCharacters(tag[attribute]);
            return attribute + "=\"" + encodedValue + "\"";
        }).join(" ").trim();

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = [_HelmetConstants.TAG_NAMES.NOSCRIPT, _HelmetConstants.TAG_NAMES.SCRIPT, _HelmetConstants.TAG_NAMES.STYLE].indexOf(type) === -1;

        return "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }).join("");

    return stringifiedMarkup;
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    // assigning into an array to define toString function on it
    var props = _defineProperty({
        key: title
    }, HELMET_ATTRIBUTE, true);
    Object.keys(attributes).forEach(function (attribute) {
        var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
        props[mappedAttribute] = attributes[attribute];
    });

    var component = [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];

    return component;
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    /* eslint-disable react/display-name */
    var component = tags.map(function (tag, i) {
        var mappedTag = _defineProperty({
            key: i
        }, HELMET_ATTRIBUTE, true);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === "innerHTML" || mappedAttribute === "cssText") {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });

    return component;
    /* eslint-enable react/display-name */
};

var getMethodsForTag = function getMethodsForTag(type, tags) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes);
                }
            };
        case _HelmetConstants.TAG_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return tags;
                },
                toString: function toString() {
                    return generateHtmlAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var htmlAttributes = _ref.htmlAttributes,
        title = _ref.title,
        titleAttributes = _ref.titleAttributes,
        baseTag = _ref.baseTag,
        metaTags = _ref.metaTags,
        linkTags = _ref.linkTags,
        scriptTags = _ref.scriptTags,
        noscriptTags = _ref.noscriptTags,
        styleTags = _ref.styleTags;
    return {
        htmlAttributes: getMethodsForTag(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }),
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };
};

var Helmet = function Helmet(Component) {
    /* eslint-disable react/no-multi-comp */
    var HelmetWrapper = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, (HelmetWrapper.__proto__ || Object.getPrototypeOf(HelmetWrapper)).apply(this, arguments));
        }

        _createClass(HelmetWrapper, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, _deepEqual2.default)(this.props, nextProps);
            }
        }, {
            key: "render",
            value: function render() {
                return _react2.default.createElement(Component, this.props);
            }
        }], [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
            /**
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {String} title: "Title"
             * @param {String} defaultTitle: "Default Title"
             * @param {String} titleTemplate: "MySite.com - %s"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div{ display: block; color: blue; }"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             */

        }]);

        return HelmetWrapper;
    }(_react2.default.Component);
    /* eslint-enable react/no-multi-comp */

    HelmetWrapper.propTypes = {
        htmlAttributes: _react2.default.PropTypes.object,
        title: _react2.default.PropTypes.string,
        defaultTitle: _react2.default.PropTypes.string,
        titleTemplate: _react2.default.PropTypes.string,
        titleAttributes: _react2.default.PropTypes.object,
        base: _react2.default.PropTypes.object,
        meta: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        link: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        script: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        noscript: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        style: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
        onChangeClientState: _react2.default.PropTypes.func
    };
    HelmetWrapper.peek = Component.peek;

    HelmetWrapper.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                htmlAttributes: {},
                title: "",
                titleAttributes: {},
                baseTag: [],
                metaTags: [],
                linkTags: [],
                scriptTags: [],
                noscriptTags: [],
                styleTags: []
            });
        }

        return mappedState;
    };

    return HelmetWrapper;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.TAG_NAMES.HTML, propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList("titleAttributes", propsList),
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        onChangeClientState: getOnChangeClientState(propsList)
    };
};

var handleClientStateChange = function handleClientStateChange(newState) {
    var htmlAttributes = newState.htmlAttributes,
        title = newState.title,
        titleAttributes = newState.titleAttributes,
        baseTag = newState.baseTag,
        metaTags = newState.metaTags,
        linkTags = newState.linkTags,
        scriptTags = newState.scriptTags,
        noscriptTags = newState.noscriptTags,
        styleTags = newState.styleTags,
        onChangeClientState = newState.onChangeClientState;


    updateAttributes("html", htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    onChangeClientState(newState, addedTags, removedTags);
};

var SideEffect = (0, _reactSideEffect2.default)(reducePropsToState, handleClientStateChange, mapStateOnServer);

// PlainComponent is used to be a blank component decorated by react-side-effect
exports.default = Helmet(SideEffect(_PlainComponent2.default));
module.exports = exports["default"];

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports = {"en-US":{"{0} is now available in your library.":"{0} is now available in your library.","A gift code has been emailed to the address you provided. You can send the link in this email to the lucky person!":"A gift code has been emailed to the address you provided. You can send the link in this email to the lucky person!","Accepted":"Accepted","Active":"Active","Add diploma template":"Add diploma template","After":"After","All":"All","Amount":"Amount","Are you sure you want to remove this module?":"Are you sure you want to remove this module?","Are you sure you would like to {0} the quiz":"Are you sure you would like to {0} the quiz","audio_interaction":"Sound","cancel":"Cancel","Change password":"🔑 Users can now change password themself in settings","Choose media":"Choose media","close":"close","collapse":"Collapse","comment":"Question feedback","Conversion":"Conversion","correctAnswers":"Correct answers","Course Interactions":"Course Interactions","courses":"Courses","customExport":"Would you like the report to be sent to a third party? (leave empty if not)","Days":"Days","Delete":"Delete","Description":"Description","Diploma":"Diploma","Diploma will be generated and mailed to your email addresss.":"Diploma will be generated and mailed to your email addresss.","discussion_interaction":"Discussion","download_interaction":"Download","Drip content":"Drip content","Drop a pdf here":"Drop a pdf here","Drop a video here":"Drop a video here","Duration":"Duration","Duration tooltip":"Time to complete the test","embed":"embed","Embed":"Embed","Embed external content":"Embed external content","Enable delayed access":"Enable delayed access","Enable drip content":"Enable drip content","Enable gated access":"Enable gated access","Enable quiz":"Enable quiz","Enable timer":"Set timer on quiz","End test":"End Quiz","endDate":"End date","export":"Export Quiz","exportDone":"Statistics export was sent to your email.","Fail message":"Fail message","failed":"Failed","Finish the course for a diploma":"Finish the course for a diploma","Finnished":"Finished","fix tasks":"✅ Improved ui for task management","Gifts sold":"Total gifts sold","google_warning":"There is no Google Data for dates previous to 2019","here":"here","Hide":"Hide answers when user completes test","Hours":"Hours","Inactive":"Inactive","Include content from a number of popular services like YouTube, Slideshare, Typeform and more.":"Include content from a number of popular services like YouTube, Slideshare, Typeform and more.","Instructions":"Instructions","Interaction":"Course Interaction","Interaction Type":"Interaction Type","Invitations":"Invitations","library":"library","lock":"Lock","Lock":"lock","Months":"Months","n/a":"n/a","name":"Name","New":"New functionallity add to the platform, read more","New release":"⚡️ New release!","New statistics":"📈 New statistics page with usage and sales stats","No":"No","No interaction data collected":"No interaction data collected","No notes":"No notes found","no_feedback":"No feedback provided","no_feedback_text":"No feedback text provided","NoInvitationData":"No invitation data found try to expande the time range","NoSalesData":"No sales data found try to expande the time range","Notes":"Notes","OK":"OK","OK, start learning!":"OK, start learning!","page":"Page","Page":"Page","pagesViewed":"Pages viewed","PageViews":"Page views","Paste embed code...":"Paste embed code...","Percentage finished to be eligible for a diploma":"Percentage finished to be eligible for a diploma","Please decide per section when they should become available after the user purchases or gains access to the course.":"Please decide per section when they should become available after the user purchases or gains access to the course.","Purchase complete":"Purchase complete","Purchase successfully completed. You will be redirected":"Purchase successfully completed. You will be redirected","Quantity":"Quantity","Questions":"Questions","quiz":"Quiz","Quiz Finnished tooltip":"When did the user end the quiz","Quiz functionality":"❓Possibility to activate quiz for courses","Quiz page settings":"Quiz settings for: ","Quiz settings":"Quiz settings","Quiz statistics will be generated and mailed to your email addresss.":"Quiz statistics will be generated and mailed to your email addresss.","Quiz status tooltip":"Did the user pass or fail the quiz","QuizWarning":"Doing this will delete all the questions you have created","refund":"Refund","refundConfirm":"Are you sure you want to refund?","Remove":"Remove","Repeatable":"Allow users to retake the test","Restart":"Retake the Quiz","Result":"Previous result","Retrieve a test diploma":"Retrieve a test diploma","Retrieve diploma":"Retrieve diploma","sales":"Sales","Score":"Score","Score to pass the test":"Score to pass the test","Search for students":"Search for students","sessions":"Sessions","show":"show","slideshow_interaction":"Slideshow","source":"Source","startDate":"Start date","Status":"Status","students":"Students","success":"Passed","Success message":"Success message","task_interaction":"Interaction with Task","Thank you!":"Thank you!","threshold":"Limit to pass the quiz (%)","timerInfo":"Set timer in format HH:MM:SS","TimeSpent":"Avg time spent","To see interactions for each page click any row in the table":"To see interactions for each page click any row in the table","Total":"Total","Total amount":"Total amount","Total amount of page views":"Total amount of page views","Total quantity":"Totalt quantity","Total sales":"Total sales","Total tooltip":"Total amount of points","totalNumberOfTasks":"Total number of tasks","TotalTimeSpent":"Average time spent","type":"Product","unlock":"Unlock","Unlock":"unlock","Upload":"Upload","upload":"upload","users":"Users","Users will only be able to open a page if they have already completed the previous page. This ensures that your users go through the course in a natural manner.":"Users will only be able to open a page if they have already completed the previous page. This ensures that your users go through the course in a natural manner.","video_interaction":"Video","Welcome":"Welcome","Welcome message":"Welcome message","Write a caption...":"Write a caption...","You can also {0}, browse your {1} or {2} one.":"You can also {0}, browse your {1} or {2} one.","Your course":"Your course","Your score":"Your score"},"sv-SE":{"{0} is now available in your library.":"{0} finns nu tillgänglig i ditt kursbibliotek.","A gift code has been emailed to the address you provided. You can send the link in this email to the lucky person!":"En presentkod har skickats till e-postadressen du angav. Ge den koden till mottagaren av presenten!","Accepted":"Accepterade","Active":"Aktiva","Add diploma template":"Lägg till en intygsmall","After":"Efter","All":"Alla","Amount":"Summa","Are you sure you want to remove this module?":"Är du säker på att du vill ta bort modulen?","Are you sure you would like to {0} the quiz":"Är du säker på att du vill {0} testet","audio_interaction":"Ljud","cancel":"Avbryt","Change password":"🔑 Användare kan nu själva byta lösenord i inställningar","Choose media":"Välj media","close":"stäng","collapse":"Göm","comment":"Kommentar till svar","Conversion":"Konverteringsgrad","correctAnswers":"Korrekta svar","Course Interactions":"Interaktion med kursen","courses":"Kurser","customExport":"Vill du att rapporten ska skickas till en tredjepart? (annars lämna fältet tomt)","Days":"Dagar","Delete":"Ta bort","Description":"Beskriving av provet","Diploma":"Intyg","Diploma will be generated and mailed to your email addresss.":"Diplomet mailas inom kort till din inkorg.","discussion_interaction":"Diskussion","download_interaction":"Nedladdning","Drip content":"Drip content","Drop a pdf here":"Dra och släpp en pdf här","Duration":"Tidsåtgång","Duration tooltip":"Hur lång tid tog quizen","Embed":"Bädda in","Embed external content":"Bädda in externt material","Enable delayed access":"Aktivera fördröjd åtkomst","Enable drip content":"Aktivera drip content","Enable gated access":"Aktivera blockerad tillgång","Enable quiz":"Aktivera quiz","Enable timer":"Ställ in timer på frågesport","End test":"Avsluta Quiz","endDate":"Slut datum","export":"Exportera Quiz","exportDone":"Statestiken har exporterats och skickats till din mail","Fail message":"Icke godkäntmeddelande","failed":"Icke godkänd","Finish the course for a diploma":"Slutför kursen för att få kursintyg","Finnished":"Sluttid","fix tasks":"✅ Förbättrad gränssnitt för uppgiftshantering","Gifts sold":"Gåvor sålda","google_warning":"Det finns ingen Google Data för datum tidigare än 2019","here":"här","Hide":"Göm svaren när användaren är klar med testet","Hours":"Timmar","Inactive":"Inaktiva","Include content from a number of popular services like YouTube, Slideshare, Typeform and more.":"Klistra in material från bl.a YouTube, Smideshare, Typeform och många fler ","Instructions":"Instruktioner","Interaction":"Kursanvändning","Interaction Type":"Typ av händelse","Invitations":"Inbjudningar","Lås":"låsa","Lås upp":"låsa upp","lock":"Lås","Months":"Månader","n/a":"n/a","name":"Namn","New":"Nya funktioner har lags till i verktyget, läs mer","New release":"⚡️ Nya funktioner!","New statistics":"📈 Ny statstiksida med försäljningsdata och användardata","No":"Nej","No interaction data collected":"Ingen händelse data insamlad","No notes":"Inga noteringar funna","no_feedback":"Ingen återkoppling lämnad","no_feedback_text":"Ingen återkopplingstext lämnad","NoInvitationData":"Ingen inbjudningsdata funnen prova att utöka tidsrymden","NoSalesData":"Ingen försäljningsdata funnen prova att utöka tidsrymden","Notes":"Anteckningar","OK":"OK","OK, start learning!":"OK, sätt igång!","page":"Sida","Page":"Sida","pagesViewed":"Sedda sidor","PageViews":"Sidvisningar","Paste embed code...":"Klistra in embed länken här","Percentage finished to be eligible for a diploma":"Sätt en procent som deltagaren måste ha tagit del av för att få intyg","Please decide per section when they should become available after the user purchases or gains access to the course.":"Vänligen bestäm varje avsnitt när de ska bli tillgängliga efter att användaren har köpt eller får tillgång till kursen.","Purchase complete":"Köp genomfört","Purchase successfully completed. You will be redirected":"Ditt köp gick igenom.","Quantity":"Antal","Questions":"Frågor","quiz":"Quiz","Quiz Finnished tooltip":"När avslutades quizen","Quiz functionality":"❓Möjligt att aktivera quiz funktionallitet för kurser","Quiz page settings":"Quiz inställningar för: ","Quiz settings":"Quiz inställningar","Quiz statistics will be generated and mailed to your email addresss.":"Quizstatestik kommer att skickas till din e-postadress.","Quiz status tooltip":"Klarade användaren quizen?","QuizWarning":"Det här kommer ta bort alla frågor du har skapat","refund":"Återbetala","refundConfirm":"Är du säker på att du vill återbetala?","Remove":"Ta bort","Repeatable":"Låt användarna återta testet","Restart":"Gör om Quizen","Result":"Tidigare resultat","Retrieve a test diploma":"Få ett exempel på kursintyget","Retrieve diploma":"Ladda ner kursintyg","sales":"Försäljning","Score":"Poäng","Score to pass the test":"Betyg för att klara provet","Search for students":"Sök studenter på namn/epost","sessions":"Sessioner","show":"visa","slideshow_interaction":"Slideshow","source":"Ursprung","startDate":"Start datum","Status":"Status","students":"Studenter","success":"Godkänd","Success message":"Godkäntmeddelande","task_interaction":"Uppgift","Thank you!":"Tack!","threshold":"Gräns för att klara provet (%)","timerInfo":"Sätt timern i formatet TT:MM:SS","TimeSpent":"Genomsnittlig tid spenderad","To see interactions for each page click any row in the table":"För att se detaljer klick på valfri rad i tabellen","Total":"Total","Total amount":"Totalbelopp","Total amount of page views":"Totalt antal sidvisningar","Total quantity":"Totalt antal","Total sales":"Totalförsäljning","Total tooltip":"Totalt antal poäng","totalNumberOfTasks":"Total antal uppgifter","TotalTimeSpent":"Total tid spenderad","type":"Produkt","unlock":"Lås upp","Upload":"Ladda upp","users":"Besökare","Users will only be able to open a page if they have already completed the previous page. This ensures that your users go through the course in a natural manner.":"Användare kan bara öppna en sida om de redan klarat av föregående sida. Detta säkerställer att dina användare genomgår kursen på ett naturligt sätt.","video_interaction":"Video","Welcome":"Välkommen","Welcome message":"Välkomstmeddelande","Write a caption...":"Bildtext","Your course":"Din kurs","Your score":"Din poäng"}}

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={input:{color:__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */].fullWhite}};var TextField=function(_Component){_inherits(TextField,_Component);function TextField(){_classCallCheck(this,TextField);return _possibleConstructorReturn(this,(TextField.__proto__||Object.getPrototypeOf(TextField)).apply(this,arguments));}_createClass(TextField,[{key:'componentDidMount',value:function componentDidMount(){var field=this.refs.field;var inputField=field._getInputNode();var value=field.getValue();field.focus();field.setValue(value);inputField.select();}},{key:'getValue',value:function getValue(){return this.refs.field.getValue();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],Object.assign({inputStyle:styles.input,ref:'field'},this.props));}}]);return TextField;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TextField.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (TextField);

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(2083)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(2088);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var EventManager=function(){function EventManager(){_classCallCheck(this,EventManager);this.events={};this.desub=[];}_createClass(EventManager,[{key:"on",value:function on(event,callback){var _this=this;if(!this.events[event]){this.events[event]=[];}this.events[event].push(callback);this.desub.push(function(){_this.remove(event,callback);});return this.desub[this.desub.length-1];}},{key:"trigger",value:function trigger(event,eventObject){if(this.events[event]){this.events[event].forEach(function(callback){callback(eventObject||{});});}}},{key:"remove",value:function remove(event,callback){var foundAt=null;for(var i=0;i<this.events[event].length;i++){if(this.events[event][i]===callback){foundAt=i;break;}}if(foundAt!==null){this.events[event].splice(foundAt,1);}}}]);return EventManager;}();/* unused harmony default export */ var _unused_webpack_default_export = (new EventManager());

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Task__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Styles__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var TaskList=function(_mixin){_inherits(TaskList,_mixin);function TaskList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TaskList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TaskList.__proto__||Object.getPrototypeOf(TaskList)).call.apply(_ref,[this].concat(args))),_this),_this.hasUnCorrectedTasks=function(results){var uncorrectedCount=0;for(var i=0;i<results&&results.length;i++){var element=results[i];if(element&&element.feedback&&!element.feedback.created&&typeof element.feedback.created_by!=="number"){uncorrectedCount++;}}return uncorrectedCount;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TaskList,[{key:"componentWillMount",value:function componentWillMount(){if(_get(TaskList.prototype.__proto__||Object.getPrototypeOf(TaskList.prototype),"componentWillMount",this)){_get(TaskList.prototype.__proto__||Object.getPrototypeOf(TaskList.prototype),"componentWillMount",this).call(this);}__WEBPACK_IMPORTED_MODULE_5_actions__["y" /* SettingsActions */].read();}},{key:"listenToStores",value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_7_stores__["s" /* SettingsStore */],'settings');}},{key:"componentDidUpdate",value:function componentDidUpdate(){var taskId=this.props.selected;if(!taskId){return;}var selectedTask=document.getElementById("task-"+taskId);if(!selectedTask){return;}selectedTask.scrollIntoView();__WEBPACK_IMPORTED_MODULE_5_actions__["E" /* TaskActions */].clearTaskSelection();}},{key:"render",value:function render(){var _this2=this;var _props=this.props,tasks=_props.tasks,canGrade=_props.canGrade,tasksLoading=_props.tasksLoading,hasFilter=_props.hasFilter,taskMode=_props.taskMode;var settings=this.state.settings;var canvasColor=this.context.muiTheme.rawTheme.palette.canvasColor;var taskStyle=Object.assign({backgroundColor:canvasColor},__WEBPACK_IMPORTED_MODULE_3__Styles__["a" /* default */].task);var taskItems=void 0,noResults=void 0;if(tasks.length>0){taskItems=tasks.sort(function(a,b){var A=_this2.hasUnCorrectedTasks(a.taskResults);var B=_this2.hasUnCorrectedTasks(b.taskResults);if(A<B){return-1;}if(A>B){return 1;}return 0;}).reverse().map(function(task){if(!task.caption.hasOwnProperty('main')){task.caption.main='Task has no caption';}var id=task.id,other=_objectWithoutProperties(task,["id"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Paper"],{key:id,style:taskStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Task__["a" /* default */],Object.assign({taskMode:taskMode,id:id},other,{settings:settings,canAnswer:false,canGrade:true})));});}else if(!hasFilter){noResults=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:__WEBPACK_IMPORTED_MODULE_3__Styles__["a" /* default */].makeSelection},this.context.getIntlMessage("selectFilter"));}else if(tasksLoading){noResults=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__["b" /* default */],null);}else{noResults=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:__WEBPACK_IMPORTED_MODULE_3__Styles__["a" /* default */].noResults},this.context.getIntlMessage("noResults"));}if(taskItems&&!taskItems[0]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:__WEBPACK_IMPORTED_MODULE_3__Styles__["a" /* default */].makeSelection},this.context.getIntlMessage('tasks.noTasks'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,taskItems,noResults);}}]);return TaskList;}(Object(__WEBPACK_IMPORTED_MODULE_6_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_6_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));TaskList.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (TaskList);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Widgets_VideoPreview__ = __webpack_require__(261);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var styles={root:{display:'inline-block',// marginRight: Spacing.desktopGutterMini,
width:Spacing.desktopKeylineIncrement*2+2*Spacing.desktopGutterMini,textAlign:'center'},link:{display:'block',padding:Spacing.desktopGutterMini},caption:{fontSize:'12px',lineHeight:'12px',margin:'5px'},icon:{width:Spacing.iconSize*2,height:Spacing.iconSize*2}};var File=function(_Component){_inherits(File,_Component);function File(){_classCallCheck(this,File);return _possibleConstructorReturn(this,(File.__proto__||Object.getPrototypeOf(File)).apply(this,arguments));}_createClass(File,[{key:'isImage',value:function isImage(){var extension=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return extension.match(/^(jpeg|jpg|gif|png)$/i)!==null;}},{key:'isVideo',value:function isVideo(){var extension=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return extension.match(/^(mp4|ogv|ogg|mp3|m4v|avi|flv|wmv|mov|mpeg)$/i)!==null;}},{key:'render',value:function render(){var _props=this.props,url=_props.url,caption=_props.caption,extension=url&&url.split('.').pop()||'',mycaption=caption.split('.').pop(),link=void 0,figCaption=void 0;if(caption){figCaption=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{style:styles.caption},caption.length>20?caption.replace(/\..+$/,'').substring(0,16)+'...':caption.replace(/\..+$/,''));}if(this.isImage(extension)){url=url.replace('coursio.s3-eu-west-1.amazonaws.com','download.s.coursio.com');link=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:styles.link,href:url+'?name='+caption,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{width:Spacing.desktopKeylineIncrement*2,src:url,title:caption.replace(/\..+$/,'')}),figCaption);}else if(this.isVideo(mycaption)){// let ending;
//   var HttpClient = function() {
//     this.get = function(aUrl, aCallback) {
//     var anHttpRequest = new XMLHttpRequest();
//     anHttpRequest.onreadystatechange = function() {
//     if (anHttpRequest.readyState == 4 && anHttpRequest.status == 200)
//      aCallback(anHttpRequest.responseText);
//       if(mycaption == 'mp4' || mycaption == 'ogv' || mycaption == 'ogg' || mycaption == 'mp3'  || mycaption == 'm4v'  || mycaption == 'avi'  || mycaption == 'flv'  || mycaption == 'wmv'  || mycaption == 'mov'  || mycaption == 'mpeg'){
//         ending = url.concat('.mp4');
//       }
//       ending = ending.replace('coursio.s3-eu-west-1.amazonaws.com', 'download.s.coursio.com');
//     }
//     anHttpRequest.open( "GET", aUrl, true );
//     anHttpRequest.send( null );
//     }
//   }
//   let aClient = new HttpClient();
//   aClient.get(url, function(response) {
//     // do something with response
//   });
//
link=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:styles.link,href:url.replace('coursio.s3-eu-west-1.amazonaws.com','download.s.coursio.com')+'?name='+caption,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Widgets_VideoPreview__["a" /* default */],{sources:[{url:url,type:extension}],style:{width:128}}),figCaption);}else{url=url&&url.replace('coursio.s3-eu-west-1.amazonaws.com','download.s.coursio.com')||'';link=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:styles.link,href:url+'?name='+caption,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["FileCloudDownload"],{style:styles.icon}),figCaption);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Paper"],{style:styles.root,zDepth:1},link);}}]);return File;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (File);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(2115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListItem__ = __webpack_require__(2116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Divider__ = __webpack_require__(2117);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ListItem__["a"]; });
/* unused harmony reexport Divider */


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TaskList__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Task__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RadioTask__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CheckBoxTask__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TextTask__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RadioTaskResult__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CheckBoxTaskResult__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TextTaskResult__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TaskFeedback__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Styles__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TaskResultList__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TaskCreator__ = __webpack_require__(2122);
/* unused harmony reexport TaskList */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Task__["a"]; });
/* unused harmony reexport RadioTask */
/* unused harmony reexport CheckBoxTask */
/* unused harmony reexport TextTask */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__RadioTaskResult__["a"]; });
/* unused harmony reexport CheckBoxTaskResult */
/* unused harmony reexport TextTaskResult */
/* unused harmony reexport TaskFeedback */
/* unused harmony reexport Styles */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__TaskResultList__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_11__TaskCreator__["a"]; });


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var SoundCloud=function(){function SoundCloud(){_classCallCheck(this,SoundCloud);this.url=__WEBPACK_IMPORTED_MODULE_0_Config__["a" /* default */].soundCloudRoot;}_createClass(SoundCloud,[{key:'oEmbed',value:function oEmbed(url,callback){__WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get(this.url+'oembed?format=json&url='+escape(url)).set('Content-Type','text/plain').set('Accept','application/json').end(function(err,response){if(callback){callback(response.body);}});}}]);return SoundCloud;}();/* harmony default export */ __webpack_exports__["a"] = (new SoundCloud());

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_b5',dense:'_b6',dark:'_b7',label:'_b8',button:'_b9'};var Tag=function(_Component){_inherits(Tag,_Component);function Tag(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Tag);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Tag.__proto__||Object.getPrototypeOf(Tag)).call.apply(_ref,[this].concat(args))),_this),_this.remove=function(){var _this$props=_this.props,onRemove=_this$props.onRemove,tag=_this$props.tag;onRemove&&onRemove(tag);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Tag,[{key:'render',value:function render(){var _classNames;var _props=this.props,onRemove=_props.onRemove,dark=_props.dark,dense=_props.dense,tag=_props.tag;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.root,(_classNames={},_defineProperty(_classNames,css.dense,dense),_defineProperty(_classNames,css.dark,dark),_classNames))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.label},tag),onRemove&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:css.button,onTouchTap:this.remove},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["NavigationClose"],null)));}}]);return Tag;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Tag.propTypes={tag:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,onRemove:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,dense:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,dark:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (Tag);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(2142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(118);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = Object(__WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (Object(__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["c" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routerShape; });
/* unused harmony export locationShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ListSelector__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_Group__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_Group__ = __webpack_require__(183);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupSelector=function(_mixin){_inherits(GroupSelector,_mixin);function GroupSelector(){_classCallCheck(this,GroupSelector);return _possibleConstructorReturn(this,(GroupSelector.__proto__||Object.getPrototypeOf(GroupSelector)).apply(this,arguments));}_createClass(GroupSelector,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores_Group__["a" /* default */]);}},{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_4_actions_Group__["a" /* default */].findBuildable();}},{key:'reset',value:function reset(){this.refs.selector.reset();}},{key:'getSelected',value:function getSelected(){return this.refs.selector.getSelected();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ListSelector__["a" /* default */],Object.assign({ref:'selector',searchHint:'Choose Groups'},this.props,{items:this.state.buildable}));}}]);return GroupSelector;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (GroupSelector);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ListSelector__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_Student__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_Student__ = __webpack_require__(235);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StudentSelector=function(_mixin){_inherits(StudentSelector,_mixin);function StudentSelector(){_classCallCheck(this,StudentSelector);return _possibleConstructorReturn(this,(StudentSelector.__proto__||Object.getPrototypeOf(StudentSelector)).apply(this,arguments));}_createClass(StudentSelector,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores_Student__["a" /* default */]);}},{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_4_actions_Student__["a" /* default */].findReaders();}},{key:'reset',value:function reset(){this.refs.selector.reset();}},{key:'getSelected',value:function getSelected(){return this.refs.selector.getSelected();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ListSelector__["a" /* default */],Object.assign({ref:'selector',searchHint:this.context.getIntlMessage('Search')},this.props,{loading:this.state.readersLoading,items:this.state.readers}));}}]);return StudentSelector;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));StudentSelector.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StudentSelector);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_update__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_addons_update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_addons_update__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={root:{display:'flex',borderWidth:1},textAreaContainer:{flexGrow:0},listContainer:{flexGrow:1,minHeight:Spacing.desktopKeylineIncrement*4,maxHeight:Spacing.desktopKeylineIncrement*6,overflow:'auto'},textarea:{height:32*12,display:'block',width:'100%',boxSizing:'border-box',outline:'none',borderStyle:'none solid none none',borderWidth:1,lineHeight:1.5,padding:Spacing.desktopGutterMini}};var InviteeAdder=function(_Component){_inherits(InviteeAdder,_Component);function InviteeAdder(){_classCallCheck(this,InviteeAdder);var _this=_possibleConstructorReturn(this,(InviteeAdder.__proto__||Object.getPrototypeOf(InviteeAdder)).apply(this,arguments));_this.state={invitees:_this.props.initial,deleted:{}};return _this;}_createClass(InviteeAdder,[{key:'getInvitees',value:function getInvitees(){return this.parseText();}},{key:'getRootStyle',value:function getRootStyle(){var media=this.context.media;return Object.assign(styles.root,{flexDirection:this.context.media=='phone'?'column':'row',borderColor:this.context.muiTheme.rawTheme.palette.borderColor,borderStyle:this.props.standAlone?'solid':'none solid solid solid'});}},{key:'getContainerStyle',value:function getContainerStyle(){return styles.listContainer;}},{key:'getTextAreaStyle',value:function getTextAreaStyle(){var media=this.context.media;return Object.assign(styles.textarea,{height:media==='phone'?Spacing.desktopKeylineIncrement*2:Spacing.desktopKeylineIncrement*6,borderColor:this.context.muiTheme.rawTheme.palette.borderColor});}},{key:'getTextAreaContainerStyle',value:function getTextAreaContainerStyle(){var media=this.context.media;return Object.assign(styles.textAreaContainer,{width:media=='phone'?'auto':Spacing.desktopKeylineIncrement*4,height:media==='phone'?Spacing.desktopKeylineIncrement*2:Spacing.desktopKeylineIncrement*6});}},{key:'reset',value:function reset(){this.setState({invitees:[],deleted:{}});}},{key:'isEmail',value:function isEmail(value){var re=/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;return re.test(value);}},{key:'parseText',value:function parseText(){var _this2=this;var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{keyCode:13};var value=e&&e.target&&e.target.value||this.refs.emails.value;var keyCode=e.keyCode;var invitees=this.state.invitees.slice();var dirty=false;if(keyCode===13){var emails=value.split(/[\s,]+/);emails.forEach(function(email){if(invitees.indexOf(email)<0&&_this2.isEmail(email)){invitees.push(email);dirty=true;}});if(e&&e.target){e.target.value='';}}var filtered=invitees.filter(function(invitee){return!_this2.state.deleted[invitee];});if(dirty){this.setState({invitees:filtered});if(this.props.onChange){this.props.onChange(filtered);}}return filtered;}},{key:'removeEmail',value:function removeEmail(email){var deleted=Object.assign({},this.state.deleted,_defineProperty({},email,true));var filtered=this.state.invitees.filter(function(invitee){return!deleted[invitee];});var onChange=this.props.onChange;onChange&&onChange(filtered);this.setState({deleted:deleted});}},{key:'render',value:function render(){var _this3=this;var items=[];items.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListDivider"],{key:'d'}));this.state.invitees.forEach(function(email,index){if(!_this3.state.deleted[email]){items.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListItem"],{key:'i-'+index,primaryText:email,rightIconButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{onTouchTap:_this3.removeEmail.bind(_this3,email)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["ContentClear"],null))}));items.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListDivider"],{key:'d-'+index}));}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getRootStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getTextAreaContainerStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{ref:'emails',placeholder:this.context.getIntlMessage('invite.enterEmail'),onKeyUp:this.parseText.bind(this),style:this.getTextAreaStyle()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getContainerStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["List"],{subheader:this.context.getIntlMessage('invite.foundEmails')},items)));}}]);return InviteeAdder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InviteeAdder.displayName='InviteeAdder';InviteeAdder.propTypes={initial:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,standAlone:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};InviteeAdder.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};InviteeAdder.defaultProps={initial:[],standAlone:false};/* harmony default export */ __webpack_exports__["a"] = (InviteeAdder);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Widgets_SimpleOverview__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_InvitationDetail__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_CourseDetail__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_InvitationDetail__ = __webpack_require__(2163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Material_Cover__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_StudentSelector__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_GroupSelector__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_InviteeAdder__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_DialogPortal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Material_DropDown__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_containers_CourseDiplomaEditor__ = __webpack_require__(2164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_containers_CourseDripContentEditor__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_containers_CourseQuizContentEditor__ = __webpack_require__(2179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_Student_StudentOverview__ = __webpack_require__(2180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_Invitation_InvitationOverview__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_selectors_courseDetail__ = __webpack_require__(2182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_Tags__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_Widgets_Overview__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_DropDown__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_Widgets_Ozitor__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _templateObject=_taggedTemplateLiteral(['customExport'],['customExport']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_7_material_ui__["Styles"].Spacing;var css={buttonContainer:'_A',toggle:'_kq'};var minDate=new Date();var maxDate=new Date();maxDate.setFullYear(maxDate.getFullYear()+2);var CourseDetail=function(_mixin){_inherits(CourseDetail,_mixin);function CourseDetail(props,context){_classCallCheck(this,CourseDetail);var _this=_possibleConstructorReturn(this,(CourseDetail.__proto__||Object.getPrototypeOf(CourseDetail)).call(this,props,context));_this.state={selectedStudent:{},selectedInvitation:{},selectedSpecificInvitation:[],selectedGroup:{},accessTime:'threeMonths',invitees:[],userIds:{},value:'',toggleValue:'Tasks'};_this.handleChange=function(e){_this.setState({value:e.target.value});};_this.toggleChange=function(e,isInputChecked){_this.setState({toggleValue:isInputChecked?'Quizzes':'Tasks'});};_this._selectStudents=function(userIds){_this.setState({userIds:userIds});};_this._closeAddStudentsDialog=function(){_this.refs.addStudentsDialog.dismiss();};_this.changeCategory=function(categorySlug){var course=_this.props.course;__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].setCategory(course.id,[categorySlug]);};_this._closeInvitesDialog=function(){_this.refs.inviteStudentsDialog.dismiss();};_this._handleInviteesChange=function(invitees){_this.setState({invitees:invitees});};_this.addTag=function(tagName){__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].addTag(_this.props.course.id,tagName);};_this.deleteTag=function(tagName){__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].removeTag(_this.props.course.id,tagName);};_this.changeDescription=function(description){__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].update(_this.props.course.id,{description:description});};_this.export=function(){var re=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var email=null;if(re.test(String(_this.state.value).toLowerCase())){email=_this.state.value;}__WEBPACK_IMPORTED_MODULE_2_actions__["C" /* StudentActions */].export({courseIds:[_this.props.course.id],recipientEmail:email});_this.refs.exportDialog.dismiss();};_this.exportStatistic=function(){var re=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var email=null;if(re.test(String(_this.state.value).toLowerCase())){email=_this.state.value;}var toggleValue=_this.state.toggleValue;__WEBPACK_IMPORTED_MODULE_2_actions__["C" /* StudentActions */].exportStatistic({id:_this.props.course.id,recipientEmail:email,mode:toggleValue==='Quizzes'?'quiz':'task'});_this.refs.exportStatisticDialog.dismiss();};_this.accessTimes={oneMonth:context.getIntlMessage('invite.oneMonth'),threeMonths:context.getIntlMessage('invite.threeMonths'),sixMonths:context.getIntlMessage('invite.sixMonths'),oneYear:context.getIntlMessage('invite.oneYear'),twoYears:context.getIntlMessage('invite.twoYears')};_this.menuItems=[{payload:null,text:context.getIntlMessage('invite.chooseAccessTime')}];Object.keys(_this.accessTimes).forEach(function(time){_this.menuItems.push({payload:time,text:_this.accessTimes[time]});});return _this;}_createClass(CourseDetail,[{key:'listenToStores',value:function listenToStores(){var _this2=this;this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores__["s" /* SettingsStore */],'settings');this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores__["i" /* GroupStore */],'group');this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_6_stores_CourseDetail__["a" /* default */],function(state){return Object.assign({studentsLoading:state.students.loading,studentsPrevDisabled:state.students.pageStart<1,studentsNextDisabled:false,pageStartStudents:state.students.pageStart,pageLengthStudents:state.students.pageLength,totalStudents:state.totalStudents,students:Object(__WEBPACK_IMPORTED_MODULE_26_selectors_courseDetail__["b" /* getStudents */])(state)},_this2.mapActions({prevStudents:__WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__["a" /* default */].prevStudents,nextStudents:__WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__["a" /* default */].nextStudents,filterStudents:__WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__["a" /* default */].filterStudents,filterStudentsByStatus:__WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__["a" /* default */].filterStudentsByStatus}));});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_8_stores_InvitationDetail__["a" /* default */],function(state){return Object.assign({invitationsLoading:state.invitations.loading,invitationsPrevDisabled:state.invitations.pageStart<1,invitationsNextDisabled:false,pageStartInvitations:state.invitations.pageStart,pageLengthInvitations:state.invitations.pageLength,totalInvitations:state.totalInvitations,invitations:Object(__WEBPACK_IMPORTED_MODULE_26_selectors_courseDetail__["a" /* getInvitations */])(state)},_this2.mapActions({prevInvitations:__WEBPACK_IMPORTED_MODULE_5_actions_InvitationDetail__["a" /* default */].prevInvitations,nextInvitations:__WEBPACK_IMPORTED_MODULE_5_actions_InvitationDetail__["a" /* default */].nextInvitations}));});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_1_stores__["d" /* CategoryStore */],function(state){return{categories:state.list};});}},{key:'componentDidMount',value:function componentDidMount(){var course=this.props.course;__WEBPACK_IMPORTED_MODULE_2_actions__["d" /* CategoryActions */].initCategories();__WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__["a" /* default */].read(course.id);__WEBPACK_IMPORTED_MODULE_5_actions_InvitationDetail__["a" /* default */].read(course.id);__WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__["a" /* default */].countStudents(course.id);__WEBPACK_IMPORTED_MODULE_5_actions_InvitationDetail__["a" /* default */].countInvitations(course.id);__WEBPACK_IMPORTED_MODULE_2_actions__["d" /* CategoryActions */].initCategories();__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].findByCourseId(course.id);}},{key:'componentWillMount',value:function componentWillMount(){if(_get(CourseDetail.prototype.__proto__||Object.getPrototypeOf(CourseDetail.prototype),'componentWillMount',this)){_get(CourseDetail.prototype.__proto__||Object.getPrototypeOf(CourseDetail.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_2_actions__["y" /* SettingsActions */].read();}},{key:'removeStudent',value:function removeStudent(student){this.setState({selectedStudent:student});this.refs.removeStudentDialog.show();}},{key:'_onRemoveStudentConfirm',value:function _onRemoveStudentConfirm(){var course=this.props.course;__WEBPACK_IMPORTED_MODULE_2_actions__["C" /* StudentActions */].removeFromCourse(this.props.course.id,this.state.selectedStudent.id);__WEBPACK_IMPORTED_MODULE_2_actions__["C" /* StudentActions */].findByCourseId(course.id);this.state.totalStudents--;__WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__["a" /* default */].read(course.id);this.refs.removeStudentDialog.dismiss();}},{key:'removeInvitation',value:function removeInvitation(invitation){this.setState({selectedInvitation:invitation});this.refs.removeInvitationDialog.show();}},{key:'resendInvitation',value:function resendInvitation(invitation){this.setState({selectedInvitation:invitation});this.refs.resendInvitationDialog.show();}},{key:'resendSpecificInvitation',value:function resendSpecificInvitation(invitation){if(!invitation.clicked){invitation.clicked=true;this.state.selectedSpecificInvitation.push(invitation);}else{invitation.clicked=false;var index=this.state.selectedSpecificInvitation.indexOf(invitation);this.state.selectedSpecificInvitation.splice(index,1);}}},{key:'resendInvitationAll',value:function resendInvitationAll(invitations){this.setState({selectedInvitation:invitations});this.refs.resendInvitationAllDialog.show();}},{key:'resendInvitationChosen',value:function resendInvitationChosen(invitations){if(this.state.selectedSpecificInvitation.length>0){this.refs.resendInvitationChosenDialog.show();}else{__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(this.context.getIntlMessage('invitation.notChosen'));}}},{key:'_onResendInvitationChosenConfirm',value:function _onResendInvitationChosenConfirm(){__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].resend(this.state.selectedSpecificInvitation.map(function(invitation){return invitation.id;}));// this.state.selectedSpecificInvitation.map( invitation => { return invitation.clicked = true });
__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(this.context.getIntlMessage('invitation.resent'));this.refs.resendInvitationChosenDialog.dismiss();__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].findByCourseId(this.props.course.id);}},{key:'_onResendInvitationConfirm',value:function _onResendInvitationConfirm(){__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].resend(this.state.selectedInvitation.id);this.state.selectedInvitation.clicked=true;__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(this.context.getIntlMessage('invitation.resent'));this.refs.resendInvitationDialog.dismiss();__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].findByCourseId(this.props.course.id);}},{key:'_onResendInvitationAllConfirm',value:function _onResendInvitationAllConfirm(){__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].resend(this.state.selectedInvitation.map(function(invitation){return invitation.id;}));this.state.selectedInvitation.map(function(invitation){return invitation.clicked=true;});__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(this.context.getIntlMessage('invitation.allResent'));this.refs.resendInvitationAllDialog.dismiss();__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].findByCourseId(this.props.course.id);}},{key:'_onRemoveInvitationConfirm',value:function _onRemoveInvitationConfirm(){__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].delete(this.state.selectedInvitation.id);__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].findByCourseId(this.props.course.id);__WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__["a" /* default */].read(this.props.course.id);this.refs.removeInvitationDialog.dismiss();this.state.totalInvitations--;__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].findByCourseId(this.props.course.id);__WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__["a" /* default */].read(this.props.course.id);}},{key:'removeGroup',value:function removeGroup(groupId){this.setState({selectedGroup:group});this.refs.removeGroupDialog.show();}},{key:'_onRemoveGroupConfirm',value:function _onRemoveGroupConfirm(){__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].removeFromCourse(this.props.course.id,this.state.selectedGroup.id);this.refs.removeGroupDialog.dismiss();}},{key:'closeDetail',value:function closeDetail(){if(this.props.onClose){this.props.onClose();}}},{key:'addStudents',value:function addStudents(){this.refs.addStudentsDialog.show();}},{key:'changeAccessTime',value:function changeAccessTime(event,selectedIndex,menuItem){this.setState({accessTime:menuItem.payload});}},{key:'createAddStudentsDialog',value:function createAddStudentsDialog(){var _this3=this;var getIntlMessage=this.context.getIntlMessage;var userIds=this.state.userIds;var menuItems=this.menuItems;var selectedIndex=menuItems.findIndex(function(item){return item.payload===_this3.state.accessTime;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'addStudentsDialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Material_DropDown__["a" /* default */],{onChange:this.changeAccessTime.bind(this),label:this.context.getIntlMessage('invite.accessTime'),ref:'courseAccessTime',selectedIndex:selectedIndex,menuItems:menuItems}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_StudentSelector__["a" /* default */],{ref:'studentSelector',onSelect:this._selectStudents}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('Cancel'),onTouchTap:this._closeAddStudentsDialog}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["RaisedButton"],{secondary:true,disabled:Object.keys(userIds).length<1,label:getIntlMessage('Invite'),onTouchTap:this._addStudentsConfirm.bind(this)})));}},{key:'_addStudentsConfirm',value:function _addStudentsConfirm(){var _this4=this;var userIds=Object.keys(this.refs.studentSelector.getSelected()).map(function(id){return parseInt(id,10);});var accessTime=this.state.accessTime;var courseIds=[this.props.course.id];__WEBPACK_IMPORTED_MODULE_2_actions__["l" /* InviteActions */].inviteByUserIds(userIds,courseIds,accessTime,function(){__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(_this4.context.getIntlMessage('course.studentsInvited'));_this4.refs.addStudentsDialog.dismiss();_this4.state.totalStudents++;__WEBPACK_IMPORTED_MODULE_2_actions__["C" /* StudentActions */].findByCourseId(_this4.props.course.id);__WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__["a" /* default */].read(_this4.props.course.id);});}},{key:'inviteStudents',value:function inviteStudents(){this.refs.inviteStudentsDialog.show();}},{key:'createInviteStudentsDialog',value:function createInviteStudentsDialog(){var _this5=this;var getIntlMessage=this.context.getIntlMessage;var invitees=this.state.invitees;var menuItems=this.menuItems;var selectedIndex=menuItems.findIndex(function(item){return item.payload===_this5.state.accessTime;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'inviteStudentsDialog',dismissOnClickAway:true,autoDetectWindowHeight:true,autoScrollBodyContent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Material_DropDown__["a" /* default */],{onChange:this.changeAccessTime.bind(this),label:this.context.getIntlMessage('invite.accessTime'),ref:'courseAccessTime',selectedIndex:selectedIndex,menuItems:menuItems}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_InviteeAdder__["a" /* default */],{ref:'invitees',standAlone:true,onChange:this._handleInviteesChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('Cancel'),onTouchTap:this._closeInvitesDialog}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["RaisedButton"],{secondary:true,disabled:invitees.length<1,label:getIntlMessage('Invite'),onTouchTap:this._inviteStudentsConfirm.bind(this)})));}},{key:'_inviteStudentsConfirm',value:function _inviteStudentsConfirm(){var _this6=this;var _state=this.state,emails=_state.invitees,accessTime=_state.accessTime;__WEBPACK_IMPORTED_MODULE_2_actions__["l" /* InviteActions */].inviteByEmails(emails,[this.props.course.id],accessTime,function(){__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(_this6.context.getIntlMessage('course.studentsInvited'));_this6.refs.inviteStudentsDialog.dismiss();_this6.state.totalInvitations++;__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].findByCourseId(_this6.props.course.id);__WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__["a" /* default */].read(_this6.props.course.id);});}},{key:'addGroups',value:function addGroups(){this.refs.addGroupsDialog.show();}},{key:'createAddGroupsDialog',value:function createAddGroupsDialog(){var actions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Add'),onTouchTap:this._addGroupsConfirm.bind(this),ref:'submit'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'addGroupsDialog',actions:actions,actionFocus:'submit',dismissOnClickAway:true,autoDetectWindowHeight:true,autoScrollBodyContent:true},this.context.getIntlMessage('invite.accessTime'),' :',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["DatePicker"],{style:{display:'inline-block'},ref:'endDate',maxDate:maxDate,minDate:minDate,hintText:this.context.getIntlMessage('invite.chooseEndDate')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_GroupSelector__["a" /* default */],{ref:'groupSelector'}));}},{key:'_addGroupsConfirm',value:function _addGroupsConfirm(){var _this7=this;var circleIds=Object.keys(this.refs.groupSelector.getSelected()).map(function(id){return parseInt(id,10);});var endDate=this.refs.endDate.getDate();var courseIds=[this.props.course.id];__WEBPACK_IMPORTED_MODULE_2_actions__["l" /* InviteActions */].inviteByCircleIds(circleIds,courseIds,endDate,function(){__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(_this7.context.getIntlMessage('course.groupsInvited'));_this7.refs.addGroupsDialog.dismiss();__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].findByCourseId(_this7.props.course.id);});}},{key:'updateAccess',value:function updateAccess(item,finDate){__WEBPACK_IMPORTED_MODULE_2_actions__["G" /* UserActions */].course(this.props.course.id,item.id,finDate);__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(this.context.getIntlMessage('course.dateSaved'));__WEBPACK_IMPORTED_MODULE_4_actions_CourseDetail__["a" /* default */].read(this.props.course.id);}},{key:'render',value:function render(){var _state2=this.state,studentsLoading=_state2.studentsLoading,students=_state2.students,prevStudents=_state2.prevStudents,nextStudents=_state2.nextStudents,filterStudents=_state2.filterStudents,filterStudentsByStatus=_state2.filterStudentsByStatus,studentsPrevDisabled=_state2.studentsPrevDisabled,studentsNextDisabled=_state2.studentsNextDisabled,invitationsLoading=_state2.invitationsLoading,invitations=_state2.invitations,prevInvitations=_state2.prevInvitations,nextInvitations=_state2.nextInvitations,invitationsPrevDisabled=_state2.invitationsPrevDisabled,invitationsNextDisabled=_state2.invitationsNextDisabled,pageStartStudents=_state2.pageStartStudents,pageLengthStudents=_state2.pageLengthStudents,pageStartInvitations=_state2.pageStartInvitations,pageLengthInvitations=_state2.pageLengthInvitations,totalStudents=_state2.totalStudents,totalInvitations=_state2.totalInvitations,settings=_state2.settings,toggleValue=_state2.toggleValue;var course=this.props.course,coverImage=course.coverImage,backgroundImage=coverImage&&coverImage.url,addStudentsDialog=this.createAddStudentsDialog(),inviteStudentsDialog=this.createInviteStudentsDialog(),addGroupsDialog=this.createAddGroupsDialog(),removeStudentActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Remove'),onTouchTap:this._onRemoveStudentConfirm.bind(this),ref:'submit'}],removeInvitationActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Remove'),onTouchTap:this._onRemoveInvitationConfirm.bind(this),ref:'submit'}],resendInvitationActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Resend'),onTouchTap:this._onResendInvitationConfirm.bind(this),ref:'submit'}],resendInvitationAllActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Resend'),onTouchTap:this._onResendInvitationAllConfirm.bind(this),ref:'submit'}],resendInvitationChosenActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Resend'),onTouchTap:this._onResendInvitationChosenConfirm.bind(this),ref:'submit'}],removeGroupActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Remove'),onTouchTap:this._onRemoveGroupConfirm.bind(this),ref:'submit'}],exportActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Export'),onTouchTap:this.export,ref:'submit'}],exportStatisticActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Export'),onTouchTap:this.exportStatistic,ref:'submit'}];var selectedIndex=0;var categories=this.state.categories;var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ToolbarTitle"],{text:this.props.course.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ToolbarGroup"],{float:'right',key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('group.add'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["SocialGroupAdd"],null),onTouchTap:this.addGroups.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('student.add'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["SocialPersonAdd"],null),onTouchTap:this.addStudents.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('student.inviteNew'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ContentMail"],null),onTouchTap:this.inviteStudents.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('Close'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ContentClear"],null),onTouchTap:this.closeDetail.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('export.course'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ActionLaunch"],null),onTouchTap:this.refs.exportDialog&&this.refs.exportDialog.show}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('export.statistic'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["EditorInsertDriveFile"],null),onTouchTap:this.refs.exportStatisticDialog&&this.refs.exportStatisticDialog.show})));var invites=this.state.invitations.sort(function(a,b){return new Date(b.expires).getTime()-new Date(a.expires).getTime();});var selectedSpecificInvitation=this.state.selectedSpecificInvitation;var resendButton=null;var features=null;var hasDiplomas=settings.list&&settings.list.features&&settings.list.features.diplomas===true;var hasQuiz=settings.list&&settings.list.features&&settings.list.features.quiz===true;var hasDripContent=settings.list&&settings.list.features&&settings.list.features.dripContent===true;if(settings.list&&settings.list.features&&settings.list.features.enterpriseStore==true){features=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_components_Widgets_Overview__["a" /* default */],{header:this.context.getIntlMessage('Tags')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini*2}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_components_Tags__["b" /* TagSelector */],{onAddTag:this.addTag,onRemoveTag:this.deleteTag,tags:course.tagsMap,fullWidth:true,padded:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_components_Widgets_Overview__["a" /* default */],{header:this.context.getIntlMessage('course.category')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini*2}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_components_DropDown__["a" /* DropDown */],{onChange:this.changeCategory,selected:course.categories&&course.categories[0],options:categories,fullWidth:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_components_Widgets_Overview__["a" /* default */],{header:this.context.getIntlMessage('Description')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_Widgets_Ozitor__["a" /* default */],{style:{content:{minHeight:__WEBPACK_IMPORTED_MODULE_29_Css__["Units"].keyline*2,height:__WEBPACK_IMPORTED_MODULE_29_Css__["Units"].keyline*2,maxHeight:__WEBPACK_IMPORTED_MODULE_29_Css__["Units"].keyline*4},root:{minHeight:'auto'}},editable:true,onChange:this.changeDescription,defaultContent:course.description})));}if(this.state.invitations.length!=0){resendButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["List"],{subheader:'',subheaderStyle:{fontSize:24,borderStyle:'none none solid none',borderWidth:'1px',borderColor:'rgba(0, 0, 0, 0.12)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["RaisedButton"],{style:{margin:8},onTouchTap:this.resendInvitationChosen.bind(this,invitations),label:this.context.getIntlMessage('invitation.chosen')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["RaisedButton"],{style:{margin:8},onTouchTap:this.resendInvitationAll.bind(this,invitations),label:this.context.getIntlMessage('invitation.resendAll')}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_ScrollableContainer__["a" /* default */],{header:toolbar,card:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Material_Cover__["a" /* default */],{image:backgroundImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["List"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ActionLabel"],null),primaryText:course.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ActionFace"],null),primaryText:course.ownerName})),hasQuiz&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_containers_CourseQuizContentEditor__["a" /* default */],{course:course}),hasDiplomas&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_containers_CourseDiplomaEditor__["a" /* default */],{course:course}),hasDripContent&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_containers_CourseDripContentEditor__["a" /* default */],{course:course}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_components_Student_StudentOverview__["a" /* default */],{list:students,loading:studentsLoading,prevDisabled:studentsPrevDisabled,nextDisabled:studentsNextDisabled,prev:prevStudents,next:nextStudents,filter:filterStudents,filterByStatus:filterStudentsByStatus,onTouchTapRightIcon:this.removeStudent.bind(this),total:totalStudents,pageStartStudents:pageStartStudents,pageLengthStudents:pageLengthStudents,onTouchTap:this.updateAccess.bind(this)}),resendButton,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_components_Invitation_InvitationOverview__["a" /* default */],{list:invites,loading:invitationsLoading,prevDisabled:invitationsPrevDisabled,nextDisabled:invitationsNextDisabled,prev:prevInvitations,next:nextInvitations,onTouchTapRightIcon:this.removeInvitation.bind(this),onTouchTapLeftIcon:this.resendInvitation.bind(this),onCheck:this.resendSpecificInvitation.bind(this),total:totalInvitations,pageStartInvitations:pageStartInvitations,pageLengthInvitations:pageLengthInvitations}),features,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Widgets_SimpleOverview__["a" /* default */],{items:this.state.group.selection,limitToMax:100,readable:'name',title:this.context.getIntlMessage('group.Groups'),onTouchTapRightIcon:this.removeGroup.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'removeStudentDialog',title:this.context.getIntlMessage('student.removeFromCourse'),actions:removeStudentActions,actionFocus:'submit',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('student.revokeAccess'),student:this.state.selectedStudent.name,course:this.props.course.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'removeInvitationDialog',title:this.context.getIntlMessage('invitation.remove'),actions:removeInvitationActions,actionFocus:'submit',dismissOnClickAway:true},this.context.getIntlMessage('invitation.revokeAccess')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'resendInvitationDialog',title:this.context.getIntlMessage('invitation.resend'),actions:resendInvitationActions,actionFocus:'submit',dismissOnClickAway:true},this.context.getIntlMessage('invitation.prolongAccess')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'resendInvitationAllDialog',title:this.context.getIntlMessage('invitation.resendAll'),actions:resendInvitationAllActions,actionFocus:'submit',dismissOnClickAway:true},this.context.getIntlMessage('invitation.resendAll')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'resendInvitationChosenDialog',title:this.context.getIntlMessage('invitation.chosen'),actions:resendInvitationChosenActions,actionFocus:'submit',dismissOnClickAway:true},this.context.getIntlMessage('invitation.chosen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'removeGroupDialog',title:this.context.getIntlMessage('student.removeFromCourse'),actions:removeGroupActions,actionFocus:'submit',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('group.revokeAccess'),group:this.state.selectedGroup.name,course:this.props.course.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'exportDialog',title:Object(__WEBPACK_IMPORTED_MODULE_32_oxygen_i18n__["translate"])(_templateObject),actions:exportActions,actionFocus:'export',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["TextField"],{onChange:this.handleChange,floatingLabelText:'',hintText:'Email'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'exportStatisticDialog',title:Object(__WEBPACK_IMPORTED_MODULE_32_oxygen_i18n__["translate"])(_templateObject),actions:exportStatisticActions,actionFocus:'exportStatistic',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["TextField"],{onChange:this.handleChange,floatingLabelText:'',hintText:'Email'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{label:toggleValue,onToggle:this.toggleChange,toggled:toggleValue==='Quizzes',className:css.toggle})),addStudentsDialog,inviteStudentsDialog,addGroupsDialog));}}]);return CourseDetail;}(Object(__WEBPACK_IMPORTED_MODULE_11_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_11_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_11_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));CourseDetail.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (CourseDetail);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Dialog__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_MediaLibrary_FileSelectorContainer__ = __webpack_require__(2167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Toolbar__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileUploader__ = __webpack_require__(2175);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={container:'_e8'};var UploadDialog=function(_Component){_inherits(UploadDialog,_Component);function UploadDialog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UploadDialog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UploadDialog.__proto__||Object.getPrototypeOf(UploadDialog)).call.apply(_ref,[this].concat(args))),_this),_this.state={mode:'upload'},_this.uploadMode=function(){_this.setState({mode:'upload'});},_this.libraryMode=function(){_this.setState({mode:'library'});},_this.uploadSuccess=function(files){if(files&&files.length>0){var onSuccess=_this.props.onSuccess;if(onSuccess){files.forEach(function(record){var file=record.file;var url=file.url,id=file.id;onSuccess(url,id);});}}},_this.selectFile=function(file){var url=file.url,id=file.id;var onSuccess=_this.props.onSuccess;onSuccess&&onSuccess(url,id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UploadDialog,[{key:'render',value:function render(){var _props=this.props,title=_props.title,description=_props.description,type=_props.type,accept=_props.accept;var getIntlMessage=this.context.getIntlMessage;var mode=this.state.mode;var mimeType=type==='pdf'?'applicaiton/pdf':type+'/*';var fileType=type==='pdf'?'other':type;var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toolbar__["b" /* Toolbar */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toolbar__["a" /* TabButton */],{selected:mode==='upload',onTouchTap:this.uploadMode},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toolbar__["a" /* TabButton */],{selected:mode==='library',onTouchTap:this.libraryMode},getIntlMessage('menu.mediaLibrary')));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Dialog__["a" /* Dialog */],this.props,toolbar,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},mode==='library'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_containers_MediaLibrary_FileSelectorContainer__["a" /* default */],{onSelect:this.selectFile,type:fileType}),mode==='upload'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FileUploader__["a" /* default */],{type:mimeType,onSuccess:this.uploadSuccess,description:description})));}}]);return UploadDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);UploadDialog.propTypes={title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,accept:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,description:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onSuccess:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};UploadDialog.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (UploadDialog);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropDown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropDown__ = __webpack_require__(2183);
var DropDown=__WEBPACK_IMPORTED_MODULE_0__DropDown__["a" /* default */];/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__DropDown__["a" /* default */]);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_EventManager__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ReactGestures from 'react-gestures';
var ActionSearch=__WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__["ActionSearch"];var styles={iconButton:{flex:'0 1',border:18,padding:20,width:64,height:64},image:{maxHeight:56,verticalAlign:'middle'},root:{}};var css={root:'_P',header:'_Q',left:'_R',right:'_S',link:'_T',linkName:'_U'};var StoreBar=function(_mixin){_inherits(StoreBar,_mixin);function StoreBar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreBar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreBar.__proto__||Object.getPrototypeOf(StoreBar)).call.apply(_ref,[this].concat(args))),_this),_this.toggle=function(e){__WEBPACK_IMPORTED_MODULE_4_actions__["a" /* AppActions */].toggleAppBar();e.preventDefault();},_this.logout=function(){__WEBPACK_IMPORTED_MODULE_4_actions__["b" /* AuthActions */].logout();},_this.editMode=function(){__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].editMode();},_this.listMode=function(){__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].listMode();},_this.gotoStore=function(){var store=_this.props.store;__WEBPACK_IMPORTED_MODULE_9_helpers__["a" /* history */].push('/store/'+store);},_this.gotoDashboard=function(){__WEBPACK_IMPORTED_MODULE_9_helpers__["a" /* history */].push('/');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreBar,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_5_stores__["b" /* AuthStore */]);}},{key:'render',value:function render(){var _props=this.props,mode=_props.mode,store=_props.store,children=_props.children,logo=_props.logo,canIEdit=_props.canIEdit,other=_objectWithoutProperties(_props,['mode','store','children','logo','canIEdit']);var loggedIn=this.state.loggedIn;var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:css.root},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.left},loggedIn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{style:styles.iconButton,onTouchTap:this.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__["NavigationMenu"],{color:'rgba(0, 0, 0, 0.9)',hoverColor:'rgba(0, 0, 0, 0.5)'})),loggedIn&&canIEdit&&mode==='list'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{style:styles.iconButton,onTouchTap:this.editMode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__["EditorModeEdit"],{color:'rgba(0, 0, 0, 0.9)',hoverColor:'rgba(0, 0, 0, 0.5)'})),store&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.link,onTouchTap:this.gotoStore},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__["ActionStore"],{color:'rgba(0, 0, 0, 0.9)',hoverColor:'rgba(0, 0, 0, 0.5)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:css.linkName},getIntlMessage('store.goto')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header,onTouchTap:this.gotoStore,style:{backgroundImage:'url('+logo+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.right},loggedIn?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{style:styles.iconButton,onTouchTap:this.logout},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__["ActionExitToApp"],{color:'rgba(0, 0, 0, 0.9)',hoverColor:'rgba(0, 0, 0, 0.5)'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.link,onTouchTap:this.gotoDashboard},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__["AvPlayArrow"],{color:'rgba(0, 0, 0, 0.9)',hoverColor:'rgba(0, 0, 0, 0.5)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,getIntlMessage('login.toDashboard')))));}}]);return StoreBar;}(Object(__WEBPACK_IMPORTED_MODULE_6_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_6_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));StoreBar.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};StoreBar.propTypes={title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,store:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,mode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,canIEdit:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (StoreBar);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_dh',icon:'_di'};var Gift=function(_Component){_inherits(Gift,_Component);function Gift(){_classCallCheck(this,Gift);return _possibleConstructorReturn(this,(Gift.__proto__||Object.getPrototypeOf(Gift)).apply(this,arguments));}_createClass(Gift,[{key:'render',value:function render(){var _props=this.props,className=_props.className,color=_props.color,fill=_props.fill,borderColor=_props.borderColor,other=_objectWithoutProperties(_props,['className','color','fill','borderColor']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({style:{backgroundColor:fill,borderColor:borderColor}},other,{xmlns:'http://www.w3.org/2000/svg',width:'169',height:'28',viewBox:'0 0 169 28',version:'1.1',className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(className,css.root,css.icon)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'path-1',points:'0 12.6731378 70.4771076 12.6731378 70.4771076 3.16049384e-05 0 3.16049384e-05'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{id:'path-3',x:'0',y:'0',width:'169',height:'28',rx:'14'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('mask',{id:'mask-4',maskContentUnits:'userSpaceOnUse',maskUnits:'objectBoundingBox',x:'0',y:'0',width:'169',height:'28',fill:'white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use',{href:'url(#path-3'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{stroke:'none',strokeWidth:'1',fill:'none',fillRule:'evenodd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{transform:'translate(-96.000000, -85.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{transform:'translate(96.000000, 85.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M15.243,17.6 L16.541,17.6 L16.541,14.74 L18.323,14.74 C19.94,14.74 20.941,13.827 20.941,12.331 C20.941,10.802 19.852,9.9 18.312,9.9 L15.243,9.9 L15.243,17.6 Z M16.541,13.541 L16.541,11.099 L18.279,11.099 C18.95,11.099 19.61,11.418 19.61,12.331 C19.61,13.112 19.016,13.541 18.29,13.541 L16.541,13.541 Z M24.277,16.632 C23.419,16.632 22.814,15.983 22.814,14.685 C22.814,13.398 23.43,12.738 24.277,12.738 C25.124,12.738 25.729,13.42 25.729,14.685 C25.729,15.95 25.124,16.632 24.277,16.632 Z M24.277,17.765 C25.784,17.765 26.961,16.676 26.961,14.685 C26.961,12.694 25.707,11.605 24.277,11.605 C22.836,11.605 21.571,12.694 21.571,14.685 C21.571,16.676 22.759,17.765 24.277,17.765 Z M29.153,17.6 L30.352,17.6 L31.881,13.222 L31.903,13.222 L33.322,17.6 L34.532,17.6 L35.929,11.77 L34.719,11.77 L33.784,15.818 L33.762,15.818 L32.464,11.77 L31.331,11.77 L29.945,15.829 L29.923,15.829 L29.098,11.77 L27.866,11.77 L29.153,17.6 Z M40.981,15.664 C40.728,16.06 40.332,16.654 39.441,16.654 C38.517,16.654 38.022,16.005 37.989,15.059 L42.059,15.059 L42.059,14.685 C42.059,12.771 40.926,11.605 39.408,11.605 C37.879,11.605 36.724,12.793 36.724,14.685 C36.724,16.577 37.879,17.765 39.463,17.765 C40.695,17.765 41.432,17.127 41.883,16.401 L40.981,15.664 Z M38,14.113 C38.044,13.442 38.506,12.716 39.408,12.716 C40.343,12.716 40.794,13.332 40.838,14.113 L38,14.113 Z M43.404,17.6 L44.658,17.6 L44.658,14.355 C44.658,13.343 45.021,12.903 45.681,12.903 C45.879,12.903 46.022,12.958 46.143,12.991 L46.341,11.77 C46.209,11.715 46.033,11.66 45.824,11.66 C45.329,11.66 44.845,11.935 44.614,12.386 L44.592,12.386 L44.592,11.77 L43.404,11.77 L43.404,17.6 Z M51.338,15.664 C51.085,16.06 50.689,16.654 49.798,16.654 C48.874,16.654 48.379,16.005 48.346,15.059 L52.416,15.059 L52.416,14.685 C52.416,12.771 51.283,11.605 49.765,11.605 C48.236,11.605 47.081,12.793 47.081,14.685 C47.081,16.577 48.236,17.765 49.82,17.765 C51.052,17.765 51.789,17.127 52.24,16.401 L51.338,15.664 Z M48.357,14.113 C48.401,13.442 48.863,12.716 49.765,12.716 C50.7,12.716 51.151,13.332 51.195,14.113 L48.357,14.113 Z M57.435,15.367 C57.435,16.038 56.929,16.632 56.104,16.632 C55.169,16.632 54.63,15.961 54.63,14.685 C54.63,13.409 55.169,12.738 56.104,12.738 C56.962,12.738 57.435,13.376 57.435,14.047 L57.435,15.367 Z M57.523,17.6 L58.689,17.6 L58.689,9.57 L57.435,9.57 L57.435,12.331 L57.413,12.331 C57.314,12.21 56.852,11.605 55.895,11.605 C54.586,11.605 53.376,12.727 53.376,14.685 C53.376,16.555 54.366,17.765 55.906,17.765 C56.907,17.765 57.424,17.138 57.501,17.039 L57.523,17.039 L57.523,17.6 Z M64.503,14.047 C64.503,13.376 64.987,12.738 65.845,12.738 C66.769,12.738 67.308,13.409 67.308,14.685 C67.308,15.961 66.769,16.632 65.845,16.632 C65.009,16.632 64.503,16.038 64.503,15.367 L64.503,14.047 Z M63.249,17.6 L64.415,17.6 L64.415,17.039 L64.437,17.039 C64.525,17.138 65.031,17.765 66.032,17.765 C67.572,17.765 68.562,16.555 68.562,14.685 C68.562,12.815 67.484,11.605 66.054,11.605 C65.119,11.605 64.624,12.21 64.525,12.331 L64.503,12.331 L64.503,9.57 L63.249,9.57 L63.249,17.6 Z M70.358,20.075 L71.568,20.075 L74.89,11.77 L73.592,11.77 L72.063,15.785 L72.041,15.785 L70.512,11.77 L69.192,11.77 L71.458,17.336 L70.358,20.075 Z',fill:color}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{transform:'translate(86.502370, 8.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M17.0976754,6.32808296 C17.0976754,3.93400889 18.759047,2.09238914 21.2256431,2.09238914 C22.7324686,2.09238914 23.6232108,2.69509531 24.2572382,3.49896691 L23.4007677,4.25211259 C22.8525814,3.51555951 22.1504954,3.21452247 21.294025,3.21452247 C19.5471356,3.21452247 18.4336271,4.53671506 18.4336271,6.32808296 C18.4336271,8.11992494 19.5471356,9.4591842 21.294025,9.4591842 C22.1504954,9.4591842 22.8525814,9.12417185 23.4007677,8.40468543 L24.2572382,9.17489778 C23.6232108,9.97845333 22.7324686,10.5813175 21.2256431,10.5813175 C18.759047,10.5813175 17.0976754,8.72215704 17.0976754,6.32808296 L17.0976754,6.32808296 Z',fill:color}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M32.425619,6.32808296 C32.425619,4.68747062 31.4490358,3.21452247 29.6853339,3.21452247 C27.9209853,3.21452247 26.9448871,4.68747062 26.9448871,6.32808296 C26.9448871,7.98623605 27.9209853,9.4591842 29.6853339,9.4591842 C31.4490358,9.4591842 32.425619,7.98623605 32.425619,6.32808296 M25.5914762,6.32808296 C25.5914762,3.98426074 27.1673301,2.09238914 29.6853339,2.09238914 C32.2028526,2.09238914 33.7785449,3.98426074 33.7785449,6.32808296 C33.7785449,8.67222123 32.2028526,10.5813175 29.6853339,10.5813175 C27.1673301,10.5813175 25.5914762,8.67222123 25.5914762,6.32808296',fill:color}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M41.4501147,10.3803891 L41.4501147,9.24182123 C40.8164106,9.94471506 39.7374971,10.5812385 38.5038757,10.5812385 C36.7744456,10.5812385 35.8668908,9.7440237 35.8668908,8.00211753 L35.8668908,2.29347556 L37.1511115,2.29347556 L37.1511115,7.61764346 C37.1511115,9.04112988 37.8876308,9.45926321 39.017952,9.45926321 C40.0116711,9.45926321 40.9707951,8.89005827 41.4501147,8.23710025 L41.4501147,2.29347556 L42.734497,2.29347556 L42.734497,10.3803891 L41.4501147,10.3803891 Z',fill:color}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M45.302793,10.3803891 L45.302793,2.29347556 L46.586852,2.29347556 L46.586852,3.58248296 C47.2549895,2.74526815 48.2142752,2.10890272 49.3445963,2.10890272 L49.3445963,3.39822617 C49.1908584,3.38163358 49.0358273,3.36488296 48.8479793,3.36488296 C48.0430781,3.36488296 46.9638413,4.0012484 46.586852,4.65420642 L46.586852,10.3803891 L45.302793,10.3803891 Z',fill:color}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M50.251068,9.30863407 L50.9020696,8.40457481 C51.450256,9.02387358 52.4944127,9.55941926 53.6257038,9.55941926 C54.8927887,9.55941926 55.5953596,8.97362173 55.5953596,8.17006617 C55.5953596,6.21135012 50.4736727,7.41692049 50.4736727,4.4198242 C50.4736727,3.14725136 51.5698838,2.09243654 53.5398628,2.09243654 C54.9613322,2.09243654 55.954243,2.6112316 56.6050829,3.2646637 L56.0058123,4.13537975 C55.5093569,3.54926617 54.6187763,3.11375012 53.5398628,3.11375012 C52.4095417,3.11375012 51.7069708,3.66604642 51.7069708,4.38632296 C51.7069708,6.14450568 56.828011,4.98902914 56.828011,8.13656494 C56.828011,9.49289086 55.7153107,10.5813649 53.5909471,10.5813649 C52.2207237,10.5813649 51.0905642,10.1625995 50.251068,9.30863407',fill:color}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('mask',{id:'mask-2',fill:'white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use',{href:'url(#path-1)'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:color,mask:'url(#mask-2)',points:'58.9165347 10.3803575 60.2009171 10.3803575 60.2009171 2.29344395 58.9165347 2.29344395'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M69.1241494,6.32808296 C69.1241494,4.68747062 68.1472429,3.21452247 66.383541,3.21452247 C64.6195157,3.21452247 63.6432558,4.68747062 63.6432558,6.32808296 C63.6432558,7.98623605 64.6195157,9.4591842 66.383541,9.4591842 C68.1472429,9.4591842 69.1241494,7.98623605 69.1241494,6.32808296 M62.2900066,6.32808296 C62.2900066,3.98426074 63.8661839,2.09238914 66.383541,2.09238914 C68.9012214,2.09238914 70.4770753,3.98426074 70.4770753,6.32808296 C70.4770753,8.67222123 68.9012214,10.5813175 66.383541,10.5813175 C63.8661839,10.5813175 62.2900066,8.67222123 62.2900066,6.32808296',fill:color,mask:'url(#mask-2)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M6.48405362,7.60354765 C5.76838833,7.60354765 5.18609188,8.17038222 5.18609188,8.87311802 C5.18609188,9.56937481 5.76838833,10.1363674 6.48405362,10.1363674 C7.20020389,10.1363674 7.78007545,9.56937481 7.78007545,8.87311802 C7.78007545,8.17038222 7.20020389,7.60354765 6.48405362,7.60354765',fill:color,mask:'url(#mask-2)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M6.48405362,2.5337837 C5.76838833,2.5337837 5.18609188,3.10330469 5.18609188,3.80003556 C5.18609188,4.50229728 5.76838833,5.06691951 6.48405362,5.06691951 C7.20020389,5.06691951 7.78007545,4.50229728 7.78007545,3.80003556 C7.78007545,3.10330469 7.20020389,2.5337837 6.48405362,2.5337837',fill:color,mask:'url(#mask-2)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M11.6702587,5.0668879 C10.9539467,5.0668879 10.3729436,5.63609284 10.3729436,6.33819654 C10.3729436,7.03650765 10.9539467,7.60350025 11.6702587,7.60350025 C12.3847923,7.60350025 12.9646639,7.03650765 12.9646639,6.33819654 C12.9646639,5.63609284 12.3847923,5.0668879 11.6702587,5.0668879',fill:color,mask:'url(#mask-2)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M1.29611882,10.1364148 C0.579968555,10.1364148 -6.46636813e-05,10.7100444 -6.46636813e-05,11.4059852 C-6.46636813e-05,12.1068247 0.579968555,12.6731852 1.29611882,12.6731852 C2.0134007,12.6731852 2.59488886,12.1068247 2.59488886,11.4059852 C2.59488886,10.7100444 2.0134007,10.1364148 1.29611882,10.1364148',fill:color,mask:'url(#mask-2)'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M1.29611882,0 C0.579968555,0 -6.46636813e-05,0.569520988 -6.46636813e-05,1.26640988 L-6.46636813e-05,6.33821235 C-6.46636813e-05,7.03652346 0.579968555,7.60351605 1.29611882,7.60351605 C2.0134007,7.60351605 2.59488886,7.03652346 2.59488886,6.33821235 L2.59488886,1.26640988 C2.59488886,0.569520988 2.0134007,0 1.29611882,0',fill:color,mask:'url(#mask-2)'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use',{stroke:'#7E7E7E',mask:'url(#mask-4)',strokeWidth:'2.4',href:'url(#path-3)'})))));}}]);return Gift;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Gift.propTypes={className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,fill:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,borderColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};Gift.defaultProps={color:'#7E7E7E',fill:'transparent',borderColor:'#7E7E7E'};/* harmony default export */ __webpack_exports__["a"] = (Gift);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__renderTaC__ = __webpack_require__(608);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={content:'_b3'};var StoreTaC=function(_mixin){_inherits(StoreTaC,_mixin);function StoreTaC(){_classCallCheck(this,StoreTaC);return _possibleConstructorReturn(this,(StoreTaC.__proto__||Object.getPrototypeOf(StoreTaC)).apply(this,arguments));}_createClass(StoreTaC,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2__stores__["u" /* StoreStore */],function(state){return{docs:state.docs||{},logo:state.theme&&state.theme.logoUrl,title:state.owner&&state.owner.name,username:state.owner&&state.owner.username};},{docs:{}});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2__stores__["b" /* AuthStore */],function(state){return{locale:state.locale};},{locale:'en_US'});}},{key:'componentDidMount',value:function componentDidMount(){var username=this.props.username;__WEBPACK_IMPORTED_MODULE_3__actions__["z" /* StoreActions */].read(username,true);}},{key:'render',value:function render(){var _state=this.state,docs=_state.docs,title=_state.title,locale=_state.locale;var termsAndConditions=docs.termsAndConditions;var pageContent=locale==='sv_SE'?__WEBPACK_IMPORTED_MODULE_6__renderTaC__["b" /* swedish */]:__WEBPACK_IMPORTED_MODULE_6__renderTaC__["a" /* english */];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FullScreenDialog__["a" /* default */],this.props,title?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.content},termsAndConditions?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:termsAndConditions}}):pageContent):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Material_Loader__["b" /* default */],null));}}]);return StoreTaC;}(Object(__WEBPACK_IMPORTED_MODULE_1__Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1__Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));StoreTaC.contextTypes={router:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreTaC);

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(272)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = DragSource;

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(148);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _checkDecoratorArguments = __webpack_require__(273);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

var _decorateHandler = __webpack_require__(626);

var _decorateHandler2 = _interopRequireDefault(_decorateHandler);

var _registerSource = __webpack_require__(2238);

var _registerSource2 = _interopRequireDefault(_registerSource);

var _createSourceFactory = __webpack_require__(2239);

var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);

var _createSourceMonitor = __webpack_require__(2240);

var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);

var _createSourceConnector = __webpack_require__(2241);

var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);

var _isValidType = __webpack_require__(630);

var _isValidType2 = _interopRequireDefault(_isValidType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DragSource(type, spec, collect) {
	var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	_checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
	var getType = type;
	if (typeof type !== 'function') {
		(0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
		getType = function getType() {
			return type;
		};
	}
	(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
	var createSource = (0, _createSourceFactory2.default)(spec);
	(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);

	return function decorateSource(DecoratedComponent) {
		return (0, _decorateHandler2.default)({
			connectBackend: function connectBackend(backend, sourceId) {
				return backend.connectDragSource(sourceId);
			},
			containerDisplayName: 'DragSource',
			createHandler: createSource,
			registerHandler: _registerSource2.default,
			createMonitor: _createSourceMonitor2.default,
			createConnector: _createSourceConnector2.default,
			DecoratedComponent: DecoratedComponent,
			getType: getType,
			collect: collect,
			options: options
		});
	};
}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = isDisposable;

function isDisposable(obj) {
  return Boolean(obj && typeof obj.dispose === 'function');
}

module.exports = exports['default'];

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
	if (objA === objB) {
		return true;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	// Test for A's keys different from B.
	var hasOwn = Object.prototype.hasOwnProperty;
	for (var i = 0; i < keysA.length; i += 1) {
		if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
			return false;
		}

		var valA = objA[keysA[i]];
		var valB = objB[keysA[i]];

		if (valA !== valB) {
			return false;
		}
	}

	return true;
}

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = DropTarget;

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(148);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _checkDecoratorArguments = __webpack_require__(273);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

var _decorateHandler = __webpack_require__(626);

var _decorateHandler2 = _interopRequireDefault(_decorateHandler);

var _registerTarget = __webpack_require__(2243);

var _registerTarget2 = _interopRequireDefault(_registerTarget);

var _createTargetFactory = __webpack_require__(2244);

var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);

var _createTargetMonitor = __webpack_require__(2245);

var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);

var _createTargetConnector = __webpack_require__(2246);

var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);

var _isValidType = __webpack_require__(630);

var _isValidType2 = _interopRequireDefault(_isValidType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropTarget(type, spec, collect) {
	var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	_checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
	var getType = type;
	if (typeof type !== 'function') {
		(0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
		getType = function getType() {
			return type;
		};
	}
	(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
	var createTarget = (0, _createTargetFactory2.default)(spec);
	(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);

	return function decorateTarget(DecoratedComponent) {
		return (0, _decorateHandler2.default)({
			connectBackend: function connectBackend(backend, targetId) {
				return backend.connectDropTarget(targetId);
			},
			containerDisplayName: 'DropTarget',
			createHandler: createTarget,
			registerHandler: _registerTarget2.default,
			createMonitor: _createTargetMonitor2.default,
			createConnector: _createTargetConnector2.default,
			DecoratedComponent: DecoratedComponent,
			getType: getType,
			collect: collect,
			options: options
		});
	};
}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(2254);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 410 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = DragLayer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(38);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(201);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _isPlainObject = __webpack_require__(148);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _shallowEqual = __webpack_require__(407);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _shallowEqualScalar = __webpack_require__(627);

var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);

var _checkDecoratorArguments = __webpack_require__(273);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function DragLayer(collect) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	_checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
	(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);

	return function decorateLayer(DecoratedComponent) {
		var _class, _temp;

		var _options$arePropsEqua = options.arePropsEqual,
		    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;

		var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

		var DragLayerContainer = (_temp = _class = function (_Component) {
			_inherits(DragLayerContainer, _Component);

			_createClass(DragLayerContainer, [{
				key: 'getDecoratedComponentInstance',
				value: function getDecoratedComponentInstance() {
					(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
					return this.child;
				}
			}, {
				key: 'shouldComponentUpdate',
				value: function shouldComponentUpdate(nextProps, nextState) {
					return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
				}
			}]);

			function DragLayerContainer(props, context) {
				_classCallCheck(this, DragLayerContainer);

				var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));

				_this.handleChange = _this.handleChange.bind(_this);

				_this.manager = context.dragDropManager;
				(0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

				_this.state = _this.getCurrentState();
				return _this;
			}

			_createClass(DragLayerContainer, [{
				key: 'componentDidMount',
				value: function componentDidMount() {
					this.isCurrentlyMounted = true;

					var monitor = this.manager.getMonitor();
					this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
					this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);

					this.handleChange();
				}
			}, {
				key: 'componentWillUnmount',
				value: function componentWillUnmount() {
					this.isCurrentlyMounted = false;

					this.unsubscribeFromOffsetChange();
					this.unsubscribeFromStateChange();
				}
			}, {
				key: 'handleChange',
				value: function handleChange() {
					if (!this.isCurrentlyMounted) {
						return;
					}

					var nextState = this.getCurrentState();
					if (!(0, _shallowEqual2.default)(nextState, this.state)) {
						this.setState(nextState);
					}
				}
			}, {
				key: 'getCurrentState',
				value: function getCurrentState() {
					var monitor = this.manager.getMonitor();
					return collect(monitor, this.props);
				}
			}, {
				key: 'render',
				value: function render() {
					var _this2 = this;

					return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
						ref: function ref(child) {
							_this2.child = child;
						}
					}));
				}
			}]);

			return DragLayerContainer;
		}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
			dragDropManager: _propTypes2.default.object.isRequired
		}, _temp);


		return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
	};
}

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Portal__ = __webpack_require__(647);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={bubble:'_dz',padded:'_dA',active:'_dB',arrowTop:'_dC',arrowBottom:'_dD'};function getClientSize(){var w=window;var d=document;var e=d.documentElement;var g=d.getElementsByTagName('body')[0];var width=w.innerWidth||e.clientWidth||g.clientWidth;var height=w.innerHeight||e.clientHeight||g.clientHeight;return{width:width,height:height};}function elementWilFit(el,elHeight){var _getClientSize=getClientSize(),screenHeight=_getClientSize.height;var top=el.offsetTop;var height=el.offsetHeight;while(el.offsetParent){el=el.offsetParent;top+=el.offsetTop;}return top>=window.pageYOffset&&top+height+elHeight<=window.pageYOffset+screenHeight;}var Tooltip=function(_Component){_inherits(Tooltip,_Component);function Tooltip(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Tooltip);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Tooltip.__proto__||Object.getPrototypeOf(Tooltip)).call.apply(_ref,[this].concat(args))),_this),_this.state={top:null,left:null,arrowPosition:'Top'},_this.handleMount=function(portal){var anchorTo=_this.props.anchorTo;_this._anchor=anchorTo();_this._portal=portal;_this.position();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Tooltip,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.position();}},{key:'getTooltipStyle',value:function getTooltipStyle(){var _state=this.state,top=_state.top,left=_state.left;var width=this.props.width;return{width:width,transform:'translate3d( '+(left||0)+'px, '+(top||0)+'px, 0px)'};}},{key:'getPosition',value:function getPosition(){var getPosition=this.props.getPosition;var rect=this._anchor.getBoundingClientRect();var ownRect=this._portal.getBoundingClientRect();if(getPosition){return getPosition(rect,ownRect);}return this.defaultPosition(rect,ownRect);}},{key:'defaultPosition',value:function defaultPosition(rect,ownRect){var _getClientSize2=getClientSize(),width=_getClientSize2.width,height=_getClientSize2.height;if(elementWilFit(this._anchor,ownRect.height)){return{arrowPosition:'Top',left:rect.left-ownRect.width/2+rect.width/2,top:rect.top+rect.height+__WEBPACK_IMPORTED_MODULE_2_Css__["Units"].base*2};}else{return{arrowPosition:'Bottom',left:rect.left-ownRect.width/2+rect.width/2,top:rect.top-rect.height-__WEBPACK_IMPORTED_MODULE_2_Css__["Units"].base*2-ownRect.height};}}},{key:'position',value:function position(){var _getPosition=this.getPosition(),left=_getPosition.left,top=_getPosition.top,arrowPosition=_getPosition.arrowPosition;if(this.state.left!==left||this.state.top!==top||this.state.arrowPosition!==arrowPosition){this.setState({arrowPosition:arrowPosition,left:left,top:top});}}},{key:'render',value:function render(){var _classNames;var _props=this.props,children=_props.children,style=_props.style,padded=_props.padded,hasArrow=_props.hasArrow,other=_objectWithoutProperties(_props,['children','style','padded','hasArrow']);var _state2=this.state,top=_state2.top,arrowPosition=_state2.arrowPosition;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Portal__["a" /* default */],Object.assign({onMount:this.handleMount,className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.bubble,(_classNames={},_defineProperty(_classNames,css['arrow'+arrowPosition],hasArrow),_defineProperty(_classNames,css.padded,padded),_defineProperty(_classNames,css.active,top!==null),_classNames)),style:this.getTooltipStyle()},other),children);}}]);return Tooltip;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Tooltip.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,anchorTo:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,padded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,getPosition:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,hasArrow:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};Tooltip.defaultProps={padded:true,hasArrow:true,width:256};/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE = exports.FILE = '__NATIVE_FILE__';
var URL = exports.URL = '__NATIVE_URL__';
var TEXT = exports.TEXT = '__NATIVE_TEXT__';

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CSSPropertyOperations = __webpack_require__(74);

var _CSSPropertyOperations2 = _interopRequireDefault(_CSSPropertyOperations);

var _shallowequal = __webpack_require__(81);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  menu: 'cio_gI',
  dialog: 'cio_gJ',
  tooltip: 'cio_gK',
  positioned: 'cio_gL'
};

var isDescendant = function isDescendant(parent, child) {
  var node = child.parentNode;
  while (node !== null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

var Portal = function (_Component) {
  _inherits(Portal, _Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.node = null, _this.handleClickAway = function (event) {
      var onClickAway = _this.props.onClickAway;

      if (!isDescendant(_this.node, event.target)) {
        onClickAway();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Portal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          onMount = _props.onMount,
          onClickAway = _props.onClickAway;

      this.node = document.createElement('div');
      _CSSPropertyOperations2.default.setValueForStyles(this.node, this.props.style);
      document.body.appendChild(this.node);
      this.renderPortal(this.props);
      onMount && onMount(this.node);
      if (onClickAway) {
        document.body.addEventListener('mousedown', this.handleClickAway);
        document.body.addEventListener('touchstart', this.handleClickAway);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.renderPortal(nextProps);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowequal2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var onClickAway = this.props.onClickAway;

      this.closePortal();
      if (onClickAway) {
        document.body.removeEventListener('mousedown', this.handleClickAway);
        document.body.removeEventListener('touchstart', this.handleClickAway);
      }
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      if (this.node) {
        (0, _reactDom.unmountComponentAtNode)(this.node);
        document.body.removeChild(this.node);
      }
      this.node = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      var _classNames;

      var children = props.children,
          style = props.style,
          menu = props.menu,
          positioned = props.positioned,
          dialog = props.dialog,
          tooltip = props.tooltip,
          className = props.className,
          other = _objectWithoutProperties(props, ['children', 'style', 'menu', 'positioned', 'dialog', 'tooltip', 'className']);

      _CSSPropertyOperations2.default.setValueForStyles(this.node, style);
      this.node.className = (0, _classnames2.default)(className, css.root, (_classNames = {}, _defineProperty(_classNames, css.dialog, dialog), _defineProperty(_classNames, css.positioned, positioned), _defineProperty(_classNames, css.menu, menu), _defineProperty(_classNames, css.tooltip, tooltip), _classNames));

      if (children && children.length > 0) {
        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, _react2.default.createElement(
          'div',
          other,
          children
        ), this.node);
      } else if (children) {
        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, _react2.default.Children.only(children), this.node);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(_react.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  style: _react.PropTypes.object,
  onClickAway: _react.PropTypes.func,
  onMount: _react.PropTypes.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_AppContent__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ScrollableContainer__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_3_material_ui__["Styles"].Spacing;var AppPage=function(_Component){_inherits(AppPage,_Component);function AppPage(){_classCallCheck(this,AppPage);return _possibleConstructorReturn(this,(AppPage.__proto__||Object.getPrototypeOf(AppPage)).apply(this,arguments));}_createClass(AppPage,[{key:'getStyle',value:function getStyle(){var left=0;var right=0;// if (this.context.media == 'desktop') {
//   left = Spacing.desktopKeylineIncrement*3;
//   right = Spacing.desktopKeylineIncrement*3;
// } else if (this.context.media == 'tablet') {
//   left = Spacing.desktopKeylineIncrement*2;
//   right = Spacing.desktopKeylineIncrement*2;
// }
return{position:'absolute',left:left,right:right,top:0,bottom:0,backgroundColor:this.context.muiTheme.rawTheme.palette.cardColor,overflow:'auto',transition:'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'};}},{key:'onScrollToBottom',value:function onScrollToBottom(){if(this.props.onScrollToBottom){this.props.onScrollToBottom();}}},{key:'getToolbarStyle',value:function getToolbarStyle(){var style={backgroundColor:this.context.muiTheme.rawTheme.palette.primary1Color,borderStyle:'none none solid none',borderWidth:'1px',borderColor:'#DDD'};return style;}},{key:'render',value:function render(){var _props=this.props,style=_props.style,header=_props.header,other=_objectWithoutProperties(_props,['style','header']);var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Toolbar"],{style:this.getToolbarStyle()});style=Object.assign(this.getStyle(),style);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative',boxSizing:'border-box',height:'100%'}},toolbar,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Paper"],{zDepth:2,style:this.getStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ScrollableContainer__["a" /* default */],{header:header,onScrollToBottom:this.onScrollToBottom.bind(this)},this.props.children)));}}]);return AppPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AppPage.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (AppPage);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(418);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMTextComponent
 * @typechecks static-only
 */



var DOMChildrenOperations = __webpack_require__(420);
var DOMPropertyOperations = __webpack_require__(281);
var ReactComponentBrowserEnvironment = __webpack_require__(282);
var ReactMount = __webpack_require__(50);

var assign = __webpack_require__(29);
var escapeTextContentForBrowser = __webpack_require__(213);
var setTextContent = __webpack_require__(280);
var validateDOMNesting = __webpack_require__(291);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings in elements so that they can undergo
 * the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (props) {
  // This constructor and its argument is currently used by mocks.
};

assign(ReactDOMTextComponent.prototype, {

  /**
   * @param {ReactText} text
   * @internal
   */
  construct: function (text) {
    // TODO: This is really a ReactText (ReactNode), not a ReactElement
    this._currentElement = text;
    this._stringText = '' + text;

    // Properties
    this._rootNodeID = null;
    this._mountIndex = 0;
  },

  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {string} rootID DOM ID of the root node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (rootID, transaction, context) {
    if (false) {
      if (context[validateDOMNesting.ancestorInfoContextKey]) {
        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
      }
    }

    this._rootNodeID = rootID;
    if (transaction.useCreateElement) {
      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
      var el = ownerDocument.createElement('span');
      DOMPropertyOperations.setAttributeForID(el, rootID);
      // Populate node cache
      ReactMount.getID(el);
      setTextContent(el, this._stringText);
      return el;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this in a `span` for the reasons stated above, but
        // since this is a situation where React won't take over (static pages),
        // we can simply return the text as it is.
        return escapedText;
      }

      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var node = ReactMount.getNode(this._rootNodeID);
        DOMChildrenOperations.updateTextContent(node, nextStringText);
      }
    }
  },

  unmountComponent: function () {
    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
  }

});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMChildrenOperations
 * @typechecks static-only
 */



var Danger = __webpack_require__(674);
var ReactMultiChildUpdateTypes = __webpack_require__(422);
var ReactPerf = __webpack_require__(72);

var setInnerHTML = __webpack_require__(212);
var setTextContent = __webpack_require__(280);
var invariant = __webpack_require__(20);

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
function insertChildAt(parentNode, childNode, index) {
  // By exploiting arrays returning `undefined` for an undefined index, we can
  // rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. However, using `undefined` is not allowed by all
  // browsers so we must replace it with `null`.

  // fix render order error in safari
  // IE8 will throw error when index out of list size.
  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);

  parentNode.insertBefore(childNode, beforeChild);
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {

  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,

  updateTextContent: setTextContent,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @param {array<string>} markupList List of markup strings.
   * @internal
   */
  processUpdates: function (updates, markupList) {
    var update;
    // Mapping from parent IDs to initial child orderings.
    var initialChildren = null;
    // List of children that will be moved or removed.
    var updatedChildren = null;

    for (var i = 0; i < updates.length; i++) {
      update = updates[i];
      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
        var updatedIndex = update.fromIndex;
        var updatedChild = update.parentNode.childNodes[updatedIndex];
        var parentID = update.parentID;

        !updatedChild ?  false ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;

        initialChildren = initialChildren || {};
        initialChildren[parentID] = initialChildren[parentID] || [];
        initialChildren[parentID][updatedIndex] = updatedChild;

        updatedChildren = updatedChildren || [];
        updatedChildren.push(updatedChild);
      }
    }

    var renderedMarkup;
    // markupList is either a list of markup or just a list of elements
    if (markupList.length && typeof markupList[0] === 'string') {
      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
    } else {
      renderedMarkup = markupList;
    }

    // Remove updated children first so that `toIndex` is consistent.
    if (updatedChildren) {
      for (var j = 0; j < updatedChildren.length; j++) {
        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
      }
    }

    for (var k = 0; k < updates.length; k++) {
      update = updates[k];
      switch (update.type) {
        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
          break;
        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
          break;
        case ReactMultiChildUpdateTypes.SET_MARKUP:
          setInnerHTML(update.parentNode, update.content);
          break;
        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
          setTextContent(update.parentNode, update.content);
          break;
        case ReactMultiChildUpdateTypes.REMOVE_NODE:
          // Already removed by the for-loop above.
          break;
      }
    }
  }

};

ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
  updateTextContent: 'updateTextContent'
});

module.exports = DOMChildrenOperations;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(45);

var invariant = __webpack_require__(20);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMultiChildUpdateTypes
 */



var keyMirror = __webpack_require__(211);

/**
 * When a component's children are updated, a series of update configuration
 * objects are created in order to batch and serialize the required changes.
 *
 * Enumerates all the possible types of update configurations.
 *
 * @internal
 */
var ReactMultiChildUpdateTypes = keyMirror({
  INSERT_MARKUP: null,
  MOVE_EXISTING: null,
  REMOVE_NODE: null,
  SET_MARKUP: null,
  TEXT_CONTENT: null
});

module.exports = ReactMultiChildUpdateTypes;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginRegistry
 * @typechecks static-only
 */



var invariant = __webpack_require__(20);

/**
 * Injectable ordering of event plugins.
 */
var EventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!EventPluginOrder) {
    // Wait until an `EventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var PluginModule = namesToPlugins[pluginName];
    var pluginIndex = EventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
    var publishedEvents = PluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, PluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {

  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (InjectedEventPluginOrder) {
    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
    // Clone the ordering so it cannot be dynamically mutated.
    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var PluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
        namesToPlugins[pluginName] = PluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    for (var phase in dispatchConfig.phasedRegistrationNames) {
      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
        continue;
      }
      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
      if (PluginModule) {
        return PluginModule;
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    EventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }
  }

};

module.exports = EventPluginRegistry;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginUtils
 */



var EventConstants = __webpack_require__(84);
var ReactErrorUtils = __webpack_require__(425);

var invariant = __webpack_require__(20);
var warning = __webpack_require__(33);

/**
 * Injected dependencies:
 */

/**
 * - `Mount`: [required] Module that can convert between React dom IDs and
 *   actual node references.
 */
var injection = {
  Mount: null,
  injectMount: function (InjectedMount) {
    injection.Mount = InjectedMount;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
    }
  }
};

var topLevelTypes = EventConstants.topLevelTypes;

function isEndish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
}

function isMoveish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
}
function isStartish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchIDs = event._dispatchIDs;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var idsIsArr = Array.isArray(dispatchIDs);
    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {string} domID DOM id to pass to the callback.
 */
function executeDispatch(event, simulated, listener, domID) {
  var type = event.type || 'unknown-event';
  event.currentTarget = injection.Mount.getNode(domID);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchIDs = event._dispatchIDs;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and IDs are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
  }
  event._dispatchListeners = null;
  event._dispatchIDs = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchIDs = event._dispatchIDs;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and IDs are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchIDs[i])) {
        return dispatchIDs[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchIDs)) {
      return dispatchIDs;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchIDs = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchID = event._dispatchIDs;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
  event._dispatchListeners = null;
  event._dispatchIDs = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getNode: function (id) {
    return injection.Mount.getNode(id);
  },
  getID: function (node) {
    return injection.Mount.getID(node);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactErrorUtils
 * @typechecks
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {?String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a, b) {
  try {
    return func(a, b);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
    return undefined;
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof Event === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
      var boundFunc = func.bind(null, a, b);
      fakeNode.addEventListener(name, boundFunc, false);
      fakeNode.dispatchEvent(new Event(name));
      fakeNode.removeEventListener(name, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule accumulateInto
 */



var invariant = __webpack_require__(20);

/**
 *
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  var currentIsArray = Array.isArray(current);
  var nextIsArray = Array.isArray(next);

  if (currentIsArray && nextIsArray) {
    current.push.apply(current, next);
    return current;
  }

  if (currentIsArray) {
    current.push(next);
    return current;
  }

  if (nextIsArray) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule forEachAccumulated
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */
var forEachAccumulated = function (arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
};

module.exports = forEachAccumulated;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMFeatureFlags
 */



var ReactDOMFeatureFlags = {
  useCreateElement: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEmptyComponentRegistry
 */



// This registry keeps track of the React IDs of the components that rendered to
// `null` (in reality a placeholder such as `noscript`)
var nullComponentIDsRegistry = {};

/**
 * @param {string} id Component's `_rootNodeID`.
 * @return {boolean} True if the component is rendered to null.
 */
function isNullComponentID(id) {
  return !!nullComponentIDsRegistry[id];
}

/**
 * Mark the component as having rendered to null.
 * @param {string} id Component's `_rootNodeID`.
 */
function registerNullComponentID(id) {
  nullComponentIDsRegistry[id] = true;
}

/**
 * Unmark the component as having rendered to null: it renders to something now.
 * @param {string} id Component's `_rootNodeID`.
 */
function deregisterNullComponentID(id) {
  delete nullComponentIDsRegistry[id];
}

var ReactEmptyComponentRegistry = {
  isNullComponentID: isNullComponentID,
  registerNullComponentID: registerNullComponentID,
  deregisterNullComponentID: deregisterNullComponentID
};

module.exports = ReactEmptyComponentRegistry;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactRootIndex
 * @typechecks
 */



var ReactRootIndexInjection = {
  /**
   * @param {function} _createReactRootIndex
   */
  injectCreateReactRootIndex: function (_createReactRootIndex) {
    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
  }
};

var ReactRootIndex = {
  createReactRootIndex: null,
  injection: ReactRootIndexInjection
};

module.exports = ReactRootIndex;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMarkupChecksum
 */



var adler32 = __webpack_require__(679);

var TAG_END = /\/?>/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags and self-closing tags)
    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(682);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEmptyComponent
 */



var ReactElement = __webpack_require__(51);
var ReactEmptyComponentRegistry = __webpack_require__(429);
var ReactReconciler = __webpack_require__(120);

var assign = __webpack_require__(29);

var placeholderElement;

var ReactEmptyComponentInjection = {
  injectEmptyComponent: function (component) {
    placeholderElement = ReactElement.createElement(component);
  }
};

var ReactEmptyComponent = function (instantiate) {
  this._currentElement = null;
  this._rootNodeID = null;
  this._renderedComponent = instantiate(placeholderElement);
};
assign(ReactEmptyComponent.prototype, {
  construct: function (element) {},
  mountComponent: function (rootID, transaction, context) {
    ReactEmptyComponentRegistry.registerNullComponentID(rootID);
    this._rootNodeID = rootID;
    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
  },
  receiveComponent: function () {},
  unmountComponent: function (rootID, transaction, context) {
    ReactReconciler.unmountComponent(this._renderedComponent);
    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
    this._rootNodeID = null;
    this._renderedComponent = null;
  }
});

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactNativeComponent
 */



var assign = __webpack_require__(29);
var invariant = __webpack_require__(20);

var autoGenerateWrapperClass = null;
var genericComponentClass = null;
// This registry keeps track of wrapper classes around native tags.
var tagToComponentClass = {};
var textComponentClass = null;

var ReactNativeComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  },
  // This accepts a keyed object with classes as values. Each key represents a
  // tag. That particular tag will use this class instead of the generic one.
  injectComponentClasses: function (componentClasses) {
    assign(tagToComponentClass, componentClasses);
  }
};

/**
 * Get a composite component wrapper class for a specific tag.
 *
 * @param {ReactElement} element The tag for which to get the class.
 * @return {function} The React class constructor function.
 */
function getComponentClassForElement(element) {
  if (typeof element.type === 'function') {
    return element.type;
  }
  var tag = element.type;
  var componentClass = tagToComponentClass[tag];
  if (componentClass == null) {
    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
  }
  return componentClass;
}

/**
 * Get a native internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
  return new genericComponentClass(element.type, element.props);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactNativeComponent = {
  getComponentClassForElement: getComponentClassForElement,
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactNativeComponentInjection
};

module.exports = ReactNativeComponent;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDefaultInjection
 */



var BeforeInputEventPlugin = __webpack_require__(685);
var ChangeEventPlugin = __webpack_require__(689);
var ClientReactRootIndex = __webpack_require__(690);
var DefaultEventPluginOrder = __webpack_require__(691);
var EnterLeaveEventPlugin = __webpack_require__(692);
var ExecutionEnvironment = __webpack_require__(45);
var HTMLDOMPropertyConfig = __webpack_require__(693);
var ReactBrowserComponentMixin = __webpack_require__(694);
var ReactComponentBrowserEnvironment = __webpack_require__(282);
var ReactDefaultBatchingStrategy = __webpack_require__(438);
var ReactDOMComponent = __webpack_require__(695);
var ReactDOMTextComponent = __webpack_require__(419);
var ReactEventListener = __webpack_require__(709);
var ReactInjection = __webpack_require__(711);
var ReactInstanceHandles = __webpack_require__(152);
var ReactMount = __webpack_require__(50);
var ReactReconcileTransaction = __webpack_require__(712);
var SelectEventPlugin = __webpack_require__(715);
var ServerReactRootIndex = __webpack_require__(716);
var SimpleEventPlugin = __webpack_require__(717);
var SVGDOMPropertyConfig = __webpack_require__(725);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
  ReactInjection.EventPluginHub.injectMount(ReactMount);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);

  if (false) {
    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
    if (/[?&]react_perf\b/.test(url)) {
      var ReactDefaultPerf = require('./ReactDefaultPerf');
      ReactDefaultPerf.start();
    }
  }
}

module.exports = {
  inject: inject
};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getTextContentAccessor
 */



var ExecutionEnvironment = __webpack_require__(45);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isTextInputElement
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */
var supportedInputTypes = {
  'color': true,
  'date': true,
  'datetime': true,
  'datetime-local': true,
  'email': true,
  'month': true,
  'number': true,
  'password': true,
  'range': true,
  'search': true,
  'tel': true,
  'text': true,
  'time': true,
  'url': true,
  'week': true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
}

module.exports = isTextInputElement;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDefaultBatchingStrategy
 */



var ReactUpdates = __webpack_require__(73);
var Transaction = __webpack_require__(215);

var assign = __webpack_require__(29);
var emptyFunction = __webpack_require__(57);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      callback(a, b, c, d, e);
    } else {
      transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSProperty
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */
var isUnitlessNumber = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypes
 */



var ReactElement = __webpack_require__(51);
var ReactPropTypeLocationNames = __webpack_require__(217);

var emptyFunction = __webpack_require__(57);
var getIteratorFn = __webpack_require__(296);

/**
 * Collection of methods that allow declaration and validation of props that are
 * supplied to React components. Example usage:
 *
 *   var Props = require('ReactPropTypes');
 *   var MyArticle = React.createClass({
 *     propTypes: {
 *       // An optional string prop named "description".
 *       description: Props.string,
 *
 *       // A required enum prop named "category".
 *       category: Props.oneOf(['News','Photos']).isRequired,
 *
 *       // A prop named "dialog" that requires an instance of Dialog.
 *       dialog: Props.instanceOf(Dialog).isRequired
 *     },
 *     render: function() { ... }
 *   });
 *
 * A more formal specification of how these methods are used:
 *
 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
 *   decl := ReactPropTypes.{type}(.isRequired)?
 *
 * Each and every declaration produces a function with the same signature. This
 * allows the creation of custom validation functions. For example:
 *
 *  var MyLink = React.createClass({
 *    propTypes: {
 *      // An optional string or URI prop named "href".
 *      href: function(props, propName, componentName) {
 *        var propValue = props[propName];
 *        if (propValue != null && typeof propValue !== 'string' &&
 *            !(propValue instanceof URI)) {
 *          return new Error(
 *            'Expected a string or an URI for ' + propName + ' in ' +
 *            componentName
 *          );
 *        }
 *      }
 *    },
 *    render: function() {...}
 *  });
 *
 * @internal
 */

var ANONYMOUS = '<<anonymous>>';

var ReactPropTypes = {
  array: createPrimitiveTypeChecker('array'),
  bool: createPrimitiveTypeChecker('boolean'),
  func: createPrimitiveTypeChecker('function'),
  number: createPrimitiveTypeChecker('number'),
  object: createPrimitiveTypeChecker('object'),
  string: createPrimitiveTypeChecker('string'),

  any: createAnyTypeChecker(),
  arrayOf: createArrayOfTypeChecker,
  element: createElementTypeChecker(),
  instanceOf: createInstanceTypeChecker,
  node: createNodeChecker(),
  objectOf: createObjectOfTypeChecker,
  oneOf: createEnumTypeChecker,
  oneOfType: createUnionTypeChecker,
  shape: createShapeTypeChecker
};

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    componentName = componentName || ANONYMOUS;
    propFullName = propFullName || propName;
    if (props[propName] == null) {
      var locationName = ReactPropTypeLocationNames[location];
      if (isRequired) {
        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
      }
      return null;
    } else {
      return validate(props, propName, componentName, location, propFullName);
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createPrimitiveTypeChecker(expectedType) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== expectedType) {
      var locationName = ReactPropTypeLocationNames[location];
      // `propValue` being instance of, say, date/regexp, pass the 'object'
      // check, but we can offer a more precise error message here rather than
      // 'of type `object`'.
      var preciseType = getPreciseType(propValue);

      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createAnyTypeChecker() {
  return createChainableTypeChecker(emptyFunction.thatReturns(null));
}

function createArrayOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!Array.isArray(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
    }
    for (var i = 0; i < propValue.length; i++) {
      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
      if (error instanceof Error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createElementTypeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    if (!ReactElement.isValidElement(props[propName])) {
      var locationName = ReactPropTypeLocationNames[location];
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createInstanceTypeChecker(expectedClass) {
  function validate(props, propName, componentName, location, propFullName) {
    if (!(props[propName] instanceof expectedClass)) {
      var locationName = ReactPropTypeLocationNames[location];
      var expectedClassName = expectedClass.name || ANONYMOUS;
      var actualClassName = getClassName(props[propName]);
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createEnumTypeChecker(expectedValues) {
  if (!Array.isArray(expectedValues)) {
    return createChainableTypeChecker(function () {
      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
    });
  }

  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    for (var i = 0; i < expectedValues.length; i++) {
      if (propValue === expectedValues[i]) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    var valuesString = JSON.stringify(expectedValues);
    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
  }
  return createChainableTypeChecker(validate);
}

function createObjectOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
    }
    for (var key in propValue) {
      if (propValue.hasOwnProperty(key)) {
        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
        if (error instanceof Error) {
          return error;
        }
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createUnionTypeChecker(arrayOfTypeCheckers) {
  if (!Array.isArray(arrayOfTypeCheckers)) {
    return createChainableTypeChecker(function () {
      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
    });
  }

  function validate(props, propName, componentName, location, propFullName) {
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (checker(props, propName, componentName, location, propFullName) == null) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
  }
  return createChainableTypeChecker(validate);
}

function createNodeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    if (!isNode(props[propName])) {
      var locationName = ReactPropTypeLocationNames[location];
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createShapeTypeChecker(shapeTypes) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
    }
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
      if (error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function isNode(propValue) {
  switch (typeof propValue) {
    case 'number':
    case 'string':
    case 'undefined':
      return true;
    case 'boolean':
      return !propValue;
    case 'object':
      if (Array.isArray(propValue)) {
        return propValue.every(isNode);
      }
      if (propValue === null || ReactElement.isValidElement(propValue)) {
        return true;
      }

      var iteratorFn = getIteratorFn(propValue);
      if (iteratorFn) {
        var iterator = iteratorFn.call(propValue);
        var step;
        if (iteratorFn !== propValue.entries) {
          while (!(step = iterator.next()).done) {
            if (!isNode(step.value)) {
              return false;
            }
          }
        } else {
          // Iterator will provide entry [k,v] tuples rather than values.
          while (!(step = iterator.next()).done) {
            var entry = step.value;
            if (entry) {
              if (!isNode(entry[1])) {
                return false;
              }
            }
          }
        }
      } else {
        return false;
      }

      return true;
    default:
      return false;
  }
}

// Equivalent of `typeof` but with special handling for array and regexp.
function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return 'array';
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return 'object';
  }
  return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// See `createPrimitiveTypeChecker`.
function getPreciseType(propValue) {
  var propType = getPropType(propValue);
  if (propType === 'object') {
    if (propValue instanceof Date) {
      return 'date';
    } else if (propValue instanceof RegExp) {
      return 'regexp';
    }
  }
  return propType;
}

// Returns class name of the object, if any.
function getClassName(propValue) {
  if (!propValue.constructor || !propValue.constructor.name) {
    return '<<anonymous>>';
  }
  return propValue.constructor.name;
}

module.exports = ReactPropTypes;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMSelect
 */



var LinkedValueUtils = __webpack_require__(295);
var ReactMount = __webpack_require__(50);
var ReactUpdates = __webpack_require__(73);

var assign = __webpack_require__(29);
var warning = __webpack_require__(33);

var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, props, value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    if (props.multiple) {
       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
    } else {
       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactMount.getNode(inst._rootNodeID).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> native component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  valueContextKey: valueContextKey,

  getNativeProps: function (inst, props, context) {
    return assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };
  },

  processChildContext: function (inst, props, context) {
    // Pass down initial value so initial generated markup has correct
    // `selected` attributes
    var childContext = assign({}, context);
    childContext[valueContextKey] = inst._wrapperState.initialValue;
    return childContext;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // the context value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  this._wrapperState.pendingUpdate = true;
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule flattenChildren
 */



var traverseAllChildren = __webpack_require__(298);
var warning = __webpack_require__(33);

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 */
function flattenSingleChildIntoContext(traverseContext, child, name) {
  // We found a component instance.
  var result = traverseContext;
  var keyUnique = result[name] === undefined;
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
  }
  if (keyUnique && child != null) {
    result[name] = child;
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children) {
  if (children == null) {
    return children;
  }
  var result = {};
  traverseAllChildren(children, flattenSingleChildIntoContext, result);
  return result;
}

module.exports = flattenChildren;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(57);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactClass
 */



var ReactComponent = __webpack_require__(446);
var ReactElement = __webpack_require__(51);
var ReactPropTypeLocations = __webpack_require__(216);
var ReactPropTypeLocationNames = __webpack_require__(217);
var ReactNoopUpdateQueue = __webpack_require__(447);

var assign = __webpack_require__(29);
var emptyObject = __webpack_require__(153);
var invariant = __webpack_require__(20);
var keyMirror = __webpack_require__(211);
var keyOf = __webpack_require__(85);
var warning = __webpack_require__(33);

var MIXINS_KEY = keyOf({ mixins: null });

/**
 * Policies that describe methods in `ReactClassInterface`.
 */
var SpecPolicy = keyMirror({
  /**
   * These methods may be defined only once by the class specification or mixin.
   */
  DEFINE_ONCE: null,
  /**
   * These methods may be defined by both the class specification and mixins.
   * Subsequent definitions will be chained. These methods must return void.
   */
  DEFINE_MANY: null,
  /**
   * These methods are overriding the base class.
   */
  OVERRIDE_BASE: null,
  /**
   * These methods are similar to DEFINE_MANY, except we assume they return
   * objects. We try to merge the keys of the return values of all the mixed in
   * functions. If there is a key conflict we throw.
   */
  DEFINE_MANY_MERGED: null
});

var injectedMixins = [];

var warnedSetProps = false;
function warnSetProps() {
  if (!warnedSetProps) {
    warnedSetProps = true;
     false ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
  }
}

/**
 * Composite components are higher-level components that compose other composite
 * or native components.
 *
 * To create a new type of `ReactClass`, pass a specification of
 * your new class to `React.createClass`. The only requirement of your class
 * specification is that you implement a `render` method.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return <div>Hello World</div>;
 *     }
 *   });
 *
 * The class specification supports a specific protocol of methods that have
 * special meaning (e.g. `render`). See `ReactClassInterface` for
 * more the comprehensive protocol. Any other properties and methods in the
 * class specification will be available on the prototype.
 *
 * @interface ReactClassInterface
 * @internal
 */
var ReactClassInterface = {

  /**
   * An array of Mixin objects to include when defining your component.
   *
   * @type {array}
   * @optional
   */
  mixins: SpecPolicy.DEFINE_MANY,

  /**
   * An object containing properties and methods that should be defined on
   * the component's constructor instead of its prototype (static methods).
   *
   * @type {object}
   * @optional
   */
  statics: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of prop types for this component.
   *
   * @type {object}
   * @optional
   */
  propTypes: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of context types for this component.
   *
   * @type {object}
   * @optional
   */
  contextTypes: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of context types this component sets for its children.
   *
   * @type {object}
   * @optional
   */
  childContextTypes: SpecPolicy.DEFINE_MANY,

  // ==== Definition methods ====

  /**
   * Invoked when the component is mounted. Values in the mapping will be set on
   * `this.props` if that prop is not specified (i.e. using an `in` check).
   *
   * This method is invoked before `getInitialState` and therefore cannot rely
   * on `this.state` or use `this.setState`.
   *
   * @return {object}
   * @optional
   */
  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * Invoked once before the component is mounted. The return value will be used
   * as the initial value of `this.state`.
   *
   *   getInitialState: function() {
   *     return {
   *       isOn: false,
   *       fooBaz: new BazFoo()
   *     }
   *   }
   *
   * @return {object}
   * @optional
   */
  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * @return {object}
   * @optional
   */
  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * Uses props from `this.props` and state from `this.state` to render the
   * structure of the component.
   *
   * No guarantees are made about when or how often this method is invoked, so
   * it must not have side effects.
   *
   *   render: function() {
   *     var name = this.props.name;
   *     return <div>Hello, {name}!</div>;
   *   }
   *
   * @return {ReactComponent}
   * @nosideeffects
   * @required
   */
  render: SpecPolicy.DEFINE_ONCE,

  // ==== Delegate methods ====

  /**
   * Invoked when the component is initially created and about to be mounted.
   * This may have side effects, but any external subscriptions or data created
   * by this method must be cleaned up in `componentWillUnmount`.
   *
   * @optional
   */
  componentWillMount: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component has been mounted and has a DOM representation.
   * However, there is no guarantee that the DOM node is in the document.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been mounted (initialized and rendered) for the first time.
   *
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidMount: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked before the component receives new props.
   *
   * Use this as an opportunity to react to a prop transition by updating the
   * state using `this.setState`. Current props are accessed via `this.props`.
   *
   *   componentWillReceiveProps: function(nextProps, nextContext) {
   *     this.setState({
   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
   *     });
   *   }
   *
   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
   * transition may cause a state change, but the opposite is not true. If you
   * need it, you are probably looking for `componentWillUpdate`.
   *
   * @param {object} nextProps
   * @optional
   */
  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked while deciding if the component should be updated as a result of
   * receiving new props, state and/or context.
   *
   * Use this as an opportunity to `return false` when you're certain that the
   * transition to the new props/state/context will not require a component
   * update.
   *
   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
   *     return !equal(nextProps, this.props) ||
   *       !equal(nextState, this.state) ||
   *       !equal(nextContext, this.context);
   *   }
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @return {boolean} True if the component should update.
   * @optional
   */
  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,

  /**
   * Invoked when the component is about to update due to a transition from
   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
   * and `nextContext`.
   *
   * Use this as an opportunity to perform preparation before an update occurs.
   *
   * NOTE: You **cannot** use `this.setState()` in this method.
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @param {ReactReconcileTransaction} transaction
   * @optional
   */
  componentWillUpdate: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component's DOM representation has been updated.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been updated.
   *
   * @param {object} prevProps
   * @param {?object} prevState
   * @param {?object} prevContext
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidUpdate: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component is about to be removed from its parent and have
   * its DOM representation destroyed.
   *
   * Use this as an opportunity to deallocate any external resources.
   *
   * NOTE: There is no `componentDidUnmount` since your component will have been
   * destroyed by that point.
   *
   * @optional
   */
  componentWillUnmount: SpecPolicy.DEFINE_MANY,

  // ==== Advanced methods ====

  /**
   * Updates the component's currently mounted DOM representation.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   * @overridable
   */
  updateComponent: SpecPolicy.OVERRIDE_BASE

};

/**
 * Mapping from class specification keys to special processing functions.
 *
 * Although these are declared like instance properties in the specification
 * when defining classes using `React.createClass`, they are actually static
 * and are accessible on the constructor instead of the prototype. Despite
 * being static, they must be defined outside of the "statics" key under
 * which all other static methods are defined.
 */
var RESERVED_SPEC_KEYS = {
  displayName: function (Constructor, displayName) {
    Constructor.displayName = displayName;
  },
  mixins: function (Constructor, mixins) {
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        mixSpecIntoComponent(Constructor, mixins[i]);
      }
    }
  },
  childContextTypes: function (Constructor, childContextTypes) {
    if (false) {
      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
    }
    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
  },
  contextTypes: function (Constructor, contextTypes) {
    if (false) {
      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
    }
    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
  },
  /**
   * Special case getDefaultProps which should move into statics but requires
   * automatic merging.
   */
  getDefaultProps: function (Constructor, getDefaultProps) {
    if (Constructor.getDefaultProps) {
      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
    } else {
      Constructor.getDefaultProps = getDefaultProps;
    }
  },
  propTypes: function (Constructor, propTypes) {
    if (false) {
      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
    }
    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
  },
  statics: function (Constructor, statics) {
    mixStaticSpecIntoComponent(Constructor, statics);
  },
  autobind: function () {} };

// noop
function validateTypeDef(Constructor, typeDef, location) {
  for (var propName in typeDef) {
    if (typeDef.hasOwnProperty(propName)) {
      // use a warning instead of an invariant so components
      // don't show up in prod but not in __DEV__
       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
    }
  }
}

function validateMethodOverride(proto, name) {
  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

  // Disallow overriding of base class methods unless explicitly allowed.
  if (ReactClassMixin.hasOwnProperty(name)) {
    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
  }

  // Disallow defining methods more than once unless explicitly allowed.
  if (proto.hasOwnProperty(name)) {
    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
  }
}

/**
 * Mixin helper which handles policy validation and reserved
 * specification keys when building React classses.
 */
function mixSpecIntoComponent(Constructor, spec) {
  if (!spec) {
    return;
  }

  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;

  var proto = Constructor.prototype;

  // By handling mixins before any other properties, we ensure the same
  // chaining order is applied to methods with DEFINE_MANY policy, whether
  // mixins are listed before or after these methods in the spec.
  if (spec.hasOwnProperty(MIXINS_KEY)) {
    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
  }

  for (var name in spec) {
    if (!spec.hasOwnProperty(name)) {
      continue;
    }

    if (name === MIXINS_KEY) {
      // We have already handled mixins in a special case above.
      continue;
    }

    var property = spec[name];
    validateMethodOverride(proto, name);

    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
      RESERVED_SPEC_KEYS[name](Constructor, property);
    } else {
      // Setup methods on prototype:
      // The following member methods should not be automatically bound:
      // 1. Expected ReactClass methods (in the "interface").
      // 2. Overridden methods (that were mixed in).
      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
      var isAlreadyDefined = proto.hasOwnProperty(name);
      var isFunction = typeof property === 'function';
      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

      if (shouldAutoBind) {
        if (!proto.__reactAutoBindMap) {
          proto.__reactAutoBindMap = {};
        }
        proto.__reactAutoBindMap[name] = property;
        proto[name] = property;
      } else {
        if (isAlreadyDefined) {
          var specPolicy = ReactClassInterface[name];

          // These cases should already be caught by validateMethodOverride.
          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;

          // For methods which are defined more than once, call the existing
          // methods before calling the new property, merging if appropriate.
          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
            proto[name] = createMergedResultFunction(proto[name], property);
          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
            proto[name] = createChainedFunction(proto[name], property);
          }
        } else {
          proto[name] = property;
          if (false) {
            // Add verbose displayName to the function, which helps when looking
            // at profiling tools.
            if (typeof property === 'function' && spec.displayName) {
              proto[name].displayName = spec.displayName + '_' + name;
            }
          }
        }
      }
    }
  }
}

function mixStaticSpecIntoComponent(Constructor, statics) {
  if (!statics) {
    return;
  }
  for (var name in statics) {
    var property = statics[name];
    if (!statics.hasOwnProperty(name)) {
      continue;
    }

    var isReserved = (name in RESERVED_SPEC_KEYS);
    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;

    var isInherited = (name in Constructor);
    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
    Constructor[name] = property;
  }
}

/**
 * Merge two objects, but throw if both contain the same key.
 *
 * @param {object} one The first object, which is mutated.
 * @param {object} two The second object
 * @return {object} one after it has been mutated to contain everything in two.
 */
function mergeIntoWithNoDuplicateKeys(one, two) {
  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;

  for (var key in two) {
    if (two.hasOwnProperty(key)) {
      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
      one[key] = two[key];
    }
  }
  return one;
}

/**
 * Creates a function that invokes two functions and merges their return values.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createMergedResultFunction(one, two) {
  return function mergedResult() {
    var a = one.apply(this, arguments);
    var b = two.apply(this, arguments);
    if (a == null) {
      return b;
    } else if (b == null) {
      return a;
    }
    var c = {};
    mergeIntoWithNoDuplicateKeys(c, a);
    mergeIntoWithNoDuplicateKeys(c, b);
    return c;
  };
}

/**
 * Creates a function that invokes two functions and ignores their return vales.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createChainedFunction(one, two) {
  return function chainedFunction() {
    one.apply(this, arguments);
    two.apply(this, arguments);
  };
}

/**
 * Binds a method to the component.
 *
 * @param {object} component Component whose method is going to be bound.
 * @param {function} method Method to be bound.
 * @return {function} The bound method.
 */
function bindAutoBindMethod(component, method) {
  var boundMethod = method.bind(component);
  if (false) {
    boundMethod.__reactBoundContext = component;
    boundMethod.__reactBoundMethod = method;
    boundMethod.__reactBoundArguments = null;
    var componentName = component.constructor.displayName;
    var _bind = boundMethod.bind;
    /* eslint-disable block-scoped-var, no-undef */
    boundMethod.bind = function (newThis) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // User is trying to bind() an autobound method; we effectively will
      // ignore the value of "this" that the user is trying to use, so
      // let's warn.
      if (newThis !== component && newThis !== null) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
      } else if (!args.length) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
        return boundMethod;
      }
      var reboundMethod = _bind.apply(boundMethod, arguments);
      reboundMethod.__reactBoundContext = component;
      reboundMethod.__reactBoundMethod = method;
      reboundMethod.__reactBoundArguments = args;
      return reboundMethod;
      /* eslint-enable */
    };
  }
  return boundMethod;
}

/**
 * Binds all auto-bound methods in a component.
 *
 * @param {object} component Component whose method is going to be bound.
 */
function bindAutoBindMethods(component) {
  for (var autoBindKey in component.__reactAutoBindMap) {
    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
      var method = component.__reactAutoBindMap[autoBindKey];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }
}

/**
 * Add more to the ReactClass base class. These are all legacy features and
 * therefore not already part of the modern ReactComponent.
 */
var ReactClassMixin = {

  /**
   * TODO: This will be deprecated because state should always keep a consistent
   * type signature and the only use case for this, is to avoid that.
   */
  replaceState: function (newState, callback) {
    this.updater.enqueueReplaceState(this, newState);
    if (callback) {
      this.updater.enqueueCallback(this, callback);
    }
  },

  /**
   * Checks whether or not this composite component is mounted.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function () {
    return this.updater.isMounted(this);
  },

  /**
   * Sets a subset of the props.
   *
   * @param {object} partialProps Subset of the next props.
   * @param {?function} callback Called after props are updated.
   * @final
   * @public
   * @deprecated
   */
  setProps: function (partialProps, callback) {
    if (false) {
      warnSetProps();
    }
    this.updater.enqueueSetProps(this, partialProps);
    if (callback) {
      this.updater.enqueueCallback(this, callback);
    }
  },

  /**
   * Replace all the props.
   *
   * @param {object} newProps Subset of the next props.
   * @param {?function} callback Called after props are updated.
   * @final
   * @public
   * @deprecated
   */
  replaceProps: function (newProps, callback) {
    if (false) {
      warnSetProps();
    }
    this.updater.enqueueReplaceProps(this, newProps);
    if (callback) {
      this.updater.enqueueCallback(this, callback);
    }
  }
};

var ReactClassComponent = function () {};
assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

/**
 * Module for creating composite components.
 *
 * @class ReactClass
 */
var ReactClass = {

  /**
   * Creates a composite component class given a class specification.
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  createClass: function (spec) {
    var Constructor = function (props, context, updater) {
      // This constructor is overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindMap) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;

      this.state = initialState;
    };
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  },

  injection: {
    injectMixin: function (mixin) {
      injectedMixins.push(mixin);
    }
  }

};

module.exports = ReactClass;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponent
 */



var ReactNoopUpdateQueue = __webpack_require__(447);

var emptyObject = __webpack_require__(153);
var invariant = __webpack_require__(20);
var warning = __webpack_require__(33);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
  }
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback);
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback);
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
    setProps: ['setProps', 'Instead, call render again at the top level.']
  };
  var defineDeprecationWarning = function (methodName, info) {
    try {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
          return undefined;
        }
      });
    } catch (x) {
      // IE will fail on defineProperty (es5-shim/sham too)
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

module.exports = ReactComponent;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactNoopUpdateQueue
 */



var warning = __webpack_require__(33);

function warnTDZ(publicInstance, callerName) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnTDZ(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnTDZ(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnTDZ(publicInstance, 'setState');
  },

  /**
   * Sets a subset of the props.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialProps Subset of the next props.
   * @internal
   */
  enqueueSetProps: function (publicInstance, partialProps) {
    warnTDZ(publicInstance, 'setProps');
  },

  /**
   * Replaces all of the props.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} props New props.
   * @internal
   */
  enqueueReplaceProps: function (publicInstance, props) {
    warnTDZ(publicInstance, 'replaceProps');
  }

};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInputSelection
 */



var ReactDOMSelection = __webpack_require__(713);

var containsNode = __webpack_require__(432);
var focusNode = __webpack_require__(439);
var getActiveElement = __webpack_require__(449);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {

  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (typeof end === 'undefined') {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactElementValidator
 */

/**
 * ReactElementValidator provides a wrapper around a element factory
 * which validates the props passed to the element. This is intended to be
 * used only in DEV and could be replaced by a static type checker for languages
 * that support it.
 */



var ReactElement = __webpack_require__(51);
var ReactPropTypeLocations = __webpack_require__(216);
var ReactPropTypeLocationNames = __webpack_require__(217);
var ReactCurrentOwner = __webpack_require__(99);

var getIteratorFn = __webpack_require__(296);
var invariant = __webpack_require__(20);
var warning = __webpack_require__(33);

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = ReactCurrentOwner.current.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */
var ownerHasKeyUseWarning = {};

var loggedTypeFailures = {};

/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */
function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }
  element._store.validated = true;

  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
  if (addenda === null) {
    // we already showed the warning
    return;
  }
   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
}

/**
 * Shared warning and monitoring code for the key warnings.
 *
 * @internal
 * @param {string} messageType A key used for de-duping warnings.
 * @param {ReactElement} element Component that requires a key.
 * @param {*} parentType element's parent's type.
 * @returns {?object} A set of addenda to use in the warning message, or null
 * if the warning has already been shown before (and shouldn't be shown again).
 */
function getAddendaForKeyUse(messageType, element, parentType) {
  var addendum = getDeclarationErrorAddendum();
  if (!addendum) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
    if (parentName) {
      addendum = ' Check the top-level render call using <' + parentName + '>.';
    }
  }

  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
  if (memoizer[addendum]) {
    return null;
  }
  memoizer[addendum] = true;

  var addenda = {
    parentOrOwner: addendum,
    url: ' See https://fb.me/react-warning-keys for more information.',
    childOwner: null
  };

  // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.
  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
  }

  return addenda;
}

/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */
function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }
  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];
      if (ReactElement.isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (ReactElement.isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);
    // Entry iterators provide implicit keys.
    if (iteratorFn) {
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step;
        while (!(step = iterator.next()).done) {
          if (ReactElement.isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}

/**
 * Assert that the props are valid
 *
 * @param {string} componentName Name of the component for error messages.
 * @param {object} propTypes Map of prop name to a ReactPropType
 * @param {object} props
 * @param {string} location e.g. "prop", "context", "child context"
 * @private
 */
function checkPropTypes(componentName, propTypes, props, location) {
  for (var propName in propTypes) {
    if (propTypes.hasOwnProperty(propName)) {
      var error;
      // Prop type validation may throw. In case they do, we don't want to
      // fail the render phase where it didn't fail before. So we log it.
      // After these have been cleaned up, we'll let them throw.
      try {
        // This is intentionally an invariant that gets caught. It's the same
        // behavior as without this statement except with a better message.
        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
        error = propTypes[propName](props, propName, componentName, location);
      } catch (ex) {
        error = ex;
      }
       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum();
         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
      }
    }
  }
}

/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */
function validatePropTypes(element) {
  var componentClass = element.type;
  if (typeof componentClass !== 'function') {
    return;
  }
  var name = componentClass.displayName || componentClass.name;
  if (componentClass.propTypes) {
    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
  }
  if (typeof componentClass.getDefaultProps === 'function') {
     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
  }
}

var ReactElementValidator = {

  createElement: function (type, props, children) {
    var validType = typeof type === 'string' || typeof type === 'function';
    // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.
     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;

    var element = ReactElement.createElement.apply(this, arguments);

    // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.
    if (element == null) {
      return element;
    }

    // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)
    if (validType) {
      for (var i = 2; i < arguments.length; i++) {
        validateChildKeys(arguments[i], type);
      }
    }

    validatePropTypes(element);

    return element;
  },

  createFactory: function (type) {
    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
    // Legacy hook TODO: Warn if this is accessed
    validatedFactory.type = type;

    if (false) {
      try {
        Object.defineProperty(validatedFactory, 'type', {
          enumerable: false,
          get: function () {
            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
            Object.defineProperty(this, 'type', {
              value: type
            });
            return type;
          }
        });
      } catch (x) {
        // IE will fail on defineProperty (es5-shim/sham too)
      }
    }

    return validatedFactory;
  },

  cloneElement: function (element, props, children) {
    var newElement = ReactElement.cloneElement.apply(this, arguments);
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], newElement.type);
    }
    validatePropTypes(newElement);
    return newElement;
  }

};

module.exports = ReactElementValidator;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule onlyChild
 */


var ReactElement = __webpack_require__(51);

var invariant = __webpack_require__(20);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection. The current implementation of this
 * function assumes that a single child gets passed without a wrapper, but the
 * purpose of this helper function is to abstract away the particular structure
 * of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactComponent} The first and only `ReactComponent` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scope; });
/* harmony export (immutable) */ __webpack_exports__["b"] = addGlobalEventProcessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(37);


/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifiying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._context = {};
    }
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            setTimeout(function () {
                _this._scopeListeners.forEach(function (callback) {
                    callback(_this);
                });
                _this._notifyingListeners = false;
            });
        }
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            var processor = processors[index];
            // tslint:disable-next-line:strict-type-predicates
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event), hint);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["B" /* isThenable */])(result)) {
                    result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(user);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(tags));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, (_a = {}, _a[key] = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(value), _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extra) {
        this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(extra));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, (_a = {}, _a[key] = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(extra), _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(fingerprint);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(level);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransaction = function (transaction) {
        this._transaction = transaction;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (name, context) {
        this._context[name] = context ? Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(context) : undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Internal getter for Span, used in Hub.
     * @hidden
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](scope._breadcrumbs);
            newScope._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._tags);
            newScope._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._extra);
            newScope._context = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._context);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._transaction = scope._transaction;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._context = {};
        this._level = undefined;
        this._transaction = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["K" /* timestampWithMs */])();
        var mergedBreadcrumb = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ timestamp: timestamp }, breadcrumb);
        this._breadcrumbs =
            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
                ? __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](this._breadcrumbs, [Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(mergedBreadcrumb)]).slice(-maxBreadcrumbs)
                : __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](this._breadcrumbs, [Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* normalize */])(mergedBreadcrumb)]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._user, event.user);
        }
        if (this._context && Object.keys(this._context).length) {
            event.contexts = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._context, event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transaction) {
            event.transaction = this._transaction;
        }
        if (this._span) {
            event.contexts = event.contexts || {};
            event.contexts.trace = this._span.getTraceContext();
        }
        this._applyFingerprint(event);
        event.breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */]((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    return Scope;
}());

/**
 * Retruns the global event processors.
 */
function getGlobalEventProcessors() {
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* getGlobalObject */])();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Memo; });
// tslint:disable:no-unsafe-any
/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */
var Memo = /** @class */ (function () {
    function Memo() {
        // tslint:disable-next-line
        this._hasWeakSet = typeof WeakSet === 'function';
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */
    Memo.prototype.memoize = function (obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) {
                return true;
            }
            this._inner.add(obj);
            return false;
        }
        // tslint:disable-next-line:prefer-for-of
        for (var i = 0; i < this._inner.length; i++) {
            var value = this._inner[i];
            if (value === obj) {
                return true;
            }
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */
    Memo.prototype.unmemoize = function (obj) {
        if (this._hasWeakSet) {
            this._inner.delete(obj);
        }
        else {
            for (var i = 0; i < this._inner.length; i++) {
                if (this._inner[i] === obj) {
                    this._inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    return Memo;
}());

//# sourceMappingURL=memo.js.map

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["b"] = fill;
/* harmony export (immutable) */ __webpack_exports__["e"] = urlEncode;
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeToSize;
/* unused harmony export walk */
/* harmony export (immutable) */ __webpack_exports__["c"] = normalize;
/* harmony export (immutable) */ __webpack_exports__["a"] = extractExceptionKeysForMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__memo__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__string__ = __webpack_require__(456);




/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacement A function that should be used to wrap a given method.
 * @returns void
 */
function fill(source, name, replacement) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacement(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    // tslint:disable-next-line:strict-type-predicates
    if (typeof wrapped === 'function') {
        try {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __sentry__: {
                    enumerable: false,
                    value: true,
                },
                __sentry_original__: {
                    enumerable: false,
                    value: original,
                },
                __sentry_wrapped__: {
                    enumerable: false,
                    value: wrapped,
                },
            });
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(
    // tslint:disable-next-line:no-unsafe-any
    function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all it's attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order to be usable by the serializer
 */
function getWalkSource(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["d" /* isError */])(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack,
        };
        for (var i in error) {
            if (Object.prototype.hasOwnProperty.call(error, i)) {
                err[i] = error[i];
            }
        }
        return err;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["f" /* isEvent */])(value)) {
        var event_1 = value;
        var source = {};
        source.type = event_1.type;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            source.target = Object(__WEBPACK_IMPORTED_MODULE_0__is__["c" /* isElement */])(event_1.target)
                ? Object(__WEBPACK_IMPORTED_MODULE_2__misc__["i" /* htmlTreeAsString */])(event_1.target)
                : Object.prototype.toString.call(event_1.target);
        }
        catch (_oO) {
            source.target = '<unknown>';
        }
        try {
            source.currentTarget = Object(__WEBPACK_IMPORTED_MODULE_0__is__["c" /* isElement */])(event_1.currentTarget)
                ? Object(__WEBPACK_IMPORTED_MODULE_2__misc__["i" /* htmlTreeAsString */])(event_1.currentTarget)
                : Object.prototype.toString.call(event_1.currentTarget);
        }
        catch (_oO) {
            source.currentTarget = '<unknown>';
        }
        // tslint:disable-next-line:strict-type-predicates
        if (typeof CustomEvent !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_0__is__["g" /* isInstanceOf */])(value, CustomEvent)) {
            source.detail = event_1.detail;
        }
        for (var i in event_1) {
            if (Object.prototype.hasOwnProperty.call(event_1, i)) {
                source[i] = event_1;
            }
        }
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // tslint:disable-next-line:no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
/** Transforms any input value into a string form, either primitive value or a type of the input */
function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    var normalized = normalizeValue(value);
    return Object(__WEBPACK_IMPORTED_MODULE_0__is__["i" /* isPrimitive */])(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
// tslint:disable-next-line:cyclomatic-complexity
function normalizeValue(value, key) {
    if (key === 'domain' && value && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof global !== 'undefined' && value === global) {
        return '[Global]';
    }
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // React's SyntheticEvent thingy
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["l" /* isSyntheticEvent */])(value)) {
        return '[SyntheticEvent]';
    }
    // tslint:disable-next-line:no-tautology-expression
    if (typeof value === 'number' && value !== value) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + Object(__WEBPACK_IMPORTED_MODULE_2__misc__["f" /* getFunctionName */])(value) + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = new __WEBPACK_IMPORTED_MODULE_1__memo__["a" /* Memo */](); }
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) {
        return serializeValue(value);
    }
    // If value implements `toJSON` method, call it and return early
    // tslint:disable:no-unsafe-any
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    // tslint:enable:no-unsafe-any
    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = normalizeValue(value, key);
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["i" /* isPrimitive */])(normalized)) {
        return normalized;
    }
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
function normalize(input, depth) {
    try {
        // tslint:disable-next-line:no-unsafe-any
        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    // tslint:disable:strict-type-predicates
    var keys = Object.keys(getWalkSource(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__string__["c" /* truncate */])(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_3__string__["c" /* truncate */])(serialized, maxLength);
    }
    return '';
}
//# sourceMappingURL=object.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56)))

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = truncate;
/* unused harmony export snipLine */
/* harmony export (immutable) */ __webpack_exports__["b"] = safeJoin;
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatchingPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(156);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        colno = ll; // tslint:disable-line:no-parameter-reassignment
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["j" /* isRegExp */])(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
//# sourceMappingURL=string.js.map

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyncPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(156);

/** SyncPromise internal states */
var States;
(function (States) {
    /** Pending */
    States["PENDING"] = "PENDING";
    /** Resolved / OK */
    States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */
    States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = States.PENDING;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(States.RESOLVED, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(States.REJECTED, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== States.PENDING) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["m" /* isThenable */])(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */
        this._attachHandler = function (handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === States.PENDING) {
                return;
            }
            if (_this._state === States.REJECTED) {
                _this._handlers.forEach(function (handler) {
                    if (handler.onrejected) {
                        handler.onrejected(_this._value);
                    }
                });
            }
            else {
                _this._handlers.forEach(function (handler) {
                    if (handler.onfulfilled) {
                        // tslint:disable-next-line:no-unsafe-any
                        handler.onfulfilled(_this._value);
                    }
                });
            }
            _this._handlers = [];
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.toString = function () {
        return '[object SyncPromise]';
    };
    /** JSDoc */
    SyncPromise.resolve = function (value) {
        return new SyncPromise(function (resolve) {
            resolve(value);
        });
    };
    /** JSDoc */
    SyncPromise.reject = function (reason) {
        return new SyncPromise(function (_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */
    SyncPromise.all = function (collection) {
        return new SyncPromise(function (resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function (item, index) {
                SyncPromise.resolve(item)
                    .then(function (value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) {
                        return;
                    }
                    resolve(resolvedCollection);
                })
                    .then(null, reject);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._attachHandler({
                onfulfilled: function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function (reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                // tslint:disable-next-line:no-unsafe-any
                resolve(val);
            });
        });
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportsErrorEvent */
/* unused harmony export supportsDOMError */
/* unused harmony export supportsDOMException */
/* harmony export (immutable) */ __webpack_exports__["a"] = supportsFetch;
/* harmony export (immutable) */ __webpack_exports__["c"] = supportsNativeFetch;
/* unused harmony export supportsReportingObserver */
/* harmony export (immutable) */ __webpack_exports__["d"] = supportsReferrerPolicy;
/* harmony export (immutable) */ __webpack_exports__["b"] = supportsHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc__ = __webpack_require__(179);


/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        // tslint:disable:no-unused-expression
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // It really needs 1 argument, not 0.
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore
        // tslint:disable:no-unused-expression
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        // tslint:disable:no-unused-expression
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["g" /* getGlobalObject */])())) {
        return false;
    }
    try {
        // tslint:disable-next-line:no-unused-expression
        new Headers();
        // tslint:disable-next-line:no-unused-expression
        new Request('');
        // tslint:disable-next-line:no-unused-expression
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["g" /* getGlobalObject */])();
    // Fast path to avoid DOM I/O
    // tslint:disable-next-line:no-unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    if (doc) {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        try {
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // tslint:disable-next-line:no-unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* logger */].warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    // tslint:disable-next-line: no-unsafe-any
    return 'ReportingObserver' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["g" /* getGlobalObject */])();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        // tslint:disable:no-unused-expression
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["g" /* getGlobalObject */])();
    var chrome = global.chrome;
    // tslint:disable-next-line:no-unsafe-any
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(37);


/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: __WEBPACK_IMPORTED_MODULE_0__sentry_types__["b" /* Status */].Skipped,
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backend__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version__ = __webpack_require__(465);





/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_3__backend__["a" /* BrowserBackend */], options) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        event.sdk = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event.sdk, { name: __WEBPACK_IMPORTED_MODULE_4__version__["a" /* SDK_NAME */], packages: __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](((event.sdk && event.sdk.packages) || []), [
                {
                    name: 'npm:@sentry/browser',
                    version: __WEBPACK_IMPORTED_MODULE_4__version__["b" /* SDK_VERSION */],
                },
            ]), version: __WEBPACK_IMPORTED_MODULE_4__version__["b" /* SDK_VERSION */] });
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* getGlobalObject */])().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].error('Trying to call showReportDialog with Sentry Client is disabled');
            return;
        }
        var dsn = options.dsn || this.getDsn();
        if (!options.eventId) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].error('Missing `eventId` option in showReportDialog call');
            return;
        }
        if (!dsn) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].error('Missing `Dsn` option in showReportDialog call');
            return;
        }
        var script = document.createElement('script');
        script.async = true;
        script.src = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](dsn).getReportDialogEndpoint(options);
        if (options.onLoad) {
            script.onload = options.onLoad;
        }
        (document.head || document.body).appendChild(script);
    };
    return BrowserClient;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["c" /* BaseClient */]));

//# sourceMappingURL=client.js.map

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromUnknownInput;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsers__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracekit__ = __webpack_require__(303);



/** JSDoc */
function eventFromUnknownInput(exception, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["t" /* isErrorEvent */])(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        exception = errorEvent.error; // tslint:disable-line:no-parameter-reassignment
        event = Object(__WEBPACK_IMPORTED_MODULE_1__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_2__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["q" /* isDOMError */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["r" /* isDOMException */])(exception)) {
        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
        // then we just extract the name and message, as they don't provide anything else
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        var domException = exception;
        var name_1 = domException.name || (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["q" /* isDOMError */])(domException) ? 'DOMError' : 'DOMException');
        var message = domException.message ? name_1 + ": " + domException.message : name_1;
        event = eventFromString(message, syntheticException, options);
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["f" /* addExceptionTypeValue */])(event, message);
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["s" /* isError */])(exception)) {
        // we have a real Error object, do nothing
        event = Object(__WEBPACK_IMPORTED_MODULE_1__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_2__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["y" /* isPlainObject */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["u" /* isEvent */])(exception)) {
        // If it is plain Object or Event, serialize it manually and extract options
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        var objectException = exception;
        event = Object(__WEBPACK_IMPORTED_MODULE_1__parsers__["a" /* eventFromPlainObject */])(objectException, syntheticException, options.rejection);
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* addExceptionMechanism */])(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, options);
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["f" /* addExceptionTypeValue */])(event, "" + exception, undefined);
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* addExceptionMechanism */])(event, {
        synthetic: true,
    });
    return event;
}
// this._options.attachStacktrace
/** JSDoc */
function eventFromString(input, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event = {
        message: input,
    };
    if (options.attachStacktrace && syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_2__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = Object(__WEBPACK_IMPORTED_MODULE_1__parsers__["d" /* prepareFramesForEvent */])(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = exceptionFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromPlainObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["d"] = prepareFramesForEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracekit__ = __webpack_require__(303);


var STACKTRACE_LIMIT = 50;
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message,
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    // tslint:disable-next-line:strict-type-predicates
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["u" /* isEvent */])(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["j" /* extractExceptionKeysForMessage */])(exception),
                },
            ],
        },
        extra: {
            __serialized__: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* normalizeToSize */])(exception),
        },
    };
    if (syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_1__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
/**
 * @hidden
 */
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [exception],
        },
    };
}
/**
 * @hidden
 */
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || '';
    var lastFrameFunction = localStack[localStack.length - 1].func || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .map(function (frame) { return ({
        colno: frame.column === null ? undefined : frame.column,
        filename: frame.url || localStack[0].url,
        function: frame.func || '?',
        in_app: true,
        lineno: frame.line === null ? undefined : frame.line,
    }); })
        .slice(0, STACKTRACE_LIMIT)
        .reverse();
}
//# sourceMappingURL=parsers.js.map

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(304);
/* unused harmony reexport BaseTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(757);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__fetch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xhr__ = __webpack_require__(758);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__xhr__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SDK_VERSION; });
var SDK_NAME = 'sentry.javascript.browser';
var SDK_VERSION = '5.10.0';
//# sourceMappingURL=version.js.map

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalhandlers__ = __webpack_require__(760);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalHandlers", function() { return __WEBPACK_IMPORTED_MODULE_0__globalhandlers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trycatch__ = __webpack_require__(761);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TryCatch", function() { return __WEBPACK_IMPORTED_MODULE_1__trycatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__ = __webpack_require__(762);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkederrors__ = __webpack_require__(763);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedErrors", function() { return __WEBPACK_IMPORTED_MODULE_3__linkederrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useragent__ = __webpack_require__(764);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UserAgent", function() { return __WEBPACK_IMPORTED_MODULE_4__useragent__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(39) && !__webpack_require__(28)(function () {
  return Object.defineProperty(__webpack_require__(306)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(35);


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(58);
var toIObject = __webpack_require__(67);
var arrayIndexOf = __webpack_require__(221)(false);
var IE_PROTO = __webpack_require__(308)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(40);
var anObject = __webpack_require__(22);
var getKeys = __webpack_require__(126);

module.exports = __webpack_require__(39) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(67);
var gOPN = __webpack_require__(129).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(126);
var gOPS = __webpack_require__(222);
var pIE = __webpack_require__(181);
var toObject = __webpack_require__(44);
var IObject = __webpack_require__(180);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(28)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(47);
var isObject = __webpack_require__(30);
var invoke = __webpack_require__(474);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 474 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(24).parseInt;
var $trim = __webpack_require__(158).trim;
var ws = __webpack_require__(312);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(24).parseFloat;
var $trim = __webpack_require__(158).trim;

module.exports = 1 / $parseFloat(__webpack_require__(312) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(77);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(30);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 479 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(315);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(22);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(47);
var toObject = __webpack_require__(44);
var IObject = __webpack_require__(180);
var toLength = __webpack_require__(41);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(44);
var toAbsoluteIndex = __webpack_require__(127);
var toLength = __webpack_require__(41);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(39) && /./g.flags != 'g') __webpack_require__(40).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(226)
});


/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(22);
var isObject = __webpack_require__(30);
var newPromiseCapability = __webpack_require__(330);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(489);
var validate = __webpack_require__(160);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(229)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(40).f;
var create = __webpack_require__(128);
var redefineAll = __webpack_require__(133);
var ctx = __webpack_require__(76);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(132);
var $iterDefine = __webpack_require__(318);
var step = __webpack_require__(484);
var setSpecies = __webpack_require__(130);
var DESCRIPTORS = __webpack_require__(39);
var fastKey = __webpack_require__(108).fastKey;
var validate = __webpack_require__(160);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(489);
var validate = __webpack_require__(160);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(229)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(91)(0);
var redefine = __webpack_require__(60);
var meta = __webpack_require__(108);
var assign = __webpack_require__(472);
var weak = __webpack_require__(492);
var isObject = __webpack_require__(30);
var fails = __webpack_require__(28);
var validate = __webpack_require__(160);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(229)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(133);
var getWeak = __webpack_require__(108).getWeak;
var anObject = __webpack_require__(22);
var isObject = __webpack_require__(30);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(132);
var createArrayMethod = __webpack_require__(91);
var $has = __webpack_require__(58);
var validate = __webpack_require__(160);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(89);
var toLength = __webpack_require__(41);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(129);
var gOPS = __webpack_require__(222);
var anObject = __webpack_require__(22);
var Reflect = __webpack_require__(24).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(223);
var isObject = __webpack_require__(30);
var toLength = __webpack_require__(41);
var ctx = __webpack_require__(76);
var IS_CONCAT_SPREADABLE = __webpack_require__(35)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(41);
var repeat = __webpack_require__(314);
var defined = __webpack_require__(88);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(126);
var toIObject = __webpack_require__(67);
var isEnum = __webpack_require__(181).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(182);
var from = __webpack_require__(499);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(132);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 500 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 501 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * A module of methods that you want to include in all actions.
 * This module is consumed by `createAction`.
 */


module.exports = {};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Internal module used to create static and instance join methods
 */



var createStore = __webpack_require__(504),
    _ = __webpack_require__(92);

var slice = Array.prototype.slice,
    strategyMethodNames = {
    strict: "joinStrict",
    first: "joinLeading",
    last: "joinTrailing",
    all: "joinConcat"
};

/**
 * Used in `index.js` to create the static join methods
 * @param {String} strategy Which strategy to use when tracking listenable trigger arguments
 * @returns {Function} A static function which returns a store with a join listen on the given listenables using the given strategy
 */
exports.staticJoinCreator = function (strategy) {
    return function () /* listenables... */{
        var listenables = slice.call(arguments);
        return createStore({
            init: function init() {
                this[strategyMethodNames[strategy]].apply(this, listenables.concat("triggerAsync"));
            }
        });
    };
};

/**
 * Used in `ListenerMethods.js` to create the instance join methods
 * @param {String} strategy Which strategy to use when tracking listenable trigger arguments
 * @returns {Function} An instance method which sets up a join listen on the given listenables using the given strategy
 */
exports.instanceJoinCreator = function (strategy) {
    return function () /* listenables..., callback*/{
        _.throwIf(arguments.length < 2, "Cannot create a join with less than 2 listenables!");
        var listenables = slice.call(arguments),
            callback = listenables.pop(),
            numberOfListenables = listenables.length,
            join = {
            numberOfListenables: numberOfListenables,
            callback: this[callback] || callback,
            listener: this,
            strategy: strategy
        },
            i,
            cancels = [],
            subobj;
        for (i = 0; i < numberOfListenables; i++) {
            _.throwIf(this.validateListening(listenables[i]));
        }
        for (i = 0; i < numberOfListenables; i++) {
            cancels.push(listenables[i].listen(newListener(i, join), this));
        }
        reset(join);
        subobj = { listenable: listenables };
        subobj.stop = makeStopper(subobj, cancels, this);
        this.subscriptions = (this.subscriptions || []).concat(subobj);
        return subobj;
    };
};

// ---- internal join functions ----

function makeStopper(subobj, cancels, context) {
    return function () {
        var i,
            subs = context.subscriptions,
            index = subs ? subs.indexOf(subobj) : -1;
        _.throwIf(index === -1, "Tried to remove join already gone from subscriptions list!");
        for (i = 0; i < cancels.length; i++) {
            cancels[i]();
        }
        subs.splice(index, 1);
    };
}

function reset(join) {
    join.listenablesEmitted = new Array(join.numberOfListenables);
    join.args = new Array(join.numberOfListenables);
}

function newListener(i, join) {
    return function () {
        var callargs = slice.call(arguments);
        if (join.listenablesEmitted[i]) {
            switch (join.strategy) {
                case "strict":
                    throw new Error("Strict join failed because listener triggered twice.");
                case "last":
                    join.args[i] = callargs;break;
                case "all":
                    join.args[i].push(callargs);
            }
        } else {
            join.listenablesEmitted[i] = true;
            join.args[i] = join.strategy === "all" ? [callargs] : callargs;
        }
        emitIfAllListenablesEmitted(join);
    };
}

function emitIfAllListenablesEmitted(join) {
    for (var i = 0; i < join.numberOfListenables; i++) {
        if (!join.listenablesEmitted[i]) {
            return;
        }
    }
    join.callback.apply(join.listener, join.args);
    reset(join);
}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(92),
    Keep = __webpack_require__(334),
    mixer = __webpack_require__(974),
    bindMethods = __webpack_require__(975);

var allowed = { preEmit: 1, shouldEmit: 1 };

/**
 * Creates an event emitting Data Store. It is mixed in with functions
 * from the `ListenerMethods` and `PublisherMethods` mixins. `preEmit`
 * and `shouldEmit` may be overridden in the definition object.
 *
 * @param {Object} definition The data store object definition
 * @returns {Store} A data store instance
 */
module.exports = function (definition) {

    var StoreMethods = __webpack_require__(505),
        PublisherMethods = __webpack_require__(335),
        ListenerMethods = __webpack_require__(134);

    definition = definition || {};

    for (var a in StoreMethods) {
        if (!allowed[a] && (PublisherMethods[a] || ListenerMethods[a])) {
            throw new Error("Cannot override API method " + a + " in Reflux.StoreMethods. Use another method name or override it on Reflux.PublisherMethods / Reflux.ListenerMethods instead.");
        }
    }

    for (var d in definition) {
        if (!allowed[d] && (PublisherMethods[d] || ListenerMethods[d])) {
            throw new Error("Cannot override API method " + d + " in store creation. Use another method name or override it on Reflux.PublisherMethods / Reflux.ListenerMethods instead.");
        }
    }

    definition = mixer(definition);

    function Store() {
        var i = 0,
            arr;
        this.subscriptions = [];
        this.emitter = new _.EventEmitter();
        this.eventLabel = "change";
        bindMethods(this, definition);
        if (this.init && _.isFunction(this.init)) {
            this.init();
        }
        if (this.listenables) {
            arr = [].concat(this.listenables);
            for (; i < arr.length; i++) {
                this.listenToMany(arr[i]);
            }
        }
    }

    _.extend(Store.prototype, ListenerMethods, PublisherMethods, StoreMethods, definition);

    var store = new Store();
    Keep.createdStores.push(store);

    return store;
};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * A module of methods that you want to include in all stores.
 * This module is consumed by `createStore`.
 */


module.exports = {};

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var DashboardActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['read','readComplete','editCourse','addCourseSkeleton','saveCourse','createCourseComplete','updateCourseComplete','removeCourse','removeCourseCompleted','initQuizSection','duplicateCourse','duplicateCourseComplete','setSortMethod']);/* harmony default export */ __webpack_exports__["a"] = (DashboardActions);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var InvitationActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['showInfo','showInfoComplete','genericError','findByGroupId','findByCourseId','findByGroupIdComplete','findByCourseIdComplete','delete','deleteComplete','resend','resendComplete','check','checkGiftCode','accept','acceptGift','checkComplete','acceptComplete','getInvitationEmailStatus','getInvitationEmailStatusComplete','countByCourseId']);/* harmony default export */ __webpack_exports__["a"] = (InvitationActions);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var MessageActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['clearMessage','notify','info','error']);/* harmony default export */ __webpack_exports__["a"] = (MessageActions);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['next','previous','reset','restart','selectCourses','selectGroups','selectStudents','setInvitees']));

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var UserActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['findReaders','findReadersComplete','select','addToCircle','addToCircleComplete','setCircleRole','setCircleRoleComplete','listPwned','listPwnedComplete','course','courseComplete']);/* harmony default export */ __webpack_exports__["a"] = (UserActions);

/***/ }),
/* 511 */
/***/ (function(module, exports) {

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null != obj && 'object' == typeof obj;
}

module.exports = isObject;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(341);

var _BrowserProtocol = __webpack_require__(342);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(1001);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(240);

var _createHistory = __webpack_require__(343);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation;
  var getCurrentLocation = Protocol.getCurrentLocation;
  var pushLocation = Protocol.pushLocation;
  var replaceLocation = Protocol.replaceLocation;
  var go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(111);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Page=function(){function Page(){_classCallCheck(this,Page);}_createClass(Page,[{key:'createPageModule',value:function createPageModule(type,pageId,callback){__WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].call('page-module','create',{type:type,newRow:true,pageId:pageId},function(response){if(callback){callback(response);}});}},{key:'savePageModule',value:function savePageModule(id,params,callback){__WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].call('page-module','update',{id:id,params:params},function(response){if(callback){callback(response);}});}},{key:'savePageModuleExtended',value:function savePageModuleExtended(data,callback){__WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].call('page-module','update',data,function(response){if(callback){callback(response);}});}},{key:'deletePageModule',value:function deletePageModule(id,callback){__WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].call('page-module','delete',{id:id},function(response){if(callback){callback(response);}});}},{key:'deletePageRow',value:function deletePageRow(id,callback){__WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].call('page-row','delete',{id:id},function(response){if(callback){callback(response);}});}},{key:'moveToSection',value:function moveToSection(pageId,sectionId,position,callback){__WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].call('page','moveToSection',{pageId:pageId,sectionId:sectionId,position:position},function(response){if(callback){callback(response);}});}}]);return Page;}();/* harmony default export */ __webpack_exports__["a"] = (new Page());

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HelloWorld__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Oscilloscope__ = __webpack_require__(1959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InstagramFeed__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Webinar__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Spreadsheet__ = __webpack_require__(1962);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HelloWorld", function() { return __WEBPACK_IMPORTED_MODULE_0__HelloWorld__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Oscilloscope", function() { return __WEBPACK_IMPORTED_MODULE_1__Oscilloscope__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InstagramFeed", function() { return __WEBPACK_IMPORTED_MODULE_2__InstagramFeed__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Webinar", function() { return __WEBPACK_IMPORTED_MODULE_3__Webinar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Spreadsheet", function() { return __WEBPACK_IMPORTED_MODULE_4__Spreadsheet__["a"]; });


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Modernizr 2.8.3 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-borderradius-boxshadow-opacity-csstransforms-csstransforms3d-csstransitions-prefixed-teststyles-testprop-testallprops-prefixes-domprefixes
 */



module.exports = (function (window, document, undefined) {

    var version = '2.8.3',
        Modernizr = {},
        docElement = document.documentElement,
        mod = 'modernizr',
        modElem = document.createElement(mod),
        mStyle = modElem.style,
        prefixes = ' -webkit- -moz- -o- -ms- '.split(' '),
        omPrefixes = 'Webkit Moz O ms',
        cssomPrefixes = omPrefixes.split(' '),
        domPrefixes = omPrefixes.toLowerCase().split(' '),
        tests = {},
        classes = [],
        slice = classes.slice,
        featureName = undefined,
        injectElementWithStyles = function injectElementWithStyles(rule, callback, nodes, testnames) {

        var style = undefined,
            ret = undefined,
            node = undefined,
            docOverflow = undefined,
            div = document.createElement('div'),
            body = document.body,
            fakeBody = body || document.createElement('body');

        if (parseInt(nodes, 10)) {
            while (nodes--) {
                node = document.createElement('div');
                node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
                div.appendChild(node);
            }
        }

        style = ['&#173;', '<style id="s', mod, '">', rule, '</style>'].join('');
        div.id = mod;
        (body ? div : fakeBody).innerHTML += style;
        fakeBody.appendChild(div);
        if (!body) {
            fakeBody.style.background = '';
            fakeBody.style.overflow = 'hidden';
            docOverflow = docElement.style.overflow;
            docElement.style.overflow = 'hidden';
            docElement.appendChild(fakeBody);
        }

        ret = callback(div, rule);
        if (!body) {
            fakeBody.parentNode.removeChild(fakeBody);
            docElement.style.overflow = docOverflow;
        } else {
            div.parentNode.removeChild(div);
        }

        return !!ret;
    },
        _hasOwnProperty = ({}).hasOwnProperty,
        hasOwnProp = undefined;

    function is(obj, type) {
        return typeof obj === type;
    }

    if (!is(_hasOwnProperty, 'undefined') && !is(_hasOwnProperty.call, 'undefined')) {
        hasOwnProp = function (object, property) {
            return _hasOwnProperty.call(object, property);
        };
    } else {
        hasOwnProp = function (object, property) {
            return property in object && is(object.constructor.prototype[property], 'undefined');
        };
    }

    if (!Function.prototype.bind) {
        Function.prototype.bind = function bind(that) {

            var target = this;

            if (typeof target != "function") {
                throw new TypeError();
            }

            var args = slice.call(arguments, 1),
                bound = function bound() {

                if (this instanceof bound) {

                    var F = function F() {};
                    F.prototype = target.prototype;
                    var _self = new F();

                    var result = target.apply(_self, args.concat(slice.call(arguments)));
                    if (Object(result) === result) {
                        return result;
                    }
                    return _self;
                } else {

                    return target.apply(that, args.concat(slice.call(arguments)));
                }
            };

            return bound;
        };
    }

    function setCss(str) {
        mStyle.cssText = str;
    }

    function setCssAll(str1, str2) {
        return setCss(prefixes.join(str1 + ';') + (str2 || ''));
    }

    function contains(str, substr) {
        return !! ~('' + str).indexOf(substr);
    }

    function testProps(props, prefixed) {
        for (var i in props) {
            var prop = props[i];
            if (!contains(prop, "-") && mStyle[prop] !== undefined) {
                return prefixed == 'pfx' ? prop : true;
            }
        }
        return false;
    }

    function testDOMProps(props, obj, elem) {
        for (var i in props) {
            var item = obj[props[i]];
            if (item !== undefined) {

                if (elem === false) return props[i];

                if (is(item, 'function')) {
                    return item.bind(elem || obj);
                }

                return item;
            }
        }
        return false;
    }

    function testPropsAll(prop, prefixed, elem) {

        var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
            props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

        if (is(prefixed, "string") || is(prefixed, "undefined")) {
            return testProps(props, prefixed);
        } else {
            props = (prop + ' ' + domPrefixes.join(ucProp + ' ') + ucProp).split(' ');
            return testDOMProps(props, prefixed, elem);
        }
    }

    tests.borderradius = function () {
        return testPropsAll('borderRadius');
    };

    tests.boxshadow = function () {
        return testPropsAll('boxShadow');
    };

    tests.opacity = function () {
        setCssAll('opacity:.55');

        return (/^0.55$/.test(mStyle.opacity)
        );
    };
    tests.csstransforms = function () {
        return !!testPropsAll('transform');
    };

    tests.csstransforms3d = function () {

        var ret = !!testPropsAll('perspective');

        if (ret && 'webkitPerspective' in docElement.style) {

            injectElementWithStyles('@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}', function (node) {
                ret = node.offsetLeft === 9 && node.offsetHeight === 3;
            });
        }
        return ret;
    };

    tests.csstransitions = function () {
        return testPropsAll('transition');
    };

    for (var feature in tests) {
        if (hasOwnProp(tests, feature)) {
            featureName = feature.toLowerCase();
            Modernizr[featureName] = tests[feature]();

            classes.push((Modernizr[featureName] ? '' : 'no-') + featureName);
        }
    }

    Modernizr.addTest = function (feature, test) {
        if (typeof feature == 'object') {
            for (var key in feature) {
                if (hasOwnProp(feature, key)) {
                    Modernizr.addTest(key, feature[key]);
                }
            }
        } else {

            feature = feature.toLowerCase();

            if (Modernizr[feature] !== undefined) {
                return Modernizr;
            }

            test = typeof test == 'function' ? test() : test;

            if (typeof enableClasses !== "undefined" && enableClasses) {
                docElement.className += ' ' + (test ? '' : 'no-') + feature;
            }
            Modernizr[feature] = test;
        }

        return Modernizr;
    };

    setCss('');

    Modernizr._version = version;

    Modernizr._prefixes = prefixes;
    Modernizr._domPrefixes = domPrefixes;
    Modernizr._cssomPrefixes = cssomPrefixes;

    Modernizr.testProp = function (prop) {
        return testProps([prop]);
    };

    Modernizr.testAllProps = testPropsAll;

    Modernizr.testStyles = injectElementWithStyles;
    Modernizr.prefixed = function (prop, obj, elem) {
        if (!obj) {
            return testPropsAll(prop, 'pfx');
        } else {
            return testPropsAll(prop, obj, elem);
        }
    };

    return Modernizr;
})(window, window.document);

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
* @providesModule shallowCompare
*/



var shallowEqual = __webpack_require__(219);

/**
 * Does a shallow comparison for props and state.
 * See ReactComponentWithPureRenderMixin
 */
function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}

module.exports = shallowCompare;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactTransitionGroup
 */



var React = __webpack_require__(210);
var ReactTransitionChildMapping = __webpack_require__(1018);

var assign = __webpack_require__(29);
var emptyFunction = __webpack_require__(57);

var ReactTransitionGroup = React.createClass({
  displayName: 'ReactTransitionGroup',

  propTypes: {
    component: React.PropTypes.any,
    childFactory: React.PropTypes.func
  },

  getDefaultProps: function () {
    return {
      component: 'span',
      childFactory: emptyFunction.thatReturnsArgument
    };
  },

  getInitialState: function () {
    return {
      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
    };
  },

  componentWillMount: function () {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  },

  componentDidMount: function () {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key);
      }
    }
  },

  componentWillReceiveProps: function (nextProps) {
    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
    });

    var key;

    for (key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
        this.keysToLeave.push(key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  },

  componentDidUpdate: function () {
    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(this.performEnter);

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(this.performLeave);
  },

  performAppear: function (key) {
    this.currentlyTransitioningKeys[key] = true;

    var component = this.refs[key];

    if (component.componentWillAppear) {
      component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
    } else {
      this._handleDoneAppearing(key);
    }
  },

  _handleDoneAppearing: function (key) {
    var component = this.refs[key];
    if (component.componentDidAppear) {
      component.componentDidAppear();
    }

    delete this.currentlyTransitioningKeys[key];

    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);

    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
      // This was removed before it had fully appeared. Remove it.
      this.performLeave(key);
    }
  },

  performEnter: function (key) {
    this.currentlyTransitioningKeys[key] = true;

    var component = this.refs[key];

    if (component.componentWillEnter) {
      component.componentWillEnter(this._handleDoneEntering.bind(this, key));
    } else {
      this._handleDoneEntering(key);
    }
  },

  _handleDoneEntering: function (key) {
    var component = this.refs[key];
    if (component.componentDidEnter) {
      component.componentDidEnter();
    }

    delete this.currentlyTransitioningKeys[key];

    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);

    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
      // This was removed before it had fully entered. Remove it.
      this.performLeave(key);
    }
  },

  performLeave: function (key) {
    this.currentlyTransitioningKeys[key] = true;

    var component = this.refs[key];
    if (component.componentWillLeave) {
      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
    } else {
      // Note that this is somewhat dangerous b/c it calls setState()
      // again, effectively mutating the component before all the work
      // is done.
      this._handleDoneLeaving(key);
    }
  },

  _handleDoneLeaving: function (key) {
    var component = this.refs[key];

    if (component.componentDidLeave) {
      component.componentDidLeave();
    }

    delete this.currentlyTransitioningKeys[key];

    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);

    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
      // This entered again before it fully left. Add it again.
      this.performEnter(key);
    } else {
      this.setState(function (state) {
        var newChildren = assign({}, state.children);
        delete newChildren[key];
        return { children: newChildren };
      });
    }
  },

  render: function () {
    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];
    for (var key in this.state.children) {
      var child = this.state.children[key];
      if (child) {
        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
      }
    }
    return React.createElement(this.props.component, this.props, childrenToRender);
  }
});

module.exports = ReactTransitionGroup;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var PureRenderMixin = __webpack_require__(1);
var StylePropable = __webpack_require__(10);
var AutoPrefix = __webpack_require__(62);
var Transitions = __webpack_require__(21);
var Colors = __webpack_require__(53);

var CircleRipple = React.createClass({
  displayName: 'CircleRipple',

  mixins: [PureRenderMixin, StylePropable],

  propTypes: {
    color: React.PropTypes.string,
    opacity: React.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      color: Colors.darkBlack,
      opacity: 0.16
    };
  },

  componentWillAppear: function componentWillAppear(callback) {
    this._initializeAnimation(callback);
  },

  componentWillEnter: function componentWillEnter(callback) {
    this._initializeAnimation(callback);
  },

  componentDidAppear: function componentDidAppear() {
    this._animate();
  },

  componentDidEnter: function componentDidEnter() {
    this._animate();
  },

  componentWillLeave: function componentWillLeave(callback) {
    var _this = this;

    var style = ReactDOM.findDOMNode(this).style;
    style.opacity = 0;
    setTimeout(function () {
      if (_this.isMounted()) callback();
    }, 2000);
  },

  render: function render() {
    var _props = this.props;
    var color = _props.color;
    var opacity = _props.opacity;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['color', 'opacity', 'style']);

    var mergedStyles = this.mergeAndPrefix({
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      borderRadius: '50%',
      backgroundColor: color
    }, style);

    return React.createElement('div', _extends({}, other, { style: mergedStyles }));
  },

  _animate: function _animate() {
    var style = ReactDOM.findDOMNode(this).style;
    var transitionValue = Transitions.easeOut('2s', 'opacity') + ',' + Transitions.easeOut('1s', 'transform');
    AutoPrefix.set(style, 'transition', transitionValue);
    AutoPrefix.set(style, 'transform', 'scale(1)');
  },

  _initializeAnimation: function _initializeAnimation(callback) {
    var _this2 = this;

    var style = ReactDOM.findDOMNode(this).style;
    style.opacity = this.props.opacity;
    AutoPrefix.set(style, 'transform', 'scale(0)');
    setTimeout(function () {
      if (_this2.isMounted()) callback();
    }, 0);
  }

});

module.exports = CircleRipple;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var Colors = __webpack_require__(53);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Avatar = React.createClass({
  displayName: 'Avatar',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    backgroundColor: React.PropTypes.string,
    color: React.PropTypes.string,
    icon: React.PropTypes.element,
    size: React.PropTypes.number,
    src: React.PropTypes.string,
    style: React.PropTypes.object
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getDefaultProps: function getDefaultProps() {
    return {
      backgroundColor: Colors.grey400,
      color: Colors.white,
      size: 40
    };
  },

  render: function render() {
    var _props = this.props;
    var backgroundColor = _props.backgroundColor;
    var color = _props.color;
    var icon = _props.icon;
    var size = _props.size;
    var src = _props.src;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['backgroundColor', 'color', 'icon', 'size', 'src', 'style']);

    var styles = {
      root: {
        height: size,
        width: size,
        userSelect: 'none',
        borderRadius: '50%',
        display: 'inline-block'
      }
    };

    if (src) {
      var borderColor = this.state.muiTheme.avatar.borderColor;

      if (borderColor) {
        styles.root = this.mergeStyles(styles.root, {
          height: size - 2,
          width: size - 2,
          border: 'solid 1px ' + borderColor
        });
      }

      return React.createElement('img', _extends({}, other, { src: src, style: this.prepareStyles(styles.root, style) }));
    } else {
      styles.root = this.mergeStyles(styles.root, {
        backgroundColor: backgroundColor,
        textAlign: 'center',
        lineHeight: size + 'px',
        fontSize: size / 2 + 4,
        color: color
      });

      var styleIcon = {
        margin: 8
      };

      var iconElement = icon ? React.cloneElement(icon, {
        color: color,
        style: this.mergeStyles(styleIcon, icon.props.style)
      }) : null;

      return React.createElement(
        'div',
        _extends({}, other, { style: this.prepareStyles(styles.root, style) }),
        iconElement,
        this.props.children
      );
    }
  }
});

module.exports = Avatar;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var AutoPrefix = __webpack_require__(62);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

/**
 *  BeforeAfterWrapper
 *    An alternative for the ::before and ::after css pseudo-elements for
 *    components whose styles are defined in javascript instead of css.
 *
 *  Usage: For the element that we want to apply before and after elements to,
 *    wrap its children with BeforeAfterWrapper. For example:
 *
 *                                            <Paper>
 *  <Paper>                                     <div> // See notice
 *    <BeforeAfterWrapper>        renders         <div/> // before element
 *      [children of paper]       ------>         [children of paper]
 *    </BeforeAfterWrapper>                       <div/> // after element
 *  </Paper>                                    </div>
 *                                            </Paper>
 *
 *  Notice: Notice that this div bundles together our elements. If the element
 *    that we want to apply before and after elements is a HTML tag (i.e. a
 *    div, p, or button tag), we can avoid this extra nesting by passing using
 *    the BeforeAfterWrapper in place of said tag like so:
 *
 *  <p>
 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
 *      [children of p]          ------>         [children of p]
 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
 *  </p>
 *
 *  BeforeAfterWrapper features spread functionality. This means that we can
 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
 *
 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
 *  and afterElement have a defined style position.
 */

var BeforeAfterWrapper = React.createClass({
  displayName: 'BeforeAfterWrapper',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    beforeStyle: React.PropTypes.object,
    afterStyle: React.PropTypes.object,
    beforeElementType: React.PropTypes.string,
    afterElementType: React.PropTypes.string,
    elementType: React.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      beforeElementType: 'div',
      afterElementType: 'div',
      elementType: 'div'
    };
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _props = this.props;
    var beforeStyle = _props.beforeStyle;
    var afterStyle = _props.afterStyle;
    var beforeElementType = _props.beforeElementType;
    var afterElementType = _props.afterElementType;
    var elementType = _props.elementType;

    var other = _objectWithoutProperties(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);

    var beforeElement = undefined,
        afterElement = undefined;

    beforeStyle = AutoPrefix.all({ boxSizing: 'border-box' });
    afterStyle = AutoPrefix.all({ boxSizing: 'border-box' });

    if (this.props.beforeStyle) beforeElement = React.createElement(this.props.beforeElementType, {
      style: this.prepareStyles(beforeStyle, this.props.beforeStyle),
      key: "::before"
    });
    if (this.props.afterStyle) afterElement = React.createElement(this.props.afterElementType, {
      style: this.prepareStyles(afterStyle, this.props.afterStyle),
      key: "::after"
    });

    var children = [beforeElement, this.props.children, afterElement];

    var props = other;
    props.style = this.prepareStyles(this.props.style);

    return React.createElement(this.props.elementType, props, children);
  }

});

module.exports = BeforeAfterWrapper;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var Extend = __webpack_require__(350);
var OpenIcon = __webpack_require__(524);
var CloseIcon = __webpack_require__(525);
var IconButton = __webpack_require__(186);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);
var ContextPure = __webpack_require__(136);

var CardExpandable = React.createClass({
  displayName: 'CardExpandable',

  mixins: [StylePropable, ContextPure],

  getStyles: function getStyles() {
    var contextKeys = this.constructor.getRelevantContextKeys(this.state.muiTheme);

    var directionStyle = contextKeys.isRtl ? {
      left: 4
    } : {
      right: 4
    };

    return {
      root: Extend({
        top: 0,
        bottom: 0,
        margin: 'auto',
        position: 'absolute'
      }, directionStyle)
    };
  },

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    onExpanding: React.PropTypes.func.isRequired,
    expanded: React.PropTypes.bool
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  statics: {
    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
      return {
        isRtl: muiTheme.isRtl
      };
    },
    getChildrenClasses: function getChildrenClasses() {
      return [IconButton];
    }
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var styles = this.getStyles();

    var expandable = undefined;
    if (this.props.expanded === true) expandable = React.createElement(OpenIcon, null);else expandable = React.createElement(CloseIcon, null);

    var mergedStyles = this.mergeStyles(styles.root, this.props.style);

    var expandableBtn = React.createElement(
      IconButton,
      {
        style: mergedStyles,
        onTouchTap: this.props.onExpanding },
      expandable
    );

    return expandableBtn;
  }
});

module.exports = CardExpandable;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareKeyboardArrowUp = React.createClass({
  displayName: 'HardwareKeyboardArrowUp',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
    );
  }

});

module.exports = HardwareKeyboardArrowUp;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareKeyboardArrowDown = React.createClass({
  displayName: 'HardwareKeyboardArrowDown',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
    );
  }

});

module.exports = HardwareKeyboardArrowDown;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ToggleCheckBoxOutlineBlank = React.createClass({
  displayName: 'ToggleCheckBoxOutlineBlank',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = ToggleCheckBoxOutlineBlank;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ToggleCheckBox = React.createClass({
  displayName: 'ToggleCheckBox',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
    );
  }

});

module.exports = ToggleCheckBox;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var ContextPure = __webpack_require__(136);
var StylePropable = __webpack_require__(10);
var WindowListenable = __webpack_require__(103);
var CssEvent = __webpack_require__(192);
var KeyCode = __webpack_require__(79);
var Calendar = __webpack_require__(1031);
var Dialog = __webpack_require__(361);
var FlatButton = __webpack_require__(193);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var DatePickerDialog = React.createClass({
  displayName: 'DatePickerDialog',

  mixins: [StylePropable, WindowListenable, ContextPure],

  statics: {
    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
      return {
        buttonColor: muiTheme.datePicker.calendarTextColor
      };
    },
    getChildrenClasses: function getChildrenClasses() {
      return [Calendar, Dialog];
    }
  },

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    disableYearSelection: React.PropTypes.bool,
    initialDate: React.PropTypes.object,
    maxDate: React.PropTypes.object,
    minDate: React.PropTypes.object,
    onAccept: React.PropTypes.func,
    onClickAway: React.PropTypes.func,
    onDismiss: React.PropTypes.func,
    onShow: React.PropTypes.func,
    shouldDisableDate: React.PropTypes.func,
    showYearSelector: React.PropTypes.bool
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  windowListeners: {
    keyup: '_handleWindowKeyUp'
  },

  getInitialState: function getInitialState() {
    return {
      isCalendarActive: false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _props = this.props;
    var initialDate = _props.initialDate;
    var onAccept = _props.onAccept;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['initialDate', 'onAccept', 'style']);

    var _constructor$getRelevantContextKeys = this.constructor.getRelevantContextKeys(this.state.muiTheme);

    var calendarTextColor = _constructor$getRelevantContextKeys.calendarTextColor;

    var styles = {
      root: {
        fontSize: 14,
        color: calendarTextColor
      },

      dialogContent: {
        width: this.props.mode === 'landscape' ? 480 : 320
      },

      dialogBodyContent: {
        padding: 0
      },

      actions: {
        marginRight: 8
      }
    };

    var actions = [React.createElement(FlatButton, {
      key: 0,
      label: 'Cancel',
      secondary: true,
      style: styles.actions,
      onTouchTap: this._handleCancelTouchTap })];

    if (!this.props.autoOk) {
      actions.push(React.createElement(FlatButton, {
        key: 1,
        label: 'OK',
        secondary: true,
        disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
        style: styles.actions,
        onTouchTap: this._handleOKTouchTap }));
    }

    return React.createElement(
      Dialog,
      _extends({}, other, {
        ref: 'dialog',
        style: styles.root,
        contentStyle: styles.dialogContent,
        bodyStyle: styles.dialogBodyContent,
        actions: actions,
        onDismiss: this._handleDialogDismiss,
        onShow: this._handleDialogShow,
        onClickAway: this._handleDialogClickAway,
        repositionOnUpdate: false }),
      React.createElement(Calendar, {
        ref: 'calendar',
        onDayTouchTap: this._onDayTouchTap,
        initialDate: this.props.initialDate,
        isActive: this.state.isCalendarActive,
        minDate: this.props.minDate,
        maxDate: this.props.maxDate,
        shouldDisableDate: this.props.shouldDisableDate,
        showYearSelector: this.props.showYearSelector,
        mode: this.props.mode })
    );
  },

  show: function show() {
    this.refs.dialog.show();
  },

  dismiss: function dismiss() {
    this.refs.dialog.dismiss();
  },

  _onDayTouchTap: function _onDayTouchTap() {
    if (this.props.autoOk) {
      setTimeout(this._handleOKTouchTap, 300);
    }
  },

  _handleCancelTouchTap: function _handleCancelTouchTap() {
    this.dismiss();
  },

  _handleOKTouchTap: function _handleOKTouchTap() {
    if (this.props.onAccept && !this.refs.calendar.isSelectedDateDisabled()) {
      this.props.onAccept(this.refs.calendar.getSelectedDate());
    }

    this.dismiss();
  },

  _handleDialogShow: function _handleDialogShow() {
    this.setState({
      isCalendarActive: true
    });

    if (this.props.onShow) this.props.onShow();
  },

  _handleDialogDismiss: function _handleDialogDismiss() {
    var _this = this;

    CssEvent.onTransitionEnd(ReactDOM.findDOMNode(this.refs.dialog), function () {
      _this.setState({
        isCalendarActive: false
      });
    });

    if (this.props.onDismiss) this.props.onDismiss();
  },

  _handleDialogClickAway: function _handleDialogClickAway() {
    var _this2 = this;

    CssEvent.onTransitionEnd(ReactDOM.findDOMNode(this.refs.dialog), function () {
      _this2.setState({
        isCalendarActive: false
      });
    });

    if (this.props.onClickAway) this.props.onClickAway();
  },

  _handleWindowKeyUp: function _handleWindowKeyUp(e) {
    if (this.state.isCalendarActive) {
      switch (e.keyCode) {
        case KeyCode.ENTER:
          this._handleOKTouchTap();
          break;
      }
    }
  }

});

module.exports = DatePickerDialog;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Toolbar = React.createClass({
  displayName: 'Toolbar',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    className: React.PropTypes.string,
    style: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.toolbar;
  },

  getStyles: function getStyles() {
    return this.mergeStyles({
      boxSizing: 'border-box',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
      backgroundColor: this.getTheme().backgroundColor,
      height: this.getTheme().height,
      width: '100%',
      padding: this.props.noGutter ? 0 : '0px ' + this.state.muiTheme.rawTheme.spacing.desktopGutter + 'px'
    }, this.props.style);
  },

  render: function render() {
    return React.createElement(
      'div',
      { className: this.props.className, style: this.prepareStyles(this.getStyles()) },
      this.props.children
    );
  }

});

module.exports = Toolbar;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var Colors = __webpack_require__(53);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var ToolbarGroup = React.createClass({
  displayName: 'ToolbarGroup',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    className: React.PropTypes.string,
    float: React.PropTypes.string
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      float: 'left'
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.toolbar;
  },

  getSpacing: function getSpacing() {
    return this.state.muiTheme.rawTheme.spacing.desktopGutter;
  },

  getStyles: function getStyles() {
    var marginHorizontal = this.getSpacing();
    var marginVertical = (this.getTheme().height - this.state.muiTheme.button.height) / 2;
    var styles = {
      root: {
        position: 'relative',
        float: this.props.float
      },
      dropDownMenu: {
        root: {
          float: 'left',
          color: Colors.lightBlack, // removes hover color change, we want to keep it
          display: 'inline-block',
          marginRight: this.getSpacing()
        },
        controlBg: {
          backgroundColor: this.getTheme().menuHoverColor,
          borderRadius: 0
        },
        underline: {
          display: 'none'
        }
      },
      button: {
        float: 'left',
        margin: marginVertical + 'px ' + marginHorizontal + 'px',
        position: 'relative'
      },
      icon: {
        root: {
          float: 'left',
          cursor: 'pointer',
          color: this.getTheme().iconColor,
          lineHeight: this.getTheme().height + 'px',
          paddingLeft: this.getSpacing()
        },
        hover: {
          color: Colors.darkBlack
        }
      },
      span: {
        float: 'left',
        color: this.getTheme().iconColor,
        lineHeight: this.getTheme().height + 'px'
      }
    };

    return styles;
  },

  render: function render() {
    var _this = this;

    var styles = this.getStyles();

    if (this.props.firstChild) styles.marginLeft = -24;
    if (this.props.lastChild) styles.marginRight = -24;

    var newChildren = React.Children.map(this.props.children, function (currentChild) {
      if (!currentChild) {
        return null;
      }
      switch (currentChild.type.displayName) {
        case 'DropDownMenu':
          return React.cloneElement(currentChild, {
            style: _this.mergeStyles(styles.dropDownMenu.root, currentChild.props.style),
            styleControlBg: styles.dropDownMenu.controlBg,
            styleUnderline: styles.dropDownMenu.underline
          });
        case 'DropDownIcon':
          return React.cloneElement(currentChild, {
            style: _this.mergeStyles({ float: 'left' }, currentChild.props.style),
            iconStyle: styles.icon.root,
            onMouseEnter: _this._handleMouseEnterDropDownMenu,
            onMouseLeave: _this._handleMouseLeaveDropDownMenu
          });
        case 'RaisedButton':case 'FlatButton':
          return React.cloneElement(currentChild, {
            style: _this.mergeStyles(styles.button, currentChild.props.style)
          });
        case 'FontIcon':
          return React.cloneElement(currentChild, {
            style: _this.mergeStyles(styles.icon.root, currentChild.props.style),
            onMouseEnter: _this._handleMouseEnterFontIcon,
            onMouseLeave: _this._handleMouseLeaveFontIcon
          });
        case 'ToolbarSeparator':case 'ToolbarTitle':
          return React.cloneElement(currentChild, {
            style: _this.mergeStyles(styles.span, currentChild.props.style)
          });
        default:
          return currentChild;
      }
    }, this);

    return React.createElement(
      'div',
      { className: this.props.className, style: this.prepareStyles(styles.root, this.props.style) },
      newChildren
    );
  },

  _handleMouseEnterDropDownMenu: function _handleMouseEnterDropDownMenu(e) {
    e.target.style.zIndex = this.getStyles().icon.hover.zIndex;
    e.target.style.color = this.getStyles().icon.hover.color;
  },

  _handleMouseLeaveDropDownMenu: function _handleMouseLeaveDropDownMenu(e) {
    e.target.style.zIndex = 'auto';
    e.target.style.color = this.getStyles().icon.root.color;
  },

  _handleMouseEnterFontIcon: function _handleMouseEnterFontIcon(e) {
    e.target.style.zIndex = this.getStyles().icon.hover.zIndex;
    e.target.style.color = this.getStyles().icon.hover.color;
  },

  _handleMouseLeaveFontIcon: function _handleMouseLeaveFontIcon(e) {
    e.target.style.zIndex = 'auto';
    e.target.style.color = this.getStyles().icon.root.color;
  }
});

module.exports = ToolbarGroup;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  Desktop: {
    GUTTER: 24,
    GUTTER_LESS: 16,
    INCREMENT: 64,
    MENU_ITEM_HEIGHT: 32
  },

  getIncrementalDim: function getIncrementalDim(dim) {
    return Math.ceil(dim / this.Desktop.INCREMENT) * this.Desktop.INCREMENT;
  }
};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var FontIcon = __webpack_require__(189);
var Toggle = __webpack_require__(533);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Types = {
  LINK: 'LINK',
  SUBHEADER: 'SUBHEADER',
  NESTED: 'NESTED'
};

var MenuItem = React.createClass({
  displayName: 'MenuItem',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    index: React.PropTypes.number.isRequired,
    className: React.PropTypes.string,
    iconClassName: React.PropTypes.string,
    iconRightClassName: React.PropTypes.string,
    iconStyle: React.PropTypes.object,
    iconRightStyle: React.PropTypes.object,
    attribute: React.PropTypes.string,
    number: React.PropTypes.string,
    data: React.PropTypes.string,
    toggle: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
    onTouchTap: React.PropTypes.func,
    onToggle: React.PropTypes.func,
    selected: React.PropTypes.bool,
    active: React.PropTypes.bool
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  statics: {
    Types: Types
  },

  getDefaultProps: function getDefaultProps() {
    return {
      toggle: false,
      disabled: false,
      active: false
    };
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.menuItem;
  },

  getSpacing: function getSpacing() {
    return this.state.muiTheme.rawTheme.spacing;
  },

  getStyles: function getStyles() {
    var _data;

    var isRtl = this.context.muiTheme.isRtl;

    var right = isRtl ? 'left' : 'right';
    var left = isRtl ? 'right' : 'left';

    var marginRight = isRtl ? 'marginLeft' : 'marginRight';
    var paddingLeft = isRtl ? 'paddingRight' : 'paddingLeft';

    var styles = {
      root: {
        userSelect: 'none',
        cursor: 'pointer',
        lineHeight: this.getTheme().height + 'px',
        paddingLeft: this.getTheme().padding,
        paddingRight: this.getTheme().padding,
        color: this.state.muiTheme.rawTheme.palette.textColor
      },
      number: {
        float: right,
        width: 24,
        textAlign: 'center'
      },
      attribute: {
        float: right
      },
      iconRight: {
        lineHeight: this.getTheme().height + 'px',
        float: right
      },
      icon: _defineProperty({
        float: left,
        lineHeight: this.getTheme().height + 'px'
      }, marginRight, this.getSpacing().desktopGutter),
      data: (_data = {
        display: 'block'
      }, _defineProperty(_data, paddingLeft, this.getSpacing().desktopGutter * 2), _defineProperty(_data, 'lineHeight', this.getTheme().dataHeight + 'px'), _defineProperty(_data, 'height', this.getTheme().dataHeight + 'px'), _defineProperty(_data, 'verticalAlign', 'top'), _defineProperty(_data, 'top', -12), _defineProperty(_data, 'position', 'relative'), _defineProperty(_data, 'fontWeight', 300), _defineProperty(_data, 'color', this.state.muiTheme.rawTheme.palette.textColor), _data),
      toggle: {
        marginTop: (this.getTheme().height - this.state.muiTheme.radioButton.size) / 2,
        float: right,
        width: 42
      },
      rootWhenHovered: {
        backgroundColor: this.getTheme().hoverColor
      },
      rootWhenSelected: {
        color: this.getTheme().selectedTextColor
      },
      rootWhenDisabled: {
        cursor: 'default',
        color: this.state.muiTheme.rawTheme.palette.disabledColor
      }
    };

    return styles;
  },

  render: function render() {
    var icon = undefined;
    var data = undefined;
    var iconRight = undefined;
    var attribute = undefined;
    var number = undefined;
    var toggleElement = undefined;
    var styles = this.getStyles();

    if (this.props.iconClassName) icon = React.createElement(FontIcon, { style: this.mergeStyles(styles.icon, this.props.iconStyle, this.props.selected && styles.rootWhenSelected), className: this.props.iconClassName });
    if (this.props.iconRightClassName) iconRight = React.createElement(FontIcon, { style: this.mergeStyles(styles.iconRight, this.props.iconRightStyle), className: this.props.iconRightClassName });
    if (this.props.data) data = React.createElement(
      'span',
      { style: this.prepareStyles(styles.data) },
      this.props.data
    );
    if (this.props.number !== undefined) number = React.createElement(
      'span',
      { style: this.prepareStyles(styles.number) },
      this.props.number
    );
    if (this.props.attribute !== undefined) attribute = React.createElement(
      'span',
      { style: this.prepareStyles(styles.style) },
      this.props.attribute
    );
    if (this.props.icon) icon = this.props.icon;

    if (this.props.toggle) {
      var _props = this.props;
      var toggle = _props.toggle;
      var onTouchTap = _props.onTouchTap;
      var onToggle = _props.onToggle;
      var onMouseEnter = _props.onMouseEnter;
      var onMouseLeave = _props.onMouseLeave;
      var children = _props.children;
      var label = _props.label;
      var style = _props.style;

      var other = _objectWithoutProperties(_props, ['toggle', 'onTouchTap', 'onToggle', 'onMouseEnter', 'onMouseLeave', 'children', 'label', 'style']);

      toggleElement = React.createElement(Toggle, _extends({}, other, { onToggle: this._handleToggle, style: styles.toggle }));
    }

    return React.createElement(
      'div',
      {
        key: this.props.index,
        className: this.props.className,
        onTouchTap: this._handleTouchTap,
        onMouseEnter: this._handleMouseEnter,
        onMouseLeave: this._handleMouseLeave,
        style: this.prepareStyles(styles.root, this.props.selected && styles.rootWhenSelected, this.props.active && !this.props.disabled && styles.rootWhenHovered, this.props.style, this.props.disabled && styles.rootWhenDisabled) },
      icon,
      this.props.children,
      number,
      attribute,
      data,
      toggleElement,
      iconRight
    );
  },

  _handleTouchTap: function _handleTouchTap(e) {
    if (!this.props.disabled && this.props.onTouchTap) this.props.onTouchTap(e, this.props.index);
  },

  _handleToggle: function _handleToggle(e, toggled) {
    if (!this.props.disabled && this.props.onToggle) this.props.onToggle(e, this.props.index, toggled);
  },

  _handleMouseEnter: function _handleMouseEnter(e) {
    if (!this.props.disabled && this.props.onMouseEnter) this.props.onMouseEnter(e, this.props.index);
  },

  _handleMouseLeave: function _handleMouseLeave(e) {
    if (!this.props.disabled && this.props.onMouseLeave) this.props.onMouseLeave(e, this.props.index);
  }
});

module.exports = MenuItem;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var Paper = __webpack_require__(54);
var EnhancedSwitch = __webpack_require__(356);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Toggle = React.createClass({
  displayName: 'Toggle',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    elementStyle: React.PropTypes.object,
    labelStyle: React.PropTypes.object,
    onToggle: React.PropTypes.func,
    toggled: React.PropTypes.bool,
    defaultToggled: React.PropTypes.bool
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      switched: this.props.toggled || this.props.defaultToggled || this.props.valueLink && this.props.valueLink.value || false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.toggle;
  },

  getStyles: function getStyles() {
    var toggleSize = 20;
    var toggleTrackWidth = 36;
    var styles = {
      icon: {
        width: 36,
        padding: '4px 0px 6px 2px'
      },
      toggleElement: {
        width: toggleTrackWidth
      },
      track: {
        transition: Transitions.easeOut(),
        width: '100%',
        height: 14,
        borderRadius: 30,
        backgroundColor: this.getTheme().trackOffColor
      },
      thumb: {
        transition: Transitions.easeOut(),
        position: 'absolute',
        top: 1,
        left: 0,
        width: toggleSize,
        height: toggleSize,
        lineHeight: '24px',
        borderRadius: '50%',
        backgroundColor: this.getTheme().thumbOffColor
      },
      trackWhenSwitched: {
        backgroundColor: this.getTheme().trackOnColor
      },
      thumbWhenSwitched: {
        backgroundColor: this.getTheme().thumbOnColor,
        left: '100%'
      },
      trackWhenDisabled: {
        backgroundColor: this.getTheme().trackDisabledColor
      },
      thumbWhenDisabled: {
        backgroundColor: this.getTheme().thumbDisabledColor
      },
      label: {
        color: this.props.disabled ? this.getTheme().labelDisabledColor : this.getTheme().labelColor,
        width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)'
      }
    };

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var onToggle = _props.onToggle;

    var other = _objectWithoutProperties(_props, ['onToggle']);

    var styles = this.getStyles();

    var trackStyles = this.mergeStyles(styles.track, this.props.trackStyle, this.state.switched && styles.trackWhenSwitched, this.props.disabled && styles.trackWhenDisabled);

    var thumbStyles = this.mergeStyles(styles.thumb, this.props.thumbStyle, this.state.switched && styles.thumbWhenSwitched, this.props.disabled && styles.thumbWhenDisabled);

    if (this.state.switched) {
      thumbStyles.marginLeft = '-' + thumbStyles.width;
    }

    var toggleElementStyles = this.mergeStyles(styles.toggleElement, this.props.elementStyle);

    var toggleElement = React.createElement(
      'div',
      { style: this.prepareStyles(toggleElementStyles) },
      React.createElement('div', { style: this.prepareStyles(trackStyles) }),
      React.createElement(Paper, { style: thumbStyles, circle: true, zDepth: 1 })
    );

    var customRippleStyle = this.mergeStyles({
      top: -10,
      left: -10
    }, this.props.rippleStyle);

    var rippleColor = this.state.switched ? this.getTheme().thumbOnColor : this.state.muiTheme.textColor;

    var iconStyle = this.mergeStyles(styles.icon, this.props.iconStyle);

    var labelStyle = this.mergeStyles(styles.label, this.props.labelStyle);

    var enhancedSwitchProps = {
      ref: "enhancedSwitch",
      inputType: "checkbox",
      switchElement: toggleElement,
      rippleStyle: customRippleStyle,
      rippleColor: rippleColor,
      iconStyle: iconStyle,
      trackStyle: trackStyles,
      thumbStyle: thumbStyles,
      labelStyle: labelStyle,
      switched: this.state.switched,
      onSwitch: this._handleToggle,
      onParentShouldUpdate: this._handleStateChange,
      defaultSwitched: this.props.defaultToggled,
      labelPosition: this.props.labelPosition ? this.props.labelPosition : "left"
    };

    if (this.props.hasOwnProperty('toggled')) enhancedSwitchProps.checked = this.props.toggled;

    return React.createElement(EnhancedSwitch, _extends({}, other, enhancedSwitchProps));
  },

  isToggled: function isToggled() {
    return this.refs.enhancedSwitch.isSwitched();
  },

  setToggled: function setToggled(newToggledValue) {
    this.refs.enhancedSwitch.setSwitched(newToggledValue);
  },

  _handleToggle: function _handleToggle(e, isInputChecked) {
    if (this.props.onToggle) this.props.onToggle(e, isInputChecked);
  },

  _handleStateChange: function _handleStateChange(newSwitched) {
    this.setState({ switched: newSwitched });
  }

});

module.exports = Toggle;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var KeyCode = __webpack_require__(79);
var DropDownArrow = __webpack_require__(363);
var Paper = __webpack_require__(54);
var Menu = __webpack_require__(247);
var ClearFix = __webpack_require__(191);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var DropDownMenu = React.createClass({
  displayName: 'DropDownMenu',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  // The nested styles for drop-down-menu are modified by toolbar and possibly
  // other user components, so it will give full access to its js styles rather
  // than just the parent.
  propTypes: {
    className: React.PropTypes.string,
    displayMember: React.PropTypes.string,
    valueMember: React.PropTypes.string,
    autoWidth: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
    onChange: React.PropTypes.func,
    menuItems: React.PropTypes.array.isRequired,
    menuItemStyle: React.PropTypes.object,
    underlineStyle: React.PropTypes.object,
    iconStyle: React.PropTypes.object,
    labelStyle: React.PropTypes.object,
    selectedIndex: React.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autoWidth: true,
      disabled: false,
      valueMember: 'payload',
      displayMember: 'text'
    };
  },

  getInitialState: function getInitialState() {
    return {
      open: false,
      selectedIndex: this._isControlled() ? null : this.props.selectedIndex || 0,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  componentDidMount: function componentDidMount() {
    if (this.props.autoWidth) this._setWidth();
    if (this.props.hasOwnProperty('selectedIndex')) this._setSelectedIndex(this.props);
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });

    if (this.props.autoWidth) this._setWidth();
    if (nextProps.hasOwnProperty('value') || nextProps.hasOwnProperty('valueLink')) {
      return;
    } else if (nextProps.hasOwnProperty('selectedIndex')) {
      this._setSelectedIndex(nextProps);
    }
  },

  getStyles: function getStyles() {
    var disabled = this.props.disabled;

    var zIndex = 5; // As AppBar
    var spacing = this.state.muiTheme.rawTheme.spacing;
    var accentColor = this.state.muiTheme.dropDownMenu.accentColor;
    var backgroundColor = this.state.muiTheme.menu.backgroundColor;
    var styles = {
      root: {
        transition: Transitions.easeOut(),
        position: 'relative',
        display: 'inline-block',
        height: spacing.desktopSubheaderHeight,
        fontSize: spacing.desktopDropDownMenuFontSize,
        outline: 'none'
      },
      control: {
        cursor: disabled ? 'not-allowed' : 'pointer',
        position: 'static',
        height: '100%'
      },
      controlBg: {
        transition: Transitions.easeOut(),
        backgroundColor: backgroundColor,
        height: '100%',
        width: '100%',
        opacity: 0
      },
      icon: {
        position: 'absolute',
        top: (spacing.desktopToolbarHeight - 24) / 2,
        right: spacing.desktopGutterLess,
        fill: this.state.muiTheme.dropDownMenu.accentColor
      },
      label: {
        transition: Transitions.easeOut(),
        lineHeight: spacing.desktopToolbarHeight + 'px',
        position: 'absolute',
        paddingLeft: spacing.desktopGutter,
        top: 0,
        opacity: 1,
        color: disabled ? this.state.muiTheme.rawTheme.palette.disabledColor : this.state.muiTheme.rawTheme.palette.textColor
      },
      underline: {
        borderTop: 'solid 1px ' + accentColor,
        margin: '-1px ' + spacing.desktopGutter + 'px'
      },
      menu: {
        zIndex: zIndex + 1
      },
      menuItem: {
        paddingRight: spacing.iconSize + spacing.desktopGutterLess + spacing.desktopGutterMini,
        height: spacing.desktopDropDownMenuItemHeight,
        lineHeight: spacing.desktopDropDownMenuItemHeight + 'px',
        whiteSpace: 'nowrap'
      },
      rootWhenOpen: {
        opacity: 1
      },
      labelWhenOpen: {
        opacity: 0,
        top: spacing.desktopToolbarHeight / 2
      },
      overlay: {
        height: '100%',
        width: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: zIndex
      }
    };

    return styles;
  },

  getInputNode: function getInputNode() {
    var root = this.refs.root;
    var item = this.props.menuItems[this.state.selectedIndex];
    if (item) {
      root.value = item[this.props.displayMember];
    }

    return root;
  },

  render: function render() {
    var _props = this.props;
    var autoWidth = _props.autoWidth;
    var className = _props.className;
    var onFocus = _props.onFocus;
    var onBlur = _props.onBlur;
    var style = _props.style;
    var displayMember = _props.displayMember;
    var valueMember = _props.valueMember;
    var valueLink = _props.valueLink;
    var labelStyle = _props.labelStyle;
    var iconStyle = _props.iconStyle;
    var underlineStyle = _props.underlineStyle;
    var menuItemStyle = _props.menuItemStyle;

    var other = _objectWithoutProperties(_props, ['autoWidth', 'className', 'onFocus', 'onBlur', 'style', 'displayMember', 'valueMember', 'valueLink', 'labelStyle', 'iconStyle', 'underlineStyle', 'menuItemStyle']);

    var styles = this.getStyles();
    var selectedIndex = this._isControlled() ? null : this.state.selectedIndex;
    var displayValue = "";
    if (selectedIndex) {
      if (false) {
        console.assert(!!this.props.menuItems[selectedIndex], 'SelectedIndex of ' + selectedIndex + ' does not exist in menuItems.');
      }
    } else if (valueMember && this._isControlled()) {
      var value = this.props.hasOwnProperty('value') ? this.props.value : valueLink.value;
      if (value !== null && value !== undefined) {
        for (var i = 0; i < this.props.menuItems.length; i++) {
          if (this.props.menuItems[i][valueMember] === value) {
            selectedIndex = i;
          }
        }
      }
    }

    var selectedItem = this.props.menuItems[selectedIndex];
    if (selectedItem) {
      displayValue = selectedItem[displayMember];
    }

    var menuItems = this.props.menuItems.map(function (item) {
      item.text = item[displayMember];
      item.payload = item[valueMember];
      return item;
    });

    return React.createElement(
      'div',
      _extends({}, other, {
        ref: 'root',
        onKeyDown: this._onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        className: className,
        style: this.prepareStyles(styles.root, this.state.open && styles.rootWhenOpen, style) }),
      React.createElement(
        ClearFix,
        { style: this.mergeStyles(styles.control), onTouchTap: this._onControlClick },
        React.createElement(Paper, { style: this.mergeStyles(styles.controlBg), zDepth: 0 }),
        React.createElement(
          'div',
          { style: this.prepareStyles(styles.label, this.state.open && styles.labelWhenOpen, labelStyle) },
          displayValue
        ),
        React.createElement(DropDownArrow, { style: this.mergeStyles(styles.icon, iconStyle) }),
        React.createElement('div', { style: this.prepareStyles(styles.underline, underlineStyle) })
      ),
      React.createElement(Menu, {
        ref: 'menuItems',
        autoWidth: autoWidth,
        selectedIndex: selectedIndex,
        menuItems: menuItems,
        style: styles.menu,
        menuItemStyle: this.mergeStyles(styles.menuItem, menuItemStyle),
        hideable: true,
        visible: this.state.open,
        onRequestClose: this._onMenuRequestClose,
        onItemTap: this._onMenuItemClick }),
      this.state.open && React.createElement('div', { style: this.prepareStyles(styles.overlay), onTouchTap: this._handleOverlayTouchTap })
    );
  },

  _setWidth: function _setWidth() {
    var el = ReactDOM.findDOMNode(this);
    var menuItemsDom = ReactDOM.findDOMNode(this.refs.menuItems);
    if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
      el.style.width = 'auto';
      el.style.width = menuItemsDom.offsetWidth + 'px';
    }
  },

  _setSelectedIndex: function _setSelectedIndex(props) {
    var selectedIndex = props.selectedIndex;

    if (false) {
      console.warn('Cannot set selectedIndex to a negative index.', selectedIndex);
    }

    this.setState({ selectedIndex: selectedIndex > -1 ? selectedIndex : 0 });
  },

  _onControlClick: function _onControlClick() {
    if (!this.props.disabled) {
      this.setState({ open: !this.state.open });
    }
  },

  _onKeyDown: function _onKeyDown(e) {
    switch (e.which) {
      case KeyCode.UP:
        if (!this.state.open) {
          this._selectPreviousItem();
        } else {
          if (e.altKey) {
            this.setState({ open: false });
          }
        }
        break;
      case KeyCode.DOWN:
        if (!this.state.open) {
          if (e.altKey) {
            this.setState({ open: true });
          } else {
            this._selectNextItem();
          }
        }
        break;
      case KeyCode.ENTER:
      case KeyCode.SPACE:
        this.setState({ open: true });
        break;
      default:
        return; //important
    }
    e.preventDefault();
  },

  _onMenuItemClick: function _onMenuItemClick(e, key, payload) {
    if (this.props.onChange && this.state.selectedIndex !== key) {
      var selectedItem = this.props.menuItems[key];
      if (selectedItem) {
        e.target.value = selectedItem[this.props.valueMember];
      }

      if (this.props.valueLink) {
        this.props.valueLink.requestChange(e.target.value);
      } else {
        this.props.onChange(e, key, payload);
      }
    }

    this.setState({
      selectedIndex: key,
      value: e.target.value,
      open: false
    });
  },

  _onMenuRequestClose: function _onMenuRequestClose() {
    this.setState({ open: false });
  },

  _selectPreviousItem: function _selectPreviousItem() {
    this.setState({ selectedIndex: Math.max(this.state.selectedIndex - 1, 0) });
  },

  _selectNextItem: function _selectNextItem() {
    this.setState({ selectedIndex: Math.min(this.state.selectedIndex + 1, this.props.menuItems.length - 1) });
  },

  _handleOverlayTouchTap: function _handleOverlayTouchTap() {
    this.setState({
      open: false
    });
  },

  _isControlled: function _isControlled() {
    return this.props.hasOwnProperty('value') || this.props.hasOwnProperty('valueLink');
  }

});

module.exports = DropDownMenu;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

module.exports = {

  propTypes: {
    onChange: React.PropTypes.func,
    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array]),
    valueLink: React.PropTypes.shape({
      value: React.PropTypes.string.isRequired,
      requestChange: React.PropTypes.func.isRequired
    })
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onChange: function onChange() {}
    };
  },

  getValueLink: function getValueLink(props) {
    return props.valueLink || {
      value: props.value,
      requestChange: props.onChange
    };
  }

};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var ListDivider = React.createClass({
  displayName: 'ListDivider',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    inset: React.PropTypes.bool
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _props = this.props;
    var inset = _props.inset;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['inset', 'style']);

    var mergedStyles = this.mergeStyles({
      margin: 0,
      marginTop: -1,
      marginLeft: inset ? 72 : 0,
      height: 1,
      border: 'none',
      backgroundColor: this.state.muiTheme.rawTheme.palette.borderColor
    }, style);

    return React.createElement('hr', _extends({}, other, { style: this.prepareStyles(mergedStyles) }));
  }
});

module.exports = ListDivider;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationArrowDropUp = React.createClass({
  displayName: 'NavigationArrowDropUp',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 14l5-5 5 5z' })
    );
  }

});

module.exports = NavigationArrowDropUp;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var EnhancedSwitch = __webpack_require__(356);
var RadioButtonOff = __webpack_require__(539);
var RadioButtonOn = __webpack_require__(540);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var RadioButton = React.createClass({
  displayName: 'RadioButton',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  propTypes: {
    iconStyle: React.PropTypes.object,
    labelStyle: React.PropTypes.object,
    onCheck: React.PropTypes.func
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.radioButton;
  },

  getStyles: function getStyles() {
    var styles = {
      icon: {
        height: this.getTheme().size,
        width: this.getTheme().size
      },
      target: {
        transition: Transitions.easeOut(),
        position: 'absolute',
        opacity: 1,
        transform: 'scale(1)',
        fill: this.getTheme().borderColor
      },
      fill: {
        position: 'absolute',
        opacity: 1,
        transform: 'scale(0)',
        transformOrigin: '50% 50%',
        transition: Transitions.easeOut(),
        fill: this.getTheme().checkedColor
      },
      targetWhenChecked: {
        opacity: 0,
        transform: 'scale(0)'
      },
      fillWhenChecked: {
        opacity: 1,
        transform: 'scale(1)'
      },
      targetWhenDisabled: {
        fill: this.getTheme().disabledColor
      },
      fillWhenDisabled: {
        fill: this.getTheme().disabledColor
      },
      label: {
        color: this.props.disabled ? this.getTheme().labelDisabledColor : this.getTheme().labelColor
      }
    };

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var onCheck = _props.onCheck;

    var other = _objectWithoutProperties(_props, ['onCheck']);

    var styles = this.getStyles();
    var onStyles = this.mergeStyles(styles.target, this.props.checked && styles.targetWhenChecked, this.props.iconStyle, this.props.disabled && styles.targetWhenDisabled);
    var offStyles = this.mergeStyles(styles.fill, this.props.checked && styles.fillWhenChecked, this.props.iconStyle, this.props.disabled && styles.fillWhenDisabled);

    var radioButtonElement = React.createElement(
      'div',
      null,
      React.createElement(RadioButtonOff, { style: onStyles }),
      React.createElement(RadioButtonOn, { style: offStyles })
    );

    var rippleColor = this.props.checked ? this.getTheme().checkedColor : this.getTheme().borderColor;

    var iconStyle = this.mergeStyles(styles.icon, this.props.iconStyle);

    var labelStyle = this.mergeStyles(styles.label, this.props.labelStyle);

    var enhancedSwitchProps = {
      ref: "enhancedSwitch",
      inputType: "radio",
      switched: this.props.checked || false,
      switchElement: radioButtonElement,
      rippleColor: rippleColor,
      iconStyle: iconStyle,
      labelStyle: labelStyle,
      onSwitch: this._handleCheck,
      onParentShouldUpdate: this._handleStateChange,
      labelPosition: this.props.labelPosition ? this.props.labelPosition : "right"
    };

    return React.createElement(EnhancedSwitch, _extends({}, other, enhancedSwitchProps));
  },

  // Only called when selected, not when unselected.
  _handleCheck: function _handleCheck(e) {
    if (this.props.onCheck) this.props.onCheck(e, this.props.value);
  },

  _handleStateChange: function _handleStateChange() {},

  isChecked: function isChecked() {
    return this.refs.enhancedSwitch.isSwitched();
  },

  // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
  // RadioButton's checked value.
  setChecked: function setChecked(newCheckedValue) {
    this.refs.enhancedSwitch.setSwitched(newCheckedValue);
  },

  getValue: function getValue() {
    return this.refs.enhancedSwitch.getValue();
  }

});

module.exports = RadioButton;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ToggleRadioButtonUnchecked = React.createClass({
  displayName: 'ToggleRadioButtonUnchecked',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
    );
  }

});

module.exports = ToggleRadioButtonUnchecked;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ToggleRadioButtonChecked = React.createClass({
  displayName: 'ToggleRadioButtonChecked',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
    );
  }

});

module.exports = ToggleRadioButtonChecked;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var Tooltip = __webpack_require__(353);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var TableHeaderColumn = React.createClass({
  displayName: 'TableHeaderColumn',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    columnNumber: React.PropTypes.number,
    onClick: React.PropTypes.func,
    style: React.PropTypes.object,
    tooltip: React.PropTypes.string,
    tooltipStyle: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme),
      hovered: false
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.tableHeaderColumn;
  },

  getStyles: function getStyles() {
    var theme = this.getTheme();
    var styles = {
      root: {
        fontWeight: 'normal',
        fontSize: 12,
        paddingLeft: theme.spacing,
        paddingRight: theme.spacing,
        height: theme.height,
        textAlign: 'left',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        color: this.getTheme().textColor,
        position: 'relative'
      },
      tooltip: {
        boxSizing: 'border-box',
        marginTop: theme.height / 2
      }
    };

    return styles;
  },

  render: function render() {
    var styles = this.getStyles();
    var handlers = {
      onMouseEnter: this._onMouseEnter,
      onMouseLeave: this._onMouseLeave,
      onClick: this._onClick
    };
    var _props = this.props;
    var className = _props.className;
    var columnNumber = _props.columnNumber;
    var onClick = _props.onClick;
    var style = _props.style;
    var tooltip = _props.tooltip;
    var tooltipStyle = _props.tooltipStyle;

    var other = _objectWithoutProperties(_props, ['className', 'columnNumber', 'onClick', 'style', 'tooltip', 'tooltipStyle']);

    var classes = 'mui-table-header-column';
    if (className) classes += ' ' + className;

    if (this.props.tooltip !== undefined) {
      tooltip = React.createElement(Tooltip, {
        label: this.props.tooltip,
        show: this.state.hovered,
        style: this.mergeStyles(styles.tooltip, tooltipStyle) });
    }

    return React.createElement(
      'th',
      _extends({
        key: this.props.key,
        className: classes,
        style: this.prepareStyles(styles.root, style)
      }, handlers, other),
      tooltip,
      this.props.children
    );
  },

  _onMouseEnter: function _onMouseEnter() {
    if (this.props.tooltip !== undefined) this.setState({ hovered: true });
  },

  _onMouseLeave: function _onMouseLeave() {
    if (this.props.tooltip !== undefined) this.setState({ hovered: false });
  },

  _onClick: function _onClick(e) {
    if (this.props.onClick) this.props.onClick(e, this.props.columnNumber);
  }

});

module.exports = TableHeaderColumn;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var ClockNumber = React.createClass({
  displayName: 'ClockNumber',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    value: React.PropTypes.number,
    type: React.PropTypes.oneOf(['hour', 'minute']),
    onSelected: React.PropTypes.func,
    isSelected: React.PropTypes.bool
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getDefaultProps: function getDefaultProps() {
    return {
      value: 0,
      type: 'minute',
      isSelected: false
    };
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.timePicker;
  },

  render: function render() {
    var pos = this.props.value;
    var inner = false;

    if (this.props.type === "hour") {
      inner = pos < 1 || pos > 12;
      pos %= 12;
    } else {
      pos = pos / 5;
    }

    var positions = [[0, 5], [54.5, 16.6], [94.4, 59.5], [109, 114], [94.4, 168.5], [54.5, 208.4], [0, 223], [-54.5, 208.4], [-94.4, 168.5], [-109, 114], [-94.4, 59.5], [-54.5, 19.6]];

    var innerPositions = [[0, 40], [36.9, 49.9], [64, 77], [74, 114], [64, 151], [37, 178], [0, 188], [-37, 178], [-64, 151], [-74, 114], [-64, 77], [-37, 50]];

    var styles = {
      root: {
        display: "inline-block",
        position: "absolute",
        width: 32,
        height: 32,
        borderRadius: "100%",
        left: 'calc(50% - 16px)',
        top: 10,
        textAlign: "center",
        paddingTop: 5,
        userSelect: "none", /* Chrome all / Safari all */
        fontSize: "1.1em",
        pointerEvents: "none",
        boxSizing: "border-box"
      }
    };

    if (this.props.isSelected) {
      styles.root.backgroundColor = this.getTheme().accentColor;
      styles.root.color = this.getTheme().selectTextColor;
    }

    var transformPos = positions[pos];

    if (inner) {
      styles.root.width = "28px";
      styles.root.height = "28px";
      styles.root.left = 'calc(50% - 14px)';
      transformPos = innerPositions[pos];
    }

    var _transformPos = transformPos;

    var _transformPos2 = _slicedToArray(_transformPos, 2);

    var x = _transformPos2[0];
    var y = _transformPos2[1];

    styles.root.transform = "translate(" + x + "px, " + y + "px)";

    return React.createElement(
      'span',
      { style: this.prepareStyles(styles.root) },
      this.props.value
    );
  }
});

module.exports = ClockNumber;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var ClockPointer = React.createClass({
  displayName: 'ClockPointer',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    value: React.PropTypes.number,
    type: React.PropTypes.oneOf(['hour', 'minute'])
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      inner: this.isInner(this.props.value),
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      value: null,
      type: 'minute',
      hasSelected: false
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({
      inner: this.isInner(nextProps.value),
      muiTheme: newMuiTheme
    });
  },

  isInner: function isInner(value) {
    if (this.props.type !== "hour") {
      return false;
    }
    return value < 1 || value > 12;
  },

  getAngle: function getAngle() {
    if (this.props.type === "hour") {
      return this.calcAngle(this.props.value, 12);
    }

    return this.calcAngle(this.props.value, 60);
  },

  calcAngle: function calcAngle(value, base) {
    value %= base;
    var angle = 360 / base * value;
    return angle;
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.timePicker;
  },

  render: function render() {
    if (this.props.value === null) {
      return React.createElement('span', null);
    }

    var angle = this.getAngle();

    var styles = {
      root: {
        height: "30%",
        background: this.getTheme().accentColor,
        width: 2,
        left: 'calc(50% - 1px)',
        position: "absolute",
        bottom: "50%",
        transformOrigin: "bottom",
        pointerEvents: "none",
        transform: "rotateZ(" + angle + "deg)"
      },
      mark: {
        background: this.getTheme().selectTextColor,
        border: "4px solid " + this.getTheme().accentColor,
        width: 7,
        height: 7,
        position: "absolute",
        top: -5,
        left: -6,
        borderRadius: "100%"
      }
    };

    if (!this.state.inner) {
      styles.root.height = "40%";
    }

    if (this.props.hasSelected) {
      styles.mark.display = "none";
    }

    return React.createElement(
      'div',
      { style: this.prepareStyles(styles.root) },
      React.createElement('div', { style: this.prepareStyles(styles.mark) })
    );
  }
});

module.exports = ClockPointer;

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Icons__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Toolbar__ = __webpack_require__(80);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={root:{position:'absolute',left:-(Spacing.iconSize+Spacing.desktopGutterMini*4),top:0},icon:{margin:6},button:{lineHeight:36+'px',width:36,height:36,minWidth:36,verticalAlign:'middle'},withoutBorder:{border:'none',margin:0}};var Controls=function(_Component){_inherits(Controls,_Component);function Controls(props){_classCallCheck(this,Controls);var _this=_possibleConstructorReturn(this,(Controls.__proto__||Object.getPrototypeOf(Controls)).call(this,props));_this.state={isCancelResize:false};return _this;}_createClass(Controls,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.raw!==this.state.isCancelResize){this.setState({isCancelResize:nextProps.raw});}}},{key:'save',value:function save(){if(this.props.onSave){if(!this.props.raw&&!this.state.isCancelResize){this.props.onSave();}else{this.props.onSave({isCancelResize:this.state.isCancelResize});}}}},{key:'delete',value:function _delete(){if(this.props.onDelete){this.props.onDelete();}}},{key:'editMode',value:function editMode(){if(this.props.onEditMode){this.props.onEditMode();}}},{key:'cancelResize',value:function cancelResize(){this.setState({isCancelResize:!this.state.isCancelResize});}},{key:'render',value:function render(){var _props=this.props,mode=_props.mode,hoverColor=_props.hoverColor,opacity=_props.opacity,moduleName=_props.moduleName,other=_objectWithoutProperties(_props,['mode','hoverColor','opacity','moduleName']);var control=void 0;if(mode==='edit'){control=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Toolbar__["d" /* ToolbarGroup */],{style:styles.withoutBorder},moduleName&&moduleName==='image'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Toolbar__["c" /* ToolbarButton */],{tooltip:this.state.isCancelResize?this.context.getIntlMessage('settings.enableScaling'):this.context.getIntlMessage('settings.disableScaling'),onTouchTap:this.cancelResize.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Icons__["SizeSelect"],{color:this.state.isCancelResize?'#01c9cb':'#000',width:24,height:24})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Toolbar__["c" /* ToolbarButton */],{onTouchTap:this.save.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ActionVisibility"],{hoverColor:hoverColor})));}else{control=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Toolbar__["c" /* ToolbarButton */],{onTouchTap:this.editMode.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["EditorModeEdit"],{hoverColor:hoverColor}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Toolbar__["d" /* ToolbarGroup */],other,control,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Toolbar__["c" /* ToolbarButton */],{onTouchTap:this.delete.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ActionDelete"],{hoverColor:hoverColor})));// return (
//   <Bubble width={Spacing.iconSize + Spacing.desktopGutterMini} opacity={opacity} style={{root: styles.root}}>
//     {control}
//     <ToolbarButton style={styles.button} onTouchTap={::this.delete}>
//       <Icons.ActionDelete color={Colors.Colors.red[200].material} hoverColor={hoverColor}/>
//     </ToolbarButton>
//   </Bubble>
// );
}}]);return Controls;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Controls.displayName='Controls';Controls.propTypes={hoverColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,mode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOf(['edit','detail']),onSave:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onDelete:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onEditMode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,opacity:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,moduleName:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,raw:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};Controls.defaultProps={hoverColor:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material,opacity:1};Controls.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Controls);

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = __webpack_require__(164);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _Css = __webpack_require__(46);

var _css = __webpack_require__(194);

var _css2 = _interopRequireDefault(_css);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Delete = function (_Component) {
  _inherits(Delete, _Component);

  function Delete() {
    _classCallCheck(this, Delete);

    return _possibleConstructorReturn(this, (Delete.__proto__ || Object.getPrototypeOf(Delete)).apply(this, arguments));
  }

  _createClass(Delete, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _SvgIcon2.default,
        _extends({}, this.props, { className: _css2.default.inheritStroke }),
        _react2.default.createElement(
          'g',
          { strokeWidth: '2', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', transform: 'translate(2, 5)' },
          _react2.default.createElement('polyline', { points: '6 5 0 11 6 17' }),
          _react2.default.createElement('polyline', { points: '22 5 28 11 22 17' }),
          _react2.default.createElement('path', { d: 'M10,22 L18,0' })
        )
      );
    }
  }]);

  return Delete;
}(_react.Component);

Delete.defaultProps = {
  size: 32
};
exports.default = Delete;
module.exports = exports['default'];

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GridContainer=function(_Component){_inherits(GridContainer,_Component);function GridContainer(){_classCallCheck(this,GridContainer);return _possibleConstructorReturn(this,(GridContainer.__proto__||Object.getPrototypeOf(GridContainer)).apply(this,arguments));}_createClass(GridContainer,[{key:'render',value:function render(){var _props=this.props,className=_props.className,other=_objectWithoutProperties(_props,['className']);var classes=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(className,{container:!this.props.fluid,'container-fluid':this.props.fluid});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:classes},other),this.props.children);}}]);return GridContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);GridContainer.propTypes={fluid:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};GridContainer.defaultProps={fluid:false};/* harmony default export */ __webpack_exports__["a"] = (GridContainer);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GridRow=function(_Component){_inherits(GridRow,_Component);function GridRow(){_classCallCheck(this,GridRow);return _possibleConstructorReturn(this,(GridRow.__proto__||Object.getPrototypeOf(GridRow)).apply(this,arguments));}_createClass(GridRow,[{key:'render',value:function render(){var _props=this.props,className=_props.className,other=_objectWithoutProperties(_props,['className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('row',className)},other),this.props.children);}}]);return GridRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GridRow);

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GridCell=function(_Component){_inherits(GridCell,_Component);function GridCell(){_classCallCheck(this,GridCell);return _possibleConstructorReturn(this,(GridCell.__proto__||Object.getPrototypeOf(GridCell)).apply(this,arguments));}_createClass(GridCell,[{key:'render',value:function render(){var size=this.props.size,smallSize=this.props.smallSize||size,xSmallSize=this.props.xSmallSize||size,classes=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className,'col-md-'+size,'col-xs-'+xSmallSize,'col-sm-'+smallSize);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes,style:{transition:'0.25s all ease'}},this.props.children);}}]);return GridCell;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);GridCell.propTypes={size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number.isRequired,smallSize:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,xSmallSize:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number};GridCell.defaultProps={size:6,smallSize:null,xSmallSize:null};/* harmony default export */ __webpack_exports__["a"] = (GridCell);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var rgba=function rgba(input){var opacity=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var hex=input.replace('#','');var r=Math.ceil(parseInt(hex.substring(0,2),16));var g=Math.ceil(parseInt(hex.substring(2,4),16));var b=Math.ceil(parseInt(hex.substring(4,6),16));return'rgba('+r+', '+g+', '+b+', '+opacity+')';};var ThemeStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({data:{creen:{r:0,g:201,b:204},green:{r:39,g:174,b:96},blue:{r:52,g:152,b:219},blue2:{r:41,g:128,b:185},purple:{r:155,g:89,b:182},navyblue:{r:52,g:73,b:94},gray:{r:127,g:140,b:141},red:{r:192,g:57,b:43},lightgreen:{r:102,g:215,b:119},teal:{r:1,g:150,b:149},mustard:{r:146,g:144,b:25},darkblue:{r:16,g:84,b:147},golden:{r:209,g:206,b:98},mango:{r:249,g:195,b:50},pinktaco:{r:238,g:124,b:182},pinkster:{r:241,g:141,b:139},orange:{r:243,g:147,b:49},love:{r:168,g:51,b:81},purplehaze:{r:128,g:44,b:106},raspberry:{r:237,g:76,b:124}},getInitialState:function getInitialState(){return this.data;},getColor:function getColor(){var theme=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'creen';var alpha=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;if(!this.data[theme||'creen']){return rgba(theme||'creen',alpha);}else{}var color=this.data[theme||'creen'];return'rgba('+color.r+','+color.g+','+color.b+','+alpha+')';},getAllThemes:function getAllThemes(){return this.data;}});/* harmony default export */ __webpack_exports__["a"] = (ThemeStore);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
var UserStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["G" /* UserActions */]],data:{list:[],selected:null,loading:true},getInitialState:function getInitialState(){return this.data;},onFindReaders:function onFindReaders(){var showCourses=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var showCircles=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var _this=this;var sortBy=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'name';var sortMode=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'asc';this.data.loading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('user','findReaders',{showCourses:showCourses,showCircles:showCircles,sortBy:sortBy,sortMode:sortMode}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["G" /* UserActions */].findReadersComplete(response);},function(error){_this.data.loading=false;_this.trigger(_this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},onSelect:function onSelect(student){this.data.selected=student;this.trigger(this.data);},onFindReadersComplete:function onFindReadersComplete(data){this.data.list=data;this.data.loading=false;this.trigger(this.data);},addToCircle:function addToCircle(userId,circleId,callback){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('user','addToCircle',{userId:userId,circleId:circleId},function(){__WEBPACK_IMPORTED_MODULE_1_actions__["G" /* UserActions */].addToCircleComplete(callback);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},addToCircleComplete:function addToCircleComplete(callback){callback();},setCircleRole:function setCircleRole(userId,circleId,role){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('user','setCircleRole',{userId:userId,circleId:circleId,role:role},function(){__WEBPACK_IMPORTED_MODULE_1_actions__["G" /* UserActions */].setCircleRoleComplete();},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},setCircleRoleComplete:function setCircleRoleComplete(){},listPwned:function listPwned(){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('user','listPwned',{},function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["G" /* UserActions */].listPwnedComplete(response.data);});},listPwnedComplete:function listPwnedComplete(data){this.data.list=data;this.data.loading=false;this.trigger(this.data);},course:function course(id,userId,expires){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('access','course',{id:id,userId:userId,expires:expires},function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["G" /* UserActions */].courseComplete();},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},courseComplete:function courseComplete(){}});/* harmony default export */ __webpack_exports__["a"] = (UserStore);

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isObject = __webpack_require__(114);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UnionSchema = function () {
  function UnionSchema(itemSchema, options) {
    _classCallCheck(this, UnionSchema);

    if (!(0, _isObject2.default)(itemSchema)) {
      throw new Error('UnionSchema requires item schema to be an object.');
    }

    if (!options || !options.schemaAttribute) {
      throw new Error('UnionSchema requires schemaAttribute option.');
    }

    this._itemSchema = itemSchema;

    var schemaAttribute = options.schemaAttribute;
    this._getSchema = typeof schemaAttribute === 'function' ? schemaAttribute : function (x) {
      return x[schemaAttribute];
    };
  }

  _createClass(UnionSchema, [{
    key: 'getItemSchema',
    value: function getItemSchema() {
      return this._itemSchema;
    }
  }, {
    key: 'getSchemaKey',
    value: function getSchemaKey(item) {
      return this._getSchema(item);
    }
  }]);

  return UnionSchema;
}();

exports.default = UnionSchema;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    isObject = __webpack_require__(114);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 554 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(256),
    arraySome = __webpack_require__(2012),
    cacheHas = __webpack_require__(257);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 557 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(2022),
    isArguments = __webpack_require__(559),
    isArray = __webpack_require__(106),
    isBuffer = __webpack_require__(560),
    isIndex = __webpack_require__(561),
    isTypedArray = __webpack_require__(562);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(2023),
    isObjectLike = __webpack_require__(166);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(105),
    stubFalse = __webpack_require__(2024);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(372)(module)))

/***/ }),
/* 561 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(2025),
    baseUnary = __webpack_require__(373),
    nodeUtil = __webpack_require__(2026);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 563 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 564 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 565 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(139),
    root = __webpack_require__(105);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_SlidingPanel__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Widgets_ProfileHeaderContainer__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Widgets_ProfileLogoutContainer__ = __webpack_require__(2050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_MenuItem__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_lib_menus_menu_divider__ = __webpack_require__(2052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_lib_menus_menu_divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_lib_menus_menu_divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Material_CollapsibleMenu__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Icons__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_CoursioLogo__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_ScrollableContainer__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_4_material_ui__["Styles"].Spacing;var styles={icon:{display:'inline-block',verticalAlign:'middle',margin:'0 '+Spacing.desktopGutterMini+'px'}};var MainMenu=function(_mixin){_inherits(MainMenu,_mixin);function MainMenu(){_classCallCheck(this,MainMenu);return _possibleConstructorReturn(this,(MainMenu.__proto__||Object.getPrototypeOf(MainMenu)).apply(this,arguments));}_createClass(MainMenu,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_13_stores__["b" /* AuthStore */],function(state){return{role:state.role,username:state.username,roleMap:state.roleMap,incarnated:state.incarnated,features:state.features};});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_13_stores__["o" /* NotificationStore */],function(state){return{unreadNotifications:state.unreadNotifications};});}},{key:'getMenuItems',value:function getMenuItems(){var getIntlMessage=this.context.getIntlMessage;var _state=this.state,username=_state.username,unreadNotifications=_state.unreadNotifications;var base=[{route:'dashboard',text:getIntlMessage('menu.Dashboard'),icon:__WEBPACK_IMPORTED_MODULE_11_components_Icons__["Home"]},{route:'communication',text:getIntlMessage('menu.Notification'),icon:__WEBPACK_IMPORTED_MODULE_11_components_Icons__["Communication"],count:unreadNotifications<100?unreadNotifications:'100+'}];var mediaLibrary=[{divider:true},{route:'media-library',text:getIntlMessage('menu.mediaLibrary'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ActionPermMedia"]}];var userManagement=[{header:getIntlMessage('menu.StudentManagement'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["SocialPersonOutline"],menuItems:[{route:'tasks',text:getIntlMessage('menu.Tasks'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ActionAssignmentReturned"],count:!localStorage.getItem('new:seen')&&'new'},// { menu: 'app', text: getIntlMessage('menu.Back'), iconClassName: 'md md-keyboard-backspace' },
{route:'students',text:getIntlMessage('student.Students'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["SocialPersonOutline"]},{route:'groups',text:getIntlMessage('group.Groups'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["SocialPeopleOutline"]},{route:'courses',text:getIntlMessage('menu.Courses'),icon:__WEBPACK_IMPORTED_MODULE_11_components_Icons__["Library"]},{route:'invite',text:getIntlMessage('menu.Invite'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ContentAdd"]/*{ route: 'sub-accounts', text: getIntlMessage('menu.SubAccounts'), icon: MaterialIcons.CommunicationContacts}*/}]}];if(this.state.features&&this.state.features.quiz){userManagement[0].menuItems.unshift({route:'quiz',text:getIntlMessage('menu.Quiz'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ActionQuestionAnswer"],count:!localStorage.getItem('new:seen')&&'new'});}var store=[{header:getIntlMessage('menu.ECommerce'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ActionShoppingCart"],menuItems:[{route:'bundles',text:getIntlMessage('menu.Bundles'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["EditorBorderAll"]},{route:'transactions',text:getIntlMessage('menu.Transactions'),icon:__WEBPACK_IMPORTED_MODULE_11_components_Icons__["Sort"]},{route:'discounts',text:getIntlMessage('menu.Discounts'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ActionLabelOutline"]}]}];var settings=[{divider:true},{route:'settings',text:getIntlMessage('menu.Settings'),icon:__WEBPACK_IMPORTED_MODULE_11_components_Icons__["Settings"]// { route: 'logout', text: getIntlMessage('menu.Logout'), icon: MaterialIcons.ActionPowerSettingsNew },
}];var notes=[{divider:true},{route:'notes',text:getIntlMessage('menu.Notes'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ActionSpeakerNotes"],count:!localStorage.getItem('new:seen')&&'new'// { route: 'logout', text: getIntlMessage('menu.Logout'), icon: MaterialIcons.ActionPowerSettingsNew },
}];var stats=[{divider:true},{route:'statistics',text:getIntlMessage('menu.saleStats'),icon:__WEBPACK_IMPORTED_MODULE_11_components_Icons__["Stats"],count:!localStorage.getItem('new:seen')&&'new'// { route: 'logout', text: getIntlMessage('menu.Logout'), icon: MaterialIcons.ActionPowerSettingsNew },
}];var support=[{divider:true},{action:'reportBug',text:getIntlMessage('bug.report'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["CommunicationLiveHelp"]}];var incarnate=[{route:'incarnate',text:getIntlMessage('menu.Incarnate'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["SocialWhatshot"]}];var wakeUp=[{route:'wakeup',text:getIntlMessage('menu.Wakeup'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["SocialNotificationsActive"]}];var _state2=this.state,role=_state2.role,roleMap=_state2.roleMap,incarnated=_state2.incarnated;var menuItems=void 0;if(role.editor){menuItems=[{action:'readerMode',text:getIntlMessage('settings.readerMode'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ActionVisibility"]}];}else if(role.reader&&roleMap.editor){menuItems=[{action:'builderMode',text:getIntlMessage('settings.builderMode'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ContentCreate"]}];}else{menuItems=[];}role.owner&&store[0].menuItems.unshift({route:'store/'+username,text:getIntlMessage('menu.Store'),icon:__WEBPACK_IMPORTED_MODULE_12_components_Material_SvgIcons__["ActionShoppingCart"]});menuItems=menuItems.concat(role.reader?base:[]);menuItems=menuItems.concat(role.reader?notes:[]);menuItems=menuItems.concat(mediaLibrary);menuItems=menuItems.concat(role.teacher?userManagement:[]);menuItems=menuItems.concat(role.teacher||role.accountant?store:[]);menuItems=menuItems.concat(role.teacher||role.accountant?stats:[]);menuItems=menuItems.concat(settings);if(role.assistant){menuItems=menuItems.concat(incarnate);}if(incarnated){menuItems=menuItems.concat(wakeUp);}menuItems=menuItems.concat(support);return menuItems;}},{key:'_onMenuItemClick',value:function _onMenuItemClick(payload,event){if(!localStorage.getItem('new:seen')&&payload.count==='new'){localStorage.setItem('new:seen',true);}if(payload.action){this.handleAction(payload.action);}else{this.props.onChange(event,null,payload);}this.close();}},{key:'handleAction',value:function handleAction(action){var locales=this.context.locales;console.log('laca',locales);if(action==='reportBug'){if(locales[0]==='sv-SE'){window.location.replace('https://support.coursio.com/hc/sv');}else{window.location.replace('https://support.coursio.com/hc/en-us');}return;}if(this[action]){this[action]();}}},{key:'builderMode',value:function builderMode(){__WEBPACK_IMPORTED_MODULE_3_actions__["b" /* AuthActions */].builderMode();}},{key:'readerMode',value:function readerMode(){__WEBPACK_IMPORTED_MODULE_3_actions__["b" /* AuthActions */].readerMode();}},{key:'reportBug',value:function reportBug(){__WEBPACK_IMPORTED_MODULE_3_actions__["a" /* AppActions */].showReportBugDialog();}},{key:'renderMenu',value:function renderMenu(menuItems){var _this2=this;var children=[];menuItems.forEach(function(menuItem,index){if(menuItem.menuItems){children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_lib_menus_menu_divider___default.a,{style:{color:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite},key:'d'+index}));children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_CollapsibleMenu__["a" /* default */],{iconColor:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,menuItemStyle:{color:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite},icon:menuItem.icon,iconClassName:menuItem.iconClassName,initialExpanded:false,onItemTap:_this2._onMenuItemClick.bind(_this2),key:index,menuItems:menuItem.menuItems,header:menuItem.header}));}else if(menuItem.divider){children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_lib_menus_menu_divider___default.a,{key:'d'+index}));}else{var leftIcon=void 0;if(menuItem.icon){leftIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(menuItem.icon,{style:styles.icon,color:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite});}else{leftIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["FontIcon"],{color:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,className:menuItem.iconClassName});}children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_MenuItem__["a" /* default */],{count:menuItem.count,style:{color:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite},onTouchTap:_this2._onMenuItemClick.bind(_this2,menuItem),primaryText:menuItem.text,key:index,index:index,leftIcon:leftIcon}));}});return children;}},{key:'listenToActions',value:function listenToActions(){var _this3=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_3_actions__["a" /* AppActions */].toggleAppBar,function(){_this3.toggle();});}},{key:'createPanel',value:function createPanel(open){var menuItems=this.getMenuItems();var menu=this.renderMenu(menuItems);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_ScrollableContainer__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Widgets_ProfileHeaderContainer__["a" /* default */],null),style:this.getPanelStyle(open)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,menu),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini,textAlign:'center',marginTop:Spacing.desktopGutter}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CoursioLogo__["a" /* default */],{initialFill:'#ffffff',size:100,width:'48px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini,textAlign:'center',marginTop:Spacing.desktopGutter,paddingLeft:Spacing.desktopGutterMini*3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Widgets_ProfileLogoutContainer__["a" /* default */],null)));}}]);return MainMenu;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_1_components_SlidingPanel__["a" /* default */]));MainMenu.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,locales:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};/* harmony default export */ __webpack_exports__["a"] = (MainMenu);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var css={count:'_e9'};var MenuItem=function(_Component){_inherits(MenuItem,_Component);function MenuItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MenuItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MenuItem.__proto__||Object.getPrototypeOf(MenuItem)).call.apply(_ref,[this].concat(args))),_this),_this.state={mouseOver:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MenuItem,[{key:'getStyle',value:function getStyle(){var style=this.props.style;var mouseOver=this.state.mouseOver;return Object.assign({},{position:'relative',cursor:'pointer',backgroundColor:mouseOver?'rgba(255, 255, 255, 0.2)':'transparent',paddingLeft:Spacing.desktopGutterMini,paddingRight:Spacing.desktopGutterMini,height:48,lineHeight:'48px',fontSize:'16px'},style);}},{key:'handleMouseEnter',value:function handleMouseEnter(){this.setState({mouseOver:true});}},{key:'handleMouseLeave',value:function handleMouseLeave(){this.setState({mouseOver:false});}},{key:'render',value:function render(){var _props=this.props,leftIcon=_props.leftIcon,primaryText=_props.primaryText,children=_props.children,style=_props.style,count=_props.count,other=_objectWithoutProperties(_props,['leftIcon','primaryText','children','style','count']);var hasCount=!!count;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},other,{style:this.getStyle(),onMouseEnter:this.handleMouseEnter.bind(this),onMouseLeave:this.handleMouseLeave.bind(this)}),leftIcon,primaryText,children,hasCount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.count},count));}}]);return MenuItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MenuItem.propTypes={style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,primaryText:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (MenuItem);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AppSnackBar=function(_Component){_inherits(AppSnackBar,_Component);function AppSnackBar(){_classCallCheck(this,AppSnackBar);return _possibleConstructorReturn(this,(AppSnackBar.__proto__||Object.getPrototypeOf(AppSnackBar)).apply(this,arguments));}_createClass(AppSnackBar,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.message!==nextProps.message&&nextProps.message&&nextProps.message!==''){this.refs.snackbar.show();}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){if(!nextProps.message||nextProps.message===this.props.message){return false;}return true;}},{key:'reset',value:function reset(){__WEBPACK_IMPORTED_MODULE_2_actions__["q" /* MessageActions */].clearMessage();}},{key:'render',value:function render(){var _props=this.props,message=_props.message,translate=_props.translate;var messageText=translate?this.context.getIntlMessage(message):message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Snackbar"],{Snackbar:true,autoHideDuration:3000,style:{fontSize:'12px',lineHeight:1.5,padding:10},ref:'snackbar',message:messageText||'',onDismiss:this.reset.bind(this)});}}]);return AppSnackBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AppSnackBar.displayName='AppSnackBar';AppSnackBar.propTypes={message:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,translate:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};AppSnackBar.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (AppSnackBar);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Portal__ = __webpack_require__(113);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MessagePortal=function(_Component){_inherits(MessagePortal,_Component);function MessagePortal(){_classCallCheck(this,MessagePortal);return _possibleConstructorReturn(this,(MessagePortal.__proto__||Object.getPrototypeOf(MessagePortal)).apply(this,arguments));}_createClass(MessagePortal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Portal__["a" /* default */],{style:{zIndex:999,position:'absolute'}},this.props.children);}}]);return MessagePortal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MessagePortal.displayName='MessagePortal';/* harmony default export */ __webpack_exports__["a"] = (MessagePortal);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Mixins_ControlsMixin__ = __webpack_require__(2062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Dashboard_CourseDetails__ = __webpack_require__(2068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_Dashboard__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_FullWidthPane__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_SearchBarToolbar__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_oxygen_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _templateObject=_taggedTemplateLiteral(['New release'],['New release']),_templateObject2=_taggedTemplateLiteral(['fix tasks'],['fix tasks']),_templateObject3=_taggedTemplateLiteral(['New statistics'],['New statistics']),_templateObject4=_taggedTemplateLiteral(['Change password'],['Change password']),_templateObject5=_taggedTemplateLiteral(['Quiz functionality'],['Quiz functionality']),_templateObject6=_taggedTemplateLiteral(['New'],['New']),_templateObject7=_taggedTemplateLiteral(['here'],['here']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Spacing=__WEBPACK_IMPORTED_MODULE_5_material_ui__["Styles"].Spacing;var ContentAdd=__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentAdd"],NavigationCancel=__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationCancel"];var messages=[{id:1,text:function text(event){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:0,color:'white',height:'100%',position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_17_oxygen_i18n__["translate"])(_templateObject)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_17_oxygen_i18n__["translate"])(_templateObject2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_17_oxygen_i18n__["translate"])(_templateObject3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_17_oxygen_i18n__["translate"])(_templateObject4)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_17_oxygen_i18n__["translate"])(_templateObject5)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationCancel,{onClick:event,style:styles.cancel}));}},{id:2,text:function text(event){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:0,color:'white',height:'100%',position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{margin:0}},Object(__WEBPACK_IMPORTED_MODULE_17_oxygen_i18n__["translate"])(_templateObject6),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{color:'white',textDecoration:'underline'},target:'_blank',rel:'noopener',href:'https://coursio.com/new/'},Object(__WEBPACK_IMPORTED_MODULE_17_oxygen_i18n__["translate"])(_templateObject7))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationCancel,{onClick:event,style:styles.cancel}));}}];var courseControls={menuItems:{default:[// {menu: 'settings', icon: 'cog'},
{menu:'edit',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentCreate"],{color:__WEBPACK_IMPORTED_MODULE_12_components_Material_Styles_Colors__["a" /* Colors */].fullBlack})}],edit:[{onTouchTap:'save',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDone"],{color:__WEBPACK_IMPORTED_MODULE_12_components_Material_Styles_Colors__["a" /* Colors */].fullBlack})},{onTouchTap:'cancel',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentClear"],{color:__WEBPACK_IMPORTED_MODULE_12_components_Material_Styles_Colors__["a" /* Colors */].fullBlack})},{onTouchTap:'duplicate',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentContentCopy"],{color:__WEBPACK_IMPORTED_MODULE_12_components_Material_Styles_Colors__["a" /* Colors */].fullBlack})},{onTouchTap:'delete',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDelete"],{color:__WEBPACK_IMPORTED_MODULE_12_components_Material_Styles_Colors__["a" /* Colors */].fullBlack})}]}};var CourseDetailsControllable=Object(__WEBPACK_IMPORTED_MODULE_1_components_Mixins_ControlsMixin__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_components_Dashboard_CourseDetails__["a" /* default */],courseControls);var CourseDetails=__WEBPACK_IMPORTED_MODULE_2_components_Dashboard_CourseDetails__["a" /* default */];var css={container:'_d'};var styles={cancel:{height:28,width:28,fill:'white',float:'right',cursor:'pointer',position:'absolute',top:'50%',right:'11px',transform:'translateY(-50%)'},container:{display:'flex',flexWrap:'wrap',justifyContent:'center',alignItems:'center',paddingLeft:Spacing.desktopGutter,paddingRight:Spacing.desktopGutter},loader:{padding:Spacing.desktopKeylineIncrement},filterButton:{margin:Spacing.desktopGutterMini},filterButtonContainer:{margin:Spacing.desktopGutter,marginBottom:0,display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'},ruler:{width:'95%',fontSize:'1px',color:'grey',lineHeight:'1px',backgroundColor:'gainsboro',marginTop:'16px',marginBottom:'10px'}};var CourseList=function(_mixin){_inherits(CourseList,_mixin);function CourseList(){_classCallCheck(this,CourseList);var _this=_possibleConstructorReturn(this,(CourseList.__proto__||Object.getPrototypeOf(CourseList)).apply(this,arguments));_initialiseProps.call(_this);var filter=void 0;try{filter=JSON.parse(localStorage.getItem('dashboardFilter'))||{filter:'All',sort:'LastVisit'};}catch(e){filter={filter:'All',sort:'LastVisit'};}var lastSeen=_this.getLastSeenNotification();var unseenMessages=messages.filter(function(message){if(message.id<=lastSeen){return false;}return true;});var message=null;if(unseenMessages.length>0){message=unseenMessages[0];}_this.state={message:message,shownCourses:15,maxCourses:15,nameCount:0,progress:0,filter:filter.filter,sort:filter.sort};//   (function(w, d, s, g, js, fs) {
//     g = w.gapi || (w.gapi = {});
//     g.analytics = {
//       q: [],
//       ready: function(f) {
//         this.q.push(f);
//       }
//     };
//     js = d.createElement(s);
//     fs = d.getElementsByTagName(s)[0];
//     js.src = 'https://apis.google.com/js/platform.js';
//     fs.parentNode.insertBefore(js, fs);
//     js.onload = function() {
//       g.load('analytics');
//     };
//   })(window, document, 'script');
return _this;}_createClass(CourseList,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores__["a" /* AppStore */],'app');this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores__["b" /* AuthStore */],'auth');this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores__["g" /* DashboardStore */],'dashboard');}},{key:'addCourse',value:function addCourse(){if(this.state.filter!='All'){this.setState({filter:'All'});__WEBPACK_IMPORTED_MODULE_4_actions_Dashboard__["a" /* default */].addCourseSkeleton(this.context.getIntlMessage('course.new'));}else{__WEBPACK_IMPORTED_MODULE_4_actions_Dashboard__["a" /* default */].addCourseSkeleton(this.context.getIntlMessage('course.new'));}}},{key:'setSort',value:function setSort(sort){__WEBPACK_IMPORTED_MODULE_4_actions_Dashboard__["a" /* default */].setSortMethod(sort);this.setState({sort:sort});localStorage.setItem('dashboardFilter',JSON.stringify({filter:this.state.filter,sort:sort}));}},{key:'onDeleteComponent',value:function onDeleteComponent(course){this.curCourse=course;this.refs.confirmDialog.show();}},{key:'onConfirm',value:function onConfirm(){var _this2=this;this.refs.confirmDialog.dismiss();__WEBPACK_IMPORTED_MODULE_4_actions_Dashboard__["a" /* default */].removeCourse(this.curCourse,function(){__WEBPACK_IMPORTED_MODULE_6_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('dashboard.removed'));});}},{key:'onPageScroll',value:function onPageScroll(event){var node=Object(__WEBPACK_IMPORTED_MODULE_14_react_dom__["findDOMNode"])(this);if(node.offsetHeight<=event.scrollTop+document.body.offsetHeight){this.setState({maxCourses:this.state.maxCourses+3});}}},{key:'onScrollToBottom',value:function onScrollToBottom(){this.setState({maxCourses:this.state.maxCourses+3});}},{key:'gotoCourse',value:function gotoCourse(course){if(course.lastViewedPage){this.props.router.push('/course/'+course.ownerSlug+'/'+course.slug+'/'+course.lastViewedPage);}else{this.props.router.push('/course/'+course.ownerSlug+'/'+course.slug);}}},{key:'componentDidMount',value:function componentDidMount(){var editor=this.state.auth.role.editor;if(_get(CourseList.prototype.__proto__||Object.getPrototypeOf(CourseList.prototype),'componentDidMount',this)){_get(CourseList.prototype.__proto__||Object.getPrototypeOf(CourseList.prototype),'componentDidMount',this).call(this);}this._pageScrollListener=this.onPageScroll.bind(this);Object(__WEBPACK_IMPORTED_MODULE_14_react_dom__["findDOMNode"])(this).addEventListener('scroll',this._scrollListener,false);__WEBPACK_IMPORTED_MODULE_4_actions_Dashboard__["a" /* default */].read(function(){});}},{key:'componentWillMount',value:function componentWillMount(){if(_get(CourseList.prototype.__proto__||Object.getPrototypeOf(CourseList.prototype),'componentWillMount',this)){_get(CourseList.prototype.__proto__||Object.getPrototypeOf(CourseList.prototype),'componentWillMount',this).call(this);}this.enter=[];this.leave=[];}},{key:'getLastSeenNotification',value:function getLastSeenNotification(){var seen=this.getCookie('lastSeenNotification');return seen===''?0:parseInt(seen,10);}},{key:'getCookie',value:function getCookie(name){var regex=new RegExp('(?:(?:^|.*;*)'+name+'*=*([^;]*).*$)|^.*$');return document.cookie.replace(regex,'$1');}},{key:'componentWillUpdate',value:function componentWillUpdate(){this.enter=[];this.leave=[];}},{key:'componentWillUnmount',value:function componentWillUnmount(){Object(__WEBPACK_IMPORTED_MODULE_14_react_dom__["findDOMNode"])(this).removeEventListener('scroll',this._scrollListener,false);if(_get(CourseList.prototype.__proto__||Object.getPrototypeOf(CourseList.prototype),'componentWillUnmount',this)){_get(CourseList.prototype.__proto__||Object.getPrototypeOf(CourseList.prototype),'componentWillUnmount',this).call(this);}this.changeSearchText.clear();}},{key:'getFloatingActionButtonStyle',value:function getFloatingActionButtonStyle(){var style=void 0,theme=this.context.muiTheme;if(this.context.media==='phone'){style={position:'fixed',right:Spacing.desktopGutter,bottom:Spacing.desktopGutter,zIndex:6};}else{style={position:'fixed',right:Spacing.desktopKeylineIncrement/2,top:theme.toolbar.height-theme.floatingActionButton.buttonSize/2,zIndex:6};if(this.state.searchEnabled){style.top=style.top+theme.floatingActionButton.buttonSize;}}return style;}},{key:'getToolbarStyle',value:function getToolbarStyle(){var style={borderStyle:'none none solid none',borderWidth:'1px',borderColor:'#DDD',backgroundColor:this.context.muiTheme.rawThem.palette.primary1Color};return style;}},{key:'getSearchBarStyle',value:function getSearchBarStyle(){var style={boxSizing:'border-box'};if(this.context.media!=='phone'){style.marginRight=Spacing.desktopKeylineIncrement*1.5;style.marginLeft=Spacing.desktopKeylineIncrement*1.5;}return style;}},{key:'getCourse',value:function getCourse(styles){}},{key:'getStyles',value:function getStyles(){var courses=this.state.dashboard.courses;var configs={};for(var i=0;i<courses.length;i++){if(i>this.state.maxCourses){break;}configs[i]={course:courses[i],top:spring(0,presets.gentle)};}return configs;}},{key:'getDefaultStyles',value:function getDefaultStyles(){var courses=this.state.dashboard.courses;var configs={};for(var i=0;i<courses.length;i++){if(i>this.state.maxCourses){break;}configs[i]={course:courses[i],top:spring(200)};}return configs;}},{key:'willEnter',value:function willEnter(index){return{top:spring(200),course:this.state.dashboard.courses[index]};}},{key:'willLeave',value:function willLeave(index,gone){return{top:spring(0),course:gone.course};}},{key:'getFilterButtonStyle',value:function getFilterButtonStyle(){var media=this.context.media;var phone=media==='phone';return Object.assign({},styles.filterButton,{display:'flex',flexWrap:'wrap',justifyContent:'center',alignContent:'space-around'// flexDirection: phone ? 'column' : 'row'
});}},{key:'renderFilterBar',value:function renderFilterBar(){var filter=this.state.filter;var media=this.context.media;var phone=media==='phone';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,this.context.getIntlMessage('dashboard.filterTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getFilterButtonStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('dashboard.filterAll'),style:styles.filterButton,backgroundColor:'#ddd',onTouchTap:this.setFilter.bind(this,'All'),disabled:filter==='All',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('dashboard.filterCompleted'),style:styles.filterButton,backgroundColor:'#ddd',onTouchTap:this.setFilter.bind(this,'Completed'),disabled:filter==='Completed',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('dashboard.filterNotCompleted'),style:styles.filterButton,backgroundColor:'#ddd',onTouchTap:this.setFilter.bind(this,'notCompleted'),disabled:filter==='notCompleted',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('dashboard.filterExpiresSoon'),style:styles.filterButton,backgroundColor:'#ddd',onTouchTap:this.setFilter.bind(this,'Soon'),disabled:filter==='Soon',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'})));}},{key:'filterAll',value:function filterAll(){return true;}},{key:'filterSoon',value:function filterSoon(course){var expiryDate=new Date(course.expires);if(Object.prototype.toString.call(expiryDate)==='[object Date]'&&!isNaN(expiryDate.getTime())){var now=Date.now();if(expiryDate-now<24*60*60*30*1000){return true;}}return false;}},{key:'filterCompleted',value:function filterCompleted(course){return course.progress>=1;}},{key:'filterNotCompleted',value:function filterNotCompleted(course){return course.progress<1;}},{key:'renderFilterCourses',value:function renderFilterCourses(){var _state=this.state,filter=_state.filter,auth=_state.auth;var media=this.context.media;var phone=media==='phone';if(auth.role.editor){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getFilterButtonStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('dashboard.filterOwn'),style:styles.filterButton,backgroundColor:'#ddd',onTouchTap:this.setFilter.bind(this,'Own'),disabled:filter==='Own',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('dashboard.filterOthers'),style:styles.filterButton,backgroundColor:'#ddd',onTouchTap:this.setFilter.bind(this,'Others'),disabled:filter==='Others',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'}));}else{return;}}},{key:'filterOwn',value:function filterOwn(course){return course.canEdit;}},{key:'filterOthers',value:function filterOthers(course){return!course.canEdit;}},{key:'renderSortingBar',value:function renderSortingBar(){var _state2=this.state,filter=_state2.filter,sort=_state2.sort,auth=_state2.auth;var media=this.context.media;var phone=media==='phone';if(auth.role.editor){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.ruler},' - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,this.context.getIntlMessage('dashboard.sortTitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getFilterButtonStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('dashboard.sortLastVisit'),style:styles.filterButton,backgroundColor:'#ddd',onTouchTap:this.setSort.bind(this,'LastVisit'),disabled:sort==='LastVisit',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('dashboard.sortCreated'),style:styles.filterButton,backgroundColor:'#ddd',onTouchTap:this.setSort.bind(this,'Created'),disabled:sort==='Created',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'})));}}},{key:'renderFilterExpendable',value:function renderFilterExpendable(){var media=this.context.media;var renderFilterCourses=this.renderFilterCourses();var renderFilterBar=this.renderFilterBar();var renderSortingBar=this.renderSortingBar();var sortTitle=this.state.sort;if(this.state.sort=='LastVisit'){sortTitle=this.context.getIntlMessage('dashboard.sortLastVisit');}else if(this.state.sort=='Created'){sortTitle=this.context.getIntlMessage('dashboard.sortCreated');}var filterTitle=this.state.filter;if(this.state.filter=='notCompleted'){filterTitle=this.context.getIntlMessage('dashboard.filterNotCompleted');}else if(this.state.filter=='Soon'){filterTitle=this.context.getIntlMessage('dashboard.filterExpiresSoon');}else if(this.state.filter=='Own'){filterTitle=this.context.getIntlMessage('dashboard.filterOwn');}else if(this.state.filter=='Others'){filterTitle=this.context.getIntlMessage('dashboard.filterOthers');}else if(this.state.filter=='All'){filterTitle=this.context.getIntlMessage('dashboard.filterAll');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Card"],{initiallyExpanded:false,style:{width:'50%',display:'block',margin:'0 auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["CardTitle"],{subtitle:this.state.auth.role.editor?this.context.getIntlMessage('dashboard.filterTitle')+': '+filterTitle+', '+this.context.getIntlMessage('dashboard.sortTitle')+': '+sortTitle:this.context.getIntlMessage('dashboard.filterTitle')+': '+filterTitle,showExpandableButton:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["CardText"],{expandable:true},renderFilterBar,renderFilterCourses,renderSortingBar)));}},{key:'render',value:function render(){var confirmActions=[{text:'Cancel'},{text:this.context.getIntlMessage('Remove'),onTouchTap:this.onConfirm.bind(this),ref:'submit'}];var editor=this.state.auth.role.editor;var _state$dashboard=this.state.dashboard,courses=_state$dashboard.courses,loading=_state$dashboard.loading;var children=[];var searchText=this.state.searchText;var regexp=void 0;var filter=this.state.filter;var filterFunction=this['filter'+filter.charAt(0).toUpperCase()+filter.slice(1)];courses=courses.filter(filterFunction);if(searchText&&searchText!==null){regexp=new RegExp(searchText,'i');courses=courses.filter(function(course){return course.name.search(regexp)>-1;});}for(var i=0;i<courses.length;i++){if(i>this.state.maxCourses){break;}var Element=void 0;var course=courses[i];if(editor&&course.canEdit){Element=CourseDetailsControllable;}else{Element=CourseDetails;}if(course.mode==='edit'){children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Element,{editor:editor,key:course.id,mode:'edit',defaultMenu:'edit',course:course,onDeleteComponent:this.onDeleteComponent.bind(this),className:'course',onNavigate:this.gotoCourse.bind(this,course)}));}else{children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Element,{editor:editor,key:course.id,course:course,onDeleteComponent:this.onDeleteComponent.bind(this),className:'course',onNavigate:this.gotoCourse.bind(this,course)}));}}var floatingActionButton=void 0;var searchBar=void 0;if(editor){floatingActionButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["FloatingActionButton"],{style:this.getFloatingActionButtonStyle(),onTouchTap:this.addCourse.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentAdd,null));}searchBar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getSearchBarStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_SearchBarToolbar__["a" /* default */],{fullWidth:true,onChange:this.handleSearchTextChange}));var filterExpendable=this.renderFilterExpendable();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_AppPage__["a" /* default */],{className:'dashboard',header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_RulerBar__["a" /* default */],{title:this.context.getIntlMessage('menu.Dashboard')})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_FullWidthPane__["a" /* default */],{onScrollToBottom:this.onScrollToBottom.bind(this)},(this.state.auth.role.teacher||this.state.auth.role.owner||this.state.auth.role.editor||this.state.auth.role.assistant)&&this.state.message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Paper"],{style:{width:'90%',maxWidth:'900px',margin:'20px auto',padding:'1em',backgroundColor:'#6739b7'},zDepth:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',this.state.message.text(this.handleClose),' ')),searchBar,filterExpendable,!loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},children,courses.length<1&&!loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:32,padding:Spacing.desktopGutterMore*6+'px 0'}},this.context.getIntlMessage('noResults'))),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.loader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Material_Loader__["b" /* default */],null))),floatingActionButton,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Dialog"],{ref:'confirmDialog',title:this.context.getIntlMessage('dashboard.remove'),actions:confirmActions,dismissOnClickAway:true}),this.props.children);}}]);return CourseList;}(Object(__WEBPACK_IMPORTED_MODULE_7_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_7_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));CourseList.displayName='Dashboard';CourseList.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};var _initialiseProps=function _initialiseProps(){var _this3=this;this.setFilter=function(filter){_this3.setState({filter:filter});localStorage.setItem('dashboardFilter',JSON.stringify({filter:filter,sort:_this3.state.sort}));};this.handleClose=function(){_this3.setState({message:null});document.cookie='lastSeenNotification='+_this3.state.message.id+';path=/;max-age=31536000';};this.handleSearchTextChange=function(searchText){_this3.changeSearchText(searchText);};this.changeSearchText=__WEBPACK_IMPORTED_MODULE_16_oxygen_debounce___default()(function(searchText){if(searchText!==_this3.state.searchText){_this3.setState({searchText:searchText});}},300);};/* harmony default export */ __webpack_exports__["a"] = (CourseList);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LinkList=function(_Component){_inherits(LinkList,_Component);function LinkList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LinkList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LinkList.__proto__||Object.getPrototypeOf(LinkList)).call.apply(_ref,[this].concat(args))),_this),_this.go=function(link,event){var _this$props=_this.props,onClickLink=_this$props.onClickLink,username=_this$props.username;var href='/about/'+username+link.href;event.preventDefault();event.stopPropagation();onClickLink&&onClickLink(username,link.href);// history.push(href);
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LinkList,[{key:'render',value:function render(){var _this2=this;var username=this.props.username;if(this.props.links.length>0){var _props=this.props,className=_props.className,other=_objectWithoutProperties(_props,['className']);var links=this.props.links.map(function(link,index){var text=_this2.context.getIntlMessage(link.text);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:index,className:'link-list-link',onTouchTap:_this2.go.bind(_this2,link)},text,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationChevronRight"],null));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('link-list',className)},other),links);}else{return null;}}}]);return LinkList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);LinkList.propTypes={links:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,onClickLink:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};LinkList.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (LinkList);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ScrollableContainer__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailPane=function(_Component){_inherits(DetailPane,_Component);function DetailPane(){_classCallCheck(this,DetailPane);return _possibleConstructorReturn(this,(DetailPane.__proto__||Object.getPrototypeOf(DetailPane)).apply(this,arguments));}_createClass(DetailPane,[{key:'render',value:function render(){var classes=__WEBPACK_IMPORTED_MODULE_1_classnames___default()('detail-pane',this.props.className),titleElement=this.props.header&&typeof this.props.header==='string'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.props.header):this.props.header;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ScrollableContainer__["a" /* default */],{containerStyle:{backgroundColor:this.context.muiTheme.rawTheme.palette.canvasColor},header:titleElement},this.props.children);}}]);return DetailPane;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DetailPane.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};DetailPane.propTypes={header:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object])};/* unused harmony default export */ var _unused_webpack_default_export = (DetailPane);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextField=function(_Component){_inherits(TextField,_Component);function TextField(){_classCallCheck(this,TextField);return _possibleConstructorReturn(this,(TextField.__proto__||Object.getPrototypeOf(TextField)).apply(this,arguments));}_createClass(TextField,[{key:'change',value:function change(e){if(this.props.onChange){this.props.onChange(e);}}},{key:'render',value:function render(){var _props=this.props,className=_props.className,icon=_props.icon,defaultValue=_props.defaultValue,hintText=_props.hintText,autoFocus=_props.autoFocus,inline=_props.inline,onChange=_props.onChange,type=_props.type,other=_objectWithoutProperties(_props,['className','icon','defaultValue','hintText','autoFocus','inline','onChange','type']);if(icon){icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:icon});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('cio-textfield',className,{full:!inline,'has-icon':icon})},icon,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({placeholder:hintText,autoFocus:autoFocus,type:type,ref:'input',defaultValue:defaultValue,onChange:this.change.bind(this)},other)));}},{key:'getValue',value:function getValue(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.findDOMNode(this.refs.input).value;}}]);return TextField;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TextField.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,autoFocus:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,icon:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,inline:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,hintText:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,defaultValue:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number])};TextField.defaultProps={inline:false,type:'text',autoFocus:false};/* harmony default export */ __webpack_exports__["a"] = (TextField);

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(2090)['default'];
exports['default'] = exports;


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RadialSVGProgressBar=function(_Component){_inherits(RadialSVGProgressBar,_Component);function RadialSVGProgressBar(){_classCallCheck(this,RadialSVGProgressBar);var _this=_possibleConstructorReturn(this,(RadialSVGProgressBar.__proto__||Object.getPrototypeOf(RadialSVGProgressBar)).call(this,arguments));_this.state={amount:0,transition:'stroke-dashoffset 1s linear'};return _this;}_createClass(RadialSVGProgressBar,[{key:'componentDidMount',value:function componentDidMount(){this.setState({amount:this.props.amount||0});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.amount){this.setState({amount:nextProps.amount,transition:'stroke-dashoffset 0.1s linear'});}}},{key:'render',value:function render(e){var width=this.props.size;var height=this.props.size;var stroke=this.props.strokeColor;var strokeWidth=this.props.strokeWidth;var backgroundStrokeWidth=this.props.backgroundStrokeWidth;var strokeBackground=this.props.strokeBackground;var overlayStyle={};var bgStyle=void 0;var style=void 0;var progressBar=null;var r=width/2-strokeWidth;var c=Math.PI*(r*2);var text=null;var percent=(100-this.state.amount)/100*c;bgStyle=Object.assign({},{strokeDashoffset:0,fill:'transparent',transition:this.state.transition,transform:'rotate(-90 '+width/4+' '+height/4+')',stroke:strokeBackground,strokeWidth:backgroundStrokeWidth});style=Object.assign({},{strokeDashoffset:percent,fill:'transparent',transition:this.state.transition,stroke:stroke,strokeWidth:strokeWidth});overlayStyle=Object.assign({},{backgroundColor:this.props.overlayBackground,position:'absolute',left:0,right:0,top:0,textAlign:'center',paddingTop:height/4,bottom:0});if(this.props.label&&this.state.amount>0){text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:width/2,y:height/2,fontSize:width/4,fill:stroke,textAnchor:'middle',style:{alignmentBaseline:'middle'}},Math.round(this.state.amount));}progressBar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{style:Object.assign({},this.props.style),className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('radial-progress',this.props.className),width:width,height:height,version:'1.1',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{r:r,cx:width/2,cy:height/2,style:bgStyle,transform:'rotate(-90 '+width/2+' '+height/2+')'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{r:r,cx:width/2,cy:height/2,style:style,strokeDasharray:c,transform:'rotate(-90 '+width/2+' '+height/2+')'}),text);if(this.props.overlay){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:overlayStyle},progressBar);}else{return progressBar;}}}]);return RadialSVGProgressBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RadialSVGProgressBar.propTypes={amount:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,strokeWidth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,backgroundStrokeWidth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,strokeBackground:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,strokeColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,label:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,overlay:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};RadialSVGProgressBar.defaultProps={size:100,strokeWidth:2,backgroundStrokeWidth:2,label:true,overlay:false,overlayBackground:'rgba(30, 30, 30, 0.5)',strokeBackground:'rgba(30, 30, 30, 0.1)',strokeColor:'#FFF'};/* harmony default export */ __webpack_exports__["a"] = (RadialSVGProgressBar);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_dW',wrapper:'_dX'};var AppContent=function(_Component){_inherits(AppContent,_Component);function AppContent(){_classCallCheck(this,AppContent);return _possibleConstructorReturn(this,(AppContent.__proto__||Object.getPrototypeOf(AppContent)).apply(this,arguments));}_createClass(AppContent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},this.props.children);}}]);return AppContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AppContent);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_Styles_Colors__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var phoneWidth=5;var width=8;var styles={root:{padding:0,height:36,whiteSpace:'nowrap',position:'relative',backgroundColor:'transparent'},inputContainer:{backgroundColor:__WEBPACK_IMPORTED_MODULE_3_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,position:'absolute',right:36,left:0,top:0,bottom:0},input:{border:'none',outline:'none',background:'transparent',width:'100%',padding:'0 '+Spacing.desktopGutterMini+'px',verticalAlign:'top',lineHeight:36+'px',height:36,textAlign:'left',boxSizing:'border-box'},button:{verticalAlign:'top',display:'inline-block',margin:0,border:'none',width:36,height:36,position:'absolute',right:0,top:0,padding:(36-Spacing.iconSize)/2,lineHeight:36+'px',backgroundColor:'rgba(0, 0, 0, 0.2)'}};var SearchBar=function(_Component){_inherits(SearchBar,_Component);function SearchBar(props){_classCallCheck(this,SearchBar);var _this=_possibleConstructorReturn(this,(SearchBar.__proto__||Object.getPrototypeOf(SearchBar)).call(this,props));_this.searchTextChange=function(event){var newValue=event.target.value||'';_this.setState({searchText:newValue});if(!_this.props.onChange){return;}if(_this.state.typingTimeout){clearTimeout(_this.state.typingTimeout);}_this.setState({searchText:newValue,typingTimeout:setTimeout(function(){_this.props.onChange(newValue);},500)});};_this.searchHandler=function(event){if(!_this.props.onSearch){return;}_this.props.onSearch(_this.state.searchText);};_this.state={searchText:null,typingTimeout:0};_this.baseState=_this.state;return _this;}_createClass(SearchBar,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.setState(this.baseState);}},{key:'getStyle',value:function getStyle(){var style=Object.assign({},styles.root);if(this.props.fullWidth){style.display='block';}else{style.display='inline-block';if(this.context.media==='phone'){style.width=Spacing.desktopKeylineIncrement*phoneWidth;}else{style.width=Spacing.desktopKeylineIncrement*width;}}return style;}},{key:'getInputStyle',value:function getInputStyle(){var style=Object.assign({},styles.input);return style;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Paper"],{style:this.getStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.inputContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:this.getInputStyle(),type:'text',placeholder:this.props.placeholder,onChange:this.searchTextChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{style:styles.button,onTouchTap:this.searchHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["ActionSearch"],{color:__WEBPACK_IMPORTED_MODULE_3_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,hoverColor:__WEBPACK_IMPORTED_MODULE_3_components_Material_Styles_Colors__["a" /* Colors */].lightWhite})));}}]);return SearchBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SearchBar.displayName='SearchBar';SearchBar.contextTypes={media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};SearchBar.defaultProps={placeholder:'Search',fullWidth:false};/* harmony default export */ __webpack_exports__["a"] = (SearchBar);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_d6',title:'_d7',list:'_d8',constrained:'_d9',mini:'_d_',bottomBar:'_d-',listItem:'_ea',selected:'_eb'};var CardList=function(_Component){_inherits(CardList,_Component);function CardList(){_classCallCheck(this,CardList);return _possibleConstructorReturn(this,(CardList.__proto__||Object.getPrototypeOf(CardList)).apply(this,arguments));}_createClass(CardList,[{key:'render',value:function render(){var _classNames;var _props=this.props,children=_props.children,header=_props.header,footer=_props.footer,mini=_props.mini,constrained=_props.constrained;var listClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.list,(_classNames={},_defineProperty(_classNames,css.mini,mini),_defineProperty(_classNames,css.constrained,constrained),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},header&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.title},header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:listClasses},children),footer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.bottomBar},footer));}}]);return CardList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CardList.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,header:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,footer:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,mini:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,constrained:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (CardList);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styles__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RadioTask__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckBoxTask__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TextTask__ = __webpack_require__(587);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*global require*/var taskComponents={1:__WEBPACK_IMPORTED_MODULE_3__RadioTask__["a" /* default */],2:__WEBPACK_IMPORTED_MODULE_4__CheckBoxTask__["a" /* default */],4:__WEBPACK_IMPORTED_MODULE_5__TextTask__["a" /* default */],7:__WEBPACK_IMPORTED_MODULE_5__TextTask__["a" /* default */]};var Task=function(_Component){_inherits(Task,_Component);function Task(props){_classCallCheck(this,Task);var _this=_possibleConstructorReturn(this,(Task.__proto__||Object.getPrototypeOf(Task)).call(this,props));_this.state={isTaskOpen:false};return _this;}_createClass(Task,[{key:'getStatusForChoice',value:function getStatusForChoice(){if(!this.props.taskResults||this.props.taskResults.length===0){return'incomplete';}else{var correct=true;var lastResult=this.props.taskResults[this.props.taskResults.length-1];var values=lastResult.body.value;var correctResponse=this.props.correctResponse&&this.props.correctResponse.value||[];if(values&&values.length!==correctResponse.length){return'incorrect';}else{correctResponse.forEach(function(value){if(values.indexOf(value)<0){correct=false;}});return correct?'correct':'incorrect';}}}},{key:'getStatusForText',value:function getStatusForText(){if(!this.props.taskResults||this.props.taskResults.length===0){return'incomplete';}else{var lastResult=this.props.taskResults[this.props.taskResults.length-1];var feedback=lastResult.feedback;if(feedback){if(feedback.grade===0){return'incorrect';}else if(feedback.grade===1){return'correct';}else if(feedback.grade===-1){return'incomplete';}}else{return'incomplete';}}}},{key:'expandTask',value:function expandTask(){this.setState({isTaskOpen:!this.state.isTaskOpen});}},{key:'getStatus',value:function getStatus(){var type=this.props.type||__WEBPACK_IMPORTED_MODULE_2_Constants__["taskTypes"].SINGLE_CHOICE;if(type===__WEBPACK_IMPORTED_MODULE_2_Constants__["taskTypes"].SINGLE_CHOICE||type===__WEBPACK_IMPORTED_MODULE_2_Constants__["taskTypes"].MULTI_CHOICE){return this.getStatusForChoice();}else if(type===__WEBPACK_IMPORTED_MODULE_2_Constants__["taskTypes"].TEXT){return this.getStatusForText();}}},{key:'getStyle',value:function getStyle(){var status=this.getStatus();return Object.assign({},__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].root,__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */]['incomplete'],{cursor:'pointer'});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,type=_props.type,canAnswer=_props.canAnswer,settings=_props.settings,reader=_props.reader,isQuiz=_props.isQuiz,other=_objectWithoutProperties(_props,['type','canAnswer','settings','reader','isQuiz']);// "showTaskResultOnAnswer" is Jägarförbundet-only functionality,
// which only should work on /course page.
var isOnCoursePage=window.location.pathname.includes('/course/');var showTaskResultOnAnswer=isOnCoursePage&&settings&&settings.list&&settings.list.features&&settings.list.features.showTaskResultOnAnswer===true;if(typeof canAnswer==='undefined'){canAnswer=true;}type=type||__WEBPACK_IMPORTED_MODULE_2_Constants__["taskTypes"].SINGLE_CHOICE;var SpecializedTask=taskComponents[type];var task=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpecializedTask,Object.assign({showTaskResultOnAnswer:showTaskResultOnAnswer,isQuiz:isQuiz,canAnswer:canAnswer,reader:reader},other));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'task-'+this.props.id,onClick:!this.props.reader&&this.props.taskResults&&this.props.taskResults.length===0?function(){return _this2.expandTask();}:null,style:this.getStyle()},task,this.state.isTaskOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:150,display:'flex',justifyContent:'center',alignItems:'center',fontSize:25,textAlign:'center'}},this.context.getIntlMessage('tasks.noInfo')):null);}}]);return Task;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Task.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Task);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styles__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TaskResultList__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RadioTaskResult__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Embed__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['comment'],['comment']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classes={comment:'_fI'};var RadioTask=function(_Component){_inherits(RadioTask,_Component);function RadioTask(props){_classCallCheck(this,RadioTask);var _this=_possibleConstructorReturn(this,(RadioTask.__proto__||Object.getPrototypeOf(RadioTask)).call(this,props));_this.answer=function(){if(_this.state.choice!==null){var _this$props=_this.props,pageModuleId=_this$props.pageModuleId,id=_this$props.id,taskId=_this$props.taskId;_this.setState({hasAnswered:true});__WEBPACK_IMPORTED_MODULE_8_actions__["f" /* CourseActions */].answerTask(taskId||id,pageModuleId,{value:[_this.state.choice]});if(_this.props.isQuiz&&_this.props.displayNextQuizQuestion){__WEBPACK_IMPORTED_MODULE_8_actions__["w" /* QuizActions */].next();}_this.props.gaTracking&&_this.props.gaTracking();}else{__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].error(_this.context.getIntlMessage('tasks.pleaseChooseOne'));}};__WEBPACK_IMPORTED_MODULE_8_actions__["f" /* CourseActions */].answerTaskComplete.listen(props.isQuiz?__WEBPACK_IMPORTED_MODULE_8_actions__["w" /* QuizActions */].updateAnswer:function(){});var choice=null;if(_this.props.answered){choice=_this.props.answered[0];}_this.state={choice:choice,hasAnswered:false};return _this;}_createClass(RadioTask,[{key:'choose',value:function choose(index){if(this.state.choice!==index){this.setState({choice:index});}}},{key:'renderAnswerControls',value:function renderAnswerControls(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].answerControls},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{onTouchTap:this.answer,fullWidth:true,backgroundColor:this.props.themeColor,labelColor:'#FFF',label:this.context.getIntlMessage('tasks.answer')}));}},{key:'renderTaskResultList',value:function renderTaskResultList(){var _props=this.props,showTaskResultOnAnswer=_props.showTaskResultOnAnswer,caption=_props.caption,taskResults=_props.taskResults,correctResponse=_props.correctResponse,canGrade=_props.canGrade,taskId=_props.taskId,reader=_props.reader;var results=taskResults;if(showTaskResultOnAnswer){if(!this.state.hasAnswered||!taskResults){return null;}var lastAnswer=taskResults[taskResults.length-1];results=[lastAnswer];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TaskResultList__["a" /* default */],{reader:reader,correctResponse:correctResponse,ListElement:__WEBPACK_IMPORTED_MODULE_4__RadioTaskResult__["a" /* default */],results:results,choices:caption.items,canGrade:canGrade,taskId:taskId,removeAnimation:showTaskResultOnAnswer});}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,caption=_props2.caption,captionFiles=_props2.captionFiles,taskResults=_props2.taskResults,correctResponse=_props2.correctResponse,canAnswer=_props2.canAnswer,file=_props2.file,reader=_props2.reader,isQuiz=_props2.isQuiz,canEdit=_props2.canEdit;caption=caption||{};caption.items=caption.items||[];var main=isQuiz?caption.main||this.context.getIntlMessage('tasks.defineQuestion'):caption.main||this.context.getIntlMessage('tasks.defineTask');var choices=caption.items.map(function(item,index){var icon=void 0;if(canAnswer){if(index===_this2.state.choice){icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].radio,onTouchTap:_this2.choose.bind(_this2,index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["ToggleRadioButtonChecked"],{color:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].green[800].material}));}else{icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].radio,onTouchTap:_this2.choose.bind(_this2,index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["ToggleRadioButtonUnchecked"],null));}}else{icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["ToggleRadioButtonUnchecked"],{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].radio});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].label,key:index},icon,item);});var answerControls=void 0;if(canAnswer&&reader&&!canEdit){answerControls=this.renderAnswerControls();}var external=null;try{external=JSON.parse(this.props.frontend&&this.props.frontend[0]||null);}catch(err){}var fileType=null;var File=file?file:external?Object.assign({},external,{type:'external'}):captionFiles&&captionFiles[0];var ext=void 0;if(File&&File.type.includes('image')){ext=File.type.replace(/\/(jpeg|jpg|png|webp)/g,'');}else if(File&&File.type.includes('video')){ext=File.type.replace(/\/(mp4|mov)/g,'');}else if(File&&File.type.includes('audio')){ext=File.type.replace(/\/(mp4|x-m4a|mp3)/g,'');}else if(File&&File.type==='external'){ext='external';}switch(ext){case'video':fileType=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{style:{width:'100%'},controls:true,alt:File.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:File.url.includes('.mp4')?File.url:File.url+'.mp4',type:File.type}));break;case'image':fileType=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{width:'100%'},src:File.url,alt:File.name});break;case'audio':fileType=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:File.url,type:File.type}));break;case'external':fileType=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Embed__["a" /* default */],{provider:File.provider,id:File.id});break;default:break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,File&&fileType,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].question},main),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].choices},choices),answerControls,this.renderTaskResultList(),caption&&caption.comment&&taskResults&&taskResults[taskResults.length-1]&&!!diff(taskResults[taskResults.length-1].body.value,correctResponse.value).length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.comment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,Object(__WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__["translate"])(_templateObject)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,caption.comment)));}}]);return RadioTask;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RadioTask.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (RadioTask);function diff(a,b){return b.filter(function(i){return a.indexOf(i)<0;});}

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TaskFeedback__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Widgets_ProfileImage__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_gE',userName:'_gF'};var RadioTaskResult=function(_Component){_inherits(RadioTaskResult,_Component);function RadioTaskResult(){_classCallCheck(this,RadioTaskResult);return _possibleConstructorReturn(this,(RadioTaskResult.__proto__||Object.getPrototypeOf(RadioTaskResult)).apply(this,arguments));}_createClass(RadioTaskResult,[{key:'render',value:function render(){var _props=this.props,body=_props.body,choices=_props.choices,user=_props.user,correctResponse=_props.correctResponse,created=_props.created;var value=body.value;var response=void 0;var correctAnswers=correctResponse&&correctResponse.value||[];if(correctAnswers&&correctAnswers.length>0){var answers=[];correctAnswers.forEach(function(correctAnswer,i){var label=choices[correctAnswer];var color=void 0;var icon=void 0;if(value.indexOf(correctAnswer)>-1){color=__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].material.green[500].hex;icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationCheck"],{style:{verticalAlign:'middle'}});answers.push([{text:' - '+label},color,icon]);}else{color=__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].material.red[800].hex;icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationClose"],{style:{verticalAlign:'middle'}});if(i>0||correctAnswers.length>1){answers.push([{text:'missed - '+label},color,icon]);}else{var newLabel=choices[value[0]];answers.push([{text:' - '+newLabel},color,icon]);}}});if(value.length>correctAnswers.length&&answers.length===correctAnswers.length){var neededValue=value.filter(function(val){return correctAnswers.indexOf(val)===-1;});var color=__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].material.red[800].hex;var icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationClose"],{style:{verticalAlign:'middle'}});answers.push([{text:'missed - '+choices[neededValue[0]]},color,icon]);}response=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TaskFeedback__["a" /* default */],{leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["SocialPersonOutline"],null),answers:answers,created:created});}else{var _color=void 0;var _icon=void 0;if(correctAnswers.length<1){_color=__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].material.green[500].hex;_icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationCheck"],{style:{verticalAlign:'middle'}});}else{_color=__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].material.red[800].hex;_icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationClose"],{style:{verticalAlign:'middle'}});}response=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TaskFeedback__["a" /* default */],{leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["SocialPersonOutline"],null),answers:[[{text:this.context.getIntlMessage('tasks.noAnswer')},_color]],rightIcon:_icon,created:created});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},response);}}]);return RadioTaskResult;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RadioTaskResult.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (RadioTaskResult);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(2111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
// Param format: 2021-01-15 10:16:09
var formatDate=function formatDate(d){return __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(d).tz('Etc/GMT+1').add(3,'hours').format('YYYY-MM-DD HH:mm');};

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styles__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TaskResultList__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CheckBoxTaskResult__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Embed__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['comment'],['comment']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var classes={comment:'_fJ'};var RadioTask=function(_mixin){_inherits(RadioTask,_mixin);function RadioTask(props){_classCallCheck(this,RadioTask);var _this=_possibleConstructorReturn(this,(RadioTask.__proto__||Object.getPrototypeOf(RadioTask)).call(this,props));_initialiseProps.call(_this);__WEBPACK_IMPORTED_MODULE_8_actions__["f" /* CourseActions */].answerTaskComplete.listen(props.isQuiz?__WEBPACK_IMPORTED_MODULE_8_actions__["w" /* QuizActions */].updateAnswer:function(){});var choices={};if(_this.props.answered){_this.props.answered.forEach(function(key){choices[key]=true;});}_this.state={choices:choices,hasAnswered:false};return _this;}_createClass(RadioTask,[{key:'choose',value:function choose(index){var choices=this.state.choices;choices[index]=!choices[index];this.setState({choices:choices});__WEBPACK_IMPORTED_MODULE_8_actions__["w" /* QuizActions */].updateAnswer();}},{key:'renderAnswerControls',value:function renderAnswerControls(){var themeColor=this.props.themeColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].answerControls},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["RaisedButton"],{onTouchTap:this.answer,fullWidth:true,backgroundColor:themeColor,labelColor:'#FFF',label:this.context.getIntlMessage('tasks.answer')}));}},{key:'renderTaskResultList',value:function renderTaskResultList(){var _props=this.props,showTaskResultOnAnswer=_props.showTaskResultOnAnswer,caption=_props.caption,taskResults=_props.taskResults,correctResponse=_props.correctResponse,reader=_props.reader;var results=taskResults;if(showTaskResultOnAnswer){if(!this.state.hasAnswered||!taskResults){return null;}var lastAnswer=taskResults[taskResults.length-1];results=[lastAnswer];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TaskResultList__["a" /* default */],{reader:reader,correctResponse:correctResponse,ListElement:__WEBPACK_IMPORTED_MODULE_3__CheckBoxTaskResult__["a" /* default */],results:results,choices:caption.items,removeAnimation:showTaskResultOnAnswer});}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,caption=_props2.caption,captionFiles=_props2.captionFiles,frontend=_props2.frontend,taskResults=_props2.taskResults,correctResponse=_props2.correctResponse,canAnswer=_props2.canAnswer,file=_props2.file,reader=_props2.reader,canEdit=_props2.canEdit;var correctAnswers=correctResponse&&correctResponse.value||[];var choices=caption.items.map(function(item,index){var icon=void 0;if(canAnswer){if(_this2.state.choices[index]){icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["IconButton"],{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].radio,onTouchTap:_this2.choose.bind(_this2,index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["ToggleCheckBox"],{color:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].green[800].material}));}else{icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["IconButton"],{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].radio,onTouchTap:_this2.choose.bind(_this2,index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["ToggleCheckBoxOutlineBlank"],null));}}else{icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["ToggleCheckBoxOutlineBlank"],{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].radio});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].label,key:index},icon,item);});var answerControls=void 0;if(canAnswer&&!canEdit){answerControls=this.renderAnswerControls();}var external=null;try{external=JSON.parse(this.props.frontend&&this.props.frontend[0]||null);}catch(err){}var fileType=null;var File=file?file:external?Object.assign({},external,{type:'external'}):captionFiles&&captionFiles[0];var ext=void 0;if(File&&File.type.includes('image')){ext=File.type.replace(/\/(jpeg|jpg|png|webp)/g,'');}else if(File&&File.type.includes('video')){ext=File.type.replace(/\/(mp4)/g,'');}else if(File&&File.type.includes('audio')){ext=File.type.replace(/\/(mp4|x-m4a)/g,'');}else if(File&&File.type==='external'){ext='external';}switch(ext){case'video':fileType=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{style:{width:'100%'},controls:true,alt:File.name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:File.url.includes('.mp4')?File.url:File.url+'.mp4',type:File.type}));break;case'image':fileType=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{width:'100%'},src:File.url,alt:File.name});break;case'audio':fileType=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:File.url,type:File.type}));break;case'external':fileType=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Embed__["a" /* default */],{provider:File.provider,id:File.id});break;default:break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,File&&fileType,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].question},caption.main),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_1__Styles__["a" /* default */].choices},choices),answerControls,this.renderTaskResultList(),caption&&caption.comment&&taskResults&&taskResults[taskResults.length-1]&&!!diff(taskResults[taskResults.length-1].body.value,correctResponse.value).length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.comment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,Object(__WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__["translate"])(_templateObject)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,caption.comment)));}}]);return RadioTask;}(Object(__WEBPACK_IMPORTED_MODULE_4_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_4_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));RadioTask.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};var _initialiseProps=function _initialiseProps(){var _this3=this;this.answer=function(){var _props3=_this3.props,pageModuleId=_props3.pageModuleId,taskId=_props3.taskId,id=_props3.id;var choices=_this3.state.choices;_this3.setState({hasAnswered:true});var value=Object.keys(choices).filter(function(choice){return choices[choice];}).map(function(choice){return parseInt(choice,10);});__WEBPACK_IMPORTED_MODULE_8_actions__["f" /* CourseActions */].answerTask(taskId||id,pageModuleId,{value:value});_this3.props.gaTracking&&_this3.props.gaTracking();if(_this3.props.isQuiz&&_this3.props.displayNextQuizQuestion){__WEBPACK_IMPORTED_MODULE_8_actions__["w" /* QuizActions */].next();}};};/* harmony default export */ __webpack_exports__["a"] = (RadioTask);function diff(a,b){return b.filter(function(i){return a.indexOf(i)<0;});}

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TaskFeedback__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Widgets_ProfileImage__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_gG',userName:'_gH'};var CheckBoxTaskResult=function(_Component){_inherits(CheckBoxTaskResult,_Component);function CheckBoxTaskResult(){_classCallCheck(this,CheckBoxTaskResult);return _possibleConstructorReturn(this,(CheckBoxTaskResult.__proto__||Object.getPrototypeOf(CheckBoxTaskResult)).apply(this,arguments));}_createClass(CheckBoxTaskResult,[{key:'render',value:function render(){var _props=this.props,body=_props.body,choices=_props.choices,user=_props.user,correctResponse=_props.correctResponse,created=_props.created;var value=body.value;var response=void 0;var correctAnswers=correctResponse&&correctResponse.value||[];var neededValue=value.filter(function(val){return correctAnswers.indexOf(val)===-1;});if(correctAnswers&&correctAnswers.length>0){var answers=[];correctAnswers.forEach(function(correctAnswer){var label=choices[correctAnswer];var color=void 0;var icon=void 0;if(value.indexOf(correctAnswer)>-1){color=__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].material.green[500].hex;icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationCheck"],{style:{verticalAlign:'middle'}});answers.push([{text:' - '+label},color,icon]);}else{color=__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].material.green[500].hex;icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationClose"],{style:{verticalAlign:'middle'}});answers.push([{text:'Correct is - '+label},color,icon]);}});if(answers.length===correctAnswers.length&&choices[neededValue[0]]){var color=__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].material.red[800].hex;var icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationClose"],{style:{verticalAlign:'middle'}});for(var i=0;i<neededValue.length;i++){answers.push([{text:'wrong - '+choices[neededValue[i]]},color,icon]);}}response=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TaskFeedback__["a" /* default */],{leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["SocialPersonOutline"],null),answers:answers,created:created});}else{var _color=void 0;var _icon=void 0;if(correctAnswers.length<1){_color=__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].material.green[500].hex;_icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationCheck"],{style:{verticalAlign:'middle'}});}else{_color=__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].material.red[800].hex;_icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationClose"],{style:{verticalAlign:'middle'}});}response=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TaskFeedback__["a" /* default */],{leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["SocialPersonOutline"],null),answers:[[{text:this.context.getIntlMessage('tasks.noAnswer')},_color]],rightIcon:_icon,created:created});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},user&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'10px'}},user.name),response);}}]);return CheckBoxTaskResult;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CheckBoxTaskResult.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (CheckBoxTaskResult);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_File__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Page_Module_Embed__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Widgets_FileUpload__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Styles__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TaskResultList__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TextTaskResult__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_DialogPortal__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['comment'],['comment']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={fileContainer:'_fK',file:'_fL',comment:'_fM'};var hasUnCorrectedTasks=function hasUnCorrectedTasks(results){var uncorrectedCount=0;if(!!results){for(var i=0;i<results.length;i++){var element=results[i];if(element&&element.feedback&&!element.feedback.created&&typeof element.feedback.created_by!=='number'){uncorrectedCount++;}}}return uncorrectedCount;};var style={removeButton:{position:'absolute',top:0,left:0,right:0}};var TextTask=function(_Component){_inherits(TextTask,_Component);function TextTask(props){_classCallCheck(this,TextTask);var _this=_possibleConstructorReturn(this,(TextTask.__proto__||Object.getPrototypeOf(TextTask)).call(this,props));_this.toggleOpen=function(){_this.setState(function(state){return{open:!state.open};});};_this.answer=function(){var answerValue=_this.refs.answer.getValue();var _this$props=_this.props,pageModuleId=_this$props.pageModuleId,taskId=_this$props.taskId,id=_this$props.id;__WEBPACK_IMPORTED_MODULE_0_actions__["f" /* CourseActions */].answerTask(taskId||id,pageModuleId,{value:[answerValue+_this.state.files.map(function(file){return'[file:'+file.id+']';}).join('')]},_this.state.files);__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(_this.context.getIntlMessage('tasks.answerSent'));_this.refs.answer.clearValue();_this.setState({files:[]});_this.props.gaTracking&&_this.props.gaTracking();};_this.removeFile=function(index){var files=[].concat(_toConsumableArray(_this.state.files));files.splice(index,1);_this.setState({files:files});};_this.uncorrected=hasUnCorrectedTasks(props.taskResults);_this.state={open:false,progress:0,direction:null,files:[]};return _this;}_createClass(TextTask,[{key:'progress',value:function progress(e){this.setState({progress:e.percent,direction:e.direction});}},{key:'attach',value:function attach(uploadedFiles){for(var i=0;i<uploadedFiles.length;i++){for(var k=0;k<this.state.files.length;k++){if(uploadedFiles[i].file.id===this.state.files[k].id){return;}}}if(uploadedFiles.length>0){var files=[].concat(_toConsumableArray(this.state.files),_toConsumableArray(uploadedFiles.map(function(file){return file.file;})));this.refs.fileUploadedDialog.show();this.setState({files:files});}}},{key:'renderAnswerControls',value:function renderAnswerControls(){var _this2=this;var themeColor=this.props.themeColor;var fileComponent=void 0,uploadProgress=void 0;var _state=this.state,progress=_state.progress,direction=_state.direction,files=_state.files;var uploading=direction==='download'&&progress>0&&progress<100;fileComponent=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:css.fileContainer},files.map(function(file,index){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{key:index,className:css.file},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_File__["a" /* default */],{url:file.url,caption:file.name}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{label:_this2.context.getIntlMessage('Remove'),fullWidth:true,style:style.removeButton,onTouchTap:function onTouchTap(){return _this2.removeFile(index);}}));}));if(uploading){uploadProgress=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_10__Styles__["a" /* default */].progress},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["LinearProgress"],{mode:'determinate',value:progress}));}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_10__Styles__["a" /* default */].answerControls},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{ref:'answer',floatingLabelText:this.context.getIntlMessage('tasks.answer'),hintText:this.context.getIntlMessage('tasks.provideAnswer'),fullWidth:true,multiLine:true}),fileComponent,uploadProgress,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["c" /* GridRow */],{fluid:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_10__Styles__["a" /* default */].answer.button},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{disabled:uploading,onTouchTap:this.answer,fullWidth:true,backgroundColor:themeColor,labelColor:'#FFF',label:this.context.getIntlMessage('tasks.answerOpenEnded')}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:6},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_10__Styles__["a" /* default */].upload.button},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Widgets_FileUpload__["a" /* default */],{disabled:uploading,multiple:true,fullWidth:true,onProgress:this.progress.bind(this),onSuccess:this.attach.bind(this),label:this.context.getIntlMessage('attachFile')})))));}},{key:'renderDialog',value:function renderDialog(){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{ref:'fileUploadedDialog',autoDetectWindowHeight:true,autoScrollBodyContent:true,dismissOnClickAway:true},this.context.getIntlMessage('tasks.fileUploaded')));}},{key:'render',value:function render(){var _props=this.props,caption=_props.caption,canAnswer=_props.canAnswer,taskResults=_props.taskResults,correctResponse=_props.correctResponse,canGrade=_props.canGrade,file=_props.file,captionFiles=_props.captionFiles,reader=_props.reader,taskMode=_props.taskMode;var answerControls=void 0;if(canAnswer){answerControls=this.renderAnswerControls();}var external=null;try{external=JSON.parse(this.props.frontend&&this.props.frontend[0]||null);}catch(err){}var fileType=null;var File=file?file:external?Object.assign({},external,{type:'external'}):captionFiles&&captionFiles[0];var ext=void 0;if(File&&File.type.includes('image')){ext=File.type.replace(/\/(jpeg|jpg|png|webp)/g,'');}else if(File&&File.type.includes('video')){ext=File.type.replace(/\/(mp4)/g,'');}else if(File&&File.type.includes('audio')){ext=File.type.replace(/\/(mp4|x-m4a)/g,'');}else if(File&&File.type==='external'){ext='external';}switch(ext){case'video':fileType=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('video',{style:{width:'100%'},controls:true,alt:File.name},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('source',{src:File.url.includes('.mp4')?File.url:File.url+'.mp4',type:File.type}));break;case'image':fileType=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('img',{style:{width:'100%'},src:File.url,alt:File.name});break;case'audio':fileType=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('audio',{controls:true,style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('source',{src:File.url,type:File.type}));break;case'external':fileType=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Page_Module_Embed__["a" /* default */],{provider:File.provider,id:File.id});break;default:break;}var results=taskResults&&taskResults.sort(function(a,b){var A=a&&a.feedback&&!a.feedback.created&&typeof a.feedback.created_by!=='number';var B=b&&b.feedback&&!b.feedback.created&&typeof b.feedback.created_by!=='number';if(!A&&B){return 1;}else if(A&&!B){return-1;}else{return 0;}})||[];return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_10__Styles__["a" /* default */].container},File&&fileType,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{onClick:this.toggleOpen,style:Object.assign({},__WEBPACK_IMPORTED_MODULE_10__Styles__["a" /* default */].question,{cursor:results.length>0&&'pointer',opacity:taskMode&&results.length===0&&this.uncorrected<1&&0.5})},!!this.uncorrected&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('p',{style:__WEBPACK_IMPORTED_MODULE_10__Styles__["a" /* default */].uncorrected},this.uncorrected),' ',caption.main),answerControls,(!taskMode||this.state.open)&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TaskResultList__["a" /* default */],{reader:reader,canGrade:canGrade,taskId:this.props.id,correctResponse:correctResponse,ListElement:__WEBPACK_IMPORTED_MODULE_12__TextTaskResult__["a" /* default */],results:results}),caption&&caption.comment&&taskResults&&taskResults[taskResults.length-1]&&!!diff(taskResults[taskResults.length-1].body.value,correctResponse.value).length&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div',{className:css.comment},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('h5',null,Object(__WEBPACK_IMPORTED_MODULE_7_oxygen_i18n__["translate"])(_templateObject)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('i',null,caption.comment)),this.renderDialog());}}]);return TextTask;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);TextTask.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_8_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (TextTask);function diff(a,b){return b.filter(function(i){return a.indexOf(i)<0;});}

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_File__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Widgets_FileUpload__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Styles__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TaskFeedback__ = __webpack_require__(266);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_gI',uploadButton:'_gJ',userName:'_gK',fileContainer:'_gL',file:'_gM'};var style={removeButton:{position:'absolute',top:0,left:0,right:0}};var TextTaskResult=function(_Component){_inherits(TextTaskResult,_Component);function TextTaskResult(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TextTaskResult);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TextTaskResult.__proto__||Object.getPrototypeOf(TextTaskResult)).call.apply(_ref,[this].concat(args))),_this),_this.state={progress:0,files:[],showGrading:false,answered:false},_this.correct=function(){var feedback=void 0;feedback=_this.refs.feedback.getValue();__WEBPACK_IMPORTED_MODULE_0_actions__["E" /* TaskActions */].assessTask(_this.props.taskId,_this.props.id,feedback,1,_this.state.files);_this.setState({showGrading:false,answered:true});},_this.incorrect=function(){var feedback=_this.refs.feedback.getValue();__WEBPACK_IMPORTED_MODULE_0_actions__["E" /* TaskActions */].assessTask(_this.props.taskId,_this.props.id,feedback,0,_this.state.files);_this.setState({showGrading:false,answered:true});},_this.toggleGrade=function(){_this.setState(function(state){return{showGrading:!state.showGrading};});},_this.removeFile=function(index){var files=[].concat(_toConsumableArray(_this.state.files));files.splice(index,1);_this.setState({files:files});},_this.handleFeedbackChange=function(e){var feedback=e.target.value;_this.setState({feedback:feedback});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TextTaskResult,[{key:'attach',value:function attach(uploadedFiles){for(var i=0;i<uploadedFiles.length;i++){for(var k=0;k<this.state.files.length;k++){if(uploadedFiles[i].file.id===this.state.files[k].id){return;}}}if(uploadedFiles.length>0){var files=[].concat(_toConsumableArray(this.state.files),_toConsumableArray(uploadedFiles.map(function(file){return file.file;})));this.setState({files:files});}}},{key:'progress',value:function progress(e){this.setState({progress:e.percent});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,user=_props.user,body=_props.body,feedback=_props.feedback,canGrade=_props.canGrade,reader=_props.reader,created=_props.created;var _state=this.state,progress=_state.progress,files=_state.files,showGrading=_state.showGrading;var fileComponent=void 0,uploadProgress=void 0;var uploading=progress>0&&progress<100;var grading=void 0;var values=[];var feedbacks=void 0;var answers=[];if(body.value&&body.value.length>0){if(typeof body.value==='string'){answers.push([{text:body.value},__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].text.Dark.default]);}else{body.value.forEach(function(answer){answers.push([{text:answer},__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].text.Dark.default]);});}}fileComponent=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:css.fileContainer},files.map(function(file,index){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{key:index,className:css.file},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_File__["a" /* default */],{url:file.url,caption:file.name}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{label:_this2.context.getIntlMessage('Remove'),fullWidth:true,style:style.removeButton,onTouchTap:function onTouchTap(){return _this2.removeFile(index);}}));}));if(this.props.bodyFiles){answers.push([{text:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:css.fileContainer},this.props.bodyFiles.map(function(file,index){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{key:index,className:css.file},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_File__["a" /* default */],{url:file.url,caption:file.name})));}))},__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].text.Dark.default]);// answers.push([<File url={body.fileUrl} caption={body.fileName}/>, Colors.text.Dark.default]);
}if(answers.length>0){values=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TaskFeedback__["a" /* default */],{answers:answers,created:created,leftIcon:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["SocialPersonOutline"],null)});}else{values=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TaskFeedback__["a" /* default */],{answers:[[{text:this.context.getIntlMessage('tasks.noAnswer')},__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].Colors.red[800].material]],leftIcon:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ContentClear"],{color:__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].material.red[500].hex})});}if(uploading){uploadProgress=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_8__Styles__["a" /* default */].progress},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["LinearProgress"],{mode:'determinate',value:progress}));}if(feedback&&typeof feedback.grade==='number'||feedback.text||this.props.feedbackFiles&&this.props.feedbackFiles.length>0){var leftIcon=void 0;if(feedback.grade){leftIcon=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ActionDone"],{color:__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].material.green[500].hex});}else{leftIcon=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ContentClear"],{color:__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].material.red[500].hex});}feedbacks=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TaskFeedback__["a" /* default */],{answers:[[feedback,__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].text.Dark.default]],leftIcon:leftIcon,files:this.props.feedbackFiles||[]});}if(showGrading||!this.state.answered&&canGrade&&feedback&&!feedback.created&&typeof feedback.created_by!=='number'){grading=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_8__Styles__["a" /* default */].buttonContainer},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{ref:'feedback',floatingLabelText:this.context.getIntlMessage('tasks.provideFeedback'),fullWidth:true,multiLine:true}),fileComponent,uploadProgress,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["c" /* GridRow */],{fluid:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:12},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:css.uploadButton},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Widgets_FileUpload__["a" /* default */],{disabled:uploading,multiple:true,fullWidth:true,onProgress:this.progress.bind(this),onSuccess:this.attach.bind(this),label:this.context.getIntlMessage('attachFile')})))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["c" /* GridRow */],{fluid:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:6},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_8__Styles__["a" /* default */].answer.correct},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{backgroundColor:__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].material.green[400].hex,labelColor:'white',onTouchTap:this.correct,fullWidth:true,label:this.context.getIntlMessage('tasks.correct')}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:6},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_8__Styles__["a" /* default */].answer.incorrect},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{backgroundColor:__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].material.red[400].hex,labelColor:'white',onTouchTap:this.incorrect,fullWidth:true,label:this.context.getIntlMessage('tasks.incorrect')})))));}return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div',{className:css.root},values,feedbacks,grading,canGrade&&(this.state.answered||feedback&&!!feedback.created&&!!feedback.created_by)&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{onTouchTap:function onTouchTap(){},fullWidth:true,onClick:this.toggleGrade,label:!showGrading?this.context.getIntlMessage('tasks.redoanswer'):'Close'}));}}]);return TextTaskResult;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);TextTaskResult.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_7_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (TextTaskResult);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Toolbar__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_d1',leftIcon:'_d2',rightIcon:'_d3',inputContainer:'_d4',input:'_d5'};var SearchBar=function(_Component){_inherits(SearchBar,_Component);function SearchBar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SearchBar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchBar.__proto__||Object.getPrototypeOf(SearchBar)).call.apply(_ref,[this].concat(args))),_this),_this.focus=function(){_this._input.focus();_this._input.select();},_this.handleChange=function(event){var value=event.target.value;var onChange=_this.props.onChange;onChange&&onChange(value);},_this.toggle=function(){var _this$props=_this.props,expanded=_this$props.expanded,onRequestCollapse=_this$props.onRequestCollapse,onRequestExpand=_this$props.onRequestExpand;if(expanded&&onRequestCollapse){onRequestCollapse();}else if(!expanded&&onRequestExpand){onRequestExpand();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchBar,[{key:'render',value:function render(){var _this2=this;var _props=this.props,expanded=_props.expanded,expandable=_props.expandable,placeholder=_props.placeholder,children=_props.children;var expandIcon=expandable&&children?__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["HardwareKeyboardArrowRight"],null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},expanded&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.leftIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Toolbar__["c" /* ToolbarButton */],{onTouchTap:this.focus},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["ActionSearch"],null))),expanded&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.inputContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:placeholder,className:css.input,ref:function ref(_input){return _this2._input=_input;},onChange:this.handleChange})),!expandable&&children&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.rightIcon},children),expandable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.rightIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Toolbar__["c" /* ToolbarButton */],{onTouchTap:this.toggle},expanded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["HardwareKeyboardArrowLeft"],null):expandIcon)));}}]);return SearchBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SearchBar.propTypes={searchText:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,placeholder:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,expandable:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,expanded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,onChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onRequestCollapse:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onRequestExpand:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};SearchBar.defaultProps={expandable:true,expanded:true};/* harmony default export */ __webpack_exports__["a"] = (SearchBar);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Portal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={root:{zIndex:102,position:'relative'},overlay:{position:'fixed',top:0,left:'-100%',width:'100%',height:'100%',opacity:0,willChange:'opacity',transform:'translate3d(0,0,0)',transition:'left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',backgroundColor:'rgba(0, 0, 0, 0.75)'},open:{left:0,opacity:1}};var isNodeInRoot=function isNodeInRoot(child,root){var node=child;while(child){if(node===root){return true;}node=node.parentNode;}return false;};var Overlay=function(_Component){_inherits(Overlay,_Component);function Overlay(){_classCallCheck(this,Overlay);var _this=_possibleConstructorReturn(this,(Overlay.__proto__||Object.getPrototypeOf(Overlay)).apply(this,arguments));_this.handleKeyDown=function(e){if(e.keyCode===27&&_this.state.open){_this.close();}};_this.state={open:_this.props.open};return _this;}_createClass(Overlay,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.open&&!this.state.open){this.open();}else if(!nextProps.open&&this.state.open){this.close();}}},{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('keydown',this.handleKeyDown);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('keydown',this.handleKeyDown);}},{key:'getStyle',value:function getStyle(open){var _props=this.props,zIndex=_props.zIndex,style=_props.style;return Object.assign({},{zIndex:zIndex},styles.root,open?styles.open:{},style);}},{key:'getOverlayStyle',value:function getOverlayStyle(open){return Object.assign({},styles.overlay,open?styles.open:{});}},{key:'closeOverlay',value:function closeOverlay(e){this.close();e.stopPropagation();e.preventDefault();}},{key:'close',value:function close(){if(this.state.open){this.setState({open:false});if(this.props.onClose){this.props.onClose();}}}},{key:'open',value:function open(){var force=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(!this.state.open){this.setState({open:true});if(this.props.onOpen){this.props.onOpen();}}else if(force){if(this.props.onOpen){this.props.onOpen();}}}},{key:'toggle',value:function toggle(){if(this.state.open){this.close();}else{this.open();}}},{key:'handleOutsideMouseClick',value:function handleOutsideMouseClick(e){if(isNodeInRoot(e.target,Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this.refs.panel))){return;}this.close();}},{key:'render',value:function render(){var open=this.state.open;var _ref=open?this.props:{},children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Portal__["a" /* default */],{style:styles.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:this.closeOverlay.bind(this),style:this.getOverlayStyle(open)}),children);}}]);return Overlay;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Overlay.displayName='Overlay';Overlay.propTypes={onOpen:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onClose:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,zIndex:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,open:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['No notes'],['No notes']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={noteLinkWrapper:'_bO',notesLink:'_bP',note:'_bQ'};var NotesOverview=function(_mixin){_inherits(NotesOverview,_mixin);function NotesOverview(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NotesOverview);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NotesOverview.__proto__||Object.getPrototypeOf(NotesOverview)).call.apply(_ref,[this].concat(args))),_this),_this.goToPage=function(pageId){__WEBPACK_IMPORTED_MODULE_2__actions_Course__["a" /* default */].toggleNotes();_this.props.ownerSlug&&_this.props.router.push('/course/'+_this.props.ownerSlug+'/'+_this.props.courseSlug+'/'+pageId);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NotesOverview,[{key:'render',value:function render(){var _this2=this;var _props=this.props,notes=_props.notes,course=_props.course;var notesList=notes&&!!notes.length&&notes.map(function(section){var sectionName=section.name;return section.pages.map(function(page){var pageName=page.name;var pageId=page.id;return page.notes.map(function(notes,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["ListItem"],{rightIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ContentSend"],null),key:notes.ts,onClick:function onClick(){return _this2.goToPage(pageId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.note},notes.body),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.noteLinkWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.notesLink},sectionName,' - ',pageName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.notesLink},notes.ts)));});});})||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,Object(__WEBPACK_IMPORTED_MODULE_5_oxygen_i18n__["translate"])(_templateObject));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,course.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["List"],{style:{background:'#fff'}},notesList));}}]);return NotesOverview;}(Object(__WEBPACK_IMPORTED_MODULE_1__Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1__Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (NotesOverview);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(2138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(2139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(2140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(2141);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return Object(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      Object(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(390);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["a" /* routerShape */]
  },

  propTypes: {
    to: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(200);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = Object(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(2149);

var _runTransitionHook = __webpack_require__(344);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(161);

var _PathUtils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery;
    var parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(344);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.indexOf(basename) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(600);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = Object(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tag=function(_Component){_inherits(Tag,_Component);function Tag(){_classCallCheck(this,Tag);return _possibleConstructorReturn(this,(Tag.__proto__||Object.getPrototypeOf(Tag)).apply(this,arguments));}_createClass(Tag,[{key:'getStyle',value:function getStyle(){if(this.props.mini){return{borderRadius:'6px',backgroundColor:'#DDD',marginRight:'3px',padding:'1px 4px',fontSize:'10px',lineHeight:'12px',cursor:'pointer',display:'inline-block'};}else{return{borderRadius:'14px',backgroundColor:'#DDD',marginRight:'3px',height:'28px',lineHeight:'24px',padding:'2px 6px',cursor:'pointer',display:'inline-block',boxSizing:'border-box'};}}},{key:'_onDelete',value:function _onDelete(){if(this.props.onDelete){this.props.onDelete(this.props.name);}}},{key:'render',value:function render(){var _props=this.props,style=_props.style,name=_props.name,other=_objectWithoutProperties(_props,['style','name']),controls=void 0;if(this.props.controls){controls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["ContentClear"],{style:{verticalAlign:'middle'},onTouchTap:this._onDelete.bind(this),hoverColor:'#AAAAAA'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({style:Object.assign(this.getStyle(),style)},other),name,this.props.children,controls);}}]);return Tag;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Tag.propTypes={mini:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,controls:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onDelete:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};Tag.defaultProps={controls:false,mini:true};/* harmony default export */ __webpack_exports__["a"] = (Tag);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Widgets_SimpleOverview__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_CourseSelector__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_StudentSelector__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_InviteeAdder__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_DialogPortal__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_4_material_ui__["Styles"].Spacing,Colors=__WEBPACK_IMPORTED_MODULE_4_material_ui__["Styles"].Colors;var styles={label:{padding:'10px'}};var minDate=new Date();var maxDate=new Date();maxDate.setFullYear(maxDate.getFullYear()+2);var GroupDetail=function(_mixin){_inherits(GroupDetail,_mixin);function GroupDetail(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GroupDetail);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GroupDetail.__proto__||Object.getPrototypeOf(GroupDetail)).call.apply(_ref,[this].concat(args))),_this),_this.state={// selectedStudent: {name: this.context.getIntlMessage('student.noSelected')},
// selectedInvitation: {name: this.context.getIntlMessage('student.noSelected')},
studentsLoaded:false,coursesLoaded:false,invitesLoaded:false,editing:false,exporting:false,value:''},_this.exportFinal=function(){var group=_this.props.group;var re=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var email=null;if(re.test(String(_this.state.value).toLowerCase())){email=_this.state.value;}var options={startDate:_this.refs.startDate.getDate(),endDate:_this.refs.endDate.getDate(),circleIds:[group.id],withInactive:_this.refs.withInactive.isToggled(),withProgress:_this.refs.withProgress.isToggled(),recipientEmail:email};__WEBPACK_IMPORTED_MODULE_2_actions__["C" /* StudentActions */].export(options);},_this.openEdit=function(){_this.setState({editing:true});},_this.closeEdit=function(){_this.setState({editing:false});},_this.export=function(){_this.setState({exporting:true});},_this.closeExport=function(){_this.setState({exporting:false});},_this.goToStudent=function(item){if(item===null){_this.setState({student:null});}else{_this.props.router.push('/student/'+item.id);}},_this.goToCourse=function(item){if(item===null){_this.setState({student:null});}else{_this.props.router.push('/course/'+item.id);}},_this.handleChange=function(e){_this.setState({value:e.target.value});},_temp),_possibleConstructorReturn(_this,_ret);}//  mixins: [AuthMixin, IntlMixin, Reflux.connect(StudentStore, 'student'), Reflux.connect(GroupStore, 'group'), Reflux.connect(CourseStore, 'course'), Reflux.connect(InviteStore, 'invite')],
_createClass(GroupDetail,[{key:'confirmDelete',value:function confirmDelete(){this.refs.confirmDialog.show();}},{key:'selectStudent',value:function selectStudent(student){this.setState({selectedStudent:student});}},{key:'selectInvitation',value:function selectInvitation(invitation){this.setState({selectedInvitation:invitation});}},{key:'onConfirm',value:function onConfirm(){var _this2=this;this.refs.removeDialog.dismiss();__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].delete(this.props.group.id,true,function(){_this2.closeDetail();__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].filter();});}},{key:'conConfirmRemove',value:function conConfirmRemove(){var _this3=this;this.refs.removeDialog.dismiss();__WEBPACK_IMPORTED_MODULE_2_actions__["C" /* StudentActions */].removeFromGroup(this.groupId,this.state.selectedStudent.id,function(){__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(_this3.context.getIntlMessage('student.removedFromGroup'));__WEBPACK_IMPORTED_MODULE_2_actions__["C" /* StudentActions */].findByGroupId(_this3.groupId);});}},{key:'revokeAccess',value:function revokeAccess(){this.refs.removeDialog.show();}},{key:'closeDetail',value:function closeDetail(){if(this.props.onClose){this.props.onClose();}}},{key:'inviteStudents',value:function inviteStudents(){this.refs.inviteStudentsDialog.show();}},{key:'createInviteStudentsDialog',value:function createInviteStudentsDialog(){var group=this.props.group,actions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Invite'),onTouchTap:this._inviteStudentsConfirm.bind(this),ref:'submit'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'inviteStudentsDialog',actions:actions,actionFocus:'submit',dismissOnClickAway:true,autoDetectWindowHeight:true,autoScrollBodyContent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_InviteeAdder__["a" /* default */],{ref:'invitees',standAlone:true}));}},{key:'addCourses',value:function addCourses(){this.refs.addCoursesDialog.show();}},{key:'createAddCoursesDialog',value:function createAddCoursesDialog(){var group=this.props.group,actions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Add'),onTouchTap:this._addCoursesConfirm.bind(this),ref:'submit'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'addCoursesDialog',actions:actions,actionFocus:'submit',dismissOnClickAway:true,autoDetectWindowHeight:true,autoScrollBodyContent:true},this.context.getIntlMessage('invite.accessTime'),' :',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["DatePicker"],{style:{display:'inline-block'},ref:'endDate',minDate:minDate,maxDate:maxDate,hintText:this.context.getIntlMessage('invite.chooseEndDate')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_CourseSelector__["a" /* default */],{ref:'courseSelector'}));}},{key:'_addCoursesConfirm',value:function _addCoursesConfirm(){var courseIds=Object.keys(this.refs.courseSelector.getSelected()).map(function(id){return parseInt(id,10);});var endDate=this.refs.endDate.getDate();__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].addToCourse(this.props.group.id,courseIds,endDate);this.refs.addCoursesDialog.dismiss();}},{key:'addStudents',value:function addStudents(){this.refs.addStudentsDialog.show();}},{key:'createAddStudentsDialog',value:function createAddStudentsDialog(){var group=this.props.group,actions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Add'),onTouchTap:this._addStudentsConfirm.bind(this),ref:'submit'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'addStudentsDialog',actions:actions,actionFocus:'submit',dismissOnClickAway:true,autoDetectWindowHeight:true,autoScrollBodyContent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_StudentSelector__["a" /* default */],{ref:'studentSelector'}));}},{key:'_inviteStudentsConfirm',value:function _inviteStudentsConfirm(){var _this4=this;__WEBPACK_IMPORTED_MODULE_2_actions__["l" /* InviteActions */].inviteToCircle(this.refs.invitees.getInvitees(),this.props.group.id,function(){__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(_this4.context.getIntlMessage('student.multiAddedToGroup'));_this4.refs.inviteStudentsDialog.dismiss();__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].findById(_this4.props.group.id);});}},{key:'_addStudentsConfirm',value:function _addStudentsConfirm(){var _this5=this;var userIds=Object.keys(this.refs.studentSelector.getSelected()).map(function(id){return parseInt(id,10);});__WEBPACK_IMPORTED_MODULE_2_actions__["G" /* UserActions */].addToCircle(userIds,[this.props.group.id],function(){__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(_this5.context.getIntlMessage('student.multiAddedToGroup'));_this5.refs.addStudentsDialog.dismiss();__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].findById(_this5.props.group.id);});}},{key:'removeCourse',value:function removeCourse(course){this._courseToRemove=course;this.refs.removeCourseDialog.show();}},{key:'_onRemoveCourseConfirm',value:function _onRemoveCourseConfirm(){__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].removeFromCourse(this.props.group.id,this._courseToRemove.id);__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(this.context.getIntlMessage('course.removed'));this.refs.removeCourseDialog.dismiss();}},{key:'removeStudent',value:function removeStudent(student){this._studentToRemove=student;this.refs.removeStudentDialog.show();}},{key:'_onRemoveStudentConfirm',value:function _onRemoveStudentConfirm(){__WEBPACK_IMPORTED_MODULE_2_actions__["C" /* StudentActions */].removeFromGroup(this.props.group.id,this._studentToRemove.id);__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].findById(this.props.group.id);__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(this.context.getIntlMessage('student.removedFromGroup'));this.refs.removeStudentDialog.dismiss();}},{key:'_onRemoveInviteConfirm',value:function _onRemoveInviteConfirm(){__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].delete(this._inviteToRemove.id);__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].findById(this.props.group.id);__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(this.context.getIntlMessage('group.removedInvite'));this.refs.removeInviteDialog.dismiss();}},{key:'removeInvite',value:function removeInvite(invite){this._inviteToRemove=invite;this.refs.removeInviteDialog.show();}},{key:'resendInvitation',value:function resendInvitation(invitation){this.setState({selectedInvitation:invitation});this.refs.resendInvitationDialog.show();}},{key:'resendInvitationAll',value:function resendInvitationAll(invitations){this.setState({selectedInvitation:invitations});this.refs.resendInvitationAllDialog.show();}},{key:'_onResendInvitationConfirm',value:function _onResendInvitationConfirm(){__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].resend(this.state.selectedInvitation.id);__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(this.context.getIntlMessage('invitation.resent'));this.refs.resendInvitationDialog.dismiss();}},{key:'_onResendInvitationAllConfirm',value:function _onResendInvitationAllConfirm(){__WEBPACK_IMPORTED_MODULE_2_actions__["k" /* InvitationActions */].resend(this.props.group.invitations.map(function(invitation){return invitation.id;}));__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(this.context.getIntlMessage('invitation.allResent'));this.refs.resendInvitationAllDialog.dismiss();}},{key:'updateGroupName',value:function updateGroupName(){var grName=this.refs.groupName.getValue();__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].update(this.props.group.id,grName);this.closeEdit();}},{key:'updateStudent',value:function updateStudent(student){if(student.role=='user'){__WEBPACK_IMPORTED_MODULE_2_actions__["G" /* UserActions */].setCircleRole(student.id,this.props.group.id,'admin');__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].findById(this.props.group.id);}else{__WEBPACK_IMPORTED_MODULE_2_actions__["G" /* UserActions */].setCircleRole(student.id,this.props.group.id,'user');__WEBPACK_IMPORTED_MODULE_2_actions__["j" /* GroupActions */].findById(this.props.group.id);}}},{key:'render',value:function render(){var _props=this.props,group=_props.group,user=_props.user,addCoursesDialog=this.createAddCoursesDialog(),addStudentsDialog=this.createAddStudentsDialog(),removeInvitesDialog=void 0,inviteStudentsDialog=void 0,inviteStudentsDialog2=void 0,standardActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('OK'),secondary:true,className:'full',onTouchTap:this.onConfirm.bind(this)})],removeCourseActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Remove'),onTouchTap:this._onRemoveCourseConfirm.bind(this),ref:'submit'}],removeStudentActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Remove'),onTouchTap:this._onRemoveStudentConfirm.bind(this),ref:'submit'}],removeInviteActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Remove'),onTouchTap:this._onRemoveInviteConfirm.bind(this),ref:'submit'}],resendInvitationActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Resend'),onTouchTap:this._onResendInvitationConfirm.bind(this),ref:'submit'}],resendInvitationAllActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Resend'),onTouchTap:this._onResendInvitationAllConfirm.bind(this),ref:'submit'}],inviteOverview=void 0;var resendButton=null;if(this.props.group&&this.props.group.invitations&&this.props.group.invitations.length!==0){resendButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["List"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ListItem"],{leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationRefresh"],null),onTouchTap:this.resendInvitationAll.bind(this),primaryText:this.context.getIntlMessage('invitation.resendAll')})));}inviteStudentsDialog=this.createInviteStudentsDialog();inviteOverview=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Widgets_SimpleOverview__["a" /* default */],{items:group.invitations,readable:'email',title:this.context.getIntlMessage('invite.Invites'),onTouchTapRightIcon:this.removeInvite.bind(this),onTouchTapLeftIcon:this.resendInvitation.bind(this)},resendButton);removeInvitesDialog=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'removeInviteDialog',title:this.context.getIntlMessage('group.removeInvite'),actions:removeInviteActions,actionFocus:'submit',dismissOnClickAway:true},this.context.getIntlMessage('group.removeInviteConfirm'));inviteStudentsDialog2=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'resendInvitationDialog',title:this.context.getIntlMessage('invitation.resend'),actions:resendInvitationActions,actionFocus:'submit',dismissOnClickAway:true},this.context.getIntlMessage('invitation.prolongAccess')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'resendInvitationAllDialog',title:this.context.getIntlMessage('invitation.resendAll'),actions:resendInvitationAllActions,actionFocus:'submit',dismissOnClickAway:true},this.context.getIntlMessage('invitation.resendAll')));if(!this.state.editing&&!this.state.exporting){var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ToolbarTitle"],{text:this.context.getIntlMessage('Group')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ToolbarGroup"],{float:'right',key:1},user&&user.role.editor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('group.remove'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDelete"],null),onTouchTap:this.revokeAccess.bind(this)}):null,user&&user.role.editor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('course.add'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionAssignmentInd"],null),onTouchTap:this.addCourses.bind(this)}):null,user&&user.role.editor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('student.add'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["SocialPersonAdd"],null),onTouchTap:this.addStudents.bind(this)}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('student.inviteNew'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentMail"],null),onTouchTap:this.inviteStudents.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('export.userStats'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionLaunch"],null),onTouchTap:this.export.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('Close'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentClear"],null),onTouchTap:this.closeDetail.bind(this)})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ScrollableContainer__["a" /* default */],{header:toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["List"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ListItem"],{leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentCreate"],null),primaryText:group.name,onTouchTap:this.openEdit.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Widgets_SimpleOverview__["a" /* default */],{items:group.courses,readable:'name',title:this.context.getIntlMessage('course.Courses'),onTouchTapRightIcon:this.removeCourse.bind(this),user:user,onSelect:this.goToCourse}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Widgets_SimpleOverview__["a" /* default */],{removable:true,items:group.students,readable:'name',title:this.context.getIntlMessage('student.Students'),onTouchTapRightIcon:this.removeStudent.bind(this),onTouchTapRightToggle:this.updateStudent.bind(this),user:user,onSelect:this.goToStudent}),inviteOverview,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'removeDialog',title:this.context.getIntlMessage('group.remove'),actions:standardActions,dismissOnClickAway:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'removeCourseDialog',title:this.context.getIntlMessage('group.removeCourse'),actions:removeCourseActions,actionFocus:'submit',dismissOnClickAway:true},this.context.getIntlMessage('group.removeCourseConfirm')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'removeStudentDialog',title:this.context.getIntlMessage('group.removeStudent'),actions:removeStudentActions,actionFocus:'submit',dismissOnClickAway:true},this.context.getIntlMessage('group.removeStudentConfirm')),removeInvitesDialog,addCoursesDialog,addStudentsDialog,inviteStudentsDialog,inviteStudentsDialog2));}else if(this.state.exporting){var _toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ToolbarTitle"],{text:this.context.getIntlMessage('Export user statistics')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ToolbarGroup"],{float:'right',key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('Cancel'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentClear"],null),onTouchTap:this.closeExport.bind(this)})));var recipient=null;if(this.props.user.incarnated){recipient=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Toggle"],{ref:'withRecipient',defaultToggled:false,label:this.context.getIntlMessage('group.send')}));}var now=new Date();var oneMonthAgo=new Date();var month=oneMonthAgo.getMonth();oneMonthAgo.setMonth(oneMonthAgo.getMonth()-1);if(oneMonthAgo.getMonth()===month){oneMonthAgo.setDate(0);}oneMonthAgo.setHours(0,0,0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ScrollableContainer__["a" /* default */],{header:_toolbar,style:{backgroundColor:Colors.fullWhite}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["DatePicker"],{ref:'startDate',defaultDate:oneMonthAgo,maxDate:now,floatingLabelText:this.context.getIntlMessage('export.startDate')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["DatePicker"],{ref:'endDate',defaultDate:now,maxDate:now,floatingLabelText:this.context.getIntlMessage('export.endDate')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["TextField"],{onChange:this.handleChange,hintText:'Custom email'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Toggle"],{ref:'withInactive',defaultToggled:false,label:this.context.getIntlMessage('export.user.withInactive')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Toggle"],{ref:'withProgress',defaultToggled:false,label:this.context.getIntlMessage('export.user.withProgress')}),recipient,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["RaisedButton"],{primary:true,fullWidth:true,label:this.context.getIntlMessage('Export'),onTouchTap:this.exportFinal})));}else{var _toolbar2=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ToolbarTitle"],{text:this.context.getIntlMessage('group.editing')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ToolbarGroup"],{float:'right',key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('Save'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDone"],null),onTouchTap:this.updateGroupName.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('Cancel'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentClear"],null),onTouchTap:this.closeEdit.bind(this)})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ScrollableContainer__["a" /* default */],{header:_toolbar2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.label},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["TextField"],{fullWidth:true,defaultValue:group.name,hintText:'',floatingLabelText:'Group Name',ref:'groupName',type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Widgets_SimpleOverview__["a" /* default */],{items:group.courses,readable:'name',title:this.context.getIntlMessage('course.Courses'),onTouchTapRightIcon:this.removeCourse.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Widgets_SimpleOverview__["a" /* default */],{items:group.students,readable:'name',title:this.context.getIntlMessage('student.Students'),onTouchTapRightIcon:this.removeStudent.bind(this)}),inviteOverview,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'removeDialog',title:this.context.getIntlMessage('group.remove'),actions:standardActions,dismissOnClickAway:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'removeCourseDialog',title:this.context.getIntlMessage('group.removeCourse'),actions:removeCourseActions,actionFocus:'submit',dismissOnClickAway:true},this.context.getIntlMessage('group.removeCourseConfirm')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'removeStudentDialog',title:this.context.getIntlMessage('group.removeStudent'),actions:removeStudentActions,actionFocus:'submit',dismissOnClickAway:true},this.context.getIntlMessage('group.removeStudentConfirm')),removeInvitesDialog,addCoursesDialog,addStudentsDialog,inviteStudentsDialog,inviteStudentsDialog2));}}}]);return GroupDetail;}(Object(__WEBPACK_IMPORTED_MODULE_6_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_6_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_6_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));GroupDetail.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* withRouter */])(GroupDetail));

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var CourseDetail=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['read','nextStudents','prevStudents','countStudents','filterStudents','filterStudentsByStatus']);/* harmony default export */ __webpack_exports__["a"] = (CourseDetail);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var InvitationDetail=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['read','nextInvitations','prevInvitations','countInvitations']);/* harmony default export */ __webpack_exports__["a"] = (InvitationDetail);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dialog__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DialogContent__ = __webpack_require__(2166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dialog__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__DialogContent__["a"]; });


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ResponsiveImage__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_i1',responsive:'_i2',size2:'_i3',size3:'_i4',dir:'_i5'};var styles={avatar:{width:48,height:48}};var Thumb=function(_Component){_inherits(Thumb,_Component);function Thumb(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Thumb);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Thumb.__proto__||Object.getPrototypeOf(Thumb)).call.apply(_ref,[this].concat(args))),_this),_this.handleTouchTap=function(){var _this$props=_this.props,payload=_this$props.payload,onTouchTap=_this$props.onTouchTap;onTouchTap&&onTouchTap(payload);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Thumb,[{key:'renderIcon',value:function renderIcon(type,size,url){var style={width:size*__WEBPACK_IMPORTED_MODULE_3_Css__["Units"].keyline,height:size*__WEBPACK_IMPORTED_MODULE_3_Css__["Units"].keyline};if(type==='image'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ResponsiveImage__["a" /* default */],{contain:true,size:__WEBPACK_IMPORTED_MODULE_3_Css__["Units"].keyline,style:style,src:url});}else if(type==='video'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["AvMovie"],{style:styles.avatar});}else if(type==='audio'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["ImageAudiotrack"],{style:styles.avatar});}else if(type==='dir'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["FileFolder"],{color:__WEBPACK_IMPORTED_MODULE_3_Css__["Colors"].darkWhite,style:styles.avatar});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["EditorInsertDriveFile"],{style:styles.avatar});}},{key:'render',value:function render(){var _classNames;var _props=this.props,type=_props.type,url=_props.url,size=_props.size;var classes=__WEBPACK_IMPORTED_MODULE_4_classnames___default()(css.root,css['size'+size],(_classNames={},_defineProperty(_classNames,css.dir,type==='dir'),_defineProperty(_classNames,css.responsive,type==='image'),_classNames));var icon=this.renderIcon(type,size,url);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes,onTouchTap:this.handleTouchTap},icon);}}]);return Thumb;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Thumb.propTypes={type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,url:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,payload:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array]),onTouchTap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};Thumb.defaultProps={size:1};/* harmony default export */ __webpack_exports__["a"] = (Thumb);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return english; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return swedish; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var english=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Terms (2018-05-14)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'1. The service'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The course or the guide is developed with the help of Coursio\u2019s service. Coursio is a service for creation of web-based courses and guides that are distributed electronically. The service allows businesses to create create online courses consisting of video, text, images, audio, and interactive features. The service includes hosting and operating the spirit of the platform, support and in some cases even a shop for the sale and presentation of the courses.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio reserves the right to change these terms and conditions on this page and the conditions will be applied 30 days following the update.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'After having completed the purchase of a guide or course produced by Coursio\u2019s service and through the presentation page developed by Coursio\u2019s tool, you will be given access to the material. As a part of purchase process, you register a customer account to study the material through Coursio\u2019s service or use a previously registered account. When the purchase is processed, you will enter Coursio\u2019s services and can view the material. To access the material please log in through the site',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://app.coursio.com',target:'_blank'},'https://app.coursio.com'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Creation of customer account is permitted only with a valid email address. You are responsible for the email address stated is correct and active. You can change the email address stated under \u201CSettings\u201D.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To register in Coursio you must be over 18 years.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can read more about how we manage your personal data in our Privacy Policy:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://coursio.com/gdpr/',target:'_blank'},'https://coursio.com/gdpr/')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'2. Payment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To purchase the course you have 2 options depending on what country you visit our store from:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Option 1. (Swedish connection) Klarna'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Klarna AB (publ), Corp. ID No. 556737-0431, Sveav\xE4gen 46, 111 34 Stockholm, Sweden (\u201CKlarna\u201D) is a company supplying payment methods to Merchants selling online and through other agreed sales channels. Klarna Checkout is Klarna\xB4s checkout solution for online shops which includes a number of payment options (\u201CKlarna Checkout\u201D). The payment options included in Klarna Checkout (the \u201CPayment Options\u201D) include both products provided by Klarna itself, such as Invoice and Part Payment, as well as payment options offered via third parties (\u201CThird Party Payment Option Provider\u201D), such as debit/credit card (Visa and Mastercard) and direct banking. The Payment Options offered vary from country to country and may change from time to time. The Merchant operates an E-store(s) from the approved and agreed upon web addresses/URLs (the \u201CE-store\u201D). The Merchant can integrate Klarna Checkout into its E-store or any other purchase channels that may have been agreed between the Parties and thereby enable the Merchant\u2019s customers to pay via Klarna Checkout. Such integration may be done by the Merchant itself or through the use of a third party.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The Parties hereby agree to include Klarna Checkout and, consequently, the from time to time available Payment Options into the E-store or any other agreed purchase channels for the countries specified through the agreement between the Merchant and the Partner making the Service available to the Merchant or regulated directly between the Merchant and Klarna, and commit to cooperate in order to prepare and provide the Services.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Option 2 (International connection) . Card payment through Stripe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We are using Stripe as a third party payment option for card payments. All sensitive information, such as credit card information is handled by Stripe using a secure payment and SSL server. Coursio don\'t store any card information. We accept Visa, MasterCard and AMEX. You can read Stripes',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://stripe.com/se/legal',target:'_blank'},'General Terms and Conditions'),' ','and',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://stripe.com/se/privacy',target:'_blank'},'Privacy'),' ','by each link.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'3. Returns'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When you buy a course or a guide, the purchase does not apply to e-commerce law. When the payment has been processed and you get access to material, your right to withdrawal is exhausted. Is the product defective or incorrect, you are welcome to contact our customer service department at support@coursio.com.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'4. Technical conditions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The service requires access to the Internet. You are responsible for the costs incurred in the use of internet.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'5. Responsibility'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When buying a course or a guide access is only granted to the person who bought it. You may not in any way spread further content to others or share the password to your account.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'6. Coursio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Material purchased through Coursio is available around the clock, seven days a week. Coursio, however, does not guarantee that the service is always free of errors or interruptions. If the deficiencies or interruption in service occurs, Coursio reserves the right to correct them without breach of contract. Coursio also reserves the right, with reason, to close the service for upgrades and maintenance.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'7. Disclaimer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio is a service to publish material in the form of courses and guides. Through the service, customers of Coursio sell courses and guides, either through their own websites, other sales channels or where a presentation page is included in Coursio\u2019s service. Sales are made through this page and are managed via Coursio\'s accounts at Stripe and Klarna. Coursio is not responsible for any disputes, claims, losses or damages of any kind that may arise from documents or information that are implemented and shared by Coursio\u2019s customers or participants in customer courses and guides.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We do not control the content of the materials submitted by our customers and do not guarantee in any way validity or accuracy of the content. As a buyer of courses or guides you acknowledge that you may be exposed to offensive or inappropriate content and understand that Coursio bears no responsibility of this type of content and assume no responsibility for the content itself.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Via Coursio you can access links to third party sites either by the tool itself or the material that clients has provided. Coursio take no responsibility for these third-party sites and do not control them in any way. As a user of Coursio should take appropriate steps to assess whether it is advisable to visit such third party site and protect your own personal information and privacy at such a page.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'8. Freedom of choice'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Any dispute under these terms shall be governed by Swedish law in the Stockholm District Court.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Questions regarding this statement, addressed to Coursio AB, Tegn\xE9rgatan 1, 111 40 Stockholm, or info@coursio.se.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'9. Personal data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To register in Coursio\u2019s service requires only an e-mail address and first and last name. When you provide your personal details, you agree that we store and use your information in our business to fulfill the contract against you. In this part we will inform you of updates that occur in the material you have access to and for general updates to the service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You also admit that we share this personal data with the customer who is the provider of the course content. These customers may use this information to contact you for other purposes. It is your responsibility as a user to ensure what the customer will do with this information and how it will be stored. Coursio not control the uses or how this information is stored by our Customers.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Upon deregistration of your Coursio account Coursio will delete all information of you. However, it is your responsibility to inform the Customers whose material you have purchased as well. You have the right to request a deregistration, correction of potentially wrong data in regards to you. This has to be done in via email to support@coursio.com. You can also lock the access of your user data for marketing done by the Customer.'));var swedish=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Anv\xE4ndarvillkor (2018-05-14)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'1. Tj\xE4nsten'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Villkor vid k\xF6p av kurs eller guide som \xE4r framtagen med hj\xE4lp av Coursios tj\xE4nst.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio \xE4r en tj\xE4nst f\xF6r att skapa webbaserade kurser och guider som distribueras elektroniskt. Tj\xE4nsten m\xF6jligg\xF6r f\xF6retag att skapa online-kurser best\xE5ende av video, text, bilder, ljud och interaktiva funktioner. I tj\xE4nsten ing\xE5r hosting och drift av plattformen, support och i vissa fall \xE4ven en webshop f\xF6r presentation och f\xF6rs\xE4ljning av kurserna.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio reserverar sig r\xE4tten att \xE4ndra dessa villkor p\xE5 denna sida och villkoren kommer appliceras 30 dagar fr\xE5n uppdateringen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Efter att ha genomf\xF6rt k\xF6pet av en guide eller kurs som producerats med Coursios tj\xE4nst och via de presentationssidor som framtagits av Coursios verktyg f\xE5r du tillg\xE5ng till materialet. Vid genomf\xF6randet av k\xF6pet registrerar du ett kundkonto f\xF6r att ta del av material via Coursios tj\xE4nst eller anv\xE4nder ett tidigare registrerat konto. N\xE4r k\xF6pet g\xE5tt igenom kommer du in i Coursios tj\xE4nst och tar del av materialet. F\xF6r att fram\xF6ver komma \xE5t materialet loggar du in via sidan',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://app.coursio.com',target:'_blank'},'https://app.coursio.com'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Skapande av kundkonto medges endast den som har en giltig e-postadress. Du ansvarar f\xF6r att den e-postadress som angivits \xE4r riktig och aktiv. Du kan sj\xE4lv \xE4ndra den angivna e-postadressen under \u201CInst\xE4llningar\u201D.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'F\xF6r att registrera dig i Coursio ska du ha fyllt 18 \xE5r.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'L\xE4s mer om hur vi hanterar dina personuppgifter i v\xE5r Personuppgiftspolicy:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://coursio.com/sv/gdpr',target:'_blank'},'https://coursio.com/sv/gdpr'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'2. Betalning'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'D\xE5 k\xF6pet sker genom en presentationssida som framtagits av Coursios verktyg finns f\xF6ljande betalningsalternativ beroende p\xE5 vart du befinner dig d\xE5 du bes\xF6ker oss:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Alt 1. (Svensk uppkoppling) Klarna, Faktura och Kort'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Betalning hanteras genom Klarna Checkout, som erbjuds i samarbete med Klarna AB. Klarna Checkout skiljer p\xE5 k\xF6p och betalning. F\xF6rst bekr\xE4ftar du ditt k\xF6p, sedan v\xE4ljer du hur du vill betala. Du kan v\xE4lja p\xE5 Klarna faktura, Klarna konto, att betala direkt med kort eller med bank\xF6verf\xF6ring.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Klarna Checkout: Genom att anv\xE4nda Klarna Checkout godk\xE4nner du Klarna AB:s (556737-0431, Sveav\xE4gen 46, 111 34 Stockholm), "Klarna", villkor. F\xF6r att f\xE5 anv\xE4nda Klarna Checkout m\xE5ste du vara minst 15 \xE5r.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Identifiering, anpassning och riskbed\xF6mning'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'F\xF6r att s\xE4kert kunna identifiera dig och f\xF6rhindra obeh\xF6rigt nyttjande eller missbruk av Klarna Checkout samt f\xF6r att uppfylla kraven enligt god kreditgivningssed beh\xF6ver Klarna s\xE4kerst\xE4lla din identitet. Klarna inh\xE4mtar till\xE4ggsinformation s\xE5som personnummer, namn och adress samt, vid val av kreditalternativ, kreditinformation fr\xE5n olika leverant\xF6rer. Klarna beh\xF6ver \xE4ven anv\xE4nda den information som du kan ha l\xE4mnat vid tidigare k\xF6p, allm\xE4nt tillg\xE4nglig information p\xE5 internet samt information om hur du tidigare har uppfyllt v\xE5ra betalningsvillkor, f\xF6r att g\xF6ra en riskbed\xF6mning. Klarna Checkout anpassar automatiskt riskbed\xF6mningen, och d\xE4rmed utformningen av tj\xE4nsten, f\xF6r varje g\xE5ng du anv\xE4nder tj\xE4nsten och du beh\xF6ver inte ange mer information \xE4n n\xF6dv\xE4ndigt. I vissa fall visas tidigare angiven och av Klarna godk\xE4nd adress till dig s\xE5 snart du uppgivit din e-postadress och ditt postnummer. Den godk\xE4nda adressen f\xE5r endast anv\xE4ndas i syfte att f\xF6rifyllda adressuppgifterna i direkt samband med ett k\xF6p. Du kan enkelt undvika att den godk\xE4nda adressen f\xF6rifylls genom att v\xE4lja att till\xE4mpa en PIN-kod. Genom att slutf\xF6ra k\xF6pet bekr\xE4ftar du din identitet och korrekt leveransadress.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Betalning, avgifter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Klarna Checkout uppvisar de betalningsalternativ som kan erbjudas dig. Aktuella betalningsalternativ som f\xF6r n\xE4rvarande kan komma att erbjudas genom Klarna Checkout \xE4r faktura, kontokredit, kortbetalning eller direktbetalning via bank. Faktura ligger som f\xF6rvalt betalningsalternativ d\xE4r s\xE5 \xE4r m\xF6jligt. Vid betalning med faktura g\xE4ller Klarnas vid var tid g\xE4llande fakturavillkor; f.n. 14 dagars kredit, en p\xE5minnelseavgift tillkommer vid utebliven betalning. Har du handlat f\xF6r under 60 kr tillkommer 29 kr, och har du handlat f\xF6r 60 kr eller mer tillkommer 60 kr i p\xE5minnelseavgift. \xC4ven en dr\xF6jsm\xE5lsr\xE4nta motsvarande 24 % plus vid var tid av Riksbanken fastst\xE4lld referensr\xE4nta. Det kostar inget att anv\xE4nda Klarna Checkout. Eventuella skatter eller avgifter kan dock tillkomma genom valt betalningsalternativ, se n\xE4rmare de enskilda betalningsvillkoren f\xF6r det alternativ du v\xE4ljer. Klarna kan n\xE4r som helst addera eller ta bort ett eller flera betalningsalternativ av de som erbjuds i Klarna Checkout.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'N\xE4r du slutf\xF6r ett k\xF6p via Klarna Checkout tr\xE4ffar du och Klarna ett avtal d\xE4r Klarna bl.a. garanterar att du inte beh\xF6ver betala om du inte f\xE5r dina varor. Klarna ers\xE4tter samtidigt butiken f\xF6r det du handlat och \xF6vertar d\xE4rmed r\xE4tten att f\xE5 betalt. Oavsett vilket betals\xE4tt du v\xE4ljer s\xE5 g\xE5r din betalning d\xE4rmed till att reglera den fordran Klarna har.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Du kan l\xE4sa de fullst\xE4ndiga villkoren f\xF6r Klarna Checkout',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://cdn.klarna.com/1.0/shared/content/legal/terms/Klarna/sv_se/checkout',target:'_blank'},'h\xE4r.'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Alt 2. (Internationell uppkoppling) Kortbetalning via Stripe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Vi anv\xE4nder oss tj\xE4nst fr\xE5n extern part, Stripe, f\xF6r hantering av kortbetalningar. All k\xE4nslig information, s\xE5som kortuppgifter, behandlas enbart av Stripe via en s\xE4ker betal- och SSL-server. Vi hanterar och lagrar s\xE5ledes inga kortuppgifter. Vi accepterar bland annat Visa, Mastercard och AMEX. F\xF6r Stripes betaltj\xE4nster g\xE4ller Stripes',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://stripe.com/se/legal',target:'_blank'},'allm\xE4nna villkor'),' ','och',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://stripe.com/se/privacy',target:'_blank'},'sekretess-policy'),', vilken ni finner under respektive l\xE4nk.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'3. \xC5ngerr\xE4tt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'D\xE5 du k\xF6per tillg\xE5ng till en tj\xE4nst g\xE4ller inte distanshandelslagen. D\xE5 betalningen g\xE5tt igenom och du f\xE5tt tillg\xE5ng till materialet anses \xE5ngerr\xE4tten f\xF6rbrukad. \xC5ngerr\xE4tten g\xE4ller inte heller defekta eller felaktiga varor. \xC4r produkten defekt eller felaktig \xE4r du ist\xE4llet v\xE4lkommen att kontakta v\xE5r kundservice och g\xF6ra en reklamation via kursskaparen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'4. Tekniska f\xF6ruts\xE4ttningar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Tj\xE4nsten kr\xE4ver tillg\xE5ng till internet samt en modern/uppdaterad webbl\xE4sare. Du ansvarar sj\xE4lv f\xF6r de kostnader som uppst\xE5r i anv\xE4ndandet av internetuppkoppling.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'5. Ansvar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Vid k\xF6p av en kurs eller guide g\xE4ller tillg\xE5ngen till materialet endast f\xF6r den personen som har k\xF6pt det. Du f\xE5r inte p\xE5 n\xE5got s\xE4tt sprida vidare inneh\xE5llet till andra eller dela l\xF6senord till ditt konto.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'6. Coursio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Material k\xF6pt via Coursio finns tillg\xE4ngligt dygnet runt, sju dagar i veckan. Coursio ger dock inga garantier f\xF6r att tj\xE4nsten alltid \xE4r fri fr\xE5n fel eller avbrott. Om brister eller avbrott i tj\xE4nsten uppst\xE5r skall Coursio ges m\xF6jlighet att r\xE4tta till dessa utan att avtalsbrott skall anses f\xF6religga. Coursio har ocks\xE5 r\xE4tt att, i rimlig omfattning, st\xE4nga tj\xE4nsten f\xF6r till exempel uppgraderingar och service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'7. Ansvarsfriskrivning'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio \xE4r en tj\xE4nst f\xF6r att publicera material i form av kurser och guider. Genom tj\xE4nsten kan Coursios kunder s\xE4lja kurser och guider antingen via sina egna hemsidor, andra f\xF6rs\xE4ljningskanaler eller i de fall de vill via en presentationssida som ing\xE5r i Coursios tj\xE4nst. I de fall f\xF6rs\xE4ljningen sker via denna sida sk\xF6ts betalningen via Coursios konton p\xE5 Klarna och Net Payments. Coursio \xE4r inte ansvariga f\xF6r dispyter, krav, f\xF6rluster, eller skador av n\xE5got slag som kan uppst\xE5 ur handlingar eller information som genomf\xF6rs och delas av kunder till Coursio eller deltagare i kundernas kurser och guider.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Vi kontrollerar inte inneh\xE5llet i de material som l\xE4ggs upp av v\xE5ra kunder och garanterar inte p\xE5 n\xE5got s\xE4tt tillf\xF6rlitligheten, giltigheten, noggrannheten eller korrektheten i inneh\xE5llet. Som k\xF6pare av kurser eller guider medger du att du kan exponeras f\xF6r st\xF6tande eller ol\xE4mpligt inneh\xE5ll och f\xF6rst\xE5r att Coursio b\xE4r inget ansvar f\xF6r att h\xE5lla dig borta fr\xE5n denna typ av inneh\xE5ll och tar inget ansvar f\xF6r inneh\xE5llet i sig.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Via Coursio kan du f\xE5 tillg\xE5ng till l\xE4nkar till tredje parts sidor antingen genom verktyget i sig eller material som kurserna skapare lagt upp. Coursio tar inget ansvar f\xF6r dessa tredje parts sidor och kontrollerar inte dem p\xE5 n\xE5got s\xE4tt. Som anv\xE4ndare i Coursio b\xF6r du ta l\xE4mpliga \xE5tg\xE4rder f\xF6r att bed\xF6ma om det \xE4r l\xE4mpligt att bes\xF6ka en s\xE5dan tredje parts sida och skydda din egna personliga information och integritet p\xE5 en s\xE5dan sida.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'8. Lagval'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Tvist enligt dessa villkor skall avg\xF6ras enligt svensk lag i Stockholms Tingsr\xE4tt.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Fr\xE5gor kring dessa villkor riktas till Coursio AB, Tegn\xE9rgatan 1, 111 40 Stockholm eller info@coursio.com'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Personuppgifter \u2013 hur dom hanteras och anv\xE4nds'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'F\xF6r att registrera sig i Coursios tj\xE4nst kr\xE4vs endast e-mail adress och F\xF6r och Efternamn. N\xE4r du uppger dina personuppgifter hos oss godk\xE4nner du att vi lagrar och anv\xE4nder dina uppgifter i v\xE5r verksamhet f\xF6r att fullf\xF6lja avtalet gentemot dig. I detta ing\xE5r att vi kommer informera dig om uppdateringar som sker i de material du har tillg\xE5ng till och om generella uppdateringar i tj\xE4nsten.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Du medger ocks\xE5 att vi delar denna persondata med den kund som \xE4r avs\xE4ndare f\xF6r kursen eller guiden som skapats med hj\xE4lp av Coursio. Vem kunden \xE4r framg\xE5r av vem som \xE4r skapare av kursen eller guiden du f\xE5tt tillg\xE5ng till. Dessa kunder f\xE5r anv\xE4nda denna information f\xF6r att kontakta dig i anslutning till kursen som du har tillg\xE5ng till. Kunderna kan ocks\xE5 anv\xE4nda dessa uppgifter i andra syften. Det \xE4r ditt ansvar som anv\xE4ndare att s\xE4kerst\xE4lla vad Kunden kommer att g\xF6ra med denna information och hur den kommer att lagras. Coursio kontrollerar inte anv\xE4ndningsomr\xE5dena eller hur den h\xE4r informationen lagras av v\xE5ra Kunder.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Vid avregistrering av ditt Coursio konto kommer Coursio radera alla uppgifter om dig. Det \xE4r dock ditt ansvar att s\xE4kerst\xE4lla att s\xE5 \xE4ven sker hos de Kunder som du k\xF6pt material av. Du har r\xE4tt att skriftligen utan kostnad beg\xE4ra ett registerutdrag eller r\xE4ttelse/radering av eventuellt felaktiga uppgifter om dig. Du kan ocks\xE5 sp\xE4rra uppgifterna mot marknadsf\xF6ring.'));

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var NotificationDetail=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['read','nextNotifications','prevNotifications']);/* harmony default export */ __webpack_exports__["a"] = (NotificationDetail);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Editor_SelectedMarker__ = __webpack_require__(2199);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_fG'};var StoreEditor=function(_Component){_inherits(StoreEditor,_Component);function StoreEditor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreEditor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreEditor.__proto__||Object.getPrototypeOf(StoreEditor)).call.apply(_ref,[this].concat(args))),_this),_this.handleTouchTap=function(){var onTouchTap=_this.props.onTouchTap;onTouchTap&&onTouchTap();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreEditor,[{key:'render',value:function render(){var _props=this.props,children=_props.children,selected=_props.selected,mark=_props.mark,other=_objectWithoutProperties(_props,['children','selected','mark']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:css.root},other),children,mark&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Editor_SelectedMarker__["a" /* default */],{selected:selected,onTouchTap:this.handleTouchTap}));}}]);return StoreEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreEditor.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onTouchTap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,mark:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};StoreEditor.defaultProps={mark:true};/* harmony default export */ __webpack_exports__["a"] = (StoreEditor);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Widgets__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shallowequal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shallowequal__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_i_',container:'_i-',normalContainer:'_ja',iframe:'_jb',caption:'_jc'};var StoreVideoPlayer=function(_Component){_inherits(StoreVideoPlayer,_Component);function StoreVideoPlayer(){_classCallCheck(this,StoreVideoPlayer);return _possibleConstructorReturn(this,(StoreVideoPlayer.__proto__||Object.getPrototypeOf(StoreVideoPlayer)).apply(this,arguments));}_createClass(StoreVideoPlayer,[{key:'parseVideoUrl',value:function parseVideoUrl(videoUrl){try{var provider=JSON.parse(videoUrl);provider.id=provider.src;var parsedUrl=__WEBPACK_IMPORTED_MODULE_3_Util__["b" /* Media */].getUrlFromProvider(provider);return parsedUrl;}catch(e){try{var _parsedUrl=__WEBPACK_IMPORTED_MODULE_3_Util__["b" /* Media */].getEmbedUrl(videoUrl);return _parsedUrl;}catch(e1){return videoUrl;}}return videoUrl;}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!__WEBPACK_IMPORTED_MODULE_5_shallowequal___default()(this.props,nextProps);}},{key:'renderIFrame',value:function renderIFrame(src){var caption=this.props.caption;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{className:css.iframe,src:src,allowTransparency:true,frameBorder:0,scrolling:'no',webkitAllowFullScreen:true,mozAllowFullScreen:true,allowFullSreen:true,oAllowFullScreen:true,msAllowFullScreen:true}))),caption&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{className:css.caption},caption));}},{key:'getExtension',value:function getExtension(input){var url=input||'';return url.substr((~-url.lastIndexOf('.')>>>0)+2);}},{key:'renderVideoPlayer',value:function renderVideoPlayer(src){var caption=this.props.caption;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Widgets__["e" /* VideoPlayer */],{sources:[{url:src,type:this.getExtension(src)}]}),caption&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{className:css.caption},caption));}},{key:'renderEmptyVideo',value:function renderEmptyVideo(){var caption=this.props.caption;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Widgets__["e" /* VideoPlayer */],{sources:[]}),caption&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{className:css.caption},caption));}},{key:'render',value:function render(){var src=this.props.src;var videoUrl=this.parseVideoUrl(src);if(src!==videoUrl){return this.renderIFrame(videoUrl);}else if(src){return this.renderVideoPlayer(src);}else{return this.renderEmptyVideo();}}}]);return StoreVideoPlayer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreVideoPlayer.propTypes={className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,src:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,caption:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (StoreVideoPlayer);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Tags__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_List__ = __webpack_require__(384);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_jd',buyButton:'_je',giftButton:'_jf',description:'_jg',detail:'_jh',packBadge:'_ji',controls:'_jj',price:'_jk',header:'_jl',cover:'_jm'};var StoreList=function(_Component){_inherits(StoreList,_Component);function StoreList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreList.__proto__||Object.getPrototypeOf(StoreList)).call.apply(_ref,[this].concat(args))),_this),_this.onTouchTap=function(storeItem){var onTouchTapItem=_this.props.onTouchTapItem;if(onTouchTapItem){onTouchTapItem(storeItem);}else{var type=storeItem.type,slug=storeItem.slug;__WEBPACK_IMPORTED_MODULE_2_actions__["A" /* StoreOverviewActions */].findBySlug(type,slug);}},_this.buyItem=function(storeItem,event){__WEBPACK_IMPORTED_MODULE_2_actions__["A" /* StoreOverviewActions */].addToCart(storeItem);event.preventDefault();event.stopPropagation();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreList,[{key:'render',value:function render(){var _this2=this;var _props=this.props,items=_props.items,canIEdit=_props.canIEdit,themeColor=_props.themeColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_List__["a" /* List */],null,items.map(function(storeItem){var price=storeItem.price,currency=storeItem.currency,type=storeItem.type,id=storeItem.id,name=storeItem.name;var coverImages=storeItem.coverImage;var coverImage=coverImages.length&&coverImages.length>0&&coverImages[0]||{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_List__["b" /* ListItem */],{padded:false,card:true,responsive:true,key:storeItem.type+'-'+id,payload:storeItem,onTouchTap:_this2.onTouchTap},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.detail},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.cover,style:{backgroundColor:!canIEdit&&__WEBPACK_IMPORTED_MODULE_1_stores__["z" /* ThemeStore */].getColor(themeColor,0.5)||'rgba(0, 0, 0, 0.5)',backgroundImage:coverImage.id&&'url('+coverImage.url+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.description,dangerouslySetInnerHTML:{__html:storeItem.description}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.price},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedNumber"],{style:'currency',currency:currency,value:Math.round(price.discounted)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Tags__["a" /* TagList */],{dense:true,tags:storeItem.tagsMap}),type===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.packBadge,style:{backgroundColor:__WEBPACK_IMPORTED_MODULE_1_stores__["z" /* ThemeStore */].getColor(themeColor)}},storeItem.courses.length,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ActionViewModule"],{color:__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].fullWhite}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:_this2.buyItem.bind(_this2,storeItem),className:css.buyButton},_this2.context.getIntlMessage('store.joinCourse')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:_this2.buyItem.bind(_this2,storeItem),className:css.giftButton},_this2.context.getIntlMessage('store.giftCourse')));}));}}]);return StoreList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreList.propTypes={username:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,canIEdit:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,themeColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onTouchTapItem:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,cart:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};StoreList.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreList);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_b4'};var Gift=function(_Component){_inherits(Gift,_Component);function Gift(){_classCallCheck(this,Gift);return _possibleConstructorReturn(this,(Gift.__proto__||Object.getPrototypeOf(Gift)).apply(this,arguments));}_createClass(Gift,[{key:'render',value:function render(){var _props=this.props,className=_props.className,other=_objectWithoutProperties(_props,['className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({},other,{xmlns:'http://www.w3.org/2000/svg',width:'16',height:'16',viewBox:'0 0 18 18',version:'1.1',className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(className,css.root)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:'none',fillRule:'evenodd',transform:'translate(1, 1)',strokeWidth:'1.45454545'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline',{points:'14.5454545 5.81818182 14.5454545 16 1.45454545 16 1.45454545 5.81818182'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'0',y:'2.90909091',width:'16',height:'2.90909091'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M3.63636364,1.45454545 C3.63636364,0.650909091 4.28727273,0 5.09090909,0 C7.24218182,0 8,2.90909091 8,2.90909091 L5.09090909,2.90909091 C4.28727273,2.90909091 3.63636364,2.25818182 3.63636364,1.45454545 Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M12.3636364,1.45454545 C12.3636364,0.650909091 11.7127273,0 10.9090909,0 C8.75781818,0 8,2.90909091 8,2.90909091 L10.9090909,2.90909091 C11.7127273,2.90909091 12.3636364,2.25818182 12.3636364,1.45454545 Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline',{points:'9.45454545 2.90909091 9.45454545 16 6.54545455 16 6.54545455 2.90909091'})));}}]);return Gift;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Gift.propTypes={className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (Gift);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Store_StoreFilter__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StoreFilterContainer=function(_mixin){_inherits(StoreFilterContainer,_mixin);function StoreFilterContainer(){_classCallCheck(this,StoreFilterContainer);return _possibleConstructorReturn(this,(StoreFilterContainer.__proto__||Object.getPrototypeOf(StoreFilterContainer)).apply(this,arguments));}_createClass(StoreFilterContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_1_stores__["t" /* StoreOverviewStore */],function(state){return{filter:state.filter};});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_1_stores__["d" /* CategoryStore */],function(state){return{categories:state.list,loading:state.loading};});}},{key:'render',value:function render(){var _state=this.state,loading=_state.loading,other=_objectWithoutProperties(_state,['loading']);if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__["b" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Store_StoreFilter__["a" /* default */],Object.assign({},other,this.props));}}]);return StoreFilterContainer;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));StoreFilterContainer.propTypes={};/* harmony default export */ __webpack_exports__["a"] = (StoreFilterContainer);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ItemDetails__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_CountdownTimer__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Store_PaymentMethodChooser__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_Store_KlarnaOnlineForm__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_Store_KlarnaCheckoutForm__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_Store_StripeCheckoutForm__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_AlertDialog__ = __webpack_require__(2217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Constants__ = __webpack_require__(32);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import StripeCheckoutForm from 'components/Payment/StripeCheckoutForm';
var css={message:'_c5'};var PurchaseDialog=function(_Component){_inherits(PurchaseDialog,_Component);function PurchaseDialog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PurchaseDialog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PurchaseDialog.__proto__||Object.getPrototypeOf(PurchaseDialog)).call.apply(_ref,[this].concat(args))),_this),_this.state={alert:false},_this.setMethod=function(method){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].setPaymentMethod(method);},_this.handleRequestClose=function(event){var onRequestClose=_this.props.onRequestClose;if(onRequestClose){onRequestClose();}else{__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].reset();}},_this.handleComplete=function(){var _this$props=_this.props,isGift=_this$props.isGift,onComplete=_this$props.onComplete;if(onComplete){onComplete();}else{__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].reset();if(!isGift){_this.props.router.push('/dashboard');}else{_this.setState({alert:true});}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PurchaseDialog,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props=this.props,paymentCompleted=_props.paymentCompleted,isGift=_props.isGift;if(isGift&&!paymentCompleted&&nextProps.paymentCompleted){this.setState({alert:true});}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,cart=_props2.cart,isGift=_props2.isGift,open=_props2.open,method=_props2.method,activeDiscountCount=_props2.activeDiscountCount,allowedPaymentProviders=_props2.allowedPaymentProviders,paymentCompleted=_props2.paymentCompleted;var getIntlMessage=this.context.getIntlMessage;var alert=this.state.alert;var _cart=_slicedToArray(cart,1),item=_cart[0];var hasKlarnaCheckout=(allowedPaymentProviders||[]).findIndex(function(provider){return provider===__WEBPACK_IMPORTED_MODULE_10_Constants__["default"].paymentProviders.KLARNACHECKOUT;})>-1;if(paymentCompleted&&!isGift){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__["a" /* default */],{padded:true,open:true,toolbar:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.message},getIntlMessage('store.purchaseSuccess'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_CountdownTimer__["a" /* default */],{seconds:2,color:'#777',alpha:0.3,size:128,onComplete:this.handleComplete})));}else if(paymentCompleted&&isGift){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_AlertDialog__["a" /* default */],{onRequestClose:function onRequestClose(){return _this2.setState({alert:false});},title:getIntlMessage('gift.purchaseComplete'),open:alert},getIntlMessage('gift.nextStep'));}if(hasKlarnaCheckout){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_containers_Store_KlarnaCheckoutForm__["a" /* default */],{open:true,onRequestClose:this.handleRequestClose});}else if(method==='invoice'||method==='account'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers_Store_KlarnaOnlineForm__["a" /* default */],{open:true,onRequestClose:this.handleRequestClose});}else if(method==='creditcard'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_containers_Store_StripeCheckoutForm__["a" /* default */],{open:true,onRequestClose:this.handleRequestClose});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__["a" /* default */],{open:open,onRequestClose:this.handleRequestClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ItemDetails__["a" /* default */],Object.assign({activeDiscountCount:activeDiscountCount},item)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Store_PaymentMethodChooser__["a" /* default */],{onSetMethod:this.setMethod}));}}]);return PurchaseDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PurchaseDialog.propTypes={cart:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,open:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,method:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,paymentCompleted:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onRequestClose:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onComplete:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,activeDiscountCount:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number};PurchaseDialog.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (PurchaseDialog);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Cio_Assets_Visa__ = __webpack_require__(2212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Cio_Assets_MasterCard__ = __webpack_require__(2213);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Units=__WEBPACK_IMPORTED_MODULE_2_Css__["default"].Units;var css={root:'_dn',delayed:'_do',card:'_dp',cardChooser:'_dq',creditCard:'_dr'};var PaymentMethodChooser=function(_Component){_inherits(PaymentMethodChooser,_Component);function PaymentMethodChooser(){_classCallCheck(this,PaymentMethodChooser);return _possibleConstructorReturn(this,(PaymentMethodChooser.__proto__||Object.getPrototypeOf(PaymentMethodChooser)).apply(this,arguments));}_createClass(PaymentMethodChooser,[{key:'setMethod',value:function setMethod(method){var onSetMethod=this.props.onSetMethod;if(onSetMethod){onSetMethod(method);}else{__WEBPACK_IMPORTED_MODULE_1_actions__["v" /* PaymentActions */].change({method:method});}}},{key:'render',value:function render(){var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.delayed,onTouchTap:this.setMethod.bind(this,'invoice')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.cardChooser},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://cdn.klarna.com/1.0/shared/image/generic/logo/sv_se/basic/blue-black.png?width=128'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),getIntlMessage('payment.klarna.invoice'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.card,onTouchTap:this.setMethod.bind(this,'creditcard')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.cardChooser},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Cio_Assets_Visa__["a" /* default */],{className:css.creditCard}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Cio_Assets_MasterCard__["a" /* default */],{className:css.creditCard}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),getIntlMessage('payment.creditCard'))));}}]);return PaymentMethodChooser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PaymentMethodChooser.propTypes={onSetMethod:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};PaymentMethodChooser.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (PaymentMethodChooser);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Store_KlarnaOnlineForm__ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_store__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KlarnaOnlineFormContainer=function(_mixin){_inherits(KlarnaOnlineFormContainer,_mixin);function KlarnaOnlineFormContainer(){_classCallCheck(this,KlarnaOnlineFormContainer);return _possibleConstructorReturn(this,(KlarnaOnlineFormContainer.__proto__||Object.getPrototypeOf(KlarnaOnlineFormContainer)).apply(this,arguments));}_createClass(KlarnaOnlineFormContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["l" /* KlarnaStore */],function(state){return Object.assign({},state);});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["b" /* AuthStore */],function(state){return{loggedIn:state.loggedIn};});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["t" /* StoreOverviewStore */],function(state){return{cart:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_store__["a" /* getCart */])(state),method:state.payment.method,paymentLoading:state.payment.loading};});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Store_KlarnaOnlineForm__["a" /* default */],Object.assign({},this.state,this.props));}}]);return KlarnaOnlineFormContainer;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (KlarnaOnlineFormContainer);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Store_KlarnaCheckoutForm__ = __webpack_require__(2215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_store__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KlarnaCheckoutFormContainer=function(_mixin){_inherits(KlarnaCheckoutFormContainer,_mixin);function KlarnaCheckoutFormContainer(){_classCallCheck(this,KlarnaCheckoutFormContainer);return _possibleConstructorReturn(this,(KlarnaCheckoutFormContainer.__proto__||Object.getPrototypeOf(KlarnaCheckoutFormContainer)).apply(this,arguments));}_createClass(KlarnaCheckoutFormContainer,[{key:'listenToStores',value:function listenToStores(){// this.listenToStoreWithMapper(KlarnaStore, state => ({
//   ...state
// }));
this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["b" /* AuthStore */],function(state){return{loggedIn:state.loggedIn};});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["t" /* StoreOverviewStore */],function(state){return{cart:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_store__["a" /* getCart */])(state),store:state.name,method:state.payment.method,discountCode:state.discountCode,paymentLoading:state.payment.loading,snippet:state.payment.data&&state.payment.data.snippet||''};});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Store_KlarnaCheckoutForm__["a" /* default */],Object.assign({},this.state,this.props));}}]);return KlarnaCheckoutFormContainer;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (KlarnaCheckoutFormContainer);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Store_StripeCheckoutForm__ = __webpack_require__(2216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_store__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StripeCheckoutFormContainer=function(_mixin){_inherits(StripeCheckoutFormContainer,_mixin);function StripeCheckoutFormContainer(){_classCallCheck(this,StripeCheckoutFormContainer);return _possibleConstructorReturn(this,(StripeCheckoutFormContainer.__proto__||Object.getPrototypeOf(StripeCheckoutFormContainer)).apply(this,arguments));}_createClass(StripeCheckoutFormContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["v" /* StripeStore */],function(state){return Object.assign({},state);});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["b" /* AuthStore */],function(state){return{loggedIn:state.loggedIn};});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["t" /* StoreOverviewStore */],function(state){return{errorText:state.payment.errorText,secure3DUrl:state.payment.data.url,error:state.payment.data.error,paymentLoading:state.payment.loading,cart:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_store__["a" /* getCart */])(state)};});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Store_StripeCheckoutForm__["a" /* default */],Object.assign({},this.state,this.props));}}]);return StripeCheckoutFormContainer;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (StripeCheckoutFormContainer);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_Spinner__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Widgets__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Google__ = __webpack_require__(2218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_Facebook__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_actions_Auth__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_ForgotPasswordForm__ = __webpack_require__(621);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var LoginForm=function(_mixin){_inherits(LoginForm,_mixin);function LoginForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LoginForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LoginForm.__proto__||Object.getPrototypeOf(LoginForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={displayName:localStorage&&localStorage.displayName,forgotPassword:false},_this.forgotPassword=function(email){__WEBPACK_IMPORTED_MODULE_9_actions_Auth__["a" /* default */].requestNewPassword(email);_this.setState({forgotPassword:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LoginForm,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_13_stores__["b" /* AuthStore */]);}},{key:'resetLogin',value:function resetLogin(){this.setState({displayName:null});}},{key:'loginWithGoogle',value:function loginWithGoogle(e){__WEBPACK_IMPORTED_MODULE_7_services_Google__["a" /* default */].signIn().then(function(res){// this.props.onLogin();
},function(e){__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(e.error);});}},{key:'loginWithFacebook',value:function loginWithFacebook(){__WEBPACK_IMPORTED_MODULE_8_services_Facebook__["a" /* default */].getLoginUrl();}},{key:'submit',value:function submit(e){var email=this.refs.email.getValue(),password=this.refs.password.getValue();e.preventDefault();if(!email||!password){__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info('Please provide credentials.');return;}__WEBPACK_IMPORTED_MODULE_9_actions_Auth__["a" /* default */].login(email,password);}},{key:'render',value:function render(){var _this2=this;if(this.state.forgotPassword){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_ForgotPasswordForm__["a" /* default */],{onSubmit:this.forgotPassword});}var button=void 0,h4Style={padding:Spacing.desktopGutterMini,textAlign:'center',fontSize:'.75em',color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material,textTransform:'uppercase'};if(this.props.loggingIn){button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["CircularProgress"],{mode:'indeterminate'}));}else{button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{fullWidth:true,label:this.context.getIntlMessage('Login'),secondary:true,onTouchTap:this.submit.bind(this)});}var knownUser=this.state.displayName,greeting=knownUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('welcomeBack'),user:knownUser})||this.context.getIntlMessage('Login'),useOtherLogin=knownUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{style:Object.assign({cursor:'pointer'},h4Style),onTouchTap:this.resetLogin.bind(this)},this.context.getIntlMessage('useOtherLogin')),alternativeLogins=void 0,footer=void 0;if(!knownUser){alternativeLogins=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{fullWidth:true,backgroundColor:'#DC4A38',secondary:true,onTouchTap:this.loginWithGoogle.bind(this),label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Widgets__["b" /* GooglePlus */],{style:{verticalAlign:'middle'},width:'32px',height:'32px'}),this.context.getIntlMessage('loginWithGoogle'))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{onTouchTap:this.loginWithFacebook.bind(this),style:{marginTop:Spacing.desktopGutterMini},fullWidth:true,backgroundColor:'#3B5998',secondary:true,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Widgets__["a" /* FacebookLogo */],{background:'transparent',style:{verticalAlign:'middle'},width:'32px',height:'32px'}),this.context.getIntlMessage('loginWithFacebook'))}));footer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{style:{textAlign:'center',padding:'8px',lineHeight:'32px',color:'#09BEC3',fontSize:'24px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__["a" /* default */],{style:{verticalAlign:'middle',lineHeight:'32px'},initialFill:'#09BEC3',size:32,circleRadius:3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{verticalAlign:'middle',marginLeft:'8px'}},'coursio'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.submit.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:Spacing.desktopGutterMore,paddingBottom:Spacing.desktopGutterMore,textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__["a" /* default */],{initialFill:'#09BEC3'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{style:{fontSize:'1.5em',color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material,padding:'0 0 0.5em 0',margin:0}},greeting)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{fullWidth:true,hintText:this.context.getIntlMessage('Email'),ref:'email',type:'text',autoFocus:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{onEnterKeyDown:this.submit.bind(this),fullWidth:true,hintText:this.context.getIntlMessage('Password'),ref:'password',type:'password'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:Spacing.desktopGutter*0.75,paddingBottom:Spacing.desktopGutter*0.25}},button),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:Object.assign({cursor:'pointer'},h4Style),onTouchTap:function onTouchTap(){return _this2.setState({forgotPassword:true});}},this.context.getIntlMessage('forgotPassword')),useOtherLogin),alternativeLogins,footer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:support@coursio.com'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{touch:true,tooltip:'Contact Support'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__["CommunicationEmail"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material}),' '))));}}]);return LoginForm;}(Object(__WEBPACK_IMPORTED_MODULE_12_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_12_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));LoginForm.propTypes={onLogin:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};LoginForm.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (LoginForm);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_Spinner__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var ForgotPasswordForm=function(_Component){_inherits(ForgotPasswordForm,_Component);function ForgotPasswordForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ForgotPasswordForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ForgotPasswordForm.__proto__||Object.getPrototypeOf(ForgotPasswordForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={displayName:localStorage&&localStorage.displayName},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ForgotPasswordForm,[{key:'resetLogin',value:function resetLogin(){this.setState({displayName:null});}},{key:'loginWithGoogle',value:function loginWithGoogle(){}},{key:'submit',value:function submit(e){var email=this.refs.email.getValue();e.preventDefault();if(!email){__WEBPACK_IMPORTED_MODULE_4_services_Message__["a" /* default */].info('Please provide credentials.');return;}if(this.props.onSubmit){this.props.onSubmit(email);}}},{key:'render',value:function render(){var button=void 0;if(this.state.loading){button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{fullWidth:true,secondary:true,disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_Spinner__["a" /* default */],null));}else{button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{fullWidth:true,label:this.context.getIntlMessage('Request'),secondary:true,onTouchTap:this.submit.bind(this)});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.submit.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__["a" /* default */],{initialFill:'#09BEC3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{style:{fontSize:'1.5em',color:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material,padding:Spacing.desktopGutterMini*2}},this.context.getIntlMessage('forgotPassword'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{fullWidth:true,onEnterKeyDown:this.submit.bind(this),hintText:this.context.getIntlMessage('Email'),floatingLabelText:this.context.getIntlMessage('Email'),ref:'email',type:'text'}),button));}}]);return ForgotPasswordForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ForgotPasswordForm.propTypes={onSubmit:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};ForgotPasswordForm.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (ForgotPasswordForm);

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(518);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Store_PurchaseDialog__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_GiftEmailForm__ = __webpack_require__(2220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_selectors_store__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GiftDialogContainer=function(_mixin){_inherits(GiftDialogContainer,_mixin);function GiftDialogContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GiftDialogContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GiftDialogContainer.__proto__||Object.getPrototypeOf(GiftDialogContainer)).call.apply(_ref,[this].concat(args))),_this),_this.clearCart=function(){__WEBPACK_IMPORTED_MODULE_3_actions__["A" /* StoreOverviewActions */].reset();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GiftDialogContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["t" /* StoreOverviewStore */],function(state){var cart=Object(__WEBPACK_IMPORTED_MODULE_8_selectors_store__["a" /* getCart */])(state);return{cart:cart,isGift:Object(__WEBPACK_IMPORTED_MODULE_8_selectors_store__["j" /* isGift */])(state),open:cart.length>0&&Object(__WEBPACK_IMPORTED_MODULE_8_selectors_store__["j" /* isGift */])(state),activeDiscountCount:state.activeDiscountCount,paymentCompleted:state.payment.completed,method:state.payment.method,giftEmail:state.giftEmail};});}},{key:'render',value:function render(){var _state=this.state,cart=_state.cart,isGift=_state.isGift,giftEmail=_state.giftEmail;if(cart.length<1||!isGift){return null;}if(!giftEmail){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_FullScreenDialog__["a" /* default */],Object.assign({open:this.state.open,toolbar:true},this.props,{onRequestClose:this.clearCart}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_GiftEmailForm__["a" /* default */],null));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Store_PurchaseDialog__["a" /* default */],Object.assign({},this.state,this.props,{onRequestClose:this.clearCart}));}}]);return GiftDialogContainer;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (GiftDialogContainer);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Drawer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Drawer__ = __webpack_require__(2222);
var Drawer=__WEBPACK_IMPORTED_MODULE_0__Drawer__["a" /* default */];/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Drawer__["a" /* default */]);

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = decorateHandler;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(38);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _disposables = __webpack_require__(2234);

var _isPlainObject = __webpack_require__(148);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _hoistNonReactStatics = __webpack_require__(201);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _shallowEqual = __webpack_require__(407);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _shallowEqualScalar = __webpack_require__(627);

var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isClassComponent = function isClassComponent(Comp) {
	return Boolean(Comp && Comp.prototype && typeof Comp.prototype.render === 'function');
};

function decorateHandler(_ref) {
	var _class, _temp;

	var DecoratedComponent = _ref.DecoratedComponent,
	    createHandler = _ref.createHandler,
	    createMonitor = _ref.createMonitor,
	    createConnector = _ref.createConnector,
	    registerHandler = _ref.registerHandler,
	    containerDisplayName = _ref.containerDisplayName,
	    getType = _ref.getType,
	    collect = _ref.collect,
	    options = _ref.options;
	var _options$arePropsEqua = options.arePropsEqual,
	    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;

	var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

	var DragDropContainer = (_temp = _class = function (_Component) {
		_inherits(DragDropContainer, _Component);

		_createClass(DragDropContainer, [{
			key: 'getHandlerId',
			value: function getHandlerId() {
				return this.handlerId;
			}
		}, {
			key: 'getDecoratedComponentInstance',
			value: function getDecoratedComponentInstance() {
				return this.decoratedComponentInstance;
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
			}
		}]);

		function DragDropContainer(props, context) {
			_classCallCheck(this, DragDropContainer);

			var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));

			_this.handleChange = _this.handleChange.bind(_this);
			_this.handleChildRef = _this.handleChildRef.bind(_this);

			(0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

			_this.manager = _this.context.dragDropManager;
			_this.handlerMonitor = createMonitor(_this.manager);
			_this.handlerConnector = createConnector(_this.manager.getBackend());
			_this.handler = createHandler(_this.handlerMonitor);

			_this.disposable = new _disposables.SerialDisposable();
			_this.receiveProps(props);
			_this.state = _this.getCurrentState();
			_this.dispose();
			return _this;
		}

		_createClass(DragDropContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.isCurrentlyMounted = true;
				this.disposable = new _disposables.SerialDisposable();
				this.currentType = null;
				this.receiveProps(this.props);
				this.handleChange();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!arePropsEqual(nextProps, this.props)) {
					this.receiveProps(nextProps);
					this.handleChange();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.dispose();
				this.isCurrentlyMounted = false;
			}
		}, {
			key: 'receiveProps',
			value: function receiveProps(props) {
				this.handler.receiveProps(props);
				this.receiveType(getType(props));
			}
		}, {
			key: 'receiveType',
			value: function receiveType(type) {
				if (type === this.currentType) {
					return;
				}

				this.currentType = type;

				var _registerHandler = registerHandler(type, this.handler, this.manager),
				    handlerId = _registerHandler.handlerId,
				    unregister = _registerHandler.unregister;

				this.handlerId = handlerId;
				this.handlerMonitor.receiveHandlerId(handlerId);
				this.handlerConnector.receiveHandlerId(handlerId);

				var globalMonitor = this.manager.getMonitor();
				var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });

				this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
			}
		}, {
			key: 'handleChange',
			value: function handleChange() {
				if (!this.isCurrentlyMounted) {
					return;
				}

				var nextState = this.getCurrentState();
				if (!(0, _shallowEqual2.default)(nextState, this.state)) {
					this.setState(nextState);
				}
			}
		}, {
			key: 'dispose',
			value: function dispose() {
				this.disposable.dispose();
				this.handlerConnector.receiveHandlerId(null);
			}
		}, {
			key: 'handleChildRef',
			value: function handleChildRef(component) {
				this.decoratedComponentInstance = component;
				this.handler.receiveComponent(component);
			}
		}, {
			key: 'getCurrentState',
			value: function getCurrentState() {
				var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);

				if (false) {
					(0, _invariant2.default)((0, _isPlainObject2.default)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
				}

				return nextState;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
					ref: isClassComponent(DecoratedComponent) ? this.handleChildRef : null
				}));
			}
		}]);

		return DragDropContainer;
	}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
		dragDropManager: _propTypes2.default.object.isRequired
	}, _temp);


	return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
}

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = shallowEqualScalar;
function shallowEqualScalar(objA, objB) {
	if (objA === objB) {
		return true;
	}

	if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
		return false;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	// Test for A's keys different from B.
	var hasOwn = Object.prototype.hasOwnProperty;
	for (var i = 0; i < keysA.length; i += 1) {
		if (!hasOwn.call(objB, keysA[i])) {
			return false;
		}

		var valA = objA[keysA[i]];
		var valB = objB[keysA[i]];

		if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
			return false;
		}
	}

	return true;
}

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = wrapConnectorHooks;

var _react = __webpack_require__(0);

var _cloneWithRef = __webpack_require__(2242);

var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function throwIfCompositeComponentElement(element) {
	// Custom components can no longer be wrapped directly in React DnD 2.0
	// so that we don't need to depend on findDOMNode() from react-dom.
	if (typeof element.type === 'string') {
		return;
	}

	var displayName = element.type.displayName || element.type.name || 'the component';

	throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
}

function wrapHookToRecognizeElement(hook) {
	return function () {
		var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		// When passed a node, call the hook straight away.
		if (!(0, _react.isValidElement)(elementOrNode)) {
			var node = elementOrNode;
			hook(node, options);
			return undefined;
		}

		// If passed a ReactElement, clone it and attach this function as a ref.
		// This helps us achieve a neat API where user doesn't even know that refs
		// are being used under the hood.
		var element = elementOrNode;
		throwIfCompositeComponentElement(element);

		// When no options are passed, use the hook directly
		var ref = options ? function (node) {
			return hook(node, options);
		} : hook;

		return (0, _cloneWithRef2.default)(element, ref);
	};
}

function wrapConnectorHooks(hooks) {
	var wrappedHooks = {};

	Object.keys(hooks).forEach(function (key) {
		var hook = hooks[key];
		var wrappedHook = wrapHookToRecognizeElement(hook);
		wrappedHooks[key] = function () {
			return wrappedHook;
		};
	});

	return wrappedHooks;
}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = areOptionsEqual;

var _shallowEqual = __webpack_require__(407);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function areOptionsEqual(nextOptions, currentOptions) {
	if (currentOptions === nextOptions) {
		return true;
	}

	return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
}

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isValidType;

var _isArray = __webpack_require__(106);

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidType(type, allowArray) {
	return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
		return isValidType(t, false);
	});
}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the MIT License. See the accompanying LICENSE file for terms.
 */


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TouchBackend = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createTouchBackend;

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getEventClientTouchOffset(e) {
    if (e.targetTouches.length === 1) {
        return getEventClientOffset(e.targetTouches[0]);
    }
}

function getEventClientOffset(e) {
    if (e.targetTouches) {
        return getEventClientTouchOffset(e);
    } else {
        return {
            x: e.clientX,
            y: e.clientY
        };
    }
}

// Used for MouseEvent.buttons (note the s on the end).
var MouseButtons = {
    Left: 1,
    Right: 2,
    Center: 4

    // Used for e.button (note the lack of an s on the end).
};var MouseButton = {
    Left: 0,
    Center: 1,
    Right: 2

    /**
     * Only touch events and mouse events where the left button is pressed should initiate a drag.
     * @param {MouseEvent | TouchEvent} e The event
     */
};function eventShouldStartDrag(e) {
    // For touch events, button will be undefined. If e.button is defined,
    // then it should be MouseButton.Left.
    return e.button === undefined || e.button === MouseButton.Left;
}

/**
 * Only touch events and mouse events where the left mouse button is no longer held should end a drag.
 * It's possible the user mouse downs with the left mouse button, then mouse down and ups with the right mouse button.
 * We don't want releasing the right mouse button to end the drag.
 * @param {MouseEvent | TouchEvent} e The event
 */
function eventShouldEndDrag(e) {
    // Touch events will have buttons be undefined, while mouse events will have e.buttons's left button
    // bit field unset if the left mouse button has been released
    return e.buttons === undefined || (e.buttons & MouseButtons.Left) === 0;
}

// Polyfill for document.elementsFromPoint
var elementsFromPoint = (typeof document !== 'undefined' && document.elementsFromPoint || function (x, y) {

    if (document.msElementsFromPoint) {
        // msElementsFromPoint is much faster but returns a node-list, so convert it to an array
        var msElements = document.msElementsFromPoint(x, y);
        return msElements && Array.prototype.slice.call(msElements, 0);
    }

    var elements = [],
        previousPointerEvents = [],
        current,
        i,
        d;

    // get all elements via elementFromPoint, and remove them from hit-testing in order
    while ((current = document.elementFromPoint(x, y)) && elements.indexOf(current) === -1 && current !== null) {

        // push the element and its current style
        elements.push(current);
        previousPointerEvents.push({
            value: current.style.getPropertyValue('pointer-events'),
            priority: current.style.getPropertyPriority('pointer-events')
        });

        // add "pointer-events: none", to get to the underlying element
        current.style.setProperty('pointer-events', 'none', 'important');
    }

    // restore the previous pointer-events values
    for (i = previousPointerEvents.length; d = previousPointerEvents[--i];) {
        elements[i].style.setProperty('pointer-events', d.value ? d.value : '', d.priority);
    }

    // return our results
    return elements;
}).bind(typeof document !== 'undefined' ? document : null);

var supportsPassive = function () {
    // simular to jQuery's test
    var supported = false;
    try {
        addEventListener('test', null, Object.defineProperty({}, 'passive', {
            get: function get() {
                supported = true;
            }
        }));
    } catch (e) {}
    return supported;
}();

var ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
    var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

    if (!el) {
        return null;
    }

    var _el$getBoundingClient = el.getBoundingClientRect(),
        top = _el$getBoundingClient.top,
        left = _el$getBoundingClient.left;

    return { x: left, y: top };
}

var eventNames = {
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        end: 'mouseup',
        contextmenu: 'contextmenu'
    },
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        end: 'touchend'
    },
    keyboard: {
        keydown: 'keydown'
    }
};

var TouchBackend = exports.TouchBackend = function () {
    function TouchBackend(manager) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, TouchBackend);

        options.delayTouchStart = options.delayTouchStart || options.delay;

        options = _extends({
            enableTouchEvents: true,
            enableMouseEvents: false,
            enableKeyboardEvents: false,
            ignoreContextMenu: false,
            delayTouchStart: 0,
            delayMouseStart: 0,
            touchSlop: 0
        }, options);

        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();

        this.enableKeyboardEvents = options.enableKeyboardEvents;
        this.enableMouseEvents = options.enableMouseEvents;
        this.delayTouchStart = options.delayTouchStart;
        this.delayMouseStart = options.delayMouseStart;
        this.ignoreContextMenu = options.ignoreContextMenu;
        this.touchSlop = options.touchSlop;
        this.sourceNodes = {};
        this.sourceNodeOptions = {};
        this.sourcePreviewNodes = {};
        this.sourcePreviewNodeOptions = {};
        this.targetNodes = {};
        this.targetNodeOptions = {};
        this.listenerTypes = [];
        this._mouseClientOffset = {};

        if (options.enableMouseEvents) {
            this.listenerTypes.push('mouse');
        }

        if (options.enableTouchEvents) {
            this.listenerTypes.push('touch');
        }

        if (options.enableKeyboardEvents) {
            this.listenerTypes.push('keyboard');
        }

        this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
        this.handleTopMoveStart = this.handleTopMoveStart.bind(this);
        this.handleTopMoveStartDelay = this.handleTopMoveStartDelay.bind(this);
        this.handleTopMoveStartCapture = this.handleTopMoveStartCapture.bind(this);
        this.handleTopMoveCapture = this.handleTopMoveCapture.bind(this);
        this.handleTopMove = this.handleTopMove.bind(this);
        this.handleTopMoveEndCapture = this.handleTopMoveEndCapture.bind(this);
        this.handleCancelOnEscape = this.handleCancelOnEscape.bind(this);
    }

    _createClass(TouchBackend, [{
        key: 'setup',
        value: function setup() {
            if (typeof window === 'undefined') {
                return;
            }

            (0, _invariant2.default)(!this.constructor.isSetUp, 'Cannot have two Touch backends at the same time.');
            this.constructor.isSetUp = true;

            this.addEventListener(window, 'start', this.getTopMoveStartHandler());
            this.addEventListener(window, 'start', this.handleTopMoveStartCapture, true);
            this.addEventListener(window, 'move', this.handleTopMove);
            this.addEventListener(window, 'move', this.handleTopMoveCapture, true);
            this.addEventListener(window, 'end', this.handleTopMoveEndCapture, true);

            if (this.enableMouseEvents && !this.ignoreContextMenu) {
                this.addEventListener(window, 'contextmenu', this.handleTopMoveEndCapture);
            }

            if (this.enableKeyboardEvents) {
                this.addEventListener(window, 'keydown', this.handleCancelOnEscape, true);
            }
        }
    }, {
        key: 'teardown',
        value: function teardown() {
            if (typeof window === 'undefined') {
                return;
            }

            this.constructor.isSetUp = false;
            this._mouseClientOffset = {};

            this.removeEventListener(window, 'start', this.handleTopMoveStartCapture, true);
            this.removeEventListener(window, 'start', this.handleTopMoveStart);
            this.removeEventListener(window, 'move', this.handleTopMoveCapture, true);
            this.removeEventListener(window, 'move', this.handleTopMove);
            this.removeEventListener(window, 'end', this.handleTopMoveEndCapture, true);

            if (this.enableMouseEvents && !this.ignoreContextMenu) {
                this.removeEventListener(window, 'contextmenu', this.handleTopMoveEndCapture);
            }

            if (this.enableKeyboardEvents) {
                this.removeEventListener(window, 'keydown', this.handleCancelOnEscape, true);
            }

            this.uninstallSourceNodeRemovalObserver();
        }
    }, {
        key: 'addEventListener',
        value: function addEventListener(subject, event, handler, capture) {
            var options = supportsPassive ? { capture: capture, passive: false } : capture;

            this.listenerTypes.forEach(function (listenerType) {
                var evt = eventNames[listenerType][event];

                if (evt) {
                    subject.addEventListener(evt, handler, options);
                }
            });
        }
    }, {
        key: 'removeEventListener',
        value: function removeEventListener(subject, event, handler, capture) {
            var options = supportsPassive ? { capture: capture, passive: false } : capture;

            this.listenerTypes.forEach(function (listenerType) {
                var evt = eventNames[listenerType][event];

                if (evt) {
                    subject.removeEventListener(evt, handler, options);
                }
            });
        }
    }, {
        key: 'connectDragSource',
        value: function connectDragSource(sourceId, node, options) {
            var _this = this;

            var handleMoveStart = this.handleMoveStart.bind(this, sourceId);
            this.sourceNodes[sourceId] = node;

            this.addEventListener(node, 'start', handleMoveStart);

            return function () {
                delete _this.sourceNodes[sourceId];
                _this.removeEventListener(node, 'start', handleMoveStart);
            };
        }
    }, {
        key: 'connectDragPreview',
        value: function connectDragPreview(sourceId, node, options) {
            var _this2 = this;

            this.sourcePreviewNodeOptions[sourceId] = options;
            this.sourcePreviewNodes[sourceId] = node;

            return function () {
                delete _this2.sourcePreviewNodes[sourceId];
                delete _this2.sourcePreviewNodeOptions[sourceId];
            };
        }
    }, {
        key: 'connectDropTarget',
        value: function connectDropTarget(targetId, node) {
            var _this3 = this;

            var handleMove = function handleMove(e) {
                var coords = void 0;

                if (!_this3.monitor.isDragging()) {
                    return;
                }

                /**
                 * Grab the coordinates for the current mouse/touch position
                 */
                switch (e.type) {
                    case eventNames.mouse.move:
                        coords = { x: e.clientX, y: e.clientY };
                        break;

                    case eventNames.touch.move:
                        coords = { x: e.touches[0].clientX, y: e.touches[0].clientY };
                        break;
                }

                /**
                 * Use the coordinates to grab the element the drag ended on.
                 * If the element is the same as the target node (or any of it's children) then we have hit a drop target and can handle the move.
                 */
                var droppedOn = document.elementFromPoint(coords.x, coords.y);
                var childMatch = node.contains(droppedOn);

                if (droppedOn === node || childMatch) {
                    return _this3.handleMove(e, targetId);
                }
            };

            /**
             * Attaching the event listener to the body so that touchmove will work while dragging over multiple target elements.
             */
            this.addEventListener(document.querySelector('body'), 'move', handleMove);
            this.targetNodes[targetId] = node;

            return function () {
                delete _this3.targetNodes[targetId];
                _this3.removeEventListener(document.querySelector('body'), 'move', handleMove);
            };
        }
    }, {
        key: 'getSourceClientOffset',
        value: function getSourceClientOffset(sourceId) {
            return getNodeClientOffset(this.sourceNodes[sourceId]);
        }
    }, {
        key: 'handleTopMoveStartCapture',
        value: function handleTopMoveStartCapture(e) {
            if (!eventShouldStartDrag(e)) {
                return;
            }

            this.moveStartSourceIds = [];
        }
    }, {
        key: 'handleMoveStart',
        value: function handleMoveStart(sourceId) {
            // Just because we received an event doesn't necessarily mean we need to collect drag sources.
            // We only collect start collecting drag sources on touch and left mouse events.
            if (Array.isArray(this.moveStartSourceIds)) {
                this.moveStartSourceIds.unshift(sourceId);
            }
        }
    }, {
        key: 'getTopMoveStartHandler',
        value: function getTopMoveStartHandler() {
            if (!this.delayTouchStart && !this.delayMouseStart) {
                return this.handleTopMoveStart;
            }

            return this.handleTopMoveStartDelay;
        }
    }, {
        key: 'handleTopMoveStart',
        value: function handleTopMoveStart(e) {
            if (!eventShouldStartDrag(e)) {
                return;
            }

            // Don't prematurely preventDefault() here since it might:
            // 1. Mess up scrolling
            // 2. Mess up long tap (which brings up context menu)
            // 3. If there's an anchor link as a child, tap won't be triggered on link

            var clientOffset = getEventClientOffset(e);
            if (clientOffset) {
                this._mouseClientOffset = clientOffset;
            }
            this.waitingForDelay = false;
        }
    }, {
        key: 'handleTopMoveStartDelay',
        value: function handleTopMoveStartDelay(e) {
            if (!eventShouldStartDrag(e)) {
                return;
            }

            var delay = e.type === eventNames.touch.start ? this.delayTouchStart : this.delayMouseStart;
            this.timeout = setTimeout(this.handleTopMoveStart.bind(this, e), delay);
            this.waitingForDelay = true;
        }
    }, {
        key: 'handleTopMoveCapture',
        value: function handleTopMoveCapture(e) {
            this.dragOverTargetIds = [];
        }
    }, {
        key: 'handleMove',
        value: function handleMove(e, targetId) {
            this.dragOverTargetIds.unshift(targetId);
        }
    }, {
        key: 'handleTopMove',
        value: function handleTopMove(e) {
            var _this4 = this;

            clearTimeout(this.timeout);
            if (this.waitingForDelay) {
                return;
            }

            var moveStartSourceIds = this.moveStartSourceIds,
                dragOverTargetIds = this.dragOverTargetIds;

            var clientOffset = getEventClientOffset(e);

            if (!clientOffset) {
                return;
            }

            // If we're not dragging and we've moved a little, that counts as a drag start
            if (!this.monitor.isDragging() && this._mouseClientOffset.hasOwnProperty('x') && moveStartSourceIds && distance(this._mouseClientOffset.x, this._mouseClientOffset.y, clientOffset.x, clientOffset.y) > (this.touchSlop ? this.touchSlop : 0)) {
                this.moveStartSourceIds = null;
                this.actions.beginDrag(moveStartSourceIds, {
                    clientOffset: this._mouseClientOffset,
                    getSourceClientOffset: this.getSourceClientOffset,
                    publishSource: false
                });
            }

            if (!this.monitor.isDragging()) {
                return;
            }

            var sourceNode = this.sourceNodes[this.monitor.getSourceId()];
            this.installSourceNodeRemovalObserver(sourceNode);
            this.actions.publishDragSource();

            e.preventDefault();

            // Get the node elements of the hovered DropTargets
            var dragOverTargetNodes = dragOverTargetIds.map(function (key) {
                return _this4.targetNodes[key];
            });
            // Get the a ordered list of nodes that are touched by
            var elementsAtPoint = elementsFromPoint(clientOffset.x, clientOffset.y);
            // Extend list with SVG parents that are not receiving elementsFromPoint events (svg groups)
            var elementsAtPointExtended = [];
            for (var nodeId in elementsAtPoint) {
                var currentNode = elementsAtPoint[nodeId];
                elementsAtPointExtended.push(currentNode);
                // Is currentNode an SVG element
                while (currentNode && currentNode.ownerSVGElement) {
                    currentNode = currentNode.parentElement;
                    if (!elementsAtPointExtended.includes(currentNode)) elementsAtPointExtended.push(currentNode);
                }
            }
            var orderedDragOverTargetIds = elementsAtPointExtended
            // Filter off nodes that arent a hovered DropTargets nodes
            .filter(function (node) {
                return dragOverTargetNodes.indexOf(node) > -1;
            })
            // Map back the nodes elements to targetIds
            .map(function (node) {
                for (var targetId in _this4.targetNodes) {
                    if (node === _this4.targetNodes[targetId]) return targetId;
                }
                return null;
            })
            // Filter off possible null rows
            .filter(function (node) {
                return !!node;
            }).filter(function (id, index, ids) {
                return ids.indexOf(id) === index;
            });

            // Reverse order because dnd-core reverse it before calling the DropTarget drop methods
            orderedDragOverTargetIds.reverse();

            this.actions.hover(orderedDragOverTargetIds, {
                clientOffset: clientOffset
            });
        }
    }, {
        key: 'handleTopMoveEndCapture',
        value: function handleTopMoveEndCapture(e) {
            if (!eventShouldEndDrag(e)) {
                return;
            }

            if (!this.monitor.isDragging() || this.monitor.didDrop()) {
                this.moveStartSourceIds = null;
                return;
            }

            e.preventDefault();

            this._mouseClientOffset = {};

            this.uninstallSourceNodeRemovalObserver();
            this.actions.drop();
            this.actions.endDrag();
        }
    }, {
        key: 'handleCancelOnEscape',
        value: function handleCancelOnEscape(e) {
            if (e.key === 'Escape') {
                this._mouseClientOffset = {};

                this.uninstallSourceNodeRemovalObserver();
                this.actions.endDrag();
            }
        }
    }, {
        key: 'handleOnContextMenu',
        value: function handleOnContextMenu() {
            this.moveStartSourceIds = null;
        }
    }, {
        key: 'installSourceNodeRemovalObserver',
        value: function installSourceNodeRemovalObserver(node) {
            var _this5 = this;

            this.uninstallSourceNodeRemovalObserver();

            this.draggedSourceNode = node;
            this.draggedSourceNodeRemovalObserver = new window.MutationObserver(function () {
                if (!node.parentElement) {
                    _this5.resurrectSourceNode();
                    _this5.uninstallSourceNodeRemovalObserver();
                }
            });

            if (!node || !node.parentElement) {
                return;
            }

            this.draggedSourceNodeRemovalObserver.observe(node.parentElement, { childList: true });
        }
    }, {
        key: 'resurrectSourceNode',
        value: function resurrectSourceNode() {
            this.draggedSourceNode.style.display = 'none';
            this.draggedSourceNode.removeAttribute('data-reactid');
            document.body.appendChild(this.draggedSourceNode);
        }
    }, {
        key: 'uninstallSourceNodeRemovalObserver',
        value: function uninstallSourceNodeRemovalObserver() {
            if (this.draggedSourceNodeRemovalObserver) {
                this.draggedSourceNodeRemovalObserver.disconnect();
            }

            this.draggedSourceNodeRemovalObserver = null;
            this.draggedSourceNode = null;
        }
    }]);

    return TouchBackend;
}();

function createTouchBackend() {
    var optionsOrManager = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var touchBackendFactory = function touchBackendFactory(manager) {
        return new TouchBackend(manager, optionsOrManager);
    };

    if (optionsOrManager.getMonitor) {
        return touchBackendFactory(optionsOrManager);
    } else {
        return touchBackendFactory;
    }
}

function distance(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(Math.abs(x2 - x1), 2) + Math.pow(Math.abs(y2 - y1), 2));
}

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = DragDropContext;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(38);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dndCore = __webpack_require__(2247);

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _hoistNonReactStatics = __webpack_require__(201);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _checkDecoratorArguments = __webpack_require__(273);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
	dragDropManager: _propTypes2.default.object.isRequired
};

var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
	return {
		dragDropManager: new _dndCore.DragDropManager(backend, context)
	};
};

var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
	// Auto-detect ES6 default export for people still using ES5
	var backend = backendOrModule;
	if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
		backend = backend.default;
	}
	(0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
	return backend;
};

function DragDropContext(backendOrModule) {
	_checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params

	var backend = unpackBackendForEs5Users(backendOrModule);
	var childContext = createChildContext(backend);

	return function decorateContext(DecoratedComponent) {
		var _class, _temp;

		var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

		var DragDropContextContainer = (_temp = _class = function (_Component) {
			_inherits(DragDropContextContainer, _Component);

			function DragDropContextContainer() {
				_classCallCheck(this, DragDropContextContainer);

				return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
			}

			_createClass(DragDropContextContainer, [{
				key: 'getDecoratedComponentInstance',
				value: function getDecoratedComponentInstance() {
					(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
					return this.child;
				}
			}, {
				key: 'getManager',
				value: function getManager() {
					return childContext.dragDropManager;
				}
			}, {
				key: 'getChildContext',
				value: function getChildContext() {
					return childContext;
				}
			}, {
				key: 'render',
				value: function render() {
					var _this2 = this;

					return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
						ref: function ref(child) {
							_this2.child = child;
						}
					}));
				}
			}]);

			return DragDropContextContainer;
		}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);


		return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
	};
}

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = dragOffset;
exports.getSourceClientOffset = getSourceClientOffset;
exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;

var _dragDrop = __webpack_require__(274);

var initialState = {
	initialSourceClientOffset: null,
	initialClientOffset: null,
	clientOffset: null
};

function areOffsetsEqual(offsetA, offsetB) {
	if (offsetA === offsetB) {
		return true;
	}
	return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}

function dragOffset() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _dragDrop.BEGIN_DRAG:
			return {
				initialSourceClientOffset: action.sourceClientOffset,
				initialClientOffset: action.clientOffset,
				clientOffset: action.clientOffset
			};
		case _dragDrop.HOVER:
			if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
				return state;
			}
			return _extends({}, state, {
				clientOffset: action.clientOffset
			});
		case _dragDrop.END_DRAG:
		case _dragDrop.DROP:
			return initialState;
		default:
			return state;
	}
}

function getSourceClientOffset(state) {
	var clientOffset = state.clientOffset,
	    initialClientOffset = state.initialClientOffset,
	    initialSourceClientOffset = state.initialSourceClientOffset;

	if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
		return null;
	}
	return {
		x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
		y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
	};
}

function getDifferenceFromInitialOffset(state) {
	var clientOffset = state.clientOffset,
	    initialClientOffset = state.initialClientOffset;

	if (!clientOffset || !initialClientOffset) {
		return null;
	}
	return {
		x: clientOffset.x - initialClientOffset.x,
		y: clientOffset.y - initialClientOffset.y
	};
}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = matchesType;

var _isArray = __webpack_require__(106);

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matchesType(targetType, draggedItemType) {
	if ((0, _isArray2.default)(targetType)) {
		return targetType.some(function (t) {
			return t === draggedItemType;
		});
	} else {
		return targetType === draggedItemType;
	}
}

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(636),
    baseRest = __webpack_require__(205),
    isArrayLikeObject = __webpack_require__(275);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(256),
    arrayIncludes = __webpack_require__(409),
    arrayIncludesWith = __webpack_require__(410),
    arrayMap = __webpack_require__(411),
    baseUnary = __webpack_require__(373),
    cacheHas = __webpack_require__(257);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 637 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = dirtyHandlerIds;
exports.areDirty = areDirty;

var _xor = __webpack_require__(2266);

var _xor2 = _interopRequireDefault(_xor);

var _intersection = __webpack_require__(2270);

var _intersection2 = _interopRequireDefault(_intersection);

var _dragDrop = __webpack_require__(274);

var _registry = __webpack_require__(276);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NONE = [];
var ALL = [];

function dirtyHandlerIds() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
	var action = arguments[1];
	var dragOperation = arguments[2];

	switch (action.type) {
		case _dragDrop.HOVER:
			break;
		case _registry.ADD_SOURCE:
		case _registry.ADD_TARGET:
		case _registry.REMOVE_TARGET:
		case _registry.REMOVE_SOURCE:
			return NONE;
		case _dragDrop.BEGIN_DRAG:
		case _dragDrop.PUBLISH_DRAG_SOURCE:
		case _dragDrop.END_DRAG:
		case _dragDrop.DROP:
		default:
			return ALL;
	}

	var targetIds = action.targetIds;
	var prevTargetIds = dragOperation.targetIds;

	var result = (0, _xor2.default)(targetIds, prevTargetIds);

	var didChange = false;
	if (result.length === 0) {
		for (var i = 0; i < targetIds.length; i++) {
			if (targetIds[i] !== prevTargetIds[i]) {
				didChange = true;
				break;
			}
		}
	} else {
		didChange = true;
	}

	if (!didChange) {
		return NONE;
	}

	var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
	var innermostTargetId = targetIds[targetIds.length - 1];

	if (prevInnermostTargetId !== innermostTargetId) {
		if (prevInnermostTargetId) {
			result.push(prevInnermostTargetId);
		}
		if (innermostTargetId) {
			result.push(innermostTargetId);
		}
	}

	return result;
}

function areDirty(state, handlerIds) {
	if (state === NONE) {
		return false;
	}

	if (state === ALL || typeof handlerIds === 'undefined') {
		return true;
	}

	return (0, _intersection2.default)(handlerIds, state).length > 0;
}

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(556),
    isFlattenable = __webpack_require__(2268);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(256),
    arrayIncludes = __webpack_require__(409),
    arrayIncludesWith = __webpack_require__(410),
    cacheHas = __webpack_require__(257),
    createSet = __webpack_require__(2269),
    setToArray = __webpack_require__(371);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 641 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormFieldContainer__ = __webpack_require__(119);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var toHex=function toHex(number){var str=number.toString(16).toUpperCase();var pad='#000000';return pad.substring(0,pad.length-str.length)+str;};var css={root:'_jS',color:'_jT'};var ColorChooser=function(_Component){_inherits(ColorChooser,_Component);function ColorChooser(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ColorChooser);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ColorChooser.__proto__||Object.getPrototypeOf(ColorChooser)).call.apply(_ref,[this].concat(args))),_this),_this.handleTouchTap=function(color){var _this$props=_this.props,onChange=_this$props.onChange,selected=_this$props.selected;if(onChange){onChange(color===selected?null:color);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ColorChooser,[{key:'render',value:function render(){var _this2=this;var _props=this.props,colors=_props.colors,title=_props.title,selected=_props.selected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FormFieldContainer__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},colors.map(function(color){var backgroundColor=toHex(color);var borderColor=selected===backgroundColor?''+toHex(0xffffff^color):'transparent';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:color,className:css.color,style:{backgroundColor:backgroundColor},onTouchTap:_this2.handleTouchTap.bind(_this2,backgroundColor)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{borderColor:borderColor}}));})));}}]);return ColorChooser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ColorChooser.propTypes={selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,colors:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};ColorChooser.defaultProps={colors:[0xaa4245,0xadd356,0x4299aa,0x7342aa,0xaa9a42,0x000000,0x474747,0x636363,0x727272,0xffffff]};/* harmony default export */ __webpack_exports__["a"] = (ColorChooser);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormFieldContainer__ = __webpack_require__(119);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={sizeContainer:'_jQ',selected:'_jR'};var SizeChooser=function(_Component){_inherits(SizeChooser,_Component);function SizeChooser(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SizeChooser);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SizeChooser.__proto__||Object.getPrototypeOf(SizeChooser)).call.apply(_ref,[this].concat(args))),_this),_this.handleTouchTap=function(size){var _this$props=_this.props,onChange=_this$props.onChange,selected=_this$props.selected;if(size!==selected&&onChange){onChange(size);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SizeChooser,[{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,selected=_props.selected,sizes=_props.sizes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FormFieldContainer__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,sizes.map(function(size){var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.sizeContainer,_defineProperty({},css.selected,size<=selected));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:size,className:classes,onTouchTap:_this2.handleTouchTap.bind(_this2,size)});})));}}]);return SizeChooser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SizeChooser.propTypes={selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onTouchTap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,sizes:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};SizeChooser.defaultProps={sizes:[1,2,3]};/* harmony default export */ __webpack_exports__["a"] = (SizeChooser);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormFieldContainer__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_AspectRatioContainer__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_MediaLibrary_UploadDialog__ = __webpack_require__(396);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={imageContainer:'_j6',hasImage:'_j7',wrapper:'_j8'};var styles={icon:{width:64,height:64},addIcon:{position:'absolute',right:-12,bottom:-12}};var ImageChooser=function(_Component){_inherits(ImageChooser,_Component);function ImageChooser(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ImageChooser);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ImageChooser.__proto__||Object.getPrototypeOf(ImageChooser)).call.apply(_ref,[this].concat(args))),_this),_this.state={uploadDialog:false},_this.openDialog=function(){_this.setState({uploadDialog:true});},_this.closeDialog=function(){_this.setState({uploadDialog:false});},_this.changeImage=function(src){var onChange=_this.props.onChange;onChange&&onChange(src);_this.closeDialog();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ImageChooser,[{key:'render',value:function render(){var title=this.props.title;var uploadDialog=this.state.uploadDialog;var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FormFieldContainer__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_AspectRatioContainer__["a" /* default */],{mediaClassName:css.imageContainer,onTouchTap:this.openDialog},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ImageLandscape"],{style:styles.icon,color:'#535353'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ContentAddCircleOutline"],{color:__WEBPACK_IMPORTED_MODULE_1_Css__["Colors"].creen,style:styles.addIcon}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_MediaLibrary_UploadDialog__["a" /* default */],{onRequestClose:this.closeDialog,onSuccess:this.changeImage,title:getIntlMessage('image.upload'),description:getIntlMessage('module.dropImage'),type:'image',open:uploadDialog}));}}]);return ImageChooser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ImageChooser.propTypes={title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};ImageChooser.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (ImageChooser);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={container:'_kj',mediaHolder:'_kk',media:'_kl',element:'_km',cardImage:'_kn'};var CardImage=function(_Component){_inherits(CardImage,_Component);function CardImage(){_classCallCheck(this,CardImage);return _possibleConstructorReturn(this,(CardImage.__proto__||Object.getPrototypeOf(CardImage)).apply(this,arguments));}_createClass(CardImage,[{key:'render',value:function render(){var _props=this.props,className=_props.className,children=_props.children,mediaClassName=_props.mediaClassName,other=_objectWithoutProperties(_props,['className','children','mediaClassName']);var child=__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(className,css.container)},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.mediaHolder},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(mediaClassName,css.media)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child,{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(child.props.className,css.element)}))));}}]);return CardImage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CardImage.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,mediaClassName:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (CardImage);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores_Discount__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_Discount__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Grid__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Widgets_SimpleOverview__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_actions_Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Widgets_SelectableList__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_DialogPortal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_CourseSelector__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_BundleSelector__ = __webpack_require__(2306);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ImageImage=__WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__["ImageImage"],EditorModeEdit=__WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__["EditorModeEdit"],ContentAdd=__WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__["ContentAdd"],ActionDelete=__WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__["ActionDelete"],ActionLabel=__WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__["ActionLabel"],ContentSave=__WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__["ContentSave"],ContentClear=__WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__["ContentClear"],ContentCreate=__WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__["ContentCreate"];var DiscountForm=function(_Component){_inherits(DiscountForm,_Component);function DiscountForm(){_classCallCheck(this,DiscountForm);var _this=_possibleConstructorReturn(this,(DiscountForm.__proto__||Object.getPrototypeOf(DiscountForm)).apply(this,arguments));_initialiseProps.call(_this);var discount=_this.props.discount;return _this;}_createClass(DiscountForm,[{key:'listenToActions',// listenToStores() {
//   this.listenToStore(DiscountStore, 'discount');
// }
value:function listenToActions(){var _this2=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].removeComplete,function(discount){__WEBPACK_IMPORTED_MODULE_10_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('discount.removed'));_this2.refs.confirmDialog.dismiss();_this2.props.onClose();});this.listenToAction(__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].removeError,function(errorMessage){_this2.onError(errorMessage);_this2.refs.confirmDialog.dismiss();});}},{key:'closeDetail',value:function closeDetail(){if(this.props.onClose){this.props.onClose();}}},{key:'copyToClipboard',value:function copyToClipboard(e){var copyEvent=new ClipboardEvent('copy');copyEvent.clipboardData.setData('text/plain',__WEBPACK_IMPORTED_MODULE_9_Config__["a" /* default */].discountHost+'/'+this.state.discount.discount.pseudoId);copyEvent.preventDefault();document.dispatchEvent(copyEvent);__WEBPACK_IMPORTED_MODULE_10_services_Message__["a" /* default */].info(this.context.getIntlMessage('Copied'));}},{key:'confirmDelete',value:function confirmDelete(discount){__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].remove(discount);this.refs.confirmDialog.dismiss();this.closeDetail();}},{key:'deleteDiscount',value:function deleteDiscount(){this.refs.confirmDialog.show();}},{key:'addCourses',value:function addCourses(){__WEBPACK_IMPORTED_MODULE_15_actions_Course__["a" /* default */].filter();this.refs.addCoursesDialog.show();}},{key:'selectCourse',value:function selectCourse(selectedObjects){this.props.discount.objects=Object.keys(selectedObjects).map(function(objectId){return{id:objectId,name:selectedObjects[objectId]};});this.setState({discount:this.props.discount});}},{key:'closeCourseSelection',value:function closeCourseSelection(){var objects=Object.keys(this.refs.courseSelector.getSelected()).map(function(id){return{type:1,id:parseInt(id,10)};});var packages=Object.keys(this.refs.bundelSelector.getSelected()).map(function(id){return{type:2,id:parseInt(id,10)};});packages.forEach(function(item){objects.push(item);});// let objects = this.props.discount.objects.map(object => {
//   return parseInt(object.id, 10);
// });
__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].update(parseInt(this.props.discount.id,10),{objects:objects});this.refs.addCoursesDialog.dismiss();}},{key:'setValue',value:function setValue(ev){var discount=parseFloat(this.refs.discount.getValue());if(!discount||typeof discount!=='number'){__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].update(this.props.discount.id,{discount:1});}else{__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].update(this.props.discount.id,{discount:parseFloat(ev.target.discount)||0});}}},{key:'setMaxCount',value:function setMaxCount(ev){var maxCount=parseFloat(ev.target.value)||0;__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].update(this.props.discount.id,{maxCount:maxCount});}},{key:'render',value:function render(){var discount=this.props.discount;var discountedPackages=discount.objects.filter(function(item){return parseInt(item.type,10)===2;});var discountedCourses=discount.objects.filter(function(item){return parseInt(item.type,10)===1;});var start=void 0,end=void 0;if(discount.startDate==='0000-00-00 00:00:00'){start=new Date();}else{start=new Date(discount.startDate);}if(discount.endDate==='0000-00-00 00:00:00'){end=new Date()+30;}else{end=new Date(discount.endDate);}var objects=discount.objects||[];var courseActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('OK'),secondary:true,className:'full',onTouchTap:this.closeCourseSelection.bind(this)})];var confirmActions=[{text:'Cancel'},{text:'Submit',onTouchTap:this.confirmDelete.bind(this,discount),ref:'submit'}];if(this.state.editing){var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ToolbarTitle"],{text:this.context.getIntlMessage('discount.discount')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ToolbarGroup"],{float:'right',key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentSave,null),onTouchTap:this.autoSave.bind(this),tooltip:this.context.getIntlMessage('Save')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentClear,null),onTouchTap:this.closeEdit.bind(this),tooltip:this.context.getIntlMessage('Cancel')})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_ScrollableContainer__["a" /* default */],{header:toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["b" /* GridContainer */],{fluid:true,style:{padding:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:6},this.context.getIntlMessage('discount.code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{ref:'code',defaultValue:discount.code,type:'text'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:6},this.context.getIntlMessage('discount.amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{ref:'discount',defaultValue:discount.discount,onChange:this.setValue.bind(this),type:'float'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:12,xSmallSize:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RadioButtonGroup"],{ref:'type',name:this.context.getIntlMessage('discount.type'),valueSelected:discount.type+'',style:{padding:'1.5em 0'},onChange:this.setDiscountType},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RadioButton"],{value:'2',label:this.context.getIntlMessage('discount.typeAbsolute')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RadioButton"],{value:'1',label:this.context.getIntlMessage('discount.typePercentage')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:6},this.context.getIntlMessage('discount.Start'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["DatePicker"],{ref:'startDate',onChange:this.setStartDate.bind(this),value:start,hintText:this.context.getIntlMessage('discount.Start')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:6},this.context.getIntlMessage('discount.End'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["DatePicker"],{ref:'endDate',onChange:this.setEndDate.bind(this),value:end,hintText:this.context.getIntlMessage('discount.End')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:6},this.context.getIntlMessage('discount.limitedUse'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{ref:'maxCount',defaultValue:discount.maxCount==null?'0':discount.maxCount,onChange:this.setMaxCount.bind(this),type:'float'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('discount.used'),count:discount.count||'0',maxCount:discount.maxCount||'0'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:12,xSmallSize:12},this.context.getIntlMessage('discount.active'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Toggle"],{ref:'active',toggled:discount.active,onToggle:this.onChangeActive,style:{marginTop:'10px'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{ref:'addCoursesDialog'// title={<h3 className='mui-dialog-title'>{this.context.getIntlMessage('Choose Courses')}</h3>}
,title:this.context.getIntlMessage('course.choose'),actions:courseActions,autoDetectWindowHeight:true,autoScrollBodyContent:true,dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_CourseSelector__["a" /* default */],{ref:'courseSelector',selected:discount.objects})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{ref:'confirmDialog',title:this.context.getIntlMessage('discount.remove'),actions:confirmActions,actionFocus:'submit',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('discount.removeDiscount'),discount:discount.code}))));}else{var _toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ToolbarTitle"],{text:this.context.getIntlMessage('Discount')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ToolbarGroup"],{float:'right',key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentCreate,null),onTouchTap:this.openEdit.bind(this),tooltip:this.context.getIntlMessage('Create')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentAdd,null),onTouchTap:this.addCourses.bind(this),tooltip:this.context.getIntlMessage('Add')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionDelete,null),onTouchTap:this.deleteDiscount.bind(this),tooltip:this.context.getIntlMessage('Delete')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentClear,null),onTouchTap:this.closeDetail.bind(this),tooltip:this.context.getIntlMessage('Clear')})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_ScrollableContainer__["a" /* default */],{header:_toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["b" /* GridContainer */],{fluid:true,style:{padding:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:6},this.context.getIntlMessage('discount.code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["List"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ListItem"],{primaryText:discount.code,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:6},this.context.getIntlMessage('discount.amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["List"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ListItem"],{primaryText:discount.discount,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:12,xSmallSize:12},this.context.getIntlMessage('discount.type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["List"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ListItem"],{disabled:true,primaryText:discount.type+''=='2'?this.context.getIntlMessage('discount.typeAbsolute'):this.context.getIntlMessage('discount.typePercentage')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:6},this.context.getIntlMessage('discount.Start'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["DatePicker"],{style:{pointerEvents:'none'},ref:'startDate',onChange:this.setStartDate.bind(this),value:start,hintText:this.context.getIntlMessage('discount.Start')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:6},this.context.getIntlMessage('discount.End'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["DatePicker"],{style:{pointerEvents:'none'},ref:'endDate',onChange:this.setEndDate.bind(this),value:end,hintText:this.context.getIntlMessage('discount.End')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:6},this.context.getIntlMessage('discount.limitedUse'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["List"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ListItem"],{primaryText:discount.maxCount==null?'0':discount.maxCount,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('discount.used'),count:discount.count||'0',maxCount:discount.maxCount||'∞'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Grid__["a" /* GridCell */],{size:12,xSmallSize:12},this.context.getIntlMessage('discount.active'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Toggle"],{ref:'active',toggled:discount.active,style:{marginTop:'10px'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Widgets_SimpleOverview__["a" /* default */],{items:discountedCourses,readable:'name',title:this.context.getIntlMessage('discount.affectedObjects'),onTouchTapRightIcon:this.deleteObject}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Widgets_SimpleOverview__["a" /* default */],{items:discountedPackages,readable:'name',title:this.context.getIntlMessage('discount.affectedPackages'),onTouchTapRightIcon:this.deleteObject}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{ref:'addCoursesDialog'// title={<h3 className='mui-dialog-title'>{this.context.getIntlMessage('Choose Courses')}</h3>}
,title:this.context.getIntlMessage('course.choose'),actions:courseActions,autoDetectWindowHeight:true,autoScrollBodyContent:true,dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_CourseSelector__["a" /* default */],{ref:'courseSelector',selected:discount.objects.filter(function(item){return parseInt(item.type,10)===1;})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{marginTop:'10px',fontSize:'24px',lineHight:'32px'}},'V\xE4lj paket'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_BundleSelector__["a" /* default */],{ref:'bundelSelector',selected:discount.objects.filter(function(item){return parseInt(item.type,10)===2;})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{ref:'confirmDialog',title:this.context.getIntlMessage('discount.remove'),actions:confirmActions,actionFocus:'submit',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('discount.removeDiscount'),discount:discount.code}))));}}}]);return DiscountForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DiscountForm.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};var _initialiseProps=function _initialiseProps(){var _this3=this;this.state={editing:false};this.setStartDate=function(foo,startDate){__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].update(_this3.props.discount.id,{startDate:startDate});};this.setEndDate=function(foo,endDate){__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].update(_this3.props.discount.id,{endDate:endDate});};this.setDiscountType=function(event,value){var type=parseInt(value,10)||0;__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].update(_this3.props.discount.id,{type:type});};this.onChangeActive=function(event,active){__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].update(_this3.props.discount.id,{active:active});};this.autoSave=function(){if(_this3._timer){clearTimeout(_this3._timer);_this3._timer=null;}var code=_this3.refs.code.getValue();var active=_this3.refs.active.isToggled();var discount=parseFloat(_this3.refs.discount.getValue());var maxCount=parseInt(_this3.refs.maxCount.getValue(),10);var type=parseInt(_this3.refs.type.getSelectedValue(),10);if(code.length<=30){_this3._timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].update(_this3.props.discount.id,{code:code,discount:discount,active:active,maxCount:maxCount,type:type,startDate:_this3.refs.startDate.getDate(),endDate:active?_this3.refs.endDate.getDate():null});},1000);_this3.closeEdit();}else{__WEBPACK_IMPORTED_MODULE_10_services_Message__["a" /* default */].info(_this3.context.getIntlMessage('discount.codeRestriction'));}};this.openEdit=function(){_this3.setState({editing:true});};this.closeEdit=function(){_this3.setState({editing:false});};this.deleteObject=function(object){var objects=_this3.props.discount.objects.filter(function(obj){return!(object.type===obj.type&&object.id===obj.id);});__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].update(parseInt(_this3.props.discount.id,10),{objects:objects});};};/* harmony default export */ __webpack_exports__["a"] = (DiscountForm);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lib_CSSPropertyOperations__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lib_CSSPropertyOperations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_lib_CSSPropertyOperations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isDescendant=function isDescendant(parent,child){var node=child.parentNode;while(node!==null){if(node===parent){return true;}node=node.parentNode;}return false;};var Portal=function(_Component){_inherits(Portal,_Component);function Portal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Portal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Portal.__proto__||Object.getPrototypeOf(Portal)).call.apply(_ref,[this].concat(args))),_this),_this.node=null,_this.handleClickAway=function(event){var onClickAway=_this.props.onClickAway;if(!isDescendant(_this.node,event.target)){onClickAway();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Portal,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,onMount=_props.onMount,onClickAway=_props.onClickAway;this.node=document.createElement('div');__WEBPACK_IMPORTED_MODULE_1_react_lib_CSSPropertyOperations___default.a.setValueForStyles(this.node,this.props.style);document.body.appendChild(this.node);this.renderPortal(this.props);onMount&&onMount(this.node);if(onClickAway){document.body.addEventListener('mousedown',this.handleClickAway);document.body.addEventListener('touchstart',this.handleClickAway);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.renderPortal(nextProps);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!__WEBPACK_IMPORTED_MODULE_2_shallowequal___default()(this.props,nextProps);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var onClickAway=this.props.onClickAway;this.closePortal();if(onClickAway){document.body.removeEventListener('mousedown',this.handleClickAway);document.body.removeEventListener('touchstart',this.handleClickAway);}}},{key:'closePortal',value:function closePortal(){if(this.node){Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["unmountComponentAtNode"])(this.node);document.body.removeChild(this.node);}this.node=null;}},{key:'renderPortal',value:function renderPortal(props){var children=props.children,style=props.style,className=props.className,other=_objectWithoutProperties(props,['children','style','className']);__WEBPACK_IMPORTED_MODULE_1_react_lib_CSSPropertyOperations___default.a.setValueForStyles(this.node,style);if(className){this.node.className=className;}if(children&&children.length>0){__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.unstable_renderSubtreeIntoContainer(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',other,children),this.node);}else if(children){__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.unstable_renderSubtreeIntoContainer(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children),this.node);}}},{key:'render',value:function render(){return null;}}]);return Portal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Portal.displayName='Portal';Portal.propTypes={style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,onClickAway:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onMount:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_Transaction__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['cancel'],['cancel']),_templateObject2=_taggedTemplateLiteral(['refund'],['refund']),_templateObject3=_taggedTemplateLiteral(['refundConfirm'],['refundConfirm']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentClear=__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["ContentClear"],ActionLabel=__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["ActionLabel"],NavigationRefresh=__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["NavigationRefresh"],ContentRemoveCircle=__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["ContentRemoveCircle"],ActionDescription=__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["ActionDescription"],EditorAttachMoney=__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["EditorAttachMoney"],DeviceAccessTime=__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["DeviceAccessTime"],ActionFace=__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["ActionFace"];var Spacing=__WEBPACK_IMPORTED_MODULE_3_material_ui__["Styles"].Spacing;var TransactionForm=function(_mixin){_inherits(TransactionForm,_mixin);function TransactionForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TransactionForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TransactionForm.__proto__||Object.getPrototypeOf(TransactionForm)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpen=function(){_this.refs.confirmRefundDialog.show();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TransactionForm,[{key:'listenToActions',value:function listenToActions(){var _this2=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_2_actions_Transaction__["a" /* default */].resendComplete,function(transaction){__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('transaction.receiptResent'));});this.listenToAction(__WEBPACK_IMPORTED_MODULE_2_actions_Transaction__["a" /* default */].exportComplete,function(transaction){__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('transaction.exportDone'));});this.listenToAction(__WEBPACK_IMPORTED_MODULE_2_actions_Transaction__["a" /* default */].exportStatisticComplete,function(transaction){__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('transaction.exportStatisticDone'));});this.listenToAction(__WEBPACK_IMPORTED_MODULE_2_actions_Transaction__["a" /* default */].refundComplete,function(transaction){__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('transaction.refundDone'));});this.listenToAction(__WEBPACK_IMPORTED_MODULE_2_actions_Transaction__["a" /* default */].refundError,function(errorMessage){_this2.onError(errorMessage);_this2.refs.confirmDialog.dismiss();});}},{key:'onError',value:function onError(errorMessage){__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(errorMessage);}},{key:'closeDetail',value:function closeDetail(){if(this.props.onClose){this.props.onClose();}}},{key:'resend',value:function resend(){__WEBPACK_IMPORTED_MODULE_2_actions_Transaction__["a" /* default */].resend(this.props.transaction.id);}},{key:'refund',value:function refund(){__WEBPACK_IMPORTED_MODULE_2_actions_Transaction__["a" /* default */].refund(this.props.transaction.id);}},{key:'export',value:function _export(){__WEBPACK_IMPORTED_MODULE_2_actions_Transaction__["a" /* default */].export(this.props.transaction.id);}},{key:'statusText',value:function statusText(status){switch(status){case 4:return'Waiting (for approval from Klarna)';case 8:case 16:return'OK';case 32:return'Error';case 128:return this.context.getIntlMessage('transaction.refunded');default:return'Unkonwn';}}},{key:'render',value:function render(){var transaction=this.props.transaction;var confirmActions=[{text:'Cancel'}];var actions=[{text:Object(__WEBPACK_IMPORTED_MODULE_9_oxygen_i18n__["translate"])(_templateObject)},{text:Object(__WEBPACK_IMPORTED_MODULE_9_oxygen_i18n__["translate"])(_templateObject2),onTouchTap:this.refund.bind(this)}];var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["ToolbarTitle"],{text:this.context.getIntlMessage('Transaction')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["ToolbarGroup"],{float:'right',key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('transaction.resendReceipt'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationRefresh,null),onTouchTap:this.resend.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('transaction.refund'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentRemoveCircle,null),onTouchTap:this.handleOpen}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('Close'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentClear,null),onTouchTap:this.closeDetail.bind(this)})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_ScrollableContainer__["a" /* default */],{header:toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["List"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EditorAttachMoney,null),primaryText:transaction.amount+' '+transaction.currency}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeviceAccessTime,null),primaryText:transaction.date}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionFace,null),primaryText:transaction.buyer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionLabel,null),primaryText:this.statusText(transaction.status)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionDescription,null),primaryText:transaction.cart[0]?transaction.cart[0].name:'—'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Dialog"],{ref:'confirmDialog',title:this.context.getIntlMessage('transaction.remove'),actions:confirmActions,actionFocus:'submit',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('transaction.removeTransaction'),transaction:'transaction.code'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Dialog"],{ref:'confirmRefundDialog',title:this.context.getIntlMessage('transaction.refund'),actions:actions},Object(__WEBPACK_IMPORTED_MODULE_9_oxygen_i18n__["translate"])(_templateObject3)));}}]);return TransactionForm;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_1_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));TransactionForm.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (TransactionForm);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Widgets_RadialSVGProgressBar__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TextField__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_Message__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_3_material_ui__["Styles"].Spacing;var pageSource={beginDrag:function beginDrag(props){return{index:props.index,sectionIndex:props.sectionIndex};}};var pageTarget={hover:function hover(props,monitor,component){var item=monitor.getItem();var dragIndex=item.index;var sectionDragIndex=item.sectionIndex;var hoverIndex=props.index;var sectionHoverIndex=props.sectionIndex;// Don't replace items with themselves
if(dragIndex===hoverIndex&&sectionDragIndex===sectionHoverIndex){return;}// Determine rectangle on screen
var hoverBoundingRect=Object(__WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"])(component).getBoundingClientRect();// Get vertical middle
var hoverMiddleY=(hoverBoundingRect.bottom-hoverBoundingRect.top)/2;// Determine mouse position
var clientOffset=monitor.getClientOffset();// Get pixels to the top
var hoverClientY=clientOffset.y-hoverBoundingRect.top;// Only perform the move when the mouse has crossed half of the items height
// When dragging downwards, only move when the cursor is below 50%
// When dragging upwards, only move when the cursor is above 50%
// Dragging downwards
if(dragIndex<hoverIndex&&sectionDragIndex===sectionHoverIndex&&hoverClientY<hoverMiddleY){return;}// Dragging upwards
if(dragIndex>hoverIndex&&sectionDragIndex===sectionHoverIndex&&hoverClientY>hoverMiddleY){return;}props.onMovePage(sectionDragIndex,dragIndex,sectionHoverIndex,hoverIndex);monitor.getItem().index=hoverIndex;monitor.getItem().sectionIndex=sectionHoverIndex;}};var Page=function(_Component){_inherits(Page,_Component);function Page(){_classCallCheck(this,Page);var _this=_possibleConstructorReturn(this,(Page.__proto__||Object.getPrototypeOf(Page)).apply(this,arguments));_this.state={name:null,mode:_this.props.mode||'detail',mouseOver:false,controlsExpanded:false};return _this;}_createClass(Page,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!this.props.currentPage&&nextProps.currentPage){this.props.scrollIntoView(Object(__WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"])(this));}}},{key:'movePage',value:function movePage(source,target,sourceSection,targetSection){if(this.props.onMovePage){this.props.onMovePage(source,target,sourceSection,targetSection);}}},{key:'deletePage',value:function deletePage(pageId,e){if(this.props.onDelete){this.props.onDelete(pageId);}e.preventDefault();}},{key:'edit',value:function edit(){this.setState({mode:'edit'});}},{key:'trySave',value:function trySave(){var name=this.refs.textfield.getValue();if(name.trim().length!=0){__WEBPACK_IMPORTED_MODULE_6_actions__["f" /* CourseActions */].updatePage({id:this.props.id,name:name});this.setState({name:name,mode:'detail'});}else{__WEBPACK_IMPORTED_MODULE_13_services_Message__["a" /* default */].info('Page name cannot be a space!!');}}},{key:'expandControls',value:function expandControls(){this.setState({controlsExpanded:true});}},{key:'collapseControls',value:function collapseControls(){this.setState({controlsExpanded:false});}},{key:'mouseOver',value:function mouseOver(){var _mouseOver=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var newState={mouseOver:_mouseOver};if(!_mouseOver){newState.controlsExpanded=false;}this.setState(newState);}},{key:'save',value:function save(){this.setState({mode:'detail'});}},{key:'getStyle',value:function getStyle(overrides,hoverOverride){var _props=this.props,progress=_props.progress,isDragging=_props.isDragging,theme=_props.theme;var style={opacity:isDragging?0:1};var hoverStyle={backgroundColor:'rgba(200, 200, 200, 0.1)',borderColor:__WEBPACK_IMPORTED_MODULE_7_stores__["z" /* ThemeStore */].getColor(theme,0.5)};return Object.assign({},__WEBPACK_IMPORTED_MODULE_12__styles__["a" /* default */].page,progress===1?__WEBPACK_IMPORTED_MODULE_12__styles__["a" /* default */].inactivePageHeader:__WEBPACK_IMPORTED_MODULE_12__styles__["a" /* default */].activePageHeader,this.props.style,this.props.currentPage?hoverOverride?hoverOverride:{borderColor:__WEBPACK_IMPORTED_MODULE_7_stores__["z" /* ThemeStore */].getColor(theme),color:__WEBPACK_IMPORTED_MODULE_7_stores__["z" /* ThemeStore */].getColor(theme)}:{},style,this.state.mouseOver?hoverOverride?hoverOverride:hoverStyle:{},overrides);}},{key:'getTaskStyle',value:function getTaskStyle(style){return Object.assign({},{height:2,lineHeight:'8px',marginLeft:26,marginRight:18,borderRadius:2,overflow:'hidden',backgroundColor:'rgba(255, 255, 255, 0.25)'},style);}},{key:'duplicate',value:function duplicate(){__WEBPACK_IMPORTED_MODULE_6_actions__["f" /* CourseActions */].duplicatePage(this.props.courseId,this.props.id);}},{key:'copy',value:function copy(){__WEBPACK_IMPORTED_MODULE_6_actions__["e" /* ClipboardActions */].copy({type:'page',id:this.props.id,data:this.props.data});}},{key:'addPage',value:function addPage(){__WEBPACK_IMPORTED_MODULE_6_actions__["f" /* CourseActions */].addPage(this.props.sectionId,this.props.id,this.context.getIntlMessage('page.new'));}},{key:'render',value:function render(){var name=void 0,controls=void 0,progress=void 0;var _props2=this.props,tasks=_props2.tasks,connectDragSource=_props2.connectDragSource,connectDropTarget=_props2.connectDropTarget,isQuiz=_props2.isQuiz;var answered=void 0;var iconButtonStyle={backgroundColor:__WEBPACK_IMPORTED_MODULE_8_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,height:38,width:38,padding:(38-24)/2};progress=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Widgets_RadialSVGProgressBar__["a" /* default */],{style:{float:'right'},size:48,amount:this.props.progress*100});if(this.state.mode==='edit'){var extraStyles=isQuiz&&{color:'white'};var extraUnderlineStyls=isQuiz&&{borderColor:'white'};name=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TextField__["a" /* default */],{inputStyle:Object.assign({},__WEBPACK_IMPORTED_MODULE_12__styles__["a" /* default */].textField,extraStyles),underlineFocusStyle:extraUnderlineStyls,onEnterKeyDown:this.trySave.bind(this),fullWidth:true,ref:'textfield',defaultValue:this.state.name||this.props.name});controls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'controls',style:{position:'absolute',transition:'all 0.3s ease',whiteSpace:'nowrap'},key:'controls-done'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{touch:true,tooltip:this.context.getIntlMessage('Save'),tooltipPosition:'bottom-left',style:iconButtonStyle,onTouchTap:this.trySave.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["ActionVisibility"],null)));}else{var moreControls=void 0;if(tasks&&tasks.count>0){var answeredTasks=[];for(var i=0;i<tasks.count;i++){if(i<tasks.answered){answeredTasks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_12__styles__["a" /* default */].answeredTask,key:i}));}else{answeredTasks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_12__styles__["a" /* default */].unansweredTask,key:i}));}}answered=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getTaskStyle(isQuiz?{backgroundColor:'transparent'}:null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{backgroundColor:'rgba(255, 255, 255, 0.5)',height:2,width:tasks.answered*100/tasks.count+'%'}}));}name=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:this.props.onTouchTap},this.state.name||this.props.name);if(this.state.controlsExpanded){moreControls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{touch:true,tooltip:this.context.getIntlMessage('Duplicate'),tooltipPosition:'bottom-left',style:iconButtonStyle,onTouchTap:this.duplicate.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["ImageFilterNone"],{hoverColor:'#777'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{touch:true,tooltip:this.context.getIntlMessage('Edit'),tooltipPosition:'bottom-left',style:iconButtonStyle,onTouchTap:this.edit.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["ContentCreate"],{hoverColor:'#777'})),this.props.pages.length>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{touch:true,tooltip:this.context.getIntlMessage('Remove'),tooltipPosition:'bottom-left',style:iconButtonStyle,onTouchTap:this.deletePage.bind(this,this.props.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["ActionDelete"],{hoverColor:'#777'})));}else{moreControls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{touch:true,tooltip:this.context.getIntlMessage('More'),tooltipPosition:'bottom-left',style:iconButtonStyle,onTouchTap:this.expandControls.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["NavigationMoreHoriz"],{hoverColor:'#777'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{touch:true,tooltip:this.context.getIntlMessage('page.new'),tooltipPosition:'bottom-left',style:iconButtonStyle,onTouchTap:this.addPage.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["ContentAdd"],{hoverColor:'#777'})));}if(this.state.mouseOver&&this.props.editor){controls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Paper"],{className:'controls',style:__WEBPACK_IMPORTED_MODULE_12__styles__["a" /* default */].controls,key:'controls'},moreControls);}}return connectDragSource(connectDropTarget(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getStyle(isQuiz&&{color:'white'},isQuiz&&{borderColor:'rgba(255, 255, 255, 0.5)'}),onMouseEnter:this.mouseOver.bind(this,true),onMouseLeave:this.mouseOver.bind(this,false)},name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group___default.a,{transitionName:'controls',component:'div',style:{position:'absolute',top:0,right:0,bottom:0},transitionEnterTimeout:300,transitionLeaveTimeout:300},controls)),answered)));}}]);return Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Page.displayName='Page';Page.propTypes={onTouchTap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,onMovePage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onDelete:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,name:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string.isRequired,progress:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,sectionId:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,reader:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,editor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};Page.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};Page.defaultProps={progress:0};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_dnd__["DropTarget"])(__WEBPACK_IMPORTED_MODULE_4_Constants__["ItemTypes"].TOC_PAGE,pageTarget,function(connect){return{connectDropTarget:connect.dropTarget()};})(Object(__WEBPACK_IMPORTED_MODULE_2_react_dnd__["DragSource"])(__WEBPACK_IMPORTED_MODULE_4_Constants__["ItemTypes"].TOC_PAGE,pageSource,function(connect,monitor){return{connectDragSource:connect.dragSource(),isDragging:monitor.isDragging()};})(Page)));

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Widgets__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Icons__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Page__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TextField__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_Message__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_4_material_ui__["Styles"].Spacing;var sectionSource={beginDrag:function beginDrag(props){return{index:props.index};}};var sectionTarget={hover:function hover(props,monitor,component){var dragIndex=monitor.getItem().index;var hoverIndex=props.index;// Don't replace items with themselves
if(dragIndex===hoverIndex){return;}// Determine rectangle on screen
var hoverBoundingRect=Object(__WEBPACK_IMPORTED_MODULE_14_react_dom__["findDOMNode"])(component).getBoundingClientRect();// Get vertical middle
var hoverMiddleY=(hoverBoundingRect.bottom-hoverBoundingRect.top)/2;// Determine mouse position
var clientOffset=monitor.getClientOffset();// Get pixels to the top
var hoverClientY=clientOffset.y-hoverBoundingRect.top;// Only perform the move when the mouse has crossed half of the items height
// When dragging downwards, only move when the cursor is below 50%
// When dragging upwards, only move when the cursor is above 50%
// Dragging downwards
if(dragIndex<hoverIndex&&hoverClientY<hoverMiddleY){return;}// Dragging upwards
if(dragIndex>hoverIndex&&hoverClientY>hoverMiddleY){return;}props.onMoveSection(dragIndex,hoverIndex);monitor.getItem().index=hoverIndex;}};var Section=function(_mixin){_inherits(Section,_mixin);function Section(props){_classCallCheck(this,Section);var _this=_possibleConstructorReturn(this,(Section.__proto__||Object.getPrototypeOf(Section)).call(this,props));_this.movePage=function(sectionIndex,pageIndex,toSectionIndex,toPageIndex){__WEBPACK_IMPORTED_MODULE_12_actions__["f" /* CourseActions */].movePage(_this.props.courseId,sectionIndex,pageIndex,toSectionIndex,toPageIndex);};_this.state={name:null,mode:_this.props.mode||'detail',mouseOver:false,controlsExpanded:false};return _this;}_createClass(Section,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_15_stores__["e" /* ClipboardStore */],'clipboard');}},{key:'gotoPage',value:function gotoPage(params){var ownerSlug=params.ownerSlug,courseSlug=params.courseSlug,sectionSlug=params.sectionSlug,pageSlug=params.pageSlug,pageId=params.pageId;__WEBPACK_IMPORTED_MODULE_13_helpers__["a" /* history */].push('/course/'+ownerSlug+'/'+courseSlug+'/'+sectionSlug+'/'+pageSlug+'/'+pageId);}// moveSection(source, target) {
//   if (this.props.onMoveSection) {
//     this.props.onMoveSection(source, target);
//   }
// }
},{key:'scrollIntoView',value:function scrollIntoView(node){if(this.props.scrollIntoView){this.props.scrollIntoView(node);}}},{key:'addPage',value:function addPage(sectionId){__WEBPACK_IMPORTED_MODULE_12_actions__["f" /* CourseActions */].addPage(sectionId,this.context.getIntlMessage('page.new'));}},{key:'deleteSection',value:function deleteSection(sectionId){if(this.props.onDeleteSection){this.props.onDeleteSection(sectionId);}}},{key:'deletePage',value:function deletePage(pageId){if(this.props.onDeletePage){this.props.onDeletePage(pageId);}}},{key:'edit',value:function edit(){this.setState({mode:'edit'});}},{key:'trySave',value:function trySave(){var name=this.refs.textfield.getValue();if(name.trim().length!==0){__WEBPACK_IMPORTED_MODULE_12_actions__["f" /* CourseActions */].updateSection({id:this.props.data.id,name:name});this.setState({name:name,mode:'detail'});}else{__WEBPACK_IMPORTED_MODULE_17_services_Message__["a" /* default */].info('Section name cannot be a space!!');}}},{key:'save',value:function save(){this.setState({mode:'detail'});}},{key:'getStyle',value:function getStyle(isActive){var opacity=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0.1;var _props=this.props,isDragging=_props.isDragging,theme=_props.theme;return Object.assign({},__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* default */].section,isActive?{backgroundColor:__WEBPACK_IMPORTED_MODULE_15_stores__["z" /* ThemeStore */].getColor(theme,opacity)}:null,isActive?__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* default */].activeSectionHeader:__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* default */].inactiveSectionHeader,this.props.style,isDragging?{opacity:0.5}:{opacity:1});}},{key:'getHeaderStyle',value:function getHeaderStyle(){return Object.assign({},__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* default */].sectionHeader,this.state.mouseOver?{backgroundColor:'rgba(255, 255, 255, 0.1)',borderColor:'rgba(255, 255, 255, 0.5)'}:null);}},{key:'mouseOver',value:function mouseOver(){var _mouseOver=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var newState={mouseOver:_mouseOver};if(!_mouseOver){newState.controlsExpanded=false;}this.setState(newState);}},{key:'expandControls',value:function expandControls(){this.setState({controlsExpanded:true});}},{key:'collapseControls',value:function collapseControls(){this.setState({controlsExpanded:false});}},{key:'duplicate',value:function duplicate(){__WEBPACK_IMPORTED_MODULE_12_actions__["f" /* CourseActions */].duplicateSection(this.props.courseId,this.props.data.id);}},{key:'copy',value:function copy(){__WEBPACK_IMPORTED_MODULE_12_actions__["e" /* ClipboardActions */].copy({type:'section',id:this.props.id,data:this.props.data});}},{key:'paste',value:function paste(){var page=__WEBPACK_IMPORTED_MODULE_15_stores__["e" /* ClipboardStore */].paste().data;__WEBPACK_IMPORTED_MODULE_12_actions__["f" /* CourseActions */].pastePage(this.props.data.id,page);}},{key:'addSection',value:function addSection(type){if(type==='quiz'){__WEBPACK_IMPORTED_MODULE_12_actions__["f" /* CourseActions */].addPage(this.props.data.id,'',this.context.getIntlMessage('page.new'));}else{__WEBPACK_IMPORTED_MODULE_12_actions__["f" /* CourseActions */].addSection(this.props.courseId,this.props.data.id,this.context.getIntlMessage('section.new'),this.context.getIntlMessage('page.new'));}}},{key:'render',value:function render(){var _this2=this;var pages=null,controls=void 0,name=void 0,chapterProgress=this.props.data.progress,currentPage=this.props.currentPage,hasCurrentPage=false,progress=void 0;var _props2=this.props,data=_props2.data,settings=_props2.settings,isDragging=_props2.isDragging,connectDragSource=_props2.connectDragSource,connectDropTarget=_props2.connectDropTarget,theme=_props2.theme;var iconButtonStyle={backgroundColor:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,height:38,width:38,padding:(38-24)/2};pages=this.props.data.pages.map(function(page,index){var params=void 0;params={ownerSlug:_this2.props.ownerSlug,courseSlug:_this2.props.courseSlug,sectionSlug:_this2.props.data.slug,pageSlug:page.slug,pageId:page.id};hasCurrentPage=hasCurrentPage||page.id===currentPage;if(!_this2.props.editor&&(data.isLocked||page.isLocked)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Page__["a" /* default */],{theme:theme,pages:_this2.props.data.pages,onMovePage:_this2.movePage,editor:_this2.props.editor,reader:_this2.props.reader,index:index,sectionIndex:_this2.props.index,courseId:_this2.props.courseId,scrollIntoView:_this2.scrollIntoView.bind(_this2),currentPage:page.id===currentPage,style:Object.assign({},_this2.props.style,{cursor:'default',color:'#abaaaa'}),key:page.id,data:page,onDelete:_this2.deletePage.bind(_this2),sectionId:_this2.props.data.id,id:page.id,progress:page.progress,tasks:page.tasks,mode:page.mode,name:page.name});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Page__["a" /* default */],{theme:theme,pages:_this2.props.data.pages,onMovePage:_this2.movePage,editor:_this2.props.editor,reader:_this2.props.reader,index:index,sectionIndex:_this2.props.index,courseId:_this2.props.courseId,scrollIntoView:_this2.scrollIntoView.bind(_this2),currentPage:page.id===currentPage,style:_this2.props.style,key:page.id,data:page,onDelete:_this2.deletePage.bind(_this2),sectionId:_this2.props.data.id,id:page.id,isQuiz:data.type==='quiz',progress:page.progress,tasks:page.tasks,mode:page.mode,onTouchTap:_this2.gotoPage.bind(_this2,params),name:page.name});});if(data.type==='quiz'){progress=null;}else if(data.isLocked&&!this.props.editor){progress=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["ActionLock"],{color:'rgba(128, 128, 128, 0.5)',style:{position:'absolute',right:Spacing.desktopGutterMini*2,top:0}});}else if(chapterProgress===1){progress=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Icons__["ChapterDone"],{color:__WEBPACK_IMPORTED_MODULE_15_stores__["z" /* ThemeStore */].getColor(this.props.theme),style:{position:'absolute',right:Spacing.desktopGutterMini*2,top:0}});}else{progress=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Widgets__["d" /* RadialSVGProgressBar */],{strokeColor:__WEBPACK_IMPORTED_MODULE_15_stores__["z" /* ThemeStore */].getColor(this.props.theme),label:false,style:{position:'absolute',right:Spacing.desktopGutterMini*2,top:0},size:26,amount:chapterProgress*100});}if(this.state.mode==='edit'){var extraStyls=data.type==='quiz'&&{color:'white'};var extraUnderlineStyls=data.type==='quiz'&&{borderColor:'white'};name=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TextField__["a" /* default */],{inputStyle:Object.assign({},__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* default */].textField,extraStyls),underlineFocusStyle:extraUnderlineStyls,onEnterKeyDown:this.trySave.bind(this),fullWidth:true,ref:'textfield',defaultValue:this.state.name||this.props.data.name});controls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'controls',style:{position:'absolute',transition:'all 0.3s ease',whiteSpace:'nowrap'},key:'controls-done'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["IconButton"],{touch:true,tooltip:this.context.getIntlMessage('Save'),tooltipPosition:'bottom-left',style:iconButtonStyle,onTouchTap:this.trySave.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["ActionVisibility"],null)));}else{name=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:this.props.onTouchTap},this.state.name||this.props.data.name,progress);if(this.state.mouseOver&&this.props.editor){var paste=void 0;var moreControls=void 0;var clipboard=this.state.clipboard;if(false){paste=React.createElement(IconButton,{style:iconButtonStyle,onTouchTap:this.paste.bind(this)},React.createElement(MaterialIcons.ContentContentPaste,{hoverColor:'#777'}));}if(this.state.controlsExpanded){moreControls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,paste,data.type!=='quiz'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["IconButton"],{style:iconButtonStyle,onTouchTap:this.duplicate.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["ImageFilterNone"],{hoverColor:'#777'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["IconButton"],{style:iconButtonStyle,onTouchTap:this.edit.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["ContentCreate"],{hoverColor:'#777'})),data.type!=='quiz'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["IconButton"],{style:iconButtonStyle,onTouchTap:this.deleteSection.bind(this,this.props.data.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["ActionDelete"],{hoverColor:'#777'})));}else{moreControls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["IconButton"],{style:iconButtonStyle,onTouchTap:this.expandControls.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["NavigationMoreHoriz"],{hoverColor:'#777'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["IconButton"],{style:iconButtonStyle,onTouchTap:this.addSection.bind(this,data.type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["ContentAdd"],{hoverColor:'#777'})));}controls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Paper"],{className:'controls',style:{position:'absolute',transition:'all 0.3s ease',whiteSpace:'nowrap'},key:'controls'},moreControls);}}var addPageButton=void 0;if(this.props.editor){addPageButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* default */].addPageButtonContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["RaisedButton"],{backgroundColor:'transparent',labelColor:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,fullWidth:true,style:__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* default */].addPageButton,onTouchTap:this.addPage.bind(this,this.props.data.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* default */].addPageLabel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["ContentAdd"],{style:{verticalAlign:'middle'},color:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite}),this.context.getIntlMessage('page.new'))));}return connectDragSource(connectDropTarget(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:data.type!=='quiz'?this.getStyle(hasCurrentPage):this.getStyle(true,1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:data.type!=='quiz'?this.getHeaderStyle():Object.assign({},this.getHeaderStyle(),{color:'white'}),onMouseEnter:this.mouseOver.bind(this,true),onMouseLeave:this.mouseOver.bind(this,false)},name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_addons_css_transition_group___default.a,{transitionName:'controls',component:'div',style:{position:'absolute',right:0,top:0,bottom:0},transitionEnterTimeout:300,transitionLeaveTimeout:300},controls)),pages)));}}]);return Section;}(Object(__WEBPACK_IMPORTED_MODULE_16_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_16_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));Section.displayName='Section';Section.propTypes={collapsed:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onDeleteSection:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onDeletePage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onMoveSection:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onMovePageToSection:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,data:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,locked:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};Section.contextTypes={router:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_dnd__["DropTarget"])(__WEBPACK_IMPORTED_MODULE_3_Constants__["ItemTypes"].TOC_SECTION,sectionTarget,function(connect){return{connectDropTarget:connect.dropTarget()};})(Object(__WEBPACK_IMPORTED_MODULE_2_react_dnd__["DragSource"])(__WEBPACK_IMPORTED_MODULE_3_Constants__["ItemTypes"].TOC_SECTION,sectionSource,function(connect,monitor){return{connectDragSource:connect.dragSource(),// connectDragPreview: connect.dragPreview(),
isDragging:monitor.isDragging()};})(Section)));

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSafari = exports.isFirefox = undefined;

var _memoize = __webpack_require__(2337);

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
  return (/firefox/i.test(navigator.userAgent)
  );
});
var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
  return Boolean(window.safari);
});

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Css = __webpack_require__(6);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _ToolbarButton = __webpack_require__(653);

var _ToolbarButton2 = _interopRequireDefault(_ToolbarButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  root: 'cio_hm',
  transparent: 'cio_hn',
  right: 'cio_ho',
  center: 'cio_hx',
  dense: 'cio_hA',
  fullWidth: 'cio_hp'
};

var ToolbarGroup = function (_Component) {
  _inherits(ToolbarGroup, _Component);

  function ToolbarGroup() {
    _classCallCheck(this, ToolbarGroup);

    return _possibleConstructorReturn(this, (ToolbarGroup.__proto__ || Object.getPrototypeOf(ToolbarGroup)).apply(this, arguments));
  }

  _createClass(ToolbarGroup, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          right = _props.right,
          center = _props.center,
          dense = _props.dense,
          fullWidth = _props.fullWidth,
          transparent = _props.transparent,
          className = _props.className,
          other = _objectWithoutProperties(_props, ['children', 'right', 'center', 'dense', 'fullWidth', 'transparent', 'className']);

      var classes = (0, _classnames2.default)(css.root, className, (_classNames = {}, _defineProperty(_classNames, css.right, right), _defineProperty(_classNames, css.transparent, transparent), _defineProperty(_classNames, css.fullWidth, fullWidth), _defineProperty(_classNames, css.center, center), _defineProperty(_classNames, css.dense, dense), _classNames));
      return _react2.default.createElement(
        'div',
        _extends({ className: classes }, other),
        _react2.default.Children.map(children, function (child) {
          if (child.type === _ToolbarButton2.default) {
            return _react2.default.cloneElement(child, {
              dense: dense
            });
          }
          return child;
        })
      );
    }
  }]);

  return ToolbarGroup;
}(_react.Component);

ToolbarGroup.propTypes = {
  children: _react.PropTypes.node,
  right: _react.PropTypes.bool,
  transparent: _react.PropTypes.bool,
  fullWidth: _react.PropTypes.bool,
  center: _react.PropTypes.bool,
  dense: _react.PropTypes.bool,
  className: _react.PropTypes.string
};
exports.default = ToolbarGroup;
module.exports = exports['default'];

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Css = __webpack_require__(46);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Tooltip = __webpack_require__(207);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  button: 'cio_hi',
  dense: 'cio_hj',
  disabled: 'cio_hk',
  active: 'cio_hl'
};

var ToolbarButton = function (_Component) {
  _inherits(ToolbarButton, _Component);

  function ToolbarButton() {
    var _ref,
        _arguments = arguments;

    var _temp, _this, _ret;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _classCallCheck(this, ToolbarButton);

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToolbarButton.__proto__ || Object.getPrototypeOf(ToolbarButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: false,
      active: false
    }, _this.getNode = function () {
      return _reactDom2.default.findDOMNode(_this);
    }, _this.handleMouseEnter = function () {
      _this.setState({ hover: true });
    }, _this.handleMouseLeave = function () {
      _this.setState({ hover: false });
    }, _this.handleFocus = function () {
      _this.setState({ active: true });
    }, _this.handleBlur = function () {
      var onBlur = _this.props.onBlur;

      _this.setState({ active: false });
      onBlur && onBlur();
    }, _this.handleTouchTap = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var _this$props = _this.props,
          onTouchTap = _this$props.onTouchTap,
          disabled = _this$props.disabled;

      if (!disabled && onTouchTap) {
        onTouchTap.apply(undefined, _arguments);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ToolbarButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._node = _reactDom2.default.findDOMNode(this);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({ hover: false, active: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          className = _props.className,
          dense = _props.dense,
          disabled = _props.disabled,
          tooltip = _props.tooltip,
          children = _props.children,
          other = _objectWithoutProperties(_props, ['className', 'dense', 'disabled', 'tooltip', 'children']);

      var _state = this.state,
          hover = _state.hover,
          active = _state.active;

      var classes = (0, _classnames2.default)(css.button, className, (_classNames = {}, _defineProperty(_classNames, css.disabled, disabled), _defineProperty(_classNames, css.active, active), _defineProperty(_classNames, css.dense, dense), _classNames));
      var handlers = disabled ? {} : {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onTouchTap: this.handleTouchTap
      };
      return _react2.default.createElement(
        'button',
        _extends({}, other, handlers, { className: classes }),
        children,
        hover && tooltip && _react2.default.createElement(
          _Tooltip2.default,
          { anchorTo: this.getNode },
          tooltip
        )
      );
    }
  }]);

  return ToolbarButton;
}(_react.Component);

ToolbarButton.propTypes = {
  tooltip: _react.PropTypes.node,
  children: _react.PropTypes.node,
  disabled: _react.PropTypes.bool,
  dense: _react.PropTypes.bool,
  onTouchTap: _react.PropTypes.func,
  onBlur: _react.PropTypes.func,
  className: _react.PropTypes.string,
  selected: _react.PropTypes.bool
};
exports.default = ToolbarButton;
module.exports = exports['default'];

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Css = __webpack_require__(46);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Tooltip = __webpack_require__(207);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  button: 'cio_fQ',
  dense: 'cio_fR',
  disabled: 'cio_fS',
  active: 'cio_fT',
  label: 'cio_fU'
};

var IconButton = function (_Component) {
  _inherits(IconButton, _Component);

  function IconButton() {
    var _ref,
        _arguments = arguments;

    var _temp, _this, _ret;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _classCallCheck(this, IconButton);

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconButton.__proto__ || Object.getPrototypeOf(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: false,
      active: false
    }, _this.getNode = function () {
      return _reactDom2.default.findDOMNode(_this);
    }, _this.handleMouseEnter = function () {
      var onMouseEnter = _this.props.onMouseEnter;

      _this.setState({ hover: true });
      onMouseEnter && onMouseEnter();
    }, _this.handleMouseLeave = function () {
      var onMouseLeave = _this.props.onMouseLeave;

      _this.setState({ hover: false });
      onMouseLeave && onMouseLeave();
    }, _this.handleFocus = function () {
      _this.setState({ active: true });
    }, _this.handleBlur = function () {
      var onBlur = _this.props.onBlur;

      _this.setState({ active: false });
      onBlur && onBlur();
    }, _this.handleTouchTap = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var _this$props = _this.props,
          onTouchTap = _this$props.onTouchTap,
          disabled = _this$props.disabled;

      if (!disabled && onTouchTap) {
        onTouchTap.apply(undefined, _arguments);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IconButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._node = _reactDom2.default.findDOMNode(this);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({ hover: false, active: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          className = _props.className,
          dense = _props.dense,
          disabled = _props.disabled,
          tooltip = _props.tooltip,
          children = _props.children,
          label = _props.label,
          color = _props.color,
          hoverColor = _props.hoverColor,
          other = _objectWithoutProperties(_props, ['className', 'dense', 'disabled', 'tooltip', 'children', 'label', 'color', 'hoverColor']);

      var _state = this.state,
          hover = _state.hover,
          active = _state.active;

      var classes = (0, _classnames2.default)(css.button, className, (_classNames = {}, _defineProperty(_classNames, css.disabled, disabled), _defineProperty(_classNames, css.active, active), _defineProperty(_classNames, css.dense, dense), _classNames));
      var handlers = disabled ? {} : {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onTouchTap: this.handleTouchTap
      };
      return _react2.default.createElement(
        'button',
        _extends({}, other, handlers, { className: classes }),
        _react2.default.cloneElement(_react2.default.Children.only(children), {
          color: hover || active ? hoverColor : color
        }),
        label && _react2.default.createElement(
          'span',
          { className: css.label },
          label
        ),
        hover && tooltip && _react2.default.createElement(
          _Tooltip2.default,
          { anchorTo: this.getNode },
          tooltip
        )
      );
    }
  }]);

  return IconButton;
}(_react.Component);

IconButton.propTypes = {
  tooltip: _react.PropTypes.node,
  children: _react.PropTypes.node,
  disabled: _react.PropTypes.bool,
  dense: _react.PropTypes.bool,
  onTouchTap: _react.PropTypes.func,
  onBlur: _react.PropTypes.func,
  className: _react.PropTypes.string,
  label: _react.PropTypes.string,
  selected: _react.PropTypes.bool,
  hoverColor: _react.PropTypes.string,
  onMouseEnter: _react.PropTypes.func,
  onMouseLeave: _react.PropTypes.func,
  color: _react.PropTypes.string
};
IconButton.defaultProps = {
  color: _Css.Cio.Text.secondary,
  hoverColor: _Css.Cio.Colors.creen
};
exports.default = IconButton;
module.exports = exports['default'];

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Css = __webpack_require__(46);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Tooltip = __webpack_require__(207);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  button: 'cio_fD',
  disabled: 'cio_fE',
  toggled: 'cio_fF',
  active: 'cio_fG'
};

var ActionButton = function (_Component) {
  _inherits(ActionButton, _Component);

  function ActionButton() {
    var _ref,
        _arguments = arguments;

    var _temp, _this, _ret;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _classCallCheck(this, ActionButton);

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActionButton.__proto__ || Object.getPrototypeOf(ActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: false,
      active: false
    }, _this.getNode = function () {
      return _reactDom2.default.findDOMNode(_this);
    }, _this.handleMouseEnter = function () {
      _this.setState({ hover: true });
    }, _this.handleMouseLeave = function () {
      _this.setState({ hover: false });
    }, _this.handleFocus = function () {
      _this.setState({ active: true });
    }, _this.handleBlur = function () {
      var onBlur = _this.props.onBlur;

      _this.setState({ active: false });
      onBlur && onBlur();
    }, _this.handleTouchTap = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var _this$props = _this.props,
          onTouchTap = _this$props.onTouchTap,
          disabled = _this$props.disabled;

      if (!disabled && onTouchTap) {
        onTouchTap.apply(undefined, _arguments);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ActionButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._node = _reactDom2.default.findDOMNode(this);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({ hover: false, active: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          className = _props.className,
          dense = _props.dense,
          disabled = _props.disabled,
          tooltip = _props.tooltip,
          children = _props.children,
          color = _props.color,
          toggled = _props.toggled,
          hoverColor = _props.hoverColor,
          other = _objectWithoutProperties(_props, ['className', 'dense', 'disabled', 'tooltip', 'children', 'color', 'toggled', 'hoverColor']);

      var _state = this.state,
          hover = _state.hover,
          active = _state.active;

      var classes = (0, _classnames2.default)(css.button, className, (_classNames = {}, _defineProperty(_classNames, css.disabled, disabled), _defineProperty(_classNames, css.active, active), _defineProperty(_classNames, css.dense, dense), _defineProperty(_classNames, css.toggled, toggled), _classNames));
      var handlers = disabled ? {} : {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onTouchTap: this.handleTouchTap
      };
      return _react2.default.createElement(
        'button',
        _extends({}, other, handlers, { className: classes }),
        _react2.default.cloneElement(_react2.default.Children.only(children), {
          color: hover ? hoverColor : color
        }),
        hover && tooltip && _react2.default.createElement(
          _Tooltip2.default,
          { anchorTo: this.getNode },
          tooltip
        )
      );
    }
  }]);

  return ActionButton;
}(_react.Component);

ActionButton.propTypes = {
  tooltip: _react.PropTypes.node,
  children: _react.PropTypes.node,
  disabled: _react.PropTypes.bool,
  dense: _react.PropTypes.bool,
  onTouchTap: _react.PropTypes.func,
  onBlur: _react.PropTypes.func,
  className: _react.PropTypes.string,
  selected: _react.PropTypes.bool,
  hoverColor: _react.PropTypes.string,
  toggled: _react.PropTypes.bool,
  color: _react.PropTypes.string
};
ActionButton.defaultProps = {
  hoverColor: _Css.Cio.Text.secondary,
  color: _Css.Colors.white
};
exports.default = ActionButton;
module.exports = exports['default'];

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPureLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getRow=function getRow(pageRows,pageModules,pageRowId,marked,pure,selectedPageModuleId){var pageRow=pageRows[pageRowId];if(pure){return Object.assign({},pageRow,{marked:marked,pageModules:pageRow.pageModules.filter(function(pageModuleId){return pageModules[pageModuleId]&&pageModuleId!=='drag';}).map(function(pageModuleId){return Object.assign({},pageModules[pageModuleId],{selected:pageModuleId===selectedPageModuleId});})});}return Object.assign({},pageRow,{marked:marked,pageModules:pageRow.pageModules.filter(function(pageModuleId){return pageModules[pageModuleId];}).map(function(pageModuleId){return Object.assign({},pageModules[pageModuleId],{selected:pageModuleId===selectedPageModuleId});})});};var makeGetLayout=function makeGetLayout(){var pure=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.entities.page;},function(state){return state.result;},function(state){return state.entities.pageRows;},function(state){return state.entities.pageModules;},function(state){return state.overRow;},function(state){return state.selectedPageModuleId;},function(page,pageId,pageRows,pageModules,overRow,selectedPageModuleId){if(!pageId){return{pageRows:[]};}return{pageRows:page[pageId].pageRows.filter(function(pageRowId){return pageRows[pageRowId].pageModules.length>0;}).map(function(pageRowId){return getRow(pageRows,pageModules,pageRowId,overRow&&overRow.id===pageRowId?overRow.position:null,pure,selectedPageModuleId);})};});};var getLayout=makeGetLayout();var getPureLayout=makeGetLayout(true);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Drawer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Drawer__ = __webpack_require__(2402);
var Drawer=__WEBPACK_IMPORTED_MODULE_0__Drawer__["a" /* default */];/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Drawer__["a" /* default */]);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_f0',header:'_f1',footer:'_f2',container:'_f3',padded:'_f4'};var ScrollableContainer=function(_Component){_inherits(ScrollableContainer,_Component);function ScrollableContainer(){_classCallCheck(this,ScrollableContainer);return _possibleConstructorReturn(this,(ScrollableContainer.__proto__||Object.getPrototypeOf(ScrollableContainer)).apply(this,arguments));}_createClass(ScrollableContainer,[{key:'render',value:function render(){var _props=this.props,padded=_props.padded,header=_props.header,footer=_props.footer,className=_props.className,children=_props.children,color=_props.color,backgroundColor=_props.backgroundColor,other=_objectWithoutProperties(_props,['padded','header','footer','className','children','color','backgroundColor']);var style=backgroundColor||color?{backgroundColor:backgroundColor,color:color}:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(className,css.root),style:style},other),header&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.container,_defineProperty({},css.padded,padded))},children),footer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.footer},footer));}}]);return ScrollableContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ScrollableContainer.propTypes={header:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,footer:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,padded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,backgroundColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (ScrollableContainer);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toolbar__ = __webpack_require__(2408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToolbarGroup__ = __webpack_require__(2409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToolbarButton__ = __webpack_require__(2410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TabButton__ = __webpack_require__(2411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolbarTitle__ = __webpack_require__(2412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Toolbar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__ToolbarGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__ToolbarButton__["a"]; });
/* unused harmony reexport TabButton */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__ToolbarTitle__["a"]; });


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/library.f56e8a2c.jpg";

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AppStateStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppStateActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Util_refluxConnector__ = __webpack_require__(173);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var AppState=function(){function AppState(){_classCallCheck(this,AppState);}_createClass(AppState,[{key:'toggleMainMenu',value:function toggleMainMenu(){this.set({mainMenuOpen:!this.state.mainMenuOpen});}},{key:'openMainMenu',value:function openMainMenu(){this.set({mainMenuOpen:true});}},{key:'closeMainMenu',value:function closeMainMenu(){this.set({mainMenuOpen:false});}}]);return AppState;}();AppState.state={mainMenuOpen:false};var _createRefluxStore=Object(__WEBPACK_IMPORTED_MODULE_0_Util_refluxConnector__["b" /* createRefluxStore */])(AppState),actions=_createRefluxStore.actions,store=_createRefluxStore.store;var AppStateStore=store;var AppStateActions=actions;

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var SettingsActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['save','saveComplete','read','saveFrontend','saveFrontendComplete','readComplete','update','updateComplete','genericError']);/* harmony default export */ __webpack_exports__["a"] = (SettingsActions);

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(664);
module.exports = __webpack_require__(668);


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(665).enable();
  window.Promise = __webpack_require__(666);
}

// fetch() polyfill for making API calls.
__webpack_require__(667);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(209);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(417);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(417);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 667 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(669);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cio_dist_bundle_css__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cio_dist_bundle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cio_dist_bundle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_main_scss__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_oxygen_css__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_oxygen_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_oxygen_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_js__ = __webpack_require__(673);
if(!global.Intl){__webpack_require__(2440);__webpack_require__(2443);__webpack_require__(23);}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56)))

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_browser__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tap_event_plugin__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tap_event_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_tap_event_plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_AppWrapper__ = __webpack_require__(970);
/* global __DEV__ */__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["a" /* init */]({dsn:"https://c20d1075df17434b89f71399034c4fdd@sentry.io/1846476",environment:"production"});__WEBPACK_IMPORTED_MODULE_2_react_tap_event_plugin___default()();// Segment.identify();
if(false){window.React=React;}function renderApp(){Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_AppWrapper__["a" /* default */],null),document.getElementById('root'));}renderApp();if(false){module.hot.accept('components/AppWrapper',function(){renderApp();});}

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Danger
 * @typechecks static-only
 */



var ExecutionEnvironment = __webpack_require__(45);

var createNodesFromMarkup = __webpack_require__(675);
var emptyFunction = __webpack_require__(57);
var getMarkupWrap = __webpack_require__(421);
var invariant = __webpack_require__(20);

var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
var RESULT_INDEX_ATTR = 'data-danger-index';

/**
 * Extracts the `nodeName` from a string of markup.
 *
 * NOTE: Extracting the `nodeName` does not require a regular expression match
 * because we make assumptions about React-generated markup (i.e. there are no
 * spaces surrounding the opening tag and there is at least one attribute).
 *
 * @param {string} markup String of markup.
 * @return {string} Node name of the supplied markup.
 * @see http://jsperf.com/extract-nodename
 */
function getNodeName(markup) {
  return markup.substring(1, markup.indexOf(' '));
}

var Danger = {

  /**
   * Renders markup into an array of nodes. The markup is expected to render
   * into a list of root nodes. Also, the length of `resultList` and
   * `markupList` should be the same.
   *
   * @param {array<string>} markupList List of markup strings to render.
   * @return {array<DOMElement>} List of rendered nodes.
   * @internal
   */
  dangerouslyRenderMarkup: function (markupList) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
    var nodeName;
    var markupByNodeName = {};
    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
    for (var i = 0; i < markupList.length; i++) {
      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
      nodeName = getNodeName(markupList[i]);
      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
      markupByNodeName[nodeName][i] = markupList[i];
    }
    var resultList = [];
    var resultListAssignmentCount = 0;
    for (nodeName in markupByNodeName) {
      if (!markupByNodeName.hasOwnProperty(nodeName)) {
        continue;
      }
      var markupListByNodeName = markupByNodeName[nodeName];

      // This for-in loop skips the holes of the sparse array. The order of
      // iteration should follow the order of assignment, which happens to match
      // numerical index order, but we don't rely on that.
      var resultIndex;
      for (resultIndex in markupListByNodeName) {
        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
          var markup = markupListByNodeName[resultIndex];

          // Push the requested markup with an additional RESULT_INDEX_ATTR
          // attribute.  If the markup does not start with a < character, it
          // will be discarded below (with an appropriate console.error).
          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
          // This index will be parsed back out below.
          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
        }
      }

      // Render each group of markup with similar wrapping `nodeName`.
      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
      );

      for (var j = 0; j < renderNodes.length; ++j) {
        var renderNode = renderNodes[j];
        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {

          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
          renderNode.removeAttribute(RESULT_INDEX_ATTR);

          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;

          resultList[resultIndex] = renderNode;

          // This should match resultList.length and markupList.length when
          // we're done.
          resultListAssignmentCount += 1;
        } else if (false) {
          console.error('Danger: Discarding unexpected node:', renderNode);
        }
      }
    }

    // Although resultList was populated out of order, it should now be a dense
    // array.
    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;

    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;

    return resultList;
  },

  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
    !(oldChild.tagName.toLowerCase() !== 'html') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;

    var newChild;
    if (typeof markup === 'string') {
      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
    } else {
      newChild = markup;
    }
    oldChild.parentNode.replaceChild(newChild, oldChild);
  }

};

module.exports = Danger;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(45);

var createArrayFromMixed = __webpack_require__(676);
var getMarkupWrap = __webpack_require__(421);
var invariant = __webpack_require__(20);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(20);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule quoteAttributeValueForBrowser
 */



var escapeTextContentForBrowser = __webpack_require__(213);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEventEmitterMixin
 */



var EventPluginHub = __webpack_require__(151);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {

  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {object} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native environment event.
   */
  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adler32
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    for (; i < Math.min(i + 4096, m); i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactRef
 */



var ReactOwner = __webpack_require__(681);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || element === false) {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;

  return(
    // This has a few false positives w/r/t empty components.
    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
  );
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || element === false) {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactOwner
 */



var invariant = __webpack_require__(20);

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {

  /**
   * @param {?object} object
   * @return {boolean} True if `object` is a valid owner.
   * @final
   */
  isValidOwner: function (object) {
    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
  },

  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
    // Check that `component` is still the current ref because we do not want to
    // detach the ref if another component stole it.
    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }

};

module.exports = ReactOwner;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(683);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactCompositeComponent
 */



var ReactComponentEnvironment = __webpack_require__(289);
var ReactCurrentOwner = __webpack_require__(99);
var ReactElement = __webpack_require__(51);
var ReactInstanceMap = __webpack_require__(177);
var ReactPerf = __webpack_require__(72);
var ReactPropTypeLocations = __webpack_require__(216);
var ReactPropTypeLocationNames = __webpack_require__(217);
var ReactReconciler = __webpack_require__(120);
var ReactUpdateQueue = __webpack_require__(286);

var assign = __webpack_require__(29);
var emptyObject = __webpack_require__(153);
var invariant = __webpack_require__(20);
var shouldUpdateReactComponent = __webpack_require__(290);
var warning = __webpack_require__(33);

function getDeclarationErrorAddendum(component) {
  var owner = component._currentElement._owner || null;
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  return Component(this.props, this.context, this.updater);
};

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponentMixin = {

  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = null;
    this._instance = null;

    // See ReactUpdateQueue
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedComponent = null;

    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {string} rootID DOM ID of the root node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (rootID, transaction, context) {
    this._context = context;
    this._mountOrder = nextMountID++;
    this._rootNodeID = rootID;

    var publicProps = this._processProps(this._currentElement.props);
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    // Initialize the public class
    var inst;
    var renderedElement;

    // This is a way to detect if Component is a stateless arrow function
    // component, which is not newable. It might not be 100% reliable but is
    // something we can do until we start detecting that Component extends
    // React.Component. We already assume that typeof Component === 'function'.
    var canInstantiate = ('prototype' in Component);

    if (canInstantiate) {
      if (false) {
        ReactCurrentOwner.current = this;
        try {
          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
        } finally {
          ReactCurrentOwner.current = null;
        }
      } else {
        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
      }
    }

    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
      renderedElement = inst;
      inst = new StatelessComponent(Component);
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
      } else {
        // We support ES6 inheriting from React.Component, the module pattern,
        // and stateless components, but not ES6 classes that don't extend
        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
      }
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = ReactUpdateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    if (inst.componentWillMount) {
      inst.componentWillMount();
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    this._renderedComponent = this._instantiateReactComponent(renderedElement);

    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
    if (inst.componentDidMount) {
      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
    }

    return markup;
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function () {
    var inst = this._instance;

    if (inst.componentWillUnmount) {
      inst.componentWillUnmount();
    }

    ReactReconciler.unmountComponent(this._renderedComponent);
    this._renderedComponent = null;
    this._instance = null;

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = null;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var maskedContext = null;
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext = inst.getChildContext && inst.getChildContext();
    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
      if (false) {
        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
      }
      return assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Processes props by setting default values for unspecified props and
   * asserting that the props are valid. Does not mutate its argument; returns
   * a new props object with defaults merged in.
   *
   * @param {object} newProps
   * @return {object}
   * @private
   */
  _processProps: function (newProps) {
    if (false) {
      var Component = this._currentElement.type;
      if (Component.propTypes) {
        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
      }
    }
    return newProps;
  },

  /**
   * Assert that the props are valid
   *
   * @param {object} propTypes Map of prop name to a ReactPropType
   * @param {object} props
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkPropTypes: function (propTypes, props, location) {
    // TODO: Stop validating prop types here and only use the element
    // validation.
    var componentName = this.getName();
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error;
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
          error = propTypes[propName](props, propName, componentName, location);
        } catch (ex) {
          error = ex;
        }
        if (error instanceof Error) {
          // We may want to extend this logic for similar errors in
          // top-level render calls, so I'm abstracting it away into
          // a function to minimize refactoring in the future
          var addendum = getDeclarationErrorAddendum(this);

          if (location === ReactPropTypeLocations.prop) {
            // Preface gives us something to blacklist in warning module
             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
          } else {
             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
          }
        }
      }
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
    }

    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;

    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
    var nextProps;

    // Distinguish between a props update versus a simple state update
    if (prevParentElement === nextParentElement) {
      // Skip checking prop types again -- we don't read inst.props to avoid
      // warning for DOM component props in this upgrade
      nextProps = nextParentElement.props;
    } else {
      nextProps = this._processProps(nextParentElement.props);
      // An update here will schedule an update but immediately set
      // _pendingStateQueue which will ensure that any state updates gets
      // immediately reconciled instead of waiting for the next batch.

      if (inst.componentWillReceiveProps) {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);

    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
    }

    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      inst.componentWillUpdate(nextProps, nextState, nextContext);
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();
    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      // These two IDs are actually the same! But nothing should rely on that.
      var thisID = this._rootNodeID;
      var prevComponentID = prevComponentInstance._rootNodeID;
      ReactReconciler.unmountComponent(prevComponentInstance);

      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
    }
  },

  /**
   * @protected
   */
  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedComponent = inst.render();
    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedComponent = null;
      }
    }

    return renderedComponent;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedComponent;
    ReactCurrentOwner.current = this;
    try {
      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
    } finally {
      ReactCurrentOwner.current = null;
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
    return renderedComponent;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (inst instanceof StatelessComponent) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null

};

ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
  mountComponent: 'mountComponent',
  updateComponent: 'updateComponent',
  _renderValidatedComponent: '_renderValidatedComponent'
});

var ReactCompositeComponent = {

  Mixin: ReactCompositeComponentMixin

};

module.exports = ReactCompositeComponent;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015 Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BeforeInputEventPlugin
 * @typechecks static-only
 */



var EventConstants = __webpack_require__(84);
var EventPropagators = __webpack_require__(154);
var ExecutionEnvironment = __webpack_require__(45);
var FallbackCompositionState = __webpack_require__(686);
var SyntheticCompositionEvent = __webpack_require__(687);
var SyntheticInputEvent = __webpack_require__(688);

var keyOf = __webpack_require__(85);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

var topLevelTypes = EventConstants.topLevelTypes;

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onBeforeInput: null }),
      captured: keyOf({ onBeforeInputCapture: null })
    },
    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionEnd: null }),
      captured: keyOf({ onCompositionEndCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionStart: null }),
      captured: keyOf({ onCompositionStartCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionUpdate: null }),
      captured: keyOf({ onCompositionUpdateCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case topLevelTypes.topCompositionStart:
      return eventTypes.compositionStart;
    case topLevelTypes.topCompositionEnd:
      return eventTypes.compositionEnd;
    case topLevelTypes.topCompositionUpdate:
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case topLevelTypes.topKeyUp:
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case topLevelTypes.topKeyDown:
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case topLevelTypes.topKeyPress:
    case topLevelTypes.topMouseDown:
    case topLevelTypes.topBlur:
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {DOMEventTarget} topLevelTarget The listening component root node.
 * @param {string} topLevelTargetID ID of `topLevelTarget`.
 * @param {object} nativeEvent Native browser event.
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case topLevelTypes.topCompositionEnd:
      return getDataFromCustomEvent(nativeEvent);
    case topLevelTypes.topKeyPress:
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case topLevelTypes.topTextInput:
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  if (currentComposition) {
    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case topLevelTypes.topPaste:
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case topLevelTypes.topKeyPress:
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case topLevelTypes.topCompositionEnd:
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {DOMEventTarget} topLevelTarget The listening component root node.
 * @param {string} topLevelTargetID ID of `topLevelTarget`.
 * @param {object} nativeEvent Native browser event.
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {

  eventTypes: eventTypes,

  /**
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FallbackCompositionState
 * @typechecks static-only
 */



var PooledClass = __webpack_require__(107);

var assign = __webpack_require__(29);
var getTextContentAccessor = __webpack_require__(436);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticCompositionEvent
 * @typechecks static-only
 */



var SyntheticEvent = __webpack_require__(121);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticInputEvent
 * @typechecks static-only
 */



var SyntheticEvent = __webpack_require__(121);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ChangeEventPlugin
 */



var EventConstants = __webpack_require__(84);
var EventPluginHub = __webpack_require__(151);
var EventPropagators = __webpack_require__(154);
var ExecutionEnvironment = __webpack_require__(45);
var ReactUpdates = __webpack_require__(73);
var SyntheticEvent = __webpack_require__(121);

var getEventTarget = __webpack_require__(292);
var isEventSupported = __webpack_require__(285);
var isTextInputElement = __webpack_require__(437);
var keyOf = __webpack_require__(85);

var topLevelTypes = EventConstants.topLevelTypes;

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onChange: null }),
      captured: keyOf({ onChangeCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
  }
};

/**
 * For IE shims
 */
var activeElement = null;
var activeElementID = null;
var activeElementValue = null;
var activeElementValueProp = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
  EventPropagators.accumulateTwoPhaseDispatches(event);

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetID) {
  activeElement = target;
  activeElementID = targetID;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementID = null;
}

function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topChange) {
    return topLevelTargetID;
  }
}
function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topFocus) {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
  } else if (topLevelType === topLevelTypes.topBlur) {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events
  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For old IE.) Replacement getter/setter for the `value` property that gets
 * set on the active element.
 */
var newValueProp = {
  get: function () {
    return activeElementValueProp.get.call(this);
  },
  set: function (val) {
    // Cast to a string so we can do equality checks.
    activeElementValue = '' + val;
    activeElementValueProp.set.call(this, val);
  }
};

/**
 * (For old IE.) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetID) {
  activeElement = target;
  activeElementID = targetID;
  activeElementValue = target.value;
  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');

  Object.defineProperty(activeElement, 'value', newValueProp);
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For old IE.) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  // delete restores the original property definition
  delete activeElement.value;
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementID = null;
  activeElementValue = null;
  activeElementValueProp = null;
}

/**
 * (For old IE.) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  var value = nativeEvent.srcElement.value;
  if (value === activeElementValue) {
    return;
  }
  activeElementValue = value;

  manualDispatchChangeEvent(nativeEvent);
}

/**
 * If a `change` event should be fired, returns the target's ID.
 */
function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topInput) {
    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
    // what we want so fall through here and trigger an abstract event
    return topLevelTargetID;
  }
}

// For IE8 and IE9.
function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topFocus) {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
  } else if (topLevelType === topLevelTypes.topBlur) {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    if (activeElement && activeElement.value !== activeElementValue) {
      activeElementValue = activeElement.value;
      return activeElementID;
    }
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topClick) {
    return topLevelTargetID;
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {

  eventTypes: eventTypes,

  /**
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {

    var getTargetIDFunc, handleEventFunc;
    if (shouldUseChangeEvent(topLevelTarget)) {
      if (doesChangeEventBubble) {
        getTargetIDFunc = getTargetIDForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(topLevelTarget)) {
      if (isInputEventSupported) {
        getTargetIDFunc = getTargetIDForInputEvent;
      } else {
        getTargetIDFunc = getTargetIDForInputEventIE;
        handleEventFunc = handleEventsForInputEventIE;
      }
    } else if (shouldUseClickEvent(topLevelTarget)) {
      getTargetIDFunc = getTargetIDForClickEvent;
    }

    if (getTargetIDFunc) {
      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
      if (targetID) {
        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
        event.type = 'change';
        EventPropagators.accumulateTwoPhaseDispatches(event);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
    }
  }

};

module.exports = ChangeEventPlugin;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ClientReactRootIndex
 * @typechecks
 */



var nextReactRootIndex = 0;

var ClientReactRootIndex = {
  createReactRootIndex: function () {
    return nextReactRootIndex++;
  }
};

module.exports = ClientReactRootIndex;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultEventPluginOrder
 */



var keyOf = __webpack_require__(85);

/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */
var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EnterLeaveEventPlugin
 * @typechecks static-only
 */



var EventConstants = __webpack_require__(84);
var EventPropagators = __webpack_require__(154);
var SyntheticMouseEvent = __webpack_require__(218);

var ReactMount = __webpack_require__(50);
var keyOf = __webpack_require__(85);

var topLevelTypes = EventConstants.topLevelTypes;
var getFirstReactDOM = ReactMount.getFirstReactDOM;

var eventTypes = {
  mouseEnter: {
    registrationName: keyOf({ onMouseEnter: null }),
    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
  },
  mouseLeave: {
    registrationName: keyOf({ onMouseLeave: null }),
    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
  }
};

var extractedEvents = [null, null];

var EnterLeaveEventPlugin = {

  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (topLevelTarget.window === topLevelTarget) {
      // `topLevelTarget` is probably a window object.
      win = topLevelTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = topLevelTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    var fromID = '';
    var toID = '';
    if (topLevelType === topLevelTypes.topMouseOut) {
      from = topLevelTarget;
      fromID = topLevelTargetID;
      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
      if (to) {
        toID = ReactMount.getID(to);
      } else {
        to = win;
      }
      to = to || win;
    } else {
      from = win;
      to = topLevelTarget;
      toID = topLevelTargetID;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = from;
    leave.relatedTarget = to;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = to;
    enter.relatedTarget = from;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);

    extractedEvents[0] = leave;
    extractedEvents[1] = enter;

    return extractedEvents;
  }

};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule HTMLDOMPropertyConfig
 */



var DOMProperty = __webpack_require__(150);
var ExecutionEnvironment = __webpack_require__(45);

var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var hasSVG;
if (ExecutionEnvironment.canUseDOM) {
  var implementation = document.implementation;
  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
}

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
  Properties: {
    /**
     * Standard Properties
     */
    accept: null,
    acceptCharset: null,
    accessKey: null,
    action: null,
    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    allowTransparency: MUST_USE_ATTRIBUTE,
    alt: null,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: null,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    cellPadding: null,
    cellSpacing: null,
    charSet: MUST_USE_ATTRIBUTE,
    challenge: MUST_USE_ATTRIBUTE,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    classID: MUST_USE_ATTRIBUTE,
    // To set className on SVG elements, it's necessary to use .setAttribute;
    // this works on HTML elements too in all browsers except IE8. Conveniently,
    // IE8 doesn't support SVG and so we can simply use the attribute in
    // browsers that support SVG and the property in browsers that don't,
    // regardless of whether the element is HTML or SVG.
    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: null,
    content: null,
    contentEditable: null,
    contextMenu: MUST_USE_ATTRIBUTE,
    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    coords: null,
    crossOrigin: null,
    data: null, // For `<object />` acts as `src`.
    dateTime: MUST_USE_ATTRIBUTE,
    defer: HAS_BOOLEAN_VALUE,
    dir: null,
    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: null,
    encType: null,
    form: MUST_USE_ATTRIBUTE,
    formAction: MUST_USE_ATTRIBUTE,
    formEncType: MUST_USE_ATTRIBUTE,
    formMethod: MUST_USE_ATTRIBUTE,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: MUST_USE_ATTRIBUTE,
    frameBorder: MUST_USE_ATTRIBUTE,
    headers: null,
    height: MUST_USE_ATTRIBUTE,
    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    high: null,
    href: null,
    hrefLang: null,
    htmlFor: null,
    httpEquiv: null,
    icon: null,
    id: MUST_USE_PROPERTY,
    inputMode: MUST_USE_ATTRIBUTE,
    is: MUST_USE_ATTRIBUTE,
    keyParams: MUST_USE_ATTRIBUTE,
    keyType: MUST_USE_ATTRIBUTE,
    label: null,
    lang: null,
    list: MUST_USE_ATTRIBUTE,
    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    low: null,
    manifest: MUST_USE_ATTRIBUTE,
    marginHeight: null,
    marginWidth: null,
    max: null,
    maxLength: MUST_USE_ATTRIBUTE,
    media: MUST_USE_ATTRIBUTE,
    mediaGroup: null,
    method: null,
    min: null,
    minLength: MUST_USE_ATTRIBUTE,
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: null,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: null,
    pattern: null,
    placeholder: null,
    poster: null,
    preload: null,
    radioGroup: null,
    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    rel: null,
    required: HAS_BOOLEAN_VALUE,
    role: MUST_USE_ATTRIBUTE,
    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: null,
    sandbox: null,
    scope: null,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: null,
    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: null,
    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
    sizes: MUST_USE_ATTRIBUTE,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: null,
    src: null,
    srcDoc: MUST_USE_PROPERTY,
    srcSet: MUST_USE_ATTRIBUTE,
    start: HAS_NUMERIC_VALUE,
    step: null,
    style: null,
    summary: null,
    tabIndex: null,
    target: null,
    title: null,
    type: null,
    useMap: null,
    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
    width: MUST_USE_ATTRIBUTE,
    wmode: MUST_USE_ATTRIBUTE,
    wrap: null,

    /**
     * RDFa Properties
     */
    about: MUST_USE_ATTRIBUTE,
    datatype: MUST_USE_ATTRIBUTE,
    inlist: MUST_USE_ATTRIBUTE,
    prefix: MUST_USE_ATTRIBUTE,
    // property is also supported for OpenGraph in meta tags.
    property: MUST_USE_ATTRIBUTE,
    resource: MUST_USE_ATTRIBUTE,
    'typeof': MUST_USE_ATTRIBUTE,
    vocab: MUST_USE_ATTRIBUTE,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: null,
    autoCorrect: null,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: null,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: MUST_USE_ATTRIBUTE,
    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    itemType: MUST_USE_ATTRIBUTE,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: MUST_USE_ATTRIBUTE,
    itemRef: MUST_USE_ATTRIBUTE,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: null,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: MUST_USE_ATTRIBUTE,
    // IE-only attribute that controls focus behavior
    unselectable: MUST_USE_ATTRIBUTE
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {
    autoCapitalize: 'autocapitalize',
    autoComplete: 'autocomplete',
    autoCorrect: 'autocorrect',
    autoFocus: 'autofocus',
    autoPlay: 'autoplay',
    autoSave: 'autosave',
    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
    encType: 'encoding',
    hrefLang: 'hreflang',
    radioGroup: 'radiogroup',
    spellCheck: 'spellcheck',
    srcDoc: 'srcdoc',
    srcSet: 'srcset'
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactBrowserComponentMixin
 */



var ReactInstanceMap = __webpack_require__(177);

var findDOMNode = __webpack_require__(294);
var warning = __webpack_require__(33);

var didWarnKey = '_getDOMNodeDidWarn';

var ReactBrowserComponentMixin = {
  /**
   * Returns the DOM node rendered by this component.
   *
   * @return {DOMElement} The root node of this component.
   * @final
   * @protected
   */
  getDOMNode: function () {
     false ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
    this.constructor[didWarnKey] = true;
    return findDOMNode(this);
  }
};

module.exports = ReactBrowserComponentMixin;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMComponent
 * @typechecks static-only
 */

/* global hasOwnProperty:true */



var AutoFocusUtils = __webpack_require__(696);
var CSSPropertyOperations = __webpack_require__(74);
var DOMProperty = __webpack_require__(150);
var DOMPropertyOperations = __webpack_require__(281);
var EventConstants = __webpack_require__(84);
var ReactBrowserEventEmitter = __webpack_require__(214);
var ReactComponentBrowserEnvironment = __webpack_require__(282);
var ReactDOMButton = __webpack_require__(703);
var ReactDOMInput = __webpack_require__(704);
var ReactDOMOption = __webpack_require__(705);
var ReactDOMSelect = __webpack_require__(442);
var ReactDOMTextarea = __webpack_require__(706);
var ReactMount = __webpack_require__(50);
var ReactMultiChild = __webpack_require__(707);
var ReactPerf = __webpack_require__(72);
var ReactUpdateQueue = __webpack_require__(286);

var assign = __webpack_require__(29);
var escapeTextContentForBrowser = __webpack_require__(213);
var invariant = __webpack_require__(20);
var isEventSupported = __webpack_require__(285);
var keyOf = __webpack_require__(85);
var setInnerHTML = __webpack_require__(212);
var setTextContent = __webpack_require__(280);
var shallowEqual = __webpack_require__(219);
var validateDOMNesting = __webpack_require__(291);
var warning = __webpack_require__(33);

var deleteListener = ReactBrowserEventEmitter.deleteListener;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { 'string': true, 'number': true };

var STYLE = keyOf({ style: null });

var ELEMENT_NODE_TYPE = 1;

var canDefineProperty = false;
try {
  Object.defineProperty({}, 'test', { get: function () {} });
  canDefineProperty = true;
} catch (e) {}

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

var legacyPropsDescriptor;
if (false) {
  legacyPropsDescriptor = {
    props: {
      enumerable: false,
      get: function () {
        var component = this._reactInternalComponent;
        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
        return component._currentElement.props;
      }
    }
  };
}

function legacyGetDOMNode() {
  if (false) {
    var component = this._reactInternalComponent;
    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
  return this;
}

function legacyIsMounted() {
  var component = this._reactInternalComponent;
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
  return !!component;
}

function legacySetStateEtc() {
  if (false) {
    var component = this._reactInternalComponent;
    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
}

function legacySetProps(partialProps, callback) {
  var component = this._reactInternalComponent;
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
  if (!component) {
    return;
  }
  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
  if (callback) {
    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
  }
}

function legacyReplaceProps(partialProps, callback) {
  var component = this._reactInternalComponent;
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
  if (!component) {
    return;
  }
  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
  if (callback) {
    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
  }
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined becauses undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (false) {
    if (voidElementTags[component._tag]) {
      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
    }
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
    !(typeof props.dangerouslySetInnerHTML === 'object' && '__html' in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
}

function enqueuePutListener(id, registrationName, listener, transaction) {
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
  }
  var container = ReactMount.findReactContainerForID(id);
  if (container) {
    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
    listenTo(registrationName, doc);
  }
  transaction.getReactMountReady().enqueue(putListener, {
    id: id,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
  var node = ReactMount.getNode(inst._rootNodeID);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;

  switch (inst._tag) {
    case 'iframe':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
      break;
    case 'video':
    case 'audio':

      inst._wrapperState.listeners = [];
      // create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
        }
      }

      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
      break;
  }
}

function mountReadyInputWrapper() {
  ReactDOMInput.mountReadyWrapper(this);
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special cased tags.

var omittedCloseTags = {
  'area': true,
  'base': true,
  'br': true,
  'col': true,
  'embed': true,
  'hr': true,
  'img': true,
  'input': true,
  'keygen': true,
  'link': true,
  'meta': true,
  'param': true,
  'source': true,
  'track': true,
  'wbr': true
};

// NOTE: menuitem's close tag should be omitted, but that causes problems.
var newlineEatingTags = {
  'listing': true,
  'pre': true,
  'textarea': true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = assign({
  'menuitem': true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = ({}).hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
    validatedTagCache[tag] = true;
  }
}

function processChildContextDev(context, inst) {
  // Pass down our tag name to child components for validation purposes
  context = assign({}, context);
  var info = context[validateDOMNesting.ancestorInfoContextKey];
  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
  return context;
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(tag) {
  validateDangerousTag(tag);
  this._tag = tag.toLowerCase();
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._rootNodeID = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._nodeWithLegacyProperties = null;
  if (false) {
    this._unprocessedContextDev = null;
    this._processedContextDev = null;
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {

  construct: function (element) {
    this._currentElement = element;
  },

  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {string} rootID The root DOM ID for this node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (rootID, transaction, context) {
    this._rootNodeID = rootID;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'iframe':
      case 'img':
      case 'form':
      case 'video':
      case 'audio':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'button':
        props = ReactDOMButton.getNativeProps(this, props, context);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, context);
        props = ReactDOMInput.getNativeProps(this, props, context);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, context);
        props = ReactDOMOption.getNativeProps(this, props, context);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, context);
        props = ReactDOMSelect.getNativeProps(this, props, context);
        context = ReactDOMSelect.processChildContext(this, props, context);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, context);
        props = ReactDOMTextarea.getNativeProps(this, props, context);
        break;
    }

    assertValidProps(this, props);
    if (false) {
      if (context[validateDOMNesting.ancestorInfoContextKey]) {
        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
      }
    }

    if (false) {
      this._unprocessedContextDev = context;
      this._processedContextDev = processChildContextDev(context, this);
      context = this._processedContextDev;
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
      var el = ownerDocument.createElement(this._currentElement.type);
      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
      // Populate node cache
      ReactMount.getID(el);
      this._updateDOMProperties({}, props, transaction, el);
      this._createInitialChildren(transaction, props, context, el);
      mountImage = el;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
      // falls through
      case 'button':
      case 'select':
      case 'textarea':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
    return ret + ' ' + markupForID;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, el) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        setInnerHTML(el, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        setTextContent(el, contentToUse);
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          el.appendChild(mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a native DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'button':
        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
        break;
      case 'input':
        ReactDOMInput.updateWrapper(this);
        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
        break;
    }

    if (false) {
      // If the context is reference-equal to the old one, pass down the same
      // processed object so the update bailout in ReactReconciler behaves
      // correctly (and identically in dev and prod). See #5005.
      if (this._unprocessedContextDev !== context) {
        this._unprocessedContextDev = context;
        this._processedContextDev = processChildContextDev(context, this);
      }
      context = this._processedContextDev;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction, null);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    if (!canDefineProperty && this._nodeWithLegacyProperties) {
      this._nodeWithLegacyProperties.props = nextProps;
    }

    if (this._tag === 'select') {
      // <select> value update needs to occur after <option> children
      // reconciliation
      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this._rootNodeID, propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        if (!node) {
          node = ReactMount.getNode(this._rootNodeID);
        }
        DOMPropertyOperations.deleteValueForProperty(node, propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this._rootNodeID, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!node) {
          node = ReactMount.getNode(this._rootNodeID);
        }
        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        if (!node) {
          node = ReactMount.getNode(this._rootNodeID);
        }
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertantly setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      if (!node) {
        node = ReactMount.getNode(this._rootNodeID);
      }
      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
    } else if (nextChildren != null) {
      this.updateChildren(nextChildren, transaction, context);
    }
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function () {
    switch (this._tag) {
      case 'iframe':
      case 'img':
      case 'form':
      case 'video':
      case 'audio':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
        ReactDOMInput.unmountWrapper(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
        break;
    }

    this.unmountChildren();
    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
    this._rootNodeID = null;
    this._wrapperState = null;
    if (this._nodeWithLegacyProperties) {
      var node = this._nodeWithLegacyProperties;
      node._reactInternalComponent = null;
      this._nodeWithLegacyProperties = null;
    }
  },

  getPublicInstance: function () {
    if (!this._nodeWithLegacyProperties) {
      var node = ReactMount.getNode(this._rootNodeID);

      node._reactInternalComponent = this;
      node.getDOMNode = legacyGetDOMNode;
      node.isMounted = legacyIsMounted;
      node.setState = legacySetStateEtc;
      node.replaceState = legacySetStateEtc;
      node.forceUpdate = legacySetStateEtc;
      node.setProps = legacySetProps;
      node.replaceProps = legacyReplaceProps;

      if (false) {
        if (canDefineProperty) {
          Object.defineProperties(node, legacyPropsDescriptor);
        } else {
          // updateComponent will update this property on subsequent renders
          node.props = this._currentElement.props;
        }
      } else {
        // updateComponent will update this property on subsequent renders
        node.props = this._currentElement.props;
      }

      this._nodeWithLegacyProperties = node;
    }
    return this._nodeWithLegacyProperties;
  }

};

ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
  mountComponent: 'mountComponent',
  updateComponent: 'updateComponent'
});

assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule AutoFocusUtils
 * @typechecks static-only
 */



var ReactMount = __webpack_require__(50);

var findDOMNode = __webpack_require__(294);
var focusNode = __webpack_require__(439);

var Mixin = {
  componentDidMount: function () {
    if (this.props.autoFocus) {
      focusNode(findDOMNode(this));
    }
  }
};

var AutoFocusUtils = {
  Mixin: Mixin,

  focusDOMComponent: function () {
    focusNode(ReactMount.getNode(this._rootNodeID));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(698);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule dangerousStyleValue
 * @typechecks static-only
 */



var CSSProperty = __webpack_require__(440);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(701);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMButton
 */



var mouseListenerNames = {
  onClick: true,
  onDoubleClick: true,
  onMouseDown: true,
  onMouseMove: true,
  onMouseUp: true,

  onClickCapture: true,
  onDoubleClickCapture: true,
  onMouseDownCapture: true,
  onMouseMoveCapture: true,
  onMouseUpCapture: true
};

/**
 * Implements a <button> native component that does not receive mouse events
 * when `disabled` is set.
 */
var ReactDOMButton = {
  getNativeProps: function (inst, props, context) {
    if (!props.disabled) {
      return props;
    }

    // Copy the props, except the mouse listeners
    var nativeProps = {};
    for (var key in props) {
      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
        nativeProps[key] = props[key];
      }
    }

    return nativeProps;
  }
};

module.exports = ReactDOMButton;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMInput
 */



var ReactDOMIDOperations = __webpack_require__(283);
var LinkedValueUtils = __webpack_require__(295);
var ReactMount = __webpack_require__(50);
var ReactUpdates = __webpack_require__(73);

var assign = __webpack_require__(29);
var invariant = __webpack_require__(20);

var instancesByReactID = {};

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

/**
 * Implements an <input> native component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getNativeProps: function (inst, props, context) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var nativeProps = assign({}, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return nativeProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.defaultChecked || false,
      initialValue: defaultValue != null ? defaultValue : null,
      onChange: _handleChange.bind(inst)
    };
  },

  mountReadyWrapper: function (inst) {
    // Can't be in mountWrapper or else server rendering leaks.
    instancesByReactID[inst._rootNodeID] = inst;
  },

  unmountWrapper: function (inst) {
    delete instancesByReactID[inst._rootNodeID];
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
    }

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactMount.getNode(this._rootNodeID);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React with non-React.
      var otherID = ReactMount.getID(otherNode);
      !otherID ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
      var otherInstance = instancesByReactID[otherID];
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMOption
 */



var ReactChildren = __webpack_require__(297);
var ReactDOMSelect = __webpack_require__(442);

var assign = __webpack_require__(29);
var warning = __webpack_require__(33);

var valueContextKey = ReactDOMSelect.valueContextKey;

/**
 * Implements an <option> native component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, context) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
    }

    // Look up whether this option is 'selected' via context
    var selectValue = context[valueContextKey];

    // If context key is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === '' + props.value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === '' + props.value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  getNativeProps: function (inst, props, context) {
    var nativeProps = assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      nativeProps.selected = inst._wrapperState.selected;
    }

    var content = '';

    // Flatten children and warn if they aren't strings or numbers;
    // invalid types are ignored.
    ReactChildren.forEach(props.children, function (child) {
      if (child == null) {
        return;
      }
      if (typeof child === 'string' || typeof child === 'number') {
        content += child;
      } else {
         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
      }
    });

    nativeProps.children = content;
    return nativeProps;
  }

};

module.exports = ReactDOMOption;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMTextarea
 */



var LinkedValueUtils = __webpack_require__(295);
var ReactDOMIDOperations = __webpack_require__(283);
var ReactUpdates = __webpack_require__(73);

var assign = __webpack_require__(29);
var invariant = __webpack_require__(20);
var warning = __webpack_require__(33);

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> native component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getNativeProps: function (inst, props, context) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.
    var nativeProps = assign({}, props, {
      defaultValue: undefined,
      value: undefined,
      children: inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return nativeProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
    }

    var defaultValue = props.defaultValue;
    // TODO (yungsters): Remove support for children content in <textarea>.
    var children = props.children;
    if (children != null) {
      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
      }
      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
      if (Array.isArray(children)) {
        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
        children = children[0];
      }

      defaultValue = '' + children;
    }
    if (defaultValue == null) {
      defaultValue = '';
    }
    var value = LinkedValueUtils.getValue(props);

    inst._wrapperState = {
      // We save the initial value so that `ReactDOMComponent` doesn't update
      // `textContent` (unnecessary since we update value).
      // The initial value can be a boolean or object so that's why it's
      // forced to be a string.
      initialValue: '' + (value != null ? value : defaultValue),
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMultiChild
 * @typechecks static-only
 */



var ReactComponentEnvironment = __webpack_require__(289);
var ReactMultiChildUpdateTypes = __webpack_require__(422);

var ReactCurrentOwner = __webpack_require__(99);
var ReactReconciler = __webpack_require__(120);
var ReactChildReconciler = __webpack_require__(708);

var flattenChildren = __webpack_require__(443);

/**
 * Updating children of a component may trigger recursive updates. The depth is
 * used to batch recursive updates to render markup more efficiently.
 *
 * @type {number}
 * @private
 */
var updateDepth = 0;

/**
 * Queue of update configuration objects.
 *
 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
 *
 * @type {array<object>}
 * @private
 */
var updateQueue = [];

/**
 * Queue of markup to be rendered.
 *
 * @type {array<string>}
 * @private
 */
var markupQueue = [];

/**
 * Enqueues markup to be rendered and inserted at a supplied index.
 *
 * @param {string} parentID ID of the parent component.
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function enqueueInsertMarkup(parentID, markup, toIndex) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
    markupIndex: markupQueue.push(markup) - 1,
    content: null,
    fromIndex: null,
    toIndex: toIndex
  });
}

/**
 * Enqueues moving an existing element to another index.
 *
 * @param {string} parentID ID of the parent component.
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function enqueueMove(parentID, fromIndex, toIndex) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
    markupIndex: null,
    content: null,
    fromIndex: fromIndex,
    toIndex: toIndex
  });
}

/**
 * Enqueues removing an element at an index.
 *
 * @param {string} parentID ID of the parent component.
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function enqueueRemove(parentID, fromIndex) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
    markupIndex: null,
    content: null,
    fromIndex: fromIndex,
    toIndex: null
  });
}

/**
 * Enqueues setting the markup of a node.
 *
 * @param {string} parentID ID of the parent component.
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function enqueueSetMarkup(parentID, markup) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.SET_MARKUP,
    markupIndex: null,
    content: markup,
    fromIndex: null,
    toIndex: null
  });
}

/**
 * Enqueues setting the text content.
 *
 * @param {string} parentID ID of the parent component.
 * @param {string} textContent Text content to set.
 * @private
 */
function enqueueTextContent(parentID, textContent) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
    markupIndex: null,
    content: textContent,
    fromIndex: null,
    toIndex: null
  });
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue() {
  if (updateQueue.length) {
    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
    clearQueue();
  }
}

/**
 * Clears any enqueued updates.
 *
 * @private
 */
function clearQueue() {
  updateQueue.length = 0;
  markupQueue.length = 0;
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {

  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {

    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
      var nextChildren;
      if (false) {
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements);
          } finally {
            ReactCurrentOwner.current = null;
          }
          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements);
      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;
      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
          var rootID = this._rootNodeID + name;
          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }
      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      updateDepth++;
      var errorThrown = true;
      try {
        var prevChildren = this._renderedChildren;
        // Remove any rendered children.
        ReactChildReconciler.unmountChildren(prevChildren);
        // TODO: The setTextContent operation should be enough
        for (var name in prevChildren) {
          if (prevChildren.hasOwnProperty(name)) {
            this._unmountChild(prevChildren[name]);
          }
        }
        // Set new text content.
        this.setTextContent(nextContent);
        errorThrown = false;
      } finally {
        updateDepth--;
        if (!updateDepth) {
          if (errorThrown) {
            clearQueue();
          } else {
            processQueue();
          }
        }
      }
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      updateDepth++;
      var errorThrown = true;
      try {
        var prevChildren = this._renderedChildren;
        // Remove any rendered children.
        ReactChildReconciler.unmountChildren(prevChildren);
        for (var name in prevChildren) {
          if (prevChildren.hasOwnProperty(name)) {
            this._unmountChildByName(prevChildren[name], name);
          }
        }
        this.setMarkup(nextMarkup);
        errorThrown = false;
      } finally {
        updateDepth--;
        if (!updateDepth) {
          if (errorThrown) {
            clearQueue();
          } else {
            processQueue();
          }
        }
      }
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      updateDepth++;
      var errorThrown = true;
      try {
        this._updateChildren(nextNestedChildrenElements, transaction, context);
        errorThrown = false;
      } finally {
        updateDepth--;
        if (!updateDepth) {
          if (errorThrown) {
            clearQueue();
          } else {
            processQueue();
          }
        }
      }
    },

    /**
     * Improve performance by isolating this hot code path from the try/catch
     * block in `updateChildren`.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
      this._renderedChildren = nextChildren;
      if (!nextChildren && !prevChildren) {
        return;
      }
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var lastIndex = 0;
      var nextIndex = 0;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          this.moveChild(prevChild, nextIndex, lastIndex);
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            this._unmountChild(prevChild);
          }
          // The child must be instantiated before it's mounted.
          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
        }
        nextIndex++;
      }
      // Remove children that are no longer present.
      for (name in prevChildren) {
        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
          this._unmountChild(prevChildren[name]);
        }
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted.
     *
     * @internal
     */
    unmountChildren: function () {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, mountImage) {
      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child) {
      enqueueRemove(this._rootNodeID, child._mountIndex);
    },

    /**
     * Sets this text content string.
     *
     * @param {string} textContent Text content to set.
     * @protected
     */
    setTextContent: function (textContent) {
      enqueueTextContent(this._rootNodeID, textContent);
    },

    /**
     * Sets this markup string.
     *
     * @param {string} markup Markup to set.
     * @protected
     */
    setMarkup: function (markup) {
      enqueueSetMarkup(this._rootNodeID, markup);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
      var rootID = this._rootNodeID + name;
      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
      child._mountIndex = index;
      this.createChild(child, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child) {
      this.removeChild(child);
      child._mountIndex = null;
    }

  }

};

module.exports = ReactMultiChild;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactChildReconciler
 * @typechecks static-only
 */



var ReactReconciler = __webpack_require__(120);

var instantiateReactComponent = __webpack_require__(288);
var shouldUpdateReactComponent = __webpack_require__(290);
var traverseAllChildren = __webpack_require__(298);
var warning = __webpack_require__(33);

function instantiateChild(childInstances, child, name) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, null);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context) {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};
    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, transaction, context) {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return null;
    }
    var name;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      var prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          ReactReconciler.unmountComponent(prevChild, name);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, null);
        nextChildren[name] = nextChildInstance;
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        ReactReconciler.unmountComponent(prevChildren[name]);
      }
    }
    return nextChildren;
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild);
      }
    }
  }

};

module.exports = ReactChildReconciler;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEventListener
 * @typechecks static-only
 */



var EventListener = __webpack_require__(444);
var ExecutionEnvironment = __webpack_require__(45);
var PooledClass = __webpack_require__(107);
var ReactInstanceHandles = __webpack_require__(152);
var ReactMount = __webpack_require__(50);
var ReactUpdates = __webpack_require__(73);

var assign = __webpack_require__(29);
var getEventTarget = __webpack_require__(292);
var getUnboundedScrollPosition = __webpack_require__(710);

var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * Finds the parent React component of `node`.
 *
 * @param {*} node
 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
 *                           is not nested.
 */
function findParent(node) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  var nodeID = ReactMount.getID(node);
  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
  var container = ReactMount.findReactContainerForID(rootID);
  var parent = ReactMount.getFirstReactDOM(container);
  return parent;
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  // TODO: Re-enable event.path handling
  //
  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
  //   // New browsers have a path attribute on native events
  //   handleTopLevelWithPath(bookKeeping);
  // } else {
  //   // Legacy browsers don't have a path attribute on native events
  //   handleTopLevelWithoutPath(bookKeeping);
  // }

  void handleTopLevelWithPath; // temporarily unused
  handleTopLevelWithoutPath(bookKeeping);
}

// Legacy browsers don't have a path attribute on native events
function handleTopLevelWithoutPath(bookKeeping) {
  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = topLevelTarget;
  while (ancestor) {
    bookKeeping.ancestors.push(ancestor);
    ancestor = findParent(ancestor);
  }

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    topLevelTarget = bookKeeping.ancestors[i];
    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

// New browsers have a path attribute on native events
function handleTopLevelWithPath(bookKeeping) {
  var path = bookKeeping.nativeEvent.path;
  var currentNativeTarget = path[0];
  var eventsFired = 0;
  for (var i = 0; i < path.length; i++) {
    var currentPathElement = path[i];
    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
      currentNativeTarget = path[i + 1];
    }
    // TODO: slow
    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
    if (reactParent === currentPathElement) {
      var currentPathElementID = ReactMount.getID(currentPathElement);
      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
      bookKeeping.ancestors.push(currentPathElement);

      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
      eventsFired++;
      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);

      // Jump to the root of this React render tree
      while (currentPathElementID !== newRootID) {
        i++;
        currentPathElement = path[i];
        currentPathElementID = ReactMount.getID(currentPathElement);
      }
    }
  }
  if (eventsFired === 0) {
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} handle Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    var element = handle;
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} handle Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    var element = handle;
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInjection
 */



var DOMProperty = __webpack_require__(150);
var EventPluginHub = __webpack_require__(151);
var ReactComponentEnvironment = __webpack_require__(289);
var ReactClass = __webpack_require__(445);
var ReactEmptyComponent = __webpack_require__(433);
var ReactBrowserEventEmitter = __webpack_require__(214);
var ReactNativeComponent = __webpack_require__(434);
var ReactPerf = __webpack_require__(72);
var ReactRootIndex = __webpack_require__(430);
var ReactUpdates = __webpack_require__(73);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  Class: ReactClass.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  NativeComponent: ReactNativeComponent.injection,
  Perf: ReactPerf.injection,
  RootIndex: ReactRootIndex.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactReconcileTransaction
 * @typechecks static-only
 */



var CallbackQueue = __webpack_require__(287);
var PooledClass = __webpack_require__(107);
var ReactBrowserEventEmitter = __webpack_require__(214);
var ReactDOMFeatureFlags = __webpack_require__(428);
var ReactInputSelection = __webpack_require__(448);
var Transaction = __webpack_require__(215);

var assign = __webpack_require__(29);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(forceHTML) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMSelection
 */



var ExecutionEnvironment = __webpack_require__(45);

var getNodeForCharacterOffset = __webpack_require__(714);
var getTextContentAccessor = __webpack_require__(436);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (typeof offsets.end === 'undefined') {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getNodeForCharacterOffset
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */
function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SelectEventPlugin
 */



var EventConstants = __webpack_require__(84);
var EventPropagators = __webpack_require__(154);
var ExecutionEnvironment = __webpack_require__(45);
var ReactInputSelection = __webpack_require__(448);
var SyntheticEvent = __webpack_require__(121);

var getActiveElement = __webpack_require__(449);
var isTextInputElement = __webpack_require__(437);
var keyOf = __webpack_require__(85);
var shallowEqual = __webpack_require__(219);

var topLevelTypes = EventConstants.topLevelTypes;

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSelect: null }),
      captured: keyOf({ onSelectCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
  }
};

var activeElement = null;
var activeElementID = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events.
var hasListener = false;
var ON_SELECT_KEY = keyOf({ onSelect: null });

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {

  eventTypes: eventTypes,

  /**
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    switch (topLevelType) {
      // Track the input node that has focus.
      case topLevelTypes.topFocus:
        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
          activeElement = topLevelTarget;
          activeElementID = topLevelTargetID;
          lastSelection = null;
        }
        break;
      case topLevelTypes.topBlur:
        activeElement = null;
        activeElementID = null;
        lastSelection = null;
        break;

      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case topLevelTypes.topMouseDown:
        mouseDown = true;
        break;
      case topLevelTypes.topContextMenu:
      case topLevelTypes.topMouseUp:
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);

      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case topLevelTypes.topSelectionChange:
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case topLevelTypes.topKeyDown:
      case topLevelTypes.topKeyUp:
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (id, registrationName, listener) {
    if (registrationName === ON_SELECT_KEY) {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ServerReactRootIndex
 * @typechecks
 */



/**
 * Size of the reactRoot ID space. We generate random numbers for React root
 * IDs and if there's a collision the events and DOM update system will
 * get confused. In the future we need a way to generate GUIDs but for
 * now this will work on a smaller scale.
 */
var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);

var ServerReactRootIndex = {
  createReactRootIndex: function () {
    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
  }
};

module.exports = ServerReactRootIndex;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SimpleEventPlugin
 */



var EventConstants = __webpack_require__(84);
var EventListener = __webpack_require__(444);
var EventPropagators = __webpack_require__(154);
var ReactMount = __webpack_require__(50);
var SyntheticClipboardEvent = __webpack_require__(718);
var SyntheticEvent = __webpack_require__(121);
var SyntheticFocusEvent = __webpack_require__(719);
var SyntheticKeyboardEvent = __webpack_require__(720);
var SyntheticMouseEvent = __webpack_require__(218);
var SyntheticDragEvent = __webpack_require__(722);
var SyntheticTouchEvent = __webpack_require__(723);
var SyntheticUIEvent = __webpack_require__(155);
var SyntheticWheelEvent = __webpack_require__(724);

var emptyFunction = __webpack_require__(57);
var getEventCharCode = __webpack_require__(299);
var invariant = __webpack_require__(20);
var keyOf = __webpack_require__(85);

var topLevelTypes = EventConstants.topLevelTypes;

var eventTypes = {
  abort: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onAbort: true }),
      captured: keyOf({ onAbortCapture: true })
    }
  },
  blur: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onBlur: true }),
      captured: keyOf({ onBlurCapture: true })
    }
  },
  canPlay: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCanPlay: true }),
      captured: keyOf({ onCanPlayCapture: true })
    }
  },
  canPlayThrough: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCanPlayThrough: true }),
      captured: keyOf({ onCanPlayThroughCapture: true })
    }
  },
  click: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onClick: true }),
      captured: keyOf({ onClickCapture: true })
    }
  },
  contextMenu: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onContextMenu: true }),
      captured: keyOf({ onContextMenuCapture: true })
    }
  },
  copy: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCopy: true }),
      captured: keyOf({ onCopyCapture: true })
    }
  },
  cut: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCut: true }),
      captured: keyOf({ onCutCapture: true })
    }
  },
  doubleClick: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDoubleClick: true }),
      captured: keyOf({ onDoubleClickCapture: true })
    }
  },
  drag: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDrag: true }),
      captured: keyOf({ onDragCapture: true })
    }
  },
  dragEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragEnd: true }),
      captured: keyOf({ onDragEndCapture: true })
    }
  },
  dragEnter: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragEnter: true }),
      captured: keyOf({ onDragEnterCapture: true })
    }
  },
  dragExit: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragExit: true }),
      captured: keyOf({ onDragExitCapture: true })
    }
  },
  dragLeave: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragLeave: true }),
      captured: keyOf({ onDragLeaveCapture: true })
    }
  },
  dragOver: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragOver: true }),
      captured: keyOf({ onDragOverCapture: true })
    }
  },
  dragStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragStart: true }),
      captured: keyOf({ onDragStartCapture: true })
    }
  },
  drop: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDrop: true }),
      captured: keyOf({ onDropCapture: true })
    }
  },
  durationChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDurationChange: true }),
      captured: keyOf({ onDurationChangeCapture: true })
    }
  },
  emptied: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEmptied: true }),
      captured: keyOf({ onEmptiedCapture: true })
    }
  },
  encrypted: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEncrypted: true }),
      captured: keyOf({ onEncryptedCapture: true })
    }
  },
  ended: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEnded: true }),
      captured: keyOf({ onEndedCapture: true })
    }
  },
  error: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onError: true }),
      captured: keyOf({ onErrorCapture: true })
    }
  },
  focus: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onFocus: true }),
      captured: keyOf({ onFocusCapture: true })
    }
  },
  input: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onInput: true }),
      captured: keyOf({ onInputCapture: true })
    }
  },
  keyDown: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyDown: true }),
      captured: keyOf({ onKeyDownCapture: true })
    }
  },
  keyPress: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyPress: true }),
      captured: keyOf({ onKeyPressCapture: true })
    }
  },
  keyUp: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyUp: true }),
      captured: keyOf({ onKeyUpCapture: true })
    }
  },
  load: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoad: true }),
      captured: keyOf({ onLoadCapture: true })
    }
  },
  loadedData: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadedData: true }),
      captured: keyOf({ onLoadedDataCapture: true })
    }
  },
  loadedMetadata: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadedMetadata: true }),
      captured: keyOf({ onLoadedMetadataCapture: true })
    }
  },
  loadStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadStart: true }),
      captured: keyOf({ onLoadStartCapture: true })
    }
  },
  // Note: We do not allow listening to mouseOver events. Instead, use the
  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
  mouseDown: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseDown: true }),
      captured: keyOf({ onMouseDownCapture: true })
    }
  },
  mouseMove: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseMove: true }),
      captured: keyOf({ onMouseMoveCapture: true })
    }
  },
  mouseOut: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseOut: true }),
      captured: keyOf({ onMouseOutCapture: true })
    }
  },
  mouseOver: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseOver: true }),
      captured: keyOf({ onMouseOverCapture: true })
    }
  },
  mouseUp: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseUp: true }),
      captured: keyOf({ onMouseUpCapture: true })
    }
  },
  paste: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPaste: true }),
      captured: keyOf({ onPasteCapture: true })
    }
  },
  pause: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPause: true }),
      captured: keyOf({ onPauseCapture: true })
    }
  },
  play: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPlay: true }),
      captured: keyOf({ onPlayCapture: true })
    }
  },
  playing: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPlaying: true }),
      captured: keyOf({ onPlayingCapture: true })
    }
  },
  progress: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onProgress: true }),
      captured: keyOf({ onProgressCapture: true })
    }
  },
  rateChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onRateChange: true }),
      captured: keyOf({ onRateChangeCapture: true })
    }
  },
  reset: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onReset: true }),
      captured: keyOf({ onResetCapture: true })
    }
  },
  scroll: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onScroll: true }),
      captured: keyOf({ onScrollCapture: true })
    }
  },
  seeked: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSeeked: true }),
      captured: keyOf({ onSeekedCapture: true })
    }
  },
  seeking: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSeeking: true }),
      captured: keyOf({ onSeekingCapture: true })
    }
  },
  stalled: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onStalled: true }),
      captured: keyOf({ onStalledCapture: true })
    }
  },
  submit: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSubmit: true }),
      captured: keyOf({ onSubmitCapture: true })
    }
  },
  suspend: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSuspend: true }),
      captured: keyOf({ onSuspendCapture: true })
    }
  },
  timeUpdate: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTimeUpdate: true }),
      captured: keyOf({ onTimeUpdateCapture: true })
    }
  },
  touchCancel: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchCancel: true }),
      captured: keyOf({ onTouchCancelCapture: true })
    }
  },
  touchEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchEnd: true }),
      captured: keyOf({ onTouchEndCapture: true })
    }
  },
  touchMove: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchMove: true }),
      captured: keyOf({ onTouchMoveCapture: true })
    }
  },
  touchStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchStart: true }),
      captured: keyOf({ onTouchStartCapture: true })
    }
  },
  volumeChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onVolumeChange: true }),
      captured: keyOf({ onVolumeChangeCapture: true })
    }
  },
  waiting: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onWaiting: true }),
      captured: keyOf({ onWaitingCapture: true })
    }
  },
  wheel: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onWheel: true }),
      captured: keyOf({ onWheelCapture: true })
    }
  }
};

var topLevelEventsToDispatchConfig = {
  topAbort: eventTypes.abort,
  topBlur: eventTypes.blur,
  topCanPlay: eventTypes.canPlay,
  topCanPlayThrough: eventTypes.canPlayThrough,
  topClick: eventTypes.click,
  topContextMenu: eventTypes.contextMenu,
  topCopy: eventTypes.copy,
  topCut: eventTypes.cut,
  topDoubleClick: eventTypes.doubleClick,
  topDrag: eventTypes.drag,
  topDragEnd: eventTypes.dragEnd,
  topDragEnter: eventTypes.dragEnter,
  topDragExit: eventTypes.dragExit,
  topDragLeave: eventTypes.dragLeave,
  topDragOver: eventTypes.dragOver,
  topDragStart: eventTypes.dragStart,
  topDrop: eventTypes.drop,
  topDurationChange: eventTypes.durationChange,
  topEmptied: eventTypes.emptied,
  topEncrypted: eventTypes.encrypted,
  topEnded: eventTypes.ended,
  topError: eventTypes.error,
  topFocus: eventTypes.focus,
  topInput: eventTypes.input,
  topKeyDown: eventTypes.keyDown,
  topKeyPress: eventTypes.keyPress,
  topKeyUp: eventTypes.keyUp,
  topLoad: eventTypes.load,
  topLoadedData: eventTypes.loadedData,
  topLoadedMetadata: eventTypes.loadedMetadata,
  topLoadStart: eventTypes.loadStart,
  topMouseDown: eventTypes.mouseDown,
  topMouseMove: eventTypes.mouseMove,
  topMouseOut: eventTypes.mouseOut,
  topMouseOver: eventTypes.mouseOver,
  topMouseUp: eventTypes.mouseUp,
  topPaste: eventTypes.paste,
  topPause: eventTypes.pause,
  topPlay: eventTypes.play,
  topPlaying: eventTypes.playing,
  topProgress: eventTypes.progress,
  topRateChange: eventTypes.rateChange,
  topReset: eventTypes.reset,
  topScroll: eventTypes.scroll,
  topSeeked: eventTypes.seeked,
  topSeeking: eventTypes.seeking,
  topStalled: eventTypes.stalled,
  topSubmit: eventTypes.submit,
  topSuspend: eventTypes.suspend,
  topTimeUpdate: eventTypes.timeUpdate,
  topTouchCancel: eventTypes.touchCancel,
  topTouchEnd: eventTypes.touchEnd,
  topTouchMove: eventTypes.touchMove,
  topTouchStart: eventTypes.touchStart,
  topVolumeChange: eventTypes.volumeChange,
  topWaiting: eventTypes.waiting,
  topWheel: eventTypes.wheel
};

for (var type in topLevelEventsToDispatchConfig) {
  topLevelEventsToDispatchConfig[type].dependencies = [type];
}

var ON_CLICK_KEY = keyOf({ onClick: null });
var onClickListeners = {};

var SimpleEventPlugin = {

  eventTypes: eventTypes,

  /**
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case topLevelTypes.topAbort:
      case topLevelTypes.topCanPlay:
      case topLevelTypes.topCanPlayThrough:
      case topLevelTypes.topDurationChange:
      case topLevelTypes.topEmptied:
      case topLevelTypes.topEncrypted:
      case topLevelTypes.topEnded:
      case topLevelTypes.topError:
      case topLevelTypes.topInput:
      case topLevelTypes.topLoad:
      case topLevelTypes.topLoadedData:
      case topLevelTypes.topLoadedMetadata:
      case topLevelTypes.topLoadStart:
      case topLevelTypes.topPause:
      case topLevelTypes.topPlay:
      case topLevelTypes.topPlaying:
      case topLevelTypes.topProgress:
      case topLevelTypes.topRateChange:
      case topLevelTypes.topReset:
      case topLevelTypes.topSeeked:
      case topLevelTypes.topSeeking:
      case topLevelTypes.topStalled:
      case topLevelTypes.topSubmit:
      case topLevelTypes.topSuspend:
      case topLevelTypes.topTimeUpdate:
      case topLevelTypes.topVolumeChange:
      case topLevelTypes.topWaiting:
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case topLevelTypes.topKeyPress:
        // FireFox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case topLevelTypes.topKeyDown:
      case topLevelTypes.topKeyUp:
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case topLevelTypes.topBlur:
      case topLevelTypes.topFocus:
        EventConstructor = SyntheticFocusEvent;
        break;
      case topLevelTypes.topClick:
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case topLevelTypes.topContextMenu:
      case topLevelTypes.topDoubleClick:
      case topLevelTypes.topMouseDown:
      case topLevelTypes.topMouseMove:
      case topLevelTypes.topMouseOut:
      case topLevelTypes.topMouseOver:
      case topLevelTypes.topMouseUp:
        EventConstructor = SyntheticMouseEvent;
        break;
      case topLevelTypes.topDrag:
      case topLevelTypes.topDragEnd:
      case topLevelTypes.topDragEnter:
      case topLevelTypes.topDragExit:
      case topLevelTypes.topDragLeave:
      case topLevelTypes.topDragOver:
      case topLevelTypes.topDragStart:
      case topLevelTypes.topDrop:
        EventConstructor = SyntheticDragEvent;
        break;
      case topLevelTypes.topTouchCancel:
      case topLevelTypes.topTouchEnd:
      case topLevelTypes.topTouchMove:
      case topLevelTypes.topTouchStart:
        EventConstructor = SyntheticTouchEvent;
        break;
      case topLevelTypes.topScroll:
        EventConstructor = SyntheticUIEvent;
        break;
      case topLevelTypes.topWheel:
        EventConstructor = SyntheticWheelEvent;
        break;
      case topLevelTypes.topCopy:
      case topLevelTypes.topCut:
      case topLevelTypes.topPaste:
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (id, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    if (registrationName === ON_CLICK_KEY) {
      var node = ReactMount.getNode(id);
      if (!onClickListeners[id]) {
        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (id, registrationName) {
    if (registrationName === ON_CLICK_KEY) {
      onClickListeners[id].remove();
      delete onClickListeners[id];
    }
  }

};

module.exports = SimpleEventPlugin;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticClipboardEvent
 * @typechecks static-only
 */



var SyntheticEvent = __webpack_require__(121);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticFocusEvent
 * @typechecks static-only
 */



var SyntheticUIEvent = __webpack_require__(155);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticKeyboardEvent
 * @typechecks static-only
 */



var SyntheticUIEvent = __webpack_require__(155);

var getEventCharCode = __webpack_require__(299);
var getEventKey = __webpack_require__(721);
var getEventModifierState = __webpack_require__(293);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventKey
 * @typechecks static-only
 */



var getEventCharCode = __webpack_require__(299);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  'Esc': 'Escape',
  'Spacebar': ' ',
  'Left': 'ArrowLeft',
  'Up': 'ArrowUp',
  'Right': 'ArrowRight',
  'Down': 'ArrowDown',
  'Del': 'Delete',
  'Win': 'OS',
  'Menu': 'ContextMenu',
  'Apps': 'ContextMenu',
  'Scroll': 'ScrollLock',
  'MozPrintableKey': 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticDragEvent
 * @typechecks static-only
 */



var SyntheticMouseEvent = __webpack_require__(218);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticTouchEvent
 * @typechecks static-only
 */



var SyntheticUIEvent = __webpack_require__(155);

var getEventModifierState = __webpack_require__(293);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticWheelEvent
 * @typechecks static-only
 */



var SyntheticMouseEvent = __webpack_require__(218);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX :
    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY :
    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY :
    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SVGDOMPropertyConfig
 */



var DOMProperty = __webpack_require__(150);

var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;

var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

var SVGDOMPropertyConfig = {
  Properties: {
    clipPath: MUST_USE_ATTRIBUTE,
    cx: MUST_USE_ATTRIBUTE,
    cy: MUST_USE_ATTRIBUTE,
    d: MUST_USE_ATTRIBUTE,
    dx: MUST_USE_ATTRIBUTE,
    dy: MUST_USE_ATTRIBUTE,
    fill: MUST_USE_ATTRIBUTE,
    fillOpacity: MUST_USE_ATTRIBUTE,
    fontFamily: MUST_USE_ATTRIBUTE,
    fontSize: MUST_USE_ATTRIBUTE,
    fx: MUST_USE_ATTRIBUTE,
    fy: MUST_USE_ATTRIBUTE,
    gradientTransform: MUST_USE_ATTRIBUTE,
    gradientUnits: MUST_USE_ATTRIBUTE,
    markerEnd: MUST_USE_ATTRIBUTE,
    markerMid: MUST_USE_ATTRIBUTE,
    markerStart: MUST_USE_ATTRIBUTE,
    offset: MUST_USE_ATTRIBUTE,
    opacity: MUST_USE_ATTRIBUTE,
    patternContentUnits: MUST_USE_ATTRIBUTE,
    patternUnits: MUST_USE_ATTRIBUTE,
    points: MUST_USE_ATTRIBUTE,
    preserveAspectRatio: MUST_USE_ATTRIBUTE,
    r: MUST_USE_ATTRIBUTE,
    rx: MUST_USE_ATTRIBUTE,
    ry: MUST_USE_ATTRIBUTE,
    spreadMethod: MUST_USE_ATTRIBUTE,
    stopColor: MUST_USE_ATTRIBUTE,
    stopOpacity: MUST_USE_ATTRIBUTE,
    stroke: MUST_USE_ATTRIBUTE,
    strokeDasharray: MUST_USE_ATTRIBUTE,
    strokeLinecap: MUST_USE_ATTRIBUTE,
    strokeOpacity: MUST_USE_ATTRIBUTE,
    strokeWidth: MUST_USE_ATTRIBUTE,
    textAnchor: MUST_USE_ATTRIBUTE,
    transform: MUST_USE_ATTRIBUTE,
    version: MUST_USE_ATTRIBUTE,
    viewBox: MUST_USE_ATTRIBUTE,
    x1: MUST_USE_ATTRIBUTE,
    x2: MUST_USE_ATTRIBUTE,
    x: MUST_USE_ATTRIBUTE,
    xlinkActuate: MUST_USE_ATTRIBUTE,
    xlinkArcrole: MUST_USE_ATTRIBUTE,
    xlinkHref: MUST_USE_ATTRIBUTE,
    xlinkRole: MUST_USE_ATTRIBUTE,
    xlinkShow: MUST_USE_ATTRIBUTE,
    xlinkTitle: MUST_USE_ATTRIBUTE,
    xlinkType: MUST_USE_ATTRIBUTE,
    xmlBase: MUST_USE_ATTRIBUTE,
    xmlLang: MUST_USE_ATTRIBUTE,
    xmlSpace: MUST_USE_ATTRIBUTE,
    y1: MUST_USE_ATTRIBUTE,
    y2: MUST_USE_ATTRIBUTE,
    y: MUST_USE_ATTRIBUTE
  },
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {
    clipPath: 'clip-path',
    fillOpacity: 'fill-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    gradientTransform: 'gradientTransform',
    gradientUnits: 'gradientUnits',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    patternContentUnits: 'patternContentUnits',
    patternUnits: 'patternUnits',
    preserveAspectRatio: 'preserveAspectRatio',
    spreadMethod: 'spreadMethod',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strokeDasharray: 'stroke-dasharray',
    strokeLinecap: 'stroke-linecap',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    textAnchor: 'text-anchor',
    viewBox: 'viewBox',
    xlinkActuate: 'xlink:actuate',
    xlinkArcrole: 'xlink:arcrole',
    xlinkHref: 'xlink:href',
    xlinkRole: 'xlink:role',
    xlinkShow: 'xlink:show',
    xlinkTitle: 'xlink:title',
    xlinkType: 'xlink:type',
    xmlBase: 'xml:base',
    xmlLang: 'xml:lang',
    xmlSpace: 'xml:space'
  }
};

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
* @providesModule renderSubtreeIntoContainer
*/



var ReactMount = __webpack_require__(50);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMServer
 */



var ReactDefaultInjection = __webpack_require__(435);
var ReactServerRendering = __webpack_require__(728);
var ReactVersion = __webpack_require__(300);

ReactDefaultInjection.inject();

var ReactDOMServer = {
  renderToString: ReactServerRendering.renderToString,
  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
  version: ReactVersion
};

module.exports = ReactDOMServer;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks static-only
 * @providesModule ReactServerRendering
 */


var ReactDefaultBatchingStrategy = __webpack_require__(438);
var ReactElement = __webpack_require__(51);
var ReactInstanceHandles = __webpack_require__(152);
var ReactMarkupChecksum = __webpack_require__(431);
var ReactServerBatchingStrategy = __webpack_require__(729);
var ReactServerRenderingTransaction = __webpack_require__(730);
var ReactUpdates = __webpack_require__(73);

var emptyObject = __webpack_require__(153);
var instantiateReactComponent = __webpack_require__(288);
var invariant = __webpack_require__(20);

/**
 * @param {ReactElement} element
 * @return {string} the HTML markup
 */
function renderToString(element) {
  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;

  var transaction;
  try {
    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);

    var id = ReactInstanceHandles.createReactRootID();
    transaction = ReactServerRenderingTransaction.getPooled(false);

    return transaction.perform(function () {
      var componentInstance = instantiateReactComponent(element, null);
      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
      return ReactMarkupChecksum.addChecksumToMarkup(markup);
    }, null);
  } finally {
    ReactServerRenderingTransaction.release(transaction);
    // Revert to the DOM batching strategy since these two renderers
    // currently share these stateful modules.
    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
  }
}

/**
 * @param {ReactElement} element
 * @return {string} the HTML markup, without the extra React ID and checksum
 * (for generating static pages)
 */
function renderToStaticMarkup(element) {
  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;

  var transaction;
  try {
    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);

    var id = ReactInstanceHandles.createReactRootID();
    transaction = ReactServerRenderingTransaction.getPooled(true);

    return transaction.perform(function () {
      var componentInstance = instantiateReactComponent(element, null);
      return componentInstance.mountComponent(id, transaction, emptyObject);
    }, null);
  } finally {
    ReactServerRenderingTransaction.release(transaction);
    // Revert to the DOM batching strategy since these two renderers
    // currently share these stateful modules.
    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
  }
}

module.exports = {
  renderToString: renderToString,
  renderToStaticMarkup: renderToStaticMarkup
};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactServerBatchingStrategy
 * @typechecks
 */



var ReactServerBatchingStrategy = {
  isBatchingUpdates: false,
  batchedUpdates: function (callback) {
    // Don't do anything here. During the server rendering we don't want to
    // schedule any updates. We will simply ignore them.
  }
};

module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactServerRenderingTransaction
 * @typechecks
 */



var PooledClass = __webpack_require__(107);
var CallbackQueue = __webpack_require__(287);
var Transaction = __webpack_require__(215);

var assign = __webpack_require__(29);
var emptyFunction = __webpack_require__(57);

/**
 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
 * during the performing of the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  close: emptyFunction
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = false;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactIsomorphic
 */



var ReactChildren = __webpack_require__(297);
var ReactComponent = __webpack_require__(446);
var ReactClass = __webpack_require__(445);
var ReactDOMFactories = __webpack_require__(732);
var ReactElement = __webpack_require__(51);
var ReactElementValidator = __webpack_require__(450);
var ReactPropTypes = __webpack_require__(441);
var ReactVersion = __webpack_require__(300);

var assign = __webpack_require__(29);
var onlyChild = __webpack_require__(451);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var React = {

  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: ReactClass.createClass,
  createFactory: createFactory,
  createMixin: function (mixin) {
    // Currently a noop. Will be used to validate and trace mixins.
    return mixin;
  },

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Hook for JSX spread, don't use this for anything else.
  __spread: assign
};

module.exports = React;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMFactories
 * @typechecks static-only
 */



var ReactElement = __webpack_require__(51);
var ReactElementValidator = __webpack_require__(450);

var mapObject = __webpack_require__(733);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @param {string} tag Tag name (e.g. `div`).
 * @private
 */
function createDOMFactory(tag) {
  if (false) {
    return ReactElementValidator.createFactory(tag);
  }
  return ReactElement.createFactory(tag);
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 * This is also accessible via `React.DOM`.
 *
 * @public
 */
var ReactDOMFactories = mapObject({
  a: 'a',
  abbr: 'abbr',
  address: 'address',
  area: 'area',
  article: 'article',
  aside: 'aside',
  audio: 'audio',
  b: 'b',
  base: 'base',
  bdi: 'bdi',
  bdo: 'bdo',
  big: 'big',
  blockquote: 'blockquote',
  body: 'body',
  br: 'br',
  button: 'button',
  canvas: 'canvas',
  caption: 'caption',
  cite: 'cite',
  code: 'code',
  col: 'col',
  colgroup: 'colgroup',
  data: 'data',
  datalist: 'datalist',
  dd: 'dd',
  del: 'del',
  details: 'details',
  dfn: 'dfn',
  dialog: 'dialog',
  div: 'div',
  dl: 'dl',
  dt: 'dt',
  em: 'em',
  embed: 'embed',
  fieldset: 'fieldset',
  figcaption: 'figcaption',
  figure: 'figure',
  footer: 'footer',
  form: 'form',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  head: 'head',
  header: 'header',
  hgroup: 'hgroup',
  hr: 'hr',
  html: 'html',
  i: 'i',
  iframe: 'iframe',
  img: 'img',
  input: 'input',
  ins: 'ins',
  kbd: 'kbd',
  keygen: 'keygen',
  label: 'label',
  legend: 'legend',
  li: 'li',
  link: 'link',
  main: 'main',
  map: 'map',
  mark: 'mark',
  menu: 'menu',
  menuitem: 'menuitem',
  meta: 'meta',
  meter: 'meter',
  nav: 'nav',
  noscript: 'noscript',
  object: 'object',
  ol: 'ol',
  optgroup: 'optgroup',
  option: 'option',
  output: 'output',
  p: 'p',
  param: 'param',
  picture: 'picture',
  pre: 'pre',
  progress: 'progress',
  q: 'q',
  rp: 'rp',
  rt: 'rt',
  ruby: 'ruby',
  s: 's',
  samp: 'samp',
  script: 'script',
  section: 'section',
  select: 'select',
  small: 'small',
  source: 'source',
  span: 'span',
  strong: 'strong',
  style: 'style',
  sub: 'sub',
  summary: 'summary',
  sup: 'sup',
  table: 'table',
  tbody: 'tbody',
  td: 'td',
  textarea: 'textarea',
  tfoot: 'tfoot',
  th: 'th',
  thead: 'thead',
  time: 'time',
  title: 'title',
  tr: 'tr',
  track: 'track',
  u: 'u',
  ul: 'ul',
  'var': 'var',
  video: 'video',
  wbr: 'wbr',

  // SVG
  circle: 'circle',
  clipPath: 'clipPath',
  defs: 'defs',
  ellipse: 'ellipse',
  g: 'g',
  image: 'image',
  line: 'line',
  linearGradient: 'linearGradient',
  mask: 'mask',
  path: 'path',
  pattern: 'pattern',
  polygon: 'polygon',
  polyline: 'polyline',
  radialGradient: 'radialGradient',
  rect: 'rect',
  stop: 'stop',
  svg: 'svg',
  text: 'text',
  tspan: 'tspan'

}, createDOMFactory);

module.exports = ReactDOMFactories;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */
function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }
  var result = {};
  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }
  return result;
}

module.exports = mapObject;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule deprecated
 */



var assign = __webpack_require__(29);
var warning = __webpack_require__(33);

/**
 * This will log a single deprecation notice per function and forward the call
 * on to the new API.
 *
 * @param {string} fnName The name of the function
 * @param {string} newModule The module that fn will exist in
 * @param {string} newPackage The module that fn will exist in
 * @param {*} ctx The context this forwarded call should run in
 * @param {function} fn The function to forward on to
 * @return {function} The function that will warn once and then call fn
 */
function deprecated(fnName, newModule, newPackage, ctx, fn) {
  var warned = false;
  if (false) {
    var newFn = function () {
      process.env.NODE_ENV !== 'production' ? warning(warned,
      // Require examples in this string must be split to prevent React's
      // build tools from mistaking them for real requires.
      // Otherwise the build tools will attempt to build a '%s' module.
      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
      warned = true;
      return fn.apply(ctx, arguments);
    };
    // We need to make sure all properties of the original fn are copied over.
    // In particular, this is needed to support PropTypes
    return assign(newFn, fn);
  }

  return fn;
}

module.exports = deprecated;

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Integrations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(122);
/* unused harmony reexport Severity */
/* unused harmony reexport Status */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_core__ = __webpack_require__(75);
/* unused harmony reexport addGlobalEventProcessor */
/* unused harmony reexport addBreadcrumb */
/* unused harmony reexport captureException */
/* unused harmony reexport captureEvent */
/* unused harmony reexport captureMessage */
/* unused harmony reexport configureScope */
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport getCurrentHub */
/* unused harmony reexport Hub */
/* unused harmony reexport Scope */
/* unused harmony reexport setContext */
/* unused harmony reexport setExtra */
/* unused harmony reexport setExtras */
/* unused harmony reexport setTag */
/* unused harmony reexport setTags */
/* unused harmony reexport setUser */
/* unused harmony reexport withScope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__client__ = __webpack_require__(461);
/* unused harmony reexport BrowserClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sdk__ = __webpack_require__(759);
/* unused harmony reexport defaultIntegrations */
/* unused harmony reexport forceLoad */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__sdk__["a"]; });
/* unused harmony reexport lastEventId */
/* unused harmony reexport onLoad */
/* unused harmony reexport showReportDialog */
/* unused harmony reexport flush */
/* unused harmony reexport close */
/* unused harmony reexport wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version__ = __webpack_require__(465);
/* unused harmony reexport SDK_NAME */
/* unused harmony reexport SDK_VERSION */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__integrations__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transports__ = __webpack_require__(464);
/* unused harmony reexport Transports */










var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
// tslint:disable: no-unsafe-any
var _window = Object(__WEBPACK_IMPORTED_MODULE_6__sentry_utils__["n" /* getGlobalObject */])();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
// tslint:enable: no-unsafe-any
var INTEGRATIONS = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, windowIntegrations, __WEBPACK_IMPORTED_MODULE_2__sentry_core__["d" /* Integrations */], __WEBPACK_IMPORTED_MODULE_7__integrations__);

//# sourceMappingURL=index.js.map

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LogLevel */
/** Console logging verbosity for the SDK. */
var LogLevel;
(function (LogLevel) {
    /** No logs will be generated. */
    LogLevel[LogLevel["None"] = 0] = "None";
    /** Only SDK internal errors will be logged. */
    LogLevel[LogLevel["Error"] = 1] = "Error";
    /** Information useful for debugging the SDK will be logged. */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /** All SDK actions will be logged. */
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Severity; });
/** JSDoc */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));
//# sourceMappingURL=severity.js.map

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SpanStatus */
/** The status of an Span. */
var SpanStatus;
(function (SpanStatus) {
    /** The operation completed successfully. */
    SpanStatus["Ok"] = "ok";
    /** Deadline expired before operation could complete. */
    SpanStatus["DealineExceeded"] = "deadline_exceeded";
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */
    SpanStatus["Unauthenticated"] = "unauthenticated";
    /** 403 Forbidden */
    SpanStatus["PermissionDenied"] = "permission_denied";
    /** 404 Not Found. Some requested entity (file or directory) was not found. */
    SpanStatus["NotFound"] = "not_found";
    /** 429 Too Many Requests */
    SpanStatus["ResourceExhausted"] = "resource_exhausted";
    /** Client specified an invalid argument. 4xx. */
    SpanStatus["InvalidArgument"] = "invalid_argument";
    /** 501 Not Implemented */
    SpanStatus["Unimplemented"] = "unimplemented";
    /** 503 Service Unavailable */
    SpanStatus["Unavailable"] = "unavailable";
    /** Other/generic 5xx. */
    SpanStatus["InternalError"] = "internal_error";
    /** Unknown. Any non-standard HTTP status code. */
    SpanStatus["UnknownError"] = "unknown_error";
    /** The operation was cancelled (typically by the user). */
    SpanStatus["Cancelled"] = "cancelled";
    /** Already exists (409) */
    SpanStatus["AlreadyExists"] = "already_exists";
    /** Operation was rejected because the system is not in a state required for the operation's */
    SpanStatus["FailedPrecondition"] = "failed_precondition";
    /** The operation was aborted, typically due to a concurrency issue. */
    SpanStatus["Aborted"] = "aborted";
    /** Operation was attempted past the valid range. */
    SpanStatus["OutOfRange"] = "out_of_range";
    /** Unrecoverable data loss or corruption */
    SpanStatus["DataLoss"] = "data_loss";
})(SpanStatus || (SpanStatus = {}));
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (SpanStatus) {
    /**
     * Converts a HTTP status code into a {@link SpanStatus}.
     *
     * @param httpStatus The HTTP response status code.
     * @returns The span status or {@link SpanStatus.UnknownError}.
     */
    // tslint:disable-next-line:completed-docs
    function fromHttpCode(httpStatus) {
        if (httpStatus < 400) {
            return SpanStatus.Ok;
        }
        if (httpStatus >= 400 && httpStatus < 500) {
            switch (httpStatus) {
                case 401:
                    return SpanStatus.Unauthenticated;
                case 403:
                    return SpanStatus.PermissionDenied;
                case 404:
                    return SpanStatus.NotFound;
                case 409:
                    return SpanStatus.AlreadyExists;
                case 413:
                    return SpanStatus.FailedPrecondition;
                case 429:
                    return SpanStatus.ResourceExhausted;
                default:
                    return SpanStatus.InvalidArgument;
            }
        }
        if (httpStatus >= 500 && httpStatus < 600) {
            switch (httpStatus) {
                case 501:
                    return SpanStatus.Unimplemented;
                case 503:
                    return SpanStatus.Unavailable;
                case 504:
                    return SpanStatus.DealineExceeded;
                default:
                    return SpanStatus.InternalError;
            }
        }
        return SpanStatus.UnknownError;
    }
    SpanStatus.fromHttpCode = fromHttpCode;
})(SpanStatus || (SpanStatus = {}));
//# sourceMappingURL=span.js.map

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Status; });
/** The status of an event. */
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
})(Status || (Status = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status || (Status = {}));
//# sourceMappingURL=status.js.map

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = captureException;
/* unused harmony export captureMessage */
/* unused harmony export captureEvent */
/* unused harmony export configureScope */
/* unused harmony export addBreadcrumb */
/* unused harmony export setContext */
/* unused harmony export setExtras */
/* unused harmony export setTags */
/* unused harmony export setExtra */
/* unused harmony export setTag */
/* unused harmony export setUser */
/* harmony export (immutable) */ __webpack_exports__["b"] = withScope;
/* unused harmony export _callOnClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(178);


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */])();
    if (hub && hub[method]) {
        // tslint:disable-next-line:no-unsafe-any
        return hub[method].apply(hub, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
function captureException(exception) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, level) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureMessage', message, level, {
        originalException: message,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normailzed.
 */
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normailzed.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 * @param key String key of tag
 * @param value String value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](['_invokeClient', method], args));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export forget */
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
function forget(promise) {
    promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        console.error(e);
    });
}
//# sourceMappingURL=async.js.map

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setPrototypeOf; });
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties); // tslint:disable-line:no-unbound-method
/**
 * setPrototypeOf polyfill using __proto__
 */
function setProtoOf(obj, proto) {
    // @ts-ignore
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!obj.hasOwnProperty(prop)) {
            // @ts-ignore
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolve */
/* unused harmony export relative */
/* unused harmony export normalizePath */
/* unused harmony export isAbsolute */
/* unused harmony export join */
/* unused harmony export dirname */
/* unused harmony export basename */
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
            parts.splice(i, 1);
        }
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        }
        else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        for (; up--; up) {
            parts.unshift('..');
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
/** JSDoc */
function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */
function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
        if (arr[start] !== '') {
            break;
        }
    }
    var end = arr.length - 1;
    for (; end >= 0; end--) {
        if (arr[end] !== '') {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
    // tslint:disable:no-parameter-reassignment
    from = resolve(from).substr(1);
    to = resolve(to).substr(1);
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = '.';
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += '/';
    }
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */
function join() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return normalizePath(args.join('/'));
}
/** JSDoc */
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return '.';
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
}
/** JSDoc */
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) {
        f = f.substr(0, f.length - ext.length);
    }
    return f;
}
//# sourceMappingURL=path.js.map

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromiseBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncpromise__ = __webpack_require__(457);


/** A simple queue that holds promises. */
var PromiseBuffer = /** @class */ (function () {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */
        this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */
    PromiseBuffer.prototype.isReady = function () {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns The original promise.
     */
    PromiseBuffer.prototype.add = function (task) {
        var _this = this;
        if (!this.isReady()) {
            return __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].reject(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* SentryError */]('Not adding Promise due to buffer limit reached.'));
        }
        if (this._buffer.indexOf(task) === -1) {
            this._buffer.push(task);
        }
        task
            .then(function () { return _this.remove(task); })
            .then(null, function () {
            return _this.remove(task).then(null, function () {
                // We have to add this catch here otherwise we have an unhandledPromiseRejection
                // because it's a new Promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    PromiseBuffer.prototype.remove = function (task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */
    PromiseBuffer.prototype.length = function () {
        return this._buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */
    PromiseBuffer.prototype.drain = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */](function (resolve) {
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].all(_this._buffer)
                .then(function () {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            })
                .then(null, function () {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}());

//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addInstrumentationHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__object__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__supports__ = __webpack_require__(458);
/* tslint:disable:only-arrow-functions no-unsafe-any */






var global = Object(__WEBPACK_IMPORTED_MODULE_3__misc__["g" /* getGlobalObject */])();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        default:
            __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* logger */].warn('unknown instrumentation type:', type);
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(handler) {
    // tslint:disable-next-line:strict-type-predicates
    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
        return;
    }
    handlers[handler.type] = handlers[handler.type] || [];
    handlers[handler.type].push(handler.callback);
    instrument(handler.type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __values */](handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* logger */].error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + Object(__WEBPACK_IMPORTED_MODULE_3__misc__["f" /* getFunctionName */])(handler) + "\nError: " + e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global)) {
        return;
    }
    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
        if (!(level in global.console)) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global.console, level, function (originalConsoleLevel) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleLevel) {
                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__supports__["c" /* supportsNativeFetch */])()) {
        return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var commonHandlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData));
            return originalFetch.apply(global, args).then(function (response) {
                triggerHandlers('fetch', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData, { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData, { endTimestamp: Date.now(), error: error }));
                throw error;
            });
        };
    });
}
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in global && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args[1];
            this.__sentry_xhr__ = {
                method: Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(url) && this.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
                this.__sentry_own_request__ = true;
            }
            return originalOpen.apply(this, args);
        };
    });
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var xhr = this; // tslint:disable-line:no-this-assignment
            var commonHandlerData = {
                args: args,
                startTimestamp: Date.now(),
                xhr: xhr,
            };
            triggerHandlers('xhr', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData));
            /**
             * @hidden
             */
            function onreadystatechangeHandler() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        if (xhr.__sentry_xhr__) {
                            xhr.__sentry_xhr__.status_code = xhr.status;
                        }
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData, { endTimestamp: Date.now() }));
                }
            }
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                // if onreadystatechange wasn't actually set by the page on this xhr, we
                // are free to set our own and capture the breadcrumb
                xhr.onreadystatechange = onreadystatechangeHandler;
            }
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__supports__["b" /* supportsHistory */])()) {
        return;
    }
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            return oldOnPopState.apply(this, args);
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global.history, 'pushState', historyReplacementFunction);
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global.history, 'replaceState', historyReplacementFunction);
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global)) {
        return;
    }
    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    global.document.addEventListener('click', domEventHandler('click', triggerHandlers.bind(null, 'dom')), false);
    global.document.addEventListener('keypress', keypressEventHandler(triggerHandlers.bind(null, 'dom')), false);
    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
    ['EventTarget', 'Node'].forEach(function (target) {
        var proto = global[target] && global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                if (fn && fn.handleEvent) {
                    if (eventName === 'click') {
                        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                            return function (event) {
                                domEventHandler('click', triggerHandlers.bind(null, 'dom'))(event);
                                return innerOriginal.call(this, event);
                            };
                        });
                    }
                    if (eventName === 'keypress') {
                        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                            return function (event) {
                                keypressEventHandler(triggerHandlers.bind(null, 'dom'))(event);
                                return innerOriginal.call(this, event);
                            };
                        });
                    }
                }
                else {
                    if (eventName === 'click') {
                        domEventHandler('click', triggerHandlers.bind(null, 'dom'), true)(this);
                    }
                    if (eventName === 'keypress') {
                        keypressEventHandler(triggerHandlers.bind(null, 'dom'))(this);
                    }
                }
                return original.call(this, eventName, fn, options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                var callback = fn;
                try {
                    callback = callback && (callback.__sentry_wrapped__ || callback);
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, callback, options);
            };
        });
    });
}
var debounceDuration = 1000;
var debounceTimer = 0;
var keypressTimeout;
var lastCapturedEvent;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param name the event name (e.g. "click")
 * @param handler function that will be triggered
 * @param debounce decides whether it should wait till another event loop
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function domEventHandler(name, handler, debounce) {
    if (debounce === void 0) { debounce = false; }
    return function (event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        lastCapturedEvent = event;
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        if (debounce) {
            debounceTimer = setTimeout(function () {
                handler({ event: event, name: name });
            });
        }
        else {
            handler({ event: event, name: name });
        }
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @param handler function that will be triggered
 * @returns wrapped keypress events handler
 * @hidden
 */
function keypressEventHandler(handler) {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function (event) {
        var target;
        try {
            target = event.target;
        }
        catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
            return;
        }
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!keypressTimeout) {
            domEventHandler('input', handler)(event);
        }
        clearTimeout(keypressTimeout);
        keypressTimeout = setTimeout(function () {
            keypressTimeout = undefined;
        }, debounceDuration);
    };
}
//# sourceMappingURL=instrument.js.map

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dsn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(301);


/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w\.-]+)(?::(\d+))?\/(.+)/;
/** Error message */
var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */
var Dsn = /** @class */ (function () {
    /** Creates a new Dsn component */
    function Dsn(from) {
        if (typeof from === 'string') {
            this._fromString(from);
        }
        else {
            this._fromComponents(from);
        }
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private _representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */
    Dsn.prototype.toString = function (withPassword) {
        if (withPassword === void 0) { withPassword = false; }
        // tslint:disable-next-line:no-this-assignment
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
    };
    /** Parses a string into this Dsn. */
    Dsn.prototype._fromString = function (str) {
        var match = DSN_REGEX.exec(str);
        if (!match) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE);
        }
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __read */](match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
    };
    /** Maps Dsn components into this instance. */
    Dsn.prototype._fromComponents = function (components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || '';
        this.host = components.host;
        this.port = components.port || '';
        this.path = components.path || '';
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */
    Dsn.prototype._validate = function () {
        var _this = this;
        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
            if (!_this[component]) {
                throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE);
            }
        });
        if (this.protocol !== 'http' && this.protocol !== 'https') {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE);
        }
        if (this.port && isNaN(parseInt(this.port, 10))) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE);
        }
    };
    return Dsn;
}());

//# sourceMappingURL=dsn.js.map

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export API_VERSION */
/* unused harmony export Hub */
/* unused harmony export getMainCarrier */
/* unused harmony export makeMain */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrentHub;
/* unused harmony export getHubFromCarrier */
/* unused harmony export setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scope__ = __webpack_require__(452);



/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be incresed when the global interface
 * changes a and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 30;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */](); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [];
        this._stack.push({ client: client, scope: scope });
    }
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var top = this.getStackTop();
        if (top && top.client && top.client[method]) {
            (_a = top.client)[method].apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args, [top.scope]));
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var stack = this.getStack();
        var parentScope = stack.length > 0 ? stack[stack.length - 1].scope : undefined;
        var scope = __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(parentScope);
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        return this.getStack().pop() !== undefined;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["N" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalHint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["N" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalHint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["N" /* uuid4 */])());
        this._invokeClient('captureEvent', event, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, hint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var top = this.getStackTop();
        if (!top.scope || !top.client) {
            return;
        }
        var _a = (top.client.getOptions && top.client.getOptions()) || {}, _b = _a.beforeBreadcrumb, beforeBreadcrumb = _b === void 0 ? null : _b, _c = _a.maxBreadcrumbs, maxBreadcrumbs = _c === void 0 ? DEFAULT_BREADCRUMBS : _c;
        if (maxBreadcrumbs <= 0) {
            return;
        }
        var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["K" /* timestampWithMs */])();
        var mergedBreadcrumb = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["h" /* consoleSandbox */])(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null) {
            return;
        }
        top.scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setContext = function (name, context) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var top = this.getStackTop();
        if (top.scope && top.client) {
            callback(top.scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client) {
            return null;
        }
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (spanOrSpanContext, forceNoChild) {
        if (forceNoChild === void 0) { forceNoChild = false; }
        return this._callExtensionMethod('startSpan', spanOrSpanContext, forceNoChild);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        // tslint:disable-next-line: strict-type-predicates
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());

/** Returns the global shim registry. */
function getMainCarrier() {
    var carrier = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* getGlobalObject */])();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["x" /* isNodeEnv */])()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Try to read the hub from an active domain, fallback to the registry if one doesnt exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        // We need to use `dynamicRequire` because `require` on it's own will be optimized by webpack.
        // We do not want this to happen, we need to try to `require` the domain node module and fail if we are in browser
        // for example so we do not have to shim it and use `getCurrentHub` universally.
        var domain = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* dynamicRequire */])(module, 'domain');
        var activeDomain = domain.active;
        // If there no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or its an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return true;
    }
    return false;
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return carrier.__SENTRY__.hub;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier) {
        return false;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(459)(module)))

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(37);

var SENTRY_API_VERSION = '7';
/** Helper class to provide urls to different Sentry endpoints. */
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn) {
        this.dsn = dsn;
        this._dsnObject = new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["a" /* Dsn */](dsn);
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Returns a string with auth headers in the url to the store endpoint. */
    API.prototype.getStoreEndpoint = function () {
        return "" + this._getBaseUrl() + this.getStoreEndpointPath();
    };
    /** Returns the store endpoint with auth added in url encoded. */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        var dsn = this._dsnObject;
        var auth = {
            sentry_key: dsn.user,
            sentry_version: SENTRY_API_VERSION,
        };
        // Auth is intentionally sent as part of query string (NOT as custom HTTP header)
        // to avoid preflight CORS requests
        return this.getStoreEndpoint() + "?" + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["M" /* urlEncode */])(auth);
    };
    /** Returns the base path of the url including the port. */
    API.prototype._getBaseUrl = function () {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port;
    };
    /** Returns only the path component for the store endpoint. */
    API.prototype.getStoreEndpointPath = function () {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
    };
    /** Returns an object that can be used in request headers. */
    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
        var dsn = this._dsnObject;
        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
        header.push("sentry_timestamp=" + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["K" /* timestampWithMs */])()); // TODO: This can be removed
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) {
            header.push("sentry_secret=" + dsn.pass);
        }
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', '),
        };
    };
    /** Returns the url to the report dialog endpoint. */
    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
        if (dialogOptions === void 0) { dialogOptions = {}; }
        var dsn = this._dsnObject;
        var endpoint = "" + this._getBaseUrl() + (dsn.path ? "/" + dsn.path : '') + "/api/embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for (var key in dialogOptions) {
            if (key === 'user') {
                if (!dialogOptions.user) {
                    continue;
                }
                if (dialogOptions.user.name) {
                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                }
                if (dialogOptions.user.email) {
                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
                }
            }
            else {
                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
            }
        }
        if (encodedOptions.length) {
            return endpoint + "?" + encodedOptions.join('&');
        }
        return endpoint;
    };
    return API;
}());

//# sourceMappingURL=api.js.map

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__integration__ = __webpack_require__(750);



/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Is the client still processing a call? */
        this._processing = false;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["a" /* Dsn */](options.dsn);
        }
        if (this._isEnabled()) {
            this._integrations = Object(__WEBPACK_IMPORTED_MODULE_2__integration__["a" /* setupIntegrations */])(this._options);
        }
    }
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._processEvent(event, hint, scope); })
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        var promisedEvent = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["z" /* isPrimitive */])(message)
            ? this._getBackend().eventFromMessage("" + message, level, hint)
            : this._getBackend().eventFromException(message, hint);
        promisedEvent
            .then(function (event) { return _this._processEvent(event, hint, scope); })
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._processEvent(event, hint, scope)
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientProcessing(timeout).then(function (status) {
            clearInterval(status.interval);
            return _this._getBackend()
                .getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return status.ready && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegrations = function () {
        return this._integrations || {};
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Waits for the client to be done with processing. */
    BaseClient.prototype._isClientProcessing = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */](function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = 0;
            clearInterval(interval);
            interval = setInterval(function () {
                if (!_this._processing) {
                    resolve({
                        interval: interval,
                        ready: true,
                    });
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        resolve({
                            interval: interval,
                            ready: false,
                        });
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional informartion about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _a = this.getOptions(), environment = _a.environment, release = _a.release, dist = _a.dist, _b = _a.maxValueLength, maxValueLength = _b === void 0 ? 250 : _b;
        var prepared = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event);
        if (prepared.environment === undefined && environment !== undefined) {
            prepared.environment = environment;
        }
        if (prepared.release === undefined && release !== undefined) {
            prepared.release = release;
        }
        if (prepared.dist === undefined && dist !== undefined) {
            prepared.dist = dist;
        }
        if (prepared.message) {
            prepared.message = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["L" /* truncate */])(prepared.message, maxValueLength);
        }
        var exception = prepared.exception && prepared.exception.values && prepared.exception.values[0];
        if (exception && exception.value) {
            exception.value = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["L" /* truncate */])(exception.value, maxValueLength);
        }
        var request = prepared.request;
        if (request && request.url) {
            request.url = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["L" /* truncate */])(request.url, maxValueLength);
        }
        if (prepared.event_id === undefined) {
            prepared.event_id = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["N" /* uuid4 */])();
        }
        this._addIntegrations(prepared.sdk);
        // We prepare the result here with a resolved Event.
        var result = __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (scope) {
            // In case we have a hub we reassign it.
            result = scope.applyToEvent(prepared, hint);
        }
        return result;
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
     */
    BaseClient.prototype._addIntegrations = function (sdkInfo) {
        var integrationsArray = Object.keys(this._integrations);
        if (sdkInfo && integrationsArray.length > 0) {
            sdkInfo.integrations = integrationsArray;
        }
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional informartion about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        if (!this._isEnabled()) {
            return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject('SDK not enabled, will not send event.');
        }
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        if (typeof sampleRate === 'number' && Math.random() > sampleRate) {
            return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject('This event has been sampled, will not send event.');
        }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            _this._prepareEvent(event, scope, hint)
                .then(function (prepared) {
                if (prepared === null) {
                    reject('An event processor returned null, will not send event.');
                    return;
                }
                var finalEvent = prepared;
                try {
                    var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
                    if (isInternalException || !beforeSend) {
                        _this._getBackend().sendEvent(finalEvent);
                        resolve(finalEvent);
                        return;
                    }
                    var beforeSendResult = beforeSend(prepared, hint);
                    // tslint:disable-next-line:strict-type-predicates
                    if (typeof beforeSendResult === 'undefined') {
                        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].error('`beforeSend` method has to return `null` or a valid event.');
                    }
                    else if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["B" /* isThenable */])(beforeSendResult)) {
                        _this._handleAsyncBeforeSend(beforeSendResult, resolve, reject);
                    }
                    else {
                        finalEvent = beforeSendResult;
                        if (finalEvent === null) {
                            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].log('`beforeSend` returned `null`, will not send event.');
                            resolve(null);
                            return;
                        }
                        // From here on we are really async
                        _this._getBackend().sendEvent(finalEvent);
                        resolve(finalEvent);
                    }
                }
                catch (exception) {
                    _this.captureException(exception, {
                        data: {
                            __sentry__: true,
                        },
                        originalException: exception,
                    });
                    reject('`beforeSend` threw an error, will not send event.');
                }
            })
                .then(null, function () {
                reject('`beforeSend` threw an error, will not send event.');
            });
        });
    };
    /**
     * Resolves before send Promise and calls resolve/reject on parent SyncPromise.
     */
    BaseClient.prototype._handleAsyncBeforeSend = function (beforeSend, resolve, reject) {
        var _this = this;
        beforeSend
            .then(function (processedEvent) {
            if (processedEvent === null) {
                reject('`beforeSend` returned `null`, will not send event.');
                return;
            }
            // From here on we are really async
            _this._getBackend().sendEvent(processedEvent);
            resolve(processedEvent);
        })
            .then(null, function (e) {
            reject("beforeSend rejected with " + e);
        });
    };
    return BaseClient;
}());

//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export installedIntegrations */
/* unused harmony export getIntegrationsToSetup */
/* unused harmony export setupIntegration */
/* harmony export (immutable) */ __webpack_exports__["a"] = setupIntegrations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(37);



var installedIntegrations = [];
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
        var pickedIntegrationsNames_1 = [];
        // Leave only unique default integrations, that were not overridden with provided user integrations
        defaultIntegrations.forEach(function (defaultIntegration) {
            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
                integrations.push(defaultIntegration);
                pickedIntegrationsNames_1.push(defaultIntegration.name);
            }
        });
        // Don't add same user integration twice
        userIntegrations.forEach(function (userIntegration) {
            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
                integrations.push(userIntegration);
                pickedIntegrationsNames_1.push(userIntegration.name);
            }
        });
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    else {
        integrations = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](defaultIntegrations);
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a" /* addGlobalEventProcessor */], __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */]);
    installedIntegrations.push(integration.name);
    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    return integrations;
}
//# sourceMappingURL=integration.js.map

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transports_noop__ = __webpack_require__(460);


/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["C" /* logger */].warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new __WEBPACK_IMPORTED_MODULE_1__transports_noop__["a" /* NoopTransport */]();
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* SentryError */]('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* SentryError */]('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        this._transport.sendEvent(event).then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["C" /* logger */].error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initAndBind;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_hub__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(37);


/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instanciate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* logger */].enable();
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_hub__["b" /* getCurrentHub */])().bindClient(new clientClass(options));
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functiontostring__ = __webpack_require__(754);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionToString", function() { return __WEBPACK_IMPORTED_MODULE_0__functiontostring__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inboundfilters__ = __webpack_require__(755);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InboundFilters", function() { return __WEBPACK_IMPORTED_MODULE_1__inboundfilters__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FunctionToString; });
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        originalFunctionToString = Function.prototype.toString;
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = this.__sentry__ ? this.__sentry_original__ : this;
            // tslint:disable-next-line:no-unsafe-any
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InboundFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(37);



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a" /* addGlobalEventProcessor */])(function (event) {
            var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */])();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) {
                    return null;
                }
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].warn("Event dropped due to being internal Sentry Error.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* getEventDescription */])(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* getEventDescription */])(event));
            return true;
        }
        if (this._isBlacklistedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].warn("Event dropped due to being matched by `blacklistUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isWhitelistedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].warn("Event dropped due to not being matched by `whitelistUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (options === void 0) { options = {}; }
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            return ((event &&
                event.exception &&
                event.exception.values &&
                event.exception.values[0] &&
                event.exception.values[0].type === 'SentryError') ||
                false);
        }
        catch (_oO) {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (options === void 0) { options = {}; }
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["w" /* isMatchingPattern */])(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isBlacklistedUrl = function (event, options) {
        if (options === void 0) { options = {}; }
        // TODO: Use Glob instead?
        if (!options.blacklistUrls || !options.blacklistUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.blacklistUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["w" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isWhitelistedUrl = function (event, options) {
        if (options === void 0) { options = {}; }
        // TODO: Use Glob instead?
        if (!options.whitelistUrls || !options.whitelistUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.whitelistUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["w" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            blacklistUrls: __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */]((this._options.blacklistUrls || []), (clientOptions.blacklistUrls || [])),
            ignoreErrors: __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */]((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
            whitelistUrls: __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */]((this._options.whitelistUrls || []), (clientOptions.whitelistUrls || [])),
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].error("Cannot extract message for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* getEventDescription */])(event));
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                var frames_1 = event.stacktrace.frames;
                return (frames_1 && frames_1[frames_1.length - 1].filename) || null;
            }
            if (event.exception) {
                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
                return (frames_2 && frames_2[frames_2.length - 1].filename) || null;
            }
            return null;
        }
        catch (oO) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].error("Cannot extract url for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["l" /* getEventDescription */])(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transports__ = __webpack_require__(464);






/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._options.transportOptions, { dsn: this._options.dsn });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["I" /* supportsFetch */])()) {
            return new __WEBPACK_IMPORTED_MODULE_5__transports__["a" /* FetchTransport */](transportOptions);
        }
        return new __WEBPACK_IMPORTED_MODULE_5__transports__["b" /* XHRTransport */](transportOptions);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        var syntheticException = (hint && hint.syntheticException) || undefined;
        var event = Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromUnknownInput */])(exception, syntheticException, {
            attachStacktrace: this._options.attachStacktrace,
        });
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
            handled: true,
            type: 'generic',
        });
        event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
        if (hint && hint.event_id) {
            event.event_id = hint.event_id;
        }
        return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */].resolve(event);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Info; }
        var syntheticException = (hint && hint.syntheticException) || undefined;
        var event = Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["a" /* eventFromString */])(message, syntheticException, {
            attachStacktrace: this._options.attachStacktrace,
        });
        event.level = level;
        if (hint && hint.event_id) {
            event.event_id = hint.event_id;
        }
        return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */].resolve(event);
    };
    return BrowserBackend;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["b" /* BaseBackend */]));

//# sourceMappingURL=backend.js.map

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(304);




var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* getGlobalObject */])();
/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](FetchTransport, _super);
    function FetchTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Locks transport after receiving 429 response */
        _this._disabledUntil = new Date(Date.now());
        return _this;
    }
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendEvent = function (event) {
        var _this = this;
        if (new Date(Date.now()) < this._disabledUntil) {
            return Promise.reject({
                event: event,
                reason: "Transport locked till " + this._disabledUntil + " due to too many requests.",
                status: 429,
            });
        }
        var defaultOptions = {
            body: JSON.stringify(event),
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["J" /* supportsReferrerPolicy */])() ? 'origin' : ''),
        };
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            global
                .fetch(_this.url, defaultOptions)
                .then(function (response) {
                var status = __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].fromHttpCode(response.status);
                if (status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].Success) {
                    resolve({ status: status });
                    return;
                }
                if (status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].RateLimit) {
                    var now = Date.now();
                    _this._disabledUntil = new Date(now + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["F" /* parseRetryAfterHeader */])(now, response.headers.get('Retry-After')));
                    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].warn("Too many requests, backing off till: " + _this._disabledUntil);
                }
                reject(response);
            })
                .catch(reject);
        }));
    };
    return FetchTransport;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseTransport */]));

//# sourceMappingURL=fetch.js.map

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XHRTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(304);




/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](XHRTransport, _super);
    function XHRTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Locks transport after receiving 429 response */
        _this._disabledUntil = new Date(Date.now());
        return _this;
    }
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendEvent = function (event) {
        var _this = this;
        if (new Date(Date.now()) < this._disabledUntil) {
            return Promise.reject({
                event: event,
                reason: "Transport locked till " + this._disabledUntil + " due to too many requests.",
                status: 429,
            });
        }
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState !== 4) {
                    return;
                }
                var status = __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].fromHttpCode(request.status);
                if (status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].Success) {
                    resolve({ status: status });
                    return;
                }
                if (status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].RateLimit) {
                    var now = Date.now();
                    _this._disabledUntil = new Date(now + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["F" /* parseRetryAfterHeader */])(now, request.getResponseHeader('Retry-After')));
                    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* logger */].warn("Too many requests, backing off till: " + _this._disabledUntil);
                }
                reject(request);
            };
            request.open('POST', _this.url);
            request.send(JSON.stringify(event));
        }));
    };
    return XHRTransport;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseTransport */]));

//# sourceMappingURL=xhr.js.map

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultIntegrations */
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* unused harmony export showReportDialog */
/* unused harmony export lastEventId */
/* unused harmony export forceLoad */
/* unused harmony export onLoad */
/* unused harmony export flush */
/* unused harmony export close */
/* unused harmony export wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(466);





var defaultIntegrations = [
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d" /* Integrations */].InboundFilters(),
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d" /* Integrations */].FunctionToString(),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["TryCatch"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["Breadcrumbs"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["GlobalHandlers"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["LinkedErrors"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["UserAgent"](),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* getGlobalObject */])();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* initAndBind */])(__WEBPACK_IMPORTED_MODULE_2__client__["a" /* BrowserClient */], options);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        options.eventId = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["g" /* getCurrentHub */])().lastEventId();
    }
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["g" /* getCurrentHub */])().getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["g" /* getCurrentHub */])().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function flush(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["g" /* getCurrentHub */])().getClient();
    if (client) {
        return client.flush(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject(false);
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function close(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["g" /* getCurrentHub */])().getClient();
    if (client) {
        return client.close(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
function wrap(fn) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* wrap */])(fn)(); // tslint:disable-line:no-unsafe-any
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalHandlers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(305);






/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /** JSDoc */
        this._global = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["n" /* getGlobalObject */])();
        /** JSDoc */
        this._oldOnErrorHandler = null;
        /** JSDoc */
        this._oldOnUnhandledRejectionHandler = null;
        /** JSDoc */
        this._onErrorHandlerInstalled = false;
        /** JSDoc */
        this._onUnhandledRejectionHandlerInstalled = false;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* logger */].log('Global Handler attached: onerror');
            this._installGlobalOnErrorHandler();
        }
        if (this._options.onunhandledrejection) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* logger */].log('Global Handler attached: onunhandledrejection');
            this._installGlobalOnUnhandledRejectionHandler();
        }
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
        if (this._onErrorHandlerInstalled) {
            return;
        }
        var self = this; // tslint:disable-line:no-this-assignment
        this._oldOnErrorHandler = this._global.onerror;
        this._global.onerror = function (msg, url, line, column, error) {
            var currentHub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])();
            var hasIntegration = currentHub.getIntegration(GlobalHandlers);
            var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
            if (!hasIntegration || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                if (self._oldOnErrorHandler) {
                    return self._oldOnErrorHandler.apply(this, arguments);
                }
                return true;
            }
            var client = currentHub.getClient();
            var event = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["z" /* isPrimitive */])(error)
                ? self._eventFromIncompleteOnError(msg, url, line, column)
                : self._enhanceEventWithInitialFrame(Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromUnknownInput */])(error, undefined, {
                    attachStacktrace: client && client.getOptions().attachStacktrace,
                    rejection: false,
                }), url, line, column);
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
                handled: false,
                type: 'onerror',
            });
            currentHub.captureEvent(event, {
                originalException: error,
            });
            if (self._oldOnErrorHandler) {
                return self._oldOnErrorHandler.apply(this, arguments);
            }
            return true;
        };
        this._onErrorHandlerInstalled = true;
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
        if (this._onUnhandledRejectionHandlerInstalled) {
            return;
        }
        var self = this; // tslint:disable-line:no-this-assignment
        this._oldOnUnhandledRejectionHandler = this._global.onunhandledrejection;
        this._global.onunhandledrejection = function (e) {
            var error = e;
            try {
                error = e && 'reason' in e ? e.reason : e;
            }
            catch (_oO) {
                // no-empty
            }
            var currentHub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])();
            var hasIntegration = currentHub.getIntegration(GlobalHandlers);
            var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
            if (!hasIntegration || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                if (self._oldOnUnhandledRejectionHandler) {
                    return self._oldOnUnhandledRejectionHandler.apply(this, arguments);
                }
                return true;
            }
            var client = currentHub.getClient();
            var event = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["z" /* isPrimitive */])(error)
                ? self._eventFromIncompleteRejection(error)
                : Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromUnknownInput */])(error, undefined, {
                    attachStacktrace: client && client.getOptions().attachStacktrace,
                    rejection: true,
                });
            event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
                handled: false,
                type: 'onunhandledrejection',
            });
            currentHub.captureEvent(event, {
                originalException: error,
            });
            if (self._oldOnUnhandledRejectionHandler) {
                return self._oldOnUnhandledRejectionHandler.apply(this, arguments);
            }
            return true;
        };
        this._onUnhandledRejectionHandlerInstalled = true;
    };
    /**
     * This function creates a stack from an old, error-less onerror handler.
     */
    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
        // If 'message' is ErrorEvent, get real message from inside
        var message = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["t" /* isErrorEvent */])(msg) ? msg.message : msg;
        var name;
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["A" /* isString */])(message)) {
            var groups = message.match(ERROR_TYPES_RE);
            if (groups) {
                name = groups[1];
                message = groups[2];
            }
        }
        var event = {
            exception: {
                values: [
                    {
                        type: name || 'Error',
                        value: message,
                    },
                ],
            },
        };
        return this._enhanceEventWithInitialFrame(event, url, line, column);
    };
    /**
     * This function creates an Event from an TraceKitStackTrace that has part of it missing.
     */
    GlobalHandlers.prototype._eventFromIncompleteRejection = function (error) {
        return {
            exception: {
                values: [
                    {
                        type: 'UnhandledRejection',
                        value: "Non-Error promise rejection captured with value: " + error,
                    },
                ],
            },
        };
    };
    /** JSDoc */
    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
        var filename = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["A" /* isString */])(url) && url.length > 0 ? url : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["o" /* getLocationHref */])();
        if (event.exception.values[0].stacktrace.frames.length === 0) {
            event.exception.values[0].stacktrace.frames.push({
                colno: colno,
                filename: filename,
                function: '?',
                in_app: true,
                lineno: lineno,
            });
        }
        return event;
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TryCatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(305);


/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    function TryCatch() {
        /** JSDoc */
        this._ignoreOnError = 0;
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
    }
    /** JSDoc */
    TryCatch.prototype._wrapTimeFunction = function (original) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var originalCallback = args[0];
            args[0] = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(originalCallback, {
                mechanism: {
                    data: { function: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(original) },
                    handled: true,
                    type: 'instrument',
                },
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapRAF = function (original) {
        return function (callback) {
            return original(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }));
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapEventTarget = function (target) {
        var global = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["n" /* getGlobalObject */])();
        var proto = global[target] && global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    // tslint:disable-next-line:no-unbound-method strict-type-predicates
                    if (typeof fn.handleEvent === 'function') {
                        fn.handleEvent = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(fn.handleEvent.bind(fn), {
                            mechanism: {
                                data: {
                                    function: 'handleEvent',
                                    handler: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(fn),
                                    target: target,
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        });
                    }
                }
                catch (err) {
                    // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }), options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                var callback = fn;
                try {
                    callback = callback && (callback.__sentry_wrapped__ || callback);
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, callback, options);
            };
        });
    };
    /** JSDoc */
    TryCatch.prototype._wrapXHR = function (originalSend) {
        return function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var xhr = this; // tslint:disable-line:no-this-assignment
            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress'];
            xmlHttpRequestProps.forEach(function (prop) {
                if (prop in _this && typeof _this[prop] === 'function') {
                    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(_this, prop, function (original) {
                        return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(original, {
                            mechanism: {
                                data: {
                                    function: prop,
                                    handler: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(original),
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        });
                    });
                }
            });
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(xhr, 'onreadystatechange', function (original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: 'onreadystatechange',
                                handler: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(original),
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    };
                    // If Instrument integration has been called before TryCatch
                    // use it as "before" callback in the wrap and use the original instead
                    if (original.__sentry__ && original.__sentry_original__) {
                        wrapOptions.mechanism.data.handler = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["m" /* getFunctionName */])(original.__sentry_original__);
                        return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(original.__sentry_original__, wrapOptions, original.__sentry_wrapped__);
                    }
                    // Otherwise wrap directly
                    return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* wrap */])(original, wrapOptions);
                });
            }
            return originalSend.apply(this, args);
        };
    };
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        this._ignoreOnError = this._ignoreOnError;
        var global = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["n" /* getGlobalObject */])();
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(global, 'setTimeout', this._wrapTimeFunction.bind(this));
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(global, 'setInterval', this._wrapTimeFunction.bind(this));
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
        if ('XMLHttpRequest' in global) {
            Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* fill */])(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
        }
        [
            'EventTarget',
            'Window',
            'Node',
            'ApplicationCache',
            'AudioTrackList',
            'ChannelMergerNode',
            'CryptoOperation',
            'EventSource',
            'FileReader',
            'HTMLUnknownElement',
            'IDBDatabase',
            'IDBRequest',
            'IDBTransaction',
            'KeyOperation',
            'MediaController',
            'MessagePort',
            'ModalWindow',
            'Notification',
            'SVGElementInstance',
            'Screen',
            'TextTrack',
            'TextTrackCue',
            'TextTrackList',
            'WebSocket',
            'WebSocketWorker',
            'Worker',
            'XMLHttpRequest',
            'XMLHttpRequestEventTarget',
            'XMLHttpRequestUpload',
        ].forEach(this._wrapEventTarget.bind(this));
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumbs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(37);




/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Creates breadcrumbs from console API calls
     */
    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
        var breadcrumb = {
            category: 'console',
            data: {
                extra: {
                    arguments: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["D" /* normalize */])(handlerData.args, 3),
                },
                logger: 'console',
            },
            level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].fromString(handlerData.level),
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["H" /* safeJoin */])(handlerData.args, ' '),
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["H" /* safeJoin */])(handlerData.args.slice(1), ' ') || 'console.assert');
                breadcrumb.data.extra.arguments = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["D" /* normalize */])(handlerData.args.slice(1), 3);
            }
            else {
                // Don't capture a breadcrumb for passed assertions
                return;
            }
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level,
        });
    };
    /**
     * Creates breadcrumbs from DOM API calls
     */
    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
        var target;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["p" /* htmlTreeAsString */])(handlerData.event.target)
                : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["p" /* htmlTreeAsString */])(handlerData.event);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: event,
            name: handlerData.name,
        });
    };
    /**
     * Creates breadcrumbs from XHR API calls
     */
    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
        if (handlerData.endTimestamp) {
            // We only capture complete, non-sentry requests
            if (handlerData.xhr.__sentry_own_request__) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().addBreadcrumb({
                category: 'xhr',
                data: handlerData.xhr.__sentry_xhr__,
                type: 'http',
            }, {
                xhr: handlerData.xhr,
            });
            return;
        }
        // We only capture issued sentry requests
        if (handlerData.xhr.__sentry_own_request__) {
            addSentryBreadcrumb(handlerData.args[0]);
        }
    };
    /**
     * Creates breadcrumbs from fetch API calls
     */
    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
        // We only capture complete fetch requests
        if (!handlerData.endTimestamp) {
            return;
        }
        var client = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().getClient();
        var dsn = client && client.getDsn();
        if (dsn) {
            var filterUrl = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](dsn).getStoreEndpoint();
            // if Sentry key appears in URL, don't capture it as a request
            // but rather as our own 'sentry' type breadcrumb
            if (filterUrl &&
                handlerData.fetchData.url.indexOf(filterUrl) !== -1 &&
                handlerData.fetchData.method === 'POST' &&
                handlerData.args[1] &&
                handlerData.args[1].body) {
                addSentryBreadcrumb(handlerData.args[1].body);
                return;
            }
        }
        if (handlerData.error) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().addBreadcrumb({
                category: 'fetch',
                data: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, handlerData.fetchData, { status_code: handlerData.response.status }),
                level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error,
                type: 'http',
            }, {
                data: handlerData.error,
                input: handlerData.args,
            });
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().addBreadcrumb({
                category: 'fetch',
                data: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, handlerData.fetchData, { status_code: handlerData.response.status }),
                type: 'http',
            }, {
                input: handlerData.args,
                response: handlerData.response,
            });
        }
    };
    /**
     * Creates breadcrumbs from history API calls
     */
    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
        var global = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["n" /* getGlobalObject */])();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["G" /* parseUrl */])(global.location.href);
        var parsedFrom = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["G" /* parseUrl */])(from);
        var parsedTo = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["G" /* parseUrl */])(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom.path) {
            parsedFrom = parsedLoc;
        }
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
            // tslint:disable-next-line:no-parameter-reassignment
            to = parsedTo.relative;
        }
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
            // tslint:disable-next-line:no-parameter-reassignment
            from = parsedFrom.relative;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().addBreadcrumb({
            category: 'navigation',
            data: {
                from: from,
                to: to,
            },
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        var _this = this;
        if (this._options.console) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._consoleBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args));
                },
                type: 'console',
            });
        }
        if (this._options.dom) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._domBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args));
                },
                type: 'dom',
            });
        }
        if (this._options.xhr) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._xhrBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args));
                },
                type: 'xhr',
            });
        }
        if (this._options.fetch) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._fetchBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args));
                },
                type: 'fetch',
            });
        }
        if (this._options.history) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._historyBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](args));
                },
                type: 'history',
            });
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

/**
 * Create a breadcrumb of `sentry` from the events themselves
 */
function addSentryBreadcrumb(serializedData) {
    // There's always something that can go wrong with deserialization...
    try {
        var event_1 = JSON.parse(serializedData);
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().addBreadcrumb({
            category: 'sentry',
            event_id: event_1.event_id,
            level: event_1.level || __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].fromString('error'),
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["l" /* getEventDescription */])(event_1),
        }, {
            event: event_1,
        });
    }
    catch (_oO) {
        __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* logger */].error('Error while adding sentry type breadcrumb');
    }
}
//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracekit__ = __webpack_require__(303);





var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["e" /* addGlobalEventProcessor */])(function (event, hint) {
            var self = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().getIntegration(LinkedErrors);
            if (self) {
                return self._handler(event, hint);
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._handler = function (event, hint) {
        if (!event.exception || !event.exception.values || !hint || !Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["v" /* isInstanceOf */])(hint.originalException, Error)) {
            return event;
        }
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */](linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
        if (stack === void 0) { stack = []; }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["v" /* isInstanceOf */])(error[key], Error) || stack.length + 1 >= this._limit) {
            return stack;
        }
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_4__tracekit__["a" /* computeStackTrace */])(error[key]);
        var exception = Object(__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* exceptionFromStacktrace */])(stacktrace);
        return this._walkErrorTree(error[key], key, __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spread */]([exception], stack));
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserAgent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(37);



var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* getGlobalObject */])();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["e" /* addGlobalEventProcessor */])(function (event) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().getIntegration(UserAgent)) {
                if (!global.navigator || !global.location) {
                    return event;
                }
                // Request Interface: https://docs.sentry.io/development/sdk-dev/event-payloads/request/
                var request = event.request || {};
                request.url = request.url || global.location.href;
                request.headers = request.headers || {};
                request.headers['User-Agent'] = global.navigator.userAgent;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event, { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var defaultClickRejectionStrategy = __webpack_require__(766);

module.exports = function injectTapEventPlugin (strategyOverrides) {
  strategyOverrides = strategyOverrides || {}
  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;

  __webpack_require__(151).injection.injectEventPluginsByName({
    "TapEventPlugin":       __webpack_require__(767)(shouldRejectClick)
  });
};


/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = function(lastTouchEvent, clickTimestamp) {
  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
    return true;
  }
};


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule TapEventPlugin
 * @typechecks static-only
 */



var EventConstants = __webpack_require__(84);
var EventPluginUtils = __webpack_require__(424);
var EventPropagators = __webpack_require__(154);
var SyntheticUIEvent = __webpack_require__(155);
var TouchEventUtils = __webpack_require__(768);
var ViewportMetrics = __webpack_require__(284);

var keyOf = __webpack_require__(85);
var topLevelTypes = EventConstants.topLevelTypes;

var isStartish = EventPluginUtils.isStartish;
var isEndish = EventPluginUtils.isEndish;

var isTouch = function(topLevelType) {
  var touchTypes = [
    topLevelTypes.topTouchCancel,
    topLevelTypes.topTouchEnd,
    topLevelTypes.topTouchStart,
    topLevelTypes.topTouchMove
  ];
  return touchTypes.indexOf(topLevelType) >= 0;
}

/**
 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
 * in order to still be considered a 'tap' event.
 */
var tapMoveThreshold = 10;
var ignoreMouseThreshold = 750;
var startCoords = {x: null, y: null};
var lastTouchEvent = null;

var Axis = {
  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
};

function getAxisCoordOfEvent(axis, nativeEvent) {
  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
  if (singleTouch) {
    return singleTouch[axis.page];
  }
  return axis.page in nativeEvent ?
    nativeEvent[axis.page] :
    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
}

function getDistance(coords, nativeEvent) {
  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
  return Math.pow(
    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
    0.5
  );
}

var touchEvents = [
  topLevelTypes.topTouchStart,
  topLevelTypes.topTouchCancel,
  topLevelTypes.topTouchEnd,
  topLevelTypes.topTouchMove,
];

var dependencies = [
  topLevelTypes.topMouseDown,
  topLevelTypes.topMouseMove,
  topLevelTypes.topMouseUp,
].concat(touchEvents);

var eventTypes = {
  touchTap: {
    phasedRegistrationNames: {
      bubbled: keyOf({onTouchTap: null}),
      captured: keyOf({onTouchTapCapture: null})
    },
    dependencies: dependencies
  }
};

var now = (function() {
  if (Date.now) {
    return Date.now;
  } else {
    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
    return function () {
      return +new Date;
    }
  }
})();

function createTapEventPlugin(shouldRejectClick) {
  return {

    tapMoveThreshold: tapMoveThreshold,

    ignoreMouseThreshold: ignoreMouseThreshold,

    eventTypes: eventTypes,

    /**
     * @param {string} topLevelType Record from `EventConstants`.
     * @param {DOMEventTarget} topLevelTarget The listening component root node.
     * @param {string} topLevelTargetID ID of `topLevelTarget`.
     * @param {object} nativeEvent Native browser event.
     * @return {*} An accumulation of synthetic events.
     * @see {EventPluginHub.extractEvents}
     */
    extractEvents: function(
        topLevelType,
        topLevelTarget,
        topLevelTargetID,
        nativeEvent,
        nativeEventTarget) {

      if (isTouch(topLevelType)) {
        lastTouchEvent = now();
      } else {
        if (shouldRejectClick(lastTouchEvent, now())) {
          return null;
        }
      }

      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
        return null;
      }
      var event = null;
      var distance = getDistance(startCoords, nativeEvent);
      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
        event = SyntheticUIEvent.getPooled(
          eventTypes.touchTap,
          topLevelTargetID,
          nativeEvent,
          nativeEventTarget
        );
      }
      if (isStartish(topLevelType)) {
        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
      } else if (isEndish(topLevelType)) {
        startCoords.x = 0;
        startCoords.y = 0;
      }
      EventPropagators.accumulateTwoPhaseDispatches(event);
      return event;
    }

  };
}

module.exports = createTapEventPlugin;


/***/ }),
/* 768 */
/***/ (function(module, exports) {

/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule TouchEventUtils
 */

var TouchEventUtils = {
  /**
   * Utility function for common case of extracting out the primary touch from a
   * touch event.
   * - `touchEnd` events usually do not have the `touches` property.
   *   http://stackoverflow.com/questions/3666929/
   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
   *
   * @param {Event} nativeEvent Native event that may or may not be a touch.
   * @return {TouchesObject?} an object with pageX and pageY or null.
   */
  extractSingleTouch: function(nativeEvent) {
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;

    return !hasTouches && hasChangedTouches ? changedTouches[0] :
           hasTouches ? touches[0] :
           nativeEvent;
  }
};

module.exports = TouchEventUtils;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(770);

__webpack_require__(501);

__webpack_require__(967);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(771);
__webpack_require__(773);
__webpack_require__(774);
__webpack_require__(775);
__webpack_require__(776);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(779);
__webpack_require__(780);
__webpack_require__(781);
__webpack_require__(782);
__webpack_require__(783);
__webpack_require__(784);
__webpack_require__(785);
__webpack_require__(786);
__webpack_require__(787);
__webpack_require__(789);
__webpack_require__(790);
__webpack_require__(791);
__webpack_require__(792);
__webpack_require__(793);
__webpack_require__(794);
__webpack_require__(795);
__webpack_require__(796);
__webpack_require__(797);
__webpack_require__(798);
__webpack_require__(799);
__webpack_require__(800);
__webpack_require__(801);
__webpack_require__(802);
__webpack_require__(803);
__webpack_require__(804);
__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(807);
__webpack_require__(808);
__webpack_require__(809);
__webpack_require__(810);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
__webpack_require__(815);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(818);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(821);
__webpack_require__(822);
__webpack_require__(823);
__webpack_require__(824);
__webpack_require__(825);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(829);
__webpack_require__(830);
__webpack_require__(831);
__webpack_require__(832);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(835);
__webpack_require__(836);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(839);
__webpack_require__(840);
__webpack_require__(841);
__webpack_require__(842);
__webpack_require__(843);
__webpack_require__(844);
__webpack_require__(845);
__webpack_require__(846);
__webpack_require__(847);
__webpack_require__(848);
__webpack_require__(849);
__webpack_require__(851);
__webpack_require__(852);
__webpack_require__(854);
__webpack_require__(855);
__webpack_require__(856);
__webpack_require__(857);
__webpack_require__(858);
__webpack_require__(859);
__webpack_require__(860);
__webpack_require__(862);
__webpack_require__(863);
__webpack_require__(864);
__webpack_require__(865);
__webpack_require__(866);
__webpack_require__(867);
__webpack_require__(868);
__webpack_require__(869);
__webpack_require__(870);
__webpack_require__(871);
__webpack_require__(872);
__webpack_require__(873);
__webpack_require__(874);
__webpack_require__(327);
__webpack_require__(875);
__webpack_require__(876);
__webpack_require__(485);
__webpack_require__(877);
__webpack_require__(878);
__webpack_require__(879);
__webpack_require__(880);
__webpack_require__(881);
__webpack_require__(488);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(882);
__webpack_require__(883);
__webpack_require__(884);
__webpack_require__(885);
__webpack_require__(886);
__webpack_require__(887);
__webpack_require__(888);
__webpack_require__(889);
__webpack_require__(890);
__webpack_require__(891);
__webpack_require__(892);
__webpack_require__(893);
__webpack_require__(894);
__webpack_require__(895);
__webpack_require__(896);
__webpack_require__(897);
__webpack_require__(898);
__webpack_require__(899);
__webpack_require__(900);
__webpack_require__(901);
__webpack_require__(902);
__webpack_require__(903);
__webpack_require__(904);
__webpack_require__(905);
__webpack_require__(906);
__webpack_require__(907);
__webpack_require__(908);
__webpack_require__(909);
__webpack_require__(910);
__webpack_require__(911);
__webpack_require__(912);
__webpack_require__(913);
__webpack_require__(914);
__webpack_require__(915);
__webpack_require__(916);
__webpack_require__(917);
__webpack_require__(918);
__webpack_require__(919);
__webpack_require__(920);
__webpack_require__(921);
__webpack_require__(922);
__webpack_require__(923);
__webpack_require__(924);
__webpack_require__(925);
__webpack_require__(926);
__webpack_require__(927);
__webpack_require__(928);
__webpack_require__(929);
__webpack_require__(930);
__webpack_require__(931);
__webpack_require__(932);
__webpack_require__(933);
__webpack_require__(934);
__webpack_require__(935);
__webpack_require__(936);
__webpack_require__(937);
__webpack_require__(938);
__webpack_require__(939);
__webpack_require__(940);
__webpack_require__(941);
__webpack_require__(942);
__webpack_require__(943);
__webpack_require__(944);
__webpack_require__(945);
__webpack_require__(946);
__webpack_require__(947);
__webpack_require__(948);
__webpack_require__(949);
__webpack_require__(950);
__webpack_require__(951);
__webpack_require__(952);
__webpack_require__(953);
__webpack_require__(954);
__webpack_require__(955);
__webpack_require__(956);
__webpack_require__(957);
__webpack_require__(958);
__webpack_require__(959);
__webpack_require__(960);
__webpack_require__(961);
__webpack_require__(962);
__webpack_require__(963);
__webpack_require__(964);
__webpack_require__(965);
__webpack_require__(966);
module.exports = __webpack_require__(86);


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(24);
var has = __webpack_require__(58);
var DESCRIPTORS = __webpack_require__(39);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(60);
var META = __webpack_require__(108).KEY;
var $fails = __webpack_require__(28);
var shared = __webpack_require__(220);
var setToStringTag = __webpack_require__(157);
var uid = __webpack_require__(124);
var wks = __webpack_require__(35);
var wksExt = __webpack_require__(468);
var wksDefine = __webpack_require__(307);
var enumKeys = __webpack_require__(772);
var isArray = __webpack_require__(223);
var anObject = __webpack_require__(22);
var isObject = __webpack_require__(30);
var toIObject = __webpack_require__(67);
var toPrimitive = __webpack_require__(87);
var createDesc = __webpack_require__(123);
var _create = __webpack_require__(128);
var gOPNExt = __webpack_require__(471);
var $GOPD = __webpack_require__(68);
var $DP = __webpack_require__(40);
var $keys = __webpack_require__(126);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(129).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(181).f = $propertyIsEnumerable;
  __webpack_require__(222).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(125)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(59)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(126);
var gOPS = __webpack_require__(222);
var pIE = __webpack_require__(181);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(128) });


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(39), 'Object', { defineProperty: __webpack_require__(40).f });


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(39), 'Object', { defineProperties: __webpack_require__(470) });


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(67);
var $getOwnPropertyDescriptor = __webpack_require__(68).f;

__webpack_require__(90)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(44);
var $getPrototypeOf = __webpack_require__(69);

__webpack_require__(90)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(44);
var $keys = __webpack_require__(126);

__webpack_require__(90)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(90)('getOwnPropertyNames', function () {
  return __webpack_require__(471).f;
});


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(30);
var meta = __webpack_require__(108).onFreeze;

__webpack_require__(90)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(30);
var meta = __webpack_require__(108).onFreeze;

__webpack_require__(90)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(30);
var meta = __webpack_require__(108).onFreeze;

__webpack_require__(90)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(30);

__webpack_require__(90)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(30);

__webpack_require__(90)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(30);

__webpack_require__(90)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(4);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(472) });


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(4);
$export($export.S, 'Object', { is: __webpack_require__(788) });


/***/ }),
/* 788 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(4);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(311).set });


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(182);
var test = {};
test[__webpack_require__(35)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(60)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(4);

$export($export.P, 'Function', { bind: __webpack_require__(473) });


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(40).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(39) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(30);
var getPrototypeOf = __webpack_require__(69);
var HAS_INSTANCE = __webpack_require__(35)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(40).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseInt = __webpack_require__(475);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseFloat = __webpack_require__(476);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(24);
var has = __webpack_require__(58);
var cof = __webpack_require__(77);
var inheritIfRequired = __webpack_require__(313);
var toPrimitive = __webpack_require__(87);
var fails = __webpack_require__(28);
var gOPN = __webpack_require__(129).f;
var gOPD = __webpack_require__(68).f;
var dP = __webpack_require__(40).f;
var $trim = __webpack_require__(158).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(128)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(39) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(60)(global, NUMBER, $Number);
}


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toInteger = __webpack_require__(89);
var aNumberValue = __webpack_require__(477);
var repeat = __webpack_require__(314);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(28)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $fails = __webpack_require__(28);
var aNumberValue = __webpack_require__(477);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(4);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(4);
var _isFinite = __webpack_require__(24).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(4);

$export($export.S, 'Number', { isInteger: __webpack_require__(478) });


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(4);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(4);
var isInteger = __webpack_require__(478);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(4);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(4);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseFloat = __webpack_require__(476);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseInt = __webpack_require__(475);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(4);
var log1p = __webpack_require__(479);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(4);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(4);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(4);
var sign = __webpack_require__(315);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(4);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(4);
var $expm1 = __webpack_require__(316);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', { fround: __webpack_require__(480) });


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(4);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(4);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(28)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', { log1p: __webpack_require__(479) });


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', { sign: __webpack_require__(315) });


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(4);
var expm1 = __webpack_require__(316);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(28)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(4);
var expm1 = __webpack_require__(316);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var toAbsoluteIndex = __webpack_require__(127);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var toIObject = __webpack_require__(67);
var toLength = __webpack_require__(41);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(158)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(317)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(318)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $at = __webpack_require__(317)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(4);
var toLength = __webpack_require__(41);
var context = __webpack_require__(320);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(321)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(4);
var context = __webpack_require__(320);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(321)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(314)
});


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(4);
var toLength = __webpack_require__(41);
var context = __webpack_require__(320);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(321)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(61)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(61)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(61)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(61)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(61)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(61)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(61)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(61)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(61)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(61)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(61)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(61)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(61)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(4);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(44);
var toPrimitive = __webpack_require__(87);

$export($export.P + $export.F * __webpack_require__(28)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(4);
var toISOString = __webpack_require__(850);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(28);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(60)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(35)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(59)(proto, TO_PRIMITIVE, __webpack_require__(853));


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(87);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(4);

$export($export.S, 'Array', { isArray: __webpack_require__(223) });


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(76);
var $export = __webpack_require__(4);
var toObject = __webpack_require__(44);
var call = __webpack_require__(481);
var isArrayIter = __webpack_require__(322);
var toLength = __webpack_require__(41);
var createProperty = __webpack_require__(323);
var getIterFn = __webpack_require__(324);

$export($export.S + $export.F * !__webpack_require__(225)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var createProperty = __webpack_require__(323);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(28)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(4);
var toIObject = __webpack_require__(67);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(180) != Object || !__webpack_require__(78)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var html = __webpack_require__(310);
var cof = __webpack_require__(77);
var toAbsoluteIndex = __webpack_require__(127);
var toLength = __webpack_require__(41);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(28)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var aFunction = __webpack_require__(47);
var toObject = __webpack_require__(44);
var fails = __webpack_require__(28);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(78)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $forEach = __webpack_require__(91)(0);
var STRICT = __webpack_require__(78)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(30);
var isArray = __webpack_require__(223);
var SPECIES = __webpack_require__(35)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $map = __webpack_require__(91)(1);

$export($export.P + $export.F * !__webpack_require__(78)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $filter = __webpack_require__(91)(2);

$export($export.P + $export.F * !__webpack_require__(78)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $some = __webpack_require__(91)(3);

$export($export.P + $export.F * !__webpack_require__(78)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $every = __webpack_require__(91)(4);

$export($export.P + $export.F * !__webpack_require__(78)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $reduce = __webpack_require__(482);

$export($export.P + $export.F * !__webpack_require__(78)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $reduce = __webpack_require__(482);

$export($export.P + $export.F * !__webpack_require__(78)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $indexOf = __webpack_require__(221)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(78)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toIObject = __webpack_require__(67);
var toInteger = __webpack_require__(89);
var toLength = __webpack_require__(41);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(78)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(4);

$export($export.P, 'Array', { copyWithin: __webpack_require__(483) });

__webpack_require__(109)('copyWithin');


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(4);

$export($export.P, 'Array', { fill: __webpack_require__(326) });

__webpack_require__(109)('fill');


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(4);
var $find = __webpack_require__(91)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(109)(KEY);


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(4);
var $find = __webpack_require__(91)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(109)(KEY);


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(130)('Array');


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(24);
var inheritIfRequired = __webpack_require__(313);
var dP = __webpack_require__(40).f;
var gOPN = __webpack_require__(129).f;
var isRegExp = __webpack_require__(224);
var $flags = __webpack_require__(226);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(39) && (!CORRECT_NEW || __webpack_require__(28)(function () {
  re2[__webpack_require__(35)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(60)(global, 'RegExp', $RegExp);
}

__webpack_require__(130)('RegExp');


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(485);
var anObject = __webpack_require__(22);
var $flags = __webpack_require__(226);
var DESCRIPTORS = __webpack_require__(39);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(60)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(28)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(227)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(227)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(227)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(227)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(224);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(125);
var global = __webpack_require__(24);
var ctx = __webpack_require__(76);
var classof = __webpack_require__(182);
var $export = __webpack_require__(4);
var isObject = __webpack_require__(30);
var aFunction = __webpack_require__(47);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(132);
var speciesConstructor = __webpack_require__(228);
var task = __webpack_require__(328).set;
var microtask = __webpack_require__(329)();
var newPromiseCapabilityModule = __webpack_require__(330);
var perform = __webpack_require__(486);
var promiseResolve = __webpack_require__(487);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(35)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(133)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(157)($Promise, PROMISE);
__webpack_require__(130)(PROMISE);
Wrapper = __webpack_require__(86)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(225)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(492);
var validate = __webpack_require__(160);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(229)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $typed = __webpack_require__(230);
var buffer = __webpack_require__(331);
var anObject = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(127);
var toLength = __webpack_require__(41);
var isObject = __webpack_require__(30);
var ArrayBuffer = __webpack_require__(24).ArrayBuffer;
var speciesConstructor = __webpack_require__(228);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(28)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(130)(ARRAY_BUFFER);


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
$export($export.G + $export.W + $export.F * !__webpack_require__(230).ABV, {
  DataView: __webpack_require__(331).DataView
});


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(4);
var aFunction = __webpack_require__(47);
var anObject = __webpack_require__(22);
var rApply = (__webpack_require__(24).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(28)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(4);
var create = __webpack_require__(128);
var aFunction = __webpack_require__(47);
var anObject = __webpack_require__(22);
var isObject = __webpack_require__(30);
var fails = __webpack_require__(28);
var bind = __webpack_require__(473);
var rConstruct = (__webpack_require__(24).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(40);
var $export = __webpack_require__(4);
var anObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(87);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(28)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(4);
var gOPD = __webpack_require__(68).f;
var anObject = __webpack_require__(22);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(4);
var anObject = __webpack_require__(22);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(319)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(68);
var getPrototypeOf = __webpack_require__(69);
var has = __webpack_require__(58);
var $export = __webpack_require__(4);
var isObject = __webpack_require__(30);
var anObject = __webpack_require__(22);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(68);
var $export = __webpack_require__(4);
var anObject = __webpack_require__(22);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(4);
var getProto = __webpack_require__(69);
var anObject = __webpack_require__(22);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(4);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(4);
var anObject = __webpack_require__(22);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(4);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(494) });


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(4);
var anObject = __webpack_require__(22);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(40);
var gOPD = __webpack_require__(68);
var getPrototypeOf = __webpack_require__(69);
var has = __webpack_require__(58);
var $export = __webpack_require__(4);
var createDesc = __webpack_require__(123);
var anObject = __webpack_require__(22);
var isObject = __webpack_require__(30);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(4);
var setProto = __webpack_require__(311);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(4);
var $includes = __webpack_require__(221)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(109)('includes');


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(4);
var flattenIntoArray = __webpack_require__(495);
var toObject = __webpack_require__(44);
var toLength = __webpack_require__(41);
var aFunction = __webpack_require__(47);
var arraySpeciesCreate = __webpack_require__(325);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(109)('flatMap');


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(4);
var flattenIntoArray = __webpack_require__(495);
var toObject = __webpack_require__(44);
var toLength = __webpack_require__(41);
var toInteger = __webpack_require__(89);
var arraySpeciesCreate = __webpack_require__(325);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(109)('flatten');


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(4);
var $at = __webpack_require__(317)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(4);
var $pad = __webpack_require__(496);
var userAgent = __webpack_require__(332);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(4);
var $pad = __webpack_require__(496);
var userAgent = __webpack_require__(332);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(158)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(158)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(4);
var defined = __webpack_require__(88);
var toLength = __webpack_require__(41);
var isRegExp = __webpack_require__(224);
var getFlags = __webpack_require__(226);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(319)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(307)('asyncIterator');


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(307)('observable');


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(4);
var ownKeys = __webpack_require__(494);
var toIObject = __webpack_require__(67);
var gOPD = __webpack_require__(68);
var createProperty = __webpack_require__(323);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(4);
var $values = __webpack_require__(497)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(4);
var $entries = __webpack_require__(497)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(44);
var aFunction = __webpack_require__(47);
var $defineProperty = __webpack_require__(40);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(39) && $export($export.P + __webpack_require__(231), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(44);
var aFunction = __webpack_require__(47);
var $defineProperty = __webpack_require__(40);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(39) && $export($export.P + __webpack_require__(231), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(44);
var toPrimitive = __webpack_require__(87);
var getPrototypeOf = __webpack_require__(69);
var getOwnPropertyDescriptor = __webpack_require__(68).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(39) && $export($export.P + __webpack_require__(231), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(44);
var toPrimitive = __webpack_require__(87);
var getPrototypeOf = __webpack_require__(69);
var getOwnPropertyDescriptor = __webpack_require__(68).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(39) && $export($export.P + __webpack_require__(231), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(4);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(498)('Map') });


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(4);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(498)('Set') });


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(232)('Map');


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(232)('Set');


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(232)('WeakMap');


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(232)('WeakSet');


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(233)('Map');


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(233)('Set');


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(233)('WeakMap');


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(233)('WeakSet');


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(4);

$export($export.G, { global: __webpack_require__(24) });


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(4);

$export($export.S, 'System', { global: __webpack_require__(24) });


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(4);
var cof = __webpack_require__(77);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);
var scale = __webpack_require__(500);
var fround = __webpack_require__(480);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', { scale: __webpack_require__(500) });


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(4);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(4);
var core = __webpack_require__(86);
var global = __webpack_require__(24);
var speciesConstructor = __webpack_require__(228);
var promiseResolve = __webpack_require__(487);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(4);
var newPromiseCapability = __webpack_require__(330);
var perform = __webpack_require__(486);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(22);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(22);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(22);
var getPrototypeOf = __webpack_require__(69);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(490);
var from = __webpack_require__(499);
var metadata = __webpack_require__(101);
var anObject = __webpack_require__(22);
var getPrototypeOf = __webpack_require__(69);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(22);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(22);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(22);
var getPrototypeOf = __webpack_require__(69);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(22);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(101);
var anObject = __webpack_require__(22);
var aFunction = __webpack_require__(47);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(4);
var microtask = __webpack_require__(329)();
var process = __webpack_require__(24).process;
var isNode = __webpack_require__(77)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(4);
var global = __webpack_require__(24);
var core = __webpack_require__(86);
var microtask = __webpack_require__(329)();
var OBSERVABLE = __webpack_require__(35)('observable');
var aFunction = __webpack_require__(47);
var anObject = __webpack_require__(22);
var anInstance = __webpack_require__(131);
var redefineAll = __webpack_require__(133);
var hide = __webpack_require__(59);
var forOf = __webpack_require__(132);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(130)('Observable');


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(24);
var $export = __webpack_require__(4);
var userAgent = __webpack_require__(332);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $task = __webpack_require__(328);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(327);
var getKeys = __webpack_require__(126);
var redefine = __webpack_require__(60);
var global = __webpack_require__(24);
var hide = __webpack_require__(59);
var Iterators = __webpack_require__(159);
var wks = __webpack_require__(35);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(968);
module.exports = __webpack_require__(86).RegExp.escape;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(4);
var $re = __webpack_require__(969)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppContainer__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_CoursioAppContainer__ = __webpack_require__(2061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Route_Dashboard__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Route_MediaLibrary__ = __webpack_require__(2102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_MediaLibrary_MediaLibraryUpload__ = __webpack_require__(2104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Route_MediaLibrary_MediaLibraryDetailContainer__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Route_TasksContainer__ = __webpack_require__(2107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Route_QuizContainer__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Route_StatisticsContainer__ = __webpack_require__(2126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Route_NotesContainer__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Route_Students__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_StudentDetailContainer__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_containers_StudentExportContainer__ = __webpack_require__(2157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_containers_InvitationDetailContainer__ = __webpack_require__(2158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Route_Groups__ = __webpack_require__(2160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Route_Group_Detail__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Route_Courses__ = __webpack_require__(2161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Route_Course_Detail__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__containers_CourseDetailContainer__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Route_SubAccounts__ = __webpack_require__(2186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_Store_StripeCompletePurchase__ = __webpack_require__(2187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_Store_StripeCancelPurchase__ = __webpack_require__(2188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_TaC_TaC__ = __webpack_require__(2189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_Route_InviteWizard__ = __webpack_require__(2190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_Route_Communication__ = __webpack_require__(2192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_Route_StoreContainer__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_containers_Store_StoreItem__ = __webpack_require__(2296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_Route_Discount_DiscountDetailContainer__ = __webpack_require__(2304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_Route_Discounts__ = __webpack_require__(2307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_Route_Invitation_AcceptInvitationContainer__ = __webpack_require__(2308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_Route_Gift_AcceptGiftContainer__ = __webpack_require__(2310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_components_Route_Bundle_BundleDetailContainer__ = __webpack_require__(2316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_components_Route_Bundles__ = __webpack_require__(2318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_components_Route_Transactions__ = __webpack_require__(2319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_components_Route_Transaction_Detail__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_components_Route_About__ = __webpack_require__(2320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_components_Route_Help__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_components_Route_Course_CoursePreviewContainer__ = __webpack_require__(2322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_components_Route_NotFound__ = __webpack_require__(2342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_components_Route_CoursioError__ = __webpack_require__(2343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_components_Route_CoursioDown__ = __webpack_require__(2344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_components_Route_Page__ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_components_Route_ForgotPassword__ = __webpack_require__(2422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_components_Route_RestorePassword__ = __webpack_require__(2423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_components_Route_Login__ = __webpack_require__(2425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_components_Route_LoggedIn__ = __webpack_require__(2426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_components_Route_KlarnaConfirmationContainer__ = __webpack_require__(2427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_components_Route_Logout__ = __webpack_require__(2429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_components_Route_Incarnate__ = __webpack_require__(2430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_components_Route_Wakeup__ = __webpack_require__(2432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_containers_Checkout__ = __webpack_require__(2433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_react_router__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_i18n_sv_SE__ = __webpack_require__(2436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_i18n_en_US__ = __webpack_require__(2437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_components_IntlProvider__ = __webpack_require__(2438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_Config__ = __webpack_require__(52);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Settings from 'components/Route/Settings';
// import StoreDetailPurchase from 'components/Route/Store/DetailPurchase';
var messages={en_US:__WEBPACK_IMPORTED_MODULE_55_i18n_en_US__["a" /* default */],sv_SE:__WEBPACK_IMPORTED_MODULE_54_i18n_sv_SE__["a" /* default */]};var requireLogin=function requireLogin(nextState,replace,callback){if(!__WEBPACK_IMPORTED_MODULE_58_stores__["b" /* AuthStore */].isAuthenticated()){replace({pathname:"/login",query:{nextPath:nextState.location.pathname}});}callback();};var GApackageHandler=function GApackageHandler(nextState,replace,callback){var _nextState$params=nextState.params,username=_nextState$params.username,slug=_nextState$params.slug;replace({pathname:"/store/"+username+"/package/"+slug,query:{nextPath:nextState.location.pathname}});callback();};var isNumeric=function isNumeric(value){return!isNaN(parseFloat(value))&&isFinite(value);};var Landing=void 0;var domain=/:\/\/([^\/]+)/.exec(window.location.href)[1];var subDomain=void 0;if("//"+domain!==__WEBPACK_IMPORTED_MODULE_59_Config__["a" /* default */].thisHost){subDomain=domain.split(".").shift();}if(subDomain&&!isNumeric(subDomain)){Landing=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["a" /* IndexRoute */],{component:__WEBPACK_IMPORTED_MODULE_26_components_Route_StoreContainer__["a" /* default */]});}else{Landing=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["a" /* IndexRoute */],{onEnter:requireLogin,component:__WEBPACK_IMPORTED_MODULE_3_components_Route_Dashboard__["a" /* default */]});}var routes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_1_components_AppContainer__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/checkout/:username/:id/:type",component:__WEBPACK_IMPORTED_MODULE_51_containers_Checkout__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_1_components_AppContainer__["a" /* default */]},Landing,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/account/login",component:__WEBPACK_IMPORTED_MODULE_3_components_Route_Dashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/dashboard",component:__WEBPACK_IMPORTED_MODULE_3_components_Route_Dashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/settings",getComponent:function getComponent(location,cb){__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 2444)).then(function(module){return cb(null,module.default);});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/tasks(/:courseId)(/:userId)(/:taskId)",component:__WEBPACK_IMPORTED_MODULE_7_components_Route_TasksContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/quiz(/:courseId)(/:userId)(/:taskId)",component:__WEBPACK_IMPORTED_MODULE_8_components_Route_QuizContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/communication",component:__WEBPACK_IMPORTED_MODULE_25_components_Route_Communication__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/media-library/:directoryId",component:__WEBPACK_IMPORTED_MODULE_4_components_Route_MediaLibrary__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/media-library/:directoryId/upload",component:__WEBPACK_IMPORTED_MODULE_5_components_MediaLibrary_MediaLibraryUpload__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/media-library/:directoryId/:fileId",component:__WEBPACK_IMPORTED_MODULE_6_components_Route_MediaLibrary_MediaLibraryDetailContainer__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/media-library",component:__WEBPACK_IMPORTED_MODULE_4_components_Route_MediaLibrary__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/media-library/upload",component:__WEBPACK_IMPORTED_MODULE_5_components_MediaLibrary_MediaLibraryUpload__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/media-library/:fileId",component:__WEBPACK_IMPORTED_MODULE_6_components_Route_MediaLibrary_MediaLibraryDetailContainer__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/students",component:__WEBPACK_IMPORTED_MODULE_11_components_Route_Students__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/student/export",component:__WEBPACK_IMPORTED_MODULE_13_containers_StudentExportContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/student/:studentId",component:__WEBPACK_IMPORTED_MODULE_12__containers_StudentDetailContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/invitation-detail/:invitationId",component:__WEBPACK_IMPORTED_MODULE_14_containers_InvitationDetailContainer__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/invitation/:hash",component:__WEBPACK_IMPORTED_MODULE_30_components_Route_Invitation_AcceptInvitationContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/gift(/:giftCode)",component:__WEBPACK_IMPORTED_MODULE_31_components_Route_Gift_AcceptGiftContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/groups",component:__WEBPACK_IMPORTED_MODULE_15_components_Route_Groups__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/group/:groupId",component:__WEBPACK_IMPORTED_MODULE_16_components_Route_Group_Detail__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/courses",component:__WEBPACK_IMPORTED_MODULE_17_components_Route_Courses__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/course/:courseId",component:__WEBPACK_IMPORTED_MODULE_19__containers_CourseDetailContainer__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/sub-accounts",components:__WEBPACK_IMPORTED_MODULE_20_components_Route_SubAccounts__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/discounts",component:__WEBPACK_IMPORTED_MODULE_29_components_Route_Discounts__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/discount/:discountId",component:__WEBPACK_IMPORTED_MODULE_28_components_Route_Discount_DiscountDetailContainer__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/bundles",component:__WEBPACK_IMPORTED_MODULE_33_components_Route_Bundles__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/bundle/:bundleId",component:__WEBPACK_IMPORTED_MODULE_32_components_Route_Bundle_BundleDetailContainer__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/transactions",component:__WEBPACK_IMPORTED_MODULE_34_components_Route_Transactions__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/transaction/:transactionId",component:__WEBPACK_IMPORTED_MODULE_35_components_Route_Transaction_Detail__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:GApackageHandler,path:"/store/package/:username/:slug(/:purchase)",component:__WEBPACK_IMPORTED_MODULE_27_containers_Store_StoreItem__["a" /* default */],type:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/store/:username/package/:slug(/:purchase)",component:__WEBPACK_IMPORTED_MODULE_27_containers_Store_StoreItem__["a" /* default */],type:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/store/:username/:slug(/:purchase)",component:__WEBPACK_IMPORTED_MODULE_27_containers_Store_StoreItem__["a" /* default */],type:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/store(/:store)",component:__WEBPACK_IMPORTED_MODULE_26_components_Route_StoreContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/statistics",component:__WEBPACK_IMPORTED_MODULE_9_components_Route_StatisticsContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/notes",component:__WEBPACK_IMPORTED_MODULE_10_components_Route_NotesContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/checkout/stripe/success",component:__WEBPACK_IMPORTED_MODULE_21_components_Store_StripeCompletePurchase__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/checkout/stripe/cancelled",component:__WEBPACK_IMPORTED_MODULE_22_components_Store_StripeCancelPurchase__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/klarna/swish/done",component:__WEBPACK_IMPORTED_MODULE_21_components_Store_StripeCompletePurchase__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/terms-and-conditions",component:__WEBPACK_IMPORTED_MODULE_23__components_TaC_TaC__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/invite",component:__WEBPACK_IMPORTED_MODULE_24_components_Route_InviteWizard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/klarna/confirm/:transactionId",component:__WEBPACK_IMPORTED_MODULE_47_components_Route_KlarnaConfirmationContainer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/about/:username/:page",component:__WEBPACK_IMPORTED_MODULE_36_components_Route_About__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/help",component:__WEBPACK_IMPORTED_MODULE_37_components_Route_Help__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/login",component:__WEBPACK_IMPORTED_MODULE_45_components_Route_Login__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/logged-in",component:__WEBPACK_IMPORTED_MODULE_46_components_Route_LoggedIn__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/forgot-password",component:__WEBPACK_IMPORTED_MODULE_43_components_Route_ForgotPassword__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/restore-password/:key",component:__WEBPACK_IMPORTED_MODULE_44_components_Route_RestorePassword__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/logout",onEnter:requireLogin,component:__WEBPACK_IMPORTED_MODULE_48_components_Route_Logout__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/incarnate",component:__WEBPACK_IMPORTED_MODULE_49_components_Route_Incarnate__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/wakeup",component:__WEBPACK_IMPORTED_MODULE_50_components_Route_Wakeup__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/course/:ownerSlug/:courseSlug",component:__WEBPACK_IMPORTED_MODULE_38_components_Route_Course_CoursePreviewContainer__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/course/:ownerSlug/:courseSlug/:sectionSlug/:pageSlug/:pageId",component:__WEBPACK_IMPORTED_MODULE_42_components_Route_Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/builder/course/:ownerSlug/:courseSlug/:sectionSlug/:pageSlug",component:__WEBPACK_IMPORTED_MODULE_42_components_Route_Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/course/:ownerSlug/:courseSlug/:sectionSlug/:pageSlug",component:__WEBPACK_IMPORTED_MODULE_42_components_Route_Page__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{onEnter:requireLogin,path:"/course/:ownerSlug/:courseSlug/:pageId",component:__WEBPACK_IMPORTED_MODULE_42_components_Route_Page__["a" /* default */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/coursio-error",component:__WEBPACK_IMPORTED_MODULE_40_components_Route_CoursioError__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"/down",component:__WEBPACK_IMPORTED_MODULE_41_components_Route_CoursioDown__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["b" /* Route */],{path:"*",component:__WEBPACK_IMPORTED_MODULE_39_components_Route_NotFound__["a" /* default */]})));var AppWrapper=function(_mixin){_inherits(AppWrapper,_mixin);function AppWrapper(){_classCallCheck(this,AppWrapper);return _possibleConstructorReturn(this,(AppWrapper.__proto__||Object.getPrototypeOf(AppWrapper)).apply(this,arguments));}_createClass(AppWrapper,[{key:"listenToStores",value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_58_stores__["b" /* AuthStore */]);}// shouldComponentUpdate(nextProps, nextState) {
//   return false;
// }
},{key:"render",value:function render(){var locale=this.state.locale;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_56_components_IntlProvider__["a" /* default */],Object.assign({locale:locale},messages[locale]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52_react_router__["c" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_53_helpers__["a" /* history */]},routes));}}]);return AppWrapper;}(Object(__WEBPACK_IMPORTED_MODULE_57_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_57_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));AppWrapper.displayName="AppWrapper";/* harmony default export */ __webpack_exports__["a"] = (AppWrapper);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_App__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* global __PRODUCTION */try{var messages=__webpack_require__(377);Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["addMessages"])(messages);}catch(e){// console.log(e)
// Nothing going on
}var AppContainer=function(_mixin){_inherits(AppContainer,_mixin);function AppContainer(){_classCallCheck(this,AppContainer);return _possibleConstructorReturn(this,(AppContainer.__proto__||Object.getPrototypeOf(AppContainer)).apply(this,arguments));}_createClass(AppContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores__["b" /* AuthStore */],'auth');this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores__["a" /* AppStore */],'app');}},{key:'render',value:function render(){var _state$auth=this.state.auth,loggedIn=_state$auth.loggedIn,locale=_state$auth.locale;var _state$app=this.state.app,message=_state$app.message,reportBug=_state$app.reportBug;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_App__["a" /* default */],Object.assign({},this.props,{locale:locale,loggedIn:loggedIn,message:message,reportBug:reportBug}),this.props.children);}}]);return AppContainer;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));AppContainer.displayName='AppContainer';AppContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};AppContainer.childContextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};AppContainer.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (AppContainer);

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var Reflux = {
    version: {
        "reflux-core": "0.3.0"
    }
};

Reflux.ActionMethods = __webpack_require__(502);

Reflux.ListenerMethods = __webpack_require__(134);

Reflux.PublisherMethods = __webpack_require__(335);

Reflux.StoreMethods = __webpack_require__(505);

Reflux.createAction = __webpack_require__(976);

Reflux.createStore = __webpack_require__(504);

var maker = __webpack_require__(503).staticJoinCreator;

Reflux.joinTrailing = Reflux.all = maker("last"); // Reflux.all alias for backward compatibility

Reflux.joinLeading = maker("first");

Reflux.joinStrict = maker("strict");

Reflux.joinConcat = maker("all");

var _ = Reflux.utils = __webpack_require__(92);

Reflux.EventEmitter = _.EventEmitter;

Reflux.Promise = _.Promise;

/**
 * Convenience function for creating a set of actions
 *
 * @param definitions the definitions for the actions to be created
 * @returns an object with actions of corresponding action names
 */
Reflux.createActions = (function () {
    var reducer = function reducer(definitions, actions) {
        Object.keys(definitions).forEach(function (actionName) {
            var val = definitions[actionName];
            actions[actionName] = Reflux.createAction(val);
        });
    };

    return function (definitions) {
        var actions = {};
        if (definitions instanceof Array) {
            definitions.forEach(function (val) {
                if (_.isObject(val)) {
                    reducer(val, actions);
                } else {
                    actions[val] = Reflux.createAction(val);
                }
            });
        } else {
            reducer(definitions, actions);
        }
        return actions;
    };
})();

/**
 * Sets the eventmitter that Reflux uses
 */
Reflux.setEventEmitter = function (ctx) {
    Reflux.EventEmitter = _.EventEmitter = ctx;
};

/**
 * Sets the method used for deferring actions and stores
 */
Reflux.nextTick = function (nextTick) {
    _.nextTick = nextTick;
};

Reflux.use = function (pluginCb) {
    pluginCb(Reflux);
};

/**
 * Provides the set of created actions and stores for introspection
 */
/*eslint-disable no-underscore-dangle*/
Reflux.__keep = __webpack_require__(334);
/*eslint-enable no-underscore-dangle*/

/**
 * Warn if Function.prototype.bind not available
 */
if (!Function.prototype.bind) {
    console.error("Function.prototype.bind not available. " + "ES5 shim required. " + "https://github.com/spoike/refluxjs#es5");
}

exports["default"] = Reflux;
module.exports = exports["default"];

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

//
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//
var prefix = typeof Object.create !== 'function' ? '~' : false;

/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} [once=false] Only emit once
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() { /* Nothing to set */ }

/**
 * Hold the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */
EventEmitter.prototype._events = undefined;

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var events = this._events
    , names = []
    , name;

  if (!events) return names;

  for (name in events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events && this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return this;

  var listeners = this._events[evt]
    , events = [];

  if (fn) {
    if (listeners.fn) {
      if (
           listeners.fn !== fn
        || (once && !listeners.once)
        || (context && listeners.context !== context)
      ) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (
             listeners[i].fn !== fn
          || (once && !listeners[i].once)
          || (context && listeners[i].context !== context)
        ) {
          events.push(listeners[i]);
        }
      }
    }
  }

  //
  // Reset the array, or remove it completely if we have no more listeners.
  //
  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;

  if (event) delete this._events[prefix ? prefix + event : event];
  else this._events = prefix ? {} : Object.create(null);

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(92);

module.exports = function mix(def) {
    var composed = {
        init: [],
        preEmit: [],
        shouldEmit: []
    };

    var updated = (function mixDef(mixin) {
        var mixed = {};
        if (mixin.mixins) {
            mixin.mixins.forEach(function (subMixin) {
                _.extend(mixed, mixDef(subMixin));
            });
        }
        _.extend(mixed, mixin);
        Object.keys(composed).forEach(function (composable) {
            if (mixin.hasOwnProperty(composable)) {
                composed[composable].push(mixin[composable]);
            }
        });
        return mixed;
    })(def);

    if (composed.init.length > 1) {
        updated.init = function () {
            var args = arguments;
            composed.init.forEach(function (init) {
                init.apply(this, args);
            }, this);
        };
    }
    if (composed.preEmit.length > 1) {
        updated.preEmit = function () {
            return composed.preEmit.reduce((function (args, preEmit) {
                var newValue = preEmit.apply(this, args);
                return newValue === undefined ? args : [newValue];
            }).bind(this), arguments);
        };
    }
    if (composed.shouldEmit.length > 1) {
        updated.shouldEmit = function () {
            var args = arguments;
            return !composed.shouldEmit.some(function (shouldEmit) {
                return !shouldEmit.apply(this, args);
            }, this);
        };
    }
    Object.keys(composed).forEach(function (composable) {
        if (composed[composable].length === 1) {
            updated[composable] = composed[composable][0];
        }
    });

    return updated;
};

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (store, definition) {
    for (var name in definition) {
        if (Object.getOwnPropertyDescriptor && Object.defineProperty) {
            var propertyDescriptor = Object.getOwnPropertyDescriptor(definition, name);

            if (!propertyDescriptor.value || typeof propertyDescriptor.value !== "function" || !definition.hasOwnProperty(name)) {
                continue;
            }

            store[name] = definition[name].bind(store);
        } else {
            var property = definition[name];

            if (typeof property !== "function" || !definition.hasOwnProperty(name)) {
                continue;
            }

            store[name] = property.bind(store);
        }
    }

    return store;
};

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(92),
    ActionMethods = __webpack_require__(502),
    PublisherMethods = __webpack_require__(335),
    Keep = __webpack_require__(334);

var allowed = { preEmit: 1, shouldEmit: 1 };

/**
 * Creates an action functor object. It is mixed in with functions
 * from the `PublisherMethods` mixin. `preEmit` and `shouldEmit` may
 * be overridden in the definition object.
 *
 * @param {Object} definition The action object definition
 */
var createAction = function createAction(definition) {

    definition = definition || {};
    if (!_.isObject(definition)) {
        definition = { actionName: definition };
    }

    for (var a in ActionMethods) {
        if (!allowed[a] && PublisherMethods[a]) {
            throw new Error("Cannot override API method " + a + " in Reflux.ActionMethods. Use another method name or override it on Reflux.PublisherMethods instead.");
        }
    }

    for (var d in definition) {
        if (!allowed[d] && PublisherMethods[d]) {
            throw new Error("Cannot override API method " + d + " in action creation. Use another method name or override it on Reflux.PublisherMethods instead.");
        }
    }

    definition.children = definition.children || [];
    if (definition.asyncResult) {
        definition.children = definition.children.concat(["completed", "failed"]);
    }

    var i = 0,
        childActions = {};
    for (; i < definition.children.length; i++) {
        var name = definition.children[i];
        childActions[name] = createAction(name);
    }

    var context = _.extend({
        eventLabel: "action",
        emitter: new _.EventEmitter(),
        _isAction: true
    }, PublisherMethods, ActionMethods, definition);

    var functor = function functor() {
        var triggerType = functor.sync ? "trigger" : "triggerAsync";
        return functor[triggerType].apply(functor, arguments);
    };

    _.extend(functor, childActions, context);

    Keep.createdActions.push(functor);

    return functor;
};

module.exports = createAction;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var ListenerMethods = __webpack_require__(134),
    ListenerMixin = __webpack_require__(336),
    _ = __webpack_require__(92);

module.exports = function(listenable,key){
    return {
        getInitialState: function(){
            if (!_.isFunction(listenable.getInitialState)) {
                return {};
            } else if (key === undefined) {
                return listenable.getInitialState();
            } else {
                return _.object([key],[listenable.getInitialState()]);
            }
        },
        componentDidMount: function(){
            _.extend(this,ListenerMethods);
            var me = this, cb = (key === undefined ? this.setState : function(v){
                if (typeof me.isMounted === "undefined" || me.isMounted() === true) {
                    me.setState(_.object([key],[v]));
                }
            });
            this.listenTo(listenable,cb);
        },
        componentWillUnmount: ListenerMixin.componentWillUnmount
    };
};


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var ListenerMethods = __webpack_require__(134),
    ListenerMixin = __webpack_require__(336),
    _ = __webpack_require__(92);

module.exports = function(listenable, key, filterFunc) {
    filterFunc = _.isFunction(key) ? key : filterFunc;
    return {
        getInitialState: function() {
            if (!_.isFunction(listenable.getInitialState)) {
                return {};
            } else if (_.isFunction(key)) {
                return filterFunc.call(this, listenable.getInitialState());
            } else {
                // Filter initial payload from store.
                var result = filterFunc.call(this, listenable.getInitialState());
                if (typeof(result) !== "undefined") {
                    return _.object([key], [result]);
                } else {
                    return {};
                }
            }
        },
        componentDidMount: function() {
            _.extend(this, ListenerMethods);
            var me = this;
            var cb = function(value) {
                if (_.isFunction(key)) {
                    me.setState(filterFunc.call(me, value));
                } else {
                    var result = filterFunc.call(me, value);
                    me.setState(_.object([key], [result]));
                }
            };

            this.listenTo(listenable, cb);
        },
        componentWillUnmount: ListenerMixin.componentWillUnmount
    };
};



/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var ListenerMethods = __webpack_require__(134);

/**
 * A mixin factory for a React component. Meant as a more convenient way of using the `ListenerMixin`,
 * without having to manually set listeners in the `componentDidMount` method.
 *
 * @param {Action|Store} listenable An Action or Store that should be
 *  listened to.
 * @param {Function|String} callback The callback to register as event handler
 * @param {Function|String} defaultCallback The callback to register as default handler
 * @returns {Object} An object to be used as a mixin, which sets up the listener for the given listenable.
 */
module.exports = function(listenable,callback,initial){
    return {
        /**
         * Set up the mixin before the initial rendering occurs. Import methods from `ListenerMethods`
         * and then make the call to `listenTo` with the arguments provided to the factory function
         */
        componentDidMount: function() {
            for(var m in ListenerMethods){
                if (this[m] !== ListenerMethods[m]){
                    if (this[m]){
                        throw "Can't have other property '"+m+"' when using Reflux.listenTo!";
                    }
                    this[m] = ListenerMethods[m];
                }
            }
            this.listenTo(listenable,callback,initial);
        },
        /**
         * Cleans up all listener previously registered.
         */
        componentWillUnmount: ListenerMethods.stopListeningToAll
    };
};


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var ListenerMethods = __webpack_require__(134);

/**
 * A mixin factory for a React component. Meant as a more convenient way of using the `listenerMixin`,
 * without having to manually set listeners in the `componentDidMount` method. This version is used
 * to automatically set up a `listenToMany` call.
 *
 * @param {Object} listenables An object of listenables
 * @returns {Object} An object to be used as a mixin, which sets up the listeners for the given listenables.
 */
module.exports = function(listenables){
    return {
        /**
         * Set up the mixin before the initial rendering occurs. Import methods from `ListenerMethods`
         * and then make the call to `listenTo` with the arguments provided to the factory function
         */
        componentDidMount: function() {
            for(var m in ListenerMethods){
                if (this[m] !== ListenerMethods[m]){
                    if (this[m]){
                        throw "Can't have other property '"+m+"' when using Reflux.listenToMany!";
                    }
                    this[m] = ListenerMethods[m];
                }
            }
            this.listenToMany(listenables);
        },
        /**
         * Cleans up all listener previously registered.
         */
        componentWillUnmount: ListenerMethods.stopListeningToAll
    };
};


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['changeDir','gridMode','listMode','read','readComplete','changeSearchFilter']));

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['paymentStarted','paymentCompleted','change','genericError','start','cmoplete']));

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var StoreActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['read','readComplete','create','createComplete','findById','findBySlug','findByIdComplete','remove','removeComplete','genericError','save','saveComplete','changeStoreItem','pushStoreItem','setDiscountCode','joinForFree']);/* harmony default export */ __webpack_exports__["a"] = (StoreActions);

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var TaskActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['start','readTasks','readTasksComplete','findTaskStudents','findTaskStudentsComplete','findTaskGroups','findTaskGroupsComplete','removeUploaded','findTaskCourses','findTaskCoursesComplete','clearTaskSelection','setTaskFilter','setGroupFilter','setStudentFilter','setCourseFilter','assessTask','assessTaskComplete','toggleFilterMode','toggleExpand','toggleCorrected']);/* harmony default export */ __webpack_exports__["a"] = (TaskActions);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var ExportActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['exportIncomingPayment','exportIncomingPaymentComplete']);/* harmony default export */ __webpack_exports__["a"] = (ExportActions);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var ClipbardActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['copy','paste']);/* harmony default export */ __webpack_exports__["a"] = (ClipbardActions);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['getList','getListComplete','changeList']));

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['moveToNewSection','overSection','resetOverSection','resetDragging','endDragging','setDraggingPos','openModuleMenu','closeModuleMenu','setFilterCategory','setFilterTag','setFilter','setSearchText','read','readComplete','update','publish','updateComplete','toggleFilterMode','setDiscountCode','start','findBySlug','findBySlugComplete','addCart','addToCart','clearCart','startPayment','completePayment','paymentCompleted','paymentStarted','setPaymentMethod','clearPaymentMethod','resetPayment','reset','clearSelected','editMode','listMode','addModule','selectSection','selectModule','unselect','moveSectionUp','moveSectionDown','moveModuleLeft','moveModuleRight','updateModule','updateModuleDebounced','updateSection','setDialogMode','deleteModule','undo','changeStoreItem','pushStoreItem','pushStoreItemComplete','discard','setDiscountCode','setGiftEmail','clearError']));

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var KlarnaActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['getAddressesBySsn','getAddressesBySsnComplete','change']);/* harmony default export */ __webpack_exports__["a"] = (KlarnaActions);

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var StripeActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['change']);/* harmony default export */ __webpack_exports__["a"] = (StripeActions);

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var TaskActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['initCategories','readCategories','readCategoriesComplete']);/* harmony default export */ __webpack_exports__["a"] = (TaskActions);

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var QuizActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['initialize','setNextStep','next','prev','setQuestion','calculateTest','updateAnswer','reset']);/* harmony default export */ __webpack_exports__["a"] = (QuizActions);

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var QuizDetailActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['start','readQuizzes','findStudents','findCourses','findTaskStudents','selectPage','resetPage','selectCourse','selectUser','export']);/* harmony default export */ __webpack_exports__["a"] = (QuizDetailActions);

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var WebinarActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['initWebinar','initComplete']);/* harmony default export */ __webpack_exports__["a"] = (WebinarActions);

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
var PageActions=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createActions(['checkForQuiziframe']);/* harmony default export */ __webpack_exports__["a"] = (PageActions);

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 997 */
/***/ (function(module, exports) {


/**
 * Reduce `arr` with `fn`.
 *
 * @param {Array} arr
 * @param {Function} fn
 * @param {Mixed} initial
 *
 * TODO: combatible error handling?
 */

module.exports = function(arr, fn, initial){  
  var idx = 0;
  var len = arr.length;
  var curr = arguments.length == 3
    ? initial
    : arr[idx++];

  while (idx < len) {
    curr = fn.call(null, curr, arr[idx], ++idx, arr);
  }
  
  return curr;
};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(511);

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

exports.clearTimeout = function _clearTimeout(){
  this._timeout = 0;
  clearTimeout(this._timer);
  return this;
};

/**
 * Force given parser
 *
 * Sets the body parser no matter type.
 *
 * @param {Function}
 * @api public
 */

exports.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set timeout to `ms`.
 *
 * @param {Number} ms
 * @return {Request} for chaining
 * @api public
 */

exports.timeout = function timeout(ms){
  this._timeout = ms;
  return this;
};

/**
 * Faux promise support
 *
 * @param {Function} fulfill
 * @param {Function} reject
 * @return {Request}
 */

exports.then = function then(fulfill, reject) {
  return this.end(function(err, res) {
    err ? reject(err) : fulfill(res);
  });
}

/**
 * Allow for extension
 */

exports.use = function use(fn) {
  fn(this);
  return this;
}


/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

exports.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

exports.getHeader = exports.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

exports.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
exports.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val` for "multipart/form-data"
 * request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 * ```
 *
 * @param {String} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
exports.field = function(name, val) {
  this._getFormData().append(name, val);
  return this;
};


/***/ }),
/* 999 */
/***/ (function(module, exports) {

// The node and browser modules expose versions of this with the
// appropriate constructor function bound as first argument
/**
 * Issue a request:
 *
 * Examples:
 *
 *    request('GET', '/users').end(callback)
 *    request('/users').end(callback)
 *    request('/users', callback)
 *
 * @param {String} method
 * @param {String|Function} url or callback
 * @return {Request}
 * @api public
 */

function request(RequestConstructor, method, url) {
  // callback
  if ('function' == typeof url) {
    return new RequestConstructor('GET', method).end(url);
  }

  // url first
  if (2 == arguments.length) {
    return new RequestConstructor('GET', method);
  }

  return new RequestConstructor(method, url);
}

module.exports = request;


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
var history=__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default()();/* harmony default export */ __webpack_exports__["a"] = (history);

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(342);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(161);

var _PathUtils = __webpack_require__(112);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Course__ = __webpack_require__(1004);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var id=-1;var DashboardStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["g" /* DashboardActions */],__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */]],data:{courses:[],loading:false},getInitialState:function getInitialState(){return this.data;},onRead:function onRead(callback){var _this=this;this.data=Object.assign({},this.data,{loading:true});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('dashboard','read',{sortBy:'lastVisit'},function(response){_this.data=Object.assign({},_this.data,{courses:response.data||[],loading:false});_this.trigger(_this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["g" /* DashboardActions */].readComplete();if(callback){callback();}});},setSortMethod:function setSortMethod(sortMethod){this.data=Object.assign({},this.data,{sortMethod:sortMethod});this.resort();},resort:function resort(){var sortMethod='sortBy'+this.data.sortMethod;this[sortMethod]&&this[sortMethod]();},sort:function sort(sorterFunc){var courses=this.data.courses.slice();courses.sort(sorterFunc);this.data=Object.assign({},this.data,{courses:courses});this.trigger(this.data);},sortByLastVisit:function sortByLastVisit(){this.sort(function(a,b){if(a.lastVisit<b.lastVisit){return 1;}if(a.lastVisit>b.lastVisit){return-1;}// a must be equal to b
return 0;});},sortByCreated:function sortByCreated(){this.sort(function(a,b){if(a.created<b.created){return 1;}if(a.created>b.created){return-1;}// a must be equal to b
return 0;});},onDuplicateCourse:function onDuplicateCourse(course){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','duplicate',{id:course.id}).then(function(duplicate){__WEBPACK_IMPORTED_MODULE_1_actions__["g" /* DashboardActions */].duplicateCourseComplete(duplicate);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},onDuplicateCourseComplete:function onDuplicateCourseComplete(duplicate){this.data.courses.unshift(duplicate);duplicate.mode='edit';this.trigger(this.data);},addCourseSkeleton:function addCourseSkeleton(name){id=id-1;var courses=this.data.courses.slice();courses.unshift({id:id,mode:'edit',name:name,coverImage:{id:0},skeleton:true});this.data=Object.assign({},this.data,{courses:courses});this.trigger(this.data);},saveCourse:function saveCourse(course){var action=course.id>0?'update':'create';var courseId=course.id;if(action==='create'){delete course.id;course.settings={};}return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course',action,course).then(function(response){if(action==='update'){return __WEBPACK_IMPORTED_MODULE_1_actions__["g" /* DashboardActions */].updateCourseComplete(response);}else{__WEBPACK_IMPORTED_MODULE_1_actions__["g" /* DashboardActions */].createCourseComplete(courseId,response);}}).catch(function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},initQuizSection:function initQuizSection(course,enabled){__WEBPACK_IMPORTED_MODULE_1_actions__["g" /* DashboardActions */].createCourseComplete(course.id,course);__WEBPACK_IMPORTED_MODULE_3_services_Course__["a" /* default */].addSection(course.id,'Quiz','quiz').then(function(res){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].addQuizSectionComplete(Object.assign({},res,{type:'quiz'}),null);return __WEBPACK_IMPORTED_MODULE_3_services_Course__["a" /* default */].addPage(res.id,'Quiz 1','quiz').then(function(pageRes){var oldSettings=course.settings||{};var id=course.id;var pageId=pageRes.id;var settings=Object.assign({},oldSettings,{quiz:{enabled:enabled,pages:_defineProperty({},pageId,{repeatable:false,welcomeText:'',descriptionText:'',successText:'',failText:'',threshold:80})}});__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].addQuizPageComplete(res.id,null,pageRes);__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updateQuizSettings(settings.quiz);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','update',{id:id,settings:settings});});});},updateCourseComplete:function updateCourseComplete(updatedCourse){var courses=this.data.courses.slice().map(function(course){if(course.id===updatedCourse.id){return updatedCourse;}return course;});this.data=Object.assign({},this.data,{courses:courses});this.trigger(this.data);},createCourseComplete:function createCourseComplete(addedId,courseToAdd){var courses=this.data.courses.slice().filter(function(course){return course.id!==addedId;});courses.unshift(courseToAdd);this.data=Object.assign({},this.data,{courses:courses});this.trigger(this.data);},onRemoveCourse:function onRemoveCourse(course){if(course.id>1){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','delete',course).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["g" /* DashboardActions */].removeCourseCompleted(course);});}__WEBPACK_IMPORTED_MODULE_1_actions__["g" /* DashboardActions */].removeCourseCompleted(course);},removeCourseCompleted:function removeCourseCompleted(course){var courses=this.data.courses.slice();var index=courses.indexOf(course);if(index>-1){courses.splice(index,1);this.data.courses=courses;this.trigger(this.data);}}});/* harmony default export */ __webpack_exports__["a"] = (DashboardStore);

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_Course__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Course=function(){function Course(){_classCallCheck(this,Course);}_createClass(Course,[{key:'reorderSections',value:function reorderSections(id,sectionIds,callback){__WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].call('course','reorderSections',{id:id,sectionIds:sectionIds},function(response){if(callback){callback(response);}});}},{key:'save',value:function save(data){if(data.id<0){this.create(data);}else{this.update(data);}}},{key:'addPage',value:function addPage(sectionId,name,type){return __WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].request('page','create',{sectionId:sectionId,name:name,type:type}).then(function(data){if(data){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].createPageComplete(sectionId,data);}else{__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError();}return data;},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError(error);});}},{key:'updatePage',value:function updatePage(data){return __WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].request('page','update',data).then(function(response){if(response){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].updatePageComplete(data);}else{__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError();}},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError(error);});}},{key:'addSection',value:function addSection(courseId,name){var type=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'content';return __WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].request('section','create',{courseId:courseId,name:name,type:type}).then(function(data){if(data){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].createSectionComplete(data);}else{__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError();}return data;},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError(error);});}},{key:'updateSection',value:function updateSection(data){return __WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].request('section','update',data).then(function(data){if(data){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].updateSectionComplete(data);}else{__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError();}},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError(error);});}},{key:'deleteSection',value:function deleteSection(id){return __WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].request('section','delete',{id:id}).then(function(data){if(data){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].deleteSectionComplete(id);}else{__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError();}},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError(error);});}},{key:'deletePage',value:function deletePage(id){return __WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].request('page','delete',{id:id}).then(function(data){if(data){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].deletePageComplete(id);}else{__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError();}},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError(error);});}},{key:'update',value:function update(data){return __WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].request('course','update',data).then(function(data){if(data){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].updateComplete(data);}else{__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError();}},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError(error);});}},{key:'create',value:function create(data){var _this=this;return __WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].request('course','create',{name:data.name}).then(function(saveData){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].createComplete(data.id);data.id=saveData.id;_this.update(data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions_Course__["a" /* default */].genericError(error);});}}]);return Course;}();/* harmony default export */ __webpack_exports__["a"] = (new Course());

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_Invitation__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_App__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__ = __webpack_require__(18);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var InvitationStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions_Invitation__["a" /* default */]],data:{loading:true,selection:[],circles:[],groups:[],total:0,status:{loading:true,state:null},invitation:{loading:true,accepting:false,accepted:false}},getInitialState:function getInitialState(){return this.data;},countByCourseId:function countByCourseId(courseId){var _this=this;return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].call('invitation','countByCourseId',{courseId:courseId},function(response){_this.data.total=response.data;_this.trigger(_this.data);});},showInfo:function showInfo(id){var _this2=this;this.data=Object.assign({},this.data,{loading:true});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('invitation','showInfo',{id:id}).then(function(response){var course=response.course;if((typeof course==='undefined'?'undefined':_typeof(course))==='object'){course=[course];}__WEBPACK_IMPORTED_MODULE_1_actions_Invitation__["a" /* default */].showInfoComplete(Object.assign({},response,{course:course}));},function(errorMsg){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(errorMsg);_this2.data.invitation=Object.assign({},_this2.data.invitation,{loading:false});_this2.trigger(_this2.data);});},showInfoComplete:function showInfoComplete(invitation){this.data.invitation=Object.assign({},this.data.invitation,invitation,{loading:false});this.trigger(this.data);},onResend:function onResend(id){this.data.loading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('invitation','resend',{id:id}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions_Invitation__["a" /* default */].resendComplete(id);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},onDelete:function onDelete(id){this.data.loading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('invitation','delete',{id:id}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions_Invitation__["a" /* default */].deleteComplete(id);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},onDeleteComplete:function onDeleteComplete(id){var selection=this.data.selection;for(var i=selection.length;i--;){if(selection[i].id===id){selection.splice(i,1);}}this.trigger(this.data);},onFindByGroupId:function onFindByGroupId(groupId){return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('invitation','findByCircleId',{circleId:groupId,sortBy:'name',sortMode:'asc'}).then(function(invitations){__WEBPACK_IMPORTED_MODULE_1_actions_Invitation__["a" /* default */].findByGroupIdComplete(invitations);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},onFindByGroupIdComplete:function onFindByGroupIdComplete(invitations){this.data.selection=invitations;this.trigger(this.data);},onFindByCourseId:function onFindByCourseId(courseId,pageStart,pageLength,unusedOnly){return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('invitation','findByCourseId',{courseId:courseId,unusedOnly:1,sortBy:'name',sortMode:'asc'},pageStart,pageLength).then(function(invitations){__WEBPACK_IMPORTED_MODULE_1_actions_Invitation__["a" /* default */].findByCourseIdComplete(invitations);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);});},onFindByCourseIdComplete:function onFindByCourseIdComplete(invitations){this.data.selection=invitations;this.trigger(this.data);},check:function check(hash){var _this3=this;this.data=Object.assign({},this.data,{inivtation:Object.assign({},this.data.invitation,{loading:true})});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('guest','checkInvitation',{hash:hash}).then(function(response){var _response=_slicedToArray(response,1),invitation=_response[0];__WEBPACK_IMPORTED_MODULE_1_actions_Invitation__["a" /* default */].checkComplete(invitation);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);_this3.data=Object.assign({},_this3.data,{inivtation:Object.assign({},_this3.data.invitation,{loading:false})});_this3.trigger(_this3.data);});},checkGiftCode:function checkGiftCode(giftCode){var _this4=this;this.data=Object.assign({},this.data,{inivtation:Object.assign({},this.data.invitation,{loading:true})});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('guest','checkInvitation',{giftCode:giftCode}).then(function(response){var _response2=_slicedToArray(response,1),invitation=_response2[0];__WEBPACK_IMPORTED_MODULE_1_actions_Invitation__["a" /* default */].checkComplete(invitation);},function(error){_this4.data=Object.assign({},_this4.data,{invitation:Object.assign({},_this4.data.invitation,{loading:false,error:true})});_this4.trigger(_this4.data);});},checkComplete:function checkComplete(invitation){this.data=Object.assign({},this.data,{error:false,invitation:Object.assign({},this.data.invitation,invitation,{loading:false})});this.trigger(this.data);},getInvitationEmailStatus:function getInvitationEmailStatus(invitationId){var _this5=this;this.data=Object.assign({},this.data,{status:{loading:true,state:null}});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('vendor/mandrill','getInvitationEmailStatus',{invitationId:invitationId}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions_Invitation__["a" /* default */].getInvitationEmailStatusComplete(response);},function(error){_this5.data=Object.assign({},_this5.data,{status:{loading:false,state:'unknown'}});_this5.trigger(_this5.data);});},getInvitationEmailStatusComplete:function getInvitationEmailStatusComplete(state){this.data=Object.assign({},this.data,{status:{loading:false,state:state}});this.trigger(this.data);},accept:function accept(hash){var _this6=this;this.data=Object.assign({},this.data,{invitation:Object.assign({},this.data.invitation,{accepted:false,accepting:true})});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('guest','acceptInvitation',{hash:hash}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions_Invitation__["a" /* default */].acceptComplete(data);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);_this6.data=Object.assign({},_this6.data,{invitation:Object.assign({},_this6.data.invitation,{accepted:false,accepting:true})});_this6.trigger(_this6.data);});},acceptGift:function acceptGift(giftCode){var _this7=this;this.data=Object.assign({},this.data,{invitation:Object.assign({},this.data.invitation,{accepted:false,accepting:true})});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('guest','acceptInvitation',{giftCode:giftCode}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions_Invitation__["a" /* default */].acceptComplete(data);},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);_this7.data=Object.assign({},_this7.data,{loading:false,invitation:Object.assign({},_this7.data.invitation,{accepted:false,accepting:true})});_this7.trigger(_this7.data);});},acceptComplete:function acceptComplete(data){var _data=_slicedToArray(data,1),invitation=_data[0];this.data=Object.assign({},this.data,{invitation:Object.assign({},this.data.invitation,invitation,{accepted:true,accepting:false})});this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (InvitationStore);

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_Invite__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Message__ = __webpack_require__(19);
var InviteStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions_Invite__["a" /* default */]],data:{},onReset:function onReset(){var steps=['courses','courseAccess','inviteMode','groups','students','email','summary'],initialStep=0;this.data={stepOrder:steps,stepIndex:initialStep,stepName:steps[initialStep],inviteMode:null,coursesChosen:0,studentsChosen:0,groupsChosen:0,courseAccessChosen:0,selectedCourses:{},selectedStudents:{},selectedGroups:{},selectedCourseAccess:null,disabledSteps:{}};this.trigger(this.data);},onNextStep:function onNextStep(callback){var currentStep=this.data.stepName;for(var i=0;i<this.data.stepOrder.length;i++){var step=this.data.stepOrder[i];if(i>this.data.stepIndex&&!this.data.disabledSteps[step]){this.data.stepIndex=i;this.data.stepName=step;this.trigger(this.data);if(callback){callback(currentStep,step);}break;}}},getInitialState:function getInitialState(){var steps=['courses','courseAccess','inviteMode','groups','students','email','summary'],initialStep=0;this.data={list:[],stepOrder:steps,stepIndex:initialStep,stepName:steps[initialStep],inviteMode:null,coursesChosen:0,studentsChosen:0,groupsChosen:0,courseAccessChosen:0,selectedCourses:{},selectedStudents:{},selectedGroups:{},selectedCourseAccess:null,disabledSteps:{}};return this.data;},onDisableSteps:function onDisableSteps(steps){var _this=this;steps.forEach(function(step){_this.data.disabledSteps[step]=true;});this.trigger(this.data);},onSetCourses:function onSetCourses(selectedCourses,coursesChosen,dontSkip){this.data.selectedCourses=selectedCourses;this.data.coursesChosen=coursesChosen;if(!dontSkip&&this.data.stepName==='courses'&&coursesChosen>0){this.data.stepIndex++;this.data.stepName=this.data.stepOrder[this.data.stepIndex];}this.trigger(this.data);},onSetStudents:function onSetStudents(selectedStudents,studentsChosen){this.data.selectedStudents=selectedStudents;this.data.studentsChosen=studentsChosen;this.trigger(this.data);},onSetCourseAccess:function onSetCourseAccess(selectedCourseAccess,courseAccessChosen){this.data.selectedCourseAccess=selectedCourseAccess;this.data.courseAccessChosen=courseAccessChosen;this.trigger(this.data);},onSetGroups:function onSetGroups(selectedGroups,groupsChosen){this.data.selectedGroups=selectedGroups;this.data.groupsChosen=groupsChosen;this.trigger(this.data);},onSetStudentInviteMode:function onSetStudentInviteMode(mode){this.data.inviteMode=mode;this.trigger(this.data);},init:function init(){},inviteByCircleIds:function inviteByCircleIds(circleIds,courseIds,courseAccess,callback){var now=new Date(),oneMonth=new Date(now),sixMonths=new Date(now),oneYear=new Date(now),dateLookup=null;oneMonth.setDate(oneMonth.getDate()+31);sixMonths.setDate(sixMonths.getDate()+6*31);oneYear.setDate(oneYear.getDate()+365);dateLookup={oneMonth:oneMonth.toISOString(),sixMonths:sixMonths.toISOString(),oneYear:oneYear.toISOString(),unlimited:'0000-00-00'};return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('invite','byCircleIds',{circleIds:circleIds,courseIds:courseIds,expires:dateLookup.sixMonths},function(){if(callback){callback();}});},inviteByUserIds:function inviteByUserIds(userIds,courseIds,courseAccess,callback){var now=new Date(),oneMonth=new Date(now),sixMonths=new Date(now),threeMonths=new Date(now),oneYear=new Date(now),dateLookup=null;oneMonth.setDate(oneMonth.getDate()+31);threeMonths.setDate(threeMonths.getDate()+3*31);sixMonths.setDate(sixMonths.getDate()+6*31);oneYear.setDate(oneYear.getDate()+365);dateLookup={oneMonth:oneMonth.toISOString(),threeMonths:threeMonths.toISOString(),sixMonths:sixMonths.toISOString(),oneYear:oneYear.toISOString(),unlimited:'0000-00-00'};// if (Math.min(userIds.length, courseIds.length) === 0) {
//   Message.error('Please')
//   return;
// }
return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('invite','byUserIds',{userIds:userIds,courseIds:courseIds,expires:dateLookup[courseAccess]},function(){if(callback){callback();}});},inviteByEmails:function inviteByEmails(emails,courseIds,courseAccess,callback){var now=new Date(),oneMonth=new Date(now),threeMonths=new Date(now),sixMonths=new Date(now),oneYear=new Date(now),dateLookup=null;oneMonth.setDate(oneMonth.getDate()+31);threeMonths.setDate(threeMonths.getDate()+3*31);sixMonths.setDate(sixMonths.getDate()+6*31);oneYear.setDate(oneYear.getDate()+365);dateLookup={oneMonth:oneMonth.toISOString(),threeMonths:threeMonths.toISOString(),sixMonths:sixMonths.toISOString(),oneYear:oneYear.toISOString(),unlimited:'0000-00-00'};return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('invite','byEmails',{emails:emails,courseIds:courseIds,expires:dateLookup[courseAccess]},function(){if(callback){callback();}});},inviteToCircle:function inviteToCircle(emails,circleId,callback){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('invite','byEmails',{emails:emails,circleId:circleId}).then(function(){callback&&callback();});}});/* harmony default export */ __webpack_exports__["a"] = (InviteStore);

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_InviteWizard__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_Message__ = __webpack_require__(19);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions_InviteWizard__["a" /* default */]],data:{step:1,selectedCourses:[],selectedGroups:[],selectedStudents:[],invitees:[],accessTime:null,endTime:null,tags:{}},getInitialState:function getInitialState(){return this.data;},reset:function reset(){this.data={step:0,selectedCourses:[],selectedGroups:[],selectedStudents:[],invitees:[],accessTime:null,endTime:null,tags:{}};this.trigger(this.data);},restart:function restart(){this.data.step=1;this.trigger(this.data);},onNext:function onNext(){this.data.step=this.data.step+1;this.trigger(this.data);},onPrevious:function onPrevious(){if(this.data.step>1){this.data.step=this.data.step-1;this.trigger(this.data);}},onSelectCourses:function onSelectCourses(courses){this.data.selectedCourses=courses;this.trigger(this.data);},onSelectGroups:function onSelectGroups(groups){this.data.selectedGroups=groups;this.trigger(this.data);},onSelectStudents:function onSelectStudents(students){this.data.selectedStudents=students;this.trigger(this.data);},onSetInvitees:function onSetInvitees(invitees){this.data.invitees=invitees;this.trigger(this.data);}}));

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var MediaLibraryOverviewStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["p" /* MediaLibraryOverviewActions */]],data:{entities:{},directoryId:0,mode:'list',loading:false,breadCrumbs:[],filter:{type:null,searchText:null},sort:{prop:'created',direction:'desc'},items:[]},getInitialState:function getInitialState(){return this.data;},changeDir:function changeDir(directoryId){if(directoryId!==this.data.directoryId){this.data=Object.assign({},this.data,{directoryId:directoryId});this.read(this.data.filter.type);}},changeSearchFilter:function changeSearchFilter(searchText){var filter=this.data.filter;this.data=Object.assign({},this.data,{filter:Object.assign({},filter,{searchText:searchText})});this.trigger(this.data);},gridMode:function gridMode(){this.data=Object.assign({},this.data,{mode:'grid'});this.trigger(this.data);},listMode:function listMode(){this.data=Object.assign({},this.data,{mode:'list'});this.trigger(this.data);},read:function read(type){var _this=this;var directoryId=this.data.directoryId;this.data=Object.assign({},this.data,{filter:Object.assign({},this.data.filter,{type:type}),loading:true});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('file','listDirectory',{directoryId:directoryId}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["p" /* MediaLibraryOverviewActions */].readComplete(response);},function(error){_this.data=Object.assign({},_this.data,{loading:false});_this.trigger(_this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},getEntities:function getEntities(files){var items=[];var entities={};files.forEach(function(item){entities[item.id]=item;items.push(item.id);});return{items:items,entities:entities};},readComplete:function readComplete(response){var files=response.files,breadcrumbs=response.breadcrumbs;this.data=Object.assign({},this.data,{loading:false,breadCrumbs:[{id:0,name:''}].concat(_toConsumableArray(breadcrumbs.reverse()))},this.getEntities(files));this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (MediaLibraryOverviewStore);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_Message__ = __webpack_require__(508);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions_Message__["a" /* default */]],data:{message:''},getInitialState:function getInitialState(){return this.data;},init:function init(){},onNotify:function onNotify(message){this.data.message=message;this.trigger(this.data);},get:function get(){var message=this.data.message;this.data.message='';return message;}}));

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Constants__ = __webpack_require__(32);
var NotificationStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["r" /* NotificationActions */]],data:{unreadNotifications:0,list:[]},getInitialState:function getInitialState(){return this.data;},onRead:function onRead(includeRead,callback){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('notifications','read',{reversed:false,includeRead:includeRead,types:[]},0,__WEBPACK_IMPORTED_MODULE_3_Constants__["notificationPageLength"]).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["r" /* NotificationActions */].readComplete(response.data);if(callback){callback();}}).catch(console.log);},onReadComplete:function onReadComplete(data){this.data.list=data;this.trigger(this.data);},onMarkRead:function onMarkRead(ids){var _this=this;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('notifications','markRead',{ids:ids},function(response){if(ids&&ids.length){var lookup={};ids.forEach(function(id){lookup[id]=true;});_this.data.list.forEach(function(item){if(lookup[item.id]){item.isRead=true;}});_this.trigger(_this.data);}_this.countUnreadNotifications();});},countUnreadNotifications:function countUnreadNotifications(){__WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('notifications','count',{}).then(function(data){if(data!==undefined&&data!==null){__WEBPACK_IMPORTED_MODULE_1_actions__["r" /* NotificationActions */].countUnreadNotificationsComplete(data);}else{__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError();}},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},countUnreadNotificationsComplete:function countUnreadNotificationsComplete(unreadNotifications){if(this.data.unreadNotifications!==unreadNotifications){this.data=Object.assign({},this.data,{unreadNotifications:unreadNotifications});this.trigger(this.data);}}});/* harmony default export */ __webpack_exports__["a"] = (NotificationStore);

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_PageModule__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HelloWorld=function(_PageModule){_inherits(HelloWorld,_PageModule);function HelloWorld(){_classCallCheck(this,HelloWorld);return _possibleConstructorReturn(this,(HelloWorld.__proto__||Object.getPrototypeOf(HelloWorld)).apply(this,arguments));}_createClass(HelloWorld,[{key:'onInit',value:function onInit(){}},{key:'getModuleData',value:function getModuleData(moduleData){return Object.assign({},moduleData,{url:this.refs.url.getValue()});}},{key:'getUserData',value:function getUserData(userdata){var comments=(userdata&&userdata.comments||[]).slice();comments.push(this.refs.comment.getValue());return{comments:comments};}},{key:'renderEditMode',value:function renderEditMode(content,data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{label:'Url to the image',ref:'url',defaultValue:data.url}));}},{key:'comment',value:function comment(){this.saveUserData();this.refs.comment.clearValue();}},{key:'renderDetailMode',value:function renderDetailMode(content,data,userdata){var savedComments=userdata&&userdata.comments||[];var comments=savedComments.map(function(comment,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},comment);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:data.url}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Comment on this image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{fullWidth:true,onEnterKeyDown:this.comment.bind(this),label:'Comment',ref:'comment'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{fullWidth:true,label:'Save',onTouchTap:this.comment.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{fullWidth:true,label:'Clear',secondary:true,onTouchTap:this.clearUserData.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Comments'),comments));}}]);return HelloWorld;}(__WEBPACK_IMPORTED_MODULE_3_components_PageModule__["a" /* default */]);HelloWorld.readable='Hello World';HelloWorld.icon='ActionAlarm';HelloWorld.type=1000;HelloWorld.public=false;HelloWorld.active=true;/* harmony default export */ __webpack_exports__["a"] = (HelloWorld);

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var Typography = __webpack_require__(135);
var IconButton = __webpack_require__(186);
var NavigationMenu = __webpack_require__(354);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);
var Paper = __webpack_require__(54);

var AppBar = React.createClass({
  displayName: 'AppBar',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    onLeftIconButtonTouchTap: React.PropTypes.func,
    onRightIconButtonTouchTap: React.PropTypes.func,
    showMenuIconButton: React.PropTypes.bool,
    style: React.PropTypes.object,
    iconClassNameLeft: React.PropTypes.string,
    iconClassNameRight: React.PropTypes.string,
    iconElementLeft: React.PropTypes.element,
    iconElementRight: React.PropTypes.element,
    iconStyleRight: React.PropTypes.object,
    title: React.PropTypes.node,
    zDepth: React.PropTypes.number
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getDefaultProps: function getDefaultProps() {
    return {
      showMenuIconButton: true,
      title: '',
      zDepth: 1
    };
  },

  componentDidMount: function componentDidMount() {
    if (false) {
      if (this.props.iconElementLeft && this.props.iconClassNameLeft) {
        console.warn('Properties iconClassNameLeft and iconElementLeft cannot be simultaneously ' + 'defined. Please use one or the other.');
      }

      if (this.props.iconElementRight && this.props.iconClassNameRight) {
        console.warn('Properties iconClassNameRight and iconElementRight cannot be simultaneously ' + 'defined. Please use one or the other.');
      }
    }
  },

  getStyles: function getStyles() {
    var spacing = this.state.muiTheme.rawTheme.spacing;
    var themeVariables = this.state.muiTheme.appBar;
    var iconButtonSize = this.state.muiTheme.button.iconButtonSize;
    var flatButtonSize = 36;
    var styles = {
      root: {
        zIndex: 5,
        width: '100%',
        display: '-webkit-box; display: -webkit-flex; display: flex',
        minHeight: themeVariables.height,
        backgroundColor: themeVariables.color,
        paddingLeft: spacing.desktopGutter,
        paddingRight: spacing.desktopGutter
      },
      title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        margin: 0,
        paddingTop: 0,
        letterSpacing: 0,
        fontSize: 24,
        fontWeight: Typography.fontWeightNormal,
        color: themeVariables.textColor,
        lineHeight: themeVariables.height + 'px'
      },
      mainElement: {
        boxFlex: 1,
        flex: '1'
      },
      iconButton: {
        style: {
          marginTop: (themeVariables.height - iconButtonSize) / 2,
          marginRight: 8,
          marginLeft: -16
        },
        iconStyle: {
          fill: themeVariables.textColor,
          color: themeVariables.textColor
        }
      },
      flatButton: {
        color: themeVariables.textColor,
        backgroundColor: 'transparent',
        marginTop: (iconButtonSize - flatButtonSize) / 2 + 2
      }
    };

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var title = _props.title;
    var iconStyleRight = _props.iconStyleRight;
    var showMenuIconButton = _props.showMenuIconButton;
    var iconElementLeft = _props.iconElementLeft;
    var iconElementRight = _props.iconElementRight;
    var iconClassNameLeft = _props.iconClassNameLeft;
    var iconClassNameRight = _props.iconClassNameRight;
    var className = _props.className;
    var style = _props.style;
    var zDepth = _props.zDepth;
    var children = _props.children;

    var other = _objectWithoutProperties(_props, ['title', 'iconStyleRight', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'className', 'style', 'zDepth', 'children']);

    var menuElementLeft = undefined;
    var menuElementRight = undefined;
    var styles = this.getStyles();
    var iconRightStyle = this.mergeStyles(styles.iconButton.style, {
      marginRight: -16,
      marginLeft: 'auto'
    }, iconStyleRight);
    var titleElement = undefined;

    if (title) {
      // If the title is a string, wrap in an h1 tag.
      // If not, just use it as a node.
      titleElement = typeof title === 'string' || title instanceof String ? React.createElement(
        'h1',
        { style: this.prepareStyles(styles.title, styles.mainElement) },
        title
      ) : React.createElement(
        'div',
        { style: this.prepareStyles(styles.mainElement) },
        title
      );
    }

    if (showMenuIconButton) {
      if (iconElementLeft) {
        switch (iconElementLeft.type.displayName) {
          case 'IconButton':
            iconElementLeft = React.cloneElement(iconElementLeft, {
              iconStyle: this.mergeStyles(styles.iconButton.iconStyle)
            });
            break;
        }

        menuElementLeft = React.createElement(
          'div',
          { style: this.prepareStyles(styles.iconButton.style) },
          iconElementLeft
        );
      } else {
        var child = iconClassNameLeft ? '' : React.createElement(NavigationMenu, { style: this.mergeStyles(styles.iconButton.iconStyle) });
        menuElementLeft = React.createElement(
          IconButton,
          {
            style: this.mergeStyles(styles.iconButton.style),
            iconStyle: this.mergeStyles(styles.iconButton.iconStyle),
            iconClassName: iconClassNameLeft,
            onTouchTap: this._onLeftIconButtonTouchTap },
          child
        );
      }
    }

    if (iconElementRight) {
      switch (iconElementRight.type.displayName) {
        case 'IconMenu':
        case 'IconButton':
          iconElementRight = React.cloneElement(iconElementRight, {
            iconStyle: this.mergeStyles(styles.iconButton.iconStyle)
          });
          break;

        case 'FlatButton':
          iconElementRight = React.cloneElement(iconElementRight, {
            style: this.mergeStyles(styles.flatButton, iconElementRight.props.style)
          });
          break;
      }

      menuElementRight = React.createElement(
        'div',
        { style: this.prepareStyles(iconRightStyle) },
        iconElementRight
      );
    } else if (iconClassNameRight) {
      menuElementRight = React.createElement(IconButton, {
        style: iconRightStyle,
        iconStyle: this.mergeStyles(styles.iconButton.iconStyle),
        iconClassName: iconClassNameRight,
        onTouchTap: this._onRightIconButtonTouchTap });
    }

    return React.createElement(
      Paper,
      _extends({}, other, {
        rounded: false,
        className: className,
        style: this.mergeStyles(styles.root, style),
        zDepth: zDepth }),
      menuElementLeft,
      titleElement,
      menuElementRight,
      children
    );
  },

  _onLeftIconButtonTouchTap: function _onLeftIconButtonTouchTap(event) {
    if (this.props.onLeftIconButtonTouchTap) {
      this.props.onLeftIconButtonTouchTap(event);
    }
  },

  _onRightIconButtonTouchTap: function _onRightIconButtonTouchTap(event) {
    if (this.props.onRightIconButtonTouchTap) {
      this.props.onRightIconButtonTouchTap(event);
    }
  }

});

module.exports = AppBar;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = shallowEqual;

function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentWithPureRenderMixin
 */



var shallowCompare = __webpack_require__(518);

/**
 * If your React component's render function is "pure", e.g. it will render the
 * same result given the same props and state, provide this Mixin for a
 * considerable performance boost.
 *
 * Most React components have pure render functions.
 *
 * Example:
 *
 *   var ReactComponentWithPureRenderMixin =
 *     require('ReactComponentWithPureRenderMixin');
 *   React.createClass({
 *     mixins: [ReactComponentWithPureRenderMixin],
 *
 *     render: function() {
 *       return <div className={this.props.className}>foo</div>;
 *     }
 *   });
 *
 * Note: This only checks shallow equality for props and state. If these contain
 * complex data structures this mixin may have false-negatives for deeper
 * differences. Only mixin to components which have simple props and state, or
 * use `forceUpdate()` when you know deep data structures have changed.
 */
var ReactComponentWithPureRenderMixin = {
  shouldComponentUpdate: function (nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
};

module.exports = ReactComponentWithPureRenderMixin;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1016).create;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactFragment
 */



var ReactChildren = __webpack_require__(297);
var ReactElement = __webpack_require__(51);

var emptyFunction = __webpack_require__(57);
var invariant = __webpack_require__(20);
var warning = __webpack_require__(33);

/**
 * We used to allow keyed objects to serve as a collection of ReactElements,
 * or nested sets. This allowed us a way to explicitly key a set a fragment of
 * components. This is now being replaced with an opaque data structure.
 * The upgrade path is to call React.addons.createFragment({ key: value }) to
 * create a keyed fragment. The resulting data structure is an array.
 */

var numericPropertyRegex = /^\d+$/;

var warnedAboutNumeric = false;

var ReactFragment = {
  // Wrap a keyed object in an opaque proxy that warns you if you access any
  // of its properties.
  create: function (object) {
    if (typeof object !== 'object' || !object || Array.isArray(object)) {
       false ? warning(false, 'React.addons.createFragment only accepts a single object. Got: %s', object) : undefined;
      return object;
    }
    if (ReactElement.isValidElement(object)) {
       false ? warning(false, 'React.addons.createFragment does not accept a ReactElement ' + 'without a wrapper object.') : undefined;
      return object;
    }

    !(object.nodeType !== 1) ?  false ? invariant(false, 'React.addons.createFragment(...): Encountered an invalid child; DOM ' + 'elements are not valid children of React components.') : invariant(false) : undefined;

    var result = [];

    for (var key in object) {
      if (false) {
        if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React.addons.createFragment(...): Child objects should have ' + 'non-numeric keys so ordering is preserved.') : undefined;
          warnedAboutNumeric = true;
        }
      }
      ReactChildren.mapIntoWithKeyPrefixInternal(object[key], result, key, emptyFunction.thatReturnsArgument);
    }

    return result;
  }
};

module.exports = ReactFragment;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var ReactTransitionGroup = __webpack_require__(188);
var StylePropable = __webpack_require__(10);
var ScaleInChild = __webpack_require__(1019);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var ScaleIn = React.createClass({
  displayName: 'ScaleIn',

  mixins: [PureRenderMixin, StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  propTypes: {
    childStyle: React.PropTypes.object,
    enterDelay: React.PropTypes.number,
    maxScale: React.PropTypes.number,
    minScale: React.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      enterDelay: 0
    };
  },

  render: function render() {
    var _props = this.props;
    var children = _props.children;
    var childStyle = _props.childStyle;
    var enterDelay = _props.enterDelay;
    var maxScale = _props.maxScale;
    var minScale = _props.minScale;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);

    var mergedRootStyles = this.prepareStyles({
      position: 'relative',
      overflow: 'hidden',
      height: '100%'
    }, style);

    var newChildren = React.Children.map(children, function (child) {
      return React.createElement(
        ScaleInChild,
        {
          key: child.key,
          enterDelay: enterDelay,
          maxScale: maxScale,
          minScale: minScale,
          style: childStyle },
        child
      );
    });

    return React.createElement(
      ReactTransitionGroup,
      _extends({}, other, {
        style: mergedRootStyles,
        component: 'div' }),
      newChildren
    );
  }

});

module.exports = ScaleIn;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks static-only
 * @providesModule ReactTransitionChildMapping
 */



var flattenChildren = __webpack_require__(443);

var ReactTransitionChildMapping = {
  /**
   * Given `this.props.children`, return an object mapping key to child. Just
   * simple syntactic sugar around flattenChildren().
   *
   * @param {*} children `this.props.children`
   * @return {object} Mapping of key to child
   */
  getChildMapping: function (children) {
    if (!children) {
      return children;
    }
    return flattenChildren(children);
  },

  /**
   * When you're adding or removing children some may be added or removed in the
   * same render pass. We want to show *both* since we want to simultaneously
   * animate elements in and out. This function takes a previous set of keys
   * and a new set of keys and merges them with its best guess of the correct
   * ordering. In the future we may expose some of the utilities in
   * ReactMultiChild to make this easy, but for now React itself does not
   * directly have this concept of the union of prevChildren and nextChildren
   * so we implement it here.
   *
   * @param {object} prev prev children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @param {object} next next children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @return {object} a key set that contains all keys in `prev` and all keys
   * in `next` in a reasonable order.
   */
  mergeChildMappings: function (prev, next) {
    prev = prev || {};
    next = next || {};

    function getValueForKey(key) {
      if (next.hasOwnProperty(key)) {
        return next[key];
      } else {
        return prev[key];
      }
    }

    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = {};

    var pendingKeys = [];
    for (var prevKey in prev) {
      if (next.hasOwnProperty(prevKey)) {
        if (pendingKeys.length) {
          nextKeysPending[prevKey] = pendingKeys;
          pendingKeys = [];
        }
      } else {
        pendingKeys.push(prevKey);
      }
    }

    var i;
    var childMapping = {};
    for (var nextKey in next) {
      if (nextKeysPending.hasOwnProperty(nextKey)) {
        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
          var pendingNextKey = nextKeysPending[nextKey][i];
          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
      }
      childMapping[nextKey] = getValueForKey(nextKey);
    }

    // Finally, add the keys which didn't appear before any key in `next`
    for (i = 0; i < pendingKeys.length; i++) {
      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    }

    return childMapping;
  }
};

module.exports = ReactTransitionChildMapping;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var PureRenderMixin = __webpack_require__(1);
var StylePropable = __webpack_require__(10);
var AutoPrefix = __webpack_require__(62);
var Transitions = __webpack_require__(21);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var ScaleInChild = React.createClass({
  displayName: 'ScaleInChild',

  mixins: [PureRenderMixin, StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  propTypes: {
    enterDelay: React.PropTypes.number,
    maxScale: React.PropTypes.number,
    minScale: React.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      enterDelay: 0,
      maxScale: 1,
      minScale: 0
    };
  },

  componentWillAppear: function componentWillAppear(callback) {
    this._initializeAnimation(callback);
  },

  componentWillEnter: function componentWillEnter(callback) {
    this._initializeAnimation(callback);
  },

  componentDidAppear: function componentDidAppear() {
    this._animate();
  },

  componentDidEnter: function componentDidEnter() {
    this._animate();
  },

  componentWillLeave: function componentWillLeave(callback) {
    var _this = this;

    var style = ReactDOM.findDOMNode(this).style;

    style.opacity = '0';
    AutoPrefix.set(style, 'transform', 'scale(' + this.props.minScale + ')');

    setTimeout(function () {
      if (_this.isMounted()) callback();
    }, 450);
  },

  render: function render() {
    var _props = this.props;
    var children = _props.children;
    var enterDelay = _props.enterDelay;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['children', 'enterDelay', 'style']);

    var mergedRootStyles = this.prepareStyles({
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: 0,
      left: 0,
      transition: Transitions.easeOut(null, ['transform', 'opacity'])
    }, style);

    return React.createElement(
      'div',
      _extends({}, other, { style: mergedRootStyles }),
      children
    );
  },

  _animate: function _animate() {
    var style = ReactDOM.findDOMNode(this).style;

    style.opacity = '1';
    AutoPrefix.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
  },

  _initializeAnimation: function _initializeAnimation(callback) {
    var _this2 = this;

    var style = ReactDOM.findDOMNode(this).style;

    style.opacity = '0';
    AutoPrefix.set(style, 'transform', 'scale(0)');

    setTimeout(function () {
      if (_this2.isMounted()) callback();
    }, this.props.enterDelay);
  }

});

module.exports = ScaleInChild;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var AppCanvas = React.createClass({
  displayName: 'AppCanvas',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _this = this;

    var styles = {
      height: '100%',
      backgroundColor: this.state.muiTheme.rawTheme.palette.canvasColor,
      WebkitFontSmoothing: 'antialiased',
      direction: 'ltr'
    };

    var newChildren = React.Children.map(this.props.children, function (currentChild) {
      if (!currentChild) {
        // If undefined, skip it
        return null;
      }

      switch (currentChild.type.displayName) {
        case 'AppBar':
          return React.cloneElement(currentChild, {
            style: _this.mergeStyles({
              position: 'fixed'
            }, currentChild.props.style)
          });
        default:
          return currentChild;
      }
    }, this);

    return React.createElement(
      'div',
      { style: this.prepareStyles(styles) },
      newChildren
    );
  }

});

module.exports = AppCanvas;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var Paper = __webpack_require__(54);
var StylePropable = __webpack_require__(10);
var CardExpandable = __webpack_require__(523);

var Card = React.createClass({
  displayName: 'Card',

  mixins: [StylePropable],

  getInitialState: function getInitialState() {
    return { expanded: this.props.initiallyExpanded ? true : false };
  },

  propTypes: {
    style: React.PropTypes.object,
    expandable: React.PropTypes.bool,
    initiallyExpanded: React.PropTypes.bool,
    onExpandChange: React.PropTypes.func
  },

  _onExpandable: function _onExpandable() {
    var newExpandedState = !(this.state.expanded === true);
    this.setState({ expanded: newExpandedState });
    if (this.props.onExpandChange) this.props.onExpandChange(newExpandedState);
  },

  render: function render() {
    var _this = this;

    var lastElement = undefined;
    var newChildren = React.Children.map(this.props.children, function (currentChild) {
      var doClone = false;
      var newChild = undefined;
      var newProps = {};
      var element = currentChild;
      if (!currentChild || !currentChild.props) {
        return null;
      }
      if (_this.state.expanded === false && currentChild.props.expandable === true) return;
      if (currentChild.props.actAsExpander === true) {
        doClone = true;
        newProps.onTouchTap = _this._onExpandable;
        newProps.style = _this.mergeStyles({ cursor: 'pointer' }, currentChild.props.style);
      }
      if (currentChild.props.showExpandableButton === true) {
        doClone = true;
        newChild = React.createElement(CardExpandable, { expanded: _this.state.expanded, onExpanding: _this._onExpandable });
      }
      if (doClone) {
        element = React.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
      }
      return element;
    }, this);

    // If the last element is text or a title we should add
    // 8px padding to the bottom of the card
    var addBottomPadding = lastElement && (lastElement.type.displayName === "CardText" || lastElement.type.displayName === "CardTitle");
    var _props = this.props;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['style']);

    var mergedStyles = this.mergeStyles({
      overflow: 'hidden',
      zIndex: 1
    }, style);

    return React.createElement(
      Paper,
      _extends({}, other, { style: mergedStyles }),
      React.createElement(
        'div',
        { style: { paddingBottom: addBottomPadding ? 8 : 0 } },
        newChildren
      )
    );
  }
});

module.exports = Card;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var ThemeManager = __webpack_require__(12);
var DefaultRawTheme = __webpack_require__(11);

var CardActions = React.createClass({
  displayName: 'CardActions',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getStyles: function getStyles() {
    return {
      root: {
        padding: 8,
        position: 'relative'
      }
    };
  },

  propTypes: {
    expandable: React.PropTypes.bool,
    actAsExpander: React.PropTypes.bool,
    showExpandableButton: React.PropTypes.bool
  },

  render: function render() {
    var styles = this.getStyles();

    var children = React.Children.map(this.props.children, function (child) {
      return React.cloneElement(child, {
        style: { marginRight: 8 }
      });
    });

    return React.createElement(
      'div',
      _extends({}, this.props, { style: this.prepareStyles(styles.root, this.props.style) }),
      children
    );
  }
});

module.exports = CardActions;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(0);
var Styles = __webpack_require__(190);
var Avatar = __webpack_require__(521);
var StylePropable = __webpack_require__(10);
var ThemeManager = __webpack_require__(12);
var DefaultRawTheme = __webpack_require__(11);

var CardHeader = React.createClass({
  displayName: 'CardHeader',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  propTypes: {
    title: React.PropTypes.node,
    titleColor: React.PropTypes.string,
    titleStyle: React.PropTypes.object,
    subtitle: React.PropTypes.node,
    subtitleColor: React.PropTypes.string,
    subtitleStyle: React.PropTypes.object,
    textStyle: React.PropTypes.object,
    expandable: React.PropTypes.bool,
    actAsExpander: React.PropTypes.bool,
    showExpandableButton: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      titleColor: Styles.Colors.darkBlack,
      subtitleColor: Styles.Colors.lightBlack
    };
  },

  getStyles: function getStyles() {
    return {
      root: {
        height: 72,
        padding: 16,
        fontWeight: Styles.Typography.fontWeightMedium,
        boxSizing: 'border-box',
        position: 'relative'
      },
      text: {
        display: 'inline-block',
        verticalAlign: 'top'
      },
      avatar: {
        marginRight: 16
      },
      title: {
        color: this.props.titleColor,
        display: 'block',
        fontSize: 15
      },
      subtitle: {
        color: this.props.subtitleColor,
        display: 'block',
        fontSize: 14
      }
    };
  },

  render: function render() {
    var styles = this.getStyles();
    var rootStyle = this.prepareStyles(styles.root, this.props.style);
    var textStyle = this.prepareStyles(styles.text, this.props.textStyle);
    var titleStyle = this.prepareStyles(styles.title, this.props.titleStyle);
    var subtitleStyle = this.prepareStyles(styles.subtitle, this.props.subtitleStyle);

    var avatar = this.props.avatar;
    if (React.isValidElement(this.props.avatar)) {
      var avatarMergedStyle = this.mergeStyles(styles.avatar, avatar.props.style);
      avatar = React.cloneElement(avatar, { style: avatarMergedStyle });
    } else avatar = React.createElement(Avatar, { src: this.props.avatar, style: styles.avatar });

    return React.createElement(
      'div',
      _extends({}, this.props, { style: rootStyle }),
      avatar,
      React.createElement(
        'div',
        { style: textStyle },
        React.createElement(
          'span',
          { style: titleStyle },
          this.props.title
        ),
        React.createElement(
          'span',
          { style: subtitleStyle },
          this.props.subtitle
        )
      ),
      this.props.children
    );
  }
});

module.exports = CardHeader;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Colors = __webpack_require__(53);
var ColorManipulator = __webpack_require__(95);
var Spacing = __webpack_require__(349);

module.exports = {
  spacing: Spacing,
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: Colors.cyan700,
    primary2Color: Colors.cyan700,
    primary3Color: Colors.grey600,
    accent1Color: Colors.pinkA200,
    accent2Color: Colors.pinkA400,
    accent3Color: Colors.pinkA100,
    textColor: Colors.fullWhite,
    alternateTextColor: '#303030',
    canvasColor: '#303030',
    borderColor: ColorManipulator.fade(Colors.fullWhite, 0.3),
    disabledColor: ColorManipulator.fade(Colors.fullWhite, 0.3)
  }
};

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

module.exports = function (customTheme) {

  return function (Component) {

    return React.createClass({

      childContextTypes: {
        muiTheme: React.PropTypes.object
      },

      getChildContext: function getChildContext() {
        return {
          muiTheme: customTheme
        };
      },

      render: function render() {
        return React.createElement(Component, this.props);
      }
    });
  };
};

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(0);
var Styles = __webpack_require__(190);
var StylePropable = __webpack_require__(10);
var ThemeManager = __webpack_require__(12);
var DefaultRawTheme = __webpack_require__(11);

var CardMedia = React.createClass({
  displayName: 'CardMedia',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  propTypes: {
    overlay: React.PropTypes.node,
    style: React.PropTypes.object,
    overlayStyle: React.PropTypes.object,
    overlayContainerStyle: React.PropTypes.object,
    overlayContentStyle: React.PropTypes.object,
    mediaStyle: React.PropTypes.object,
    expandable: React.PropTypes.bool,
    actAsExpander: React.PropTypes.bool
  },

  getStyles: function getStyles() {
    return {
      root: {
        position: 'relative'
      },
      overlayContainer: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0
      },
      overlay: {
        height: '100%',
        position: 'relative'
      },
      overlayContent: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        left: 0,
        paddingTop: 8,
        background: Styles.Colors.lightBlack
      },
      media: {},
      mediaChild: {
        verticalAlign: 'top',
        maxWidth: '100%',
        minWidth: '100%',
        width: '100%'
      }
    };
  },

  render: function render() {
    var _this = this;

    var styles = this.getStyles();
    var rootStyle = this.prepareStyles(styles.root, this.props.style);
    var mediaStyle = this.prepareStyles(styles.media, this.props.mediaStyle);
    var overlayContainerStyle = this.prepareStyles(styles.overlayContainer, this.props.overlayContainerStyle);
    var overlayContentStyle = this.prepareStyles(styles.overlayContent, this.props.overlayContentStyle);
    var overlayStyle = this.prepareStyles(styles.overlay, this.props.overlayStyle);

    var children = React.Children.map(this.props.children, function (child) {
      return React.cloneElement(child, { style: _this.prepareStyles(styles.mediaChild, child.props.style) });
    });

    var overlayChildren = React.Children.map(this.props.overlay, function (child) {
      if (child.type.displayName === 'CardHeader' || child.type.displayName === 'CardTitle') {
        return React.cloneElement(child, {
          titleColor: Styles.Colors.darkWhite,
          subtitleColor: Styles.Colors.lightWhite
        });
      } else if (child.type.displayName === 'CardText') {
        return React.cloneElement(child, {
          color: Styles.Colors.darkWhite
        });
      } else {
        return child;
      }
    });

    return React.createElement(
      'div',
      _extends({}, this.props, { style: rootStyle }),
      React.createElement(
        'div',
        { style: mediaStyle },
        children
      ),
      this.props.overlay ? React.createElement(
        'div',
        { style: overlayContainerStyle },
        React.createElement(
          'div',
          { style: overlayStyle },
          React.createElement(
            'div',
            { style: overlayContentStyle },
            overlayChildren
          )
        )
      ) : ''
    );
  }
});

module.exports = CardMedia;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(0);
var Styles = __webpack_require__(190);
var StylePropable = __webpack_require__(10);
var ThemeManager = __webpack_require__(12);
var DefaultRawTheme = __webpack_require__(11);

var CardText = React.createClass({
  displayName: 'CardText',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  propTypes: {
    color: React.PropTypes.string,
    style: React.PropTypes.object,
    expandable: React.PropTypes.bool,
    actAsExpander: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      color: Styles.Colors.ck
    };
  },

  getStyles: function getStyles() {
    return {
      root: {
        padding: 16,
        fontSize: '14px',
        color: this.props.color
      }
    };
  },

  render: function render() {
    var styles = this.getStyles();
    var rootStyle = this.prepareStyles(styles.root, this.props.style);

    return React.createElement(
      'div',
      _extends({}, this.props, { style: rootStyle }),
      this.props.children
    );
  }
});

module.exports = CardText;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(0);
var Styles = __webpack_require__(190);
var StylePropable = __webpack_require__(10);
var ThemeManager = __webpack_require__(12);
var DefaultRawTheme = __webpack_require__(11);

var CardTitle = React.createClass({
  displayName: 'CardTitle',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  propTypes: {
    title: React.PropTypes.string,
    titleColor: React.PropTypes.string,
    titleStyle: React.PropTypes.object,
    subtitle: React.PropTypes.string,
    subtitleColor: React.PropTypes.string,
    subtitleStyle: React.PropTypes.object,
    expandable: React.PropTypes.bool,
    actAsExpander: React.PropTypes.bool,
    showExpandableButton: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      titleColor: Styles.Colors.darkBlack,
      subtitleColor: Styles.Colors.lightBlack
    };
  },

  getStyles: function getStyles() {
    return {
      root: {
        padding: 16,
        position: 'relative'
      },
      title: {
        fontSize: 24,
        color: this.props.titleColor,
        display: 'block',
        lineHeight: '36px'
      },
      subtitle: {
        fontSize: 14,
        color: this.props.subtitleColor,
        display: 'block'
      }
    };
  },

  render: function render() {
    var styles = this.getStyles();
    var rootStyle = this.prepareStyles(styles.root, this.props.style);
    var titleStyle = this.prepareStyles(styles.title, this.props.titleStyle);
    var subtitleStyle = this.prepareStyles(styles.subtitle, this.props.subtitleStyle);

    return React.createElement(
      'div',
      _extends({}, this.props, { style: rootStyle }),
      React.createElement(
        'span',
        { style: titleStyle },
        this.props.title
      ),
      React.createElement(
        'span',
        { style: subtitleStyle },
        this.props.subtitle
      ),
      this.props.children
    );
  }
});

module.exports = CardTitle;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var AutoPrefix = __webpack_require__(62);
var Transitions = __webpack_require__(21);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var CircularProgress = React.createClass({
  displayName: 'CircularProgress',

  mixins: [StylePropable],

  propTypes: {
    mode: React.PropTypes.oneOf(["determinate", "indeterminate"]),
    value: React.PropTypes.number,
    min: React.PropTypes.number,
    max: React.PropTypes.number,
    size: React.PropTypes.number,
    color: React.PropTypes.string,
    innerStyle: React.PropTypes.object
  },

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  _getRelativeValue: function _getRelativeValue() {
    var value = this.props.value;
    var min = this.props.min;
    var max = this.props.max;

    var clampedValue = Math.min(Math.max(min, value), max);
    var rangeValue = max - min;
    var relValue = Math.round(clampedValue / rangeValue * 10000) / 10000;
    return relValue * 100;
  },

  componentDidMount: function componentDidMount() {
    var wrapper = ReactDOM.findDOMNode(this.refs.wrapper);
    var path = ReactDOM.findDOMNode(this.refs.path);

    this._scalePath(path);
    this._rotateWrapper(wrapper);
  },

  _scalePath: function _scalePath(path, step) {
    step = step || 0;
    step %= 3;

    setTimeout(this._scalePath.bind(this, path, step + 1), step ? 750 : 250);

    if (!this.isMounted()) return;
    if (this.props.mode !== "indeterminate") return;

    if (step === 0) {
      path.style.strokeDasharray = "1, 200";
      path.style.strokeDashoffset = 0;
      path.style.transitionDuration = "0ms";
    } else if (step === 1) {
      path.style.strokeDasharray = "89, 200";
      path.style.strokeDashoffset = -35;
      path.style.transitionDuration = "750ms";
    } else {
      path.style.strokeDasharray = "89,200";
      path.style.strokeDashoffset = -124;
      path.style.transitionDuration = "850ms";
    }
  },

  _rotateWrapper: function _rotateWrapper(wrapper) {
    setTimeout(this._rotateWrapper.bind(this, wrapper), 10050);

    if (!this.isMounted()) return;
    if (this.props.mode !== "indeterminate") return;

    AutoPrefix.set(wrapper.style, "transform", null);
    AutoPrefix.set(wrapper.style, "transform", "rotate(0deg)");
    wrapper.style.transitionDuration = "0ms";

    setTimeout(function () {
      AutoPrefix.set(wrapper.style, "transform", "rotate(1800deg)");
      wrapper.style.transitionDuration = "10s";
      //wrapper.style.webkitTransitionTimingFunction = "linear";
      AutoPrefix.set(wrapper.style, "transitionTimingFunction", "linear");
    }, 50);
  },

  getDefaultProps: function getDefaultProps() {
    return {
      mode: "indeterminate",
      value: 0,
      min: 0,
      max: 100,
      size: 1
    };
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.rawTheme.palette;
  },

  getStyles: function getStyles(zoom) {
    zoom *= 1.4;
    var size = "50px";

    var margin = Math.round((50 * zoom - 50) / 2);

    if (margin < 0) margin = 0;

    var styles = {
      root: {
        position: "relative",
        margin: margin + "px",
        display: "inline-block",
        width: size,
        height: size
      },
      wrapper: {
        width: size,
        height: size,
        margin: "5px",
        display: "inline-block",
        transition: Transitions.create("transform", "20s", null, "linear")
      },
      svg: {
        height: size,
        position: "relative",
        transform: "scale(" + zoom + ")",
        width: size
      },
      path: {
        strokeDasharray: "89,200",
        strokeDashoffset: 0,
        stroke: this.props.color || this.getTheme().primary1Color,
        strokeLinecap: "round",
        transition: Transitions.create("all", "1.5s", null, "ease-in-out")
      }
    };

    AutoPrefix.set(styles.wrapper, "transitionTimingFunction", "linear");

    if (this.props.mode === "determinate") {
      var relVal = this._getRelativeValue();
      styles.path.transition = Transitions.create("all", "0.3s", null, "linear");
      styles.path.strokeDasharray = Math.round(relVal * 1.25) + ",200";
    }

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var style = _props.style;
    var innerStyle = _props.innerStyle;
    var size = _props.size;

    var other = _objectWithoutProperties(_props, ['style', 'innerStyle', 'size']);

    var styles = this.getStyles(size || 1);

    return React.createElement(
      'div',
      _extends({}, other, { style: this.prepareStyles(styles.root, style) }),
      React.createElement(
        'div',
        { ref: 'wrapper', style: this.prepareStyles(styles.wrapper, innerStyle) },
        React.createElement(
          'svg',
          { style: this.prepareStyles(styles.svg) },
          React.createElement('circle', { ref: 'path', style: this.prepareStyles(styles.path), cx: '25', cy: '25',
            r: '20', fill: 'none', strokeWidth: '2.5', strokeMiterlimit: '10' })
        )
      )
    );
  }
});

module.exports = CircularProgress;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var WindowListenable = __webpack_require__(103);
var DateTime = __webpack_require__(138);
var DatePickerDialog = __webpack_require__(528);
var TextField = __webpack_require__(246);
var ThemeManager = __webpack_require__(12);
var DefaultRawTheme = __webpack_require__(11);

var DatePicker = React.createClass({
  displayName: 'DatePicker',

  mixins: [StylePropable, WindowListenable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    autoOk: React.PropTypes.bool,
    defaultDate: React.PropTypes.object,
    formatDate: React.PropTypes.func,
    hideToolbarYearChange: React.PropTypes.bool,
    maxDate: React.PropTypes.object,
    minDate: React.PropTypes.object,
    mode: React.PropTypes.oneOf(['portrait', 'landscape', 'inline']),
    onDismiss: React.PropTypes.func,
    onChange: React.PropTypes.func,
    onFocus: React.PropTypes.func,
    onShow: React.PropTypes.func,
    onTouchTap: React.PropTypes.func,
    shouldDisableDate: React.PropTypes.func,
    showYearSelector: React.PropTypes.bool,
    style: React.PropTypes.object,
    textFieldStyle: React.PropTypes.object
  },

  windowListeners: {
    keyup: '_handleWindowKeyUp'
  },

  getDefaultProps: function getDefaultProps() {
    return {
      formatDate: DateTime.format,
      autoOk: false,
      showYearSelector: false,
      style: {}
    };
  },

  getInitialState: function getInitialState() {
    return {
      date: this._isControlled() ? this._getControlledDate() : this.props.defaultDate,
      dialogDate: new Date(),
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this._isControlled()) {
      var newDate = this._getControlledDate(nextProps);
      if (!DateTime.isEqualDate(this.state.date, newDate)) {
        this.setState({
          date: newDate
        });
      }
    }
  },

  render: function render() {
    var _props = this.props;
    var autoOk = _props.autoOk;
    var defaultDate = _props.defaultDate;
    var formatDate = _props.formatDate;
    var maxDate = _props.maxDate;
    var minDate = _props.minDate;
    var mode = _props.mode;
    var onDismiss = _props.onDismiss;
    var onFocus = _props.onFocus;
    var onShow = _props.onShow;
    var onTouchTap = _props.onTouchTap;
    var showYearSelector = _props.showYearSelector;
    var style = _props.style;
    var textFieldStyle = _props.textFieldStyle;
    var valueLink = _props.valueLink;

    var other = _objectWithoutProperties(_props, ['autoOk', 'defaultDate', 'formatDate', 'maxDate', 'minDate', 'mode', 'onDismiss', 'onFocus', 'onShow', 'onTouchTap', 'showYearSelector', 'style', 'textFieldStyle', 'valueLink']);

    return React.createElement(
      'div',
      { style: this.prepareStyles(style) },
      React.createElement(TextField, _extends({}, other, {
        style: textFieldStyle,
        ref: 'input',
        value: this.state.date ? formatDate(this.state.date) : undefined,
        onFocus: this._handleInputFocus,
        onTouchTap: this._handleInputTouchTap })),
      React.createElement(DatePickerDialog, {
        ref: 'dialogWindow',
        mode: mode,
        initialDate: this.state.dialogDate,
        onAccept: this._handleDialogAccept,
        onShow: onShow,
        onDismiss: this._handleDialogDismiss,
        minDate: minDate,
        maxDate: maxDate,
        autoOk: autoOk,
        showYearSelector: showYearSelector,
        shouldDisableDate: this.props.shouldDisableDate,
        hideToolbarYearChange: this.props.hideToolbarYearChange })
    );
  },

  getDate: function getDate() {
    return this.state.date;
  },

  setDate: function setDate(d) {
    if (false) {
      console.error('Cannot call DatePicker.setDate when value or valueLink is defined as a property.');
    }
    this.setState({
      date: d
    });
  },

  /**
   * Open the date-picker dialog programmatically from a parent.
   */
  openDialog: function openDialog() {
    this.setState({
      dialogDate: this.getDate()
    }, this.refs.dialogWindow.show);
  },

  /**
   * Alias for `openDialog()` for an api consistent with TextField.
   */
  focus: function focus() {
    this.openDialog();
  },

  _handleDialogAccept: function _handleDialogAccept(d) {
    if (!this._isControlled()) {
      this.setDate(d);
    }
    if (this.props.onChange) this.props.onChange(null, d);
    if (this.props.valueLink) this.props.valueLink.requestChange(d);
  },

  _handleDialogDismiss: function _handleDialogDismiss() {
    if (this.props.onDismiss) this.props.onDismiss();
  },

  _handleInputFocus: function _handleInputFocus(e) {
    e.target.blur();
    if (this.props.onFocus) this.props.onFocus(e);
  },

  _handleInputTouchTap: function _handleInputTouchTap(event) {
    var _this = this;

    if (this.props.onTouchTap) this.props.onTouchTap(event);

    setTimeout(function () {
      _this.openDialog();
    }, 0);
  },

  _handleWindowKeyUp: function _handleWindowKeyUp() {
    //TO DO: open the dialog if input has focus
  },

  _isControlled: function _isControlled() {
    return this.props.hasOwnProperty('value') || this.props.hasOwnProperty('valueLink');
  },

  _getControlledDate: function _getControlledDate() {
    var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];

    if (DateTime.isDateObject(props.value)) {
      return props.value;
    } else if (props.valueLink && DateTime.isDateObject(props.valueLink.value)) {
      return props.valueLink.value;
    }
  }

});

module.exports = DatePicker;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var WindowListenable = __webpack_require__(103);
var DateTime = __webpack_require__(138);
var KeyCode = __webpack_require__(79);
var Transitions = __webpack_require__(21);
var CalendarMonth = __webpack_require__(1032);
var CalendarYear = __webpack_require__(1034);
var CalendarToolbar = __webpack_require__(1036);
var DateDisplay = __webpack_require__(1038);
var SlideInTransitionGroup = __webpack_require__(360);
var ClearFix = __webpack_require__(191);
var ThemeManager = __webpack_require__(12);
var DefaultRawTheme = __webpack_require__(11);

var Calendar = React.createClass({
  displayName: 'Calendar',

  mixins: [StylePropable, WindowListenable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    disableYearSelection: React.PropTypes.bool,
    initialDate: React.PropTypes.object,
    isActive: React.PropTypes.bool,
    minDate: React.PropTypes.object,
    maxDate: React.PropTypes.object,
    onDayTouchTap: React.PropTypes.func,
    shouldDisableDate: React.PropTypes.func
  },

  windowListeners: {
    'keydown': '_handleWindowKeyDown'
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disableYearSelection: false,
      initialDate: new Date(),
      minDate: DateTime.addYears(new Date(), -100),
      maxDate: DateTime.addYears(new Date(), 100)
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme),
      displayDate: DateTime.getFirstDayOfMonth(this.props.initialDate),
      displayMonthDay: true,
      selectedDate: this.props.initialDate,
      transitionDirection: 'left',
      transitionEnter: true
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });

    if (nextProps.initialDate !== this.props.initialDate) {
      var d = nextProps.initialDate || new Date();
      this.setState({
        displayDate: DateTime.getFirstDayOfMonth(d),
        selectedDate: d
      });
    }
  },

  render: function render() {
    var yearCount = DateTime.yearDiff(this.props.maxDate, this.props.minDate) + 1;
    var weekCount = DateTime.getWeekArray(this.state.displayDate).length;
    var toolbarInteractions = this._getToolbarInteractions();
    var isLandscape = this.props.mode === 'landscape';
    var styles = {
      root: {
        fontSize: 12
      },
      calendarContainer: {
        width: isLandscape ? 320 : '100%',
        height: weekCount === 5 ? 284 : weekCount === 6 ? 324 : 244,
        float: isLandscape ? 'right' : 'none',
        transition: Transitions.easeOut('150ms', 'height'),
        overflow: 'hidden'
      },
      yearContainer: {
        width: 280,
        overflow: 'hidden',
        height: yearCount < 6 ? yearCount * 56 + 10 : weekCount === 5 ? 284 : weekCount === 6 ? 324 : 244,
        float: isLandscape ? 'right' : 'none'
      },
      dateDisplay: {
        width: isLandscape ? 120 : '',
        height: isLandscape ? weekCount === 5 ? 238 : weekCount === 6 ? 278 : 198 : '100%',
        float: isLandscape ? 'left' : 'none'
      },
      weekTitle: {
        padding: '0 14px',
        lineHeight: '12px',
        opacity: '0.5',
        height: 12,
        fontWeight: '500',
        margin: 0
      },
      weekTitleDay: {
        listStyle: 'none',
        float: 'left',
        width: 37,
        textAlign: 'center',
        margin: '0 2px'
      }
    };

    var weekTitleDayStyle = this.prepareStyles(styles.weekTitleDay);

    return React.createElement(
      ClearFix,
      { style: this.mergeStyles(styles.root) },
      React.createElement(DateDisplay, {
        disableYearSelection: this.props.disableYearSelection,
        style: styles.dateDisplay,
        selectedDate: this.state.selectedDate,
        handleMonthDayClick: this._handleMonthDayClick,
        handleYearClick: this._handleYearClick,
        monthDaySelected: this.state.displayMonthDay,
        mode: this.props.mode,
        weekCount: weekCount }),
      this.state.displayMonthDay && React.createElement(
        'div',
        { style: this.prepareStyles(styles.calendarContainer) },
        React.createElement(CalendarToolbar, {
          displayDate: this.state.displayDate,
          onMonthChange: this._handleMonthChange,
          prevMonth: toolbarInteractions.prevMonth,
          nextMonth: toolbarInteractions.nextMonth }),
        React.createElement(
          ClearFix,
          {
            elementType: 'ul',
            style: styles.weekTitle },
          React.createElement(
            'li',
            { style: weekTitleDayStyle },
            'S'
          ),
          React.createElement(
            'li',
            { style: weekTitleDayStyle },
            'M'
          ),
          React.createElement(
            'li',
            { style: weekTitleDayStyle },
            'T'
          ),
          React.createElement(
            'li',
            { style: weekTitleDayStyle },
            'W'
          ),
          React.createElement(
            'li',
            { style: weekTitleDayStyle },
            'T'
          ),
          React.createElement(
            'li',
            { style: weekTitleDayStyle },
            'F'
          ),
          React.createElement(
            'li',
            { style: weekTitleDayStyle },
            'S'
          )
        ),
        React.createElement(
          SlideInTransitionGroup,
          {
            direction: this.state.transitionDirection },
          React.createElement(CalendarMonth, {
            key: this.state.displayDate.toDateString(),
            ref: 'calendar',
            displayDate: this.state.displayDate,
            onDayTouchTap: this._handleDayTouchTap,
            selectedDate: this.state.selectedDate,
            minDate: this.props.minDate,
            maxDate: this.props.maxDate,
            shouldDisableDate: this.props.shouldDisableDate })
        )
      ),
      !this.state.displayMonthDay && React.createElement(
        'div',
        { style: this.prepareStyles(styles.yearContainer) },
        this._yearSelector()
      )
    );
  },

  _yearSelector: function _yearSelector() {
    if (this.props.disableYearSelection) return;

    return React.createElement(CalendarYear, {
      key: 'years',
      displayDate: this.state.displayDate,
      onYearTouchTap: this._handleYearTouchTap,
      selectedDate: this.state.selectedDate,
      minDate: this.props.minDate,
      maxDate: this.props.maxDate });
  },

  getSelectedDate: function getSelectedDate() {
    return this.state.selectedDate;
  },

  isSelectedDateDisabled: function isSelectedDateDisabled() {
    return this.refs.calendar.isSelectedDateDisabled();
  },

  _addSelectedDays: function _addSelectedDays(days) {
    this._setSelectedDate(DateTime.addDays(this.state.selectedDate, days));
  },

  _addSelectedMonths: function _addSelectedMonths(months) {
    this._setSelectedDate(DateTime.addMonths(this.state.selectedDate, months));
  },

  _addSelectedYears: function _addSelectedYears(years) {
    this._setSelectedDate(DateTime.addYears(this.state.selectedDate, years));
  },

  _setDisplayDate: function _setDisplayDate(d, newSelectedDate) {
    var newDisplayDate = DateTime.getFirstDayOfMonth(d);
    var direction = newDisplayDate > this.state.displayDate ? 'left' : 'right';

    if (newDisplayDate !== this.state.displayDate) {
      this.setState({
        displayDate: newDisplayDate,
        transitionDirection: direction,
        selectedDate: newSelectedDate || this.state.selectedDate
      });
    }
  },

  _setSelectedDate: function _setSelectedDate(date) {
    var adjustedDate = date;
    if (DateTime.isBeforeDate(date, this.props.minDate)) {
      adjustedDate = this.props.minDate;
    } else if (DateTime.isAfterDate(date, this.props.maxDate)) {
      adjustedDate = this.props.maxDate;
    }

    var newDisplayDate = DateTime.getFirstDayOfMonth(adjustedDate);
    if (newDisplayDate !== this.state.displayDate) {
      this._setDisplayDate(newDisplayDate, adjustedDate);
    } else {
      this.setState({
        selectedDate: adjustedDate
      });
    }
  },

  _handleDayTouchTap: function _handleDayTouchTap(e, date) {
    this._setSelectedDate(date);
    if (this.props.onDayTouchTap) this.props.onDayTouchTap(e, date);
  },

  _handleMonthChange: function _handleMonthChange(months) {
    this.setState({ displayDate: DateTime.addMonths(this.state.displayDate, months) });
  },

  _handleYearTouchTap: function _handleYearTouchTap(e, year) {
    var date = DateTime.clone(this.state.selectedDate);
    date.setFullYear(year);
    this._setSelectedDate(date, e);
  },

  _getToolbarInteractions: function _getToolbarInteractions() {
    return {
      prevMonth: DateTime.monthDiff(this.state.displayDate, this.props.minDate) > 0,
      nextMonth: DateTime.monthDiff(this.state.displayDate, this.props.maxDate) < 0
    };
  },

  _handleMonthDayClick: function _handleMonthDayClick() {
    this.setState({
      displayMonthDay: true
    });
  },

  _handleYearClick: function _handleYearClick() {
    this.setState({
      displayMonthDay: false
    });
  },

  _handleWindowKeyDown: function _handleWindowKeyDown(e) {
    if (this.props.isActive) {

      switch (e.keyCode) {
        case KeyCode.UP:
          if (e.altKey && e.shiftKey) {
            this._addSelectedYears(-1);
          } else if (e.shiftKey) {
            this._addSelectedMonths(-1);
          } else {
            this._addSelectedDays(-7);
          }
          break;

        case KeyCode.DOWN:
          if (e.altKey && e.shiftKey) {
            this._addSelectedYears(1);
          } else if (e.shiftKey) {
            this._addSelectedMonths(1);
          } else {
            this._addSelectedDays(7);
          }
          break;

        case KeyCode.RIGHT:
          if (e.altKey && e.shiftKey) {
            this._addSelectedYears(1);
          } else if (e.shiftKey) {
            this._addSelectedMonths(1);
          } else {
            this._addSelectedDays(1);
          }
          break;

        case KeyCode.LEFT:
          if (e.altKey && e.shiftKey) {
            this._addSelectedYears(-1);
          } else if (e.shiftKey) {
            this._addSelectedMonths(-1);
          } else {
            this._addSelectedDays(-1);
          }
          break;
      }
    }
  }

});

module.exports = Calendar;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var DateTime = __webpack_require__(138);
var DayButton = __webpack_require__(1033);
var ClearFix = __webpack_require__(191);

var CalendarMonth = React.createClass({
  displayName: 'CalendarMonth',

  propTypes: {
    displayDate: React.PropTypes.object.isRequired,
    selectedDate: React.PropTypes.object.isRequired,
    autoOk: React.PropTypes.bool,
    maxDate: React.PropTypes.object,
    minDate: React.PropTypes.object,
    onDayTouchTap: React.PropTypes.func,
    shouldDisableDate: React.PropTypes.func
  },

  render: function render() {
    var styles = {
      lineHeight: '32px',
      textAlign: 'center',
      padding: '16px 14px 0 14px'
    };

    return React.createElement(
      'div',
      { style: styles },
      this._getWeekElements()
    );
  },

  isSelectedDateDisabled: function isSelectedDateDisabled() {
    return this._selectedDateDisabled;
  },

  _getWeekElements: function _getWeekElements() {
    var _this = this;

    var weekArray = DateTime.getWeekArray(this.props.displayDate);

    return weekArray.map(function (week, i) {
      return React.createElement(
        ClearFix,
        { key: i },
        _this._getDayElements(week, i)
      );
    }, this);
  },

  _getDayElements: function _getDayElements(week, i) {
    var _this2 = this;

    return week.map(function (day, j) {
      var isSameDate = DateTime.isEqualDate(_this2.props.selectedDate, day);
      var disabled = _this2._shouldDisableDate(day);
      var selected = !disabled && isSameDate;

      if (isSameDate) {
        if (disabled) {
          _this2._selectedDateDisabled = true;
        } else {
          _this2._selectedDateDisabled = false;
        }
      }

      return React.createElement(DayButton, {
        key: 'db' + i + j,
        date: day,
        onTouchTap: _this2._handleDayTouchTap,
        selected: selected,
        disabled: disabled });
    }, this);
  },

  _handleDayTouchTap: function _handleDayTouchTap(e, date) {
    if (this.props.onDayTouchTap) this.props.onDayTouchTap(e, date);
  },

  _shouldDisableDate: function _shouldDisableDate(day) {
    if (day === null) return false;
    var disabled = !DateTime.isBetweenDates(day, this.props.minDate, this.props.maxDate);
    if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);

    return disabled;
  }

});

module.exports = CalendarMonth;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var Transition = __webpack_require__(21);
var DateTime = __webpack_require__(138);
var EnhancedButton = __webpack_require__(102);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var DayButton = React.createClass({
  displayName: 'DayButton',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    date: React.PropTypes.object,
    onTouchTap: React.PropTypes.func,
    selected: React.PropTypes.bool,
    disabled: React.PropTypes.bool
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      selected: false,
      disabled: false
    };
  },

  getInitialState: function getInitialState() {
    return {
      hover: false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.datePicker;
  },

  render: function render() {
    var _props = this.props;
    var date = _props.date;
    var onTouchTap = _props.onTouchTap;
    var selected = _props.selected;

    var other = _objectWithoutProperties(_props, ['date', 'onTouchTap', 'selected']);

    var styles = {
      root: {
        boxSizing: 'border-box',
        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
        position: 'relative',
        float: 'left',
        width: 41,
        padding: '4px 2px'
      },

      label: {
        position: 'relative',
        color: this.state.muiTheme.rawTheme.palette.textColor
      },

      buttonState: {
        position: 'absolute',
        height: 36,
        width: 36,
        top: 2,
        opacity: 0,
        borderRadius: '50%',
        transform: 'scale(0)',
        transition: Transition.easeOut(),
        backgroundColor: this.getTheme().selectColor
      }
    };

    if (this.state.hover) {
      styles.label.color = this.getTheme().selectTextColor;
      styles.buttonState.opacity = '0.6';
      styles.buttonState.transform = 'scale(1)';
    }

    if (this.props.selected) {
      styles.label.color = this.getTheme().selectTextColor;
      styles.buttonState.opacity = 1;
      styles.buttonState.transform = 'scale(1)';
    } else if (this.props.disabled) {
      styles.root.opacity = '0.6';
    }

    if (DateTime.isEqualDate(this.props.date, new Date()) && !this.props.selected) {
      styles.label.color = this.getTheme().color;
    }

    return this.props.date ? React.createElement(
      EnhancedButton,
      _extends({}, other, {
        style: styles.root,
        hoverStyle: styles.hover,
        disabled: this.props.disabled,
        disableFocusRipple: true,
        disableTouchRipple: true,
        onMouseEnter: this._handleMouseEnter,
        onMouseLeave: this._handleMouseLeave,
        onTouchTap: this._handleTouchTap,
        onKeyboardFocus: this._handleKeyboardFocus }),
      React.createElement('div', { style: this.prepareStyles(styles.buttonState) }),
      React.createElement(
        'span',
        { style: this.prepareStyles(styles.label) },
        this.props.date.getDate()
      )
    ) : React.createElement('span', { style: this.prepareStyles(styles.root) });
  },

  _handleMouseEnter: function _handleMouseEnter() {
    if (!this.props.disabled) this.setState({ hover: true });
  },

  _handleMouseLeave: function _handleMouseLeave() {
    if (!this.props.disabled) this.setState({ hover: false });
  },

  _handleTouchTap: function _handleTouchTap(e) {
    if (!this.props.disabled && this.props.onTouchTap) this.props.onTouchTap(e, this.props.date);
  },

  _handleKeyboardFocus: function _handleKeyboardFocus(e, keyboardFocused) {
    if (!this.props.disabled && this.props.onKeyboardFocus) this.props.onKeyboardFocus(e, keyboardFocused, this.props.date);
  }

});

module.exports = DayButton;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var Colors = __webpack_require__(53);
var DateTime = __webpack_require__(138);
var YearButton = __webpack_require__(1035);

var CalendarYear = React.createClass({
  displayName: 'CalendarYear',

  mixins: [StylePropable],

  propTypes: {
    displayDate: React.PropTypes.object.isRequired,
    onYearTouchTap: React.PropTypes.func,
    selectedDate: React.PropTypes.object.isRequired,
    minDate: React.PropTypes.object,
    maxDate: React.PropTypes.object
  },

  componentDidMount: function componentDidMount() {
    this._scrollToSelectedYear();
  },

  componentDidUpdate: function componentDidUpdate() {
    this._scrollToSelectedYear();
  },

  render: function render() {
    var years = this._getYears();
    var styles = {
      position: 'relative',
      height: 'inherit',
      lineHeight: '36px',
      textAlign: 'center',
      padding: '8px 14px 0 14px',
      backgroundColor: Colors.white,
      overflowX: 'hidden',
      overflowY: 'scroll'
    };

    return React.createElement(
      'div',
      { style: styles },
      years
    );
  },

  _getYears: function _getYears() {
    var minYear = this.props.minDate.getFullYear();
    var maxYear = this.props.maxDate.getFullYear();

    var years = [];
    var dateCheck = DateTime.clone(this.props.selectedDate);
    for (var year = minYear; year <= maxYear; year++) {
      dateCheck.setFullYear(year);
      if (!DateTime.isBetweenDates(dateCheck, this.props.minDate, this.props.maxDate)) continue;
      var selected = this.props.selectedDate.getFullYear() === year;
      var selectedProps = {};
      if (selected) {
        selectedProps = { ref: 'selectedYearButton' };
      }

      var yearButton = React.createElement(YearButton, _extends({
        key: 'yb' + year,
        year: year,
        onTouchTap: this._handleYearTouchTap,
        selected: selected
      }, selectedProps));

      years.push(yearButton);
    }

    return years;
  },

  _scrollToSelectedYear: function _scrollToSelectedYear() {
    if (this.refs.selectedYearButton === undefined) return;

    var container = ReactDOM.findDOMNode(this);
    var yearButtonNode = ReactDOM.findDOMNode(this.refs.selectedYearButton);

    var containerHeight = container.clientHeight;
    var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;

    var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
    container.scrollTop = scrollYOffset;
  },

  _handleYearTouchTap: function _handleYearTouchTap(e, year) {
    if (this.props.onYearTouchTap) this.props.onYearTouchTap(e, year);
  }

});

module.exports = CalendarYear;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var EnhancedButton = __webpack_require__(102);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var YearButton = React.createClass({
  displayName: 'YearButton',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    year: React.PropTypes.number,
    onTouchTap: React.PropTypes.func,
    selected: React.PropTypes.bool
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      selected: false
    };
  },

  getInitialState: function getInitialState() {
    return {
      hover: false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.datePicker;
  },

  render: function render() {
    var _props = this.props;
    var className = _props.className;
    var year = _props.year;
    var onTouchTap = _props.onTouchTap;
    var selected = _props.selected;

    var other = _objectWithoutProperties(_props, ['className', 'year', 'onTouchTap', 'selected']);

    var styles = {
      root: {
        boxSizing: 'border-box',
        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
        position: 'relative',
        display: 'block',
        margin: '0 auto',
        width: 36,
        fontSize: 14,
        padding: '8px 2px'
      },

      label: {
        position: 'relative',
        top: -1,
        color: this.state.muiTheme.rawTheme.palette.textColor
      },

      buttonState: {
        position: 'absolute',
        height: 32,
        width: 32,
        opacity: 0,
        borderRadius: '50%',
        transform: 'scale(0)',
        backgroundColor: this.getTheme().selectColor
      }
    };

    if (this.state.hover) {
      styles.label.color = this.getTheme().selectTextColor;
      styles.buttonState.opacity = 0.6;
      styles.buttonState.transform = 'scale(1.5)';
    }

    if (selected) {
      styles.label.color = this.getTheme().selectTextColor;
      styles.buttonState.opacity = 1;
      styles.buttonState.transform = 'scale(1.5)';
    }

    if (year === new Date().getFullYear()) {
      styles.root.color = this.getTheme().color;
    }

    return React.createElement(
      EnhancedButton,
      _extends({}, other, {
        style: styles.root,
        disableFocusRipple: true,
        disableTouchRipple: true,
        onMouseEnter: this._handleMouseEnter,
        onMouseLeave: this._handleMouseLeave,
        onTouchTap: this._handleTouchTap }),
      React.createElement('div', { style: this.prepareStyles(styles.buttonState) }),
      React.createElement(
        'span',
        { style: this.prepareStyles(styles.label) },
        year
      )
    );
  },

  _handleMouseEnter: function _handleMouseEnter() {
    this.setState({ hover: true });
  },

  _handleMouseLeave: function _handleMouseLeave() {
    this.setState({ hover: false });
  },

  _handleTouchTap: function _handleTouchTap(e) {
    if (this.props.onTouchTap) this.props.onTouchTap(e, this.props.year);
  }

});

module.exports = YearButton;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var DateTime = __webpack_require__(138);
var IconButton = __webpack_require__(186);
var Toolbar = __webpack_require__(529);
var ToolbarGroup = __webpack_require__(530);
var NavigationChevronLeft = __webpack_require__(358);
var NavigationChevronRight = __webpack_require__(359);
var SlideInTransitionGroup = __webpack_require__(360);
var ThemeManager = __webpack_require__(12);
var DefaultRawTheme = __webpack_require__(11);

var CalendarToolbar = React.createClass({
  displayName: 'CalendarToolbar',

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    displayDate: React.PropTypes.object.isRequired,
    nextMonth: React.PropTypes.bool,
    onMonthChange: React.PropTypes.func,
    prevMonth: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      nextMonth: true,
      prevMonth: true
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme),
      transitionDirection: 'up'
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });

    var direction = undefined;

    if (nextProps.displayDate !== this.props.displayDate) {
      direction = nextProps.displayDate > this.props.displayDate ? 'up' : 'down';
      this.setState({
        transitionDirection: direction
      });
    }
  },

  _styles: function _styles() {
    return {
      root: {
        position: 'relative',
        padding: 0,
        backgroundColor: 'inherit'
      },

      title: {
        position: 'absolute',
        top: '17px',
        lineHeight: '14px',
        fontSize: '14px',
        height: '14px',
        width: '100%',
        fontWeight: '500',
        textAlign: 'center'
      }
    };
  },

  render: function render() {
    var month = DateTime.getFullMonth(this.props.displayDate);
    var year = this.props.displayDate.getFullYear();
    var styles = this._styles();

    var nextButtonIcon = this.state.muiTheme.isRtl ? React.createElement(NavigationChevronRight, null) : React.createElement(NavigationChevronLeft, null);
    var prevButtonIcon = this.state.muiTheme.isRtl ? React.createElement(NavigationChevronLeft, null) : React.createElement(NavigationChevronRight, null);

    return React.createElement(
      Toolbar,
      { className: 'mui-date-picker-calendar-toolbar', style: styles.root, noGutter: true },
      React.createElement(
        SlideInTransitionGroup,
        {
          style: styles.title,
          direction: this.state.transitionDirection },
        React.createElement(
          'div',
          { key: month + '_' + year },
          month,
          ' ',
          year
        )
      ),
      React.createElement(
        ToolbarGroup,
        { key: 0, float: 'left' },
        React.createElement(
          IconButton,
          {
            style: styles.button,
            disabled: !this.props.prevMonth,
            onTouchTap: this._prevMonthTouchTap },
          nextButtonIcon
        )
      ),
      React.createElement(
        ToolbarGroup,
        { key: 1, float: 'right' },
        React.createElement(
          IconButton,
          {
            style: styles.button,
            disabled: !this.props.nextMonth,
            onTouchTap: this._nextMonthTouchTap },
          prevButtonIcon
        )
      )
    );
  },

  _prevMonthTouchTap: function _prevMonthTouchTap() {
    if (this.props.onMonthChange && this.props.prevMonth) this.props.onMonthChange(-1);
  },

  _nextMonthTouchTap: function _nextMonthTouchTap() {
    if (this.props.onMonthChange && this.props.nextMonth) this.props.onMonthChange(1);
  }

});

module.exports = CalendarToolbar;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var AutoPrefix = __webpack_require__(62);
var Transitions = __webpack_require__(21);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var SlideInChild = React.createClass({
  displayName: 'SlideInChild',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  propTypes: {
    enterDelay: React.PropTypes.number,
    //This callback is needed bacause
    //the direction could change when leaving the dom
    getLeaveDirection: React.PropTypes.func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      enterDelay: 0
    };
  },

  componentWillEnter: function componentWillEnter(callback) {
    var _this = this;

    var style = ReactDOM.findDOMNode(this).style;
    var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
    var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';

    style.opacity = '0';
    AutoPrefix.set(style, 'transform', 'translate3d(' + x + ',' + y + ',0)');

    setTimeout(function () {
      if (_this.isMounted()) callback();
    }, this.props.enterDelay);
  },

  componentDidEnter: function componentDidEnter() {
    var style = ReactDOM.findDOMNode(this).style;
    style.opacity = '1';
    AutoPrefix.set(style, 'transform', 'translate3d(0,0,0)');
  },

  componentWillLeave: function componentWillLeave(callback) {
    var _this2 = this;

    var style = ReactDOM.findDOMNode(this).style;
    var direction = this.props.getLeaveDirection();
    var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
    var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';

    style.opacity = '0';
    AutoPrefix.set(style, 'transform', 'translate3d(' + x + ',' + y + ',0)');

    setTimeout(function () {
      if (_this2.isMounted()) callback();
    }, 450);
  },

  render: function render() {
    var _props = this.props;
    var children = _props.children;
    var enterDelay = _props.enterDelay;
    var getLeaveDirection = _props.getLeaveDirection;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);

    var mergedRootStyles = this.prepareStyles({
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: 0,
      left: 0,
      transition: Transitions.easeOut(null, ['transform', 'opacity'])
    }, style);

    return React.createElement(
      'div',
      _extends({}, other, { style: mergedRootStyles }),
      children
    );
  }

});

module.exports = SlideInChild;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DateTime = __webpack_require__(138);
var Transitions = __webpack_require__(21);
var AutoPrefix = __webpack_require__(62);
var SlideInTransitionGroup = __webpack_require__(360);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var DateDisplay = React.createClass({
  displayName: 'DateDisplay',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    disableYearSelection: React.PropTypes.bool,
    monthDaySelected: React.PropTypes.bool,
    selectedDate: React.PropTypes.object.isRequired,
    weekCount: React.PropTypes.number
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disableYearSelection: false,
      monthDaySelected: true,
      weekCount: 4
    };
  },

  getInitialState: function getInitialState() {
    return {
      selectedYear: !this.props.monthDaySelected,
      transitionDirection: 'up',
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });

    var direction = undefined;

    if (nextProps.selectedDate !== this.props.selectedDate) {
      direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
      this.setState({
        transitionDirection: direction
      });
    }

    if (nextProps.monthDaySelected !== undefined) {
      this.setState({ selectedYear: !nextProps.monthDaySelected });
    }
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.datePicker;
  },

  getStyles: function getStyles() {
    var theme = this.getTheme();
    var isLandscape = this.props.mode === 'landscape';

    var styles = {
      root: {
        backgroundColor: theme.selectColor,
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        color: theme.textColor,
        height: 60,
        padding: 20
      },

      month: {
        display: isLandscape ? 'block' : undefined,
        marginLeft: isLandscape ? undefined : 8,
        marginTop: isLandscape ? 5 : undefined
      },

      monthDay: {
        root: {
          display: 'inline-block',
          fontSize: 36,
          fontWeight: '400',
          lineHeight: '36px',
          height: isLandscape ? 76 : 38,
          opacity: this.state.selectedYear ? 0.7 : 1.0,
          transition: Transitions.easeOut(),
          width: '100%'
        },

        title: {
          cursor: !this.state.selectedYear ? 'default' : 'pointer'
        }
      },

      year: {
        root: {
          margin: 0,
          fontSize: 16,
          fontWeight: '400',
          lineHeight: '16px',
          height: 16,
          opacity: this.state.selectedYear ? 1.0 : 0.7,
          transition: Transitions.easeOut(),
          marginBottom: 10
        },

        title: {
          cursor: this.state.selectedYear && !this.props.disableYearSelection ? 'pointer' : 'default'
        }
      }
    };

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var selectedDate = _props.selectedDate;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['selectedDate', 'style']);

    var dayOfWeek = DateTime.getDayOfWeek(this.props.selectedDate);
    var month = DateTime.getShortMonth(this.props.selectedDate);
    var day = this.props.selectedDate.getDate();
    var year = this.props.selectedDate.getFullYear();
    var styles = this.getStyles();

    return React.createElement(
      'div',
      _extends({}, other, { style: this.prepareStyles(styles.root, this.props.style) }),
      React.createElement(
        SlideInTransitionGroup,
        {
          style: styles.year.root,
          direction: this.state.transitionDirection },
        React.createElement(
          'div',
          { key: year, style: styles.year.title, onTouchTap: this._handleYearClick },
          year
        )
      ),
      React.createElement(
        SlideInTransitionGroup,
        {
          style: styles.monthDay.root,
          direction: this.state.transitionDirection },
        React.createElement(
          'div',
          {
            key: dayOfWeek + month + day,
            style: styles.monthDay.title,
            onTouchTap: this._handleMonthDayClick },
          React.createElement(
            'span',
            null,
            dayOfWeek,
            ','
          ),
          React.createElement(
            'span',
            { style: styles.month },
            month,
            ' ',
            day
          )
        )
      )
    );
  },

  _handleMonthDayClick: function _handleMonthDayClick() {
    if (this.props.handleMonthDayClick && this.state.selectedYear) {
      this.props.handleMonthDayClick();
    }

    this.setState({ selectedYear: false });
  },

  _handleYearClick: function _handleYearClick() {
    if (this.props.handleYearClick && !this.props.disableYearSelection && !this.state.selectedYear) {
      this.props.handleYearClick();
    }

    if (!this.props.disableYearSelection) {
      this.setState({ selectedYear: true });
    }
  }

});

module.exports = DateDisplay;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ContextPure = __webpack_require__(136);
var StylePropable = __webpack_require__(10);
var Styles = __webpack_require__(348);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var FlatButtonLabel = React.createClass({
  displayName: 'FlatButtonLabel',

  mixins: [ContextPure, StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    label: React.PropTypes.node,
    style: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  statics: {
    getRelevantContextKeys: function getRelevantContextKeys(muiTheme) {
      return {
        spacingDesktopGutterLess: muiTheme.rawTheme.spacing.desktopGutterLess
      };
    }
  },

  render: function render() {
    var _props = this.props;
    var label = _props.label;
    var style = _props.style;

    var contextKeys = this.constructor.getRelevantContextKeys(this.state.muiTheme);

    var mergedRootStyles = this.mergeStyles({
      position: 'relative',
      padding: '0 ' + contextKeys.spacingDesktopGutterLess + 'px'
    }, style);

    return React.createElement(
      'span',
      { style: this.prepareStyles(mergedRootStyles) },
      label
    );
  }

});

module.exports = FlatButtonLabel;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var rowsHeight = 24;

var styles = {
  textarea: {
    width: '100%',
    resize: 'none',
    font: 'inherit',
    padding: 0
  },
  shadow: {
    width: '100%',
    resize: 'none',
    // Overflow also needed to here to remove the extra row
    // added to textareas in Firefox.
    overflow: 'hidden',
    font: 'inherit',
    padding: 0,
    position: 'absolute',
    opacity: 0
  }
};

var EnhancedTextarea = React.createClass({
  displayName: 'EnhancedTextarea',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    onChange: React.PropTypes.func,
    onHeightChange: React.PropTypes.func,
    textareaStyle: React.PropTypes.object,
    rows: React.PropTypes.number,
    rowsMax: React.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      rows: 1
    };
  },

  getInitialState: function getInitialState() {
    return {
      height: this.props.rows * rowsHeight,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  componentDidMount: function componentDidMount() {
    this._syncHeightWithShadow();
  },

  render: function render() {
    var _props = this.props;
    var onChange = _props.onChange;
    var onHeightChange = _props.onHeightChange;
    var rows = _props.rows;
    var style = _props.style;
    var textareaStyle = _props.textareaStyle;
    var valueLink = _props.valueLink;

    var other = _objectWithoutProperties(_props, ['onChange', 'onHeightChange', 'rows', 'style', 'textareaStyle', 'valueLink']);

    var textareaStyles = this.mergeStyles(styles.textarea, textareaStyle, {
      height: this.state.height
    });

    var shadowStyles = styles.shadow;

    if (this.props.hasOwnProperty('valueLink')) {
      other.value = this.props.valueLink.value;
    }

    if (this.props.disabled) {
      style.cursor = 'default';
    }

    return React.createElement(
      'div',
      { style: this.prepareStyles(this.props.style) },
      React.createElement('textarea', {
        ref: 'shadow',
        style: this.prepareStyles(shadowStyles),
        tabIndex: '-1',
        rows: this.props.rows,
        defaultValue: this.props.defaultValue,
        readOnly: true,
        value: this.props.value,
        valueLink: this.props.valueLink }),
      React.createElement('textarea', _extends({}, other, {
        ref: 'input',
        rows: this.props.rows,
        style: this.prepareStyles(textareaStyles),
        onChange: this._handleChange }))
    );
  },

  getInputNode: function getInputNode() {
    return ReactDOM.findDOMNode(this.refs.input);
  },

  setValue: function setValue(value) {
    this.getInputNode().value = value;
    this._syncHeightWithShadow(value);
  },

  _syncHeightWithShadow: function _syncHeightWithShadow(newValue, e) {
    var shadow = ReactDOM.findDOMNode(this.refs.shadow);

    if (newValue !== undefined) {
      shadow.value = newValue;
    }

    var newHeight = shadow.scrollHeight;

    if (this.props.rowsMax > this.props.rows) {
      newHeight = Math.min(this.props.rowsMax * rowsHeight, newHeight);
    }

    if (this.state.height !== newHeight) {
      this.setState({
        height: newHeight
      });

      if (this.props.onHeightChange) {
        this.props.onHeightChange(e, newHeight);
      }
    }
  },

  _handleChange: function _handleChange(e) {
    this._syncHeightWithShadow(e.target.value);

    if (this.props.hasOwnProperty('valueLink')) {
      this.props.valueLink.requestChange(e.target.value);
    }

    if (this.props.onChange) {
      this.props.onChange(e);
    }
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.value !== this.props.value) {
      this._syncHeightWithShadow(nextProps.value);
    }
    var newState = {};
    newState.muiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
  }
});

module.exports = EnhancedTextarea;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var ClickAwayable = __webpack_require__(163);
var FontIcon = __webpack_require__(189);
var Menu = __webpack_require__(247);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var DropDownIcon = React.createClass({
  displayName: 'DropDownIcon',

  mixins: [StylePropable, ClickAwayable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    onChange: React.PropTypes.func,
    menuItems: React.PropTypes.array.isRequired,
    closeOnMenuItemTouchTap: React.PropTypes.bool,
    iconStyle: React.PropTypes.object,
    iconClassName: React.PropTypes.string,
    iconLigature: React.PropTypes.string
  },

  getInitialState: function getInitialState() {
    return {
      open: false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getDefaultProps: function getDefaultProps() {
    return {
      closeOnMenuItemTouchTap: true
    };
  },

  componentDidMount: function componentDidMount() {
    // This component can be deprecated once ./menu/menu has been deprecated.
    // if (process.env.NODE_ENV !== 'production') {
    //   console.warn('DropDownIcon has been deprecated. Use IconMenu instead.');
    // }
  },

  componentClickAway: function componentClickAway() {
    this.setState({ open: false });
  },

  getStyles: function getStyles() {
    var spacing = this.state.muiTheme.rawTheme.spacing;
    var iconWidth = 48;
    var styles = {
      root: {
        display: 'inline-block',
        width: iconWidth + 'px !important',
        position: 'relative',
        height: spacing.desktopToolbarHeight,
        fontSize: spacing.desktopDropDownMenuFontSize,
        cursor: 'pointer'
      },
      menu: {
        transition: Transitions.easeOut(),
        right: '-14px !important',
        top: '9px !important',
        opacity: this.state.open ? 1 : 0
      },
      menuItem: { // similair to drop down menu's menu item styles
        paddingRight: spacing.iconSize + spacing.desktopGutterLess * 2,
        height: spacing.desktopDropDownMenuItemHeight,
        lineHeight: spacing.desktopDropDownMenuItemHeight + 'px'
      }
    };
    return styles;
  },

  render: function render() {
    var _props = this.props;
    var style = _props.style;
    var children = _props.children;
    var menuItems = _props.menuItems;
    var closeOnMenuItemTouchTap = _props.closeOnMenuItemTouchTap;
    var iconStyle = _props.iconStyle;
    var iconClassName = _props.iconClassName;

    var other = _objectWithoutProperties(_props, ['style', 'children', 'menuItems', 'closeOnMenuItemTouchTap', 'iconStyle', 'iconClassName']);

    var styles = this.getStyles();

    return React.createElement(
      'div',
      _extends({}, other, { style: this.prepareStyles(styles.root, this.props.style) }),
      React.createElement(
        'div',
        { onTouchTap: this._onControlClick },
        React.createElement(
          FontIcon,
          {
            className: iconClassName,
            style: iconStyle },
          this.props.iconLigature
        ),
        this.props.children
      ),
      React.createElement(Menu, {
        ref: 'menuItems',
        style: styles.menu,
        menuItems: menuItems,
        menuItemStyle: styles.menuItem,
        hideable: true,
        visible: this.state.open,
        onItemTap: this._onMenuItemClick })
    );
  },

  _onControlClick: function _onControlClick() {
    this.setState({ open: !this.state.open });
  },

  _onMenuItemClick: function _onMenuItemClick(e, key, payload) {
    if (this.props.onChange) this.props.onChange(e, key, payload);

    if (this.props.closeOnMenuItemTouchTap) {
      this.setState({ open: false });
    }
  }
});

module.exports = DropDownIcon;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var LinkMenuItem = React.createClass({
  displayName: 'LinkMenuItem',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    index: React.PropTypes.number.isRequired,
    payload: React.PropTypes.string.isRequired,
    text: React.PropTypes.string.isRequired,
    target: React.PropTypes.string,
    active: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
    className: React.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      active: false,
      disabled: false
    };
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme),
      hovered: false
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.menuItem;
  },

  getStyles: function getStyles() {
    var style = {
      root: {
        userSelect: 'none',
        cursor: 'pointer',
        display: 'block',
        lineHeight: this.getTheme().height + 'px',
        paddingLeft: this.getTheme().padding,
        paddingRight: this.getTheme().padding
      },
      rootWhenHovered: {
        backgroundColor: this.getTheme().hoverColor
      },
      rootWhenSelected: {
        color: this.getTheme().selectedTextColor
      },
      rootWhenDisabled: {
        cursor: 'default',
        color: this.state.muiTheme.rawTheme.palette.disabledColor
      }
    };

    return style;
  },

  render: function render() {
    var onClickHandler = this.props.disabled ? this._stopLink : undefined;
    // Prevent context menu 'Open In New Tab/Window'
    var linkAttribute = this.props.disabled ? 'data-href' : 'href';
    var link = {};
    link[linkAttribute] = this.props.payload;

    var styles = this.getStyles();

    var linkStyles = this.prepareStyles(styles.root, this.props.selected && styles.rootWhenSelected, this.props.selected && styles.rootWhenSelected, this.props.active && !this.props.disabled && styles.rootWhenHovered, this.props.style, this.props.disabled && styles.rootWhenDisabled);

    return React.createElement(
      'a',
      _extends({
        key: this.props.index,
        target: this.props.target,
        style: linkStyles }, link, {
        className: this.props.className,
        onClick: onClickHandler,
        onMouseEnter: this._handleMouseEnter,
        onMouseLeave: this._handleMouseLeave }),
      this.props.text
    );
  },

  _stopLink: function _stopLink(event) {
    event.preventDefault();
  },

  _handleMouseEnter: function _handleMouseEnter(e) {
    this.setState({ hovered: true });
    if (!this.props.disabled && this.props.onMouseEnter) this.props.onMouseEnter(e);
  },

  _handleMouseLeave: function _handleMouseLeave(e) {
    this.setState({ hovered: false });
    if (!this.props.disabled && this.props.onMouseLeave) this.props.onMouseLeave(e);
  }
});

module.exports = LinkMenuItem;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var Typography = __webpack_require__(135);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var SubheaderMenuItem = React.createClass({
  displayName: 'SubheaderMenuItem',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    index: React.PropTypes.number.isRequired,
    text: React.PropTypes.string.isRequired,
    firstChild: React.PropTypes.bool,
    className: React.PropTypes.string
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.menuSubheader;
  },

  getSpacing: function getSpacing() {
    return this.state.muiTheme.rawTheme.spacing;
  },

  getStyles: function getStyles() {
    var gutterMini = this.getSpacing().desktopGutterMini;
    var subheaderHeight = this.getSpacing().desktopSubheaderHeight;
    var styles = {
      root: {
        boxSizing: 'border-box',
        fontSize: '13px',
        letterSpacing: 0,
        fontWeight: Typography.fontWeightMedium,
        margin: 0,
        height: subheaderHeight + gutterMini,
        lineHeight: subheaderHeight + 'px',
        color: this.getTheme().textColor,
        borderTop: 'solid 1px ' + this.getTheme().borderColor,
        paddingTop: gutterMini,
        marginTop: gutterMini
      },
      rootWhenFirstChild: {
        height: subheaderHeight,
        borderTop: 'none',
        paddingTop: 0,
        marginTop: 0
      }
    };

    return styles;
  },

  render: function render() {
    return React.createElement(
      'div',
      {
        key: this.props.index,
        className: this.props.className,
        style: this.prepareStyles(this.getStyles().root, this.props.firstChild && this.getStyles().rootWhenFirstChild, this.props.style) },
      this.props.text
    );
  }

});

module.exports = SubheaderMenuItem;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var ColorManipulator = __webpack_require__(95);
var EnhancedButton = __webpack_require__(102);
var FontIcon = __webpack_require__(189);
var Paper = __webpack_require__(54);
var Children = __webpack_require__(244);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var getZDepth = function getZDepth(disabled) {
  var zDepth = disabled ? 0 : 2;
  return {
    zDepth: zDepth,
    initialZDepth: zDepth
  };
};

var FloatingActionButton = React.createClass({
  displayName: 'FloatingActionButton',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    backgroundColor: React.PropTypes.string,
    disabled: React.PropTypes.bool,
    disabledColor: React.PropTypes.string,
    iconClassName: React.PropTypes.string,
    iconStyle: React.PropTypes.object,
    mini: React.PropTypes.bool,
    onMouseDown: React.PropTypes.func,
    onMouseUp: React.PropTypes.func,
    onMouseLeave: React.PropTypes.func,
    onTouchEnd: React.PropTypes.func,
    onTouchStart: React.PropTypes.func,
    secondary: React.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    var zDepth = this.props.disabled ? 0 : 2;
    return {
      hovered: false,
      initialZDepth: zDepth,
      touch: false,
      zDepth: zDepth,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  componentWillMount: function componentWillMount() {
    this.setState(getZDepth(this.props.disabled));
  },

  componentWillReceiveProps: function componentWillReceiveProps(newProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });

    if (newProps.disabled !== this.props.disabled) {
      this.setState(getZDepth(newProps.disabled));
    }
  },

  componentDidMount: function componentDidMount() {
    if (false) {
      if (this.props.iconClassName && this.props.children) {
        var warning = 'You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.';
        console.warn(warning);
      }
    }
  },

  _getBackgroundColor: function _getBackgroundColor() {
    return this.props.disabled ? this.props.disabledColor || this.getTheme().disabledColor : this.props.backgroundColor ? this.props.backgroundColor : this.props.secondary ? this.getTheme().secondaryColor : this.getTheme().color;
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.floatingActionButton;
  },

  _getIconColor: function _getIconColor() {
    return this.props.disabled ? this.getTheme().disabledTextColor : this.props.secondary ? this.getTheme().secondaryIconColor : this.getTheme().iconColor;
  },

  getStyles: function getStyles() {
    var themeVariables = this.state.muiTheme.floatingActionButton;

    var styles = {
      root: {
        transition: Transitions.easeOut(),
        display: 'inline-block'
      },
      container: {
        transition: Transitions.easeOut(),
        position: 'relative',
        height: themeVariables.buttonSize,
        width: themeVariables.buttonSize,
        padding: 0,
        overflow: 'hidden',
        backgroundColor: this._getBackgroundColor(),
        borderRadius: '50%',
        textAlign: 'center',
        verticalAlign: 'bottom',
        //This is need so that ripples do not bleed
        //past border radius.
        //See: http://stackoverflow.com/questions/17298739/css-overflow-hidden-not-working-in-chrome-when-parent-has-border-radius-and-chil
        transform: 'translate3d(0, 0, 0)'
      },
      containerWhenMini: {
        height: themeVariables.miniSize,
        width: themeVariables.miniSize
      },
      overlay: {
        transition: Transitions.easeOut(),
        top: 0
      },
      overlayWhenHovered: {
        backgroundColor: ColorManipulator.fade(this._getIconColor(), 0.4)
      },
      icon: {
        height: themeVariables.buttonSize,
        lineHeight: themeVariables.buttonSize + 'px',
        fill: themeVariables.iconColor,
        color: this._getIconColor()
      },
      iconWhenMini: {
        height: themeVariables.miniSize,
        lineHeight: themeVariables.miniSize + 'px'
      }
    };
    return styles;
  },

  render: function render() {
    var _props = this.props;
    var disabled = _props.disabled;
    var mini = _props.mini;
    var secondary = _props.secondary;
    var iconStyle = _props.iconStyle;
    var iconClassName = _props.iconClassName;

    var other = _objectWithoutProperties(_props, ['disabled', 'mini', 'secondary', 'iconStyle', 'iconClassName']);

    var styles = this.getStyles();

    var iconElement = undefined;
    if (iconClassName) {
      iconElement = React.createElement(FontIcon, {
        className: iconClassName,
        style: this.mergeStyles(styles.icon, mini && styles.iconWhenMini, iconStyle) });
    }

    var children = Children.extend(this.props.children, {
      style: this.mergeStyles(styles.icon, mini && styles.iconWhenMini, iconStyle)
    });

    var buttonEventHandlers = disabled ? null : {
      onMouseDown: this._handleMouseDown,
      onMouseUp: this._handleMouseUp,
      onMouseLeave: this._handleMouseLeave,
      onMouseEnter: this._handleMouseEnter,
      onTouchStart: this._handleTouchStart,
      onTouchEnd: this._handleTouchEnd,
      onKeyboardFocus: this._handleKeyboardFocus
    };

    return React.createElement(
      Paper,
      {
        style: this.mergeStyles(styles.root, this.props.style),
        zDepth: this.state.zDepth,
        circle: true },
      React.createElement(
        EnhancedButton,
        _extends({}, other, buttonEventHandlers, {
          ref: 'container',
          disabled: disabled,
          style: this.mergeStyles(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
          focusRippleColor: styles.icon.color,
          touchRippleColor: styles.icon.color }),
        React.createElement(
          'div',
          {
            ref: 'overlay',
            style: this.prepareStyles(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered) },
          iconElement,
          children
        )
      )
    );
  },

  _handleMouseDown: function _handleMouseDown(e) {
    //only listen to left clicks
    if (e.button === 0) {
      this.setState({ zDepth: this.state.initialZDepth + 1 });
    }
    if (this.props.onMouseDown) this.props.onMouseDown(e);
  },

  _handleMouseUp: function _handleMouseUp(e) {
    this.setState({ zDepth: this.state.initialZDepth });
    if (this.props.onMouseUp) this.props.onMouseUp(e);
  },

  _handleMouseLeave: function _handleMouseLeave(e) {
    if (!this.refs.container.isKeyboardFocused()) this.setState({ zDepth: this.state.initialZDepth, hovered: false });
    if (this.props.onMouseLeave) this.props.onMouseLeave(e);
  },

  _handleMouseEnter: function _handleMouseEnter(e) {
    if (!this.refs.container.isKeyboardFocused() && !this.state.touch) {
      this.setState({ hovered: true });
    }
    if (this.props.onMouseEnter) this.props.onMouseEnter(e);
  },

  _handleTouchStart: function _handleTouchStart(e) {
    this.setState({
      touch: true,
      zDepth: this.state.initialZDepth + 1
    });
    if (this.props.onTouchStart) this.props.onTouchStart(e);
  },

  _handleTouchEnd: function _handleTouchEnd(e) {
    this.setState({ zDepth: this.state.initialZDepth });
    if (this.props.onTouchEnd) this.props.onTouchEnd(e);
  },

  _handleKeyboardFocus: function _handleKeyboardFocus(e, keyboardFocused) {
    if (keyboardFocused && !this.props.disabled) {
      this.setState({ zDepth: this.state.initialZDepth + 1 });
      ReactDOM.findDOMNode(this.refs.overlay).style.backgroundColor = ColorManipulator.fade(this.getStyles().icon.color, 0.4);
    } else if (!this.state.hovered) {
      this.setState({ zDepth: this.state.initialZDepth });
      ReactDOM.findDOMNode(this.refs.overlay).style.backgroundColor = 'transparent';
    }
  }

});

module.exports = FloatingActionButton;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var GridList = React.createClass({
  displayName: 'GridList',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    cols: React.PropTypes.number,
    padding: React.PropTypes.number,
    cellHeight: React.PropTypes.number
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      cols: 2,
      padding: 4,
      cellHeight: 180
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getStyles: function getStyles() {
    return {
      root: {
        display: '-webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex',
        flexWrap: 'wrap',
        margin: '-' + this.props.padding / 2 + 'px'
      },
      item: {
        boxSizing: 'border-box',
        padding: this.props.padding / 2 + 'px'
      }
    };
  },

  render: function render() {
    var _this = this;

    var _props = this.props;
    var cols = _props.cols;
    var padding = _props.padding;
    var cellHeight = _props.cellHeight;
    var children = _props.children;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['cols', 'padding', 'cellHeight', 'children', 'style']);

    var styles = this.getStyles();

    var mergedRootStyles = this.mergeStyles(styles.root, style);

    var wrappedChildren = React.Children.map(children, function (currentChild) {
      var childCols = currentChild.props.cols || 1;
      var childRows = currentChild.props.rows || 1;
      var itemStyle = _this.mergeStyles(styles.item, {
        width: 100 / cols * childCols + '%',
        height: cellHeight * childRows + padding
      });

      return React.createElement(
        'div',
        { style: _this.prepareStyles(itemStyle) },
        currentChild
      );
    });

    return React.createElement(
      'div',
      _extends({ style: this.prepareStyles(mergedRootStyles) }, other),
      wrappedChildren
    );
  }
});

module.exports = GridList;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var GridTile = React.createClass({
  displayName: 'GridTile',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    title: React.PropTypes.string,
    subtitle: React.PropTypes.node,
    titlePosition: React.PropTypes.oneOf(['top', 'bottom']),
    titleBackground: React.PropTypes.string,
    actionIcon: React.PropTypes.element,
    actionPosition: React.PropTypes.oneOf(['left', 'right']),
    cols: React.PropTypes.number,
    rows: React.PropTypes.number,
    rootClass: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object])
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      titlePosition: 'bottom',
      titleBackground: 'rgba(0, 0, 0, 0.4)',
      actionPosition: 'right',
      cols: 1,
      rows: 1,
      rootClass: 'div'
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getStyles: function getStyles() {
    var _titleBar;

    var spacing = this.state.muiTheme.rawTheme.spacing;
    var themeVariables = this.state.muiTheme.gridTile;
    var actionPos = this.props.actionIcon ? this.props.actionPosition : null;
    var gutterLess = spacing.desktopGutterLess;

    var styles = {
      root: {
        position: 'relative',
        display: 'block',
        height: '100%',
        overflow: 'hidden'
      },
      titleBar: (_titleBar = {
        position: 'absolute',
        left: 0,
        right: 0
      }, _defineProperty(_titleBar, this.props.titlePosition, 0), _defineProperty(_titleBar, 'height', this.props.subtitle ? 68 : 48), _defineProperty(_titleBar, 'background', this.props.titleBackground), _defineProperty(_titleBar, 'display', '-webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex'), _defineProperty(_titleBar, 'alignItems', 'center'), _titleBar),
      titleWrap: {
        flexGrow: 1,
        marginLeft: actionPos === 'right' ? gutterLess : 0,
        marginRight: actionPos === 'left' ? gutterLess : 0,
        color: themeVariables.textColor,
        overflow: 'hidden'
      },
      title: {
        fontSize: '16px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
      },
      subtitle: {
        fontSize: '12px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
      },
      actionIcon: {
        order: actionPos === 'left' ? -1 : 1
      },
      childImg: {
        height: '100%',
        transform: 'translateX(-50%)',
        position: 'relative',
        left: '50%'
      }
    };
    return styles;
  },

  componentDidMount: function componentDidMount() {
    this._ensureImageCover();
  },

  componeneDidUpdate: function componeneDidUpdate() {
    this._ensureImageCover();
  },

  _ensureImageCover: function _ensureImageCover() {
    var imgEl = ReactDOM.findDOMNode(this.refs.img);

    if (imgEl) {
      (function () {
        var fit = function fit() {
          if (imgEl.offsetWidth < imgEl.parentNode.offsetWidth) {
            imgEl.style.height = 'auto';
            imgEl.style.left = '0';
            imgEl.style.width = '100%';
            imgEl.style.top = '50%';
            imgEl.style.transform = imgEl.style.WebkitTransform = 'translateY(-50%)';
          }
          imgEl.removeEventListener('load', fit);
          imgEl = null; // prevent closure memory leak
        };
        if (imgEl.complete) {
          fit();
        } else {
          imgEl.addEventListener('load', fit);
        }
      })();
    }
  },

  render: function render() {
    var _this = this;

    var _props = this.props;
    var title = _props.title;
    var subtitle = _props.subtitle;
    var titlePosition = _props.titlePosition;
    var titleBackground = _props.titleBackground;
    var actionIcon = _props.actionIcon;
    var actionPosition = _props.actionPosition;
    var style = _props.style;
    var children = _props.children;
    var rootClass = _props.rootClass;

    var other = _objectWithoutProperties(_props, ['title', 'subtitle', 'titlePosition', 'titleBackground', 'actionIcon', 'actionPosition', 'style', 'children', 'rootClass']);

    var styles = this.getStyles();

    var mergedRootStyles = this.prepareStyles(styles.root, style);

    var titleBar = null;

    if (title) {
      titleBar = React.createElement(
        'div',
        { style: this.prepareStyles(styles.titleBar) },
        React.createElement(
          'div',
          { style: this.prepareStyles(styles.titleWrap) },
          React.createElement(
            'div',
            { style: this.prepareStyles(styles.title) },
            title
          ),
          subtitle ? React.createElement(
            'div',
            { style: this.prepareStyles(styles.subtitle) },
            subtitle
          ) : null
        ),
        actionIcon ? React.createElement(
          'div',
          { style: this.prepareStyles(styles.actionIcon) },
          actionIcon
        ) : null
      );
    }

    var newChildren = children;

    // if there is an image passed as children
    // clone it an put our styles
    if (React.Children.count(children) === 1) {
      newChildren = React.Children.map(children, function (child) {
        if (child.type === 'img') {
          return React.cloneElement(child, {
            ref: 'img',
            style: _this.prepareStyles(styles.childImg, child.props.style)
          });
        } else {
          return child;
        }
      });
    }

    var RootTag = rootClass;
    return React.createElement(
      RootTag,
      _extends({ style: mergedRootStyles }, other),
      newChildren,
      titleBar
    );
  }
});

module.exports = GridTile;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var ReactTransitionGroup = __webpack_require__(188);
var ClickAwayable = __webpack_require__(163);
var StylePropable = __webpack_require__(10);
var Events = __webpack_require__(137);
var PropTypes = __webpack_require__(187);
var Menu = __webpack_require__(1048);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var IconMenu = React.createClass({
  displayName: 'IconMenu',

  mixins: [StylePropable, ClickAwayable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    closeOnItemTouchTap: React.PropTypes.bool,
    iconButtonElement: React.PropTypes.element.isRequired,
    iconStyle: React.PropTypes.object,
    openDirection: PropTypes.corners,
    onItemTouchTap: React.PropTypes.func,
    onKeyboardFocus: React.PropTypes.func,
    onMouseDown: React.PropTypes.func,
    onMouseLeave: React.PropTypes.func,
    onMouseEnter: React.PropTypes.func,
    onMouseUp: React.PropTypes.func,
    onTouchTap: React.PropTypes.func,
    menuStyle: React.PropTypes.object,
    touchTapCloseDelay: React.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      closeOnItemTouchTap: true,
      openDirection: 'bottom-left',
      onItemTouchTap: function onItemTouchTap() {},
      onKeyboardFocus: function onKeyboardFocus() {},
      onMouseDown: function onMouseDown() {},
      onMouseLeave: function onMouseLeave() {},
      onMouseEnter: function onMouseEnter() {},
      onMouseUp: function onMouseUp() {},
      onTouchTap: function onTouchTap() {},
      touchTapCloseDelay: 200
    };
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme),
      iconButtonRef: this.props.iconButtonElement.props.ref || 'iconButton',
      menuInitiallyKeyboardFocused: false,
      open: false
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  componentWillUnmount: function componentWillUnmount() {
    if (this._timeout) clearTimeout(this._timeout);
  },

  componentClickAway: function componentClickAway() {
    this.close();
  },

  render: function render() {
    var _this = this;

    var _props = this.props;
    var className = _props.className;
    var closeOnItemTouchTap = _props.closeOnItemTouchTap;
    var iconButtonElement = _props.iconButtonElement;
    var iconStyle = _props.iconStyle;
    var openDirection = _props.openDirection;
    var onItemTouchTap = _props.onItemTouchTap;
    var onKeyboardFocus = _props.onKeyboardFocus;
    var onMouseDown = _props.onMouseDown;
    var onMouseLeave = _props.onMouseLeave;
    var onMouseEnter = _props.onMouseEnter;
    var onMouseUp = _props.onMouseUp;
    var onTouchTap = _props.onTouchTap;
    var menuStyle = _props.menuStyle;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['className', 'closeOnItemTouchTap', 'iconButtonElement', 'iconStyle', 'openDirection', 'onItemTouchTap', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onTouchTap', 'menuStyle', 'style']);

    var open = this.state.open;
    var openDown = openDirection.split('-')[0] === 'bottom';
    var openLeft = openDirection.split('-')[1] === 'left';

    var styles = {
      root: {
        display: 'inline-block',
        position: 'relative'
      },

      menu: {
        top: openDown ? 12 : null,
        bottom: !openDown ? 12 : null,
        left: !openLeft ? 12 : null,
        right: openLeft ? 12 : null
      }
    };

    var mergedRootStyles = this.prepareStyles(styles.root, style);
    var mergedMenuStyles = this.mergeStyles(styles.menu, menuStyle);

    var iconButton = React.cloneElement(iconButtonElement, {
      onKeyboardFocus: this.props.onKeyboardFocus,
      iconStyle: this.mergeStyles(iconStyle, iconButtonElement.props.iconStyle),
      onTouchTap: function onTouchTap(e) {
        _this.open(Events.isKeyboard(e));
        if (iconButtonElement.props.onTouchTap) iconButtonElement.props.onTouchTap(e);
      },
      ref: this.state.iconButtonRef
    });

    var menu = open ? React.createElement(
      Menu,
      _extends({}, other, {
        animated: true,
        initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
        onEscKeyDown: this._handleMenuEscKeyDown,
        onItemTouchTap: this._handleItemTouchTap,
        openDirection: openDirection,
        style: mergedMenuStyles }),
      this.props.children
    ) : null;

    return React.createElement(
      'div',
      {
        className: className,
        onMouseDown: onMouseDown,
        onMouseLeave: onMouseLeave,
        onMouseEnter: onMouseEnter,
        onMouseUp: onMouseUp,
        onTouchTap: onTouchTap,
        style: mergedRootStyles },
      iconButton,
      React.createElement(
        ReactTransitionGroup,
        null,
        menu
      )
    );
  },

  isOpen: function isOpen() {
    return this.state.open;
  },

  close: function close(isKeyboard) {
    var _this2 = this;

    if (this.state.open) {
      this.setState({ open: false }, function () {
        //Set focus on the icon button when the menu close
        if (isKeyboard) {
          var iconButton = _this2.refs[_this2.state.iconButtonRef];
          ReactDOM.findDOMNode(iconButton).focus();
          iconButton.setKeyboardFocus();
        }
      });
    }
  },

  open: function open(menuInitiallyKeyboardFocused) {
    if (!this.state.open) {
      this.setState({
        open: true,
        menuInitiallyKeyboardFocused: menuInitiallyKeyboardFocused
      });
    }
  },

  _handleItemTouchTap: function _handleItemTouchTap(e, child) {
    var _this3 = this;

    if (this.props.closeOnItemTouchTap) {
      (function () {
        var isKeyboard = Events.isKeyboard(e);

        _this3._timeout = setTimeout(function () {
          _this3.close(isKeyboard);
        }, _this3.props.touchTapCloseDelay);
      })();
    }

    this.props.onItemTouchTap(e, child);
  },

  _handleMenuEscKeyDown: function _handleMenuEscKeyDown() {
    this.close(true);
  }

});

module.exports = IconMenu;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var update = __webpack_require__(243);
var Controllable = __webpack_require__(535);
var StylePropable = __webpack_require__(10);
var AutoPrefix = __webpack_require__(62);
var Transitions = __webpack_require__(21);
var KeyCode = __webpack_require__(79);
var PropTypes = __webpack_require__(187);
var List = __webpack_require__(364);
var Paper = __webpack_require__(54);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Menu = React.createClass({
  displayName: 'Menu',

  mixins: [StylePropable, Controllable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    animated: React.PropTypes.bool,
    autoWidth: React.PropTypes.bool,
    desktop: React.PropTypes.bool,
    initiallyKeyboardFocused: React.PropTypes.bool,
    listStyle: React.PropTypes.object,
    maxHeight: React.PropTypes.number,
    multiple: React.PropTypes.bool,
    onEscKeyDown: React.PropTypes.func,
    onItemTouchTap: React.PropTypes.func,
    onKeyDown: React.PropTypes.func,
    openDirection: PropTypes.corners,
    selectedMenuItemStyle: React.PropTypes.object,
    width: PropTypes.stringOrNumber,
    zDepth: PropTypes.zDepth
  },

  getDefaultProps: function getDefaultProps() {
    return {
      animated: false,
      autoWidth: true,
      maxHeight: null,
      onEscKeyDown: function onEscKeyDown() {},
      onItemTouchTap: function onItemTouchTap() {},
      onKeyDown: function onKeyDown() {},
      openDirection: 'bottom-left',
      zDepth: 1
    };
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    var selectedIndex = this._getSelectedIndex(this.props);

    return {
      focusIndex: selectedIndex >= 0 ? selectedIndex : 0,
      isKeyboardFocused: this.props.initiallyKeyboardFocused,
      keyWidth: this.props.desktop ? 64 : 56,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  componentDidEnter: function componentDidEnter() {
    this._animateOpen();
  },

  componentDidMount: function componentDidMount() {
    if (this.props.autoWidth) this._setWidth();
    if (!this.props.animated) this._animateOpen();
    this._setScollPosition();
  },

  componentDidUpdate: function componentDidUpdate() {
    if (this.props.autoWidth) this._setWidth();
  },

  componentWillLeave: function componentWillLeave(callback) {
    var _this = this;

    var rootStyle = ReactDOM.findDOMNode(this).style;

    AutoPrefix.set(rootStyle, 'transition', Transitions.easeOut('250ms', ['opacity', 'transform']));
    AutoPrefix.set(rootStyle, 'transform', 'translate3d(0,-8px,0)');
    rootStyle.opacity = 0;

    setTimeout(function () {
      if (_this.isMounted()) callback();
    }, 250);
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var selectedIndex = this._getSelectedIndex(nextProps);
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;

    this.setState({
      focusIndex: selectedIndex >= 0 ? selectedIndex : 0,
      keyWidth: nextProps.desktop ? 64 : 56,
      muiTheme: newMuiTheme
    });
  },

  render: function render() {
    var _this2 = this;

    var _props = this.props;
    var animated = _props.animated;
    var autoWidth = _props.autoWidth;
    var children = _props.children;
    var desktop = _props.desktop;
    var initiallyKeyboardFocused = _props.initiallyKeyboardFocused;
    var listStyle = _props.listStyle;
    var maxHeight = _props.maxHeight;
    var multiple = _props.multiple;
    var openDirection = _props.openDirection;
    var selectedMenuItemStyle = _props.selectedMenuItemStyle;
    var style = _props.style;
    var value = _props.value;
    var valueLink = _props.valueLink;
    var width = _props.width;
    var zDepth = _props.zDepth;

    var other = _objectWithoutProperties(_props, ['animated', 'autoWidth', 'children', 'desktop', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'openDirection', 'selectedMenuItemStyle', 'style', 'value', 'valueLink', 'width', 'zDepth']);

    var openDown = openDirection.split('-')[0] === 'bottom';
    var openLeft = openDirection.split('-')[1] === 'left';

    var styles = {
      root: {
        //Nested div bacause the List scales x faster than
        //it scales y
        transition: animated ? Transitions.easeOut('250ms', 'transform') : null,
        position: 'absolute',
        zIndex: 10,
        top: openDown ? 0 : null,
        bottom: !openDown ? 0 : null,
        left: !openLeft ? 0 : null,
        right: openLeft ? 0 : null,
        transform: 'scaleX(0)',
        transformOrigin: openLeft ? 'right' : 'left'
      },

      list: {
        display: 'table-cell',
        paddingBottom: desktop ? 16 : 8,
        paddingTop: desktop ? 16 : 8,
        userSelect: 'none',
        width: width
      },

      menuItemContainer: {
        transition: animated ? Transitions.easeOut(null, 'opacity') : null,
        opacity: 0
      },

      paper: {
        transition: animated ? Transitions.easeOut('500ms', ['transform', 'opacity']) : null,
        transform: 'scaleY(0)',
        transformOrigin: openDown ? 'top' : 'bottom',
        opacity: 0,
        maxHeight: maxHeight,
        overflowY: maxHeight ? 'scroll' : null
      },

      selectedMenuItem: {
        color: this.state.muiTheme.rawTheme.palette.accent1Color
      }
    };

    var mergedRootStyles = this.prepareStyles(styles.root, style);
    var mergedListStyles = this.mergeStyles(styles.list, listStyle);

    //Cascade children opacity
    var cumulativeDelay = openDown ? 175 : 325;
    var cascadeChildrenCount = this._getCascadeChildrenCount();
    var cumulativeDelayIncrement = Math.ceil(150 / cascadeChildrenCount);

    var menuItemIndex = 0;
    var newChildren = React.Children.map(children, function (child) {

      var childIsADivider = child.type.displayName === 'MenuDivider';
      var childIsDisabled = child.props.disabled;
      var childrenContainerStyles = {};

      if (animated) {
        var focusIndex = _this2.state.focusIndex;
        var transitionDelay = 0;

        //Only cascade the visible menu items
        if (menuItemIndex >= focusIndex - 1 && menuItemIndex <= focusIndex + cascadeChildrenCount - 1) {
          cumulativeDelay = openDown ? cumulativeDelay + cumulativeDelayIncrement : cumulativeDelay - cumulativeDelayIncrement;
          transitionDelay = cumulativeDelay;
        }

        childrenContainerStyles = _this2.prepareStyles(styles.menuItemContainer, {
          transitionDelay: transitionDelay + 'ms'
        });
      }

      var clonedChild = childIsADivider ? child : childIsDisabled ? React.cloneElement(child, { desktop: desktop }) : _this2._cloneMenuItem(child, menuItemIndex, styles);

      if (!childIsADivider && !childIsDisabled) menuItemIndex++;

      return animated ? React.createElement(
        'div',
        { style: childrenContainerStyles },
        clonedChild
      ) : clonedChild;
    });

    return React.createElement(
      'div',
      {
        onKeyDown: this._handleKeyDown,
        style: mergedRootStyles },
      React.createElement(
        Paper,
        {
          ref: 'scrollContainer',
          style: styles.paper,
          zDepth: zDepth },
        React.createElement(
          List,
          _extends({}, other, {
            ref: 'list',
            style: mergedListStyles }),
          newChildren
        )
      )
    );
  },

  setKeyboardFocused: function setKeyboardFocused(keyboardFocused) {
    this.setState({
      isKeyboardFocused: keyboardFocused
    });
  },

  _animateOpen: function _animateOpen() {
    var rootStyle = ReactDOM.findDOMNode(this).style;
    var scrollContainerStyle = ReactDOM.findDOMNode(this.refs.scrollContainer).style;
    var menuContainers = ReactDOM.findDOMNode(this.refs.list).childNodes;

    AutoPrefix.set(rootStyle, 'transform', 'scaleX(1)');
    AutoPrefix.set(scrollContainerStyle, 'transform', 'scaleY(1)');
    scrollContainerStyle.opacity = 1;

    for (var i = 0; i < menuContainers.length; ++i) {
      menuContainers[i].style.opacity = 1;
    }
  },

  _cloneMenuItem: function _cloneMenuItem(child, childIndex, styles) {
    var _this3 = this;

    var _props2 = this.props;
    var desktop = _props2.desktop;
    var selectedMenuItemStyle = _props2.selectedMenuItemStyle;

    var selected = this._isChildSelected(child, this.props);
    var selectedChildrenStyles = {};

    if (selected) {
      selectedChildrenStyles = this.mergeStyles(styles.selectedMenuItem, selectedMenuItemStyle);
    }

    var mergedChildrenStyles = this.mergeStyles(child.props.style || {}, selectedChildrenStyles);

    var isFocused = childIndex === this.state.focusIndex;
    var focusState = 'none';
    if (isFocused) {
      focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
    }

    return React.cloneElement(child, {
      desktop: desktop,
      focusState: focusState,
      onTouchTap: function onTouchTap(e) {
        _this3._handleMenuItemTouchTap(e, child);
        if (child.props.onTouchTap) child.props.onTouchTap(e);
      },
      ref: isFocused ? 'focusedMenuItem' : null,
      style: mergedChildrenStyles
    });
  },

  _decrementKeyboardFocusIndex: function _decrementKeyboardFocusIndex() {
    var index = this.state.focusIndex;

    index--;
    if (index < 0) index = 0;

    this._setFocusIndex(index, true);
  },

  _getCascadeChildrenCount: function _getCascadeChildrenCount() {
    var _props3 = this.props;
    var children = _props3.children;
    var desktop = _props3.desktop;
    var maxHeight = _props3.maxHeight;

    var count = 1;
    var currentHeight = desktop ? 16 : 8;
    var menuItemHeight = desktop ? 32 : 48;

    //MaxHeight isn't set - cascade all of the children
    if (!maxHeight) return React.Children.count(children);

    //Count all the children that will fit inside the
    //max menu height
    React.Children.forEach(children, function (child) {
      if (currentHeight < maxHeight) {
        var childIsADivider = child.type.displayName === 'MenuDivider';

        currentHeight += childIsADivider ? 16 : menuItemHeight;
        count++;
      }
    });

    return count;
  },

  _getMenuItemCount: function _getMenuItemCount() {
    var menuItemCount = 0;
    React.Children.forEach(this.props.children, function (child) {
      var childIsADivider = child.type.displayName === 'MenuDivider';
      var childIsDisabled = child.props.disabled;
      if (!childIsADivider && !childIsDisabled) menuItemCount++;
    });
    return menuItemCount;
  },

  _getSelectedIndex: function _getSelectedIndex(props) {
    var _this4 = this;

    var children = props.children;

    var selectedIndex = -1;
    var menuItemIndex = 0;

    React.Children.forEach(children, function (child) {
      var childIsADivider = child.type.displayName === 'MenuDivider';

      if (_this4._isChildSelected(child, props)) selectedIndex = menuItemIndex;
      if (!childIsADivider) menuItemIndex++;
    });

    return selectedIndex;
  },

  _handleKeyDown: function _handleKeyDown(e) {
    switch (e.keyCode) {
      case KeyCode.DOWN:
        e.preventDefault();
        this._incrementKeyboardFocusIndex();
        break;
      case KeyCode.ESC:
        this.props.onEscKeyDown(e);
        break;
      case KeyCode.TAB:
        e.preventDefault();
        if (e.shiftKey) {
          this._decrementKeyboardFocusIndex();
        } else {
          this._incrementKeyboardFocusIndex();
        }
        break;
      case KeyCode.UP:
        e.preventDefault();
        this._decrementKeyboardFocusIndex();
        break;
    }
    this.props.onKeyDown(e);
  },

  _handleMenuItemTouchTap: function _handleMenuItemTouchTap(e, item) {
    var multiple = this.props.multiple;
    var valueLink = this.getValueLink(this.props);
    var menuValue = valueLink.value;
    var itemValue = item.props.value;

    if (multiple) {
      var index = menuValue.indexOf(itemValue);
      var newMenuValue = index === -1 ? update(menuValue, { $push: [itemValue] }) : update(menuValue, { $splice: [[index, 1]] });

      valueLink.requestChange(e, newMenuValue);
    } else if (!multiple && itemValue !== menuValue) {
      valueLink.requestChange(e, itemValue);
    }

    this.props.onItemTouchTap(e, item);
  },

  _incrementKeyboardFocusIndex: function _incrementKeyboardFocusIndex() {
    var index = this.state.focusIndex;
    var maxIndex = this._getMenuItemCount() - 1;

    index++;
    if (index > maxIndex) index = maxIndex;

    this._setFocusIndex(index, true);
  },

  _isChildSelected: function _isChildSelected(child, props) {
    var multiple = props.multiple;
    var menuValue = this.getValueLink(props).value;
    var childValue = child.props.value;

    return multiple && menuValue.length && menuValue.indexOf(childValue) !== -1 || !multiple && menuValue && menuValue === childValue;
  },

  _setFocusIndex: function _setFocusIndex(newIndex, isKeyboardFocused) {
    this.setState({
      focusIndex: newIndex,
      isKeyboardFocused: isKeyboardFocused
    });
  },

  _setScollPosition: function _setScollPosition() {
    var desktop = this.props.desktop;
    var focusedMenuItem = this.refs.focusedMenuItem;
    var menuItemHeight = desktop ? 32 : 48;

    if (focusedMenuItem) {
      var selectedOffSet = ReactDOM.findDOMNode(focusedMenuItem).offsetTop;

      //Make the focused item be the 2nd item in the list the
      //user sees
      var scrollTop = selectedOffSet - menuItemHeight;
      if (scrollTop < menuItemHeight) scrollTop = 0;

      ReactDOM.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
    }
  },

  _setWidth: function _setWidth() {
    var el = ReactDOM.findDOMNode(this);
    var listEl = ReactDOM.findDOMNode(this.refs.list);
    var elWidth = el.offsetWidth;
    var keyWidth = this.state.keyWidth;
    var minWidth = keyWidth * 1.5;
    var keyIncrements = elWidth / keyWidth;
    var newWidth = undefined;

    keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
    newWidth = keyIncrements * keyWidth;

    if (newWidth < minWidth) newWidth = minWidth;

    el.style.width = newWidth + 'px';
    listEl.style.width = newWidth + 'px';
  }

});

module.exports = Menu;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isBrowser = __webpack_require__(516);

var Modernizr = isBrowser ? __webpack_require__(517) : undefined;

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var KeyCode = __webpack_require__(79);
var StylePropable = __webpack_require__(10);
var AutoPrefix = __webpack_require__(62);
var Transitions = __webpack_require__(21);
var WindowListenable = __webpack_require__(103);
var Overlay = __webpack_require__(362);
var Paper = __webpack_require__(54);
var Menu = __webpack_require__(247);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var openNavEventHandler = null;

var LeftNav = React.createClass({
  displayName: 'LeftNav',

  mixins: [StylePropable, WindowListenable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    className: React.PropTypes.string,
    disableSwipeToOpen: React.PropTypes.bool,
    docked: React.PropTypes.bool,
    header: React.PropTypes.element,
    menuItems: React.PropTypes.array.isRequired,
    onChange: React.PropTypes.func,
    onNavOpen: React.PropTypes.func,
    onNavClose: React.PropTypes.func,
    openRight: React.PropTypes.bool,
    selectedIndex: React.PropTypes.number,
    menuItemClassName: React.PropTypes.string,
    menuItemClassNameSubheader: React.PropTypes.string,
    menuItemClassNameLink: React.PropTypes.string
  },

  windowListeners: {
    'keyup': '_onWindowKeyUp',
    'resize': '_onWindowResize'
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disableSwipeToOpen: false,
      docked: true
    };
  },

  getInitialState: function getInitialState() {
    this._maybeSwiping = false;
    this._touchStartX = null;
    this._touchStartY = null;
    this._swipeStartX = null;

    return {
      open: this.props.docked,
      swiping: null,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  componentDidMount: function componentDidMount() {
    this._updateMenuHeight();
    this._enableSwipeHandling();
  },

  componentDidUpdate: function componentDidUpdate() {
    this._updateMenuHeight();
    this._enableSwipeHandling();
  },

  componentWillUnmount: function componentWillUnmount() {
    this._disableSwipeHandling();
  },

  toggle: function toggle() {
    this.setState({ open: !this.state.open });
    return this;
  },

  close: function close() {
    this.setState({ open: false });
    if (this.props.onNavClose) this.props.onNavClose();
    return this;
  },

  open: function open() {
    this.setState({ open: true });
    if (this.props.onNavOpen) this.props.onNavOpen();
    return this;
  },

  getThemePalette: function getThemePalette() {
    return this.state.muiTheme.rawTheme.palette;
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.leftNav;
  },

  getStyles: function getStyles() {
    var x = this._getTranslateMultiplier() * (this.state.open ? 0 : this._getMaxTranslateX());
    var styles = {
      root: {
        height: '100%',
        width: this.getTheme().width,
        position: 'fixed',
        zIndex: 10,
        left: isBrowser && Modernizr.csstransforms3d ? 0 : x,
        top: 0,
        transform: 'translate3d(' + x + 'px, 0, 0)',
        transition: !this.state.swiping && Transitions.easeOut(),
        backgroundColor: this.getTheme().color,
        overflow: 'hidden'
      },
      menu: {
        overflowY: 'auto',
        overflowX: 'hidden',
        height: '100%',
        borderRadius: '0'
      },
      menuItem: {
        height: this.state.muiTheme.rawTheme.spacing.desktopLeftNavMenuItemHeight,
        lineHeight: this.state.muiTheme.rawTheme.spacing.desktopLeftNavMenuItemHeight + 'px'
      },
      rootWhenOpenRight: {
        left: 'auto',
        right: 0
      }
    };

    styles.menuItemLink = this.mergeStyles(styles.menuItem, {
      display: 'block',
      textDecoration: 'none',
      color: this.getThemePalette().textColor
    });
    styles.menuItemSubheader = this.mergeStyles(styles.menuItem, {
      overflow: 'hidden'
    });

    return styles;
  },

  render: function render() {
    var selectedIndex = this.props.selectedIndex;
    var overlay = undefined;

    var styles = this.getStyles();
    if (!this.props.docked) {
      overlay = React.createElement(Overlay, {
        ref: 'overlay',
        show: this.state.open || !!this.state.swiping,
        transitionEnabled: !this.state.swiping,
        onTouchTap: this._onOverlayTouchTap });
    }

    return React.createElement(
      'div',
      { className: this.props.className },
      overlay,
      React.createElement(
        Paper,
        {
          ref: 'clickAwayableElement',
          zDepth: 2,
          rounded: false,
          transitionEnabled: !this.state.swiping,
          style: this.mergeStyles(styles.root, this.props.openRight && styles.rootWhenOpenRight, this.props.style) },
        this.props.header,
        React.createElement(Menu, {
          ref: 'menuItems',
          style: this.mergeStyles(styles.menu),
          zDepth: 0,
          menuItems: this.props.menuItems,
          menuItemStyle: this.mergeStyles(styles.menuItem),
          menuItemStyleLink: this.mergeStyles(styles.menuItemLink),
          menuItemStyleSubheader: this.mergeStyles(styles.menuItemSubheader),
          menuItemClassName: this.props.menuItemClassName,
          menuItemClassNameSubheader: this.props.menuItemClassNameSubheader,
          menuItemClassNameLink: this.props.menuItemClassNameLink,
          selectedIndex: selectedIndex,
          onItemTap: this._onMenuItemClick })
      )
    );
  },

  _updateMenuHeight: function _updateMenuHeight() {
    if (this.props.header) {
      var container = ReactDOM.findDOMNode(this.refs.clickAwayableElement);
      var menu = ReactDOM.findDOMNode(this.refs.menuItems);
      var menuHeight = container.clientHeight - menu.offsetTop;
      menu.style.height = menuHeight + 'px';
    }
  },

  _onMenuItemClick: function _onMenuItemClick(e, key, payload) {
    if (this.props.onChange && this.props.selectedIndex !== key) {
      this.props.onChange(e, key, payload);
    }
    if (!this.props.docked) this.close();
  },

  _onOverlayTouchTap: function _onOverlayTouchTap() {
    this.close();
  },

  _onWindowKeyUp: function _onWindowKeyUp(e) {
    if (e.keyCode === KeyCode.ESC && !this.props.docked && this.state.open) {
      this.close();
    }
  },

  _onWindowResize: function _onWindowResize() {
    this._updateMenuHeight();
  },

  _getMaxTranslateX: function _getMaxTranslateX() {
    return this.getTheme().width + 10;
  },

  _getTranslateMultiplier: function _getTranslateMultiplier() {
    return this.props.openRight ? 1 : -1;
  },

  _enableSwipeHandling: function _enableSwipeHandling() {
    if (!this.props.docked) {
      document.body.addEventListener('touchstart', this._onBodyTouchStart);
      if (!openNavEventHandler) {
        openNavEventHandler = this._onBodyTouchStart;
      }
    } else {
      this._disableSwipeHandling();
    }
  },

  _disableSwipeHandling: function _disableSwipeHandling() {
    document.body.removeEventListener('touchstart', this._onBodyTouchStart);
    if (openNavEventHandler === this._onBodyTouchStart) {
      openNavEventHandler = null;
    }
  },

  _onBodyTouchStart: function _onBodyTouchStart(e) {
    if (!this.state.open && (openNavEventHandler !== this._onBodyTouchStart || this.props.disableSwipeToOpen)) {
      return;
    }

    var touchStartX = e.touches[0].pageX;
    var touchStartY = e.touches[0].pageY;

    this._maybeSwiping = true;
    this._touchStartX = touchStartX;
    this._touchStartY = touchStartY;

    document.body.addEventListener('touchmove', this._onBodyTouchMove);
    document.body.addEventListener('touchend', this._onBodyTouchEnd);
    document.body.addEventListener('touchcancel', this._onBodyTouchEnd);
  },

  _setPosition: function _setPosition(translateX) {
    var leftNav = ReactDOM.findDOMNode(this.refs.clickAwayableElement);
    leftNav.style[AutoPrefix.single('transform')] = 'translate3d(' + this._getTranslateMultiplier() * translateX + 'px, 0, 0)';
    this.refs.overlay.setOpacity(1 - translateX / this._getMaxTranslateX());
  },

  _getTranslateX: function _getTranslateX(currentX) {
    return Math.min(Math.max(this.state.swiping === 'closing' ? this._getTranslateMultiplier() * (currentX - this._swipeStartX) : this._getMaxTranslateX() - this._getTranslateMultiplier() * (this._swipeStartX - currentX), 0), this._getMaxTranslateX());
  },

  _onBodyTouchMove: function _onBodyTouchMove(e) {
    var currentX = e.touches[0].pageX;
    var currentY = e.touches[0].pageY;

    if (this.state.swiping) {
      e.preventDefault();
      this._setPosition(this._getTranslateX(currentX));
    } else if (this._maybeSwiping) {
      var dXAbs = Math.abs(currentX - this._touchStartX);
      var dYAbs = Math.abs(currentY - this._touchStartY);
      // If the user has moved his thumb ten pixels in either direction,
      // we can safely make an assumption about whether he was intending
      // to swipe or scroll.
      var threshold = 10;

      if (dXAbs > threshold && dYAbs <= threshold) {
        this._swipeStartX = currentX;
        this.setState({
          swiping: this.state.open ? 'closing' : 'opening'
        });
        this._setPosition(this._getTranslateX(currentX));
      } else if (dXAbs <= threshold && dYAbs > threshold) {
        this._onBodyTouchEnd();
      }
    }
  },

  _onBodyTouchEnd: function _onBodyTouchEnd(e) {
    if (this.state.swiping) {
      var currentX = e.changedTouches[0].pageX;
      var translateRatio = this._getTranslateX(currentX) / this._getMaxTranslateX();

      this._maybeSwiping = false;
      var swiping = this.state.swiping;
      this.setState({
        swiping: null
      });

      // We have to open or close after setting swiping to null,
      // because only then CSS transition is enabled.
      if (translateRatio > 0.5) {
        if (swiping === 'opening') {
          this._setPosition(this._getMaxTranslateX());
        } else {
          this.close();
        }
      } else {
        if (swiping === 'opening') {
          this.open();
        } else {
          this._setPosition(0);
        }
      }
    } else {
      this._maybeSwiping = false;
    }

    document.body.removeEventListener('touchmove', this._onBodyTouchMove);
    document.body.removeEventListener('touchend', this._onBodyTouchEnd);
    document.body.removeEventListener('touchcancel', this._onBodyTouchEnd);
  }

});

module.exports = LeftNav;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var LinearProgress = React.createClass({
  displayName: 'LinearProgress',

  mixins: [StylePropable],

  propTypes: {
    mode: React.PropTypes.oneOf(["determinate", "indeterminate"]),
    value: React.PropTypes.number,
    min: React.PropTypes.number,
    max: React.PropTypes.number
  },

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  _getRelativeValue: function _getRelativeValue() {
    var value = this.props.value;
    var min = this.props.min;
    var max = this.props.max;

    var clampedValue = Math.min(Math.max(min, value), max);
    var rangeValue = max - min;
    var relValue = Math.round(clampedValue / rangeValue * 10000) / 10000;
    return relValue * 100;
  },

  componentDidMount: function componentDidMount() {
    var _this = this;

    var bar1 = ReactDOM.findDOMNode(this.refs.bar1);
    var bar2 = ReactDOM.findDOMNode(this.refs.bar2);

    this._barUpdate(0, bar1, [[-35, 100], [100, -90]]);

    setTimeout(function () {
      _this._barUpdate(0, bar2, [[-200, 100], [107, -8]]);
    }, 850);
  },

  _barUpdate: function _barUpdate(step, barElement, stepValues) {
    step = step || 0;
    step %= 4;
    setTimeout(this._barUpdate.bind(this, step + 1, barElement, stepValues), 420);
    if (!this.isMounted()) return;
    if (this.props.mode !== "indeterminate") return;

    var right = this.state.muiTheme.isRtl ? 'left' : 'right';
    var left = this.state.muiTheme.isRtl ? 'right' : 'left';

    if (step === 0) {
      barElement.style[left] = stepValues[0][0] + "%";
      barElement.style[right] = stepValues[0][1] + "%";
    } else if (step === 1) {
      barElement.style.transitionDuration = "840ms";
    } else if (step === 2) {
      barElement.style[left] = stepValues[1][0] + "%";
      barElement.style[right] = stepValues[1][1] + "%";
    } else if (step === 3) {
      barElement.style.transitionDuration = "0ms";
    }
  },

  getDefaultProps: function getDefaultProps() {
    return {
      mode: "indeterminate",
      value: 0,
      min: 0,
      max: 100
    };
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.rawTheme.palette;
  },

  getStyles: function getStyles() {
    var styles = {
      root: {
        position: "relative",
        height: 4,
        display: "block",
        width: "100%",
        backgroundColor: this.getTheme().primary3Color,
        borderRadius: 2,
        margin: 0,
        overflow: "hidden"
      },
      bar: {
        height: "100%"
      },
      barFragment1: {},
      barFragment2: {}
    };

    if (this.props.mode === "indeterminate") {
      styles.barFragment1 = {
        position: "absolute",
        backgroundColor: this.getTheme().primary1Color,
        top: 0,
        left: 0,
        bottom: 0,
        transition: Transitions.create("all", "840ms", null, "cubic-bezier(0.650, 0.815, 0.735, 0.395)")
      };

      styles.barFragment2 = {
        position: "absolute",
        backgroundColor: this.getTheme().primary1Color,
        top: 0,
        left: 0,
        bottom: 0,
        transition: Transitions.create("all", "840ms", null, "cubic-bezier(0.165, 0.840, 0.440, 1.000)")
      };
    } else {
      styles.bar.backgroundColor = this.getTheme().primary1Color;
      styles.bar.transition = Transitions.create("width", ".3s", null, "linear");
      styles.bar.width = this._getRelativeValue() + "%";
    }

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['style']);

    var styles = this.getStyles();

    return React.createElement(
      'div',
      _extends({}, other, { style: this.prepareStyles(styles.root, style) }),
      React.createElement(
        'div',
        { style: this.prepareStyles(styles.bar) },
        React.createElement('div', { ref: 'bar1', style: this.prepareStyles(styles.barFragment1) }),
        React.createElement('div', { ref: 'bar2', style: this.prepareStyles(styles.barFragment2) })
      )
    );
  }
});

module.exports = LinearProgress;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var PureRenderMixin = __webpack_require__(1);
var ColorManipulator = __webpack_require__(95);
var StylePropable = __webpack_require__(10);
var Colors = __webpack_require__(53);
var Transitions = __webpack_require__(21);
var Typography = __webpack_require__(135);
var EnhancedButton = __webpack_require__(102);
var IconButton = __webpack_require__(186);
var OpenIcon = __webpack_require__(537);
var CloseIcon = __webpack_require__(363);
var NestedList = __webpack_require__(1052);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var ListItem = React.createClass({
  displayName: 'ListItem',

  mixins: [PureRenderMixin, StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    autoGenerateNestedIndicator: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
    disableKeyboardFocus: React.PropTypes.bool,
    initiallyOpen: React.PropTypes.bool,
    innerDivStyle: React.PropTypes.object,
    insetChildren: React.PropTypes.bool,
    innerStyle: React.PropTypes.object,
    leftAvatar: React.PropTypes.element,
    leftCheckbox: React.PropTypes.element,
    leftIcon: React.PropTypes.element,
    nestedLevel: React.PropTypes.number,
    nestedItems: React.PropTypes.arrayOf(React.PropTypes.element),
    onKeyboardFocus: React.PropTypes.func,
    onMouseEnter: React.PropTypes.func,
    onMouseLeave: React.PropTypes.func,
    onNestedListToggle: React.PropTypes.func,
    onTouchStart: React.PropTypes.func,
    onTouchTap: React.PropTypes.func,
    rightAvatar: React.PropTypes.element,
    rightIcon: React.PropTypes.element,
    rightIconButton: React.PropTypes.element,
    rightToggle: React.PropTypes.element,
    primaryText: React.PropTypes.node,
    secondaryText: React.PropTypes.node,
    secondaryTextLines: React.PropTypes.oneOf([1, 2])
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autoGenerateNestedIndicator: true,
      initiallyOpen: false,
      nestedItems: [],
      nestedLevel: 0,
      onKeyboardFocus: function onKeyboardFocus() {},
      onMouseEnter: function onMouseEnter() {},
      onMouseLeave: function onMouseLeave() {},
      onNestedListToggle: function onNestedListToggle() {},
      onTouchStart: function onTouchStart() {},
      secondaryTextLines: 1
    };
  },

  getInitialState: function getInitialState() {
    return {
      hovered: false,
      isKeyboardFocused: false,
      open: this.props.initiallyOpen,
      rightIconButtonHovered: false,
      rightIconButtonKeyboardFocused: false,
      touch: false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _props = this.props;
    var autoGenerateNestedIndicator = _props.autoGenerateNestedIndicator;
    var children = _props.children;
    var disabled = _props.disabled;
    var disableKeyboardFocus = _props.disableKeyboardFocus;
    var innerDivStyle = _props.innerDivStyle;
    var insetChildren = _props.insetChildren;
    var leftAvatar = _props.leftAvatar;
    var leftCheckbox = _props.leftCheckbox;
    var leftIcon = _props.leftIcon;
    var nestedItems = _props.nestedItems;
    var nestedLevel = _props.nestedLevel;
    var onKeyboardFocus = _props.onKeyboardFocus;
    var onMouseLeave = _props.onMouseLeave;
    var onMouseEnter = _props.onMouseEnter;
    var onTouchStart = _props.onTouchStart;
    var onTouchTap = _props.onTouchTap;
    var rightAvatar = _props.rightAvatar;
    var rightIcon = _props.rightIcon;
    var rightIconButton = _props.rightIconButton;
    var rightToggle = _props.rightToggle;
    var primaryText = _props.primaryText;
    var secondaryText = _props.secondaryText;
    var secondaryTextLines = _props.secondaryTextLines;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['autoGenerateNestedIndicator', 'children', 'disabled', 'disableKeyboardFocus', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'onKeyboardFocus', 'onMouseLeave', 'onMouseEnter', 'onTouchStart', 'onTouchTap', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'secondaryText', 'secondaryTextLines', 'style']);

    var textColor = this.state.muiTheme.rawTheme.palette.textColor;
    var hoverColor = ColorManipulator.fade(textColor, 0.1);
    var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
    var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
    var twoLine = secondaryText && secondaryTextLines === 1;
    var threeLine = secondaryText && secondaryTextLines > 1;
    var hasCheckbox = leftCheckbox || rightToggle;

    var styles = {
      root: {
        backgroundColor: (this.state.isKeyboardFocused || this.state.hovered) && !this.state.rightIconButtonHovered && !this.state.rightIconButtonKeyboardFocused ? hoverColor : null,
        color: textColor,
        display: 'block',
        fontSize: 16,
        lineHeight: '16px',
        position: 'relative',
        transition: Transitions.easeOut()
      },

      //This inner div is needed so that ripples will span the entire container
      innerDiv: {
        marginLeft: nestedLevel * this.state.muiTheme.listItem.nestedLevelDepth,
        paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
        paddingRight: rightIcon || rightAvatar || rightIconButton ? 56 : rightToggle ? 72 : 16,
        paddingBottom: singleAvatar ? 20 : 16,
        paddingTop: singleNoAvatar || threeLine ? 16 : 20,
        position: 'relative'
      },

      icons: {
        height: 24,
        width: 24,
        display: 'block',
        position: 'absolute',
        top: twoLine ? 12 : singleAvatar ? 4 : 0,
        padding: 12
      },

      leftIcon: {
        color: Colors.grey600,
        fill: Colors.grey600,
        left: 4
      },

      rightIcon: {
        color: Colors.grey400,
        fill: Colors.grey400,
        right: 4
      },

      avatars: {
        position: 'absolute',
        top: singleAvatar ? 8 : 16
      },

      label: {
        cursor: 'pointer'
      },

      leftAvatar: {
        left: 16
      },

      rightAvatar: {
        right: 16
      },

      leftCheckbox: {
        position: 'absolute',
        display: 'block',
        width: 24,
        top: twoLine ? 24 : singleAvatar ? 16 : 12,
        left: 16
      },

      primaryText: {},

      rightIconButton: {
        position: 'absolute',
        display: 'block',
        top: twoLine ? 12 : singleAvatar ? 4 : 0,
        right: 4
      },

      rightToggle: {
        position: 'absolute',
        display: 'block',
        width: 54,
        top: twoLine ? 25 : singleAvatar ? 17 : 13,
        right: 8
      },

      secondaryText: {
        fontSize: 14,
        lineHeight: threeLine ? '18px' : '16px',
        height: threeLine ? 36 : 16,
        margin: 0,
        marginTop: 4,
        color: Typography.textLightBlack,

        //needed for 2 and 3 line ellipsis
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: threeLine ? null : 'nowrap',
        display: threeLine ? '-webkit-box' : null,
        WebkitLineClamp: threeLine ? 2 : null,
        WebkitBoxOrient: threeLine ? 'vertical' : null
      }
    };

    var contentChildren = [children];

    if (leftIcon) {
      this._pushElement(contentChildren, leftIcon, this.mergeStyles(styles.icons, styles.leftIcon));
    }

    if (rightIcon) {
      this._pushElement(contentChildren, rightIcon, this.mergeStyles(styles.icons, styles.rightIcon));
    }

    if (leftAvatar) {
      this._pushElement(contentChildren, leftAvatar, this.mergeStyles(styles.avatars, styles.leftAvatar));
    }

    if (rightAvatar) {
      this._pushElement(contentChildren, rightAvatar, this.mergeStyles(styles.avatars, styles.rightAvatar));
    }

    if (leftCheckbox) {
      this._pushElement(contentChildren, leftCheckbox, this.mergeStyles(styles.leftCheckbox));
    }

    //RightIconButtonElement
    var hasNestListItems = nestedItems.length;
    var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
    var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;

    if (rightIconButton || needsNestedIndicator) {
      var rightIconButtonElement = rightIconButton;
      var rightIconButtonHandlers = {
        onKeyboardFocus: this._handleRightIconButtonKeyboardFocus,
        onMouseEnter: this._handleRightIconButtonMouseEnter,
        onMouseLeave: this._handleRightIconButtonMouseLeave,
        onTouchTap: this._handleRightIconButtonTouchTap,
        onMouseDown: this._handleRightIconButtonMouseUp,
        onMouseUp: this._handleRightIconButtonMouseUp
      };

      // Create a nested list indicator icon if we don't have an icon on the right
      if (needsNestedIndicator) {
        rightIconButtonElement = this.state.open ? React.createElement(
          IconButton,
          null,
          React.createElement(OpenIcon, null)
        ) : React.createElement(
          IconButton,
          null,
          React.createElement(CloseIcon, null)
        );
        rightIconButtonHandlers.onTouchTap = this._handleNestedListToggle;
      }

      this._pushElement(contentChildren, rightIconButtonElement, this.mergeStyles(styles.rightIconButton), rightIconButtonHandlers);
    }

    if (rightToggle) {
      this._pushElement(contentChildren, rightToggle, this.mergeStyles(styles.rightToggle));
    }

    if (primaryText) {
      var secondaryTextElement = this._createTextElement(styles.primaryText, primaryText, 'primaryText');
      contentChildren.push(secondaryTextElement);
    }

    if (secondaryText) {
      var secondaryTextElement = this._createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
      contentChildren.push(secondaryTextElement);
    }

    var nestedList = nestedItems.length ? React.createElement(
      NestedList,
      { nestedLevel: nestedLevel + 1, open: this.state.open },
      nestedItems
    ) : undefined;

    return hasCheckbox ? this._createLabelElement(styles, contentChildren) : disabled ? this._createDisabledElement(styles, contentChildren) : React.createElement(
      'div',
      null,
      React.createElement(
        EnhancedButton,
        _extends({}, other, {
          disabled: disabled,
          disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
          linkButton: true,
          onKeyboardFocus: this._handleKeyboardFocus,
          onMouseLeave: this._handleMouseLeave,
          onMouseEnter: this._handleMouseEnter,
          onTouchStart: this._handleTouchStart,
          onTouchTap: onTouchTap,
          ref: 'enhancedButton',
          style: this.mergeStyles(styles.root, style) }),
        React.createElement(
          'div',
          { style: this.prepareStyles(styles.innerDiv, innerDivStyle) },
          contentChildren
        )
      ),
      nestedList
    );
  },

  applyFocusState: function applyFocusState(focusState) {
    var button = this.refs.enhancedButton;
    var buttonEl = ReactDOM.findDOMNode(button);

    if (button) {
      switch (focusState) {
        case 'none':
          buttonEl.blur();
          break;
        case 'focused':
          buttonEl.focus();
          break;
        case 'keyboard-focused':
          button.setKeyboardFocus();
          buttonEl.focus();
          break;
      }
    }
  },

  _createDisabledElement: function _createDisabledElement(styles, contentChildren) {
    var _props2 = this.props;
    var innerDivStyle = _props2.innerDivStyle;
    var style = _props2.style;

    var mergedDivStyles = this.prepareStyles(styles.root, styles.innerDiv, innerDivStyle, style);

    return React.createElement('div', { style: mergedDivStyles }, contentChildren);
  },

  _createLabelElement: function _createLabelElement(styles, contentChildren) {
    var _props3 = this.props;
    var innerDivStyle = _props3.innerDivStyle;
    var style = _props3.style;

    var mergedLabelStyles = this.prepareStyles(styles.root, styles.innerDiv, innerDivStyle, styles.label, style);

    return React.createElement('label', { style: mergedLabelStyles }, contentChildren);
  },

  _createTextElement: function _createTextElement(styles, data, key) {
    var isAnElement = React.isValidElement(data);
    var mergedStyles = isAnElement ? this.prepareStyles(styles, data.props.style) : null;

    return isAnElement ? React.cloneElement(data, {
      key: key,
      style: mergedStyles
    }) : React.createElement(
      'div',
      { key: key, style: this.prepareStyles(styles) },
      data
    );
  },

  _handleKeyboardFocus: function _handleKeyboardFocus(e, isKeyboardFocused) {
    this.setState({ isKeyboardFocused: isKeyboardFocused });
    this.props.onKeyboardFocus(e, isKeyboardFocused);
  },

  _handleMouseEnter: function _handleMouseEnter(e) {
    if (!this.state.touch) this.setState({ hovered: true });
    this.props.onMouseEnter(e);
  },

  _handleMouseLeave: function _handleMouseLeave(e) {
    this.setState({ hovered: false });
    this.props.onMouseLeave(e);
  },

  _handleNestedListToggle: function _handleNestedListToggle(e) {
    e.stopPropagation();
    this.setState({ open: !this.state.open });
    this.props.onNestedListToggle(this);
  },

  _handleRightIconButtonKeyboardFocus: function _handleRightIconButtonKeyboardFocus(e, isKeyboardFocused) {
    var iconButton = this.props.rightIconButton;
    var newState = {};

    newState.rightIconButtonKeyboardFocused = isKeyboardFocused;
    if (isKeyboardFocused) newState.isKeyboardFocused = false;
    this.setState(newState);

    if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(e, isKeyboardFocused);
  },

  _handleRightIconButtonMouseDown: function _handleRightIconButtonMouseDown(e) {
    var iconButton = this.props.rightIconButton;
    e.stopPropagation();
    if (iconButton && iconButton.props.onMouseDown) iconButton.props.onMouseDown(e);
  },

  _handleRightIconButtonMouseLeave: function _handleRightIconButtonMouseLeave(e) {
    var iconButton = this.props.rightIconButton;
    this.setState({ rightIconButtonHovered: false });
    if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(e);
  },

  _handleRightIconButtonMouseEnter: function _handleRightIconButtonMouseEnter(e) {
    var iconButton = this.props.rightIconButton;
    this.setState({ rightIconButtonHovered: true });
    if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(e);
  },

  _handleRightIconButtonMouseUp: function _handleRightIconButtonMouseUp(e) {
    var iconButton = this.props.rightIconButton;
    e.stopPropagation();
    if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(e);
  },

  _handleRightIconButtonTouchTap: function _handleRightIconButtonTouchTap(e) {
    var iconButton = this.props.rightIconButton;

    //Stop the event from bubbling up to the list-item
    e.stopPropagation();
    if (iconButton && iconButton.props.onTouchTap) iconButton.props.onTouchTap(e);
  },

  _handleTouchStart: function _handleTouchStart(e) {
    this.setState({ touch: true });
    this.props.onTouchStart(e);
  },

  _pushElement: function _pushElement(children, element, baseStyles, additionalProps) {
    if (element) {
      var styles = this.mergeStyles(baseStyles, element.props.style);
      children.push(React.cloneElement(element, _extends({
        key: children.length,
        style: styles
      }, additionalProps)));
    }
  }

});

module.exports = ListItem;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ImmutabilityHelper = __webpack_require__(162);
var List = __webpack_require__(364);

var NestedList = React.createClass({
  displayName: 'NestedList',

  propTypes: {
    nestedLevel: React.PropTypes.number,
    open: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      nestedLevel: 1,
      open: false
    };
  },

  render: function render() {
    var _props = this.props;
    var children = _props.children;
    var open = _props.open;
    var nestedLevel = _props.nestedLevel;
    var style = _props.style;

    var styles = {
      root: {
        display: open ? null : 'none'
      }
    };

    return React.createElement(
      List,
      { style: ImmutabilityHelper.merge(styles.root, style) },
      React.Children.map(children, function (child) {
        return React.isValidElement(child) ? React.cloneElement(child, {
          nestedLevel: nestedLevel + 1
        }) : child;
      })
    );
  }

});

module.exports = NestedList;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  ClickAwayable: __webpack_require__(163),
  WindowListenable: __webpack_require__(103),
  StylePropable: __webpack_require__(10),
  StyleResizable: __webpack_require__(1054)
};

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Events = __webpack_require__(137);

var Sizes = {
  SMALL: 1,
  MEDIUM: 2,
  LARGE: 3
};

module.exports = {

  statics: {
    Sizes: Sizes
  },

  getInitialState: function getInitialState() {
    return {
      deviceSize: Sizes.SMALL
    };
  },

  componentDidMount: function componentDidMount() {
    this._updateDeviceSize();
    if (!this.manuallyBindResize) this._bindResize();
  },

  componentWillUnmount: function componentWillUnmount() {
    this._unbindResize();
  },

  isDeviceSize: function isDeviceSize(desiredSize) {
    return this.state.deviceSize >= desiredSize;
  },

  _updateDeviceSize: function _updateDeviceSize() {
    var width = window.innerWidth;
    if (width >= 992) this.setState({ deviceSize: Sizes.LARGE });else if (width >= 768) this.setState({ deviceSize: Sizes.MEDIUM });else this.setState({ deviceSize: Sizes.SMALL }); // width < 768
  },

  _bindResize: function _bindResize() {
    Events.on(window, 'resize', this._updateDeviceSize);
  },

  _unbindResize: function _unbindResize() {
    Events.off(window, 'resize', this._updateDeviceSize);
  }
};

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var RadioButton = __webpack_require__(538);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var RadioButtonGroup = React.createClass({
  displayName: 'RadioButtonGroup',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    name: React.PropTypes.string.isRequired,
    valueSelected: React.PropTypes.string,
    defaultSelected: React.PropTypes.string,
    labelPosition: React.PropTypes.oneOf(['left', 'right']),
    onChange: React.PropTypes.func
  },

  _hasCheckAttribute: function _hasCheckAttribute(radioButton) {
    return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
  },

  getInitialState: function getInitialState() {
    return {
      numberCheckedRadioButtons: 0,
      selected: this.props.valueSelected || this.props.defaultSelected || '',
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      style: {}
    };
  },

  componentWillMount: function componentWillMount() {
    var _this = this;

    var cnt = 0;

    React.Children.forEach(this.props.children, function (option) {
      if (_this._hasCheckAttribute(option)) cnt++;
    }, this);

    this.setState({ numberCheckedRadioButtons: cnt });
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    var newState = { muiTheme: newMuiTheme };

    if (nextProps.hasOwnProperty('valueSelected')) {
      newState.selected = nextProps.valueSelected;
    }

    this.setState(newState);
  },

  render: function render() {
    var _this2 = this;

    var options = React.Children.map(this.props.children, function (option) {
      var _option$props = option.props;
      var name = _option$props.name;
      var value = _option$props.value;
      var label = _option$props.label;
      var onCheck = _option$props.onCheck;

      var other = _objectWithoutProperties(_option$props, ['name', 'value', 'label', 'onCheck']);

      return React.createElement(RadioButton, _extends({}, other, {
        ref: option.props.value,
        name: _this2.props.name,
        key: option.props.value,
        value: option.props.value,
        label: option.props.label,
        labelPosition: _this2.props.labelPosition,
        onCheck: _this2._onChange,
        checked: option.props.value === _this2.state.selected }));
    }, this);

    return React.createElement(
      'div',
      {
        style: this.prepareStyles(this.props.style),
        className: this.props.className || '' },
      options
    );
  },

  _updateRadioButtons: function _updateRadioButtons(newSelection) {
    if (this.state.numberCheckedRadioButtons === 0) {
      this.setState({ selected: newSelection });
    } else if (false) {
      var message = "Cannot select a different radio button while another radio button " + "has the 'checked' property set to true.";
      console.error(message);
    }
  },

  _onChange: function _onChange(e, newSelection) {
    this._updateRadioButtons(newSelection);

    // Successful update
    if (this.state.numberCheckedRadioButtons === 0) {
      if (this.props.onChange) this.props.onChange(e, newSelection);
    }
  },

  getSelectedValue: function getSelectedValue() {
    return this.state.selected;
  },

  setSelectedValue: function setSelectedValue(newSelectionValue) {
    this._updateRadioButtons(newSelectionValue);
  },

  clearValue: function clearValue() {
    this.setSelectedValue('');
  }

});

module.exports = RadioButtonGroup;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var ColorManipulator = __webpack_require__(95);
var Typography = __webpack_require__(135);
var EnhancedButton = __webpack_require__(102);
var Paper = __webpack_require__(54);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

function validateLabel(props, propName, componentName) {
  if (!props.children && !props.label) {
    return new Error('Required prop label or children was not ' + 'specified in ' + componentName + '.');
  }
}

var RaisedButton = React.createClass({
  displayName: 'RaisedButton',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    className: React.PropTypes.string,
    disabled: React.PropTypes.bool,
    label: validateLabel,
    onMouseDown: React.PropTypes.func,
    onMouseUp: React.PropTypes.func,
    onMouseLeave: React.PropTypes.func,
    onTouchEnd: React.PropTypes.func,
    onTouchStart: React.PropTypes.func,
    primary: React.PropTypes.bool,
    secondary: React.PropTypes.bool,
    labelStyle: React.PropTypes.object,
    backgroundColor: React.PropTypes.string,
    labelColor: React.PropTypes.string,
    disabledBackgroundColor: React.PropTypes.string,
    disabledLabelColor: React.PropTypes.string,
    fullWidth: React.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    var zDepth = this.props.disabled ? 0 : 1;
    return {
      hovered: false,
      touched: false,
      initialZDepth: zDepth,
      zDepth: zDepth,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var zDepth = nextProps.disabled ? 0 : 1;
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({
      zDepth: zDepth,
      initialZDepth: zDepth,
      muiTheme: newMuiTheme
    });
  },

  _getBackgroundColor: function _getBackgroundColor() {
    var disabledColor = this.props.disabledBackgroundColor ? this.props.disabledBackgroundColor : this.getTheme().disabledColor;

    return this.props.disabled ? disabledColor : this.props.backgroundColor ? this.props.backgroundColor : this.props.primary ? this.getTheme().primaryColor : this.props.secondary ? this.getTheme().secondaryColor : this.getTheme().color;
  },

  _getLabelColor: function _getLabelColor() {
    var disabledColor = this.props.disabledLabelColor ? this.props.disabledLabelColor : this.getTheme().disabledTextColor;

    return this.props.disabled ? disabledColor : this.props.labelColor ? this.props.labelColor : this.props.primary ? this.getTheme().primaryTextColor : this.props.secondary ? this.getTheme().secondaryTextColor : this.getTheme().textColor;
  },

  getThemeButton: function getThemeButton() {
    return this.state.muiTheme.button;
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.raisedButton;
  },

  getStyles: function getStyles() {

    var amount = this.props.primary || this.props.secondary ? 0.4 : 0.08;
    var styles = {
      root: {
        backgroundColor: 'none',
        display: 'inline-block',
        minWidth: this.props.fullWidth ? '100%' : this.getThemeButton().minWidth,
        height: this.getThemeButton().height,
        transition: Transitions.easeOut()
      },
      container: {
        position: 'relative',
        height: '100%',
        width: '100%',
        padding: 0,
        overflow: 'hidden',
        borderRadius: 2,
        transition: Transitions.easeOut(),
        backgroundColor: this._getBackgroundColor(),

        //This is need so that ripples do not bleed
        //past border radius.
        //See: http://stackoverflow.com/questions/17298739/css-overflow-hidden-not-working-in-chrome-when-parent-has-border-radius-and-chil
        transform: 'translate3d(0, 0, 0)'
      },
      label: {
        position: 'relative',
        opacity: 1,
        fontSize: '14px',
        letterSpacing: 0,
        textTransform: this.getTheme().textTransform ? this.getTheme().textTransform : this.getThemeButton().textTransform ? this.getThemeButton().textTransform : 'uppercase',
        fontWeight: Typography.fontWeightMedium,
        margin: 0,
        padding: '0px ' + this.state.muiTheme.rawTheme.spacing.desktopGutterLess + 'px',
        userSelect: 'none',
        lineHeight: this.props.style && this.props.style.height ? this.props.style.height : this.getThemeButton().height + 'px',
        color: this._getLabelColor()
      },
      overlay: {
        transition: Transitions.easeOut(),
        top: 0
      },
      overlayWhenHovered: {
        backgroundColor: ColorManipulator.fade(this._getLabelColor(), amount)
      }
    };
    return styles;
  },

  render: function render() {
    var _props = this.props;
    var disabled = _props.disabled;
    var label = _props.label;
    var primary = _props.primary;
    var secondary = _props.secondary;

    var other = _objectWithoutProperties(_props, ['disabled', 'label', 'primary', 'secondary']);

    var styles = this.getStyles();

    var labelElement = undefined;
    if (label) {
      labelElement = React.createElement(
        'span',
        { style: this.prepareStyles(styles.label, this.props.labelStyle) },
        label
      );
    }

    var rippleColor = styles.label.color;
    var rippleOpacity = !(primary || secondary) ? 0.1 : 0.16;

    var buttonEventHandlers = disabled ? null : {
      onMouseDown: this._handleMouseDown,
      onMouseUp: this._handleMouseUp,
      onMouseLeave: this._handleMouseLeave,
      onMouseEnter: this._handleMouseEnter,
      onTouchStart: this._handleTouchStart,
      onTouchEnd: this._handleTouchEnd,
      onKeyboardFocus: this._handleKeyboardFocus
    };

    return React.createElement(
      Paper,
      {
        style: this.mergeStyles(styles.root, this.props.style),
        zDepth: this.state.zDepth },
      React.createElement(
        EnhancedButton,
        _extends({}, other, buttonEventHandlers, {
          ref: 'container',
          disabled: disabled,
          style: this.mergeStyles(styles.container),
          focusRippleColor: rippleColor,
          touchRippleColor: rippleColor,
          focusRippleOpacity: rippleOpacity,
          touchRippleOpacity: rippleOpacity }),
        React.createElement(
          'div',
          { ref: 'overlay', style: this.prepareStyles(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered) },
          labelElement,
          this.props.children
        )
      )
    );
  },

  _handleMouseDown: function _handleMouseDown(e) {
    //only listen to left clicks
    if (e.button === 0) {
      this.setState({ zDepth: this.state.initialZDepth + 1 });
    }
    if (this.props.onMouseDown) this.props.onMouseDown(e);
  },

  _handleMouseUp: function _handleMouseUp(e) {
    this.setState({ zDepth: this.state.initialZDepth });
    if (this.props.onMouseUp) this.props.onMouseUp(e);
  },

  _handleMouseLeave: function _handleMouseLeave(e) {
    if (!this.refs.container.isKeyboardFocused()) this.setState({ zDepth: this.state.initialZDepth, hovered: false });
    if (this.props.onMouseLeave) this.props.onMouseLeave(e);
  },

  _handleMouseEnter: function _handleMouseEnter(e) {
    if (!this.refs.container.isKeyboardFocused() && !this.state.touch) {
      this.setState({ hovered: true });
    }
    if (this.props.onMouseEnter) this.props.onMouseEnter(e);
  },

  _handleTouchStart: function _handleTouchStart(e) {
    this.setState({
      touch: true,
      zDepth: this.state.initialZDepth + 1
    });
    if (this.props.onTouchStart) this.props.onTouchStart(e);
  },

  _handleTouchEnd: function _handleTouchEnd(e) {
    this.setState({ zDepth: this.state.initialZDepth });
    if (this.props.onTouchEnd) this.props.onTouchEnd(e);
  },

  _handleKeyboardFocus: function _handleKeyboardFocus(e, keyboardFocused) {
    if (keyboardFocused && !this.props.disabled) {
      this.setState({ zDepth: this.state.initialZDepth + 1 });
      var amount = this.props.primary || this.props.secondary ? 0.4 : 0.08;
      ReactDOM.findDOMNode(this.refs.overlay).style.backgroundColor = ColorManipulator.fade(this.prepareStyles(this.getStyles().label, this.props.labelStyle).color, amount);
    } else if (!this.state.hovered) {
      this.setState({ zDepth: this.state.initialZDepth });
      ReactDOM.findDOMNode(this.refs.overlay).style.backgroundColor = 'transparent';
    }
  }
});

module.exports = RaisedButton;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var AutoPrefix = __webpack_require__(62);
var Transitions = __webpack_require__(21);
var Paper = __webpack_require__(54);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var VIEWBOX_SIZE = 32;
var RefreshIndicator = _react2['default'].createClass({
  displayName: 'RefreshIndicator',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: _react2['default'].PropTypes.object
  },

  propTypes: {
    left: _react2['default'].PropTypes.number.isRequired,
    percentage: _react2['default'].PropTypes.number,
    size: _react2['default'].PropTypes.number,
    status: _react2['default'].PropTypes.oneOf(['ready', 'loading', 'hide']),
    style: _react2['default'].PropTypes.object,
    top: _react2['default'].PropTypes.number.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      percentage: 0,
      size: 40,
      status: 'hide'
    };
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: _react2['default'].PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  componentDidMount: function componentDidMount() {
    this.componentDidUpdate();
  },

  componentDidUpdate: function componentDidUpdate() {
    this._scalePath(ReactDOM.findDOMNode(this.refs.path), 0);
    this._rotateWrapper(ReactDOM.findDOMNode(this.refs.wrapper));
  },

  render: function render() {
    var rootStyle = this._getRootStyle();
    return _react2['default'].createElement(
      Paper,
      {
        circle: true,
        style: this.mergeStyles(rootStyle, this.props.style),
        ref: 'indicatorCt'
      },
      this._renderChildren()
    );
  },

  _renderChildren: function _renderChildren() {
    var paperSize = this._getPaperSize();
    var childrenCmp = null;
    if (this.props.status !== 'ready') {
      var circleStyle = this._getCircleStyle(paperSize);
      childrenCmp = _react2['default'].createElement(
        'div',
        { ref: 'wrapper', style: this.prepareStyles({
            transition: Transitions.create('transform', '20s', null, 'linear'),
            width: '100%',
            height: '100%'
          })
        },
        _react2['default'].createElement(
          'svg',
          { style: {
              width: paperSize,
              height: paperSize
            },
            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
          },
          _react2['default'].createElement('circle', _extends({ ref: 'path',
            style: this.prepareStyles(circleStyle.style, {
              transition: Transitions.create('all', '1.5s', null, 'ease-in-out')
            })
          }, circleStyle.attr))
        )
      );
    } else {
      var circleStyle = this._getCircleStyle(paperSize);
      var polygonStyle = this._getPolygonStyle(paperSize);
      childrenCmp = _react2['default'].createElement(
        'svg',
        { style: {
            width: paperSize,
            height: paperSize
          },
          viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
        },
        _react2['default'].createElement('circle', _extends({
          style: this.prepareStyles(circleStyle.style)
        }, circleStyle.attr)),
        _react2['default'].createElement('polygon', _extends({
          style: this.prepareStyles(polygonStyle.style)
        }, polygonStyle.attr))
      );
    }

    return childrenCmp;
  },

  _getTheme: function _getTheme() {
    return this.state.muiTheme.refreshIndicator;
  },

  _getPaddingSize: function _getPaddingSize() {
    var padding = this.props.size * 0.1;
    return padding;
  },

  _getPaperSize: function _getPaperSize() {
    return this.props.size - this._getPaddingSize() * 2;
  },

  _getCircleAttr: function _getCircleAttr() {
    return {
      radiu: VIEWBOX_SIZE / 2 - 5,
      originX: VIEWBOX_SIZE / 2,
      originY: VIEWBOX_SIZE / 2,
      strokeWidth: 3
    };
  },

  _getArcDeg: function _getArcDeg() {
    var p = this.props.percentage / 100;

    var beginDeg = p * 120;
    var endDeg = p * 410;
    return [beginDeg, endDeg];
  },

  _getFactor: function _getFactor() {
    var p = this.props.percentage / 100;
    var p1 = Math.min(1, p / 0.4);

    return p1;
  },

  _getRootStyle: function _getRootStyle() {
    var padding = this._getPaddingSize();
    return {
      position: "absolute",
      zIndex: 2,
      width: this.props.size,
      height: this.props.size,
      padding: padding,
      top: -10000,
      left: -10000,
      transform: 'translate3d(' + (10000 + this.props.left) + 'px, ' + (10000 + this.props.top) + 'px, 0)',
      opacity: this.props.status === 'hide' ? 0 : 1,
      transition: this.props.status === 'hide' ? Transitions.create('all', '.3s', 'ease-out') : 'none'
    };
  },

  _getCircleStyle: function _getCircleStyle() {
    var isLoading = this.props.status === 'loading';
    var p1 = isLoading ? 1 : this._getFactor();
    var circle = this._getCircleAttr();
    var perimeter = Math.PI * 2 * circle.radiu;

    var _getArcDeg2 = this._getArcDeg();

    var _getArcDeg22 = _slicedToArray(_getArcDeg2, 2);

    var beginDeg = _getArcDeg22[0];
    var endDeg = _getArcDeg22[1];

    var arcLen = (endDeg - beginDeg) * perimeter / 360;
    var dashOffset = -beginDeg * perimeter / 360;

    var theme = this._getTheme();
    return {
      style: {
        strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
        strokeDashoffset: dashOffset,
        stroke: isLoading || this.props.percentage === 100 ? theme.loadingStrokeColor : theme.strokeColor,
        strokeLinecap: 'round',
        opacity: p1,
        strokeWidth: circle.strokeWidth * p1,
        fill: 'none'
      },
      attr: {
        cx: circle.originX,
        cy: circle.originY,
        r: circle.radiu
      }
    };
  },

  _getPolygonStyle: function _getPolygonStyle() {
    var p1 = this._getFactor();
    var circle = this._getCircleAttr();

    var triangleCx = circle.originX + circle.radiu;
    var triangleCy = circle.originY;
    var dx = circle.strokeWidth * 7 / 4 * p1;
    var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);

    var _getArcDeg3 = this._getArcDeg();

    var _getArcDeg32 = _slicedToArray(_getArcDeg3, 2);

    var endDeg = _getArcDeg32[1];

    var theme = this._getTheme();
    return {
      style: {
        fill: this.props.percentage === 100 ? theme.loadingStrokeColor : theme.strokeColor,
        transform: 'rotate(' + endDeg + 'deg)',
        transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
        opacity: p1
      },
      attr: {
        points: trianglePath
      }
    };
  },

  _scalePath: function _scalePath(path, step) {
    if (this.props.status !== 'loading' || !this.isMounted()) return;

    var currStep = (step || 0) % 3;

    clearTimeout(this._timer1);
    this._timer1 = setTimeout(this._scalePath.bind(this, path, currStep + 1), currStep ? 750 : 250);

    var circle = this._getCircleAttr();
    var perimeter = Math.PI * 2 * circle.radiu;
    var arcLen = perimeter * 0.64;

    if (currStep === 0) {
      path.style.strokeDasharray = '1, 200';
      path.style.strokeDashoffset = 0;
      path.style[this.prefixed('transitionDuration')] = '0ms';
    } else if (currStep === 1) {
      path.style.strokeDasharray = arcLen + ', 200';
      path.style.strokeDashoffset = -15;
      path.style[this.prefixed('transitionDuration')] = '750ms';
    } else {
      path.style.strokeDasharray = arcLen + ',200';
      path.style.strokeDashoffset = -(perimeter - 1);
      path.style[this.prefixed('transitionDuration')] = '850ms';
    }
  },

  _rotateWrapper: function _rotateWrapper(wrapper) {
    var _this = this;

    if (this.props.status !== 'loading' || !this.isMounted()) return;

    clearTimeout(this._timer2);
    this._timer2 = setTimeout(this._rotateWrapper.bind(this, wrapper), 10050);

    AutoPrefix.set(wrapper.style, "transform", null);
    AutoPrefix.set(wrapper.style, "transform", "rotate(0deg)");
    AutoPrefix.set(wrapper.style, "transitionDuration", "0ms");

    setTimeout(function () {
      if (_this.isMounted()) {
        AutoPrefix.set(wrapper.style, "transform", "rotate(1800deg)");
        wrapper.style.transitionDuration = "10s";
        AutoPrefix.set(wrapper.style, "transitionTimingFunction", "linear");
      }
    }, 50);
  },

  prefixed: function prefixed(key) {
    return AutoPrefix.single(key);
  }

});

module.exports = RefreshIndicator;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  CircleRipple: __webpack_require__(520),
  FocusRipple: __webpack_require__(245),
  TouchRipple: __webpack_require__(351)
};

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var TextField = __webpack_require__(246);
var DropDownMenu = __webpack_require__(534);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);
var ContextPure = __webpack_require__(136);

var SelectField = React.createClass({
  displayName: 'SelectField',

  mixins: [StylePropable, ContextPure],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  statics: {
    getChildrenClasses: function getChildrenClasses() {
      return [TextField, DropDownMenu];
    }
  },

  propTypes: {
    errorText: React.PropTypes.string,
    floatingLabelText: React.PropTypes.string,
    selectFieldRoot: React.PropTypes.object,
    underlineStyle: React.PropTypes.object,
    labelStyle: React.PropTypes.object,
    errorStyle: React.PropTypes.object,
    hintText: React.PropTypes.string,
    id: React.PropTypes.string,
    multiLine: React.PropTypes.bool,
    onBlur: React.PropTypes.func,
    onChange: React.PropTypes.func,
    onFocus: React.PropTypes.func,
    onKeyDown: React.PropTypes.func,
    onEnterKeyDown: React.PropTypes.func,
    type: React.PropTypes.string,
    rows: React.PropTypes.number,
    inputStyle: React.PropTypes.object,
    iconStyle: React.PropTypes.object,
    floatingLabelStyle: React.PropTypes.object,
    autoWidth: React.PropTypes.bool,
    menuItems: React.PropTypes.array.isRequired,
    menuItemStyle: React.PropTypes.object,
    selectedIndex: React.PropTypes.number
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      fullWidth: false
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getStyles: function getStyles() {
    var styles = {
      root: {
        height: 46,
        position: 'relative',
        width: '100%',
        top: 16,
        fontSize: 16
      },
      label: {
        paddingLeft: 0,
        top: 4,
        width: '100%'
      },
      icon: {
        top: 20,
        right: 0
      },
      underline: {
        borderTop: 'none'
      },
      input: {},
      error: {}
    };

    if (!this.props.floatingLabelText) {
      if (this.props.hintText) {
        styles.root.top = -5;
        styles.label.top = 1;
        styles.icon.top = 17;
      } else {
        styles.root.top = -8;
      }
    } else {
      styles.error.bottom = -15;
    }

    return styles;
  },

  render: function render() {
    var styles = this.getStyles();
    var _props = this.props;
    var style = _props.style;
    var labelStyle = _props.labelStyle;
    var iconStyle = _props.iconStyle;
    var underlineStyle = _props.underlineStyle;
    var errorStyle = _props.errorStyle;
    var selectFieldRoot = _props.selectFieldRoot;
    var menuItems = _props.menuItems;
    var disabled = _props.disabled;
    var floatingLabelText = _props.floatingLabelText;
    var floatingLabelStyle = _props.floatingLabelStyle;
    var hintText = _props.hintText;
    var fullWidth = _props.fullWidth;
    var errorText = _props.errorText;

    var other = _objectWithoutProperties(_props, ['style', 'labelStyle', 'iconStyle', 'underlineStyle', 'errorStyle', 'selectFieldRoot', 'menuItems', 'disabled', 'floatingLabelText', 'floatingLabelStyle', 'hintText', 'fullWidth', 'errorText']);

    var textFieldProps = {
      style: this.mergeAndPrefix(styles.input, style),
      floatingLabelText: floatingLabelText,
      floatingLabelStyle: floatingLabelStyle,
      hintText: !hintText && !floatingLabelText ? ' ' : hintText,
      fullWidth: fullWidth,
      errorText: errorText,
      errorStyle: this.mergeAndPrefix(styles.error, errorStyle)
    };
    var dropDownMenuProps = {
      menuItems: menuItems,
      disabled: disabled,
      style: this.mergeAndPrefix(styles.root, selectFieldRoot),
      labelStyle: this.mergeAndPrefix(styles.label, labelStyle),
      iconStyle: this.mergeAndPrefix(styles.icon, iconStyle),
      underlineStyle: this.mergeAndPrefix(styles.underline, underlineStyle),
      autoWidth: false
    };

    return React.createElement(
      TextField,
      textFieldProps,
      React.createElement(DropDownMenu, _extends({}, dropDownMenuProps, other))
    );
  }
});

module.exports = SelectField;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var FocusRipple = __webpack_require__(245);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

/**
  * Verifies min/max range.
  * @param   {Object} props         Properties of the React component.
  * @param   {String} propName      Name of the property to validate.
  * @param   {String} componentName Name of the component whose property is being validated.
  * @returns {Object} Returns an Error if min >= max otherwise null.
  */
var minMaxPropType = function minMaxPropType(props, propName, componentName) {
  var error = React.PropTypes.number(props, propName, componentName);
  if (error !== null) return error;

  if (props.min >= props.max) {
    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
    return new Error(errorMsg);
  }
};

/**
  * Verifies value is within the min/max range.
  * @param   {Object} props         Properties of the React component.
  * @param   {String} propName      Name of the property to validate.
  * @param   {String} componentName Name of the component whose property is being validated.
  * @returns {Object} Returns an Error if the value is not within the range otherwise null.
  */
var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
  var error = React.PropTypes.number(props, propName, componentName);
  if (error !== null) return error;

  var value = props[propName];
  if (value < props.min || props.max < value) {
    return new Error(propName + ' should be within the range specified by min and max');
  }
};

var Slider = React.createClass({
  displayName: 'Slider',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    name: React.PropTypes.string.isRequired,
    defaultValue: valueInRangePropType,
    description: React.PropTypes.string,
    disabled: React.PropTypes.bool,
    error: React.PropTypes.string,
    max: minMaxPropType,
    min: minMaxPropType,
    required: React.PropTypes.bool,
    step: React.PropTypes.number,
    onBlur: React.PropTypes.func,
    onChange: React.PropTypes.func,
    onDragStart: React.PropTypes.func,
    onDragStop: React.PropTypes.func,
    onFocus: React.PropTypes.func,
    value: valueInRangePropType
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      defaultValue: 0,
      disabled: false,
      max: 1,
      min: 0,
      required: true,
      step: 0.01,
      style: {}
    };
  },

  getInitialState: function getInitialState() {
    var value = this.props.value;
    if (value === undefined) {
      value = this.props.defaultValue;
    }
    var percent = (value - this.props.min) / (this.props.max - this.props.min);
    if (isNaN(percent)) percent = 0;

    return {
      active: false,
      dragging: false,
      focused: false,
      hovered: false,
      percent: percent,
      value: value,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });

    if (nextProps.value !== undefined) {
      this.setValue(nextProps.value);
    }
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.slider;
  },

  getStyles: function getStyles() {
    var fillGutter = this.getTheme().handleSize / 2;
    var disabledGutter = this.getTheme().trackSize + this.getTheme().handleSizeDisabled / 2;
    var calcDisabledSpacing = this.props.disabled ? ' - ' + disabledGutter + 'px' : '';
    var styles = {
      root: {
        touchCallout: 'none',
        userSelect: 'none',
        cursor: 'default',
        height: this.getTheme().handleSizeActive,
        position: 'relative',
        marginTop: 24,
        marginBottom: 48
      },
      track: {
        position: 'absolute',
        top: (this.getTheme().handleSizeActive - this.getTheme().trackSize) / 2,
        left: 0,
        width: '100%',
        height: this.getTheme().trackSize
      },
      filledAndRemaining: {
        position: 'absolute',
        top: 0,
        height: '100%',
        transition: Transitions.easeOut(null, 'margin')
      },
      handle: {
        boxSizing: 'border-box',
        position: 'absolute',
        cursor: 'pointer',
        pointerEvents: 'inherit',
        top: 0,
        left: '0%',
        zIndex: 1,
        margin: this.getTheme().trackSize / 2 + 'px 0 0 0',
        width: this.getTheme().handleSize,
        height: this.getTheme().handleSize,
        backgroundColor: this.getTheme().selectionColor,
        backgroundClip: 'padding-box',
        border: '0px solid transparent',
        borderRadius: '50%',
        transform: 'translate(-50%, -50%)',
        transition: Transitions.easeOut('450ms', 'background') + ',' + Transitions.easeOut('450ms', 'border-color') + ',' + Transitions.easeOut('450ms', 'width') + ',' + Transitions.easeOut('450ms', 'height'),
        overflow: 'visible'
      },
      handleWhenDisabled: {
        boxSizing: 'content-box',
        cursor: 'not-allowed',
        backgroundColor: this.getTheme().trackColor,
        width: this.getTheme().handleSizeDisabled,
        height: this.getTheme().handleSizeDisabled,
        border: 'none'
      },
      handleWhenPercentZero: {
        border: this.getTheme().trackSize + 'px solid ' + this.getTheme().handleColorZero,
        backgroundColor: this.getTheme().handleFillColor,
        boxShadow: 'none'
      },
      handleWhenPercentZeroAndDisabled: {
        cursor: 'not-allowed',
        width: this.getTheme().handleSizeDisabled,
        height: this.getTheme().handleSizeDisabled
      },
      handleWhenPercentZeroAndFocused: {
        border: this.getTheme().trackSize + 'px solid ' + this.getTheme().trackColorSelected
      },
      handleWhenActive: {
        width: this.getTheme().handleSizeActive,
        height: this.getTheme().handleSizeActive
      },
      ripple: {
        height: this.getTheme().handleSize,
        width: this.getTheme().handleSize,
        overflow: 'visible'
      },
      rippleWhenPercentZero: {
        top: -this.getTheme().trackSize,
        left: -this.getTheme().trackSize
      },
      rippleInner: {
        height: '300%',
        width: '300%',
        top: -this.getTheme().handleSize,
        left: -this.getTheme().handleSize
      }
    };
    styles.filled = this.mergeAndPrefix(styles.filledAndRemaining, {
      left: 0,
      backgroundColor: this.props.disabled ? this.getTheme().trackColor : this.getTheme().selectionColor,
      marginRight: fillGutter,
      width: 'calc(' + this.state.percent * 100 + '%' + calcDisabledSpacing + ')'
    });
    styles.remaining = this.mergeAndPrefix(styles.filledAndRemaining, {
      right: 0,
      backgroundColor: this.getTheme().trackColor,
      marginLeft: fillGutter,
      width: 'calc(' + (1 - this.state.percent) * 100 + '%' + calcDisabledSpacing + ')'
    });

    return styles;
  },

  render: function render() {
    var others = _objectWithoutProperties(this.props, []);

    var percent = this.state.percent;
    if (percent > 1) percent = 1;else if (percent < 0) percent = 0;

    var styles = this.getStyles();
    var sliderStyles = this.prepareStyles(styles.root, this.props.style);
    var handleStyles = percent === 0 ? this.prepareStyles(styles.handle, styles.handleWhenPercentZero, this.state.active && styles.handleWhenActive, this.state.focused && { outline: 'none' }, (this.state.hovered || this.state.focused) && !this.props.disabled && styles.handleWhenPercentZeroAndFocused, this.props.disabled && styles.handleWhenPercentZeroAndDisabled) : this.prepareStyles(styles.handle, this.state.active && styles.handleWhenActive, this.state.focused && { outline: 'none' }, this.props.disabled && styles.handleWhenDisabled, {
      left: percent * 100 + '%'
    });
    var rippleStyle = this.mergeAndPrefix(styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
    var remainingStyles = styles.remaining;
    if ((this.state.hovered || this.state.focused) && !this.props.disabled) {
      remainingStyles.backgroundColor = this.getTheme().trackColorSelected;
    }

    var rippleShowCondition = (this.state.hovered || this.state.focused) && !this.state.active;
    var rippleColor = this.state.percent === 0 ? this.getTheme().handleColorZero : this.getTheme().rippleColor;
    var focusRipple = undefined;
    if (!this.props.disabled && !this.props.disableFocusRipple) {
      focusRipple = React.createElement(FocusRipple, {
        ref: 'focusRipple',
        key: 'focusRipple',
        style: rippleStyle,
        innerStyle: styles.rippleInner,
        show: rippleShowCondition,
        color: rippleColor });
    }

    var handleDragProps = {};

    if (!this.props.disabled) {
      handleDragProps = {
        onTouchStart: this._onHandleTouchStart,
        onMouseDown: this._onHandleMouseDown
      };
    }

    return React.createElement(
      'div',
      _extends({}, others, { style: this.prepareStyles(this.props.style) }),
      React.createElement('span', { className: 'mui-input-highlight' }),
      React.createElement('span', { className: 'mui-input-bar' }),
      React.createElement(
        'span',
        { className: 'mui-input-description' },
        this.props.description
      ),
      React.createElement(
        'span',
        { className: 'mui-input-error' },
        this.props.error
      ),
      React.createElement(
        'div',
        { style: sliderStyles,
          onFocus: this._onFocus,
          onBlur: this._onBlur,
          onMouseDown: this._onMouseDown,
          onMouseEnter: this._onMouseEnter,
          onMouseLeave: this._onMouseLeave,
          onMouseUp: this._onMouseUp },
        React.createElement(
          'div',
          { ref: 'track', style: this.prepareStyles(styles.track) },
          React.createElement('div', { style: this.prepareStyles(styles.filled) }),
          React.createElement('div', { style: this.prepareStyles(remainingStyles) }),
          React.createElement(
            'div',
            _extends({ style: handleStyles, tabIndex: 0 }, handleDragProps),
            focusRipple
          )
        )
      ),
      React.createElement('input', { ref: 'input', type: 'hidden',
        name: this.props.name,
        value: this.state.value,
        required: this.props.required,
        min: this.props.min,
        max: this.props.max,
        step: this.props.step })
    );
  },

  _onHandleTouchStart: function _onHandleTouchStart(e) {
    if (document) {
      document.addEventListener('touchmove', this._dragTouchHandler, false);
      document.addEventListener('touchup', this._dragTouchEndHandler, false);
      document.addEventListener('touchend', this._dragTouchEndHandler, false);
      document.addEventListener('touchcancel', this._dragTouchEndHandler, false);
    }
    this._onDragStart(e);
  },

  _onHandleMouseDown: function _onHandleMouseDown(e) {
    if (document) {
      document.addEventListener('mousemove', this._dragHandler, false);
      document.addEventListener('mouseup', this._dragEndHandler, false);
    }
    this._onDragStart(e);
  },

  _dragHandler: function _dragHandler(e) {
    var _this = this;

    if (this._dragRunning) {
      return;
    }
    this._dragRunning = true;
    requestAnimationFrame(function () {
      _this._onDragUpdate(e, e.clientX - _this._getTrackLeft());
      _this._dragRunning = false;
    });
  },

  _dragTouchHandler: function _dragTouchHandler(e) {
    var _this2 = this;

    if (this._dragRunning) {
      return;
    }
    this._dragRunning = true;
    requestAnimationFrame(function () {
      _this2._onDragUpdate(e, e.touches[0].clientX - _this2._getTrackLeft());
      _this2._dragRunning = false;
    });
  },

  _dragEndHandler: function _dragEndHandler(e) {
    if (document) {
      document.removeEventListener('mousemove', this._dragHandler, false);
      document.removeEventListener('mouseup', this._dragEndHandler, false);
    }

    this._onDragStop(e);
  },

  _dragTouchEndHandler: function _dragTouchEndHandler(e) {
    if (document) {
      document.removeEventListener('touchmove', this._dragTouchHandler, false);
      document.removeEventListener('touchup', this._dragTouchEndHandler, false);
      document.removeEventListener('touchend', this._dragTouchEndHandler, false);
      document.removeEventListener('touchcancel', this._dragTouchEndHandler, false);
    }

    this._onDragStop(e);
  },

  getValue: function getValue() {
    return this.state.value;
  },

  setValue: function setValue(i) {
    // calculate percentage
    var percent = (i - this.props.min) / (this.props.max - this.props.min);
    if (isNaN(percent)) percent = 0;
    // update state
    this.setState({
      value: i,
      percent: percent
    });
  },

  getPercent: function getPercent() {
    return this.state.percent;
  },

  setPercent: function setPercent(percent, callback) {
    var value = this._alignValue(this._percentToValue(percent));
    var _props = this.props;
    var min = _props.min;
    var max = _props.max;

    var alignedPercent = (value - min) / (max - min);
    if (this.state.value !== value) {
      this.setState({ value: value, percent: alignedPercent }, callback);
    }
  },

  clearValue: function clearValue() {
    this.setValue(this.props.min);
  },

  _alignValue: function _alignValue(val) {
    var _props2 = this.props;
    var step = _props2.step;
    var min = _props2.min;

    var alignValue = Math.round((val - min) / step) * step + min;
    return parseFloat(alignValue.toFixed(5));
  },

  _onFocus: function _onFocus(e) {
    this.setState({ focused: true });
    if (this.props.onFocus) this.props.onFocus(e);
  },

  _onBlur: function _onBlur(e) {
    this.setState({ focused: false, active: false });
    if (this.props.onBlur) this.props.onBlur(e);
  },

  _onMouseDown: function _onMouseDown(e) {
    if (!this.props.disabled) this._pos = e.clientX;
  },

  _onMouseEnter: function _onMouseEnter() {
    this.setState({ hovered: true });
  },

  _onMouseLeave: function _onMouseLeave() {
    this.setState({ hovered: false });
  },

  _getTrackLeft: function _getTrackLeft() {
    return ReactDOM.findDOMNode(this.refs.track).getBoundingClientRect().left;
  },

  _onMouseUp: function _onMouseUp(e) {
    if (!this.props.disabled) this.setState({ active: false });
    if (!this.state.dragging && Math.abs(this._pos - e.clientX) < 5) {
      var pos = e.clientX - this._getTrackLeft();
      this._dragX(e, pos);
    }

    this._pos = undefined;
  },

  _onDragStart: function _onDragStart(e) {
    this.setState({
      dragging: true,
      active: true
    });
    if (this.props.onDragStart) this.props.onDragStart(e);
  },

  _onDragStop: function _onDragStop(e) {
    this.setState({
      dragging: false,
      active: false
    });
    if (this.props.onDragStop) this.props.onDragStop(e);
  },

  _onDragUpdate: function _onDragUpdate(e, pos) {
    if (!this.state.dragging) return;
    if (!this.props.disabled) this._dragX(e, pos);
  },

  _dragX: function _dragX(e, pos) {
    var max = ReactDOM.findDOMNode(this.refs.track).clientWidth;
    if (pos < 0) pos = 0;else if (pos > max) pos = max;
    this._updateWithChangeEvent(e, pos / max);
  },

  _updateWithChangeEvent: function _updateWithChangeEvent(e, percent) {
    var _this3 = this;

    this.setPercent(percent, function () {
      if (_this3.props.onChange) _this3.props.onChange(e, _this3.state.value);
    });
  },

  _percentToValue: function _percentToValue(percent) {
    return percent * (this.props.max - this.props.min) + this.props.min;
  }

});

module.exports = Slider;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var CssEvent = __webpack_require__(192);
var StylePropable = __webpack_require__(10);
var Transitions = __webpack_require__(21);
var ClickAwayable = __webpack_require__(163);
var FlatButton = __webpack_require__(193);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Snackbar = React.createClass({
  displayName: 'Snackbar',

  mixins: [StylePropable, ClickAwayable],

  manuallyBindClickAway: true,

  // ID of the active timer.
  _autoHideTimerId: undefined,

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    message: React.PropTypes.string.isRequired,
    action: React.PropTypes.string,
    autoHideDuration: React.PropTypes.number,
    onActionTouchTap: React.PropTypes.func,
    onShow: React.PropTypes.func,
    onDismiss: React.PropTypes.func,
    openOnMount: React.PropTypes.bool
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      open: this.props.openOnMount || false,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  componentDidMount: function componentDidMount() {
    if (this.props.openOnMount) {
      this._setAutoHideTimer();
      this._bindClickAway();
    }
  },

  componentClickAway: function componentClickAway() {
    this.dismiss();
  },

  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    var _this = this;

    if (prevState.open !== this.state.open) {
      if (this.state.open) {
        this._setAutoHideTimer();

        //Only Bind clickaway after transition finishes
        CssEvent.onTransitionEnd(ReactDOM.findDOMNode(this), function () {
          _this._bindClickAway();
        });
      } else {
        this._unbindClickAway();
      }
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    this._clearAutoHideTimer();
    this._unbindClickAway();
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.snackbar;
  },

  getSpacing: function getSpacing() {
    return this.state.muiTheme.rawTheme.spacing;
  },

  getStyles: function getStyles() {
    var styles = {
      root: {
        color: this.getTheme().textColor,
        backgroundColor: this.getTheme().backgroundColor,
        borderRadius: 2,
        padding: '0px ' + this.getSpacing().desktopGutter + 'px',
        height: this.getSpacing().desktopSubheaderHeight,
        lineHeight: this.getSpacing().desktopSubheaderHeight + 'px',
        minWidth: 288,
        maxWidth: 568,

        position: 'fixed',
        zIndex: 10,
        bottom: this.getSpacing().desktopGutter,
        marginLeft: this.getSpacing().desktopGutter,

        left: 0,
        opacity: 0,
        visibility: 'hidden',
        transform: 'translate3d(0, 20px, 0)',
        transition: Transitions.easeOut('0ms', 'left', '400ms') + ',' + Transitions.easeOut('400ms', 'opacity') + ',' + Transitions.easeOut('400ms', 'transform') + ',' + Transitions.easeOut('400ms', 'visibility')
      },
      action: {
        color: this.getTheme().actionColor,
        float: 'right',
        marginTop: 6,
        marginRight: -16,
        marginLeft: this.getSpacing().desktopGutter,
        backgroundColor: 'transparent'
      },
      rootWhenOpen: {
        opacity: 1,
        visibility: 'visible',
        transform: 'translate3d(0, 0, 0)',
        transition: Transitions.easeOut('0ms', 'left', '0ms') + ',' + Transitions.easeOut('400ms', 'opacity', '0ms') + ',' + Transitions.easeOut('400ms', 'transform', '0ms') + ',' + Transitions.easeOut('400ms', 'visibility', '0ms')
      }
    };

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var action = _props.action;
    var message = _props.message;
    var onActionTouchTap = _props.onActionTouchTap;
    var style = _props.style;

    var others = _objectWithoutProperties(_props, ['action', 'message', 'onActionTouchTap', 'style']);

    var styles = this.getStyles();

    var rootStyles = this.state.open ? this.prepareStyles(styles.root, styles.rootWhenOpen, style) : this.prepareStyles(styles.root, style);

    var actionButton = undefined;
    if (action) {
      actionButton = React.createElement(FlatButton, {
        style: styles.action,
        label: action,
        onTouchTap: onActionTouchTap });
    }

    return React.createElement(
      'span',
      _extends({}, others, { style: rootStyles }),
      React.createElement(
        'span',
        null,
        message
      ),
      actionButton
    );
  },

  show: function show() {
    this.setState({ open: true });
    if (this.props.onShow) this.props.onShow();
  },

  dismiss: function dismiss() {
    this._clearAutoHideTimer();
    this.setState({ open: false });
    if (this.props.onDismiss) this.props.onDismiss();
  },

  _clearAutoHideTimer: function _clearAutoHideTimer() {
    if (this._autoHideTimerId !== undefined) {
      this._autoHideTimerId = clearTimeout(this._autoHideTimerId);
    }
  },

  _setAutoHideTimer: function _setAutoHideTimer() {
    var _this2 = this;

    if (this.props.autoHideDuration > 0) {
      this._clearAutoHideTimer();
      this._autoHideTimerId = setTimeout(function () {
        _this2.dismiss();
      }, this.props.autoHideDuration);
    }
  }

});

module.exports = Snackbar;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Tab = React.createClass({
  displayName: 'Tab',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    onTouchTap: React.PropTypes.func,
    label: React.PropTypes.node,
    onActive: React.PropTypes.func,
    selected: React.PropTypes.bool,
    width: React.PropTypes.string,
    value: React.PropTypes.string
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onActive: function onActive() {},
      onTouchTap: function onTouchTap() {}
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _props = this.props;
    var label = _props.label;
    var onActive = _props.onActive;
    var onTouchTap = _props.onTouchTap;
    var selected = _props.selected;
    var style = _props.style;
    var value = _props.value;
    var width = _props.width;

    var other = _objectWithoutProperties(_props, ['label', 'onActive', 'onTouchTap', 'selected', 'style', 'value', 'width']);

    var styles = this.prepareStyles({
      display: 'table-cell',
      cursor: 'pointer',
      textAlign: 'center',
      verticalAlign: 'middle',
      height: 48,
      color: selected ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.6)',
      outline: 'none',
      fontSize: 14,
      fontWeight: 500,
      whiteSpace: 'initial',
      fontFamily: this.state.muiTheme.rawTheme.fontFamily,
      boxSizing: 'border-box',
      width: width
    }, style);

    return React.createElement(
      'div',
      _extends({}, other, {
        style: styles,
        onTouchTap: this._handleTouchTap }),
      label
    );
  },

  _handleTouchTap: function _handleTouchTap(e) {
    this.props.onTouchTap(this.props.value, e, this);
  }

});

module.exports = Tab;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var TabTemplate = __webpack_require__(1064);
var InkBar = __webpack_require__(1065);
var StylePropable = __webpack_require__(10);
var Controllable = __webpack_require__(535);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Tabs = React.createClass({
  displayName: 'Tabs',

  mixins: [StylePropable, Controllable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    contentContainerStyle: React.PropTypes.object,
    initialSelectedIndex: React.PropTypes.number,
    inkBarStyle: React.PropTypes.object,
    tabItemContainerStyle: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      initialSelectedIndex: 0
    };
  },

  getInitialState: function getInitialState() {
    var valueLink = this.getValueLink(this.props);
    var initialIndex = this.props.initialSelectedIndex;

    return {
      selectedIndex: valueLink.value ? this._getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0,
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  getEvenWidth: function getEvenWidth() {
    return parseInt(window.getComputedStyle(ReactDOM.findDOMNode(this)).getPropertyValue('width'), 10);
  },

  getTabCount: function getTabCount() {
    return React.Children.count(this.props.children);
  },

  componentWillReceiveProps: function componentWillReceiveProps(newProps, nextContext) {
    var valueLink = this.getValueLink(newProps);
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;

    if (valueLink.value) {
      this.setState({ selectedIndex: this._getSelectedIndex(newProps) });
    }

    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _this = this;

    var _props = this.props;
    var children = _props.children;
    var contentContainerStyle = _props.contentContainerStyle;
    var initialSelectedIndex = _props.initialSelectedIndex;
    var inkBarStyle = _props.inkBarStyle;
    var style = _props.style;
    var tabWidth = _props.tabWidth;
    var tabItemContainerStyle = _props.tabItemContainerStyle;

    var other = _objectWithoutProperties(_props, ['children', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'style', 'tabWidth', 'tabItemContainerStyle']);

    var themeVariables = this.state.muiTheme.tabs;
    var styles = {
      tabItemContainer: {
        margin: 0,
        padding: 0,
        width: '100%',
        height: 48,
        backgroundColor: themeVariables.backgroundColor,
        whiteSpace: 'nowrap',
        display: 'table'
      }
    };

    var valueLink = this.getValueLink(this.props);
    var tabValue = valueLink.value;
    var tabContent = [];

    var width = 100 / this.getTabCount() + '%';

    var left = 'calc(' + width + '*' + this.state.selectedIndex + ')';

    var tabs = React.Children.map(children, function (tab, index) {
      if (tab.type.displayName === "Tab") {
        if (!tab.props.value && tabValue && "production" !== 'production') {
          console.error('Tabs value prop has been passed, but Tab ' + index + ' does not have a value prop. Needs value if Tabs is going' + ' to be a controlled component.');
        }

        tabContent.push(tab.props.children ? React.createElement(TabTemplate, {
          key: index,
          selected: _this._getSelected(tab, index)
        }, tab.props.children) : undefined);

        return React.cloneElement(tab, {
          key: index,
          selected: _this._getSelected(tab, index),
          tabIndex: index,
          width: width,
          onTouchTap: _this._handleTabTouchTap
        });
      } else {
        var type = tab.type.displayName || tab.type;
        console.error('Tabs only accepts Tab Components as children. Found ' + type + ' as child number ' + (index + 1) + ' of Tabs');
      }
    }, this);

    var inkBar = this.state.selectedIndex !== -1 ? React.createElement(InkBar, {
      left: left,
      width: width,
      style: inkBarStyle }) : null;

    var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';

    return React.createElement(
      'div',
      _extends({}, other, {
        style: this.prepareStyles(style) }),
      React.createElement(
        'div',
        { style: this.prepareStyles(styles.tabItemContainer, tabItemContainerStyle) },
        tabs
      ),
      React.createElement(
        'div',
        { style: { width: inkBarContainerWidth } },
        inkBar
      ),
      React.createElement(
        'div',
        { style: this.prepareStyles(contentContainerStyle) },
        tabContent
      )
    );
  },

  _getSelectedIndex: function _getSelectedIndex(props) {
    var valueLink = this.getValueLink(props);
    var selectedIndex = -1;

    React.Children.forEach(props.children, function (tab, index) {
      if (valueLink.value === tab.props.value) {
        selectedIndex = index;
      }
    });

    return selectedIndex;
  },

  _handleTabTouchTap: function _handleTabTouchTap(value, e, tab) {
    var valueLink = this.getValueLink(this.props);
    var tabIndex = tab.props.tabIndex;

    if (valueLink.value && valueLink.value !== value || this.state.selectedIndex !== tabIndex) {
      valueLink.requestChange(value, e, tab);
    }

    this.setState({ selectedIndex: tabIndex });
    tab.props.onActive(tab);
  },

  _getSelected: function _getSelected(tab, index) {
    var valueLink = this.getValueLink(this.props);
    return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
  }

});

module.exports = Tabs;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

var TabTemplate = React.createClass({
  displayName: 'TabTemplate',

  render: function render() {
    var styles = {
      'height': 0,
      'overflow': 'hidden',
      'width': '100%',
      'position': 'relative',
      'textAlign': 'initial'
    };

    if (this.props.selected) {
      delete styles.height;
      delete styles.overflow;
    }

    return React.createElement(
      'div',
      { style: styles },
      this.props.children
    );
  }
});

module.exports = TabTemplate;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var Transitions = __webpack_require__(21);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var InkBar = React.createClass({
  displayName: 'InkBar',

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    color: React.PropTypes.string,
    left: React.PropTypes.string.isRequired,
    width: React.PropTypes.string.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  mixins: [StylePropable],

  render: function render() {
    var _props = this.props;
    var color = _props.color;
    var left = _props.left;
    var width = _props.width;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['color', 'left', 'width', 'style']);

    var colorStyle = color ? { backgroundColor: color } : undefined;
    var styles = this.prepareStyles({
      left: left,
      width: width,
      bottom: 0,
      display: 'block',
      backgroundColor: this.state.muiTheme.inkBar.backgroundColor,
      height: 2,
      marginTop: -2,
      position: 'relative',
      transition: Transitions.easeOut('1s', 'left')
    }, this.props.style, colorStyle);

    return React.createElement(
      'div',
      { style: styles },
      ' '
    );
  }

});

module.exports = InkBar;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var Table = React.createClass({
  displayName: 'Table',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    allRowsSelected: React.PropTypes.bool,
    fixedFooter: React.PropTypes.bool,
    fixedHeader: React.PropTypes.bool,
    height: React.PropTypes.string,
    multiSelectable: React.PropTypes.bool,
    onCellClick: React.PropTypes.func,
    onCellHover: React.PropTypes.func,
    onCellHoverExit: React.PropTypes.func,
    onRowHover: React.PropTypes.func,
    onRowHoverExit: React.PropTypes.func,
    onRowSelection: React.PropTypes.func,
    selectable: React.PropTypes.bool,
    style: React.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      allRowsSelected: false,
      fixedFooter: true,
      fixedHeader: true,
      height: 'inherit',
      multiSelectable: false,
      selectable: true
    };
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme),
      allRowsSelected: this.props.allRowsSelected
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.table;
  },

  getStyles: function getStyles() {
    var styles = {
      root: {
        backgroundColor: this.getTheme().backgroundColor,
        padding: '0 ' + this.state.muiTheme.rawTheme.spacing.desktopGutter + 'px',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        tableLayout: 'fixed'
      },
      bodyTable: {
        height: this.props.fixedHeader || this.props.fixedFooter ? this.props.height : 'auto',
        overflowX: 'hidden',
        overflowY: 'auto'
      },
      tableWrapper: {
        height: this.props.fixedHeader || this.props.fixedFooter ? 'auto' : this.props.height,
        overflow: 'auto'
      }
    };

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var children = _props.children;
    var className = _props.className;
    var fixedFooter = _props.fixedFooter;
    var fixedHeader = _props.fixedHeader;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['children', 'className', 'fixedFooter', 'fixedHeader', 'style']);

    var classes = 'mui-table';
    if (className) classes += ' ' + className;
    var styles = this.getStyles();

    var tHead = undefined,
        tFoot = undefined,
        tBody = undefined;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;

        if (!React.isValidElement(child)) continue;

        var displayName = child.type.displayName;
        if (displayName === 'TableBody') {
          tBody = this._createTableBody(child);
        } else if (displayName === 'TableHeader') {
          tHead = this._createTableHeader(child);
        } else if (displayName === 'TableFooter') {
          tFoot = this._createTableFooter(child);
        }
      }

      // If we could not find a table-header and a table-body, do not attempt to display anything.
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (!tBody && !tHead) return null;

    var mergedTableStyle = this.prepareStyles(styles.root, style);
    var headerTable = undefined,
        footerTable = undefined;
    var inlineHeader = undefined,
        inlineFooter = undefined;
    if (fixedHeader) {
      headerTable = React.createElement(
        'div',
        { className: 'mui-header-table' },
        React.createElement(
          'table',
          { className: className, style: mergedTableStyle },
          tHead
        )
      );
    } else {
      inlineHeader = tHead;
    }
    if (tFoot !== undefined) {
      if (fixedFooter) {
        footerTable = React.createElement(
          'div',
          { className: 'mui-footer-table' },
          React.createElement(
            'table',
            { className: className, style: mergedTableStyle },
            tFoot
          )
        );
      } else {
        inlineFooter = tFoot;
      }
    }

    return React.createElement(
      'div',
      { className: 'mui-table-wrapper', style: this.prepareStyles(styles.tableWrapper) },
      headerTable,
      React.createElement(
        'div',
        { className: 'mui-body-table', style: this.prepareStyles(styles.bodyTable), ref: 'tableDiv' },
        React.createElement(
          'table',
          { className: classes, style: mergedTableStyle, ref: 'tableBody' },
          inlineHeader,
          inlineFooter,
          tBody
        )
      ),
      footerTable
    );
  },

  isScrollbarVisible: function isScrollbarVisible() {
    var tableDivHeight = ReactDOM.findDOMNode(this.refs.tableDiv).clientHeight;
    var tableBodyHeight = ReactDOM.findDOMNode(this.refs.tableBody).clientHeight;

    return tableBodyHeight > tableDivHeight;
  },

  _createTableHeader: function _createTableHeader(base) {
    return React.cloneElement(base, {
      enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
      onSelectAll: this._onSelectAll,
      selectAllSelected: this.state.allRowsSelected
    });
  },

  _createTableBody: function _createTableBody(base) {
    return React.cloneElement(base, {
      allRowsSelected: this.state.allRowsSelected,
      multiSelectable: this.props.multiSelectable,
      onCellClick: this._onCellClick,
      onCellHover: this._onCellHover,
      onCellHoverExit: this._onCellHoverExit,
      onRowHover: this._onRowHover,
      onRowHoverExit: this._onRowHoverExit,
      onRowSelection: this._onRowSelection,
      selectable: this.props.selectable,
      style: this.mergeAndPrefix({ height: this.props.height }, base.props.style)
    });
  },

  _createTableFooter: function _createTableFooter(base) {
    return base;
  },

  _onCellClick: function _onCellClick(rowNumber, columnNumber) {
    if (this.props.onCellClick) this.props.onCellClick(rowNumber, columnNumber);
  },

  _onCellHover: function _onCellHover(rowNumber, columnNumber) {
    if (this.props.onCellHover) this.props.onCellHover(rowNumber, columnNumber);
  },

  _onCellHoverExit: function _onCellHoverExit(rowNumber, columnNumber) {
    if (this.props.onCellHoverExit) this.props.onCellHoverExit(rowNumber, columnNumber);
  },

  _onRowHover: function _onRowHover(rowNumber) {
    if (this.props.onRowHover) this.props.onRowHover(rowNumber);
  },

  _onRowHoverExit: function _onRowHoverExit(rowNumber) {
    if (this.props.onRowHoverExit) this.props.onRowHoverExit(rowNumber);
  },

  _onRowSelection: function _onRowSelection(selectedRows) {
    if (this.state.allRowsSelected) this.setState({ allRowsSelected: false });
    if (this.props.onRowSelection) this.props.onRowSelection(selectedRows);
  },

  _onSelectAll: function _onSelectAll() {
    if (this.props.onRowSelection && !this.state.allRowsSelected) this.props.onRowSelection('all');
    this.setState({ allRowsSelected: !this.state.allRowsSelected });
  }

});

module.exports = Table;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var Checkbox = __webpack_require__(355);
var TableRowColumn = __webpack_require__(365);
var ClickAwayable = __webpack_require__(163);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var TableBody = React.createClass({
  displayName: 'TableBody',

  mixins: [ClickAwayable, StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  propTypes: {
    allRowsSelected: React.PropTypes.bool,
    deselectOnClickaway: React.PropTypes.bool,
    displayRowCheckbox: React.PropTypes.bool,
    multiSelectable: React.PropTypes.bool,
    onCellClick: React.PropTypes.func,
    onCellHover: React.PropTypes.func,
    onCellHoverExit: React.PropTypes.func,
    onRowHover: React.PropTypes.func,
    onRowHoverExit: React.PropTypes.func,
    onRowSelection: React.PropTypes.func,
    preScanRows: React.PropTypes.bool,
    selectable: React.PropTypes.bool,
    showRowHover: React.PropTypes.bool,
    stripedRows: React.PropTypes.bool,
    style: React.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      allRowsSelected: false,
      deselectOnClickaway: true,
      displayRowCheckbox: true,
      multiSelectable: false,
      preScanRows: true,
      selectable: true,
      style: {}
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme),
      selectedRows: this._calculatePreselectedRows(this.props)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });

    var newState = {};

    if (this.props.allRowsSelected && !nextProps.allRowsSelected) {
      var lastSelectedRow = this.state.selectedRows.length ? this.state.selectedRows[this.state.selectedRows.length - 1] : undefined;

      newState.selectedRows = [lastSelectedRow];
    } else {
      newState.selectedRows = this._calculatePreselectedRows(nextProps);
    }

    this.setState(newState);
  },

  componentClickAway: function componentClickAway() {
    if (this.props.deselectOnClickaway && this.state.selectedRows.length) {
      this.setState({ selectedRows: [] });
    }
  },

  render: function render() {
    var _props = this.props;
    var className = _props.className;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['className', 'style']);

    var classes = 'mui-table-body';
    if (className) classes += ' ' + className;

    var rows = this._createRows();

    return React.createElement(
      'tbody',
      { className: classes, style: this.prepareStyles(style) },
      rows
    );
  },

  _createRows: function _createRows() {
    var _this = this;

    var numChildren = React.Children.count(this.props.children);
    var rowNumber = 0;
    var handlers = {
      onCellClick: this._onCellClick,
      onCellHover: this._onCellHover,
      onCellHoverExit: this._onCellHoverExit,
      onRowHover: this._onRowHover,
      onRowHoverExit: this._onRowHoverExit,
      onRowClick: this._onRowClick
    };

    return React.Children.map(this.props.children, function (child) {
      if (React.isValidElement(child)) {
        var _ret = (function () {
          var props = {
            displayRowCheckbox: _this.props.displayRowCheckbox,
            hoverable: _this.props.showRowHover,
            selected: _this._isRowSelected(rowNumber),
            striped: _this.props.stripedRows && rowNumber % 2 === 0,
            rowNumber: rowNumber++
          };
          var checkboxColumn = _this._createRowCheckboxColumn(props);

          if (rowNumber === numChildren) {
            props.displayBorder = false;
          }

          var children = [checkboxColumn];
          React.Children.forEach(child.props.children, function (child) {
            children.push(child);
          });

          return {
            v: React.cloneElement(child, _extends({}, props, handlers), children)
          };
        })();

        if (typeof _ret === 'object') return _ret.v;
      }
    });
  },

  _createRowCheckboxColumn: function _createRowCheckboxColumn(rowProps) {
    if (!this.props.displayRowCheckbox) return null;

    var key = rowProps.rowNumber + '-cb';
    var checkbox = React.createElement(Checkbox, {
      ref: 'rowSelectCB',
      name: key,
      value: 'selected',
      disabled: !this.props.selectable,
      checked: rowProps.selected });

    return React.createElement(
      TableRowColumn,
      {
        key: key,
        columnNumber: 0,
        style: { width: 24 } },
      checkbox
    );
  },

  _calculatePreselectedRows: function _calculatePreselectedRows(props) {
    // Determine what rows are 'pre-selected'.
    var preSelectedRows = [];

    if (props.selectable && props.preScanRows) {
      (function () {
        var index = 0;
        React.Children.forEach(props.children, function (child) {
          if (React.isValidElement(child)) {
            if (child.props.selected && (preSelectedRows.length === 0 || props.multiSelectable)) {
              preSelectedRows.push(index);
            }

            index++;
          }
        });
      })();
    }

    return preSelectedRows;
  },

  _isRowSelected: function _isRowSelected(rowNumber) {
    if (this.props.allRowsSelected) {
      return true;
    }

    for (var i = 0; i < this.state.selectedRows.length; i++) {
      var selection = this.state.selectedRows[i];

      if (typeof selection === 'object') {
        if (this._isValueInRange(rowNumber, selection)) return true;
      } else {
        if (selection === rowNumber) return true;
      }
    }

    return false;
  },

  _isValueInRange: function _isValueInRange(value, range) {
    if (!range) return false;

    if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
      return true;
    }

    return false;
  },

  _onRowClick: function _onRowClick(e, rowNumber) {
    e.stopPropagation();

    if (this.props.selectable) {
      // Prevent text selection while selecting rows.
      window.getSelection().removeAllRanges();
      this._processRowSelection(e, rowNumber);
    }
  },

  _processRowSelection: function _processRowSelection(e, rowNumber) {
    var selectedRows = this.state.selectedRows;

    if (e.shiftKey && this.props.multiSelectable && selectedRows.length) {
      var lastIndex = selectedRows.length - 1;
      var lastSelection = selectedRows[lastIndex];

      if (typeof lastSelection === 'object') {
        lastSelection.end = rowNumber;
      } else {
        selectedRows.splice(lastIndex, 1, { start: lastSelection, end: rowNumber });
      }
    } else if ((e.ctrlKey && !e.metaKey || e.metaKey && !e.ctrlKey) && this.props.multiSelectable) {
      var idx = selectedRows.indexOf(rowNumber);
      if (idx < 0) {
        var foundRange = false;
        for (var i = 0; i < selectedRows.length; i++) {
          var range = selectedRows[i];
          if (typeof range !== 'object') continue;

          if (this._isValueInRange(rowNumber, range)) {
            var _selectedRows;

            foundRange = true;
            var values = this._splitRange(range, rowNumber);
            (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat(_toConsumableArray(values)));
          }
        }

        if (!foundRange) selectedRows.push(rowNumber);
      } else {
        selectedRows.splice(idx, 1);
      }
    } else {
      if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
        selectedRows = [];
      } else {
        selectedRows = [rowNumber];
      }
    }

    this.setState({ selectedRows: selectedRows });
    if (this.props.onRowSelection) this.props.onRowSelection(this._flattenRanges(selectedRows));
  },

  _splitRange: function _splitRange(range, splitPoint) {
    var splitValues = [];
    var startOffset = range.start - splitPoint;
    var endOffset = range.end - splitPoint;

    // Process start half
    splitValues.push.apply(splitValues, _toConsumableArray(this._genRangeOfValues(splitPoint, startOffset)));

    // Process end half
    splitValues.push.apply(splitValues, _toConsumableArray(this._genRangeOfValues(splitPoint, endOffset)));

    return splitValues;
  },

  _genRangeOfValues: function _genRangeOfValues(start, offset) {
    var values = [];
    var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
    while (offset !== 0) {
      values.push(start + offset);
      offset += dir;
    }

    return values;
  },

  _flattenRanges: function _flattenRanges(selectedRows) {
    var rows = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = selectedRows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var selection = _step.value;

        if (typeof selection === 'object') {
          var values = this._genRangeOfValues(selection.end, selection.start - selection.end);
          rows.push.apply(rows, [selection.end].concat(_toConsumableArray(values)));
        } else {
          rows.push(selection);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return rows.sort();
  },

  _onCellClick: function _onCellClick(e, rowNumber, columnNumber) {
    e.stopPropagation();
    if (this.props.onCellClick) this.props.onCellClick(rowNumber, this._getColumnId(columnNumber));
  },

  _onCellHover: function _onCellHover(e, rowNumber, columnNumber) {
    if (this.props.onCellHover) this.props.onCellHover(rowNumber, this._getColumnId(columnNumber));
    this._onRowHover(e, rowNumber);
  },

  _onCellHoverExit: function _onCellHoverExit(e, rowNumber, columnNumber) {
    if (this.props.onCellHoverExit) this.props.onCellHoverExit(rowNumber, this._getColumnId(columnNumber));
    this._onRowHoverExit(e, rowNumber);
  },

  _onRowHover: function _onRowHover(e, rowNumber) {
    if (this.props.onRowHover) this.props.onRowHover(rowNumber);
  },

  _onRowHoverExit: function _onRowHoverExit(e, rowNumber) {
    if (this.props.onRowHoverExit) this.props.onRowHoverExit(rowNumber);
  },

  _getColumnId: function _getColumnId(columnNumber) {
    var columnId = columnNumber;
    if (this.props.displayRowCheckbox) columnId--;

    return columnId;
  }

});

module.exports = TableBody;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var TableRowColumn = __webpack_require__(365);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var TableFooter = React.createClass({
  displayName: 'TableFooter',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    adjustForCheckbox: React.PropTypes.bool,
    style: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getDefaultProps: function getDefaultProps() {
    return {
      adjustForCheckbox: true,
      style: {}
    };
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.tableFooter;
  },

  getStyles: function getStyles() {
    var styles = {
      cell: {
        borderTop: '1px solid ' + this.getTheme().borderColor,
        verticalAlign: 'bottom',
        padding: 20,
        textAlign: 'left',
        whiteSpace: 'nowrap'
      }
    };

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var className = _props.className;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['className', 'style']);

    var classes = 'mui-table-footer';
    if (className) classes += ' ' + className;

    var footerRows = this._createRows();

    return React.createElement(
      'tfoot',
      _extends({ className: classes, style: this.prepareStyles(style) }, other),
      footerRows
    );
  },

  _createRows: function _createRows() {
    var _this = this;

    var rowNumber = 0;
    return React.Children.map(this.props.children, function (child) {
      return _this._createRow(child, rowNumber++);
    });
  },

  _createRow: function _createRow(child, rowNumber) {
    var styles = this.getStyles();
    var props = {
      className: 'mui-table-footer-row',
      displayBorder: false,
      key: 'f-' + rowNumber,
      rowNumber: rowNumber,
      style: this.mergeAndPrefix(styles.cell, child.props.style)
    };

    var children = [this._getCheckboxPlaceholder(props)];
    React.Children.forEach(child.props.children, function (child) {
      children.push(child);
    });

    return React.cloneElement(child, props, children);
  },

  _getCheckboxPlaceholder: function _getCheckboxPlaceholder(props) {
    if (!this.props.adjustForCheckbox) return null;

    var key = 'fpcb' + props.rowNumber;
    return React.createElement(TableRowColumn, { key: key, style: { width: 24 } });
  }

});

module.exports = TableFooter;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var Checkbox = __webpack_require__(355);
var StylePropable = __webpack_require__(10);
var TableHeaderColumn = __webpack_require__(541);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var TableHeader = React.createClass({
  displayName: 'TableHeader',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    adjustForCheckbox: React.PropTypes.bool,
    displaySelectAll: React.PropTypes.bool,
    enableSelectAll: React.PropTypes.bool,
    onSelectAll: React.PropTypes.func,
    selectAllSelected: React.PropTypes.bool,
    style: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getDefaultProps: function getDefaultProps() {
    return {
      adjustForCheckbox: true,
      displaySelectAll: true,
      enableSelectAll: true,
      selectAllSelected: false
    };
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.tableHeader;
  },

  getStyles: function getStyles() {
    var styles = {
      root: {
        borderBottom: '1px solid ' + this.getTheme().borderColor
      }
    };

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var className = _props.className;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['className', 'style']);

    var classes = 'mui-table-header';
    if (className) classes += ' ' + className;

    var superHeaderRows = this._createSuperHeaderRows();
    var baseHeaderRow = this._createBaseHeaderRow();

    return React.createElement(
      'thead',
      { className: classes, style: this.prepareStyles(this.getStyles().root, style) },
      superHeaderRows,
      baseHeaderRow
    );
  },

  _createSuperHeaderRows: function _createSuperHeaderRows() {
    var numChildren = React.Children.count(this.props.children);
    if (numChildren === 1) return undefined;

    var superHeaders = [];
    for (var index = 0; index < numChildren - 1; index++) {
      var child = this.props.children[index];

      if (!React.isValidElement(child)) continue;

      var props = {
        className: 'mui-table-super-header-row',
        displayRowCheckbox: false,
        key: 'sh' + index,
        rowNumber: index
      };
      superHeaders.push(this._createSuperHeaderRow(child, props));
    }

    if (superHeaders.length) return superHeaders;
  },

  _createSuperHeaderRow: function _createSuperHeaderRow(child, props) {
    var children = [];
    if (this.props.adjustForCheckbox) {
      children.push(this._getCheckboxPlaceholder(props));
    }
    React.Children.forEach(child.props.children, function (child) {
      children.push(child);
    });

    return React.cloneElement(child, props, children);
  },

  _createBaseHeaderRow: function _createBaseHeaderRow() {
    var numChildren = React.Children.count(this.props.children);
    var child = numChildren === 1 ? this.props.children : this.props.children[numChildren - 1];
    var props = {
      className: 'mui-table-header-row',
      key: 'h' + numChildren,
      rowNumber: numChildren
    };

    var children = [this._getSelectAllCheckboxColumn(props)];
    React.Children.forEach(child.props.children, function (child) {
      children.push(child);
    });

    return React.cloneElement(child, props, children);
  },

  _getCheckboxPlaceholder: function _getCheckboxPlaceholder(props) {
    if (!this.props.adjustForCheckbox) return null;

    var key = 'hpcb' + props.rowNumber;
    return React.createElement(TableHeaderColumn, { key: key, style: { width: 24 } });
  },

  _getSelectAllCheckboxColumn: function _getSelectAllCheckboxColumn(props) {
    if (!this.props.displaySelectAll) return this._getCheckboxPlaceholder(props);

    var checkbox = React.createElement(Checkbox, {
      key: 'selectallcb',
      name: 'selectallcb',
      value: 'selected',
      disabled: !this.props.enableSelectAll,
      checked: this.props.selectAllSelected,
      onCheck: this._onSelectAll });

    return React.createElement(
      TableHeaderColumn,
      { style: { width: 24 } },
      checkbox
    );
  },

  _onSelectAll: function _onSelectAll(e, checked) {
    if (this.props.onSelectAll) this.props.onSelectAll(checked);
  }

});

module.exports = TableHeader;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var TableRow = React.createClass({
  displayName: 'TableRow',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    displayBorder: React.PropTypes.bool,
    hoverable: React.PropTypes.bool,
    onCellClick: React.PropTypes.func,
    onCellHover: React.PropTypes.func,
    onCellHoverExit: React.PropTypes.func,
    onRowClick: React.PropTypes.func,
    onRowHover: React.PropTypes.func,
    onRowHoverExit: React.PropTypes.func,
    rowNumber: React.PropTypes.number,
    selectable: React.PropTypes.bool,
    selected: React.PropTypes.bool,
    striped: React.PropTypes.bool,
    style: React.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      displayBorder: true,
      displayRowCheckbox: true,
      hoverable: false,
      selectable: true,
      selected: false,
      striped: false
    };
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme),
      hovered: false
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.tableRow;
  },

  getStyles: function getStyles() {
    var theme = this.getTheme();
    var cellBgColor = 'inherit';
    if (this.state.hovered) {
      cellBgColor = theme.hoverColor;
    } else if (this.props.selected) {
      cellBgColor = theme.selectedColor;
    } else if (this.props.striped) {
      cellBgColor = theme.stripeColor;
    }

    var styles = {
      root: {
        borderBottom: '1px solid ' + this.getTheme().borderColor,
        color: this.getTheme().textColor
      },
      cell: {
        backgroundColor: cellBgColor
      }
    };

    if (!this.props.displayBorder) {
      styles.root.borderBottom = '';
    }

    return styles;
  },

  render: function render() {
    var _props = this.props;
    var className = _props.className;
    var displayBorder = _props.displayBorder;
    var hoverable = _props.hoverable;
    var onCellClick = _props.onCellClick;
    var onCellHover = _props.onCellHover;
    var onCellHoverExit = _props.onCellHoverExit;
    var onRowClick = _props.onRowClick;
    var onRowHover = _props.onRowHover;
    var onRowHoverExit = _props.onRowHoverExit;
    var rowNumber = _props.rowNumber;
    var selectable = _props.selectable;
    var selected = _props.selected;
    var striped = _props.striped;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['className', 'displayBorder', 'hoverable', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);

    var classes = 'mui-table-row';
    if (className) classes += ' ' + className;
    var rowColumns = this._createColumns();

    return React.createElement(
      'tr',
      _extends({
        className: classes,
        style: this.prepareStyles(this.getStyles().root, style)
      }, other),
      rowColumns
    );
  },

  _createColumns: function _createColumns() {
    var _this = this;

    var columnNumber = 1;
    return React.Children.map(this.props.children, function (child) {
      if (React.isValidElement(child)) {
        return _this._createColumn(child, columnNumber++);
      }
    });
  },

  _createColumn: function _createColumn(child, columnNumber) {
    var key = this.props.rowNumber + '-' + columnNumber;
    var styles = this.getStyles();
    var handlers = {
      onClick: this._onCellClick,
      onHover: this._onCellHover,
      onHoverExit: this._onCellHoverExit
    };

    return React.cloneElement(child, _extends({
      columnNumber: columnNumber,
      hoverable: this.props.hoverable,
      key: child.props.key || key,
      style: this.mergeAndPrefix(styles.cell, child.props.style)
    }, handlers));
  },

  _onRowClick: function _onRowClick(e) {
    if (this.props.onRowClick) this.props.onRowClick(e, this.props.rowNumber);
  },

  _onRowHover: function _onRowHover(e) {
    if (this.props.onRowHover) this.props.onRowHover(e, this.props.rowNumber);
  },

  _onRowHoverExit: function _onRowHoverExit(e) {
    if (this.props.onRowHoverExit) this.props.onRowHoverExit(e, this.props.rowNumber);
  },

  _onCellClick: function _onCellClick(e, columnIndex) {
    if (this.props.selectable && this.props.onCellClick) this.props.onCellClick(e, this.props.rowNumber, columnIndex);
    e.ctrlKey = true;
    this._onRowClick(e);
  },

  _onCellHover: function _onCellHover(e, columnIndex) {
    if (this.props.hoverable) {
      this.setState({ hovered: true });
      if (this.props.onCellHover) this.props.onCellHover(e, this.props.rowNumber, columnIndex);
      this._onRowHover(e);
    }
  },

  _onCellHoverExit: function _onCellHoverExit(e, columnIndex) {
    if (this.props.hoverable) {
      this.setState({ hovered: false });
      if (this.props.onCellHoverExit) this.props.onCellHoverExit(e, this.props.rowNumber, columnIndex);
      this._onRowHoverExit(e);
    }
  }

});

module.exports = TableRow;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);

module.exports = React.createClass({
	displayName: 'exports',

	propTypes: {
		theme: React.PropTypes.object.isRequired
	},

	childContextTypes: {
		muiTheme: React.PropTypes.object
	},

	getChildContext: function getChildContext() {
		return {
			muiTheme: this.props.theme
		};
	},

	render: function render() {
		return this.props.children();
	}
});

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1073);

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var WindowListenable = __webpack_require__(103);
var TimePickerDialog = __webpack_require__(1074);
var TextField = __webpack_require__(246);

var emptyTime = new Date();
emptyTime.setHours(0);
emptyTime.setMinutes(0);

var TimePicker = React.createClass({
  displayName: 'TimePicker',

  mixins: [StylePropable, WindowListenable],

  propTypes: {
    defaultTime: React.PropTypes.object,
    format: React.PropTypes.oneOf(['ampm', '24hr']),
    pedantic: React.PropTypes.bool,
    onFocus: React.PropTypes.func,
    onTouchTap: React.PropTypes.func,
    onChange: React.PropTypes.func,
    onShow: React.PropTypes.func,
    onDismiss: React.PropTypes.func
  },

  windowListeners: {
    'keyup': '_handleWindowKeyUp'
  },

  getDefaultProps: function getDefaultProps() {
    return {
      defaultTime: null,
      format: 'ampm',
      pedantic: false
    };
  },

  getInitialState: function getInitialState() {
    return {
      time: this.props.defaultTime || emptyTime,
      dialogTime: new Date()
    };
  },

  formatTime: function formatTime(date) {
    var hours = date.getHours();
    var mins = date.getMinutes().toString();

    if (this.props.format === "ampm") {
      var isAM = hours < 12;
      hours = hours % 12;
      var additional = isAM ? " am" : " pm";
      hours = (hours || 12).toString();

      if (mins.length < 2) mins = "0" + mins;

      if (this.props.pedantic) {
        // Treat midday/midnight specially http://www.nist.gov/pml/div688/times.cfm
        if (hours === "12" && mins === "00") {
          return additional === " pm" ? "12 noon" : "12 midnight";
        }
      }

      return hours + (mins === "00" ? "" : ":" + mins) + additional;
    }

    hours = hours.toString();

    if (hours.length < 2) hours = "0" + hours;
    if (mins.length < 2) mins = "0" + mins;

    return hours + ":" + mins;
  },

  render: function render() {
    var _props = this.props;
    var format = _props.format;
    var onFocus = _props.onFocus;
    var onTouchTap = _props.onTouchTap;
    var onShow = _props.onShow;
    var onDismiss = _props.onDismiss;

    var other = _objectWithoutProperties(_props, ['format', 'onFocus', 'onTouchTap', 'onShow', 'onDismiss']);

    var defaultInputValue = undefined;

    if (this.props.defaultTime) {
      defaultInputValue = this.formatTime(this.props.defaultTime);
    }

    return React.createElement(
      'div',
      null,
      React.createElement(TextField, _extends({}, other, {
        ref: 'input',
        defaultValue: defaultInputValue,
        onFocus: this._handleInputFocus,
        onTouchTap: this._handleInputTouchTap })),
      React.createElement(TimePickerDialog, {
        ref: 'dialogWindow',
        initialTime: this.state.dialogTime,
        onAccept: this._handleDialogAccept,
        onShow: onShow,
        onDismiss: onDismiss,
        format: format })
    );
  },

  getTime: function getTime() {
    return this.state.time;
  },

  setTime: function setTime(t) {
    this.setState({
      time: t
    });
    this.refs.input.setValue(this.formatTime(t));
  },

  _handleDialogAccept: function _handleDialogAccept(t) {
    this.setTime(t);
    if (this.props.onChange) this.props.onChange(null, t);
  },

  _handleInputFocus: function _handleInputFocus(e) {
    e.target.blur();
    if (this.props.onFocus) this.props.onFocus(e);
  },

  _handleInputTouchTap: function _handleInputTouchTap(e) {
    e.preventDefault();

    this.setState({
      dialogTime: this.getTime()
    });

    this.refs.dialogWindow.show();
    if (this.props.onTouchTap) this.props.onTouchTap(e);
  }
});

module.exports = TimePicker;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var WindowListenable = __webpack_require__(103);
var KeyCode = __webpack_require__(79);
var Clock = __webpack_require__(1075);
var Dialog = __webpack_require__(361);
var FlatButton = __webpack_require__(193);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var TimePickerDialog = React.createClass({
  displayName: 'TimePickerDialog',

  mixins: [StylePropable, WindowListenable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    initialTime: React.PropTypes.object,
    onAccept: React.PropTypes.func,
    onShow: React.PropTypes.func,
    onDismiss: React.PropTypes.func
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  windowListeners: {
    keyup: '_handleWindowKeyUp'
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.timePicker;
  },

  render: function render() {
    var _props = this.props;
    var initialTime = _props.initialTime;
    var onAccept = _props.onAccept;
    var format = _props.format;

    var other = _objectWithoutProperties(_props, ['initialTime', 'onAccept', 'format']);

    var styles = {
      root: {
        fontSize: 14,
        color: this.getTheme().clockColor
      },
      dialogContent: {
        width: 280
      },
      body: {
        padding: 0
      }
    };

    var actions = [React.createElement(FlatButton, {
      key: 0,
      label: 'Cancel',
      secondary: true,
      onTouchTap: this._handleCancelTouchTap }), React.createElement(FlatButton, {
      key: 1,
      label: 'OK',
      secondary: true,
      onTouchTap: this._handleOKTouchTap })];

    return React.createElement(
      Dialog,
      _extends({}, other, {
        ref: 'dialogWindow',
        style: this.mergeAndPrefix(styles.root),
        bodyStyle: this.mergeAndPrefix(styles.body),
        actions: actions,
        contentStyle: styles.dialogContent,
        onDismiss: this._handleDialogDismiss,
        onShow: this._handleDialogShow,
        repositionOnUpdate: false }),
      React.createElement(Clock, {
        ref: 'clock',
        format: format,
        initialTime: initialTime })
    );
  },

  show: function show() {
    this.refs.dialogWindow.show();
  },

  dismiss: function dismiss() {
    this.refs.dialogWindow.dismiss();
  },

  _handleCancelTouchTap: function _handleCancelTouchTap() {
    this.dismiss();
  },

  _handleOKTouchTap: function _handleOKTouchTap() {
    this.dismiss();
    if (this.props.onAccept) {
      this.props.onAccept(this.refs.clock.getSelectedTime());
    }
  },

  _handleDialogShow: function _handleDialogShow() {
    if (this.props.onShow) {
      this.props.onShow();
    }
  },

  _handleDialogDismiss: function _handleDialogDismiss() {
    if (this.props.onDismiss) {
      this.props.onDismiss();
    }
  },

  _handleWindowKeyUp: function _handleWindowKeyUp(e) {
    if (this.refs.dialogWindow.isOpen()) {
      switch (e.keyCode) {
        case KeyCode.ENTER:
          this._handleOKTouchTap();
          break;
      }
    }
  }

});

module.exports = TimePickerDialog;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var TimeDisplay = __webpack_require__(1076);
var ClockButton = __webpack_require__(1077);
var ClockHours = __webpack_require__(1078);
var ClockMinutes = __webpack_require__(1079);

var Clock = React.createClass({
  displayName: 'Clock',

  mixins: [StylePropable],

  propTypes: {
    initialTime: React.PropTypes.object,
    mode: React.PropTypes.oneOf(['hour', 'minute']),
    format: React.PropTypes.oneOf(['ampm', '24hr']),
    isActive: React.PropTypes.bool
  },

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      initialTime: new Date()
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState({
      selectedTime: nextProps.initialTime
    });
  },

  getInitialState: function getInitialState() {
    return {
      selectedTime: this.props.initialTime,
      mode: 'hour'
    };
  },

  _setMode: function _setMode(mode) {
    var _this = this;

    setTimeout(function () {
      _this.setState({
        mode: mode
      });
    }, 100);
  },

  _setAffix: function _setAffix(affix) {
    if (affix === this._getAffix()) return;

    var hours = this.state.selectedTime.getHours();

    if (affix === "am") {
      this.handleChangeHours(hours - 12, affix);
      return;
    }

    this.handleChangeHours(hours + 12, affix);
  },

  _getAffix: function _getAffix() {
    if (this.props.format !== "ampm") return "";

    var hours = this.state.selectedTime.getHours();
    if (hours < 12) {
      return "am";
    }

    return "pm";
  },

  _getButtons: function _getButtons() {
    var buttons = [];
    var isAM = this._getIsAM();

    if (this.props.format === 'ampm') {
      buttons = [React.createElement(
        ClockButton,
        { position: 'left', onTouchTap: this._setAffix.bind(this, "am"), selected: isAM },
        "AM"
      ), React.createElement(
        ClockButton,
        { position: 'right', onTouchTap: this._setAffix.bind(this, "pm"), selected: !isAM },
        "PM"
      )];
    }
    return buttons;
  },

  _getIsAM: function _getIsAM() {
    return this._getAffix() === "am";
  },

  render: function render() {
    var clock = null;
    var buttons = this._getButtons();

    var styles = {
      root: {},

      container: {
        height: 280,
        padding: 10
      }
    };

    if (this.state.mode === "hour") {
      clock = React.createElement(ClockHours, { key: 'hours',
        format: this.props.format,
        onChange: this.handleChangeHours,
        initialHours: this.state.selectedTime.getHours() });
    } else {
      clock = React.createElement(ClockMinutes, { key: 'minutes',
        onChange: this.handleChangeMinutes,
        initialMinutes: this.state.selectedTime.getMinutes() });
    }

    return React.createElement(
      'div',
      { style: this.prepareStyles(styles.root) },
      React.createElement(TimeDisplay, {
        selectedTime: this.state.selectedTime,
        mode: this.state.mode,
        format: this.props.format,
        affix: this._getAffix(),
        onSelectHour: this._setMode.bind(this, 'hour'),
        onSelectMin: this._setMode.bind(this, 'minute') }),
      React.createElement(
        'div',
        { style: this.prepareStyles(styles.container) },
        clock
      ),
      buttons
    );
  },

  handleChangeHours: function handleChangeHours(hours, finished) {
    var _this2 = this;

    var time = new Date(this.state.selectedTime);
    var affix = undefined;

    if (typeof finished === 'string') {
      affix = finished;
      finished = undefined;
    }
    if (!affix) {
      affix = this._getAffix();
    }
    if (affix === 'pm' && hours < 12) {
      hours += 12;
    }

    time.setHours(hours);
    this.setState({
      selectedTime: time
    });

    if (finished) {
      setTimeout(function () {
        _this2.setState({
          mode: 'minute'
        });
      }, 100);
    }
  },

  handleChangeMinutes: function handleChangeMinutes(minutes) {
    var time = new Date(this.state.selectedTime);
    time.setMinutes(minutes);
    this.setState({
      selectedTime: time
    });
  },

  getSelectedTime: function getSelectedTime() {
    return this.state.selectedTime;
  }
});

module.exports = Clock;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var TimeDisplay = React.createClass({
  displayName: 'TimeDisplay',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    selectedTime: React.PropTypes.object.isRequired,
    format: React.PropTypes.oneOf(['ampm', '24hr']),
    mode: React.PropTypes.oneOf(['hour', 'minute']),
    affix: React.PropTypes.oneOf(['', 'pm', 'am'])
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      transitionDirection: 'up',
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  getDefaultProps: function getDefaultProps() {
    return {
      mode: 'hour',
      affix: ''
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var direction = undefined;
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });

    if (nextProps.selectedTime !== this.props.selectedTime) {
      direction = nextProps.selectedTime > this.props.selectedTime ? 'up' : 'down';

      this.setState({
        transitionDirection: direction
      });
    }
  },

  sanitizeTime: function sanitizeTime() {
    var hour = this.props.selectedTime.getHours();
    var min = this.props.selectedTime.getMinutes().toString();

    if (this.props.format === "ampm") {
      hour %= 12;
      hour = hour || 12;
    }

    hour = hour.toString();
    if (hour.length < 2) hour = "0" + hour;
    if (min.length < 2) min = "0" + min;

    return [hour, min];
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.timePicker;
  },

  render: function render() {
    var _props = this.props;
    var selectedTime = _props.selectedTime;
    var mode = _props.mode;

    var other = _objectWithoutProperties(_props, ['selectedTime', 'mode']);

    var styles = {
      root: {
        textAlign: "center",
        position: "relative",
        width: 280,
        height: "100%"
      },

      time: {
        margin: "6px 0",
        lineHeight: "58px",
        height: 58,
        fontSize: "58px"
      },

      box: {
        padding: "16px 0",
        backgroundColor: this.getTheme().color,
        color: this.getTheme().textColor
      },

      hour: {},

      minute: {}
    };

    var _sanitizeTime = this.sanitizeTime();

    var _sanitizeTime2 = _slicedToArray(_sanitizeTime, 2);

    var hour = _sanitizeTime2[0];
    var min = _sanitizeTime2[1];

    styles[mode].color = this.getTheme().accentColor;

    return React.createElement(
      'div',
      _extends({}, other, { style: this.prepareStyles(styles.root) }),
      React.createElement(
        'div',
        { style: this.prepareStyles(styles.box) },
        React.createElement(
          'div',
          { style: this.prepareStyles(styles.time) },
          React.createElement(
            'span',
            { style: this.prepareStyles(styles.hour), onTouchTap: this.props.onSelectHour },
            hour
          ),
          React.createElement(
            'span',
            null,
            ':'
          ),
          React.createElement(
            'span',
            { style: this.prepareStyles(styles.minute), onTouchTap: this.props.onSelectMin },
            min
          )
        ),
        React.createElement(
          'span',
          { key: "affix" },
          this.props.affix.toUpperCase()
        )
      )
    );
  }

});

module.exports = TimeDisplay;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var EnhancedButton = __webpack_require__(102);
var Transitions = __webpack_require__(21);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var ClockButton = React.createClass({
  displayName: 'ClockButton',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    position: React.PropTypes.oneOf(['left', 'right'])
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getDefaultProps: function getDefaultProps() {
    return {
      position: "left"
    };
  },

  _handleTouchTap: function _handleTouchTap() {
    this.setState({
      selected: true
    });
    this.props.onTouchTap();
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.timePicker;
  },

  render: function render() {
    var _props = this.props;
    var className = _props.className;

    var other = _objectWithoutProperties(_props, ['className']);

    var styles = {
      root: {
        position: "absolute",
        bottom: 65,
        pointerEvents: "auto",
        height: 50,
        width: 50,
        borderRadius: "100%"
      },

      label: {
        position: "absolute",
        top: 17,
        left: 14
      },

      select: {
        position: 'absolute',
        height: 50,
        width: 50,
        top: 0,
        left: 0,
        opacity: 0,
        borderRadius: '50%',
        transform: 'scale(0)',
        transition: Transitions.easeOut(),
        backgroundColor: this.getTheme().accentColor
      }
    };

    if (this.props.selected) {
      styles.label.color = this.getTheme().selectTextColor;
      styles.select.opacity = 1;
      styles.select.transform = 'scale(1)';
    }

    if (this.props.position === "right") {
      styles.root.right = "5px";
    } else {
      styles.root.left = "5px";
    }

    return React.createElement(
      EnhancedButton,
      _extends({}, other, {
        style: this.mergeStyles(styles.root),
        disableFocusRipple: true,
        disableTouchRipple: true,
        onTouchTap: this._handleTouchTap }),
      React.createElement('span', { style: this.prepareStyles(styles.select) }),
      React.createElement(
        'span',
        { style: this.prepareStyles(styles.label) },
        this.props.children
      )
    );
  }
});

module.exports = ClockButton;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var ClockNumber = __webpack_require__(542);
var ClockPointer = __webpack_require__(543);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

function rad2deg(rad) {
  return rad * 57.29577951308232;
}

function getTouchEventOffsetValues(e) {
  var el = e.target;
  var boundingRect = el.getBoundingClientRect();

  var offset = {
    offsetX: e.clientX - boundingRect.left,
    offsetY: e.clientY - boundingRect.top
  };

  return offset;
}

var ClockHours = React.createClass({
  displayName: 'ClockHours',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  propTypes: {
    initialHours: React.PropTypes.number,
    onChange: React.PropTypes.func,
    format: React.PropTypes.oneOf(['ampm', '24hr'])
  },

  center: { x: 0, y: 0 },
  basePoint: { x: 0, y: 0 },

  isMousePressed: function isMousePressed(e) {
    if (typeof e.buttons === "undefined") {
      return e.nativeEvent.which;
    }

    return e.buttons;
  },

  getDefaultProps: function getDefaultProps() {
    return {
      initialHours: new Date().getHours(),
      onChange: function onChange() {},
      format: 'ampm'
    };
  },

  componentDidMount: function componentDidMount() {
    var clockElement = ReactDOM.findDOMNode(this.refs.mask);

    this.center = {
      x: clockElement.offsetWidth / 2,
      y: clockElement.offsetHeight / 2
    };

    this.basePoint = {
      x: this.center.x,
      y: 0
    };
  },

  handleUp: function handleUp(e) {
    e.preventDefault();
    this.setClock(e.nativeEvent, true);
  },

  handleMove: function handleMove(e) {
    e.preventDefault();
    if (this.isMousePressed(e) !== 1) return;
    this.setClock(e.nativeEvent, false);
  },

  handleTouchMove: function handleTouchMove(e) {
    e.preventDefault();
    this.setClock(e.changedTouches[0], false);
  },

  handleTouchEnd: function handleTouchEnd(e) {
    e.preventDefault();
    this.setClock(e.changedTouches[0], true);
  },

  setClock: function setClock(e, finish) {
    if (typeof e.offsetX === 'undefined') {
      var offset = getTouchEventOffsetValues(e);

      e.offsetX = offset.offsetX;
      e.offsetY = offset.offsetY;
    }

    var hours = this.getHours(e.offsetX, e.offsetY);

    this.props.onChange(hours, finish);
  },

  getHours: function getHours(offsetX, offsetY) {
    var step = 30;
    var x = offsetX - this.center.x;
    var y = offsetY - this.center.y;
    var cx = this.basePoint.x - this.center.x;
    var cy = this.basePoint.y - this.center.y;

    var atan = Math.atan2(cx, cy) - Math.atan2(x, y);

    var deg = rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;

    var value = Math.floor(deg / step) || 0;

    var delta = Math.pow(x, 2) + Math.pow(y, 2);
    var distance = Math.sqrt(delta);

    value = value || 12;
    if (this.props.format === "24hr") {
      if (distance < 90) {
        value += 12;
        value %= 24;
      }
    } else {
      value %= 12;
    }

    return value;
  },

  _getSelected: function _getSelected() {
    var hour = this.props.initialHours;

    if (this.props.format === "ampm") {
      hour %= 12;
      hour = hour || 12;
    }

    return hour;
  },

  _getHourNumbers: function _getHourNumbers() {
    var _this = this;

    var style = {
      pointerEvents: "none"
    };
    var hourSize = this.props.format === 'ampm' ? 12 : 24;

    var hours = [];
    for (var i = 1; i <= hourSize; i++) {
      hours.push(i % 24);
    }

    return hours.map(function (hour) {
      var isSelected = _this._getSelected() === hour;
      return React.createElement(ClockNumber, { key: hour, style: style, isSelected: isSelected, type: 'hour',
        value: hour });
    });
  },

  render: function render() {
    var styles = {
      root: {
        height: "100%",
        width: "100%",
        borderRadius: "100%",
        position: "relative",
        pointerEvents: "none",
        boxSizing: "border-box"
      },

      hitMask: {
        height: "100%",
        width: "100%",
        pointerEvents: "auto"
      }
    };

    var hours = this._getSelected();
    var numbers = this._getHourNumbers();

    return React.createElement(
      'div',
      { ref: 'clock', style: this.prepareStyles(styles.root) },
      React.createElement(ClockPointer, { hasSelected: true, value: hours, type: 'hour' }),
      numbers,
      React.createElement('div', { ref: 'mask', style: this.prepareStyles(styles.hitMask), onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd, onMouseUp: this.handleUp, onMouseMove: this.handleMove })
    );
  }
});

module.exports = ClockHours;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var StylePropable = __webpack_require__(10);
var ClockNumber = __webpack_require__(542);
var ClockPointer = __webpack_require__(543);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

function rad2deg(rad) {
  return rad * 57.29577951308232;
}

function getTouchEventOffsetValues(e) {
  var el = e.target;
  var boundingRect = el.getBoundingClientRect();

  var offset = {
    offsetX: e.clientX - boundingRect.left,
    offsetY: e.clientY - boundingRect.top
  };

  return offset;
}

var ClockMinutes = React.createClass({
  displayName: 'ClockMinutes',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    initialMinutes: React.PropTypes.number,
    onChange: React.PropTypes.func
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  center: { x: 0, y: 0 },
  basePoint: { x: 0, y: 0 },

  isMousePressed: function isMousePressed(e) {

    if (typeof e.buttons === "undefined") {
      return e.nativeEvent.which;
    }
    return e.buttons;
  },

  getDefaultProps: function getDefaultProps() {
    return {
      initialMinutes: new Date().getMinutes(),
      onChange: function onChange() {}
    };
  },

  componentDidMount: function componentDidMount() {
    var clockElement = ReactDOM.findDOMNode(this.refs.mask);

    this.center = {
      x: clockElement.offsetWidth / 2,
      y: clockElement.offsetHeight / 2
    };

    this.basePoint = {
      x: this.center.x,
      y: 0
    };
  },

  handleUp: function handleUp(e) {
    e.preventDefault();
    this.setClock(e.nativeEvent, true);
  },

  handleMove: function handleMove(e) {
    e.preventDefault();
    if (this.isMousePressed(e) !== 1) return;
    this.setClock(e.nativeEvent, false);
  },

  handleTouch: function handleTouch(e) {
    e.preventDefault();
    this.setClock(e.changedTouches[0], false);
  },

  setClock: function setClock(e, finish) {
    if (typeof e.offsetX === 'undefined') {
      var offset = getTouchEventOffsetValues(e);

      e.offsetX = offset.offsetX;
      e.offsetY = offset.offsetY;
    }

    var minutes = this.getMinutes(e.offsetX, e.offsetY);

    this.props.onChange(minutes, finish);
  },

  getMinutes: function getMinutes(offsetX, offsetY) {
    var step = 6;
    var x = offsetX - this.center.x;
    var y = offsetY - this.center.y;
    var cx = this.basePoint.x - this.center.x;
    var cy = this.basePoint.y - this.center.y;

    var atan = Math.atan2(cx, cy) - Math.atan2(x, y);

    var deg = rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;

    var value = Math.floor(deg / step) || 0;

    return value;
  },

  _getMinuteNumbers: function _getMinuteNumbers() {
    var minutes = [];
    for (var i = 0; i < 12; i++) {
      minutes.push(i * 5);
    }
    var selectedMinutes = this.props.initialMinutes;
    var hasSelected = false;

    var numbers = minutes.map(function (minute) {
      var isSelected = selectedMinutes === minute;
      if (isSelected) hasSelected = true;
      return React.createElement(ClockNumber, { key: minute, isSelected: isSelected, type: 'minute', value: minute });
    });

    return {
      numbers: numbers,
      hasSelected: hasSelected,
      selected: selectedMinutes
    };
  },

  render: function render() {
    var styles = {
      root: {
        height: "100%",
        width: "100%",
        borderRadius: "100%",
        position: "relative",
        pointerEvents: "none",
        boxSizing: "border-box"
      },

      hitMask: {
        height: "100%",
        width: "100%",
        pointerEvents: "auto"
      }
    };

    var minutes = this._getMinuteNumbers();

    return React.createElement(
      'div',
      { ref: 'clock', style: this.prepareStyles(styles.root) },
      React.createElement(ClockPointer, { value: minutes.selected, type: 'minute' }),
      minutes.numbers,
      React.createElement('div', { ref: 'mask', style: this.prepareStyles(styles.hitMask), hasSelected: minutes.hasSelected,
        onTouchMove: this.handleTouch, onTouchEnd: this.handleTouch,
        onMouseUp: this.handleUp, onMouseMove: this.handleMove })
    );
  }
});

module.exports = ClockMinutes;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var ToolbarSeparator = React.createClass({
  displayName: 'ToolbarSeparator',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.toolbar;
  },

  getSpacing: function getSpacing() {
    return this.state.muiTheme.rawTheme.spacing;
  },

  render: function render() {
    var styles = this.prepareStyles({
      backgroundColor: this.getTheme().separatorColor,
      display: 'inline-block',
      height: this.getSpacing().desktopGutterMore,
      marginLeft: this.getSpacing().desktopGutter,
      position: 'relative',
      top: (this.getTheme().height - this.getSpacing().desktopGutterMore) / 2,
      width: 1
    }, this.props.style);

    return React.createElement('span', { className: this.props.className, style: styles });
  }

});

module.exports = ToolbarSeparator;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var ToolbarTitle = React.createClass({
  displayName: 'ToolbarTitle',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  propTypes: {
    text: React.PropTypes.string
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  getTheme: function getTheme() {
    return this.state.muiTheme.toolbar;
  },

  render: function render() {
    var _props = this.props;
    var style = _props.style;
    var text = _props.text;

    var other = _objectWithoutProperties(_props, ['style', 'text']);

    var styles = this.prepareStyles({
      paddingRight: this.state.muiTheme.rawTheme.spacing.desktopGutterLess,
      lineHeight: this.getTheme().height + 'px',
      fontSize: this.getTheme().titleFontSize + 'px',
      display: 'inline-block',
      position: 'relative'
    }, style);

    return React.createElement(
      'span',
      _extends({ style: styles }, other),
      text
    );
  }

});

module.exports = ToolbarTitle;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  ColorManipulator: __webpack_require__(95),
  CssEvent: __webpack_require__(192),
  Dom: __webpack_require__(352),
  Events: __webpack_require__(137),
  Extend: __webpack_require__(350),
  ImmutabilityHelper: __webpack_require__(162),
  KeyCode: __webpack_require__(79),
  KeyLine: __webpack_require__(531),
  UniqueId: __webpack_require__(357),
  Styles: __webpack_require__(348)
};

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsDirectionsRailway = React.createClass({
  displayName: 'MapsDirectionsRailway',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z' })
    );
  }

});

module.exports = MapsDirectionsRailway;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsDirectionsSubway = React.createClass({
  displayName: 'MapsDirectionsSubway',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z' })
    );
  }

});

module.exports = MapsDirectionsSubway;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsSatellite = React.createClass({
  displayName: 'MapsSatellite',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z' })
    );
  }

});

module.exports = MapsSatellite;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsDirectionsCar = React.createClass({
  displayName: 'MapsDirectionsCar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z' })
    );
  }

});

module.exports = MapsDirectionsCar;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsDirectionsWalk = React.createClass({
  displayName: 'MapsDirectionsWalk',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7' })
    );
  }

});

module.exports = MapsDirectionsWalk;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLayersClear = React.createClass({
  displayName: 'MapsLayersClear',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z' })
    );
  }

});

module.exports = MapsLayersClear;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalPharmacy = React.createClass({
  displayName: 'MapsLocalPharmacy',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z' })
    );
  }

});

module.exports = MapsLocalPharmacy;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsPlace = React.createClass({
  displayName: 'MapsPlace',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
    );
  }

});

module.exports = MapsPlace;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsHotel = React.createClass({
  displayName: 'MapsHotel',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z' })
    );
  }

});

module.exports = MapsHotel;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsDirectionsBike = React.createClass({
  displayName: 'MapsDirectionsBike',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z' })
    );
  }

});

module.exports = MapsDirectionsBike;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalMall = React.createClass({
  displayName: 'MapsLocalMall',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z' })
    );
  }

});

module.exports = MapsLocalMall;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsMyLocation = React.createClass({
  displayName: 'MapsMyLocation',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
    );
  }

});

module.exports = MapsMyLocation;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalOffer = React.createClass({
  displayName: 'MapsLocalOffer',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z' })
    );
  }

});

module.exports = MapsLocalOffer;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalSee = React.createClass({
  displayName: 'MapsLocalSee',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
      React.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
    );
  }

});

module.exports = MapsLocalSee;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalCarWash = React.createClass({
  displayName: 'MapsLocalCarWash',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z' })
    );
  }

});

module.exports = MapsLocalCarWash;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalPostOffice = React.createClass({
  displayName: 'MapsLocalPostOffice',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
    );
  }

});

module.exports = MapsLocalPostOffice;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsDirections = React.createClass({
  displayName: 'MapsDirections',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z' })
    );
  }

});

module.exports = MapsDirections;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalMovies = React.createClass({
  displayName: 'MapsLocalMovies',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z' })
    );
  }

});

module.exports = MapsLocalMovies;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsRestaurantMenu = React.createClass({
  displayName: 'MapsRestaurantMenu',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z' })
    );
  }

});

module.exports = MapsRestaurantMenu;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsDirectionsBoat = React.createClass({
  displayName: 'MapsDirectionsBoat',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z' })
    );
  }

});

module.exports = MapsDirectionsBoat;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalCafe = React.createClass({
  displayName: 'MapsLocalCafe',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z' })
    );
  }

});

module.exports = MapsLocalCafe;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsTerrain = React.createClass({
  displayName: 'MapsTerrain',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
    );
  }

});

module.exports = MapsTerrain;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalPhone = React.createClass({
  displayName: 'MapsLocalPhone',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
    );
  }

});

module.exports = MapsLocalPhone;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalHotel = React.createClass({
  displayName: 'MapsLocalHotel',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z' })
    );
  }

});

module.exports = MapsLocalHotel;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalPlay = React.createClass({
  displayName: 'MapsLocalPlay',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z' })
    );
  }

});

module.exports = MapsLocalPlay;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalPizza = React.createClass({
  displayName: 'MapsLocalPizza',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
    );
  }

});

module.exports = MapsLocalPizza;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalAirport = React.createClass({
  displayName: 'MapsLocalAirport',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
    );
  }

});

module.exports = MapsLocalAirport;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalShipping = React.createClass({
  displayName: 'MapsLocalShipping',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
    );
  }

});

module.exports = MapsLocalShipping;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalParking = React.createClass({
  displayName: 'MapsLocalParking',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z' })
    );
  }

});

module.exports = MapsLocalParking;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsNavigation = React.createClass({
  displayName: 'MapsNavigation',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z' })
    );
  }

});

module.exports = MapsNavigation;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsMap = React.createClass({
  displayName: 'MapsMap',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z' })
    );
  }

});

module.exports = MapsMap;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsPinDrop = React.createClass({
  displayName: 'MapsPinDrop',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z' })
    );
  }

});

module.exports = MapsPinDrop;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalHospital = React.createClass({
  displayName: 'MapsLocalHospital',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z' })
    );
  }

});

module.exports = MapsLocalHospital;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsDirectionsRun = React.createClass({
  displayName: 'MapsDirectionsRun',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z' })
    );
  }

});

module.exports = MapsDirectionsRun;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsTraffic = React.createClass({
  displayName: 'MapsTraffic',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z' })
    );
  }

});

module.exports = MapsTraffic;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLayers = React.createClass({
  displayName: 'MapsLayers',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z' })
    );
  }

});

module.exports = MapsLayers;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalDrink = React.createClass({
  displayName: 'MapsLocalDrink',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z' })
    );
  }

});

module.exports = MapsLocalDrink;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalGroceryStore = React.createClass({
  displayName: 'MapsLocalGroceryStore',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' })
    );
  }

});

module.exports = MapsLocalGroceryStore;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalDining = React.createClass({
  displayName: 'MapsLocalDining',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z' })
    );
  }

});

module.exports = MapsLocalDining;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalTaxi = React.createClass({
  displayName: 'MapsLocalTaxi',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z' })
    );
  }

});

module.exports = MapsLocalTaxi;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsPersonPin = React.createClass({
  displayName: 'MapsPersonPin',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z' })
    );
  }

});

module.exports = MapsPersonPin;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalGasStation = React.createClass({
  displayName: 'MapsLocalGasStation',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
    );
  }

});

module.exports = MapsLocalGasStation;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsFlight = React.createClass({
  displayName: 'MapsFlight',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10.18 9' }),
      React.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
    );
  }

});

module.exports = MapsFlight;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalActivity = React.createClass({
  displayName: 'MapsLocalActivity',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z' })
    );
  }

});

module.exports = MapsLocalActivity;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalFlorist = React.createClass({
  displayName: 'MapsLocalFlorist',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z' })
    );
  }

});

module.exports = MapsLocalFlorist;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalBar = React.createClass({
  displayName: 'MapsLocalBar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 13v6H6v2h12v-2h-5v-6l8-8V3H3v2l8 8zM7.5 7l-2-2h13l-2 2h-9z' })
    );
  }

});

module.exports = MapsLocalBar;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsDirectionsTransit = React.createClass({
  displayName: 'MapsDirectionsTransit',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z' })
    );
  }

});

module.exports = MapsDirectionsTransit;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalPrintshop = React.createClass({
  displayName: 'MapsLocalPrintshop',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
    );
  }

});

module.exports = MapsLocalPrintshop;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalAtm = React.createClass({
  displayName: 'MapsLocalAtm',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z' })
    );
  }

});

module.exports = MapsLocalAtm;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsStoreMallDirectory = React.createClass({
  displayName: 'MapsStoreMallDirectory',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' })
    );
  }

});

module.exports = MapsStoreMallDirectory;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalConvenienceStore = React.createClass({
  displayName: 'MapsLocalConvenienceStore',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z' })
    );
  }

});

module.exports = MapsLocalConvenienceStore;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsRateReview = React.createClass({
  displayName: 'MapsRateReview',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z' })
    );
  }

});

module.exports = MapsRateReview;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalLibrary = React.createClass({
  displayName: 'MapsLocalLibrary',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z' })
    );
  }

});

module.exports = MapsLocalLibrary;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsLocalLaundryService = React.createClass({
  displayName: 'MapsLocalLaundryService',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9.17 16.83c1.56 1.56 4.1 1.56 5.66 0 1.56-1.56 1.56-4.1 0-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
    );
  }

});

module.exports = MapsLocalLaundryService;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsBeenhere = React.createClass({
  displayName: 'MapsBeenhere',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z' })
    );
  }

});

module.exports = MapsBeenhere;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var MapsDirectionsBus = React.createClass({
  displayName: 'MapsDirectionsBus',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z' })
    );
  }

});

module.exports = MapsDirectionsBus;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationMoreHoriz = React.createClass({
  displayName: 'NavigationMoreHoriz',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
    );
  }

});

module.exports = NavigationMoreHoriz;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationFullscreen = React.createClass({
  displayName: 'NavigationFullscreen',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z' })
    );
  }

});

module.exports = NavigationFullscreen;

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationCheck = React.createClass({
  displayName: 'NavigationCheck',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
    );
  }

});

module.exports = NavigationCheck;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationRefresh = React.createClass({
  displayName: 'NavigationRefresh',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z' })
    );
  }

});

module.exports = NavigationRefresh;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationArrowDropDownCircle = React.createClass({
  displayName: 'NavigationArrowDropDownCircle',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z' })
    );
  }

});

module.exports = NavigationArrowDropDownCircle;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationExpandMore = React.createClass({
  displayName: 'NavigationExpandMore',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
    );
  }

});

module.exports = NavigationExpandMore;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationUnfoldLess = React.createClass({
  displayName: 'NavigationUnfoldLess',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z' })
    );
  }

});

module.exports = NavigationUnfoldLess;

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationArrowForward = React.createClass({
  displayName: 'NavigationArrowForward',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z' })
    );
  }

});

module.exports = NavigationArrowForward;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationFullscreenExit = React.createClass({
  displayName: 'NavigationFullscreenExit',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z' })
    );
  }

});

module.exports = NavigationFullscreenExit;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationApps = React.createClass({
  displayName: 'NavigationApps',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z' })
    );
  }

});

module.exports = NavigationApps;

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationArrowBack = React.createClass({
  displayName: 'NavigationArrowBack',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
    );
  }

});

module.exports = NavigationArrowBack;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationClose = React.createClass({
  displayName: 'NavigationClose',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
    );
  }

});

module.exports = NavigationClose;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationExpandLess = React.createClass({
  displayName: 'NavigationExpandLess',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
    );
  }

});

module.exports = NavigationExpandLess;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationMoreVert = React.createClass({
  displayName: 'NavigationMoreVert',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
    );
  }

});

module.exports = NavigationMoreVert;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationUnfoldMore = React.createClass({
  displayName: 'NavigationUnfoldMore',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z' })
    );
  }

});

module.exports = NavigationUnfoldMore;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NavigationCancel = React.createClass({
  displayName: 'NavigationCancel',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
    );
  }

});

module.exports = NavigationCancel;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorVerticalAlignBottom = React.createClass({
  displayName: 'EditorVerticalAlignBottom',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z' })
    );
  }

});

module.exports = EditorVerticalAlignBottom;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatPaint = React.createClass({
  displayName: 'EditorFormatPaint',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z' })
    );
  }

});

module.exports = EditorFormatPaint;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorBorderHorizontal = React.createClass({
  displayName: 'EditorBorderHorizontal',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z' })
    );
  }

});

module.exports = EditorBorderHorizontal;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatAlignRight = React.createClass({
  displayName: 'EditorFormatAlignRight',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z' })
    );
  }

});

module.exports = EditorFormatAlignRight;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorBorderStyle = React.createClass({
  displayName: 'EditorBorderStyle',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z' })
    );
  }

});

module.exports = EditorBorderStyle;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorBorderInner = React.createClass({
  displayName: 'EditorBorderInner',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z' })
    );
  }

});

module.exports = EditorBorderInner;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatTextdirectionLToR = React.createClass({
  displayName: 'EditorFormatTextdirectionLToR',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z' })
    );
  }

});

module.exports = EditorFormatTextdirectionLToR;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorBorderColor = React.createClass({
  displayName: 'EditorBorderColor',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z' }),
      React.createElement('path', { 'fill-opacity': '.36', d: 'M0 20h24v4H0z' })
    );
  }

});

module.exports = EditorBorderColor;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatAlignCenter = React.createClass({
  displayName: 'EditorFormatAlignCenter',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z' })
    );
  }

});

module.exports = EditorFormatAlignCenter;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatStrikethrough = React.createClass({
  displayName: 'EditorFormatStrikethrough',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z' })
    );
  }

});

module.exports = EditorFormatStrikethrough;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatListBulleted = React.createClass({
  displayName: 'EditorFormatListBulleted',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12.17c-.74 0-1.33.6-1.33 1.33s.6 1.33 1.33 1.33 1.33-.6 1.33-1.33-.59-1.33-1.33-1.33zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z' })
    );
  }

});

module.exports = EditorFormatListBulleted;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFunctions = React.createClass({
  displayName: 'EditorFunctions',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z' })
    );
  }

});

module.exports = EditorFunctions;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatColorText = React.createClass({
  displayName: 'EditorFormatColorText',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.36', d: 'M0 20h24v4H0z' }),
      React.createElement('path', { d: 'M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z' })
    );
  }

});

module.exports = EditorFormatColorText;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatColorFill = React.createClass({
  displayName: 'EditorFormatColorFill',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z' }),
      React.createElement('path', { 'fill-opacity': '.36', d: 'M0 20h24v4H0z' })
    );
  }

});

module.exports = EditorFormatColorFill;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorModeEdit = React.createClass({
  displayName: 'EditorModeEdit',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
    );
  }

});

module.exports = EditorModeEdit;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorWrapText = React.createClass({
  displayName: 'EditorWrapText',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z' })
    );
  }

});

module.exports = EditorWrapText;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorMergeType = React.createClass({
  displayName: 'EditorMergeType',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z' })
    );
  }

});

module.exports = EditorMergeType;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorBorderVertical = React.createClass({
  displayName: 'EditorBorderVertical',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z' })
    );
  }

});

module.exports = EditorBorderVertical;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorVerticalAlignCenter = React.createClass({
  displayName: 'EditorVerticalAlignCenter',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z' })
    );
  }

});

module.exports = EditorVerticalAlignCenter;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorBorderLeft = React.createClass({
  displayName: 'EditorBorderLeft',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z' })
    );
  }

});

module.exports = EditorBorderLeft;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatListNumbered = React.createClass({
  displayName: 'EditorFormatListNumbered',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z' })
    );
  }

});

module.exports = EditorFormatListNumbered;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorBorderRight = React.createClass({
  displayName: 'EditorBorderRight',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z' })
    );
  }

});

module.exports = EditorBorderRight;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatLineSpacing = React.createClass({
  displayName: 'EditorFormatLineSpacing',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z' })
    );
  }

});

module.exports = EditorFormatLineSpacing;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatIndentDecrease = React.createClass({
  displayName: 'EditorFormatIndentDecrease',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z' })
    );
  }

});

module.exports = EditorFormatIndentDecrease;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorBorderTop = React.createClass({
  displayName: 'EditorBorderTop',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z' })
    );
  }

});

module.exports = EditorBorderTop;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorModeComment = React.createClass({
  displayName: 'EditorModeComment',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z' })
    );
  }

});

module.exports = EditorModeComment;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatColorReset = React.createClass({
  displayName: 'EditorFormatColorReset',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z' })
    );
  }

});

module.exports = EditorFormatColorReset;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorMoneyOff = React.createClass({
  displayName: 'EditorMoneyOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z' })
    );
  }

});

module.exports = EditorMoneyOff;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorSpaceBar = React.createClass({
  displayName: 'EditorSpaceBar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 9v4H6V9H4v6h16V9z' })
    );
  }

});

module.exports = EditorSpaceBar;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorInsertEmoticon = React.createClass({
  displayName: 'EditorInsertEmoticon',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
    );
  }

});

module.exports = EditorInsertEmoticon;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatQuote = React.createClass({
  displayName: 'EditorFormatQuote',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z' })
    );
  }

});

module.exports = EditorFormatQuote;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorVerticalAlignTop = React.createClass({
  displayName: 'EditorVerticalAlignTop',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z' })
    );
  }

});

module.exports = EditorVerticalAlignTop;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatAlignLeft = React.createClass({
  displayName: 'EditorFormatAlignLeft',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z' })
    );
  }

});

module.exports = EditorFormatAlignLeft;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorAttachMoney = React.createClass({
  displayName: 'EditorAttachMoney',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z' })
    );
  }

});

module.exports = EditorAttachMoney;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorBorderBottom = React.createClass({
  displayName: 'EditorBorderBottom',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z' })
    );
  }

});

module.exports = EditorBorderBottom;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatTextdirectionRToL = React.createClass({
  displayName: 'EditorFormatTextdirectionRToL',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z' })
    );
  }

});

module.exports = EditorFormatTextdirectionRToL;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatClear = React.createClass({
  displayName: 'EditorFormatClear',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z' })
    );
  }

});

module.exports = EditorFormatClear;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorInsertDriveFile = React.createClass({
  displayName: 'EditorInsertDriveFile',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z' })
    );
  }

});

module.exports = EditorInsertDriveFile;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatIndentIncrease = React.createClass({
  displayName: 'EditorFormatIndentIncrease',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z' })
    );
  }

});

module.exports = EditorFormatIndentIncrease;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorInsertChart = React.createClass({
  displayName: 'EditorInsertChart',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
    );
  }

});

module.exports = EditorInsertChart;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorInsertComment = React.createClass({
  displayName: 'EditorInsertComment',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
    );
  }

});

module.exports = EditorInsertComment;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatBold = React.createClass({
  displayName: 'EditorFormatBold',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z' })
    );
  }

});

module.exports = EditorFormatBold;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatSize = React.createClass({
  displayName: 'EditorFormatSize',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z' })
    );
  }

});

module.exports = EditorFormatSize;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorBorderClear = React.createClass({
  displayName: 'EditorBorderClear',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z' })
    );
  }

});

module.exports = EditorBorderClear;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorPublish = React.createClass({
  displayName: 'EditorPublish',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z' })
    );
  }

});

module.exports = EditorPublish;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorAttachFile = React.createClass({
  displayName: 'EditorAttachFile',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z' })
    );
  }

});

module.exports = EditorAttachFile;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorBorderAll = React.createClass({
  displayName: 'EditorBorderAll',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z' })
    );
  }

});

module.exports = EditorBorderAll;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorStrikethroughS = React.createClass({
  displayName: 'EditorStrikethroughS',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5.9 10h6.3c-.8-.3-1.5-.6-2-.9-.7-.4-1-1-1-1.6 0-.3.1-.6.2-.9.1-.3.3-.5.6-.7.3-.2.6-.4 1-.5.4-.1.8-.2 1.4-.2.5 0 1 .1 1.4.2.4.1.7.3 1 .6.3.2.5.5.6.9.1.3.2.7.2 1.1h4c0-.9-.2-1.7-.5-2.4s-.8-1.4-1.4-1.9c-.6-.5-1.4-1-2.3-1.2-1-.4-2-.5-3.1-.5s-2 .1-2.9.4c-.9.3-1.6.6-2.3 1.1-.6.5-1.1 1-1.4 1.7-.4.7-.6 1.4-.6 2.2 0 .8.2 1.6.5 2.2.1.2.2.3.3.4zM23 12H1v2h11.9c.2.1.5.2.7.3.5.2.9.5 1.2.7.3.2.5.5.6.8.1.3.1.6.1.9 0 .3-.1.6-.2.9-.1.3-.3.5-.6.7-.2.2-.6.3-.9.5-.4.1-.8.2-1.4.2-.6 0-1.1-.1-1.6-.2s-.9-.3-1.2-.6c-.3-.3-.6-.6-.8-1-.2-.4-.3-1-.3-1.6h-4c0 .7.1 1.5.3 2.1.2.6.5 1.1.9 1.6s.8.9 1.3 1.2c.5.3 1 .6 1.6.9.6.2 1.2.4 1.8.5.6.1 1.3.2 1.9.2 1.1 0 2-.1 2.9-.4.9-.2 1.6-.6 2.2-1.1.6-.5 1.1-1 1.4-1.7.3-.7.5-1.4.5-2.3 0-.8-.1-1.5-.4-2.2-.1-.2-.1-.3-.2-.4H23v-2z' })
    );
  }

});

module.exports = EditorStrikethroughS;

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatUnderlined = React.createClass({
  displayName: 'EditorFormatUnderlined',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z' })
    );
  }

});

module.exports = EditorFormatUnderlined;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorInsertInvitation = React.createClass({
  displayName: 'EditorInsertInvitation',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z' })
    );
  }

});

module.exports = EditorInsertInvitation;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorInsertLink = React.createClass({
  displayName: 'EditorInsertLink',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
    );
  }

});

module.exports = EditorInsertLink;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorBorderOuter = React.createClass({
  displayName: 'EditorBorderOuter',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z' })
    );
  }

});

module.exports = EditorBorderOuter;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatAlignJustify = React.createClass({
  displayName: 'EditorFormatAlignJustify',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z' })
    );
  }

});

module.exports = EditorFormatAlignJustify;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorInsertPhoto = React.createClass({
  displayName: 'EditorInsertPhoto',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
    );
  }

});

module.exports = EditorInsertPhoto;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var EditorFormatItalic = React.createClass({
  displayName: 'EditorFormatItalic',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z' })
    );
  }

});

module.exports = EditorFormatItalic;

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var SvgIcon = __webpack_require__(2);

var NavigationArrowDropRight = React.createClass({
  displayName: 'NavigationArrowDropRight',

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9.5,7l5,5l-5,5V7z' })
    );
  }

});

module.exports = NavigationArrowDropRight;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ToggleStar = React.createClass({
  displayName: 'ToggleStar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
    );
  }

});

module.exports = ToggleStar;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ToggleStarHalf = React.createClass({
  displayName: 'ToggleStarHalf',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 9.74l-7.19-.62L12 2.5 9.19 9.13 2 9.74l5.46 4.73-1.64 7.03L12 17.77l6.18 3.73-1.63-7.03L22 9.74zM12 15.9V6.6l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.9z' })
    );
  }

});

module.exports = ToggleStarHalf;

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ToggleStarBorder = React.createClass({
  displayName: 'ToggleStarBorder',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z' })
    );
  }

});

module.exports = ToggleStarBorder;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ToggleIndeterminateCheckBox = React.createClass({
  displayName: 'ToggleIndeterminateCheckBox',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M0 0h24v24H0z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { 'clip-path': 'url(#b)', d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' })
    );
  }

});

module.exports = ToggleIndeterminateCheckBox;

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileCloudOff = React.createClass({
  displayName: 'FileCloudOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z' })
    );
  }

});

module.exports = FileCloudOff;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileCloud = React.createClass({
  displayName: 'FileCloud',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z' })
    );
  }

});

module.exports = FileCloud;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileCloudDownload = React.createClass({
  displayName: 'FileCloudDownload',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z' })
    );
  }

});

module.exports = FileCloudDownload;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileFolderOpen = React.createClass({
  displayName: 'FileFolderOpen',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z' })
    );
  }

});

module.exports = FileFolderOpen;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileFileUpload = React.createClass({
  displayName: 'FileFileUpload',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z' })
    );
  }

});

module.exports = FileFileUpload;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileCloudUpload = React.createClass({
  displayName: 'FileCloudUpload',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' })
    );
  }

});

module.exports = FileCloudUpload;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileFileDownload = React.createClass({
  displayName: 'FileFileDownload',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
    );
  }

});

module.exports = FileFileDownload;

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileCloudDone = React.createClass({
  displayName: 'FileCloudDone',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z' })
    );
  }

});

module.exports = FileCloudDone;

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileAttachment = React.createClass({
  displayName: 'FileAttachment',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.5 18C4.46 18 2 15.54 2 12.5S4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v1.5H9.5c-.55 0-1 .45-1 1s.45 1 1 1H18c1.38 0 2.5-1.12 2.5-2.5S19.38 8.5 18 8.5H7.5c-2.21 0-4 1.79-4 4s1.79 4 4 4H17V18H7.5z' })
    );
  }

});

module.exports = FileAttachment;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileFolderShared = React.createClass({
  displayName: 'FileFolderShared',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z' })
    );
  }

});

module.exports = FileFolderShared;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileCloudQueue = React.createClass({
  displayName: 'FileCloudQueue',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z' })
    );
  }

});

module.exports = FileCloudQueue;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileCloudCircle = React.createClass({
  displayName: 'FileCloudCircle',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z' })
    );
  }

});

module.exports = FileCloudCircle;

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var FileFolder = React.createClass({
  displayName: 'FileFolder',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z' })
    );
  }

});

module.exports = FileFolder;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationMessage = React.createClass({
  displayName: 'CommunicationMessage',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
    );
  }

});

module.exports = CommunicationMessage;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationSpeakerPhone = React.createClass({
  displayName: 'CommunicationSpeakerPhone',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z' })
    );
  }

});

module.exports = CommunicationSpeakerPhone;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationForum = React.createClass({
  displayName: 'CommunicationForum',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
    );
  }

});

module.exports = CommunicationForum;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationLocationOn = React.createClass({
  displayName: 'CommunicationLocationOn',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
    );
  }

});

module.exports = CommunicationLocationOn;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationDialpad = React.createClass({
  displayName: 'CommunicationDialpad',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
    );
  }

});

module.exports = CommunicationDialpad;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationContacts = React.createClass({
  displayName: 'CommunicationContacts',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z' })
    );
  }

});

module.exports = CommunicationContacts;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationLocationOff = React.createClass({
  displayName: 'CommunicationLocationOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 6.5c1.38 0 2.5 1.12 2.5 2.5 0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7-1.98 0-3.76.83-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z' })
    );
  }

});

module.exports = CommunicationLocationOff;

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationChatBubbleOutline = React.createClass({
  displayName: 'CommunicationChatBubbleOutline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z' })
    );
  }

});

module.exports = CommunicationChatBubbleOutline;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationStayCurrentPortrait = React.createClass({
  displayName: 'CommunicationStayCurrentPortrait',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
    );
  }

});

module.exports = CommunicationStayCurrentPortrait;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationCallSplit = React.createClass({
  displayName: 'CommunicationCallSplit',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z' })
    );
  }

});

module.exports = CommunicationCallSplit;

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationCallMissed = React.createClass({
  displayName: 'CommunicationCallMissed',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z' })
    );
  }

});

module.exports = CommunicationCallMissed;

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationChatBubble = React.createClass({
  displayName: 'CommunicationChatBubble',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = CommunicationChatBubble;

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationPresentToAll = React.createClass({
  displayName: 'CommunicationPresentToAll',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z' })
    );
  }

});

module.exports = CommunicationPresentToAll;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationStayPrimaryPortrait = React.createClass({
  displayName: 'CommunicationStayPrimaryPortrait',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
    );
  }

});

module.exports = CommunicationStayPrimaryPortrait;

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationCallReceived = React.createClass({
  displayName: 'CommunicationCallReceived',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z' })
    );
  }

});

module.exports = CommunicationCallReceived;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationStayPrimaryLandscape = React.createClass({
  displayName: 'CommunicationStayPrimaryLandscape',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z' })
    );
  }

});

module.exports = CommunicationStayPrimaryLandscape;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationPhonelinkErase = React.createClass({
  displayName: 'CommunicationPhonelinkErase',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = CommunicationPhonelinkErase;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationInvertColorsOff = React.createClass({
  displayName: 'CommunicationInvertColorsOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20.65 20.87l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78c-2.55 3.14-2.36 7.76.56 10.69C7.9 20.8 9.95 21.58 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zM12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z' })
    );
  }

});

module.exports = CommunicationInvertColorsOff;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationCallMerge = React.createClass({
  displayName: 'CommunicationCallMerge',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z' })
    );
  }

});

module.exports = CommunicationCallMerge;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationPhonelinkLock = React.createClass({
  displayName: 'CommunicationPhonelinkLock',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z' })
    );
  }

});

module.exports = CommunicationPhonelinkLock;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationLiveHelp = React.createClass({
  displayName: 'CommunicationLiveHelp',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
    );
  }

});

module.exports = CommunicationLiveHelp;

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationSwapCalls = React.createClass({
  displayName: 'CommunicationSwapCalls',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z' })
    );
  }

});

module.exports = CommunicationSwapCalls;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationTactMail = React.createClass({
  displayName: 'CommunicationTactMail',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z' })
    );
  }

});

module.exports = CommunicationTactMail;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationContactPhone = React.createClass({
  displayName: 'CommunicationContactPhone',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z' })
    );
  }

});

module.exports = CommunicationContactPhone;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationPortableWifiOff = React.createClass({
  displayName: 'CommunicationPortableWifiOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06 2.21 0 4 1.79 4 4 0 .21-.02.42-.05.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47C21.46 15.69 22 13.91 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z' })
    );
  }

});

module.exports = CommunicationPortableWifiOff;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationDialerSip = React.createClass({
  displayName: 'CommunicationDialerSip',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
    );
  }

});

module.exports = CommunicationDialerSip;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationNoSim = React.createClass({
  displayName: 'CommunicationNoSim',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z' })
    );
  }

});

module.exports = CommunicationNoSim;

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationStayCurrentLandscape = React.createClass({
  displayName: 'CommunicationStayCurrentLandscape',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z' })
    );
  }

});

module.exports = CommunicationStayCurrentLandscape;

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationCall = React.createClass({
  displayName: 'CommunicationCall',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
    );
  }

});

module.exports = CommunicationCall;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationVpnKey = React.createClass({
  displayName: 'CommunicationVpnKey',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
    );
  }

});

module.exports = CommunicationVpnKey;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationVoicemail = React.createClass({
  displayName: 'CommunicationVoicemail',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z' })
    );
  }

});

module.exports = CommunicationVoicemail;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationPhonelinkRing = React.createClass({
  displayName: 'CommunicationPhonelinkRing',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z' })
    );
  }

});

module.exports = CommunicationPhonelinkRing;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationBusiness = React.createClass({
  displayName: 'CommunicationBusiness',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
    );
  }

});

module.exports = CommunicationBusiness;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationImportExport = React.createClass({
  displayName: 'CommunicationImportExport',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z' })
    );
  }

});

module.exports = CommunicationImportExport;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationClearAll = React.createClass({
  displayName: 'CommunicationClearAll',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z' })
    );
  }

});

module.exports = CommunicationClearAll;

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationEmail = React.createClass({
  displayName: 'CommunicationEmail',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
    );
  }

});

module.exports = CommunicationEmail;

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationComment = React.createClass({
  displayName: 'CommunicationComment',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
    );
  }

});

module.exports = CommunicationComment;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationTextsms = React.createClass({
  displayName: 'CommunicationTextsms',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
    );
  }

});

module.exports = CommunicationTextsms;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationPhonelinkSetup = React.createClass({
  displayName: 'CommunicationPhonelinkSetup',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.8 12.5v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.3-.2H7c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.9.5l-1.3-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.2-.1.3-.1.4l1 1.7c.1.1.2.2.3.1l1.4-.4c.3.2.6.4.9.5l.2 1.3c-.1.1.1.2.2.2h2c.1 0 .2-.1.3-.2l.2-1.3c.3-.1.6-.3.9-.5l1.3.5c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.9zM8 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = CommunicationPhonelinkSetup;

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationCallEnd = React.createClass({
  displayName: 'CommunicationCallEnd',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z' })
    );
  }

});

module.exports = CommunicationCallEnd;

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationCallMade = React.createClass({
  displayName: 'CommunicationCallMade',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z' })
    );
  }

});

module.exports = CommunicationCallMade;

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationChat = React.createClass({
  displayName: 'CommunicationChat',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z' })
    );
  }

});

module.exports = CommunicationChat;

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationPhone = React.createClass({
  displayName: 'CommunicationPhone',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
    );
  }

});

module.exports = CommunicationPhone;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var CommunicationRingVolume = React.createClass({
  displayName: 'CommunicationRingVolume',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z' })
    );
  }

});

module.exports = CommunicationRingVolume;

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsEthernet = React.createClass({
  displayName: 'ActionSettingsEthernet',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z' })
    );
  }

});

module.exports = ActionSettingsEthernet;

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAssignmentReturned = React.createClass({
  displayName: 'ActionAssignmentReturned',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z' })
    );
  }

});

module.exports = ActionAssignmentReturned;

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionLockOpen = React.createClass({
  displayName: 'ActionLockOpen',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z' })
    );
  }

});

module.exports = ActionLockOpen;

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionReportProblem = React.createClass({
  displayName: 'ActionReportProblem',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
    );
  }

});

module.exports = ActionReportProblem;

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionList = React.createClass({
  displayName: 'ActionList',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z' })
    );
  }

});

module.exports = ActionList;

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSwapVert = React.createClass({
  displayName: 'ActionSwapVert',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z' })
    );
  }

});

module.exports = ActionSwapVert;

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionTab = React.createClass({
  displayName: 'ActionTab',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z' })
    );
  }

});

module.exports = ActionTab;

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionInfoOutline = React.createClass({
  displayName: 'ActionInfoOutline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z' })
    );
  }

});

module.exports = ActionInfoOutline;

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionTabUnselected = React.createClass({
  displayName: 'ActionTabUnselected',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z' })
    );
  }

});

module.exports = ActionTabUnselected;

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionGif = React.createClass({
  displayName: 'ActionGif',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M24 24H0V0h24v24z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { d: 'M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z', 'clip-path': 'url(#b)' })
    );
  }

});

module.exports = ActionGif;

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPolymer = React.createClass({
  displayName: 'ActionPolymer',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z' })
    );
  }

});

module.exports = ActionPolymer;

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionExplore = React.createClass({
  displayName: 'ActionExplore',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z' })
    );
  }

});

module.exports = ActionExplore;

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionThumbDown = React.createClass({
  displayName: 'ActionThumbDown',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z' })
    );
  }

});

module.exports = ActionThumbDown;

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionViewHeadline = React.createClass({
  displayName: 'ActionViewHeadline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z' })
    );
  }

});

module.exports = ActionViewHeadline;

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPageview = React.createClass({
  displayName: 'ActionPageview',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z' })
    );
  }

});

module.exports = ActionPageview;

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionFavoriteBorder = React.createClass({
  displayName: 'ActionFavoriteBorder',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z' })
    );
  }

});

module.exports = ActionFavoriteBorder;

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPermPhoneMsg = React.createClass({
  displayName: 'ActionPermPhoneMsg',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z' })
    );
  }

});

module.exports = ActionPermPhoneMsg;

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsInputAntenna = React.createClass({
  displayName: 'ActionSettingsInputAntenna',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z' })
    );
  }

});

module.exports = ActionSettingsInputAntenna;

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAssignment = React.createClass({
  displayName: 'ActionAssignment',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z' })
    );
  }

});

module.exports = ActionAssignment;

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionGetApp = React.createClass({
  displayName: 'ActionGetApp',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
    );
  }

});

module.exports = ActionGetApp;

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPermMedia = React.createClass({
  displayName: 'ActionPermMedia',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z' })
    );
  }

});

module.exports = ActionPermMedia;

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionFindInPage = React.createClass({
  displayName: 'ActionFindInPage',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z' })
    );
  }

});

module.exports = ActionFindInPage;

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsBluetooth = React.createClass({
  displayName: 'ActionSettingsBluetooth',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z' })
    );
  }

});

module.exports = ActionSettingsBluetooth;

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionCreditCard = React.createClass({
  displayName: 'ActionCreditCard',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' })
    );
  }

});

module.exports = ActionCreditCard;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionViewWeek = React.createClass({
  displayName: 'ActionViewWeek',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z' })
    );
  }

});

module.exports = ActionViewWeek;

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionTrackChanges = React.createClass({
  displayName: 'ActionTrackChanges',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { fill: '#231F20', d: 'M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z' })
    );
  }

});

module.exports = ActionTrackChanges;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionCardGiftcard = React.createClass({
  displayName: 'ActionCardGiftcard',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z' })
    );
  }

});

module.exports = ActionCardGiftcard;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsBackupRestore = React.createClass({
  displayName: 'ActionSettingsBackupRestore',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z' })
    );
  }

});

module.exports = ActionSettingsBackupRestore;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionBugReport = React.createClass({
  displayName: 'ActionBugReport',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z' })
    );
  }

});

module.exports = ActionBugReport;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionHighlightOff = React.createClass({
  displayName: 'ActionHighlightOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
    );
  }

});

module.exports = ActionHighlightOff;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionChangeHistory = React.createClass({
  displayName: 'ActionChangeHistory',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z' })
    );
  }

});

module.exports = ActionChangeHistory;

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionViewAgenda = React.createClass({
  displayName: 'ActionViewAgenda',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z' })
    );
  }

});

module.exports = ActionViewAgenda;

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionDone = React.createClass({
  displayName: 'ActionDone',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' })
    );
  }

});

module.exports = ActionDone;

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionLockOutline = React.createClass({
  displayName: 'ActionLockOutline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6-5.1c1.71 0 3.1 1.39 3.1 3.1v2H9V6h-.1c0-1.71 1.39-3.1 3.1-3.1zM18 20H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z' })
    );
  }

});

module.exports = ActionLockOutline;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionHourglassFull = React.createClass({
  displayName: 'ActionHourglassFull',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z' })
    );
  }

});

module.exports = ActionHourglassFull;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionLabel = React.createClass({
  displayName: 'ActionLabel',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z' })
    );
  }

});

module.exports = ActionLabel;

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionBookmark = React.createClass({
  displayName: 'ActionBookmark',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = ActionBookmark;

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSwapVerticalCircle = React.createClass({
  displayName: 'ActionSwapVerticalCircle',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z' })
    );
  }

});

module.exports = ActionSwapVerticalCircle;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionEject = React.createClass({
  displayName: 'ActionEject',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 17h14v2H5zm7-12L5.33 15h13.34z' })
    );
  }

});

module.exports = ActionEject;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionTrendingFlat = React.createClass({
  displayName: 'ActionTrendingFlat',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 12l-4-4v3H3v2h15v3z' })
    );
  }

});

module.exports = ActionTrendingFlat;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionGroupWork = React.createClass({
  displayName: 'ActionGroupWork',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
    );
  }

});

module.exports = ActionGroupWork;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsInputSvideo = React.createClass({
  displayName: 'ActionSettingsInputSvideo',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z' })
    );
  }

});

module.exports = ActionSettingsInputSvideo;

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPermContactCalendar = React.createClass({
  displayName: 'ActionPermContactCalendar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z' })
    );
  }

});

module.exports = ActionPermContactCalendar;

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionFace = React.createClass({
  displayName: 'ActionFace',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z' })
    );
  }

});

module.exports = ActionFace;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionVerifiedUser = React.createClass({
  displayName: 'ActionVerifiedUser',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' })
    );
  }

});

module.exports = ActionVerifiedUser;

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionTheaters = React.createClass({
  displayName: 'ActionTheaters',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z' })
    );
  }

});

module.exports = ActionTheaters;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionBuild = React.createClass({
  displayName: 'ActionBuild',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z' })
    );
  }

});

module.exports = ActionBuild;

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPermDataSetting = React.createClass({
  displayName: 'ActionPermDataSetting',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
    );
  }

});

module.exports = ActionPermDataSetting;

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionQuestionAnswer = React.createClass({
  displayName: 'ActionQuestionAnswer',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
    );
  }

});

module.exports = ActionQuestionAnswer;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionFlipToBack = React.createClass({
  displayName: 'ActionFlipToBack',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z' })
    );
  }

});

module.exports = ActionFlipToBack;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionExtension = React.createClass({
  displayName: 'ActionExtension',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z' })
    );
  }

});

module.exports = ActionExtension;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAccessibility = React.createClass({
  displayName: 'ActionAccessibility',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z' })
    );
  }

});

module.exports = ActionAccessibility;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAlarmOn = React.createClass({
  displayName: 'ActionAlarmOn',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z' })
    );
  }

});

module.exports = ActionAlarmOn;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionQueryBuilder = React.createClass({
  displayName: 'ActionQueryBuilder',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zM12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
    );
  }

});

module.exports = ActionQueryBuilder;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAddShoppingCart = React.createClass({
  displayName: 'ActionAddShoppingCart',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z' })
    );
  }

});

module.exports = ActionAddShoppingCart;

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPayment = React.createClass({
  displayName: 'ActionPayment',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' })
    );
  }

});

module.exports = ActionPayment;

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionEventSeat = React.createClass({
  displayName: 'ActionEventSeat',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M0 0h24v24H0V0z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { d: 'M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z', 'clip-path': 'url(#b)' })
    );
  }

});

module.exports = ActionEventSeat;

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionInput = React.createClass({
  displayName: 'ActionInput',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z' })
    );
  }

});

module.exports = ActionInput;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionMarkunreadMailbox = React.createClass({
  displayName: 'ActionMarkunreadMailbox',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = ActionMarkunreadMailbox;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionLoyalty = React.createClass({
  displayName: 'ActionLoyalty',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z' })
    );
  }

});

module.exports = ActionLoyalty;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPrint = React.createClass({
  displayName: 'ActionPrint',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
    );
  }

});

module.exports = ActionPrint;

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAutorenew = React.createClass({
  displayName: 'ActionAutorenew',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z' })
    );
  }

});

module.exports = ActionAutorenew;

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionDelete = React.createClass({
  displayName: 'ActionDelete',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' })
    );
  }

});

module.exports = ActionDelete;

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAlarmAdd = React.createClass({
  displayName: 'ActionAlarmAdd',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z' })
    );
  }

});

module.exports = ActionAlarmAdd;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAccountBalance = React.createClass({
  displayName: 'ActionAccountBalance',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z' })
    );
  }

});

module.exports = ActionAccountBalance;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAndroid = React.createClass({
  displayName: 'ActionAndroid',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z' })
    );
  }

});

module.exports = ActionAndroid;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionBookmarkBorder = React.createClass({
  displayName: 'ActionBookmarkBorder',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z' })
    );
  }

});

module.exports = ActionBookmarkBorder;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionLaunch = React.createClass({
  displayName: 'ActionLaunch',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
    );
  }

});

module.exports = ActionLaunch;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSearch = React.createClass({
  displayName: 'ActionSearch',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' })
    );
  }

});

module.exports = ActionSearch;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionZoomOut = React.createClass({
  displayName: 'ActionZoomOut',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z' })
    );
  }

});

module.exports = ActionZoomOut;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionVisibilityOff = React.createClass({
  displayName: 'ActionVisibilityOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z' })
    );
  }

});

module.exports = ActionVisibilityOff;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionLock = React.createClass({
  displayName: 'ActionLock',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' })
    );
  }

});

module.exports = ActionLock;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAccountCircle = React.createClass({
  displayName: 'ActionAccountCircle',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z' })
    );
  }

});

module.exports = ActionAccountCircle;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAssignmentLate = React.createClass({
  displayName: 'ActionAssignmentLate',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
    );
  }

});

module.exports = ActionAssignmentLate;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionShop = React.createClass({
  displayName: 'ActionShop',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z' })
    );
  }

});

module.exports = ActionShop;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionToc = React.createClass({
  displayName: 'ActionToc',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z' })
    );
  }

});

module.exports = ActionToc;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionShoppingCart = React.createClass({
  displayName: 'ActionShoppingCart',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' })
    );
  }

});

module.exports = ActionShoppingCart;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionCardMembership = React.createClass({
  displayName: 'ActionCardMembership',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z' })
    );
  }

});

module.exports = ActionCardMembership;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionLabelOutline = React.createClass({
  displayName: 'ActionLabelOutline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z' })
    );
  }

});

module.exports = ActionLabelOutline;

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettings = React.createClass({
  displayName: 'ActionSettings',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z' })
    );
  }

});

module.exports = ActionSettings;

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsCell = React.createClass({
  displayName: 'ActionSettingsCell',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z' })
    );
  }

});

module.exports = ActionSettingsCell;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionOfflinePin = React.createClass({
  displayName: 'ActionOfflinePin',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M0 0h24v24H0V0z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { 'clip-path': 'url(#b)', d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z' })
    );
  }

});

module.exports = ActionOfflinePin;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionViewDay = React.createClass({
  displayName: 'ActionViewDay',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z' })
    );
  }

});

module.exports = ActionViewDay;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionDashboard = React.createClass({
  displayName: 'ActionDashboard',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z' })
    );
  }

});

module.exports = ActionDashboard;

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionViewModule = React.createClass({
  displayName: 'ActionViewModule',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z' })
    );
  }

});

module.exports = ActionViewModule;

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsApplications = React.createClass({
  displayName: 'ActionSettingsApplications',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z' })
    );
  }

});

module.exports = ActionSettingsApplications;

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionViewStream = React.createClass({
  displayName: 'ActionViewStream',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 18h17v-6H4v6zM4 5v6h17V5H4z' })
    );
  }

});

module.exports = ActionViewStream;

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionViewColumn = React.createClass({
  displayName: 'ActionViewColumn',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z' })
    );
  }

});

module.exports = ActionViewColumn;

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsInputComposite = React.createClass({
  displayName: 'ActionSettingsInputComposite',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z' })
    );
  }

});

module.exports = ActionSettingsInputComposite;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAccountBalanceWallet = React.createClass({
  displayName: 'ActionAccountBalanceWallet',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
    );
  }

});

module.exports = ActionAccountBalanceWallet;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionInfo = React.createClass({
  displayName: 'ActionInfo',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z' })
    );
  }

});

module.exports = ActionInfo;

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAssignmentTurnedIn = React.createClass({
  displayName: 'ActionAssignmentTurnedIn',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' })
    );
  }

});

module.exports = ActionAssignmentTurnedIn;

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSchedule = React.createClass({
  displayName: 'ActionSchedule',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.9', d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zM12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
    );
  }

});

module.exports = ActionSchedule;

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPermDeviceInformation = React.createClass({
  displayName: 'ActionPermDeviceInformation',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
    );
  }

});

module.exports = ActionPermDeviceInformation;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionViewList = React.createClass({
  displayName: 'ActionViewList',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z' })
    );
  }

});

module.exports = ActionViewList;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionOpenInBrowser = React.createClass({
  displayName: 'ActionOpenInBrowser',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z' })
    );
  }

});

module.exports = ActionOpenInBrowser;

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsPhone = React.createClass({
  displayName: 'ActionSettingsPhone',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z' })
    );
  }

});

module.exports = ActionSettingsPhone;

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionFeedback = React.createClass({
  displayName: 'ActionFeedback',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z' })
    );
  }

});

module.exports = ActionFeedback;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionHttps = React.createClass({
  displayName: 'ActionHttps',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' })
    );
  }

});

module.exports = ActionHttps;

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAlarmOff = React.createClass({
  displayName: 'ActionAlarmOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92 0-4.97-4.03-9-9-9-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z' })
    );
  }

});

module.exports = ActionAlarmOff;

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionCached = React.createClass({
  displayName: 'ActionCached',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z' })
    );
  }

});

module.exports = ActionCached;

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionTrendingUp = React.createClass({
  displayName: 'ActionTrendingUp',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z' })
    );
  }

});

module.exports = ActionTrendingUp;

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionWork = React.createClass({
  displayName: 'ActionWork',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z' })
    );
  }

});

module.exports = ActionWork;

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPermCameraMic = React.createClass({
  displayName: 'ActionPermCameraMic',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z' })
    );
  }

});

module.exports = ActionPermCameraMic;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionOpenInNew = React.createClass({
  displayName: 'ActionOpenInNew',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
    );
  }

});

module.exports = ActionOpenInNew;

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionTurnedInNot = React.createClass({
  displayName: 'ActionTurnedInNot',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z' })
    );
  }

});

module.exports = ActionTurnedInNot;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionThumbUp = React.createClass({
  displayName: 'ActionThumbUp',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z' })
    );
  }

});

module.exports = ActionThumbUp;

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionExitToApp = React.createClass({
  displayName: 'ActionExitToApp',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = ActionExitToApp;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionViewArray = React.createClass({
  displayName: 'ActionViewArray',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z' })
    );
  }

});

module.exports = ActionViewArray;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionReceipt = React.createClass({
  displayName: 'ActionReceipt',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z' })
    );
  }

});

module.exports = ActionReceipt;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAspectRatio = React.createClass({
  displayName: 'ActionAspectRatio',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
    );
  }

});

module.exports = ActionAspectRatio;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPlayForWork = React.createClass({
  displayName: 'ActionPlayForWork',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { fill: '#010101', d: 'M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z' })
    );
  }

});

module.exports = ActionPlayForWork;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionRedeem = React.createClass({
  displayName: 'ActionRedeem',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z' })
    );
  }

});

module.exports = ActionRedeem;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionCheckCircle = React.createClass({
  displayName: 'ActionCheckCircle',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
    );
  }

});

module.exports = ActionCheckCircle;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionHttp = React.createClass({
  displayName: 'ActionHttp',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z' })
    );
  }

});

module.exports = ActionHttp;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionEvent = React.createClass({
  displayName: 'ActionEvent',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z' })
    );
  }

});

module.exports = ActionEvent;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionStars = React.createClass({
  displayName: 'ActionStars',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z' })
    );
  }

});

module.exports = ActionStars;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionInvertColors = React.createClass({
  displayName: 'ActionInvertColors',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z' })
    );
  }

});

module.exports = ActionInvertColors;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSpeakerNotes = React.createClass({
  displayName: 'ActionSpeakerNotes',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z' })
    );
  }

});

module.exports = ActionSpeakerNotes;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionOpenWith = React.createClass({
  displayName: 'ActionOpenWith',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z' })
    );
  }

});

module.exports = ActionOpenWith;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionHelp = React.createClass({
  displayName: 'ActionHelp',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
    );
  }

});

module.exports = ActionHelp;

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionHourglassEmpty = React.createClass({
  displayName: 'ActionHourglassEmpty',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z' })
    );
  }

});

module.exports = ActionHourglassEmpty;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAssignmentInd = React.createClass({
  displayName: 'ActionAssignmentInd',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z' })
    );
  }

});

module.exports = ActionAssignmentInd;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAssessment = React.createClass({
  displayName: 'ActionAssessment',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
    );
  }

});

module.exports = ActionAssessment;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionCode = React.createClass({
  displayName: 'ActionCode',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z' })
    );
  }

});

module.exports = ActionCode;

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAlarm = React.createClass({
  displayName: 'ActionAlarm',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
    );
  }

});

module.exports = ActionAlarm;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPowerSettingsNew = React.createClass({
  displayName: 'ActionPowerSettingsNew',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z' })
    );
  }

});

module.exports = ActionPowerSettingsNew;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSystemUpdateAlt = React.createClass({
  displayName: 'ActionSystemUpdateAlt',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = ActionSystemUpdateAlt;

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionToll = React.createClass({
  displayName: 'ActionToll',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z' })
    );
  }

});

module.exports = ActionToll;

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionNoteAdd = React.createClass({
  displayName: 'ActionNoteAdd',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z' })
    );
  }

});

module.exports = ActionNoteAdd;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionCardTravel = React.createClass({
  displayName: 'ActionCardTravel',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z' })
    );
  }

});

module.exports = ActionCardTravel;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsRemote = React.createClass({
  displayName: 'ActionSettingsRemote',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z' })
    );
  }

});

module.exports = ActionSettingsRemote;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionBook = React.createClass({
  displayName: 'ActionBook',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z' })
    );
  }

});

module.exports = ActionBook;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionStore = React.createClass({
  displayName: 'ActionStore',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' })
    );
  }

});

module.exports = ActionStore;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSubject = React.createClass({
  displayName: 'ActionSubject',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z' })
    );
  }

});

module.exports = ActionSubject;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionViewCarousel = React.createClass({
  displayName: 'ActionViewCarousel',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z' })
    );
  }

});

module.exports = ActionViewCarousel;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionReorder = React.createClass({
  displayName: 'ActionReorder',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z' })
    );
  }

});

module.exports = ActionReorder;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionVisibility = React.createClass({
  displayName: 'ActionVisibility',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
    );
  }

});

module.exports = ActionVisibility;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAccountBox = React.createClass({
  displayName: 'ActionAccountBox',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z' })
    );
  }

});

module.exports = ActionAccountBox;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionFavorite = React.createClass({
  displayName: 'ActionFavorite',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z' })
    );
  }

});

module.exports = ActionFavorite;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsInputHdmi = React.createClass({
  displayName: 'ActionSettingsInputHdmi',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z' })
    );
  }

});

module.exports = ActionSettingsInputHdmi;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionTurnedIn = React.createClass({
  displayName: 'ActionTurnedIn',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = ActionTurnedIn;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionDescription = React.createClass({
  displayName: 'ActionDescription',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z' })
    );
  }

});

module.exports = ActionDescription;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionHelpOutline = React.createClass({
  displayName: 'ActionHelpOutline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z' })
    );
  }

});

module.exports = ActionHelpOutline;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionTrendingDown = React.createClass({
  displayName: 'ActionTrendingDown',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z' })
    );
  }

});

module.exports = ActionTrendingDown;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionFlightLand = React.createClass({
  displayName: 'ActionFlightLand',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M0 0h24v24H0V0z' })
      ),
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'c', d: 'M0 0h24v24H0V0z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement(
        'clipPath',
        { id: 'd', 'clip-path': 'url(#b)' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { d: 'M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z', 'clip-path': 'url(#d)' })
    );
  }

});

module.exports = ActionFlightLand;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionFlipToFront = React.createClass({
  displayName: 'ActionFlipToFront',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z' })
    );
  }

});

module.exports = ActionFlipToFront;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionToday = React.createClass({
  displayName: 'ActionToday',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z' })
    );
  }

});

module.exports = ActionToday;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionShoppingBasket = React.createClass({
  displayName: 'ActionShoppingBasket',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
    );
  }

});

module.exports = ActionShoppingBasket;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsBrightness = React.createClass({
  displayName: 'ActionSettingsBrightness',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z' })
    );
  }

});

module.exports = ActionSettingsBrightness;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPictureInPicture = React.createClass({
  displayName: 'ActionPictureInPicture',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z' })
    );
  }

});

module.exports = ActionPictureInPicture;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionZoomIn = React.createClass({
  displayName: 'ActionZoomIn',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z' })
    );
  }

});

module.exports = ActionZoomIn;

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionShopTwo = React.createClass({
  displayName: 'ActionShopTwo',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z' })
    );
  }

});

module.exports = ActionShopTwo;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionClass = React.createClass({
  displayName: 'ActionClass',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z' })
    );
  }

});

module.exports = ActionClass;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSwapHoriz = React.createClass({
  displayName: 'ActionSwapHoriz',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z' })
    );
  }

});

module.exports = ActionSwapHoriz;

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPermScanWifi = React.createClass({
  displayName: 'ActionPermScanWifi',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z' })
    );
  }

});

module.exports = ActionPermScanWifi;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionFlightTakeoff = React.createClass({
  displayName: 'ActionFlightTakeoff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M0 0h24v24H0V0z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { d: 'M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z', 'clip-path': 'url(#b)' })
    );
  }

});

module.exports = ActionFlightTakeoff;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionGrade = React.createClass({
  displayName: 'ActionGrade',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
    );
  }

});

module.exports = ActionGrade;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionHome = React.createClass({
  displayName: 'ActionHome',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' })
    );
  }

});

module.exports = ActionHome;

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionBackup = React.createClass({
  displayName: 'ActionBackup',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' })
    );
  }

});

module.exports = ActionBackup;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsInputComponent = React.createClass({
  displayName: 'ActionSettingsInputComponent',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z' })
    );
  }

});

module.exports = ActionSettingsInputComponent;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionTranslate = React.createClass({
  displayName: 'ActionTranslate',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z' })
    );
  }

});

module.exports = ActionTranslate;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsVoice = React.createClass({
  displayName: 'ActionSettingsVoice',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z' })
    );
  }

});

module.exports = ActionSettingsVoice;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionThumbsUpDown = React.createClass({
  displayName: 'ActionThumbsUpDown',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z' })
    );
  }

});

module.exports = ActionThumbsUpDown;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionViewQuilt = React.createClass({
  displayName: 'ActionViewQuilt',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z' })
    );
  }

});

module.exports = ActionViewQuilt;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionDns = React.createClass({
  displayName: 'ActionDns',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
    );
  }

});

module.exports = ActionDns;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionRestore = React.createClass({
  displayName: 'ActionRestore',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' })
    );
  }

});

module.exports = ActionRestore;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsOverscan = React.createClass({
  displayName: 'ActionSettingsOverscan',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
    );
  }

});

module.exports = ActionSettingsOverscan;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionDoneAll = React.createClass({
  displayName: 'ActionDoneAll',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z' })
    );
  }

});

module.exports = ActionDoneAll;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSupervisorAccount = React.createClass({
  displayName: 'ActionSupervisorAccount',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z' })
    );
  }

});

module.exports = ActionSupervisorAccount;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionLanguage = React.createClass({
  displayName: 'ActionLanguage',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z' })
    );
  }

});

module.exports = ActionLanguage;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionPermIdentity = React.createClass({
  displayName: 'ActionPermIdentity',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z' })
    );
  }

});

module.exports = ActionPermIdentity;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionYoutubeSearchedFor = React.createClass({
  displayName: 'ActionYoutubeSearchedFor',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z' })
    );
  }

});

module.exports = ActionYoutubeSearchedFor;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAssignmentReturn = React.createClass({
  displayName: 'ActionAssignmentReturn',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z' })
    );
  }

});

module.exports = ActionAssignmentReturn;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionAnnouncement = React.createClass({
  displayName: 'ActionAnnouncement',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z' })
    );
  }

});

module.exports = ActionAnnouncement;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSettingsPower = React.createClass({
  displayName: 'ActionSettingsPower',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z' })
    );
  }

});

module.exports = ActionSettingsPower;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionRoom = React.createClass({
  displayName: 'ActionRoom',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
    );
  }

});

module.exports = ActionRoom;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionFindReplace = React.createClass({
  displayName: 'ActionFindReplace',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z' })
    );
  }

});

module.exports = ActionFindReplace;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionThreeDRotation = React.createClass({
  displayName: 'ActionThreeDRotation',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z' })
    );
  }

});

module.exports = ActionThreeDRotation;

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionChromeReaderMode = React.createClass({
  displayName: 'ActionChromeReaderMode',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z' })
    );
  }

});

module.exports = ActionChromeReaderMode;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionCameraEnhance = React.createClass({
  displayName: 'ActionCameraEnhance',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zM12 17l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z' })
    );
  }

});

module.exports = ActionCameraEnhance;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionHistory = React.createClass({
  displayName: 'ActionHistory',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { opacity: '.9', d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' })
    );
  }

});

module.exports = ActionHistory;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ActionSpellcheck = React.createClass({
  displayName: 'ActionSpellcheck',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z' })
    );
  }

});

module.exports = ActionSpellcheck;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialNotificationsOff = React.createClass({
  displayName: 'SocialNotificationsOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.5 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zM18 10.5c0-3.07-2.13-5.64-5-6.32V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v.68c-.51.12-.99.32-1.45.56L18 14.18V10.5zm-.27 8.5l2 2L21 19.73 4.27 3 3 4.27l2.92 2.92C5.34 8.16 5 9.29 5 10.5V16l-2 2v1h14.73z' })
    );
  }

});

module.exports = SocialNotificationsOff;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialPersonAdd = React.createClass({
  displayName: 'SocialPersonAdd',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' })
    );
  }

});

module.exports = SocialPersonAdd;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialShare = React.createClass({
  displayName: 'SocialShare',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z' })
    );
  }

});

module.exports = SocialShare;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialGroupAdd = React.createClass({
  displayName: 'SocialGroupAdd',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z' })
    );
  }

});

module.exports = SocialGroupAdd;

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialGroup = React.createClass({
  displayName: 'SocialGroup',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
    );
  }

});

module.exports = SocialGroup;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialNotificationsNone = React.createClass({
  displayName: 'SocialNotificationsNone',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.5 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6.5-6v-5.5c0-3.07-2.13-5.64-5-6.32V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v.68c-2.87.68-5 3.25-5 6.32V16l-2 2v1h17v-1l-2-2zm-2 1H7v-6.5C7 8.01 9.01 6 11.5 6S16 8.01 16 10.5V17z' })
    );
  }

});

module.exports = SocialNotificationsNone;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialMoodBad = React.createClass({
  displayName: 'SocialMoodBad',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z' })
    );
  }

});

module.exports = SocialMoodBad;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialPlusOne = React.createClass({
  displayName: 'SocialPlusOne',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z' })
    );
  }

});

module.exports = SocialPlusOne;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialMood = React.createClass({
  displayName: 'SocialMood',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
    );
  }

});

module.exports = SocialMood;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialPersonOutline = React.createClass({
  displayName: 'SocialPersonOutline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z' })
    );
  }

});

module.exports = SocialPersonOutline;

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialPoll = React.createClass({
  displayName: 'SocialPoll',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
    );
  }

});

module.exports = SocialPoll;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialLocationCity = React.createClass({
  displayName: 'SocialLocationCity',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z' })
    );
  }

});

module.exports = SocialLocationCity;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialPerson = React.createClass({
  displayName: 'SocialPerson',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' })
    );
  }

});

module.exports = SocialPerson;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialPeopleOutline = React.createClass({
  displayName: 'SocialPeopleOutline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z' })
    );
  }

});

module.exports = SocialPeopleOutline;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialCake = React.createClass({
  displayName: 'SocialCake',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z' })
    );
  }

});

module.exports = SocialCake;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialWhatshot = React.createClass({
  displayName: 'SocialWhatshot',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z' })
    );
  }

});

module.exports = SocialWhatshot;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialNotificationsPaused = React.createClass({
  displayName: 'SocialNotificationsPaused',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.5 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6.5-6v-5.5c0-3.07-2.13-5.64-5-6.32V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v.68c-2.87.68-5 3.25-5 6.32V16l-2 2v1h17v-1l-2-2zm-4-6.2l-2.8 3.4H14V15H9v-1.8l2.8-3.4H9V8h5v1.8z' })
    );
  }

});

module.exports = SocialNotificationsPaused;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialPublic = React.createClass({
  displayName: 'SocialPublic',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z' })
    );
  }

});

module.exports = SocialPublic;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialPages = React.createClass({
  displayName: 'SocialPages',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = SocialPages;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialPeople = React.createClass({
  displayName: 'SocialPeople',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
    );
  }

});

module.exports = SocialPeople;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialNotifications = React.createClass({
  displayName: 'SocialNotifications',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.5 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6.5-6v-5.5c0-3.07-2.13-5.64-5-6.32V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v.68c-2.87.68-5 3.25-5 6.32V16l-2 2v1h17v-1l-2-2z' })
    );
  }

});

module.exports = SocialNotifications;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialNotificationsActive = React.createClass({
  displayName: 'SocialNotificationsActive',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6.58 3.58L5.15 2.15C2.76 3.97 1.18 6.8 1.03 10h2c.15-2.65 1.51-4.97 3.55-6.42zM19.97 10h2c-.15-3.2-1.73-6.03-4.13-7.85l-1.43 1.43c2.05 1.45 3.41 3.77 3.56 6.42zm-1.97.5c0-3.07-2.13-5.64-5-6.32V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v.68c-2.87.68-5 3.25-5 6.32V16l-2 2v1h17v-1l-2-2v-5.5zM11.5 22c.14 0 .27-.01.4-.04.65-.13 1.19-.58 1.44-1.18.1-.24.16-.5.16-.78h-4c0 1.1.9 2 2 2z' })
    );
  }

});

module.exports = SocialNotificationsActive;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialSchool = React.createClass({
  displayName: 'SocialSchool',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z' })
    );
  }

});

module.exports = SocialSchool;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialDomain = React.createClass({
  displayName: 'SocialDomain',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
    );
  }

});

module.exports = SocialDomain;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var SocialPartyMode = React.createClass({
  displayName: 'SocialPartyMode',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z' })
    );
  }

});

module.exports = SocialPartyMode;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvNotInterested = React.createClass({
  displayName: 'AvNotInterested',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z' })
    );
  }

});

module.exports = AvNotInterested;

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvPauseCircleOutline = React.createClass({
  displayName: 'AvPauseCircleOutline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z' })
    );
  }

});

module.exports = AvPauseCircleOutline;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvNewReleases = React.createClass({
  displayName: 'AvNewReleases',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z' })
    );
  }

});

module.exports = AvNewReleases;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvMic = React.createClass({
  displayName: 'AvMic',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
    );
  }

});

module.exports = AvMic;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvSkipPrevious = React.createClass({
  displayName: 'AvSkipPrevious',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 6h2v12H6zm3.5 6l8.5 6V6z' })
    );
  }

});

module.exports = AvSkipPrevious;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvReplay5 = React.createClass({
  displayName: 'AvReplay5',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M0 0h24v24H0V0z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.3 8.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.4.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.7z', 'clip-path': 'url(#b)' })
    );
  }

});

module.exports = AvReplay5;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvMovie = React.createClass({
  displayName: 'AvMovie',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' })
    );
  }

});

module.exports = AvMovie;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvForward10 = React.createClass({
  displayName: 'AvForward10',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M24 24H0V0h24v24z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z', 'clip-path': 'url(#b)' })
    );
  }

});

module.exports = AvForward10;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvGames = React.createClass({
  displayName: 'AvGames',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z' })
    );
  }

});

module.exports = AvGames;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvHighQuality = React.createClass({
  displayName: 'AvHighQuality',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z' })
    );
  }

});

module.exports = AvHighQuality;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvExplicit = React.createClass({
  displayName: 'AvExplicit',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z' })
    );
  }

});

module.exports = AvExplicit;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvHd = React.createClass({
  displayName: 'AvHd',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z' })
    );
  }

});

module.exports = AvHd;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvAlbum = React.createClass({
  displayName: 'AvAlbum',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z' })
    );
  }

});

module.exports = AvAlbum;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvRepeatOne = React.createClass({
  displayName: 'AvRepeatOne',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z' })
    );
  }

});

module.exports = AvRepeatOne;

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvSkipNext = React.createClass({
  displayName: 'AvSkipNext',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z' })
    );
  }

});

module.exports = AvSkipNext;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvLibraryBooks = React.createClass({
  displayName: 'AvLibraryBooks',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z' })
    );
  }

});

module.exports = AvLibraryBooks;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvVolumeMute = React.createClass({
  displayName: 'AvVolumeMute',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 9v6h4l5 5V4l-5 5H7z' })
    );
  }

});

module.exports = AvVolumeMute;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvLibraryMusic = React.createClass({
  displayName: 'AvLibraryMusic',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z' })
    );
  }

});

module.exports = AvLibraryMusic;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvPlayArrow = React.createClass({
  displayName: 'AvPlayArrow',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M8 5v14l11-7z' })
    );
  }

});

module.exports = AvPlayArrow;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvRadio = React.createClass({
  displayName: 'AvRadio',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z' })
    );
  }

});

module.exports = AvRadio;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvFastRewind = React.createClass({
  displayName: 'AvFastRewind',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z' })
    );
  }

});

module.exports = AvFastRewind;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvReplay = React.createClass({
  displayName: 'AvReplay',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z' })
    );
  }

});

module.exports = AvReplay;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvHearing = React.createClass({
  displayName: 'AvHearing',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z' })
    );
  }

});

module.exports = AvHearing;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvPause = React.createClass({
  displayName: 'AvPause',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z' })
    );
  }

});

module.exports = AvPause;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvEqualizer = React.createClass({
  displayName: 'AvEqualizer',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z' })
    );
  }

});

module.exports = AvEqualizer;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvVolumeUp = React.createClass({
  displayName: 'AvVolumeUp',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z' })
    );
  }

});

module.exports = AvVolumeUp;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvFastForward = React.createClass({
  displayName: 'AvFastForward',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z' })
    );
  }

});

module.exports = AvFastForward;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvSurroundSound = React.createClass({
  displayName: 'AvSurroundSound',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41C4.78 16.1 4 14.05 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41C19.22 7.9 20 9.95 20 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
    );
  }

});

module.exports = AvSurroundSound;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvForward30 = React.createClass({
  displayName: 'AvForward30',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M24 24H0V0h24v24z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { d: 'M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z', 'clip-path': 'url(#b)' })
    );
  }

});

module.exports = AvForward30;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvQueueMusic = React.createClass({
  displayName: 'AvQueueMusic',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z' })
    );
  }

});

module.exports = AvQueueMusic;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvReplay30 = React.createClass({
  displayName: 'AvReplay30',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M0 0h24v24H0V0z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-2.4 8.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5c0-.1-.1-.2-.1-.3s-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z', 'clip-path': 'url(#b)' })
    );
  }

});

module.exports = AvReplay30;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvSortByAlpha = React.createClass({
  displayName: 'AvSortByAlpha',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z' })
    );
  }

});

module.exports = AvSortByAlpha;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvSubtitles = React.createClass({
  displayName: 'AvSubtitles',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z' })
    );
  }

});

module.exports = AvSubtitles;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvClosedCaption = React.createClass({
  displayName: 'AvClosedCaption',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z' })
    );
  }

});

module.exports = AvClosedCaption;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvVideoLibrary = React.createClass({
  displayName: 'AvVideoLibrary',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z' })
    );
  }

});

module.exports = AvVideoLibrary;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvWeb = React.createClass({
  displayName: 'AvWeb',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z' })
    );
  }

});

module.exports = AvWeb;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvMicNone = React.createClass({
  displayName: 'AvMicNone',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
    );
  }

});

module.exports = AvMicNone;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvShuffle = React.createClass({
  displayName: 'AvShuffle',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z' })
    );
  }

});

module.exports = AvShuffle;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvStop = React.createClass({
  displayName: 'AvStop',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 6h12v12H6z' })
    );
  }

});

module.exports = AvStop;

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvPlayCircleOutline = React.createClass({
  displayName: 'AvPlayCircleOutline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
    );
  }

});

module.exports = AvPlayCircleOutline;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvVideocamOff = React.createClass({
  displayName: 'AvVideocamOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z' })
    );
  }

});

module.exports = AvVideocamOff;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvQueue = React.createClass({
  displayName: 'AvQueue',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
    );
  }

});

module.exports = AvQueue;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvVolumeDown = React.createClass({
  displayName: 'AvVolumeDown',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z' })
    );
  }

});

module.exports = AvVolumeDown;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvVideocam = React.createClass({
  displayName: 'AvVideocam',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z' })
    );
  }

});

module.exports = AvVideocam;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvRepeat = React.createClass({
  displayName: 'AvRepeat',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z' })
    );
  }

});

module.exports = AvRepeat;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvRecentActors = React.createClass({
  displayName: 'AvRecentActors',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z' })
    );
  }

});

module.exports = AvRecentActors;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvForward5 = React.createClass({
  displayName: 'AvForward5',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M24 24H0V0h24v24z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.7.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.5.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.6z', 'clip-path': 'url(#b)' })
    );
  }

});

module.exports = AvForward5;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvLoop = React.createClass({
  displayName: 'AvLoop',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
    );
  }

});

module.exports = AvLoop;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvLibraryAdd = React.createClass({
  displayName: 'AvLibraryAdd',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
    );
  }

});

module.exports = AvLibraryAdd;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvPlayCircleFilled = React.createClass({
  displayName: 'AvPlayCircleFilled',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z' })
    );
  }

});

module.exports = AvPlayCircleFilled;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvPlaylistAdd = React.createClass({
  displayName: 'AvPlaylistAdd',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z' })
    );
  }

});

module.exports = AvPlaylistAdd;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvMicOff = React.createClass({
  displayName: 'AvMicOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z' })
    );
  }

});

module.exports = AvMicOff;

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvReplay10 = React.createClass({
  displayName: 'AvReplay10',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M0 0h24v24H0V0z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z', 'clip-path': 'url(#b)' })
    );
  }

});

module.exports = AvReplay10;

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvAvTimer = React.createClass({
  displayName: 'AvAvTimer',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z' })
    );
  }

});

module.exports = AvAvTimer;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvVolumeOff = React.createClass({
  displayName: 'AvVolumeOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z' })
    );
  }

});

module.exports = AvVolumeOff;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvPauseCircleFilled = React.createClass({
  displayName: 'AvPauseCircleFilled',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z' })
    );
  }

});

module.exports = AvPauseCircleFilled;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvAirplay = React.createClass({
  displayName: 'AvAirplay',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M0 0h24v24H0V0z' })
      ),
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'c', d: 'M0 0h24v24H0V0z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement(
        'clipPath',
        { id: 'd', 'clip-path': 'url(#b)' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { d: 'M6 22h12l-6-6zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z', 'clip-path': 'url(#d)' })
    );
  }

});

module.exports = AvAirplay;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AvSnooze = React.createClass({
  displayName: 'AvSnooze',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z' })
    );
  }

});

module.exports = AvSnooze;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBrush = React.createClass({
  displayName: 'ImageBrush',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z' })
    );
  }

});

module.exports = ImageBrush;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageLooksOne = React.createClass({
  displayName: 'ImageLooksOne',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z' })
    );
  }

});

module.exports = ImageLooksOne;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageDetails = React.createClass({
  displayName: 'ImageDetails',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z' })
    );
  }

});

module.exports = ImageDetails;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageTimer3 = React.createClass({
  displayName: 'ImageTimer3',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39s.03-.28.09-.41c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z' })
    );
  }

});

module.exports = ImageTimer3;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilterNone = React.createClass({
  displayName: 'ImageFilterNone',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
    );
  }

});

module.exports = ImageFilterNone;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageLooks3 = React.createClass({
  displayName: 'ImageLooks3',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4c1.1 0 2 .89 2 2v1.5z' })
    );
  }

});

module.exports = ImageLooks3;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilter9 = React.createClass({
  displayName: 'ImageFilter9',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2zm0 4h-2V7h2v2z' })
    );
  }

});

module.exports = ImageFilter9;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilter = React.createClass({
  displayName: 'ImageFilter',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
    );
  }

});

module.exports = ImageFilter;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageAssistantPhoto = React.createClass({
  displayName: 'ImageAssistantPhoto',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z' })
    );
  }

});

module.exports = ImageAssistantPhoto;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageWbCloudy = React.createClass({
  displayName: 'ImageWbCloudy',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z' })
    );
  }

});

module.exports = ImageWbCloudy;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBrightness1 = React.createClass({
  displayName: 'ImageBrightness1',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('circle', { cx: '12', cy: '12', r: '10' })
    );
  }

});

module.exports = ImageBrightness1;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePanoramaWideAngle = React.createClass({
  displayName: 'ImagePanoramaWideAngle',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z' })
    );
  }

});

module.exports = ImagePanoramaWideAngle;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePanoramaFishEye = React.createClass({
  displayName: 'ImagePanoramaFishEye',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
    );
  }

});

module.exports = ImagePanoramaFishEye;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePortrait = React.createClass({
  displayName: 'ImagePortrait',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
    );
  }

});

module.exports = ImagePortrait;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBrightness5 = React.createClass({
  displayName: 'ImageBrightness5',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
    );
  }

});

module.exports = ImageBrightness5;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageExposureZero = React.createClass({
  displayName: 'ImageExposureZero',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z' })
    );
  }

});

module.exports = ImageExposureZero;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageExposureNeg2 = React.createClass({
  displayName: 'ImageExposureNeg2',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z' })
    );
  }

});

module.exports = ImageExposureNeg2;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageWbAuto = React.createClass({
  displayName: 'ImageWbAuto',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z' })
    );
  }

});

module.exports = ImageWbAuto;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageHdrOff = React.createClass({
  displayName: 'ImageHdrOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z' })
    );
  }

});

module.exports = ImageHdrOff;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageNaturePeople = React.createClass({
  displayName: 'ImageNaturePeople',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z' })
    );
  }

});

module.exports = ImageNaturePeople;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageAudiotrack = React.createClass({
  displayName: 'ImageAudiotrack',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z' })
    );
  }

});

module.exports = ImageAudiotrack;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCropPortrait = React.createClass({
  displayName: 'ImageCropPortrait',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z' })
    );
  }

});

module.exports = ImageCropPortrait;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageColorize = React.createClass({
  displayName: 'ImageColorize',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z' })
    );
  }

});

module.exports = ImageColorize;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCompare = React.createClass({
  displayName: 'ImageCompare',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = ImageCompare;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilter2 = React.createClass({
  displayName: 'ImageFilter2',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z' })
    );
  }

});

module.exports = ImageFilter2;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageTagFaces = React.createClass({
  displayName: 'ImageTagFaces',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
    );
  }

});

module.exports = ImageTagFaces;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBlurCircular = React.createClass({
  displayName: 'ImageBlurCircular',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z' })
    );
  }

});

module.exports = ImageBlurCircular;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageLens = React.createClass({
  displayName: 'ImageLens',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z' })
    );
  }

});

module.exports = ImageLens;

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageTune = React.createClass({
  displayName: 'ImageTune',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z' })
    );
  }

});

module.exports = ImageTune;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageViewComfy = React.createClass({
  displayName: 'ImageViewComfy',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z' })
    );
  }

});

module.exports = ImageViewComfy;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCameraRoll = React.createClass({
  displayName: 'ImageCameraRoll',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z' })
    );
  }

});

module.exports = ImageCameraRoll;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCenterFocusStrong = React.createClass({
  displayName: 'ImageCenterFocusStrong',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z' })
    );
  }

});

module.exports = ImageCenterFocusStrong;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFlashOff = React.createClass({
  displayName: 'ImageFlashOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z' })
    );
  }

});

module.exports = ImageFlashOff;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCollectionsBookmark = React.createClass({
  displayName: 'ImageCollectionsBookmark',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zM20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z' })
    );
  }

});

module.exports = ImageCollectionsBookmark;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePhotoSizeSelectActual = React.createClass({
  displayName: 'ImagePhotoSizeSelectActual',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z' })
    );
  }

});

module.exports = ImagePhotoSizeSelectActual;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageImageAspectRatio = React.createClass({
  displayName: 'ImageImageAspectRatio',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z' })
    );
  }

});

module.exports = ImageImageAspectRatio;

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilterHdr = React.createClass({
  displayName: 'ImageFilterHdr',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
    );
  }

});

module.exports = ImageFilterHdr;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageRotateRight = React.createClass({
  displayName: 'ImageRotateRight',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z' })
    );
  }

});

module.exports = ImageRotateRight;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilterTiltShift = React.createClass({
  displayName: 'ImageFilterTiltShift',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z' })
    );
  }

});

module.exports = ImageFilterTiltShift;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCropFree = React.createClass({
  displayName: 'ImageCropFree',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = ImageCropFree;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageStyle = React.createClass({
  displayName: 'ImageStyle',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z' })
    );
  }

});

module.exports = ImageStyle;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageNature = React.createClass({
  displayName: 'ImageNature',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z' })
    );
  }

});

module.exports = ImageNature;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePhotoSizeSelectLarge = React.createClass({
  displayName: 'ImagePhotoSizeSelectLarge',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z' })
    );
  }

});

module.exports = ImagePhotoSizeSelectLarge;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageAdjust = React.createClass({
  displayName: 'ImageAdjust',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z' })
    );
  }

});

module.exports = ImageAdjust;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFlare = React.createClass({
  displayName: 'ImageFlare',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z' })
    );
  }

});

module.exports = ImageFlare;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageWbIridescent = React.createClass({
  displayName: 'ImageWbIridescent',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z' })
    );
  }

});

module.exports = ImageWbIridescent;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilterDrama = React.createClass({
  displayName: 'ImageFilterDrama',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z' })
    );
  }

});

module.exports = ImageFilterDrama;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBrightness7 = React.createClass({
  displayName: 'ImageBrightness7',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z' })
    );
  }

});

module.exports = ImageBrightness7;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBlurOn = React.createClass({
  displayName: 'ImageBlurOn',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z' })
    );
  }

});

module.exports = ImageBlurOn;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageTimer10 = React.createClass({
  displayName: 'ImageTimer10',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z' })
    );
  }

});

module.exports = ImageTimer10;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFlashOn = React.createClass({
  displayName: 'ImageFlashOn',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 2v11h3v9l7-12h-4l4-8z' })
    );
  }

});

module.exports = ImageFlashOn;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePhotoLibrary = React.createClass({
  displayName: 'ImagePhotoLibrary',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z' })
    );
  }

});

module.exports = ImagePhotoLibrary;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBlurLinear = React.createClass({
  displayName: 'ImageBlurLinear',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z' })
    );
  }

});

module.exports = ImageBlurLinear;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCamera = React.createClass({
  displayName: 'ImageCamera',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z' })
    );
  }

});

module.exports = ImageCamera;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageTimelapse = React.createClass({
  displayName: 'ImageTimelapse',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
    );
  }

});

module.exports = ImageTimelapse;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageLoupe = React.createClass({
  displayName: 'ImageLoupe',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
    );
  }

});

module.exports = ImageLoupe;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageExposurePlus1 = React.createClass({
  displayName: 'ImageExposurePlus1',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z' })
    );
  }

});

module.exports = ImageExposurePlus1;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageExposurePlus2 = React.createClass({
  displayName: 'ImageExposurePlus2',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z' })
    );
  }

});

module.exports = ImageExposurePlus2;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFlashAuto = React.createClass({
  displayName: 'ImageFlashAuto',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z' })
    );
  }

});

module.exports = ImageFlashAuto;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePalette = React.createClass({
  displayName: 'ImagePalette',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
    );
  }

});

module.exports = ImagePalette;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCropDin = React.createClass({
  displayName: 'ImageCropDin',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
    );
  }

});

module.exports = ImageCropDin;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCrop169 = React.createClass({
  displayName: 'ImageCrop169',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z' })
    );
  }

});

module.exports = ImageCrop169;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageSlideshow = React.createClass({
  displayName: 'ImageSlideshow',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
    );
  }

});

module.exports = ImageSlideshow;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilter1 = React.createClass({
  displayName: 'ImageFilter1',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
    );
  }

});

module.exports = ImageFilter1;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCrop75 = React.createClass({
  displayName: 'ImageCrop75',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z' })
    );
  }

});

module.exports = ImageCrop75;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageMusicNote = React.createClass({
  displayName: 'ImageMusicNote',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z' })
    );
  }

});

module.exports = ImageMusicNote;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCropLandscape = React.createClass({
  displayName: 'ImageCropLandscape',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' })
    );
  }

});

module.exports = ImageCropLandscape;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCrop32 = React.createClass({
  displayName: 'ImageCrop32',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z' })
    );
  }

});

module.exports = ImageCrop32;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageTimer = React.createClass({
  displayName: 'ImageTimer',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
    );
  }

});

module.exports = ImageTimer;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageWbIncandescent = React.createClass({
  displayName: 'ImageWbIncandescent',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z' })
    );
  }

});

module.exports = ImageWbIncandescent;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageLooks5 = React.createClass({
  displayName: 'ImageLooks5',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z' })
    );
  }

});

module.exports = ImageLooks5;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageGradient = React.createClass({
  displayName: 'ImageGradient',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z' })
    );
  }

});

module.exports = ImageGradient;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageViewCompact = React.createClass({
  displayName: 'ImageViewCompact',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z' })
    );
  }

});

module.exports = ImageViewCompact;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCenterFocusWeak = React.createClass({
  displayName: 'ImageCenterFocusWeak',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
    );
  }

});

module.exports = ImageCenterFocusWeak;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageLooks = React.createClass({
  displayName: 'ImageLooks',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z' })
    );
  }

});

module.exports = ImageLooks;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCollections = React.createClass({
  displayName: 'ImageCollections',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z' })
    );
  }

});

module.exports = ImageCollections;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageMonochromePhotos = React.createClass({
  displayName: 'ImageMonochromePhotos',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z' })
    );
  }

});

module.exports = ImageMonochromePhotos;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBlurOff = React.createClass({
  displayName: 'ImageBlurOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z' })
    );
  }

});

module.exports = ImageBlurOff;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePhotoSizeSelectSmall = React.createClass({
  displayName: 'ImagePhotoSizeSelectSmall',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z' })
    );
  }

});

module.exports = ImagePhotoSizeSelectSmall;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilter6 = React.createClass({
  displayName: 'ImageFilter6',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2z' })
    );
  }

});

module.exports = ImageFilter6;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCameraRear = React.createClass({
  displayName: 'ImageCameraRear',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z' })
    );
  }

});

module.exports = ImageCameraRear;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageRotateLeft = React.createClass({
  displayName: 'ImageRotateLeft',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z' })
    );
  }

});

module.exports = ImageRotateLeft;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilter7 = React.createClass({
  displayName: 'ImageFilter7',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z' })
    );
  }

});

module.exports = ImageFilter7;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageEdit = React.createClass({
  displayName: 'ImageEdit',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
    );
  }

});

module.exports = ImageEdit;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilter9Plus = React.createClass({
  displayName: 'ImageFilter9Plus',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z' })
    );
  }

});

module.exports = ImageFilter9Plus;

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageLeakRemove = React.createClass({
  displayName: 'ImageLeakRemove',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46C18.09 12.37 19.5 12 21 12v-2c-2.06 0-3.98.58-5.62 1.56z' })
    );
  }

});

module.exports = ImageLeakRemove;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageTexture = React.createClass({
  displayName: 'ImageTexture',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z' })
    );
  }

});

module.exports = ImageTexture;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBrightness6 = React.createClass({
  displayName: 'ImageBrightness6',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
    );
  }

});

module.exports = ImageBrightness6;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCropOriginal = React.createClass({
  displayName: 'ImageCropOriginal',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z' })
    );
  }

});

module.exports = ImageCropOriginal;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageNavigateNext = React.createClass({
  displayName: 'ImageNavigateNext',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
    );
  }

});

module.exports = ImageNavigateNext;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilterCenterFocus = React.createClass({
  displayName: 'ImageFilterCenterFocus',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
    );
  }

});

module.exports = ImageFilterCenterFocus;

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageAssistant = React.createClass({
  displayName: 'ImageAssistant',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z' })
    );
  }

});

module.exports = ImageAssistant;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFlip = React.createClass({
  displayName: 'ImageFlip',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z' })
    );
  }

});

module.exports = ImageFlip;

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCropSquare = React.createClass({
  displayName: 'ImageCropSquare',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z' })
    );
  }

});

module.exports = ImageCropSquare;

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageVignette = React.createClass({
  displayName: 'ImageVignette',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z' })
    );
  }

});

module.exports = ImageVignette;

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageExposure = React.createClass({
  displayName: 'ImageExposure',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 17v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2zm5-15H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 5h6v2H5V5zm15 15H4L20 4v16z' })
    );
  }

});

module.exports = ImageExposure;

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePanoramaHorizontal = React.createClass({
  displayName: 'ImagePanoramaHorizontal',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z' })
    );
  }

});

module.exports = ImagePanoramaHorizontal;

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePanorama = React.createClass({
  displayName: 'ImagePanorama',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z' })
    );
  }

});

module.exports = ImagePanorama;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCrop = React.createClass({
  displayName: 'ImageCrop',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z' })
    );
  }

});

module.exports = ImageCrop;

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageControlPoint = React.createClass({
  displayName: 'ImageControlPoint',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
    );
  }

});

module.exports = ImageControlPoint;

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageRotate90DegreesCcw = React.createClass({
  displayName: 'ImageRotate90DegreesCcw',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z' })
    );
  }

});

module.exports = ImageRotate90DegreesCcw;

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilterBAndW = React.createClass({
  displayName: 'ImageFilterBAndW',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z' })
    );
  }

});

module.exports = ImageFilterBAndW;

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageGridOff = React.createClass({
  displayName: 'ImageGridOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z' })
    );
  }

});

module.exports = ImageGridOff;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBrightness3 = React.createClass({
  displayName: 'ImageBrightness3',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z' })
    );
  }

});

module.exports = ImageBrightness3;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilter8 = React.createClass({
  displayName: 'ImageFilter8',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z' })
    );
  }

});

module.exports = ImageFilter8;

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageLeakAdd = React.createClass({
  displayName: 'ImageLeakAdd',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z' })
    );
  }

});

module.exports = ImageLeakAdd;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageRemoveRedEye = React.createClass({
  displayName: 'ImageRemoveRedEye',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
    );
  }

});

module.exports = ImageRemoveRedEye;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePhotoCamera = React.createClass({
  displayName: 'ImagePhotoCamera',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
      React.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
    );
  }

});

module.exports = ImagePhotoCamera;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageStraighten = React.createClass({
  displayName: 'ImageStraighten',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z' })
    );
  }

});

module.exports = ImageStraighten;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilter4 = React.createClass({
  displayName: 'ImageFilter4',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
    );
  }

});

module.exports = ImageFilter4;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageGridOn = React.createClass({
  displayName: 'ImageGridOn',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z' })
    );
  }

});

module.exports = ImageGridOn;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilter3 = React.createClass({
  displayName: 'ImageFilter3',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2z' })
    );
  }

});

module.exports = ImageFilter3;

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageLandscape = React.createClass({
  displayName: 'ImageLandscape',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
    );
  }

});

module.exports = ImageLandscape;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilterFrames = React.createClass({
  displayName: 'ImageFilterFrames',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12' })
    );
  }

});

module.exports = ImageFilterFrames;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageIso = React.createClass({
  displayName: 'ImageIso',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z' })
    );
  }

});

module.exports = ImageIso;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageTonality = React.createClass({
  displayName: 'ImageTonality',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z' })
    );
  }

});

module.exports = ImageTonality;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageDehaze = React.createClass({
  displayName: 'ImageDehaze',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z' })
    );
  }

});

module.exports = ImageDehaze;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageHdrStrong = React.createClass({
  displayName: 'ImageHdrStrong',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
    );
  }

});

module.exports = ImageHdrStrong;

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageHealing = React.createClass({
  displayName: 'ImageHealing',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34c-.39-.39-1.02-.39-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z' })
    );
  }

});

module.exports = ImageHealing;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageHdrWeak = React.createClass({
  displayName: 'ImageHdrWeak',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' })
    );
  }

});

module.exports = ImageHdrWeak;

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilterVintage = React.createClass({
  displayName: 'ImageFilterVintage',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' })
    );
  }

});

module.exports = ImageFilterVintage;

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageFilter5 = React.createClass({
  displayName: 'ImageFilter5',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z' })
    );
  }

});

module.exports = ImageFilter5;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageImage = React.createClass({
  displayName: 'ImageImage',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
    );
  }

});

module.exports = ImageImage;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageColorLens = React.createClass({
  displayName: 'ImageColorLens',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
    );
  }

});

module.exports = ImageColorLens;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageLooks4 = React.createClass({
  displayName: 'ImageLooks4',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z' })
    );
  }

});

module.exports = ImageLooks4;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePanoramaVertical = React.createClass({
  displayName: 'ImagePanoramaVertical',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z' })
    );
  }

});

module.exports = ImagePanoramaVertical;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBrightness4 = React.createClass({
  displayName: 'ImageBrightness4',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
    );
  }

});

module.exports = ImageBrightness4;

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageLooks6 = React.createClass({
  displayName: 'ImageLooks6',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z' })
    );
  }

});

module.exports = ImageLooks6;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageControlPointDuplicate = React.createClass({
  displayName: 'ImageControlPointDuplicate',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z' })
    );
  }

});

module.exports = ImageControlPointDuplicate;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCrop54 = React.createClass({
  displayName: 'ImageCrop54',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' })
    );
  }

});

module.exports = ImageCrop54;

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageHdrOn = React.createClass({
  displayName: 'ImageHdrOn',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z' })
    );
  }

});

module.exports = ImageHdrOn;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePhotoAlbum = React.createClass({
  displayName: 'ImagePhotoAlbum',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z' })
    );
  }

});

module.exports = ImagePhotoAlbum;

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageNavigateBefore = React.createClass({
  displayName: 'ImageNavigateBefore',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
    );
  }

});

module.exports = ImageNavigateBefore;

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageSwitchVideo = React.createClass({
  displayName: 'ImageSwitchVideo',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z' })
    );
  }

});

module.exports = ImageSwitchVideo;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageWbSunny = React.createClass({
  displayName: 'ImageWbSunny',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z' })
    );
  }

});

module.exports = ImageWbSunny;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageAddToPhotos = React.createClass({
  displayName: 'ImageAddToPhotos',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
    );
  }

});

module.exports = ImageAddToPhotos;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePhoto = React.createClass({
  displayName: 'ImagePhoto',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
    );
  }

});

module.exports = ImagePhoto;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBrokenImage = React.createClass({
  displayName: 'ImageBrokenImage',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z' })
    );
  }

});

module.exports = ImageBrokenImage;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImagePictureAsPdf = React.createClass({
  displayName: 'ImagePictureAsPdf',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z' })
    );
  }

});

module.exports = ImagePictureAsPdf;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageTransform = React.createClass({
  displayName: 'ImageTransform',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z' })
    );
  }

});

module.exports = ImageTransform;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCameraAlt = React.createClass({
  displayName: 'ImageCameraAlt',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
      React.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
    );
  }

});

module.exports = ImageCameraAlt;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageBrightness2 = React.createClass({
  displayName: 'ImageBrightness2',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z' })
    );
  }

});

module.exports = ImageBrightness2;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageMovieCreation = React.createClass({
  displayName: 'ImageMovieCreation',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' })
    );
  }

});

module.exports = ImageMovieCreation;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageGrain = React.createClass({
  displayName: 'ImageGrain',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
    );
  }

});

module.exports = ImageGrain;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageLooksTwo = React.createClass({
  displayName: 'ImageLooksTwo',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z' })
    );
  }

});

module.exports = ImageLooksTwo;

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageTimerOff = React.createClass({
  displayName: 'ImageTimerOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.04 4.55l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.83 0-3.53.55-4.95 1.48l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45C20.45 16.53 21 14.83 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03C3.55 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z' })
    );
  }

});

module.exports = ImageTimerOff;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageExposureNeg1 = React.createClass({
  displayName: 'ImageExposureNeg1',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z' })
    );
  }

});

module.exports = ImageExposureNeg1;

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageCameraFront = React.createClass({
  displayName: 'ImageCameraFront',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z' })
    );
  }

});

module.exports = ImageCameraFront;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ImageSwitchCamera = React.createClass({
  displayName: 'ImageSwitchCamera',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z' })
    );
  }

});

module.exports = ImageSwitchCamera;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentForward = React.createClass({
  displayName: 'ContentForward',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 8V4l8 8-8 8v-4H4V8z' })
    );
  }

});

module.exports = ContentForward;

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentSelectAll = React.createClass({
  displayName: 'ContentSelectAll',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z' })
    );
  }

});

module.exports = ContentSelectAll;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentDrafts = React.createClass({
  displayName: 'ContentDrafts',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z' })
    );
  }

});

module.exports = ContentDrafts;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentContentCopy = React.createClass({
  displayName: 'ContentContentCopy',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' })
    );
  }

});

module.exports = ContentContentCopy;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentFlag = React.createClass({
  displayName: 'ContentFlag',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z' })
    );
  }

});

module.exports = ContentFlag;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentTextFormat = React.createClass({
  displayName: 'ContentTextFormat',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z' })
    );
  }

});

module.exports = ContentTextFormat;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentReplyAll = React.createClass({
  displayName: 'ContentReplyAll',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
    );
  }

});

module.exports = ContentReplyAll;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentReply = React.createClass({
  displayName: 'ContentReply',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
    );
  }

});

module.exports = ContentReply;

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentRemoveCircle = React.createClass({
  displayName: 'ContentRemoveCircle',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z' })
    );
  }

});

module.exports = ContentRemoveCircle;

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentAddCircle = React.createClass({
  displayName: 'ContentAddCircle',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
    );
  }

});

module.exports = ContentAddCircle;

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentLink = React.createClass({
  displayName: 'ContentLink',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
    );
  }

});

module.exports = ContentLink;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentMail = React.createClass({
  displayName: 'ContentMail',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
    );
  }

});

module.exports = ContentMail;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentArchive = React.createClass({
  displayName: 'ContentArchive',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z' })
    );
  }

});

module.exports = ContentArchive;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentSave = React.createClass({
  displayName: 'ContentSave',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z' })
    );
  }

});

module.exports = ContentSave;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentRemove = React.createClass({
  displayName: 'ContentRemove',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 13H5v-2h14v2z' })
    );
  }

});

module.exports = ContentRemove;

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentFontDownload = React.createClass({
  displayName: 'ContentFontDownload',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z' })
    );
  }

});

module.exports = ContentFontDownload;

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentRemoveCircleOutline = React.createClass({
  displayName: 'ContentRemoveCircleOutline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
    );
  }

});

module.exports = ContentRemoveCircleOutline;

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentCreate = React.createClass({
  displayName: 'ContentCreate',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
    );
  }

});

module.exports = ContentCreate;

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentClear = React.createClass({
  displayName: 'ContentClear',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
    );
  }

});

module.exports = ContentClear;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentContentCut = React.createClass({
  displayName: 'ContentContentCut',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z' })
    );
  }

});

module.exports = ContentContentCut;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentRedo = React.createClass({
  displayName: 'ContentRedo',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z' })
    );
  }

});

module.exports = ContentRedo;

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentMarkunread = React.createClass({
  displayName: 'ContentMarkunread',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
    );
  }

});

module.exports = ContentMarkunread;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentContentPaste = React.createClass({
  displayName: 'ContentContentPaste',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z' })
    );
  }

});

module.exports = ContentContentPaste;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentBackspace = React.createClass({
  displayName: 'ContentBackspace',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z' })
    );
  }

});

module.exports = ContentBackspace;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentReport = React.createClass({
  displayName: 'ContentReport',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z' })
    );
  }

});

module.exports = ContentReport;

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentSort = React.createClass({
  displayName: 'ContentSort',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z' })
    );
  }

});

module.exports = ContentSort;

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentInbox = React.createClass({
  displayName: 'ContentInbox',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H4.99c-1.1 0-1.98.9-1.98 2L3 19c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.34 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z' })
    );
  }

});

module.exports = ContentInbox;

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentGesture = React.createClass({
  displayName: 'ContentGesture',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z' })
    );
  }

});

module.exports = ContentGesture;

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentBlock = React.createClass({
  displayName: 'ContentBlock',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z' })
    );
  }

});

module.exports = ContentBlock;

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentAdd = React.createClass({
  displayName: 'ContentAdd',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' })
    );
  }

});

module.exports = ContentAdd;

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentUndo = React.createClass({
  displayName: 'ContentUndo',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z' })
    );
  }

});

module.exports = ContentUndo;

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentAddBox = React.createClass({
  displayName: 'ContentAddBox',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
    );
  }

});

module.exports = ContentAddBox;

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentAddCircleOutline = React.createClass({
  displayName: 'ContentAddCircleOutline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
    );
  }

});

module.exports = ContentAddCircleOutline;

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentFilterList = React.createClass({
  displayName: 'ContentFilterList',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z' })
    );
  }

});

module.exports = ContentFilterList;

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var ContentSend = React.createClass({
  displayName: 'ContentSend',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M2.01 21L23 12 2.01 3 2 10l15 2-15 2z' })
    );
  }

});

module.exports = ContentSend;

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationSyncProblem = React.createClass({
  displayName: 'NotificationSyncProblem',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z' })
    );
  }

});

module.exports = NotificationSyncProblem;

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationAirlineSeatIndividualSuite = React.createClass({
  displayName: 'NotificationAirlineSeatIndividualSuite',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z' })
    );
  }

});

module.exports = NotificationAirlineSeatIndividualSuite;

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationVpnLock = React.createClass({
  displayName: 'NotificationVpnLock',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z' })
    );
  }

});

module.exports = NotificationVpnLock;

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationAirlineSeatLegroomExtra = React.createClass({
  displayName: 'NotificationAirlineSeatLegroomExtra',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98c-.34-.68-1.03-1.12-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z' })
    );
  }

});

module.exports = NotificationAirlineSeatLegroomExtra;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationWifi = React.createClass({
  displayName: 'NotificationWifi',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z' })
    );
  }

});

module.exports = NotificationWifi;

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationTapAndPlay = React.createClass({
  displayName: 'NotificationTapAndPlay',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z' })
    );
  }

});

module.exports = NotificationTapAndPlay;

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationAirlineSeatFlatAngled = React.createClass({
  displayName: 'NotificationAirlineSeatFlatAngled',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09c2.1.76 3.18 3.06 2.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94c1.49-.72 2.12-2.51 1.41-4C7.99 4.71 6.2 4.08 4.7 4.8c-1.49.71-2.12 2.5-1.4 4 .71 1.49 2.5 2.12 4 1.4z' })
    );
  }

});

module.exports = NotificationAirlineSeatFlatAngled;

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationWc = React.createClass({
  displayName: 'NotificationWc',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z' })
    );
  }

});

module.exports = NotificationWc;

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationSms = React.createClass({
  displayName: 'NotificationSms',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
    );
  }

});

module.exports = NotificationSms;

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationBluetoothAudio = React.createClass({
  displayName: 'NotificationBluetoothAudio',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z' })
    );
  }

});

module.exports = NotificationBluetoothAudio;

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationFolderSpecial = React.createClass({
  displayName: 'NotificationFolderSpecial',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6.42 12L10 15.9 6.42 18l.95-4.07-3.16-2.74 4.16-.36L10 7l1.63 3.84 4.16.36-3.16 2.74.95 4.06z' })
    );
  }

});

module.exports = NotificationFolderSpecial;

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationSimCardAlert = React.createClass({
  displayName: 'NotificationSimCardAlert',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z' })
    );
  }

});

module.exports = NotificationSimCardAlert;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationEventNote = React.createClass({
  displayName: 'NotificationEventNote',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z' })
    );
  }

});

module.exports = NotificationEventNote;

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationPersonalVideo = React.createClass({
  displayName: 'NotificationPersonalVideo',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z' })
    );
  }

});

module.exports = NotificationPersonalVideo;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationLiveTv = React.createClass({
  displayName: 'NotificationLiveTv',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z' })
    );
  }

});

module.exports = NotificationLiveTv;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationTimeToLeave = React.createClass({
  displayName: 'NotificationTimeToLeave',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z' })
    );
  }

});

module.exports = NotificationTimeToLeave;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationAdb = React.createClass({
  displayName: 'NotificationAdb',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
    );
  }

});

module.exports = NotificationAdb;

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationConfirmationNumber = React.createClass({
  displayName: 'NotificationConfirmationNumber',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement(
        'defs',
        null,
        React.createElement('path', { id: 'a', d: 'M0 0h24v24H0z' })
      ),
      React.createElement(
        'clipPath',
        { id: 'b' },
        React.createElement('use', { overflow: 'visible' })
      ),
      React.createElement('path', { d: 'M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z', 'clip-path': 'url(#b)' })
    );
  }

});

module.exports = NotificationConfirmationNumber;

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationAirlineSeatFlat = React.createClass({
  displayName: 'NotificationAirlineSeatFlat',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z' })
    );
  }

});

module.exports = NotificationAirlineSeatFlat;

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationSync = React.createClass({
  displayName: 'NotificationSync',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
    );
  }

});

module.exports = NotificationSync;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationVoiceChat = React.createClass({
  displayName: 'NotificationVoiceChat',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12l-4-3.2V14H6V6h8v3.2L18 6v8z' })
    );
  }

});

module.exports = NotificationVoiceChat;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationPhoneLocked = React.createClass({
  displayName: 'NotificationPhoneLocked',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4z' })
    );
  }

});

module.exports = NotificationPhoneLocked;

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationPhoneForwarded = React.createClass({
  displayName: 'NotificationPhoneForwarded',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
    );
  }

});

module.exports = NotificationPhoneForwarded;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationSystemUpdate = React.createClass({
  displayName: 'NotificationSystemUpdate',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z' })
    );
  }

});

module.exports = NotificationSystemUpdate;

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationMore = React.createClass({
  displayName: 'NotificationMore',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
    );
  }

});

module.exports = NotificationMore;

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationMms = React.createClass({
  displayName: 'NotificationMms',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z' })
    );
  }

});

module.exports = NotificationMms;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationPhoneInTalk = React.createClass({
  displayName: 'NotificationPhoneInTalk',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z' })
    );
  }

});

module.exports = NotificationPhoneInTalk;

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationAirlineSeatReclineExtra = React.createClass({
  displayName: 'NotificationAirlineSeatReclineExtra',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76C4.37 19.2 6.47 21 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z' })
    );
  }

});

module.exports = NotificationAirlineSeatReclineExtra;

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationPhoneBluetoothSpeaker = React.createClass({
  displayName: 'NotificationPhoneBluetoothSpeaker',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
    );
  }

});

module.exports = NotificationPhoneBluetoothSpeaker;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationAirlineSeatLegroomNormal = React.createClass({
  displayName: 'NotificationAirlineSeatLegroomNormal',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z' })
    );
  }

});

module.exports = NotificationAirlineSeatLegroomNormal;

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationDoNotDisturbAlt = React.createClass({
  displayName: 'NotificationDoNotDisturbAlt',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z' })
    );
  }

});

module.exports = NotificationDoNotDisturbAlt;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationOndemandVideo = React.createClass({
  displayName: 'NotificationOndemandVideo',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z' })
    );
  }

});

module.exports = NotificationOndemandVideo;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationEventBusy = React.createClass({
  displayName: 'NotificationEventBusy',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z' })
    );
  }

});

module.exports = NotificationEventBusy;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationDoNotDisturb = React.createClass({
  displayName: 'NotificationDoNotDisturb',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z' })
    );
  }

});

module.exports = NotificationDoNotDisturb;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationDriveEta = React.createClass({
  displayName: 'NotificationDriveEta',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z' })
    );
  }

});

module.exports = NotificationDriveEta;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationAirlineSeatLegroomReduced = React.createClass({
  displayName: 'NotificationAirlineSeatLegroomReduced',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z' })
    );
  }

});

module.exports = NotificationAirlineSeatLegroomReduced;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationSyncDisabled = React.createClass({
  displayName: 'NotificationSyncDisabled',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64L20 4z' })
    );
  }

});

module.exports = NotificationSyncDisabled;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationPhoneMissed = React.createClass({
  displayName: 'NotificationPhoneMissed',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z' })
    );
  }

});

module.exports = NotificationPhoneMissed;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationEventAvailable = React.createClass({
  displayName: 'NotificationEventAvailable',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z' })
    );
  }

});

module.exports = NotificationEventAvailable;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationAirlineSeatReclineNormal = React.createClass({
  displayName: 'NotificationAirlineSeatReclineNormal',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z' })
    );
  }

});

module.exports = NotificationAirlineSeatReclineNormal;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationVibration = React.createClass({
  displayName: 'NotificationVibration',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z' })
    );
  }

});

module.exports = NotificationVibration;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationPower = React.createClass({
  displayName: 'NotificationPower',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z' })
    );
  }

});

module.exports = NotificationPower;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationSdCard = React.createClass({
  displayName: 'NotificationSdCard',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z' })
    );
  }

});

module.exports = NotificationSdCard;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationPhonePaused = React.createClass({
  displayName: 'NotificationPhonePaused',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z' })
    );
  }

});

module.exports = NotificationPhonePaused;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationDiscFull = React.createClass({
  displayName: 'NotificationDiscFull',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
    );
  }

});

module.exports = NotificationDiscFull;

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationSmsFailed = React.createClass({
  displayName: 'NotificationSmsFailed',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z' })
    );
  }

});

module.exports = NotificationSmsFailed;

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var NotificationNetworkLocked = React.createClass({
  displayName: 'NotificationNetworkLocked',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5c0-1.38-1.12-2.5-2.5-2.5S17 13.12 17 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z' })
    );
  }

});

module.exports = NotificationNetworkLocked;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwarePowerInput = React.createClass({
  displayName: 'HardwarePowerInput',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z' })
    );
  }

});

module.exports = HardwarePowerInput;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareWatch = React.createClass({
  displayName: 'HardwareWatch',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z' })
    );
  }

});

module.exports = HardwareWatch;

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareGamepad = React.createClass({
  displayName: 'HardwareGamepad',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z' })
    );
  }

});

module.exports = HardwareGamepad;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareLaptop = React.createClass({
  displayName: 'HardwareLaptop',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z' })
    );
  }

});

module.exports = HardwareLaptop;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareKeyboardBackspace = React.createClass({
  displayName: 'HardwareKeyboardBackspace',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z' })
    );
  }

});

module.exports = HardwareKeyboardBackspace;

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareSmartphone = React.createClass({
  displayName: 'HardwareSmartphone',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
    );
  }

});

module.exports = HardwareSmartphone;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwarePhonelinkOff = React.createClass({
  displayName: 'HardwarePhonelinkOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z' })
    );
  }

});

module.exports = HardwarePhonelinkOff;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwarePhoneAndroid = React.createClass({
  displayName: 'HardwarePhoneAndroid',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z' })
    );
  }

});

module.exports = HardwarePhoneAndroid;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareMouse = React.createClass({
  displayName: 'HardwareMouse',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z' })
    );
  }

});

module.exports = HardwareMouse;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareLaptopChromebook = React.createClass({
  displayName: 'HardwareLaptopChromebook',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z' })
    );
  }

});

module.exports = HardwareLaptopChromebook;

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareSecurity = React.createClass({
  displayName: 'HardwareSecurity',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z' })
    );
  }

});

module.exports = HardwareSecurity;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareTv = React.createClass({
  displayName: 'HardwareTv',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z' })
    );
  }

});

module.exports = HardwareTv;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareSpeakerGroup = React.createClass({
  displayName: 'HardwareSpeakerGroup',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' }),
      React.createElement('circle', { cx: '14', cy: '12.5', r: '2.5' }),
      React.createElement('path', { d: 'M6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z' })
    );
  }

});

module.exports = HardwareSpeakerGroup;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareSimCard = React.createClass({
  displayName: 'HardwareSimCard',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z' })
    );
  }

});

module.exports = HardwareSimCard;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareCastConnected = React.createClass({
  displayName: 'HardwareCastConnected',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
    );
  }

});

module.exports = HardwareCastConnected;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareMemory = React.createClass({
  displayName: 'HardwareMemory',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z' })
    );
  }

});

module.exports = HardwareMemory;

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareDesktopMac = React.createClass({
  displayName: 'HardwareDesktopMac',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z' })
    );
  }

});

module.exports = HardwareDesktopMac;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareDesktopWindows = React.createClass({
  displayName: 'HardwareDesktopWindows',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z' })
    );
  }

});

module.exports = HardwareDesktopWindows;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareSpeaker = React.createClass({
  displayName: 'HardwareSpeaker',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
    );
  }

});

module.exports = HardwareSpeaker;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareToys = React.createClass({
  displayName: 'HardwareToys',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z' })
    );
  }

});

module.exports = HardwareToys;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareKeyboardHide = React.createClass({
  displayName: 'HardwareKeyboardHide',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z' })
    );
  }

});

module.exports = HardwareKeyboardHide;

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareRouter = React.createClass({
  displayName: 'HardwareRouter',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z' })
    );
  }

});

module.exports = HardwareRouter;

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareTabletAndroid = React.createClass({
  displayName: 'HardwareTabletAndroid',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z' })
    );
  }

});

module.exports = HardwareTabletAndroid;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareHeadset = React.createClass({
  displayName: 'HardwareHeadset',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z' })
    );
  }

});

module.exports = HardwareHeadset;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareLaptopWindows = React.createClass({
  displayName: 'HardwareLaptopWindows',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z' })
    );
  }

});

module.exports = HardwareLaptopWindows;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareKeyboardArrowLeft = React.createClass({
  displayName: 'HardwareKeyboardArrowLeft',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z' })
    );
  }

});

module.exports = HardwareKeyboardArrowLeft;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareLaptopMac = React.createClass({
  displayName: 'HardwareLaptopMac',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
    );
  }

});

module.exports = HardwareLaptopMac;

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareTabletMac = React.createClass({
  displayName: 'HardwareTabletMac',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z' })
    );
  }

});

module.exports = HardwareTabletMac;

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareKeyboardArrowRight = React.createClass({
  displayName: 'HardwareKeyboardArrowRight',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z' })
    );
  }

});

module.exports = HardwareKeyboardArrowRight;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareKeyboard = React.createClass({
  displayName: 'HardwareKeyboard',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z' })
    );
  }

});

module.exports = HardwareKeyboard;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwarePhoneIphone = React.createClass({
  displayName: 'HardwarePhoneIphone',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z' })
    );
  }

});

module.exports = HardwarePhoneIphone;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareDeveloperBoard = React.createClass({
  displayName: 'HardwareDeveloperBoard',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z' })
    );
  }

});

module.exports = HardwareDeveloperBoard;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareDeviceHub = React.createClass({
  displayName: 'HardwareDeviceHub',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z' })
    );
  }

});

module.exports = HardwareDeviceHub;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareKeyboardReturn = React.createClass({
  displayName: 'HardwareKeyboardReturn',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z' })
    );
  }

});

module.exports = HardwareKeyboardReturn;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareHeadsetMic = React.createClass({
  displayName: 'HardwareHeadsetMic',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z' })
    );
  }

});

module.exports = HardwareHeadsetMic;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareTablet = React.createClass({
  displayName: 'HardwareTablet',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z' })
    );
  }

});

module.exports = HardwareTablet;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwarePhonelink = React.createClass({
  displayName: 'HardwarePhonelink',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z' })
    );
  }

});

module.exports = HardwarePhonelink;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareKeyboardTab = React.createClass({
  displayName: 'HardwareKeyboardTab',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z' })
    );
  }

});

module.exports = HardwareKeyboardTab;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareComputer = React.createClass({
  displayName: 'HardwareComputer',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z' })
    );
  }

});

module.exports = HardwareComputer;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareCast = React.createClass({
  displayName: 'HardwareCast',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z' })
    );
  }

});

module.exports = HardwareCast;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareDock = React.createClass({
  displayName: 'HardwareDock',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z' })
    );
  }

});

module.exports = HardwareDock;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareKeyboardVoice = React.createClass({
  displayName: 'HardwareKeyboardVoice',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
    );
  }

});

module.exports = HardwareKeyboardVoice;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareScanner = React.createClass({
  displayName: 'HardwareScanner',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z' })
    );
  }

});

module.exports = HardwareScanner;

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var HardwareKeyboardCapslock = React.createClass({
  displayName: 'HardwareKeyboardCapslock',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z' })
    );
  }

});

module.exports = HardwareKeyboardCapslock;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AlertWarning = React.createClass({
  displayName: 'AlertWarning',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
    );
  }

});

module.exports = AlertWarning;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AlertErrorOutline = React.createClass({
  displayName: 'AlertErrorOutline',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
    );
  }

});

module.exports = AlertErrorOutline;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AlertAddAlert = React.createClass({
  displayName: 'AlertAddAlert',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z' })
    );
  }

});

module.exports = AlertAddAlert;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var AlertError = React.createClass({
  displayName: 'AlertError',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' })
    );
  }

});

module.exports = AlertError;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceNetworkWifi = React.createClass({
  displayName: 'DeviceNetworkWifi',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
      React.createElement('path', { d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z' })
    );
  }

});

module.exports = DeviceNetworkWifi;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalWifi0Bar = React.createClass({
  displayName: 'DeviceSignalWifi0Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' })
    );
  }

});

module.exports = DeviceSignalWifi0Bar;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellular4Bar = React.createClass({
  displayName: 'DeviceSignalCellular4Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M2 22h20V2z' })
    );
  }

});

module.exports = DeviceSignalCellular4Bar;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceAccessAlarm = React.createClass({
  displayName: 'DeviceAccessAlarm',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
    );
  }

});

module.exports = DeviceAccessAlarm;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceWallpaper = React.createClass({
  displayName: 'DeviceWallpaper',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z' })
    );
  }

});

module.exports = DeviceWallpaper;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceDataUsage = React.createClass({
  displayName: 'DeviceDataUsage',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z' })
    );
  }

});

module.exports = DeviceDataUsage;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellularConnectedNoInternet1Bar = React.createClass({
  displayName: 'DeviceSignalCellularConnectedNoInternet1Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M22 8V2L2 22h16V8z' }),
      React.createElement('path', { d: 'M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z' })
    );
  }

});

module.exports = DeviceSignalCellularConnectedNoInternet1Bar;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBatteryCharging80 = React.createClass({
  displayName: 'DeviceBatteryCharging80',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z' }),
      React.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z' })
    );
  }

});

module.exports = DeviceBatteryCharging80;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceLocationSearching = React.createClass({
  displayName: 'DeviceLocationSearching',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
    );
  }

});

module.exports = DeviceLocationSearching;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellular0Bar = React.createClass({
  displayName: 'DeviceSignalCellular0Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M2 22h20V2z' })
    );
  }

});

module.exports = DeviceSignalCellular0Bar;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSettingsSystemDaydream = React.createClass({
  displayName: 'DeviceSettingsSystemDaydream',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
    );
  }

});

module.exports = DeviceSettingsSystemDaydream;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBatteryChargingFull = React.createClass({
  displayName: 'DeviceBatteryChargingFull',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z' })
    );
  }

});

module.exports = DeviceBatteryChargingFull;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceScreenLockLandscape = React.createClass({
  displayName: 'DeviceScreenLockLandscape',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z' })
    );
  }

});

module.exports = DeviceScreenLockLandscape;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBluetoothConnected = React.createClass({
  displayName: 'DeviceBluetoothConnected',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z' })
    );
  }

});

module.exports = DeviceBluetoothConnected;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSdStorage = React.createClass({
  displayName: 'DeviceSdStorage',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z' })
    );
  }

});

module.exports = DeviceSdStorage;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceWidgets = React.createClass({
  displayName: 'DeviceWidgets',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z' })
    );
  }

});

module.exports = DeviceWidgets;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBrightnessHigh = React.createClass({
  displayName: 'DeviceBrightnessHigh',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z' })
    );
  }

});

module.exports = DeviceBrightnessHigh;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceWifiLock = React.createClass({
  displayName: 'DeviceWifiLock',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z' })
    );
  }

});

module.exports = DeviceWifiLock;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBatteryCharging60 = React.createClass({
  displayName: 'DeviceBatteryCharging60',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z' }),
      React.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z' })
    );
  }

});

module.exports = DeviceBatteryCharging60;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBrightnessAuto = React.createClass({
  displayName: 'DeviceBrightnessAuto',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z' })
    );
  }

});

module.exports = DeviceBrightnessAuto;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBattery60 = React.createClass({
  displayName: 'DeviceBattery60',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z' }),
      React.createElement('path', { d: 'M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z' })
    );
  }

});

module.exports = DeviceBattery60;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBatteryCharging20 = React.createClass({
  displayName: 'DeviceBatteryCharging20',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z' }),
      React.createElement('path', { 'fill-opacity': '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z' })
    );
  }

});

module.exports = DeviceBatteryCharging20;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellular3Bar = React.createClass({
  displayName: 'DeviceSignalCellular3Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M2 22h20V2z' }),
      React.createElement('path', { d: 'M17 7L2 22h15z' })
    );
  }

});

module.exports = DeviceSignalCellular3Bar;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellular2Bar = React.createClass({
  displayName: 'DeviceSignalCellular2Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M2 22h20V2z' }),
      React.createElement('path', { d: 'M14 10L2 22h12z' })
    );
  }

});

module.exports = DeviceSignalCellular2Bar;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBatteryCharging50 = React.createClass({
  displayName: 'DeviceBatteryCharging50',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z' }),
      React.createElement('path', { 'fill-opacity': '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z' })
    );
  }

});

module.exports = DeviceBatteryCharging50;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBattery50 = React.createClass({
  displayName: 'DeviceBattery50',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z' }),
      React.createElement('path', { d: 'M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z' })
    );
  }

});

module.exports = DeviceBattery50;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceWifiTethering = React.createClass({
  displayName: 'DeviceWifiTethering',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z' })
    );
  }

});

module.exports = DeviceWifiTethering;

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBattery20 = React.createClass({
  displayName: 'DeviceBattery20',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z' }),
      React.createElement('path', { 'fill-opacity': '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z' })
    );
  }

});

module.exports = DeviceBattery20;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellularConnectedNoInternet2Bar = React.createClass({
  displayName: 'DeviceSignalCellularConnectedNoInternet2Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M22 8V2L2 22h16V8z' }),
      React.createElement('path', { d: 'M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z' })
    );
  }

});

module.exports = DeviceSignalCellularConnectedNoInternet2Bar;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceAccessAlarms = React.createClass({
  displayName: 'DeviceAccessAlarms',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z' })
    );
  }

});

module.exports = DeviceAccessAlarms;

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalWifi1Bar = React.createClass({
  displayName: 'DeviceSignalWifi1Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
      React.createElement('path', { d: 'M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z' })
    );
  }

});

module.exports = DeviceSignalWifi1Bar;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceScreenLockPortrait = React.createClass({
  displayName: 'DeviceScreenLockPortrait',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z' })
    );
  }

});

module.exports = DeviceScreenLockPortrait;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceAccessTime = React.createClass({
  displayName: 'DeviceAccessTime',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.9', d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zM12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
    );
  }

});

module.exports = DeviceAccessTime;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBattery80 = React.createClass({
  displayName: 'DeviceBattery80',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z' }),
      React.createElement('path', { d: 'M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z' })
    );
  }

});

module.exports = DeviceBattery80;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceGpsOff = React.createClass({
  displayName: 'DeviceGpsOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z' })
    );
  }

});

module.exports = DeviceGpsOff;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceScreenLockRotation = React.createClass({
  displayName: 'DeviceScreenLockRotation',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75c-.59-.59-1.54-.59-2.12 0L2.75 7.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48C5.2 18.94 2.86 15.76 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5C21 1.12 19.88 0 18.5 0S16 1.12 16 2.5V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z' })
    );
  }

});

module.exports = DeviceScreenLockRotation;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBatteryUnknown = React.createClass({
  displayName: 'DeviceBatteryUnknown',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z' })
    );
  }

});

module.exports = DeviceBatteryUnknown;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceGpsNotFixed = React.createClass({
  displayName: 'DeviceGpsNotFixed',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
    );
  }

});

module.exports = DeviceGpsNotFixed;

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalWifi3BarLock = React.createClass({
  displayName: 'DeviceSignalWifi3BarLock',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { opacity: '.3', d: 'M12 3C5.3 3 .8 6.7.4 7l3.2 3.9L12 21.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7.3-.1.5-.2.8-.2.3-.1.6-.1.9-.1.4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4z' }),
      React.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-10 5.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7C17.3 9 14.9 8 12 8c-4.8 0-8 2.6-8.5 2.9' })
    );
  }

});

module.exports = DeviceSignalWifi3BarLock;

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceNfc = React.createClass({
  displayName: 'DeviceNfc',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z' })
    );
  }

});

module.exports = DeviceNfc;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceDvr = React.createClass({
  displayName: 'DeviceDvr',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z' })
    );
  }

});

module.exports = DeviceDvr;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellular1Bar = React.createClass({
  displayName: 'DeviceSignalCellular1Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M2 22h20V2z' }),
      React.createElement('path', { d: 'M12 12L2 22h10z' })
    );
  }

});

module.exports = DeviceSignalCellular1Bar;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceAirplanemodeActive = React.createClass({
  displayName: 'DeviceAirplanemodeActive',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M10.18 9' }),
      React.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
    );
  }

});

module.exports = DeviceAirplanemodeActive;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBattery90 = React.createClass({
  displayName: 'DeviceBattery90',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z' }),
      React.createElement('path', { d: 'M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z' })
    );
  }

});

module.exports = DeviceBattery90;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBluetoothSearching = React.createClass({
  displayName: 'DeviceBluetoothSearching',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z' })
    );
  }

});

module.exports = DeviceBluetoothSearching;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceStorage = React.createClass({
  displayName: 'DeviceStorage',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z' })
    );
  }

});

module.exports = DeviceStorage;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellularNoSim = React.createClass({
  displayName: 'DeviceSignalCellularNoSim',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z' })
    );
  }

});

module.exports = DeviceSignalCellularNoSim;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBrightnessMedium = React.createClass({
  displayName: 'DeviceBrightnessMedium',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
    );
  }

});

module.exports = DeviceBrightnessMedium;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceLocationDisabled = React.createClass({
  displayName: 'DeviceLocationDisabled',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z' })
    );
  }

});

module.exports = DeviceLocationDisabled;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalWifi2BarLock = React.createClass({
  displayName: 'DeviceSignalWifi2BarLock',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z' }),
      React.createElement('path', { d: 'M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z', opacity: '.3' }),
      React.createElement('path', { d: 'M4.8 12.5l7.2 9 3.5-4.4v-2.6c0-1.3.5-2.5 1.4-3.4C15.6 10.5 14 10 12 10c-4.1 0-6.8 2.2-7.2 2.5z' })
    );
  }

});

module.exports = DeviceSignalWifi2BarLock;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalWifiOff = React.createClass({
  displayName: 'DeviceSignalWifiOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z' })
    );
  }

});

module.exports = DeviceSignalWifiOff;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBatteryFull = React.createClass({
  displayName: 'DeviceBatteryFull',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z' })
    );
  }

});

module.exports = DeviceBatteryFull;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBluetooth = React.createClass({
  displayName: 'DeviceBluetooth',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z' })
    );
  }

});

module.exports = DeviceBluetooth;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellularConnectedNoInternet3Bar = React.createClass({
  displayName: 'DeviceSignalCellularConnectedNoInternet3Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M22 8V2L2 22h16V8z' }),
      React.createElement('path', { d: 'M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z' })
    );
  }

});

module.exports = DeviceSignalCellularConnectedNoInternet3Bar;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalWifi1BarLock = React.createClass({
  displayName: 'DeviceSignalWifi1BarLock',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z' }),
      React.createElement('path', { d: 'M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z', opacity: '.3' }),
      React.createElement('path', { d: 'M6.7 14.9l5.3 6.6 3.5-4.3v-2.6c0-.2 0-.5.1-.7-.9-.5-2.2-.9-3.6-.9-3 0-5.1 1.7-5.3 1.9z' })
    );
  }

});

module.exports = DeviceSignalWifi1BarLock;

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellularNull = React.createClass({
  displayName: 'DeviceSignalCellularNull',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z' })
    );
  }

});

module.exports = DeviceSignalCellularNull;

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBrightnessLow = React.createClass({
  displayName: 'DeviceBrightnessLow',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
    );
  }

});

module.exports = DeviceBrightnessLow;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBatteryCharging90 = React.createClass({
  displayName: 'DeviceBatteryCharging90',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z' }),
      React.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z' })
    );
  }

});

module.exports = DeviceBatteryCharging90;

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalWifi3Bar = React.createClass({
  displayName: 'DeviceSignalWifi3Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
      React.createElement('path', { d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z' })
    );
  }

});

module.exports = DeviceSignalWifi3Bar;

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellularOff = React.createClass({
  displayName: 'DeviceSignalCellularOff',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z' })
    );
  }

});

module.exports = DeviceSignalCellularOff;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellularConnectedNoInternet0Bar = React.createClass({
  displayName: 'DeviceSignalCellularConnectedNoInternet0Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M22 8V2L2 22h16V8z' }),
      React.createElement('path', { d: 'M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z' })
    );
  }

});

module.exports = DeviceSignalCellularConnectedNoInternet0Bar;

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBluetoothDisabled = React.createClass({
  displayName: 'DeviceBluetoothDisabled',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z' })
    );
  }

});

module.exports = DeviceBluetoothDisabled;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceDevices = React.createClass({
  displayName: 'DeviceDevices',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z' })
    );
  }

});

module.exports = DeviceDevices;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceAddAlarm = React.createClass({
  displayName: 'DeviceAddAlarm',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z' })
    );
  }

});

module.exports = DeviceAddAlarm;

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceGraphicEq = React.createClass({
  displayName: 'DeviceGraphicEq',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z' })
    );
  }

});

module.exports = DeviceGraphicEq;

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBatteryAlert = React.createClass({
  displayName: 'DeviceBatteryAlert',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z' })
    );
  }

});

module.exports = DeviceBatteryAlert;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalWifi4BarLock = React.createClass({
  displayName: 'DeviceSignalWifi4BarLock',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z' })
    );
  }

});

module.exports = DeviceSignalWifi4BarLock;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalWifi4Bar = React.createClass({
  displayName: 'DeviceSignalWifi4Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' })
    );
  }

});

module.exports = DeviceSignalWifi4Bar;

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalCellularConnectedNoInternet4Bar = React.createClass({
  displayName: 'DeviceSignalCellularConnectedNoInternet4Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z' })
    );
  }

});

module.exports = DeviceSignalCellularConnectedNoInternet4Bar;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceDeveloperMode = React.createClass({
  displayName: 'DeviceDeveloperMode',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z' })
    );
  }

});

module.exports = DeviceDeveloperMode;

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceGpsFixed = React.createClass({
  displayName: 'DeviceGpsFixed',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
    );
  }

});

module.exports = DeviceGpsFixed;

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBatteryStd = React.createClass({
  displayName: 'DeviceBatteryStd',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z' })
    );
  }

});

module.exports = DeviceBatteryStd;

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBattery30 = React.createClass({
  displayName: 'DeviceBattery30',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z' }),
      React.createElement('path', { d: 'M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z' })
    );
  }

});

module.exports = DeviceBattery30;

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceAirplanemodeInactive = React.createClass({
  displayName: 'DeviceAirplanemodeInactive',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.68l7.83 7.83L21 16v-2l-8-5zM3 5.27l4.99 4.99L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-3.73L18.73 21 20 19.73 4.27 4 3 5.27z' })
    );
  }

});

module.exports = DeviceAirplanemodeInactive;

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceSignalWifi2Bar = React.createClass({
  displayName: 'DeviceSignalWifi2Bar',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
      React.createElement('path', { d: 'M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z' })
    );
  }

});

module.exports = DeviceSignalWifi2Bar;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceNetworkCell = React.createClass({
  displayName: 'DeviceNetworkCell',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M2 22h20V2z' }),
      React.createElement('path', { d: 'M17 7L2 22h15z' })
    );
  }

});

module.exports = DeviceNetworkCell;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceUsb = React.createClass({
  displayName: 'DeviceUsb',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z' })
    );
  }

});

module.exports = DeviceUsb;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceBatteryCharging30 = React.createClass({
  displayName: 'DeviceBatteryCharging30',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { 'fill-opacity': '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z' }),
      React.createElement('path', { d: 'M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z' })
    );
  }

});

module.exports = DeviceBatteryCharging30;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0);
var PureRenderMixin = __webpack_require__(1);
var SvgIcon = __webpack_require__(2);

var DeviceScreenRotation = React.createClass({
  displayName: 'DeviceScreenRotation',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z' })
    );
  }

});

module.exports = DeviceScreenRotation;

/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AudioHigher=function(_Icon){_inherits(AudioHigher,_Icon);function AudioHigher(){_classCallCheck(this,AudioHigher);return _possibleConstructorReturn(this,(AudioHigher.__proto__||Object.getPrototypeOf(AudioHigher)).apply(this,arguments));}_createClass(AudioHigher,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M9.4,8c0,0.7-0.3,1.2-0.7,1.6l0.6,1.1c0.8-0.6,1.4-1.5,1.4-2.6s-0.5-2.1-1.4-2.6L8.7,6.4 C9.1,6.8,9.4,7.3,9.4,8z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M11.6,1.3L11,2.4c1.8,1.2,3,3.2,3,5.6c0,2.4-1.2,4.5-3,5.6l0.6,1.1c2.1-1.4,3.6-3.9,3.6-6.7 C15.2,5.2,13.8,2.7,11.6,1.3z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M13,8c0-2-1-3.7-2.5-4.7L9.9,4.4C11,5.2,11.7,6.5,11.7,8s-0.8,2.8-1.9,3.6l0.6,1.1C12,11.7,13,10,13,8z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M5.5,13.7l-4.3-3.6L1,9.5v-3l0.3-0.6l4.3-3.6l1.2,0.6v10.2L5.5,13.7z M2.5,9.1l2.8,2.4v-7L2.5,6.9V9.1z'})));}}]);return AudioHigher;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (AudioHigher);

/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AudioLower=function(_Icon){_inherits(AudioLower,_Icon);function AudioLower(){_classCallCheck(this,AudioLower);return _possibleConstructorReturn(this,(AudioLower.__proto__||Object.getPrototypeOf(AudioLower)).apply(this,arguments));}_createClass(AudioLower,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M9.4,8c0,0.7-0.3,1.2-0.7,1.6l0.6,1.1c0.8-0.6,1.4-1.5,1.4-2.6s-0.5-2.1-1.4-2.6L8.7,6.4 C9.1,6.8,9.4,7.3,9.4,8z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M5.5,13.7l-4.3-3.6L1,9.5v-3l0.3-0.6l4.3-3.6l1.2,0.6v10.2L5.5,13.7z M2.5,9.1l2.8,2.4v-7L2.5,6.9V9.1z'})));}}]);return AudioLower;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (AudioLower);

/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AudioMid=function(_Icon){_inherits(AudioMid,_Icon);function AudioMid(){_classCallCheck(this,AudioMid);return _possibleConstructorReturn(this,(AudioMid.__proto__||Object.getPrototypeOf(AudioMid)).apply(this,arguments));}_createClass(AudioMid,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M9.4,8c0,0.7-0.3,1.2-0.7,1.6l0.6,1.1c0.8-0.6,1.4-1.5,1.4-2.6s-0.5-2.1-1.4-2.6L8.7,6.4 C9.1,6.8,9.4,7.3,9.4,8z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M13,8c0-2-1-3.7-2.5-4.7L9.9,4.4C11,5.2,11.7,6.5,11.7,8s-0.8,2.8-1.9,3.6l0.6,1.1C12,11.7,13,10,13,8z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M5.5,13.7l-4.3-3.6L1,9.5v-3l0.3-0.6l4.3-3.6l1.2,0.6v10.2L5.5,13.7z M2.5,9.1l2.8,2.4v-7L2.5,6.9V9.1z'})));}}]);return AudioMid;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (AudioMid);

/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AudioMute=function(_Icon){_inherits(AudioMute,_Icon);function AudioMute(){_classCallCheck(this,AudioMute);return _possibleConstructorReturn(this,(AudioMute.__proto__||Object.getPrototypeOf(AudioMute)).apply(this,arguments));}_createClass(AudioMute,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'7.3',y:'-0.1',transform:'matrix(0.7071 0.7071 -0.7071 0.7071 8 -3.3137)',width:'1.5',height:viewPortSize}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'5,13.2 5.5,13.7 6.8,13.1 6.8,11.3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'2.6,11.2 3.7,10.2 2.5,9.1 2.5,6.9 5.3,4.5 5.3,8.6 6.8,7.1 6.8,2.9 5.5,2.3 1.2,5.9 1,6.5 1,9.5 1.2,10.1'}))));}}]);return AudioMute;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (AudioMute);

/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cancel=function(_Icon){_inherits(Cancel,_Icon);function Cancel(){_classCallCheck(this,Cancel);return _possibleConstructorReturn(this,(Cancel.__proto__||Object.getPrototypeOf(Cancel)).apply(this,arguments));}_createClass(Cancel,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'15,2.4 13.6,1 8,6.6 2.4,1 1,2.4 6.6,8 1,13.6 2.4,15 8,9.4 13.6,15 15,13.6 9.4,8 '})));}}]);return Cancel;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Cancel);

/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckCheckBox=function(_Icon){_inherits(CheckCheckBox,_Icon);function CheckCheckBox(){_classCallCheck(this,CheckCheckBox);return _possibleConstructorReturn(this,(CheckCheckBox.__proto__||Object.getPrototypeOf(CheckCheckBox)).apply(this,arguments));}_createClass(CheckCheckBox,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'7.1,14.7 2.5,11.9 3.6,10.2 7.3,12.4 11.9,3.5 13.7,4.4 8.6,14.3 '})));}}]);return CheckCheckBox;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CheckCheckBox);

/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Check=function(_Icon){_inherits(Check,_Icon);function Check(){_classCallCheck(this,Check);return _possibleConstructorReturn(this,(Check.__proto__||Object.getPrototypeOf(Check)).apply(this,arguments));}_createClass(Check,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'7.1,14.7 1,11 2,9.3 7.3,12.4 13.2,1 15,1.9 8.6,14.3 '})));}}]);return Check;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Check);

/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Close=function(_Icon){_inherits(Close,_Icon);function Close(){_classCallCheck(this,Close);return _possibleConstructorReturn(this,(Close.__proto__||Object.getPrototypeOf(Close)).apply(this,arguments));}_createClass(Close,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'15,2.4 13.6,1 8,6.6 2.4,1 1,2.4 6.6,8 1,13.6 2.4,15 8,9.4 13.6,15 15,13.6 9.4,8 '})));}}]);return Close;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Close);

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Communication=function(_Icon){_inherits(Communication,_Icon);function Communication(){_classCallCheck(this,Communication);return _possibleConstructorReturn(this,(Communication.__proto__||Object.getPrototypeOf(Communication)).apply(this,arguments));}_createClass(Communication,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M3.5,16l-1.3-0.5v-5.4C0.8,9,0,7.4,0,5.6C0,2.5,2.5,0,5.6,0h5.8C14.5,0,17,2.5,17,5.6c0,3.1-2.5,5.6-5.6,5.6   H8.3L3.5,16z M5.6,1.5c-2.3,0-4.1,1.8-4.1,4.1C1.5,7,2.2,8.3,3.4,9l0.3,0.6v4l3.8-3.8L8,9.7h3.4c2.3,0,4.1-1.8,4.1-4.1 c0-2.3-1.8-4.1-4.1-4.1H5.6z'})));}}]);return Communication;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Communication);

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Delete=function(_Icon){_inherits(Delete,_Icon);function Delete(){_classCallCheck(this,Delete);return _possibleConstructorReturn(this,(Delete.__proto__||Object.getPrototypeOf(Delete)).apply(this,arguments));}_createClass(Delete,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M14.5,2.3l-0.8-0.8h-3.6v-1L9.6,0H5.9L5.4,0.5v1H1.8L1,2.3v0.8h1v12.2L2.8,16h10l0.8-0.8V3.1h1V2.3z M6.4,1h2.8v0.5H6.4V1z M12,14.5H3.5V3.1H12V14.5z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'4.8',y:'4.3',width:'1',height:'9'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'7.2',y:'4.3',width:'1',height:'9'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'9.7',y:'4.3',width:'1',height:'9'})));}}]);return Delete;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Delete);

/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Download=function(_Icon){_inherits(Download,_Icon);function Download(){_classCallCheck(this,Download);return _possibleConstructorReturn(this,(Download.__proto__||Object.getPrototypeOf(Download)).apply(this,arguments));}_createClass(Download,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M10.1,12.2V7.7H8.6v4.5L7,10.9L6,12l2.8,2.3c0.1,0.1,0.3,0.2,0.5,0.2s0.3-0.1,0.5-0.2l2.8-2.3l-1-1.2\r L10.1,12.2z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M14.8,5.3c-0.3-2.2-2.2-3.8-4.5-3.8c-1.6,0-3.1,0.8-3.9,2.2c-0.2,0-0.3,0-0.5,0c-1.8,0-3.3,1.5-3.3,3.3\r c0,0,0,0.1,0,0.1c-1,0.3-1.8,1.3-1.8,2.4c0,1.4,1.1,2.5,2.5,2.5h2v-1.5h-2c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h0.2l0.7-1\r C4.2,7.2,4.2,7.1,4.2,6.9c0-1,0.8-1.8,1.8-1.8c0.2,0,0.4,0,0.6,0.1l0.9-0.4C8,3.7,9.1,3,10.3,3c1.7,0,3.1,1.4,3.1,3.1l0.9,0.7\r c0.1,0,0.2,0,0.3,0c1,0,1.8,0.8,1.8,1.8c0,1-0.8,1.8-1.8,1.8h-1.3v1.5h1.3c1.8,0,3.3-1.5,3.3-3.3C17.8,6.9,16.5,5.5,14.8,5.3z'})));}}]);return Download;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Download);

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Duplicate=function(_Icon){_inherits(Duplicate,_Icon);function Duplicate(){_classCallCheck(this,Duplicate);return _possibleConstructorReturn(this,(Duplicate.__proto__||Object.getPrototypeOf(Duplicate)).apply(this,arguments));}_createClass(Duplicate,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M15.2,2.8H3.6L2.8,3.6v11.7L3.6,16h11.7l0.8-0.8V3.6L15.2,2.8z M14.5,14.5H4.3V4.3h10.1V14.5z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'12.4,0 0.8,0 0,0.8 0,12.4 1.5,12.4 1.5,1.5 12.4,1.5  '})));}}]);return Duplicate;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Duplicate);

/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Edit=function(_Icon){_inherits(Edit,_Icon);function Edit(){_classCallCheck(this,Edit);return _possibleConstructorReturn(this,(Edit.__proto__||Object.getPrototypeOf(Edit)).apply(this,arguments));}_createClass(Edit,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M12,0h-1.1L1,10l-0.2,0.4L0,15.1L0.9,16l4.8-0.7L6.1,15L16,5.1V4L12,0z M14.4,4.6L14,4.9l-3-3l0.4-0.4L14.4,4.6z M5.7,12\r c-0.3-0.3-0.8-0.6-1.1-0.7c-0.1-0.2-0.3-0.7-0.7-1.1c-0.2-0.2-0.5-0.4-0.7-0.5L10,3l3,3l-6.8,6.8C6.1,12.5,5.9,12.3,5.7,12z\r M3.2,14.1c-0.1-0.3-0.2-0.6-0.5-0.9c-0.3-0.3-0.6-0.4-0.9-0.5l0.3-1.9l0.5-0.5c0.2,0.1,0.5,0.2,0.7,0.5C3.8,11.2,4,11.8,4,11.8\r C4,11.9,4.1,12,4.2,12c0,0,0.6,0.2,0.9,0.6c0.2,0.2,0.4,0.6,0.5,0.7l-0.5,0.5L3.2,14.1z'})));}}]);return Edit;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Edit);

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Export=function(_Icon){_inherits(Export,_Icon);function Export(){_classCallCheck(this,Export);return _possibleConstructorReturn(this,(Export.__proto__||Object.getPrototypeOf(Export)).apply(this,arguments));}_createClass(Export,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M12.3,4.6l-1.2,1l1.4,1.7H7.8v1.5h4.8l-1.4,1.7l1.2,1l2.4-3v-1L12.3,4.6z M3.1,3.5h8.6V2H2.4L1.6,2.7v10.6\r L2.4,14h9.3v-1.5H3.1V3.5z'})));}}]);return Export;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Export);

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Filter=function(_Icon){_inherits(Filter,_Icon);function Filter(){_classCallCheck(this,Filter);return _possibleConstructorReturn(this,(Filter.__proto__||Object.getPrototypeOf(Filter)).apply(this,arguments));}_createClass(Filter,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M7.3,14.2l-1.2-0.6V7.1L1.6,2.7l0.5-1.3H14l0.5,1.3l-4.5,4.5v4.8l-0.3,0.6L7.3,14.2z M4,2.9l3.4,3.4l0.2,0.5\r v5.4l1-0.7V6.8l0.2-0.5l3.4-3.4H4z'})));}}]);return Filter;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Filter);

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Fullsize=function(_Icon){_inherits(Fullsize,_Icon);function Fullsize(){_classCallCheck(this,Fullsize);return _possibleConstructorReturn(this,(Fullsize.__proto__||Object.getPrototypeOf(Fullsize)).apply(this,arguments));}_createClass(Fullsize,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'6.4,8.5 2.8,12.2 2.8,9.1 1.2,9.1 1.2,14 2,14.8 6.9,14.8 6.9,13.2 3.8,13.2 7.5,9.6   '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'14,1.2 9.1,1.2 9.1,2.8 12.2,2.8 8.5,6.4 9.6,7.5 13.2,3.8 13.2,6.9 14.8,6.9 14.8,2   '})));}}]);return Fullsize;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Fullsize);

/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Help=function(_Icon){_inherits(Help,_Icon);function Help(){_classCallCheck(this,Help);return _possibleConstructorReturn(this,(Help.__proto__||Object.getPrototypeOf(Help)).apply(this,arguments));}_createClass(Help,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M8.5,11.8h-2c0-2.8,1.6-3.9,2.8-4.7C10.5,6.4,11,6,11,4.8C11,3,9.8,2,7.8,2C5.2,2,5,3.8,5,4.3H3\r C3,2.7,4,0,7.8,0C11.6,0,13,2.6,13,4.8c0,2.4-1.5,3.3-2.6,4.1C9.3,9.6,8.5,10.1,8.5,11.8z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'6.5',y:'14.2',width:'2',height:'1.8'})));}}]);return Help;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Help);

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Home=function(_Icon){_inherits(Home,_Icon);function Home(){_classCallCheck(this,Home);return _possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).apply(this,arguments));}_createClass(Home,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M14.2,16H0.8L0,15.2V5.7L0.3,5L7,0H8l6.7,5L15,5.7v9.6L14.2,16z M1.6,14.4h11.9V6L7.5,1.6L1.6,6V14.4z'})));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Layout=function(_Icon){_inherits(Layout,_Icon);function Layout(){_classCallCheck(this,Layout);return _possibleConstructorReturn(this,(Layout.__proto__||Object.getPrototypeOf(Layout)).apply(this,arguments));}_createClass(Layout,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M12.3,5H0.7L0,4.3V1.7L0.7,1h11.6L13,1.7v2.6L12.3,5z M1.4,3.6h10.2V2.4H1.4V3.6z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M15.3,10H3.7L3,9.3V6.7L3.7,6h11.6L16,6.7v2.6L15.3,10z M4.4,8.6h10.2V7.4H4.4V8.6z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M12.3,15H0.7L0,14.3v-2.6L0.7,11h11.6l0.7,0.7v2.6L12.3,15z M1.4,13.6h10.2v-1.2H1.4V13.6z'})));}}]);return Layout;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Layout);

/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Library=function(_Icon){_inherits(Library,_Icon);function Library(){_classCallCheck(this,Library);return _possibleConstructorReturn(this,(Library.__proto__||Object.getPrototypeOf(Library)).apply(this,arguments));}_createClass(Library,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M15.7,2.1c-1-0.7-3.3-1.1-4.6-1.1C10,1,8.9,1.3,8,1.8C7.1,1.3,6,1,4.9,1C3.6,1,1.3,1.3,0.3,2.1L0,2.7v11.7\r L1.2,15c0.6-0.4,2.5-0.8,3.7-0.8c1,0,2,0.3,2.7,0.8h0.9c0.7-0.5,1.7-0.8,2.7-0.8c1.2,0,3.1,0.4,3.7,0.8l1.2-0.6V2.7L15.7,2.1z\r M1.5,13.3V3.1c0.8-0.4,2.4-0.6,3.4-0.6c0.9,0,1.7,0.2,2.4,0.6v10.1c-0.7-0.3-1.6-0.4-2.4-0.4C4,12.7,2.6,12.9,1.5,13.3z M14.5,13.3\r c-1.1-0.4-2.5-0.5-3.4-0.5c-0.8,0-1.7,0.2-2.4,0.4V3.1c0.7-0.4,1.5-0.6,2.4-0.6c1,0,2.6,0.3,3.4,0.6V13.3z'})));}}]);return Library;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Library);

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ListView=function(_Icon){_inherits(ListView,_Icon);function ListView(){_classCallCheck(this,ListView);return _possibleConstructorReturn(this,(ListView.__proto__||Object.getPrototypeOf(ListView)).apply(this,arguments));}_createClass(ListView,[{key:'render',value:function render(){var _props=this.props,color=_props.color,stroke=_props.stroke,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','stroke','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color,stroke:stroke},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{fill:'none',strokeWidth:'2',strokeLinejoin:'bevel',strokeMiterlimit:'10',x1:'16.7',y1:'5.3',x2:'5.9',y2:'5.3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{fill:'none',strokeWidth:'2',strokeLinejoin:'bevel',strokeMiterlimit:'10',x1:'16.7',y1:'10',x2:'5.9',y2:'10'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{fill:'none',strokeWidth:'2',strokeLinejoin:'bevel',strokeMiterlimit:'10',x1:'16.7',y1:'14.7',x2:'5.9',y2:'14.7'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{fill:'none',strokeWidth:'2',strokeLinejoin:'bevel',strokeMiterlimit:'10',x1:'4.7',y1:'5.3',x2:'3.3',y2:'5.3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{fill:'none',strokeWidth:'2',strokeLinejoin:'bevel',strokeMiterlimit:'10',x1:'4.7',y1:'10',x2:'3.3',y2:'10'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{fill:'none',strokeWidth:'2',strokeLinejoin:'bevel',strokeMiterlimit:'10',x1:'4.7',y1:'14.7',x2:'3.3',y2:'14.7'}))));}}]);return ListView;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);ListView.defaultProps={color:'#FFFFFF',size:16,stroke:'#FFFFFF',viewPortSize:16};ListView.propTypes={color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,stroke:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,viewPortSize:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number};/* harmony default export */ __webpack_exports__["a"] = (ListView);

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Lock=function(_Icon){_inherits(Lock,_Icon);function Lock(){_classCallCheck(this,Lock);return _possibleConstructorReturn(this,(Lock.__proto__||Object.getPrototypeOf(Lock)).apply(this,arguments));}_createClass(Lock,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M14,8.1h-0.3V5.7C13.7,2.6,11.2,0,8,0C4.8,0,2.3,2.6,2.3,5.7v2.4H2l-1,1V17l1,1h12l1-1V9.1L14,8.1z M4.3,5.7\r C4.3,3.7,6,2,8,2c2,0,3.7,1.7,3.7,3.7v2.4H4.3V5.7z'})));}}]);return Lock;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Lock);

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Menu=function(_Icon){_inherits(Menu,_Icon);function Menu(){_classCallCheck(this,Menu);return _possibleConstructorReturn(this,(Menu.__proto__||Object.getPrototypeOf(Menu)).apply(this,arguments));}_createClass(Menu,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'1',y:'7',width:'14',height:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'1',y:'1',width:'14',height:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'1',y:'13',width:'14',height:'2'})));}}]);return Menu;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleAudio=function(_Icon){_inherits(ModuleAudio,_Icon);function ModuleAudio(){_classCallCheck(this,ModuleAudio);return _possibleConstructorReturn(this,(ModuleAudio.__proto__||Object.getPrototypeOf(ModuleAudio)).apply(this,arguments));}_createClass(ModuleAudio,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M12.8,1.5l-7.4,1L5.1,2.8v7.5C4.8,10,4.4,9.8,3.9,9.8c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8V4.7l6.8-0.9\r v5.5c-0.3-0.3-0.7-0.5-1.2-0.5c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8V1.8L12.8,1.5z M3.9,12.8\r c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2C5.1,12.3,4.6,12.8,3.9,12.8z M5.7,4.1V3.1l6.8-0.9v1.1L5.7,4.1z\r M11.4,11.8c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2C12.6,11.3,12,11.8,11.4,11.8z'})));}}]);return ModuleAudio;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ModuleAudio);

/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleDiscussion=function(_Icon){_inherits(ModuleDiscussion,_Icon);function ModuleDiscussion(){_classCallCheck(this,ModuleDiscussion);return _possibleConstructorReturn(this,(ModuleDiscussion.__proto__||Object.getPrototypeOf(ModuleDiscussion)).apply(this,arguments));}_createClass(ModuleDiscussion,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M15.1,8.2c0-1.8-1.2-3.6-3.9-4c0.1,0.2,0.2,0.4,0.3,0.7c1.9,0.4,3,1.6,3,3.3c0,0.8-0.3,1.6-0.8,2.2l0,0.3\r l0.4,0.8l-0.9-0.5l-0.3,0c-0.7,0.4-1.6,0.6-2.7,0.6c-1.1,0-2-0.2-2.7-0.7c-0.3,0-0.6,0.1-0.9,0.1c0.8,0.7,2,1.2,3.7,1.2\r c1.1,0,2.1-0.2,2.9-0.6l1.6,0.8l0.4-0.4l-0.8-1.5C14.8,10,15.1,9.2,15.1,8.2z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M1.7,10.7l-0.4-0.4L2,8.9C1.5,8.2,1.2,7.4,1.2,6.5c0-2,1.5-4.1,5-4.1s5,2.1,5,4.1s-1.5,4.1-5,4.1\r c-1.1,0-2.1-0.2-2.9-0.6L1.7,10.7z M3.2,9.3l0.3,0c0.7,0.4,1.6,0.6,2.7,0.6c2.6,0,4.4-1.4,4.4-3.5S8.8,3,6.2,3S1.8,4.4,1.8,6.5\r c0,0.8,0.3,1.6,0.8,2.2l0,0.3L2.2,9.8L3.2,9.3z'})));}}]);return ModuleDiscussion;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);ModuleDiscussion.defaultProps={color:'#FFFFFF',size:16,viewPortSize:18};/* harmony default export */ __webpack_exports__["a"] = (ModuleDiscussion);

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleDownload=function(_Icon){_inherits(ModuleDownload,_Icon);function ModuleDownload(){_classCallCheck(this,ModuleDownload);return _possibleConstructorReturn(this,(ModuleDownload.__proto__||Object.getPrototypeOf(ModuleDownload)).apply(this,arguments));}_createClass(ModuleDownload,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M8.3,12.7v-5H7.7v5l-1.5-1.1l-0.4,0.5l2,1.5c0.1,0,0.1,0.1,0.2,0.1s0.1,0,0.2-0.1l2-1.5l-0.4-0.5L8.3,12.7z\r '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M12.7,5.9c-0.1-2-1.8-3.5-3.8-3.5c-1.4,0-2.7,0.8-3.4,2.1C5.3,4.4,5.1,4.3,4.9,4.3C3.5,4.3,2.3,5.5,2.3,7\r c0,0.1,0,0.3,0,0.4c-1,0.1-1.7,0.9-1.7,1.9c0,1,0.9,1.9,1.9,1.9h2.9v-0.6H2.5c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3h0.2\r L3,7.6C2.9,7.4,2.9,7.2,2.9,7c0-1.1,0.9-2,2-2c0.2,0,0.5,0,0.7,0.1L6,4.9C6.5,3.7,7.6,3,8.9,3c1.8,0,3.2,1.4,3.2,3.2l0,0l0.3,0.3\r c0.1,0,0.2,0,0.3,0c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2h-2.2v0.6h2.2c1.4,0,2.6-1.2,2.6-2.6C15.4,7.1,14.2,5.9,12.7,5.9z'})));}}]);return ModuleDownload;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ModuleDownload);

/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleImage=function(_Icon){_inherits(ModuleImage,_Icon);function ModuleImage(){_classCallCheck(this,ModuleImage);return _possibleConstructorReturn(this,(ModuleImage.__proto__||Object.getPrototypeOf(ModuleImage)).apply(this,arguments));}_createClass(ModuleImage,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M3.9,7.7c1,0,1.8-0.8,1.8-1.8S4.9,4.1,3.9,4.1S2.1,4.9,2.1,5.9S2.9,7.7,3.9,7.7z M3.9,4.7c0.7,0,1.2,0.5,1.2,1.2\r S4.5,7.1,3.9,7.1S2.7,6.5,2.7,5.9S3.2,4.7,3.9,4.7z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M15.4,2.3H0.6L0.3,2.6v10.9l0.3,0.3h14.9l0.3-0.3V2.6L15.4,2.3z M15.1,2.9v1.3L10,9.6L7.3,8.2L7,8.2l-6.1,3.9V2.9H15.1z\r M0.9,13.1v-0.3l6.3-4.1L9.5,10l-2,1.3l0.3,0.5l2.4-1.5l0.1,0L15.1,5v8.1H0.9z'})));}}]);return ModuleImage;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ModuleImage);

/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleInteraction=function(_Icon){_inherits(ModuleInteraction,_Icon);function ModuleInteraction(){_classCallCheck(this,ModuleInteraction);return _possibleConstructorReturn(this,(ModuleInteraction.__proto__||Object.getPrototypeOf(ModuleInteraction)).apply(this,arguments));}_createClass(ModuleInteraction,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M5,7.5V7C4.3,6.5,3.8,5.7,3.8,4.7c0-1.5,1.3-2.8,2.8-2.8s2.8,1.3,2.8,2.8c0,0.6-0.2,1.2-0.5,1.7c0.2,0.1,0.4,0.2,0.5,0.3\r c0.4-0.6,0.6-1.2,0.6-2c0-1.9-1.5-3.4-3.4-3.4S3.2,2.8,3.2,4.7C3.2,6,3.9,7,4.9,7.6C4.9,7.6,5,7.6,5,7.5z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M8.8,4.7c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2c0,0.6,0.2,1.1,0.6,1.5V4.8c0-0.1,0-0.3,0-0.4c0.1-0.7,0.8-1.3,1.6-1.3\r c0.8,0,1.4,0.6,1.6,1.3c0,0.1,0,0.3,0,0.4v1.4C8.6,5.8,8.8,5.3,8.8,4.7z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M11.4,8.1c-0.2,0-0.3,0-0.5,0.1c-0.1-0.5-0.5-0.8-1.1-0.8c-0.2,0-0.4,0-0.5,0.1C9.2,7.1,8.8,6.8,8.2,6.8\r c-0.2,0-0.4,0-0.5,0.1v-2c0-0.6-0.5-1.1-1.1-1.1S5.5,4.2,5.5,4.8v3.1C5,8,4.4,8.5,4.4,9v2.6l0,0c0,0.1,0.1,1.8,1.8,2.7l0,0\r c0.5,0.3,1.4,0.4,2.3,0.4c0,0,0,0,0,0c0.7,0,1.8-0.1,2.6-0.7c0.9-0.5,1.3-1.4,1.3-2.5l0-2.5C12.4,8.5,12,8.1,11.4,8.1z M11.8,11.6\r c0,0.9-0.3,1.6-1,2c-0.6,0.4-1.4,0.6-2.3,0.6c0,0,0,0,0,0c-0.8,0-1.5-0.1-2-0.4C5.1,13,5,11.7,5,11.6V9c0-0.2,0.2-0.4,0.5-0.5v1.9\r h0.6V8.2V4.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2.9v0.1v1.7h0.6V7.8c0-0.3,0.3-0.4,0.5-0.4s0.5,0.1,0.5,0.4v0.6v0.1v1h0.6v-1\r C9.4,8.2,9.6,8,9.9,8s0.5,0.1,0.5,0.4V9v0.1v0.4H11V9.1c0-0.3,0.2-0.4,0.4-0.4c0.2,0,0.4,0.1,0.4,0.4L11.8,11.6z'})));}}]);return ModuleInteraction;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ModuleInteraction);

/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleSlideshow=function(_Icon){_inherits(ModuleSlideshow,_Icon);function ModuleSlideshow(){_classCallCheck(this,ModuleSlideshow);return _possibleConstructorReturn(this,(ModuleSlideshow.__proto__||Object.getPrototypeOf(ModuleSlideshow)).apply(this,arguments));}_createClass(ModuleSlideshow,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M17.7,12.6V2.6l-0.3-0.3H3.6L3.3,2.6v10.1l0.3,0.3h13.8L17.7,12.6z M17.1,2.9V4L12.4,9L9.8,7.7l-0.3,0\r l-5.6,3.6V2.9H17.1z M3.9,12.4v-0.3l5.8-3.7l2.1,1.1l-1.8,1.2l0.3,0.5l2.2-1.4l0.1,0l4.5-4.8v7.5H3.9z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M6.7,7.3c0.9,0,1.7-0.8,1.7-1.7l0,0c0,0,0,0,0,0c0-0.9-0.8-1.7-1.7-1.7S5,4.7,5,5.6c0,0,0,0,0,0l0,0\r C5,6.5,5.8,7.3,6.7,7.3z M6.7,4.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C5.6,5,6.1,4.5,6.7,4.5z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M1.8,5.5l-1.5,2c-0.1,0.1-0.1,0.3,0,0.4l1.5,2l0.5-0.4L0.9,7.6l1.4-1.8L1.8,5.5z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M20.8,7.4l-1.5-2l-0.5,0.4l1.4,1.8l-1.4,1.8l0.5,0.4l1.5-2C20.8,7.7,20.8,7.5,20.8,7.4z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M7.4,14.8c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.1-0.2-0.1-0.4C6.9,14.2,6.9,14,7,14c0.2-0.2,0.5-0.2,0.7,0\r c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.3-0.1,0.4C7.6,14.8,7.5,14.8,7.4,14.8z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M11.6,14.3c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5l0,0\r C11.8,14.8,11.6,14.6,11.6,14.3z M10,14.3c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5l0,0\r C10.3,14.8,10,14.6,10,14.3z M8.4,14.3c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3-0.2,0.5-0.5,0.5l0,0\r C8.7,14.8,8.4,14.6,8.4,14.3z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M13.7,14.8c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.1,0-0.2,0.1-0.3c0.2-0.2,0.5-0.2,0.7,0\r c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.3-0.1,0.4C14,14.8,13.8,14.8,13.7,14.8z'}))));}}]);return ModuleSlideshow;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);ModuleSlideshow.defaultProps={color:'#FFFFFF',size:16,viewPortSize:21};/* harmony default export */ __webpack_exports__["a"] = (ModuleSlideshow);

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleTask=function(_Icon){_inherits(ModuleTask,_Icon);function ModuleTask(){_classCallCheck(this,ModuleTask);return _possibleConstructorReturn(this,(ModuleTask.__proto__||Object.getPrototypeOf(ModuleTask)).apply(this,arguments));}_createClass(ModuleTask,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M12.4,2.3H3.6L3.3,2.6v10.9l0.3,0.3h8.8l0.3-0.3V2.6L12.4,2.3z M5.9,2.9h4.1v0.9H5.9V2.9z M12.1,13.1H3.9\r V2.9h1.4v1.2l0.3,0.3h4.7l0.3-0.3V2.9h1.4V13.1z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'7.8,10 5.9,8.8 5.6,9.3 7.8,10.6 8.2,10.5 10.5,6.2 10,5.9  '})));}}]);return ModuleTask;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ModuleTask);

/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleText=function(_Icon){_inherits(ModuleText,_Icon);function ModuleText(){_classCallCheck(this,ModuleText);return _possibleConstructorReturn(this,(ModuleText.__proto__||Object.getPrototypeOf(ModuleText)).apply(this,arguments));}_createClass(ModuleText,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M6.4,10.6l1.2-0.1V3.9L5.8,4L5.5,4.9L5,4.9l0.1-1.5H11l0,1.5l-0.4,0L10.3,4L8.5,3.9v6.5l1.3,0.1V11H6.4V10.6z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'13.4,12.6 2.6,12.6 2.3,12.3 2.3,11.5 2.9,11.5 2.9,12 13.1,12 13.1,11.5 13.7,11.5 13.7,12.3   '})));}}]);return ModuleText;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ModuleText);

/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleVideo=function(_Icon){_inherits(ModuleVideo,_Icon);function ModuleVideo(){_classCallCheck(this,ModuleVideo);return _possibleConstructorReturn(this,(ModuleVideo.__proto__||Object.getPrototypeOf(ModuleVideo)).apply(this,arguments));}_createClass(ModuleVideo,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M6.6,11l-0.5-0.2V5.1l0.5-0.2l4.2,2.8v0.5L6.6,11z M6.8,5.7v4.5l3.4-2.2L6.8,5.7z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M15.4,13.7H0.6l-0.3-0.3V2.6l0.3-0.3h14.9l0.3,0.3v10.9L15.4,13.7z M0.9,13.1h14.3V2.9H0.9V13.1z'})));}}]);return ModuleVideo;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ModuleVideo);

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleWebinar=function(_Icon){_inherits(ModuleWebinar,_Icon);function ModuleWebinar(){_classCallCheck(this,ModuleWebinar);return _possibleConstructorReturn(this,(ModuleWebinar.__proto__||Object.getPrototypeOf(ModuleWebinar)).apply(this,arguments));}_createClass(ModuleWebinar,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 250 250.05'},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M190.75 158.55a3.37 3.37 0 01-1.6-.41L153.53 139a3.38 3.38 0 013.21-6l30.64 16.5v-49L156.74 117a3.38 3.38 0 11-3.21-5.94l35.62-19.18a3.37 3.37 0 015 3v60.28a3.37 3.37 0 01-3.38 3.38z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M144.18 169.51h-74a14.37 14.37 0 01-14.34-14.34V94.89A14.37 14.37 0 0170.2 80.55h74a14.37 14.37 0 0114.34 14.34V114a3.38 3.38 0 01-6.76 0v-6.4V94.89a7.59 7.59 0 00-7.58-7.58h-74a7.59 7.59 0 00-7.58 7.58v60.28a7.59 7.59 0 007.58 7.58h74a7.59 7.59 0 007.58-7.58v-19a3.38 3.38 0 016.76 0v19a14.37 14.37 0 01-14.36 14.34z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M127.14 250.05h-2.29c-27.18-.41-52.63-8.71-73.61-24A124.66 124.66 0 010 125.12c.11-24.57 7.46-47.73 21.85-68.82a133.39 133.39 0 0126.22-28.61C76.94 4.83 108.54.68 124.81.24L231.27 0a17.56 17.56 0 0113.32 5.58 17.92 17.92 0 014.26 10.15c1 9 1.42 52 1 109.44v.08a155.05 155.05 0 01-8.37 43.11c-9.59 27.86-25.68 49.16-47.8 63.3-19.15 12.21-41.51 18.39-66.54 18.39zM231.69 6.76h-.35L124.91 7c-15.34.42-45.31 4.35-72.64 26C44.71 39 7 71.54 6.76 125.15a117.86 117.86 0 0048.46 95.43c19.84 14.46 44 22.32 69.73 22.7 24.62.38 46.49-5.46 65-17.31 49.24-31.47 52.81-93.68 53.06-100.9.45-56.3.09-99.92-.91-108.56a11.2 11.2 0 00-2.57-6.41 10.83 10.83 0 00-7.84-3.34z'})));}}]);return ModuleWebinar;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ModuleWebinar);

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModuleQuiziframe=function(_Icon){_inherits(ModuleQuiziframe,_Icon);function ModuleQuiziframe(){_classCallCheck(this,ModuleQuiziframe);return _possibleConstructorReturn(this,(ModuleQuiziframe.__proto__||Object.getPrototypeOf(ModuleQuiziframe)).apply(this,arguments));}_createClass(ModuleQuiziframe,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http:ww.w3.org/2000/svg',x:'0px',y:'0px','enable-background':'new 0 0 512 512',viewBox:'0 0 512 512'},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'m95.72 178.319c26.411 0 47.898-21.487 47.898-47.898s-21.487-47.898-47.898-47.898-47.897 21.487-47.897 47.898 21.485 47.898 47.897 47.898zm0-80.796c18.141 0 32.898 14.758 32.898 32.898s-14.758 32.898-32.898 32.898-32.897-14.758-32.897-32.898c-.001-18.14 14.757-32.898 32.897-32.898z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'m154.637 130.421c0 26.411 21.487 47.898 47.898 47.898s47.897-21.487 47.897-47.898-21.486-47.898-47.897-47.898-47.898 21.487-47.898 47.898zm80.795 0c0 18.14-14.758 32.898-32.897 32.898-18.141 0-32.898-14.758-32.898-32.898s14.758-32.898 32.898-32.898 32.897 14.758 32.897 32.898z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'m309.349 178.319c26.411 0 47.898-21.487 47.898-47.898s-21.487-47.898-47.898-47.898-47.898 21.487-47.898 47.898 21.487 47.898 47.898 47.898zm0-80.796c18.141 0 32.898 14.758 32.898 32.898s-14.758 32.898-32.898 32.898-32.898-14.758-32.898-32.898 14.758-32.898 32.898-32.898z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'m265.738 51.131h-210.416c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h210.416c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'m95.72 327.858c26.411 0 47.898-21.487 47.898-47.898s-21.487-47.898-47.898-47.898-47.897 21.487-47.897 47.898 21.485 47.898 47.897 47.898zm0-80.796c18.141 0 32.898 14.758 32.898 32.898s-14.758 32.898-32.898 32.898-32.897-14.758-32.897-32.898 14.757-32.898 32.897-32.898z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'m154.637 279.96c0 26.411 21.487 47.898 47.898 47.898s47.897-21.487 47.897-47.898-21.486-47.898-47.897-47.898-47.898 21.487-47.898 47.898zm80.795 0c0 18.14-14.758 32.898-32.897 32.898-18.141 0-32.898-14.758-32.898-32.898s14.758-32.898 32.898-32.898 32.897 14.758 32.897 32.898z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'m55.322 215.67h210.416c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-210.416c-4.143 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'m95.72 482.77c26.411 0 47.898-21.487 47.898-47.898s-21.487-47.898-47.898-47.898-47.897 21.487-47.897 47.898 21.485 47.898 47.897 47.898zm0-80.796c18.141 0 32.898 14.758 32.898 32.898s-14.758 32.898-32.898 32.898-32.897-14.758-32.897-32.898 14.757-32.898 32.897-32.898z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'m154.637 434.872c0 26.411 21.487 47.898 47.898 47.898s47.897-21.487 47.897-47.898-21.486-47.898-47.897-47.898-47.898 21.487-47.898 47.898zm80.795 0c0 18.14-14.758 32.898-32.897 32.898-18.141 0-32.898-14.758-32.898-32.898s14.758-32.898 32.898-32.898 32.897 14.758 32.897 32.898z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'m309.349 482.77c26.411 0 47.898-21.487 47.898-47.898s-21.487-47.898-47.898-47.898-47.898 21.487-47.898 47.898 21.487 47.898 47.898 47.898zm0-80.796c18.141 0 32.898 14.758 32.898 32.898s-14.758 32.898-32.898 32.898-32.898-14.758-32.898-32.898 14.758-32.898 32.898-32.898z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'m55.322 370.582h210.416c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-210.416c-4.143 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'m483.829 92.191 4.659-11.685c4.17-10.459-.946-22.36-11.406-26.531l-20.323-8.104c-5.068-2.021-10.62-1.947-15.632.21-5.009 2.155-8.88 6.131-10.899 11.195l-9.289 23.297c-3.773 1.888-7.142 4.669-9.744 8.273-2.105 2.911-4.218 5.957-6.333 9.115v-67.181c0-16.972-13.813-30.78-30.79-30.78h-343.081c-16.972 0-30.779 13.808-30.779 30.78v374.464c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-374.464c0-8.701 7.078-15.78 15.779-15.78h343.08c8.707 0 15.79 7.079 15.79 15.78v91.488c-13.252 23.163-26.204 50.286-37.786 79.334-5.335 13.378-10.175 26.673-14.471 39.666-8.106-5.937-17.922-9.208-28.253-9.208-26.412 0-47.9 21.488-47.9 47.9s21.488 47.9 47.9 47.9c2.582 0 5.13-.202 7.634-.602-4.358 35.705.523 56.638 14.54 62.229 2.252.897 4.604 1.345 7.057 1.345 13.45-.001 29.893-13.475 49.007-40.202.757-1.058 1.514-2.138 2.272-3.228v133.818c0 8.701-7.083 15.78-15.79 15.78h-343.08c-8.701 0-15.779-7.079-15.779-15.78v-45.976c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v45.976c0 16.972 13.808 30.78 30.779 30.78h343.08c16.978 0 30.79-13.808 30.79-30.78v-157.312c14.388-24.365 28.527-53.551 41.027-84.902 8.966-22.493 16.55-44.712 22.544-66.038 1.12-3.988-1.204-8.129-5.191-9.249s-8.129 1.203-9.25 5.191c-5.851 20.821-13.266 42.536-22.036 64.542-6.995 17.544-14.5 34.368-22.26 49.988l-61.919-24.688c5.118-16.678 11.234-34.045 18.232-51.595 17.325-43.453 37.688-82.348 57.343-109.526 3.187-4.413 8.96-6.081 14.042-4.055l20.913 8.341c5.081 2.024 8.124 7.208 7.401 12.608-1.064 7.955-2.601 16.605-4.567 25.711-.874 4.049 1.699 8.04 5.748 8.914 4.04.875 8.039-1.698 8.914-5.747 2.051-9.494 3.656-18.541 4.772-26.888.439-3.279.248-6.517-.462-9.596 11.634 5.397 17.233 15.033 16.632 28.768-.852 19.371-19.019 54.82-35.047 86.096-19.627 38.297-31.502 62.44-28.479 75.68.794 3.477 3.884 5.832 7.305 5.832.553 0 1.114-.062 1.677-.19 4.038-.922 6.563-4.943 5.642-8.981-.354-1.548-.418-6.917 6.597-23.295 5.198-12.138 12.684-26.743 20.607-42.206 17.546-34.236 35.688-69.637 36.685-92.279.912-20.825-9.158-36.537-27.902-44.153zm-207.378 187.769c0-18.141 14.759-32.9 32.9-32.9 8.864 0 17.185 3.498 23.348 9.708-5.852 19.361-10.358 37.793-13.306 54.528-3.222 1.035-6.584 1.564-10.042 1.564-18.141 0-32.9-14.759-32.9-32.9zm126.366 16.886c-9.035 17.037-18.306 32.302-27.429 45.059-21.533 30.11-34.486 35.179-38.308 33.649-3.835-1.53-9.741-14.111-4.648-50.78 2.157-15.528 5.949-32.991 11.112-51.561zm40.133-217.202c-1.617-.645-3.266-1.106-4.925-1.424l6.135-15.388c.536-1.344 1.563-2.399 2.894-2.971 1.329-.572 2.803-.592 4.149-.056l20.322 8.104c2.777 1.107 4.136 4.266 3.028 7.042l-6.136 15.39c-1.424-.911-2.939-1.711-4.558-2.356z'})));}}]);return ModuleQuiziframe;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ModuleQuiziframe);

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MoveVertical=function(_Icon){_inherits(MoveVertical,_Icon);function MoveVertical(){_classCallCheck(this,MoveVertical);return _possibleConstructorReturn(this,(MoveVertical.__proto__||Object.getPrototypeOf(MoveVertical)).apply(this,arguments));}_createClass(MoveVertical,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'7.3,1.9 7.3,6.9 8.7,6.9 8.7,1.9 12.3,4 13,2.7 8.4,0 7.6,0 3,2.7 3.7,4   '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'8.7,14.1 8.7,9.1 7.3,9.1 7.3,14 3.7,12 3,13.3 7.6,16 8.4,16 13,13.3 12.3,12   '})));}}]);return MoveVertical;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (MoveVertical);

/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AudioHigher=function(_Icon){_inherits(AudioHigher,_Icon);function AudioHigher(){_classCallCheck(this,AudioHigher);return _possibleConstructorReturn(this,(AudioHigher.__proto__||Object.getPrototypeOf(AudioHigher)).apply(this,arguments));}_createClass(AudioHigher,[{key:'render',value:function render(){var _props=this.props,strokeWidth=_props.strokeWidth,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['strokeWidth','color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{stroke:'none',strokeWidth:'1',fill:'none','fill-rule':'evenodd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{transform:'translate(-1324.000000, -127.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{transform:'translate(1325.000000, 128.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M1.45571886e-16,17.3568204 L8.83131951e-16,29.2979765 L8.04265817,21.3157895 L33.4051746,21.3157895 C34.2850016,21.3157895 35,20.5984831 35,19.7136408 L35,1.60214866 C35,0.709214461 34.2859724,0 33.4051746,0 L1.59482539,0 C0.714998385,0 0,0.71730639 0,1.60214866 L0,17.3568204 Z',stroke:color,strokeWidth:strokeWidth||"0.8"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M23.5673844,9.96491228 L20.4430782,9.96491228 C20.1311481,9.96491228 19.8863636,10.2162612 19.8863636,10.5263158 C19.8863636,10.8273026 20.1356133,11.0877193 20.4430782,11.0877193 L23.5673844,11.0877193 L23.5673844,14.2120254 C23.5673844,14.5239555 23.8187333,14.76874 24.1287879,14.76874 C24.4297747,14.76874 24.6901914,14.5194904 24.6901914,14.2120254 L24.6901914,11.0877193 L27.8144975,11.0877193 C28.1264276,11.0877193 28.3712121,10.8363704 28.3712121,10.5263158 C28.3712121,10.2253289 28.1219625,9.96491228 27.8144975,9.96491228 L24.6901914,9.96491228 L24.6901914,6.84060615 C24.6901914,6.52867605 24.4388425,6.28389155 24.1287879,6.28389155 C23.827801,6.28389155 23.5673844,6.53314117 23.5673844,6.84060615 L23.5673844,9.96491228 Z',fill:color}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M5.56818182,7.67942584 C5.56818182,7.36232455 5.82552552,7.10526316 6.13291209,7.10526316 L11.3670879,7.10526316 C11.6789798,7.10526316 11.9318182,7.37159839 11.9318182,7.67942584 C11.9318182,7.99652713 11.6744745,8.25358852 11.3670879,8.25358852 L6.13291209,8.25358852 C5.82102017,8.25358852 5.56818182,7.98725329 5.56818182,7.67942584 Z M5.56818182,10.2631579 C5.56818182,9.9460566 5.83284378,9.68899522 6.14025311,9.68899522 L12.950656,9.68899522 C13.2666022,9.68899522 13.5227273,9.95533044 13.5227273,10.2631579 C13.5227273,10.5802592 13.2580653,10.8373206 12.950656,10.8373206 L6.14025311,10.8373206 C5.82430686,10.8373206 5.56818182,10.5709853 5.56818182,10.2631579 Z M5.56818182,12.84689 C5.56818182,12.5297887 5.82297765,12.2727273 6.14193853,12.2727273 L12.153516,12.2727273 C12.4703931,12.2727273 12.7272727,12.5390625 12.7272727,12.84689 C12.7272727,13.1639912 12.4724769,13.4210526 12.153516,13.4210526 L6.14193853,13.4210526 C5.82506145,13.4210526 5.56818182,13.1547174 5.56818182,12.84689 Z',fill:color})))));}}]);return AudioHigher;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);AudioHigher.defaultProps={color:'#F8AC5B',size:37,viewPortSize:37};/* harmony default export */ __webpack_exports__["a"] = (AudioHigher);

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Pause=function(_Icon){_inherits(Pause,_Icon);function Pause(){_classCallCheck(this,Pause);return _possibleConstructorReturn(this,(Pause.__proto__||Object.getPrototypeOf(Pause)).apply(this,arguments));}_createClass(Pause,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'3.8',y:'1',width:'1.5',height:'14'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'10.8',y:'1',width:'1.5',height:'14'})));}}]);return Pause;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Pause);

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Play=function(_Icon){_inherits(Play,_Icon);function Play(){_classCallCheck(this,Play);return _possibleConstructorReturn(this,(Play.__proto__||Object.getPrototypeOf(Play)).apply(this,arguments));}_createClass(Play,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M2.1,16.8L1,16.2V-0.2l1.2-0.6l12.5,8.2v1.3L2.1,16.8z M2.5,1.2v13.7L12.9,8L2.5,1.2z'})));}}]);return Play;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Play);

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Plus=function(_Icon){_inherits(Plus,_Icon);function Plus(){_classCallCheck(this,Plus);return _possibleConstructorReturn(this,(Plus.__proto__||Object.getPrototypeOf(Plus)).apply(this,arguments));}_createClass(Plus,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'16,7 9,7 9,0 7,0 7,7 0,7 0,9 7,9 7,16 9,16 9,9 16,9 '})));}}]);return Plus;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Plus);

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Preview=function(_Icon){_inherits(Preview,_Icon);function Preview(){_classCallCheck(this,Preview);return _possibleConstructorReturn(this,(Preview.__proto__||Object.getPrototypeOf(Preview)).apply(this,arguments));}_createClass(Preview,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M16.8,8.3C16.6,8,13.1,2,8.5,2C3.9,2,0.4,8,0.2,8.3L0,8.7l0.3,0.4c0.1,0.2,3.7,5.2,8.2,5.2c4.5,0,8.1-5,8.2-5.2L17,8.7\r L16.8,8.3z M8.5,3.5c2,0,3.9,1.6,5.2,3.1c-1.4-0.5-3.2-1-5.2-1c-2,0-3.8,0.5-5.2,1C4.6,5.1,6.5,3.5,8.5,3.5z M8.5,7.3\r c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7S6.8,9.9,6.8,9C6.8,8,7.6,7.3,8.5,7.3z M8.5,12.8c-2.9,0-5.5-2.7-6.5-4\r c0.8-0.4,2.1-1.1,3.8-1.5C5.5,7.9,5.3,8.4,5.3,9c0,1.8,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2c0-0.6-0.2-1.1-0.5-1.6\r c1.7,0.4,3,1.1,3.8,1.5C14,10.1,11.4,12.8,8.5,12.8z'})));}}]);return Preview;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);Preview.defaultProps={color:'#FFFFFF',size:16,viewPortSize:18};/* harmony default export */ __webpack_exports__["a"] = (Preview);

/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoursioLogo=function(_Icon){_inherits(CoursioLogo,_Icon);function CoursioLogo(){_classCallCheck(this,CoursioLogo);return _possibleConstructorReturn(this,(CoursioLogo.__proto__||Object.getPrototypeOf(CoursioLogo)).apply(this,arguments));}_createClass(CoursioLogo,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M2.7,5c-0.4,0.6-1,0.9-1.7,0.9c-0.3,0-0.5-0.1-0.7-0.2C0.1,6.3,0,6.9,0,7.5c1,0,1.8,0.6,2,1.6v0c0,0,0,0,0,0\r c0.2,1-0.4,1.9-1.3,2.2c0.2,0.5,0.5,1.1,0.9,1.5c0.7-0.6,1.8-0.7,2.5-0.1c0.7,0.6,0.9,1.7,0.4,2.5c0.5,0.3,1.1,0.5,1.7,0.6\r C6.2,14.9,7,14.1,8,14.1c1,0,1.8,0.7,1.9,1.7c0.6-0.1,1.1-0.3,1.7-0.6c-0.5-0.8-0.4-1.9,0.4-2.5c0.8-0.6,1.8-0.6,2.5,0.1\r c0.3-0.5,0.7-1,0.9-1.5c-0.9-0.3-1.5-1.2-1.3-2.2c0.2-1,1-1.6,2-1.6c0-0.6-0.1-1.2-0.3-1.8c-0.2,0.1-0.5,0.2-0.7,0.2\r c-0.7,0-1.3-0.3-1.7-1c-0.5-0.8-0.3-1.9,0.5-2.5c-0.4-0.4-0.9-0.8-1.4-1.2c-0.3,0.6-1,1-1.7,1c-0.2,0-0.4,0-0.7-0.1\r C9.2,1.9,8.7,1,8.9,0.1C8.6,0,8.3,0,8,0C7.7,0,7.4,0,7.1,0C7.3,1,6.8,1.9,5.9,2.3C5.7,2.3,5.5,2.4,5.3,2.4C4.6,2.4,3.9,2,3.6,1.3\r C3.1,1.7,2.6,2,2.2,2.5C3,3,3.2,4.1,2.7,5z M8,3.4c2.5,0,4.6,2.1,4.6,4.6c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6\r C3.4,5.5,5.5,3.4,8,3.4z'})));}}]);return CoursioLogo;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CoursioLogo);

/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Sort=function(_Icon){_inherits(Sort,_Icon);function Sort(){_classCallCheck(this,Sort);return _possibleConstructorReturn(this,(Sort.__proto__||Object.getPrototypeOf(Sort)).apply(this,arguments));}_createClass(Sort,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'18.5,4.8 14.3,2.4 13.5,2.4 9.3,4.8 10,6.1 13.1,4.3 13.1,13 14.6,13 14.6,4.3 17.7,6.1  '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'6.9,15.7 6.9,7 5.4,7 5.4,15.7 2.3,13.9 1.5,15.2 5.7,17.6 6.5,17.6 10.7,15.2 10,13.9   '})));}}]);return Sort;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);Sort.defaultProps={color:'#FFFFFF',size:16,viewPortSize:18};/* harmony default export */ __webpack_exports__["a"] = (Sort);

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Stats=function(_Icon){_inherits(Stats,_Icon);function Stats(){_classCallCheck(this,Stats);return _possibleConstructorReturn(this,(Stats.__proto__||Object.getPrototypeOf(Stats)).apply(this,arguments));}_createClass(Stats,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'14.8,13.5 14.8,1 12.8,1 12.8,13.5 10.9,13.5 10.9,4.2 8.9,4.2 8.9,13.5 7.1,13.5 7.1,7.5 5.1,7.5\r 5.1,13.5 3.2,13.5 3.2,6.5 1.2,6.5 1.2,13.5 0,13.5 0,15 16,15 16,13.5 '})));}}]);return Stats;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Stats);

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Students=function(_Icon){_inherits(Students,_Icon);function Students(){_classCallCheck(this,Students);return _possibleConstructorReturn(this,(Students.__proto__||Object.getPrototypeOf(Students)).apply(this,arguments));}_createClass(Students,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M10.4,7.3c1-0.7,1.6-1.9,1.6-3.2C12,1.8,10.2,0,8,0S3.9,1.8,3.9,4.1c0,1.3,0.7,2.5,1.7,3.3\r C2.8,8.6,2,11.8,2,13.8C2,15.8,6.2,16,8,16s6-0.2,6-2.1C14,11.8,13.2,8.5,10.4,7.3z M8,1.4c1.5,0,2.7,1.2,2.7,2.7S9.4,6.8,8,6.8\r S5.3,5.6,5.3,4.1S6.5,1.4,8,1.4z M8,14.6c-2.9,0-4.4-0.5-4.6-0.7c0-0.6,0.1-5.6,4.6-5.6c4.5,0,4.6,5,4.6,5.5\r C12.4,14,10.9,14.6,8,14.6z'})));}}]);return Students;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Students);

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextB=function(_Icon){_inherits(TextB,_Icon);function TextB(){_classCallCheck(this,TextB);return _possibleConstructorReturn(this,(TextB.__proto__||Object.getPrototypeOf(TextB)).apply(this,arguments));}_createClass(TextB,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M5.2,3.2H8c0.4,0,0.8,0,1.2,0.1c0.4,0.1,0.7,0.2,0.9,0.3s0.5,0.3,0.6,0.6c0.2,0.3,0.2,0.6,0.2,1c0,0.2,0,0.3-0.1,0.5\r c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.2-0.2,0.3-0.4,0.4S9.9,6.8,9.7,6.9v0c0.6,0.1,1,0.3,1.2,0.6c0.3,0.3,0.4,0.7,0.4,1.2\r c0,0.4-0.1,0.7-0.2,1c-0.2,0.3-0.4,0.5-0.7,0.7c-0.3,0.2-0.6,0.3-1,0.4C9.1,11,8.7,11,8.2,11h-3V3.2z M8,6.3c0.3,0,0.6-0.1,0.7-0.2\r c0.2-0.2,0.2-0.3,0.2-0.6c0-0.2-0.1-0.4-0.2-0.5C8.5,4.9,8.3,4.8,8,4.8H7.3v1.5H8z M8.1,9.5c0.8,0,1.2-0.3,1.2-0.9\r c0-0.3-0.1-0.5-0.3-0.6C8.8,7.8,8.5,7.8,8.1,7.8H7.3v1.7H8.1z'})));}}]);return TextB;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TextB);

/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextH1=function(_Icon){_inherits(TextH1,_Icon);function TextH1(){_classCallCheck(this,TextH1);return _possibleConstructorReturn(this,(TextH1.__proto__||Object.getPrototypeOf(TextH1)).apply(this,arguments));}_createClass(TextH1,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M2.2,3.2h1v3.3h3.7V3.2h1V11h-1V7.3H3.2V11h-1V3.2z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M9.9,10.2h1.8V4.6h-1.4V4c0.4-0.1,0.7-0.1,0.9-0.2c0.3-0.1,0.5-0.2,0.7-0.3h0.8v6.8h1.6V11H9.9V10.2z'})));}}]);return TextH1;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TextH1);

/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextH2=function(_Icon){_inherits(TextH2,_Icon);function TextH2(){_classCallCheck(this,TextH2);return _possibleConstructorReturn(this,(TextH2.__proto__||Object.getPrototypeOf(TextH2)).apply(this,arguments));}_createClass(TextH2,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M2.2,3.2h1v3.3h3.7V3.2h1V11h-1V7.3H3.2V11h-1V3.2z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M9.4,10.5c0.6-0.6,1.1-1.1,1.5-1.6c0.4-0.5,0.8-0.9,1.1-1.3c0.3-0.4,0.5-0.8,0.7-1.1s0.2-0.7,0.2-1c0-0.4-0.1-0.8-0.4-1.1\r C12.4,4.2,12,4,11.6,4c-0.3,0-0.6,0.1-0.9,0.3C10.4,4.5,10.1,4.7,9.9,5L9.4,4.4c0.3-0.4,0.7-0.6,1-0.8s0.8-0.3,1.3-0.3\r c0.7,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,1,0.6,1.6c0,0.4-0.1,0.7-0.2,1.1c-0.2,0.4-0.4,0.7-0.6,1.1c-0.3,0.4-0.6,0.8-1,1.2\r s-0.8,0.9-1.3,1.3c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0h2.2V11H9.4V10.5z'})));}}]);return TextH2;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TextH2);

/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextH3=function(_Icon){_inherits(TextH3,_Icon);function TextH3(){_classCallCheck(this,TextH3);return _possibleConstructorReturn(this,(TextH3.__proto__||Object.getPrototypeOf(TextH3)).apply(this,arguments));}_createClass(TextH3,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M2.2,3.2h1v3.3h3.7V3.2h1V11h-1V7.3H3.2V11h-1V3.2z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M9.7,9.5c0.2,0.2,0.5,0.5,0.8,0.6c0.3,0.2,0.7,0.3,1.1,0.3c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.6,0.4-1\r c0-0.2,0-0.4-0.1-0.6S12.9,8,12.7,7.9c-0.2-0.1-0.4-0.2-0.8-0.3c-0.3-0.1-0.7-0.1-1.2-0.1V6.7c0.4,0,0.8,0,1-0.1\r c0.3-0.1,0.5-0.2,0.7-0.3c0.2-0.1,0.3-0.3,0.4-0.5C13,5.6,13,5.5,13,5.3c0-0.4-0.1-0.7-0.4-0.9c-0.2-0.2-0.6-0.3-1-0.3\r c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.1-0.5,0.3-0.8,0.6L9.5,4.2c0.3-0.3,0.6-0.5,1-0.7c0.4-0.2,0.8-0.3,1.2-0.3c0.3,0,0.6,0,0.9,0.1\r c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.4,0.4,0.5,0.6C14,4.6,14,4.9,14,5.2c0,0.5-0.1,0.8-0.4,1.1S13,6.9,12.6,7v0\r c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0.1,0.4,0.2,0.5,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0.1,0.7c0,0.3-0.1,0.6-0.2,0.9\r c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.6,0.1-1,0.1c-0.3,0-0.6,0-0.8-0.1c-0.3-0.1-0.5-0.1-0.7-0.2\r c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.3-0.3-0.4-0.4L9.7,9.5z'})));}}]);return TextH3;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TextH3);

/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextI=function(_Icon){_inherits(TextI,_Icon);function TextI(){_classCallCheck(this,TextI);return _possibleConstructorReturn(this,(TextI.__proto__||Object.getPrototypeOf(TextI)).apply(this,arguments));}_createClass(TextI,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M8.5,3.2h0.9L7.8,11H6.9L8.5,3.2z'})));}}]);return TextI;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TextI);

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextP=function(_Icon){_inherits(TextP,_Icon);function TextP(){_classCallCheck(this,TextP);return _possibleConstructorReturn(this,(TextP.__proto__||Object.getPrototypeOf(TextP)).apply(this,arguments));}_createClass(TextP,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M5.6,3.2H8c0.4,0,0.8,0,1.2,0.1c0.4,0.1,0.7,0.2,0.9,0.4c0.3,0.2,0.4,0.4,0.6,0.7c0.1,0.3,0.2,0.7,0.2,1.1\r c0,0.4-0.1,0.8-0.2,1.1c-0.1,0.3-0.3,0.6-0.6,0.8C9.9,7.5,9.6,7.7,9.2,7.8C8.9,7.9,8.5,7.9,8,7.9H6.6V11h-1V3.2z M7.9,7.1\r c0.7,0,1.2-0.1,1.5-0.4C9.8,6.5,9.9,6,9.9,5.5c0-0.6-0.2-1-0.5-1.2C9.1,4.1,8.6,4,7.9,4H6.6v3.1H7.9z'})));}}]);return TextP;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TextP);

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tool=function(_Icon){_inherits(Tool,_Icon);function Tool(){_classCallCheck(this,Tool);return _possibleConstructorReturn(this,(Tool.__proto__||Object.getPrototypeOf(Tool)).apply(this,arguments));}_createClass(Tool,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({width:size,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M14.1,9c-0.2-0.2-0.4-0.2-0.7-0.2l-2.1,0.6L9.3,7.4L8.6,6.7L6.6,4.6l0.6-2.1c0.1-0.2,0-0.5-0.2-0.7L5.1,0\r l-1,1l1.6,1.6L5,5L2.6,5.7L1,4.1l-1,1L1.9,7C2,7.1,2.2,7.2,2.4,7.2c0.1,0,0.1,0,0.2,0l2.1-0.6l2.1,2.1l0.6,0.6l2.1,2.1l-0.6,2.1\r c-0.1,0.2,0,0.5,0.2,0.7l1.9,1.9l1-1l-1.6-1.6L11,11l2.5-0.7l1.6,1.6l1-1L14.1,9z'})));}}]);return Tool;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Tool);

/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AudioHigher=function(_Icon){_inherits(AudioHigher,_Icon);function AudioHigher(){_classCallCheck(this,AudioHigher);return _possibleConstructorReturn(this,(AudioHigher.__proto__||Object.getPrototypeOf(AudioHigher)).apply(this,arguments));}_createClass(AudioHigher,[{key:'render',value:function render(){var _props=this.props,color=_props.color,size=_props.size,style=_props.style,viewPortSize=_props.viewPortSize,className=_props.className,props=_objectWithoutProperties(_props,['color','size','style','viewPortSize','className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:size,style:style,height:size,version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 '+viewPortSize+' '+viewPortSize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{stroke:'none',strokeWidth:'1',fill:'none','fill-rule':'evenodd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{transform:'translate(-870.000000, -602.000000)',fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{transform:'translate(556.000000, 602.000000)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M334.737314,8.01699916 C335.291302,9.23029424 335.6,10.579097 335.6,12 C335.6,17.3019339 331.301934,21.6 326,21.6 C320.698066,21.6 316.4,17.3019339 316.4,12 C316.4,6.69806614 320.698066,2.4 326,2.4 C328.943687,2.4 331.577923,3.72491397 333.338914,5.81094638 L326.135612,12.6738641 L323.000233,9.53871845 L321.238913,11.3000388 L326.118369,16.1794951 L334.737314,8.01699916 Z M326,24 C332.627417,24 338,18.6274173 338,12 C338,5.37258267 332.627417,0 326,0 C319.372583,0 314,5.37258267 314,12 C314,18.6274173 319.372583,24 326,24 Z'})))));}}]);return AudioHigher;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);AudioHigher.defaultProps={color:'#FFFFFF',size:24,viewPortSize:24};/* harmony default export */ __webpack_exports__["a"] = (AudioHigher);

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SizeSelect=function(_Icon){_inherits(SizeSelect,_Icon);function SizeSelect(){_classCallCheck(this,SizeSelect);return _possibleConstructorReturn(this,(SizeSelect.__proto__||Object.getPrototypeOf(SizeSelect)).apply(this,arguments));}_createClass(SizeSelect,[{key:'render',value:function render(){var _props=this.props,color=_props.color,style=_props.style,viewPortSize=_props.viewPortSize,width=_props.width,height=_props.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:width,style:style,height:height,x:'0px',y:'0px',version:'1.1',xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 24 24'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{fill:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M21,15H23V17H21V15M21,11H23V13H21V11M23,19H21V21C22,21 23,20 23,19M13,3H15V5H13V3M21,7H23V9H21V7M21,3V5H23C23,4 22,3 21,3M1,7H3V9H1V7M17,3H19V5H17V3M17,19H19V21H17V19M3,3C2,3 1,4 1,5H3V3M9,3H11V5H9V3M5,3H7V5H5V3M1,11V19A2,2 0 0,0 3,21H15V11H1M3,19L5.5,15.79L7.29,17.94L9.79,14.72L13,19H3Z'})));}}]);return SizeSelect;}(__WEBPACK_IMPORTED_MODULE_1__Icon__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SizeSelect);

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_cJ',fixed:'_cK',bottom:'_cL',top:'_cM',depth0:'_cN',depth1:'_cO',depth2:'_cP',depth3:'_cQ',depth4:'_cR',depth5:'_cS',toolbar:'_cT',dense:'_cU',center:'_cV'};var Toolbar=function(_Component){_inherits(Toolbar,_Component);function Toolbar(){_classCallCheck(this,Toolbar);return _possibleConstructorReturn(this,(Toolbar.__proto__||Object.getPrototypeOf(Toolbar)).apply(this,arguments));}_createClass(Toolbar,[{key:'render',value:function render(){var _classNames,_classNames2;var _props=this.props,children=_props.children,dense=_props.dense,top=_props.top,zDepth=_props.zDepth,bottom=_props.bottom,fixed=_props.fixed,transparent=_props.transparent,color=_props.color,center=_props.center,other=_objectWithoutProperties(_props,['children','dense','top','zDepth','bottom','fixed','transparent','color','center']);var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.root,css['depth'+zDepth],(_classNames={},_defineProperty(_classNames,css.top,top),_defineProperty(_classNames,css.bottom,bottom),_defineProperty(_classNames,css.fixed,fixed),_classNames));var backgroundColor=transparent?null:color?color:__WEBPACK_IMPORTED_MODULE_1_Css__["Colors"].material.grey[200].hex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:classes,style:{backgroundColor:backgroundColor}},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.toolbar,(_classNames2={},_defineProperty(_classNames2,css.center,center),_defineProperty(_classNames2,css.dense,dense),_classNames2))},children));}}]);return Toolbar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Toolbar.propTypes={color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,center:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,fixed:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,top:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,bottom:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,transparent:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,dense:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,zDepth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number};Toolbar.defaultProps={zDepth:0};/* harmony default export */ __webpack_exports__["a"] = (Toolbar);

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_cF',transparent:'_cG',right:'_cH',fullWidth:'_cI'};var ToolbarGroup=function(_Component){_inherits(ToolbarGroup,_Component);function ToolbarGroup(){_classCallCheck(this,ToolbarGroup);return _possibleConstructorReturn(this,(ToolbarGroup.__proto__||Object.getPrototypeOf(ToolbarGroup)).apply(this,arguments));}_createClass(ToolbarGroup,[{key:'render',value:function render(){var _classNames;var _props=this.props,children=_props.children,right=_props.right,fullWidth=_props.fullWidth,transparent=_props.transparent,other=_objectWithoutProperties(_props,['children','right','fullWidth','transparent']);var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.root,(_classNames={},_defineProperty(_classNames,css.right,right),_defineProperty(_classNames,css.transparent,transparent),_defineProperty(_classNames,css.fullWidth,fullWidth),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:classes},other),children);}}]);return ToolbarGroup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ToolbarGroup.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,right:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,transparent:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,fullWidth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (ToolbarGroup);

/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Tooltip__ = __webpack_require__(366);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={button:'_cB',dense:'_cC',disabled:'_cD',active:'_cE'};var ToolbarButton=function(_Component){_inherits(ToolbarButton,_Component);function ToolbarButton(){var _ref,_arguments=arguments;var _temp,_this,_ret;for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_classCallCheck(this,ToolbarButton);return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ToolbarButton.__proto__||Object.getPrototypeOf(ToolbarButton)).call.apply(_ref,[this].concat(args))),_this),_this.state={hover:false,active:false},_this.getNode=function(){return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this);},_this.handleMouseEnter=function(){_this.setState({hover:true});},_this.handleMouseLeave=function(){_this.setState({hover:false});},_this.handleFocus=function(){_this.setState({active:true});},_this.handleBlur=function(){var onBlur=_this.props.onBlur;_this.setState({active:false});onBlur&&onBlur();},_this.handleTouchTap=function(event){event.preventDefault();event.stopPropagation();var _this$props=_this.props,onTouchTap=_this$props.onTouchTap,disabled=_this$props.disabled;if(!disabled&&onTouchTap){onTouchTap.apply(undefined,_arguments);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ToolbarButton,[{key:'componentDidMount',value:function componentDidMount(){this._node=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.disabled){this.setState({hover:false,active:false});}}},{key:'render',value:function render(){var _classNames;var _props=this.props,className=_props.className,dense=_props.dense,disabled=_props.disabled,tooltip=_props.tooltip,children=_props.children,other=_objectWithoutProperties(_props,['className','dense','disabled','tooltip','children']);var _state=this.state,hover=_state.hover,active=_state.active;var classes=__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.button,className,(_classNames={},_defineProperty(_classNames,css.disabled,disabled),_defineProperty(_classNames,css.active,active),_defineProperty(_classNames,css.dense,dense),_classNames));var handlers=disabled?{}:{onFocus:this.handleFocus,onBlur:this.handleBlur,onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave,onTouchTap:this.handleTouchTap};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',Object.assign({},other,handlers,{className:classes}),children,hover&&tooltip&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Tooltip__["a" /* default */],{anchorTo:this.getNode},tooltip));}}]);return ToolbarButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ToolbarButton.propTypes={tooltip:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,disabled:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,dense:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onTouchTap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onBlur:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (ToolbarButton);

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(1953),
    isArguments = __webpack_require__(1954),
    isArray = __webpack_require__(1955);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 1953 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 1954 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 1955 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Tooltip__ = __webpack_require__(366);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={button:'_cw',dense:'_cx',selected:'_cy',disabled:'_cz',active:'_cA'};var TabButton=function(_Component){_inherits(TabButton,_Component);function TabButton(){var _ref,_arguments=arguments;var _temp,_this,_ret;for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_classCallCheck(this,TabButton);return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TabButton.__proto__||Object.getPrototypeOf(TabButton)).call.apply(_ref,[this].concat(args))),_this),_this.state={hover:false,active:false},_this.getNode=function(){return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this);},_this.handleMouseEnter=function(){_this.setState({hover:true});},_this.handleMouseLeave=function(){_this.setState({hover:false});},_this.handleFocus=function(){_this.setState({active:true});},_this.handleBlur=function(){var onBlur=_this.props.onBlur;_this.setState({active:false});onBlur&&onBlur();},_this.handleTouchTap=function(event){event.preventDefault();event.stopPropagation();var _this$props=_this.props,onTouchTap=_this$props.onTouchTap,disabled=_this$props.disabled;if(!disabled&&onTouchTap){onTouchTap.apply(undefined,_arguments);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TabButton,[{key:'componentDidMount',value:function componentDidMount(){this._node=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.disabled){this.setState({hover:false,active:false});}}},{key:'render',value:function render(){var _classNames;var _props=this.props,className=_props.className,dense=_props.dense,disabled=_props.disabled,tooltip=_props.tooltip,children=_props.children,selected=_props.selected,other=_objectWithoutProperties(_props,['className','dense','disabled','tooltip','children','selected']);var _state=this.state,hover=_state.hover,active=_state.active;var classes=__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.button,className,(_classNames={},_defineProperty(_classNames,css.disabled,disabled),_defineProperty(_classNames,css.active,active),_defineProperty(_classNames,css.selected,selected),_defineProperty(_classNames,css.dense,dense),_classNames));var handlers=disabled?{}:{onFocus:this.handleFocus,onBlur:this.handleBlur,onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave,onTouchTap:this.handleTouchTap};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',Object.assign({},other,handlers,{className:classes}),children,hover&&tooltip&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Tooltip__["a" /* default */],{anchorTo:this.getNode},tooltip));}}]);return TabButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TabButton.propTypes={tooltip:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,disabled:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,dense:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onTouchTap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onBlur:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (TabButton);

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_cv'};var ToolbarTitle=function(_Component){_inherits(ToolbarTitle,_Component);function ToolbarTitle(){_classCallCheck(this,ToolbarTitle);return _possibleConstructorReturn(this,(ToolbarTitle.__proto__||Object.getPrototypeOf(ToolbarTitle)).apply(this,arguments));}_createClass(ToolbarTitle,[{key:'render',value:function render(){var _props=this.props,children=_props.children,color=_props.color,other=_objectWithoutProperties(_props,['children','color']);var style=color?{color:color}:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:css.root,style:style},children);}}]);return ToolbarTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ToolbarTitle.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (ToolbarTitle);

/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FlexBox=function(_Component){_inherits(FlexBox,_Component);function FlexBox(){_classCallCheck(this,FlexBox);return _possibleConstructorReturn(this,(FlexBox.__proto__||Object.getPrototypeOf(FlexBox)).apply(this,arguments));}_createClass(FlexBox,[{key:'getStyle',value:function getStyle(){var _props=this.props,style=_props.style,column=_props.column,justifyContent=_props.justifyContent,wrap=_props.wrap,alignItems=_props.alignItems,alignContent=_props.alignContent,width=_props.width,height=_props.height,grow=_props.grow,shrink=_props.shrink,alignSelf=_props.alignSelf;var direction=column?'column':'row';var reverse=reverse?'-reverse':'';return Object.assign({},{// flex: 1,
display:'flex',flexDirection:direction+reverse,justifyContent:justifyContent,flexWrap:wrap,alignItems:alignItems,alignContent:alignContent,width:width,height:height,flexGrow:grow,flexShrink:shrink,alignSelf:alignSelf},style);}},{key:'render',value:function render(){var _props2=this.props,children=_props2.children,className=_props2.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className,style:this.getStyle()},children);}}]);return FlexBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FlexBox.displayName='FlexBox';FlexBox.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,reverse:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,column:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,row:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,justifyContent:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,wrap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOf(['nowrap','wrap','wrap-reverse']),alignItems:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOf(['stretch','flex-start','center','flex-end','base-line']),alignContent:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOf(['stretch','flex-start','center','flex-end','base-line','space-between','space-around']),width:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,height:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,grow:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,shrink:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,alignSelf:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOf(['stretch','flex-start','center','flex-end','base-line'])};FlexBox.defaultProps={reverse:false,column:false,row:true,justifyContent:'flex-start',wrap:'nowrap',alignItems:'stretch',alignContent:'stretch',grow:1,shrink:1,alignSelf:'stretch'};/* harmony default export */ __webpack_exports__["a"] = (FlexBox);

/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_PageModule__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// https://github.com/miguelmota/audio-oscilloscope
window.AudioContext=window.AudioContext||window.webkitAudioContext||window.mozAudioContext;window.URL=window.URL||window.webkitURL||window.mozURL;navigator.getUserMedia=navigator.getUserMedia||navigator.webkitGetUserMedia||navigator.mozGetUserMedia;var Oscilloscope=function(_PageModule){_inherits(Oscilloscope,_PageModule);function Oscilloscope(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Oscilloscope);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Oscilloscope.__proto__||Object.getPrototypeOf(Oscilloscope)).call.apply(_ref,[this].concat(args))),_this),_this.audioContext=null,_this.analyser=null,_this.bufferLength=0,_this.dataArray=[],_this.canvasContext=null,_this.width=400,_this.height=400,_this.stream=null,_this.state={powerOn:false,accumulation:false,sync:{mode:3,vDiff:0.1,tDiff:3},autoGain:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Oscilloscope,[{key:'onInit',value:function onInit(){this.width=this.refs.container.getBoundingClientRect().width;try{this.audioContext=new AudioContext();}catch(e){alert('No audio input found.');}}},{key:'draw',value:function draw(){if(!this.state.powerOn){return;}var dataArray=this.dataArray;var bufferLength=this.bufferLength;var ctx=this.canvasContext;var w=this.width;var h=this.height;if(this.analyser){this.analyser.getByteTimeDomainData(dataArray);}ctx.fillRect(0,0,w,h);ctx.beginPath();// 'bufferLength' is usually 1024
var sliceWidth=w*1.0/bufferLength;var x=0;if(!bufferLength){ctx.moveTo(0,this.height/2);}var risingFront=false;var fallingFront=false;var zeroTrigger=false;var syncVDiff=this.state.sync.vDiff;// normalize
var maxV=Math.max.apply(null,dataArray),minV=Math.min.apply(null,dataArray),spread=maxV-minV,semiA=Math.max(maxV/128,minV/128);// console.log(maxV, minV)
for(var i=0;i<bufferLength;i++){switch(this.state.sync.mode){case 0:break;case 1:// check for rising
if(!risingFront&&i>5&&(dataArray[i-5]-dataArray[i])/spread>syncVDiff){x=0;risingFront=true;ctx.fillRect(0,0,w,h);ctx.beginPath();ctx.moveTo(0,this.height/2);}break;case 2:// check for falling
if(!fallingFront&&i>5&&(dataArray[i-5]-dataArray[i])/spread<syncVDiff){x=0;fallingFront=true;ctx.fillRect(0,0,w,h);ctx.beginPath();ctx.moveTo(0,this.height/2);}break;case 3:// check for zero + increase
if(!zeroTrigger&&i>0&&dataArray[i-1]==128&&dataArray[i]<dataArray[i-1]){x=0;zeroTrigger=true;ctx.fillRect(0,0,w,h);ctx.beginPath();ctx.moveTo(0,this.height/2);}break;}var v=dataArray[i]-128.0;if(this.state.autoGain){v*=128/spread;}var y=h/2+v;if(i===0){ctx.moveTo(x,y);}else{ctx.lineTo(x,y);}x+=sliceWidth;}ctx.lineTo(w,h/2);ctx.stroke();window.requestAnimationFrame(this.draw.bind(this));}},{key:'addSource',value:function addSource(streamSource){this.audioContext=streamSource.context;this.analyser=this.audioContext.createAnalyser();this.analyser.fftSize=2048;this.bufferLength=this.analyser.frequencyBinCount;this.source=this.audioContext.createBufferSource();this.dataArray=new Uint8Array(this.bufferLength);this.analyser.getByteTimeDomainData(this.dataArray);streamSource.connect(this.analyser);}},{key:'togglePower',value:function togglePower(){var _this2=this;var power=!this.state.powerOn;this.setState({powerOn:power});if(power){this.setState({accumulation:false});this.refs.canvas.width=this.width;this.refs.canvas.height=this.height;this.canvasContext=this.refs.canvas.getContext('2d');this.canvasContext.fillStyle='white';this.canvasContext.strokeStyle='red';this.canvasContext.lineWidth=1;navigator.getUserMedia({audio:true},function(stream){_this2.stream=stream;_this2.addSource(_this2.audioContext.createMediaStreamSource(stream));},function(error){console.error(error);});}else{if(this.stream){this.stream.getTracks()[0].stop();}}}},{key:'toggleAccumulation',value:function toggleAccumulation(){var accumulation=!this.state.accumulation;this.setState({accumulation:accumulation});this.canvasContext.fillStyle=accumulation?'rgba(0,0,0,0)':'white';}},{key:'toggleAutoGain',value:function toggleAutoGain(){var autoGain=!this.state.autoGain;this.setState({autoGain:autoGain});}},{key:'changeSyncMode',value:function changeSyncMode(e,i){var sync=this.state.sync;sync.mode=i;this.setState({sync:sync});}},{key:'changeSyncVDiff',value:function changeSyncVDiff(e,v){var sync=this.state.sync;sync.vDiff=v;this.setState({sync:sync});}},{key:'renderEditMode',value:function renderEditMode(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Device is used in reader mode.');}},{key:'renderDetailMode',value:function renderDetailMode(data){var menuItems=[{payload:'0',text:'No sync'},{payload:'1',text:'Raising front sync'},{payload:'2',text:'Falling front sync'},{payload:'3',text:'Zero cross sync'}];this.draw();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{ref:'canvas'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{label:'Power '+(this.state.powerOn?'off':'on'),onTouchTap:this.togglePower.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Toggle"],{defaultToggled:this.state.accumulation,label:'Accumulation',onToggle:this.toggleAccumulation.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Toggle"],{defaultToggled:this.state.autoGain,label:'Auto gain',onToggle:this.toggleAutoGain.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["DropDownMenu"],{menuItems:menuItems,onChange:this.changeSyncMode.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Slider"],{name:'changeSyncVDiffSlider',defaultValue:0.1,max:0.5,onChange:this.changeSyncVDiff.bind(this)})));}}]);return Oscilloscope;}(__WEBPACK_IMPORTED_MODULE_3_components_PageModule__["a" /* default */]);Oscilloscope.readable='Oscilloscope';Oscilloscope.icon='ImageExposure';Oscilloscope.type=1002;Oscilloscope.public=false;Oscilloscope.active=true;/* harmony default export */ __webpack_exports__["a"] = (Oscilloscope);

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_PageModule__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var loadJSONP=function(){var e=0;return function(a,t,n){var c='_jsonp_'+e++;a+=a.match(/\?/)?'&callback='+c:'?callback='+c;var l=document.createElement('script');l.type='text/javascript',l.src=a,window[c]=function(e){t.call(n||window,e),document.getElementsByTagName('head')[0].removeChild(l),l=null,delete window[c];},document.getElementsByTagName('head')[0].appendChild(l);};}();var accessToken='18360510.5b9e1e6.de870cc4d5344ffeaae178542029e98b';var InstagramFeed=function(_PageModule){_inherits(InstagramFeed,_PageModule);function InstagramFeed(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InstagramFeed);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InstagramFeed.__proto__||Object.getPrototypeOf(InstagramFeed)).call.apply(_ref,[this].concat(args))),_this),_this.state={response:null,reference:'coursio',mode:'tag',maxItems:16},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InstagramFeed,[{key:'onInit',value:function onInit(){var reference=this.props.params&&this.props.params.reference||this.state.reference,mode=this.props.params&&this.props.params.mode||this.state.mode,maxItems=this.props.params&&this.props.params.maxItems||this.state.maxItems;this.setState({maxItems:maxItems});this.fetch(mode,reference);}},{key:'getModuleData',value:function getModuleData(moduleData){var reference=this.refs.reference.getValue(),mode=this.state.mode,maxItems=this.refs.maxItems.getValue();this.fetch(mode,reference);return{reference:reference,mode:mode,maxItems:maxItems};}},{key:'changeMaxItems',value:function changeMaxItems(e,v){this.setState({maxItems:v});}},{key:'changeMode',value:function changeMode(e,i){this.setState({mode:i?'user':'tag'});}},{key:'fetch',value:function fetch(mode,reference){var _this2=this;var url='';if(mode=='tag'){var hashtag=reference||this.state.hashtag;url='https://api.instagram.com/v1/tags/'+hashtag+'/media/recent?access_token='+accessToken;loadJSONP(url,function(data){_this2.setState({response:data,reference:hashtag,mode:mode});});}else if(mode=='user'){var username=reference||this.state.username;// get user ID by his name
url='https://api.instagram.com/v1/users/search?q='+username+'&access_token='+accessToken;loadJSONP(url,function(data){if(!data.data||!data.data.length){return;}var userId=data.data[0].id;url='https://api.instagram.com/v1/users/'+userId+'/media/recent?access_token='+accessToken;loadJSONP(url,function(data){_this2.setState({response:data,reference:username,referenceId:userId,mode:mode});});});}else{console.error('Unknown mode');}}},{key:'renderEditMode',value:function renderEditMode(content,data){var menuItems=[{payload:'tag',text:'Follow tag'},{payload:'user',text:'Follow user'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["b" /* GridContainer */],{fluid:true,style:{padding:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:3,xSmallSize:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'20px'}},'Max items: ',this.state.maxItems)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:9,xSmallSize:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Slider"],{name:'maxItemsSlider',defaultValue:this.state.maxItems,ref:'maxItems',min:1,max:16,step:1,onChange:this.changeMaxItems.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["DropDownMenu"],{ref:'mode',menuItems:menuItems,selectedIndex:this.state.mode=='tag'?0:1,onChange:this.changeMode.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:6,xSmallSize:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{ref:'reference',defaultValue:this.state.reference})));}},{key:'renderDetailMode',value:function renderDetailMode(content,data,userdata){var images=[];var captionStyle={backgroundColor:'rgba(40, 40, 40, 0.5)',position:'absolute',bottom:0,left:0,right:0,height:'20px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',color:'white',font:'12px Arial',padding:'6px 2px 0'};if(this.state.response){var max=Math.min(this.state.maxItems,this.state.response.data.length);var source='thumbnail',width=25;if([3,6,9].indexOf(this.state.maxItems)!=-1){width=33;source='low_resolution';}if([2,4].indexOf(this.state.maxItems)!=-1){width=50;source='standard_resolution';}if(this.state.maxItems==1){width=100;source='standard_resolution';}for(var i=0;i<max;i++){var item=this.state.response.data[i];var caption=item.caption&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:captionStyle},item.caption.text);images.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,style:{padding:2,display:'inline-block',boxSizing:'border-box',width:width+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:item.link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{width:'100%'},src:item.images[source].url})),caption)));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},images);}}]);return InstagramFeed;}(__WEBPACK_IMPORTED_MODULE_4_components_PageModule__["a" /* default */]);InstagramFeed.readable='Instagram Feed';InstagramFeed.icon='DeviceWallpaper';InstagramFeed.type=1003;InstagramFeed.public=false;InstagramFeed.active=true;/* harmony default export */ __webpack_exports__["a"] = (InstagramFeed);

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_PageModule__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import PUBNUB from 'services/Pubnub';
// https://webrtcexperiment-webrtc.netdna-ssl.com/websocket/PeerConnection.js
!function(){function e(e,n){function t(){o.stopBroadcasting=!0,e.MediaStream&&e.MediaStream.stop();for(var n in e.peers){e.peers[n].peer.close();}e.peers={};}function a(n){var i=JSON.parse(n.data);i.userid!=e.userid&&(e.participant=i.userid,console.debug(JSON.stringify(i,function(e,n){return n&&n.sdp?(console.log(n.sdp.type,'---',n.sdp.sdp),''):n;},'---')),i.sdp&&i.to==e.userid&&o.onsdp(i),i.candidate&&i.to==e.userid&&o.onice(i),i.participationRequest&&i.to==e.userid&&(o.participantFound=!0,e.onParticipationRequest?e.onParticipationRequest(i.userid):e.acceptRequest(i.userid)),i.broadcasting&&e.onUserFound&&e.onUserFound(i.userid),i.userLeft&&i.to==e.userid&&t());}var o=this;e.startBroadcasting=function(){if(!e.MediaStream)throw'Offerer must have media stream.';!function n(){c.send({userid:e.userid,broadcasting:!0}),!o.participantFound&&!o.stopBroadcasting&&setTimeout(n,3e3);}();},e.sendParticipationRequest=function(n){c.send({participationRequest:!0,userid:e.userid,to:n});},this.onsdp=function(n){var t=n.sdp;'offer'==t.type&&(e.peers[n.userid]=g.createAnswer(i(s,{MediaStream:e.MediaStream,sdp:t}))),'answer'==t.type&&e.peers[n.userid].setRemoteDescription(t);},e.acceptRequest=function(n){e.peers[n]=w.createOffer(i(s,{MediaStream:e.MediaStream}));};var d=[];this.onice=function(n){var t=e.peers[n.userid];if(t){t.addIceCandidate(n.candidate);for(var i=0;i<d.length;i++){t.addIceCandidate(d[i]);}d=[];}else d.push(d);};var s={onsdp:function onsdp(n){c.send({userid:e.userid,sdp:n,to:e.participant});},onicecandidate:function onicecandidate(n){c.send({userid:e.userid,candidate:n,to:e.participant});},onStreamAdded:function onStreamAdded(n){function t(){e.onStreamAdded&&e.onStreamAdded(a);}console.debug('onStreamAdded','>>>>>>',n),n.onended=function(){e.onStreamEnded&&e.onStreamEnded(a);};var i=document.createElement('video');i.id=e.participant,i[r?'mozSrcObject':'src']=r?n:window.webkitURL.createObjectURL(n),i.autoplay=!0,i.controls=!0,i.play();var a={mediaElement:i,stream:n,userid:e.participant,type:'remote'};t();}};e.close=function(){c.send({userLeft:!0,userid:e.userid,to:e.participant}),t();},window.onbeforeunload=function(){e.close();},window.onkeyup=function(n){116==n.keyCode&&e.close();};var c=n;'string'==typeof n&&(c=new WebSocket(n),c.push=c.send,c.send=function(e){c.push(JSON.stringify(e));},c.onopen=function(){console.log('websocket connection opened.');}),c.onmessage=a;}function n(){return Math.round(9999999999*Math.random())+9999999999;}function t(){}function i(e,n){for(var t in n){e[t]=n[t];}return e;}window.PeerConnection=function(t,i){if(this.userid=i||n(),this.peers={},!t)throw'Socket-URL is mandatory.';new e(this,t),this.addStream=function(e){this.MediaStream=e;};};var a=window.mozRTCPeerConnection||window.webkitRTCPeerConnection,o=window.mozRTCSessionDescription||window.RTCSessionDescription,d=window.mozRTCIceCandidate||window.RTCIceCandidate;navigator.getUserMedia=navigator.mozGetUserMedia||navigator.webkitGetUserMedia,window.URL=window.webkitURL||window.URL;var r=!!navigator.mozGetUserMedia,s=!!navigator.webkitGetUserMedia,c={url:s?'stun:stun.l.google.com:19302':'stun:23.21.150.121'},u={url:'turn:homeo@turn.bistri.com:80',credential:'homeo'},p={iceServers:[c]};s&&(parseInt(navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)[2])>=28&&(u={url:'turn:turn.bistri.com:80',credential:'homeo',username:'homeo'}),p.iceServers=[c,u]);var f={optional:[{DtlsSrtpKeyAgreement:!0}]},m={optional:[],mandatory:{OfferToReceiveAudio:!0,OfferToReceiveVideo:!0}},w={createOffer:function createOffer(e){var n=new a(p,f);return e.MediaStream&&n.addStream(e.MediaStream),n.onaddstream=function(n){e.onStreamAdded(n.stream);},n.onicecandidate=function(n){n.candidate&&e.onicecandidate(n.candidate);},n.createOffer(function(t){n.setLocalDescription(t),e.onsdp(t);},t,m),this.peer=n,this;},setRemoteDescription:function setRemoteDescription(e){this.peer.setRemoteDescription(new o(e));},addIceCandidate:function addIceCandidate(e){this.peer.addIceCandidate(new d({sdpMLineIndex:e.sdpMLineIndex,candidate:e.candidate}));}},g={createAnswer:function createAnswer(e){var n=new a(p,f);return e.MediaStream&&n.addStream(e.MediaStream),n.onaddstream=function(n){e.onStreamAdded(n.stream);},n.onicecandidate=function(n){n.candidate&&e.onicecandidate(n.candidate);},n.setRemoteDescription(new o(e.sdp)),n.createAnswer(function(t){n.setLocalDescription(t),e.onsdp(t);},t,m),this.peer=n,this;},addIceCandidate:function addIceCandidate(e){this.peer.addIceCandidate(new d({sdpMLineIndex:e.sdpMLineIndex,candidate:e.candidate}));}};window.URL=window.webkitURL||window.URL,navigator.getMedia=navigator.webkitGetUserMedia||navigator.mozGetUserMedia,navigator.getUserMedia=function(e,n,t){function i(e){n(e);}function a(e){if(!t)throw Error('getUserMedia failed: '+JSON.stringify(e,null,'   '));t(e);}if(e||(e={audio:!0,video:!0}),!n)throw'Second argument is mandatory. navigator.getUserMedia(hints,onsuccess,onfailure)';navigator.getMedia(e,i,a);};}();var channel='coursio';var pub='pub-c-24e38eb9-8fa9-420e-85c9-9046088fe686';var sub='sub-c-ecad80ec-9b3e-11e5-bcd8-0619f8945a4f';var styles={video:{width:'100%'},box:{transition:'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',display:'inline-block',width:'50%'}};var Webinar=function(_PageModule){_inherits(Webinar,_PageModule);function Webinar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Webinar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Webinar.__proto__||Object.getPrototypeOf(Webinar)).call.apply(_ref,[this].concat(args))),_this),_this.peer=null,_this.broadcasterId=null,_this.state={ownVideoStream:null,videos:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Webinar,[{key:'onInit',value:function onInit(){var _this2=this;var WebSocket=PUBNUB.ws;var websocket=new WebSocket('wss://pubsub.pubnub.com/'+pub+'/'+sub+'/'+channel);websocket.onerror=function(){};websocket.onclose=function(){};websocket.push=websocket.send;websocket.send=function(data){websocket.push(JSON.stringify(data));};this.peer=new PeerConnection(websocket);this.peer.onUserFound=function(userid){_this2.broadcasterId=userid;document.getElementById('broadcaster-info').innerHTML='User '+userid+' started a webinar.';};this.peer.onStreamAdded=function(e){var videos=_this2.state.videos;videos.push({userid:e.userid,stream:e.stream});_this2.setState({videos:videos});};this.peer.onStreamEnded=function(e){};}},{key:'createVideoBox',value:function createVideoBox(){}},{key:'getUserMedia',value:function getUserMedia(callback){var _this3=this;var hints={audio:true,video:{optional:[],mandatory:{}}};navigator.getUserMedia(hints,function(stream){_this3.setState({ownVideoStream:{userid:'self',stream:stream,callback:callback}});});}},{key:'startBroadcast',value:function startBroadcast(){var _this4=this;this.peer.userid=this.props.user.displayName;this.getUserMedia(function(stream){_this4.peer.addStream(stream);_this4.peer.startBroadcasting();});}},{key:'connectToBroadcast',value:function connectToBroadcast(){var _this5=this;this.getUserMedia(function(stream){_this5.peer.addStream(stream);_this5.peer.sendParticipationRequest(_this5.broadcasterId);});}},{key:'zoomVideo',value:function zoomVideo(index){var videos=this.state.videos.slice();videos[index].zoom=!vides[index].zoom;this.setState({videos:videos});}},{key:'zoomOwnVideo',value:function zoomOwnVideo(index){var ownVideoStream=this.state.ownVideoStream;ownVideoStream.zoom=!ownVideoStream.zoom;this.setState({ownVideoStream:ownVideoStream});}},{key:'renderVideos',value:function renderVideos(){var _this6=this;return this.state.videos.map(function(video,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VideoContainer,{zoom:video.zoom,onTouchTap:_this6.zoomVideo.bind(_this6,index),key:index,peer:_this6.peer,userid:video.userid,stream:video.stream,callback:video.callback});});}},{key:'renderEditMode',value:function renderEditMode(data){var ownVideo=this.renderOwnVideo();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{label:'Start broadcasting',onTouchTap:this.startBroadcast.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'broadcaster-info'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,ownVideo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderVideos()));}},{key:'renderOwnVideo',value:function renderOwnVideo(){if(this.state.ownVideoStream){console.log(this.state.ownVideoStream);var _state$ownVideoStream=this.state.ownVideoStream,callback=_state$ownVideoStream.callback,zoom=_state$ownVideoStream.zoom,stream=_state$ownVideoStream.stream;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VideoContainer,{onTouchTap:this.zoomOwnVideo.bind(this),zoom:zoom,userid:'self',callback:callback,stream:stream});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__["b" /* default */],null);}},{key:'renderDetailMode',value:function renderDetailMode(data){var ownVideo=this.renderOwnVideo();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{label:'Connect',onTouchTap:this.connectToBroadcast.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'broadcaster-info'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,ownVideo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderVideos()));}}]);return Webinar;}(__WEBPACK_IMPORTED_MODULE_3_components_PageModule__["a" /* default */]);Webinar.readable='Webinar';Webinar.icon='NotificationLiveTv';Webinar.type=1001;Webinar.public=false;Webinar.active=true;/* harmony default export */ __webpack_exports__["a"] = (Webinar);var VideoContainer=function(_Component){_inherits(VideoContainer,_Component);function VideoContainer(){_classCallCheck(this,VideoContainer);return _possibleConstructorReturn(this,(VideoContainer.__proto__||Object.getPrototypeOf(VideoContainer)).apply(this,arguments));}_createClass(VideoContainer,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,callback=_props.callback,stream=_props.stream;var mediaElement=this.refs.video;// this.props.peer.onStreamAdded({
//   mediaElement,
//   userid,
//   stream
// });
mediaElement.play();if(callback){callback(stream);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return nextProps.stream!==this.props.stream;}},{key:'getStyle',value:function getStyle(){var zoom=this.props.zoom;return Object.assign({},styles.box,{width:zoom?'100%':'50%'});}},{key:'render',value:function render(){var _props2=this.props,userid=_props2.userid,stream=_props2.stream,other=_objectWithoutProperties(_props2,['userid','stream']);var title=userid==='self'?'Ground Control':'Major Tom';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({style:this.getStyle.call(this)},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{ref:'video',controls:true,src:URL.createObjectURL(stream),style:styles.video}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,title));}}]);return VideoContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VideoContainer.displayName='VideoContainer';VideoContainer.propTypes={peer:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,userid:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,stream:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,callback:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,zoom:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_PageModule__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_Loader__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var myContext=function(){var cells=void 0,document=[],window=[],navigator=[];function test(){alert('Baams!');console.log('Baams:',cells);return'OK!';}function addd(a,b){console.log(a+b);}function _x_sync(vars){if(vars)for(var i=0;i<vars.length;i++){}}function _x_run(remoteCells,code){cells=remoteCells;return eval(code);}return{_x_run:_x_run,_x_sync:_x_sync};}();var Spreadsheet=function(_PageModule){_inherits(Spreadsheet,_PageModule);function Spreadsheet(){_classCallCheck(this,Spreadsheet);var _this=_possibleConstructorReturn(this,(Spreadsheet.__proto__||Object.getPrototypeOf(Spreadsheet)).apply(this,arguments));var colConfig=[/*{width:'80px'},{width:'50px'}*/];var focused=[0,0];// x,y
var params=_this.props.params;var cells=params.cells||[['','','','','',''],['','','','','',''],['','','','','',''],['','','','','',''],['','','','','','']];// push column names
cells.unshift([]);cells[0].push('');for(var x=0;x<cells[1].length;x++){cells[0].push(String.fromCharCode('A'.charCodeAt(0)+x));}// push row names
for(var y=0;y<cells.length;y++){for(var _x=0;_x<cells[y].length;_x++){if(!_x&&y){cells[y].unshift(y);}}}var shownCells=cells.map(function(row){return row.map(function(cell){return _this.compute(cell+'');});});_this.state={cells:cells,shownCells:shownCells,colConfig:colConfig,focused:focused};return _this;}_createClass(Spreadsheet,[{key:'getModuleData',value:function getModuleData(moduleData){var cells=this.state.cells;// cut headers
for(var y=0;y<cells.length;y++){for(var x=0;x<cells[y].length;x++){if(!x){cells[y].shift();}}}cells.shift();return{cells:cells};}},{key:'onChangeCell',value:function onChangeCell(x,y,e){var cells=this.state.cells.slice();var shownCells=this.state.shownCells.slice();var value=e.target.value;var w=cells[0].length,h=cells.length;cells[y][x]=value;// check if it's a border cell
if(y==h-1){// add a row
var row=[];for(var xi=0;xi<w;xi++){row.push(xi?'':h);}cells.push(row);row=row.slice();shownCells.push(row);h++;}if(x==w-1){// add a column
for(var yi=0;yi<h;yi++){var symbol=String.fromCharCode('A'.charCodeAt(0)+w);cells[yi].push(yi?'':symbol);shownCells[yi].push(yi?'':symbol);}w++;}this.setState({cells:cells,shownCells:shownCells});}},{key:'onFocusCell',value:function onFocusCell(x,y){var _state=this.state,cells=_state.cells,shownCells=_state.shownCells;shownCells[y][x]=cells[y][x]+'';this.setState({shownCells:shownCells});}},{key:'onFocusOutCell',value:function onFocusOutCell(x,y){var _state2=this.state,cells=_state2.cells,shownCells=_state2.shownCells;shownCells[y][x]=this.compute(cells[y][x]);this.setState({shownCells:shownCells});}},{key:'setFocus',value:function setFocus(x,y){this.setState({focused:[x,y]});}},{key:'compute',value:function compute(value){var shownCells=this.state.shownCells;if(value.charAt(0)=='='){return myContext._x_run(shownCells,value.substring(1));}else{return isNaN(parseFloat(value))?value:parseFloat(value);}}},{key:'renderDetailMode',value:function renderDetailMode(data){return this.prepareRender(data,false);}},{key:'renderEditMode',value:function renderEditMode(data){return this.prepareRender(data,true);}},{key:'prepareRender',value:function prepareRender(data,canEdit){var _this2=this;var _state3=this.state,cells=_state3.cells,shownCells=_state3.shownCells,colConfig=_state3.colConfig,focused=_state3.focused,styles=void 0;var rows=shownCells.map(function(row,rowIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:rowIndex},row.map(function(cell,cellIndex){styles={border:'1px solid #888',padding:'1px 3px'};if(!rowIndex){Object.assign(styles,{backgroundColor:'#ccc',textAlign:'center'});}else{if(!cellIndex){Object.assign(styles,{backgroundColor:'#ccc'});}else{var cellWidth=50;if(typeof colConfig[cellIndex-1]!='undefined'){cellWidth=colConfig[cellIndex-1].width;}Object.assign(styles,{width:cellWidth,backgroundColor:'white'});}}var canEditCell=rowIndex&&cellIndex,ref='ci_'+cellIndex+'_'+rowIndex;if(canEditCell){if(focused[0]==cellIndex&&focused[1]==rowIndex&&canEdit){Object.assign(styles,{border:'1px double blue',padding:'0 2px'});if(_this2.refs[ref]===document.activeElement){cell=cells[rowIndex][cellIndex];Object.assign(styles,{borderColor:'red'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:cellIndex,style:styles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:ref,style:{border:'none',width:'100%',backgroundColor:'transparent'},value:cell,onChange:_this2.onChangeCell.bind(_this2,cellIndex,rowIndex),onFocus:_this2.onFocusCell.bind(_this2,cellIndex,rowIndex),onBlur:_this2.onFocusOutCell.bind(_this2,cellIndex,rowIndex)}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:cellIndex,style:styles,onClick:_this2.setFocus.bind(_this2,cellIndex,rowIndex)},cell);}else{// that's a title cell
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:cellIndex,style:styles},cell);}}));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{style:{border:'1px solid #888',borderCollapse:'collapse'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rows)));}},{key:'componentDidMount',value:function componentDidMount(){this.keyboardInterceptor=this.keyboardInterceptor.bind(this);window.addEventListener('keydown',this.keyboardInterceptor);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('keydown',this.keyboardInterceptor);}},{key:'keyboardInterceptor',value:function keyboardInterceptor(e){var _this3=this;var focused=this.state.focused;var w=this.state.cells[0].length,h=this.state.cells.length,x=focused[0],y=focused[1],ref='ci_'+x+'_'+y,active=this.refs[ref]==document.activeElement;if(focused[0]){switch(e.keyCode){case 37:if(x>1&&!active)focused[0]--;this.setState({focused:focused});break;case 38:if(y>1&&!active)focused[1]--;this.setState({focused:focused});break;case 39:if(x<w-1&&!active)focused[0]++;this.setState({focused:focused});break;case 40:if(y<h-1&&!active)focused[1]++;this.setState({focused:focused});break;case 13:if(active){this.refs[ref].blur();}else{window.setTimeout(function(){_this3.refs[ref].focus();},1);}break;case 27:/*  if (active) {
          let {shownCells, cells, lastValue} = this.state;
          cells[y][x] = lastValue;
          shownCells[y][x] = cells[y][x];
          this.setState({shownCells, cells});
        }
        this.setState({focused:[0,0]});*/break;default:}e.stopPropagation();}}}]);return Spreadsheet;}(__WEBPACK_IMPORTED_MODULE_2_components_PageModule__["a" /* default */]);Spreadsheet.readable='Spreadsheet';Spreadsheet.icon='ImageViewComfy';Spreadsheet.type=1004;Spreadsheet.public=false;Spreadsheet.active=true;/* harmony default export */ __webpack_exports__["a"] = (Spreadsheet);

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_deep_extend__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_deep_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_deep_extend__);
var SettingsStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["y" /* SettingsActions */]],data:{list:{},saving:false,frontend:{},loading:true},getInitialState:function getInitialState(){return this.data;},onRead:function onRead(){var _this=this;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('settings','read',{},function(response){_this.data.loading=true;_this.trigger(_this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["y" /* SettingsActions */].readComplete(response.data);});},onReadComplete:function onReadComplete(data){this.data={list:Object.assign({},data,{js:data&&data.js||{},features:data&&data.features||{}}),frontend:data&&data.js||{},loading:false};this.trigger(this.data);},update:function update(settings){this.data=Object.assign({},this.data,{saving:true});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('settings','update',settings).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["y" /* SettingsActions */].updateComplete(settings);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},updateComplete:function updateComplete(settings){this.data=Object.assign({},this.data,{saving:false});var user=JSON.parse(localStorage.getItem('user'));var newUser=Object.assign({},user,{features:settings.features});localStorage.setItem('user',JSON.stringify(newUser));this.trigger(this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].translatableMessage('settings.saved');},saveFrontend:function saveFrontend(settings){var newSettings=Object.assign({},this.data.frontend);__WEBPACK_IMPORTED_MODULE_3_deep_extend___default()(newSettings,settings);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('settings','update',{js:newSettings}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["y" /* SettingsActions */].saveFrontendComplete(newSettings);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},saveFrontendComplete:function saveFrontendComplete(settings){this.data={list:Object.assign({},this.data.list,{js:Object.assign({},settings)}),frontend:Object.assign({},settings)};this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (SettingsStore);

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * @description Recursive object extending
 * @author Viacheslav Lotsmanov <lotsmanov89@gmail.com>
 * @license MIT
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2013-2015 Viacheslav Lotsmanov
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



function isSpecificValue(val) {
	return (
		val instanceof Buffer
		|| val instanceof Date
		|| val instanceof RegExp
	) ? true : false;
}

function cloneSpecificValue(val) {
	if (val instanceof Buffer) {
		var x = new Buffer(val.length);
		val.copy(x);
		return x;
	} else if (val instanceof Date) {
		return new Date(val.getTime());
	} else if (val instanceof RegExp) {
		return new RegExp(val);
	} else {
		throw new Error('Unexpected situation');
	}
}

/**
 * Recursive cloning array.
 */
function deepCloneArray(arr) {
	var clone = [];
	arr.forEach(function (item, index) {
		if (typeof item === 'object' && item !== null) {
			if (Array.isArray(item)) {
				clone[index] = deepCloneArray(item);
			} else if (isSpecificValue(item)) {
				clone[index] = cloneSpecificValue(item);
			} else {
				clone[index] = deepExtend({}, item);
			}
		} else {
			clone[index] = item;
		}
	});
	return clone;
}

/**
 * Extening object that entered in first argument.
 *
 * Returns extended object or false if have no target object or incorrect type.
 *
 * If you wish to clone source object (without modify it), just use empty new
 * object as first argument, like this:
 *   deepExtend({}, yourObj_1, [yourObj_N]);
 */
var deepExtend = module.exports = function (/*obj_1, [obj_2], [obj_N]*/) {
	if (arguments.length < 1 || typeof arguments[0] !== 'object') {
		return false;
	}

	if (arguments.length < 2) {
		return arguments[0];
	}

	var target = arguments[0];

	// convert arguments to array and cut off target object
	var args = Array.prototype.slice.call(arguments, 1);

	var val, src, clone;

	args.forEach(function (obj) {
		// skip argument if isn't an object, is null, or is an array
		if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
			return;
		}

		Object.keys(obj).forEach(function (key) {
			src = target[key]; // source value
			val = obj[key]; // new value

			// recursion prevention
			if (val === target) {
				return;

			/**
			 * if new value isn't object then just overwrite by new value
			 * instead of extending.
			 */
			} else if (typeof val !== 'object' || val === null) {
				target[key] = val;
				return;

			// just clone arrays (and recursive clone objects inside)
			} else if (Array.isArray(val)) {
				target[key] = deepCloneArray(val);
				return;

			// custom cloning and overwrite for specific objects
			} else if (isSpecificValue(val)) {
				target[key] = cloneSpecificValue(val);
				return;

			// overwrite by new value if source isn't object or array
			} else if (typeof src !== 'object' || src === null || Array.isArray(src)) {
				target[key] = deepExtend({}, val);
				return;

			// source value and new value is objects both, extending...
			} else {
				target[key] = deepExtend(src, val);
				return;
			}
		});
	});

	return target;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1965).Buffer))

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1966)
var ieee754 = __webpack_require__(1967)
var isArray = __webpack_require__(1968)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = ((uint8[i] << 16) & 0xFF0000) + ((uint8[i + 1] << 8) & 0xFF00) + (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 1967 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1968 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers_universalAnalytics__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers_facebookPixel__ = __webpack_require__(367);
/* global __TARGET__*/var inProduction="production"==='production';var StoreStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["z" /* StoreActions */]],data:{list:[],loading:true,storeId:null,storeItem:{},docs:{},discountCode:localStorage.getItem('discountCode'),canIEdit:false,theme:{color:'creen'}},getInitialState:function getInitialState(){return this.data;},read:function read(name,skipItems,skipLoading){if(!skipLoading){this.data.loading=true;this.trigger(this.data);}var discountCode=this.data.discountCode;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('store','read',{name:name,skipItems:skipItems,discountCode:discountCode},function(response){if(response.isError){__WEBPACK_IMPORTED_MODULE_1_actions__["z" /* StoreActions */].genericError(response.errMsg);}else{__WEBPACK_IMPORTED_MODULE_1_actions__["z" /* StoreActions */].readComplete(response.data,name);}return response.data;});},setDiscountCode:function setDiscountCode(discountCode){localStorage.setItem('discountCode',discountCode);this.data=Object.assign({},this.data,{discountCode:discountCode});this.trigger(this.data);},fixPrices:function fixPrices(list){return list.map(function(item){return Object.assign({},item,{price:Object.assign({},item.price,{discounted:Math.ceil(item.price.discounted),gross:Math.ceil(item.price.gross)})});});},readComplete:function readComplete(data,storeId,skipItems){data.list=data.items?data.items.slice():[];delete data.items;this.data=Object.assign({},this.data,data,{storeId:storeId,list:skipItems?this.data.list:this.fixPrices(data.list)||[],loading:false});var googleAnalyticsId=inProduction&&data.ga?data.ga.id:__WEBPACK_IMPORTED_MODULE_4_Config__["a" /* default */].googleAnalyticsId;__WEBPACK_IMPORTED_MODULE_5_helpers_universalAnalytics__["a" /* default */].initialize(googleAnalyticsId);var options={autoConfig:true,debug:false};var facebookPixelId=inProduction&&data.js?data.js.pixel:__WEBPACK_IMPORTED_MODULE_4_Config__["a" /* default */].facebookPixelId;__WEBPACK_IMPORTED_MODULE_6_helpers_facebookPixel__["a" /* default */].init(facebookPixelId,null,options);__WEBPACK_IMPORTED_MODULE_6_helpers_facebookPixel__["a" /* default */].track('PageView');this.trigger(this.data);},findById:function findById(type,id,name){// this.data.loading = true;
var discountCode=this.data.discountCode;this.data.storeItem={};this.trigger(this.data);if(this.data.storeId){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('store','findById',{type:type,id:id,discountCode:discountCode}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions__["z" /* StoreActions */].findByIdComplete(data,type,id);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});}return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('store','read',{name:name,skipItems:true,discountCode:discountCode}).then(function(storeData){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('store','findById',{type:type,id:id,discountCode:discountCode}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions__["z" /* StoreActions */].findByIdComplete(data,type,id);__WEBPACK_IMPORTED_MODULE_1_actions__["z" /* StoreActions */].readComplete(storeData,name,true);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},findBySlug:function findBySlug(type,username,slug,callback,skipReset){// this.data.loading = true;
//
var discountCode=this.data.discountCode;if(!skipReset){this.data.storeItem={};this.trigger(this.data);}if(this.data.storeId){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('store','findBySlug',{type:type,slug:slug,discountCode:discountCode,username:username}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions__["z" /* StoreActions */].findByIdComplete(data);callback&&callback(data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});}return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('store','read',{name:username,skipItems:true,discountCode:discountCode}).then(function(storeData){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('store','findBySlug',{discountCode:discountCode,type:type,slug:slug,username:username}).then(function(data){callback&&callback(data);__WEBPACK_IMPORTED_MODULE_1_actions__["z" /* StoreActions */].readComplete(storeData,username,true);__WEBPACK_IMPORTED_MODULE_1_actions__["z" /* StoreActions */].findByIdComplete(data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},findByIdComplete:function findByIdComplete(data){if(data){this.data=Object.assign({},this.data,{storeItem:Object.assign({},data,{price:Object.assign({},data.price,{discounted:Math.ceil(data.price.discounted),gross:Math.ceil(data.price.gross)})}),loading:false});this.trigger(this.data);}},changeStoreItem:function changeStoreItem(storeItem){if(storeItem.price){this.data=Object.assign({},this.data,{storeItem:Object.assign({},this.data.storeItem,storeItem,{price:Object.assign({},storeItem.price,{discounted:Math.ceil(storeItem.price.discounted),gross:Math.ceil(storeItem.price.gross)})})});}else{this.data=Object.assign({},this.data,{storeItem:Object.assign({},this.data.storeItem,storeItem)});}this.trigger(this.data);},pushStoreItem:function pushStoreItem(props){var _data$storeItem=this.data.storeItem,ucpPeriod=_data$storeItem.ucpPeriod,price=_data$storeItem.price,videoUrl=_data$storeItem.videoUrl,presentation=_data$storeItem.presentation,type=_data$storeItem.type,id=_data$storeItem.id;var isPublic=this.data.storeItem.public;this.save(parseInt(type,10),Object.assign({id:id,ucpPeriod:ucpPeriod,public:isPublic,price:price.net,videoUrl:videoUrl,presentation:presentation},props));},save:function save(type,data){if(type===1){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','update',data).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["z" /* StoreActions */].saveComplete();__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].translatableMessage('changesSaved');},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});}else if(type===2){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course-package','update',data).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["z" /* StoreActions */].saveComplete();__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].translatableMessage('changesSaved');},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});}// return SteelCompass.call('course-package', 'update', {})
},joinForFree:function joinForFree(type,id){var storeId=this.data.storeId;if(type===1){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','joinForFree',{courseId:id,storeName:storeId}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].translatableMessage('store.purchaseSuccess');setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* history */].pushState('/dashboard');},2000);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});}else if(type===2){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course-package','joinForFree',{coursePackageId:id,storeName:storeId}).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].translatableMessage('store.purchaseSuccess');setTimeout(function(){__WEBPACK_IMPORTED_MODULE_3_helpers__["a" /* history */].pushState('/dashboard');},2000);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});}},saveComplete:function saveComplete(data){}});/* harmony default export */ __webpack_exports__["a"] = (StoreStore);

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_Transaction__ = __webpack_require__(337);
var TransactionStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions_Transaction__["a" /* default */]],data:{list:[],loading:true},getInitialState:function getInitialState(){return this.data;},onRead:function onRead(includeRead,callback){this.data.loading=true;this.trigger(this.data);return SteelCompass.call('payment/incoming','read',{status:184,sortBy:'date',sortMode:'desc'},function(response){__WEBPACK_IMPORTED_MODULE_1_actions_Transaction__["a" /* default */].readComplete(response.data);if(callback){callback();}});},onReadComplete:function onReadComplete(data){this.data={list:data,loading:false,saving:false,transaction:{}};this.trigger(this.data);},onFindById:function onFindById(id){this.data.loading=true;this.trigger(this.data);return SteelCompass.call('payment/incoming','findById',{id:id},function(response){if(response.isError){__WEBPACK_IMPORTED_MODULE_1_actions_Transaction__["a" /* default */].genericError(response.errMsg);}else{__WEBPACK_IMPORTED_MODULE_1_actions_Transaction__["a" /* default */].findByIdComplete(response.data);}});},onFindByIdComplete:function onFindByIdComplete(transaction){this.data.loading=false;this.data.transaction=transaction;this.trigger(this.data);},onFindByIdError:function onFindByIdError(errorMessage){this.data.loading=false;this.data.errorMessage=errorMessage;this.trigger(this.data);},onRefund:function onRefund(id){var _this=this;return SteelCompass.call('payment/incoming','refund',{id:id},function(response){if(response.isError){__WEBPACK_IMPORTED_MODULE_1_actions_Transaction__["a" /* default */].refundError(response.errMsg);}else{__WEBPACK_IMPORTED_MODULE_1_actions_Transaction__["a" /* default */].refundComplete(response.data);}_this.data.loading=true;_this.trigger(_this.data);});},onResend:function onResend(id){return SteelCompass.call('payment/incoming','resendReceipt',{id:id},function(response){__WEBPACK_IMPORTED_MODULE_1_actions_Transaction__["a" /* default */].resendComplete(response.data);});},onExport:function onExport(id){return SteelCompass.call('payment/incoming','export',{id:id},function(response){__WEBPACK_IMPORTED_MODULE_1_actions_Transaction__["a" /* default */].exportComplete(response.data);});}});/* harmony default export */ __webpack_exports__["a"] = (TransactionStore);

/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_oxygen_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers__ = __webpack_require__(31);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var TaskStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */]],data:{filterMode:localStorage.getItem('taskFilterMode')||'simple',tasks:{list:[],entities:{},filter:{userId:null,courseId:null,circleId:null,corrected:false},loading:true},students:{list:[],expanded:true,entities:{},filter:null,loading:true},courses:{list:[],expanded:true,entities:{},filter:null,loading:true},groups:{list:[],expanded:true,entities:{},filter:null,loading:true}},getInitialState:function getInitialState(){return this.data;},loading:function loading(){var listName=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'tasks';var loading=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;this.data=Object.assign({},this.data,_defineProperty({},listName,Object.assign({},this.data[listName],{loading:loading})));this.trigger(this.data);},start:function start(_ref){var courseId=_ref.courseId,userId=_ref.userId,taskId=_ref.taskId;this.data=Object.assign({},this.data,{tasks:Object.assign({},this.data.tasks,{filter:Object.assign({},this.data.tasks.filter,{userId:Number(userId)||null,courseId:Number(courseId)||null,taskId:Number(taskId)||null,circleId:null})})});this.trigger(this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].readTasks();__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].findTaskStudents();__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].findTaskCourses();// TaskActions.findTaskGroups();
},readTasks:__WEBPACK_IMPORTED_MODULE_3_oxygen_debounce___default()(function readTasksDebounced(){var _this=this;this.loading();var filter=this.data.tasks.filter;var corrected=filter.corrected,other=_objectWithoutProperties(filter,['corrected']);// eslint-disable-line no-unused-vars
if(filter.courseId||filter.userId||filter.groupId){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('task','read',Object.assign({},other)).then(function(tasks){__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].readTasksComplete(tasks);},function(error){_this.loading('tasks',false);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});}},500),findTaskStudents:function findTaskStudents(){this.loading('students');return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('coursio-ui','populateColumn2InTasks',{showUsersHavingFeedback:true}).then(function(students){__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].findTaskStudentsComplete(students);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},toggleFilterMode:function toggleFilterMode(){var filterMode=this.data.filterMode==='simple'?'extended':'simple';this.data=Object.assign({},this.data,{filterMode:filterMode});localStorage.setItem('taskFilterMode',filterMode);this.trigger(this.data);},removeUploaded:function removeUploaded(id){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('task-result','removeUploaded',{id:id}).then(function(res){if(res){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].translatableMessage('tasks.fileRemoved');}else{__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].translatableMessage('tasks.fileNotRemoved');}},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},findTaskGroups:function findTaskGroups(){var _this2=this;this.loading('groups');return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('circle','findBuildable',{}).then(function(groups){__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].findTaskGroupsComplete(groups);},function(error){_this2.loading('groups',false);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},findTaskCourses:function findTaskCourses(){var _this3=this;this.loading('courses');return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','findBuildable',{showUncorrected:true}).then(function(courses){__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].findTaskCoursesComplete(courses);},function(error){_this3.loading('courses',false);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},getEntities:function getEntities(input){var list=[];var entities={};input.forEach(function(item){list.push(item.id);entities[item.id]=item;});return{list:list,entities:entities};},findTaskStudentsComplete:function findTaskStudentsComplete(list){this.data=Object.assign({},this.data,{students:Object.assign({},this.data.students,{loading:false},this.getEntities(list))});this.trigger(this.data);},toggleExpand:function toggleExpand(list){this.data=Object.assign({},this.data,_defineProperty({},list,Object.assign({},this.data[list],{expanded:!this.data[list].expanded})));this.trigger(this.data);},findTaskCoursesComplete:function findTaskCoursesComplete(list){this.data=Object.assign({},this.data,{courses:Object.assign({},this.data.courses,{loading:false},this.getEntities(list))});this.trigger(this.data);},findTaskGroupsComplete:function findTaskGroupsComplete(list){this.data=Object.assign({},this.data,{groups:Object.assign({},this.data.groups,{loading:false},this.getEntities(list))});this.trigger(this.data);},readTasksComplete:function readTasksComplete(entities){this.data=Object.assign({},this.data,{tasks:Object.assign({},this.data.tasks,{list:Object.keys(entities),entities:entities,loading:false}),entities:{}});this.trigger(this.data);},clearTaskSelection:function clearTaskSelection(){if(!this.data.tasks||!this.data.tasks.filter){return;}this.data.tasks.filter.taskId=null;__WEBPACK_IMPORTED_MODULE_4_helpers__["a" /* history */].replace('/tasks');},toggleCorrected:function toggleCorrected(){var tasks=this.data.tasks;this.data=Object.assign({},this.data,{tasks:Object.assign({},tasks,{filter:Object.assign({},tasks.filter,{corrected:!tasks.filter.corrected})})});this.trigger(this.data);},setTaskFilter:function setTaskFilter(filter){var tasks=this.data.tasks;this.data=Object.assign({},this.data,{tasks:Object.assign({},tasks,{filter:Object.assign({userId:null,courseId:null,circleId:null},filter)})});this.trigger(this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].readTasks();},setGroupFilter:function setGroupFilter(filter){var groups=this.data.groups;this.data=Object.assign({},this.data,{groups:Object.assign({},groups,{filter:filter})});this.trigger(this.data);},setStudentFilter:function setStudentFilter(filter){var students=this.data.students;this.data=Object.assign({},this.data,{students:Object.assign({},students,{filter:filter})});this.trigger(this.data);},setCourseFilter:function setCourseFilter(filter){var courses=this.data.courses;this.data=Object.assign({},this.data,{courses:Object.assign({},courses,{filter:filter})});this.trigger(this.data);},assessTask:function assessTask(taskId,taskResultId,feedback,grade){var bodyFiles=arguments.length>4&&arguments[4]!==undefined?arguments[4]:[];var silent=arguments[5];return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('task-result','assess',{id:taskResultId,grade:grade,silent:silent,text:feedback+bodyFiles.map(function(file){return'[file:'+file.id+']';}).join('')}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].assessTaskComplete(taskId,taskResultId,feedback,grade,bodyFiles);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},assessTaskComplete:function assessTaskComplete(taskId,taskResultId,text,grade){var bodyFiles=arguments.length>4&&arguments[4]!==undefined?arguments[4]:[];var task=this.data.tasks.entities[taskId];this.data=Object.assign({},this.data,{tasks:Object.assign({},this.data.tasks,{entities:Object.assign({},this.data.tasks.entities,_defineProperty({},taskId,Object.assign({},task,{taskResults:task.taskResults.map(function(taskResult){if(taskResult.id===taskResultId){return Object.assign({},taskResult,{bodyFiles:bodyFiles,feedback:{grade:grade,text:text}});}return taskResult;})})))})});this.trigger(this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].translatableMessage('tasks.feedbackSent');}});/* harmony default export */ __webpack_exports__["a"] = (TaskStore);

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
var ExportStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["i" /* ExportActions */]],data:{},getInitialState:function getInitialState(){return this.data;},exportIncomingPayment:function exportIncomingPayment(email){this.data.loading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('payment/incoming','export',{recipientEmail:email}).then(function(response){__WEBPACK_IMPORTED_MODULE_1_actions__["i" /* ExportActions */].exportIncomingPaymentComplete(response.data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},exportIncomingPaymentComplete:function exportIncomingPaymentComplete(data){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].translatableMessage('transaction.exportDone');}});/* harmony default export */ __webpack_exports__["a"] = (ExportStore);

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
var ClipboardStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["e" /* ClipboardActions */]],data:{object:null},getInitialState:function getInitialState(){return this.data;},init:function init(){var _this=this;var clipboard=JSON.parse(localStorage.getItem('clipboard'));if(window){window.addEventListener('storage',function(){var clipboard=JSON.parse(localStorage.getItem('clipboard'));_this.data=Object.assign({},_this.data,clipboard);_this.trigger(_this.data);});}this.data=Object.assign({},this.data,clipboard);},copy:function copy(object){this.data.object=object;this.trigger(this.data);this.serialize();},paste:function paste(){return this.data.object;},serialize:function serialize(){localStorage.setItem('clipboard',JSON.stringify(this.data));}});/* harmony default export */ __webpack_exports__["a"] = (ClipboardStore);

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
var KlarnaStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["n" /* KlarnaActions */]],data:{email:null,phone:null,firstName:null,lastName:null,street:null,zip:null,city:null,country:null,ssn:null,loading:false},getInitialState:function getInitialState(){return this.data;},paymentStarted:function paymentStarted(data){console.log(data);},change:function change(props){this.data=Object.assign({},this.data,props);this.trigger(this.data);},getAddressesBySsn:function getAddressesBySsn(ssn){var _this=this;this.data=Object.assign({},this.data,{loading:true});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('payment','getAddressesBySsn',{ssn:ssn}).then(function(address){__WEBPACK_IMPORTED_MODULE_1_actions__["n" /* KlarnaActions */].getAddressesBySsnComplete(address[0]);},function(error){_this.data=Object.assign({},_this.data,{loading:false});_this.trigger(_this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},getAddressesBySsnComplete:function getAddressesBySsnComplete(address){this.data=Object.assign({},this.data,address,{loading:false});this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (KlarnaStore);

/***/ }),
/* 1975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var pageLength=1000;var StudentOverviewStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["b" /* AuthActions */],__WEBPACK_IMPORTED_MODULE_1_actions__["C" /* StudentActions */],__WEBPACK_IMPORTED_MODULE_1_actions__["D" /* StudentOverviewActions */]],data:{user:{list:[],loading:true},invitation:{list:[],loading:true},activeList:'user'},getInitialState:function getInitialState(){return this.data;},init:function init(){},changeList:function changeList(activeList){this.data=Object.assign({},this.data,{activeList:activeList});this.trigger(this.data);if(this.data[activeList].list.length<1){this.getList(activeList);}},incarnate:function incarnate(){this.data={user:{list:[],loading:true},invitation:{list:[],loading:true},activeList:'user'};this.trigger(this.data);},getList:function getList(list){var _this=this;var pageStart=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;this.data=Object.assign({},this.data,_defineProperty({},list,Object.assign({},this.data[list],{loading:true})));this.trigger(this.data);__WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request(list,'prepareForUserList',{},list==='user'?pageStart:undefined,list==='user'?pageLength:undefined).then(function(data){if(data){__WEBPACK_IMPORTED_MODULE_1_actions__["D" /* StudentOverviewActions */].getListComplete(list,data,pageStart);if(data.length===pageLength){_this.getList(list,pageStart+pageLength);}}else{_this.error(list);}},function(error){_this.error(list,error);});},error:function error(list,_error){this.data=Object.assign({},this.data,_defineProperty({},list,Object.assign({},this.data[list],{loading:false})));this.trigger(this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(_error);},sort_user:function sort_user(item1,item2){if(item1.name.charAt(0)===' '&&item2.name.charAt(0)===' '){var firstName=item1.name.substring(1).toLowerCase();var secondName=item2.name.substring(1).toLowerCase();return firstName<secondName?-1:firstName>secondName?1:0;}else if(item1.name.charAt(0)===' '&&item2.name.charAt(0)!==' '){var _firstName=item1.name.substring(1).toLowerCase();var _secondName=item2.name.toLowerCase();return _firstName<_secondName?-1:_firstName>_secondName?1:0;}else if(item1.name.charAt(0)!==' '&&item2.name.charAt(0)===' '){var _firstName2=item1.name.toLowerCase();var _secondName2=item2.name.substring(1).toLowerCase();return _firstName2<_secondName2?-1:_firstName2>_secondName2?1:0;}else{var _firstName3=item1.name.toLowerCase();var _secondName3=item2.name.toLowerCase();return _firstName3<_secondName3?-1:_firstName3>_secondName3?1:0;}},sort_invitation:function sort_invitation(item1,item2){if(item1.email<item2.email){return-1;}if(item1.email>item2.email){return 1;}return 0;},sort:function sort(listName,list){return list.sort(this['sort_'+listName]);},addTagComplete:function addTagComplete(userId,name){this.data=Object.assign({},this.data,{user:Object.assign({},this.data.user,{list:this.data.user.list.map(function(user){if(user.id===userId){return Object.assign({},user,{tagsMap:Object.assign({},user.tagsMap,_defineProperty({},name,1))});}return user;})})});this.trigger(this.data);},expelComplete:function expelComplete(userId){this.data=Object.assign({},this.data,{user:Object.assign({},this.data.user,{list:this.data.user.list.filter(function(user){return user.id!==userId;})})});this.trigger(this.data);},removeTagComplete:function removeTagComplete(userId,name){this.data=Object.assign({},this.data,{user:Object.assign({},this.data.user,{list:this.data.user.list.map(function(user){if(user.id===userId){return Object.assign({},user,{tagsMap:Object.assign({},user.tagsMap,_defineProperty({},name,0))});}return user;})})});this.trigger(this.data);},getListComplete:function getListComplete(list,data,pageStart){if(pageStart===0){this.data=Object.assign({},this.data,_defineProperty({},list,{list:this.sort(list,data),loading:data.length===pageLength}));}else{this.data=Object.assign({},this.data,_defineProperty({},list,{list:this.sort(list,[].concat(_toConsumableArray(this.data[list].list),_toConsumableArray(data))),loading:data.length===pageLength}));}this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (StudentOverviewStore);

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EntitySchema = function () {
  function EntitySchema(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, EntitySchema);

    if (!key || typeof key !== 'string') {
      throw new Error('A string non-empty key is required');
    }

    this._key = key;
    this._assignEntity = options.assignEntity;

    var idAttribute = options.idAttribute || 'id';
    this._getId = typeof idAttribute === 'function' ? idAttribute : function (x) {
      return x[idAttribute];
    };
    this._idAttribute = idAttribute;
    this._meta = options.meta;
    this._defaults = options.defaults;
  }

  _createClass(EntitySchema, [{
    key: 'getAssignEntity',
    value: function getAssignEntity() {
      return this._assignEntity;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return this._key;
    }
  }, {
    key: 'getId',
    value: function getId(entity, key) {
      return this._getId(entity, key);
    }
  }, {
    key: 'getIdAttribute',
    value: function getIdAttribute() {
      return this._idAttribute;
    }
  }, {
    key: 'getMeta',
    value: function getMeta(prop) {
      if (!prop || typeof prop !== 'string') {
        throw new Error('A string non-empty property name is required');
      }
      return this._meta && this._meta[prop];
    }
  }, {
    key: 'getDefaults',
    value: function getDefaults() {
      return this._defaults;
    }
  }, {
    key: 'define',
    value: function define(nestedSchema) {
      for (var key in nestedSchema) {
        if (nestedSchema.hasOwnProperty(key)) {
          this[key] = nestedSchema[key];
        }
      }
    }
  }]);

  return EntitySchema;
}();

exports.default = EntitySchema;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isObject = __webpack_require__(114);

var _isObject2 = _interopRequireDefault(_isObject);

var _UnionSchema = __webpack_require__(551);

var _UnionSchema2 = _interopRequireDefault(_UnionSchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ArraySchema = function () {
  function ArraySchema(itemSchema) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ArraySchema);

    if (!(0, _isObject2.default)(itemSchema)) {
      throw new Error('ArraySchema requires item schema to be an object.');
    }

    if (options.schemaAttribute) {
      var schemaAttribute = options.schemaAttribute;
      this._itemSchema = new _UnionSchema2.default(itemSchema, { schemaAttribute: schemaAttribute });
    } else {
      this._itemSchema = itemSchema;
    }
  }

  _createClass(ArraySchema, [{
    key: 'getItemSchema',
    value: function getItemSchema() {
      return this._itemSchema;
    }
  }]);

  return ArraySchema;
}();

exports.default = ArraySchema;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(1979);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1980),
    isObjectLike = __webpack_require__(166);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(1981),
    equalArrays = __webpack_require__(555),
    equalByTag = __webpack_require__(2013),
    equalObjects = __webpack_require__(2016),
    getTag = __webpack_require__(2029),
    isArray = __webpack_require__(106),
    isBuffer = __webpack_require__(560),
    isTypedArray = __webpack_require__(562);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(250),
    stackClear = __webpack_require__(1987),
    stackDelete = __webpack_require__(1988),
    stackGet = __webpack_require__(1989),
    stackHas = __webpack_require__(1990),
    stackSet = __webpack_require__(1991);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 1982 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(251);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(251);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(251);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(251);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(250);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1988 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1989 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1990 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(250),
    Map = __webpack_require__(369),
    MapCache = __webpack_require__(370);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(552),
    isMasked = __webpack_require__(1995),
    isObject = __webpack_require__(114),
    toSource = __webpack_require__(554);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(253);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1994 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1996);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(105);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1997 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1999),
    ListCache = __webpack_require__(250),
    Map = __webpack_require__(369);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(2000),
    hashDelete = __webpack_require__(2001),
    hashGet = __webpack_require__(2002),
    hashHas = __webpack_require__(2003),
    hashSet = __webpack_require__(2004);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(254);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 2001 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(254);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(254);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(254);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(255);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 2006 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(255);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(255);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(255);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 2010 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 2011 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 2012 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(253),
    Uint8Array = __webpack_require__(2014),
    eq = __webpack_require__(252),
    equalArrays = __webpack_require__(555),
    mapToArray = __webpack_require__(2015),
    setToArray = __webpack_require__(371);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(105);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 2015 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(2017);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(2018),
    getSymbols = __webpack_require__(2019),
    keys = __webpack_require__(2021);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(556),
    isArray = __webpack_require__(106);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(557),
    stubArray = __webpack_require__(2020);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 2020 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(558),
    baseKeys = __webpack_require__(2027),
    isArrayLike = __webpack_require__(258);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 2022 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    isObjectLike = __webpack_require__(166);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 2024 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    isLength = __webpack_require__(563),
    isObjectLike = __webpack_require__(166);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(553);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(372)(module)))

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(564),
    nativeKeys = __webpack_require__(2028);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(565);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(2030),
    Map = __webpack_require__(369),
    Promise = __webpack_require__(2031),
    Set = __webpack_require__(566),
    WeakMap = __webpack_require__(2032),
    baseGetTag = __webpack_require__(195),
    toSource = __webpack_require__(554);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(139),
    root = __webpack_require__(105);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(139),
    root = __webpack_require__(105);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(139),
    root = __webpack_require__(105);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_oxygen_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Util_ObjectId__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_Theme__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers_universalAnalytics__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_helpers_facebookPixel__ = __webpack_require__(367);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var inProduction="production"==='production';var isNumeric=function isNumeric(value){return!isNaN(parseFloat(value))&&isFinite(value);};var domain=/:\/\/([^\/]+)/.exec(window.location.href)[1];var subDomain=void 0;var storeName=void 0;if('//'+domain!==__WEBPACK_IMPORTED_MODULE_4_Config__["a" /* default */].thisHost){subDomain=domain.split('.').shift();}if(subDomain&&!isNumeric(subDomain)){storeName=subDomain;}var loadStore=function loadStore(){return JSON.parse(localStorage.getItem('coursio::store'))||{name:'',googleAnalyticsId:__WEBPACK_IMPORTED_MODULE_4_Config__["a" /* default */].googleAnalytics,cart:[],items:{},dialogMode:'dialog',filterMode:'simple',owner:{},presentation:{},countryCode:'SE',theme:{color:'teal'},layoutDraft:null,discountCode:null,allowedPaymentProviders:[]};};var persistStore=function persistStore(data){localStorage.setItem('coursio::store',JSON.stringify({name:data.name,googleAnalyticsId:data.googleAnalyticsId,facebookPixelId:data.facebookPixelId,cart:data.cart,items:data.items,dialogMode:data.dialogMode,filterMode:data.filterMode,countryCode:data.countryCode,owner:data.owner,presentation:data.presentation,theme:data.theme,discountCode:data.discountCode,layoutDraft:data.layoutDraft,allowedPaymentProviders:data.allowedPaymentProviders}));};var store=loadStore();var stripe=null;try{stripe=Stripe(__WEBPACK_IMPORTED_MODULE_4_Config__["a" /* default */].stripeKey);}catch(e){}var StoreOverviewStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */]],data:Object.assign({},store,{mode:'list',moduleMenu:false,activeDiscountCount:0,giftEmail:null,layoutHistory:[],layout:{entities:{sections:{},modules:{}},sections:[],overSection:{}},layoutDraft:{entities:{sections:{},modules:{}},sections:[],overSection:{}},canIEdit:false,canJoinForFree:false,docs:{},name:storeName,payment:{completed:false,errorText:{},loading:false,method:null,data:{}},filter:{searchText:null,tags:{},categoryId:null},list:[],selected:{},load:null,loading:true,stripe:stripe}),init:function init(){this.updateModuleDebounced=__WEBPACK_IMPORTED_MODULE_3_oxygen_debounce___default()(function updateModuleDebounced(moduleId,moduleProps){this.updateModule(moduleId,moduleProps);},500);},changeStoreItem:function changeStoreItem(props){var id=props.id,type=props.type;this.data=Object.assign({},this.data,{items:Object.assign({},this.data.items,_defineProperty({},type,Object.assign({},this.data.items[type],_defineProperty({},id,Object.assign({},this.data.items[type][id],props)))))});this.trigger(this.data);},pushStoreItem:function pushStoreItem(props){var id=props.id,type=props.type;var item=this.data.items[type][id];var data={ucpPeriod:item.ucpPeriod,price:item.price.net,videoUrl:item.videoUrl,presentation:item.presentation,id:item.id,public:item.public};if(type===1){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course','update',data).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].pushStoreItemComplete();__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].translatableMessage('changesSaved');},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});}else if(type===2){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('course-package','update',data).then(function(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].pushStoreItemComplete();__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].translatableMessage('changesSaved');},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});}// return SteelCompass.call('course-package', 'update', {})
},pushStoreItemComplete:function pushStoreItemComplete(data){},setDraggingPos:function setDraggingPos(sectionId,dropPosition,moduleId){var entities=this.data.layoutDraft.entities;var sections=entities.sections,modules=entities.modules;var _modules=modules,drag=_modules.drag;if(drag&&drag.moduleId===moduleId&&drag.sectionId===sectionId&&drag.dropPosition===dropPosition){return;}if(drag&&drag.sectionId===sectionId){var dragIndex=sections[drag.sectionId].modules.findIndex(function(_moduleId){return _moduleId==='drag';});if(dragIndex===dropPosition){return;}}// Remove it from the old section
if(drag){Object.keys(sections).forEach(function(id){var section=sections[id];if(section.modules.findIndex(function(_mid){return _mid==='drag';})>-1){sections[id]=Object.assign({},sections[id],{modules:section.modules.filter(function(_mid){return _mid!=='drag';})});}});}drag={id:'drag',sectionId:sectionId,dropPosition:dropPosition,moduleId:moduleId,subType:modules[moduleId].type,type:'Drag'};// create a new drag handle
modules=Object.assign({},modules,{drag:drag});// Add it to the new section
var newModules=sections[sectionId].modules.filter(function(_moduleId){return _moduleId!=='drag';});newModules.splice(dropPosition,0,'drag');sections=Object.assign({},sections,_defineProperty({},sectionId,Object.assign({},sections[sectionId],{modules:newModules})));this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layoutDraft,{entities:Object.assign({},this.data.layoutDraft.entities,{sections:sections,modules:modules}),overSection:{}})});this.trigger(this.data);},resetDragging:function resetDragging(){var entities=this.data.layoutDraft.entities;this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layoutDraft,{overSection:{},entities:Object.assign({},entities,{modules:Object.assign({},entities.modules,{drag:null,overRow:{}})})})});this.trigger(this.data);},overSection:function overSection(position,id){var overSection=this.data.layoutDraft.overSection;if(overSection.id!==id||overSection.position!==position){var entities=this.data.layoutDraft.entities;var sections=entities.sections;var drag=entities.modules.drag;if(drag){sections=Object.assign({},sections,_defineProperty({},drag.sectionId,Object.assign({},sections[drag.sectionId],{modules:sections[drag.sectionId].modules.filter(function(moduleId){return moduleId!=='drag';})})));}this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layoutDraft,{entities:Object.assign({},entities,{sections:sections,modules:Object.assign({},entities.modules,{drag:null})}),overSection:{position:position,id:id}})});this.trigger(this.data);}},moveToNewSection:function moveToNewSection(toSectionId,fromSectionId,moduleId){var _Object$assign5;if(toSectionId===fromSectionId){return;}// TODO : move whole section
var _data$layoutDraft=this.data.layoutDraft,entities=_data$layoutDraft.entities,overSection=_data$layoutDraft.overSection;var sections=[].concat(_toConsumableArray(this.data.layoutDraft.sections));var offset=overSection.position==='after'?1:0;if(entities.sections[fromSectionId].modules.length===1){this.moveSection(fromSectionId,toSectionId,offset);return;}var sectionId=new __WEBPACK_IMPORTED_MODULE_5_Util_ObjectId__["a" /* default */]().toString();var section={id:sectionId,type:entities.modules[moduleId].type==='Banner'||entities.modules[moduleId].type==='List'?'banner':'default',modules:[moduleId]};var dropSectionIndex=sections.findIndex(function(_sectionId){return overSection.id===_sectionId;});sections.splice(dropSectionIndex+offset,0,sectionId);this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layoutDraft,{overSection:{}})});this.saveSnapshot();this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layoutDraft,{entities:Object.assign({},entities,{sections:Object.assign({},entities.sections,(_Object$assign5={},_defineProperty(_Object$assign5,fromSectionId,Object.assign({},entities.sections[fromSectionId],{modules:entities.sections[fromSectionId].modules.filter(function(id){return id!==moduleId;})})),_defineProperty(_Object$assign5,sectionId,section),_Object$assign5))}),sections:sections,overSection:{}})});if(this.data.layoutDraft.entities.sections[fromSectionId].modules.length<1){delete this.data.layoutDraft.entities.sections[fromSectionId];this.data.layoutDraft.sections=this.data.layoutDraft.sections.filter(function(id){return id!==fromSectionId;});}this.trigger(this.data);},resetOverSection:function resetOverSection(){this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layoutDraft,{overSection:{}})});this.trigger(this.data);},endDragging:function endDragging(sectionId,item){var _data$layoutDraft2=this.data.layoutDraft,entities=_data$layoutDraft2.entities,overSection=_data$layoutDraft2.overSection;var drag=entities.modules.drag;if(!drag&&overSection&&overSection.id){return this.moveToNewSection(overSection.id,sectionId,item.id);}var sections=entities.sections,modules=entities.modules;if(drag){var toSectionId=drag.sectionId,moduleId=drag.moduleId;modules=Object.assign({},modules,{drag:null});this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layoutDraft,{overSection:{},entities:Object.assign({},entities,{modules:modules})})});this.saveSnapshot();if(sectionId===toSectionId){var section=Object.assign({},sections[sectionId],{modules:sections[sectionId].modules.filter(function(_mId){return _mId!==moduleId;}).map(function(id){if(id==='drag'){return moduleId;}return id;})});sections=Object.assign({},sections,_defineProperty({},sectionId,section));}else{var _Object$assign7;var _section=Object.assign({},sections[sectionId],{modules:sections[sectionId].modules.filter(function(_mId){return _mId!==moduleId;})});var toSection=Object.assign({},sections[toSectionId],{modules:sections[toSectionId].modules.map(function(id){if(id==='drag'){return moduleId;}return id;})});sections=Object.assign({},sections,(_Object$assign7={},_defineProperty(_Object$assign7,sectionId,_section),_defineProperty(_Object$assign7,toSectionId,toSection),_Object$assign7));}this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layoutDraft,{entities:Object.assign({},entities,{sections:sections})})});if(sections[sectionId].modules.length<1){this.data.layoutDraft.sections=this.data.layoutDraft.sections.filter(function(id){return id!==sectionId;});delete sections[sectionId];}this.trigger(this.data);}},getInitialState:function getInitialState(){return this.data;},setFilterCategory:function setFilterCategory(categoryId){if(this.data.filter.categoryId!==categoryId){var filter=Object.assign({},this.data.filter,{categoryId:categoryId});this.data=Object.assign({},this.data,{filter:filter});this.trigger(this.data);}},setFilterTag:function setFilterTag(tagName){var enabled=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;if(!!this.data.filter.tags[tagName]!==enabled){var filter=Object.assign({},this.data.filter,{tags:Object.assign({},this.data.filter.tags,_defineProperty({},tagName,enabled))});this.data=Object.assign({},this.data,{filter:filter});this.trigger(this.data);}},setSearchText:function setSearchText(searchText){if(this.data.filter.searchText!==searchText){var filter=Object.assign({},this.data.filter,{searchText:searchText});this.data=Object.assign({},this.data,{filter:filter});this.trigger(this.data);}},setFilter:function setFilter(filter){this.data=Object.assign({},this.data,{filter:Object.assign({},this.data.filter,filter)});this.trigger(this.data);},editMode:function editMode(){var layoutDraft=this.data.layoutDraft;if(!layoutDraft){layoutDraft=JSON.parse(JSON.stringify(this.data.layout));}this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},layoutDraft,{selectedModuleId:null,selectedSectionId:null}),mode:'editor'});this.trigger(this.data);},listMode:function listMode(){this.data=Object.assign({},this.data,{mode:'list'});this.trigger(this.data);},start:function start(name){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var slug=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;if(slug&&type){this.data.load={type:type,slug:slug};}if(this.data.name!==name){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].read(name);}else{this.loadQueued();}},setDialogMode:function setDialogMode(dialogMode){this.data=Object.assign({},this.data,{dialogMode:dialogMode});persistStore(this.data);this.trigger(this.data);},loading:function loading(){var loading=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;this.data=Object.assign({},this.data,{loading:loading});this.trigger(this.data);},read:function read(name){var _this=this;var skipItems=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;this.loading();var discountCode=this.data.discountCode;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('store','read',{name:name,hostname:domain,discountCode:discountCode,skipItems:skipItems}).then(function(store){if(store&&store.owner&&store.owner.locale){__WEBPACK_IMPORTED_MODULE_1_actions__["b" /* AuthActions */].setLocale(store.owner.locale);}__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].readComplete(name,store);},function(error){_this.loading(false);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},getEntities:function getEntities(data){var list=[];var items={};data.forEach(function(item){item.tagsMap=Array.isArray(item.tagsMap)?{}:item.tagsMap;var categories={};if(!Array.isArray(item.categories)){categories[item.categories]=true;}else{item.categories.forEach(function(category){return categories[category]=true;});}item.categories=categories;items[item.type]=items[item.type]||{};items[item.type][item.id]=item;list.push({type:item.type,id:item.id});});return{list:list,items:items};},getDefaultLayout:function getDefaultLayout(data){var _sections,_modules2;var bannerModule={type:'Banner',src:data.presentation.coverUrl,color:__WEBPACK_IMPORTED_MODULE_6_stores_Theme__["a" /* default */].getColor(data.theme.color),headerPosition:'centerCenter',backgroundColor:'#FFFFFF',opacity:0,size:2,header:'<h1>'+data.presentation.text+'</h1>',id:new __WEBPACK_IMPORTED_MODULE_5_Util_ObjectId__["a" /* default */]().toString()};var listModule={type:'List',id:new __WEBPACK_IMPORTED_MODULE_5_Util_ObjectId__["a" /* default */]().toString(),mode:'cards'};var bannerSection={type:'banner',id:new __WEBPACK_IMPORTED_MODULE_5_Util_ObjectId__["a" /* default */]().toString(),modules:[bannerModule.id]};var listSection={type:'banner',id:new __WEBPACK_IMPORTED_MODULE_5_Util_ObjectId__["a" /* default */]().toString(),modules:[listModule.id]};return{entities:{sections:(_sections={},_defineProperty(_sections,bannerSection.id,bannerSection),_defineProperty(_sections,listSection.id,listSection),_sections),modules:(_modules2={},_defineProperty(_modules2,bannerModule.id,bannerModule),_defineProperty(_modules2,listModule.id,listModule),_modules2)},sections:[bannerSection.id,listSection.id]};},readComplete:function readComplete(name,store){var items=store.items,layoutStructure=store.layoutStructure,other=_objectWithoutProperties(store,['items','layoutStructure']);if(layoutStructure&&layoutStructure.entities&&layoutStructure.entities.modules){delete layoutStructure.entities.modules.drag;}var entities=this.getEntities(items);var defaultLayout=void 0;var template={entities:{sections:{},modules:{}},sections:[],overSection:{}};if(!layoutStructure){defaultLayout=this.getDefaultLayout(store);}var googleAnalyticsId=inProduction&&store.ga?store.ga.id:__WEBPACK_IMPORTED_MODULE_4_Config__["a" /* default */].googleAnalyticsId;__WEBPACK_IMPORTED_MODULE_8_helpers_universalAnalytics__["a" /* default */].initialize(googleAnalyticsId);if(store.owner.id===100205){this.renderGtmScript('GTM-5XL3C2J');}if(store.owner.id===141243){this.renderGtmScript('GTM-WFLZ5BN');}var options={autoConfig:true,debug:false};var facebookPixelId=inProduction&&store.js?store.js.pixel:__WEBPACK_IMPORTED_MODULE_4_Config__["a" /* default */].facebookPixelId;__WEBPACK_IMPORTED_MODULE_9_helpers_facebookPixel__["a" /* default */].init(facebookPixelId,null,options);__WEBPACK_IMPORTED_MODULE_9_helpers_facebookPixel__["a" /* default */].track('PageView');this.data=Object.assign({},this.data,other,entities,{layout:Object.assign({},template,defaultLayout,layoutStructure),name:name,googleAnalyticsId:googleAnalyticsId,facebookPixelId:facebookPixelId,loading:false});persistStore(this.data);this.trigger(this.data);this.loadQueued();},update:function update(){var layoutDraft=this.data.layoutDraft;persistStore(this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateComplete(layoutDraft);},publish:function publish(){var _this2=this;var _data=this.data,name=_data.name,layoutDraft=_data.layoutDraft;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('store','saveLayout',{name:name,data:layoutDraft}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateComplete(layoutDraft);},function(error){_this2.loading(false);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},discard:function discard(){this.saveSnapshot();this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layout),mode:'list'});this.trigger(this.data);},updateComplete:function updateComplete(layout){this.data=Object.assign({},this.data,{layout:layout,layoutDraft:Object.assign({},this.data.layout),mode:'list'});this.trigger(this.data);},loadQueued:function loadQueued(){if(this.data.load){var _data$load=this.data.load,type=_data$load.type,slug=_data$load.slug;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].findBySlug(type,slug);this.data.load=null;}},toggleFilterMode:function toggleFilterMode(){var filterMode=this.data.filterMode==='simple'?'extended':'simple';this.data=Object.assign({},this.data,{filterMode:filterMode});persistStore(this.data);this.trigger(this.data);},completePayment:function completePayment(paymentId,providerId,token){var _this3=this;__WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('payment','complete',{paymentId:paymentId,providerId:providerId,token:token}).then(function(data){if(data){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].paymentCompleted(data);}else{__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError();}},function(error){if(error=='3D authentication has failed.'){_this3.data=Object.assign({},_this3.data,{payment:Object.assign({},_this3.data.payment,{loading:false,completed:false,error:error,data:Object.assign({},_this3.data.payment.data,{url:null,error:error})})});_this3.trigger(_this3.data);}else{__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);}});},startPayment:function startPayment(providerId,token,evidence,address,source){var _this4=this;// gift email
var _data2=this.data,giftEmail=_data2.giftEmail,discountCode=_data2.discountCode,cart=_data2.cart,name=_data2.name,payment=_data2.payment;this.data=Object.assign({},this.data,{payment:Object.assign({},payment,{loading:true,completed:false,error:null})});var errorLookup={incorrect_number:'number',card_declined:'number',invalid_number:'number',invalid_expiry_year:'year',invalid_expiry_month:'month',invalid_cvc:'cvc','0':'number'};this.trigger(this.data);__WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('payment','start',{address:address,gifterEmail:giftEmail,source:source,evidence:evidence,cart:cart,providerId:providerId,storeId:name,discountCode:discountCode,token:token}).then(function(data){if(data){if(data.snippet||data.action&&data.action=='redirect'&&data.url){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].paymentStarted(data);}else if(providerId===6){_this4.data.stripe.redirectToCheckout({sessionId:data.sessionId});}else{__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].paymentCompleted(data);}}else{_this4.data=Object.assign({},_this4.data,{payment:Object.assign({},_this4.data.payment,{loading:false,completed:false,errorText:{},error:true})});_this4.trigger(_this4.data);}},function(error){var match=error.match(/(Stripe error:)\s(.*)\s\(#(.*)\)/)||[];if(match.length<1){_this4.data=Object.assign({},_this4.data,{payment:Object.assign({},_this4.data.payment,{loading:false})});_this4.trigger(_this4.data);return __WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);}var _match=_slicedToArray(match,4),str=_match[0],type=_match[1],message=_match[2],messageId=_match[3];var errorText={};if(type==='Stripe error:'){var field=errorLookup[messageId];if(field){errorText[field]=message;}}_this4.data=Object.assign({},_this4.data,{payment:Object.assign({},_this4.data.payment,{loading:false,error:error,errorText:errorText})});_this4.trigger(_this4.data);});},clearError:function clearError(){this.data=Object.assign({},this.data,{payment:Object.assign({},this.data.payment,{errorText:{}})});this.trigger(this.data);},clearPaymentMethod:function clearPaymentMethod(){this.setPaymentMethod(null);},resetPayment:function resetPayment(){this.data=Object.assign({},this.data,{giftEmail:null,payment:Object.assign({},this.data.payment,{method:null,completed:false})});this.trigger(this.data);},reset:function reset(){this.data=Object.assign({},this.data,{giftEmail:null,cart:[],payment:Object.assign({},this.data.payment,{method:null,completed:false})});localStorage.removeItem('coursio::store');this.trigger(this.data);},setPaymentMethod:function setPaymentMethod(method){this.data=Object.assign({},this.data,{payment:Object.assign({},this.data.payment,{method:method})});this.trigger(this.data);},paymentCompleted:function paymentCompleted(data){this.data=Object.assign({},this.data,{payment:Object.assign({},this.data.payment,{loading:false,completed:true,error:false,data:Object.assign({},this.data.payment.data,data)})});var _data3=this.data,googleAnalyticsId=_data3.googleAnalyticsId,facebookPixelId=_data3.facebookPixelId;if(googleAnalyticsId){var _data$cart=_slicedToArray(this.data.cart,1),_data$cart$=_data$cart[0],type=_data$cart$.type,id=_data$cart$.id,gift=_data$cart$.gift;var affiliation=this.data.owner.username;var item=this.data.items[type][id];var options={autoConfig:true,debug:false};__WEBPACK_IMPORTED_MODULE_9_helpers_facebookPixel__["a" /* default */].init(facebookPixelId,null,options);__WEBPACK_IMPORTED_MODULE_9_helpers_facebookPixel__["a" /* default */].track('Purchase',{currency:item.currency||'SEK',value:item.price.discounted});__WEBPACK_IMPORTED_MODULE_8_helpers_universalAnalytics__["a" /* default */].initialize(googleAnalyticsId);__WEBPACK_IMPORTED_MODULE_8_helpers_universalAnalytics__["a" /* default */].ecAddTransaction({transaction_id:type+'-'+id,affiliation:affiliation,value:item.price.discounted,currency:item.currency||'SEK',items:[{id:id,name:item.name,quantity:1,price:item.price.discounted}]});}else{var _data$cart2=_slicedToArray(this.data.cart,1),_data$cart2$=_data$cart2[0],_type=_data$cart2$.type,_id=_data$cart2$.id,_gift=_data$cart2$.gift;var _affiliation=this.data.owner.username;var _item=this.data.items[_type][_id];var _options={autoConfig:true,debug:false};__WEBPACK_IMPORTED_MODULE_9_helpers_facebookPixel__["a" /* default */].init(facebookPixelId,null,_options);__WEBPACK_IMPORTED_MODULE_9_helpers_facebookPixel__["a" /* default */].track('Purchase',{currency:_item.currency||'SEK',value:_item.price.discounted});__WEBPACK_IMPORTED_MODULE_8_helpers_universalAnalytics__["a" /* default */].initialize();__WEBPACK_IMPORTED_MODULE_8_helpers_universalAnalytics__["a" /* default */].ecAddTransaction({transaction_id:_type+'-'+_id,affiliation:_affiliation,value:_item.price.discounted,currency:_item.currency||'SEK',items:[{id:_id,name:_item.name,quantity:1,price:_item.price.discounted}]});}this.trigger(this.data);},paymentStarted:function paymentStarted(data){var item=this.data.items[this.data.cart[0].type][this.data.cart[0].id];__WEBPACK_IMPORTED_MODULE_8_helpers_universalAnalytics__["a" /* default */].checkout({id:item.id,name:item.name,price:item.price.discounted,quantity:1});this.data=Object.assign({},this.data,{payment:Object.assign({},this.data.payment,{loading:false,completed:false,error:false,data:Object.assign({},this.data.payment.data,data)})});persistStore(this.data);this.trigger(this.data);},findBySlug:function findBySlug(type,slug){var _data4=this.data,discountCode=_data4.discountCode,name=_data4.name;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('store','findBySlug',{type:type,slug:slug,discountCode:discountCode,username:name}).then(function(data){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].findBySlugComplete(data);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},addCart:function addCart(type,id,name){var gift=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;this.data=Object.assign({},this.data,{name:name,cart:[{type:type,id:id,gift:gift}]});persistStore(this.data);this.trigger(this.data);},addToCart:function addToCart(data){var gift=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var type=data.type,id=data.id,name=data.name,price=data.price;this.data=Object.assign({},this.data,{cart:[{type:type,id:id,gift:gift}]});persistStore(this.data);__WEBPACK_IMPORTED_MODULE_8_helpers_universalAnalytics__["a" /* default */].ecAddItem({name:name,id:id,variant:gift?'gift':null,category:type,price:price.discounted,quantity:1});__WEBPACK_IMPORTED_MODULE_9_helpers_facebookPixel__["a" /* default */].track('AddToCart',{content_name:this.data.name,contents:[{type:type,id:id,gift:gift}]});this.trigger(this.data);!gift&&__WEBPACK_IMPORTED_MODULE_7_helpers__["a" /* history */].push('/checkout/'+this.data.name+'/'+id+'/'+type);},clearCart:function clearCart(){this.data=Object.assign({},this.data,{cart:[],payment:Object.assign({},this.data.payment,{completed:false,method:null})});this.trigger(this.data);},findBySlugComplete:function findBySlugComplete(data){console.log(data);var type=data.type,id=data.id;var items=this.data.items;var item=Object.assign({},items[type][id],data);this.data=Object.assign({},this.data,{items:Object.assign({},items,_defineProperty({},type,Object.assign({},items[type],_defineProperty({},id,item)))),selected:{type:type,id:id}});persistStore(this.data);__WEBPACK_IMPORTED_MODULE_8_helpers_universalAnalytics__["a" /* default */].viewitem({id:data.id,name:data.name,price:data.price.discounted,quantity:1});this.trigger(this.data);},clearSelected:function clearSelected(){this.data=Object.assign({},this.data,{selected:{}});this.trigger(this.data);},setDiscountCode:function setDiscountCode(discountCode){this.data=Object.assign({},this.data,{discountCode:discountCode});persistStore(this.data);this.trigger(this.data);},setGiftEmail:function setGiftEmail(giftEmail){this.data=Object.assign({},this.data,{giftEmail:giftEmail});var _data$cart3=_slicedToArray(this.data.cart,1),_data$cart3$=_data$cart3[0],type=_data$cart3$.type,id=_data$cart3$.id;this.trigger(this.data);__WEBPACK_IMPORTED_MODULE_7_helpers__["a" /* history */].push('/checkout/'+this.data.name+'/'+id+'/'+type);},openModuleMenu:function openModuleMenu(){this.data=Object.assign({},this.data,{moduleMenu:true});this.trigger(this.data);},closeModuleMenu:function closeModuleMenu(){this.data=Object.assign({},this.data,{moduleMenu:false});this.trigger(this.data);},addModule:function addModule(sectionProps,moduleProps){var sectionId=new __WEBPACK_IMPORTED_MODULE_5_Util_ObjectId__["a" /* default */]().toString();var moduleId=new __WEBPACK_IMPORTED_MODULE_5_Util_ObjectId__["a" /* default */]().toString();var sections=void 0;var module=Object.assign({},moduleProps,{id:moduleId});var section=void 0;var layoutDraft=this.data.layoutDraft;if(layoutDraft.selectedSectionId){var selectedSection=layoutDraft.entities.sections[layoutDraft.selectedSectionId];sectionId=layoutDraft.selectedSectionId;section=Object.assign({},selectedSection,{modules:[].concat(_toConsumableArray(selectedSection.modules),[moduleId])});sections=layoutDraft.sections;}else{section=Object.assign({type:'banner',id:sectionId},sectionProps,{modules:[moduleId]});sections=[].concat(_toConsumableArray(layoutDraft.sections),[sectionId]);}this.saveSnapshot();this.data=Object.assign({},this.data,{moduleMenu:false,layoutDraft:Object.assign({},layoutDraft,this.data.layoutDraft,{entities:{sections:Object.assign({},layoutDraft.entities.sections,_defineProperty({},sectionId,section)),modules:Object.assign({},layoutDraft.entities.modules,_defineProperty({},moduleId,module))},sections:sections})});this.trigger(this.data);},selectSection:function selectSection(selectedSectionId){this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layoutDraft,{selectedSectionId:selectedSectionId})});this.trigger(this.data);},selectModule:function selectModule(selectedModuleId){this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layoutDraft,{selectedModuleId:selectedModuleId})});this.trigger(this.data);},unselect:function unselect(){this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layoutDraft,{selectedModuleId:null,selectedSectionId:null})});this.trigger(this.data);},moveElement:function moveElement(array,from,to){var defCopy=[].concat(_toConsumableArray(array));var dest=to;if(from<to){dest=dest-1;}if(to>=defCopy.length){var k=to-defCopy.length;while(k--+1){defCopy.push(undefined);}}defCopy.splice(dest,0,defCopy.splice(from,1)[0]);return defCopy.filter(function(item){return typeof item!=='undefined';});},moveSection:function moveSection(sectionId,toSectionId,offset){this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},this.data.layoutDraft,{overSection:{}})});this.saveSnapshot();var layoutDraft=this.data.layoutDraft;var sections=layoutDraft.sections;var index=sections.findIndex(function(id){return sectionId===id;});var destIndex=sections.findIndex(function(id){return toSectionId===id;});if(index>-1){this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},layoutDraft,{sections:this.moveElement(layoutDraft.sections,index,Math.max(destIndex+offset,0))})});this.trigger(this.data);}},updateModule:function updateModule(moduleId,moduleProps){this.saveSnapshot();var layoutDraft=this.data.layoutDraft;this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},layoutDraft,{entities:Object.assign({},layoutDraft.entities,{modules:Object.assign({},layoutDraft.entities.modules,_defineProperty({},moduleId,Object.assign({},layoutDraft.entities.modules[moduleId],moduleProps)))})})});this.trigger(this.data);},updateSection:function updateSection(sectionId,sectionProps){this.saveSnapshot();var layoutDraft=this.data.layoutDraft;this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},layoutDraft,{entities:Object.assign({},layoutDraft.entities,{sections:Object.assign({},layoutDraft.entities.sections,_defineProperty({},sectionId,Object.assign({},layoutDraft.entities.sections[sectionId],sectionProps)))})})});this.trigger(this.data);},undo:function undo(){this.updateModuleDebounced.clear();var layoutDraft=this.data.layoutHistory.pop();this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},layoutDraft)});this.trigger(this.data);},saveSnapshot:function saveSnapshot(){this.data.layoutHistory.push(Object.assign({},this.data.layoutDraft));},deleteModule:function deleteModule(){this.saveSnapshot();var _data$layoutDraft3=this.data.layoutDraft,selectedModuleId=_data$layoutDraft3.selectedModuleId,selectedSectionId=_data$layoutDraft3.selectedSectionId;var layoutDraft=Object.assign({},this.data.layoutDraft);var sections=Object.assign({},layoutDraft.entities.sections);var modules=Object.assign({},layoutDraft.entities.modules);delete modules[selectedModuleId];sections[selectedSectionId]=Object.assign({},sections[selectedSectionId],{modules:sections[selectedSectionId].modules.filter(function(moduleId){return moduleId!==selectedModuleId;})});if(sections[selectedSectionId].modules.length<1){delete sections[selectedSectionId];layoutDraft.sections=layoutDraft.sections.filter(function(sectionId){return sectionId!==selectedSectionId;});}this.data=Object.assign({},this.data,{layoutDraft:Object.assign({},layoutDraft,{entities:Object.assign({},layoutDraft.entities,{sections:sections,modules:modules})}),selectedSectionId:null,selectedModuleId:null});this.trigger(this.data);},renderGtmScript:function renderGtmScript(gtmCode){return function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);}(window,document,'script','dataLayer',gtmCode);}});/* harmony default export */ __webpack_exports__["a"] = (StoreOverviewStore);

/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var _increment=Math.floor(Math.random()*16777216);var _pid=Math.floor(Math.random()*65536);var _machine=Math.floor(Math.random()*16777216);var mongoMachineId=parseInt(localStorage.mongoMachineId,10);if(mongoMachineId>=0&&mongoMachineId<=16777215){_machine=Math.floor(localStorage.mongoMachineId);}// Just always stick the value in.
localStorage.mongoMachineId=_machine;var ObjectId=function(){function ObjectId(){_classCallCheck(this,ObjectId);if(!(this instanceof ObjectId)){return new ObjectId(arguments[0],arguments[1],arguments[2],arguments[3]).toString();}if(_typeof(arguments[0])==='object'){this.timestamp=arguments[0].timestamp;this.machine=arguments[0].machine;this.pid=arguments[0].pid;this.increment=arguments[0].increment;}else if(typeof arguments[0]==='string'&&arguments[0].length===24){this.timestamp=Number('0x'+arguments[0].substr(0,8));this.machine=Number('0x'+arguments[0].substr(8,6));this.pid=Number('0x'+arguments[0].substr(14,4));this.increment=Number('0x'+arguments[0].substr(18,6));}else if(arguments.length===4&&arguments[0]!==null){this.timestamp=arguments[0];this.machine=arguments[1];this.pid=arguments[2];this.increment=arguments[3];}else{this.timestamp=Math.floor(new Date().valueOf()/1000);this.machine=_machine;this.pid=_pid;this.increment=_increment++;if(_increment>0xffffff){_increment=0;}}}_createClass(ObjectId,[{key:'getDate',value:function getDate(){return new Date(this.timestamp*1000);}},{key:'toArray',value:function toArray(){var strOid=this.toString();var array=[];for(var i=0;i<12;i++){array[i]=parseInt(strOid.slice(i*2,i*2+2),16);}return array;}},{key:'toString',value:function toString(){if(this.timestamp===undefined||this.machine===undefined||this.pid===undefined||this.increment===undefined){return'Invalid ObjectId';}var timestamp=this.timestamp.toString(16);var machine=this.machine.toString(16);var pid=this.pid.toString(16);var increment=this.increment.toString(16);return'00000000'.substr(0,8-timestamp.length)+timestamp+'000000'.substr(0,6-machine.length)+machine+'0000'.substr(0,4-pid.length)+pid+'000000'.substr(0,6-increment.length)+increment;}}]);return ObjectId;}();/* harmony default export */ __webpack_exports__["a"] = (ObjectId);

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers_facebookPixel__ = __webpack_require__(367);
/* global __TARGET__*/var inProduction="production"==='production';var KlarnaStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["v" /* PaymentActions */]],data:{paymentComplete:false,error:null,method:null},getInitialState:function getInitialState(){return this.data;},init:function init(){},change:function change(props){this.data=Object.assign({},this.data,props);this.trigger(this.data);},start:function start(cart,providerId,storeId,discountCode,token,evidence,address){var _this=this;this.data=Object.assign({},this.data,{paymentComplete:false,error:null,loading:true});this.trigger(this.data);__WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('payment','start',{address:address,evidence:evidence,cart:cart,providerId:providerId,storeId:storeId,discountCode:discountCode,token:token}).then(function(data){if(data){__WEBPACK_IMPORTED_MODULE_1_actions__["v" /* PaymentActions */].paymentCompleted(data);}else{_this.error();}},function(error){_this.error(error);});},error:function error(_error){this.data=Object.assign({},this.data,{loading:false,error:_error,paymentComplete:false});this.trigger(this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(_error);},paymentCompleted:function paymentCompleted(data){this.data=Object.assign({},this.data,{paymentComplete:true,loading:false});var options={autoConfig:true,debug:false};var facebookPixelId=inProduction&&data.js?data.js.pixel:__WEBPACK_IMPORTED_MODULE_3_Config__["a" /* default */].facebookPixelId;__WEBPACK_IMPORTED_MODULE_4_helpers_facebookPixel__["a" /* default */].init(facebookPixelId,null,options);__WEBPACK_IMPORTED_MODULE_4_helpers_facebookPixel__["a" /* default */].track('Purchase',{currency:data.currency,value:data.price});this.trigger(this.data);},paymentStarted:function paymentStarted(data){}});/* harmony default export */ __webpack_exports__["a"] = (KlarnaStore);

/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
var CategoryStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["d" /* CategoryActions */]],data:{list:[],loading:true},getInitialState:function getInitialState(){return this.data;},init:function init(){},initCategories:function initCategories(){if(this.data.list.length<1){this.readCategories();}},loading:function loading(_loading){this.data=Object.assign({},this.data,{loading:_loading});this.trigger(this.data);},readCategories:function readCategories(){var _this=this;this.loading();return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('category','read',{}).then(function(list){__WEBPACK_IMPORTED_MODULE_1_actions__["d" /* CategoryActions */].readCategoriesComplete(list);},function(error){_this.loading(false);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},readCategoriesComplete:function readCategoriesComplete(list){this.data=Object.assign({},this.data,{list:list.map(function(category){return{payload:category.slug,id:category.id,slug:category.slug,label:category.name};}),loading:false});this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (CategoryStore);

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
var StripeStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["B" /* StripeActions */]],data:{exp_month:null,exp_year:null,number:null,object:'card',cvc:null},getInitialState:function getInitialState(){return this.data;},init:function init(){},change:function change(props){this.data=Object.assign({},this.data,props);this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (StripeStore);

/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function dateCheck(from,to,check){var fDate=void 0,lDate=void 0,cDate=void 0;fDate=Date.parse(from);lDate=Date.parse(to);cDate=Date.parse(check);if(cDate<=lDate&&cDate>=fDate){return true;}return false;}var QuizStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */]],data:{started:false,ended:false,time:'',userdata:{},results:{},pageId:null,content:[],answers:[],score:null,threshold:null,steps:['QUIZ_INTRO','QUIZ_MAIN','QUIZ_FAIL','QUIZ_SUCCESS','QUIZ_RESULT'],currentStep:'QUIZ_INTRO',currentQuestion:0,displayNext:null,displayPrev:null,testComplete:false,startTime:null},getInitialState:function getInitialState(){return this.data;},initialize:function initialize(data,settings,pageId,userdata){var can=true;// if (
//   (settings.hasOwnProperty('endDate') && settings.endDate === '') ||
//   !settings.hasOwnProperty('endDate')
// ) {
//   can = false;
// }
// if (
//   (settings.hasOwnProperty('startDate') && settings.startDate !== '') ||
//   !settings.hasOwnProperty('startDate')
// ) {
//   can = false;
// }
// if (!!settings.startDate && !!settings.endDate) {
//   if (!dateCheck(settings.startDate, settings.endDate, new Date())) {
//     can = false;
//   }
// } else if (
//   !settings.startDate &&
//   !!settings.endDate &&
//   !(new Date() <= new Date(settings.endDate))
// ) {
//   can = false;
// } else if (
//   !!settings.startDate &&
//   !settings.endDate &&
//   !(new Date() >= new Date(settings.startDate))
// ) {
//   can = false;
// }
can&&!this.data.started&&this.startTimer(settings);this.data=Object.assign({},this.data,{started:false,userdata:!!userdata?userdata:{locked:false,pages:{}},results:{},pageId:pageId,content:this.normalizeData(data),answers:[],score:null,threshold:settings.threshold/100,currentStep:'QUIZ_INTRO',currentQuestion:0,displayNext:this.data.content.length-1>this.data.currentQuestion,displayPrev:this.data.currentQuestion>=1,testComplete:false,startTime:null});this.trigger(this.data);},getTimeRemaining:function getTimeRemaining(endtime){var t=Date.parse(endtime)-Date.parse(new Date());var seconds=Math.floor(t/1000%60);var minutes=Math.floor(t/1000/60%60);var hours=Math.floor(t/(1000*60*60)%24);var days=Math.floor(t/(1000*60*60*24));return{total:t,days:days,hours:hours,minutes:minutes,seconds:seconds};},startTimer:function startTimer(settings){var _this=this;var updateClock=function updateClock(){var t=_this.getTimeRemaining(settings.endDate);if(t.total<=0){_this.calculateTest();clearInterval(timeinterval);}_this.data.time=t.hours+'h '+t.minutes+'m '+t.seconds+'s left';_this.trigger(_this.data);};updateClock();// run function once at first to avoid delay
var timeinterval=setInterval(updateClock,1000);},reset:function reset(){this.data={started:false,userdata:{},results:{},pageId:null,content:[],answers:[],score:null,threshold:null,currentStep:'QUIZ_INTRO',steps:['QUIZ_INTRO','QUIZ_MAIN','QUIZ_FAIL','QUIZ_SUCCESS','QUIZ_RESULT'],currentQuestion:0,displayNext:null,displayPrev:null,testComplete:false,startTime:null};this.trigger(this.data);},normalizeData:function normalizeData(data){var _this2=this;return data.map(function(_ref){var pageModules=_ref.pageModules;var _pageModules$=pageModules[0],id=_pageModules$.id,_pageModules$$data$pa=_pageModules$.data.params,task=_pageModules$$data$pa.task,taskResults=_pageModules$$data$pa.taskResults;_this2.data.results[id]=taskResults&&taskResults[taskResults.length-1]||{};return Object.assign({},task,{pageModuleId:id,taskResults:taskResults});});},calculateTest:function calculateTest(){var _this3=this;for(var i=0;i<this.data.content.length;i++){if(!this.data.content[i].hasOwnProperty('answered')){return alert('You have not answered all questions to end quiz');}}__WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('quiz','complete',{pageId:this.data.pageId},0,1000).then(function(_ref2){var score=_ref2.score,answers=_ref2.answers;_this3.data.score=score;_this3.data.answers=answers;if(score>=_this3.data.content.length*(_this3.data.threshold||0.8)){_this3.data.currentStep='QUIZ_SUCCESS';}else{_this3.data.currentStep='QUIZ_FAIL';}var endTime=new Date();var duration=endTime-_this3.data.startTime;_this3.data.ended=true;_this3.trigger(_this3.data);var page=_this3.data.userdata.pages[_this3.data.pageId]?_this3.data.userdata.pages[_this3.data.pageId]:[];var data=Object.assign({},_this3.data.userdata,{locked:true,pages:Object.assign({},_this3.data.userdata.pages,_defineProperty({},_this3.data.pageId,[].concat(_toConsumableArray(page),[{score:score,total:_this3.data.content.length,status:_this3.data.currentStep,startTime:_this3.data.startTime,endTime:new Date(),duration:duration}])))});_this3.data.userdata=data;_this3.trigger(data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('content','saveDataForObject',{objectId:_this3.data.pageId,objectType:'page',data:data});});},updateAnswer:function updateAnswer(taskId,pageModuleId,taskResult,bodyFiles){var numAnswers=0;this.data.content=this.data.content.map(function(q){if(q.taskResults.length){numAnswers++;}if(q.pageModuleId===pageModuleId){return Object.assign({},q,{answered:taskResult.body.value,taskResults:[].concat(_toConsumableArray(q.taskResults),[{id:taskResult.id,feedback:taskResult.feedback||{},visible:taskResult.visible,bodyFiles:bodyFiles,body:{value:taskResult.body.value}}])});}return q;});if(numAnswers===this.data.content.length){this.data.testComplete=true;}// localStorage.setItem(this.data.pageId, JSON.stringify(this.data.content));
this.trigger(this.data);},setNextStep:function setNextStep(step){var _this4=this;if(typeof step==='string'){var index=this.data.steps.findIndex(function(i){return i===step;});this.data.currentStep=this.data.steps[index];}else{var _index=this.data.steps.findIndex(function(i){return i===_this4.data.currentStep;});this.data.currentStep=this.data.steps[_index+1];}if(this.data.currentStep==='QUIZ_MAIN'){this.data.startTime=new Date();this.data.started=true;}this.trigger(this.data);},next:function next(){this.data.currentQuestion=this.data.currentQuestion+1;this.data.displayNext=this.data.content.length-1>this.data.currentQuestion;this.data.displayPrev=this.data.currentQuestion>=1;this.trigger(this.data);},prev:function prev(){this.data.currentQuestion=this.data.currentQuestion-1;this.data.displayNext=this.data.content.length-1>this.data.currentQuestion;this.data.displayPrev=this.data.currentQuestion>=1;this.trigger(this.data);},setQuestion:function setQuestion(index){this.data.currentQuestion=index;this.data.displayNext=this.data.content.length-1>this.data.currentQuestion;this.data.displayPrev=this.data.currentQuestion>=1;this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (QuizStore);

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_oxygen_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__);
var _templateObject=_taggedTemplateLiteral(['Quiz statistics will be generated and mailed to your email addresss.'],['Quiz statistics will be generated and mailed to your email addresss.']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var QuizDetailStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["x" /* QuizDetailActions */]],data:{filters:{courseId:null,userId:null},pages:{selectedPage:null,list:[],entities:{},loading:false},students:{selectedStudent:null,loading:false,entities:{},list:[]},courses:{selectedCourse:null,list:[],expanded:true,entities:{},filter:null,loading:false}},quiz:{quizData:[],quizStudents:[],studentData:null},getInitialState:function getInitialState(){return this.data;},start:function start(){__WEBPACK_IMPORTED_MODULE_1_actions__["x" /* QuizDetailActions */].findCourses();},loading:function loading(){var listName=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'pages';var loading=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;this.data=Object.assign({},this.data,_defineProperty({},listName,Object.assign({},this.data[listName],{loading:loading})));this.trigger(this.data);this.trigger(this.quiz);},resetPage:function resetPage(id,locked,selectedPage,quizData){var _this=this;quizData.forEach(function(el,i){if(el.id===selectedPage){var userdata=el.userdata[id];_this.quiz.quizData[i]=el;_this.quiz.quizData[i].userdata[id].locked=locked;_this.trigger(_this.quiz);return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('content','saveDataForObject',{objectId:Number(selectedPage),objectType:'page',userId:id,data:Object.assign({},userdata,{locked:locked})});}});},selectPage:function selectPage(id){this.data.pages.selectedPage=id;this.data.students.selectedStudent=null;this.trigger(this.data);},// selectCourse(id) {
//   this.data.courses.selectedCourse = id;
//   this.data.pages.selectedPage = null;
//   this.data.students.selectedStudent = null;
//   this.trigger(this.data);
//   QuizDetailActions.readQuizzes(id);
// },
// selectUser(id, pageLength) {
//   this.data.students.selectedStudent = id;
//   this.trigger(this.data);
//   QuizDetailActions.readQuizzes(this.data.courses.selectedCourse, id, 0, pageLength);
// },
selectUser:__WEBPACK_IMPORTED_MODULE_2_oxygen_debounce___default()(function readUserDebounced(){var courseId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var userId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var _this2=this;var pageStart=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var pageLength=arguments.length>3&&arguments[3]!==undefined?arguments[3]:20;this.loading();return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('quiz','read',{courseId:courseId,userId:userId},pageStart,pageLength).then(function(data){_this2.quiz.studentData=data;_this2.trigger(_this2.quiz);},function(error){_this2.loading('pages',false);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},500),selectCourse:__WEBPACK_IMPORTED_MODULE_2_oxygen_debounce___default()(function readQuizzesDebounced(){var courseId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var userId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var pageStart=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var _this3=this;var pageLength=arguments.length>3&&arguments[3]!==undefined?arguments[3]:20;var callback=arguments[4];this.loading();__WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('quiz','read',{courseId:courseId,userId:userId},pageStart,pageLength).then(function(data){if(!Object.keys(data).length){return;}if(pageStart===0){_this3.quiz.quizData=data;}else{_this3.quiz.quizData=Object.assign({},_this3.quiz.quizData,data);}_this3.trigger(_this3.quiz);callback&&callback(data);},function(error){_this3.loading('pages',false);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);callback&&callback([]);});},500),readQuizzes:__WEBPACK_IMPORTED_MODULE_2_oxygen_debounce___default()(function readTasksDebounced(){var courseId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var userId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var _this4=this;var pageStart=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var pageLength=arguments.length>3&&arguments[3]!==undefined?arguments[3]:20;this.loading();return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('quiz','read',{courseId:courseId,userId:userId},pageStart,pageLength).then(function(data){_this4.readQuizComplete(data,userId);},function(error){_this4.loading('pages',false);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},500),// findTaskStudents(courseId) {
//   this.loading('students');
//   return SteelCompass.request('user', 'findByCourseId', {
//     courseId,
//     showCourses: true,
//     sortBy: 'name',
//     sortMode: 'asc'
//   }, 0, 1100).then(
//     students => {
//       this.findTaskStudentsComplete(students);
//     },
//     error => {
//       this.loading('students', false);
//       AppActions.genericError(error);
//     }
//   );
// },
findTaskStudents:function findTaskStudents(courseId){var _this5=this;this.loading('students');return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('user','findByCourseId',{courseId:courseId,showCourses:true,sortBy:'name',sortMode:'asc'},0,1100).then(function(students){_this5.quiz.quizStudents=students;_this5.trigger(_this5.quiz);},function(error){_this5.loading('students',false);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},findCourses:function findCourses(){var _this6=this;this.loading('courses');return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('course','findBuildable',{filters:[{mode:'hasQuiz',value:true}]}).then(function(courses){_this6.findTaskCoursesComplete(courses);},function(error){_this6.loading('courses',false);__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},export:function _export(email){return __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].request('quiz','export',{recipientEmail:email}).then(function(courses){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].notify(Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject));},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},getEntities:function getEntities(input){var list=[];var entities={};input.forEach(function(item){list.push(item.id);entities[item.id]=item;});return{list:list,entities:entities};},findTaskCoursesComplete:function findTaskCoursesComplete(list){this.data=Object.assign({},this.data,{courses:Object.assign({},this.data.courses,{loading:false},this.getEntities(list))});this.trigger(this.data);},findTaskStudentsComplete:function findTaskStudentsComplete(list){this.data=Object.assign({},this.data,{students:Object.assign({},this.data.students,{loading:false},this.getEntities(list))});this.trigger(this.data);},readQuizComplete:function readQuizComplete(entities,id){this.data=Object.assign({},this.data,{pages:Object.assign({},this.data.pages,{list:Object.keys(entities),entities:Object.assign(_defineProperty({},this.data.pages.selectedPage,Object.assign({},entities[this.data.pages.selectedPage],this.data.pages.entities[this.data.pages.selectedPage])),this.data.pages.entities,entities),loading:false})});// console.log(this.data, 'check data')
this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (QuizDetailStore);

/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
var WebinarStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["H" /* WebinarActions */]],data:{url:null,loading:true},getInitialState:function getInitialState(){return this.data;},initWebinar:function initWebinar(id,isWebinar,isHost,addHostKey,useCoursioKeys){var _this=this;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('vendor/xroom','init',{id:id,isWebinar:isWebinar,isHost:isHost,addHostKey:addHostKey,useCoursioKeys:useCoursioKeys}).then(function(data){_this.data.loading=true;_this.trigger(_this.data);__WEBPACK_IMPORTED_MODULE_1_actions__["H" /* WebinarActions */].initComplete(data.url);},function(error){__WEBPACK_IMPORTED_MODULE_1_actions__["a" /* AppActions */].genericError(error);});},initComplete:function initComplete(url){this.data={url:url,loading:false};this.trigger(this.data);}});/* harmony default export */ __webpack_exports__["a"] = (WebinarStore);

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
var PageStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions__["s" /* PageActions */]],data:{courseHasQuiziframe:false},getInitialState:function getInitialState(){return this.data;},init:function init(){},findById:function findById(id){return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('page','findById',{id:id});},checkForQuiziframe:function checkForQuiziframe(pageIds){var _this=this;var findPagesByIdPromises=pageIds.map(function(id){return _this.findById(id);});Promise.all(findPagesByIdPromises).then(function(data){var doesCourseHasQuiziframe=data.some(function(item){return item.pageRows.map(function(row){return row.pageModules[0].type.name;}).some(function(type){return type==='quiziframe';});});if(doesCourseHasQuiziframe){_this.data.courseHasQuiziframe=true;_this.trigger(_this.data);}},function(error){console.log(error);__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].genericError(error);});}});/* harmony default export */ __webpack_exports__["a"] = (PageStore);

/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mixin;
function mixin(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var ParentClass=args.pop();var classGenerators=args;return classGenerators.reduce(function(ParentClass,classGenerator){return classGenerator(ParentClass);},ParentClass);}

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RefluxMixin;
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function RefluxMixin(ParentClass){return function(_ParentClass){_inherits(RefluxMixin,_ParentClass);function RefluxMixin(props){_classCallCheck(this,RefluxMixin);var _this=_possibleConstructorReturn(this,(RefluxMixin.__proto__||Object.getPrototypeOf(RefluxMixin)).call(this,props));_this._storeListeners=[];_this._actionListeners=[];return _this;}_createClass(RefluxMixin,[{key:"listenToStores",value:function listenToStores(){if(_get(RefluxMixin.prototype.__proto__||Object.getPrototypeOf(RefluxMixin.prototype),"listenToStores",this)){_get(RefluxMixin.prototype.__proto__||Object.getPrototypeOf(RefluxMixin.prototype),"listenToStores",this).call(this);}}},{key:"listenToStore",value:function listenToStore(store,key){if(key){this._storeListeners.push(store.listen(this._changeListenerWithKey.bind(this,key)));var data={};data[key]=store.getInitialState();this.setState(data);}else{this._storeListeners.push(store.listen(this._changeListener.bind(this)));this.setState(store.getInitialState());}}},{key:"listenToStoreWithSelector",value:function listenToStoreWithSelector(store,selector){this._storeListeners.push(store.listen(this._changelistenerWithSelector.bind(this,selector)));this.setState(store.getInitialState());}},{key:"shallowEquals",value:function shallowEquals(subState,state){return Object.keys(subState).every(function(key){return subState[key]===state[key];});}},{key:"listenToStoreWithMapper",value:function listenToStoreWithMapper(store,mapper,initial){var _this2=this;this._storeListeners.push(store.listen(function(state){var newState=mapper(state);if(!_this2.shallowEquals(newState,_this2.state)){_this2.setState(newState);}}));var state=Object.assign({},initial,mapper(store.getInitialState()));this.setState(state);}},{key:"listenToActions",value:function listenToActions(){if(_get(RefluxMixin.prototype.__proto__||Object.getPrototypeOf(RefluxMixin.prototype),"listenToActions",this)){_get(RefluxMixin.prototype.__proto__||Object.getPrototypeOf(RefluxMixin.prototype),"listenToActions",this).call(this);}}},{key:"mapActions",value:function mapActions(actions){var boundActions={};Object.keys(actions).forEach(function(actionName){var action=actions[actionName];boundActions[actionName]=function(){return action.apply(undefined,arguments);};});return boundActions;}},{key:"listenToAction",value:function listenToAction(action,callback){action&&this._actionListeners.push(action.listen(callback));}},{key:"_changeListenerWithKey",value:function _changeListenerWithKey(key,data){var updateObject={};updateObject[key]=data;this.setState(updateObject);}},{key:"_changelistenerWithSelector",value:function _changelistenerWithSelector(selector,data){var updateObject=Object.keys(selector).reduce(function(prev,current){prev[selector[current]]=data[current];return prev;},{});this.setState(updateObject);}},{key:"_changeListener",value:function _changeListener(data){this.setState(data);}},{key:"componentWillMount",value:function componentWillMount(){if(_get(RefluxMixin.prototype.__proto__||Object.getPrototypeOf(RefluxMixin.prototype),"componentWillMount",this)){_get(RefluxMixin.prototype.__proto__||Object.getPrototypeOf(RefluxMixin.prototype),"componentWillMount",this).call(this);}this.listenToStores();this.listenToActions();}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(_get(RefluxMixin.prototype.__proto__||Object.getPrototypeOf(RefluxMixin.prototype),"componentWillUnmount",this)){_get(RefluxMixin.prototype.__proto__||Object.getPrototypeOf(RefluxMixin.prototype),"componentWillUnmount",this).call(this);}this._storeListeners.forEach(function(unsub){return unsub();});this._actionListeners.forEach(function(unsub){return unsub();});}}]);return RefluxMixin;}(ParentClass);}

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RefluxMixin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stores_Auth__ = __webpack_require__(93);
function RefluxMixin(ParentClass){return ParentClass;// return class Authorizer extends ParentClass {
//   static willTransitionTo(transition) {
//     console.log(AuthStore.isAuthenticated());
//     if (!AuthStore.isAuthenticated()) {
//       transition.redirect('/login', {}, {nextPath : transition.path});
//     }
//   }
// };
}

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_MediaQuery__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_MainMenu__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_CoursioTheme__ = __webpack_require__(2054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_AppSnackBar__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_MessagePortal__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_DialogPortal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_helmet__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var navigatorData=['appCodeName','appName','appMinorVersion','cpuClass','platform',// 'plugins',
'opsProfile','userProfile','systemLanguage','userLanguage','appVersion','userAgent',// 'onLine',
'cookieEnabled'// 'mimeTypes',
];var windowData=['innerWidth','innerHeight'];var locationData=['host','hostname','href','origin','pathname','port','protocol'];var ThemeManager=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].ThemeManager;var css={report:'_D'};var App=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.state={media:__WEBPACK_IMPORTED_MODULE_2_services_MediaQuery__["a" /* default */].detect(),shouldSendBeDisabled:true},_this.onMenuChange=function(event,key,payload){if(payload.route){__WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* history */].push('/'+payload.route);}else if(payload.action&&_this[payload.action]){_this[payload.action](payload);event.preventDefault();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'getChildContext',value:function getChildContext(){return{muiTheme:ThemeManager.getMuiTheme(__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_CoursioTheme__["a" /* default */]),media:this.state.media,getIntlMessage:this.context.getIntlMessage};}},{key:'componentDidMount',value:function componentDidMount(){this.handleResize=this.handleResize.bind(this);this.handleContextMenu=this.handleContextMenu.bind(this);window.addEventListener('resize',this.handleResize);if(true){document.addEventListener('contextmenu',this.handleContextMenu);}// AuthActions.login();
this.checkUnreadNotifications();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props=this.props,params=_props.params,location=_props.location;var pathname=location.pathname;if(params.hash){return;}if(this.props.locale!==nextProps.locale){var locale=nextProps.locale;__WEBPACK_IMPORTED_MODULE_11_oxygen_i18n___default.a.setLocale(locale.replace('_','-'),locale.replace('_','-'));__WEBPACK_IMPORTED_MODULE_13_moment___default.a.locale(locale.replace(/(_SE|_EN)/g,''));this.forceUpdate();}if(!!nextProps.reportBug&&!this.props.reportBug){this.showReportBugDialog();}else if(!nextProps.reportBug&&!!this.props.reportBug){this.hideReportBugDialog();}if(nextProps.loggedIn&&!this.props.loggedIn){this.checkUnreadNotifications(true);var query=location.query;if(query&&query.nextPath&&query.nextPath.nextPath!=='/logout'){__WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* history */].push(query.nextPath);}}else if(this.props.loggedIn&&!nextProps.loggedIn&&pathname!=='/login'){__WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* history */].push('/login');}else if(this.props.loggedIn&&!nextProps.loggedIn&&pathname!=='/login'){__WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* history */].replace('/login');}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleResize);document.removeEventListener('contextmenu',this.handleContextMenu);clearTimeout(this._timer);}},{key:'checkUnreadNotifications',value:function checkUnreadNotifications(){var _this2=this;var force=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(this.props.loggedIn||force){__WEBPACK_IMPORTED_MODULE_8_actions__["r" /* NotificationActions */].countUnreadNotifications();this._timer=setTimeout(function(){_this2.checkUnreadNotifications();},5*60*10000);}}},{key:'handleResize',value:function handleResize(){var media=__WEBPACK_IMPORTED_MODULE_2_services_MediaQuery__["a" /* default */].detect();if(this.state.media!==media){this.setState({media:media});}}},{key:'showReportBugDialog',value:function showReportBugDialog(){this.refs.bugReportDialog.show();}},{key:'hideReportBugDialog',value:function hideReportBugDialog(){this.refs.bugReportDialog.dismiss();}},{key:'handleContextMenu',value:function handleContextMenu(event){event.preventDefault();event.stopPropagation();}},{key:'dismissBugReport',value:function dismissBugReport(){__WEBPACK_IMPORTED_MODULE_8_actions__["a" /* AppActions */].hideReportBugDialog();}},{key:'submitBug',value:function submitBug(){var technicalData={media:this.context.media,location:{}};var navigator=window.navigator||{};navigatorData.forEach(function(key){technicalData[key]=navigator[key];});windowData.forEach(function(key){technicalData[key]=window[key];});locationData.forEach(function(key){technicalData.location[key]=window.location[key];});var userComment=this.refs.bugData.getValue();__WEBPACK_IMPORTED_MODULE_8_actions__["a" /* AppActions */].reportBug(userComment,technicalData);this.dismissBugReport();}},{key:'checkBugDataValidation',value:function checkBugDataValidation(){var bugData=this.refs.bugData.getValue();var isValidBugData=bugData.trim().split(/\s+/).length;this.setState({shouldSendBeDisabled:!(isValidBugData>=3)});}},{key:'render',value:function render(){var _this3=this;var leftNav=void 0;var _props2=this.props,loggedIn=_props2.loggedIn,message=_props2.message;if(loggedIn){// leftNav = <LeftNav nested={true} ref="leftNav" header={header} docked={false} menuItems={this.appMenuItems} onChange={this.onMenuChange} zDepth={0} onForceClose={this.forceCloseMenu}/>;
leftNav=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_MainMenu__["a" /* default */],{closeOnRequestClose:true,zIndex:101,initialOpen:false,onChange:this.onMenuChange});}var reportBugActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["FlatButton"],{style:{marginRight:10},onTouchTap:this.dismissBugReport,secondary:true,label:this.context.getIntlMessage('Cancel')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["FlatButton"],{secondary:true,label:this.context.getIntlMessage('bug.reportTitle'),ref:'submit',disabled:this.state.shouldSendBeDisabled,onTouchTap:this.submitBug.bind(this)})];var english=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.report},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Frequently Asked Questions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'I have forgot my password.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Click the button that says \u201CFORGOT YOUR PASSWORD\u201D under the login-button to get an email sent to your email address with a link. Click the link to select a new password. If you can\u2019t find the email, please make sure to look in the junk mail.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'I have changed the password but it still doesn\u2019t work.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Make sure that you type your email address and password manually when you\u2019re trying to log in since webb browsers tend to save old passwords.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'I have a problem seeing things, the course is lagging, the pages are empty, I can\u2019t see the videos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'First, make sure that you are using Google Chrome when using Coursio, it is most compatible with our tool. Other platforms may cause technical issues when using Coursios tool e.g Explorer. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Do you have questions about the course content?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please contact the course creator as Coursio can only help with technical issues.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'My course has disappeared?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If your course have disappeared it is most likely because the access time for the course has expired. Before you buy the course there are information about how long the access time for the course is. You can also see the access time on your Dashboard on each individual course on the right corner. If you want to continue to read the course after the access time has expired, you will have to buy the course again.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'How do I create an account?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When you purchase a course you will automatically be redirected to the page where you create an account. To get to this page you have to click the purchase-button for selected course.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'When do I get access to the rest of the material in my course?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sometimes the course creator chooses to release material in a course at different times. If you have questions regarding this, please contact the course creator since Coursio only can help with technical difficulties.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Is there a Coursio app that I can download?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio does not have an app for the time being.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'I am finished with my course but doesn\u2019t get a diploma.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Some courses contain a diploma that the course reader can download when the course is finished. If you haven\u2019t received your diploma it usually depends on that you haven\u2019t completed all the momentums that is required. You can see if all of the momentums has been completed by looking at the index of the course. Next to every chapter title there is a circle, when you have completed the chapter the circle gets completely filled and checked off. If the course contains a Quiz, make sure that all of the questions are answered.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Can I undo my purchase?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You have the right to return your purchase within 14 days. If it\u2019s within 14 days since purchase and you want to make a return, email us and we will cancel your purchase. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'My invitation link has expired.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The invitation links are valid for 30 days after the email has been sent to you. If you have been invited to a course and your invitation link has expired, please contact the course creator and ask them to send you a new invitation.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Can I download the course material?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can only download course material that the course creator has made downloadable in the form of downloadable files e.g pdf:s, excel files etc. Otherwise you can only get the information by reading the course in the platform.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'I have received a gift code and want to use it, how?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you have received a gift code to a course you click on this link \u2192 https://app.coursio.com/gift and fill out the code in the box. Then you will have the opportunity to create an account at Coursio or log in to your already existing account to take part of the course.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'I want to change the email address connected to my Coursio account, how?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To change your email address you click on the Settings button in the main menu and scroll down to User Settings. When you have chosen your new email address you scroll down to the bottom at the page to save. You can also change your password under Change Password. Don\u2019t forget to save!'));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{zIndex:1,width:'100%',height:'100%',position:'absolute',left:0,top:0}},this.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_DialogPortal__["a" /* default */],null,leftNav),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Dialog"],{title:this.context.getIntlMessage('bug.report'),ref:'bugReportDialog',onDismiss:this.dismissBugReport.bind(this),actions:reportBugActions,autoDetectWindowHeight:true,autoScrollBodyContent:true},english,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{hintText:this.context.getIntlMessage('bug.describe'),onChange:function onChange(){return _this3.checkBugDataValidation();},fullWidth:true,multiLine:true,rowsMax:8,ref:'bugData',style:{marginTop:'2em'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_MessagePortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_AppSnackBar__["a" /* default */],message)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_helmet___default.a,{title:'Coursio 3'}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);App.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};App.childContextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 2046 */
/***/ (function(module, exports) {

/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license */window.matchMedia||(window.matchMedia=function(){'use strict';// For browsers that support matchMedium api such as IE 9 and webkit
var styleMedia=window.styleMedia||window.media;// For those that don't support matchMedium
if(!styleMedia){var style=document.createElement('style'),script=document.getElementsByTagName('script')[0],info=null;style.type='text/css';style.id='matchmediajs-test';script.parentNode.insertBefore(style,script);// 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
info='getComputedStyle'in window&&window.getComputedStyle(style,null)||style.currentStyle;styleMedia={matchMedium:function matchMedium(media){var text='@media '+media+'{ #matchmediajs-test { width: 1px; } }';// 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
if(style.styleSheet){style.styleSheet.cssText=text;}else{style.textContent=text;}// Test if media query is true or false
return info.width==='1px';}};}return function(media){return{matches:styleMedia.matchMedium(media||'all'),media:media||'all'};};}());

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProfileHeader__ = __webpack_require__(2048);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProfileImageContainer=function(_utils$mixin){_inherits(ProfileImageContainer,_utils$mixin);function ProfileImageContainer(){_classCallCheck(this,ProfileImageContainer);return _possibleConstructorReturn(this,(ProfileImageContainer.__proto__||Object.getPrototypeOf(ProfileImageContainer)).apply(this,arguments));}_createClass(ProfileImageContainer,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!__WEBPACK_IMPORTED_MODULE_2_shallowequal___default()(this.props,nextProps)||!__WEBPACK_IMPORTED_MODULE_2_shallowequal___default()(this.state,nextState);}},{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores__["b" /* AuthStore */]);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProfileHeader__["a" /* default */],{author:this.state});}}]);return ProfileImageContainer;}(__WEBPACK_IMPORTED_MODULE_3_Util__["d" /* mixin */](__WEBPACK_IMPORTED_MODULE_3_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));ProfileImageContainer.displayName='ProfileHeaderContainer';/* harmony default export */ __webpack_exports__["a"] = (ProfileImageContainer);

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProfileImage__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_fW',small:'_fX',smaller:'_fY',profileImage:'_fZ'};var ProfileHeader=function(_Component){_inherits(ProfileHeader,_Component);function ProfileHeader(){_classCallCheck(this,ProfileHeader);return _possibleConstructorReturn(this,(ProfileHeader.__proto__||Object.getPrototypeOf(ProfileHeader)).apply(this,arguments));}_createClass(ProfileHeader,[{key:'render',value:function render(){var author=this.props.author;var displayName=author&&author.displayName||'';var small=displayName.length>13;var smaller=displayName.length>20;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.root,_defineProperty({},css.small,small),_defineProperty({},css.smaller,smaller))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ProfileImage__["a" /* default */],{author:author,className:css.profileImage}),displayName);}}]);return ProfileHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProfileHeader.displayName='ProfileHeader';ProfileHeader.propTypes={author:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};ProfileHeader.defaultProps={author:{}};/* harmony default export */ __webpack_exports__["a"] = (ProfileHeader);

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/profile_default.f031e4d5.png";

/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProfileLogout__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_Auth__ = __webpack_require__(83);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProfileLogoutContainer=function(_mixin){_inherits(ProfileLogoutContainer,_mixin);function ProfileLogoutContainer(){_classCallCheck(this,ProfileLogoutContainer);return _possibleConstructorReturn(this,(ProfileLogoutContainer.__proto__||Object.getPrototypeOf(ProfileLogoutContainer)).apply(this,arguments));}_createClass(ProfileLogoutContainer,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!__WEBPACK_IMPORTED_MODULE_2_shallowequal___default()(this.props,nextProps)||!__WEBPACK_IMPORTED_MODULE_2_shallowequal___default()(this.state,nextState);}},{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores__["b" /* AuthStore */]);}},{key:'logout',value:function logout(){__WEBPACK_IMPORTED_MODULE_5_actions_Auth__["a" /* default */].logout();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ProfileLogout__["a" /* default */],{logout:this.logout.bind(this)});}}]);return ProfileLogoutContainer;}(Object(__WEBPACK_IMPORTED_MODULE_3_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_3_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));ProfileLogoutContainer.displayName='ProfileFooterContainer';/* harmony default export */ __webpack_exports__["a"] = (ProfileLogoutContainer);

/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActionExitToApp=__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ActionExitToApp"];var Spacing=__WEBPACK_IMPORTED_MODULE_3_material_ui__["Styles"].Spacing;var css={footer:'_fV'};var ProfileLogout=function(_Component){_inherits(ProfileLogout,_Component);function ProfileLogout(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProfileLogout);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProfileLogout.__proto__||Object.getPrototypeOf(ProfileLogout)).call.apply(_ref,[this].concat(args))),_this),_this.state={mouseOver:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProfileLogout,[{key:'getStyle',value:function getStyle(){var style=this.props.style;var mouseOver=this.state.mouseOver;return Object.assign({},{position:'relative',cursor:'pointer',backgroundColor:mouseOver?'rgba(255, 255, 255, 0.2)':'transparent',paddingLeft:'135px',paddingRight:'25px',height:48,lineHeight:'48px',fontSize:'16px',color:'white',bottom:'0px',left:'-10px'},style);}},{key:'logOut',value:function logOut(){if(this.props.logout){this.props.logout();}}},{key:'handleMouseEnter',value:function handleMouseEnter(){this.setState({mouseOver:true});}},{key:'handleMouseLeave',value:function handleMouseLeave(){this.setState({mouseOver:false});}},{key:'render',value:function render(){var text=this.context.getIntlMessage('menu.Logout');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.footer,style:this.getStyle(),onMouseEnter:this.handleMouseEnter.bind(this),onMouseLeave:this.handleMouseLeave.bind(this),onTouchTap:this.logOut.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{style:{marginLeft:'-90px',float:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionExitToApp,{color:'white'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:'left',marginLeft:'-45px'}},' ',text,' '));}}]);return ProfileLogout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProfileLogout.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};ProfileLogout.propTypes={logOut:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (ProfileLogout);

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = __webpack_require__(0);
var StylePropable = __webpack_require__(10);
var ListDivider = __webpack_require__(536);
var DefaultRawTheme = __webpack_require__(11);
var ThemeManager = __webpack_require__(12);

var MenuDivider = React.createClass({
  displayName: 'MenuDivider',

  mixins: [StylePropable],

  contextTypes: {
    muiTheme: React.PropTypes.object
  },

  //for passing default theme context to children
  childContextTypes: {
    muiTheme: React.PropTypes.object
  },

  getChildContext: function getChildContext() {
    return {
      muiTheme: this.state.muiTheme
    };
  },

  getInitialState: function getInitialState() {
    return {
      muiTheme: this.context.muiTheme ? this.context.muiTheme : ThemeManager.getMuiTheme(DefaultRawTheme)
    };
  },

  //to update theme inside state whenever a new theme is passed down
  //from the parent / owner using context
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var newMuiTheme = nextContext.muiTheme ? nextContext.muiTheme : this.state.muiTheme;
    this.setState({ muiTheme: newMuiTheme });
  },

  render: function render() {
    var _props = this.props;
    var style = _props.style;

    var other = _objectWithoutProperties(_props, ['style']);

    var mergedStyles = this.mergeStyles({
      marginTop: 7,
      marginBottom: 8
    }, style);

    return React.createElement(ListDivider, _extends({}, other, { style: mergedStyles }));
  }
});

module.exports = MenuDivider;

/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_MenuItem__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={icon:{display:'inline-block',verticalAlign:'middle',margin:'0 '+Spacing.desktopGutterMini+'px'}};var CollapsibleMenu=function(_Component){_inherits(CollapsibleMenu,_Component);function CollapsibleMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CollapsibleMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CollapsibleMenu.__proto__||Object.getPrototypeOf(CollapsibleMenu)).call.apply(_ref,[this].concat(args))),_this),_this.state={expanded:_this.props.initialExpanded},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CollapsibleMenu,[{key:'toggle',value:function toggle(){this.setState({expanded:!this.state.expanded});}},{key:'getMenuStyle',value:function getMenuStyle(){return Object.assign({},this.props.menuStyle);}},{key:'getStyle',value:function getStyle(){return Object.assign({},this.props.menuStyle);}},{key:'getItemStyle',value:function getItemStyle(){return Object.assign({paddingLeft:Spacing.desktopGutterMini*2},this.props.menuItemStyle);}},{key:'_onItemTap',value:function _onItemTap(menuItem,e){if(this.props.onItemTap){this.props.onItemTap(menuItem,e);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,padding=_props.padding,style=_props.style,menuItems=_props.menuItems,menuStyle=_props.menuStyle,header=_props.header,other=_objectWithoutProperties(_props,['padding','style','menuItems','menuStyle','header']);var menuElement=void 0,rightIcon=void 0,menuElements=menuItems.map(function(menuItem,index){var leftIcon=void 0;if(menuItem.icon){leftIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(menuItem.icon,{style:styles.icon,color:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].fullWhite});}else{leftIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["FontIcon"],{color:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,className:menuItem.iconClassName});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_MenuItem__["a" /* default */],{count:menuItem.count,style:_this2.getItemStyle(),onTouchTap:_this2._onItemTap.bind(_this2,menuItem),primaryText:menuItem.text,index:index,key:index,leftIcon:leftIcon});});if(this.state.expanded){// rightIcon = <Icons.HardwareKeyboardArrowUp />
menuElement=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({style:this.getMenuStyle()},other),menuElements);}else{// rightIcon = <Icons.HardwareKeyboardArrowDown />
}var icon=void 0;if(this.props.icon){var Icon=this.props.icon;icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{style:styles.icon,color:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].fullWhite});}else{icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["FontIcon"],{color:this.props.iconColor,className:this.props.iconClassName});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_MenuItem__["a" /* default */],{style:this.props.menuItemStyle,leftIcon:icon,onTouchTap:this.toggle.bind(this),primaryText:header,rightIcon:rightIcon}),menuElement);}}]);return CollapsibleMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CollapsibleMenu.propTypes={padding:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,menuStyle:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,initialExpanded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onItemTap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};CollapsibleMenu.defaultProps={padding:Spacing.desktopGutterMini,style:{},menuStyle:{},initialExpanded:true};/* harmony default export */ __webpack_exports__["a"] = (CollapsibleMenu);

/***/ }),
/* 2054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_lib_utils_color_manipulator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_lib_utils_color_manipulator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_lib_utils_color_manipulator__);
var Colors=__WEBPACK_IMPORTED_MODULE_0_material_ui__["Styles"].Colors,Spacing=__WEBPACK_IMPORTED_MODULE_0_material_ui__["Styles"].Spacing;var primaryColor=__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].coursio;var accentColor=__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].deepPurple;var textColors=__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["b" /* Text */];var themeColors=__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["c" /* Theme */].Light;/* harmony default export */ __webpack_exports__["a"] = ({spacing:Spacing,contentFontFamily:'\'MaisonNeue-Book\', sans-serif',fontFamily:'\'MaisonNeue-Book\', sans-serif',toolbar:{height:60},palette:{primary1Color:primaryColor[500].material,primary2Color:primaryColor[600].material,primary3Color:__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].grey[300].material,accent1Color:accentColor[500].material,accent2Color:__WEBPACK_IMPORTED_MODULE_1_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material,accent3Color:accentColor[100].material,textColor:textColors.Dark.text,alternateTextColor:textColors.Light.text,canvasColor:themeColors.background,cardColor:themeColors.card,borderColor:textColors.Dark.divider,primary1TextColor:textColors[primaryColor[500].text].text,primary2TextColor:textColors[primaryColor[700].text].text,primary3TextColor:textColors[primaryColor[100].text].text,accent1TextColor:textColors[accentColor[500].text].text,accent2TextColor:textColors[accentColor[700].text].text,accent3TextColor:textColors[accentColor[100].text].text,disabledColor:__WEBPACK_IMPORTED_MODULE_2_material_ui_lib_utils_color_manipulator___default.a.fade(Colors.darkBlack,0.3),pickerHeaderColor:Colors.cyan500,clockCircleColor:__WEBPACK_IMPORTED_MODULE_2_material_ui_lib_utils_color_manipulator___default.a.fade(Colors.darkBlack,0.07)}});

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _fbjsLibExecutionEnvironment = __webpack_require__(45);

var _fbjsLibExecutionEnvironment2 = _interopRequireDefault(_fbjsLibExecutionEnvironment);

var _fbjsLibShallowEqual = __webpack_require__(219);

var _fbjsLibShallowEqual2 = _interopRequireDefault(_fbjsLibShallowEqual);

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = undefined;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = (function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        _Component.apply(this, arguments);
      }

      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may ony call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !_fbjsLibShallowEqual2['default'](nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return _react2['default'].createElement(WrappedComponent, this.props);
      };

      _createClass(SideEffect, null, [{
        key: 'displayName',

        // Try to use displayName of wrapped component
        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',

        // Expose canUseDOM so tests can monkeypatch it
        enumerable: true
      }, {
        key: 'canUseDOM',
        value: _fbjsLibExecutionEnvironment2['default'].canUseDOM,
        enumerable: true
      }]);

      return SideEffect;
    })(_react.Component);

    return SideEffect;
  };
};

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(2057);
var isArguments = __webpack_require__(2058);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 2057 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 2058 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 2059 */
/***/ (function(module, exports) {

exports.__esModule = true;
var TAG_NAMES = exports.TAG_NAMES = {
    HTML: "htmlAttributes",
    TITLE: "title",
    BASE: "base",
    META: "meta",
    LINK: "link",
    SCRIPT: "script",
    NOSCRIPT: "noscript",
    STYLE: "style"
};

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    NAME: "name",
    CHARSET: "charset",
    HTTPEQUIV: "http-equiv",
    REL: "rel",
    HREF: "href",
    PROPERTY: "property",
    SRC: "src",
    INNER_HTML: "innerHTML",
    CSS_TEXT: "cssText",
    ITEM_PROP: "itemprop"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    "charset": "charSet",
    "http-equiv": "httpEquiv",
    "itemprop": "itemProp",
    "class": "className"
};

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlainComponent = function (_React$Component) {
    _inherits(PlainComponent, _React$Component);

    function PlainComponent() {
        _classCallCheck(this, PlainComponent);

        return _possibleConstructorReturn(this, (PlainComponent.__proto__ || Object.getPrototypeOf(PlainComponent)).apply(this, arguments));
    }

    _createClass(PlainComponent, [{
        key: "render",
        value: function render() {
            return null;
        }
    }]);

    return PlainComponent;
}(_react2.default.Component);

exports.default = PlainComponent;
module.exports = exports["default"];

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores_Auth__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_App__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_AppSnackBar__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_MessagePortal__ = __webpack_require__(570);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// if (!__DEV__) {
// i18n.fallback = false;
// }
try{var messages=__webpack_require__(377);Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["addMessages"])(messages);}catch(e){// Nothing going on
}var CoursioApp=function(_Component){_inherits(CoursioApp,_Component);function CoursioApp(){_classCallCheck(this,CoursioApp);return _possibleConstructorReturn(this,(CoursioApp.__proto__||Object.getPrototypeOf(CoursioApp)).apply(this,arguments));}_createClass(CoursioApp,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.locale!==nextProps.locale){var locale=nextProps.locale;__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n___default.a.setLocale(locale.replace('_','-'),locale.replace('_','-'));this.forceUpdate();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.children);}}]);return CoursioApp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CoursioApp.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,locale:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};var CoursioAppContainer=function(_mixin){_inherits(CoursioAppContainer,_mixin);function CoursioAppContainer(){_classCallCheck(this,CoursioAppContainer);return _possibleConstructorReturn(this,(CoursioAppContainer.__proto__||Object.getPrototypeOf(CoursioAppContainer)).apply(this,arguments));}_createClass(CoursioAppContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores_Auth__["a" /* default */],function(state){return{loggedIn:state.loggedIn,name:state.displayName,email:state.email,createdAt:state.createdAt,user:state,role:state.role,locale:state.locale};});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_3_stores_App__["a" /* default */],function(state){return{message:state.message};});}},{key:'getChildContext',value:function getChildContext(){return{user:this.state.user};}},{key:'render',value:function render(){var children=this.props.children;var _state=this.state,locale=_state.locale,message=_state.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CoursioApp,{locale:locale},children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_MessagePortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_AppSnackBar__["a" /* default */],message)));}}]);return CoursioAppContainer;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));CoursioAppContainer.childContextTypes={user:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* unused harmony default export */ var _unused_webpack_default_export = (CoursioAppContainer);

/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Page_Controls__ = __webpack_require__(2063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (function(Component,options){options=options||{};return function(_React$Component){_inherits(ControlledComponent,_React$Component);function ControlledComponent(){_classCallCheck(this,ControlledComponent);var _this=_possibleConstructorReturn(this,(ControlledComponent.__proto__||Object.getPrototypeOf(ControlledComponent)).apply(this,arguments));_this.state={mode:_this.props.mode||'detail',shown:false};return _this;}_createClass(ControlledComponent,[{key:'show',value:function show(){if(!this.state.shown){this.setState({shown:true});}}},{key:'hide',value:function hide(){if(this.state.mode==='detail'&&this.state.shown){this.setState({shown:false});}}},{key:'_onEditMenu',value:function _onEditMenu(){if(this.refs.component.edit){this.refs.component.edit();}this.setState({mode:'edit'});}},{key:'_onDefaultMenu',value:function _onDefaultMenu(){this.setState({mode:'detail'});}},{key:'_onSettings',value:function _onSettings(){console.log('TODO : implement settings');}},{key:'_onCancel',value:function _onCancel(){if(this.refs.component.cancel){this.refs.component.cancel();}this.setState({mode:'detail'});}},{key:'_onDelete',value:function _onDelete(){if(this.refs.component.delete){this.refs.component.delete();}// ??
}},{key:'_onAttach',value:function _onAttach(){if(this.refs.component.attach){this.refs.component.attach();}}},{key:'_onSave',value:function _onSave(){if(this.refs.component.save){this.refs.component.save();}this.setState({mode:'detail'});}},{key:'_onUploadSuccess',value:function _onUploadSuccess(data){if(this.refs.component.attach){this.refs.component.attach(data);}}},{key:'_onProgress',value:function _onProgress(event){if(this.refs.component.progress){this.refs.component.progress(event);}}},{key:'_handler',value:function _handler(func,payload){if(this.refs.component[func]){this.refs.component[func](payload);}}},{key:'createControls',value:function createControls(menuItems){if(this.props.builder||true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Page_Controls__["a" /* default */],{encoded:options.encoded||false,multiple:options.multiple||false,defaultMenu:this.props.defaultMenu,ref:'controls',menuItems:menuItems,onSave:this._onSave.bind(this),onDelete:this._onDelete.bind(this),onSettings:this._onSettings.bind(this),onEditMenu:this._onEditMenu.bind(this),onDefaultMenu:this._onDefaultMenu.bind(this),onCancel:this._onCancel.bind(this),onAttach:this._onAttach.bind(this),onProgress:this._onProgress.bind(this),handler:this._handler.bind(this),onUploadSuccess:this._onUploadSuccess.bind(this)});}else{return null;}}},{key:'render',value:function render(){var standardMenuItems=options.menuItems||{default:[{menu:'edit',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ContentCreate"],{color:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].fullBlack})}],edit:[{onTouchTap:'save',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ActionDone"],{color:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].fullBlack})},{onTouchTap:'cancel',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ContentClear"],{color:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].fullBlack})},{onTouchTap:'delete',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ActionDelete"],{color:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].fullBlack})}]};var menuItems={default:standardMenuItems.default.slice(),edit:standardMenuItems.edit.slice()};if(options.attach){menuItems.edit.push({attach:true,accept:options.attach,onTouchTap:'attach'});}var controls=void 0;if(this.state.shown||this.props.defaultMenu){controls=this.createControls(menuItems);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({ref:'component'},this.props,{mode:this.state.mode,onMouseEnter:this.show.bind(this),onMouseLeave:this.hide.bind(this)}),this.props.children,controls);}}]);return ControlledComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);});

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_addons_css_transition_group__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_SteelCompass__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var styles={uploadInput:{position:'absolute',left:0,right:0,top:0,bottom:0,opacity:0,cursor:'pointer',width:48,height:48}};var Controls=function(_Component){_inherits(Controls,_Component);function Controls(){_classCallCheck(this,Controls);var _this=_possibleConstructorReturn(this,(Controls.__proto__||Object.getPrototypeOf(Controls)).apply(this,arguments));_this.state={activeMenu:_this.props.defaultMenu||'default',locked:false,shown:true,progressing:false,progress:0};return _this;}_createClass(Controls,[{key:'show',value:function show(){// this.setState({shown: true});
}},{key:'hide',value:function hide(){// this.setState({shown: false});
}},{key:'onEditMenu',value:function onEditMenu(e){if(this.props.onEditMenu){this.props.onEditMenu();}this.setState({locked:true});}},{key:'onSettingsMenu',value:function onSettingsMenu(e){if(this.props.onSettingsMenu){this.props.onSettingsMenu();}this.setState({locked:true});}},{key:'onDefaultMenu',value:function onDefaultMenu(e){if(this.props.onDefaultMenu){this.props.onDefaultMenu();}this.setState({locked:false});}},{key:'setEdit',value:function setEdit(){this.setState({locked:true,activeMenu:'edit'});}},{key:'onCancel',value:function onCancel(e){if(this.props.onCancel){this.props.onCancel();}this.setState({locked:false,shown:false,activeMenu:'default'});}},{key:'onSave',value:function onSave(e){if(this.props.onSave){this.props.onSave();this.setState({locked:false,shown:false,activeMenu:'default'});}}},{key:'onDelete',value:function onDelete(e){if(this.props.onDelete){this.props.onDelete();}}},{key:'onSettings',value:function onSettings(){if(this.props.onSettings){this.props.onSettings();}this.setState({locked:false,shown:false,activeMenu:'default'});}},{key:'handleFile',value:function handleFile(e){var _this2=this;this.setState({progress:0,progressing:true});__WEBPACK_IMPORTED_MODULE_6_services_SteelCompass__["a" /* default */].upload(e.target.files,{encoded:this.props.encoded,progress:function progress(event){if(_this2.props.onProgress&&event){_this2.props.onProgress(event);}},success:function success(response){_this2.setState({progressing:false,amount:0});if(_this2.props.onUploadSuccess){_this2.props.onUploadSuccess(response.data);}}});}},{key:'_onTouchTap',value:function _onTouchTap(payload,e){if(payload.menu){this.setState({activeMenu:payload.menu});var func='on'+payload.menu.charAt(0).toUpperCase()+payload.menu.slice(1)+'Menu';if(this[func]){this[func]();}}else if(typeof payload.onTouchTap==='string'){var _func='on'+payload.onTouchTap.charAt(0).toUpperCase()+payload.onTouchTap.slice(1);if(this[_func]){this[_func]();}else if(this.props.handler){this.props.handler(_func,payload);}}else if(typeof payload.onTouchTap==='function'){payload.onTouchTap();}if(e&&e.payload){e.stopPropagation();}}},{key:'render',value:function render(){var _this3=this;var iconButtonStyle={backgroundColor:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].fullWhite};var iconStyle={color:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].fullBlack};var menuItems=[];this.props.menuItems[this.state.activeMenu].forEach(function(menuItem,index){if(menuItem.disabled){return null;}if(menuItem.attach){var props={type:'file',accept:menuItem.accept};if(_this3.props.multiple){props.multiple='multiple';}menuItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative',cursor:'pointer'},key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{style:iconButtonStyle,iconStyle:iconStyle,onTouchTap:_this3._onTouchTap(_this3,menuItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["FileCloudUpload"],{color:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].fullBlack})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({onChange:_this3.handleFile.bind(_this3),style:styles.uploadInput},props))));}else{menuItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{style:iconButtonStyle,iconStyle:iconStyle,key:index,onTouchTap:_this3._onTouchTap.bind(_this3,menuItem)},menuItem.icon));}});var controls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'controls-vertical',style:{position:'absolute',transition:'all 0.1s ease'},key:this.state.activeMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Paper"],{style:{overflow:'hidden',margin:Spacing.desktopGutterMini}},menuItems));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_addons_css_transition_group___default.a,{transitionName:'controls-vertical',component:'div',style:{position:'absolute',top:0,right:0,bottom:0},transitionEnterTimeout:100,transitionLeaveTimeout:100},controls);}}]);return Controls;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Controls.propTypes={encoded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,menuItems:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};Controls.defaultProps={encoded:false,menuItems:{}};Controls.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (Controls);

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * @providesModule ReactCSSTransitionGroup
 */



var React = __webpack_require__(210);

var assign = __webpack_require__(29);

var ReactTransitionGroup = __webpack_require__(519);
var ReactCSSTransitionGroupChild = __webpack_require__(2065);

function createTransitionTimeoutPropValidator(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (!props[timeoutPropName]) {
        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
        }
    }
  };
}

var ReactCSSTransitionGroup = React.createClass({
  displayName: 'ReactCSSTransitionGroup',

  propTypes: {
    transitionName: ReactCSSTransitionGroupChild.propTypes.name,

    transitionAppear: React.PropTypes.bool,
    transitionEnter: React.PropTypes.bool,
    transitionLeave: React.PropTypes.bool,
    transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
    transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
    transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
  },

  getDefaultProps: function () {
    return {
      transitionAppear: false,
      transitionEnter: true,
      transitionLeave: true
    };
  },

  _wrapChild: function (child) {
    // We need to provide this childFactory so that
    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
    // leave while it is leaving.
    return React.createElement(ReactCSSTransitionGroupChild, {
      name: this.props.transitionName,
      appear: this.props.transitionAppear,
      enter: this.props.transitionEnter,
      leave: this.props.transitionLeave,
      appearTimeout: this.props.transitionAppearTimeout,
      enterTimeout: this.props.transitionEnterTimeout,
      leaveTimeout: this.props.transitionLeaveTimeout
    }, child);
  },

  render: function () {
    return React.createElement(ReactTransitionGroup, assign({}, this.props, { childFactory: this._wrapChild }));
  }
});

module.exports = ReactCSSTransitionGroup;

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * @providesModule ReactCSSTransitionGroupChild
 */



var React = __webpack_require__(210);
var ReactDOM = __webpack_require__(279);

var CSSCore = __webpack_require__(2066);
var ReactTransitionEvents = __webpack_require__(2067);

var onlyChild = __webpack_require__(451);

// We don't remove the element from the DOM until we receive an animationend or
// transitionend event. If the user screws up and forgets to add an animation
// their node will be stuck in the DOM forever, so we detect if an animation
// does not start and if it doesn't, we just call the end listener immediately.
var TICK = 17;

var ReactCSSTransitionGroupChild = React.createClass({
  displayName: 'ReactCSSTransitionGroupChild',

  propTypes: {
    name: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
      enter: React.PropTypes.string,
      leave: React.PropTypes.string,
      active: React.PropTypes.string
    }), React.PropTypes.shape({
      enter: React.PropTypes.string,
      enterActive: React.PropTypes.string,
      leave: React.PropTypes.string,
      leaveActive: React.PropTypes.string,
      appear: React.PropTypes.string,
      appearActive: React.PropTypes.string
    })]).isRequired,

    // Once we require timeouts to be specified, we can remove the
    // boolean flags (appear etc.) and just accept a number
    // or a bool for the timeout flags (appearTimeout etc.)
    appear: React.PropTypes.bool,
    enter: React.PropTypes.bool,
    leave: React.PropTypes.bool,
    appearTimeout: React.PropTypes.number,
    enterTimeout: React.PropTypes.number,
    leaveTimeout: React.PropTypes.number
  },

  transition: function (animationType, finishCallback, userSpecifiedDelay) {
    var node = ReactDOM.findDOMNode(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timeout = null;

    var endListener = function (e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timeout);

      CSSCore.removeClass(node, className);
      CSSCore.removeClass(node, activeClassName);

      ReactTransitionEvents.removeEndEventListener(node, endListener);

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    CSSCore.addClass(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClass(activeClassName);

    // If the user specified a timeout delay.
    if (userSpecifiedDelay) {
      // Clean-up the animation after the specified delay
      timeout = setTimeout(endListener, userSpecifiedDelay);
    } else {
      // DEPRECATED: this listener will be removed in a future version of react
      ReactTransitionEvents.addEndEventListener(node, endListener);
    }
  },

  queueClass: function (className) {
    this.classNameQueue.push(className);

    if (!this.timeout) {
      this.timeout = setTimeout(this.flushClassNameQueue, TICK);
    }
  },

  flushClassNameQueue: function () {
    if (this.isMounted()) {
      this.classNameQueue.forEach(CSSCore.addClass.bind(CSSCore, ReactDOM.findDOMNode(this)));
    }
    this.classNameQueue.length = 0;
    this.timeout = null;
  },

  componentWillMount: function () {
    this.classNameQueue = [];
  },

  componentWillUnmount: function () {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },

  componentWillAppear: function (done) {
    if (this.props.appear) {
      this.transition('appear', done, this.props.appearTimeout);
    } else {
      done();
    }
  },

  componentWillEnter: function (done) {
    if (this.props.enter) {
      this.transition('enter', done, this.props.enterTimeout);
    } else {
      done();
    }
  },

  componentWillLeave: function (done) {
    if (this.props.leave) {
      this.transition('leave', done, this.props.leaveTimeout);
    } else {
      done();
    }
  },

  render: function () {
    return onlyChild(this.props.children);
  }
});

module.exports = ReactCSSTransitionGroupChild;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(20);

/**
 * The CSSCore module specifies the API (and implements most of the methods)
 * that should be used when dealing with the display of elements (via their
 * CSS classes and visibility on screen. It is an API focused on mutating the
 * display and not reading it as no logical state should be encoded in the
 * display of elements.
 */

/* Slow implementation for browsers that don't natively support .matches() */
function matchesSelector_SLOW(element, selector) {
  var root = element;
  while (root.parentNode) {
    root = root.parentNode;
  }

  var all = root.querySelectorAll(selector);
  return Array.prototype.indexOf.call(all, element) !== -1;
}

var CSSCore = {

  /**
   * Adds the class passed in to the element if it doesn't already have it.
   *
   * @param {DOMElement} element the element to set the class on
   * @param {string} className the CSS className
   * @return {DOMElement} the element passed in
   */
  addClass: function addClass(element, className) {
    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;

    if (className) {
      if (element.classList) {
        element.classList.add(className);
      } else if (!CSSCore.hasClass(element, className)) {
        element.className = element.className + ' ' + className;
      }
    }
    return element;
  },

  /**
   * Removes the class passed in from the element
   *
   * @param {DOMElement} element the element to set the class on
   * @param {string} className the CSS className
   * @return {DOMElement} the element passed in
   */
  removeClass: function removeClass(element, className) {
    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;

    if (className) {
      if (element.classList) {
        element.classList.remove(className);
      } else if (CSSCore.hasClass(element, className)) {
        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
        .replace(/^\s*|\s*$/g, ''); // trim the ends
      }
    }
    return element;
  },

  /**
   * Helper to add or remove a class from an element based on a condition.
   *
   * @param {DOMElement} element the element to set the class on
   * @param {string} className the CSS className
   * @param {*} bool condition to whether to add or remove the class
   * @return {DOMElement} the element passed in
   */
  conditionClass: function conditionClass(element, className, bool) {
    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
  },

  /**
   * Tests whether the element has the class specified.
   *
   * @param {DOMNode|DOMWindow} element the element to check the class on
   * @param {string} className the CSS className
   * @return {boolean} true if the element has the class, false if not
   */
  hasClass: function hasClass(element, className) {
    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
    if (element.classList) {
      return !!className && element.classList.contains(className);
    }
    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
  },

  /**
   * Tests whether the element matches the selector specified
   *
   * @param {DOMNode|DOMWindow} element the element that we are querying
   * @param {string} selector the CSS selector
   * @return {boolean} true if the element matches the selector, false if not
   */
  matchesSelector: function matchesSelector(element, selector) {
    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
      return matchesSelector_SLOW(element, s);
    };
    return matchesImpl.call(element, selector);
  }

};

module.exports = CSSCore;

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactTransitionEvents
 */



var ExecutionEnvironment = __webpack_require__(45);

/**
 * EVENT_NAME_MAP is used to determine which event fired when a
 * transition/animation ends, based on the style property used to
 * define that event.
 */
var EVENT_NAME_MAP = {
  transitionend: {
    'transition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'mozTransitionEnd',
    'OTransition': 'oTransitionEnd',
    'msTransition': 'MSTransitionEnd'
  },

  animationend: {
    'animation': 'animationend',
    'WebkitAnimation': 'webkitAnimationEnd',
    'MozAnimation': 'mozAnimationEnd',
    'OAnimation': 'oAnimationEnd',
    'msAnimation': 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are useable, and if not remove them
  // from the map
  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    var baseEvents = EVENT_NAME_MAP[baseEventName];
    for (var styleName in baseEvents) {
      if (styleName in style) {
        endEvents.push(baseEvents[styleName]);
        break;
      }
    }
  }
}

if (ExecutionEnvironment.canUseDOM) {
  detectEvents();
}

// We use the raw {add|remove}EventListener() call because EventListener
// does not know how to remove event listeners and we really should
// clean up. Also, these events are not triggered in older browsers
// so we should be A-OK here.

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var ReactTransitionEvents = {
  addEndEventListener: function (node, eventListener) {
    if (endEvents.length === 0) {
      // If CSS transitions are not supported, trigger an "end animation"
      // event immediately.
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },

  removeEndEventListener: function (node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

module.exports = ReactTransitionEvents;

/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Course_TableOfContents_TextField__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Icons__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_CircularProgress__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_Cover__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Widgets__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_Message__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_10_material_ui__["Styles"].Spacing;var styles={input:{fontSize:'20px'},progress:{position:'absolute',left:0,right:0,top:0,bottom:0,textAlign:'center'}};var css={root:'_fg',clickable:'_fh',detail:'_fi',progress:'_fj',expires:'_fk',byGroup:'_fl',itemWrapper:'_fm',item:'_fn',header:'_fo'};var CourseDetails=function(_Component){_inherits(CourseDetails,_Component);function CourseDetails(){_classCallCheck(this,CourseDetails);var _this=_possibleConstructorReturn(this,(CourseDetails.__proto__||Object.getPrototypeOf(CourseDetails)).apply(this,arguments));_this.onTouchTap=function(){if(_this.props.onNavigate){_this.props.onNavigate();}};_this.state={progress:_this.props.course.progress,uploadProgress:0,activeCourse:null,coverImage:null};return _this;}_createClass(CourseDetails,[{key:'save',value:function save(){var course=this.props.course;if(this.refs.name.getValue().trim().length!=0){if(this.refs.name.getValue().length>50){return __WEBPACK_IMPORTED_MODULE_13_services_Message__["a" /* default */].info(this.context.getIntlMessage('course.nameTooLong'));}}else{return __WEBPACK_IMPORTED_MODULE_13_services_Message__["a" /* default */].info(this.context.getIntlMessage('course.nameNotEmpty'));}if(this.state.coverImage){__WEBPACK_IMPORTED_MODULE_0_actions__["g" /* DashboardActions */].saveCourse({id:course.id,name:this.refs.name.getValue(),coverImage:{id:this.state.coverImage.id}});}else{__WEBPACK_IMPORTED_MODULE_0_actions__["g" /* DashboardActions */].saveCourse({id:course.id,name:this.refs.name.getValue()});}}},{key:'onDuplicate',value:function onDuplicate(){var course=this.props.course;__WEBPACK_IMPORTED_MODULE_0_actions__["g" /* DashboardActions */].duplicateCourse(course);}},{key:'delete',value:function _delete(){this.props.onDeleteComponent(this.props.course);}},{key:'handleFile',value:function handleFile(e){var _this2=this;this.setState({uploadProgress:0,progressing:true});SteelCompass.upload(e.target.files,{progress:function progress(event){_this2.setState({uploadProgress:event.percentage});},success:function success(response){_this2.setState({progressing:false,uploadProgress:0});var file=response.data&&response.data[0]&&response.data[0].file;_this2.setState({coverImage:file});}});}},{key:'renderEditMode',value:function renderEditMode(){var course=this.props.course,progress=this.state.progress,coverImage=this.state.coverImage||course.coverImage,uploadProgress=void 0;if(this.state.uploadProgress>0&&this.state.uploadProgress<100){uploadProgress=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:'course-progress'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_CircularProgress__["a" /* default */],{size:2,progress:this.state.uploadProgress*100,progressWidth:2,trackWidth:2,cornersWidth:1}));}return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_Cover__["a" /* default */],{image:coverImage.id&&coverImage.url,defaultIcon:'FileCloudUpload'},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input',{style:{position:'absolute',left:0,top:0,width:'100%',height:'100%',opacity:0},type:'file',onChange:this.handleFile.bind(this),multiple:false,accept:'image/*'})),uploadProgress,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:css.detail},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Course_TableOfContents_TextField__["a" /* default */],{inputStyle:styles.input,onEnterKeyDown:this.save.bind(this),fullWidth:true,hintText:this.context.getIntlMessage('course.new'),type:'text',ref:'name',defaultValue:course.name}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:css.progress},course.ownerName)));}},{key:'getProgressStyle',value:function getProgressStyle(progressSize){var coverHeight=Spacing.desktopKeylineIncrement*4;return Object.assign({},styles.progress,{padding:(coverHeight-progressSize-2*Spacing.desktopGutterMore)/2});}},{key:'renderDetailMode',value:function renderDetailMode(){var course=this.props.course,progress=this.state.progress,coverImage=course.coverImage,progressSize=2;var editor=this.props.editor;var themeColor=__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].coursio[500].material;var progressElement=void 0;if(!editor){if(progress===1){progressElement=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Icons__["ChapterDone"],{color:themeColor});}else{progressElement=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui__["LinearProgress"],{mode:'determinate',value:progress*100});}}var expires=void 0;var expireColor=__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material;var expiryDate=new Date(course.expires);if(Object.prototype.toString.call(expiryDate)==='[object Date]'&&!isNaN(expiryDate.getTime())){var now=Date.now();if(expiryDate-now<24*60*60*30*1000){expireColor=__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].orange[500].material;}else if(expiryDate-now<0){expireColor=__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].red[500].material;}expires=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedDate"],{value:expiryDate});}else{expires=course.expires;}var expireIcon=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__["ActionSchedule"],{style:{verticalAlign:'middle',width:18,height:18},color:expireColor});return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:css.clickable,onTouchTap:this.onTouchTap},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_Cover__["a" /* default */],{backgroundColor:!editor&&this.context.muiTheme.rawTheme.palette.primary1Color||'rgba(0, 0, 0, 0.5)',image:coverImage.id&&coverImage.url,noImage:!editor}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:css.detail},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:css.header},course.name),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["b" /* GridContainer */],{fluid:true},!editor&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:12},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:css.progress},progressElement,course.ownerName)),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:12},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:css.expires,style:{color:expireColor}},course.ucpType===8&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('p',{className:css.byGroup},'managed by group'),expireIcon,expires)))));}},{key:'render',value:function render(){var _props=this.props,course=_props.course,className=_props.className,mode=_props.mode,other=_objectWithoutProperties(_props,['course','className','mode']),content=void 0;var editor=this.props.editor;if(mode==='edit'&&editor){content=this.renderEditMode();}else{content=this.renderDetailMode();}return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('div',{className:css.itemWrapper},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui__["Paper"],Object.assign({},other,{className:css.item}),content,this.props.children));}}]);return CourseDetails;}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);CourseDetails.propTypes={builder:__WEBPACK_IMPORTED_MODULE_11_react__["PropTypes"].bool};CourseDetails.defaultProps={builder:true};CourseDetails.contextTypes={router:__WEBPACK_IMPORTED_MODULE_11_react__["PropTypes"].object,muiTheme:__WEBPACK_IMPORTED_MODULE_11_react__["PropTypes"].object,media:__WEBPACK_IMPORTED_MODULE_11_react__["PropTypes"].string,getIntlMessage:__WEBPACK_IMPORTED_MODULE_11_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (CourseDetails);

/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GooglePlus=function(_Component){_inherits(GooglePlus,_Component);function GooglePlus(){_classCallCheck(this,GooglePlus);return _possibleConstructorReturn(this,(GooglePlus.__proto__||Object.getPrototypeOf(GooglePlus)).apply(this,arguments));}_createClass(GooglePlus,[{key:'render',value:function render(){var _props=this.props,fill=_props.fill,other=_objectWithoutProperties(_props,['fill']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',width:'134.658px',height:'131.646px',viewBox:'0 0 134.658 131.646',enableBackground:'new 0 0 134.658 131.646'},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:fill,d:'M70.479,71.845l-3.983-3.093c-1.213-1.006-2.872-2.334-2.872-4.765c0-2.441,1.659-3.993,3.099-5.43 c4.64-3.652,9.276-7.539,9.276-15.73c0-8.423-5.3-12.854-7.84-14.956h6.849l7.189-4.517H60.418 c-5.976,0-14.588,1.414-20.893,6.619c-4.752,4.1-7.07,9.753-7.07,14.842c0,8.639,6.633,17.396,18.346,17.396 c1.106,0,2.316-0.109,3.534-0.222c-0.547,1.331-1.1,2.439-1.1,4.32c0,3.431,1.763,5.535,3.317,7.528 c-4.977,0.342-14.268,0.893-21.117,5.103c-6.523,3.879-8.508,9.525-8.508,13.51c0,8.202,7.731,15.842,23.762,15.842 c19.01,0,29.074-10.519,29.074-20.932C79.764,79.709,75.344,75.943,70.479,71.845z M56,59.107 c-9.51,0-13.818-12.294-13.818-19.712c0-2.888,0.547-5.87,2.428-8.199c1.773-2.218,4.861-3.657,7.744-3.657 c9.168,0,13.923,12.404,13.923,20.382c0,1.996-0.22,5.533-2.762,8.09C61.737,57.785,58.762,59.107,56,59.107z M56.109,103.65 c-11.826,0-19.452-5.657-19.452-13.523c0-7.864,7.071-10.524,9.504-11.405c4.64-1.561,10.611-1.779,11.607-1.779 c1.105,0,1.658,0,2.538,0.111c8.407,5.983,12.056,8.965,12.056,14.629C72.362,98.542,66.723,103.65,56.109,103.65z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{fill:fill,points:'98.393,58.938 98.393,47.863 92.923,47.863 92.923,58.938 81.866,58.938 81.866,64.469 92.923,64.469 92.923,75.612 98.393,75.612 98.393,64.469 109.506,64.469 109.506,58.938     '})));}}]);return GooglePlus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);GooglePlus.propTypes={fill:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};GooglePlus.defaultProps={fill:'#FFFFFF'};/* harmony default export */ __webpack_exports__["a"] = (GooglePlus);

/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FacebookLogo=function(_Component){_inherits(FacebookLogo,_Component);function FacebookLogo(){_classCallCheck(this,FacebookLogo);return _possibleConstructorReturn(this,(FacebookLogo.__proto__||Object.getPrototypeOf(FacebookLogo)).apply(this,arguments));}_createClass(FacebookLogo,[{key:'render',value:function render(){var _props=this.props,background=_props.background,color=_props.color,other=_objectWithoutProperties(_props,['background','color']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({version:'1.1',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',width:'266.893px',height:'266.895px',viewBox:'0 0 266.893 266.895',enableBackground:'new 0 0 266.893 266.895'},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:background,d:'M248.082,262.307c7.854,0,14.223-6.369,14.223-14.225V18.812 c0-7.857-6.368-14.224-14.223-14.224H18.812c-7.857,0-14.224,6.367-14.224,14.224v229.27c0,7.855,6.366,14.225,14.224,14.225 H248.082z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{id:'f',fill:color,d:'M182.409,262.307v-99.803h33.499l5.016-38.895h-38.515V98.777c0-11.261,3.127-18.935,19.275-18.935 l20.596-0.009V45.045c-3.562-0.474-15.788-1.533-30.012-1.533c-29.695,0-50.025,18.126-50.025,51.413v28.684h-33.585v38.895h33.585 v99.803H182.409z'}));}}]);return FacebookLogo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FacebookLogo.displayName='FacebookLogo';FacebookLogo.propTypes={background:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};FacebookLogo.defaultProps={color:'#FFFFFF',background:'#3B5998'};/* harmony default export */ __webpack_exports__["a"] = (FacebookLogo);

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {"object"==typeof navigator&&function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("Plyr",t):(e=e||self).Plyr=t()}(this,function(){"use strict";function e(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function t(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}function n(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}function i(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=[],i=!0,a=!1,s=void 0;try{for(var r,o=e[Symbol.iterator]();!(i=(r=o.next()).done)&&(n.push(r.value),!t||n.length!==t);i=!0);}catch(e){a=!0,s=e}finally{try{i||null==o.return||o.return()}finally{if(a)throw s}}return n}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function s(e){return function(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var r={addCSS:!0,thumbWidth:15,watch:!0};var o=function(e){return null!=e?e.constructor:null},l=function(e,t){return Boolean(e&&t&&e instanceof t)},c=function(e){return null==e},u=function(e){return o(e)===Object},d=function(e){return o(e)===String},h=function(e){return Array.isArray(e)},m=function(e){return l(e,NodeList)},p={nullOrUndefined:c,object:u,number:function(e){return o(e)===Number&&!Number.isNaN(e)},string:d,boolean:function(e){return o(e)===Boolean},function:function(e){return o(e)===Function},array:h,nodeList:m,element:function(e){return l(e,Element)},event:function(e){return l(e,Event)},empty:function(e){return c(e)||(d(e)||h(e)||m(e))&&!e.length||u(e)&&!Object.keys(e).length}};function f(e,t){if(t<1){var n=(i="".concat(t).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/))?Math.max(0,(i[1]?i[1].length:0)-(i[2]?+i[2]:0)):0;return parseFloat(e.toFixed(n))}var i;return Math.round(e/t)*t}var g,y,v,b=function(){function t(n,i){e(this,t),p.element(n)?this.element=n:p.string(n)&&(this.element=document.querySelector(n)),p.element(this.element)&&p.empty(this.element.rangeTouch)&&(this.config=Object.assign({},r,i),this.init())}return n(t,[{key:"init",value:function(){t.enabled&&(this.config.addCSS&&(this.element.style.userSelect="none",this.element.style.webKitUserSelect="none",this.element.style.touchAction="manipulation"),this.listeners(!0),this.element.rangeTouch=this)}},{key:"destroy",value:function(){t.enabled&&(this.listeners(!1),this.element.rangeTouch=null)}},{key:"listeners",value:function(e){var t=this,n=e?"addEventListener":"removeEventListener";["touchstart","touchmove","touchend"].forEach(function(e){t.element[n](e,function(e){return t.set(e)},!1)})}},{key:"get",value:function(e){if(!t.enabled||!p.event(e))return null;var n,i=e.target,a=e.changedTouches[0],s=parseFloat(i.getAttribute("min"))||0,r=parseFloat(i.getAttribute("max"))||100,o=parseFloat(i.getAttribute("step"))||1,l=r-s,c=i.getBoundingClientRect(),u=100/c.width*(this.config.thumbWidth/2)/100;return(n=100/c.width*(a.clientX-c.left))<0?n=0:n>100&&(n=100),n<50?n-=(100-2*n)*u:n>50&&(n+=2*(n-50)*u),s+f(l*(n/100),o)}},{key:"set",value:function(e){t.enabled&&p.event(e)&&!e.target.disabled&&(e.preventDefault(),e.target.value=this.get(e),function(e,t){if(e&&t){var n=new Event(t);e.dispatchEvent(n)}}(e.target,"touchend"===e.type?"change":"input"))}}],[{key:"setup",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=null;if(p.empty(e)||p.string(e)?i=Array.from(document.querySelectorAll(p.string(e)?e:'input[type="range"]')):p.element(e)?i=[e]:p.nodeList(e)?i=Array.from(e):p.array(e)&&(i=e.filter(p.element)),p.empty(i))return null;var a=Object.assign({},r,n);p.string(e)&&a.watch&&new MutationObserver(function(n){Array.from(n).forEach(function(n){Array.from(n.addedNodes).forEach(function(n){if(p.element(n)&&function(){return Array.from(document.querySelectorAll(i)).includes(this)}.call(n,i=e)){var i;new t(n,a)}})})}).observe(document.body,{childList:!0,subtree:!0});return i.map(function(e){return new t(e,n)})}},{key:"enabled",get:function(){return"ontouchstart"in document.documentElement}}]),t}(),k=function(e){return null!=e?e.constructor:null},w=function(e,t){return Boolean(e&&t&&e instanceof t)},T=function(e){return null==e},C=function(e){return k(e)===Object},A=function(e){return k(e)===String},E=function(e){return Array.isArray(e)},S=function(e){return w(e,NodeList)},P=function(e){return T(e)||(A(e)||E(e)||S(e))&&!e.length||C(e)&&!Object.keys(e).length},N={nullOrUndefined:T,object:C,number:function(e){return k(e)===Number&&!Number.isNaN(e)},string:A,boolean:function(e){return k(e)===Boolean},function:function(e){return k(e)===Function},array:E,weakMap:function(e){return w(e,WeakMap)},nodeList:S,element:function(e){return w(e,Element)},textNode:function(e){return k(e)===Text},event:function(e){return w(e,Event)},keyboardEvent:function(e){return w(e,KeyboardEvent)},cue:function(e){return w(e,window.TextTrackCue)||w(e,window.VTTCue)},track:function(e){return w(e,TextTrack)||!T(e)&&A(e.kind)},promise:function(e){return w(e,Promise)},url:function(e){if(w(e,window.URL))return!0;if(!A(e))return!1;var t=e;e.startsWith("http://")&&e.startsWith("https://")||(t="http://".concat(e));try{return!P(new URL(t).hostname)}catch(e){return!1}},empty:P},M=(g=document.createElement("span"),y={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"},v=Object.keys(y).find(function(e){return void 0!==g.style[e]}),!!N.string(v)&&y[v]);function x(e,t){setTimeout(function(){try{e.hidden=!0,e.offsetHeight,e.hidden=!1}catch(e){}},t)}var L={isIE:!!document.documentMode,isEdge:window.navigator.userAgent.includes("Edge"),isWebkit:"WebkitAppearance"in document.documentElement.style&&!/Edge/.test(navigator.userAgent),isIPhone:/(iPhone|iPod)/gi.test(navigator.platform),isIos:/(iPad|iPhone|iPod)/gi.test(navigator.platform)},I=function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){return e=!0,null}});window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(e){}return e}();function _(e,t,n){var i=this,a=arguments.length>3&&void 0!==arguments[3]&&arguments[3],s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],r=arguments.length>5&&void 0!==arguments[5]&&arguments[5];if(e&&"addEventListener"in e&&!N.empty(t)&&N.function(n)){var o=t.split(" "),l=r;I&&(l={passive:s,capture:r}),o.forEach(function(t){i&&i.eventListeners&&a&&i.eventListeners.push({element:e,type:t,callback:n,options:l}),e[a?"addEventListener":"removeEventListener"](t,n,l)})}}function O(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2?arguments[2]:void 0,i=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],a=arguments.length>4&&void 0!==arguments[4]&&arguments[4];_.call(this,e,t,n,!0,i,a)}function j(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2?arguments[2]:void 0,i=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],a=arguments.length>4&&void 0!==arguments[4]&&arguments[4];_.call(this,e,t,n,!1,i,a)}function q(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments.length>2?arguments[2]:void 0,a=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],s=arguments.length>4&&void 0!==arguments[4]&&arguments[4];_.call(this,e,n,function r(){j(e,n,r,a,s);for(var o=arguments.length,l=new Array(o),c=0;c<o;c++)l[c]=arguments[c];i.apply(t,l)},!0,a,s)}function H(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};if(N.element(e)&&!N.empty(t)){var a=new CustomEvent(t,{bubbles:n,detail:Object.assign({},i,{plyr:this})});e.dispatchEvent(a)}}function D(e,t){return t.split(".").reduce(function(e,t){return e&&e[t]},e)}function F(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length,n=new Array(t>1?t-1:0),a=1;a<t;a++)n[a-1]=arguments[a];if(!n.length)return e;var s=n.shift();return N.object(s)?(Object.keys(s).forEach(function(t){N.object(s[t])?(Object.keys(e).includes(t)||Object.assign(e,i({},t,{})),F(e[t],s[t])):Object.assign(e,i({},t,s[t]))}),F.apply(void 0,[e].concat(n))):e}function R(e,t){var n=e.length?e:[e];Array.from(n).reverse().forEach(function(e,n){var i=n>0?t.cloneNode(!0):t,a=e.parentNode,s=e.nextSibling;i.appendChild(e),s?a.insertBefore(i,s):a.appendChild(i)})}function V(e,t){N.element(e)&&!N.empty(t)&&Object.entries(t).filter(function(e){var t=a(e,2)[1];return!N.nullOrUndefined(t)}).forEach(function(t){var n=a(t,2),i=n[0],s=n[1];return e.setAttribute(i,s)})}function B(e,t,n){var i=document.createElement(e);return N.object(t)&&V(i,t),N.string(n)&&(i.innerText=n),i}function U(e,t,n,i){N.element(t)&&t.appendChild(B(e,n,i))}function W(e){N.nodeList(e)||N.array(e)?Array.from(e).forEach(W):N.element(e)&&N.element(e.parentNode)&&e.parentNode.removeChild(e)}function z(e){if(N.element(e))for(var t=e.childNodes.length;t>0;)e.removeChild(e.lastChild),t-=1}function K(e,t){return N.element(t)&&N.element(t.parentNode)&&N.element(e)?(t.parentNode.replaceChild(e,t),e):null}function Y(e,t){if(!N.string(e)||N.empty(e))return{};var n={},i=F({},t);return e.split(",").forEach(function(e){var t=e.trim(),s=t.replace(".",""),r=t.replace(/[[\]]/g,"").split("="),o=a(r,1)[0],l=r.length>1?r[1].replace(/["']/g,""):"";switch(t.charAt(0)){case".":N.string(i.class)?n.class="".concat(i.class," ").concat(s):n.class=s;break;case"#":n.id=t.replace("#","");break;case"[":n[o]=l}}),F(i,n)}function Q(e,t){if(N.element(e)){var n=t;N.boolean(n)||(n=!e.hidden),e.hidden=n}}function X(e,t,n){if(N.nodeList(e))return Array.from(e).map(function(e){return X(e,t,n)});if(N.element(e)){var i="toggle";return void 0!==n&&(i=n?"add":"remove"),e.classList[i](t),e.classList.contains(t)}return!1}function J(e,t){return N.element(e)&&e.classList.contains(t)}function $(e,t){return function(){return Array.from(document.querySelectorAll(t)).includes(this)}.call(e,t)}function G(e){return this.elements.container.querySelectorAll(e)}function Z(e){return this.elements.container.querySelector(e)}function ee(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];N.element(e)&&(e.focus({preventScroll:!0}),t&&X(e,this.config.classNames.tabFocus))}var te,ne={"audio/ogg":"vorbis","audio/wav":"1","video/webm":"vp8, vorbis","video/mp4":"avc1.42E01E, mp4a.40.2","video/ogg":"theora"},ie={audio:"canPlayType"in document.createElement("audio"),video:"canPlayType"in document.createElement("video"),check:function(e,t,n){var i=L.isIPhone&&n&&ie.playsinline,a=ie[e]||"html5"!==t;return{api:a,ui:a&&ie.rangeInput&&("video"!==e||!L.isIPhone||i)}},pip:!(L.isIPhone||!N.function(B("video").webkitSetPresentationMode)&&(!document.pictureInPictureEnabled||B("video").disablePictureInPicture)),airplay:N.function(window.WebKitPlaybackTargetAvailabilityEvent),playsinline:"playsInline"in document.createElement("video"),mime:function(e){if(N.empty(e))return!1;var t=a(e.split("/"),1)[0],n=e;if(!this.isHTML5||t!==this.type)return!1;Object.keys(ne).includes(n)&&(n+='; codecs="'.concat(ne[e],'"'));try{return Boolean(n&&this.media.canPlayType(n).replace(/no/,""))}catch(e){return!1}},textTracks:"textTracks"in document.createElement("video"),rangeInput:(te=document.createElement("input"),te.type="range","range"===te.type),touch:"ontouchstart"in document.documentElement,transitions:!1!==M,reducedMotion:"matchMedia"in window&&window.matchMedia("(prefers-reduced-motion)").matches};function ae(e){return!!(N.array(e)||N.string(e)&&e.includes(":"))&&(N.array(e)?e:e.split(":")).map(Number).every(N.number)}function se(e){if(!N.array(e)||!e.every(N.number))return null;var t=a(e,2),n=t[0],i=t[1],s=function e(t,n){return 0===n?t:e(n,t%n)}(n,i);return[n/s,i/s]}function re(e){var t=function(e){return ae(e)?e.split(":").map(Number):null},n=t(e);if(null===n&&(n=t(this.config.ratio)),null===n&&!N.empty(this.embed)&&N.array(this.embed.ratio)&&(n=this.embed.ratio),null===n&&this.isHTML5){var i=this.media;n=se([i.videoWidth,i.videoHeight])}return n}function oe(e){if(!this.isVideo)return{};var t=re.call(this,e),n=a(N.array(t)?t:[0,0],2),i=100/n[0]*n[1];if(this.elements.wrapper.style.paddingBottom="".concat(i,"%"),this.isVimeo&&this.supported.ui){var s=(240-i)/4.8;this.media.style.transform="translateY(-".concat(s,"%)")}else this.isHTML5&&this.elements.wrapper.classList.toggle(this.config.classNames.videoFixedRatio,null!==t);return{padding:i,ratio:t}}var le={getSources:function(){var e=this;return this.isHTML5?Array.from(this.media.querySelectorAll("source")).filter(function(t){var n=t.getAttribute("type");return!!N.empty(n)||ie.mime.call(e,n)}):[]},getQualityOptions:function(){return le.getSources.call(this).map(function(e){return Number(e.getAttribute("size"))}).filter(Boolean)},extend:function(){if(this.isHTML5){var e=this;N.empty(this.config.ratio)||oe.call(e),Object.defineProperty(e.media,"quality",{get:function(){var t=le.getSources.call(e).find(function(t){return t.getAttribute("src")===e.source});return t&&Number(t.getAttribute("size"))},set:function(t){var n=le.getSources.call(e).find(function(e){return Number(e.getAttribute("size"))===t});if(n){var i=e.media,a=i.currentTime,s=i.paused,r=i.preload,o=i.readyState;e.media.src=n.getAttribute("src"),("none"!==r||o)&&(e.once("loadedmetadata",function(){e.currentTime=a,s||e.play()}),e.media.load()),H.call(e,e.media,"qualitychange",!1,{quality:t})}}})}},cancelRequests:function(){this.isHTML5&&(W(le.getSources.call(this)),this.media.setAttribute("src",this.config.blankVideo),this.media.load(),this.debug.log("Cancelled network requests"))}};function ce(e){return N.array(e)?e.filter(function(t,n){return e.indexOf(t)===n}):e}function ue(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];return N.empty(e)?e:e.toString().replace(/{(\d+)}/g,function(e,t){return n[t].toString()})}function de(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"";return e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]\/\\])/g,"\\$1"),"g"),n.toString())}function he(){return(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString().replace(/\w\S*/g,function(e){return e.charAt(0).toUpperCase()+e.substr(1).toLowerCase()})}function me(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString();return(e=function(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString();return e=de(e,"-"," "),e=de(e,"_"," "),de(e=he(e)," ","")}(e)).charAt(0).toLowerCase()+e.slice(1)}function pe(e){var t=document.createElement("div");return t.appendChild(e),t.innerHTML}var fe={pip:"PIP",airplay:"AirPlay",html5:"HTML5",vimeo:"Vimeo",youtube:"YouTube"},ge=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(N.empty(e)||N.empty(t))return"";var n=D(t.i18n,e);if(N.empty(n))return Object.keys(fe).includes(e)?fe[e]:"";var i={"{seektime}":t.seekTime,"{title}":t.title};return Object.entries(i).forEach(function(e){var t=a(e,2),i=t[0],s=t[1];n=de(n,i,s)}),n},ye=function(){function t(n){e(this,t),this.enabled=n.config.storage.enabled,this.key=n.config.storage.key}return n(t,[{key:"get",value:function(e){if(!t.supported||!this.enabled)return null;var n=window.localStorage.getItem(this.key);if(N.empty(n))return null;var i=JSON.parse(n);return N.string(e)&&e.length?i[e]:i}},{key:"set",value:function(e){if(t.supported&&this.enabled&&N.object(e)){var n=this.get();N.empty(n)&&(n={}),F(n,e),window.localStorage.setItem(this.key,JSON.stringify(n))}}}],[{key:"supported",get:function(){try{if(!("localStorage"in window))return!1;return window.localStorage.setItem("___test","___test"),window.localStorage.removeItem("___test"),!0}catch(e){return!1}}}]),t}();function ve(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"text";return new Promise(function(n,i){try{var a=new XMLHttpRequest;if(!("withCredentials"in a))return;a.addEventListener("load",function(){if("text"===t)try{n(JSON.parse(a.responseText))}catch(e){n(a.responseText)}else n(a.response)}),a.addEventListener("error",function(){throw new Error(a.status)}),a.open("GET",e,!0),a.responseType=t,a.send()}catch(e){i(e)}})}function be(e,t){if(N.string(e)){var n=N.string(t),i=function(){return null!==document.getElementById(t)},a=function(e,t){e.innerHTML=t,n&&i()||document.body.insertAdjacentElement("afterbegin",e)};if(!n||!i()){var s=ye.supported,r=document.createElement("div");if(r.setAttribute("hidden",""),n&&r.setAttribute("id",t),s){var o=window.localStorage.getItem("".concat("cache","-").concat(t));if(null!==o){var l=JSON.parse(o);a(r,l.content)}}ve(e).then(function(e){N.empty(e)||(s&&window.localStorage.setItem("".concat("cache","-").concat(t),JSON.stringify({content:e})),a(r,e))}).catch(function(){})}}}var ke=function(e){return Math.trunc(e/60/60%60,10)},we=function(e){return Math.trunc(e/60%60,10)},Te=function(e){return Math.trunc(e%60,10)};function Ce(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!N.number(e))return Ce(null,t,n);var i=function(e){return"0".concat(e).slice(-2)},a=ke(e),s=we(e),r=Te(e);return a=t||a>0?"".concat(a,":"):"","".concat(n&&e>0?"-":"").concat(a).concat(i(s),":").concat(i(r))}var Ae={getIconUrl:function(){var e=new URL(this.config.iconUrl,window.location).host!==window.location.host||L.isIE&&!window.svg4everybody;return{url:this.config.iconUrl,cors:e}},findElements:function(){try{return this.elements.controls=Z.call(this,this.config.selectors.controls.wrapper),this.elements.buttons={play:G.call(this,this.config.selectors.buttons.play),pause:Z.call(this,this.config.selectors.buttons.pause),restart:Z.call(this,this.config.selectors.buttons.restart),rewind:Z.call(this,this.config.selectors.buttons.rewind),fastForward:Z.call(this,this.config.selectors.buttons.fastForward),mute:Z.call(this,this.config.selectors.buttons.mute),pip:Z.call(this,this.config.selectors.buttons.pip),airplay:Z.call(this,this.config.selectors.buttons.airplay),settings:Z.call(this,this.config.selectors.buttons.settings),captions:Z.call(this,this.config.selectors.buttons.captions),fullscreen:Z.call(this,this.config.selectors.buttons.fullscreen)},this.elements.progress=Z.call(this,this.config.selectors.progress),this.elements.inputs={seek:Z.call(this,this.config.selectors.inputs.seek),volume:Z.call(this,this.config.selectors.inputs.volume)},this.elements.display={buffer:Z.call(this,this.config.selectors.display.buffer),currentTime:Z.call(this,this.config.selectors.display.currentTime),duration:Z.call(this,this.config.selectors.display.duration)},N.element(this.elements.progress)&&(this.elements.display.seekTooltip=this.elements.progress.querySelector(".".concat(this.config.classNames.tooltip))),!0}catch(e){return this.debug.warn("It looks like there is a problem with your custom controls HTML",e),this.toggleNativeControls(!0),!1}},createIcon:function(e,t){var n=Ae.getIconUrl.call(this),i="".concat(n.cors?"":n.url,"#").concat(this.config.iconPrefix),a=document.createElementNS("http://www.w3.org/2000/svg","svg");V(a,F(t,{role:"presentation",focusable:"false"}));var s=document.createElementNS("http://www.w3.org/2000/svg","use"),r="".concat(i,"-").concat(e);return"href"in s&&s.setAttributeNS("http://www.w3.org/1999/xlink","href",r),s.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href",r),a.appendChild(s),a},createLabel:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=ge(e,this.config);return B("span",Object.assign({},t,{class:[t.class,this.config.classNames.hidden].filter(Boolean).join(" ")}),n)},createBadge:function(e){if(N.empty(e))return null;var t=B("span",{class:this.config.classNames.menu.value});return t.appendChild(B("span",{class:this.config.classNames.menu.badge},e)),t},createButton:function(e,t){var n=this,i=F({},t),a=me(e),s={element:"button",toggle:!1,label:null,icon:null,labelPressed:null,iconPressed:null};switch(["element","icon","label"].forEach(function(e){Object.keys(i).includes(e)&&(s[e]=i[e],delete i[e])}),"button"!==s.element||Object.keys(i).includes("type")||(i.type="button"),Object.keys(i).includes("class")?i.class.split(" ").some(function(e){return e===n.config.classNames.control})||F(i,{class:"".concat(i.class," ").concat(this.config.classNames.control)}):i.class=this.config.classNames.control,e){case"play":s.toggle=!0,s.label="play",s.labelPressed="pause",s.icon="play",s.iconPressed="pause";break;case"mute":s.toggle=!0,s.label="mute",s.labelPressed="unmute",s.icon="volume",s.iconPressed="muted";break;case"captions":s.toggle=!0,s.label="enableCaptions",s.labelPressed="disableCaptions",s.icon="captions-off",s.iconPressed="captions-on";break;case"fullscreen":s.toggle=!0,s.label="enterFullscreen",s.labelPressed="exitFullscreen",s.icon="enter-fullscreen",s.iconPressed="exit-fullscreen";break;case"play-large":i.class+=" ".concat(this.config.classNames.control,"--overlaid"),a="play",s.label="play",s.icon="play";break;default:N.empty(s.label)&&(s.label=a),N.empty(s.icon)&&(s.icon=e)}var r=B(s.element);return s.toggle?(r.appendChild(Ae.createIcon.call(this,s.iconPressed,{class:"icon--pressed"})),r.appendChild(Ae.createIcon.call(this,s.icon,{class:"icon--not-pressed"})),r.appendChild(Ae.createLabel.call(this,s.labelPressed,{class:"label--pressed"})),r.appendChild(Ae.createLabel.call(this,s.label,{class:"label--not-pressed"}))):(r.appendChild(Ae.createIcon.call(this,s.icon)),r.appendChild(Ae.createLabel.call(this,s.label))),F(i,Y(this.config.selectors.buttons[a],i)),V(r,i),"play"===a?(N.array(this.elements.buttons[a])||(this.elements.buttons[a]=[]),this.elements.buttons[a].push(r)):this.elements.buttons[a]=r,r},createRange:function(e,t){var n=B("input",F(Y(this.config.selectors.inputs[e]),{type:"range",min:0,max:100,step:.01,value:0,autocomplete:"off",role:"slider","aria-label":ge(e,this.config),"aria-valuemin":0,"aria-valuemax":100,"aria-valuenow":0},t));return this.elements.inputs[e]=n,Ae.updateRangeFill.call(this,n),b.setup(n),n},createProgress:function(e,t){var n=B("progress",F(Y(this.config.selectors.display[e]),{min:0,max:100,value:0,role:"progressbar","aria-hidden":!0},t));if("volume"!==e){n.appendChild(B("span",null,"0"));var i={played:"played",buffer:"buffered"}[e],a=i?ge(i,this.config):"";n.innerText="% ".concat(a.toLowerCase())}return this.elements.display[e]=n,n},createTime:function(e,t){var n=Y(this.config.selectors.display[e],t),i=B("div",F(n,{class:"".concat(n.class?n.class:""," ").concat(this.config.classNames.display.time," ").trim(),"aria-label":ge(e,this.config)}),"00:00");return this.elements.display[e]=i,i},bindMenuItemShortcuts:function(e,t){var n=this;O(e,"keydown keyup",function(i){if([32,38,39,40].includes(i.which)&&(i.preventDefault(),i.stopPropagation(),"keydown"!==i.type)){var a,s=$(e,'[role="menuitemradio"]');if(!s&&[32,39].includes(i.which))Ae.showMenuPanel.call(n,t,!0);else 32!==i.which&&(40===i.which||s&&39===i.which?(a=e.nextElementSibling,N.element(a)||(a=e.parentNode.firstElementChild)):(a=e.previousElementSibling,N.element(a)||(a=e.parentNode.lastElementChild)),ee.call(n,a,!0))}},!1),O(e,"keyup",function(e){13===e.which&&Ae.focusFirstMenuItem.call(n,null,!0)})},createMenuItem:function(e){var t=this,n=e.value,i=e.list,a=e.type,s=e.title,r=e.badge,o=void 0===r?null:r,l=e.checked,c=void 0!==l&&l,u=Y(this.config.selectors.inputs[a]),d=B("button",F(u,{type:"button",role:"menuitemradio",class:"".concat(this.config.classNames.control," ").concat(u.class?u.class:"").trim(),"aria-checked":c,value:n})),h=B("span");h.innerHTML=s,N.element(o)&&h.appendChild(o),d.appendChild(h),Object.defineProperty(d,"checked",{enumerable:!0,get:function(){return"true"===d.getAttribute("aria-checked")},set:function(e){e&&Array.from(d.parentNode.children).filter(function(e){return $(e,'[role="menuitemradio"]')}).forEach(function(e){return e.setAttribute("aria-checked","false")}),d.setAttribute("aria-checked",e?"true":"false")}}),this.listeners.bind(d,"click keyup",function(e){if(!N.keyboardEvent(e)||32===e.which){switch(e.preventDefault(),e.stopPropagation(),d.checked=!0,a){case"language":t.currentTrack=Number(n);break;case"quality":t.quality=n;break;case"speed":t.speed=parseFloat(n)}Ae.showMenuPanel.call(t,"home",N.keyboardEvent(e))}},a,!1),Ae.bindMenuItemShortcuts.call(this,d,a),i.appendChild(d)},formatTime:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return N.number(e)?Ce(e,ke(this.duration)>0,t):e},updateTimeDisplay:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];N.element(e)&&N.number(t)&&(e.innerText=Ae.formatTime(t,n))},updateVolume:function(){this.supported.ui&&(N.element(this.elements.inputs.volume)&&Ae.setRange.call(this,this.elements.inputs.volume,this.muted?0:this.volume),N.element(this.elements.buttons.mute)&&(this.elements.buttons.mute.pressed=this.muted||0===this.volume))},setRange:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;N.element(e)&&(e.value=t,Ae.updateRangeFill.call(this,e))},updateProgress:function(e){var t=this;if(this.supported.ui&&N.event(e)){var n,i,a=0;if(e)switch(e.type){case"timeupdate":case"seeking":case"seeked":n=this.currentTime,i=this.duration,a=0===n||0===i||Number.isNaN(n)||Number.isNaN(i)?0:(n/i*100).toFixed(2),"timeupdate"===e.type&&Ae.setRange.call(this,this.elements.inputs.seek,a);break;case"playing":case"progress":!function(e,n){var i=N.number(n)?n:0,a=N.element(e)?e:t.elements.display.buffer;if(N.element(a)){a.value=i;var s=a.getElementsByTagName("span")[0];N.element(s)&&(s.childNodes[0].nodeValue=i)}}(this.elements.display.buffer,100*this.buffered)}}},updateRangeFill:function(e){var t=N.event(e)?e.target:e;if(N.element(t)&&"range"===t.getAttribute("type")){if($(t,this.config.selectors.inputs.seek)){t.setAttribute("aria-valuenow",this.currentTime);var n=Ae.formatTime(this.currentTime),i=Ae.formatTime(this.duration),a=ge("seekLabel",this.config);t.setAttribute("aria-valuetext",a.replace("{currentTime}",n).replace("{duration}",i))}else if($(t,this.config.selectors.inputs.volume)){var s=100*t.value;t.setAttribute("aria-valuenow",s),t.setAttribute("aria-valuetext","".concat(s.toFixed(1),"%"))}else t.setAttribute("aria-valuenow",t.value);L.isWebkit&&t.style.setProperty("--value","".concat(t.value/t.max*100,"%"))}},updateSeekTooltip:function(e){var t=this;if(this.config.tooltips.seek&&N.element(this.elements.inputs.seek)&&N.element(this.elements.display.seekTooltip)&&0!==this.duration){var n="".concat(this.config.classNames.tooltip,"--visible"),i=function(e){return X(t.elements.display.seekTooltip,n,e)};if(this.touch)i(!1);else{var a=0,s=this.elements.progress.getBoundingClientRect();if(N.event(e))a=100/s.width*(e.pageX-s.left);else{if(!J(this.elements.display.seekTooltip,n))return;a=parseFloat(this.elements.display.seekTooltip.style.left,10)}a<0?a=0:a>100&&(a=100),Ae.updateTimeDisplay.call(this,this.elements.display.seekTooltip,this.duration/100*a),this.elements.display.seekTooltip.style.left="".concat(a,"%"),N.event(e)&&["mouseenter","mouseleave"].includes(e.type)&&i("mouseenter"===e.type)}}},timeUpdate:function(e){var t=!N.element(this.elements.display.duration)&&this.config.invertTime;Ae.updateTimeDisplay.call(this,this.elements.display.currentTime,t?this.duration-this.currentTime:this.currentTime,t),e&&"timeupdate"===e.type&&this.media.seeking||Ae.updateProgress.call(this,e)},durationUpdate:function(){if(this.supported.ui&&(this.config.invertTime||!this.currentTime)){if(this.duration>=Math.pow(2,32))return Q(this.elements.display.currentTime,!0),void Q(this.elements.progress,!0);N.element(this.elements.inputs.seek)&&this.elements.inputs.seek.setAttribute("aria-valuemax",this.duration);var e=N.element(this.elements.display.duration);!e&&this.config.displayDuration&&this.paused&&Ae.updateTimeDisplay.call(this,this.elements.display.currentTime,this.duration),e&&Ae.updateTimeDisplay.call(this,this.elements.display.duration,this.duration),Ae.updateSeekTooltip.call(this)}},toggleMenuButton:function(e,t){Q(this.elements.settings.buttons[e],!t)},updateSetting:function(e,t,n){var i=this.elements.settings.panels[e],a=null,s=t;if("captions"===e)a=this.currentTrack;else{if(a=N.empty(n)?this[e]:n,N.empty(a)&&(a=this.config[e].default),!N.empty(this.options[e])&&!this.options[e].includes(a))return void this.debug.warn("Unsupported value of '".concat(a,"' for ").concat(e));if(!this.config[e].options.includes(a))return void this.debug.warn("Disabled value of '".concat(a,"' for ").concat(e))}if(N.element(s)||(s=i&&i.querySelector('[role="menu"]')),N.element(s)){this.elements.settings.buttons[e].querySelector(".".concat(this.config.classNames.menu.value)).innerHTML=Ae.getLabel.call(this,e,a);var r=s&&s.querySelector('[value="'.concat(a,'"]'));N.element(r)&&(r.checked=!0)}},getLabel:function(e,t){switch(e){case"speed":return 1===t?ge("normal",this.config):"".concat(t,"&times;");case"quality":if(N.number(t)){var n=ge("qualityLabel.".concat(t),this.config);return n.length?n:"".concat(t,"p")}return he(t);case"captions":return Pe.getLabel.call(this);default:return null}},setQualityMenu:function(e){var t=this;if(N.element(this.elements.settings.panels.quality)){var n=this.elements.settings.panels.quality.querySelector('[role="menu"]');N.array(e)&&(this.options.quality=ce(e).filter(function(e){return t.config.quality.options.includes(e)}));var i=!N.empty(this.options.quality)&&this.options.quality.length>1;if(Ae.toggleMenuButton.call(this,"quality",i),z(n),Ae.checkMenu.call(this),i){var a=function(e){var n=ge("qualityBadge.".concat(e),t.config);return n.length?Ae.createBadge.call(t,n):null};this.options.quality.sort(function(e,n){var i=t.config.quality.options;return i.indexOf(e)>i.indexOf(n)?1:-1}).forEach(function(e){Ae.createMenuItem.call(t,{value:e,list:n,type:"quality",title:Ae.getLabel.call(t,"quality",e),badge:a(e)})}),Ae.updateSetting.call(this,"quality",n)}}},setCaptionsMenu:function(){var e=this;if(N.element(this.elements.settings.panels.captions)){var t=this.elements.settings.panels.captions.querySelector('[role="menu"]'),n=Pe.getTracks.call(this),i=Boolean(n.length);if(Ae.toggleMenuButton.call(this,"captions",i),z(t),Ae.checkMenu.call(this),i){var a=n.map(function(n,i){return{value:i,checked:e.captions.toggled&&e.currentTrack===i,title:Pe.getLabel.call(e,n),badge:n.language&&Ae.createBadge.call(e,n.language.toUpperCase()),list:t,type:"language"}});a.unshift({value:-1,checked:!this.captions.toggled,title:ge("disabled",this.config),list:t,type:"language"}),a.forEach(Ae.createMenuItem.bind(this)),Ae.updateSetting.call(this,"captions",t)}}},setSpeedMenu:function(e){var t=this;if(N.element(this.elements.settings.panels.speed)){var n=this.elements.settings.panels.speed.querySelector('[role="menu"]');N.array(e)?this.options.speed=e:(this.isHTML5||this.isVimeo)&&(this.options.speed=[.5,.75,1,1.25,1.5,1.75,2]),this.options.speed=this.options.speed.filter(function(e){return t.config.speed.options.includes(e)});var i=!N.empty(this.options.speed)&&this.options.speed.length>1;Ae.toggleMenuButton.call(this,"speed",i),z(n),Ae.checkMenu.call(this),i&&(this.options.speed.forEach(function(e){Ae.createMenuItem.call(t,{value:e,list:n,type:"speed",title:Ae.getLabel.call(t,"speed",e)})}),Ae.updateSetting.call(this,"speed",n))}},checkMenu:function(){var e=this.elements.settings.buttons,t=!N.empty(e)&&Object.values(e).some(function(e){return!e.hidden});Q(this.elements.settings.menu,!t)},focusFirstMenuItem:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(!this.elements.settings.popup.hidden){var n=e;N.element(n)||(n=Object.values(this.elements.settings.panels).find(function(e){return!e.hidden}));var i=n.querySelector('[role^="menuitem"]');ee.call(this,i,t)}},toggleMenu:function(e){var t=this.elements.settings.popup,n=this.elements.buttons.settings;if(N.element(t)&&N.element(n)){var i=t.hidden,a=i;if(N.boolean(e))a=e;else if(N.keyboardEvent(e)&&27===e.which)a=!1;else if(N.event(e)){var s=N.function(e.composedPath)?e.composedPath()[0]:e.target,r=t.contains(s);if(r||!r&&e.target!==n&&a)return}n.setAttribute("aria-expanded",a),Q(t,!a),X(this.elements.container,this.config.classNames.menu.open,a),a&&N.keyboardEvent(e)?Ae.focusFirstMenuItem.call(this,null,!0):a||i||ee.call(this,n,N.keyboardEvent(e))}},getMenuSize:function(e){var t=e.cloneNode(!0);t.style.position="absolute",t.style.opacity=0,t.removeAttribute("hidden"),e.parentNode.appendChild(t);var n=t.scrollWidth,i=t.scrollHeight;return W(t),{width:n,height:i}},showMenuPanel:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=this.elements.container.querySelector("#plyr-settings-".concat(this.id,"-").concat(t));if(N.element(i)){var a=i.parentNode,s=Array.from(a.children).find(function(e){return!e.hidden});if(ie.transitions&&!ie.reducedMotion){a.style.width="".concat(s.scrollWidth,"px"),a.style.height="".concat(s.scrollHeight,"px");var r=Ae.getMenuSize.call(this,i);O.call(this,a,M,function t(n){n.target===a&&["width","height"].includes(n.propertyName)&&(a.style.width="",a.style.height="",j.call(e,a,M,t))}),a.style.width="".concat(r.width,"px"),a.style.height="".concat(r.height,"px")}Q(s,!0),Q(i,!1),Ae.focusFirstMenuItem.call(this,i,n)}},setDownloadUrl:function(){var e=this.elements.buttons.download;N.element(e)&&e.setAttribute("href",this.download)},create:function(e){var t=this,n=Ae.bindMenuItemShortcuts,i=Ae.createButton,a=Ae.createProgress,s=Ae.createRange,r=Ae.createTime,o=Ae.setQualityMenu,l=Ae.setSpeedMenu,c=Ae.showMenuPanel;this.elements.controls=null,this.config.controls.includes("play-large")&&this.elements.container.appendChild(i.call(this,"play-large"));var u=B("div",Y(this.config.selectors.controls.wrapper));this.elements.controls=u;var d={class:"plyr__controls__item"};return ce(this.config.controls).forEach(function(o){if("restart"===o&&u.appendChild(i.call(t,"restart",d)),"rewind"===o&&u.appendChild(i.call(t,"rewind",d)),"play"===o&&u.appendChild(i.call(t,"play",d)),"fast-forward"===o&&u.appendChild(i.call(t,"fast-forward",d)),"progress"===o){var l=B("div",{class:"".concat(d.class," plyr__progress__container")}),h=B("div",Y(t.config.selectors.progress));if(h.appendChild(s.call(t,"seek",{id:"plyr-seek-".concat(e.id)})),h.appendChild(a.call(t,"buffer")),t.config.tooltips.seek){var m=B("span",{class:t.config.classNames.tooltip},"00:00");h.appendChild(m),t.elements.display.seekTooltip=m}t.elements.progress=h,l.appendChild(t.elements.progress),u.appendChild(l)}if("current-time"===o&&u.appendChild(r.call(t,"currentTime",d)),"duration"===o&&u.appendChild(r.call(t,"duration",d)),"mute"===o||"volume"===o){var p=t.elements.volume;if(N.element(p)&&u.contains(p)||(p=B("div",F({},d,{class:"".concat(d.class," plyr__volume").trim()})),t.elements.volume=p,u.appendChild(p)),"mute"===o&&p.appendChild(i.call(t,"mute")),"volume"===o){var f={max:1,step:.05,value:t.config.volume};p.appendChild(s.call(t,"volume",F(f,{id:"plyr-volume-".concat(e.id)})))}}if("captions"===o&&u.appendChild(i.call(t,"captions",d)),"settings"===o&&!N.empty(t.config.settings)){var g=B("div",F({},d,{class:"".concat(d.class," plyr__menu").trim(),hidden:""}));g.appendChild(i.call(t,"settings",{"aria-haspopup":!0,"aria-controls":"plyr-settings-".concat(e.id),"aria-expanded":!1}));var y=B("div",{class:"plyr__menu__container",id:"plyr-settings-".concat(e.id),hidden:""}),v=B("div"),b=B("div",{id:"plyr-settings-".concat(e.id,"-home")}),k=B("div",{role:"menu"});b.appendChild(k),v.appendChild(b),t.elements.settings.panels.home=b,t.config.settings.forEach(function(i){var a=B("button",F(Y(t.config.selectors.buttons.settings),{type:"button",class:"".concat(t.config.classNames.control," ").concat(t.config.classNames.control,"--forward"),role:"menuitem","aria-haspopup":!0,hidden:""}));n.call(t,a,i),O(a,"click",function(){c.call(t,i,!1)});var s=B("span",null,ge(i,t.config)),r=B("span",{class:t.config.classNames.menu.value});r.innerHTML=e[i],s.appendChild(r),a.appendChild(s),k.appendChild(a);var o=B("div",{id:"plyr-settings-".concat(e.id,"-").concat(i),hidden:""}),l=B("button",{type:"button",class:"".concat(t.config.classNames.control," ").concat(t.config.classNames.control,"--back")});l.appendChild(B("span",{"aria-hidden":!0},ge(i,t.config))),l.appendChild(B("span",{class:t.config.classNames.hidden},ge("menuBack",t.config))),O(o,"keydown",function(e){37===e.which&&(e.preventDefault(),e.stopPropagation(),c.call(t,"home",!0))},!1),O(l,"click",function(){c.call(t,"home",!1)}),o.appendChild(l),o.appendChild(B("div",{role:"menu"})),v.appendChild(o),t.elements.settings.buttons[i]=a,t.elements.settings.panels[i]=o}),y.appendChild(v),g.appendChild(y),u.appendChild(g),t.elements.settings.popup=y,t.elements.settings.menu=g}if("pip"===o&&ie.pip&&u.appendChild(i.call(t,"pip",d)),"airplay"===o&&ie.airplay&&u.appendChild(i.call(t,"airplay",d)),"download"===o){var w=F({},d,{element:"a",href:t.download,target:"_blank"}),T=t.config.urls.download;!N.url(T)&&t.isEmbed&&F(w,{icon:"logo-".concat(t.provider),label:t.provider}),u.appendChild(i.call(t,"download",w))}"fullscreen"===o&&u.appendChild(i.call(t,"fullscreen",d))}),this.isHTML5&&o.call(this,le.getQualityOptions.call(this)),l.call(this),u},inject:function(){var e=this;if(this.config.loadSprite){var t=Ae.getIconUrl.call(this);t.cors&&be(t.url,"sprite-plyr")}this.id=Math.floor(1e4*Math.random());var n=null;this.elements.controls=null;var i={id:this.id,seektime:this.config.seekTime,title:this.config.title},s=!0;N.function(this.config.controls)&&(this.config.controls=this.config.controls.call(this,i)),this.config.controls||(this.config.controls=[]),N.element(this.config.controls)||N.string(this.config.controls)?n=this.config.controls:(n=Ae.create.call(this,{id:this.id,seektime:this.config.seekTime,speed:this.speed,quality:this.quality,captions:Pe.getLabel.call(this)}),s=!1);var r,o=function(e){var t=e;return Object.entries(i).forEach(function(e){var n=a(e,2),i=n[0],s=n[1];t=de(t,"{".concat(i,"}"),s)}),t};if(s&&(N.string(this.config.controls)?n=o(n):N.element(n)&&(n.innerHTML=o(n.innerHTML))),N.string(this.config.selectors.controls.container)&&(r=document.querySelector(this.config.selectors.controls.container)),N.element(r)||(r=this.elements.container),r[N.element(n)?"insertAdjacentElement":"insertAdjacentHTML"]("afterbegin",n),N.element(this.elements.controls)||Ae.findElements.call(this),!N.empty(this.elements.buttons)){var l=function(t){var n=e.config.classNames.controlPressed;Object.defineProperty(t,"pressed",{enumerable:!0,get:function(){return J(t,n)},set:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];X(t,n,e)}})};Object.values(this.elements.buttons).filter(Boolean).forEach(function(e){N.array(e)||N.nodeList(e)?Array.from(e).filter(Boolean).forEach(l):l(e)})}if(L.isEdge&&x(r),this.config.tooltips.controls){var c=this.config,u=c.classNames,d=c.selectors,h="".concat(d.controls.wrapper," ").concat(d.labels," .").concat(u.hidden),m=G.call(this,h);Array.from(m).forEach(function(t){X(t,e.config.classNames.hidden,!1),X(t,e.config.classNames.tooltip,!0)})}}};function Ee(e){var t=e;if(!(arguments.length>1&&void 0!==arguments[1])||arguments[1]){var n=document.createElement("a");n.href=t,t=n.href}try{return new URL(t)}catch(e){return null}}function Se(e){var t=new URLSearchParams;return N.object(e)&&Object.entries(e).forEach(function(e){var n=a(e,2),i=n[0],s=n[1];t.set(i,s)}),t}var Pe={setup:function(){if(this.supported.ui)if(!this.isVideo||this.isYouTube||this.isHTML5&&!ie.textTracks)N.array(this.config.controls)&&this.config.controls.includes("settings")&&this.config.settings.includes("captions")&&Ae.setCaptionsMenu.call(this);else{if(N.element(this.elements.captions)||(this.elements.captions=B("div",Y(this.config.selectors.captions)),function(e,t){N.element(e)&&N.element(t)&&t.parentNode.insertBefore(e,t.nextSibling)}(this.elements.captions,this.elements.wrapper)),L.isIE&&window.URL){var e=this.media.querySelectorAll("track");Array.from(e).forEach(function(e){var t=e.getAttribute("src"),n=Ee(t);null!==n&&n.hostname!==window.location.href.hostname&&["http:","https:"].includes(n.protocol)&&ve(t,"blob").then(function(t){e.setAttribute("src",window.URL.createObjectURL(t))}).catch(function(){W(e)})})}var t=ce((navigator.languages||[navigator.language||navigator.userLanguage||"en"]).map(function(e){return e.split("-")[0]})),n=(this.storage.get("language")||this.config.captions.language||"auto").toLowerCase();if("auto"===n)n=a(t,1)[0];var i=this.storage.get("captions");if(N.boolean(i)||(i=this.config.captions.active),Object.assign(this.captions,{toggled:!1,active:i,language:n,languages:t}),this.isHTML5){var s=this.config.captions.update?"addtrack removetrack":"removetrack";O.call(this,this.media.textTracks,s,Pe.update.bind(this))}setTimeout(Pe.update.bind(this),0)}},update:function(){var e=this,t=Pe.getTracks.call(this,!0),n=this.captions,i=n.active,a=n.language,s=n.meta,r=n.currentTrackNode,o=Boolean(t.find(function(e){return e.language===a}));this.isHTML5&&this.isVideo&&t.filter(function(e){return!s.get(e)}).forEach(function(t){e.debug.log("Track added",t),s.set(t,{default:"showing"===t.mode}),t.mode="hidden",O.call(e,t,"cuechange",function(){return Pe.updateCues.call(e)})}),(o&&this.language!==a||!t.includes(r))&&(Pe.setLanguage.call(this,a),Pe.toggle.call(this,i&&o)),X(this.elements.container,this.config.classNames.captions.enabled,!N.empty(t)),(this.config.controls||[]).includes("settings")&&this.config.settings.includes("captions")&&Ae.setCaptionsMenu.call(this)},toggle:function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(this.supported.ui){var n=this.captions.toggled,i=this.config.classNames.captions.active,a=N.nullOrUndefined(e)?!n:e;if(a!==n){if(t||(this.captions.active=a,this.storage.set({captions:a})),!this.language&&a&&!t){var r=Pe.getTracks.call(this),o=Pe.findTrack.call(this,[this.captions.language].concat(s(this.captions.languages)),!0);return this.captions.language=o.language,void Pe.set.call(this,r.indexOf(o))}this.elements.buttons.captions&&(this.elements.buttons.captions.pressed=a),X(this.elements.container,i,a),this.captions.toggled=a,Ae.updateSetting.call(this,"captions"),H.call(this,this.media,a?"captionsenabled":"captionsdisabled")}}},set:function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=Pe.getTracks.call(this);if(-1!==e)if(N.number(e))if(e in n){if(this.captions.currentTrack!==e){this.captions.currentTrack=e;var i=n[e],a=(i||{}).language;this.captions.currentTrackNode=i,Ae.updateSetting.call(this,"captions"),t||(this.captions.language=a,this.storage.set({language:a})),this.isVimeo&&this.embed.enableTextTrack(a),H.call(this,this.media,"languagechange")}Pe.toggle.call(this,!0,t),this.isHTML5&&this.isVideo&&Pe.updateCues.call(this)}else this.debug.warn("Track not found",e);else this.debug.warn("Invalid caption argument",e);else Pe.toggle.call(this,!1,t)},setLanguage:function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(N.string(e)){var n=e.toLowerCase();this.captions.language=n;var i=Pe.getTracks.call(this),a=Pe.findTrack.call(this,[n]);Pe.set.call(this,i.indexOf(a),t)}else this.debug.warn("Invalid language argument",e)},getTracks:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return Array.from((this.media||{}).textTracks||[]).filter(function(n){return!e.isHTML5||t||e.captions.meta.has(n)}).filter(function(e){return["captions","subtitles"].includes(e.kind)})},findTrack:function(e){var t,n=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1],a=Pe.getTracks.call(this),s=function(e){return Number((n.captions.meta.get(e)||{}).default)},r=Array.from(a).sort(function(e,t){return s(t)-s(e)});return e.every(function(e){return!(t=r.find(function(t){return t.language===e}))}),t||(i?r[0]:void 0)},getCurrentTrack:function(){return Pe.getTracks.call(this)[this.currentTrack]},getLabel:function(e){var t=e;return!N.track(t)&&ie.textTracks&&this.captions.toggled&&(t=Pe.getCurrentTrack.call(this)),N.track(t)?N.empty(t.label)?N.empty(t.language)?ge("enabled",this.config):e.language.toUpperCase():t.label:ge("disabled",this.config)},updateCues:function(e){if(this.supported.ui)if(N.element(this.elements.captions))if(N.nullOrUndefined(e)||Array.isArray(e)){var t=e;if(!t){var n=Pe.getCurrentTrack.call(this);t=Array.from((n||{}).activeCues||[]).map(function(e){return e.getCueAsHTML()}).map(pe)}var i=t.map(function(e){return e.trim()}).join("\n");if(i!==this.elements.captions.innerHTML){z(this.elements.captions);var a=B("span",Y(this.config.selectors.caption));a.innerHTML=i,this.elements.captions.appendChild(a),H.call(this,this.media,"cuechange")}}else this.debug.warn("updateCues: Invalid input",e);else this.debug.warn("No captions element to render to")}},Ne={enabled:!0,title:"",debug:!1,autoplay:!1,autopause:!0,playsinline:!0,seekTime:10,volume:1,muted:!1,duration:null,displayDuration:!0,invertTime:!0,toggleInvert:!0,ratio:null,clickToPlay:!0,hideControls:!0,resetOnEnd:!1,disableContextMenu:!0,loadSprite:!0,iconPrefix:"plyr",iconUrl:"https://cdn.plyr.io/3.5.6/plyr.svg",blankVideo:"https://cdn.plyr.io/static/blank.mp4",quality:{default:576,options:[4320,2880,2160,1440,1080,720,576,480,360,240]},loop:{active:!1},speed:{selected:1,options:[.5,.75,1,1.25,1.5,1.75,2]},keyboard:{focused:!0,global:!1},tooltips:{controls:!1,seek:!0},captions:{active:!1,language:"auto",update:!1},fullscreen:{enabled:!0,fallback:!0,iosNative:!1},storage:{enabled:!0,key:"plyr"},controls:["play-large","play","progress","current-time","mute","volume","captions","settings","pip","airplay","fullscreen"],settings:["captions","quality","speed"],i18n:{restart:"Restart",rewind:"Rewind {seektime}s",play:"Play",pause:"Pause",fastForward:"Forward {seektime}s",seek:"Seek",seekLabel:"{currentTime} of {duration}",played:"Played",buffered:"Buffered",currentTime:"Current time",duration:"Duration",volume:"Volume",mute:"Mute",unmute:"Unmute",enableCaptions:"Enable captions",disableCaptions:"Disable captions",download:"Download",enterFullscreen:"Enter fullscreen",exitFullscreen:"Exit fullscreen",frameTitle:"Player for {title}",captions:"Captions",settings:"Settings",menuBack:"Go back to previous menu",speed:"Speed",normal:"Normal",quality:"Quality",loop:"Loop",start:"Start",end:"End",all:"All",reset:"Reset",disabled:"Disabled",enabled:"Enabled",advertisement:"Ad",qualityBadge:{2160:"4K",1440:"HD",1080:"HD",720:"HD",576:"SD",480:"SD"}},urls:{download:null,vimeo:{sdk:"https://player.vimeo.com/api/player.js",iframe:"https://player.vimeo.com/video/{0}?{1}",api:"https://vimeo.com/api/v2/video/{0}.json"},youtube:{sdk:"https://www.youtube.com/iframe_api",api:"https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"},googleIMA:{sdk:"https://imasdk.googleapis.com/js/sdkloader/ima3.js"}},listeners:{seek:null,play:null,pause:null,restart:null,rewind:null,fastForward:null,mute:null,volume:null,captions:null,download:null,fullscreen:null,pip:null,airplay:null,speed:null,quality:null,loop:null,language:null},events:["ended","progress","stalled","playing","waiting","canplay","canplaythrough","loadstart","loadeddata","loadedmetadata","timeupdate","volumechange","play","pause","error","seeking","seeked","emptied","ratechange","cuechange","download","enterfullscreen","exitfullscreen","captionsenabled","captionsdisabled","languagechange","controlshidden","controlsshown","ready","statechange","qualitychange","adsloaded","adscontentpause","adscontentresume","adstarted","adsmidpoint","adscomplete","adsallcomplete","adsimpression","adsclick"],selectors:{editable:"input, textarea, select, [contenteditable]",container:".plyr",controls:{container:null,wrapper:".plyr__controls"},labels:"[data-plyr]",buttons:{play:'[data-plyr="play"]',pause:'[data-plyr="pause"]',restart:'[data-plyr="restart"]',rewind:'[data-plyr="rewind"]',fastForward:'[data-plyr="fast-forward"]',mute:'[data-plyr="mute"]',captions:'[data-plyr="captions"]',download:'[data-plyr="download"]',fullscreen:'[data-plyr="fullscreen"]',pip:'[data-plyr="pip"]',airplay:'[data-plyr="airplay"]',settings:'[data-plyr="settings"]',loop:'[data-plyr="loop"]'},inputs:{seek:'[data-plyr="seek"]',volume:'[data-plyr="volume"]',speed:'[data-plyr="speed"]',language:'[data-plyr="language"]',quality:'[data-plyr="quality"]'},display:{currentTime:".plyr__time--current",duration:".plyr__time--duration",buffer:".plyr__progress__buffer",loop:".plyr__progress__loop",volume:".plyr__volume--display"},progress:".plyr__progress",captions:".plyr__captions",caption:".plyr__caption"},classNames:{type:"plyr--{0}",provider:"plyr--{0}",video:"plyr__video-wrapper",embed:"plyr__video-embed",videoFixedRatio:"plyr__video-wrapper--fixed-ratio",embedContainer:"plyr__video-embed__container",poster:"plyr__poster",posterEnabled:"plyr__poster-enabled",ads:"plyr__ads",control:"plyr__control",controlPressed:"plyr__control--pressed",playing:"plyr--playing",paused:"plyr--paused",stopped:"plyr--stopped",loading:"plyr--loading",hover:"plyr--hover",tooltip:"plyr__tooltip",cues:"plyr__cues",hidden:"plyr__sr-only",hideControls:"plyr--hide-controls",isIos:"plyr--is-ios",isTouch:"plyr--is-touch",uiSupported:"plyr--full-ui",noTransition:"plyr--no-transition",display:{time:"plyr__time"},menu:{value:"plyr__menu__value",badge:"plyr__badge",open:"plyr--menu-open"},captions:{enabled:"plyr--captions-enabled",active:"plyr--captions-active"},fullscreen:{enabled:"plyr--fullscreen-enabled",fallback:"plyr--fullscreen-fallback"},pip:{supported:"plyr--pip-supported",active:"plyr--pip-active"},airplay:{supported:"plyr--airplay-supported",active:"plyr--airplay-active"},tabFocus:"plyr__tab-focus",previewThumbnails:{thumbContainer:"plyr__preview-thumb",thumbContainerShown:"plyr__preview-thumb--is-shown",imageContainer:"plyr__preview-thumb__image-container",timeContainer:"plyr__preview-thumb__time-container",scrubbingContainer:"plyr__preview-scrubbing",scrubbingContainerShown:"plyr__preview-scrubbing--is-shown"}},attributes:{embed:{provider:"data-plyr-provider",id:"data-plyr-embed-id"}},ads:{enabled:!1,publisherId:"",tagUrl:""},previewThumbnails:{enabled:!1,src:""},vimeo:{byline:!1,portrait:!1,title:!1,speed:!0,transparent:!1},youtube:{noCookie:!1,rel:0,showinfo:0,iv_load_policy:3,modestbranding:1}},Me="picture-in-picture",xe="inline",Le={html5:"html5",youtube:"youtube",vimeo:"vimeo"},Ie={audio:"audio",video:"video"};var _e=function(){},Oe=function(){function t(){var n=arguments.length>0&&void 0!==arguments[0]&&arguments[0];e(this,t),this.enabled=window.console&&n,this.enabled&&this.log("Debugging enabled")}return n(t,[{key:"log",get:function(){return this.enabled?Function.prototype.bind.call(console.log,console):_e}},{key:"warn",get:function(){return this.enabled?Function.prototype.bind.call(console.warn,console):_e}},{key:"error",get:function(){return this.enabled?Function.prototype.bind.call(console.error,console):_e}}]),t}();function je(){if(this.enabled){var e=this.player.elements.buttons.fullscreen;N.element(e)&&(e.pressed=this.active),H.call(this.player,this.target,this.active?"enterfullscreen":"exitfullscreen",!0),L.isIos||function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(N.element(e)){var n=G.call(this,"button:not(:disabled), input:not(:disabled), [tabindex]"),i=n[0],a=n[n.length-1];_.call(this,this.elements.container,"keydown",function(e){if("Tab"===e.key&&9===e.keyCode){var t=document.activeElement;t!==a||e.shiftKey?t===i&&e.shiftKey&&(a.focus(),e.preventDefault()):(i.focus(),e.preventDefault())}},t,!1)}}.call(this.player,this.target,this.active)}}function qe(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e?this.scrollPosition={x:window.scrollX||0,y:window.scrollY||0}:window.scrollTo(this.scrollPosition.x,this.scrollPosition.y),document.body.style.overflow=e?"hidden":"",X(this.target,this.player.config.classNames.fullscreen.fallback,e),L.isIos){var t=document.head.querySelector('meta[name="viewport"]'),n="viewport-fit=cover";t||(t=document.createElement("meta")).setAttribute("name","viewport");var i=N.string(t.content)&&t.content.includes(n);e?(this.cleanupViewport=!i,i||(t.content+=",".concat(n))):this.cleanupViewport&&(t.content=t.content.split(",").filter(function(e){return e.trim()!==n}).join(","))}je.call(this)}var He=function(){function t(n){var i=this;e(this,t),this.player=n,this.prefix=t.prefix,this.property=t.property,this.scrollPosition={x:0,y:0},this.forceFallback="force"===n.config.fullscreen.fallback,O.call(this.player,document,"ms"===this.prefix?"MSFullscreenChange":"".concat(this.prefix,"fullscreenchange"),function(){je.call(i)}),O.call(this.player,this.player.elements.container,"dblclick",function(e){N.element(i.player.elements.controls)&&i.player.elements.controls.contains(e.target)||i.toggle()}),this.update()}return n(t,[{key:"update",value:function(){var e;this.enabled?(e=this.forceFallback?"Fallback (forced)":t.native?"Native":"Fallback",this.player.debug.log("".concat(e," fullscreen enabled"))):this.player.debug.log("Fullscreen not supported and fallback disabled");X(this.player.elements.container,this.player.config.classNames.fullscreen.enabled,this.enabled)}},{key:"enter",value:function(){this.enabled&&(L.isIos&&this.player.config.fullscreen.iosNative?this.target.webkitEnterFullscreen():!t.native||this.forceFallback?qe.call(this,!0):this.prefix?N.empty(this.prefix)||this.target["".concat(this.prefix,"Request").concat(this.property)]():this.target.requestFullscreen())}},{key:"exit",value:function(){if(this.enabled)if(L.isIos&&this.player.config.fullscreen.iosNative)this.target.webkitExitFullscreen(),this.player.play();else if(!t.native||this.forceFallback)qe.call(this,!1);else if(this.prefix){if(!N.empty(this.prefix)){var e="moz"===this.prefix?"Cancel":"Exit";document["".concat(this.prefix).concat(e).concat(this.property)]()}}else(document.cancelFullScreen||document.exitFullscreen).call(document)}},{key:"toggle",value:function(){this.active?this.exit():this.enter()}},{key:"usingNative",get:function(){return t.native&&!this.forceFallback}},{key:"enabled",get:function(){return(t.native||this.player.config.fullscreen.fallback)&&this.player.config.fullscreen.enabled&&this.player.supported.ui&&this.player.isVideo}},{key:"active",get:function(){return!!this.enabled&&(!t.native||this.forceFallback?J(this.target,this.player.config.classNames.fullscreen.fallback):(this.prefix?document["".concat(this.prefix).concat(this.property,"Element")]:document.fullscreenElement)===this.target)}},{key:"target",get:function(){return L.isIos&&this.player.config.fullscreen.iosNative?this.player.media:this.player.elements.container}}],[{key:"native",get:function(){return!!(document.fullscreenEnabled||document.webkitFullscreenEnabled||document.mozFullScreenEnabled||document.msFullscreenEnabled)}},{key:"prefix",get:function(){if(N.function(document.exitFullscreen))return"";var e="";return["webkit","moz","ms"].some(function(t){return!(!N.function(document["".concat(t,"ExitFullscreen")])&&!N.function(document["".concat(t,"CancelFullScreen")]))&&(e=t,!0)}),e}},{key:"property",get:function(){return"moz"===this.prefix?"FullScreen":"Fullscreen"}}]),t}();function De(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;return new Promise(function(n,i){var a=new Image,s=function(){delete a.onload,delete a.onerror,(a.naturalWidth>=t?n:i)(a)};Object.assign(a,{onload:s,onerror:s,src:e})})}var Fe={addStyleHook:function(){X(this.elements.container,this.config.selectors.container.replace(".",""),!0),X(this.elements.container,this.config.classNames.uiSupported,this.supported.ui)},toggleNativeControls:function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&this.isHTML5?this.media.setAttribute("controls",""):this.media.removeAttribute("controls")},build:function(){var e=this;if(this.listeners.media(),!this.supported.ui)return this.debug.warn("Basic support only for ".concat(this.provider," ").concat(this.type)),void Fe.toggleNativeControls.call(this,!0);N.element(this.elements.controls)||(Ae.inject.call(this),this.listeners.controls()),Fe.toggleNativeControls.call(this),this.isHTML5&&Pe.setup.call(this),this.volume=null,this.muted=null,this.loop=null,this.quality=null,this.speed=null,Ae.updateVolume.call(this),Ae.timeUpdate.call(this),Fe.checkPlaying.call(this),X(this.elements.container,this.config.classNames.pip.supported,ie.pip&&this.isHTML5&&this.isVideo),X(this.elements.container,this.config.classNames.airplay.supported,ie.airplay&&this.isHTML5),X(this.elements.container,this.config.classNames.isIos,L.isIos),X(this.elements.container,this.config.classNames.isTouch,this.touch),this.ready=!0,setTimeout(function(){H.call(e,e.media,"ready")},0),Fe.setTitle.call(this),this.poster&&Fe.setPoster.call(this,this.poster,!1).catch(function(){}),this.config.duration&&Ae.durationUpdate.call(this)},setTitle:function(){var e=ge("play",this.config);if(N.string(this.config.title)&&!N.empty(this.config.title)&&(e+=", ".concat(this.config.title)),Array.from(this.elements.buttons.play||[]).forEach(function(t){t.setAttribute("aria-label",e)}),this.isEmbed){var t=Z.call(this,"iframe");if(!N.element(t))return;var n=N.empty(this.config.title)?"video":this.config.title,i=ge("frameTitle",this.config);t.setAttribute("title",i.replace("{title}",n))}},togglePoster:function(e){X(this.elements.container,this.config.classNames.posterEnabled,e)},setPoster:function(e){var t=this;return arguments.length>1&&void 0!==arguments[1]&&!arguments[1]||!this.poster?(this.media.setAttribute("poster",e),function(){var e=this;return new Promise(function(t){return e.ready?setTimeout(t,0):O.call(e,e.elements.container,"ready",t)}).then(function(){})}.call(this).then(function(){return De(e)}).catch(function(n){throw e===t.poster&&Fe.togglePoster.call(t,!1),n}).then(function(){if(e!==t.poster)throw new Error("setPoster cancelled by later call to setPoster")}).then(function(){return Object.assign(t.elements.poster.style,{backgroundImage:"url('".concat(e,"')"),backgroundSize:""}),Fe.togglePoster.call(t,!0),e})):Promise.reject(new Error("Poster already set"))},checkPlaying:function(e){var t=this;X(this.elements.container,this.config.classNames.playing,this.playing),X(this.elements.container,this.config.classNames.paused,this.paused),X(this.elements.container,this.config.classNames.stopped,this.stopped),Array.from(this.elements.buttons.play||[]).forEach(function(e){Object.assign(e,{pressed:t.playing})}),N.event(e)&&"timeupdate"===e.type||Fe.toggleControls.call(this)},checkLoading:function(e){var t=this;this.loading=["stalled","waiting"].includes(e.type),clearTimeout(this.timers.loading),this.timers.loading=setTimeout(function(){X(t.elements.container,t.config.classNames.loading,t.loading),Fe.toggleControls.call(t)},this.loading?250:0)},toggleControls:function(e){var t=this.elements.controls;if(t&&this.config.hideControls){var n=this.touch&&this.lastSeekTime+2e3>Date.now();this.toggleControls(Boolean(e||this.loading||this.paused||t.pressed||t.hover||n))}}},Re=function(){function t(n){e(this,t),this.player=n,this.lastKey=null,this.focusTimer=null,this.lastKeyDown=null,this.handleKey=this.handleKey.bind(this),this.toggleMenu=this.toggleMenu.bind(this),this.setTabFocus=this.setTabFocus.bind(this),this.firstTouch=this.firstTouch.bind(this)}return n(t,[{key:"handleKey",value:function(e){var t=this.player,n=t.elements,i=e.keyCode?e.keyCode:e.which,a="keydown"===e.type,s=a&&i===this.lastKey;if(!(e.altKey||e.ctrlKey||e.metaKey||e.shiftKey)&&N.number(i)){if(a){var r=document.activeElement;if(N.element(r)){var o=t.config.selectors.editable;if(r!==n.inputs.seek&&$(r,o))return;if(32===e.which&&$(r,'button, [role^="menuitem"]'))return}switch([32,37,38,39,40,48,49,50,51,52,53,54,56,57,67,70,73,75,76,77,79].includes(i)&&(e.preventDefault(),e.stopPropagation()),i){case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:s||(t.currentTime=t.duration/10*(i-48));break;case 32:case 75:s||t.togglePlay();break;case 38:t.increaseVolume(.1);break;case 40:t.decreaseVolume(.1);break;case 77:s||(t.muted=!t.muted);break;case 39:t.forward();break;case 37:t.rewind();break;case 70:t.fullscreen.toggle();break;case 67:s||t.toggleCaptions();break;case 76:t.loop=!t.loop}27===i&&!t.fullscreen.usingNative&&t.fullscreen.active&&t.fullscreen.toggle(),this.lastKey=i}else this.lastKey=null}}},{key:"toggleMenu",value:function(e){Ae.toggleMenu.call(this.player,e)}},{key:"firstTouch",value:function(){var e=this.player,t=e.elements;e.touch=!0,X(t.container,e.config.classNames.isTouch,!0)}},{key:"setTabFocus",value:function(e){var t=this.player,n=t.elements;if(clearTimeout(this.focusTimer),"keydown"!==e.type||9===e.which){"keydown"===e.type&&(this.lastKeyDown=e.timeStamp);var i,a=e.timeStamp-this.lastKeyDown<=20;if("focus"!==e.type||a)i=t.config.classNames.tabFocus,X(G.call(t,".".concat(i)),i,!1),this.focusTimer=setTimeout(function(){var e=document.activeElement;n.container.contains(e)&&X(document.activeElement,t.config.classNames.tabFocus,!0)},10)}}},{key:"global",value:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],t=this.player;t.config.keyboard.global&&_.call(t,window,"keydown keyup",this.handleKey,e,!1),_.call(t,document.body,"click",this.toggleMenu,e),q.call(t,document.body,"touchstart",this.firstTouch),_.call(t,document.body,"keydown focus blur",this.setTabFocus,e,!1,!0)}},{key:"container",value:function(){var e=this.player,t=e.config,n=e.elements,i=e.timers;!t.keyboard.global&&t.keyboard.focused&&O.call(e,n.container,"keydown keyup",this.handleKey,!1),O.call(e,n.container,"mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen",function(t){var a=n.controls;a&&"enterfullscreen"===t.type&&(a.pressed=!1,a.hover=!1);var s=0;["touchstart","touchmove","mousemove"].includes(t.type)&&(Fe.toggleControls.call(e,!0),s=e.touch?3e3:2e3),clearTimeout(i.controls),i.controls=setTimeout(function(){return Fe.toggleControls.call(e,!1)},s)});var s=function(t){if(!t)return oe.call(e);var i=n.container.getBoundingClientRect(),a=i.width,s=i.height;return oe.call(e,"".concat(a,":").concat(s))},r=function(){clearTimeout(i.resized),i.resized=setTimeout(s,50)};O.call(e,n.container,"enterfullscreen exitfullscreen",function(t){var i=e.fullscreen,o=i.target,l=i.usingNative;if(o===n.container&&(e.isEmbed||!N.empty(e.config.ratio))){var c="enterfullscreen"===t.type,u=s(c);u.padding;!function(t,n,i){if(e.isVimeo){var s=e.elements.wrapper.firstChild,r=a(t,2)[1],o=a(re.call(e),2),l=o[0],c=o[1];s.style.maxWidth=i?"".concat(r/c*l,"px"):null,s.style.margin=i?"0 auto":null}}(u.ratio,0,c),l||(c?O.call(e,window,"resize",r):j.call(e,window,"resize",r))}})}},{key:"media",value:function(){var e=this,t=this.player,n=t.elements;if(O.call(t,t.media,"timeupdate seeking seeked",function(e){return Ae.timeUpdate.call(t,e)}),O.call(t,t.media,"durationchange loadeddata loadedmetadata",function(e){return Ae.durationUpdate.call(t,e)}),O.call(t,t.media,"canplay loadeddata",function(){Q(n.volume,!t.hasAudio),Q(n.buttons.mute,!t.hasAudio)}),O.call(t,t.media,"ended",function(){t.isHTML5&&t.isVideo&&t.config.resetOnEnd&&t.restart()}),O.call(t,t.media,"progress playing seeking seeked",function(e){return Ae.updateProgress.call(t,e)}),O.call(t,t.media,"volumechange",function(e){return Ae.updateVolume.call(t,e)}),O.call(t,t.media,"playing play pause ended emptied timeupdate",function(e){return Fe.checkPlaying.call(t,e)}),O.call(t,t.media,"waiting canplay seeked playing",function(e){return Fe.checkLoading.call(t,e)}),t.supported.ui&&t.config.clickToPlay&&!t.isAudio){var i=Z.call(t,".".concat(t.config.classNames.video));if(!N.element(i))return;O.call(t,n.container,"click",function(a){([n.container,i].includes(a.target)||i.contains(a.target))&&(t.touch&&t.config.hideControls||(t.ended?(e.proxy(a,t.restart,"restart"),e.proxy(a,t.play,"play")):e.proxy(a,t.togglePlay,"play")))})}t.supported.ui&&t.config.disableContextMenu&&O.call(t,n.wrapper,"contextmenu",function(e){e.preventDefault()},!1),O.call(t,t.media,"volumechange",function(){t.storage.set({volume:t.volume,muted:t.muted})}),O.call(t,t.media,"ratechange",function(){Ae.updateSetting.call(t,"speed"),t.storage.set({speed:t.speed})}),O.call(t,t.media,"qualitychange",function(e){Ae.updateSetting.call(t,"quality",null,e.detail.quality)}),O.call(t,t.media,"ready qualitychange",function(){Ae.setDownloadUrl.call(t)});var a=t.config.events.concat(["keyup","keydown"]).join(" ");O.call(t,t.media,a,function(e){var i=e.detail,a=void 0===i?{}:i;"error"===e.type&&(a=t.media.error),H.call(t,n.container,e.type,!0,a)})}},{key:"proxy",value:function(e,t,n){var i=this.player,a=i.config.listeners[n],s=!0;N.function(a)&&(s=a.call(i,e)),s&&N.function(t)&&t.call(i,e)}},{key:"bind",value:function(e,t,n,i){var a=this,s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],r=this.player,o=r.config.listeners[i],l=N.function(o);O.call(r,e,t,function(e){return a.proxy(e,n,i)},s&&!l)}},{key:"controls",value:function(){var e=this,t=this.player,n=t.elements,i=L.isIE?"change":"input";if(n.buttons.play&&Array.from(n.buttons.play).forEach(function(n){e.bind(n,"click",t.togglePlay,"play")}),this.bind(n.buttons.restart,"click",t.restart,"restart"),this.bind(n.buttons.rewind,"click",t.rewind,"rewind"),this.bind(n.buttons.fastForward,"click",t.forward,"fastForward"),this.bind(n.buttons.mute,"click",function(){t.muted=!t.muted},"mute"),this.bind(n.buttons.captions,"click",function(){return t.toggleCaptions()}),this.bind(n.buttons.download,"click",function(){H.call(t,t.media,"download")},"download"),this.bind(n.buttons.fullscreen,"click",function(){t.fullscreen.toggle()},"fullscreen"),this.bind(n.buttons.pip,"click",function(){t.pip="toggle"},"pip"),this.bind(n.buttons.airplay,"click",t.airplay,"airplay"),this.bind(n.buttons.settings,"click",function(e){e.stopPropagation(),Ae.toggleMenu.call(t,e)}),this.bind(n.buttons.settings,"keyup",function(e){var n=e.which;[13,32].includes(n)&&(13!==n?(e.preventDefault(),e.stopPropagation(),Ae.toggleMenu.call(t,e)):Ae.focusFirstMenuItem.call(t,null,!0))},null,!1),this.bind(n.settings.menu,"keydown",function(e){27===e.which&&Ae.toggleMenu.call(t,e)}),this.bind(n.inputs.seek,"mousedown mousemove",function(e){var t=n.progress.getBoundingClientRect(),i=100/t.width*(e.pageX-t.left);e.currentTarget.setAttribute("seek-value",i)}),this.bind(n.inputs.seek,"mousedown mouseup keydown keyup touchstart touchend",function(e){var n=e.currentTarget,i=e.keyCode?e.keyCode:e.which;if(!N.keyboardEvent(e)||39===i||37===i){t.lastSeekTime=Date.now();var a=n.hasAttribute("play-on-seeked"),s=["mouseup","touchend","keyup"].includes(e.type);a&&s?(n.removeAttribute("play-on-seeked"),t.play()):!s&&t.playing&&(n.setAttribute("play-on-seeked",""),t.pause())}}),L.isIos){var s=G.call(t,'input[type="range"]');Array.from(s).forEach(function(t){return e.bind(t,i,function(e){return x(e.target)})})}this.bind(n.inputs.seek,i,function(e){var n=e.currentTarget,i=n.getAttribute("seek-value");N.empty(i)&&(i=n.value),n.removeAttribute("seek-value"),t.currentTime=i/n.max*t.duration},"seek"),this.bind(n.progress,"mouseenter mouseleave mousemove",function(e){return Ae.updateSeekTooltip.call(t,e)}),this.bind(n.progress,"mousemove touchmove",function(e){var n=t.previewThumbnails;n&&n.loaded&&n.startMove(e)}),this.bind(n.progress,"mouseleave click",function(){var e=t.previewThumbnails;e&&e.loaded&&e.endMove(!1,!0)}),this.bind(n.progress,"mousedown touchstart",function(e){var n=t.previewThumbnails;n&&n.loaded&&n.startScrubbing(e)}),this.bind(n.progress,"mouseup touchend",function(e){var n=t.previewThumbnails;n&&n.loaded&&n.endScrubbing(e)}),L.isWebkit&&Array.from(G.call(t,'input[type="range"]')).forEach(function(n){e.bind(n,"input",function(e){return Ae.updateRangeFill.call(t,e.target)})}),t.config.toggleInvert&&!N.element(n.display.duration)&&this.bind(n.display.currentTime,"click",function(){0!==t.currentTime&&(t.config.invertTime=!t.config.invertTime,Ae.timeUpdate.call(t))}),this.bind(n.inputs.volume,i,function(e){t.volume=e.target.value},"volume"),this.bind(n.controls,"mouseenter mouseleave",function(e){n.controls.hover=!t.touch&&"mouseenter"===e.type}),this.bind(n.controls,"mousedown mouseup touchstart touchend touchcancel",function(e){n.controls.pressed=["mousedown","touchstart"].includes(e.type)}),this.bind(n.controls,"focusin",function(){var i=t.config,a=t.timers;X(n.controls,i.classNames.noTransition,!0),Fe.toggleControls.call(t,!0),setTimeout(function(){X(n.controls,i.classNames.noTransition,!1)},0);var s=e.touch?3e3:4e3;clearTimeout(a.controls),a.controls=setTimeout(function(){return Fe.toggleControls.call(t,!1)},s)}),this.bind(n.inputs.volume,"wheel",function(e){var n=e.webkitDirectionInvertedFromDevice,i=a([e.deltaX,-e.deltaY].map(function(e){return n?-e:e}),2),s=i[0],r=i[1],o=Math.sign(Math.abs(s)>Math.abs(r)?s:r);t.increaseVolume(o/50);var l=t.media.volume;(1===o&&l<1||-1===o&&l>0)&&e.preventDefault()},"volume",!1)}}]),t}();"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self&&self;var Ve=function(e,t){return e(t={exports:{}},t.exports),t.exports}(function(e,t){e.exports=function(){var e=function(){},t={},n={},i={};function a(e,t){if(e){var a=i[e];if(n[e]=t,a)for(;a.length;)a[0](e,t),a.splice(0,1)}}function s(t,n){t.call&&(t={success:t}),n.length?(t.error||e)(n):(t.success||e)(t)}function r(t,n,i,a){var s,o,l=document,c=i.async,u=(i.numRetries||0)+1,d=i.before||e,h=t.replace(/^(css|img)!/,"");a=a||0,/(^css!|\.css$)/.test(t)?((o=l.createElement("link")).rel="stylesheet",o.href=h,(s="hideFocus"in o)&&o.relList&&(s=0,o.rel="preload",o.as="style")):/(^img!|\.(png|gif|jpg|svg)$)/.test(t)?(o=l.createElement("img")).src=h:((o=l.createElement("script")).src=t,o.async=void 0===c||c),o.onload=o.onerror=o.onbeforeload=function(e){var l=e.type[0];if(s)try{o.sheet.cssText.length||(l="e")}catch(e){18!=e.code&&(l="e")}if("e"==l){if((a+=1)<u)return r(t,n,i,a)}else if("preload"==o.rel&&"style"==o.as)return o.rel="stylesheet";n(t,l,e.defaultPrevented)},!1!==d(t,o)&&l.head.appendChild(o)}function o(e,n,i){var o,l;if(n&&n.trim&&(o=n),l=(o?i:n)||{},o){if(o in t)throw"LoadJS";t[o]=!0}function c(t,n){!function(e,t,n){var i,a,s=(e=e.push?e:[e]).length,o=s,l=[];for(i=function(e,n,i){if("e"==n&&l.push(e),"b"==n){if(!i)return;l.push(e)}--s||t(l)},a=0;a<o;a++)r(e[a],i,n)}(e,function(e){s(l,e),t&&s({success:t,error:n},e),a(o,e)},l)}if(l.returnPromise)return new Promise(c);c()}return o.ready=function(e,t){return function(e,t){e=e.push?e:[e];var a,s,r,o=[],l=e.length,c=l;for(a=function(e,n){n.length&&o.push(e),--c||t(o)};l--;)s=e[l],(r=n[s])?a(s,r):(i[s]=i[s]||[]).push(a)}(e,function(e){s(t,e)}),o},o.done=function(e){a(e,[])},o.reset=function(){t={},n={},i={}},o.isDefined=function(e){return e in t},o}()});function Be(e){return new Promise(function(t,n){Ve(e,{success:t,error:n})})}function Ue(e){e&&!this.embed.hasPlayed&&(this.embed.hasPlayed=!0),this.media.paused===e&&(this.media.paused=!e,H.call(this,this.media,e?"play":"pause"))}var We={setup:function(){var e=this;X(this.elements.wrapper,this.config.classNames.embed,!0),oe.call(this),N.object(window.Vimeo)?We.ready.call(this):Be(this.config.urls.vimeo.sdk).then(function(){We.ready.call(e)}).catch(function(t){e.debug.warn("Vimeo SDK (player.js) failed to load",t)})},ready:function(){var e=this,t=this,n=t.config.vimeo,i=Se(F({},{loop:t.config.loop.active,autoplay:t.autoplay,muted:t.muted,gesture:"media",playsinline:!this.config.fullscreen.iosNative},n)),s=t.media.getAttribute("src");N.empty(s)&&(s=t.media.getAttribute(t.config.attributes.embed.id));var r,o=(r=s,N.empty(r)?null:N.number(Number(r))?r:r.match(/^.*(vimeo.com\/|video\/)(\d+).*/)?RegExp.$2:r),l=B("iframe"),c=ue(t.config.urls.vimeo.iframe,o,i);l.setAttribute("src",c),l.setAttribute("allowfullscreen",""),l.setAttribute("allowtransparency",""),l.setAttribute("allow","autoplay");var u=B("div",{poster:t.poster,class:t.config.classNames.embedContainer});u.appendChild(l),t.media=K(u,t.media),ve(ue(t.config.urls.vimeo.api,o),"json").then(function(e){if(!N.empty(e)){var n=new URL(e[0].thumbnail_large);n.pathname="".concat(n.pathname.split("_")[0],".jpg"),Fe.setPoster.call(t,n.href).catch(function(){})}}),t.embed=new window.Vimeo.Player(l,{autopause:t.config.autopause,muted:t.muted}),t.media.paused=!0,t.media.currentTime=0,t.supported.ui&&t.embed.disableTextTrack(),t.media.play=function(){return Ue.call(t,!0),t.embed.play()},t.media.pause=function(){return Ue.call(t,!1),t.embed.pause()},t.media.stop=function(){t.pause(),t.currentTime=0};var d=t.media.currentTime;Object.defineProperty(t.media,"currentTime",{get:function(){return d},set:function(e){var n=t.embed,i=t.media,a=t.paused,s=t.volume,r=a&&!n.hasPlayed;i.seeking=!0,H.call(t,i,"seeking"),Promise.resolve(r&&n.setVolume(0)).then(function(){return n.setCurrentTime(e)}).then(function(){return r&&n.pause()}).then(function(){return r&&n.setVolume(s)}).catch(function(){})}});var h=t.config.speed.selected;Object.defineProperty(t.media,"playbackRate",{get:function(){return h},set:function(e){t.embed.setPlaybackRate(e).then(function(){h=e,H.call(t,t.media,"ratechange")}).catch(function(e){"Error"===e.name&&Ae.setSpeedMenu.call(t,[])})}});var m=t.config.volume;Object.defineProperty(t.media,"volume",{get:function(){return m},set:function(e){t.embed.setVolume(e).then(function(){m=e,H.call(t,t.media,"volumechange")})}});var p=t.config.muted;Object.defineProperty(t.media,"muted",{get:function(){return p},set:function(e){var n=!!N.boolean(e)&&e;t.embed.setVolume(n?0:t.config.volume).then(function(){p=n,H.call(t,t.media,"volumechange")})}});var f,g=t.config.loop;Object.defineProperty(t.media,"loop",{get:function(){return g},set:function(e){var n=N.boolean(e)?e:t.config.loop.active;t.embed.setLoop(n).then(function(){g=n})}}),t.embed.getVideoUrl().then(function(e){f=e,Ae.setDownloadUrl.call(t)}).catch(function(t){e.debug.warn(t)}),Object.defineProperty(t.media,"currentSrc",{get:function(){return f}}),Object.defineProperty(t.media,"ended",{get:function(){return t.currentTime===t.duration}}),Promise.all([t.embed.getVideoWidth(),t.embed.getVideoHeight()]).then(function(n){var i=a(n,2),s=i[0],r=i[1];t.embed.ratio=[s,r],oe.call(e)}),t.embed.setAutopause(t.config.autopause).then(function(e){t.config.autopause=e}),t.embed.getVideoTitle().then(function(n){t.config.title=n,Fe.setTitle.call(e)}),t.embed.getCurrentTime().then(function(e){d=e,H.call(t,t.media,"timeupdate")}),t.embed.getDuration().then(function(e){t.media.duration=e,H.call(t,t.media,"durationchange")}),t.embed.getTextTracks().then(function(e){t.media.textTracks=e,Pe.setup.call(t)}),t.embed.on("cuechange",function(e){var n=e.cues,i=(void 0===n?[]:n).map(function(e){return function(e){var t=document.createDocumentFragment(),n=document.createElement("div");return t.appendChild(n),n.innerHTML=e,t.firstChild.innerText}(e.text)});Pe.updateCues.call(t,i)}),t.embed.on("loaded",function(){(t.embed.getPaused().then(function(e){Ue.call(t,!e),e||H.call(t,t.media,"playing")}),N.element(t.embed.element)&&t.supported.ui)&&t.embed.element.setAttribute("tabindex",-1)}),t.embed.on("play",function(){Ue.call(t,!0),H.call(t,t.media,"playing")}),t.embed.on("pause",function(){Ue.call(t,!1)}),t.embed.on("timeupdate",function(e){t.media.seeking=!1,d=e.seconds,H.call(t,t.media,"timeupdate")}),t.embed.on("progress",function(e){t.media.buffered=e.percent,H.call(t,t.media,"progress"),1===parseInt(e.percent,10)&&H.call(t,t.media,"canplaythrough"),t.embed.getDuration().then(function(e){e!==t.media.duration&&(t.media.duration=e,H.call(t,t.media,"durationchange"))})}),t.embed.on("seeked",function(){t.media.seeking=!1,H.call(t,t.media,"seeked")}),t.embed.on("ended",function(){t.media.paused=!0,H.call(t,t.media,"ended")}),t.embed.on("error",function(e){t.media.error=e,H.call(t,t.media,"error")}),setTimeout(function(){return Fe.build.call(t)},0)}};function ze(e){e&&!this.embed.hasPlayed&&(this.embed.hasPlayed=!0),this.media.paused===e&&(this.media.paused=!e,H.call(this,this.media,e?"play":"pause"))}function Ke(e){return e.noCookie?"https://www.youtube-nocookie.com":"http:"===window.location.protocol?"http://www.youtube.com":void 0}var Ye={setup:function(){var e=this;if(X(this.elements.wrapper,this.config.classNames.embed,!0),N.object(window.YT)&&N.function(window.YT.Player))Ye.ready.call(this);else{var t=window.onYouTubeIframeAPIReady;window.onYouTubeIframeAPIReady=function(){N.function(t)&&t(),Ye.ready.call(e)},Be(this.config.urls.youtube.sdk).catch(function(t){e.debug.warn("YouTube API failed to load",t)})}},getTitle:function(e){var t=this;ve(ue(this.config.urls.youtube.api,e)).then(function(e){if(N.object(e)){var n=e.title,i=e.height,a=e.width;t.config.title=n,Fe.setTitle.call(t),t.embed.ratio=[a,i]}oe.call(t)}).catch(function(){oe.call(t)})},ready:function(){var e=this,t=e.media&&e.media.getAttribute("id");if(N.empty(t)||!t.startsWith("youtube-")){var n=e.media.getAttribute("src");N.empty(n)&&(n=e.media.getAttribute(this.config.attributes.embed.id));var i,a,s=(i=n,N.empty(i)?null:i.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/)?RegExp.$2:i),r=(a=e.provider,"".concat(a,"-").concat(Math.floor(1e4*Math.random()))),o=B("div",{id:r,poster:e.poster});e.media=K(o,e.media);var l=function(e){return"https://i.ytimg.com/vi/".concat(s,"/").concat(e,"default.jpg")};De(l("maxres"),121).catch(function(){return De(l("sd"),121)}).catch(function(){return De(l("hq"))}).then(function(t){return Fe.setPoster.call(e,t.src)}).then(function(t){t.includes("maxres")||(e.elements.poster.style.backgroundSize="cover")}).catch(function(){});var c=e.config.youtube;e.embed=new window.YT.Player(r,{videoId:s,host:Ke(c),playerVars:F({},{autoplay:e.config.autoplay?1:0,hl:e.config.hl,controls:e.supported.ui?0:1,disablekb:1,playsinline:e.config.fullscreen.iosNative?0:1,cc_load_policy:e.captions.active?1:0,cc_lang_pref:e.config.captions.language,widget_referrer:window?window.location.href:null},c),events:{onError:function(t){if(!e.media.error){var n=t.data,i={2:"The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",5:"The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",100:"The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",101:"The owner of the requested video does not allow it to be played in embedded players.",150:"The owner of the requested video does not allow it to be played in embedded players."}[n]||"An unknown error occured";e.media.error={code:n,message:i},H.call(e,e.media,"error")}},onPlaybackRateChange:function(t){var n=t.target;e.media.playbackRate=n.getPlaybackRate(),H.call(e,e.media,"ratechange")},onReady:function(t){if(!N.function(e.media.play)){var n=t.target;Ye.getTitle.call(e,s),e.media.play=function(){ze.call(e,!0),n.playVideo()},e.media.pause=function(){ze.call(e,!1),n.pauseVideo()},e.media.stop=function(){n.stopVideo()},e.media.duration=n.getDuration(),e.media.paused=!0,e.media.currentTime=0,Object.defineProperty(e.media,"currentTime",{get:function(){return Number(n.getCurrentTime())},set:function(t){e.paused&&!e.embed.hasPlayed&&e.embed.mute(),e.media.seeking=!0,H.call(e,e.media,"seeking"),n.seekTo(t)}}),Object.defineProperty(e.media,"playbackRate",{get:function(){return n.getPlaybackRate()},set:function(e){n.setPlaybackRate(e)}});var i=e.config.volume;Object.defineProperty(e.media,"volume",{get:function(){return i},set:function(t){i=t,n.setVolume(100*i),H.call(e,e.media,"volumechange")}});var a=e.config.muted;Object.defineProperty(e.media,"muted",{get:function(){return a},set:function(t){var i=N.boolean(t)?t:a;a=i,n[i?"mute":"unMute"](),H.call(e,e.media,"volumechange")}}),Object.defineProperty(e.media,"currentSrc",{get:function(){return n.getVideoUrl()}}),Object.defineProperty(e.media,"ended",{get:function(){return e.currentTime===e.duration}}),e.options.speed=n.getAvailablePlaybackRates(),e.supported.ui&&e.media.setAttribute("tabindex",-1),H.call(e,e.media,"timeupdate"),H.call(e,e.media,"durationchange"),clearInterval(e.timers.buffering),e.timers.buffering=setInterval(function(){e.media.buffered=n.getVideoLoadedFraction(),(null===e.media.lastBuffered||e.media.lastBuffered<e.media.buffered)&&H.call(e,e.media,"progress"),e.media.lastBuffered=e.media.buffered,1===e.media.buffered&&(clearInterval(e.timers.buffering),H.call(e,e.media,"canplaythrough"))},200),setTimeout(function(){return Fe.build.call(e)},50)}},onStateChange:function(t){var n=t.target;switch(clearInterval(e.timers.playing),e.media.seeking&&[1,2].includes(t.data)&&(e.media.seeking=!1,H.call(e,e.media,"seeked")),t.data){case-1:H.call(e,e.media,"timeupdate"),e.media.buffered=n.getVideoLoadedFraction(),H.call(e,e.media,"progress");break;case 0:ze.call(e,!1),e.media.loop?(n.stopVideo(),n.playVideo()):H.call(e,e.media,"ended");break;case 1:e.config.autoplay||!e.media.paused||e.embed.hasPlayed?(ze.call(e,!0),H.call(e,e.media,"playing"),e.timers.playing=setInterval(function(){H.call(e,e.media,"timeupdate")},50),e.media.duration!==n.getDuration()&&(e.media.duration=n.getDuration(),H.call(e,e.media,"durationchange"))):e.media.pause();break;case 2:e.muted||e.embed.unMute(),ze.call(e,!1)}H.call(e,e.elements.container,"statechange",!1,{code:t.data})}}})}}},Qe={setup:function(){this.media?(X(this.elements.container,this.config.classNames.type.replace("{0}",this.type),!0),X(this.elements.container,this.config.classNames.provider.replace("{0}",this.provider),!0),this.isEmbed&&X(this.elements.container,this.config.classNames.type.replace("{0}","video"),!0),this.isVideo&&(this.elements.wrapper=B("div",{class:this.config.classNames.video}),R(this.media,this.elements.wrapper),this.elements.poster=B("div",{class:this.config.classNames.poster}),this.elements.wrapper.appendChild(this.elements.poster)),this.isHTML5?le.extend.call(this):this.isYouTube?Ye.setup.call(this):this.isVimeo&&We.setup.call(this)):this.debug.warn("No media element found!")}},Xe=function(){function t(n){var i=this;e(this,t),this.player=n,this.config=n.config.ads,this.playing=!1,this.initialized=!1,this.elements={container:null,displayContainer:null},this.manager=null,this.loader=null,this.cuePoints=null,this.events={},this.safetyTimer=null,this.countdownTimer=null,this.managerPromise=new Promise(function(e,t){i.on("loaded",e),i.on("error",t)}),this.load()}return n(t,[{key:"load",value:function(){var e=this;this.enabled&&(N.object(window.google)&&N.object(window.google.ima)?this.ready():Be(this.player.config.urls.googleIMA.sdk).then(function(){e.ready()}).catch(function(){e.trigger("error",new Error("Google IMA SDK failed to load"))}))}},{key:"ready",value:function(){var e,t=this;this.enabled||((e=this).manager&&e.manager.destroy(),e.elements.displayContainer&&e.elements.displayContainer.destroy(),e.elements.container.remove()),this.startSafetyTimer(12e3,"ready()"),this.managerPromise.then(function(){t.clearSafetyTimer("onAdsManagerLoaded()")}),this.listeners(),this.setupIMA()}},{key:"setupIMA",value:function(){this.elements.container=B("div",{class:this.player.config.classNames.ads}),this.player.elements.container.appendChild(this.elements.container),google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED),google.ima.settings.setLocale(this.player.config.ads.language),google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline),this.elements.displayContainer=new google.ima.AdDisplayContainer(this.elements.container,this.player.media),this.requestAds()}},{key:"requestAds",value:function(){var e=this,t=this.player.elements.container;try{this.loader=new google.ima.AdsLoader(this.elements.displayContainer),this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,function(t){return e.onAdsManagerLoaded(t)},!1),this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR,function(t){return e.onAdError(t)},!1);var n=new google.ima.AdsRequest;n.adTagUrl=this.tagUrl,n.linearAdSlotWidth=t.offsetWidth,n.linearAdSlotHeight=t.offsetHeight,n.nonLinearAdSlotWidth=t.offsetWidth,n.nonLinearAdSlotHeight=t.offsetHeight,n.forceNonLinearFullSlot=!1,n.setAdWillPlayMuted(!this.player.muted),this.loader.requestAds(n)}catch(e){this.onAdError(e)}}},{key:"pollCountdown",value:function(){var e=this;if(!(arguments.length>0&&void 0!==arguments[0]&&arguments[0]))return clearInterval(this.countdownTimer),void this.elements.container.removeAttribute("data-badge-text");this.countdownTimer=setInterval(function(){var t=Ce(Math.max(e.manager.getRemainingTime(),0)),n="".concat(ge("advertisement",e.player.config)," - ").concat(t);e.elements.container.setAttribute("data-badge-text",n)},100)}},{key:"onAdsManagerLoaded",value:function(e){var t=this;if(this.enabled){var n=new google.ima.AdsRenderingSettings;n.restoreCustomPlaybackStateOnAdBreakComplete=!0,n.enablePreloading=!0,this.manager=e.getAdsManager(this.player,n),this.cuePoints=this.manager.getCuePoints(),this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR,function(e){return t.onAdError(e)}),Object.keys(google.ima.AdEvent.Type).forEach(function(e){t.manager.addEventListener(google.ima.AdEvent.Type[e],function(e){return t.onAdEvent(e)})}),this.trigger("loaded")}}},{key:"addCuePoints",value:function(){var e=this;N.empty(this.cuePoints)||this.cuePoints.forEach(function(t){if(0!==t&&-1!==t&&t<e.player.duration){var n=e.player.elements.progress;if(N.element(n)){var i=100/e.player.duration*t,a=B("span",{class:e.player.config.classNames.cues});a.style.left="".concat(i.toString(),"%"),n.appendChild(a)}}})}},{key:"onAdEvent",value:function(e){var t=this,n=this.player.elements.container,i=e.getAd(),a=e.getAdData();switch(function(e){H.call(t.player,t.player.media,"ads".concat(e.replace(/_/g,"").toLowerCase()))}(e.type),e.type){case google.ima.AdEvent.Type.LOADED:this.trigger("loaded"),this.pollCountdown(!0),i.isLinear()||(i.width=n.offsetWidth,i.height=n.offsetHeight);break;case google.ima.AdEvent.Type.STARTED:this.manager.setVolume(this.player.volume);break;case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:this.loadAds();break;case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:this.pauseContent();break;case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:this.pollCountdown(),this.resumeContent();break;case google.ima.AdEvent.Type.LOG:a.adError&&this.player.debug.warn("Non-fatal ad error: ".concat(a.adError.getMessage()))}}},{key:"onAdError",value:function(e){this.cancel(),this.player.debug.warn("Ads error",e)}},{key:"listeners",value:function(){var e,t=this,n=this.player.elements.container;this.player.on("canplay",function(){t.addCuePoints()}),this.player.on("ended",function(){t.loader.contentComplete()}),this.player.on("timeupdate",function(){e=t.player.currentTime}),this.player.on("seeked",function(){var n=t.player.currentTime;N.empty(t.cuePoints)||t.cuePoints.forEach(function(i,a){e<i&&i<n&&(t.manager.discardAdBreak(),t.cuePoints.splice(a,1))})}),window.addEventListener("resize",function(){t.manager&&t.manager.resize(n.offsetWidth,n.offsetHeight,google.ima.ViewMode.NORMAL)})}},{key:"play",value:function(){var e=this,t=this.player.elements.container;this.managerPromise||this.resumeContent(),this.managerPromise.then(function(){e.manager.setVolume(e.player.volume),e.elements.displayContainer.initialize();try{e.initialized||(e.manager.init(t.offsetWidth,t.offsetHeight,google.ima.ViewMode.NORMAL),e.manager.start()),e.initialized=!0}catch(t){e.onAdError(t)}}).catch(function(){})}},{key:"resumeContent",value:function(){this.elements.container.style.zIndex="",this.playing=!1,this.player.media.play()}},{key:"pauseContent",value:function(){this.elements.container.style.zIndex=3,this.playing=!0,this.player.media.pause()}},{key:"cancel",value:function(){this.initialized&&this.resumeContent(),this.trigger("error"),this.loadAds()}},{key:"loadAds",value:function(){var e=this;this.managerPromise.then(function(){e.manager&&e.manager.destroy(),e.managerPromise=new Promise(function(t){e.on("loaded",t),e.player.debug.log(e.manager)}),e.requestAds()}).catch(function(){})}},{key:"trigger",value:function(e){for(var t=this,n=arguments.length,i=new Array(n>1?n-1:0),a=1;a<n;a++)i[a-1]=arguments[a];var s=this.events[e];N.array(s)&&s.forEach(function(e){N.function(e)&&e.apply(t,i)})}},{key:"on",value:function(e,t){return N.array(this.events[e])||(this.events[e]=[]),this.events[e].push(t),this}},{key:"startSafetyTimer",value:function(e,t){var n=this;this.player.debug.log("Safety timer invoked from: ".concat(t)),this.safetyTimer=setTimeout(function(){n.cancel(),n.clearSafetyTimer("startSafetyTimer()")},e)}},{key:"clearSafetyTimer",value:function(e){N.nullOrUndefined(this.safetyTimer)||(this.player.debug.log("Safety timer cleared from: ".concat(e)),clearTimeout(this.safetyTimer),this.safetyTimer=null)}},{key:"enabled",get:function(){var e=this.config;return this.player.isHTML5&&this.player.isVideo&&e.enabled&&(!N.empty(e.publisherId)||N.url(e.tagUrl))}},{key:"tagUrl",get:function(){var e=this.config;if(N.url(e.tagUrl))return e.tagUrl;var t={AV_PUBLISHERID:"58c25bb0073ef448b1087ad6",AV_CHANNELID:"5a0458dc28a06145e4519d21",AV_URL:window.location.hostname,cb:Date.now(),AV_WIDTH:640,AV_HEIGHT:480,AV_CDIM2:this.publisherId};return"".concat("https://go.aniview.com/api/adserver6/vast/","?").concat(Se(t))}}]),t}(),Je=function(){function t(n){e(this,t),this.player=n,this.thumbnails=[],this.loaded=!1,this.lastMouseMoveTime=Date.now(),this.mouseDown=!1,this.loadedImages=[],this.elements={thumb:{},scrubbing:{}},this.load()}return n(t,[{key:"load",value:function(){var e=this;this.player.elements.display.seekTooltip&&(this.player.elements.display.seekTooltip.hidden=this.enabled),this.enabled&&this.getThumbnails().then(function(){e.enabled&&(e.render(),e.determineContainerAutoSizing(),e.loaded=!0)})}},{key:"getThumbnails",value:function(){var e=this;return new Promise(function(t){var n=e.player.config.previewThumbnails.src;if(N.empty(n))throw new Error("Missing previewThumbnails.src config attribute");var i=(N.string(n)?[n]:n).map(function(t){return e.getThumbnail(t)});Promise.all(i).then(function(){e.thumbnails.sort(function(e,t){return e.height-t.height}),e.player.debug.log("Preview thumbnails",e.thumbnails),t()})})}},{key:"getThumbnail",value:function(e){var t=this;return new Promise(function(n){ve(e).then(function(i){var s,r,o={frames:(s=i,r=[],s.split(/\r\n\r\n|\n\n|\r\r/).forEach(function(e){var t={};e.split(/\r\n|\n|\r/).forEach(function(e){if(N.number(t.startTime)){if(!N.empty(e.trim())&&N.empty(t.text)){var n=e.trim().split("#xywh="),i=a(n,1);if(t.text=i[0],n[1]){var s=a(n[1].split(","),4);t.x=s[0],t.y=s[1],t.w=s[2],t.h=s[3]}}}else{var r=e.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);r&&(t.startTime=60*Number(r[1]||0)*60+60*Number(r[2])+Number(r[3])+Number("0.".concat(r[4])),t.endTime=60*Number(r[6]||0)*60+60*Number(r[7])+Number(r[8])+Number("0.".concat(r[9])))}}),t.text&&r.push(t)}),r),height:null,urlPrefix:""};o.frames[0].text.startsWith("/")||o.frames[0].text.startsWith("http://")||o.frames[0].text.startsWith("https://")||(o.urlPrefix=e.substring(0,e.lastIndexOf("/")+1));var l=new Image;l.onload=function(){o.height=l.naturalHeight,o.width=l.naturalWidth,t.thumbnails.push(o),n()},l.src=o.urlPrefix+o.frames[0].text})})}},{key:"startMove",value:function(e){if(this.loaded&&N.event(e)&&["touchmove","mousemove"].includes(e.type)&&this.player.media.duration){if("touchmove"===e.type)this.seekTime=this.player.media.duration*(this.player.elements.inputs.seek.value/100);else{var t=this.player.elements.progress.getBoundingClientRect(),n=100/t.width*(e.pageX-t.left);this.seekTime=this.player.media.duration*(n/100),this.seekTime<0&&(this.seekTime=0),this.seekTime>this.player.media.duration-1&&(this.seekTime=this.player.media.duration-1),this.mousePosX=e.pageX,this.elements.thumb.time.innerText=Ce(this.seekTime)}this.showImageAtCurrentTime()}}},{key:"endMove",value:function(){this.toggleThumbContainer(!1,!0)}},{key:"startScrubbing",value:function(e){!1!==e.button&&0!==e.button||(this.mouseDown=!0,this.player.media.duration&&(this.toggleScrubbingContainer(!0),this.toggleThumbContainer(!1,!0),this.showImageAtCurrentTime()))}},{key:"endScrubbing",value:function(){var e=this;this.mouseDown=!1,Math.ceil(this.lastTime)===Math.ceil(this.player.media.currentTime)?this.toggleScrubbingContainer(!1):q.call(this.player,this.player.media,"timeupdate",function(){e.mouseDown||e.toggleScrubbingContainer(!1)})}},{key:"listeners",value:function(){var e=this;this.player.on("play",function(){e.toggleThumbContainer(!1,!0)}),this.player.on("seeked",function(){e.toggleThumbContainer(!1)}),this.player.on("timeupdate",function(){e.lastTime=e.player.media.currentTime})}},{key:"render",value:function(){this.elements.thumb.container=B("div",{class:this.player.config.classNames.previewThumbnails.thumbContainer}),this.elements.thumb.imageContainer=B("div",{class:this.player.config.classNames.previewThumbnails.imageContainer}),this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);var e=B("div",{class:this.player.config.classNames.previewThumbnails.timeContainer});this.elements.thumb.time=B("span",{},"00:00"),e.appendChild(this.elements.thumb.time),this.elements.thumb.container.appendChild(e),N.element(this.player.elements.progress)&&this.player.elements.progress.appendChild(this.elements.thumb.container),this.elements.scrubbing.container=B("div",{class:this.player.config.classNames.previewThumbnails.scrubbingContainer}),this.player.elements.wrapper.appendChild(this.elements.scrubbing.container)}},{key:"showImageAtCurrentTime",value:function(){var e=this;this.mouseDown?this.setScrubbingContainerSize():this.setThumbContainerSizeAndPos();var t=this.thumbnails[0].frames.findIndex(function(t){return e.seekTime>=t.startTime&&e.seekTime<=t.endTime}),n=t>=0,i=0;this.mouseDown||this.toggleThumbContainer(n),n&&(this.thumbnails.forEach(function(n,a){e.loadedImages.includes(n.frames[t].text)&&(i=a)}),t!==this.showingThumb&&(this.showingThumb=t,this.loadImage(i)))}},{key:"loadImage",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=this.showingThumb,i=this.thumbnails[t],a=i.urlPrefix,s=i.frames[n],r=i.frames[n].text,o=a+r;if(this.currentImageElement&&this.currentImageElement.dataset.filename===r)this.showImage(this.currentImageElement,s,t,n,r,!1),this.currentImageElement.dataset.index=n,this.removeOldImages(this.currentImageElement);else{this.loadingImage&&this.usingSprites&&(this.loadingImage.onload=null);var l=new Image;l.src=o,l.dataset.index=n,l.dataset.filename=r,this.showingThumbFilename=r,this.player.debug.log("Loading image: ".concat(o)),l.onload=function(){return e.showImage(l,s,t,n,r,!0)},this.loadingImage=l,this.removeOldImages(l)}}},{key:"showImage",value:function(e,t,n,i,a){var s=!(arguments.length>5&&void 0!==arguments[5])||arguments[5];this.player.debug.log("Showing thumb: ".concat(a,". num: ").concat(i,". qual: ").concat(n,". newimg: ").concat(s)),this.setImageSizeAndOffset(e,t),s&&(this.currentImageContainer.appendChild(e),this.currentImageElement=e,this.loadedImages.includes(a)||this.loadedImages.push(a)),this.preloadNearby(i,!0).then(this.preloadNearby(i,!1)).then(this.getHigherQuality(n,e,t,a))}},{key:"removeOldImages",value:function(e){var t=this;Array.from(this.currentImageContainer.children).forEach(function(n){if("img"===n.tagName.toLowerCase()){var i=t.usingSprites?500:1e3;if(n.dataset.index!==e.dataset.index&&!n.dataset.deleting){n.dataset.deleting=!0;var a=t.currentImageContainer;setTimeout(function(){a.removeChild(n),t.player.debug.log("Removing thumb: ".concat(n.dataset.filename))},i)}}})}},{key:"preloadNearby",value:function(e){var t=this,n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return new Promise(function(i){setTimeout(function(){var a=t.thumbnails[0].frames[e].text;if(t.showingThumbFilename===a){var s;s=n?t.thumbnails[0].frames.slice(e):t.thumbnails[0].frames.slice(0,e).reverse();var r=!1;s.forEach(function(e){var n=e.text;if(n!==a&&!t.loadedImages.includes(n)){r=!0,t.player.debug.log("Preloading thumb filename: ".concat(n));var s=t.thumbnails[0].urlPrefix+n,o=new Image;o.src=s,o.onload=function(){t.player.debug.log("Preloaded thumb filename: ".concat(n)),t.loadedImages.includes(n)||t.loadedImages.push(n),i()}}}),r||i()}},300)})}},{key:"getHigherQuality",value:function(e,t,n,i){var a=this;if(e<this.thumbnails.length-1){var s=t.naturalHeight;this.usingSprites&&(s=n.h),s<this.thumbContainerHeight&&setTimeout(function(){a.showingThumbFilename===i&&(a.player.debug.log("Showing higher quality thumb for: ".concat(i)),a.loadImage(e+1))},300)}}},{key:"toggleThumbContainer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=this.player.config.classNames.previewThumbnails.thumbContainerShown;this.elements.thumb.container.classList.toggle(n,e),!e&&t&&(this.showingThumb=null,this.showingThumbFilename=null)}},{key:"toggleScrubbingContainer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=this.player.config.classNames.previewThumbnails.scrubbingContainerShown;this.elements.scrubbing.container.classList.toggle(t,e),e||(this.showingThumb=null,this.showingThumbFilename=null)}},{key:"determineContainerAutoSizing",value:function(){this.elements.thumb.imageContainer.clientHeight>20&&(this.sizeSpecifiedInCSS=!0)}},{key:"setThumbContainerSizeAndPos",value:function(){if(!this.sizeSpecifiedInCSS){var e=Math.floor(this.thumbContainerHeight*this.thumbAspectRatio);this.elements.thumb.imageContainer.style.height="".concat(this.thumbContainerHeight,"px"),this.elements.thumb.imageContainer.style.width="".concat(e,"px")}this.setThumbContainerPos()}},{key:"setThumbContainerPos",value:function(){var e=this.player.elements.progress.getBoundingClientRect(),t=this.player.elements.container.getBoundingClientRect(),n=this.elements.thumb.container,i=t.left-e.left+10,a=t.right-e.left-n.clientWidth-10,s=this.mousePosX-e.left-n.clientWidth/2;s<i&&(s=i),s>a&&(s=a),n.style.left="".concat(s,"px")}},{key:"setScrubbingContainerSize",value:function(){this.elements.scrubbing.container.style.width="".concat(this.player.media.clientWidth,"px"),this.elements.scrubbing.container.style.height="".concat(this.player.media.clientWidth/this.thumbAspectRatio,"px")}},{key:"setImageSizeAndOffset",value:function(e,t){if(this.usingSprites){var n=this.thumbContainerHeight/t.h;e.style.height="".concat(Math.floor(e.naturalHeight*n),"px"),e.style.width="".concat(Math.floor(e.naturalWidth*n),"px"),e.style.left="-".concat(t.x*n,"px"),e.style.top="-".concat(t.y*n,"px")}}},{key:"enabled",get:function(){return this.player.isHTML5&&this.player.isVideo&&this.player.config.previewThumbnails.enabled}},{key:"currentImageContainer",get:function(){return this.mouseDown?this.elements.scrubbing.container:this.elements.thumb.imageContainer}},{key:"usingSprites",get:function(){return Object.keys(this.thumbnails[0].frames[0]).includes("w")}},{key:"thumbAspectRatio",get:function(){return this.usingSprites?this.thumbnails[0].frames[0].w/this.thumbnails[0].frames[0].h:this.thumbnails[0].width/this.thumbnails[0].height}},{key:"thumbContainerHeight",get:function(){return this.mouseDown?Math.floor(this.player.media.clientWidth/this.thumbAspectRatio):Math.floor(this.player.media.clientWidth/this.thumbAspectRatio/4)}},{key:"currentImageElement",get:function(){return this.mouseDown?this.currentScrubbingImageElement:this.currentThumbnailImageElement},set:function(e){this.mouseDown?this.currentScrubbingImageElement=e:this.currentThumbnailImageElement=e}}]),t}(),$e={insertElements:function(e,t){var n=this;N.string(t)?U(e,this.media,{src:t}):N.array(t)&&t.forEach(function(t){U(e,n.media,t)})},change:function(e){var t=this;D(e,"sources.length")?(le.cancelRequests.call(this),this.destroy.call(this,function(){t.options.quality=[],W(t.media),t.media=null,N.element(t.elements.container)&&t.elements.container.removeAttribute("class");var n=e.sources,i=e.type,s=a(n,1)[0],r=s.provider,o=void 0===r?Le.html5:r,l=s.src,c="html5"===o?i:"div",u="html5"===o?{}:{src:l};Object.assign(t,{provider:o,type:i,supported:ie.check(i,o,t.config.playsinline),media:B(c,u)}),t.elements.container.appendChild(t.media),N.boolean(e.autoplay)&&(t.config.autoplay=e.autoplay),t.isHTML5&&(t.config.crossorigin&&t.media.setAttribute("crossorigin",""),t.config.autoplay&&t.media.setAttribute("autoplay",""),N.empty(e.poster)||(t.poster=e.poster),t.config.loop.active&&t.media.setAttribute("loop",""),t.config.muted&&t.media.setAttribute("muted",""),t.config.playsinline&&t.media.setAttribute("playsinline","")),Fe.addStyleHook.call(t),t.isHTML5&&$e.insertElements.call(t,"source",n),t.config.title=e.title,Qe.setup.call(t),t.isHTML5&&Object.keys(e).includes("tracks")&&$e.insertElements.call(t,"track",e.tracks),(t.isHTML5||t.isEmbed&&!t.supported.ui)&&Fe.build.call(t),t.isHTML5&&t.media.load(),t.previewThumbnails&&t.previewThumbnails.load(),t.fullscreen.update()},!0)):this.debug.warn("Invalid source format")}};var Ge,Ze=function(){function t(n,i){var a=this;if(e(this,t),this.timers={},this.ready=!1,this.loading=!1,this.failed=!1,this.touch=ie.touch,this.media=n,N.string(this.media)&&(this.media=document.querySelectorAll(this.media)),(window.jQuery&&this.media instanceof jQuery||N.nodeList(this.media)||N.array(this.media))&&(this.media=this.media[0]),this.config=F({},Ne,t.defaults,i||{},function(){try{return JSON.parse(a.media.getAttribute("data-plyr-config"))}catch(e){return{}}}()),this.elements={container:null,captions:null,buttons:{},display:{},progress:{},inputs:{},settings:{popup:null,menu:null,panels:{},buttons:{}}},this.captions={active:null,currentTrack:-1,meta:new WeakMap},this.fullscreen={active:!1},this.options={speed:[],quality:[]},this.debug=new Oe(this.config.debug),this.debug.log("Config",this.config),this.debug.log("Support",ie),!N.nullOrUndefined(this.media)&&N.element(this.media))if(this.media.plyr)this.debug.warn("Target already setup");else if(this.config.enabled)if(ie.check().api){var s=this.media.cloneNode(!0);s.autoplay=!1,this.elements.original=s;var r=this.media.tagName.toLowerCase(),o=null,l=null;switch(r){case"div":if(o=this.media.querySelector("iframe"),N.element(o)){if(l=Ee(o.getAttribute("src")),this.provider=function(e){return/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e)?Le.youtube:/^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e)?Le.vimeo:null}(l.toString()),this.elements.container=this.media,this.media=o,this.elements.container.className="",l.search.length){var c=["1","true"];c.includes(l.searchParams.get("autoplay"))&&(this.config.autoplay=!0),c.includes(l.searchParams.get("loop"))&&(this.config.loop.active=!0),this.isYouTube?(this.config.playsinline=c.includes(l.searchParams.get("playsinline")),this.config.youtube.hl=l.searchParams.get("hl")):this.config.playsinline=!0}}else this.provider=this.media.getAttribute(this.config.attributes.embed.provider),this.media.removeAttribute(this.config.attributes.embed.provider);if(N.empty(this.provider)||!Object.keys(Le).includes(this.provider))return void this.debug.error("Setup failed: Invalid provider");this.type=Ie.video;break;case"video":case"audio":this.type=r,this.provider=Le.html5,this.media.hasAttribute("crossorigin")&&(this.config.crossorigin=!0),this.media.hasAttribute("autoplay")&&(this.config.autoplay=!0),(this.media.hasAttribute("playsinline")||this.media.hasAttribute("webkit-playsinline"))&&(this.config.playsinline=!0),this.media.hasAttribute("muted")&&(this.config.muted=!0),this.media.hasAttribute("loop")&&(this.config.loop.active=!0);break;default:return void this.debug.error("Setup failed: unsupported type")}this.supported=ie.check(this.type,this.provider,this.config.playsinline),this.supported.api?(this.eventListeners=[],this.listeners=new Re(this),this.storage=new ye(this),this.media.plyr=this,N.element(this.elements.container)||(this.elements.container=B("div",{tabindex:0}),R(this.media,this.elements.container)),Fe.addStyleHook.call(this),Qe.setup.call(this),this.config.debug&&O.call(this,this.elements.container,this.config.events.join(" "),function(e){a.debug.log("event: ".concat(e.type))}),(this.isHTML5||this.isEmbed&&!this.supported.ui)&&Fe.build.call(this),this.listeners.container(),this.listeners.global(),this.fullscreen=new He(this),this.config.ads.enabled&&(this.ads=new Xe(this)),this.isHTML5&&this.config.autoplay&&setTimeout(function(){return a.play()},10),this.lastSeekTime=0,this.config.previewThumbnails.enabled&&(this.previewThumbnails=new Je(this))):this.debug.error("Setup failed: no support")}else this.debug.error("Setup failed: no support");else this.debug.error("Setup failed: disabled by config");else this.debug.error("Setup failed: no suitable element passed")}return n(t,[{key:"play",value:function(){var e=this;return N.function(this.media.play)?(this.ads&&this.ads.enabled&&this.ads.managerPromise.then(function(){return e.ads.play()}).catch(function(){return e.media.play()}),this.media.play()):null}},{key:"pause",value:function(){this.playing&&N.function(this.media.pause)&&this.media.pause()}},{key:"togglePlay",value:function(e){(N.boolean(e)?e:!this.playing)?this.play():this.pause()}},{key:"stop",value:function(){this.isHTML5?(this.pause(),this.restart()):N.function(this.media.stop)&&this.media.stop()}},{key:"restart",value:function(){this.currentTime=0}},{key:"rewind",value:function(e){this.currentTime=this.currentTime-(N.number(e)?e:this.config.seekTime)}},{key:"forward",value:function(e){this.currentTime=this.currentTime+(N.number(e)?e:this.config.seekTime)}},{key:"increaseVolume",value:function(e){var t=this.media.muted?0:this.volume;this.volume=t+(N.number(e)?e:0)}},{key:"decreaseVolume",value:function(e){this.increaseVolume(-e)}},{key:"toggleCaptions",value:function(e){Pe.toggle.call(this,e,!1)}},{key:"airplay",value:function(){ie.airplay&&this.media.webkitShowPlaybackTargetPicker()}},{key:"toggleControls",value:function(e){if(this.supported.ui&&!this.isAudio){var t=J(this.elements.container,this.config.classNames.hideControls),n=void 0===e?void 0:!e,i=X(this.elements.container,this.config.classNames.hideControls,n);if(i&&this.config.controls.includes("settings")&&!N.empty(this.config.settings)&&Ae.toggleMenu.call(this,!1),i!==t){var a=i?"controlshidden":"controlsshown";H.call(this,this.media,a)}return!i}return!1}},{key:"on",value:function(e,t){O.call(this,this.elements.container,e,t)}},{key:"once",value:function(e,t){q.call(this,this.elements.container,e,t)}},{key:"off",value:function(e,t){j(this.elements.container,e,t)}},{key:"destroy",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(this.ready){var i=function(){document.body.style.overflow="",t.embed=null,n?(Object.keys(t.elements).length&&(W(t.elements.buttons.play),W(t.elements.captions),W(t.elements.controls),W(t.elements.wrapper),t.elements.buttons.play=null,t.elements.captions=null,t.elements.controls=null,t.elements.wrapper=null),N.function(e)&&e()):(function(){this&&this.eventListeners&&(this.eventListeners.forEach(function(e){var t=e.element,n=e.type,i=e.callback,a=e.options;t.removeEventListener(n,i,a)}),this.eventListeners=[])}.call(t),K(t.elements.original,t.elements.container),H.call(t,t.elements.original,"destroyed",!0),N.function(e)&&e.call(t.elements.original),t.ready=!1,setTimeout(function(){t.elements=null,t.media=null},200))};this.stop(),clearTimeout(this.timers.loading),clearTimeout(this.timers.controls),clearTimeout(this.timers.resized),this.isHTML5?(Fe.toggleNativeControls.call(this,!0),i()):this.isYouTube?(clearInterval(this.timers.buffering),clearInterval(this.timers.playing),null!==this.embed&&N.function(this.embed.destroy)&&this.embed.destroy(),i()):this.isVimeo&&(null!==this.embed&&this.embed.unload().then(i),setTimeout(i,200))}}},{key:"supports",value:function(e){return ie.mime.call(this,e)}},{key:"isHTML5",get:function(){return this.provider===Le.html5}},{key:"isEmbed",get:function(){return this.isYouTube||this.isVimeo}},{key:"isYouTube",get:function(){return this.provider===Le.youtube}},{key:"isVimeo",get:function(){return this.provider===Le.vimeo}},{key:"isVideo",get:function(){return this.type===Ie.video}},{key:"isAudio",get:function(){return this.type===Ie.audio}},{key:"playing",get:function(){return Boolean(this.ready&&!this.paused&&!this.ended)}},{key:"paused",get:function(){return Boolean(this.media.paused)}},{key:"stopped",get:function(){return Boolean(this.paused&&0===this.currentTime)}},{key:"ended",get:function(){return Boolean(this.media.ended)}},{key:"currentTime",set:function(e){if(this.duration){var t=N.number(e)&&e>0;this.media.currentTime=t?Math.min(e,this.duration):0,this.debug.log("Seeking to ".concat(this.currentTime," seconds"))}},get:function(){return Number(this.media.currentTime)}},{key:"buffered",get:function(){var e=this.media.buffered;return N.number(e)?e:e&&e.length&&this.duration>0?e.end(0)/this.duration:0}},{key:"seeking",get:function(){return Boolean(this.media.seeking)}},{key:"duration",get:function(){var e=parseFloat(this.config.duration),t=(this.media||{}).duration,n=N.number(t)&&t!==1/0?t:0;return e||n}},{key:"volume",set:function(e){var t=e;N.string(t)&&(t=Number(t)),N.number(t)||(t=this.storage.get("volume")),N.number(t)||(t=this.config.volume),t>1&&(t=1),t<0&&(t=0),this.config.volume=t,this.media.volume=t,!N.empty(e)&&this.muted&&t>0&&(this.muted=!1)},get:function(){return Number(this.media.volume)}},{key:"muted",set:function(e){var t=e;N.boolean(t)||(t=this.storage.get("muted")),N.boolean(t)||(t=this.config.muted),this.config.muted=t,this.media.muted=t},get:function(){return Boolean(this.media.muted)}},{key:"hasAudio",get:function(){return!this.isHTML5||(!!this.isAudio||(Boolean(this.media.mozHasAudio)||Boolean(this.media.webkitAudioDecodedByteCount)||Boolean(this.media.audioTracks&&this.media.audioTracks.length)))}},{key:"speed",set:function(e){var t=this,n=null;N.number(e)&&(n=e),N.number(n)||(n=this.storage.get("speed")),N.number(n)||(n=this.config.speed.selected);var i=this.minimumSpeed,a=this.maximumSpeed;n=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:255;return Math.min(Math.max(e,t),n)}(n,i,a),this.config.speed.selected=n,setTimeout(function(){t.media.playbackRate=n},0)},get:function(){return Number(this.media.playbackRate)}},{key:"minimumSpeed",get:function(){return this.isYouTube?Math.min.apply(Math,s(this.options.speed)):this.isVimeo?.5:.0625}},{key:"maximumSpeed",get:function(){return this.isYouTube?Math.max.apply(Math,s(this.options.speed)):this.isVimeo?2:16}},{key:"quality",set:function(e){var t=this.config.quality,n=this.options.quality;if(n.length){var i=[!N.empty(e)&&Number(e),this.storage.get("quality"),t.selected,t.default].find(N.number),a=!0;if(!n.includes(i)){var s=function(e,t){return N.array(e)&&e.length?e.reduce(function(e,n){return Math.abs(n-t)<Math.abs(e-t)?n:e}):null}(n,i);this.debug.warn("Unsupported quality option: ".concat(i,", using ").concat(s," instead")),i=s,a=!1}t.selected=i,this.media.quality=i,a&&this.storage.set({quality:i})}},get:function(){return this.media.quality}},{key:"loop",set:function(e){var t=N.boolean(e)?e:this.config.loop.active;this.config.loop.active=t,this.media.loop=t},get:function(){return Boolean(this.media.loop)}},{key:"source",set:function(e){$e.change.call(this,e)},get:function(){return this.media.currentSrc}},{key:"download",get:function(){var e=this.config.urls.download;return N.url(e)?e:this.source},set:function(e){N.url(e)&&(this.config.urls.download=e,Ae.setDownloadUrl.call(this))}},{key:"poster",set:function(e){this.isVideo?Fe.setPoster.call(this,e,!1).catch(function(){}):this.debug.warn("Poster can only be set for video")},get:function(){return this.isVideo?this.media.getAttribute("poster"):null}},{key:"ratio",get:function(){if(!this.isVideo)return null;var e=se(re.call(this));return N.array(e)?e.join(":"):e},set:function(e){this.isVideo?N.string(e)&&ae(e)?(this.config.ratio=e,oe.call(this)):this.debug.error("Invalid aspect ratio specified (".concat(e,")")):this.debug.warn("Aspect ratio can only be set for video")}},{key:"autoplay",set:function(e){var t=N.boolean(e)?e:this.config.autoplay;this.config.autoplay=t},get:function(){return Boolean(this.config.autoplay)}},{key:"currentTrack",set:function(e){Pe.set.call(this,e,!1)},get:function(){var e=this.captions,t=e.toggled,n=e.currentTrack;return t?n:-1}},{key:"language",set:function(e){Pe.setLanguage.call(this,e,!1)},get:function(){return(Pe.getCurrentTrack.call(this)||{}).language}},{key:"pip",set:function(e){if(ie.pip){var t=N.boolean(e)?e:!this.pip;N.function(this.media.webkitSetPresentationMode)&&this.media.webkitSetPresentationMode(t?Me:xe),N.function(this.media.requestPictureInPicture)&&(!this.pip&&t?this.media.requestPictureInPicture():this.pip&&!t&&document.exitPictureInPicture())}},get:function(){return ie.pip?N.empty(this.media.webkitPresentationMode)?this.media===document.pictureInPictureElement:this.media.webkitPresentationMode===Me:null}}],[{key:"supported",value:function(e,t,n){return ie.check(e,t,n)}},{key:"loadSprite",value:function(e,t){return be(e,t)}},{key:"setup",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=null;return N.string(e)?i=Array.from(document.querySelectorAll(e)):N.nodeList(e)?i=Array.from(e):N.array(e)&&(i=e.filter(N.element)),N.empty(i)?null:i.map(function(e){return new t(e,n)})}}]),t}();return Ze.defaults=(Ge=Ne,JSON.parse(JSON.stringify(Ge))),Ze});
//# sourceMappingURL=plyr.min.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Dropdown=function(_Component){_inherits(Dropdown,_Component);function Dropdown(){_classCallCheck(this,Dropdown);var _this=_possibleConstructorReturn(this,(Dropdown.__proto__||Object.getPrototypeOf(Dropdown)).apply(this,arguments));_this.state={listVisible:false,placeHolder:true,selected:{}};_this.props.list.map(function(item){if(_this.props.value===item[_this.props.valueProperty]){_this.state.selected=item;_this.state.placeHolder=false;}});return _this;}_createClass(Dropdown,[{key:'select',value:function select(item){this.setState({placeHolder:!item});item=item||{};this.setState({selected:item});if(this.props.onChange){this.props.onChange(item);}}},{key:'componentDidMount',value:function componentDidMount(){this.clickListener=this.hide.bind(this);document.addEventListener('mousedown',this.clickListener);document.addEventListener('touchstart',this.clickListener);if(_get(Dropdown.prototype.__proto__||Object.getPrototypeOf(Dropdown.prototype),'componentDidMount',this)){_get(Dropdown.prototype.__proto__||Object.getPrototypeOf(Dropdown.prototype),'componentDidMount',this).call(this);}}},{key:'getValue',value:function getValue(){if(this.state.selected){return this.state.selected[this.props.valueProperty];}else{return null;}}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('mousedown',this.clickListener);document.removeEventListener('touchstart',this.clickListener);if(_get(Dropdown.prototype.__proto__||Object.getPrototypeOf(Dropdown.prototype),'componentWillUnmount',this)){_get(Dropdown.prototype.__proto__||Object.getPrototypeOf(Dropdown.prototype),'componentWillUnmount',this).call(this);}}},{key:'show',value:function show(event){this.setState({listVisible:true});event.stopPropagation();}},{key:'hide',value:function hide(e){this.setState({listVisible:false});}},{key:'render',value:function render(){var _this2=this;var listItems=void 0,classes=__WEBPACK_IMPORTED_MODULE_1_classnames___default()('cio-dropdown',{shown:this.state.listVisible,'has-placeholder':this.state.placeHolder});listItems=this.props.list.map(function(item){var value=_this2.state.selected[_this2.props.valueProperty];if(item[_this2.props.valueProperty]!==value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:item[_this2.props.valueProperty],onTouchTap:_this2.select.bind(_this2,item)},item[_this2.props.labelProperty]);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cio-dropdown-display',onTouchTap:this.show.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.selected[this.props.labelProperty]||this.props.placeholder),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["FontIcon"],{className:'md md-expand-more'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cio-dropdown-list'},listItems));}}]);return Dropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Dropdown.propTypes={labelProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,valueProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,list:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};Dropdown.defaultProps={labelProperty:'label',valueProperty:'value',list:[]};/* unused harmony default export */ var _unused_webpack_default_export = (Dropdown);

/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_HammerWrapper__ = __webpack_require__(2100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_Grid__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Widgets_VideoPreview__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Widgets_TextField__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Constants__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var types=__WEBPACK_IMPORTED_MODULE_8_Constants__["default"].fileTypeIcons;var FileList=function(_Component){_inherits(FileList,_Component);function FileList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FileList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FileList.__proto__||Object.getPrototypeOf(FileList)).call.apply(_ref,[this].concat(args))),_this),_this.state={selected:{}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FileList,[{key:'onSearchTextChange',value:function onSearchTextChange(e){var _this2=this;var value=e.target.value;if(this._debounce){clearTimeout(this._debounce);}this._debounce=setTimeout(function(){_this2.setState({searchText:value});},300);}},{key:'selectFile',value:function selectFile(id){var selected=this.state.selected;selected[id]=!selected[id];if(!selected[id]){delete selected[id];}this.setState({selected:selected});if(this.props.onSelect){this.props.onSelect(this.state.selected);}}},{key:'removeFilter',value:function removeFilter(){if(this.props.removeFilter){this.props.removeFilter();}}},{key:'getSelectedFiles',value:function getSelectedFiles(){return this.state.selected;}},{key:'onTap',value:function onTap(fileId){if(this.props.onTap){this.props.onTap(fileId);}}},{key:'render',value:function render(){var _this3=this;var hasFilter=void 0,searchBar=void 0;searchBar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_Grid__["a" /* GridCell */],{size:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Widgets_TextField__["a" /* default */],{icon:'md md-search',hintText:this.context.getIntlMessage(this.props.searchHint),ref:'searchField',onChange:this.onSearchTextChange.bind(this)})));if(this.props.list.length>0){var list=this.props.list;if(this.props.filter.type){hasFilter=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_Grid__["b" /* GridContainer */],{fluid:true,className:'filtered-warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_Grid__["a" /* GridCell */],{size:6},this.context.getIntlMessage('resultsFiltered')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_Grid__["a" /* GridCell */],{size:6,className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["FlatButton"],{primary:true,label:'Remove',onTouchTap:this.removeFilter.bind(this)})));var fileType=this.props.filter.type;list=list.filter(function(file){return file.type.indexOf(fileType)===0;});}if(this.state.searchText&&this.state.searchText!==''){var searchText=this.state.searchText.toUpperCase();list=list.filter(function(file){return file.name.toUpperCase().indexOf(searchText)>-1;});}if(this.props.sort.property){var sortProperty=this.props.sort.property;list.sort(function(a,b){if(typeof a[sortProperty]==='string'){a=a[sortProperty].toUpperCase();b=b[sortProperty].toUpperCase();if(a<b)return-1;if(a>b)return 1;return 0;}else{a=a[sortProperty];b=b[sortProperty];if(a<b)return-1;if(al>b)return 1;return 0;}});}var files=list.map(function(file,index){var coverStyle=void 0,thumb=void 0;coverStyle={backgroundImage:'none'};if(_this3.props.style==='list'){var _fileType=file.type.substring(0,file.type.indexOf('/'));if(_fileType==='image'){coverStyle={backgroundImage:'url('+file.url+')'// backgroundImage: 'url(http://lorempixel.com/144/144/technics)'
};thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thumb',style:coverStyle});}else if(_fileType==='video'){var extension=file.url.split('.').pop();thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Widgets_VideoPreview__["a" /* default */],{style:{display:'inline-block'},sources:[{url:file.url,type:extension}]});}else if(types[_fileType]){thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thumb',style:coverStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'zmdi zmdi-hc-2x zmdi-'+types[_fileType]}));}else{thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thumb',style:coverStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'zmdi zmdi-hc-2x zmdi-file'}));}var date=file.created&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["FormattedDate"],{value:new Date(file.created)})||'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('file',{selected:_this3.state.selected[file.id]})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'checkbox',onTouchTap:_this3.selectFile.bind(_this3,file.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'zmdi zmdi-hc-2x zmdi-check'})),thumb,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,file.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'date'},date)));}else{var color=file.metadata;var _fileType2=file.type.substring(0,file.type.indexOf('/'));if(_fileType2==='image'){coverStyle={backgroundImage:'url('+file.url+')'// backgroundImage: 'url(http://lorempixel.com/144/144/technics)'
};thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thumb',style:coverStyle});}else if(_fileType2==='video'){var _extension=file.url.split('.').pop();thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Widgets_VideoPreview__["a" /* default */],{style:{display:'inline-block'},sources:[{url:file.url,type:_extension}]});}else if(types[_fileType2]){thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thumb',style:coverStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'zmdi zmdi-hc-2x zmdi-'+types[_fileType2]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),file.name);}else{thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thumb',style:coverStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'zmdi zmdi-hc-2x zmdi-file'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),file.name);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_HammerWrapper__["a" /* default */],{component:'div',key:file.id,onTap:_this3.onTap.bind(_this3,file.id),onPress:_this3.selectFile.bind(_this3,file.id),className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('thumb-holder',{selected:_this3.state.selected[file.id]})},thumb);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('file-list',this.props.style)},searchBar,hasFilter,files);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}]);return FileList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FileList.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};FileList.propTypes={list:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,sort:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,filter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,removeFilter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onSelect:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onTap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,searchHint:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOf(['list','thumb'])};FileList.defaultProps={style:'list',searchHint:'Search'};/* unused harmony default export */ var _unused_webpack_default_export = (FileList);

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint esnext: true */


exports.__addLocaleData = __addLocaleData;
var intl$messageformat$$ = __webpack_require__(262), intl$relativeformat$$ = __webpack_require__(379), src$en$$ = __webpack_require__(2089), src$mixin$$ = __webpack_require__(141), src$components$date$$ = __webpack_require__(2092), src$components$time$$ = __webpack_require__(2093), src$components$relative$$ = __webpack_require__(2094), src$components$number$$ = __webpack_require__(2095), src$components$message$$ = __webpack_require__(2096), src$components$html$message$$ = __webpack_require__(2097);
function __addLocaleData(data) {
    intl$messageformat$$["default"].__addLocaleData(data);
    intl$relativeformat$$["default"].__addLocaleData(data);
}

__addLocaleData(src$en$$["default"]);
exports.IntlMixin = src$mixin$$["default"], exports.FormattedDate = src$components$date$$["default"], exports.FormattedTime = src$components$time$$["default"], exports.FormattedRelative = src$components$relative$$["default"], exports.FormattedNumber = src$components$number$$["default"], exports.FormattedMessage = src$components$message$$["default"], exports.FormattedHTMLMessage = src$components$html$message$$["default"];

//# sourceMappingURL=react-intl.js.map

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(2076), src$en$$ = __webpack_require__(2081);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(575), src$es5$$ = __webpack_require__(2077), src$compiler$$ = __webpack_require__(2078), intl$messageformat$parser$$ = __webpack_require__(2079);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
        return messageFormat._format(pattern, values);
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
            throw new Error('A value must be provided for: ' + id);
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(575);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value) {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(2080)['default'];
exports['default'] = exports;


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  /*
   * Generated by PEG.js 0.8.0.
   *
   * http://pegjs.majda.cz/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function SyntaxError(message, expected, found, offset, line, column) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.offset   = offset;
    this.line     = line;
    this.column   = column;

    this.name     = "SyntaxError";
  }

  peg$subclass(SyntaxError, Error);

  function parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = [],
        peg$c1 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements
                };
            },
        peg$c2 = peg$FAILED,
        peg$c3 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c4 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText
                };
            },
        peg$c5 = /^[^ \t\n\r,.+={}#]/,
        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c7 = "{",
        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c9 = null,
        peg$c10 = ",",
        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
        peg$c12 = "}",
        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c14 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2]
                };
            },
        peg$c15 = "number",
        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c17 = "date",
        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c19 = "time",
        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c21 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2]
                };
            },
        peg$c22 = "plural",
        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                };
            },
        peg$c25 = "selectordinal",
        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c27 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                }
            },
        peg$c28 = "select",
        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c30 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options
                };
            },
        peg$c31 = "=",
        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c33 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern
                };
            },
        peg$c34 = "offset:",
        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c36 = function(number) {
                return number;
            },
        peg$c37 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options
                };
            },
        peg$c38 = { type: "other", description: "whitespace" },
        peg$c39 = /^[ \t\n\r]/,
        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c41 = { type: "other", description: "optionalWhitespace" },
        peg$c42 = /^[0-9]/,
        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c44 = /^[0-9a-f]/i,
        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c46 = "0",
        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c48 = /^[1-9]/,
        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c50 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
        peg$c53 = "\\\\",
        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c55 = function() { return '\\'; },
        peg$c56 = "\\#",
        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c58 = function() { return '\\#'; },
        peg$c59 = "\\{",
        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c61 = function() { return '\u007B'; },
        peg$c62 = "\\}",
        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c64 = function() { return '\u007D'; },
        peg$c65 = "\\u",
        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c67 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c68 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$reportedPos      = 0,
        peg$cachedPos        = 0,
        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$reportedPos, peg$currPos);
    }

    function offset() {
      return peg$reportedPos;
    }

    function line() {
      return peg$computePosDetails(peg$reportedPos).line;
    }

    function column() {
      return peg$computePosDetails(peg$reportedPos).column;
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        peg$reportedPos
      );
    }

    function error(message) {
      throw peg$buildException(message, null, peg$reportedPos);
    }

    function peg$computePosDetails(pos) {
      function advance(details, startPos, endPos) {
        var p, ch;

        for (p = startPos; p < endPos; p++) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }
        }
      }

      if (peg$cachedPos !== pos) {
        if (peg$cachedPos > pos) {
          peg$cachedPos = 0;
          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
        }
        advance(peg$cachedPosDetails, peg$cachedPos, pos);
        peg$cachedPos = pos;
      }

      return peg$cachedPosDetails;
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, pos) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      var posDetails = peg$computePosDetails(pos),
          found      = pos < input.length ? input.charAt(pos) : null;

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        pos,
        posDetails.line,
        posDetails.column
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$c2;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c2;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c2;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c4(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c5.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c6); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c5.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
          }
        } else {
          s1 = peg$c2;
        }
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c7;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c8); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c10;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c11); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$c2;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$c2;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$c2;
              }
              if (s5 === peg$FAILED) {
                s5 = peg$c9;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c12;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c14(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c15) {
        s1 = peg$c15;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c16); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c17) {
          s1 = peg$c17;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c18); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c19) {
            s1 = peg$c19;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c20); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c10;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$c2;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c2;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c2;
          }
          if (s3 === peg$FAILED) {
            s3 = peg$c9;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c21(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c28) {
        s1 = peg$c28;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$c2;
              }
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c30(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c31;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$c2;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c7;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c8); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c12;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$reportedPos = s0;
                      s1 = peg$c33(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$c2;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c34) {
        s1 = peg$c34;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c36(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = peg$c9;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$c2;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c37(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c39.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c39.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c40); }
          }
        }
      } else {
        s0 = peg$c2;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c41); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c42.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c43); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c44.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c45); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c46;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c47); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c48.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c49); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
        if (s2 !== peg$FAILED) {
          s2 = input.substring(s1, peg$currPos);
        }
        s1 = s2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c50(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c51.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c52); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c53) {
          s1 = peg$c53;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c54); }
        }
        if (s1 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c55();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c56) {
            s1 = peg$c56;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c57); }
          }
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c58();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c59) {
              s1 = peg$c59;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c60); }
            }
            if (s1 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c61();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c62) {
                s1 = peg$c62;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c63); }
              }
              if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c64();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c65) {
                  s1 = peg$c65;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$c2;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$c2;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$c2;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$c2;
                  }
                  if (s3 !== peg$FAILED) {
                    s3 = input.substring(s2, peg$currPos);
                  }
                  s2 = s3;
                  if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c67(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c68(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
    }
  }

  return {
    SyntaxError: SyntaxError,
    parse:       parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 2082 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(2084), src$en$$ = __webpack_require__(2087);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(262), src$diff$$ = __webpack_require__(2085), src$es5$$ = __webpack_require__(2086);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45,  // seconds to minute
        minute: 45,  // minutes to hour
        hour  : 22,  // hours to day
        day   : 26,  // days to month
        month : 11   // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;

    for (i = 0, l = FIELDS.length; i < l; i += 1) {
        units = FIELDS[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond: millisecond,
        second     : second,
        minute     : minute,
        hour       : hour,
        day        : day,
        week       : week,
        month      : month,
        year       : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 2088 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"Year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"Month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"Day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"Hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"Minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"Second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jshint esnext: true */


var src$es5$$ = __webpack_require__(2091);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill



var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint esnext:true */

// TODO: Use `import React from "react";` when external modules are supported.

var src$react$$ = __webpack_require__(142), src$mixin$$ = __webpack_require__(141);

var FormattedDate = src$react$$["default"].createClass({
    displayName: 'FormattedDate',
    mixins     : [src$mixin$$["default"]],

    statics: {
        formatOptions: [
            'localeMatcher', 'timeZone', 'hour12', 'formatMatcher', 'weekday',
            'era', 'year', 'month', 'day', 'hour', 'minute', 'second',
            'timeZoneName'
        ]
    },

    propTypes: {
        format: src$react$$["default"].PropTypes.string,
        value : src$react$$["default"].PropTypes.any.isRequired
    },

    render: function () {
        var props    = this.props;
        var value    = props.value;
        var format   = props.format;
        var defaults = format && this.getNamedFormat('date', format);
        var options  = FormattedDate.filterFormatOptions(props, defaults);

        return src$react$$["default"].DOM.span(null, this.formatDate(value, options));
    }
});

exports["default"] = FormattedDate;

//# sourceMappingURL=date.js.map

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint esnext:true */

// TODO: Use `import React from "react";` when external modules are supported.

var src$react$$ = __webpack_require__(142), src$mixin$$ = __webpack_require__(141);

var FormattedTime = src$react$$["default"].createClass({
    displayName: 'FormattedTime',
    mixins     : [src$mixin$$["default"]],

    statics: {
        formatOptions: [
            'localeMatcher', 'timeZone', 'hour12', 'formatMatcher', 'weekday',
            'era', 'year', 'month', 'day', 'hour', 'minute', 'second',
            'timeZoneName'
        ]
    },

    propTypes: {
        format: src$react$$["default"].PropTypes.string,
        value : src$react$$["default"].PropTypes.any.isRequired
    },

    render: function () {
        var props    = this.props;
        var value    = props.value;
        var format   = props.format;
        var defaults = format && this.getNamedFormat('time', format);
        var options  = FormattedTime.filterFormatOptions(props, defaults);

        return src$react$$["default"].DOM.span(null, this.formatTime(value, options));
    }
});

exports["default"] = FormattedTime;

//# sourceMappingURL=time.js.map

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint esnext:true */

// TODO: Use `import React from "react";` when external modules are supported.

var src$react$$ = __webpack_require__(142), src$mixin$$ = __webpack_require__(141);

var FormattedRelative = src$react$$["default"].createClass({
    displayName: 'FormattedRelative',
    mixins     : [src$mixin$$["default"]],

    statics: {
        formatOptions: [
            'style', 'units'
        ]
    },

    propTypes: {
        format: src$react$$["default"].PropTypes.string,
        value : src$react$$["default"].PropTypes.any.isRequired,
        now   : src$react$$["default"].PropTypes.any
    },

    render: function () {
        var props    = this.props;
        var value    = props.value;
        var format   = props.format;
        var defaults = format && this.getNamedFormat('relative', format);
        var options  = FormattedRelative.filterFormatOptions(props, defaults);

        var formattedRelativeTime = this.formatRelative(value, options, {
            now: props.now
        });

        return src$react$$["default"].DOM.span(null, formattedRelativeTime);
    }
});

exports["default"] = FormattedRelative;

//# sourceMappingURL=relative.js.map

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint esnext:true */

// TODO: Use `import React from "react";` when external modules are supported.

var src$react$$ = __webpack_require__(142), src$mixin$$ = __webpack_require__(141);

var FormattedNumber = src$react$$["default"].createClass({
    displayName: 'FormattedNumber',
    mixins     : [src$mixin$$["default"]],

    statics: {
        formatOptions: [
            'localeMatcher', 'style', 'currency', 'currencyDisplay',
            'useGrouping', 'minimumIntegerDigits', 'minimumFractionDigits',
            'maximumFractionDigits', 'minimumSignificantDigits',
            'maximumSignificantDigits'
        ]
    },

    propTypes: {
        format: src$react$$["default"].PropTypes.string,
        value : src$react$$["default"].PropTypes.any.isRequired
    },

    render: function () {
        var props    = this.props;
        var value    = props.value;
        var format   = props.format;
        var defaults = format && this.getNamedFormat('number', format);
        var options  = FormattedNumber.filterFormatOptions(props, defaults);

        return src$react$$["default"].DOM.span(null, this.formatNumber(value, options));
    }
});

exports["default"] = FormattedNumber;

//# sourceMappingURL=number.js.map

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint esnext:true */

// TODO: Use `import React from "react";` when external modules are supported.

var src$react$$ = __webpack_require__(142), src$mixin$$ = __webpack_require__(141);

var FormattedMessage = src$react$$["default"].createClass({
    displayName: 'FormattedMessage',
    mixins     : [src$mixin$$["default"]],

    propTypes: {
        tagName: src$react$$["default"].PropTypes.string,
        message: src$react$$["default"].PropTypes.string.isRequired
    },

    getDefaultProps: function () {
        return {tagName: 'span'};
    },

    render: function () {
        var props   = this.props;
        var tagName = props.tagName;
        var message = props.message;

        // Creates a token with a random guid that should not be guessable or
        // conflict with other parts of the `message` string.
        var guid       = Math.floor(Math.random() * 0x10000000000).toString(16);
        var tokenRegex = new RegExp('(@__ELEMENT-' + guid + '-\\d+__@)', 'g');
        var elements   = {};

        var generateToken = (function () {
            var counter = 0;
            return function () {
                return '@__ELEMENT-' + guid + '-' + (counter += 1) + '__@';
            };
        }());

        // Iterates over the `props` to keep track of any React Element values
        // so they can be represented by the `token` as a placeholder when the
        // `message` is formatted. This allows the formatted message to then be
        // broken-up into parts with references to the React Elements inserted
        // back in.
        var values = Object.keys(props).reduce(function (values, name) {
            var value = props[name];
            var token;

            if (src$react$$["default"].isValidElement(value)) {
                token           = generateToken();
                values[name]    = token;
                elements[token] = value;
            } else {
                values[name] = value;
            }

            return values;
        }, {});

        // Formats the `message` with the `values`, including the `token`
        // placeholders for React Element values.
        var formattedMessage = this.formatMessage(message, values);

        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while keeping
        // React's virtual diffing working properly.
        var children = formattedMessage.split(tokenRegex)
            .filter(function (part) {
                // Ignore empty string parts.
                return !!part;
            })
            .map(function (part) {
                // When the `part` is a token, get a ref to the React Element.
                return elements[part] || part;
            });

        var elementArgs = [tagName, null].concat(children);
        return src$react$$["default"].createElement.apply(null, elementArgs);
    }
});

exports["default"] = FormattedMessage;

//# sourceMappingURL=message.js.map

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint esnext:true */

// TODO: Use `import React from "react";` when external modules are supported.

var src$react$$ = __webpack_require__(142), src$escape$$ = __webpack_require__(2098), src$mixin$$ = __webpack_require__(141);

var FormattedHTMLMessage = src$react$$["default"].createClass({
    displayName: 'FormattedHTMLMessage',
    mixins     : [src$mixin$$["default"]],

    propTypes: {
        tagName: src$react$$["default"].PropTypes.string,
        message: src$react$$["default"].PropTypes.string.isRequired
    },

    getDefaultProps: function () {
        return {tagName: 'span'};
    },

    render: function () {
        var props   = this.props;
        var tagName = props.tagName;
        var message = props.message;

        // Process all the props before they are used as values when formatting
        // the ICU Message string. Since the formatted message will be injected
        // via `innerHTML`, all String-based values need to be HTML-escaped. Any
        // React Elements that are passed as props will be rendered to a static
        // markup string that is presumed to be safe.
        var values = Object.keys(props).reduce(function (values, name) {
            var value = props[name];

            if (typeof value === 'string') {
                value = src$escape$$["default"](value);
            } else if (src$react$$["default"].isValidElement(value)) {
                value = src$react$$["default"].renderToStaticMarkup(value);
            }

            values[name] = value;
            return values;
        }, {});

        // Since the message presumably has HTML in it, we need to set
        // `innerHTML` in order for it to be rendered and not escaped by React.
        // To be safe, all string prop values were escaped before formatting the
        // message. It is assumed that the message is not UGC, and came from
        // the developer making it more like a template.
        //
        // Note: There's a perf impact of using this component since there's no
        // way for React to do its virtual DOM diffing.
        return src$react$$["default"].DOM[tagName]({
            dangerouslySetInnerHTML: {
                __html: this.formatMessage(message, values)
            }
        });
    }
});

exports["default"] = FormattedHTMLMessage;

//# sourceMappingURL=html-message.js.map

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint esnext:true */

/*
HTML escaping implementation is the same as React's (on purpose.) Therefore, it
has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var ESCAPED_CHARS = {
    '&' : '&amp;',
    '>' : '&gt;',
    '<' : '&lt;',
    '"' : '&quot;',
    '\'': '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

exports["default"] = function (str) {
    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
        return ESCAPED_CHARS[match];
    });
};

//# sourceMappingURL=escape.js.map

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hammerjs__ = __webpack_require__(2101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var privateProps={component:true,children:true,action:true,onTap:true,onDoubleTap:true,onPan:true,onSwipe:true,onPress:true,onPinch:true,onRotate:true};var HammerWrapper=function(_Component){_inherits(HammerWrapper,_Component);function HammerWrapper(){_classCallCheck(this,HammerWrapper);return _possibleConstructorReturn(this,(HammerWrapper.__proto__||Object.getPrototypeOf(HammerWrapper)).apply(this,arguments));}_createClass(HammerWrapper,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.hammer=new __WEBPACK_IMPORTED_MODULE_1_hammerjs___default.a(Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this));if(this.props.options){Object.keys(this.props.options).forEach(function(option){if(option==='recognizers'){Object.keys(_this2.props.options.recognizers).forEach(function(gesture){_this2.hammer.get(gesture).set(_this2.props.options.recognizers[gesture]);});}else{var key=option,optionObj={};optionObj[key]=_this2.props.options[option];_this2.hammer.set(optionObj);}});}if(this.props.vertical){this.hammer.get('pan').set({direction:__WEBPACK_IMPORTED_MODULE_1_hammerjs___default.a.DIRECTION_ALL});this.hammer.get('swipe').set({direction:__WEBPACK_IMPORTED_MODULE_1_hammerjs___default.a.DIRECTION_ALL});}if(this.props.action)this.hammer.on('tap press',this.props.action);if(this.props.onTap)this.hammer.on('tap',this.props.onTap);if(this.props.onDoubleTap)this.hammer.on('doubletap',this.props.onDoubleTap);if(this.props.onPan)this.hammer.on('pan',this.props.onPan);if(this.props.onPanStart)this.hammer.on('panstart',this.props.onPanStart);if(this.props.onPanEnd)this.hammer.on('panend',this.props.onPanEnd);if(this.props.onSwipe)this.hammer.on('swipe',this.props.onSwipe);if(this.props.onPress)this.hammer.on('press',this.props.onPress);if(this.props.onPinch)this.hammer.on('pinch',this.props.onPinch);if(this.props.onRotate)this.hammer.on('rotate',this.props.onRotate);}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.hammer){this.hammer.stop();this.hammer.destroy();}this.hammer=null;}},{key:'render',value:function render(){var _this3=this;var props={};Object.keys(this.props).forEach(function(i){if(!privateProps[i]){props[i]=_this3.props[i];}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.props.component,props,this.props.children);}}]);return HammerWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);HammerWrapper.displayName='Hammer';HammerWrapper.propTypes={component:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].any,className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};HammerWrapper.defaultProps={component:'span'};/* harmony default export */ __webpack_exports__["a"] = (HammerWrapper);

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return Hammer;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores_MediaLibrary__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_MediaLibrary__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_FileList__ = __webpack_require__(2103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MediaLibrary=function(_mixin){_inherits(MediaLibrary,_mixin);function MediaLibrary(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MediaLibrary);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MediaLibrary.__proto__||Object.getPrototypeOf(MediaLibrary)).call.apply(_ref,[this].concat(args))),_this),_this.state={activeDir:{}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MediaLibrary,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores_MediaLibrary__["a" /* default */]);}},{key:'onError',value:function onError(errorMessage){__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(errorMessage);}},{key:'componentDidMount',value:function componentDidMount(){var params=this.props.params;__WEBPACK_IMPORTED_MODULE_5_actions_MediaLibrary__["a" /* default */].listDirectory(params.directoryId);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.params.directoryId!==this.props.params.directoryId){__WEBPACK_IMPORTED_MODULE_5_actions_MediaLibrary__["a" /* default */].listDirectory(nextProps.params.directoryId);}}},{key:'changeDirectory',value:function changeDirectory(directoryId){this.props.router.push('/media-library/'+directoryId);}},{key:'add',value:function add(){var directoryId=this.props.params.directoryId;this.props.router.push('/media-library/'+(directoryId||0)+'/upload');}},{key:'resetFilter',value:function resetFilter(){__WEBPACK_IMPORTED_MODULE_5_actions_MediaLibrary__["a" /* default */].resetFilter();}},{key:'deleteFiles',value:function deleteFiles(){this.refs.confirmDialog.show();}},{key:'toggleMode',value:function toggleMode(){__WEBPACK_IMPORTED_MODULE_5_actions_MediaLibrary__["a" /* default */].toggleMode();}},{key:'onConfirmDelete',value:function onConfirmDelete(){__WEBPACK_IMPORTED_MODULE_5_actions_MediaLibrary__["a" /* default */].delete(Object.keys(this.refs.fileList.getSelectedFiles()));this.refs.confirmDialog.dismiss();}},{key:'gotoFile',value:function gotoFile(file){var directoryId=this.props.params.directoryId;this.props.router.push('/media-library/'+(directoryId||0)+'/'+file.id);}},{key:'createDirectory',value:function createDirectory(name){var breadcrumbs=this.state.breadcrumbs;__WEBPACK_IMPORTED_MODULE_5_actions_MediaLibrary__["a" /* default */].createDirectory(breadcrumbs&&breadcrumbs.length>0&&breadcrumbs[0].id||0,name);}},{key:'render',value:function render(){if(this.state.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_RulerBar__["a" /* default */],{title:this.context.getIntlMessage('menu.mediaLibrary')}),className:'settings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_Loader__["b" /* default */],null));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_AppPage__["a" /* default */],{key:'settings',header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_RulerBar__["a" /* default */],{title:this.context.getIntlMessage('menu.mediaLibrary')}),className:'media-library',style:{zIndex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_FileList__["a" /* default */],{onCreateDirectory:this.createDirectory.bind(this),onToggleMode:this.toggleMode.bind(this),grid:this.state.grid,breadcrumbs:this.state.breadcrumbs,onChangeDirectory:this.changeDirectory.bind(this),items:this.state.list,labelProperty:'name',onTouchTapItem:this.gotoFile.bind(this),hasDivider:false,floatingActionButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui__["FloatingActionButton"],{onTouchTap:this.add.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentAdd"],null))},this.props.children));}}]);return MediaLibrary;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));MediaLibrary.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (MediaLibrary);

/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SearchBarToolbar__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ResponsiveImage__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_DialogPortal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_Message__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={root:{position:'relative',height:'100%'},floatingActionButton:{position:'fixed',zIndex:3},list:{marginTop:Spacing.desktopGutter,boxSizing:'border-box'},searchBar:{boxSizing:'border-box'},avatar:{cursor:'pointer',display:'inline-block',verticalAlign:'top',borderRadius:0},gridItem:{cursor:'pointer',display:'inline-block',verticalAlign:'top',margin:Spacing.desktopGutterMini/2,boxSizing:'border-box',position:'relative'},gridName:{position:'absolute',left:0,right:0,bottom:0,// height: 24,
whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',fontSize:'10px',backgroundColor:'rgba(100, 100, 100, 0.5)',color:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].darkWhite,boxSizing:'border-box',padding:2},breadcrumb:{// backgroundColor: 'transparent',
minWidth:32,display:'inline-block',margin:'10px 2px',padding:'0px 4px'}};var gridSize=140;var FileList=function(_Component){_inherits(FileList,_Component);function FileList(){_classCallCheck(this,FileList);var _this=_possibleConstructorReturn(this,(FileList.__proto__||Object.getPrototypeOf(FileList)).apply(this,arguments));var itemCount=25;var grid=_this.props.grid;if(grid){itemCount=Math.floor(window.innerWidth/gridSize)*Math.ceil(window.innerHeight/gridSize);}else{itemCount=Math.ceil(window.innerHeight/70);}_this.state={maxItems:itemCount,deleted:{}};return _this;}_createClass(FileList,[{key:'onTouchTapItem',value:function onTouchTapItem(item){if(item.type==='dir'){this.props.onChangeDirectory(item.id);}else if(this.props.onTouchTapItem){this.props.onTouchTapItem(item);}}},{key:'onScrollToBottom',value:function onScrollToBottom(){var increment=3;if(this.props.grid){increment=Math.floor(window.innerWidth/gridSize)*3;}this.setState({maxItems:this.state.maxItems+increment});}},{key:'getFloatingActionButtonStyle',value:function getFloatingActionButtonStyle(){var _context=this.context,muiTheme=_context.muiTheme,media=_context.media;return Object.assign({},styles.floatingActionButton,{right:media==='phone'?Spacing.desktopGutter:Spacing.desktopKeylineIncrement/2,bottom:media==='phone'?Spacing.desktopGutter:null,top:media!=='phone'?muiTheme.toolbar.height*2-muiTheme.floatingActionButton.buttonSize/2:null});}},{key:'getStyle',value:function getStyle(hasDetail){return Object.assign({},styles.root,{backgroundColor:this.context.muiTheme.primary1Color});}},{key:'getDetailStyle',value:function getDetailStyle(){var left=8;var right=8;if(this.context.media==='desktop'){left=Spacing.desktopKeylineIncrement*7;right=Spacing.desktopKeylineIncrement*2;}else if(this.context.media==='tablet'){left=Spacing.desktopKeylineIncrement*6;right=Spacing.desktopKeylineIncrement*2;}return{position:'absolute',left:left,right:right,top:0,bottom:0,backgroundColor:this.context.muiTheme.rawTheme.palette.cardColor,overflow:'auto',transition:'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',zIndex:2// transform: 'translate3d(0,0,0)'
};}},{key:'getToolbarStyle',value:function getToolbarStyle(hasDetail){var style={backgroundColor:this.context.muiTheme.primary1Color,borderStyle:'none none solid none',borderWidth:'1px',borderColor:'#DDD'};if(hasDetail){if(this.context.media==='desktop'){style.width=Spacing.desktopKeylineIncrement*7;}else if(this.context.media==='tablet'){style.width=Spacing.desktopKeylineIncrement*6;}}return style;}},{key:'getSearchHeaderStyle',value:function getSearchHeaderStyle(){var palette=this.context.muiTheme.rawTheme.palette;return Object.assign({},{backgroundColor:palette.primary1Color});}},{key:'getListStyle',value:function getListStyle(){var hasDetail=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var media=this.context.media;return Object.assign({},styles.list,hasDetail?{width:media==='desktop'?Spacing.desktopKeylineIncrement*7:Spacing.desktopKeylineIncrement*6}:null);}},{key:'getSearchBarStyle',value:function getSearchBarStyle(){var hasDetail=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var media=this.context.media;var style={};if(hasDetail){if(media==='desktop'){style.width=Spacing.desktopKeylineIncrement*7;}else if(media==='tablet'){style.width=Spacing.desktopKeylineIncrement*6;}}else if(media!=='phone'){style.marginRight=Spacing.desktopKeylineIncrement*1.5;style.marginLeft=Spacing.desktopKeylineIncrement*1.5;}return Object.assign({},styles.searchBar,style);}},{key:'filter',value:function filter(item,searchText,labelProperty){if(searchText&&searchText!==''){return item[labelProperty].search(searchText)>-1;}return true;}},{key:'searchTextChange',value:function searchTextChange(searchText){var _this2=this;if(this._timer){clearTimeout(this._timer);}this._timer=setTimeout(function(){_this2.setState({searchText:searchText});},150);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var maxItems=this.state.maxItems;if(nextProps.grid&&!this.props.grid){var itemCount=Math.floor(window.innerWidth/gridSize)*Math.ceil(window.innerHeight/gridSize);if(itemCount>maxItems){this.setState({maxItems:itemCount});}}}},{key:'toggleMode',value:function toggleMode(){if(this.props.onToggleMode){this.props.onToggleMode();}}},{key:'changeDirectory',value:function changeDirectory(directoryId){if(this.props.onChangeDirectory){this.props.onChangeDirectory(directoryId);}}},{key:'createDirectory',value:function createDirectory(){this.refs.createDialog.show();}},{key:'confirmCreate',value:function confirmCreate(){var name=this.refs.directoryName.getValue();if(name.trim().length!=0){this.refs.createDialog.dismiss();if(this.props.onCreateDirectory){this.props.onCreateDirectory(name);}}else{__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info('Folder name cannot be a space');}}},{key:'render',value:function render(){var _this3=this;var children=[];var list=void 0;var detail=void 0;var floatingActionButton=void 0;var regexp='';var items=this.props.items;var _props=this.props,sort=_props.sort,labelProperty=_props.labelProperty,grid=_props.grid;var searchText=this.state.searchText;var size=grid?gridSize:40;var filter=this.props.filter||this.filter;if(searchText&&searchText!==''){regexp=new RegExp(searchText,'i');}items=items.filter(function(item){var created=item.created&&item.created.split(' ').join('T')+'Z';item.creationDate=new Date(created);return!item.deleted&&filter(item,regexp,labelProperty);});if(sort&&sort.property){var sortProperty=sort.property;var sortDirection=sort.direction;items.sort(function(left,right){if(left.type==='dir'&&right.type!=='dir'){return-1;}else if(left.type!=='dir'&&right.type==='dir'){return 1;}if(typeof left[sortProperty]==='string'){var _leftProp=left[sortProperty].toUpperCase();var _rightProp=right[sortProperty].toUpperCase();if(_leftProp<_rightProp)return sortDirection==='asc'?-1:1;if(_leftProp>_rightProp)return sortDirection==='asc'?1:-1;return 0;}var leftProp=left[sortProperty];var rightProp=right[sortProperty];if(leftProp<rightProp)return sortDirection==='asc'?-1:1;if(leftProp>rightProp)return sortDirection==='asc'?1:-1;return 0;});}items=items.splice(0,this.state.maxItems);for(var i=0;i<items.length;i++){var file=items[i];var id=file.id,name=file.name;var fileType=file.type;// const fileType = type.substring(0, type.indexOf('/'));
var thumb=void 0;if(fileType==='image'){// let tokens = file.url.split('.');
// let extension = tokens.pop();
// thumb = <Avatar src={tokens.join('.')+'-40.'+extension}/>;
//thumb = <Avatar size={size} src={file.url} style={{borderRadius: 0}}/>;
thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ResponsiveImage__["a" /* default */],{contain:true,size:size,style:{width:size,height:size},src:file.url});}else if(fileType==='video'){thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Avatar"],{size:size,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["AvMovie"],null),style:styles.avatar});}else if(fileType==='audio'){thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Avatar"],{size:size,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageAudiotrack"],null),style:styles.avatar});}else if(fileType==='dir'){thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Avatar"],{backgroundColor:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].lightBlue[400].material,size:size,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["FileFolder"],{color:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].lightBlue[400].material}),style:styles.avatar});}else{thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Avatar"],{size:size,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["EditorInsertDriveFile"],null),style:styles.avatar});}var createdTime=file.created&&file.created.split(' ').join('T')+'Z'||null;//      item.creationDate = new Date(item.created);
// const createdTime = file.created && file.created.split(' ').join('T') || null;
var date=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].minBlack}},createdTime&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedDate"],{value:new Date(createdTime)})||'');// const date = createdTime;
if(grid){var gridItem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.gridItem,key:id,onTouchTap:this.onTouchTapItem.bind(this,file)},thumb,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.gridName},name));children.push(gridItem);}else{children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListItem"],{leftAvatar:thumb,key:'i-'+id,onTouchTap:this.onTouchTapItem.bind(this,file),primaryText:name,secondaryText:date}));children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListDivider"],{key:'d-'+id}));}}var hasDetail=!!this.props.children;floatingActionButton=this.props.floatingActionButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.floatingActionButton,{style:this.getFloatingActionButtonStyle(hasDetail)});if(hasDetail){detail=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Paper"],{style:this.getDetailStyle(hasDetail),zDepth:2},this.props.children);}var switchIcon=void 0;if(grid){switchIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ActionViewList"],{color:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,hoverColor:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material});}else{switchIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ActionViewModule"],{color:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,hoverColor:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material});}// let upButton;
var crumbs=this.props.breadcrumbs.slice().reverse();crumbs.unshift({id:0,name:this.context.getIntlMessage('menu.mediaLibrary')});var breadCrumbs=crumbs.map(function(current){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{style:styles.breadcrumb,onTouchTap:_this3.changeDirectory.bind(_this3,current.id),key:current.id,href:'/media-library/dir/'+current.id},current.name,'/');});// if (crumbs.length > 0) {
//   let directoryId = 0;
//   if (crumbs.length > 1) {
//     directoryId = crumbs[1].id;
//   }
//   upButton = (
//     <IconButton onTouchTap={this.changeDirectory.bind(this, directoryId)}>
//       <SvgIcons.HardwareKeyboardArrowUp color={Colors.Colors.fullWhite} hoverColor={Colors.Colors.grey[500].material}/>
//     </IconButton>
//   );
// }
var helperBar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ToolbarGroup"],{style:{margin:0},float:'left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ToolbarGroup"],{float:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{primary:true,style:{margin:'10px 2px'},onTouchTap:this.createDirectory.bind(this),label:this.context.getIntlMessage('mediaLibrary.createDir')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{onTouchTap:this.toggleMode.bind(this)},switchIcon)));if(grid){list=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getListStyle()},breadCrumbs,helperBar,children);}else{list=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getListStyle()},breadCrumbs,helperBar,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["List"],null,children));}var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getSearchHeaderStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getSearchBarStyle(hasDetail)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_SearchBarToolbar__["a" /* default */],{fullWidth:true,onChange:this.searchTextChange.bind(this)})));var createActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('Create'),onTouchTap:this.confirmCreate.bind(this)})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getStyle(hasDetail)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ScrollableContainer__["a" /* default */],{containerStyle:{backgroundColor:this.context.muiTheme.canvasColor},header:toolbar,onScrollToBottom:this.onScrollToBottom.bind(this)},list),floatingActionButton,detail,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Dialog"],{ref:'createDialog',title:this.context.getIntlMessage('mediaLibrary.createDir'),actions:createActions,actionFocus:'ok',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{onEnterKeyDown:this.confirmCreate.bind(this),ref:'directoryName',fullWidth:true,hintText:this.context.getIntlMessage('mediaLibrary.directoryName'),floatingLabelText:this.context.getIntlMessage('mediaLibrary.directoryName')}))));}}]);return FileList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FileList.displayName='FileList';FileList.propTypes={grid:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,hasDivider:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,labelProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,idProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,onTouchTapItem:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,searchText:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,initialItemCount:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,filterChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,filter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,sort:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,floatingActionButton:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,breadcrumbs:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};FileList.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};FileList.defaultProps={searchText:null,labelProperty:'name',idProperty:'id',initialItemCount:25,sort:{property:'creationDate',direction:'desc'},hasDivider:true,items:[],swipeEnabled:true,dangerouslySetInnerHTML:false};/* harmony default export */ __webpack_exports__["a"] = (FileList);

/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_DropZone__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Widgets_FileUpload__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_CircularProgress__ = __webpack_require__(115);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={root:{backgroundColor:'#FFF'},remaining:{fontSize:24,textAlign:'center',padding:Spacing.desktopGutter}};var MediaLibraryUpload=function(_Component){_inherits(MediaLibraryUpload,_Component);function MediaLibraryUpload(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MediaLibraryUpload);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MediaLibraryUpload.__proto__||Object.getPrototypeOf(MediaLibraryUpload)).call.apply(_ref,[this].concat(args))),_this),_this.state={progress:0,remaining:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MediaLibraryUpload,[{key:'progress',value:function progress(event){this.setState({progress:Math.floor(event.percent),remaining:event.remaining});}},{key:'attach',value:function attach(files,e){this.setState({progress:0});__WEBPACK_IMPORTED_MODULE_6_services_Message__["a" /* default */].info(this.context.getIntlMessage('mediaLibrary.uploadComplete'));__WEBPACK_IMPORTED_MODULE_7_actions__["o" /* MediaLibraryActions */].moveFiles(files);}},{key:'goBack',value:function goBack(){__WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* history */].goBack();}},{key:'render',value:function render(){var description=this.context.getIntlMessage('mediaLibrary.dropHere');var progress=void 0;if(this.state.progress>0){progress=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'auto',textAlign:'center',lineHeight:Spacing.desktopKeylineIncrement*4+'px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_CircularProgress__["a" /* default */],{progressColor:this.context.muiTheme.rawTheme.palette.primary1Color,progress:this.state.progress,size:2})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},this.context.getIntlMessage('mediaLibrary.Uploading')));}var busy=this.state.remaining>0||this.progress>0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ToolbarTitle"],{text:this.context.getIntlMessage('mediaLibrary.Upload')})),!busy&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ToolbarGroup"],{float:'right',key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('Close'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["ContentClear"],null),onTouchTap:this.goBack.bind(this)}))),this.state.remaining>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.remaining},this.state.remaining,' ',this.context.getIntlMessage('mediaLibrary.filesRemaining')),progress,!busy&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:Spacing.desktopGutterMore,textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_DropZone__["a" /* default */],{height:300,width:'100%',lineHeight:300,onProgress:this.progress.bind(this),onSuccess:this.attach.bind(this),multiple:true},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{margin:Spacing.desktopGutter,padding:0}},this.context.getIntlMessage('or')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Widgets_FileUpload__["a" /* default */],{multiple:true,fullWidth:true,className:'upload-button',onProgress:this.progress.bind(this),onSuccess:this.attach.bind(this),secondary:true,label:this.context.getIntlMessage('mediaLibrary.uploadFiles')}))));}}]);return MediaLibraryUpload;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MediaLibraryUpload.displayName='MediaLibraryUpload';MediaLibraryUpload.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (MediaLibraryUpload);

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Route_MediaLibrary_Detail__ = __webpack_require__(2106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_Loader__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MediaLibraryDetailContainer=function(_mixin){_inherits(MediaLibraryDetailContainer,_mixin);function MediaLibraryDetailContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MediaLibraryDetailContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MediaLibraryDetailContainer.__proto__||Object.getPrototypeOf(MediaLibraryDetailContainer)).call.apply(_ref,[this].concat(args))),_this),_this.goBack=function(){_this.props.router.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MediaLibraryDetailContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores__["n" /* MediaLibraryStore */]);}},{key:'componentWillMount',value:function componentWillMount(){if(_get(MediaLibraryDetailContainer.prototype.__proto__||Object.getPrototypeOf(MediaLibraryDetailContainer.prototype),'componentWillMount',this)){_get(MediaLibraryDetailContainer.prototype.__proto__||Object.getPrototypeOf(MediaLibraryDetailContainer.prototype),'componentWillMount',this).call(this);}var fileId=this.props.routeParams.fileId;__WEBPACK_IMPORTED_MODULE_1_actions__["o" /* MediaLibraryActions */].getFileInfo(fileId);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.routeParams.fileId!==nextProps.routeParams.fileId){__WEBPACK_IMPORTED_MODULE_1_actions__["o" /* MediaLibraryActions */].getFileInfo(nextProps.routeParams.fileId);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(_get(MediaLibraryDetailContainer.prototype.__proto__||Object.getPrototypeOf(MediaLibraryDetailContainer.prototype),'componentWillUnmount',this)){_get(MediaLibraryDetailContainer.prototype.__proto__||Object.getPrototypeOf(MediaLibraryDetailContainer.prototype),'componentWillUnmount',this).call(this);}__WEBPACK_IMPORTED_MODULE_1_actions__["o" /* MediaLibraryActions */].clearSelected();}},{key:'render',value:function render(){var selected=this.state.selected;if(!selected){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_Loader__["b" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Route_MediaLibrary_Detail__["a" /* default */],{key:selected.id,file:selected,onClose:this.goBack});}}]);return MediaLibraryDetailContainer;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));MediaLibraryDetailContainer.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (MediaLibraryDetailContainer);

/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_MediaLibrary__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_MediaLibrary__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Widgets_DetailPane__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_Spinner__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Grid_Grid__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Widgets_VideoPlayer__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_DialogPortal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _addMessages;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}Object(__WEBPACK_IMPORTED_MODULE_18_oxygen_i18n__["addMessages"])((_addMessages={},_defineProperty(_addMessages,'en-US',{'Download':'Download'}),_defineProperty(_addMessages,'sv-SE',{'Download':'Ladda ner'}),_addMessages));var ImageAudiotrack=__WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__["ImageAudiotrack"],AvMovie=__WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__["AvMovie"],EditorInsertDriveFile=__WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__["EditorInsertDriveFile"],ImageImage=__WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__["ImageImage"],ActionAccountBox=__WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__["ActionAccountBox"],EditorInsertLink=__WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__["EditorInsertLink"],ActionSchedule=__WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__["ActionSchedule"],EditorModeEdit=__WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__["EditorModeEdit"],ContentAdd=__WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__["ContentAdd"],ActionDelete=__WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__["ActionDelete"],ContentClear=__WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__["ContentClear"],ActionLabel=__WEBPACK_IMPORTED_MODULE_15_components_Material_SvgIcons__["ActionLabel"];var Spacing=__WEBPACK_IMPORTED_MODULE_7_material_ui__["Styles"].Spacing,Colors=__WEBPACK_IMPORTED_MODULE_7_material_ui__["Styles"].Colors;var types={audio:ImageAudiotrack,video:AvMovie};var MediaLibraryDetail=function(_mixin){_inherits(MediaLibraryDetail,_mixin);function MediaLibraryDetail(){_classCallCheck(this,MediaLibraryDetail);return _possibleConstructorReturn(this,(MediaLibraryDetail.__proto__||Object.getPrototypeOf(MediaLibraryDetail)).apply(this,arguments));}_createClass(MediaLibraryDetail,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores_MediaLibrary__["a" /* default */]);}},{key:'listenToActions',value:function listenToActions(){var _this2=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_5_actions_MediaLibrary__["a" /* default */].deleteComplete,function(file){__WEBPACK_IMPORTED_MODULE_11_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('mediaLibrary.removed'));if(_this2.props.onClose){_this2.props.onClose();}});this.listenToAction(__WEBPACK_IMPORTED_MODULE_5_actions_MediaLibrary__["a" /* default */].genericError,this.onError.bind(this));}},{key:'onError',value:function onError(errorMessage){__WEBPACK_IMPORTED_MODULE_11_services_Message__["a" /* default */].info(errorMessage);}},{key:'confirmDelete',value:function confirmDelete(file){__WEBPACK_IMPORTED_MODULE_5_actions_MediaLibrary__["a" /* default */].delete(file.id);}},{key:'deleteFile',value:function deleteFile(){this.refs.confirmDialog.show();}},{key:'closeDetail',value:function closeDetail(){if(this.props.onClose){this.props.onClose();}}},{key:'render',value:function render(){var file=this.props.file;var confirmActions=[{text:'Cancel'},{text:this.context.getIntlMessage('mediaLibrary.remove'),onTouchTap:this.confirmDelete.bind(this,file),ref:'submit'}];var coverStyle=void 0,thumb=void 0;var fileType=file.mime.substring(0,file.mime.indexOf('/'));if(fileType==='image'){coverStyle={backgroundImage:'url('+file.url+')'// backgroundImage: 'url(http://lorempixel.com/144/144/technics)'
};thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:file.url,style:{maxWidth:'100%'}}));}else if(fileType==='video'){var extension=file.url.split('.').pop();thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Widgets_VideoPlayer__["a" /* default */],{style:{display:'inline-block'},sources:[{url:file.url,type:'mp4'},{url:file.url,type:'ogg'}]});}else if(types[fileType]){var type=types[fileType];thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',height:Spacing.desktopKeylineIncrement*4}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('type',null));}else{__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EditorInsertDriveFile,null);thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',height:Spacing.desktopKeylineIncrement*4}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EditorInsertDriveFile,null));}var created=file.created&&file.created.split(' ').join('T')+'Z';var date=created&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedDate"],{value:new Date(created)})||'';var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ToolbarTitle"],{text:this.context.getIntlMessage('File')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ToolbarGroup"],{float:'right',key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('mediaLibrary.remove'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionDelete,null),onTouchTap:this.deleteFile.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('Close'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentClear,null),onTouchTap:this.closeDetail.bind(this)})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_ScrollableContainer__["a" /* default */],{header:toolbar,style:{backgroundColor:Colors.fullWhite}},thumb,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["List"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionLabel,null),primaryText:file.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionSchedule,null),primaryText:date}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EditorInsertLink,null),primaryText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:file.mime.includes('video')?file.url+file.mime.replace('video/','.'):file.url,download:true},this.context.getIntlMessage('Download'))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionAccountBox,null),primaryText:localStorage.displayName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'confirmDialog',title:this.context.getIntlMessage('mediaLibrary.remove'),actions:confirmActions,actionFocus:'submit',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('mediaLibrary.removeConfirm'),file:file.name}))));}}]);return MediaLibraryDetail;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_2_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));MediaLibraryDetail.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (MediaLibraryDetail);

/***/ }),
/* 2107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tasks__ = __webpack_require__(2108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_tasks__ = __webpack_require__(2118);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TasksContainer=function(_mixin){_inherits(TasksContainer,_mixin);function TasksContainer(){_classCallCheck(this,TasksContainer);return _possibleConstructorReturn(this,(TasksContainer.__proto__||Object.getPrototypeOf(TasksContainer)).apply(this,arguments));}_createClass(TasksContainer,[{key:'componentDidMount',value:function componentDidMount(){var _props$params=this.props.params,courseId=_props$params.courseId,userId=_props$params.userId,taskId=_props$params.taskId;__WEBPACK_IMPORTED_MODULE_2_actions__["E" /* TaskActions */].start({courseId:courseId,userId:userId,taskId:taskId});}},{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_1_stores__["y" /* TaskStore */],function(state){return{tasks:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_tasks__["c" /* getVisibleTasks */])(state),tasksFilter:state.tasks.filter,tasksLoading:state.tasks.loading,students:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_tasks__["b" /* getVisibleStudents */])(state),studentsLoading:state.students.loading,courses:Object(__WEBPACK_IMPORTED_MODULE_5_selectors_tasks__["a" /* getVisibleCourses */])(state),coursesLoading:state.courses.loading,coursesExpanded:state.courses.expanded,studentsExpanded:state.students.expanded,filterMode:state.filterMode};});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Tasks__["a" /* default */],this.state);}}]);return TasksContainer;}(Object(__WEBPACK_IMPORTED_MODULE_3_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_3_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (TasksContainer);

/***/ }),
/* 2108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Tasks_FilterBar__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_CardList__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Route_Task_TaskList__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Tasks_SearchBar__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Tasks_SearchList__ = __webpack_require__(2114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Tasks_ScrollableContainer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_oxygen_debounce__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_E',courseFilter:'_F',studentFilter:'_G',tasks:'_H',toggle:'_I'};var Tasks=function(_Component){_inherits(Tasks,_Component);function Tasks(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Tasks);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Tasks.__proto__||Object.getPrototypeOf(Tasks)).call.apply(_ref,[this].concat(args))),_this),_this.setCourseFilter=function(filter){__WEBPACK_IMPORTED_MODULE_6_actions__["E" /* TaskActions */].setCourseFilter(filter);},_this.setGroupsFilter=function(filter){__WEBPACK_IMPORTED_MODULE_6_actions__["E" /* TaskActions */].setGroupFilter(filter);},_this.setStudentsFilter=function(filter){__WEBPACK_IMPORTED_MODULE_6_actions__["E" /* TaskActions */].setStudentFilter(filter);},_this.toggle=function(list){__WEBPACK_IMPORTED_MODULE_6_actions__["E" /* TaskActions */].toggleExpand(list);},_this.selectCourse=function(course){var tasksFilter=_this.props.tasksFilter;if(tasksFilter.courseId===course.id){__WEBPACK_IMPORTED_MODULE_6_actions__["E" /* TaskActions */].setTaskFilter({courseId:null});}else{__WEBPACK_IMPORTED_MODULE_6_actions__["E" /* TaskActions */].setTaskFilter({courseId:course.id});}},_this.selectStudent=function(student){var tasksFilter=_this.props.tasksFilter;if(tasksFilter.userId===student.id){__WEBPACK_IMPORTED_MODULE_6_actions__["E" /* TaskActions */].setTaskFilter({userId:null});}else{__WEBPACK_IMPORTED_MODULE_6_actions__["E" /* TaskActions */].setTaskFilter({userId:student.id});}},_this.toggleCorrected=function(corrected){__WEBPACK_IMPORTED_MODULE_6_actions__["E" /* TaskActions */].toggleCorrected();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Tasks,[{key:'render',value:function render(){var _props=this.props,tasks=_props.tasks,tasksLoading=_props.tasksLoading,coursesExpanded=_props.coursesExpanded,studentsExpanded=_props.studentsExpanded,studentsLoading=_props.studentsLoading,coursesLoading=_props.coursesLoading,tasksFilter=_props.tasksFilter,courses=_props.courses,students=_props.students,filterMode=_props.filterMode;var getIntlMessage=this.context.getIntlMessage;var hasFilter=tasksFilter.userId||tasksFilter.courseId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_RulerBar__["a" /* default */],{title:this.context.getIntlMessage('menu.Tasks')})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.courseFilter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Tasks_SearchList__["a" /* default */],{expanded:coursesExpanded,onChange:this.setCourseFilter,onTouchTapItem:this.selectCourse,onRequestCollapse:this.toggle.bind(this,'courses'),onRequestExpand:this.toggle.bind(this,'courses'),placeholder:getIntlMessage('tasks.findCourse'),selected:tasksFilter.courseId,items:courses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentContentPaste"],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.studentFilter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Tasks_SearchList__["a" /* default */],{expanded:studentsExpanded,onChange:this.setStudentsFilter,onTouchTapItem:this.selectStudent,onRequestCollapse:this.toggle.bind(this,'students'),onRequestExpand:this.toggle.bind(this,'students'),placeholder:getIntlMessage('tasks.findStudent'),selected:tasksFilter.userId,items:students},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["SocialPersonOutline"],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.tasks},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Tasks_ScrollableContainer__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{label:getIntlMessage('tasks.showCorrected'),toggled:tasksFilter.corrected,onToggle:this.toggleCorrected}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Route_Task_TaskList__["a" /* default */],{tasks:tasks,hasFilter:hasFilter,tasksLoading:tasksLoading,selected:tasksFilter.taskId,taskMode:true})))));}}]);return Tasks;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Tasks.propTypes={tasks:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,tasksFilter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,coursesExpanded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,groupsExpanded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,students:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,courses:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,groups:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,tasksLoading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,studentsLoading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,coursesLoading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,groupsLoading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,filterMode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};Tasks.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Tasks);

/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grid__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FilterList__ = __webpack_require__(2110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_ec',filter:'_ed',filterToggle:'_ee'};var FilterBar=function(_Component){_inherits(FilterBar,_Component);function FilterBar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FilterBar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FilterBar.__proto__||Object.getPrototypeOf(FilterBar)).call.apply(_ref,[this].concat(args))),_this),_this._handleCorrected=function(event){var corrected=event.target.checked;__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].setTaskFilter({corrected:corrected});},_this._handleFilterChange=function(listName,filter){if(listName==='students'){__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].setStudentFilter(filter);}else if(listName==='courses'){__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].setCourseFilter(filter);}else if(listName==='groups'){__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].setGroupFilter(filter);}},_this._handleTaskFilterChange=function(listName,list){__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].setTaskFilter(_defineProperty({},listName,list));},_this.toggleMode=function(){__WEBPACK_IMPORTED_MODULE_1_actions__["E" /* TaskActions */].toggleFilterMode();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FilterBar,[{key:'render',value:function render(){var getIntlMessage=this.context.getIntlMessage;var _props=this.props,tasksFilter=_props.tasksFilter,students=_props.students,courses=_props.courses,groups=_props.groups,studentsFilter=_props.studentsFilter,coursesFilter=_props.coursesFilter,groupsFilter=_props.groupsFilter,studentsLoading=_props.studentsLoading,coursesLoading=_props.coursesLoading,groupsLoading=_props.groupsLoading,mode=_props.mode;var simple=mode==='simple';var switchIcon=simple?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["HardwareKeyboardArrowDown"],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["HardwareKeyboardArrowUp"],null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["b" /* GridContainer */],{fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["c" /* GridRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:4,xSmallSize:12}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:4,xSmallSize:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.filter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Toggle"],{toggled:tasksFilter.corrected,label:getIntlMessage('tasks.corrected'),onToggle:this._handleCorrected}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:4,xSmallSize:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.filterToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["IconButton"],{touch:true,onTouchTap:this.toggleMode},switchIcon)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["c" /* GridRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:4,xSmallSize:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FilterList__["a" /* default */],{mini:simple,title:getIntlMessage('tasks.students'),list:students,loading:studentsLoading,filter:studentsFilter,onFilterChange:this._handleFilterChange.bind(this,'students'),onChange:this._handleTaskFilterChange.bind(this,'students'),selected:tasksFilter.students})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:4,xSmallSize:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FilterList__["a" /* default */],{mini:simple,title:getIntlMessage('tasks.courses'),list:courses,loading:coursesLoading,filter:coursesFilter,onFilterChange:this._handleFilterChange.bind(this,'courses'),onChange:this._handleTaskFilterChange.bind(this,'courses'),selected:tasksFilter.courses})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Grid__["a" /* GridCell */],{size:4,xSmallSize:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FilterList__["a" /* default */],{mini:simple,title:getIntlMessage('tasks.groups'),list:groups,loading:groupsLoading,filter:groupsFilter,onFilterChange:this._handleFilterChange.bind(this,'groups'),onChange:this._handleTaskFilterChange.bind(this,'groups'),selected:tasksFilter.groups})))));}}]);return FilterBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FilterBar.propTypes={tasksFilter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,studentsFilter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,coursesFilter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,groupsFilter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,studentsLoading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,coursesLoading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,groupsLoading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,students:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,courses:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,groups:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,mode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};FilterBar.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* unused harmony default export */ var _unused_webpack_default_export = (FilterBar);

/***/ }),
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_CardList__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_eP',title:'_eQ',list:'_eR',mini:'_eS',bottomBar:'_eT',listItem:'_eU',selected:'_eV'};var FilterList=function(_Component){_inherits(FilterList,_Component);function FilterList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FilterList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FilterList.__proto__||Object.getPrototypeOf(FilterList)).call.apply(_ref,[this].concat(args))),_this),_this._handleFilterChange=function(event){var filter=event.target.value;var onFilterChange=_this.props.onFilterChange;onFilterChange&&onFilterChange(filter);},_this._handleTouchTap=function(item){var _this$props=_this.props,onChange=_this$props.onChange,selected=_this$props.selected;onChange&&onChange(Object.assign({},selected,_defineProperty({},item.id,!selected[item.id])));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FilterList,[{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,list=_props.list,selected=_props.selected,loading=_props.loading,filter=_props.filter,mini=_props.mini;var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CardList__["a" /* default */],{mini:mini,constrained:true,header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{fullWidth:true,hintText:title,onChange:this._handleFilterChange,value:filter}),footer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["FormattedMessage"],{message:getIntlMessage('selectedCount'),num:Object.keys(selected).length})},loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__["b" /* default */],null),!loading&&list.map(function(item){var id=item.id;if(id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,onTouchTap:_this2._handleTouchTap.bind(_this2,item),className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.listItem,selected[id]&&css.selected)},item.name);}}));}}]);return FilterList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FilterList.propTypes={title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,filter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,list:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,onFilterChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,loading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,mini:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};FilterList.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (FilterList);

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(2112);
moment.tz.load(__webpack_require__(2113));


/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.32
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(97)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(97)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.32",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 2113 */
/***/ (function(module, exports) {

module.exports = {"version":"2020d","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Tasks_SearchBar__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Tasks_ScrollableContainer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_List__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_dY',expanded:'_dZ',uncorrected:'_d0'};var SearchList=function(_Component){_inherits(SearchList,_Component);function SearchList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SearchList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchList.__proto__||Object.getPrototypeOf(SearchList)).call.apply(_ref,[this].concat(args))),_this),_this.onTouchTapItem=function(item){var onTouchTapItem=_this.props.onTouchTapItem;onTouchTapItem&&onTouchTapItem(item);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchList,[{key:'render',value:function render(){var _this2=this;var _props=this.props,items=_props.items,expanded=_props.expanded,selected=_props.selected,other=_objectWithoutProperties(_props,['items','expanded','selected']);var classes=__WEBPACK_IMPORTED_MODULE_4_classnames___default()(css.root,_defineProperty({},css.expanded,expanded));if(!expanded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Tasks_SearchBar__["a" /* default */],Object.assign({expanded:expanded},other));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Tasks_ScrollableContainer__["a" /* default */],{className:classes,header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Tasks_SearchBar__["a" /* default */],Object.assign({expanded:expanded},other))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_List__["a" /* List */],null,items.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_List__["b" /* ListItem */],{key:item.id,selected:selected===item.id,onTouchTap:_this2.onTouchTapItem.bind(_this2,item)},item.uncorrectedCount>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.uncorrected},item.uncorrectedCount):null,item.name);})));}}]);return SearchList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SearchList.propTypes={items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number]),onTouchTapItem:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,expanded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (SearchList);

/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var List=function(_Component){_inherits(List,_Component);function List(){_classCallCheck(this,List);return _possibleConstructorReturn(this,(List.__proto__||Object.getPrototypeOf(List)).apply(this,arguments));}_createClass(List,[{key:'render',value:function render(){var _props=this.props,children=_props.children,other=_objectWithoutProperties(_props,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',other,children);}}]);return List;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);List.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_gn',padded:'_go',responsive:'_gp',divider:'_gq',card:'_gr',selected:'_gs'};var ListItem=function(_Component){_inherits(ListItem,_Component);function ListItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ListItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ListItem.__proto__||Object.getPrototypeOf(ListItem)).call.apply(_ref,[this].concat(args))),_this),_this.handleTouchTap=function(){var _this$props=_this.props,payload=_this$props.payload,onTouchTap=_this$props.onTouchTap;onTouchTap&&onTouchTap(payload);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ListItem,[{key:'render',value:function render(){var _classNames;var _props=this.props,children=_props.children,divider=_props.divider,responsive=_props.responsive,selected=_props.selected,card=_props.card,padded=_props.padded,other=_objectWithoutProperties(_props,['children','divider','responsive','selected','card','padded']);var classes=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.root,(_classNames={},_defineProperty(_classNames,css.padded,padded),_defineProperty(_classNames,css.selected,selected),_defineProperty(_classNames,css.divider,divider),_defineProperty(_classNames,css.card,card),_defineProperty(_classNames,css.responsive,responsive),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:classes},other,{onTouchTap:this.handleTouchTap}),children);}}]);return ListItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ListItem.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,payload:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array]),selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,divider:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,card:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,padded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onTouchTap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,responsive:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};ListItem.defaultProps={padded:true};/* harmony default export */ __webpack_exports__["a"] = (ListItem);

/***/ }),
/* 2117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_gt'};var ListItem=function(_Component){_inherits(ListItem,_Component);function ListItem(){_classCallCheck(this,ListItem);return _possibleConstructorReturn(this,(ListItem.__proto__||Object.getPrototypeOf(ListItem)).apply(this,arguments));}_createClass(ListItem,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root});}}]);return ListItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (ListItem);

/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getVisibleTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVisibleCourses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getVisibleStudents; });
/* unused harmony export getVisibleGroups */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var makeGetVisibleTasks=function makeGetVisibleTasks(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.tasks.list;},function(state){return state.tasks.entities;},function(state){return state.tasks.filter;},function(state){return state.students.filter;},function(list,entities,filter,student){var tasks=list.map(function(taskId){return Object.assign({},entities[taskId]);});if(student){var regexp=new RegExp(student,'i');tasks.forEach(function(task){task.taskResults=task.taskResults.filter(function(result){return result.user.name.search(regexp)>-1;});});}if(filter.corrected){return tasks;}else{return tasks.filter(function(task){return task.type===4||task.type===7;}).map(function(task){var taskResultLength=task.taskResults.length;return Object.assign({},task,{taskResults:(task.taskResults||[]).filter(function(result){return!result.feedback||!result.feedback.created||!result.feedbackFiles||result.feedbackFiles.length<1;})});}).filter(function(task){return task.taskResults.length>0;});}});};var getVisibleTasks=makeGetVisibleTasks();var makeGetVisibleCourses=function makeGetVisibleCourses(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.courses.list;},function(state){return state.courses.entities;},function(state){return state.courses.filter;},function(list,entities,filter){var courses=list.map(function(id){return entities[id];});if(filter){var regexp=new RegExp(filter,'i');courses=courses.filter(function(item){return item.name.search(regexp)>-1;});}courses.sort(function(a,b){if(a.uncorrectedCount>b.uncorrectedCount){return-1;}if(a.uncorrectedCount<b.uncorrectedCount){return 1;}return 0;});return courses;});};var getVisibleCourses=makeGetVisibleCourses();var makeGetVisibleStudents=function makeGetVisibleStudents(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.students.list;},function(state){return state.students.entities;},function(state){return state.students.filter;},function(list,entities,filter){var students=list.map(function(id){return entities[id];});if(filter){var regexp=new RegExp(filter,'i');students=students.filter(function(item){return item.name.search(regexp)>-1;});}students.sort(function(a,b){if(a.uncorrectedCount>b.uncorrectedCount){return-1;}if(a.uncorrectedCount<b.uncorrectedCount){return 1;}return 0;});return students;});};var getVisibleStudents=makeGetVisibleStudents();var makeGetVisibleGroups=function makeGetVisibleGroups(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.groups.list;},function(state){return state.groups.entities;},function(state){return state.groups.filter;},function(list,entities,filter){var groups=list.map(function(id){return entities[id];});if(filter){var regexp=new RegExp(filter,'i');return groups.filter(function(item){return item.name.search(regexp)>-1;});}return groups;});};var getVisibleGroups=makeGetVisibleGroups();

/***/ }),
/* 2119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Quizzes__ = __webpack_require__(2120);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TasksContainer=function(_mixin){_inherits(TasksContainer,_mixin);function TasksContainer(){_classCallCheck(this,TasksContainer);return _possibleConstructorReturn(this,(TasksContainer.__proto__||Object.getPrototypeOf(TasksContainer)).apply(this,arguments));}_createClass(TasksContainer,[{key:'componentDidMount',value:function componentDidMount(){var _props$params=this.props.params,courseId=_props$params.courseId,userId=_props$params.userId,taskId=_props$params.taskId;__WEBPACK_IMPORTED_MODULE_2_actions__["x" /* QuizDetailActions */].start({courseId:courseId,userId:userId,taskId:taskId});}},{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores__["q" /* QuizDetailStore */]);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Quizzes__["a" /* default */],this.state);}}]);return TasksContainer;}(Object(__WEBPACK_IMPORTED_MODULE_3_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_3_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (TasksContainer);

/***/ }),
/* 2120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Route_Task__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Route_Task_TaskList__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['cancel'],['cancel']),_templateObject2=_taggedTemplateLiteral(['lock'],['lock']),_templateObject3=_taggedTemplateLiteral(['unlock'],['unlock']),_templateObject4=_taggedTemplateLiteral(['collapse'],['collapse']),_templateObject5=_taggedTemplateLiteral(['show'],['show']),_templateObject6=_taggedTemplateLiteral(['courses'],['courses']),_templateObject7=_taggedTemplateLiteral(['Are you sure you would like to ',' the quiz'],['Are you sure you would like to ',' the quiz']),_templateObject8=_taggedTemplateLiteral(['customExport'],['customExport']),_templateObject9=_taggedTemplateLiteral(['Quiz Finnished tooltip'],['Quiz Finnished tooltip']),_templateObject10=_taggedTemplateLiteral(['Finnished'],['Finnished']),_templateObject11=_taggedTemplateLiteral(['Quiz status tooltip'],['Quiz status tooltip']),_templateObject12=_taggedTemplateLiteral(['Status'],['Status']),_templateObject13=_taggedTemplateLiteral(['Score'],['Score']),_templateObject14=_taggedTemplateLiteral(['Total tooltip'],['Total tooltip']),_templateObject15=_taggedTemplateLiteral(['Total'],['Total']),_templateObject16=_taggedTemplateLiteral(['Duration tooltip'],['Duration tooltip']),_templateObject17=_taggedTemplateLiteral(['Duration'],['Duration']),_templateObject18=_taggedTemplateLiteral(['success'],['success']),_templateObject19=_taggedTemplateLiteral(['failed'],['failed']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_eL',list:'_eM',container:'_eN',active:'_eO'};var Quizzes=function(_mixin){_inherits(Quizzes,_mixin);function Quizzes(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Quizzes);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Quizzes.__proto__||Object.getPrototypeOf(Quizzes)).call.apply(_ref,[this].concat(args))),_this),_this.state={userId:null,toggleLock:null,standardActions:[{text:Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject)},{text:'Unlock'}],courseOpen:true,pageOpen:false,studentOpen:true,value:'',limit:20,currentDataUserId:null,currentCourseId:null,quizData:[],quizStudents:[],selectedPage:null,studentData:null,loading:false},_this.constructQuiz=function(quizData){var result=[];for(var key in quizData){var quizConstructor=quizData;quizConstructor[key].id=key;result.push(quizConstructor[key]);}return result;},_this.handleLoadMore=function(){var _this$state=_this.state,currentCourseId=_this$state.currentCourseId,currentDataUserId=_this$state.currentDataUserId,limit=_this$state.limit;_this.setState(function(state){return{limit:state.limit+20};},function(){__WEBPACK_IMPORTED_MODULE_2_actions__["x" /* QuizDetailActions */].selectUser(currentCourseId,currentDataUserId,0,limit);});},_this.handleChangeText=function(e){_this.setState({value:e.target.value});},_this.handleSelectPage=function(id){_this.setState({selectedPage:id,studentData:null,currentDataUserId:null});// QuizDetailActions.selectPage(id);
},_this.handleSelectCourse=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id){var pageStart,f,data,pageId,tasksKeys;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({currentCourseId:id,selectedPage:null,studentData:null,currentDataUserId:null,pageOpen:false});__WEBPACK_IMPORTED_MODULE_2_actions__["x" /* QuizDetailActions */].findTaskStudents(id);pageStart=0;f=function f(){return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_2_actions__["x" /* QuizDetailActions */].selectCourse(id,null,pageStart++*20,20,resolve);});};case 4:if(false){_context.next=16;break;}_context.next=7;return f();case 7:data=_context.sent;if(Object.keys(data).length){_context.next=10;break;}return _context.abrupt('break',16);case 10:pageId=Object.keys(data)[0];tasksKeys=Object.keys(data&&data[pageId]&&data[pageId].tasks);if(tasksKeys.length){_context.next=14;break;}return _context.abrupt('break',16);case 14:_context.next=4;break;case 16:_this.setState({pageOpen:true});case 17:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.handleSelectUser=function(id){if(Array.isArray(_this.state.quizData)){var selectedPage=_this.state.selectedPage;var quizData=JSON.parse(JSON.stringify(_this.state.quizData));_this.setState({currentDataUserId:id,limit:40,studentData:null});quizData.forEach(function(mockedQuiz){if(mockedQuiz.id===selectedPage){var result=[];var mockedTasks=mockedQuiz.tasks;var statsKeys=Object.keys(mockedQuiz.userStats).filter(function(el){return Number(el)===id;});var dataKeys=Object.keys(mockedQuiz.userdata).filter(function(el){return Number(el)===id;});var taskKeys=Object.keys(mockedQuiz.tasks);taskKeys.forEach(function(taskKey){result.push(Object.assign({},mockedQuiz.tasks[taskKey]));});var task=result.map(function(el){return el.taskResults.filter(function(taskResult){return taskResult.user.id===id;});}).filter(function(el){return el.length>0;});taskKeys.forEach(function(taskKey,i){mockedTasks[taskKey].taskResults=task[i];});var studentData=_defineProperty({},mockedQuiz.id,{id:mockedQuiz.id,page:mockedQuiz.page,tasks:mockedTasks,userStats:mockedQuiz.userStats[statsKeys[0]],userdata:mockedQuiz.userdata[dataKeys[0]]});if(!mockedQuiz.userStats[statsKeys[0]]&&!mockedQuiz.userdata[statsKeys[0]]){_this.setState({studentData:null});}else{_this.setState({studentData:studentData});}}});}},_this.handleOpen=function(id,toggleLock){var actionText=toggleLock?{text:Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject2),onClick:_this.handleReset}:{text:Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject3),onClick:_this.handleReset};var standardActions=_this.state.standardActions;standardActions[1]=Object.assign({},standardActions[1],actionText);_this.setState({userId:id,toggleLock:toggleLock,standardActions:standardActions});_this.refs.confirm.show();},_this.handleReset=function(){var _this$state2=_this.state,userId=_this$state2.userId,toggleLock=_this$state2.toggleLock,selectedPage=_this$state2.selectedPage,quizData=_this$state2.quizData;__WEBPACK_IMPORTED_MODULE_2_actions__["x" /* QuizDetailActions */].resetPage(userId,toggleLock,selectedPage,quizData);_this.refs.confirm.dismiss();},_this.handleChange=function(e){if(e.target.name==='students'){var quizStudents=_this.props.quizStudents;_this.setState({quizStudents:quizStudents.filter(function(student){if(student.name.toLowerCase().includes(e.target.value.toLowerCase())){return student;}})});}else if(e.target.name==='pages'){var quizData=_this.props.quizData;var constructedQuizData=_this.constructQuiz(quizData);_this.setState({quizData:constructedQuizData.filter(function(data){if(data.page.name.toLowerCase().includes(e.target.value.toLowerCase())){return data;}})});}else{_this.setState(_defineProperty({},e.target.name,_this.props[e.target.name].list.filter(function(k){if(_this.props[e.target.name].entities[k].page){return _this.props[e.target.name].entities[k].page.name.toLowerCase().includes(e.target.value.toLowerCase());}return _this.props[e.target.name].entities[k].name.toLowerCase().includes(e.target.value.toLowerCase());})));}},_this.courseChange=function(e){_this.setState({courseOpen:!_this.state.courseOpen});},_this.pageChange=function(e){_this.setState({pageOpen:!_this.state.pageOpen});},_this.studentChange=function(e){_this.setState({studentOpen:!_this.state.studentOpen});},_this.export=function(){var re=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var email=null;if(re.test(String(_this.state.value).toLowerCase())){email=_this.state.value;}__WEBPACK_IMPORTED_MODULE_2_actions__["x" /* QuizDetailActions */].export(email);_this.refs.exportDialog.dismiss();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Quizzes,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _state=this.state,quizData=_state.quizData,quizStudents=_state.quizStudents;if(nextProps.studentData){this.setState({studentData:nextProps.studentData});}if(nextProps.quizStudents&&nextProps.quizStudents.length>0){if(JSON.stringify(nextProps.quizStudents)!==JSON.stringify(quizStudents)){this.setState({quizStudents:nextProps.quizStudents});}}if(!quizData&&nextProps.quizData&&!Array.isArray(nextProps.quizData)){this.setState({quizData:this.constructQuiz(nextProps.quizData),pageOpen:true});}else if(nextProps.quizData&&!Array.isArray(nextProps.quizData)){var propsKeys=Object.keys(nextProps.quizData);var stateKeys=[];if(quizData.length>1){quizData.forEach(function(el){stateKeys.push(el.id);});}else if(quizData.length>0){stateKeys.push(quizData[0].id);}if(JSON.stringify(propsKeys)!==JSON.stringify(stateKeys)){this.setState({quizData:this.constructQuiz(nextProps.quizData),pageOpen:true,loading:false});}else{this.setState({loading:true});}}if(quizData&&Array.isArray(nextProps.quizData)){this.setState({quizData:[],pageOpen:false});}}},{key:'render',value:function render(){var _this3=this;var _state2=this.state,currentDataUserId=_state2.currentDataUserId,studentData=_state2.studentData,selectedPage=_state2.selectedPage,standardActions=_state2.standardActions,currentCourseId=_state2.currentCourseId,quizStudents=_state2.quizStudents,studentOpen=_state2.studentOpen,pageOpen=_state2.pageOpen,courseOpen=_state2.courseOpen,quizData=_state2.quizData,loading=_state2.loading;var courses=this.state.courses?this.state.courses:this.props.courses.list;// const pages = this.state.pages ? this.state.pages : this.props.pages.list;
// const students = this.state.students
//   ? this.state.students
//   : this.props.students.list;
var exportActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Export'),onTouchTap:this.export,ref:'submit'}];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_RulerBar__["a" /* default */],{title:'Quiz'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["List"],{style:{width:!courseOpen&&'50px',backgroundColor:'white',overflowY:'auto',overflowX:'hidden'},className:css.list,subheaderStyle:{paddingRight:'16px',textOverflow:'ellipsis',overflow:'hidden',height:'50px',whiteSpace:'nowrap'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["IconButton"],{tooltip:courseOpen?Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject4):Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject5),name:'courseOpen',onClick:this.courseChange,style:{color:'rgba(0,0,0,0.3)'}},courseOpen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ActionSearch"],null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ContentContentPaste"],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{name:'courses',style:{marginRight:15,marginBottom:5,width:'calc(100% - 70px)',float:'right',overflow:'hidden'},fullWidth:true,onChange:this.handleChange,hintText:this.props.courses.selectedCourse?this.props.courses.entities[this.props.courses.selectedCourse].name:Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject6)}),courseOpen&&courses.map(function(q){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ListItem"],{className:currentCourseId===q?css.active:'',key:q,style:{fontSize:'14px'},onClick:function onClick(){return _this3.handleSelectCourse(q);},primaryText:_this3.props.courses.entities[q].name});})),(pageOpen||selectedPage)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["List"],{style:{width:!pageOpen&&'50px',backgroundColor:'white',overflowY:'auto',overflowX:'hidden'},className:css.list,subheaderStyle:{paddingRight:'16px',textOverflow:'ellipsis',overflow:'hidden',height:'50px',whiteSpace:'nowrap'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["IconButton"],{tooltip:pageOpen?Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject4):Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject5),name:'pageOpen',onClick:this.pageChange,style:{color:'rgba(0,0,0,0.3)'}},pageOpen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ActionSearch"],null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["SocialPages"],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{name:'pages',style:{marginRight:15,marginBottom:5,width:'calc(100% - 70px)',float:'right',overflow:'hidden'},fullWidth:true,onChange:this.handleChange,hintText:'Search page'}),quizData.map(function(q){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ListItem"],{key:q.id,className:selectedPage===q.id?css.active:'',style:{fontSize:'14px'},onClick:function onClick(){return _this3.handleSelectPage(q.id);},primaryText:q.page.name});})),selectedPage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["List"],{style:{width:!studentOpen&&'50px',backgroundColor:'white',overflowY:'auto',overflowX:'hidden'},className:css.list,subheaderStyle:{paddingRight:'16px',textOverflow:'ellipsis',overflow:'hidden',height:'50px',whiteSpace:'nowrap'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["IconButton"],{tooltip:studentOpen?Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject4):Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject5),name:'studentOpen',onClick:this.studentChange,style:{color:'rgba(0,0,0,0.3)'}},studentOpen?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ActionSearch"],null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["SocialPersonOutline"],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{name:'students',style:{marginBottom:5,marginRight:15,width:'calc(100% - 70px)',float:'right',overflow:'hidden'},fullWidth:true,onChange:this.handleChange,hintText:'Search students'}),studentOpen&&quizStudents.map(function(student){var user=void 0,lockStatus=void 0;quizData.forEach(function(page){if(page.id===selectedPage){Object.keys(page.userdata).forEach(function(key){if(Number(key)===student.id){user=page.userdata[key];lockStatus=page.userdata[key]&&page.userdata[key].locked;}});}});var courses=_this3.props.courses;var repeatable=courses.entities[currentCourseId]&&courses.entities[currentCourseId].settings.quiz&&courses.entities[currentCourseId].settings.quiz.pages&&courses.entities[currentCourseId].settings.quiz.pages[selectedPage]&&courses.entities[currentCourseId].settings.quiz.pages[selectedPage].repeatable;var lockButton=user&&!lockStatus&&!repeatable?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["IconButton"],{onClick:function onClick(){return _this3.handleOpen(student.id,!lockStatus);},tooltip:'Lock Quiz'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ActionLockOpen"],null)):user&&lockStatus&&!repeatable?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["IconButton"],{onClick:function onClick(){return _this3.handleOpen(student.id,!lockStatus);},tooltip:'Unlock Quiz'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ActionLockOutline"],null)):null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ListItem"],{key:student.id,className:currentDataUserId===student.id?css.active:'',style:{fontSize:'14px'},primaryText:student.name,onClick:function onClick(){return _this3.handleSelectUser(student.id);},rightIconButton:lockButton});})),!currentDataUserId?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(QuizResult,{handleLoadMore:this.handleLoadMore,title:'',data:studentData&&studentData[selectedPage]&&studentData[selectedPage].userdata&&studentData[selectedPage].userdata.pages&&studentData[selectedPage].userdata.pages[selectedPage]?studentData[selectedPage].userdata.pages[selectedPage]:studentData&&studentData[selectedPage]&&studentData[selectedPage].userdata&&studentData[selectedPage].userdata[currentDataUserId]&&studentData[selectedPage].userdata[currentDataUserId].pages&&studentData[selectedPage].userdata[currentDataUserId].pages[selectedPage]?studentData[selectedPage].userdata[currentDataUserId].pages[selectedPage]:null,content:studentData&&studentData[selectedPage]&&studentData[selectedPage].tasks?studentData[selectedPage].tasks:{}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FloatingActionButton"],{style:{position:'fixed',right:32,top:35,zIndex:10},onClick:this.refs.exportDialog&&this.refs.exportDialog.show},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ActionLaunch"],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{title:standardActions[1].text+' quiz',actions:standardActions,ref:'confirm'},Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])([standardActions[1].text]))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{ref:'exportDialog',title:Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject8),actions:exportActions,actionFocus:'export',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{onChange:this.handleChangeText,floatingLabelText:'',hintText:'Email'})));}}]);return Quizzes;}(Object(__WEBPACK_IMPORTED_MODULE_5_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_5_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));Quizzes.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_1_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Quizzes);var QuizResult=function(_Component){_inherits(QuizResult,_Component);function QuizResult(){_classCallCheck(this,QuizResult);return _possibleConstructorReturn(this,(QuizResult.__proto__||Object.getPrototypeOf(QuizResult)).apply(this,arguments));}_createClass(QuizResult,[{key:'render',value:function render(){var _props=this.props,content=_props.content,data=_props.data,handleLoadMore=_props.handleLoadMore;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:css.container},data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Table"],{height:150,fixedHeader:true,selectable:false,multiSelectable:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableHeader"],{selectAllSelected:false,adjustForCheckbox:false,displaySelectAll:false,enableSelectAll:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableHeaderColumn"],{style:{color:'#656565',textAlign:'left'},tooltip:Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject9)},Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject10)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableHeaderColumn"],{style:{color:'#656565',textAlign:'left'},tooltip:Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject11)},Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject12)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableHeaderColumn"],{style:{color:'#656565'},tooltip:Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject13)},Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject13)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableHeaderColumn"],{style:{color:'#656565'},tooltip:Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject14)},Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject15)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableHeaderColumn"],{style:{color:'#656565'},tooltip:Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject16)},Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject17)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableBody"],{displayRowCheckbox:false,stripedRows:false},data.sort(function(a,b){return new Date(b.endTime)-new Date(a.endTime);}).map(function(_ref3){var score=_ref3.score,status=_ref3.status,total=_ref3.total,duration=_ref3.duration,startTime=_ref3.startTime,endTime=_ref3.endTime;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableRow"],{key:startTime},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableRowColumn"],null,__WEBPACK_IMPORTED_MODULE_7_moment___default()(endTime).fromNow()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableRowColumn"],null,status==='QUIZ_SUCCESS'?Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject18):Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject19)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableRowColumn"],null,score),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableRowColumn"],null,total),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TableRowColumn"],null,millisToMinutesAndSeconds(duration)));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Route_Task_TaskList__["a" /* default */],{tasks:Object.keys(content).reverse().map(function(t){return content[t];}),hasFilter:true,tasksLoading:false,selected:null}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{onTouchTap:handleLoadMore,style:{margin:'20px auto'},fullWidth:true,backgroundColor:'#01c9cb',labelColor:'#FFF',label:this.context.getIntlMessage('loadMore')}));}}]);return QuizResult;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);QuizResult.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_1_react__["PropTypes"].func};function millisToMinutesAndSeconds(millis){var minutes=Math.floor(millis/60000);var seconds=(millis%60000/1000).toFixed(0);return minutes+':'+(seconds<10?'0':'')+seconds;};

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(501);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 2122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_DropDown__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Embed__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Widgets_VideoPlayer__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Widgets_FileSelectorDialog__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_DropZone__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_superagent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_services_SoundCloud__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Material_CircularProgress__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shallow_equals__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shallow_equals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_shallow_equals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['Choose media'],['Choose media']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_3_material_ui__["Styles"].Spacing;var styles={root:{border:'solid 1px #EEE',backgroundColor:__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */].fullWhite},value:{position:'relative',paddingLeft:Spacing.iconSize*2+Spacing.desktopGutterMini*2,paddingRight:Spacing.iconSize*2+Spacing.desktopGutterMini*2},check:{position:'absolute',left:Spacing.desktopGutterMini,top:0,bottom:0,lineHeight:'48px'},icon:{cursor:'pointer',verticalAlign:'middle'},removeButton:{position:'absolute',right:Spacing.desktopGutterMini,top:0,bottom:0,lineHeight:'48px'}};var css={toggleWrapper:'_gQ',videoDownload:'_gR',downloadLink:'_gS'};var supportedExtensions=['mp4','m4a','png','jpg','jpeg','webp'];var TaskCreator=function(_Component){_inherits(TaskCreator,_Component);function TaskCreator(props,context){_classCallCheck(this,TaskCreator);var _this=_possibleConstructorReturn(this,(TaskCreator.__proto__||Object.getPrototypeOf(TaskCreator)).call(this,props,context));_initialiseProps.call(_this);_this.counter=1;_this.menuItems=[{payload:1,text:_this.context.getIntlMessage('tasks.singleChoice')},{payload:2,text:_this.context.getIntlMessage('tasks.multipleChoice')},{payload:4,text:_this.context.getIntlMessage('tasks.openEnded')}];var _this$props=_this.props,caption=_this$props.caption,correctResponse=_this$props.correctResponse,captionFiles=_this$props.captionFiles,frontend=_this$props.frontend,type=_this$props.type,file=_this$props.file,sources=_this$props.sources,content=_this$props.content,_this$props$params=_this$props.params,params=_this$props$params===undefined?{}:_this$props$params;var mediaTypes=[{payload:0,text:Object(__WEBPACK_IMPORTED_MODULE_22_oxygen_i18n__["translate"])(_templateObject)},{payload:1,text:'Image'},{payload:2,text:'Video'},{payload:3,text:'Audio'}];var values=caption.items.map(function(item,index){if(correctResponse&&correctResponse.value&&correctResponse.value.indexOf(index)>-1){return{correct:true,text:item};}else{return{correct:false,text:item};}});var external=null;try{external=JSON.parse(_this.props.frontend&&_this.props.frontend[0]||null);}catch(err){}var url=void 0;var fileId=void 0;var media=void 0;var currentFile=file?file:external?Object.assign({},external,{type:'external'}):captionFiles&&captionFiles[0];if(sources&&sources.length&&sources.length>0){url=sources[0].data;fileId=params&&params.file_id&&params.file_id[0];}else if(params.fileId){url=params.url;fileId=params.fileId;}else if(content&&content.length&&content.length>0){url=content[0].url;fileId=content[0].fileId;}else if(currentFile){url=currentFile.url;fileId=currentFile.id;media=mediaTypes.find(function(t){if(currentFile&&currentFile.type.includes('image')){return t.text.toLowerCase()===currentFile.type.replace(/\/(jpeg|jpg|png|webp)/g,'');}else if(currentFile&&currentFile.type.includes('video')){return t.text.toLowerCase()===currentFile.type.replace(/\/(mp4)/g,'');}else if(currentFile&&currentFile.type.includes('audio')){return t.text.toLowerCase()===currentFile.type.replace(/\/(mp4|x-m4a)/g,'');}else if(currentFile.type==='external'&&t.text.toLowerCase()==='video'){return true;}return false;});}_this.state={description:caption.main||'Task has no caption',comment:caption.comment||'',type:type||1,media:media&&media.payload||0,values:values,file:currentFile,edit:{url:url,fileId:fileId,caption:caption,sources:[],external:!file?external:file}};return _this;}_createClass(TaskCreator,[{key:'addValue',value:function addValue(){var text=this.context.getIntlMessage('tasks.emptyChoice');var values=[].concat(_toConsumableArray(this.state.values),[{correct:false,text:text,id:this.counter}]);this.setState({values:values});this.counter++;this.onChange(Object.assign({},this.state,{values:values}));}},{key:'removeValue',value:function removeValue(index){var values=this.state.values;values.splice(index,1);this.setState({values:values});this.onChange(Object.assign({},this.state,{values:values}));}},{key:'componentDidMount',value:function componentDidMount(){this.autoFocus();}},{key:'autoFocus',value:function autoFocus(){var field=this.refs.field;var inputField=field._getInputNode();var value=field.getValue();field.focus();field.setValue(value);inputField.select();}},{key:'getPreparedTask',value:function getPreparedTask(){return this.state;}},{key:'onChange',value:function onChange(task){if(this.props.onChange){this.props.onChange(task);}}},{key:'onDescriptionChange',value:function onDescriptionChange(e){var _this2=this;if(this._timer){clearTimeout(this._timer);}var description=e.target.value;this._timer=setTimeout(function(){_this2.setState({description:description});var external=JSON.parse(_this2.props.frontend&&_this2.props.frontend[0]||null);var raw=description;var file=_this2.props.file?_this2.props.file:external?Object.assign({},external,{type:'external'}):_this2.props.captionFiles&&_this2.props.captionFiles[0];description=file?'['+(file.type==='external'?'frontend':'file')+':'+(file.type!=='external'?file.id:JSON.stringify(file))+']'+description:description;_this2.props.onChange(Object.assign({},_this2.state,{description:description}),raw);__WEBPACK_IMPORTED_MODULE_21_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('video.changesSaved'));},1000);}},{key:'changeText',value:function changeText(index,text){var values=this.state.values;if(values[index]){values[index].text=text;}this.setState({values:values});var external=JSON.parse(this.props.frontend&&this.props.frontend[0]||null);var file=this.props.file?this.props.file:external?Object.assign({},external,{type:'external'}):this.props.captionFiles&&this.props.captionFiles[0];var description=file?'['+(file.type==='external'?'frontend':'file')+':'+(file.type!=='external'?file.id:JSON.stringify(file))+']'+this.state.description:this.state.description;this.props.onChange(Object.assign({},this.state,{values:values,description:description}),this.state.description);}},{key:'setCorrect',value:function setCorrect(index){var correct=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var external=JSON.parse(this.props.frontend&&this.props.frontend[0]||null);var file=this.props.file?this.props.file:external?Object.assign({},external,{type:'external'}):this.props.captionFiles&&this.props.captionFiles[0];var description=file?'['+(file.type==='external'?'frontend':'file')+':'+(file.type!=='external'?file.id:JSON.stringify(file))+']'+this.state.description:this.state.description;if(this.state.type===__WEBPACK_IMPORTED_MODULE_18_Constants__["taskTypes"].SINGLE_CHOICE){if(this.state.values[index]){var values=this.state.values;if(correct){values.forEach(function(value){value.correct=false;});}values[index]={text:values[index].text,correct:correct};this.setState({values:values});this.props.onChange(Object.assign({},this.state,{values:values,description:description}),this.state.description);}}else{if(this.state.values[index]){var _values=this.state.values;_values[index]={text:_values[index].text,correct:correct};this.setState({values:_values});this.props.onChange(Object.assign({},this.state,{values:_values,description:description}),this.state.description);}}}},{key:'changeMediaType',value:function changeMediaType(e,selectedIndex,menuItem){this.setState({media:menuItem.payload});}},{key:'changeType',value:function changeType(e,selectedIndex,menuItem){if(this.state.type!==menuItem.payload){var values=this.state.values;if(this.state.type===__WEBPACK_IMPORTED_MODULE_18_Constants__["taskTypes"].MULTI_CHOICE&&menuItem.payLoad!==__WEBPACK_IMPORTED_MODULE_18_Constants__["taskTypes"].MULTI_CHOICE){var hasValue=false;values.forEach(function(value){if(hasValue&&value.correct){value.correct=false;}else if(!hasValue&&value.correct){hasValue=true;}});}this.setState({type:menuItem.payload,values:values});var external=null;try{external=JSON.parse(this.props.frontend&&this.props.frontend[0]||null);}catch(err){}var file=this.props.file?this.props.file:external?Object.assign({},external,{type:'external'}):this.props.captionFiles&&this.props.captionFiles[0];var description=file?'['+(file.type!=='external'?'file':'frontend')+':'+(file.type!=='external'?file.id:JSON.stringify(file))+']'+this.state.description:this.state.description;this.props.onChange(Object.assign({},this.state,{type:menuItem.payload,values:values,description:description}),this.state.description);this.autoFocus();}}},{key:'renderValueAdder',value:function renderValueAdder(){var _this3=this;var values=this.state.values.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Value,Object.assign({key:index,onChange:_this3.changeText.bind(_this3,index),onRemove:_this3.removeValue.bind(_this3,index),onCheck:_this3.setCorrect.bind(_this3,index,!value.correct),type:_this3.state.type},value));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,values,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["RaisedButton"],{backgroundColor:this.props.themeColor,labelColor:'#FFF',fullWidth:true,onTouchTap:this.addValue.bind(this),label:this.context.getIntlMessage('tasks.addChoice')}));}},{key:'selectMedia',value:function selectMedia(file){var sources=supportedExtensions.map(function(extension){return{url:file.url,type:extension};});var edit=Object.assign({},this.state.edit,{fileId:file.id,url:''+file.url,sources:sources,external:null});this.setState({edit:edit,fileSelectorOpen:false});this.props.setFile(Object.assign({},file,{type:file.mime}));this.props.onChange(Object.assign({},this.state,{description:'[file:'+file.id+']'+this.state.description}),this.state.description);// PageLayoutActions.setPageModuleFile(this.props.pageRowId, this.props.moduleId, file)
}},{key:'import',value:function _import(){var _this4=this;var url=this.refs.import.value.trim();if(url===''){__WEBPACK_IMPORTED_MODULE_21_services_Message__["a" /* default */].info(this.context.getIntlMessage('image.provideImportUrl'));return;}SteelCompass.call('file','import',{url:url,encode:false},function(response){if(!response.isError){var edit=Object.assign({},_this4.state.edit,{url:response.data.file.url,fileId:response.data.file.id});_this4.setState({edit:edit});_this4.props.setFile(Object.assign({},response.data.file,{type:response.data.file.url.endsWith('jpg')?'image/jpg':'image/png'}));_this4.props.onChange(Object.assign({},_this4.state,{description:'[file:'+response.data.file.id+']'+_this4.state.description}),_this4.state.description);__WEBPACK_IMPORTED_MODULE_21_services_Message__["a" /* default */].info(_this4.context.getIntlMessage('image.imported'));}else{__WEBPACK_IMPORTED_MODULE_21_services_Message__["a" /* default */].info(_this4.context.getIntlMessage('image.importFailed'));}});}},{key:'embed',value:function embed(){var _this5=this;var url=this.refs.embedUrl.value;var edit=Object.assign({},this.state.edit);if(url!==''){var provider=__WEBPACK_IMPORTED_MODULE_12_Util__["b" /* Media */].getProviderFromUrl(url);if(provider){if(provider.provider===3){__WEBPACK_IMPORTED_MODULE_15_services_SoundCloud__["a" /* default */].oEmbed(url,function(response){provider.id=response.html;edit.external=provider;_this5.setState({edit:edit});_this5.props.setFile(Object.assign({},provider,{type:'external'}));_this5.props.onChange(Object.assign({},_this5.state,{description:'[frontend:'+JSON.stringify(provider)+']'+_this5.state.description}),_this5.state.description);});}else{edit.external=provider;this.setState({edit:edit});this.props.setFile(Object.assign({},provider,{type:'external'}));this.props.onChange(Object.assign({},this.state,{description:'[frontend:'+JSON.stringify(provider)+']'+this.state.description}),this.state.description);}}else{this.cannotSave();}}}},{key:'progress',value:function progress(e){this.setState({progress:e.percent,direction:e.direction});}},{key:'pollApiForJobId',value:function pollApiForJobId(fileId){var _this6=this;setTimeout(function(){var now=new Date();_this6.apiPollerStart=_this6.apiPollerStart||new Date();if(now-_this6.apiPollerStart<100000){SteelCompass.call('file','getJobId',{fileId:fileId},function(response){var data=response.data;// Poll encoding progress
if(data&&data.jobId&&data.accessKey){_this6.pollZencForProgress(data.jobId,data.accessKey);if(!_this6.state.pollProgress){_this6.setState({progress:0,pollProgress:true});}}else{// Keep polling for jobId
_this6.pollApiForJobId(fileId);}});}else{// Reset polling
_this6.apiPollerStart=null;}},3500);}},{key:'pollZencForProgress',value:function pollZencForProgress(jobId,accessKey){var _this7=this;setTimeout(function(){var now=new Date();_this7.zencPollerStart=_this7.zencPollerStart||new Date();if(now-_this7.zencPollerStart<100000||_this7.encodingProgress>0&&_this7.encodingProgress<100){__WEBPACK_IMPORTED_MODULE_14_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_13_Config__["a" /* default */].zenCoderRoot+'jobs/'+jobId+'/progress.json?api_key='+accessKey).set('Content-Type','text/plain').end(function(err,response){var data=response&&JSON.parse(response.text)||{};// Data object should contain a state and a progress property if the state is still processing.
if(data.state==='processing'&&data.progress){_this7.setState({progress:data.progress});_this7.pollZencForProgress(jobId,accessKey);}else if(data.state==='finished'){// Stop the polling
var sources=_this7.state.edit.sources.map(function(source){return Object.assign({},source,{url:source.url.replace(/deathstar\.s\.coursio\.com\/files/i,'coursio.s3-eu-west-1.amazonaws.com')});});_this7.setState({progress:100,pollProgress:false,edit:Object.assign({},_this7.state.edit,{sources:sources})});__WEBPACK_IMPORTED_MODULE_21_services_Message__["a" /* default */].info(_this7.context.getIntlMessage('media.encodingComplete'));}else{// Keep polling
_this7.pollZencForProgress(jobId,accessKey);}});}else{// Reset polling
_this7.zencPollerStart=null;}},1000);}},{key:'attachVideo',value:function attachVideo(data){if(data.length&&data.length>0){var file=data[0].file;var sources=supportedExtensions.map(function(extension){return{url:file.url,type:extension};});var edit=Object.assign({},this.state.edit,{external:null,fileId:file.id,sources:sources});this.setState({edit:edit});this.pollApiForJobId(file.id);this.props.setFile(Object.assign({},file,{type:file.mime||'video/mp4'}));this.props.onChange(Object.assign({},this.state,{description:'[file:'+file.id+']'+this.state.description}),this.state.description);if(!this.state.pollProgress){this.setState({progress:0.45,pollProgress:true});}}}},{key:'attachAudio',value:function attachAudio(data){if(data.length&&data.length>0){var file=data[0].file;var sources=supportedExtensions.map(function(extension){return{url:file.url,type:extension};});var edit=Object.assign({},this.state.edit,{external:null,fileId:file.id,sources:sources});this.setState({edit:edit});this.props.setFile(Object.assign({},file,{type:file.mime||'audio/mp4'}));this.props.onChange(Object.assign({},this.state,{description:'[file:'+file.id+']'+this.state.description}),this.state.description);this.pollApiForJobId(file.id);}}},{key:'attachImage',value:function attachImage(uploadedFiles){if(uploadedFiles.length>0){var edit=Object.assign({},this.state.edit,{fileId:uploadedFiles[0]&&uploadedFiles[0].file.id,url:uploadedFiles[0]&&uploadedFiles[0].file.url});this.setState({edit:edit});this.props.setFile(Object.assign({},uploadedFiles[0].file,{type:'image/jpg'}));this.props.onChange(Object.assign({},this.state,{description:'[file:'+uploadedFiles[0].file.id+']'+this.state.description}),this.state.description);this.pollApiForJobId(uploadedFiles[0].file.id);}}},{key:'onMediaLibrary',value:function onMediaLibrary(){this.setState({fileSelectorOpen:true});}},{key:'onMediaLibraryClose',value:function onMediaLibraryClose(){this.setState({fileSelectorOpen:false});}},{key:'openDownload',value:function openDownload(event){this.refs.dropZone.open();event.stopPropagation();event.preventDefault();}},{key:'renderEditAudio',value:function renderEditAudio(){var _state$edit=this.state.edit,sources=_state$edit.sources,external=_state$edit.external,caption=_state$edit.caption;var audioSources=sources.map(function(source){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:source.url,type:'audio/'+source.type,key:source.type});});var audio=void 0;var pollProgress=void 0;if(this.state.pollProgress){pollProgress=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["LinearProgress"],{style:{height:Spacing.desktopKeylineIncrement/4},mode:'indeterminate'});}var uploadLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:this.openDownload.bind(this)},this.context.getIntlMessage('module.upload'));var libraryLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:this.onMediaLibrary.bind(this)},this.context.getIntlMessage('module.library'));if(this.state.progress>0&&this.state.progress<100){audio=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Material_CircularProgress__["a" /* default */],{progress:this.state.progress,size:2});}else if(sources.length>0||external&&external.provider){if(external&&external.provider){audio=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Embed__["a" /* default */],{params:external});}else if(this.state.media===3){audio=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,style:styles.audio},audioSources);}}else{audio=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["AvMovie"],{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].icon});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].moduleContainer},audio,pollProgress),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_DropZone__["a" /* default */],{accept:'audio/*',ref:'dropZone',style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].dropZone,lineHeight:Spacing.desktopKeylineIncrement/2,onProgress:this.progress.bind(this),onSuccess:this.attachAudio.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].header},this.context.getIntlMessage('module.dropAudio')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].subHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('module.uploadOrBrowse'),upload:uploadLink,library:libraryLink})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].subHeader},this.context.getIntlMessage('module.or')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Paper"],{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].import.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:'embedUrl',style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].import.input,type:'text',placeholder:this.context.getIntlMessage('audio.embed'),onChange:this.embed.bind(this)}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Widgets_FileSelectorDialog__["a" /* default */],{type:'audio',open:this.state.fileSelectorOpen,onSelect:this.selectMedia.bind(this),onClose:this.onMediaLibraryClose.bind(this)}));}},{key:'render',value:function render(){var _this8=this;var _state=this.state,progress=_state.progress,direction=_state.direction,media=_state.media;var uploading=direction==='upload'&&progress>0&&progress<100;var valueAdder=void 0;var mediaTypes=[{payload:0,text:Object(__WEBPACK_IMPORTED_MODULE_22_oxygen_i18n__["translate"])(_templateObject)},{payload:1,text:'Image'},{payload:2,text:'Video'},{payload:3,text:'Audio'}];var selectedIndex=this.menuItems.findIndex(function(menuItem){return menuItem.payload===_this8.state.type;});var selectedMediaIndex=mediaTypes.findIndex(function(menuItem){return menuItem.payload===_this8.state.media;});if(this.state.type===__WEBPACK_IMPORTED_MODULE_18_Constants__["taskTypes"].SINGLE_CHOICE||this.state.type===__WEBPACK_IMPORTED_MODULE_18_Constants__["taskTypes"].MULTI_CHOICE){valueAdder=this.renderValueAdder();}var currentMedia=null;switch(media){case 1:currentMedia=this.renderEditImage();break;case 2:currentMedia=this.renderEditVideo();break;case 3:currentMedia=this.renderEditAudio();break;default:break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_DropDown__["a" /* default */],{onChange:this.changeType.bind(this),label:this.context.getIntlMessage('tasks.type'),menuItems:this.props.isQuiz?this.menuItems.filter(function(i){return i.payload!==4;}):this.menuItems,selectedIndex:selectedIndex}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_DropDown__["a" /* default */],{onChange:this.changeMediaType.bind(this),label:'Media',menuItems:mediaTypes,selectedIndex:selectedMediaIndex}),currentMedia,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["TextField"],{ref:'field',onChange:this.onDescriptionChange.bind(this),multiLine:true,fullWidth:true,floatingLabelText:this.props.isQuiz?this.context.getIntlMessage('tasks.question_description'):this.context.getIntlMessage('tasks.description'),defaultValue:this.state.description}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["TextField"],{onChange:this.onCommentChange,multiLine:true,fullWidth:true,floatingLabelText:this.context.getIntlMessage('pageModule.quizCommentOnQuestion'),defaultValue:this.state.comment}),valueAdder));}}]);return TaskCreator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TaskCreator.displayName='TaskCreator';TaskCreator.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};var _initialiseProps=function _initialiseProps(){var _this9=this;this.onCommentChange=function(e){if(_this9._timer){clearTimeout(_this9._timer);}var comment=e.target.value;_this9._timer=setTimeout(function(){_this9.setState({comment:comment});_this9.props.onChange(Object.assign({},_this9.state,{comment:comment}));__WEBPACK_IMPORTED_MODULE_21_services_Message__["a" /* default */].info(_this9.context.getIntlMessage('video.changesSaved'));},1000);};this.renderEditVideo=function(){var _state$edit2=_this9.state.edit,sources=_state$edit2.sources,external=_state$edit2.external;var video=void 0;// let pollProgress;
// if (this.state.pollProgress) {
//   pollProgress = <CircularProgress style={{ height: Spacing.desktopKeylineIncrement / 4 }} progressColor={this.context.muiTheme.rawTheme.palette.primary2Color} progress={this.state.progress} size={2} />;
// }
var uploadLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:_this9.openDownload.bind(_this9)},_this9.context.getIntlMessage('module.upload'));var libraryLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:_this9.onMediaLibrary.bind(_this9)},_this9.context.getIntlMessage('module.library'));if(_this9.state.pollProgress||_this9.state.progress>0&&_this9.state.progress<100){video=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Material_CircularProgress__["a" /* default */],{progress:_this9.state.progress,size:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this9.state.pollProgress?_this9.context.getIntlMessage('media.encoding'):_this9.context.getIntlMessage('media.uploading')));}else if(sources&&sources.length>0||external&&external.provider){if(external&&external.provider){video=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Embed__["a" /* default */],{params:external});}else if(_this9.state.media===2){video=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Widgets_VideoPlayer__["a" /* default */],{sources:sources});}}else{video=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["AvMovie"],{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].icon});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].moduleContainer},video),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_DropZone__["a" /* default */],{accept:'video/*',ref:'dropZone',style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].dropZone,lineHeight:Spacing.desktopKeylineIncrement/2,onProgress:_this9.progress.bind(_this9),onSuccess:_this9.attachVideo.bind(_this9)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].header},_this9.context.getIntlMessage('module.dropVideo')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].subHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"],{message:_this9.context.getIntlMessage('module.uploadOrBrowse'),upload:uploadLink,library:libraryLink})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].subHeader},_this9.context.getIntlMessage('module.or')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Paper"],{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].import.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:'embedUrl',style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].import.input,type:'text',placeholder:_this9.context.getIntlMessage('video.embed'),onChange:_this9.embed.bind(_this9)}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Widgets_FileSelectorDialog__["a" /* default */],{type:'video',open:_this9.state.fileSelectorOpen,onSelect:_this9.selectMedia.bind(_this9),onClose:_this9.onMediaLibraryClose.bind(_this9)}));};this.renderEditImage=function(){var _ref=_this9.state||{},edit=_ref.edit;var image=void 0;var uploadLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:_this9.openDownload.bind(_this9)},_this9.context.getIntlMessage('module.upload'));var libraryLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:_this9.onMediaLibrary.bind(_this9)},_this9.context.getIntlMessage('module.library'));if(_this9.state.progress>0&&_this9.state.progress<100){image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Material_CircularProgress__["a" /* default */],{progress:_this9.state.progress,size:2});}else if(edit.url){image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:edit.url,style:{maxWidth:'100%'}});}else{image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["ImageImage"],{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].icon});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_DropZone__["a" /* default */],{ref:'dropZone',style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].dropZone,lineHeight:Spacing.desktopKeylineIncrement/2,onProgress:_this9.progress.bind(_this9),onSuccess:_this9.attachImage.bind(_this9)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].moduleContainer},image),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].header},_this9.context.getIntlMessage('module.dropImage')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].subHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_intl__["FormattedMessage"],{message:_this9.context.getIntlMessage('module.uploadOrBrowse'),upload:uploadLink,library:libraryLink})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].subHeader},_this9.context.getIntlMessage('module.youCanImport')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Paper"],{style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].import.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:'import',style:__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Styles__["a" /* default */].import.input,type:'text',placeholder:_this9.context.getIntlMessage('importFromUrl'),onChange:_this9.import.bind(_this9)}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Widgets_FileSelectorDialog__["a" /* default */],{type:'image',open:_this9.state.fileSelectorOpen,onSelect:_this9.selectMedia.bind(_this9),onClose:_this9.onMediaLibraryClose.bind(_this9)}));};};/* harmony default export */ __webpack_exports__["a"] = (TaskCreator);var Value=function(_Component2){_inherits(Value,_Component2);function Value(){_classCallCheck(this,Value);return _possibleConstructorReturn(this,(Value.__proto__||Object.getPrototypeOf(Value)).apply(this,arguments));}_createClass(Value,[{key:'onCheck',value:function onCheck(){this.props.onCheck();}},{key:'onRemove',value:function onRemove(){this.props.onRemove();}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!__WEBPACK_IMPORTED_MODULE_19_shallow_equals___default()(this.props,nextProps);}},{key:'onChange',value:function onChange(e){var value=e.target.value;var onChange=this.props.onChange;onChange&&onChange(value);}},{key:'componentDidMount',value:function componentDidMount(){var field=this.refs.field;var inputField=field._getInputNode();// const value = field.getValue();
field.focus();// field.setValue(value);
inputField.select();}},{key:'render',value:function render(){var _props=this.props,type=_props.type,correct=_props.correct,text=_props.text;var Icon=void 0,color=void 0;if(type===__WEBPACK_IMPORTED_MODULE_18_Constants__["taskTypes"].SINGLE_CHOICE){if(correct){color=__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */].green[500].material;Icon=__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["ToggleRadioButtonChecked"];}else{color=__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["b" /* Text */].Dark.text;Icon=__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["ToggleRadioButtonUnchecked"];}}else if(type===__WEBPACK_IMPORTED_MODULE_18_Constants__["taskTypes"].MULTI_CHOICE){if(correct){color=__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */].green[500].material;Icon=__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["ToggleCheckBox"];}else{color=__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["b" /* Text */].Dark.text;Icon=__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["ToggleCheckBoxOutlineBlank"];}}var icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{color:color,hoverColor:__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */].green[500].material,style:styles.icon});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.value},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{style:styles.check,onTouchTap:this.onCheck.bind(this)},icon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["TextField"],{ref:'field',fullWidth:true,value:this.props.text,onChange:this.onChange.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{style:styles.removeButton,onTouchTap:this.onRemove.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["ContentClear"],{style:styles.icon,hoverColor:__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */].red[800].material})));}}]);return Value;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 2123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores_MediaLibrary__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_MediaLibrary__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Widgets_FileSelector__ = __webpack_require__(2124);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FileSelectorContainer=function(_mixin){_inherits(FileSelectorContainer,_mixin);function FileSelectorContainer(){_classCallCheck(this,FileSelectorContainer);return _possibleConstructorReturn(this,(FileSelectorContainer.__proto__||Object.getPrototypeOf(FileSelectorContainer)).apply(this,arguments));}_createClass(FileSelectorContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_2_stores_MediaLibrary__["a" /* default */]);}},{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_actions_MediaLibrary__["a" /* default */].listDirectory(0);}},{key:'changeDir',value:function changeDir(dir){__WEBPACK_IMPORTED_MODULE_3_actions_MediaLibrary__["a" /* default */].listDirectory(dir);}},{key:'render',value:function render(){if(this.state.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__["b" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Widgets_FileSelector__["a" /* default */],Object.assign({breadcrumbs:this.state.breadcrumbs,onChangeDirectory:this.changeDir.bind(this),items:this.state.list},this.props,{labelProperty:'name'}));}}]);return FileSelectorContainer;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));FileSelectorContainer.displayName='FileSelectorContainer';/* harmony default export */ __webpack_exports__["a"] = (FileSelectorContainer);

/***/ }),
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SearchBarToolbar__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing,Colors=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Colors;var styles={root:{position:'relative',height:'100%'},list:{boxSizing:'border-box'},searchBar:{boxSizing:'border-box'},breadcrumb:{// backgroundColor: 'transparent',
minWidth:32,display:'inline-block',margin:'10px 2px',padding:'0px 4px'}};var gridSize=140;var FileSelector=function(_Component){_inherits(FileSelector,_Component);function FileSelector(){_classCallCheck(this,FileSelector);var _this=_possibleConstructorReturn(this,(FileSelector.__proto__||Object.getPrototypeOf(FileSelector)).apply(this,arguments));var itemCount=25;var grid=_this.props.grid;if(grid){itemCount=Math.floor(window.innerWidth/gridSize)*Math.ceil(window.innerHeight/gridSize);}else{itemCount=Math.ceil(window.innerHeight/70);}_this.state={maxItems:itemCount,grid:grid,deleted:{}};return _this;}_createClass(FileSelector,[{key:'onTouchTapItem',value:function onTouchTapItem(item){if(item.type==='dir'){this.props.onChangeDirectory(item.id);}else if(this.props.onSelect){this.props.onSelect(item);}}},{key:'onScrollToBottom',value:function onScrollToBottom(){this.setState({maxItems:this.state.maxItems+3});}},{key:'getFloatingActionButtonStyle',value:function getFloatingActionButtonStyle(){var _context=this.context,muiTheme=_context.muiTheme,media=_context.media;return Object.assign({},styles.floatingActionButton,{right:media==='phone'?Spacing.desktopGutter:Spacing.desktopKeylineIncrement/2,bottom:media==='phopne'?Spacing.desktopGutter:muiTheme.toolbar.height*2-muiTheme.floatingActionButton.buttonSize/2});}},{key:'getStyle',value:function getStyle(){return Object.assign({},styles.root,{backgroundColor:this.context.muiTheme.primary1Color});}},{key:'getSearchHeaderStyle',value:function getSearchHeaderStyle(){var palette=this.context.muiTheme.rawTheme.palette;return Object.assign({},{backgroundColor:palette.primary1Color});}},{key:'getListStyle',value:function getListStyle(){return Object.assign({},styles.list);}},{key:'filter',value:function filter(item,searchText,labelProperty){if(searchText&&searchText!==''){return item[labelProperty].search(searchText)>-1;}return true;}},{key:'searchTextChange',value:function searchTextChange(searchText){var _this2=this;if(this._timer){clearTimeout(this._timer);}this._timer=setTimeout(function(){_this2.setState({searchText:searchText});},150);}},{key:'toggleMode',value:function toggleMode(){this.setState({grid:!this.state.grid});}},{key:'changeDirectory',value:function changeDirectory(directoryId){if(this.props.onChangeDirectory){this.props.onChangeDirectory(directoryId);}}},{key:'render',value:function render(){var _this3=this;var children=[];var list=void 0;var detail=void 0;var regexp='';var items=this.props.items;var _props=this.props,grid=_props.grid,sort=_props.sort,labelProperty=_props.labelProperty,type=_props.type;var searchText=this.state.searchText;var filter=this.props.filter||this.filter;var size=grid?gridSize:40;if(searchText&&searchText!==''){regexp=new RegExp(searchText,'i');}items=items.filter(function(item){var created=item.created&&item.created.split(' ').join('T')+'Z';item.creationDate=new Date(created);return!item.deleted&&(!type||item.type==='dir'||item.type.indexOf(type)>-1)&&filter(item,regexp,labelProperty);});if(sort&&sort.property){var sortProperty=sort.property;var sortDirection=sort.direction;items.sort(function(left,right){if(left.type==='dir'&&right.type!=='dir'){return-1;}else if(left.type!=='dir'&&right.type==='dir'){return 1;}if(typeof left[sortProperty]==='string'){var _leftProp=left[sortProperty].toUpperCase();var _rightProp=right[sortProperty].toUpperCase();if(_leftProp<_rightProp)return sortDirection==='asc'?-1:1;if(_leftProp>_rightProp)return sortDirection==='asc'?1:-1;return 0;}var leftProp=left[sortProperty];var rightProp=right[sortProperty];if(leftProp<rightProp)return sortDirection==='asc'?-1:1;if(leftProp>rightProp)return sortDirection==='asc'?1:-1;return 0;});}items=items.splice(0,this.state.maxItems);for(var i=0;i<items.length;i++){var file=items[i];var id=file.id,name=file.name;var fileType=file.type;var thumb=void 0;if(fileType==='image'){// let tokens = file.url.split('.');
// let extension = tokens.pop();
// thumb = <Avatar src={tokens.join('.')+'-40.'+extension}/>;
thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Avatar"],{src:file.url,style:{borderRadius:0}});}else if(fileType==='video'){thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Avatar"],{icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["AvMovie"],null)});}else if(fileType==='audio'){thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Avatar"],{icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageAudiotrack"],null)});}else if(fileType==='dir'){thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Avatar"],{backgroundColor:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].lightBlue[400].material,size:size,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["FileFolder"],{color:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].lightBlue[400].material}),style:styles.avatar});}else{thumb=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Avatar"],{icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["EditorInsertDriveFile"],null)});}var createdTime=file.created&&file.created.split(' ').join('T')||null;var date=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:Colors.minBlack}},createdTime&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedDate"],{value:new Date(createdTime)})||'');children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListItem"],{leftAvatar:thumb,key:'i-'+id,onTouchTap:this.onTouchTapItem.bind(this,file),primaryText:name,secondaryText:date}));children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListDivider"],{key:'d-'+id}));}var crumbs=this.props.breadcrumbs.slice().reverse();crumbs.unshift({id:0,name:this.context.getIntlMessage('menu.mediaLibrary')});var breadCrumbs=crumbs.map(function(current){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{style:styles.breadcrumb,onTouchTap:_this3.changeDirectory.bind(_this3,current.id),key:current.id,href:'/media-library/dir/'+current.id},current.name,'/');});list=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getListStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["List"],null,children));var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getSearchHeaderStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_SearchBarToolbar__["a" /* default */],{fullWidth:true,onChange:this.searchTextChange.bind(this)}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getStyle()},breadCrumbs,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ScrollableContainer__["a" /* default */],{containerStyle:{backgroundColor:this.context.muiTheme.canvasColor},header:toolbar,onScrollToBottom:this.onScrollToBottom.bind(this)},list),detail);}}]);return FileSelector;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FileSelector.displayName='FileSelector';FileSelector.propTypes={grid:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,hasDivider:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,labelProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,idProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,onSelect:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,searchText:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,initialItemCount:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,filterChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,filter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,sort:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,floatingActionButton:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};FileSelector.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};FileSelector.defaultProps={searchText:null,labelProperty:'name',idProperty:'id',initialItemCount:25,sort:{property:'creationDate',direction:'desc'},hasDivider:true,items:[],swipeEnabled:true,dangerouslySetInnerHTML:false};/* harmony default export */ __webpack_exports__["a"] = (FileSelector);

/***/ }),
/* 2125 */
/***/ (function(module, exports) {

module.exports = shallow

function shallow(a, b, compare) {
  var aIsArray = Array.isArray(a)
  var bIsArray = Array.isArray(b)

  if (aIsArray !== bIsArray) return false

  var aTypeof = typeof a
  var bTypeof = typeof b

  if (aTypeof !== bTypeof) return false
  if (flat(aTypeof)) return compare
    ? compare(a, b)
    : a === b

  return aIsArray
    ? shallowArray(a, b, compare)
    : shallowObject(a, b, compare)
}

function shallowArray(a, b, compare) {
  var l = a.length
  if (l !== b.length) return false

  if (compare) {
    for (var i = 0; i < l; i++)
      if (!compare(a[i], b[i])) return false
  } else {
    for (var i = 0; i < l; i++) {
      if (a[i] !== b[i]) return false
    }
  }

  return true
}

function shallowObject(a, b, compare) {
  var ka = 0
  var kb = 0

  if (compare) {
    for (var key in a) {
      if (
        a.hasOwnProperty(key) &&
        !compare(a[key], b[key])
      ) return false

      ka++
    }
  } else {
    for (var key in a) {
      if (
        a.hasOwnProperty(key) &&
        a[key] !== b[key]
      ) return false

      ka++
    }
  }

  for (var key in b) {
    if (b.hasOwnProperty(key)) kb++
  }

  return ka === kb
}

function flat(type) {
  return (
    type !== 'function' &&
    type !== 'object'
  )
}


/***/ }),
/* 2126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_App__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["exportDone"],["exportDone"]),_templateObject2=_taggedTemplateLiteral(["customExport"],["customExport"]),_templateObject3=_taggedTemplateLiteral(["sales"],["sales"]),_templateObject4=_taggedTemplateLiteral(["google_warning"],["google_warning"]),_templateObject5=_taggedTemplateLiteral(["name"],["name"]),_templateObject6=_taggedTemplateLiteral(["Quantity"],["Quantity"]),_templateObject7=_taggedTemplateLiteral(["Amount"],["Amount"]),_templateObject8=_taggedTemplateLiteral(["PageViews"],["PageViews"]),_templateObject9=_taggedTemplateLiteral(["TotalTimeSpent"],["TotalTimeSpent"]),_templateObject10=_taggedTemplateLiteral(["Conversion"],["Conversion"]),_templateObject11=_taggedTemplateLiteral(["Total"],["Total"]),_templateObject12=_taggedTemplateLiteral(["NoSalesData"],["NoSalesData"]),_templateObject13=_taggedTemplateLiteral(["Invitations"],["Invitations"]),_templateObject14=_taggedTemplateLiteral(["Accepted"],["Accepted"]),_templateObject15=_taggedTemplateLiteral(["NoInvitationData"],["NoInvitationData"]),_templateObject16=_taggedTemplateLiteral(["task_interaction"],["task_interaction"]),_templateObject17=_taggedTemplateLiteral(["video_interaction"],["video_interaction"]),_templateObject18=_taggedTemplateLiteral(["download_interaction"],["download_interaction"]),_templateObject19=_taggedTemplateLiteral(["slideshow_interaction"],["slideshow_interaction"]),_templateObject20=_taggedTemplateLiteral(["discussion_interaction"],["discussion_interaction"]),_templateObject21=_taggedTemplateLiteral(["audio_interaction"],["audio_interaction"]),_templateObject22=_taggedTemplateLiteral(["close"],["close"]),_templateObject23=_taggedTemplateLiteral(["Interaction"],["Interaction"]),_templateObject24=_taggedTemplateLiteral(["page"],["page"]),_templateObject25=_taggedTemplateLiteral(["sessions"],["sessions"]),_templateObject26=_taggedTemplateLiteral(["TimeSpent"],["TimeSpent"]),_templateObject27=_taggedTemplateLiteral(["Course Interactions"],["Course Interactions"]),_templateObject28=_taggedTemplateLiteral(["Interaction Type"],["Interaction Type"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable no-useless-computed-key */var css={box:"_g",date:"_h",flex:"_i",graph:"_j",dropdown:"_k"};var SALES_TAB="sales";var USAGE_TAB="usage";var StatisticsContainer=function(_mixin){_inherits(StatisticsContainer,_mixin);function StatisticsContainer(props){_classCallCheck(this,StatisticsContainer);var _this=_possibleConstructorReturn(this,(StatisticsContainer.__proto__||Object.getPrototypeOf(StatisticsContainer)).call(this,props));_initialiseProps.call(_this);var now=new Date();var startDate=new Date(now.getFullYear(),now.getMonth()-1,1);var endDate=new Date();_this.state={startDate:startDate,endDate:endDate,loading:true,labels:[],lineData:[],invitations:{count:0,acceptedCount:0,invPerCourse:[],invPerCircle:[]},clickData:[]};return _this;}_createClass(StatisticsContainer,[{key:"componentWillMount",value:function componentWillMount(){var startDate=this.state.startDate;var endDate=this.state.endDate;this.fetchStats(startDate,endDate);//this.fetchInvitations(startDate, endDate);
//this.fetchEventStats({ startDate, endDate });
}},{key:"groupData",value:function groupData(startDate,endDate,data){var period=(endDate-startDate)/(24*60*60*1000);var dates=data.dates,sums=data.sums;var lookup={};for(var i=0;i<dates.length;i++){var date=new Date(dates[i]);date.setHours(12);lookup[date.getTime()]=(lookup[dates[i]]||0)+parseFloat(sums[i]);}if(period<=31){return this.groupDataInDays(startDate,endDate,lookup);// } else if (period <= 90) {
//   return this.groupDataInWeeks(startDate, endDate, lookup);
}else if(period<=365){return this.groupDataInMonths(startDate,endDate,lookup);}else{return this.groupDataInYears(startDate,endDate,lookup);}}},{key:"groupDataInDays",value:function groupDataInDays(startDate,endDate,lookup){var days=0;var data={labels:[],lineData:[]};var date=new Date(startDate.valueOf());while(date<=endDate){date=new Date(startDate.valueOf());date.setDate(date.getDate()+days);date.setHours(12);var time=date.getTime();var readable=date.toDateString();data.labels.push(readable);data.lineData.push(lookup[time]||0);days++;}return data;}},{key:"groupDataInWeeks",value:function groupDataInWeeks(startDate,endDate,lookup){var days=0;var data={labels:[],lineData:[]};var date=new Date(startDate.valueOf());while(date<=endDate){date=new Date(startDate.valueOf());date.setDate(date.getDate()+days);date.setHours(12);var time=date.getTime();var readable=date.toDateString();data.labels.push(readable);data.lineData.push(lookup[time]||0);days++;}return data;}},{key:"groupDataInMonths",value:function groupDataInMonths(startDate,endDate,lookup){var days=0;var data={labels:[],lineData:[]};var grouped={};var date=new Date(startDate.valueOf());while(date<=endDate){date=new Date(startDate.valueOf());date.setDate(date.getDate()+days);date.setHours(12);var time=date.getTime();var year=date.getFullYear();var month=date.getMonth()+1;var readable=year+"-"+month;grouped[readable]=(grouped[readable]||0)+(lookup[time]||0);days++;}data.labels=Object.keys(grouped);data.labels.forEach(function(key){data.lineData.push(grouped[key]);});return data;}},{key:"groupDataInYears",value:function groupDataInYears(startDate,endDate,lookup){var days=0;var data={labels:[],lineData:[]};var grouped={};var date=new Date(startDate.valueOf());while(date<=endDate){date=new Date(startDate.valueOf());date.setDate(date.getDate()+days);date.setHours(12);var time=date.getTime();var year=date.getFullYear();var readable=year;grouped[readable]=(grouped[readable]||0)+(lookup[time]||0);days++;}data.labels=Object.keys(grouped);data.labels.forEach(function(key){data.lineData.push(grouped[key]);});return data;}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(StatisticsPage,Object.assign({setDate:this.setDate,fetchStats:this.fetchStats,fetchInvitations:this.fetchInvitations,fetchEventStats:this.fetchEventStats},this.props,this.state));}}]);return StatisticsContainer;}(Object(__WEBPACK_IMPORTED_MODULE_8_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_8_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_7_react__["Component"]));var _initialiseProps=function _initialiseProps(){var _this2=this;this.setDate=function(data){_this2.setState(data);};this.fetchEventStats=function(_ref){var startDate=_ref.startDate,endDate=_ref.endDate,dimensions=_ref.dimensions,fetchStore=_ref.fetchStore,metrics=_ref.metrics,filters=_ref.filters,courseId=_ref.courseId,sort=_ref.sort;var key=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"data";return SteelCompass.request("statistics","queryAnalytics",{startDate:startDate.getFullYear()+"-"+("0"+(startDate.getMonth()+1)).slice(-2)+"-"+("0"+startDate.getDate()).slice(-2),endDate:endDate.getFullYear()+"-"+("0"+(endDate.getMonth()+1)).slice(-2)+"-"+("0"+endDate.getDate()).slice(-2),dimensions:dimensions||"ga:source",fetchStore:fetchStore,metrics:metrics||"ga:users",filters:filters,courseId:courseId,sort:sort}).then(function(response){var data=[];response.forEach(function(arr){data.push(Object.assign({},arr));});_this2.setState(function(state){return Object.assign({},state,_defineProperty({},key,data));});return response;}).catch(function(error){return _this2.setState(function(state){return Object.assign({},state,{error:error});});});};this.fetchStats=function(startDate,endDate){SteelCompass.request("statistics","sales",{startDate:startDate.getDate()+"."+(startDate.getMonth()+1)+"."+startDate.getFullYear(),endDate:endDate.getDate()+"."+(endDate.getMonth()+1)+"."+endDate.getFullYear()}).then(function(response){var data=_this2.groupData(startDate,endDate,response);_this2.setState(function(state){return Object.assign({},state,data,response,{loading:false});});});};this.fetchInvitations=function(startDate,endDate){SteelCompass.request("statistics","invitations",{startDate:startDate.getDate()+"."+(startDate.getMonth()+1)+"."+startDate.getFullYear(),endDate:endDate.getDate()+"."+(endDate.getMonth()+1)+"."+endDate.getFullYear()}).then(function(response){var count=response.count,acceptedCount=response.acceptedCount,invPerCourse=response.invPerCourse,invPerCircle=response.invPerCircle;var invitations={count:count,acceptedCount:acceptedCount,invPerCourse:invPerCourse,invPerCircle:invPerCircle};_this2.setState(function(state){return Object.assign({},state,{invitations:invitations,loading:false});});});};};/* harmony default export */ __webpack_exports__["a"] = (StatisticsContainer);var StatisticsPage=function(_Component){_inherits(StatisticsPage,_Component);function StatisticsPage(){var _ref2;var _temp,_this3,_ret;_classCallCheck(this,StatisticsPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this3=_possibleConstructorReturn(this,(_ref2=StatisticsPage.__proto__||Object.getPrototypeOf(StatisticsPage)).call.apply(_ref2,[this].concat(args))),_this3),_this3.state={currentTab:SALES_TAB,selectedCourse:null,recipientEmail:""},_this3.tabChange=function(value){_this3.setState({currentTab:value});},_this3.selectedCourse=function(id){_this3.setState({selectedCourse:id});},_this3.setStartDate=function(_,startDate){if(_this3.props.startDate!==startDate){_this3.props.setDate({startDate:startDate});_this3.props.fetchStats(startDate,_this3.props.endDate);_this3.props.fetchInvitations(startDate,_this3.props.endDate);}},_this3.setEndDate=function(_,endDate){if(_this3.props.endDate!==endDate){_this3.props.setDate({endDate:endDate});_this3.props.fetchStats(_this3.props.startDate,endDate);_this3.props.fetchInvitations(_this3.props.startDate,endDate);}},_this3.handleChangeExport=function(e){_this3.setState({recipientEmail:e.target.value});},_this3.exportStatistics=function(){var re=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var email=null;if(re.test(String(_this3.state.recipientEmail).toLowerCase())){email=_this3.state.recipientEmail;}SteelCompass.request("statistics","interaction",{startDate:_this3.refs.startDate.getDate(),endDate:_this3.refs.endDate.getDate(),courseId:_this3.state.selectedCourse,recipientEmail:email}).then(function(response){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].translatableMessage(Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject));_this3.refs.exportDialog.dismiss();},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_App__["a" /* default */].genericError(error);_this3.refs.exportDialog.dismiss();});},_temp),_possibleConstructorReturn(_this3,_ret);}_createClass(StatisticsPage,[{key:"render",value:function render(){var tab=null;switch(this.state.currentTab){case SALES_TAB:tab=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(StatisticsSalesTab,Object.assign({},this.props,{selectedCourse:this.selectedCourse}));break;case USAGE_TAB:tab=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(StatisticsUsageTab,Object.assign({},this.props,{selectedCourse:this.selectedCourse}));break;default:tab=__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(StatisticsSalesTab,Object.assign({},this.props,{selectedCourse:this.selectedCourse}));break;}var exportActions=[{text:this.context.getIntlMessage("Cancel")},{text:this.context.getIntlMessage("Export"),onTouchTap:this.exportStatistics,ref:"submit"}];return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_RulerBar__["a" /* default */],{title:"Statistics"})},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_components__["a" /* FlexBox */],{style:{margin:"auto",maxWidth:1200},row:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_components__["a" /* FlexBox */],{style:{justifyContent:"center"},className:css.flex,grow:0,shrink:0},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("p",{className:css.date},"Start Date:"),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["DatePicker"],{maxDate:this.props.endDate,onChange:this.setStartDate,value:this.props.startDate,hintText:"Start date",ref:"startDate"})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_components__["a" /* FlexBox */],{style:{justifyContent:"center"},className:css.flex,grow:0,shrink:0},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("p",{className:css.date},"End Date:"),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["DatePicker"],{minDate:this.props.startDate,onChange:this.setEndDate,value:this.props.endDate,hintText:"End date",ref:"endDate"})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["FloatingActionButton"],{style:{transform:"translateY(-50%)",zIndex:10},onClick:this.refs.exportDialog&&this.refs.exportDialog.show},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ActionLaunch"],null)))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(StatisticsPageNavigation,{changeTab:this.tabChange}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{style:{height:"auto"}},tab),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Dialog"],{ref:"exportDialog",title:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject2),actions:exportActions,actionFocus:"export",dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TextField"],{onChange:this.handleChangeExport,floatingLabelText:"",hintText:"Email"})));}}]);return StatisticsPage;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);StatisticsPage.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_7_react__["PropTypes"].func};var StatisticsPageNavigation=function(_Component2){_inherits(StatisticsPageNavigation,_Component2);function StatisticsPageNavigation(){_classCallCheck(this,StatisticsPageNavigation);return _possibleConstructorReturn(this,(StatisticsPageNavigation.__proto__||Object.getPrototypeOf(StatisticsPageNavigation)).apply(this,arguments));}_createClass(StatisticsPageNavigation,[{key:"render",value:function render(){var changeTab=this.props.changeTab;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Tabs"],{style:{maxWidth:1200,margin:"auto"},onChange:changeTab},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Tab"],{label:"Sales",value:SALES_TAB}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Tab"],{label:"Usage",value:USAGE_TAB}));}}]);return StatisticsPageNavigation;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);var StatisticsSalesTab=function(_Component3){_inherits(StatisticsSalesTab,_Component3);function StatisticsSalesTab(){var _ref3;var _temp2,_this5,_ret2;_classCallCheck(this,StatisticsSalesTab);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this5=_possibleConstructorReturn(this,(_ref3=StatisticsSalesTab.__proto__||Object.getPrototypeOf(StatisticsSalesTab)).call.apply(_ref3,[this].concat(args))),_this5),_this5.state={loading:false},_this5.sumConversion=function(pageData,salesPerObject){var totalSales=salesPerObject.map(function(x){return x.type==="course"&&x.salesCount;}).reduce(function(a,b){return b+a;},0);var totalSessions=pageData.reduce(function(a,b){var slug=salesPerObject.find(function(x){return b[0].includes(x.slug);});if(!slug){return a;}return a+=Math.round(Number(b[1]));},0);if((totalSales/totalSessions*100).toFixed(1)==='Infinity'){return'N/A';}else{var result=(totalSales/totalSessions*100).toFixed(1);return result>30?'N/A':result+"%";}},_temp2),_possibleConstructorReturn(_this5,_ret2);}_createClass(StatisticsSalesTab,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this6=this;if(nextProps.startDate!==this.props.startDate||nextProps.endDate!==this.props.endDate){this.props.fetchEventStats({startDate:nextProps.startDate,endDate:nextProps.endDate,dimensions:"ga:pagePath",metrics:"ga:sessions, ga:avgSessionDuration",sort:"-ga:sessions",fetchStore:true},"pageData").then(function(){return _this6.setState({loading:false});});}}},{key:"componentWillMount",value:function componentWillMount(){var _this7=this;this.props.fetchEventStats({startDate:this.props.startDate,endDate:this.props.endDate,dimensions:"ga:pagePath",metrics:"ga:sessions, ga:avgSessionDuration",sort:"-ga:sessions",fetchStore:true},"pageData").then(function(){return _this7.setState({loading:false});});}},{key:"populateSalesDataWithGA",value:function populateSalesDataWithGA(id,slug,name,salesCount,salesAmount,storeCurrency,hasGoogleData){var gaData=null;for(var i=0;i<this.props.pageData.length;i++){if(this.props.pageData[i]&&this.props.pageData[i][0].includes(slug)){gaData=this.props.pageData[i];break;}}if(gaData&&hasGoogleData){var minutes=Math.floor(gaData[2]/60);var seconds=Math.floor(gaData[2]-minutes*60);var sessions=+gaData[1];return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRow"],{key:id},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},name),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},salesCount),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},Math.round(salesAmount)," ",storeCurrency),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},gaData[1]),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},minutes,",",seconds),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},sessions?(salesCount/sessions*100).toFixed(1)>30?'N/A':(salesCount/sessions*100).toFixed(1)+"%":'N/A'));}else{return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRow"],{key:id},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},name),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},salesCount),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},Math.round(salesAmount)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},"-"),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},"-"),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},"-"));}}},{key:"render",value:function render(){var _this8=this;var _props=this.props,salesPerObject=_props.salesPerObject,pageData=_props.pageData,loading=_props.loading,totalValue=_props.totalValue,invitations=_props.invitations,storeCurrency=_props.storeCurrency;var hasGoogleData=new Date(this.props.startDate).getFullYear()>=2019;var currency=storeCurrency||"SEK";var formatter=new Intl.NumberFormat(currency==="SEK"?"sv-SE":"en-US",{style:"currency",currency:currency,minimumFractionDigits:0});return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{style:{overflowY:"scroll",height:"calc(100vh - 200px)"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{style:{margin:20,marginLeft:"34px"}},!loading&&!!pageData&&!!salesPerObject.length&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Paper"],{style:{maxWidth:1200,margin:"auto"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h2",{style:{fontSize:22,lineHeight:"28px",borderRadius:"2px",padding:"20px",background:"#777",color:"#fff"}},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject3)),!hasGoogleData&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("p",{style:{color:"red",marginLeft:"20px",fontSize:"16px"}},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject4)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Table"],{fixedHeader:true,fixedFooter:true,selectable:false,multiSelectable:false},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeader"],{selectAllSelected:false,adjustForCheckbox:false,displaySelectAll:false,enableSelectAll:false},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject5)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject5)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject6)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject6)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject7)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject7)),hasGoogleData&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject8)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject8)),hasGoogleData&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject9)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject9)),hasGoogleData&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject10)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject10)))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableBody"],{displayRowCheckbox:false,stripedRows:false},salesPerObject.map(function(_ref4){var id=_ref4.id,slug=_ref4.slug,type=_ref4.type,name=_ref4.name,salesCount=_ref4.salesCount,salesAmount=_ref4.salesAmount;if(type==="course"||type==="package"){return _this8.populateSalesDataWithGA(id,slug,name,salesCount,salesAmount,storeCurrency,hasGoogleData);}else{return null;}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],null),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject11),":"," ",!!salesPerObject.length?salesPerObject.map(function(x){return x.salesCount;}).reduce(function(a,b){return b+a;}):0)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject11),": ",formatter.format(Math.round(totalValue)))),hasGoogleData&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject11),":"," ",hasGoogleData&&pageData&&!!pageData.length&&pageData.reduce(function(a,b){var slug=salesPerObject.find(function(x){return b[0].includes(x.slug);});if(!slug){return a;}return a+=Math.round(Number(b[1]));},0))),hasGoogleData&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject11),":"," ",hasGoogleData&&pageData&&!!pageData.length&&Math.round(pageData.reduce(function(a,b){var slug=salesPerObject.find(function(x){return b[0].includes(x.slug);});if(!slug){return a;}return a+=Math.round(Number(b[2]));},0)/60)," ","min")),hasGoogleData&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject11),":"," ",pageData&&!!pageData.length&&this.sumConversion(pageData,salesPerObject)))))))||__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Paper"],{style:{maxWidth:1200,margin:"auto",padding:20}}," ",__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h2",null,Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject12))," ")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{style:{margin:20,marginLeft:"34px"}},!loading&&!!invitations&&(!!invitations.invPerCourse.length||!!invitations.invPerCircle.length)&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Paper"],{style:{maxWidth:1200,margin:"auto"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h2",{style:{fontSize:22,lineHeight:"28px",borderRadius:"2px",padding:"20px",background:"#777",color:"#fff"}},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject13)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Table"],{fixedHeader:true,selectable:false,multiSelectable:false},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeader"],{selectAllSelected:false,adjustForCheckbox:false,displaySelectAll:false,enableSelectAll:false},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject5)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject5)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject3)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject13)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject3)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject14)," ",Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject13)))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableBody"],{displayRowCheckbox:false,stripedRows:false},invitations.invPerCourse.map(function(_ref5){var id=_ref5.id,name=_ref5.name,count=_ref5.count,acceptedCount=_ref5.acceptedCount;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRow"],{key:id},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},name),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},count),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},acceptedCount));}),invitations.invPerCircle.map(function(_ref6){var id=_ref6.id,name=_ref6.name,count=_ref6.count,acceptedCount=_ref6.acceptedCount;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRow"],{key:id},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},name),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},count),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},acceptedCount));}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],null),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject11),": ",invitations.count)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong",null,Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject11),": ",invitations.acceptedCount))))))||__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Paper"],{style:{maxWidth:1200,margin:"auto",padding:20}}," ",__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h2",null,Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject15))," ")));}}]);return StatisticsSalesTab;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);var StatisticsUsageTab=function(_Component4){_inherits(StatisticsUsageTab,_Component4);function StatisticsUsageTab(){var _ref7;var _temp3,_this9,_ret3;_classCallCheck(this,StatisticsUsageTab);for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return _ret3=(_temp3=(_this9=_possibleConstructorReturn(this,(_ref7=StatisticsUsageTab.__proto__||Object.getPrototypeOf(StatisticsUsageTab)).call.apply(_ref7,[this].concat(args))),_this9),_this9.state={loading:true,loadingDetails:true,courses:[],selectedCourse:null,sortingTable:null,sortBy:false,sortOrder:false},_this9.fetchCourses=function(){SteelCompass.request("course","findBuildable").then(function(courses){_this9.setState(function(state){return Object.assign({},state,{courses:courses});});});},_this9.handleChange=function(_,__,menuItem){if(menuItem.payload===_this9.state.selectedCourse||menuItem.payload==="none"){return;}_this9.props.selectedCourse(menuItem.id);_this9.props.fetchEventStats({startDate:_this9.props.startDate,endDate:_this9.props.endDate,dimensions:"ga:pagePath",metrics:"ga:sessions, ga:avgSessionDuration",sort:"-ga:avgSessionDuration",filters:"ga:pagePath=@/"+menuItem.payload+"/",courseId:menuItem.id});_this9.props.fetchEventStats({startDate:_this9.props.startDate,endDate:_this9.props.endDate,filters:"ga:pagePath=@"+menuItem.payload,dimensions:"ga:pagePath,ga:eventAction",metrics:"ga:totalEvents",sort:"-ga:totalEvents",courseId:menuItem.id},"interactionData").then(function(){return _this9.setState({loading:false});});_this9.setState(function(state){return Object.assign({},state,{selectedCourse:menuItem.payload,courseId:menuItem.id});});},_this9.mapUsageData=function(data){return data.map(function(obj){var sessions=0;var avgSessionDuration=0;if(obj.gaData.length){obj.gaData.forEach(function(item){avgSessionDuration+=item.avgSessionDuration&&Number(item.avgSessionDuration);sessions+=item.sessions&&Number(item.sessions);});}return Object.assign({},obj,{avgSessionDuration:avgSessionDuration,sessions:sessions});});},_this9.mapInteractionData=function(data){var flatList=[];data.forEach(function(item){var numberOfgaItems=item.gaData.length;if(numberOfgaItems===1){flatList.push({sectionName:item.sectionName,name:item.name,eventAction:item.gaData[0].eventAction,totalEvents:Number(item.gaData[0].totalEvents)});}else if(numberOfgaItems>1){//handle duplication from GA e.g. /course/:id /course/:slug/:id
item.gaData.reduce(function(acc,current){var totalEvents=0;var x=acc.find(function(baz){return baz.eventAction===current.eventAction;});if(!x){return acc.concat([current]);}else{if(acc[0]&&acc[0].totalEvents){totalEvents=Number(acc[0].totalEvents);totalEvents+=Number(current.totalEvents);}return[Object.assign({},acc[0],{totalEvents:totalEvents,sectionName:item.sectionName,name:item.name})];}},[]).forEach(function(item){return flatList.push(item);});}else{flatList.push({sectionName:item.sectionName,name:item.name,eventAction:"n/a",totalEvents:0});}});return flatList;},_this9.sortSectionAndName=function(a,b){if(_this9.state.sortOrder){if(a.section<b.section){return-1;}if(a.section>b.section){return 1;}if(a.name<b.name){return-1;}if(a.name>b.name){return 1;}}else{if(a.section>b.sectionName){return-1;}if(a.section<b.sectionName){return 1;}if(a.name>b.name){return-1;}if(a.name<b.name){return 1;}}},_this9.sortColumn=function(a,b){if(_this9.state.sortOrder){if(a[_this9.state.sortBy]>b[_this9.state.sortBy]){return-1;}if([_this9.state.sortBy]<[_this9.state.sortBy]){return 1;}return 0;}else{if(b[_this9.state.sortBy]<b[_this9.state.sortBy]){return-1;}if(a[_this9.state.sortBy]>b[_this9.state.sortBy]){return 1;}return 0;}},_this9.sortUsageData=function(a,b){if(!_this9.state.sortBy&&_this9.state.sortingTable==="usage")return 0;if(_this9.state.sortBy==="sectionName")return _this9.sortSectionAndName(a,b);return _this9.sortColumn(a,b);},_this9.sortInteractionData=function(a,b){if(!_this9.state.sortBy&&_this9.state.sortingTable==="interction")return 0;if(_this9.state.sortBy==="sectionName")return _this9.sortSectionAndName(a,b);return _this9.sortColumn(a,b);},_this9.sortTable=function(table,column,toggle){_this9.setState({sortingTable:table});_this9.setState({sortBy:column});_this9.setState({sortOrder:!toggle});},_temp3),_possibleConstructorReturn(_this9,_ret3);}_createClass(StatisticsUsageTab,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this10=this;if(nextProps.startDate!==this.props.startDate||nextProps.endDate!==this.props.endDate){if(this.state.selectedCourse){this.setState({loading:true});this.props.fetchEventStats({startDate:nextProps.startDate,endDate:nextProps.endDate,filters:"ga:pagePath=@/"+this.state.selectedCourse+"/",dimensions:"ga:pagePath",metrics:"ga:sessions, ga:avgSessionDuration",sort:"-ga:avgSessionDuration",courseId:this.state.courseId});this.props.fetchEventStats({startDate:nextProps.startDate,endDate:nextProps.endDate,filters:"ga:pagePath=@"+this.state.selectedCourse,dimensions:"ga:pagePath,ga:eventAction",metrics:"ga:totalEvents",sort:"-ga:totalEvents",courseId:this.state.courseId},"interactionData").then(function(){return _this10.setState({loading:false});});}}}},{key:"componentWillMount",value:function componentWillMount(){this.fetchCourses();}},{key:"printInteractionType",value:function printInteractionType(interaction){switch(interaction){case"task_interaction":return Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject16);case"video_interaction":return Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject17);case"download_interaction":return Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject18);case"slideshow_interaction":return Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject19);case"discussion_interaction":return Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject20);case"audio_interaction":return Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject21);default:return"n/a";}}},{key:"render",value:function render(){var _this11=this;var _state=this.state,loading=_state.loading,loadingDetails=_state.loadingDetails,courses=_state.courses,error=_state.error,sortBy=_state.sortBy;var _props2=this.props,interactionData=_props2.interactionData,data=_props2.data;var standardActions=[__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{key:"close",label:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject22),secondary:true,onTouchTap:function onTouchTap(){_this11.refs.interactionDialog.dismiss();}})];var menuItems=courses.map(function(c){return{payload:c.slug,id:c.id,text:c.name};});menuItems.unshift({payload:"none",text:"Select course"});return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{style:{overflowY:"scroll",height:"calc(100vh - 200px)"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:css.dropdown},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["SelectField"],{style:{width:"100%"},onChange:this.handleChange,menuItems:menuItems}),error&&error),!loading&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{style:{margin:20,marginLeft:"34px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Paper"],{style:{maxWidth:1200,margin:"auto"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h2",{style:{fontSize:22,lineHeight:"28px",borderRadius:"2px",padding:"20px",background:"#777",color:"#fff"}},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject23)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Table"],{height:"400px",style:{maxWidth:1200,margin:"auto"},fixedHeader:true,multiSelectable:false},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeader"],{selectAllSelected:false,adjustForCheckbox:false,displaySelectAll:false,enableSelectAll:false},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject24)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject24),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["IconButton"],{onClick:function onClick(e){return _this11.sortTable("usage","sectionName",_this11.state.sortOrder);}},!this.state.sortOrder&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationArrowDropDown"],null),this.state.sortOrder&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationArrowDropUp"],null))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject25)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject25),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["IconButton"],{onClick:function onClick(e){return _this11.sortTable("usage","sessions",_this11.state.sortOrder);}},!this.state.sortOrder&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationArrowDropDown"],null),this.state.sortOrder&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationArrowDropUp"],null))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject26)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject26),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["IconButton"],{onClick:function onClick(e){return _this11.sortTable("usage","avgSessionDuration",_this11.state.sortOrder);}},!this.state.sortOrder&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationArrowDropDown"],null),this.state.sortOrder&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationArrowDropUp"],null))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableBody"],{displayRowCheckbox:false,stripedRows:false},!loading&&data&&this.mapUsageData(data).sort(this.sortUsageData).map(function(page,i){var minutes=Math.floor(page.avgSessionDuration/60);var seconds=Math.floor(page.avgSessionDuration-minutes*60);return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRow"],{key:page.id,style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong",null,page.sectionName)," -"," ",page.name),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],null,page.sessions),page&&page.avgSessionDuration&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},minutes+":"+seconds)||__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},"N/A"));}),")}")))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{style:{margin:20,marginLeft:"34px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Paper"],{style:{maxWidth:1200,margin:"auto"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h2",{style:{fontSize:22,lineHeight:"28px",borderRadius:"2px",padding:"20px",background:"#777",color:"#fff"}},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject27)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Table"],{style:{margin:"auto"},height:"400px",fixedHeader:true,multiSelectable:false},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeader"],{selectAllSelected:false,adjustForCheckbox:false,displaySelectAll:false,enableSelectAll:false},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565",fontSize:"13px"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject24)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject24),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["IconButton"],{onClick:function onClick(e){return _this11.sortTable("interaction","sectionName",_this11.state.sortOrder);}},!this.state.sortOrder&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationArrowDropDown"],null),this.state.sortOrder&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationArrowDropUp"],null))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject28)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject28),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["IconButton"],{onClick:function onClick(e){return _this11.sortTable("interaction","eventAction",_this11.state.sortOrder);}},!this.state.sortOrder&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationArrowDropDown"],null),this.state.sortOrder&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationArrowDropUp"],null))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableHeaderColumn"],{style:{color:"#656565"},tooltip:Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject7)},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject7),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["IconButton"],{onClick:function onClick(e){return _this11.sortTable("interaction","totalEvents",_this11.state.sortOrder);}},!this.state.sortOrder&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationArrowDropDown"],null),this.state.sortOrder&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationArrowDropUp"],null))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableBody"],{displayRowCheckbox:false,stripedRows:false},!loading&&interactionData&&this.mapInteractionData(interactionData).sort(this.sortInteractionData).map(function(page,i){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRow"],{key:i,style:{cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong",null,page.sectionName)," -"," ",page.name),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])([page.eventAction])),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TableRowColumn"],{style:{fontSize:"15px"}},page.totalEvents));}))))))));}}]);return StatisticsUsageTab;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/***/ }),
/* 2127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores_Course__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Notes_NotesOverview__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_AppPage__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotesContainer=function(_mixin){_inherits(NotesContainer,_mixin);function NotesContainer(){_classCallCheck(this,NotesContainer);return _possibleConstructorReturn(this,(NotesContainer.__proto__||Object.getPrototypeOf(NotesContainer)).apply(this,arguments));}_createClass(NotesContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_2_stores_Course__["a" /* default */]);}},{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_actions_Course__["a" /* default */].findNotes();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_RulerBar__["a" /* default */],{title:'Notes'})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'3em'}},this.state.notes.map(function(course){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Notes_NotesOverview__["a" /* default */],Object.assign({id:course.id,course:course,notes:course.sections},_this2.props));})));}}]);return NotesContainer;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (NotesContainer);

/***/ }),
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_ListDetail__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Tags__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Units=__WEBPACK_IMPORTED_MODULE_11_Css__["default"].Units;var css={filterContainer:'_e',buttonWrapper:'_f'};var Students=function(_mixin){_inherits(Students,_mixin);function Students(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Students);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Students.__proto__||Object.getPrototypeOf(Students)).call.apply(_ref,[this].concat(args))),_this),_this.state={filter:{}},_this.deleteTag=function(tagName){var filter=Object.assign({},_this.statefilter);delete filter[tagName];_this.setState({filter:filter});},_this.addTag=function(tagName){_this.setState({filter:Object.assign({},_this.state.filter,_defineProperty({},tagName,true))});},_this.setTab=function(list){__WEBPACK_IMPORTED_MODULE_2_actions__["D" /* StudentOverviewActions */].changeList(list);},_temp),_possibleConstructorReturn(_this,_ret);}// mixins : [AuthMixin, IntlMixin, Reflux.connect(AppStore, 'app'), Reflux.connect(AuthStore, 'auth'), Reflux.connect(StudentStore, 'students')],
_createClass(Students,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_1_stores__["w" /* StudentOverviewStore */],function(state){return{user:state.user,invitation:state.invitation,activeList:state.activeList};});}},{key:'componentDidMount',value:function componentDidMount(){var activeList=this.state.activeList;__WEBPACK_IMPORTED_MODULE_2_actions__["D" /* StudentOverviewActions */].getList(activeList);}},{key:'gotoStudent',value:function gotoStudent(student){if(student.realUser){this.props.router.push('/student/'+student.id);// StudentActions.findById(student);
}else{this.props.router.push('/invitation-detail/'+student.id);// InvitationActions.showInfo(student);
}}},{key:'getItemStyle',value:function getItemStyle(){var style={};return style;}},{key:'createListItem',value:function createListItem(item,leftAvatar,insetChildren){var style=this.getItemStyle();if(this.state.selected&&item.id===this.state.selected.id){style.backgroundColor=__WEBPACK_IMPORTED_MODULE_9_components_Material_Styles_Colors__["a" /* Colors */].grey[300].material;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{style:style,leftAvatar:leftAvatar,insetChildren:insetChildren,key:'i'+item.id,primaryText:item.name,secondaryText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Tags__["a" /* TagList */],{dense:true,tags:item.tagsMap}),onTouchTap:this.gotoStudent.bind(this,item)});}},{key:'export',value:function _export(){this.props.router.push('/student/export');}},{key:'renderFilterBar',value:function renderFilterBar(){var activeList=this.state.activeList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.filterContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('students.students'),backgroundColor:'#ddd',onTouchTap:this.setTab.bind(this,'user'),disabled:activeList==='user',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('students.invitations'),backgroundColor:'#ddd',onTouchTap:this.setTab.bind(this,'invitation'),disabled:activeList==='invitation',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'})));}},{key:'render',value:function render(){var _this2=this;var activeList=this.state.activeList;var items=this.state[activeList].list;var loading=this.state[activeList].loading;var exportForm=void 0;var filterFunc=function filterFunc(item,searchText,labelProperty,emailProperty){var hasTags=true;Object.keys(_this2.state.filter).forEach(function(tagName){var tagsMap=item.tagsMap||{};hasTags=hasTags&&tagsMap[tagName];});if(!hasTags){return false;}if(searchText&&searchText!==''){return item[labelProperty].search(searchText)>-1||item[emailProperty].search(searchText)>-1;}else{return true;}};var tagSelector=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderFilterBar());return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_RulerBar__["a" /* default */],{title:'Students'}),className:'student'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_ListDetail__["a" /* default */],{key:activeList,activeList:this.state.user&&this.state.user.list,loading:loading,filter:filterFunc,listHeader:tagSelector,items:items,listItemGenerator:this.createListItem.bind(this),floatingActionButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["FloatingActionButton"],{onTouchTap:this.export.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ActionLaunch"],null))},this.props.children));}}]);return Students;}(Object(__WEBPACK_IMPORTED_MODULE_6_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_6_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));Students.defaultProps={filterBar:true};Students.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Students);

/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tag__ = __webpack_require__(387);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ENTER=13;var BACKSPACE=8;var css={tagsContainer:'_ca',fullWidth:'_cb',dark:'_cc',input:'_cd',padded:'_ce',inputWrapper:'_cf'};var TagSelector=function(_Component){_inherits(TagSelector,_Component);function TagSelector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TagSelector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TagSelector.__proto__||Object.getPrototypeOf(TagSelector)).call.apply(_ref,[this].concat(args))),_this),_this.addedTags=Object.keys(_this.props.tags),_this.handleKey=function(event){var keyCode=event.keyCode;if(keyCode===ENTER){_this.addTag();}else if(keyCode===BACKSPACE&&!_this._input.value&&_this.addedTags.length>0){var toDelete=_this.addedTags.pop();_this.removeTag(toDelete);}},_this.addTag=function(){var onAddTag=_this.props.onAddTag;var tagName=_this._input.value.trim();if(tagName&&tagName!==''){_this.addedTags.push(tagName);onAddTag&&onAddTag(tagName);_this._input.value=null;}},_this.removeTag=function(tagName){var onRemoveTag=_this.props.onRemoveTag;_this.addedTags=_this.addedTags.filter(function(tag){return tag!==tagName;});onRemoveTag&&onRemoveTag(tagName);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TagSelector,[{key:'render',value:function render(){var _classNames,_this2=this;var _props=this.props,tags=_props.tags,fullWidth=_props.fullWidth,dark=_props.dark,padded=_props.padded,placeholder=_props.placeholder;var getIntlMessage=this.context.getIntlMessage;var classes=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.tagsContainer,(_classNames={},_defineProperty(_classNames,css.dark,dark),_defineProperty(_classNames,css.padded,padded),_defineProperty(_classNames,css.fullWidth,fullWidth),_classNames));var placeholderText=typeof placeholder==='undefined'?getIntlMessage('tag.name'):placeholder;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes,onTouchTap:function onTouchTap(){return _this2._input.focus();}},tags&&Object.keys(tags).map(function(tagName){if(tags[tagName]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Tag__["a" /* default */],{dark:dark,onRemove:_this2.removeTag,key:tagName,tag:tagName});}return null;}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.inputWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:function ref(_input){return _this2._input=_input;},className:css.input,type:'text',placeholder:placeholderText,onKeyUp:this.handleKey})));}}]);return TagSelector;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TagSelector.propTypes={tags:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,onAddTag:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onRemoveTag:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,placeholder:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,fullWidth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,padded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,dark:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};TagSelector.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};TagSelector.defaultProps={fullWidth:false,tags:{}};/* harmony default export */ __webpack_exports__["a"] = (TagSelector);

/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tag__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={tagsContainer:'_b_',fullWidth:'_b-'};var TagList=function(_Component){_inherits(TagList,_Component);function TagList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TagList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TagList.__proto__||Object.getPrototypeOf(TagList)).call.apply(_ref,[this].concat(args))),_this),_this.addedTags=[],_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TagList,[{key:'render',value:function render(){var _this2=this;var _props=this.props,tags=_props.tags,fullWidth=_props.fullWidth,other=_objectWithoutProperties(_props,['tags','fullWidth']);var classes=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.tagsContainer,_defineProperty({},css.fullWidth,fullWidth));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},tags&&Object.keys(tags).map(function(tagName){if(tags[tagName]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Tag__["a" /* default */],Object.assign({},other,{onRemove:_this2.removeTag,key:tagName,tag:tagName}));}return null;}));}}]);return TagList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TagList.propTypes={tags:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,fullWidth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};TagList.defaultProps={fullWidth:false};/* harmony default export */ __webpack_exports__["a"] = (TagList);

/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Route_Student_Detail__ = __webpack_require__(2132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_Auth__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_Loader__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StudentDetailContainer=function(_mixin){_inherits(StudentDetailContainer,_mixin);function StudentDetailContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StudentDetailContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StudentDetailContainer.__proto__||Object.getPrototypeOf(StudentDetailContainer)).call.apply(_ref,[this].concat(args))),_this),_this.state={lista:'user'},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StudentDetailContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores__["x" /* StudentStore */]);this.listenToStore(__WEBPACK_IMPORTED_MODULE_5_stores_Auth__["a" /* default */],'auth');}},{key:'componentWillMount',value:function componentWillMount(){if(_get(StudentDetailContainer.prototype.__proto__||Object.getPrototypeOf(StudentDetailContainer.prototype),'componentWillMount',this)){_get(StudentDetailContainer.prototype.__proto__||Object.getPrototypeOf(StudentDetailContainer.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_1_actions__["C" /* StudentActions */].findById(this.props.params.studentId);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.routeParams.studentId!==nextProps.routeParams.studentId){__WEBPACK_IMPORTED_MODULE_1_actions__["C" /* StudentActions */].findById(nextProps.routeParams.studentId);}}},{key:'render',value:function render(){var _state=this.state,student=_state.student,auth=_state.auth;if(!student){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_Loader__["b" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Route_Student_Detail__["a" /* default */],{student:student,auth:auth,list:this.state.lista,onClose:this.props.router.goBack});}}]);return StudentDetailContainer;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (StudentDetailContainer);

/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores_Student__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_Group__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores_Course__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Widgets_SimpleOverview__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_Invite__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Tag__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_CourseSelector__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_GroupSelector__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_DialogPortal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Material_DropDown__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Widgets_Overview__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_Icons__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_7_material_ui__["Styles"].Spacing;var StudentDetail=function(_mixin){_inherits(StudentDetail,_mixin);function StudentDetail(props,context){_classCallCheck(this,StudentDetail);var _this=_possibleConstructorReturn(this,(StudentDetail.__proto__||Object.getPrototypeOf(StudentDetail)).call(this,props,context));_this.setToggle=function(roleMask,event){var rolesValue=_this.props.student.roles;var checked=event.target.checked;if(_this._timer){clearTimeout(_this._timer);}_this._timer=setTimeout(function(rolesValue,roleMask){if(checked){rolesValue.push(roleMask);}else{var index=rolesValue.indexOf(roleMask);if(index>-1){rolesValue.splice(index,1);}rolesValue[roleMask]=false;}_this.setState({rolesValue:rolesValue});__WEBPACK_IMPORTED_MODULE_5_actions__["C" /* StudentActions */].update(_this.props.student.id,rolesValue,function(){__WEBPACK_IMPORTED_MODULE_5_actions__["j" /* GroupActions */].findByUserId(_this.props.student.id);__WEBPACK_IMPORTED_MODULE_5_actions__["f" /* CourseActions */].findByUserId(_this.props.student.id);});_this._timer=null;},300,rolesValue,roleMask);};_this.goToCourse=function(item){if(item===null){_this.setState({student:null});}else{_this.props.router.push('/course/'+item.id);}};_this.goToGroup=function(item){if(item===null){_this.setState({student:null});}else{_this.props.router.push('/group/'+item.id);}};_this.state={accessTime:null,selectedCourse:{name:context.getIntlMessage('course.noSelected')},selectedGroup:{name:context.getIntlMessage('group.noSelected')},selectedStudent:{name:context.getIntlMessage('student.noSelected')},rolesValue:_this.props.student.roles.value,progress:[]};_this.accessTimes={oneMonth:context.getIntlMessage('invite.oneMonth'),threeMonths:context.getIntlMessage('invite.threeMonths'),sixMonths:context.getIntlMessage('invite.sixMonths'),oneYear:context.getIntlMessage('invite.oneYear')};_this.menuItems=[{payload:null,text:context.getIntlMessage('invite.chooseAccessTime')}];Object.keys(_this.accessTimes).forEach(function(time){_this.menuItems.push({payload:time,text:_this.accessTimes[time]});});return _this;}_createClass(StudentDetail,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores_Group__["a" /* default */],'group');this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores_Course__["a" /* default */],'course');this.listenToStore(__WEBPACK_IMPORTED_MODULE_2_stores_Student__["a" /* default */],'student');}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var student=this.props.student;__WEBPACK_IMPORTED_MODULE_5_actions__["j" /* GroupActions */].findByUserId(student.id);__WEBPACK_IMPORTED_MODULE_5_actions__["f" /* CourseActions */].findByUserId(student.id);SteelCompass.request("statistics","user",{userId:student.id}).then(function(response){_this2.setState({progress:response.courses});});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this3=this;if(nextProps.student.id!==this.props.student.id){__WEBPACK_IMPORTED_MODULE_5_actions__["j" /* GroupActions */].findByUserId(nextProps.student.id);__WEBPACK_IMPORTED_MODULE_5_actions__["f" /* CourseActions */].findByUserId(nextProps.student.id);SteelCompass.request("statistics","user",{userId:nextProps.student.id}).then(function(response){_this3.setState({progress:response.courses});});}}},{key:'confirmDelete',value:function confirmDelete(){this.refs.confirmDialog.show();}},{key:'onConfirmRevoke',value:function onConfirmRevoke(){var _this4=this;this.refs.revokeAccessDialog.dismiss();__WEBPACK_IMPORTED_MODULE_5_actions__["C" /* StudentActions */].removeFromCourse(this.state.selectedCourse.id,this.props.id,function(){__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(_this4.context.getIntlMessage('student.revokedAccess'));__WEBPACK_IMPORTED_MODULE_5_actions__["f" /* CourseActions */].findByUserId(_this4.props.id);});}},{key:'revokeAccess',value:function revokeAccess(){this.refs.revokeAccessDialog.show();}},{key:'selectCourse',value:function selectCourse(course){this.setState({selectedCourse:course});}},{key:'closeDetail',value:function closeDetail(){if(this.props.onClose){this.props.onClose();}}},{key:'deleteTag',value:function deleteTag(tagName){__WEBPACK_IMPORTED_MODULE_5_actions__["C" /* StudentActions */].removeTag(this.props.student.id,tagName);}},{key:'addTag',value:function addTag(){var tagName=this.refs.addTag.getValue();__WEBPACK_IMPORTED_MODULE_5_actions__["C" /* StudentActions */].addTag(this.props.student.id,tagName);this.refs.addTag.clearValue();}},{key:'removeFromGroup',value:function removeFromGroup(group){this.setState({selectedGroup:group});this.refs.removeFromGroupDialog.show();}},{key:'removeFromCourse',value:function removeFromCourse(course){this.setState({selectedCourse:course});this.refs.removeFromCourseDialog.show();}},{key:'_onRemoveFromCourseConfirm',value:function _onRemoveFromCourseConfirm(){__WEBPACK_IMPORTED_MODULE_5_actions__["C" /* StudentActions */].removeFromCourse(this.state.selectedCourse.id,this.props.student.id);this.refs.removeFromCourseDialog.dismiss();}},{key:'_onRemoveFromGroupConfirm',value:function _onRemoveFromGroupConfirm(){__WEBPACK_IMPORTED_MODULE_5_actions__["C" /* StudentActions */].removeFromGroup(this.state.selectedGroup.id,this.props.student.id);this.refs.removeFromGroupDialog.dismiss();}},{key:'_onDeleteStudentConfirm',value:function _onDeleteStudentConfirm(){__WEBPACK_IMPORTED_MODULE_5_actions__["C" /* StudentActions */].expel(this.state.selectedStudent.id);this.refs.removeStudentDialog.dismiss();// StudentOverviewActions.getList(this.props.list);
this.closeDetail();}},{key:'addToGroups',value:function addToGroups(){this.refs.addToGroupsDialog.show();}},{key:'addToCourses',value:function addToCourses(){this.refs.addToCoursesDialog.show();}},{key:'expelStudent',value:function expelStudent(student){this.setState({selectedStudent:student});this.refs.removeStudentDialog.show();}},{key:'changeAccessTime',value:function changeAccessTime(event,selectedIndex,menuItem){this.setState({accessTime:menuItem.payload});}},{key:'createAddToCoursesDialog',value:function createAddToCoursesDialog(){var menuItems=this.menuItems;var selectedIndex=menuItems.findIndex(function(item){return item.payload==='sixMonths';});var actions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Add'),onTouchTap:this._addCoursesConfirm.bind(this),ref:'submit'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'addToCoursesDialog',actions:actions,actionFocus:'submit',dismissOnClickAway:true,autoDetectWindowHeight:true,autoScrollBodyContent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Material_DropDown__["a" /* default */],{onChange:this.changeAccessTime.bind(this),label:this.context.getIntlMessage('invite.accessTime'),ref:'courseAccessTime',selectedIndex:selectedIndex,menuItems:menuItems}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CourseSelector__["a" /* default */],{ref:'courseSelector'}));}},{key:'_addCoursesConfirm',value:function _addCoursesConfirm(){var _this5=this;var courseIds=Object.keys(this.refs.courseSelector.getSelected()).map(function(id){return parseInt(id,10);});var accessTime=this.state.accessTime;var userIds=[this.props.student.id];__WEBPACK_IMPORTED_MODULE_10_actions_Invite__["a" /* default */].inviteByUserIds(userIds,courseIds,accessTime,function(){__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(_this5.context.getIntlMessage('invite.studentInvitedToCourse'));_this5.refs.addToCoursesDialog.dismiss();__WEBPACK_IMPORTED_MODULE_5_actions__["f" /* CourseActions */].findByUserId(_this5.props.student.id);});}},{key:'createAddToGroupsDialog',value:function createAddToGroupsDialog(){var actions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Add'),onTouchTap:this._addGroupsConfirm.bind(this),ref:'submit'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'addToGroupsDialog',actions:actions,actionFocus:'submit',dismissOnClickAway:true,autoDetectWindowHeight:true,autoScrollBodyContent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_GroupSelector__["a" /* default */],{ref:'groupSelector'}));}},{key:'_addGroupsConfirm',value:function _addGroupsConfirm(){var _this6=this;var groupIds=Object.keys(this.refs.groupSelector.getSelected()).map(function(id){return parseInt(id,10);});__WEBPACK_IMPORTED_MODULE_5_actions__["G" /* UserActions */].addToCircle([this.props.student.id],groupIds,function(){__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(_this6.context.getIntlMessage('student.addedToGroup'));_this6.refs.addToGroupsDialog.dismiss();__WEBPACK_IMPORTED_MODULE_5_actions__["j" /* GroupActions */].findByUserId(_this6.props.student.id);});}},{key:'render',value:function render(){var _this7=this;var active=this.context.getIntlMessage('student.neverActive'),student=this.props.student,auth=this.props.auth,lastActive=student.lastActive,removeFromGroupActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Remove'),onTouchTap:this._onRemoveFromGroupConfirm.bind(this),ref:'submit'}],removeFromCourseActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Remove'),onTouchTap:this._onRemoveFromCourseConfirm.bind(this),ref:'submit'}],deleteStudentActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Remove'),onTouchTap:this._onDeleteStudentConfirm.bind(this),ref:'submit'}],addToCoursesDialog=this.createAddToCoursesDialog(),addToGroupsDialog=this.createAddToGroupsDialog();if(lastActive&&lastActive!==__WEBPACK_IMPORTED_MODULE_8_Constants__["default"].NO_TIME){var lastActiveFixed=lastActive&&lastActive.split(' ').join('T')+'Z';var lastActiveDate=void 0;try{lastActiveDate=new Date(lastActiveFixed);active=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('student.active'),ago:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedRelative"],{value:lastActiveDate})});}catch(e){active=' ';}}var tags=void 0;if(student.tagsMap){tags=Object.keys(student.tagsMap).map(function(tag){if(student.tagsMap[tag])return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Tag__["a" /* default */],{onDelete:_this7.deleteTag.bind(_this7),key:tag,controls:true,mini:false,name:tag});});}var roleMap=this.props.student.roles.reduce(function(map,item){map[item]=true;return map;},{});var rolesList=void 0;if(auth.role.assistant){rolesList=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["List"],{subheader:this.context.getIntlMessage('Roles'),style:{marginTop:Spacing.desktopGutter,backgroundColor:'#FFFFFF'},subheaderStyle:{fontSize:24,borderStyle:'none none solid none',borderWidth:'1px',borderColor:'rgba(0, 0, 0, 0.12)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{primaryText:this.context.getIntlMessage('role.reader'),rightToggle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{toggled:!!roleMap.reader,onToggle:this.setToggle.bind(this,'reader'),ref:'reader'})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{primaryText:this.context.getIntlMessage('role.editor'),rightToggle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{toggled:!!roleMap.editor,onToggle:this.setToggle.bind(this,'editor'),ref:'editor'})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{primaryText:this.context.getIntlMessage('role.teacher'),rightToggle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{toggled:!!roleMap.teacher,onToggle:this.setToggle.bind(this,'teacher'),ref:'teacher'})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{primaryText:this.context.getIntlMessage('role.accountant'),rightToggle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{toggled:!!roleMap.accountant,onToggle:this.setToggle.bind(this,'accountant'),ref:'accountant'})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{primaryText:this.context.getIntlMessage('role.owner'),rightToggle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{toggled:!!roleMap.owner,onToggle:this.setToggle.bind(this,'owner'),ref:'owner'})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{primaryText:this.context.getIntlMessage('role.assistant'),rightToggle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{toggled:!!roleMap.assistant,onToggle:this.setToggle.bind(this,'assistant'),ref:'assistant'})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{primaryText:this.context.getIntlMessage('role.tester'),rightToggle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{toggled:!!roleMap.tester,onToggle:this.setToggle.bind(this,'tester'),ref:'tester'})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{primaryText:this.context.getIntlMessage('role.darkAdmin'),rightToggle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{toggled:!!roleMap.darkAdmin,onToggle:this.setToggle.bind(this,'darkAdmin'),ref:'darkAdmin'})}));}else{rolesList=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["List"],{subheader:this.context.getIntlMessage('Roles'),style:{marginTop:Spacing.desktopGutter,backgroundColor:'#FFFFFF'},subheaderStyle:{fontSize:24,borderStyle:'none none solid none',borderWidth:'1px',borderColor:'rgba(0, 0, 0, 0.12)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{primaryText:this.context.getIntlMessage('role.reader'),rightToggle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{toggled:!!roleMap.reader,onToggle:this.setToggle.bind(this,'reader'),ref:'reader'})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{primaryText:this.context.getIntlMessage('role.teacher'),rightToggle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{toggled:!!roleMap.teacher,onToggle:this.setToggle.bind(this,'teacher'),ref:'teacher'})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{primaryText:this.context.getIntlMessage('role.accountant'),rightToggle:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toggle"],{toggled:!!roleMap.accountant,onToggle:this.setToggle.bind(this,'accountant'),ref:'accountant'})}));}var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ToolbarTitle"],{text:this.context.getIntlMessage('Student')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ToolbarGroup"],{float:'right',key:1},parseInt(this.props.auth&&this.props.auth.id)===parseInt(this.state.student&&this.state.student.student&&this.state.student.student.id)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_Material_SvgIcons__["ActionDelete"],null),tooltip:this.context.getIntlMessage('student.expel'),tooltipPosition:'bottom-center',onTouchTap:this.expelStudent.bind(this,student)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_Material_SvgIcons__["SocialGroupAdd"],null),tooltip:this.context.getIntlMessage('group.add'),tooltipPosition:'bottom-center',onTouchTap:this.addToGroups.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_components_Icons__["Library"],null),tooltip:this.context.getIntlMessage('course.add'),tooltipPosition:'bottom-center',onTouchTap:this.addToCourses.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_Material_SvgIcons__["ContentClear"],null),tooltip:this.context.getIntlMessage('Close'),tooltipPosition:'bottom-center',onTouchTap:this.closeDetail.bind(this)})));// Remove recently deleted (non-active) courses.
var courseSelection=this.state.progress.filter(function(course){return!course.ucpInfo.isDeleted;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_ScrollableContainer__["a" /* default */],{header:toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["List"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_Material_SvgIcons__["ActionLabel"],null),primaryText:student.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_Material_SvgIcons__["ContentInbox"],null),primaryText:student.email}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_Material_SvgIcons__["DeviceAccessTime"],null),primaryText:active})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_Widgets_Overview__["a" /* default */],{header:this.context.getIntlMessage('Tags')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini*2}},tags,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["TextField"],{fullWidth:true,floatingLabelText:this.context.getIntlMessage('tag.add'),ref:'addTag',onEnterKeyDown:this.addTag.bind(this)})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Widgets_SimpleOverview__["a" /* default */],{loading:this.state.group.selectionLoading,items:this.state.group.selection,readable:'name',title:this.context.getIntlMessage('group.Groups'),onTouchTapRightIcon:this.removeFromGroup.bind(this),onSelect:this.goToGroup}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Widgets_SimpleOverview__["a" /* default */],{loading:this.state.course.selectionLoading,items:courseSelection,progress:this.state.progress,readable:'name',title:this.context.getIntlMessage('course.Courses'),onTouchTapRightIcon:this.removeFromCourse.bind(this),onSelect:this.goToCourse}),rolesList,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'removeFromCourseDialog',title:this.context.getIntlMessage('student.removeFromCourse'),actions:removeFromCourseActions,actionFocus:'submit',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('student.revokeAccess'),course:this.state.selectedCourse.name,student:this.props.student.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'removeFromGroupDialog',title:this.context.getIntlMessage('student.removeFromGroupShort'),actions:removeFromGroupActions,actionFocus:'submit',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('student.removeFromGroup'),group:this.state.selectedGroup.name,student:this.props.student.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Dialog"],{ref:'removeStudentDialog',title:this.context.getIntlMessage('student.expel'),actions:deleteStudentActions,actionFocus:'submit',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('student.expelConfirm'),student:this.state.selectedStudent.name})),addToCoursesDialog,addToGroupsDialog));}}]);return StudentDetail;}(Object(__WEBPACK_IMPORTED_MODULE_12_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_12_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));StudentDetail.contextTypes={router:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* withRouter */])(StudentDetail));

/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(170);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]

  /**
   * A <Router> is a high-level API for automatically setting up
   * a router that renders a <RouterContext> with all the props
   * it needs each time the URL changes.
   */
};var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(209);

var emptyObject = __webpack_require__(153);
var _invariant = __webpack_require__(20);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(57);
var invariant = __webpack_require__(20);
var ReactPropTypesSecret = __webpack_require__(2136);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(171);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(388);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 2139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(171);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(593);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 2141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(118);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 2142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(171);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 2143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(595);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexLink);

/***/ }),
/* 2144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(391);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 2145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(200);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRedirect);

/***/ }),
/* 2146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(200);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(200);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 2148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(594);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : Object(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (match);

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(2150);
var objectAssign = __webpack_require__(209);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(111);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(161);

var _PathUtils = __webpack_require__(112);

var _createHistory = __webpack_require__(343);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(239);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options;
  var entries = _options.entries;
  var current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(170);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(601);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 2154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(601);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(111);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(341);

var _DOMUtils = __webpack_require__(240);

var _HashProtocol = __webpack_require__(2156);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(343);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey;
  var hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(342);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(111);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(161);

var _DOMUtils = __webpack_require__(240);

var _DOMStateStorage = __webpack_require__(513);

var _PathUtils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state;
  var key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing,Colors=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Colors;var StudentExportContainer=function(_Component){_inherits(StudentExportContainer,_Component);function StudentExportContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StudentExportContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StudentExportContainer.__proto__||Object.getPrototypeOf(StudentExportContainer)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:''},_this.handleChange=function(e){_this.setState({value:e.target.value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StudentExportContainer,[{key:'export',value:function _export(){var re=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var email=null;if(re.test(String(this.state.value).toLowerCase())){email=this.state.value;}var options={startDate:this.refs.startDate.getDate(),endDate:this.refs.endDate.getDate(),withInactive:this.refs.withInactive.isToggled(),withProgress:this.refs.withProgress.isToggled(),recipientEmail:email};__WEBPACK_IMPORTED_MODULE_5_actions__["C" /* StudentActions */].export(options);}},{key:'render',value:function render(){var _context;var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ToolbarTitle"],{text:this.context.getIntlMessage('Export')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ToolbarGroup"],{float:'right',key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('Close'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ContentClear"],null),onTouchTap:(_context=this.props.router).goBack.bind(_context)})));var now=new Date();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ScrollableContainer__["a" /* default */],{header:toolbar,style:{backgroundColor:Colors.fullWhite}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["DatePicker"],{ref:'startDate',maxDate:now,floatingLabelText:this.context.getIntlMessage('export.startDate')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["DatePicker"],{ref:'endDate',defaultDate:now,maxDate:now,floatingLabelText:this.context.getIntlMessage('export.endDate')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{onChange:this.handleChange,hintText:'Custom email'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Toggle"],{ref:'withInactive',defaultToggled:false,label:this.context.getIntlMessage('export.user.withInactive')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Toggle"],{ref:'withProgress',defaultToggled:false,label:this.context.getIntlMessage('export.user.withProgress')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{primary:true,fullWidth:true,label:this.context.getIntlMessage('Export'),onTouchTap:this.export.bind(this)})));}}]);return StudentExportContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StudentExportContainer.displayName='StudentExportContainer';StudentExportContainer.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StudentExportContainer);

/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Route_Invitation_Detail__ = __webpack_require__(2159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_Loader__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InvitationDetailContainer=function(_mixin){_inherits(InvitationDetailContainer,_mixin);function InvitationDetailContainer(){_classCallCheck(this,InvitationDetailContainer);return _possibleConstructorReturn(this,(InvitationDetailContainer.__proto__||Object.getPrototypeOf(InvitationDetailContainer)).apply(this,arguments));}_createClass(InvitationDetailContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_4_stores__["j" /* InvitationStore */],function(state){return{invitation:state.invitation};});}},{key:'componentWillMount',value:function componentWillMount(){if(_get(InvitationDetailContainer.prototype.__proto__||Object.getPrototypeOf(InvitationDetailContainer.prototype),'componentWillMount',this)){_get(InvitationDetailContainer.prototype.__proto__||Object.getPrototypeOf(InvitationDetailContainer.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_1_actions__["k" /* InvitationActions */].showInfo(this.props.params.invitationId);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.routeParams.invitationId!==nextProps.routeParams.invitationId){__WEBPACK_IMPORTED_MODULE_1_actions__["k" /* InvitationActions */].showInfo(nextProps.routeParams.invitationId);}}},{key:'render',value:function render(){var invitation=this.state.invitation;if(invitation.loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_Loader__["b" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Route_Invitation_Detail__["a" /* default */],{id:invitation.id,invitation:invitation,onClose:this.props.router.goBack});}}]);return InvitationDetailContainer;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (InvitationDetailContainer);

/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Widgets_SimpleOverview__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Colors=__WEBPACK_IMPORTED_MODULE_9_components_Material_Styles_Colors__["a" /* Colors */];var colorLookup={sent:Colors.green[500].material,bounced:Colors.red[500].material,rejected:Colors.red[500].material,error:Colors.red[500].material,unknown:Colors.grey[500].material};var InvitationDetail=function(_mixin){_inherits(InvitationDetail,_mixin);function InvitationDetail(props,context){_classCallCheck(this,InvitationDetail);var _this=_possibleConstructorReturn(this,(InvitationDetail.__proto__||Object.getPrototypeOf(InvitationDetail)).call(this,props,context));_this.state={selectedCourse:{name:context.getIntlMessage('course.noSelected')},selectedGroup:{name:context.getIntlMessage('group.noSelected')}};return _this;}_createClass(InvitationDetail,[{key:'listenToActions',value:function listenToActions(){var _this2=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_3_actions__["k" /* InvitationActions */].deleteComplete,function(){__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('invitation.removed'));_this2.closeDetail();});this.listenToAction(__WEBPACK_IMPORTED_MODULE_3_actions__["k" /* InvitationActions */].resendComplete,function(){__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('invitation.resent'));_this2.closeDetail();});}},{key:'confirmDelete',value:function confirmDelete(){this.refs.confirmDialog.show();}},{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_8_stores__["j" /* InvitationStore */]);}},{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_actions__["k" /* InvitationActions */].getInvitationEmailStatus(this.props.id);}},{key:'onConfirm',value:function onConfirm(){this.refs.removeDialog.dismiss();__WEBPACK_IMPORTED_MODULE_3_actions__["k" /* InvitationActions */].delete(this.props.id);__WEBPACK_IMPORTED_MODULE_3_actions__["C" /* StudentActions */].filter();}},{key:'selectCourse',value:function selectCourse(course){this.setState({selectedCourse:course});}},{key:'selectGroup',value:function selectGroup(group){this.setState({selectedGroup:group});}},{key:'revokeAccess',value:function revokeAccess(){this.refs.removeDialog.show();}},{key:'resend',value:function resend(){__WEBPACK_IMPORTED_MODULE_3_actions__["k" /* InvitationActions */].resend(this.props.id);}},{key:'closeDetail',value:function closeDetail(){if(this.props.onClose){this.props.onClose();}}},{key:'render',value:function render(){var invitation=this.props.invitation;var confirmActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('OK'),secondary:true,className:'full',onTouchTap:this.onConfirm.bind(this)})];var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["ToolbarTitle"],{text:this.context.getIntlMessage('Invitation')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["ToolbarGroup"],{float:'right',key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["NavigationRefresh"],null),onTouchTap:this.resend.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ActionDelete"],null),onTouchTap:this.revokeAccess.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ContentClear"],null),onTouchTap:this.closeDetail.bind(this)})));var state=void 0;if(this.state.status.loading){state=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["LinearProgress"],{mode:'indeterminate'});}else{state=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:colorLookup[this.state.status.state]}},this.context.getIntlMessage('emailStatus.'+this.state.status.state));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ScrollableContainer__["a" /* default */],{header:toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["List"],{style:{backgroundColor:'#FFFFFF'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["ListItem"],{leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["CommunicationEmail"],null),primaryText:invitation.email})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["List"],{style:{backgroundColor:'#FFFFFF'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["ListItem"],{leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ContentInbox"],null),primaryText:state})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Widgets_SimpleOverview__["a" /* default */],{items:invitation.circles,readable:'name',title:this.context.getIntlMessage('group.Groups'),onSelect:this.selectGroup.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Widgets_SimpleOverview__["a" /* default */],{items:invitation.course,readable:'name',title:this.context.getIntlMessage('course.Courses'),onSelect:this.selectCourse.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Dialog"],{ref:'removeDialog',title:this.context.getIntlMessage('invitation.remove'),actions:confirmActions,dismissOnClickAway:true}));}}]);return InvitationDetail;}(Object(__WEBPACK_IMPORTED_MODULE_4_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_4_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_4_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));InvitationDetail.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (InvitationDetail);

/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores_Group__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores_Auth__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_Group__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Route_Group_Detail__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_ListDetail__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_Message__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentAdd=__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ContentAdd"];var Groups=function(_mixin){_inherits(Groups,_mixin);function Groups(){_classCallCheck(this,Groups);return _possibleConstructorReturn(this,(Groups.__proto__||Object.getPrototypeOf(Groups)).apply(this,arguments));}_createClass(Groups,[{key:'componentWillMount',value:function componentWillMount(){if(_get(Groups.prototype.__proto__||Object.getPrototypeOf(Groups.prototype),'componentWillMount',this)){_get(Groups.prototype.__proto__||Object.getPrototypeOf(Groups.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_3_actions_Group__["a" /* default */].filter();}},{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores_Group__["a" /* default */],'groups');this.listenToStore(__WEBPACK_IMPORTED_MODULE_2_stores_Auth__["a" /* default */],'auth');}},{key:'listenToActions',value:function listenToActions(){var _this2=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_3_actions_Group__["a" /* default */].findByIdComplete,function(group){_this2.setState({selected:group});});this.listenToAction(__WEBPACK_IMPORTED_MODULE_3_actions_Group__["a" /* default */].createComplete,function(group){__WEBPACK_IMPORTED_MODULE_3_actions_Group__["a" /* default */].filter();_this2.setState({selected:group});});this.listenToAction(__WEBPACK_IMPORTED_MODULE_3_actions_Group__["a" /* default */].updateComplete,function(group){__WEBPACK_IMPORTED_MODULE_3_actions_Group__["a" /* default */].filter();});}},{key:'resetFilter',value:function resetFilter(){__WEBPACK_IMPORTED_MODULE_3_actions_Group__["a" /* default */].resetFilter();__WEBPACK_IMPORTED_MODULE_3_actions_Group__["a" /* default */].filter();}},{key:'showCreateDialog',value:function showCreateDialog(){this.refs.createDialog.show();}},{key:'gotoGroup',value:function gotoGroup(group){if(group===null){this.setState({selected:null});}else if(!this.selected||this.selected.id!==group.id){__WEBPACK_IMPORTED_MODULE_3_actions_Group__["a" /* default */].findById(group.id);}}},{key:'onConfirmCreate',value:function onConfirmCreate(){var grName=this.refs.groupName.getValue();if(grName.trim().length!=0){__WEBPACK_IMPORTED_MODULE_3_actions_Group__["a" /* default */].create(this.refs.groupName.getValue());this.refs.createDialog.dismiss();}else{__WEBPACK_IMPORTED_MODULE_11_services_Message__["a" /* default */].info('Group name cannot be a space');}}},{key:'render',value:function render(){var groups=this.state.groups.list||[],detail;if(this.state.selected){detail=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Route_Group_Detail__["a" /* default */],{key:this.state.selected.id,user:this.state.auth,group:this.state.selected,onClose:this.gotoGroup.bind(this,null)});}var standardActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('Create'),onTouchTap:this.onConfirmCreate.bind(this)})];var filterFunc=function filterFunc(item,searchText,labelProperty){if(searchText&&searchText!==''){return item[labelProperty].search(searchText)>-1;}else{return true;}};var addGroupButton=null;if(this.state.auth&&this.state.auth.role.editor){addGroupButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui__["FloatingActionButton"],{onTouchTap:this.showCreateDialog.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentAdd,null)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_RulerBar__["a" /* default */],{title:'Groups'}),className:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_ListDetail__["a" /* default */],{items:groups,filter:filterFunc,onTouchTapItem:this.gotoGroup.bind(this),floatingActionButton:addGroupButton},detail),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui__["Dialog"],{ref:'createDialog',title:this.context.getIntlMessage('group.create'),actions:standardActions,dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui__["TextField"],{ref:'groupName',fullWidth:true,hintText:this.context.getIntlMessage('group.name'),onChange:this.onChange,floatingLabelText:this.context.getIntlMessage('group.name')})));}}]);return Groups;}(Object(__WEBPACK_IMPORTED_MODULE_8_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_8_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_8_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));Groups.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Groups);

/***/ }),
/* 2161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores_Course__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_ListDetail__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Route_Course_Detail__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Tags__ = __webpack_require__(98);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_9_material_ui__["Styles"].Spacing;var Courses=function(_mixin){_inherits(Courses,_mixin);function Courses(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Courses);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Courses.__proto__||Object.getPrototypeOf(Courses)).call.apply(_ref,[this].concat(args))),_this),_this.state={filter:{}},_this.deleteTag=function(tagName){var filter=Object.assign({},_this.statefilter);delete filter[tagName];_this.setState({filter:filter});},_this.addTag=function(tagName){_this.setState({filter:Object.assign({},_this.state.filter,_defineProperty({},tagName,true))});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Courses,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores_Course__["a" /* default */]);}},{key:'componentWillMount',value:function componentWillMount(){if(_get(Courses.prototype.__proto__||Object.getPrototypeOf(Courses.prototype),'componentWillMount',this)){_get(Courses.prototype.__proto__||Object.getPrototypeOf(Courses.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_2_actions_Course__["a" /* default */].filter();}},{key:'resetFilter',value:function resetFilter(){__WEBPACK_IMPORTED_MODULE_2_actions_Course__["a" /* default */].filter(true);}},{key:'selectCourse',value:function selectCourse(course){if(course===null){this.setState({selected:null});}else{this.props.router.push('/course/'+course.id);}}},{key:'createListItem',value:function createListItem(item,leftAvatar,insetChildren){var style={};if(this.state.selected&&item.id===this.state.selected.id){style.backgroundColor=__WEBPACK_IMPORTED_MODULE_8_components_Material_Styles_Colors__["a" /* Colors */].grey[300].material;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui__["ListItem"],{style:style,leftAvatar:leftAvatar,insetChildren:insetChildren,key:'i'+item.id,primaryText:item.name,secondaryText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Tags__["a" /* TagList */],{dense:true,tags:item.tagsMap}),onTouchTap:this.selectCourse.bind(this,item)});}},{key:'render',value:function render(){var _this2=this;var courses=this.state.list||[];var filterFunc=function filterFunc(item,searchText,labelProperty){var hasTags=true;Object.keys(_this2.state.filter).forEach(function(tagName){var tagsMap=item.tagsMap||{};hasTags=hasTags&&tagsMap[tagName];});if(!hasTags){return false;}if(searchText&&searchText!==''){return item[labelProperty].search(searchText)>-1;}else{return true;}};var tagSelector=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Tags__["b" /* TagSelector */],{onAddTag:this.addTag,onRemoveTag:this.deleteTag,tags:this.state.filter,fullWidth:true,padded:true});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_RulerBar__["a" /* default */],{title:this.context.getIntlMessage('Courses')})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_ListDetail__["a" /* default */],{items:courses,filter:filterFunc,listItemGenerator:this.createListItem.bind(this),listHeader:tagSelector},this.props.children));}}]);return Courses;}(Object(__WEBPACK_IMPORTED_MODULE_5_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_5_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_5_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));Courses.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (Courses);

/***/ }),
/* 2162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_CourseDetail__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalizr__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_normalizr__);
// import { normalize, Schema, arrayOf } from 'normalizr';
var student=new __WEBPACK_IMPORTED_MODULE_3_normalizr__["Schema"]('student');var CourseDetailStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions_CourseDetail__["a" /* default */]],data:{courseId:null,students:{pageStart:0,pageLength:25,loading:true},token:null,isActive:null,list:{students:[]},entities:{student:{}},totalStudents:0},getInitialState:function getInitialState(){return this.data;},read:function read(courseId){this.data=Object.assign({},this.data,{courseId:courseId,token:null,isActive:null});this.getStudentsAtPage(0);},getStudentsAtPage:function getStudentsAtPage(pageStart){var _this=this;var pageLength=this.data.students.pageLength;var options={courseId:this.data.courseId,sortBy:'name',sortMode:'asc',isActive:this.data.isActive,token:this.data.token};this.data.students.pageStart=pageStart;if(pageStart+pageLength<this.data.list.students.length){this.trigger(this.data);return;}this.data.students.loading=true;this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('user','findByCourseId',options,pageStart,pageLength).then(function(response){var newData=Object(__WEBPACK_IMPORTED_MODULE_3_normalizr__["normalize"])(response,Object(__WEBPACK_IMPORTED_MODULE_3_normalizr__["arrayOf"])(student));var entities=_this.data.entities;var students=pageStart===0?newData.result:_this.data.list.students.concat(newData.result);_this.data=Object.assign({},_this.data,{students:Object.assign({},_this.data.students,{loading:false}),entities:Object.assign({},entities,{student:Object.assign({},_this.data.entities.student,newData.entities.student)}),list:Object.assign({},_this.data.list,{students:students})});_this.trigger(_this.data);});},nextStudents:function nextStudents(){var newPageStart=this.data.students.pageStart+this.data.students.pageLength;this.getStudentsAtPage(newPageStart);},prevStudents:function prevStudents(){if(this.data.students.pageStart>=this.data.students.pageLength){var newPageStart=this.data.students.pageStart-this.data.students.pageLength;this.getStudentsAtPage(newPageStart);}},filterStudents:function filterStudents(token){if(this.data.token!==token){this.data.token=token;this.getStudentsAtPage(0);}},filterStudentsByStatus:function filterStudentsByStatus(active){if(this.data.isActive!==active){this.data.isActive=active;this.getStudentsAtPage(0);}},countStudents:function countStudents(courseId){var _this2=this;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('user','countByCourseId',{courseId:courseId},function(response){_this2.data.totalStudents=response.data;_this2.trigger(_this2.data);});}});/* harmony default export */ __webpack_exports__["a"] = (CourseDetailStore);

/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_InvitationDetail__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalizr__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_normalizr__);
// import { normalize, Schema, arrayOf } from 'normalizr';
var invitation=new __WEBPACK_IMPORTED_MODULE_3_normalizr__["Schema"]('invitation');var InvitationDetailStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions_InvitationDetail__["a" /* default */]],data:{courseId:null,invitations:{pageStart:0,pageLength:25,loading:true},list:{invitations:[]},entities:{invitation:{}},totalInvitations:0},getInitialState:function getInitialState(){return this.data;},read:function read(courseId){this.data=Object.assign({},this.data,{courseId:courseId});var _data$invitations=this.data.invitations,pageStart=_data$invitations.pageStart,pageLength=_data$invitations.pageLength;this.getInvitationsAtPage(0);},getInvitationsAtPage:function getInvitationsAtPage(pageStart){var _this=this;var pageLength=this.data.invitations.pageLength;if(pageStart+pageLength<this.data.list.invitations.length){this.data=Object.assign({},this.data,{invitations:Object.assign({},this.data.invitations,{pageStart:pageStart})});this.trigger(this.data);return;}var courseId=this.data.courseId;this.data=Object.assign({},this.data,{invitations:Object.assign({},this.data.invitations,{loading:true})});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('invitation','findByCourseId',{courseId:courseId,unusedOnly:1,sortBy:'name',sortMode:'asc'},pageStart,pageLength).then(function(response){var data=Object(__WEBPACK_IMPORTED_MODULE_3_normalizr__["normalize"])(response,Object(__WEBPACK_IMPORTED_MODULE_3_normalizr__["arrayOf"])(invitation));var entities=_this.data.entities;var invitations=pageStart===0?data.result:_this.data.list.invitations.concat(data.result);_this.data=Object.assign({},_this.data,{invitations:Object.assign({},_this.data.invitations,{pageStart:pageStart,loading:false}),entities:Object.assign({},entities,{invitation:Object.assign({},entities.invitation,data.entities.invitation)}),list:Object.assign({},_this.data.list,{invitations:invitations})});_this.trigger(_this.data);});},nextInvitations:function nextInvitations(){this.getInvitationsAtPage(this.data.invitations.pageStart+this.data.invitations.pageLength);},prevInvitations:function prevInvitations(){if(this.data.invitations.pageStart>=this.data.invitations.pageLength){this.getInvitationsAtPage(this.data.invitations.pageStart-this.data.invitations.pageLength);}},countInvitations:function countInvitations(courseId){var _this2=this;return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].call('invitation','countByCourseId',{courseId:courseId,unusedOnly:1},function(response){_this2.data.totalInvitations=response.data;_this2.trigger(_this2.data);});}});/* harmony default export */ __webpack_exports__["a"] = (InvitationDetailStore);

/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util_refluxConnector__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_MediaLibrary_UploadDialog__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions_Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_oxygen_debounce__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['Remove'],['Remove']),_templateObject2=_taggedTemplateLiteral(['Diploma'],['Diploma']),_templateObject3=_taggedTemplateLiteral(['Percentage finished to be eligible for a diploma'],['Percentage finished to be eligible for a diploma']),_templateObject4=_taggedTemplateLiteral(['Add diploma template'],['Add diploma template']),_templateObject5=_taggedTemplateLiteral(['Retrieve a test diploma'],['Retrieve a test diploma']),_templateObject6=_taggedTemplateLiteral(['Upload'],['Upload']),_templateObject7=_taggedTemplateLiteral(['Drop a pdf here'],['Drop a pdf here']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={list:{paddingTop:32,backgroundColor:'#FFFFFF'},listHeader:{fontSize:24,borderStyle:'none none solid none',borderWidth:'1px',borderColor:'rgba(0, 0, 0, 0.12)'}};var css={header:'_ep',content:'_eq',buttonWrapper:'_er',panel:'_es'};var CourseDiplomaEditor=function(_Component){_inherits(CourseDiplomaEditor,_Component);function CourseDiplomaEditor(props){_classCallCheck(this,CourseDiplomaEditor);var _this=_possibleConstructorReturn(this,(CourseDiplomaEditor.__proto__||Object.getPrototypeOf(CourseDiplomaEditor)).call(this,props));_this.openFileSelector=function(){return _this.setState({fileSelectorOpen:true});};_this.closeFileSelector=function(){return _this.setState({fileSelectorOpen:false});};_this.progress=function(event){return _this.setState({progress:event.pervent});};_this.openUpload=function(){return _this.dropZone.open();};_this.retrieveTest=function(){var _this$props=_this.props,course=_this$props.course,retrieveTest=_this$props.retrieveTest;retrieveTest(course.id);};_this.add=function(url,id){var update=_this.props.update;update({fileId:id,passPercentage:80});_this.closeFileSelector();_this.save();};_this.remove=function(){var _this$props2=_this.props,remove=_this$props2.remove,course=_this$props2.course;remove(course.id);};_this.handlePassPercentageChange=function(event){var passPercentage=event.target.value;var update=_this.props.update;_this.setState({passPercentage:passPercentage});if(!isNaN(parseInt(passPercentage))){update({passPercentage:parseInt(passPercentage)});_this.save();}};_this.save=__WEBPACK_IMPORTED_MODULE_9_oxygen_debounce___default()(function(){var save=_this.props.save;save();},300);var settings=_this.props.course.settings||{};var diploma=settings.diploma||{};_this.state={fileSelectorOpen:false,progress:0,passPercentage:diploma.passPercentage||80};return _this;}_createClass(CourseDiplomaEditor,[{key:'render',value:function render(){var fileSelectorOpen=this.state.fileSelectorOpen;var course=this.props.course;var settings=course.settings||{};var hasDiploma=settings.diploma&&settings.diploma.fileId;var removeButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["IconButton"],{onTouchTap:this.remove,tooltip:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject),tooltipPosition:'top-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__["ContentClear"],null));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["List"],{subheader:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject2),style:styles.list,subheaderStyle:styles.listHeader},hasDiploma&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["ListItem"],{primaryText:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject2),leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__["FileFolder"],null),rightIconButton:removeButton}),hasDiploma&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TextField"],{fullWidth:true,floatingLabelText:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject3),value:this.state.passPercentage,onChange:this.handlePassPercentageChange})),!hasDiploma&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{onTouchTap:this.openFileSelector,fullWidth:true},Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject4))),hasDiploma&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{onTouchTap:this.retrieveTest,fullWidth:true},Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject5))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_MediaLibrary_UploadDialog__["a" /* default */],{onRequestClose:this.closeFileSelector,onSuccess:this.add,title:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject6),description:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject7),type:'pdf',open:fileSelectorOpen}));}}]);return CourseDiplomaEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CourseDiplomaEditor.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,course:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,save:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,update:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,remove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,retrieveTest:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_Util_refluxConnector__["a" /* connect */])([],{update:__WEBPACK_IMPORTED_MODULE_8_actions_Course__["a" /* default */].updateDiploma,remove:__WEBPACK_IMPORTED_MODULE_8_actions_Course__["a" /* default */].removeDiploma,save:__WEBPACK_IMPORTED_MODULE_8_actions_Course__["a" /* default */].saveSettings,retrieveTest:__WEBPACK_IMPORTED_MODULE_8_actions_Course__["a" /* default */].retrieveDiploma})(CourseDiplomaEditor));//{courseId: }
//php ./worker run IssueCertificate '{"file_id":140548,"user_id":11329$,"course_id":1565}'

/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Portal__ = __webpack_require__(113);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Units=__WEBPACK_IMPORTED_MODULE_2_Css__["default"].Units,Shadow=__WEBPACK_IMPORTED_MODULE_2_Css__["default"].Shadow,Colors=__WEBPACK_IMPORTED_MODULE_2_Css__["default"].Colors;var css={root:'_hc',container:'_hd',padded:'_he',overlay:'_hf',dialog:'_hg'};var ESC=27;var Dialog=function(_Component){_inherits(Dialog,_Component);function Dialog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Dialog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Dialog.__proto__||Object.getPrototypeOf(Dialog)).call.apply(_ref,[this].concat(args))),_this),_this.reset=function(props){var open=props.open;if(!open){__WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations___default.a.setValueForStyles(document.body,{overflow:_this._overflow});}else{__WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations___default.a.setValueForStyles(document.body,{overflow:'hidden'});}},_this.handleKey=function(event){var keyCode=event.keyCode;if(keyCode===ESC){_this.requestClose();}},_this.requestClose=function(){var onRequestClose=_this.props.onRequestClose;onRequestClose&&onRequestClose();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dialog,[{key:'componentWillMount',value:function componentWillMount(){this._overflow=document.body.style.overflow;document.addEventListener('keyup',this.handleKey);this.reset(this.props);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.reset(nextProps);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keyup',this.handleKey);this.reset({open:false});}},{key:'render',value:function render(){var _props=this.props,padded=_props.padded,children=_props.children,open=_props.open;if(!open){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Portal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.overlay,onTouchTap:this.requestClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.dialog},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.container,padded&&css.padded)},children))));}}]);return Dialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Dialog.propTypes={onRequestClose:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,open:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onDismiss:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,padded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (Dialog);

/***/ }),
/* 2166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_hh',content:'_hi',padded:'_hj',hasHeader:'_hk',hasFooter:'_hl'};var DialogContent=function(_Component){_inherits(DialogContent,_Component);function DialogContent(){_classCallCheck(this,DialogContent);return _possibleConstructorReturn(this,(DialogContent.__proto__||Object.getPrototypeOf(DialogContent)).apply(this,arguments));}_createClass(DialogContent,[{key:'render',value:function render(){var _classNames;var _props=this.props,className=_props.className,padded=_props.padded,header=_props.header,footer=_props.footer,children=_props.children,other=_objectWithoutProperties(_props,['className','padded','header','footer','children']);var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.content,className,(_classNames={},_defineProperty(_classNames,css.hasHeader,header),_defineProperty(_classNames,css.hasFooter,footer),_defineProperty(_classNames,css.padded,padded),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:css.root},other),header,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},children),footer);}}]);return DialogContent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DialogContent.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,padded:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,header:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,footer:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (DialogContent);

/***/ }),
/* 2167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_MediaLibrary_MediaLibraryProvider__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_MediaLibrary_FileSelector__ = __webpack_require__(2170);
var FileSelectorContainer=function FileSelectorContainer(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers_MediaLibrary_MediaLibraryProvider__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_MediaLibrary_FileSelector__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (FileSelectorContainer);

/***/ }),
/* 2168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_selectors_mediaLibrary__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MediaLibraryProvider=function(_mixin){_inherits(MediaLibraryProvider,_mixin);function MediaLibraryProvider(){_classCallCheck(this,MediaLibraryProvider);return _possibleConstructorReturn(this,(MediaLibraryProvider.__proto__||Object.getPrototypeOf(MediaLibraryProvider)).apply(this,arguments));}_createClass(MediaLibraryProvider,[{key:'listenToStores',value:function listenToStores(){var _this2=this;this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_1_stores__["m" /* MediaLibraryOverviewStore */],function(state){return Object.assign({items:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_mediaLibrary__["b" /* getVisibleItems */])(state),totalItems:Object(__WEBPACK_IMPORTED_MODULE_3_selectors_mediaLibrary__["a" /* getTotal */])(state),mode:state.mode,loading:state.loadng,breadCrumbs:state.breadCrumbs},_this2.mapActions({read:__WEBPACK_IMPORTED_MODULE_2_actions__["p" /* MediaLibraryOverviewActions */].read,changeDir:__WEBPACK_IMPORTED_MODULE_2_actions__["p" /* MediaLibraryOverviewActions */].changeDir,gridMode:__WEBPACK_IMPORTED_MODULE_2_actions__["p" /* MediaLibraryOverviewActions */].gridMode,listMode:__WEBPACK_IMPORTED_MODULE_2_actions__["p" /* MediaLibraryOverviewActions */].listMode,changeSearchFilter:__WEBPACK_IMPORTED_MODULE_2_actions__["p" /* MediaLibraryOverviewActions */].changeSearchFilter}));});}},{key:'render',value:function render(){var _props=this.props,children=_props.children,other=_objectWithoutProperties(_props,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children),Object.assign({},children.props,other,this.state));}}]);return MediaLibraryProvider;}(Object(__WEBPACK_IMPORTED_MODULE_4_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_4_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));MediaLibraryProvider.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (MediaLibraryProvider);

/***/ }),
/* 2169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getVisibleItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTotal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getItems=function getItems(state){return state.items;};var getEntities=function getEntities(state){return state.entities;};var getCurrentDir=function getCurrentDir(state){return state.directoryId;};var getFilter=function getFilter(state){return state.filter;};var makeGetVisibleItems=function makeGetVisibleItems(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getItems,getEntities,getFilter,function(state){return state.sort;},function(items,entities,filter,sort){var files=items.map(function(id){return entities[id];});if(filter.type){files=files.filter(function(file){return file.type==='dir'||file.type===filter.type;});}if(filter.searchText){var regexp=new RegExp(filter.searchText,'i');files=files.filter(function(file){return file.name.search(regexp)>-1;});}files.sort(function(left,right){if(left.type==='dir'&&right.type!=='dir'){return-1;}else if(left.type!=='dir'&&right.type==='dir'){return 1;}var prop=sort.prop,direction=sort.direction;if(typeof left[prop]==='string'){var _leftProp=left[prop].toUpperCase();var _rightProp=right[prop].toUpperCase();if(_leftProp<_rightProp)return direction==='asc'?-1:1;if(_leftProp>_rightProp)return direction==='asc'?1:-1;return 0;}var leftProp=left[prop];var rightProp=right[prop];if(leftProp<rightProp)return direction==='asc'?-1:1;if(leftProp>rightProp)return direction==='asc'?1:-1;return 0;});return files;});};var getVisibleItems=makeGetVisibleItems();var makeGetTotal=function makeGetTotal(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getItems,function(items){return items.length;});};var getTotal=makeGetTotal();

/***/ }),
/* 2170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FileSelectorGrid__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FileSelectorList__ = __webpack_require__(2172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Tasks_ScrollableContainer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileSelectorToolbar__ = __webpack_require__(2173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={statusBar:'_gN'};var FileSelector=function(_Component){_inherits(FileSelector,_Component);function FileSelector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FileSelector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FileSelector.__proto__||Object.getPrototypeOf(FileSelector)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelect=function(item){var onSelect=_this.props.onSelect;onSelect&&onSelect(item);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FileSelector,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,read=_props.read,type=_props.type;read(type);}},{key:'render',value:function render(){var _props2=this.props,items=_props2.items,mode=_props2.mode,totalItems=_props2.totalItems,changeDir=_props2.changeDir,other=_objectWithoutProperties(_props2,['items','mode','totalItems','changeDir']);var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FileSelectorToolbar__["a" /* default */],Object.assign({changeDir:changeDir,mode:mode},other));var info=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.statusBar},items.length,' / ',totalItems);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Tasks_ScrollableContainer__["a" /* default */],{header:toolbar,footer:info},mode==='grid'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__FileSelectorGrid__["a" /* default */],{changeDir:changeDir,onSelect:this.handleSelect,items:items}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FileSelectorList__["a" /* default */],{changeDir:changeDir,onSelect:this.handleSelect,items:items}));}}]);return FileSelector;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FileSelector.propTypes={read:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,changeDir:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onSelect:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,totalItems:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,mode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};/* harmony default export */ __webpack_exports__["a"] = (FileSelector);

/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Thumb__ = __webpack_require__(607);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={container:'_hy',thumb:'_hz'};var FileSelectorGrid=function(_Component){_inherits(FileSelectorGrid,_Component);function FileSelectorGrid(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FileSelectorGrid);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FileSelectorGrid.__proto__||Object.getPrototypeOf(FileSelectorGrid)).call.apply(_ref,[this].concat(args))),_this),_this.handleTouchTap=function(item){var type=item.type,id=item.id;if(type==='dir'){var changeDir=_this.props.changeDir;changeDir(id);}else{var onSelect=_this.props.onSelect;onSelect&&onSelect(item);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FileSelectorGrid,[{key:'render',value:function render(){var _this2=this;var items=this.props.items;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},items.map(function(item){var id=item.id,type=item.type,url=item.url;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.thumb,key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Thumb__["a" /* default */],{type:type,url:url,size:2,onTouchTap:_this2.handleTouchTap,payload:item}));}));}}]);return FileSelectorGrid;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FileSelectorGrid.propTypes={items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,changeDir:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onSelect:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (FileSelectorGrid);

/***/ }),
/* 2172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_List__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Thumb__ = __webpack_require__(607);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={date:'_hv',thumb:'_hw',body:'_hx'};var FileSelectorList=function(_Component){_inherits(FileSelectorList,_Component);function FileSelectorList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FileSelectorList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FileSelectorList.__proto__||Object.getPrototypeOf(FileSelectorList)).call.apply(_ref,[this].concat(args))),_this),_this.handleTouchTap=function(item){var type=item.type,id=item.id;if(type==='dir'){var changeDir=_this.props.changeDir;changeDir(id);}else{var onSelect=_this.props.onSelect;onSelect&&onSelect(item);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FileSelectorList,[{key:'render',value:function render(){var _this2=this;var items=this.props.items;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_List__["a" /* List */],null,items.map(function(item){var id=item.id,created=item.created,type=item.type,url=item.url;var createdTime=created&&created.split(' ').join('T')+'Z'||null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_List__["b" /* ListItem */],{key:id,payload:item,onTouchTap:_this2.handleTouchTap},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.thumb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Thumb__["a" /* default */],{type:type,url:url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.body},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.date},createdTime&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["FormattedDate"],{value:new Date(createdTime)})||'')));}));}}]);return FileSelectorList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FileSelectorList.propTypes={items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,changeDir:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onSelect:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (FileSelectorList);

/***/ }),
/* 2173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Toolbar__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchBar__ = __webpack_require__(2174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_hA',breadCrumb:'_hB'};var FileSelectorToolbar=function(_Component){_inherits(FileSelectorToolbar,_Component);function FileSelectorToolbar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FileSelectorToolbar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FileSelectorToolbar.__proto__||Object.getPrototypeOf(FileSelectorToolbar)).call.apply(_ref,[this].concat(args))),_this),_this.changeSearchFilter=function(searchText){var changeSearchFilter=_this.props.changeSearchFilter;changeSearchFilter(searchText);},_this.changeDir=function(directoryId){var changeDir=_this.props.changeDir;changeDir(directoryId);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FileSelectorToolbar,[{key:'render',value:function render(){var _this2=this;var _props=this.props,mode=_props.mode,breadCrumbs=_props.breadCrumbs,gridMode=_props.gridMode,listMode=_props.listMode,closeButton=_props.closeButton;var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toolbar__["b" /* Toolbar */],{dense:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toolbar__["d" /* ToolbarGroup */],{transparent:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toolbar__["d" /* ToolbarGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toolbar__["c" /* ToolbarButton */],{tooltip:getIntlMessage('mediaLibrary.thumbView'),onTouchTap:gridMode,disabled:mode==='grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["ActionViewModule"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toolbar__["c" /* ToolbarButton */],{tooltip:getIntlMessage('mediaLibrary.listView'),onTouchTap:listMode,disabled:mode==='list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["ActionViewList"],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toolbar__["d" /* ToolbarGroup */],null,breadCrumbs.map(function(breadCrumb){var id=breadCrumb.id,name=breadCrumb.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toolbar__["c" /* ToolbarButton */],{onTouchTap:_this2.changeDir.bind(_this2,id),key:id,className:css.breadCrumb},name,' /');}))),closeButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toolbar__["d" /* ToolbarGroup */],{right:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toolbar__["c" /* ToolbarButton */],{tooltip:getIntlMessage('mediaLibrary.close'),onTouchTap:this.close},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["ContentClear"],null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toolbar__["b" /* Toolbar */],{dense:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SearchBar__["a" /* default */],{onChange:this.changeSearchFilter,fullWidth:true})));}}]);return FileSelectorToolbar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FileSelectorToolbar.propTypes={mode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,gridMode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,listMode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,changeDir:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,changeSearchFilter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,closeButton:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,breadCrumbs:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};FileSelectorToolbar.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};FileSelectorToolbar.defaultProps={breadCrumbs:[],closeButton:false};/* harmony default export */ __webpack_exports__["a"] = (FileSelectorToolbar);

/***/ }),
/* 2174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Toolbar__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_oxygen_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={wrapper:'_i6',inputContainer:'_i7',input:'_i8',button:'_i9'};var SearchBar=function(_Component){_inherits(SearchBar,_Component);function SearchBar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SearchBar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchBar.__proto__||Object.getPrototypeOf(SearchBar)).call.apply(_ref,[this].concat(args))),_this),_this.changeSearchText=__WEBPACK_IMPORTED_MODULE_3_oxygen_debounce___default()(function(value){var onChange=_this.props.onChange;onChange&&onChange(value);},250),_this.searchTextChange=function(event){var value=event.target.value;_this.changeSearchText(value.trim()||'');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchBar,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.changeSearchText.clear();}},{key:'render',value:function render(){var _props=this.props,placeholder=_props.placeholder,onChange=_props.onChange,other=_objectWithoutProperties(_props,['placeholder','onChange']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Toolbar__["d" /* ToolbarGroup */],other,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.inputContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:css.input,type:'text',placeholder:placeholder,onChange:this.searchTextChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Toolbar__["c" /* ToolbarButton */],{className:css.button},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["ActionSearch"],{color:__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].lightBlack,hoverColor:__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].lightWhite}))));}}]);return SearchBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SearchBar.propTypes={placeholder:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};SearchBar.defaultProps={placeholder:'Search'};/* harmony default export */ __webpack_exports__["a"] = (SearchBar);

/***/ }),
/* 2175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_attr_accept__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_attr_accept__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_fN',heading:'_fO',alternative:'_fP',description:'_fQ',wrapper:'_fR',input:'_fS',progressBar:'_fT',progress:'_fU'};var FileUploader=function(_Component){_inherits(FileUploader,_Component);function FileUploader(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FileUploader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FileUploader.__proto__||Object.getPrototypeOf(FileUploader)).call.apply(_ref,[this].concat(args))),_this),_this.state={isDragActive:false,remaining:0,progress:undefined},_this.onDragLeave=function(event){event.preventDefault();// Only deactivate once the dropzone and all children was left.
if(--_this.enterCounter>0){return;}var onDragLeave=_this.props.onDragLeave;_this.setState({isDragActive:false,isDragReject:false});onDragLeave&&onDragLeave();},_this.onDragOver=function(event){event.preventDefault();event.stopPropagation();return false;},_this.onDragEnter=function(event){var onDragEnter=_this.props.onDragEnter;event.preventDefault();var dataTransfer=event.dataTransfer;dataTransfer.dropEffect='copy';++_this.enterCounter;var dataTransferItems=dataTransfer&&dataTransfer.items?dataTransfer.items:[];var allFilesAccepted=_this.allFilesAccepted(Array.prototype.slice.call(dataTransferItems));_this.setState({isDragActive:allFilesAccepted,isDragReject:!allFilesAccepted});onDragEnter&&onDragEnter();},_this.onChange=function(event){var files=event.target.files;_this.processFiles(files);},_this.onClick=function(event){var supportClick=_this.props.supportClick;supportClick&&_this.open();},_this.onDrop=function(event){var target=event.target,dataTransfer=event.dataTransfer;var multiple=_this.props.multiple;event.preventDefault();_this.setState({isDragActive:false});var files=void 0;if(dataTransfer){files=dataTransfer.files;}else if(target){files=event.target.files;}var maxFiles=multiple?files.length:1;for(var i=0;i<maxFiles;i++){files[i].preview=URL.createObjectURL(files[i]);}files=Array.prototype.slice.call(files,0,maxFiles);_this.processFiles(files);},_this.open=function(){_this._input.value=null;_this._input.click();},_this.handleTouchTap=function(event){event.preventDefault();event.stopPropagation();_this.open();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FileUploader,[{key:'componentDidMount',value:function componentDidMount(){this.enterCounter=0;}},{key:'handleFile',value:function handleFile(files){var _this2=this;if(files.length<1){return;}var current=files.pop();var _props=this.props,onProgress=_props.onProgress,onSuccess=_props.onSuccess;if(current){var fileType=current.type;var encoded=fileType.indexOf('audio')===0||fileType.indexOf('video')===0;__WEBPACK_IMPORTED_MODULE_3_services_SteelCompass__["a" /* default */].upload([current],{encoded:encoded,progress:function progress(event){onProgress&&event&&onProgress(Object.assign({},event,{remaining:files.length}));_this2.setState({progress:event.percent,remaining:files.length});},error:function error(){if(files.length>0){_this2.handleFile(files);}},success:function success(response){if(files.length>0){_this2.handleFile(files);_this2.setState({progress:0,remaining:files.length},function(){response&&response.data&&onSuccess&&onSuccess(response.data);});}else{_this2.setState({progress:undefined,remaining:files.length},function(){response&&response.data&&onSuccess&&onSuccess(response.data);});}}});}}},{key:'processFiles',value:function processFiles(files){var fileList=Object.keys(files).map(function(key){return files[key];});var willBeUploaded=fileList.filter(function(file){return file.size<__WEBPACK_IMPORTED_MODULE_2_Constants__["maxFileSize"];});var willBeDropped=fileList.filter(function(file){return file.size>=__WEBPACK_IMPORTED_MODULE_2_Constants__["maxFileSize"];});if(willBeDropped.length>0){if(willBeDropped.length>1){__WEBPACK_IMPORTED_MODULE_4_services_Message__["a" /* default */].info(willBeDropped.length+' files are too big.');}else{__WEBPACK_IMPORTED_MODULE_4_services_Message__["a" /* default */].info(willBeDropped.length+' file is too big.');}}if(willBeUploaded.length>0){this.handleFile(willBeUploaded);}}},{key:'allFilesAccepted',value:function allFilesAccepted(files){var _this3=this;return files.every(function(file){return __WEBPACK_IMPORTED_MODULE_1_attr_accept___default()(file,_this3.props.accept);});}},{key:'render',value:function render(){var _this4=this;var _props2=this.props,className=_props2.className,children=_props2.children,accept=_props2.accept,style=_props2.style,description=_props2.description,other=_objectWithoutProperties(_props2,['className','children','accept','style','description']);var getIntlMessage=this.context.getIntlMessage;var _state=this.state,isDragActive=_state.isDragActive,remaining=_state.remaining,progress=_state.progress;var classes=__WEBPACK_IMPORTED_MODULE_7_classnames___default()(className,css.wrapper);var styles=Object.assign({backgroundColor:isDragActive?__WEBPACK_IMPORTED_MODULE_6_Css__["Colors"].material.yellow[50].hex:null},style);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:classes,style:styles,onTouchTap:this.handleTouchTap,onDragLeave:this.onDragLeave,onDragOver:this.onDragOver,onDragEnter:this.onDragEnter,onDrop:this.onDrop},other),typeof progress==='undefined'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.description},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.heading},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.alternative},getIntlMessage('module.orIfYouPrefer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{secondary:true,label:getIntlMessage('module.selectAFileFromYourComputer')})),typeof progress!=='undefined'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.alternative},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.progressBar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.progress,style:{width:progress+'%'}},Math.round(progress)+'%')),remaining>0&&remaining+' '+getIntlMessage('mediaLibrary.filesRemaining'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:css.input,type:'file',multiple:this.props.multiple,ref:function ref(_input){return _this4._input=_input;},onChange:this.onChange.bind(this),accept:accept}));}}]);return FileUploader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FileUploader.propTypes={className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,onProgress:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onSuccess:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,style:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,supportClick:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,accept:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,multiple:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onDragLeave:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,description:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,onDragEnter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};FileUploader.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};FileUploader.defaultProps={supportClick:true,multiple:true};/* harmony default export */ __webpack_exports__["a"] = (FileUploader);

/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util_refluxConnector__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_Course__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_oxygen_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_dripContent_selector__ = __webpack_require__(2177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_PeriodSelector__ = __webpack_require__(2178);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["Drip content"],["Drip content"]),_templateObject2=_taggedTemplateLiteral(["Enable gated access"],["Enable gated access"]),_templateObject3=_taggedTemplateLiteral(["Users will only be able to open a page if they have already completed the previous page. This ensures that your users go through the course in a natural manner."],["Users will only be able to open a page if they have already completed the previous page. This ensures that your users go through the course in a natural manner."]),_templateObject4=_taggedTemplateLiteral(["Enable delayed access"],["Enable delayed access"]),_templateObject5=_taggedTemplateLiteral(["Please decide per section when they should become available after the user purchases or gains access to the course."],["Please decide per section when they should become available after the user purchases or gains access to the course."]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={list:{paddingTop:32,backgroundColor:"#FFFFFF"},listHeader:{fontSize:24,borderStyle:"none none solid none",borderWidth:"1px",borderColor:"rgba(0, 0, 0, 0.12)"}};var css={header:"_ek",content:"_el",buttonWrapper:"_em",panel:"_en",info:"_eo"};var CourseDripContentEditor=function(_Component){_inherits(CourseDripContentEditor,_Component);function CourseDripContentEditor(props){_classCallCheck(this,CourseDripContentEditor);var _this=_possibleConstructorReturn(this,(CourseDripContentEditor.__proto__||Object.getPrototypeOf(CourseDripContentEditor)).call(this,props));_this.save=__WEBPACK_IMPORTED_MODULE_8_oxygen_debounce___default()(function(){var save=_this.props.save;save();},300);_this.toggleAccess=function(data){var update=_this.props.update;_this.setState(data);update(data);_this.save();};_this.handleDelayedAccessChange=function(sectionId,accessDelay){var updateSection=_this.props.updateSection;updateSection({id:sectionId,accessDelay:accessDelay});};var _this$props=_this.props,_this$props$course=_this$props.course,course=_this$props$course===undefined?{}:_this$props$course,delayedAccessSettings=_this$props.delayedAccessSettings;var toc=props.course.toc;var settings=course.settings||{};var dripContent=settings.dripContent||{};var gatedAccess=dripContent.gatedAccess,delayedAccess=dripContent.delayedAccess;var synchronizedDelayedAccessSettings=[];var map=new Map();var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=toc.concat(delayedAccessSettings)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var item=_step.value;if(!map.has(item.id)){map.set(item.id,true);synchronizedDelayedAccessSettings.push({id:item.id,name:item.name,accessDelay:item.accessDelay||null});}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}_this.state={gatedAccess:gatedAccess||null,delayedAccess:delayedAccess||null,delayedAccessSettings:synchronizedDelayedAccessSettings};return _this;}_createClass(CourseDripContentEditor,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["List"],{subheader:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject),style:styles.list,subheaderStyle:styles.listHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:css.buttonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Toggle"],{checked:this.state.gatedAccess,label:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject2),onToggle:function onToggle(event,toggled){return _this2.toggleAccess({gatedAccess:toggled});}}),this.state.gatedAccess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:css.info},Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject3))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:css.buttonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["Toggle"],{checked:this.state.delayedAccess,label:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject4),onToggle:function onToggle(event,toggled){return _this2.toggleAccess({delayedAccess:toggled});}}),this.state.delayedAccess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:css.info},Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject5)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["List"],null,this.state.delayedAccessSettings.map(function(section){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_PeriodSelector__["a" /* default */],{value:section.accessDelay,key:section.id,onChange:function onChange(seconds){return _this2.handleDelayedAccessChange(section.id,seconds);}},section.name);})))));}}]);return CourseDripContentEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CourseDripContentEditor.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,course:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,save:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,update:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,updateSection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,delayedAccessSettings:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_Util_refluxConnector__["a" /* connect */])([[__WEBPACK_IMPORTED_MODULE_7_stores_Course__["a" /* default */],function(state){return{delayedAccessSettings:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_dripContent_selector__["a" /* getDelayedAccessSettings */])(state)};}]],{updateSection:__WEBPACK_IMPORTED_MODULE_6_actions_Course__["a" /* default */].updateSection,update:__WEBPACK_IMPORTED_MODULE_6_actions_Course__["a" /* default */].updateDripContent,save:__WEBPACK_IMPORTED_MODULE_6_actions_Course__["a" /* default */].saveSettings})(CourseDripContentEditor));

/***/ }),
/* 2177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDelayedAccessSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var makeGetDelayedAccessSettings=function makeGetDelayedAccessSettings(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.selected?state.selected.toc:[];},function(toc){return toc.map(function(section){return{id:section.id,name:section.name,accessDelay:section.accessDelay};});});};var getDelayedAccessSettings=makeGetDelayedAccessSettings();

/***/ }),
/* 2178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['Hours'],['Hours']),_templateObject2=_taggedTemplateLiteral(['Days'],['Days']),_templateObject3=_taggedTemplateLiteral(['Months'],['Months']),_templateObject4=_taggedTemplateLiteral(['After'],['After']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var secondsInAnHour=60*60;var periodMultipliers={0:1,1:24,2:30*24};var secondsToPeriod=function secondsToPeriod(seconds){var selectedIndex=0;var amount=0;Object.keys(periodMultipliers).sort(function(a,b){return b-a;}).forEach(function(index){if(amount<1&&seconds%(secondsInAnHour*periodMultipliers[index])===0){amount=seconds/(secondsInAnHour*periodMultipliers[index]);selectedIndex=parseInt(index,10);}});return{selectedIndex:selectedIndex,amount:amount};};var css={container:'_e4',input:'_e5',label:'_e6',dropdown:'_e7'};var PeriodSelector=function(_Component){_inherits(PeriodSelector,_Component);function PeriodSelector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PeriodSelector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PeriodSelector.__proto__||Object.getPrototypeOf(PeriodSelector)).call.apply(_ref,[this].concat(args))),_this),_this.state=secondsToPeriod(_this.props.value),_this.handleAmountChange=function(_ref2){var value=_ref2.target.value;_this.setState({amount:value},function(){_this.onChange();});},_this.handleSliceChange=function(event,selectedIndex){_this.setState({selectedIndex:selectedIndex},function(){_this.onChange();});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PeriodSelector,[{key:'onChange',value:function onChange(){var onChange=this.props.onChange;if(onChange){var selectedIndex=this.state.selectedIndex;if(!isNaN(this.state.amount)){var amount=parseInt(this.state.amount,10);var seconds=amount*secondsInAnHour*periodMultipliers[selectedIndex];onChange(seconds);}}}},{key:'render',value:function render(){var timeSlices=[{payload:'hour',text:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["_l"])(_templateObject)},{payload:'day',text:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["_l"])(_templateObject2)},{payload:'mount',text:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["_l"])(_templateObject3)}];var _state=this.state,amount=_state.amount,selectedIndex=_state.selectedIndex;var children=this.props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.label},children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.input},Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["_l"])(_templateObject4)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.input},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["TextField"],{fullWidth:true,onChange:this.handleAmountChange,value:amount})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.dropdown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["SelectField"],{selectedIndex:selectedIndex,onChange:this.handleSliceChange,menuItems:timeSlices,fullWidth:true})));}}]);return PeriodSelector;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PeriodSelector.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (PeriodSelector);

/***/ }),
/* 2179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util_refluxConnector__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_oxygen_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['Quiz settings'],['Quiz settings']),_templateObject2=_taggedTemplateLiteral(['Enable quiz'],['Enable quiz']),_templateObject3=_taggedTemplateLiteral(['Enable timer'],['Enable timer']),_templateObject4=_taggedTemplateLiteral(['timerInfo'],['timerInfo']),_templateObject5=_taggedTemplateLiteral(['Quiz page settings'],['Quiz page settings']),_templateObject6=_taggedTemplateLiteral(['Repeatable'],['Repeatable']),_templateObject7=_taggedTemplateLiteral(['Hide'],['Hide']),_templateObject8=_taggedTemplateLiteral(['Welcome message'],['Welcome message']),_templateObject9=_taggedTemplateLiteral(['Description'],['Description']),_templateObject10=_taggedTemplateLiteral(['Success message'],['Success message']),_templateObject11=_taggedTemplateLiteral(['Fail message'],['Fail message']),_templateObject12=_taggedTemplateLiteral(['threshold'],['threshold']),_templateObject13=_taggedTemplateLiteral(['QuizWarning'],['QuizWarning']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={list:{paddingTop:32,backgroundColor:'#FFFFFF'},listHeader:{fontSize:24,borderStyle:'none none solid none',borderWidth:'1px',borderColor:'rgba(0, 0, 0, 0.12)'}};var css={header:'_ef',content:'_eg',buttonWrapper:'_eh',panel:'_ei',info:'_ej',timer:'_kr'};var CourseQuizContentEditor=function(_mixin){_inherits(CourseQuizContentEditor,_mixin);function CourseQuizContentEditor(props){_classCallCheck(this,CourseQuizContentEditor);var _this=_possibleConstructorReturn(this,(CourseQuizContentEditor.__proto__||Object.getPrototypeOf(CourseQuizContentEditor)).call(this,props));_initialiseProps.call(_this);var _this$props$course=_this.props.course,course=_this$props$course===undefined?{}:_this$props$course;var settings=course.settings||{};var quizContent=settings.quiz||{};var enabled=quizContent.enabled,timer=quizContent.timer,isTimer=quizContent.isTimer;_this.state={enabled:enabled,isTimer:isTimer,timer:timer?timer:'00:00:00',repeatable:null};return _this;}_createClass(CourseQuizContentEditor,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_9_stores__["f" /* CourseStore */],'courseStore');}},{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$course=_props.course,course=_props$course===undefined?{}:_props$course,isTimer=_props.isTimer;var settings=course.settings||{};var quizContent=settings.quiz||{};var enabled=quizContent.enabled;var pages=quizContent.pages||{};var isTimerActive=isTimer||this.state.isTimer;var quizGlobalSetting=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["List"],{subheader:Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject),style:styles.list,subheaderStyle:styles.listHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Toggle"],{name:'enabled',checked:this.state.enabled,label:Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject2),onToggle:function onToggle(event,toggled){_this2.handleChange(event,course.toc,toggled);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Toggle"],{name:'isTimer',checked:this.state.isTimer,label:Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject3),onToggle:function onToggle(e,toggled){_this2.switchTimer(toggled);}}),isTimerActive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.timer},Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject4),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'time',name:'timer',value:this.state.timer,step:'1',onBlur:this.updateTimer,onChange:function onChange(e){return _this2.setState({timer:e.target.value});}}))));var quizToc=this.state.courseStore.course.toc.filter(function(item){return item.type==='quiz';});var quizPageSettings=null;if(quizToc.length&&this.state.enabled){quizPageSettings=quizToc[0].pages.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["List"],{subheader:Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject5)+item.name,style:styles.list,subheaderStyle:styles.listHeader,key:item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Toggle"],{name:'repeatable',checked:pages[item.id]&&pages[item.id].repeatable||false,label:Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject6),onToggle:function onToggle(_,toggled){_this2.update(item.id,{repeatable:toggled});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Toggle"],{name:'hideanswers',checked:pages[item.id]&&pages[item.id].hideAnswers||false,label:Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject7),onToggle:function onToggle(event,toggled){// this.handleChange(event);
_this2.update(item.id,{hideAnswers:toggled});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{fullWidth:true,multiLine:true,floatingLabelText:Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject8),onBlur:function onBlur(e){return _this2.update(item.id,{welcomeText:e.target.value});},defaultValue:pages[item.id]&&pages[item.id].welcomeText||''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{fullWidth:true,multiLine:true,floatingLabelText:Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject9),onBlur:function onBlur(e){return _this2.update(item.id,{descriptionText:e.target.value});},defaultValue:pages[item.id]&&pages[item.id].descriptionText||''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{fullWidth:true,multiLine:true,floatingLabelText:Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject10),onBlur:function onBlur(e){return _this2.update(item.id,{successText:e.target.value});},defaultValue:pages[item.id]&&pages[item.id].successText||''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{fullWidth:true,multiLine:true,floatingLabelText:Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject11),onBlur:function onBlur(e){return _this2.update(item.id,{failText:e.target.value});},defaultValue:pages[item.id]&&pages[item.id].failText||''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{fullWidth:true,key:item.id,type:'number',floatingLabelText:Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject12),onBlur:function onBlur(e){return _this2.update(item.id,{threshold:e.target.value});},defaultValue:pages[item.id]&&pages[item.id].threshold||80})));});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',quizGlobalSetting,quizPageSettings,' ');}}]);return CourseQuizContentEditor;}(Object(__WEBPACK_IMPORTED_MODULE_3_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_3_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));CourseQuizContentEditor.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,course:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,save:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,update:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,updateSection:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,delayedAccessSettings:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array};var _initialiseProps=function _initialiseProps(){var _this3=this;this.handleChange=function(e,toc,toggled){if(e.target.name==='enabled'&&!e.target.checked){var ok=confirm(Object(__WEBPACK_IMPORTED_MODULE_4_oxygen_i18n__["translate"])(_templateObject13));if(ok){_this3.setState(_defineProperty({},e.target.name,e.target.checked));_this3.enableQuiz(toc,toggled);}}else{_this3.setState(_defineProperty({},e.target.name,e.target.checked));_this3.enableQuiz(toc,toggled);}};this.save=function(){var save=_this3.props.save;save();};this.enableQuiz=function(toc,enabled){var update=_this3.props.update;var hasQuiz=toc.find(function(s){return s.type==='quiz';});if(!hasQuiz){__WEBPACK_IMPORTED_MODULE_7_actions__["g" /* DashboardActions */].initQuizSection(_this3.props.course,enabled);}_this3.setState({enabled:enabled});update({enabled:enabled});_this3.save();};this.update=function(pageId,data){var quizPages=_this3.props.course.settings.quiz.pages||{};if(!Object.keys(quizPages).length){quizPages=_defineProperty({},pageId,Object.assign({},quizPages,data));}else{quizPages[pageId]?quizPages[pageId]=Object.assign({},quizPages[pageId],data):quizPages=Object.assign({},quizPages,_defineProperty({},pageId,data));}var update=_this3.props.update;update({pages:quizPages});_this3.save();};this.updateTimer=function(){var update=_this3.props.update;var _state=_this3.state,timer=_state.timer,isTimer=_state.isTimer;update({timer:timer,isTimer:isTimer});_this3.save();};this.switchTimer=function(toggled){var update=_this3.props.update;_this3.setState({isTimer:toggled},function(){update({isTimer:_this3.state.isTimer});_this3.save();});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_Util_refluxConnector__["a" /* connect */])([],{update:__WEBPACK_IMPORTED_MODULE_7_actions__["f" /* CourseActions */].updateQuizSettings,save:__WEBPACK_IMPORTED_MODULE_7_actions__["f" /* CourseActions */].saveSettings})(CourseQuizContentEditor));

/***/ }),
/* 2180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBar__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Material_DropDown__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['All'],['All']),_templateObject2=_taggedTemplateLiteral(['Active'],['Active']),_templateObject3=_taggedTemplateLiteral(['Inactive'],['Inactive']),_templateObject4=_taggedTemplateLiteral(['Search for students'],['Search for students']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var minDate=new Date();var maxDate=new Date();maxDate.setFullYear(maxDate.getFullYear()+2);var StudentOverview=function(_Component){_inherits(StudentOverview,_Component);function StudentOverview(props){_classCallCheck(this,StudentOverview);var _this=_possibleConstructorReturn(this,(StudentOverview.__proto__||Object.getPrototypeOf(StudentOverview)).call(this,props));_this.formatDate=function(date){return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format('YYYY-MM-DD');};_this.onClickDatePicker=function(event,item){event.stopPropagation();_this.setState({student:item});};_this.onTouchTapRightIcon=function(event,item){event.stopPropagation();if(_this.props.onTouchTapRightIcon){_this.props.onTouchTapRightIcon(item);}};_this.changeAccessDate=function(foo,accessDate){accessDate.setHours(12);if(_this.props.onTouchTap){_this.props.onTouchTap(_this.state.student,accessDate);}};_this.goToStudent=function(item){if(item===null){_this.setState({student:null});}else{_this.props.router.push('/student/'+item.id);}};_this.state={student:{}};return _this;}_createClass(StudentOverview,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return nextProps.list!==this.props.list||nextProps.loading!==this.props.loading;}},{key:'handleFilterByStatus',value:function handleFilterByStatus(event){this.props.filterByStatus(event.target.value);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,list=_props.list,prevDisabled=_props.prevDisabled,nextDisabled=_props.nextDisabled,prev=_props.prev,next=_props.next,filter=_props.filter,loading=_props.loading,total=_props.total,pageStartStudents=_props.pageStartStudents,pageLengthStudents=_props.pageLengthStudents;var count=list.length+pageStartStudents;if(pageStartStudents===0&&total<pageLengthStudents){count=total;}var buttons=null;if(total>=pageLengthStudents&&pageLengthStudents<=list.length){buttons=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Material_Loader__["b" /* default */],null):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{label:'prev',disabled:prevDisabled,onTouchTap:prev}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{label:'next',disabled:pageStartStudents+pageLengthStudents>total,onTouchTap:next}));}var subHeader=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Students (',count,'/',total,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'0.6em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Material_DropDown__["a" /* default */],{onChange:this.handleFilterByStatus.bind(this),label:'Filter by status',menuItems:[{payload:null,text:Object(__WEBPACK_IMPORTED_MODULE_7_oxygen_i18n__["_l"])(_templateObject)},{payload:1,text:Object(__WEBPACK_IMPORTED_MODULE_7_oxygen_i18n__["_l"])(_templateObject2)},{payload:0,text:Object(__WEBPACK_IMPORTED_MODULE_7_oxygen_i18n__["_l"])(_templateObject3)}]})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["List"],{subheader:subHeader,style:{marginTop:'10px',backgroundColor:'#FFFFFF'},subheaderStyle:{fontSize:24,borderStyle:'none none solid none',borderWidth:'1px',borderColor:'rgba(0, 0, 0, 0.12)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SearchBar__["a" /* default */],{fullWidth:true,onChange:filter,placeholder:Object(__WEBPACK_IMPORTED_MODULE_7_oxygen_i18n__["_l"])(_templateObject4)}),list.map(function(item){var expiration=null;if(item.expires==='0000-00-00'){expiration='Forever';}else{expiration=item.expires;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["ListItem"],{key:item.id,primaryText:item.name,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{onTouchTap:function onTouchTap(event){return _this2.onTouchTapRightIcon(event,item);},tooltip:_this2.context.getIntlMessage('student.removeFromCourse'),tooltipPosition:'top-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Material_SvgIcons__["ContentClear"],null)),rightIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{onTouchTap:function onTouchTap(event){return _this2.onClickDatePicker(event,item);},style:{didFlip:false,right:'200px',top:'-10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["DatePicker"],{hintText:_this2.context.getIntlMessage('course.access')+expiration,minDate:minDate,maxDate:maxDate,onChange:_this2.changeAccessDate.bind(_this2),formatDate:_this2.formatDate,textFieldStyle:{width:'210px',fontSize:'15px'},inputStyle:{cursor:'pointer'}})),onTouchTap:function onTouchTap(){return _this2.goToStudent(item);}});}),buttons);}}]);return StudentOverview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StudentOverview.propTypes={list:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,prevDisabled:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,nextDisabled:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,loading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,prev:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,next:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,filter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,filterByStatus:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};StudentOverview.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* withRouter */])(StudentOverview));

/***/ }),
/* 2181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentClear=__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ContentClear"],ContentSend=__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ContentSend"],MapsBeenhere=__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["MapsBeenhere"];var InvitationOverview=function(_Component){_inherits(InvitationOverview,_Component);function InvitationOverview(){_classCallCheck(this,InvitationOverview);var _this=_possibleConstructorReturn(this,(InvitationOverview.__proto__||Object.getPrototypeOf(InvitationOverview)).apply(this,arguments));_this.state={collapsed:false,clicked:false,count:0};return _this;}_createClass(InvitationOverview,[{key:'select',value:function select(item){if(this.props.onSelect){this.props.onSelect(item);}}},{key:'toggle',value:function toggle(){this.setState({collapsed:!this.state.collapsed});}},{key:'onTouchTapRightIcon',value:function onTouchTapRightIcon(item){if(this.props.onTouchTapRightIcon){this.props.onTouchTapRightIcon(item);}}},{key:'onTouchTapLeftIcon',value:function onTouchTapLeftIcon(item){if(this.props.onTouchTapLeftIcon){this.props.onTouchTapLeftIcon(item);}}},{key:'onCheck',value:function onCheck(item){if(this.props.onCheck){this.props.onCheck(item);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,list=_props.list,prevDisabled=_props.prevDisabled,nextDisabled=_props.nextDisabled,prev=_props.prev,next=_props.next,loading=_props.loading,total=_props.total,pageStartInvitations=_props.pageStartInvitations,pageLengthInvitations=_props.pageLengthInvitations;if(pageStartInvitations==0&&total<pageLengthInvitations){this.state.count=total;}else{this.state.count=list.length+pageStartInvitations;}var finTotal=void 0,buttons=void 0;if(total<pageLengthInvitations){finTotal='';buttons=null;}else{finTotal='/'+total;buttons=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_Loader__["b" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{label:'prev',disabled:prevDisabled,onTouchTap:prev}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{label:'next',disabled:pageStartInvitations+pageLengthInvitations>total?true:false,onTouchTap:next}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["List"],{subheader:'Invitations ('+this.state.count+finTotal+')',style:{marginTop:'10px',backgroundColor:'#FFFFFF'},subheaderStyle:{fontSize:24,borderStyle:'none none solid none',borderWidth:'1px',borderColor:'rgba(0, 0, 0, 0.12)'}},list.map(function(item){var expiration=void 0,resendButton=void 0,checkBoxItem=void 0;if(item.expires){expiration=' ('+item.expires.slice(0,10)+')';if(!item.clicked){resendButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{style:{marginLeft:30},onTouchTap:_this2.onTouchTapLeftIcon.bind(_this2,item),tooltip:_this2.context.getIntlMessage('invitation.resend'),tooltipPosition:'top-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentSend,null));}else{resendButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{style:{marginLeft:30},onTouchTap:_this2.onTouchTapLeftIcon.bind(_this2,item),tooltip:_this2.context.getIntlMessage('invitation.resend'),tooltipPosition:'top-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MapsBeenhere,null));}checkBoxItem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Checkbox"],{onCheck:_this2.onCheck.bind(_this2,item)});}else{expiration='';resendButton=null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["ListItem"],{key:item.id,primaryText:item.email+expiration,leftCheckbox:checkBoxItem,onTouchTap:_this2.select.bind(_this2,item),rightIconButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{onTouchTap:_this2.onTouchTapRightIcon.bind(_this2,item),tooltip:_this2.context.getIntlMessage('invitation.remove'),tooltipPosition:'top-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentClear,null)),leftIcon:resendButton});}),buttons);}}]);return InvitationOverview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);InvitationOverview.propTypes={list:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,prevDisabled:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,nextDisabled:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,loading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,prev:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,next:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};InvitationOverview.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (InvitationOverview);

/***/ }),
/* 2182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStudents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getInvitations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var makeGetStudents=function makeGetStudents(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.entities.student;},function(state){return state.list.students;},function(state){return state.students.pageStart;},function(state){return state.students.pageLength;},function(state){return state.totalStudents;},function(students,list,pageStart,pageLength,totalStudents){return list.slice(pageStart,pageStart+pageLength).map(function(studentId){return students[studentId];});});};var getStudents=makeGetStudents();var makeGetInvitations=function makeGetInvitations(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.entities.invitation;},function(state){return state.list.invitations;},function(state){return state.invitations.pageStart;},function(state){return state.invitations.pageLength;},function(state){return state.totalInvitations;},function(invitations,list,pageStart,pageLength){return list.slice(pageStart,pageStart+pageLength).map(function(invitationId){return invitations[invitationId];});});};var getInvitations=makeGetInvitations();

/***/ }),
/* 2183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Toolbar__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Option__ = __webpack_require__(2184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Tooltip__ = __webpack_require__(366);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ESC=27;var css={root:'_ck',fullWidth:'_cl',dark:'_cm',inputContainer:'_cn',button:'_co'};var DropDown=function(_Component){_inherits(DropDown,_Component);function DropDown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DropDown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DropDown.__proto__||Object.getPrototypeOf(DropDown)).call.apply(_ref,[this].concat(args))),_this),_this.state={active:false},_this.getNode=function(){return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this);},_this.activate=function(){if(!_this.state.active){_this.setState({active:true});}},_this.deactivate=function(){if(_this.state.active){_this.setState({active:false});}},_this.handleKeyDown=function(event){var keyCode=event.keyCode;if(keyCode===ESC&&_this.state.active){_this.deactivate();}else if(!_this.state.active){_this.activate();}},_this.handleSelect=function(payload){var _this$props=_this.props,selected=_this$props.selected,onChange=_this$props.onChange;if(selected!==payload){onChange&&onChange(payload);}_this.deactivate();},_this.positionDropdown=function(rect,ownRect){return{left:rect.left,top:rect.top,width:rect.width};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DropDown,[{key:'render',value:function render(){var _classNames,_this2=this;var _props=this.props,fullWidth=_props.fullWidth,dark=_props.dark,options=_props.options,placeholder=_props.placeholder,selected=_props.selected;var active=this.state.active;var classes=__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.root,(_classNames={},_defineProperty(_classNames,css.fullWidth,fullWidth),_defineProperty(_classNames,css.dark,dark),_classNames));var selectedOption=options.find(function(option){return option.payload===selected;})||{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.inputContainer,onTouchTap:this.activate},selectedOption.label||placeholder),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Toolbar__["c" /* ToolbarButton */],{onTouchTap:this.activate,className:css.button,onKeyDown:this.handleKeyDown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["HardwareKeyboardArrowDown"],{color:dark?__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].text.Light.secondary:__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].text.Dark.secondary})),active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Tooltip__["a" /* default */],{onClickAway:this.deactivate,hasArrow:false,anchorTo:this.getNode,padded:false,getPosition:this.positionDropdown},options.map(function(option){var payload=option.payload,label=option.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Option__["a" /* default */],{selected:selectedOption.payload===payload,key:payload,payload:payload,onTouchTap:_this2.handleSelect},label);})));}}]);return DropDown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DropDown.propTypes={dark:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,options:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,placeholder:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,fullWidth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object]),onChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};DropDown.defaultProps={placeholder:'Select',fullWidth:false};/* harmony default export */ __webpack_exports__["a"] = (DropDown);

/***/ }),
/* 2184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_ct',selected:'_cu'};var Option=function(_Component){_inherits(Option,_Component);function Option(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Option);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Option.__proto__||Object.getPrototypeOf(Option)).call.apply(_ref,[this].concat(args))),_this),_this.handleTap=function(event){var _this$props=_this.props,payload=_this$props.payload,onTouchTap=_this$props.onTouchTap;onTouchTap&&onTouchTap(payload);event.stopPropagation();event.preventDefault();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Option,[{key:'render',value:function render(){var _props=this.props,children=_props.children,payload=_props.payload,onTouchTap=_props.onTouchTap,selected=_props.selected,other=_objectWithoutProperties(_props,['children','payload','onTouchTap','selected']);var classes=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.root,_defineProperty({},css.selected,selected));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},other,{onTouchTap:this.handleTap,className:classes}),children);}}]);return Option;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Option.propTypes={onTouchTap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,payload:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object])};/* harmony default export */ __webpack_exports__["a"] = (Option);

/***/ }),
/* 2185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_Course__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Route_Course_Detail__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Material_Loader__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CourseDetailContainer=function(_mixin){_inherits(CourseDetailContainer,_mixin);function CourseDetailContainer(){_classCallCheck(this,CourseDetailContainer);return _possibleConstructorReturn(this,(CourseDetailContainer.__proto__||Object.getPrototypeOf(CourseDetailContainer)).apply(this,arguments));}_createClass(CourseDetailContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_2__stores_Course__["a" /* default */]);}},{key:'componentWillMount',value:function componentWillMount(){if(_get(CourseDetailContainer.prototype.__proto__||Object.getPrototypeOf(CourseDetailContainer.prototype),'componentWillMount',this)){_get(CourseDetailContainer.prototype.__proto__||Object.getPrototypeOf(CourseDetailContainer.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_3__actions_Course__["a" /* default */].findById(this.props.params.courseId);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.routeParams.courseId!==nextProps.routeParams.courseId){__WEBPACK_IMPORTED_MODULE_3__actions_Course__["a" /* default */].findById(nextProps.routeParams.courseId);}}},{key:'render',value:function render(){var course=this.state.course;if(!course||!course.id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Material_Loader__["b" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Route_Course_Detail__["a" /* default */],{key:course.id,course:course,onClose:this.props.router.goBack});}}]);return CourseDetailContainer;}(Object(__WEBPACK_IMPORTED_MODULE_1__Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1__Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (CourseDetailContainer);

/***/ }),
/* 2186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_User__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_User__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions_Student__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_ListDetail__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_DialogPortal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions_Auth__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_stores_Auth__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_intl__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubAccounts=function(_mixin){_inherits(SubAccounts,_mixin);function SubAccounts(){_classCallCheck(this,SubAccounts);return _possibleConstructorReturn(this,(SubAccounts.__proto__||Object.getPrototypeOf(SubAccounts)).apply(this,arguments));}_createClass(SubAccounts,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_5_stores_User__["a" /* default */]);this.listenToStore(__WEBPACK_IMPORTED_MODULE_11_stores_Auth__["a" /* default */]);}},{key:'componentWillMount',value:function componentWillMount(){if(_get(SubAccounts.prototype.__proto__||Object.getPrototypeOf(SubAccounts.prototype),'componentWillMount',this)){_get(SubAccounts.prototype.__proto__||Object.getPrototypeOf(SubAccounts.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_6_actions_User__["a" /* default */].listPwned();}},{key:'selectAccount',value:function selectAccount(account){if(null===account){this.setState({selected:null});}else{this.setState({selected:account});this.refs.incarnateAccountDialog.show();}}},{key:'_onIncarnateAccountConfirm',value:function _onIncarnateAccountConfirm(){var _this2=this;var account=this.state.selected||null;__WEBPACK_IMPORTED_MODULE_10_actions_Auth__["a" /* default */].incarnate(parseInt(account.id,10),function(){var router=_this2.props.router;router.replace(null,'/dashboard');});}},{key:'render',value:function render(){var accounts=this.state.list.sort(function(a,b){if(a.name.toLowerCase()<b.name.toLowerCase())return-1;if(a.name.toLowerCase()>b.name.toLowerCase())return 1;return 0;})||[];var incarnateAccountActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('subAccount.incarnate'),onTouchTap:this._onIncarnateAccountConfirm.bind(this),ref:'incarnate'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_RulerBar__["a" /* default */],{title:this.context.getIntlMessage('Sub-Accounts')})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ListDetail__["a" /* default */],{items:accounts,onTouchTapItem:this.selectAccount.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'incarnateAccountDialog',title:this.context.getIntlMessage('subAccount.incarnate'),actions:incarnateAccountActions,actionFocus:'Ok',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('subAccount.attention')}))));}}]);return SubAccounts;}(Object(__WEBPACK_IMPORTED_MODULE_3_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_3_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_3_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));SubAccounts.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (SubAccounts);

/***/ }),
/* 2187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RulerBar__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_B'};var StripeCompletePurchase=function(_Component){_inherits(StripeCompletePurchase,_Component);function StripeCompletePurchase(){_classCallCheck(this,StripeCompletePurchase);return _possibleConstructorReturn(this,(StripeCompletePurchase.__proto__||Object.getPrototypeOf(StripeCompletePurchase)).apply(this,arguments));}_createClass(StripeCompletePurchase,[{key:'componentDidMount',value:function componentDidMount(){var queryParams=this.props.location.query;var data=Object.assign({},queryParams);var event=new CustomEvent('stripeSecure3DSuccess',{detail:data});window.parent.document.dispatchEvent(event);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_AppPage__["a" /* default */],{className:'dashboard',header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_RulerBar__["a" /* default */],{title:''})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:css.root},'Payment complete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:css.root},'The course will soon appear on your dashboard once we have received a signal.'));}}]);return StripeCompletePurchase;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StripeCompletePurchase.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (StripeCompletePurchase);

/***/ }),
/* 2188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RulerBar__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_C'};var StripeCompletePurchase=function(_Component){_inherits(StripeCompletePurchase,_Component);function StripeCompletePurchase(){_classCallCheck(this,StripeCompletePurchase);return _possibleConstructorReturn(this,(StripeCompletePurchase.__proto__||Object.getPrototypeOf(StripeCompletePurchase)).apply(this,arguments));}_createClass(StripeCompletePurchase,[{key:'componentDidMount',value:function componentDidMount(){var queryParams=this.props.location.query;var data=Object.assign({},queryParams);var event=new CustomEvent('stripeSecure3DSuccess',{detail:data});window.parent.document.dispatchEvent(event);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_AppPage__["a" /* default */],{className:'dashboard',header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_RulerBar__["a" /* default */],{title:''})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:css.root},'Payment canceled'));}}]);return StripeCompletePurchase;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StripeCompletePurchase.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (StripeCompletePurchase);

/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__renderTaC__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FullWidthPane__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={content:'_c'};var TaC=function(_mixin){_inherits(TaC,_mixin);function TaC(){_classCallCheck(this,TaC);return _possibleConstructorReturn(this,(TaC.__proto__||Object.getPrototypeOf(TaC)).apply(this,arguments));}_createClass(TaC,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_5__stores__["b" /* AuthStore */],function(state){return{locale:state.locale};},{locale:'en_US'});}},{key:'render',value:function render(){var locale=this.state.locale;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AppPage__["a" /* default */],{key:'TaC',header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RulerBar__["a" /* default */],{title:this.context.getIntlMessage('menu.TaC')})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FullWidthPane__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.content},locale==='sv_SE'?__WEBPACK_IMPORTED_MODULE_1__renderTaC__["b" /* swedish */]:__WEBPACK_IMPORTED_MODULE_1__renderTaC__["a" /* english */])));}}]);return TaC;}(Object(__WEBPACK_IMPORTED_MODULE_6__Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_6__Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));TaC.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (TaC);

/***/ }),
/* 2190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Wizard__ = __webpack_require__(2191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CourseSelector__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_GroupSelector__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_StudentSelector__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_InviteeAdder__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Tag__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Widgets_Overview__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_Message__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Colors=__WEBPACK_IMPORTED_MODULE_16_components_Material_Styles_Colors__["a" /* Colors */];var Spacing=__WEBPACK_IMPORTED_MODULE_11_material_ui__["Styles"].Spacing;var styles={header:{margin:__WEBPACK_IMPORTED_MODULE_11_material_ui__["Styles"].Spacing.desktopGutterMini,fontSize:18}};var InviteWizard=function(_mixin){_inherits(InviteWizard,_mixin);function InviteWizard(props,context){_classCallCheck(this,InviteWizard);var _this=_possibleConstructorReturn(this,(InviteWizard.__proto__||Object.getPrototypeOf(InviteWizard)).call(this,props,context));_this.state={newGroup:{}};_this.accessTimes={oneMonth:context.getIntlMessage('invite.oneMonth'),threeMonths:context.getIntlMessage('invite.threeMonths'),sixMonths:context.getIntlMessage('invite.sixMonths'),oneYear:context.getIntlMessage('invite.oneYear'),twoYears:context.getIntlMessage('invite.twoYears')};_this.menuItems=[{payload:null,text:context.getIntlMessage('invite.chooseAccessTime')}];Object.keys(_this.accessTimes).forEach(function(time){_this.menuItems.push({payload:time,text:_this.accessTimes[time]});});return _this;}_createClass(InviteWizard,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_2_stores__["k" /* InviteWizardStore */]);this.listenToStore(__WEBPACK_IMPORTED_MODULE_2_stores__["i" /* GroupStore */],'groups');}},{key:'selectCourses',value:function selectCourses(courses){__WEBPACK_IMPORTED_MODULE_3_actions__["m" /* InviteWizardActions */].selectCourses(Object.keys(courses).map(function(x){return courses[x];}));}},{key:'selectGroups',value:function selectGroups(groups){__WEBPACK_IMPORTED_MODULE_3_actions__["m" /* InviteWizardActions */].selectGroups(Object.keys(groups).map(function(x){return groups[x];}));this.refs.inviteesAdder.reset();this.refs.studentSelector.reset();__WEBPACK_IMPORTED_MODULE_3_actions__["m" /* InviteWizardActions */].selectStudents([]);__WEBPACK_IMPORTED_MODULE_3_actions__["m" /* InviteWizardActions */].setInvitees([]);}},{key:'selectStudents',value:function selectStudents(students){__WEBPACK_IMPORTED_MODULE_3_actions__["m" /* InviteWizardActions */].selectStudents(Object.keys(students).map(function(x){return students[x];}));this.refs.inviteesAdder.reset();this.refs.groupSelector.reset();__WEBPACK_IMPORTED_MODULE_3_actions__["m" /* InviteWizardActions */].selectGroups([]);__WEBPACK_IMPORTED_MODULE_3_actions__["m" /* InviteWizardActions */].setInvitees([]);}},{key:'addInvitees',value:function addInvitees(invitees){__WEBPACK_IMPORTED_MODULE_3_actions__["m" /* InviteWizardActions */].setInvitees(invitees);this.refs.groupSelector.reset();this.refs.studentSelector.reset();__WEBPACK_IMPORTED_MODULE_3_actions__["m" /* InviteWizardActions */].selectGroups([]);__WEBPACK_IMPORTED_MODULE_3_actions__["m" /* InviteWizardActions */].selectStudents([]);}},{key:'getCardStyle',value:function getCardStyle(){return{marginBottom:Spacing.desktopGutter,backgroundColor:this.context.muiTheme.rawTheme.palette.cardColor};}},{key:'createCourseChoice',value:function createCourseChoice(completed){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Wizard__["b" /* WizardStep */],{title:this.context.getIntlMessage('invite.chooseCourses'),icon:1,completed:completed},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.header},this.context.getIntlMessage('invite.chooseCourseExplanation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CourseSelector__["a" /* default */],{ref:'courseSelector',onSelect:this.selectCourses.bind(this),selected:this.state.selectedCourses}));}},{key:'createStudentChoice',value:function createStudentChoice(completed){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Wizard__["b" /* WizardStep */],{title:this.context.getIntlMessage('invite.chooseStudents'),icon:2,completed:completed},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.header},this.context.getIntlMessage('invite.chooseStudentsOrGroups')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["Tabs"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["Tab"],{label:this.context.getIntlMessage('invite.existingStudents')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_StudentSelector__["a" /* default */],{ref:'studentSelector',selected:this.state.selectedStudents,onSelect:this.selectStudents.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["Tab"],{label:this.context.getIntlMessage('invite.newStudents')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_InviteeAdder__["a" /* default */],{initial:this.state.invitees,ref:'inviteesAdder',onChange:this.addInvitees.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["Tab"],{label:this.context.getIntlMessage('invite.groups')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_GroupSelector__["a" /* default */],{ref:'groupSelector',selected:this.state.selectedGroups,onSelect:this.selectGroups.bind(this)}))));}},{key:'setAccessTime',value:function setAccessTime(e,index,menuItem){this.setState({accessTime:menuItem.payload,endTime:null});}},{key:'setEndTime',value:function setEndTime(foo,date){this.setState({endTime:date.toISOString(),accessTime:null});}},{key:'createAccessTime',value:function createAccessTime(completed,accessTime){var _this2=this;var step=void 0;var menuItems=this.menuItems;if(accessTime){var selectedIndex=menuItems.findIndex(function(item){return item.payload===_this2.state.accessTime;});step=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.context.getIntlMessage('invite.chooseAccessTimeExplanation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["DropDownMenu"],{selectedIndex:selectedIndex,menuItems:menuItems,onChange:this.setAccessTime.bind(this)}));}else{step=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.context.getIntlMessage('invite.chooseEndDateExplanation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["DatePicker"],{minDate:new Date(),maxDate:this.state.endDate,hintText:this.context.getIntlMessage('invite.chooseEndDate'),defaultValue:this.state.endDate,onChange:this.setEndTime.bind(this)}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Wizard__["b" /* WizardStep */],{title:this.context.getIntlMessage('invite.chooseAccessTime'),icon:3,completed:completed},step);}},{key:'deleteTag',value:function deleteTag(tagName){var tags=this.state.tags;delete tags[tagName];this.setState({tags:tags});}},{key:'addTag',value:function addTag(){var tagName=this.refs.addTag.getValue();var tags=this.state.tags;tags[tagName]=true;this.setState({tags:tags});this.refs.addTag.clearValue();}/*createTagCreator() {
    let tags = [];
    if (this.state.tags) {
      tags = Object.keys(this.state.tags).map(tag => {
        if (this.state.tags[tag])
          return <Tag onDelete={this.deleteTag.bind(this)} key={tag} controls={true} mini={false} name={tag} />;
      });
    }
    return (
      <Paper style={this.getCardStyle()}>
        <Overview header={this.context.getIntlMessage('invite.createTags')}>
          <div style={{ padding: Spacing.desktopGutterMini * 2 }}>
            {tags}
            <div>
              <TextField fullWidth={true} floatingLabelText={this.context.getIntlMessage('tag.name')} hintText={'Type a new tag and press enter to add it to these students'} ref='addTag' onEnterKeyDown={this.addTag.bind(this)}/>
            </div>
          </div>
        </Overview>
      </Paper>
    );
  }*/},{key:'onChange',value:function onChange(e){e.preventDefault();var grName=this.refs.groupName.getValue();if(grName.trim().length!=0){__WEBPACK_IMPORTED_MODULE_3_actions__["j" /* GroupActions */].create(this.refs.groupName.getValue());__WEBPACK_IMPORTED_MODULE_3_actions__["j" /* GroupActions */].filter();}else{return;}}},{key:'createSummary',value:function createSummary(completed){var courses=this.state.selectedCourses,students=this.state.selectedStudents,groups=this.state.selectedGroups,invitees=this.state.invitees,accessTime=this.state.accessTime,endTime=this.state.endTime;//tagCreator = this.createTagCreator();
var courseList=void 0,choiceList=void 0,accessElement=void 0;var courseElements=[],choiceElements=[];var groupCreator=void 0;courses.forEach(function(course,index){courseElements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["ListItem"],{primaryText:course.name,key:'i-'+index}));courseElements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["ListDivider"],{key:'d-'+index}));});if(endTime){accessElement=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["Paper"],{style:this.getCardStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Widgets_Overview__["a" /* default */],{header:this.context.getIntlMessage('invite.accessTime')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["List"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["ListItem"],{primaryText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.context.getIntlMessage('invite.willHaveAccessTill'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_intl__["FormattedDate"],{value:endTime,day:'numeric',month:'long',year:'numeric'})))}))));}else{accessElement=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["Paper"],{style:this.getCardStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Widgets_Overview__["a" /* default */],{header:this.context.getIntlMessage('invite.accessTime')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["List"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["ListItem"],{primaryText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.context.getIntlMessage('invite.willHaveAccessFor'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.accessTimes[accessTime]))}))));}courseList=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Widgets_Overview__["a" /* default */],{header:this.context.getIntlMessage('invite.selectedCourses')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["List"],null,courseElements));if(students.length>0||invitees.length>0){if(students.length>0){students.forEach(function(student,index){choiceElements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["ListItem"],{primaryText:student.name,key:'i-'+index}));choiceElements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["ListDivider"],{key:'d-'+index}));});choiceList=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Widgets_Overview__["a" /* default */],{header:this.context.getIntlMessage('invite.selectedStudents')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["List"],null,choiceElements));}else if(invitees.length>0){invitees.forEach(function(email,index){choiceElements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["ListItem"],{primaryText:email,key:'i-'+index}));choiceElements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["ListDivider"],{key:'d-'+index}));});choiceList=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Widgets_Overview__["a" /* default */],{header:this.context.getIntlMessage('invite.newStudents')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["List"],{subheader:''},choiceElements));}groupCreator=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["Paper"],{style:this.getCardStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Widgets_Overview__["a" /* default */],{header:this.context.getIntlMessage('invite.addToGroup')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["TextField"],{fullWidth:true,floatingLabelText:this.context.getIntlMessage('group.name'),hintText:this.context.getIntlMessage('invite.createGroupExplanation'),ref:'groupName',onEnterKeyDown:this.onChange.bind(this)}))));}else if(groups.length>0){groups.forEach(function(group,index){choiceElements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["ListItem"],{primaryText:group.name,key:'i-'+group.is}));choiceElements.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["ListDivider"],{key:'d-'+group.id}));});choiceList=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Widgets_Overview__["a" /* default */],{header:this.context.getIntlMessage('invite.selectedGroups')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["List"],null,choiceElements));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Wizard__["b" /* WizardStep */],{title:this.context.getIntlMessage('invite.summary'),icon:4,completed:completed},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.context.getIntlMessage('invite.summaryExplanation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flexGrow:1,padding:Spacing.desktopGutterMini}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["Paper"],{style:this.getCardStyle()},courseList)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flexGrow:1,padding:Spacing.desktopGutterMini}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["Paper"],{style:this.getCardStyle()},choiceList))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini}},accessElement),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["RaisedButton"],{style:{marginBottom:Spacing.desktopGutterMore},onTouchTap:this.finalize.bind(this),secondary:true,label:this.context.getIntlMessage('invite.confirmSend'),fullWidth:true}));}},{key:'finalize',value:function finalize(){var _this3=this;var courseIds=this.state.selectedCourses.map(function(course){return course.id;});var circleIds=this.state.selectedGroups.map(function(group){return group.id;});var userIds=this.state.selectedStudents.map(function(student){return student.id;});var selected=this.state.groups.selected;var studentChosen=this.state.selectedStudents.map(function(student){return student.email;});var _state=this.state,accessTime=_state.accessTime,endTime=_state.endTime;var invitees=this.state.invitees;if(invitees.length>0){__WEBPACK_IMPORTED_MODULE_3_actions__["l" /* InviteActions */].inviteByEmails(invitees,courseIds,accessTime,function(){__WEBPACK_IMPORTED_MODULE_17_services_Message__["a" /* default */].info(_this3.context.getIntlMessage('invite.sentOut'));_this3.reset();});}if(circleIds.length>0){__WEBPACK_IMPORTED_MODULE_3_actions__["l" /* InviteActions */].inviteByCircleIds(circleIds,courseIds,endTime,function(){__WEBPACK_IMPORTED_MODULE_17_services_Message__["a" /* default */].info(_this3.context.getIntlMessage('invite.sentOut'));_this3.reset();});}if(userIds.length>0){__WEBPACK_IMPORTED_MODULE_3_actions__["l" /* InviteActions */].inviteByUserIds(userIds,courseIds,accessTime,function(){__WEBPACK_IMPORTED_MODULE_17_services_Message__["a" /* default */].info(_this3.context.getIntlMessage('invite.sentOut'));_this3.reset();});}//this one should be called for adding students to a group but it does not work because it contradicts with
//inviting students to a course
/* if (selected && selected.id) {
      InviteActions.inviteByEmails(studentChosen, selected.id, accessTime, () => {
        Message.info(this.context.getIntlMessage('invite.sentOut'));
        this.reset();
      })
    } */}},{key:'reset',value:function reset(){__WEBPACK_IMPORTED_MODULE_3_actions__["m" /* InviteWizardActions */].reset();}},{key:'restart',value:function restart(){__WEBPACK_IMPORTED_MODULE_3_actions__["m" /* InviteWizardActions */].restart();}},{key:'getFloatingActionButtonStyle',value:function getFloatingActionButtonStyle(hasDetail){var style=void 0,componentTheme=this.context.muiTheme;if(this.context.media==='phone'){style={zIndex:10,position:'fixed',right:Spacing.desktopGutter,bottom:Spacing.desktopGutter};}else{style={zIndex:10,position:'fixed',right:Spacing.desktopKeylineIncrement,top:componentTheme.toolbar.height-componentTheme.floatingActionButton.buttonSize/2};}return style;}},{key:'render',value:function render(){var courseChosen=Object.keys(this.state.selectedCourses).length>0,studentChosen=Object.keys(this.state.selectedStudents).length>0,groupChosen=Object.keys(this.state.selectedGroups).length>0,inviteesAdded=this.state.invitees.length>0,accessTime=this.state.accessTime,endTime=this.state.endTime,courseChoiceStep=this.createCourseChoice(courseChosen),studentChoiceStep=this.createStudentChoice(studentChosen||groupChosen||inviteesAdded),accessTimeStep=this.createAccessTime((studentChosen||inviteesAdded)&&accessTime||groupChosen&&endTime,studentChosen||inviteesAdded),summaryStep=this.createSummary();var floatingActionButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["FloatingActionButton"],{style:this.getFloatingActionButtonStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__["HardwareKeyboardArrowRight"],null));var sendButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["FloatingActionButton"],{backgroundColor:Colors.green[500].material,style:this.getFloatingActionButtonStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__["ActionDoneAll"],null));var wizard=void 0;if(this.state.step===0){wizard=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:Spacing.desktopGutterMore+'px auto',width:Spacing.desktopKeylineIncrement*12}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.context.getIntlMessage('invite.success')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui__["RaisedButton"],{fullWidth:true,secondary:true,label:this.context.getIntlMessage('invite.inviteMore'),onTouchTap:this.restart.bind(this)}));}else{wizard=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Wizard__["a" /* Wizard */],{ref:'wizard',onFinalize:this.finalize.bind(this),nextButton:floatingActionButton,finalButton:sendButton},courseChoiceStep,studentChoiceStep,accessTimeStep,summaryStep);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_RulerBar__["a" /* default */],{title:this.context.getIntlMessage('Invite')})},wizard);}}]);return InviteWizard;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_1_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));InviteWizard.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (InviteWizard);

/***/ }),
/* 2191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wizard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WizardStep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Colors=__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */],Text=__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["b" /* Text */];var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={root:{position:'relative',margin:'auto',width:Spacing.desktopKeylineIncrement*12},titles:{padding:Spacing.desktopGutterMini,textAlign:'center'},avatar:{width:24,height:24,lineHeight:'24px',color:__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,fontWeight:700,fontSize:'24px'}};var Wizard=function(_Component){_inherits(Wizard,_Component);function Wizard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Wizard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Wizard.__proto__||Object.getPrototypeOf(Wizard)).call.apply(_ref,[this].concat(args))),_this),_this.state={step:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Wizard,[{key:'gotoStep',value:function gotoStep(step,enabled){if(enabled){this.setState({step:step});}}},{key:'next',value:function next(){if(this.state.step<this.props.children.length){this.setState({step:this.state.step+1});}}},{key:'finalize',value:function finalize(){if(this.props.onFinalize){this.props.onFinalize();}}},{key:'getStepButtonStyle',value:function getStepButtonStyle(){var completed=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var enabled=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var bgColor={material:Colors.darkBondiBlue,text:'Light'},borderColor=Colors.grey[600],enabledBgColor=Colors.coursio[500],enabledBorderColor=Colors.grey[600],textColor=Text[bgColor.text].text,enabledTextColor=Text[enabledBgColor.text].text,inactiveBgColor=Colors.grey[500],inactiveBorderColor=Colors.grey[300],inactiveTextColor=Text[inactiveBgColor.text].text;return{transition:'all 0.5s linear',display:'inline-block',height:Spacing.iconSize*2,width:Spacing.iconSize*2,lineHeight:Spacing.iconSize*2+'px',borderRadius:Spacing.desktopToolbarHeight/2,backgroundColor:completed?bgColor.material:enabled?enabledBgColor.material:inactiveBgColor.material,color:completed?textColor.material:enabled?enabledTextColor.material:inactiveTextColor.material,borderColor:completed?borderColor.material:enabled?enabledBorderColor.material:inactiveBorderColor.material,borderWidth:1,borderStyle:'solid',verticalAlign:'middle'};}},{key:'reset',value:function reset(){this.setState({step:0});}},{key:'getSeperatorStyle',value:function getSeperatorStyle(){var completed=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var bgColor=Colors.darkBondiBlue,inactiveBgColor=Colors.grey[500].material;return{transition:'all 0.5s linear',display:'inline-block',height:Spacing.desktopGutterMini,width:Spacing.desktopGutter*2,marginLeft:-Spacing.desktopGutterMini,marginRight:-Spacing.desktopGutterMini,backgroundColor:completed?bgColor:inactiveBgColor,verticalAlign:'middle'};}},{key:'render',value:function render(){var _this2=this;var titles=[],activeStep=void 0,stepCount=this.props.children.length,previousCompleted=true,currentStepCompleted=false,nextButton=void 0;__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(this.props.children,function(child,index){var completed=child.props.completed,currentStep=index===_this2.state.step,enabled=false;enabled=previousCompleted;var icon=child.props.icon;titles.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{key:index,style:_this2.getStepButtonStyle(completed,!completed&&previousCompleted),tooltipPosition:'bottom-center',tooltip:child.props.title,onTouchTap:_this2.gotoStep.bind(_this2,index,enabled||completed)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WizardButton,null,icon)));if(index<stepCount-1){titles.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'s-'+index,style:_this2.getSeperatorStyle(completed)}));}if(currentStep){if(completed||index===stepCount-1){currentStepCompleted=true;}activeStep=child;}previousCompleted=completed;});if(this.state.step===stepCount-1){nextButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.finalButton,{onTouchTap:this.finalize.bind(this)});}else{nextButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.nextButton,{onTouchTap:this.next.bind(this),disabled:!currentStepCompleted});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_ScrollableContainer__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.titles},titles)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.root},activeStep)),nextButton);}}]);return Wizard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Wizard.displayName='Wizard';Wizard.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};var WizardStep=function(_Component2){_inherits(WizardStep,_Component2);function WizardStep(){_classCallCheck(this,WizardStep);return _possibleConstructorReturn(this,(WizardStep.__proto__||Object.getPrototypeOf(WizardStep)).apply(this,arguments));}_createClass(WizardStep,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.children);}}]);return WizardStep;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);WizardStep.displayName='WizardStep';var WizardButton=function(_Component3){_inherits(WizardButton,_Component3);function WizardButton(){_classCallCheck(this,WizardButton);return _possibleConstructorReturn(this,(WizardButton.__proto__||Object.getPrototypeOf(WizardButton)).apply(this,arguments));}_createClass(WizardButton,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.avatar},this.props.children);}}]);return WizardButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 2192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_Notification__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_NotificationDetail__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores_NotificationDetail__ = __webpack_require__(2193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_stores_App__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_ListDetail__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Material_ListItem__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Icons__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_selectors_notificationDetail__ = __webpack_require__(2195);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Transitions=__WEBPACK_IMPORTED_MODULE_13_material_ui__["Styles"].Transitions,Colors=__WEBPACK_IMPORTED_MODULE_13_material_ui__["Styles"].Colors;var notificationIcons={};notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_ADDED_TO_CIRCLE]='ModuleDiscussion';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_TASK_FEEDBACK]='ModuleTask';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_DRIP_CONTENT]='ModuleTask';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_POST_ADDED]='ModuleDiscussion';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_TASK_ASSESSED]='ModuleTask';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_YOU_MENTIONED]='ModuleDiscussion';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_FEEDBACK_REQUIRED]='ModuleInteraction';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_UNREVIEWED_TASKS]='ModuleTask';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_THREAD_NEW_POSTS]='ModuleDiscussion';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_COURSE_NEW_POSTS]='ModuleDiscussion';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_COURSE_SOLD]='ModuleDiscussion';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_COURSE_PACKAGE_SOLD]='ModuleDiscussion';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_ADDED_TO_COURSE]='ModuleDiscussion';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_DATA_EXPORT]='ModuleDiscussion';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_COURSE_INVITE]='ModuleDiscussion';notificationIcons[__WEBPACK_IMPORTED_MODULE_12_Constants__["NOTIFICATIONS"].NOTIFICATION_BROADCAST]='ModuleDiscussion';var Communication=function(_mixin){_inherits(Communication,_mixin);function Communication(){_classCallCheck(this,Communication);var _this=_possibleConstructorReturn(this,(Communication.__proto__||Object.getPrototypeOf(Communication)).apply(this,arguments));_initialiseProps.call(_this);var types={};types[-1]=true;_this.state={filter:{},page:0,types:types};return _this;}_createClass(Communication,[{key:'listenToStores',value:function listenToStores(){var _this2=this;this.listenToStore(__WEBPACK_IMPORTED_MODULE_7_stores_App__["a" /* default */],'app');this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_6_stores_NotificationDetail__["a" /* default */],function(state){return Object.assign({notificationsLoading:state.notifications.loading,notificationsPrevDisabled:state.notifications.pageStart<1,notificationsNextDisabled:false,pageStartNotifications:state.notifications.pageStart,pageLengthNotifications:state.notifications.pageLength,notifications:Object(__WEBPACK_IMPORTED_MODULE_14_selectors_notificationDetail__["a" /* getNotifications */])(state)},_this2.mapActions({prevNotifications:__WEBPACK_IMPORTED_MODULE_5_actions_NotificationDetail__["a" /* default */].prevNotifications,nextNotifications:__WEBPACK_IMPORTED_MODULE_5_actions_NotificationDetail__["a" /* default */].nextNotifications}));});}},{key:'componentDidMount',value:function componentDidMount(){if(_get(Communication.prototype.__proto__||Object.getPrototypeOf(Communication.prototype),'componentDidMount',this)){_get(Communication.prototype.__proto__||Object.getPrototypeOf(Communication.prototype),'componentDidMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_5_actions_NotificationDetail__["a" /* default */].read(false);// NotificationActions.read();
this.filter({payload:'all',types:[-1],text:'New'});}},{key:'sayHi',value:function sayHi(message){}},{key:'getItemStyle',value:function getItemStyle(){var style={};return style;}},{key:'render',value:function render(){var _this3=this;var filterFunc=void 0,detail=void 0;var _state=this.state,types=_state.types,filter=_state.filter;var _state2=this.state,notifications=_state2.notifications,notificationsLoading=_state2.notificationsLoading,prevNotifications=_state2.prevNotifications,nextNotifications=_state2.nextNotifications,notificationsPrevDisabled=_state2.notificationsPrevDisabled,notificationsNextDisabled=_state2.notificationsNextDisabled,pageStartNotifications=_state2.pageStartNotifications,pageLengthNotifications=_state2.pageLengthNotifications;filterFunc=function filterFunc(item,searchText,labelProperty){var filtered=void 0;if(_this3.state.filter.payload==='task'){filtered=[2,4,6,7].includes(item.type);}else if(_this3.state.filter.payload==='discussion'){filtered=[3,5,8,9].includes(item.type);}else if(_this3.state.filter.payload==='archive'&&item.isRead){filtered=true;}else if(_this3.state.filter.payload==='all'&&!item.isRead){filtered=true;}else{filtered=[10,11].includes(item.type);}if(searchText!==null){return filtered&&item[labelProperty].toUpperCase().search(searchText)>-1;}else{return filtered;}};var newNotifications=notifications.filter(function(el){return el.isRead===0;});var pagination=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui__["RaisedButton"],{secondary:true,disabled:pageStartNotifications<2,onClick:__WEBPACK_IMPORTED_MODULE_5_actions_NotificationDetail__["a" /* default */].prevNotifications,label:'back'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui__["RaisedButton"],{secondary:true,disabled:filter.text==='New'?newNotifications.length<__WEBPACK_IMPORTED_MODULE_12_Constants__["notificationPageLength"]:notifications.length<__WEBPACK_IMPORTED_MODULE_12_Constants__["notificationPageLength"],onClick:__WEBPACK_IMPORTED_MODULE_5_actions_NotificationDetail__["a" /* default */].nextNotifications,label:'next'}));return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_RulerBar__["a" /* default */],{title:this.context.getIntlMessage('menu.Notification')})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_ListDetail__["a" /* default */],{pagination:!notificationsLoading&&pagination,filter:filterFunc,filtering:filter,containerStyle:{bottom:'75px'},types:types,divider:false,listItemGenerator:this.createListItem,dangerouslySetInnerHTML:true,onFilterChange:this.filter,items:notifications,labelProperty:'message',filterOptions:this.props.filter,loading:notificationsLoading,prevDisabled:notificationsPrevDisabled,nextDisabled:notificationsNextDisabled,prev:prevNotifications,next:nextNotifications,pageStartNotifications:pageStartNotifications,pageLengthNotifications:pageLengthNotifications},detail));}}]);return Communication;}(Object(__WEBPACK_IMPORTED_MODULE_8_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_8_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_8_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));Communication.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_1_react__["PropTypes"].func};Communication.defaultProps={filter:[{payload:'all',types:[-1],text:'New'},{payload:'task',types:[2,4,6,7],text:'Tasks'},{payload:'discussion',types:[3,5,8,9],text:'Discussions'},{payload:'sales',types:[10,11],text:'Sales'},{payload:'archive',types:[-1],text:'Archive'}]};var _initialiseProps=function _initialiseProps(){var _this4=this;this.filter=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(filter){var types;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:types={};filter.types.forEach(function(type){types[type]=true;});if(!(_this4.state.filter.payload==='archive'||filter.payload==='archive')){_context.next=8;break;}_context.next=5;return __WEBPACK_IMPORTED_MODULE_5_actions_NotificationDetail__["a" /* default */].read(true);case 5:_this4.setState({types:types,filter:filter});_context.next=9;break;case 8:_this4.setState({types:types,filter:filter});case 9:case'end':return _context.stop();}}},_callee,_this4);}));return function(_x){return _ref.apply(this,arguments);};}();this.markRead=function(item){__WEBPACK_IMPORTED_MODULE_4_actions_Notification__["a" /* default */].markRead([item.id]);};this.createListItem=function(item,leftAvatar,insetChildren){var filter=_this4.state.filter;var style=_this4.getItemStyle();if(_this4.state.selected&&item.id===_this4.state.selected.id){//style.backgroundColor = this.context.muiTheme.rawTheme.palette.primary3Color;
style.backgroundColor=Colors.Colors.grey[300].material;}var filterPayload=_this4.state.filter.payload||'';var TypeIcon=__WEBPACK_IMPORTED_MODULE_11_components_Icons__[notificationIcons[item.type]];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_ListItem__["a" /* default */],{key:item.id,payload:filterPayload,item:item,filter:filter,leftIcon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TypeIcon,null),dangerouslySetInnerHTML:{__html:item.message},onNavigateTouchTap:_this4.markRead});};this.prev=function(){_this4.setState({page:_this4.state.page-1});__WEBPACK_IMPORTED_MODULE_5_actions_NotificationDetail__["a" /* default */].read(_this4.state.page);};this.next=function(){_this4.setState({page:_this4.state.page+1});__WEBPACK_IMPORTED_MODULE_5_actions_NotificationDetail__["a" /* default */].read(_this4.state.page);};};/* harmony default export */ __webpack_exports__["a"] = (Communication);

/***/ }),
/* 2193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reflux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reflux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions_NotificationDetail__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_normalizr__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_normalizr__);
// import { normalize, Schema, arrayOf } from 'normalizr';
var notification=new __WEBPACK_IMPORTED_MODULE_4_normalizr__["Schema"]('notification');var NotificationDetailStore=__WEBPACK_IMPORTED_MODULE_0_reflux___default.a.createStore({listenables:[__WEBPACK_IMPORTED_MODULE_1_actions_NotificationDetail__["a" /* default */]],data:{notifications:{pageStart:0,pageLength:__WEBPACK_IMPORTED_MODULE_3_Constants__["notificationPageLength"],loading:true},list:{notifications:[]},entities:{notification:{}}},getInitialState:function getInitialState(){return this.data;},read:function read(includedRead){var pageStart=this.data.notifications.pageStart;this.getNotificationsAtPage(pageStart,includedRead);},getNotificationsAtPage:function getNotificationsAtPage(pageStart,includedRead){var _this=this;var pageLength=this.data.notifications.pageLength;if(pageStart+pageLength<this.data.list.notifications.length){this.data=Object.assign({},this.data,{notifications:Object.assign({},this.data.notifications,{pageStart:pageStart})});this.trigger(this.data);return;}this.data=Object.assign({},this.data,{notifications:Object.assign({},this.data.notifications,{loading:true})});this.trigger(this.data);return __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].request('notifications','read',{reversed:false,includeRead:includedRead,types:[]},pageStart,pageLength).then(function(response){var data=Object(__WEBPACK_IMPORTED_MODULE_4_normalizr__["normalize"])(response,Object(__WEBPACK_IMPORTED_MODULE_4_normalizr__["arrayOf"])(notification));var entities=_this.data.entities;var notifications=pageStart===1?data.result:_this.data.list.notifications.concat(data.result);_this.data=Object.assign({},_this.data,{notifications:Object.assign({},_this.data.notifications,{pageStart:pageStart,loading:false}),entities:Object.assign({},entities,{notification:Object.assign({},entities.notification,data.entities.notification)}),list:Object.assign({},_this.data.list,{notifications:notifications})});_this.trigger(_this.data);});},nextNotifications:function nextNotifications(){this.getNotificationsAtPage(this.data.notifications.pageStart+this.data.notifications.pageLength);},prevNotifications:function prevNotifications(){if(this.data.notifications.pageStart>=this.data.notifications.pageLength){this.getNotificationsAtPage(this.data.notifications.pageStart-this.data.notifications.pageLength);}}});/* harmony default export */ __webpack_exports__["a"] = (NotificationDetailStore);

/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_lib_styles_transitions__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_lib_styles_transitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_lib_styles_transitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_formatDate__ = __webpack_require__(584);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*global require*/var Spacing=__WEBPACK_IMPORTED_MODULE_5_material_ui__["Styles"].Spacing;var iconSize=Spacing.iconSize*2;var fontSize=16;var styles={root:{display:'block',fontSize:fontSize,lineHeight:fontSize+'px',position:'relative',transition:__WEBPACK_IMPORTED_MODULE_1_material_ui_lib_styles_transitions___default.a.easeOut(),padding:(iconSize-fontSize)/2+Spacing.desktopGutterMini/2,borderStyle:'solid none none none',borderWidth:1,borderColor:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["b" /* Text */].Dark.divider},label:{paddingLeft:iconSize+Spacing.desktopGutterMini,paddingRight:iconSize+Spacing.desktopGutterMini*28},mouseOver:{backgroundColor:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["a" /* Colors */].grey[300].material},navigateButton:{position:'absolute',right:0,top:0,bottom:0,borderStyle:'none none none solid',borderWidth:1,borderColor:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["b" /* Text */].Dark.divider,padding:Spacing.desktopGutterMini/2+'px 0',backgroundColor:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["c" /* Theme */].Light.background},leftIcon:{position:'absolute',left:Spacing.desktopGutterMini/2,top:0,bottom:0,padding:Spacing.desktopGutterMini/2+'px 0'},icon:{width:iconSize,height:iconSize},date:{position:'absolute',right:'100px',top:'20px',fontSize:'12px'},date2:{position:'absolute',right:'20px',top:'20px',fontSize:'12px'}};var ListItem=function(_Component){_inherits(ListItem,_Component);function ListItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ListItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ListItem.__proto__||Object.getPrototypeOf(ListItem)).call.apply(_ref,[this].concat(args))),_this),_this.state={mosueOver:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ListItem,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!__WEBPACK_IMPORTED_MODULE_2_shallowequal___default()(this.props,nextProps)||!__WEBPACK_IMPORTED_MODULE_2_shallowequal___default()(this.state,nextState);}},{key:'getStyle',value:function getStyle(){return Object.assign({},styles.root,this.state.mouseOver?styles.mouseOver:null);}},{key:'getLabelStyle',value:function getLabelStyle(){return Object.assign({},styles.label);}},{key:'handleMouseEnter',value:function handleMouseEnter(){this.setState({mouseOver:true});}},{key:'handleMouseLeave',value:function handleMouseLeave(){this.setState({mouseOver:false});}},{key:'handleTouchTap',value:function handleTouchTap(item){if(this.props.onTouchTap){this.props.onTouchTap(item);}}},{key:'handleLeftIconTouchTap',value:function handleLeftIconTouchTap(item,event){event.stopPropagation();if(this.props.onLeftIconTouchTap){this.props.onLeftIconTouchTap(item);}}},{key:'handleNavigateTouchTap',value:function handleNavigateTouchTap(item,event){event.stopPropagation();if(this.props.onNavigateTouchTap){this.props.onNavigateTouchTap(item);}}},{key:'render',value:function render(){var _props=this.props,item=_props.item,children=_props.children,other=_objectWithoutProperties(_props,['item','children']);var icon=void 0,xIcon=void 0;var date=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_formatDate__["a" /* formatDate */])(item.created);if(this.props.leftIcon){icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.leftIcon,{color:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["b" /* Text */].Dark.secondary,hoverColor:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["b" /* Text */].Dark.text,style:styles.icon});}if(this.props.payload==='archive'){xIcon=null;}else{xIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["IconButton"],{tooltip:this.context.getIntlMessage('item.read'),tooltipPosition:'top-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["NavigationCheck"],{color:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["b" /* Text */].Dark.secondary,hoverColor:__WEBPACK_IMPORTED_MODULE_4_components_Material_Styles_Colors__["b" /* Text */].Dark.text,style:styles.icon})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getStyle(),onMouseEnter:this.handleMouseEnter.bind(this),onMouseLeave:this.handleMouseLeave.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},other,{style:this.getLabelStyle(),onTouchTap:this.handleTouchTap.bind(this,item)})),children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.props.payload==='archive'?styles.date2:styles.date},date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.leftIcon,onTouchTap:this.handleLeftIconTouchTap.bind(this,item)},icon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.navigateButton,onTouchTap:this.handleNavigateTouchTap.bind(this,item)},xIcon));}}]);return ListItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ListItem.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (ListItem);

/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNotifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var makeGetNotifications=function makeGetNotifications(){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return state.entities.notification;},function(state){return state.list.notifications;},function(state){return state.notifications.pageStart;},function(state){return state.notifications.pageLength;},function(notifications,list,pageStart,pageLength){return list.slice(pageStart,pageStart+pageLength).map(function(notificationId){return notifications[notificationId];});});};var getNotifications=makeGetNotifications();

/***/ }),
/* 2196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_StoreBar__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Store_StoreLayout__ = __webpack_require__(2197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Store_Editor_StoreLayoutOverview__ = __webpack_require__(2221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Store_Editor_StoreModuleMenu__ = __webpack_require__(2295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Tasks_ScrollableContainer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_helmet__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_selectors_store__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StoreContainer=function(_mixin){_inherits(StoreContainer,_mixin);function StoreContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreContainer.__proto__||Object.getPrototypeOf(StoreContainer)).call.apply(_ref,[this].concat(args))),_this),_this.getStoreItem=function(storeItem){var type=storeItem.type,slug=storeItem.slug;var store=_this.state.store;if(type===1){__WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* history */].push('/store/'+store+'/'+slug);}else{__WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* history */].push('/store/package/'+store+'/'+slug);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreContainer,[{key:'componentDidMount',value:function componentDidMount(){var params=this.props.params;var _state=this.state,store=_state.store,username=_state.username;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].read(params.store||store||username);// CategoryActions.initCategories();
__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].clearSelected();}},{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["t" /* StoreOverviewStore */],function(state){var items=Object(__WEBPACK_IMPORTED_MODULE_12_selectors_store__["i" /* getVisibleStoreItems */])(state);var storeItems=Object(__WEBPACK_IMPORTED_MODULE_12_selectors_store__["h" /* getStoreItems */])(state);return{ownerName:state.owner.name,userLocale:state.owner.locale,store:state.name,mode:state.mode,storeItems:storeItems,items:items,coverUrl:state.presentation.coverUrl,name:state.presentation.text,searchText:state.filter.searchText,moduleMenu:state.moduleMenu,dialogMode:state.dialogMode,selectedModule:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_store__["f" /* getSelectedModule */])(state),selectedSection:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_store__["g" /* getSelectedSection */])(state),canIEdit:state.canIEdit,layout:Object(__WEBPACK_IMPORTED_MODULE_12_selectors_store__["c" /* getLayout */])(state),themeColor:state.theme.color,logoUrl:state.theme.logoUrl,canUndo:state.layoutHistory.length>0,loading:state.loading&&items.length<1};});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["d" /* CategoryStore */],function(state){return{categories:state.list};});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["b" /* AuthStore */],function(state){return{username:state.username,features:state.features};});}},{key:'render',value:function render(){var _state2=this.state,store=_state2.store,canUndo=_state2.canUndo,ownerName=_state2.ownerName,userLocale=_state2.userLocale,selectedSection=_state2.selectedSection,selectedModule=_state2.selectedModule,layout=_state2.layout,themeColor=_state2.themeColor,logoUrl=_state2.logoUrl,items=_state2.items,storeItems=_state2.storeItems,loading=_state2.loading,canIEdit=_state2.canIEdit,moduleMenu=_state2.moduleMenu,categories=_state2.categories,searchText=_state2.searchText,features=_state2.features,name=_state2.name,coverUrl=_state2.coverUrl,mode=_state2.mode;if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_Loader__["b" /* default */],null);}var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_StoreBar__["a" /* default */],{mode:mode,canIEdit:canIEdit&&features&&features.enterpriseStore,logo:logoUrl,title:this.context.getIntlMessage('menu.Store')});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Tasks_ScrollableContainer__["a" /* default */],{header:toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Store_StoreLayout__["a" /* default */],{canIEdit:canIEdit,selectedModule:selectedModule,selectedSection:selectedSection,ownerName:ownerName,userLocale:userLocale,mode:mode,store:store,storeName:store,themeColor:themeColor,items:items,searchText:searchText,storeItems:storeItems,layout:layout,history:__WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* history */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Store_Editor_StoreLayoutOverview__["a" /* default */],{canIEdit:canIEdit,categories:categories,canUndo:canUndo,width:selectedModule?780:390,layout:layout,selectedSection:selectedSection,selectedModule:selectedModule,open:mode==='editor'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Store_Editor_StoreModuleMenu__["a" /* default */],{open:moduleMenu}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_helmet___default.a,{meta:[{name:'twitter:card',content:"summary_large_image"},{name:'twitter:image',content:coverUrl||'https://res.cloudinary.com/teamtailor/image/upload/c_limit,dpr_2.0,f_auto,h_65,q_80,w_200/v1476197337/divchtdesiriwvpnri3e.png'},{name:'og:url',content:window.location.href},{name:'og:title',content:ownerName},{name:'og:image',content:coverUrl||'https://res.cloudinary.com/teamtailor/image/upload/c_limit,dpr_2.0,f_auto,h_65,q_80,w_200/v1476197337/divchtdesiriwvpnri3e.png'}],title:ownerName}));}}]);return StoreContainer;}(Object(__WEBPACK_IMPORTED_MODULE_9_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_9_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));StoreContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,params:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};StoreContainer.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreContainer);

/***/ }),
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StoreSection__ = __webpack_require__(2198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StoreEditor__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Dialog__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_CoursioLogo__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_Store_PurchaseDialog__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_Store_GiftDialog__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shallowequal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_shallowequal__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_eI',copyright:'_eJ',coursioLogoContainer:'_eK'};var StoreLayout=function(_Component){_inherits(StoreLayout,_Component);function StoreLayout(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreLayout);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreLayout.__proto__||Object.getPrototypeOf(StoreLayout)).call.apply(_ref,[this].concat(args))),_this),_this.selectSection=function(section){if(_this.props.mode==='editor'){__WEBPACK_IMPORTED_MODULE_3_actions__["A" /* StoreOverviewActions */].selectSection(section.id);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreLayout,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!__WEBPACK_IMPORTED_MODULE_10_shallowequal___default()(this.props,nextProps);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,layout=_props.layout,selectedSection=_props.selectedSection,ownerName=_props.ownerName,storeName=_props.storeName,userLocale=_props.userLocale,history=_props.history,other=_objectWithoutProperties(_props,['layout','selectedSection','ownerName','storeName','userLocale','history']);var getIntlMessage=this.context.getIntlMessage;var sections=layout.sections;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Dialog__["b" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},sections.map(function(section){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StoreEditor__["a" /* default */],{onTouchTap:_this2.selectSection.bind(_this2,section),mark:false,key:section.id,selected:selectedSection&&selectedSection.id===section.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StoreSection__["a" /* default */],Object.assign({ownerName:ownerName},section,other)));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.copyright},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"],{message:getIntlMessage('copyright'),year:new Date().getFullYear(),name:ownerName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.coursioLogoContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CoursioLogo__["a" /* default */],{initialFill:__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].material.grey[400].hex,size:100,width:'48px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["FormattedMessage"],{message:getIntlMessage('poweredBy'),engine:'Coursio'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_containers_Store_GiftDialog__["a" /* default */],null));}}]);return StoreLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreLayout.propTypes={layout:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,mode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,searchText:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,selectedSection:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,ownerName:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};StoreLayout.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreLayout);

/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StoreEditor__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modules__ = __webpack_require__(2200);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_fy',banner:'_fz',wrapper:'_fA',size2:'_fB',size3:'_fC',size4:'_fD',size5:'_fE',default:'_fF'};var StoreSection=function(_Component){_inherits(StoreSection,_Component);function StoreSection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreSection.__proto__||Object.getPrototypeOf(StoreSection)).call.apply(_ref,[this].concat(args))),_this),_this.selectModule=function(module,event){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].selectModule(module.id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreSection,[{key:'render',value:function render(){var _this2=this;var _props=this.props,type=_props.type,modules=_props.modules,selectedModule=_props.selectedModule,mode=_props.mode,other=_objectWithoutProperties(_props,['type','modules','selectedModule','mode']);var classes=__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.root,css[type]);var size=modules.length>1?modules.length:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},modules.map(function(module){var moduleType=module.type,moduleProps=_objectWithoutProperties(module,['type']);var wrapperClass=__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.wrapper,_defineProperty({},css['size'+size],size));if(__WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* default */][moduleType]){var SpecializedModule=__WEBPACK_IMPORTED_MODULE_4__Modules__["a" /* default */][moduleType];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:wrapperClass,key:module.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StoreEditor__["a" /* default */],{selected:selectedModule&&selectedModule.id===module.id,onTouchTap:_this2.selectModule.bind(_this2,module),mark:mode==='editor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpecializedModule,Object.assign({},other,moduleProps))));}return null;}));}}]);return StoreSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreSection.propTypes={type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOf(['banner','default']),selectedModule:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,modules:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,mode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};StoreSection.defaultProps={type:'default',modules:[]};/* harmony default export */ __webpack_exports__["a"] = (StoreSection);

/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_ga',selected:'_gb',left:'_gc',right:'_gd',top:'_ge',bottom:'_gf',cornerTopLeft:'_gg',cornerTopRight:'_gh',cornerBottomLeft:'_gi',cornerBottomRight:'_gj'};var SelectedMarker=function(_Component){_inherits(SelectedMarker,_Component);function SelectedMarker(){_classCallCheck(this,SelectedMarker);return _possibleConstructorReturn(this,(SelectedMarker.__proto__||Object.getPrototypeOf(SelectedMarker)).apply(this,arguments));}_createClass(SelectedMarker,[{key:'render',value:function render(){var selected=this.props.selected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.root,_defineProperty({},css.selected,selected))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.left}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.right}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.top}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.bottom}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.cornerTopLeft}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.cornerTopRight}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.cornerBottomLeft}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.cornerBottomRight}));}}]);return SelectedMarker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectedMarker.propTypes={selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (SelectedMarker);

/***/ }),
/* 2200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StoreBannerModule__ = __webpack_require__(2201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StoreVideoModule__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StoreImageModule__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StoreListModule__ = __webpack_require__(2204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoreTextModule__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StoreFilterModule__ = __webpack_require__(2209);
/* harmony default export */ __webpack_exports__["a"] = ({Banner:__WEBPACK_IMPORTED_MODULE_0__StoreBannerModule__["a" /* default */],Video:__WEBPACK_IMPORTED_MODULE_1__StoreVideoModule__["a" /* default */],Image:__WEBPACK_IMPORTED_MODULE_2__StoreImageModule__["a" /* default */],List:__WEBPACK_IMPORTED_MODULE_3__StoreListModule__["a" /* default */],Text:__WEBPACK_IMPORTED_MODULE_4__StoreTextModule__["a" /* default */],Filter:__WEBPACK_IMPORTED_MODULE_5__StoreFilterModule__["a" /* default */]});

/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export colors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var colors={creen:{r:26,g:188,b:156},green:{r:39,g:174,b:96},blue:{r:52,g:152,b:219},blue2:{r:41,g:128,b:185},purple:{r:155,g:89,b:182},navyblue:{r:52,g:73,b:94},gray:{r:127,g:140,b:141},red:{r:192,g:57,b:43},lightgreen:{r:102,g:215,b:119},teal:{r:1,g:150,b:149},mustard:{r:146,g:144,b:25},darkblue:{r:16,g:84,b:147},golden:{r:209,g:206,b:98},mango:{r:249,g:195,b:50},pinktaco:{r:238,g:124,b:182},pinkster:{r:241,g:141,b:139},orange:{r:243,g:147,b:49},love:{r:168,g:51,b:81},purplehaze:{r:128,g:44,b:106},raspberry:{r:237,g:76,b:124},white:{r:255,g:255,b:255},black:{r:0,g:0,b:0}};var css={root:'_h-',size1:'_ia',size2:'_ib',size3:'_ic',overlay:'_id',headerWrapper:'_ie',header:'_if',centerCenter:'_ig',leftCenter:'_ih',rightCenter:'_ii',topLeft:'_ij',topCenter:'_ik',topRight:'_il',bottomLeft:'_im',bottomCenter:'_in',bottomRight:'_io'};var StoreBannerModule=function(_Component){_inherits(StoreBannerModule,_Component);function StoreBannerModule(){_classCallCheck(this,StoreBannerModule);return _possibleConstructorReturn(this,(StoreBannerModule.__proto__||Object.getPrototypeOf(StoreBannerModule)).apply(this,arguments));}_createClass(StoreBannerModule,[{key:'render',value:function render(){var _props=this.props,src=_props.src,size=_props.size,opacity=_props.opacity,header=_props.header,color=_props.color,backgroundColor=_props.backgroundColor,headerPosition=_props.headerPosition;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.root,css['size'+size],css[headerPosition]),style:{color:color,backgroundImage:'url('+src+')'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.overlay,style:{backgroundColor:backgroundColor,opacity:opacity}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.headerWrapper},!header.includes('<h1>null</h1>')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header,dangerouslySetInnerHTML:{__html:header}})));}}]);return StoreBannerModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreBannerModule.propTypes={src:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,opacity:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,backgroundColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,header:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,headerPosition:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};StoreBannerModule.defaultProps={size:1,opacity:0.25,color:'#FFFFFF',backgroundColor:'#000000',headerPosition:'centerCenter'};/* harmony default export */ __webpack_exports__["a"] = (StoreBannerModule);

/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StoreVideoPlayer__ = __webpack_require__(611);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StoreVideoModule=function(_Component){_inherits(StoreVideoModule,_Component);function StoreVideoModule(){_classCallCheck(this,StoreVideoModule);return _possibleConstructorReturn(this,(StoreVideoModule.__proto__||Object.getPrototypeOf(StoreVideoModule)).apply(this,arguments));}_createClass(StoreVideoModule,[{key:'render',value:function render(){var _props=this.props,embedUrl=_props.embedUrl,caption=_props.caption;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StoreVideoPlayer__["a" /* default */],{src:embedUrl,caption:caption});}}]);return StoreVideoModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreVideoModule.propTypes={embedUrl:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,caption:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (StoreVideoModule);

/***/ }),
/* 2203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_ip',image:'_iq',caption:'_ir'};var StoreImageModule=function(_Component){_inherits(StoreImageModule,_Component);function StoreImageModule(){_classCallCheck(this,StoreImageModule);return _possibleConstructorReturn(this,(StoreImageModule.__proto__||Object.getPrototypeOf(StoreImageModule)).apply(this,arguments));}_createClass(StoreImageModule,[{key:'render',value:function render(){var _props=this.props,src=_props.src,caption=_props.caption;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:css.image,src:src}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{className:css.caption},caption));}}]);return StoreImageModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreImageModule.propTypes={src:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,caption:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (StoreImageModule);

/***/ }),
/* 2204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Store_StoreList__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Store_StoreGrid__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Store_StoreCards__ = __webpack_require__(2206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_Store_StoreFilter__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_store__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StoreListModule=function(_Component){_inherits(StoreListModule,_Component);function StoreListModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreListModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreListModule.__proto__||Object.getPrototypeOf(StoreListModule)).call.apply(_ref,[this].concat(args))),_this),_this.gotoItem=function(item){var type=item.type;var store=_this.props.store;if(type===2){__WEBPACK_IMPORTED_MODULE_6_helpers__["a" /* history */].push('/store/package/'+store+'/'+item.slug);}else{__WEBPACK_IMPORTED_MODULE_6_helpers__["a" /* history */].push('/store/'+store+'/'+item.slug);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreListModule,[{key:'render',value:function render(){var _props=this.props,themeColor=_props.themeColor,storeItems=_props.storeItems,filter=_props.filter,items=_props.items,store=_props.store,searchText=_props.searchText,canIEdit=_props.canIEdit,other=_objectWithoutProperties(_props,['themeColor','storeItems','filter','items','store','searchText','canIEdit']);var mode=this.props.mode||'grid';var tags=filter&&filter.tags||{};var hasFilter=filter&&(filter.categoryId||Object.keys(tags).some(function(tag){return tags[tag];}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,mode==='list'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Store_StoreList__["a" /* default */],Object.assign({onTouchTapItem:this.gotoItem,themeColor:themeColor,displayFilter:!!filter,canIEdit:canIEdit,items:hasFilter?Object(__WEBPACK_IMPORTED_MODULE_5_selectors_store__["b" /* getFilteredStoreItems */])(storeItems,Object.assign({},filter,{searchText:searchText})):items,username:store},other)),mode==='grid'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Store_StoreGrid__["a" /* default */],Object.assign({onTouchTapItem:this.gotoItem,themeColor:themeColor,displayFilter:!!filter,canIEdit:canIEdit,items:hasFilter?Object(__WEBPACK_IMPORTED_MODULE_5_selectors_store__["b" /* getFilteredStoreItems */])(storeItems,Object.assign({},filter,{searchText:searchText})):items,username:store},other)),mode==='cards'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Store_StoreCards__["a" /* default */],Object.assign({onTouchTapItem:this.gotoItem,themeColor:themeColor,displayFilter:!!filter,canIEdit:canIEdit,items:hasFilter?Object(__WEBPACK_IMPORTED_MODULE_5_selectors_store__["b" /* getFilteredStoreItems */])(storeItems,Object.assign({},filter,{searchText:searchText})):items,username:store},other)));}}]);return StoreListModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreListModule.propTypes={store:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,storeItems:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,filter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,themeColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,mode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,canIEdit:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,searchText:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};StoreListModule.contextTypes={router:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (StoreListModule);

/***/ }),
/* 2205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_Cover__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Tags__ = __webpack_require__(98);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_jn',detail:'_jo',price:'_jp',tags:'_jq',header:'_jr',description:'_js',container:'_jt',itemWrapper:'_ju',buyButton:'_jv',giftButton:'_jw',packBadge:'_jx',publicIcon:'_jy'};var StoreGrid=function(_Component){_inherits(StoreGrid,_Component);function StoreGrid(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreGrid);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreGrid.__proto__||Object.getPrototypeOf(StoreGrid)).call.apply(_ref,[this].concat(args))),_this),_this.onTouchTap=function(storeItem){var onTouchTapItem=_this.props.onTouchTapItem;if(onTouchTapItem){onTouchTapItem(storeItem);}else{var type=storeItem.type,slug=storeItem.slug;__WEBPACK_IMPORTED_MODULE_3_actions__["A" /* StoreOverviewActions */].findBySlug(type,slug);}},_this.buyItem=function(storeItem,event){__WEBPACK_IMPORTED_MODULE_3_actions__["A" /* StoreOverviewActions */].addToCart(storeItem);event.preventDefault();event.stopPropagation();},_this.giftItem=function(storeItem,event){__WEBPACK_IMPORTED_MODULE_3_actions__["A" /* StoreOverviewActions */].addToCart(storeItem,true);event.preventDefault();event.stopPropagation();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreGrid,[{key:'render',value:function render(){var _this2=this;var _props=this.props,items=_props.items,canIEdit=_props.canIEdit,themeColor=_props.themeColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},items.map(function(storeItem){var price=storeItem.price,currency=storeItem.currency,type=storeItem.type,id=storeItem.id,name=storeItem.name,isPublic=storeItem.public;var coverImages=storeItem.coverImage;var coverImage=coverImages.length&&coverImages.length>0&&coverImages[0]||{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.itemWrapper,key:storeItem.type+'-'+id,onTouchTap:_this2.onTouchTap.bind(_this2,storeItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_Cover__["a" /* default */],{backgroundColor:!canIEdit&&__WEBPACK_IMPORTED_MODULE_2_stores__["z" /* ThemeStore */].getColor(themeColor,0.5)||'rgba(0, 0, 0, 0.5)',image:coverImage.id&&coverImage.url}),canIEdit&&isPublic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.publicIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ImageRemoveRedEye"],{color:'green',style:{width:32,height:32}})):null,type===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Paper"],{className:css.packBadge,style:{backgroundColor:__WEBPACK_IMPORTED_MODULE_2_stores__["z" /* ThemeStore */].getColor(themeColor)}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ActionViewModule"],{color:__WEBPACK_IMPORTED_MODULE_7_Css__["Colors"].fullWhite}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"],{message:_this2.context.getIntlMessage('store.packOf'),count:storeItem.courses.length})),isPublic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:_this2.buyItem.bind(_this2,storeItem),className:css.buyButton},_this2.context.getIntlMessage('store.joinCourse')):null,isPublic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:_this2.giftItem.bind(_this2,storeItem),className:css.giftButton},_this2.context.getIntlMessage('store.giftCourse')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.detail},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.description,dangerouslySetInnerHTML:{__html:storeItem.description}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.tags},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Tags__["a" /* TagList */],{tags:storeItem.tagsMap})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.price},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedNumber"],{style:'currency',currency:currency,value:Math.round(price.discounted)})));}));}}]);return StoreGrid;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreGrid.propTypes={username:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,canIEdit:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,themeColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onTouchTapItem:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,cart:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};StoreGrid.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreGrid);

/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_Cover__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Tags__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Cio_Assets_Gift__ = __webpack_require__(613);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_jz',detail:'_jA',price:'_jB',tags:'_jC',header:'_jD',author:'_jE',description:'_jF',container:'_jG',itemWrapper:'_jH',buyButton:'_jI',giftButton:'_jJ',buttonWrapper:'_jK',giftButtonWrapper:'_jL',packBadge:'_jM',publicIcon:'_jN',buttonContainer:'_jO',giftIcon:'_jP'};var StoreCards=function(_Component){_inherits(StoreCards,_Component);function StoreCards(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreCards);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreCards.__proto__||Object.getPrototypeOf(StoreCards)).call.apply(_ref,[this].concat(args))),_this),_this.onTouchTap=function(storeItem){var onTouchTapItem=_this.props.onTouchTapItem;if(onTouchTapItem){onTouchTapItem(storeItem);}else{var type=storeItem.type,slug=storeItem.slug;__WEBPACK_IMPORTED_MODULE_3_actions__["A" /* StoreOverviewActions */].findBySlug(type,slug);}},_this.buyItem=function(storeItem,event){__WEBPACK_IMPORTED_MODULE_3_actions__["A" /* StoreOverviewActions */].addToCart(storeItem);event.preventDefault();event.stopPropagation();},_this.giftItem=function(storeItem,event){__WEBPACK_IMPORTED_MODULE_3_actions__["A" /* StoreOverviewActions */].addToCart(storeItem,true);event.preventDefault();event.stopPropagation();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreCards,[{key:'render',value:function render(){var _this2=this;var _props=this.props,items=_props.items,canIEdit=_props.canIEdit,themeColor=_props.themeColor,ownerName=_props.ownerName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},items.map(function(storeItem){var price=storeItem.price,currency=storeItem.currency,type=storeItem.type,id=storeItem.id,name=storeItem.name,isPublic=storeItem.public;var coverImages=storeItem.coverImage;var coverImage=coverImages.length&&coverImages.length>0&&coverImages[0]||{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.itemWrapper,key:storeItem.type+'-'+id,onTouchTap:_this2.onTouchTap.bind(_this2,storeItem)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_Cover__["a" /* default */],{height:240,backgroundColor:!canIEdit&&__WEBPACK_IMPORTED_MODULE_2_stores__["z" /* ThemeStore */].getColor(themeColor,0.5)||'rgba(0, 0, 0, 0.5)',image:coverImage.id&&coverImage.url}),type===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Paper"],{className:css.packBadge,style:{backgroundColor:__WEBPACK_IMPORTED_MODULE_2_stores__["z" /* ThemeStore */].getColor(themeColor)}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ActionViewModule"],{color:__WEBPACK_IMPORTED_MODULE_7_Css__["Colors"].fullWhite}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"],{message:_this2.context.getIntlMessage('store.packOf'),count:storeItem.courses.length})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.detail},canIEdit&&isPublic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.publicIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ImageRemoveRedEye"],{color:'green',style:{width:32,height:32}})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.author},ownerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.description,dangerouslySetInnerHTML:{__html:storeItem.description}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.tags},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Tags__["a" /* TagList */],{tags:storeItem.tagsMap})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonContainer},isPublic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:_this2.buyItem.bind(_this2,storeItem),className:css.buyButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"],{message:_this2.context.getIntlMessage('store.buyFor'),price:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedNumber"],{style:'currency',currency:currency,maximumFractionDigits:0,minimumFractionDigits:0,value:Math.round(price.discounted)})}))):null,isPublic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.giftButtonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:_this2.giftItem.bind(_this2,storeItem),className:css.giftButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Cio_Assets_Gift__["a" /* default */],{className:css.giftIcon}),' ',_this2.context.getIntlMessage('store.giftCourse'))):null));}));}}]);return StoreCards;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreCards.propTypes={username:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,items:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,canIEdit:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,themeColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onTouchTapItem:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,cart:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};StoreCards.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreCards);

/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Tags__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_DropDown__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Store_StoreList__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_selectors_store__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={container:'_kc',half:'_kd',searchBarContainer:'_ke',searchBar:'_kf',fullWidth:'_kg',input:'_kh',inputWrapper:'_ki'};var StoreFilter=function(_Component){_inherits(StoreFilter,_Component);function StoreFilter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreFilter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreFilter.__proto__||Object.getPrototypeOf(StoreFilter)).call.apply(_ref,[this].concat(args))),_this),_this.setCategory=function(event,foo,category){var categoryId=category.categoryId;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].setFilterCategory(categoryId);},_this.addTag=function(tagName){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].setFilterTag(tagName);},_this.removeTag=function(tagName){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].setFilterTag(tagName,false);},_this.handleCategoryChange=function(categoryId){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].setFilterCategory(categoryId);},_this.handleSearchTextChagne=function(event){var searchText=event.target.value;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].setSearchText(searchText);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreFilter,[{key:'render',value:function render(){var getIntlMessage=this.context.getIntlMessage;var _props=this.props,themeColor=_props.themeColor,storeItems=_props.storeItems,categories=_props.categories,filter=_props.filter,items=_props.items,store=_props.store;var tags=filter.tags,categoryId=filter.categoryId,searchText=filter.searchText;var menuItems=[{payload:null,label:getIntlMessage('store.chooseCategory')}].concat(_toConsumableArray(categories.map(function(category){return{payload:category.slug,label:category.label};})));var hasSearchText=searchText&&searchText.trim()!=='';var placeholderText=typeof placeholder==='undefined'?getIntlMessage('Search'):placeholder;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.searchBarContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.searchBar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.inputWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:css.input,type:'text',placeholder:placeholderText,onChange:this.handleSearchTextChagne})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.half},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Category'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_DropDown__["a" /* DropDown */],{fullWidth:true,onChange:this.handleCategoryChange,options:menuItems,selected:categoryId})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.half},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,getIntlMessage('Tags')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Tags__["b" /* TagSelector */],{fullWidth:true,tags:tags,onAddTag:this.addTag,onRemoveTag:this.removeTag}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Store_StoreList__["a" /* default */],{onTouchTapItem:this.gotoItem,themeColor:themeColor,displayFilter:false,items:hasSearchText?Object(__WEBPACK_IMPORTED_MODULE_5_selectors_store__["d" /* getSearchedStoreItems */])(storeItems,filter):[],username:store}));}}]);return StoreFilter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreFilter.propTypes={categories:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,filter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};StoreFilter.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreFilter);

/***/ }),
/* 2208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_it',size1:'_iu',size2:'_iv',size3:'_iw'};var StoreTextModule=function(_Component){_inherits(StoreTextModule,_Component);function StoreTextModule(){_classCallCheck(this,StoreTextModule);return _possibleConstructorReturn(this,(StoreTextModule.__proto__||Object.getPrototypeOf(StoreTextModule)).apply(this,arguments));}_createClass(StoreTextModule,[{key:'render',value:function render(){var _props=this.props,__html=_props.__html,color=_props.color,backgroundColor=_props.backgroundColor,size=_props.size;var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.root,_defineProperty({},css['size'+size],size));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes,style:{color:color,backgroundColor:backgroundColor},dangerouslySetInnerHTML:{__html:__html}});}}]);return StoreTextModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreTextModule.propTypes={color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,backgroundColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,__html:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (StoreTextModule);

/***/ }),
/* 2209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_containers_Store_StoreFilter__ = __webpack_require__(614);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_is'};var StoreFilterModule=function(_Component){_inherits(StoreFilterModule,_Component);function StoreFilterModule(){_classCallCheck(this,StoreFilterModule);return _possibleConstructorReturn(this,(StoreFilterModule.__proto__||Object.getPrototypeOf(StoreFilterModule)).apply(this,arguments));}_createClass(StoreFilterModule,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_containers_Store_StoreFilter__["a" /* default */],this.props));}}]);return StoreFilterModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (StoreFilterModule);

/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Store_PurchaseDialog__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_RegisterForm__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TaC_StoreTaC__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_selectors_store__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PurchaseDialogContainer=function(_mixin){_inherits(PurchaseDialogContainer,_mixin);function PurchaseDialogContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PurchaseDialogContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PurchaseDialogContainer.__proto__||Object.getPrototypeOf(PurchaseDialogContainer)).call.apply(_ref,[this].concat(args))),_this),_this.state={tac:false},_this.clearCart=function(){__WEBPACK_IMPORTED_MODULE_3_actions__["A" /* StoreOverviewActions */].clearCart();},_this.closeTac=function(){_this.setState({tac:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PurchaseDialogContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_2_stores__["b" /* AuthStore */],'auth');this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["t" /* StoreOverviewStore */],function(state){var cart=Object(__WEBPACK_IMPORTED_MODULE_9_selectors_store__["a" /* getCart */])(state);return{cart:cart,isGift:Object(__WEBPACK_IMPORTED_MODULE_9_selectors_store__["j" /* isGift */])(state),activeDiscountCount:state.activeDiscountCount,paymentCompleted:state.payment.completed,open:cart.length>0&&!Object(__WEBPACK_IMPORTED_MODULE_9_selectors_store__["j" /* isGift */])(state),method:state.payment.method,countryCode:state.countryCode,allowedPaymentProviders:state.allowedPaymentProviders};});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["b" /* AuthStore */],function(state){return{loggedIn:state.loggedIn};});}},{key:'render',value:function render(){var _this2=this;var _state=this.state,loggedIn=_state.loggedIn,isGift=_state.isGift,cart=_state.cart,tac=_state.tac;var _props=this.props,userName=_props.userName,userLocale=_props.userLocale,router=_props.router;if(cart.length<1||isGift){return null;}if(tac){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_TaC_StoreTaC__["a" /* default */],{username:userName,open:tac,onRequestClose:this.closeTac});}if(!loggedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_FullScreenDialog__["a" /* default */],Object.assign({},this.props,{open:true,padded:true,toolbar:true,onRequestClose:this.clearCart}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_RegisterForm__["a" /* default */],{userName:userName,userLocale:userLocale,router:router,onTac:function onTac(){return _this2.setState({tac:true});}}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Store_PurchaseDialog__["a" /* default */],Object.assign({},this.state,this.props,{onRequestClose:this.clearCart}));}}]);return PurchaseDialogContainer;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* unused harmony default export */ var _unused_webpack_default_export = (PurchaseDialogContainer);

/***/ }),
/* 2211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_MediaQuery__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var phoneWidth=5;var width=12;var styles={root:{margin:'auto',padding:0,height:36,whiteSpace:'nowrap',position:'relative',backgroundColor:'transparent'},inputContainer:{display:'inline-block',left:36,right:0,top:0,bottom:0},input:{border:'none',outline:'none',background:'transparent',width:'100%',padding:'0 '+Spacing.desktopGutterMini+'px',verticalAlign:'top',lineHeight:36+'px',height:36,textAlign:'left',boxSizing:'border-box'},button:{verticalAlign:'top',display:'inline-block',margin:0,border:'none',height:36,left:0,top:0,padding:(36-Spacing.iconSize)/2,lineHeight:36+'px',backgroundColor:'#00A1A3'},activateCode:{fontSize:14,position:'relative',top:-8,left:-6,display:'inline-block',paddingLeft:14,fontWeight:'bold'},navigationCheck:{marginRight:4}};var ESC=27;var ENTER=13;var DiscountField=function(_mixin){_inherits(DiscountField,_mixin);function DiscountField(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DiscountField);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DiscountField.__proto__||Object.getPrototypeOf(DiscountField)).call.apply(_ref,[this].concat(args))),_this),_this.state={mode:'edit',discountCode:''},_this.editMode=function(){if(_this.state.mode!=='edit'){_this.setState({mode:'edit'});_this._timer=setTimeout(function(){_this.refs.input.focus();_this.refs.input.select();_this._timer=null;},250);}},_this.setCode=function(){var onChange=_this.props.onChange;var discountCode=_this.refs.input.value.trim();if(discountCode.length===0){return;}_this.setState({mode:'display'});__WEBPACK_IMPORTED_MODULE_3_actions__["A" /* StoreOverviewActions */].setDiscountCode(discountCode);onChange&&onChange(discountCode);},_this.getCheckButtonStyle=function(isEmptyDiscountCode){return Object.assign({},styles.button,{width:__WEBPACK_IMPORTED_MODULE_6_services_MediaQuery__["a" /* default */].phone()?'40%':'30%',backgroundColor:isEmptyDiscountCode?'#3c9798':'#00a1a3',color:isEmptyDiscountCode?__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].lightWhite:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite});},_this.handleKey=function(event){var discountCode=_this.refs.input.value.trim();_this.setState({discountCode:discountCode});var keyCode=event.keyCode;if(keyCode===ESC){_this.setState({mode:'display'});}else if(keyCode==ENTER){_this.setCode();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DiscountField,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["t" /* StoreOverviewStore */],function(state){return{discountCode:state.discountCode};});}},{key:'componentWillUnmount',value:function componentWillUnmount(){_get(DiscountField.prototype.__proto__||Object.getPrototypeOf(DiscountField.prototype),'componentWillUnmount',this).call(this);if(this._timer){clearTimeout(this._timer);}}},{key:'getStyle',value:function getStyle(){var style=Object.assign({},styles.root);if(this.props.fullWidth){style.display='block';}else{style.display='inline-block';if(this.context.media==='phone'){style.width=Spacing.desktopKeylineIncrement*phoneWidth;}else{style.width=Spacing.desktopKeylineIncrement*width;}}return style;}},{key:'getInputStyle',value:function getInputStyle(edit){return Object.assign({},styles.input,{color:edit?__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullBlack:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,cursor:'pointer'});}},{key:'getInputContainerStyle',value:function getInputContainerStyle(display){return Object.assign({},styles.inputContainer,{backgroundColor:display?'rgba(0, 0, 0, 0.2)':'rgba(255, 255, 255, 0.9)',right:display?0:36,width:__WEBPACK_IMPORTED_MODULE_6_services_MediaQuery__["a" /* default */].phone()?display?'90%':'50%':display?'92%':'62%'});}},{key:'getButtonStyle',value:function getButtonStyle(){return Object.assign({},styles.button,{width:__WEBPACK_IMPORTED_MODULE_6_services_MediaQuery__["a" /* default */].phone()?'10%':'8%'});}},{key:'render',value:function render(){var _state=this.state,mode=_state.mode,discountCode=_state.discountCode;var display=mode==='display';var isEmptyDiscountCode=!discountCode||discountCode.trim().length===0;var code=void 0;if(display){var displayCode=discountCode&&this.context.getIntlMessage('discount.code')+' : '+discountCode||this.context.getIntlMessage('discount.code');code=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:this.editMode,style:this.getInputStyle(false)},displayCode);}else{code=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onKeyUp:this.handleKey,defaultValue:discountCode,ref:'input',style:this.getInputStyle(true),type:'text',placeholder:this.context.getIntlMessage('discount.code')});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Paper"],{style:this.getStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{style:this.getButtonStyle(),onTouchTap:this.editMode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ActionCardGiftcard"],{color:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,hoverColor:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].lightWhite})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getInputContainerStyle(display)},code),mode==='edit'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{style:this.getCheckButtonStyle(isEmptyDiscountCode),onTouchTap:this.setCode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["NavigationCheck"],{style:styles.navigationCheck,color:isEmptyDiscountCode?__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].lightWhite:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].fullWhite}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.activateCode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.context.getIntlMessage('discount.activate')))));}}]);return DiscountField;}(Object(__WEBPACK_IMPORTED_MODULE_7_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_7_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));DiscountField.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};DiscountField.contextTypes={media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};DiscountField.defaultProps={fullWidth:false};/* harmony default export */ __webpack_exports__["a"] = (DiscountField);

/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Visa=function(_Component){_inherits(Visa,_Component);function Visa(){_classCallCheck(this,Visa);return _possibleConstructorReturn(this,(Visa.__proto__||Object.getPrototypeOf(Visa)).apply(this,arguments));}_createClass(Visa,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",width:"32",height:"22",viewBox:"0 0 32 22",version:"1.1"},this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#FFFFFF",transform:"translate(16.000000, 11.000000) scale(1, -1) translate(-16.000000, -11.000000) ",x:"0",y:"4",width:"32",height:"14"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(4.000000, 7.000000)",fill:"#1A1F71"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M8.42 7.23L9.54 0.15 11.33 0.15 10.21 7.23 8.42 7.23"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M16.71 0.33C16.35 0.19 15.8 0.03 15.1 0.03 13.33 0.03 12.09 0.99 12.07 2.37 12.06 3.39 12.96 3.95 13.64 4.29 14.34 4.64 14.58 4.86 14.57 5.17 14.57 5.65 14.02 5.86 13.5 5.86 12.78 5.86 12.4 5.75 11.81 5.49L11.58 5.38 11.33 6.96C11.75 7.16 12.52 7.33 13.33 7.34 15.21 7.34 16.43 6.39 16.45 4.92 16.45 4.12 15.98 3.5 14.94 3 14.32 2.67 13.93 2.45 13.94 2.12 13.94 1.83 14.26 1.51 14.96 1.51 15.55 1.5 15.97 1.64 16.3 1.78L16.47 1.86 16.71 0.33"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M21.3 0.16L19.92 0.16C19.49 0.16 19.17 0.29 18.98 0.75L16.32 7.24 18.2 7.24C18.2 7.24 18.51 6.37 18.58 6.17 18.78 6.17 20.61 6.18 20.87 6.18 20.92 6.42 21.09 7.24 21.09 7.24L22.75 7.24 21.3 0.16 21.3 0.16ZM19.09 4.73C19.24 4.32 19.81 2.75 19.81 2.75 19.8 2.76 19.95 2.34 20.04 2.07L20.16 2.68C20.16 2.68 20.51 4.37 20.58 4.73L19.09 4.73 19.09 4.73Z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M4.85 3.85L5.04 4.83 6.79 0 8.69 0 5.87 7.07 3.97 7.07 2.38 0.92C1.83 0.6 1.2 0.33 0.5 0.15L0.52 0 3.41 0C3.8 0.02 4.12 0.15 4.22 0.6L4.85 3.85Z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 4L32 4 32 1.01C32 0.44 31.56 0 31.01 0L0.99 0C0.45 0 0 0.45 0 1.01L0 4Z",fill:"#1A1F71"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 17.86L0 17.86 0 20.85C0 21.41 0.44 21.86 0.99 21.86L31.01 21.86C31.55 21.86 32 21.41 32 20.85L32 17.86 0 17.86Z",fill:"#F7B600"})));}}]);return Visa;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Visa.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (Visa);

/***/ }),
/* 2213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MasterCard=function(_Component){_inherits(MasterCard,_Component);function MasterCard(){_classCallCheck(this,MasterCard);return _possibleConstructorReturn(this,(MasterCard.__proto__||Object.getPrototypeOf(MasterCard)).apply(this,arguments));}_createClass(MasterCard,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",width:"35",height:"22",viewBox:"0 0 35 22",version:"1.1"},this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"path-1",x:"0",y:"0",width:"35",height:"22",rx:"2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"path-1",x:"0",y:"0",width:"35",height:"22",rx:"2",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(5.000000, 3.000000)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0.000000, 0.500000)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12.59 13.05C13.91 14.26 15.65 14.99 17.56 14.99 21.64 14.99 24.95 11.64 24.95 7.5 24.95 3.36 21.64 0.01 17.56 0.01 15.65 0.01 13.91 0.74 12.59 1.95 11.1 3.32 10.16 5.3 10.16 7.5 10.16 9.7 11.1 11.68 12.59 13.05",fill:"#F8971D"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#F8971D"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M14.98 6.71C14.95 6.44 14.91 6.17 14.86 5.91L10.33 5.91C10.39 5.64 10.46 5.38 10.54 5.12L14.64 5.12C14.55 4.85 14.45 4.58 14.33 4.33L10.86 4.33C10.98 4.05 11.13 3.79 11.29 3.53L13.9 3.53C13.73 3.26 13.54 2.99 13.34 2.74L11.85 2.74C12.08 2.46 12.33 2.19 12.59 1.95 11.28 0.74 9.54 0.01 7.63 0.01 3.55 0.01 0.24 3.36 0.24 7.5 0.24 11.64 3.55 14.99 7.63 14.99 9.54 14.99 11.28 14.26 12.59 13.05 12.86 12.81 13.11 12.54 13.34 12.26L11.85 12.26C11.64 12.01 11.46 11.74 11.29 11.47L13.9 11.47C14.06 11.21 14.2 10.95 14.33 10.67L10.86 10.67C10.74 10.42 10.63 10.15 10.54 9.88L14.64 9.88C14.73 9.62 14.8 9.36 14.86 9.09 14.91 8.83 14.95 8.56 14.98 8.29 15.01 8.03 15.02 7.77 15.02 7.5 15.02 7.23 15.01 6.97 14.98 6.71",fill:"#CA1F27"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M10.08 9.66C9.83 9.73 9.66 9.76 9.48 9.76 9.1 9.76 8.87 9.52 8.87 9.09 8.87 9 8.88 8.91 8.89 8.81L8.94 8.51 8.98 8.26 9.33 6.15 10.1 6.15 10 6.61 10.49 6.61 10.37 7.39 9.89 7.39 9.68 8.65C9.67 8.71 9.67 8.75 9.67 8.78 9.67 8.94 9.75 9.01 9.94 9.01 10.03 9.01 10.1 9 10.19 8.98L10.08 9.66",fill:"#221F5F"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12.56 9.63C12.28 9.72 12.02 9.76 11.74 9.76 10.88 9.76 10.37 9.28 10.37 8.38 10.37 7.32 10.97 6.53 11.77 6.53 12.43 6.53 12.86 6.97 12.86 7.66 12.86 7.88 12.83 8.11 12.76 8.42L11.16 8.42C11.16 8.47 11.15 8.49 11.15 8.52 11.15 8.88 11.39 9.06 11.86 9.06 12.15 9.06 12.4 9 12.69 8.86L12.56 9.63M12.08 7.8C12.08 7.73 12.09 7.68 12.09 7.64 12.09 7.39 11.95 7.24 11.71 7.24 11.45 7.24 11.27 7.44 11.2 7.79L12.08 7.8",fill:"#221F5F"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M3.95 9.7L3.15 9.7 3.61 6.78 2.58 9.7 2.04 9.7 1.97 6.8 1.49 9.7 0.71 9.7 1.33 5.9 2.49 5.9 2.52 8.25 3.3 5.9 4.57 5.9 3.95 9.7",fill:"#221F5F"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M5.88 8.33C5.8 8.31 5.78 8.31 5.72 8.31 5.27 8.31 5.04 8.49 5.04 8.78 5.04 8.97 5.15 9.1 5.33 9.1 5.71 9.1 5.87 8.78 5.88 8.33M6.52 9.7L5.82 9.7 5.84 9.38C5.66 9.62 5.42 9.75 4.99 9.75 4.61 9.75 4.28 9.41 4.28 8.91 4.28 8.76 4.31 8.63 4.34 8.51 4.47 8.03 4.94 7.73 5.67 7.72 5.76 7.72 5.9 7.72 6.02 7.73 6.05 7.63 6.06 7.59 6.06 7.53 6.06 7.33 5.89 7.26 5.51 7.26 5.29 7.26 5.03 7.3 4.85 7.36L4.74 7.39 4.69 7.4 4.8 6.71C5.18 6.59 5.44 6.54 5.74 6.54 6.43 6.54 6.79 6.86 6.79 7.45 6.79 7.6 6.81 7.72 6.75 8.06L6.59 9.16 6.56 9.35 6.54 9.51 6.52 9.62 6.52 9.7",fill:"#221F5F"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M16.42 6.64C16.64 6.64 16.85 6.7 17.14 6.85L17.27 6.02C17.2 5.99 17.18 5.98 17.07 5.95L16.74 5.86C16.64 5.84 16.52 5.82 16.38 5.82 15.99 5.82 15.75 5.83 15.51 5.98 15.38 6.06 15.22 6.17 15.03 6.38L14.94 6.35 14.12 6.94 14.16 6.61 13.31 6.61 12.82 9.7 13.62 9.7 13.92 8.04C13.92 8.04 14.03 7.81 14.08 7.74 14.23 7.54 14.36 7.54 14.53 7.54 14.55 7.54 14.58 7.54 14.59 7.54 14.56 7.72 14.55 7.92 14.55 8.13 14.55 9.14 15.12 9.77 15.98 9.77 16.2 9.77 16.39 9.74 16.69 9.66L16.83 8.79C16.56 8.93 16.35 8.99 16.15 8.99 15.68 8.99 15.4 8.64 15.4 8.06 15.4 7.23 15.82 6.64 16.42 6.64",fill:"#221F5F"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M23.2 5.9L23.02 6.99C22.83 6.69 22.6 6.55 22.29 6.55 21.87 6.55 21.48 6.8 21.24 7.25L21.24 7.25 20.73 6.94 20.77 6.61 19.92 6.61 19.43 9.7 20.23 9.7 20.5 8.04C20.5 8.04 20.7 7.81 20.75 7.74 20.87 7.58 21 7.55 21.11 7.54 21.02 7.8 20.96 8.11 20.96 8.46 20.96 9.23 21.36 9.74 21.95 9.74 22.24 9.74 22.47 9.64 22.69 9.4L22.65 9.7 23.41 9.7 24.02 5.9 23.2 5.9M22.22 8.97C21.95 8.97 21.81 8.77 21.81 8.36 21.81 7.76 22.07 7.33 22.43 7.33 22.71 7.33 22.86 7.54 22.86 7.93 22.86 8.55 22.6 8.97 22.22 8.97",fill:"#221F5F"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M18.53 8.33C18.44 8.31 18.43 8.31 18.37 8.31 17.91 8.31 17.68 8.49 17.68 8.78 17.68 8.97 17.8 9.1 17.97 9.1 18.36 9.1 18.51 8.78 18.53 8.33M19.16 9.7L18.47 9.7 18.48 9.38C18.31 9.62 18.07 9.75 17.64 9.75 17.25 9.75 16.9 9.42 16.9 8.91 16.91 8.17 17.45 7.72 18.32 7.72 18.41 7.72 18.55 7.72 18.67 7.73 18.69 7.63 18.7 7.59 18.7 7.53 18.7 7.33 18.54 7.26 18.16 7.26 17.93 7.26 17.68 7.3 17.5 7.36L17.38 7.39 17.34 7.4 17.45 6.71C17.82 6.59 18.09 6.54 18.38 6.54 19.07 6.54 19.44 6.86 19.44 7.45 19.44 7.6 19.45 7.72 19.4 8.06L19.23 9.16 19.2 9.35 19.18 9.51 19.17 9.62 19.16 9.7",fill:"#221F5F"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M8.19 7.27C8.35 7.27 8.56 7.29 8.79 7.32L8.91 6.61C8.67 6.57 8.37 6.54 8.19 6.54 7.29 6.54 7 7.03 7 7.6 7 7.97 7.17 8.24 7.6 8.44 7.92 8.6 7.98 8.63 7.98 8.77 7.98 8.96 7.81 9.07 7.49 9.07 7.25 9.07 7.03 9.03 6.78 8.95L6.68 9.66 6.7 9.66 6.85 9.69C6.89 9.7 6.97 9.71 7.06 9.72 7.25 9.74 7.41 9.75 7.51 9.75 8.4 9.75 8.77 9.4 8.77 8.72 8.77 8.3 8.57 8.05 8.17 7.86 7.84 7.7 7.79 7.68 7.8 7.54 7.8 7.4 7.94 7.27 8.19 7.27",fill:"#221F5F"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M17.48 5.78L17.35 6.61C17.07 6.46 16.86 6.4 16.64 6.4 16.04 6.4 15.62 6.99 15.62 7.82 15.62 8.4 15.9 8.75 16.37 8.75 16.56 8.75 16.78 8.69 17.05 8.55L16.91 9.42C16.61 9.5 16.42 9.53 16.2 9.53 15.33 9.53 14.79 8.9 14.79 7.89 14.79 6.53 15.54 5.58 16.6 5.58 16.74 5.58 16.86 5.6 16.96 5.62L17.29 5.71C17.39 5.74 17.41 5.75 17.48 5.78",fill:"#FFFFFF"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M14.91 6.35C14.88 6.34 14.86 6.34 14.83 6.34 14.56 6.34 14.41 6.48 14.17 6.84L14.24 6.37 13.51 6.37 13.02 9.46 13.83 9.46C14.11 7.57 14.19 7.25 14.57 7.25 14.6 7.25 14.6 7.25 14.63 7.25 14.7 6.88 14.8 6.6 14.94 6.35L14.91 6.35",fill:"#FFFFFF"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M10.28 9.42C10.06 9.49 9.89 9.52 9.71 9.52 9.3 9.52 9.07 9.29 9.07 8.85 9.07 8.76 9.08 8.67 9.1 8.57L9.15 8.27 9.18 8.02 9.53 5.91 10.33 5.91 10.24 6.37 10.65 6.37 10.54 7.12 10.12 7.12 9.91 8.41C9.9 8.47 9.9 8.51 9.9 8.54 9.9 8.7 9.98 8.77 10.17 8.77 10.27 8.77 10.34 8.76 10.39 8.74L10.28 9.42",fill:"#FFFFFF"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M7.2 7.35C7.2 7.74 7.39 8.01 7.81 8.21 8.14 8.37 8.19 8.41 8.19 8.55 8.19 8.74 8.04 8.83 7.73 8.83 7.49 8.83 7.26 8.79 7.01 8.71L6.9 9.42 6.93 9.43 7.08 9.46C7.13 9.47 7.2 9.48 7.29 9.49 7.48 9.5 7.63 9.51 7.73 9.51 8.58 9.51 8.97 9.19 8.97 8.48 8.97 8.06 8.8 7.81 8.4 7.62 8.07 7.46 8.03 7.43 8.03 7.29 8.03 7.12 8.16 7.03 8.42 7.03 8.58 7.03 8.79 7.05 9 7.08L9.11 6.36C8.9 6.33 8.59 6.3 8.4 6.3 7.51 6.3 7.2 6.78 7.2 7.35",fill:"#FFFFFF"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M23.61 9.46L22.85 9.46 22.89 9.16C22.67 9.4 22.44 9.5 22.15 9.5 21.57 9.5 21.18 8.99 21.18 8.22 21.18 7.19 21.78 6.32 22.49 6.32 22.8 6.32 23.04 6.46 23.26 6.75L23.43 5.66 24.22 5.66 23.61 9.46M22.43 8.74C22.8 8.74 23.07 8.31 23.07 7.69 23.07 7.3 22.92 7.09 22.64 7.09 22.27 7.09 22.02 7.52 22.02 8.13 22.02 8.53 22.15 8.74 22.43 8.74",fill:"#FFFFFF"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12.74 9.4C12.46 9.48 12.19 9.52 11.91 9.52 11.02 9.52 10.55 9.05 10.55 8.14 10.55 7.08 11.14 6.3 11.95 6.3 12.61 6.3 13.03 6.73 13.03 7.42 13.03 7.65 13 7.87 12.93 8.18L11.34 8.18C11.33 8.23 11.33 8.25 11.33 8.28 11.33 8.64 11.57 8.82 12.04 8.82 12.32 8.82 12.58 8.76 12.87 8.62L12.74 9.4M12.29 7.56C12.29 7.49 12.29 7.44 12.29 7.4 12.29 7.15 12.15 7 11.91 7 11.66 7 11.48 7.2 11.4 7.56L12.29 7.56",fill:"#FFFFFF"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M4.16 9.46L3.35 9.46 3.81 6.54 2.79 9.46 2.24 9.46 2.17 6.56 1.69 9.46 0.94 9.46 1.57 5.66 2.72 5.66 2.75 8.02 3.53 5.66 4.78 5.66 4.16 9.46",fill:"#FFFFFF"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M6.13 8.09C6.05 8.08 6.01 8.07 5.95 8.07 5.5 8.07 5.27 8.23 5.27 8.54 5.27 8.74 5.38 8.86 5.56 8.86 5.88 8.86 6.12 8.54 6.13 8.09M6.72 9.46L6.05 9.46 6.07 9.14C5.87 9.4 5.59 9.52 5.23 9.52 4.79 9.52 4.49 9.17 4.49 8.67 4.49 7.92 5.01 7.48 5.9 7.48 5.99 7.48 6.11 7.49 6.23 7.5 6.26 7.4 6.26 7.36 6.26 7.3 6.26 7.1 6.12 7.02 5.75 7.02 5.52 7.02 5.26 7.06 5.08 7.11L4.97 7.14 4.9 7.16 5.01 6.47C5.41 6.35 5.67 6.3 5.97 6.3 6.66 6.3 7.02 6.62 7.02 7.21 7.02 7.36 7.01 7.48 6.96 7.82L6.79 8.92 6.76 9.11 6.74 9.27 6.73 9.38 6.72 9.46",fill:"#FFFFFF"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M18.78 8.09C18.7 8.08 18.66 8.07 18.6 8.07 18.15 8.07 17.92 8.23 17.92 8.54 17.92 8.74 18.03 8.86 18.2 8.86 18.53 8.86 18.77 8.54 18.78 8.09M19.36 9.46L18.7 9.46 18.71 9.14C18.51 9.4 18.24 9.52 17.87 9.52 17.44 9.52 17.14 9.17 17.14 8.67 17.14 7.92 17.66 7.48 18.55 7.48 18.64 7.48 18.76 7.49 18.88 7.5 18.9 7.4 18.91 7.36 18.91 7.3 18.91 7.1 18.77 7.02 18.39 7.02 18.16 7.02 17.9 7.06 17.73 7.11L17.61 7.14 17.54 7.16 17.65 6.47C18.05 6.35 18.32 6.3 18.61 6.3 19.3 6.3 19.67 6.62 19.67 7.21 19.67 7.36 19.66 7.48 19.6 7.82L19.44 8.92 19.41 9.11 19.37 9.38 19.36 9.46",fill:"#FFFFFF"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M21.52 6.35C21.49 6.34 21.47 6.34 21.44 6.34 21.17 6.34 21.02 6.48 20.78 6.84L20.85 6.37 20.12 6.37 19.63 9.46 20.43 9.46C20.72 7.57 20.8 7.25 21.18 7.25 21.21 7.25 21.21 7.25 21.24 7.25 21.31 6.88 21.41 6.6 21.54 6.35L21.52 6.35",fill:"#FFFFFF"})))));}}]);return MasterCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MasterCard.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (MasterCard);

/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Store_ItemDetails__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_CountdownTimer__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__ = __webpack_require__(7);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isValidSSN=/^\d{6,8}[-|(\s)]{0,1}\d{4}$/;var isValidPhone=/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;var isValidEmail=/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var css={root:'_dN',details:'_dO',method:'_dP',container:'_dQ',flex:'_dR',flexChild:'_dS',courseBought:'_dT',error:'_dU',backButton:'_dV'};var KlarnaOnlineForm=function(_Component){_inherits(KlarnaOnlineForm,_Component);function KlarnaOnlineForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,KlarnaOnlineForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=KlarnaOnlineForm.__proto__||Object.getPrototypeOf(KlarnaOnlineForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={ssnError:null,phoneError:null,emailError:null},_this.requestAddress=function(){var ssn=_this.props.ssn;__WEBPACK_IMPORTED_MODULE_1_actions__["n" /* KlarnaActions */].getAddressesBySsn(ssn);},_this.handlePersonalNumberChange=function(event){var value=event.target.value;var getIntlMessage=_this.context.getIntlMessage;if(value!=''){if(_this.validSSN(value)){_this.setState({ssnError:null});}else{_this.setState({ssnError:getIntlMessage('payment.klarna.personalNumberError')});}}else{_this.setState({ssnError:null});}__WEBPACK_IMPORTED_MODULE_1_actions__["n" /* KlarnaActions */].change({ssn:value});},_this.handleTelephoneNumberChange=function(event){var value=event.target.value;var getIntlMessage=_this.context.getIntlMessage;if(value!=''){if(_this.validPhone(value)){_this.setState({phoneError:null});}else{_this.setState({phoneError:getIntlMessage('payment.klarna.phoneError')});}}else{_this.setState({phoneError:null});}__WEBPACK_IMPORTED_MODULE_1_actions__["n" /* KlarnaActions */].change({phone:value});},_this.handleEmailChange=function(event){var value=event.target.value;var getIntlMessage=_this.context.getIntlMessage;if(value!=''){if(_this.validEmail(value)){_this.setState({emailError:null});}else{_this.setState({emailError:getIntlMessage('payment.klarna.emailError')});}}else{_this.setState({emailError:null});}__WEBPACK_IMPORTED_MODULE_1_actions__["n" /* KlarnaActions */].change({email:value});},_this.changePropertyWithEvent=function(property,event){var value=event.target.value;__WEBPACK_IMPORTED_MODULE_1_actions__["n" /* KlarnaActions */].change(_defineProperty({},property,value));},_this.redirect=function(){if(_this.props.loggedIn){__WEBPACK_IMPORTED_MODULE_7_helpers__["a" /* history */].push('/dashboard');}else{__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].reset();}},_this.completePurchase=function(){var _this$props=_this.props,firstName=_this$props.firstName,lastName=_this$props.lastName,city=_this$props.city,country=_this$props.country,street=_this$props.street,zip=_this$props.zip,phone=_this$props.phone,email=_this$props.email,ssn=_this$props.ssn;var address={ssn:ssn,firstName:firstName,lastName:lastName,city:city,country:country,street:street,zip:zip,phone:phone,email:email};__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].startPayment(__WEBPACK_IMPORTED_MODULE_4_Constants__["default"].paymentProviders.KLARNA,null,null,address);},_this.back=function(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].setPaymentMethod(null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(KlarnaOnlineForm,[{key:'validSSN',value:function validSSN(ssn){return isValidSSN.test(ssn.toLowerCase());}},{key:'validPhone',value:function validPhone(phone){return isValidPhone.test(phone);}},{key:'validEmail',value:function validEmail(email){return isValidEmail.test(email.toLowerCase());}},{key:'change',value:function change(property,value){__WEBPACK_IMPORTED_MODULE_1_actions__["n" /* KlarnaActions */].change(_defineProperty({},property,value));}},{key:'renderChosenMethod',value:function renderChosenMethod(){var method=this.props.method;var getIntlMessage=this.context.getIntlMessage;if(method==='account'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://cdn.klarna.com/1.0/shared/image/generic/logo/sv_se/basic/blue-black.png?width=100'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),getIntlMessage('payment.klarna.account'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://cdn.klarna.com/1.0/shared/image/generic/logo/sv_se/basic/blue-black.png?width=100'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),getIntlMessage('payment.klarna.invoice'));}},{key:'renderDetails',value:function renderDetails(){var _props=this.props,email=_props.email,phone=_props.phone,city=_props.city,country=_props.country,firstName=_props.firstName,lastName=_props.lastName,street=_props.street,zip=_props.zip,paymentLoading=_props.paymentLoading;var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.details},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.method},this.renderChosenMethod()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{floatingLabelText:getIntlMessage('payment.klarna.firstName'),value:firstName,fullWidth:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{floatingLabelText:getIntlMessage('payment.klarna.lastName'),value:lastName,fullWidth:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{hintText:getIntlMessage('payment.klarna.emailFormat'),floatingLabelText:getIntlMessage('payment.klarna.email'),value:email,fullWidth:true,disabled:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{hintText:getIntlMessage('payment.klarna.phoneNumberFormat'),floatingLabelText:getIntlMessage('payment.klarna.phone'),value:phone,fullWidth:true,disabled:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{floatingLabelText:getIntlMessage('payment.klarna.street'),value:street,fullWidth:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{floatingLabelText:getIntlMessage('payment.klarna.zip'),value:zip,fullWidth:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{floatingLabelText:getIntlMessage('payment.klarna.city'),value:city,fullWidth:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{floatingLabelText:getIntlMessage('payment.klarna.country'),value:country,fullWidth:true})),paymentLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_Loader__["b" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["RaisedButton"],{secondary:true,label:getIntlMessage('payment.completePurchase'),onTouchTap:this.completePurchase}));}},{key:'renderPersonNumber',value:function renderPersonNumber(){var _props2=this.props,method=_props2.method,ssn=_props2.ssn,phone=_props2.phone,email=_props2.email,city=_props2.city,country=_props2.country,firstName=_props2.firstName,lastName=_props2.lastName,street=_props2.street,zip=_props2.zip,loading=_props2.loading,other=_objectWithoutProperties(_props2,['method','ssn','phone','email','city','country','firstName','lastName','street','zip','loading']);var getIntlMessage=this.context.getIntlMessage;var _state=this.state,ssnError=_state.ssnError,phoneError=_state.phoneError,emailError=_state.emailError;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.details},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{fullWidth:true,errorText:ssnError,hintText:getIntlMessage('payment.klarna.personalNumberFormat'),value:ssn,floatingLabelText:getIntlMessage('payment.klarna.personalOrganisationalNumber'),floatingLabelStyle:{top:'10px'},onChange:this.handlePersonalNumberChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{fullWidth:true,errorText:phoneError,value:phone,hintText:getIntlMessage('payment.klarna.phoneNumberFormat'),floatingLabelText:getIntlMessage('payment.klarna.phone'),onChange:this.handleTelephoneNumberChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{fullWidth:true,errorText:emailError,value:email,hintText:getIntlMessage('payment.klarna.emailFormat'),floatingLabelText:getIntlMessage('payment.klarna.email'),onChange:this.handleEmailChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["RaisedButton"],{disabled:!ssn||!email||!phone||!!ssnError||!!emailError||!!phoneError,secondary:true,label:getIntlMessage('Continue'),onTouchTap:this.requestAddress})),firstName&&this.renderDetails());}},{key:'render',value:function render(){var _props3=this.props,error=_props3.error,paymentComplete=_props3.paymentComplete,cart=_props3.cart,method=_props3.method,ssn=_props3.ssn,city=_props3.city,country=_props3.country,firstName=_props3.firstName,lastName=_props3.lastName,street=_props3.street,zip=_props3.zip,loading=_props3.loading,other=_objectWithoutProperties(_props3,['error','paymentComplete','cart','method','ssn','city','country','firstName','lastName','street','zip','loading']);var _cart=_slicedToArray(cart,1),item=_cart[0];var detail=void 0;if(loading){detail=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_Loader__["b" /* default */],null);}else{if(error){detail=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.courseBought},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CountdownTimer__["a" /* default */],{seconds:2,color:'#777',alpha:0.3,size:128,onComplete:this.reset}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.error},error));}else if(paymentComplete){detail=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.courseBought},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CountdownTimer__["a" /* default */],{seconds:2,color:'#777',alpha:0.3,size:128,onComplete:this.redirect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.context.getIntlMessage('store.purchaseSuccess'));}else if((method==='account'||method==='invoice')&&!firstName){detail=this.renderPersonNumber();}else if(firstName){detail=this.renderDetails();}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Store_ItemDetails__["a" /* default */],item),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.backButton,onTouchTap:this.back},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationArrowBack"],null),this.context.getIntlMessage('menu.Back')),detail);}}]);return KlarnaOnlineForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);KlarnaOnlineForm.propTypes={ssn:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,phone:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,email:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,firstName:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,lastName:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,city:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,country:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,street:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,zip:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,loading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,item:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,method:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,error:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,paymentComplete:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,paymentLoading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};KlarnaOnlineForm.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,router:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (KlarnaOnlineForm);

/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Store_ItemDetails__ = __webpack_require__(174);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KlarnaCheckoutForm=function(_Component){_inherits(KlarnaCheckoutForm,_Component);function KlarnaCheckoutForm(){_classCallCheck(this,KlarnaCheckoutForm);return _possibleConstructorReturn(this,(KlarnaCheckoutForm.__proto__||Object.getPrototypeOf(KlarnaCheckoutForm)).apply(this,arguments));}_createClass(KlarnaCheckoutForm,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].startPayment(__WEBPACK_IMPORTED_MODULE_2_Constants__["default"].paymentProviders.KLARNACHECKOUT,null,null,null);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.discountCode!==nextProps.discountCode){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].startPayment(__WEBPACK_IMPORTED_MODULE_2_Constants__["default"].paymentProviders.KLARNACHECKOUT,null,null,null);}if(this.props.snippet!==nextProps.snippet){var snippet=nextProps.snippet;var node=this.refs.klarnaShizzle;node.innerHTML=snippet;var klarnaCode=node.getElementsByTagName('script')[0].text;//node.children[0].children[0].text;
var script=document.createElement('script');script.type='text/javascript';try{script.appendChild(document.createTextNode(klarnaCode));}catch(e){script.text=klarnaCode;}node.appendChild(script);}}},{key:'render',value:function render(){var _props=this.props,cart=_props.cart,other=_objectWithoutProperties(_props,['cart']);var _cart=_slicedToArray(cart,1),item=_cart[0];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Store_ItemDetails__["a" /* default */],item),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'klarnaShizzle'}));}}]);return KlarnaCheckoutForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);KlarnaCheckoutForm.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,store:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,cart:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};/* harmony default export */ __webpack_exports__["a"] = (KlarnaCheckoutForm);

/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Store_ItemDetails__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_CountdownTimer__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__ = __webpack_require__(7);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Units=__WEBPACK_IMPORTED_MODULE_6_Css__["default"].Units,Colors=__WEBPACK_IMPORTED_MODULE_6_Css__["default"].Colors;var isValidYear=/^[0-9]{4}$/;var isValidCCNumber=/^[0-9]{16}$/;var isValidMonth=/^[0-9]{2}$/;var isValidCvC=/^[0-9]{3}$/;var css={root:'_dE',details:'_dF',method:'_dG',container:'_dH',flex:'_dI',flexChild:'_dJ',courseBought:'_dK',error:'_dL',secure3DFrame:'_dM'};var StripeCheckoutForm=function(_Component){_inherits(StripeCheckoutForm,_Component);function StripeCheckoutForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StripeCheckoutForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StripeCheckoutForm.__proto__||Object.getPrototypeOf(StripeCheckoutForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={errorText:{}},_this.stripeSecure3DSuccess=function(event){var detail=event.detail;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].completePayment(null,__WEBPACK_IMPORTED_MODULE_4_Constants__["default"].paymentProviders.STRIPE);},_this.redirect=function(){if(_this.props.loggedIn){__WEBPACK_IMPORTED_MODULE_7_helpers__["a" /* history */].push('/dashboard');}else{__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].reset();}},_this.completePurchase=function(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].startPayment(__WEBPACK_IMPORTED_MODULE_4_Constants__["default"].paymentProviders.STRIPE,null,null,null,null);},_this.back=function(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].setPaymentMethod(null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StripeCheckoutForm,[{key:'componentWillMount',value:function componentWillMount(){window.document.addEventListener('stripeSecure3DSuccess',this.stripeSecure3DSuccess,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.document.removeEventListener('stripeSecure3DSuccess',this.stripeSecure3DSuccess);}},{key:'changePropertyWithEvent',value:function changePropertyWithEvent(property,event){var value=event.target.value;__WEBPACK_IMPORTED_MODULE_1_actions__["B" /* StripeActions */].change(_defineProperty({},property,value));__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].clearError();}},{key:'change',value:function change(property,value){__WEBPACK_IMPORTED_MODULE_1_actions__["B" /* StripeActions */].change(_defineProperty({},property,value));__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].clearError();}},{key:'renderForm',value:function renderForm(){var paymentLoading=this.props.paymentLoading;var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.details},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},paymentLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_Loader__["b" /* default */],null),!paymentLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["RaisedButton"],{style:{left:'50%',position:'relative',transform:'translateX(-50%)'},secondary:true,label:getIntlMessage('payment.payWithStripe'),onTouchTap:this.completePurchase})));}},{key:'render',value:function render(){var _props=this.props,error=_props.error,paymentComplete=_props.paymentComplete,cart=_props.cart,loading=_props.loading,other=_objectWithoutProperties(_props,['error','paymentComplete','cart','loading']);var _cart=_slicedToArray(cart,1),item=_cart[0];var detail=void 0;if(loading){detail=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_Loader__["b" /* default */],null);}else{if(paymentComplete){detail=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.courseBought},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CountdownTimer__["a" /* default */],{seconds:2,color:'#777',alpha:0.3,size:128,onComplete:this.redirect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.context.getIntlMessage('store.purchaseSuccess'));}else{detail=this.renderForm();}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Store_ItemDetails__["a" /* default */],item),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.courseBought},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.error},error)),detail);}}]);return StripeCheckoutForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StripeCheckoutForm.propTypes={exp_month:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,exp_year:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,number:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,cvc:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,error:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,errorText:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,paymentLoading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,paymentComplete:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};StripeCheckoutForm.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,router:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (StripeCheckoutForm);

/***/ }),
/* 2217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Cio_Assets_PoweredBy__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_dj',logo:'_dk',container:'_dl',buttonContainer:'_dm'};var AlertDialog=function(_Component){_inherits(AlertDialog,_Component);function AlertDialog(){_classCallCheck(this,AlertDialog);return _possibleConstructorReturn(this,(AlertDialog.__proto__||Object.getPrototypeOf(AlertDialog)).apply(this,arguments));}_createClass(AlertDialog,[{key:'render',value:function render(){var _props=this.props,children=_props.children,open=_props.open,title=_props.title,onRequestClose=_props.onRequestClose;var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_FullScreenDialog__["a" /* default */],{open:open,toolbar:false,onRequestClose:onRequestClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,title),children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["RaisedButton"],{fullWidth:true,secondary:true,label:getIntlMessage('OK'),onTouchTap:onRequestClose}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.details},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:css.logo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Cio_Assets_PoweredBy__["a" /* default */],{color:'#09BEC3',borderColor:'#09BEC3'}))));}}]);return AlertDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AlertDialog.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,open:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onRequestClose:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};AlertDialog.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (AlertDialog);

/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_Auth__ = __webpack_require__(83);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/* global gapi*/var Google=function(){function Google(){_classCallCheck(this,Google);}_createClass(Google,[{key:'signIn',value:function signIn(){var _this=this;if(this.auth&&this.user){var token=this.user.getAuthResponse().id_token;if(token){return new Promise(function(resolve,reject){_this.login(token,function(response){if(response.isError){reject(response.errMsg);}else{resolve(response.data);}});});}}else{return this.load();}}},{key:'login',value:function login(idToken,callback){return __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].request('auth','loginGoogle',{idToken:idToken}).then(function(data){if(data){__WEBPACK_IMPORTED_MODULE_2_actions_Auth__["a" /* default */].loginSuccess(data);}else{__WEBPACK_IMPORTED_MODULE_2_actions_Auth__["a" /* default */].loginError();}},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_Auth__["a" /* default */].loginError(error);});}},{key:'load',value:function load(){var _this2=this;return new Promise(function(resolve,reject){gapi.load('auth2',function(){gapi.auth2.init({client_id:__WEBPACK_IMPORTED_MODULE_0_Config__["a" /* default */].googleClientId,// cookiepolicy: 'single_host_origin',
fetch_basic_profile:true}).then(function(auth){var user=auth.currentUser.get();_this2.auth=auth;_this2.user=user;auth.signIn().then(function(googleUser){var idToken=googleUser.getAuthResponse().id_token;_this2.login(idToken).then(function(response){resolve(response);},function(error){reject(error);});},function(error){reject(error);// error
});},function(error){reject(e);});});});}}]);return Google;}();/* harmony default export */ __webpack_exports__["a"] = (new Google());

/***/ }),
/* 2219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_Auth__ = __webpack_require__(83);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/* global gapi*/var Facebook=function(){function Facebook(){_classCallCheck(this,Facebook);}_createClass(Facebook,[{key:'getLoginUrl',value:function getLoginUrl(){return __WEBPACK_IMPORTED_MODULE_1_services_SteelCompass__["a" /* default */].request('auth','getFacebookLoginUrl').then(function(url){window.location=url;},function(error){__WEBPACK_IMPORTED_MODULE_2_actions_Auth__["a" /* default */].loginError(error);});}}]);return Facebook;}();/* harmony default export */ __webpack_exports__["a"] = (new Facebook());

/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Store_ItemDetails__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_CoursioLogo__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Cio_Assets_PoweredBy__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isValidEmail=/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;var css={root:'_cW',details:'_cX',logo:'_cY',method:'_cZ',container:'_c0',courseBought:'_c1',error:'_c2',backButton:'_c3',explanation:'_c4'};var GiftEmailForm=function(_Component){_inherits(GiftEmailForm,_Component);function GiftEmailForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GiftEmailForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GiftEmailForm.__proto__||Object.getPrototypeOf(GiftEmailForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={emailError:null,giftEmailError:null,giftEmail:null,giftEmailConfirm:null},_this._handleEmailChange=function(event){var giftEmail=event.target.value;if(!_this.validEmail(giftEmail)){_this.setState({giftEmail:giftEmail,emailError:_this.context.getIntlMessage('validation.invalidEmail')});}else{_this.setState({giftEmail:giftEmail,emailError:null});}},_this.setGiftEmail=function(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].setGiftEmail(_this.state.giftEmail);},_this._handleEmailConfirmChange=function(event){var giftEmailConfirm=event.target.value;var giftEmail=_this.state.giftEmail;if(!_this.validEmail(giftEmailConfirm)){_this.setState({giftEmailConfirm:giftEmailConfirm,giftEmailError:_this.context.getIntlMessage('validation.invalidEmail')});}else if(giftEmailConfirm!==giftEmail){_this.setState({giftEmailConfirm:giftEmailConfirm,giftEmailError:_this.context.getIntlMessage('gift.emailMustMatch')});}else{_this.setState({giftEmailConfirm:giftEmailConfirm,giftEmailError:null});}},_this.back=function(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].clearCart(null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GiftEmailForm,[{key:'validEmail',value:function validEmail(email){return isValidEmail.test(email.toLowerCase());}},{key:'render',value:function render(){var getIntlMessage=this.context.getIntlMessage;var _state=this.state,giftEmail=_state.giftEmail,giftEmailConfirm=_state.giftEmailConfirm,emailError=_state.emailError,giftEmailError=_state.giftEmailError;var canContinue=giftEmail===giftEmailConfirm&&!!giftEmail&&!giftEmailError&&!giftEmailError;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.details},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,getIntlMessage('gift.thisCourse')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:css.explanation},getIntlMessage('gift.explanation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:css.explanation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,getIntlMessage('gift.warning'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{fullWidth:true,hintText:getIntlMessage('gift.email'),value:giftEmail,errorText:emailError,onChange:this._handleEmailChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["TextField"],{fullWidth:true,hintText:getIntlMessage('gift.confirm'),errorText:giftEmailError,value:giftEmailConfirm,onChange:this._handleEmailConfirmChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["RaisedButton"],{fullWidth:true,secondary:true,disabled:!canContinue,label:getIntlMessage('Continue'),onTouchTap:this.setGiftEmail})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:css.logo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_Cio_Assets_PoweredBy__["a" /* default */],{color:'#777',borderColor:'#777'})));}}]);return GiftEmailForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);GiftEmailForm.propTypes={};GiftEmailForm.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,history:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (GiftEmailForm);

/***/ }),
/* 2221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Drawer__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Store_Editor_StoreLayoutEditor__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Store_Editor_StoreModuleEditor__ = __webpack_require__(2283);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={layoutEditor:'_eW',moduleEditor:'_eX',root:'_eY'};var StoreLayoutOverview=function(_Component){_inherits(StoreLayoutOverview,_Component);function StoreLayoutOverview(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreLayoutOverview);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreLayoutOverview.__proto__||Object.getPrototypeOf(StoreLayoutOverview)).call.apply(_ref,[this].concat(args))),_this),_this.unselect=function(){__WEBPACK_IMPORTED_MODULE_2_actions__["A" /* StoreOverviewActions */].unselect();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreLayoutOverview,[{key:'render',value:function render(){var _props=this.props,mode=_props.mode,layout=_props.layout,selectedModule=_props.selectedModule,selectedSection=_props.selectedSection,canUndo=_props.canUndo,categories=_props.categories,other=_objectWithoutProperties(_props,['mode','layout','selectedModule','selectedSection','canUndo','categories']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Drawer__["a" /* default */],Object.assign({className:css.root// closeOnEsc={false}
,onRequestClose:this.unselect},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.layoutEditor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Store_Editor_StoreLayoutEditor__["a" /* default */],{canUndo:canUndo,layout:layout,selectedModule:selectedModule})),selectedModule&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.moduleEditor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Store_Editor_StoreModuleEditor__["a" /* default */],{selectedModule:selectedModule,selectedSection:selectedSection,categories:categories})));}}]);return StoreLayoutOverview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreLayoutOverview.propTypes={layout:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,canUndo:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,mode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,categories:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,selectedModule:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,selectedSection:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (StoreLayoutOverview);

/***/ }),
/* 2222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Portal__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ESC=27;var css={container:'_hr'};var Drawer=function(_Component){_inherits(Drawer,_Component);function Drawer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Drawer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Drawer.__proto__||Object.getPrototypeOf(Drawer)).call.apply(_ref,[this].concat(args))),_this),_this.handleRequestOpen=function(){var _this$props=_this.props,open=_this$props.open,onRequestOpen=_this$props.onRequestOpen;if(!open&&onRequestOpen){onRequestOpen();}},_this.handleRequestClose=function(){var _this$props2=_this.props,open=_this$props2.open,onRequestClose=_this$props2.onRequestClose;if(open&&onRequestClose){onRequestClose();}},_this.handleRest=function(){var _this$props3=_this.props,slide=_this$props3.slide,open=_this$props3.open,onOpen=_this$props3.onOpen,onClose=_this$props3.onClose;if(open&&onOpen){onOpen();}else if(!open&&onClose){onClose();}if(!open&&slide){__WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations___default.a.setValueForStyles(_this._app,{right:0,left:0});}},_this.handleKey=function(event){var keyCode=event.keyCode;var _this$props4=_this.props,closeOnEsc=_this$props4.closeOnEsc,onRequestClose=_this$props4.onRequestClose;if(keyCode===ESC&&closeOnEsc&&onRequestClose){onRequestClose();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Drawer,[{key:'componentWillMount',value:function componentWillMount(){this._app=document.getElementById('root');document.addEventListener('keyup',this.handleKey);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var slide=this.props.slide;slide&&__WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations___default.a.setValueForStyles(this._app,{right:0,left:0});document.removeEventListener('keyup',this.handleKey);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,open=_props.open,slide=_props.slide,children=_props.children,right=_props.right,width=_props.width,className=_props.className;var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.container,className);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_motion__["Motion"],{style:{width:Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(width,{stiffness:300,damping:25}),x:Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(open?1:0,{stiffness:300,damping:25}),open:Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(open?1:0)},onRest:this.handleRest},function(interpolated){if(interpolated.open>0){var x=interpolated.x,interpolatedWidth=interpolated.width;var style={width:interpolatedWidth,left:right?null:-interpolatedWidth,right:right?-interpolatedWidth:null,transform:'translate3d('+(right?0:x*interpolatedWidth)+'px, '+(right?-x*interpolatedWidth:0)+'px, 0)'};slide&&__WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations___default.a.setValueForStyles(_this2._app,{right:right?x*interpolatedWidth:0,left:right?0:x*interpolatedWidth});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Portal__["a" /* default */],{className:classes,style:style},children);}return null;});}}]);return Drawer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Drawer.propTypes={className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,open:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,right:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onClose:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onOpen:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,width:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,onRequestClose:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onRequestOpen:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,closeOnEsc:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,slide:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};Drawer.defaultProps={open:false,width:390,slide:true,closeOnEsc:true};/* harmony default export */ __webpack_exports__["a"] = (Drawer);

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _mapToZero = __webpack_require__(401);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(271);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(402);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(272);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(403);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(404);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(38);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(71);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var msPerFrame = 1000 / 60;

var Motion = _createReactClass2['default']({
  propTypes: {
    // TOOD: warn against putting a config in here
    defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
    style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
    children: _propTypes2['default'].func.isRequired,
    onRest: _propTypes2['default'].func
  },

  getInitialState: function getInitialState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  },

  wasAnimating: false,
  animationID: null,
  prevTime: 0,
  accumulatedTime: 0,
  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400
  unreadPropStyle: null,
  // after checking for unreadPropStyle != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)
  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
    var dirty = false;
    var _state = this.state;
    var currentStyle = _state.currentStyle;
    var currentVelocity = _state.currentVelocity;
    var lastIdealStyle = _state.lastIdealStyle;
    var lastIdealVelocity = _state.lastIdealVelocity;

    for (var key in destStyle) {
      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
        continue;
      }

      var styleValue = destStyle[key];
      if (typeof styleValue === 'number') {
        if (!dirty) {
          dirty = true;
          currentStyle = _extends({}, currentStyle);
          currentVelocity = _extends({}, currentVelocity);
          lastIdealStyle = _extends({}, lastIdealStyle);
          lastIdealVelocity = _extends({}, lastIdealVelocity);
        }

        currentStyle[key] = styleValue;
        currentVelocity[key] = 0;
        lastIdealStyle[key] = styleValue;
        lastIdealVelocity[key] = 0;
      }
    }

    if (dirty) {
      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
    }
  },

  startAnimationIfNecessary: function startAnimationIfNecessary() {
    var _this = this;

    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
    // call cb? No, otherwise accidental parent rerender causes cb trigger
    this.animationID = _raf2['default'](function (timestamp) {
      // check if we need to animate in the first place
      var propsStyle = _this.props.style;
      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
        if (_this.wasAnimating && _this.props.onRest) {
          _this.props.onRest();
        }

        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.wasAnimating = false;
        _this.accumulatedTime = 0;
        return;
      }

      _this.wasAnimating = true;

      var currentTime = timestamp || _performanceNow2['default']();
      var timeDelta = currentTime - _this.prevTime;
      _this.prevTime = currentTime;
      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
      // more than 10 frames? prolly switched browser tab. Restart
      if (_this.accumulatedTime > msPerFrame * 10) {
        _this.accumulatedTime = 0;
      }

      if (_this.accumulatedTime === 0) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.startAnimationIfNecessary();
        return;
      }

      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

      var newLastIdealStyle = {};
      var newLastIdealVelocity = {};
      var newCurrentStyle = {};
      var newCurrentVelocity = {};

      for (var key in propsStyle) {
        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
          continue;
        }

        var styleValue = propsStyle[key];
        if (typeof styleValue === 'number') {
          newCurrentStyle[key] = styleValue;
          newCurrentVelocity[key] = 0;
          newLastIdealStyle[key] = styleValue;
          newLastIdealVelocity[key] = 0;
        } else {
          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
          for (var i = 0; i < framesToCatchUp; i++) {
            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            newLastIdealStyleValue = _stepper[0];
            newLastIdealVelocityValue = _stepper[1];
          }

          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

          var nextIdealX = _stepper2[0];
          var nextIdealV = _stepper2[1];

          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
          newLastIdealStyle[key] = newLastIdealStyleValue;
          newLastIdealVelocity[key] = newLastIdealVelocityValue;
        }
      }

      _this.animationID = null;
      // the amount we're looped over above
      _this.accumulatedTime -= framesToCatchUp * msPerFrame;

      _this.setState({
        currentStyle: newCurrentStyle,
        currentVelocity: newCurrentVelocity,
        lastIdealStyle: newLastIdealStyle,
        lastIdealVelocity: newLastIdealVelocity
      });

      _this.unreadPropStyle = null;

      _this.startAnimationIfNecessary();
    });
  },

  componentDidMount: function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  },

  render: function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  }
});

exports['default'] = Motion;
module.exports = exports['default'];

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _mapToZero = __webpack_require__(401);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(271);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(402);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(272);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(403);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(404);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(38);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(71);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = _createReactClass2['default']({
  propTypes: {
    // TOOD: warn against putting a config in here
    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
    styles: _propTypes2['default'].func.isRequired,
    children: _propTypes2['default'].func.isRequired
  },

  getInitialState: function getInitialState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  },

  animationID: null,
  prevTime: 0,
  accumulatedTime: 0,
  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400
  unreadPropStyles: null,
  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)
  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
    var _state = this.state;
    var currentStyles = _state.currentStyles;
    var currentVelocities = _state.currentVelocities;
    var lastIdealStyles = _state.lastIdealStyles;
    var lastIdealVelocities = _state.lastIdealVelocities;

    var someDirty = false;
    for (var i = 0; i < unreadPropStyles.length; i++) {
      var unreadPropStyle = unreadPropStyles[i];
      var dirty = false;

      for (var key in unreadPropStyle) {
        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
          continue;
        }

        var styleValue = unreadPropStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            someDirty = true;
            currentStyles[i] = _extends({}, currentStyles[i]);
            currentVelocities[i] = _extends({}, currentVelocities[i]);
            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
          }
          currentStyles[i][key] = styleValue;
          currentVelocities[i][key] = 0;
          lastIdealStyles[i][key] = styleValue;
          lastIdealVelocities[i][key] = 0;
        }
      }
    }

    if (someDirty) {
      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
    }
  },

  startAnimationIfNecessary: function startAnimationIfNecessary() {
    var _this = this;

    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
    // call cb? No, otherwise accidental parent rerender causes cb trigger
    this.animationID = _raf2['default'](function (timestamp) {
      var destStyles = _this.props.styles(_this.state.lastIdealStyles);

      // check if we need to animate in the first place
      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.accumulatedTime = 0;
        return;
      }

      var currentTime = timestamp || _performanceNow2['default']();
      var timeDelta = currentTime - _this.prevTime;
      _this.prevTime = currentTime;
      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
      // more than 10 frames? prolly switched browser tab. Restart
      if (_this.accumulatedTime > msPerFrame * 10) {
        _this.accumulatedTime = 0;
      }

      if (_this.accumulatedTime === 0) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.startAnimationIfNecessary();
        return;
      }

      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

      var newLastIdealStyles = [];
      var newLastIdealVelocities = [];
      var newCurrentStyles = [];
      var newCurrentVelocities = [];

      for (var i = 0; i < destStyles.length; i++) {
        var destStyle = destStyles[i];
        var newCurrentStyle = {};
        var newCurrentVelocity = {};
        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};

        for (var key in destStyle) {
          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
            continue;
          }

          var styleValue = destStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
            for (var j = 0; j < framesToCatchUp; j++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        newCurrentStyles[i] = newCurrentStyle;
        newCurrentVelocities[i] = newCurrentVelocity;
        newLastIdealStyles[i] = newLastIdealStyle;
        newLastIdealVelocities[i] = newLastIdealVelocity;
      }

      _this.animationID = null;
      // the amount we're looped over above
      _this.accumulatedTime -= framesToCatchUp * msPerFrame;

      _this.setState({
        currentStyles: newCurrentStyles,
        currentVelocities: newCurrentVelocities,
        lastIdealStyles: newLastIdealStyles,
        lastIdealVelocities: newLastIdealVelocities
      });

      _this.unreadPropStyles = null;

      _this.startAnimationIfNecessary();
    });
  },

  componentDidMount: function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  },

  render: function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  }
});

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _mapToZero = __webpack_require__(401);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(271);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(402);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(2226);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(272);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(403);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(404);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(38);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(71);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = _createReactClass2['default']({
  propTypes: {
    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
      key: _propTypes2['default'].string.isRequired,
      data: _propTypes2['default'].any,
      style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
    })),
    styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
      key: _propTypes2['default'].string.isRequired,
      data: _propTypes2['default'].any,
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
    }))]).isRequired,
    children: _propTypes2['default'].func.isRequired,
    willEnter: _propTypes2['default'].func,
    willLeave: _propTypes2['default'].func,
    didLeave: _propTypes2['default'].func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    };
  },

  getInitialState: function getInitialState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync[0];
    var currentStyles = _mergeAndSync[1];
    var currentVelocities = _mergeAndSync[2];
    var lastIdealStyles = _mergeAndSync[3];
    var lastIdealVelocities = _mergeAndSync[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  },

  unmounting: false,
  animationID: null,
  prevTime: 0,
  accumulatedTime: 0,
  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400
  unreadPropStyles: null,
  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)
  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.props.didLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);

    var mergedPropsStyles = _mergeAndSync2[0];
    var currentStyles = _mergeAndSync2[1];
    var currentVelocities = _mergeAndSync2[2];
    var lastIdealStyles = _mergeAndSync2[3];
    var lastIdealVelocities = _mergeAndSync2[4];

    for (var i = 0; i < unreadPropStyles.length; i++) {
      var unreadPropStyle = unreadPropStyles[i].style;
      var dirty = false;

      for (var key in unreadPropStyle) {
        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
          continue;
        }

        var styleValue = unreadPropStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyles[i] = _extends({}, currentStyles[i]);
            currentVelocities[i] = _extends({}, currentVelocities[i]);
            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            mergedPropsStyles[i] = {
              key: mergedPropsStyles[i].key,
              data: mergedPropsStyles[i].data,
              style: _extends({}, mergedPropsStyles[i].style)
            };
          }
          currentStyles[i][key] = styleValue;
          currentVelocities[i][key] = 0;
          lastIdealStyles[i][key] = styleValue;
          lastIdealVelocities[i][key] = 0;
          mergedPropsStyles[i].style[key] = styleValue;
        }
      }
    }

    // unlike the other 2 components, we can't detect staleness and optionally
    // opt out of setState here. each style object's data might contain new
    // stuff we're not/cannot compare
    this.setState({
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      mergedPropsStyles: mergedPropsStyles,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities
    });
  },

  startAnimationIfNecessary: function startAnimationIfNecessary() {
    var _this = this;

    if (this.unmounting) {
      return;
    }

    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
    // call cb? No, otherwise accidental parent rerender causes cb trigger
    this.animationID = _raf2['default'](function (timestamp) {
      // https://github.com/chenglou/react-motion/pull/420
      // > if execution passes the conditional if (this.unmounting), then
      // executes async defaultRaf and after that component unmounts and after
      // that the callback of defaultRaf is called, then setState will be called
      // on unmounted component.
      if (_this.unmounting) {
        return;
      }

      var propStyles = _this.props.styles;
      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

      // check if we need to animate in the first place
      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.accumulatedTime = 0;
        return;
      }

      var currentTime = timestamp || _performanceNow2['default']();
      var timeDelta = currentTime - _this.prevTime;
      _this.prevTime = currentTime;
      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
      // more than 10 frames? prolly switched browser tab. Restart
      if (_this.accumulatedTime > msPerFrame * 10) {
        _this.accumulatedTime = 0;
      }

      if (_this.accumulatedTime === 0) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.startAnimationIfNecessary();
        return;
      }

      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var newMergedPropsStyles = _mergeAndSync3[0];
      var newCurrentStyles = _mergeAndSync3[1];
      var newCurrentVelocities = _mergeAndSync3[2];
      var newLastIdealStyles = _mergeAndSync3[3];
      var newLastIdealVelocities = _mergeAndSync3[4];

      for (var i = 0; i < newMergedPropsStyles.length; i++) {
        var newMergedPropsStyle = newMergedPropsStyles[i].style;
        var newCurrentStyle = {};
        var newCurrentVelocity = {};
        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};

        for (var key in newMergedPropsStyle) {
          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
            continue;
          }

          var styleValue = newMergedPropsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = newLastIdealStyles[i][key];
            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
            for (var j = 0; j < framesToCatchUp; j++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        newLastIdealStyles[i] = newLastIdealStyle;
        newLastIdealVelocities[i] = newLastIdealVelocity;
        newCurrentStyles[i] = newCurrentStyle;
        newCurrentVelocities[i] = newCurrentVelocity;
      }

      _this.animationID = null;
      // the amount we're looped over above
      _this.accumulatedTime -= framesToCatchUp * msPerFrame;

      _this.setState({
        currentStyles: newCurrentStyles,
        currentVelocities: newCurrentVelocities,
        lastIdealStyles: newLastIdealStyles,
        lastIdealVelocities: newLastIdealVelocities,
        mergedPropsStyles: newMergedPropsStyles
      });

      _this.unreadPropStyles = null;

      _this.startAnimationIfNecessary();
    });
  },

  componentDidMount: function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  },

  render: function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  }
});

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(625);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Store_StoreLayoutEditorToolbar__ = __webpack_require__(2230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Tasks_ScrollableContainer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LayoutOverview_StoreLayoutOverviewRow__ = __webpack_require__(2231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dnd_touch_backend__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dnd_touch_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dnd_touch_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dnd__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LayoutOverview_Preview__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Toolbar__ = __webpack_require__(80);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StoreLayoutEditor=function(_Component){_inherits(StoreLayoutEditor,_Component);function StoreLayoutEditor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreLayoutEditor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreLayoutEditor.__proto__||Object.getPrototypeOf(StoreLayoutEditor)).call.apply(_ref,[this].concat(args))),_this),_this.openModuleMenu=function(){__WEBPACK_IMPORTED_MODULE_5_actions__["A" /* StoreOverviewActions */].openModuleMenu();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreLayoutEditor,[{key:'render',value:function render(){var _props=this.props,layout=_props.layout,canUndo=_props.canUndo,selectedModule=_props.selectedModule;var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Tasks_ScrollableContainer__["a" /* default */],{padded:true,header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Store_StoreLayoutEditorToolbar__["a" /* default */],{canUndo:canUndo}),footer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Toolbar__["b" /* Toolbar */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Toolbar__["d" /* ToolbarGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Toolbar__["c" /* ToolbarButton */],{onTouchTap:this.openModuleMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ContentAdd"],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Toolbar__["e" /* ToolbarTitle */],null,getIntlMessage('store.addContent')))},layout.sections.map(function(section){var id=section.id,other=_objectWithoutProperties(section,['id']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__LayoutOverview_StoreLayoutOverviewRow__["a" /* default */],Object.assign({id:id,key:id},other,{selectedModule:selectedModule}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LayoutOverview_Preview__["a" /* default */],{key:'preview',name:'StoreColumn'}));}}]);return StoreLayoutEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreLayoutEditor.propTypes={selectedModule:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,canUndo:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,layout:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};StoreLayoutEditor.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_dnd__["DragDropContext"])(__WEBPACK_IMPORTED_MODULE_6_react_dnd_touch_backend___default()({enableMouseEvents:true}))(StoreLayoutEditor));

/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Toolbar__ = __webpack_require__(80);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StoreLayoutEditorToolbar=function(_Component){_inherits(StoreLayoutEditorToolbar,_Component);function StoreLayoutEditorToolbar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreLayoutEditorToolbar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreLayoutEditorToolbar.__proto__||Object.getPrototypeOf(StoreLayoutEditorToolbar)).call.apply(_ref,[this].concat(args))),_this),_this.editMode=function(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].editMode();},_this.listMode=function(){_this.save();__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].listMode();},_this.save=function(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].update();},_this.publish=function(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].publish();},_this.undo=function(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].undo();},_this.discard=function(){__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].discard();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreLayoutEditorToolbar,[{key:'render',value:function render(){var _props=this.props,canUndo=_props.canUndo,other=_objectWithoutProperties(_props,['canUndo']);var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toolbar__["b" /* Toolbar */],Object.assign({center:true,key:'edit'},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toolbar__["d" /* ToolbarGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toolbar__["c" /* ToolbarButton */],{onTouchTap:this.listMode,tooltip:getIntlMessage('menu.Back')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["NavigationArrowBack"],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toolbar__["d" /* ToolbarGroup */],{right:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toolbar__["c" /* ToolbarButton */],{disabled:!canUndo,tooltip:getIntlMessage('storeBuilder.undo'),onTouchTap:this.undo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["ContentUndo"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toolbar__["c" /* ToolbarButton */],{tooltip:getIntlMessage('storeBuilder.save'),onTouchTap:this.save},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["ContentSave"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toolbar__["c" /* ToolbarButton */],{tooltip:getIntlMessage('storeBuilder.discard'),onTouchTap:this.discard},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["ActionDelete"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toolbar__["c" /* ToolbarButton */],{tooltip:getIntlMessage('storeBuilder.publish'),onTouchTap:this.publish},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_SvgIcons__["EditorPublish"],null))));}}]);return StoreLayoutEditorToolbar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreLayoutEditorToolbar.propTypes={canUndo:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};StoreLayoutEditorToolbar.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreLayoutEditorToolbar);

/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StoreLayoutOverviewColumn__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dnd_lib_DropTarget__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dnd_lib_DropTarget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dnd_lib_DropTarget__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_gu',before:'_gv',after:'_gw',dragContainer:'_gx',size1:'_gy',size2:'_gz',size3:'_gA',size4:'_gB',drag:'_gC'};var styles={icon:{width:__WEBPACK_IMPORTED_MODULE_4_Css__["Units"].base*4,height:__WEBPACK_IMPORTED_MODULE_4_Css__["Units"].base*4}};var icons={Text:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["EditorFormatAlignLeft"],Banner:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageLandscape"],Image:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageImage"],Video:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["AvMovie"],List:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageViewComfy"],Filter:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ContentFilterList"]};var dropTarget={hover:function hover(props,monitor,component){if(monitor.isOver({shallow:true})&&component){var offset=monitor.getClientOffset();var y=offset.y,x=offset.x;component.checkHover(y,x,monitor.getItem().id);}}};var StoreLayoutOverviewRow=function(_Component){_inherits(StoreLayoutOverviewRow,_Component);function StoreLayoutOverviewRow(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreLayoutOverviewRow);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreLayoutOverviewRow.__proto__||Object.getPrototypeOf(StoreLayoutOverviewRow)).call.apply(_ref,[this].concat(args))),_this),_this.select=function(){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_2_actions__["A" /* StoreOverviewActions */].selectSection(id);},_this.endDrag=function(item,didDrop){if(didDrop){__WEBPACK_IMPORTED_MODULE_2_actions__["A" /* StoreOverviewActions */].endDragging(_this.props.id,item);}else{__WEBPACK_IMPORTED_MODULE_2_actions__["A" /* StoreOverviewActions */].resetDragging();}},_this.checkHover=function(y,x,moduleId){var _this$_node$getBoundi=_this._node.getBoundingClientRect(),left=_this$_node$getBoundi.left,top=_this$_node$getBoundi.top,height=_this$_node$getBoundi.height,width=_this$_node$getBoundi.width;var _this$props=_this.props,id=_this$props.id,modules=_this$props.modules;var modulesWithoutDragging=modules.filter(function(module){return module.id!=='drag';});var columnCount=modules.length;var moduleIndex=modulesWithoutDragging.findIndex(function(module){return module.id===moduleId;});if(moduleIndex<0){columnCount++;}var xOffset=Math.max(x-left,1);var dropPosition=Math.floor(columnCount*(xOffset/width));if(moduleIndex>-1&&moduleIndex===dropPosition){if(modules.length!==modulesWithoutDragging.length){__WEBPACK_IMPORTED_MODULE_2_actions__["A" /* StoreOverviewActions */].resetDragging();}return;}var pos=(y-top)/height;if(pos<0.33){__WEBPACK_IMPORTED_MODULE_2_actions__["A" /* StoreOverviewActions */].overSection('before',id);}else if(pos>0.66){__WEBPACK_IMPORTED_MODULE_2_actions__["A" /* StoreOverviewActions */].overSection('after',id);}else{__WEBPACK_IMPORTED_MODULE_2_actions__["A" /* StoreOverviewActions */].setDraggingPos(id,dropPosition,moduleId);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreLayoutOverviewRow,[{key:'render',value:function render(){var _classNames,_this2=this;var _props=this.props,modules=_props.modules,selectedModule=_props.selectedModule,marked=_props.marked,id=_props.id;var columnCount=modules.length;var dragClasses=__WEBPACK_IMPORTED_MODULE_5_classnames___default()(css.dragContainer,css['size'+columnCount]);var classes=__WEBPACK_IMPORTED_MODULE_5_classnames___default()(css.root,(_classNames={},_defineProperty(_classNames,css.before,marked==='before'),_defineProperty(_classNames,css.after,marked==='after'),_classNames));var content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(_node){return _this2._node=_node;},className:classes,onTouchTap:this.select},modules.map(function(module){var moduleId=module.id,type=module.type,other=_objectWithoutProperties(module,['id','type']);if(type==='Drag'){var Icon=icons[module.subType];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:dragClasses,key:'drag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.drag},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{style:styles.icon,color:__WEBPACK_IMPORTED_MODULE_4_Css__["Colors"].creen})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:dragClasses,key:moduleId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StoreLayoutOverviewColumn__["a" /* default */],Object.assign({endDrag:_this2.endDrag,onHover:_this2.onHover,id:moduleId,sectionId:id,columnCount:columnCount,selected:selectedModule&&moduleId===selectedModule.id,type:type},other)));}));return this.props.connectDropTarget(content);}}]);return StoreLayoutOverviewRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreLayoutOverviewRow.propTypes={type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,modules:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,selectedModule:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,connectDropTarget:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,marked:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_react_dnd_lib_DropTarget___default()('StoreColumn',dropTarget,function(connect,monitor){return{connectDropTarget:connect.dropTarget(),isOver:monitor.isOver()};})(StoreLayoutOverviewRow));

/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dnd_lib_DragSource__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dnd_lib_DragSource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dnd_lib_DragSource__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_hm',selected:'_hn',isOver:'_ho',isDragging:'_hp',settingsIcon:'_hq'};var styles={icon:{width:__WEBPACK_IMPORTED_MODULE_1_Css__["Units"].base*4,height:__WEBPACK_IMPORTED_MODULE_1_Css__["Units"].base*4},settingsIcon:{width:__WEBPACK_IMPORTED_MODULE_1_Css__["Units"].base*2,height:__WEBPACK_IMPORTED_MODULE_1_Css__["Units"].base*2}};var icons={Text:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["EditorFormatAlignLeft"],Banner:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageLandscape"],Image:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageImage"],Video:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["AvMovie"],List:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageViewComfy"],Filter:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ContentFilterList"]};var dragSource={beginDrag:function beginDrag(props){return{id:props.id,sectionId:props.sectionId,type:props.type};},endDrag:function endDrag(props,monitor){props.endDrag(monitor.getItem(),monitor.didDrop());}};var StoreLayoutOverviewColumn=function(_Component){_inherits(StoreLayoutOverviewColumn,_Component);function StoreLayoutOverviewColumn(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreLayoutOverviewColumn);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreLayoutOverviewColumn.__proto__||Object.getPrototypeOf(StoreLayoutOverviewColumn)).call.apply(_ref,[this].concat(args))),_this),_this.select=function(){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].selectModule(id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreLayoutOverviewColumn,[{key:'render',value:function render(){var _classNames;var _props=this.props,selected=_props.selected,type=_props.type,isOver=_props.isOver,isDragging=_props.isDragging,other=_objectWithoutProperties(_props,['selected','type','isOver','isDragging']);var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.root,(_classNames={},_defineProperty(_classNames,css.selected,selected),_defineProperty(_classNames,css.isDragging,isDragging),_classNames));var Icon=icons[type];var content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes,onTouchTap:this.select},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{style:styles.icon,color:selected?__WEBPACK_IMPORTED_MODULE_1_Css__["Colors"].creen:'#777777'}),selected&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ActionSettings"],{style:styles.settingsIcon,className:css.settingsIcon,color:__WEBPACK_IMPORTED_MODULE_1_Css__["Colors"].creen}));// Connect as drag source
content=this.props.connectDragSource(content,{dropEffect:'move'});// Connect to drag layer
content=this.props.connectDragPreview(content);return content;}}]);return StoreLayoutOverviewColumn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreLayoutOverviewColumn.propTypes={type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,columnCount:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,// react-dnd props
connectDragSource:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,connectDropTarget:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,connectDragPreview:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,endDrag:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onDrop:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,isDragging:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,isOver:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_react_dnd_lib_DragSource___default()('StoreColumn',dragSource,function(connect,monitor){return{connectDragSource:connect.dragSource(),connectDragPreview:connect.dragPreview(),isDragging:monitor.isDragging()};})(StoreLayoutOverviewColumn));

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(565);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _isDisposable2 = __webpack_require__(406);

var _isDisposable3 = _interopRequireDefault(_isDisposable2);

exports.isDisposable = _isDisposable3['default'];

var _Disposable2 = __webpack_require__(2235);

var _Disposable3 = _interopRequireDefault(_Disposable2);

exports.Disposable = _Disposable3['default'];

var _CompositeDisposable2 = __webpack_require__(2236);

var _CompositeDisposable3 = _interopRequireDefault(_CompositeDisposable2);

exports.CompositeDisposable = _CompositeDisposable3['default'];

var _SerialDisposable2 = __webpack_require__(2237);

var _SerialDisposable3 = _interopRequireDefault(_SerialDisposable2);

exports.SerialDisposable = _SerialDisposable3['default'];

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var noop = function noop() {};

/**
 * The basic disposable.
 */

var Disposable = (function () {
  _createClass(Disposable, null, [{
    key: "empty",
    value: { dispose: noop },
    enumerable: true
  }]);

  function Disposable(action) {
    _classCallCheck(this, Disposable);

    this.isDisposed = false;
    this.action = action || noop;
  }

  Disposable.prototype.dispose = function dispose() {
    if (!this.isDisposed) {
      this.action.call(null);
      this.isDisposed = true;
    }
  };

  return Disposable;
})();

exports["default"] = Disposable;
module.exports = exports["default"];

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _isDisposable = __webpack_require__(406);

var _isDisposable2 = _interopRequireDefault(_isDisposable);

/**
 * Represents a group of disposable resources that are disposed together.
 */

var CompositeDisposable = (function () {
  function CompositeDisposable() {
    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
      disposables[_key] = arguments[_key];
    }

    _classCallCheck(this, CompositeDisposable);

    if (Array.isArray(disposables[0]) && disposables.length === 1) {
      disposables = disposables[0];
    }

    for (var i = 0; i < disposables.length; i++) {
      if (!_isDisposable2['default'](disposables[i])) {
        throw new Error('Expected a disposable');
      }
    }

    this.disposables = disposables;
    this.isDisposed = false;
  }

  /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Disposable} item Disposable to add.
   */

  CompositeDisposable.prototype.add = function add(item) {
    if (this.isDisposed) {
      item.dispose();
    } else {
      this.disposables.push(item);
    }
  };

  /**
   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
   * @param {Disposable} item Disposable to remove.
   * @returns {Boolean} true if found; false otherwise.
   */

  CompositeDisposable.prototype.remove = function remove(item) {
    if (this.isDisposed) {
      return false;
    }

    var index = this.disposables.indexOf(item);
    if (index === -1) {
      return false;
    }

    this.disposables.splice(index, 1);
    item.dispose();
    return true;
  };

  /**
   * Disposes all disposables in the group and removes them from the group.
   */

  CompositeDisposable.prototype.dispose = function dispose() {
    if (this.isDisposed) {
      return;
    }

    var len = this.disposables.length;
    var currentDisposables = new Array(len);
    for (var i = 0; i < len; i++) {
      currentDisposables[i] = this.disposables[i];
    }

    this.isDisposed = true;
    this.disposables = [];
    this.length = 0;

    for (var i = 0; i < len; i++) {
      currentDisposables[i].dispose();
    }
  };

  return CompositeDisposable;
})();

exports['default'] = CompositeDisposable;
module.exports = exports['default'];

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _isDisposable = __webpack_require__(406);

var _isDisposable2 = _interopRequireDefault(_isDisposable);

var SerialDisposable = (function () {
  function SerialDisposable() {
    _classCallCheck(this, SerialDisposable);

    this.isDisposed = false;
    this.current = null;
  }

  /**
   * Gets the underlying disposable.
   * @return The underlying disposable.
   */

  SerialDisposable.prototype.getDisposable = function getDisposable() {
    return this.current;
  };

  /**
   * Sets the underlying disposable.
   * @param {Disposable} value The new underlying disposable.
   */

  SerialDisposable.prototype.setDisposable = function setDisposable() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

    if (value != null && !_isDisposable2['default'](value)) {
      throw new Error('Expected either an empty value or a valid disposable');
    }

    var isDisposed = this.isDisposed;
    var previous = undefined;

    if (!isDisposed) {
      previous = this.current;
      this.current = value;
    }

    if (previous) {
      previous.dispose();
    }

    if (isDisposed && value) {
      value.dispose();
    }
  };

  /**
   * Disposes the underlying disposable as well as all future replacements.
   */

  SerialDisposable.prototype.dispose = function dispose() {
    if (this.isDisposed) {
      return;
    }

    this.isDisposed = true;
    var previous = this.current;
    this.current = null;

    if (previous) {
      previous.dispose();
    }
  };

  return SerialDisposable;
})();

exports['default'] = SerialDisposable;
module.exports = exports['default'];

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = registerSource;
function registerSource(type, source, manager) {
	var registry = manager.getRegistry();
	var sourceId = registry.addSource(type, source);

	function unregisterSource() {
		registry.removeSource(sourceId);
	}

	return {
		handlerId: sourceId,
		unregister: unregisterSource
	};
}

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createSourceFactory;

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(148);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
var REQUIRED_SPEC_METHODS = ['beginDrag'];

function createSourceFactory(spec) {
	Object.keys(spec).forEach(function (key) {
		(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
		(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	});
	REQUIRED_SPEC_METHODS.forEach(function (key) {
		(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	});

	var Source = function () {
		function Source(monitor) {
			_classCallCheck(this, Source);

			this.monitor = monitor;
			this.props = null;
			this.component = null;
		}

		_createClass(Source, [{
			key: 'receiveProps',
			value: function receiveProps(props) {
				this.props = props;
			}
		}, {
			key: 'receiveComponent',
			value: function receiveComponent(component) {
				this.component = component;
			}
		}, {
			key: 'canDrag',
			value: function canDrag() {
				if (!spec.canDrag) {
					return true;
				}

				return spec.canDrag(this.props, this.monitor);
			}
		}, {
			key: 'isDragging',
			value: function isDragging(globalMonitor, sourceId) {
				if (!spec.isDragging) {
					return sourceId === globalMonitor.getSourceId();
				}

				return spec.isDragging(this.props, this.monitor);
			}
		}, {
			key: 'beginDrag',
			value: function beginDrag() {
				var item = spec.beginDrag(this.props, this.monitor, this.component);
				if (false) {
					(0, _invariant2.default)((0, _isPlainObject2.default)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
				}
				return item;
			}
		}, {
			key: 'endDrag',
			value: function endDrag() {
				if (!spec.endDrag) {
					return;
				}

				spec.endDrag(this.props, this.monitor, this.component);
			}
		}]);

		return Source;
	}();

	return function createSource(monitor) {
		return new Source(monitor);
	};
}

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createSourceMonitor;

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isCallingCanDrag = false;
var isCallingIsDragging = false;

var SourceMonitor = function () {
	function SourceMonitor(manager) {
		_classCallCheck(this, SourceMonitor);

		this.internalMonitor = manager.getMonitor();
	}

	_createClass(SourceMonitor, [{
		key: 'receiveHandlerId',
		value: function receiveHandlerId(sourceId) {
			this.sourceId = sourceId;
		}
	}, {
		key: 'canDrag',
		value: function canDrag() {
			(0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');

			try {
				isCallingCanDrag = true;
				return this.internalMonitor.canDragSource(this.sourceId);
			} finally {
				isCallingCanDrag = false;
			}
		}
	}, {
		key: 'isDragging',
		value: function isDragging() {
			(0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');

			try {
				isCallingIsDragging = true;
				return this.internalMonitor.isDraggingSource(this.sourceId);
			} finally {
				isCallingIsDragging = false;
			}
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.internalMonitor.getItemType();
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.internalMonitor.getItem();
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.internalMonitor.getDropResult();
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.internalMonitor.didDrop();
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.internalMonitor.getInitialClientOffset();
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.internalMonitor.getInitialSourceClientOffset();
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return this.internalMonitor.getSourceClientOffset();
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.internalMonitor.getClientOffset();
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return this.internalMonitor.getDifferenceFromInitialOffset();
		}
	}]);

	return SourceMonitor;
}();

function createSourceMonitor(manager) {
	return new SourceMonitor(manager);
}

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = createSourceConnector;

var _wrapConnectorHooks = __webpack_require__(628);

var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);

var _areOptionsEqual = __webpack_require__(629);

var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createSourceConnector(backend) {
	var currentHandlerId = void 0;

	var currentDragSourceNode = void 0;
	var currentDragSourceOptions = void 0;
	var disconnectCurrentDragSource = void 0;

	var currentDragPreviewNode = void 0;
	var currentDragPreviewOptions = void 0;
	var disconnectCurrentDragPreview = void 0;

	function reconnectDragSource() {
		if (disconnectCurrentDragSource) {
			disconnectCurrentDragSource();
			disconnectCurrentDragSource = null;
		}

		if (currentHandlerId && currentDragSourceNode) {
			disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
		}
	}

	function reconnectDragPreview() {
		if (disconnectCurrentDragPreview) {
			disconnectCurrentDragPreview();
			disconnectCurrentDragPreview = null;
		}

		if (currentHandlerId && currentDragPreviewNode) {
			disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
		}
	}

	function receiveHandlerId(handlerId) {
		if (handlerId === currentHandlerId) {
			return;
		}

		currentHandlerId = handlerId;
		reconnectDragSource();
		reconnectDragPreview();
	}

	var hooks = (0, _wrapConnectorHooks2.default)({
		dragSource: function connectDragSource(node, options) {
			if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
				return;
			}

			currentDragSourceNode = node;
			currentDragSourceOptions = options;

			reconnectDragSource();
		},

		dragPreview: function connectDragPreview(node, options) {
			if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
				return;
			}

			currentDragPreviewNode = node;
			currentDragPreviewOptions = options;

			reconnectDragPreview();
		}
	});

	return {
		receiveHandlerId: receiveHandlerId,
		hooks: hooks
	};
}

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = cloneWithRef;

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cloneWithRef(element, newRef) {
	var previousRef = element.ref;
	(0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');

	if (!previousRef) {
		// When there is no ref on the element, use the new ref directly
		return (0, _react.cloneElement)(element, {
			ref: newRef
		});
	}

	return (0, _react.cloneElement)(element, {
		ref: function ref(node) {
			newRef(node);

			if (previousRef) {
				previousRef(node);
			}
		}
	});
}

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = registerTarget;
function registerTarget(type, target, manager) {
	var registry = manager.getRegistry();
	var targetId = registry.addTarget(type, target);

	function unregisterTarget() {
		registry.removeTarget(targetId);
	}

	return {
		handlerId: targetId,
		unregister: unregisterTarget
	};
}

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createTargetFactory;

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(148);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];

function createTargetFactory(spec) {
	Object.keys(spec).forEach(function (key) {
		(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
		(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
	});

	var Target = function () {
		function Target(monitor) {
			_classCallCheck(this, Target);

			this.monitor = monitor;
			this.props = null;
			this.component = null;
		}

		_createClass(Target, [{
			key: 'receiveProps',
			value: function receiveProps(props) {
				this.props = props;
			}
		}, {
			key: 'receiveMonitor',
			value: function receiveMonitor(monitor) {
				this.monitor = monitor;
			}
		}, {
			key: 'receiveComponent',
			value: function receiveComponent(component) {
				this.component = component;
			}
		}, {
			key: 'canDrop',
			value: function canDrop() {
				if (!spec.canDrop) {
					return true;
				}

				return spec.canDrop(this.props, this.monitor);
			}
		}, {
			key: 'hover',
			value: function hover() {
				if (!spec.hover) {
					return;
				}

				spec.hover(this.props, this.monitor, this.component);
			}
		}, {
			key: 'drop',
			value: function drop() {
				if (!spec.drop) {
					return undefined;
				}

				var dropResult = spec.drop(this.props, this.monitor, this.component);
				if (false) {
					(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isPlainObject2.default)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
				}
				return dropResult;
			}
		}]);

		return Target;
	}();

	return function createTarget(monitor) {
		return new Target(monitor);
	};
}

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createTargetMonitor;

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isCallingCanDrop = false;

var TargetMonitor = function () {
	function TargetMonitor(manager) {
		_classCallCheck(this, TargetMonitor);

		this.internalMonitor = manager.getMonitor();
	}

	_createClass(TargetMonitor, [{
		key: 'receiveHandlerId',
		value: function receiveHandlerId(targetId) {
			this.targetId = targetId;
		}
	}, {
		key: 'canDrop',
		value: function canDrop() {
			(0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');

			try {
				isCallingCanDrop = true;
				return this.internalMonitor.canDropOnTarget(this.targetId);
			} finally {
				isCallingCanDrop = false;
			}
		}
	}, {
		key: 'isOver',
		value: function isOver(options) {
			return this.internalMonitor.isOverTarget(this.targetId, options);
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.internalMonitor.getItemType();
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.internalMonitor.getItem();
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.internalMonitor.getDropResult();
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.internalMonitor.didDrop();
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.internalMonitor.getInitialClientOffset();
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.internalMonitor.getInitialSourceClientOffset();
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return this.internalMonitor.getSourceClientOffset();
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.internalMonitor.getClientOffset();
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return this.internalMonitor.getDifferenceFromInitialOffset();
		}
	}]);

	return TargetMonitor;
}();

function createTargetMonitor(manager) {
	return new TargetMonitor(manager);
}

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = createTargetConnector;

var _wrapConnectorHooks = __webpack_require__(628);

var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);

var _areOptionsEqual = __webpack_require__(629);

var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTargetConnector(backend) {
	var currentHandlerId = void 0;

	var currentDropTargetNode = void 0;
	var currentDropTargetOptions = void 0;
	var disconnectCurrentDropTarget = void 0;

	function reconnectDropTarget() {
		if (disconnectCurrentDropTarget) {
			disconnectCurrentDropTarget();
			disconnectCurrentDropTarget = null;
		}

		if (currentHandlerId && currentDropTargetNode) {
			disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
		}
	}

	function receiveHandlerId(handlerId) {
		if (handlerId === currentHandlerId) {
			return;
		}

		currentHandlerId = handlerId;
		reconnectDropTarget();
	}

	var hooks = (0, _wrapConnectorHooks2.default)({
		dropTarget: function connectDropTarget(node, options) {
			if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
				return;
			}

			currentDropTargetNode = node;
			currentDropTargetOptions = options;

			reconnectDropTarget();
		}
	});

	return {
		receiveHandlerId: receiveHandlerId,
		hooks: hooks
	};
}

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropManager = __webpack_require__(2248);

Object.defineProperty(exports, 'DragDropManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropManager).default;
  }
});

var _DragSource = __webpack_require__(2278);

Object.defineProperty(exports, 'DragSource', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragSource).default;
  }
});

var _DropTarget = __webpack_require__(2279);

Object.defineProperty(exports, 'DropTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropTarget).default;
  }
});

var _createTestBackend = __webpack_require__(2280);

Object.defineProperty(exports, 'createTestBackend', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createTestBackend).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createStore = __webpack_require__(2249);

var _createStore2 = _interopRequireDefault(_createStore);

var _reducers = __webpack_require__(2252);

var _reducers2 = _interopRequireDefault(_reducers);

var _dragDrop = __webpack_require__(274);

var dragDropActions = _interopRequireWildcard(_dragDrop);

var _DragDropMonitor = __webpack_require__(2274);

var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragDropManager = function () {
	function DragDropManager(createBackend) {
		var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, DragDropManager);

		var store = (0, _createStore2.default)(_reducers2.default);
		this.context = context;
		this.store = store;
		this.monitor = new _DragDropMonitor2.default(store);
		this.registry = this.monitor.registry;
		this.backend = createBackend(this);

		store.subscribe(this.handleRefCountChange.bind(this));
	}

	_createClass(DragDropManager, [{
		key: 'handleRefCountChange',
		value: function handleRefCountChange() {
			var shouldSetUp = this.store.getState().refCount > 0;
			if (shouldSetUp && !this.isSetUp) {
				this.backend.setup();
				this.isSetUp = true;
			} else if (!shouldSetUp && this.isSetUp) {
				this.backend.teardown();
				this.isSetUp = false;
			}
		}
	}, {
		key: 'getContext',
		value: function getContext() {
			return this.context;
		}
	}, {
		key: 'getMonitor',
		value: function getMonitor() {
			return this.monitor;
		}
	}, {
		key: 'getBackend',
		value: function getBackend() {
			return this.backend;
		}
	}, {
		key: 'getRegistry',
		value: function getRegistry() {
			return this.registry;
		}
	}, {
		key: 'getActions',
		value: function getActions() {
			var manager = this;
			var dispatch = this.store.dispatch;


			function bindActionCreator(actionCreator) {
				return function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var action = actionCreator.apply(manager, args);
					if (typeof action !== 'undefined') {
						dispatch(action);
					}
				};
			}

			return Object.keys(dragDropActions).filter(function (key) {
				return typeof dragDropActions[key] === 'function';
			}).reduce(function (boundActions, key) {
				var action = dragDropActions[key];
				boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
				return boundActions;
			}, {});
		}
	}]);

	return DragDropManager;
}();

exports.default = DragDropManager;

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ActionTypes = undefined;
exports['default'] = createStore;

var _isPlainObject = __webpack_require__(148);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _symbolObservable = __webpack_require__(2250);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = exports.ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!(0, _isPlainObject2['default'])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[_symbolObservable2['default']] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
}

/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(2251);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56), __webpack_require__(459)(module)))

/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = reduce;

var _dragOffset = __webpack_require__(633);

var _dragOffset2 = _interopRequireDefault(_dragOffset);

var _dragOperation = __webpack_require__(2253);

var _dragOperation2 = _interopRequireDefault(_dragOperation);

var _refCount = __webpack_require__(2265);

var _refCount2 = _interopRequireDefault(_refCount);

var _dirtyHandlerIds = __webpack_require__(638);

var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);

var _stateId = __webpack_require__(2273);

var _stateId2 = _interopRequireDefault(_stateId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reduce() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	return {
		dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
		dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
		refCount: (0, _refCount2.default)(state.refCount, action),
		dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
		stateId: (0, _stateId2.default)(state.stateId)
	};
}

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = dragOperation;

var _without = __webpack_require__(635);

var _without2 = _interopRequireDefault(_without);

var _dragDrop = __webpack_require__(274);

var _registry = __webpack_require__(276);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
	itemType: null,
	item: null,
	sourceId: null,
	targetIds: [],
	dropResult: null,
	didDrop: false,
	isSourcePublic: null
};

function dragOperation() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _dragDrop.BEGIN_DRAG:
			return _extends({}, state, {
				itemType: action.itemType,
				item: action.item,
				sourceId: action.sourceId,
				isSourcePublic: action.isSourcePublic,
				dropResult: null,
				didDrop: false
			});
		case _dragDrop.PUBLISH_DRAG_SOURCE:
			return _extends({}, state, {
				isSourcePublic: true
			});
		case _dragDrop.HOVER:
			return _extends({}, state, {
				targetIds: action.targetIds
			});
		case _registry.REMOVE_TARGET:
			if (state.targetIds.indexOf(action.targetId) === -1) {
				return state;
			}
			return _extends({}, state, {
				targetIds: (0, _without2.default)(state.targetIds, action.targetId)
			});
		case _dragDrop.DROP:
			return _extends({}, state, {
				dropResult: action.dropResult,
				didDrop: true,
				targetIds: []
			});
		case _dragDrop.END_DRAG:
			return _extends({}, state, {
				itemType: null,
				item: null,
				sourceId: null,
				dropResult: null,
				didDrop: false,
				isSourcePublic: null,
				targetIds: []
			});
		default:
			return state;
	}
}

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(2255),
    baseIsNaN = __webpack_require__(2256),
    strictIndexOf = __webpack_require__(2257);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 2255 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 2256 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 2257 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(2259);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 2259 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(2261),
    shortOut = __webpack_require__(2264);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(2262),
    defineProperty = __webpack_require__(2263),
    identity = __webpack_require__(637);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 2262 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(139);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 2264 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = refCount;

var _registry = __webpack_require__(276);

function refCount() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	var action = arguments[1];

	switch (action.type) {
		case _registry.ADD_SOURCE:
		case _registry.ADD_TARGET:
			return state + 1;
		case _registry.REMOVE_SOURCE:
		case _registry.REMOVE_TARGET:
			return state - 1;
		default:
			return state;
	}
}

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(557),
    baseRest = __webpack_require__(205),
    baseXor = __webpack_require__(2267),
    isArrayLikeObject = __webpack_require__(275);

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

module.exports = xor;


/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(636),
    baseFlatten = __webpack_require__(639),
    baseUniq = __webpack_require__(640);

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

module.exports = baseXor;


/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(253),
    isArguments = __webpack_require__(559),
    isArray = __webpack_require__(106);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(566),
    noop = __webpack_require__(641),
    setToArray = __webpack_require__(371);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(411),
    baseIntersection = __webpack_require__(2271),
    baseRest = __webpack_require__(205),
    castArrayLikeObject = __webpack_require__(2272);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(256),
    arrayIncludes = __webpack_require__(409),
    arrayIncludesWith = __webpack_require__(410),
    arrayMap = __webpack_require__(411),
    baseUnary = __webpack_require__(373),
    cacheHas = __webpack_require__(257);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(275);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = stateId;
function stateId() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

	return state + 1;
}

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(106);

var _isArray2 = _interopRequireDefault(_isArray);

var _matchesType = __webpack_require__(634);

var _matchesType2 = _interopRequireDefault(_matchesType);

var _HandlerRegistry = __webpack_require__(2275);

var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);

var _dragOffset = __webpack_require__(633);

var _dirtyHandlerIds = __webpack_require__(638);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragDropMonitor = function () {
	function DragDropMonitor(store) {
		_classCallCheck(this, DragDropMonitor);

		this.store = store;
		this.registry = new _HandlerRegistry2.default(store);
	}

	_createClass(DragDropMonitor, [{
		key: 'subscribeToStateChange',
		value: function subscribeToStateChange(listener) {
			var _this = this;

			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var handlerIds = options.handlerIds;

			(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
			(0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');

			var prevStateId = this.store.getState().stateId;
			var handleChange = function handleChange() {
				var state = _this.store.getState();
				var currentStateId = state.stateId;
				try {
					var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);

					if (!canSkipListener) {
						listener();
					}
				} finally {
					prevStateId = currentStateId;
				}
			};

			return this.store.subscribe(handleChange);
		}
	}, {
		key: 'subscribeToOffsetChange',
		value: function subscribeToOffsetChange(listener) {
			var _this2 = this;

			(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');

			var previousState = this.store.getState().dragOffset;
			var handleChange = function handleChange() {
				var nextState = _this2.store.getState().dragOffset;
				if (nextState === previousState) {
					return;
				}

				previousState = nextState;
				listener();
			};

			return this.store.subscribe(handleChange);
		}
	}, {
		key: 'canDragSource',
		value: function canDragSource(sourceId) {
			var source = this.registry.getSource(sourceId);
			(0, _invariant2.default)(source, 'Expected to find a valid source.');

			if (this.isDragging()) {
				return false;
			}

			return source.canDrag(this, sourceId);
		}
	}, {
		key: 'canDropOnTarget',
		value: function canDropOnTarget(targetId) {
			var target = this.registry.getTarget(targetId);
			(0, _invariant2.default)(target, 'Expected to find a valid target.');

			if (!this.isDragging() || this.didDrop()) {
				return false;
			}

			var targetType = this.registry.getTargetType(targetId);
			var draggedItemType = this.getItemType();
			return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
		}
	}, {
		key: 'isDragging',
		value: function isDragging() {
			return Boolean(this.getItemType());
		}
	}, {
		key: 'isDraggingSource',
		value: function isDraggingSource(sourceId) {
			var source = this.registry.getSource(sourceId, true);
			(0, _invariant2.default)(source, 'Expected to find a valid source.');

			if (!this.isDragging() || !this.isSourcePublic()) {
				return false;
			}

			var sourceType = this.registry.getSourceType(sourceId);
			var draggedItemType = this.getItemType();
			if (sourceType !== draggedItemType) {
				return false;
			}

			return source.isDragging(this, sourceId);
		}
	}, {
		key: 'isOverTarget',
		value: function isOverTarget(targetId) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { shallow: false };
			var shallow = options.shallow;

			if (!this.isDragging()) {
				return false;
			}

			var targetType = this.registry.getTargetType(targetId);
			var draggedItemType = this.getItemType();
			if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
				return false;
			}

			var targetIds = this.getTargetIds();
			if (!targetIds.length) {
				return false;
			}

			var index = targetIds.indexOf(targetId);
			if (shallow) {
				return index === targetIds.length - 1;
			} else {
				return index > -1;
			}
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.store.getState().dragOperation.itemType;
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.store.getState().dragOperation.item;
		}
	}, {
		key: 'getSourceId',
		value: function getSourceId() {
			return this.store.getState().dragOperation.sourceId;
		}
	}, {
		key: 'getTargetIds',
		value: function getTargetIds() {
			return this.store.getState().dragOperation.targetIds;
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.store.getState().dragOperation.dropResult;
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.store.getState().dragOperation.didDrop;
		}
	}, {
		key: 'isSourcePublic',
		value: function isSourcePublic() {
			return this.store.getState().dragOperation.isSourcePublic;
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.store.getState().dragOffset.initialClientOffset;
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.store.getState().dragOffset.initialSourceClientOffset;
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.store.getState().dragOffset.clientOffset;
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
		}
	}]);

	return DragDropMonitor;
}();

exports.default = DragDropMonitor;

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = __webpack_require__(34);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(106);

var _isArray2 = _interopRequireDefault(_isArray);

var _asap = __webpack_require__(2276);

var _asap2 = _interopRequireDefault(_asap);

var _registry = __webpack_require__(276);

var _getNextUniqueId = __webpack_require__(2277);

var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HandlerRoles = {
	SOURCE: 'SOURCE',
	TARGET: 'TARGET'
};

function validateSourceContract(source) {
	(0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
	(0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
	(0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}

function validateTargetContract(target) {
	(0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
	(0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
	(0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}

function validateType(type, allowArray) {
	if (allowArray && (0, _isArray2.default)(type)) {
		type.forEach(function (t) {
			return validateType(t, false);
		});
		return;
	}

	(0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

function getNextHandlerId(role) {
	var id = (0, _getNextUniqueId2.default)().toString();
	switch (role) {
		case HandlerRoles.SOURCE:
			return 'S' + id;
		case HandlerRoles.TARGET:
			return 'T' + id;
		default:
			(0, _invariant2.default)(false, 'Unknown role: ' + role);
	}
}

function parseRoleFromHandlerId(handlerId) {
	switch (handlerId[0]) {
		case 'S':
			return HandlerRoles.SOURCE;
		case 'T':
			return HandlerRoles.TARGET;
		default:
			(0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
	}
}

var HandlerRegistry = function () {
	function HandlerRegistry(store) {
		_classCallCheck(this, HandlerRegistry);

		this.store = store;

		this.types = {};
		this.handlers = {};

		this.pinnedSourceId = null;
		this.pinnedSource = null;
	}

	_createClass(HandlerRegistry, [{
		key: 'addSource',
		value: function addSource(type, source) {
			validateType(type);
			validateSourceContract(source);

			var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
			this.store.dispatch((0, _registry.addSource)(sourceId));
			return sourceId;
		}
	}, {
		key: 'addTarget',
		value: function addTarget(type, target) {
			validateType(type, true);
			validateTargetContract(target);

			var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
			this.store.dispatch((0, _registry.addTarget)(targetId));
			return targetId;
		}
	}, {
		key: 'addHandler',
		value: function addHandler(role, type, handler) {
			var id = getNextHandlerId(role);
			this.types[id] = type;
			this.handlers[id] = handler;

			return id;
		}
	}, {
		key: 'containsHandler',
		value: function containsHandler(handler) {
			var _this = this;

			return Object.keys(this.handlers).some(function (key) {
				return _this.handlers[key] === handler;
			});
		}
	}, {
		key: 'getSource',
		value: function getSource(sourceId, includePinned) {
			(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');

			var isPinned = includePinned && sourceId === this.pinnedSourceId;
			var source = isPinned ? this.pinnedSource : this.handlers[sourceId];

			return source;
		}
	}, {
		key: 'getTarget',
		value: function getTarget(targetId) {
			(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
			return this.handlers[targetId];
		}
	}, {
		key: 'getSourceType',
		value: function getSourceType(sourceId) {
			(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
			return this.types[sourceId];
		}
	}, {
		key: 'getTargetType',
		value: function getTargetType(targetId) {
			(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
			return this.types[targetId];
		}
	}, {
		key: 'isSourceId',
		value: function isSourceId(handlerId) {
			var role = parseRoleFromHandlerId(handlerId);
			return role === HandlerRoles.SOURCE;
		}
	}, {
		key: 'isTargetId',
		value: function isTargetId(handlerId) {
			var role = parseRoleFromHandlerId(handlerId);
			return role === HandlerRoles.TARGET;
		}
	}, {
		key: 'removeSource',
		value: function removeSource(sourceId) {
			var _this2 = this;

			(0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
			this.store.dispatch((0, _registry.removeSource)(sourceId));

			(0, _asap2.default)(function () {
				delete _this2.handlers[sourceId];
				delete _this2.types[sourceId];
			});
		}
	}, {
		key: 'removeTarget',
		value: function removeTarget(targetId) {
			var _this3 = this;

			(0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
			this.store.dispatch((0, _registry.removeTarget)(targetId));

			(0, _asap2.default)(function () {
				delete _this3.handlers[targetId];
				delete _this3.types[targetId];
			});
		}
	}, {
		key: 'pinSource',
		value: function pinSource(sourceId) {
			var source = this.getSource(sourceId);
			(0, _invariant2.default)(source, 'Expected an existing source.');

			this.pinnedSourceId = sourceId;
			this.pinnedSource = source;
		}
	}, {
		key: 'unpinSource',
		value: function unpinSource() {
			(0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');

			this.pinnedSourceId = null;
			this.pinnedSource = null;
		}
	}]);

	return HandlerRegistry;
}();

exports.default = HandlerRegistry;

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.
var rawAsap = __webpack_require__(418);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};


/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getNextUniqueId;
var nextUniqueId = 0;

function getNextUniqueId() {
	return nextUniqueId++;
}

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragSource = function () {
	function DragSource() {
		_classCallCheck(this, DragSource);
	}

	_createClass(DragSource, [{
		key: "canDrag",
		value: function canDrag() {
			return true;
		}
	}, {
		key: "isDragging",
		value: function isDragging(monitor, handle) {
			return handle === monitor.getSourceId();
		}
	}, {
		key: "endDrag",
		value: function endDrag() {}
	}]);

	return DragSource;
}();

exports.default = DragSource;

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DropTarget = function () {
	function DropTarget() {
		_classCallCheck(this, DropTarget);
	}

	_createClass(DropTarget, [{
		key: "canDrop",
		value: function canDrop() {
			return true;
		}
	}, {
		key: "hover",
		value: function hover() {}
	}, {
		key: "drop",
		value: function drop() {}
	}]);

	return DropTarget;
}();

exports.default = DropTarget;

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createBackend;

var _noop = __webpack_require__(641);

var _noop2 = _interopRequireDefault(_noop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TestBackend = function () {
	function TestBackend(manager) {
		_classCallCheck(this, TestBackend);

		this.actions = manager.getActions();
	}

	_createClass(TestBackend, [{
		key: 'setup',
		value: function setup() {
			this.didCallSetup = true;
		}
	}, {
		key: 'teardown',
		value: function teardown() {
			this.didCallTeardown = true;
		}
	}, {
		key: 'connectDragSource',
		value: function connectDragSource() {
			return _noop2.default;
		}
	}, {
		key: 'connectDragPreview',
		value: function connectDragPreview() {
			return _noop2.default;
		}
	}, {
		key: 'connectDropTarget',
		value: function connectDropTarget() {
			return _noop2.default;
		}
	}, {
		key: 'simulateBeginDrag',
		value: function simulateBeginDrag(sourceIds, options) {
			this.actions.beginDrag(sourceIds, options);
		}
	}, {
		key: 'simulatePublishDragSource',
		value: function simulatePublishDragSource() {
			this.actions.publishDragSource();
		}
	}, {
		key: 'simulateHover',
		value: function simulateHover(targetIds, options) {
			this.actions.hover(targetIds, options);
		}
	}, {
		key: 'simulateDrop',
		value: function simulateDrop() {
			this.actions.drop();
		}
	}, {
		key: 'simulateEndDrag',
		value: function simulateEndDrag() {
			this.actions.endDrag();
		}
	}]);

	return TestBackend;
}();

function createBackend(manager) {
	return new TestBackend(manager);
}

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(38);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DragDropContext = __webpack_require__(632);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This class is a React-Component based version of the DragDropContext.
 * This is an alternative to decorating an application component with an ES7 decorator.
 */
var DragDropContextProvider = (_temp = _class = function (_Component) {
	_inherits(DragDropContextProvider, _Component);

	function DragDropContextProvider(props, context) {
		_classCallCheck(this, DragDropContextProvider);

		/**
   * This property determines which window global to use for creating the DragDropManager.
   * If a window has been injected explicitly via props, that is used first. If it is available
   * as a context value, then use that, otherwise use the browser global.
   */
		var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));

		var getWindow = function getWindow() {
			if (props && props.window) {
				return props.window;
			} else if (context && context.window) {
				return context.window;
			} else if (typeof window !== 'undefined') {
				return window;
			}
			return undefined;
		};

		_this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
		_this.childContext = (0, _DragDropContext.createChildContext)(_this.backend, {
			window: getWindow()
		});
		return _this;
	}

	_createClass(DragDropContextProvider, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.backend !== this.props.backend || nextProps.window !== this.props.window) {
				throw new Error('DragDropContextProvider backend and window props must not change.');
			}
		}
	}, {
		key: 'getChildContext',
		value: function getChildContext() {
			return this.childContext;
		}
	}, {
		key: 'render',
		value: function render() {
			return _react.Children.only(this.props.children);
		}
	}]);

	return DragDropContextProvider;
}(_react.Component), _class.propTypes = {
	backend: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]).isRequired,
	children: _propTypes2.default.element.isRequired,
	window: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
}, _class.defaultProps = {
	window: undefined
}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
	window: _propTypes2.default.object
}, _temp);
exports.default = DragDropContextProvider;

/***/ }),
/* 2282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd_lib_DragLayer__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd_lib_DragLayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dnd_lib_DragLayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={preview:'_gD'};var styles={icon:{width:__WEBPACK_IMPORTED_MODULE_2_Css__["Units"].base*4,height:__WEBPACK_IMPORTED_MODULE_2_Css__["Units"].base*4}};var icons={Text:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["EditorFormatAlignLeft"],Banner:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageLandscape"],Image:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageImage"],Video:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["AvMovie"],List:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageViewComfy"],Filter:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ContentFilterList"]};function collect(monitor){var item=monitor.getItem();var initial=monitor.getInitialClientOffset();var difference=monitor.getDifferenceFromInitialOffset();return{id:item&&item.id,type:item&&item.type,initialClientOffset:initial&&difference?{x:initial.x+difference.x,y:initial.y+difference.y}:null,currentOffset:monitor.getSourceClientOffset(),isDragging:monitor.isDragging()};}function getItemStyles(currentOffset){if(!currentOffset){return{display:'none'};}var x=currentOffset.x,y=currentOffset.y;var transform='translate('+(x-48)+'px, '+(y-96)+'px)';return{pointerEvents:'none',transform:transform,WebkitTransform:transform};}var Preview=function(_React$Component){_inherits(Preview,_React$Component);function Preview(){_classCallCheck(this,Preview);return _possibleConstructorReturn(this,(Preview.__proto__||Object.getPrototypeOf(Preview)).apply(this,arguments));}_createClass(Preview,[{key:'render',value:function render(){var _props=this.props,isDragging=_props.isDragging,type=_props.type;if(!isDragging){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}var Icon=icons[this.props.type];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.preview,style:getItemStyles(this.props.initialClientOffset)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{style:styles.icon,className:css.icon,color:'#777777'}));}}]);return Preview;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Preview.propTypes={id:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,type:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,currentOffset:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.shape({x:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.number,y:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.number}),initialClientOffset:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.shape({x:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.number,y:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.number}),isDragging:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_dnd_lib_DragLayer___default()(collect)(Preview));

/***/ }),
/* 2283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Tasks_ScrollableContainer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Toolbar__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules__ = __webpack_require__(2284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StoreSectionEditor__ = __webpack_require__(2294);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_fH'};var StoreModuleEditor=function(_Component){_inherits(StoreModuleEditor,_Component);function StoreModuleEditor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreModuleEditor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreModuleEditor.__proto__||Object.getPrototypeOf(StoreModuleEditor)).call.apply(_ref,[this].concat(args))),_this),_this.unselect=function(){__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].unselect();},_this.delete=function(){__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].deleteModule();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreModuleEditor,[{key:'render',value:function render(){var getIntlMessage=this.context.getIntlMessage;var _props=this.props,selectedModule=_props.selectedModule,selectedSection=_props.selectedSection,categories=_props.categories;var ModuleEditor=selectedModule&&__WEBPACK_IMPORTED_MODULE_6__Modules__[selectedModule.type];var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Toolbar__["b" /* Toolbar */],{color:'#202020'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Toolbar__["e" /* ToolbarTitle */],{color:__WEBPACK_IMPORTED_MODULE_5_Css__["Colors"].fullWhite},'Settings'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Toolbar__["d" /* ToolbarGroup */],{right:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Toolbar__["c" /* ToolbarButton */],{tooltip:getIntlMessage('Remove'),onTouchTap:this.delete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ActionDelete"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Toolbar__["c" /* ToolbarButton */],{tooltip:getIntlMessage('Close'),onTouchTap:this.unselect},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ContentClear"],null))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Tasks_ScrollableContainer__["a" /* default */],{backgroundColor:'#2a2a2a',padded:true,header:toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},ModuleEditor&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModuleEditor,Object.assign({key:selectedModule.id},selectedModule,{categories:categories})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StoreSectionEditor__["a" /* default */],selectedSection)));}}]);return StoreModuleEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreModuleEditor.propTypes={selectedModule:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,selectedSection:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,categories:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};StoreModuleEditor.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreModuleEditor);

/***/ }),
/* 2284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StoreBannerModuleEditor__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StoreImageModuleEditor__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StoreVideoModuleEditor__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StoreTextModuleEditor__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoreListModuleEditor__ = __webpack_require__(2292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StoreFilterModuleEditor__ = __webpack_require__(2293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Banner", function() { return __WEBPACK_IMPORTED_MODULE_0__StoreBannerModuleEditor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return __WEBPACK_IMPORTED_MODULE_1__StoreImageModuleEditor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Video", function() { return __WEBPACK_IMPORTED_MODULE_2__StoreVideoModuleEditor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return __WEBPACK_IMPORTED_MODULE_3__StoreTextModuleEditor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_4__StoreListModuleEditor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Filter", function() { return __WEBPACK_IMPORTED_MODULE_5__StoreFilterModuleEditor__["a"]; });


/***/ }),
/* 2285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Widgets_Ozitor__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColorChooser__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SizeChooser__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SliderChooser__ = __webpack_require__(2286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PositionChooser__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ImageChooser__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormFieldContainer__ = __webpack_require__(119);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_ix',panel:'_iy',image:'_iz',colorChooser:'_iA',inputWrapper:'_iB',title:'_iC',color:'_iD',active:'_iE',half:'_iF',row:'_iG'};var StoreBannerModuleEditor=function(_Component){_inherits(StoreBannerModuleEditor,_Component);function StoreBannerModuleEditor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreBannerModuleEditor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreBannerModuleEditor.__proto__||Object.getPrototypeOf(StoreBannerModuleEditor)).call.apply(_ref,[this].concat(args))),_this),_this.onChangeHeader=function(header){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{header:header});},_this.handleChange=function(event,foo,payload){var id=_this.props.id;var headerPosition=payload.headerPosition;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{headerPosition:headerPosition});},_this.chooseColor=function(color){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{color:color});},_this.chooseBackgroundColor=function(backgroundColor){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{backgroundColor:backgroundColor});},_this.chooseSize=function(size){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{size:size});},_this.chooseOpacity=function(opacity){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{opacity:opacity});},_this.choosePosition=function(headerPosition){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{headerPosition:headerPosition});},_this.changeImage=function(src){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{src:src});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreBannerModuleEditor,[{key:'render',value:function render(){var _props=this.props,size=_props.size,color=_props.color,backgroundColor=_props.backgroundColor,header=_props.header,opacity=_props.opacity,headerPosition=_props.headerPosition,src=_props.src;var height=360/1920*(__WEBPACK_IMPORTED_MODULE_3_Css__["Units"].keyline*3*(size||1));var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.panel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.half},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SizeChooser__["a" /* default */],{onChange:this.chooseSize,selected:size,title:getIntlMessage('store.size')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.half},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ImageChooser__["a" /* default */],{onChange:this.changeImage,title:getIntlMessage('store.image')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FormFieldContainer__["a" /* default */],{title:getIntlMessage('store.bannerApproximation')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.image,style:{height:height,backgroundImage:'url('+src+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ColorChooser__["a" /* default */],{onChange:this.chooseBackgroundColor,title:getIntlMessage('store.backgroundColor'),selected:backgroundColor}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ColorChooser__["a" /* default */],{onChange:this.chooseColor,title:getIntlMessage('store.Color'),selected:color}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SliderChooser__["a" /* default */],{selected:opacity,title:getIntlMessage('store.overlayOpacity'),step:0.05,min:0,max:1,onChange:this.chooseOpacity}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PositionChooser__["a" /* default */],{backgroundImage:src,title:getIntlMessage('store.headerPosition'),selected:headerPosition,onChange:this.choosePosition}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.inputWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.title},getIntlMessage('store.header')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Widgets_Ozitor__["a" /* default */],{style:{content:{backgroundColor:__WEBPACK_IMPORTED_MODULE_3_Css__["Colors"].theme.Light.card,minHeight:__WEBPACK_IMPORTED_MODULE_3_Css__["Units"].keyline*2,height:__WEBPACK_IMPORTED_MODULE_3_Css__["Units"].keyline*2,maxHeight:__WEBPACK_IMPORTED_MODULE_3_Css__["Units"].keyline*2},root:{minHeight:'auto'}},editable:true,onChange:this.onChangeHeader,defaultContent:header}))));}}]);return StoreBannerModuleEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreBannerModuleEditor.propTypes={id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,header:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,headerPosition:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,opacity:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,backgroundColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,src:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};StoreBannerModuleEditor.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreBannerModuleEditor);

/***/ }),
/* 2286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormFieldContainer__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SliderChooser=function(_Component){_inherits(SliderChooser,_Component);function SliderChooser(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SliderChooser);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SliderChooser.__proto__||Object.getPrototypeOf(SliderChooser)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(event,value){var _this$props=_this.props,onChange=_this$props.onChange,selected=_this$props.selected;if(value!==selected&&onChange){onChange(value);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SliderChooser,[{key:'render',value:function render(){var _props=this.props,title=_props.title,selected=_props.selected,other=_objectWithoutProperties(_props,['title','selected']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FormFieldContainer__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Slider"],Object.assign({name:'slider',style:{marginBottom:__WEBPACK_IMPORTED_MODULE_3_Css__["Units"].base,marginTop:__WEBPACK_IMPORTED_MODULE_3_Css__["Units"].base},defaultValue:selected},other,{onChange:this.handleChange})));}}]);return SliderChooser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SliderChooser.propTypes={selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (SliderChooser);

/***/ }),
/* 2287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormFieldContainer__ = __webpack_require__(119);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={container:'_jU',centerCenter:'_jV',leftCenter:'_jW',rightCenter:'_jX',topLeft:'_jY',topCenter:'_jZ',topRight:'_j0',bottomLeft:'_j1',bottomCenter:'_j2',bottomRight:'_j3',position:'_j4',selected:'_j5'};var PositionChooser=function(_Component){_inherits(PositionChooser,_Component);function PositionChooser(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PositionChooser);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PositionChooser.__proto__||Object.getPrototypeOf(PositionChooser)).call.apply(_ref,[this].concat(args))),_this),_this.handleTouchTap=function(position){var _this$props=_this.props,onChange=_this$props.onChange,selected=_this$props.selected;if(position!==selected&&onChange){onChange(position);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PositionChooser,[{key:'render',value:function render(){var _this2=this;var _props=this.props,title=_props.title,selected=_props.selected,positions=_props.positions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FormFieldContainer__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},positions.map(function(position){var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.position,css[position],_defineProperty({},css.selected,position===selected));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:position,className:classes,onTouchTap:_this2.handleTouchTap.bind(_this2,position)});})));}}]);return PositionChooser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PositionChooser.propTypes={selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,positions:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};PositionChooser.defaultProps={positions:['centerCenter','leftCenter','rightCenter','topLeft','topCenter','topRight','bottomLeft','bottomCenter','bottomRight'],selected:'centerCenter'};/* harmony default export */ __webpack_exports__["a"] = (PositionChooser);

/***/ }),
/* 2288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ImageChooser__ = __webpack_require__(644);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_iJ',panel:'_iK',inputWrapper:'_iL',title:'_iM',input:'_iN'};var StoreImageModuleEditor=function(_Component){_inherits(StoreImageModuleEditor,_Component);function StoreImageModuleEditor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreImageModuleEditor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreImageModuleEditor.__proto__||Object.getPrototypeOf(StoreImageModuleEditor)).call.apply(_ref,[this].concat(args))),_this),_this.changeCaption=function(event){var id=_this.props.id;var caption=event.target.value;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{caption:caption});},_this.changeImage=function(src){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{src:src});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreImageModuleEditor,[{key:'render',value:function render(){var _props=this.props,src=_props.src,caption=_props.caption;var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.panel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ImageChooser__["a" /* default */],{onChange:this.changeImage,title:getIntlMessage('image.upload')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.inputWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.title},getIntlMessage('Caption')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:getIntlMessage('Caption'),onChange:this.changeCaption,value:caption,className:css.input}))));}}]);return StoreImageModuleEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreImageModuleEditor.propTypes={id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,caption:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,src:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};StoreImageModuleEditor.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreImageModuleEditor);

/***/ }),
/* 2289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VideoChooser__ = __webpack_require__(2290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoreVideoPlayer__ = __webpack_require__(611);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_iW',panel:'_iX',inputWrapper:'_iY',title:'_iZ',input:'_i0'};var StoreVideoModuleEditor=function(_Component){_inherits(StoreVideoModuleEditor,_Component);function StoreVideoModuleEditor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreVideoModuleEditor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreVideoModuleEditor.__proto__||Object.getPrototypeOf(StoreVideoModuleEditor)).call.apply(_ref,[this].concat(args))),_this),_this.changeCaption=function(event){var id=_this.props.id;var caption=event.target.value;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{caption:caption});},_this.changeVideo=function(src){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{src:src});},_this.changeEmbedUrl=function(event){var id=_this.props.id;var embedUrl=event.target.value;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{embedUrl:embedUrl});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreVideoModuleEditor,[{key:'render',value:function render(){var _props=this.props,src=_props.src,embedUrl=_props.embedUrl,caption=_props.caption;var getIntlMessage=this.context.getIntlMessage;/*
          <VideoChooser
            onChange={this.changeVideo}
            title={getIntlMessage('video.upload')}
          />
    */return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.panel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.inputWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.title},getIntlMessage('store.video')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:getIntlMessage('store.chooseVideo'),onChange:this.changeEmbedUrl,value:embedUrl,className:css.input})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.inputWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.title},getIntlMessage('Caption')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:getIntlMessage('Caption'),onChange:this.changeCaption,value:caption,className:css.input})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StoreVideoPlayer__["a" /* default */],{src:embedUrl})));}}]);return StoreVideoModuleEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreVideoModuleEditor.propTypes={id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,caption:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,src:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,embedUrl:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};StoreVideoModuleEditor.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreVideoModuleEditor);

/***/ }),
/* 2290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormFieldContainer__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_AspectRatioContainer__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_MediaLibrary_UploadDialog__ = __webpack_require__(396);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={videoContainer:'_j-',hasImage:'_ka',wrapper:'_kb'};var styles={icon:{width:64,height:64},addIcon:{position:'absolute',right:-12,bottom:-12}};var VideoChooser=function(_Component){_inherits(VideoChooser,_Component);function VideoChooser(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VideoChooser);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VideoChooser.__proto__||Object.getPrototypeOf(VideoChooser)).call.apply(_ref,[this].concat(args))),_this),_this.state={uploadDialog:false},_this.openDialog=function(){_this.setState({uploadDialog:true});},_this.closeDialog=function(){_this.setState({uploadDialog:false});},_this.changeImage=function(src){var onChange=_this.props.onChange;onChange&&onChange(src);_this.closeDialog();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VideoChooser,[{key:'render',value:function render(){var title=this.props.title;var uploadDialog=this.state.uploadDialog;var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FormFieldContainer__["a" /* default */],{title:title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_AspectRatioContainer__["a" /* default */],{mediaClassName:css.videoContainer,onTouchTap:this.openDialog},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["AvMovie"],{style:styles.icon,color:'#535353'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_SvgIcons__["ContentAddCircleOutline"],{color:__WEBPACK_IMPORTED_MODULE_1_Css__["Colors"].creen,style:styles.addIcon}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_MediaLibrary_UploadDialog__["a" /* default */],{onRequestClose:this.closeDialog,onSuccess:this.changeImage,title:getIntlMessage('video.upload'),description:getIntlMessage('module.dropVideo'),type:'video',open:uploadDialog}));}}]);return VideoChooser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VideoChooser.propTypes={title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};VideoChooser.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* unused harmony default export */ var _unused_webpack_default_export = (VideoChooser);

/***/ }),
/* 2291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Widgets_Ozitor__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColorChooser__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SizeChooser__ = __webpack_require__(643);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={editorWrapper:'_iH',half:'_iI'};var StoreTextModuleEditor=function(_Component){_inherits(StoreTextModuleEditor,_Component);function StoreTextModuleEditor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreTextModuleEditor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreTextModuleEditor.__proto__||Object.getPrototypeOf(StoreTextModuleEditor)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(__html){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModuleDebounced(id,{__html:__html});},_this.chooseColor=function(newColor){var _this$props=_this.props,id=_this$props.id,color=_this$props.color;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{color:color===newColor?null:newColor});},_this.chooseBackgroundColor=function(newColor){var _this$props2=_this.props,id=_this$props2.id,backgroundColor=_this$props2.backgroundColor;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{backgroundColor:backgroundColor===newColor?null:newColor});},_this.chooseSize=function(size){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{size:size});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreTextModuleEditor,[{key:'render',value:function render(){var _props=this.props,__html=_props.__html,color=_props.color,size=_props.size,backgroundColor=_props.backgroundColor;var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.half},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SizeChooser__["a" /* default */],{sizes:[0,1,2,3],onChange:this.chooseSize,selected:size,title:getIntlMessage('store.size')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ColorChooser__["a" /* default */],{onChange:this.chooseBackgroundColor,title:getIntlMessage('store.backgroundColor'),selected:backgroundColor}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ColorChooser__["a" /* default */],{onChange:this.chooseColor,title:getIntlMessage('store.Color'),selected:color}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.editorWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Widgets_Ozitor__["a" /* default */],{editable:true,onChange:this.handleChange,defaultContent:__html})));}}]);return StoreTextModuleEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreTextModuleEditor.propTypes={id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,backgroundColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,size:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,__html:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};StoreTextModuleEditor.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreTextModuleEditor);

/***/ }),
/* 2292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormFieldContainer__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Tags__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_DropDown__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_iO',panel:'_iP',half:'_iQ',row:'_iR',title:'_iS',list:'_iT',selected:'_iU',grid:'_iV'};var StoreListModuleEditor=function(_Component){_inherits(StoreListModuleEditor,_Component);function StoreListModuleEditor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreListModuleEditor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreListModuleEditor.__proto__||Object.getPrototypeOf(StoreListModuleEditor)).call.apply(_ref,[this].concat(args))),_this),_this.addTag=function(tagName){var _this$props=_this.props,id=_this$props.id,filter=_this$props.filter;var tags=filter&&filter.tags||{};__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{filter:Object.assign({},filter,{tags:Object.assign({},tags,_defineProperty({},tagName,true))})});},_this.removeTag=function(tagName){var _this$props2=_this.props,id=_this$props2.id,filter=_this$props2.filter;var tags=filter&&filter.tags||{};__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{filter:Object.assign({},filter,{tags:Object.assign({},tags,_defineProperty({},tagName,false))})});},_this.handleCategoryChange=function(categoryId){var _this$props3=_this.props,id=_this$props3.id,filter=_this$props3.filter;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{filter:Object.assign({},filter,{categoryId:categoryId})});},_this.gridMode=function(){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{mode:'grid'});},_this.listMode=function(){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{mode:'list'});},_this.cardsMode=function(){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateModule(id,{mode:'cards'});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreListModuleEditor,[{key:'render',value:function render(){var _props=this.props,filter=_props.filter,categories=_props.categories;var mode=this.props.mode||'grid';// const { tags } = filter;
var tags=filter&&filter.tags||{};var categoryId=filter&&filter.categoryId||null;var getIntlMessage=this.context.getIntlMessage;var menuItems=[{payload:null,label:getIntlMessage('store.chooseCategory')}].concat(_toConsumableArray(categories.map(function(category){return{payload:category.slug,label:category.label};})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.panel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.half},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FormFieldContainer__["a" /* default */],{title:getIntlMessage('store.smallCards')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:this.gridMode,className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()(css.grid,_defineProperty({},css.selected,mode==='grid'))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.half},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FormFieldContainer__["a" /* default */],{title:getIntlMessage('store.bigCards')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:this.cardsMode,className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()(css.grid,_defineProperty({},css.selected,mode==='cards'))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.half},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FormFieldContainer__["a" /* default */],{title:getIntlMessage('store.list')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:this.listMode,className:__WEBPACK_IMPORTED_MODULE_6_classnames___default()(css.list,_defineProperty({},css.selected,mode==='list'))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.title},getIntlMessage('store.showOnlyMatching')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FormFieldContainer__["a" /* default */],{title:getIntlMessage('Tags'),leftAlign:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Tags__["b" /* TagSelector */],{dark:true,fullWidth:true,tags:tags,onAddTag:this.addTag,onRemoveTag:this.removeTag})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FormFieldContainer__["a" /* default */],{title:getIntlMessage('course.category'),leftAlign:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_DropDown__["a" /* DropDown */],{fullWidth:true,dark:true,onChange:this.handleCategoryChange,options:menuItems,selected:categoryId}))));}}]);return StoreListModuleEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreListModuleEditor.propTypes={id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,filter:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,mode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOf(['grid','list','cards']),categories:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};StoreListModuleEditor.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreListModuleEditor);

/***/ }),
/* 2293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={};var StoreFilterModuleEditor=function(_Component){_inherits(StoreFilterModuleEditor,_Component);function StoreFilterModuleEditor(){_classCallCheck(this,StoreFilterModuleEditor);return _possibleConstructorReturn(this,(StoreFilterModuleEditor.__proto__||Object.getPrototypeOf(StoreFilterModuleEditor)).apply(this,arguments));}_createClass(StoreFilterModuleEditor,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root});}}]);return StoreFilterModuleEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreFilterModuleEditor.propTypes={id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (StoreFilterModuleEditor);

/***/ }),
/* 2294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_gm'};var StoreSectionEditor=function(_Component){_inherits(StoreSectionEditor,_Component);function StoreSectionEditor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreSectionEditor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreSectionEditor.__proto__||Object.getPrototypeOf(StoreSectionEditor)).call.apply(_ref,[this].concat(args))),_this),_this.changeType=function(event){var checked=event.target.checked;var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].updateSection(id,{type:checked?'banner':'default'});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreSectionEditor,[{key:'render',value:function render(){var type=this.props.type;var fullWidth=type==='banner';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Toggle"],{labelStyle:{color:__WEBPACK_IMPORTED_MODULE_2_Css__["Colors"].fullWhite},label:'Full width',toggled:fullWidth,onToggle:this.changeType}));}}]);return StoreSectionEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreSectionEditor.propTypes={id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (StoreSectionEditor);

/***/ }),
/* 2295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Drawer__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Tasks_ScrollableContainer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Toolbar__ = __webpack_require__(80);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*global oxygenCss*/var css={root:'_eZ',row:'_e0',column:'_e1',header:'_e2',container:'_e3'};var styles={icon:{width:__WEBPACK_IMPORTED_MODULE_5_Css__["Units"].base*6,height:__WEBPACK_IMPORTED_MODULE_5_Css__["Units"].base*6}};var Icons={Text:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["EditorFormatAlignLeft"],Banner:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageLandscape"],Image:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageImage"],Video:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["AvMovie"],List:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ImageViewComfy"],Filter:__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ContentFilterList"]};var StoreModuleMenu=function(_Component){_inherits(StoreModuleMenu,_Component);function StoreModuleMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreModuleMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreModuleMenu.__proto__||Object.getPrototypeOf(StoreModuleMenu)).call.apply(_ref,[this].concat(args))),_this),_this.closeModuleMenu=function(){__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].closeModuleMenu();},_this.addList=function(){__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].addModule({type:'banner'},{type:'List'});},_this.addImage=function(){__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].addModule({type:'default'},{type:'Image',src:'/images/library.jpg',caption:null});},_this.addVideo=function(){__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].addModule({type:'default'},{type:'Video',src:null,caption:null});},_this.addBanner=function(){var getIntlMessage=_this.context.getIntlMessage;__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].addModule({type:'banner'},{type:'Banner',src:'/images/library.jpg',color:'#FFFFFF',backgroundColor:'#000000',size:1,header:getIntlMessage('storeBuilder.thisIsMyStore')});},_this.addText=function(){var getIntlMessage=_this.context.getIntlMessage;__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].addModule({type:'default'},{type:'Text',__html:getIntlMessage('storeBuilder.thisIsMyStore')});},_this.addFilter=function(){__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].addModule({type:'default'},{type:'Filter'});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreModuleMenu,[{key:'render',value:function render(){var other=_objectWithoutProperties(this.props,[]);var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Drawer__["a" /* default */],Object.assign({slide:false,className:css.root,onRequestClose:this.closeModuleMenu},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Tasks_ScrollableContainer__["a" /* default */],{padded:true,header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Toolbar__["b" /* Toolbar */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Toolbar__["d" /* ToolbarGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Toolbar__["c" /* ToolbarButton */],{onTouchTap:this.closeModuleMenu,tooltip:getIntlMessage('Close')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ContentClear"],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Toolbar__["e" /* ToolbarTitle */],null,getIntlMessage('store.addContent')))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.column,onTouchTap:this.addList},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.List,{color:'#777777',style:styles.icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},getIntlMessage('store.coursesModule'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.column,onTouchTap:this.addFilter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.Filter,{color:'#777777',style:styles.icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},getIntlMessage('store.filter')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.column,onTouchTap:this.addBanner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.Banner,{color:'#777777',style:styles.icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},getIntlMessage('store.bannerModule'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.column,onTouchTap:this.addVideo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.Video,{color:'#777777',style:styles.icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},getIntlMessage('store.videoModule')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.column,onTouchTap:this.addImage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.Image,{color:'#777777',style:styles.icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},getIntlMessage('store.imageModule'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.column,onTouchTap:this.addText},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons.Text,{color:'#777777',style:styles.icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},getIntlMessage('store.textModule')))))));}}]);return StoreModuleMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreModuleMenu.propTypes={};StoreModuleMenu.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreModuleMenu);

/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Store_StoreItem__ = __webpack_require__(2297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_selectors_store__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StoreItemContainer=function(_mixin){_inherits(StoreItemContainer,_mixin);function StoreItemContainer(){_classCallCheck(this,StoreItemContainer);return _possibleConstructorReturn(this,(StoreItemContainer.__proto__||Object.getPrototypeOf(StoreItemContainer)).apply(this,arguments));}_createClass(StoreItemContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["t" /* StoreOverviewStore */],function(state){return{loading:!state.selected||state.loading,themeColor:state.theme.color,logoUrl:state.theme.logoUrl,canIEdit:state.canIEdit,store:state.name,item:Object(__WEBPACK_IMPORTED_MODULE_7_selectors_store__["e" /* getSelectedItem */])(state),owner:state.owner};});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["b" /* AuthStore */],function(state){return{loggedIn:state.loggedIn};});}},{key:'componentDidMount',value:function componentDidMount(){var _props$params=this.props.params,username=_props$params.username,slug=_props$params.slug;var type=this.props.route.type;__WEBPACK_IMPORTED_MODULE_1_actions__["A" /* StoreOverviewActions */].start(username,type,slug);}},{key:'render',value:function render(){var purchase=this.props.params.purchase==='purchase';var username=this.props.params.username;var _state=this.state,item=_state.item,loggedIn=_state.loggedIn,loading=_state.loading,owner=_state.owner;if(!item||loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_Loader__["b" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Store_StoreItem__["a" /* default */],Object.assign({userLocale:owner.locale,userName:username,loggedIn:loggedIn,purchase:purchase},this.state,{history:__WEBPACK_IMPORTED_MODULE_6_helpers__["a" /* history */]}));}}]);return StoreItemContainer;}(Object(__WEBPACK_IMPORTED_MODULE_4_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_4_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));StoreItemContainer.propTypes={params:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,route:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (StoreItemContainer);

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_StoreBar__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_EmbeddedVideoPreview__ = __webpack_require__(2298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Widgets_ProfileImage__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Store_StoreTabs__ = __webpack_require__(2299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Store_CourseTableOfContentsContainer__ = __webpack_require__(2300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Store_CoursePackageList__ = __webpack_require__(2302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Widgets_LinkList__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Store_StoreItemEditPanel__ = __webpack_require__(2303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_containers_Store_GiftDialog__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_helmet__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TaC_StoreTaC__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_Cio_Assets_Gift__ = __webpack_require__(613);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={padded:'_ba',root:'_bb',header:'_bc',body:'_bd',backButton:'_be',main:'_bf',buyButton:'_bg',callToAction:'_bh',buttonWrapper:'_bi',giftButtonWrapper:'_bj',giftButton:'_bk',giftIcon:'_bl',videoContainer:'_bm',noVideo:'_bn',content:'_bo',sidebar:'_bp',courseTitle:'_bq',coursePrice:'_br',courseAccess:'_bs',courseAccess1:'_bt',footer:'_bu',itemInfo:'_bv',courseInfo:'_bw',spacing:'_bx',courseInfo1:'_by',packageInfo:'_bz',ownerInfo:'_bA',ownerInfo1:'_bB',profileImage:'_bC',profileImage1:'_bD',packBadge:'_bE',panel:'_bF'};var lookup={0:'Unlimited',1:'oneMonth',3:'threeMonths',6:'sixMonths',12:'oneYear',24:'twoYears'};var StoreItem=function(_Component){_inherits(StoreItem,_Component);function StoreItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreItem.__proto__||Object.getPrototypeOf(StoreItem)).call.apply(_ref,[this].concat(args))),_this),_this.state={mode:'detail',tab:'course',tac:false},_this.buyCourse=function(){__WEBPACK_IMPORTED_MODULE_17_actions__["A" /* StoreOverviewActions */].addToCart(_this.props.item);},_this.giftCourse=function(){__WEBPACK_IMPORTED_MODULE_17_actions__["A" /* StoreOverviewActions */].addToCart(_this.props.item,true);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreItem,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,purchase=_props.purchase,item=_props.item;if(purchase){__WEBPACK_IMPORTED_MODULE_17_actions__["A" /* StoreOverviewActions */].addToCart(item);}}},{key:'parseVideoUrl',value:function parseVideoUrl(videoUrl){try{var provider=JSON.parse(videoUrl);provider.id=provider.src;var parsedUrl=__WEBPACK_IMPORTED_MODULE_15_Util__["b" /* Media */].getUrlFromProvider(provider);return parsedUrl;}catch(e){try{var _parsedUrl=__WEBPACK_IMPORTED_MODULE_15_Util__["b" /* Media */].getEmbedUrl(videoUrl);return _parsedUrl;}catch(e1){return videoUrl;}}return videoUrl;}},{key:'strip',value:function strip(html){var tmp=document.createElement('div');tmp.innerHTML=html;return tmp.textContent||tmp.innerText||'';}},{key:'renderSideBar',value:function renderSideBar(item){var _classNames,_this2=this;var getIntlMessage=this.context.getIntlMessage;var _props2=this.props,themeColor=_props2.themeColor,canIEdit=_props2.canIEdit,store=_props2.store,owner=_props2.owner;var tab=this.state.tab;var type=item.type,id=item.id,presentation=item.presentation,price=item.price;var videoUrl=this.parseVideoUrl(item.videoUrl);var tabs=[{name:'course',label:getIntlMessage('store.aboutThisCourse')}];if(type===1){tabs.push({name:'content',label:getIntlMessage('store.courseContent')});}else{tabs.push({name:'content',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"],{message:getIntlMessage('store.courseCount'),count:item.courses.length})});}if(canIEdit){tabs.push({name:'edit',label:getIntlMessage('Edit')});}var links=[{href:'/tac',text:getIntlMessage('TermsAndConditions')}];var ucpPeriod=parseInt(item.ucpPeriod,10);var displayVideo=videoUrl||!videoUrl&&canIEdit;var accessMonths=Math.floor(ucpPeriod/(24*60*60*30));var accessDescription=lookup[accessMonths]?getIntlMessage('invite.'+lookup[accessMonths]):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"],{message:getIntlMessage('invite.accessMonths'),months:accessMonths});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()((_classNames={},_defineProperty(_classNames,css.sidebar,displayVideo),_defineProperty(_classNames,css.content,!displayVideo),_classNames))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Store_StoreTabs__["a" /* default */],{onChange:function onChange(nextTab){return _this2.setState({tab:nextTab});},themeColor:__WEBPACK_IMPORTED_MODULE_1_stores__["z" /* ThemeStore */].getColor(themeColor),activeTab:tab,tabs:tabs}),tab==='content'&&type===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.panel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Store_CoursePackageList__["a" /* default */],{themeColor:themeColor,courses:item.courses})),tab==='content'&&type===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.panel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Store_CourseTableOfContentsContainer__["a" /* default */],{courseId:id})),tab==='course'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.courseInfo1,_defineProperty({},css.spacing,type===1))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.courseTitle},item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.courseAccess1},this.context.getIntlMessage('invite.accessTime'),' :',' ',accessDescription,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.panel,dangerouslySetInnerHTML:{__html:presentation}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.ownerInfo1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.profileImage1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Widgets_ProfileImage__["a" /* default */],{author:{avatar:owner.avatarUrl}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.context.getIntlMessage('store.yourCourseLeader')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.courseTitle},item.ownerName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Widgets_LinkList__["a" /* default */],{links:links,style:{marginTop:'3em'},username:store,onClickLink:function onClickLink(){return _this2.setState({tac:true});}})),tab==='edit'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.panel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Store_StoreItemEditPanel__["a" /* default */],{type:type,id:id,presentation:presentation,price:price,isPublic:!!item.public,ucpPeriod:ucpPeriod,videoUrl:item.videoUrl,themeColor:__WEBPACK_IMPORTED_MODULE_1_stores__["z" /* ThemeStore */].getColor(themeColor)})));}},{key:'renderBottomBar',value:function renderBottomBar(){var getIntlMessage=this.context.getIntlMessage;var _props3=this.props,themeColor=_props3.themeColor,owner=_props3.owner,item=_props3.item;var price=item.price,currency=item.currency,type=item.type;var builderColor=__WEBPACK_IMPORTED_MODULE_1_stores__["z" /* ThemeStore */].getColor(themeColor);var ucpPeriod=parseInt(item.ucpPeriod,10);var accessMonths=Math.floor(ucpPeriod/(24*60*60*30));var accessDescription=lookup[accessMonths]?getIntlMessage('invite.'+lookup[accessMonths]):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"],{message:getIntlMessage('invite.accessMonths'),months:accessMonths});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.footer},type===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.packageInfo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.packBadge},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionViewModule"],{color:__WEBPACK_IMPORTED_MODULE_2_Css__["Colors"].fullWhite}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('store.packOf'),count:item.courses.length}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.courseInfo,_defineProperty({},css.spacing,type===1))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.courseTitle},item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.courseAccess},this.context.getIntlMessage('invite.accessTime'),' :',' ',accessDescription,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.ownerInfo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.profileImage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Widgets_ProfileImage__["a" /* default */],{author:{avatar:owner.avatarUrl}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.context.getIntlMessage('store.yourCourseLeader')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.courseTitle},item.ownerName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.callToAction},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:this.buyCourse,className:css.buyButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('store.buyFor'),price:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedNumber"],{style:'currency',currency:currency,maximumFractionDigits:0,minimumFractionDigits:0,value:Math.round(price.discounted)})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.giftButtonWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onTouchTap:this.giftCourse,className:css.giftButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_Cio_Assets_Gift__["a" /* default */],{className:css.giftIcon}),' ',this.context.getIntlMessage('store.giftCourse')))));}},{key:'renderContent',value:function renderContent(item){var getIntlMessage=this.context.getIntlMessage;var canIEdit=this.props.canIEdit;var videoUrl=this.parseVideoUrl(item.videoUrl);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.content},(videoUrl||!videoUrl&&canIEdit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.videoContainer},videoUrl&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_EmbeddedVideoPreview__["a" /* default */],{source:videoUrl}),!videoUrl&&canIEdit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:32,borderRadius:2,border:'solid 1px #BBB',backgroundColor:'#DDD',padding:'128px 64px',textAlign:'center',fontSize:24,lineHeight:'32px'}},getIntlMessage('store.chooseVideo'))));}},{key:'renderTopBar',value:function renderTopBar(item){var _props4=this.props,store=_props4.store,logoUrl=_props4.logoUrl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.topBar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_StoreBar__["a" /* default */],{store:store,logo:logoUrl,title:item.name}));}},{key:'render',value:function render(){var _this3=this;var _props5=this.props,item=_props5.item,store=_props5.store,canIEdit=_props5.canIEdit;var tac=this.state.tac;var videoUrl=item.videoUrl;var noVideo=!(videoUrl||!videoUrl&&canIEdit);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.root,_defineProperty({},css.noVideo,noVideo))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.body},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.main},this.renderContent(item)),this.renderSideBar(item)),this.renderTopBar(item),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_containers_Store_GiftDialog__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__TaC_StoreTaC__["a" /* default */],{username:store,open:tac,onRequestClose:function onRequestClose(){return _this3.setState({tac:false});}}),this.renderBottomBar(item),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_helmet___default.a,{title:item.name,meta:[{name:'twitter:card',content:'summary_large_image'},{name:'twitter:image',content:item.coverImage[0].url||'https://res.cloudinary.com/teamtailor/image/upload/c_limit,dpr_2.0,f_auto,h_65,q_80,w_200/v1476197337/divchtdesiriwvpnri3e.png'},{name:'og:title',content:item.name},{name:'og:image',content:item.coverImage[0].url||'https://res.cloudinary.com/teamtailor/image/upload/c_limit,dpr_2.0,f_auto,h_65,q_80,w_200/v1476197337/divchtdesiriwvpnri3e.png'},{name:'og:description',content:cleanWordHTML(item.presentation)}]}));}}]);return StoreItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreItem.propTypes={item:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,store:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,canIEdit:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,themeColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,logoUrl:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,owner:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,history:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,purchase:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,loggedIn:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};StoreItem.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};var cleanWordHTML=function cleanWordHTML(str){var tmp=document.createElement('DIV');tmp.innerHTML=str;var newString=tmp.textContent||tmp.innerText;newString=newString.replace(/\n\n/g,'<br />').replace(/.*<!--.*-->/g,'');// this next piece removes any break tags (up to 10) at beginning
for(var i=0;i<10;i++){if(newString.substr(0,6)==='<br />'){newString=newString.replace('<br />',' ');}}return newString.replace(/<(?:.|\n)*?>/gm,'');};/* harmony default export */ __webpack_exports__["a"] = (StoreItem);

/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Widgets__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Page_Module_Embed__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_c7',container:'_c8',normalContainer:'_c9',iframe:'_c_'};var EmbeddedVideoPreview=function(_Component){_inherits(EmbeddedVideoPreview,_Component);function EmbeddedVideoPreview(){_classCallCheck(this,EmbeddedVideoPreview);return _possibleConstructorReturn(this,(EmbeddedVideoPreview.__proto__||Object.getPrototypeOf(EmbeddedVideoPreview)).apply(this,arguments));}_createClass(EmbeddedVideoPreview,[{key:'renderIFrame',value:function renderIFrame(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.root,this.props.className),style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{className:css.iframe,src:this.props.source,allowTransparency:true,frameBorder:0,scrolling:'no',webkitAllowFullScreen:true,mozAllowFullScreen:true,allowFullSreen:true,oAllowFullScreen:true,msAllowFullScreen:true})));}},{key:'getExtension',value:function getExtension(url){url=url||'';return url.substr((~-url.lastIndexOf('.')>>>0)+2);}},{key:'renderVideoPlayer',value:function renderVideoPlayer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Widgets__["e" /* VideoPlayer */],{sources:[{url:this.props.src,type:this.getExtension(this.props.src)}]});}},{key:'renderEmptyVideo',value:function renderEmptyVideo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Widgets__["e" /* VideoPlayer */],{sources:[]});}},{key:'renderEmbed',value:function renderEmbed(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Page_Module_Embed__["a" /* default */],{provider:this.props.source.provider,id:this.props.source.src});}},{key:'render',value:function render(){if(typeof this.props.source==='string'){return this.renderIFrame();}else if(this.props.source&&this.props.source.provider){return this.renderEmbed();}else if(this.props.source&&this.props.source.src){return this.renderVideoPlayer();}else{return this.renderEmptyVideo();}// 3 standards
}}]);return EmbeddedVideoPreview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EmbeddedVideoPreview.contextTypes={media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (EmbeddedVideoPreview);

/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={container:{display:'flex',flex:'1 0 auto'},tab:{boxSizing:'border-box',flexGrow:1,textAlign:'center',height:48,lineHeight:'48px',borderStyle:'solid solid solid none',borderWidth:1,borderColor:'rgba(0, 0, 0, 0.2)',cursor:'pointer',fontWeight:'bold'},last:{borderStyle:'solid none solid none'},active:{}};var StoreTabs=function(_Component){_inherits(StoreTabs,_Component);function StoreTabs(){_classCallCheck(this,StoreTabs);return _possibleConstructorReturn(this,(StoreTabs.__proto__||Object.getPrototypeOf(StoreTabs)).apply(this,arguments));}_createClass(StoreTabs,[{key:'getTabStyle',value:function getTabStyle(active,last){var themeColor=this.props.themeColor;return Object.assign({},{color:active?themeColor:null},styles.tab,active&&styles.active,last&&styles.last);}},{key:'handleTab',value:function handleTab(tab){var _props=this.props,onChange=_props.onChange,activeTab=_props.activeTab;if(tab.name!==activeTab){onChange&&onChange(tab.name);}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,activeTab=_props2.activeTab,tabs=_props2.tabs;var count=tabs.length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.container},tabs.map(function(tab,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:tab.name,onTouchTap:_this2.handleTab.bind(_this2,tab),style:_this2.getTabStyle(tab.name===activeTab,index===count-1)},tab.label);}));}}]);return StoreTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreTabs.propTypes={tabs:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,activeTab:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,onChange:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,themeColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (StoreTabs);

/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CourseTableOfContents__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CourseTableOfContentsContainer=function(_mixin){_inherits(CourseTableOfContentsContainer,_mixin);function CourseTableOfContentsContainer(){_classCallCheck(this,CourseTableOfContentsContainer);return _possibleConstructorReturn(this,(CourseTableOfContentsContainer.__proto__||Object.getPrototypeOf(CourseTableOfContentsContainer)).apply(this,arguments));}_createClass(CourseTableOfContentsContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_2_stores__["f" /* CourseStore */],function(state){return{toc:state.toc.list,loading:state.toc.loading};},{toc:[],loading:true});}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return this.state.toc!==nextState.toc;}},{key:'componentDidMount',value:function componentDidMount(){var courseId=this.props.courseId;__WEBPACK_IMPORTED_MODULE_3_actions__["f" /* CourseActions */].getGuestToc(courseId);}},{key:'render',value:function render(){var _state=this.state,loading=_state.loading,toc=_state.toc;if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__["b" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CourseTableOfContents__["a" /* default */],{toc:toc});}}]);return CourseTableOfContentsContainer;}(Object(__WEBPACK_IMPORTED_MODULE_5_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_5_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));CourseTableOfContentsContainer.propTypes={courseId:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string])};/* harmony default export */ __webpack_exports__["a"] = (CourseTableOfContentsContainer);

/***/ }),
/* 2301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Course_TableOfContents_styles__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_cg',section:'_ch',sectionHeader:'_ci',pageHeader:'_cj'};var CourseTableOfContents=function(_Component){_inherits(CourseTableOfContents,_Component);function CourseTableOfContents(){_classCallCheck(this,CourseTableOfContents);return _possibleConstructorReturn(this,(CourseTableOfContents.__proto__||Object.getPrototypeOf(CourseTableOfContents)).apply(this,arguments));}_createClass(CourseTableOfContents,[{key:'render',value:function render(){var toc=this.props.toc;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},toc.map(function(section){if(section.name.match(/(^|\s)Quiz(\s|$)/g)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:section.id,className:css.section},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.sectionHeader},section.name),section.pages.map(function(page){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.pageHeader,key:page.id},page.name);}));}));}}]);return CourseTableOfContents;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CourseTableOfContents.propTypes={toc:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};/* harmony default export */ __webpack_exports__["a"] = (CourseTableOfContents);

/***/ }),
/* 2302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Cover__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_intl__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Colors=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Colors,Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={container:{display:'flex',flexWrap:'wrap',justifyContent:'center',alignItems:'center'},item:{width:'100%',marginBottom:Spacing.desktopGutterMore,position:'relative'},detail:{padding:Spacing.desktopGutter,boxSizing:'border-box',height:88,lineHeight:88-2*Spacing.desktopGutter+'px'},header:{fontSize:'24px',margin:0,fontWeight:100,whiteSpace:'nowrap',textOverflow:'ellipsis',overflow:'hidden'},packIcon:{verticalAlign:'middle'}};var CoursePackageList=function(_Component){_inherits(CoursePackageList,_Component);function CoursePackageList(){_classCallCheck(this,CoursePackageList);return _possibleConstructorReturn(this,(CoursePackageList.__proto__||Object.getPrototypeOf(CoursePackageList)).apply(this,arguments));}_createClass(CoursePackageList,[{key:'getPackStyle',value:function getPackStyle(themeColor){return{backgroundColor:__WEBPACK_IMPORTED_MODULE_2_stores__["z" /* ThemeStore */].getColor(themeColor),position:'absolute',top:24,left:-24,lineHeight:'24px',padding:Spacing.desktopGutterMini/4+'px '+Spacing.desktopGutterMini+'px',color:Colors.fullWhite,fontWeight:500};}},{key:'render',value:function render(){var _props=this.props,courses=_props.courses,canIEdit=_props.canIEdit,themeColor=_props.themeColor;var packStyle=this.getPackStyle(themeColor);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.container},courses.map(function(course){var name=course.name,coverUrl=course.coverUrl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Paper"],{style:styles.item,key:course.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_Cover__["a" /* default */],{backgroundColor:!canIEdit&&__WEBPACK_IMPORTED_MODULE_2_stores__["z" /* ThemeStore */].getColor(themeColor,0.5)||'rgba(0, 0, 0, 0.5)',image:coverUrl}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.detail},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.header},name)));}));}}]);return CoursePackageList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CoursePackageList.propTypes={courses:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,canIEdit:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,themeColor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};CoursePackageList.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (CoursePackageList);

/***/ }),
/* 2303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Widgets__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var styles={ozitor:{marginTop:Spacing.desktopGutter}};var StoreItemEditPanel=function(_Component){_inherits(StoreItemEditPanel,_Component);function StoreItemEditPanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StoreItemEditPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StoreItemEditPanel.__proto__||Object.getPrototypeOf(StoreItemEditPanel)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.statusChange=function(event){_this.change({public:event.target.checked});},_this.changeVideo=function(event){_this.change({videoUrl:event.target.value});},_this.changePrice=function(event){var price=_this.props.price;var gross=parseInt(event.target.value,10);var net=gross/(price.gross/price.net||1.25);_this.change({price:{net:net,gross:gross,discounted:gross}});},_this.changePresentation=function(presentation){_this.change({presentation:presentation});},_this.queueSave=function(){if(_this._timer){_this._save=true;}else{_this.save();}},_this.save=function(props){var _this$props=_this.props,id=_this$props.id,type=_this$props.type;__WEBPACK_IMPORTED_MODULE_5_actions__["A" /* StoreOverviewActions */].pushStoreItem(Object.assign({id:id,type:type},props));},_this.changeAccessTime=function(event,selectedIndex,menuItem){_this.change({ucpPeriod:menuItem.payload});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StoreItemEditPanel,[{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this._timer);this.change({});}},{key:'change',value:function change(props){var _this2=this;var _props=this.props,id=_props.id,type=_props.type;if(this._timer){clearTimeout(this._timer);}this._timer=setTimeout(function(){if(_this2._save){_this2._save=false;_this2.save(Object.assign({id:id,type:type},props));}else{__WEBPACK_IMPORTED_MODULE_5_actions__["A" /* StoreOverviewActions */].changeStoreItem(Object.assign({id:id,type:type},props));}_this2._timer=null;},500);}},{key:'parseVideoUrl',value:function parseVideoUrl(videoUrl){try{var provider=JSON.parse(videoUrl);provider.id=provider.src;return __WEBPACK_IMPORTED_MODULE_1_Util__["b" /* Media */].getUrlFromProvider(provider);}catch(e){return videoUrl;}}},{key:'render',value:function render(){var _props2=this.props,price=_props2.price,presentation=_props2.presentation,isPublic=_props2.isPublic,ucpPeriod=_props2.ucpPeriod,themeColor=_props2.themeColor;var videoUrl=this.parseVideoUrl(this.props.videoUrl);var month=24*60*60*30;var year=31536000;var menuItems=[{payload:null,text:this.context.getIntlMessage('invite.chooseAccessTime')},{payload:month,text:this.context.getIntlMessage('invite.oneMonth')},{payload:3*month,text:this.context.getIntlMessage('invite.threeMonths')},{payload:year/2,text:this.context.getIntlMessage('invite.sixMonths')},{payload:year,text:this.context.getIntlMessage('invite.oneYear')},{payload:year*1.5,text:this.context.getIntlMessage('invite.oneAndHalfYear')},{payload:year*2,text:this.context.getIntlMessage('invite.twoYears')}];var period=Math.floor(ucpPeriod/month);var selectedIndex=menuItems.findIndex(function(access){return access.payload===ucpPeriod;});if(selectedIndex<0){if(period>18){selectedIndex=6;}else if(period>12){selectedIndex=5;}else if(period>6){selectedIndex=4;}else if(period>3){selectedIndex=3;}else if(period>1){selectedIndex=2;}else{selectedIndex=1;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('Save'),onTouchTap:this.queueSave,backgroundColor:themeColor,fullWidth:true,secondary:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["SelectField"],{onChange:this.changeAccessTime,floatingLabelText:this.context.getIntlMessage('course.access'),floatingLabelStyle:{transform:'perspective(1px) scale(0.75) translate3d(2px, -28px, 0)'},menuItems:menuItems,selectedIndex:selectedIndex,fullWidth:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["TextField"],{fullWidth:true,multiline:true,floatingLabelText:this.context.getIntlMessage('store.grossPrice'),defaultValue:Math.round(price.gross*100)/100,onChange:this.changePrice}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Toggle"],{label:this.context.getIntlMessage('store.public'),defaultToggled:isPublic,onToggle:this.statusChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["TextField"],{fullWidth:true,floatingLabelText:this.context.getIntlMessage('store.video'),hintText:this.context.getIntlMessage('store.video'),defaultValue:videoUrl,onChange:this.changeVideo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.ozitor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Widgets__["c" /* Ozitor */],{disabledControls:__WEBPACK_IMPORTED_MODULE_4_Constants__["default"].OZITOR_DISABLED_CONTROLS,editable:true,defaultContent:presentation,onChange:this.changePresentation})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('Save'),onTouchTap:this.queueSave,backgroundColor:themeColor,fullWidth:true,secondary:true}));}}]);return StoreItemEditPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreItemEditPanel.propTypes={price:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,videoUrl:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,presentation:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,isPublic:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,ucpPeriod:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string])};StoreItemEditPanel.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (StoreItemEditPanel);

/***/ }),
/* 2304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Route_Discount_Detail__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_Discount__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_Loader__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DiscountDetailContainer=function(_mixin){_inherits(DiscountDetailContainer,_mixin);function DiscountDetailContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DiscountDetailContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DiscountDetailContainer.__proto__||Object.getPrototypeOf(DiscountDetailContainer)).call.apply(_ref,[this].concat(args))),_this),_this.goBack=function(){_this.props.router.push('/discounts');__WEBPACK_IMPORTED_MODULE_4_actions_Discount__["a" /* default */].read();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DiscountDetailContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores__["h" /* DiscountStore */]);}},{key:'componentDidMount',value:function componentDidMount(){if(_get(DiscountDetailContainer.prototype.__proto__||Object.getPrototypeOf(DiscountDetailContainer.prototype),'componentDidMount',this)){_get(DiscountDetailContainer.prototype.__proto__||Object.getPrototypeOf(DiscountDetailContainer.prototype),'componentDidMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_4_actions_Discount__["a" /* default */].findById(this.props.params.discountId);}// shouldComponentUpdate(nextProps, nextState) {
//   return (this.props.routeParams.discountId !== nextProps.routeParams.discountId) || (this.state.discount !== nextState.discount);
// }
},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.routeParams.discountId!==nextProps.routeParams.discountId){__WEBPACK_IMPORTED_MODULE_4_actions_Discount__["a" /* default */].findById(nextProps.routeParams.discountId);}}},{key:'render',value:function render(){var discount=this.state.discount;if(!discount){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_Loader__["b" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Route_Discount_Detail__["a" /* default */],{discount:discount,onClose:this.goBack});}}]);return DiscountDetailContainer;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));DiscountDetailContainer.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (DiscountDetailContainer);

/***/ }),
/* 2305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_Grid__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectableList=function(_Component){_inherits(SelectableList,_Component);function SelectableList(){_classCallCheck(this,SelectableList);var _this=_possibleConstructorReturn(this,(SelectableList.__proto__||Object.getPrototypeOf(SelectableList)).apply(this,arguments));var selected={},idProperty=_this.props.idProperty,selectedCount=0,labelProperty=_this.props.labelProperty;_this.props.preSelected.map(function(item){selectedCount++;selected[item[idProperty]]=item[labelProperty];});if(_this.props.onSelect&&selectedCount>0){_this.props.onSelect(selected,selectedCount);}_this.state={searchText:null,selectedCount:selectedCount,selected:selected};return _this;}_createClass(SelectableList,[{key:'onSearchTextChange',value:function onSearchTextChange(event){var _this2=this;var timerId=this.timerId;if(timerId){clearTimeout(timerId);}timerId=setTimeout(function(){var searchText=null,fieldValue=_this2.refs.searchField.getValue();if(fieldValue!==''){searchText=fieldValue.toUpperCase();}_this2.setState({searchText:searchText});},500);this.timerId=timerId;}},{key:'selectItem',value:function selectItem(item){var selected=void 0,id=item[this.props.idProperty],selectedCount=this.state.selectedCount,selectedLabel=item[this.props.selectProperty];if(this.props.singleChoice){selected={};selectedCount=0;}else{selected=this.state.selected;}if(selected[id]){delete selected[id];}else{selected[id]=selectedLabel;}if(selected[id]){selectedCount=selectedCount+1;}else{selectedCount=selectedCount-1;}this.setState({selected:selected,selectedCount:selectedCount,selectedLabel:selectedLabel});if(this.props.onSelect){this.props.onSelect(this.state.selected,selectedCount);}}},{key:'markAll',value:function markAll(markSelected){var _this3=this;var items=void 0,selected=this.state.selected,searchText=this.state.searchText,idProperty=this.props.idProperty,labelProperty=this.props.labelProperty,selectProperty=this.props.selectProperty,selectedCount=0,selectedList=[];markSelected=!!markSelected;if(markSelected){this.props.list.map(function(item){if(searchText===null||item[_this3.props.labelProperty].toUpperCase().search(searchText)>-1){selected[item[idProperty]]=item[selectProperty];selectedCount++;}});}else{selected={};selectedCount=0;}this.setState({selected:selected,selectedCount:selectedCount});if(this.props.onSelect){this.props.onSelect(this.state.selected,selectedCount);}}},{key:'renderControls',value:function renderControls(){if(!this.props.searchBar&&!this.props.controls){return null;}else{var children=[];if(this.props.searchBar){children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_Grid__["a" /* GridCell */],{size:12,key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'search-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["TextField"],{icon:'md md-search',hintText:this.props.searchHint,ref:'searchField',onChange:this.onSearchTextChange.bind(this)}))));}if(this.props.controls){children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_Grid__["a" /* GridCell */],{size:6,key:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["FlatButton"],{label:this.context.getIntlMessage('selectAll'),onTouchTap:this.markAll.bind(this,true)}))));children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_Grid__["a" /* GridCell */],{size:6,key:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["FlatButton"],{label:this.context.getIntlMessage('deselectAll'),onTouchTap:this.markAll.bind(this,false)}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_Grid__["b" /* GridContainer */],{fluid:true,className:'controls'},children);}}},{key:'renderSummary',value:function renderSummary(){var summary=null;if(this.state.selectedCount>0){summary=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('selectedCount'),num:this.state.selectedCount});}else{return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'summary'},summary);}},{key:'render',value:function render(){var _this4=this;var items=void 0,children=void 0,controls=void 0,summary=void 0,classes=void 0,title=void 0;var list=this.props.list||[];items=list.filter(function(item){var searchText=_this4.state.searchText;return searchText===null||item[_this4.props.labelProperty].toUpperCase().search(searchText)>-1;});children=items.map(function(item){var id=item[_this4.props.idProperty],selected=_this4.state.selected[id],itemClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('list-item',{selected:selected}),selectedItem=null;if(selected){selectedItem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'check'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["FontIcon"],{className:'md md-done'}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id,className:itemClasses,onTouchTap:_this4.selectItem.bind(_this4,item)},item[_this4.props.labelProperty],selectedItem);});controls=this.renderControls();summary=this.renderSummary();classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('selectable-list',this.props.className,{'has-summary':this.props.summary&&!!summary});title=typeof this.props.title==='string'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.props.title):this.props.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-wrapper'},title,controls,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list'},children)),summary);}}]);return SelectableList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectableList.propTypes={searchHint:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,singleChoice:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,list:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array.isRequired,labelProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,selectProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,idProperty:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,preSelected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,controls:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,searchBar:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,summary:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onSelect:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,title:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object])};SelectableList.defaultProps={singleChoice:false,labelProperty:'name',selectProperty:'name',idProperty:'id',searchHint:'Search',preSelected:[],searchBar:true,summary:true,controls:false};SelectableList.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* unused harmony default export */ var _unused_webpack_default_export = (SelectableList);

/***/ }),
/* 2306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ListSelector__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_Course__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores_Bundle__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_Bundle__ = __webpack_require__(236);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CourseSelector=function(_mixin){_inherits(CourseSelector,_mixin);function CourseSelector(){_classCallCheck(this,CourseSelector);return _possibleConstructorReturn(this,(CourseSelector.__proto__||Object.getPrototypeOf(CourseSelector)).apply(this,arguments));}_createClass(CourseSelector,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores_Bundle__["a" /* default */]);}},{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_6_actions_Bundle__["a" /* default */].read();}},{key:'getSelected',value:function getSelected(){return this.refs.list.getSelected();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ListSelector__["a" /* default */],Object.assign({ref:'list',searchHint:this.context.getIntlMessage('bundle.choose')},this.props,{items:this.state.list}));}}]);return CourseSelector;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));CourseSelector.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (CourseSelector);

/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_Discount__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_Discount__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_ListDetail__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Route_Discount_Detail__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentAdd=__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ContentAdd"];var Discounts=function(_mixin){_inherits(Discounts,_mixin);function Discounts(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Discounts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Discounts.__proto__||Object.getPrototypeOf(Discounts)).call.apply(_ref,[this].concat(args))),_this),_this.state={valid:false,errorText:null},_this.handleChange=function(event){var getIntlMessage=_this.context.getIntlMessage;var value=event.target.value;if(value.length<=30){_this.setState({errorText:!value&&getIntlMessage('discount.codeRequired'),valid:!!value});}else{__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(_this.context.getIntlMessage('discount.codeRestriction'));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Discounts,[{key:'listenToStores',/**
   * Listen to the DiscountStore and AppStore
   *
   */value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores_Discount__["a" /* default */],'discount');}/**
   * Listen to actions and update state as needed
   */},{key:'listenToActions',value:function listenToActions(){this.listenToAction(__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].genericError,this.onError.bind(this));}/**
   * Display error through the Message Service.
   *
   * @param  {string} errorMessage Error message to display
   */},{key:'onError',value:function onError(errorMessage){__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(errorMessage);}/**
   * Read all discounts on mount
   */},{key:'componentWillMount',value:function componentWillMount(){if(_get(Discounts.prototype.__proto__||Object.getPrototypeOf(Discounts.prototype),'componentWillMount',this)){_get(Discounts.prototype.__proto__||Object.getPrototypeOf(Discounts.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].read();}/**
   * Select a particular discount. This will result in the details of this discount
   * to be displayed. If the current selected discount is different than the already
   * selected one, also invoke an action.
   *
   * @param  {object} discount Discount to select
   */},{key:'gotoDiscount',value:function gotoDiscount(discount){this.props.router.push('/discount/'+discount.id);__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].read();}/**
   * Display a dialog for creating a new discount
   */},{key:'addDiscountForm',value:function addDiscountForm(){this.refs.createDialog.show();}/**
   * Confirms the creation of a discount and invokes the proper action
   * @return {[type]} [description]
   */},{key:'onConfirmCreate',value:function onConfirmCreate(){var code=this.refs.discountName.getValue();if(code&&code!==''&&code.length<=30){this.refs.createDialog.dismiss();__WEBPACK_IMPORTED_MODULE_5_actions_Discount__["a" /* default */].create({code:code,discount:1,maxCount:'0',active:true});}else{__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(this.context.getIntlMessage('discount.codeRestriction'));}}},{key:'render',value:function render(){var discounts=this.state.discount.list;var _state=this.state,errorText=_state.errorText,valid=_state.valid;var detail=void 0;var standardActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FlatButton"],{disabled:!valid,key:'ok',label:this.context.getIntlMessage('Create'),secondary:true,className:'full',onTouchTap:this.onConfirmCreate.bind(this)})];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_RulerBar__["a" /* default */],{title:this.context.getIntlMessage('menu.Discounts')}),className:'discounts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ListDetail__["a" /* default */],{items:discounts,labelProperty:'code',onTouchTapItem:this.gotoDiscount.bind(this),hasDivider:false,floatingActionButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FloatingActionButton"],{onTouchTap:this.addDiscountForm.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentAdd,null))},this.props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{ref:'createDialog',title:this.context.getIntlMessage('discount.new'),actions:standardActions,dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{onChange:this.handleChange,errorText:errorText,ref:'discountName',fullWidth:true,hintText:this.context.getIntlMessage('discount.enterCode'),floatingLabelText:this.context.getIntlMessage('discount.code')})));}}]);return Discounts;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_2_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));Discounts.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Discounts);

/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AcceptInvitation__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AcceptInvitationContainer=function(_mixin){_inherits(AcceptInvitationContainer,_mixin);function AcceptInvitationContainer(){_classCallCheck(this,AcceptInvitationContainer);return _possibleConstructorReturn(this,(AcceptInvitationContainer.__proto__||Object.getPrototypeOf(AcceptInvitationContainer)).apply(this,arguments));}_createClass(AcceptInvitationContainer,[{key:'componentDidMount',value:function componentDidMount(){var hash=this.props.params.hash;__WEBPACK_IMPORTED_MODULE_6_actions__["k" /* InvitationActions */].check(hash);}},{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores__["b" /* AuthStore */],'auth');this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores__["j" /* InvitationStore */],'invitation');}},{key:'render',value:function render(){var hash=this.props.params.hash;var invitation=this.state.invitation.invitation;var usedByMe=invitation.usedByMe,loading=invitation.loading,email=invitation.email,expired=invitation.expired,accepted=invitation.accepted,accepting=invitation.accepting,used=invitation.used,limit=invitation.limit,count=invitation.count,owner=invitation.owner,course=invitation.course;var _state$auth=this.state.auth,loggedIn=_state$auth.loggedIn,locale=_state$auth.locale;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AcceptInvitation__["a" /* default */],{count:count,limit:limit,loading:loading,locale:locale,used:used,usedByMe:usedByMe,accepting:accepting,accepted:accepted||usedByMe,expired:expired,loggedIn:loggedIn,hash:hash,email:email,owner:owner,course:course});}}]);return AcceptInvitationContainer;}(Object(__WEBPACK_IMPORTED_MODULE_5_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_5_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));AcceptInvitationContainer.displayName='AcceptInvitationContainer';AcceptInvitationContainer.propTypes={params:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};AcceptInvitationContainer.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (AcceptInvitationContainer);

/***/ }),
/* 2309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RegisterForm__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CountdownTimer__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Material_Loader__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var Units=__WEBPACK_IMPORTED_MODULE_11_Css__["default"].Units;var css={message:'_-'};var AcceptInvitation=function(_Component){_inherits(AcceptInvitation,_Component);function AcceptInvitation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AcceptInvitation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AcceptInvitation.__proto__||Object.getPrototypeOf(AcceptInvitation)).call.apply(_ref,[this].concat(args))),_this),_this.state={accepted:false},_this.accept=function(){if(_this.props.loggedIn){__WEBPACK_IMPORTED_MODULE_7_actions__["k" /* InvitationActions */].accept(_this.props.hash);}},_this.redirect=function(){__WEBPACK_IMPORTED_MODULE_8_helpers__["a" /* history */].replace('/dashboard');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AcceptInvitation,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!this.props.loggedIn&&nextProps.loggedIn){__WEBPACK_IMPORTED_MODULE_7_actions__["k" /* InvitationActions */].accept(this.props.hash);}if(nextProps.owner&&nextProps.owner.locale!==this.props.locale){__WEBPACK_IMPORTED_MODULE_7_actions__["b" /* AuthActions */].setLocale(nextProps.owner.locale);}}},{key:'render',value:function render(){var _props=this.props,loading=_props.loading,expired=_props.expired,accepted=_props.accepted,loggedIn=_props.loggedIn,usedByMe=_props.usedByMe,accepting=_props.accepting,used=_props.used,email=_props.email,owner=_props.owner,course=_props.course,limit=_props.limit,count=_props.count,hash=_props.hash;if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_Loader__["b" /* default */],null);}var message=null;var emailMessage=null;if(expired){message=this.context.getIntlMessage('invitation.expired');emailMessage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:'+owner.email+'?subject=Expired Invitation Link for Course: '+course.name},'Click here'),' ','to contact the course creator for another link');}else if(used&&!usedByMe&&limit<=1){message=this.context.getIntlMessage('invitation.used');}else if(accepted){var color=__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].green[500].material;message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["NavigationCheck"],{color:color,style:{verticalAlign:'middle'}}),this.context.getIntlMessage('invitation.accepted'));}else if(!accepting&&limit<=1){message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('invitation.acceptText'),email:this.props.email});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_FullScreenDialog__["a" /* default */],{padded:true,title:this.context.getIntlMessage('invitation.accept'),overlay:false,open:true},message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.message},message,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),emailMessage),limit===count&&(accepted||usedByMe)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},this.context.getIntlMessage('invitation.redirectIncoming'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CountdownTimer__["a" /* default */],{seconds:3,color:'#777',alpha:0.3,size:128,onComplete:this.redirect})),limit===count&&!(accepted||usedByMe)&&used&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},this.context.getIntlMessage('invitation.redirectLoginPage'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CountdownTimer__["a" /* default */],{seconds:4,color:'#777',alpha:0.3,size:128,onComplete:this.redirect})),!loggedIn&&!expired&&(!used||count<=limit)&&!accepting&&(!accepted||count<=limit)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_RegisterForm__["a" /* default */],{title:' ',ref:'registerForm',hash:hash,userName:owner.username,userEmail:email,userLocale:owner.locale}),accepting&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.message},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["CircularProgress"],{mode:'indeterminate'})),loggedIn&&!accepted&&!usedByMe&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{disabled:expired,fullWidth:true,secondary:true,label:this.context.getIntlMessage('Accept'),onTouchTap:this.accept}));}}]);return AcceptInvitation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AcceptInvitation.propTypes={accepted:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,loggedIn:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,expired:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,hash:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};AcceptInvitation.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (AcceptInvitation);

/***/ }),
/* 2310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AcceptGift__ = __webpack_require__(2311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_Loader__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AcceptGiftContainer=function(_mixin){_inherits(AcceptGiftContainer,_mixin);function AcceptGiftContainer(){_classCallCheck(this,AcceptGiftContainer);return _possibleConstructorReturn(this,(AcceptGiftContainer.__proto__||Object.getPrototypeOf(AcceptGiftContainer)).apply(this,arguments));}_createClass(AcceptGiftContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores__["b" /* AuthStore */],'auth');this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores__["j" /* InvitationStore */],'invitation');}},{key:'componentDidMount',value:function componentDidMount(){var giftCode=this.props.params.giftCode;if(giftCode){__WEBPACK_IMPORTED_MODULE_6_actions__["k" /* InvitationActions */].checkGiftCode(giftCode);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return nextState.auth.loggedIn!==this.state.auth.loggedIn||nextState.invitation!==this.state.invitation;}},{key:'render',value:function render(){var giftCode=this.props.params.giftCode;var invitation=this.state.invitation.invitation;var usedByMe=invitation.usedByMe,error=invitation.error,email=invitation.email,expired=invitation.expired,accepted=invitation.accepted,accepting=invitation.accepting,used=invitation.used,owner=invitation.owner,course=invitation.course;var loggedIn=this.state.auth.loggedIn;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AcceptGift__["a" /* default */],{giftCode:giftCode,used:used,accepting:accepting,accepted:accepted||usedByMe,usedByMe:usedByMe,expired:expired,loggedIn:loggedIn,email:email,owner:owner,course:course,error:error});}}]);return AcceptGiftContainer;}(Object(__WEBPACK_IMPORTED_MODULE_5_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_5_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));AcceptGiftContainer.propTypes={params:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};AcceptGiftContainer.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (AcceptGiftContainer);

/***/ }),
/* 2311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RegisterForm__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_CountdownTimer__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Cio_Assets_QuestionMark__ = __webpack_require__(2312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Cio_Assets_EmailGift__ = __webpack_require__(2313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Cio_TooltipContainer__ = __webpack_require__(2314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_CoursioLogo__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_Util_isDblTouchTap__ = __webpack_require__(2315);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var css={message:'_V',error:'_W',root:'_X',subHeader:'_Y',inputWrapper:'_Z',needAccount:'_0',giftInput:'_1',hasText:'_2',giftButton:'_3',left:'_4',coursioLogo:'_5',giftBanner:'_6',right:'_7',emailGift:'_8',giftWrapper:'_9',secret:'__'};var styles={icon:{width:32,height:32,verticalAlign:'middle'}};var AcceptGift=function(_Component){_inherits(AcceptGift,_Component);function AcceptGift(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AcceptGift);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AcceptGift.__proto__||Object.getPrototypeOf(AcceptGift)).call.apply(_ref,[this].concat(args))),_this),_this.state={accepted:false,readyToAccept:false,secretActivated:false,giftCode:_this.props.giftCode},_this.readyToAccept=function(){if(_this.props.loggedIn){__WEBPACK_IMPORTED_MODULE_6_actions__["k" /* InvitationActions */].acceptGift(_this.state.giftCode);}else{__WEBPACK_IMPORTED_MODULE_6_actions__["k" /* InvitationActions */].checkGiftCode(_this.state.giftCode);}},_this.redirect=function(){__WEBPACK_IMPORTED_MODULE_7_helpers__["a" /* history */].push('/dashboard');},_this.gotoLogin=function(){__WEBPACK_IMPORTED_MODULE_7_helpers__["a" /* history */].push('/dashboard');},_this.handleSecretTouch=function(event){if(Object(__WEBPACK_IMPORTED_MODULE_16_Util_isDblTouchTap__["a" /* default */])(event)){_this.setState({secretActivated:true});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AcceptGift,[{key:'componentDidMount',value:function componentDidMount(){if(this.input){this.input.focus();}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!this.props.owner&&nextProps.owner){this.setState({readyToAccept:true});}if(!this.props.loggedIn&&nextProps.loggedIn){__WEBPACK_IMPORTED_MODULE_6_actions__["k" /* InvitationActions */].acceptGift(this.state.giftCode);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,expired=_props.expired,accepted=_props.accepted,loggedIn=_props.loggedIn,error=_props.error,usedByMe=_props.usedByMe,accepting=_props.accepting,used=_props.used;var _state=this.state,giftCode=_state.giftCode,readyToAccept=_state.readyToAccept,secretActivated=_state.secretActivated;var getIntlMessage=this.context.getIntlMessage;var message=null;var empty=!giftCode||giftCode.length!==6;if(expired){message=getIntlMessage('gift.expired');}else if(usedByMe&&accepted&&used){var color=__WEBPACK_IMPORTED_MODULE_13_Css__["Colors"].material.green[500].hex;message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["NavigationCheck"],{color:color,style:{verticalAlign:'middle'}}),getIntlMessage('gift.accepted'));}else if(used){message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,getIntlMessage('gift.used'),getIntlMessage('gift.help'));}else if(!accepting){message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.subHeader},getIntlMessage('gift.acceptSubText')));}var tooltip=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"],{message:getIntlMessage('aboutCoursio'),link:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.coursio.com'},'coursio.com')});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_FullScreenDialog__["a" /* default */],{toolbar:false,open:readyToAccept&&!loggedIn,padded:true,onRequestClose:function onRequestClose(){return _this2.setState({readyToAccept:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_RegisterForm__["a" /* default */],{title:getIntlMessage('account.create')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.left},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.coursioLogo,onTouchTap:function onTouchTap(){return _this2.gotoLogin();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_CoursioLogo__["a" /* default */],{width:32}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Sign in')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.giftBanner,onTouchTap:this.handleSecretTouch,onDoubleClick:function onDoubleClick(){return _this2.setState({secretActivated:true});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.giftWrapper},secretActivated?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.secret}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_Cio_Assets_EmailGift__["a" /* default */],{className:css.emailGift})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.right},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(_defineProperty({},css.error,accepted&&used&&!usedByMe),css.message)},message),usedByMe&&accepted&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},getIntlMessage('gift.redirectIncoming'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_CountdownTimer__["a" /* default */],{seconds:3,color:'#777',alpha:0.3,size:128,onComplete:this.redirect})),accepting&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.message},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["CircularProgress"],{mode:'indeterminate'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.inputWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:function ref(input){return _this2.input=input;},maxLength:'6',placeholder:'T1E3L7',className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(css.giftInput,_defineProperty({},css.hasText,!empty)),value:giftCode,onChange:function onChange(event){return _this2.setState({giftCode:event.target.value});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:readyToAccept||empty,className:css.giftButton,onTouchTap:this.readyToAccept},readyToAccept&&!accepted?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__["NavigationCheck"],{color:'#FFF',style:styles.icon}):getIntlMessage('Continue'))),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.error},getIntlMessage('gift.doesNotExist')),!loggedIn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.needAccount},getIntlMessage('gift.needCoursioAccount'),'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_Cio_TooltipContainer__["a" /* default */],{width:192,tooltip:tooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_Cio_Assets_QuestionMark__["a" /* default */],null))))));}}]);return AcceptGift;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AcceptGift.propTypes={accepted:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,loggedIn:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,expired:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,giftCode:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};AcceptGift.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (AcceptGift);

/***/ }),
/* 2312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_dg'};var Gift=function(_Component){_inherits(Gift,_Component);function Gift(){_classCallCheck(this,Gift);return _possibleConstructorReturn(this,(Gift.__proto__||Object.getPrototypeOf(Gift)).apply(this,arguments));}_createClass(Gift,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({},this.props,{xmlns:'http://www.w3.org/2000/svg',width:'16',height:'16',viewBox:'0 0 16 16',version:'1.1',className:css.root,stroke:'none',strokeWidth:'1',fillRule:'evenodd',opacity:'0.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M8,0 C3.6,0 0,3.6 0,8 C0,12.4 3.6,16 8,16 C12.4,16 16,12.4 16,8 C16,3.6 12.4,0 8,0 L8,0 Z M8,13 C7.4,13 7,12.6 7,12 C7,11.4 7.4,11 8,11 C8.6,11 9,11.4 9,12 C9,12.6 8.6,13 8,13 L8,13 Z M9.5,8.4 C9,8.7 9,8.8 9,9 L9,10 L7,10 L7,9 C7,7.7 7.8,7.1 8.4,6.7 C8.9,6.4 9,6.3 9,6 C9,5.4 8.6,5 8,5 C7.6,5 7.3,5.2 7.1,5.5 L6.6,6.4 L4.9,5.4 L5.4,4.5 C5.9,3.6 6.9,3 8,3 C9.7,3 11,4.3 11,6 C11,7.4 10.1,8 9.5,8.4 L9.5,8.4 Z'}));}}]);return Gift;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Gift);

/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_df'};var EmailGift=function(_Component){_inherits(EmailGift,_Component);function EmailGift(){_classCallCheck(this,EmailGift);return _possibleConstructorReturn(this,(EmailGift.__proto__||Object.getPrototypeOf(EmailGift)).apply(this,arguments));}_createClass(EmailGift,[{key:'render',value:function render(){var _props=this.props,className=_props.className,other=_objectWithoutProperties(_props,['className']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({},other,{xmlns:'http://www.w3.org/2000/svg',width:'352',height:'352',viewBox:'0 0 352 352',version:'1.1',className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.root,className),stroke:'none',strokeWidth:'1',fillRule:'evenodd'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{stroke:'none',strokeWidth:'1',fill:'none','fill-rule':'evenodd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{fill:'#FFFFFF',cx:'176',cy:'176',r:'176'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{transform:'translate(100.336449, 100.336449)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M138.740274,111.850467 C135.28972,107.738318 124.872263,102.803738 124.872263,102.803738 L118.292824,107.327103 L118.978204,116.373832 L136.11215,116.785047 L138.740274,111.850467 Z',fill:'#EAD8C5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M108.560748,0 C94.2102011,0 86.1926938,11.6778467 82.2429907,20.1754228 C78.2932875,11.6778467 70.2757802,0 55.9252336,0 C46.856003,0 39.4766355,7.37936748 39.4766355,16.4485981 C39.4766355,25.5178288 46.856003,32.8971963 55.9252336,32.8971963 L82.2429907,32.8971963 L108.560748,32.8971963 C117.629978,32.8971963 125.009346,25.5178288 125.009346,16.4485981 C125.009346,7.37936748 117.629978,0 108.560748,0 Z M55.9252336,26.317757 C50.4830505,26.317757 46.0560748,21.8907813 46.0560748,16.4485981 C46.0560748,11.006415 50.4830505,6.57943925 55.9252336,6.57943925 C68.441597,6.57943925 75.0660067,19.5054056 77.6874856,26.317757 L55.9252336,26.317757 Z M108.560748,26.317757 L86.7984957,26.317757 C89.4199746,19.5054056 96.0443843,6.57943925 108.560748,6.57943925 C114.002931,6.57943925 118.429907,11.006415 118.429907,16.4485981 C118.429907,21.8907813 114.002931,26.317757 108.560748,26.317757 Z',fill:'#4CDEE0'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M131.588785,111.850467 L29.6074766,111.850467 C27.7905974,111.850467 26.317757,110.377594 26.317757,108.560748 L26.317757,49.3457944 C26.317757,47.5289151 27.7905974,46.0560748 29.6074766,46.0560748 L134.878505,46.0560748 C136.695351,46.0560748 138.168224,47.5289151 138.168224,49.3457944 L138.168224,105.271028 C138.168224,108.904754 135.222511,111.850467 131.588785,111.850467 Z',fill:'#DEDEDE'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M144.747664,52.635514 L19.7383178,52.635514 C16.1045921,52.635514 13.1588785,49.6898004 13.1588785,46.0560748 L13.1588785,32.8971963 C13.1588785,29.2634707 16.1045921,26.317757 19.7383178,26.317757 L144.747664,26.317757 C148.381389,26.317757 151.327103,29.2634707 151.327103,32.8971963 L151.327103,46.0560748 C151.327103,49.6898004 148.381389,52.635514 144.747664,52.635514 Z',fill:'#FBFBFB'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{fill:'#4CDFE0',x:'65.7943925',y:'26.317757',width:'32.8971963',height:'26.317757'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{fill:'#45CFD0',x:'65.7943925',y:'52.635514',width:'32.8971963',height:'59.2149533'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M138.740274,111.850467 L52.635514,111.850467 C49.0017884,111.850467 46.0560748,108.904754 46.0560748,105.271028 L46.0560748,105.271028 C46.0560748,101.637302 49.0017884,98.6915888 52.635514,98.6915888 L81.6850213,98.6915888 C87.0285129,98.6915888 91.8180815,94.6905989 92.0981353,89.3544434 C92.3968419,83.662735 87.8711417,78.953271 82.2429907,78.953271 L0,78.953271 L0,126.585121 L54.1133219,149.144111 C60.1032434,151.389542 66.7302849,151.357993 72.8268262,149.818766 L145.505845,123.762838 C143.976422,118.662029 141.64128,114.757296 138.740274,111.850467 Z',fill:'#ECCDAB'}))));}}]);return EmailGift;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EmailGift.propTypes={className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (EmailGift);

/***/ }),
/* 2314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Cio_Tooltip__ = __webpack_require__(413);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_de'};var TooltipContainer=function(_Component){_inherits(TooltipContainer,_Component);function TooltipContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TooltipContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TooltipContainer.__proto__||Object.getPrototypeOf(TooltipContainer)).call.apply(_ref,[this].concat(args))),_this),_this.state={hover:false,active:false},_this.handleMouseEnter=function(){_this.setState({hover:true});},_this.handleTouchTap=function(){_this.setState({hover:!_this.state.hover});},_this.handleMouseLeave=function(){_this.setState({hover:false});},_this.handleFocus=function(){_this.setState({active:true});},_this.handleBlur=function(){_this.setState({active:false});},_this.getNode=function(){return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TooltipContainer,[{key:'render',value:function render(){var handlers={onFocus:this.handleFocus,onBlur:this.handleBlur,onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave,onTouchTap:this.handleTouchTap};var _state=this.state,hover=_state.hover,active=_state.active;var _props=this.props,tooltip=_props.tooltip,children=_props.children,other=_objectWithoutProperties(_props,['tooltip','children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:css.root},handlers,{tabIndex:0}),children,(hover||active)&&tooltip&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Cio_Tooltip__["a" /* default */],Object.assign({anchorTo:this.getNode},other),tooltip));}}]);return TooltipContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TooltipContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,tooltip:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (TooltipContainer);

/***/ }),
/* 2315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dblTouchTapMaxDelay=300;var latestTouchTap={time:0,target:null};/* harmony default export */ __webpack_exports__["a"] = (function(event){var touchTap={time:new Date().getTime(),target:event.currentTarget};var isFastDblTouchTap=touchTap.target===latestTouchTap.target&&touchTap.time-latestTouchTap.time<dblTouchTapMaxDelay;latestTouchTap=touchTap;return isFastDblTouchTap;});

/***/ }),
/* 2316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Route_Bundle_Detail__ = __webpack_require__(2317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BundleDetailContainer=function(_mixin){_inherits(BundleDetailContainer,_mixin);function BundleDetailContainer(){_classCallCheck(this,BundleDetailContainer);return _possibleConstructorReturn(this,(BundleDetailContainer.__proto__||Object.getPrototypeOf(BundleDetailContainer)).apply(this,arguments));}_createClass(BundleDetailContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores__["c" /* BundleStore */]);}},{key:'componentWillMount',value:function componentWillMount(){if(_get(BundleDetailContainer.prototype.__proto__||Object.getPrototypeOf(BundleDetailContainer.prototype),'componentWillMount',this)){_get(BundleDetailContainer.prototype.__proto__||Object.getPrototypeOf(BundleDetailContainer.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_1_actions__["c" /* BundleActions */].findById(this.props.params.bundleId);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.routeParams.bundleId!==nextProps.routeParams.bundleId){__WEBPACK_IMPORTED_MODULE_1_actions__["c" /* BundleActions */].findById(nextProps.routeParams.bundleId);}}},{key:'goBack',value:function goBack(){__WEBPACK_IMPORTED_MODULE_5_helpers__["a" /* history */].push('/bundles');}},{key:'render',value:function render(){var selected=this.state.selected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Route_Bundle_Detail__["a" /* default */],{bundle:selected,onClose:this.goBack.bind(this)});}}]);return BundleDetailContainer;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));BundleDetailContainer.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (BundleDetailContainer);

/***/ }),
/* 2317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_Bundle__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Widgets_SimpleOverview__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_stores_Course__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Widgets_FileUpload__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Material_Cover__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_DialogPortal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_CourseSelector__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Tags__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Widgets_Overview__ = __webpack_require__(269);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ImageImage=__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ImageImage"],EditorModeEdit=__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["EditorModeEdit"],ContentAdd=__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ContentAdd"],ActionDelete=__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ActionDelete"],ContentClear=__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ContentClear"],ActionLabel=__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ActionLabel"];var Spacing=__WEBPACK_IMPORTED_MODULE_4_material_ui__["Styles"].Spacing;var BundleForm=function(_mixin){_inherits(BundleForm,_mixin);function BundleForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BundleForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BundleForm.__proto__||Object.getPrototypeOf(BundleForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={nameEditActive:false,newName:''},_this.addTag=function(tagName){__WEBPACK_IMPORTED_MODULE_2_actions_Bundle__["a" /* default */].addTag(_this.props.bundle.id,tagName);},_this.deleteTag=function(tagName){__WEBPACK_IMPORTED_MODULE_2_actions_Bundle__["a" /* default */].removeTag(_this.props.bundle.id,tagName);},_this.handleNameEditActive=function(nameEditActive){_this.setState({nameEditActive:nameEditActive});},_this.handleNameEdit=function(e){_this.setState({newName:e.target.value});},_this.handleNameSave=function(){if(_this.state.newName===''||_this.state.newName===_this.props.bundle.name){return;}__WEBPACK_IMPORTED_MODULE_2_actions_Bundle__["a" /* default */].update(parseInt(_this.props.bundle.id,10),{name:_this.state.newName});_this.handleNameEditActive(false);},_this.renderName=function(){var nameEditActive=_this.state.nameEditActive;var bundle=_this.props.bundle;if(!bundle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Material_Loader__["b" /* default */],null);}if(nameEditActive){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["TextField"],{ref:'noteText',defaultValue:bundle.name,onChange:_this.handleNameEdit,style:{marginLeft:30}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["RaisedButton"],{onClick:_this.handleNameSave,label:'Save',style:{marginLeft:10}}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(){return _this.handleNameEditActive(true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ListItem"],{disabled:true,leftIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionLabel,null),primaryText:bundle.name}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BundleForm,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_8_stores_Course__["a" /* default */],'course');}},{key:'listenToActions',value:function listenToActions(){var _this2=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_2_actions_Bundle__["a" /* default */].removeComplete,function(bundle){__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('bundle.removed'));});this.listenToAction(__WEBPACK_IMPORTED_MODULE_2_actions_Bundle__["a" /* default */].removeError,function(errorMessage){_this2.onError(errorMessage);_this2.refs.confirmDialog.dismiss();});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// console.log(this.props.bundle, nextProps.bundle);
if(this.props.bundle&&!nextProps.bundle){this.closeDetail();}}},{key:'onError',value:function onError(errorMessage){__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(errorMessage);}},{key:'closeDetail',value:function closeDetail(){if(this.props.onClose){this.props.onClose();}}},{key:'selectCourse',value:function selectCourse(selectedCourses){this.props.bundle.courses=Object.keys(selectedCourses).map(function(courseId){return{id:courseId,name:selectedCourses[courseId]};});this.setState({bundle:this.props.bundle});}},{key:'confirmDelete',value:function confirmDelete(bundle){__WEBPACK_IMPORTED_MODULE_2_actions_Bundle__["a" /* default */].remove(bundle);this.refs.confirmDialog.dismiss();}},{key:'deleteBundle',value:function deleteBundle(){this.refs.confirmDialog.show();}},{key:'addCourses',value:function addCourses(){__WEBPACK_IMPORTED_MODULE_3_actions_Course__["a" /* default */].filter();this.refs.addCoursesDialog.show();}},{key:'closeCourseSelection',value:function closeCourseSelection(){var courses=Object.keys(this.refs.courseSelector.getSelected()).map(function(id){return parseInt(id,10);});if(courses.length>0){this.props.bundle.courses.forEach(function(course){courses.push(parseInt(course.id,10));});__WEBPACK_IMPORTED_MODULE_2_actions_Bundle__["a" /* default */].update(parseInt(this.props.bundle.id,10),{courses:courses});__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(this.context.getIntlMessage('bundle.updated'));}this.refs.addCoursesDialog.dismiss();}},{key:'handleUpload',value:function handleUpload(data){var response=void 0,_data$pop=data.pop(),file=_data$pop.file;if(file.id){__WEBPACK_IMPORTED_MODULE_2_actions_Bundle__["a" /* default */].update(parseInt(this.props.bundle.id,10),{fileId:file.id});}}},{key:'removeCourse',value:function removeCourse(course){this._courseToRemove=course;this.refs.confirmRemoveCourseDialog.show();}},{key:'confirmCourseRemove',value:function confirmCourseRemove(){var _this3=this;var courses=[];this.props.bundle.courses.forEach(function(course){if(course.id!==_this3._courseToRemove.id){courses.push(parseInt(course.id,10));}});__WEBPACK_IMPORTED_MODULE_2_actions_Bundle__["a" /* default */].update(parseInt(this.props.bundle.id,10),{courses:courses});this.refs.confirmRemoveCourseDialog.dismiss();__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(this.context.getIntlMessage('bundle.removedCourse'));delete this._courseToRemove;}},{key:'render',value:function render(){var bundle=this.props.bundle;if(!bundle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Material_Loader__["b" /* default */],null);}var existingCourses=bundle.courses.map(function(course){return course.id;});var confirmActions=[{text:'Cancel'},{text:'Submit',onTouchTap:this.confirmDelete.bind(this,bundle),ref:'submit'}];var confirmCourseRemoveActions=[{text:'Cancel'},{text:'Submit',onTouchTap:this.confirmCourseRemove.bind(this),ref:'submit'}];var courseActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('OK'),secondary:true,className:'full',onTouchTap:this.closeCourseSelection.bind(this)})];var coverImage=bundle.coverImage;var backgroundImage=coverImage&&coverImage.length>0&&coverImage[0]&&coverImage[0].url;var toolbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Toolbar"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ToolbarTitle"],{text:this.context.getIntlMessage('Bundle')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["ToolbarGroup"],{float:'right',key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Widgets_FileUpload__["a" /* default */],{onSuccess:this.handleUpload.bind(this),Element:__WEBPACK_IMPORTED_MODULE_11_components_Material_ToolbarIconButton__["a" /* default */],svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageImage,null),secondary:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentAdd,null),onTouchTap:this.addCourses.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionDelete,null),onTouchTap:this.deleteBundle.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentClear,null),onTouchTap:this.closeDetail.bind(this)})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_ScrollableContainer__["a" /* default */],{header:toolbar,card:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_Cover__["a" /* default */],{responsive:false,size:1920,image:backgroundImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["List"],null,this.renderName()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Widgets_Overview__["a" /* default */],{header:this.context.getIntlMessage('course.properties')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_Tags__["b" /* TagSelector */],{onAddTag:this.addTag,onRemoveTag:this.deleteTag,tags:bundle.tagsMap,fullWidth:true,padded:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Widgets_SimpleOverview__["a" /* default */],{items:bundle.courses,readable:'name',title:this.context.getIntlMessage('course.Courses'),onTouchTapRightIcon:this.removeCourse.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'addCoursesDialog'// title={<h3 className='mui-dialog-title'>{this.context.getIntlMessage('Choose Courses')}</h3>}
,title:this.context.getIntlMessage('course.choose'),actions:courseActions,autoDetectWindowHeight:true,autoScrollBodyContent:true,dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_CourseSelector__["a" /* default */],{ref:'courseSelector',ignoreExistingCourses:existingCourses})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'confirmDialog',title:this.context.getIntlMessage('bundle.remove'),actions:confirmActions,actionFocus:'submit',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('bundle.removeBundle'),bundle:bundle.code})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Dialog"],{ref:'confirmRemoveCourseDialog',title:this.context.getIntlMessage('bundle.removeCourse'),actions:confirmCourseRemoveActions,actionFocus:'submit',dismissOnClickAway:true},this.context.getIntlMessage('bundle.removeCourseConfirm'))));}}]);return BundleForm;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_1_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));BundleForm.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (BundleForm);

/***/ }),
/* 2318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_Bundle__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_Bundle__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_ListDetail__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Tags__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_helpers__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentAdd=__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentAdd"];/**
 * Creates a bundles overview, uses the next helpers
 * RefluxMixin  : Reflux helper
 * Authorizer   : Only displays this page if the user was authenticated
 * Component    : React.Component to extend
 *
 * @exports {React.Component} Bundles
 */var Bundles=function(_mixin){_inherits(Bundles,_mixin);function Bundles(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Bundles);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Bundles.__proto__||Object.getPrototypeOf(Bundles)).call.apply(_ref,[this].concat(args))),_this),_this.state={bundle:{},filter:{}},_this.deleteTag=function(tagName){var filter=Object.assign({},_this.statefilter);delete filter[tagName];_this.setState({filter:filter});},_this.addTag=function(tagName){_this.setState({filter:Object.assign({},_this.state.filter,_defineProperty({},tagName,true))});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Bundles,[{key:'listenToStores',/**
   * Listen to the BundleStore and AppStore
   *
   */value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores_Bundle__["a" /* default */],'bundle');}/**
   * Listen to actions and update state as needed
   */},{key:'listenToActions',value:function listenToActions(){var _this2=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_5_actions_Bundle__["a" /* default */].removeComplete,function(bundle){__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('bundle.removed'));});}/**
   * Read all bundles on mount
   */},{key:'componentWillMount',value:function componentWillMount(){if(_get(Bundles.prototype.__proto__||Object.getPrototypeOf(Bundles.prototype),'componentWillMount',this)){_get(Bundles.prototype.__proto__||Object.getPrototypeOf(Bundles.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_5_actions_Bundle__["a" /* default */].read();}/**
   * Select a particular bundle. This will result in the details of this bundle
   * to be displayed. If the current selected bundle is different than the already
   * selected one, also invoke an action.
   *
   * @param  {object} bundle Bundle to select
   */},{key:'gotoBundle',value:function gotoBundle(bundle){__WEBPACK_IMPORTED_MODULE_12_helpers__["a" /* history */].push('/bundle/'+bundle.id);}/**
   * Display a dialog for creating a new bundle
   */},{key:'addBundleForm',value:function addBundleForm(){this.refs.createDialog.show();}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(!this.state.selected&&nextState.selected){__WEBPACK_IMPORTED_MODULE_12_helpers__["a" /* history */].push('/bundle/'+nextState.selected.id);}return true;}},{key:'createListItem',value:function createListItem(item,leftAvatar,insetChildren){var style={};if(this.state.selected&&item.id===this.state.selected.id){style.backgroundColor=__WEBPACK_IMPORTED_MODULE_11_components_Material_Styles_Colors__["a" /* Colors */].grey[300].material;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ListItem"],{style:style,leftAvatar:leftAvatar,insetChildren:insetChildren,key:'i'+item.id,primaryText:item.name,secondaryText:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Tags__["a" /* TagList */],{dense:true,tags:item.tagsMap}),onTouchTap:this.gotoBundle.bind(this,item)});}},{key:'addTag',value:function addTag(e,tagName){if(e){tagName=this.refs.addTag.getValue();}var filter=this.state.filter;filter[tagName]=true;this.setState({filter:filter});this.refs.addTag.clearValue();}/**
   * Confirms the creation of a bundle and invokes the proper action
   * @return {[type]} [description]
   */},{key:'onConfirmCreate',value:function onConfirmCreate(){__WEBPACK_IMPORTED_MODULE_5_actions_Bundle__["a" /* default */].create({name:this.refs.bundleName.getValue()});this.refs.createDialog.dismiss();}/**
   * Renders the bundles: Basically a ListDetail element with a detail element
   * if there was one selected
   *
   * @return {React.Element} Created render element
   */},{key:'render',value:function render(){var _this3=this;var bundles=this.state.bundle.list;var detail=void 0;var standardActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('Create'),secondary:true,className:'full',onTouchTap:this.onConfirmCreate.bind(this)})];var filterFunc=function filterFunc(item,searchText,labelProperty){var hasTags=true;Object.keys(_this3.state.filter).forEach(function(tagName){var tagsMap=item.tagsMap||{};hasTags=hasTags&&tagsMap[tagName];});if(!hasTags){return false;}if(searchText&&searchText!==''){return item[labelProperty].search(searchText)>-1;}else{return true;}};var tagSelector=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Tags__["b" /* TagSelector */],{onAddTag:this.addTag,onRemoveTag:this.deleteTag,tags:this.state.filter,fullWidth:true,padded:true});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_RulerBar__["a" /* default */],{title:this.context.getIntlMessage('menu.Bundles')})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ListDetail__["a" /* default */],{items:bundles,labelProperty:'name',hasDivider:false,filter:filterFunc,listHeader:tagSelector,listItemGenerator:this.createListItem.bind(this),floatingActionButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FloatingActionButton"],{onTouchTap:this.addBundleForm.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentAdd,null))},this.props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{ref:'createDialog',title:this.context.getIntlMessage('bundle.new'),actions:standardActions,dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{ref:'bundleName',fullWidth:true,hintText:this.context.getIntlMessage('bundle.name'),floatingLabelText:this.context.getIntlMessage('bundle.name')})));}}]);return Bundles;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_2_Util__["a" /* Authorizer */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));Bundles.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Bundles);

/***/ }),
/* 2319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_ListDetail__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Route_Transaction_Detail__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_oxygen_i18n__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _templateObject=_taggedTemplateLiteral(['customExport'],['customExport']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_6_material_ui__["Styles"].Spacing;var styles={filterButtonContainer:{},filterButton:{margin:8}};/**
 * Creates a transactions overview, uses the next helpers
 * Intl         : Internationlization object
 * RefluxMixin  : Reflux helper
 * Authorizer   : Only displays this page if the user was authenticated
 * Component    : React.Component to extend
 *
 * @exports {React.Component} Transactions
 */var Transactions=function(_mixin){_inherits(Transactions,_mixin);function Transactions(){_classCallCheck(this,Transactions);var _this=_possibleConstructorReturn(this,(Transactions.__proto__||Object.getPrototypeOf(Transactions)).apply(this,arguments));_this.state={value:''};_this.handleChangeText=function(e){_this.setState({value:e.target.value});};_this.setFilter=function(filter){_this.setState({filter:filter});};_this.export=function(){var re=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var email=null;if(re.test(String(_this.state.value).toLowerCase())){email=_this.state.value;}__WEBPACK_IMPORTED_MODULE_5_actions__["i" /* ExportActions */].exportIncomingPayment(email);_this.refs.exportDialog.dismiss();};_this.state={filter:'all',status:2147483647};return _this;}_createClass(Transactions,[{key:'listenToStores',/**
   * Listen to the TransactionStore and AppStore
   *
   */value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores__["A" /* TransactionStore */],'transaction');}/**
   * Listen to actions and update state as needed
   */},{key:'listenToActions',value:function listenToActions(){var _this2=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_5_actions__["F" /* TransactionActions */].findByIdComplete,function(transaction){_this2.setState({selected:transaction});});this.listenToAction(__WEBPACK_IMPORTED_MODULE_5_actions__["F" /* TransactionActions */].genericError,this.onError.bind(this));}/**
   * Display error through the Message Service.
   *
   * @param  {string} errorMessage Error message to display
   */},{key:'onError',value:function onError(errorMessage){__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(errorMessage);}/**
   * Read all transactions on mount
   */},{key:'componentWillMount',value:function componentWillMount(){if(_get(Transactions.prototype.__proto__||Object.getPrototypeOf(Transactions.prototype),'componentWillMount',this)){_get(Transactions.prototype.__proto__||Object.getPrototypeOf(Transactions.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_5_actions__["F" /* TransactionActions */].read();}/**
   * Select a particular transaction. This will result in the details of this transaction
   * to be displayed. If the current selected transaction is different than the already
   * selected one, also invoke an action.
   *
   * @param  {object} transaction Transaction to select
   */},{key:'gotoTransaction',value:function gotoTransaction(transaction){if(transaction===null){this.setState({selected:null});}else if(!this.selected||this.selected.id!==transaction.id){__WEBPACK_IMPORTED_MODULE_5_actions__["F" /* TransactionActions */].findById(transaction.id);}}},{key:'itemGenerator',value:function itemGenerator(item){var refunded=item.status===128?' ('+this.context.getIntlMessage('transaction.refunded')+')':'';var newTransaction=item.status===1?' ('+this.context.getIntlMessage('transaction.new')+')':'';var registered=item.status===4?' ('+this.context.getIntlMessage('transaction.registered')+')':'';var paid=item.status===8||item.status===16?' ('+this.context.getIntlMessage('transaction.paid')+')':'';var error=item.status===32?' ('+this.context.getIntlMessage('transaction.error')+')':'';var cancelled=item.status===64?' ('+this.context.getIntlMessage('transaction.cancelled')+')':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ListItem"],{key:'i-'+item.id,onTouchTap:this.gotoTransaction.bind(this,item),primaryText:item.buyer+' - '+item.amount+' '+item.currency+refunded+newTransaction+registered+paid+error+cancelled,secondaryText:item.date.split(' ')[0]});}},{key:'getFilterButtonStyle',value:function getFilterButtonStyle(){var media=this.context.media;var phone=media==='phone';return Object.assign({},styles.filterButtonContainer,{display:'flex',flexWrap:'wrap',justifyContent:'center',alignContent:'space-around'// flexDirection: phone ? 'column' : 'row'
});}},{key:'renderFilterBar',value:function renderFilterBar(){var filter=this.state.filter;var media=this.context.media;var phone=media==='phone';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getFilterButtonStyle()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('dashboard.filterAll'),backgroundColor:'#ddd',style:styles.filterButton,onTouchTap:this.setFilter.bind(this,'all'),disabled:filter==='all',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('dashboard.filterPaid'),backgroundColor:'#ddd',style:styles.filterButton,onTouchTap:this.setFilter.bind(this,'paid'),disabled:filter==='paid',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('dashboard.filterRefunded'),backgroundColor:'#ddd',style:styles.filterButton,onTouchTap:this.setFilter.bind(this,'refunded'),disabled:filter==='refunded',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{label:this.context.getIntlMessage('dashboard.filterError'),backgroundColor:'#ddd',style:styles.filterButton,onTouchTap:this.setFilter.bind(this,'error'),disabled:filter==='error',disabledBackgroundColor:'#00c9cc',disabledLabelColor:'#ffffff'}));}},{key:'filterAll',value:function filterAll(){return true;}},{key:'filterPaid',value:function filterPaid(transaction){return transaction.status===8||transaction.status===16;}},{key:'filterRefunded',value:function filterRefunded(transaction){return transaction.status===128;}},{key:'filterCancelled',value:function filterCancelled(transaction){return transaction.status===64;}},{key:'filterError',value:function filterError(transaction){return transaction.status===32;}/**
   * Renders the transactions: Basically a ListDetail element with a detail element
   * if there was one selected
   *
   * @return {React.Element} Created render element
   */},{key:'render',value:function render(){var transactions=this.state.transaction.list;var loading=this.state.transactions;var detail=void 0;if(this.state.selected){detail=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Route_Transaction_Detail__["a" /* default */],{key:this.state.selected.id,transaction:this.state.selected,onClose:this.gotoTransaction.bind(this,null)});}var filter=this.state.filter;var filtFunc=this['filter'+filter.charAt(0).toUpperCase()+filter.slice(1)];transactions=transactions.filter(filtFunc);var filterFunc=function filterFunc(item,searchText,labelProperty){if(searchText&&searchText!==''){return item[labelProperty].search(searchText)>-1;}else{return true;}};var filterBar=this.renderFilterBar();var exportActions=[{text:this.context.getIntlMessage('Cancel')},{text:this.context.getIntlMessage('Export'),onTouchTap:this.export,ref:'submit'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_RulerBar__["a" /* default */],{title:this.context.getIntlMessage('menu.Transactions')}),className:'transactions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_ListDetail__["a" /* default */],{filter:filterFunc,filterBar:filterBar,loading:loading,items:transactions,labelProperty:'buyer',listItemGenerator:this.itemGenerator.bind(this),hasDivider:false,floatingActionButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FloatingActionButton"],{onTouchTap:this.refs.exportDialog&&this.refs.exportDialog.show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Material_SvgIcons__["ActionLaunch"],null))},detail),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{ref:'exportDialog',title:Object(__WEBPACK_IMPORTED_MODULE_11_oxygen_i18n__["translate"])(_templateObject),actions:exportActions,actionFocus:'export',dismissOnClickAway:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{onChange:this.handleChangeText,floatingLabelText:'',hintText:'Email'})));}}]);return Transactions;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));Transactions.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Transactions);

/***/ }),
/* 2320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_StoreBar__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_ScrollableContainer__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isNumeric=function isNumeric(value){return!isNaN(parseFloat(value))&&isFinite(value);};var pageLookup={course:'courseExplanation',tac:'termsAndConditions',support:'support'};var css={content:'_l'};var About=function(_mixin){_inherits(About,_mixin);function About(){_classCallCheck(this,About);return _possibleConstructorReturn(this,(About.__proto__||Object.getPrototypeOf(About)).apply(this,arguments));}_createClass(About,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_6_stores__["u" /* StoreStore */],function(state){return{docs:state.docs||{},logo:state.theme&&state.theme.logoUrl,title:state.owner&&state.owner.name,username:state.owner&&state.owner.username};},{docs:{}});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_6_stores__["b" /* AuthStore */],function(state){return{locale:state.locale};},{locale:'en_US'});}},{key:'componentDidMount',value:function componentDidMount(){var domain=/:\/\/([^\/]+)/.exec(window.location.href)[1];var subDomain=void 0;if('//'+domain!==__WEBPACK_IMPORTED_MODULE_8_Config__["a" /* default */].thisHost){subDomain=domain.split('.').shift();}var username=this.props.routeParams.username;if(subDomain&&!isNumeric(subDomain)){username=subDomain;}else if(!username&&__WEBPACK_IMPORTED_MODULE_6_stores__["b" /* AuthStore */].isAuthenticated()){username=__WEBPACK_IMPORTED_MODULE_6_stores__["b" /* AuthStore */].getUser().username;}if(username!==this.state.username){__WEBPACK_IMPORTED_MODULE_7_actions__["z" /* StoreActions */].read(username,true);}}},{key:'renderToCSwedish',value:function renderToCSwedish(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Anv\xE4ndarvillkor (2013-10-18)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'1. Tj\xE4nsten'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Villkor vid k\xF6p av kurs eller guide som \xE4r framtagen med hj\xE4lp av Coursios tj\xE4nst.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio \xE4r en tj\xE4nst f\xF6r att skapa webbaserade kurser och guider som distribueras elektroniskt. Tj\xE4nsten m\xF6jligg\xF6r f\xF6retag att skapa skapa online kurser best\xE5ende av video, text, bilder, ljud och interaktiva funktioner. I tj\xE4nsten ing\xE5r hosting och driftande av plattformen, support och i vissa fall \xE4ven en webshop f\xF6r presentation och f\xF6rs\xE4ljning av kurserna.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio reserverar sig r\xE4tten att \xE4ndra dessa villkor p\xE5 denna sida och villkoren kommer appliceras 30 dagar fr\xE5n uppdateringen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Efter att ha genomf\xF6rt k\xF6pet av en guide eller kurs som producerats med Coursios tj\xE4nst och via de presentationssidor som framtagits av Coursios verktyg f\xE5r du tillg\xE5ng till materialet. Vid genomf\xF6randet av k\xF6pet registrerar du ett kundkonto f\xF6r att ta del av material via Coursios tj\xE4nst eller anv\xE4nder ett tidigare registrerat konto. N\xE4r k\xF6pet g\xE5tt igenom kommer du in i Coursios tj\xE4nst och tar del av materialet. F\xF6r att fram\xF6ver komma \xE5t materialet loggar du in via sidan http://app.coursio.com.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Skapande av kundkonto medges endast den som har en giltig e-postadress. Du ansvarar f\xF6r att den e-postadress som angivits \xE4r riktig och aktiv. Du kan sj\xE4lv \xE4ndra den angivna e-postadressen under \u201CInst\xE4llningar\u201D.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'F\xF6r att registrera dig i Coursio ska du ha fyllt 18 \xE5r.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'2. Betalning'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'D\xE5 k\xF6pet sker genom en presentationssida som framtagits av Coursios verktyg finns tv\xE5 betalningsalternativ:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Alt 1. Klarna, Faktura och Kort'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio erbjuder i samarbete med Klarna fakturering till privatpersoner och f\xF6retag, med betalningsvillkor 14 dagar. Faktura s\xE4nds ut via e-mail och du betalar enkelt till BankGiro. Betalning mot faktura sker enbart till folkbokf\xF6rd (privatperson) eller registrerad (f\xF6retag) adress. Kontakta Klarna p\xE5 telefon 08-120 120 00 om du har fr\xE5gor ang\xE5ende betalning. Vid f\xF6rsenad betalning utg\xE5r p\xE5minnelseavgift med det belopp som \xE4r till\xE5tet enligt. Vid fr\xE5gor r\xF6rande p\xE5minnelseavgift/r\xE4ntor, kontakta Klarna. F\xF6renklad kreditpr\xF6vning utan k\xE4nnedomskopia sker. Genom Klarna finns ocks\xE5 m\xF6jlighet till betalning via kort.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Alt 2. Kortbetalning via Net Payments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio erbjuder i samarbete med NetPayments kortbetalning. Kort som fungerar \xE4r Visa och Mastercard. Net Payments anv\xE4nder sig av 3D-secure vilket \xE4r den s\xE4kerhetsgrad som de svenska bankerna kr\xE4ver.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'3. \xC5ngerr\xE4tt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'D\xE5 du k\xF6per tillg\xE5ng till en tj\xE4nst g\xE4ller inte distanshandelslagen. D\xE5 betalningen g\xE5tt igenom och du f\xE5tt tillg\xE5ng till materialet anses \xE5ngerr\xE4tten f\xF6rbrukad. \xC5ngerr\xE4tten g\xE4ller inte heller defekta eller felaktiga varor. \xC4r produkten defekt eller felaktig \xE4r du ist\xE4llet v\xE4lkommen att kontakta v\xE5r kundservice och g\xF6ra en reklamation p\xE5 support@coursio.com'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'4. Tekniska f\xF6ruts\xE4ttningar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Tj\xE4nsten kr\xE4ver tillg\xE5ng till internet. Du ansvarar sj\xE4lv f\xF6r de kostnader som uppst\xE5r i anv\xE4ndandet av internetuppkoppling.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'5. Ansvar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Vid k\xF6p av en kurs eller guide g\xE4ller tillg\xE5ngen till materialet endast f\xF6r den personen som har k\xF6pt det. Du f\xE5r inte p\xE5 n\xE5got s\xE4tt sprida vidare inneh\xE5llet till andra eller dela l\xF6senord till ditt konto.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'6. Coursio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Mateiral k\xF6pt via Coursio finns tillg\xE4ngligt dygnet runt, sju dagar i veckan. Coursio ger dock inga garantier f\xF6r att tj\xE4nsten alltid \xE4r fri fr\xE5n fel eller avbrott. Om brister eller avbrott i tj\xE4nsten uppst\xE5r skall Corusio ges m\xF6jlighet att r\xE4tta till dessa utan att avtalsbrott skall anses f\xF6religga. Coursio har ocks\xE5 r\xE4tt att, i rimlig omfattning, st\xE4nga tj\xE4nsten f\xF6r till exempel uppgraderingar och service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'7. Ansvarsfriskrivning'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio \xE4r en tj\xE4nst f\xF6r att publicera material i form av kurser och guider. Genom tj\xE4nsten kan Coursios kunder s\xE4lja kurser och guider antingen via sina egna hemsidor, andra f\xF6rs\xE4ljningskanaler eller i de fall de vill via en presentationssida som ing\xE5r i Coursios tj\xE4nst. I de fall f\xF6rs\xE4ljningen sker via denna sida sk\xF6ts betalningen via Coursios konton p\xE5 Klarna och Net Payments. Coursio \xE4r inte ansvariga f\xF6r dispyter, krav, f\xF6rluster, eller skador av n\xE5got slag som kan uppst\xE5 ur handlingar eller information som genomf\xF6rs och delas av kunder till Coursio eller deltagare i kundernas kurser och guider.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Vi kontrollerar inte inneh\xE5llet i de material som l\xE4ggs upp av v\xE5ra kunder och garanterar inte p\xE5 n\xE5got s\xE4tt tillf\xF6rligtligheten, giltigheten, nogrannheten eller korrektheten i inneh\xE5llet. Som k\xF6pare av kurser eller guider medger du att du kan exponeras f\xF6r st\xF6tande eller ol\xE4mpligt inneh\xE5ll och f\xF6rst\xE5r att Coursio b\xE4r inget ansvar f\xF6r att h\xE5lla dig borta fr\xE5n denna typ av inneh\xE5ll och tar inget ansvar f\xF6r inneh\xE5llet i sig.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Via Coursio kan du f\xE5 tillg\xE5ng till l\xE4nkar till tredje parts sidor antingen genom verktyget i sig eller material som kunder lagt upp. Coursio tar inget ansvar f\xF6r dessa tredje parts sidor och kontrollerar inte dem p\xE5 n\xE5got s\xE4tt. Som anv\xE4ndare i Coursio b\xF6r du ta l\xE4mpliga \xE5tg\xE4rder f\xF6r att bed\xF6ma om det \xE4r l\xE4mpligt att bes\xF6ka en s\xE5dan tredje parts sida och skydda din egna personliga information och integritet p\xE5 en s\xE5dan sida.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'8. Lagval'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Tvist enligt dessa villkor skall avg\xF6ras enligt svensk lag i Stockholms Tingsr\xE4tt.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Fr\xE5gor kring dessa villkor riktas till Coursio AB, Tegn\xE9rgatan 1, 111 40 Stockholm eller info@coursio.se.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Personuppgifter \u2013 hur dom hanteras och anv\xE4nds'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'F\xF6r att registrera sig i Coursios tj\xE4nst kr\xE4vs endast e-mail adress och F\xF6r och Efternamn. N\xE4r du uppger dina personuppgifter hos oss godk\xE4nner du att vi lagrar och anv\xE4nder dina uppgifter i v\xE5r verksamhet f\xF6r att fullf\xF6lja avtalet gentemot dig. I detta ing\xE5r att vi kommer informera dig om uppdateringar som sker i de material du har tillg\xE5ng till och om generella uppdateringar i tj\xE4nsten.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Du medger ocks\xE5 att vi delar denna persondata med den kund som \xE4r avs\xE4ndare f\xF6r kursen eller guiden som skapats med hj\xE4lp av Coursio. Vem kunden \xE4r framg\xE5r av vem som \xE4r skapare av kursen eller guiden du f\xE5tt tillg\xE5ng till. Dessa kunder f\xE5r anv\xE4nda denna information f\xF6r att kontakta dig i anslutning till kursen som du har tillg\xE5ng till. Kunderna kan ocks\xE5 anv\xE4nda dessa uppgifter i andra syften. Det \xE4r ditt ansvar som anv\xE4ndare att s\xE4kerst\xE4lla vad Kunden kommer att g\xF6ra med denna information och hur den kommer att lagras. Coursio kontrollerar inte anv\xE4ndningsomr\xE5dena eller hur den h\xE4r informationen lagras av v\xE5ra Kunder.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Vid avregistrering av ditt Coursio konto kommer Coursio radera alla uppgifter om dig. Det \xE4r dock ditt ansvar att s\xE4kerst\xE4lla att s\xE5 \xE4ven sker hos de Kunder som du k\xF6pt material av. Du har r\xE4tt att skriftligen utan kostnad beg\xE4ra ett registerutdrag eller r\xE4ttelse/radering av eventuellt felaktiga uppgifter om dig. Du kan ocks\xE5 sp\xE4rra uppgifterna mot marknadsf\xF6ring.',' '));}},{key:'renderToCEnglish',value:function renderToCEnglish(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Terms (2013-10-18)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'The service'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The course or the guide are developed with the help of oursio\u2019s service. Coursio is a service for creation of web-based courses and guides that are distributed electronically. The service allows businesses to create create online courses consisting of video, text, images, audio, and interactive features. The service includes hosting and operating the spirit of the platform, support and in some cases even a shop for the sale and presentation of the courses.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio reserves the right to change these terms and conditions on this page and the conditions will be applied 30 days following the update.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'After having completed the purchase of a guide or course produced by Coursio\u2019s service and through the presentation page developed by Coursio\u2019s tool, you will be given access to the material. As a part of purchase process, you register a customer account to study the material through Coursio\u2019s service or use a previously registered account. When the purchase is processed, you will enter Coursio\u2019s services and can view the material. To access the material please log in through the site http://app.coursio.com.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Creation of customer account is permitted only with a valid email address. You are responsible for the email address stated is correct and active. You can change the email address stated under \u201CSettings\u201D.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To register in Coursio you must be over 18 years.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'2. Payment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To purchase the course you have 2 options:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Option 1. Payment via the Net Payments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio offers a cooperation with NetPayments card payments. Cards that work is Visa and MasterCard. Net Payments uses 3D-Secure, which is the level of security that the Swedish banks require.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Option 2. Paypal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio offers payment through your Paypal account.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'3. Returns'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When you buy a course or a guide, the purchase does not apply to e-commerce law. When the payment has been processed and you got access to material, your right to withdrawal is exhausted. Is the product defective or incorrect, you are welcome to contact our customer service department at support@coursio.com.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'4. Technical conditions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The service requires access to the Internet. You are responsible for the costs incurred in the use of internet.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'5. Responsibility'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When buying a course or a guide access is only granted to the person who bought it. You may not in any way spread further content to others or share the password to your account.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'6. Coursio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Material purchased through Coursio is available around the clock, seven days a week. Coursio, however, no guarantee that the service is always free of errors or interruptions. If the deficiencies or interruption in service occurs, the Coursio reserves the right to correct them without breach of contract. Coursio also reserves the right, with reason, to close the service for upgrades and maintenance.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'7. Disclaimer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Coursio is a service to publish material in the form of courses and guides. Through the service, customers Coursio\u2019s sell courses and guides, either through their own websites, other sales channels or where a presentation page is included in Coursio\u2019s service. Sales are made through this page are managed payment via Coursios accounts at Paypal and Net Payments. Coursio is not responsible for any disputes, claims, losses, or damages of any kind that may arise from documents or information that are implemented and shared by customers Coursio or participants in customer courses and guides.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We do not control the content of the materials submitted by our customers and do not guarantee in any way validity or accuracy of the content. As a buyer of courses or guides you acknowledge that you may be exposed to offensive or inappropriate content and understand that Coursio bears no responsibility of this type of content and assume no responsibility for the content itself.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Via Coursio you can access links to third party sites either by the tool itself or the material that clients has provided. Coursio take no responsibility for these third-party sites and do not control them in any way. As a user of Coursio should take appropriate steps to assess whether it is advisable to visit such third party site and protect your own personal information and privacy at such a page.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'8. Freedom of choice'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Any dispute under these terms shall be governed by Swedish law in the Stockholm District Court.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Questions regarding this statement, addressed to Coursio AB, Tegn\xE9rgatan 1, 111 40 Stockholm, or info@coursio.se.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'9. Personal data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To register in Coursios service requires only the e-mail address and first and last name. When you provide your personal details, you agree that we store and use your information in our business to fulfill the contract against you. In this part we will inform you of updates that occur in the material you have access and for general updates to the service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You also admit that we share this personal data with the customer who is the provider of the course content. These customers may use this information to contact you for other purposes. It is your responsibility as a user to ensure what the customer will do with this information and how it will be stored. Coursio not control the uses or how this information is stored by our Customers.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Upon deregistration of your Coursio account will Coursio delete all information of you. However, it is your responsibility to inform the Customers whose material you have purchase is well. You have the right to request a deregistration, correction of potentially wrong data in regards to you. This has to be done in via email to support@coursio.com. You can also lock the access of your user data for marketing done by the Customer.',' '));}},{key:'render',value:function render(){var page=this.props.params.page;var getIntlMessage=this.context.getIntlMessage;var _state=this.state,docs=_state.docs,logo=_state.logo,title=_state.title,locale=_state.locale;var pageContent=void 0;var content=docs[pageLookup[page]];if(!content){if(page==='tac'){if(locale==='sv_SE'){pageContent=this.renderToCSwedish();}else{pageContent=this.renderToCEnglish();}}else if(page==='support'){pageContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:getIntlMessage('about.support')}});}}else{pageContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:content}});}if(!title){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_Loader__["b" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_AppPage__["a" /* default */],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_StoreBar__["a" /* default */],{logo:logo,title:title}),className:'about'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_ScrollableContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.content},pageContent)));}}]);return About;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));About.contextTypes={router:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (About);

/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*global Zenbox*/var Help=function(_Component){_inherits(Help,_Component);function Help(){_classCallCheck(this,Help);return _possibleConstructorReturn(this,(Help.__proto__||Object.getPrototypeOf(Help)).apply(this,arguments));}_createClass(Help,[{key:'componentDidMount',value:function componentDidMount(){if(typeof Zenbox!=='undefined'){var User=__WEBPACK_IMPORTED_MODULE_1_stores__["b" /* AuthStore */].getUser();Zenbox.init({dropboxID:'20297068',url:'https://coursio.zendesk.com/',tabTooltip:'Help',tabImageURL:'https://assets.zendesk.com/external/zenbox/images/tab_help_right.png',tabColor:'#1abc9c',tabPosition:'Right',requester_name:User.displayName,requester_email:User.email,hide_tab:'true'});Zenbox.show();var router=this.props.router;router.push('/');}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return Help;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Help);

/***/ }),
/* 2322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Route_Course__ = __webpack_require__(2323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shallowequal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_Loader__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoursePreviewContainer=function(_mixin){_inherits(CoursePreviewContainer,_mixin);function CoursePreviewContainer(){_classCallCheck(this,CoursePreviewContainer);return _possibleConstructorReturn(this,(CoursePreviewContainer.__proto__||Object.getPrototypeOf(CoursePreviewContainer)).apply(this,arguments));}_createClass(CoursePreviewContainer,[{key:'componentWillMount',value:function componentWillMount(){if(_get(CoursePreviewContainer.prototype.__proto__||Object.getPrototypeOf(CoursePreviewContainer.prototype),'componentWillMount',this)){_get(CoursePreviewContainer.prototype.__proto__||Object.getPrototypeOf(CoursePreviewContainer.prototype),'componentWillMount',this).call(this);}var params=this.props.routeParams;if(params.ownerSlug&&params.courseSlug){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].findBySlug(params.ownerSlug,params.courseSlug,true);}}},{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_2_stores__["f" /* CourseStore */]);this.listenToStore(__WEBPACK_IMPORTED_MODULE_2_stores__["b" /* AuthStore */]);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!__WEBPACK_IMPORTED_MODULE_5_shallowequal___default()(this.state,nextState)||!__WEBPACK_IMPORTED_MODULE_5_shallowequal___default()(this.props,nextProps);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var oldParams=this.props.params;var newParams=nextProps.params;if(!__WEBPACK_IMPORTED_MODULE_5_shallowequal___default()(oldParams,newParams)){if(newParams.ownerSlug!==oldParams.ownerSlug||newParams.courseSlug!==oldParams.courseSlug){__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].findBySlug(newParams.ownerSlug,newParams.courseSlug);}}}},{key:'render',value:function render(){var course=this.state.course;var params=this.props.routeParams;if(!course.toc||params.ownerSlug!==course.ownerSlug||params.courseSlug!==course.slug){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_AppPage__["a" /* default */],{style:{paddingTop:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_Loader__["b" /* default */],null));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Route_Course__["a" /* default */],{course:this.state.course,params:this.props.params,router:this.props.router},this.props.children);}}]);return CoursePreviewContainer;}(Object(__WEBPACK_IMPORTED_MODULE_4_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_4_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (CoursePreviewContainer);

/***/ }),
/* 2323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_App__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions_Auth__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Course_TableOfContentsContainer__ = __webpack_require__(2324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_SlidingPanel__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_lib_CSSPropertyOperations__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_lib_CSSPropertyOperations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_lib_CSSPropertyOperations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_dnd__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_dnd_html5_backend__ = __webpack_require__(2327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_dnd_html5_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_dnd_html5_backend__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_7_material_ui__["Styles"].Spacing;var styles={toolbar:{color:__WEBPACK_IMPORTED_MODULE_9_components_Material_Styles_Colors__["a" /* Colors */].fullWhite},toc:{position:'fixed',left:0,top:0,bottom:0,width:Spacing.desktopKeylineIncrement*6,transition:'all 0.5s ease',zIndex:2}};var css={section:'_et'};var Course=function(_mixin){_inherits(Course,_mixin);function Course(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Course);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Course.__proto__||Object.getPrototypeOf(Course)).call.apply(_ref,[this].concat(args))),_this),_this.state={sectionChange:false},_this.closeToc=function(){__WEBPACK_IMPORTED_MODULE_2_actions_Course__["a" /* default */].closeToc();_this.slideAppLeft();},_this.toggleToc=function(){__WEBPACK_IMPORTED_MODULE_2_actions_Course__["a" /* default */].toggleToc();},_this.openToc=function(){__WEBPACK_IMPORTED_MODULE_2_actions_Course__["a" /* default */].openToc();_this.slideAppRight();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Course,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_5_stores__["f" /* CourseStore */]);this.listenToStore(__WEBPACK_IMPORTED_MODULE_5_stores__["b" /* AuthStore */],'auth');}},{key:'onMenuChange',value:function onMenuChange(e,key,payload){}},{key:'_gotoPage',value:function _gotoPage(sectionPage){var course=this.state.course;var page=sectionPage.page,chapter=sectionPage.chapter;this.props.router.push('/course/'+course.ownerSlug+'/'+course.slug+'/'+chapter.slug+'/'+page.slug+'/'+page.id);}},{key:'getTocStyle',value:function getTocStyle(tocEnabled){var style=styles.toc;if(!tocEnabled){style.left=-Spacing.desktopKeylineIncrement*7;}else{style.left=0;}return style;}},{key:'componentDidMount',value:function componentDidMount(){if(this.state.tocEnabled){this.slideAppRight();}var course=this.props.course;var _props$params=this.props.params,pageId=_props$params.pageId,courseSlug=_props$params.courseSlug,ownerSlug=_props$params.ownerSlug;var lastViewedPageId=course.lastViewedPageId;var lastViewedPageExists=false;if(!pageId){course.toc.some(function(section){var foundPage=section.pages.find(function(page){return page.id===lastViewedPageId;});lastViewedPageExists=!!foundPage;return lastViewedPageExists;});if(lastViewedPageId&&lastViewedPageExists){return this.props.router.replace('/course/'+ownerSlug+'/'+courseSlug+'/'+lastViewedPageId);}var firstPageId=course.toc&&course.toc[0]&&course.toc[0].pages&&course.toc[0].pages[0]&&course.toc[0].pages[0].id;if(firstPageId){__WEBPACK_IMPORTED_MODULE_2_actions_Course__["a" /* default */].markPageViewed(course.id,firstPageId);this.props.router.replace('/course/'+ownerSlug+'/'+courseSlug+'/'+firstPageId);}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(_get(Course.prototype.__proto__||Object.getPrototypeOf(Course.prototype),'componentWillUnmount',this)){_get(Course.prototype.__proto__||Object.getPrototypeOf(Course.prototype),'componentWillUnmount',this).call(this);}if(this._timer){clearTimeout(this._timer);this._timer=null;}var app=document.getElementById('root');__WEBPACK_IMPORTED_MODULE_11_react_lib_CSSPropertyOperations___default.a.setValueForStyles(app,{left:0});}},{key:'slideAppRight',value:function slideAppRight(){if(this.context.media!=='phone'){var panelWidth=this.context.media==='phone'?4:6;var app=document.getElementById('root');app.style.left=Spacing.desktopKeylineIncrement*panelWidth+'px';}}},{key:'slideAppLeft',value:function slideAppLeft(){var app=document.getElementById('root');app.style.left=0;// CSSPropertyOperations.setValueForStyles(app, { left: 0 });
}},{key:'toggleLayoutDesign',value:function toggleLayoutDesign(){__WEBPACK_IMPORTED_MODULE_2_actions_Course__["a" /* default */].toggleLayoutDesign();}},{key:'createToc',value:function createToc(panelWidth,pageId,courseSlug,ownerSlug){var activePageId=void 0;if(this.state.page){activePageId=this.state.page.id;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_SlidingPanel__["a" /* default */],{backgroundColor:__WEBPACK_IMPORTED_MODULE_9_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,width:panelWidth,overlay:this.context.media==='phone',initialOpen:this.state.tocEnabled,zIndex:1,ref:'toc',onOpen:this.openToc,onClose:this.closeToc,onRequestClose:this.closeToc},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Course_TableOfContentsContainer__["a" /* default */],{reader:this.state.auth.role.reader,editor:this.state.auth.role.editor,auth:this.state.auth,currentPage:activePageId,courseSlug:courseSlug,ownerSlug:ownerSlug}));}},{key:'builderMode',value:function builderMode(){__WEBPACK_IMPORTED_MODULE_4_actions_Auth__["a" /* default */].builderMode();}},{key:'readerMode',value:function readerMode(){__WEBPACK_IMPORTED_MODULE_4_actions_Auth__["a" /* default */].readerMode();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){var _this2=this;var media=this.context.media;var oldParams=this.props.params;var newParams=nextProps.params;var pageId=oldParams.pageId;var nextPageId=newParams.pageId;if(pageId!==nextPageId&&media==='phone'){this.closeToc();}if(oldParams.sectionSlug!==newParams.sectionSlug){this.setState({sectionChange:true});this._timer=setTimeout(function(){_this2.setState({sectionChange:false});},2000);}}},{key:'renderSectionChange',value:function renderSectionChange(currentSection,backgroundColor){var media=this.context.media;var style={left:'50%',marginLeft:-5*Spacing.desktopKeylineIncrement,position:'absolute',width:Spacing.desktopKeylineIncrement*10,textAlign:'center',transition:'all 0.5s ease',fontSize:'20px',letterSpacing:'0.5px',lineHeight:'64px',height:60,color:'#393939',zIndex:10,padding:0,opacity:1};if(this.state.sectionChange){style.top=Spacing.desktopKeylineIncrement;style.backgroundColor=backgroundColor;style.color=__WEBPACK_IMPORTED_MODULE_9_components_Material_Styles_Colors__["a" /* Colors */].fullWhite;if(media==='phone'){style.left=Spacing.desktopGutterMini;style.right=Spacing.desktopGutterMini;style.marginLeft='auto';style.width=null;}}else{style.top=0;style.backgroundColor='transparent';style.boxShadow='none';if(media==='phone'){style.opacity=0;style.left=64;style.right=Spacing.desktopGutterMini;style.marginLeft='auto';style.width=null;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["Paper"],{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.section},currentSection.name));}},{key:'render',value:function render(){if(!this.state.course||!this.state.course.theme||!this.state.page){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppPage__["a" /* default */],{style:{paddingTop:0},key:pageId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_Loader__["b" /* default */],null));}var _props$params2=this.props.params,pageId=_props$params2.pageId,courseSlug=_props$params2.courseSlug,ownerSlug=_props$params2.ownerSlug;var course=this.props.course;var panelWidth=this.context.media==='phone'?4:6;var toc=this.createToc(panelWidth,course.lastViewedPageId,courseSlug,ownerSlug);var currentSection=course.toc.find(function(section){var foundPage=section.pages.find(function(page){return page.id===parseInt(pageId,10);});return!!foundPage;});var sectionChange=currentSection&&this.renderSectionChange(currentSection,__WEBPACK_IMPORTED_MODULE_5_stores__["z" /* ThemeStore */].getColor(course&&course.theme.color,0.8));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppPage__["a" /* default */],{style:{paddingTop:0}},toc,this.props.children,sectionChange);}}]);return Course;}(Object(__WEBPACK_IMPORTED_MODULE_13_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_13_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));Course.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_react_dnd__["DragDropContext"])(__WEBPACK_IMPORTED_MODULE_16_react_dnd_html5_backend___default.a)(Course));

/***/ }),
/* 2324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableOfContents__ = __webpack_require__(2325);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TableOfContentsContainer=function(_mixin){_inherits(TableOfContentsContainer,_mixin);function TableOfContentsContainer(){_classCallCheck(this,TableOfContentsContainer);return _possibleConstructorReturn(this,(TableOfContentsContainer.__proto__||Object.getPrototypeOf(TableOfContentsContainer)).apply(this,arguments));}_createClass(TableOfContentsContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores__["f" /* CourseStore */]);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return this.props!==nextProps;}},{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,ownerSlug=_props.ownerSlug,courseSlug=_props.courseSlug;if(_get(TableOfContentsContainer.prototype.__proto__||Object.getPrototypeOf(TableOfContentsContainer.prototype),'componentWillMount',this)){_get(TableOfContentsContainer.prototype.__proto__||Object.getPrototypeOf(TableOfContentsContainer.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].findBySlug(ownerSlug,courseSlug);}},{key:'render',value:function render(){if(!this.state.course){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Material_Loader__["a" /* Loader */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TableOfContents__["a" /* TableOfContents */],Object.assign({course:this.state.course},this.props,{canEdit:this.state.course.canEdit,editor:this.props.editor&&this.state.course.canEdit}));}}]);return TableOfContentsContainer;}(Object(__WEBPACK_IMPORTED_MODULE_3_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_3_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));TableOfContentsContainer.displayName='TableOfContentsContainer';TableOfContentsContainer.propTypes={ownerSlug:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,courseSlug:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};TableOfContentsContainer.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (TableOfContentsContainer);

/***/ }),
/* 2325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Page__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Section__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableOfContents__ = __webpack_require__(2326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(206);
/* unused harmony reexport Page */
/* unused harmony reexport Section */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__TableOfContents__["a"]; });
/* unused harmony reexport styles */


/***/ }),
/* 2326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lib_update__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lib_update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_lib_update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Page__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Icons__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Material_Cover__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Section__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_CoursioLogo__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_oxygen_debounce__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};var _templateObject=_taggedTemplateLiteral(['Retrieve diploma'],['Retrieve diploma']),_templateObject2=_taggedTemplateLiteral(['Finish the course for a diploma'],['Finish the course for a diploma']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_6_material_ui__["Styles"].Spacing;var css={buttonWrapper:'_hs',search:'_ht',searchCard:'_ko',diplomaWarning:'_hu'};var TableOfContents=function(_mixin){_inherits(TableOfContents,_mixin);function TableOfContents(){_classCallCheck(this,TableOfContents);var _this=_possibleConstructorReturn(this,(TableOfContents.__proto__||Object.getPrototypeOf(TableOfContents)).apply(this,arguments));_this.search=__WEBPACK_IMPORTED_MODULE_20_oxygen_debounce___default()(function(){__WEBPACK_IMPORTED_MODULE_10_actions__["f" /* CourseActions */].search(_this.refs.courseSearch.getValue());},500);_this.openSearch=function(){_this.setState({searchOpen:!_this.state.searchOpen});};_this.showNotes=function(){__WEBPACK_IMPORTED_MODULE_10_actions__["f" /* CourseActions */].toggleNotes();};_this.retrieveDiploma=function(){var course=_this.props.course;__WEBPACK_IMPORTED_MODULE_10_actions__["f" /* CourseActions */].retrieveDiploma(course.id);};_this.state={searchOpen:false,selectedSection:null,selectedPage:null,collapsed:_this.props.initialCollapsed,sectionsCollapsed:false};return _this;}_createClass(TableOfContents,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores__["p" /* PageStore */]);this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores__["f" /* CourseStore */]);this.listenToStore(__WEBPACK_IMPORTED_MODULE_1_stores__["e" /* ClipboardStore */],'clipboard');}},{key:'listenToActions',value:function listenToActions(){this.listenToAction(__WEBPACK_IMPORTED_MODULE_10_actions__["f" /* CourseActions */].addPageModuleComplete,function(){//this.refs.scroller.scrollToEnd();
});}},{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,ownerSlug=_props.ownerSlug,courseSlug=_props.courseSlug;if(_get(TableOfContents.prototype.__proto__||Object.getPrototypeOf(TableOfContents.prototype),'componentWillMount',this)){_get(TableOfContents.prototype.__proto__||Object.getPrototypeOf(TableOfContents.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_10_actions__["f" /* CourseActions */].findBySlug(ownerSlug,courseSlug);}},{key:'onSearchResultClick',value:function onSearchResultClick(pageId){this.gotoPage(pageId);}},{key:'gotoPage',value:function gotoPage(pageId){var _props2=this.props,courseSlug=_props2.courseSlug,ownerSlug=_props2.ownerSlug;__WEBPACK_IMPORTED_MODULE_2_helpers__["a" /* history */].push('/course/'+ownerSlug+'/'+courseSlug+'/'+pageId);}},{key:'moveSection',value:function moveSection(dragIndex,hoverIndex){__WEBPACK_IMPORTED_MODULE_10_actions__["f" /* CourseActions */].moveSection(this.props.course.id,dragIndex,hoverIndex);}},{key:'movePageToSectionA',value:function movePageToSectionA(pageId,sectionId,position){if(this._movePageToSection){clearTimeout(this._movePageToSection);}this._movePageToSection=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_5_services_Page__["a" /* default */].moveToSection(pageId,sectionId,position);},1000);}},{key:'movePageToSection',value:function movePageToSection(id,afterId,sectionId,newSectionId){var sections=this.state.course.toc;var section=sections.filter(function(sect){return sect.id===sectionId;})[0];var newSection=sections.filter(function(sect){return sect.id===newSectionId;})[0];var sectionIndex=sections.indexOf(section);var newSectionIndex=sections.indexOf(newSection);var page=section.pages.filter(function(pageToFind){return pageToFind.id===id;})[0];var newPage=newSection.pages.filter(function(pageToFind){return pageToFind.id===afterId;})[0];var pageIndex=section.pages.indexOf(page);var newPageIndex=newSection.pages.indexOf(newPage);if(pageIndex<0||newPageIndex<0){return;}var updateObj={course:{toc:{}}};updateObj.course.toc[sectionIndex]={pages:{$splice:[[pageIndex,1]]}};updateObj.course.toc[newSectionIndex]={pages:{$splice:[[newPageIndex,0,page]]}};this.setState(__WEBPACK_IMPORTED_MODULE_4_react_lib_update___default()(this.state,updateObj));this.movePageToSectionA(id,newSectionId,newPageIndex+2);}},{key:'updateTest',value:function updateTest(obj){this.setState(__WEBPACK_IMPORTED_MODULE_4_react_lib_update___default()(this.state,obj));}},{key:'collapse',value:function collapse(){this.setState({sectionsCollapsed:true});}},{key:'expand',value:function expand(){this.setState({sectionsCollapsed:false});}},{key:'toggle',value:function toggle(){this.setState({collapsed:!this.state.collapsed});}},{key:'addSection',value:function addSection(courseId){__WEBPACK_IMPORTED_MODULE_10_actions__["f" /* CourseActions */].addSection(courseId,null,this.context.getIntlMessage('page.new'),this.context.getIntlMessage('section.new'));}},{key:'onDeleteSection',value:function onDeleteSection(sectionId){this.setState({selectedSection:sectionId});this.refs.confirmSectionDeleteDialog.show();}},{key:'deleteSection',value:function deleteSection(sectionId){if(this.state.selectedSection){__WEBPACK_IMPORTED_MODULE_10_actions__["f" /* CourseActions */].deleteSection(this.state.selectedSection);}this.refs.confirmSectionDeleteDialog.dismiss();// this.refs.scrollbar.forceUpdate();
}},{key:'onDeletePage',value:function onDeletePage(pageId){this.setState({selectedPage:pageId});this.refs.confirmPageDeleteDialog.show();// this.refs.scrollbar.forceUpdate();
}},{key:'deletePage',value:function deletePage(pageId){if(this.state.selectedPage){__WEBPACK_IMPORTED_MODULE_10_actions__["f" /* CourseActions */].deletePage(this.state.selectedPage);}this.refs.confirmPageDeleteDialog.dismiss();// this.refs.scrollbar.forceUpdate();
}},{key:'onUpdate',value:function onUpdate(){// this.refs.scrollbar.update();
}},{key:'getStyles',value:function getStyles(theme){var rawTheme=this.context.muiTheme.rawTheme;var themeColor=__WEBPACK_IMPORTED_MODULE_1_stores__["z" /* ThemeStore */].getColor(theme);return{root:Object.assign({},{backgroundColor:'#FAFAFA'}),toolbar:Object.assign({},{height:60,backgroundColor:themeColor}),page:Object.assign({},{overflowX:'hidden',overflowY:'auto',color:rawTheme.palette.primary1TextColor})};}},{key:'toggle',value:function toggle(){if(this.props.onToggle){this.props.onToggle();}}},{key:'scrollIntoView',value:function scrollIntoView(domNode){var containerDomNode=Object(__WEBPACK_IMPORTED_MODULE_14_react_dom__["findDOMNode"])(this);var boundingRect=domNode.getBoundingClientRect();if(this.refs.scroller&&boundingRect.bottom>containerDomNode.scrollTop+containerDomNode.scrollHeight){this.refs.scroller.scrollTo(boundingRect.bottom-window.innerHeight/2+100);}}},{key:'toggleApplicationMenu',value:function toggleApplicationMenu(){__WEBPACK_IMPORTED_MODULE_10_actions__["a" /* AppActions */].toggleAppBar();}},{key:'closeToc',value:function closeToc(){__WEBPACK_IMPORTED_MODULE_10_actions__["f" /* CourseActions */].closeToc();}},{key:'toggleLayoutDesign',value:function toggleLayoutDesign(){__WEBPACK_IMPORTED_MODULE_10_actions__["t" /* PageLayoutActions */].toggle();}},{key:'builderMode',value:function builderMode(){__WEBPACK_IMPORTED_MODULE_10_actions__["b" /* AuthActions */].builderMode();}},{key:'readerMode',value:function readerMode(){__WEBPACK_IMPORTED_MODULE_10_actions__["b" /* AuthActions */].readerMode();}},{key:'pasteSection',value:function pasteSection(){var section=__WEBPACK_IMPORTED_MODULE_1_stores__["e" /* ClipboardStore */].paste().data;__WEBPACK_IMPORTED_MODULE_10_actions__["f" /* CourseActions */].pasteSection(section);}},{key:'render',value:function render(){var _this2=this;if(!this.state.course){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Material_Loader__["b" /* default */],null);}var theme=void 0;if(this.state.course&&this.state.course.theme&&this.state.course.theme.color){theme=this.state.course.theme.color;}else{theme='creen';}var dynamicStyles=this.getStyles(theme);var sections=[],toc=this.state.course.toc||[],confirmSectionActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('OK'),secondary:true,className:'half',onTouchTap:this.deleteSection.bind(this)})],confirmPageActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('OK'),secondary:true,className:'half',onTouchTap:this.deletePage.bind(this)})];var pageCount=0;var settings=!!this.state.course.settings?Object.assign({quiz:{enabled:false}},this.state.course.settings):{quiz:{enabled:false}};sections=toc.map(function(section,index){pageCount+=section.pages.length;if(section.type==='quiz'&&(!settings.quiz.enabled||_this2.state.courseHasQuiziframe)){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Section__["a" /* default */],{theme:theme,index:index,reader:_this2.props.reader,editor:_this2.props.editor,courseId:_this2.state.course.id,settings:settings,scrollIntoView:_this2.scrollIntoView.bind(_this2),currentPage:_this2.props.currentPage,onUpdate:_this2.onUpdate.bind(_this2),data:section,onDeletePage:_this2.onDeletePage.bind(_this2),onDeleteSection:_this2.onDeleteSection.bind(_this2),onMoveSection:_this2.moveSection.bind(_this2),collapsed:false,key:section.id,mode:section.mode,ownerSlug:_this2.props.ownerSlug,courseSlug:_this2.props.courseSlug});});var addSectionButton=void 0;var pasteSectionButton=void 0;if(this.props.editor){var clipboard=this.state.clipboard;if(false){pasteSectionButton=React.createElement('div',{style:styles.addSectionButtonContainer},React.createElement(RaisedButton,{backgroundColor:'transparent',labelColor:Colors.Colors.fullWhite,fullWidth:true,style:styles.addSectionButton,onTouchTap:this.pasteSection.bind(this)},React.createElement('div',{style:styles.addPageLabel},React.createElement(Icons.ContentContentPaste,{style:{verticalAlign:'middle'},color:Colors.Colors.fullWhite}),this.context.getIntlMessage('section.paste'))));}addSectionButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_16__styles__["a" /* default */].addSectionButtonContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{backgroundColor:'transparent',labelColor:__WEBPACK_IMPORTED_MODULE_11_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,fullWidth:true,style:__WEBPACK_IMPORTED_MODULE_16__styles__["a" /* default */].addSectionButton,onTouchTap:this.addSection.bind(this,this.state.course.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_16__styles__["a" /* default */].addPageLabel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_SvgIcons__["ContentAdd"],{style:{verticalAlign:'middle'},color:__WEBPACK_IMPORTED_MODULE_11_components_Material_Styles_Colors__["a" /* Colors */].fullWhite}),this.context.getIntlMessage('section.new'))));}//        <div style={styles.logoContainer}>
//          <img src={course.theme.logoUrl} style={styles.logo} />
//        </div>
var moduleLayoutButton=void 0;var switchButton=void 0;if(this.props.editor){moduleLayoutButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('pageModule.layout'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_SvgIcons__["ActionViewModule"],null),onTouchTap:this.toggleLayoutDesign.bind(this)});switchButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('settings.readerMode'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_SvgIcons__["ActionVisibility"],null),onTouchTap:this.readerMode.bind(this)});}else if(this.props.auth.roleMap.editor&&this.props.canEdit){switchButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('settings.builderMode'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_SvgIcons__["ContentCreate"],null),onTouchTap:this.builderMode.bind(this)});}var tocHeader=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Toolbar"],{style:dynamicStyles.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_SvgIcons__["NavigationMenu"],null),onClick:this.toggleApplicationMenu})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["ToolbarGroup"],{float:'right',key:2},switchButton,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('toc.search'),svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_SvgIcons__["ActionSearch"],null),onClick:this.openSearch}),moduleLayoutButton,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('toc.close'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Icons__["Note"],{height:22,strokeWidth:2}),onClick:this.showNotes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Material_ToolbarIconButton__["a" /* default */],{tooltip:this.context.getIntlMessage('toc.close'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_SvgIcons__["NavigationChevronLeft"],null),onClick:this.closeToc})));var course=this.state.course;var hasDiploma=settings.diploma&&settings.diploma.fileId;var _ref=settings.diploma||80,passPercentage=_ref.passPercentage;var finished=(course.progress||0)>=passPercentage/100;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ScrollableContainer__["a" /* default */],{ref:'scroller',style:dynamicStyles.root,header:tocHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Material_Cover__["a" /* default */],{image:this.state.course.coverImage&&this.state.course.coverImage.url},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_16__styles__["a" /* default */].coverCaption},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_16__styles__["a" /* default */].coverCourseName},course.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_16__styles__["a" /* default */].coverCourseBy},this.context.getIntlMessage('by'),' ',course.ownerName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:dynamicStyles.page},this.props.children,!sections.length&&addSectionButton,!this.state.searchOpen?sections:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["TextField"],{style:{margin:20},fullWidth:true,ref:'courseSearch',onChange:this.search,hintText:this.context.getIntlMessage('toc.search')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:css.search},this.state.search.map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Card"],{className:css.searchCard,onClick:function onClick(){return _this2.onSearchResultClick(c.pageId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["CardText"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:c.content}})));}))),pasteSectionButton),hasDiploma&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonWrapper},finished&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{onTouchTap:this.retrieveDiploma,backgroundColor:__WEBPACK_IMPORTED_MODULE_1_stores__["z" /* ThemeStore */].getColor(theme),labelColor:'#FFF',fullWidth:true,label:Object(__WEBPACK_IMPORTED_MODULE_19_oxygen_i18n__["translate"])(_templateObject)}),!finished&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.diplomaWarning},Object(__WEBPACK_IMPORTED_MODULE_19_oxygen_i18n__["translate"])(_templateObject2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{ref:'confirmSectionDeleteDialog',title:this.context.getIntlMessage('section.remove'),actions:confirmSectionActions,dismissOnClickAway:true},this.context.getIntlMessage('section.confirmDelete')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{ref:'confirmPageDeleteDialog',title:this.context.getIntlMessage('page.remove'),actions:confirmPageActions,dismissOnClickAway:true},this.context.getIntlMessage('page.confirmDelete')));}}]);return TableOfContents;}(Object(__WEBPACK_IMPORTED_MODULE_3_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_3_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));TableOfContents.displayName='TableOfContents';TableOfContents.propTypes={links:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,initialCollapsed:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,ownerSlug:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,courseSlug:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,aside:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,toc:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};TableOfContents.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};TableOfContents.defaultProps={links:true,aside:false,initialCollapsed:false,toc:[]};/* harmony default export */ __webpack_exports__["a"] = (TableOfContents);

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getEmptyImage = exports.NativeTypes = undefined;
exports.default = createHTML5Backend;

var _HTML5Backend = __webpack_require__(2328);

var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);

var _getEmptyImage = __webpack_require__(2341);

var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);

var _NativeTypes = __webpack_require__(414);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.NativeTypes = NativeTypes;
exports.getEmptyImage = _getEmptyImage2.default;
function createHTML5Backend(manager) {
	return new _HTML5Backend2.default(manager);
}

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-underscore-dangle */


var _defaults = __webpack_require__(2329);

var _defaults2 = _interopRequireDefault(_defaults);

var _shallowEqual = __webpack_require__(2334);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _EnterLeaveCounter = __webpack_require__(2335);

var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);

var _BrowserDetector = __webpack_require__(651);

var _OffsetUtils = __webpack_require__(2338);

var _NativeDragSources = __webpack_require__(2340);

var _NativeTypes = __webpack_require__(414);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HTML5Backend = function () {
	function HTML5Backend(manager) {
		_classCallCheck(this, HTML5Backend);

		this.actions = manager.getActions();
		this.monitor = manager.getMonitor();
		this.registry = manager.getRegistry();
		this.context = manager.getContext();

		this.sourcePreviewNodes = {};
		this.sourcePreviewNodeOptions = {};
		this.sourceNodes = {};
		this.sourceNodeOptions = {};
		this.enterLeaveCounter = new _EnterLeaveCounter2.default();

		this.dragStartSourceIds = [];
		this.dropTargetIds = [];
		this.dragEnterTargetIds = [];
		this.currentNativeSource = null;
		this.currentNativeHandle = null;
		this.currentDragSourceNode = null;
		this.currentDragSourceNodeOffset = null;
		this.currentDragSourceNodeOffsetChanged = false;
		this.altKeyPressed = false;
		this.mouseMoveTimeoutTimer = null;

		this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
		this.handleTopDragStart = this.handleTopDragStart.bind(this);
		this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
		this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
		this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
		this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
		this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
		this.handleTopDragOver = this.handleTopDragOver.bind(this);
		this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
		this.handleTopDrop = this.handleTopDrop.bind(this);
		this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
		this.handleSelectStart = this.handleSelectStart.bind(this);
		this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
		this.endDragNativeItem = this.endDragNativeItem.bind(this);
		this.asyncEndDragNativeItem = this.asyncEndDragNativeItem.bind(this);
		this.isNodeInDocument = this.isNodeInDocument.bind(this);
	}

	_createClass(HTML5Backend, [{
		key: 'setup',
		value: function setup() {
			if (this.window === undefined) {
				return;
			}

			if (this.window.__isReactDndBackendSetUp) {
				throw new Error('Cannot have two HTML5 backends at the same time.');
			}
			this.window.__isReactDndBackendSetUp = true;
			this.addEventListeners(this.window);
		}
	}, {
		key: 'teardown',
		value: function teardown() {
			if (this.window === undefined) {
				return;
			}

			this.window.__isReactDndBackendSetUp = false;
			this.removeEventListeners(this.window);
			this.clearCurrentDragSourceNode();
			if (this.asyncEndDragFrameId) {
				this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
			}
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners(target) {
			// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
			if (!target.addEventListener) {
				return;
			}
			target.addEventListener('dragstart', this.handleTopDragStart);
			target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
			target.addEventListener('dragend', this.handleTopDragEndCapture, true);
			target.addEventListener('dragenter', this.handleTopDragEnter);
			target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
			target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
			target.addEventListener('dragover', this.handleTopDragOver);
			target.addEventListener('dragover', this.handleTopDragOverCapture, true);
			target.addEventListener('drop', this.handleTopDrop);
			target.addEventListener('drop', this.handleTopDropCapture, true);
		}
	}, {
		key: 'removeEventListeners',
		value: function removeEventListeners(target) {
			// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
			if (!target.removeEventListener) {
				return;
			}
			target.removeEventListener('dragstart', this.handleTopDragStart);
			target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
			target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
			target.removeEventListener('dragenter', this.handleTopDragEnter);
			target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
			target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
			target.removeEventListener('dragover', this.handleTopDragOver);
			target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
			target.removeEventListener('drop', this.handleTopDrop);
			target.removeEventListener('drop', this.handleTopDropCapture, true);
		}
	}, {
		key: 'connectDragPreview',
		value: function connectDragPreview(sourceId, node, options) {
			var _this = this;

			this.sourcePreviewNodeOptions[sourceId] = options;
			this.sourcePreviewNodes[sourceId] = node;

			return function () {
				delete _this.sourcePreviewNodes[sourceId];
				delete _this.sourcePreviewNodeOptions[sourceId];
			};
		}
	}, {
		key: 'connectDragSource',
		value: function connectDragSource(sourceId, node, options) {
			var _this2 = this;

			this.sourceNodes[sourceId] = node;
			this.sourceNodeOptions[sourceId] = options;

			var handleDragStart = function handleDragStart(e) {
				return _this2.handleDragStart(e, sourceId);
			};
			var handleSelectStart = function handleSelectStart(e) {
				return _this2.handleSelectStart(e, sourceId);
			};

			node.setAttribute('draggable', true);
			node.addEventListener('dragstart', handleDragStart);
			node.addEventListener('selectstart', handleSelectStart);

			return function () {
				delete _this2.sourceNodes[sourceId];
				delete _this2.sourceNodeOptions[sourceId];

				node.removeEventListener('dragstart', handleDragStart);
				node.removeEventListener('selectstart', handleSelectStart);
				node.setAttribute('draggable', false);
			};
		}
	}, {
		key: 'connectDropTarget',
		value: function connectDropTarget(targetId, node) {
			var _this3 = this;

			var handleDragEnter = function handleDragEnter(e) {
				return _this3.handleDragEnter(e, targetId);
			};
			var handleDragOver = function handleDragOver(e) {
				return _this3.handleDragOver(e, targetId);
			};
			var handleDrop = function handleDrop(e) {
				return _this3.handleDrop(e, targetId);
			};

			node.addEventListener('dragenter', handleDragEnter);
			node.addEventListener('dragover', handleDragOver);
			node.addEventListener('drop', handleDrop);

			return function () {
				node.removeEventListener('dragenter', handleDragEnter);
				node.removeEventListener('dragover', handleDragOver);
				node.removeEventListener('drop', handleDrop);
			};
		}
	}, {
		key: 'getCurrentSourceNodeOptions',
		value: function getCurrentSourceNodeOptions() {
			var sourceId = this.monitor.getSourceId();
			var sourceNodeOptions = this.sourceNodeOptions[sourceId];

			return (0, _defaults2.default)(sourceNodeOptions || {}, {
				dropEffect: this.altKeyPressed ? 'copy' : 'move'
			});
		}
	}, {
		key: 'getCurrentDropEffect',
		value: function getCurrentDropEffect() {
			if (this.isDraggingNativeItem()) {
				// It makes more sense to default to 'copy' for native resources
				return 'copy';
			}

			return this.getCurrentSourceNodeOptions().dropEffect;
		}
	}, {
		key: 'getCurrentSourcePreviewNodeOptions',
		value: function getCurrentSourcePreviewNodeOptions() {
			var sourceId = this.monitor.getSourceId();
			var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];

			return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
				anchorX: 0.5,
				anchorY: 0.5,
				captureDraggingState: false
			});
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset(sourceId) {
			return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
		}
	}, {
		key: 'isDraggingNativeItem',
		value: function isDraggingNativeItem() {
			var itemType = this.monitor.getItemType();
			return Object.keys(NativeTypes).some(function (key) {
				return NativeTypes[key] === itemType;
			});
		}
	}, {
		key: 'beginDragNativeItem',
		value: function beginDragNativeItem(type) {
			this.clearCurrentDragSourceNode();

			var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
			this.currentNativeSource = new SourceType();
			this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
			this.actions.beginDrag([this.currentNativeHandle]);
		}
	}, {
		key: 'asyncEndDragNativeItem',
		value: function asyncEndDragNativeItem() {
			this.asyncEndDragFrameId = this.window.requestAnimationFrame(this.endDragNativeItem);
		}
	}, {
		key: 'endDragNativeItem',
		value: function endDragNativeItem() {
			if (!this.isDraggingNativeItem()) {
				return;
			}

			this.actions.endDrag();
			this.registry.removeSource(this.currentNativeHandle);
			this.currentNativeHandle = null;
			this.currentNativeSource = null;
		}
	}, {
		key: 'isNodeInDocument',
		value: function isNodeInDocument(node) {
			// Check the node either in the main document or in the current context
			return document.body.contains(node) || this.window ? this.window.document.body.contains(node) : false;
		}
	}, {
		key: 'endDragIfSourceWasRemovedFromDOM',
		value: function endDragIfSourceWasRemovedFromDOM() {
			var node = this.currentDragSourceNode;
			if (this.isNodeInDocument(node)) {
				return;
			}

			if (this.clearCurrentDragSourceNode()) {
				this.actions.endDrag();
			}
		}
	}, {
		key: 'setCurrentDragSourceNode',
		value: function setCurrentDragSourceNode(node) {
			var _this4 = this;

			this.clearCurrentDragSourceNode();
			this.currentDragSourceNode = node;
			this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
			this.currentDragSourceNodeOffsetChanged = false;

			// A timeout of > 0 is necessary to resolve Firefox issue referenced
			// See:
			//   * https://github.com/react-dnd/react-dnd/pull/928
			//   * https://github.com/react-dnd/react-dnd/issues/869
			var MOUSE_MOVE_TIMEOUT = 1000;

			// Receiving a mouse event in the middle of a dragging operation
			// means it has ended and the drag source node disappeared from DOM,
			// so the browser didn't dispatch the dragend event.
			//
			// We need to wait before we start listening for mousemove events.
			// This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
			// immediately in some browsers.
			//
			// See:
			//   * https://github.com/react-dnd/react-dnd/pull/928
			//   * https://github.com/react-dnd/react-dnd/issues/869
			//
			this.mouseMoveTimeoutTimer = setTimeout(function () {
				_this4.mouseMoveTimeoutId = null;
				return _this4.window.addEventListener('mousemove', _this4.endDragIfSourceWasRemovedFromDOM, true);
			}, MOUSE_MOVE_TIMEOUT);
		}
	}, {
		key: 'clearCurrentDragSourceNode',
		value: function clearCurrentDragSourceNode() {
			if (this.currentDragSourceNode) {
				this.currentDragSourceNode = null;
				this.currentDragSourceNodeOffset = null;
				this.currentDragSourceNodeOffsetChanged = false;
				this.window.clearTimeout(this.mouseMoveTimeoutTimer);
				this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
				this.mouseMoveTimeoutTimer = null;
				return true;
			}

			return false;
		}
	}, {
		key: 'checkIfCurrentDragSourceRectChanged',
		value: function checkIfCurrentDragSourceRectChanged() {
			var node = this.currentDragSourceNode;
			if (!node) {
				return false;
			}

			if (this.currentDragSourceNodeOffsetChanged) {
				return true;
			}

			this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);

			return this.currentDragSourceNodeOffsetChanged;
		}
	}, {
		key: 'handleTopDragStartCapture',
		value: function handleTopDragStartCapture() {
			this.clearCurrentDragSourceNode();
			this.dragStartSourceIds = [];
		}
	}, {
		key: 'handleDragStart',
		value: function handleDragStart(e, sourceId) {
			this.dragStartSourceIds.unshift(sourceId);
		}
	}, {
		key: 'handleTopDragStart',
		value: function handleTopDragStart(e) {
			var _this5 = this;

			var dragStartSourceIds = this.dragStartSourceIds;

			this.dragStartSourceIds = null;

			var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);

			// Avoid crashing if we missed a drop event or our previous drag died
			if (this.monitor.isDragging()) {
				this.actions.endDrag();
			}

			// Don't publish the source just yet (see why below)
			this.actions.beginDrag(dragStartSourceIds, {
				publishSource: false,
				getSourceClientOffset: this.getSourceClientOffset,
				clientOffset: clientOffset
			});

			var dataTransfer = e.dataTransfer;

			var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);

			if (this.monitor.isDragging()) {
				if (typeof dataTransfer.setDragImage === 'function') {
					// Use custom drag image if user specifies it.
					// If child drag source refuses drag but parent agrees,
					// use parent's node as drag image. Neither works in IE though.
					var sourceId = this.monitor.getSourceId();
					var sourceNode = this.sourceNodes[sourceId];
					var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;

					var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
					    anchorX = _getCurrentSourcePrev.anchorX,
					    anchorY = _getCurrentSourcePrev.anchorY,
					    offsetX = _getCurrentSourcePrev.offsetX,
					    offsetY = _getCurrentSourcePrev.offsetY;

					var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
					var offsetPoint = { offsetX: offsetX, offsetY: offsetY };
					var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);

					dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
				}

				try {
					// Firefox won't drag without setting data
					dataTransfer.setData('application/json', {});
				} catch (err) {}
				// IE doesn't support MIME types in setData


				// Store drag source node so we can check whether
				// it is removed from DOM and trigger endDrag manually.
				this.setCurrentDragSourceNode(e.target);

				// Now we are ready to publish the drag source.. or are we not?

				var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
				    captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;

				if (!captureDraggingState) {
					// Usually we want to publish it in the next tick so that browser
					// is able to screenshot the current (not yet dragging) state.
					//
					// It also neatly avoids a situation where render() returns null
					// in the same tick for the source element, and browser freaks out.
					setTimeout(function () {
						return _this5.actions.publishDragSource();
					});
				} else {
					// In some cases the user may want to override this behavior, e.g.
					// to work around IE not supporting custom drag previews.
					//
					// When using a custom drag layer, the only way to prevent
					// the default drag preview from drawing in IE is to screenshot
					// the dragging state in which the node itself has zero opacity
					// and height. In this case, though, returning null from render()
					// will abruptly end the dragging, which is not obvious.
					//
					// This is the reason such behavior is strictly opt-in.
					this.actions.publishDragSource();
				}
			} else if (nativeType) {
				// A native item (such as URL) dragged from inside the document
				this.beginDragNativeItem(nativeType);
			} else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
				// Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
				// Just let it drag. It's a native type (URL or text) and will be picked up in
				// dragenter handler.
				return; // eslint-disable-line no-useless-return
			} else {
				// If by this time no drag source reacted, tell browser not to drag.
				e.preventDefault();
			}
		}
	}, {
		key: 'handleTopDragEndCapture',
		value: function handleTopDragEndCapture() {
			if (this.clearCurrentDragSourceNode()) {
				// Firefox can dispatch this event in an infinite loop
				// if dragend handler does something like showing an alert.
				// Only proceed if we have not handled it already.
				this.actions.endDrag();
			}
		}
	}, {
		key: 'handleTopDragEnterCapture',
		value: function handleTopDragEnterCapture(e) {
			this.dragEnterTargetIds = [];

			var isFirstEnter = this.enterLeaveCounter.enter(e.target);
			if (!isFirstEnter || this.monitor.isDragging()) {
				return;
			}

			var dataTransfer = e.dataTransfer;

			var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);

			if (nativeType) {
				// A native item (such as file or URL) dragged from outside the document
				this.beginDragNativeItem(nativeType);
			}
		}
	}, {
		key: 'handleDragEnter',
		value: function handleDragEnter(e, targetId) {
			this.dragEnterTargetIds.unshift(targetId);
		}
	}, {
		key: 'handleTopDragEnter',
		value: function handleTopDragEnter(e) {
			var _this6 = this;

			var dragEnterTargetIds = this.dragEnterTargetIds;

			this.dragEnterTargetIds = [];

			if (!this.monitor.isDragging()) {
				// This is probably a native item type we don't understand.
				return;
			}

			this.altKeyPressed = e.altKey;

			if (!(0, _BrowserDetector.isFirefox)()) {
				// Don't emit hover in `dragenter` on Firefox due to an edge case.
				// If the target changes position as the result of `dragenter`, Firefox
				// will still happily dispatch `dragover` despite target being no longer
				// there. The easy solution is to only fire `hover` in `dragover` on FF.
				this.actions.hover(dragEnterTargetIds, {
					clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
				});
			}

			var canDrop = dragEnterTargetIds.some(function (targetId) {
				return _this6.monitor.canDropOnTarget(targetId);
			});

			if (canDrop) {
				// IE requires this to fire dragover events
				e.preventDefault();
				e.dataTransfer.dropEffect = this.getCurrentDropEffect();
			}
		}
	}, {
		key: 'handleTopDragOverCapture',
		value: function handleTopDragOverCapture() {
			this.dragOverTargetIds = [];
		}
	}, {
		key: 'handleDragOver',
		value: function handleDragOver(e, targetId) {
			this.dragOverTargetIds.unshift(targetId);
		}
	}, {
		key: 'handleTopDragOver',
		value: function handleTopDragOver(e) {
			var _this7 = this;

			var dragOverTargetIds = this.dragOverTargetIds;

			this.dragOverTargetIds = [];

			if (!this.monitor.isDragging()) {
				// This is probably a native item type we don't understand.
				// Prevent default "drop and blow away the whole document" action.
				e.preventDefault();
				e.dataTransfer.dropEffect = 'none';
				return;
			}

			this.altKeyPressed = e.altKey;

			this.actions.hover(dragOverTargetIds, {
				clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
			});

			var canDrop = dragOverTargetIds.some(function (targetId) {
				return _this7.monitor.canDropOnTarget(targetId);
			});

			if (canDrop) {
				// Show user-specified drop effect.
				e.preventDefault();
				e.dataTransfer.dropEffect = this.getCurrentDropEffect();
			} else if (this.isDraggingNativeItem()) {
				// Don't show a nice cursor but still prevent default
				// "drop and blow away the whole document" action.
				e.preventDefault();
				e.dataTransfer.dropEffect = 'none';
			} else if (this.checkIfCurrentDragSourceRectChanged()) {
				// Prevent animating to incorrect position.
				// Drop effect must be other than 'none' to prevent animation.
				e.preventDefault();
				e.dataTransfer.dropEffect = 'move';
			}
		}
	}, {
		key: 'handleTopDragLeaveCapture',
		value: function handleTopDragLeaveCapture(e) {
			if (this.isDraggingNativeItem()) {
				e.preventDefault();
			}

			var isLastLeave = this.enterLeaveCounter.leave(e.target);
			if (!isLastLeave) {
				return;
			}

			if (this.isDraggingNativeItem()) {
				this.endDragNativeItem();
			}
		}
	}, {
		key: 'handleTopDropCapture',
		value: function handleTopDropCapture(e) {
			this.dropTargetIds = [];
			e.preventDefault();

			if (this.isDraggingNativeItem()) {
				this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
			}

			this.enterLeaveCounter.reset();
		}
	}, {
		key: 'handleDrop',
		value: function handleDrop(e, targetId) {
			this.dropTargetIds.unshift(targetId);
		}
	}, {
		key: 'handleTopDrop',
		value: function handleTopDrop(e) {
			var dropTargetIds = this.dropTargetIds;

			this.dropTargetIds = [];

			this.actions.hover(dropTargetIds, {
				clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
			});
			this.actions.drop({ dropEffect: this.getCurrentDropEffect() });

			if (this.isDraggingNativeItem()) {
				this.endDragNativeItem();
			} else {
				this.endDragIfSourceWasRemovedFromDOM();
			}
		}
	}, {
		key: 'handleSelectStart',
		value: function handleSelectStart(e) {
			var target = e.target;

			// Only IE requires us to explicitly say
			// we want drag drop operation to start

			if (typeof target.dragDrop !== 'function') {
				return;
			}

			// Inputs and textareas should be selectable
			if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
				return;
			}

			// For other targets, ask IE
			// to enable drag and drop
			e.preventDefault();
			target.dragDrop();
		}
	}, {
		key: 'window',
		get: function get() {
			if (this.context && this.context.window) {
				return this.context.window;
			} else if (typeof window !== 'undefined') {
				return window;
			}
			return undefined;
		}
	}]);

	return HTML5Backend;
}();

exports.default = HTML5Backend;

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(205),
    eq = __webpack_require__(252),
    isIterateeCall = __webpack_require__(2330),
    keysIn = __webpack_require__(2331);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(252),
    isArrayLike = __webpack_require__(258),
    isIndex = __webpack_require__(561),
    isObject = __webpack_require__(114);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(558),
    baseKeysIn = __webpack_require__(2332),
    isArrayLike = __webpack_require__(258);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(114),
    isPrototype = __webpack_require__(564),
    nativeKeysIn = __webpack_require__(2333);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 2333 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
	if (objA === objB) {
		return true;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	// Test for A's keys different from B.
	var hasOwn = Object.prototype.hasOwnProperty;
	for (var i = 0; i < keysA.length; i += 1) {
		if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
			return false;
		}

		var valA = objA[keysA[i]];
		var valB = objB[keysA[i]];

		if (valA !== valB) {
			return false;
		}
	}

	return true;
}

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _union = __webpack_require__(2336);

var _union2 = _interopRequireDefault(_union);

var _without = __webpack_require__(635);

var _without2 = _interopRequireDefault(_without);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EnterLeaveCounter = function () {
	function EnterLeaveCounter() {
		_classCallCheck(this, EnterLeaveCounter);

		this.entered = [];
	}

	_createClass(EnterLeaveCounter, [{
		key: 'enter',
		value: function enter(enteringNode) {
			var previousLength = this.entered.length;

			var isNodeEntered = function isNodeEntered(node) {
				return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
			};

			this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);

			return previousLength === 0 && this.entered.length > 0;
		}
	}, {
		key: 'leave',
		value: function leave(leavingNode) {
			var previousLength = this.entered.length;

			this.entered = (0, _without2.default)(this.entered.filter(function (node) {
				return document.documentElement.contains(node);
			}), leavingNode);

			return previousLength > 0 && this.entered.length === 0;
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.entered = [];
		}
	}]);

	return EnterLeaveCounter;
}();

exports.default = EnterLeaveCounter;

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(639),
    baseRest = __webpack_require__(205),
    baseUniq = __webpack_require__(640),
    isArrayLikeObject = __webpack_require__(275);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(370);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getNodeClientOffset = getNodeClientOffset;
exports.getEventClientOffset = getEventClientOffset;
exports.getDragPreviewOffset = getDragPreviewOffset;

var _BrowserDetector = __webpack_require__(651);

var _MonotonicInterpolant = __webpack_require__(2339);

var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint
   no-mixed-operators: off
*/
var ELEMENT_NODE = 1;

function getNodeClientOffset(node) {
	var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

	if (!el) {
		return null;
	}

	var _el$getBoundingClient = el.getBoundingClientRect(),
	    top = _el$getBoundingClient.top,
	    left = _el$getBoundingClient.left;

	return { x: left, y: top };
}

function getEventClientOffset(e) {
	return {
		x: e.clientX,
		y: e.clientY
	};
}

function isImageNode(node) {
	return node.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(node));
}

function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
	var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
	var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;

	// Work around @2x coordinate discrepancies in browsers
	if ((0, _BrowserDetector.isSafari)() && isImage) {
		dragPreviewHeight /= window.devicePixelRatio;
		dragPreviewWidth /= window.devicePixelRatio;
	}
	return { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight };
}

function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
	// The browsers will use the image intrinsic size under different conditions.
	// Firefox only cares if it's an image, but WebKit also wants it to be detached.
	var isImage = isImageNode(dragPreview);
	var dragPreviewNode = isImage ? sourceNode : dragPreview;
	var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
	var offsetFromDragPreview = {
		x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
		y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
	};
	var sourceWidth = sourceNode.offsetWidth,
	    sourceHeight = sourceNode.offsetHeight;
	var anchorX = anchorPoint.anchorX,
	    anchorY = anchorPoint.anchorY;

	var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
	    dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
	    dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;

	var calculateYOffset = function calculateYOffset() {
		var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
		// Dock to the top
		offsetFromDragPreview.y,
		// Align at the center
		offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
		// Dock to the bottom
		offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
		var y = interpolantY.interpolate(anchorY);
		// Work around Safari 8 positioning bug
		if ((0, _BrowserDetector.isSafari)() && isImage) {
			// We'll have to wait for @3x to see if this is entirely correct
			y += (window.devicePixelRatio - 1) * dragPreviewHeight;
		}
		return y;
	};

	var calculateXOffset = function calculateXOffset() {
		// Interpolate coordinates depending on anchor point
		// If you know a simpler way to do this, let me know
		var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
		// Dock to the left
		offsetFromDragPreview.x,
		// Align at the center
		offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
		// Dock to the right
		offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
		return interpolantX.interpolate(anchorX);
	};

	// Force offsets if specified in the options.
	var offsetX = offsetPoint.offsetX,
	    offsetY = offsetPoint.offsetY;

	var isManualOffsetX = offsetX === 0 || offsetX;
	var isManualOffsetY = offsetY === 0 || offsetY;
	return {
		x: isManualOffsetX ? offsetX : calculateXOffset(),
		y: isManualOffsetY ? offsetY : calculateYOffset()
	};
}

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint
   no-plusplus: off,
   no-mixed-operators: off
*/
var MonotonicInterpolant = function () {
	function MonotonicInterpolant(xs, ys) {
		_classCallCheck(this, MonotonicInterpolant);

		var length = xs.length;

		// Rearrange xs and ys so that xs is sorted
		var indexes = [];
		for (var i = 0; i < length; i++) {
			indexes.push(i);
		}
		indexes.sort(function (a, b) {
			return xs[a] < xs[b] ? -1 : 1;
		});

		// Get consecutive differences and slopes
		var dys = [];
		var dxs = [];
		var ms = [];
		var dx = void 0;
		var dy = void 0;
		for (var _i = 0; _i < length - 1; _i++) {
			dx = xs[_i + 1] - xs[_i];
			dy = ys[_i + 1] - ys[_i];
			dxs.push(dx);
			dys.push(dy);
			ms.push(dy / dx);
		}

		// Get degree-1 coefficients
		var c1s = [ms[0]];
		for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
			var _m = ms[_i2];
			var mNext = ms[_i2 + 1];
			if (_m * mNext <= 0) {
				c1s.push(0);
			} else {
				dx = dxs[_i2];
				var dxNext = dxs[_i2 + 1];
				var common = dx + dxNext;
				c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
			}
		}
		c1s.push(ms[ms.length - 1]);

		// Get degree-2 and degree-3 coefficients
		var c2s = [];
		var c3s = [];
		var m = void 0;
		for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
			m = ms[_i3];
			var c1 = c1s[_i3];
			var invDx = 1 / dxs[_i3];
			var _common = c1 + c1s[_i3 + 1] - m - m;
			c2s.push((m - c1 - _common) * invDx);
			c3s.push(_common * invDx * invDx);
		}

		this.xs = xs;
		this.ys = ys;
		this.c1s = c1s;
		this.c2s = c2s;
		this.c3s = c3s;
	}

	_createClass(MonotonicInterpolant, [{
		key: "interpolate",
		value: function interpolate(x) {
			var xs = this.xs,
			    ys = this.ys,
			    c1s = this.c1s,
			    c2s = this.c2s,
			    c3s = this.c3s;

			// The rightmost point in the dataset should give an exact result

			var i = xs.length - 1;
			if (x === xs[i]) {
				return ys[i];
			}

			// Search for the interval x is in, returning the corresponding y if x is one of the original xs
			var low = 0;
			var high = c3s.length - 1;
			var mid = void 0;
			while (low <= high) {
				mid = Math.floor(0.5 * (low + high));
				var xHere = xs[mid];
				if (xHere < x) {
					low = mid + 1;
				} else if (xHere > x) {
					high = mid - 1;
				} else {
					return ys[mid];
				}
			}
			i = Math.max(0, high);

			// Interpolate
			var diff = x - xs[i];
			var diffSq = diff * diff;
			return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
		}
	}]);

	return MonotonicInterpolant;
}();

exports.default = MonotonicInterpolant;

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _nativeTypesConfig;

exports.createNativeDragSource = createNativeDragSource;
exports.matchNativeItemType = matchNativeItemType;

var _NativeTypes = __webpack_require__(414);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
	var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
		return resultSoFar || dataTransfer.getData(typeToTry);
	}, null);

	return result != null // eslint-disable-line eqeqeq
	? result : defaultValue;
}

var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
	exposeProperty: 'files',
	matchesTypes: ['Files'],
	getData: function getData(dataTransfer) {
		return Array.prototype.slice.call(dataTransfer.files);
	}
}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
	exposeProperty: 'urls',
	matchesTypes: ['Url', 'text/uri-list'],
	getData: function getData(dataTransfer, matchesTypes) {
		return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
	}
}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
	exposeProperty: 'text',
	matchesTypes: ['Text', 'text/plain'],
	getData: function getData(dataTransfer, matchesTypes) {
		return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
	}
}), _nativeTypesConfig);

function createNativeDragSource(type) {
	var _nativeTypesConfig$ty = nativeTypesConfig[type],
	    exposeProperty = _nativeTypesConfig$ty.exposeProperty,
	    matchesTypes = _nativeTypesConfig$ty.matchesTypes,
	    getData = _nativeTypesConfig$ty.getData;


	return function () {
		function NativeDragSource() {
			var _item, _mutatorMap;

			_classCallCheck(this, NativeDragSource);

			this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
				// eslint-disable-next-line no-console
				console.warn('Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
				return null;
			}, _defineEnumerableProperties(_item, _mutatorMap), _item);
		}

		_createClass(NativeDragSource, [{
			key: 'mutateItemByReadingDataTransfer',
			value: function mutateItemByReadingDataTransfer(dataTransfer) {
				delete this.item[exposeProperty];
				this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
			}
		}, {
			key: 'canDrag',
			value: function canDrag() {
				return true;
			}
		}, {
			key: 'beginDrag',
			value: function beginDrag() {
				return this.item;
			}
		}, {
			key: 'isDragging',
			value: function isDragging(monitor, handle) {
				return handle === monitor.getSourceId();
			}
		}, {
			key: 'endDrag',
			value: function endDrag() {}
		}]);

		return NativeDragSource;
	}();
}

function matchNativeItemType(dataTransfer) {
	var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);

	return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
		var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;

		return matchesTypes.some(function (t) {
			return dataTransferTypes.indexOf(t) > -1;
		});
	})[0] || null;
}

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getEmptyImage;
var emptyImage = void 0;
function getEmptyImage() {
	if (!emptyImage) {
		emptyImage = new Image();
		emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	}

	return emptyImage;
}

/***/ }),
/* 2342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__ = __webpack_require__(70);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={root:{margin:"2em 3em",textAlign:"center"},warning:{fontSize:32,lineHeight:"normal",marginTop:"1em"}};var NotFound=function(_Component){_inherits(NotFound,_Component);function NotFound(){_classCallCheck(this,NotFound);return _possibleConstructorReturn(this,(NotFound.__proto__||Object.getPrototypeOf(NotFound)).apply(this,arguments));}_createClass(NotFound,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppPage__["a" /* default */],{style:{background:"#00c9cc"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__["a" /* default */],{open:true,toolbar:false,overlay:false,padded:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:styles.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__["a" /* default */],{initialFill:"#00c9cc",size:100,width:"48px"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:styles.warning},this.context.getIntlMessage("notFound")))));}}]);return NotFound;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NotFound.displayName="NotFound";NotFound.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (NotFound);

/***/ }),
/* 2343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_helpers__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={root:{margin:"2em 3em",textAlign:"center"},warning:{fontSize:32,lineHeight:"normal",marginTop:"1em"}};var CoursioError=function(_Component){_inherits(CoursioError,_Component);function CoursioError(props){_classCallCheck(this,CoursioError);return _possibleConstructorReturn(this,(CoursioError.__proto__||Object.getPrototypeOf(CoursioError)).call(this,props));}_createClass(CoursioError,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppPage__["a" /* default */],{style:{background:"#00c9cc"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__["a" /* default */],{open:true,toolbar:false,overlay:false,padded:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:styles.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__["a" /* default */],{initialFill:"#00c9cc",size:100,width:"48px"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:styles.warning},this.context.getIntlMessage("error"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{style:{cursor:'pointer'},onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_4_helpers__["a" /* history */].goBack();}},'\xa0',this.context.getIntlMessage("here"))))));}}]);return CoursioError;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CoursioError.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (CoursioError);

/***/ }),
/* 2344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__ = __webpack_require__(70);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={root:{margin:"2em 3em",textAlign:"center"},warning:{fontSize:32,lineHeight:"normal",marginTop:"1em"}};var NotFound=function(_Component){_inherits(NotFound,_Component);function NotFound(){_classCallCheck(this,NotFound);return _possibleConstructorReturn(this,(NotFound.__proto__||Object.getPrototypeOf(NotFound)).apply(this,arguments));}_createClass(NotFound,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppPage__["a" /* default */],{style:{background:"#00c9cc"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__["a" /* default */],{open:true,toolbar:false,overlay:false,padded:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:styles.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__["a" /* default */],{initialFill:"#00c9cc",size:100,width:"48px"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:styles.warning},this.context.getIntlMessage("down")))));}}]);return NotFound;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NotFound.displayName="NotFound";NotFound.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (NotFound);

/***/ }),
/* 2345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_MediaQuery__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ModuleMenu__ = __webpack_require__(2346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Page_Row__ = __webpack_require__(2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ScrollableContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_SlidingPanel__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_lib_CSSPropertyOperations__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_lib_CSSPropertyOperations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_lib_CSSPropertyOperations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Material_ToolbarIconButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shallowequal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Material_Loader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_containers_PageLayoutContainer__ = __webpack_require__(2400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_containers_QuizContainer__ = __webpack_require__(2414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_containers_PageModuleMenuContainer__ = __webpack_require__(2418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_stores_PageLayout__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_selectors_pageLayout__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__containers_NotesContainer__ = __webpack_require__(2421);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={nextControl:'_m',nextControlIcon:'_n',nextControlText:'_o',prevControl:'_p',prevControlIcon:'_q',prevControlText:'_r',footer:'_s',pageDisplay:'_t',pageDisplayNonPhone1:'_u',pageDisplayNonPhone2:'_v',pageDisplayTitle:'_w',pageDisplaySubTitle:'_x',page:'_y'};var generateKey=function generateKey(pre){return pre+'_'+new Date().getTime();};var Spacing=__WEBPACK_IMPORTED_MODULE_8_material_ui__["Styles"].Spacing;var styles={toolbar:{backgroundColor:'rgba(0, 0, 0, 0.5)',color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite},toolbarTitle:{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite},buttonContainer:{// width: Spacing.desktopKeylineIncrement * 6,
margin:'auto',padding:Spacing.desktopGutterMini},toc:{position:'fixed',left:0,top:0,bottom:0,width:Spacing.desktopKeylineIncrement*6,transition:'all 0.5s ease',zIndex:2}};var Page=function(_mixin){_inherits(Page,_mixin);function Page(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Page);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Page.__proto__||Object.getPrototypeOf(Page)).call.apply(_ref,[this].concat(args))),_this),_this.state={mode:'',quiziframeHasBeenChecked:false},_this.onPageNavigate=function(e){e.preventDefault();var params=_this.props.routeParams;var router=_this.props.router;var pageId=parseInt(params.pageId,10);var next=__WEBPACK_IMPORTED_MODULE_3_stores__["f" /* CourseStore */].getNextForPageId(pageId);var previous=__WEBPACK_IMPORTED_MODULE_3_stores__["f" /* CourseStore */].getPreviousForPageId(pageId);if(_this.state.mode=='reader'){if(next&&e.keyCode==39){router.push('/course/'+params.ownerSlug+'/'+params.courseSlug+'/'+next.chapter.slug+'/'+next.page.slug+'/'+next.page.id);}if(previous&&e.keyCode===37){router.push('/course/'+params.ownerSlug+'/'+params.courseSlug+'/'+previous.chapter.slug+'/'+previous.page.slug+'/'+previous.page.id);}}},_this.openModuleMenu=function(){__WEBPACK_IMPORTED_MODULE_2_actions__["t" /* PageLayoutActions */].openModuleMenu();},_this.newQuestion=function(){var hasNoneValidQuestion=_this.state.page.pageRows&&_this.state.page.pageRows.length&&_this.state.page.pageRows;if(hasNoneValidQuestion&&hasNoneValidQuestion.filter(function(a){return a.pageModules[0].data.params.task.correctResponse===undefined||!Object.keys(a.pageModules[0].data.params.task.correctResponse).length||!a.pageModules[0].data.params.task.correctResponse.value.length;}).length){_this.refs.confirm.show();}else{__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].addPageModule('task',_this.state.page.id);}},_this.scrollIntoView=function(){setTimeout(function(){var hashbang=window.location.hash.substr(1);if(hashbang){var el=document.getElementById(hashbang);el&&el.scrollIntoView(true);}},300);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Page,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores__["p" /* PageStore */]);this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores__["f" /* CourseStore */]);this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_3_stores__["r" /* QuizStore */],function(state){return{pageId:state.pageId};});this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores__["b" /* AuthStore */],'auth');this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_20_stores_PageLayout__["a" /* default */],function(state){return{layout:Object(__WEBPACK_IMPORTED_MODULE_21_selectors_pageLayout__["b" /* getPureLayout */])(state)};});}},{key:'listenToActions',value:function listenToActions(){var _this2=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].addPageModuleComplete,function(){_this2.refs.page.scrollToEnd();});}},{key:'onMenuChange',value:function onMenuChange(e,key,payload){}},{key:'_gotoPage',value:function _gotoPage(sectionPage){var course=this.state.course;var page=sectionPage.page,chapter=sectionPage.chapter;this.props.router.push('/course/'+course.ownerSlug+'/'+course.slug+'/'+chapter.slug+'/'+page.slug+'/'+page.id);}},{key:'_newModule',value:function _newModule(type){// PageService.createPageModule(type, this.state.page.id, response => {
//   Message.info(this.context.getIntlMessage('pageModule.created'));
//   if (response.data && response.data.pageRows) {
//     this.setState({page: {
//       ...this.state.page,
//       pageRows: this.state.page.pageRows.concat(response.data.pageRows)
//     }});
//     this.closeModuleMenu();
//   }
// });
__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].addPageModule(type,this.state.page.id);this.closeModuleMenu();}},{key:'getToolbarStyle',value:function getToolbarStyle(tocEnabled){var style={position:'absolute',left:0,right:0,top:0,height:60,zIndex:2,borderStyle:'none none solid none',borderWidth:'1px',borderColor:'#DDD',backgroundColor:this.context.muiTheme.rawTheme.cardColor,paddingLeft:0,paddingRight:0,boxSizing:'border-box',boxShadow:'0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12)'};return style;}},{key:'onScrollToBottom',value:function onScrollToBottom(){}},{key:'getFloatingActionButtonStyle',value:function getFloatingActionButtonStyle(){var media=this.context.media;var phone=media==='phone'||media==='tablet';var style=void 0,componentTheme=this.context.muiTheme;if(phone){style={position:'fixed',right:Spacing.desktopGutter,bottom:Spacing.desktopGutterMini+64,zIndex:23};}else{style={position:'fixed',right:Spacing.desktopKeylineIncrement/2,top:componentTheme.toolbar.height-componentTheme.floatingActionButton.buttonSize/2,zIndex:23};}return style;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var oldParams=this.props.params;var newParams=nextProps.params;if(!__WEBPACK_IMPORTED_MODULE_14_shallowequal___default()(oldParams,newParams)){var editor=this.state.auth.role.editor;if(newParams.pageId){__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].getPageById(newParams.pageId,editor);}else{__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].getPageBySlug(newParams.ownerSlug,newParams.courseSlug,newParams.sectionSlug,newParams.pageSlug);}}var _state=this.state,course=_state.course,page=_state.page;__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].refetchToc();}},{key:'componentWillMount',value:function componentWillMount(){if(_get(Page.prototype.__proto__||Object.getPrototypeOf(Page.prototype),'componentWillMount',this)){_get(Page.prototype.__proto__||Object.getPrototypeOf(Page.prototype),'componentWillMount',this).call(this);}var params=this.props.routeParams;if(params.pageId){__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].getPageById(params.pageId);}else{__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].getPageBySlug(params.ownerSlug,params.courseSlug,params.sectionSlug,params.pageSlug);}}},{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('keyup',this.onPageNavigate);}},{key:'closeModuleMenu',value:function closeModuleMenu(){__WEBPACK_IMPORTED_MODULE_2_actions__["t" /* PageLayoutActions */].closeModuleMenu();}},{key:'toggleModuleMenu',value:function toggleModuleMenu(){__WEBPACK_IMPORTED_MODULE_2_actions__["t" /* PageLayoutActions */].toggleModuleMenu();}},{key:'toggleLayoutDesign',value:function toggleLayoutDesign(){__WEBPACK_IMPORTED_MODULE_2_actions__["t" /* PageLayoutActions */].toggle();}},{key:'openLayoutDesign',value:function openLayoutDesign(){__WEBPACK_IMPORTED_MODULE_2_actions__["t" /* PageLayoutActions */].enable();}},{key:'closeLayoutDesign',value:function closeLayoutDesign(){__WEBPACK_IMPORTED_MODULE_2_actions__["t" /* PageLayoutActions */].disable();}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(_get(Page.prototype.__proto__||Object.getPrototypeOf(Page.prototype),'componentWillUnmount',this)){_get(Page.prototype.__proto__||Object.getPrototypeOf(Page.prototype),'componentWillUnmount',this).call(this);}var app=document.getElementById('root');__WEBPACK_IMPORTED_MODULE_12_react_lib_CSSPropertyOperations___default.a.setValueForStyles(app,{left:0});window.removeEventListener('keyup',this.onPageNavigate);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){var needsToBeOpen=nextState.tocEnabled;var isOpen=this.state.tocEnabled;if(!isOpen&&needsToBeOpen){this.slideAppRight();}else if(isOpen&&!needsToBeOpen){this.slideAppLeft();}return true;// return shallowEqual(this.state, nextState) || !shallowEqual(this.props, nextProps);
}},{key:'slideAppRight',value:function slideAppRight(){if(this.context.media!=='phone'){var panelWidth=this.context.media==='phone'?4:6;var app=document.getElementById('root');__WEBPACK_IMPORTED_MODULE_12_react_lib_CSSPropertyOperations___default.a.setValueForStyles(app,{left:Spacing.desktopKeylineIncrement*panelWidth});}}},{key:'toggleToc',value:function toggleToc(){__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].toggleToc();}},{key:'openToc',value:function openToc(){if(!this.state.tocEnabled){if(this.state.moduleMenuEnabled){this.toggleModuleMenu();}__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].openToc();}}},{key:'closeToc',value:function closeToc(){__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].closeToc();}},{key:'slideAppLeft',value:function slideAppLeft(){var app=document.getElementById('root');__WEBPACK_IMPORTED_MODULE_12_react_lib_CSSPropertyOperations___default.a.setValueForStyles(app,{left:0});}},{key:'getPageStyle',value:function getPageStyle(){var style={position:'relative',boxSizing:'border-box',margin:'auto',padding:'60px 20px 68px 20px',overflow:'visible'};var user=JSON.parse(localStorage.getItem('user'));if(user.roles.length===1&&user.roles.includes('reader')||!this.state.course.canEdit){style.userSelect='none';}if(this.context.media!=='phone'){style.width=770;}return style;}},{key:'toggleApplicationMenu',value:function toggleApplicationMenu(){__WEBPACK_IMPORTED_MODULE_2_actions__["a" /* AppActions */].toggleAppBar();}},{key:'createModuleMenu',value:function createModuleMenu(panelWidth){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_SlidingPanel__["a" /* default */],{initialOpen:this.state.moduleMenuEnabled,width:panelWidth,overlay:this.context.media==='phone',zIndex:4,ref:'moduleMenu',onOpen:this.openModuleMenu.bind(this),onClose:this.closeModuleMenu.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ModuleMenu__["a" /* default */],{onCreate:this._newModule.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["Toolbar"],{style:styles.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["ToolbarGroup"],{float:'left',key:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["ToolbarTitle"],{style:styles.toolbarTitle,text:this.context.getIntlMessage('Modules')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["ToolbarGroup"],{float:'right',key:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Material_ToolbarIconButton__["a" /* default */],{svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationChevronLeft"],null),onTouchTap:this.toggleModuleMenu.bind(this)})))));}},{key:'builderMode',value:function builderMode(){__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */].builderMode();}},{key:'readerMode',value:function readerMode(){__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */].readerMode();}},{key:'getPageTotals',value:function getPageTotals(){var _state2=this.state,courseHasQuiziframe=_state2.courseHasQuiziframe,course=_state2.course;var pageId=parseInt(this.props.params.pageId,10);var toc=courseHasQuiziframe?course.toc.filter(function(s){return s.type!=='quiz';}):course.toc;var pages=toc.reduce(function(previousValue,section){return previousValue.concat(section.pages);},[]);var pageNo=pages.findIndex(function(page){return page.id===pageId;});return{pageNo:pageNo+1,pageTotal:pages.length};}},{key:'scrollModuleIntoView',value:function scrollModuleIntoView(pageModuleId){var el=document.getElementById('pageModule-'+pageModuleId);el&&el.scrollIntoView({block:'start',behavior:'smooth'});}},{key:'checkForQuiziframe',value:function checkForQuiziframe(){var toc=this.state.course.toc;var courseHasQuiz=toc.some(function(section){return section.type==='quiz';});// Get the course pages.
var pageIds=toc.filter(function(section){return section.type==='content';}).map(function(section){return section.pages.map(function(page){return page.id;});}).flat();// Check if any page has quizIframe type. (So we can hide the old quiz)
if(courseHasQuiz&&pageIds.length>1){__WEBPACK_IMPORTED_MODULE_2_actions__["s" /* PageActions */].checkForQuiziframe(pageIds);}this.setState({quiziframeHasBeenChecked:true});}},{key:'getNextAfterQuiz',value:function getNextAfterQuiz(pageId){var next=__WEBPACK_IMPORTED_MODULE_3_stores__["f" /* CourseStore */].getNextForPageId(pageId);if(next==null)return null;var _next$page=next.page,id=_next$page.id,sectionType=_next$page.sectionType;return sectionType==="quiz"?this.getNextAfterQuiz(id):next;}},{key:'getPrevBeforeQuiz',value:function getPrevBeforeQuiz(pageId){var prev=__WEBPACK_IMPORTED_MODULE_3_stores__["f" /* CourseStore */].getPreviousForPageId(pageId);if(prev==null)return null;var _prev$page=prev.page,id=_prev$page.id,sectionType=_prev$page.sectionType;return sectionType==="quiz"?this.getPrevBeforeQuiz(id):prev;}},{key:'render',value:function render(){var _this3=this;var media=this.context.media;var _state3=this.state,auth=_state3.auth,PID=_state3.pageId;var phone=media==='phone'||media==='tablet';if(!this.state.course||!this.state.course.theme||!this.state.page){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppPage__["a" /* default */],{noHeader:true,key:pageId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Material_Loader__["b" /* default */],null));}if(this.state.auth.role.reader&&!this.state.auth.role.editor){this.state.mode='reader';}else{this.state.mode='builder';}var hasNotes=false;var rows=null,params=this.props.routeParams,course=this.state.course,quizSettings=course.settings&&course.settings.quiz,theme=course.theme||{},themeColor=__WEBPACK_IMPORTED_MODULE_3_stores__["z" /* ThemeStore */].getColor(theme.color),footer=null,pageId=parseInt(params.pageId,10),next=__WEBPACK_IMPORTED_MODULE_3_stores__["f" /* CourseStore */].getNextForPageId(pageId),nextPage=next&&next.page||{},previous=__WEBPACK_IMPORTED_MODULE_3_stores__["f" /* CourseStore */].getPreviousForPageId(pageId),previousPage=previous&&previous.page||{},incarnated=auth.incarnated?this.context.getIntlMessage('subAccount.incarnated'):'';// Hide prev/next buttons for old quiz.
if(this.state.courseHasQuiziframe){if(next&&next.page.sectionType==='quiz'){var nextAfterQuiz=this.getNextAfterQuiz(next.page.id);next=nextAfterQuiz;nextPage=nextAfterQuiz&&nextAfterQuiz.page||{};}if(previous&&previous.page.sectionType==='quiz'){var previousBeforeQuiz=this.getPrevBeforeQuiz(previous.page.id);previous=previousBeforeQuiz;previousPage=previousBeforeQuiz&&previousBeforeQuiz.page||{};}}if(this.state.layout&&this.state.layout.pageRows&&this.state.layout.pageRows.length){if(this.state.page.sectionType==='quiz'&&!this.state.course.canEdit){rows=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_containers_QuizContainer__["a" /* default */],{themeColor:themeColor,user:this.state.auth,userdata:this.state.page.userdata,data:this.state.layout.pageRows,pageId:pageId,courseId:course.id,quizSettings:quizSettings&&quizSettings.pages&&quizSettings.pages[pageId]?quizSettings.pages[pageId]:{}});}else{rows=this.state.layout.pageRows.map(function(row){if(!_this3.state.course.canEdit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Page_Row__["a" /* default */],{themeColor:themeColor,user:_this3.state.auth,placement:row.placement,editor:_this3.state.auth.role.editor&&_this3.state.course.canEdit,reader:_this3.state.auth.role.reader,className:'row',data:row,key:row.id,pageId:pageId,courseId:course.id,courseSlug:course.slug,ownerName:course.ownerName});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Page_Row__["a" /* default */],{isQuiz:_this3.state.page.sectionType==='quiz',themeColor:themeColor,user:_this3.state.auth,placement:row.placement,editor:_this3.state.auth.role.editor&&_this3.state.course.canEdit,reader:_this3.state.auth.role.reader,className:'row',data:row,key:row.id,pageId:pageId,courseId:course.id,courseSlug:course.slug,ownerName:course.ownerName});}});}}var currentSection=course.toc.find(function(section){var foundPage=section.pages.find(function(page){return page.id===pageId;});return!!foundPage;});if(this.state.notesEnabled){hasNotes=true;rows=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__containers_NotesContainer__["a" /* default */],{router:this.props.router,ownerSlug:this.state.course.ownerSlug,courseSlug:this.state.course.slug,courseId:course.id,coruseName:course.name,section:currentSection&&currentSection.name||""});}var prevControl=void 0,nextControl=void 0;var shade='Light';var backgroundColor=__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["c" /* Theme */][shade].card;var textColor=__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["b" /* Text */][shade==='Light'?'Dark':'Light'].secondary;var nextStyle={fontSize:14,textTransform:'uppercase',color:'rgba(255, 255, 255, 0.4)',marginLeft:32,marginRight:32};if(next&&next.page&&!next.chapter.isLocked){nextControl=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.nextControl,onTouchTap:this._gotoPage.bind(this,next)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:css.nextControlText},nextPage.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationChevronRight"],{className:css.nextControlIcon,color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite}));}if(previous&&previous.page){prevControl=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.prevControl,onTouchTap:this._gotoPage.bind(this,previous)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationChevronLeft"],{className:css.prevControlIcon,color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:css.prevControlText},previousPage.name));}footer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.footer,style:{backgroundColor:__WEBPACK_IMPORTED_MODULE_3_stores__["z" /* ThemeStore */].getColor(theme.color),color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite}},prevControl,nextControl);var toggleTocButton=void 0;if(!this.state.tocEnabled){// toggleTocButton = <IconButton style={{ height: 56, lineHeight: '56px', verticalAlign: 'top' }} tooltip={this.context.getIntlMessage('course.tableOfContents')} tooltipPosition='bottom-center' onTouchTap={::this.openToc}><Icons.EditorFormatListNumbered color={this.context.muiTheme.rawTheme.palette.textColor} /></IconButton>;
// toggleTocButton = <IconButton style={{ height: 56, lineHeight: '56px', verticalAlign: 'top' }} tooltip={this.context.getIntlMessage('course.tableOfContents')} tooltipPosition='bottom-center' onTouchTap={::this.openToc}><Icons.EditorFormatListNumbered color={this.context.muiTheme.rawTheme.palette.textColor} /></IconButton>;
toggleTocButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Material_ToolbarIconButton__["a" /* default */],{style:{backgroundColor:themeColor,height:60,lineHeight:'60px'},tooltip:this.context.getIntlMessage('toc.open'),tooltipPosition:'bottom-center',svgIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationChevronRight"],null),onTouchTap:this.openToc.bind(this)});}var _getPageTotals=this.getPageTotals(),pageNo=_getPageTotals.pageNo,pageTotal=_getPageTotals.pageTotal;var pageDisplay=void 0;if(media==='phone'||media==='tablet'){pageDisplay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.pageDisplay},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.pageDisplayTitle,style:{color:themeColor}},this.state.page.name,' ',incarnated),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.pageDisplaySubTitle},currentSection&&currentSection.name));}else{pageDisplay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.pageDisplay},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.pageDisplayTitle,style:{color:themeColor}},pageNo+'/'+pageTotal+' : '+this.state.page.name+' '+incarnated));}var header=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getToolbarStyle(this.state.tocEnabled)},toggleTocButton,pageDisplay);//     <FlatButton className='add-module' secondary={true} onTouchTap={this.changeTab.bind(this, 'moduleMenu')}>
//   <i className='md md-add' />
// </FlatButton>
// {footer}
var floatingActionButton=void 0;var _props$params=this.props.params,courseSlug=_props$params.courseSlug,ownerSlug=_props$params.ownerSlug;var moduleMenu=void 0;var panelWidth=phone?4:6;if(this.state.auth.role.editor&&this.state.page.id&&this.state.course.canEdit){floatingActionButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["FloatingActionButton"],{secondary:true,backgroundColor:themeColor,color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,style:this.getFloatingActionButtonStyle(),onTouchTap:this.toggleModuleMenu.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentAdd"],null));moduleMenu=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_containers_PageModuleMenuContainer__["a" /* default */],{course:course});}var addModuleButton=void 0;if(this.state.auth.role.editor&&this.state.course.canEdit){addModuleButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.buttonContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["RaisedButton"],{secondary:true,fullWidth:true,backgroundColor:themeColor,onTouchTap:this.state.page.sectionType==='quiz'?this.newQuestion:this.openModuleMenu,label:this.state.page.sectionType==='quiz'?this.context.getIntlMessage('pageModule.quiz'):this.context.getIntlMessage('pageModule.add')}));}if(!this.state.quiziframeHasBeenChecked){this.checkForQuiziframe();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppPage__["a" /* default */],{noHeader:true,key:pageId},moduleMenu,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.page},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_containers_PageLayoutContainer__["a" /* default */],{onSelectModule:function onSelectModule(pageModuleId){return _this3.scrollModuleIntoView(pageModuleId);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ScrollableContainer__["a" /* default */],{ref:'page',header:header,style:{position:'relative'},onMount:this.scrollIntoView},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getPageStyle()},rows,!hasNotes&&addModuleButton)),!hasNotes&&floatingActionButton,!hasNotes&&footer),moduleMenu,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui__["Dialog"],{title:this.context.getIntlMessage('pageModule.quizQuestionErrorTitle'),actions:[{text:'Ok'}],ref:'confirm'},this.context.getIntlMessage('pageModule.quizQuestionErrorMessage')));}}]);return Page;}(Object(__WEBPACK_IMPORTED_MODULE_16_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_16_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));Page.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Page);

/***/ }),
/* 2346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grid_Grid__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Icons__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_plugins_PageModules__ = __webpack_require__(515);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={icon:{backgroundColor:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].darkBondiBlue,width:Spacing.desktopKeylineIncrement*0.75,height:Spacing.desktopKeylineIncrement*0.75,padding:0,margin:0},container:{backgroundColor:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].darkBondiBlue,// width : Spacing.desktopKeylineIncrement*2-Spacing.desktopGutterMini*2,
// height : Spacing.desktopKeylineIncrement*2-Spacing.desktopGutterMini*4,
margin:Spacing.desktopGutterMini,color:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,fontSize:'18px',textAlign:'center',fontWeight:100,cursor:'pointer'}};var ModuleMenu=function(_Component){_inherits(ModuleMenu,_Component);function ModuleMenu(){_classCallCheck(this,ModuleMenu);return _possibleConstructorReturn(this,(ModuleMenu.__proto__||Object.getPrototypeOf(ModuleMenu)).apply(this,arguments));}_createClass(ModuleMenu,[{key:'_onTouchTap',value:function _onTouchTap(type){this.props.onCreate(type);}},{key:'render',value:function render(){var modules=[];for(var moduleName in __WEBPACK_IMPORTED_MODULE_4_Constants__["pageModules"]){var moduleDetails=__WEBPACK_IMPORTED_MODULE_4_Constants__["pageModules"][moduleName];var Icon=void 0;var icon=void 0;var readable=void 0;var active=true;if(moduleDetails.plugin){if(!moduleDetails.active||!moduleDetails.public&&!false){active=false;}var Mod=__WEBPACK_IMPORTED_MODULE_8_plugins_PageModules__[moduleName.charAt(0).toUpperCase()+moduleName.slice(1)];Icon=__WEBPACK_IMPORTED_MODULE_7_components_Material_SvgIcons__[Mod.icon];readable=Mod.name;var size=Spacing.desktopKeylineIncrement*0.75;icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{style:{width:size,height:size},color:__WEBPACK_IMPORTED_MODULE_6_components_Material_Styles_Colors__["a" /* Colors */].fullWhite});}else{Icon=__WEBPACK_IMPORTED_MODULE_5_components_Icons__[moduleDetails.icon];icon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{size:Spacing.desktopKeylineIncrement*0.75});readable=this.context.getIntlMessage('pageModule.'+moduleName);}if(active){modules.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_Grid__["a" /* GridCell */],{size:6,key:moduleName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.container,onTouchTap:this._onTouchTap.bind(this,moduleDetails.id)},icon,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,readable))));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Grid_Grid__["b" /* GridContainer */],{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('module-menu',this.props.className),fluid:true},this.props.children,modules);}}]);return ModuleMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModuleMenu.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};ModuleMenu.propTypes={onCreate:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (ModuleMenu);

/***/ }),
/* 2347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Column__ = __webpack_require__(2348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Note__ = __webpack_require__(2399);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var styles={noteContainer:{position:'absolute',top:0,right:-2,width:1,bottom:0},column:{transition:'width 0.25s ease'}};var Row=function(_Component){_inherits(Row,_Component);function Row(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Row);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Row.__proto__||Object.getPrototypeOf(Row)).call.apply(_ref,[this].concat(args))),_this),_this.state={mouseOver:false,noteEnabled:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Row,[{key:'mouseEnter',value:function mouseEnter(){var _this2=this;if(this._timer){clearTimeout(this._timer);}if(this._outTimer){clearTimeout(this._outTimer);}this._timer=setTimeout(function(){_this2.state.mouseOver=true;},300);}},{key:'mouseLeave',value:function mouseLeave(){var _this3=this;this._outTimer=setTimeout(function(){_this3.state.mouseOver=false;},300);}},{key:'enableNote',value:function enableNote(){this.state.noteEnabled=true;}},{key:'disableNote',value:function disableNote(){this.state.noteEnabled=false;}},{key:'render',value:function render(){var _this4=this;var columnCount=this.props.data.pageModules.length;var placement=this.props.placement||[6,6];var defaultGridSize=Math.ceil(12/columnCount);var columns=this.props.data.pageModules.map(function(module,index){var weight=placement[index]||6;var gridSize=columnCount===2&&typeof weight!=='undefined'&&weight||defaultGridSize;var columnClass='col-md-'+gridSize;var noteComponent=void 0;var note={text:module.note&&module.note.text||'',color:module.note&&module.note.color||'coursio'};noteComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:5}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Note__["a" /* default */],Object.assign({onEnable:_this4.enableNote.bind(_this4),onDisable:_this4.disableNote.bind(_this4),pageModuleId:module.id},note)));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.column,className:columnClass},noteComponent,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:module.id,id:'pageModule-'+module.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Column__["a" /* default */],{pageRowId:_this4.props.data.id,isQuiz:_this4.props.isQuiz,themeColor:_this4.props.themeColor,user:_this4.props.user,reader:_this4.props.reader,editor:_this4.props.editor,data:module,saving:module.saving,key:module.id,pageId:_this4.props.pageId,courseId:_this4.props.courseId,courseSlug:_this4.props.courseSlug,ownerName:_this4.props.ownerName}))));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row',onMouseEnter:this.mouseEnter.bind(this),onMouseLeave:this.mouseLeave.bind(this)},columns);}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Row.propTypes={placement:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array};Row.defaultProps={};/* harmony default export */ __webpack_exports__["a"] = (Row);

/***/ }),
/* 2348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Module_Image__ = __webpack_require__(2349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Module_Audio__ = __webpack_require__(2350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Module_Download__ = __webpack_require__(2351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Module_Text__ = __webpack_require__(2352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Module_Slideshow__ = __webpack_require__(2353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Module_Task__ = __webpack_require__(2358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Module_Discussion__ = __webpack_require__(2359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Module_Video__ = __webpack_require__(2369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shallowequal__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_module_View_VideoModule__ = __webpack_require__(2370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_module_View_EmbedModule__ = __webpack_require__(2394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Module_Webinar__ = __webpack_require__(2397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Module_QuizIframe__ = __webpack_require__(2398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_helpers_universalAnalytics__ = __webpack_require__(185);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modules={image:__WEBPACK_IMPORTED_MODULE_1__Module_Image__["a" /* default */],audio:__WEBPACK_IMPORTED_MODULE_2__Module_Audio__["a" /* default */],download:__WEBPACK_IMPORTED_MODULE_3__Module_Download__["a" /* default */],text:__WEBPACK_IMPORTED_MODULE_4__Module_Text__["a" /* default */],slideshow:__WEBPACK_IMPORTED_MODULE_5__Module_Slideshow__["a" /* default */],task:__WEBPACK_IMPORTED_MODULE_6__Module_Task__["a" /* default */],discussion:__WEBPACK_IMPORTED_MODULE_7__Module_Discussion__["a" /* default */],video:__WEBPACK_IMPORTED_MODULE_8__Module_Video__["a" /* default */],webinar:__WEBPACK_IMPORTED_MODULE_15__Module_Webinar__["a" /* default */],quiziframe:__WEBPACK_IMPORTED_MODULE_16__Module_QuizIframe__["a" /* default */]};var options={default:{},Audio:{menuItems:{default:[{menu:'edit',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentCreate"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})}],edit:[{onTouchTap:'save',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDone"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{onTouchTap:'cancel',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentClear"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{onTouchTap:'delete',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDelete"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})}],settings:[{onTouchTap:'settings',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionSettings"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{menu:'default',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentClear"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})}]}},Video:{menuItems:{default:[// {menu: 'settings', icon: 'cog'},
{menu:'edit',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentCreate"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})}],edit:[{onTouchTap:'save',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDone"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{onTouchTap:'cancel',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentClear"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{onTouchTap:'delete',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDelete"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})}],settings:[{onTouchTap:'settings',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionSettings"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{menu:'default',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentClear"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})}]}},Image:{menuItems:{default:[{menu:'edit',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentCreate"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})}],edit:[{onTouchTap:'save',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDone"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{onTouchTap:'cancel',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentClear"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{onTouchTap:'delete',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDelete"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})}]}},Download:{menuItems:{default:[{menu:'edit',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentCreate"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})}],edit:[{onTouchTap:'save',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDone"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{onTouchTap:'cancel',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentClear"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{onTouchTap:'delete',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDelete"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})}]}},Slideshow:{menuItems:{default:[// {menu: 'settings', icon: 'cog'},
{menu:'edit',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentCreate"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})}],edit:[{onTouchTap:'save',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDone"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{onTouchTap:'cancel',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentClear"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{onTouchTap:'delete',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDelete"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})// {onTouchTap: 'deleteImage', icon : <MaterialIcons.ActionDelete color={Colors.Colors.fullWhite} />},
// {onTouchTap: 'mediaLibrary', icon : <MaterialIcons.ImagePhotoLibrary color={Colors.Colors.fullWhite} />},
}],settings:[{onTouchTap:'settings',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionSettings"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})},{menu:'default',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ContentClear"],{color:__WEBPACK_IMPORTED_MODULE_10_components_Material_Styles_Colors__["a" /* Colors */].fullWhite})}]}}};var Column=function(_Component){_inherits(Column,_Component);function Column(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Column);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Column.__proto__||Object.getPrototypeOf(Column)).call.apply(_ref,[this].concat(args))),_this),_this.trackInteraction=function(){var typeId=_this.props.data.type.id;var name=null;Object.keys(__WEBPACK_IMPORTED_MODULE_12_Constants__["pageModules"]).forEach(function(moduleName){if(__WEBPACK_IMPORTED_MODULE_12_Constants__["pageModules"][moduleName].id===typeId){name=moduleName;}});if(name){__WEBPACK_IMPORTED_MODULE_17_helpers_universalAnalytics__["a" /* default */].event(_this.props.courseId,name+'_interaction',{eventLabel:_this.props.pageId});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Column,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return!__WEBPACK_IMPORTED_MODULE_11_shallowequal___default()(this.props,nextProps);}},{key:'render',value:function render(){var type=this.props.data.type;var Module=void 0;var ModuleName=void 0;var className=void 0;if(type.name){var name=type.name;if(name==='!video'){var _props=this.props,editor=_props.editor,saving=_props.saving,data=_props.data;var _data$data=data.data,sources=_data$data.sources,caption=_data$data.caption;var id=data.id,mode=data.mode;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_module_View_VideoModule__["a" /* default */],{editor:editor,saving:saving,id:id,caption:caption,sources:sources,mode:mode});}else if(name==='embed'){var _props2=this.props,_editor=_props2.editor,_saving=_props2.saving,_data=_props2.data;var _data$data2=_data.data,_sources=_data$data2.sources,_caption=_data$data2.caption;var _id=_data.id,_mode=_data.mode;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_module_View_EmbedModule__["a" /* default */],{editor:_editor,saving:_saving,id:_id,sources:_sources||[],caption:_caption,mode:_mode});}else{className='page-module '+type.name+'-module '+this.props.columnClass;Module=Modules[name];ModuleName=name;}}else{className='page-module';Object.keys(__WEBPACK_IMPORTED_MODULE_12_Constants__["pageModules"]).forEach(function(moduleName){if(__WEBPACK_IMPORTED_MODULE_12_Constants__["pageModules"][moduleName].id===type.id){Module=Modules[moduleName];ModuleName=moduleName;}});}if(Module){var _props$data=this.props.data,_mode2=_props$data.mode,_saving2=_props$data.saving;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Module,Object.assign({themeColor:this.props.themeColor,data:this.props.data.data},this.props.data.data,{isQuiz:this.props.isQuiz,saving:_saving2,name:type.name,user:this.props.user,editor:this.props.editor,reader:this.props.reader,moduleId:this.props.data.id,pageId:this.props.pageId,courseId:this.props.courseId,courseSlug:this.props.courseSlug,ownerName:this.props.ownerName,gaTracking:this.trackInteraction,pageRowId:this.props.pageRowId,mode:_mode2,defaultMenu:_mode2,className:className,moduleName:ModuleName}));}else{return null;}}}]);return Column;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Column);

/***/ }),
/* 2349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Widgets_FileSelectorDialog__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_DropZone__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_CircularProgress__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_ResponsiveImage__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Overlay__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_PageModule__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_SteelCompass__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var imageScalingWidth=Math.min(2000,0.9*window.screen.width);var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var styles={detail:{position:'absolute',left:0,right:0,bottom:0,padding:Spacing.desktopGutterMini},header:{fontSize:'24px',margin:0,fontWeight:100},progress:{position:'absolute',left:0,right:0,top:0,bottom:0,textAlign:'center'},scrollContainer:{overflow:'auto',maxHeight:'95vh'},imageContainer:{position:'fixed',left:Spacing.desktopGutter,right:Spacing.desktopGutter,top:Spacing.desktopGutter,bottom:Spacing.desktopGutter,display:'flex',alignItems:'center',justifyContent:'center'},overlayImage:{borderRadius:2,borderColor:__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material,borderWidth:1,maxWidth:'100%',maxHeight:'100%',width:'100%'}};var ImageModule=function(_PageModule){_inherits(ImageModule,_PageModule);function ImageModule(){_classCallCheck(this,ImageModule);var _this=_possibleConstructorReturn(this,(ImageModule.__proto__||Object.getPrototypeOf(ImageModule)).apply(this,arguments));_this.state={edit:{}};var _this$props=_this.props,sources=_this$props.sources,content=_this$props.content,params=_this$props.params;var url=void 0;var fileId=void 0;var caption=params.caption;if(sources&&sources.length&&sources.length>0){url=sources[0].data;fileId=params&&params.file_id&&params.file_id[0];}else if(params.fileId){url=params.url;fileId=params.fileId;}else if(content&&content.length&&content.length>0){url=content[0].url;fileId=content[0].fileId;}_this.state={edit:{url:url,fileId:fileId,caption:caption}};return _this;}_createClass(ImageModule,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var sources=nextProps.sources,content=nextProps.content,params=nextProps.params;var url=void 0;var fileId=void 0;var caption=params.caption;if(sources&&sources.length&&sources.length>0){url=sources[0].data;fileId=params&&params.file_id&&params.file_id[0];}else if(params.fileId){url=params.url;fileId=params.fileId;}else if(content&&content.length&&content.length>0){url=content[0].url;fileId=content[0].fileId;}if(url&&fileId){this.setState({edit:{url:url,fileId:fileId,caption:caption}});}}},{key:'onMediaLibrary',value:function onMediaLibrary(){this.setState({fileSelectorOpen:true});}},{key:'onMediaLibraryClose',value:function onMediaLibraryClose(){this.setState({fileSelectorOpen:false});}},{key:'openDownload',value:function openDownload(event){this.refs.dropZone.open();event.stopPropagation();event.preventDefault();}},{key:'selectMedia',value:function selectMedia(file){var edit=Object.assign({},this.state.edit,{fileId:file.id,url:file.url});this.setState({edit:edit,fileSelectorOpen:false});this.autoSave();}},{key:'import',value:function _import(){var _this2=this;var url=this.refs.import.value.trim();if(url===''){__WEBPACK_IMPORTED_MODULE_13_services_Message__["a" /* default */].info(this.context.getIntlMessage('image.provideImportUrl'));return;}__WEBPACK_IMPORTED_MODULE_14_services_SteelCompass__["a" /* default */].call('file','import',{url:url,encode:false},function(response){if(!response.isError){var edit=Object.assign({},_this2.state.edit,{url:response.data.file.url,fileId:response.data.file.id});_this2.setState({edit:edit});_this2.autoSave();__WEBPACK_IMPORTED_MODULE_13_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('image.imported'));}else{__WEBPACK_IMPORTED_MODULE_13_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('image.importFailed'));}});}},{key:'progress',value:function progress(event){this.setState({progress:event.percent});}},{key:'attach',value:function attach(data){var edit=Object.assign({},this.state.edit,{fileId:data[0]&&data[0].file.id,url:data[0]&&data[0].file.url});this.setState({edit:edit});this.autoSave();}},{key:'openOverlay',value:function openOverlay(){this.setState({overlayOpen:true});}},{key:'closeOverlay',value:function closeOverlay(){this.setState({overlayOpen:false});}},{key:'changeCaption',value:function changeCaption(e){var edit=Object.assign({},this.state.edit,{caption:e.target.value});this.setState({edit:edit});}},{key:'saveOnBlur',value:function saveOnBlur(){__WEBPACK_IMPORTED_MODULE_13_services_Message__["a" /* default */].info(this.context.getIntlMessage('video.changesSaved'));this.save(false);}},{key:'autoSave',value:function autoSave(){var _this3=this;if(this._timer){clearTimeout(this._timer);}this._timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_13_services_Message__["a" /* default */].info(_this3.context.getIntlMessage('video.changesSaved'));_this3.save(false);_this3._timer=null;},1000);}},{key:'getModuleData',value:function getModuleData(content,data){return{caption:this.state.edit.caption,fileId:this.state.edit.fileId||data.fileId};}},{key:'renderEditMode',value:function renderEditMode(){var _ref=this.state||{},edit=_ref.edit;var image=void 0;var uploadLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:this.openDownload.bind(this)},this.context.getIntlMessage('module.upload'));var libraryLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:this.onMediaLibrary.bind(this)},this.context.getIntlMessage('module.library'));if(this.state.progress>0&&this.state.progress<100){image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_CircularProgress__["a" /* default */],{progressColor:this.context.muiTheme.rawTheme.palette.primary1Color,progress:this.state.progress,size:2});}else if(edit.url){var params=this.props.data.params;image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_ResponsiveImage__["a" /* default */],{raw:params.hasOwnProperty('raw')&&params.raw,style:{width:'100%',height:300},contain:true,size:imageScalingWidth,src:edit.url});}else{image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__["ImageImage"],{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].icon});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_DropZone__["a" /* default */],{ref:'dropZone',style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].dropZone,lineHeight:Spacing.desktopKeylineIncrement/2,onProgress:this.progress.bind(this),onSuccess:this.attach.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].moduleContainer},image),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].header},this.context.getIntlMessage('module.dropImage')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].subHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('module.uploadOrBrowse'),upload:uploadLink,library:libraryLink})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].subHeader},this.context.getIntlMessage('module.youCanImport')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Paper"],{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].import.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:'import',style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].import.input,type:'text',placeholder:this.context.getIntlMessage('importFromUrl'),onChange:this.import.bind(this)})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{ref:'caption',fullWidth:true,hintText:this.context.getIntlMessage('Caption'),value:edit.caption,onChange:this.changeCaption.bind(this),onBlur:this.saveOnBlur.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Widgets_FileSelectorDialog__["a" /* default */],{type:'image',open:this.state.fileSelectorOpen,onSelect:this.selectMedia.bind(this),onClose:this.onMediaLibraryClose.bind(this)}));}},{key:'renderDetailMode',value:function renderDetailMode(){var _state$edit=this.state.edit,url=_state$edit.url,caption=_state$edit.caption;var params=this.props.data.params;var image=void 0;if(url){if(this.state.overlayOpen){image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Overlay__["a" /* default */],{open:this.state.overlayOpen,onClose:this.closeOverlay.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.imageContainer,onTouchTap:this.closeOverlay.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.scrollContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_ResponsiveImage__["a" /* default */],{contain:true,raw:params.hasOwnProperty('raw')&&params.raw,size:imageScalingWidth,style:styles.overlayImage,src:url}))));}else{if(params.hasOwnProperty('raw')&&params.raw){image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_ResponsiveImage__["a" /* default */],{onTouchTap:this.openOverlay.bind(this),raw:params.raw,src:url,style:{width:'inherit',cursor:'pointer'}});}else{image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_ResponsiveImage__["a" /* default */],{contain:true,size:imageScalingWidth,onTouchTap:this.openOverlay.bind(this),src:url,style:{maxWidth:'100%',cursor:'pointer',width:'100%'}});}}}else{image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].dropZone},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].moduleContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Material_SvgIcons__["ImageImage"],{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.context.getIntlMessage('module.uploadImage')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',marginBottom:42}},image,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{style:{fontSize:'13px',fontStyle:'italic'}},caption));}}]);return ImageModule;}(__WEBPACK_IMPORTED_MODULE_12_components_PageModule__["a" /* default */]);ImageModule.readable='ImageModule';/* harmony default export */ __webpack_exports__["a"] = (ImageModule);

/***/ }),
/* 2350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Widgets_FileSelectorDialog__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_DropZone__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_CircularProgress__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Embed__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_superagent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_PageModule__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_SoundCloud__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_Css__ = __webpack_require__(6);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var styles={audio:{width:'100%'}};var css={toggleWrapper:'_kp'};var supportedExtensions=['mp4'];var AudioModule=function(_PageModule){_inherits(AudioModule,_PageModule);function AudioModule(){_classCallCheck(this,AudioModule);var _this=_possibleConstructorReturn(this,(AudioModule.__proto__||Object.getPrototypeOf(AudioModule)).apply(this,arguments));_initialiseProps.call(_this);var _this$props=_this.props,content=_this$props.content,params=_this$props.params;var caption=params.caption,external=params.external,allowDownloading=params.allowDownloading,file_id=params.file_id;var file=void 0;var sources=[];if(content.length&&content.length>0){file=content[0];sources=file&&supportedExtensions.map(function(extension){return{url:file.url+'.'+extension,type:extension};})||[];}else if(params&&(typeof params==='undefined'?'undefined':_typeof(params))==='object'&&Object.keys(params).length>0&&!params.external){sources=Object.keys(params).map(function(extension){return{url:params[extension],type:extension};});}// const sources = [{ url: file.url, type: file.url.split('.').pop() }];
_this.state={edit:{sources:sources,external:external,caption:caption,allowDownloading:allowDownloading,fileId:file_id?file_id[0]:null}};return _this;}_createClass(AudioModule,[{key:'controlsList',value:function controlsList(){var _state$edit=this.state.edit,allowDownloading=_state$edit.allowDownloading,fileId=_state$edit.fileId;var audioPlayer=document.getElementById(''+fileId);if(audioPlayer&&allowDownloading&&audioPlayer.hasAttribute('controlsList')){audioPlayer.removeAttribute('controlsList');}if(audioPlayer&&!allowDownloading&&!audioPlayer.hasAttribute('controlsList')){audioPlayer.setAttribute('controlsList','nodownload');}}},{key:'componentDidMount',value:function componentDidMount(){this.controlsList();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.params.allowDownloading!==prevState.edit.allowDownloading){this.controlsList();}}},{key:'selectMedia',value:function selectMedia(file){var sources=supportedExtensions.map(function(extension){return{url:file.url,type:extension};});var edit=Object.assign({},this.state.edit,{fileId:file.id,external:null,sources:sources});this.setState({edit:edit,fileSelectorOpen:false});// this.autoSave();
}},{key:'progress',value:function progress(event){this.setState({progress:event.percent});}},{key:'onMediaLibrary',value:function onMediaLibrary(){this.setState({fileSelectorOpen:true});}},{key:'onMediaLibraryClose',value:function onMediaLibraryClose(){this.setState({fileSelectorOpen:false});}},{key:'openDownload',value:function openDownload(event){this.refs.dropZone.open();event.stopPropagation();event.preventDefault();}},{key:'changeCaption',value:function changeCaption(e){var edit=Object.assign({},this.state.edit,{caption:e.target.value});this.setState({edit:edit});}},{key:'saveOnBlur',value:function saveOnBlur(){__WEBPACK_IMPORTED_MODULE_17_services_Message__["a" /* default */].info(this.context.getIntlMessage('video.changesSaved'));this.save(false);}},{key:'getModuleData',value:function getModuleData(content,data){return{caption:this.state.edit.caption,allowDownloading:this.state.edit.allowDownloading,fileId:this.state.edit.fileId||data.fileId,external:this.state.edit.external};}},{key:'embed',value:function embed(){var _this2=this;var url=this.refs.embedUrl.value;var provider=__WEBPACK_IMPORTED_MODULE_15_Util__["b" /* Media */].getProviderFromUrl(url);var edit=Object.assign({},this.state.edit);if(provider.provider===3){__WEBPACK_IMPORTED_MODULE_16_services_SoundCloud__["a" /* default */].oEmbed(url,function(response){provider.id=response.html;edit.external=provider;_this2.setState({edit:edit});_this2.autoSave();});}else{edit.external=provider;this.setState({edit:edit});this.autoSave();}}},{key:'attach',value:function attach(data){if(data.length&&data.length>0){var file=data[0].file;var sources=supportedExtensions.map(function(extension){return{url:file.url,type:extension};});var edit=Object.assign({},this.state.edit,{external:null,fileId:file.id,sources:sources});this.setState({edit:edit});this.getModuleData();this.pollApiForJobId(file.id);}}},{key:'autoSave',value:function autoSave(){var _this3=this;if(this._timer){clearTimeout(this._timer);}this._timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_17_services_Message__["a" /* default */].info(_this3.context.getIntlMessage('video.changesSaved'));_this3.save(false);_this3._timer=null;},1000);}},{key:'pollApiForJobId',value:function pollApiForJobId(fileId){var _this4=this;if(!this.state.pollProgress){this.setState({pollProgress:true});}setTimeout(function(){var now=new Date();_this4.apiPollerStart=_this4.apiPollerStart||new Date();if(now-_this4.apiPollerStart<100000){__WEBPACK_IMPORTED_MODULE_10_services_SteelCompass__["a" /* default */].call('file','getJobId',{fileId:fileId},function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:data=response.data;// Poll encoding progress
if(!(data&&data.jobId&&data.accessKey)){_context.next=6;break;}_context.next=4;return _this4.pollZencForProgress(data.jobId,data.accessKey);case 4:_context.next=7;break;case 6:// Keep polling for jobId
_this4.pollApiForJobId(fileId);case 7:case'end':return _context.stop();}}},_callee,_this4);}));return function(_x){return _ref.apply(this,arguments);};}());}else{// Reset polling
_this4.apiPollerStart=null;}},5000);}},{key:'pollZencForProgress',value:function pollZencForProgress(jobId,accessKey){var _this5=this;this.setState({progress:0,pollProgress:false});setTimeout(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var now,response,data,sources;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:now=new Date();_this5.zencPollerStart=_this5.zencPollerStart||new Date();if(!(now-_this5.zencPollerStart<100000||_this5.encodingProgress>0&&_this5.encodingProgress<100)){_context2.next=16;break;}_context2.next=5;return __WEBPACK_IMPORTED_MODULE_11_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_12_Config__["a" /* default */].zenCoderRoot+'jobs/'+jobId+'/progress.json?api_key='+accessKey).set('Content-Type','text/plain');case 5:response=_context2.sent;data=response&&JSON.parse(response.text)||{};// Data object should contain a state and a progress property if the state is still processing.
if(!(data.state==='processing'&&data.progress)){_context2.next=13;break;}if(data.progress>_this5.state.progress){_this5.setState({progress:data.progress});}_context2.next=11;return _this5.pollZencForProgress(jobId,accessKey);case 11:_context2.next=14;break;case 13:if(data.state==='finished'){// Stop the polling
sources=_this5.state.edit.sources.map(function(source){return Object.assign({},source,{url:source.url});});_this5.setState({progress:100,pollProgress:false,edit:Object.assign({},_this5.state.edit,{sources:sources})});__WEBPACK_IMPORTED_MODULE_17_services_Message__["a" /* default */].info(_this5.context.getIntlMessage('media.encodingComplete'));}case 14:_context2.next=18;break;case 16:// Reset polling
_this5.zencPollerStart=null;_this5.autoSave();case 18:case'end':return _context2.stop();}}},_callee2,_this5);})),2000);}},{key:'renderEditMode',value:function renderEditMode(){var _state$edit2=this.state.edit,sources=_state$edit2.sources,external=_state$edit2.external,caption=_state$edit2.caption,allowDownloading=_state$edit2.allowDownloading;var audioSources=sources.map(function(source){if(typeof source.url==='string'){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('source',{src:source.url.split('.')[source.url.split('.').length-1]===source.type?source.url:source.url+'.'+source.type,type:'audio/'+source.type,key:source.type});}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('source',{src:source.url,type:'audio/'+source.type,key:source.type});}});var audio=void 0;var pollProgress=void 0;if(this.state.pollProgress){pollProgress=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["LinearProgress"],{style:{height:Spacing.desktopKeylineIncrement/4},mode:'indeterminate'});}var uploadLink=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onTouchTap:this.openDownload.bind(this)},this.context.getIntlMessage('module.upload'));var libraryLink=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onTouchTap:this.onMediaLibrary.bind(this)},this.context.getIntlMessage('module.library'));if(this.state.progress>0&&this.state.progress<100){audio=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_CircularProgress__["a" /* default */],{progressColor:this.context.muiTheme.rawTheme.palette.primary1Color,progress:this.state.progress,size:2});}else if(sources.length>0||external&&external.provider){if(external&&external.provider){audio=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Embed__["a" /* default */],{params:external});}else{audio=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{controls:true,style:styles.audio},audioSources);}}else{audio=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Material_SvgIcons__["AvMovie"],{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].icon});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].moduleContainer},audio,pollProgress),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_DropZone__["a" /* default */],{accept:'audio/*',ref:'dropZone',style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].dropZone,lineHeight:Spacing.desktopKeylineIncrement/2,onProgress:this.progress.bind(this),onSuccess:this.attach.bind(this)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].header},this.context.getIntlMessage('module.dropAudio')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].subHeader},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('module.uploadOrBrowse'),upload:uploadLink,library:libraryLink})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].subHeader},this.context.getIntlMessage('module.or')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Paper"],{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].import.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{ref:'embedUrl',style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].import.input,type:'text',placeholder:this.context.getIntlMessage('audio.embed'),onChange:this.embed.bind(this)})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["TextField"],{fullWidth:true,hintText:this.context.getIntlMessage('Caption'),value:caption,onChange:this.changeCaption.bind(this)// onBlur={::this.saveOnBlur}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:css.toggleWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Toggle"],{name:'allowDownloading',value:'allowDownloading',labelPosition:'right',defaultToggled:allowDownloading,label:this.context.getIntlMessage('video.allowDownloading'),onToggle:this.allowDownloading})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Widgets_FileSelectorDialog__["a" /* default */],{type:'audio',open:this.state.fileSelectorOpen,onSelect:this.selectMedia.bind(this),onClose:this.onMediaLibraryClose.bind(this)}));// return (
//   <div>
//     <DropZone accept="audio/*" ref="dropZone" style={dropZoneStyles.dropZone} lineHeight={Spacing.desktopKeylineIncrement / 2} onProgress={this.progress} onSuccess={this.attach}>
//       <div style={dropZoneStyles.moduleContainer}>{audio}</div>
//       <div style={dropZoneStyles.header}>{this.context.getIntlMessage('module.dropAudio')}</div>
//       <div style={dropZoneStyles.subHeader}>
//         <FormattedMessage message={this.context.getIntlMessage('module.uploadOrBrowse')} upload={uploadLink} library={libraryLink} />
//       </div>
//       <div style={dropZoneStyles.subHeader}>
//         {this.context.getIntlMessage('module.or')}
//       </div>
//       <Paper style={styles.import.root}>
//         <input ref="embedUrl" style={styles.import.input} type='text' placeholder={this.getIntlMessage('audio.embed')} value={this.state.embedUrl} onChange={this.embed}/>
//         <FlatButton secondary={true} label={this.getIntlMessage('Embed')} onTouchTap={this.embed}/>
//       </Paper>
//       <TextField fullWidth={true} floatingLabelText={this.getIntlMessage('Caption')} value={this.state.caption} onChange={this.changeCaption}/>
//     </DropZone>
//   </div>
// );
}},{key:'renderDetailMode',value:function renderDetailMode(){var _state$edit3=this.state.edit,sources=_state$edit3.sources,caption=_state$edit3.caption,external=_state$edit3.external,fileId=_state$edit3.fileId;var audio=void 0;if(external&&external.provider){audio=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Embed__["a" /* default */],{params:external});}else if(sources&&sources.length>0){var audioSources=sources.map(function(source){if(typeof source.url==='string'){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('source',{src:source.url.split('.')[source.url.split('.').length-1]===source.type?source.url:source.url+'.'+source.type,type:'audio/'+source.type,key:source.type});}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('source',{src:source.url,type:'audio/'+source.type,key:source.type});}});audio=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{id:fileId,controls:true,style:styles.audio},audioSources,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('figcaption',null,caption));}else{audio=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].dropZone},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].moduleContainer},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Material_SvgIcons__["ImageAudiotrack"],{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].icon}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),this.context.getIntlMessage('module.uploadAudio')));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,audio,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('figcaption',null,caption));}}]);return AudioModule;}(__WEBPACK_IMPORTED_MODULE_14_components_PageModule__["a" /* default */]);AudioModule.readable='AudioModule';var _initialiseProps=function _initialiseProps(){var _this6=this;this.allowDownloading=function(event,allowDownloading){_this6.setState({edit:Object.assign({},_this6.state.edit,{allowDownloading:allowDownloading})});};};/* harmony default export */ __webpack_exports__["a"] = (AudioModule);

/***/ }),
/* 2351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Widgets_FileSelectorDialog__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_DropZone__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_CircularProgress__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_PageModule__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_services_Message__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var donwloadStyles={root:{textAlign:'center'}};var DownloadModule=function(_PageModule){_inherits(DownloadModule,_PageModule);function DownloadModule(){_classCallCheck(this,DownloadModule);var _this=_possibleConstructorReturn(this,(DownloadModule.__proto__||Object.getPrototypeOf(DownloadModule)).apply(this,arguments));var _this$props=_this.props,content=_this$props.content,params=_this$props.params;var caption=params.caption;var files=content||[];_this.state={edit:{files:files,caption:caption}};return _this;}_createClass(DownloadModule,[{key:'selectMedia',value:function selectMedia(file){var edit=Object.assign({fileId:file.id},this.state.edit,{files:[Object.assign({},file)]});this.setState({edit:edit,fileSelectorOpen:false});if(edit.files&&edit.files[0].type){this.attach(edit);this.autoSave();}else{this.autoSave();}}},{key:'attach',value:function attach(data){if(data.length&&data.length>0){var file=data[0].file;var files=[file];var edit=Object.assign({},this.state.edit,{fileId:file.id,fileName:file.name,files:files});this.setState({edit:edit});this.autoSave();}}},{key:'progress',value:function progress(event){this.setState({progress:event.percent});}},{key:'onMediaLibrary',value:function onMediaLibrary(){this.setState({fileSelectorOpen:true});}},{key:'onMediaLibraryClose',value:function onMediaLibraryClose(){this.setState({fileSelectorOpen:false});}},{key:'openDownload',value:function openDownload(event){this.refs.dropZone.open();event.stopPropagation();event.preventDefault();}},{key:'changeCaption',value:function changeCaption(e){var _this2=this;if(this._timer){clearTimeout(this._timer);}var edit=Object.assign({},this.state.edit,{caption:e.target.value});this.setState({edit:edit});this._timer=setTimeout(function(){_this2.autoSave();__WEBPACK_IMPORTED_MODULE_9_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('video.changesSaved'));_this2._timer=null;},1000);}},{key:'getModuleData',value:function getModuleData(content,data){return{caption:this.state.edit.caption,fileId:this.state.edit.fileId||data.fileId,external:this.state.edit.external};}},{key:'getPrettySize',value:function getPrettySize(size){var unit=void 0;var prettySize=void 0;if(size<1024){prettySize=size;unit='B';}else if(size<1048576){prettySize=size/1024;unit='KB';}else if(size<1073741824){prettySize=size/1048576;unit='MB';}else{prettySize=size/1073741824;unit='GB';}prettySize=Math.round(prettySize*100)/100;return prettySize+' '+unit;}},{key:'getModuleData',value:function getModuleData(content,data){return{caption:this.state.edit.caption,fileId:this.state.edit.fileId||data.fileId};}},{key:'changeLink',value:function changeLink(file,e){this.props.gaTracking();if(file.type&&file.type.indexOf('video')!=-1||file.type&&file.type.indexOf('audio')!=-1){e.stopPropagation();e.preventDefault();var parts=file.url.split('?'),//    r = new Image,
url=document.location.protocol+parts[0].replace(/,/g,'.').replace('coursio.s3-eu-west-1.amazonaws.com','download.s.coursio.com');// console.log('start', url)
var r=document.createElement('iframe');r.onload=function(e,a,b,c){// console.log(e,a,b,c)
var parts2=url.split('.');if(['ogg','mp4'].indexOf(parts2.slice(-1)[0])!=-1){parts2.pop();url=parts2.join('.');}else{url=parts2+'.mp4';}if(parts.length>1){url+='?'+parts[1];}url=url.replace(/,/g,'.');// console.log('fixed url', url)
window.open(url,'_blank');};r.onerror=function(){// console.log('nothing done', url)
url+='?name='+file.name;// console.log(url)
window.open(url.replace(/,/g,'.'),'_blank');};r.src=url+'?name='+file.name;document.body.appendChild(r);return false;}}},{key:'renderDetailMode',value:function renderDetailMode(){var _this3=this;var files=[];var edit=this.state.edit;if(edit.files.length>0){files=edit.files.map(function(file,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:_this3.changeLink.bind(_this3,file),key:index,download:true,href:file.url.replace('coursio.s3-eu-west-1.amazonaws.com','download.s.coursio.com')+'?name='+file.name.toLowerCase().replace('&','and'),style:{lineHeight:Spacing.desktopKeylineIncrement+'px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["FileCloudDownload"],{style:__WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__["a" /* default */].icon,color:_this3.props.themeColor}),file.name,'(',_this3.getPrettySize(file.size),')');});}else{files=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__["a" /* default */].dropZone},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__["a" /* default */].moduleContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["FileCloudDownload"],{style:__WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__["a" /* default */].icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.context.getIntlMessage('module.uploadFile')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:donwloadStyles.root},files,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',null,edit.caption));}},{key:'renderEditMode',value:function renderEditMode(){var _this4=this;var _state=this.state,fileSelectorOpen=_state.fileSelectorOpen,edit=_state.edit;var uploadLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:this.openDownload.bind(this)},this.context.getIntlMessage('module.upload'));var libraryLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:this.onMediaLibrary.bind(this)},this.context.getIntlMessage('module.library'));var download=void 0;if(this.state.progress>0&&this.state.progress<100){download=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_CircularProgress__["a" /* default */],{progressColor:this.context.muiTheme.rawTheme.palette.primary1Color,progress:this.state.progress,size:2});}else if(edit.files.length>0){download=edit.files.map(function(file,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:index,target:'_blank',href:file.url,style:{lineHeight:Spacing.desktopKeylineIncrement+'px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["FileCloudDownload"],{style:__WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__["a" /* default */].icon}),file.name,' (',_this4.getPrettySize(file.size),')');});}else{download=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_SvgIcons__["FileCloudDownload"],{style:__WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__["a" /* default */].icon});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_DropZone__["a" /* default */],{ref:'dropZone',style:__WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__["a" /* default */].dropZone,lineHeight:Spacing.desktopKeylineIncrement/2,onProgress:this.progress.bind(this),onSuccess:this.attach.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__["a" /* default */].moduleContainer},download),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__["a" /* default */].header},this.context.getIntlMessage('module.dropOneFile')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_8_components_Page_Module_Styles__["a" /* default */].subHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('module.uploadOrBrowse'),upload:uploadLink,library:libraryLink})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{fullWidth:true,floatingLabelText:this.context.getIntlMessage('Caption'),value:edit.caption,onChange:this.changeCaption.bind(this)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Widgets_FileSelectorDialog__["a" /* default */],{open:fileSelectorOpen,onSelect:this.selectMedia.bind(this),onClose:this.onMediaLibraryClose.bind(this)}));}}]);return DownloadModule;}(__WEBPACK_IMPORTED_MODULE_7_components_PageModule__["a" /* default */]);DownloadModule.readable='DownloadModule';/* harmony default export */ __webpack_exports__["a"] = (DownloadModule);

/***/ }),
/* 2352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Widgets_Ozitor__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_PageModule_Controls__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_PageModule__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Page_Module_Styles__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_oxygen_debounce__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextModule=function(_PageModule){_inherits(TextModule,_PageModule);function TextModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TextModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TextModule.__proto__||Object.getPrototypeOf(TextModule)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(content){_this.autoSave(content);},_this.autoSave=__WEBPACK_IMPORTED_MODULE_8_oxygen_debounce___default()(function(content){var _this$props=_this.props,id=_this$props.moduleId,data=_this$props.data;__WEBPACK_IMPORTED_MODULE_5_actions__["u" /* PageModuleActions */].changePageModule({id:id,data:Object.assign({},data,{content:content})},function(newModule){var newData=newModule.data;__WEBPACK_IMPORTED_MODULE_5_actions__["u" /* PageModuleActions */].savePageModule(_this.props.moduleId,newData.content,newData.params);});},300),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TextModule,[{key:'renderDetailMode',value:function renderDetailMode(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(_node){return _this2._renderNode=_node;}})// <div dangerouslySetInnerHTML={{  __html: '<div style="padding: 0.6em">' + this.props.content + '</div>' }} />
;}},{key:'getStyle',value:function getStyle(){var mouseOver=this.state.mouseOver;var _props=this.props,style=_props.style,mode=_props.mode;var margins={marginBottom:42};return Object.assign({},__WEBPACK_IMPORTED_MODULE_7_components_Page_Module_Styles__["a" /* default */].root,margins,style,mode==='edit'?__WEBPACK_IMPORTED_MODULE_7_components_Page_Module_Styles__["a" /* default */].edit:null,mode==='edit'&&mouseOver?__WEBPACK_IMPORTED_MODULE_7_components_Page_Module_Styles__["a" /* default */].hover:null);}},{key:'createModuleControls',value:function createModuleControls(){var mode=this.props.mode;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_PageModule_Controls__["a" /* default */],{style:__WEBPACK_IMPORTED_MODULE_7_components_Page_Module_Styles__["a" /* default */].toolbarGroup,onSave:this.save.bind(this),onDelete:this.askForDelete.bind(this),onEditMode:this.changeToEditMode.bind(this),mode:mode});}},{key:'onEdit',value:function onEdit(){}},{key:'getContent',value:function getContent(content,params){return this.props.content;}},{key:'componentDidMount',value:function componentDidMount(){var renderNode=this._renderNode;if(renderNode){renderNode.innerHTML='';var div=document.createElement('div');try{div.innerHTML='<div style="padding: 0.6em">'+this.props.content+'</div>';}catch(e){}renderNode.appendChild(div);}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var renderNode=this._renderNode;if(renderNode){renderNode.innerHTML='';var div=document.createElement('div');try{div.innerHTML='<div style="padding: 0.6em">'+this.props.content+'</div>';}catch(e){}renderNode.appendChild(div);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){// this.autoSave.clear();
}},{key:'onDetail',value:function onDetail(){this.autoSave(this.refs.editor.getValue());}},{key:'renderEditMode',value:function renderEditMode(){var content=this.props.content;var extraControls=this.createModuleControls();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Widgets_Ozitor__["a" /* default */],{onChange:this.handleChange,ref:'editor',extraControls:extraControls,editable:this.props.mode==='edit',defaultContent:content});}},{key:'createControls',value:function createControls(){var mode=this.props.mode;if(mode==='edit'){return null;}return _get(TextModule.prototype.__proto__||Object.getPrototypeOf(TextModule.prototype),'createControls',this).call(this);}}]);return TextModule;}(__WEBPACK_IMPORTED_MODULE_6_components_PageModule__["a" /* default */]);TextModule.displayName='TextModule';TextModule.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (TextModule);

/***/ }),
/* 2353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Widgets_FileSelectorDialog__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_DropZone__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Material_CircularProgress__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_PageModule__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fullscreen__ = __webpack_require__(2354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_MediaContainer__ = __webpack_require__(2357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_ResponsiveImage__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var canUseFullscreen=document.fullscreenEnabled||document.webkitFullscreenEnabled||document.msFullscreenEnabled||document.mozFullScreenEnabled;var iconColor=__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].fullWhite;var activeColor=__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].grey[700].material;var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var hoverColor=__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material;var styles={fullScreen:{position:'fixed',left:0,right:0,bottom:0,top:0,backgroundColor:__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].fullBlack},box:{position:'absolute',left:0,right:0,top:0,bottom:0},root:{margin:'auto',display:'block',maxWidth:'100%',position:'relative',paddingBottom:'56.25%'/* 16:9 */,height:0},image:{maxWidth:'100%',maxHeight:'100%'},imageWrapper:{position:'absolute',top:0,left:0,width:'100%',height:'100%',border:'none',backgroundPosition:'center center',backgroundSize:'contain',backgroundRepeat:'no-repeat',textAlign:'center'},progressDot:{cursor:'pointer'},slideshowProgress:{textAlign:'center',minHeight:Spacing.desktopGutterMore,margin:Spacing.desktopGutterMini/2},caption:{minHeight:Spacing.desktopGutterMore},icon:{filter:'drop-shadow( 0px 0px 1px #000 )',WebkitFilter:'drop-shadow( 0px 0px 1px #000 )'},verticalHelper:{display:'inline-block',height:'100%',verticalAlign:'middle'},big:{width:48,height:48},prevNext:{position:'absolute',marginTop:-24,top:'50%',cursor:'pointer'},prev:{left:0},next:{right:0},fullscreenControl:{position:'absolute',right:Spacing.desktopGutterMini,bottom:Spacing.desktopGutterMini,backgroundColor:'rgba(255, 255, 255, 0.5)',width:Spacing.iconSize,height:Spacing.iconSize,margin:0,padding:0,cursor:'pointer',lineHeight:Spacing.iconSize+'px'},deleteImageButton:{button:{lineHeight:36+'px',width:36,height:36,minWidth:36,position:'absolute',right:0,bottom:0,verticalAlign:'middle'},icon:{margin:6}}};var SlideshowModule=function(_PageModule){_inherits(SlideshowModule,_PageModule);function SlideshowModule(){_classCallCheck(this,SlideshowModule);var _this=_possibleConstructorReturn(this,(SlideshowModule.__proto__||Object.getPrototypeOf(SlideshowModule)).apply(this,arguments));var _this$props=_this.props,content=_this$props.content,params=_this$props.params;var caption=params.caption||[];var data=content||[];if(typeof caption==='string'){caption=[caption];}var images=data.map(function(file,index){return{url:file.url,id:params.file_id[index]};});_this.preloaded=[];_this.state={edit:{images:images,caption:caption},isFullscreen:false,showProgress:0,fileSelectorOpen:false};_this.preload(0);return _this;}_createClass(SlideshowModule,[{key:'attach',value:function attach(data){var showProgress=this.state.showProgress;var images=this.state.edit.images.slice();for(var i=0;i<data.length;i++){for(var k=0;k<images.length;k++){if(data[i].file.id===images[k].id){return;}}}var insertLocation=images.length>0&&showProgress<images.length?showProgress+1:0;data.forEach(function(obj){images.splice(insertLocation,0,obj.file);});var edit=Object.assign({},this.state.edit,{images:images});this.setState({edit:edit,showProgress:insertLocation});this.autoSave();}},{key:'progress',value:function progress(event){this.setState({progress:event.percent});}},{key:'preload',value:function preload(index){var edit=this.state.edit;var images=edit.images;if(!images||images.length===0){return;}var realIndex=(images.length+index)%images.length;if(this.preloaded[realIndex]){return;}if(images[index]){var image=new Image(1,1);image.src=images[index].url;this.preloaded[index]=image;}}},{key:'autoSave',value:function autoSave(){var _this2=this;if(this._timer){clearTimeout(this._timer);}this._timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_14_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('video.changesSaved'));_this2.save(false);_this2._timer=null;},1000);}},{key:'changeCaption',value:function changeCaption(e){var caption=this.state.edit.caption.slice();caption[this.state.showProgress]=e.target.value;var edit=Object.assign({},this.state.edit,{caption:caption});this.setState({edit:edit});}},{key:'saveOnBlur',value:function saveOnBlur(){__WEBPACK_IMPORTED_MODULE_14_services_Message__["a" /* default */].info(this.context.getIntlMessage('video.changesSaved'));this.save(false);}},{key:'fullScreen',value:function fullScreen(){var _this3=this;var fs=__WEBPACK_IMPORTED_MODULE_11_fullscreen___default()(__WEBPACK_IMPORTED_MODULE_16_react_dom___default.a.findDOMNode(this));fs.on('release',function(){_this3.setState({isFullscreen:false});});fs.on('attain',function(){_this3.setState({isFullscreen:true});});fs.request();}},{key:'previous',value:function previous(){if(this.state.showProgress>0){this.setProgress(this.state.showProgress-1);}this.props.gaTracking();}},{key:'next',value:function next(){if(this.state.showProgress<this.state.edit.images.length-1){this.setProgress(this.state.showProgress+1);}this.props.gaTracking();}},{key:'setProgress',value:function setProgress(index){this.setState({showProgress:index});}},{key:'getStyle',value:function getStyle(){var _state=this.state,mouseOver=_state.mouseOver,isFullscreen=_state.isFullscreen;var _props=this.props,style=_props.style,mode=_props.mode;return Object.assign({},// styles.root,
style,mode==='edit'?__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].edit:null,isFullscreen?styles.fullScreen:null,mouseOver?__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].hover:null);}},{key:'getModuleData',value:function getModuleData(){var edit=this.state.edit;var caption=edit.caption;var fileId=edit.images.map(function(image){return image.id;});return{fileId:fileId,caption:caption};}},{key:'onMediaLibrary',value:function onMediaLibrary(){this.setState({fileSelectorOpen:true});}},{key:'onMediaLibraryClose',value:function onMediaLibraryClose(){this.setState({fileSelectorOpen:false});}},{key:'openDownload',value:function openDownload(event){this.refs.dropZone.open();event.stopPropagation();event.preventDefault();}},{key:'selectMedia',value:function selectMedia(file){var showProgress=this.state.showProgress;var images=this.state.edit.images.slice();var insertLocation=images.length>0&&showProgress<images.length?showProgress+1:0;images.splice(insertLocation,0,file);var edit=Object.assign({},this.state.edit,{images:images});this.setState({edit:edit,fileSelectorOpen:false,showProgress:insertLocation});this.autoSave();}},{key:'import',value:function _import(){var _this4=this;__WEBPACK_IMPORTED_MODULE_8_services_SteelCompass__["a" /* default */].call('file','import',{url:this.refs.import.value,encode:false},function(response){if(!response.isError){var showProgress=_this4.state.showProgress;var images=_this4.state.edit.images.slice();var insertLocation=images.length>0&&showProgress<images.length?showProgress+1:0;images.splice(insertLocation,0,{url:response.data.file.url,id:response.data.file.id});var edit=Object.assign({},_this4.state.edit,{images:images});_this4.setState({edit:edit,showProgress:insertLocation});_this4.autoSave();__WEBPACK_IMPORTED_MODULE_14_services_Message__["a" /* default */].info(_this4.context.getIntlMessage('image.imported'));}else{__WEBPACK_IMPORTED_MODULE_14_services_Message__["a" /* default */].info(_this4.context.getIntlMessage('image.importFailed'));}});}},{key:'deleteImage',value:function deleteImage(){var showProgress=this.state.showProgress+0;var images=this.state.edit.images.slice();var caption=this.state.edit.caption.slice();images.splice(showProgress,1);caption.splice(showProgress,1);var edit=Object.assign({},this.state.edit,{images:images,caption:caption});if(showProgress>images.length-1&&showProgress>0){showProgress=showProgress-1;}this.setState({showProgress:showProgress,edit:edit});this.autoSave();}},{key:'renderEditMode',value:function renderEditMode(){var _this5=this;var _state2=this.state,fileSelectorOpen=_state2.fileSelectorOpen,edit=_state2.edit,showProgress=_state2.showProgress,isFullscreen=_state2.isFullscreen;var images=edit.images;var url=images[showProgress]&&images[showProgress].url;var progressDots=images.map(function(image,index){if(showProgress===index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ImageLens"],{color:__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material,style:styles.progressDot,key:index,onTouchTap:_this5.setProgress.bind(_this5,index)});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ImagePanoramaFishEye"],{color:__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material,hoverColor:hoverColor,style:styles.progressDot,key:index,onTouchTap:_this5.setProgress.bind(_this5,index)});});this.preload(showProgress+1);this.preload(showProgress-1);var progressIndicator=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.slideshowProgress},progressDots);var previous=void 0;var next=void 0;var fullscreenControl=void 0;if(images.length>0){if(showProgress<images.length-1){next=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.next.bind(this),style:Object.assign({},styles.prevNext,styles.next)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationChevronRight"],{color:iconColor,hoverColor:hoverColor,style:Object.assign(styles.icon,styles.big)}));}if(showProgress>0){previous=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.previous.bind(this),style:Object.assign({},styles.prevNext,styles.prev)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationChevronLeft"],{color:iconColor,hoverColor:hoverColor,style:Object.assign(styles.icon,styles.big)}));}}if(!isFullscreen){fullscreenControl=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Paper"],{style:styles.fullscreenControl,onTouchTap:this.fullScreen.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationFullscreen"],{color:activeColor,hoverColor:hoverColor}));}var slideshow=void 0;var uploadLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:this.openDownload.bind(this)},this.context.getIntlMessage('module.upload'));var libraryLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:this.onMediaLibrary.bind(this)},this.context.getIntlMessage('module.library'));if(this.state.progress>0&&this.state.progress<100){slideshow=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Material_CircularProgress__["a" /* default */],{progressColor:this.context.muiTheme.rawTheme.palette.primary1Color,progress:this.state.progress,size:2});}else if(url){var caption=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{ref:'caption',fullWidth:true,hintText:this.context.getIntlMessage('Caption'),value:edit.caption[showProgress],onChange:this.changeCaption.bind(this),onBlur:this.saveOnBlur.bind(this)});slideshow=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_MediaContainer__["a" /* default */],{mediaObject:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_ResponsiveImage__["a" /* default */],{style:{width:'100%',height:300},contain:true,size:1000,key:url,src:url}),controls:progressIndicator,caption:caption},previous,next,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["IconButton"],{tooltip:this.context.getIntlMessage('image.delete'),style:styles.deleteImageButton.button,onTouchTap:this.deleteImage.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ActionDelete"],{style:styles.deleteImageButton.icon,color:__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].red[200].material,hoverColor:hoverColor})));}else{slideshow=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ImageImage"],{style:__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].icon});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_DropZone__["a" /* default */],{accept:'image/jpeg,image/jpg,image/gif,image/png',ref:'dropZone',style:__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].dropZone,lineHeight:Spacing.desktopKeylineIncrement/2,onProgress:this.progress.bind(this),onSuccess:this.attach.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].moduleContainer},slideshow),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].header},this.context.getIntlMessage('module.dropImages')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].subHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('module.uploadOrBrowse'),upload:uploadLink,library:libraryLink})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].subHeader},this.context.getIntlMessage('module.youCanImport')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Paper"],{style:__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].import.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:'import',style:__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].import.input,type:'text',placeholder:this.context.getIntlMessage('importFromUrl')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["a" /* FlexBox */],{grow:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["FlatButton"],{secondary:true,label:this.context.getIntlMessage('Import'),onTouchTap:this.import.bind(this)}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Widgets_FileSelectorDialog__["a" /* default */],{type:'image',open:fileSelectorOpen,onSelect:this.selectMedia.bind(this),onClose:this.onMediaLibraryClose.bind(this)}));}},{key:'renderDetailMode',value:function renderDetailMode(){var _this6=this;var _state3=this.state,edit=_state3.edit,showProgress=_state3.showProgress,isFullscreen=_state3.isFullscreen;var images=edit.images;var caption=edit.caption;var url=images[showProgress]&&images[showProgress].url;var progressDots=images.map(function(image,index){if(showProgress===index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ImageLens"],{color:__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material,style:styles.progressDot,key:index,onTouchTap:_this6.setProgress.bind(_this6,index)});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ImagePanoramaFishEye"],{color:__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material,hoverColor:hoverColor,style:styles.progressDot,key:index,onTouchTap:_this6.setProgress.bind(_this6,index)});});this.preload(showProgress+1);this.preload(showProgress-1);var progressIndicator=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.slideshowProgress},progressDots);var previous=void 0;var next=void 0;var fullscreenControl=void 0;if(images.length>0){if(showProgress<images.length-1){next=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.next.bind(this),style:Object.assign({},styles.prevNext,styles.next)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationChevronRight"],{color:iconColor,hoverColor:hoverColor,style:Object.assign(styles.icon,styles.big)}));}if(showProgress>0){previous=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.previous.bind(this),style:Object.assign({},styles.prevNext,styles.prev)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationChevronLeft"],{color:iconColor,hoverColor:hoverColor,style:Object.assign(styles.icon,styles.big)}));}}if(canUseFullscreen&&!isFullscreen){fullscreenControl=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["Paper"],{style:styles.fullscreenControl,onTouchTap:this.fullScreen.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationFullscreen"],{color:activeColor,hoverColor:hoverColor}));}if(url){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_MediaContainer__["a" /* default */],{mediaObject:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_ResponsiveImage__["a" /* default */],{style:{width:'100%',height:300},contain:true,size:1000,key:url,src:url}),controls:progressIndicator,caption:caption[showProgress]},previous,next,fullscreenControl);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].dropZone,onTouchTap:this.changeToEditMode.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].moduleContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["ImageSlideshow"],{style:__WEBPACK_IMPORTED_MODULE_5_components_Page_Module_Styles__["a" /* default */].icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.context.getIntlMessage('module.uploadImage')));}}]);return SlideshowModule;}(__WEBPACK_IMPORTED_MODULE_10_components_PageModule__["a" /* default */]);SlideshowModule.readable='SlideshowModule';/* harmony default export */ __webpack_exports__["a"] = (SlideshowModule);

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = fullscreen
fullscreen.available = available
fullscreen.enabled = enabled

var EE = __webpack_require__(2355).EventEmitter
var ael = __webpack_require__(2356)
var rel = ael.removeEventListener

function available() {
  return !!shim(document.body)
}

function enabled() {
  return !!(document.fullscreenEnabled ||
    document.webkitFullscreenEnabled ||
    document.mozFullScreenEnabled ||
    document.msFullscreenEnabled);
}

function fullscreen(el) {
  var doc = el.ownerDocument
    , body = doc.body
    , rfs = shim(el)
    , ee = new EE

  var vendors = ['', 'webkit', 'moz']

  for(var i = 0, len = vendors.length; i < len; ++i) {
    ael(doc, vendors[i] + 'fullscreenchange', onfullscreenchange)
    ael(doc, vendors[i] + 'fullscreenerror', onfullscreenerror)
  }
  // MS uses different casing:
  ael(doc, 'MSFullscreenChange', onfullscreenchange)
  ael(doc, 'MSFullscreenError', onfullscreenerror)

  ee.release = release
  ee.request = request
  ee.dispose = dispose
  ee.target = fullscreenelement

  if(!shim) {
    setTimeout(function() {
      ee.emit('error', new Error('fullscreen is not supported'))
    }, 0)
  }
  return ee

  function onfullscreenchange() {
    if(!fullscreenelement()) {
      return ee.emit('release')
    }
    ee.emit('attain')
  }

  function onfullscreenerror() {
    ee.emit('error')
  }

  function request() {
    return rfs.apply(el, arguments)
  }

  function release() {

    var element_exit = (el.exitFullscreen ||
      el.webkitExitFullscreen ||
      el.mozCancelFullScreen ||
      el.mozExitFullScreen ||
      el.msExitFullscreen);

    if (element_exit) {
      element_exit.apply(el, arguments);
      return;
    }

    var document_exit = (doc.exitFullscreen ||
      doc.webkitExitFullscreen ||
      doc.mozCancelFullScreen ||
      doc.mozExitFullScreen ||
      doc.msExitFullscreen);

    document_exit.apply(doc, arguments);
  } 

  function fullscreenelement() {
    return (0 ||
      doc.fullscreenElement ||
      doc.webkitFullscreenElement ||
      doc.mozFullScreenElement ||
      doc.msFullscreenElement ||
      null);
  }

  function dispose() {
    for(var i = 0, len = vendors.length; i < len; ++i) {
      rel(doc, vendors[i] + 'fullscreenchange', onfullscreenchange)
      rel(doc, vendors[i] + 'fullscreenerror', onfullscreenerror)
    }
    // MS uses different casing:
    rel(doc, 'MSFullscreenChange', onfullscreenchange)
    rel(doc, 'MSFullscreenError', onfullscreenerror)
  }
}

function shim(el) {
  return (el.requestFullscreen ||
    el.webkitRequestFullscreen ||
    el.mozRequestFullScreen ||
    el.msRequestFullscreen);
}


/***/ }),
/* 2355 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 2356 */
/***/ (function(module, exports) {

addEventListener.removeEventListener = removeEventListener
addEventListener.addEventListener = addEventListener

module.exports = addEventListener

var Events = null

function addEventListener(el, eventName, listener, useCapture) {
  Events = Events || (
    document.addEventListener ?
    {add: stdAttach, rm: stdDetach} :
    {add: oldIEAttach, rm: oldIEDetach}
  )
  
  return Events.add(el, eventName, listener, useCapture)
}

function removeEventListener(el, eventName, listener, useCapture) {
  Events = Events || (
    document.addEventListener ?
    {add: stdAttach, rm: stdDetach} :
    {add: oldIEAttach, rm: oldIEDetach}
  )
  
  return Events.rm(el, eventName, listener, useCapture)
}

function stdAttach(el, eventName, listener, useCapture) {
  el.addEventListener(eventName, listener, useCapture)
}

function stdDetach(el, eventName, listener, useCapture) {
  el.removeEventListener(eventName, listener, useCapture)
}

function oldIEAttach(el, eventName, listener, useCapture) {
  if(useCapture) {
    throw new Error('cannot useCapture in oldIE')
  }

  el.attachEvent('on' + eventName, listener)
}

function oldIEDetach(el, eventName, listener, useCapture) {
  el.detachEvent('on' + eventName, listener)
}


/***/ }),
/* 2357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var boxSizing='border-box';var WebkitBoxSizing='border-box';var MozBoxSizing='border-box';var styles={container:{boxSizing:boxSizing,WebkitBoxSizing:WebkitBoxSizing,MozBoxSizing:MozBoxSizing},media:{display:'flex',flexDirection:'column',width:'100%',boxSizing:boxSizing,WebkitBoxSizing:WebkitBoxSizing,MozBoxSizing:MozBoxSizing},body:{boxSizing:boxSizing,WebkitBoxSizing:WebkitBoxSizing,MozBoxSizing:MozBoxSizing},mediaObjectContainer:{height:0,paddingBottom:Math.floor(9*100000/16)/1000+'%',textAlign:'center',boxSizing:boxSizing,WebkitBoxSizing:WebkitBoxSizing,MozBoxSizing:MozBoxSizing,position:'relative'},mediaObject:{height:350,width:'100%',// maxHheight: '100%',
// maxWidth: '100%',
// height: 'auto',
verticalAlign:'middle'},mediaObjectPhone:{maxHeight:'100%'},objectWrapper:{// alignItems: 'center',
// justifyContent: 'center',
position:'absolute',overflow:'hidden',left:0,right:0,bottom:0,top:0},caption:{minHeight:Spacing.desktopGutterMore}};var css={root:'_gT'};var MediaContainer=function(_Component){_inherits(MediaContainer,_Component);function MediaContainer(){_classCallCheck(this,MediaContainer);return _possibleConstructorReturn(this,(MediaContainer.__proto__||Object.getPrototypeOf(MediaContainer)).apply(this,arguments));}_createClass(MediaContainer,[{key:'render',value:function render(){var _props=this.props,children=_props.children,controls=_props.controls,caption=_props.caption;var mediaObject=__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.mediaObject,{style:styles.mediaObject});var zoom=children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.media},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.mediaObjectContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root,style:styles.objectWrapper},mediaObject,zoom))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.body},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{style:styles.caption},caption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,controls))));}}]);return MediaContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MediaContainer.displayName='MediaContainer';MediaContainer.propTypes={controls:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,mediaObject:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,caption:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (MediaContainer);

/***/ }),
/* 2358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Route_Task__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_oxygen_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_PageModule__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TaskModule=function(_PageModule){_inherits(TaskModule,_PageModule);function TaskModule(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TaskModule);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TaskModule.__proto__||Object.getPrototypeOf(TaskModule)).call.apply(_ref,[this].concat(args))),_this),_initialiseProps.call(_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TaskModule,[{key:'save',value:function save(task){if(!task){this.changeToDetailMode();return;}var type=task.type,values=task.values,description=task.description;var data=this.props.params;var items=[];var correctResponse={value:[]};values.forEach(function(value,index){if(value.correct){correctResponse.value.push(index);}items.push(value.text);});__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].updateTask(this.props.moduleId,{id:data.taskId||data.task.taskId,caption:{main:description,items:items},correctResponse:correctResponse,type:type});return true;}},{key:'autoSave',value:function autoSave(task){var _this2=this;__WEBPACK_IMPORTED_MODULE_2_actions__["u" /* PageModuleActions */].markModuleSaving(this.props.moduleId);if(this._saveTimer){clearTimeout(this._saveTimer);}this._saveTimer=setTimeout(function(){_this2.save(task);},1000);}},{key:'componentWillUnmount',value:function componentWillUnmount(){// this.handleChange.clear();
}},{key:'renderEditMode',value:function renderEditMode(content,data){var _props=this.props,moduleId=_props.moduleId,themeColor=_props.themeColor,isQuiz=_props.isQuiz,pageRowId=_props.pageRowId,userdata=_props.data.userdata,other=_objectWithoutProperties(_props,['moduleId','themeColor','isQuiz','pageRowId','data']);data.task=data.task||{};data.task.caption=data.task.caption||{main:[this.context.getIntlMessage('tasks.description')]};data.task.caption.items=data.task.caption.items||[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',other,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Route_Task__["c" /* TaskCreator */],Object.assign({themeColor:themeColor,onChange:this.handleChange,setFile:this.setFile,file:this.state.file,ref:'creator',content:content,userdata:userdata,moduleId:moduleId,pageRowId:pageRowId,isQuiz:isQuiz},data.task)));}},{key:'renderDetailMode',value:function renderDetailMode(content,data){var _props2=this.props,moduleId=_props2.moduleId,themeColor=_props2.themeColor,reader=_props2.reader,isQuiz=_props2.isQuiz,userdata=_props2.data.userdata,other=_objectWithoutProperties(_props2,['moduleId','themeColor','reader','isQuiz','data']);var canAnswer=!this.props.editor&&data.task&&data.task.caption&&data.task.caption.main||this.props.reader;data.task=data.task||{};data.task.caption=data.task.caption||{main:[this.context.getIntlMessage('tasks.description')]};data.task.caption.items=data.task.caption.items||[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',other,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,content,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Route_Task__["b" /* Task */],Object.assign({isQuiz:isQuiz,reader:reader,file:this.state.file,themeColor:themeColor,canGrade:!this.props.reader,pageModuleId:moduleId,userdata:userdata},data.task,{taskResults:data.taskResults,canAnswer:canAnswer,name:this.props.name,pageId:this.props.pageId,courseId:this.props.courseId,gaTracking:this.props.gaTracking}))));}}]);return TaskModule;}(__WEBPACK_IMPORTED_MODULE_4_components_PageModule__["a" /* default */]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.state={file:null};this.setFile=function(file){_this3.setState({file:file});};this.saveCaption=function(task,desc){var type=task.type,values=task.values,description=task.description,comment=task.comment;var data=_this3.props.params;var items=[];var correctResponse={value:[]};values.forEach(function(value,index){if(value.correct){correctResponse.value.push(index);}items.push(value.text);});__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].updateTaskComplete(_this3.props.moduleId,{id:data.taskId||data.task.taskId,caption:{main:desc||description,items:items,comment:comment},correctResponse:correctResponse,type:type});__WEBPACK_IMPORTED_MODULE_2_actions__["f" /* CourseActions */].updateTaskCaption({id:data.taskId||data.task.taskId,caption:{main:description,items:items,comment:comment},correctResponse:correctResponse,type:type});};this.handleChange=__WEBPACK_IMPORTED_MODULE_3_oxygen_debounce___default()(function(){_this3.saveCaption.apply(_this3,arguments);},1000);};/* harmony default export */ __webpack_exports__["a"] = (TaskModule);

/***/ }),
/* 2359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Grid_Grid__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Widgets_ProfileImage__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Post__ = __webpack_require__(2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Widgets_VideoPreview__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lib_update__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lib_update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_lib_update__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_linkify__ = __webpack_require__(2361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_linkify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_linkify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_PageModule__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_DialogPortal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_services_SteelCompass__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var hoverColor=__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material;var Component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component,PropTypes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes;var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var styles={message:{adminButton:{margin:Spacing.desktopGutterMini/4,padding:Spacing.desktopGutterMini/4,minWidth:24,border:Spacing.desktopGutterMini/4,lineHeight:'24px'}},deleteButton:{button:{lineHeight:36+'px',width:36,height:36,minWidth:36},icon:{margin:6}},editBox:{borderRadius:2,border:'solid 1px '+__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].grey[300].material,backgroundColor:__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].grey[100].material,padding:Spacing.desktopGutterMini/2},ago:{color:'rgba(0, 0, 0, 0.4)',marginLeft:'4px'},toolbarGroup:{margin:2,borderRadius:2,borderStyle:'solid',borderWidth:'1px',borderColor:__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].grey[300].material},iconButton:{lineHeight:36+'px',backgroundColor:__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].fullWhite,margin:0,padding:6,borderRadius:2,width:36,height:36,verticalAlign:'middle'},icon:{margin:6}};var MessageControls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({displayName:'MessageControls',mixins:[__WEBPACK_IMPORTED_MODULE_5_react_intl__["IntlMixin"]],propTypes:{reply:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool,follow:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool,created:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,onReply:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func.isRequired},getDefaultProps:function getDefaultProps(){return{reply:true,follow:true};},_onTouchTap:function _onTouchTap(){this.props.onReply();},follow:function follow(){this.props.onFollow();},unfollow:function unfollow(){this.props.onUnFollow();},edit:function edit(){this.props.onEdit();},delete:function _delete(){this.props.onDelete();},render:function render(){var replyButton=void 0,followButton=void 0,editButton=void 0,deleteButton=void 0,created=void 0;created=new Date(this.props.created.split(' ').join('T')+'Z');if(this.props.reply){replyButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{tooltip:this.getIntlMessage('Reply'),tooltipPosition:this.props.editor?'top-center':'bottom-center',style:styles.iconButton,onTouchTap:this._onTouchTap},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_SvgIcons__["ContentReply"],{style:styles.icon}));//<FlatButton style={styles.message.adminButton} label={this.getIntlMessage('Reply')} onTouchTap={this._onTouchTap}/>;
}if(this.props.follow){if(this.props.isFollowing){followButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{tooltip:this.getIntlMessage('Unfollow'),style:styles.iconButton,onTouchTap:this.unfollow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_SvgIcons__["ActionFavoriteBorder"],{style:styles.icon}));}else{followButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{tooltip:this.getIntlMessage('Follow'),style:styles.iconButton,onTouchTap:this.follow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_SvgIcons__["ActionFavorite"],{style:styles.icon}));// <FlatButton onTouchTap={this.follow} style={styles.message.adminButton} label={this.getIntlMessage('Follow')}/>;
}}if(this.props.edit||this.props.editor){editButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{tooltip:this.getIntlMessage('Edit'),tooltipPosition:'top-center',style:styles.iconButton,onTouchTap:this.edit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_SvgIcons__["EditorModeEdit"],{style:styles.icon}));//<FlatButton onTouchTap={this.edit} style={styles.message.adminButton} label={this.getIntlMessage('Edit')}/>;
}if(this.props.delete||this.props.editor){deleteButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["IconButton"],{tooltip:this.getIntlMessage('Delete'),tooltipPosition:'top-center',style:styles.iconButton,onTouchTap:this.delete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_SvgIcons__["ActionDelete"],{style:styles.icon}));//<FlatButton onTouchTap={this.delete} style={styles.message.adminButton} label={this.getIntlMessage('Delete')}/>;
}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_Grid__["c" /* GridRow */],{fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_Grid__["a" /* GridCell */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'author'},this.props.author),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:styles.ago},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedRelative"],{value:created}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_Grid__["a" /* GridCell */],{size:6,className:'actions',style:styles.toolbarGroup},editButton,deleteButton,replyButton,followButton));}});var MessageComposer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({displayName:'MessageComposer',mixins:[__WEBPACK_IMPORTED_MODULE_5_react_intl__["IntlMixin"]],getInitialState:function getInitialState(){return{message:this.props.message||'',uploads:this.props.files||[]};},propTypes:{sendButton:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool,onChange:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func,onSend:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func,onAttach:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func,saveOnBlur:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func},getDefaultProps:function getDefaultProps(){return{sendButton:true};},_onSend:function _onSend(){if(this.props.onSend){this.props.onSend(this.state.message,this.state.uploads);}else{__WEBPACK_IMPORTED_MODULE_7_services_Post__["a" /* default */].create(this.props.id,this.state.message,this.state.uploads,function(response){});this.clear();}},_onChangeMessage:function _onChangeMessage(event){this.setState({message:event.target.value});if(this.props.onChange){this.props.onChange(event.target.value,this.state.uploads);}},getMessage:function getMessage(){return this.state.messsage;},getUploads:function getUploads(){return this.state.uploads;},clear:function clear(){this.setState({message:'',uploads:[]});},_onAttach:function _onAttach(e){var _this=this;if(this.props.onAttach){__WEBPACK_IMPORTED_MODULE_16_services_SteelCompass__["a" /* default */].upload(e.target.files,{encoded:this.props.encoded,progress:function progress(event){},success:function success(response){var uploads=[];response.data.forEach(function(data){data.file.title=data.file.name;uploads.push(data.file);});uploads=_this.state.uploads.concat(uploads);_this.props.onAttach(uploads);_this.setState({uploads:uploads});if(_this.props.onChange){_this.props.onChange(_this.state.message,uploads);}//data.
}});}else{var i=0;this.setState({progress:0,progressing:true});__WEBPACK_IMPORTED_MODULE_16_services_SteelCompass__["a" /* default */].upload(e.target.files,{encoded:this.props.encoded,progress:function progress(event){},success:function success(response){i++;if(i>1){return;}_this.setState({progressing:false,amount:0});if(response.data){var uploads=[];response.data.forEach(function(data){data.file.title=data.file.name;uploads.push(data.file);});uploads=_this.state.uploads.concat(uploads);_this.setState({uploads:uploads});if(_this.props.onChange){_this.props.onChange(_this.state.message,uploads);}}}});}},_removeUpload:function _removeUpload(uploadId){var foundIndex=null;this.state.uploads.forEach(function(upload,index){if(upload.id===uploadId){foundIndex=index;}});if(foundIndex!==null){this.state.uploads.splice(foundIndex,1);this.setState({uploads:this.state.uploads});if(this.props.onChange){this.props.onChange(this.state.message,this.state.uploads);}}},render:function render(){var _this2=this;var uploads,sendButton;if(this.state.uploads.length>0){uploads=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'uploads'},this.state.uploads.map(function(upload){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:upload.id,className:'upload-file'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{href:upload.url,linkButton:true,label:upload.title,target:'_blank'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{tooltip:_this2.getIntlMessage('Delete'),style:styles.deleteButton.button,onTouchTap:_this2._removeUpload.bind(_this2,upload.id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_SvgIcons__["ActionDelete"],{style:styles.deleteButton.icon,color:__WEBPACK_IMPORTED_MODULE_15_components_Material_Styles_Colors__["a" /* Colors */].red[200].material,hoverColor:hoverColor})));}));}var padding=Spacing.desktopGutterMini/2;if(this.props.sendButton){sendButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_Grid__["a" /* GridCell */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:padding+'px '+padding+'px '+padding+'px 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{fullWidth:true,label:this.getIntlMessage('Send'),onTouchTap:this._onSend})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'post-wrapper post-reply'},!this.props.noUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Widgets_ProfileImage__["a" /* default */],{author:this.props.author})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()({'arrow-box':!this.props.noUser,'message-box':this.props.noUser})},this.props.author&&this.props.author.displayName,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["TextField"],{fullWidth:true,value:this.state.message,multiLine:true,floatingLabelText:this.getIntlMessage(this.props.noUser?'post.describeDiscussion':'post.writeAComment'),onChange:this._onChangeMessage,onBlur:this.props.saveOnBlur})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_Grid__["c" /* GridRow */],null,sendButton,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Grid_Grid__["a" /* GridCell */],{size:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:padding+'px 0 '+padding+'px '+padding+'px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{fullWidth:true,className:'file-upload',label:this.getIntlMessage('attachFile')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onChange:this._onAttach,type:'file',accept:'*/*',multiple:true}))))),uploads));}});var Message=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createClass({displayName:'Message',getInitialState:function getInitialState(){return{reply:this.props.replyEnabled,messages:this.props.messages.reverse(),files:this.props.files,mode:'detail',body:this.props.body,confirmDialog:false};},contextTypes:{getIntlMessage:PropTypes.func},propTypes:{author:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object,created:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,depth:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.number,messages:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.array,files:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.array,objects:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object,body:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,id:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.number,isFollowing:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool,replyEnabled:__WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool},getDefaultProps:function getDefaultProps(){return{depth:0,isFollowing:false,body:'',messages:[],user:{},author:{},files:[],replyEnabled:false};},_onReply:function _onReply(){this.setState({reply:!this.state.reply});},_onSend:function _onSend(message,uploads){var _this3=this;this.props.gaTracking();var i=0;__WEBPACK_IMPORTED_MODULE_7_services_Post__["a" /* default */].create(this.props.id,message,uploads,function(response){if(response.data){if(i>0){return;}i++;_this3.setState(__WEBPACK_IMPORTED_MODULE_9_react_lib_update___default()(_this3.state,{messages:{$push:[response.data]}}));_this3.refs.composer.clear();}else if(response.isError&&response.errMsg){__WEBPACK_IMPORTED_MODULE_10_services_Message__["a" /* default */].info(response.errMsg);}});},_onAttach:function _onAttach(files){},isImage:function isImage(url){url=url||'';return url.match(/\.(jpeg|jpg|gif|png)$/)!==null;},isVideo:function isVideo(url){url=url||'';return url.match(/\.(mp4|ogv|ogg)$/)!==null;},onFollow:function onFollow(){if(this.props.onFollowChild){this.props.onFollowChild(this.props.id);}},onSortMessage:function onSortMessage(){var messages=this.state.messages.reverse();this.setState({messages:messages});},onUnFollow:function onUnFollow(){if(this.props.onUnfollowChild){this.props.onUnfollowChild(this.props.id);}},onEdit:function onEdit(){this.setState({mode:'edit'});},onDelete:function onDelete(){this.setState({confirmDialog:true});},cancelDelete:function cancelDelete(){this.setState({confirmDialog:false});},deleteConfirm:function deleteConfirm(){if(this.props.onDeleteChild){this.props.onDeleteChild(this.props.id);}},followChild:function followChild(id){var messages=this.state.messages.slice().map(function(message){if(message.id===id){return Object.assign({},message,{isFollowing:true});}return message;});__WEBPACK_IMPORTED_MODULE_7_services_Post__["a" /* default */].follow(id);this.setState({messages:messages});},unfollowChild:function unfollowChild(id){var messages=this.state.messages.slice().map(function(message){if(message.id===id){return Object.assign({},message,{isFollowing:false});}return message;});__WEBPACK_IMPORTED_MODULE_7_services_Post__["a" /* default */].unfollow(id);this.setState({messages:messages});},deleteChild:function deleteChild(id){var messages=this.state.messages.slice().filter(function(message){return message.id!==id;});__WEBPACK_IMPORTED_MODULE_7_services_Post__["a" /* default */].delete(id);this.setState({messages:messages});},onSave:function onSave(body){__WEBPACK_IMPORTED_MODULE_7_services_Post__["a" /* default */].update(this.props.id,body,this.state.files);this.setState({mode:'detail',body:body});},onRemove:function onRemove(id){var processChildren=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;__WEBPACK_IMPORTED_MODULE_16_services_SteelCompass__["a" /* default */].request('post','removeUploaded',{id:id,processChildren:processChildren}).then(function(res){if(res){__WEBPACK_IMPORTED_MODULE_3_actions__["a" /* AppActions */].translatableMessage('tasks.fileRemoved');}else{__WEBPACK_IMPORTED_MODULE_3_actions__["a" /* AppActions */].translatableMessage('tasks.fileNotRemoved');}},function(error){__WEBPACK_IMPORTED_MODULE_3_actions__["a" /* AppActions */].genericError(error);});},render:function render(){var _this4=this;var messages,composer,controls,downloads,depth=this.props.depth+1;if(this.state.messages.length>0){messages=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()({'deep-responses':depth>1})},this.state.messages.map(function(message){var files=[],fileObjects,fileIds;if(message.objects){fileObjects=message.objects.files||[],fileIds=message.objects.file||[];for(var i=0;i<fileObjects.length;i++){files.push({id:fileObjects.id||fileIds[i],title:fileObjects[i].title,url:fileObjects[i].url});}}else{files=message.files;}message.author=message.author||{avatar:'',id:0,name:''};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Message,{onFollowChild:_this4.followChild,onUnfollowChild:_this4.unfollowChild,onDeleteChild:_this4.deleteChild,editor:_this4.props.editor,user:_this4.props.user,depth:depth,key:message.id,messages:message.children,body:message.body,id:message.id,isFollowing:message.isFollowing,gaTracking:_this4.props.gaTracking,created:message.created,author:message.author,files:files}),!!_this4.props.author&&_this4.props.author.id===_this4.props.user.id&&!!files.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{style:{marginLeft:70,width:'calc(100% - 70px)',marginBottom:16,minWidth:'auto'},onClick:function onClick(){return _this4.onRemove(message.id);},fullWidth:true,label:'Remove attached files'}));}));}if(this.state.reply){composer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MessageComposer,{ref:'composer',editor:this.props.editor,author:this.props.user,onSend:this._onSend});}if(depth>1&&this.state.mode!=='edit'){controls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MessageControls,{mode:this.state.mode,onSave:this.onSave,onDelete:this.onDelete,onFollow:this.onFollow,onUnFollow:this.onUnFollow,onEdit:this.onEdit,onReply:this._onReply,editor:this.props.editor,author:this.props.author&&this.props.author.name,created:this.props.created,reply:depth<=2&&this.props.author&&this.props.author.id!==this.props.user.id,follow:this.props.author&&this.props.author.id!==this.props.user.id,edit:this.props.author&&this.props.author.id===this.props.user.id,'delete':this.props.author&&this.props.author.id===this.props.user.id,isFollowing:this.props.isFollowing});}if(this.props.files&&this.props.files.length>0){var index=0;downloads=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'download-files'},this.props.files.map(function(download){index++;if(_this4.isImage(download.url)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Paper"],{className:'image-thumb',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:download.url,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:download.url}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',null,download.title)));}else if(_this4.isVideo(download.url)){var extension=download.url.split('.').pop();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Paper"],{className:'image-thumb',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:download.url,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Widgets_VideoPreview__["a" /* default */],{sources:[{url:download.url,type:extension}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',null,download.title)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'download-file'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:download.url,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'md md-cloud'}),download.title));}}));}var body=void 0,confirmDialog=void 0;if(this.state.confirmDialog){var standardActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["FlatButton"],{key:'cancel',label:this.context.getIntlMessage('No'),primary:true,onTouchTap:this.cancelDelete}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('Yes'),secondary:true,onTouchTap:this.deleteConfirm})];confirmDialog=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Dialog"],{ref:'confirmDialog',openImmediately:true,title:this.context.getIntlMessage('Remove'),actions:standardActions,dismissOnClickAway:true},this.context.getIntlMessage('post.confirmDelete')));}if(this.state.mode==='edit'){body=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EditBox,{value:this.state.body,onSave:this.onSave});}else{body=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_linkify___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{whiteSpace:'pre-wrap'}},this.state.body.replace('\r','<br />')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'post-'+this.props.id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('post-wrapper',{'discussion-header':depth===1})},!this.props.noUser&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Widgets_ProfileImage__["a" /* default */],{author:this.props.author})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()({'arrow-box':!this.props.noUser,'message-box':this.props.noUser,light:this.props.author&&depth>1&&this.props.user.id!==this.props.author.id,dark:this.props.author&&this.props.user.id===this.props.author.id&&depth>1})},controls,body,downloads))),this.props.author&&this.props.author.id===this.props.user.id&&this.state.messages.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{style:{marginLeft:70,width:'calc(100% - 70px)',marginBottom:16,minWidth:'auto'},onClick:this.onSortMessage,fullWidth:true,backgroundColor:'rgb(255, 255, 255)',labelColor:'#000',label:this.context.getIntlMessage('SortMessages')}),messages,composer,this.props.author&&this.props.author.id===this.props.user.id&&this.state.messages.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{style:{marginLeft:70,width:'calc(100% - 70px)',marginBottom:16,minWidth:'auto'},onClick:function onClick(){return _this4.onRemove(_this4.props.id,true);},fullWidth:true,label:'Remove all attached files'}),confirmDialog);}});var EditBox=function(_Component){_inherits(EditBox,_Component);function EditBox(){_classCallCheck(this,EditBox);return _possibleConstructorReturn(this,(EditBox.__proto__||Object.getPrototypeOf(EditBox)).apply(this,arguments));}_createClass(EditBox,[{key:'componentDidMount',value:function componentDidMount(){var textField=this.refs.textField;var inputField=textField._getInputNode();var value=textField.getValue();textField.focus();textField.setValue(value);inputField.select();}},{key:'save',value:function save(){if(this.props.onSave){var value=this.refs.textField.getValue();this.props.onSave(value);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.editBox},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["TextField"],{ref:'textField',fullWidth:true,defaultValue:this.props.value,multiLine:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{secondary:true,fullWidth:true,label:'Save',onTouchTap:this.save.bind(this)}));}}]);return EditBox;}(Component);EditBox.propTypes={value:PropTypes.string,onSave:PropTypes.func};var DiscussionModule=function(_PageModule){_inherits(DiscussionModule,_PageModule);function DiscussionModule(){_classCallCheck(this,DiscussionModule);var _this6=_possibleConstructorReturn(this,(DiscussionModule.__proto__||Object.getPrototypeOf(DiscussionModule)).apply(this,arguments));var _this6$props=_this6.props,content=_this6$props.content,params=_this6$props.params;var fileObjects=content.objects&&content.objects.files||[];var fileIds=content.objects&&content.objects.file||[];var files=fileObjects.map(function(file,index){return{id:fileIds[index],title:file.title,url:file.url};});_this6.state={body:content.body,files:files};return _this6;}_createClass(DiscussionModule,[{key:'onChange',value:function onChange(message,uploads){this.setState({body:message,files:uploads});}},{key:'saveOnBlur',value:function saveOnBlur(){__WEBPACK_IMPORTED_MODULE_10_services_Message__["a" /* default */].info(this.context.getIntlMessage('video.changesSaved'));this.save(false);}},{key:'save',value:function save(){var _this7=this;var switchBack=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var message=this.state.body;var files=this.state.files;var originalMessage=this.props.content;var params=this.props.params;var originalMessageId=originalMessage.id||params.post_id;__WEBPACK_IMPORTED_MODULE_7_services_Post__["a" /* default */].update(originalMessageId,message,files,function(response){_this7.setState({body:response.data.body,files:response.data.files});});if(switchBack){this.changeToDetailMode();}}},{key:'renderDetailMode',value:function renderDetailMode(content,data){var _props=this.props,user=_props.user,editor=_props.editor,themeColor=_props.themeColor,gaTracking=_props.gaTracking;var mainAuthor=content.author;var messageId=content.id||data.post_id;var _state=this.state,files=_state.files,body=_state.body;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini},className:'discussion-module'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Message,{themeColor:themeColor,noUser:true,editor:editor,replyEnabled:true,user:user,depth:0,messages:content.children,body:body,id:messageId,isFollowing:content.isFollowing,created:content.created,author:mainAuthor,files:files,gaTracking:gaTracking}));}},{key:'renderEditMode',value:function renderEditMode(){var _props2=this.props,user=_props2.user,themeColor=_props2.themeColor;var _state2=this.state,files=_state2.files,body=_state2.body;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini},className:'discussion-module'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MessageComposer,{themeColor:themeColor,noUser:true,ref:'composer',onChange:this.onChange.bind(this),saveOnBlur:this.saveOnBlur.bind(this),sendButton:false,message:body,files:files,author:user}));}}]);return DiscussionModule;}(__WEBPACK_IMPORTED_MODULE_12_components_PageModule__["a" /* default */]);DiscussionModule.displayName='DiscussionModule';/* harmony default export */ __webpack_exports__["a"] = (DiscussionModule);// var Discussion = React.createClass({
//   mixins: [IntlMixin],
//   getDefaultProps() {
//     return {
//       content : {
//         objects : {
//           files: []
//         }
//       }
//     };
//   },
//   getInitialState() {
//     var files = [],
//         fileObjects = this.props.content && this.props.content.objects && this.props.content.objects.files || [],
//         fileIds = this.props.content && this.props.content.objects && this.props.content.objects.file || [];
//     for (var i = 0; i < fileObjects.length; i++) {
//       files.push({id: fileIds[i], title: fileObjects[i].title, url: fileObjects[i].url});
//     }
//     return {
//       body: this.props.content.body || '',
//       files: files,
//     };
//   },
//   _onChange(message, uploads) {
//     this.setState({body: message, files:uploads});
//   },
//   save() {
//     var message = this.state.body,
//         uploads = this.state.files,
//         originalMessage = this.props.content,
//         params = this.props.params,
//         originalMessageId = originalMessage.id || params.post_id;
//     Post.update(originalMessageId, message, uploads, response => {
//       var fileIds = response.data.files.map(file => {
//         return file.id;
//       });
//       this.setState({body: response.data.body, files: response.data.files})
//     });
//   },
//   delete() {
//     this.refs.confirmDialog.show();
//   },
//   confirmDelete() {
//     Page.deletePageModule(this.props.moduleId, response => {
//       CourseActions.getPageById(this.props.pageId);
//     });
//   },
//   render() {
//     var {content, ...other} = this.props, classes, standardActions;
//     classes = ClassNames(this.props.className, this.props.mode + '-mode');
//     standardActions = [
//       <FlatButton key='ok' label={this.getIntlMessage('OK')} secondary={true} className='full' onTouchTap={this.confirmDelete} />
//     ];
//     if (this.props.mode == 'edit') {
//       content = this.renderEditMode();
//     } else {
//       content = this.renderDetailMode();
//     }
//     return (
//       <div {...other} className={classes}>
//         {content}
//         {this.props.children}
//         <Dialog
//           ref="confirmDialog"
//           title={this.getIntlMessage('Remove')}
//           actions={standardActions}
//           dismissOnClickAway={true}>
//           {this.getIntlMessage('discussion.confirmDelete')}
//         </Dialog>
//       </div>
//     );
//   }
// });
// module.exports = Discussion;

/***/ }),
/* 2360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Post=function(){function Post(){_classCallCheck(this,Post);}_createClass(Post,[{key:'create',value:function create(parentId,body,files,callback){files=files.map(function(file){return'[file:'+file.id+']';});body=body+files.join('');__WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].call('post','create',{parentId:parentId,body:body},function(response){if(callback){callback(response);}});}},{key:'delete',value:function _delete(id,callback){__WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].call('post','delete',{id:id},function(response){if(callback){callback(response);}});}},{key:'follow',value:function follow(postId,callback){__WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].call('post','follow',{postId:postId},function(response){if(callback){callback(response);}});}},{key:'unfollow',value:function unfollow(postId,callback){__WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].call('post','unfollow',{postId:postId},function(response){if(callback){callback(response);}});}},{key:'update',value:function update(parentId,body,files,callback){files=files.map(function(file){return'[file:'+file.id+']';});body=body+files.join('');__WEBPACK_IMPORTED_MODULE_0_services_SteelCompass__["a" /* default */].call('post','update',{id:parentId,body:body},function(response){if(callback){callback(response);}});}}]);return Post;}();/* harmony default export */ __webpack_exports__["a"] = (new Post());

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkify = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _linkifyIt = __webpack_require__(2362);

var _linkifyIt2 = _interopRequireDefault(_linkifyIt);

var _tlds = __webpack_require__(2368);

var _tlds2 = _interopRequireDefault(_tlds);

var _propTypes = __webpack_require__(38);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var linkify = exports.linkify = new _linkifyIt2.default();
linkify.tlds(_tlds2.default);

var Linkify = function (_React$Component) {
  _inherits(Linkify, _React$Component);

  function Linkify() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Linkify);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Linkify.__proto__ || Object.getPrototypeOf(Linkify)).call.apply(_ref, [this].concat(args))), _this), _this.parseCounter = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Linkify, [{
    key: 'getMatches',
    value: function getMatches(string) {
      return linkify.match(string);
    }
  }, {
    key: 'parseString',
    value: function parseString(string) {
      var _this2 = this;

      var elements = [];
      if (string === '') {
        return elements;
      }

      var matches = this.getMatches(string);
      if (!matches) {
        return string;
      }

      var lastIndex = 0;
      matches.forEach(function (match, idx) {
        // Push the preceding text if there is any
        if (match.index > lastIndex) {
          elements.push(string.substring(lastIndex, match.index));
        }
        // Shallow update values that specified the match
        var props = { href: match.url, key: 'parse' + _this2.parseCounter + 'match' + idx };
        for (var key in _this2.props.properties) {
          var val = _this2.props.properties[key];
          if (val === Linkify.MATCH) {
            val = match.url;
          }

          props[key] = val;
        }
        elements.push(_react2.default.createElement(_this2.props.component, props, match.text));
        lastIndex = match.lastIndex;
      });

      if (lastIndex < string.length) {
        elements.push(string.substring(lastIndex));
      }

      return elements.length === 1 ? elements[0] : elements;
    }
  }, {
    key: 'parse',
    value: function parse(children) {
      var _this3 = this;

      var parsed = children;

      if (typeof children === 'string') {
        parsed = this.parseString(children);
      } else if (_react2.default.isValidElement(children) && children.type !== 'a' && children.type !== 'button') {
        parsed = _react2.default.cloneElement(children, { key: 'parse' + ++this.parseCounter }, this.parse(children.props.children));
      } else if (children instanceof Array) {
        parsed = children.map(function (child) {
          return _this3.parse(child);
        });
      }

      return parsed;
    }
  }, {
    key: 'render',
    value: function render() {
      this.parseCounter = 0;
      var parsedChildren = this.parse(this.props.children);

      return _react2.default.createElement(
        'span',
        { className: this.props.className },
        parsedChildren
      );
    }
  }]);

  return Linkify;
}(_react2.default.Component);

Linkify.MATCH = 'LINKIFY_MATCH';
Linkify.propTypes = {
  className: _propTypes2.default.string,
  component: _propTypes2.default.any,
  properties: _propTypes2.default.object,
  urlRegex: _propTypes2.default.object,
  emailRegex: _propTypes2.default.object
};
Linkify.defaultProps = {
  className: 'Linkify',
  component: 'a',
  properties: {}
};
exports.default = Linkify;


/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



////////////////////////////////////////////////////////////////////////////////
// Helpers

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

function _class(obj) { return Object.prototype.toString.call(obj); }
function isString(obj) { return _class(obj) === '[object String]'; }
function isObject(obj) { return _class(obj) === '[object Object]'; }
function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
function isFunction(obj) { return _class(obj) === '[object Function]'; }


function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }

////////////////////////////////////////////////////////////////////////////////


var defaultOptions = {
  fuzzyLink: true,
  fuzzyEmail: true,
  fuzzyIP: false
};


function isOptionsObj(obj) {
  return Object.keys(obj || {}).reduce(function (acc, k) {
    return acc || defaultOptions.hasOwnProperty(k);
  }, false);
}


var defaultSchemas = {
  'http:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.http =  new RegExp(
          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
        );
      }
      if (self.re.http.test(tail)) {
        return tail.match(self.re.http)[0].length;
      }
      return 0;
    }
  },
  'https:':  'http:',
  'ftp:':    'http:',
  '//':      {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.no_http) {
      // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.no_http =  new RegExp(
          '^' +
          self.re.src_auth +
          // Don't allow single-level domains, because of false positives like '//test'
          // with code comments
          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
          self.re.src_port +
          self.re.src_host_terminator +
          self.re.src_path,

          'i'
        );
      }

      if (self.re.no_http.test(tail)) {
        // should not be `://` & `///`, that protects from errors in protocol name
        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
        return tail.match(self.re.no_http)[0].length;
      }
      return 0;
    }
  },
  'mailto:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.mailto) {
        self.re.mailto =  new RegExp(
          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
        );
      }
      if (self.re.mailto.test(tail)) {
        return tail.match(self.re.mailto)[0].length;
      }
      return 0;
    }
  }
};

/*eslint-disable max-len*/

// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';

// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');

/*eslint-enable max-len*/

////////////////////////////////////////////////////////////////////////////////

function resetScanCache(self) {
  self.__index__ = -1;
  self.__text_cache__   = '';
}

function createValidator(re) {
  return function (text, pos) {
    var tail = text.slice(pos);

    if (re.test(tail)) {
      return tail.match(re)[0].length;
    }
    return 0;
  };
}

function createNormalizer() {
  return function (match, self) {
    self.normalize(match);
  };
}

// Schemas compiler. Build regexps.
//
function compile(self) {

  // Load & clone RE patterns.
  var re = self.re = __webpack_require__(2363)(self.__opts__);

  // Define dynamic patterns
  var tlds = self.__tlds__.slice();

  self.onCompile();

  if (!self.__tlds_replaced__) {
    tlds.push(tlds_2ch_src_re);
  }
  tlds.push(re.src_xn);

  re.src_tlds = tlds.join('|');

  function untpl(tpl) { return tpl.replace('%TLDS%', re.src_tlds); }

  re.email_fuzzy      = RegExp(untpl(re.tpl_email_fuzzy), 'i');
  re.link_fuzzy       = RegExp(untpl(re.tpl_link_fuzzy), 'i');
  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
  re.host_fuzzy_test  = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');

  //
  // Compile each schema
  //

  var aliases = [];

  self.__compiled__ = {}; // Reset compiled data

  function schemaError(name, val) {
    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
  }

  Object.keys(self.__schemas__).forEach(function (name) {
    var val = self.__schemas__[name];

    // skip disabled methods
    if (val === null) { return; }

    var compiled = { validate: null, link: null };

    self.__compiled__[name] = compiled;

    if (isObject(val)) {
      if (isRegExp(val.validate)) {
        compiled.validate = createValidator(val.validate);
      } else if (isFunction(val.validate)) {
        compiled.validate = val.validate;
      } else {
        schemaError(name, val);
      }

      if (isFunction(val.normalize)) {
        compiled.normalize = val.normalize;
      } else if (!val.normalize) {
        compiled.normalize = createNormalizer();
      } else {
        schemaError(name, val);
      }

      return;
    }

    if (isString(val)) {
      aliases.push(name);
      return;
    }

    schemaError(name, val);
  });

  //
  // Compile postponed aliases
  //

  aliases.forEach(function (alias) {
    if (!self.__compiled__[self.__schemas__[alias]]) {
      // Silently fail on missed schemas to avoid errons on disable.
      // schemaError(alias, self.__schemas__[alias]);
      return;
    }

    self.__compiled__[alias].validate =
      self.__compiled__[self.__schemas__[alias]].validate;
    self.__compiled__[alias].normalize =
      self.__compiled__[self.__schemas__[alias]].normalize;
  });

  //
  // Fake record for guessed links
  //
  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };

  //
  // Build schema condition
  //
  var slist = Object.keys(self.__compiled__)
                      .filter(function (name) {
                        // Filter disabled & fake schemas
                        return name.length > 0 && self.__compiled__[name];
                      })
                      .map(escapeRE)
                      .join('|');
  // (?!_) cause 1.5x slowdown
  self.re.schema_test   = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
  self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');

  self.re.pretest       = RegExp(
                            '(' + self.re.schema_test.source + ')|' +
                            '(' + self.re.host_fuzzy_test.source + ')|' +
                            '@',
                            'i');

  //
  // Cleanup
  //

  resetScanCache(self);
}

/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/
function Match(self, shift) {
  var start = self.__index__,
      end   = self.__last_index__,
      text  = self.__text_cache__.slice(start, end);

  /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/
  this.schema    = self.__schema__.toLowerCase();
  /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/
  this.index     = start + shift;
  /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/
  this.lastIndex = end + shift;
  /**
   * Match#raw -> String
   *
   * Matched string.
   **/
  this.raw       = text;
  /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/
  this.text      = text;
  /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/
  this.url       = text;
}

function createMatch(self, shift) {
  var match = new Match(self, shift);

  self.__compiled__[match.schema].normalize(match, self);

  return match;
}


/**
 * class LinkifyIt
 **/

/**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/
function LinkifyIt(schemas, options) {
  if (!(this instanceof LinkifyIt)) {
    return new LinkifyIt(schemas, options);
  }

  if (!options) {
    if (isOptionsObj(schemas)) {
      options = schemas;
      schemas = {};
    }
  }

  this.__opts__           = assign({}, defaultOptions, options);

  // Cache last tested result. Used to skip repeating steps on next `match` call.
  this.__index__          = -1;
  this.__last_index__     = -1; // Next scan position
  this.__schema__         = '';
  this.__text_cache__     = '';

  this.__schemas__        = assign({}, defaultSchemas, schemas);
  this.__compiled__       = {};

  this.__tlds__           = tlds_default;
  this.__tlds_replaced__  = false;

  this.re = {};

  compile(this);
}


/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/
LinkifyIt.prototype.add = function add(schema, definition) {
  this.__schemas__[schema] = definition;
  compile(this);
  return this;
};


/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/
LinkifyIt.prototype.set = function set(options) {
  this.__opts__ = assign(this.__opts__, options);
  return this;
};


/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/
LinkifyIt.prototype.test = function test(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__      = -1;

  if (!text.length) { return false; }

  var m, ml, me, len, shift, next, re, tld_pos, at_pos;

  // try to scan for link with schema - that's the most simple rule
  if (this.re.schema_test.test(text)) {
    re = this.re.schema_search;
    re.lastIndex = 0;
    while ((m = re.exec(text)) !== null) {
      len = this.testSchemaAt(text, m[2], re.lastIndex);
      if (len) {
        this.__schema__     = m[2];
        this.__index__      = m.index + m[1].length;
        this.__last_index__ = m.index + m[0].length + len;
        break;
      }
    }
  }

  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
    // guess schemaless links
    tld_pos = text.search(this.re.host_fuzzy_test);
    if (tld_pos >= 0) {
      // if tld is located after found link - no need to check fuzzy pattern
      if (this.__index__ < 0 || tld_pos < this.__index__) {
        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {

          shift = ml.index + ml[1].length;

          if (this.__index__ < 0 || shift < this.__index__) {
            this.__schema__     = '';
            this.__index__      = shift;
            this.__last_index__ = ml.index + ml[0].length;
          }
        }
      }
    }
  }

  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
    // guess schemaless emails
    at_pos = text.indexOf('@');
    if (at_pos >= 0) {
      // We can't skip this check, because this cases are possible:
      // 192.168.1.1@gmail.com, my.in@example.com
      if ((me = text.match(this.re.email_fuzzy)) !== null) {

        shift = me.index + me[1].length;
        next  = me.index + me[0].length;

        if (this.__index__ < 0 || shift < this.__index__ ||
            (shift === this.__index__ && next > this.__last_index__)) {
          this.__schema__     = 'mailto:';
          this.__index__      = shift;
          this.__last_index__ = next;
        }
      }
    }
  }

  return this.__index__ >= 0;
};


/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/
LinkifyIt.prototype.pretest = function pretest(text) {
  return this.re.pretest.test(text);
};


/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/
LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
  // If not supported schema check requested - terminate
  if (!this.__compiled__[schema.toLowerCase()]) {
    return 0;
  }
  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};


/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/
LinkifyIt.prototype.match = function match(text) {
  var shift = 0, result = [];

  // Try to take previous element from cache, if .test() called before
  if (this.__index__ >= 0 && this.__text_cache__ === text) {
    result.push(createMatch(this, shift));
    shift = this.__last_index__;
  }

  // Cut head if cache was used
  var tail = shift ? text.slice(shift) : text;

  // Scan string until end reached
  while (this.test(tail)) {
    result.push(createMatch(this, shift));

    tail = tail.slice(this.__last_index__);
    shift += this.__last_index__;
  }

  if (result.length) {
    return result;
  }

  return null;
};


/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/
LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
  list = Array.isArray(list) ? list : [ list ];

  if (!keepOld) {
    this.__tlds__ = list.slice();
    this.__tlds_replaced__ = true;
    compile(this);
    return this;
  }

  this.__tlds__ = this.__tlds__.concat(list)
                                  .sort()
                                  .filter(function (el, idx, arr) {
                                    return el !== arr[idx - 1];
                                  })
                                  .reverse();

  compile(this);
  return this;
};

/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/
LinkifyIt.prototype.normalize = function normalize(match) {

  // Do minimal possible changes by default. Need to collect feedback prior
  // to move forward https://github.com/markdown-it/linkify-it/issues/1

  if (!match.schema) { match.url = 'http://' + match.url; }

  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
    match.url = 'mailto:' + match.url;
  }
};


/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/
LinkifyIt.prototype.onCompile = function onCompile() {
};


module.exports = LinkifyIt;


/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = function (opts) {
  var re = {};

  // Use direct extract instead of `regenerate` to reduse browserified size
  re.src_Any = __webpack_require__(2364).source;
  re.src_Cc  = __webpack_require__(2365).source;
  re.src_Z   = __webpack_require__(2366).source;
  re.src_P   = __webpack_require__(2367).source;

  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
  re.src_ZPCc = [ re.src_Z, re.src_P, re.src_Cc ].join('|');

  // \p{\Z\Cc} (white spaces + control)
  re.src_ZCc = [ re.src_Z, re.src_Cc ].join('|');

  // Experimental. List of chars, completely prohibited in links
  // because can separate it from other part of text
  var text_separators = '[><\uff5c]';

  // All possible word characters (everything without punctuation, spaces & controls)
  // Defined via punctuation & spaces to save space
  // Should be something like \p{\L\N\S\M} (\w but without `_`)
  re.src_pseudo_letter       = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
  // The same as abothe but without [0-9]
  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';

  ////////////////////////////////////////////////////////////////////////////////

  re.src_ip4 =

    '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

  // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
  re.src_auth    = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';

  re.src_port =

    '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';

  re.src_host_terminator =

    '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';

  re.src_path =

    '(?:' +
      '[/?#]' +
        '(?:' +
          '(?!' + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' +
          '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' +
          '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' +
          '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' +
          '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' +
          "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" +
          "\\'(?=" + re.src_pseudo_letter + '|[-]).|' +  // allow `I'm_king` if no pair found
          '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
                                     // - english
                                     // - percent-encoded
                                     // - parts of file path
                                     // until more examples found.
          '\\.(?!' + re.src_ZCc + '|[.]).|' +
          (opts && opts['---'] ?
            '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
          :
            '\\-+|'
          ) +
          '\\,(?!' + re.src_ZCc + ').|' +      // allow `,,,` in paths
          '\\!(?!' + re.src_ZCc + '|[!]).|' +
          '\\?(?!' + re.src_ZCc + '|[?]).' +
        ')+' +
      '|\\/' +
    ')?';

  re.src_email_name =

    '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';

  re.src_xn =

    'xn--[a-z0-9\\-]{1,59}';

  // More to read about domain names
  // http://serverfault.com/questions/638260/

  re.src_domain_root =

    // Allow letters & digits (http://test1)
    '(?:' +
      re.src_xn +
      '|' +
      re.src_pseudo_letter + '{1,63}' +
    ')';

  re.src_domain =

    '(?:' +
      re.src_xn +
      '|' +
      '(?:' + re.src_pseudo_letter + ')' +
      '|' +
      // don't allow `--` in domain names, because:
      // - that can conflict with markdown &mdash; / &ndash;
      // - nobody use those anyway
      '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' +
    ')';

  re.src_host =

    '(?:' +
    // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain/*_root*/ + ')' +
    ')';

  re.tpl_host_fuzzy =

    '(?:' +
      re.src_ip4 +
    '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' +
    ')';

  re.tpl_host_no_ip_fuzzy =

    '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';

  re.src_host_strict =

    re.src_host + re.src_host_terminator;

  re.tpl_host_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_host_terminator;

  re.src_host_port_strict =

    re.src_host + re.src_port + re.src_host_terminator;

  re.tpl_host_port_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;

  re.tpl_host_port_no_ip_fuzzy_strict =

    re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;


  ////////////////////////////////////////////////////////////////////////////////
  // Main rules

  // Rude test fuzzy links by host, for quick deny
  re.tpl_host_fuzzy_test =

    'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';

  re.tpl_email_fuzzy =

      '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';

  re.tpl_link_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';

  re.tpl_link_no_ip_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';

  return re;
};


/***/ }),
/* 2364 */
/***/ (function(module, exports) {

module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/

/***/ }),
/* 2365 */
/***/ (function(module, exports) {

module.exports=/[\0-\x1F\x7F-\x9F]/

/***/ }),
/* 2366 */
/***/ (function(module, exports) {

module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/

/***/ }),
/* 2367 */
/***/ (function(module, exports) {

module.exports=/[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/

/***/ }),
/* 2368 */
/***/ (function(module, exports) {

module.exports = [
  "aaa",
  "aarp",
  "abarth",
  "abb",
  "abbott",
  "abbvie",
  "abc",
  "able",
  "abogado",
  "abudhabi",
  "ac",
  "academy",
  "accenture",
  "accountant",
  "accountants",
  "aco",
  "active",
  "actor",
  "ad",
  "adac",
  "ads",
  "adult",
  "ae",
  "aeg",
  "aero",
  "aetna",
  "af",
  "afamilycompany",
  "afl",
  "africa",
  "ag",
  "agakhan",
  "agency",
  "ai",
  "aig",
  "aigo",
  "airbus",
  "airforce",
  "airtel",
  "akdn",
  "al",
  "alfaromeo",
  "alibaba",
  "alipay",
  "allfinanz",
  "allstate",
  "ally",
  "alsace",
  "alstom",
  "am",
  "americanexpress",
  "americanfamily",
  "amex",
  "amfam",
  "amica",
  "amsterdam",
  "analytics",
  "android",
  "anquan",
  "anz",
  "ao",
  "aol",
  "apartments",
  "app",
  "apple",
  "aq",
  "aquarelle",
  "ar",
  "arab",
  "aramco",
  "archi",
  "army",
  "arpa",
  "art",
  "arte",
  "as",
  "asda",
  "asia",
  "associates",
  "at",
  "athleta",
  "attorney",
  "au",
  "auction",
  "audi",
  "audible",
  "audio",
  "auspost",
  "author",
  "auto",
  "autos",
  "avianca",
  "aw",
  "aws",
  "ax",
  "axa",
  "az",
  "azure",
  "ba",
  "baby",
  "baidu",
  "banamex",
  "bananarepublic",
  "band",
  "bank",
  "bar",
  "barcelona",
  "barclaycard",
  "barclays",
  "barefoot",
  "bargains",
  "baseball",
  "basketball",
  "bauhaus",
  "bayern",
  "bb",
  "bbc",
  "bbt",
  "bbva",
  "bcg",
  "bcn",
  "bd",
  "be",
  "beats",
  "beauty",
  "beer",
  "bentley",
  "berlin",
  "best",
  "bestbuy",
  "bet",
  "bf",
  "bg",
  "bh",
  "bharti",
  "bi",
  "bible",
  "bid",
  "bike",
  "bing",
  "bingo",
  "bio",
  "biz",
  "bj",
  "black",
  "blackfriday",
  "blanco",
  "blockbuster",
  "blog",
  "bloomberg",
  "blue",
  "bm",
  "bms",
  "bmw",
  "bn",
  "bnl",
  "bnpparibas",
  "bo",
  "boats",
  "boehringer",
  "bofa",
  "bom",
  "bond",
  "boo",
  "book",
  "booking",
  "boots",
  "bosch",
  "bostik",
  "boston",
  "bot",
  "boutique",
  "box",
  "br",
  "bradesco",
  "bridgestone",
  "broadway",
  "broker",
  "brother",
  "brussels",
  "bs",
  "bt",
  "budapest",
  "bugatti",
  "build",
  "builders",
  "business",
  "buy",
  "buzz",
  "bv",
  "bw",
  "by",
  "bz",
  "bzh",
  "ca",
  "cab",
  "cafe",
  "cal",
  "call",
  "calvinklein",
  "cam",
  "camera",
  "camp",
  "cancerresearch",
  "canon",
  "capetown",
  "capital",
  "capitalone",
  "car",
  "caravan",
  "cards",
  "care",
  "career",
  "careers",
  "cars",
  "cartier",
  "casa",
  "case",
  "caseih",
  "cash",
  "casino",
  "cat",
  "catering",
  "catholic",
  "cba",
  "cbn",
  "cbre",
  "cbs",
  "cc",
  "cd",
  "ceb",
  "center",
  "ceo",
  "cern",
  "cf",
  "cfa",
  "cfd",
  "cg",
  "ch",
  "chanel",
  "channel",
  "chase",
  "chat",
  "cheap",
  "chintai",
  "christmas",
  "chrome",
  "chrysler",
  "church",
  "ci",
  "cipriani",
  "circle",
  "cisco",
  "citadel",
  "citi",
  "citic",
  "city",
  "cityeats",
  "ck",
  "cl",
  "claims",
  "cleaning",
  "click",
  "clinic",
  "clinique",
  "clothing",
  "cloud",
  "club",
  "clubmed",
  "cm",
  "cn",
  "co",
  "coach",
  "codes",
  "coffee",
  "college",
  "cologne",
  "com",
  "comcast",
  "commbank",
  "community",
  "company",
  "compare",
  "computer",
  "comsec",
  "condos",
  "construction",
  "consulting",
  "contact",
  "contractors",
  "cooking",
  "cookingchannel",
  "cool",
  "coop",
  "corsica",
  "country",
  "coupon",
  "coupons",
  "courses",
  "cr",
  "credit",
  "creditcard",
  "creditunion",
  "cricket",
  "crown",
  "crs",
  "cruise",
  "cruises",
  "csc",
  "cu",
  "cuisinella",
  "cv",
  "cw",
  "cx",
  "cy",
  "cymru",
  "cyou",
  "cz",
  "dabur",
  "dad",
  "dance",
  "data",
  "date",
  "dating",
  "datsun",
  "day",
  "dclk",
  "dds",
  "de",
  "deal",
  "dealer",
  "deals",
  "degree",
  "delivery",
  "dell",
  "deloitte",
  "delta",
  "democrat",
  "dental",
  "dentist",
  "desi",
  "design",
  "dev",
  "dhl",
  "diamonds",
  "diet",
  "digital",
  "direct",
  "directory",
  "discount",
  "discover",
  "dish",
  "diy",
  "dj",
  "dk",
  "dm",
  "dnp",
  "do",
  "docs",
  "doctor",
  "dodge",
  "dog",
  "doha",
  "domains",
  "dot",
  "download",
  "drive",
  "dtv",
  "dubai",
  "duck",
  "dunlop",
  "duns",
  "dupont",
  "durban",
  "dvag",
  "dvr",
  "dz",
  "earth",
  "eat",
  "ec",
  "eco",
  "edeka",
  "edu",
  "education",
  "ee",
  "eg",
  "email",
  "emerck",
  "energy",
  "engineer",
  "engineering",
  "enterprises",
  "epost",
  "epson",
  "equipment",
  "er",
  "ericsson",
  "erni",
  "es",
  "esq",
  "estate",
  "esurance",
  "et",
  "etisalat",
  "eu",
  "eurovision",
  "eus",
  "events",
  "everbank",
  "exchange",
  "expert",
  "exposed",
  "express",
  "extraspace",
  "fage",
  "fail",
  "fairwinds",
  "faith",
  "family",
  "fan",
  "fans",
  "farm",
  "farmers",
  "fashion",
  "fast",
  "fedex",
  "feedback",
  "ferrari",
  "ferrero",
  "fi",
  "fiat",
  "fidelity",
  "fido",
  "film",
  "final",
  "finance",
  "financial",
  "fire",
  "firestone",
  "firmdale",
  "fish",
  "fishing",
  "fit",
  "fitness",
  "fj",
  "fk",
  "flickr",
  "flights",
  "flir",
  "florist",
  "flowers",
  "fly",
  "fm",
  "fo",
  "foo",
  "food",
  "foodnetwork",
  "football",
  "ford",
  "forex",
  "forsale",
  "forum",
  "foundation",
  "fox",
  "fr",
  "free",
  "fresenius",
  "frl",
  "frogans",
  "frontdoor",
  "frontier",
  "ftr",
  "fujitsu",
  "fujixerox",
  "fun",
  "fund",
  "furniture",
  "futbol",
  "fyi",
  "ga",
  "gal",
  "gallery",
  "gallo",
  "gallup",
  "game",
  "games",
  "gap",
  "garden",
  "gb",
  "gbiz",
  "gd",
  "gdn",
  "ge",
  "gea",
  "gent",
  "genting",
  "george",
  "gf",
  "gg",
  "ggee",
  "gh",
  "gi",
  "gift",
  "gifts",
  "gives",
  "giving",
  "gl",
  "glade",
  "glass",
  "gle",
  "global",
  "globo",
  "gm",
  "gmail",
  "gmbh",
  "gmo",
  "gmx",
  "gn",
  "godaddy",
  "gold",
  "goldpoint",
  "golf",
  "goo",
  "goodhands",
  "goodyear",
  "goog",
  "google",
  "gop",
  "got",
  "gov",
  "gp",
  "gq",
  "gr",
  "grainger",
  "graphics",
  "gratis",
  "green",
  "gripe",
  "grocery",
  "group",
  "gs",
  "gt",
  "gu",
  "guardian",
  "gucci",
  "guge",
  "guide",
  "guitars",
  "guru",
  "gw",
  "gy",
  "hair",
  "hamburg",
  "hangout",
  "haus",
  "hbo",
  "hdfc",
  "hdfcbank",
  "health",
  "healthcare",
  "help",
  "helsinki",
  "here",
  "hermes",
  "hgtv",
  "hiphop",
  "hisamitsu",
  "hitachi",
  "hiv",
  "hk",
  "hkt",
  "hm",
  "hn",
  "hockey",
  "holdings",
  "holiday",
  "homedepot",
  "homegoods",
  "homes",
  "homesense",
  "honda",
  "honeywell",
  "horse",
  "hospital",
  "host",
  "hosting",
  "hot",
  "hoteles",
  "hotels",
  "hotmail",
  "house",
  "how",
  "hr",
  "hsbc",
  "ht",
  "hu",
  "hughes",
  "hyatt",
  "hyundai",
  "ibm",
  "icbc",
  "ice",
  "icu",
  "id",
  "ie",
  "ieee",
  "ifm",
  "ikano",
  "il",
  "im",
  "imamat",
  "imdb",
  "immo",
  "immobilien",
  "in",
  "industries",
  "infiniti",
  "info",
  "ing",
  "ink",
  "institute",
  "insurance",
  "insure",
  "int",
  "intel",
  "international",
  "intuit",
  "investments",
  "io",
  "ipiranga",
  "iq",
  "ir",
  "irish",
  "is",
  "iselect",
  "ismaili",
  "ist",
  "istanbul",
  "it",
  "itau",
  "itv",
  "iveco",
  "iwc",
  "jaguar",
  "java",
  "jcb",
  "jcp",
  "je",
  "jeep",
  "jetzt",
  "jewelry",
  "jio",
  "jlc",
  "jll",
  "jm",
  "jmp",
  "jnj",
  "jo",
  "jobs",
  "joburg",
  "jot",
  "joy",
  "jp",
  "jpmorgan",
  "jprs",
  "juegos",
  "juniper",
  "kaufen",
  "kddi",
  "ke",
  "kerryhotels",
  "kerrylogistics",
  "kerryproperties",
  "kfh",
  "kg",
  "kh",
  "ki",
  "kia",
  "kim",
  "kinder",
  "kindle",
  "kitchen",
  "kiwi",
  "km",
  "kn",
  "koeln",
  "komatsu",
  "kosher",
  "kp",
  "kpmg",
  "kpn",
  "kr",
  "krd",
  "kred",
  "kuokgroup",
  "kw",
  "ky",
  "kyoto",
  "kz",
  "la",
  "lacaixa",
  "ladbrokes",
  "lamborghini",
  "lamer",
  "lancaster",
  "lancia",
  "lancome",
  "land",
  "landrover",
  "lanxess",
  "lasalle",
  "lat",
  "latino",
  "latrobe",
  "law",
  "lawyer",
  "lb",
  "lc",
  "lds",
  "lease",
  "leclerc",
  "lefrak",
  "legal",
  "lego",
  "lexus",
  "lgbt",
  "li",
  "liaison",
  "lidl",
  "life",
  "lifeinsurance",
  "lifestyle",
  "lighting",
  "like",
  "lilly",
  "limited",
  "limo",
  "lincoln",
  "linde",
  "link",
  "lipsy",
  "live",
  "living",
  "lixil",
  "lk",
  "loan",
  "loans",
  "locker",
  "locus",
  "loft",
  "lol",
  "london",
  "lotte",
  "lotto",
  "love",
  "lpl",
  "lplfinancial",
  "lr",
  "ls",
  "lt",
  "ltd",
  "ltda",
  "lu",
  "lundbeck",
  "lupin",
  "luxe",
  "luxury",
  "lv",
  "ly",
  "ma",
  "macys",
  "madrid",
  "maif",
  "maison",
  "makeup",
  "man",
  "management",
  "mango",
  "map",
  "market",
  "marketing",
  "markets",
  "marriott",
  "marshalls",
  "maserati",
  "mattel",
  "mba",
  "mc",
  "mckinsey",
  "md",
  "me",
  "med",
  "media",
  "meet",
  "melbourne",
  "meme",
  "memorial",
  "men",
  "menu",
  "meo",
  "merckmsd",
  "metlife",
  "mg",
  "mh",
  "miami",
  "microsoft",
  "mil",
  "mini",
  "mint",
  "mit",
  "mitsubishi",
  "mk",
  "ml",
  "mlb",
  "mls",
  "mm",
  "mma",
  "mn",
  "mo",
  "mobi",
  "mobile",
  "mobily",
  "moda",
  "moe",
  "moi",
  "mom",
  "monash",
  "money",
  "monster",
  "mopar",
  "mormon",
  "mortgage",
  "moscow",
  "moto",
  "motorcycles",
  "mov",
  "movie",
  "movistar",
  "mp",
  "mq",
  "mr",
  "ms",
  "msd",
  "mt",
  "mtn",
  "mtr",
  "mu",
  "museum",
  "mutual",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nab",
  "nadex",
  "nagoya",
  "name",
  "nationwide",
  "natura",
  "navy",
  "nba",
  "nc",
  "ne",
  "nec",
  "net",
  "netbank",
  "netflix",
  "network",
  "neustar",
  "new",
  "newholland",
  "news",
  "next",
  "nextdirect",
  "nexus",
  "nf",
  "nfl",
  "ng",
  "ngo",
  "nhk",
  "ni",
  "nico",
  "nike",
  "nikon",
  "ninja",
  "nissan",
  "nissay",
  "nl",
  "no",
  "nokia",
  "northwesternmutual",
  "norton",
  "now",
  "nowruz",
  "nowtv",
  "np",
  "nr",
  "nra",
  "nrw",
  "ntt",
  "nu",
  "nyc",
  "nz",
  "obi",
  "observer",
  "off",
  "office",
  "okinawa",
  "olayan",
  "olayangroup",
  "oldnavy",
  "ollo",
  "om",
  "omega",
  "one",
  "ong",
  "onl",
  "online",
  "onyourside",
  "ooo",
  "open",
  "oracle",
  "orange",
  "org",
  "organic",
  "origins",
  "osaka",
  "otsuka",
  "ott",
  "ovh",
  "pa",
  "page",
  "panasonic",
  "panerai",
  "paris",
  "pars",
  "partners",
  "parts",
  "party",
  "passagens",
  "pay",
  "pccw",
  "pe",
  "pet",
  "pf",
  "pfizer",
  "pg",
  "ph",
  "pharmacy",
  "phd",
  "philips",
  "phone",
  "photo",
  "photography",
  "photos",
  "physio",
  "piaget",
  "pics",
  "pictet",
  "pictures",
  "pid",
  "pin",
  "ping",
  "pink",
  "pioneer",
  "pizza",
  "pk",
  "pl",
  "place",
  "play",
  "playstation",
  "plumbing",
  "plus",
  "pm",
  "pn",
  "pnc",
  "pohl",
  "poker",
  "politie",
  "porn",
  "post",
  "pr",
  "pramerica",
  "praxi",
  "press",
  "prime",
  "pro",
  "prod",
  "productions",
  "prof",
  "progressive",
  "promo",
  "properties",
  "property",
  "protection",
  "pru",
  "prudential",
  "ps",
  "pt",
  "pub",
  "pw",
  "pwc",
  "py",
  "qa",
  "qpon",
  "quebec",
  "quest",
  "qvc",
  "racing",
  "radio",
  "raid",
  "re",
  "read",
  "realestate",
  "realtor",
  "realty",
  "recipes",
  "red",
  "redstone",
  "redumbrella",
  "rehab",
  "reise",
  "reisen",
  "reit",
  "reliance",
  "ren",
  "rent",
  "rentals",
  "repair",
  "report",
  "republican",
  "rest",
  "restaurant",
  "review",
  "reviews",
  "rexroth",
  "rich",
  "richardli",
  "ricoh",
  "rightathome",
  "ril",
  "rio",
  "rip",
  "rmit",
  "ro",
  "rocher",
  "rocks",
  "rodeo",
  "rogers",
  "room",
  "rs",
  "rsvp",
  "ru",
  "rugby",
  "ruhr",
  "run",
  "rw",
  "rwe",
  "ryukyu",
  "sa",
  "saarland",
  "safe",
  "safety",
  "sakura",
  "sale",
  "salon",
  "samsclub",
  "samsung",
  "sandvik",
  "sandvikcoromant",
  "sanofi",
  "sap",
  "sapo",
  "sarl",
  "sas",
  "save",
  "saxo",
  "sb",
  "sbi",
  "sbs",
  "sc",
  "sca",
  "scb",
  "schaeffler",
  "schmidt",
  "scholarships",
  "school",
  "schule",
  "schwarz",
  "science",
  "scjohnson",
  "scor",
  "scot",
  "sd",
  "se",
  "search",
  "seat",
  "secure",
  "security",
  "seek",
  "select",
  "sener",
  "services",
  "ses",
  "seven",
  "sew",
  "sex",
  "sexy",
  "sfr",
  "sg",
  "sh",
  "shangrila",
  "sharp",
  "shaw",
  "shell",
  "shia",
  "shiksha",
  "shoes",
  "shop",
  "shopping",
  "shouji",
  "show",
  "showtime",
  "shriram",
  "si",
  "silk",
  "sina",
  "singles",
  "site",
  "sj",
  "sk",
  "ski",
  "skin",
  "sky",
  "skype",
  "sl",
  "sling",
  "sm",
  "smart",
  "smile",
  "sn",
  "sncf",
  "so",
  "soccer",
  "social",
  "softbank",
  "software",
  "sohu",
  "solar",
  "solutions",
  "song",
  "sony",
  "soy",
  "space",
  "spiegel",
  "spot",
  "spreadbetting",
  "sr",
  "srl",
  "srt",
  "st",
  "stada",
  "staples",
  "star",
  "starhub",
  "statebank",
  "statefarm",
  "statoil",
  "stc",
  "stcgroup",
  "stockholm",
  "storage",
  "store",
  "stream",
  "studio",
  "study",
  "style",
  "su",
  "sucks",
  "supplies",
  "supply",
  "support",
  "surf",
  "surgery",
  "suzuki",
  "sv",
  "swatch",
  "swiftcover",
  "swiss",
  "sx",
  "sy",
  "sydney",
  "symantec",
  "systems",
  "sz",
  "tab",
  "taipei",
  "talk",
  "taobao",
  "target",
  "tatamotors",
  "tatar",
  "tattoo",
  "tax",
  "taxi",
  "tc",
  "tci",
  "td",
  "tdk",
  "team",
  "tech",
  "technology",
  "tel",
  "telecity",
  "telefonica",
  "temasek",
  "tennis",
  "teva",
  "tf",
  "tg",
  "th",
  "thd",
  "theater",
  "theatre",
  "tiaa",
  "tickets",
  "tienda",
  "tiffany",
  "tips",
  "tires",
  "tirol",
  "tj",
  "tjmaxx",
  "tjx",
  "tk",
  "tkmaxx",
  "tl",
  "tm",
  "tmall",
  "tn",
  "to",
  "today",
  "tokyo",
  "tools",
  "top",
  "toray",
  "toshiba",
  "total",
  "tours",
  "town",
  "toyota",
  "toys",
  "tr",
  "trade",
  "trading",
  "training",
  "travel",
  "travelchannel",
  "travelers",
  "travelersinsurance",
  "trust",
  "trv",
  "tt",
  "tube",
  "tui",
  "tunes",
  "tushu",
  "tv",
  "tvs",
  "tw",
  "tz",
  "ua",
  "ubank",
  "ubs",
  "uconnect",
  "ug",
  "uk",
  "unicom",
  "university",
  "uno",
  "uol",
  "ups",
  "us",
  "uy",
  "uz",
  "va",
  "vacations",
  "vana",
  "vanguard",
  "vc",
  "ve",
  "vegas",
  "ventures",
  "verisign",
  "versicherung",
  "vet",
  "vg",
  "vi",
  "viajes",
  "video",
  "vig",
  "viking",
  "villas",
  "vin",
  "vip",
  "virgin",
  "visa",
  "vision",
  "vista",
  "vistaprint",
  "viva",
  "vivo",
  "vlaanderen",
  "vn",
  "vodka",
  "volkswagen",
  "volvo",
  "vote",
  "voting",
  "voto",
  "voyage",
  "vu",
  "vuelos",
  "wales",
  "walmart",
  "walter",
  "wang",
  "wanggou",
  "warman",
  "watch",
  "watches",
  "weather",
  "weatherchannel",
  "webcam",
  "weber",
  "website",
  "wed",
  "wedding",
  "weibo",
  "weir",
  "wf",
  "whoswho",
  "wien",
  "wiki",
  "williamhill",
  "win",
  "windows",
  "wine",
  "winners",
  "wme",
  "wolterskluwer",
  "woodside",
  "work",
  "works",
  "world",
  "wow",
  "ws",
  "wtc",
  "wtf",
  "xbox",
  "xerox",
  "xfinity",
  "xihuan",
  "xin",
  "कॉम", // xn--11b4c3d
  "セール", // xn--1ck2e1b
  "佛山", // xn--1qqw23a
  "ಭಾರತ", // xn--2scrj9c
  "慈善", // xn--30rr7y
  "集团", // xn--3bst00m
  "在线", // xn--3ds443g
  "한국", // xn--3e0b707e
  "ଭାରତ", // xn--3hcrj9c
  "大众汽车", // xn--3oq18vl8pn36a
  "点看", // xn--3pxu8k
  "คอม", // xn--42c2d9a
  "ভাৰত", // xn--45br5cyl
  "ভারত", // xn--45brj9c
  "八卦", // xn--45q11c
  "موقع", // xn--4gbrim
  "বাংলা", // xn--54b7fta0cc
  "公益", // xn--55qw42g
  "公司", // xn--55qx5d
  "香格里拉", // xn--5su34j936bgsg
  "网站", // xn--5tzm5g
  "移动", // xn--6frz82g
  "我爱你", // xn--6qq986b3xl
  "москва", // xn--80adxhks
  "қаз", // xn--80ao21a
  "католик", // xn--80aqecdr1a
  "онлайн", // xn--80asehdb
  "сайт", // xn--80aswg
  "联通", // xn--8y0a063a
  "срб", // xn--90a3ac
  "бг", // xn--90ae
  "бел", // xn--90ais
  "קום", // xn--9dbq2a
  "时尚", // xn--9et52u
  "微博", // xn--9krt00a
  "淡马锡", // xn--b4w605ferd
  "ファッション", // xn--bck1b9a5dre4c
  "орг", // xn--c1avg
  "नेट", // xn--c2br7g
  "ストア", // xn--cck2b3b
  "삼성", // xn--cg4bki
  "சிங்கப்பூர்", // xn--clchc0ea0b2g2a9gcd
  "商标", // xn--czr694b
  "商店", // xn--czrs0t
  "商城", // xn--czru2d
  "дети", // xn--d1acj3b
  "мкд", // xn--d1alf
  "ею", // xn--e1a4c
  "ポイント", // xn--eckvdtc9d
  "新闻", // xn--efvy88h
  "工行", // xn--estv75g
  "家電", // xn--fct429k
  "كوم", // xn--fhbei
  "中文网", // xn--fiq228c5hs
  "中信", // xn--fiq64b
  "中国", // xn--fiqs8s
  "中國", // xn--fiqz9s
  "娱乐", // xn--fjq720a
  "谷歌", // xn--flw351e
  "భారత్", // xn--fpcrj9c3d
  "ලංකා", // xn--fzc2c9e2c
  "電訊盈科", // xn--fzys8d69uvgm
  "购物", // xn--g2xx48c
  "クラウド", // xn--gckr3f0f
  "ભારત", // xn--gecrj9c
  "通販", // xn--gk3at1e
  "भारतम्", // xn--h2breg3eve
  "भारत", // xn--h2brj9c
  "भारोत", // xn--h2brj9c8c
  "网店", // xn--hxt814e
  "संगठन", // xn--i1b6b1a6a2e
  "餐厅", // xn--imr513n
  "网络", // xn--io0a7i
  "ком", // xn--j1aef
  "укр", // xn--j1amh
  "香港", // xn--j6w193g
  "诺基亚", // xn--jlq61u9w7b
  "食品", // xn--jvr189m
  "飞利浦", // xn--kcrx77d1x4a
  "台湾", // xn--kprw13d
  "台灣", // xn--kpry57d
  "手表", // xn--kpu716f
  "手机", // xn--kput3i
  "мон", // xn--l1acc
  "الجزائر", // xn--lgbbat1ad8j
  "عمان", // xn--mgb9awbf
  "ارامكو", // xn--mgba3a3ejt
  "ایران", // xn--mgba3a4f16a
  "العليان", // xn--mgba7c0bbn0a
  "اتصالات", // xn--mgbaakc7dvf
  "امارات", // xn--mgbaam7a8h
  "بازار", // xn--mgbab2bd
  "پاکستان", // xn--mgbai9azgqp6j
  "الاردن", // xn--mgbayh7gpa
  "موبايلي", // xn--mgbb9fbpob
  "بارت", // xn--mgbbh1a
  "بھارت", // xn--mgbbh1a71e
  "المغرب", // xn--mgbc0a9azcg
  "ابوظبي", // xn--mgbca7dzdo
  "السعودية", // xn--mgberp4a5d4ar
  "ڀارت", // xn--mgbgu82a
  "كاثوليك", // xn--mgbi4ecexp
  "سودان", // xn--mgbpl2fh
  "همراه", // xn--mgbt3dhd
  "عراق", // xn--mgbtx2b
  "مليسيا", // xn--mgbx4cd0ab
  "澳門", // xn--mix891f
  "닷컴", // xn--mk1bu44c
  "政府", // xn--mxtq1m
  "شبكة", // xn--ngbc5azd
  "بيتك", // xn--ngbe9e0a
  "عرب", // xn--ngbrx
  "გე", // xn--node
  "机构", // xn--nqv7f
  "组织机构", // xn--nqv7fs00ema
  "健康", // xn--nyqy26a
  "ไทย", // xn--o3cw4h
  "سورية", // xn--ogbpf8fl
  "рус", // xn--p1acf
  "рф", // xn--p1ai
  "珠宝", // xn--pbt977c
  "تونس", // xn--pgbs0dh
  "大拿", // xn--pssy2u
  "みんな", // xn--q9jyb4c
  "グーグル", // xn--qcka1pmc
  "ελ", // xn--qxam
  "世界", // xn--rhqv96g
  "書籍", // xn--rovu88b
  "ഭാരതം", // xn--rvc1e0am3e
  "ਭਾਰਤ", // xn--s9brj9c
  "网址", // xn--ses554g
  "닷넷", // xn--t60b56a
  "コム", // xn--tckwe
  "天主教", // xn--tiq49xqyj
  "游戏", // xn--unup4y
  "vermögensberater", // xn--vermgensberater-ctb
  "vermögensberatung", // xn--vermgensberatung-pwb
  "企业", // xn--vhquv
  "信息", // xn--vuq861b
  "嘉里大酒店", // xn--w4r85el8fhu5dnra
  "嘉里", // xn--w4rs40l
  "مصر", // xn--wgbh1c
  "قطر", // xn--wgbl6a
  "广东", // xn--xhq521b
  "இலங்கை", // xn--xkc2al3hye2a
  "இந்தியா", // xn--xkc2dl3a5ee0h
  "հայ", // xn--y9a3aq
  "新加坡", // xn--yfro4i67o
  "فلسطين", // xn--ygbi2ammx
  "政务", // xn--zfr164b
  "xperia",
  "xxx",
  "xyz",
  "yachts",
  "yahoo",
  "yamaxun",
  "yandex",
  "ye",
  "yodobashi",
  "yoga",
  "yokohama",
  "you",
  "youtube",
  "yt",
  "yun",
  "za",
  "zappos",
  "zara",
  "zero",
  "zip",
  "zippo",
  "zm",
  "zone",
  "zuerich",
  "zw"
];


/***/ }),
/* 2369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Widgets_FileSelectorDialog__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_DropZone__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_CircularProgress__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Embed__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Widgets_VideoPlayer__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_superagent__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Config__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_PageModule__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_services_SoundCloud__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_Css__ = __webpack_require__(6);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var supportedExtensions=['mp4','ogv'];// const oldExtensions = ['mp4', 'ogv', 'ogg'];
var css={toggleWrapper:'_f7',videoDownload:'_f8',downloadLink:'_f9'};var VideoModule=function(_PageModule){_inherits(VideoModule,_PageModule);function VideoModule(){_classCallCheck(this,VideoModule);var _this=_possibleConstructorReturn(this,(VideoModule.__proto__||Object.getPrototypeOf(VideoModule)).apply(this,arguments));_initialiseProps.call(_this);var _this$props=_this.props,content=_this$props.content,params=_this$props.params;var caption=params.caption,external=params.external,allowDownloading=params.allowDownloading;var file=void 0;var sources=void 0;if(content.length&&content.length>0){file=content[0];sources=file&&supportedExtensions.map(function(extension){return{url:file.url,type:extension};})||[];}else if(params&&(typeof params==='undefined'?'undefined':_typeof(params))==='object'&&Object.keys(params).length>0&&!params.external&&(!params.file_id||params.file_id.length<1)){sources=Object.keys(params).map(function(extension){/*const tokens = params[extension].split('.');
        tokens.pop();*/return{url:params[extension],type:extension};});}_this.state={edit:{sources:sources,external:external,caption:caption,allowDownloading:allowDownloading}};return _this;}_createClass(VideoModule,[{key:'isFullscreen',value:function isFullscreen(){return!window.screenTop&&!window.screenY;}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('webkitfullscreenchange',this.handleFullScreen,false);document.addEventListener('mozfullscreenchange',this.handleFullScreen,false);document.addEventListener('fullscreenchange',this.handleFullScreen,false);}},{key:'componentWillMount',value:function componentWillMount(){document.removeEventListener('webkitfullscreenchange',this.handleFullScreen);document.removeEventListener('mozfullscreenchange',this.handleFullScreen);document.removeEventListener('fullscreenchange',this.handleFullScreen);}},{key:'autoSave',value:function autoSave(){var _this2=this;if(this._timer){clearTimeout(this._timer);}this._timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_18_services_Message__["a" /* default */].info(_this2.context.getIntlMessage('video.changesSaved'));_this2.save(false);_this2._timer=null;},1000);}},{key:'selectMedia',value:function selectMedia(file){var sources=supportedExtensions.map(function(extension){return{url:file.url,type:extension};});var edit=Object.assign({},this.state.edit,{fileId:file.id,external:null,sources:sources});this.setState({edit:edit,fileSelectorOpen:false});this.autoSave();}},{key:'progress',value:function progress(event){this.setState({progress:event.percent});}},{key:'onMediaLibrary',value:function onMediaLibrary(){this.setState({fileSelectorOpen:true});}},{key:'onMediaLibraryClose',value:function onMediaLibraryClose(){this.setState({fileSelectorOpen:false});}},{key:'openDownload',value:function openDownload(event){this.refs.dropZone.open();event.stopPropagation();event.preventDefault();}},{key:'changeCaption',value:function changeCaption(e){var edit=Object.assign({},this.state.edit,{caption:e.target.value});this.setState({edit:edit});}},{key:'saveOnBlur',value:function saveOnBlur(){__WEBPACK_IMPORTED_MODULE_18_services_Message__["a" /* default */].info(this.context.getIntlMessage('video.changesSaved'));this.save(false);}},{key:'getModuleData',value:function getModuleData(content,data){return{caption:this.state.edit.caption,allowDownloading:this.state.edit.allowDownloading,fileId:this.state.edit.fileId||data.fileId,external:this.state.edit.external};}},{key:'embed',value:function embed(){var _this3=this;var url=this.refs.embedUrl.value;var edit=Object.assign({},this.state.edit);if(url!==''){var provider=__WEBPACK_IMPORTED_MODULE_16_Util__["b" /* Media */].getProviderFromUrl(url);if(provider){if(provider.provider===3){__WEBPACK_IMPORTED_MODULE_17_services_SoundCloud__["a" /* default */].oEmbed(url,function(response){provider.id=response.html;edit.external=provider;_this3.setState({edit:edit});_this3.autoSave();});}else{edit.external=provider;this.setState({edit:edit});this.autoSave();}}else{this.cannotSave();}}}},{key:'attach',value:function attach(data){if(data.length&&data.length>0){var file=data[0].file;var sources=supportedExtensions.map(function(extension){return{url:file.url.replace(/deathstar\.s\.coursio\.com\/files/i,'coursio.s3-eu-west-1.amazonaws.com'),type:extension};});var edit=Object.assign({},this.state.edit,{external:null,fileId:file.id,sources:sources});this.setState({edit:edit});this.getModuleData();this.pollApiForJobId(file.id);if(!this.state.pollProgress){this.setState({progress:0.45,pollProgress:true});}}}},{key:'cannotSave',value:function cannotSave(){var _this4=this;if(this._timer){clearTimeout(this._timer);}this._timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_18_services_Message__["a" /* default */].info(_this4.context.getIntlMessage('video.changesCannotBeSaved'));_this4._timer=null;},1000);}},{key:'pollApiForJobId',value:function pollApiForJobId(fileId){var _this5=this;setTimeout(function(){var now=new Date();_this5.apiPollerStart=_this5.apiPollerStart||new Date();if(now-_this5.apiPollerStart<100000){__WEBPACK_IMPORTED_MODULE_11_services_SteelCompass__["a" /* default */].call('file','getJobId',{fileId:fileId},function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:data=response.data;// Poll encoding progress
if(!(data&&data.jobId&&data.accessKey)){_context.next=7;break;}_context.next=4;return _this5.pollZencForProgress(data.jobId,data.accessKey);case 4:if(!_this5.state.pollProgress){_this5.setState({progress:0,pollProgress:true});}_context.next=8;break;case 7:// Keep polling for jobId
_this5.pollApiForJobId(fileId);case 8:case'end':return _context.stop();}}},_callee,_this5);}));return function(_x){return _ref.apply(this,arguments);};}());}else{// Reset polling
_this5.apiPollerStart=null;}},3500);}},{key:'pollZencForProgress',value:function pollZencForProgress(jobId,accessKey){var _this6=this;setTimeout(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var now,response,data,sources;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:now=new Date();_this6.zencPollerStart=_this6.zencPollerStart||new Date();if(!(now-_this6.zencPollerStart<1000000||_this6.encodingProgress>0&&_this6.encodingProgress<100)){_context2.next=16;break;}_context2.next=5;return __WEBPACK_IMPORTED_MODULE_12_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_13_Config__["a" /* default */].zenCoderRoot+'jobs/'+jobId+'/progress.json?api_key='+accessKey).set('Content-Type','text/plain');case 5:response=_context2.sent;data=response&&JSON.parse(response.text)||{};// Data object should contain a state and a progress property if the state is still processing.
if(!(data.state==='processing'&&data.progress)){_context2.next=13;break;}if(data.progress>_this6.state.progress){_this6.setState({progress:data.progress});}_context2.next=11;return _this6.pollZencForProgress(jobId,accessKey);case 11:_context2.next=14;break;case 13:if(data.state==='finished'){// Stop the polling
sources=_this6.state.edit.sources.map(function(source){return Object.assign({},source,{url:source.url.replace(/deathstar\.s\.coursio\.com\/files/i,'coursio.s3-eu-west-1.amazonaws.com')});});_this6.setState({progress:100,pollProgress:false,edit:Object.assign({},_this6.state.edit,{sources:sources})});__WEBPACK_IMPORTED_MODULE_18_services_Message__["a" /* default */].info(_this6.context.getIntlMessage('media.encodingComplete'));}case 14:_context2.next=18;break;case 16:// Reset polling
_this6.zencPollerStart=null;_this6.autoSave();case 18:case'end':return _context2.stop();}}},_callee2,_this6);})),2000);}},{key:'renderEditMode',value:function renderEditMode(){var _state$edit=this.state.edit,sources=_state$edit.sources,external=_state$edit.external,caption=_state$edit.caption,allowDownloading=_state$edit.allowDownloading;var video=void 0;// let pollProgress;
// if (this.state.pollProgress) {
//   pollProgress = <CircularProgress style={{ height: Spacing.desktopKeylineIncrement / 4 }} progressColor={this.context.muiTheme.rawTheme.palette.primary2Color} progress={this.state.progress} size={2} />;
// }
var uploadLink=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onTouchTap:this.openDownload.bind(this)},this.context.getIntlMessage('module.upload'));var libraryLink=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{onTouchTap:this.onMediaLibrary.bind(this)},this.context.getIntlMessage('module.library'));if(this.state.pollProgress||this.state.progress>0&&this.state.progress<100){video=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_CircularProgress__["a" /* default */],{progressColor:this.context.muiTheme.rawTheme.palette.primary1Color,progress:this.state.progress,size:2}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.pollProgress?this.context.getIntlMessage('media.encoding'):this.context.getIntlMessage('media.uploading')));}else if(sources&&sources.length>0||external&&external.provider){if(external&&external.provider){video=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Embed__["a" /* default */],{params:external});}else{video=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Widgets_VideoPlayer__["a" /* default */],{sources:sources});}}else{video=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_SvgIcons__["AvMovie"],{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].icon});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].moduleContainer},video),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_DropZone__["a" /* default */],{accept:'video/*',ref:'dropZone',style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].dropZone,lineHeight:Spacing.desktopKeylineIncrement/2,onProgress:this.progress.bind(this),onSuccess:this.attach.bind(this)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].header},this.context.getIntlMessage('module.dropVideo')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].subHeader},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["FormattedMessage"],{message:this.context.getIntlMessage('module.uploadOrBrowse'),upload:uploadLink,library:libraryLink})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].subHeader},this.context.getIntlMessage('module.or')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Paper"],{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].import.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["a" /* FlexBox */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{ref:'embedUrl',style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].import.input,type:'text',placeholder:this.context.getIntlMessage('video.embed'),onChange:this.embed.bind(this)})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["TextField"],{fullWidth:true,hintText:this.context.getIntlMessage('Caption'),value:caption,onChange:this.changeCaption.bind(this),onBlur:this.saveOnBlur.bind(this)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:css.toggleWrapper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["Toggle"],{name:'allowDownloading',value:'allowDownloading',labelPosition:'right',defaultToggled:allowDownloading,label:this.context.getIntlMessage('video.allowDownloading'),onToggle:this.allowDownloading})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Widgets_FileSelectorDialog__["a" /* default */],{type:'video',open:this.state.fileSelectorOpen,onSelect:this.selectMedia.bind(this),onClose:this.onMediaLibraryClose.bind(this)}));}},{key:'renderDetailMode',value:function renderDetailMode(){var _state$edit2=this.state.edit,sources=_state$edit2.sources,caption=_state$edit2.caption,external=_state$edit2.external,allowDownloading=_state$edit2.allowDownloading;var video=void 0;if(external&&external.provider){video=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Page_Module_Embed__["a" /* default */],{params:external});}else if(sources&&sources.length>0){video=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Widgets_VideoPlayer__["a" /* default */],{sources:sources,gaTacking:this.props.gaTacking});}else{video=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].dropZone},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].moduleContainer},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Material_SvgIcons__["AvMovie"],{style:__WEBPACK_IMPORTED_MODULE_6_components_Page_Module_Styles__["a" /* default */].icon}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),this.context.getIntlMessage('module.uploadVideo')));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{ref:'root',style:{marginBottom:42}},video,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('figcaption',null,caption),allowDownloading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:css.videoDownload},this.context.getIntlMessage('video.download'),this.props.sources.map(function(source){var extension=source.data.split('.').pop();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{key:extension,className:css.downloadLink,target:'_blank',href:''+location.protocol+source.downloadable},extension);})));}}]);return VideoModule;}(__WEBPACK_IMPORTED_MODULE_15_components_PageModule__["a" /* default */]);VideoModule.readable='VideoModule';var _initialiseProps=function _initialiseProps(){var _this7=this;this.handleFullScreen=function(event){var fullscreen=_this7.isFullscreen();if(!fullscreen){_this7.refs.root.scrollIntoView(true);}};this.allowDownloading=function(event,allowDownloading){_this7.setState({edit:Object.assign({},_this7.state.edit,{allowDownloading:allowDownloading})});};};/* harmony default export */ __webpack_exports__["a"] = (VideoModule);

/***/ }),
/* 2370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageModule__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edit_VideoModuleEditor__ = __webpack_require__(2392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cio_lib_Assets_Video__ = __webpack_require__(2393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cio_lib_Assets_Video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_cio_lib_Assets_Video__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var videoCss={video:'_gl'};var VideoModule=function(_Component){_inherits(VideoModule,_Component);function VideoModule(){_classCallCheck(this,VideoModule);return _possibleConstructorReturn(this,(VideoModule.__proto__||Object.getPrototypeOf(VideoModule)).apply(this,arguments));}_createClass(VideoModule,[{key:'render',value:function render(){var _props=this.props,sources=_props.sources,caption=_props.caption,mode=_props.mode,other=_objectWithoutProperties(_props,['sources','caption','mode']);var hasSources=sources.length>0;if(mode==='edit'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Edit_VideoModuleEditor__["a" /* default */],Object.assign({icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_cio_lib_Assets_Video___default.a,null)},this.props));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PageModule__["a" /* default */],other,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{controls:true,className:videoCss.video},sources.map(function(source){var extension=source.data.split('.').pop();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:source.data,type:'video/'+extension,key:extension});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',null,caption));}}]);return VideoModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VideoModule.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (VideoModule);

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Css = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  root: 'cio_gW',
  input: 'cio_gX'
};

var TextField = function (_Component) {
  _inherits(TextField, _Component);

  function TextField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextField.__proto__ || Object.getPrototypeOf(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: _this.props.value
    }, _this.handleChange = function (event) {
      var onChange = _this.props.onChange;
      var value = event.target.value;

      _this.setState({ value: value });
      onChange && onChange(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.state.value) {
        this.setState({ value: nextProps.value });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          value = _props.value,
          rest = _objectWithoutProperties(_props, ['className', 'style', 'value']);

      var classes = (0, _classnames2.default)(className, css.input, {});
      return _react2.default.createElement(
        'div',
        { style: style, className: css.root },
        _react2.default.createElement('input', _extends({ type: 'text', className: classes }, rest, { onChange: this.handleChange, value: this.state.value }))
      );
    }
  }]);

  return TextField;
}(_react.Component);

TextField.propTypes = {
  className: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  value: _react.PropTypes.string
};
exports.default = TextField;
module.exports = exports['default'];

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Css = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ENTER = 13;

var css = {
  root: 'cio_gU',
  fullWidth: 'cio_gV'
};

var TextArea = function (_Component) {
  _inherits(TextArea, _Component);

  function TextArea() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextArea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: _this.props.value
    }, _this.handleChange = function (event) {
      var onChange = _this.props.onChange;
      var value = event.target.value;

      _this.setState({ value: value }, function () {
        onChange && onChange(value);
      });
    }, _this.handleKeyUp = function (event) {
      var keyCode = event.keyCode;
      var onPressEnter = _this.props.onPressEnter;

      if (keyCode === ENTER) {
        onPressEnter && onPressEnter();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextArea, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.state.value) {
        this.setState({ value: nextProps.value });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          fullWidth = _props.fullWidth,
          value = _props.value,
          rest = _objectWithoutProperties(_props, ['className', 'children', 'fullWidth', 'value']);

      var classes = (0, _classnames2.default)(className, css.root, _defineProperty({}, css.fullWidth, fullWidth));
      return _react2.default.createElement(
        'textarea',
        _extends({
          type: 'text',
          className: classes
        }, rest, {
          onChange: this.handleChange,
          onKeyUp: this.handleKeyUp,
          value: this.state.value
        }),
        children
      );
    }
  }]);

  return TextArea;
}(_react.Component);

TextArea.propTypes = {
  className: _react.PropTypes.string,
  children: _react.PropTypes.node,
  onChange: _react.PropTypes.func,
  fullWidth: _react.PropTypes.bool,
  onPressEnter: _react.PropTypes.func,
  value: _react.PropTypes.string
};
exports.default = TextArea;
module.exports = exports['default'];

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Css = __webpack_require__(6);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _ToolbarGroup = __webpack_require__(652);

var _ToolbarGroup2 = _interopRequireDefault(_ToolbarGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  root: 'cio_g6',
  fixed: 'cio_g7',
  bottom: 'cio_g8',
  top: 'cio_g9',
  depth0: 'cio_g_',
  depth1: 'cio_g-',
  depth2: 'cio_ha',
  depth3: 'cio_hb',
  depth4: 'cio_hc',
  depth5: 'cio_hd',
  toolbar: 'cio_he',
  dense: 'cio_hf',
  big: 'cio_hg',
  center: 'cio_hh'
};

var Toolbar = function (_Component) {
  _inherits(Toolbar, _Component);

  function Toolbar() {
    _classCallCheck(this, Toolbar);

    return _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).apply(this, arguments));
  }

  _createClass(Toolbar, [{
    key: 'render',
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          children = _props.children,
          dense = _props.dense,
          top = _props.top,
          zDepth = _props.zDepth,
          bottom = _props.bottom,
          fixed = _props.fixed,
          transparent = _props.transparent,
          color = _props.color,
          center = _props.center,
          big = _props.big,
          other = _objectWithoutProperties(_props, ['children', 'dense', 'top', 'zDepth', 'bottom', 'fixed', 'transparent', 'color', 'center', 'big']);

      var classes = (0, _classnames2.default)(css.root, css['depth' + zDepth], (_classNames = {}, _defineProperty(_classNames, css.top, top), _defineProperty(_classNames, css.bottom, bottom), _defineProperty(_classNames, css.fixed, fixed), _classNames));
      var backgroundColor = transparent ? null : color ? color : _Css.Colors.material.grey[200].hex;
      return _react2.default.createElement(
        'div',
        _extends({ className: classes, style: { backgroundColor: backgroundColor } }, other),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(css.toolbar, (_classNames2 = {}, _defineProperty(_classNames2, css.center, center), _defineProperty(_classNames2, css.dense, dense), _defineProperty(_classNames2, css.big, big), _classNames2)) },
          _react2.default.Children.map(children, function (child) {
            if (child.type === _ToolbarGroup2.default) {
              return _react2.default.cloneElement(child, {
                dense: dense,
                transparent: transparent
              });
            }
            return child;
          })
        )
      );
    }
  }]);

  return Toolbar;
}(_react.Component);

Toolbar.propTypes = {
  color: _react.PropTypes.string,
  children: _react.PropTypes.node,
  center: _react.PropTypes.bool,
  fixed: _react.PropTypes.bool,
  top: _react.PropTypes.bool,
  bottom: _react.PropTypes.bool,
  transparent: _react.PropTypes.bool,
  dense: _react.PropTypes.bool,
  zDepth: _react.PropTypes.number,
  big: _react.PropTypes.bool
};
Toolbar.defaultProps = {
  zDepth: 0
};
exports.default = Toolbar;
module.exports = exports['default'];

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Css = __webpack_require__(6);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Tooltip = __webpack_require__(207);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  button: 'cio_g1',
  dense: 'cio_g2',
  selected: 'cio_g3',
  disabled: 'cio_g4',
  active: 'cio_g5'
};

var TabButton = function (_Component) {
  _inherits(TabButton, _Component);

  function TabButton() {
    var _ref,
        _arguments = arguments;

    var _temp, _this, _ret;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _classCallCheck(this, TabButton);

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabButton.__proto__ || Object.getPrototypeOf(TabButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: false,
      active: false
    }, _this.getNode = function () {
      return _reactDom2.default.findDOMNode(_this);
    }, _this.handleMouseEnter = function () {
      _this.setState({ hover: true });
    }, _this.handleMouseLeave = function () {
      _this.setState({ hover: false });
    }, _this.handleFocus = function () {
      _this.setState({ active: true });
    }, _this.handleBlur = function () {
      var onBlur = _this.props.onBlur;

      _this.setState({ active: false });
      onBlur && onBlur();
    }, _this.handleTouchTap = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var _this$props = _this.props,
          onTouchTap = _this$props.onTouchTap,
          disabled = _this$props.disabled;

      if (!disabled && onTouchTap) {
        onTouchTap.apply(undefined, _arguments);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TabButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._node = _reactDom2.default.findDOMNode(this);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({ hover: false, active: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          className = _props.className,
          dense = _props.dense,
          disabled = _props.disabled,
          tooltip = _props.tooltip,
          children = _props.children,
          selected = _props.selected,
          other = _objectWithoutProperties(_props, ['className', 'dense', 'disabled', 'tooltip', 'children', 'selected']);

      var _state = this.state,
          hover = _state.hover,
          active = _state.active;

      var classes = (0, _classnames2.default)(css.button, className, (_classNames = {}, _defineProperty(_classNames, css.disabled, disabled), _defineProperty(_classNames, css.active, active), _defineProperty(_classNames, css.selected, selected), _defineProperty(_classNames, css.dense, dense), _classNames));
      var handlers = disabled ? {} : {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onTouchTap: this.handleTouchTap
      };
      return _react2.default.createElement(
        'button',
        _extends({}, other, handlers, { className: classes }),
        children,
        hover && tooltip && _react2.default.createElement(
          _Tooltip2.default,
          { anchorTo: this.getNode },
          tooltip
        )
      );
    }
  }]);

  return TabButton;
}(_react.Component);

TabButton.propTypes = {
  tooltip: _react.PropTypes.node,
  children: _react.PropTypes.node,
  disabled: _react.PropTypes.bool,
  dense: _react.PropTypes.bool,
  onTouchTap: _react.PropTypes.func,
  onBlur: _react.PropTypes.func,
  className: _react.PropTypes.string,
  selected: _react.PropTypes.bool
};
exports.default = TabButton;
module.exports = exports['default'];

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Css = __webpack_require__(6);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  root: 'cio_hq',
  grow: 'cio_hr'
};

var ToolbarTitle = function (_Component) {
  _inherits(ToolbarTitle, _Component);

  function ToolbarTitle() {
    _classCallCheck(this, ToolbarTitle);

    return _possibleConstructorReturn(this, (ToolbarTitle.__proto__ || Object.getPrototypeOf(ToolbarTitle)).apply(this, arguments));
  }

  _createClass(ToolbarTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          grow = _props.grow,
          color = _props.color,
          className = _props.className,
          other = _objectWithoutProperties(_props, ['children', 'grow', 'color', 'className']);

      var style = color ? { color: color } : null;
      var classes = (0, _classnames2.default)(css.root, className, _defineProperty({}, css.grow, grow));
      return _react2.default.createElement(
        'h2',
        { className: classes, style: style },
        children
      );
    }
  }]);

  return ToolbarTitle;
}(_react.Component);

ToolbarTitle.propTypes = {
  children: _react.PropTypes.node,
  color: _react.PropTypes.string,
  className: _react.PropTypes.string,
  grow: _react.PropTypes.bool
};
exports.default = ToolbarTitle;
module.exports = exports['default'];

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _attrAccept = __webpack_require__(381);

var _attrAccept2 = _interopRequireDefault(_attrAccept);

var _Constants = __webpack_require__(32);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  root: 'cio_hy',
  input: 'cio_hz'
};

var Dropzone = function (_Component) {
  _inherits(Dropzone, _Component);

  function Dropzone() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dropzone);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isDragActive: false
    }, _this.onDragLeave = function (e) {
      var _this2 = _this,
          onDragLeave = _this2.onDragLeave;

      e.preventDefault();
      // Only deactivate once the dropzone and all children was left.
      if (--_this.enterCounter > 0) {
        return;
      }

      _this.setState({
        isDragActive: false,
        isDragReject: false
      });

      onDragLeave && onDragLeave();
    }, _this.onDragOver = function (e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }, _this.onDragEnter = function (e) {
      var _this3 = _this,
          onDragEnter = _this3.onDragEnter;

      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
      ++_this.enterCounter;

      // This is tricky. During the drag even the dataTransfer.files is null
      // But Chrome implements some drag store, which is accesible via dataTransfer.items
      var dataTransferItems = e.dataTransfer && e.dataTransfer.items ? e.dataTransfer.items : [];

      // Now we need to convert the DataTransferList to Array
      var allFilesAccepted = _this.allFilesAccepted(Array.prototype.slice.call(dataTransferItems));

      _this.setState({
        isDragActive: allFilesAccepted,
        isDragReject: !allFilesAccepted
      });
      onDragEnter && onDragEnter();
    }, _this.onChange = function (e) {
      _this.processFiles(e.target.files);
    }, _this.onDrop = function (e) {
      e.preventDefault();

      _this.setState({
        isDragActive: false
      });

      var files = void 0;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }

      var maxFiles = _this.props.multiple ? files.length : 1;
      for (var i = 0; i < maxFiles; i++) {
        files[i].preview = URL.createObjectURL(files[i]);
      }

      files = Array.prototype.slice.call(files, 0, maxFiles);
      _this.processFiles(files);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.enterCounter = 0;
    }
  }, {
    key: 'allFilesAccepted',
    value: function allFilesAccepted(files) {
      var _this4 = this;

      return files.every(function (file) {
        return (0, _attrAccept2.default)(file, _this4.props.accept);
      });
    }
  }, {
    key: 'handleFile',
    value: function handleFile(files) {
      var _this5 = this;

      if (files.length < 1) {
        return;
      }
      var current = files.pop();
      if (current) {
        var fileType = current.type;
        var encoded = fileType.indexOf('audio') === 0 || fileType.indexOf('video') === 0;
        SteelCompass.upload([current], {
          encoded: encoded,
          progress: function progress(event) {
            if (_this5.props.onProgress && event) {
              _this5.props.onProgress(_extends({}, event, {
                remaining: files.length
              }));
            }
          },
          error: function error() {
            if (files.length > 0) {
              _this5.handleFile(files);
            }
          },
          success: function success(response) {
            if (response && response.data && _this5.props.onSuccess) {
              _this5.props.onSuccess(response.data);
            }
            if (files.length > 0) {
              _this5.handleFile(files);
            }
          }
        });
      }
    }
  }, {
    key: 'processFiles',
    value: function processFiles(files) {
      var onError = this.props.onError;

      var fileList = Object.keys(files).map(function (key) {
        return files[key];
      });
      var willBeUploaded = fileList.filter(function (file) {
        return file.size < _Constants.maxFileSize;
      });
      var willBeDropped = fileList.filter(function (file) {
        return file.size >= _Constants.maxFileSize;
      });
      if (willBeDropped.length > 0) {
        onError && onError('TOO_BIG', willBeDropped.length);
      }
      if (willBeUploaded.length > 0) {
        this.handleFile(willBeUploaded);
      }
    }
  }, {
    key: 'open',
    value: function open() {
      var fileInput = this.refs.fileInput;

      fileInput.value = null;
      fileInput.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          multiple = _props.multiple,
          accept = _props.accept,
          children = _props.children,
          className = _props.className;

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)(css.root, className),
          onDragLeave: this.onDragLeave,
          onDragOver: this.onDragOver,
          onDragEnter: this.onDragEnter,
          onDrop: this.onDrop
        },
        children,
        _react2.default.createElement('input', {
          className: css.input,
          type: 'file',
          multiple: multiple,
          ref: 'fileInput',
          onChange: this.onChange,
          accept: accept
        })
      );
    }
  }]);

  return Dropzone;
}(_react.Component);

Dropzone.defaultProps = {
  supportClick: true,
  multiple: true
};
Dropzone.propTypes = {
  children: _react.PropTypes.node,
  onProgress: _react.PropTypes.func,
  onError: _react.PropTypes.func,
  onSuccess: _react.PropTypes.func,
  onDragLeave: _react.PropTypes.func,
  onDragEnter: _react.PropTypes.func,
  supportClick: _react.PropTypes.bool,
  accept: _react.PropTypes.string,
  className: _react.PropTypes.string,
  multiple: _react.PropTypes.bool
};
exports.default = Dropzone;
module.exports = exports['default'];

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Css = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  root: 'cio_hC',
  progress: 'cio_hD'
};

var ProgressBar = function (_Component) {
  _inherits(ProgressBar, _Component);

  function ProgressBar() {
    _classCallCheck(this, ProgressBar);

    return _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).apply(this, arguments));
  }

  _createClass(ProgressBar, [{
    key: 'render',
    value: function render() {
      var progress = this.props.progress;

      return _react2.default.createElement(
        'div',
        { className: css.root },
        _react2.default.createElement('div', { className: css.progress, style: { width: Math.round(progress) + '%' } })
      );
    }
  }]);

  return ProgressBar;
}(_react.Component);

ProgressBar.propTypes = {
  progress: _react.PropTypes.number
};
exports.default = ProgressBar;
module.exports = exports['default'];

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Css = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  root: 'cio_hG',
  secondary: 'cio_hH'
};

var ListText = function (_Component) {
  _inherits(ListText, _Component);

  function ListText() {
    _classCallCheck(this, ListText);

    return _possibleConstructorReturn(this, (ListText.__proto__ || Object.getPrototypeOf(ListText)).apply(this, arguments));
  }

  _createClass(ListText, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          secondary = _props.secondary,
          rest = _objectWithoutProperties(_props, ['children', 'className', 'secondary']);

      var classes = (0, _classnames2.default)(css.root, className, _defineProperty({}, css.secondary, secondary));

      return _react2.default.createElement(
        'span',
        _extends({ className: classes }, rest),
        children
      );
    }
  }]);

  return ListText;
}(_react.Component);

ListText.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  secondary: _react.PropTypes.bool
};
exports.default = ListText;
module.exports = exports['default'];

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Css = __webpack_require__(46);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Tooltip = __webpack_require__(207);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  button: 'cio_fO',
  disabled: 'cio_fP'
};

var IconButton = function (_Component) {
  _inherits(IconButton, _Component);

  function IconButton() {
    var _ref,
        _arguments = arguments;

    var _temp, _this, _ret;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _classCallCheck(this, IconButton);

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconButton.__proto__ || Object.getPrototypeOf(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: false,
      active: false
    }, _this.getNode = function () {
      return _reactDom2.default.findDOMNode(_this);
    }, _this.handleMouseEnter = function () {
      _this.setState({ hover: true });
    }, _this.handleMouseLeave = function () {
      _this.setState({ hover: false });
    }, _this.handleFocus = function () {
      _this.setState({ active: true });
    }, _this.handleBlur = function () {
      var onBlur = _this.props.onBlur;

      _this.setState({ active: false });
      onBlur && onBlur();
    }, _this.handleTouchTap = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var _this$props = _this.props,
          onTouchTap = _this$props.onTouchTap,
          disabled = _this$props.disabled;

      if (!disabled && onTouchTap) {
        onTouchTap.apply(undefined, _arguments);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IconButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._node = _reactDom2.default.findDOMNode(this);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({ hover: false, active: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          className = _props.className,
          dense = _props.dense,
          disabled = _props.disabled,
          tooltip = _props.tooltip,
          children = _props.children,
          icon = _props.icon,
          verbose = _props.verbose,
          hoverIcon = _props.hoverIcon,
          other = _objectWithoutProperties(_props, ['className', 'dense', 'disabled', 'tooltip', 'children', 'icon', 'verbose', 'hoverIcon']);

      var _state = this.state,
          hover = _state.hover,
          active = _state.active;

      var classes = (0, _classnames2.default)(css.button, className, (_classNames = {}, _defineProperty(_classNames, css.disabled, disabled), _defineProperty(_classNames, css.active, active), _defineProperty(_classNames, css.dense, dense), _classNames));
      var handlers = disabled ? {} : {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onTouchTap: this.handleTouchTap
      };
      return _react2.default.createElement(
        'button',
        _extends({}, other, handlers, { className: classes }),
        hover || active ? hoverIcon : icon,
        (hover || active) && tooltip && _react2.default.createElement(
          _Tooltip2.default,
          { anchorTo: this.getNode },
          tooltip
        )
      );
    }
  }]);

  return IconButton;
}(_react.Component);

IconButton.propTypes = {
  tooltip: _react.PropTypes.node,
  children: _react.PropTypes.node,
  disabled: _react.PropTypes.bool,
  dense: _react.PropTypes.bool,
  onTouchTap: _react.PropTypes.func,
  onBlur: _react.PropTypes.func,
  className: _react.PropTypes.string,
  selected: _react.PropTypes.bool,
  icon: _react.PropTypes.node,
  hoverIcon: _react.PropTypes.node
};
exports.default = IconButton;
module.exports = exports['default'];

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _IconButton2 = __webpack_require__(654);

var _IconButton3 = _interopRequireDefault(_IconButton2);

var _Portal = __webpack_require__(415);

var _Portal2 = _interopRequireDefault(_Portal);

var _Menu = __webpack_require__(2381);

var _Menu2 = _interopRequireDefault(_Menu);

var _reactMotion = __webpack_require__(203);

var _Css = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  root: 'cio_fV',
  menu: 'cio_fW',
  button: 'cio_fX'
};

var MenuButton = function (_IconButton) {
  _inherits(MenuButton, _IconButton);

  function MenuButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      menu: false
    }, _this.handleTouchTap = function () {
      _this.setState({ menu: !_this.state.menu });
    }, _this.handleMenuClose = function () {
      _this.setState({ menu: false });
    }, _this.handleKeyPress = function (event) {
      var keyCode = event.keyCode;

      if (keyCode === 0 || keyCode === 32 || keyCode == 13) {
        _this.handleTouchTap(event);
        event.preventDefault();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          dense = _props.dense,
          children = _props.children,
          icon = _props.icon,
          other = _objectWithoutProperties(_props, ['dense', 'children', 'icon']);

      var menu = this.state.menu;

      return _react2.default.createElement(
        'div',
        { className: css.root },
        _react2.default.createElement(
          _reactMotion.Motion,
          { style: { progress: (0, _reactMotion.spring)(menu ? 1 : 0) } },
          function (interpolated) {
            var progress = interpolated.progress;

            if (progress > 0) {
              return _react2.default.createElement(
                _Menu2.default,
                {
                  padded: true,
                  onRequestClose: _this2.handleMenuClose,
                  className: css.menu,
                  style: {
                    width: 256,
                    opacity: progress
                  }
                },
                children
              );
            }
            return null;
          }
        ),
        _react2.default.createElement(
          _IconButton3.default,
          _extends({}, other, {
            className: css.button,
            onKeyPress: this.handleKeyPress,
            onTouchTap: this.handleTouchTap,
            onClick: this.handleClick
          }),
          icon
        )
      );
    }
  }]);

  return MenuButton;
}(_IconButton3.default);

MenuButton.propTypes = {
  disabled: _react.PropTypes.bool,
  dense: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  icon: _react.PropTypes.node,
  onTouchTap: _react.PropTypes.func
};
exports.default = MenuButton;
module.exports = exports['default'];

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = exports.MenuItem = undefined;

var _Menu2 = __webpack_require__(2382);

var _Menu3 = _interopRequireDefault(_Menu2);

var _MenuItem2 = __webpack_require__(2383);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MenuItem = _MenuItem3.default;
var Menu = exports.Menu = _Menu3.default;
exports.default = _Menu3.default;

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Css = __webpack_require__(6);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ESC = 27;

var css = {
  root: 'cio_gC',
  padded: 'cio_gD'
};

var Menu = function (_Component) {
  _inherits(Menu, _Component);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.onMenuItemTap = function (furtherTap, payload, label, event) {
      var _this$props = _this.props,
          onMenuItemTap = _this$props.onMenuItemTap,
          disabled = _this$props.disabled;

      if (disabled) {
        return;
      }
      if (furtherTap) {
        furtherTap(payload, label);
      }
      onMenuItemTap && onMenuItemTap(payload, label);
      if (_this.props.onRequestClose) {
        _this.props.onRequestClose();
      }
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, _this.handleKey = function (event) {
      var keyCode = event.keyCode;
      var _this$props2 = _this.props,
          onRequestClose = _this$props2.onRequestClose,
          disabled = _this$props2.disabled;

      if (disabled) {
        return;
      }
      onRequestClose && keyCode === ESC && onRequestClose();
    }, _this.onBodyTouchStart = function (event) {
      if (!_this.isDescendant(_this._node, event.target)) {
        if (_this.props.onRequestClose) {
          _this.props.onRequestClose();
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Menu, [{
    key: 'isDescendant',
    value: function isDescendant(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          closeOnEsc = _props.closeOnEsc,
          onRequestClose = _props.onRequestClose;

      if (onRequestClose) {
        this._node = _reactDom2.default.findDOMNode(this);
        document.body.addEventListener('touchstart', this.onBodyTouchStart);
        document.body.addEventListener('mousedown', this.onBodyTouchStart);
      }
      if (closeOnEsc) {
        document.addEventListener('keyup', this.handleKey);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.removeEventListener('touchstart', this.onBodyTouchStart);
      document.body.removeEventListener('mousedown', this.onBodyTouchStart);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          children = _props2.children,
          padded = _props2.padded,
          className = _props2.className,
          closeOnEsc = _props2.closeOnEsc,
          other = _objectWithoutProperties(_props2, ['children', 'padded', 'className', 'closeOnEsc']);

      var classes = (0, _classnames2.default)(className, css.root, _defineProperty({}, css.padded, padded));
      return _react2.default.createElement(
        'div',
        _extends({}, other, { className: classes }),
        _react2.default.Children.map(children, function (child) {
          return _react2.default.cloneElement(child, { onTouchTap: _this2.onMenuItemTap.bind(_this2, child.props.onTouchTap) });
        })
      );
    }
  }]);

  return Menu;
}(_react.Component);

Menu.propTypes = {
  children: _react.PropTypes.node,
  closeOnEsc: _react.PropTypes.bool,
  disabled: _react.PropTypes.bool,
  padded: _react.PropTypes.bool,
  onMenuItemTap: _react.PropTypes.func,
  className: _react.PropTypes.string,
  onRequestClose: _react.PropTypes.func
};
Menu.defaultProps = {
  closeOnEsc: true,
  padded: true
};
exports.default = Menu;
module.exports = exports['default'];

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Css = __webpack_require__(6);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  icon: 'cio_gE',
  root: 'cio_gF',
  dense: 'cio_gG'
};

var MenuItem = function (_Component) {
  _inherits(MenuItem, _Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: false,
      hasFocus: false
    }, _this.handleMouseEnter = function () {
      var disabled = _this.props.disabled;

      if (!disabled) {
        _this.setState({ hover: true });
      }
    }, _this.handleMouseLeave = function () {
      var disabled = _this.props.disabled;

      if (!disabled) {
        _this.setState({ hover: false });
      }
    }, _this.handleTouchTap = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          payload = _this$props.payload,
          label = _this$props.label,
          onTouchTap = _this$props.onTouchTap,
          href = _this$props.href;

      if (!disabled && onTouchTap) {
        event.preventDefault();
        event.stopPropagation();
        if (href) {
          onTouchTap(href, label, event);
        } else {
          onTouchTap(payload, label, event);
        }
      }
    }, _this.handleClick = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }, _this.handleFocus = function () {
      if (!_this.state.hasFocus) {
        _this.setState({ hasFocus: true });
      }
    }, _this.handleBlur = function () {
      if (_this.state.hasFocus) {
        _this.setState({ hasFocus: false });
      }
    }, _this.handleKeyPress = function (event) {
      var keyCode = event.keyCode;

      if (keyCode === 0 || keyCode === 32 || keyCode == 13) {
        _this.handleTouchTap(event);
        event.preventDefault();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autoFocus) {
        this._timer = setTimeout(function () {
          _reactDom2.default.findDOMNode(_this2).focus();
        }, 200);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._timer) {
        clearTimeout(this._timer);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          payload = _props.payload,
          divider = _props.divider,
          children = _props.children,
          icon = _props.icon,
          dense = _props.dense,
          href = _props.href,
          label = _props.label,
          className = _props.className,
          other = _objectWithoutProperties(_props, ['disabled', 'payload', 'divider', 'children', 'icon', 'dense', 'href', 'label', 'className']);

      var iconElement = void 0;
      var tabIndex = void 0;
      if (icon) {
        iconElement = _react2.default.cloneElement(icon, { className: styles.icon });
      }
      var rootClasses = (0, _classnames2.default)(styles.root, className, _defineProperty({}, styles.dense, dense));

      if (!disabled) {
        tabIndex = 0;
      }
      var props = _extends({}, other, {
        onTouchTap: this.handleTouchTap,
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onKeyPress: this.handleKeyPress,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        tabIndex: tabIndex,
        className: rootClasses
      });

      var containerElement = href ? disabled ? 'span' : 'a' : 'div';
      return _react2.default.createElement(containerElement, props, iconElement, label, children);
    }
  }]);

  return MenuItem;
}(_react.Component);

MenuItem.propTypes = {
  payload: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string, _react.PropTypes.bool, _react.PropTypes.number, _react.PropTypes.array]),
  disabled: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  dense: _react.PropTypes.bool,
  href: _react.PropTypes.string,
  active: _react.PropTypes.bool,
  icon: _react.PropTypes.node,
  label: _react.PropTypes.node,
  divider: _react.PropTypes.bool,
  autoFocus: _react.PropTypes.bool,
  onTouchTap: _react.PropTypes.func,
  style: _react.PropTypes.object,
  children: _react.PropTypes.node
};
exports.default = MenuItem;
module.exports = exports['default'];

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ActionButton = __webpack_require__(655);

var _ActionButton2 = _interopRequireDefault(_ActionButton);

var _PrimaryAdd = __webpack_require__(2385);

var _PrimaryAdd2 = _interopRequireDefault(_PrimaryAdd);

var _reactMotion = __webpack_require__(203);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  root: 'cio_fY',
  dropDown: 'cio_fZ'
};

var RollDownButton = function (_Component) {
  _inherits(RollDownButton, _Component);

  function RollDownButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RollDownButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RollDownButton.__proto__ || Object.getPrototypeOf(RollDownButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RollDownButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var open = this.state.open;
      var children = this.props.children;

      return _react2.default.createElement(
        _reactMotion.Motion,
        { style: { progress: (0, _reactMotion.spring)(open ? 1 : 0, { stiffness: 300, damping: 25 }), open: (0, _reactMotion.spring)(open ? 1 : 0) } },
        function (interpolated) {
          return _react2.default.createElement(
            'div',
            { className: css.root },
            _react2.default.createElement(
              _ActionButton2.default,
              {
                toggled: open,
                onTouchTap: function onTouchTap() {
                  return _this2.setState({ open: !_this2.state.open });
                }
              },
              _react2.default.createElement(_PrimaryAdd2.default, { style: { transform: 'rotate(' + Math.floor(interpolated.progress * 135) + 'deg)' } })
            ),
            interpolated.progress > 0 ? _react2.default.createElement(
              'div',
              { className: css.dropDown, style: { top: interpolated.progress * 64 } },
              _react2.default.Children.map(children, function (child, index) {
                return _react2.default.cloneElement(child, {
                  style: { left: 0, position: 'absolute', top: index * interpolated.progress * 56 }
                });
              })
            ) : null
          );
        }
      );
    }
  }]);

  return RollDownButton;
}(_react.Component);

RollDownButton.propTypes = {
  children: _react.PropTypes.node
};
exports.default = RollDownButton;
module.exports = exports['default'];

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = __webpack_require__(164);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrimaryAddIcon = function (_Component) {
  _inherits(PrimaryAddIcon, _Component);

  function PrimaryAddIcon() {
    _classCallCheck(this, PrimaryAddIcon);

    return _possibleConstructorReturn(this, (PrimaryAddIcon.__proto__ || Object.getPrototypeOf(PrimaryAddIcon)).apply(this, arguments));
  }

  _createClass(PrimaryAddIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          rest = _objectWithoutProperties(_props, ['color']);

      return _react2.default.createElement(
        _SvgIcon2.default,
        rest,
        _react2.default.createElement(
          'g',
          { transform: 'translate(2, 2)', strokeWidth: '2', stroke: color },
          _react2.default.createElement('path', { d: 'M10,0 L10,20' }),
          _react2.default.createElement('path', { d: 'M20,10 L0,10' })
        )
      );
    }
  }]);

  return PrimaryAddIcon;
}(_react.Component);

PrimaryAddIcon.propTypes = {
  children: _react.PropTypes.node,
  color: _react.PropTypes.string
};
PrimaryAddIcon.defaultProps = {
  viewPortSize: 24
};
exports.default = PrimaryAddIcon;
module.exports = exports['default'];

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Css = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  root: 'cio_fH',
  secondary: 'cio_fI',
  disabled: 'cio_fJ'
};

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTap = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onTouchTap = _this$props.onTouchTap;

      !disabled && onTouchTap && onTouchTap(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          secondary = _props.secondary,
          disabled = _props.disabled,
          label = _props.label,
          rest = _objectWithoutProperties(_props, ['className', 'children', 'secondary', 'disabled', 'label']);

      var classes = (0, _classnames2.default)(className, css.root, (_classNames = {}, _defineProperty(_classNames, css.disabled, disabled), _defineProperty(_classNames, css.secondary, secondary), _classNames));
      return _react2.default.createElement(
        'button',
        _extends({ className: classes, disabled: disabled }, rest),
        label,
        children
      );
    }
  }]);

  return Button;
}(_react.Component);

Button.propTypes = {
  children: _react.PropTypes.node,
  label: _react.PropTypes.node,
  disabled: _react.PropTypes.bool,
  secondary: _react.PropTypes.bool,
  onTouchTap: _react.PropTypes.func,
  className: _react.PropTypes.string
};
exports.default = Button;
module.exports = exports['default'];

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Css = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = {
  root: 'cio_fK',
  padded: 'cio_fL',
  bigPadded: 'cio_fM',
  fullWidth: 'cio_fN'
};

var ButtonGroup = function (_Component) {
  _inherits(ButtonGroup, _Component);

  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);

    return _possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).apply(this, arguments));
  }

  _createClass(ButtonGroup, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          fullWidth = _props.fullWidth,
          children = _props.children,
          className = _props.className,
          padded = _props.padded,
          bigPadded = _props.bigPadded,
          rest = _objectWithoutProperties(_props, ['fullWidth', 'children', 'className', 'padded', 'bigPadded']);

      var classes = (0, _classnames2.default)(css.root, className, (_classNames = {}, _defineProperty(_classNames, css.fullWidth, fullWidth), _defineProperty(_classNames, css.padded, [padded]), _defineProperty(_classNames, css.bigPadded, [bigPadded]), _classNames));
      return _react2.default.createElement(
        'div',
        _extends({ className: classes }, rest),
        children
      );
    }
  }]);

  return ButtonGroup;
}(_react.Component);

ButtonGroup.propTypes = {
  children: _react.PropTypes.node,
  fullWidth: _react.PropTypes.bool,
  padded: _react.PropTypes.bool,
  bigPadded: _react.PropTypes.bool,
  className: _react.PropTypes.string
};
exports.default = ButtonGroup;
module.exports = exports['default'];

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(8);

var _classnames2 = _interopRequireDefault(_classnames);

var _Css = __webpack_require__(46);

var _Css2 = _interopRequireDefault(_Css);

var _CSSPropertyOperations = __webpack_require__(74);

var _CSSPropertyOperations2 = _interopRequireDefault(_CSSPropertyOperations);

var _Portal = __webpack_require__(415);

var _Portal2 = _interopRequireDefault(_Portal);

var _reactMotion = __webpack_require__(203);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Units = _Css2.default.Units,
    Shadow = _Css2.default.Shadow,
    Colors = _Css2.default.Colors;


var css = {
  root: 'cio_f8',
  container: 'cio_f9',
  padded: 'cio_f_',
  overlay: 'cio_f-',
  dialog: 'cio_ga',
  fullWidth: 'cio_hI'
};

var ESC = 27;

var Dialog = function (_Component) {
  _inherits(Dialog, _Component);

  function Dialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call.apply(_ref, [this].concat(args))), _this), _this.reset = function (props) {
      var open = props.open;


      if (!open) {
        _CSSPropertyOperations2.default.setValueForStyles(document.body, { overflow: _this._overflow });
      } else {
        _CSSPropertyOperations2.default.setValueForStyles(document.body, { overflow: 'hidden' });
      }
    }, _this.handleKey = function (event) {
      var keyCode = event.keyCode;

      if (keyCode === ESC) {
        _this.requestClose();
      }
    }, _this.requestClose = function () {
      var onRequestClose = _this.props.onRequestClose;

      onRequestClose && onRequestClose();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dialog, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._overflow = document.body.style.overflow;
      document.addEventListener('keyup', this.handleKey);
      this.reset(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.reset(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keyup', this.handleKey);
      this.reset({ open: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          padded = _props.padded,
          fullWidth = _props.fullWidth,
          children = _props.children,
          open = _props.open;

      return _react2.default.createElement(
        _reactMotion.Motion,
        { style: _defineProperty({ opacity: (0, _reactMotion.spring)(open ? 1 : 0) }, 'opacity', (0, _reactMotion.spring)(open ? 1 : 0, { stiffness: 300, damping: 25 })) },
        function (interpolated) {
          var opacity = interpolated.opacity;

          if (opacity > 0) {
            return _react2.default.createElement(
              _Portal2.default,
              null,
              _react2.default.createElement(
                'div',
                { className: css.root },
                _react2.default.createElement('div', { className: css.overlay, onTouchTap: _this2.requestClose, style: { opacity: opacity } }),
                _react2.default.createElement(
                  'div',
                  { className: (0, _classnames2.default)(css.dialog, _defineProperty({}, css.fullWidth, fullWidth)), style: { opacity: opacity, transform: 'translateY(-' + (64 - 64 * opacity) + 'px)' } },
                  _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(css.container, padded && css.padded) },
                    children
                  )
                )
              )
            );
          }
          return null;
        }
      );
    }
  }]);

  return Dialog;
}(_react.Component);

Dialog.propTypes = {
  onRequestClose: _react.PropTypes.func,
  children: _react.PropTypes.node,
  open: _react.PropTypes.bool,
  onDismiss: _react.PropTypes.func,
  padded: _react.PropTypes.bool,
  fullWidth: _react.PropTypes.bool
};
exports.default = Dialog;
module.exports = exports['default'];

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = __webpack_require__(164);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _Css = __webpack_require__(46);

var _css = __webpack_require__(194);

var _css2 = _interopRequireDefault(_css);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Delete = function (_Component) {
  _inherits(Delete, _Component);

  function Delete() {
    _classCallCheck(this, Delete);

    return _possibleConstructorReturn(this, (Delete.__proto__ || Object.getPrototypeOf(Delete)).apply(this, arguments));
  }

  _createClass(Delete, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _SvgIcon2.default,
        _extends({}, this.props, { className: _css2.default.inheritFill }),
        _react2.default.createElement(
          'g',
          { stroke: 'none', strokeWidth: '1', fillRule: 'evenodd' },
          _react2.default.createElement('rect', { x: '5', y: '7', width: '2', height: '6' }),
          _react2.default.createElement('rect', { x: '9', y: '7', width: '2', height: '6' }),
          _react2.default.createElement('path', { d: 'M12,1 C12,0.4 11.6,0 11,0 L5,0 C4.4,0 4,0.4 4,1 L4,3 L0,3 L0,5 L1,5 L1,15 C1,15.6 1.4,16 2,16 L14,16 C14.6,16 15,15.6 15,15 L15,5 L16,5 L16,3 L12,3 L12,1 L12,1 Z M6,2 L10,2 L10,3 L6,3 L6,2 L6,2 Z M13,5 L13,14 L3,14 L3,5 L13,5 L13,5 Z' })
        )
      );
    }
  }]);

  return Delete;
}(_react.Component);

Delete.defaultProps = {
  size: 16
};
exports.default = Delete;
module.exports = exports['default'];

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = __webpack_require__(164);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _Css = __webpack_require__(46);

var _css = __webpack_require__(194);

var _css2 = _interopRequireDefault(_css);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Eye = function (_Component) {
  _inherits(Eye, _Component);

  function Eye() {
    _classCallCheck(this, Eye);

    return _possibleConstructorReturn(this, (Eye.__proto__ || Object.getPrototypeOf(Eye)).apply(this, arguments));
  }

  _createClass(Eye, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _SvgIcon2.default,
        _extends({}, this.props, { className: _css2.default.inheritFill }),
        _react2.default.createElement(
          'g',
          { stroke: 'none', strokeWidth: '1', fillRule: 'evenodd', transform: 'translate(0, 2)' },
          _react2.default.createElement('path', { d: 'M8,12 C12.707,12 15.744,6.716 15.871,6.492 C16.042,6.188 16.043,5.816 15.872,5.512 C15.746,5.287 12.731,0 8,0 C3.245,0 0.251,5.289 0.126,5.514 C-0.043,5.817 -0.042,6.186 0.128,6.489 C0.254,6.713 3.269,12 8,12 Z M8,2 C10.839,2 13.036,4.835 13.818,6 C13.034,7.166 10.837,10 8,10 C5.159,10 2.962,7.162 2.181,5.999 C2.958,4.835 5.146,2 8,2 Z' }),
          _react2.default.createElement('circle', { cx: '8', cy: '6', r: '2' })
        )
      );
    }
  }]);

  return Eye;
}(_react.Component);

Eye.defaultProps = {
  size: 16
};
exports.default = Eye;
module.exports = exports['default'];

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = __webpack_require__(164);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _Css = __webpack_require__(46);

var _css = __webpack_require__(194);

var _css2 = _interopRequireDefault(_css);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit() {
    _classCallCheck(this, Edit);

    return _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).apply(this, arguments));
  }

  _createClass(Edit, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _SvgIcon2.default,
        _extends({}, this.props, { className: _css2.default.inheritFill }),
        _react2.default.createElement(
          'g',
          { stroke: 'none', strokeWidth: '1', fillRule: 'evenodd' },
          _react2.default.createElement('path', { d: 'M0.75,9 L3,9 C3.225,9 3.375,8.925 3.525,8.775 L8.775,3.525 C9.075,3.225 9.075,2.775 8.775,2.475 L6.525,0.225 C6.225,-0.075 5.775,-0.075 5.475,0.225 L0.225,5.475 C0.075,5.625 0,5.775 0,6 L0,8.25 C0,8.7 0.3,9 0.75,9 Z M1.5,6.3 L6,1.8 L7.2,3 L2.7,7.5 L1.5,7.5 L1.5,6.3 Z' }),
          _react2.default.createElement('rect', { x: '0', y: '10.5', width: '12', height: '1.5' })
        )
      );
    }
  }]);

  return Edit;
}(_react.Component);

Edit.defaultProps = {
  size: 16
};
exports.default = Edit;
module.exports = exports['default'];

/***/ }),
/* 2392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageModule__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cio__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_cio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_PageLayout__ = __webpack_require__(340);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['Drop a video here'],['Drop a video here']),_templateObject2=_taggedTemplateLiteral(['You can also ',', browse your ',' or ',' one.'],['You can also ',', browse your ',' or ',' one.']),_templateObject3=_taggedTemplateLiteral(['upload'],['upload']),_templateObject4=_taggedTemplateLiteral(['library'],['library']),_templateObject5=_taggedTemplateLiteral(['embed'],['embed']),_templateObject6=_taggedTemplateLiteral(['Write a caption...'],['Write a caption...']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var videoCss={video:'_hb'};var VideoModuleEditor=function(_Component){_inherits(VideoModuleEditor,_Component);function VideoModuleEditor(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VideoModuleEditor);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VideoModuleEditor.__proto__||Object.getPrototypeOf(VideoModuleEditor)).call.apply(_ref,[this].concat(args))),_this),_this.state={progress:0},_this.attach=function(data){},_this.changeCaption=function(caption){var id=_this.props.id;__WEBPACK_IMPORTED_MODULE_5_actions_PageLayout__["a" /* default */].changePageModuleData({id:id,data:{caption:caption}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VideoModuleEditor,[{key:'render',value:function render(){var _this2=this;var _props=this.props,sources=_props.sources,caption=_props.caption,other=_objectWithoutProperties(_props,['sources','caption']);var progress=50;var uploading=false;var hasSources=sources.length>0;if(uploading>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PageModule__["a" /* default */],other,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].panel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].progress},Math.round(progress)+'%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_cio__["ProgressBar"],{progress:progress})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PageModule__["a" /* default */],other,!hasSources&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_cio__["DropZone"],{accept:'video/*',ref:'dropZone',onProgress:function onProgress(event){return _this2.setState({progress:event.percent});},onSuccess:this.attach},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].panel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject)),Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject2,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onTouchTap:function onTouchTap(){return console.log('wut');}},Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject4)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject5))))),hasSources&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{controls:true,className:videoCss.video},sources.map(function(source){var extension=source.data.split('.').pop();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:source.data,type:'video/'+extension,key:extension});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_cio__["TextField"],{placeholder:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject6),value:caption,onChange:this.changeCaption})));}}]);return VideoModuleEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);VideoModuleEditor.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (VideoModuleEditor);

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = __webpack_require__(164);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _Css = __webpack_require__(46);

var _css = __webpack_require__(194);

var _css2 = _interopRequireDefault(_css);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Video = function (_Component) {
  _inherits(Video, _Component);

  function Video() {
    _classCallCheck(this, Video);

    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
  }

  _createClass(Video, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _SvgIcon2.default,
        _extends({}, this.props, { className: _css2.default.inheritStroke }),
        _react2.default.createElement(
          'g',
          { transform: 'translate(1, 3)', strokeWidth: '2', fill: 'none' },
          _react2.default.createElement('path', { d: 'M30,3 L30,23 C30,24.7 28.7,26 27,26 L3,26 C1.3,26 0,24.7 0,23 L0,3 C0,1.3 1.3,0 3,0 L27,0 C28.7,0 30,1.3 30,3 Z' }),
          _react2.default.createElement('rect', { x: '4', y: '4', width: '22', height: '18' }),
          _react2.default.createElement('polygon', { points: '12 9 18 13 12 17' })
        )
      );
    }
  }]);

  return Video;
}(_react.Component);

Video.defaultProps = {
  size: 32
};
exports.default = Video;
module.exports = exports['default'];

/***/ }),
/* 2394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageModule__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edit_EmbedModuleEditor__ = __webpack_require__(2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cio_lib_Assets_Embed__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cio_lib_Assets_Embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_cio_lib_Assets_Embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IFrameEmbedder__ = __webpack_require__(2396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_PageModule__ = __webpack_require__(238);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var videoCss={center:'_gk'};var EmbedModule=function(_Component){_inherits(EmbedModule,_Component);function EmbedModule(){_classCallCheck(this,EmbedModule);return _possibleConstructorReturn(this,(EmbedModule.__proto__||Object.getPrototypeOf(EmbedModule)).apply(this,arguments));}_createClass(EmbedModule,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,editor=_props.editor,sources=_props.sources,id=_props.id;if(editor&&sources.length<1){__WEBPACK_IMPORTED_MODULE_6_actions_PageModule__["a" /* default */].changePageModuleMode(id,'edit');}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.editor&&!nextProps.editor){__WEBPACK_IMPORTED_MODULE_6_actions_PageModule__["a" /* default */].changePageModuleMode(this.props.id,'detail');}}},{key:'render',value:function render(){var _props2=this.props,sources=_props2.sources,mode=_props2.mode,other=_objectWithoutProperties(_props2,['sources','mode']);var source=sources[0]||{};if(mode==='edit'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Edit_EmbedModuleEditor__["a" /* default */],Object.assign({icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_cio_lib_Assets_Embed___default.a,null)},this.props));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PageModule__["a" /* default */],other,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:videoCss.center},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__IFrameEmbedder__["a" /* default */],{provider:source.provider,data:source.data})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',null,source.caption));}}]);return EmbedModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EmbedModule.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (EmbedModule);

/***/ }),
/* 2395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageModule__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cio__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_cio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions_PageLayout__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions_PageModule__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Util_Media__ = __webpack_require__(374);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['Embed external content'],['Embed external content']),_templateObject2=_taggedTemplateLiteral(['Include content from a number of popular services like YouTube, Slideshare, Typeform and more.'],['Include content from a number of popular services like YouTube, Slideshare, Typeform and more.']),_templateObject3=_taggedTemplateLiteral(['Paste embed code...'],['Paste embed code...']),_templateObject4=_taggedTemplateLiteral(['Write a caption...'],['Write a caption...']),_templateObject5=_taggedTemplateLiteral(['Embed'],['Embed']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EmbedModuleEditor=function(_Component){_inherits(EmbedModuleEditor,_Component);function EmbedModuleEditor(){_classCallCheck(this,EmbedModuleEditor);var _this=_possibleConstructorReturn(this,(EmbedModuleEditor.__proto__||Object.getPrototypeOf(EmbedModuleEditor)).apply(this,arguments));_initialiseProps.call(_this);var source=_this.props.sources[0]||{};if(source.provider>0&&source.provider<7){_this.state={url:__WEBPACK_IMPORTED_MODULE_7_Util_Media__["a" /* default */].getUrlFromProvider({provider:source.provider,id:source.data})};}else{_this.state={url:source.data};}return _this;}_createClass(EmbedModuleEditor,[{key:'render',value:function render(){var _props=this.props,sources=_props.sources,other=_objectWithoutProperties(_props,['sources']);var source=sources[0]||{};var url=this.state.url;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PageModule__["a" /* default */],Object.assign({i:true},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].panel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_cio__["Text"],{secondary:true},Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].pad},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_cio__["TextArea"],{fullWidth:true,placeholder:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject3),value:url,onChange:this.changeEmbed})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].pad},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_cio__["TextField"],{placeholder:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject4),value:source.caption,onChange:this.changeCaption})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__css__["a" /* default */].pad},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_cio__["Button"],{label:Object(__WEBPACK_IMPORTED_MODULE_3_oxygen_i18n__["translate"])(_templateObject5),onTouchTap:this.detailMode}))));}}]);return EmbedModuleEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EmbedModuleEditor.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,sources:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number};var _initialiseProps=function _initialiseProps(){var _this2=this;this.changeCaption=function(caption){var _props2=_this2.props,sources=_props2.sources,id=_props2.id;var _sources=_slicedToArray(sources,1),source=_sources[0];__WEBPACK_IMPORTED_MODULE_5_actions_PageLayout__["a" /* default */].changePageModuleData({id:id,data:{params:{caption:[caption]},sources:[Object.assign({},source,{caption:caption})]}});};this.changeEmbed=function(embed){var _props3=_this2.props,sources=_props3.sources,id=_props3.id;var _sources2=_slicedToArray(sources,1),source=_sources2[0];var recognized=__WEBPACK_IMPORTED_MODULE_7_Util_Media__["a" /* default */].getProviderFromUrl(embed);_this2.setState({url:embed});__WEBPACK_IMPORTED_MODULE_5_actions_PageLayout__["a" /* default */].changePageModuleData({id:id,data:{sources:[Object.assign({},source,{data:recognized.id,provider:recognized.provider})]}});};this.detailMode=function(){var id=_this2.props.id;__WEBPACK_IMPORTED_MODULE_6_actions_PageModule__["a" /* default */].changePageModuleMode(id,'detail');__WEBPACK_IMPORTED_MODULE_5_actions_PageLayout__["a" /* default */].savePageModule(id);};};/* harmony default export */ __webpack_exports__["a"] = (EmbedModuleEditor);

/***/ }),
/* 2396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util_Media__ = __webpack_require__(374);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IFrameEmbedder=function(_Component){_inherits(IFrameEmbedder,_Component);function IFrameEmbedder(){_classCallCheck(this,IFrameEmbedder);return _possibleConstructorReturn(this,(IFrameEmbedder.__proto__||Object.getPrototypeOf(IFrameEmbedder)).apply(this,arguments));}_createClass(IFrameEmbedder,[{key:'render',value:function render(){var _props=this.props,provider=_props.provider,data=_props.data;if(provider>0&&provider<8){var url=__WEBPACK_IMPORTED_MODULE_1_Util_Media__["a" /* default */].getUrlFromProvider({provider:provider,id:data});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{width:730,height:730/1920*1080,src:url,allowTransparency:true,frameBorder:0,webkitAllowFullScreen:true,mozAllowFullScreen:true,allowFullSreen:true,oAllowFullScreen:true,msAllowFullScreen:true});}else if(provider===8){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:data}}));}return null;}}]);return IFrameEmbedder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);IFrameEmbedder.propTypes={provider:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,data:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number])};/* harmony default export */ __webpack_exports__["a"] = (IFrameEmbedder);

/***/ }),
/* 2397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_debounce__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oxygen_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_oxygen_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_PageModule__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Material_DropDown__ = __webpack_require__(199);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={root:{background:'#f5f5f5',display:'flex',justifyContent:'center',flexDirection:'column',alignItems:'center',marginBottom:40},editContainer:{background:'#f5f5f5',display:'flex',justifyContent:'center',flexDirection:'column',alignItems:'center',margin:40},fullScreen:{position:'fixed',left:0,right:0,bottom:0,top:0},box:{position:'absolute',left:0,right:0,top:0,bottom:0},webinarTitle:{textAlign:'center',fontSize:25,marginTop:15},input:{width:'100%'},dropdown:{display:'flex',alignSelf:'baseline',height:'100px'},webinarDescription:{textAlign:'center',fontSize:15,marginTop:15,marginBottom:30},enter:{width:'65%',marginBottom:15}};var WebinarModule=function(_mixin){_inherits(WebinarModule,_mixin);function WebinarModule(props){_classCallCheck(this,WebinarModule);var _this=_possibleConstructorReturn(this,(WebinarModule.__proto__||Object.getPrototypeOf(WebinarModule)).call(this,props));_this.saveCaption=__WEBPACK_IMPORTED_MODULE_3_oxygen_debounce___default()(function(){var moduleId=_this.props.moduleId;var _this$state=_this.state,description=_this$state.description,roomName=_this$state.roomName,isWebinar=_this$state.isWebinar;__WEBPACK_IMPORTED_MODULE_1_actions__["f" /* CourseActions */].updatePageModule(_this.props.moduleId,{id:moduleId,params:{caption:{main:description,name:roomName,isWebinar:isWebinar}}});},1000);var caption=props.params.caption;_this.state={description:caption&&caption.main||'',roomName:caption&&caption.name||'',zroom:null,zroomUrl:null,fullScreen:false,isWebinar:caption?caption.isWebinar:true};return _this;}_createClass(WebinarModule,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_2_stores__["s" /* SettingsStore */]);this.listenToStore(__WEBPACK_IMPORTED_MODULE_2_stores__["B" /* WebinarStore */]);}},{key:'componentWillMount',value:function componentWillMount(){if(_get(WebinarModule.prototype.__proto__||Object.getPrototypeOf(WebinarModule.prototype),'componentWillMount',this)){_get(WebinarModule.prototype.__proto__||Object.getPrototypeOf(WebinarModule.prototype),'componentWillMount',this).call(this);}__WEBPACK_IMPORTED_MODULE_1_actions__["y" /* SettingsActions */].read();}},{key:'listenToActions',value:function listenToActions(){var _this2=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_1_actions__["y" /* SettingsActions */].readComplete,function(data){_this2.setState({zroom:data.zroom,userEmail:data.email});});this.listenToAction(__WEBPACK_IMPORTED_MODULE_1_actions__["H" /* WebinarActions */].initComplete,function(data){_this2.setState({zroomUrl:data});var webinar=document.getElementById('webinar');webinar.setAttribute('allow','microphone *; camera *;');webinar.src=webinar.src;});}},{key:'handleChange',value:function handleChange(event,prop){if(prop==='description'){this.setState({description:event.target.value});}else{this.setState({roomName:event.target.value});}this.saveCaption(event,prop);}},{key:'initWebinarRoom',value:function initWebinarRoom(moduleId,ownerName,isWebinar){var _state=this.state,zroom=_state.zroom,userEmail=_state.userEmail;var coursioCreds=zroom?typeof zroom.useCoursio==="boolean"?zroom.useCoursio:true:true;var isSettingsFilled=coursioCreds||zroom.domain&&zroom.user&&zroom.secret;var id=isSettingsFilled&&(zroom.useCoursio?'webinar-'+moduleId:zroom.domain&&zroom.domain+'/webinar-'+moduleId);__WEBPACK_IMPORTED_MODULE_1_actions__["H" /* WebinarActions */].initWebinar(id,isWebinar,userEmail===ownerName,true,coursioCreds);}},{key:'statusChange',value:function statusChange(event,prop){this.setState({isWebinar:event.target.value});this.saveCaption(event,prop);}},{key:'renderEditMode',value:function renderEditMode(){var _this3=this;var other=_objectWithoutProperties(this.props,[]);var _state2=this.state,isWebinar=_state2.isWebinar,roomName=_state2.roomName,description=_state2.description;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},other,{style:styles.editContainer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.webinarTitle},'Webinar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TextField"],{style:styles.input,value:roomName,floatingLabelText:this.context.getIntlMessage('webinar.roomName'),onChange:function onChange(e){return _this3.handleChange(e,'roomName');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["TextField"],{style:styles.input,value:description,floatingLabelText:this.context.getIntlMessage('webinar.description'),onChange:function onChange(e){return _this3.handleChange(e,'description');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.dropdown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Material_DropDown__["a" /* default */],{onChange:function onChange(e){return _this3.statusChange(e,'isWebinar');},label:this.context.getIntlMessage('webinar.isWebinar'),selectedIndex:isWebinar?0:1,menuItems:[{payload:true,text:'Webinar'},{payload:false,text:'Conference'}]})));}},{key:'fullScreen',value:function fullScreen(){document.getElementById('webinar').requestFullscreen();}},{key:'renderDetailMode',value:function renderDetailMode(){var _this4=this;var _state3=this.state,roomName=_state3.roomName,description=_state3.description,zroom=_state3.zroom,zroomUrl=_state3.zroomUrl,isWebinar=_state3.isWebinar;var _props=this.props,moduleId=_props.moduleId,ownerName=_props.ownerName,other=_objectWithoutProperties(_props,['moduleId','ownerName']);var coursioCreds=zroom?typeof zroom.useCoursio==="boolean"?zroom.useCoursio:true:true;var isSettingsFilled=zroom&&(coursioCreds||zroom.domain&&zroom.user&&zroom.secret);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},other,{style:styles.root}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.webinarTitle},roomName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.webinarDescription},description),!zroomUrl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{style:styles.enter,backgroundColor:'#02c9cc',disabled:!isSettingsFilled,label:this.context.getIntlMessage('webinar.enter'),secondary:true,onTouchTap:function onTouchTap(){return _this4.initWebinarRoom(moduleId,ownerName,isWebinar);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui__["RaisedButton"],{style:styles.enter,backgroundColor:'#02c9cc',label:this.context.getIntlMessage('webinar.fullScreen'),secondary:true,onTouchTap:function onTouchTap(){return _this4.fullScreen();}}),!isSettingsFilled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.webinarDescription},this.context.getIntlMessage('webinar.missedSettings')),zroomUrl&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:zroomUrl&&zroomUrl,id:'webinar',width:'100%',height:'500',allowFullScreen:true}));}}]);return WebinarModule;}(Object(__WEBPACK_IMPORTED_MODULE_6_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_6_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_4_components_PageModule__["a" /* default */]));/* harmony default export */ __webpack_exports__["a"] = (WebinarModule);

/***/ }),
/* 2398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_PageModule__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={root:{background:'#f5f5f5',display:'flex',justifyContent:'center',flexDirection:'column',alignItems:'center',marginBottom:40},iframe:{border:'0',height:'75vh',width:'100%'}};var QuizIframeModule=function(_mixin){_inherits(QuizIframeModule,_mixin);function QuizIframeModule(props){_classCallCheck(this,QuizIframeModule);var _this=_possibleConstructorReturn(this,(QuizIframeModule.__proto__||Object.getPrototypeOf(QuizIframeModule)).call(this,props));var caption=props.params.caption;var initUrl=!caption?'https://quiztaker.s.coursio.com':caption.main;_this.state={url:initUrl,hash:''};return _this;}_createClass(QuizIframeModule,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_actions__["f" /* CourseActions */].findById(this.props.courseId);__WEBPACK_IMPORTED_MODULE_3_actions__["y" /* SettingsActions */].read();}},{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores__["f" /* CourseStore */]);this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores__["s" /* SettingsStore */]);}},{key:'listenToActions',value:function listenToActions(){var _this2=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_3_actions__["y" /* SettingsActions */].readComplete,function(data){_this2.setState({language:data.language});});}},{key:'handleChange',value:function handleChange(e){this.setState({url:e.target.value});}},{key:'saveUrl',value:function saveUrl(){var moduleId=this.props.moduleId;var url=this.state.url;__WEBPACK_IMPORTED_MODULE_3_actions__["f" /* CourseActions */].updatePageModule(moduleId,{id:moduleId,params:{caption:{main:url}}});__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(this.context.getIntlMessage('video.changesSaved'));}},{key:'changeToDetailMode',value:function changeToDetailMode(){this.saveUrl();this.onDetail();if(this.props.onDetail){this.props.onDetail();}__WEBPACK_IMPORTED_MODULE_3_actions__["u" /* PageModuleActions */].changePageModuleMode(this.props.moduleId,'detail');}},{key:'getUserHash',value:function getUserHash(){var _this3=this;var userId=this.props.user.id;__WEBPACK_IMPORTED_MODULE_2_services_SteelCompass__["a" /* default */].issueCdk(userId).then(function(response){if(response&&response[0].hash){var hash=response[0].hash;_this3.setState({hash:hash});}},function(error){console.log(error);});}},{key:'renderIframe',value:function renderIframe(){var _state=this.state,url=_state.url,hash=_state.hash,course=_state.course,language=_state.language;var lang=typeof language!=='undefined'?language:'en_US';var _props=this.props,courseSlug=_props.courseSlug,themeColor=_props.themeColor;var courseOwner=course.ownerSlug;if(!hash.length){this.getUserHash();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Loading...');}if(!url){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Please provide a valid URL');}var iframeUrl=url+'?hash='+hash+'&lang='+lang+'&themeColor='+themeColor+'&courseSlug='+courseSlug+'&courseOwner='+courseOwner;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{title:'Quiztaker app',width:'560',height:'315',style:styles.iframe,src:iframeUrl});}},{key:'renderEditMode',value:function renderEditMode(){var other=_objectWithoutProperties(this.props,[]);var url=this.state.url;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},other,{style:styles.root}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{hintText:'Iframe URL...',value:url,onChange:this.handleChange.bind(this),onBlur:this.saveUrl.bind(this)}));}},{key:'renderDetailMode',value:function renderDetailMode(){var other=_objectWithoutProperties(this.props,[]);var _state2=this.state,url=_state2.url,hash=_state2.hash;if(!this.props.editor){return this.renderIframe();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},other,{style:styles.root}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'If the course contains a quiz, it will automatically be shown here while in readerMode')));}}]);return QuizIframeModule;}(Object(__WEBPACK_IMPORTED_MODULE_7_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_7_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_6_components_PageModule__["a" /* default */]));/* harmony default export */ __webpack_exports__["a"] = (QuizIframeModule);

/***/ }),
/* 2399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Icons__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_3_material_ui__["Styles"].Spacing;var styles={root:{position:'relative',paddingTop:Spacing.iconSize+Spacing.desktopGutterMini/2},icon:{cursor:'pointer',position:'absolute',right:0,top:0},colorChooser:{position:'absolute',top:48,left:48},arrow:{cursor:'pointer'},colorChoice:{cursor:'pointer',display:'inline-block',height:24,width:24,margin:Spacing.desktopGutterMini/4},note:{paddingLeft:48,paddingRight:28}};var css={root:'_fx'};var Note=function(_Component){_inherits(Note,_Component);function Note(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Note);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Note.__proto__||Object.getPrototypeOf(Note)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,color:_this.props.text.trim().length===0?'coursio':'red',//color: this.props.color,
mouseOver:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Note,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_5_stores__["f" /* CourseStore */]);}},{key:'getIconStyle',value:function getIconStyle(){return Object.assign({transform:!this.state.open?'scale(1, 1)':'scale(-1, 1)'},styles.icon);}},{key:'mouseEnter',value:function mouseEnter(){var _this2=this;if(!this.state.open){return;}if(this._timer){clearTimeout(this._timer);this._timer=null;}if(this._outTimer){this._outTimer=null;clearTimeout(this._outTimer);}this._timer=setTimeout(function(){_this2._timer=null;_this2.setState({mouseOver:true});},1000);}},{key:'mouseLeave',value:function mouseLeave(){var _this3=this;this._outTimer=setTimeout(function(){_this3._outTimer=null;_this3.setState({mouseOver:false});},1000);}},{key:'getNoteStyle',value:function getNoteStyle(){return Object.assign({minWidth:Spacing.desktopKeylineIncrement*3,minHeight:50},styles.note);}},{key:'toggle',value:function toggle(){if(this.state.open){this.close();}else{this.open();}}},{key:'open',value:function open(){if(!this.state.open){this.setState({open:true});if(this.props.onEnable){this.props.onEnable();}}}},{key:'close',value:function close(){if(this.state.open){this.setState({open:false,mouseOver:false});if(this.props.onDisable){this.props.onDisable();}}}/*  chooseColor(color) {
    this.setState({ color });
    this.save();
  }*/},{key:'save',value:function save(){var _this4=this;var pageModuleId=this.props.pageModuleId;if(this._saveTimer){clearTimeout(this._saveTimer);}this._saveTimer=setTimeout(function(){var noteText=_this4.refs.noteText.getValue();var color=_this4.state.color;if(noteText.trim().length!=0){_this4.setState({noteText:noteText,color:'red'});}else{_this4.setState({noteText:noteText,color:'coursio'});}__WEBPACK_IMPORTED_MODULE_4_actions__["f" /* CourseActions */].note(pageModuleId,noteText,color);},500);}},{key:'render',value:function render(){var text=this.props.text;var color=this.state.color;var materialColor=__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */][color];var iconColor=materialColor[400].material;var hoverColor=materialColor[200].material;var noteText=void 0,colorChooser=void 0;// if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
if(this.state.open){noteText=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["TextField"],{ref:'noteText',defaultValue:this.state.noteText||this.props.text,onChange:this.save.bind(this),underlineFocusStyle:{borderColor:materialColor[500].material},defaultvalue:text,fullWidth:true,multiLine:true,hintText:this.context.getIntlMessage('note.yourNote')});}/*if (this.state.mouseOver) {
      colorChooser = <ColorChooser onSelect={::this.chooseColor} color={color}/>;
    }*/return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.getNoteStyle(materialColor),className:css.root},noteText,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onMouseEnter:this.mouseEnter.bind(this),onMouseLeave:this.mouseLeave.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Icons__["Note"],{onTouchTap:this.toggle.bind(this),style:this.getIconStyle(),color:iconColor,hoverColor:hoverColor})));}}]);return Note;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Note.defaultProps={color:'coursio'};Note.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Note);var colors=['red','purple','pink','deepPurple','indigo','blue','lightBlue','cyan','coursio','teal','green','lightGreen','lime','yellow','amber','orange','deepOrange','brown','grey','blueGrey'];var ColorChooser=function(_Component2){_inherits(ColorChooser,_Component2);function ColorChooser(){_classCallCheck(this,ColorChooser);return _possibleConstructorReturn(this,(ColorChooser.__proto__||Object.getPrototypeOf(ColorChooser)).apply(this,arguments));}_createClass(ColorChooser,[{key:'getChooserStyle',value:function getChooserStyle(color){var materialColor=__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */][color][500];return Object.assign({backgroundColor:materialColor.material},styles.colorChoice);}},{key:'choose',value:function choose(color){if(this.props.onSelect){this.props.onSelect(color);}}},{key:'render',value:function render(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.colorChooser},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Paper"],{style:{width:28*4+4,padding:Spacing.desktopGutterMini/4,backgroundColor:__WEBPACK_IMPORTED_MODULE_2_components_Material_Styles_Colors__["a" /* Colors */].fullWhite}},colors.map(function(color){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:color,onTouchTap:_this6.choose.bind(_this6,color),style:_this6.getChooserStyle(color)});})));}}]);return ColorChooser;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 2400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores_PageLayout__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_pageLayout__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Page_PageLayout__ = __webpack_require__(2401);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageLayoutContainer=function(_mixin){_inherits(PageLayoutContainer,_mixin);function PageLayoutContainer(){_classCallCheck(this,PageLayoutContainer);return _possibleConstructorReturn(this,(PageLayoutContainer.__proto__||Object.getPrototypeOf(PageLayoutContainer)).apply(this,arguments));}_createClass(PageLayoutContainer,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'listenToStores',value:function listenToStores(){var _this2=this;this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_1_stores_PageLayout__["a" /* default */],function(state){return Object.assign({layout:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_pageLayout__["a" /* getLayout */])(state),selectedPageModuleId:state.selectedPageModuleId,open:state.enabled},_this2.mapActions({closeLayoutEditor:__WEBPACK_IMPORTED_MODULE_2_actions__["t" /* PageLayoutActions */].disable,openModuleMenu:__WEBPACK_IMPORTED_MODULE_2_actions__["t" /* PageLayoutActions */].openModuleMenu}));});}},{key:'render',value:function render(){var _state=this.state,loading=_state.loading,open=_state.open,other=_objectWithoutProperties(_state,['loading','open']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Page_PageLayout__["a" /* default */],Object.assign({open:open,loading:loading},this.props,other));}}]);return PageLayoutContainer;}(Object(__WEBPACK_IMPORTED_MODULE_3_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_3_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));PageLayoutContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,params:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,history:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};PageLayoutContainer.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (PageLayoutContainer);

/***/ }),
/* 2401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Cio_Drawer__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Page_PageLayoutEditor__ = __webpack_require__(2403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Cio_Loader__ = __webpack_require__(2413);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={layoutEditor:'_fu',moduleEditor:'_fv',root:'_fw'};var PageLayoutOverview=function(_Component){_inherits(PageLayoutOverview,_Component);function PageLayoutOverview(){_classCallCheck(this,PageLayoutOverview);return _possibleConstructorReturn(this,(PageLayoutOverview.__proto__||Object.getPrototypeOf(PageLayoutOverview)).apply(this,arguments));}_createClass(PageLayoutOverview,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props=this.props,selectedPageModuleId=_props.selectedPageModuleId,onSelectModule=_props.onSelectModule;if(nextProps.selectedPageModuleId!==selectedPageModuleId){onSelectModule&&onSelectModule(nextProps.selectedPageModuleId);}}},{key:'render',value:function render(){var _props2=this.props,layout=_props2.layout,openModuleMenu=_props2.openModuleMenu,closeLayoutEditor=_props2.closeLayoutEditor,loading=_props2.loading,other=_objectWithoutProperties(_props2,['layout','openModuleMenu','closeLayoutEditor','loading']);if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Cio_Loader__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Cio_Drawer__["a" /* default */],Object.assign({className:css.root,slide:false// closeOnEsc={false}
,onRequestClose:this.unselect},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Page_PageLayoutEditor__["a" /* default */],Object.assign({closeLayoutEditor:closeLayoutEditor,openModuleMenu:openModuleMenu,layout:layout},other)));}}]);return PageLayoutOverview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PageLayoutOverview.propTypes={layout:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,closeLayoutEditor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,openModuleMenu:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,loading:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,selectedPageModuleId:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,onSelectModule:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (PageLayoutOverview);

/***/ }),
/* 2402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Cio_Portal__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ESC=27;var css={container:'_hV'};var Drawer=function(_Component){_inherits(Drawer,_Component);function Drawer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Drawer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Drawer.__proto__||Object.getPrototypeOf(Drawer)).call.apply(_ref,[this].concat(args))),_this),_this.handleRequestOpen=function(){var _this$props=_this.props,open=_this$props.open,onRequestOpen=_this$props.onRequestOpen;if(!open&&onRequestOpen){onRequestOpen();}},_this.handleRequestClose=function(){var _this$props2=_this.props,open=_this$props2.open,onRequestClose=_this$props2.onRequestClose;if(open&&onRequestClose){onRequestClose();}},_this.handleRest=function(){var _this$props3=_this.props,slide=_this$props3.slide,open=_this$props3.open,onOpen=_this$props3.onOpen,onClose=_this$props3.onClose;if(open&&onOpen){onOpen();}else if(!open&&onClose){onClose();}if(!open&&slide){__WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations___default.a.setValueForStyles(_this._app,{right:0,left:0});}},_this.handleKey=function(event){var keyCode=event.keyCode;var _this$props4=_this.props,closeOnEsc=_this$props4.closeOnEsc,onRequestClose=_this$props4.onRequestClose;if(keyCode===ESC&&closeOnEsc&&onRequestClose){onRequestClose();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Drawer,[{key:'componentWillMount',value:function componentWillMount(){this._app=document.getElementById('root');document.addEventListener('keyup',this.handleKey);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var slide=this.props.slide;slide&&__WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations___default.a.setValueForStyles(this._app,{right:0,left:0});document.removeEventListener('keyup',this.handleKey);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,open=_props.open,slide=_props.slide,children=_props.children,right=_props.right,width=_props.width,className=_props.className;var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.container,className);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_motion__["Motion"],{style:{width:Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(width,{stiffness:300,damping:25}),x:Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(open?1:0,{stiffness:300,damping:25}),open:Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(open?1:0)},onRest:this.handleRest},function(interpolated){if(interpolated.open>0){var x=interpolated.x,interpolatedWidth=interpolated.width;var style={width:interpolatedWidth,left:right?null:-interpolatedWidth,right:right?-interpolatedWidth:null,transform:'translate3d('+(right?0:x*interpolatedWidth)+'px, '+(right?-x*interpolatedWidth:0)+'px, 0)'};slide&&__WEBPACK_IMPORTED_MODULE_3_react_lib_CSSPropertyOperations___default.a.setValueForStyles(_this2._app,{right:right?x*interpolatedWidth:0,left:right?0:x*interpolatedWidth});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_Cio_Portal__["a" /* default */],{className:classes,style:style},children);}return null;});}}]);return Drawer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Drawer.propTypes={className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,open:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,right:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onClose:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onOpen:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,width:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,onRequestClose:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onRequestOpen:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,closeOnEsc:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,slide:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};Drawer.defaultProps={open:false,width:390,slide:true,closeOnEsc:true};/* harmony default export */ __webpack_exports__["a"] = (Drawer);

/***/ }),
/* 2403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd_touch_backend__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd_touch_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dnd_touch_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Cio_ScrollableContainer__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LayoutOverview_PageLayoutOverviewColumnPreview__ = __webpack_require__(2404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LayoutOverview_PageLayoutOverviewRow__ = __webpack_require__(2405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LayoutOverview_PageLayoutEditorToolbar__ = __webpack_require__(2407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Util__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={addModuleButton:'_f5'};var PageLayoutEditor=function(_mixin){_inherits(PageLayoutEditor,_mixin);function PageLayoutEditor(){_classCallCheck(this,PageLayoutEditor);return _possibleConstructorReturn(this,(PageLayoutEditor.__proto__||Object.getPrototypeOf(PageLayoutEditor)).apply(this,arguments));}_createClass(PageLayoutEditor,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_9_stores__["f" /* CourseStore */],function(state){return{course:state.course,theme:state.course.theme};});}},{key:'render',value:function render(){var _props=this.props,layout=_props.layout,closeLayoutEditor=_props.closeLayoutEditor,openModuleMenu=_props.openModuleMenu;var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_Cio_ScrollableContainer__["a" /* default */],{padded:true,header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__LayoutOverview_PageLayoutEditorToolbar__["a" /* default */],{closeLayoutEditor:closeLayoutEditor})},layout.pageRows.map(function(pageRow){var id=pageRow.id,other=_objectWithoutProperties(pageRow,['id']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LayoutOverview_PageLayoutOverviewRow__["a" /* default */],Object.assign({id:id,key:id},other));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LayoutOverview_PageLayoutOverviewColumnPreview__["a" /* default */],{key:'preview',name:'CourseColumn'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.addModuleButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui__["RaisedButton"],{fullWidth:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_9_stores__["z" /* ThemeStore */].getColor(this.state.theme.color),label:getIntlMessage('pageModule.add'),secondary:true,onTouchTap:openModuleMenu})));}}]);return PageLayoutEditor;}(Object(__WEBPACK_IMPORTED_MODULE_10_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_10_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));PageLayoutEditor.propTypes={closeLayoutEditor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,openModuleMenu:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,layout:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};PageLayoutEditor.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_dnd__["DragDropContext"])(__WEBPACK_IMPORTED_MODULE_1_react_dnd_touch_backend___default()({enableMouseEvents:true}))(PageLayoutEditor));

/***/ }),
/* 2404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd_lib_DragLayer__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd_lib_DragLayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dnd_lib_DragLayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Icons__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={preview:'_g3'};var styles={icon:{width:__WEBPACK_IMPORTED_MODULE_2_Css__["Units"].base*4,height:__WEBPACK_IMPORTED_MODULE_2_Css__["Units"].base*4}};function collect(monitor){var item=monitor.getItem();var initial=monitor.getInitialClientOffset();var difference=monitor.getDifferenceFromInitialOffset();return{id:item&&item.id,type:item&&item.type,initialClientOffset:initial&&difference?{x:initial.x+difference.x,y:initial.y+difference.y}:null,currentOffset:monitor.getSourceClientOffset(),isDragging:monitor.isDragging()};}function getItemStyles(currentOffset){if(!currentOffset){return{display:'none'};}var x=currentOffset.x,y=currentOffset.y;var transform='translate('+(x-48)+'px, '+(y-96)+'px)';return{pointerEvents:'none',transform:transform,WebkitTransform:transform};}var Preview=function(_Component){_inherits(Preview,_Component);function Preview(){_classCallCheck(this,Preview);return _possibleConstructorReturn(this,(Preview.__proto__||Object.getPrototypeOf(Preview)).apply(this,arguments));}_createClass(Preview,[{key:'render',value:function render(){var _props=this.props,isDragging=_props.isDragging,type=_props.type;if(!isDragging){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}var Icon=__WEBPACK_IMPORTED_MODULE_4_components_Icons__[__WEBPACK_IMPORTED_MODULE_3_Constants__["pageModules"][type.name].icon];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.preview,style:getItemStyles(this.props.initialClientOffset)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{style:styles.icon,className:css.icon,color:'#777777'}));}}]);return Preview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Preview.propTypes={id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number]),type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,currentOffset:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({x:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,y:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number}),initialClientOffset:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].shape({x:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,y:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number}),isDragging:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_dnd_lib_DragLayer___default()(collect)(Preview));

/***/ }),
/* 2405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd_lib_DropTarget__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd_lib_DropTarget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dnd_lib_DropTarget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PageLayoutOverviewColumn__ = __webpack_require__(2406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Icons__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_gU',before:'_gV',after:'_gW',dragContainer:'_gX',size1:'_gY',size2:'_gZ',size3:'_g0',size4:'_g1',drag:'_g2'};var styles={icon:{width:__WEBPACK_IMPORTED_MODULE_6_Css__["Units"].base*4,height:__WEBPACK_IMPORTED_MODULE_6_Css__["Units"].base*4}};var dropTarget={hover:function hover(props,monitor,component){if(monitor.isOver({shallow:true})&&component){var offset=monitor.getClientOffset();var y=offset.y,x=offset.x;component.checkHover(y,x,monitor.getItem().pageModuleId,monitor.getItem().pageRowId);}}};var CourseLayoutOverviewRow=function(_Component){_inherits(CourseLayoutOverviewRow,_Component);function CourseLayoutOverviewRow(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CourseLayoutOverviewRow);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CourseLayoutOverviewRow.__proto__||Object.getPrototypeOf(CourseLayoutOverviewRow)).call.apply(_ref,[this].concat(args))),_this),_this.endDrag=function(item){__WEBPACK_IMPORTED_MODULE_4_actions__["t" /* PageLayoutActions */].endDragging(_this.props.id,item);},_this.checkHover=function(y,x,pageModuleId,pageRowId){var _this$_node$getBoundi=_this._node.getBoundingClientRect(),left=_this$_node$getBoundi.left,top=_this$_node$getBoundi.top,height=_this$_node$getBoundi.height,width=_this$_node$getBoundi.width;var _this$props=_this.props,id=_this$props.id,pageModules=_this$props.pageModules;var pageModulesWithoutDragging=pageModules.filter(function(pageModule){return pageModule.id!=='drag';});var columnCount=pageModules.length;var pageModuleIndex=pageModulesWithoutDragging.findIndex(function(pageModule){return pageModule.id===pageModuleId;});if(pageModuleIndex<0){columnCount++;}var xOffset=Math.max(x-left,1);var dropPosition=Math.floor(columnCount*(xOffset/width));var pos=(y-top)/height;if(pos<0.33){__WEBPACK_IMPORTED_MODULE_4_actions__["t" /* PageLayoutActions */].overRow('before',id);}else if(pos>0.66){__WEBPACK_IMPORTED_MODULE_4_actions__["t" /* PageLayoutActions */].overRow('after',id);}else{if(columnCount>3){return;}// if (pageRowId === id && dropPosition === pageModuleIndex) {
//   return;
// }
// console.log(pageRowId, id, dropPosition, pageModuleIndex);
// if (pageRowId === id && dropPosition === pageModuleIndex + 1) {
//   return;
// }
if(pageModuleIndex>-1&&pageModuleIndex===dropPosition){if(pageRowId===id&&pageModules[dropPosition].id===pageModuleId){return __WEBPACK_IMPORTED_MODULE_4_actions__["t" /* PageLayoutActions */].resetDragging();}if(pageRowId===id&&dropPosition===pageModuleIndex+1&&pageModules[dropPosition-1].id===pageModuleId){return __WEBPACK_IMPORTED_MODULE_4_actions__["t" /* PageLayoutActions */].resetDragging();}if(pageModules.length!==pageModulesWithoutDragging.length){return __WEBPACK_IMPORTED_MODULE_4_actions__["t" /* PageLayoutActions */].resetDragging();}return;}__WEBPACK_IMPORTED_MODULE_4_actions__["t" /* PageLayoutActions */].setDraggingPos(id,dropPosition,pageModuleId);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CourseLayoutOverviewRow,[{key:'render',value:function render(){var _classNames,_this2=this;var _props=this.props,pageModules=_props.pageModules,marked=_props.marked,id=_props.id;var columnCount=pageModules.length;var dragClasses=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.dragContainer,css['size'+columnCount]);var classes=__WEBPACK_IMPORTED_MODULE_1_classnames___default()(css.root,(_classNames={},_defineProperty(_classNames,css.before,marked==='before'),_defineProperty(_classNames,css.after,marked==='after'),_classNames));var dragIndex=pageModules.findIndex(function(pageModule){return pageModule.type==='Drag';});var isDragInSameRow=dragIndex>-1&&pageModules.findIndex(function(pageModule){return pageModule.id===pageModules[dragIndex].pageModuleId;})>-1;var content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(_node){return _this2._node=_node;},className:classes,onTouchTap:this.select},pageModules.map(function(pageModule,index){var pageModuleId=pageModule.id,type=pageModule.type,other=_objectWithoutProperties(pageModule,['id','type']);if(type==='Drag'){if(!isDragInSameRow){var Icon=__WEBPACK_IMPORTED_MODULE_8_components_Icons__[__WEBPACK_IMPORTED_MODULE_3_Constants__["default"].pageModules[pageModule.subType.name].icon];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:dragClasses,key:'drag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.drag},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{style:styles.icon,color:__WEBPACK_IMPORTED_MODULE_6_Css__["Colors"].creen})));}return null;}var columnMarked=void 0;if(dragIndex>-1){if(index===dragIndex-1){columnMarked='after';}else if(index===dragIndex||index===dragIndex+1){columnMarked='before';}else{columnMarked='';}}else{columnMarked='';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:dragClasses,key:pageModuleId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PageLayoutOverviewColumn__["a" /* default */],Object.assign({endDrag:_this2.endDrag,onHover:_this2.onHover,id:pageModuleId,pageRowId:id,type:type,marked:columnMarked},other)));}));return this.props.connectDropTarget(content);}}]);return CourseLayoutOverviewRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CourseLayoutOverviewRow.propTypes={type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,marked:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,pageModules:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array,connectDropTarget:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_dnd_lib_DropTarget___default()('CourseColumn',dropTarget,function(connect,monitor){return{connectDropTarget:connect.dropTarget(),isOver:monitor.isOver()};})(CourseLayoutOverviewRow));

/***/ }),
/* 2406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dnd_lib_DragSource__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dnd_lib_DragSource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dnd_lib_DragSource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Icons__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_DialogPortal__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_actions__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_6_material_ui__["Styles"].Spacing;var css={task:'_hC',root:'_hD',isOver:'_hE',isDragging:'_hF',afterMarker:'_hG',beforeMarker:'_hH'};var styles={icon:{width:__WEBPACK_IMPORTED_MODULE_1_Css__["Units"].base*4,height:__WEBPACK_IMPORTED_MODULE_1_Css__["Units"].base*4},smallIcon:{width:__WEBPACK_IMPORTED_MODULE_1_Css__["Units"].base*2.5,height:__WEBPACK_IMPORTED_MODULE_1_Css__["Units"].base*2.5},deleteButton:{position:'absolute',right:-10,lineHeight:Spacing.desktopKeylineIncrement-2*Spacing.desktopGutterMini+'px',padding:Spacing.desktopGutterMini,top:-5}};var dragSource={beginDrag:function beginDrag(props){return{pageModuleId:props.id,pageRowId:props.pageRowId,type:props.type};},endDrag:function endDrag(props,monitor){props.endDrag(monitor.getItem(),monitor.didDrop());}};var PageLayoutOverviewColumn=function(_Component){_inherits(PageLayoutOverviewColumn,_Component);function PageLayoutOverviewColumn(props){_classCallCheck(this,PageLayoutOverviewColumn);var _this=_possibleConstructorReturn(this,(PageLayoutOverviewColumn.__proto__||Object.getPrototypeOf(PageLayoutOverviewColumn)).call(this,props));_this.toggleControls=function(){_this.setState({controls:!_this.state.controls});__WEBPACK_IMPORTED_MODULE_8_actions__["t" /* PageLayoutActions */].selectPageModule(_this.props.id);};_this.handleDelete=function(){_this.refs.confirmDialog.show();};_this.state={controls:false};return _this;}_createClass(PageLayoutOverviewColumn,[{key:'cancelDelete',value:function cancelDelete(){this.refs.confirmDialog.dismiss();}},{key:'deleteModule',value:function deleteModule(){__WEBPACK_IMPORTED_MODULE_8_actions__["u" /* PageModuleActions */].deletePageModule(this.props.id);}},{key:'render',value:function render(){var _classNames;var _props=this.props,type=_props.type,marked=_props.marked,isDragging=_props.isDragging,data=_props.data;var deleteButton=void 0,deleteDialog=void 0;var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.root,(_classNames={},_defineProperty(_classNames,css.task,type.name==='task'),_defineProperty(_classNames,css.isDragging,isDragging),_defineProperty(_classNames,'controls',this.state.controls),_classNames));var standardActions=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FlatButton"],{key:'cancel',label:this.context.getIntlMessage('No'),primary:true,onTouchTap:this.cancelDelete.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FlatButton"],{key:'ok',label:this.context.getIntlMessage('Yes'),secondary:true,onTouchTap:this.deleteModule.bind(this)})];var dialog=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_DialogPortal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["Dialog"],{ref:'confirmDialog',title:this.context.getIntlMessage('Remove'),actions:standardActions,dismissOnClickAway:true,style:{zIndex:99}},this.context.getIntlMessage('module.confirmDelete')));if(this.state.controls){deleteButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["IconButton"],{iconStyle:styles.smallIcon,style:Object.assign({},styles.deleteButton),onTouchTap:this.handleDelete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Icons__["Delete"],{color:'#B0281A'})));}var Icon=void 0;if(type.name==='quiz'){Icon=__WEBPACK_IMPORTED_MODULE_5_components_Icons__[__WEBPACK_IMPORTED_MODULE_4_Constants__["pageModules"]['task'].icon];}else{Icon=__WEBPACK_IMPORTED_MODULE_5_components_Icons__[__WEBPACK_IMPORTED_MODULE_4_Constants__["pageModules"][type.name].icon];}var name=null;if(type.name==='task'){var caption=Array.isArray(data.params.task.caption.main)?data.params.task.caption.main.join():data.params.task.caption.main;if(data.params.task.caption.main&&data.params.task.caption.main.length>35){name=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{display:'inline'}},caption.substr(0,40),'...');}else{name=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{display:'inline'}},caption);}}var content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes,onTouchTap:this.toggleControls},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{style:Object.assign({},styles.icon,{marginRight:type.name==='task'&&'12px'}),color:'#777777'}),name,marked==='after'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.afterMarker}),marked==='before'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.beforeMarker}),deleteButton,dialog));// Connect as drag source
content=this.props.connectDragSource(content,{dropEffect:'move'});// Connect to drag layer
content=this.props.connectDragPreview(content);return content;}}]);return PageLayoutOverviewColumn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PageLayoutOverviewColumn.propTypes={type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,id:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number,// react-dnd props
connectDragSource:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,connectDropTarget:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,connectDragPreview:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,endDrag:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,isDragging:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,isOver:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,marked:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};PageLayoutOverviewColumn.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_react_dnd_lib_DragSource___default()('CourseColumn',dragSource,function(connect,monitor){return{connectDragSource:connect.dragSource(),connectDragPreview:connect.dragPreview(),isDragging:monitor.isDragging()};})(PageLayoutOverviewColumn));

/***/ }),
/* 2407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Cio_Toolbar__ = __webpack_require__(659);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageLayoutEditorToolbar=function(_Component){_inherits(PageLayoutEditorToolbar,_Component);function PageLayoutEditorToolbar(){_classCallCheck(this,PageLayoutEditorToolbar);return _possibleConstructorReturn(this,(PageLayoutEditorToolbar.__proto__||Object.getPrototypeOf(PageLayoutEditorToolbar)).apply(this,arguments));}_createClass(PageLayoutEditorToolbar,[{key:'render',value:function render(){var _props=this.props,closeLayoutEditor=_props.closeLayoutEditor,other=_objectWithoutProperties(_props,['closeLayoutEditor']);var getIntlMessage=this.context.getIntlMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Cio_Toolbar__["a" /* Toolbar */],Object.assign({center:true,key:'edit'},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Cio_Toolbar__["c" /* ToolbarGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Cio_Toolbar__["b" /* ToolbarButton */],{onTouchTap:closeLayoutEditor,tooltip:getIntlMessage('menu.Back')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Material_SvgIcons__["NavigationArrowBack"],null))));}}]);return PageLayoutEditorToolbar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PageLayoutEditorToolbar.propTypes={closeLayoutEditor:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};PageLayoutEditorToolbar.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (PageLayoutEditorToolbar);

/***/ }),
/* 2408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_hI',fixed:'_hJ',bottom:'_hK',top:'_hL',depth0:'_hM',depth1:'_hN',depth2:'_hO',depth3:'_hP',depth4:'_hQ',depth5:'_hR',toolbar:'_hS',dense:'_hT',center:'_hU'};var Toolbar=function(_Component){_inherits(Toolbar,_Component);function Toolbar(){_classCallCheck(this,Toolbar);return _possibleConstructorReturn(this,(Toolbar.__proto__||Object.getPrototypeOf(Toolbar)).apply(this,arguments));}_createClass(Toolbar,[{key:'render',value:function render(){var _classNames,_classNames2;var _props=this.props,children=_props.children,dense=_props.dense,top=_props.top,zDepth=_props.zDepth,bottom=_props.bottom,fixed=_props.fixed,transparent=_props.transparent,color=_props.color,center=_props.center,other=_objectWithoutProperties(_props,['children','dense','top','zDepth','bottom','fixed','transparent','color','center']);var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.root,css['depth'+zDepth],(_classNames={},_defineProperty(_classNames,css.top,top),_defineProperty(_classNames,css.bottom,bottom),_defineProperty(_classNames,css.fixed,fixed),_classNames));var backgroundColor=transparent?null:color?color:__WEBPACK_IMPORTED_MODULE_1_Css__["Colors"].material.grey[200].hex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:classes,style:{backgroundColor:backgroundColor}},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.toolbar,(_classNames2={},_defineProperty(_classNames2,css.center,center),_defineProperty(_classNames2,css.dense,dense),_classNames2))},children));}}]);return Toolbar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Toolbar.propTypes={color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,center:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,fixed:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,top:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,bottom:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,transparent:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,dense:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,zDepth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].number};Toolbar.defaultProps={zDepth:0};/* harmony default export */ __webpack_exports__["a"] = (Toolbar);

/***/ }),
/* 2409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_h0',transparent:'_h1',dense:'_h2',right:'_h3',fullWidth:'_h4'};var ToolbarGroup=function(_Component){_inherits(ToolbarGroup,_Component);function ToolbarGroup(){_classCallCheck(this,ToolbarGroup);return _possibleConstructorReturn(this,(ToolbarGroup.__proto__||Object.getPrototypeOf(ToolbarGroup)).apply(this,arguments));}_createClass(ToolbarGroup,[{key:'render',value:function render(){var _classNames;var _props=this.props,children=_props.children,right=_props.right,fullWidth=_props.fullWidth,transparent=_props.transparent,dense=_props.dense,other=_objectWithoutProperties(_props,['children','right','fullWidth','transparent','dense']);var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.root,(_classNames={},_defineProperty(_classNames,css.right,right),_defineProperty(_classNames,css.dense,dense),_defineProperty(_classNames,css.transparent,transparent),_defineProperty(_classNames,css.fullWidth,fullWidth),_classNames));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:classes},other),children);}}]);return ToolbarGroup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ToolbarGroup.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,right:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,transparent:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,fullWidth:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,dense:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (ToolbarGroup);

/***/ }),
/* 2410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tooltip__ = __webpack_require__(413);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={button:'_hW',dense:'_hX',disabled:'_hY',active:'_hZ'};var ToolbarButton=function(_Component){_inherits(ToolbarButton,_Component);function ToolbarButton(){var _ref,_arguments=arguments;var _temp,_this,_ret;for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_classCallCheck(this,ToolbarButton);return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ToolbarButton.__proto__||Object.getPrototypeOf(ToolbarButton)).call.apply(_ref,[this].concat(args))),_this),_this.state={hover:false,active:false},_this.getNode=function(){return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this);},_this.handleMouseEnter=function(){_this.setState({hover:true});},_this.handleMouseLeave=function(){_this.setState({hover:false});},_this.handleFocus=function(){_this.setState({active:true});},_this.handleBlur=function(){var onBlur=_this.props.onBlur;_this.setState({active:false});onBlur&&onBlur();},_this.handleTouchTap=function(event){event.preventDefault();event.stopPropagation();var _this$props=_this.props,onTouchTap=_this$props.onTouchTap,disabled=_this$props.disabled;if(!disabled&&onTouchTap){onTouchTap.apply(undefined,_arguments);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ToolbarButton,[{key:'componentDidMount',value:function componentDidMount(){this._node=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.disabled){this.setState({hover:false,active:false});}}},{key:'render',value:function render(){var _classNames;var _props=this.props,className=_props.className,dense=_props.dense,disabled=_props.disabled,tooltip=_props.tooltip,children=_props.children,other=_objectWithoutProperties(_props,['className','dense','disabled','tooltip','children']);var _state=this.state,hover=_state.hover,active=_state.active;var classes=__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.button,className,(_classNames={},_defineProperty(_classNames,css.disabled,disabled),_defineProperty(_classNames,css.active,active),_defineProperty(_classNames,css.dense,dense),_classNames));var handlers=disabled?{}:{onFocus:this.handleFocus,onBlur:this.handleBlur,onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave,onTouchTap:this.handleTouchTap};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',Object.assign({},other,handlers,{className:classes}),children,hover&&tooltip&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Tooltip__["a" /* default */],{anchorTo:this.getNode},tooltip));}}]);return ToolbarButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ToolbarButton.propTypes={tooltip:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,disabled:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,dense:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onTouchTap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onBlur:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (ToolbarButton);

/***/ }),
/* 2411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tooltip__ = __webpack_require__(413);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={button:'_h5',dense:'_h6',selected:'_h7',disabled:'_h8',active:'_h9'};var TabButton=function(_Component){_inherits(TabButton,_Component);function TabButton(){var _ref,_arguments=arguments;var _temp,_this,_ret;for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_classCallCheck(this,TabButton);return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TabButton.__proto__||Object.getPrototypeOf(TabButton)).call.apply(_ref,[this].concat(args))),_this),_this.state={hover:false,active:false},_this.getNode=function(){return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this);},_this.handleMouseEnter=function(){_this.setState({hover:true});},_this.handleMouseLeave=function(){_this.setState({hover:false});},_this.handleFocus=function(){_this.setState({active:true});},_this.handleBlur=function(){var onBlur=_this.props.onBlur;_this.setState({active:false});onBlur&&onBlur();},_this.handleTouchTap=function(event){event.preventDefault();event.stopPropagation();var _this$props=_this.props,onTouchTap=_this$props.onTouchTap,disabled=_this$props.disabled;if(!disabled&&onTouchTap){onTouchTap.apply(undefined,_arguments);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TabButton,[{key:'componentDidMount',value:function componentDidMount(){this._node=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.disabled){this.setState({hover:false,active:false});}}},{key:'render',value:function render(){var _classNames;var _props=this.props,className=_props.className,dense=_props.dense,disabled=_props.disabled,tooltip=_props.tooltip,children=_props.children,selected=_props.selected,other=_objectWithoutProperties(_props,['className','dense','disabled','tooltip','children','selected']);var _state=this.state,hover=_state.hover,active=_state.active;var classes=__WEBPACK_IMPORTED_MODULE_3_classnames___default()(css.button,className,(_classNames={},_defineProperty(_classNames,css.disabled,disabled),_defineProperty(_classNames,css.active,active),_defineProperty(_classNames,css.selected,selected),_defineProperty(_classNames,css.dense,dense),_classNames));var handlers=disabled?{}:{onFocus:this.handleFocus,onBlur:this.handleBlur,onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave,onTouchTap:this.handleTouchTap};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',Object.assign({},other,handlers,{className:classes}),children,hover&&tooltip&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Tooltip__["a" /* default */],{anchorTo:this.getNode},tooltip));}}]);return TabButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TabButton.propTypes={tooltip:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,disabled:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,dense:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,onTouchTap:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,onBlur:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,className:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,selected:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* unused harmony default export */ var _unused_webpack_default_export = (TabButton);

/***/ }),
/* 2412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_h_'};var ToolbarTitle=function(_Component){_inherits(ToolbarTitle,_Component);function ToolbarTitle(){_classCallCheck(this,ToolbarTitle);return _possibleConstructorReturn(this,(ToolbarTitle.__proto__||Object.getPrototypeOf(ToolbarTitle)).apply(this,arguments));}_createClass(ToolbarTitle,[{key:'render',value:function render(){var _props=this.props,children=_props.children,color=_props.color,other=_objectWithoutProperties(_props,['children','color']);var style=color?{color:color}:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:css.root,style:style},children);}}]);return ToolbarTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ToolbarTitle.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,color:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (ToolbarTitle);

/***/ }),
/* 2413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={container:'_f6'};var Loader=function(_Component){_inherits(Loader,_Component);function Loader(){_classCallCheck(this,Loader);return _possibleConstructorReturn(this,(Loader.__proto__||Object.getPrototypeOf(Loader)).apply(this,arguments));}_createClass(Loader,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["CircularProgress"],{mode:'indeterminate'}));}}]);return Loader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 2414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Route_Task__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stores_Auth__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_helpers__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Confetti__ = __webpack_require__(2415);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['Welcome'],['Welcome']),_templateObject2=_taggedTemplateLiteral(['End test'],['End test']),_templateObject3=_taggedTemplateLiteral(['Questions'],['Questions']),_templateObject4=_taggedTemplateLiteral(['Result'],['Result']),_templateObject5=_taggedTemplateLiteral(['Your score'],['Your score']),_templateObject6=_taggedTemplateLiteral(['comment'],['comment']),_templateObject7=_taggedTemplateLiteral(['Restart'],['Restart']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={startButtonContainer:{left:'50%',position:'relative',transform:'translateX(-50%)',display:'inline-block'},startButton:{marginRight:'5px'},navButton:{position:'absolute',top:'50%',transform:'translateY(-50%)'},paginationBlock:{padding:5,marginRight:10,marginTop:10,minWidth:58,border:0}};var classes={container:'_ez',message:'_eA',startButton:'_eB',hideButtons:'_eC',pagination:'_eD',paginationDivider:'_eE',comment:'_eF',confetti:'_eG'};function dateCheck(from,to,check){var fDate=void 0,lDate=void 0,cDate=void 0;fDate=Date.parse(from);lDate=Date.parse(to);cDate=Date.parse(check);if(cDate<=lDate&&cDate>=fDate){return true;}return false;}var QuizContainer=function(_mixin){_inherits(QuizContainer,_mixin);function QuizContainer(){_classCallCheck(this,QuizContainer);return _possibleConstructorReturn(this,(QuizContainer.__proto__||Object.getPrototypeOf(QuizContainer)).apply(this,arguments));}_createClass(QuizContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores__["r" /* QuizStore */]);this.listenToStore(__WEBPACK_IMPORTED_MODULE_5_stores_Auth__["a" /* default */],'auth');}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;__WEBPACK_IMPORTED_MODULE_7_helpers__["a" /* history */].listenBefore(function(_,callback){if(_this2.state.started&&!_this2.state.ended){alert("Do not leave the test! If you do your results won't be saved");callback(false);}else{callback(true);}});if(!this.state.startTime){__WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */].initialize(nextProps.data,nextProps.quizSettings,nextProps.pageId,nextProps.userdata);}}},{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */].initialize(this.props.data,this.props.quizSettings,this.props.pageId,this.props.userdata);}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */].reset();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuizPage,Object.assign({},this.props,this.state));}}]);return QuizContainer;}(Object(__WEBPACK_IMPORTED_MODULE_2_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_2_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));//just for show
var QuizPage=function(_Component){_inherits(QuizPage,_Component);function QuizPage(){_classCallCheck(this,QuizPage);return _possibleConstructorReturn(this,(QuizPage.__proto__||Object.getPrototypeOf(QuizPage)).apply(this,arguments));}_createClass(QuizPage,[{key:'render',value:function render(){var _props=this.props,currentStep=_props.currentStep,content=_props.content,themeColor=_props.themeColor,currentQuestion=_props.currentQuestion,answers=_props.answers,score=_props.score,threshold=_props.threshold,userdata=_props.userdata,testComplete=_props.testComplete,quizSettings=_props.quizSettings,displayNext=_props.displayNext,displayPrev=_props.displayPrev,pageId=_props.pageId,time=_props.time;var hasTaken=userdata.pages&&userdata.pages[pageId]&&!!userdata.pages[pageId].length;var prevResult={};if(hasTaken){prevResult=userdata.pages[pageId];if(hasTaken&&userdata.locked&&!quizSettings.repeatable){var data=userdata.pages[pageId][userdata.pages[pageId].length-1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuizResult,{title:data.status==='QUIZ_SUCCESS'?quizSettings.successText:quizSettings.failText,hide:quizSettings.hideAnswers||false,data:prevResult,themeColor:themeColor,score:data.score,total:Object.keys(answers).length||data.total,threshold:threshold,currentStep:currentStep,content:content}));}if(hasTaken&&!userdata.locked&&!quizSettings.repeatable&&currentStep==='QUIZ_RESULT'){var _data=userdata.pages[pageId][0];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuizResult,{title:_data.status==='QUIZ_SUCCESS'?quizSettings.successText:quizSettings.failText,hide:quizSettings.hideAnswers||false,data:prevResult,themeColor:themeColor,score:_data.score,total:Object.keys(answers).length||_data.total,threshold:threshold,currentStep:currentStep,content:content,enableRestartQuiz:true}));}}switch(currentStep){case'QUIZ_INTRO':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuizMessage,{title:Object(__WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__["translate"])(_templateObject),description:quizSettings.descriptionText||'',settings:quizSettings,themeColor:themeColor,currentStep:currentStep,content:content,result:this.props,hasPreviewsResult:hasTaken});case'QUIZ_MAIN':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuizInteractionModule,{time:time,displayNext:displayNext,displayPrev:displayPrev,currentQuestion:currentQuestion,themeColor:themeColor,currentStep:currentStep,testComplete:testComplete,content:content});case'QUIZ_FAIL':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuizResult,{hide:quizSettings.hideAnswers||false,title:quizSettings.failText,score:score,total:Object.keys(answers).length,threshold:threshold,themeColor:themeColor,currentStep:currentStep,content:content,data:prevResult||{},enableRestartQuiz:quizSettings.repeatable});case'QUIZ_SUCCESS':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuizResult,{hide:quizSettings.hideAnswers||false,title:quizSettings.successText,Confetti:__WEBPACK_IMPORTED_MODULE_12__Confetti__["a" /* default */],themeColor:themeColor,score:score,total:Object.keys(answers).length,threshold:threshold,currentStep:currentStep,content:content,data:prevResult||{},enableRestartQuiz:quizSettings.repeatable});case'QUIZ_RESULT':var page=this.props.userdata.pages[pageId];var lastestScore=page&&page[page.length-1].score;var latestTotal=page&&page[page.length-1].total;var latestTitle=page&&page[page.length-1].status==='QUIZ_SUCCESS'?quizSettings.successText:quizSettings.failText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuizResult,{hide:quizSettings.hideAnswers||false,score:lastestScore,title:latestTitle,total:latestTotal,threshold:threshold,themeColor:themeColor,currentStep:currentStep,data:prevResult||{},content:content,enableRestartQuiz:quizSettings.repeatable});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}]);return QuizPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var QuizInteractionModule=function(_Component2){_inherits(QuizInteractionModule,_Component2);function QuizInteractionModule(){_classCallCheck(this,QuizInteractionModule);return _possibleConstructorReturn(this,(QuizInteractionModule.__proto__||Object.getPrototypeOf(QuizInteractionModule)).apply(this,arguments));}_createClass(QuizInteractionModule,[{key:'next',value:function next(){__WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */].next();}},{key:'prev',value:function prev(){__WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */].prev();}},{key:'render',value:function render(){var _props2=this.props,themeColor=_props2.themeColor,currentQuestion=_props2.currentQuestion,content=_props2.content,displayNext=_props2.displayNext,testComplete=_props2.testComplete,displayPrev=_props2.displayPrev,time=_props2.time;var _content$currentQuest=content[currentQuestion],taskResults=_content$currentQuest.taskResults,pageModuleId=_content$currentQuest.pageModuleId,task=_objectWithoutProperties(_content$currentQuest,['taskResults','pageModuleId']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{textAlign:'center'}},time),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:classes.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FloatingActionButton"],{className:classes.hideButtons,disabled:!displayPrev,onClick:this.prev,style:Object.assign({},styles.navButton,{left:'-71px'}),backgroundColor:themeColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationArrowBack"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Route_Task__["b" /* Task */],Object.assign({key:pageModuleId,isQuiz:true,reader:true,themeColor:themeColor,canGrade:false,pageModuleId:pageModuleId},task,{canAnswer:true,name:'',displayNextQuizQuestion:displayNext})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["FloatingActionButton"],{className:classes.hideButtons,disabled:!displayNext,onClick:this.next,style:Object.assign({},styles.navButton,{right:'-71px'}),backgroundColor:themeColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Material_SvgIcons__["NavigationArrowForward"],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{onClick:__WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */].calculateTest,label:Object(__WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__["translate"])(_templateObject2),style:{marginTop:'10px',height:'50px'},primary:true,disabled:!testComplete,fullWidth:true,backgroundColor:'green'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pagination,{currentQuestion:currentQuestion,content:content,themeColor:themeColor}));}}]);return QuizInteractionModule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Pagination=function(_Component3){_inherits(Pagination,_Component3);function Pagination(){_classCallCheck(this,Pagination);return _possibleConstructorReturn(this,(Pagination.__proto__||Object.getPrototypeOf(Pagination)).apply(this,arguments));}_createClass(Pagination,[{key:'render',value:function render(){var _props3=this.props,currentQuestion=_props3.currentQuestion,content=_props3.content,themeColor=_props3.themeColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.pagination},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.paginationDivider},Object(__WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__["translate"])(_templateObject3)),content.map(function(q,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:q.id,onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */].setQuestion(i);},style:Object.assign({},styles.paginationBlock,{boxShadow:'0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)',transform:currentQuestion===i&&'translateY(-2px)',color:!q.answered?'#000':'#fff',backgroundColor:!q.answered?'#fff':themeColor})},i+1);}));}}]);return Pagination;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var QuizMessage=function(_Component4){_inherits(QuizMessage,_Component4);function QuizMessage(){_classCallCheck(this,QuizMessage);return _possibleConstructorReturn(this,(QuizMessage.__proto__||Object.getPrototypeOf(QuizMessage)).apply(this,arguments));}_createClass(QuizMessage,[{key:'next',value:function next(){__WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */].setNextStep('QUIZ_MAIN');}},{key:'render',value:function render(){var _props4=this.props,themeColor=_props4.themeColor,title=_props4.title,description=_props4.description,hasPreviewsResult=_props4.hasPreviewsResult,settings=_props4.settings;var can=true;// if (!!settings.startDate && !!settings.endDate) {
//   if (!dateCheck(settings.startDate, settings.endDate, new Date())) {
//     can = false;
//   }
// } else if (
//   !settings.startDate &&
//   !!settings.endDate &&
//   !(new Date() <= new Date(settings.endDate))
// ) {
//   can = false;
// } else if (
//   !!settings.startDate &&
//   !settings.endDate &&
//   !(new Date() >= new Date(settings.startDate))
// ) {
//   can = false;
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:classes.message},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:classes.message},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.startButtonContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{backgroundColor:themeColor,style:styles.startButton,primary:true,disabled:!can,onClick:this.next,label:can?'Start':'Test has not started yet or has ended'}),hasPreviewsResult&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{backgroundColor:themeColor,primary:true,onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */].setNextStep('QUIZ_RESULT');},label:Object(__WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__["translate"])(_templateObject4)})));}}]);return QuizMessage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var QuizResult=function(_Component5){_inherits(QuizResult,_Component5);function QuizResult(){_classCallCheck(this,QuizResult);return _possibleConstructorReturn(this,(QuizResult.__proto__||Object.getPrototypeOf(QuizResult)).apply(this,arguments));}_createClass(QuizResult,[{key:'next',value:function next(){__WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */].setNextStep('QUIZ_INTRO');}},{key:'render',value:function render(){var _props5=this.props,title=_props5.title,score=_props5.score,total=_props5.total,content=_props5.content,data=_props5.data,hide=_props5.hide,Confetti=_props5.Confetti,enableRestartQuiz=_props5.enableRestartQuiz,themeColor=_props5.themeColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,typeof score==='number'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:classes.message},title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),Object(__WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__["translate"])(_templateObject5),': ',score,'/',total),!hide&&content.map(function(_ref){var taskResults=_ref.taskResults,pageModuleId=_ref.pageModuleId,task=_objectWithoutProperties(_ref,['taskResults','pageModuleId']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:task.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,task.caption&&task.caption.main),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Route_Task__["d" /* TaskResultList */],{reader:true,correctResponse:task.correctResponse,ListElement:__WEBPACK_IMPORTED_MODULE_4_components_Route_Task__["a" /* RadioTaskResult */],results:[taskResults&&taskResults[taskResults.length-1]],choices:task.caption&&task.caption.items,canGrade:false,taskId:task.id}),task.caption&&task.caption.comment&&taskResults[taskResults.length-1]&&!!diff(taskResults[taskResults.length-1].body.value,task.correctResponse.value).length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.comment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,Object(__WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__["translate"])(_templateObject6)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,task.caption.comment)));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:styles.startButtonContainer},enableRestartQuiz&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui__["RaisedButton"],{style:{marginTop:10},backgroundColor:themeColor,primary:true,onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_1_actions__["w" /* QuizActions */].setNextStep('QUIZ_MAIN');},label:Object(__WEBPACK_IMPORTED_MODULE_10_oxygen_i18n__["translate"])(_templateObject7)})),Confetti&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.confetti},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Confetti,{height:window.innerHeight,width:window.innerWidth})));}}]);return QuizResult;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (QuizContainer);function diff(a,b){return b.filter(function(i){return a.indexOf(i)<0;});}

/***/ }),
/* 2415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__confetti__ = __webpack_require__(2416);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReactConfetti=function(_React$Component){_inherits(ReactConfetti,_React$Component);function ReactConfetti(){_classCallCheck(this,ReactConfetti);return _possibleConstructorReturn(this,(ReactConfetti.__proto__||Object.getPrototypeOf(ReactConfetti)).apply(this,arguments));}_createClass(ReactConfetti,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(){return false;}},{key:'componentDidMount',value:function componentDidMount(){this.confetti=Object(__WEBPACK_IMPORTED_MODULE_1__confetti__["a" /* default */])(this.canvas).numberOfPieces(this.props.numberOfPieces).confettiSource(this.props.confettiSource).friction(this.props.friction).wind(this.props.wind).gravity(this.props.gravity).colors(this.props.colors).opacity(this.props.opacity).recycle(this.props.recycle).run(this.props.run)();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.confetti.numberOfPieces(nextProps.numberOfPieces).confettiSource(nextProps.confettiSource).friction(nextProps.friction).wind(nextProps.wind).gravity(nextProps.gravity).colors(nextProps.colors).opacity(nextProps.opacity).recycle(nextProps.recycle).run(nextProps.run);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,width=_props.width,height=_props.height,style=_props.style,numberOfPieces=_props.numberOfPieces,friction=_props.friction,wind=_props.wind,gravity=_props.gravity,colors=_props.colors,opacity=_props.opacity,recycle=_props.recycle,confettiSource=_props.confettiSource,run=_props.run,passedProps=_objectWithoutProperties(_props,['width','height','style','numberOfPieces','friction','wind','gravity','colors','opacity','recycle','confettiSource','run']);var canvasStyles=Object.assign({},{zIndex:2,position:'absolute',top:0,left:0,pointerEvents:'none',WebkitPointerEvents:'none',MozPointerEvents:'none'},style);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',Object.assign({width:width,height:height,ref:function ref(c){_this2.canvas=c;},style:canvasStyles},passedProps));}}]);return ReactConfetti;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ReactConfetti.defaultProps={numberOfPieces:300,confettiSource:{},friction:0.99,wind:0,gravity:0.1,colors:['#f44336','#e91e63','#9c27b0','#673ab7','#3f51b5','#2196f3','#03a9f4','#00bcd4','#009688','#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#FF9800','#FF5722','#795548'],opacity:1.0,recycle:false,run:true};/* harmony default export */ __webpack_exports__["a"] = (ReactConfetti);

/***/ }),
/* 2416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2417);
/**
 * Most of this was copied directly from the pen at http://codepen.io/Gthibaud/pen/BoaBZK
 * and halfheartedly converted to es6.
 */function confetti(canvas){var numberOfPieces=200;var confettiSource={x:0,y:0,w:canvas.width,h:0};var friction=0.99;var wind=0;var gravity=0.1;var colors=['#f44336','#e91e63','#9c27b0','#673ab7','#3f51b5','#2196f3','#03a9f4','#00bcd4','#009688','#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FFC107','#FF9800','#FF5722','#795548'];var opacity=1.0;var recycle=true;var run=true;function self(){var context=canvas.getContext('2d');function Particle(x,y){this.radius=__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* randomRange */](0.1,1);this.x=x;this.y=y;this.vx=__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* randomRange */](-4,4);this.vy=__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* randomRange */](-10,-0);this.type=__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* randomInt */](0,1);this.w=__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* randomRange */](5,20);this.h=__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* randomRange */](5,20);this.r=__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* randomRange */](5,10);this.angle=__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* degreesToRads */](__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* randomRange */](0,360));this.anglespin=__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* randomRange */](-0.2,0.2);this.color=colors[Math.floor(Math.random()*colors.length)];this.rotateY=__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* randomRange */](0,1);}Particle.prototype.update=function updateParticle(){this.x+=this.vx;this.y+=this.vy;this.vy+=gravity;this.vx+=wind;this.vx*=friction;this.vy*=friction;this.radius-=0.02;if(this.rotateY<1){this.rotateY+=0.1;}else{this.rotateY=-1;}this.angle+=this.anglespin;context.save();context.translate(this.x,this.y);context.rotate(this.angle);context.scale(1,this.rotateY);context.rotate(this.angle);context.beginPath();context.fillStyle=this.color;context.strokeStyle=this.color;context.globalAlpha=opacity;context.lineCap='round';context.lineWidth=2;if(this.type===0){context.beginPath();context.arc(0,0,this.r,0,2*Math.PI);context.fill();}else if(this.type===2){context.beginPath();for(var i=0;i<22;i++){var angle=0.5*i;var x=(0.2+1.5*angle)*Math.cos(angle);var y=(0.2+1.5*angle)*Math.sin(angle);context.lineTo(x,y);}context.stroke();}else if(this.type===1){context.fillRect(-this.w/2,-this.h/2,this.w,this.h);}context.closePath();context.restore();};function ParticleGenerator(source,number,text){// particle will spawn in this aera
this.x=source.x;this.y=source.y;this.w=source.w;this.h=source.h;this.number=number;this.particles=[];this.particlesGenerated=0;this.text=text;this.recycle=recycle;}ParticleGenerator.prototype.removeParticleAt=function removeParticleAt(i){this.particles.splice(i,1);};ParticleGenerator.prototype.getParticle=function addParticle(){var newParticleX=__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* randomRange */](this.x,this.w+this.x);var newParticleY=__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* randomRange */](this.y,this.h+this.y);return new Particle(newParticleX,newParticleY,this.text);};ParticleGenerator.prototype.animate=function animateParticle(){var _this=this;if(!run){return false;}var nP=this.particles.length;var limit=this.recycle?nP:this.particlesGenerated;if(limit<this.number){this.particles.push(this.getParticle());this.particlesGenerated+=1;}this.particles.forEach(function(p,i){p.update();if(p.y>canvas.height||p.y<-100||p.x>canvas.width+100||p.x<-100){if(recycle&&limit<=_this.number){// a brand new particle replacing the dead one
_this.particles[i]=_this.getParticle();}else{_this.removeParticleAt(i);}}});return nP>0||limit<this.number;};self.particleGenerator=new ParticleGenerator(confettiSource,numberOfPieces);self.update=function(){if(run){self.particleGenerator.number=numberOfPieces;// context.globalAlpha=.5;
context.fillStyle='white';context.clearRect(0,0,canvas.width,canvas.height);}if(self.particleGenerator.animate()){requestAnimationFrame(self.update);}else{run=false;}};self.update();return self;}self.numberOfPieces=function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}if(!args.length){return numberOfPieces;}numberOfPieces=args[0];if(self.particleGenerator){self.particleGenerator.number=numberOfPieces;}return self;};self.friction=function(){for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}if(!args.length){return friction;}friction=args[0];return self;};self.wind=function(){for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}if(!args.length){return wind;}wind=args[0];return self;};self.gravity=function(){for(var _len4=arguments.length,args=Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}if(!args.length){return gravity;}gravity=args[0];return self;};self.colors=function(){for(var _len5=arguments.length,args=Array(_len5),_key5=0;_key5<_len5;_key5++){args[_key5]=arguments[_key5];}if(!args.length){return colors;}colors=args[0];return self;};self.opacity=function(){for(var _len6=arguments.length,args=Array(_len6),_key6=0;_key6<_len6;_key6++){args[_key6]=arguments[_key6];}if(!args.length){return opacity;}opacity=args[0];return self;};self.recycle=function(){for(var _len7=arguments.length,args=Array(_len7),_key7=0;_key7<_len7;_key7++){args[_key7]=arguments[_key7];}if(!args.length){return recycle;}recycle=args[0];if(self.particleGenerator){self.particleGenerator.recycle=recycle;}return self;};self.confettiSource=function(){if(!arguments.length){return confettiSource;}confettiSource=Object.assign(confettiSource,arguments.length<=0?undefined:arguments[0]);return self;};self.run=function(){for(var _len8=arguments.length,args=Array(_len8),_key8=0;_key8<_len8;_key8++){args[_key8]=arguments[_key8];}if(!args.length){return run;}var wasRunning=run;var isRunning=args[0];run=isRunning;if(!wasRunning&&run){self.update();}return self;};return self;}/* harmony default export */ __webpack_exports__["a"] = (confetti);

/***/ }),
/* 2417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export norm */
/* unused harmony export lerp */
/* unused harmony export map */
/* unused harmony export clamp */
/* unused harmony export distance */
/* unused harmony export distanceXY */
/* unused harmony export circleCollision */
/* unused harmony export circlePointCollision */
/* unused harmony export inRange */
/* unused harmony export pointInRect */
/* unused harmony export rangeIntersect */
/* unused harmony export rectIntersect */
/* harmony export (immutable) */ __webpack_exports__["a"] = degreesToRads;
/* unused harmony export radsToDegrees */
/* harmony export (immutable) */ __webpack_exports__["c"] = randomRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = randomInt;
function norm(value,min,max){return(value-min)/(max-min);}function lerp(lnorm,min,max){return(max-min)*lnorm+min;}function map(value,sourceMin,sourceMax,destMin,destMax){return lerp(norm(value,sourceMin,sourceMax),destMin,destMax);}function clamp(value,min,max){return Math.min(Math.max(value,Math.min(min,max)),Math.max(min,max));}function distance(p0,p1){var dx=p1.x-p0.x;var dy=p1.y-p0.y;return Math.sqrt(dx*dx+dy*dy);}function distanceXY(x0,y0,x1,y1){var dx=x1-x0;var dy=y1-y0;return Math.sqrt(dx*dx+dy*dy);}function circleCollision(c0,c1){return distance(c0,c1)<=c0.radius+c1.radius;}function circlePointCollision(x,y,circle){return distanceXY(x,y,circle.x,circle.y)<circle.radius;}function inRange(value,min,max){return value>=Math.min(min,max)&&value<=Math.max(min,max);}function pointInRect(x,y,rect){return inRange(x,rect.x,rect.x+rect.width)&&inRange(y,rect.y,rect.y+rect.height);}function rangeIntersect(min0,max0,min1,max1){return Math.max(min0,max0)>=Math.min(min1,max1)&&Math.min(min0,max0)<=Math.max(min1,max1);}function rectIntersect(r0,r1){return rangeIntersect(r0.x,r0.x+r0.width,r1.x,r1.x+r1.width)&&rangeIntersect(r0.y,r0.y+r0.height,r1.y,r1.y+r1.height);}function degreesToRads(degrees){return degrees/(180*Math.PI);}function radsToDegrees(radians){return radians*180/Math.PI;}function randomRange(min,max){return min+Math.random()*(max-min);}function randomInt(min,max){return Math.floor(min+Math.random()*(max-min+1));}

/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stores_PageLayout__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Page_PageModuleMenu__ = __webpack_require__(2419);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageLayoutContainer=function(_mixin){_inherits(PageLayoutContainer,_mixin);function PageLayoutContainer(){_classCallCheck(this,PageLayoutContainer);return _possibleConstructorReturn(this,(PageLayoutContainer.__proto__||Object.getPrototypeOf(PageLayoutContainer)).apply(this,arguments));}_createClass(PageLayoutContainer,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'listenToStores',value:function listenToStores(){var _this2=this;this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_1_stores_PageLayout__["a" /* default */],function(state){return Object.assign({open:state.moduleMenuEnabled},_this2.mapActions({closeModuleMenu:__WEBPACK_IMPORTED_MODULE_2_actions__["t" /* PageLayoutActions */].closeModuleMenu,addPageModule:__WEBPACK_IMPORTED_MODULE_2_actions__["t" /* PageLayoutActions */].addPageModule}));});}},{key:'render',value:function render(){var _state=this.state,loading=_state.loading,open=_state.open,other=_objectWithoutProperties(_state,['loading','open']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Page_PageModuleMenu__["a" /* default */],Object.assign({open:open},other,this.props));}}]);return PageLayoutContainer;}(Object(__WEBPACK_IMPORTED_MODULE_3_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_3_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));PageLayoutContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,params:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,history:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (PageLayoutContainer);

/***/ }),
/* 2419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Cio_Drawer__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Cio_ScrollableContainer__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__ = __webpack_require__(2420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Cio_Toolbar__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_fp',hide:'_fq',row:'_fr',container:'_fs',column:'_ft'};var PageModuleMenu=function(_Component){_inherits(PageModuleMenu,_Component);function PageModuleMenu(){_classCallCheck(this,PageModuleMenu);return _possibleConstructorReturn(this,(PageModuleMenu.__proto__||Object.getPrototypeOf(PageModuleMenu)).apply(this,arguments));}_createClass(PageModuleMenu,[{key:'render',value:function render(){var _this2=this;var _props=this.props,closeModuleMenu=_props.closeModuleMenu,addPageModule=_props.addPageModule,other=_objectWithoutProperties(_props,['closeModuleMenu','addPageModule']);var getIntlMessage=this.context.getIntlMessage;var isQuiz=false;this.props.course.toc.forEach(function(section){if(section.type==='quiz'){var ids=section.pages.map(function(p){return p.id;});if(ids.includes(_this2.props.course.lastViewedPageId)){isQuiz=true;}}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_Cio_Drawer__["a" /* default */],Object.assign({slide:false,className:css.root,onRequestClose:closeModuleMenu},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_Cio_ScrollableContainer__["a" /* default */],{padded:true,header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Cio_Toolbar__["a" /* Toolbar */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Cio_Toolbar__["c" /* ToolbarGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Cio_Toolbar__["b" /* ToolbarButton */],{onTouchTap:closeModuleMenu,tooltip:getIntlMessage('Close')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Material_SvgIcons__["ContentClear"],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_Cio_Toolbar__["d" /* ToolbarTitle */],null,getIntlMessage('page.addContent')))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_7_classnames___default()(css.container,_defineProperty({},css.hide,!isQuiz))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__["a" /* default */],{type:'task',addPageModule:addPageModule}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_7_classnames___default()(css.container,_defineProperty({},css.hide,isQuiz))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__["a" /* default */],{type:'text',addPageModule:addPageModule}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__["a" /* default */],{type:'image',addPageModule:addPageModule})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__["a" /* default */],{type:'audio',addPageModule:addPageModule}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__["a" /* default */],{type:'video',addPageModule:addPageModule})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__["a" /* default */],{type:'task',addPageModule:addPageModule}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__["a" /* default */],{type:'download',addPageModule:addPageModule})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__["a" /* default */],{type:'discussion',addPageModule:addPageModule}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__["a" /* default */],{type:'slideshow',addPageModule:addPageModule})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__["a" /* default */],{type:'embed',addPageModule:addPageModule}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__["a" /* default */],{type:'webinar',addPageModule:addPageModule})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ModuleMenu_PageModuleMenuIcon__["a" /* default */],{type:'quiziframe',addPageModule:addPageModule}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.column})))));}}]);return PageModuleMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PageModuleMenu.propTypes={closeModuleMenu:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,addPageModule:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};PageModuleMenu.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (PageModuleMenu);

/***/ }),
/* 2420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Icons__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={column:'_f_',header:'_f-'};var styles={icon:{width:__WEBPACK_IMPORTED_MODULE_3_Css__["Units"].base*6,height:__WEBPACK_IMPORTED_MODULE_3_Css__["Units"].base*6}};var PageModuleMenuIcon=function(_Component){_inherits(PageModuleMenuIcon,_Component);function PageModuleMenuIcon(){_classCallCheck(this,PageModuleMenuIcon);return _possibleConstructorReturn(this,(PageModuleMenuIcon.__proto__||Object.getPrototypeOf(PageModuleMenuIcon)).apply(this,arguments));}_createClass(PageModuleMenuIcon,[{key:'render',value:function render(){var _props=this.props,type=_props.type,addPageModule=_props.addPageModule;var getIntlMessage=this.context.getIntlMessage;var Icon=void 0;if(type==='quiz'){Icon=__WEBPACK_IMPORTED_MODULE_1_components_Icons__[__WEBPACK_IMPORTED_MODULE_2_Constants__["pageModules"]['task'].icon];}else{Icon=__WEBPACK_IMPORTED_MODULE_1_components_Icons__[__WEBPACK_IMPORTED_MODULE_2_Constants__["pageModules"][type].icon];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.column,onTouchTap:function onTouchTap(){return addPageModule(type);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{color:'#777777',style:styles.icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},getIntlMessage('pageModule.'+type)));}}]);return PageModuleMenuIcon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PageModuleMenuIcon.propTypes={type:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,addPageModule:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};PageModuleMenuIcon.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (PageModuleMenuIcon);

/***/ }),
/* 2421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores_Course__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_Course__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Notes_NotesOverview__ = __webpack_require__(591);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotesContainer=function(_mixin){_inherits(NotesContainer,_mixin);function NotesContainer(){_classCallCheck(this,NotesContainer);return _possibleConstructorReturn(this,(NotesContainer.__proto__||Object.getPrototypeOf(NotesContainer)).apply(this,arguments));}_createClass(NotesContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_2_stores_Course__["a" /* default */]);}},{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_actions_Course__["a" /* default */].findNotes(this.props.courseId);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.notes.map(function(course){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Notes_NotesOverview__["a" /* default */],Object.assign({id:course.id,course:course,notes:course.sections},_this2.props));}));}}]);return NotesContainer;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (NotesContainer);

/***/ }),
/* 2422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ForgotPasswordForm__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_4_material_ui__["Styles"].Spacing;var ForgotPassword=function(_Component){_inherits(ForgotPassword,_Component);function ForgotPassword(){_classCallCheck(this,ForgotPassword);return _possibleConstructorReturn(this,(ForgotPassword.__proto__||Object.getPrototypeOf(ForgotPassword)).apply(this,arguments));}_createClass(ForgotPassword,[{key:'submit',value:function submit(email){__WEBPACK_IMPORTED_MODULE_5_actions__["b" /* AuthActions */].requestNewPassword(email);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppPage__["a" /* default */],{style:{backgroundColor:'transparent',backgroundImage:'url(../images/library.jpg)',backgroundPosition:'top left',backgroundRepeat:'no-repeat',backgroundSize:'cover',marginTop:-Spacing.desktopKeylineIncrement,paddingTop:Spacing.desktopKeylineIncrement,boxSizing:'initial'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Paper"],{zDepth:2,style:{backgroundColor:this.context.muiTheme.rawTheme.palette.cardColor,width:Spacing.desktopKeylineIncrement*5-20,margin:'auto',padding:Spacing.desktopGutterMini,paddingTop:Spacing.desktopGutter,paddingBottom:Spacing.desktopGutter,marginTop:Spacing.desktopKeylineIncrement}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_ForgotPasswordForm__["a" /* default */],{onSubmit:this.submit.bind(this)})));}}]);return ForgotPassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ForgotPassword.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (ForgotPassword);

/***/ }),
/* 2423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RestorePasswordForm__ = __webpack_require__(2424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_actions__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_4_material_ui__["Styles"].Spacing;var ForgotPassword=function(_Component){_inherits(ForgotPassword,_Component);function ForgotPassword(){_classCallCheck(this,ForgotPassword);return _possibleConstructorReturn(this,(ForgotPassword.__proto__||Object.getPrototypeOf(ForgotPassword)).apply(this,arguments));}_createClass(ForgotPassword,[{key:'submit',value:function submit(password,confirm){var key=this.props.params.key;__WEBPACK_IMPORTED_MODULE_5_actions__["b" /* AuthActions */].restorePassword(key,password,confirm);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AppPage__["a" /* default */],{style:{backgroundColor:'transparent',backgroundImage:'url(../images/library.jpg)',backgroundPosition:'top left',backgroundRepeat:'no-repeat',backgroundSize:'cover',marginTop:-Spacing.desktopKeylineIncrement,paddingTop:Spacing.desktopKeylineIncrement,boxSizing:'initial'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui__["Paper"],{zDepth:2,style:{backgroundColor:this.context.muiTheme.rawTheme.palette.cardColor,width:Spacing.desktopKeylineIncrement*5-20,margin:'auto',padding:Spacing.desktopGutterMini,paddingTop:Spacing.desktopGutter,paddingBottom:Spacing.desktopGutter,marginTop:Spacing.desktopKeylineIncrement}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_RestorePasswordForm__["a" /* default */],{onSubmit:this.submit.bind(this)})));}}]);return ForgotPassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ForgotPassword.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (ForgotPassword);

/***/ }),
/* 2424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Material_Spinner__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_1_material_ui__["Styles"].Spacing;var ForgotPasswordForm=function(_Component){_inherits(ForgotPasswordForm,_Component);function ForgotPasswordForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ForgotPasswordForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ForgotPasswordForm.__proto__||Object.getPrototypeOf(ForgotPasswordForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={displayName:localStorage&&localStorage.displayName,canSubmit:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ForgotPasswordForm,[{key:'resetLogin',value:function resetLogin(){this.setState({displayName:null});}},{key:'submit',value:function submit(e){var password=this.refs.password.getValue();var confirm=this.refs.confirm.getValue();e.preventDefault();if(this.props.onSubmit){this.props.onSubmit(password,confirm);}}},{key:'change',value:function change(){var password=this.refs.password.getValue();var confirm=this.refs.confirm.getValue();this.setState({canSubmit:password&&confirm&&password===confirm});}},{key:'render',value:function render(){var button=void 0;if(this.state.loading){button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{fullWidth:true,secondary:true,disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Material_Spinner__["a" /* default */],null));}else{button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["RaisedButton"],{disabled:!this.state.canSubmit,fullWidth:true,label:this.context.getIntlMessage('Reset'),secondary:true,onTouchTap:this.submit.bind(this)});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.submit.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_CoursioLogo__["a" /* default */],{initialFill:'#09BEC3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{style:{fontSize:'1.5em',color:__WEBPACK_IMPORTED_MODULE_5_components_Material_Styles_Colors__["a" /* Colors */].grey[500].material,padding:Spacing.desktopGutterMini*2}},this.context.getIntlMessage('password.reset'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{type:'password',onChange:this.change.bind(this),fullWidth:true,floatingLabelText:this.context.getIntlMessage('password.newPassword'),ref:'password'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{type:'password',onChange:this.change.bind(this),fullWidth:true,floatingLabelText:this.context.getIntlMessage('password.confirm'),ref:'confirm'}),button));}}]);return ForgotPasswordForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ForgotPasswordForm.propTypes={onSubmit:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func.isRequired,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};ForgotPasswordForm.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (ForgotPasswordForm);

/***/ }),
/* 2425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_Auth__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores_Auth__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_LoginForm__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Css__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Units=__WEBPACK_IMPORTED_MODULE_8_Css__["default"].Units;var css={root:'_z'};var Login=function(_mixin){_inherits(Login,_mixin);function Login(){_classCallCheck(this,Login);return _possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).apply(this,arguments));}_createClass(Login,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_3_stores_Auth__["a" /* default */]);}},{key:'listenToActions',value:function listenToActions(){var _this2=this;this.listenToAction(__WEBPACK_IMPORTED_MODULE_2_actions_Auth__["a" /* default */].loginSuccess,function(){var _props=_this2.props,params=_props.params,location=_props.location;var query=location.query;if(params.hash){return;}if(query&&query.nextPath&&query.nextPath!=='/logout'){_this2.props.router.replace(query.nextPath);}else{_this2.props.router.replace('/dashboard');}});}},{key:'componentDidMount',value:function componentDidMount(){if(this.state.loggedIn){this.props.router.replace('/logged-in');}else{__WEBPACK_IMPORTED_MODULE_2_actions_Auth__["a" /* default */].tryHashLogin();}}},{key:'onError',value:function onError(errorMessage){__WEBPACK_IMPORTED_MODULE_5_services_Message__["a" /* default */].info(errorMessage);}},{key:'handleSubmit',value:function handleSubmit(email,password){__WEBPACK_IMPORTED_MODULE_2_actions_Auth__["a" /* default */].login(email,password);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_AppPage__["a" /* default */],{className:css.root,style:{backgroundImage:'url(\''+__webpack_require__(660)+'\')'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_FullScreenDialog__["a" /* default */],{open:true,mini:true,toolbar:false,overlay:false,padded:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_LoginForm__["a" /* default */],{router:this.props.router,loggingIn:this.state.loading,onSubmit:this.handleSubmit.bind(this)})));}}]);return Login;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));Login.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (Login);

/***/ }),
/* 2426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions_Auth__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores_Auth__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_EventManager__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_Message__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_MediaQuery__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CountdownTimer__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_helpers__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_3_material_ui__["Styles"].Spacing;var Login=function(_mixin){_inherits(Login,_mixin);function Login(){_classCallCheck(this,Login);return _possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).apply(this,arguments));}_createClass(Login,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores_Auth__["a" /* default */]);}},{key:'redirect',value:function redirect(){__WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* history */].replace('/dashboard');}},{key:'componentDidMount',value:function componentDidMount(){if(this.state.loggedIn){__WEBPACK_IMPORTED_MODULE_10_helpers__["a" /* history */].replace('/logged-in');}}},{key:'onError',value:function onError(errorMessage){__WEBPACK_IMPORTED_MODULE_7_services_Message__["a" /* default */].info(errorMessage);}},{key:'handleSubmit',value:function handleSubmit(email,password){__WEBPACK_IMPORTED_MODULE_2_actions_Auth__["a" /* default */].login(email,password);}},{key:'render',value:function render(){var marginCss=this.context.media==='phone'?'auto':'100px auto auto';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_AppPage__["a" /* default */],{style:{backgroundColor:'transparent',backgroundImage:'url('+__webpack_require__(660)+')',backgroundPosition:'top left',backgroundRepeat:'no-repeat',backgroundSize:'cover',marginTop:-Spacing.desktopKeylineIncrement,paddingTop:Spacing.desktopKeylineIncrement,boxSizing:'initial'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["Paper"],{zDepth:2,style:{backgroundColor:this.context.muiTheme.rawTheme.palette.cardColor,width:Spacing.desktopKeylineIncrement*5-20,margin:marginCss,padding:Spacing.desktopGutterMini}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},this.context.getIntlMessage('login.redirectIncoming'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CountdownTimer__["a" /* default */],{seconds:5,color:'#777',alpha:0.3,size:128,onComplete:this.redirect.bind(this)}))));}}]);return Login;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));Login.contextTypes={muiTheme:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func,media:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string};/* harmony default export */ __webpack_exports__["a"] = (Login);

/***/ }),
/* 2427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_KlarnaConfirmation__ = __webpack_require__(2428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_selectors_store__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KlarnaConfirmationContainer=function(_mixin){_inherits(KlarnaConfirmationContainer,_mixin);function KlarnaConfirmationContainer(){_classCallCheck(this,KlarnaConfirmationContainer);return _possibleConstructorReturn(this,(KlarnaConfirmationContainer.__proto__||Object.getPrototypeOf(KlarnaConfirmationContainer)).apply(this,arguments));}_createClass(KlarnaConfirmationContainer,[{key:'listenToStores',value:function listenToStores(){this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_3_stores__["b" /* AuthStore */],function(state){return{loggedIn:state.loggedIn};});this.listenToStoreWithMapper(__WEBPACK_IMPORTED_MODULE_3_stores__["t" /* StoreOverviewStore */],function(state){return{owner:state.owner,theme:state.theme,cart:Object(__WEBPACK_IMPORTED_MODULE_4_selectors_store__["a" /* getCart */])(state),store:state.name,method:state.payment.method,discountCode:state.discountCode,paymentLoading:state.payment.loading,snippet:state.payment.data&&state.payment.data.snippet||''};});}},{key:'render',value:function render(){var transactionId=this.props.params.transactionId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_KlarnaConfirmation__["a" /* default */],Object.assign({},this.props,this.state,{transactionId:transactionId}));}}]);return KlarnaConfirmationContainer;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["a"] = (KlarnaConfirmationContainer);

/***/ }),
/* 2428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Route_Dashboard__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Css__ = __webpack_require__(6);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['Thank you!'],['Thank you!']),_templateObject2=_taggedTemplateLiteral(['',' is now available in your library.'],['',' is now available in your library.']),_templateObject3=_taggedTemplateLiteral(['Your course'],['Your course']),_templateObject4=_taggedTemplateLiteral(['OK, start learning!'],['OK, start learning!']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_eu',logo:'_ev',message:'_ew',header:'_ex',button:'_ey'};var KlarnaConfirmation=function(_Component){_inherits(KlarnaConfirmation,_Component);function KlarnaConfirmation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,KlarnaConfirmation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=KlarnaConfirmation.__proto__||Object.getPrototypeOf(KlarnaConfirmation)).call.apply(_ref,[this].concat(args))),_this),_this.state={confirmationOpen:true,klarnaDialog:true},_this.close=function(){_this.props.router.push('/dashboard');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(KlarnaConfirmation,[{key:'componentDidMount',value:function componentDidMount(){var transactionId=this.props.transactionId;__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].completePayment(null,__WEBPACK_IMPORTED_MODULE_5_Constants__["default"].paymentProviders.KLARNACHECKOUT,transactionId);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.snippet!==nextProps.snippet){var snippet=nextProps.snippet;var node=this.refs.klarnaDialog;node.innerHTML=snippet;var klarnaCode=node.getElementsByTagName('script')[0].text;//node.children[0].children[0].text;
var script=document.createElement('script');script.type='text/javascript';try{script.appendChild(document.createTextNode(klarnaCode));}catch(e){script.text=klarnaCode;}node.appendChild(script);}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,confirmationOpen=_state.confirmationOpen,klarnaDialog=_state.klarnaDialog;var _props=this.props,theme=_props.theme,cart=_props.cart;var _cart=_slicedToArray(cart,1),item=_cart[0];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Route_Dashboard__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__["a" /* default */],{maxi:true,open:confirmationOpen,title:'Congratulations'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.logo,style:{backgroundImage:'url('+theme.logoUrl+')'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.message},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject2,item&&item.name||Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject3)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.button,onTouchTap:this.close},Object(__WEBPACK_IMPORTED_MODULE_6_oxygen_i18n__["translate"])(_templateObject4)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_FullScreenDialog__["a" /* default */],{maxi:true,open:klarnaDialog,onRequestClose:function onRequestClose(){return _this2.setState({klarnaDialog:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:'klarnaDialog'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.button,onClick:function onClick(){return _this2.setState({klarnaDialog:false});}},'Continue')));}}]);return KlarnaConfirmation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);KlarnaConfirmation.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,params:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object};/* harmony default export */ __webpack_exports__["a"] = (KlarnaConfirmation);

/***/ }),
/* 2429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var Logout=function(_Component){_inherits(Logout,_Component);function Logout(){_classCallCheck(this,Logout);return _possibleConstructorReturn(this,(Logout.__proto__||Object.getPrototypeOf(Logout)).apply(this,arguments));}_createClass(Logout,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_1_actions__["b" /* AuthActions */].logout();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',marginTop:Spacing.desktopKeylineIncrement}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["CircularProgress"],{mode:'indeterminate'}));}}]);return Logout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Logout);

/***/ }),
/* 2430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_actions_Auth__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stores_Auth__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_AppPage__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_RulerBar__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Suggest__ = __webpack_require__(2431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(169);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spacing=__WEBPACK_IMPORTED_MODULE_2_material_ui__["Styles"].Spacing;var Incarnate=function(_mixin){_inherits(Incarnate,_mixin);function Incarnate(){_classCallCheck(this,Incarnate);return _possibleConstructorReturn(this,(Incarnate.__proto__||Object.getPrototypeOf(Incarnate)).apply(this,arguments));}_createClass(Incarnate,[{key:'listenToStores',value:function listenToStores(){this.listenToStore(__WEBPACK_IMPORTED_MODULE_4_stores_Auth__["a" /* default */]);}},{key:'incarnate',value:function incarnate(){var router=this.props.router;__WEBPACK_IMPORTED_MODULE_3_actions_Auth__["a" /* default */].incarnate(parseInt(this.refs.userId.getValue(),10),function(){router.replace('/dashboard');});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_AppPage__["a" /* default */],{key:'settings',header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_RulerBar__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:Spacing.desktopGutterMini}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Suggest__["a" /* default */],{hintText:'User id',ref:'userId',endpoint:'mr.wolf-user'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui__["RaisedButton"],{onEnterKeyDown:this.incarnate.bind(this),fullWidth:true,secondary:true,style:{zIndex:2},label:this.context.getIntlMessage('Incarnate'),onTouchTap:this.incarnate.bind(this)})));}}]);return Incarnate;}(Object(__WEBPACK_IMPORTED_MODULE_1_Util__["d" /* mixin */])(__WEBPACK_IMPORTED_MODULE_1_Util__["c" /* RefluxMixin */],__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));Incarnate.contextTypes={getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_router__["d" /* withRouter */])(Incarnate));

/***/ }),
/* 2431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Suggest=function(_Component){_inherits(Suggest,_Component);function Suggest(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Suggest);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Suggest.__proto__||Object.getPrototypeOf(Suggest)).call.apply(_ref,[this].concat(args))),_this),_this.state={endpoint:null,hintText:null,data:[],userId:0,closed:true},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Suggest,[{key:'onChangeState',value:function onChangeState(ev){var _this2=this;var token=this.refs.inputField.getValue();if(token.length<3&&isNaN(parseInt(token,10))){this.setState({closed:true});return null;}this.setState({closed:false});return SteelCompass.call(this.props.endpoint,'suggest',{token:token},function(response){if(response.isError){console.log('Ohmy!',response.errMsg);}else{_this2.setState({data:response.data});}});}},{key:'getValue',value:function getValue(){// return this.refs.inputField.getValue();
return this.state.data.length==1?this.state.data[0].id:this.state.userId?this.state.userId:null;}},{key:'pickSuggestion',value:function pickSuggestion(row){this.state.userId=row.id;this.refs.inputField.setValue(row.caption);this.setState({closed:true});}},{key:'render',value:function render(){var items=[];for(var i in this.state.data){var row=this.state.data[i];items.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'3px 5px',cursor:'pointer',lineHeight:'100%'},rowId:row.id,onClick:this.pickSuggestion.bind(this,row)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,row.caption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'70%'}},row.descr[0]+', '+row.descr[1]+', '+row.descr[2])));}if(this.state.closed){items=[];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{zIndex:3,position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui__["TextField"],{fullWidth:true,ref:'inputField',hintText:this.props.hintText,onChange:this.onChangeState.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'absolute',border:'1px solid #bbb',backgroundColor:'#fff'}},items));}}]);return Suggest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Suggest);

/***/ }),
/* 2432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_actions__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Wakeup=function(_Component){_inherits(Wakeup,_Component);function Wakeup(){_classCallCheck(this,Wakeup);return _possibleConstructorReturn(this,(Wakeup.__proto__||Object.getPrototypeOf(Wakeup)).apply(this,arguments));}_createClass(Wakeup,[{key:'componentDidMount',value:function componentDidMount(){var router=this.props.router;__WEBPACK_IMPORTED_MODULE_2_actions__["b" /* AuthActions */].wakeUp(function(){router.replace('/dashboard');});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return Wakeup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* withRouter */])(Wakeup));

/***/ }),
/* 2433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Util_refluxConnector__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stores__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Cio_AppPage__ = __webpack_require__(2434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Checkout__ = __webpack_require__(2435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Material_SvgIcons__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_entities_AppState__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_selectors_store__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={iconButton:{flex:'0 1',border:18,padding:20,width:64,height:64}};var css={root:'_a',header:'_b'};var CheckoutContainer=function(_Component){_inherits(CheckoutContainer,_Component);function CheckoutContainer(props){_classCallCheck(this,CheckoutContainer);var _this=_possibleConstructorReturn(this,(CheckoutContainer.__proto__||Object.getPrototypeOf(CheckoutContainer)).call(this,props));__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].addCart(_this.props.params.type,_this.props.params.id,_this.props.params.username);__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].read(_this.props.params.username);return _this;}_createClass(CheckoutContainer,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.countryCode){__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].read(this.props.params.username);}}},{key:'render',value:function render(){var username=this.props.params.username;var _props=this.props,owner=_props.owner,loggedIn=_props.loggedIn,toggleMainMenu=_props.toggleMainMenu;var header=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.header},loggedIn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui__["IconButton"],{style:styles.iconButton,onTouchTap:toggleMainMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Material_SvgIcons__["NavigationMenu"],{color:'rgba(0, 0, 0, 0.9)',hoverColor:'rgba(0, 0, 0, 0.5)'})));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_Cio_AppPage__["a" /* default */],{header:header},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Checkout__["a" /* default */],this.props)));}}]);return CheckoutContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CheckoutContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_Util_refluxConnector__["a" /* connect */])([[__WEBPACK_IMPORTED_MODULE_2_stores__["t" /* StoreOverviewStore */],function(state){var cart=Object(__WEBPACK_IMPORTED_MODULE_10_selectors_store__["a" /* getCart */])(state);return{cart:cart,isGift:Object(__WEBPACK_IMPORTED_MODULE_10_selectors_store__["j" /* isGift */])(state),name:state.name,activeDiscountCount:state.activeDiscountCount,paymentCompleted:state.payment.completed,open:cart.length>0&&!Object(__WEBPACK_IMPORTED_MODULE_10_selectors_store__["j" /* isGift */])(state),method:state.payment.method,countryCode:state.countryCode,allowedPaymentProviders:state.allowedPaymentProviders,owner:state.owner};}],[__WEBPACK_IMPORTED_MODULE_2_stores__["b" /* AuthStore */],function(state){return{loggedIn:state.loggedIn};}]],{setPaymentMethod:__WEBPACK_IMPORTED_MODULE_4_actions__["A" /* StoreOverviewActions */].setPaymentMethod,toggleMainMenu:__WEBPACK_IMPORTED_MODULE_9_entities_AppState__["a" /* AppStateActions */].toggleMainMenu})(CheckoutContainer));

/***/ }),
/* 2434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Util_refluxConnector__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_entities_AppState__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Material_MainMenu__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_helpers__ = __webpack_require__(31);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={root:'_fd',dense:'_fe',hasHeader:'_ff'};var AppPage=function(_Component){_inherits(AppPage,_Component);function AppPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AppPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AppPage.__proto__||Object.getPrototypeOf(AppPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={dense:false},_this.handleScroll=function(event){var scrollTop=document.body.scrollTop;var dense=_this.state.dense;if(!dense&&scrollTop>__WEBPACK_IMPORTED_MODULE_1_Css__["Units"].keyline*2){_this.setState({dense:true});}else if(dense&&scrollTop<=__WEBPACK_IMPORTED_MODULE_1_Css__["Units"].keyline*2){_this.setState({dense:false});}},_this.onMenuChange=function(event,key,payload){if(payload.route){__WEBPACK_IMPORTED_MODULE_6_helpers__["a" /* history */].push('/'+payload.route);}else if(payload.action&&_this[payload.action]){_this[payload.action](payload);event.preventDefault();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AppPage,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('scroll',this.handleScroll);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('scroll',this.handleScroll);}},{key:'render',value:function render(){var _classNames;var _props=this.props,header=_props.header,children=_props.children,mainMenuOpen=_props.mainMenuOpen,openMainMenu=_props.openMainMenu,closeMainMenu=_props.closeMainMenu;var dense=this.props.dense||this.state.dense;var classes=__WEBPACK_IMPORTED_MODULE_2_classnames___default()(css.root,(_classNames={},_defineProperty(_classNames,css.hasHeader,!!header),_defineProperty(_classNames,css.dense,dense),_classNames));if(header){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_MainMenu__["a" /* default */],{onRequestClose:closeMainMenu,zIndex:101,initialOpen:mainMenuOpen,onChange:this.onMenuChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(header,{dense:dense}),children);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Material_MainMenu__["a" /* default */],{onRequestClose:closeMainMenu,zIndex:101,initialOpen:mainMenuOpen,onChange:this.onMenuChange}),children);}}}]);return AppPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AppPage.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,header:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node,dense:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_Util_refluxConnector__["a" /* connect */])([[__WEBPACK_IMPORTED_MODULE_4_entities_AppState__["b" /* AppStateStore */],function(state){return{mainMenuOpen:state.mainMenuOpen};}]],{openMainMenu:__WEBPACK_IMPORTED_MODULE_4_entities_AppState__["a" /* AppStateActions */].openMainMenu,closeMainMenu:__WEBPACK_IMPORTED_MODULE_4_entities_AppState__["a" /* AppStateActions */].closeMainMenu})(AppPage));

/***/ }),
/* 2435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_RegisterForm__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Store_ItemDetails__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Store_PaymentMethodChooser__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_Store_KlarnaCheckoutForm__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers_Store_KlarnaOnlineForm__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_Store_StripeCheckoutForm__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_CountdownTimer__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Constants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Cio_Assets_PoweredBy__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TaC_StoreTaC__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['Purchase successfully completed. You will be redirected'],['Purchase successfully completed. You will be redirected']),_templateObject2=_taggedTemplateLiteral(['Purchase complete'],['Purchase complete']),_templateObject3=_taggedTemplateLiteral(['A gift code has been emailed to the address you provided. You can send the link in this email to the lucky person!'],['A gift code has been emailed to the address you provided. You can send the link in this email to the lucky person!']),_templateObject4=_taggedTemplateLiteral(['OK'],['OK']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var css={message:'_e_',root:'_e-',logo:'_fa',container:'_fb',buttonContainer:'_fc'};var Checkout=function(_Component){_inherits(Checkout,_Component);function Checkout(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Checkout);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Checkout.__proto__||Object.getPrototypeOf(Checkout)).call.apply(_ref,[this].concat(args))),_this),_this.state={tac:false},_this.handleComplete=function(){var _this$props=_this.props,isGift=_this$props.isGift,onComplete=_this$props.onComplete;var router=_this.props.router;__WEBPACK_IMPORTED_MODULE_10_actions__["A" /* StoreOverviewActions */].reset();router.push('/dashboard');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Checkout,[{key:'render',value:function render(){var _this2=this;var _props=this.props,loggedIn=_props.loggedIn,owner=_props.owner,router=_props.router,params=_props.params,activeDiscountCount=_props.activeDiscountCount,setPaymentMethod=_props.setPaymentMethod,allowedPaymentProviders=_props.allowedPaymentProviders,paymentCompleted=_props.paymentCompleted,isGift=_props.isGift,method=_props.method,countryCode=_props.countryCode,cart=_props.cart;var store=params.username;var tac=this.state.tac;var main=void 0;var _cart=_slicedToArray(cart,1),item=_cart[0];var hasKlarnaCheckout=(countryCode==='SE'||countryCode==='LT'||countryCode==='UA')&&item&&item.currency==='SEK';//(allowedPaymentProviders || []).findIndex(provider => provider === Constants.paymentProviders.KLARNACHECKOUT) > -1;
if(!loggedIn){main=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_RegisterForm__["a" /* default */],{userName:store,userLocale:owner.locale,router:router,onTac:function onTac(){return _this2.setState({tac:true});}});}else if(paymentCompleted&&!isGift){main=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.message},Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CountdownTimer__["a" /* default */],{seconds:9,color:'#777',alpha:0.3,size:128,onComplete:this.handleComplete}));}else if(paymentCompleted&&isGift){main=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject2)),Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject3),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.buttonContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui__["RaisedButton"],{fullWidth:true,secondary:true,onTouchTap:this.handleComplete,label:Object(__WEBPACK_IMPORTED_MODULE_12_oxygen_i18n__["translate"])(_templateObject4)}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:css.details},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:css.logo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_Cio_Assets_PoweredBy__["a" /* default */],{color:'#09BEC3',borderColor:'#09BEC3'}))));}else if(hasKlarnaCheckout){main=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_containers_Store_KlarnaCheckoutForm__["a" /* default */],{open:true,onRequestClose:this.handleRequestClose});}else{main=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_containers_Store_StripeCheckoutForm__["a" /* default */],{open:true,onRequestClose:this.handleRequestClose});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,main,tac&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TaC_StoreTaC__["a" /* default */],{username:store,open:tac,onRequestClose:function onRequestClose(){return _this2.setState({tac:false});}}));}}]);return Checkout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Checkout.propTypes={children:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].node};/* harmony default export */ __webpack_exports__["a"] = (Checkout);

/***/ }),
/* 2436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({locales:["sv-SE"],messages:{webinar:{fullScreen:"Fullskärm",useCoursio:"Använd Coursio-konto för moduler på webinar",missedSettings:"Vänligen ställ in dina webinarinställningar eller använd ditt Coursio-konto",domain:"Domän",description:"Beskrivning",roomName:"Rumsnamn",enter:"Skriva in",isWebinar:"Vänligen välj modultyp:"},user:{updated:"Användarens rättigheter är uppdaterade"},login:{success:"Välkommen",loggedOut:"Vi ses snart igen",redirectIncoming:"Du är redan inloggad, vi laddar nu ditt konto",toDashboard:"Logga in på din sida"},bug:{report:"Support",reportTitle:"Skicka förfrågan",describe:"För kursrelaterade frågor var god kontakta kursskaparen. För platforms relaterade frågor var snäll och beskriv den här.",reported:"Din förfrågan har skickats.",reportFailed:"Vi kunde inte ta emot din förfrågan."},coursio:{welcome:"Välkommen till Coursio"},dashboard:{remove:"Är du säker?",removed:"Kursen har blivit borttagen",filterAll:"Alla",filterCompleted:"Genomförda",filterNotCompleted:"Inte slutförda",filterExpiresSoon:"Går ut snart",filterGood:"Bra",filterNew:"Nya",filterPaid:"Betald",filterRegistered:"Registrerad",filterRefunded:"Återbetald",filterCancelled:"Avbryts",filterError:"Error",filterOwn:"Egna Kurser",filterOthers:"Inbjudna Kurser",sortLastVisit:"Senaste besökte",sortCreated:"Senaste skapade",filterAndSort:"Välj Filtrering och Sortering",filter:"Välj Filtrering",filterTitle:"Filtrera",sortTitle:"Sortera efter"},ozitor:{url:"URL",openInNewTab:"Öppna i ny flik",createLink:"Skapa länk",more:"Mer",less:"Mindre"},students:{students:"Deltagare",invitations:"Inbjudningar"},course:{nameTooLong:"Kursnamnet får inte överstiga 50 tecken.",buy:"Köp kurs",Courses:"Kurser",category:"Kategori",remove:'Ta bort kurs "{course}?',removed:"Kursen har tagits bort",revokeAccess:"Ta bort tillgänglighet",show:"Visa kurs",noSelected:"Inga kurser valda",choose:"Välj kurser",setAccess:"Välj tillgänglighetstid",lastViewedPage:"Sista besökta sida",whatIs:"Vad är en online kurs?",studentsInvited:"Deltagare har blivit inbjudna till kursen.",groupsInvited:"Grupper har blivit inbjudna till kurs",goto:"Gå till kurs",new:"Kursnamn",add:"Lägg till kurs",tableOfContents:"Innehållsförteckning",access:"Åtkomst to.m: ",dateSaved:"Tillgång datum har sparats",forever:"Oändlig"},group:{Groups:"Grupper",remove:"Ta bort grupp?",add:"Lägg till grupp",removed:"Gruppen har tagits bort",create:"Ny grupp",name:"Gruppnamn",expunge:"Ta även bort alla rättigheter om är kopplade till denna grupp.",doesNotExist:"Gruppen existerar inte",noSelected:"Ingen grupp vald",revokeAccess:'Ta bort tillgång för grupp "{group}" till "{course}"?',revokedAccess:"Tillgången har tagits bort för gruppen.",show:"Visa grupp",choose:"Välj grupp",removeCourse:"Ta bort kurs",removeCourseConfirm:"Är du säker på att du vill ta bort kursen från gruppen?",removeStudent:"Ta bort deltagare",removeStudentConfirm:"Är du säker på att du vill ta bort deltagaren från gruppen?",removeInvite:"Ta bort inbjudan",removeInviteConfirm:"Är du säker på att du vill ta bort inbjudan från gruppen?",removedInvite:"Inbjudan har tagits bort",coursesAdded:"Kurs(er) tillagda",courseRemoved:"Kurs borttagen",editing:"Redigering Gruppnamn",send:"Skicka till mig"},student:{active:"Aktiv {ago}.",neverActive:"Deltagaren har aldrig varit inloggad",Students:"Deltagare",delete:"Ta bort deltagare",Invited:"Inbjuden",Registered:"Registrerad",remove:'Ta bort deltagare "{student}"?',removed:"Deltagaren har blivit borttagen",removeFromCourse:"Ta bort från kurs",revokeAccess:'Ta bort tillgång för deltagare "{student}" från kurs "{course}"?',revokedAccess:"Tillgång har blivit borttagen",show:"Visa deltagare",removeFromGroupShort:"Ta bort från grupp?",removeFromGroup:'Ta bort deltagare "{student} från grupp "{group}" ?',removedFromGroup:"Deltagaren har blivit borttagen från gruppen",addedToGroup:"Deltagaren har blivit tillagd i gruppen.",multiAddedToGroup:"Deltagare har blivit tillagda i gruppen.",choose:"Välj deltagare",addToCourseShort:"Lägg till kurs",add:"Lägg till deltagare",inviteNew:"Bjud in deltagare",exportDone:"Exporten är skickad till din mail.",exportStatisticDone:"Statistisk export skickades till din mail.",expel:"Radera deltagarekonto",expelConfirm:'Uppmärksamhet! Är du säker på att du vill ta bort deltagaren "{student}"? Efter denna åtgärd "{student}" kommer att tas bort för alltid från alla kurser och grupper ',expelDone:"Deltagaren har tagits bort från alla dina kurser och grupper",noSelected:"Ingen deltagare vald"},menu:{StudentManagement:"Användarhantering",Tasks:"Uppgifter",Quiz:"Quiz",Notes:"Noteringar",Stripe:"Stripe",Dashboard:"Startsida",Notification:"Notifieringar",Settings:"Inställningar",Incarnate:"Incarnate",Invite:"Bjud in",Wakeup:"Wake up",Logout:"Logga ut",Courses:"Kurser",ECommerce:"E-handel",Store:"Butik",saleStats:"Statistik",Transactions:"Transaktioner",Discounts:"Rabattkod",Bundles:"Paket",mediaLibrary:"Media bibliotek",Back:"Tillbaka",Help:"Hjälp",SubAccounts:"Underkonton",TaC:"Villkor"},invite:{studentInvitedToCourse:"Deltagaren har blivit inbjuden till kursen.",groupInvitedToCourse:"Gruppen har blivit inbjuden till kursen.",chooseCourses:"Välj grupp(er)",chooseGroups:"Välj grupp(er)",chooseStudents:"Välj deltagare",selectedCourses:"Valda kurser",selectedGroups:"Valda grupper",selectedStudents:"Deltagare",existingStudents:"Befintliga deltagare",newStudents:"Nya deltagare",groups:"Grupper",summary:"Sammanfattning",summaryExplanation:"Nedan finns en sammanfattning av dina val.",accessTime:"Tillgänglighetstid",willHaveAccessTill:"Deltagarna kommer ha tillgång till kurserna t.o.m",willHaveAccessFor:"Deltagarna kommer ha tillgång till kurserna i",chooseCourseExplanation:"Vänligen välj en eller flera kurser att bjuda in deltagaren till",chooseAccessTime:"Välj tillgänglighetstid",chooseAccessTimeExplanation:"Vänligen välj hur lång tid deltagaren ska ha tillgång till kursen/erna efter att ha loggat in första gången",chooseEndDate:"Välj ett slutdatum",chooseEndDateExplanation:"Vänligen välj t.o.m vilket datum gruppen ska ha tillgång till kursen/erna",chooseStudentsOrGroups:"Vill du bjuda in deltagare eller grupper?",Unlimited:"Oändlig tillgång",oneMonth:"En månad",threeMonths:"Tre månader",sixMonths:"Sex månader",oneYear:"Ett år",oneAndHalfYear:"Arton Månader",twoYears:"Två år",accessMonths:"{months} month(s)",enterEmail:"Skriv in mailadresser",confirmSend:"Bekräfta och skicka",sendInvite:"Skicka inbjudan",sentOut:"Inbjudningarna har blivit skickade.",Invites:"Inbjudningar",foundEmails:"Mailadresser",createTags:"Tags",addToGroup:"Lägg till i grupp",createGroupExplanation:"Skriv in ett namn för den nya gruppen",success:"Grattis, du har nu bjudit in dina deltagare! Vill du:",inviteMore:"Bjuda in fler?"},invitation:{expired:"Tidsramen för inbjudningslänken har utgått och kan inte användas längre.",used:"Inbjudningslänken har redan blivit använd och kan inte användas på nytt.",remove:"Ta bort",revokeAccess:"Ta bort tillgång?",resend:"Återsänd inbjudan",resendAll:"Återsänd inbjudningar till alla",prolongAccess:"Återsänd inbjudan för kursen?",resent:"En inbjudan har skickats på nytt.",resentAll:"En inbjudan har skickats på nytt till alla.",accept:"Acceptera inbjudan",accepted:"Inbjudan accepterad",redirectIncoming:"Du kommer att omdirigeras till startsidan.",acceptText:"Vänligen slutför din inbjudan genom att klicka på knappen nedan. Inbjudan blev skickad till {email}",chosen:"Skicka inbjudan till vald e-post",notChosen:"Ingen e-post valdes för att skicka en inbjudan till",admin:"Adminrättigheter"},bundle:{updated:"Paket uppdaterat.",new:"Nytt paket",remove:"Ta bort paket",removed:"Paket borttaget.",removeCourse:"Ta bort kurs",removedCourse:"Kurs borttagen från paketet.",removeCourseConfirm:"Är du säker på att du vill ta bort kursen?",removeBundle:"Är du säker på att du vill ta bort paketet {bundle}?",name:"Namn på paketet",in1:"{courseCount} kurser i ett paket",choose:"Välj paket"},item:{read:"Markera som läst"},discount:{new:"Ny rabattkod",remove:"Ta bort rabattkod",removed:"Rabattkod borttagen",removeDiscount:"Är du säker på att du vill ta bort rabattkod «{discount}»?",activate:"Aktivera kod",code:"Rabattkod",enterCode:"Ange kod (max 30 tecken)",codeRestriction:"Koden kan inte vara längre än 30 tecken",amount:"Belopp",active:"Aktiv",limitedUse:"Begränsad användning",Start:"Start",End:"Slut",Activation:"Aktivering",Manual:"Manuell",Date:"Datum",All:"Alla",Selected:"Valda",amountMustBeNumeric:"Beloppet måste vara numeriskt.",codeRequired:"Kod krävs",used:"{count} / {maxCount} använda",applied:"Rabattkod applicerad.",typeAbsolute:"Belopp",typePercentage:"Procent",affectedObjects:"Specifik kurs",affectedPackages:"Specifika paket ",discount:"Rabatt",type:"Rabatt typ"},transaction:{completed:"Avslutad",resendReceipt:"Skicka om kvitto",refund:"Återbetalning",refunded:"Återbetald",receiptResent:"Kvittot har skickats igen.",refundDone:"Återbetalning genomförd",exportDone:"Statistik på inkommande transaktioner är skickad till din e-mail.",date:"Datum",showDetails:"Visa detaljer",name:"Namn",coursePackage:"Kurs/Paket",amount:"Belopp",new:"Nya",registered:"Registrerad",paid:"Betald",good:"Bra",error:"Fel",cancelled:"Avbryts"},export:{startDate:"Startdatum",endDate:"Slutdatum",course:"Exportera kursdeltagare",statistic:"Exportera detaljerad uppgiftsstatistik",user:{withInactive:"Inkludera inaktivera användare",withProgress:"Inkludera kurs statistik"},userStats:"export användarstatistik"},image:{upload:"Ladda upp bild",importFailed:"Importen gick inte igenom, vänligen försök igen.",imported:"Bilden har blivit importerad.",provideImportUrl:"Opps, du glömde att lägga till en url",confirmDelete:"Är du säker på att du vill ta bort bilden?",delete:"Ta bort bild"},audio:{upload:"Ladda upp ljudklipp",importFailed:"Importen gick inte igenom, vänligen försök igen.",imported:"Ljudklippet har blivit importerad",confirmDelete:"Är du säker på att du vill ta bort ljudklippet",embed:"Klistra in Spofify eller SoundCloud länk",download:'Ladda ner ljud som: '},text:{confirmDelete:"Är du säker på att du vill ta bort textmodulen?"},module:{confirmDelete:"Är du säker på att du vill ta bort modulen?",removeImage:"Ta bort bild",dropOneFile:"Släpp en fil här",dropImage:"Släpp en bild här",dropImages:"Släpp en eller flera bilder här",youCanImport:"eller klistra in en länk",or:"eller",dropVideo:"Släpp en video här",dropAudio:"Släpp en ljudfil här",uploadOrBrowse:"Du kan också {upload} eller infoga från {library}",upload:"ladda upp",uploadFile:"Ladda upp en fil",uploadImage:"Ladda upp en bild",uploadAudio:"Ladda upp en ljudfil",uploadVideo:"Ladda upp en video",library:"bibliotek"},Roles:"Roller",role:{accountant:"Revisor",reader:"Deltagare",editor:"Redaktör",teacher:"Lärare",owner:"Ägare",darkAdmin:"Sith",assistant:"Assistant",tester:"Testare"},video:{upload:"Ladda upp video",importFailed:"Importen gick inte igenom, vänligen försök igen.",imported:"Video har blivit importerad",confirmDelete:"Är du säker på att du vill ta bort videon?",embed:"Klistra in Youtube, Vimeo eller Wistia länk",changesSaved:"Ändringar har sparts",changesCannotBeSaved:"Link är inte korrekt",allowDownloading:"Tillåt nedladdning",download:"Ladda ner"},download:{upload:"Ladda upp fil",confirmDelete:"Är du säker på att du vill ta bort filen?"},discussion:{confirmDelete:"Är du säker på att du vill ta bort diskussionen?"},slideshow:{confirmDelete:"Är du säker på att du vill ta bort bildspelet?"},tasks:{noInfo:"Det finns inget att visa",noTasks:"No tasks requiring your attention found",findCourse:"Hitta kurs",findGroup:"Hitta grupp",findStudent:"Hitta elev",showCorrected:"Visa korrigerade uppgifter",fileRemoved:"Filer borttagna",fileNotRemoved:"Kunde inte ta bort filer",fileUploaded:"Fil bifogad, klicka på SKICKA för att skicka in ditt svar.",students:"Elever",courses:"Kurser",corrected:"Visa korrigerade uppgifter",openEnded:"Öppen fråga",correct:"Rätt",incorrect:"Fel",defineTask:"Skriv in fråga",defineQuestion:"Skriv en fråga",emptyChoice:"Nytt svar",addChoice:"Lägg till svar",description:"Skriv in fråga",submit:"Svara",attach:"Bifoga fil",answer:"Svara",answerOpenEnded:"Skicka",noAnswer:"Inget svar angivet",provideAnswer:"Skriv in ditt svar",feedback:"Feedback",provideFeedback:"Vänligen ge användaren feedback",type:"Uppgiftstyp",chooseType:"Välj uppgiftstyp",answeredCount:"{answered}/{count} uppgifter",question_description:"Beskriv frågan",noAnsweredTasks:"Inga uppgifter",singleChoice:"Ett val",multipleChoice:"Flerval",text:"Öppen",pleaseChooseOne:"Vänligen välj en",remove:"Ta bort uppgift",confirmDelete:"Är du säker på att du vill ta bort uppgiften?",feedbackSent:"Din feedback har skickats",redoanswer:"Rätta igen",answerSent:"Ditt svar har skickats till kursskaparen",showMore:"Visa alla resultat",showLatest:"Visa senaste resultat"},post:{confirmDelete:"Är du säker på att du vill ta bort ditt inlägg?",writeAComment:"Skriv en kommentar",describeDiscussion:"Diskussions ämne"},pageModule:{quiz:"Lägg till en fråga",quizQuestionErrorTitle:"Felaktig fråga",quizQuestionErrorMessage:"Sidan innehåller en fråga som saknar korrekt alternativ eller inte har några alternativ",quizCommentOnQuestion:"Motivera det rätta svaret",add:"Lägg till modul",text:"Text",video:"Video",image:"Bild",audio:"Ljud",task:"Uppgift",webinar:"Webinar",download:"Nedladdningsbart",discussion:"Diskussion",slideshow:"Bildspel",created:"Modul tillagd",layout:"Översikt",embed:"Embed",quiziframe:"Quiz"},card:{number:"Kortnummer"},account:{Account:"Konto",register:"För att komma åt en kurs du behöver för att skapa en Coursio konto. Vänligen fyll i dina uppgifter nedan:",need:"För att köpa kursen så behöver du ett Coursio konto, fyll i dina uppgifter nedan:",create:"Create account",have:"Har du redan ett Coursio konto?"},toc:{search:"Sök i kursen",accept:"Genom att registrera ditt konto så accepterar du våra användarvillkor {toc}",toc:"Coursios Användarvillkor.",close:"Stäng innehållsförteckning",open:"Öppna"},mediaLibrary:{filesRemaining:"filer kvarstår",addNew:"Lägg till ny",Delete:"Ta bort",listView:"Listvy",thumbView:"Miniatyrbild",type:"Typ",remove:"Ta bort fil",removed:"Fil borttagen.",uploadFiles:"Uppladdade filer",removeConfirm:'Är du säker på att du vill ta bort "{file}"?',removeFilesConfirm:"Är du säker på att du vill ta bort filerna?",uploadComplete:"Uppladdning genomförd.",dropHere:"Släpp filer här",Uploading:"Laddar upp...",Upload:"Uppladdad",createDir:"Skapa mapp",directoryName:"Namge mappen"},page:{addContent:"Lägg till modul",new:"Ny sida",remove:"Ta bort sida",rename:"Byt namn på sida",duplicate:"Duplicera sida",confirmDelete:"Är du säker på att du vill ta bort sidan?"},section:{paste:"Klistra in sektion",new:"Nytt avsnitt",remove:"Ta bort avsnitt",confirmDelete:"Är du säker på att du vill ta bort avsnittet?"},payment:{connectToStripe:"Anslut till Stripe",payWithStripe:"Betala med stripe",chooseMethod:"Välj betalningsalternativ",fillInDetails:"Fyll i dina uppgifter",Taxamo:"Kortbetalning",Klarna:"Klarna",next:"Nästa",completePurchase:"Slutför köp",creditCard:"Kortbetalning",klarna:{phone:"Telefon",zipCode:"Postnummer",emailError:"Vänligen fyll i en korrekt mailadress",phoneError:"Vänligen fyll i en korrekt telefonnummer",zipCodeError:"Vänligen fyll i ett korrekt postnummer",personalNumberError:"Vänligen fyll i ett korrekt personnummer",personalOrganisationalNumber:"Personnummer/ Organisationsnummer",email:"E-mail",next:"Nästa",personalNumberFormat:"ÅÅÅÅMMDD-XXXX",phoneNumberFormat:"0XX XX XXXX",emailFormat:"someone@coursio.com",zip:"Postnummer",invoice:"Faktura",account:"Konto",address:"Adress",street:"Adress",firstName:"Förnamn",lastName:"Efternamn",city:"Stad",country:"Land"},hint:{creditCardNumber:"XXXXXXXXXXXXXXXX",expYear:"ÅÅÅÅ",expMonth:"MM",cvc:"XXX"},validation:{invalidYear:"Ogiltigt år. Måste skrivas in likt ÅÅÅÅ (2020)",invalidMonth:"Ogiltig månad. Måste skrivas in likt MM (12)",invalidCvC:"Felaktig CVC: Måste skrivas in likt XXX (123)",invalidCreditCard:"Inkorrekt kortnummer, måste vara 16 siffror långt"},stripe:{number:"Kortnummer",year:"Giltigt till år",month:"Giltigt till månad",cvc:"CVC"}},validation:{invalidEmail:"Skriv in en korrekt e-mailadress",required:"Du måste fylla i detta fält",passwordTooShort:"Ett lösenord måste innehålla minst 6 tecken"},password:{restoreLinkMailed:"Ett mail har skickats med instruktioner på hur du byter ditt lösenord.",reset:"Ändra lösenord",newPassword:"Nytt lösenord",changed:"Ditt lösenord har ändrats",confirm:"Bekräfta",fillIn:"Fyll i båda fälten"},loadMore:"Ladda mer",areYouSure:"Är du säker?",Copy:"Kopia",Copied:"Kopierad",OK:"OK",Cancel:"Avbryt",Yes:"Ja",No:"Nej",Reset:"Nollställ",Sort:"Sortera",Filter:"Filtrera",Create:"Skapa",Invite:"Bjud in",Export:"Exportera",Course:"Kurs",Courses:"Kurser",Group:"Grupp",Time:"Tid",Groups:"Grupper",Email:" E-postadress",Student:"Deltagare",Report:"Rapportera",Students:"Deltagare",Status:"Status",Search:"Sök",Never:"Aldrig",Buy:"Köp",Support:"Support",Expired:"Utgått",selectAll:"Markera alla",deselectAll:"Avmarkera alla",revokeAccess:"Ta bort tillgång?",noResults:"Inget hittades",resultsFiltered:"Resultat filtrerat",selectedCount:"{num, plural, =0{Inga valda} other{# valda}}",Next:"Nästa",addFrom:"Lägg till från",Login:"Logga in",Authenticating:"Autentiserande",Caption:"Bildtext",Other:"Annat",importFromUrl:"Importera från URL",Upload:"Ladda upp",Import:"Importera",Embed:"Bädda in",Reply:"Svara",Follow:"Följ",Unfollow:"Sluta följa",Send:"Skicka",SortMessages:"Sortera meddelanden",attachFile:"Bifoga fil",nextPage:"Nästa sida",Modules:"Moduler",Layout:"Översikt",Undo:"Ångra",Deleted:"Borttagen.",Delete:"Ta bort",Discount:"Rabatt",Private:"Privat",Public:"Publik",TermsAndConditions:"Användarvillkor",copyright:"Copyright {year} av {name}",poweredBy:"Powered by {engine}",forgotPassword:"Glömt ditt lösenord?",loginWithGoogle:"Logga in med Google",loginWithFacebook:"Logga in med Facebook",welcomeBack:"Välkommen tillbaka, {user}!",useOtherLogin:"Använd ett annat inlogg",VAT:"Moms",fullName:"Namn",firstname:"Förnamn",lastname:"Efternamn",noTasksOrNotifications:"Inga öppna svar eller diskussioner",Branding:"Temasättning",Notifications:"Notifieringar",or:"eller",Remove:"Ta bort",Save:"Spara",Add:"Addera",Clear:"Rensa",Logout:"Logga ut",gift:{explanation:"När du köper en kurs som en present, får du en presentkod skickad till din e-post.",warning:"Viktigt att tänka på! Ange din egen e-post, inte mottagarens e-post.",purchaseComplete:"Köp genomfört",nextStep:"En presentkod har skickats till e-postadressen du angav. Ge den koden till mottagaren av presenten!",thisCourse:"Ge bort denna kurs",email:"Skriv in din Email",confirm:"Verifiera din Email",emailMustMatch:"Emailadresserna matchar inte.",expired:"Presentkoden har utgått och kan därför inte användas längre.",used:"Presentkoden har redan använts och kan därför inte användas igen.",accepted:"Presenten accepterad",help:"Om du använt presentkoden och fått tillgång till kursen loggar du in här-> app.coursio.com/login",acceptText:"Du har varit snäll!",acceptSubText:"Skriv in din presentkod för att komma åt kursen.",redirectIncoming:"Du kommer nu att dirigeras till startsidan",redirectLoginPage:"Du kommer nu att dirigeras till inloggningssidan.",needCoursioAccount:"För att ta del av kursen så behöver du ett Coursio konto.",doesNotExist:"This gift code does not exist."},store:{smallCards:"Cards",bigCards:"Big Cards",giftCourse:"Köp som gåva",buyFor:"Köp för {price}",join:"Köp",goto:" Gå till butiken",edit:"Editera",takeCourse:"Gå kurs",video:"Video URL",price:"Pris",private:"Privat",public:"Publik",purchaseSuccess:"Ditt köp gick igenom.",chooseVideo:"Vänligen klistra in en video URL från YouTube, Vimeo eller Wistia.",yourCourseLeader:"Din kursledare",joinCourse:"Köp kurs",aboutThisCourse:"Om kursen",aboutThisPack:"Om paketet",courseContent:"Kursinnehåll",aboutAuthor:"Om {author}",aboutAuthorInfo:"Information om kursledaren",courseCount:"Kurser ({count})",name:"Webshops namn",grossPrice:"Pris (ink MOMS)",packOf:"Paket av {count}",noOwnerInfo:"Ingen information om kursledaren ännu",chooseCategory:"Välj kategori"},settings:{SendBulletin:'Skickar bulletiner',Bulletin:'Bulletin',Webinar:'Webinar',Docs:"Dokument",termsAndConditions:"Användarvillkor",courseExplanation:"Vad är en kurs?",support:"Support",aboutMe:"Om mig",storeHeadline:"Webshops header",storeBackground:"Webshopens bakgrund",readerMode:"Deltagarläge",disableScaling:"Inaktivera skalning",enableScaling:"Aktivera skalning",builderMode:"Skaparläge",displayName:"Visningsnamn",firstName:"Förnamn",lastName:"Efternamn",language:"Språk",email:"E-mail",logo:"Logotyp",color:"Färg",currency:"Valuta",saved:"Inställningar sparade",avatar:"Profilbild",Account:"Konto",Account2:"Användarinställningar",Stripe:"Stripe",Builder:"Skapare",Branding:"Tema",ssn:"Organisationsnummer",phone:"Telefon",address:"Adress",zip:"Postnummer",city:"Stad",country:"Land",Codes:"Koder",Notifications:"Notifieringar",gaCode:"Google Analytics kod",fbCode:"Facebook Pixel kod",gaGtm:"Google Tag Manager kod",checkoutCode:"Utcheckningskod",ECommerce:"E-handel",currentPassword:"Nuvarande Lösenord"},subAccount:{attention:"Varning! Du kommer nu att loggas in som användaren. Alla ändringar du gör kommer att sparas på detta konto.",incarnate:"Logga in",incarnated:"(Extern inloggning)"},note:{yourNote:"Dina anteckningar..."},Register:"Registrera",notification:{NOTIFICATION_ADDED_TO_CIRCLE:"Tillagd till grupp",NOTIFICATION_TASK_FEEDBACK:"Feedback på uppgift",NOTIFICATION_DRIP_CONTENT:"Droppinnehåll",NOTIFICATION_POST_ADDED:"Inlägg tillagd",NOTIFICATION_TASK_ASSESSED:"Uppgift rättad",NOTIFICATION_YOU_MENTIONED:"Någon nämnde dig",NOTIFICATION_FEEDBACK_REQUIRED:"Feedback efterfrågad",NOTIFICATION_UNREVIEWED_TASKS:"Orättade uppgifter",NOTIFICATION_THREAD_NEW_POSTS:"Nytt inlägg i diskussion",NOTIFICATION_COURSE_NEW_POSTS:"Nytt inlägg i kurs",NOTIFICATION_COURSE_SOLD:"Kurs såld",NOTIFICATION_COURSE_PACKAGE_SOLD:"Kurspaket sålt",NOTIFICATION_ADDED_TO_COURSE:"Tillagd till kurs",removed:"Nya anmälningar markerades som lästa",readAll:"Markera meddelanden som lästa",NOTIFICATION_DATA_EXPORT:"Data export",NOTIFICATION_COURSE_INVITE:"Kursinbjudan",NOTIFICATION_BROADCAST:"Broadcast"},emailStatus:{error:"Error (Detta betyder oftast att mailet inte skickades) ",sent:"Skickat",bounced:"Bounced",rejected:"Rejected",unknown:"Okänd mailadress"},about:{support:' Vänligen kontakta <a href="mailto:support@coursio.com">support@coursio.com</a> för teknisk support.'},personalSettings:"Privata inställningar",tag:{name:"Tag namn",add:"Lägg till tag"},aboutCoursio:"Coursio är en plattform för online utbildningar. Läs mer om oss här {link}.",Request:"Skicka",Password:"Lösenord",Continue:"Nästa",changesSaved:"Dina ändringar har sparats.",exclVat:"ex. MOMS",Edit:"Redigera",by:"av",Close:"Stäng",Tags:"Tags",notFound:"404: Sidan ej hittad.",here:'här',error:"Ett fel har inträffat och vårt team har meddelats. För att gå tillbaka klicka",down:"Coursio är nere för tillfället och vi arbetar på problemet. Tack för ditt tålamod!",loremIpsum:"Hej Skapare! Detta är bara utfyllningstext. Klistra in din text eller börja skriva."}});

/***/ }),
/* 2437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _course;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = ({locales:["en-US"],messages:{// post: {
//     meta: 'Posted {ago}, {num, plural, one{# comment} other{# comments}}'
// },
// time : {
// },
webinar:{fullScreen:"Full screen",useCoursio:'Use Coursio account for webinar modules',missedSettings:'Please setup you webinar settings or use Coursio account',domain:'Domain',description:'Description',roomName:'Room name',enter:'Enter',isWebinar:'Please, choose module type:'},user:{updated:"User roles updated"},login:{success:"Welcome!",loggedOut:"See you again, soon.",redirectIncoming:"You are already logged in, you will be redirected to the dashboard.",toDashboard:"Login to your dashboard"},coursio:{welcome:"Welcome to Coursio"},dashboard:{remove:"Are you sure?",removed:"Course has been removed",filterAll:"All",filterCompleted:"Completed",filterNotCompleted:"Not completed",filterExpiresSoon:"Expires soon",filterGood:"Good",filterNew:"New",filterPaid:"Paid",filterRegistered:"Registered",filterRefunded:"Refunded",filterCancelled:"Cancelled",filterError:"Error",filterOwn:"Own Courses",filterOthers:"Invited Courses",sortLastVisit:"Last Visited",sortCreated:"Last Created",filterAndSort:"Choose Filtering and Sorting",filter:"Choose Filtering",filterTitle:"Filter",sortTitle:"Sort By"},ozitor:{url:"URL",openInNewTab:"Open in new tab",createLink:"Create link",more:"More",less:"Less"},bug:{report:"Support",reportTitle:"Send request",describe:"If you have course related questions please contact course creator. For technical issues please describe it here.",reported:"Your request has been sent.",reportFailed:"Request report has failed."},course:(_course={properties:"Properties",category:"Category",nameTooLong:"Course name can be maximum of 50 characters.",nameNotEmpty:"Course name cannot be empty",buy:"Buy course",Courses:"Courses",access:"Course Access",remove:'Remove course "{course}?',removed:"Course has been removed",revokeAccess:"Revoke access",show:"Show course",noSelected:"No course selected",choose:"Choose courses",setAccess:"Set course access",lastViewedPage:"Last page visited",whatIs:"What is an online course?",studentsInvited:"Students have been invited to course.",groupsInvited:"Groups have been invited to course.",goto:"Goto course",new:"Course name",add:"Add course",tableOfContents:"Table of Contents"},_defineProperty(_course,"access","Access Until: "),_defineProperty(_course,"dateSaved","Access date has been saved"),_defineProperty(_course,"forever","Forever"),_course),group:{Groups:"Groups",remove:"Remove group?",add:"Add Group",removed:"Group has been removed.",create:"New Group",name:"Group name",expunge:"Also expunge all privileges granted through this group.",doesNotExist:"This group does not exist.",noSelected:"No group selected",revokeAccess:'Revoke access for group "{group}" from course "{course}"?',revokedAccess:"Access has been revoked for this group.",show:"Show group",choose:"Choose groups",removeCourse:"Remove course",removeCourseConfirm:"Are you sure you want to remove this course from the group?",removeStudent:"Remove student",removeStudentConfirm:"Are you sure you want to remove this student from the group?",removeInvite:"Remove invite",removeInviteConfirm:"Are you sure you want to remove this invite from the group?",removedInvite:"Invitation has been removed",coursesAdded:"Course(s) added",courseRemoved:"Course removed",editing:"Editing Group Name",send:"Send to me"},students:{students:"Students",invitations:"Invitations"},student:{active:"Active {ago}.",neverActive:"Student has never been active.",Students:"Students",delete:"Remove student",Invited:"Invited",Registered:"Registered",remove:'Remove student "{student}"?',removed:"Student has been removed.",removeFromCourse:"Remove from course",revokeAccess:'Revoke access for student "{student}" from course "{course}"?',revokedAccess:"Access has been revoked.",show:"Show student",removeFromGroupShort:"Remove from group?",removeFromGroup:'Remove student "{student} from group "{group}" ?',removedFromGroup:"Student has been removed from group.",addedToGroup:"Student has been added to group.",multiAddedToGroup:"Students have been added to group.",choose:"Choose students",addToCourseShort:"Add to courses",add:"Add student",inviteNew:"Invite new students",exportDone:"Student export was sent to your email.",exportStatisticDone:"Statistic export was sent to your email.",expel:"Delete student account",expelConfirm:'Attention! Are you sure you want to delete the student "{student}"? After this action "{student}" will be deleted for ever from all courses and groups',expelDone:"Student has been removed from all your courses and groups",noSelected:"No student selected"},menu:{Quiz:"Quiz",Notes:"Notes",Tasks:"Tasks",Stripe:"Stripe",Dashboard:"Dashboard",StudentManagement:"Student management",Notification:"Notification",Settings:"Settings",Incarnate:"Incarnate",Invite:"Invite",Wakeup:"Wake up",Logout:"Log out",Courses:"Courses",ECommerce:"E-Commerce",Store:"Store",saleStats:"Statistics",Transactions:"Transactions",Discounts:"Discounts",Bundles:"Bundles",mediaLibrary:"Media library",Back:"Back",Help:"Help",SubAccounts:"Sub-Accounts",TaC:"Terms and conditions"},invite:{supplyEmails:"Please enter at least one email",studentInvitedToCourse:"Student has been invited to course.",groupInvitedToCourse:"Group has been invited to course.",chooseCourses:"Choose course(s)",chooseGroups:"Choose group(s)",chooseStudents:"Choose student(s)",selectedCourses:"Selected courses",selectedGroups:"Selected groups",selectedStudents:"Selected students",existingStudents:"Existing Students",newStudents:"New Students",groups:"Groups",summary:"Summary",summaryExplanation:"Below is a summary of your choices for your convenience",accessTime:"Access time",willHaveAccessTill:"Students will have access to these courses till : ",willHaveAccessFor:"Students will have access to these courses for : ",chooseCourseExplanation:"Please choose one or more courses to invite students to",chooseAccessTime:"Choose access duration",chooseAccessTimeExplanation:"Please specify how long the students will have access to the course(s) after accessing the course : ",chooseEndDate:"Choose end date",chooseEndDateExplanation:"Please specify till which date this group will have access to the course(s) : ",chooseStudentsOrGroups:"Do you want to invite Students or Groups?",Unlimited:"Unlimited",oneMonth:"One Month",threeMonths:"Three Months",sixMonths:"Six Months",oneYear:"One Year",oneAndHalfYear:"Eighteen Months",twoYears:"Two Years",accessMonths:"{months} month(s)",enterEmail:"Enter email addresses",confirmSend:"Confirm and send",sendInvite:"Send invite",sentOut:"Invites have been sent out.",Invites:"Invites",foundEmails:"Found email addresses",createTags:"Tags",addToGroup:"Add to a group",createGroupExplanation:"Type in the name of a new group to be created for these students and press enter",success:"You have successfully invited students, would you like to:",inviteMore:"Invite More?"},invitation:{expired:"This invitation has expired and thus cannot be accepted anymore.",used:"This invitation has already been used and thus cannot be accepted anymore.",accepted:"Invitation accepted",acceptText:"Please finalize your invitation by pressing the button below. This invitation was sent to {email}",redirectIncoming:"You will be redirected to the dashboard.",redirectLoginPage:"You will be redirected to the login page.",remove:"Remove",revokeAccess:"Revoke access?",resend:"Resend invitation",resendAll:"Resend invitations to All",prolongAccess:"Resend invitation for the course?",resent:"Email with an invitation link was resent.",allResent:"Email with an invitation link was resent to all.",accept:"Accept invitation",chosen:"Resend invitation to chosen email(s)",notChosen:"No email was chosen to send an invitation to",admin:"Admin rights"},item:{read:"Mark as read"},bundle:{updated:"Bundle updated.",new:"New bundle",remove:"Remove bundle",removed:"Bundle removed.",removeCourse:"Remove course",removedCourse:"Course removed from bundle.",removeCourseConfirm:"Are you sure you want to remove this course?",removeBundle:"Are you sure you want to remove bundle {bundle}?",name:"Name of the bundle",in1:"{courseCount} in 1",choose:"Choose bundle"},discount:{new:"New discount",remove:"Remove discount",removed:"Discount removed.",removeDiscount:"Are you sure you want to remove discount «{discount}»?",activate:"Activate code",code:"Discount code",enterCode:"Enter code (max 30 characters)",codeRestriction:"Code cannot be longer than 30 characters",amount:"Amount",active:"Active",limitedUse:"Limited use",Start:"Start",End:"End",Activation:"Activation",Manual:"Manual",Date:"Date",All:"All",Selected:"Selected",amountMustBeNumeric:"Amount must be numeric.",codeRequired:"Code is required.",used:"{count} / {maxCount} used",applied:"Discount code applied.",typeAbsolute:"Absolute value",typePercentage:"Percentage",affectedObjects:"Specific courses ",affectedPackages:"Specific packages ",discount:"Discount",type:"Discount Type"},transaction:{completed:"Completed",resendReceipt:"Resend receipt",refund:"Refund",refunded:"Refunded",receiptResent:"Receipt resent.",refundDone:"Refund done.",exportDone:"Data on incoming transactions was sent to your email.",date:"Date",showDetails:"Show Details",name:"Name",coursePackage:"Course/Package",amount:"Amount",new:"New",registered:"Registered",paid:"Paid",good:"Good",error:"Error",cancelled:"Cancelled"},export:{startDate:"Start date",endDate:"End date",course:"Export course students",statistic:"Export detailed tasks statistics",user:{withInactive:"Include already inactive users",withProgress:"Include course progress data"},userStats:"Export User Stats"},image:{upload:"Upload image",importFailed:"Import has failed, try again.",imported:"Image has been imported",provideImportUrl:"Please provide a url",confirmDelete:"Are you sure you want to remove this image?",delete:"Delete image"},audio:{upload:"Upload audio",importFailed:"Import has failed, try again.",imported:"Audio has been imported",confirmDelete:"Are you sure you want to remove this audio?",embed:"Paste a Spotify or SoundCloud link",download:"Download audio as: "},text:{confirmDelete:"Are you sure you want to remove this text block?"},media:{encodingComplete:"Encoding has been completed.",encoding:"Encoding media",uploading:"Uploading media"},video:{upload:"Upload video",importFailed:"Import has failed, try again.",imported:"Video has been imported",confirmDelete:"Are you sure you want to remove this video?",embed:"Paste a YouTube, Vimeo or Wistia link",changesSaved:"Changes have been saved",changesCannotBeSaved:"Link is not correct",allowDownloading:"Allow downloading",download:"Download video as: "},module:{confirmDelete:"Are you sure you want to remove this module?",removeImage:"Remove image ",dropOneFile:"Drop a file here ",dropImage:"Drop an image here ",dropImages:"Drop one or multiple images here ",youCanImport:"or paste a link ",or:"or ",orIfYouPrefer:"Or, if you prefer...",selectAFileFromYourComputer:"Select a file from your computer",dropVideo:"Drop a video here ",dropAudio:"Drop an audio file here ",uploadOrBrowse:"You can also {upload} or browse your {library} ",upload:"upload ",uploadFile:"Upload a file ",uploadImage:"Upload an image ",uploadAudio:"Upload an audio file ",uploadVideo:"Upload a video file ",library:"library "},download:{upload:"Upload a file",confirmDelete:"Are you sure you want to remove this file?"},discussion:{confirmDelete:"Are you sure you want to remove this discussion?"},slideshow:{confirmDelete:"Are you sure you want to remove this slideshow?"},tasks:{noInfo:"There is no information to show",noTasks:"No tasks requiring your attention found",findCourse:"Find course",findGroup:"Find group",findStudent:"Find student",showCorrected:"Show corrected tasks",fileRemoved:"Files successfully removed",fileNotRemoved:"Could not remove files",fileUploaded:"File attached, please click SEND to send your answer.",students:"Students",courses:"Courses",groups:"Groups",corrected:"Show corrected tasks",correct:"Correct",incorrect:"Incorrect",defineTask:"Please define the task",defineQuestion:"Please define the question",question_description:"Describe the Question",emptyChoice:"Empty choice",addChoice:"Add choice",description:"Describe the task",submit:"Submit Answer",attach:"Attach File",answer:"Answer",answerOpenEnded:"Send",noAnswer:"No answer given",provideAnswer:"Please provide your answer",feedback:"Feedback",provideFeedback:"Please provide the student with some feedback",type:"Task Type",chooseType:"Choose a task type",answeredCount:"{answered}/{count} tasks",noAnsweredTasks:"No tasks",singleChoice:"Single Choice",multipleChoice:"Multiple Choice",text:"Text",openEnded:"Open-ended question",pleaseChooseOne:"Please make a choice",remove:"Remove task",confirmDelete:"Are you sure you want to remove this task?",answerSent:"Your answer has been sent to the course creator.",feedbackSent:"Your feedback has been sent",redoanswer:"Redo answer",showMore:"Show all results",showLatest:"Show latest result"},post:{confirmDelete:"Are you sure you want to remove this post?",writeAComment:"Write a comment",describeDiscussion:"Describe the discussion topic"},pageModule:{quiz:"Add question",quizQuestionErrorTitle:"Invalid question",quizQuestionErrorMessage:"You have a question that does not contain alternatives or correct option",add:"Add module",text:"Text",video:"Video",image:"Image",audio:"Audio",task:"Task",webinar:"Webinar",quizCommentOnQuestion:"Motivate the correct choice",download:"Download",discussion:"Discussion",slideshow:"Slideshow",created:"Module created.",layout:"Module layout",embed:"Embed",quiziframe:"Quiz"},card:{number:"Card number"},account:{Account:"Account",register:"To access a course you need to create a Coursio account. Please, fill in your details below: ",create:"Create account",need:"To buy a course you need to create a Coursio account fill in your details below:",have:"Have a Coursio Account?"},toc:{search:"Search the course",accept:"By registering you accept the {toc}",toc:"Terms and Conditions",close:"Close table of contents",open:"Open"},mediaLibrary:{filesRemaining:"files remaining",addNew:"Add New",Delete:"Delete",listView:"List View",thumbView:"Thumb View",type:"Type",remove:"Remove File",removed:"File removed.",uploadFiles:"Upload Files",removeConfirm:'Are you sure you want to remove "{file}"?',removeFilesConfirm:"Are you sure you want to remove these files?",uploadComplete:"Upload complete.",dropHere:"Drop files here",Uploading:"Uploading...",Upload:"Upload",createDir:"Create Directory",directoryName:"Name of the directory"},Roles:"Roles",role:{accountant:"Accountant",reader:"Reader",editor:"Editor",teacher:"Teacher",owner:"Owner",darkAdmin:"Sith",assistant:"Assistant",tester:"Tester"},page:{addContent:"Add content",new:"Page",remove:"Remove page",rename:"Rename page",duplicate:"Duplicate page",confirmDelete:"Are you sure you wnat to remove this page?"},section:{new:"Section",paste:"Paste section",remove:"Remove section",confirmDelete:"Are you sure you wnat to remove this section?"},payment:{chooseMethod:"Choose your payment method",fillInDetails:"Fill in your details",connectToStripe:"Connect to stripe",payWithStripe:"Pay with stripe",Taxamo:"Card payment",Klarna:"Klarna",next:"Next",creditCard:"Card payment",creditCardHolder:"Credit Card Holder",creditCardExpirationDate:"Expiration Date",creditCardConfirmationCode:"CC",completePurchase:"Complete purchase",hint:{creditCardNumber:"XXXXXXXXXXXXXXXX",expYear:"YYYY",expMonth:"MM",cvc:"XXX"},validation:{invalidYear:"Invalid year. Needs to be in the form of YYYY (2020)",invalidMonth:"Invalid year. Needs to be in the form of MM (12)",invalidCvC:"Invalid CvC. Needs to be in the form of XXX (123)",invalidCreditCard:"Invalid card number, needs to be 16 chars long"},stripe:{number:"Credit card number",year:"Expiration year",month:"Expiration month",cvc:"CVC"},klarna:{zip:"Zip code",invoice:"Invoice",account:"Account",address:"Address",street:"Address",firstName:"First name",lastName:"Last name",city:"City",phone:"Phone",country:"Country",zipCode:"Post code",emailError:"Please fill in a correct email address",phoneError:"Please fill in a correct telephone number",zipCodeError:"Please fill in a correct post code",personalNumberError:"Please fill in a correct Swedish personal number",personalOrganisationalNumber:"Personal Number/ Organisation Number",email:"E-mail",next:"Next",personalNumberFormat:"YYYYMMDD-XXXX",phoneNumberFormat:"0XX XXX XXXX",emailFormat:"someone@coursio.com"}},loadMore:"Load more",areYouSure:"Are you sure?",Copy:"Copy",Copied:"Copied",OK:"OK",Cancel:"Cancel",Yes:"Yes",No:"No",Reset:"Reset",Sort:"Sort",Filter:"Filter",Create:"Create",Invite:"Invite",Export:"Export",Course:"Course",Courses:"Courses",Group:"Group",Time:"Time",Groups:"Groups",Email:"Email",Student:"Student",Students:"Students",Status:"Status",Search:"Search",Never:"Never",Expired:"Expired",selectAll:"Select All",deselectAll:"Deselect All",revokeAccess:"Revoke access?",noResults:"No results found",selectFilter:"Please make a selection",resultsFiltered:"Results are filtered",selectedCount:"{num, plural, =0{None selected} other{# selected}}",Next:"Next",addFrom:"Add From",Login:"Login",Authenticating:"Authenticating",Caption:"Caption",Other:"Other",importFromUrl:"Import from URL",Upload:"Upload",Import:"Import",Embed:"Embed",Reply:"Reply",Follow:"Follow",Unfollow:"Unfollow",Send:"Send",SortMessages:"Sort Messages",attachFile:"Attach File",nextPage:"Next Page",Modules:"Modules",Layout:"Layout",Undo:"Undo",Deleted:"Deleted.",Delete:"Delete",Discount:"Discount",Request:"Skicka",Buy:"Buy",Private:"Private",Public:"Public",TermsAndConditions:"Terms & Conditions",Support:"Support",copyright:"Copyright {year} by {name}",poweredBy:"Powered by {engine}",forgotPassword:"Forgot your password?",loginWithGoogle:"Login with Google",loginWithFacebook:"Login with Facebook",welcomeBack:"Welcome back, {user}!",useOtherLogin:"Use other login",VAT:"VAT",fullName:"Full name",firstname:"Firstname",lastname:"Lastname",noTasksOrNotifications:"No open tasks or new discussions",Branding:"Branding",Notifications:"Notifications",or:"or",Remove:"Remove",Save:"Save",Add:"Add",Clear:"Clear",Logout:"Logout",validation:{invalidEmail:"Enter a valid email",required:"This field is required",passwordTooShort:"Password must be at least 6 characters"},password:{restoreLinkMailed:"An email has been sent to you with instructions.",reset:"Reset password",newPassword:"New password",changed:"Your password has been changed",confirm:"Confirm",fillIn:"Fill in both fields"},storeBuilder:{thisIsMyStore:"This is my store",edit:"Edit the store layout",centerCenter:"Center",leftCenter:"Left center",rightCenter:"Right center",topLeft:"Top left",topCenter:"Top center",topRight:"Top right",bottomLeft:"Bottom left",bottomCenter:"Bottom center",bottomRight:"Bottom right",headerPosition:"Header position",heading:"Heading",list:"Store list",text:"Text",image:"Image",video:"Video",banner:"Banner",undo:"Undo",save:"Save",publish:"Publish",discard:"Discard"},gift:{purchaseComplete:"Purchase complete",explanation:"When buying this course as a gift, you will get a gift code sent to your email.",warning:"Please note! Enter your own email, not the email of the gift receiver.",nextStep:"A gift code has been emailed to the address you provided. You can send the link in this email to the lucky person!",thisCourse:"Gift this course",email:"Enter your Email",confirm:"Confirm your Email",emailMustMatch:"Both emails must match",expired:"This gift code has expired and thus cannot be accepted anymore.",used:"This gift code has already been used and thus cannot be accepted anymore.",accepted:"Gift accepted",help:"If you already used your giftcode and have access to the course log in here->app.coursio.com/login",acceptText:"You have been nice!",acceptSubText:"Enter your gift code to get access to the course",redirectIncoming:"You will be redirected to the dashboard.",redirectLoginPage:"You will be redirected to the login page.",needCoursioAccount:"To get access to courses, you need a Coursio account.",doesNotExist:"This gift code does not exist."},store:{buyFor:"Buy for {price}",goto:"Go to store",smallCards:"Cards",bigCards:"Big Cards",list:"List",showOnlyMatching:"Only show courses that match these criteria:",bannerApproximation:"Image (approximation att Full HD)",bannerModule:"Banner",videoModule:"Video",textModule:"Text",imageModule:"Image",coursesModule:"Courses",addContent:"Add content",chooseVideo:"Please choose a video by pasting a YouTube, Vimeo or Wistia link.",yourCourseLeader:"Your course leader",joinCourse:"Join course",giftCourse:"Gift",join:"Join",aboutThisCourse:"About this course",aboutThisPack:"About this pack",courseContent:"Course content",aboutAuthor:"About {author}",aboutAuthorInfo:"Information about the course leader",courseCount:"Courses ({count})",overlayOpacity:"Overlay opacity",headerPosition:"Header position",header:"Header",image:"Image",filter:"Filter",size:"Size",Color:"Color",backgroundColor:"Background color",name:"Store name",edit:"Edit",takeCourse:"Join course",video:"Video URL",price:"Price",grossPrice:"Price (incl VAT)",private:"Private",public:"Public",purchaseSuccess:"Purchase successfully completed. You will be redirected",packOf:"Pack of {count}",noOwnerInfo:"No information about course leader yet",chooseCategory:"Choose category"},about:{support:'Please contact <a href="mailto:support@coursio.com">support@coursio.com</a> for technical support.'},settings:{SendBulletin:'Sending bulletins',Bulletin:'Bulletin',Webinar:'Webinar',Docs:"Documents",termsAndConditions:"Terms & Conditions",courseExplanation:"What is a course?",support:"Support",aboutMe:"About me",storeHeadline:"Store headline",storeBackground:"Store background",readerMode:"Reader mode",disableScaling:"Disable scaling",enableScaling:"Enable scaling",builderMode:"Builder mode",displayName:"Display name",firstName:"First name",lastName:"Last name",language:"Language",email:"E-mail",currentPassword:"Current Password",addCurrentPassword:"Add Your Current Password to update E-mail",logo:"Logo",color:"Color",currency:"Currency",saved:"Settings saved.",avatar:"Avatar",Account:"Account",Account2:"User Settings",Stripe:"Stripe",Builder:"Builder",Branding:"Branding",ssn:"Company Registration Number",phone:"Phone",address:"Address",zip:"Zipcode",city:"City",country:"Country",Codes:"Codes",Notifications:"Notifications",gaCode:"Google Analytics Code",fbCode:"Facebook Pixel Code",gaGtm:"Google Tag Manager Code",checkoutCode:"Checkout code",ECommerce:"E-Commerce"},subAccount:{attention:"Attention! You are going to login to the user account. Be aware that anything you change will be stored permanently on the user account.",incarnate:"Log in",incarnated:"(External log in)"},Register:"Register",note:{yourNote:"Your notes..."},notification:{NOTIFICATION_ADDED_TO_CIRCLE:"Added to group",NOTIFICATION_TASK_FEEDBACK:"Feedback on task",NOTIFICATION_DRIP_CONTENT:"Drip content",NOTIFICATION_POST_ADDED:"Post added",NOTIFICATION_TASK_ASSESSED:"Task assessed",NOTIFICATION_YOU_MENTIONED:"Someone mentioned you",NOTIFICATION_FEEDBACK_REQUIRED:"Feedback required",NOTIFICATION_UNREVIEWED_TASKS:"Unreviewed tasks",NOTIFICATION_THREAD_NEW_POSTS:"New post in discussion",NOTIFICATION_COURSE_NEW_POSTS:"New post in course",NOTIFICATION_COURSE_SOLD:"Course sold",NOTIFICATION_COURSE_PACKAGE_SOLD:"Course package sold",NOTIFICATION_ADDED_TO_COURSE:"Added to course",removed:"New notifications were marked as read",readAll:"Mark notifications as read",NOTIFICATION_DATA_EXPORT:"Data export",NOTIFICATION_COURSE_INVITE:"Course invite",NOTIFICATION_BROADCAST:"Broadcast"},personalSettings:"Personal Settings",tag:{name:"Tag name",add:"Add tag"},emailStatus:{error:"Error (This usually means the mail was not sent)",sent:"Sent",bounced:"Bounced",rejected:"Rejected",unknown:"Email is unknown"},aboutCoursio:"Coursio is a tool for creating courses online. Read more about us at {link}.",Password:"Password",Continue:"Continue",Description:"Description",changesSaved:"Your changes have been saved.",exclVat:"excl. VAT",Edit:"Edit",Report:"Report",notFound:"404: Page not found.",by:"by",here:'here',error:"An error has occurred and our team has been notified. To go back click",down:"Coursio is down at the moment and we are working on the problem. Thank you for your patience!",Close:"Close",Tags:"Tags",loremIpsum:"Hey creator! This is just a placeholder text. You should edit this text and replace it."}});

/***/ }),
/* 2438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_oxygen_i18n__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_oxygen_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_oxygen_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intl_messageformat__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_intl_relativeformat__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_intl_format_cache__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_intl_format_cache__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__webpack_require__(2439);function assertIsDate(date,errMsg){// Determine if the `date` is valid by checking if it is finite, which is
// the same way that `Intl.DateTimeFormat#format()` checks.
if(!isFinite(date)){throw new TypeError(errMsg);}}var typesSpec={locales:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].oneOfType([__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string,__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].array]),formats:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,messages:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,getIntlMessage:__WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func};var IntlProvider=function(_Component){_inherits(IntlProvider,_Component);function IntlProvider(){_classCallCheck(this,IntlProvider);var _this=_possibleConstructorReturn(this,(IntlProvider.__proto__||Object.getPrototypeOf(IntlProvider)).apply(this,arguments));_this.getNumberFormat=__WEBPACK_IMPORTED_MODULE_5_intl_format_cache___default()(Intl.NumberFormat);_this.getDateTimeFormat=__WEBPACK_IMPORTED_MODULE_5_intl_format_cache___default()(Intl.DateTimeFormat);_this.getMessageFormat=__WEBPACK_IMPORTED_MODULE_5_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_3_intl_messageformat___default.a);_this.getRelativeFormat=__WEBPACK_IMPORTED_MODULE_5_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_4_intl_relativeformat___default.a);__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale(_this.props.locale.replace(/(_SE|_EN)/g,''));_this.setLocale(_this.props.locale);return _this;}_createClass(IntlProvider,[{key:'setLocale',value:function setLocale(locale){try{var messages=__webpack_require__(377);Object(__WEBPACK_IMPORTED_MODULE_1_oxygen_i18n__["addMessages"])(messages);__WEBPACK_IMPORTED_MODULE_1_oxygen_i18n___default.a.setLocale(locale.replace('_','-'),locale.replace('_','-'));}catch(e){// Nothing going on
//
}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.locale!==this.props.locale){this.setLocale(nextProps.locale);}}},{key:'getChildContext',value:function getChildContext(){var context=this.context;var props=this.props;return{locales:props.locales||context.locales,formats:props.formats||context.formats,messages:props.messages||context.messages,getIntlMessage:this.getIntlMessage.bind(this)};}},{key:'formatDate',value:function formatDate(date,options){date=new Date(date);// assertIsDate(date, 'A date or timestamp must be provided to formatDate()');
return this._format('date',date,options);}},{key:'formatTime',value:function formatTime(date,options){date=new Date(date);// assertIsDate(date, 'A date or timestamp must be provided to formatTime()');
return this._format('time',date,options);}},{key:'formatRelative',value:function formatRelative(date,options,formatOptions){date=new Date(date);// assertIsDate(date, 'A date or timestamp must be provided to formatRelative()');
return this._format('relative',date,options,formatOptions);}},{key:'formatNumber',value:function formatNumber(num,options){return this._format('number',num,options);}},{key:'formatMessage',value:function formatMessage(message,values){var locales=this.props.locales||this.context.locales;var formats=this.props.formats||this.context.formats;// When `message` is a function, assume it's an IntlMessageFormat
// instance's `format()` method passed by reference, and call it. This
// is possible because its `this` will be pre-bound to the instance.
if(typeof message==='function'){return message(values);}if(typeof message==='string'){message=this.getMessageFormat(message,locales,formats);}return message.format(values);}},{key:'getIntlMessage',value:function getIntlMessage(path){var messages=this.props.messages||this.context.messages;var pathParts=path.split('.');var message;try{message=pathParts.reduce(function(obj,pathPart){return obj[pathPart];},messages);}finally{if(message===undefined){return path;//throw new ReferenceError('Could not find Intl message: ' + path);
}}return message;}},{key:'getNamedFormat',value:function getNamedFormat(type,name){var formats=this.props.formats||this.context.formats;var format=null;try{format=formats[type][name];}finally{if(!format){throw new ReferenceError('No '+type+' format named: '+name);}}return format;}},{key:'_format',value:function _format(type,value,options,formatOptions){var locales=this.props.locales||this.context.locales;if(options&&typeof options==='string'){options=this.getNamedFormat(type,options);}switch(type){case'date':case'time':return this.getDateTimeFormat(locales,options).format(value);case'number':return this.getNumberFormat(locales,options).format(value);case'relative':return this.getRelativeFormat(locales,options).format(value,formatOptions);default:throw new Error('Unrecognized format type: '+type);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);}}]);return IntlProvider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);IntlProvider.displayName='IntlProvider';IntlProvider.propTypes=typesSpec;IntlProvider.contextTypes=typesSpec;IntlProvider.childContextTypes=typesSpec;IntlProvider.filterFormatOptions=function(obj,defaults){if(!defaults){defaults={};}return(this.formatOptions||[]).reduce(function(opts,name){if(obj.hasOwnProperty(name)){opts[name]=obj[name];}else if(defaults.hasOwnProperty(name)){opts[name]=defaults[name];}return opts;},{});};/* harmony default export */ __webpack_exports__["a"] = (IntlProvider);

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(97)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
global.IntlPolyfill = __webpack_require__(2441);

// Require all locale data for `Intl`. This module will be
// ignored when bundling for the browser with Browserify/Webpack.
__webpack_require__(2442);

// hack to export the polyfill as global Intl if needed
if (!global.Intl) {
    global.Intl = global.IntlPolyfill;
    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
}

// providing an idiomatic api for the nodejs version of this module
module.exports = global.IntlPolyfill;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
};

var jsx = function () {
  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            return step("next", value);
          }, function (err) {
            return step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineEnumerableProperties = function (obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    Object.defineProperty(obj, key, desc);
  }

  return obj;
};

var defaults = function (obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);

    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }

  return obj;
};

var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var _instanceof = function (left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
};

var interopRequireDefault = function (obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
};

var interopRequireWildcard = function (obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
};

var newArrowCheck = function (innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
};

var objectDestructuringEmpty = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var selfGlobal = typeof global === "undefined" ? self : global;

var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var slicedToArrayLoose = function (arr, i) {
  if (Array.isArray(arr)) {
    return arr;
  } else if (Symbol.iterator in Object(arr)) {
    var _arr = [];

    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
      _arr.push(_step.value);

      if (i && _arr.length === i) break;
    }

    return _arr;
  } else {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var temporalRef = function (val, name, undef) {
  if (val === undef) {
    throw new ReferenceError(name + " is not defined - temporal dead zone");
  } else {
    return val;
  }
};

var temporalUndefined = {};

var toArray = function (arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};



var babelHelpers$1 = Object.freeze({
  jsx: jsx,
  asyncToGenerator: asyncToGenerator,
  classCallCheck: classCallCheck,
  createClass: createClass,
  defineEnumerableProperties: defineEnumerableProperties,
  defaults: defaults,
  defineProperty: defineProperty$1,
  get: get,
  inherits: inherits,
  interopRequireDefault: interopRequireDefault,
  interopRequireWildcard: interopRequireWildcard,
  newArrowCheck: newArrowCheck,
  objectDestructuringEmpty: objectDestructuringEmpty,
  objectWithoutProperties: objectWithoutProperties,
  possibleConstructorReturn: possibleConstructorReturn,
  selfGlobal: selfGlobal,
  set: set,
  slicedToArray: slicedToArray,
  slicedToArrayLoose: slicedToArrayLoose,
  taggedTemplateLiteral: taggedTemplateLiteral,
  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
  temporalRef: temporalRef,
  temporalUndefined: temporalUndefined,
  toArray: toArray,
  toConsumableArray: toConsumableArray,
  typeof: _typeof,
  extends: _extends,
  instanceof: _instanceof
});

var realDefineProp = function () {
    var sentinel = function sentinel() {};
    try {
        Object.defineProperty(sentinel, 'a', {
            get: function get() {
                return 1;
            }
        });
        Object.defineProperty(sentinel, 'prototype', { writable: false });
        return sentinel.a === 1 && sentinel.prototype instanceof Object;
    } catch (e) {
        return false;
    }
}();

// Need a workaround for getters in ES3
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

// We use this a lot (and need it for proto-less objects)
var hop = Object.prototype.hasOwnProperty;

// Naive defineProperty for compatibility
var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};

// Array.prototype.indexOf, as good as we need it to be
var arrIndexOf = Array.prototype.indexOf || function (search) {
    /*jshint validthis:true */
    var t = this;
    if (!t.length) return -1;

    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
        if (t[i] === search) return i;
    }

    return -1;
};

// Create an object with the specified prototype (2nd arg required for Record)
var objCreate = Object.create || function (proto, props) {
    var obj = void 0;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (var k in props) {
        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
    }

    return obj;
};

// Snapshot some (hopefully still) native built-ins
var arrSlice = Array.prototype.slice;
var arrConcat = Array.prototype.concat;
var arrPush = Array.prototype.push;
var arrJoin = Array.prototype.join;
var arrShift = Array.prototype.shift;

// Naive Function.prototype.bind for compatibility
var fnBind = Function.prototype.bind || function (thisObj) {
    var fn = this,
        args = arrSlice.call(arguments, 1);

    // All our (presently) bound functions have either 1 or 0 arguments. By returning
    // different function signatures, we can pass some tests in ES3 environments
    if (fn.length === 1) {
        return function () {
            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
        };
    }
    return function () {
        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
    };
};

// Object housing internal properties for constructors
var internals = objCreate(null);

// Keep internal properties internal
var secret = Math.random();

// Helper functions
// ================

/**
 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
 * causing issue #62.
 */
function log10Floor(n) {
    // ES6 provides the more accurate Math.log10
    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));

    var x = Math.round(Math.log(n) * Math.LOG10E);
    return x - (Number('1e' + x) > n);
}

/**
 * A map that doesn't contain Object in its prototype chain
 */
function Record(obj) {
    // Copy only own properties over unless this object is already a Record instance
    for (var k in obj) {
        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
    }
}
Record.prototype = objCreate(null);

/**
 * An ordered list
 */
function List() {
    defineProperty(this, 'length', { writable: true, value: 0 });

    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
}
List.prototype = objCreate(null);

/**
 * Constructs a regular expression to restore tainted RegExp properties
 */
function createRegExpRestore() {
    if (internals.disableRegExpRestore) {
        return function () {/* no-op */};
    }

    var regExpCache = {
        lastMatch: RegExp.lastMatch || '',
        leftContext: RegExp.leftContext,
        multiline: RegExp.multiline,
        input: RegExp.input
    },
        has = false;

    // Create a snapshot of all the 'captured' properties
    for (var i = 1; i <= 9; i++) {
        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
    }return function () {
        // Now we've snapshotted some properties, escape the lastMatch string
        var esc = /[.?*+^$[\]\\(){}|-]/g,
            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
            reg = new List();

        // If any of the captured strings were non-empty, iterate over them all
        if (has) {
            for (var _i = 1; _i <= 9; _i++) {
                var m = regExpCache['$' + _i];

                // If it's empty, add an empty capturing group
                if (!m) lm = '()' + lm;

                // Else find the string in lm and escape & wrap it to capture it
                else {
                        m = m.replace(esc, '\\$&');
                        lm = lm.replace(m, '(' + m + ')');
                    }

                // Push it to the reg and chop lm to make sure further groups come after
                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
                lm = lm.slice(lm.indexOf('(') + 1);
            }
        }

        var exprStr = arrJoin.call(reg, '') + lm;

        // Shorten the regex by replacing each part of the expression with a match
        // for a string of that exact length.  This is safe for the type of
        // expressions generated above, because the expression matches the whole
        // match string, so we know each group and each segment between capturing
        // groups can be matched by its length alone.
        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
        });

        // Create the regular expression that will reconstruct the RegExp properties
        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');

        // Set the lastIndex of the generated expression to ensure that the match
        // is found in the correct index.
        expr.lastIndex = regExpCache.leftContext.length;

        expr.exec(regExpCache.input);
    };
}

/**
 * Mimics ES5's abstract ToObject() function
 */
function toObject(arg) {
    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');

    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
    return Object(arg);
}

function toNumber(arg) {
    if (typeof arg === 'number') return arg;
    return Number(arg);
}

function toInteger(arg) {
    var number = toNumber(arg);
    if (isNaN(number)) return 0;
    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
    if (number < 0) return Math.floor(Math.abs(number)) * -1;
    return Math.floor(Math.abs(number));
}

function toLength(arg) {
    var len = toInteger(arg);
    if (len <= 0) return 0;
    if (len === Infinity) return Math.pow(2, 53) - 1;
    return Math.min(len, Math.pow(2, 53) - 1);
}

/**
 * Returns "internal" properties for an object
 */
function getInternalProperties(obj) {
    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);

    return objCreate(null);
}

/**
* Defines regular expressions for various operations related to the BCP 47 syntax,
* as defined at http://tools.ietf.org/html/bcp47#section-2.1
*/

// extlang       = 3ALPHA              ; selected ISO 639 codes
//                 *2("-" 3ALPHA)      ; permanently reserved
var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';

// language      = 2*3ALPHA            ; shortest ISO 639 code
//                 ["-" extlang]       ; sometimes followed by
//                                     ; extended language subtags
//               / 4ALPHA              ; or reserved for future use
//               / 5*8ALPHA            ; or registered language subtag
var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';

// script        = 4ALPHA              ; ISO 15924 code
var script = '[a-z]{4}';

// region        = 2ALPHA              ; ISO 3166-1 code
//               / 3DIGIT              ; UN M.49 code
var region = '(?:[a-z]{2}|\\d{3})';

// variant       = 5*8alphanum         ; registered variants
//               / (DIGIT 3alphanum)
var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';

//                                     ; Single alphanumerics
//                                     ; "x" reserved for private use
// singleton     = DIGIT               ; 0 - 9
//               / %x41-57             ; A - W
//               / %x59-5A             ; Y - Z
//               / %x61-77             ; a - w
//               / %x79-7A             ; y - z
var singleton = '[0-9a-wy-z]';

// extension     = singleton 1*("-" (2*8alphanum))
var extension = singleton + '(?:-[a-z0-9]{2,8})+';

// privateuse    = "x" 1*("-" (1*8alphanum))
var privateuse = 'x(?:-[a-z0-9]{1,8})+';

// irregular     = "en-GB-oed"         ; irregular tags do not match
//               / "i-ami"             ; the 'langtag' production and
//               / "i-bnn"             ; would not otherwise be
//               / "i-default"         ; considered 'well-formed'
//               / "i-enochian"        ; These tags are all valid,
//               / "i-hak"             ; but most are deprecated
//               / "i-klingon"         ; in favor of more modern
//               / "i-lux"             ; subtags or subtag
//               / "i-mingo"           ; combination
//               / "i-navajo"
//               / "i-pwn"
//               / "i-tao"
//               / "i-tay"
//               / "i-tsu"
//               / "sgn-BE-FR"
//               / "sgn-BE-NL"
//               / "sgn-CH-DE"
var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';

// regular       = "art-lojban"        ; these tags match the 'langtag'
//               / "cel-gaulish"       ; production, but their subtags
//               / "no-bok"            ; are not extended language
//               / "no-nyn"            ; or variant subtags: their meaning
//               / "zh-guoyu"          ; is defined by their registration
//               / "zh-hakka"          ; and all of these are deprecated
//               / "zh-min"            ; in favor of a more modern
//               / "zh-min-nan"        ; subtag or sequence of subtags
//               / "zh-xiang"
var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';

// grandfathered = irregular           ; non-redundant tags registered
//               / regular             ; during the RFC 3066 era
var grandfathered = '(?:' + irregular + '|' + regular + ')';

// langtag       = language
//                 ["-" script]
//                 ["-" region]
//                 *("-" variant)
//                 *("-" extension)
//                 ["-" privateuse]
var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';

// Language-Tag  = langtag             ; normal language tags
//               / privateuse          ; private use tag
//               / grandfathered       ; grandfathered tags
var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');

// Match duplicate variants in a language tag
var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');

// Match duplicate singletons in a language tag (except in private use)
var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');

// Match all extension sequences
var expExtSequences = RegExp('-' + extension, 'ig');

// Default locale is the first-added locale data for us
var defaultLocale = void 0;
function setDefaultLocale(locale) {
    defaultLocale = locale;
}

// IANA Subtag Registry redundant tag and subtag maps
var redundantTags = {
    tags: {
        "art-lojban": "jbo",
        "i-ami": "ami",
        "i-bnn": "bnn",
        "i-hak": "hak",
        "i-klingon": "tlh",
        "i-lux": "lb",
        "i-navajo": "nv",
        "i-pwn": "pwn",
        "i-tao": "tao",
        "i-tay": "tay",
        "i-tsu": "tsu",
        "no-bok": "nb",
        "no-nyn": "nn",
        "sgn-BE-FR": "sfb",
        "sgn-BE-NL": "vgt",
        "sgn-CH-DE": "sgg",
        "zh-guoyu": "cmn",
        "zh-hakka": "hak",
        "zh-min-nan": "nan",
        "zh-xiang": "hsn",
        "sgn-BR": "bzs",
        "sgn-CO": "csn",
        "sgn-DE": "gsg",
        "sgn-DK": "dsl",
        "sgn-ES": "ssp",
        "sgn-FR": "fsl",
        "sgn-GB": "bfi",
        "sgn-GR": "gss",
        "sgn-IE": "isg",
        "sgn-IT": "ise",
        "sgn-JP": "jsl",
        "sgn-MX": "mfs",
        "sgn-NI": "ncs",
        "sgn-NL": "dse",
        "sgn-NO": "nsl",
        "sgn-PT": "psr",
        "sgn-SE": "swl",
        "sgn-US": "ase",
        "sgn-ZA": "sfs",
        "zh-cmn": "cmn",
        "zh-cmn-Hans": "cmn-Hans",
        "zh-cmn-Hant": "cmn-Hant",
        "zh-gan": "gan",
        "zh-wuu": "wuu",
        "zh-yue": "yue"
    },
    subtags: {
        BU: "MM",
        DD: "DE",
        FX: "FR",
        TP: "TL",
        YD: "YE",
        ZR: "CD",
        heploc: "alalc97",
        'in': "id",
        iw: "he",
        ji: "yi",
        jw: "jv",
        mo: "ro",
        ayx: "nun",
        bjd: "drl",
        ccq: "rki",
        cjr: "mom",
        cka: "cmr",
        cmk: "xch",
        drh: "khk",
        drw: "prs",
        gav: "dev",
        hrr: "jal",
        ibi: "opa",
        kgh: "kml",
        lcq: "ppr",
        mst: "mry",
        myt: "mry",
        sca: "hle",
        tie: "ras",
        tkk: "twm",
        tlw: "weo",
        tnf: "prs",
        ybd: "rki",
        yma: "lrr"
    },
    extLang: {
        aao: ["aao", "ar"],
        abh: ["abh", "ar"],
        abv: ["abv", "ar"],
        acm: ["acm", "ar"],
        acq: ["acq", "ar"],
        acw: ["acw", "ar"],
        acx: ["acx", "ar"],
        acy: ["acy", "ar"],
        adf: ["adf", "ar"],
        ads: ["ads", "sgn"],
        aeb: ["aeb", "ar"],
        aec: ["aec", "ar"],
        aed: ["aed", "sgn"],
        aen: ["aen", "sgn"],
        afb: ["afb", "ar"],
        afg: ["afg", "sgn"],
        ajp: ["ajp", "ar"],
        apc: ["apc", "ar"],
        apd: ["apd", "ar"],
        arb: ["arb", "ar"],
        arq: ["arq", "ar"],
        ars: ["ars", "ar"],
        ary: ["ary", "ar"],
        arz: ["arz", "ar"],
        ase: ["ase", "sgn"],
        asf: ["asf", "sgn"],
        asp: ["asp", "sgn"],
        asq: ["asq", "sgn"],
        asw: ["asw", "sgn"],
        auz: ["auz", "ar"],
        avl: ["avl", "ar"],
        ayh: ["ayh", "ar"],
        ayl: ["ayl", "ar"],
        ayn: ["ayn", "ar"],
        ayp: ["ayp", "ar"],
        bbz: ["bbz", "ar"],
        bfi: ["bfi", "sgn"],
        bfk: ["bfk", "sgn"],
        bjn: ["bjn", "ms"],
        bog: ["bog", "sgn"],
        bqn: ["bqn", "sgn"],
        bqy: ["bqy", "sgn"],
        btj: ["btj", "ms"],
        bve: ["bve", "ms"],
        bvl: ["bvl", "sgn"],
        bvu: ["bvu", "ms"],
        bzs: ["bzs", "sgn"],
        cdo: ["cdo", "zh"],
        cds: ["cds", "sgn"],
        cjy: ["cjy", "zh"],
        cmn: ["cmn", "zh"],
        coa: ["coa", "ms"],
        cpx: ["cpx", "zh"],
        csc: ["csc", "sgn"],
        csd: ["csd", "sgn"],
        cse: ["cse", "sgn"],
        csf: ["csf", "sgn"],
        csg: ["csg", "sgn"],
        csl: ["csl", "sgn"],
        csn: ["csn", "sgn"],
        csq: ["csq", "sgn"],
        csr: ["csr", "sgn"],
        czh: ["czh", "zh"],
        czo: ["czo", "zh"],
        doq: ["doq", "sgn"],
        dse: ["dse", "sgn"],
        dsl: ["dsl", "sgn"],
        dup: ["dup", "ms"],
        ecs: ["ecs", "sgn"],
        esl: ["esl", "sgn"],
        esn: ["esn", "sgn"],
        eso: ["eso", "sgn"],
        eth: ["eth", "sgn"],
        fcs: ["fcs", "sgn"],
        fse: ["fse", "sgn"],
        fsl: ["fsl", "sgn"],
        fss: ["fss", "sgn"],
        gan: ["gan", "zh"],
        gds: ["gds", "sgn"],
        gom: ["gom", "kok"],
        gse: ["gse", "sgn"],
        gsg: ["gsg", "sgn"],
        gsm: ["gsm", "sgn"],
        gss: ["gss", "sgn"],
        gus: ["gus", "sgn"],
        hab: ["hab", "sgn"],
        haf: ["haf", "sgn"],
        hak: ["hak", "zh"],
        hds: ["hds", "sgn"],
        hji: ["hji", "ms"],
        hks: ["hks", "sgn"],
        hos: ["hos", "sgn"],
        hps: ["hps", "sgn"],
        hsh: ["hsh", "sgn"],
        hsl: ["hsl", "sgn"],
        hsn: ["hsn", "zh"],
        icl: ["icl", "sgn"],
        ils: ["ils", "sgn"],
        inl: ["inl", "sgn"],
        ins: ["ins", "sgn"],
        ise: ["ise", "sgn"],
        isg: ["isg", "sgn"],
        isr: ["isr", "sgn"],
        jak: ["jak", "ms"],
        jax: ["jax", "ms"],
        jcs: ["jcs", "sgn"],
        jhs: ["jhs", "sgn"],
        jls: ["jls", "sgn"],
        jos: ["jos", "sgn"],
        jsl: ["jsl", "sgn"],
        jus: ["jus", "sgn"],
        kgi: ["kgi", "sgn"],
        knn: ["knn", "kok"],
        kvb: ["kvb", "ms"],
        kvk: ["kvk", "sgn"],
        kvr: ["kvr", "ms"],
        kxd: ["kxd", "ms"],
        lbs: ["lbs", "sgn"],
        lce: ["lce", "ms"],
        lcf: ["lcf", "ms"],
        liw: ["liw", "ms"],
        lls: ["lls", "sgn"],
        lsg: ["lsg", "sgn"],
        lsl: ["lsl", "sgn"],
        lso: ["lso", "sgn"],
        lsp: ["lsp", "sgn"],
        lst: ["lst", "sgn"],
        lsy: ["lsy", "sgn"],
        ltg: ["ltg", "lv"],
        lvs: ["lvs", "lv"],
        lzh: ["lzh", "zh"],
        max: ["max", "ms"],
        mdl: ["mdl", "sgn"],
        meo: ["meo", "ms"],
        mfa: ["mfa", "ms"],
        mfb: ["mfb", "ms"],
        mfs: ["mfs", "sgn"],
        min: ["min", "ms"],
        mnp: ["mnp", "zh"],
        mqg: ["mqg", "ms"],
        mre: ["mre", "sgn"],
        msd: ["msd", "sgn"],
        msi: ["msi", "ms"],
        msr: ["msr", "sgn"],
        mui: ["mui", "ms"],
        mzc: ["mzc", "sgn"],
        mzg: ["mzg", "sgn"],
        mzy: ["mzy", "sgn"],
        nan: ["nan", "zh"],
        nbs: ["nbs", "sgn"],
        ncs: ["ncs", "sgn"],
        nsi: ["nsi", "sgn"],
        nsl: ["nsl", "sgn"],
        nsp: ["nsp", "sgn"],
        nsr: ["nsr", "sgn"],
        nzs: ["nzs", "sgn"],
        okl: ["okl", "sgn"],
        orn: ["orn", "ms"],
        ors: ["ors", "ms"],
        pel: ["pel", "ms"],
        pga: ["pga", "ar"],
        pks: ["pks", "sgn"],
        prl: ["prl", "sgn"],
        prz: ["prz", "sgn"],
        psc: ["psc", "sgn"],
        psd: ["psd", "sgn"],
        pse: ["pse", "ms"],
        psg: ["psg", "sgn"],
        psl: ["psl", "sgn"],
        pso: ["pso", "sgn"],
        psp: ["psp", "sgn"],
        psr: ["psr", "sgn"],
        pys: ["pys", "sgn"],
        rms: ["rms", "sgn"],
        rsi: ["rsi", "sgn"],
        rsl: ["rsl", "sgn"],
        sdl: ["sdl", "sgn"],
        sfb: ["sfb", "sgn"],
        sfs: ["sfs", "sgn"],
        sgg: ["sgg", "sgn"],
        sgx: ["sgx", "sgn"],
        shu: ["shu", "ar"],
        slf: ["slf", "sgn"],
        sls: ["sls", "sgn"],
        sqk: ["sqk", "sgn"],
        sqs: ["sqs", "sgn"],
        ssh: ["ssh", "ar"],
        ssp: ["ssp", "sgn"],
        ssr: ["ssr", "sgn"],
        svk: ["svk", "sgn"],
        swc: ["swc", "sw"],
        swh: ["swh", "sw"],
        swl: ["swl", "sgn"],
        syy: ["syy", "sgn"],
        tmw: ["tmw", "ms"],
        tse: ["tse", "sgn"],
        tsm: ["tsm", "sgn"],
        tsq: ["tsq", "sgn"],
        tss: ["tss", "sgn"],
        tsy: ["tsy", "sgn"],
        tza: ["tza", "sgn"],
        ugn: ["ugn", "sgn"],
        ugy: ["ugy", "sgn"],
        ukl: ["ukl", "sgn"],
        uks: ["uks", "sgn"],
        urk: ["urk", "ms"],
        uzn: ["uzn", "uz"],
        uzs: ["uzs", "uz"],
        vgt: ["vgt", "sgn"],
        vkk: ["vkk", "ms"],
        vkt: ["vkt", "ms"],
        vsi: ["vsi", "sgn"],
        vsl: ["vsl", "sgn"],
        vsv: ["vsv", "sgn"],
        wuu: ["wuu", "zh"],
        xki: ["xki", "sgn"],
        xml: ["xml", "sgn"],
        xmm: ["xmm", "ms"],
        xms: ["xms", "sgn"],
        yds: ["yds", "sgn"],
        ysl: ["ysl", "sgn"],
        yue: ["yue", "zh"],
        zib: ["zib", "sgn"],
        zlm: ["zlm", "ms"],
        zmi: ["zmi", "ms"],
        zsl: ["zsl", "sgn"],
        zsm: ["zsm", "ms"]
    }
};

/**
 * Convert only a-z to uppercase as per section 6.1 of the spec
 */
function toLatinUpperCase(str) {
    var i = str.length;

    while (i--) {
        var ch = str.charAt(i);

        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
    }

    return str;
}

/**
 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
 * argument (which must be a String value)
 *
 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
 *   2.1, or successor,
 * - does not include duplicate variant subtags, and
 * - does not include duplicate singleton subtags.
 *
 * The abstract operation returns true if locale can be generated from the ABNF
 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
 * contain duplicate variant or singleton subtags (other than as a private use
 * subtag). It returns false otherwise. Terminal value characters in the grammar are
 * interpreted as the Unicode equivalents of the ASCII octet values given.
 */
function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
    // represents a well-formed BCP 47 language tag as specified in RFC 5646
    if (!expBCP47Syntax.test(locale)) return false;

    // does not include duplicate variant subtags, and
    if (expVariantDupes.test(locale)) return false;

    // does not include duplicate singleton subtags.
    if (expSingletonDupes.test(locale)) return false;

    return true;
}

/**
 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
 * regularized form of the locale argument (which must be a String value that is
 * a structurally valid BCP 47 language tag as verified by the
 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
 * into canonical form, and to regularize the case of the subtags, but does not
 * take the steps to bring a language tag into “extlang form” and to reorder
 * variant subtags.

 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
 * may include canonicalization rules for the extension subtag sequences they
 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
 * Implementations are allowed, but not required, to apply these additional rules.
 */
function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
    var match = void 0,
        parts = void 0;

    // A language tag is in 'canonical form' when the tag is well-formed
    // according to the rules in Sections 2.1 and 2.2

    // Section 2.1 says all subtags use lowercase...
    locale = locale.toLowerCase();

    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
    // appear at the start of the tag nor occur after singletons.  Such two-letter
    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
    parts = locale.split('-');
    for (var i = 1, max = parts.length; i < max; i++) {
        // Two-letter subtags are all uppercase
        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();

        // Four-letter subtags are titlecase
        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);

            // Is it a singleton?
            else if (parts[i].length === 1 && parts[i] !== 'x') break;
    }
    locale = arrJoin.call(parts, '-');

    // The steps laid out in RFC 5646 section 4.5 are as follows:

    // 1.  Extension sequences are ordered into case-insensitive ASCII order
    //     by singleton subtag.
    if ((match = locale.match(expExtSequences)) && match.length > 1) {
        // The built-in sort() sorts by ASCII order, so use that
        match.sort();

        // Replace all extensions with the joined, sorted array
        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
    }

    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
    //     Value', if there is one.
    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];

    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
    //     For extlangs, the original primary language subtag is also
    //     replaced if there is a primary language subtag in the 'Preferred-
    //     Value'.
    parts = locale.split('-');

    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
            parts[_i] = redundantTags.extLang[parts[_i]][0];

            // For extlang tags, the prefix needs to be removed if it is redundant
            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
                parts = arrSlice.call(parts, _i++);
                _max -= 1;
            }
        }
    }

    return arrJoin.call(parts, '-');
}

/**
 * The DefaultLocale abstract operation returns a String value representing the
 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
 * host environment’s current locale.
 */
function /* 6.2.4 */DefaultLocale() {
    return defaultLocale;
}

// Sect 6.3 Currency Codes
// =======================

var expCurrencyCode = /^[A-Z]{3}$/;

/**
 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
 * code. The following steps are taken:
 */
function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
    // 1. Let `c` be ToString(currency)
    var c = String(currency);

    // 2. Let `normalized` be the result of mapping c to upper case as described
    //    in 6.1.
    var normalized = toLatinUpperCase(c);

    // 3. If the string length of normalized is not 3, return false.
    // 4. If normalized contains any character that is not in the range "A" to "Z"
    //    (U+0041 to U+005A), return false.
    if (expCurrencyCode.test(normalized) === false) return false;

    // 5. Return true
    return true;
}

var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below

function /* 9.2.1 */CanonicalizeLocaleList(locales) {
    // The abstract operation CanonicalizeLocaleList takes the following steps:

    // 1. If locales is undefined, then a. Return a new empty List
    if (locales === undefined) return new List();

    // 2. Let seen be a new empty List.
    var seen = new List();

    // 3. If locales is a String value, then
    //    a. Let locales be a new array created as if by the expression new
    //    Array(locales) where Array is the standard built-in constructor with
    //    that name and locales is the value of locales.
    locales = typeof locales === 'string' ? [locales] : locales;

    // 4. Let O be ToObject(locales).
    var O = toObject(locales);

    // 5. Let lenValue be the result of calling the [[Get]] internal method of
    //    O with the argument "length".
    // 6. Let len be ToUint32(lenValue).
    var len = toLength(O.length);

    // 7. Let k be 0.
    var k = 0;

    // 8. Repeat, while k < len
    while (k < len) {
        // a. Let Pk be ToString(k).
        var Pk = String(k);

        // b. Let kPresent be the result of calling the [[HasProperty]] internal
        //    method of O with argument Pk.
        var kPresent = Pk in O;

        // c. If kPresent is true, then
        if (kPresent) {
            // i. Let kValue be the result of calling the [[Get]] internal
            //     method of O with argument Pk.
            var kValue = O[Pk];

            // ii. If the type of kValue is not String or Object, then throw a
            //     TypeError exception.
            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');

            // iii. Let tag be ToString(kValue).
            var tag = String(kValue);

            // iv. If the result of calling the abstract operation
            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
            //     the argument, is false, then throw a RangeError exception.
            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");

            // v. Let tag be the result of calling the abstract operation
            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
            //    argument.
            tag = CanonicalizeLanguageTag(tag);

            // vi. If tag is not an element of seen, then append tag as the last
            //     element of seen.
            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
        }

        // d. Increase k by 1.
        k++;
    }

    // 9. Return seen.
    return seen;
}

/**
 * The BestAvailableLocale abstract operation compares the provided argument
 * locale, which must be a String value with a structurally valid and
 * canonicalized BCP 47 language tag, against the locales in availableLocales and
 * returns either the longest non-empty prefix of locale that is an element of
 * availableLocales, or undefined if there is no such element. It uses the
 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
 */
function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
    // 1. Let candidate be locale
    var candidate = locale;

    // 2. Repeat
    while (candidate) {
        // a. If availableLocales contains an element equal to candidate, then return
        // candidate.
        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;

        // b. Let pos be the character index of the last occurrence of "-"
        // (U+002D) within candidate. If that character does not occur, return
        // undefined.
        var pos = candidate.lastIndexOf('-');

        if (pos < 0) return;

        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
        //    then decrease pos by 2.
        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;

        // d. Let candidate be the substring of candidate from position 0, inclusive,
        //    to position pos, exclusive.
        candidate = candidate.substring(0, pos);
    }
}

/**
 * The LookupMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The following steps are taken:
 */
function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
    // 1. Let i be 0.
    var i = 0;

    // 2. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;

    // 3. Let availableLocale be undefined.
    var availableLocale = void 0;

    var locale = void 0,
        noExtensionsLocale = void 0;

    // 4. Repeat while i < len and availableLocale is undefined:
    while (i < len && !availableLocale) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position i.
        locale = requestedLocales[i];

        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');

        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. Increase i by 1.
        i++;
    }

    // 5. Let result be a new Record.
    var result = new Record();

    // 6. If availableLocale is not undefined, then
    if (availableLocale !== undefined) {
        // a. Set result.[[locale]] to availableLocale.
        result['[[locale]]'] = availableLocale;

        // b. If locale and noExtensionsLocale are not the same String value, then
        if (String(locale) !== String(noExtensionsLocale)) {
            // i. Let extension be the String value consisting of the first
            //    substring of locale that is a Unicode locale extension sequence.
            var extension = locale.match(expUnicodeExSeq)[0];

            // ii. Let extensionIndex be the character position of the initial
            //     "-" of the first Unicode locale extension sequence within locale.
            var extensionIndex = locale.indexOf('-u-');

            // iii. Set result.[[extension]] to extension.
            result['[[extension]]'] = extension;

            // iv. Set result.[[extensionIndex]] to extensionIndex.
            result['[[extensionIndex]]'] = extensionIndex;
        }
    }
    // 7. Else
    else
        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
        //    operation (defined in 6.2.4).
        result['[[locale]]'] = DefaultLocale();

    // 8. Return result
    return result;
}

/**
 * The BestFitMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The algorithm is implementation dependent, but should produce results
 * that a typical user of the requested locales would perceive as at least as
 * good as those produced by the LookupMatcher abstract operation. Options
 * specified through Unicode locale extension sequences must be ignored by the
 * algorithm. Information about such subsequences is returned separately.
 * The abstract operation returns a record with a [[locale]] field, whose value
 * is the language tag of the selected locale, which must be an element of
 * availableLocales. If the language tag of the request locale that led to the
 * selected locale contained a Unicode locale extension sequence, then the
 * returned record also contains an [[extension]] field whose value is the first
 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
 * is the index of the first Unicode locale extension sequence within the request
 * locale language tag.
 */
function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
    return LookupMatcher(availableLocales, requestedLocales);
}

/**
 * The ResolveLocale abstract operation compares a BCP 47 language priority list
 * requestedLocales against the locales in availableLocales and determines the
 * best available language to meet the request. availableLocales and
 * requestedLocales must be provided as List values, options as a Record.
 */
function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
    if (availableLocales.length === 0) {
        throw new ReferenceError('No locale data has been provided for this object yet.');
    }

    // The following steps are taken:
    // 1. Let matcher be the value of options.[[localeMatcher]].
    var matcher = options['[[localeMatcher]]'];

    var r = void 0;

    // 2. If matcher is "lookup", then
    if (matcher === 'lookup')
        // a. Let r be the result of calling the LookupMatcher abstract operation
        //    (defined in 9.2.3) with arguments availableLocales and
        //    requestedLocales.
        r = LookupMatcher(availableLocales, requestedLocales);

        // 3. Else
    else
        // a. Let r be the result of calling the BestFitMatcher abstract
        //    operation (defined in 9.2.4) with arguments availableLocales and
        //    requestedLocales.
        r = BestFitMatcher(availableLocales, requestedLocales);

    // 4. Let foundLocale be the value of r.[[locale]].
    var foundLocale = r['[[locale]]'];

    var extensionSubtags = void 0,
        extensionSubtagsLength = void 0;

    // 5. If r has an [[extension]] field, then
    if (hop.call(r, '[[extension]]')) {
        // a. Let extension be the value of r.[[extension]].
        var extension = r['[[extension]]'];
        // b. Let split be the standard built-in function object defined in ES5,
        //    15.5.4.14.
        var split = String.prototype.split;
        // c. Let extensionSubtags be the result of calling the [[Call]] internal
        //    method of split with extension as the this value and an argument
        //    list containing the single item "-".
        extensionSubtags = split.call(extension, '-');
        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
        //    internal method of extensionSubtags with argument "length".
        extensionSubtagsLength = extensionSubtags.length;
    }

    // 6. Let result be a new Record.
    var result = new Record();

    // 7. Set result.[[dataLocale]] to foundLocale.
    result['[[dataLocale]]'] = foundLocale;

    // 8. Let supportedExtension be "-u".
    var supportedExtension = '-u';
    // 9. Let i be 0.
    var i = 0;
    // 10. Let len be the result of calling the [[Get]] internal method of
    //     relevantExtensionKeys with argument "length".
    var len = relevantExtensionKeys.length;

    // 11 Repeat while i < len:
    while (i < len) {
        // a. Let key be the result of calling the [[Get]] internal method of
        //    relevantExtensionKeys with argument ToString(i).
        var key = relevantExtensionKeys[i];
        // b. Let foundLocaleData be the result of calling the [[Get]] internal
        //    method of localeData with the argument foundLocale.
        var foundLocaleData = localeData[foundLocale];
        // c. Let keyLocaleData be the result of calling the [[Get]] internal
        //    method of foundLocaleData with the argument key.
        var keyLocaleData = foundLocaleData[key];
        // d. Let value be the result of calling the [[Get]] internal method of
        //    keyLocaleData with argument "0".
        var value = keyLocaleData['0'];
        // e. Let supportedExtensionAddition be "".
        var supportedExtensionAddition = '';
        // f. Let indexOf be the standard built-in function object defined in
        //    ES5, 15.4.4.14.
        var indexOf = arrIndexOf;

        // g. If extensionSubtags is not undefined, then
        if (extensionSubtags !== undefined) {
            // i. Let keyPos be the result of calling the [[Call]] internal
            //    method of indexOf with extensionSubtags as the this value and
            // an argument list containing the single item key.
            var keyPos = indexOf.call(extensionSubtags, key);

            // ii. If keyPos ≠ -1, then
            if (keyPos !== -1) {
                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
                //    result of calling the [[Get]] internal method of
                //    extensionSubtags with argument ToString(keyPos +1) is greater
                //    than 2, then
                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
                    // a. Let requestedValue be the result of calling the [[Get]]
                    //    internal method of extensionSubtags with argument
                    //    ToString(keyPos + 1).
                    var requestedValue = extensionSubtags[keyPos + 1];
                    // b. Let valuePos be the result of calling the [[Call]]
                    //    internal method of indexOf with keyLocaleData as the
                    //    this value and an argument list containing the single
                    //    item requestedValue.
                    var valuePos = indexOf.call(keyLocaleData, requestedValue);

                    // c. If valuePos ≠ -1, then
                    if (valuePos !== -1) {
                        // i. Let value be requestedValue.
                        value = requestedValue,
                        // ii. Let supportedExtensionAddition be the
                        //     concatenation of "-", key, "-", and value.
                        supportedExtensionAddition = '-' + key + '-' + value;
                    }
                }
                // 2. Else
                else {
                        // a. Let valuePos be the result of calling the [[Call]]
                        // internal method of indexOf with keyLocaleData as the this
                        // value and an argument list containing the single item
                        // "true".
                        var _valuePos = indexOf(keyLocaleData, 'true');

                        // b. If valuePos ≠ -1, then
                        if (_valuePos !== -1)
                            // i. Let value be "true".
                            value = 'true';
                    }
            }
        }
        // h. If options has a field [[<key>]], then
        if (hop.call(options, '[[' + key + ']]')) {
            // i. Let optionsValue be the value of options.[[<key>]].
            var optionsValue = options['[[' + key + ']]'];

            // ii. If the result of calling the [[Call]] internal method of indexOf
            //     with keyLocaleData as the this value and an argument list
            //     containing the single item optionsValue is not -1, then
            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
                // 1. If optionsValue is not equal to value, then
                if (optionsValue !== value) {
                    // a. Let value be optionsValue.
                    value = optionsValue;
                    // b. Let supportedExtensionAddition be "".
                    supportedExtensionAddition = '';
                }
            }
        }
        // i. Set result.[[<key>]] to value.
        result['[[' + key + ']]'] = value;

        // j. Append supportedExtensionAddition to supportedExtension.
        supportedExtension += supportedExtensionAddition;

        // k. Increase i by 1.
        i++;
    }
    // 12. If the length of supportedExtension is greater than 2, then
    if (supportedExtension.length > 2) {
        // a.
        var privateIndex = foundLocale.indexOf("-x-");
        // b.
        if (privateIndex === -1) {
            // i.
            foundLocale = foundLocale + supportedExtension;
        }
        // c.
        else {
                // i.
                var preExtension = foundLocale.substring(0, privateIndex);
                // ii.
                var postExtension = foundLocale.substring(privateIndex);
                // iii.
                foundLocale = preExtension + supportedExtension + postExtension;
            }
        // d. asserting - skipping
        // e.
        foundLocale = CanonicalizeLanguageTag(foundLocale);
    }
    // 13. Set result.[[locale]] to foundLocale.
    result['[[locale]]'] = foundLocale;

    // 14. Return result.
    return result;
}

/**
 * The LookupSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
 * Locales appear in the same order in the returned list as in requestedLocales.
 * The following steps are taken:
 */
function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
    // 1. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;
    // 2. Let subset be a new empty List.
    var subset = new List();
    // 3. Let k be 0.
    var k = 0;

    // 4. Repeat while k < len
    while (k < len) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position k.
        var locale = requestedLocales[k];
        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. If availableLocale is not undefined, then append locale to the end of
        //    subset.
        if (availableLocale !== undefined) arrPush.call(subset, locale);

        // e. Increment k by 1.
        k++;
    }

    // 5. Let subsetArray be a new Array object whose elements are the same
    //    values in the same order as the elements of subset.
    var subsetArray = arrSlice.call(subset);

    // 6. Return subsetArray.
    return subsetArray;
}

/**
 * The BestFitSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the Best Fit Matcher
 * algorithm. Locales appear in the same order in the returned list as in
 * requestedLocales. The steps taken are implementation dependent.
 */
function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
    // ###TODO: implement this function as described by the specification###
    return LookupSupportedLocales(availableLocales, requestedLocales);
}

/**
 * The SupportedLocales abstract operation returns the subset of the provided BCP
 * 47 language priority list requestedLocales for which availableLocales has a
 * matching locale. Two algorithms are available to match the locales: the Lookup
 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
 * best-fit algorithm. Locales appear in the same order in the returned list as
 * in requestedLocales. The following steps are taken:
 */
function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = void 0,
        subset = void 0;

    // 1. If options is not undefined, then
    if (options !== undefined) {
        // a. Let options be ToObject(options).
        options = new Record(toObject(options));
        // b. Let matcher be the result of calling the [[Get]] internal method of
        //    options with argument "localeMatcher".
        matcher = options.localeMatcher;

        // c. If matcher is not undefined, then
        if (matcher !== undefined) {
            // i. Let matcher be ToString(matcher).
            matcher = String(matcher);

            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
            //     exception.
            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
        }
    }
    // 2. If matcher is undefined or "best fit", then
    if (matcher === undefined || matcher === 'best fit')
        // a. Let subset be the result of calling the BestFitSupportedLocales
        //    abstract operation (defined in 9.2.7) with arguments
        //    availableLocales and requestedLocales.
        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
        // 3. Else
    else
        // a. Let subset be the result of calling the LookupSupportedLocales
        //    abstract operation (defined in 9.2.6) with arguments
        //    availableLocales and requestedLocales.
        subset = LookupSupportedLocales(availableLocales, requestedLocales);

    // 4. For each named own property name P of subset,
    for (var P in subset) {
        if (!hop.call(subset, P)) continue;

        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
        //    method of subset with P.
        // b. Set desc.[[Writable]] to false.
        // c. Set desc.[[Configurable]] to false.
        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
        //    and true as arguments.
        defineProperty(subset, P, {
            writable: false, configurable: false, value: subset[P]
        });
    }
    // "Freeze" the array so no new elements can be added
    defineProperty(subset, 'length', { writable: false });

    // 5. Return subset
    return subset;
}

/**
 * The GetOption abstract operation extracts the value of the property named
 * property from the provided options object, converts it to the required type,
 * checks whether it is one of a List of allowed values, and fills in a fallback
 * value if necessary.
 */
function /*9.2.9 */GetOption(options, property, type, values, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Assert: type is "boolean" or "string".
        // b. If type is "boolean", then let value be ToBoolean(value).
        // c. If type is "string", then let value be ToString(value).
        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;

        // d. If values is not undefined, then
        if (values !== undefined) {
            // i. If values does not contain an element equal to value, then throw a
            //    RangeError exception.
            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
        }

        // e. Return value.
        return value;
    }
    // Else return fallback.
    return fallback;
}

/**
 * The GetNumberOption abstract operation extracts a property value from the
 * provided options object, converts it to a Number value, checks whether it is
 * in the allowed range, and fills in a fallback value if necessary.
 */
function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Let value be ToNumber(value).
        value = Number(value);

        // b. If value is NaN or less than minimum or greater than maximum, throw a
        //    RangeError exception.
        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');

        // c. Return floor(value).
        return Math.floor(value);
    }
    // 3. Else return fallback.
    return fallback;
}

// 8 The Intl Object
var Intl = {};

// 8.2 Function Properties of the Intl Object

// 8.2.1
// @spec[tc39/ecma402/master/spec/intl.html]
// @clause[sec-intl.getcanonicallocales]
function getCanonicalLocales(locales) {
    // 1. Let ll be ? CanonicalizeLocaleList(locales).
    var ll = CanonicalizeLocaleList(locales);
    // 2. Return CreateArrayFromList(ll).
    {
        var result = [];

        var len = ll.length;
        var k = 0;

        while (k < len) {
            result[k] = ll[k];
            k++;
        }
        return result;
    }
}

Object.defineProperty(Intl, 'getCanonicalLocales', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: getCanonicalLocales
});

// Currency minor units output from get-4217 grunt task, formatted
var currencyMinorUnits = {
    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
};

// Define the NumberFormat constructor internally so it cannot be tainted
function NumberFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.NumberFormat(locales, options);
    }

    return InitializeNumberFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'NumberFormat', {
    configurable: true,
    writable: true,
    value: NumberFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(Intl.NumberFormat, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeNumberFormat accepts the arguments
 * numberFormat (which must be an object), locales, and options. It initializes
 * numberFormat as a NumberFormat object.
 */
function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(numberFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
    // value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(numberFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. If options is undefined, then
    if (options === undefined)
        // a. Let options be the result of creating a new object as if by the
        // expression new Object() where Object is the standard built-in constructor
        // with that name.
        options = {};

        // 5. Else
    else
        // a. Let options be ToObject(options).
        options = toObject(options);

    // 6. Let opt be a new Record.
    var opt = new Record(),


    // 7. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
    //    a List containing the two String values "lookup" and "best fit", and
    //    "best fit".
    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 8. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 9. Let NumberFormat be the standard built-in object that is the initial value
    //    of Intl.NumberFormat.
    // 10. Let localeData be the value of the [[localeData]] internal property of
    //     NumberFormat.
    var localeData = internals.NumberFormat['[[localeData]]'];

    // 11. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //     internal property of NumberFormat, and localeData.
    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);

    // 12. Set the [[locale]] internal property of numberFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
    //     of r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let s be the result of calling the GetOption abstract operation with the
    //     arguments options, "style", "string", a List containing the three String
    //     values "decimal", "percent", and "currency", and "decimal".
    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');

    // 16. Set the [[style]] internal property of numberFormat to s.
    internal['[[style]]'] = s;

    // 17. Let c be the result of calling the GetOption abstract operation with the
    //     arguments options, "currency", "string", undefined, and undefined.
    var c = GetOption(options, 'currency', 'string');

    // 18. If c is not undefined and the result of calling the
    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
    //     argument c is false, then throw a RangeError exception.
    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");

    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');

    var cDigits = void 0;

    // 20. If s is "currency", then
    if (s === 'currency') {
        // a. Let c be the result of converting c to upper case as specified in 6.1.
        c = c.toUpperCase();

        // b. Set the [[currency]] internal property of numberFormat to c.
        internal['[[currency]]'] = c;

        // c. Let cDigits be the result of calling the CurrencyDigits abstract
        //    operation (defined below) with argument c.
        cDigits = CurrencyDigits(c);
    }

    // 21. Let cd be the result of calling the GetOption abstract operation with the
    //     arguments options, "currencyDisplay", "string", a List containing the
    //     three String values "code", "symbol", and "name", and "symbol".
    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');

    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
    //     numberFormat to cd.
    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;

    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
    //     and 1.
    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);

    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
    internal['[[minimumIntegerDigits]]'] = mnid;

    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
    //     be 0.
    var mnfdDefault = s === 'currency' ? cDigits : 0;

    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);

    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
    internal['[[minimumFractionDigits]]'] = mnfd;

    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
    //     be max(mnfd, 3).
    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);

    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);

    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
    internal['[[maximumFractionDigits]]'] = mxfd;

    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
    //     with argument "minimumSignificantDigits".
    var mnsd = options.minimumSignificantDigits;

    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
    //     with argument "maximumSignificantDigits".
    var mxsd = options.maximumSignificantDigits;

    // 33. If mnsd is not undefined or mxsd is not undefined, then:
    if (mnsd !== undefined || mxsd !== undefined) {
        // a. Let mnsd be the result of calling the GetNumberOption abstract
        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
        //    and 1.
        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);

        // b. Let mxsd be the result of calling the GetNumberOption abstract
        //     operation with arguments options, "maximumSignificantDigits", mnsd,
        //     21, and 21.
        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);

        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
        //    numberFormat to mxsd.
        internal['[[minimumSignificantDigits]]'] = mnsd;
        internal['[[maximumSignificantDigits]]'] = mxsd;
    }
    // 34. Let g be the result of calling the GetOption abstract operation with the
    //     arguments options, "useGrouping", "boolean", undefined, and true.
    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);

    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
    internal['[[useGrouping]]'] = g;

    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 37. Let patterns be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "patterns".
    var patterns = dataLocaleData.patterns;

    // 38. Assert: patterns is an object (see 11.2.3)

    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
    //     patterns with argument s.
    var stylePatterns = patterns[s];

    // 40. Set the [[positivePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "positivePattern".
    internal['[[positivePattern]]'] = stylePatterns.positivePattern;

    // 41. Set the [[negativePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "negativePattern".
    internal['[[negativePattern]]'] = stylePatterns.negativePattern;

    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
    //     true.
    internal['[[initializedNumberFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return numberFormat;
}

function CurrencyDigits(currency) {
    // When the CurrencyDigits abstract operation is called with an argument currency
    // (which must be an upper case String value), the following steps are taken:

    // 1. If the ISO 4217 currency and funds code list contains currency as an
    // alphabetic code, then return the minor unit value corresponding to the
    // currency from the list; else return 2.
    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
}

/* 11.2.3 */internals.NumberFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
 * following steps are taken:
 */
/* 11.2.2 */
defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * NumberFormat object.
 */
/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatNumber
});

function GetFormatNumber() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 11.3_b
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this NumberFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 1, that takes the argument value and
        //    performs the following steps:
        var F = function F(value) {
            // i. If value is not provided, then let value be undefined.
            // ii. Let x be ToNumber(value).
            // iii. Return the result of calling the FormatNumber abstract
            //      operation (defined below) with arguments this and x.
            return FormatNumber(this, /* x = */Number(value));
        };

        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);

        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');

    var x = Number(value);
    return FormatNumberToParts(this, x);
}

Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: formatToParts
});

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumbertoparts]
 */
function FormatNumberToParts(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be ArrayCreate(0).
    var result = [];
    // 3. Let n be 0.
    var n = 0;
    // 4. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Let O be ObjectCreate(%ObjectPrototype%).
        var O = {};
        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
        O.type = part['[[type]]'];
        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
        O.value = part['[[value]]'];
        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
        result[n] = O;
        // a. Increment n by 1.
        n += 1;
    }
    // 5. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-partitionnumberpattern]
 */
function PartitionNumberPattern(numberFormat, x) {

    var internal = getInternalProperties(numberFormat),
        locale = internal['[[dataLocale]]'],
        nums = internal['[[numberingSystem]]'],
        data = internals.NumberFormat['[[localeData]]'][locale],
        ild = data.symbols[nums] || data.symbols.latn,
        pattern = void 0;

    // 1. If x is not NaN and x < 0, then:
    if (!isNaN(x) && x < 0) {
        // a. Let x be -x.
        x = -x;
        // a. Let pattern be the value of numberFormat.[[negativePattern]].
        pattern = internal['[[negativePattern]]'];
    }
    // 2. Else,
    else {
            // a. Let pattern be the value of numberFormat.[[positivePattern]].
            pattern = internal['[[positivePattern]]'];
        }
    // 3. Let result be a new empty List.
    var result = new List();
    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
    var beginIndex = pattern.indexOf('{', 0);
    // 5. Let endIndex be 0.
    var endIndex = 0;
    // 6. Let nextIndex be 0.
    var nextIndex = 0;
    // 7. Let length be the number of code units in pattern.
    var length = pattern.length;
    // 8. Repeat while beginIndex is an integer index into pattern:
    while (beginIndex > -1 && beginIndex < length) {
        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
        endIndex = pattern.indexOf('}', beginIndex);
        // a. If endIndex = -1, throw new Error exception.
        if (endIndex === -1) throw new Error();
        // a. If beginIndex is greater than nextIndex, then:
        if (beginIndex > nextIndex) {
            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
            var literal = pattern.substring(nextIndex, beginIndex);
            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
        }
        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // a. If p is equal "number", then:
        if (p === "number") {
            // i. If x is NaN,
            if (isNaN(x)) {
                // 1. Let n be an ILD String value indicating the NaN value.
                var n = ild.nan;
                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
            }
            // ii. Else if isFinite(x) is false,
            else if (!isFinite(x)) {
                    // 1. Let n be an ILD String value indicating infinity.
                    var _n = ild.infinity;
                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
                }
                // iii. Else,
                else {
                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;

                        var _n2 = void 0;
                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
                        }
                        // 3. Else,
                        else {
                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
                            }
                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
                        if (numSys[nums]) {
                            (function () {
                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
                                var digits = numSys[nums];
                                // a. Replace each digit in n with the value of digits[digit].
                                _n2 = String(_n2).replace(/\d/g, function (digit) {
                                    return digits[digit];
                                });
                            })();
                        }
                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
                        else _n2 = String(_n2); // ###TODO###

                        var integer = void 0;
                        var fraction = void 0;
                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
                        var decimalSepIndex = _n2.indexOf('.', 0);
                        // 7. If decimalSepIndex > 0, then:
                        if (decimalSepIndex > 0) {
                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
                            integer = _n2.substring(0, decimalSepIndex);
                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
                        }
                        // 8. Else:
                        else {
                                // a. Let integer be n.
                                integer = _n2;
                                // a. Let fraction be undefined.
                                fraction = undefined;
                            }
                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
                        if (internal['[[useGrouping]]'] === true) {
                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
                            var groupSepSymbol = ild.group;
                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
                            var groups = [];
                            // ----> implementation:
                            // Primary group represents the group closest to the decimal
                            var pgSize = data.patterns.primaryGroupSize || 3;
                            // Secondary group is every other group
                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
                            // Group only if necessary
                            if (integer.length > pgSize) {
                                // Index of the primary grouping separator
                                var end = integer.length - pgSize;
                                // Starting index for our loop
                                var idx = end % sgSize;
                                var start = integer.slice(0, idx);
                                if (start.length) arrPush.call(groups, start);
                                // Loop to separate into secondary grouping digits
                                while (idx < end) {
                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
                                    idx += sgSize;
                                }
                                // Add the primary grouping digits
                                arrPush.call(groups, integer.slice(end));
                            } else {
                                arrPush.call(groups, integer);
                            }
                            // a. Assert: The number of elements in groups List is greater than 0.
                            if (groups.length === 0) throw new Error();
                            // a. Repeat, while groups List is not empty:
                            while (groups.length) {
                                // i. Remove the first element from groups and let integerGroup be the value of that element.
                                var integerGroup = arrShift.call(groups);
                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
                                // iii. If groups List is not empty, then:
                                if (groups.length) {
                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
                                }
                            }
                        }
                        // 10. Else,
                        else {
                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
                            }
                        // 11. If fraction is not undefined, then:
                        if (fraction !== undefined) {
                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
                            var decimalSepSymbol = ild.decimal;
                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
                        }
                    }
        }
        // a. Else if p is equal "plusSign", then:
        else if (p === "plusSign") {
                // i. Let plusSignSymbol be the ILND String representing the plus sign.
                var plusSignSymbol = ild.plusSign;
                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
            }
            // a. Else if p is equal "minusSign", then:
            else if (p === "minusSign") {
                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
                    var minusSignSymbol = ild.minusSign;
                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
                }
                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
                        var percentSignSymbol = ild.percentSign;
                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
                    }
                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
                    else if (p === "currency" && internal['[[style]]'] === "currency") {
                            // i. Let currency be the value of numberFormat.[[currency]].
                            var currency = internal['[[currency]]'];

                            var cd = void 0;

                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
                            if (internal['[[currencyDisplay]]'] === "code") {
                                // 1. Let cd be currency.
                                cd = currency;
                            }
                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
                            else if (internal['[[currencyDisplay]]'] === "symbol") {
                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
                                    cd = data.currencies[currency] || currency;
                                }
                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
                                else if (internal['[[currencyDisplay]]'] === "name") {
                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
                                        cd = currency;
                                    }
                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
                        }
                        // a. Else,
                        else {
                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
                                var _literal = pattern.substring(beginIndex, endIndex);
                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
                            }
        // a. Set nextIndex to endIndex + 1.
        nextIndex = endIndex + 1;
        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
        beginIndex = pattern.indexOf('{', nextIndex);
    }
    // 9. If nextIndex is less than length, then:
    if (nextIndex < length) {
        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
        var _literal2 = pattern.substring(nextIndex, length);
        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
    }
    // 10. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumber]
 */
function FormatNumber(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be an empty String.
    var result = '';
    // 3. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Set result to a String value produced by concatenating result and part.[[value]].
        result += part['[[value]]'];
    }
    // 4. Return result.
    return result;
}

/**
 * When the ToRawPrecision abstract operation is called with arguments x (which
 * must be a finite non-negative number), minPrecision, and maxPrecision (both
 * must be integers between 1 and 21) the following steps are taken:
 */
function ToRawPrecision(x, minPrecision, maxPrecision) {
    // 1. Let p be maxPrecision.
    var p = maxPrecision;

    var m = void 0,
        e = void 0;

    // 2. If x = 0, then
    if (x === 0) {
        // a. Let m be the String consisting of p occurrences of the character "0".
        m = arrJoin.call(Array(p + 1), '0');
        // b. Let e be 0.
        e = 0;
    }
    // 3. Else
    else {
            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
            //    possible. If there are two such sets of e and n, pick the e and n for
            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
            e = log10Floor(Math.abs(x));

            // Easier to get to m from here
            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));

            // b. Let m be the String consisting of the digits of the decimal
            //    representation of n (in order, with no leading zeroes)
            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
        }

    // 4. If e ≥ p, then
    if (e >= p)
        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
        return m + arrJoin.call(Array(e - p + 1 + 1), '0');

        // 5. If e = p-1, then
    else if (e === p - 1)
            // a. Return m.
            return m;

            // 6. If e ≥ 0, then
        else if (e >= 0)
                // a. Let m be the concatenation of the first e+1 characters of m, the character
                //    ".", and the remaining p–(e+1) characters of m.
                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);

                // 7. If e < 0, then
            else if (e < 0)
                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
                    //    character "0", and the string m.
                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;

    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        // a. Let cut be maxPrecision – minPrecision.
        var cut = maxPrecision - minPrecision;

        // b. Repeat while cut > 0 and the last character of m is "0":
        while (cut > 0 && m.charAt(m.length - 1) === '0') {
            //  i. Remove the last character from m.
            m = m.slice(0, -1);

            //  ii. Decrease cut by 1.
            cut--;
        }

        // c. If the last character of m is ".", then
        if (m.charAt(m.length - 1) === '.')
            //    i. Remove the last character from m.
            m = m.slice(0, -1);
    }
    // 9. Return m.
    return m;
}

/**
 * @spec[tc39/ecma402/master/spec/numberformat.html]
 * @clause[sec-torawfixed]
 * When the ToRawFixed abstract operation is called with arguments x (which must
 * be a finite non-negative number), minInteger (which must be an integer between
 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
 * 20) the following steps are taken:
 */
function ToRawFixed(x, minInteger, minFraction, maxFraction) {
    // 1. Let f be maxFraction.
    var f = maxFraction;
    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
    var n = Math.pow(10, f) * x; // diverging...
    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
    var m = n === 0 ? "0" : n.toFixed(0); // divering...

    {
        // this diversion is needed to take into consideration big numbers, e.g.:
        // 1.2344501e+37 -> 12344501000000000000000000000000000000
        var idx = void 0;
        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
        if (exp) {
            m = m.slice(0, idx).replace('.', '');
            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
        }
    }

    var int = void 0;
    // 4. If f ≠ 0, then
    if (f !== 0) {
        // a. Let k be the number of characters in m.
        var k = m.length;
        // a. If k ≤ f, then
        if (k <= f) {
            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
            // ii. Let m be the concatenation of Strings z and m.
            m = z + m;
            // iii. Let k be f+1.
            k = f + 1;
        }
        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
        var a = m.substring(0, k - f),
            b = m.substring(k - f, m.length);
        // a. Let m be the concatenation of the three Strings a, ".", and b.
        m = a + "." + b;
        // a. Let int be the number of characters in a.
        int = a.length;
    }
    // 5. Else, let int be the number of characters in m.
    else int = m.length;
    // 6. Let cut be maxFraction – minFraction.
    var cut = maxFraction - minFraction;
    // 7. Repeat while cut > 0 and the last character of m is "0":
    while (cut > 0 && m.slice(-1) === "0") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
        // a. Decrease cut by 1.
        cut--;
    }
    // 8. If the last character of m is ".", then
    if (m.slice(-1) === ".") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
    }
    // 9. If int < minInteger, then
    if (int < minInteger) {
        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
        // a. Let m be the concatenation of Strings z and m.
        m = _z + m;
    }
    // 10. Return m.
    return m;
}

// Sect 11.3.2 Table 2, Numbering systems
// ======================================
var numSys = {
    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
};

/**
 * This function provides access to the locale and formatting options computed
 * during initialization of the object.
 *
 * The function returns a new object whose properties and attributes are set as
 * if constructed by an object literal assigning to each of the following
 * properties the value of the corresponding internal property of this
 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
 * useGrouping. Properties whose corresponding internal properties are not present
 * are not assigned.
 */
/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
    configurable: true,
    writable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 11.3_b
        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

/* jslint esnext: true */

// Match these datetime components in a CLDR pattern, except those in single quotes
var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
// trim patterns after transformations
var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
// Skip over patterns with these datetime components because we don't have data
// to back them up:
// timezone, weekday, amoung others
var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string

var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];

function isDateFormatOnly(obj) {
    for (var i = 0; i < tmKeys.length; i += 1) {
        if (obj.hasOwnProperty(tmKeys[i])) {
            return false;
        }
    }
    return true;
}

function isTimeFormatOnly(obj) {
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (obj.hasOwnProperty(dtKeys[i])) {
            return false;
        }
    }
    return true;
}

function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
    var o = { _: {} };
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (dateFormatObj[dtKeys[i]]) {
            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
        }
        if (dateFormatObj._[dtKeys[i]]) {
            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
        }
    }
    for (var j = 0; j < tmKeys.length; j += 1) {
        if (timeFormatObj[tmKeys[j]]) {
            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
        }
        if (timeFormatObj._[tmKeys[j]]) {
            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
        }
    }
    return o;
}

function computeFinalPatterns(formatObj) {
    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
    //  'In patterns, two single quotes represents a literal single quote, either
    //   inside or outside single quotes. Text within single quotes is not
    //   interpreted in any way (except for two adjacent single quotes).'
    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
        return literal ? literal : "'";
    });

    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
    return formatObj;
}

function expDTComponentsMeta($0, formatObj) {
    switch ($0.charAt(0)) {
        // --- Era
        case 'G':
            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
            return '{era}';

        // --- Year
        case 'y':
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
            return '{year}';

        // --- Quarter (not supported in this polyfill)
        case 'Q':
        case 'q':
            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{quarter}';

        // --- Month
        case 'M':
        case 'L':
            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{month}';

        // --- Week (not supported in this polyfill)
        case 'w':
            // week of the year
            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
            return '{weekday}';
        case 'W':
            // week of the month
            formatObj.week = 'numeric';
            return '{weekday}';

        // --- Day
        case 'd':
            // day of the month
            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
            return '{day}';
        case 'D': // day of the year
        case 'F': // day of the week
        case 'g':
            // 1..n: Modified Julian day
            formatObj.day = 'numeric';
            return '{day}';

        // --- Week Day
        case 'E':
            // day of the week
            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'e':
            // local day of the week
            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'c':
            // stand alone local day of the week
            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';

        // --- Period
        case 'a': // AM, PM
        case 'b': // am, pm, noon, midnight
        case 'B':
            // flexible day periods
            formatObj.hour12 = true;
            return '{ampm}';

        // --- Hour
        case 'h':
        case 'H':
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';
        case 'k':
        case 'K':
            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';

        // --- Minute
        case 'm':
            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
            return '{minute}';

        // --- Second
        case 's':
            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
            return '{second}';
        case 'S':
        case 'A':
            formatObj.second = 'numeric';
            return '{second}';

        // --- Timezone
        case 'z': // 1..3, 4: specific non-location format
        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
        case 'O': // 1, 4: miliseconds in day short, long
        case 'v': // 1, 4: generic non-location format
        case 'V': // 1, 2, 3, 4: time zone ID or city
        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
        case 'x':
            // 1, 2, 3, 4: The ISO8601 varios formats
            // this polyfill only supports much, for now, we are just doing something dummy
            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
            return '{timeZoneName}';
    }
}

/**
 * Converts the CLDR availableFormats into the objects and patterns required by
 * the ECMAScript Internationalization API specification.
 */
function createDateTimeFormat(skeleton, pattern) {
    // we ignore certain patterns that are unsupported to avoid this expensive op.
    if (unwantedDTCs.test(pattern)) return undefined;

    var formatObj = {
        originalPattern: pattern,
        _: {}
    };

    // Replace the pattern string with the one required by the specification, whilst
    // at the same time evaluating it for the subsets and formats
    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj._);
    });

    // Match the skeleton string with the one required by the specification
    // this implementation is based on the Date Field Symbol Table:
    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
    // Note: we are adding extra data to the formatObject even though this polyfill
    //       might not support it.
    skeleton.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj);
    });

    return computeFinalPatterns(formatObj);
}

/**
 * Processes DateTime formats from CLDR to an easier-to-parse format.
 * the result of this operation should be cached the first time a particular
 * calendar is analyzed.
 *
 * The specification requires we support at least the following subsets of
 * date/time components:
 *
 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
 *   - 'weekday', 'year', 'month', 'day'
 *   - 'year', 'month', 'day'
 *   - 'year', 'month'
 *   - 'month', 'day'
 *   - 'hour', 'minute', 'second'
 *   - 'hour', 'minute'
 *
 * We need to cherry pick at least these subsets from the CLDR data and convert
 * them into the pattern objects used in the ECMA-402 API.
 */
function createDateTimeFormats(formats) {
    var availableFormats = formats.availableFormats;
    var timeFormats = formats.timeFormats;
    var dateFormats = formats.dateFormats;
    var result = [];
    var skeleton = void 0,
        pattern = void 0,
        computed = void 0,
        i = void 0,
        j = void 0;
    var timeRelatedFormats = [];
    var dateRelatedFormats = [];

    // Map available (custom) formats into a pattern for createDateTimeFormats
    for (skeleton in availableFormats) {
        if (availableFormats.hasOwnProperty(skeleton)) {
            pattern = availableFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                // in some cases, the format is only displaying date specific props
                // or time specific props, in which case we need to also produce the
                // combined formats.
                if (isDateFormatOnly(computed)) {
                    dateRelatedFormats.push(computed);
                } else if (isTimeFormatOnly(computed)) {
                    timeRelatedFormats.push(computed);
                }
            }
        }
    }

    // Map time formats into a pattern for createDateTimeFormats
    for (skeleton in timeFormats) {
        if (timeFormats.hasOwnProperty(skeleton)) {
            pattern = timeFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                timeRelatedFormats.push(computed);
            }
        }
    }

    // Map date formats into a pattern for createDateTimeFormats
    for (skeleton in dateFormats) {
        if (dateFormats.hasOwnProperty(skeleton)) {
            pattern = dateFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                dateRelatedFormats.push(computed);
            }
        }
    }

    // combine custom time and custom date formats when they are orthogonals to complete the
    // formats supported by CLDR.
    // This Algo is based on section "Missing Skeleton Fields" from:
    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
    for (i = 0; i < timeRelatedFormats.length; i += 1) {
        for (j = 0; j < dateRelatedFormats.length; j += 1) {
            if (dateRelatedFormats[j].month === 'long') {
                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
            } else if (dateRelatedFormats[j].month === 'short') {
                pattern = formats.medium;
            } else {
                pattern = formats.short;
            }
            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
            computed.originalPattern = pattern;
            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
            result.push(computeFinalPatterns(computed));
        }
    }

    return result;
}

// this represents the exceptions of the rule that are not covered by CLDR availableFormats
// for single property configurations, they play no role when using multiple properties, and
// those that are not in this table, are not exceptions or are not covered by the data we
// provide.
var validSyntheticProps = {
    second: {
        numeric: 's',
        '2-digit': 'ss'
    },
    minute: {
        numeric: 'm',
        '2-digit': 'mm'
    },
    year: {
        numeric: 'y',
        '2-digit': 'yy'
    },
    day: {
        numeric: 'd',
        '2-digit': 'dd'
    },
    month: {
        numeric: 'L',
        '2-digit': 'LL',
        narrow: 'LLLLL',
        short: 'LLL',
        long: 'LLLL'
    },
    weekday: {
        narrow: 'ccccc',
        short: 'ccc',
        long: 'cccc'
    }
};

function generateSyntheticFormat(propName, propValue) {
    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
        var _ref2;

        return _ref2 = {
            originalPattern: validSyntheticProps[propName][propValue],
            _: defineProperty$1({}, propName, propValue),
            extendedPattern: "{" + propName + "}"
        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
    }
}

// An object map of date component keys, saves using a regex later
var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });

/**
 * Returns a string for a date component, resolved using multiple inheritance as specified
 * as specified in the Unicode Technical Standard 35.
 */
function resolveDateString(data, ca, component, width, key) {
    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
    // 'In clearly specified instances, resources may inherit from within the same locale.
    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],


    // "sideways" inheritance resolves strings when a key doesn't exist
    alts = {
        narrow: ['short', 'long'],
        short: ['long', 'narrow'],
        long: ['short', 'narrow']
    },


    //
    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];

    // `key` wouldn't be specified for components 'dayPeriods'
    return key !== null ? resolved[key] : resolved;
}

// Define the DateTimeFormat constructor internally so it cannot be tainted
function DateTimeFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.DateTimeFormat(locales, options);
    }
    return InitializeDateTimeFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'DateTimeFormat', {
    configurable: true,
    writable: true,
    value: DateTimeFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(DateTimeFormatConstructor, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
 * DateTimeFormat object.
 */
function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(dateTimeFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
    //    value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(dateTimeFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined below) with arguments options, "any", and "date".
    options = ToDateTimeOptions(options, 'any', 'date');

    // 5. Let opt be a new Record.
    var opt = new Record();

    // 6. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
    //    containing the two String values "lookup" and "best fit", and "best fit".
    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 7. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 8. Let DateTimeFormat be the standard built-in object that is the initial
    //    value of Intl.DateTimeFormat.
    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need

    // 9. Let localeData be the value of the [[localeData]] internal property of
    //    DateTimeFormat.
    var localeData = DateTimeFormat['[[localeData]]'];

    // 10. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //      internal property of DateTimeFormat, and localeData.
    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);

    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
    //     r.[[ca]].
    internal['[[calendar]]'] = r['[[ca]]'];

    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
    //     r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let tz be the result of calling the [[Get]] internal method of options with
    //     argument "timeZone".
    var tz = options.timeZone;

    // 16. If tz is not undefined, then
    if (tz !== undefined) {
        // a. Let tz be ToString(tz).
        // b. Convert tz to upper case as described in 6.1.
        //    NOTE: If an implementation accepts additional time zone values, as permitted
        //          under certain conditions by the Conformance clause, different casing
        //          rules apply.
        tz = toLatinUpperCase(tz);

        // c. If tz is not "UTC", then throw a RangeError exception.
        // ###TODO: accept more time zones###
        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
    }

    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
    internal['[[timeZone]]'] = tz;

    // 18. Let opt be a new Record.
    opt = new Record();

    // 19. For each row of Table 3, except the header row, do:
    for (var prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, prop)) continue;

        // 20. Let prop be the name given in the Property column of the row.
        // 21. Let value be the result of calling the GetOption abstract operation,
        //     passing as argument options, the name given in the Property column of the
        //     row, "string", a List containing the strings given in the Values column of
        //     the row, and undefined.
        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);

        // 22. Set opt.[[<prop>]] to value.
        opt['[[' + prop + ']]'] = value;
    }

    // Assigned a value below
    var bestFormat = void 0;

    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 24. Let formats be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "formats".
    //     Note: we process the CLDR formats into the spec'd structure
    var formats = ToDateTimeFormats(dataLocaleData.formats);

    // 25. Let matcher be the result of calling the GetOption abstract operation with
    //     arguments options, "formatMatcher", "string", a List containing the two String
    //     values "basic" and "best fit", and "best fit".
    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');

    // Optimization: caching the processed formats as a one time operation by
    // replacing the initial structure from localeData
    dataLocaleData.formats = formats;

    // 26. If matcher is "basic", then
    if (matcher === 'basic') {
        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
        //     operation (defined below) with opt and formats.
        bestFormat = BasicFormatMatcher(opt, formats);

        // 28. Else
    } else {
        {
            // diverging
            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
        }
        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
        //     abstract operation (defined below) with opt and formats.
        bestFormat = BestFitFormatMatcher(opt, formats);
    }

    // 30. For each row in Table 3, except the header row, do
    for (var _prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, _prop)) continue;

        // a. Let prop be the name given in the Property column of the row.
        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
        //    bestFormat with argument prop.
        // c. If pDesc is not undefined, then
        if (hop.call(bestFormat, _prop)) {
            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
            //    with argument prop.
            var p = bestFormat[_prop];
            {
                // diverging
                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
            }

            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
            internal['[[' + _prop + ']]'] = p;
        }
    }

    var pattern = void 0; // Assigned a value below

    // 31. Let hr12 be the result of calling the GetOption abstract operation with
    //     arguments options, "hour12", "boolean", undefined, and undefined.
    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);

    // 32. If dateTimeFormat has an internal property [[hour]], then
    if (internal['[[hour]]']) {
        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
        //    internal method of dataLocaleData with argument "hour12".
        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;

        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
        internal['[[hour12]]'] = hr12;

        // c. If hr12 is true, then
        if (hr12 === true) {
            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
            //    dataLocaleData with argument "hourNo0".
            var hourNo0 = dataLocaleData.hourNo0;

            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
            internal['[[hourNo0]]'] = hourNo0;

            // iii. Let pattern be the result of calling the [[Get]] internal method of
            //      bestFormat with argument "pattern12".
            pattern = bestFormat.pattern12;
        }

        // d. Else
        else
            // i. Let pattern be the result of calling the [[Get]] internal method of
            //    bestFormat with argument "pattern".
            pattern = bestFormat.pattern;
    }

    // 33. Else
    else
        // a. Let pattern be the result of calling the [[Get]] internal method of
        //    bestFormat with argument "pattern".
        pattern = bestFormat.pattern;

    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
    internal['[[pattern]]'] = pattern;

    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
    //     true.
    internal['[[initializedDateTimeFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return dateTimeFormat;
}

/**
 * Several DateTimeFormat algorithms use values from the following table, which provides
 * property names and allowable values for the components of date and time formats:
 */
var dateTimeComponents = {
    weekday: ["narrow", "short", "long"],
    era: ["narrow", "short", "long"],
    year: ["2-digit", "numeric"],
    month: ["2-digit", "numeric", "narrow", "short", "long"],
    day: ["2-digit", "numeric"],
    hour: ["2-digit", "numeric"],
    minute: ["2-digit", "numeric"],
    second: ["2-digit", "numeric"],
    timeZoneName: ["short", "long"]
};

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeFormats(formats) {
    if (Object.prototype.toString.call(formats) === '[object Array]') {
        return formats;
    }
    return createDateTimeFormats(formats);
}

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeOptions(options, required, defaults) {
    // 1. If options is undefined, then let options be null, else let options be
    //    ToObject(options).
    if (options === undefined) options = null;else {
        // (#12) options needs to be a Record, but it also needs to inherit properties
        var opt2 = toObject(options);
        options = new Record();

        for (var k in opt2) {
            options[k] = opt2[k];
        }
    }

    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
    var create = objCreate;

    // 3. Let options be the result of calling the [[Call]] internal method of create with
    //    undefined as the this value and an argument list containing the single item
    //    options.
    options = create(options);

    // 4. Let needDefaults be true.
    var needDefaults = true;

    // 5. If required is "date" or "any", then
    if (required === 'date' || required === 'any') {
        // a. For each of the property names "weekday", "year", "month", "day":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
    }

    // 6. If required is "time" or "any", then
    if (required === 'time' || required === 'any') {
        // a. For each of the property names "hour", "minute", "second":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
    }

    // 7. If needDefaults is true and defaults is either "date" or "all", then
    if (needDefaults && (defaults === 'date' || defaults === 'all'))
        // a. For each of the property names "year", "month", "day":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.year = options.month = options.day = 'numeric';

    // 8. If needDefaults is true and defaults is either "time" or "all", then
    if (needDefaults && (defaults === 'time' || defaults === 'all'))
        // a. For each of the property names "hour", "minute", "second":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.hour = options.minute = options.second = 'numeric';

    // 9. Return options.
    return options;
}

/**
 * When the BasicFormatMatcher abstract operation is called with two arguments options and
 * formats, the following steps are taken:
 */
function BasicFormatMatcher(options, formats) {
    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, property) ? format[property] : undefined;

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        // 5. If delta = 2, decrease score by longMorePenalty.
                        if (delta === 2) score -= longMorePenalty;

                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
                        else if (delta === 1) score -= shortMorePenalty;

                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
                            else if (delta === -1) score -= shortLessPenalty;

                                // 8. Else if delta = -2, decrease score by longLessPenalty.
                                else if (delta === -2) score -= longLessPenalty;
                    }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;

            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/**
 * When the BestFitFormatMatcher abstract operation is called with two arguments options
 * and formats, it performs implementation dependent steps, which should return a set of
 * component representations that a typical user of the selected locale would perceive as
 * at least as good as the one returned by BasicFormatMatcher.
 *
 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
 * with the addition of bonus points awarded where the requested format is of
 * the same data type as the potentially matching format.
 *
 * This algo relies on the concept of closest distance matching described here:
 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
 * Typically a “best match” is found using a closest distance match, such as:
 *
 * Symbols requesting a best choice for the locale are replaced.
 *      j → one of {H, k, h, K}; C → one of {a, b, B}
 * -> Covered by cldr.js matching process
 *
 * For fields with symbols representing the same type (year, month, day, etc):
 *     Most symbols have a small distance from each other.
 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
 *     -> Covered by cldr.js matching process
 *
 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
 *         MMM ≅ MMMM
 *         MM ≅ M
 *     Numeric and text fields are given a larger distance from each other.
 *         MMM ≈ MM
 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
 *         d ≋ D; ...
 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
 *
 *
 * For example,
 *
 *     { month: 'numeric', day: 'numeric' }
 *
 * should match
 *
 *     { month: '2-digit', day: '2-digit' }
 *
 * rather than
 *
 *     { month: 'short', day: 'numeric' }
 *
 * This makes sense because a user requesting a formatted date with numeric parts would
 * not expect to see the returned format containing narrow, short or long part names
 */
function BestFitFormatMatcher(options, formats) {
    /** Diverging: this block implements the hack for single property configuration, eg.:
     *
     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
     *
     * should produce a single digit with the day of the month. This is needed because
     * CLDR `availableFormats` data structure doesn't cover these cases.
     */
    {
        var optionsPropNames = [];
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            if (options['[[' + property + ']]'] !== undefined) {
                optionsPropNames.push(property);
            }
        }
        if (optionsPropNames.length === 1) {
            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
            if (_bestFormat) {
                return _bestFormat;
            }
        }
    }

    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    var patternPenalty = 2;

    var hour12Penalty = 1;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var _property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, _property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + _property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, _property) ? format[_property] : undefined;

            // Diverging: using the default properties produced by the pattern/skeleton
            // to match it with user options, and apply a penalty
            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
            if (optionsProp !== patternProp) {
                score -= patternPenalty;
            }

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        {
                            // diverging from spec
                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
                            } else {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
                            }
                        }
                    }
        }

        {
            // diverging to also take into consideration differences between 12 or 24 hours
            // which is special for the best fit only.
            if (format._.hour12 !== options.hour12) {
                score -= hour12Penalty;
            }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;
            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/* 12.2.3 */internals.DateTimeFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['ca', 'nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
 * following steps are taken:
 */
/* 12.2.2 */
defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * DateTimeFormat object.
 */
/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatDateTime
});

function GetFormatDateTime() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 12.3_b
    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 0, that takes the argument date and
        //    performs the following steps:
        var F = function F() {
            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

            //   i. If date is not provided or is undefined, then let x be the
            //      result as if by the expression Date.now() where Date.now is
            //      the standard built-in function defined in ES5, 15.9.4.4.
            //  ii. Else let x be ToNumber(date).
            // iii. Return the result of calling the FormatDateTime abstract
            //      operation (defined below) with arguments this and x.
            var x = date === undefined ? Date.now() : toNumber(date);
            return FormatDateTime(this, x);
        };
        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);
        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts$1() {
    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');

    var x = date === undefined ? Date.now() : toNumber(date);
    return FormatToPartsDateTime(this, x);
}

Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
    enumerable: false,
    writable: true,
    configurable: true,
    value: formatToParts$1
});

function CreateDateTimeParts(dateTimeFormat, x) {
    // 1. If x is not a finite Number, then throw a RangeError exception.
    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');

    var internal = dateTimeFormat.__getInternalProperties(secret);

    // Creating restore point for properties on the RegExp object... please wait
    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this

    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
    var locale = internal['[[locale]]'];

    // 3. Let nf be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    var nf = new Intl.NumberFormat([locale], { useGrouping: false });

    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
    // 11.1.3.
    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });

    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
    // and the value of the [[timeZone]] internal property of dateTimeFormat.
    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);

    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
    var pattern = internal['[[pattern]]'];

    // 7.
    var result = new List();

    // 8.
    var index = 0;

    // 9.
    var beginIndex = pattern.indexOf('{');

    // 10.
    var endIndex = 0;

    // Need the locale minus any extensions
    var dataLocale = internal['[[dataLocale]]'];

    // Need the calendar data from CLDR
    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
    var ca = internal['[[calendar]]'];

    // 11.
    while (beginIndex !== -1) {
        var fv = void 0;
        // a.
        endIndex = pattern.indexOf('}', beginIndex);
        // b.
        if (endIndex === -1) {
            throw new Error('Unclosed pattern');
        }
        // c.
        if (beginIndex > index) {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(index, beginIndex)
            });
        }
        // d.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // e.
        if (dateTimeComponents.hasOwnProperty(p)) {
            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
            var f = internal['[[' + p + ']]'];
            //  ii. Let v be the value of tm.[[<p>]].
            var v = tm['[[' + p + ']]'];
            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
            if (p === 'year' && v <= 0) {
                v = 1 - v;
            }
            //  iv. If p is "month", then increase v by 1.
            else if (p === 'month') {
                    v++;
                }
                //   v. If p is "hour" and the value of the [[hour12]] internal property of
                //      dateTimeFormat is true, then
                else if (p === 'hour' && internal['[[hour12]]'] === true) {
                        // 1. Let v be v modulo 12.
                        v = v % 12;
                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
                        //    dateTimeFormat is true, then let v be 12.
                        if (v === 0 && internal['[[hourNo0]]'] === true) {
                            v = 12;
                        }
                    }

            //  vi. If f is "numeric", then
            if (f === 'numeric') {
                // 1. Let fv be the result of calling the FormatNumber abstract operation
                //    (defined in 11.3.2) with arguments nf and v.
                fv = FormatNumber(nf, v);
            }
            // vii. Else if f is "2-digit", then
            else if (f === '2-digit') {
                    // 1. Let fv be the result of calling the FormatNumber abstract operation
                    //    with arguments nf2 and v.
                    fv = FormatNumber(nf2, v);
                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
                    //    containing the last two characters.
                    if (fv.length > 2) {
                        fv = fv.slice(-2);
                    }
                }
                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
                //     value representing f in the desired form; the String value depends upon
                //     the implementation and the effective locale and calendar of
                //     dateTimeFormat. If p is "month", then the String value may also depend
                //     on whether dateTimeFormat has a [[day]] internal property. If p is
                //     "timeZoneName", then the String value may also depend on the value of
                //     the [[inDST]] field of tm.
                else if (f in dateWidths) {
                        switch (p) {
                            case 'month':
                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
                                break;

                            case 'weekday':
                                try {
                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
                                } catch (e) {
                                    throw new Error('Could not find weekday data for locale ' + locale);
                                }
                                break;

                            case 'timeZoneName':
                                fv = ''; // ###TODO
                                break;

                            case 'era':
                                try {
                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
                                } catch (e) {
                                    throw new Error('Could not find era data for locale ' + locale);
                                }
                                break;

                            default:
                                fv = tm['[[' + p + ']]'];
                        }
                    }
            // ix
            arrPush.call(result, {
                type: p,
                value: fv
            });
            // f.
        } else if (p === 'ampm') {
            // i.
            var _v = tm['[[hour]]'];
            // ii./iii.
            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
            // iv.
            arrPush.call(result, {
                type: 'dayPeriod',
                value: fv
            });
            // g.
        } else {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(beginIndex, endIndex + 1)
            });
        }
        // h.
        index = endIndex + 1;
        // i.
        beginIndex = pattern.indexOf('{', index);
    }
    // 12.
    if (endIndex < pattern.length - 1) {
        arrPush.call(result, {
            type: 'literal',
            value: pattern.substr(endIndex + 1)
        });
    }
    // 13.
    return result;
}

/**
 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
 * value), it returns a String value representing x (interpreted as a time value as
 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
 * options of dateTimeFormat.
 */
function FormatDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = '';

    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result += part.value;
    }
    return result;
}

function FormatToPartsDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = [];
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}

/**
 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
 * timeZone, the following steps are taken:
 */
function ToLocalTime(date, calendar, timeZone) {
    // 1. Apply calendrical calculations on date for the given calendar and time zone to
    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
    //    The calculations should use best available information about the specified
    //    calendar and time zone. If the calendar is "gregory", then the calculations must
    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
    //    bound by the restrictions on the use of best available information on time zones
    //    for local time zone adjustment and daylight saving time adjustment imposed by
    //    ES5, 15.9.1.7 and 15.9.1.8.
    // ###TODO###
    var d = new Date(date),
        m = 'get' + (timeZone || '');

    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
    //    calculated value.
    return new Record({
        '[[weekday]]': d[m + 'Day'](),
        '[[era]]': +(d[m + 'FullYear']() >= 0),
        '[[year]]': d[m + 'FullYear'](),
        '[[month]]': d[m + 'Month'](),
        '[[day]]': d[m + 'Date'](),
        '[[hour]]': d[m + 'Hours'](),
        '[[minute]]': d[m + 'Minutes'](),
        '[[second]]': d[m + 'Seconds'](),
        '[[inDST]]': false // ###TODO###
    });
}

/**
 * The function returns a new object whose properties and attributes are set as if
 * constructed by an object literal assigning to each of the following properties the
 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
 * properties are not present are not assigned.
 */
/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
    writable: true,
    configurable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 12.3_b
        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

var ls = Intl.__localeSensitiveProtos = {
    Number: {},
    Date: {}
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.2.1 */ls.Number.toLocaleString = function () {
    // Satisfy test 13.2.1_1
    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');

    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
    // 2. If locales is not provided, then let locales be undefined.
    // 3. If options is not provided, then let options be undefined.
    // 4. Let numberFormat be the result of creating a new object as if by the
    //    expression new Intl.NumberFormat(locales, options) where
    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    // 5. Return the result of calling the FormatNumber abstract operation
    //    (defined in 11.3.2) with arguments numberFormat and x.
    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.3.1 */ls.Date.toLocaleString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
    options = ToDateTimeOptions(options, 'any', 'all');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleDateString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.2 */ls.Date.toLocaleDateString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0],


    // 4. If options is not provided, then let options be undefined.
    options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
    options = ToDateTimeOptions(options, 'date', 'date');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleTimeString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
    options = ToDateTimeOptions(options, 'time', 'time');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
    writable: true,
    configurable: true,
    value: function value() {
        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
        // Need this here for IE 8, to avoid the _DontEnum_ bug
        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });

        for (var k in ls.Date) {
            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
        }
    }
});

/**
 * Can't really ship a single script with data for hundreds of locales, so we provide
 * this __addLocaleData method as a means for the developer to add the data on an
 * as-needed basis
 */
defineProperty(Intl, '__addLocaleData', {
    value: function value(data) {
        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");

        addLocaleData(data, data.locale);
    }
});

function addLocaleData(data, tag) {
    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");

    var locale = void 0,
        locales = [tag],
        parts = tag.split('-');

    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);

    while (locale = arrShift.call(locales)) {
        // Add to NumberFormat internal properties as per 11.2.3
        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
        internals.NumberFormat['[[localeData]]'][locale] = data.number;

        // ...and DateTimeFormat internal properties as per 12.2.3
        if (data.date) {
            data.date.nu = data.number.nu;
            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
        }
    }

    // If this is the first set of locale data added, make it the default
    if (defaultLocale === undefined) setDefaultLocale(tag);
}

defineProperty(Intl, '__disableRegExpRestore', {
    value: function value() {
        internals.disableRegExpRestore = true;
    }
});

module.exports = Intl;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 2442 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2443 */
/***/ (function(module, exports) {

IntlPolyfill.__addLocaleData({locale:"en",date:{ca:["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc"],hourNo0:true,hour12:true,formats:{short:"{1}, {0}",medium:"{1}, {0}",full:"{1} 'at' {0}",long:"{1} 'at' {0}",availableFormats:{"d":"d","E":"ccc",Ed:"d E",Ehm:"E h:mm a",EHm:"E HH:mm",Ehms:"E h:mm:ss a",EHms:"E HH:mm:ss",Gy:"y G",GyMMM:"MMM y G",GyMMMd:"MMM d, y G",GyMMMEd:"E, MMM d, y G","h":"h a","H":"HH",hm:"h:mm a",Hm:"HH:mm",hms:"h:mm:ss a",Hms:"HH:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"HH:mm:ss v",hmv:"h:mm a v",Hmv:"HH:mm v","M":"L",Md:"M/d",MEd:"E, M/d",MMM:"LLL",MMMd:"MMM d",MMMEd:"E, MMM d",MMMMd:"MMMM d",ms:"mm:ss","y":"y",yM:"M/y",yMd:"M/d/y",yMEd:"E, M/d/y",yMMM:"MMM y",yMMMd:"MMM d, y",yMMMEd:"E, MMM d, y",yMMMM:"MMMM y",yQQQ:"QQQ y",yQQQQ:"QQQQ y"},dateFormats:{yMMMMEEEEd:"EEEE, MMMM d, y",yMMMMd:"MMMM d, y",yMMMd:"MMM d, y",yMd:"M/d/yy"},timeFormats:{hmmsszzzz:"h:mm:ss a zzzz",hmsz:"h:mm:ss a z",hms:"h:mm:ss a",hm:"h:mm a"}},calendars:{buddhist:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["BE"],short:["BE"],long:["BE"]},dayPeriods:{am:"AM",pm:"PM"}},chinese:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],long:["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},coptic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"],long:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},dangi:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],long:["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},ethiopic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},ethioaa:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0"],short:["ERA0"],long:["ERA0"]},dayPeriods:{am:"AM",pm:"PM"}},generic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},gregory:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["B","A","BCE","CE"],short:["BC","AD","BCE","CE"],long:["Before Christ","Anno Domini","Before Common Era","Common Era"]},dayPeriods:{am:"AM",pm:"PM"}},hebrew:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13","7"],short:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"],long:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AM"],short:["AM"],long:["AM"]},dayPeriods:{am:"AM",pm:"PM"}},indian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"],long:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Saka"],short:["Saka"],long:["Saka"]},dayPeriods:{am:"AM",pm:"PM"}},islamic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},islamicc:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},japanese:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","M","T","S","H"],short:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"],long:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"]},dayPeriods:{am:"AM",pm:"PM"}},persian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"],long:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AP"],short:["AP"],long:["AP"]},dayPeriods:{am:"AM",pm:"PM"}},roc:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Before R.O.C.","Minguo"],short:["Before R.O.C.","Minguo"],long:["Before R.O.C.","Minguo"]},dayPeriods:{am:"AM",pm:"PM"}}}},number:{nu:["latn"],patterns:{decimal:{positivePattern:"{number}",negativePattern:"{minusSign}{number}"},currency:{positivePattern:"{currency}{number}",negativePattern:"{minusSign}{currency}{number}"},percent:{positivePattern:"{number}{percentSign}",negativePattern:"{minusSign}{number}{percentSign}"}},symbols:{latn:{decimal:".",group:",",nan:"NaN",plusSign:"+",minusSign:"-",percentSign:"%",infinity:"∞"}},currencies:{AUD:"A$",BRL:"R$",CAD:"CA$",CNY:"CN¥",EUR:"€",GBP:"£",HKD:"HK$",ILS:"₪",INR:"₹",JPY:"¥",KRW:"₩",MXN:"MX$",NZD:"NZ$",TWD:"NT$",USD:"$",VND:"₫",XAF:"FCFA",XCD:"EC$",XOF:"CFA",XPF:"CFPF"}}});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.17302b94.js